(function () {

    tinymce.PluginManager.add('qiupaste', function(editor) {
        function getSizes(editor) {
            var defaultSizes = [
                { text: '-',    value: '' },
                { text: 'Small',    value: 'img-25' },
                { text: 'Medium',   value: 'img-50' },
                { text: 'Large',    value: 'img-75' },
                { text: 'Full',     value: 'img-100' }
            ];

            return defaultSizes;
        }

        function showDialog() {
            var win = editor.windowManager.open({
                title: "Paste Embed",
                body: [
                    {
                        type: 'textbox',
                        name: 'code',
                        multiline: true,
                        minWidth: editor.getParam("code_dialog_width", 600),
                        minHeight: editor.getParam("code_dialog_height", Math.min(tinymce.DOM.getViewPort().h - 200, 500)),
                        spellcheck: false,
                        style: 'direction: ltr; text-align: left'
                    },
                    {
                        type: 'listbox',
                        name: 'size',
                        label: 'Size',
                        maxWidth: 200,
                        value: '',
                        values: getSizes(editor)
                    },
                ],
                onSubmit: function(e) {
                    // We get a lovely "Wrong document" error in IE 11 if we
                    // don't move the focus to the editor before creating an undo
                    // transation since it tries to make a bookmark for the current selection
                    editor.focus();

                    editor.undoManager.transact(function() {
                        var newContent  = '';
                        if (!e.data.size) {
                            newContent  = e.data.code;
                        } else {
                            $(e.data.code).each(function(index, elem) {
                                if ($(elem).prop('outerHTML')) {
                                    if ($(elem).is(':first-child')) {
                                        newContent = $(elem).addClass(e.data.size).attr('contentEditable','false').prop('outerHTML');
                                    } else {
                                        newContent += $(elem).prop('outerHTML');
                                    }
                                }
                            });
                        }
                        editor.insertContent(newContent);
                    });

                    editor.selection.setCursorLocation();
                    editor.nodeChanged();
                }
            });

            // Gecko has a major performance issue with textarea
            // contents so we need to set it when all reflows are done
            win.find('#code').value('');
        }

        editor.addButton('qiupaste', {
            icon: 'pastetext',
            tooltip: 'Insert Social Embed',
            onclick: showDialog,
            stateSelector: 'div[class="qiupaste"]'
        });

        editor.addCommand('mceQiuPaste', showDialog);

        this.showDialog = showDialog;

        editor.addMenuItem('qiupaste', {
            icon: 'pastetext',
            text: 'Insert Social Embed',
            onclick: showDialog,
            stateSelector: 'div[class="qiupaste"]',
            context: 'insert',
            prependToContext: true
        });
    });
})();
/**
 * Satellizer 0.15.5
 * (c) 2016 Sahat Yalkabov 
 * License: MIT 
 */

(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.satellizer = factory());
}(this, function () { 'use strict';

    var Config = (function () {
        function Config() {
            this.baseUrl = '/';
            this.loginUrl = '/auth/login';
            this.signupUrl = '/auth/signup';
            this.unlinkUrl = '/auth/unlink/';
            this.tokenName = 'token';
            this.tokenPrefix = 'satellizer';
            this.tokenHeader = 'Authorization';
            this.tokenType = 'Bearer';
            this.storageType = 'localStorage';
            this.tokenRoot = null;
            this.withCredentials = false;
            this.providers = {
                facebook: {
                    name: 'facebook',
                    url: '/auth/facebook',
                    authorizationEndpoint: 'https://www.facebook.com/v2.5/dialog/oauth',
                    redirectUri: window.location.origin + '/',
                    requiredUrlParams: ['display', 'scope'],
                    scope: ['email'],
                    scopeDelimiter: ',',
                    display: 'popup',
                    oauthType: '2.0',
                    popupOptions: { width: 580, height: 400 }
                },
                google: {
                    name: 'google',
                    url: '/auth/google',
                    authorizationEndpoint: 'https://accounts.google.com/o/oauth2/auth',
                    redirectUri: window.location.origin,
                    requiredUrlParams: ['scope'],
                    optionalUrlParams: ['display', 'state'],
                    scope: ['profile', 'email'],
                    scopePrefix: 'openid',
                    scopeDelimiter: ' ',
                    display: 'popup',
                    oauthType: '2.0',
                    popupOptions: { width: 452, height: 633 },
                    state: function () { return encodeURIComponent(Math.random().toString(36).substr(2)); }
                },
                github: {
                    name: 'github',
                    url: '/auth/github',
                    authorizationEndpoint: 'https://github.com/login/oauth/authorize',
                    redirectUri: window.location.origin,
                    optionalUrlParams: ['scope'],
                    scope: ['user:email'],
                    scopeDelimiter: ' ',
                    oauthType: '2.0',
                    popupOptions: { width: 1020, height: 618 }
                },
                instagram: {
                    name: 'instagram',
                    url: '/auth/instagram',
                    authorizationEndpoint: 'https://api.instagram.com/oauth/authorize',
                    redirectUri: window.location.origin,
                    requiredUrlParams: ['scope'],
                    scope: ['basic'],
                    scopeDelimiter: '+',
                    oauthType: '2.0'
                },
                linkedin: {
                    name: 'linkedin',
                    url: '/auth/linkedin',
                    authorizationEndpoint: 'https://www.linkedin.com/uas/oauth2/authorization',
                    redirectUri: window.location.origin,
                    requiredUrlParams: ['state'],
                    scope: ['r_emailaddress'],
                    scopeDelimiter: ' ',
                    state: 'STATE',
                    oauthType: '2.0',
                    popupOptions: { width: 527, height: 582 }
                },
                twitter: {
                    name: 'twitter',
                    url: '/auth/twitter',
                    authorizationEndpoint: 'https://api.twitter.com/oauth/authenticate',
                    redirectUri: window.location.origin,
                    oauthType: '1.0',
                    popupOptions: { width: 495, height: 645 }
                },
                twitch: {
                    name: 'twitch',
                    url: '/auth/twitch',
                    authorizationEndpoint: 'https://api.twitch.tv/kraken/oauth2/authorize',
                    redirectUri: window.location.origin,
                    requiredUrlParams: ['scope'],
                    scope: ['user_read'],
                    scopeDelimiter: ' ',
                    display: 'popup',
                    oauthType: '2.0',
                    popupOptions: { width: 500, height: 560 }
                },
                live: {
                    name: 'live',
                    url: '/auth/live',
                    authorizationEndpoint: 'https://login.live.com/oauth20_authorize.srf',
                    redirectUri: window.location.origin,
                    requiredUrlParams: ['display', 'scope'],
                    scope: ['wl.emails'],
                    scopeDelimiter: ' ',
                    display: 'popup',
                    oauthType: '2.0',
                    popupOptions: { width: 500, height: 560 }
                },
                yahoo: {
                    name: 'yahoo',
                    url: '/auth/yahoo',
                    authorizationEndpoint: 'https://api.login.yahoo.com/oauth2/request_auth',
                    redirectUri: window.location.origin,
                    scope: [],
                    scopeDelimiter: ',',
                    oauthType: '2.0',
                    popupOptions: { width: 559, height: 519 }
                },
                bitbucket: {
                    name: 'bitbucket',
                    url: '/auth/bitbucket',
                    authorizationEndpoint: 'https://bitbucket.org/site/oauth2/authorize',
                    redirectUri: window.location.origin + '/',
                    requiredUrlParams: ['scope'],
                    scope: ['email'],
                    scopeDelimiter: ' ',
                    oauthType: '2.0',
                    popupOptions: { width: 1028, height: 529 }
                },
                spotify: {
                    name: 'spotify',
                    url: '/auth/spotify',
                    authorizationEndpoint: 'https://accounts.spotify.com/authorize',
                    redirectUri: window.location.origin,
                    optionalUrlParams: ['state'],
                    requiredUrlParams: ['scope'],
                    scope: ['user-read-email'],
                    scopePrefix: '',
                    scopeDelimiter: ',',
                    oauthType: '2.0',
                    popupOptions: { width: 500, height: 530 },
                    state: function () { return encodeURIComponent(Math.random().toString(36).substr(2)); }
                }
            };
            this.httpInterceptor = function () { return true; };
        }
        Object.defineProperty(Config, "getConstant", {
            get: function () {
                return new Config();
            },
            enumerable: true,
            configurable: true
        });
        return Config;
    }());
    ;

    var AuthProvider = (function () {
        function AuthProvider(SatellizerConfig) {
            this.SatellizerConfig = SatellizerConfig;
        }
        Object.defineProperty(AuthProvider.prototype, "baseUrl", {
            get: function () { return this.SatellizerConfig.baseUrl; },
            set: function (value) { this.SatellizerConfig.baseUrl = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthProvider.prototype, "loginUrl", {
            get: function () { return this.SatellizerConfig.loginUrl; },
            set: function (value) { this.SatellizerConfig.loginUrl = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthProvider.prototype, "signupUrl", {
            get: function () { return this.SatellizerConfig.signupUrl; },
            set: function (value) { this.SatellizerConfig.signupUrl = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthProvider.prototype, "unlinkUrl", {
            get: function () { return this.SatellizerConfig.unlinkUrl; },
            set: function (value) { this.SatellizerConfig.unlinkUrl = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthProvider.prototype, "tokenRoot", {
            get: function () { return this.SatellizerConfig.tokenRoot; },
            set: function (value) { this.SatellizerConfig.tokenRoot = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthProvider.prototype, "tokenName", {
            get: function () { return this.SatellizerConfig.tokenName; },
            set: function (value) { this.SatellizerConfig.tokenName = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthProvider.prototype, "tokenPrefix", {
            get: function () { return this.SatellizerConfig.tokenPrefix; },
            set: function (value) { this.SatellizerConfig.tokenPrefix = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthProvider.prototype, "tokenHeader", {
            get: function () { return this.SatellizerConfig.tokenHeader; },
            set: function (value) { this.SatellizerConfig.tokenHeader = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthProvider.prototype, "tokenType", {
            get: function () { return this.SatellizerConfig.tokenType; },
            set: function (value) { this.SatellizerConfig.tokenType = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthProvider.prototype, "withCredentials", {
            get: function () { return this.SatellizerConfig.withCredentials; },
            set: function (value) { this.SatellizerConfig.withCredentials = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthProvider.prototype, "storageType", {
            get: function () { return this.SatellizerConfig.storageType; },
            set: function (value) { this.SatellizerConfig.storageType = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthProvider.prototype, "httpInterceptor", {
            get: function () { return this.SatellizerConfig.httpInterceptor; },
            set: function (value) {
                if (typeof value === 'function') {
                    this.SatellizerConfig.httpInterceptor = value;
                }
                else {
                    this.SatellizerConfig.httpInterceptor = function () { return value; };
                }
            },
            enumerable: true,
            configurable: true
        });
        AuthProvider.prototype.facebook = function (options) {
            angular.extend(this.SatellizerConfig.providers.facebook, options);
        };
        AuthProvider.prototype.google = function (options) {
            angular.extend(this.SatellizerConfig.providers.google, options);
        };
        AuthProvider.prototype.github = function (options) {
            angular.extend(this.SatellizerConfig.providers.github, options);
        };
        AuthProvider.prototype.instagram = function (options) {
            angular.extend(this.SatellizerConfig.providers.instagram, options);
        };
        AuthProvider.prototype.linkedin = function (options) {
            angular.extend(this.SatellizerConfig.providers.linkedin, options);
        };
        AuthProvider.prototype.twitter = function (options) {
            angular.extend(this.SatellizerConfig.providers.twitter, options);
        };
        AuthProvider.prototype.twitch = function (options) {
            angular.extend(this.SatellizerConfig.providers.twitch, options);
        };
        AuthProvider.prototype.live = function (options) {
            angular.extend(this.SatellizerConfig.providers.live, options);
        };
        AuthProvider.prototype.yahoo = function (options) {
            angular.extend(this.SatellizerConfig.providers.yahoo, options);
        };
        AuthProvider.prototype.bitbucket = function (options) {
            angular.extend(this.SatellizerConfig.providers.bitbucket, options);
        };
        AuthProvider.prototype.spotify = function (options) {
            angular.extend(this.SatellizerConfig.providers.spotify, options);
        };
        AuthProvider.prototype.oauth1 = function (options) {
            this.SatellizerConfig.providers[options.name] = angular.extend(options, {
                oauthType: '1.0'
            });
        };
        AuthProvider.prototype.oauth2 = function (options) {
            this.SatellizerConfig.providers[options.name] = angular.extend(options, {
                oauthType: '2.0'
            });
        };
        AuthProvider.prototype.$get = function (SatellizerShared, SatellizerLocal, SatellizerOAuth) {
            return {
                login: function (user, options) { return SatellizerLocal.login(user, options); },
                signup: function (user, options) { return SatellizerLocal.signup(user, options); },
                logout: function () { return SatellizerShared.logout(); },
                authenticate: function (name, data) { return SatellizerOAuth.authenticate(name, data); },
                link: function (name, data) { return SatellizerOAuth.authenticate(name, data); },
                unlink: function (name, options) { return SatellizerOAuth.unlink(name, options); },
                isAuthenticated: function () { return SatellizerShared.isAuthenticated(); },
                getPayload: function () { return SatellizerShared.getPayload(); },
                getToken: function () { return SatellizerShared.getToken(); },
                setToken: function (token) { return SatellizerShared.setToken({ access_token: token }); },
                removeToken: function () { return SatellizerShared.removeToken(); },
                setStorageType: function (type) { return SatellizerShared.setStorageType(type); }
            };
        };
        AuthProvider.$inject = ['SatellizerConfig'];
        return AuthProvider;
    }());
    AuthProvider.prototype.$get.$inject = ['SatellizerShared', 'SatellizerLocal', 'SatellizerOAuth'];

    function joinUrl(baseUrl, url) {
        if (/^(?:[a-z]+:)?\/\//i.test(url)) {
            return url;
        }
        var joined = [baseUrl, url].join('/');
        var normalize = function (str) {
            return str
                .replace(/[\/]+/g, '/')
                .replace(/\/\?/g, '?')
                .replace(/\/\#/g, '#')
                .replace(/\:\//g, '://');
        };
        return normalize(joined);
    }
    function getFullUrlPath(location) {
        var isHttps = location.protocol === 'https:';
        return location.protocol + '//' + location.hostname +
            ':' + (location.port || (isHttps ? '443' : '80')) +
            (/^\//.test(location.pathname) ? location.pathname : '/' + location.pathname);
    }
    function parseQueryString(str) {
        var obj = {};
        var key;
        var value;
        angular.forEach((str || '').split('&'), function (keyValue) {
            if (keyValue) {
                value = keyValue.split('=');
                key = decodeURIComponent(value[0]);
                obj[key] = angular.isDefined(value[1]) ? decodeURIComponent(value[1]) : true;
            }
        });
        return obj;
    }
    function decodeBase64(str) {
        var buffer;
        if (typeof module !== 'undefined' && module.exports) {
            try {
                buffer = require('buffer').Buffer;
            }
            catch (err) {
            }
        }
        var fromCharCode = String.fromCharCode;
        var re_btou = new RegExp([
            '[\xC0-\xDF][\x80-\xBF]',
            '[\xE0-\xEF][\x80-\xBF]{2}',
            '[\xF0-\xF7][\x80-\xBF]{3}'
        ].join('|'), 'g');
        var cb_btou = function (cccc) {
            switch (cccc.length) {
                case 4:
                    var cp = ((0x07 & cccc.charCodeAt(0)) << 18)
                        | ((0x3f & cccc.charCodeAt(1)) << 12)
                        | ((0x3f & cccc.charCodeAt(2)) << 6)
                        | (0x3f & cccc.charCodeAt(3));
                    var offset = cp - 0x10000;
                    return (fromCharCode((offset >>> 10) + 0xD800)
                        + fromCharCode((offset & 0x3FF) + 0xDC00));
                case 3:
                    return fromCharCode(((0x0f & cccc.charCodeAt(0)) << 12)
                        | ((0x3f & cccc.charCodeAt(1)) << 6)
                        | (0x3f & cccc.charCodeAt(2)));
                default:
                    return fromCharCode(((0x1f & cccc.charCodeAt(0)) << 6)
                        | (0x3f & cccc.charCodeAt(1)));
            }
        };
        var btou = function (b) {
            return b.replace(re_btou, cb_btou);
        };
        var _decode = buffer ? function (a) {
            return (a.constructor === buffer.constructor
                ? a : new buffer(a, 'base64')).toString();
        }
            : function (a) {
                return btou(atob(a));
            };
        return _decode(String(str).replace(/[-_]/g, function (m0) {
            return m0 === '-' ? '+' : '/';
        })
            .replace(/[^A-Za-z0-9\+\/]/g, ''));
    }

    var Shared = (function () {
        function Shared($q, $window, SatellizerConfig, SatellizerStorage) {
            this.$q = $q;
            this.$window = $window;
            this.SatellizerConfig = SatellizerConfig;
            this.SatellizerStorage = SatellizerStorage;
            var _a = this.SatellizerConfig, tokenName = _a.tokenName, tokenPrefix = _a.tokenPrefix;
            this.prefixedTokenName = tokenPrefix ? [tokenPrefix, tokenName].join('_') : tokenName;
        }
        Shared.prototype.getToken = function () {
            return this.SatellizerStorage.get(this.prefixedTokenName);
        };
        Shared.prototype.getPayload = function () {
            var token = this.SatellizerStorage.get(this.prefixedTokenName);
            if (token && token.split('.').length === 3) {
                try {
                    var base64Url = token.split('.')[1];
                    var base64 = base64Url.replace('-', '+').replace('_', '/');
                    return JSON.parse(decodeBase64(base64));
                }
                catch (e) {
                }
            }
        };
        Shared.prototype.setToken = function (response) {
            var tokenRoot = this.SatellizerConfig.tokenRoot;
            var tokenName = this.SatellizerConfig.tokenName;
            var accessToken = response && response.access_token;
            var token;
            if (accessToken) {
                if (angular.isObject(accessToken) && angular.isObject(accessToken.data)) {
                    response = accessToken;
                }
                else if (angular.isString(accessToken)) {
                    token = accessToken;
                }
            }
            if (!token && response) {
                var tokenRootData = tokenRoot && tokenRoot.split('.').reduce(function (o, x) { return o[x]; }, response.data);
                token = tokenRootData ? tokenRootData[tokenName] : response.data && response.data[tokenName];
            }
            if (token) {
                this.SatellizerStorage.set(this.prefixedTokenName, token);
            }
        };
        Shared.prototype.removeToken = function () {
            this.SatellizerStorage.remove(this.prefixedTokenName);
        };
        Shared.prototype.isAuthenticated = function () {
            var token = this.SatellizerStorage.get(this.prefixedTokenName);
            if (token) {
                if (token.split('.').length === 3) {
                    try {
                        var base64Url = token.split('.')[1];
                        var base64 = base64Url.replace('-', '+').replace('_', '/');
                        var exp = JSON.parse(this.$window.atob(base64)).exp;
                        if (typeof exp === 'number') {
                            return Math.round(new Date().getTime() / 1000) < exp;
                        }
                    }
                    catch (e) {
                        return true; // Pass: Non-JWT token that looks like JWT
                    }
                }
                return true; // Pass: All other tokens
            }
            return false; // Fail: No token at all
        };
        Shared.prototype.logout = function () {
            this.SatellizerStorage.remove(this.prefixedTokenName);
            return this.$q.when();
        };
        Shared.prototype.setStorageType = function (type) {
            this.SatellizerConfig.storageType = type;
        };
        Shared.$inject = ['$q', '$window', 'SatellizerConfig', 'SatellizerStorage'];
        return Shared;
    }());

    var Local = (function () {
        function Local($http, SatellizerConfig, SatellizerShared) {
            this.$http = $http;
            this.SatellizerConfig = SatellizerConfig;
            this.SatellizerShared = SatellizerShared;
        }
        Local.prototype.login = function (user, options) {
            var _this = this;
            if (options === void 0) { options = {}; }
            options.url = options.url ? options.url : joinUrl(this.SatellizerConfig.baseUrl, this.SatellizerConfig.loginUrl);
            options.data = user || options.data;
            options.method = options.method || 'POST';
            options.withCredentials = options.withCredentials || this.SatellizerConfig.withCredentials;
            return this.$http(options).then(function (response) {
                _this.SatellizerShared.setToken(response);
                return response;
            });
        };
        Local.prototype.signup = function (user, options) {
            if (options === void 0) { options = {}; }
            options.url = options.url ? options.url : joinUrl(this.SatellizerConfig.baseUrl, this.SatellizerConfig.signupUrl);
            options.data = user || options.data;
            options.method = options.method || 'POST';
            options.withCredentials = options.withCredentials || this.SatellizerConfig.withCredentials;
            return this.$http(options);
        };
        Local.$inject = ['$http', 'SatellizerConfig', 'SatellizerShared'];
        return Local;
    }());

    var Popup = (function () {
        function Popup($interval, $window, $q) {
            this.$interval = $interval;
            this.$window = $window;
            this.$q = $q;
            this.popup = null;
            this.defaults = {
                redirectUri: null
            };
        }
        Popup.prototype.stringifyOptions = function (options) {
            var parts = [];
            angular.forEach(options, function (value, key) {
                parts.push(key + '=' + value);
            });
            return parts.join(',');
        };
        Popup.prototype.open = function (url, name, popupOptions, redirectUri, dontPoll) {
            var width = popupOptions.width || 500;
            var height = popupOptions.height || 500;
            var options = this.stringifyOptions({
                width: width,
                height: height,
                top: this.$window.screenY + ((this.$window.outerHeight - height) / 2.5),
                left: this.$window.screenX + ((this.$window.outerWidth - width) / 2)
            });
            var popupName = this.$window['cordova'] || this.$window.navigator.userAgent.indexOf('CriOS') > -1 ? '_blank' : name;
            this.popup = this.$window.open(url, popupName, options);
            if (this.popup && this.popup.focus) {
                this.popup.focus();
            }
            if (dontPoll) {
                return;
            }
            if (this.$window['cordova']) {
                return this.eventListener(redirectUri);
            }
            else {
                if (url === 'about:blank') {
                    this.popup.location = url;
                }
                return this.polling(redirectUri);
            }
        };
        Popup.prototype.polling = function (redirectUri) {
            var _this = this;
            return this.$q(function (resolve, reject) {
                var redirectUriParser = document.createElement('a');
                redirectUriParser.href = redirectUri;
                var redirectUriPath = getFullUrlPath(redirectUriParser);
                var polling = _this.$interval(function () {
                    if (!_this.popup || _this.popup.closed || _this.popup.closed === undefined) {
                        _this.$interval.cancel(polling);
                        reject(new Error('The popup window was closed'));
                    }
                    try {
                        var popupWindowPath = getFullUrlPath(_this.popup.location);
                        if (popupWindowPath === redirectUriPath) {
                            if (_this.popup.location.search || _this.popup.location.hash) {
                                var query = parseQueryString(_this.popup.location.search.substring(1).replace(/\/$/, ''));
                                var hash = parseQueryString(_this.popup.location.hash.substring(1).replace(/[\/$]/, ''));
                                var params = angular.extend({}, query, hash);
                                if (params.error) {
                                    reject(new Error(params.error));
                                }
                                else {
                                    resolve(params);
                                }
                            }
                            else {
                                reject(new Error('OAuth redirect has occurred but no query or hash parameters were found. ' +
                                    'They were either not set during the redirect, or were removed—typically by a ' +
                                    'routing library—before Satellizer could read it.'));
                            }
                            _this.$interval.cancel(polling);
                            _this.popup.close();
                        }
                    }
                    catch (error) {
                    }
                }, 500);
            });
        };
        Popup.prototype.eventListener = function (redirectUri) {
            var _this = this;
            return this.$q(function (resolve, reject) {
                _this.popup.addEventListener('loadstart', function (event) {
                    if (event.url.indexOf(redirectUri) !== 0) {
                        return;
                    }
                    var parser = document.createElement('a');
                    parser.href = event.url;
                    if (parser.search || parser.hash) {
                        var query = parseQueryString(parser.search.substring(1).replace(/\/$/, ''));
                        var hash = parseQueryString(parser.hash.substring(1).replace(/[\/$]/, ''));
                        var params = angular.extend({}, query, hash);
                        if (params.error) {
                            reject(new Error(params.error));
                        }
                        else {
                            resolve(params);
                        }
                        _this.popup.close();
                    }
                });
                _this.popup.addEventListener('loaderror', function () {
                    reject(new Error('Authorization failed'));
                });
                _this.popup.addEventListener('exit', function () {
                    reject(new Error('The popup window was closed'));
                });
            });
        };
        Popup.$inject = ['$interval', '$window', '$q'];
        return Popup;
    }());

    var OAuth1 = (function () {
        function OAuth1($http, $window, SatellizerConfig, SatellizerPopup) {
            this.$http = $http;
            this.$window = $window;
            this.SatellizerConfig = SatellizerConfig;
            this.SatellizerPopup = SatellizerPopup;
            this.defaults = {
                name: null,
                url: null,
                authorizationEndpoint: null,
                scope: null,
                scopePrefix: null,
                scopeDelimiter: null,
                redirectUri: null,
                requiredUrlParams: null,
                defaultUrlParams: null,
                oauthType: '1.0',
                popupOptions: { width: null, height: null }
            };
        }
        ;
        OAuth1.prototype.init = function (options, userData) {
            var _this = this;
            angular.extend(this.defaults, options);
            var name = options.name, popupOptions = options.popupOptions;
            var redirectUri = this.defaults.redirectUri;
            // Should open an empty popup and wait until request token is received
            if (!this.$window['cordova']) {
                this.SatellizerPopup.open('about:blank', name, popupOptions, redirectUri, true);
            }
            return this.getRequestToken().then(function (response) {
                return _this.openPopup(options, response).then(function (popupResponse) {
                    return _this.exchangeForToken(popupResponse, userData);
                });
            });
        };
        OAuth1.prototype.openPopup = function (options, response) {
            var url = [options.authorizationEndpoint, this.buildQueryString(response.data)].join('?');
            var redirectUri = this.defaults.redirectUri;
            if (this.$window['cordova']) {
                return this.SatellizerPopup.open(url, options.name, options.popupOptions, redirectUri);
            }
            else {
                this.SatellizerPopup.popup.location = url;
                return this.SatellizerPopup.polling(redirectUri);
            }
        };
        OAuth1.prototype.getRequestToken = function () {
            var url = this.SatellizerConfig.baseUrl ? joinUrl(this.SatellizerConfig.baseUrl, this.defaults.url) : this.defaults.url;
            return this.$http.post(url, this.defaults);
        };
        OAuth1.prototype.exchangeForToken = function (oauthData, userData) {
            var payload = angular.extend({}, userData, oauthData);
            var exchangeForTokenUrl = this.SatellizerConfig.baseUrl ? joinUrl(this.SatellizerConfig.baseUrl, this.defaults.url) : this.defaults.url;
            return this.$http.post(exchangeForTokenUrl, payload, { withCredentials: this.SatellizerConfig.withCredentials });
        };
        OAuth1.prototype.buildQueryString = function (obj) {
            var str = [];
            angular.forEach(obj, function (value, key) {
                str.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
            });
            return str.join('&');
        };
        OAuth1.$inject = ['$http', '$window', 'SatellizerConfig', 'SatellizerPopup'];
        return OAuth1;
    }());

    var OAuth2 = (function () {
        function OAuth2($http, $window, $timeout, $q, SatellizerConfig, SatellizerPopup, SatellizerStorage) {
            this.$http = $http;
            this.$window = $window;
            this.$timeout = $timeout;
            this.$q = $q;
            this.SatellizerConfig = SatellizerConfig;
            this.SatellizerPopup = SatellizerPopup;
            this.SatellizerStorage = SatellizerStorage;
            this.defaults = {
                name: null,
                url: null,
                clientId: null,
                authorizationEndpoint: null,
                redirectUri: null,
                scope: null,
                scopePrefix: null,
                scopeDelimiter: null,
                state: null,
                requiredUrlParams: null,
                defaultUrlParams: ['response_type', 'client_id', 'redirect_uri'],
                responseType: 'code',
                responseParams: {
                    code: 'code',
                    clientId: 'clientId',
                    redirectUri: 'redirectUri'
                },
                oauthType: '2.0',
                popupOptions: { width: null, height: null }
            };
        }
        OAuth2.camelCase = function (name) {
            return name.replace(/([\:\-\_]+(.))/g, function (_, separator, letter, offset) {
                return offset ? letter.toUpperCase() : letter;
            });
        };
        OAuth2.prototype.init = function (options, userData) {
            var _this = this;
            return this.$q(function (resolve, reject) {
                angular.extend(_this.defaults, options);
                var stateName = _this.defaults.name + '_state';
                var _a = _this.defaults, name = _a.name, state = _a.state, popupOptions = _a.popupOptions, redirectUri = _a.redirectUri, responseType = _a.responseType;
                if (typeof state === 'function') {
                    _this.SatellizerStorage.set(stateName, state());
                }
                else if (typeof state === 'string') {
                    _this.SatellizerStorage.set(stateName, state);
                }
                var url = [_this.defaults.authorizationEndpoint, _this.buildQueryString()].join('?');
                _this.SatellizerPopup.open(url, name, popupOptions, redirectUri).then(function (oauth) {
                    if (responseType === 'token' || !url) {
                        return resolve(oauth);
                    }
                    if (oauth.state && oauth.state !== _this.SatellizerStorage.get(stateName)) {
                        return reject(new Error('The value returned in the state parameter does not match the state value from your original ' +
                            'authorization code request.'));
                    }
                    resolve(_this.exchangeForToken(oauth, userData));
                }).catch(function (error) { return reject(error); });
            });
        };
        OAuth2.prototype.exchangeForToken = function (oauthData, userData) {
            var _this = this;
            var payload = angular.extend({}, userData);
            angular.forEach(this.defaults.responseParams, function (value, key) {
                switch (key) {
                    case 'code':
                        payload[value] = oauthData.code;
                        break;
                    case 'clientId':
                        payload[value] = _this.defaults.clientId;
                        break;
                    case 'redirectUri':
                        payload[value] = _this.defaults.redirectUri;
                        break;
                    default:
                        payload[value] = oauthData[key];
                }
            });
            if (oauthData.state) {
                payload.state = oauthData.state;
            }
            var exchangeForTokenUrl = this.SatellizerConfig.baseUrl ?
                joinUrl(this.SatellizerConfig.baseUrl, this.defaults.url) :
                this.defaults.url;
            return this.$http.post(exchangeForTokenUrl, payload, { withCredentials: this.SatellizerConfig.withCredentials });
        };
        OAuth2.prototype.buildQueryString = function () {
            var _this = this;
            var keyValuePairs = [];
            var urlParamsCategories = ['defaultUrlParams', 'requiredUrlParams', 'optionalUrlParams'];
            angular.forEach(urlParamsCategories, function (paramsCategory) {
                angular.forEach(_this.defaults[paramsCategory], function (paramName) {
                    var camelizedName = OAuth2.camelCase(paramName);
                    var paramValue = angular.isFunction(_this.defaults[paramName]) ? _this.defaults[paramName]() : _this.defaults[camelizedName];
                    if (paramName === 'redirect_uri' && !paramValue) {
                        return;
                    }
                    if (paramName === 'state') {
                        var stateName = _this.defaults.name + '_state';
                        paramValue = encodeURIComponent(_this.SatellizerStorage.get(stateName));
                    }
                    if (paramName === 'scope' && Array.isArray(paramValue)) {
                        paramValue = paramValue.join(_this.defaults.scopeDelimiter);
                        if (_this.defaults.scopePrefix) {
                            paramValue = [_this.defaults.scopePrefix, paramValue].join(_this.defaults.scopeDelimiter);
                        }
                    }
                    keyValuePairs.push([paramName, paramValue]);
                });
            });
            return keyValuePairs.map(function (pair) { return pair.join('='); }).join('&');
        };
        OAuth2.$inject = ['$http', '$window', '$timeout', '$q', 'SatellizerConfig', 'SatellizerPopup', 'SatellizerStorage'];
        return OAuth2;
    }());

    var OAuth = (function () {
        function OAuth($http, $window, $timeout, $q, SatellizerConfig, SatellizerPopup, SatellizerStorage, SatellizerShared, SatellizerOAuth1, SatellizerOAuth2) {
            this.$http = $http;
            this.$window = $window;
            this.$timeout = $timeout;
            this.$q = $q;
            this.SatellizerConfig = SatellizerConfig;
            this.SatellizerPopup = SatellizerPopup;
            this.SatellizerStorage = SatellizerStorage;
            this.SatellizerShared = SatellizerShared;
            this.SatellizerOAuth1 = SatellizerOAuth1;
            this.SatellizerOAuth2 = SatellizerOAuth2;
        }
        OAuth.prototype.authenticate = function (name, userData) {
            var _this = this;
            return this.$q(function (resolve, reject) {
                var provider = _this.SatellizerConfig.providers[name];
                var oauth = null;
                switch (provider.oauthType) {
                    case '1.0':
                        oauth = new OAuth1(_this.$http, _this.$window, _this.SatellizerConfig, _this.SatellizerPopup);
                        break;
                    case '2.0':
                        oauth = new OAuth2(_this.$http, _this.$window, _this.$timeout, _this.$q, _this.SatellizerConfig, _this.SatellizerPopup, _this.SatellizerStorage);
                        break;
                    default:
                        return reject(new Error('Invalid OAuth Type'));
                }
                return oauth.init(provider, userData).then(function (response) {
                    if (provider.url) {
                        _this.SatellizerShared.setToken(response);
                    }
                    resolve(response);
                }).catch(function (error) {
                    reject(error);
                });
            });
        };
        OAuth.prototype.unlink = function (provider, httpOptions) {
            if (httpOptions === void 0) { httpOptions = {}; }
            httpOptions.url = httpOptions.url ? httpOptions.url : joinUrl(this.SatellizerConfig.baseUrl, this.SatellizerConfig.unlinkUrl);
            httpOptions.data = { provider: provider } || httpOptions.data;
            httpOptions.method = httpOptions.method || 'POST';
            httpOptions.withCredentials = httpOptions.withCredentials || this.SatellizerConfig.withCredentials;
            return this.$http(httpOptions);
        };
        OAuth.$inject = [
            '$http',
            '$window',
            '$timeout',
            '$q',
            'SatellizerConfig',
            'SatellizerPopup',
            'SatellizerStorage',
            'SatellizerShared',
            'SatellizerOAuth1',
            'SatellizerOAuth2'
        ];
        return OAuth;
    }());

    var Storage = (function () {
        function Storage($window, SatellizerConfig) {
            this.$window = $window;
            this.SatellizerConfig = SatellizerConfig;
            this.memoryStore = {};
        }
        Storage.prototype.get = function (key) {
            try {
                return this.$window[this.SatellizerConfig.storageType].getItem(key);
            }
            catch (e) {
                return this.memoryStore[key];
            }
        };
        Storage.prototype.set = function (key, value) {
            try {
                this.$window[this.SatellizerConfig.storageType].setItem(key, value);
            }
            catch (e) {
                this.memoryStore[key] = value;
            }
        };
        Storage.prototype.remove = function (key) {
            try {
                this.$window[this.SatellizerConfig.storageType].removeItem(key);
            }
            catch (e) {
                delete this.memoryStore[key];
            }
        };
        Storage.$inject = ['$window', 'SatellizerConfig'];
        return Storage;
    }());

    var Interceptor = (function () {
        function Interceptor(SatellizerConfig, SatellizerShared, SatellizerStorage) {
            var _this = this;
            this.SatellizerConfig = SatellizerConfig;
            this.SatellizerShared = SatellizerShared;
            this.SatellizerStorage = SatellizerStorage;
            this.request = function (config) {
                if (config['skipAuthorization']) {
                    return config;
                }
                if (_this.SatellizerShared.isAuthenticated() && _this.SatellizerConfig.httpInterceptor()) {
                    var tokenName = _this.SatellizerConfig.tokenPrefix ?
                        [_this.SatellizerConfig.tokenPrefix, _this.SatellizerConfig.tokenName].join('_') : _this.SatellizerConfig.tokenName;
                    var token = _this.SatellizerStorage.get(tokenName);
                    if (_this.SatellizerConfig.tokenHeader && _this.SatellizerConfig.tokenType) {
                        token = _this.SatellizerConfig.tokenType + ' ' + token;
                    }
                    config.headers[_this.SatellizerConfig.tokenHeader] = token;
                }
                return config;
            };
        }
        Interceptor.Factory = function (SatellizerConfig, SatellizerShared, SatellizerStorage) {
            return new Interceptor(SatellizerConfig, SatellizerShared, SatellizerStorage);
        };
        Interceptor.$inject = ['SatellizerConfig', 'SatellizerShared', 'SatellizerStorage'];
        return Interceptor;
    }());
    Interceptor.Factory.$inject = ['SatellizerConfig', 'SatellizerShared', 'SatellizerStorage'];

    var HttpProviderConfig = (function () {
        function HttpProviderConfig($httpProvider) {
            this.$httpProvider = $httpProvider;
            $httpProvider.interceptors.push(Interceptor.Factory);
        }
        HttpProviderConfig.$inject = ['$httpProvider'];
        return HttpProviderConfig;
    }());

    angular.module('satellizer', [])
        .provider('$auth', ['SatellizerConfig', function (SatellizerConfig) { return new AuthProvider(SatellizerConfig); }])
        .constant('SatellizerConfig', Config.getConstant)
        .service('SatellizerShared', Shared)
        .service('SatellizerLocal', Local)
        .service('SatellizerPopup', Popup)
        .service('SatellizerOAuth', OAuth)
        .service('SatellizerOAuth2', OAuth2)
        .service('SatellizerOAuth1', OAuth1)
        .service('SatellizerStorage', Storage)
        .service('SatellizerInterceptor', Interceptor)
        .config(['$httpProvider', function ($httpProvider) { return new HttpProviderConfig($httpProvider); }]);
    var ng1 = 'satellizer';

    return ng1;

}));

(function ()
{
    'use strict';

    angular
        .module('app.scrumboard', [])
        .config(config)
        .run(run);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider,msUtilProvider)
    {
        $stateProvider
            .state('app.scrumboard', {
                abstract : true,
                url      : '/scrumboard',
                resolve  : {
                    BoardList: function (msApi)
                    {
                        return msApi.resolve('scrumboard.boardList@get');
                    }
                },
                bodyClass: 'scrumboard'
            })

            // Home
            .state('app.scrumboard.boards', {
                url  : '/boards',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/scrumboard/views/boards/boards-view.html',
                        controller : 'BoardsViewController as vm'
                    }
                }
            })

            // Board
            .state('app.scrumboard.boards.board', {
                    url    : '/:id/:uri',
                    views  : {
                        'content@app'                                  : {
                            templateUrl: 'app/main/apps/scrumboard/scrumboard.html',
                            controller : 'ScrumboardController as vm'
                        },
                        'scrumboardContent@app.scrumboard.boards.board': {
                            templateUrl: 'app/main/apps/scrumboard/views/board/board-view.html',
                            controller : 'BoardViewController as vm'
                        }
                    },
                    resolve: {
                        BoardData: function ($stateParams, BoardService)
                        {
                            return BoardService.getBoardData($stateParams.id);
                        }
                    }
                }
            )

            // Add board
            .state('app.scrumboard.boards.addBoard', {
                    url    : '/add',
                    views  : {
                        'content@app'                                     : {
                            templateUrl: 'app/main/apps/scrumboard/scrumboard.html',
                            controller : 'ScrumboardController as vm'
                        },
                        'scrumboardContent@app.scrumboard.boards.addBoard': {
                            templateUrl: 'app/main/apps/scrumboard/views/board/board-view.html',
                            controller : 'BoardViewController as vm'
                        }
                    },
                    resolve: {
                        BoardData: function ($stateParams, BoardService)
                        {
                            return BoardService.addNewBoard();
                        }
                    }
                }
            )

            // Calendar
            .state('app.scrumboard.boards.board.calendar', {
                url  : '/calendar',
                views: {
                    'scrumboardContent@app.scrumboard.boards.board': {
                        templateUrl: 'app/main/apps/scrumboard/views/calendar/calendar-view.html',
                        controller : 'CalendarViewController as vm'
                    }
                }
            });

        // Translation
        var base = 'app/main/apps/scrumboard';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }
        // Api
        msApiProvider.register('scrumboard.boardList', ['app/data/scrumboard/board-list.json']);
        msApiProvider.register('scrumboard.board', ['app/data/scrumboard/boards/:id.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('apps.scrumboard', {
            title : 'Scrumboard',
            icon  : 'icon-trello',
            state : 'app.scrumboard.boards',
            weight: 8
        });
    }

    /** @ngInject */
    function run(editableThemes)
    {
        /**
         * Inline Edit Configuration
         * @type {string}
         */
        editableThemes.default.submitTpl = '<md-button class="md-icon-button" type="submit" aria-label="save"><md-icon md-font-icon="icon-checkbox-marked-circle" class="md-accent-fg md-hue-1"></md-icon></md-button>';
        editableThemes.default.cancelTpl = '<md-button class="md-icon-button" ng-click="$form.$cancel()" aria-label="cancel"><md-icon md-font-icon="icon-close-circle" class="icon-cancel"></md-icon></md-button>';
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ScrumboardCalendarEventDialogController', ScrumboardCalendarEventDialogController);

    /** @ngInject */
    function ScrumboardCalendarEventDialogController($mdDialog, dueDate, BoardService, msUtils)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.dueDate = dueDate;
        vm.newCard = {
            name  : '',
            listId: ''
        };
        vm.selectedCards = [];

        // Methods
        vm.exists = msUtils.exists;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.closeDialog = closeDialog;
        vm.addNewCard = addNewCard;
        vm.assignDueDate = assignDueDate;

        //////////

        /**
         * Close Dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Add New Card
         */
        function addNewCard()
        {
            var newCardId = msUtils.guidGenerator();

            vm.board.cards.push({
                'id'               : newCardId,
                'name'             : vm.newCard.name,
                'description'      : '',
                'idAttachmentCover': '',
                'idMembers'        : [],
                'idLabels'         : [],
                'attachments'      : [],
                'subscribed'       : false,
                'checklists'       : [],
                'checkItems'       : 0,
                'checkItemsChecked': 0,
                'comments'         : [],
                'activities'       : [],
                'due'              : vm.dueDate
            });

            vm.board.lists.getById(vm.newCard.listId).idCards.push(newCardId);

            // Reset the newCard object
            vm.newCard = {
                name: '',
                listId: ''
            };

            closeDialog();
        }

        /**
         * Assign Due Date
         */
        function assignDueDate()
        {
            angular.forEach(vm.selectedCards, function (cardId)
            {
                vm.board.cards.getById(cardId).due = vm.dueDate;
            });

            vm.selectedCards = [];

            closeDialog();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('MembersMenuController', MembersMenuController);

    /** @ngInject */
    function MembersMenuController($document, $mdDialog, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.newMemberSearchInput = '';

        // Methods
        vm.addNewMember = addNewMember;
        vm.removeMember = removeMember;

        ////////

        /**
         * Add New Member
         */
        function addNewMember()
        {
            // Add new member
        }

        /**
         * Remove member
         *
         * @param ev
         * @param memberId
         */
        function removeMember(ev, memberId)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove Member',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove member?',
                ariaLabel          : 'remove member',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });

            $mdDialog.show(confirm).then(function ()
            {
                var arr = vm.board.members;
                arr.splice(arr.indexOf(arr.getById(memberId)), 1);

                angular.forEach(vm.board.cards, function (card)
                {
                    if ( card.idMembers && card.idMembers.indexOf(memberId) > -1 )
                    {
                        card.idMembers.splice(card.idMembers.indexOf(memberId), 1);
                    }
                });
            }, function ()
            {
                // Canceled
            });
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ColorMenuController', ColorMenuController);

    /** @ngInject */
    function ColorMenuController($mdColorPalette, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.palettes = $mdColorPalette;

        // Methods

        ////////

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('LabelsMenuController', LabelsMenuController);

    /** @ngInject */
    function LabelsMenuController($document, $mdColorPalette, $mdDialog, fuseGenerator, msUtils, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.palettes = $mdColorPalette;
        vm.rgba = fuseGenerator.rgba;
        vm.hue = 500;
        vm.newLabelColor = 'red';
        vm.newLabelName = '';

        // Methods
        vm.addNewLabel = addNewLabel;
        vm.removeLabel = removeLabel;

        ////////

        /**
         * Add New Label
         */
        function addNewLabel()
        {
            vm.board.labels.push({
                id   : msUtils.guidGenerator(),
                name : vm.newLabelName,
                color: vm.newLabelColor
            });
            vm.newLabelName = '';
        }

        /**
         * Remove label
         *
         * @param ev
         * @param labelId
         */
        function removeLabel(ev, labelId)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove Label',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove label?',
                ariaLabel          : 'remove label',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });

            $mdDialog.show(confirm).then(function ()
            {
                var arr = vm.board.labels;
                arr.splice(arr.indexOf(arr.getById(labelId)), 1);

                angular.forEach(vm.board.cards, function (card)
                {
                    if ( card.idLabels && card.idLabels.indexOf(labelId) > -1 )
                    {
                        card.idLabels.splice(card.idLabels.indexOf(labelId), 1);
                    }
                });
            }, function ()
            {
                // Canceled
            });
        }

    }
})();
var app = angular.module('toolbarDemo2', ['ngMaterial']);

app.controller('TitleController', function($scope) {
  $scope.title = 'My App Title';
});

app.controller('AppCtrl', function($scope) {
  var imagePath = 'assets/angular-material-assets/img/list/60.jpeg';

  $scope.todos = [];
  for (var i = 0; i < 15; i++) {
    $scope.todos.push({
      face: imagePath,
      what: "Brunch this weekend?",
      who: "Min Li Chan",
      notes: "I'll be in your neighborhood doing errands."
    });
  }
});


angular.module('toolbarDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {

});

angular.module('whiteframeBasicUsage', ['ngMaterial']);

angular.module('whiteframeDirectiveUsage', ['ngMaterial']);

(function () {
  'use strict';

    angular
      .module('virtualRepeatDeferredLoadingDemo', ['ngMaterial'])
      .controller('AppCtrl', function($timeout) {

        // In this example, we set up our model using a class.
        // Using a plain object works too. All that matters
        // is that we implement getItemAtIndex and getLength.
        var DynamicItems = function() {
          /**
           * @type {!Object<?Array>} Data pages, keyed by page number (0-index).
           */
          this.loadedPages = {};

          /** @type {number} Total number of items. */
          this.numItems = 0;

          /** @const {number} Number of items to fetch per request. */
          this.PAGE_SIZE = 50;

          this.fetchNumItems_();
        };

        // Required.
        DynamicItems.prototype.getItemAtIndex = function(index) {
          var pageNumber = Math.floor(index / this.PAGE_SIZE);
          var page = this.loadedPages[pageNumber];

          if (page) {
            return page[index % this.PAGE_SIZE];
          } else if (page !== null) {
            this.fetchPage_(pageNumber);
          }
        };

        // Required.
        DynamicItems.prototype.getLength = function() {
          return this.numItems;
        };

        DynamicItems.prototype.fetchPage_ = function(pageNumber) {
          // Set the page to null so we know it is already being fetched.
          this.loadedPages[pageNumber] = null;

          // For demo purposes, we simulate loading more items with a timed
          // promise. In real code, this function would likely contain an
          // $http request.
          $timeout(angular.noop, 300).then(angular.bind(this, function() {
            this.loadedPages[pageNumber] = [];
            var pageOffset = pageNumber * this.PAGE_SIZE;
            for (var i = pageOffset; i < pageOffset + this.PAGE_SIZE; i++) {
              this.loadedPages[pageNumber].push(i);
            }
          }));
        };

        DynamicItems.prototype.fetchNumItems_ = function() {
          // For demo purposes, we simulate loading the item count with a timed
          // promise. In real code, this function would likely contain an
          // $http request.
          $timeout(angular.noop, 300).then(angular.bind(this, function() {
            this.numItems = 50000;
          }));
        };
        
        this.dynamicItems = new DynamicItems();
      });
})();

(function () {
  'use strict';

    angular
      .module('virtualRepeatScrollToDemo', ['ngMaterial'])
      .controller('AppCtrl', function($scope) {
        this.selectedYear = 0;
        this.years = [];
        this.items = [];
        var currentYear = new Date().getFullYear();
        var monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
          'July', 'August', 'September', 'October', 'November', 'December'];
        // Build a list of months over 20 years
        for (var y = currentYear; y >= (currentYear-20); y--) {
          this.years.push(y);
          this.items.push({year: y, text: y, header: true});
          for (var m = 11; m >= 0; m--) {
            this.items.push({year: y, month: m, text: monthNames[m]});
          }
        }
        // Whenever a different year is selected, scroll to that year
        $scope.$watch('ctrl.selectedYear', angular.bind(this, function(yearIndex) {
          var scrollYear = Math.floor(this.topIndex / 13);
          if(scrollYear !== yearIndex) {
            this.topIndex = yearIndex * 13;
          }
        }));
        // The selected year should follow the year that is at the top of the scroll container
        $scope.$watch('ctrl.topIndex', angular.bind(this, function(topIndex) {
          var scrollYear = Math.floor(topIndex / 13);
          this.selectedYear = scrollYear;
        }));
      });

})();

(function () {
  'use strict';

    angular
      .module('virtualRepeatVerticalDemo', ['ngMaterial'])
      .controller('AppCtrl', function() {
        this.items = [];
        for (var i = 0; i < 1000; i++) {
          this.items.push(i);
        }
      });

})();

(function () {
  'use strict';

    angular
      .module('virtualRepeatInfiniteScrollDemo', ['ngMaterial'])
      .controller('AppCtrl', function($timeout) {

        // In this example, we set up our model using a plain object.
        // Using a class works too. All that matters is that we implement
        // getItemAtIndex and getLength.
        this.infiniteItems = {
          numLoaded_: 0,
          toLoad_: 0,

          // Required.
          getItemAtIndex: function(index) {
            if (index > this.numLoaded_) {
              this.fetchMoreItems_(index);
              return null;
            }

            return index;
          },

          // Required.
          // For infinite scroll behavior, we always return a slightly higher
          // number than the previously loaded items.
          getLength: function() {
            return this.numLoaded_ + 5;
          },

          fetchMoreItems_: function(index) {
            // For demo purposes, we simulate loading more items with a timed
            // promise. In real code, this function would likely contain an
            // $http request.

            if (this.toLoad_ < index) {
              this.toLoad_ += 20;
              $timeout(angular.noop, 300).then(angular.bind(this, function() {
                this.numLoaded_ = this.toLoad_;
              }));
            }
          }
        };
      });

})();

(function () {
  'use strict';

  angular
      .module('tabsDemoStaticTabs', ['ngMaterial'] )
      .controller('AppCtrl', AppCtrl);

  function AppCtrl ( $scope ) {
    $scope.data = {
      selectedIndex: 0,
      secondLocked:  true,
      secondLabel:   "Item Two",
      bottom:        false
    };
    $scope.next = function() {
      $scope.data.selectedIndex = Math.min($scope.data.selectedIndex + 1, 2) ;
    };
    $scope.previous = function() {
      $scope.data.selectedIndex = Math.max($scope.data.selectedIndex - 1, 0);
    };
  }
})();

(function () {
  'use strict';

    angular
      .module('virtualRepeatHorizontalDemo', ['ngMaterial'])
      .controller('AppCtrl', function() {
        this.items = [];
        for (var i = 0; i < 1000; i++) {
          this.items.push(i);
        }
      });

})();

(function () {
  'use strict';
  angular
      .module('tabsDemoDynamicTabs', ['ngMaterial'])
      .controller('AppCtrl', AppCtrl);

  function AppCtrl ($scope, $log) {
    var tabs = [
          { title: 'One', content: "Tabs will become paginated if there isn't enough room for them."},
          { title: 'Two', content: "You can swipe left and right on a mobile device to change tabs."},
          { title: 'Three', content: "You can bind the selected tab via the selected attribute on the md-tabs element."},
          { title: 'Four', content: "If you set the selected tab binding to -1, it will leave no tab selected."},
          { title: 'Five', content: "If you remove a tab, it will try to select a new one."},
          { title: 'Six', content: "There's an ink bar that follows the selected tab, you can turn it off if you want."},
          { title: 'Seven', content: "If you set ng-disabled on a tab, it becomes unselectable. If the currently selected tab becomes disabled, it will try to select the next tab."},
          { title: 'Eight', content: "If you look at the source, you're using tabs to look at a demo for tabs. Recursion!"},
          { title: 'Nine', content: "If you set md-theme=\"green\" on the md-tabs element, you'll get green tabs."},
          { title: 'Ten', content: "If you're still reading this, you should just go check out the API docs for tabs!"}
        ],
        selected = null,
        previous = null;
    $scope.tabs = tabs;
    $scope.selectedIndex = 2;
    $scope.$watch('selectedIndex', function(current, old){
      previous = selected;
      selected = tabs[current];
      if ( old + 1 && (old != current)) $log.debug('Goodbye ' + previous.title + '!');
      if ( current + 1 )                $log.debug('Hello ' + selected.title + '!');
    });
    $scope.addTab = function (title, view) {
      view = view || title + " Content View";
      tabs.push({ title: title, content: view, disabled: false});
    };
    $scope.removeTab = function (tab) {
      var index = tabs.indexOf(tab);
      tabs.splice(index, 1);
    };
  }
})();


angular.module('tabsDemoDynamicHeight', ['ngMaterial']);
(function() {

  var isDlgOpen;

  angular
    .module('toastDemo2', ['ngMaterial'])
    .controller('AppCtrl', function($scope, $mdToast) {
      $scope.showCustomToast = function() {
        $mdToast.show({
          hideDelay   : 3000,
          position    : 'top right',
          controller  : 'ToastCtrl',
          templateUrl : 'toast-template.html'
        });
      };
    })
    .controller('ToastCtrl', function($scope, $mdToast, $mdDialog) {

      $scope.closeToast = function() {
        if (isDlgOpen) return;

        $mdToast
          .hide()
          .then(function() {
            isDlgOpen = false;
          });
      };

      $scope.openMoreInfo = function(e) {
        if ( isDlgOpen ) return;
        isDlgOpen = true;

        $mdDialog
          .show($mdDialog
            .alert()
            .title('More info goes here.')
            .textContent('Something witty.')
            .ariaLabel('More info')
            .ok('Got it')
            .targetEvent(e)
          )
          .then(function() {
            isDlgOpen = false;
          })
      };
    });

})();

angular.module('tooltipDemo1', ['ngMaterial'])
.controller('AppCtrl', function($scope) {
  $scope.demo = {
    showTooltip : false,
    tipDirection : ''
  };

  $scope.demo.delayTooltip = undefined;
  $scope.$watch('demo.delayTooltip',function(val) {
    $scope.demo.delayTooltip = parseInt(val, 10) || 0;
  });

  $scope.$watch('demo.tipDirection',function(val) {
    if (val && val.length ) {
      $scope.demo.showTooltip = true;
    }
  })
});


angular.module('toastDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope, $mdToast) {
  var last = {
      bottom: false,
      top: true,
      left: false,
      right: true
    };

  $scope.toastPosition = angular.extend({},last);

  $scope.getToastPosition = function() {
    sanitizePosition();

    return Object.keys($scope.toastPosition)
      .filter(function(pos) { return $scope.toastPosition[pos]; })
      .join(' ');
  };

  function sanitizePosition() {
    var current = $scope.toastPosition;

    if ( current.bottom && last.top ) current.top = false;
    if ( current.top && last.bottom ) current.bottom = false;
    if ( current.right && last.left ) current.left = false;
    if ( current.left && last.right ) current.right = false;

    last = angular.extend({},current);
  }

  $scope.showSimpleToast = function() {
    var pinTo = $scope.getToastPosition();

    $mdToast.show(
      $mdToast.simple()
        .textContent('Simple Toast!')
        .position(pinTo )
        .hideDelay(3000)
    );
  };

  $scope.showActionToast = function() {
    var pinTo = $scope.getToastPosition();
    var toast = $mdToast.simple()
      .textContent('Marked as read')
      .action('UNDO')
      .position(pinTo);

    $mdToast.show(toast).then(function(response) {
      if ( response == 'ok' ) {
        alert('You clicked the \'UNDO\' action.');
      }
    });
  };

})

.controller('ToastCtrl', function($scope, $mdToast) {
  $scope.closeToast = function() {
    $mdToast.hide();
  };
});

angular.module('switchDemo1', ['ngMaterial'])
.controller('SwitchDemoCtrl', function($scope) {
  $scope.data = {
    cb1: true,
    cb4: true,
    cb5: false
  };

  $scope.message = 'false';

  $scope.onChange = function(cbState) {
  	$scope.message = cbState;
  };
});


angular.module('subheaderBasicDemo', ['ngMaterial'])
.config(function($mdThemingProvider) {
  $mdThemingProvider.theme('altTheme')
    .primaryPalette('purple');
})
.controller('SubheaderAppCtrl', function($scope) {
    var imagePath = 'assets/angular-material-assets/img/list/60.jpeg';
    $scope.messages = [
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
    ];
});


angular.module('sliderDemo1', ['ngMaterial'])
  .config(function($mdIconProvider) {
    $mdIconProvider
      .iconSet('device', 'assets/angular-material-assets/img/icons/sets/device-icons.svg', 24);
  })
.controller('AppCtrl', function($scope) {

  $scope.color = {
    red: Math.floor(Math.random() * 255),
    green: Math.floor(Math.random() * 255),
    blue: Math.floor(Math.random() * 255)
  };

  $scope.rating1 = 3;
  $scope.rating2 = 2;
  $scope.rating3 = 4;

  $scope.disabled1 = Math.floor(Math.random() * 100);
  $scope.disabled2 = 0;
  $scope.disabled3 = 70;

  $scope.isDisabled = true;
});

angular.module('demoSwipe', ['ngMaterial'])
  .controller('demoSwipeCtrl', function($scope) {
    $scope.onSwipeLeft = function(ev) {
      alert('You swiped left!!');
    };

    $scope.onSwipeRight = function(ev) {
      alert('You swiped right!!');
    };
    $scope.onSwipeUp = function(ev) {
      alert('You swiped up!!');
    };

    $scope.onSwipeDown = function(ev) {
      alert('You swiped down!!');
    };
  });


angular.module('sliderDemo2', ['ngMaterial'])

.controller('AppCtrl', function($scope) {

  $scope.vol = Math.floor(Math.random() * 100);
  $scope.bass = Math.floor(Math.random() * 100);
  $scope.master = Math.floor(Math.random() * 100);
});

angular
  .module('sidenavDemo1', ['ngMaterial'])
  .controller('AppCtrl', function ($scope, $timeout, $mdSidenav, $log) {
    $scope.toggleLeft = buildDelayedToggler('left');
    $scope.toggleRight = buildToggler('right');
    $scope.isOpenRight = function(){
      return $mdSidenav('right').isOpen();
    };

    /**
     * Supplies a function that will continue to operate until the
     * time is up.
     */
    function debounce(func, wait, context) {
      var timer;

      return function debounced() {
        var context = $scope,
            args = Array.prototype.slice.call(arguments);
        $timeout.cancel(timer);
        timer = $timeout(function() {
          timer = undefined;
          func.apply(context, args);
        }, wait || 10);
      };
    }

    /**
     * Build handler to open/close a SideNav; when animation finishes
     * report completion in console
     */
    function buildDelayedToggler(navID) {
      return debounce(function() {
        // Component lookup should always be available since we are not using `ng-if`
        $mdSidenav(navID)
          .toggle()
          .then(function () {
            $log.debug("toggle " + navID + " is done");
          });
      }, 200);
    }

    function buildToggler(navID) {
      return function() {
        // Component lookup should always be available since we are not using `ng-if`
        $mdSidenav(navID)
          .toggle()
          .then(function () {
            $log.debug("toggle " + navID + " is done");
          });
      }
    }
  })
  .controller('LeftCtrl', function ($scope, $timeout, $mdSidenav, $log) {
    $scope.close = function () {
      // Component lookup should always be available since we are not using `ng-if`
      $mdSidenav('left').close()
        .then(function () {
          $log.debug("close LEFT is done");
        });

    };
  })
  .controller('RightCtrl', function ($scope, $timeout, $mdSidenav, $log) {
    $scope.close = function () {
      // Component lookup should always be available since we are not using `ng-if`
      $mdSidenav('right').close()
        .then(function () {
          $log.debug("close RIGHT is done");
        });
    };
  });

angular
  .module('progressCircularDemo1', ['ngMaterial'])
  .controller('AppCtrl', ['$interval',
    function($interval) {
      var self = this;

      self.activated = true;
      self.determinateValue = 30;

      // Iterate every 100ms, non-stop and increment
      // the Determinate loader.
      $interval(function() {

        self.determinateValue += 1;
        if (self.determinateValue > 100) {
          self.determinateValue = 30;
        }

      }, 100);
    }
  ]);

angular.module('selectDemoValidation', ['ngMaterial', 'ngMessages'])
.controller('AppCtrl', function($scope) {
  $scope.clearValue = function() {
    $scope.myModel = undefined;
  };
  $scope.save = function() {
    alert('Form was valid!');
  };
});

angular
    .module('selectDemoSelectedText', ['ngMaterial'])
    .controller('SelectedTextController', function($scope) {
      $scope.items = [1, 2, 3, 4, 5, 6, 7];
      $scope.selectedItem;
      $scope.getSelectedText = function() {
        if ($scope.selectedItem !== undefined) {
          return "You have selected: Item " + $scope.selectedItem;
        } else {
          return "Please select an item";
        }
      };
    });

angular
    .module('selectDemoSelectHeader', ['ngMaterial'])
    .controller('SelectHeaderController', function($scope, $element) {
      $scope.vegetables = ['Corn' ,'Onions' ,'Kale' ,'Arugula' ,'Peas', 'Zucchini'];
      $scope.searchTerm;
      $scope.clearSearchTerm = function() {
        $scope.searchTerm = '';
      };
      // The md-select directive eats keydown events for some quick select
      // logic. Since we have a search input here, we don't need that logic.
      $element.find('input').on('keydown', function(ev) {
          ev.stopPropagation();
      });
    });

angular.module('selectDemoOptionsAsync', ['ngMaterial'])
.controller('SelectAsyncController', function($timeout, $scope) {
  $scope.user = null;
  $scope.users = null;

  $scope.loadUsers = function() {

    // Use timeout to simulate a 650ms request.
    return $timeout(function() {

      $scope.users =  $scope.users  || [
        { id: 1, name: 'Scooby Doo' },
        { id: 2, name: 'Shaggy Rodgers' },
        { id: 3, name: 'Fred Jones' },
        { id: 4, name: 'Daphne Blake' },
        { id: 5, name: 'Velma Dinkley' }
      ];

    }, 650);
  };
});

(function () {
  'use strict';
  angular
      .module('selectDemoBasic', ['ngMaterial'])
      .controller('AppCtrl', function() {
        this.userState = '';
        this.states = ('AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS ' +
            'MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI ' +
            'WY').split(' ').map(function (state) { return { abbrev: state }; });
      });
})();


angular
  .module('radioDemo1', ['ngMaterial'])
  .controller('AppCtrl', function($scope) {

    $scope.data = {
      group1 : 'Banana',
      group2 : '2',
      group3 : 'avatar-1'
    };

    $scope.avatarData = [{
        id: "avatars:svg-1",
        title: 'avatar 1',
        value: 'avatar-1'
      },{
        id: "avatars:svg-2",
        title: 'avatar 2',
        value: 'avatar-2'
      },{
        id: "avatars:svg-3",
        title: 'avatar 3',
        value: 'avatar-3'
    }];

    $scope.radioData = [
      { label: '1', value: 1 },
      { label: '2', value: 2 },
      { label: '3', value: '3', isDisabled: true },
      { label: '4', value: '4' }
    ];


    $scope.submit = function() {
      alert('submit');
    };

    $scope.addItem = function() {
      var r = Math.ceil(Math.random() * 1000);
      $scope.radioData.push({ label: r, value: r });
    };

    $scope.removeItem = function() {
      $scope.radioData.pop();
    };

  })
  .config(function($mdIconProvider) {
    $mdIconProvider.iconSet("avatars", 'assets/angular-material-assets/icons/avatar-icons.svg',128);
  });

angular
    .module('selectDemoOptGroups', ['ngMaterial'])
    .controller('SelectOptGroupController', function($scope) {
      $scope.sizes = [
          "small (12-inch)",
          "medium (14-inch)",
          "large (16-inch)",
          "insane (42-inch)"
      ];
      $scope.toppings = [
        { category: 'meat', name: 'Pepperoni' },
        { category: 'meat', name: 'Sausage' },
        { category: 'meat', name: 'Ground Beef' },
        { category: 'meat', name: 'Bacon' },
        { category: 'veg', name: 'Mushrooms' },
        { category: 'veg', name: 'Onion' },
        { category: 'veg', name: 'Green Pepper' },
        { category: 'veg', name: 'Green Olives' }
      ];
      $scope.selectedToppings = [];
      $scope.printSelectedToppings = function printSelectedToppings() {
        var numberOfToppings = this.selectedToppings.length;

        // If there is more than one topping, we add an 'and'
        // to be gramatically correct. If there are 3+ toppings
        // we also add an oxford comma.
        if (numberOfToppings > 1) {
          var needsOxfordComma = numberOfToppings > 2;
          var lastToppingConjunction = (needsOxfordComma ? ',' : '') + ' and ';
          var lastTopping = lastToppingConjunction +
              this.selectedToppings[this.selectedToppings.length - 1];
          return this.selectedToppings.slice(0, -1).join(', ') + lastTopping;
        }

        return this.selectedToppings.join('');
      };
    });

angular
  .module('radioDemo2', ['ngMaterial'])
  .controller('ContactController', function($scope, $filter) {
    var self = this;

    self.contacts = [{
      'id': 1,
      'fullName': 'Maria Guadalupe',
      'lastName': 'Guadalupe',
      'title': "CEO, Found"
    }, {
      'id': 2,
      'fullName': 'Gabriel García Marquéz',
      'lastName': 'Marquéz',
      'title': "VP Sales & Marketing"
    }, {
      'id': 3,
      'fullName': 'Miguel de Cervantes',
      'lastName': 'Cervantes',
      'title': "Manager, Operations"
    }, {
      'id': 4,
      'fullName': 'Pacorro de Castel',
      'lastName': 'Castel',
      'title': "Security"
    }];
    self.selectedId = 2;
    self.selectedUser = function() {
      return $filter('filter')(self.contacts, { id: self.selectedId })[0].lastName;
    }
  });

angular.module('progressLinearDemo1', ['ngMaterial'])
  .config(function($mdThemingProvider) {
  })
  .controller('AppCtrl', ['$scope', '$interval', function($scope, $interval) {
    var self = this, j= 0, counter = 0;

    self.mode = 'query';
    self.activated = true;
    self.determinateValue = 30;
    self.determinateValue2 = 30;

    self.showList = [ ];

    /**
     * Turn off or on the 5 themed loaders
     */
    self.toggleActivation = function() {
        if ( !self.activated ) self.showList = [ ];
        if (  self.activated ) {
          j = counter = 0;
          self.determinateValue = 30;
          self.determinateValue2 = 30;
        }
    };

    $interval(function() {
      self.determinateValue += 1;
      self.determinateValue2 += 1.5;

      if (self.determinateValue > 100) self.determinateValue = 30;
      if (self.determinateValue2 > 100) self.determinateValue2 = 30;

        // Incrementally start animation the five (5) Indeterminate,
        // themed progress circular bars

        if ( (j < 2) && !self.showList[j] && self.activated ) {
          self.showList[j] = true;
        }
        if ( counter++ % 4 == 0 ) j++;

        // Show the indicator in the "Used within Containers" after 200ms delay
        if ( j == 2 ) self.contained = "indeterminate";

    }, 100, 0, true);

    $interval(function() {
      self.mode = (self.mode == 'query' ? 'determinate' : 'query');
    }, 7200, 0, true);
  }]);

angular.module('panelDemo', ['ngMaterial'])
    .controller('BasicDemoCtrl', BasicDemoCtrl)
    .controller('PanelDialogCtrl', PanelDialogCtrl);


function BasicDemoCtrl($mdPanel) {
  this._mdPanel = $mdPanel;

  this.desserts = [
    'Apple Pie',
    'Donut',
    'Fudge',
    'Cupcake',
    'Ice Cream',
    'Tiramisu'
  ];

  this.selected = {favoriteDessert: 'Donut'};
  this.disableParentScroll = false;
}


BasicDemoCtrl.prototype.showDialog = function() {
  var position = this._mdPanel.newPanelPosition()
      .absolute()
      .center();

  var config = {
    attachTo: angular.element(document.body),
    controller: PanelDialogCtrl,
    controllerAs: 'ctrl',
    disableParentScroll: this.disableParentScroll,
    templateUrl: 'panel.tmpl.html',
    hasBackdrop: true,
    panelClass: 'demo-dialog-example',
    position: position,
    trapFocus: true,
    zIndex: 150,
    clickOutsideToClose: true,
    escapeToClose: true,
    focusOnOpen: true
  };

  this._mdPanel.open(config);
};


BasicDemoCtrl.prototype.showMenu = function(ev) {
  var position = this._mdPanel.newPanelPosition()
      .relativeTo('.demo-menu-open-button')
      .addPanelPosition(this._mdPanel.xPosition.ALIGN_START, this._mdPanel.yPosition.BELOW);

  var config = {
    attachTo: angular.element(document.body),
    controller: PanelMenuCtrl,
    controllerAs: 'ctrl',
    template:
        '<div class="demo-menu-example" ' +
        '     aria-label="Select your favorite dessert." ' +
        '     role="listbox">' +
        '  <div class="demo-menu-item" ' +
        '       ng-class="{selected : dessert == ctrl.favoriteDessert}" ' +
        '       aria-selected="{{dessert == ctrl.favoriteDessert}}" ' +
        '       tabindex="-1" ' +
        '       role="option" ' +
        '       ng-repeat="dessert in ctrl.desserts" ' +
        '       ng-click="ctrl.selectDessert(dessert)"' +
        '       ng-keydown="ctrl.onKeydown($event, dessert)">' +
        '    {{ dessert }} ' +
        '  </div>' +
        '</div>',
    panelClass: 'demo-menu-example',
    position: position,
    locals: {
      'selected': this.selected,
      'desserts': this.desserts
    },
    openFrom: ev,
    clickOutsideToClose: true,
    escapeToClose: true,
    focusOnOpen: false,
    zIndex: 2
  };

  this._mdPanel.open(config);
};


function PanelDialogCtrl(mdPanelRef) {
  this._mdPanelRef = mdPanelRef;
}


PanelDialogCtrl.prototype.closeDialog = function() {
  this._mdPanelRef && this._mdPanelRef.close().then(function() {
    angular.element(document.querySelector('.demo-dialog-open-button')).focus();
  });
};



function PanelMenuCtrl(mdPanelRef, $timeout) {
  this._mdPanelRef = mdPanelRef;
  this.favoriteDessert = this.selected.favoriteDessert;
  $timeout(function() {
    var selected = document.querySelector('.demo-menu-item.selected');
    if (selected) {
      angular.element(selected).focus();
    } else {
      angular.element(document.querySelectorAll('.demo-menu-item')[0]).focus();
    }
  });
}


PanelMenuCtrl.prototype.selectDessert = function(dessert) {
  this.selected.favoriteDessert = dessert;
  this._mdPanelRef && this._mdPanelRef.close().then(function() {
    angular.element(document.querySelector('.demo-menu-open-button')).focus();
  });
};


PanelMenuCtrl.prototype.onKeydown = function($event, dessert) {
  var handled;
  switch ($event.which) {
    case 38: // Up Arrow.
      var els = document.querySelectorAll('.demo-menu-item');
      var index = indexOf(els, document.activeElement);
      var prevIndex = (index + els.length - 1) % els.length;
      els[prevIndex].focus();
      handled = true;
      break;

    case 40: // Down Arrow.
      var els = document.querySelectorAll('.demo-menu-item');
      var index = indexOf(els, document.activeElement);
      var nextIndex = (index + 1) % els.length;
      els[nextIndex].focus();
      handled = true;
      break;

    case 13: // Enter.
    case 32: // Space.
      this.selectDessert(dessert);
      handled = true;
      break;

    case 9: // Tab.
      this._mdPanelRef && this._mdPanelRef.close();
  }

  if (handled) {
    $event.preventDefault();
    $event.stopImmediatePropagation();
  }

  function indexOf(nodeList, element) {
    for (var item, i = 0; item = nodeList[i]; i++) {
      if (item === element) {
        return i;
      }
    }
    return -1;
  }
};

angular.module('panelAnimationsDemo', ['ngMaterial'])
    .controller('AnimationCtrl', AnimationCtrl)
    .controller('DialogCtrl', DialogCtrl);


function AnimationCtrl($mdPanel) {
  this._mdPanel = $mdPanel;
  this.openFrom = 'button';
  this.closeTo = 'button';
  this.animationType = 'none';
}


AnimationCtrl.prototype.showDialog = function() {
  var position = this._mdPanel.newPanelPosition()
      .absolute()
      .right()
      .top();

  var animation = this._mdPanel.newPanelAnimation();

  switch(this.openFrom) {
    case 'button':
      animation.openFrom('.animation-target');
      break;
    case 'corner':
      animation.openFrom({top:0, left:0});
      break;
    case 'bottom':
      animation.openFrom({
        top: document.documentElement.clientHeight,
        left: document.documentElement.clientWidth / 2 - 250
      });
  }
  switch(this.closeTo) {
    case 'button':
      animation.closeTo('.animation-target');
      break;
    case 'corner':
      animation.closeTo({top:0, left:0});
      break;
    case 'bottom':
      animation.closeTo({
        top: document.documentElement.clientHeight,
        left: document.documentElement.clientWidth / 2 - 250
      });
  }

  switch(this.animationType) {
    case 'custom':
      animation.withAnimation({
        open: 'demo-dialog-custom-animation-open',
        close: 'demo-dialog-custom-animation-close'
      });
      break;
    case 'slide':
      animation.withAnimation(this._mdPanel.animation.SLIDE);
      break;
    case 'scale':
      animation.withAnimation(this._mdPanel.animation.SCALE);
      break;
    case 'fade':
      animation.withAnimation(this._mdPanel.animation.FADE);
      break;
    case 'none':
      animation = undefined;
      break;
  }

  var config = {
    animation: animation,
    attachTo: angular.element(document.body),
    controller: DialogCtrl,
    controllerAs: 'ctrl',
    templateUrl: 'panel.tmpl.html',
    panelClass: 'demo-dialog-example',
    position: position,
    trapFocus: true,
    zIndex: 150,
    clickOutsideToClose: true,
    clickEscapeToClose: true,
    hasBackdrop: true,
  };

  this._mdPanel.open(config);
};


// Necessary to pass locals to the dialog template.
function DialogCtrl(mdPanelRef) {
  this._mdPanelRef = mdPanelRef;
}

DialogCtrl.prototype.closeDialog = function() {
  this._mdPanelRef && this._mdPanelRef.close();
};

angular
  .module('menuBarDemoBasic', ['ngMaterial'])
  .config(function($mdIconProvider) {
    $mdIconProvider
      .defaultIconSet('assets/angular-material-assets/img/icons/sets/core-icons.svg', 24);
  })
  .filter('keyboardShortcut', function($window) {
    return function(str) {
      if (!str) return;
      var keys = str.split('-');
      var isOSX = /Mac OS X/.test($window.navigator.userAgent);

      var seperator = (!isOSX || keys.length > 2) ? '+' : '';

      var abbreviations = {
        M: isOSX ? '⌘' : 'Ctrl',
        A: isOSX ? 'Option' : 'Alt',
        S: 'Shift'
      };

      return keys.map(function(key, index) {
        var last = index == keys.length - 1;
        return last ? key : abbreviations[key];
      }).join(seperator);
    };
  })
  .controller('DemoBasicCtrl', function DemoCtrl($mdDialog) {
    this.settings = {
      printLayout: true,
      showRuler: true,
      showSpellingSuggestions: true,
      presentationMode: 'edit'
    };

    this.sampleAction = function(name, ev) {
      $mdDialog.show($mdDialog.alert()
        .title(name)
        .textContent('You triggered the "' + name + '" action')
        .ok('Great')
        .targetEvent(ev)
      );
    };
  });


(function() {
  'use strict';

  angular.module('navBarDemoBasicUsage', ['ngMaterial'])
      .controller('AppCtrl', AppCtrl);

  function AppCtrl($scope) {
    $scope.currentNavItem = 'page1';
  }
})();

angular
  .module('menuDemoBasic', ['ngMaterial'])
  .config(function($mdIconProvider) {
    $mdIconProvider
      .iconSet("call", 'assets/angular-material-assets/img/icons/sets/communication-icons.svg', 24)
      .iconSet("social", 'assets/angular-material-assets/img/icons/sets/social-icons.svg', 24);
  })
  .controller('BasicDemoCtrl', function DemoCtrl($mdDialog) {
    var originatorEv;

    this.openMenu = function($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    };

    this.notificationsEnabled = true;
    this.toggleNotifications = function() {
      this.notificationsEnabled = !this.notificationsEnabled;
    };

    this.redial = function() {
      $mdDialog.show(
        $mdDialog.alert()
          .targetEvent(originatorEv)
          .clickOutsideToClose(true)
          .parent(angular.element(document.body))
          .title('Suddenly, a redial')
          .textContent('You just called a friend; who told you the most amazing story. Have a cookie!')
          .ok('That was easy')
      );

      originatorEv = null;
    };

    this.checkVoicemail = function() {
      // This never happens.
    };
  });

angular.module('menuDemoWidth', ['ngMaterial'])
.config(function($mdIconProvider) {
  $mdIconProvider
    .iconSet("call", 'assets/angular-material-assets/img/icons/sets/communication-icons.svg', 24)
    .iconSet("social", 'assets/angular-material-assets/img/icons/sets/social-icons.svg', 24);
})
.controller('WidthDemoCtrl', DemoCtrl);

function DemoCtrl($mdDialog) {
  var vm = this;

  this.announceClick = function(index) {
    $mdDialog.show(
      $mdDialog.alert()
          .clickOutsideToClose(true)
          .parent(angular.element(document.body))
        .title('You clicked!')
        .textContent('You clicked the menu item at index ' + index)
        .ok('Nice')
    );
  };
}


angular
  .module('menuDemoPosition', ['ngMaterial'])
  .config(function($mdIconProvider) {
    $mdIconProvider
      .iconSet("call", 'assets/angular-material-assets/img/icons/sets/communication-icons.svg', 24)
      .iconSet("social", 'assets/angular-material-assets/img/icons/sets/social-icons.svg', 24);
  })
  .controller('PositionDemoCtrl', function DemoCtrl($mdDialog) {
    var originatorEv;
    
    this.menuHref = "http://www.google.com/design/spec/components/menus.html#menus-specs";

    this.openMenu = function($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    };

    this.announceClick = function(index) {
      $mdDialog.show(
        $mdDialog.alert()
            .targetEvent(originatorEv)
            .clickOutsideToClose(true)
            .parent(angular.element(document.body))
          .title('You clicked!')
          .textContent('You clicked the menu item at index ' + index)
          .ok('Nice')
      );
      originatorEv = null;
    };
  });




angular.module('appUsingTemplateCache', ['ngMaterial'])
  .controller('DemoCtrl', function($scope) {})
  .config(function($mdIconProvider) {

    // Register icon IDs with sources. Future $mdIcon( <id> ) lookups
    // will load by url and retrieve the data via the $templateRequest

    $mdIconProvider
      .iconSet('core', 'assets/angular-material-assets/img/icons/sets/core-icons.svg',24)
      .icon('social:cake', 'assets/angular-material-assets/img/icons/cake.svg',24);

  })
  .run(function($templateRequest) {

    var urls = [
      'assets/angular-material-assets/img/icons/sets/core-icons.svg',
      'assets/angular-material-assets/img/icons/cake.svg',
      'assets/angular-material-assets/img/icons/android.svg'
    ];

    // Pre-fetch icons sources by URL and cache in the $templateCache...
    // subsequent $templateRequest calls will look there first.

    angular.forEach(urls, function(url) {
      $templateRequest(url);
    });

  })
  ;


angular.module('appUsingTemplateCache', ['ngMaterial'])
  .controller('DemoCtrl', function($scope) {})
  .config(function($mdIconProvider) {

    // Register icon IDs with sources. Future $mdIcon( <id> ) lookups
    // will load by url and retrieve the data via the $http and $templateCache

    $mdIconProvider
      .iconSet('core', 'assets/angular-material-assets/img/icons/sets/core-icons.svg',24)
      .icon('social:cake', 'assets/angular-material-assets/img/icons/cake.svg',24);

  })
  .run(function($http, $templateCache) {

    var urls = [
      'assets/angular-material-assets/img/icons/sets/core-icons.svg',
      'assets/angular-material-assets/img/icons/cake.svg',
      'assets/angular-material-assets/img/icons/android.svg'
    ];

    // Pre-fetch icons sources by URL and cache in the $templateCache...
    // subsequent $http calls will look there first.

    angular.forEach(urls, function(url) {
      $http.get(url, {cache: $templateCache});
    });

  })
  ;


angular
  .module('appDemoFontIconsWithLigatures', ['ngMaterial'])
  .controller('DemoCtrl', function( $scope ) {
      // Specify a list of font-icons with ligatures and color overrides
      var iconData = [
            {name: 'accessibility'  , color: "#777" },
            {name: 'question_answer', color: "rgb(89, 226, 168)" },
            {name: 'backup'         , color: "#A00" },
            {name: 'email'          , color: "#00A" }
          ];

      $scope.fonts = [].concat(iconData);

      // Create a set of sizes...
      $scope.sizes = [
        {size:"md-18",padding:0},
        {size:"md-24",padding:2},
        {size:"md-36",padding:6},
        {size:"md-48",padding:10}
      ];

  });


angular.module('listDemo1', ['ngMaterial'])
.config(function($mdIconProvider) {
  $mdIconProvider
    .iconSet('communication', 'assets/angular-material-assets/img/icons/sets/communication-icons.svg', 24);
})
.controller('AppCtrl', function($scope) {
    var imagePath = 'assets/angular-material-assets/img/list/60.jpeg';

    $scope.phones = [
      {
        type: 'Home',
        number: '(555) 251-1234',
        options: {
          icon: 'communication:phone'
        }
      },
      {
        type: 'Cell',
        number: '(555) 786-9841',
        options: {
          icon: 'communication:phone',
          avatarIcon: true
        }
      },
      {
        type: 'Office',
        number: '(555) 314-1592',
        options: {
          face : imagePath
        }
      },
      {
        type: 'Offset',
        number: '(555) 192-2010',
        options: {
          offset: true,
          actionIcon: 'communication:phone'
        }
      }
    ];
    $scope.todos = [
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
    ];
});


angular.module('appSvgIconSets', ['ngMaterial'])
  .controller('DemoCtrl', function($scope) {})
  .config(['$mdIconProvider', function($mdIconProvider) {
    $mdIconProvider
      .iconSet('social', 'assets/angular-material-assets/img/icons/sets/social-icons.svg', 24)
      .defaultIconSet('assets/angular-material-assets/img/icons/sets/core-icons.svg', 24);
  }]);


angular.module('appDemoSvgIcons', ['ngMaterial'])
.controller('DemoCtrl', function( $scope ) {

    $scope.insertDriveIconURL = 'assets/angular-material-assets/img/icons/ic_insert_drive_file_24px.svg';
    $scope.getAndroid = function() {
      return 'assets/angular-material-assets/img/icons/android.svg';
    }
    /* Returns base64 encoded SVG. */
    $scope.getAndroidEncoded = function() {
      return 'PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgaWQ9ImFuZHJvaWQiPjxwYXRoIGQ9Ik02IDE4YzAgLjU1LjQ1IDEgMSAxaDF2My41YzAgLjgzLjY3IDEuNSAxLjUgMS41czEuNS0uNjcgMS41LTEuNVYxOWgydjMuNWMwIC44My42NyAxLjUgMS41IDEuNXMxLjUtLjY3IDEuNS0xLjVWMTloMWMuNTUgMCAxLS40NSAxLTFWOEg2djEwek0zLjUgOEMyLjY3IDggMiA4LjY3IDIgOS41djdjMCAuODMuNjcgMS41IDEuNSAxLjVTNSAxNy4zMyA1IDE2LjV2LTdDNSA4LjY3IDQuMzMgOCAzLjUgOHptMTcgMGMtLjgzIDAtMS41LjY3LTEuNSAxLjV2N2MwIC44My42NyAxLjUgMS41IDEuNXMxLjUtLjY3IDEuNS0xLjV2LTdjMC0uODMtLjY3LTEuNS0xLjUtMS41em0tNC45Ny01Ljg0bDEuMy0xLjNjLjItLjIuMi0uNTEgMC0uNzEtLjItLjItLjUxLS4yLS43MSAwbC0xLjQ4IDEuNDhDMTMuODUgMS4yMyAxMi45NSAxIDEyIDFjLS45NiAwLTEuODYuMjMtMi42Ni42M0w3Ljg1LjE1Yy0uMi0uMi0uNTEtLjItLjcxIDAtLjIuMi0uMi41MSAwIC43MWwxLjMxIDEuMzFDNi45NyAzLjI2IDYgNS4wMSA2IDdoMTJjMC0xLjk5LS45Ny0zLjc1LTIuNDctNC44NHpNMTAgNUg5VjRoMXYxem01IDBoLTFWNGgxdjF6Ii8+PC9nPjwvc3ZnPg==';
    }
});


angular
  .module('appDemoFontIconsWithClassnames', ['ngMaterial'])
  .controller('DemoCtrl', function( $scope ) {
      // Create list of font-icon names with color overrides
      var iconData = [
            {name: 'icon-home'        , color: "#777" },
            {name: 'icon-user-plus'   , color: "rgb(89, 226, 168)" },
            {name: 'icon-google-plus2', color: "#A00" },
            {name: 'icon-youtube4'    , color:"#00A" },
             // Use theming to color the font-icon
            {name: 'icon-settings'    , color:"#A00", theme:"md-warn md-hue-5"}
          ];

      // Create a set of sizes...
      $scope.sizes = [
        {size:48,padding:10},
        {size:36,padding:6},
        {size:24,padding:2},
        {size:12,padding:0}
      ];

      $scope.fonts = [].concat(iconData);



  })
  .config(function($mdThemingProvider){
    // Update the theme colors to use themes on font-icons
    $mdThemingProvider.theme('default')
          .primaryPalette("red")
          .accentPalette('green')
          .warnPalette('blue');
  });

angular.module('listDemo2', ['ngMaterial'])
.config(function($mdIconProvider) {
  $mdIconProvider
    .iconSet('social', 'assets/angular-material-assets/img/icons/sets/social-icons.svg', 24)
    .iconSet('device', 'assets/angular-material-assets/img/icons/sets/device-icons.svg', 24)
    .iconSet('communication', 'assets/angular-material-assets/img/icons/sets/communication-icons.svg', 24)
    .defaultIconSet('assets/angular-material-assets/img/icons/sets/core-icons.svg', 24);
})
.controller('ListCtrl', function($scope, $mdDialog) {
  $scope.toppings = [
    { name: 'Pepperoni', wanted: true },
    { name: 'Sausage', wanted: false },
    { name: 'Black Olives', wanted: true },
    { name: 'Green Peppers', wanted: false }
  ];

  $scope.settings = [
    { name: 'Wi-Fi', extraScreen: 'Wi-fi menu', icon: 'device:network-wifi', enabled: true },
    { name: 'Bluetooth', extraScreen: 'Bluetooth menu', icon: 'device:bluetooth', enabled: false },
  ];

  $scope.messages = [
    {id: 1, title: "Message A", selected: false},
    {id: 2, title: "Message B", selected: true},
    {id: 3, title: "Message C", selected: true},
  ];

  $scope.people = [
    { name: 'Janet Perkins', img: 'assets/angular-material-assets/img/100-0.jpeg', newMessage: true },
    { name: 'Mary Johnson', img: 'assets/angular-material-assets/img/100-1.jpeg', newMessage: false },
    { name: 'Peter Carlsson', img: 'assets/angular-material-assets/img/100-2.jpeg', newMessage: false }
  ];

  $scope.goToPerson = function(person, event) {
    $mdDialog.show(
      $mdDialog.alert()
        .title('Navigating')
        .textContent('Inspect ' + person)
        .ariaLabel('Person inspect demo')
        .ok('Neat!')
        .targetEvent(event)
    );
  };

  $scope.navigateTo = function(to, event) {
    $mdDialog.show(
      $mdDialog.alert()
        .title('Navigating')
        .textContent('Imagine being taken to ' + to)
        .ariaLabel('Navigation demo')
        .ok('Neat!')
        .targetEvent(event)
    );
  };

  $scope.doPrimaryAction = function(event) {
    $mdDialog.show(
      $mdDialog.alert()
        .title('Primary Action')
        .textContent('Primary actions can be used for one click actions')
        .ariaLabel('Primary click demo')
        .ok('Awesome!')
        .targetEvent(event)
    );
  };

  $scope.doSecondaryAction = function(event) {
    $mdDialog.show(
      $mdDialog.alert()
        .title('Secondary Action')
        .textContent('Secondary actions can be used for one click actions')
        .ariaLabel('Secondary click demo')
        .ok('Neat!')
        .targetEvent(event)
    );
  };

});

angular
  .module('inputIconDemo', ['ngMaterial', 'ngMessages'])
  .controller('DemoCtrl', function($scope) {
    $scope.user = {
      name: 'John Doe',
      email: '',
      phone: '',
      address: 'Mountain View, CA',
      donation: 19.99
    };
  });

angular.module('inputErrorsAdvancedApp', ['ngMaterial', 'ngMessages'])

  .controller('AppCtrl', function($scope) {
    $scope.showHints = true;

    $scope.user = {
      name: "",
      email: "",
      social: "123456789",
      phone: "N/A"
    };
  });


angular.module('gridListDemo1', ['ngMaterial'])
.controller('AppCtrl', function($scope) {});

angular
  .module('inputBasicDemo', ['ngMaterial', 'ngMessages'])
  .controller('DemoCtrl', function($scope) {
    $scope.user = {
      title: 'Developer',
      email: 'ipsum@lorem.com',
      firstName: '',
      lastName: '',
      company: 'Google',
      address: '1600 Amphitheatre Pkwy',
      city: 'Mountain View',
      state: 'CA',
      biography: 'Loves kittens, snowboarding, and can type at 130 WPM.\n\nAnd rumor has it she bouldered up Castle Craig!',
      postalCode: '94043'
    };

    $scope.states = ('AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS ' +
    'MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI ' +
    'WY').split(' ').map(function(state) {
        return {abbrev: state};
      });
  })
  .config(function($mdThemingProvider) {

    // Configure a dark theme with primary foreground yellow

    $mdThemingProvider.theme('docs-dark', 'default')
      .primaryPalette('yellow')
      .dark();

  });

angular.module('inputErrorsApp', ['ngMaterial', 'ngMessages'])

.controller('AppCtrl', function($scope) {
  $scope.project = {
    description: 'Nuclear Missile Defense System',
    rate: 500
  };
});

angular.module('dialogDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope, $mdDialog, $mdMedia) {
  $scope.status = '  ';
  $scope.customFullscreen = $mdMedia('xs') || $mdMedia('sm');

  $scope.showAlert = function(ev) {
    // Appending dialog to document.body to cover sidenav in docs app
    // Modal dialogs should fully cover application
    // to prevent interaction outside of dialog
    $mdDialog.show(
      $mdDialog.alert()
        .parent(angular.element(document.querySelector('#popupContainer')))
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .title('This is an alert title')
        .textContent('You can specify some description text in here.')
        .ariaLabel('Alert Dialog Demo')
        .ok('Got it!')
        .targetEvent(ev)
    );
  };

  $scope.showConfirm = function(ev) {
    // Appending dialog to document.body to cover sidenav in docs app
    var confirm = $mdDialog.confirm()
          .title('Would you like to delete your debt?')
          .textContent('All of the banks have agreed to forgive you your debts.')
          .ariaLabel('Lucky day')
          .targetEvent(ev)
          .clickOutsideToClose(true)
          .parent(angular.element(document.body))
          .ok('Please do it!')
          .cancel('Sounds like a scam');

    $mdDialog.show(confirm).then(function() {
      $scope.status = 'You decided to get rid of your debt.';
    }, function() {
      $scope.status = 'You decided to keep your debt.';
    });
  };

  $scope.showPrompt = function(ev) {
    // Appending dialog to document.body to cover sidenav in docs app
    var confirm = $mdDialog.prompt()
          .title('What would you name your dog?')
          .textContent('Bowser is a common name.')
          .placeholder('dog name')
          .ariaLabel('Dog name')
          .targetEvent(ev)
          .parent(angular.element(document.body))
          .ok('Okay!')
          .cancel('I\'m a cat person');

    $mdDialog.show(confirm).then(function(result) {
      $scope.status = 'You decided to name your dog ' + result + '.';
    }, function() {
      $scope.status = 'You didn\'t name your dog.';
    });
  };

  $scope.showAdvanced = function(ev) {
    var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && $scope.customFullscreen;

    $mdDialog.show({
      controller: DialogController,
      templateUrl: 'dialog1.tmpl.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose:true,
      fullscreen: useFullScreen
    })
    .then(function(answer) {
      $scope.status = 'You said the information was "' + answer + '".';
    }, function() {
      $scope.status = 'You cancelled the dialog.';
    });



    $scope.$watch(function() {
      return $mdMedia('xs') || $mdMedia('sm');
    }, function(wantsFullScreen) {
      $scope.customFullscreen = (wantsFullScreen === true);
    });

  };

  $scope.showTabDialog = function(ev) {
    $mdDialog.show({
      controller: DialogController,
      templateUrl: 'tabDialog.tmpl.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose:true
    })
        .then(function(answer) {
          $scope.status = 'You said the information was "' + answer + '".';
        }, function() {
          $scope.status = 'You cancelled the dialog.';
        });
  };
});

function DialogController($scope, $mdDialog) {
  $scope.hide = function() {
    $mdDialog.hide();
  };

  $scope.cancel = function() {
    $mdDialog.cancel();
  };

  $scope.answer = function(answer) {
    $mdDialog.hide(answer);
  };
}


angular.module('gridListDemo2', ['ngMaterial'])
.controller('AppCtrl', function($scope) {
  var COLORS = ['#ffebee', '#ffcdd2', '#ef9a9a', '#e57373', '#ef5350', '#f44336', '#e53935', '#d32f2f', '#c62828', '#b71c1c', '#ff8a80', '#ff5252', '#ff1744', '#d50000', '#f8bbd0', '#f48fb1', '#f06292', '#ec407a', '#e91e63', '#d81b60', '#c2185b', '#ad1457', '#880e4f', '#ff80ab', '#ff4081', '#f50057', '#c51162', '#e1bee7', '#ce93d8', '#ba68c8', '#ab47bc', '#9c27b0', '#8e24aa', '#7b1fa2', '#4a148c', '#ea80fc', '#e040fb', '#d500f9', '#aa00ff', '#ede7f6', '#d1c4e9', '#b39ddb', '#9575cd', '#7e57c2', '#673ab7', '#5e35b1', '#4527a0', '#311b92', '#b388ff', '#7c4dff', '#651fff', '#6200ea', '#c5cae9', '#9fa8da', '#7986cb', '#5c6bc0', '#3f51b5', '#3949ab', '#303f9f', '#283593', '#1a237e', '#8c9eff', '#536dfe', '#3d5afe', '#304ffe', '#e3f2fd', '#bbdefb', '#90caf9', '#64b5f6', '#42a5f5', '#2196f3', '#1e88e5', '#1976d2', '#1565c0', '#0d47a1', '#82b1ff', '#448aff', '#2979ff', '#2962ff', '#b3e5fc', '#81d4fa', '#4fc3f7', '#29b6f6', '#03a9f4', '#039be5', '#0288d1', '#0277bd', '#01579b', '#80d8ff', '#40c4ff', '#00b0ff', '#0091ea', '#e0f7fa', '#b2ebf2', '#80deea', '#4dd0e1', '#26c6da', '#00bcd4', '#00acc1', '#0097a7', '#00838f', '#006064', '#84ffff', '#18ffff', '#00e5ff', '#00b8d4', '#e0f2f1', '#b2dfdb', '#80cbc4', '#4db6ac', '#26a69a', '#009688', '#00897b', '#00796b', '#00695c', '#a7ffeb', '#64ffda', '#1de9b6', '#00bfa5', '#e8f5e9', '#c8e6c9', '#a5d6a7', '#81c784', '#66bb6a', '#4caf50', '#43a047', '#388e3c', '#2e7d32', '#1b5e20', '#b9f6ca', '#69f0ae', '#00e676', '#00c853', '#f1f8e9', '#dcedc8', '#c5e1a5', '#aed581', '#9ccc65', '#8bc34a', '#7cb342', '#689f38', '#558b2f', '#33691e', '#ccff90', '#b2ff59', '#76ff03', '#64dd17', '#f9fbe7', '#f0f4c3', '#e6ee9c', '#dce775', '#d4e157', '#cddc39', '#c0ca33', '#afb42b', '#9e9d24', '#827717', '#f4ff81', '#eeff41', '#c6ff00', '#aeea00', '#fffde7', '#fff9c4', '#fff59d', '#fff176', '#ffee58', '#ffeb3b', '#fdd835', '#fbc02d', '#f9a825', '#f57f17', '#ffff8d', '#ffff00', '#ffea00', '#ffd600', '#fff8e1', '#ffecb3', '#ffe082', '#ffd54f', '#ffca28', '#ffc107', '#ffb300', '#ffa000', '#ff8f00', '#ff6f00', '#ffe57f', '#ffd740', '#ffc400', '#ffab00', '#fff3e0', '#ffe0b2', '#ffcc80', '#ffb74d', '#ffa726', '#ff9800', '#fb8c00', '#f57c00', '#ef6c00', '#e65100', '#ffd180', '#ffab40', '#ff9100', '#ff6d00', '#fbe9e7', '#ffccbc', '#ffab91', '#ff8a65', '#ff7043', '#ff5722', '#f4511e', '#e64a19', '#d84315', '#bf360c', '#ff9e80', '#ff6e40', '#ff3d00', '#dd2c00', '#d7ccc8', '#bcaaa4', '#795548', '#d7ccc8', '#bcaaa4', '#8d6e63', '#eceff1', '#cfd8dc', '#b0bec5', '#90a4ae', '#78909c', '#607d8b', '#546e7a', '#cfd8dc', '#b0bec5', '#78909c'];

  this.colorTiles = (function() {
    var tiles = [];
    for (var i = 0; i < 46; i++) {
      tiles.push({
        color: randomColor(),
        colspan: randomSpan(),
        rowspan: randomSpan()
      });
    }
    return tiles;
  })();


  function randomColor() {
    return COLORS[Math.floor(Math.random() * COLORS.length)];
  }

  function randomSpan() {
    var r = Math.random();
    if (r < 0.8) {
      return 1;
    } else if (r < 0.9) {
      return 2;
    } else {
      return 3;
    }
  }
});


angular
  .module('gridListDemoApp', ['ngMaterial'])
  .controller('gridListDemoCtrl', function($scope) {

    this.tiles = buildGridModel({
            icon : "avatar:svg-",
            title: "Svg-",
            background: ""
          });

    function buildGridModel(tileTmpl){
      var it, results = [ ];

      for (var j=0; j<11; j++) {

        it = angular.extend({},tileTmpl);
        it.icon  = it.icon + (j+1);
        it.title = it.title + (j+1);
        it.span  = { row : 1, col : 1 };

        switch(j+1) {
          case 1:
            it.background = "red";
            it.span.row = it.span.col = 2;
            break;

          case 2: it.background = "green";         break;
          case 3: it.background = "darkBlue";      break;
          case 4:
            it.background = "blue";
            it.span.col = 2;
            break;

          case 5:
            it.background = "yellow";
            it.span.row = it.span.col = 2;
            break;

          case 6: it.background = "pink";          break;
          case 7: it.background = "darkBlue";      break;
          case 8: it.background = "purple";        break;
          case 9: it.background = "deepBlue";      break;
          case 10: it.background = "lightPurple";  break;
          case 11: it.background = "yellow";       break;
        }

        results.push(it);
      }
      return results;
    }
  })
  .config( function( $mdIconProvider ){
    $mdIconProvider.iconSet("avatar", 'assets/angular-material-assets/icons/avatar-icons.svg', 128);
  });

angular.module('dialogDemo2', ['ngMaterial'])

.controller('AppCtrl', function($scope, $mdDialog) {
  $scope.openFromLeft = function() {
    $mdDialog.show(
      $mdDialog.alert()
        .clickOutsideToClose(true)
        .title('Opening from the left')
        .textContent('Closing to the right!')
        .ariaLabel('Left to right demo')
        .parent(angular.element(document.body))
        .ok('Nice!')
        // You can specify either sting with query selector
        .openFrom('#left')
        // or an element
        .closeTo(angular.element(document.querySelector('#right')))
    );
  };

  $scope.openOffscreen = function() {
    $mdDialog.show(
      $mdDialog.alert()
        .clickOutsideToClose(true)
        .title('Opening from offscreen')
        .textContent('Closing to offscreen')
        .ariaLabel('Offscreen Demo')
        .parent(angular.element(document.body))
        .ok('Amazing!')
        // Or you can specify the rect to do the transition from
        .openFrom({
          top: -50,
          width: 30,
          height: 80
        })
        .closeTo({
          left: 1500
        })
    );
  };
});

angular
  .module('colorsThemePickerDemo', ['ngMaterial'])
  .controller('ThemeDemoCtrl', function ($scope, $mdColorPalette) {
    $scope.colors = Object.keys($mdColorPalette); 

    $scope.mdURL = 'https://www.google.com/design/spec/style/color.html#color-color-palette';
    $scope.primary = 'purple';
    $scope.accent = 'green';

    $scope.isPrimary = true;

    $scope.selectTheme = function (color) {
      if ($scope.isPrimary) {
        $scope.primary = color;

        $scope.isPrimary = false;
      }
      else {
        $scope.accent = color;

        $scope.isPrimary = true;
      }
    };
  })
  .directive('themePreview', function () {
    return {
      restrict: 'E',
      templateUrl: 'themePreview.tmpl.html',
      scope: {
        primary: '=',
        accent: '='
      },
      controller: function ($scope, $mdColors, $mdColorUtil) {
        $scope.getColor = function (color) {
          return $mdColorUtil.rgbaToHex($mdColors.getThemeColor(color))
        };
      }
    }
  })
  .directive('mdJustified', function() {
    return {
      restrict : 'A',
      compile : function(element, attrs)  {
        var layoutDirection = 'layout-'+ (attrs.mdJustified || "row");

        element.removeAttr('md-justified');
        element.addClass(layoutDirection);
        element.addClass("layout-align-space-between-stretch");

        return angular.noop;
      }
    };
  });

(function() {
  'use strict';

  angular.module('fabToolbarBasicUsageDemo', ['ngMaterial'])
    .controller('AppCtrl', function($scope) {
      $scope.isOpen = false;

      $scope.demo = {
        isOpen: false,
        count: 0,
        selectedDirection: 'left'
      };
    });
})();
(function() {
  'use strict';

  angular.module('fabSpeedDialDemoMoreOptions', ['ngMaterial'])
    .controller('DemoCtrl', function($scope, $mdDialog, $timeout) {
      var self = this;

      self.hidden = false;
      self.isOpen = false;
      self.hover = false;

      // On opening, add a delayed property which shows tooltips after the speed dial has opened
      // so that they have the proper position; if closing, immediately hide the tooltips
      $scope.$watch('demo.isOpen', function(isOpen) {
        if (isOpen) {
          $timeout(function() {
            $scope.tooltipVisible = self.isOpen;
          }, 600);
        } else {
          $scope.tooltipVisible = self.isOpen;
        }
      });

      self.items = [
        { name: "Twitter", icon: "assets/angular-material-assets/img/icons/twitter.svg", direction: "bottom" },
        { name: "Facebook", icon: "assets/angular-material-assets/img/icons/facebook.svg", direction: "top" },
        { name: "Google Hangout", icon: "assets/angular-material-assets/img/icons/hangout.svg", direction: "bottom" }
      ];

      self.openDialog = function($event, item) {
        // Show the dialog
        $mdDialog.show({
          clickOutsideToClose: true,
          controller: function($mdDialog) {
            // Save the clicked item
            this.item = item;

            // Setup some handlers
            this.close = function() {
              $mdDialog.cancel();
            };
            this.submit = function() {
              $mdDialog.hide();
            };
          },
          controllerAs: 'dialog',
          templateUrl: 'dialog.html',
          targetEvent: $event
        });
      }
    });
})();

angular.module('dividerDemo1', ['ngMaterial'])
  .controller('AppCtrl', function($scope) {
    var imagePath = 'assets/angular-material-assets/img/list/60.jpeg';
    $scope.messages = [{
      face : imagePath,
      what: 'Brunch this weekend?',
      who: 'Min Li Chan',
      when: '3:08PM',
      notes: " I'll be in your neighborhood doing errands"
    }, {
      face : imagePath,
      what: 'Brunch this weekend?',
      who: 'Min Li Chan',
      when: '3:08PM',
      notes: " I'll be in your neighborhood doing errands"
    }, {
      face : imagePath,
      what: 'Brunch this weekend?',
      who: 'Min Li Chan',
      when: '3:08PM',
      notes: " I'll be in your neighborhood doing errands"
    }, {
      face : imagePath,
      what: 'Brunch this weekend?',
      who: 'Min Li Chan',
      when: '3:08PM',
      notes: " I'll be in your neighborhood doing errands"
    }, {
      face : imagePath,
      what: 'Brunch this weekend?',
      who: 'Min Li Chan',
      when: '3:08PM',
      notes: " I'll be in your neighborhood doing errands"
    }];
  });

angular.module('datepickerBasicUsage',
    ['ngMaterial', 'ngMessages']).controller('AppCtrl', function($scope) {
  $scope.myDate = new Date();

  $scope.minDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth() - 2,
      $scope.myDate.getDate());

  $scope.maxDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth() + 2,
      $scope.myDate.getDate());
  
  $scope.onlyWeekendsPredicate = function(date) {
    var day = date.getDay();
    return day === 0 || day === 6;
  }
});

(function() {
  'use strict';

  angular.module('fabSpeedDialDemoBasicUsage', ['ngMaterial'])
    .controller('DemoCtrl', function() {
      this.topDirections = ['left', 'up'];
      this.bottomDirections = ['down', 'right'];

      this.isOpen = false;

      this.availableModes = ['md-fling', 'md-scale'];
      this.selectedMode = 'md-fling';

      this.availableDirections = ['up', 'down', 'left', 'right'];
      this.selectedDirection = 'up';
    });
})();


angular.module('contentDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {

});

angular.module('colorsDemo', ['ngMaterial'])
  .config(function ($mdThemingProvider, $mdIconProvider) {
    $mdThemingProvider.theme('forest')
      .primaryPalette('brown')
      .accentPalette('green');

    $mdIconProvider
      .defaultIconSet('assets/angular-material-assets/img/icons/sets/social-icons.svg', 24);
  })
  .directive('regularCard', function () {
    return {
      restrict: 'E',
      templateUrl: 'regularCard.tmpl.html',
      scope: {
        name: '@',
      }
    }
  })
  .directive('userCard', function () {
    return {
      restrict: 'E',
      templateUrl: 'userCard.tmpl.html',
      scope: {
        name: '@',
        theme: '@'
      },
      controller: function ($scope) {
        $scope.theme = $scope.theme || 'default';
      }
    }
  });

(function () {
  'use strict';
  angular
      .module('chipsCustomSeparatorDemo', ['ngMaterial'])
      .controller('CustomSeparatorCtrl', DemoCtrl);

  function DemoCtrl ($mdConstant) {
    // Use common key codes found in $mdConstant.KEY_CODE...
    this.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];
    this.tags = [];

    // Any key code can be used to create a custom separator
    var semicolon = 186;
    this.customKeys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, semicolon];
    this.contacts = ['test@example.com'];
  }
})();

(function () {
  'use strict';
  angular
      .module('staticChipsDemo', ['ngMaterial'])
      .controller('DemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q) {
    this.chipText = 'Football';
  }
})();

(function () {
  'use strict';
  angular
      .module('chipsDemo', ['ngMaterial', 'ngMessages'])
      .controller('BasicDemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q) {
    var self = this;

    self.readonly = false;

    // Lists of fruit names and Vegetable objects
    self.fruitNames = ['Apple', 'Banana', 'Orange'];
    self.roFruitNames = angular.copy(self.fruitNames);
    self.editableFruitNames = angular.copy(self.fruitNames);

    self.tags = [];
    self.vegObjs = [
      {
        'name' : 'Broccoli',
        'type' : 'Brassica'
      },
      {
        'name' : 'Cabbage',
        'type' : 'Brassica'
      },
      {
        'name' : 'Carrot',
        'type' : 'Umbelliferous'
      }
    ];

    self.newVeg = function(chip) {
      return {
        name: chip,
        type: 'unknown'
      };
    };
  }
})();

(function () {
  'use strict';
  angular
      .module('chipsCustomInputDemo', ['ngMaterial'])
      .controller('CustomInputDemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q) {
    var self = this;

    self.readonly = false;
    self.selectedItem = null;
    self.searchText = null;
    self.querySearch = querySearch;
    self.vegetables = loadVegetables();
    self.selectedVegetables = [];
    self.numberChips = [];
    self.numberChips2 = [];
    self.numberBuffer = '';
    self.autocompleteDemoRequireMatch = true;
    self.transformChip = transformChip;

    /**
     * Return the proper object when the append is called.
     */
    function transformChip(chip) {
      // If it is an object, it's already a known chip
      if (angular.isObject(chip)) {
        return chip;
      }

      // Otherwise, create a new one
      return { name: chip, type: 'new' }
    }

    /**
     * Search for vegetables.
     */
    function querySearch (query) {
      var results = query ? self.vegetables.filter(createFilterFor(query)) : [];
      return results;
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(vegetable) {
        return (vegetable._lowername.indexOf(lowercaseQuery) === 0) ||
            (vegetable._lowertype.indexOf(lowercaseQuery) === 0);
      };

    }

    function loadVegetables() {
      var veggies = [
        {
          'name': 'Broccoli',
          'type': 'Brassica'
        },
        {
          'name': 'Cabbage',
          'type': 'Brassica'
        },
        {
          'name': 'Carrot',
          'type': 'Umbelliferous'
        },
        {
          'name': 'Lettuce',
          'type': 'Composite'
        },
        {
          'name': 'Spinach',
          'type': 'Goosefoot'
        }
      ];

      return veggies.map(function (veg) {
        veg._lowername = veg.name.toLowerCase();
        veg._lowertype = veg.type.toLowerCase();
        return veg;
      });
    }
  }
})();

(function () {
  'use strict';
  angular
      .module('contactChipsDemo', ['ngMaterial'])
      .controller('ContactChipDemoCtrl', DemoCtrl);

  function DemoCtrl ($q, $timeout) {
    var self = this;
    var pendingSearch, cancelSearch = angular.noop;
    var cachedQuery, lastSearch;

    self.allContacts = loadContacts();
    self.contacts = [self.allContacts[0]];
    self.asyncContacts = [];
    self.filterSelected = true;

    self.querySearch = querySearch;
    self.delayedQuerySearch = delayedQuerySearch;

    /**
     * Search for contacts; use a random delay to simulate a remote call
     */
    function querySearch (criteria) {
      cachedQuery = cachedQuery || criteria;
      return cachedQuery ? self.allContacts.filter(createFilterFor(cachedQuery)) : [];
    }

    /**
     * Async search for contacts
     * Also debounce the queries; since the md-contact-chips does not support this
     */
    function delayedQuerySearch(criteria) {
      cachedQuery = criteria;
      if ( !pendingSearch || !debounceSearch() )  {
        cancelSearch();

        return pendingSearch = $q(function(resolve, reject) {
          // Simulate async search... (after debouncing)
          cancelSearch = reject;
          $timeout(function() {

            resolve( self.querySearch() );

            refreshDebounce();
          }, Math.random() * 500, true)
        });
      }

      return pendingSearch;
    }

    function refreshDebounce() {
      lastSearch = 0;
      pendingSearch = null;
      cancelSearch = angular.noop;
    }

    /**
     * Debounce if querying faster than 300ms
     */
    function debounceSearch() {
      var now = new Date().getMilliseconds();
      lastSearch = lastSearch || now;

      return ((now - lastSearch) < 300);
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(contact) {
        return (contact._lowername.indexOf(lowercaseQuery) != -1);
      };

    }

    function loadContacts() {
      var contacts = [
        'Marina Augustine',
        'Oddr Sarno',
        'Nick Giannopoulos',
        'Narayana Garner',
        'Anita Gros',
        'Megan Smith',
        'Tsvetko Metzger',
        'Hector Simek',
        'Some-guy withalongalastaname'
      ];

      return contacts.map(function (c, index) {
        var cParts = c.split(' ');
        var contact = {
          name: c,
          email: cParts[0][0].toLowerCase() + '.' + cParts[1].toLowerCase() + '@example.com',
          image: 'http://lorempixel.com/50/50/people?' + index
        };
        contact._lowername = contact.name.toLowerCase();
        return contact;
      });
    }
  }


})();


angular.module('buttonsDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {
  $scope.title1 = 'Button';
  $scope.title4 = 'Warn';
  $scope.isDisabled = true;

  $scope.googleUrl = 'http://google.com';

});


angular.module('checkboxDemo2', ['ngMaterial'])

.controller('AppCtrl', function($scope) {

    $scope.items = [1,2,3,4,5];
      $scope.selected = [];

      $scope.toggle = function (item, list) {
        var idx = list.indexOf(item);
        if (idx > -1) {
          list.splice(idx, 1);
        }
        else {
          list.push(item);
        }
      };

      $scope.exists = function (item, list) {
        return list.indexOf(item) > -1;
      };
});


angular.module('checkboxDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {

  $scope.data = {};
  $scope.data.cb1 = true;
  $scope.data.cb2 = false;
  $scope.data.cb3 = false;
  $scope.data.cb4 = false;
  $scope.data.cb5 = false;

});


angular.module('checkboxDemo3', ['ngMaterial'])

.controller('AppCtrl', function($scope) {
  $scope.items = [1,2,3,4,5];
  $scope.selected = [1];
  $scope.toggle = function (item, list) {
    var idx = list.indexOf(item);
    if (idx > -1) {
      list.splice(idx, 1);
    }
    else {
      list.push(item);
    }
  };

  $scope.exists = function (item, list) {
    return list.indexOf(item) > -1;
  };

  $scope.isIndeterminate = function() {
    return ($scope.selected.length !== 0 &&
        $scope.selected.length !== $scope.items.length);
  };

  $scope.isChecked = function() {
    return $scope.selected.length === $scope.items.length;
  };

  $scope.toggleAll = function() {
    if ($scope.selected.length === $scope.items.length) {
      $scope.selected = [];
    } else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
      $scope.selected = $scope.items.slice(0);
    }
  };
});


angular.module('cardDemo3', ['ngMaterial'])

.controller('AppCtrl', function($scope) {
  $scope.imagePath = 'assets/angular-material-assets/img/washedout.png';
});


angular.module('cardDemo2', ['ngMaterial'])

.controller('AppCtrl', function($scope) {
  $scope.imagePath = 'assets/angular-material-assets/img/washedout.png';
});


angular.module('cardDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {
  $scope.imagePath = 'assets/angular-material-assets/img/washedout.png';
})
.config(function($mdThemingProvider) {
  $mdThemingProvider.theme('dark-grey').backgroundPalette('grey').dark();
  $mdThemingProvider.theme('dark-orange').backgroundPalette('orange').dark();
  $mdThemingProvider.theme('dark-purple').backgroundPalette('deep-purple').dark();
  $mdThemingProvider.theme('dark-blue').backgroundPalette('blue').dark();
});

(function () {
  'use strict';
  angular
      .module('autocompleteDemoInsideDialog', ['ngMaterial'])
      .controller('DemoCtrl', DemoCtrl);

  function DemoCtrl($mdDialog) {
    var self = this;

    self.openDialog = function($event) {
      $mdDialog.show({
        controller: DialogCtrl,
        controllerAs: 'ctrl',
        templateUrl: 'dialog.tmpl.html',
        parent: angular.element(document.body),
        targetEvent: $event,
        clickOutsideToClose:true
      })
    }
  }

  function DialogCtrl ($timeout, $q, $scope, $mdDialog) {
    var self = this;

    // list of `state` value/display objects
    self.states        = loadAll();
    self.querySearch   = querySearch;

    // ******************************
    // Template methods
    // ******************************

    self.cancel = function($event) {
      $mdDialog.cancel();
    };
    self.finish = function($event) {
      $mdDialog.hide();
    };

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for states... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch (query) {
      return query ? self.states.filter( createFilterFor(query) ) : self.states;
    }

    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {
      var allStates = 'Alabama, Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware,\
              Florida, Georgia, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana,\
              Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana,\
              Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, New York, North Carolina,\
              North Dakota, Ohio, Oklahoma, Oregon, Pennsylvania, Rhode Island, South Carolina,\
              South Dakota, Tennessee, Texas, Utah, Vermont, Virginia, Washington, West Virginia,\
              Wisconsin, Wyoming';

      return allStates.split(/, +/g).map( function (state) {
        return {
          value: state.toLowerCase(),
          display: state
        };
      });
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(state) {
        return (state.value.indexOf(lowercaseQuery) === 0);
      };

    }
  }
})();

(function () {
  'use strict';
  angular
      .module('autocompleteCustomTemplateDemo', ['ngMaterial'])
      .controller('DemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q, $log) {
    var self = this;

    self.simulateQuery = false;
    self.isDisabled    = false;

    self.repos         = loadAll();
    self.querySearch   = querySearch;
    self.selectedItemChange = selectedItemChange;
    self.searchTextChange   = searchTextChange;

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for repos... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch (query) {
      var results = query ? self.repos.filter( createFilterFor(query) ) : self.repos,
          deferred;
      if (self.simulateQuery) {
        deferred = $q.defer();
        $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
        return deferred.promise;
      } else {
        return results;
      }
    }

    function searchTextChange(text) {
      $log.info('Text changed to ' + text);
    }

    function selectedItemChange(item) {
      $log.info('Item changed to ' + JSON.stringify(item));
    }

    /**
     * Build `components` list of key/value pairs
     */
    function loadAll() {
      var repos = [
        {
          'name'      : 'Angular 1',
          'url'       : 'https://github.com/angular/angular.js',
          'watchers'  : '3,623',
          'forks'     : '16,175',
        },
        {
          'name'      : 'Angular 2',
          'url'       : 'https://github.com/angular/angular',
          'watchers'  : '469',
          'forks'     : '760',
        },
        {
          'name'      : 'Angular Material',
          'url'       : 'https://github.com/angular/material',
          'watchers'  : '727',
          'forks'     : '1,241',
        },
        {
          'name'      : 'Bower Material',
          'url'       : 'https://github.com/angular/bower-material',
          'watchers'  : '42',
          'forks'     : '84',
        },
        {
          'name'      : 'Material Start',
          'url'       : 'https://github.com/angular/material-start',
          'watchers'  : '81',
          'forks'     : '303',
        }
      ];
      return repos.map( function (repo) {
        repo.value = repo.name.toLowerCase();
        return repo;
      });
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(item) {
        return (item.value.indexOf(lowercaseQuery) === 0);
      };

    }
  }
})();

angular.module('bottomSheetDemo1', ['ngMaterial'])
.config(function($mdIconProvider) {
    $mdIconProvider
      .icon('share-arrow', 'assets/angular-material-assets/img/icons/share-arrow.svg', 24)
      .icon('upload', 'assets/angular-material-assets/img/icons/upload.svg', 24)
      .icon('copy', 'assets/angular-material-assets/img/icons/copy.svg', 24)
      .icon('print', 'assets/angular-material-assets/img/icons/print.svg', 24)
      .icon('hangout', 'assets/angular-material-assets/img/icons/hangout.svg', 24)
      .icon('mail', 'assets/angular-material-assets/img/icons/mail.svg', 24)
      .icon('message', 'assets/angular-material-assets/img/icons/message.svg', 24)
      .icon('copy2', 'assets/angular-material-assets/img/icons/copy2.svg', 24)
      .icon('facebook', 'assets/angular-material-assets/img/icons/facebook.svg', 24)
      .icon('twitter', 'assets/angular-material-assets/img/icons/twitter.svg', 24);
  })
.controller('BottomSheetExample', function($scope, $timeout, $mdBottomSheet, $mdToast) {
  $scope.alert = '';

  $scope.showListBottomSheet = function() {
    $scope.alert = '';
    $mdBottomSheet.show({
      templateUrl: 'bottom-sheet-list-template.html',
      controller: 'ListBottomSheetCtrl'
    }).then(function(clickedItem) {
      $scope.alert = clickedItem['name'] + ' clicked!';
    });
  };

  $scope.showGridBottomSheet = function() {
    $scope.alert = '';
    $mdBottomSheet.show({
      templateUrl: 'bottom-sheet-grid-template.html',
      controller: 'GridBottomSheetCtrl',
      clickOutsideToClose: false
    }).then(function(clickedItem) {
      $mdToast.show(
            $mdToast.simple()
              .textContent(clickedItem['name'] + ' clicked!')
              .position('top right')
              .hideDelay(1500)
          );
    });
  };
})

.controller('ListBottomSheetCtrl', function($scope, $mdBottomSheet) {

  $scope.items = [
    { name: 'Share', icon: 'share-arrow' },
    { name: 'Upload', icon: 'upload' },
    { name: 'Copy', icon: 'copy' },
    { name: 'Print this page', icon: 'print' },
  ];

  $scope.listItemClick = function($index) {
    var clickedItem = $scope.items[$index];
    $mdBottomSheet.hide(clickedItem);
  };
})
.controller('GridBottomSheetCtrl', function($scope, $mdBottomSheet) {
  $scope.items = [
    { name: 'Hangout', icon: 'hangout' },
    { name: 'Mail', icon: 'mail' },
    { name: 'Message', icon: 'message' },
    { name: 'Copy', icon: 'copy2' },
    { name: 'Facebook', icon: 'facebook' },
    { name: 'Twitter', icon: 'twitter' },
  ];

  $scope.listItemClick = function($index) {
    var clickedItem = $scope.items[$index];
    $mdBottomSheet.hide(clickedItem);
  };
})
.run(function($templateRequest) {

    var urls = [
      'assets/angular-material-assets/img/icons/share-arrow.svg',
      'assets/angular-material-assets/img/icons/upload.svg',
      'assets/angular-material-assets/img/icons/copy.svg',
      'assets/angular-material-assets/img/icons/print.svg',
      'assets/angular-material-assets/img/icons/hangout.svg',
      'assets/angular-material-assets/img/icons/mail.svg',
      'assets/angular-material-assets/img/icons/message.svg',
      'assets/angular-material-assets/img/icons/copy2.svg',
      'assets/angular-material-assets/img/icons/facebook.svg',
      'assets/angular-material-assets/img/icons/twitter.svg'
    ];

    angular.forEach(urls, function(url) {
      $templateRequest(url);
    });

  });

(function () {
  'use strict';
  angular
      .module('autocompleteFloatingLabelDemo', ['ngMaterial', 'ngMessages'])
      .controller('DemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q) {
    var self = this;

    // list of `state` value/display objects
    self.states        = loadAll();
    self.selectedItem  = null;
    self.searchText    = null;
    self.querySearch   = querySearch;

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for states... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch (query) {
      var results = query ? self.states.filter( createFilterFor(query) ) : self.states;
      var deferred = $q.defer();
      $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
      return deferred.promise;
    }

    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {
      var allStates = 'Alabama, Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware,\
              Florida, Georgia, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana,\
              Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana,\
              Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, New York, North Carolina,\
              North Dakota, Ohio, Oklahoma, Oregon, Pennsylvania, Rhode Island, South Carolina,\
              South Dakota, Tennessee, Texas, Utah, Vermont, Virginia, Washington, West Virginia,\
              Wisconsin, Wyoming';

      return allStates.split(/, +/g).map( function (state) {
        return {
          value: state.toLowerCase(),
          display: state
        };
      });
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(state) {
        return (state.value.indexOf(lowercaseQuery) === 0);
      };

    }
  }
})();

(function () {
  'use strict';
  angular
      .module('autocompleteDemo', ['ngMaterial'])
      .controller('DemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q, $log) {
    var self = this;

    self.simulateQuery = false;
    self.isDisabled    = false;

    // list of `state` value/display objects
    self.states        = loadAll();
    self.querySearch   = querySearch;
    self.selectedItemChange = selectedItemChange;
    self.searchTextChange   = searchTextChange;

    self.newState = newState;

    function newState(state) {
      alert("Sorry! You'll need to create a Constituion for " + state + " first!");
    }

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for states... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch (query) {
      var results = query ? self.states.filter( createFilterFor(query) ) : self.states,
          deferred;
      if (self.simulateQuery) {
        deferred = $q.defer();
        $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
        return deferred.promise;
      } else {
        return results;
      }
    }

    function searchTextChange(text) {
      $log.info('Text changed to ' + text);
    }

    function selectedItemChange(item) {
      $log.info('Item changed to ' + JSON.stringify(item));
    }

    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {
      var allStates = 'Alabama, Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware,\
              Florida, Georgia, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana,\
              Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana,\
              Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, New York, North Carolina,\
              North Dakota, Ohio, Oklahoma, Oregon, Pennsylvania, Rhode Island, South Carolina,\
              South Dakota, Tennessee, Texas, Utah, Vermont, Virginia, Washington, West Virginia,\
              Wisconsin, Wyoming';

      return allStates.split(/, +/g).map( function (state) {
        return {
          value: state.toLowerCase(),
          display: state
        };
      });
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(state) {
        return (state.value.indexOf(lowercaseQuery) === 0);
      };

    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.ui.theme-colors', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_theme-colors', {
            url      : '/ui/theme-colors',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/theme-colors/theme-colors.html',
                    controller : 'ThemeColorsController as vm'
                }
            },
            bodyClass: 'theme-colors'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.theme-colors')
        .controller('CustomThemeDialogController', CustomThemeDialogController);

    /** @ngInject */
    function CustomThemeDialogController(fuseTheming, $mdDialog, fuseGenerator, $cookies, $window)
    {
        // Data
        var vm = this;
        vm.palettes = fuseTheming.getRegisteredPalettes();
        vm.themes = fuseTheming.getRegisteredThemes();

        // Delete Unnecessary hue value
        delete vm.palettes.grey['1000'];

        // Methods
        vm.rgba = fuseGenerator.rgba;
        vm.setTheme = setTheme;
        vm.closeDialog = closeDialog;

        //////////

        // If custom theme exist keep using it otherwise set default as a custom
        if ( !vm.themes.custom )
        {
            vm.theme = angular.copy(vm.themes['default'].colors);
        }
        else
        {
            vm.theme = vm.themes.custom.colors;
        }

        /**
         * Put custom theme into the cookies
         * and reload for generate styles
         */
        function setTheme()
        {
            $cookies.putObject('customTheme', vm.theme);
            $cookies.put('selectedTheme', 'custom');
            $window.location.reload();
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_right-sidenav', {
            url  : '/ui/page-layouts/carded/right-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/right-sidenav/right-sidenav.html',
                    controller : 'CardedRightSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav')
        .controller('CardedRightSidenavController', CardedRightSidenavController);

    /** @ngInject */
    function CardedRightSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_right-sidenav-ii', {
            url  : '/ui/page-layouts/carded/right-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/right-sidenav-ii/right-sidenav-ii.html',
                    controller : 'CardedRightSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav-ii')
        .controller('CardedRightSidenavIIController', CardedRightSidenavIIController);

    /** @ngInject */
    function CardedRightSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_left-sidenav', {
            url  : '/ui/page-layouts/carded/left-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/left-sidenav/left-sidenav.html',
                    controller : 'CardedLeftSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav')
        .controller('CardedLeftSidenavController', CardedLeftSidenavController);

    /** @ngInject */
    function CardedLeftSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_left-sidenav-ii', {
            url  : '/ui/page-layouts/carded/left-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/left-sidenav-ii/left-sidenav-ii.html',
                    controller : 'CardedLeftSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav-ii')
        .controller('CardedLeftSidenavIIController', CardedLeftSidenavIIController);

    /** @ngInject */
    function CardedLeftSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_fullwidth', {
            url  : '/ui/page-layouts/carded/fullwidth',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/fullwidth/fullwidth.html',
                    controller : 'CardedFullwidthController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth')
        .controller('CardedFullwidthController', CardedFullwidthController);

    /** @ngInject */
    function CardedFullwidthController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_fullwidth-ii', {
            url  : '/ui/page-layouts/carded/fullwidth-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/fullwidth-ii/fullwidth-ii.html',
                    controller : 'CardedFullwidthIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth-ii')
        .controller('CardedFullwidthIIController', CardedFullwidthIIController);

    /** @ngInject */
    function CardedFullwidthIIController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.tabbed', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_tabbed', {
            url  : '/ui/page-layouts/simple/tabbed',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/tabbed/tabbed.html',
                    controller : 'SimpleTabbedController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.tabbed')
        .controller('SimpleTabbedController', SimpleTabbedController);

    /** @ngInject */
    function SimpleTabbedController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_right-sidenav-ii', {
            url  : '/ui/page-layouts/simple/right-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/right-sidenav-ii/right-sidenav-ii.html',
                    controller : 'SimpleRightSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav-ii')
        .controller('SimpleRightSidenavIIController', SimpleRightSidenavIIController);

    /** @ngInject */
    function SimpleRightSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav-iii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_right-sidenav-iii', {
            url  : '/ui/page-layouts/simple/right-sidenav-iii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/right-sidenav-iii/right-sidenav-iii.html',
                    controller : 'SimpleRightSidenavIIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav-iii')
        .controller('SimpleRightSidenavIIIController', SimpleRightSidenavIIIController);

    /** @ngInject */
    function SimpleRightSidenavIIIController($mdSidenav)
    {

        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_right-sidenav', {
            url  : '/ui/page-layouts/simple/right-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/right-sidenav/right-sidenav.html',
                    controller : 'SimpleRightSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav')
        .controller('SimpleRightSidenavController', SimpleRightSidenavController);

    /** @ngInject */
    function SimpleRightSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_left-sidenav-ii', {
            url  : '/ui/page-layouts/simple/left-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/left-sidenav-ii/left-sidenav-ii.html',
                    controller : 'SimpleLeftSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav-ii')
        .controller('SimpleLeftSidenavIIController', SimpleLeftSidenavIIController);

    /** @ngInject */
    function SimpleLeftSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav-iii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_left-sidenav-iii', {
            url  : '/ui/page-layouts/simple/left-sidenav-iii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/left-sidenav-iii/left-sidenav-iii.html',
                    controller : 'SimpleLeftSidenavIIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav-iii')
        .controller('SimpleLeftSidenavIIIController', SimpleLeftSidenavIIIController);

    /** @ngInject */
    function SimpleLeftSidenavIIIController($mdSidenav)
    {

        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_left-sidenav', {
            url  : '/ui/page-layouts/simple/left-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/left-sidenav/left-sidenav.html',
                    controller : 'SimpleLeftSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav')
        .controller('SimpleLeftSidenavController', SimpleLeftSidenavController);

    /** @ngInject */
    function SimpleLeftSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.fullwidth', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_fullwidth', {
            url  : '/ui/page-layouts/simple/fullwidth',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/fullwidth/fullwidth.html',
                    controller : 'SimpleFullwidthController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.fullwidth')
        .controller('SimpleFullwidthController', SimpleFullwidthController);

    /** @ngInject */
    function SimpleFullwidthController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function () {
    'use strict';

    angular
        .module('app.clients', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider,
        msApiProvider, msNavigationServiceProvider, ivhTreeviewOptionsProvider) {


        ivhTreeviewOptionsProvider.set({
            defaultSelectedState: false,
            validate: true,
            expandToDepth: -1,
            twistieCollapsedTpl: '<md-icon md-font-icon="icon-chevron-right"></md-icon>',
            twistieExpandedTpl: '<md-icon md-font-icon="icon-chevron-left"></md-icon>',
            twistieLeafTpl: '<span style="cursor: default;">&#8192;&#8192;</span>'
        });





        // State


        $stateProvider.state('app.clients', {
            url: '/clients',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/clients/clients.html',
                    controller: 'ClientsController as vm'
                }
            },
            bodyClass: 'clients'
        });

        $stateProvider
            .state('app.site_overview.clients', {
                abstract: true,
                url: '/clients',
                onEnter: function ($stateParams) {


                },
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                    section: function ($stateParams) {
                        return $stateParams.owner
                    },
                    is_owner: function ($stateParams) {
                        return false
                    },
                },


            })
            .state('app.site_overview.clients.list', {
                url: '/list',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/clients/clients.html',
                        controller: 'ClientsController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.clients.complaints', {
                url: '/compliance',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/clients/clients.html',
                        controller: 'ClientsController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.clients.list.thread', {
                url: '/list/:id',
                bodyClass: 'clients'
            });
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/clients');


    }
})();


(function () {
    'use strict';

    angular
        .module('app.clients')
        .constant('_', window._)
        .controller('NewStakeDialogController', NewStakeDialogController);

    /** @ngInject */
    function NewStakeDialogController($scope, $mdDialog, sectors, regions, $stateParams, $document, documentsService, staffService,
        sessionService, clientsService, regionsLiterals, company, main_branch, $translate) {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.saveDialog = saveDialog;
        vm.getRegionLiteral = getRegionLiteral;
        vm.sectors = sectors;
        vm.regions = regions;
        vm.regionsLiterals = regionsLiterals;
        vm.mediaDialogSingle = mediaDialogSingle;
        vm.deleteLogotype = deleteLogotype;
        $scope.owner = $stateParams.owner;
        vm.company = company ? company : {};
/*
        vm.main_branch = main_branch ? main_branch : {}

        if (vm.company.id) {
            staffService.getMainBranch({ owner: $scope.owner, id_company: vm.company.id }).then(res => {
                vm.main_branch = res.data[0];
            })
        }
        if (vm.company.logo && vm.company.logo.length > 0) {
            var options = {
                owner: $scope.owner
            };
            clientsService.getStoragePrefix(options).then(function (res) {
                $scope.imageUrl = res.prefix + vm.company.logo[0].url;
                vm.logoIsLoaded = true;
            })
        }
        if (!vm.company.region_id) {
            vm.company.region_id = sessionService.user.region_id;
        }
        */
        function saveDialog() {
 //           if (!vm.main_branch.name) {
 //               vm.main_branch.name = vm.company.name;
 //           }
 //           $mdDialog.hide({ company: vm.company, branch: vm.main_branch, image: $scope.image, updateLogotype: vm.updateLogotype });
            $mdDialog.hide({ company: vm.company });
        }
        function mediaDialogSingle(ev, field) {
            $mdDialog.show({
                controller: 'MediaClientsController',
                controllerAs: 'vm',
                locals: {
                    owner: $scope.owner,
                    multipleSelection: true,
                    isTiny: false
                },
                templateUrl: 'app/main/apps/clients/dialogs/media/media-clients.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                multiple: true
            }).then(function (image) {
                if (image) {
                    vm.updateLogotype = true;
                    $scope.image = image;
                }
            });
        }
        function deleteLogotype() {
            if (vm.company.logo && vm.company.logo.length > 0) {
                for (var i = 0; i < vm.company.logo.length; i++) {
                    const itemLogo = vm.company.logo[i];
                    var options = {
                        owner: $scope.owner,
                        id: itemLogo.id
                    }
                    documentsService.deleteDocument(options).then(function () {
                        vm.company.logo = null;
                    })
                }
            }
            $scope.image = undefined;
            $scope.imageUrl = undefined;
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function getRegionLiteral(literalKey) {
            if (!angular.isUndefined(vm.company) && vm.company.region_id) {
                const literalsObject = vm.regionsLiterals.find(x => x.region_id === vm.company.region_id)
                return literalsObject.literals[literalKey];
            } else {
                return 'CIF/NIF';
            }
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('MediaClientsController', MediaClientsController);

    /** @ngInject */
    function MediaClientsController($mdDialog,$stateParams, $document, mediaService, owner, requestContext, $anchorScroll, $timeout, $scope, $sce, Upload, multipleSelection, msUtils, COMMON, isTiny, $log) {
        var vm = this;

        // Data
        vm.owner = owner;
        $scope.owner = $stateParams.owner;

        vm.defaultPage = 1;
        vm.defaultPerPage = 50;
        vm.PerPage = 50;
        vm.searchStringFilter = '';
        vm.searchQuery = '';
        vm.modelSearch = '';
        vm.pagination_search = pagination_search;

        vm.isTiny = isTiny;

        vm.views = {
            1: 'app/main/apps/clients/dialogs/media/views/photos-view.html',
            2: 'app/main/apps/clients/dialogs/media/views/videos-view.html',
            3: 'app/main/apps/clients/dialogs/media/views/files-view.html',
            4: 'app/main/apps/clients/dialogs/media/views/audios-view.html',
            upload: 'app/main/apps/clients/dialogs/media/views/upload-view.html',
            import: 'app/main/apps/clients/dialogs/media/views/import-view.html',
        };
        vm.defaultView = 'upload';
        vm.currentView = 'upload';

        vm.viewsTiny = {
            1: 'app/main/apps/clients/dialogs/media/views/tiny-attached.html',
            properties: 'app/main/apps/clients/dialogs/media/views/tiny-properties.html',
            upload: 'app/main/apps/clients/dialogs/media/views/upload-view.html',
        };
        vm.defaultViewTiny = '1';
        vm.currentViewTiny = '1';

        vm.firstLoad = true;
        vm.media_type = '1';
        vm.showSearchAndPaginator = true;
        vm.import_field = '';
        vm.import_disabled = '';
        vm.importedFiles = [];
        vm.importPreview = false;
        vm.imported = false;
        vm.importing = false;
        vm.selectedImages = [];
        vm.files = [];
        vm.tinyProperties = {
            mediaType: '',
            mediaSort: '',
            mediaData: {},
            align: '',
            size: ''
        };
        vm.tinyOptions = {
            size: [
                { value: 25, text: '25%' },
                { value: 50, text: '50%' },
                { value: 75, text: '75%' },
                { value: 100, text: '100%' }
            ],
            align: [
                { value: 'left', text: 'left' },
                { value: 'center', text: 'center' },
                { value: 'right', text: 'right' }
            ]
        }

        // If replying
        // if (angular.isDefined(selectedMail)) {
        // 	vm.form.to = selectedMail.from.email;
        // 	vm.form.subject = 'RE: ' + selectedMail.subject;
        // 	vm.form.message = '<blockquote>' + selectedMail.message + '</blockquote>';
        // }

        // Methods
        vm.closeDialog = closeDialog;
        vm.changeView = changeView;
        vm.changeViewTiny = changeViewTiny;

        vm.nextPage = nextPage;
        vm.prevPage = prevPage;
        vm.morePages = morePages;
        vm.firstPage = firstPage;
        vm.upload = upload;
        vm.attachMedia = attachMedia;
        vm.attachMediaTiny = attachMediaTiny;
        vm.selectMediaTiny = selectMediaTiny;
        vm.selectedMediaTiny = '';
        vm.search = search;

        vm.exists = msUtils.exists;
        vm.alreadySelectedbyZone = alreadySelectedbyZone;
        vm.existInArray = msUtils.existInArray;
        vm.toggleSelectedImages = toggleSelectedImages;


        //////////

        if (!isTiny) {
            init();
        } else {
            vm.section = section;
            initTiny();
        }
        /**
         * Initialize
         */
        function init() {

            vm.loading = true;
        }

        /**
         * Initialize Tinymce
         */
        function initTiny() {
            vm.currentViewTiny = vm.defaultViewTiny;
            vm.showSearchAndPaginator = false;
            vm.loading = true;
            for (var i = 0; i < vm.currentThread.length; i++) {
                if (vm.mediazone) {
                    if (vm.currentThread[i].id_zone == 1) {
                        vm.selectedImages.push(vm.currentThread[i]);
                    }
                } else {
                    vm.selectedImages.push(vm.currentThread[i]);
                }
            }
            if (vm.section.mediaSort) {
                var currentSort = 0;
                var currentItem = '';
                for (var i = 0; i < vm.currentThread.length; i++) {
                    if (vm.mediazone) {
                        if (vm.currentThread[i]['id_zone'] == 1 && (vm.currentThread[i]['media_type'] == vm.section.mediaType)) {
                            currentSort++;
                            if (currentSort = vm.section.mediaSort) {
                                currentItem = vm.currentThread[i];
                            }
                        }
                    } else {
                        if (vm.currentThread[i]['media_type'] == vm.section.mediaType) {
                            currentSort++;
                            if (currentSort = vm.section.mediaSort) {
                                currentItem = vm.currentThread[i];
                            }
                        }

                    }
                }

                vm.selectedMediaTiny = currentItem;
                vm.tinyProperties.mediaSort = vm.section.mediaSort;
                vm.tinyProperties.mediaType = currentItem.media_type;
                vm.tinyProperties.align = vm.section.mediaAlign;
                vm.tinyProperties.size = vm.section.mediaSize;
                vm.changeViewTiny('properties');


            }
            vm.loading = false;

        }

        function pagination_search(searchString) {
            var options = {
                section: section,
                media_type: vm.media_type,
                page: vm.defaultPage,
                perPage: vm.defaultPerPage,
                searchString: searchString
            };
        }


        function search(options) {
            // console.log(options, vm.searchStringFilter);
            /*

			vm.loading 		= true;
			vm.items		=[];
			// Scroll to the top Dialog
            scrollToTopOfDialog();

			mediaService.get({
				siteID: siteID,
				page: options.page,
				paginate: options.perPage,
				media_type: options.media_type,
                withCropStatus: true,
                sortField: 'date_uploaded',
                searchStringFilter: options.searchString,

			})
				.then(function (response) {
					vm.totalItems = response.total;
					vm.pagination_totalItems = response.total;
					vm.from = response.from;
					vm.pagination_from = response.from;
					vm.to = response.to;
					vm.pagination_to = response.to;
					vm.currentPage = response.current_page;
					vm.lastPage = response.last_page;
					vm.maxSize = 500;
					vm.bigTotalItems = 175;

					vm.loading = false;

                    vm.items = angular.copy(response.data);

                    $('.md-button')
                        .removeClass('active');
                    $('[type=' + options.media_type + ']')
						.addClass('active');

				});




			vm.firstLoad = false;
*/
        }

        function closeDialog() {
            $mdDialog.hide(vm.currentThread);
        }

        function changeView(view) {

            //console.log(view)
            if (vm.views[view]) {
                vm.items = [];
                vm.loadingView = true;
                vm.showSearchAndPaginator = false;
                vm.defaultView = view;
                vm.currentView = view;


                vm.media_type = view;

                var options = {
                    page: 1,
                    perPage: vm.PerPage,
                    media_type: view,

                };
                if (view == 1 || view == 2 || view == 3 || view == 4) {
                    vm.showSearchAndPaginator = true;
                }

            }

        }

        function changeViewTiny(view) {


            if (vm.viewsTiny[view]) {
                vm.items = [];
                vm.loadingView = true;
                vm.showSearchAndPaginator = false;
                vm.defaultViewTiny = view;
                vm.currentViewTiny = view;
            }

        }

        $scope.file_changed = function (element) {

            $scope.$apply(function (scope) {
                var photofile = element.files[0];
                console.log(photofile);
                $mdDialog.hide(photofile);
                //vm.upload(photofile);
                var reader = new FileReader();
                reader.onload = function (e) {
                    // handle onload
                };
                reader.readAsDataURL(photofile);
                $scope.image = photofile;
            });
        };

        $scope.$watch('vm.files', function () {
            console.debug("WATCH!!:::!:!:!:!: ")
            $scope.formUpload = false;
            if (vm.files != null) {
                // make files array for not multiple to be able to be used in ng-repeat in the ui
                if (!angular.isArray(vm.files)) {
                    $timeout(function () {
                        $scope.files = vm.files = [vm.files];
                    });
                    return;
                }
                for (var i = 0; i < vm.files.length; i++) {
                    $scope.errorMsg = null;
                    (function (f) {
                        //vm.upload(f, true);
                        $mdDialog.hide(f);
                    })(vm.files[i]);
                }
            }
        });

        $scope.$watch('vm.import_field', function () {
            vm.importConfirm(false);
        });


        $scope.log = '';

        function upload(file) {
            if (!file.$error) {
                var token = undefined;
                console.debug("UPLOAD______****", file)
                mediaService.getS3UploadPreSignedUrl({
                    owner: $scope.owner,
                    uploadKey: 'company_logo',
                    fileName: file.name,
                    rowId: 1
                })
                    .then(function (resp) {
                        token = resp.token;
                        file.id_media = resp.id_media;
                        file.upload = Upload.http({
                            url: resp.url,
                            skipAuthorization: true,
                            method: 'PUT',
                            headers: {
                                "Content-Type": file.type != '' ? file.type : 'application/octet-stream' 
                            },
                            data: file
                        });

                        file.upload.then(function (response) {
                            file.result = response.data;
                            $timeout(function () {
                                $scope.log = 'file: ' +
                                    file.name +
                                    ', Response: ' + JSON.stringify(response.data) +
                                    ', ID: ' + file.id_media +
                                    '\n' + $scope.log;
                            });
                            console.debug("SEND_TO_CROP______****", file)
                            mediaService.finishedUploadingFileToCdn({
                                owner: vm.owner,
                                idMedia: file.id_media,
                                token: token
                            })
                            $mdDialog.hide(vm.files[0]);


                        }, function (response) {
                            if (response.status > 0)
                                $scope.errorMsg = response.status + ': ' + response.data;
                        });

                        file.upload.progress(function (evt) {
                            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                        });

                    })
            }
        };

        vm.importConfirm = function (confirm) {
            vm.import_disabled = false;
            vm.imported = false;
            if (!confirm) {
                vm.importPreview = false;
            }
            if (vm.import_field.length > 10) {
                vm.importing = true;
                vm.import_disabled = true;

                $timeout(function () {
                    var pastedUrl = vm.import_field;
                    mediaService.importFromUrl({
                        siteID: siteID,
                        url: pastedUrl,
                        execute: confirm
                    })
                        .then(function (response) {
                            vm.importing = false;
                            response.embedCodeSafe = $sce.trustAsHtml(response.metadata.embedCode);
                            if (response.id_media) {
                                vm.imported = true;
                                vm.importPreview = false;
                                mediaService.get({
                                    siteID: siteID,
                                    withCropStatus: true,
                                    idMedia: response.id_media
                                })
                                    .then(function (response) {
                                        if (response.total == 1) {
                                            var photo = response.data[0];
                                            vm.importedFiles.push(photo);
                                            toggleSelectedImages(photo);
                                        }
                                    });

                            } else {
                                vm.importPreview = response;
                            }
                            vm.import_disabled = false;
                        });
                })
            }
        }

        function nextPage() {

            var options = {
                page: vm.currentPage + 1,
                perPage: vm.PerPage,
                media_type: vm.media_type
            };

        }

        function prevPage() {
            var options = {
                page: vm.currentPage - 1,
                perPage: vm.PerPage,
                media_type: vm.media_type,
                searchString: vm.modelSearch
            };
            
        }

        function morePages() {
            if (vm.currentPage <= vm.lastPage) return true;
            return false;
        }

        function firstPage() {
            if (vm.currentPage == 1) return true;
            return false;
        }

        function alreadySelectedbyZone(array, item) {
            var ret = false;
            for (var i = 0, len = array.length; i < len; i++) {
                if (vm.mediazone) {
                    if (array[i]['id_media'] === item.id_media && array[i]['id_zone'] === mediazone.id_zone) {
                        ret = true;
                    }
                } else {
                    if (array[i]['id_media'] === item.id_media) {
                        ret = true;
                    }

                }
            }

            return ret;
        }


        function toogleSelectedbyZone(item) {
            if (!multipleSelection) {
                vm.selectedImages = [];
            }
            for (var i = 0, len = vm.selectedImages.length; i < len; i++) {
                if (vm.selectedImages[i]['id_media'] === item.id_media && vm.selectedImages[i]['id_zone'] === mediazone.id_zone) {
                    vm.selectedImages.splice(i, 1);
                    return;
                }
            }

            vm.selectedImages.push(item);
            return;
        }

        function selectMediaTiny(item) {
            var currentSort = 0;
            var mediaSort = 0;
            for (var i = 0; i < vm.currentThread.length; i++) {
                if (vm.mediazone) {
                    //            		console.log(vm.currentThread[i]['id_zone']);
                    if (vm.currentThread[i]['id_zone'] == 1 && (vm.currentThread[i]['media_type'] == item.media_type)) {
                        currentSort++;
                        if (item.id_media == vm.currentThread[i]['id_media']) {
                            mediaSort = currentSort;
                        }
                    }
                } else {
                    currentSort++;
                    if (item.id_media == vm.currentThread[i]['id_media']) {
                        mediaSort = currentSort;
                    }
                }
            }
            vm.selectedMediaTiny = item;
            vm.tinyProperties.mediaSort = mediaSort;
            vm.tinyProperties.mediaType = item.media_type;
            vm.changeViewTiny('properties');

        }

        function attachMedia() {
            if ($scope.image) {
                $mdDialog.hide($scope.image);
            } else {
                $mdDialog.hide();
            }
        }

        function attachMediaTiny() {
            $mdDialog.hide(vm.tinyProperties);
        }

        /**
         * Toggle selected status of the contact
         *
         * @param contact
         * @param event
         */
        function toggleSelectedImages(photo, event) {
            if (event) {
                event.stopPropagation();
            }


            //         else{
            if (vm.mediazone) {
                photo.id_zone = vm.mediazone.id_zone;
                photo.zone_name = vm.mediazone.zone_name;
            } else {
                photo.id_zone = null;
                photo.zone_name = null;
            }

            toogleSelectedbyZone(photo);

        }

        /**
         * Scroll Media Dialog Content to the top
         * @param speed
         */
        function scrollToTopOfDialog() {     
            $timeout(function () {
                var dialogContent = $document.find('md-dialog-content').filter(function () {
                    return angular.element(this).hasClass('mediadialog-content');
                });
                if (!angular.isUndefined(dialogContent[0])) {
                    dialogContent.animate({
                        scrollTop: dialogContent[0].scrollHeight  
                    }, 1);
                }
            }, 1000);

        }
    }
})();
(function () {
	'use strict';

	angular
		.module('app.clients')
		.controller('ImageDialogClientsController', ImageDialogClientsController);

	/** @ngInject */
	function ImageDialogClientsController($mdDialog, sessionService, Images, ImageSelected, $document, cropFormats, MediaFull)
	{
		var vm = this;

		vm.views = {
			fotorama: 'app/main/apps/clients/dialogs/image/views/fotorama-view.html',
			editmedia: 'app/main/apps/clients/dialogs/image/views/edit-media-view.html',
		};
		vm.defaultView = 'fotorama';
		vm.currentView = 'fotorama';

		// Data
		vm.title = 'View Media';
		vm.images = [];
		vm.dataImages = [];

		// Methods
		vm.closeDialog = closeDialog;
		vm.changeView = changeView;
		vm.edit = edit;

		// //////////

		/**
		 * Close dialog
		 */
		function closeDialog()
		{
			/*var $fotoramaDiv = $('#fotorama').fotorama();
			var fotorama = $fotoramaDiv.data('fotorama');
			fotorama.destroy();*/
			$mdDialog.hide();
		}

		init();

		function init()
		{

			vm.dataFotorama = [];
			var fotoramaDiv = angular.element(".testingelement");

			var fit = (cropFormats) ? 'scaledown' : 'contain';
			vm.fotoramaoptions = {
				width: '100%',
				height: '80%',
				captions: true,
				loop: true,
				keyboard: true,
				allowfullscreen: true,
				nav: 'thumbs',
				ratio: 16 / 9,
				fit: fit,
			};

			if (!cropFormats) {
				if (!_.isArray(Images)) {
					var ImagesArray = [];
					ImagesArray.push(Images);
					Images = ImagesArray;
				}


				for (var i = 0; i < Images.length; i++) {

					var attachment = Images[i];
					var imagesCrops = [];

					for (var iCrop = 0; iCrop < Images[i].cropstatus.length; iCrop++) {
						var imageCrop = Images[i].cropstatus[iCrop];
						imagesCrops.push(Images[i].cropstatus[iCrop]);
					}

					if (ImageSelected) {
						var selected = (Images[i].id_media === ImageSelected.id_media) ? true : false;
					} else {
						var selected = false;
					}

					if (Images[i].media_type !== 1) {
						// continue;
					}

					// .container.view_url}}{{image.cropstatus[0].fileName

					if (attachment.media_type == 1) {

						if (MediaFull) {
							var cropstatus = _.find(Images[i].cropstatus, {
								'id_cropformats': sessionService.getMediaThumbnailCropformatId()
							});

							var cropstatus = _.find(Images[i].cropstatus, {
								'id_cropformats': sessionService.getMediaFullCropformatId()
							});
							var urlImage = cropstatus.container.view_url + cropstatus.fileName;
							vm.dataFotorama.push({
								imageUrl: urlImage,
								thumb: urlImage,
								dataCaption: '#' + attachment.id_media + ' | ' + urlImage,
								html: '<div>123</div>',
								selected: selected
							})
						} else {
							var cropstatus = _.find(attachment.cropstatus, {
								'id_cropformats': sessionService.getMediaFullCropformatId()
							});

							if(!cropstatus){
								var urlImage = attachment.container.view_url + 'original/m' + attachment.id_media + '_' + attachment.filename;
							}else{
								var urlImage = cropstatus.container.view_url + cropstatus.fileName;
							}
								vm.dataFotorama.push({
									imageUrl: urlImage,
									thumb: urlImage,
									dataCaption: '#' + attachment.id_media + ' | ' + urlImage,
									html: '<div>123</div>',
									selected: selected
								})
						}
					}

					if (attachment.media_type == 2) {
						var videoUrl = '';
						if (!attachment.embed) {
							videoUrl = attachment.container.view_url + 'videos/m' + attachment.id_media + '_' + attachment.filename;
						} else {
							if (attachment.embed.indexOf('yt|') !== -1) {
								var YT_VideoSource = attachment.embed.split('yt|')[1];
								videoUrl = 'http://youtube.com/' + YT_VideoSource;
							} else if (attachment.embed.indexOf('fb|') !== -1) {
								var embed_url = angular.element(attachment.embed_url);
								videoUrl = embed_url.attr('src');
							}
						}

						vm.dataFotorama.push({
							imageUrl: attachment.embed_thumb,
							thumb: attachment.embed_thumb,
							full: attachment.embed_thumb, // Separate image for the fullscreen mode.
							video: videoUrl, // Youtube, Vimeo or custom iframe URL
							id: 'one', // Custom anchor is used with the hash:true option.
							caption: 'The first caption',
							html: '<div>123</div>',
							// html: $('selector'), // ...or '<div>123</div>'. Custom HTML inside the frame.
							fit: 'cover', // Override the global fit option.
							any: 'Any data relative to the frame you want to store',
							selected: selected
						})
					}
				}
				// }else{
				// 	var cropstatus = _.find( Images.cropstatus, {'id_cropformats': sessionService.getMediaThumbnailCropformatId()});
				// 	if(MediaFull){
				// 		var cropstatus = _.find( Images.cropstatus, {'id_cropformats': sessionService.getMediaFullCropformatId()});
				// 		var urlImage = cropstatus.container.view_url + cropstatus.fileName;
				// 	}else{
				//       				var urlImage = cropstatus.container.view_url + 'original/m' + Images.id_media + '_' + Images.filename;
				//       			}
				// 	vm.dataFotorama.push({
				// 					 imageUrl: urlImage,
				// 					 thumb: urlImage,
				// 					 dataCaption: '#' + Images.id_media + ' | ' + Images.filename,
				// 					 html: '<div>123</div>',
				// 					 selected: selected
				// 				 })
				// }
			} else {

				for (var i = 0; i < Images.length; i++) {
					
					var selected = (Images[i].id_cropformats === ImageSelected.id_cropformats && Images[i].container.id_container === ImageSelected.container.id_container) ? true : false;


					if (Images[i].container.use_grid === 1) {
						var urlImage = Images[i].container.view_url + Images[i].grid + '/' + Images[i].fileName;
					} else {
						var urlImage = Images[i].container.view_url + Images[i].fileName;
					}
					vm.dataFotorama.push({
						imageUrl: urlImage,
						thumb: urlImage,
						dataCaption: 'aa#' + Images[i].id_cropformats + ' | ' + urlImage,
						html: '<div>123</div>',
						selected: selected
					})
				}
			}

			// $fotoramaDiv.data({
			// 	data: vm.dataFotorama
			// });

		}

		function changeView(view) {
			if (vm.views[view]) {
				vm.loadingView = true;
				vm.showSearchAndPaginator = false;
				vm.defaultView = view;
				vm.currentView = view;
			}
		}


		function edit() {
			var $fotoramaDiv = angular.element("#fotorama1");
		}

	}
})();

(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('DialogFormController', DialogFormController);

    /** @ngInject */
    function DialogFormController($mdDialog, $document, usersService, clientsService, sessionService, owner, type, documentsService, positionsIds, idCompany, $filter, $mdMenu, requestContext, Upload, user_type, title, fields, users, $translate, alreadySelected, branchId, storagePrefix, $anchorScroll, $timeout, $scope, $sce, msUtils, COMMON, isTiny, $log, defaultDivision, defaultJob) {

        var vm = this;
        var originatorEv;
        vm.owner = owner;
        vm.type = type;
        sessionService.getQuota().then(function (quota) {
            vm.quota = quota;
        });

        vm.userLogued = sessionService.getUser();
        vm.fields = fields;
        var foundFiles = _.find(vm.fields, function (field) {
            return field.field == 'files';
        });
        vm.files = (foundFiles && foundFiles.value) ? (Array.isArray(foundFiles.value) ? foundFiles.value : [foundFiles.value]) : [];
        vm.emailOriginal = _.find(vm.fields, function (field) {
            if (field.field == 'email') {
                return true
            }
        }).value;
        vm.openMenu = openMenu;
        vm.user_type = user_type;
        vm.positionsIds = positionsIds;

        vm.alreadySelected = [];
        vm.branchId = branchId;
        vm.storagePrefix = storagePrefix;
        vm.deleteAvatar = deleteAvatar;
        vm.noDivisionJobSelected = true;
        vm.jobPositionId = '';
        vm.divisionId = '';
        vm.alreadySelected = alreadySelected;
        vm.indexDivision = null;
        vm.indexPosition = null;
        vm.translate = function (text) {
            return $translate.instant(text);
        }

        for (var i = 0; i < vm.fields.length; i++) {
            if (vm.fields[i].field == 'division') {
                vm.indexDivision = i;
                break;
            }
        }
        for (var i = 0; i < vm.fields.length; i++) {
            if (vm.fields[i].field == 'position') {
                vm.indexPosition = i;
                break;
            }
        }



        var originatorEv;

        function openMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        }

        function deleteAvatar(file) {
            var options = {
                owner: vm.owner,
                id: file.id
            }
            documentsService.deleteDocument(options).then(function () {
                vm.files = [];
            })
        }

        if (defaultDivision) {
            vm.divisionId = defaultDivision;
        }
        if (defaultJob) {
            vm.jobPositionId = defaultJob;
        }



        // Methods
        vm.closeDialog = closeDialog;
        vm.sendForm = sendForm;
        vm.disabledPosition = disabledPosition;
        vm.showSector = showSector;
        vm.selectUser = selectUser;
        vm.showUserImage = showUserImage;
        vm.showSelectPosition = showSelectPosition;
        vm.selectJobDivision = selectJobDivision;
        vm.unSelectJobDivision = unSelectJobDivision;
        vm.divisionJobSelected = divisionJobSelected;
        vm.showJobDivision = showJobDivision;
        vm.isSendDisabled = isSendDisabled;

        init();

        function init() {
            vm.loading = true;
            if (title === 'branch') {
                vm.title = 'GLOBAL.NEW_BRANCH';
            } else if (title === 'administrator') {
                vm.title = 'GLOBAL.ADMINISTRATOR';
            } else if (title === 'managerLegal') {
                vm.title = 'GLOBAL.LEGAL_MANAGER';
            } else if (title === 'personnel' && defaultJob == "") {
                vm.title = 'GLOBAL.BRANCH_PERSONNEL';
            } else if (title === 'personnel' && defaultJob == 3) {
                vm.title = 'GLOBAL.COMPLIANCE_OFFICER';
            } else if (title === 'personnel' && defaultJob == 4) {
                vm.title = 'GLOBAL.REPORT_COMMITTEE';
            } else if (title === 'personnel' && defaultJob == 5) {
                vm.title = 'GLOBAL.DELEGATE_DATA_PROTECCTION';
            } else if (title === 'personnel' && defaultJob == 2) {
                vm.title = 'GLOBAL.ADMINISTRATOR';
            } else if (title === 'personnel' && defaultJob == 1) {
                vm.title = 'GLOBAL.LEGAL_MANAGER';
            }
            getUsersByCompany(idCompany)
            getUsersAdministrators()
        }


        function getUsersByCompany(idCompany) {
            var options = {
                owner: vm.owner,
                inCompany: idCompany,
                resultsPerPage: 500
            };
            clientsService.getUsers(options).then(function (response) {
                vm.users = response.data;
            })
        }
        function getUsersAdministrators() {
            var options = {
                owner: vm.owner,
                resultsPerPage: 100
            };
            usersService.getUsers(options).then(function (response) {
                vm.usersAll = response.data;
            })
        }


        function closeDialog() {
            $mdDialog.hide();
        }
        function isSendDisabled() {
            for (var i = 0; i < vm.fields.length; i++) {
                const element = vm.fields[i];
                if (element.required && !element.value) {
                    return true;
                }
            }
            return false;
        }

        function checkUploadsAndUpdateUser() {
            var noUpdate = false;
            if (vm.files) {
                angular.forEach(vm.files, function (file) {
                    if (angular.isUndefined(file.progress) || file.progress < 100) {
                        noUpdate = true;
                    }
                })
                if (!noUpdate && !$scope.uploadingFile) {
                    initState()
                    vm.loadingReadPane = false;
                    $rootScope.pagination_resetquery();
                } else {
                    $timeout(function () {
                        vm.checkUploadsAndUpdateUser();
                    }, 1000)
                }
            } else {
                initState()
                vm.loadingReadPane = false;
                $rootScope.pagination_resetquery();

            }
        }

        function sendForm(ev) {
            for (var i = 0; i < vm.fields.length; i++) {
                if (vm.fields[i].field === 'position' && !vm.fields[i].value) {
                    vm.fields[i].value = vm.jobPositionId;
                }
                else if (vm.fields[i].field === 'division' && !vm.fields[i].value) {
                    vm.fields[i].value = vm.divisionId;
                } else if (vm.fields[i].field === 'email' && vm.fields[i].value == '') {
                    delete vm.fields[i].value;
                }
            }
            if (((vm.positionsIds.compliance_officer == vm.jobPositionId
                || vm.positionsIds.compliance_comite == vm.jobPositionId
                || vm.positionsIds.data_protection == vm.jobPositionId)
                && vm.quota.users_registered >= vm.quota.max_allowed_users)
            ) {
                $mdDialog.show({
                    controller: 'UserQuotaDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/dialogs/userQuotaDialog/userQuotaDialog.html',
                    preserveScope: true,
                    autoWrap: true,
                    quota: null,
                    multiple: true,
                    locals: {
                        user: vm.userLogued,
                        quota: vm.quota,
                        quotaComplaint: null
                    }
                }).then(function (res) {
                    if (res && res.type) {
                        if (res.type == 'upgrade') {
                            console.log("go upgrade screen");
                        } else {
                            createUser(true);
                        }
                    }
                });
            } else {
                createUser();
            }



        }

        function createUser(quotaexceded) {


            var email = _.find(vm.fields, function (field) {
                if (field.field == 'email') {
                    return true
                }
            }).value;

            if (vm.emailOriginal === email) {
                vm.fields.files = vm.files;
                $mdDialog.hide({ fields: vm.fields, quotaexceded: quotaexceded });
                return
            }
            var options = {
                owner: vm.owner,
                searchStringFilter: email
            };
            usersService.getUsersWithTrashed(options).then(function (response) {

                var existedUser = _.find(response.data, function (user) {
                    if (user.email == email && (!vm.userSelected || user.id !== vm.userSelected.id)) {
                        return true;
                    }
                });

                if (!existedUser) {
                    vm.fields.files = vm.files;
                    $mdDialog.hide({ fields: vm.fields, quotaexceded: quotaexceded });
                } else {
                    alert = $mdDialog.alert({
                        title: vm.translate('GLOBAL.ATTENTION'),
                        textContent: vm.translate('GLOBAL.USER_ALREADY_EXISTS'),
                        ok: vm.translate('GLOBAL.CLOSE'),
                    }).multiple(true);

                    $mdDialog
                        .show(alert)
                        .finally(function () {
                            alert = undefined;
                        });
                }
            })





        }

        function disabledPosition(field) {
            var idAdmin;
            var idManagerLegal;
            var idComplaints;
            var idReport;
            for (var i = 0; i < field.options.length; i++) {
                if (field.options[i].field === 'ADMINISTRADOR') {
                    idAdmin = field.options[i].id;
                } else if (field.options[i].field === 'REPRESENTANTE LEGAL') {
                    idManagerLegal = field.options[i].id
                } else if (field.options[i].field === 'Complaints committee') {
                    idComplaints = field.options[i].id
                } else if (field.options[i].field === 'Reports committee') {
                    idReport = field.options[i].id
                }
            }

            if (vm.title === 'managerLegal') {
                field.value = idManagerLegal;
                return true;
            } else if (vm.title === 'administrator') {
                field.value = idAdmin;
                return true;
            } else if (vm.title === 'compliance') {
                field.value = idComplaints;
                return true;
            } else if (vm.title === 'report') {
                field.value = idReport;
                return true;
            }
        }

        function showSector() {
            if (title === 'personnel') {
                return true;
            }
        }

        function selectUser(user) {
            for (var i = 0; i < vm.fields.length; i++) {
                if (vm.fields[i].field === 'first_name') {
                    vm.fields[i].value = user.first_name
                } else if (vm.fields[i].field === 'last_name') {
                    vm.fields[i].value = user.last_name;
                } else if (vm.fields[i].field === 'email') {
                    vm.fields[i].value = user.email;
                } else if (vm.fields[i].field === 'nif') {
                    vm.fields[i].value = user.id_number;
                } else if (vm.fields[i].field === 'position') {
                    vm.fields[i].value = vm.jobPositionId;
                } else if (vm.fields[i].field === 'division') {
                    vm.fields[i].value = vm.divisionId;
                } else if (vm.fields[i].field === 'profile_color') {
                    vm.fields[i].value = user.profile_color;
                } else if (vm.fields[i].field === 'user_type') {
                    vm.fields[i].value = user.user_type;
                }
            }

            vm.fields.push({ field: 'id', value: user.id });
            vm.fields.push({ field: 'files', value: user.files });
            if (vm.quota.users_registered >= vm.quota.max_allowed_users && (user.user_type > 3)) {
                $mdDialog.show({
                    controller: 'UserQuotaDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/dialogs/userQuotaDialog/userQuotaDialog.html',
                    preserveScope: true,
                    autoWrap: true,
                    multiple: true,
                    locals: {
                        user: vm.userLogued,
                        quota: vm.quota,
                        quotaComplaint: null
                    }
                }).then(function (res) {
                    if (res && res.type) {
                        if (res.type == 'upgrade') {
                            console.log("go upgrade screen");
                        } else {
                            $mdDialog.hide({ fields: vm.fields, existUser: true, quotaexceded: vm.quota.users_registered >= vm.quota.max_allowed_users });
                        }
                    }
                });
            } else {
                $mdDialog.hide({ fields: vm.fields, existUser: true, quotaexceded: vm.quota.users_registered >= vm.quota.max_allowed_users });
            }

        }

        $scope.filterAlreadyAdded = function (item) {
            if (vm.fields[vm.indexDivision].value && vm.fields[vm.indexPosition].value) {
                var found = $filter('filter')(vm.alreadySelected, { id: item.id, position: vm.fields[vm.indexPosition].value, division: vm.fields[vm.indexDivision].value });
                return found.length == 0;;
            } else {
                var found = _.find(vm.alreadySelected, function (_item) { return _item.id == item.id });
                return !found;
            }
        };

        function showUserImage(user) {
            return vm.storagePrefix + user.files.url
        }

        function showSelectPosition() {
            if (vm.branchId && vm.noDivisionJobSelected) {
                return true;
            }
            return false;
        }

        function selectJobDivision() {
            vm.noDivisionJobSelected = false;
        }

        function divisionJobSelected() {
            var ret1 = false;
            var ret2 = false;
            for (var i = 0; i < vm.fields.length; i++) {
                if (vm.fields[i].field === 'position' && vm.fields[i].value) {
                    vm.jobPositionId = vm.fields[i].value;
                    ret1 = true;
                }
                if (vm.fields[i].field === 'division' && vm.fields[i].value) {
                    vm.divisionId = vm.fields[i].value;
                    ret2 = true;
                }
            }

            return (!ret1 || !ret2);
        }

        function unSelectJobDivision() {
            vm.noDivisionJobSelected = true;
        }

        function showJobDivision() {
            if (vm.branchId) {
                return true;
            }
            return false;
        }

    }
})();


(function () {
    'use strict';

    angular
        .module('app.clients')
        .constant('_', window._)
        .controller('EditBranchDialog', EditBranchDialog);

    /** @ngInject */
    function EditBranchDialog($scope, $mdDialog, $translate, region_id, clientsService, tinyMceService, branch, $mdToast) {
        var vm = this;
        vm.region_id = region_id;
        vm.branch = angular.copy(branch);
        vm.tinymceOptions = tinyMceService.getOptions($scope);
        vm.tinymceOptions.height = 100;
        vm.saveDialog = saveDialog;
        vm.closeDialog = closeDialog;
        vm.getRegionLiteral = getRegionLiteral;
        clientsService.getFileRegions().then(function (res) {
            vm.regionsLiterals = res;
        })
        function saveDialog() {

            $mdDialog.hide(vm.branch);

        }
        function getRegionLiteral(literalKey) {
            if (vm.region_id && vm.regionsLiterals) {
                const literalsObject = vm.regionsLiterals.find(x => x.region_id === vm.region_id)
                return literalsObject.literals[literalKey];
            } else {
                return '';
            }
        }



        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.todo', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, msUtilProvider) {
        // State
        $stateProvider.state('app.to-do', {
            url: '/to-do',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/todo/todo.html',
                    controller: 'TodoController as vm'
                }
            },
            resolve: {
                Tasks: function (msApi) {
                    return msApi.resolve('todo.tasks@get');
                },
                Tags: function (msApi) {
                    return msApi.resolve('todo.tags@get');
                }
            },
            bodyClass: 'todo'
        });

        // Translation
        var base = 'app/main/apps/todo';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }
        // Api
        msApiProvider.register('todo.tasks', ['app/data/todo/tasks.json']);
        msApiProvider.register('todo.tags', ['app/data/todo/tags.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('apps.to-do', {
            title: 'To-Do',
            icon: 'icon-checkbox-marked',
            state: 'app.to-do',
            badge: {
                content: 3,
                color: '#FF6F00'
            },
            weight: 9
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.todo')
        .controller('TaskDialogController', TaskDialogController);

    /** @ngInject */
    function TaskDialogController($mdDialog, Task, Tasks, event)
    {
        var vm = this;

        // Data
        vm.title = 'Edit Task';
        vm.task = angular.copy(Task);
        vm.tasks = Tasks;
        vm.newTask = false;

        if ( !vm.task )
        {
            vm.task = {
                'id'                : '',
                'title'             : '',
                'notes'             : '',
                'startDate'         : new Date(),
                'startDateTimeStamp': new Date().getTime(),
                'dueDate'           : '',
                'dueDateTimeStamp'  : '',
                'completed'         : false,
                'starred'           : false,
                'important'         : false,
                'deleted'           : false,
                'tags'              : []
            };
            vm.title = 'New Task';
            vm.newTask = true;
            vm.task.tags = [];
        }

        // Methods
        vm.addNewTask = addNewTask;
        vm.saveTask = saveTask;
        vm.deleteTask = deleteTask;
        vm.newTag = newTag;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Add new task
         */
        function addNewTask()
        {
            vm.tasks.unshift(vm.task);

            closeDialog();
        }

        /**
         * Save task
         */
        function saveTask()
        {
            // Dummy save action
            for ( var i = 0; i < vm.tasks.length; i++ )
            {
                if ( vm.tasks[i].id === vm.task.id )
                {
                    vm.tasks[i] = angular.copy(vm.task);
                    break;
                }
            }

            closeDialog();
        }

        /**
         * Delete task
         */
        function deleteTask()
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure?')
                .content('The Task will be deleted.')
                .ariaLabel('Delete Task')
                .ok('Delete')
                .cancel('Cancel')
                .targetEvent(event);

            $mdDialog.show(confirm).then(function ()
            {
                // Dummy delete action
                for ( var i = 0; i < vm.tasks.length; i++ )
                {
                    if ( vm.tasks[i].id === vm.task.id )
                    {
                        vm.tasks[i].deleted = true;
                        break;
                    }
                }
            }, function ()
            {
                // Cancel Action
            });
        }


        /**
         * New tag
         *
         * @param chip
         * @returns {{label: *, color: string}}
         */
        function newTag(chip)
        {
            var tagColors = ['#388E3C', '#F44336', '#FF9800', '#0091EA', '#9C27B0'];

            return {
                name : chip,
                label: chip,
                color: tagColors[Math.floor(Math.random() * (tagColors.length))]
            };
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.tasks', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider,msUtilProvider) {


        // State

        $stateProvider.state('app.tasks', {
            url: '/tasks',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/tasks/tasks.html',
                    controller: 'TasksController as vm'
                }
            },
            bodyClass: 'tasks'
        });

        $stateProvider
            .state('app.site_overview.tasks', {
                abstract: true,
                url: '/tasks',
                onEnter: function ($stateParams) {
                },
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                    section: function ($stateParams) {
                        return $stateParams.owner
                    },
                },


            })
            .state('app.site_overview.tasks.list', {
                url: '',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/tasks/tasks.html',
                        controller: 'TasksController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.tasks.list.active_task', {
                url: '/view/:id',
                onEnter: function () {

                }
            })
        // Translation

        var base = 'app/main/apps/tasks';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.tasks')
        .constant('_', window._)
        .controller('TaskEditStatusController', TaskEditStatusController);

    /** @ngInject */
    function TaskEditStatusController($mdDialog, task) {
        var vm = this;
        vm.task = task;

        vm.closeDialog = closeDialog;
        vm.saveDialog = saveDialog;
        vm.dateExpired = dateExpired;
        function saveDialog() {
            $mdDialog.hide(vm.task);
        }


        function dateExpired(stringDate) {
            return moment.utc(stringDate) < moment.utc();
        }

        function closeDialog() {
            $mdDialog.hide(false);
        }

    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('CalendarViewController', CalendarViewController);

    /** @ngInject */
    function CalendarViewController($scope, $document, $mdDialog, $mdSidenav, BoardService, DialogService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.eventSources = [];

        vm.calendarUiConfig = {
            calendar: {
                editable                 : true,
                eventLimit               : true,
                header                   : '',
                handleWindowResize       : false,
                aspectRatio              : 1,
                dayNames                 : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                dayNamesShort            : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                timezone                 : 'local',
                eventDurationEditable    : false,
                defaultTimedEventDuration: '01:00:00',
                viewRender               : function (view)
                {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                    vm.currentMonthShort = vm.calendar.getDate().format('MMM');
                },
                columnFormat             : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd D'
                },
                eventClick               : function eventDetail(calendarEvent, ev)
                {
                    vm.openCardDialog(ev, calendarEvent.idCard);
                },
                eventDrop                : function (event)
                {
                    vm.board.cards.getById(event.idCard).due = moment.utc(event.start).format('x');
                },
                selectable               : true,
                selectHelper             : true,
                dayClick                 : function (date, ev)
                {
                    var offset = moment().utcOffset();
                    var corrDate = '';

                    if ( offset < 0 )
                    {
                        corrDate = moment.utc(date).subtract(offset, 'm').format('x');
                    }
                    else
                    {
                        corrDate = moment.utc(date).add(offset, 'm').format('x');
                    }

                    eventDialog(corrDate, ev);
                }
            }
        };

        // Methods
        vm.next = next;
        vm.prev = prev;
        vm.goToDate = goToDate;
        vm.openCardDialog = DialogService.openCardDialog;
        vm.toggleSidenav = toggleSidenav;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            vm.cards = getScheduledCards();
            vm.eventSources[0] = vm.cards;
        }

        /**
         * Get scheduled cards and prepare
         * them to show on the calendar
         *
         * @returns {Array}
         */
        function getScheduledCards()
        {
            var cards = [];

            angular.forEach(vm.board.cards, function (card)
            {
                if ( card.due )
                {
                    cards.push({
                        idCard         : card.id,
                        title          : card.name,
                        start          : moment.utc(card.due, 'x'),
                        due            : card.due,
                        backgroundColor: getEventBgColor(card.due)
                    });
                }
            });

            return cards;
        }

        /**
         * Get background color
         *
         * @param cardDue
         * @returns {*}
         */
        function getEventBgColor(cardDue)
        {
            if ( moment() > moment(cardDue, 'x') )
            {
                return '#F44336';
            }

            return '#4CAF50';
        }

        /**
         * Watch board changes
         */
        $scope.$watch('vm.board', function (current, old)
        {
            if ( angular.equals(current, old) )
            {
                return;
            }

            init();

        }, true);

        /**
         * Go to Date
         *
         * @param date
         */
        function goToDate(date)
        {
            vm.calendarView.calendar.gotoDate(date);
            $mdSidenav('scheduled-tasks-sidenav').close();
        }

        /**
         * Go to next on current view (week, month etc.)
         */
        function next()
        {
            vm.calendarView.calendar.next();
        }

        /**
         * Go to previous on current view (week, month etc.)
         */
        function prev()
        {
            vm.calendarView.calendar.prev();
        }

        /**
         * Event Dialog
         */
        function eventDialog(date, ev)
        {
            $mdDialog.show({
                templateUrl        : 'app/main/apps/scrumboard/views/calendar/dialogs/event/event-dialog.html',
                controller         : 'ScrumboardCalendarEventDialogController',
                controllerAs       : 'vm',
                parent             : $document.find('#scrumboard'),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    dueDate: date
                }
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('BoardViewController', BoardViewController);

    /** @ngInject */
    function BoardViewController($document, $window, $timeout, $mdDialog, msUtils, BoardList, BoardService, CardFilters, DialogService)
    {
        var vm = this;

        // Data
        vm.currentView = 'board';
        vm.board = BoardService.data;
        vm.boardList = BoardList.data;
        vm.cardFilters = CardFilters;
        vm.card = {};
        vm.cardOptions = {};
        vm.newListName = '';
        vm.sortableListOptions = {
            axis       : 'x',
            delay      : 75,
            distance   : 7,
            items      : '> .list-wrapper',
            handle     : '.list-header',
            placeholder: 'list-wrapper list-sortable-placeholder',
            tolerance  : 'pointer',
            start      : function (event, ui)
            {
                var width = ui.item[0].children[0].clientWidth;
                var height = ui.item[0].children[0].clientHeight;
                ui.placeholder.css({
                    'min-width': width + 'px',
                    'width'    : width + 'px',
                    'height'   : height + 'px'
                });
            }
        };
        vm.sortableCardOptions = {
            appendTo            : 'body',
            connectWith         : '.list-cards',
            delay               : 75,
            distance            : 7,
            forceHelperSize     : true,
            forcePlaceholderSize: true,
            handle              : msUtils.isMobile() ? '.list-card-sort-handle' : false,
            helper              : function (event, el)
            {
                return el.clone().addClass('list-card-sort-helper');
            },
            placeholder         : 'list-card card-sortable-placeholder',
            tolerance           : 'pointer',
            scroll              : true,
            sort                : function (event, ui)
            {
                var listContentEl = ui.placeholder.closest('.list-content');
                var boardContentEl = ui.placeholder.closest('#board');

                if ( listContentEl )
                {
                    var listContentElHeight = listContentEl[0].clientHeight,
                        listContentElScrollHeight = listContentEl[0].scrollHeight;

                    if ( listContentElHeight !== listContentElScrollHeight )
                    {
                        var itemTop = ui.position.top,
                            itemBottom = itemTop + ui.item.height(),
                            listTop = listContentEl.offset().top,
                            listBottom = listTop + listContentElHeight;

                        if ( itemTop < listTop + 25 )
                        {
                            listContentEl.scrollTop(listContentEl.scrollTop() - 25);
                        }

                        if ( itemBottom > listBottom - 25 )
                        {
                            listContentEl.scrollTop(listContentEl.scrollTop() + 25);
                        }
                    }
                }

                if ( boardContentEl )
                {
                    var boardContentElWidth = boardContentEl[0].clientWidth;
                    var boardContentElScrollWidth = boardContentEl[0].scrollWidth;

                    if ( boardContentElWidth !== boardContentElScrollWidth )
                    {
                        var itemLeft = ui.position.left,
                            itemRight = itemLeft + ui.item.width(),
                            boardLeft = boardContentEl.offset().left,
                            boardRight = boardLeft + boardContentElWidth;

                        if ( itemLeft < boardLeft + 25 )
                        {
                            boardContentEl.scrollLeft(boardContentEl.scrollLeft() - 25);
                        }

                        if ( itemRight > boardRight )
                        {
                            boardContentEl.scrollLeft(boardContentEl.scrollLeft() + 25);
                        }
                    }
                }
            }
        };

        // Methods
        vm.openCardDialog = DialogService.openCardDialog;
        vm.addNewList = addNewList;
        vm.removeList = removeList;
        vm.cardFilter = cardFilter;
        vm.isOverdue = isOverdue;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {

            $timeout(function ()
            {
                // IE list-content max-height hack
                if ( angular.element('html').hasClass('explorer') )
                {
                    // Calculate the height for the first time
                    calculateListContentHeight();

                    // Attach calculateListContentHeight function to window resize
                    $window.onresize = function ()
                    {
                        calculateListContentHeight();
                    };
                }
            }, 0);

        }

        /**
         * IE ONLY
         * Calculate the list-content height
         * IE ONLY
         */
        function calculateListContentHeight()
        {
            var boardEl = angular.element('#board');
            var boardElHeight = boardEl.height();

            boardEl.find('.list-wrapper').each(function (index, el)
            {
                // Get the required heights for calculations
                var listWrapperEl = angular.element(el),
                    listHeaderElHeight = listWrapperEl.find('.list-header').height(),
                    listFooterElHeight = listWrapperEl.find('.list-footer').height();

                // Calculate the max height
                var maxHeight = boardElHeight - listHeaderElHeight - listFooterElHeight;

                // Add the max height
                listWrapperEl.find('.list-content').css({'max-height': maxHeight});
            });
        }

        /**
         * Add new list
         */
        function addNewList()
        {
            if ( vm.newListName === '' )
            {
                return;
            }

            vm.board.lists.push({
                id     : msUtils.guidGenerator(),
                name   : vm.newListName,
                idCards: []
            });

            vm.newListName = '';
        }

        /**
         * Remove list
         *
         * @param ev
         * @param list
         */
        function removeList(ev, list)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove List',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove list?',
                ariaLabel          : 'remove list',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });
            $mdDialog.show(confirm).then(function ()
            {
                vm.board.lists.splice(vm.board.lists.indexOf(list), 1);
            }, function ()
            {
                // Canceled
            });

        }

        /**
         * Card filter
         *
         * @param cardId
         * @returns {*}
         */
        function cardFilter(cardId)
        {
            var card = vm.board.cards.getById(cardId);

            try
            {
                if ( angular.lowercase(card.name).indexOf(angular.lowercase(vm.cardFilters.name)) < 0 )
                {
                    throw false;
                }

                angular.forEach(vm.cardFilters.labels, function (label)
                {
                    if ( !msUtils.exists(label, card.idLabels) )
                    {
                        throw false;
                    }
                });

                angular.forEach(vm.cardFilters.members, function (member)
                {
                    if ( !msUtils.exists(member, card.idMembers) )
                    {
                        throw false;
                    }
                });


            } catch ( err )
            {
                return err;
            }

            return true;
        }

        /**
         * Is the card overdue?
         *
         * @param cardDate
         * @returns {boolean}
         */
        function isOverdue(cardDate)
        {
            return moment() > moment(cardDate, 'x');
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('BoardsViewController', BoardsViewController);

    /** @ngInject */
    function BoardsViewController(BoardList)
    {
        var vm = this;

        // Data
        vm.boardList = BoardList.data;

        // Methods

        //////////
    }
})();
(function() {
    'use strict';

    angular
        .module('app.clients')
        .controller('DialogFormController', DialogFormController);

    /** @ngInject */
    function DialogFormController($mdDialog, $document, requestContext,title, fields, users, $anchorScroll, $timeout, $scope, $sce, msUtils, COMMON, isTiny, $log) {

        var vm = this;
        var originatorEv;

        // Data
        vm.title = title;
        vm.fields = fields;
        vm.translate = undefined;
        vm.users = users;


        // Methods
        vm.closeDialog = closeDialog;
        vm.sendForm = sendForm;
        vm.disabledPosition = disabledPosition;
        vm.selectUser = selectUser;

        init();

        function init() {
            vm.loading = true;
            if(vm.title === 'branch') {
                vm.translate = 'GLOBAL.BRANCH';
            } else if(vm.title === 'administrator') {
                vm.translate = 'GLOBAL.ADMINISTRATOR';
            } else if(vm.title === 'managerLegal') {
                vm.translate = 'GLOBAL.LEGAL_MANAGER';
            } else if (vm.title === 'branch') {
                vm.translate = 'GLOBAL.BRANCH';
            } else if(vm.title === 'compliance') {
                vm.translate = 'GLOBAL.COMPLIANCE_COMMITTEE';
            } else if(vm.title === 'report') {
                vm.translate = 'GLOBAL.REPORT_COMMITTEE';
            }
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function sendForm() {
            $mdDialog.hide(vm.fields);
        }

        function disabledPosition(field) {
            var idAdmin;
            var idManagerLegal;
            for (var i = 0; i < field.options.length; i++) {
                if(field.options[i].field === 'Administrator') {
                    idAdmin = field.options[i].id;
                } else {
                    idManagerLegal = field.options[i].id
                }
            }
            
            if(vm.title === 'managerLegal') {
                field.value = idManagerLegal;
                return true;
            } else if (vm.title === 'administrator') {
                field.value = idAdmin;
                return true;
            }
        }

        function selectUser(user) {
            for (var i = 0; i < vm.fields.length; i++) {
                if(vm.fields[i].field === 'name') {
                    vm.fields[i].value = user.first_name
                } else if(vm.fields[i].field === 'surnames') {
                    vm.fields[i].value = user.last_name;
                } else if(vm.fields[i].field === 'email') {
                    vm.fields[i].value = user.email;
                } else if(vm.fields[i].field === 'nif') {
                    vm.fields[i].value = user.id_number;
                } else if(vm.fields[i].field === 'position') {
                    vm.fields[i].value = user.job_position_id;
                }
            }
            vm.fields.push({field: 'id', value: user.id});
            $mdDialog.hide({fields: vm.fields, existUser: true});
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('MediaClientsController', MediaClientsController);

    /** @ngInject */
    function MediaClientsController($mdDialog,$stateParams, $document, mediaService, owner, requestContext, $anchorScroll, $timeout, $scope, $sce, Upload, multipleSelection, msUtils, COMMON, isTiny, $log) {
        var vm = this;

        // Data
        vm.owner = owner;
        $scope.owner = $stateParams.owner;

        vm.defaultPage = 1;
        vm.defaultPerPage = 50;
        vm.PerPage = 50;
        vm.searchStringFilter = '';
        vm.searchQuery = '';
        vm.modelSearch = '';
        vm.pagination_search = pagination_search;

        vm.isTiny = isTiny;

        vm.views = {
            1: 'app/main/apps/clients/dialogs/media/views/photos-view.html',
            2: 'app/main/apps/clients/dialogs/media/views/videos-view.html',
            3: 'app/main/apps/clients/dialogs/media/views/files-view.html',
            4: 'app/main/apps/clients/dialogs/media/views/audios-view.html',
            upload: 'app/main/apps/clients/dialogs/media/views/upload-view.html',
            import: 'app/main/apps/clients/dialogs/media/views/import-view.html',
        };
        vm.defaultView = 'upload';
        vm.currentView = 'upload';

        vm.viewsTiny = {
            1: 'app/main/apps/clients/dialogs/media/views/tiny-attached.html',
            properties: 'app/main/apps/clients/dialogs/media/views/tiny-properties.html',
            upload: 'app/main/apps/clients/dialogs/media/views/upload-view.html',
        };
        vm.defaultViewTiny = '1';
        vm.currentViewTiny = '1';

        vm.firstLoad = true;
        vm.media_type = '1';
        vm.showSearchAndPaginator = true;
        vm.import_field = '';
        vm.import_disabled = '';
        vm.importedFiles = [];
        vm.importPreview = false;
        vm.imported = false;
        vm.importing = false;
        vm.selectedImages = [];
        vm.files = [];
        vm.tinyProperties = {
            mediaType: '',
            mediaSort: '',
            mediaData: {},
            align: '',
            size: ''
        };
        vm.tinyOptions = {
            size: [
                { value: 25, text: '25%' },
                { value: 50, text: '50%' },
                { value: 75, text: '75%' },
                { value: 100, text: '100%' }
            ],
            align: [
                { value: 'left', text: 'left' },
                { value: 'center', text: 'center' },
                { value: 'right', text: 'right' }
            ]
        }

        // If replying
        // if (angular.isDefined(selectedMail)) {
        // 	vm.form.to = selectedMail.from.email;
        // 	vm.form.subject = 'RE: ' + selectedMail.subject;
        // 	vm.form.message = '<blockquote>' + selectedMail.message + '</blockquote>';
        // }

        // Methods
        vm.closeDialog = closeDialog;
        vm.changeView = changeView;
        vm.changeViewTiny = changeViewTiny;

        vm.nextPage = nextPage;
        vm.prevPage = prevPage;
        vm.morePages = morePages;
        vm.firstPage = firstPage;
        vm.upload = upload;
        vm.attachMedia = attachMedia;
        vm.attachMediaTiny = attachMediaTiny;
        vm.selectMediaTiny = selectMediaTiny;
        vm.selectedMediaTiny = '';
        vm.search = search;

        vm.exists = msUtils.exists;
        vm.alreadySelectedbyZone = alreadySelectedbyZone;
        vm.existInArray = msUtils.existInArray;
        vm.toggleSelectedImages = toggleSelectedImages;


        //////////

        if (!isTiny) {
            init();
        } else {
            vm.section = section;
            initTiny();
        }
        /**
         * Initialize
         */
        function init() {

            vm.loading = true;
        }

        /**
         * Initialize Tinymce
         */
        function initTiny() {
            vm.currentViewTiny = vm.defaultViewTiny;
            vm.showSearchAndPaginator = false;
            vm.loading = true;
            for (var i = 0; i < vm.currentThread.length; i++) {
                if (vm.mediazone) {
                    if (vm.currentThread[i].id_zone == 1) {
                        vm.selectedImages.push(vm.currentThread[i]);
                    }
                } else {
                    vm.selectedImages.push(vm.currentThread[i]);
                }
            }
            if (vm.section.mediaSort) {
                var currentSort = 0;
                var currentItem = '';
                for (var i = 0; i < vm.currentThread.length; i++) {
                    if (vm.mediazone) {
                        if (vm.currentThread[i]['id_zone'] == 1 && (vm.currentThread[i]['media_type'] == vm.section.mediaType)) {
                            currentSort++;
                            if (currentSort = vm.section.mediaSort) {
                                currentItem = vm.currentThread[i];
                            }
                        }
                    } else {
                        if (vm.currentThread[i]['media_type'] == vm.section.mediaType) {
                            currentSort++;
                            if (currentSort = vm.section.mediaSort) {
                                currentItem = vm.currentThread[i];
                            }
                        }

                    }
                }

                vm.selectedMediaTiny = currentItem;
                vm.tinyProperties.mediaSort = vm.section.mediaSort;
                vm.tinyProperties.mediaType = currentItem.media_type;
                vm.tinyProperties.align = vm.section.mediaAlign;
                vm.tinyProperties.size = vm.section.mediaSize;
                vm.changeViewTiny('properties');


            }
            vm.loading = false;

        }

        function pagination_search(searchString) {
            var options = {
                section: section,
                media_type: vm.media_type,
                page: vm.defaultPage,
                perPage: vm.defaultPerPage,
                searchString: searchString
            };
        }


        function search(options) {
            // console.log(options, vm.searchStringFilter);
            /*

			vm.loading 		= true;
			vm.items		=[];
			// Scroll to the top Dialog
            scrollToTopOfDialog();

			mediaService.get({
				siteID: siteID,
				page: options.page,
				paginate: options.perPage,
				media_type: options.media_type,
                withCropStatus: true,
                sortField: 'date_uploaded',
                searchStringFilter: options.searchString,

			})
				.then(function (response) {
					vm.totalItems = response.total;
					vm.pagination_totalItems = response.total;
					vm.from = response.from;
					vm.pagination_from = response.from;
					vm.to = response.to;
					vm.pagination_to = response.to;
					vm.currentPage = response.current_page;
					vm.lastPage = response.last_page;
					vm.maxSize = 500;
					vm.bigTotalItems = 175;

					vm.loading = false;

                    vm.items = angular.copy(response.data);

                    $('.md-button')
                        .removeClass('active');
                    $('[type=' + options.media_type + ']')
						.addClass('active');

				});




			vm.firstLoad = false;
*/
        }

        function closeDialog() {
            $mdDialog.hide(vm.currentThread);
        }

        function changeView(view) {

            //console.log(view)
            if (vm.views[view]) {
                vm.items = [];
                vm.loadingView = true;
                vm.showSearchAndPaginator = false;
                vm.defaultView = view;
                vm.currentView = view;


                vm.media_type = view;

                var options = {
                    page: 1,
                    perPage: vm.PerPage,
                    media_type: view,

                };
                if (view == 1 || view == 2 || view == 3 || view == 4) {
                    vm.showSearchAndPaginator = true;
                }

            }

        }

        function changeViewTiny(view) {


            if (vm.viewsTiny[view]) {
                vm.items = [];
                vm.loadingView = true;
                vm.showSearchAndPaginator = false;
                vm.defaultViewTiny = view;
                vm.currentViewTiny = view;
            }

        }

        $scope.file_changed = function (element) {

            $scope.$apply(function (scope) {
                var photofile = element.files[0];
                console.log(photofile);
                $mdDialog.hide(photofile);
                //vm.upload(photofile);
                var reader = new FileReader();
                reader.onload = function (e) {
                    // handle onload
                };
                reader.readAsDataURL(photofile);
                $scope.image = photofile;
            });
        };

        $scope.$watch('vm.files', function () {
            console.debug("WATCH!!:::!:!:!:!: ")
            $scope.formUpload = false;
            if (vm.files != null) {
                // make files array for not multiple to be able to be used in ng-repeat in the ui
                if (!angular.isArray(vm.files)) {
                    $timeout(function () {
                        $scope.files = vm.files = [vm.files];
                    });
                    return;
                }
                for (var i = 0; i < vm.files.length; i++) {
                    $scope.errorMsg = null;
                    (function (f) {
                        //vm.upload(f, true);
                        $mdDialog.hide(f);
                    })(vm.files[i]);
                }
            }
        });

        $scope.$watch('vm.import_field', function () {
            vm.importConfirm(false);
        });


        $scope.log = '';

        function upload(file) {
            if (!file.$error) {
                var token = undefined;
                console.debug("UPLOAD______****", file)
                mediaService.getS3UploadPreSignedUrl({
                    owner: $scope.owner,
                    uploadKey: 'company_logo',
                    fileName: file.name,
                    rowId: 1
                })
                    .then(function (resp) {
                        token = resp.token;
                        file.id_media = resp.id_media;
                        file.upload = Upload.http({
                            url: resp.url,
                            skipAuthorization: true,
                            method: 'PUT',
                            headers: {
                                "Content-Type": file.type != '' ? file.type : 'application/octet-stream' 
                            },
                            data: file
                        });

                        file.upload.then(function (response) {
                            file.result = response.data;
                            $timeout(function () {
                                $scope.log = 'file: ' +
                                    file.name +
                                    ', Response: ' + JSON.stringify(response.data) +
                                    ', ID: ' + file.id_media +
                                    '\n' + $scope.log;
                            });
                            console.debug("SEND_TO_CROP______****", file)
                            mediaService.finishedUploadingFileToCdn({
                                owner: vm.owner,
                                idMedia: file.id_media,
                                token: token
                            })
                            $mdDialog.hide(vm.files[0]);


                        }, function (response) {
                            if (response.status > 0)
                                $scope.errorMsg = response.status + ': ' + response.data;
                        });

                        file.upload.progress(function (evt) {
                            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                        });

                    })
            }
        };

        vm.importConfirm = function (confirm) {
            vm.import_disabled = false;
            vm.imported = false;
            if (!confirm) {
                vm.importPreview = false;
            }
            if (vm.import_field.length > 10) {
                vm.importing = true;
                vm.import_disabled = true;

                $timeout(function () {
                    var pastedUrl = vm.import_field;
                    mediaService.importFromUrl({
                        siteID: siteID,
                        url: pastedUrl,
                        execute: confirm
                    })
                        .then(function (response) {
                            vm.importing = false;
                            response.embedCodeSafe = $sce.trustAsHtml(response.metadata.embedCode);
                            if (response.id_media) {
                                vm.imported = true;
                                vm.importPreview = false;
                                mediaService.get({
                                    siteID: siteID,
                                    withCropStatus: true,
                                    idMedia: response.id_media
                                })
                                    .then(function (response) {
                                        if (response.total == 1) {
                                            var photo = response.data[0];
                                            vm.importedFiles.push(photo);
                                            toggleSelectedImages(photo);
                                        }
                                    });

                            } else {
                                vm.importPreview = response;
                            }
                            vm.import_disabled = false;
                        });
                })
            }
        }

        function nextPage() {

            var options = {
                page: vm.currentPage + 1,
                perPage: vm.PerPage,
                media_type: vm.media_type
            };

        }

        function prevPage() {
            var options = {
                page: vm.currentPage - 1,
                perPage: vm.PerPage,
                media_type: vm.media_type,
                searchString: vm.modelSearch
            };
            
        }

        function morePages() {
            if (vm.currentPage <= vm.lastPage) return true;
            return false;
        }

        function firstPage() {
            if (vm.currentPage == 1) return true;
            return false;
        }

        function alreadySelectedbyZone(array, item) {
            var ret = false;
            for (var i = 0, len = array.length; i < len; i++) {
                if (vm.mediazone) {
                    if (array[i]['id_media'] === item.id_media && array[i]['id_zone'] === mediazone.id_zone) {
                        ret = true;
                    }
                } else {
                    if (array[i]['id_media'] === item.id_media) {
                        ret = true;
                    }

                }
            }

            return ret;
        }


        function toogleSelectedbyZone(item) {
            if (!multipleSelection) {
                vm.selectedImages = [];
            }
            for (var i = 0, len = vm.selectedImages.length; i < len; i++) {
                if (vm.selectedImages[i]['id_media'] === item.id_media && vm.selectedImages[i]['id_zone'] === mediazone.id_zone) {
                    vm.selectedImages.splice(i, 1);
                    return;
                }
            }

            vm.selectedImages.push(item);
            return;
        }

        function selectMediaTiny(item) {
            var currentSort = 0;
            var mediaSort = 0;
            for (var i = 0; i < vm.currentThread.length; i++) {
                if (vm.mediazone) {
                    //            		console.log(vm.currentThread[i]['id_zone']);
                    if (vm.currentThread[i]['id_zone'] == 1 && (vm.currentThread[i]['media_type'] == item.media_type)) {
                        currentSort++;
                        if (item.id_media == vm.currentThread[i]['id_media']) {
                            mediaSort = currentSort;
                        }
                    }
                } else {
                    currentSort++;
                    if (item.id_media == vm.currentThread[i]['id_media']) {
                        mediaSort = currentSort;
                    }
                }
            }
            vm.selectedMediaTiny = item;
            vm.tinyProperties.mediaSort = mediaSort;
            vm.tinyProperties.mediaType = item.media_type;
            vm.changeViewTiny('properties');

        }

        function attachMedia() {
            if ($scope.image) {
                $mdDialog.hide($scope.image);
            } else {
                $mdDialog.hide();
            }
        }

        function attachMediaTiny() {
            $mdDialog.hide(vm.tinyProperties);
        }

        /**
         * Toggle selected status of the contact
         *
         * @param contact
         * @param event
         */
        function toggleSelectedImages(photo, event) {
            if (event) {
                event.stopPropagation();
            }


            //         else{
            if (vm.mediazone) {
                photo.id_zone = vm.mediazone.id_zone;
                photo.zone_name = vm.mediazone.zone_name;
            } else {
                photo.id_zone = null;
                photo.zone_name = null;
            }

            toogleSelectedbyZone(photo);

        }

        /**
         * Scroll Media Dialog Content to the top
         * @param speed
         */
        function scrollToTopOfDialog() {     
            $timeout(function () {
                var dialogContent = $document.find('md-dialog-content').filter(function () {
                    return angular.element(this).hasClass('mediadialog-content');
                });
                if (!angular.isUndefined(dialogContent[0])) {
                    dialogContent.animate({
                        scrollTop: dialogContent[0].scrollHeight  
                    }, 1);
                }
            }, 1000);

        }
    }
})();
(function () {
	'use strict';

	angular
		.module('app.clients')
		.controller('ImageDialogClientsController', ImageDialogClientsController);

	/** @ngInject */
	function ImageDialogClientsController($mdDialog, sessionService, Images, ImageSelected, $document, cropFormats, MediaFull)
	{
		var vm = this;

		vm.views = {
			fotorama: 'app/main/apps/clients/dialogs/image/views/fotorama-view.html',
			editmedia: 'app/main/apps/clients/dialogs/image/views/edit-media-view.html',
		};
		vm.defaultView = 'fotorama';
		vm.currentView = 'fotorama';

		// Data
		vm.title = 'View Media';
		vm.images = [];
		vm.dataImages = [];

		// Methods
		vm.closeDialog = closeDialog;
		vm.changeView = changeView;
		vm.edit = edit;

		// //////////

		/**
		 * Close dialog
		 */
		function closeDialog()
		{
			/*var $fotoramaDiv = $('#fotorama').fotorama();
			var fotorama = $fotoramaDiv.data('fotorama');
			fotorama.destroy();*/
			$mdDialog.hide();
		}

		init();

		function init()
		{

			vm.dataFotorama = [];
			var fotoramaDiv = angular.element(".testingelement");

			var fit = (cropFormats) ? 'scaledown' : 'contain';
			vm.fotoramaoptions = {
				width: '100%',
				height: '80%',
				captions: true,
				loop: true,
				keyboard: true,
				allowfullscreen: true,
				nav: 'thumbs',
				ratio: 16 / 9,
				fit: fit,
			};

			if (!cropFormats) {
				if (!_.isArray(Images)) {
					var ImagesArray = [];
					ImagesArray.push(Images);
					Images = ImagesArray;
				}


				for (var i = 0; i < Images.length; i++) {

					var attachment = Images[i];
					var imagesCrops = [];

					for (var iCrop = 0; iCrop < Images[i].cropstatus.length; iCrop++) {
						var imageCrop = Images[i].cropstatus[iCrop];
						imagesCrops.push(Images[i].cropstatus[iCrop]);
					}

					if (ImageSelected) {
						var selected = (Images[i].id_media === ImageSelected.id_media) ? true : false;
					} else {
						var selected = false;
					}

					if (Images[i].media_type !== 1) {
						// continue;
					}

					// .container.view_url}}{{image.cropstatus[0].fileName

					if (attachment.media_type == 1) {

						if (MediaFull) {
							var cropstatus = _.find(Images[i].cropstatus, {
								'id_cropformats': sessionService.getMediaThumbnailCropformatId()
							});

							var cropstatus = _.find(Images[i].cropstatus, {
								'id_cropformats': sessionService.getMediaFullCropformatId()
							});
							var urlImage = cropstatus.container.view_url + cropstatus.fileName;
							vm.dataFotorama.push({
								imageUrl: urlImage,
								thumb: urlImage,
								dataCaption: '#' + attachment.id_media + ' | ' + urlImage,
								html: '<div>123</div>',
								selected: selected
							})
						} else {
							var cropstatus = _.find(attachment.cropstatus, {
								'id_cropformats': sessionService.getMediaFullCropformatId()
							});

							if(!cropstatus){
								var urlImage = attachment.container.view_url + 'original/m' + attachment.id_media + '_' + attachment.filename;
							}else{
								var urlImage = cropstatus.container.view_url + cropstatus.fileName;
							}
								vm.dataFotorama.push({
									imageUrl: urlImage,
									thumb: urlImage,
									dataCaption: '#' + attachment.id_media + ' | ' + urlImage,
									html: '<div>123</div>',
									selected: selected
								})
						}
					}

					if (attachment.media_type == 2) {
						var videoUrl = '';
						if (!attachment.embed) {
							videoUrl = attachment.container.view_url + 'videos/m' + attachment.id_media + '_' + attachment.filename;
						} else {
							if (attachment.embed.indexOf('yt|') !== -1) {
								var YT_VideoSource = attachment.embed.split('yt|')[1];
								videoUrl = 'http://youtube.com/' + YT_VideoSource;
							} else if (attachment.embed.indexOf('fb|') !== -1) {
								var embed_url = angular.element(attachment.embed_url);
								videoUrl = embed_url.attr('src');
							}
						}

						vm.dataFotorama.push({
							imageUrl: attachment.embed_thumb,
							thumb: attachment.embed_thumb,
							full: attachment.embed_thumb, // Separate image for the fullscreen mode.
							video: videoUrl, // Youtube, Vimeo or custom iframe URL
							id: 'one', // Custom anchor is used with the hash:true option.
							caption: 'The first caption',
							html: '<div>123</div>',
							// html: $('selector'), // ...or '<div>123</div>'. Custom HTML inside the frame.
							fit: 'cover', // Override the global fit option.
							any: 'Any data relative to the frame you want to store',
							selected: selected
						})
					}
				}
				// }else{
				// 	var cropstatus = _.find( Images.cropstatus, {'id_cropformats': sessionService.getMediaThumbnailCropformatId()});
				// 	if(MediaFull){
				// 		var cropstatus = _.find( Images.cropstatus, {'id_cropformats': sessionService.getMediaFullCropformatId()});
				// 		var urlImage = cropstatus.container.view_url + cropstatus.fileName;
				// 	}else{
				//       				var urlImage = cropstatus.container.view_url + 'original/m' + Images.id_media + '_' + Images.filename;
				//       			}
				// 	vm.dataFotorama.push({
				// 					 imageUrl: urlImage,
				// 					 thumb: urlImage,
				// 					 dataCaption: '#' + Images.id_media + ' | ' + Images.filename,
				// 					 html: '<div>123</div>',
				// 					 selected: selected
				// 				 })
				// }
			} else {

				for (var i = 0; i < Images.length; i++) {
					
					var selected = (Images[i].id_cropformats === ImageSelected.id_cropformats && Images[i].container.id_container === ImageSelected.container.id_container) ? true : false;


					if (Images[i].container.use_grid === 1) {
						var urlImage = Images[i].container.view_url + Images[i].grid + '/' + Images[i].fileName;
					} else {
						var urlImage = Images[i].container.view_url + Images[i].fileName;
					}
					vm.dataFotorama.push({
						imageUrl: urlImage,
						thumb: urlImage,
						dataCaption: 'aa#' + Images[i].id_cropformats + ' | ' + urlImage,
						html: '<div>123</div>',
						selected: selected
					})
				}
			}

			// $fotoramaDiv.data({
			// 	data: vm.dataFotorama
			// });

		}

		function changeView(view) {
			if (vm.views[view]) {
				vm.loadingView = true;
				vm.showSearchAndPaginator = false;
				vm.defaultView = view;
				vm.currentView = view;
			}
		}


		function edit() {
			var $fotoramaDiv = angular.element("#fotorama1");
		}

	}
})();

(function () {
    'use strict';

    angular
        .module('app.riskconfig', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, 
        msUtilProvider, msNavigationServiceProvider, ivhTreeviewOptionsProvider) {


        ivhTreeviewOptionsProvider.set({
            defaultSelectedState: false,
            validate: true,
            expandToDepth: -1,
            twistieCollapsedTpl: '',
            twistieExpandedTpl: '<md-icon md-svg-icon="assets/angular-material-assets/img/icons/ic_expand_more_black_24px.svg"></md-icon>',
            twistieLeafTpl: '<span style="cursor: default;">&#8192;&#8192;</span>'
        });





        // State


        $stateProvider.state('app.riskconfig', {
            url: '/riskconfig',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/riskconfig/riskconfig.html',
                    controller: 'RiskConfigController as vm'
                }
            },
            bodyClass: 'riskconfig'
        });

        $stateProvider
            .state('app.site_overview.riskconfig', {
                abstract: true,
                url: '/riskconfig',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/riskconfig/riskconfig.html',
                        controller: 'RiskConfigController as vm'
                    }
                },
                onEnter: function ($stateParams) {
                },
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                },
            })
            .state('app.site_overview.riskconfig.list', {
                url: '/:domain',
                onEnter: function () {
                },
                data: {
                },
                resolve: {
                },
            })
            .state('app.site_overview.riskconfig.new_risk', {
                url: '/:domain',
                onEnter: function () {
                },
                data: {
                },
                resolve: {
                },
            })
            .state('app.site_overview.riskconfig.active_risk', {
                url: ':domain/view/:id',
                onEnter: function () {

                }
            })
        // Translation
        var base = 'app/main/apps/riskconfig';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('app.riskconfig')
        .constant('_', window._)
        .controller('EditRiskDialogController', EditRiskDialogController);

    /** @ngInject */
    function EditRiskDialogController($scope, $mdDialog, msUtils, tinyMceService, risk, regionSelected, $mdToast) {
        var vm = this;
        vm.branding = msUtils.getBranding();
        vm.risk = angular.copy(risk);
        vm.regionSelected = regionSelected;
        vm.tinymceOptions = tinyMceService.getOptions($scope);
        vm.tinymceOptions.height = 100;
        vm.saveDialog = saveDialog;
        vm.closeDialog = closeDialog;

        function saveDialog() {
            //console.log("Before assigning region_id:", vm.regionSelected);

    
            vm.risk.region_id = vm.regionSelected.id;
            //console.log("After assigning region_id:", vm.risk.region_id);
            //console.log("Saving risk:", vm.risk); // Agrega este log
            $mdDialog.hide(vm.risk);

        }




        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();


(function () {
    'use strict';

    angular
        .module('app.riskconfig')
        .constant('_', window._)
        .controller('CreateProcessDialog', CreateProcessDialog);

    /** @ngInject */
    function CreateProcessDialog($mdDialog, $translate, Owner, risk, regionSelected, $mdToast, riskConfigService) {
        var vm = this;
        vm.owner = Owner;
        vm.risk = risk;
        vm.regionSelected = regionSelected;
        vm.closeDialog = closeDialog;
        vm.saveDialog = saveDialog;

        function saveDialog() {
            var options = {
                owner: vm.owner,
                name: vm.name,
                region_id: vm.regionSelected.id
            }
            riskConfigService.createProcess(options).then(function (response) {
                var options2 = {
                    owner: vm.owner,
                    risk_id: vm.risk.id,
                    process_id: response.result.id
                }
                riskConfigService.createProcessInRisk(options2).then(function () {
                    $mdDialog.hide({ completed: true });
                }).catch(function (err) {
                    var message = $translate.instant('GLOBAL.ERROR') + '<br>' + err.data.detail;

                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                        hideDelay: 5000,
                        position: 'top',
                        parent: '#content-container'
                    });
                })
            }).catch(function (err) {
                var message = $translate.instant('GLOBAL.ERROR') + '<br>' + err.data.detail;

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
            })

        }

        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();


(function () {
    'use strict';

    angular
        .module('app.riskconfig')
        .constant('_', window._)
        .controller('DelegationsDialogController', DelegationsDialogController);

    /** @ngInject */
    function DelegationsDialogController($mdDialog, $translate, selectedRisks, Owner, sessionService, clientsService, riskConfigService, $mdToast) {
        var vm = this;
        vm.owner = Owner;
        vm.selectedRisks = selectedRisks;
        vm.saveDialog = saveDialog;
        vm.closeDialog = closeDialog;
        vm.loadCompany = loadCompany;
        vm.user = sessionService.getUser();
        vm.loading = false;
        vm.toggleSelectThread = toggleSelectThread;
        vm.toggleSelectThreads = toggleSelectThreads;
        vm.deselectThreads = deselectThreads;
        vm.selectThreads = selectThreads;
        vm.isSelected = isSelected;
        vm.selectedBranchs = [];
        /**
          * Select threads. If key/value pair given,
          * threads will be tested against them.
          *
          * @param [key]
          * @param [value]
          */
        function selectThreads(key, value) {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedBranchs = [];

            for (var i = 0; i < vm.branches.length; i++) {
                if (angular.isUndefined(key) && angular.isUndefined(value)) {
                    vm.selectedBranchs.push(vm.branches[i]);
                    continue;
                }

                if (angular.isDefined(key) && angular.isDefined(value) && vm.branches[i][key] === value) {
                    vm.selectedBranchs.push(vm.branches[i]);
                }
            }
        }


        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        function isSelected(thread) {
            return vm.selectedBranchs.indexOf(thread) > -1;
        }
        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        function toggleSelectThread(thread, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedBranchs.indexOf(thread) > -1) {
                vm.selectedBranchs.splice(vm.selectedBranchs.indexOf(thread), 1);
            } else {
                vm.selectedBranchs.push(thread);
            }
        }

        /**
         * Deselect threads
         */
        function deselectThreads() {
            vm.selectedBranchs = [];
        }

        /**
         * Toggle select threads
         */
        function toggleSelectThreads() {
            if (vm.selectedBranchs.length > 0) {
                vm.deselectThreads();
            } else {
                vm.selectThreads();
            }
        }




        function saveDialog() {

            vm.loading = true;
            var count = 0;
            for (var j = 0; j < vm.selectedRisks.length; j++) {
                for (var i = 0; i < vm.selectedBranchs.length; i++) {
                    var options = {
                        owner: vm.owner,
                        risk_id: vm.selectedRisks[j].id,
                        company_id: vm.companySelected,
                        branch_id: vm.selectedBranchs[i].id
                    };
                    riskConfigService.activateRisk(options).then(function (response) {
                        count++;
                        if (count == (vm.selectedBranchs.length * vm.selectedRisks.length)) {
                            var message = $translate.instant('RISKCONFIG.RISK_ADDED_SUCCESSFULLY');
                            $mdToast.show({
                                template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content bg-green">' + message + '</div></md-toast>',
                                hideDelay: 7000,
                                position: 'top right',
                                parent: '#content'
                            });
                            $mdDialog.hide({ completed: true });
                        }
                    }, function (error) {
                        count++;
                        if (count == (vm.selectedBranchs.length * vm.selectedRisks.length)) {
                            vm.loading = false;
                        }
                    });
                }
            }

        }


        function loadCompany() {
            var options = {
                owner: vm.owner,
                id: vm.companySelected
            };
            clientsService.getCompany(options).then(function (response) {
                vm.branches = response.branches;
            });
        }

        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();


(function () {
    'use strict';

    angular
        .module('app.riskconfig')
        .constant('_', window._)
        .controller('CreateRiskDialog', CreateRiskDialog);

    /** @ngInject */
    function CreateRiskDialog($scope, $mdDialog, $translate, Owner, msUtils, $mdToast, riskConfigService, tinyMceService) {
        var vm = this;
        vm.owner = Owner;
        vm.branding = msUtils.getBranding();
        vm.closeDialog = closeDialog;
        vm.saveDialog = saveDialog;
        vm.country_id = 1;
        vm.language_id = 1;
        vm.tinymceOptions = tinyMceService.getOptions($scope);
        vm.tinymceOptions.height = 150;

        function saveDialog() {
            var options = {
                owner: vm.owner,
                name: vm.name,
                description: vm.description,
                code: vm.code,
                external_link: vm.external_link,
                conducts: vm.conducts,
                factual_causes: vm.factual_causes,
                reputation_impact: vm.reputation_impact,
                penal_code_impact: vm.penal_code_impact,
                client_loss: vm.client_loss,
                country_id: vm.country_id,
                language_id: vm.language_id
            }
            riskConfigService.createRisk(options).then(function (response) {

                $mdDialog.hide({ risk: response.result });
            }).catch(function (err) {
                var message = $translate.instant('GLOBAL.ERROR') + '<br>' + err.data.detail;

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
            });

        }

        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();


(function () {
    'use strict';

    angular
        .module('app.riskconfig')
        .constant('_', window._)
        .controller('CreateControlDialog', CreateControlDialog);

    /** @ngInject */
    function CreateControlDialog($mdDialog, $translate, Owner,  process, $mdToast, riskConfigService) {
        var vm = this;
        vm.owner = Owner;
        vm.process = process;
        vm.closeDialog = closeDialog;
        vm.saveDialog = saveDialog;




        function saveDialog() {
            var options = {
                owner: vm.owner,
                name: vm.name,
                process_id: vm.process.id
            }
            riskConfigService.createControl(options).then(function (response) {
                $mdDialog.hide({ completed: true });
            }).catch(function (err) {
                var message = $translate.instant('GLOBAL.ERROR') + '<br>' + err.data.detail;

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
            })
        }

        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('SettingsSidenavController', SettingsSidenavController);

    /** @ngInject */
    function SettingsSidenavController($mdColorPalette, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.palettes = $mdColorPalette;
        vm.selectedMenu = 'Settings';

        // Methods

        ////////

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('msSbAddCardController', msSbAddCardController)
        .directive('msSbAddCard', msSbAddCardDirective);

    /** @ngInject */
    function msSbAddCardController($scope, $timeout, BoardService, msUtils)
    {
        var vm = this;

        vm.newCardName = '';
        vm.listId = $scope.msListId;
        vm.board = BoardService.data;
        vm.cards = vm.board.cards;
        vm.list = vm.board.lists.getById(vm.listId);

        // Methods
        vm.addNewCard = addNewCard;

        /////

        /**
         * Add New Card
         */
        function addNewCard()
        {
            if ( vm.newCardName === '' )
            {
                return;
            }

            var newCardId = msUtils.guidGenerator();

            vm.cards.push({
                id               : newCardId,
                name             : vm.newCardName,
                description      : '',
                idAttachmentCover: '',
                idMembers        : [],
                idLabels         : [],
                attachments      : [],
                subscribed       : false,
                checklists       : [],
                checkItems       : 0,
                checkItemsChecked: 0,
                comments         : [],
                activities       : [],
                due              : null
            });

            vm.list.idCards.push(newCardId);

            $timeout(function ()
            {
                $scope.scrollListContentBottom();
            });

            vm.newCardName = '';
        }
    }

    /** @ngInject */
    function msSbAddCardDirective($document, $window, $timeout)
    {
        return {
            restrict   : 'E',
            controller : 'msSbAddCardController as vm',
            templateUrl: 'app/main/apps/scrumboard/directives/ms-sb-add-card/ms-sb-add-card.html',
            scope      : {
                msListId: '='
            },
            link       : function (scope, iElement)
            {
                scope.formActive = false;
                scope.toggleForm = toggleForm;
                scope.scrollListContentBottom = scrollListContentBottom;

                var buttonEl = iElement.find('.ms-sb-add-card-button'),
                    formEl = iElement.find('.ms-sb-add-card-form'),
                    listCards = iElement.parent().prev().find('.list-cards');

                /**
                 * Click Event
                 */
                buttonEl.on('click', toggleForm);

                /**
                 * Toggle Form
                 */
                function toggleForm()
                {
                    scope.$evalAsync(function ()
                    {
                        scope.formActive = !scope.formActive;

                        if ( scope.formActive )
                        {
                            $timeout(function ()
                            {
                                formEl.find('input').focus();

                                scrollListContentBottom();
                            });

                            $document.on('click', outSideClick);
                        }
                        else
                        {
                            PerfectScrollbar.update(listCards[0]);
                            $document.off('click', outSideClick);
                        }

                        $timeout(function ()
                        {
                            // IE list-content max-height hack
                            if ( angular.element('html').hasClass('explorer') )
                            {
                                angular.element($window).trigger('resize');
                            }
                        });

                    });
                }

                /**
                 * Scroll List to the Bottom
                 */
                function scrollListContentBottom()
                {
                    listCards[0].scrollTop = listCards[0].scrollHeight;
                }

                /**
                 * Click Outside Event Handler
                 * @param event
                 */
                var outSideClick = function (event)
                {
                    var isChild = formEl.has(event.target).length > 0;
                    var isSelf = formEl[0] === event.target;
                    var isInside = isChild || isSelf;

                    if ( !isInside )
                    {
                        toggleForm();
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('FiltersSidenavController', FiltersSidenavController);

    /** @ngInject */
    function FiltersSidenavController(msUtils, BoardService, CardFilters)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.cardFilters = CardFilters;
        vm.labels = vm.board.labels;
        vm.members = vm.board.members;
        vm.selectedMenu = 'Settings';

        // Methods
        vm.exists = msUtils.exists;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.clearFilters = CardFilters.clear;
        vm.filteringIsOn = CardFilters.isOn;

        ////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ScrumboardCardDialogController', ScrumboardCardDialogController);

    /** @ngInject */
    function ScrumboardCardDialogController($document, $mdDialog, fuseTheming, fuseGenerator, msUtils, BoardService, cardId)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.card = vm.board.cards.getById(cardId);
        vm.newLabelColor = 'red';
        vm.members = vm.board.members;
        vm.labels = vm.board.labels;

        // Methods
        vm.palettes = fuseTheming.getRegisteredPalettes();
        vm.rgba = fuseGenerator.rgba;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.closeDialog = closeDialog;
        vm.getCardList = getCardList;
        vm.removeCard = removeCard;
        /* Attachment */
        vm.toggleCoverImage = toggleCoverImage;
        vm.removeAttachment = removeAttachment;
        /* Labels */
        vm.labelQuerySearch = labelQuerySearch;
        vm.filterLabel = filterLabel;
        vm.addNewLabel = addNewLabel;
        vm.removeLabel = removeLabel;
        /* Members */
        vm.memberQuerySearch = memberQuerySearch;
        vm.filterMember = filterMember;
        /* Checklist */
        vm.updateCheckedCount = updateCheckedCount;
        vm.addCheckItem = addCheckItem;
        vm.removeChecklist = removeChecklist;
        vm.createCheckList = createCheckList;
        /* Comment */
        vm.addNewComment = addNewComment;

        //////////

        /**
         * Close Dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Get Card List
         */
        function getCardList()
        {
            var response;
            for ( var i = 0, len = vm.board.lists.length; i < len; i++ )
            {
                if ( vm.board.lists[i].idCards.indexOf(vm.card.id) > -1 )
                {
                    response = vm.board.lists[i];
                    break;
                }
            }
            return response;
        }

        /**
         * Remove card
         *
         * @param ev
         */
        function removeCard(ev)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove Card',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove card?',
                ariaLabel          : 'remove card',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });

            $mdDialog.show(confirm).then(function ()
            {
                var cardList = getCardList();

                cardList.idCards.splice(cardList.idCards.indexOf(vm.card.id), 1);

                vm.board.cards.splice(vm.board.cards.indexOf(vm.card), 1);

            }, function ()
            {
                // Canceled
            });
        }

        /**
         * Toggle cover image
         *
         * @param attachmentId
         */
        function toggleCoverImage(attachmentId)
        {
            if ( attachmentId === vm.card.idAttachmentCover )
            {
                vm.card.idAttachmentCover = null;
            }
            else
            {
                vm.card.idAttachmentCover = attachmentId;
            }
        }

        /**
         * Remove attachment
         *
         * @param item
         */
        function removeAttachment(item)
        {
            if ( vm.card.idAttachmentCover === item.id )
            {
                vm.card.idAttachmentCover = '';
            }
            vm.card.attachments.splice(vm.card.attachments.indexOf(item), 1);
        }

        /**
         * Add label chips
         *
         * @param query
         * @returns {filterFn}
         */
        function labelQuerySearch(query)
        {
            return query ? vm.labels.filter(createFilterFor(query)) : [];
        }

        /**
         * Label filter
         *
         * @param label
         * @returns {boolean}
         */
        function filterLabel(label)
        {
            if ( !vm.labelSearchText || vm.labelSearchText === '' )
            {
                return true;
            }

            return angular.lowercase(label.name).indexOf(angular.lowercase(vm.labelSearchText)) >= 0;
        }

        /**
         * Add new label
         */
        function addNewLabel()
        {
            vm.board.labels.push({
                id   : msUtils.guidGenerator(),
                name : vm.newLabelName,
                color: vm.newLabelColor
            });

            vm.newLabelName = '';
        }

        /**
         * Remove label
         */
        function removeLabel()
        {
            var arr = vm.board.labels;
            arr.splice(arr.indexOf(arr.getById(vm.editLabelId)), 1);

            angular.forEach(vm.board.cards, function (card)
            {
                if ( card.idLabels && card.idLabels.indexOf(vm.editLabelId) > -1 )
                {
                    card.idLabels.splice(card.idLabels.indexOf(vm.editLabelId), 1);
                }
            });

            vm.newLabelName = '';
        }

        /**
         * Add member chips
         *
         * @param query
         * @returns {Array}
         */
        function memberQuerySearch(query)
        {
            return query ? vm.members.filter(createFilterFor(query)) : [];
        }

        /**
         * Member filter
         *
         * @param member
         * @returns {boolean}
         */
        function filterMember(member)
        {
            if ( !vm.memberSearchText || vm.memberSearchText === '' )
            {
                return true;
            }

            return angular.lowercase(member.name).indexOf(angular.lowercase(vm.memberSearchText)) >= 0;
        }

        /**
         * Update check list stats
         * @param list
         */
        function updateCheckedCount(list)
        {
            var checkItems = list.checkItems;
            var checkedItems = 0;
            var allCheckedItems = 0;
            var allCheckItems = 0;

            angular.forEach(checkItems, function (checkItem)
            {
                if ( checkItem.checked )
                {
                    checkedItems++;
                }
            });

            list.checkItemsChecked = checkedItems;

            angular.forEach(vm.card.checklists, function (item)
            {
                allCheckItems += item.checkItems.length;
                allCheckedItems += item.checkItemsChecked;
            });

            vm.card.checkItems = allCheckItems;
            vm.card.checkItemsChecked = allCheckedItems;
        }

        /**
         * Add checklist item
         *
         * @param text
         * @param checkList
         */
        function addCheckItem(text, checkList)
        {
            if ( !text || text === '' )
            {
                return;
            }

            var newCheckItem = {
                'name'   : text,
                'checked': false
            };

            checkList.checkItems.push(newCheckItem);

            updateCheckedCount(checkList);
        }

        /**
         * Remove checklist
         *
         * @param item
         */
        function removeChecklist(item)
        {
            vm.card.checklists.splice(vm.card.checklists.indexOf(item), 1);

            angular.forEach(vm.card.checklists, function (list)
            {
                updateCheckedCount(list);
            });
        }

        /**
         * Create checklist
         */
        function createCheckList()
        {
            vm.card.checklists.push({
                id               : msUtils.guidGenerator(),
                name             : vm.newCheckListTitle,
                checkItemsChecked: 0,
                checkItems       : []
            });

            vm.newCheckListTitle = '';
        }

        /**
         * Add new comment
         *
         * @param newCommentText
         */
        function addNewComment(newCommentText)
        {
            var newComment = {
                idMember: '36027j1930450d8bf7b10158',
                message : newCommentText,
                time    : 'now'
            };

            vm.card.comments.unshift(newComment);
        }

        /**
         * Filter for chips
         *
         * @param query
         * @returns {filterFn}
         */
        function createFilterFor(query)
        {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(item)
            {
                return angular.lowercase(item.name).indexOf(lowercaseQuery) >= 0;
            };
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.riskmap', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider,
        msUtilProvider, msNavigationServiceProvider, ivhTreeviewOptionsProvider) {

        ivhTreeviewOptionsProvider.set({
            defaultSelectedState: false,
            validate: true,
            expandToDepth: -1,
            twistieCollapsedTpl: '',
            twistieExpandedTpl: '<md-icon md-svg-icon="assets/angular-material-assets/img/icons/ic_expand_more_black_24px.svg"></md-icon>',
            twistieLeafTpl: '<span style="cursor: default;">&#8192;&#8192;</span>'
        });





        // State


        $stateProvider.state('app.riskmap', {
            url: '/riskmap',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/riskmap/riskmap.html',
                    controller: 'RiskMapController as vm'
                }
            },
            bodyClass: 'riskmap'
        });

        $stateProvider
            .state('app.site_overview.riskmap', {
                abstract: true,
                url: '/riskmap',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/riskmap/riskmap.html',
                        controller: 'RiskMapController as vm'
                    }
                },
                onEnter: function ($stateParams) {
                },
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                },
            })
            .state('app.site_overview.riskmap.list', {
                url: '/list',
                onEnter: function () {
                },
                params: {
                    isInherent: false
                },
                resolve: {
                },
            })
            .state('app.site_overview.riskmap.inherent', {
                url: '/inherent',
                onEnter: function () {
                },
                params: {
                    isInherent: true
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/riskmap/riskmap.html',
                        controller: 'RiskMapController as vm'
                    }
                },
                resolve: {
                },
            })
        // Translation
        var base = 'app/main/apps/riskmap';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.riskmap')
        .controller('RiskMapEditRiskDialogController', RiskMapEditRiskDialogController);

    /** @ngInject */
    function RiskMapEditRiskDialogController($mdDialog, $mdToast, $translate, riskMapService, risk, owner) {
        var vm = this;

        vm.risk = risk;
        vm.owner = owner;
        vm.loading = false;

        vm.editValues = {
            reputation_impact: risk.reputation_impact || 1,
            penal_code_impact: risk.penal_code_impact || 1,
            client_loss: risk.client_loss || 1,
            risk_impact: risk.risk_impact || 1,
            process_odds_of_occurrence: risk.process_odds_of_occurrence || 1,
            evidence_average: risk.evidence_average || null,
            process_probability: risk.process_probability || 1,
            computed_process: risk.computed_process || 1
        };

        vm.impactOptions = [1, 2, 3, 4, 5];
        
        vm.computedProcessConfig = {
            min: 1,
            max: Math.max(risk.computed_process || 1, 25),
            step: 1
        };

        vm.save = save;
        vm.cancel = cancel;
        vm.getImpactLabel = getImpactLabel;
        vm.getComputedProcessLabel = getComputedProcessLabel;

        function save() {
            vm.loading = true;

            riskMapService.updateRiskMapItem(vm.owner, vm.risk.id, vm.editValues)
                .then(function (response) {
                    var message = $translate.instant('GLOBAL.UPDATED_SUCCESSFULLY');
                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content bg-green">' + message + '</div></md-toast>',
                        hideDelay: 7000,
                        position: 'top right',
                        parent: '#content'
                    });
                    $mdDialog.hide(response.result);
                })
                .catch(function (error) {
                    var message = $translate.instant('GLOBAL.ERROR') + '<br>' + (error.data ? error.data.detail : 'Error al actualizar el riesgo');
                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                        hideDelay: 5000,
                        position: 'top',
                        parent: '#content-container'
                    });
                    console.error('Error al actualizar riesgo:', error);
                })
                .finally(function () {
                    vm.loading = false;
                });
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function getImpactLabel(value) {
            if (value === null || value === undefined || value === 0) {
                return 'N/A';
            }
            return $translate.instant('RISK.RISK_LEVELS_' + value) || value;
        }

        function getComputedProcessLabel(value) {
            if (value === null || value === undefined) {
                return 'N/A';
            }
            
            var riskLevel = '';
            if (value <= 5) {
                riskLevel = ' (' + $translate.instant('RISK.RISK_LEVELS_1') + ')';
            } else if (value <= 10) {
                riskLevel = ' (' + $translate.instant('RISK.RISK_LEVELS_2') + ')';
            } else if (value <= 15) {
                riskLevel = ' (' + $translate.instant('RISK.RISK_LEVELS_3') + ')';
            } else if (value <= 20) {
                riskLevel = ' (' + $translate.instant('RISK.RISK_LEVELS_4') + ')';
            } else {
                riskLevel = ' (' + $translate.instant('RISK.RISK_LEVELS_5') + ')';
            }
            
            return value + riskLevel;
        }
    }
})(); 
(function () {
    'use strict';

    angular
        .module('app.register-book', ['app.complaints', 'app.core'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msUtilProvider) {
        $stateProvider
            .state('app.site_overview.register-book', {
                abstract: true,
                url: '/register-book',
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                    section: function ($stateParams) {
                        return $stateParams.owner;
                    }
                }
            })
            .state('app.site_overview.register-book.list', {
                url: '',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/register-book/register-book.html',
                        controller: 'RegisterBookController as vm'
                    }
                },
                data: {
                    displayName: 'Register book',
                    bodyClass: 'register-book'
                }
            })
            .state('app.site_overview.register-book.list.entry', {
                url: '/entry/:id'
            });

        var base = 'app/main/apps/register-book';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.register-book')
        .controller('RegisterBookReportDialogController', RegisterBookReportDialogController);

    /** @ngInject */
    function RegisterBookReportDialogController($mdDialog, $translate, companySelected, owner, registerBookService, $mdToast) {
        var vm = this;

        vm.companySelected = companySelected;
        vm.owner = owner;
        vm.closeDialog = closeDialog;
        vm.submit = submit;
        vm.isDateRange = isDateRange;
        vm.canSubmit = canSubmit;
        vm.isDateRangeInvalid = isDateRangeInvalid;
        vm.onRangeModeChange = onRangeModeChange;
        vm.dayFormat = buildLocaleProvider('DD-MM-YYYY');
        vm.languageOptions = [
            { code: 'es', label: 'Español' },
            { code: 'en', label: 'English' },
            { code: 'de', label: 'Deutsch' },
            { code: 'fr', label: 'Français' },
            { code: 'it', label: 'Italiano' },
            { code: 'ca', label: 'Català' },
            { code: 'pt', label: 'Português' }
        ];

        vm.form = {
            title: '',
            range_mode: 'all',
            from_date: null,
            to_date: null,
            language_code: localStorage.getItem('LANG_CODE') || 'es'
        };

        function closeDialog(created) {
            $mdDialog.hide(created);
        }

        function isDateRange() {
            return vm.form.range_mode === 'date_range';
        }

        function onRangeModeChange() {
            if (!isDateRange()) {
                vm.form.from_date = null;
                vm.form.to_date = null;
            }
        }

        function canSubmit() {
            if (!vm.form.title || !String(vm.form.title).trim()) {
                return false;
            }

            if (!vm.form.language_code) {
                return false;
            }

            if (!isDateRange()) {
                return true;
            }

            if (!vm.form.from_date || !vm.form.to_date) {
                return false;
            }

            return !isDateRangeInvalid();
        }

        function isDateRangeInvalid() {
            if (!isDateRange() || !vm.form.from_date || !vm.form.to_date) {
                return false;
            }

            var fromDate = normalizeDate(vm.form.from_date);
            var toDate = normalizeDate(vm.form.to_date);

            if (!fromDate || !toDate) {
                return true;
            }

            return toDate.getTime() < fromDate.getTime();
        }

        function normalizeDate(value) {
            var date = value instanceof Date ? new Date(value.getTime()) : new Date(value);

            if (isNaN(date.getTime())) {
                return null;
            }

            date.setHours(0, 0, 0, 0);
            return date;
        }

        function buildLocaleProvider(formatString) {
            return {
                formatDate: function (date) {
                    if (date) {
                        return moment(date).format(formatString);
                    }

                    return '';
                },
                parseDate: function (dateString) {
                    if (!dateString) {
                        return null;
                    }

                    var m = moment(dateString, formatString, true);
                    return m.isValid() ? m.toDate() : new Date(NaN);
                }
            };
        }

        function submit() {
            if (!canSubmit()) {
                return;
            }

            var payload = {
                report_type: 'company_register_book',
                company_id: vm.companySelected.id,
                title: String(vm.form.title).trim(),
                language_code: vm.form.language_code,
                from_date: null,
                to_date: null
            };

            if (isDateRange()) {
                payload.from_date = moment(vm.form.from_date).format('YYYY-MM-DD');
                payload.to_date = moment(vm.form.to_date).format('YYYY-MM-DD');
            }

            registerBookService.createComplaintReport({
                owner: vm.owner,
                item: payload
            }).then(function () {
                closeDialog(true);
            }, function () {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent($translate.instant('GLOBAL.ERROR'))
                        .position('top right')
                        .hideDelay(4000)
                        .parent('#content')
                );
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.register-book')
        .controller('RegisterBookPreviewDialogController', RegisterBookPreviewDialogController);

    /** @ngInject */
    function RegisterBookPreviewDialogController($mdDialog, previewUrl) {
        var vm = this;

        vm.previewUrl = previewUrl;
        vm.closeDialog = closeDialog;

        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.risk', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider,
        msUtilProvider, msNavigationServiceProvider, ivhTreeviewOptionsProvider) {
        ivhTreeviewOptionsProvider.set({
            defaultSelectedState: false,
            validate: true,
            expandToDepth: -1,
            twistieCollapsedTpl: '',
            twistieExpandedTpl: '<md-icon md-svg-icon="assets/angular-material-assets/img/icons/ic_expand_more_black_24px.svg"></md-icon>',
            twistieLeafTpl: '<span style="cursor: default;">&#8192;&#8192;</span>'
        });





        // State


        $stateProvider.state('app.risk', {
            url: '/risk',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/risk/risk.html',
                    controller: 'RiskController as vm'
                }
            },
            params: {
                isEvidences: false
            },
            bodyClass: 'risk'
        });

        $stateProvider
            .state('app.site_overview.risk', {
                abstract: true,
                url: '/risk',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/risk/risk.html',
                        controller: 'RiskController as vm'
                    }
                },
                onEnter: function ($stateParams) {
                },
                params: {
                    isEvidences: false
                },
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                },
            })
            .state('app.site_overview.risk.list', {
                url: '/:domain',
                onEnter: function () {
                },
                params: {
                    isEvidences: false
                },
                data: {
                },
                resolve: {
                },
            })
            .state('app.site_overview.risk.active_risk', {
                url: '/view/:id',
                params: {
                    isEvidences: false
                },
                onEnter: function () {

                }
            })



        $stateProvider.state('app.evidences', {
            url: '/evidences',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/risk/evidences.html',
                    controller: 'RiskController as vm'
                }
            },
            params: {
                isEvidences: true
            },
            bodyClass: 'evidences'
        });

        $stateProvider
            .state('app.site_overview.evidences', {
                abstract: true,
                url: '/evidences',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/risk/evidences.html',
                        controller: 'RiskController as vm'
                    }
                },
                onEnter: function ($stateParams) {
                },
                data: {
                    displayName: '{{owner}}'
                },
                params: {
                    isEvidences: true
                },
                resolve: {
                },
            })
            .state('app.site_overview.evidences.list', {
                url: '/:domain',
                onEnter: function () {
                },
                data: {
                },
                params: {
                    isEvidences: true
                },
                resolve: {
                },
            })
            .state('app.site_overview.evidences.active_control', {
                url: '/company/:id_company/risk/:id_active_risk/task/:id_active_control/:tab',
                params: {
                    isEvidences: true
                },
                onEnter: function () {

                }
            })

        // Translation
        var base = 'app/main/apps/risk';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.risk')
        .constant('_', window._)
        .controller('SelectRiskDialogController', SelectRiskDialogController);

    /** @ngInject */
    function SelectRiskDialogController($mdDialog, riskService, riskConfigService, alreadySelected, Owner, company) {
        var vm = this;
        vm.owner = Owner;
        vm.alreadySelected = alreadySelected;
        vm.isLoadingRisks = true;
        vm.selectRisk = selectRisk;
        vm.closeDialog = closeDialog;
        vm.saveDialog = saveDialog;
        vm.toggleRisk = toggleRisk;
        vm.toggleProcess = toggleProcess;
        vm.toggleControl = toggleControl;
        vm.isSelectedRisk = isSelectedRisk;
        vm.isSelectedProcess = isSelectedProcess;
        vm.isSelectedControl = isSelectedControl;

        function saveDialog() {
            vm.defaultSelection.processes = this.selectedRisk.processes.filter(x => {
                var result = false;
                x.controls.forEach(element => {
                    result = result || vm.isSelectedControl(element)
                });
                return !result
            }).map(y => y.id)
            vm.defaultSelection.controls = this.defaultSelection.controls.filter(x => {
                return !vm.defaultSelection.processes.find(y => y === x.process_id);
            }).map(z => z.id)
            $mdDialog.hide({
                selectedRisk: vm.selectedRisk,
                exclude: vm.defaultSelection
            });
        }

        function selectRisk(risk) {
            vm.isLoadingRiskDetail = true;
            vm.selectedRisk = risk;
            var options = {
                owner: vm.owner,
                id: vm.selectedRisk.id
            }
            riskConfigService.getrisk(options).then(function (res) {
                vm.selectedRisk = res.result;
                initExclusions(true);
                vm.isLoadingRiskDetail = false;
            })
        }
        function initExclusions(full) {
            vm.defaultSelection = {
                "processes": [],
                "controls": []
            };
            if (!full) {
                vm.selectedRisk.processes.forEach(processElement => {
                    vm.defaultSelection.processes.push(processElement);
                    processElement.controls.forEach(control => {
                        vm.defaultSelection.controls.push(control);
                    });
                });
            }
        }

        function toggleRisk() {
            if (vm.isSelectedRisk()) {
                initExclusions()
            } else {
                initExclusions(true)

            }
        }
        function toggleProcess(item) {
            if (vm.isSelectedProcess(item)) {
                item.controls.forEach(control => {
                    vm.defaultSelection.controls.push(control);
                });
            } else {
                item.controls.forEach(control => {
                    if (vm.defaultSelection.controls.indexOf(control) >= 0) {
                        vm.defaultSelection.controls.splice(vm.defaultSelection.controls.indexOf(control), 1);
                    }
                });
            }
        }
        function toggleControl(item, processItem) {
            if (vm.isSelectedControl(item)) {
                vm.defaultSelection.controls.push(item);
            } else if (vm.defaultSelection.controls.indexOf(item) >= 0) {
                vm.defaultSelection.controls.splice(vm.defaultSelection.controls.indexOf(item), 1);
            }
        }
        function isSelectedRisk() {
            return areSelectedProcesses(vm.selectedRisk.processes);
        }
        function isSelectedProcess(item) {
            return areSelectedControls(item.controls)
        }
        function isSelectedControl(item) {
            return !vm.defaultSelection.controls.find(x => x === item)
        }
        function areSelectedControls(controls) {
            for (let i = 0; i < controls.length; i++) {
                const control = controls[i];
                const result = isSelectedControl(control)
                if (!result) {
                    return false;
                }
            }
            return true;
        }
        function areSelectedProcesses(processes) {
            for (let i = 0; i < processes.length; i++) {
                const processItem = processes[i];
                const result = isSelectedProcess(processItem)
                if (!result) {
                    return false;
                }
            }
            return true;
        }
        function closeDialog() {
            $mdDialog.hide(false);
        }

        var options = {
            owner: vm.owner,
            resultsPerPage: 100,
            region_id: company.region_id
        }
        riskService.getRisksMaster(options).then(function (res) {
            vm.risks = res.data;
            // We comment on the next block to avoid excluding the risks already selected.
            /*
            vm.risks = _.filter(vm.risks, function (risk) {
                return _.filter(vm.alreadySelected, function (_risk) {
                    return _risk.id == risk.id;
                }).length == 0;
            });
            */
            vm.isLoadingRisks = false;
        })
    }
})();


(function () {
    'use strict';

    angular
        .module('app.risk')
        .constant('_', window._)
        .controller('SelectControlDialogController', SelectControlDialogController);

    /** @ngInject */
    function SelectControlDialogController($mdDialog, riskConfigService, $q, process, risk, Owner) {
        var vm = this;

        vm.owner = Owner;
        vm.process = process;
        vm.risk = risk;
        vm.selectedRisk = null;
        console.log('Owner:', vm.owner);
        console.log('Process:', vm.process);
        console.log('Risk:', vm.risk);
        vm.controls = [];

        vm.selectedControls = [];
        vm.defaultSelection = {
            processes: [],
            controls: []
        };
        vm.isLoadingControls = true;
        vm.searchQuery = '';
        vm.closeDialog = closeDialog;
        vm.saveDialog = saveDialog;
        vm.toggleControl = toggleControl;
        vm.isSelectedControl = isSelectedControl;

        loadRiskDetails();

        function loadRiskDetails() {
            var options = {
                owner: vm.owner,
                id: vm.risk.id,
                process: vm.process.id
            };
            console.log('Options:', options);
            riskConfigService.getrisk(options).then(function (res) {
                console.log('Response:', res);
                vm.controls = res.result.processes
                    .filter(p => p.id === vm.process.id)
                    .flatMap(p => p.controls);
                console.log('Controls:', vm.controls);

                vm.selectedRisk = res.result;
                initControls();
                vm.isLoadingControls = false;
            });
        }

        function saveDialog() {
    if (!vm.selectedRisk) {
        console.error('vm.selectedRisk no está definido');
        return;
    }

    console.log('Before Save - Selected Risk:', vm.selectedRisk);
    console.log('Before Save - Default Selection:', vm.defaultSelection);

    vm.defaultSelection.processes = vm.selectedRisk.processes.filter(x => {
        console.log('Processing process:', x);
        var result = false;
        x.controls.forEach(element => {
            result = result || vm.isSelectedControl(element);
            console.log('Result for control', element, 'is', result);
        });
        console.log('Final result for process', x, 'is', !result);
        return !result;
    }).map(y => ({
        id: y.id,
        name: y.name
    }));

    vm.defaultSelection.controls = vm.selectedControls.map(control => ({
        id: control.id,
        name: control.name
    }));

    console.log('After Filtering - Processes:', vm.defaultSelection.processes);
    console.log('After Filtering - Controls:', vm.defaultSelection.controls);

    var options = {
        owner: vm.owner,
        id: vm.selectedRisk.id,
        name: vm.selectedRisk.name,
        item: {
            country_id: vm.selectedRisk.country_id,
            language_id: vm.selectedRisk.language_id,
            processes: vm.defaultSelection.processes,
            controls: vm.defaultSelection.controls,
            process_id: vm.process.id
        }
    };

    console.log('Options:', options);

    riskConfigService.updateControl(options).then(function (response) {
        console.log('Update Response:', response);
        $mdDialog.hide({
            selectedRisk: vm.selectedRisk,
            exclude: vm.defaultSelection
        });
    }).catch(function (error) {
        console.error('Update Error:', error);
    });
}

        

        function initControls() {
            vm.selectedControls = [];
            vm.controls.forEach(function (control) {
                if (isSelectedControl(control)) {
                    vm.selectedControls.push(control);
                }
            });
        }

        function toggleControl(control) {
            var index = vm.selectedControls.indexOf(control);
            if (index > -1) {
                vm.selectedControls.splice(index, 1);
            } else {
                vm.selectedControls.push(control);
            }
        }

        function isSelectedControl(control) {
            return vm.selectedControls.indexOf(control) > -1;
        }

        function closeDialog() {
            $mdDialog.hide(false);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.reports', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msUtilProvider, msNavigationServiceProvider) {
        // State


        $stateProvider.state('app.report', {
            url: '/reports',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/reports/reports.html',
                    controller: 'ReportsController as vm'
                }
            },
            bodyClass: 'reports'
        });

        $stateProvider
        
            .state('app.site_overview.report', {
                abstract: true,
                url: '/reports',
                onEnter: function ($stateParams) {


                },
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                    section: function ($stateParams) {
                        return $stateParams.owner
                    },
                },


            })
            .state('app.site_overview.report.list', {
                url: '',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/reports.html',
                        controller: 'ReportsController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.report.list.active_report', {
                url: '/company/:id_company/report/:id',
                onEnter: function () {

                }
            })
        // Translation
        var base = 'app/main/apps/reports';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('dialogPreview', dialogPreview);

    /** @ngInject */
    function dialogPreview($mdDialog, owner, reportId, $http, reportsService) {

        var vm = this;
        vm.owner = owner;
        vm.reportId = reportId;
        vm.closeDialog = closeDialog;

        reportsService.getS3ReportPreSignedUrl({
            owner: vm.owner,
            id: vm.reportId,
            key: 'html',
        }).then(function (res) {
            $http({
                method: 'GET',
                url: res.url,
                skipAuthorization: true
            }).then(function (result) {
                vm.html = result.data;
            }).catch(function(result) {
                console.log('err', result);
            })
        });




        /**
         * Close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.questions', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider , 
        msUtilProvider, msNavigationServiceProvider, ivhTreeviewOptionsProvider) {
            ivhTreeviewOptionsProvider.set({
                defaultSelectedState: false,
                validate: true,
                expandToDepth: -1,
                twistieCollapsedTpl: '',
                twistieExpandedTpl: '<md-icon md-svg-icon="assets/angular-material-assets/img/icons/ic_expand_more_black_24px.svg"></md-icon>',
                twistieLeafTpl: '<span style="cursor: default;">&#8192;&#8192;</span>'
            });


        $stateProvider
            .state('app.site_overview.questions', {
                abstract: true,
                url: '/questions',
                onEnter: function ($stateParams) {
                },
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                    section: function ($stateParams) {
                        return $stateParams.owner
                    },
                },
            })
            .state('app.site_overview.questions.list', {
                url: '',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/questions-master/questions-master.html',
                        controller: 'QuestionsMasterController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.questions.questionnaire', {
                url: '/questionnaire',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/questions/questionnaire.html',
                        controller: 'QuestionsController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.questions.questionnaire.open', {
                url: '/:domain/branch/:branch',
                onEnter: function () {
                },
            });
        // Translation
        var base = 'app/main/apps/questions';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.questions')
        .controller('SelectProcessDialogController', SelectProcessDialogController);

    /** @ngInject */
    function SelectProcessDialogController($mdDialog, questionsMasterService, Owner, regionSelected) {
        var vm = this;
        vm.owner = Owner;
        vm.regionSelected = regionSelected;
        vm.isLoadingProcesses = true;
        vm.isLoadingRisks = true;
        vm.selectProcess = selectProcess;
        vm.closeDialog = closeDialog;
        /**
         * Save contact
         */
        function selectProcess(process) {
            $mdDialog.hide(process);
        }

        var options = {
            owner: vm.owner,
            region_id: vm.regionSelected.id
        }
        questionsMasterService.getProcesses(options).then(function (res) {
            vm.processes = res.data;
            vm.isLoadingProcesses = false;
        })
        var options = {
            owner: vm.owner,
            region_id: vm.regionSelected.id
        }
        questionsMasterService.getRiskWithProcesses(options).then(function (res) {
            vm.risks = res.data;
            vm.isLoadingRisks = false;
        })

        /**
         * Close dialog
         */
        function closeDialog() {
            $mdDialog.hide(false);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .constant('_', window._)
        .controller('NewProyectDialogController', NewProyectDialogController);

    /** @ngInject */
    function NewProyectDialogController($rootScope, $scope, $mdDialog, sectors, regions, $stateParams, $document, documentsService, staffsroiService,
        sessionService, clientsService, inputsService, outcomesService, regionsLiterals, company, main_branch, itemsService, transformitems, transforminputs, transformoutcomes, $translate) {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.saveDialog = saveDialog;
        vm.closeDialogT = closeDialogT;
        vm.saveDialogT = saveDialogT;
        vm.getRegionLiteral = getRegionLiteral;
        vm.sectors = sectors;
        vm.regions = regions;
        vm.regionsLiterals = regionsLiterals;
        vm.mediaDialogSingle = mediaDialogSingle;
        vm.deleteLogotype = deleteLogotype;
        $scope.owner = $stateParams.owner;
        vm.company = company ? company : {};
        vm.itemElemen = [];
        vm.item = [];
        vm.itemE = [];
        vm.inputTotal = [];
        vm.outcomesTotal = [];
        vm.getitems = getitems;
        vm.inputs = getinputs;
        vm.updateItem = updateItem;
        vm.getoutcomes = getoutcomes;
        vm.parentIndex = parentIndex;
        vm.tipemoney = ['€', '$', '£'];
        //        console.log(vm.company);
        vm.operator = ['+', '-', '/', '*', "(", ")"];
        vm.isSelected = isSelected;
        //        vm.selectedThreads = [];
        vm.selectedThreads = [];
        vm.openCompany = openCompany;
        vm.toggleSelectThread = toggleSelectThread;
        vm.cambio = false;
        vm.changeValue = changeValue;
        vm.changeValueInteres = changeValueInteres;        //        vm.calculoAnual = calculo;
        vm.calculoAnual = calculoAnual;
        //        vm.calculoAnualO = calculoO;
        vm.calculoAnualO = calculoAnualO;
        vm.itemActive = '1';
        vm.tipefield = [
            { number: '1', name: $translate.instant('ITEM.PROXY') },
            { number: '2', name: $translate.instant('ITEM.INDICATOR') },
            { number: '3', name: $translate.instant('ITEM.OUTPUT') }
        ];
        vm.newForm = newForm;
        vm.deleteitem = deleteitem;

        vm.main_branch = main_branch ? main_branch : {}
        getitems();
        getinputs();
        getoutcomes();
        if (vm.company.id) {
            staffsroiService.getMainBranch({ owner: $scope.owner, id_company: vm.company.id }).then(res => {
                vm.main_branch = res.data[0];
            })
        }
        if (vm.company.logo && vm.company.logo.length > 0) {
            var options = {
                owner: $scope.owner
            };
            clientsService.getStoragePrefix(options).then(function (res) {
                $scope.imageUrl = res.prefix + vm.company.logo[0].url;
                vm.logoIsLoaded = true;
            })
        }
        if (!vm.company.region_id) {
            vm.company.region_id = sessionService.user.region_id;
        }
        function saveDialog() {
            if (!vm.main_branch.name) {
                vm.main_branch.name = vm.company.name;
            }
            $rootScope.symbolMoney = vm.company.money_symbol;
            //        console.log($rootScope.symbolMoney);
            if (!vm.company.money_symbol) {
                $rootScope.symbolMoney = "€";
            }
            if ($rootScope.typeInterest != vm.company.type_interest) {
                $rootScope.typeInterest = vm.company.type_interest;
                changeValueInteres();
            }
            $mdDialog.hide({ company: vm.company, branch: vm.main_branch, image: $scope.image, updateLogotype: vm.updateLogotype });
        }
        function toggleSelectThread(thread, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedThreads.indexOf(thread) > -1) {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            }
            else {
                vm.selectedThreads.push(thread);
            }
        }
        function openCompany(company, ev) {
            vm.itemE = company;
            vm.edit = true;
        }
        function parentIndex() {
            var retorno = false;
            for (let it = 0; it < vm.item.length; it++) {
                if (vm.item[it].type == vm.itemActive) {
                    retorno = true;
                }
            }
            return (retorno);
        }
        function getitems(idCompany, inOwner) {
            var options = {
                owner: $scope.owner,
                proyect_id: vm.company.id,
                withFiles: true
            };
            itemsService.getProyects(options).then(function (response) {
                vm.item = response;
                $scope.isLoadingP = false;
            }, function (response) {
                vm.item = [];
                //                $scope.isLoadingP = true;
            }
            )
        }

        function getinputs(idCompany, inOwner) {
            var options = {
                owner: $scope.owner,
                proyect_id: vm.company.id,
                withFiles: true
            };
            inputsService.getInputs(options).then(function (response) {
                vm.input = response;
                //                console.log(vm.input);
                vm.input.forEach(function (input1, index) {
                    input1.input_structure = JSON.parse(input1.input_structure);
                    vm.inputTotal = vm.inputTotal.concat(input1.input_structure.inputs);
                });
            }, function (response) {
                vm.input = [];
                vm.inputTotal = [];
            }
            )
        }
        function getoutcomes(idCompany, inOwner) {
            var options = {
                owner: $scope.owner,
                proyect_id: vm.company.id,
                withFiles: true
            };
            outcomesService.getOutcomes(options).then(function (response) {
                vm.outcome = response;
                vm.outcome.forEach(function (output1, index) {
                    output1.output_structure = JSON.parse(output1.outcome_structure);
                    vm.outcomesTotal = vm.outcomesTotal.concat(output1.output_structure.outcomes);
                });
            }, function (response) {
                vm.outcome = [];
                vm.outcomesTotal = [];
            }
            )
        }
        function updateItem(itemUpdate, close) {
            vm.formWizard = {};
            vm.formWizard.company = itemUpdate;
            //            console.log(vm.formWizard);
            if (vm.company.id) {
                var options = {
                    owner: $scope.owner,
                    item: transformitems.itemToDTO(vm.formWizard)
                };
                //                        console.log(transformitems.itemToDTO(vm.formWizard));
                options.id = itemUpdate.id;
                //                $scope.isLoading = true;
                //                vm.idCompany = company.id;
                //                vm.formWizard.company = company;
                //                vm.edit = false;
                //               console.log(options);
                itemsService.updateProyect(options).then(function (response) {

                });


            }
        }
        function isSelected(thread) {
            return vm.selectedThreads.indexOf(thread) > -1;
        }
        function closeDialogT() {
            vm.edit = false;
        }
        function saveDialogT(company, ev) {
            company.Type = vm.itemActive;
            if (company.id) {
                vm.formWizard = {};
                $scope.isLoading = true;
                vm.idCompany = company.id;
                vm.formWizard.company = company;
                vm.edit = false;
            }
            else {
                //            vm.formWizard = {};
                $scope.isLoading = true;
                //           vm.idCompany = company.id;
                vm.formWizard = {};
                vm.formWizard.company = vm.itemE;
                vm.formWizard.company.type = vm.itemActive;
                vm.edit = false;
                vm.formWizard.company.company_id = vm.company.id;
                //                console.log(vm.formWizard);
            }
            createItem(null, true);
        }
        function createItem(msWizard, close) {
            //                       console.log(vm.formWizard);
            var options = {
                owner: $scope.owner,
                item: transformitems.itemToDTO(vm.formWizard)
            };
            //                        console.log(transformitems.itemToDTO(vm.formWizard));
            if (vm.idCompany) {
                options.id = vm.idCompany;
                //               console.log(options);
                itemsService.updateProyect(options).then(function (response) {

                });


            } else {
                //               options.item.is_owner = vm.companies.length > 0 ? 0 : true;
                itemsService.createProyect(options).then(function (response) {
                    //                    sessionService.authenticate($cookies.get('owner'));
                    $scope.isLoadingP = true;
                    vm.idCompany = response.id;
                    getitems();

                })
            }
        }

        function changeValueInteres() {
            //            console.log(itemC);
                var options = {
                    owner: $scope.owner,
                    proyect_id: vm.company.id,
                    withFiles: true
                };
                inputsService.getInputs(options).then(function (response) {
                    vm.input = response;
                    vm.input.forEach(function (input1, index) {
                        input1.input_structure = JSON.parse(input1.input_structure);
                        var inputF1 = input1.input_structure.inputs;
                        //                      console.log(inputF1);
                                calculoAnual(input1);
                                saveInput(input1);
                    });
                }, function (response) {
                    vm.input = [];
                    $scope.isLoadingP = false;
                }
                )
                outcomesService.getOutcomes(options).then(function (response) {
                    vm.input = response;
                    vm.input.forEach(function (input1, index) {
                        input1.outcome_structure = JSON.parse(input1.outcome_structure);
                        var inputF1 = input1.outcome_structure.outcomes;
                                calculoAnualO(input1);
                                saveOutcome(input1);
                   });
                }, function (response) {
                    vm.input = [];
                    $scope.isLoadingP = false;
                }
                )
                /*               vm.inputTotal = [];
                                vm.outcomesTotal = [];
                                getinputs();
                                getoutcomes();*/
        }
        function changeValue(itemC) {
            //            console.log(itemC);
            if (vm.cambio && itemC.id_item > 0) {
                var options = {
                    owner: $scope.owner,
                    proyect_id: vm.company.id,
                    withFiles: true
                };
                inputsService.getInputs(options).then(function (response) {
                    vm.input = response;
                    vm.input.forEach(function (input1, index) {
                        input1.input_structure = JSON.parse(input1.input_structure);
                        var inputF1 = input1.input_structure.inputs;
                        //                      console.log(inputF1);
                        inputF1.forEach(function (input1F, indexF) {
                            if (itemC.id_item == input1F.id_item) {
                                input1F.data = itemC.data;
                                calculo(input1);
                                calculoAnual(input1);
                                saveInput(input1);
                            }
                        });
                    });
                    vm.inputTotal.forEach(function (input1, index) {
                        if (itemC.id_item == input1.id_item) {
                            input1.data = itemC.data;
                        }
                    });
                }, function (response) {
                    vm.input = [];
                    $scope.isLoadingP = false;
                }
                )
                outcomesService.getOutcomes(options).then(function (response) {
                    vm.input = response;
                    vm.input.forEach(function (input1, index) {
                        input1.outcome_structure = JSON.parse(input1.outcome_structure);
                        var inputF1 = input1.outcome_structure.outcomes;
                        inputF1.forEach(function (input1F, indexF) {
                            if (itemC.id_item == input1F.id_item) {
                                input1F.data = itemC.data;
                                calculoO(input1);
                                calculoAnualO(input1);
                                saveOutcome(input1);
                            }
                        });
                    });
                    vm.outcomesTotal.forEach(function (input1, index) {
                        if (itemC.id_item == input1.id_item) {
                            input1.data = itemC.data;
                        }
                    });
                }, function (response) {
                    vm.input = [];
                    $scope.isLoadingP = false;
                }
                )
                /*               vm.inputTotal = [];
                                vm.outcomesTotal = [];
                                getinputs();
                                getoutcomes();*/
                vm.item.forEach(function (item1, index) {
                    if (item1.id == itemC.id_item) {
                        item1.value = itemC.data;
                        updateItem(item1, "");
                    }
                });
            }
            vm.cambio = false;
            //            vm.edit = false;
        }
        function deleteitem(ev) {
            var threads = angular.copy(vm.selectedThreads);
            const confirm = $mdDialog.confirm()
                .title($translate.instant('GLOBAL.ARE_YOU_SURE'))
                .targetEvent(ev)
                .multiple(true)
                .ok($translate.instant('GLOBAL.YES'))
                .cancel($translate.instant('GLOBAL.NO'));
            $mdDialog.show(confirm).then(e => {
                for (var i = 0; i < threads.length; i++) {
                    var options = {
                        owner: $scope.owner,
                        item_id: threads[i].id,
                    }
                    //                        console.log(options);
                    itemsService.deleteItem(options).then(function (response) {
                        vm.edit = false;
                        getitems();
                    })
                }
            })
            vm.edit = false;
            vm.selectedThreads = [];
        }

        function saveOutcome(inputC) {

            var inputC1 = {};
            inputC1.company = inputC;
            var options = {
                owner: $scope.owner,
                item: transformoutcomes.outcomeToDTO(inputC1)
            };
            options.id = inputC.id;
            outcomesService.updateOutcome(options).then(function (response) {

            });

        }
        function newForm(ev) {
            vm.idCompany = null;
            vm.itemE = [];
            vm.edit = true;
        }


        function saveInput(inputC) {

            var inputC1 = {};
            inputC1.company = inputC;
            var options = {
                owner: $scope.owner,
                item: transforminputs.inputToDTO(inputC1)
            };
            options.id = inputC.id;
            inputsService.updateInput(options).then(function (response) {

            });

        }
        function calculoO(inputC) {
            if (inputC.outcome_structure) {
                var valor = 0;
                var valorParen = [];
                var cantidad = 0;
                var cantidadt = 0;
                var indi = 0;
                var datainput = [];
                var operadorU = [];
                if (inputC.outcome_structure.formula.length == 0) {
                    datainput[0] = 0;
                }
                for (let it = 0; it < inputC.outcome_structure.formula.length; it++) {
                    var findv = false;
                    var parametro = inputC.outcome_structure.formula[it];
                    for (let i = 0; i < inputC.outcome_structure.outcomes.length; i++) {
                        if (inputC.outcome_structure.outcomes[i].fieldName == parametro) {
                            cantidad = inputC.outcome_structure.outcomes[i].data;
                            if (!datainput[indi]) {
                                datainput[indi] = cantidad;
                            }
                            findv = true;
                            break;
                        }
                    }
                    if (parametro == "(") {
                        indi = indi + 1;
                        continue;
                    }
                    if (parametro == ")") {
                        cantidad = datainput[indi];
                        datainput[indi] = 0;
                        indi = indi - 1;
                    }
                    if (inputC.outcome_structure.formula[it + 1] && (inputC.outcome_structure.formula[it + 1] == "*" || inputC.outcome_structure.formula[it + 1] == "/")) {
                        var operadorA = inputC.outcome_structure.formula[it + 1];
                        if (!inputC.outcome_structure.formula[it + 2]) {
                            datainput[0] = $translate.instant('INPUT.FORMULA_ERROR');
                            break;
                        }
                        var parametro = inputC.outcome_structure.formula[it + 2];
                        for (let i = 0; i < inputC.outcome_structure.outcomes.length; i++) {
                            if (inputC.outcome_structure.outcomes[i].fieldName == parametro) {
                                var cantidadMD = inputC.outcome_structure.outcomes[i].data;
                                break;
                            }
                        }
                        switch (operadorA) {
                            case '*':
                                cantidad = cantidadMD * cantidad;
                                break;
                            case '/':
                                if (cantidad > 0) {
                                    cantidad = cantidad / cantidadMD;
                                    break;
                                }
                        }
                        if (!operadorU[indi]) {
                            datainput[indi] = cantidad;
                        }
                        it = it + 2;
                    }
                    switch (operadorU[indi]) {
                        case '+':
                            datainput[indi] = parseFloat(datainput[indi]) + parseFloat(cantidad);
                            break;
                        case '-':
                            datainput[indi] = datainput[indi] - cantidad;
                            break;
                        case '*':
                            datainput[indi] = datainput[indi] * cantidad;
                            break;
                        case '/':
                            if (cantidad > 0) {
                                datainput[indi] = datainput[indi] / cantidad;
                            }
                            break;
                    }
                    operadorU[indi] = "";
                    if (!findv) {
                        for (let i = 0; i < vm.operator.length - 2; i++) {
                            if (vm.operator[i] == parametro) {
                                operadorU[indi] = parametro;
                                break;
                            }
                        }

                    }
                }
                inputC.outcome_structure.calculation = datainput[0];
                inputC.sub_result = datainput[0];
            }
        }
        function calculoAnualO(inputC) {

            var interes = 1 + ($rootScope.typeInterest / 100);
            var totalCalc = 0;
            if (inputC.years_input > 1) {
                if (inputC.dead_weight == 0) {
                    inputC.dead_weight = 100;
                }
                if (inputC.displacement == 0) {
                    inputC.displacement = 100;
                }
                if (inputC.attribution == 0) {
                    inputC.attribution = 100;
                }
                var anual = (inputC.sub_result / inputC.years_input) * (inputC.dead_weight / 100) * (inputC.displacement / 100) * (inputC.attribution / 100);
                totalCalc = anual;
                for (let i = 2; i <= inputC.years_input; i++) {
                    anual = (anual * (1 - inputC.decrease / 100) / interes);
                    totalCalc = totalCalc + anual;
                }
            }
            else {
                totalCalc = inputC.sub_result * (inputC.dead_weight / 100) * (inputC.displacement / 100) * (inputC.attribution / 100);
            }
            inputC.result = totalCalc;
        }
        function calculo(inputC) {
            if (inputC.input_structure) {
                var valor = 0;
                var valorParen = [];
                var cantidad = 0;
                var cantidadt = 0;
                var indi = 0;
                var datainput = [];
                var operadorU = [];
                if (inputC.input_structure.formula.length == 0) {
                    datainput[0] = 0;
                }
                for (let it = 0; it < inputC.input_structure.formula.length; it++) {
                    var findv = false;
                    var parametro = inputC.input_structure.formula[it];
                    for (let i = 0; i < inputC.input_structure.inputs.length; i++) {
                        if (inputC.input_structure.inputs[i].fieldName == parametro) {
                            cantidad = inputC.input_structure.inputs[i].data;
                            if (!datainput[indi]) {
                                datainput[indi] = cantidad;
                            }
                            findv = true;
                            break;
                        }
                    }
                    if (parametro == "(") {
                        indi = indi + 1;
                        continue;
                    }
                    if (parametro == ")") {
                        cantidad = datainput[indi];
                        datainput[indi] = 0;
                        indi = indi - 1;
                    }
                    if (inputC.input_structure.formula[it + 1] && (inputC.input_structure.formula[it + 1] == "*" || inputC.input_structure.formula[it + 1] == "/")) {
                        var operadorA = inputC.input_structure.formula[it + 1];
                        if (!inputC.input_structure.formula[it + 2]) {
                            datainput[0] = $translate.instant('INPUT.FORMULA_ERROR');
                            break;
                        }
                        var parametro = inputC.input_structure.formula[it + 2];
                        for (let i = 0; i < inputC.input_structure.inputs.length; i++) {
                            if (inputC.input_structure.inputs[i].fieldName == parametro) {
                                var cantidadMD = inputC.input_structure.inputs[i].data;
                                break;
                            }
                        }
                        switch (operadorA) {
                            case '*':
                                cantidad = cantidadMD * cantidad;
                                break;
                            case '/':
                                if (cantidad > 0) {
                                    cantidad = cantidad / cantidadMD;
                                    break;
                                }
                        }
                        if (!operadorU[indi]) {
                            datainput[indi] = cantidad;
                        }
                        it = it + 2;
                    }
                    switch (operadorU[indi]) {
                        case '+':
                            datainput[indi] = parseFloat(datainput[indi]) + parseFloat(cantidad);
                            break;
                        case '-':
                            datainput[indi] = datainput[indi] - cantidad;
                            break;
                        case '*':
                            datainput[indi] = datainput[indi] * cantidad;
                            break;
                        case '/':
                            if (cantidad > 0) {
                                datainput[indi] = datainput[indi] / cantidad;
                            }
                            break;
                    }
                    operadorU[indi] = "";
                    if (!findv) {
                        for (let i = 0; i < vm.operator.length - 2; i++) {
                            if (vm.operator[i] == parametro) {
                                operadorU[indi] = parametro;
                                break;
                            }
                        }

                    }
                }
                inputC.input_structure.calculation = datainput[0];
                inputC.sub_result = datainput[0];
            }
        }
        function calculoAnual(inputC) {
            var interes = 1 + ($rootScope.typeInterest / 100);
            var totalCalc = 0;
            if (inputC.years > 1) {
                var anual = inputC.sub_result / inputC.years;
                totalCalc = anual;
                for (let i = 2; i <= inputC.years; i++) {
                    anual = anual / interes;
                    totalCalc = totalCalc + anual;
                }
            }
            else {
                totalCalc = inputC.sub_result
            }
            inputC.result = totalCalc;
        }
        function mediaDialogSingle(ev, field) {
            $mdDialog.show({
                controller: 'MediaClientsController',
                controllerAs: 'vm',
                locals: {
                    owner: $scope.owner,
                    multipleSelection: true,
                    isTiny: false
                },
                templateUrl: 'app/main/apps/proyects/dialogs/media/media-clients.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                multiple: true
            }).then(function (image) {
                if (image) {
                    vm.updateLogotype = true;
                    $scope.image = image;
                }
            });
        }
        function deleteLogotype() {
            if (vm.company.logo && vm.company.logo.length > 0) {
                for (var i = 0; i < vm.company.logo.length; i++) {
                    const itemLogo = vm.company.logo[i];
                    var options = {
                        owner: $scope.owner,
                        id: itemLogo.id
                    }
                    documentsService.deleteDocument(options).then(function () {
                        vm.company.logo = null;
                    })
                }
            }
            $scope.image = undefined;
            $scope.imageUrl = undefined;
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function getRegionLiteral(literalKey) {
            if (!angular.isUndefined(vm.company) && vm.company.region_id) {
                const literalsObject = vm.regionsLiterals.find(x => x.region_id === vm.company.region_id)
                return literalsObject.literals[literalKey];
            } else {
                return 'CIF/NIF';
            }
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('MediaClientsController', MediaClientsController);

    /** @ngInject */
    function MediaClientsController($mdDialog,$stateParams, $document, mediaService, owner, requestContext, $anchorScroll, $timeout, $scope, $sce, Upload, multipleSelection, msUtils, COMMON, isTiny, $log) {
        var vm = this;

        // Data
        vm.owner = owner;
        $scope.owner = $stateParams.owner;

        vm.defaultPage = 1;
        vm.defaultPerPage = 50;
        vm.PerPage = 50;
        vm.searchStringFilter = '';
        vm.searchQuery = '';
        vm.modelSearch = '';
        vm.pagination_search = pagination_search;

        vm.isTiny = isTiny;

        vm.views = {
            1: 'app/main/apps/clients/dialogs/media/views/photos-view.html',
            2: 'app/main/apps/clients/dialogs/media/views/videos-view.html',
            3: 'app/main/apps/clients/dialogs/media/views/files-view.html',
            4: 'app/main/apps/clients/dialogs/media/views/audios-view.html',
            upload: 'app/main/apps/clients/dialogs/media/views/upload-view.html',
            import: 'app/main/apps/clients/dialogs/media/views/import-view.html',
        };
        vm.defaultView = 'upload';
        vm.currentView = 'upload';

        vm.viewsTiny = {
            1: 'app/main/apps/clients/dialogs/media/views/tiny-attached.html',
            properties: 'app/main/apps/clients/dialogs/media/views/tiny-properties.html',
            upload: 'app/main/apps/clients/dialogs/media/views/upload-view.html',
        };
        vm.defaultViewTiny = '1';
        vm.currentViewTiny = '1';

        vm.firstLoad = true;
        vm.media_type = '1';
        vm.showSearchAndPaginator = true;
        vm.import_field = '';
        vm.import_disabled = '';
        vm.importedFiles = [];
        vm.importPreview = false;
        vm.imported = false;
        vm.importing = false;
        vm.selectedImages = [];
        vm.files = [];
        vm.tinyProperties = {
            mediaType: '',
            mediaSort: '',
            mediaData: {},
            align: '',
            size: ''
        };
        vm.tinyOptions = {
            size: [
                { value: 25, text: '25%' },
                { value: 50, text: '50%' },
                { value: 75, text: '75%' },
                { value: 100, text: '100%' }
            ],
            align: [
                { value: 'left', text: 'left' },
                { value: 'center', text: 'center' },
                { value: 'right', text: 'right' }
            ]
        }

        // If replying
        // if (angular.isDefined(selectedMail)) {
        // 	vm.form.to = selectedMail.from.email;
        // 	vm.form.subject = 'RE: ' + selectedMail.subject;
        // 	vm.form.message = '<blockquote>' + selectedMail.message + '</blockquote>';
        // }

        // Methods
        vm.closeDialog = closeDialog;
        vm.changeView = changeView;
        vm.changeViewTiny = changeViewTiny;

        vm.nextPage = nextPage;
        vm.prevPage = prevPage;
        vm.morePages = morePages;
        vm.firstPage = firstPage;
        vm.upload = upload;
        vm.attachMedia = attachMedia;
        vm.attachMediaTiny = attachMediaTiny;
        vm.selectMediaTiny = selectMediaTiny;
        vm.selectedMediaTiny = '';
        vm.search = search;

        vm.exists = msUtils.exists;
        vm.alreadySelectedbyZone = alreadySelectedbyZone;
        vm.existInArray = msUtils.existInArray;
        vm.toggleSelectedImages = toggleSelectedImages;


        //////////

        if (!isTiny) {
            init();
        } else {
            vm.section = section;
            initTiny();
        }
        /**
         * Initialize
         */
        function init() {

            vm.loading = true;
        }

        /**
         * Initialize Tinymce
         */
        function initTiny() {
            vm.currentViewTiny = vm.defaultViewTiny;
            vm.showSearchAndPaginator = false;
            vm.loading = true;
            for (var i = 0; i < vm.currentThread.length; i++) {
                if (vm.mediazone) {
                    if (vm.currentThread[i].id_zone == 1) {
                        vm.selectedImages.push(vm.currentThread[i]);
                    }
                } else {
                    vm.selectedImages.push(vm.currentThread[i]);
                }
            }
            if (vm.section.mediaSort) {
                var currentSort = 0;
                var currentItem = '';
                for (var i = 0; i < vm.currentThread.length; i++) {
                    if (vm.mediazone) {
                        if (vm.currentThread[i]['id_zone'] == 1 && (vm.currentThread[i]['media_type'] == vm.section.mediaType)) {
                            currentSort++;
                            if (currentSort = vm.section.mediaSort) {
                                currentItem = vm.currentThread[i];
                            }
                        }
                    } else {
                        if (vm.currentThread[i]['media_type'] == vm.section.mediaType) {
                            currentSort++;
                            if (currentSort = vm.section.mediaSort) {
                                currentItem = vm.currentThread[i];
                            }
                        }

                    }
                }

                vm.selectedMediaTiny = currentItem;
                vm.tinyProperties.mediaSort = vm.section.mediaSort;
                vm.tinyProperties.mediaType = currentItem.media_type;
                vm.tinyProperties.align = vm.section.mediaAlign;
                vm.tinyProperties.size = vm.section.mediaSize;
                vm.changeViewTiny('properties');


            }
            vm.loading = false;

        }

        function pagination_search(searchString) {
            var options = {
                section: section,
                media_type: vm.media_type,
                page: vm.defaultPage,
                perPage: vm.defaultPerPage,
                searchString: searchString
            };
        }


        function search(options) {
            // console.log(options, vm.searchStringFilter);
            /*

			vm.loading 		= true;
			vm.items		=[];
			// Scroll to the top Dialog
            scrollToTopOfDialog();

			mediaService.get({
				siteID: siteID,
				page: options.page,
				paginate: options.perPage,
				media_type: options.media_type,
                withCropStatus: true,
                sortField: 'date_uploaded',
                searchStringFilter: options.searchString,

			})
				.then(function (response) {
					vm.totalItems = response.total;
					vm.pagination_totalItems = response.total;
					vm.from = response.from;
					vm.pagination_from = response.from;
					vm.to = response.to;
					vm.pagination_to = response.to;
					vm.currentPage = response.current_page;
					vm.lastPage = response.last_page;
					vm.maxSize = 500;
					vm.bigTotalItems = 175;

					vm.loading = false;

                    vm.items = angular.copy(response.data);

                    $('.md-button')
                        .removeClass('active');
                    $('[type=' + options.media_type + ']')
						.addClass('active');

				});




			vm.firstLoad = false;
*/
        }

        function closeDialog() {
            $mdDialog.hide(vm.currentThread);
        }

        function changeView(view) {

            //console.log(view)
            if (vm.views[view]) {
                vm.items = [];
                vm.loadingView = true;
                vm.showSearchAndPaginator = false;
                vm.defaultView = view;
                vm.currentView = view;


                vm.media_type = view;

                var options = {
                    page: 1,
                    perPage: vm.PerPage,
                    media_type: view,

                };
                if (view == 1 || view == 2 || view == 3 || view == 4) {
                    vm.showSearchAndPaginator = true;
                }

            }

        }

        function changeViewTiny(view) {


            if (vm.viewsTiny[view]) {
                vm.items = [];
                vm.loadingView = true;
                vm.showSearchAndPaginator = false;
                vm.defaultViewTiny = view;
                vm.currentViewTiny = view;
            }

        }

        $scope.file_changed = function (element) {

            $scope.$apply(function (scope) {
                var photofile = element.files[0];
                console.log(photofile);
                $mdDialog.hide(photofile);
                //vm.upload(photofile);
                var reader = new FileReader();
                reader.onload = function (e) {
                    // handle onload
                };
                reader.readAsDataURL(photofile);
                $scope.image = photofile;
            });
        };

        $scope.$watch('vm.files', function () {
            console.debug("WATCH!!:::!:!:!:!: ")
            $scope.formUpload = false;
            if (vm.files != null) {
                // make files array for not multiple to be able to be used in ng-repeat in the ui
                if (!angular.isArray(vm.files)) {
                    $timeout(function () {
                        $scope.files = vm.files = [vm.files];
                    });
                    return;
                }
                for (var i = 0; i < vm.files.length; i++) {
                    $scope.errorMsg = null;
                    (function (f) {
                        //vm.upload(f, true);
                        $mdDialog.hide(f);
                    })(vm.files[i]);
                }
            }
        });

        $scope.$watch('vm.import_field', function () {
            vm.importConfirm(false);
        });


        $scope.log = '';

        function upload(file) {
            if (!file.$error) {
                var token = undefined;
                console.debug("UPLOAD______****", file)
                mediaService.getS3UploadPreSignedUrl({
                    owner: $scope.owner,
                    uploadKey: 'company_logo',
                    fileName: file.name,
                    rowId: 1
                })
                    .then(function (resp) {
                        token = resp.token;
                        file.id_media = resp.id_media;
                        file.upload = Upload.http({
                            url: resp.url,
                            skipAuthorization: true,
                            method: 'PUT',
                            headers: {
                                "Content-Type": file.type != '' ? file.type : 'application/octet-stream' 
                            },
                            data: file
                        });

                        file.upload.then(function (response) {
                            file.result = response.data;
                            $timeout(function () {
                                $scope.log = 'file: ' +
                                    file.name +
                                    ', Response: ' + JSON.stringify(response.data) +
                                    ', ID: ' + file.id_media +
                                    '\n' + $scope.log;
                            });
                            console.debug("SEND_TO_CROP______****", file)
                            mediaService.finishedUploadingFileToCdn({
                                owner: vm.owner,
                                idMedia: file.id_media,
                                token: token
                            })
                            $mdDialog.hide(vm.files[0]);


                        }, function (response) {
                            if (response.status > 0)
                                $scope.errorMsg = response.status + ': ' + response.data;
                        });

                        file.upload.progress(function (evt) {
                            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                        });

                    })
            }
        };

        vm.importConfirm = function (confirm) {
            vm.import_disabled = false;
            vm.imported = false;
            if (!confirm) {
                vm.importPreview = false;
            }
            if (vm.import_field.length > 10) {
                vm.importing = true;
                vm.import_disabled = true;

                $timeout(function () {
                    var pastedUrl = vm.import_field;
                    mediaService.importFromUrl({
                        siteID: siteID,
                        url: pastedUrl,
                        execute: confirm
                    })
                        .then(function (response) {
                            vm.importing = false;
                            response.embedCodeSafe = $sce.trustAsHtml(response.metadata.embedCode);
                            if (response.id_media) {
                                vm.imported = true;
                                vm.importPreview = false;
                                mediaService.get({
                                    siteID: siteID,
                                    withCropStatus: true,
                                    idMedia: response.id_media
                                })
                                    .then(function (response) {
                                        if (response.total == 1) {
                                            var photo = response.data[0];
                                            vm.importedFiles.push(photo);
                                            toggleSelectedImages(photo);
                                        }
                                    });

                            } else {
                                vm.importPreview = response;
                            }
                            vm.import_disabled = false;
                        });
                })
            }
        }

        function nextPage() {

            var options = {
                page: vm.currentPage + 1,
                perPage: vm.PerPage,
                media_type: vm.media_type
            };

        }

        function prevPage() {
            var options = {
                page: vm.currentPage - 1,
                perPage: vm.PerPage,
                media_type: vm.media_type,
                searchString: vm.modelSearch
            };
            
        }

        function morePages() {
            if (vm.currentPage <= vm.lastPage) return true;
            return false;
        }

        function firstPage() {
            if (vm.currentPage == 1) return true;
            return false;
        }

        function alreadySelectedbyZone(array, item) {
            var ret = false;
            for (var i = 0, len = array.length; i < len; i++) {
                if (vm.mediazone) {
                    if (array[i]['id_media'] === item.id_media && array[i]['id_zone'] === mediazone.id_zone) {
                        ret = true;
                    }
                } else {
                    if (array[i]['id_media'] === item.id_media) {
                        ret = true;
                    }

                }
            }

            return ret;
        }


        function toogleSelectedbyZone(item) {
            if (!multipleSelection) {
                vm.selectedImages = [];
            }
            for (var i = 0, len = vm.selectedImages.length; i < len; i++) {
                if (vm.selectedImages[i]['id_media'] === item.id_media && vm.selectedImages[i]['id_zone'] === mediazone.id_zone) {
                    vm.selectedImages.splice(i, 1);
                    return;
                }
            }

            vm.selectedImages.push(item);
            return;
        }

        function selectMediaTiny(item) {
            var currentSort = 0;
            var mediaSort = 0;
            for (var i = 0; i < vm.currentThread.length; i++) {
                if (vm.mediazone) {
                    //            		console.log(vm.currentThread[i]['id_zone']);
                    if (vm.currentThread[i]['id_zone'] == 1 && (vm.currentThread[i]['media_type'] == item.media_type)) {
                        currentSort++;
                        if (item.id_media == vm.currentThread[i]['id_media']) {
                            mediaSort = currentSort;
                        }
                    }
                } else {
                    currentSort++;
                    if (item.id_media == vm.currentThread[i]['id_media']) {
                        mediaSort = currentSort;
                    }
                }
            }
            vm.selectedMediaTiny = item;
            vm.tinyProperties.mediaSort = mediaSort;
            vm.tinyProperties.mediaType = item.media_type;
            vm.changeViewTiny('properties');

        }

        function attachMedia() {
            if ($scope.image) {
                $mdDialog.hide($scope.image);
            } else {
                $mdDialog.hide();
            }
        }

        function attachMediaTiny() {
            $mdDialog.hide(vm.tinyProperties);
        }

        /**
         * Toggle selected status of the contact
         *
         * @param contact
         * @param event
         */
        function toggleSelectedImages(photo, event) {
            if (event) {
                event.stopPropagation();
            }


            //         else{
            if (vm.mediazone) {
                photo.id_zone = vm.mediazone.id_zone;
                photo.zone_name = vm.mediazone.zone_name;
            } else {
                photo.id_zone = null;
                photo.zone_name = null;
            }

            toogleSelectedbyZone(photo);

        }

        /**
         * Scroll Media Dialog Content to the top
         * @param speed
         */
        function scrollToTopOfDialog() {     
            $timeout(function () {
                var dialogContent = $document.find('md-dialog-content').filter(function () {
                    return angular.element(this).hasClass('mediadialog-content');
                });
                if (!angular.isUndefined(dialogContent[0])) {
                    dialogContent.animate({
                        scrollTop: dialogContent[0].scrollHeight  
                    }, 1);
                }
            }, 1000);

        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('DialogFormController', DialogFormController);

    /** @ngInject */
    function DialogFormController($mdDialog, $document, usersService, clientsService, sessionService, owner, type, documentsService, positionsIds, idCompany, $filter, $mdMenu, requestContext, Upload, user_type, title, fields, users, $translate, alreadySelected, branchId, storagePrefix, $anchorScroll, $timeout, $scope, $sce, msUtils, COMMON, isTiny, $log, defaultDivision, defaultJob) {

        var vm = this;
        var originatorEv;
        vm.owner = owner;
        vm.type = type;
        sessionService.getQuota().then(function (quota) {
            vm.quota = quota;
        });

        vm.userLogued = sessionService.getUser();
        vm.fields = fields;
        var foundFiles = _.find(vm.fields, function (field) {
            return field.field == 'files';
        });
        vm.files = (foundFiles && foundFiles.value) ? (Array.isArray(foundFiles.value) ? foundFiles.value : [foundFiles.value]) : [];
        vm.emailOriginal = _.find(vm.fields, function (field) {
            if (field.field == 'email') {
                return true
            }
        }).value;
        vm.openMenu = openMenu;
        vm.user_type = user_type;
        vm.positionsIds = positionsIds;

        vm.alreadySelected = [];
        vm.branchId = branchId;
        vm.storagePrefix = storagePrefix;
        vm.deleteAvatar = deleteAvatar;
        vm.noDivisionJobSelected = true;
        vm.jobPositionId = '';
        vm.divisionId = '';
        vm.alreadySelected = alreadySelected;
        vm.indexDivision = null;
        vm.indexPosition = null;
        vm.translate = function (text) {
            return $translate.instant(text);
        }

        for (var i = 0; i < vm.fields.length; i++) {
            if (vm.fields[i].field == 'division') {
                vm.indexDivision = i;
                break;
            }
        }
        for (var i = 0; i < vm.fields.length; i++) {
            if (vm.fields[i].field == 'position') {
                vm.indexPosition = i;
                break;
            }
        }



        var originatorEv;

        function openMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        }

        function deleteAvatar(file) {
            var options = {
                owner: vm.owner,
                id: file.id
            }
            documentsService.deleteDocument(options).then(function () {
                vm.files = [];
            })
        }

        if (defaultDivision) {
            vm.divisionId = defaultDivision;
        }
        if (defaultJob) {
            vm.jobPositionId = defaultJob;
        }



        // Methods
        vm.closeDialog = closeDialog;
        vm.sendForm = sendForm;
        vm.disabledPosition = disabledPosition;
        vm.showSector = showSector;
        vm.selectUser = selectUser;
        vm.showUserImage = showUserImage;
        vm.showSelectPosition = showSelectPosition;
        vm.selectJobDivision = selectJobDivision;
        vm.unSelectJobDivision = unSelectJobDivision;
        vm.divisionJobSelected = divisionJobSelected;
        vm.showJobDivision = showJobDivision;
        vm.isSendDisabled = isSendDisabled;

        init();

        function init() {
            vm.loading = true;
            if (title === 'branch') {
                vm.title = 'GLOBAL.NEW_BRANCH';
            } else if (title === 'administrator') {
                vm.title = 'GLOBAL.ADMINISTRATOR';
            } else if (title === 'managerLegal') {
                vm.title = 'GLOBAL.LEGAL_MANAGER';
            } else if (title === 'personnel' && defaultJob == "") {
                vm.title = 'GLOBAL.BRANCH_PERSONNEL';
            } else if (title === 'personnel' && defaultJob == 3) {
                vm.title = 'GLOBAL.COMPLIANCE_OFFICER';
            } else if (title === 'personnel' && defaultJob == 4) {
                vm.title = 'GLOBAL.REPORT_COMMITTEE';
            } else if (title === 'personnel' && defaultJob == 5) {
                vm.title = 'GLOBAL.DELEGATE_DATA_PROTECCTION';
            } else if (title === 'personnel' && defaultJob == 2) {
                vm.title = 'GLOBAL.ADMINISTRATOR';
            } else if (title === 'personnel' && defaultJob == 1) {
                vm.title = 'GLOBAL.LEGAL_MANAGER';
            }
            getUsersByCompany(idCompany)
            getUsersAdministrators()
        }


        function getUsersByCompany(idCompany) {
            var options = {
                owner: vm.owner,
                inCompany: idCompany,
                resultsPerPage: 500
            };
            clientsService.getUsers(options).then(function (response) {
                vm.users = response.data;
            })
        }
        function getUsersAdministrators() {
            var options = {
                owner: vm.owner,
                resultsPerPage: 100
            };
            usersService.getUsers(options).then(function (response) {
                vm.usersAll = response.data;
            })
        }


        function closeDialog() {
            $mdDialog.hide();
        }
        function isSendDisabled() {
            for (var i = 0; i < vm.fields.length; i++) {
                const element = vm.fields[i];
                if (element.required && !element.value) {
                    return true;
                }
            }
            return false;
        }

        function checkUploadsAndUpdateUser() {
            var noUpdate = false;
            if (vm.files) {
                angular.forEach(vm.files, function (file) {
                    if (angular.isUndefined(file.progress) || file.progress < 100) {
                        noUpdate = true;
                    }
                })
                if (!noUpdate && !$scope.uploadingFile) {
                    initState()
                    vm.loadingReadPane = false;
                    $rootScope.pagination_resetquery();
                } else {
                    $timeout(function () {
                        vm.checkUploadsAndUpdateUser();
                    }, 1000)
                }
            } else {
                initState()
                vm.loadingReadPane = false;
                $rootScope.pagination_resetquery();

            }
        }

        function sendForm(ev) {
            for (var i = 0; i < vm.fields.length; i++) {
                if (vm.fields[i].field === 'position' && !vm.fields[i].value) {
                    vm.fields[i].value = vm.jobPositionId;
                }
                else if (vm.fields[i].field === 'division' && !vm.fields[i].value) {
                    vm.fields[i].value = vm.divisionId;
                } else if (vm.fields[i].field === 'email' && vm.fields[i].value == '') {
                    delete vm.fields[i].value;
                }
            }
            if (((vm.positionsIds.compliance_officer == vm.jobPositionId
                || vm.positionsIds.compliance_comite == vm.jobPositionId
                || vm.positionsIds.data_protection == vm.jobPositionId)
                && vm.quota.users_registered >= vm.quota.max_allowed_users)
            ) {
                $mdDialog.show({
                    controller: 'UserQuotaDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/dialogs/userQuotaDialog/userQuotaDialog.html',
                    preserveScope: true,
                    autoWrap: true,
                    quota: null,
                    multiple: true,
                    locals: {
                        user: vm.userLogued,
                        quota: vm.quota,
                        quotaComplaint: null
                    }
                }).then(function (res) {
                    if (res && res.type) {
                        if (res.type == 'upgrade') {
                            console.log("go upgrade screen");
                        } else {
                            createUser(true);
                        }
                    }
                });
            } else {
                createUser();
            }



        }

        function createUser(quotaexceded) {


            var email = _.find(vm.fields, function (field) {
                if (field.field == 'email') {
                    return true
                }
            }).value;

            if (vm.emailOriginal === email) {
                vm.fields.files = vm.files;
                $mdDialog.hide({ fields: vm.fields, quotaexceded: quotaexceded });
                return
            }
            var options = {
                owner: vm.owner,
                searchStringFilter: email
            };
            usersService.getUsersWithTrashed(options).then(function (response) {

                var existedUser = _.find(response.data, function (user) {
                    if (user.email == email && (!vm.userSelected || user.id !== vm.userSelected.id)) {
                        return true;
                    }
                });

                if (!existedUser) {
                    vm.fields.files = vm.files;
                    $mdDialog.hide({ fields: vm.fields, quotaexceded: quotaexceded });
                } else {
                    alert = $mdDialog.alert({
                        title: vm.translate('GLOBAL.ATTENTION'),
                        textContent: vm.translate('GLOBAL.USER_ALREADY_EXISTS'),
                        ok: vm.translate('GLOBAL.CLOSE'),
                    }).multiple(true);

                    $mdDialog
                        .show(alert)
                        .finally(function () {
                            alert = undefined;
                        });
                }
            })





        }

        function disabledPosition(field) {
            var idAdmin;
            var idManagerLegal;
            var idComplaints;
            var idReport;
            for (var i = 0; i < field.options.length; i++) {
                if (field.options[i].field === 'ADMINISTRADOR') {
                    idAdmin = field.options[i].id;
                } else if (field.options[i].field === 'REPRESENTANTE LEGAL') {
                    idManagerLegal = field.options[i].id
                } else if (field.options[i].field === 'Complaints committee') {
                    idComplaints = field.options[i].id
                } else if (field.options[i].field === 'Reports committee') {
                    idReport = field.options[i].id
                }
            }

            if (vm.title === 'managerLegal') {
                field.value = idManagerLegal;
                return true;
            } else if (vm.title === 'administrator') {
                field.value = idAdmin;
                return true;
            } else if (vm.title === 'compliance') {
                field.value = idComplaints;
                return true;
            } else if (vm.title === 'report') {
                field.value = idReport;
                return true;
            }
        }

        function showSector() {
            if (title === 'personnel') {
                return true;
            }
        }

        function selectUser(user) {
            for (var i = 0; i < vm.fields.length; i++) {
                if (vm.fields[i].field === 'first_name') {
                    vm.fields[i].value = user.first_name
                } else if (vm.fields[i].field === 'last_name') {
                    vm.fields[i].value = user.last_name;
                } else if (vm.fields[i].field === 'email') {
                    vm.fields[i].value = user.email;
                } else if (vm.fields[i].field === 'nif') {
                    vm.fields[i].value = user.id_number;
                } else if (vm.fields[i].field === 'position') {
                    vm.fields[i].value = vm.jobPositionId;
                } else if (vm.fields[i].field === 'division') {
                    vm.fields[i].value = vm.divisionId;
                } else if (vm.fields[i].field === 'profile_color') {
                    vm.fields[i].value = user.profile_color;
                } else if (vm.fields[i].field === 'user_type') {
                    vm.fields[i].value = user.user_type;
                }
            }

            vm.fields.push({ field: 'id', value: user.id });
            vm.fields.push({ field: 'files', value: user.files });
            if (vm.quota.users_registered >= vm.quota.max_allowed_users && (user.user_type > 3)) {
                $mdDialog.show({
                    controller: 'UserQuotaDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/dialogs/userQuotaDialog/userQuotaDialog.html',
                    preserveScope: true,
                    autoWrap: true,
                    multiple: true,
                    locals: {
                        user: vm.userLogued,
                        quota: vm.quota,
                        quotaComplaint: null
                    }
                }).then(function (res) {
                    if (res && res.type) {
                        if (res.type == 'upgrade') {
                            console.log("go upgrade screen");
                        } else {
                            $mdDialog.hide({ fields: vm.fields, existUser: true, quotaexceded: vm.quota.users_registered >= vm.quota.max_allowed_users });
                        }
                    }
                });
            } else {
                $mdDialog.hide({ fields: vm.fields, existUser: true, quotaexceded: vm.quota.users_registered >= vm.quota.max_allowed_users });
            }

        }

        $scope.filterAlreadyAdded = function (item) {
            if (vm.fields[vm.indexDivision].value && vm.fields[vm.indexPosition].value) {
                var found = $filter('filter')(vm.alreadySelected, { id: item.id, position: vm.fields[vm.indexPosition].value, division: vm.fields[vm.indexDivision].value });
                return found.length == 0;;
            } else {
                var found = _.find(vm.alreadySelected, function (_item) { return _item.id == item.id });
                return !found;
            }
        };

        function showUserImage(user) {
            return vm.storagePrefix + user.files.url
        }

        function showSelectPosition() {
            if (vm.branchId && vm.noDivisionJobSelected) {
                return true;
            }
            return false;
        }

        function selectJobDivision() {
            vm.noDivisionJobSelected = false;
        }

        function divisionJobSelected() {
            var ret1 = false;
            var ret2 = false;
            for (var i = 0; i < vm.fields.length; i++) {
                if (vm.fields[i].field === 'position' && vm.fields[i].value) {
                    vm.jobPositionId = vm.fields[i].value;
                    ret1 = true;
                }
                if (vm.fields[i].field === 'division' && vm.fields[i].value) {
                    vm.divisionId = vm.fields[i].value;
                    ret2 = true;
                }
            }

            return (!ret1 || !ret2);
        }

        function unSelectJobDivision() {
            vm.noDivisionJobSelected = true;
        }

        function showJobDivision() {
            if (vm.branchId) {
                return true;
            }
            return false;
        }

    }
})();
(function () {
	'use strict';

	angular
		.module('app.clients')
		.controller('ImageDialogClientsController', ImageDialogClientsController);

	/** @ngInject */
	function ImageDialogClientsController($mdDialog, sessionService, Images, ImageSelected, $document, cropFormats, MediaFull)
	{
		var vm = this;

		vm.views = {
			fotorama: 'app/main/apps/clients/dialogs/image/views/fotorama-view.html',
			editmedia: 'app/main/apps/clients/dialogs/image/views/edit-media-view.html',
		};
		vm.defaultView = 'fotorama';
		vm.currentView = 'fotorama';

		// Data
		vm.title = 'View Media';
		vm.images = [];
		vm.dataImages = [];

		// Methods
		vm.closeDialog = closeDialog;
		vm.changeView = changeView;
		vm.edit = edit;

		// //////////

		/**
		 * Close dialog
		 */
		function closeDialog()
		{
			/*var $fotoramaDiv = $('#fotorama').fotorama();
			var fotorama = $fotoramaDiv.data('fotorama');
			fotorama.destroy();*/
			$mdDialog.hide();
		}

		init();

		function init()
		{

			vm.dataFotorama = [];
			var fotoramaDiv = angular.element(".testingelement");

			var fit = (cropFormats) ? 'scaledown' : 'contain';
			vm.fotoramaoptions = {
				width: '100%',
				height: '80%',
				captions: true,
				loop: true,
				keyboard: true,
				allowfullscreen: true,
				nav: 'thumbs',
				ratio: 16 / 9,
				fit: fit,
			};

			if (!cropFormats) {
				if (!_.isArray(Images)) {
					var ImagesArray = [];
					ImagesArray.push(Images);
					Images = ImagesArray;
				}


				for (var i = 0; i < Images.length; i++) {

					var attachment = Images[i];
					var imagesCrops = [];

					for (var iCrop = 0; iCrop < Images[i].cropstatus.length; iCrop++) {
						var imageCrop = Images[i].cropstatus[iCrop];
						imagesCrops.push(Images[i].cropstatus[iCrop]);
					}

					if (ImageSelected) {
						var selected = (Images[i].id_media === ImageSelected.id_media) ? true : false;
					} else {
						var selected = false;
					}

					if (Images[i].media_type !== 1) {
						// continue;
					}

					// .container.view_url}}{{image.cropstatus[0].fileName

					if (attachment.media_type == 1) {

						if (MediaFull) {
							var cropstatus = _.find(Images[i].cropstatus, {
								'id_cropformats': sessionService.getMediaThumbnailCropformatId()
							});

							var cropstatus = _.find(Images[i].cropstatus, {
								'id_cropformats': sessionService.getMediaFullCropformatId()
							});
							var urlImage = cropstatus.container.view_url + cropstatus.fileName;
							vm.dataFotorama.push({
								imageUrl: urlImage,
								thumb: urlImage,
								dataCaption: '#' + attachment.id_media + ' | ' + urlImage,
								html: '<div>123</div>',
								selected: selected
							})
						} else {
							var cropstatus = _.find(attachment.cropstatus, {
								'id_cropformats': sessionService.getMediaFullCropformatId()
							});

							if(!cropstatus){
								var urlImage = attachment.container.view_url + 'original/m' + attachment.id_media + '_' + attachment.filename;
							}else{
								var urlImage = cropstatus.container.view_url + cropstatus.fileName;
							}
								vm.dataFotorama.push({
									imageUrl: urlImage,
									thumb: urlImage,
									dataCaption: '#' + attachment.id_media + ' | ' + urlImage,
									html: '<div>123</div>',
									selected: selected
								})
						}
					}

					if (attachment.media_type == 2) {
						var videoUrl = '';
						if (!attachment.embed) {
							videoUrl = attachment.container.view_url + 'videos/m' + attachment.id_media + '_' + attachment.filename;
						} else {
							if (attachment.embed.indexOf('yt|') !== -1) {
								var YT_VideoSource = attachment.embed.split('yt|')[1];
								videoUrl = 'http://youtube.com/' + YT_VideoSource;
							} else if (attachment.embed.indexOf('fb|') !== -1) {
								var embed_url = angular.element(attachment.embed_url);
								videoUrl = embed_url.attr('src');
							}
						}

						vm.dataFotorama.push({
							imageUrl: attachment.embed_thumb,
							thumb: attachment.embed_thumb,
							full: attachment.embed_thumb, // Separate image for the fullscreen mode.
							video: videoUrl, // Youtube, Vimeo or custom iframe URL
							id: 'one', // Custom anchor is used with the hash:true option.
							caption: 'The first caption',
							html: '<div>123</div>',
							// html: $('selector'), // ...or '<div>123</div>'. Custom HTML inside the frame.
							fit: 'cover', // Override the global fit option.
							any: 'Any data relative to the frame you want to store',
							selected: selected
						})
					}
				}
				// }else{
				// 	var cropstatus = _.find( Images.cropstatus, {'id_cropformats': sessionService.getMediaThumbnailCropformatId()});
				// 	if(MediaFull){
				// 		var cropstatus = _.find( Images.cropstatus, {'id_cropformats': sessionService.getMediaFullCropformatId()});
				// 		var urlImage = cropstatus.container.view_url + cropstatus.fileName;
				// 	}else{
				//       				var urlImage = cropstatus.container.view_url + 'original/m' + Images.id_media + '_' + Images.filename;
				//       			}
				// 	vm.dataFotorama.push({
				// 					 imageUrl: urlImage,
				// 					 thumb: urlImage,
				// 					 dataCaption: '#' + Images.id_media + ' | ' + Images.filename,
				// 					 html: '<div>123</div>',
				// 					 selected: selected
				// 				 })
				// }
			} else {

				for (var i = 0; i < Images.length; i++) {
					
					var selected = (Images[i].id_cropformats === ImageSelected.id_cropformats && Images[i].container.id_container === ImageSelected.container.id_container) ? true : false;


					if (Images[i].container.use_grid === 1) {
						var urlImage = Images[i].container.view_url + Images[i].grid + '/' + Images[i].fileName;
					} else {
						var urlImage = Images[i].container.view_url + Images[i].fileName;
					}
					vm.dataFotorama.push({
						imageUrl: urlImage,
						thumb: urlImage,
						dataCaption: 'aa#' + Images[i].id_cropformats + ' | ' + urlImage,
						html: '<div>123</div>',
						selected: selected
					})
				}
			}

			// $fotoramaDiv.data({
			// 	data: vm.dataFotorama
			// });

		}

		function changeView(view) {
			if (vm.views[view]) {
				vm.loadingView = true;
				vm.showSearchAndPaginator = false;
				vm.defaultView = view;
				vm.currentView = view;
			}
		}


		function edit() {
			var $fotoramaDiv = angular.element("#fotorama1");
		}

	}
})();



(function () {
    'use strict';

    angular
        .module('app.clients')
        .constant('_', window._)
        .controller('EditBranchDialog', EditBranchDialog);

    /** @ngInject */
    function EditBranchDialog($scope, $mdDialog, $translate, region_id, clientsService, tinyMceService, branch, $mdToast) {
        var vm = this;
        vm.region_id = region_id;
        vm.branch = angular.copy(branch);
        vm.tinymceOptions = tinyMceService.getOptions($scope);
        vm.tinymceOptions.height = 100;
        vm.saveDialog = saveDialog;
        vm.closeDialog = closeDialog;
        vm.getRegionLiteral = getRegionLiteral;
        clientsService.getFileRegions().then(function (res) {
            vm.regionsLiterals = res;
        })
        function saveDialog() {

            $mdDialog.hide(vm.branch);

        }
        function getRegionLiteral(literalKey) {
            if (vm.region_id && vm.regionsLiterals) {
                const literalsObject = vm.regionsLiterals.find(x => x.region_id === vm.region_id)
                return literalsObject.literals[literalKey];
            } else {
                return '';
            }
        }



        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('MediaClientsController', MediaClientsController);

    /** @ngInject */
    function MediaClientsController($mdDialog,$stateParams, $document, mediaService, owner, requestContext, $anchorScroll, $timeout, $scope, $sce, Upload, multipleSelection, msUtils, COMMON, isTiny, $log) {
        var vm = this;

        // Data
        vm.owner = owner;
        $scope.owner = $stateParams.owner;

        vm.defaultPage = 1;
        vm.defaultPerPage = 50;
        vm.PerPage = 50;
        vm.searchStringFilter = '';
        vm.searchQuery = '';
        vm.modelSearch = '';
        vm.pagination_search = pagination_search;

        vm.isTiny = isTiny;

        vm.views = {
            1: 'app/main/apps/clients/dialogs/media/views/photos-view.html',
            2: 'app/main/apps/clients/dialogs/media/views/videos-view.html',
            3: 'app/main/apps/clients/dialogs/media/views/files-view.html',
            4: 'app/main/apps/clients/dialogs/media/views/audios-view.html',
            upload: 'app/main/apps/clients/dialogs/media/views/upload-view.html',
            import: 'app/main/apps/clients/dialogs/media/views/import-view.html',
        };
        vm.defaultView = 'upload';
        vm.currentView = 'upload';

        vm.viewsTiny = {
            1: 'app/main/apps/clients/dialogs/media/views/tiny-attached.html',
            properties: 'app/main/apps/clients/dialogs/media/views/tiny-properties.html',
            upload: 'app/main/apps/clients/dialogs/media/views/upload-view.html',
        };
        vm.defaultViewTiny = '1';
        vm.currentViewTiny = '1';

        vm.firstLoad = true;
        vm.media_type = '1';
        vm.showSearchAndPaginator = true;
        vm.import_field = '';
        vm.import_disabled = '';
        vm.importedFiles = [];
        vm.importPreview = false;
        vm.imported = false;
        vm.importing = false;
        vm.selectedImages = [];
        vm.files = [];
        vm.tinyProperties = {
            mediaType: '',
            mediaSort: '',
            mediaData: {},
            align: '',
            size: ''
        };
        vm.tinyOptions = {
            size: [
                { value: 25, text: '25%' },
                { value: 50, text: '50%' },
                { value: 75, text: '75%' },
                { value: 100, text: '100%' }
            ],
            align: [
                { value: 'left', text: 'left' },
                { value: 'center', text: 'center' },
                { value: 'right', text: 'right' }
            ]
        }

        // If replying
        // if (angular.isDefined(selectedMail)) {
        // 	vm.form.to = selectedMail.from.email;
        // 	vm.form.subject = 'RE: ' + selectedMail.subject;
        // 	vm.form.message = '<blockquote>' + selectedMail.message + '</blockquote>';
        // }

        // Methods
        vm.closeDialog = closeDialog;
        vm.changeView = changeView;
        vm.changeViewTiny = changeViewTiny;

        vm.nextPage = nextPage;
        vm.prevPage = prevPage;
        vm.morePages = morePages;
        vm.firstPage = firstPage;
        vm.upload = upload;
        vm.attachMedia = attachMedia;
        vm.attachMediaTiny = attachMediaTiny;
        vm.selectMediaTiny = selectMediaTiny;
        vm.selectedMediaTiny = '';
        vm.search = search;

        vm.exists = msUtils.exists;
        vm.alreadySelectedbyZone = alreadySelectedbyZone;
        vm.existInArray = msUtils.existInArray;
        vm.toggleSelectedImages = toggleSelectedImages;


        //////////

        if (!isTiny) {
            init();
        } else {
            vm.section = section;
            initTiny();
        }
        /**
         * Initialize
         */
        function init() {

            vm.loading = true;
        }

        /**
         * Initialize Tinymce
         */
        function initTiny() {
            vm.currentViewTiny = vm.defaultViewTiny;
            vm.showSearchAndPaginator = false;
            vm.loading = true;
            for (var i = 0; i < vm.currentThread.length; i++) {
                if (vm.mediazone) {
                    if (vm.currentThread[i].id_zone == 1) {
                        vm.selectedImages.push(vm.currentThread[i]);
                    }
                } else {
                    vm.selectedImages.push(vm.currentThread[i]);
                }
            }
            if (vm.section.mediaSort) {
                var currentSort = 0;
                var currentItem = '';
                for (var i = 0; i < vm.currentThread.length; i++) {
                    if (vm.mediazone) {
                        if (vm.currentThread[i]['id_zone'] == 1 && (vm.currentThread[i]['media_type'] == vm.section.mediaType)) {
                            currentSort++;
                            if (currentSort = vm.section.mediaSort) {
                                currentItem = vm.currentThread[i];
                            }
                        }
                    } else {
                        if (vm.currentThread[i]['media_type'] == vm.section.mediaType) {
                            currentSort++;
                            if (currentSort = vm.section.mediaSort) {
                                currentItem = vm.currentThread[i];
                            }
                        }

                    }
                }

                vm.selectedMediaTiny = currentItem;
                vm.tinyProperties.mediaSort = vm.section.mediaSort;
                vm.tinyProperties.mediaType = currentItem.media_type;
                vm.tinyProperties.align = vm.section.mediaAlign;
                vm.tinyProperties.size = vm.section.mediaSize;
                vm.changeViewTiny('properties');


            }
            vm.loading = false;

        }

        function pagination_search(searchString) {
            var options = {
                section: section,
                media_type: vm.media_type,
                page: vm.defaultPage,
                perPage: vm.defaultPerPage,
                searchString: searchString
            };
        }


        function search(options) {
            // console.log(options, vm.searchStringFilter);
            /*

			vm.loading 		= true;
			vm.items		=[];
			// Scroll to the top Dialog
            scrollToTopOfDialog();

			mediaService.get({
				siteID: siteID,
				page: options.page,
				paginate: options.perPage,
				media_type: options.media_type,
                withCropStatus: true,
                sortField: 'date_uploaded',
                searchStringFilter: options.searchString,

			})
				.then(function (response) {
					vm.totalItems = response.total;
					vm.pagination_totalItems = response.total;
					vm.from = response.from;
					vm.pagination_from = response.from;
					vm.to = response.to;
					vm.pagination_to = response.to;
					vm.currentPage = response.current_page;
					vm.lastPage = response.last_page;
					vm.maxSize = 500;
					vm.bigTotalItems = 175;

					vm.loading = false;

                    vm.items = angular.copy(response.data);

                    $('.md-button')
                        .removeClass('active');
                    $('[type=' + options.media_type + ']')
						.addClass('active');

				});




			vm.firstLoad = false;
*/
        }

        function closeDialog() {
            $mdDialog.hide(vm.currentThread);
        }

        function changeView(view) {

            //console.log(view)
            if (vm.views[view]) {
                vm.items = [];
                vm.loadingView = true;
                vm.showSearchAndPaginator = false;
                vm.defaultView = view;
                vm.currentView = view;


                vm.media_type = view;

                var options = {
                    page: 1,
                    perPage: vm.PerPage,
                    media_type: view,

                };
                if (view == 1 || view == 2 || view == 3 || view == 4) {
                    vm.showSearchAndPaginator = true;
                }

            }

        }

        function changeViewTiny(view) {


            if (vm.viewsTiny[view]) {
                vm.items = [];
                vm.loadingView = true;
                vm.showSearchAndPaginator = false;
                vm.defaultViewTiny = view;
                vm.currentViewTiny = view;
            }

        }

        $scope.file_changed = function (element) {

            $scope.$apply(function (scope) {
                var photofile = element.files[0];
                console.log(photofile);
                $mdDialog.hide(photofile);
                //vm.upload(photofile);
                var reader = new FileReader();
                reader.onload = function (e) {
                    // handle onload
                };
                reader.readAsDataURL(photofile);
                $scope.image = photofile;
            });
        };

        $scope.$watch('vm.files', function () {
            console.debug("WATCH!!:::!:!:!:!: ")
            $scope.formUpload = false;
            if (vm.files != null) {
                // make files array for not multiple to be able to be used in ng-repeat in the ui
                if (!angular.isArray(vm.files)) {
                    $timeout(function () {
                        $scope.files = vm.files = [vm.files];
                    });
                    return;
                }
                for (var i = 0; i < vm.files.length; i++) {
                    $scope.errorMsg = null;
                    (function (f) {
                        //vm.upload(f, true);
                        $mdDialog.hide(f);
                    })(vm.files[i]);
                }
            }
        });

        $scope.$watch('vm.import_field', function () {
            vm.importConfirm(false);
        });


        $scope.log = '';

        function upload(file) {
            if (!file.$error) {
                var token = undefined;
                console.debug("UPLOAD______****", file)
                mediaService.getS3UploadPreSignedUrl({
                    owner: $scope.owner,
                    uploadKey: 'company_logo',
                    fileName: file.name,
                    rowId: 1
                })
                    .then(function (resp) {
                        token = resp.token;
                        file.id_media = resp.id_media;
                        file.upload = Upload.http({
                            url: resp.url,
                            skipAuthorization: true,
                            method: 'PUT',
                            headers: {
                                "Content-Type": file.type != '' ? file.type : 'application/octet-stream' 
                            },
                            data: file
                        });

                        file.upload.then(function (response) {
                            file.result = response.data;
                            $timeout(function () {
                                $scope.log = 'file: ' +
                                    file.name +
                                    ', Response: ' + JSON.stringify(response.data) +
                                    ', ID: ' + file.id_media +
                                    '\n' + $scope.log;
                            });
                            console.debug("SEND_TO_CROP______****", file)
                            mediaService.finishedUploadingFileToCdn({
                                owner: vm.owner,
                                idMedia: file.id_media,
                                token: token
                            })
                            $mdDialog.hide(vm.files[0]);


                        }, function (response) {
                            if (response.status > 0)
                                $scope.errorMsg = response.status + ': ' + response.data;
                        });

                        file.upload.progress(function (evt) {
                            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                        });

                    })
            }
        };

        vm.importConfirm = function (confirm) {
            vm.import_disabled = false;
            vm.imported = false;
            if (!confirm) {
                vm.importPreview = false;
            }
            if (vm.import_field.length > 10) {
                vm.importing = true;
                vm.import_disabled = true;

                $timeout(function () {
                    var pastedUrl = vm.import_field;
                    mediaService.importFromUrl({
                        siteID: siteID,
                        url: pastedUrl,
                        execute: confirm
                    })
                        .then(function (response) {
                            vm.importing = false;
                            response.embedCodeSafe = $sce.trustAsHtml(response.metadata.embedCode);
                            if (response.id_media) {
                                vm.imported = true;
                                vm.importPreview = false;
                                mediaService.get({
                                    siteID: siteID,
                                    withCropStatus: true,
                                    idMedia: response.id_media
                                })
                                    .then(function (response) {
                                        if (response.total == 1) {
                                            var photo = response.data[0];
                                            vm.importedFiles.push(photo);
                                            toggleSelectedImages(photo);
                                        }
                                    });

                            } else {
                                vm.importPreview = response;
                            }
                            vm.import_disabled = false;
                        });
                })
            }
        }

        function nextPage() {

            var options = {
                page: vm.currentPage + 1,
                perPage: vm.PerPage,
                media_type: vm.media_type
            };

        }

        function prevPage() {
            var options = {
                page: vm.currentPage - 1,
                perPage: vm.PerPage,
                media_type: vm.media_type,
                searchString: vm.modelSearch
            };
            
        }

        function morePages() {
            if (vm.currentPage <= vm.lastPage) return true;
            return false;
        }

        function firstPage() {
            if (vm.currentPage == 1) return true;
            return false;
        }

        function alreadySelectedbyZone(array, item) {
            var ret = false;
            for (var i = 0, len = array.length; i < len; i++) {
                if (vm.mediazone) {
                    if (array[i]['id_media'] === item.id_media && array[i]['id_zone'] === mediazone.id_zone) {
                        ret = true;
                    }
                } else {
                    if (array[i]['id_media'] === item.id_media) {
                        ret = true;
                    }

                }
            }

            return ret;
        }


        function toogleSelectedbyZone(item) {
            if (!multipleSelection) {
                vm.selectedImages = [];
            }
            for (var i = 0, len = vm.selectedImages.length; i < len; i++) {
                if (vm.selectedImages[i]['id_media'] === item.id_media && vm.selectedImages[i]['id_zone'] === mediazone.id_zone) {
                    vm.selectedImages.splice(i, 1);
                    return;
                }
            }

            vm.selectedImages.push(item);
            return;
        }

        function selectMediaTiny(item) {
            var currentSort = 0;
            var mediaSort = 0;
            for (var i = 0; i < vm.currentThread.length; i++) {
                if (vm.mediazone) {
                    //            		console.log(vm.currentThread[i]['id_zone']);
                    if (vm.currentThread[i]['id_zone'] == 1 && (vm.currentThread[i]['media_type'] == item.media_type)) {
                        currentSort++;
                        if (item.id_media == vm.currentThread[i]['id_media']) {
                            mediaSort = currentSort;
                        }
                    }
                } else {
                    currentSort++;
                    if (item.id_media == vm.currentThread[i]['id_media']) {
                        mediaSort = currentSort;
                    }
                }
            }
            vm.selectedMediaTiny = item;
            vm.tinyProperties.mediaSort = mediaSort;
            vm.tinyProperties.mediaType = item.media_type;
            vm.changeViewTiny('properties');

        }

        function attachMedia() {
            if ($scope.image) {
                $mdDialog.hide($scope.image);
            } else {
                $mdDialog.hide();
            }
        }

        function attachMediaTiny() {
            $mdDialog.hide(vm.tinyProperties);
        }

        /**
         * Toggle selected status of the contact
         *
         * @param contact
         * @param event
         */
        function toggleSelectedImages(photo, event) {
            if (event) {
                event.stopPropagation();
            }


            //         else{
            if (vm.mediazone) {
                photo.id_zone = vm.mediazone.id_zone;
                photo.zone_name = vm.mediazone.zone_name;
            } else {
                photo.id_zone = null;
                photo.zone_name = null;
            }

            toogleSelectedbyZone(photo);

        }

        /**
         * Scroll Media Dialog Content to the top
         * @param speed
         */
        function scrollToTopOfDialog() {     
            $timeout(function () {
                var dialogContent = $document.find('md-dialog-content').filter(function () {
                    return angular.element(this).hasClass('mediadialog-content');
                });
                if (!angular.isUndefined(dialogContent[0])) {
                    dialogContent.animate({
                        scrollTop: dialogContent[0].scrollHeight  
                    }, 1);
                }
            }, 1000);

        }
    }
})();
(function () {
	'use strict';

	angular
		.module('app.clients')
		.controller('ImageDialogClientsController', ImageDialogClientsController);

	/** @ngInject */
	function ImageDialogClientsController($mdDialog, sessionService, Images, ImageSelected, $document, cropFormats, MediaFull)
	{
		var vm = this;

		vm.views = {
			fotorama: 'app/main/apps/clients/dialogs/image/views/fotorama-view.html',
			editmedia: 'app/main/apps/clients/dialogs/image/views/edit-media-view.html',
		};
		vm.defaultView = 'fotorama';
		vm.currentView = 'fotorama';

		// Data
		vm.title = 'View Media';
		vm.images = [];
		vm.dataImages = [];

		// Methods
		vm.closeDialog = closeDialog;
		vm.changeView = changeView;
		vm.edit = edit;

		// //////////

		/**
		 * Close dialog
		 */
		function closeDialog()
		{
			/*var $fotoramaDiv = $('#fotorama').fotorama();
			var fotorama = $fotoramaDiv.data('fotorama');
			fotorama.destroy();*/
			$mdDialog.hide();
		}

		init();

		function init()
		{

			vm.dataFotorama = [];
			var fotoramaDiv = angular.element(".testingelement");

			var fit = (cropFormats) ? 'scaledown' : 'contain';
			vm.fotoramaoptions = {
				width: '100%',
				height: '80%',
				captions: true,
				loop: true,
				keyboard: true,
				allowfullscreen: true,
				nav: 'thumbs',
				ratio: 16 / 9,
				fit: fit,
			};

			if (!cropFormats) {
				if (!_.isArray(Images)) {
					var ImagesArray = [];
					ImagesArray.push(Images);
					Images = ImagesArray;
				}


				for (var i = 0; i < Images.length; i++) {

					var attachment = Images[i];
					var imagesCrops = [];

					for (var iCrop = 0; iCrop < Images[i].cropstatus.length; iCrop++) {
						var imageCrop = Images[i].cropstatus[iCrop];
						imagesCrops.push(Images[i].cropstatus[iCrop]);
					}

					if (ImageSelected) {
						var selected = (Images[i].id_media === ImageSelected.id_media) ? true : false;
					} else {
						var selected = false;
					}

					if (Images[i].media_type !== 1) {
						// continue;
					}

					// .container.view_url}}{{image.cropstatus[0].fileName

					if (attachment.media_type == 1) {

						if (MediaFull) {
							var cropstatus = _.find(Images[i].cropstatus, {
								'id_cropformats': sessionService.getMediaThumbnailCropformatId()
							});

							var cropstatus = _.find(Images[i].cropstatus, {
								'id_cropformats': sessionService.getMediaFullCropformatId()
							});
							var urlImage = cropstatus.container.view_url + cropstatus.fileName;
							vm.dataFotorama.push({
								imageUrl: urlImage,
								thumb: urlImage,
								dataCaption: '#' + attachment.id_media + ' | ' + urlImage,
								html: '<div>123</div>',
								selected: selected
							})
						} else {
							var cropstatus = _.find(attachment.cropstatus, {
								'id_cropformats': sessionService.getMediaFullCropformatId()
							});

							if(!cropstatus){
								var urlImage = attachment.container.view_url + 'original/m' + attachment.id_media + '_' + attachment.filename;
							}else{
								var urlImage = cropstatus.container.view_url + cropstatus.fileName;
							}
								vm.dataFotorama.push({
									imageUrl: urlImage,
									thumb: urlImage,
									dataCaption: '#' + attachment.id_media + ' | ' + urlImage,
									html: '<div>123</div>',
									selected: selected
								})
						}
					}

					if (attachment.media_type == 2) {
						var videoUrl = '';
						if (!attachment.embed) {
							videoUrl = attachment.container.view_url + 'videos/m' + attachment.id_media + '_' + attachment.filename;
						} else {
							if (attachment.embed.indexOf('yt|') !== -1) {
								var YT_VideoSource = attachment.embed.split('yt|')[1];
								videoUrl = 'http://youtube.com/' + YT_VideoSource;
							} else if (attachment.embed.indexOf('fb|') !== -1) {
								var embed_url = angular.element(attachment.embed_url);
								videoUrl = embed_url.attr('src');
							}
						}

						vm.dataFotorama.push({
							imageUrl: attachment.embed_thumb,
							thumb: attachment.embed_thumb,
							full: attachment.embed_thumb, // Separate image for the fullscreen mode.
							video: videoUrl, // Youtube, Vimeo or custom iframe URL
							id: 'one', // Custom anchor is used with the hash:true option.
							caption: 'The first caption',
							html: '<div>123</div>',
							// html: $('selector'), // ...or '<div>123</div>'. Custom HTML inside the frame.
							fit: 'cover', // Override the global fit option.
							any: 'Any data relative to the frame you want to store',
							selected: selected
						})
					}
				}
				// }else{
				// 	var cropstatus = _.find( Images.cropstatus, {'id_cropformats': sessionService.getMediaThumbnailCropformatId()});
				// 	if(MediaFull){
				// 		var cropstatus = _.find( Images.cropstatus, {'id_cropformats': sessionService.getMediaFullCropformatId()});
				// 		var urlImage = cropstatus.container.view_url + cropstatus.fileName;
				// 	}else{
				//       				var urlImage = cropstatus.container.view_url + 'original/m' + Images.id_media + '_' + Images.filename;
				//       			}
				// 	vm.dataFotorama.push({
				// 					 imageUrl: urlImage,
				// 					 thumb: urlImage,
				// 					 dataCaption: '#' + Images.id_media + ' | ' + Images.filename,
				// 					 html: '<div>123</div>',
				// 					 selected: selected
				// 				 })
				// }
			} else {

				for (var i = 0; i < Images.length; i++) {
					
					var selected = (Images[i].id_cropformats === ImageSelected.id_cropformats && Images[i].container.id_container === ImageSelected.container.id_container) ? true : false;


					if (Images[i].container.use_grid === 1) {
						var urlImage = Images[i].container.view_url + Images[i].grid + '/' + Images[i].fileName;
					} else {
						var urlImage = Images[i].container.view_url + Images[i].fileName;
					}
					vm.dataFotorama.push({
						imageUrl: urlImage,
						thumb: urlImage,
						dataCaption: 'aa#' + Images[i].id_cropformats + ' | ' + urlImage,
						html: '<div>123</div>',
						selected: selected
					})
				}
			}

			// $fotoramaDiv.data({
			// 	data: vm.dataFotorama
			// });

		}

		function changeView(view) {
			if (vm.views[view]) {
				vm.loadingView = true;
				vm.showSearchAndPaginator = false;
				vm.defaultView = view;
				vm.currentView = view;
			}
		}


		function edit() {
			var $fotoramaDiv = angular.element("#fotorama1");
		}

	}
})();

(function() {
    'use strict';

    angular
        .module('app.clients')
        .controller('DialogFormController', DialogFormController);

    /** @ngInject */
    function DialogFormController($mdDialog, $document, requestContext,title, fields, users, $anchorScroll, $timeout, $scope, $sce, msUtils, COMMON, isTiny, $log) {

        var vm = this;
        var originatorEv;

        // Data
        vm.title = title;
        vm.fields = fields;
        vm.translate = undefined;
        vm.users = users;


        // Methods
        vm.closeDialog = closeDialog;
        vm.sendForm = sendForm;
        vm.disabledPosition = disabledPosition;
        vm.selectUser = selectUser;

        init();

        function init() {
            vm.loading = true;
            if(vm.title === 'branch') {
                vm.translate = 'GLOBAL.BRANCH';
            } else if(vm.title === 'administrator') {
                vm.translate = 'GLOBAL.ADMINISTRATOR';
            } else if(vm.title === 'managerLegal') {
                vm.translate = 'GLOBAL.LEGAL_MANAGER';
            } else if (vm.title === 'branch') {
                vm.translate = 'GLOBAL.BRANCH';
            } else if(vm.title === 'compliance') {
                vm.translate = 'GLOBAL.COMPLIANCE_COMMITTEE';
            } else if(vm.title === 'report') {
                vm.translate = 'GLOBAL.REPORT_COMMITTEE';
            }
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function sendForm() {
            $mdDialog.hide(vm.fields);
        }

        function disabledPosition(field) {
            var idAdmin;
            var idManagerLegal;
            for (var i = 0; i < field.options.length; i++) {
                if(field.options[i].field === 'Administrator') {
                    idAdmin = field.options[i].id;
                } else {
                    idManagerLegal = field.options[i].id
                }
            }
            
            if(vm.title === 'managerLegal') {
                field.value = idManagerLegal;
                return true;
            } else if (vm.title === 'administrator') {
                field.value = idAdmin;
                return true;
            }
        }

        function selectUser(user) {
            for (var i = 0; i < vm.fields.length; i++) {
                if(vm.fields[i].field === 'name') {
                    vm.fields[i].value = user.first_name
                } else if(vm.fields[i].field === 'surnames') {
                    vm.fields[i].value = user.last_name;
                } else if(vm.fields[i].field === 'email') {
                    vm.fields[i].value = user.email;
                } else if(vm.fields[i].field === 'nif') {
                    vm.fields[i].value = user.id_number;
                } else if(vm.fields[i].field === 'position') {
                    vm.fields[i].value = user.job_position_id;
                }
            }
            vm.fields.push({field: 'id', value: user.id});
            $mdDialog.hide({fields: vm.fields, existUser: true});
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('app.clients')
        .constant('_', window._)
        .controller('NewStakeDialogController', NewStakeDialogController);

    /** @ngInject */
    function NewStakeDialogController($scope, $mdDialog, sectors, regions, $stateParams, $document, documentsService, staffService,
        sessionService, clientsService, regionsLiterals, company, main_branch, $translate) {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.saveDialog = saveDialog;
        vm.getRegionLiteral = getRegionLiteral;
        vm.sectors = sectors;
        vm.regions = regions;
        vm.regionsLiterals = regionsLiterals;
        vm.mediaDialogSingle = mediaDialogSingle;
        vm.deleteLogotype = deleteLogotype;
        $scope.owner = $stateParams.owner;
        vm.company = company ? company : {};
/*
        vm.main_branch = main_branch ? main_branch : {}

        if (vm.company.id) {
            staffService.getMainBranch({ owner: $scope.owner, id_company: vm.company.id }).then(res => {
                vm.main_branch = res.data[0];
            })
        }
        if (vm.company.logo && vm.company.logo.length > 0) {
            var options = {
                owner: $scope.owner
            };
            clientsService.getStoragePrefix(options).then(function (res) {
                $scope.imageUrl = res.prefix + vm.company.logo[0].url;
                vm.logoIsLoaded = true;
            })
        }
        if (!vm.company.region_id) {
            vm.company.region_id = sessionService.user.region_id;
        }
        */
        function saveDialog() {
 //           if (!vm.main_branch.name) {
 //               vm.main_branch.name = vm.company.name;
 //           }
 //           $mdDialog.hide({ company: vm.company, branch: vm.main_branch, image: $scope.image, updateLogotype: vm.updateLogotype });
            $mdDialog.hide({ company: vm.company });
        }
        function mediaDialogSingle(ev, field) {
            $mdDialog.show({
                controller: 'MediaClientsController',
                controllerAs: 'vm',
                locals: {
                    owner: $scope.owner,
                    multipleSelection: true,
                    isTiny: false
                },
                templateUrl: 'app/main/apps/clients/dialogs/media/media-clients.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                multiple: true
            }).then(function (image) {
                if (image) {
                    vm.updateLogotype = true;
                    $scope.image = image;
                }
            });
        }
        function deleteLogotype() {
            if (vm.company.logo && vm.company.logo.length > 0) {
                for (var i = 0; i < vm.company.logo.length; i++) {
                    const itemLogo = vm.company.logo[i];
                    var options = {
                        owner: $scope.owner,
                        id: itemLogo.id
                    }
                    documentsService.deleteDocument(options).then(function () {
                        vm.company.logo = null;
                    })
                }
            }
            $scope.image = undefined;
            $scope.imageUrl = undefined;
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function getRegionLiteral(literalKey) {
            if (!angular.isUndefined(vm.company) && vm.company.region_id) {
                const literalsObject = vm.regionsLiterals.find(x => x.region_id === vm.company.region_id)
                return literalsObject.literals[literalKey];
            } else {
                return 'CIF/NIF';
            }
        }

    }
})();


(function () {
    'use strict';

    angular
        .module('app.clients')
        .constant('_', window._)
        .controller('NewStakeDialogController', NewStakeDialogController);

    /** @ngInject */
    function NewStakeDialogController($scope, $mdDialog, sectors, regions, $stateParams, $document, documentsService, staffService,
        sessionService, clientsService, regionsLiterals, company, main_branch, $translate) {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.saveDialog = saveDialog;
        vm.getRegionLiteral = getRegionLiteral;
        vm.sectors = sectors;
        vm.regions = regions;
        vm.regionsLiterals = regionsLiterals;
        vm.mediaDialogSingle = mediaDialogSingle;
        vm.deleteLogotype = deleteLogotype;
        $scope.owner = $stateParams.owner;
        vm.company = company ? company : {};
/*
        vm.main_branch = main_branch ? main_branch : {}

        if (vm.company.id) {
            staffService.getMainBranch({ owner: $scope.owner, id_company: vm.company.id }).then(res => {
                vm.main_branch = res.data[0];
            })
        }
        if (vm.company.logo && vm.company.logo.length > 0) {
            var options = {
                owner: $scope.owner
            };
            clientsService.getStoragePrefix(options).then(function (res) {
                $scope.imageUrl = res.prefix + vm.company.logo[0].url;
                vm.logoIsLoaded = true;
            })
        }
        if (!vm.company.region_id) {
            vm.company.region_id = sessionService.user.region_id;
        }
        */
        function saveDialog() {
 //           if (!vm.main_branch.name) {
 //               vm.main_branch.name = vm.company.name;
 //           }
 //           $mdDialog.hide({ company: vm.company, branch: vm.main_branch, image: $scope.image, updateLogotype: vm.updateLogotype });
            $mdDialog.hide({ company: vm.company });
        }
        function mediaDialogSingle(ev, field) {
            $mdDialog.show({
                controller: 'MediaClientsController',
                controllerAs: 'vm',
                locals: {
                    owner: $scope.owner,
                    multipleSelection: true,
                    isTiny: false
                },
                templateUrl: 'app/main/apps/clients/dialogs/media/media-clients.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                multiple: true
            }).then(function (image) {
                if (image) {
                    vm.updateLogotype = true;
                    $scope.image = image;
                }
            });
        }
        function deleteLogotype() {
            if (vm.company.logo && vm.company.logo.length > 0) {
                for (var i = 0; i < vm.company.logo.length; i++) {
                    const itemLogo = vm.company.logo[i];
                    var options = {
                        owner: $scope.owner,
                        id: itemLogo.id
                    }
                    documentsService.deleteDocument(options).then(function () {
                        vm.company.logo = null;
                    })
                }
            }
            $scope.image = undefined;
            $scope.imageUrl = undefined;
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function getRegionLiteral(literalKey) {
            if (!angular.isUndefined(vm.company) && vm.company.region_id) {
                const literalsObject = vm.regionsLiterals.find(x => x.region_id === vm.company.region_id)
                return literalsObject.literals[literalKey];
            } else {
                return 'CIF/NIF';
            }
        }

    }
})();
(function () {
	'use strict';

	angular
		.module('app.clients')
		.controller('ImageDialogClientsController', ImageDialogClientsController);

	/** @ngInject */
	function ImageDialogClientsController($mdDialog, sessionService, Images, ImageSelected, $document, cropFormats, MediaFull)
	{
		var vm = this;

		vm.views = {
			fotorama: 'app/main/apps/clients/dialogs/image/views/fotorama-view.html',
			editmedia: 'app/main/apps/clients/dialogs/image/views/edit-media-view.html',
		};
		vm.defaultView = 'fotorama';
		vm.currentView = 'fotorama';

		// Data
		vm.title = 'View Media';
		vm.images = [];
		vm.dataImages = [];

		// Methods
		vm.closeDialog = closeDialog;
		vm.changeView = changeView;
		vm.edit = edit;

		// //////////

		/**
		 * Close dialog
		 */
		function closeDialog()
		{
			/*var $fotoramaDiv = $('#fotorama').fotorama();
			var fotorama = $fotoramaDiv.data('fotorama');
			fotorama.destroy();*/
			$mdDialog.hide();
		}

		init();

		function init()
		{

			vm.dataFotorama = [];
			var fotoramaDiv = angular.element(".testingelement");

			var fit = (cropFormats) ? 'scaledown' : 'contain';
			vm.fotoramaoptions = {
				width: '100%',
				height: '80%',
				captions: true,
				loop: true,
				keyboard: true,
				allowfullscreen: true,
				nav: 'thumbs',
				ratio: 16 / 9,
				fit: fit,
			};

			if (!cropFormats) {
				if (!_.isArray(Images)) {
					var ImagesArray = [];
					ImagesArray.push(Images);
					Images = ImagesArray;
				}


				for (var i = 0; i < Images.length; i++) {

					var attachment = Images[i];
					var imagesCrops = [];

					for (var iCrop = 0; iCrop < Images[i].cropstatus.length; iCrop++) {
						var imageCrop = Images[i].cropstatus[iCrop];
						imagesCrops.push(Images[i].cropstatus[iCrop]);
					}

					if (ImageSelected) {
						var selected = (Images[i].id_media === ImageSelected.id_media) ? true : false;
					} else {
						var selected = false;
					}

					if (Images[i].media_type !== 1) {
						// continue;
					}

					// .container.view_url}}{{image.cropstatus[0].fileName

					if (attachment.media_type == 1) {

						if (MediaFull) {
							var cropstatus = _.find(Images[i].cropstatus, {
								'id_cropformats': sessionService.getMediaThumbnailCropformatId()
							});

							var cropstatus = _.find(Images[i].cropstatus, {
								'id_cropformats': sessionService.getMediaFullCropformatId()
							});
							var urlImage = cropstatus.container.view_url + cropstatus.fileName;
							vm.dataFotorama.push({
								imageUrl: urlImage,
								thumb: urlImage,
								dataCaption: '#' + attachment.id_media + ' | ' + urlImage,
								html: '<div>123</div>',
								selected: selected
							})
						} else {
							var cropstatus = _.find(attachment.cropstatus, {
								'id_cropformats': sessionService.getMediaFullCropformatId()
							});

							if(!cropstatus){
								var urlImage = attachment.container.view_url + 'original/m' + attachment.id_media + '_' + attachment.filename;
							}else{
								var urlImage = cropstatus.container.view_url + cropstatus.fileName;
							}
								vm.dataFotorama.push({
									imageUrl: urlImage,
									thumb: urlImage,
									dataCaption: '#' + attachment.id_media + ' | ' + urlImage,
									html: '<div>123</div>',
									selected: selected
								})
						}
					}

					if (attachment.media_type == 2) {
						var videoUrl = '';
						if (!attachment.embed) {
							videoUrl = attachment.container.view_url + 'videos/m' + attachment.id_media + '_' + attachment.filename;
						} else {
							if (attachment.embed.indexOf('yt|') !== -1) {
								var YT_VideoSource = attachment.embed.split('yt|')[1];
								videoUrl = 'http://youtube.com/' + YT_VideoSource;
							} else if (attachment.embed.indexOf('fb|') !== -1) {
								var embed_url = angular.element(attachment.embed_url);
								videoUrl = embed_url.attr('src');
							}
						}

						vm.dataFotorama.push({
							imageUrl: attachment.embed_thumb,
							thumb: attachment.embed_thumb,
							full: attachment.embed_thumb, // Separate image for the fullscreen mode.
							video: videoUrl, // Youtube, Vimeo or custom iframe URL
							id: 'one', // Custom anchor is used with the hash:true option.
							caption: 'The first caption',
							html: '<div>123</div>',
							// html: $('selector'), // ...or '<div>123</div>'. Custom HTML inside the frame.
							fit: 'cover', // Override the global fit option.
							any: 'Any data relative to the frame you want to store',
							selected: selected
						})
					}
				}
				// }else{
				// 	var cropstatus = _.find( Images.cropstatus, {'id_cropformats': sessionService.getMediaThumbnailCropformatId()});
				// 	if(MediaFull){
				// 		var cropstatus = _.find( Images.cropstatus, {'id_cropformats': sessionService.getMediaFullCropformatId()});
				// 		var urlImage = cropstatus.container.view_url + cropstatus.fileName;
				// 	}else{
				//       				var urlImage = cropstatus.container.view_url + 'original/m' + Images.id_media + '_' + Images.filename;
				//       			}
				// 	vm.dataFotorama.push({
				// 					 imageUrl: urlImage,
				// 					 thumb: urlImage,
				// 					 dataCaption: '#' + Images.id_media + ' | ' + Images.filename,
				// 					 html: '<div>123</div>',
				// 					 selected: selected
				// 				 })
				// }
			} else {

				for (var i = 0; i < Images.length; i++) {
					
					var selected = (Images[i].id_cropformats === ImageSelected.id_cropformats && Images[i].container.id_container === ImageSelected.container.id_container) ? true : false;


					if (Images[i].container.use_grid === 1) {
						var urlImage = Images[i].container.view_url + Images[i].grid + '/' + Images[i].fileName;
					} else {
						var urlImage = Images[i].container.view_url + Images[i].fileName;
					}
					vm.dataFotorama.push({
						imageUrl: urlImage,
						thumb: urlImage,
						dataCaption: 'aa#' + Images[i].id_cropformats + ' | ' + urlImage,
						html: '<div>123</div>',
						selected: selected
					})
				}
			}

			// $fotoramaDiv.data({
			// 	data: vm.dataFotorama
			// });

		}

		function changeView(view) {
			if (vm.views[view]) {
				vm.loadingView = true;
				vm.showSearchAndPaginator = false;
				vm.defaultView = view;
				vm.currentView = view;
			}
		}


		function edit() {
			var $fotoramaDiv = angular.element("#fotorama1");
		}

	}
})();

(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('MediaClientsController', MediaClientsController);

    /** @ngInject */
    function MediaClientsController($mdDialog,$stateParams, $document, mediaService, owner, requestContext, $anchorScroll, $timeout, $scope, $sce, Upload, multipleSelection, msUtils, COMMON, isTiny, $log) {
        var vm = this;

        // Data
        vm.owner = owner;
        $scope.owner = $stateParams.owner;

        vm.defaultPage = 1;
        vm.defaultPerPage = 50;
        vm.PerPage = 50;
        vm.searchStringFilter = '';
        vm.searchQuery = '';
        vm.modelSearch = '';
        vm.pagination_search = pagination_search;

        vm.isTiny = isTiny;

        vm.views = {
            1: 'app/main/apps/clients/dialogs/media/views/photos-view.html',
            2: 'app/main/apps/clients/dialogs/media/views/videos-view.html',
            3: 'app/main/apps/clients/dialogs/media/views/files-view.html',
            4: 'app/main/apps/clients/dialogs/media/views/audios-view.html',
            upload: 'app/main/apps/clients/dialogs/media/views/upload-view.html',
            import: 'app/main/apps/clients/dialogs/media/views/import-view.html',
        };
        vm.defaultView = 'upload';
        vm.currentView = 'upload';

        vm.viewsTiny = {
            1: 'app/main/apps/clients/dialogs/media/views/tiny-attached.html',
            properties: 'app/main/apps/clients/dialogs/media/views/tiny-properties.html',
            upload: 'app/main/apps/clients/dialogs/media/views/upload-view.html',
        };
        vm.defaultViewTiny = '1';
        vm.currentViewTiny = '1';

        vm.firstLoad = true;
        vm.media_type = '1';
        vm.showSearchAndPaginator = true;
        vm.import_field = '';
        vm.import_disabled = '';
        vm.importedFiles = [];
        vm.importPreview = false;
        vm.imported = false;
        vm.importing = false;
        vm.selectedImages = [];
        vm.files = [];
        vm.tinyProperties = {
            mediaType: '',
            mediaSort: '',
            mediaData: {},
            align: '',
            size: ''
        };
        vm.tinyOptions = {
            size: [
                { value: 25, text: '25%' },
                { value: 50, text: '50%' },
                { value: 75, text: '75%' },
                { value: 100, text: '100%' }
            ],
            align: [
                { value: 'left', text: 'left' },
                { value: 'center', text: 'center' },
                { value: 'right', text: 'right' }
            ]
        }

        // If replying
        // if (angular.isDefined(selectedMail)) {
        // 	vm.form.to = selectedMail.from.email;
        // 	vm.form.subject = 'RE: ' + selectedMail.subject;
        // 	vm.form.message = '<blockquote>' + selectedMail.message + '</blockquote>';
        // }

        // Methods
        vm.closeDialog = closeDialog;
        vm.changeView = changeView;
        vm.changeViewTiny = changeViewTiny;

        vm.nextPage = nextPage;
        vm.prevPage = prevPage;
        vm.morePages = morePages;
        vm.firstPage = firstPage;
        vm.upload = upload;
        vm.attachMedia = attachMedia;
        vm.attachMediaTiny = attachMediaTiny;
        vm.selectMediaTiny = selectMediaTiny;
        vm.selectedMediaTiny = '';
        vm.search = search;

        vm.exists = msUtils.exists;
        vm.alreadySelectedbyZone = alreadySelectedbyZone;
        vm.existInArray = msUtils.existInArray;
        vm.toggleSelectedImages = toggleSelectedImages;


        //////////

        if (!isTiny) {
            init();
        } else {
            vm.section = section;
            initTiny();
        }
        /**
         * Initialize
         */
        function init() {

            vm.loading = true;
        }

        /**
         * Initialize Tinymce
         */
        function initTiny() {
            vm.currentViewTiny = vm.defaultViewTiny;
            vm.showSearchAndPaginator = false;
            vm.loading = true;
            for (var i = 0; i < vm.currentThread.length; i++) {
                if (vm.mediazone) {
                    if (vm.currentThread[i].id_zone == 1) {
                        vm.selectedImages.push(vm.currentThread[i]);
                    }
                } else {
                    vm.selectedImages.push(vm.currentThread[i]);
                }
            }
            if (vm.section.mediaSort) {
                var currentSort = 0;
                var currentItem = '';
                for (var i = 0; i < vm.currentThread.length; i++) {
                    if (vm.mediazone) {
                        if (vm.currentThread[i]['id_zone'] == 1 && (vm.currentThread[i]['media_type'] == vm.section.mediaType)) {
                            currentSort++;
                            if (currentSort = vm.section.mediaSort) {
                                currentItem = vm.currentThread[i];
                            }
                        }
                    } else {
                        if (vm.currentThread[i]['media_type'] == vm.section.mediaType) {
                            currentSort++;
                            if (currentSort = vm.section.mediaSort) {
                                currentItem = vm.currentThread[i];
                            }
                        }

                    }
                }

                vm.selectedMediaTiny = currentItem;
                vm.tinyProperties.mediaSort = vm.section.mediaSort;
                vm.tinyProperties.mediaType = currentItem.media_type;
                vm.tinyProperties.align = vm.section.mediaAlign;
                vm.tinyProperties.size = vm.section.mediaSize;
                vm.changeViewTiny('properties');


            }
            vm.loading = false;

        }

        function pagination_search(searchString) {
            var options = {
                section: section,
                media_type: vm.media_type,
                page: vm.defaultPage,
                perPage: vm.defaultPerPage,
                searchString: searchString
            };
        }


        function search(options) {
            // console.log(options, vm.searchStringFilter);
            /*

			vm.loading 		= true;
			vm.items		=[];
			// Scroll to the top Dialog
            scrollToTopOfDialog();

			mediaService.get({
				siteID: siteID,
				page: options.page,
				paginate: options.perPage,
				media_type: options.media_type,
                withCropStatus: true,
                sortField: 'date_uploaded',
                searchStringFilter: options.searchString,

			})
				.then(function (response) {
					vm.totalItems = response.total;
					vm.pagination_totalItems = response.total;
					vm.from = response.from;
					vm.pagination_from = response.from;
					vm.to = response.to;
					vm.pagination_to = response.to;
					vm.currentPage = response.current_page;
					vm.lastPage = response.last_page;
					vm.maxSize = 500;
					vm.bigTotalItems = 175;

					vm.loading = false;

                    vm.items = angular.copy(response.data);

                    $('.md-button')
                        .removeClass('active');
                    $('[type=' + options.media_type + ']')
						.addClass('active');

				});




			vm.firstLoad = false;
*/
        }

        function closeDialog() {
            $mdDialog.hide(vm.currentThread);
        }

        function changeView(view) {

            //console.log(view)
            if (vm.views[view]) {
                vm.items = [];
                vm.loadingView = true;
                vm.showSearchAndPaginator = false;
                vm.defaultView = view;
                vm.currentView = view;


                vm.media_type = view;

                var options = {
                    page: 1,
                    perPage: vm.PerPage,
                    media_type: view,

                };
                if (view == 1 || view == 2 || view == 3 || view == 4) {
                    vm.showSearchAndPaginator = true;
                }

            }

        }

        function changeViewTiny(view) {


            if (vm.viewsTiny[view]) {
                vm.items = [];
                vm.loadingView = true;
                vm.showSearchAndPaginator = false;
                vm.defaultViewTiny = view;
                vm.currentViewTiny = view;
            }

        }

        $scope.file_changed = function (element) {

            $scope.$apply(function (scope) {
                var photofile = element.files[0];
                console.log(photofile);
                $mdDialog.hide(photofile);
                //vm.upload(photofile);
                var reader = new FileReader();
                reader.onload = function (e) {
                    // handle onload
                };
                reader.readAsDataURL(photofile);
                $scope.image = photofile;
            });
        };

        $scope.$watch('vm.files', function () {
            console.debug("WATCH!!:::!:!:!:!: ")
            $scope.formUpload = false;
            if (vm.files != null) {
                // make files array for not multiple to be able to be used in ng-repeat in the ui
                if (!angular.isArray(vm.files)) {
                    $timeout(function () {
                        $scope.files = vm.files = [vm.files];
                    });
                    return;
                }
                for (var i = 0; i < vm.files.length; i++) {
                    $scope.errorMsg = null;
                    (function (f) {
                        //vm.upload(f, true);
                        $mdDialog.hide(f);
                    })(vm.files[i]);
                }
            }
        });

        $scope.$watch('vm.import_field', function () {
            vm.importConfirm(false);
        });


        $scope.log = '';

        function upload(file) {
            if (!file.$error) {
                var token = undefined;
                console.debug("UPLOAD______****", file)
                mediaService.getS3UploadPreSignedUrl({
                    owner: $scope.owner,
                    uploadKey: 'company_logo',
                    fileName: file.name,
                    rowId: 1
                })
                    .then(function (resp) {
                        token = resp.token;
                        file.id_media = resp.id_media;
                        file.upload = Upload.http({
                            url: resp.url,
                            skipAuthorization: true,
                            method: 'PUT',
                            headers: {
                                "Content-Type": file.type != '' ? file.type : 'application/octet-stream' 
                            },
                            data: file
                        });

                        file.upload.then(function (response) {
                            file.result = response.data;
                            $timeout(function () {
                                $scope.log = 'file: ' +
                                    file.name +
                                    ', Response: ' + JSON.stringify(response.data) +
                                    ', ID: ' + file.id_media +
                                    '\n' + $scope.log;
                            });
                            console.debug("SEND_TO_CROP______****", file)
                            mediaService.finishedUploadingFileToCdn({
                                owner: vm.owner,
                                idMedia: file.id_media,
                                token: token
                            })
                            $mdDialog.hide(vm.files[0]);


                        }, function (response) {
                            if (response.status > 0)
                                $scope.errorMsg = response.status + ': ' + response.data;
                        });

                        file.upload.progress(function (evt) {
                            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                        });

                    })
            }
        };

        vm.importConfirm = function (confirm) {
            vm.import_disabled = false;
            vm.imported = false;
            if (!confirm) {
                vm.importPreview = false;
            }
            if (vm.import_field.length > 10) {
                vm.importing = true;
                vm.import_disabled = true;

                $timeout(function () {
                    var pastedUrl = vm.import_field;
                    mediaService.importFromUrl({
                        siteID: siteID,
                        url: pastedUrl,
                        execute: confirm
                    })
                        .then(function (response) {
                            vm.importing = false;
                            response.embedCodeSafe = $sce.trustAsHtml(response.metadata.embedCode);
                            if (response.id_media) {
                                vm.imported = true;
                                vm.importPreview = false;
                                mediaService.get({
                                    siteID: siteID,
                                    withCropStatus: true,
                                    idMedia: response.id_media
                                })
                                    .then(function (response) {
                                        if (response.total == 1) {
                                            var photo = response.data[0];
                                            vm.importedFiles.push(photo);
                                            toggleSelectedImages(photo);
                                        }
                                    });

                            } else {
                                vm.importPreview = response;
                            }
                            vm.import_disabled = false;
                        });
                })
            }
        }

        function nextPage() {

            var options = {
                page: vm.currentPage + 1,
                perPage: vm.PerPage,
                media_type: vm.media_type
            };

        }

        function prevPage() {
            var options = {
                page: vm.currentPage - 1,
                perPage: vm.PerPage,
                media_type: vm.media_type,
                searchString: vm.modelSearch
            };
            
        }

        function morePages() {
            if (vm.currentPage <= vm.lastPage) return true;
            return false;
        }

        function firstPage() {
            if (vm.currentPage == 1) return true;
            return false;
        }

        function alreadySelectedbyZone(array, item) {
            var ret = false;
            for (var i = 0, len = array.length; i < len; i++) {
                if (vm.mediazone) {
                    if (array[i]['id_media'] === item.id_media && array[i]['id_zone'] === mediazone.id_zone) {
                        ret = true;
                    }
                } else {
                    if (array[i]['id_media'] === item.id_media) {
                        ret = true;
                    }

                }
            }

            return ret;
        }


        function toogleSelectedbyZone(item) {
            if (!multipleSelection) {
                vm.selectedImages = [];
            }
            for (var i = 0, len = vm.selectedImages.length; i < len; i++) {
                if (vm.selectedImages[i]['id_media'] === item.id_media && vm.selectedImages[i]['id_zone'] === mediazone.id_zone) {
                    vm.selectedImages.splice(i, 1);
                    return;
                }
            }

            vm.selectedImages.push(item);
            return;
        }

        function selectMediaTiny(item) {
            var currentSort = 0;
            var mediaSort = 0;
            for (var i = 0; i < vm.currentThread.length; i++) {
                if (vm.mediazone) {
                    //            		console.log(vm.currentThread[i]['id_zone']);
                    if (vm.currentThread[i]['id_zone'] == 1 && (vm.currentThread[i]['media_type'] == item.media_type)) {
                        currentSort++;
                        if (item.id_media == vm.currentThread[i]['id_media']) {
                            mediaSort = currentSort;
                        }
                    }
                } else {
                    currentSort++;
                    if (item.id_media == vm.currentThread[i]['id_media']) {
                        mediaSort = currentSort;
                    }
                }
            }
            vm.selectedMediaTiny = item;
            vm.tinyProperties.mediaSort = mediaSort;
            vm.tinyProperties.mediaType = item.media_type;
            vm.changeViewTiny('properties');

        }

        function attachMedia() {
            if ($scope.image) {
                $mdDialog.hide($scope.image);
            } else {
                $mdDialog.hide();
            }
        }

        function attachMediaTiny() {
            $mdDialog.hide(vm.tinyProperties);
        }

        /**
         * Toggle selected status of the contact
         *
         * @param contact
         * @param event
         */
        function toggleSelectedImages(photo, event) {
            if (event) {
                event.stopPropagation();
            }


            //         else{
            if (vm.mediazone) {
                photo.id_zone = vm.mediazone.id_zone;
                photo.zone_name = vm.mediazone.zone_name;
            } else {
                photo.id_zone = null;
                photo.zone_name = null;
            }

            toogleSelectedbyZone(photo);

        }

        /**
         * Scroll Media Dialog Content to the top
         * @param speed
         */
        function scrollToTopOfDialog() {     
            $timeout(function () {
                var dialogContent = $document.find('md-dialog-content').filter(function () {
                    return angular.element(this).hasClass('mediadialog-content');
                });
                if (!angular.isUndefined(dialogContent[0])) {
                    dialogContent.animate({
                        scrollTop: dialogContent[0].scrollHeight  
                    }, 1);
                }
            }, 1000);

        }
    }
})();


(function () {
    'use strict';

    angular
        .module('app.clients')
        .constant('_', window._)
        .controller('NewStakeDialogController', NewStakeDialogController);

    /** @ngInject */
    function NewStakeDialogController($scope, $mdDialog, sectors, regions, $stateParams, $document, documentsService, staffService,
        sessionService, clientsService, regionsLiterals, company, main_branch, $translate) {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.saveDialog = saveDialog;
        vm.getRegionLiteral = getRegionLiteral;
        vm.sectors = sectors;
        vm.regions = regions;
        vm.regionsLiterals = regionsLiterals;
        vm.mediaDialogSingle = mediaDialogSingle;
        vm.deleteLogotype = deleteLogotype;
        $scope.owner = $stateParams.owner;
        vm.company = company ? company : {};
/*
        vm.main_branch = main_branch ? main_branch : {}

        if (vm.company.id) {
            staffService.getMainBranch({ owner: $scope.owner, id_company: vm.company.id }).then(res => {
                vm.main_branch = res.data[0];
            })
        }
        if (vm.company.logo && vm.company.logo.length > 0) {
            var options = {
                owner: $scope.owner
            };
            clientsService.getStoragePrefix(options).then(function (res) {
                $scope.imageUrl = res.prefix + vm.company.logo[0].url;
                vm.logoIsLoaded = true;
            })
        }
        if (!vm.company.region_id) {
            vm.company.region_id = sessionService.user.region_id;
        }
        */
        function saveDialog() {
 //           if (!vm.main_branch.name) {
 //               vm.main_branch.name = vm.company.name;
 //           }
 //           $mdDialog.hide({ company: vm.company, branch: vm.main_branch, image: $scope.image, updateLogotype: vm.updateLogotype });
            $mdDialog.hide({ company: vm.company });
        }
        function mediaDialogSingle(ev, field) {
            $mdDialog.show({
                controller: 'MediaClientsController',
                controllerAs: 'vm',
                locals: {
                    owner: $scope.owner,
                    multipleSelection: true,
                    isTiny: false
                },
                templateUrl: 'app/main/apps/clients/dialogs/media/media-clients.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                multiple: true
            }).then(function (image) {
                if (image) {
                    vm.updateLogotype = true;
                    $scope.image = image;
                }
            });
        }
        function deleteLogotype() {
            if (vm.company.logo && vm.company.logo.length > 0) {
                for (var i = 0; i < vm.company.logo.length; i++) {
                    const itemLogo = vm.company.logo[i];
                    var options = {
                        owner: $scope.owner,
                        id: itemLogo.id
                    }
                    documentsService.deleteDocument(options).then(function () {
                        vm.company.logo = null;
                    })
                }
            }
            $scope.image = undefined;
            $scope.imageUrl = undefined;
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function getRegionLiteral(literalKey) {
            if (!angular.isUndefined(vm.company) && vm.company.region_id) {
                const literalsObject = vm.regionsLiterals.find(x => x.region_id === vm.company.region_id)
                return literalsObject.literals[literalKey];
            } else {
                return 'CIF/NIF';
            }
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('DialogFormController', DialogFormController);

    /** @ngInject */
    function DialogFormController($mdDialog, $document, usersService, clientsService, sessionService, owner, type, documentsService, positionsIds, idCompany, $filter, $mdMenu, requestContext, Upload, user_type, title, fields, users, $translate, alreadySelected, branchId, storagePrefix, $anchorScroll, $timeout, $scope, $sce, msUtils, COMMON, isTiny, $log, defaultDivision, defaultJob) {

        var vm = this;
        var originatorEv;
        vm.owner = owner;
        vm.type = type;
        sessionService.getQuota().then(function (quota) {
            vm.quota = quota;
        });

        vm.userLogued = sessionService.getUser();
        vm.fields = fields;
        var foundFiles = _.find(vm.fields, function (field) {
            return field.field == 'files';
        });
        vm.files = (foundFiles && foundFiles.value) ? (Array.isArray(foundFiles.value) ? foundFiles.value : [foundFiles.value]) : [];
        vm.emailOriginal = _.find(vm.fields, function (field) {
            if (field.field == 'email') {
                return true
            }
        }).value;
        vm.openMenu = openMenu;
        vm.user_type = user_type;
        vm.positionsIds = positionsIds;

        vm.alreadySelected = [];
        vm.branchId = branchId;
        vm.storagePrefix = storagePrefix;
        vm.deleteAvatar = deleteAvatar;
        vm.noDivisionJobSelected = true;
        vm.jobPositionId = '';
        vm.divisionId = '';
        vm.alreadySelected = alreadySelected;
        vm.indexDivision = null;
        vm.indexPosition = null;
        vm.translate = function (text) {
            return $translate.instant(text);
        }

        for (var i = 0; i < vm.fields.length; i++) {
            if (vm.fields[i].field == 'division') {
                vm.indexDivision = i;
                break;
            }
        }
        for (var i = 0; i < vm.fields.length; i++) {
            if (vm.fields[i].field == 'position') {
                vm.indexPosition = i;
                break;
            }
        }



        var originatorEv;

        function openMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        }

        function deleteAvatar(file) {
            var options = {
                owner: vm.owner,
                id: file.id
            }
            documentsService.deleteDocument(options).then(function () {
                vm.files = [];
            })
        }

        if (defaultDivision) {
            vm.divisionId = defaultDivision;
        }
        if (defaultJob) {
            vm.jobPositionId = defaultJob;
        }



        // Methods
        vm.closeDialog = closeDialog;
        vm.sendForm = sendForm;
        vm.disabledPosition = disabledPosition;
        vm.showSector = showSector;
        vm.selectUser = selectUser;
        vm.showUserImage = showUserImage;
        vm.showSelectPosition = showSelectPosition;
        vm.selectJobDivision = selectJobDivision;
        vm.unSelectJobDivision = unSelectJobDivision;
        vm.divisionJobSelected = divisionJobSelected;
        vm.showJobDivision = showJobDivision;
        vm.isSendDisabled = isSendDisabled;

        init();

        function init() {
            vm.loading = true;
            if (title === 'branch') {
                vm.title = 'GLOBAL.NEW_BRANCH';
            } else if (title === 'administrator') {
                vm.title = 'GLOBAL.ADMINISTRATOR';
            } else if (title === 'managerLegal') {
                vm.title = 'GLOBAL.LEGAL_MANAGER';
            } else if (title === 'personnel' && defaultJob == "") {
                vm.title = 'GLOBAL.BRANCH_PERSONNEL';
            } else if (title === 'personnel' && defaultJob == 3) {
                vm.title = 'GLOBAL.COMPLIANCE_OFFICER';
            } else if (title === 'personnel' && defaultJob == 4) {
                vm.title = 'GLOBAL.REPORT_COMMITTEE';
            } else if (title === 'personnel' && defaultJob == 5) {
                vm.title = 'GLOBAL.DELEGATE_DATA_PROTECCTION';
            } else if (title === 'personnel' && defaultJob == 2) {
                vm.title = 'GLOBAL.ADMINISTRATOR';
            } else if (title === 'personnel' && defaultJob == 1) {
                vm.title = 'GLOBAL.LEGAL_MANAGER';
            }
            getUsersByCompany(idCompany)
            getUsersAdministrators()
        }


        function getUsersByCompany(idCompany) {
            var options = {
                owner: vm.owner,
                inCompany: idCompany,
                resultsPerPage: 500
            };
            clientsService.getUsers(options).then(function (response) {
                vm.users = response.data;
            })
        }
        function getUsersAdministrators() {
            var options = {
                owner: vm.owner,
                resultsPerPage: 100
            };
            usersService.getUsers(options).then(function (response) {
                vm.usersAll = response.data;
            })
        }


        function closeDialog() {
            $mdDialog.hide();
        }
        function isSendDisabled() {
            for (var i = 0; i < vm.fields.length; i++) {
                const element = vm.fields[i];
                if (element.required && !element.value) {
                    return true;
                }
            }
            return false;
        }

        function checkUploadsAndUpdateUser() {
            var noUpdate = false;
            if (vm.files) {
                angular.forEach(vm.files, function (file) {
                    if (angular.isUndefined(file.progress) || file.progress < 100) {
                        noUpdate = true;
                    }
                })
                if (!noUpdate && !$scope.uploadingFile) {
                    initState()
                    vm.loadingReadPane = false;
                    $rootScope.pagination_resetquery();
                } else {
                    $timeout(function () {
                        vm.checkUploadsAndUpdateUser();
                    }, 1000)
                }
            } else {
                initState()
                vm.loadingReadPane = false;
                $rootScope.pagination_resetquery();

            }
        }

        function sendForm(ev) {
            for (var i = 0; i < vm.fields.length; i++) {
                if (vm.fields[i].field === 'position' && !vm.fields[i].value) {
                    vm.fields[i].value = vm.jobPositionId;
                }
                else if (vm.fields[i].field === 'division' && !vm.fields[i].value) {
                    vm.fields[i].value = vm.divisionId;
                } else if (vm.fields[i].field === 'email' && vm.fields[i].value == '') {
                    delete vm.fields[i].value;
                }
            }
            if (((vm.positionsIds.compliance_officer == vm.jobPositionId
                || vm.positionsIds.compliance_comite == vm.jobPositionId
                || vm.positionsIds.data_protection == vm.jobPositionId)
                && vm.quota.users_registered >= vm.quota.max_allowed_users)
            ) {
                $mdDialog.show({
                    controller: 'UserQuotaDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/dialogs/userQuotaDialog/userQuotaDialog.html',
                    preserveScope: true,
                    autoWrap: true,
                    quota: null,
                    multiple: true,
                    locals: {
                        user: vm.userLogued,
                        quota: vm.quota,
                        quotaComplaint: null
                    }
                }).then(function (res) {
                    if (res && res.type) {
                        if (res.type == 'upgrade') {
                            console.log("go upgrade screen");
                        } else {
                            createUser(true);
                        }
                    }
                });
            } else {
                createUser();
            }



        }

        function createUser(quotaexceded) {


            var email = _.find(vm.fields, function (field) {
                if (field.field == 'email') {
                    return true
                }
            }).value;

            if (vm.emailOriginal === email) {
                vm.fields.files = vm.files;
                $mdDialog.hide({ fields: vm.fields, quotaexceded: quotaexceded });
                return
            }
            var options = {
                owner: vm.owner,
                searchStringFilter: email
            };
            usersService.getUsersWithTrashed(options).then(function (response) {

                var existedUser = _.find(response.data, function (user) {
                    if (user.email == email && (!vm.userSelected || user.id !== vm.userSelected.id)) {
                        return true;
                    }
                });

                if (!existedUser) {
                    vm.fields.files = vm.files;
                    $mdDialog.hide({ fields: vm.fields, quotaexceded: quotaexceded });
                } else {
                    alert = $mdDialog.alert({
                        title: vm.translate('GLOBAL.ATTENTION'),
                        textContent: vm.translate('GLOBAL.USER_ALREADY_EXISTS'),
                        ok: vm.translate('GLOBAL.CLOSE'),
                    }).multiple(true);

                    $mdDialog
                        .show(alert)
                        .finally(function () {
                            alert = undefined;
                        });
                }
            })





        }

        function disabledPosition(field) {
            var idAdmin;
            var idManagerLegal;
            var idComplaints;
            var idReport;
            for (var i = 0; i < field.options.length; i++) {
                if (field.options[i].field === 'ADMINISTRADOR') {
                    idAdmin = field.options[i].id;
                } else if (field.options[i].field === 'REPRESENTANTE LEGAL') {
                    idManagerLegal = field.options[i].id
                } else if (field.options[i].field === 'Complaints committee') {
                    idComplaints = field.options[i].id
                } else if (field.options[i].field === 'Reports committee') {
                    idReport = field.options[i].id
                }
            }

            if (vm.title === 'managerLegal') {
                field.value = idManagerLegal;
                return true;
            } else if (vm.title === 'administrator') {
                field.value = idAdmin;
                return true;
            } else if (vm.title === 'compliance') {
                field.value = idComplaints;
                return true;
            } else if (vm.title === 'report') {
                field.value = idReport;
                return true;
            }
        }

        function showSector() {
            if (title === 'personnel') {
                return true;
            }
        }

        function selectUser(user) {
            for (var i = 0; i < vm.fields.length; i++) {
                if (vm.fields[i].field === 'first_name') {
                    vm.fields[i].value = user.first_name
                } else if (vm.fields[i].field === 'last_name') {
                    vm.fields[i].value = user.last_name;
                } else if (vm.fields[i].field === 'email') {
                    vm.fields[i].value = user.email;
                } else if (vm.fields[i].field === 'nif') {
                    vm.fields[i].value = user.id_number;
                } else if (vm.fields[i].field === 'position') {
                    vm.fields[i].value = vm.jobPositionId;
                } else if (vm.fields[i].field === 'division') {
                    vm.fields[i].value = vm.divisionId;
                } else if (vm.fields[i].field === 'profile_color') {
                    vm.fields[i].value = user.profile_color;
                } else if (vm.fields[i].field === 'user_type') {
                    vm.fields[i].value = user.user_type;
                }
            }

            vm.fields.push({ field: 'id', value: user.id });
            vm.fields.push({ field: 'files', value: user.files });
            if (vm.quota.users_registered >= vm.quota.max_allowed_users && (user.user_type > 3)) {
                $mdDialog.show({
                    controller: 'UserQuotaDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/dialogs/userQuotaDialog/userQuotaDialog.html',
                    preserveScope: true,
                    autoWrap: true,
                    multiple: true,
                    locals: {
                        user: vm.userLogued,
                        quota: vm.quota,
                        quotaComplaint: null
                    }
                }).then(function (res) {
                    if (res && res.type) {
                        if (res.type == 'upgrade') {
                            console.log("go upgrade screen");
                        } else {
                            $mdDialog.hide({ fields: vm.fields, existUser: true, quotaexceded: vm.quota.users_registered >= vm.quota.max_allowed_users });
                        }
                    }
                });
            } else {
                $mdDialog.hide({ fields: vm.fields, existUser: true, quotaexceded: vm.quota.users_registered >= vm.quota.max_allowed_users });
            }

        }

        $scope.filterAlreadyAdded = function (item) {
            if (vm.fields[vm.indexDivision].value && vm.fields[vm.indexPosition].value) {
                var found = $filter('filter')(vm.alreadySelected, { id: item.id, position: vm.fields[vm.indexPosition].value, division: vm.fields[vm.indexDivision].value });
                return found.length == 0;;
            } else {
                var found = _.find(vm.alreadySelected, function (_item) { return _item.id == item.id });
                return !found;
            }
        };

        function showUserImage(user) {
            return vm.storagePrefix + user.files.url
        }

        function showSelectPosition() {
            if (vm.branchId && vm.noDivisionJobSelected) {
                return true;
            }
            return false;
        }

        function selectJobDivision() {
            vm.noDivisionJobSelected = false;
        }

        function divisionJobSelected() {
            var ret1 = false;
            var ret2 = false;
            for (var i = 0; i < vm.fields.length; i++) {
                if (vm.fields[i].field === 'position' && vm.fields[i].value) {
                    vm.jobPositionId = vm.fields[i].value;
                    ret1 = true;
                }
                if (vm.fields[i].field === 'division' && vm.fields[i].value) {
                    vm.divisionId = vm.fields[i].value;
                    ret2 = true;
                }
            }

            return (!ret1 || !ret2);
        }

        function unSelectJobDivision() {
            vm.noDivisionJobSelected = true;
        }

        function showJobDivision() {
            if (vm.branchId) {
                return true;
            }
            return false;
        }

    }
})();


(function () {
    'use strict';

    angular
        .module('app.clients')
        .constant('_', window._)
        .controller('EditBranchDialog', EditBranchDialog);

    /** @ngInject */
    function EditBranchDialog($scope, $mdDialog, $translate, region_id, clientsService, tinyMceService, branch, $mdToast) {
        var vm = this;
        vm.region_id = region_id;
        vm.branch = angular.copy(branch);
        vm.tinymceOptions = tinyMceService.getOptions($scope);
        vm.tinymceOptions.height = 100;
        vm.saveDialog = saveDialog;
        vm.closeDialog = closeDialog;
        vm.getRegionLiteral = getRegionLiteral;
        clientsService.getFileRegions().then(function (res) {
            vm.regionsLiterals = res;
        })
        function saveDialog() {

            $mdDialog.hide(vm.branch);

        }
        function getRegionLiteral(literalKey) {
            if (vm.region_id && vm.regionsLiterals) {
                const literalsObject = vm.regionsLiterals.find(x => x.region_id === vm.region_id)
                return literalsObject.literals[literalKey];
            } else {
                return '';
            }
        }



        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.notes', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msUtilProvider, msNavigationServiceProvider) {
        $stateProvider.state('app.notes', {
            url: '/notes',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/notes/notes.html',
                    controller: 'NotesController as vm'
                }
            },
            resolve: {
                Notes: function (NotesService) {
                    return NotesService.getData();
                },
                Labels: function (LabelsService) {
                    return LabelsService.getData();
                }
            }
        });

        // Translation
        var base = 'app/main/apps/notes';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }
        // Api
        msApiProvider.register('notes.notes', ['app/data/notes/notes.json']);
        msApiProvider.register('notes.labels', ['app/data/notes/labels.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('apps.notes', {
            title: 'Notes',
            icon: 'icon-lightbulb',
            state: 'app.notes',
            weight: 11
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .controller('msNoteFormController', msNoteFormController)
        .directive('msNoteForm', msNoteFormDirective);

    /** @ngInject */
    function msNoteFormController($scope, NotesService, msUtils, $mdDialog, $timeout, LabelsService)
    {
        var MsNoteForm = this;
        var notes = NotesService.data;

        //Data
        MsNoteForm.type = '';
        MsNoteForm.defaultNote = {
            'id'         : '',
            'title'      : '',
            'description': '',
            'archive'    : false,
            'image'      : '',
            'color'      : '',
            'time'       : new Date().toISOString(),
            'reminder'   : null,
            'checklist'  : [],
            'labels'     : []
        };
        MsNoteForm.noteId = '';
        MsNoteForm.editNode = {};
        MsNoteForm.newCheckListItem = '';
        MsNoteForm.checkListForm = false;
        MsNoteForm.labels = LabelsService.data;

        MsNoteForm.ngFlowOptions = {
            singleFile: true
            // You can configure the ngFlow from here
            /*target                   : 'api/media/image',
             chunkSize                : 15 * 1024 * 1024,
             maxChunkRetries          : 1,
             simultaneousUploads      : 1,
             testChunks               : false,
             progressCallbacksInterval: 1000*/
        };
        MsNoteForm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {}
        };

        //Methods
        MsNoteForm.init = init;
        MsNoteForm.submit = submit;
        MsNoteForm.isNotValid = isNotValid;
        MsNoteForm.deleteNote = deleteNote;
        MsNoteForm.deleteImage = deleteImage;
        MsNoteForm.addChecklistItem = addChecklistItem;
        MsNoteForm.checklistFormToggle = checklistFormToggle;
        MsNoteForm.deleteCheckItem = deleteCheckItem;
        MsNoteForm.toggleArchive = toggleArchive;
        MsNoteForm.toggleInArray = msUtils.toggleInArray;
        MsNoteForm.exists = msUtils.exists;
        MsNoteForm.upload = upload;
        MsNoteForm.imageSuccess = imageSuccess;

        //////

        /**
         * Initialize
         */
        function init()
        {
            // If form type edit
            if ( MsNoteForm.type === 'edit' )
            {
                MsNoteForm.editNode = notes.getById(MsNoteForm.noteId);
                MsNoteForm.note = angular.copy(MsNoteForm.editNode);
            }
            // If form type new
            else
            {
                resetForm();
            }
        }

        /**
         * Watch New Note Form, reset form if it is closed
         */
        $scope.$on('MsNewNote:closed', function ()
        {
            resetForm();
        });

        /**
         * Reset Form
         */
        function resetForm()
        {
            $scope.$evalAsync(function ()
            {
                MsNoteForm.note = angular.copy(MsNoteForm.defaultNote);
                MsNoteForm.checkListForm = false;
            });
        }

        /**
         * Submit Form
         */
        function submit()
        {
            if ( MsNoteForm.type === 'new' )
            {
                add();
            }
            else if ( MsNoteForm.type === 'edit' )
            {
                save();
            }
        }

        /**
         * Add new note
         */
        function add()
        {
            if ( isNotValid() )
            {
                return;
            }

            MsNoteForm.note.id = msUtils.guidGenerator();
            MsNoteForm.note.time = new Date().toISOString();

            NotesService.addNote(angular.copy(MsNoteForm.note));

            MsNoteForm.note = angular.copy(MsNoteForm.defaultNote);

            $scope.$emit('MsNewNote:close');
        }

        /**
         * Save Note
         */
        function save()
        {
            if ( isNotValid() )
            {
                return;
            }
            NotesService.updateNote(MsNoteForm.note);
            $mdDialog.hide();
        }

        /**
         * Delete Note Image
         */
        function deleteImage()
        {
            MsNoteForm.note.image = '';
        }

        /**
         * Toggle Archive State
         */
        function toggleArchive()
        {
            if ( MsNoteForm.type === 'new' )
            {
                MsNoteForm.note.archive = true;
                submit();
            }
            else if ( MsNoteForm.type === 'edit' )
            {
                MsNoteForm.note.archive = !MsNoteForm.note.archive;
                save();
            }
        }

        /**
         * One of the image, title, description, checklist inputs are should be exist.
         * @returns {boolean}
         */
        function isNotValid()
        {
            return MsNoteForm.note.image === '' && MsNoteForm.note.title === '' && MsNoteForm.note.description === '' && MsNoteForm.note.checklist.length === 0;
        }

        /**
         * Delete Note
         * @param ev
         */
        function deleteNote(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the note?')
                .htmlContent('the note will be deleted permanently.')
                .ariaLabel('delete note')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                NotesService.deleteNote(MsNoteForm.note);
            });
        }

        /**
         * Add Checklist Item
         */
        function addChecklistItem()
        {
            if ( MsNoteForm.newCheckListItem === '' )
            {
                return;
            }

            MsNoteForm.note.checklist.push({
                checked: false,
                text   : MsNoteForm.newCheckListItem
            });

            MsNoteForm.newCheckListItem = '';

            focusChecklistInput();
        }

        /**
         * Checklist form toggle
         */
        function checklistFormToggle()
        {
            $scope.$evalAsync(function ()
            {
                MsNoteForm.checkListForm = !MsNoteForm.checkListForm;

                $timeout(function ()
                {
                    focusChecklistInput();
                });
            });
        }

        /**
         * Delete check item
         * @param item
         */
        function deleteCheckItem(item)
        {
            MsNoteForm.note.checklist.splice(MsNoteForm.note.checklist.indexOf(item), 1);
            focusChecklistInput();
        }

        /**
         * Focus checklist input
         */
        function focusChecklistInput()
        {
            angular.element('#new-checklist-item-input').focus();
        }

        /**
         * Upload
         */
        function upload()
        {
            // Set headers
            MsNoteForm.ngFlow.flow.opts.headers = {
                'X-Requested-With': 'XMLHttpRequest',
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
            };

            MsNoteForm.ngFlow.flow.upload();
        }

        /**
         * Image Success
         * @param file
         * @param message
         */
        function imageSuccess(file, message)
        {
            var fileReader = new FileReader();

            fileReader.readAsDataURL(file.file);

            fileReader.onload = function (event)
            {
                file.url = event.target.result;

                $scope.$evalAsync(function ()
                {
                    MsNoteForm.note.image = file.url;
                });
            };

            file.type = 'image';
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };

    }

    /** @ngInject */
    function msNoteFormDirective()
    {
        return {
            restrict    : 'EA',
            controller  : 'msNoteFormController',
            controllerAs: 'MsNoteForm',
            scope       : {
                noteType: '=',
                noteId  : '='
            },
            templateUrl : 'app/main/apps/notes/directives/ms-note-form/ms-note-form.html',
            link        : function (scope, element, attributes, MsNoteForm)
            {
                // Type
                MsNoteForm.type = scope.noteType;

                // Note id
                if ( angular.isDefined(scope.noteId) )
                {
                    MsNoteForm.noteId = scope.noteId;
                }

                MsNoteForm.init();

            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .controller('msNoteItemController', msNoteItemController)
        .directive('msNoteItem', msNoteItemDirective);

    /** @ngInject */
    function msNoteItemController($document)
    {
        var vm = this;
        var fontSizes = {
            '1': {
                fontSize  : 14,
                lineHeight: 19
            },
            '2': {
                fontSize  : 18,
                lineHeight: 28
            },
            '3': {
                fontSize  : 24,
                lineHeight: 36
            },
            '4': {
                fontSize  : 36,
                lineHeight: 48
            },
            '5': {
                fontSize  : 48,
                lineHeight: 60
            }
        };

        vm.element = [];
        vm.noFontResize = false;

        // Methods
        vm.updateDescriptionFontSize = updateDescriptionFontSize;

        //////

        function updateDescriptionFontSize()
        {
            if ( vm.noFontResize || !vm.note.description || vm.note.description === '' )
            {
                return;
            }

            var fontSize = '';
            var descWidth = Math.floor(vm.columnWidth - 52); // 48px paddings, + 4px tolerance
            var tmp = angular.element('<div style="visibility:hidden; font-size:10px;line-height: 10px;position:absolute;z-index:-1;white-space:pre-wrap;word-wrap: break-word;"></div>');
            tmp.appendTo($document.find('body'));

            fontSize = checkLineCount(sizeFromMaxWordCount());

            angular.element(vm.element).find('md-description').attr('font-size', fontSize);

            tmp.remove();

            function sizeFromMaxWordCount()
            {
                var words = vm.note.description.split(' ');

                var wordLengths = words.map(function (word)
                {
                    return tmp.text(word)[0].clientWidth;
                });

                var maxWordLength = Math.max.apply(Math, wordLengths);

                var maxPx = Math.floor((descWidth * 10) / maxWordLength);

                if ( maxPx < 18 )
                {
                    fontSize = 1;
                }
                else if ( 18 <= maxPx && maxPx < 24 )
                {
                    fontSize = 2;
                }
                else if ( 24 <= maxPx && maxPx < 36 )
                {
                    fontSize = 3;
                }
                else if ( 36 <= maxPx && maxPx < 48 )
                {
                    fontSize = 4;

                }
                else if ( maxPx >= 48 )
                {
                    fontSize = 5;
                }
                return fontSize;
            }

            function checkLineCount(sizeFromMaxWord)
            {
                var size = fontSizes[sizeFromMaxWord];
                var result;

                tmp.text(vm.note.description);
                tmp.width(descWidth);
                tmp.css({
                    'line-height': size.lineHeight + 'px',
                    'font-size'  : size.fontSize + 'px'
                });

                var lineCount = tmp[0].clientHeight / size.lineHeight;

                if ( 4 < lineCount && lineCount < 6 )
                {
                    result = 4;
                }
                else if ( 6 <= lineCount && lineCount < 9 )
                {
                    result = 3;
                }
                else if ( 9 <= lineCount && lineCount < 11 )
                {
                    result = 2;
                }
                else if ( 11 <= lineCount )
                {
                    result = 1;
                }
                else
                {
                    result = sizeFromMaxWord;
                }
                return result;
            }
        }
    }

    /** @ngInject */
    function msNoteItemDirective()
    {
        return {
            restrict        : 'A',
            controller      : 'msNoteItemController as MsNoteItem',
            templateUrl     : 'app/main/apps/notes/directives/ms-note-item/ms-note-item.html',
            require         : ['msNoteItem', '^msMasonry'],
            bindToController: {
                msNoteItem: '='
            },
            link            : function (scope, element, attributes, controllers)
            {

                var MsNoteItem = controllers[0];
                var msMasonry = controllers[1];

                MsNoteItem.element = element;
                MsNoteItem.note = MsNoteItem.msNoteItem;


                if ( angular.isDefined(attributes.noFontResize) )
                {
                    MsNoteItem.noFontResize = true;
                }

                scope.$watch('MsNoteItem.msNoteItem', function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        MsNoteItem.note = newVal;
                    }
                });

                scope.$on('msMasonryItem:startReLayout', function ()
                {
                    if ( MsNoteItem.noFontResize || MsNoteItem.columnWidth === msMasonry.columnWidth )
                    {
                        return;
                    }

                    MsNoteItem.columnWidth = msMasonry.columnWidth;

                    MsNoteItem.updateDescriptionFontSize();
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .controller('msNewNoteController', msNewNoteController)
        .directive('msNewNoteButton', msNewNoteButtonDirective)
        .directive('msNewNote', msNewNoteDirective);

    /** @ngInject */
    function msNewNoteController($scope, $document)
    {
        var MsNewNote = this;

        //Data
        MsNewNote.formVisible = false;
        MsNewNote.form = {
            title      : '',
            description: ''
        };

        //Methods
        MsNewNote.open = open;
        MsNewNote.close = close;
        MsNewNote.element = [];

        //////

        /**
         * Close Trigger
         */
        $scope.$on('MsNewNote:close', function ()
        {
            close();
        });

        /**
         * Open new note form
         */
        function open()
        {
            MsNewNote.element.addClass('form-visible');
            MsNewNote.element.find('textarea').focus();
            $document.on('click', outSideClick);
        }

        /**
         * Close new note form
         */
        function close()
        {
            MsNewNote.element.removeClass('form-visible');
            $scope.$broadcast('MsNewNote:closed');

            $document.off('click', outSideClick);
        }

        /**
         * Click Outside Event Handler
         * @param event
         */
        function outSideClick(event)
        {
            var isChild = MsNewNote.element.has(event.target).length > 0;
            var isSelf = MsNewNote.element[0] === event.target;
            var isMenu = angular.element(event.target).closest('md-menu-content').length > 0;
            var isCalendar = angular.element(event.target).closest('md-calendar').length > 0 || angular.element(event.target).closest('.md-datepicker-calendar-pane').length > 0 || angular.element(event.target).hasClass('md-scroll-mask');

            var isInside = isChild || isSelf || isMenu || isCalendar;

            if ( !isInside )
            {
                close();
            }
        }
    }

    /** @ngInject */
    function msNewNoteDirective()
    {
        return {
            restrict    : 'E',
            controller  : 'msNewNoteController',
            controllerAs: 'MsNewNote',
            templateUrl : 'app/main/apps/notes/directives/ms-new-note/ms-new-note.html',
            link        : function (scope, element, attributes, MsNewNote)
            {
                MsNewNote.element = element;
            }
        };
    }

    /** @ngInject */
    function msNewNoteButtonDirective()
    {
        return {
            restrict: 'EA',
            require : '^msNewNote',
            link    : function (scope, element, attributes, msNewNote)
            {
                element.on('click', function ()
                {
                    msNewNote.open();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.mail', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, msUtilProvider) {
        // State
        $stateProvider
            .state('app.mail', {
                abstract: true,
                url: '/mail',
                resolve: {
                    Folders: function (msApi) {
                        return msApi.resolve('mail.folders@get');
                    },
                    Labels: function (msApi) {
                        return msApi.resolve('mail.labels@get');
                    }
                }
            })
            .state('app.mail.threads', {
                url: '/{type:(?:label)}/:filter',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/mail/mail.html',
                        controller: 'MailController as vm'
                    }
                },
                params: {
                    type: {
                        value: null,
                        squash: true
                    }
                },
                bodyClass: 'mail'
            })
            .state('app.mail.threads.thread', {
                url: '/:threadId',
                bodyClass: 'mail'
            });

        // Translation
        var base = 'app/main/apps/mail';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }
        // Api
        msApiProvider.register('mail.folders', ['app/data/mail/folders.json']);
        msApiProvider.register('mail.labels', ['app/data/mail/labels.json']);

        msApiProvider.register('mail.label.notes', ['app/data/mail/labels/notes.json']);
        msApiProvider.register('mail.label.paypal', ['app/data/mail/labels/paypal.json']);
        msApiProvider.register('mail.label.invoices', ['app/data/mail/labels/invoices.json']);
        msApiProvider.register('mail.label.amazon', ['app/data/mail/labels/amazon.json']);

        msApiProvider.register('mail.folder.inbox', ['app/data/mail/folders/inbox.json']);
        msApiProvider.register('mail.folder.sent', ['app/data/mail/folders/sent.json']);
        msApiProvider.register('mail.folder.drafts', ['app/data/mail/folders/drafts.json']);
        msApiProvider.register('mail.folder.spam', ['app/data/mail/folders/spam.json']);
        msApiProvider.register('mail.folder.trash', ['app/data/mail/folders/trash.json']);
        msApiProvider.register('mail.folder.starred', ['app/data/mail/folders/starred.json']);
        msApiProvider.register('mail.folder.important', ['app/data/mail/folders/important.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('apps.mail', {
            title: 'Mail',
            icon: 'icon-email',
            state: 'app.mail.threads',
            stateParams: {
                filter: 'inbox'
            },
            badge: {
                content: 25,
                color: '#F44336'
            },
            weight: 4
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.mail')
        .controller('ComposeDialogController', ComposeDialogController);

    /** @ngInject */
    function ComposeDialogController($mdDialog, selectedMail)
    {
        var vm = this;

        // Data
        vm.form = {
            from: 'johndoe@creapond.com'
        };

        vm.hiddenCC = true;
        vm.hiddenBCC = true;

        // If replying
        if ( angular.isDefined(selectedMail) )
        {
            vm.form.to = selectedMail.from.email;
            vm.form.subject = 'RE: ' + selectedMail.subject;
            vm.form.message = '<blockquote>' + selectedMail.message + '</blockquote>';
        }

        // Methods
        vm.closeDialog = closeDialog;

        //////////

        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();



(function () {
    'use strict';

    angular
        .module('app.clients')
        .constant('_', window._)
        .controller('NewStakeDialogController', NewStakeDialogController);

    /** @ngInject */
    function NewStakeDialogController($scope, $mdDialog, sectors, regions, $stateParams, $document, documentsService, staffService,
        sessionService, clientsService, regionsLiterals, company, main_branch, $translate) {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.saveDialog = saveDialog;
        vm.getRegionLiteral = getRegionLiteral;
        vm.sectors = sectors;
        vm.regions = regions;
        vm.regionsLiterals = regionsLiterals;
        vm.mediaDialogSingle = mediaDialogSingle;
        vm.deleteLogotype = deleteLogotype;
        $scope.owner = $stateParams.owner;
        vm.company = company ? company : {};
/*
        vm.main_branch = main_branch ? main_branch : {}

        if (vm.company.id) {
            staffService.getMainBranch({ owner: $scope.owner, id_company: vm.company.id }).then(res => {
                vm.main_branch = res.data[0];
            })
        }
        if (vm.company.logo && vm.company.logo.length > 0) {
            var options = {
                owner: $scope.owner
            };
            clientsService.getStoragePrefix(options).then(function (res) {
                $scope.imageUrl = res.prefix + vm.company.logo[0].url;
                vm.logoIsLoaded = true;
            })
        }
        if (!vm.company.region_id) {
            vm.company.region_id = sessionService.user.region_id;
        }
        */
        function saveDialog() {
 //           if (!vm.main_branch.name) {
 //               vm.main_branch.name = vm.company.name;
 //           }
 //           $mdDialog.hide({ company: vm.company, branch: vm.main_branch, image: $scope.image, updateLogotype: vm.updateLogotype });
            $mdDialog.hide({ company: vm.company });
        }
        function mediaDialogSingle(ev, field) {
            $mdDialog.show({
                controller: 'MediaClientsController',
                controllerAs: 'vm',
                locals: {
                    owner: $scope.owner,
                    multipleSelection: true,
                    isTiny: false
                },
                templateUrl: 'app/main/apps/clients/dialogs/media/media-clients.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                multiple: true
            }).then(function (image) {
                if (image) {
                    vm.updateLogotype = true;
                    $scope.image = image;
                }
            });
        }
        function deleteLogotype() {
            if (vm.company.logo && vm.company.logo.length > 0) {
                for (var i = 0; i < vm.company.logo.length; i++) {
                    const itemLogo = vm.company.logo[i];
                    var options = {
                        owner: $scope.owner,
                        id: itemLogo.id
                    }
                    documentsService.deleteDocument(options).then(function () {
                        vm.company.logo = null;
                    })
                }
            }
            $scope.image = undefined;
            $scope.imageUrl = undefined;
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function getRegionLiteral(literalKey) {
            if (!angular.isUndefined(vm.company) && vm.company.region_id) {
                const literalsObject = vm.regionsLiterals.find(x => x.region_id === vm.company.region_id)
                return literalsObject.literals[literalKey];
            } else {
                return 'CIF/NIF';
            }
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.gantt-chart', [
            'gantt',
            'gantt.sortable',
            'gantt.movable',
            'gantt.drawtask',
            'gantt.tooltips',
            'gantt.bounds',
            'gantt.progress',
            'gantt.table',
            'gantt.tree',
            'gantt.groups',
            'gantt.dependencies',
            'gantt.overlap',
            'ngAnimate',
            'gantt.resizeSensor'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msUtilProvider, msApiProvider)
    {

        $stateProvider.state('app.gantt-chart', {
            url    : '/gantt-chart',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/gantt-chart/gantt-chart.html',
                    controller : 'GanttChartController as vm'
                }
            },
            resolve: {
                Tasks    : function (msApi)
                {
                    return msApi.resolve('ganttChart.tasks@get');
                },
                Timespans: function (msApi)
                {
                    return msApi.resolve('ganttChart.timespans@get');
                }
            }
        });

        // Translation
        var base = 'app/main/apps/gantt-chart';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }
        // Navigation
        // msNavigationServiceProvider.saveItem('apps.gantt-chart', {
        //     title : 'Gantt Chart',
        //     icon  : 'icon-calendar-text',
        //     state : 'app.gantt-chart',
        //     weight: 7
        // });

        // Api
        msApiProvider.register('ganttChart.tasks', ['app/data/gantt-chart/tasks.json']);
        msApiProvider.register('ganttChart.timespans', ['app/data/gantt-chart/timespans.json']);

    }

})();
(function ()
{
    'use strict';

    angular.module('app.gantt-chart')
        .controller('GanttChartAddEditDialogController', GanttChartAddEditDialogController);

    /** @ngInject */
    function GanttChartAddEditDialogController($mdDialog, ganttUtils, dialogData, fuseGenerator)
    {
        var vm = this;

        // Data
        vm.chartData = dialogData.chartData;
        vm.dialogType = dialogData.dialogType;

        /// Edit Dialog
        if ( vm.dialogType === 'edit' )
        {
            vm.formView = dialogData.formView;
            vm.row = vm.task = angular.copy(dialogData.formData.model);
        }

        /// Add Dialog
        else if ( vm.dialogType === 'add' )
        {
            vm.row = {
                id      : ganttUtils.randomUuid(),
                name    : '',
                tasks   : [],
                classes : ['', ''],
                sortable: true,
                parent  : ''
            };
            vm.task = {
                id      : ganttUtils.randomUuid(),
                name    : '',
                classes : ['', ''],
                from    : '',
                to      : '',
                progress: ''
            };
            vm.taskRowId = '';
        }

        // Methods
        vm.addNewRow = addNewRow;
        vm.saveRow = saveRow;
        vm.removeRow = removeRow;
        vm.addNewTask = addNewTask;
        vm.saveTask = saveTask;
        vm.removeTask = removeTask;
        vm.closeDialog = closeDialog;
        vm.rgba = fuseGenerator.rgba;

        //////////

        /**
         * Add New Row
         */
        function addNewRow()
        {
            vm.chartData.push(vm.row);

            closeDialog();
        }

        /**
         * Save Row
         */
        function saveRow()
        {
            dialogData.formData.model = vm.row;

            closeDialog();
        }

        /**
         * Remove Row
         */
        function removeRow()
        {
            vm.chartData.splice(vm.chartData.indexOf(vm.chartData.getById(vm.row.id)), 1);

            closeDialog();
        }

        /**
         * Add New Task
         */
        function addNewTask()
        {
            vm.chartData.getById(vm.taskRowId).tasks.push(angular.copy(vm.task));

            closeDialog();
        }

        /**
         * Save Task
         */
        function saveTask()
        {
            dialogData.formData.model = vm.task;

            closeDialog();
        }

        /**
         * Remove Task
         */
        function removeTask()
        {
            var taskRow = vm.chartData.getById(dialogData.formData.row.model.id);

            taskRow.tasks.splice(taskRow.tasks.indexOf(taskRow.tasks.getById(vm.task.id)), 1);

            closeDialog();
        }


        /**
         * Close Dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.documents', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider , 
        msUtilProvider, msNavigationServiceProvider, ivhTreeviewOptionsProvider) {

        // State


        $stateProvider.state('app.document', {
            url: '/documents',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/documents/documents.html',
                    controller: 'DocumentsController as vm'
                }
            },
            bodyClass: 'clients'
        });

        $stateProvider
            .state('app.site_overview.document', {
                abstract: true,
                url: '/documents',
                onEnter: function ($stateParams) {


                },
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                    section: function ($stateParams) {             
                        return $stateParams.owner
                    },
                },


            })
            .state('app.site_overview.document.list', {
                url: '',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/documents/documents.html',
                        controller: 'DocumentsController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.document.list.thread', {
                url: '/:id',
                bodyClass: 'documents'
            })

       // Translation
       var base = 'app/main/apps/documents';
       var base18 = base + '/i18n/';
       $translatePartialLoaderProvider.addPart(base);
       if (msUtilProvider.$get().getTenantTranslate(base18)) {
           $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
       }
    }
})();
(function () {
	'use strict';

	angular
        .module('app.documents')
		.directive('h2cOnSelectGroup', ['documentsService', selectGroup])
		.controller('ImportDialogController', ImportDialogController);

	/** @ngInject */
	function ImportDialogController($mdDialog, $scope, $timeout, owner, $translate, Upload, groups, documentsService) {
		var vm = this;

		vm.closeDialog = closeDialog;
		vm.resetForm = resetForm;
		vm.owner = owner;
		vm.upload = upload;
		vm.importFile = importFile;
		vm.isLoading = false;
		vm.groups = groups;
		vm.groupId = null;
		vm.importError = false;
		vm.resetForm();

		vm.translate = function (text) {
			return $translate.instant(text);
		}


		function resetForm() {
			vm.isLoading = false;
			delete vm.importFinished;
			delete vm.files;
		}



		function importFile() {
			vm.isLoading = true;
			documentsService.finishedUploadingFile({
				owner: vm.owner,
				token: vm.token
			}).then(function (response) {
				vm.isLoading = false;
				$mdDialog.hide({ update: true });
			}, function (error) {
				vm.isLoading = false;
				vm.importError = error;
			})
		}


		$scope.$watch('vm.files', function () {
			$scope.formUpload = false;
			if (vm.files != null) {
				// make files array for not multiple to be able to be used in ng-repeat in the ui
				if (!angular.isArray(vm.files)) {
					$timeout(function () {
						$scope.files = vm.files = [vm.files];
					});
					return;
				}
				for (var i = 0; i < vm.files.length; i++) {
					$scope.errorMsg = null;
					(function (f) {
						vm.upload(f, true);
					})(vm.files[i]);
				}
			}
		});


		$scope.$on('selectGroup', function (event, group) {
			vm.groupId = group.id;
			$scope.$digest();
		});

		function upload(file) {
			if (!file.$error) {
				//				console.debug("UPLOAD______****", file)
				documentsService.getS3UploadPreSignedUrl({
					owner: vm.owner,
					fileName: file.name,
					groupId: vm.groupId
				})
					.then(function (resp) {
						vm.token = resp.token;
						file.upload = Upload.http({
							url: resp.url,
							skipAuthorization: true,
							method: 'PUT',
							headers: {
								"Content-Type": file.type != '' ? file.type : 'application/octet-stream'
							},
							data: file
						});

						file.upload.then(function (response) {
							file.result = response.data;
							$timeout(function () {
								$scope.log = 'file: ' +
									file.name +
									', Response: ' + JSON.stringify(response.data) +
									', ID: ' + file.id_media +
									'\n' + $scope.log;
							});

							vm.importFinished = true;
						}, function (response) {
							if (response.status > 0)
								$scope.errorMsg = response.status + ': ' + response.data;
						});

						file.upload.progress(function (evt) {
							file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});

					})
			}
		};


		function closeDialog() {
			$mdDialog.hide();
		}
	}


	function selectGroup(documentsService) {

		function unselectAllGroups() {
			var elemList = document.querySelectorAll('.group-row');
			elemList.forEach(function (elem) {
				elem.classList.remove('selected');
			});
		}

		return {
			restrict: 'A',
			link: function (scope, element, attrs) {
				$(element).on('click', function (e) {
					unselectAllGroups();
					element.parent().addClass('selected');
					documentsService.triggerSelectGroup(scope.node);
				});
			}
		};
	}
})();

(function () {
    'use strict';

    angular
        .module('app.documents')
        .controller('DeleteDocumentDialogController', DeleteDocumentDialogController);

    /** @ngInject */
    function DeleteDocumentDialogController(
        $mdDialog,
        $document,
        selectedThreads,
        owner,
        requestContext,
        $anchorScroll,
        $timeout,
        $scope,
        $sce,
        msUtils,
        COMMON,
        $log,
        $translate,
        documentsService,
        $rootScope,
        $mdToast
    ) {
        var vm = this;

        // Data
        vm.selectedThreads = selectedThreads;
        vm.selectedIds = [];
        vm.owner = owner;
        vm.isLoading = false;
        vm.mediaRelations = false;


        // Methods
        vm.delete = deleteItems;
        vm.cancel = cancel;


        vm.translate = function (text) {
            return $translate.instant(text);
        }

        init();
        /**
         * Initialize
         */
        function init() {

            for (var i = 0; i < vm.selectedThreads.length; i++) {
                vm.selectedIds.push(vm.selectedThreads[i].id_media);
            }
        }

        function cancel() {
            $mdDialog.hide(false);
        }


        function deleteItems() {
            vm.isLoading = true;

            if (vm.selectedIds.length == 1) {
                var message = $translate.instant('DOCUMENTS.DELETED');
            } else {
                var message = vm.selectedIds.length + ' ' + $translate.instant('DOCUMENTS.DELETED_PLURAL');
            }


            var count = 0;
            for (var i = 0; i < vm.selectedThreads.length; i++) {
                const element = vm.selectedThreads[i];
                var options = {
                    owner: vm.owner,
                    id: element.id
                };
                documentsService.deleteDocument(options).then(function (response) {
                    count++;
                    if (count == vm.selectedThreads.length) {
                        vm.isLoading = false;
                        $mdToast.show({
                            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                            hideDelay: 5000,
                            position: 'top',
                            parent: '#content-container'
                        });
                        $mdDialog.hide(true);
                    }

                });
            }


        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.documents')
        .controller('EditGroupDialogController', EditGroupDialogController)
        .directive('h2cOnClickSelectParentGroup', ['documentsService', SelectParentGroup]);

    /** @ngInject */
    function EditGroupDialogController($scope, $mdDialog, group, groups, groupParentId, owner, edit, documentsService, transformUsers, $translate) {

        var vm = this;

        vm.owner = owner;
        vm.group = group;
        vm.edit = edit;
        vm.groups = groups;
        vm.groupName = group.name;
        vm.groupParentId = groupParentId;
        vm.groupParentName = '';
        vm.selectParentGroupRoot = selectParentGroupRoot;
        vm.groups = removeGroupFromNestedGroups(group, angular.copy(vm.groups));
        vm.selectParentGroup = selectParentGroup;
        var unnestedGroups = getUnnestedGroups(angular.copy(vm.groups), []);
        angular.forEach(unnestedGroups, function (obj) {
            if (obj.id == group.parent_id) {
                vm.groupParentName = obj.name;
            }
        });
        vm.selectParentGroup({ id: groupParentId, name: vm.groupParentName });
        vm.translate = function (text) {
            return $translate.instant(text);
        }

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.delete = function (group, ev) {
            const message = $translate.instant('GLOBAL.ARE_YOU_SURE');
            const yes = $translate.instant('GLOBAL.YES');
            const no = $translate.instant('GLOBAL.NO');
            // TODO: show advice that users from group won't be deleted.
            const confirm = $mdDialog.confirm()
                .title(message)
                .targetEvent(ev)
                .ok(yes)
                .cancel(no).multiple(true);

            $mdDialog.show(confirm).then(e => {
                documentsService
                    .deleteGroup(owner, group.id)
                    .then(function (response) {
                        // TODO: show success message
                        $mdDialog.hide({ update: true });

                    });
            })

        };

        $scope.save = function (group) {
            if (angular.equals({}, group)) {
                documentsService
                    .createGroup(owner, vm.groupParentId, vm.groupName)
                    .then(function (response) {
                        // TODO: show success message
                        $mdDialog.hide({ update: true });
                    });
            } else {
                documentsService
                    .saveGroup(owner, group.id, vm.groupParentId, vm.groupName)
                    .then(function (response) {
                        // TODO: show success message
                        $mdDialog.hide({ update: true });
                    });
            }

        };

        $scope.$on('selectParentGroup', function (event, parentGroup) {
            selectParentGroup(parentGroup)
        });

        function selectParentGroup(parentGroup) {
            vm.groupParentId = parentGroup.id;
            vm.groupParentName = parentGroup.name;
        }

        function selectParentGroupRoot() {
            vm.groupParentName = $translate.instant('DOCUMENTS.ROOT');
            vm.groupParentId = null;
        }

        function removeGroupFromNestedGroups(group, groups) {
            angular.forEach(groups, function (obj) {
                if (group.id == obj.id) {
                    var index = groups.indexOf(obj);
                    groups.splice(index, 1);
                }
                if (typeof obj.children !== 'undefined' && obj.children.length > 0) {
                    removeGroupFromNestedGroups(group, obj.children);
                }
            });
            return groups;
        }
        function getUnnestedGroups(groups, result) {
            angular.forEach(groups, function (group) {
                if (group.id) {
                    result.push(group);
                    if (typeof group.children !== 'undefined' && group.children.length > 0) {
                        getUnnestedGroups(group.children, result);
                    }
                }
            });
            return result;
        }



    }


    function SelectParentGroup(documentsService) {

        function unselectAllGroups() {
            var elemList = document.querySelectorAll('.select-parent-group-row');
            elemList.forEach(function (elem) {
                elem.classList.remove('selected');
            });
        }

        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {
                    var groupNode = false;
                    if (element.parent().hasClass('selected')) {
                        unselectAllGroups();
                    } else {
                        unselectAllGroups();
                        element.parent().addClass('selected');
                        groupNode = scope.node;
                    }
                    documentsService.triggerSelectParentGroup(groupNode);
                });
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.e-commerce',
            [
                'flow'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msUtilProvider)
    {
        // State
        $stateProvider
            .state('app.e-commerce', {
                abstract: true,
                url     : '/e-commerce'
            })
            .state('app.e-commerce.dashboard', {
                url      : '/dashboard',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/dashboard/dashboard.html',
                        controller : 'DashboardEcommerceController as vm'
                    }
                },
                resolve  : {
                    Dashboard: function (msApi)
                    {
                        return msApi.resolve('e-commerce.dashboard@get');
                    }
                },
                bodyClass: 'ecommerce'
            })
            .state('app.e-commerce.products', {
                url      : '/airplanes',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/products/products.html',
                        controller : 'ProductsController as vm'
                    }
                },
                resolve  : {
                    Products: function (msApi)
                    {
                        return msApi.resolve('e-commerce.products@get');
                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.products.detail', {
                url      : '/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/product/product.html',
                        controller : 'ProductController as vm'
                    }
                },
                resolve  : {
                    Product: function (msApi)
                    {
                        return msApi.resolve('e-commerce.product@get');
                    }
                },
                bodyClass: 'e-commerce'
            });
            // .state('app.e-commerce.orders', {
            //     url      : '/orders',
            //     views    : {
            //         'content@app': {
            //             templateUrl: 'app/main/apps/e-commerce/views/orders/orders.html',
            //             controller : 'OrdersController as vm'
            //         }
            //     },
            //     resolve  : {
            //         Orders  : function (msApi)
            //         {
            //             return msApi.resolve('e-commerce.orders@get');
            //         },
            //         Statuses: function (msApi)
            //         {
            //             return msApi.resolve('e-commerce.statuses@get');
            //         }
            //     },
            //     bodyClass: 'e-commerce'
            // })
            // .state('app.e-commerce.orders.detail', {
            //     url      : '/:id',
            //     views    : {
            //         'content@app': {
            //             templateUrl: 'app/main/apps/e-commerce/views/order/order.html',
            //             controller : 'OrderController as vm'
            //         }
            //     },
            //     resolve  : {
            //         Order   : function (msApi)
            //         {
            //             return msApi.resolve('e-commerce.order@get');
            //         },
            //         Statuses: function (msApi)
            //         {
            //             return msApi.resolve('e-commerce.statuses@get');
            //         }
            //     },
            //     bodyClass: 'e-commerce'
            // });

        // Translation
        var base = 'app/main/apps/e-commerce';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }
        // Api
        msApiProvider.register('e-commerce.dashboard', ['app/data/e-commerce/dashboard.json']);
        msApiProvider.register('e-commerce.products', ['app/data/e-commerce/products.json']);
        msApiProvider.register('e-commerce.product', ['app/data/e-commerce/product.json']);
        msApiProvider.register('e-commerce.orders', ['app/data/e-commerce/orders.json']);
        msApiProvider.register('e-commerce.statuses', ['app/data/e-commerce/statuses.json']);
        msApiProvider.register('e-commerce.order', ['app/data/e-commerce/order.json']);

        // Navigation
        // msNavigationServiceProvider.saveItem('apps.e-commerce', {
        //     title : 'E-Commerce',
        //     icon  : 'icon-cart',
        //     weight: 3
        // });

        // msNavigationServiceProvider.saveItem('apps.e-commerce.dashboard', {
        //     title: 'Dashboard',
        //     state: 'app.e-commerce.dashboard'
        // });

        // msNavigationServiceProvider.saveItem('apps.products', {
        //     title: 'Aircraft',
        //     icon  : 'icon-airplane',
        //     state: 'app.e-commerce.products',
        //     weight: 3
        // });
        //
        // msNavigationServiceProvider.saveItem('apps.e-commerce.orders', {
        //     title: 'Orders',
        //     state: 'app.e-commerce.orders'
        // });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.e-commerce')
        .controller('ProductsController', ProductsController);

    /** @ngInject */
    function ProductsController($state, Products)
    {
        var vm = this;

        // Data
        vm.products = Products.data;

        vm.dtInstance = {};
        vm.dtOptions = {
            dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs  : [
                {
                    // Target the id column
                    targets: 0,
                    width  : '72px'
                },
                {
                    // Target the image column
                    targets   : 1,
                    filterable: false,
                    sortable  : false,
                    width     : '80px'
                },
                {
                    // Target the quantity column
                    targets: 3,
                    render : function (data, type)
                    {
                        if ( type === 'display' )
                        {
                            if ( parseInt(data) <= 5 )
                            {
                                return '<div layout="row" layout-align="start center"><div class="quantity-indicator md-red-500-bg"></div><div>' + data + '</div></div>';
                            }
                            else if ( parseInt(data) > 5 && parseInt(data) <= 25 )
                            {
                                return '<div layout="row" layout-align="start center"><div class="quantity-indicator md-amber-500-bg"></div><div>' + data + '</div></div>';
                            }
                            else
                            {
                                return '<div layout="row" layout-align="start center"><div class="quantity-indicator md-green-600-bg"></div><div>' + data + '</div></div>';
                            }
                        }

                        return data;
                    }
                },
                {
                    // Target the status column
                    targets   : 4,
                    filterable: false,
                    render    : function (data, type)
                    {
                        if ( type === 'display' )
                        {
                            if ( data === 'true' )
                            {
                                return '<i class="icon-checkbox-marked-circle green-500-fg"></i>';
                            }

                            return '<i class="icon-cancel red-500-fg"></i>';
                        }

                        if ( type === 'filter' )
                        {
                            if ( data )
                            {
                                return '1';
                            }

                            return '0';
                        }

                        return data;
                    }
                },
                {
                    // Target the actions column
                    targets           : 5,
                    responsivePriority: 1,
                    filterable        : false,
                    sortable          : false
                }
            ],
            initComplete: function ()
            {
                var api = this.api(),
                    searchBox = angular.element('body').find('#e-commerce-products-search');

                // Bind an external input as a table wide search box
                if ( searchBox.length > 0 )
                {
                    searchBox.on('keyup', function (event)
                    {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType  : 'simple',
            lengthMenu  : [10, 20, 30, 50, 100],
            pageLength  : 20,
            scrollY     : 'auto',
            responsive  : true
        };

        // Methods
        vm.gotoProductDetail = gotoProductDetail;

        //////////

        /**
         * Go to product detail
         *
         * @param id
         */
        function gotoProductDetail(id)
        {
            $state.go('app.e-commerce.products.detail', {id: id});
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.e-commerce')
        .controller('ProductController', ProductController);

    /** @ngInject */
    function ProductController($document, $state, Product)
    {
        var vm = this;

        // Data
        vm.taToolbar = [
            ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
        ];
        vm.product = Product.data;
        vm.categoriesSelectFilter = '';
        vm.ngFlowOptions = {
            // You can configure the ngFlow from here
            /*target                   : 'api/media/image',
             chunkSize                : 15 * 1024 * 1024,
             maxChunkRetries          : 1,
             simultaneousUploads      : 1,
             testChunks               : false,
             progressCallbacksInterval: 1000*/
        };
        vm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {}
        };
        vm.dropping = false;

        // Methods
        vm.gotoProducts = gotoProducts;
        vm.onCategoriesSelectorOpen = onCategoriesSelectorOpen;
        vm.onCategoriesSelectorClose = onCategoriesSelectorClose;
        vm.fileAdded = fileAdded;
        vm.upload = upload;
        vm.fileSuccess = fileSuccess;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Select the correct product from the data.
            // This is an unnecessary step for a real world app
            // because normally, you would request the product
            // with its id and you would get only one product.
            // For demo purposes, we are grabbing the entire
            // json file which have more than one product details
            // and then hand picking the requested product from
            // it.
            var id = $state.params.id;

            for ( var i = 0; i < vm.product.length; i++ )
            {
                if ( vm.product[i].id === parseInt(id) )
                {
                    vm.product = vm.product[i];
                    break;
                }
            }
            // END - Select the correct product from the data
        }

        /**
         * Go to products page
         */
        function gotoProducts()
        {
            $state.go('app.e-commerce.products');
        }

        /**
         * On categories selector open
         */
        function onCategoriesSelectorOpen()
        {
            // The md-select directive eats keydown events for some quick select
            // logic. Since we have a search input here, we don't need that logic.
            $document.find('md-select-header input[type="search"]').on('keydown', function (e)
            {
                e.stopPropagation();
            });
        }

        /**
         * On categories selector close
         */
        function onCategoriesSelectorClose()
        {
            // Clear the filter
            vm.categoriesSelectFilter = '';

            // Unbind the input event
            $document.find('md-select-header input[type="search"]').unbind('keydown');
        }

        /**
         * File added callback
         * Triggers when files added to the uploader
         *
         * @param file
         */
        function fileAdded(file)
        {
            // Prepare the temp file data for media list
            var uploadingFile = {
                id  : file.uniqueIdentifier,
                file: file,
                type: 'uploading'
            };

            // Append it to the media list
            vm.product.images.unshift(uploadingFile);
        }

        /**
         * Upload
         * Automatically triggers when files added to the uploader
         */
        function upload()
        {
            // Set headers
            vm.ngFlow.flow.opts.headers = {
                'X-Requested-With': 'XMLHttpRequest',
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
            };

            vm.ngFlow.flow.upload();
        }

        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function fileSuccess(file, message)
        {
            // Iterate through the media list, find the one we
            // are added as a temp and replace its data
            // Normally you would parse the message and extract
            // the uploaded file data from it
            angular.forEach(vm.product.images, function (media, index)
            {
                if ( media.id === file.uniqueIdentifier )
                {
                    // Normally you would update the media item
                    // from database but we are cheating here!
                    var fileReader = new FileReader();
                    fileReader.readAsDataURL(media.file.file);
                    fileReader.onload = function (event)
                    {
                        media.url = event.target.result;
                    };

                    // Update the image type so the overlay can go away
                    media.type = 'image';
                }
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.e-commerce')
        .controller('OrdersController', OrdersController);

    /** @ngInject */
    function OrdersController($state, Statuses, Orders)
    {
        var vm = this;

        // Data
        vm.orders = Orders.data;
        vm.statuses = Statuses.data;

        vm.dtInstance = {};
        vm.dtOptions = {
            dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs  : [
                {
                    // Target the id column
                    targets: 0,
                    width  : '72px'
                },
                {
                    // Target the status column
                    targets: 6,
                    render : function (data, type)
                    {
                        if ( type === 'display' )
                        {
                            var orderStatus = vm.getOrderStatus(data);
                            return '<span class="status ' + orderStatus.color + '">' + orderStatus.name + '</span>';
                        }

                        if ( type === 'filter' )
                        {
                            return vm.getOrderStatus(data).name;
                        }

                        return data;
                    }
                },
                {
                    // Target the actions column
                    targets           : 8,
                    responsivePriority: 1,
                    filterable        : false,
                    sortable          : false
                }
            ],
            initComplete: function ()
            {
                var api = this.api(),
                    searchBox = angular.element('body').find('#e-commerce-products-search');

                // Bind an external input as a table wide search box
                if ( searchBox.length > 0 )
                {
                    searchBox.on('keyup', function (event)
                    {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType  : 'simple',
            lengthMenu  : [10, 20, 30, 50, 100],
            pageLength  : 20,
            scrollY     : 'auto',
            responsive  : true
        };

        // Methods
        vm.getOrderStatus = getOrderStatus;
        vm.gotoOrderDetail = gotoOrderDetail;

        //////////

        /**
         * Get order status
         *
         * @param id
         * @returns {*}
         */
        function getOrderStatus(id)
        {
            for ( var i = 0; i < vm.statuses.length; i++ )
            {
                if ( vm.statuses[i].id === parseInt(id) )
                {
                    return vm.statuses[i];
                }
            }
        }

        /**
         * Go to product detail
         *
         * @param id
         */
        function gotoOrderDetail(id)
        {
            $state.go('app.e-commerce.orders.detail', {id: id});
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.e-commerce')
        .controller('OrderController', OrderController);

    /** @ngInject */
    function OrderController($state, Statuses, uiGmapGoogleMapApi, Order)
    {
        var vm = this;

        // Data
        vm.order = Order.data;
        vm.statuses = Statuses.data;
        vm.dtInstance = {};
        vm.dtOptions = {
            dom       : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs: [
                {
                    // Target the id column
                    targets: 0,
                    width  : '72px'
                },
                {
                    // Target the image column
                    targets   : 1,
                    filterable: false,
                    sortable  : false,
                    width     : '80px'
                },
                {
                    // Target the actions column
                    targets           : 5,
                    responsivePriority: 1,
                    filterable        : false,
                    sortable          : false
                }
            ],
            pagingType: 'simple',
            lengthMenu: [10, 20, 30, 50, 100],
            pageLength: 20,
            responsive: true
        };

        vm.newStatus = '';

        // Methods
        vm.gotoOrders = gotoOrders;
        vm.gotoProductDetail = gotoProductDetail;
        vm.updateStatus = updateStatus;

        //////////

        init();

        // Normally, you would need Google Maps Geocoding API
        // to convert addresses into latitude and longitude
        // but because Google's policies, we are faking it for
        // the demo
        uiGmapGoogleMapApi.then(function (maps)
        {
            vm.shippingAddressMap = {
                center: {
                    latitude : -34.397,
                    longitude: 150.644
                },
                marker: {
                    id: 'shippingAddress'
                },
                zoom  : 8
            };

            vm.invoiceAddressMap = {
                center: {
                    latitude : -34.397,
                    longitude: 150.644
                },
                marker: {
                    id: 'invoiceAddress'
                },
                zoom  : 8
            };
        });

        /**
         * Initialize
         */
        function init()
        {
            // Select the correct order from the data.
            // This is an unnecessary step for a real world app
            // because normally, you would request the product
            // with its id and you would get only one product.
            // For demo purposes, we are grabbing the entire
            // json file which have more than one product details
            // and then hand picking the requested product from
            // it.
            var id = $state.params.id;

            for ( var i = 0; i < vm.order.length; i++ )
            {
                if ( vm.order[i].id === parseInt(id) )
                {
                    vm.order = vm.order[i];
                    break;
                }
            }
            // END - Select the correct product from the data
        }

        /**
         * Go to orders page
         */
        function gotoOrders()
        {
            $state.go('app.e-commerce.orders');
        }

        /**
         * Go to product page
         * @param id
         */
        function gotoProductDetail(id)
        {
            $state.go('app.e-commerce.products.detail', {id: id});
        }

        /**
         * Update order status
         *
         * @param id
         */
        function updateStatus(id)
        {
            if ( !id )
            {
                return;
            }

            for ( var i = 0; i < vm.statuses.length; i++ )
            {
                if ( vm.statuses[i].id === parseInt(id) )
                {
                    vm.order.status.unshift({
                        id   : vm.statuses[i].id,
                        name : vm.statuses[i].name,
                        color: vm.statuses[i].color,
                        date : moment().format('YYYY/MM/DD HH:mm:ss')
                    });

                    break;
                }
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.e-commerce')
        .controller('DashboardEcommerceController', DashboardEcommerceController);

    /** @ngInject */
    function DashboardEcommerceController(Dashboard)
    {
        var vm = this;

        // Data
        vm.dashboard = Dashboard;

        vm.widget1 = vm.dashboard.widget1;
        vm.widget2 = vm.dashboard.widget2;
        vm.widget3 = vm.dashboard.widget3;
        vm.widget4 = vm.dashboard.widget4;
        vm.widget5 = {
            title       : vm.dashboard.widget5.title,
            mainChart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'multiBarChart',
                        color       : ['#03a9f4', '#b3e5fc'],
                        height      : 420,
                        margin      : {
                            top   : 8,
                            right : 16,
                            bottom: 32,
                            left  : 32
                        },
                        clipEdge    : true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked     : true,
                        duration    : 250,
                        x           : function (d)
                        {
                            return d.x;
                        },
                        y           : function (d)
                        {
                            return d.y;
                        },
                        yAxis       : {
                            tickFormat: function (d)
                            {
                                return d;
                            }
                        },
                        legend      : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        controls    : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : []
            },
            days        : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges      : vm.dashboard.widget5.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget5.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboard.widget5.mainChart, function (chartData, index)
                {
                    vm.widget5.mainChart.data[index] = {
                        key   : chartData.key,
                        values: chartData.values[range]
                    };
                });
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget5.changeRange('TW');
            }
        };

        // Widget 6
        vm.widget6 = {
            title       : vm.dashboard.widget6.title,
            mainChart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'pieChart',
                        color       : ['#f44336', '#9c27b0', '#03a9f4', '#e91e63'],
                        height      : 400,
                        margin      : {
                            top   : 0,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        donut       : true,
                        clipEdge    : true,
                        cornerRadius: 0,
                        labelType   : 'percent',
                        padAngle    : 0.02,
                        x           : function (d)
                        {
                            return d.label;
                        },
                        y           : function (d)
                        {
                            return d.value;
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : []
            },
            footerLeft  : vm.dashboard.widget6.footerLeft,
            footerRight : vm.dashboard.widget6.footerRight,
            ranges      : vm.dashboard.widget6.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget6.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboard.widget6.mainChart, function (data, index)
                {
                    vm.widget6.mainChart.data[index] = {
                        label: data.label,
                        value: data.values[range]
                    };
                });
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget6.changeRange('TW');
            }
        };

        // Widget 7
        vm.widget7 = {
            title       : vm.dashboard.widget7.title,
            ranges      : vm.dashboard.widget7.ranges,
            customers   : vm.dashboard.widget7.customers,
            currentRange: 'T'
        };

        // Methods

        //////////

        // Initialize Widget 5
        vm.widget5.init();

        // Initialize Widget 6
        vm.widget6.init();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.complaints', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msUtilProvider) {


        // State

        $stateProvider.state('app.complaints', {
            url: '/complaints',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/complaints/complaints.html',
                    controller: 'ComplaintsController as vm'
                }
            },
            bodyClass: 'complaints'
        });

        $stateProvider
            .state('app.site_overview.complaints', {
                abstract: true,
                url: '/complaints',
                onEnter: function ($stateParams) {
                },
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                    section: function ($stateParams) {
                        return $stateParams.owner
                    },
                },


            })
            .state('app.site_overview.complaints.formslist', {
                url: '/formslist',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/complaints/complaints.html',
                        controller: 'ComplaintsController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.complaints.list', {
                url: '',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/complaints/complaints.html',
                        controller: 'ComplaintsController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.complaints.list.active_complaint', {
                url: '/view/:id',
                onEnter: function () {

                }
            })
        // Translation
        var base = 'app/main/apps/complaints';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }

    }
})();
(function () {
	'use strict';

	angular
		.module('app.complaints')
		.controller('SelectUserDialog', SelectUserDialog);

	/** @ngInject */
	function SelectUserDialog($mdDialog, $stateParams, $scope, $sce, COMMON, alreadySelected, sessionService, mediaService, usersService, clientsService, idCompany, $translate) {
		var vm = this;
		vm.closeDialog = closeDialog;
		vm.selectUser = selectUser;
		vm.showUserImage = showUserImage;
		vm.owner = $stateParams.owner;
		vm.alreadySelected = [];
		vm.userLogued = sessionService.getUser();
		mediaService.getStoragePrefix({
			owner: $stateParams.owner
		}).then(function (res) {
			$scope.storagePrefix = res.prefix;
		})
		function getUsers(idCompany) {
			var options = {
				owner: vm.owner,
				inCompany: idCompany,
				resultsPerPage: 300
			};
			Promise.all([
				clientsService.getUsers(options),
				usersService.getUsers(options)
			]).then(function (response) {
				vm.users = response[0].data;
				vm.usersAll = response[1].data;
			})
		}

		function selectUser(user) {
			$mdDialog.hide(user);
		}
		function showUserImage(user) {
			return $scope.storagePrefix + user.files.url
		}


		vm.translate = function (text) {
			return $translate.instant(text);
		}


		function closeDialog(data) {
			$mdDialog.hide(false);
		}
		getUsers(idCompany);
	}

})();

(function () {
	'use strict';

	angular
		.module('app.complaints')
		.controller('NewReportDialogController', NewReportDialogController);

	/** @ngInject */
	function NewReportDialogController($mdDialog, $scope, $sce, COMMON, $translate, forms, companySelected, owner, complaint, $rootScope, $stateParams, $document, $mdMedia, $mdSidenav, $state, msApi, tinyMceService, requestContext, companyService, sessionService, mediaService, $timeout, $interval, complaintsService, transformReports, $window, $mdToast) {
		var vm = this;
		vm.closeDialog = closeDialog;
		vm.forms = forms;
		vm.companySelected = companySelected;
		vm.owner = owner;
		vm.complaint = complaint;
		vm.next = next;
		vm.newReport = newReport;
		vm.newReport.config_data = 
		vm.sendReport = sendReport;
		vm.showForm = false;
		vm.type = 1;
		vm.timerExpired = false;
		vm.formSelected = vm.forms[0];
		var endDate = new Date(2024, 2, 25, 12, 0, 0);
		

		vm.timer = { days: 0, hours: 0, minutes: 0, seconds: 0 };
	
		function updateTimer() {
			var now = new Date();
			vm.timerExpired = now >= endDate;

			var distance = endDate - now;
	
			if (distance > 0) {
				vm.timer.days = Math.floor(distance / (1000 * 60 * 60 * 24));
				vm.timer.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
				vm.timer.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
				vm.timer.seconds = Math.floor((distance % (1000 * 60)) / 1000);
			} else {
				vm.timerExpired = true;
				$interval.cancel(timerInterval);
			}
		}
	
		var timerInterval = $interval(updateTimer, 1000);
	
		$scope.$on('$destroy', function() {
			$interval.cancel(timerInterval);
		});



		vm.translate = function (text) {
			return $translate.instant(text);
		}

		function next() {
			vm.showForm = true;
			vm.urlForm = $sce.trustAsResourceUrl(COMMON.URL_FORM.replace('%filename%', vm.formSelected.filename) + 'communication_type=' + vm.type);
			console.log(vm.urlForm)
		}


		function closeDialog(data) {
			$mdDialog.hide(data);
		}
		function newReport() {
			if (vm.reportSelected) vm.reportSelected = undefined;
			vm.reportNew = {				
					"company_id"   : vm.companySelected.id,
					"complaint_id" : vm.complaint.id,
					"report_type"  : "complaint_detail",
					"title"        : vm.newReport.title,
					"config_data"  : {
						actions :vm.newReport.config_data.actions   !== undefined ? vm.newReport.config_data.actions.active  : false,
						data    :vm.newReport.config_data.data      !== undefined ? vm.newReport.config_data.data.active     : false,
						files   :vm.newReport.config_data.files     !== undefined ? vm.newReport.config_data.files.active    : false,
						messages:vm.newReport.config_data.messages  !== undefined ? vm.newReport.config_data.messages.active : false,
						tasks   :vm.newReport.config_data.tasks     !== undefined ? vm.newReport.config_data.tasks.active    : false,
					},
					"language_code": localStorage.getItem("LANG_CODE")
			};

			var options = {
				owner: vm.owner,
				item: vm.reportNew
			};
			complaintsService.createComplaintReport(options).then(function (response) {
				vm.reportNew = undefined;
				vm.closeDialog(true);
			});			
		}
		function initState() {
			vm.reportSelected = undefined;
			vm.reportNew = undefined;
		}
		function createReport() {
			adaptDates(vm.reportNew);

			var options = {
				owner: $scope.owner,
				item: vm.reportNew
			};
			reportsService.createReport(options).then(function (response) {
				vm.reportNew = undefined;
				$rootScope.pagination_resetquery();
				vm.checkState();
			});
		}
		function sendReport() {
			if (vm.reportSelected) {
				updateReport();
			} else if (vm.newReport) {
				newReport();
			}
			initState();
			var message = vm.translate('COMPLAINTS.REPORT_CREATED_SUCCESSFULLY')
			$mdToast.show({
				template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content bg-green">' + message + '</div></md-toast>',
				hideDelay: 11000,
				position: 'top right',
				parent: '#content'
			});
		}
	}
	function createReport() {
			adaptDates(vm.reportNew);

			var options = {
				owner: $scope.owner,
				item: vm.reportNew
			};
			reportsService.createReport(options).then(function (response) {
				vm.reportNew = undefined;
				$rootScope.pagination_resetquery();
				vm.checkState();
			});
		}
		function adaptDates(report, update) {
			if (report.from_date) {
				report.from_date = moment(report.from_date).format('YYYY-MM-DD');
			}
			var toDate;
			if (report.to_date) {
				if (update) {
					toDate = new Date(report.to_date);
				} else {
					toDate = report.to_date;
				}
			} else if (report.from_date) {
				toDate = new Date(report.from_date);
			}
			if (toDate) {
				report.to_date = new Date(toDate.getFullYear(), toDate.getMonth() + 1, 0);
				report.to_date = moment(report.to_date).format('YYYY-MM-DD');
			}
		}

})();








(function () {
	'use strict';

	angular
		.module('app.complaints')
		.controller('NewComplaintDialogController', NewComplaintDialogController);

	/** @ngInject */
	function NewComplaintDialogController($mdDialog, $scope, $sce, COMMON, $translate, forms) {
		var vm = this;
		vm.closeDialog = closeDialog;
		vm.forms = forms;
		vm.next = next;
		vm.showForm = false;
		vm.type = 1;
		vm.formSelected = vm.forms[0];



		vm.translate = function (text) {
			return $translate.instant(text);
		}

		function next() {
			vm.showForm = true;
			vm.urlForm = $sce.trustAsResourceUrl(COMMON.URL_FORM.replace('%filename%', vm.formSelected.filename) + 'communication_type=' + vm.type);
			console.log(vm.urlForm)
		}


		function closeDialog(data) {
			$mdDialog.hide(data);
		}
	}

})();

(function() {
  'use strict';

  angular
    .module('app.complaints')
    .controller('ValidationsController', ValidationsController);

  /** @ngInject */
  function ValidationsController($mdDialog, $translate, Index, Field, Fields, $scope) {
    var vm = this;
    vm.field = Field;
    vm.copyField = angular.copy(Field);
    vm.saveDialog = saveDialog;
    vm.closeDialog = closeDialog;
    vm.addValidation = addValidation;
    vm.addValidator = addValidator;
    vm.removeValidation = removeValidation;
    vm.removeValidator = removeValidator;

    vm.validationObject = {
      type: '',
      data: ''
    };
    vm.validatorObject = {
      type: '',
      data: ''
    };

    console.log(vm.field);
    vm.translate = function(text) {
      return $translate.instant(text);
    }


    function addValidation(validation) {
      if (angular.isUndefined(vm.field.validation) || angular.isUndefined(vm.field.validation.messages))
      {
        vm.field.validation = {
          messages: {}
        }
      }

      vm.field.validation.messages[validation.type] = '|| return \'' + validation.data + '\'';
      delete validation.$$hashKey
      vm.validationObject = {
        type: '',
        data: ''
      };
    }

    function removeValidation(key) {
      if (!angular.isUndefined(vm.field.validation.messages[key]))
      {
        delete(vm.field.validation.messages[key])
      }
      if (Object.keys(vm.field.validation.messages).length == 0) {
        delete(vm.field.validation);
      }
    }

    function addValidator(validator) {
      if (angular.isUndefined(vm.field.validators))
      {
        vm.field.validators = {}
      }
      vm.field.validators[validator.type] = '||' + validator.data;
      delete validator.$$hashKey
      if (validator.type == 'passwordStrength') {
        vm.field.templateOptions.funcPStrength  = '__passwordStrength';
      } else if (validator.type == 'slugCheck') {
        vm.field.templateOptions.funcSlugCheck  = '__slugCheck';
      }
      vm.validatorObject = {
        type: '',
        data: ''
      };
    }
    function removeValidator(key) {
      if (!angular.isUndefined(vm.field.validators[key]))
      {
        delete(vm.field.validators[key])
      }
      if (Object.keys(vm.field.validators).length == 0) {
        delete(vm.field.validators);
      }
      if (key == 'passwordStrength') {
        delete(vm.field.templateOptions.funcPStrength)
      }
      if (key == 'slugCheck') {
        delete(vm.field.templateOptions.funcSlugCheck)
      }
    }

    function saveDialog() {
      if (!angular.isUndefined(vm.field.validation) && !angular.isUndefined(vm.field.validation.messages) && Object.keys(vm.field.validation.messages).length == 0)
      {
        delete(vm.field.validation);
      }
      if (!angular.isUndefined(vm.field.validators) && Object.keys(vm.field.validators).length == 0)
      {
        delete(vm.field.validators);
      }
      Fields[Index] = vm.field;
      $mdDialog.hide();
    }


    function closeDialog() {
      Fields[Index] = vm.copyField;
      $mdDialog.hide();
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.complaints')
        .controller('OptionsController', OptionsController);

    /** @ngInject */
    function OptionsController($mdDialog, $translate, $stateParams, Index, $document, Field, Fields, Title, idCompany, complaintPlan, mediaService, ArrayName, $scope) {
        var vm = this;
        vm.field = Field;
        vm.isComplaintType = vm.field.templateOptions.selecttypecomplaint;
        vm.arrayName = ArrayName;
        vm.complaintPlan = complaintPlan;
        vm.title = Title;
        vm.copyField = angular.copy(Field);
        vm.saveDialog = saveDialog;
        vm.closeDialog = closeDialog;
        vm.addOption = addOption;
        vm.showUserImage = showUserImage;
        vm.openDialogUsers = openDialogUsers;
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];

        mediaService.getStoragePrefix({
            owner: $stateParams.owner
        }).then(function (res) {
            $scope.storagePrefix = res.prefix;
        })
        vm.option = {
            value: '',
            name: '',
        };
        if (vm.isComplaintType) {
            vm.option.users = [];
            vm.field.templateOptions[vm.arrayName] = vm.field.templateOptions[vm.arrayName].map(x => {
                if (!x.users) {
                    x.users = [];
                }
                return x;
            })
            vm.usersMapping = [];
        }

        vm.translate = function (text) {
            return $translate.instant(text);
        }

        function addOption(option) {
            if (vm.isComplaintType) {
                // Get all existing values (IDs) in the array
                var existingValues = vm.field.templateOptions[vm.arrayName]
                    .map(function(x) {
                        return parseInt(x.value);
                    })
                    .filter(function(x) {
                        return !isNaN(x);
                    });
                
                // Calculate the next available ID
                var nextId = 1;
                if (existingValues.length > 0) {
                    var maxId = Math.max.apply(null, existingValues);
                    nextId = maxId + 1;
                }
                
                option.value = nextId;
            } else {
                option.value = option.name;
            }
            
            vm.field.templateOptions[vm.arrayName].push(option);
            vm.option = {
                value: '',
                name: '',
                users: [],
            };
        }


        function showUserImage(user) {
            return $scope.storagePrefix + user.files.url
        }

        function openDialogUsers(ev, option) {
            $mdDialog.show({
                controller: 'SelectUserDialog',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/complaints/dialogs/select-user-dialog/select-user-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                multiple: true,
                locals: {
                    alreadySelected: [],
                    idCompany: idCompany
                }
            }).then(res => {
                if (res) {
                    option.users.push(res);
                }
            });
        }

        function saveDialog() {
            // Correct duplicate IDs before saving (only for communication types)
            if (vm.isComplaintType) {
                fixDuplicateIds();
            }
            $mdDialog.hide(vm.field.templateOptions[vm.arrayName]);
        }

        function fixDuplicateIds() {
            var options = vm.field.templateOptions[vm.arrayName];
            
            // Group options by their value (ID) to detect duplicates
            var groupedByValue = {};
            options.forEach(function(option, index) {
                var value = parseInt(option.value);
                if (!isNaN(value)) {
                    if (!groupedByValue[value]) {
                        groupedByValue[value] = [];
                    }
                    groupedByValue[value].push({
                        option: option,
                        index: index
                    });
                }
            });
            
            // Process each group of values
            Object.keys(groupedByValue).forEach(function(value) {
                var group = groupedByValue[value];
                
                // If there are duplicates (more than one item with the same ID)
                if (group.length > 1) {
                    // Keep the first one, reassign the others
                    for (var i = 1; i < group.length; i++) {
                        var duplicateOption = group[i].option;
                        
                        // Calculate the next available ID
                        var allCurrentValues = options
                            .map(function(x) {
                                return parseInt(x.value);
                            })
                            .filter(function(x) {
                                return !isNaN(x);
                            });
                        
                        var nextId = 1;
                        if (allCurrentValues.length > 0) {
                            var maxId = Math.max.apply(null, allCurrentValues);
                            nextId = maxId + 1;
                        }
                        
                        // Reassign the ID
                        duplicateOption.value = nextId;
                    }
                }
            });
        }

        function closeDialog() {
            Fields[Index] = vm.copyField;
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.complaints')
        .controller('AnalyzeDialogController', AnalyzeDialogController);

    /** @ngInject */
    function AnalyzeDialogController($mdDialog, $scope, $sce, $translate, complaint, $http, $mdToast) {
        var vm = this;

        // Data passed to the dialogue
        vm.complaint = complaint;
        vm.filteredComplaint = filterCommunicationJson(vm.complaint);

        // Dialogue states
        vm.isAnalyzing = false;
        vm.result = null; // Clean analysis result
        vm.typingText = ''; // Text that is written gradually
        vm.isTyping = false; // Indicates whether the writing effect is active

        // Controller functions
        vm.closeDialog = closeDialog;
        vm.startAnalysis = startAnalysis;
        vm.formatResult = formatResult;

        // Allowed fields filter
        function filterCommunicationJson(communicationJson) {
            const allowedFields = [
                "id",
                "subject",
                "description",
                "anonymous_complaint",
                "complaint_type",
                "created_at",
                "priority"
            ];

            return Object.keys(communicationJson)
                .filter(key => allowedFields.includes(key))
                .reduce((obj, key) => {
                    obj[key] = communicationJson[key];
                    return obj;
                }, {});
        }

        // Close the dialogue
        function closeDialog() {
            $mdDialog.hide();
        }

        // Start analysis
        function startAnalysis() {
            vm.isAnalyzing = true;
            vm.result = null;
            vm.typingText = ''; // Reset the displayed text

            $http.post(
                'https://s7nqx6kx1e.execute-api.us-east-1.amazonaws.com/dev/send-json',
                vm.filteredComplaint,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            )
			.then(response => {
				vm.result = formatResult(response.data); // Format the result
				vm.typingText = ''; // Reset the displayed text
				typeText(vm.result.sentiment); // Call the adjusted function
				vm.isAnalyzing = false;
			
				const message = $translate.instant('COMPLAINTS.ANALYSIS_SUCCESS');
				$mdToast.show({
					template: '<md-toast id="analysis-success-toast" layout="column" layout-align="center start"><div class="md-toast-content bg-green">' + message + '</div></md-toast>',
					hideDelay: 5000,
					position: 'top right'
				});
			})
                .catch(error => {
                    console.error("Error al enviar el JSON:", error);

                    vm.result = {
                        error: $translate.instant('COMPLAINTS.ANALYSIS_ERROR')
                    };
                    vm.isAnalyzing = false;

                    const message = $translate.instant('COMPLAINTS.ANALYSIS_ERROR');
                    $mdToast.show({
                        template: '<md-toast id="analysis-error-toast" layout="column" layout-align="center start"><div class="md-toast-content bg-red">' + message + '</div></md-toast>',
                        hideDelay: 5000,
                        position: 'top right'
                    });
                });
        }

        // Writing effect
        function typeText(fullText) {
			if (typeof fullText !== 'string') {
				fullText = $sce.getTrustedHtml(fullText) || '';
			}
		
			vm.isTyping = true; // Indicates that the writing effect is active
			const textArray = fullText.split(''); // Divide the text into characters
			let index = 0;
		
			const interval = setInterval(() => {
				if (index < textArray.length) {
					vm.typingText += textArray[index]; // Add a character to the displayed text
					index++;
					$scope.$apply(); // Update the DOM in each step
				} else {
					clearInterval(interval); // Stop the interval when it is complete
					vm.isTyping = false; // Indicates that the writing is finished
		
					// At the end, render the text as complete HTML
					vm.typingText = $sce.trustAsHtml(fullText);
				}
			}, 50); // Writing speed in milliseconds (adjustable)
		}

        // Format the received text
        function formatText(text) {
            if (!text) return text;

            // Combine numbers of lists with their content, removing unnecessary line breaks
            text = text.replace(/\n(\d+\.)\s*\n?/g, ' $1 ');

            // Divide into paragraphs or numbered lists (without lookbehind for compatibility with old Safari/iOS)
            const paragraphs = text.replace(/\.\s+/g, '.\x00').split('\x00').map(function (p) {
                return p.trim();
            }).filter(Boolean);

            return paragraphs.map(paragraph => {
                paragraph = paragraph.trim(); // Clean blank spaces
                if (/^\d+\.\s/.test(paragraph)) {
                    return `<li>${paragraph}</li>`; // Format numbered lists
                }
                return `<p>${paragraph}</p>`; // Format normal paragraphs
            }).join('');
        }

        // Format the result for the client
        function formatResult(data) {
			if (data.error) {
				return { error: data.error };
			}
		
			const sentimentText = typeof data.sentiment === 'string' ? data.sentiment : String(data.sentiment || '');
			return {
				message: data.message,
				sentiment: $sce.trustAsHtml(formatText(sentimentText)) // Make sure it is reliable text
			};
		}
    }
})();
(function () {
    'use strict';

    angular
        .module('app.dashboard-complaints', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider , msUtilProvider, msNavigationServiceProvider) {
        // State


        $stateProvider.state('app.dashboard-complaints', {
            url: '/dashboard',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboard-complaints/dashboard-complaints.html',
                    controller: 'DashboardComplaintsController as vm'
                }
            },
            bodyClass: 'dashboard'
        });

        $stateProvider
            .state('app.site_overview.dashboard-complaints', {
                abstract: true,
                url: '/dashboard-complaints',
                onEnter: function ($stateParams) {


                },
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                    section: function ($stateParams) {
                        return $stateParams.owner
                    },
                },


            })
            .state('app.site_overview.dashboard-complaints.list', {
                url: '',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/dashboard-complaints/dashboard-complaints.html',
                        controller: 'DashboardComplaintsController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.dashboard-complaints.dashboard', {
                url: '/overview',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/dashboard-complaints/dashboarddata-complaints.html',
                        controller: 'DashboardComplaintsController as vm'
                    }
                },
                onEnter: function () {
                },
                params: {
                    is_dashboard_data: true
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
        // Translation
        var base = 'app/main/apps/dashboard-complaints';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }

    }
})();

angular.module('app.dashboard-complaints')
    .controller('CompanyPerformanceDialogController', CompanyPerformanceDialogController)
    .controller('CategoryDialogController', CategoryDialogController);

/** @ngInject */
function CompanyPerformanceDialogController($mdDialog, companiesData) {
    var vm = this;
    
    vm.companiesData = companiesData || [];
    vm.closeDialog = closeDialog;
    vm.maxResolutionDays = vm.companiesData.length > 0 ? 
        Math.max.apply(Math, vm.companiesData.map(function(c) {
            return c.avgResolutionDays || 0;
        })) : 0;
    function closeDialog() {
        $mdDialog.hide();
    }
}

/** @ngInject */
function CategoryDialogController($mdDialog, categoriesData) {
    var vm = this;
    
    vm.categoriesData = categoriesData || [];
    vm.closeDialog = closeDialog;
    
    function closeDialog() {
        $mdDialog.hide();
    }
}
(function () {
    'use strict';

    angular
        .module('app.dashboard-complaints')
        .constant('_', window._)
        .controller('ViewItemListDashboardDialog', ViewItemListDashboardDialog);

    /** @ngInject */
    function ViewItemListDashboardDialog($mdDialog, items, msUtils, type, $translate) {
        var vm = this;
        vm.items = items;
        vm.type = type;
        vm.selectItem = selectItem;
        vm.closeDialog = closeDialog;
        vm.timeAgo = msUtils.timeAgo;
        vm.maxDaysPending = 0;
        
        vm.isNewComplaints = vm.type === 'COMPLAINTS' && vm.items && vm.items.length > 0 && 
                             vm.items.every(function(item) { return item.status === 2; });
        
        vm.isInProcessComplaints = vm.type === 'COMPLAINTS' && vm.items && vm.items.length > 0 && 
                                   vm.items.every(function(item) { return item.status === 1; });
        
        vm.isInvestigationComplaints = vm.type === 'COMPLAINTS' && vm.items && vm.items.length > 0 && 
                                       vm.items.every(function(item) { return item.status === 4; });
        
        vm.isDueTasks = vm.type === 'DUE_TASKS' && vm.items && vm.items.length > 0;
        
        vm.isFiles = vm.type === 'FILES' && vm.items && vm.items.length > 0;
        
        if (vm.isNewComplaints || vm.isInProcessComplaints || vm.isInvestigationComplaints || vm.isDueTasks || vm.isFiles) {
            processComplaintsData();
        }
        
        function processComplaintsData() {
            if (!vm.items || vm.items.length === 0) return;
            
            vm.items.forEach(function(item) {
                var dateField = item.date || item.due_date || item.created_at;
                if (dateField) {
                    var itemDate = new Date(dateField);
                    var today = new Date();
                    var daysDiff = Math.floor((today - itemDate) / (1000 * 60 * 60 * 24));
                    item.daysPending = Math.max(0, daysDiff);
                    
                    if (vm.isInProcessComplaints || vm.isInvestigationComplaints) {
                        item.daysLabel = item.daysPending + " " + $translate.instant('DASHBOARD-COMPLAINTS.DAYS_IN_PROCESS').toLowerCase();
                    } else if (vm.isDueTasks) {
                        item.daysLabel = item.daysPending + " " + $translate.instant('DASHBOARD-COMPLAINTS.DAYS_OVERDUE').toLowerCase();
                    } else if (vm.isFiles) {
                        item.daysLabel = item.daysPending + " " + $translate.instant('DASHBOARD-COMPLAINTS.DAYS_AGO').toLowerCase();
                    } else {
                        item.daysLabel = item.daysPending + " " + $translate.instant('DASHBOARD-COMPLAINTS.DAYS').toLowerCase();
                    }
                } else {
                    item.daysPending = 0;
                    if (vm.isInProcessComplaints || vm.isInvestigationComplaints) {
                        item.daysLabel = "0 " + $translate.instant('DASHBOARD-COMPLAINTS.DAYS_IN_PROCESS').toLowerCase();
                    } else if (vm.isDueTasks) {
                        item.daysLabel = "0 " + $translate.instant('DASHBOARD-COMPLAINTS.DAYS_OVERDUE').toLowerCase();
                    } else if (vm.isFiles) {
                        item.daysLabel = "0 " + $translate.instant('DASHBOARD-COMPLAINTS.DAYS_AGO').toLowerCase();
                    } else {
                        item.daysLabel = "0 " + $translate.instant('DASHBOARD-COMPLAINTS.DAYS').toLowerCase();
                    }
                }
                
                if ((vm.isDueTasks || vm.isFiles) && !item.company) {
                    var companyName = item.company_name;
                    if (companyName === '' || companyName === 0) {
                        companyName = null;
                    }
                    
                    var companyObj = item.company;
                    if (companyObj === '') {
                        companyObj = null;
                    }
                    
                    item.company = {
                        name: companyName || (companyObj && companyObj.name) || "Sin empresa",
                        logo: (companyObj && companyObj.logo) || null
                    };
                }
            });
            
            vm.maxDaysPending = Math.max.apply(Math, vm.items.map(function(item) {
                return item.daysPending || 0;
            }));
            
            if (vm.maxDaysPending === 0) {
                vm.maxDaysPending = 1;
            }
            
            vm.items.forEach(function(item) {
                item.color = getComplaintColor(item.daysPending, vm.maxDaysPending);
            });
            
            vm.items.sort(function(a, b) {
                return b.daysPending - a.daysPending;
            });
        }
        
        function getComplaintColor(days, maxDays) {
            if (!days || days === 0 || maxDays === 0) {
                return '#95a5a6';
            }
            
            var percentage = days / maxDays;
            percentage = Math.max(0, Math.min(1, percentage));
            
            if (percentage <= 0.33) {
                var factor = percentage / 0.33;
                return interpolateColor('#2ECC71', '#F1C40F', factor);
            } else if (percentage <= 0.66) {
                var factor = (percentage - 0.33) / 0.33;
                return interpolateColor('#F1C40F', '#E67E22', factor);
            } else {
                var factor = (percentage - 0.66) / 0.34;
                return interpolateColor('#E67E22', '#E74C3C', factor);
            }
        }
        
        function interpolateColor(color1, color2, factor) {
            function hexToRgb(hex) {
                var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
                return result ? {
                    r: parseInt(result[1], 16),
                    g: parseInt(result[2], 16),
                    b: parseInt(result[3], 16)
                } : null;
            }
            
            function rgbToHex(r, g, b) {
                return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
            }
            
            var rgb1 = hexToRgb(color1);
            var rgb2 = hexToRgb(color2);
            
            var r = Math.round(rgb1.r + (rgb2.r - rgb1.r) * factor);
            var g = Math.round(rgb1.g + (rgb2.g - rgb1.g) * factor);
            var b = Math.round(rgb1.b + (rgb2.b - rgb1.b) * factor);
            
            return rgbToHex(r, g, b);
        }
        
        function selectItem(item) {
            if (vm.type == 'ACTIVITIES') return;
            $mdDialog.hide({ item: item, type: vm.type });
        }
        
        function closeDialog() {
            $mdDialog.hide(false);
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('app.dashboard', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider , msUtilProvider, msNavigationServiceProvider) {
        // State


        $stateProvider.state('app.dashboard', {
            url: '/dashboard',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboard/dashboard.html',
                    controller: 'DashboardController as vm'
                }
            },
            bodyClass: 'dashboard'
        });

        $stateProvider
            .state('app.site_overview.dashboard', {
                abstract: true,
                url: '/dashboard',
                onEnter: function ($stateParams) {


                },
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                    section: function ($stateParams) {
                        return $stateParams.owner
                    },
                },


            })
            .state('app.site_overview.dashboard.list', {
                url: '',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/dashboard/dashboard.html',
                        controller: 'DashboardController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.dashboard.dashboard', {
                url: '/overview',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/dashboard/dashboarddata.html',
                        controller: 'DashboardController as vm'
                    }
                },
                onEnter: function () {
                },
                params: {
                    is_dashboard_data: true
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
        // Translation
        var base = 'app/main/apps/dashboard';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.dashboard')
        .constant('_', window._)
        .controller('ViewItemListDashboardDialog', ViewItemListDashboardDialog);

    /** @ngInject */
    function ViewItemListDashboardDialog($mdDialog, items, msUtils, type) {
        var vm = this;
        vm.items = items;
        vm.type = type;
        vm.selectItem = selectItem;
        vm.closeDialog = closeDialog;
        vm.timeAgo = msUtils.timeAgo;
        function selectItem(item) {
            if (vm.type == 'ACTIVITIES') return;
            $mdDialog.hide({ item: item, type: vm.type });
        }
        function closeDialog() {
            $mdDialog.hide(false);
        }

    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.contacts', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msUtilProvider)
    {

        $stateProvider.state('app.contacts', {
            url    : '/contacts',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/contacts/contacts.html',
                    controller : 'ContactsController as vm'
                }
            },
            resolve: {
                Contacts: function (msApi)
                {
                    return msApi.resolve('contacts.contacts@get');
                },
                User: function (msApi)
                {
                    return msApi.resolve('contacts.user@get');
                }
            }
        });

        $stateProvider.state('app.empty', {
            url    : '/blank',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/contacts/empty.html',
                    controller : 'ContactsController as vm'
                }
            },
            resolve: {
                Contacts: function (msApi)
                {
                    return msApi.resolve('contacts.contacts@get');
                },
                User: function (msApi)
                {
                    return msApi.resolve('contacts.user@get');
                }
            }
        });
        $stateProvider.state('app.empty1', {
            url    : '/blank',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/contacts/empty.html',
                    controller : 'ContactsController as vm'
                }
            },
            resolve: {
                Contacts: function (msApi)
                {
                    return msApi.resolve('contacts.contacts@get');
                },
                User: function (msApi)
                {
                    return msApi.resolve('contacts.user@get');
                }
            }
        });
        $stateProvider.state('app.empty2', {
            url    : '/blank',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/contacts/empty.html',
                    controller : 'ContactsController as vm'
                }
            },
            resolve: {
                Contacts: function (msApi)
                {
                    return msApi.resolve('contacts.contacts@get');
                },
                User: function (msApi)
                {
                    return msApi.resolve('contacts.user@get');
                }
            }
        });

        // Translation
        var base = 'app/main/apps/contacts';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }
        // Api
        msApiProvider.register('contacts.contacts', ['app/data/contacts/contacts.json']);
        msApiProvider.register('contacts.user', ['app/data/contacts/user.json']);

        // // Navigation
        // msNavigationServiceProvider.saveItem('apps.contacts', {
        //     title : 'Crew & Pax',
        //     icon  : 'icon-account-box',
        //     state : 'app.contacts',
        //     weight: 5
        // });
        // msNavigationServiceProvider.saveItem('apps.empty', {
        //     title : 'Hotel & Transportation',
        //     icon  : 'icon-account-box',
        //     state : 'app.empty',
        //     weight: 6
        // });
        // msNavigationServiceProvider.saveItem('apps.empty1', {
        //     title : 'Electronic Whiteboard',
        //     icon  : 'icon-account-box',
        //     state : 'app.empty1',
        //     weight: 7
        // });
        // msNavigationServiceProvider.saveItem('apps.empty2', {
        //     title : 'Settings',
        //     icon  : 'icon-account-box',
        //     state : 'app.empty2',
        //     weight: 7
        // });

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts')
        .controller('ContactDialogController', ContactDialogController);

    /** @ngInject */
    function ContactDialogController($mdDialog, Contact, Contacts, User, msUtils)
    {
        var vm = this;

        // Data
        vm.title = 'Edit Contact';
        vm.contact = angular.copy(Contact);
        vm.contacts = Contacts;
        vm.user = User;
        vm.newContact = false;
        vm.allFields = false;

        if ( !vm.contact )
        {
            vm.contact = {
                'id'      : msUtils.guidGenerator(),
                'name'    : '',
                'lastName': '',
                'avatar'  : 'assets/images/avatars/profile.jpg',
                'nickname': '',
                'company' : '',
                'jobTitle': '',
                'email'   : '',
                'phone'   : '',
                'address' : '',
                'birthday': null,
                'notes'   : ''
            };

            vm.title = 'New Contact';
            vm.newContact = true;
            vm.contact.tags = [];
        }

        // Methods
        vm.addNewContact = addNewContact;
        vm.saveContact = saveContact;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.closeDialog = closeDialog;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;

        //////////

        /**
         * Add new contact
         */
        function addNewContact()
        {
            vm.contacts.unshift(vm.contact);

            closeDialog();
        }

        /**
         * Save contact
         */
        function saveContact()
        {
            // Dummy save action
            for ( var i = 0; i < vm.contacts.length; i++ )
            {
                if ( vm.contacts[i].id === vm.contact.id )
                {
                    vm.contacts[i] = angular.copy(vm.contact);
                    break;
                }
            }

            closeDialog();
        }

        /**
         * Delete Contact Confirm Dialog
         */
        function deleteContactConfirm(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the contact?')
                .htmlContent('<b>' + vm.contact.name + ' ' + vm.contact.lastName + '</b>' + ' will be deleted.')
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                vm.contacts.splice(vm.contacts.indexOf(Contact), 1);

            });
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients-complaints', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider,
        msApiProvider, msNavigationServiceProvider, ivhTreeviewOptionsProvider) {


        ivhTreeviewOptionsProvider.set({
            defaultSelectedState: false,
            validate: true,
            expandToDepth: -1,
            twistieCollapsedTpl: '<md-icon md-font-icon="icon-chevron-right"></md-icon>',
            twistieExpandedTpl: '<md-icon md-font-icon="icon-chevron-left"></md-icon>',
            twistieLeafTpl: '<span style="cursor: default;">&#8192;&#8192;</span>'
        });





        // State


        $stateProvider.state('app.clients-complaints', {
            url: '/clients',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/clients-complaints/clients-complaints.html',
                    controller: 'ClientsComplaintsController as vm'
                }
            },
            bodyClass: 'clients'
        });

        $stateProvider
            .state('app.site_overview.clients-complaints', {
                abstract: true,
                url: '/clients-complaints',
                onEnter: function ($stateParams) {


                },
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                    section: function ($stateParams) {
                        return $stateParams.owner
                    },
                    is_owner: function ($stateParams) {
                        return false
                    },
                },


            })
            .state('app.site_overview.clients-complaints.list', {
                url: '/list',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/clients-complaints/clients-complaints.html',
                        controller: 'ClientsComplaintsController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.clients-complaints.complaints', {
                url: '/complaints',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/clients-complaints/clients-complaints.html',
                        controller: 'ClientsComplaintsController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.clients-complaints.list.thread', {
                url: '/list/:id',
                bodyClass: 'clients'
            });
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/clients-complaints');


    }
})();


(function () {
    'use strict';

    angular
        .module('app.clients-complaints')
        .constant('_', window._)
        .controller('NewClientDialogController', NewClientDialogController);

    /** @ngInject */
    function NewClientDialogController($scope, $mdDialog, $rootScope, sectors, regions, $stateParams, $document, $state, documentsService, staffService,
        sessionService, clientsService, regionsLiterals, company, main_branch, $filter, $translate) {
        var vm = this;

        vm.positionsIds = {
            administrator: 1,
            managerLegal: 2,
            compliance_officer: 3,
            compliance_comite: 5,
            data_protection: 4,
            collaborator: 24
        }

        vm.divisionsId = {
            administrator: 3,
            managerLegal: 3,
            compliance_officer: 1,
            compliance_comite: 1,
            data_protection: 2,
            collaborator: 1
        }

        // Data
        vm.accounts = {
            'creapond': 'johndoe@creapond.com',
            'withinpixels': 'johndoe@withinpixels.com'
        };
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
        vm.profileColors = ['md-blue-300-bg', 'md-blue-grey-300-bg', 'md-orange-300-bg', 'md-pink-300-bg', 'md-purple-300-bg', 'md-red-300-bg', 'md-yellow-300-bg', 'md-light-blue-300-bg'];
        vm.selectedAccount = 'creapond';

        vm.loadingStep = false;
        vm.folders = 'Folders.data';
        vm.labels = 'Labels.data';
        vm.loadingThreads = true;

        vm.currentFilter = {
            type: $state.params.type,
            filter: $state.params.filter
        };
        vm.currentThread = null;
        vm.selectedThreads = [];

        vm.views = {
            split: 'app/main/apps/clients-complaints/views/list/split-view.html',
            nosplit: 'app/main/apps/clients-complaints/views/list/nosplit-view.html'
        };
        vm.defaultView = 'split';
        vm.currentView = 'split';

        vm.readView = false;

        vm.branchFields = [
            { name: 'Nombre', type: 'text', field: 'name', translate: 'GLOBAL.NAME' },
            { name: 'Domicilio', type: 'text', field: 'address1', translate: 'GLOBAL.ADDRESS' },
            { name: 'Población', type: 'text', field: 'city', translate: 'GLOBAL.CITY' },
            { name: 'Provincia', type: 'text', field: 'state', translate: 'GLOBAL.PROVINCE' },
            { name: 'Codigo postal', type: 'number', field: 'postcode', translate: 'GLOBAL.POSTAL_CODE' },
            { name: 'Telefono', type: 'number', field: 'phone', translate: 'GLOBAL.PHONE' },
            { name: 'Email', type: 'email', field: 'email', translate: 'GLOBAL.EMAIL' }
        ];

        vm.personFields = [
            { name: 'Name', type: 'text', field: 'first_name', translate: 'GLOBAL.NAME', required: true },
            { name: 'Apellidos', type: 'text', field: 'last_name', translate: 'GLOBAL.SURNAMES', required: true },
            { name: 'NIF', type: 'text', field: 'id_number', translate: 'GLOBAL.NIF_CIF', required: true },
            { name: 'Email', type: 'text', field: 'email', translate: 'GLOBAL.EMAIL', required: true },
            { name: 'Password', type: 'password', field: 'password', translate: 'LOGIN.PASSWORD', required: false },
            { name: 'Picture', type: 'picture', field: 'picture', translate: '', required: false },
            { name: '3rd Party Company', type: 'text', field: '3rd_party_company_name', translate: 'CLIENTS.3RD_PARTY_COMPANY' },
            { name: 'Profile Color', type: 'text', field: 'profile_color', translate: 'GLOBAL.PROFILE_COLOR', hidden: true },
            { name: 'User type', type: 'text', field: 'user_type', translate: 'GLOBAL.PROFILE_COLOR', hidden: true },
            // { name: 'Files', type: 'text', field: 'files', translate: 'GLOBAL.FILES', hidden: true },
            { name: 'Files', type: '', field: 'files', hidden: true, value: [] },
        ];

        vm.administratorFields = vm.personFields;
        vm.managerLegalFields = vm.personFields;
        vm.complianceFields = vm.personFields;
        vm.reportFields = vm.personFields;
        vm.personnelFields = vm.personFields;

        vm.addUsersJobFromUserId = addUsersJobFromUserId;
    





        vm.closeDialog = closeDialog;
        vm.saveDialog = saveDialog;
        vm.getRegionLiteral = getRegionLiteral;
        vm.sectors = sectors;
        vm.regions = regions;
        vm.regionsLiterals = regionsLiterals;
        vm.openDialogForm = openDialogForm;
        vm.mediaDialogSingle = mediaDialogSingle;
        vm.deleteLogotype = deleteLogotype;

        vm.getDivisionName = getDivisionName;
        vm.getPositionName = getPositionName;
        vm.isFromType = isFromType;
        vm.areFromType = areFromType;
        $scope.owner = $stateParams.owner;
        vm.company = company ? company : {};

        

        vm.main_branch = main_branch ? main_branch : {}

        if (vm.company.id) {
            staffService.getMainBranch({ owner: $scope.owner, id_company: vm.company.id }).then(res => {
                vm.main_branch = res.data[0];
            })
        }
        if (vm.company.logo && vm.company.logo.length > 0) {
            var options = {
                owner: $scope.owner
            };
            clientsService.getStoragePrefix(options).then(function (res) {
                $scope.imageUrl = res.prefix + vm.company.logo[0].url;
                vm.logoIsLoaded = true;
            })
        }
        if (!vm.company.region_id) {
            vm.company.region_id = sessionService.user.region_id;
        }
        function saveDialog() {
            if (!vm.main_branch.name) {
                vm.main_branch.name = vm.company.name;
            }
            $mdDialog.hide({ company: vm.company, branch: vm.main_branch, image: $scope.image, updateLogotype: vm.updateLogotype });
        }
        function mediaDialogSingle(ev, field) {
            $mdDialog.show({
                controller: 'MediaClientsController',
                controllerAs: 'vm',
                locals: {
                    owner: $scope.owner,
                    multipleSelection: true,
                    isTiny: false
                },
                templateUrl: 'app/main/apps/clients-complaints/dialogs/media/media-clients.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                multiple: true
            }).then(function (image) {
                if (image) {
                    vm.updateLogotype = true;
                    $scope.image = image;
                }
            });
        }
        function deleteLogotype() {
            if (vm.company.logo && vm.company.logo.length > 0) {
                for (var i = 0; i < vm.company.logo.length; i++) {
                    const itemLogo = vm.company.logo[i];
                    var options = {
                        owner: $scope.owner,
                        id: itemLogo.id
                    }
                    documentsService.deleteDocument(options).then(function () {
                        vm.company.logo = null;
                    })
                }
            }
            $scope.image = undefined;
            $scope.imageUrl = undefined;
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function getRegionLiteral(literalKey) {
            if (!angular.isUndefined(vm.company) && vm.company.region_id) {
                const literalsObject = vm.regionsLiterals.find(x => x.region_id === vm.company.region_id)
                return literalsObject.literals[literalKey];
            } else {
                return 'CIF/NIF';
            }
        }





        function initFieldsForm(title) {
            let fields;
            if (title === 'branch') {
                fields = angular.copy(vm.branchFields);
            }
            else if (title === 'administrator') {
                fields = angular.copy(vm.administratorFields);
            }
            else if (title === 'managerLegal') {
                fields = angular.copy(vm.managerLegalFields);
            }
            else if (title === 'compliance') {
                fields = angular.copy(vm.complianceFields);
            }
            else if (title === 'report') {
                fields = angular.copy(vm.reportFields);
            }
            else if (title === 'personnel') {
                fields = angular.copy(vm.personnelFields);
            }
            fields.forEach(item => {
                if (item.name == 'Población') {
                    item.translate = vm.getRegionLiteral('city');
                }
                if (item.name == 'Provincia') {
                    item.translate = vm.getRegionLiteral('state');
                }
                if (item.name == 'NIF') {
                    item.translate = vm.getRegionLiteral('id_number');
                }
            })
            return fields;
        }


        function openDialogForm(title, branchId, saveNow, model, index, type) {
            var hasModel = true;
            var divisionId = '';
            var jobId = '';
            if (model === undefined || !model) {
                hasModel = false;
                var fields = initFieldsForm(title);
            }
            else {
                //var fields = angular.copy(model);
                var fields = initFieldsForm(title);
                angular.forEach(fields, function (f) {
                    if (!angular.isUndefined(model[f.field])) {
                        f.value = model[f.field];
                        if (f.field == 'division') {
                            divisionId = f.value;
                        } else if (f.field == 'position') {
                            jobId = f.value;
                        }
                    }
                })
            }

            if (!divisionId && type && !angular.isUndefined(vm.divisionsId[type])) {
                divisionId = vm.divisionsId[type];
            }
            if (!jobId && type && !angular.isUndefined(vm.positionsIds[type])) {
                jobId = vm.positionsIds[type];
            }

           
  if (!vm.formWizard) {
    vm.formWizard = {};
  }
  if (angular.isUndefined(vm.formWizard[title])) {
    vm.formWizard[title] = [];
  }
            if (!vm.users) {
                vm.users = [];
            }
            if (!vm.mainUsers) {
                vm.mainUsers = [];
            }
            var usersDialog = vm.users.concat(vm.mainUsers);
            usersDialog = _.uniq(usersDialog, function (e) {
                return e.id;
            });
            $mdDialog.show({
                controller: 'DialogFormController',
                controllerAs: 'vm',
                locals: {
                    title: title,
                    fields: fields,
                    type: type,
                    users: angular.copy(usersDialog),
                    alreadySelected: type ? vm.areFromType(vm.formWizard[title], type) : vm.formWizard[title],
                    storagePrefix: $scope.storagePrefix,
                    branchId: branchId,
                    defaultDivision: divisionId,
                    owner: $scope.owner,
                    defaultJob: jobId,
                    positionsIds: vm.positionsIds,
                    idCompany: vm.idCompany,
                    user_type: model ? model.user_type : undefined,
                    isTiny: false
                },
                templateUrl: 'app/main/apps/clients-complaints/dialogs/forms/dialog-view.html',
                parent: angular.element($document.body),
                targetEvent: 'ev',
                disableParentScroll: true,
                clickOutsideToClose: true,

            }).then(function (result) {

                if (result) {
                    if (result.fields && result.fields.files) {
                        vm.files = result.fields.files;
                        delete result.fields.files;
                    }
                    vm.quotaexceded = result.quotaexceded;
                    var existUser = result.existUser;
                    if (hasModel) {
                        angular.forEach(result.fields, function (f) {
                            // no se por que hay que tener el if siguiente pero las dejo ya que imagino que alguien las puso por algo.
                            if (!angular.isUndefined(model[f.field])) {
                                model[f.field] = f.value;
                            }
                            if (f.field == 'password' && !angular.isUndefined(f.value)) {
                                model[f.field] = f.value;
                            }
                        })
                        if (title !== 'branch') {
                            updateUser(title, index);
                        }

                    }
                    else {

                        if (branchId) {
                            var subIndex = createSubForm(title, result.fields, true, branchId);
                            if (!existUser) {
                                createUser(title, result.fields, subIndex, true);
                            } else {
                                var itemUser = vm.formWizard[title][subIndex];
                                upgradeRol(title, subIndex, itemUser)
                                vm.addUsersJobFromUserId(itemUser.division, itemUser.position, itemUser.branch_id, itemUser, true)
                            }
                        } else {
                            var subIndex = createSubForm(title, result.fields, true);
                            if (title !== 'branch') {
                                if (!existUser) {
                                    createUser(title, result.fields, subIndex, true);
                                } else {
                                    var itemUser = vm.formWizard[title][subIndex];
                                    upgradeRol(title, subIndex, itemUser)
                                    vm.addUsersJobFromUserId(itemUser.division, itemUser.position, itemUser.branch_id, itemUser, true)
                                }
                            }
                            else if (title === 'branch') {
                                saveRemainBranches();
                                //addBranchToForm(result.fields, subIndex);
                            }
                        }
                    }
                }
            });
        }

        function upgradeRol(title, index, itemUser) {
            if ((vm.positionsIds.compliance_officer == itemUser.position
                || vm.positionsIds.compliance_comite == itemUser.position
                || vm.positionsIds.data_protection == itemUser.position)
                && (itemUser.user_type > 3) && !vm.quotaexceded) {
                vm.formWizard[title][index].user_type = 3;
                updateUser(title, index);
            }
        }

        function addUsersJobFromUserId(divisionId, jobPositionId, branchId, user, noPush) {
            if (angular.isUndefined(user.isAdded) && divisionId && jobPositionId && branchId) {
                clientsService.addUserToCompany({
                    owner: $scope.owner,
                    user_id: user.id,
                    company_id: vm.idCompany
                }).then(function (response) {

                })
                clientsService.addUserJobPosition({
                    owner: $scope.owner,
                    user_id: user.id,
                    branch_id: branchId,
                    division_id: divisionId,
                    job_position_id: jobPositionId
                }).then(function (response) {
                    user.branch_id = branchId;
                    user.division = divisionId;
                    user.position = jobPositionId;
                    user.isAdded = true;
                    if (!noPush) {
                        vm.formWizard.personnel.push(user);
                    }
                })
            }
        }

function editUser(usersArray, idx) {
            vm.openDialogForm('personnel', '', '', usersArray[idx], idx)
        }

        function getDivisionName(divisionId) {

            var x = vm.divisions.filter(function (division) {
                return (division.id == divisionId);
            });
            return x;
        }

        function getPositionName(positionId) {
            var x = vm.positions.filter(function (position) {
                return (position.id == positionId);
            });
            return x;
        }


        function areFromType(users, type) {
            var result = [];
            for (var i = 0; i < users.length; i++) {
                if (vm.isFromType(users[i], type)) {
                    result.push(users[i]);
                }
            }
            return result;
        }
        function isFromType(user, type) {
            if ((!user.branch_id || user.branch_id == vm.formWizard.main_branch.id) && user.position == vm.positionsIds[type] && user.division == vm.divisionsId[type]) {
                return true
            }
            return false;
        }
function createUser(type, subForm, subIndex, noPush) {
            //var itemUser = transformClients.userToDTO(subForm, type);
            var itemUser = vm.formWizard[type][subIndex];
            if ((vm.positionsIds.compliance_officer == itemUser.position || vm.positionsIds.compliance_comite == itemUser.position || vm.positionsIds.data_protection == itemUser.position && itemUser.user_type > 3) && !vm.quotaexceded) {
                itemUser.user_type = 3;
            } else if (vm.positionsIds.collaborator == itemUser.position && !itemUser.user_type) {
                itemUser.user_type = 6; // Usuario COLLABORATOR
            } else if (itemUser.user_type > 4 || !itemUser.user_type) {
                if (itemUser.password) {
                    itemUser.user_type = 4;
                } else {
                    itemUser.user_type = 5;
                }
            }
            itemUser.region_id = vm.formWizard.company.region_id;
            if (!angular.isUndefined(itemUser.password) && itemUser.password.length == 0) {
                delete itemUser.password;
            }
            var options = {
                owner: $scope.owner,
                item: itemUser
            };
            clientsService.createUser(options).then(function (response) {
                vm.users.push(response);
                vm.formWizard[type][subIndex].id = response.id;
                if (!angular.isUndefined(itemUser.position) && !angular.isUndefined(itemUser.division) && !angular.isUndefined(itemUser.branch_id)) {
                    vm.addUsersJobFromUserId(itemUser.division, itemUser.position, itemUser.branch_id, itemUser, noPush)
                }
                $scope.uploadingFotoUserId = response.id;
                if (vm.files.length > 0) {
                    angular.forEach(vm.files, function (f) {
                        vm.uploadMedia(f, response.id, 'user_photo')
                    })
                } else {
                    delete $scope.uploadingFotoUserId;
                    delete vm.files;
                }

            }, function (error) {
                getUsers();
                getDataCompany(vm.idCompany);
            })
        }

function updateUser(type, subIndex) {
            var itemUser = vm.formWizard[type][subIndex];
            if (itemUser.password && itemUser.user_type > 4) {
                itemUser.user_type = 4;
            }
            var options = {
                owner: $scope.owner,
                id: itemUser.id,
                item: itemUser
            };
            clientsService.updateUser(options).then(function () {
                $scope.uploadingFotoUserId = itemUser.id;
                delete itemUser.password;
                if (vm.files && vm.files.length > 0) {
                    var uploading = false;
                    angular.forEach(vm.files, function (f) {
                        if (!f.url) {
                            uploading = true;
                            vm.uploadMedia(f, itemUser.id, 'user_photo')
                        }
                    })
                    if (!uploading) {
                        delete $scope.uploadingFotoUserId;
                        delete vm.files;
                    }
                } else {
                    delete $scope.uploadingFotoUserId;
                    delete vm.files;
                }
                getUsers();
                getDataCompany(vm.idCompany);
            });
        }

function createSubForm(title, subForm, noFields, branchId) {
            if (noFields) {
                var newData = {};
                if (branchId) {
                    newData.branch_id = branchId;
                } else if (vm.formWizard.main_branch && vm.formWizard.main_branch.id) {
                    newData.branch_id = vm.formWizard.main_branch.id;
                }
                angular.forEach(subForm, function (field) {
                    if (field.field == 'profile_color') {
                        newData[field.field] = vm.profileColors[Math.floor(Math.random() * vm.profileColors.length)];
                    } else {
                        newData[field.field] = field.value;
                    }
                })
                subForm = newData
            } else {
                transformClients.setFullName(subForm);
            }
            if (!vm.formWizard) {
                vm.formWizard = {};
            }
            if (angular.isUndefined(vm.formWizard[title])) {
                vm.formWizard[title] = [];
            }
            vm.formWizard[title].push(subForm);
            return (vm.formWizard[title].length > 0) ? vm.formWizard[title].length - 1 : undefined;
        }

        function newForm(ev) {
            if (vm.quota.companies_registered >= vm.quota.max_allowed_companies) {
                $mdDialog.show({
                    controller: 'CompanyQuotaDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/dialogs/companyQuotaDialog/companyQuotaDialog.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                    }
                }).then(function (res) {
                    if (res && res.type) {
                        if (res.type == 'upgrade') {
                            console.log("go upgrade screen");
                        } else {
                            vm.idCompany = '';
                            vm.mainBranch = {};
                            vm.readView = true;
                        }
                    }
                });
            } else {
                if (vm.fromComplaint) {
                    $mdDialog.show({
                        controller: 'NewClientDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/apps/clients-complaints/dialogs/new-client-dialog/new-client-dialog.html',
                        parent: angular.element($document.body),
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        locals: {
                            company: null,
                            main_branch: null,
                            sectors: vm.sectors,
                            regions: vm.regions,
                            regionsLiterals: vm.regionsLiterals
                        }
                    }).then(function (res) {
                        if (res) {
                            vm.formWizard = {};
                            vm.formWizard.company = res.company;
                            vm.formWizard.main_branch = res.branch;
                            $scope.image = res.image
                            $scope.isLoading = true;
                            vm.forceCreateBranch = true;
                            createCompany(null, true);
                        }
                    });
                } else {
                    vm.idCompany = '';
                    vm.mainBranch = {};
                    vm.readView = true;
                    $timeout(function () {
                        vm.formWizard.company.region_id = sessionService.user.region_id;
                    }, 1000)
                }
            }
        }

        function closeForm(preview) {
            if (vm.idCompany) {
                getDataCompany(vm.idCompany);
                vm.readView = false;
                vm.preview = preview;
            } else {
                vm.goClients();
            }
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients-complaints')
        .controller('MediaClientsController', MediaClientsController);

    /** @ngInject */
    function MediaClientsController($mdDialog,$stateParams, $document, mediaService, owner, requestContext, $anchorScroll, $timeout, $scope, $sce, Upload, multipleSelection, msUtils, COMMON, isTiny, $log) {
        var vm = this;

        // Data
        vm.owner = owner;
        $scope.owner = $stateParams.owner;

        vm.defaultPage = 1;
        vm.defaultPerPage = 50;
        vm.PerPage = 50;
        vm.searchStringFilter = '';
        vm.searchQuery = '';
        vm.modelSearch = '';
        vm.pagination_search = pagination_search;

        vm.isTiny = isTiny;

        vm.views = {
            1: 'app/main/apps/clients/dialogs/media/views/photos-view.html',
            2: 'app/main/apps/clients/dialogs/media/views/videos-view.html',
            3: 'app/main/apps/clients/dialogs/media/views/files-view.html',
            4: 'app/main/apps/clients/dialogs/media/views/audios-view.html',
            upload: 'app/main/apps/clients/dialogs/media/views/upload-view.html',
            import: 'app/main/apps/clients/dialogs/media/views/import-view.html',
        };
        vm.defaultView = 'upload';
        vm.currentView = 'upload';

        vm.viewsTiny = {
            1: 'app/main/apps/clients/dialogs/media/views/tiny-attached.html',
            properties: 'app/main/apps/clients/dialogs/media/views/tiny-properties.html',
            upload: 'app/main/apps/clients/dialogs/media/views/upload-view.html',
        };
        vm.defaultViewTiny = '1';
        vm.currentViewTiny = '1';

        vm.firstLoad = true;
        vm.media_type = '1';
        vm.showSearchAndPaginator = true;
        vm.import_field = '';
        vm.import_disabled = '';
        vm.importedFiles = [];
        vm.importPreview = false;
        vm.imported = false;
        vm.importing = false;
        vm.selectedImages = [];
        vm.files = [];
        vm.tinyProperties = {
            mediaType: '',
            mediaSort: '',
            mediaData: {},
            align: '',
            size: ''
        };
        vm.tinyOptions = {
            size: [
                { value: 25, text: '25%' },
                { value: 50, text: '50%' },
                { value: 75, text: '75%' },
                { value: 100, text: '100%' }
            ],
            align: [
                { value: 'left', text: 'left' },
                { value: 'center', text: 'center' },
                { value: 'right', text: 'right' }
            ]
        }

        // If replying
        // if (angular.isDefined(selectedMail)) {
        // 	vm.form.to = selectedMail.from.email;
        // 	vm.form.subject = 'RE: ' + selectedMail.subject;
        // 	vm.form.message = '<blockquote>' + selectedMail.message + '</blockquote>';
        // }

        // Methods
        vm.closeDialog = closeDialog;
        vm.changeView = changeView;
        vm.changeViewTiny = changeViewTiny;

        vm.nextPage = nextPage;
        vm.prevPage = prevPage;
        vm.morePages = morePages;
        vm.firstPage = firstPage;
        vm.upload = upload;
        vm.attachMedia = attachMedia;
        vm.attachMediaTiny = attachMediaTiny;
        vm.selectMediaTiny = selectMediaTiny;
        vm.selectedMediaTiny = '';
        vm.search = search;

        vm.exists = msUtils.exists;
        vm.alreadySelectedbyZone = alreadySelectedbyZone;
        vm.existInArray = msUtils.existInArray;
        vm.toggleSelectedImages = toggleSelectedImages;


        //////////

        if (!isTiny) {
            init();
        } else {
            vm.section = section;
            initTiny();
        }
        /**
         * Initialize
         */
        function init() {

            vm.loading = true;
        }

        /**
         * Initialize Tinymce
         */
        function initTiny() {
            vm.currentViewTiny = vm.defaultViewTiny;
            vm.showSearchAndPaginator = false;
            vm.loading = true;
            for (var i = 0; i < vm.currentThread.length; i++) {
                if (vm.mediazone) {
                    if (vm.currentThread[i].id_zone == 1) {
                        vm.selectedImages.push(vm.currentThread[i]);
                    }
                } else {
                    vm.selectedImages.push(vm.currentThread[i]);
                }
            }
            if (vm.section.mediaSort) {
                var currentSort = 0;
                var currentItem = '';
                for (var i = 0; i < vm.currentThread.length; i++) {
                    if (vm.mediazone) {
                        if (vm.currentThread[i]['id_zone'] == 1 && (vm.currentThread[i]['media_type'] == vm.section.mediaType)) {
                            currentSort++;
                            if (currentSort = vm.section.mediaSort) {
                                currentItem = vm.currentThread[i];
                            }
                        }
                    } else {
                        if (vm.currentThread[i]['media_type'] == vm.section.mediaType) {
                            currentSort++;
                            if (currentSort = vm.section.mediaSort) {
                                currentItem = vm.currentThread[i];
                            }
                        }

                    }
                }

                vm.selectedMediaTiny = currentItem;
                vm.tinyProperties.mediaSort = vm.section.mediaSort;
                vm.tinyProperties.mediaType = currentItem.media_type;
                vm.tinyProperties.align = vm.section.mediaAlign;
                vm.tinyProperties.size = vm.section.mediaSize;
                vm.changeViewTiny('properties');


            }
            vm.loading = false;

        }

        function pagination_search(searchString) {
            var options = {
                section: section,
                media_type: vm.media_type,
                page: vm.defaultPage,
                perPage: vm.defaultPerPage,
                searchString: searchString
            };
        }


        function search(options) {
            // console.log(options, vm.searchStringFilter);
            /*

			vm.loading 		= true;
			vm.items		=[];
			// Scroll to the top Dialog
            scrollToTopOfDialog();

			mediaService.get({
				siteID: siteID,
				page: options.page,
				paginate: options.perPage,
				media_type: options.media_type,
                withCropStatus: true,
                sortField: 'date_uploaded',
                searchStringFilter: options.searchString,

			})
				.then(function (response) {
					vm.totalItems = response.total;
					vm.pagination_totalItems = response.total;
					vm.from = response.from;
					vm.pagination_from = response.from;
					vm.to = response.to;
					vm.pagination_to = response.to;
					vm.currentPage = response.current_page;
					vm.lastPage = response.last_page;
					vm.maxSize = 500;
					vm.bigTotalItems = 175;

					vm.loading = false;

                    vm.items = angular.copy(response.data);

                    $('.md-button')
                        .removeClass('active');
                    $('[type=' + options.media_type + ']')
						.addClass('active');

				});




			vm.firstLoad = false;
*/
        }

        function closeDialog() {
            $mdDialog.hide(vm.currentThread);
        }

        function changeView(view) {

            //console.log(view)
            if (vm.views[view]) {
                vm.items = [];
                vm.loadingView = true;
                vm.showSearchAndPaginator = false;
                vm.defaultView = view;
                vm.currentView = view;


                vm.media_type = view;

                var options = {
                    page: 1,
                    perPage: vm.PerPage,
                    media_type: view,

                };
                if (view == 1 || view == 2 || view == 3 || view == 4) {
                    vm.showSearchAndPaginator = true;
                }

            }

        }

        function changeViewTiny(view) {


            if (vm.viewsTiny[view]) {
                vm.items = [];
                vm.loadingView = true;
                vm.showSearchAndPaginator = false;
                vm.defaultViewTiny = view;
                vm.currentViewTiny = view;
            }

        }

        $scope.file_changed = function (element) {

            $scope.$apply(function (scope) {
                var photofile = element.files[0];
                console.log(photofile);
                $mdDialog.hide(photofile);
                //vm.upload(photofile);
                var reader = new FileReader();
                reader.onload = function (e) {
                    // handle onload
                };
                reader.readAsDataURL(photofile);
                $scope.image = photofile;
            });
        };

        $scope.$watch('vm.files', function () {
            console.debug("WATCH!!:::!:!:!:!: ")
            $scope.formUpload = false;
            if (vm.files != null) {
                // make files array for not multiple to be able to be used in ng-repeat in the ui
                if (!angular.isArray(vm.files)) {
                    $timeout(function () {
                        $scope.files = vm.files = [vm.files];
                    });
                    return;
                }
                for (var i = 0; i < vm.files.length; i++) {
                    $scope.errorMsg = null;
                    (function (f) {
                        //vm.upload(f, true);
                        $mdDialog.hide(f);
                    })(vm.files[i]);
                }
            }
        });

        $scope.$watch('vm.import_field', function () {
            vm.importConfirm(false);
        });


        $scope.log = '';

        function upload(file) {
            if (!file.$error) {
                var token = undefined;
                console.debug("UPLOAD______****", file)
                mediaService.getS3UploadPreSignedUrl({
                    owner: $scope.owner,
                    uploadKey: 'company_logo',
                    fileName: file.name,
                    rowId: 1
                })
                    .then(function (resp) {
                        token = resp.token;
                        file.id_media = resp.id_media;
                        file.upload = Upload.http({
                            url: resp.url,
                            skipAuthorization: true,
                            method: 'PUT',
                            headers: {
                                "Content-Type": file.type != '' ? file.type : 'application/octet-stream' 
                            },
                            data: file
                        });

                        file.upload.then(function (response) {
                            file.result = response.data;
                            $timeout(function () {
                                $scope.log = 'file: ' +
                                    file.name +
                                    ', Response: ' + JSON.stringify(response.data) +
                                    ', ID: ' + file.id_media +
                                    '\n' + $scope.log;
                            });
                            console.debug("SEND_TO_CROP______****", file)
                            mediaService.finishedUploadingFileToCdn({
                                owner: vm.owner,
                                idMedia: file.id_media,
                                token: token
                            })
                            $mdDialog.hide(vm.files[0]);


                        }, function (response) {
                            if (response.status > 0)
                                $scope.errorMsg = response.status + ': ' + response.data;
                        });

                        file.upload.progress(function (evt) {
                            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                        });

                    })
            }
        };

        vm.importConfirm = function (confirm) {
            vm.import_disabled = false;
            vm.imported = false;
            if (!confirm) {
                vm.importPreview = false;
            }
            if (vm.import_field.length > 10) {
                vm.importing = true;
                vm.import_disabled = true;

                $timeout(function () {
                    var pastedUrl = vm.import_field;
                    mediaService.importFromUrl({
                        siteID: siteID,
                        url: pastedUrl,
                        execute: confirm
                    })
                        .then(function (response) {
                            vm.importing = false;
                            response.embedCodeSafe = $sce.trustAsHtml(response.metadata.embedCode);
                            if (response.id_media) {
                                vm.imported = true;
                                vm.importPreview = false;
                                mediaService.get({
                                    siteID: siteID,
                                    withCropStatus: true,
                                    idMedia: response.id_media
                                })
                                    .then(function (response) {
                                        if (response.total == 1) {
                                            var photo = response.data[0];
                                            vm.importedFiles.push(photo);
                                            toggleSelectedImages(photo);
                                        }
                                    });

                            } else {
                                vm.importPreview = response;
                            }
                            vm.import_disabled = false;
                        });
                })
            }
        }

        function nextPage() {

            var options = {
                page: vm.currentPage + 1,
                perPage: vm.PerPage,
                media_type: vm.media_type
            };

        }

        function prevPage() {
            var options = {
                page: vm.currentPage - 1,
                perPage: vm.PerPage,
                media_type: vm.media_type,
                searchString: vm.modelSearch
            };
            
        }

        function morePages() {
            if (vm.currentPage <= vm.lastPage) return true;
            return false;
        }

        function firstPage() {
            if (vm.currentPage == 1) return true;
            return false;
        }

        function alreadySelectedbyZone(array, item) {
            var ret = false;
            for (var i = 0, len = array.length; i < len; i++) {
                if (vm.mediazone) {
                    if (array[i]['id_media'] === item.id_media && array[i]['id_zone'] === mediazone.id_zone) {
                        ret = true;
                    }
                } else {
                    if (array[i]['id_media'] === item.id_media) {
                        ret = true;
                    }

                }
            }

            return ret;
        }


        function toogleSelectedbyZone(item) {
            if (!multipleSelection) {
                vm.selectedImages = [];
            }
            for (var i = 0, len = vm.selectedImages.length; i < len; i++) {
                if (vm.selectedImages[i]['id_media'] === item.id_media && vm.selectedImages[i]['id_zone'] === mediazone.id_zone) {
                    vm.selectedImages.splice(i, 1);
                    return;
                }
            }

            vm.selectedImages.push(item);
            return;
        }

        function selectMediaTiny(item) {
            var currentSort = 0;
            var mediaSort = 0;
            for (var i = 0; i < vm.currentThread.length; i++) {
                if (vm.mediazone) {
                    //            		console.log(vm.currentThread[i]['id_zone']);
                    if (vm.currentThread[i]['id_zone'] == 1 && (vm.currentThread[i]['media_type'] == item.media_type)) {
                        currentSort++;
                        if (item.id_media == vm.currentThread[i]['id_media']) {
                            mediaSort = currentSort;
                        }
                    }
                } else {
                    currentSort++;
                    if (item.id_media == vm.currentThread[i]['id_media']) {
                        mediaSort = currentSort;
                    }
                }
            }
            vm.selectedMediaTiny = item;
            vm.tinyProperties.mediaSort = mediaSort;
            vm.tinyProperties.mediaType = item.media_type;
            vm.changeViewTiny('properties');

        }

        function attachMedia() {
            if ($scope.image) {
                $mdDialog.hide($scope.image);
            } else {
                $mdDialog.hide();
            }
        }

        function attachMediaTiny() {
            $mdDialog.hide(vm.tinyProperties);
        }

        /**
         * Toggle selected status of the contact
         *
         * @param contact
         * @param event
         */
        function toggleSelectedImages(photo, event) {
            if (event) {
                event.stopPropagation();
            }


            //         else{
            if (vm.mediazone) {
                photo.id_zone = vm.mediazone.id_zone;
                photo.zone_name = vm.mediazone.zone_name;
            } else {
                photo.id_zone = null;
                photo.zone_name = null;
            }

            toogleSelectedbyZone(photo);

        }

        /**
         * Scroll Media Dialog Content to the top
         * @param speed
         */
        function scrollToTopOfDialog() {     
            $timeout(function () {
                var dialogContent = $document.find('md-dialog-content').filter(function () {
                    return angular.element(this).hasClass('mediadialog-content');
                });
                if (!angular.isUndefined(dialogContent[0])) {
                    dialogContent.animate({
                        scrollTop: dialogContent[0].scrollHeight  
                    }, 1);
                }
            }, 1000);

        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients-complaints')
        .controller('DialogFormController', DialogFormController);

    /** @ngInject */
    function DialogFormController($mdDialog, $document, usersService, clientsService, sessionService, owner, type, documentsService, positionsIds, idCompany, $filter, $mdMenu, requestContext, Upload, user_type, title, fields, users, $translate, alreadySelected, branchId, storagePrefix, $anchorScroll, $timeout, $scope, $sce, msUtils, COMMON, isTiny, $log, defaultDivision, defaultJob) {

        var vm = this;
        var originatorEv;
        vm.owner = owner;
        vm.type = type;
        sessionService.getQuota().then(function (quota) {
            vm.quota = quota;
        });

        vm.userLogued = sessionService.getUser();
        vm.fields = fields;
        var foundFiles = _.find(vm.fields, function (field) {
            return field.field == 'files';
        });
        vm.files = (foundFiles && foundFiles.value) ? (Array.isArray(foundFiles.value) ? foundFiles.value : [foundFiles.value]) : [];
        vm.emailOriginal = _.find(vm.fields, function (field) {
            if (field.field == 'email') {
                return true
            }
        }).value;
        vm.openMenu = openMenu;
        vm.user_type = user_type;
        vm.positionsIds = positionsIds;

        vm.alreadySelected = [];
        vm.branchId = branchId;
        vm.storagePrefix = storagePrefix;
        vm.deleteAvatar = deleteAvatar;
        vm.noDivisionJobSelected = true;
        vm.jobPositionId = '';
        vm.divisionId = '';
        vm.alreadySelected = alreadySelected;
        vm.indexDivision = null;
        vm.indexPosition = null;
        vm.translate = function (text) {
            return $translate.instant(text);
        }

        for (var i = 0; i < vm.fields.length; i++) {
            if (vm.fields[i].field == 'division') {
                vm.indexDivision = i;
                break;
            }
        }
        for (var i = 0; i < vm.fields.length; i++) {
            if (vm.fields[i].field == 'position') {
                vm.indexPosition = i;
                break;
            }
        }



        var originatorEv;

        function openMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        }

        function deleteAvatar(file) {
            var options = {
                owner: vm.owner,
                id: file.id
            }
            documentsService.deleteDocument(options).then(function () {
                vm.files = [];
            })
        }

        if (defaultDivision) {
            vm.divisionId = defaultDivision;
        }
        if (defaultJob) {
            vm.jobPositionId = defaultJob;
        }



        // Methods
        vm.closeDialog = closeDialog;
        vm.sendForm = sendForm;
        vm.disabledPosition = disabledPosition;
        vm.showSector = showSector;
        vm.selectUser = selectUser;
        vm.showUserImage = showUserImage;
        vm.showSelectPosition = showSelectPosition;
        vm.selectJobDivision = selectJobDivision;
        vm.unSelectJobDivision = unSelectJobDivision;
        vm.divisionJobSelected = divisionJobSelected;
        vm.showJobDivision = showJobDivision;
        vm.isSendDisabled = isSendDisabled;

        init();

        function init() {
            vm.loading = true;
            if (title === 'branch') {
                vm.title = 'GLOBAL.NEW_BRANCH';
            } else if (title === 'administrator') {
                vm.title = 'GLOBAL.ADMINISTRATOR';
            } else if (title === 'managerLegal') {
                vm.title = 'GLOBAL.LEGAL_MANAGER';
            } else if (title === 'personnel' && defaultJob == "") {
                vm.title = 'GLOBAL.BRANCH_PERSONNEL';
            } else if (title === 'personnel' && defaultJob == 3) {
                vm.title = 'GLOBAL.COMPLIANCE_OFFICER';
            } else if (title === 'personnel' && defaultJob == 4) {
                vm.title = 'GLOBAL.REPORT_COMMITTEE';
            } else if (title === 'personnel' && defaultJob == 5) {
                vm.title = 'GLOBAL.DELEGATE_DATA_PROTECCTION';
            } else if (title === 'personnel' && defaultJob == 2) {
                vm.title = 'GLOBAL.ADMINISTRATOR';
            } else if (title === 'personnel' && defaultJob == 1) {
                vm.title = 'GLOBAL.LEGAL_MANAGER';
            }
            getUsersByCompany(idCompany)
            getUsersAdministrators()
        }


        function getUsersByCompany(idCompany) {
            var options = {
                owner: vm.owner,
                inCompany: idCompany,
                resultsPerPage: 500
            };
            clientsService.getUsers(options).then(function (response) {
                vm.users = response.data;
            })
        }
        function getUsersAdministrators() {
            var options = {
                owner: vm.owner,
                resultsPerPage: 100
            };
            usersService.getUsers(options).then(function (response) {
                vm.usersAll = response.data;
            })
        }


        function closeDialog() {
            $mdDialog.hide();
        }
        function isSendDisabled() {
            for (var i = 0; i < vm.fields.length; i++) {
                const element = vm.fields[i];
                if (element.required && !element.value) {
                    return true;
                }
            }
            return false;
        }

        function checkUploadsAndUpdateUser() {
            var noUpdate = false;
            if (vm.files) {
                angular.forEach(vm.files, function (file) {
                    if (angular.isUndefined(file.progress) || file.progress < 100) {
                        noUpdate = true;
                    }
                })
                if (!noUpdate && !$scope.uploadingFile) {
                    initState()
                    vm.loadingReadPane = false;
                    $rootScope.pagination_resetquery();
                } else {
                    $timeout(function () {
                        vm.checkUploadsAndUpdateUser();
                    }, 1000)
                }
            } else {
                initState()
                vm.loadingReadPane = false;
                $rootScope.pagination_resetquery();

            }
        }

        function sendForm(ev) {
            for (var i = 0; i < vm.fields.length; i++) {
                if (vm.fields[i].field === 'position' && !vm.fields[i].value) {
                    vm.fields[i].value = vm.jobPositionId;
                }
                else if (vm.fields[i].field === 'division' && !vm.fields[i].value) {
                    vm.fields[i].value = vm.divisionId;
                } else if (vm.fields[i].field === 'email' && vm.fields[i].value == '') {
                    delete vm.fields[i].value;
                }
            }
            if (((vm.positionsIds.compliance_officer == vm.jobPositionId
                || vm.positionsIds.compliance_comite == vm.jobPositionId
                || vm.positionsIds.data_protection == vm.jobPositionId)
                && vm.quota.users_registered >= vm.quota.max_allowed_users)
            ) {
                $mdDialog.show({
                    controller: 'UserQuotaDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/dialogs/userQuotaDialog/userQuotaDialog.html',
                    preserveScope: true,
                    autoWrap: true,
                    multiple: true,
                    locals: {
                        user: vm.userLogued,
                        quota: vm.quota,
                        quotaComplaint: null
                    }
                }).then(function (res) {
                    if (res && res.type) {
                        if (res.type == 'upgrade') {
                            console.log("go upgrade screen");
                        } else {
                            createUser(true);
                        }
                    }
                });
            } else {
                createUser();
            }



        }

        function createUser(quotaexceded) {


            var email = _.find(vm.fields, function (field) {
                if (field.field == 'email') {
                    return true
                }
            }).value;

            if (vm.emailOriginal === email) {
                vm.fields.files = vm.files;
                $mdDialog.hide({ fields: vm.fields, quotaexceded: quotaexceded });
                return
            }
            var options = {
                owner: vm.owner,
                searchStringFilter: email
            };
            usersService.getUsersWithTrashed(options).then(function (response) {

                var existedUser = _.find(response.data, function (user) {
                    if (user.email == email && (!vm.userSelected || user.id !== vm.userSelected.id)) {
                        return true;
                    }
                });

                if (!existedUser) {
                    vm.fields.files = vm.files;
                    $mdDialog.hide({ fields: vm.fields, quotaexceded: quotaexceded });
                } else {
                    alert = $mdDialog.alert({
                        title: vm.translate('GLOBAL.ATTENTION'),
                        textContent: vm.translate('GLOBAL.USER_ALREADY_EXISTS'),
                        ok: vm.translate('GLOBAL.CLOSE'),
                    }).multiple(true);

                    $mdDialog
                        .show(alert)
                        .finally(function () {
                            alert = undefined;
                        });
                }
            })





        }

        function disabledPosition(field) {
            var idAdmin;
            var idManagerLegal;
            var idComplaints;
            var idReport;
            for (var i = 0; i < field.options.length; i++) {
                if (field.options[i].field === 'ADMINISTRADOR') {
                    idAdmin = field.options[i].id;
                } else if (field.options[i].field === 'REPRESENTANTE LEGAL') {
                    idManagerLegal = field.options[i].id
                } else if (field.options[i].field === 'Complaints committee') {
                    idComplaints = field.options[i].id
                } else if (field.options[i].field === 'Reports committee') {
                    idReport = field.options[i].id
                }
            }

            if (vm.title === 'managerLegal') {
                field.value = idManagerLegal;
                return true;
            } else if (vm.title === 'administrator') {
                field.value = idAdmin;
                return true;
            } else if (vm.title === 'compliance') {
                field.value = idComplaints;
                return true;
            } else if (vm.title === 'report') {
                field.value = idReport;
                return true;
            }
        }

        function showSector() {
            if (title === 'personnel') {
                return true;
            }
        }

        function selectUser(user) {
            for (var i = 0; i < vm.fields.length; i++) {
                if (vm.fields[i].field === 'first_name') {
                    vm.fields[i].value = user.first_name
                } else if (vm.fields[i].field === 'last_name') {
                    vm.fields[i].value = user.last_name;
                } else if (vm.fields[i].field === 'email') {
                    vm.fields[i].value = user.email;
                } else if (vm.fields[i].field === 'nif') {
                    vm.fields[i].value = user.id_number;
                } else if (vm.fields[i].field === 'position') {
                    vm.fields[i].value = vm.jobPositionId;
                } else if (vm.fields[i].field === 'division') {
                    vm.fields[i].value = vm.divisionId;
                } else if (vm.fields[i].field === 'profile_color') {
                    vm.fields[i].value = user.profile_color;
                } else if (vm.fields[i].field === 'user_type') {
                    vm.fields[i].value = user.user_type;
                }
            }

            vm.fields.push({ field: 'id', value: user.id });
            vm.fields.push({ field: 'files', value: user.files });
            if (vm.quota.users_registered >= vm.quota.max_allowed_users && (user.user_type > 3)) {
                $mdDialog.show({
                    controller: 'UserQuotaDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/dialogs/userQuotaDialog/userQuotaDialog.html',
                    preserveScope: true,
                    autoWrap: true,
                    multiple: true,
                    locals: {
                        user: vm.userLogued,
                        quota: vm.quota,
                        quotaComplaint: null
                    }
                }).then(function (res) {
                    if (res && res.type) {
                        if (res.type == 'upgrade') {
                            console.log("go upgrade screen");
                        } else {
                            $mdDialog.hide({ fields: vm.fields, existUser: true, quotaexceded: vm.quota.users_registered >= vm.quota.max_allowed_users });
                        }
                    }
                });
            } else {
                $mdDialog.hide({ fields: vm.fields, existUser: true, quotaexceded: vm.quota.users_registered >= vm.quota.max_allowed_users });
            }

        }

        $scope.filterAlreadyAdded = function (item) {
            if (vm.fields[vm.indexDivision].value && vm.fields[vm.indexPosition].value) {
                var found = $filter('filter')(vm.alreadySelected, { id: item.id, position: vm.fields[vm.indexPosition].value, division: vm.fields[vm.indexDivision].value });
                return found.length == 0;;
            } else {
                var found = _.find(vm.alreadySelected, function (_item) { return _item.id == item.id });
                return !found;
            }
        };

        function showUserImage(user) {
            return vm.storagePrefix + user.files.url
        }

        function showSelectPosition() {
            if (vm.branchId && vm.noDivisionJobSelected) {
                return true;
            }
            return false;
        }

        function selectJobDivision() {
            vm.noDivisionJobSelected = false;
        }

        function divisionJobSelected() {
            var ret1 = false;
            var ret2 = false;
            for (var i = 0; i < vm.fields.length; i++) {
                if (vm.fields[i].field === 'position' && vm.fields[i].value) {
                    vm.jobPositionId = vm.fields[i].value;
                    ret1 = true;
                }
                if (vm.fields[i].field === 'division' && vm.fields[i].value) {
                    vm.divisionId = vm.fields[i].value;
                    ret2 = true;
                }
            }

            return (!ret1 || !ret2);
        }

        function unSelectJobDivision() {
            vm.noDivisionJobSelected = true;
        }

        function showJobDivision() {
            if (vm.branchId) {
                return true;
            }
            return false;
        }

    }
})();


(function () {
    'use strict';

    angular
        .module('app.clients-complaints')
        .constant('_', window._)
        .controller('EditBranchDialog', EditBranchDialog);

    /** @ngInject */
    function EditBranchDialog($scope, $mdDialog, $translate, region_id, clientsService, tinyMceService, branch, $mdToast) {
        var vm = this;
        vm.region_id = region_id;
        vm.branch = angular.copy(branch);
        vm.tinymceOptions = tinyMceService.getOptions($scope);
        vm.tinymceOptions.height = 100;
        vm.saveDialog = saveDialog;
        vm.closeDialog = closeDialog;
        vm.getRegionLiteral = getRegionLiteral;
        clientsService.getFileRegions().then(function (res) {
            vm.regionsLiterals = res;
        })
        function saveDialog() {

            $mdDialog.hide(vm.branch);

        }
        function getRegionLiteral(literalKey) {
            if (vm.region_id && vm.regionsLiterals) {
                const literalsObject = vm.regionsLiterals.find(x => x.region_id === vm.region_id)
                return literalsObject.literals[literalKey];
            } else {
                return '';
            }
        }



        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();
(function () {
	'use strict';

	angular
		.module('app.clients-complaints')
		.controller('ImageDialogClientsController', ImageDialogClientsController);

	/** @ngInject */
	function ImageDialogClientsController($mdDialog, sessionService, Images, ImageSelected, $document, cropFormats, MediaFull)
	{
		var vm = this;

		vm.views = {
			fotorama: 'app/main/apps/clients-complaints/dialogs/image/views/fotorama-view.html',
			editmedia: 'app/main/apps/clients-complaints/dialogs/image/views/edit-media-view.html',
		};
		vm.defaultView = 'fotorama';
		vm.currentView = 'fotorama';

		// Data
		vm.title = 'View Media';
		vm.images = [];
		vm.dataImages = [];

		// Methods
		vm.closeDialog = closeDialog;
		vm.changeView = changeView;
		vm.edit = edit;

		// //////////

		/**
		 * Close dialog
		 */
		function closeDialog()
		{
			/*var $fotoramaDiv = $('#fotorama').fotorama();
			var fotorama = $fotoramaDiv.data('fotorama');
			fotorama.destroy();*/
			$mdDialog.hide();
		}

		init();

		function init()
		{

			vm.dataFotorama = [];
			var fotoramaDiv = angular.element(".testingelement");

			var fit = (cropFormats) ? 'scaledown' : 'contain';
			vm.fotoramaoptions = {
				width: '100%',
				height: '80%',
				captions: true,
				loop: true,
				keyboard: true,
				allowfullscreen: true,
				nav: 'thumbs',
				ratio: 16 / 9,
				fit: fit,
			};

			if (!cropFormats) {
				if (!_.isArray(Images)) {
					var ImagesArray = [];
					ImagesArray.push(Images);
					Images = ImagesArray;
				}


				for (var i = 0; i < Images.length; i++) {

					var attachment = Images[i];
					var imagesCrops = [];

					for (var iCrop = 0; iCrop < Images[i].cropstatus.length; iCrop++) {
						var imageCrop = Images[i].cropstatus[iCrop];
						imagesCrops.push(Images[i].cropstatus[iCrop]);
					}

					if (ImageSelected) {
						var selected = (Images[i].id_media === ImageSelected.id_media) ? true : false;
					} else {
						var selected = false;
					}

					if (Images[i].media_type !== 1) {
						// continue;
					}

					// .container.view_url}}{{image.cropstatus[0].fileName

					if (attachment.media_type == 1) {

						if (MediaFull) {
							var cropstatus = _.find(Images[i].cropstatus, {
								'id_cropformats': sessionService.getMediaThumbnailCropformatId()
							});

							var cropstatus = _.find(Images[i].cropstatus, {
								'id_cropformats': sessionService.getMediaFullCropformatId()
							});
							var urlImage = cropstatus.container.view_url + cropstatus.fileName;
							vm.dataFotorama.push({
								imageUrl: urlImage,
								thumb: urlImage,
								dataCaption: '#' + attachment.id_media + ' | ' + urlImage,
								html: '<div>123</div>',
								selected: selected
							})
						} else {
							var cropstatus = _.find(attachment.cropstatus, {
								'id_cropformats': sessionService.getMediaFullCropformatId()
							});

							if(!cropstatus){
								var urlImage = attachment.container.view_url + 'original/m' + attachment.id_media + '_' + attachment.filename;
							}else{
								var urlImage = cropstatus.container.view_url + cropstatus.fileName;
							}
								vm.dataFotorama.push({
									imageUrl: urlImage,
									thumb: urlImage,
									dataCaption: '#' + attachment.id_media + ' | ' + urlImage,
									html: '<div>123</div>',
									selected: selected
								})
						}
					}

					if (attachment.media_type == 2) {
						var videoUrl = '';
						if (!attachment.embed) {
							videoUrl = attachment.container.view_url + 'videos/m' + attachment.id_media + '_' + attachment.filename;
						} else {
							if (attachment.embed.indexOf('yt|') !== -1) {
								var YT_VideoSource = attachment.embed.split('yt|')[1];
								videoUrl = 'http://youtube.com/' + YT_VideoSource;
							} else if (attachment.embed.indexOf('fb|') !== -1) {
								var embed_url = angular.element(attachment.embed_url);
								videoUrl = embed_url.attr('src');
							}
						}

						vm.dataFotorama.push({
							imageUrl: attachment.embed_thumb,
							thumb: attachment.embed_thumb,
							full: attachment.embed_thumb, // Separate image for the fullscreen mode.
							video: videoUrl, // Youtube, Vimeo or custom iframe URL
							id: 'one', // Custom anchor is used with the hash:true option.
							caption: 'The first caption',
							html: '<div>123</div>',
							// html: $('selector'), // ...or '<div>123</div>'. Custom HTML inside the frame.
							fit: 'cover', // Override the global fit option.
							any: 'Any data relative to the frame you want to store',
							selected: selected
						})
					}
				}
				// }else{
				// 	var cropstatus = _.find( Images.cropstatus, {'id_cropformats': sessionService.getMediaThumbnailCropformatId()});
				// 	if(MediaFull){
				// 		var cropstatus = _.find( Images.cropstatus, {'id_cropformats': sessionService.getMediaFullCropformatId()});
				// 		var urlImage = cropstatus.container.view_url + cropstatus.fileName;
				// 	}else{
				//       				var urlImage = cropstatus.container.view_url + 'original/m' + Images.id_media + '_' + Images.filename;
				//       			}
				// 	vm.dataFotorama.push({
				// 					 imageUrl: urlImage,
				// 					 thumb: urlImage,
				// 					 dataCaption: '#' + Images.id_media + ' | ' + Images.filename,
				// 					 html: '<div>123</div>',
				// 					 selected: selected
				// 				 })
				// }
			} else {

				for (var i = 0; i < Images.length; i++) {
					
					var selected = (Images[i].id_cropformats === ImageSelected.id_cropformats && Images[i].container.id_container === ImageSelected.container.id_container) ? true : false;


					if (Images[i].container.use_grid === 1) {
						var urlImage = Images[i].container.view_url + Images[i].grid + '/' + Images[i].fileName;
					} else {
						var urlImage = Images[i].container.view_url + Images[i].fileName;
					}
					vm.dataFotorama.push({
						imageUrl: urlImage,
						thumb: urlImage,
						dataCaption: 'aa#' + Images[i].id_cropformats + ' | ' + urlImage,
						html: '<div>123</div>',
						selected: selected
					})
				}
			}

			// $fotoramaDiv.data({
			// 	data: vm.dataFotorama
			// });

		}

		function changeView(view) {
			if (vm.views[view]) {
				vm.loadingView = true;
				vm.showSearchAndPaginator = false;
				vm.defaultView = view;
				vm.currentView = view;
			}
		}


		function edit() {
			var $fotoramaDiv = angular.element("#fotorama1");
		}

	}
})();

(function ()
{
    'use strict';

    angular
        .module('app.calendar', [
            'ui.calendar'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msUtilProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.calendar', {
            url      : '/calendar',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/calendar/calendar.html',
                    controller : 'CalendarController as vm'
                }
            },
            resolve: {
                Contacts: function (msApi)
                {
                    return msApi.resolve('contacts.contactsPax@get');
                },
                ContactsCrew: function (msApi)
                {
                    return msApi.resolve('contacts.contactsCrew@get');
                }
            },
            bodyClass: 'calendar'
        });

        msApiProvider.register('contacts.contactsPax', ['app/data/contacts/contacts_pax.json']);
        msApiProvider.register('contacts.contactsCrew', ['app/data/contacts/contacts_crew.json']);

        // Translation
        var base = 'app/main/apps/calendar';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }
        // Navigation
        // msNavigationServiceProvider.saveItem('apps.calendar', {
        //     title : 'Flight Calendar',
        //     icon  : 'icon-calendar-today',
        //     state : 'app.calendar',
        //     weight: 2
        // });
    }
})();

(function ()
{
    'use strict';

    angular.module('app.calendar')
        .controller('EventFormFTDialogController', EventFormFTDialogController);

    /** @ngInject */
    function EventFormFTDialogController($mdDialog, dialogData, Contacts, ContactsCrew, msUtils)
    {
        var vm = this;

        // Data
        vm.contacts = Contacts.data;
        vm.contactsCrew = ContactsCrew.data;
        vm.dialogData = dialogData;
        vm.notifications = ['15 minutes before', '30 minutes before', '1 hour before'];
        vm.selectedItem;
        vm.selectedItemSeat;
        vm.calendarEvent = {
            id   : 1,
            title: 'All Day Event'
        }

        vm.selectedContacts = [];


        // Methods
        vm.saveEvent = saveEvent;
        vm.closeDialog = closeDialog;
        vm.getSelectedText = getSelectedText;
        vm.getSelectedTextSeat = getSelectedTextSeat;
        vm.toggleSelectContact = toggleSelectContact;
        vm.exists = msUtils.exists;


        init();

        //////////

        /**
         * Initialize
         */
        function init()
        {
          console.log(Contacts)
          console.log(vm.contacts)

            vm.dialogTitle = (vm.dialogData.type === 'add' ? 'Add Event' : 'Edit Event');

            // Edit
            if ( vm.dialogData.calendarEvent )
            {
                // Clone the calendarEvent object before doing anything
                // to make sure we are not going to brake the Full Calendar
                vm.calendarEvent = angular.copy(vm.dialogData.calendarEvent);

                // Convert moment.js dates to javascript date object
                if ( moment.isMoment(vm.calendarEvent.start) )
                {
                    vm.calendarEvent.start = vm.calendarEvent.start.toDate();
                }

                if ( moment.isMoment(vm.calendarEvent.end) )
                {
                    vm.calendarEvent.end = vm.calendarEvent.end.toDate();
                }
            }
            // Add
            else
            {
                // Convert moment.js dates to javascript date object
                if ( moment.isMoment(vm.dialogData.start) )
                {
                    vm.dialogData.start = vm.dialogData.start.toDate();
                }

                if ( moment.isMoment(vm.dialogData.end) )
                {
                    vm.dialogData.end = vm.dialogData.end.toDate();
                }

                vm.calendarEvent = {
                    start        : vm.dialogData.start,
                    end          : vm.dialogData.end,
                    notifications: []
                };
            }
        }


        function getSelectedText() {
                if (vm.selectedItem !== undefined) {
                  return vm.selectedItem;
                } else {
                  return "Please select";
                }
              };

        function getSelectedTextSeat() {
                if (vm.selectedItemSeat !== undefined) {
                  return vm.selectedItemSeat;
                } else {
                  return "Please select";
                }
              };

        function saveEvent()
        {
            var response = {
                type         : vm.dialogData.type,
                calendarEvent: vm.calendarEvent
            };

            $mdDialog.hide(response);
        }

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }


        /**
         * Toggle selected status of the contact
         *
         * @param contact
         * @param event
         */
        function toggleSelectContact(contact, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            if ( vm.selectedContacts.indexOf(contact) > -1 )
            {
                vm.selectedContacts.splice(vm.selectedContacts.indexOf(contact), 1);
            }
            else
            {
                vm.selectedContacts.push(contact);
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.calendar')
        .controller('EventFormDialogController', EventFormDialogController);

    /** @ngInject */
    function EventFormDialogController($mdDialog, dialogData)
    {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.notifications = ['15 minutes before', '30 minutes before', '1 hour before'];

        // Methods
        vm.saveEvent = saveEvent;
        vm.closeDialog = closeDialog;

        init();

        //////////

        /**
         * Initialize
         */
        function init()
        {
            vm.dialogTitle = (vm.dialogData.type === 'add' ? 'Add Event' : 'Edit Event');

            // Edit
            if ( vm.dialogData.calendarEvent )
            {
                // Clone the calendarEvent object before doing anything
                // to make sure we are not going to brake the Full Calendar
                vm.calendarEvent = angular.copy(vm.dialogData.calendarEvent);

                // Convert moment.js dates to javascript date object
                if ( moment.isMoment(vm.calendarEvent.start) )
                {
                    vm.calendarEvent.start = vm.calendarEvent.start.toDate();
                }

                if ( moment.isMoment(vm.calendarEvent.end) )
                {
                    vm.calendarEvent.end = vm.calendarEvent.end.toDate();
                }
            }
            // Add
            else
            {
                // Convert moment.js dates to javascript date object
                if ( moment.isMoment(vm.dialogData.start) )
                {
                    vm.dialogData.start = vm.dialogData.start.toDate();
                }

                if ( moment.isMoment(vm.dialogData.end) )
                {
                    vm.dialogData.end = vm.dialogData.end.toDate();
                }

                vm.calendarEvent = {
                    start        : vm.dialogData.start,
                    end          : vm.dialogData.end,
                    notifications: []
                };
            }
        }

        function saveEvent()
        {
            var response = {
                type         : vm.dialogData.type,
                calendarEvent: vm.calendarEvent
            };

            $mdDialog.hide(response);
        }

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.calendar')
        .controller('EventDetailFTDialogController', EventDetailFTDialogController);

    /** @ngInject */
    function EventDetailFTDialogController($mdDialog, calendarEvent, showEventFormDialog, event)
    {
        var vm = this;

        // Data
        vm.calendarEvent = calendarEvent;

        // Methods
        vm.editEvent = editEvent;
        vm.closeDialog = closeDialog;

        //////////

        function closeDialog()
        {
            $mdDialog.hide();
        }

        function editEvent(calendarEvent)
        {
            showEventFormDialog('edit', calendarEvent, false, false, event);
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.calendar')
        .controller('EventDetailDialogController', EventDetailDialogController);

    /** @ngInject */
    function EventDetailDialogController($mdDialog, calendarEvent, showEventFormDialog, event)
    {
        var vm = this;

        // Data
        vm.calendarEvent = calendarEvent;

        // Methods
        vm.editEvent = editEvent;
        vm.closeDialog = closeDialog;

        //////////

        function closeDialog()
        {
            $mdDialog.hide();
        }

        function editEvent(calendarEvent)
        {
            showEventFormDialog('edit', calendarEvent, false, false, event);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('MediaClientsController', MediaClientsController);

    /** @ngInject */
    function MediaClientsController($mdDialog,$stateParams, $document, mediaService, owner, requestContext, $anchorScroll, $timeout, $scope, $sce, Upload, multipleSelection, msUtils, COMMON, isTiny, $log) {
        var vm = this;

        // Data
        vm.owner = owner;
        $scope.owner = $stateParams.owner;

        vm.defaultPage = 1;
        vm.defaultPerPage = 50;
        vm.PerPage = 50;
        vm.searchStringFilter = '';
        vm.searchQuery = '';
        vm.modelSearch = '';
        vm.pagination_search = pagination_search;

        vm.isTiny = isTiny;

        vm.views = {
            1: 'app/main/apps/clients/dialogs/media/views/photos-view.html',
            2: 'app/main/apps/clients/dialogs/media/views/videos-view.html',
            3: 'app/main/apps/clients/dialogs/media/views/files-view.html',
            4: 'app/main/apps/clients/dialogs/media/views/audios-view.html',
            upload: 'app/main/apps/clients/dialogs/media/views/upload-view.html',
            import: 'app/main/apps/clients/dialogs/media/views/import-view.html',
        };
        vm.defaultView = 'upload';
        vm.currentView = 'upload';

        vm.viewsTiny = {
            1: 'app/main/apps/clients/dialogs/media/views/tiny-attached.html',
            properties: 'app/main/apps/clients/dialogs/media/views/tiny-properties.html',
            upload: 'app/main/apps/clients/dialogs/media/views/upload-view.html',
        };
        vm.defaultViewTiny = '1';
        vm.currentViewTiny = '1';

        vm.firstLoad = true;
        vm.media_type = '1';
        vm.showSearchAndPaginator = true;
        vm.import_field = '';
        vm.import_disabled = '';
        vm.importedFiles = [];
        vm.importPreview = false;
        vm.imported = false;
        vm.importing = false;
        vm.selectedImages = [];
        vm.files = [];
        vm.tinyProperties = {
            mediaType: '',
            mediaSort: '',
            mediaData: {},
            align: '',
            size: ''
        };
        vm.tinyOptions = {
            size: [
                { value: 25, text: '25%' },
                { value: 50, text: '50%' },
                { value: 75, text: '75%' },
                { value: 100, text: '100%' }
            ],
            align: [
                { value: 'left', text: 'left' },
                { value: 'center', text: 'center' },
                { value: 'right', text: 'right' }
            ]
        }

        // If replying
        // if (angular.isDefined(selectedMail)) {
        // 	vm.form.to = selectedMail.from.email;
        // 	vm.form.subject = 'RE: ' + selectedMail.subject;
        // 	vm.form.message = '<blockquote>' + selectedMail.message + '</blockquote>';
        // }

        // Methods
        vm.closeDialog = closeDialog;
        vm.changeView = changeView;
        vm.changeViewTiny = changeViewTiny;

        vm.nextPage = nextPage;
        vm.prevPage = prevPage;
        vm.morePages = morePages;
        vm.firstPage = firstPage;
        vm.upload = upload;
        vm.attachMedia = attachMedia;
        vm.attachMediaTiny = attachMediaTiny;
        vm.selectMediaTiny = selectMediaTiny;
        vm.selectedMediaTiny = '';
        vm.search = search;

        vm.exists = msUtils.exists;
        vm.alreadySelectedbyZone = alreadySelectedbyZone;
        vm.existInArray = msUtils.existInArray;
        vm.toggleSelectedImages = toggleSelectedImages;


        //////////

        if (!isTiny) {
            init();
        } else {
            vm.section = section;
            initTiny();
        }
        /**
         * Initialize
         */
        function init() {

            vm.loading = true;
        }

        /**
         * Initialize Tinymce
         */
        function initTiny() {
            vm.currentViewTiny = vm.defaultViewTiny;
            vm.showSearchAndPaginator = false;
            vm.loading = true;
            for (var i = 0; i < vm.currentThread.length; i++) {
                if (vm.mediazone) {
                    if (vm.currentThread[i].id_zone == 1) {
                        vm.selectedImages.push(vm.currentThread[i]);
                    }
                } else {
                    vm.selectedImages.push(vm.currentThread[i]);
                }
            }
            if (vm.section.mediaSort) {
                var currentSort = 0;
                var currentItem = '';
                for (var i = 0; i < vm.currentThread.length; i++) {
                    if (vm.mediazone) {
                        if (vm.currentThread[i]['id_zone'] == 1 && (vm.currentThread[i]['media_type'] == vm.section.mediaType)) {
                            currentSort++;
                            if (currentSort = vm.section.mediaSort) {
                                currentItem = vm.currentThread[i];
                            }
                        }
                    } else {
                        if (vm.currentThread[i]['media_type'] == vm.section.mediaType) {
                            currentSort++;
                            if (currentSort = vm.section.mediaSort) {
                                currentItem = vm.currentThread[i];
                            }
                        }

                    }
                }

                vm.selectedMediaTiny = currentItem;
                vm.tinyProperties.mediaSort = vm.section.mediaSort;
                vm.tinyProperties.mediaType = currentItem.media_type;
                vm.tinyProperties.align = vm.section.mediaAlign;
                vm.tinyProperties.size = vm.section.mediaSize;
                vm.changeViewTiny('properties');


            }
            vm.loading = false;

        }

        function pagination_search(searchString) {
            var options = {
                section: section,
                media_type: vm.media_type,
                page: vm.defaultPage,
                perPage: vm.defaultPerPage,
                searchString: searchString
            };
        }


        function search(options) {
            // console.log(options, vm.searchStringFilter);
            /*

			vm.loading 		= true;
			vm.items		=[];
			// Scroll to the top Dialog
            scrollToTopOfDialog();

			mediaService.get({
				siteID: siteID,
				page: options.page,
				paginate: options.perPage,
				media_type: options.media_type,
                withCropStatus: true,
                sortField: 'date_uploaded',
                searchStringFilter: options.searchString,

			})
				.then(function (response) {
					vm.totalItems = response.total;
					vm.pagination_totalItems = response.total;
					vm.from = response.from;
					vm.pagination_from = response.from;
					vm.to = response.to;
					vm.pagination_to = response.to;
					vm.currentPage = response.current_page;
					vm.lastPage = response.last_page;
					vm.maxSize = 500;
					vm.bigTotalItems = 175;

					vm.loading = false;

                    vm.items = angular.copy(response.data);

                    $('.md-button')
                        .removeClass('active');
                    $('[type=' + options.media_type + ']')
						.addClass('active');

				});




			vm.firstLoad = false;
*/
        }

        function closeDialog() {
            $mdDialog.hide(vm.currentThread);
        }

        function changeView(view) {

            //console.log(view)
            if (vm.views[view]) {
                vm.items = [];
                vm.loadingView = true;
                vm.showSearchAndPaginator = false;
                vm.defaultView = view;
                vm.currentView = view;


                vm.media_type = view;

                var options = {
                    page: 1,
                    perPage: vm.PerPage,
                    media_type: view,

                };
                if (view == 1 || view == 2 || view == 3 || view == 4) {
                    vm.showSearchAndPaginator = true;
                }

            }

        }

        function changeViewTiny(view) {


            if (vm.viewsTiny[view]) {
                vm.items = [];
                vm.loadingView = true;
                vm.showSearchAndPaginator = false;
                vm.defaultViewTiny = view;
                vm.currentViewTiny = view;
            }

        }

        $scope.file_changed = function (element) {

            $scope.$apply(function (scope) {
                var photofile = element.files[0];
                console.log(photofile);
                $mdDialog.hide(photofile);
                //vm.upload(photofile);
                var reader = new FileReader();
                reader.onload = function (e) {
                    // handle onload
                };
                reader.readAsDataURL(photofile);
                $scope.image = photofile;
            });
        };

        $scope.$watch('vm.files', function () {
            console.debug("WATCH!!:::!:!:!:!: ")
            $scope.formUpload = false;
            if (vm.files != null) {
                // make files array for not multiple to be able to be used in ng-repeat in the ui
                if (!angular.isArray(vm.files)) {
                    $timeout(function () {
                        $scope.files = vm.files = [vm.files];
                    });
                    return;
                }
                for (var i = 0; i < vm.files.length; i++) {
                    $scope.errorMsg = null;
                    (function (f) {
                        //vm.upload(f, true);
                        $mdDialog.hide(f);
                    })(vm.files[i]);
                }
            }
        });

        $scope.$watch('vm.import_field', function () {
            vm.importConfirm(false);
        });


        $scope.log = '';

        function upload(file) {
            if (!file.$error) {
                var token = undefined;
                console.debug("UPLOAD______****", file)
                mediaService.getS3UploadPreSignedUrl({
                    owner: $scope.owner,
                    uploadKey: 'company_logo',
                    fileName: file.name,
                    rowId: 1
                })
                    .then(function (resp) {
                        token = resp.token;
                        file.id_media = resp.id_media;
                        file.upload = Upload.http({
                            url: resp.url,
                            skipAuthorization: true,
                            method: 'PUT',
                            headers: {
                                "Content-Type": file.type != '' ? file.type : 'application/octet-stream' 
                            },
                            data: file
                        });

                        file.upload.then(function (response) {
                            file.result = response.data;
                            $timeout(function () {
                                $scope.log = 'file: ' +
                                    file.name +
                                    ', Response: ' + JSON.stringify(response.data) +
                                    ', ID: ' + file.id_media +
                                    '\n' + $scope.log;
                            });
                            console.debug("SEND_TO_CROP______****", file)
                            mediaService.finishedUploadingFileToCdn({
                                owner: vm.owner,
                                idMedia: file.id_media,
                                token: token
                            })
                            $mdDialog.hide(vm.files[0]);


                        }, function (response) {
                            if (response.status > 0)
                                $scope.errorMsg = response.status + ': ' + response.data;
                        });

                        file.upload.progress(function (evt) {
                            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                        });

                    })
            }
        };

        vm.importConfirm = function (confirm) {
            vm.import_disabled = false;
            vm.imported = false;
            if (!confirm) {
                vm.importPreview = false;
            }
            if (vm.import_field.length > 10) {
                vm.importing = true;
                vm.import_disabled = true;

                $timeout(function () {
                    var pastedUrl = vm.import_field;
                    mediaService.importFromUrl({
                        siteID: siteID,
                        url: pastedUrl,
                        execute: confirm
                    })
                        .then(function (response) {
                            vm.importing = false;
                            response.embedCodeSafe = $sce.trustAsHtml(response.metadata.embedCode);
                            if (response.id_media) {
                                vm.imported = true;
                                vm.importPreview = false;
                                mediaService.get({
                                    siteID: siteID,
                                    withCropStatus: true,
                                    idMedia: response.id_media
                                })
                                    .then(function (response) {
                                        if (response.total == 1) {
                                            var photo = response.data[0];
                                            vm.importedFiles.push(photo);
                                            toggleSelectedImages(photo);
                                        }
                                    });

                            } else {
                                vm.importPreview = response;
                            }
                            vm.import_disabled = false;
                        });
                })
            }
        }

        function nextPage() {

            var options = {
                page: vm.currentPage + 1,
                perPage: vm.PerPage,
                media_type: vm.media_type
            };

        }

        function prevPage() {
            var options = {
                page: vm.currentPage - 1,
                perPage: vm.PerPage,
                media_type: vm.media_type,
                searchString: vm.modelSearch
            };
            
        }

        function morePages() {
            if (vm.currentPage <= vm.lastPage) return true;
            return false;
        }

        function firstPage() {
            if (vm.currentPage == 1) return true;
            return false;
        }

        function alreadySelectedbyZone(array, item) {
            var ret = false;
            for (var i = 0, len = array.length; i < len; i++) {
                if (vm.mediazone) {
                    if (array[i]['id_media'] === item.id_media && array[i]['id_zone'] === mediazone.id_zone) {
                        ret = true;
                    }
                } else {
                    if (array[i]['id_media'] === item.id_media) {
                        ret = true;
                    }

                }
            }

            return ret;
        }


        function toogleSelectedbyZone(item) {
            if (!multipleSelection) {
                vm.selectedImages = [];
            }
            for (var i = 0, len = vm.selectedImages.length; i < len; i++) {
                if (vm.selectedImages[i]['id_media'] === item.id_media && vm.selectedImages[i]['id_zone'] === mediazone.id_zone) {
                    vm.selectedImages.splice(i, 1);
                    return;
                }
            }

            vm.selectedImages.push(item);
            return;
        }

        function selectMediaTiny(item) {
            var currentSort = 0;
            var mediaSort = 0;
            for (var i = 0; i < vm.currentThread.length; i++) {
                if (vm.mediazone) {
                    //            		console.log(vm.currentThread[i]['id_zone']);
                    if (vm.currentThread[i]['id_zone'] == 1 && (vm.currentThread[i]['media_type'] == item.media_type)) {
                        currentSort++;
                        if (item.id_media == vm.currentThread[i]['id_media']) {
                            mediaSort = currentSort;
                        }
                    }
                } else {
                    currentSort++;
                    if (item.id_media == vm.currentThread[i]['id_media']) {
                        mediaSort = currentSort;
                    }
                }
            }
            vm.selectedMediaTiny = item;
            vm.tinyProperties.mediaSort = mediaSort;
            vm.tinyProperties.mediaType = item.media_type;
            vm.changeViewTiny('properties');

        }

        function attachMedia() {
            if ($scope.image) {
                $mdDialog.hide($scope.image);
            } else {
                $mdDialog.hide();
            }
        }

        function attachMediaTiny() {
            $mdDialog.hide(vm.tinyProperties);
        }

        /**
         * Toggle selected status of the contact
         *
         * @param contact
         * @param event
         */
        function toggleSelectedImages(photo, event) {
            if (event) {
                event.stopPropagation();
            }


            //         else{
            if (vm.mediazone) {
                photo.id_zone = vm.mediazone.id_zone;
                photo.zone_name = vm.mediazone.zone_name;
            } else {
                photo.id_zone = null;
                photo.zone_name = null;
            }

            toogleSelectedbyZone(photo);

        }

        /**
         * Scroll Media Dialog Content to the top
         * @param speed
         */
        function scrollToTopOfDialog() {     
            $timeout(function () {
                var dialogContent = $document.find('md-dialog-content').filter(function () {
                    return angular.element(this).hasClass('mediadialog-content');
                });
                if (!angular.isUndefined(dialogContent[0])) {
                    dialogContent.animate({
                        scrollTop: dialogContent[0].scrollHeight  
                    }, 1);
                }
            }, 1000);

        }
    }
})();


(function () {
    'use strict';

    angular
        .module('app.clients')
        .constant('_', window._)
        .controller('NewClientDialogController', NewClientDialogController);

    /** @ngInject */
    function NewClientDialogController($scope, $mdDialog, sectors, regions, $stateParams, $document, documentsService, staffService,
        sessionService, clientsService, regionsLiterals, company, main_branch, $translate) {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.saveDialog = saveDialog;
        vm.getRegionLiteral = getRegionLiteral;
        vm.sectors = sectors;
        vm.regions = regions;
        vm.regionsLiterals = regionsLiterals;
        vm.mediaDialogSingle = mediaDialogSingle;
        vm.deleteLogotype = deleteLogotype;
        $scope.owner = $stateParams.owner;
        vm.company = company ? company : {};

        vm.main_branch = main_branch ? main_branch : {}

        if (vm.company.id) {
            staffService.getMainBranch({ owner: $scope.owner, id_company: vm.company.id }).then(res => {
                vm.main_branch = res.data[0];
            })
        }
        if (vm.company.logo && vm.company.logo.length > 0) {
            var options = {
                owner: $scope.owner
            };
            clientsService.getStoragePrefix(options).then(function (res) {
                $scope.imageUrl = res.prefix + vm.company.logo[0].url;
                vm.logoIsLoaded = true;
            })
        }
        if (!vm.company.region_id) {
            vm.company.region_id = sessionService.user.region_id;
        }
        function saveDialog() {
            if (!vm.main_branch.name) {
                vm.main_branch.name = vm.company.name;
            }
            $mdDialog.hide({ company: vm.company, branch: vm.main_branch, image: $scope.image, updateLogotype: vm.updateLogotype });
        }
        function mediaDialogSingle(ev, field) {
            $mdDialog.show({
                controller: 'MediaClientsController',
                controllerAs: 'vm',
                locals: {
                    owner: $scope.owner,
                    multipleSelection: true,
                    isTiny: false
                },
                templateUrl: 'app/main/apps/clients/dialogs/media/media-clients.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                multiple: true
            }).then(function (image) {
                if (image) {
                    vm.updateLogotype = true;
                    $scope.image = image;
                }
            });
        }
        function deleteLogotype() {
            if (vm.company.logo && vm.company.logo.length > 0) {
                for (var i = 0; i < vm.company.logo.length; i++) {
                    const itemLogo = vm.company.logo[i];
                    var options = {
                        owner: $scope.owner,
                        id: itemLogo.id
                    }
                    documentsService.deleteDocument(options).then(function () {
                        vm.company.logo = null;
                    })
                }
            }
            $scope.image = undefined;
            $scope.imageUrl = undefined;
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function getRegionLiteral(literalKey) {
            if (!angular.isUndefined(vm.company) && vm.company.region_id) {
                const literalsObject = vm.regionsLiterals.find(x => x.region_id === vm.company.region_id)
                return literalsObject.literals[literalKey];
            } else {
                return 'CIF/NIF';
            }
        }

    }
})();


(function () {
    'use strict';

    angular
        .module('app.clients')
        .constant('_', window._)
        .controller('EditBranchDialog', EditBranchDialog);

    /** @ngInject */
    function EditBranchDialog($scope, $mdDialog, $translate, region_id, clientsService, tinyMceService, branch, $mdToast) {
        var vm = this;
        vm.region_id = region_id;
        vm.branch = angular.copy(branch);
        vm.tinymceOptions = tinyMceService.getOptions($scope);
        vm.tinymceOptions.height = 100;
        vm.saveDialog = saveDialog;
        vm.closeDialog = closeDialog;
        vm.getRegionLiteral = getRegionLiteral;
        clientsService.getFileRegions().then(function (res) {
            vm.regionsLiterals = res;
        })
        function saveDialog() {

            $mdDialog.hide(vm.branch);

        }
        function getRegionLiteral(literalKey) {
            if (vm.region_id && vm.regionsLiterals) {
                const literalsObject = vm.regionsLiterals.find(x => x.region_id === vm.region_id)
                return literalsObject.literals[literalKey];
            } else {
                return '';
            }
        }



        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();
(function () {
	'use strict';

	angular
		.module('app.clients')
		.controller('ImageDialogClientsController', ImageDialogClientsController);

	/** @ngInject */
	function ImageDialogClientsController($mdDialog, sessionService, Images, ImageSelected, $document, cropFormats, MediaFull)
	{
		var vm = this;

		vm.views = {
			fotorama: 'app/main/apps/clients/dialogs/image/views/fotorama-view.html',
			editmedia: 'app/main/apps/clients/dialogs/image/views/edit-media-view.html',
		};
		vm.defaultView = 'fotorama';
		vm.currentView = 'fotorama';

		// Data
		vm.title = 'View Media';
		vm.images = [];
		vm.dataImages = [];

		// Methods
		vm.closeDialog = closeDialog;
		vm.changeView = changeView;
		vm.edit = edit;

		// //////////

		/**
		 * Close dialog
		 */
		function closeDialog()
		{
			/*var $fotoramaDiv = $('#fotorama').fotorama();
			var fotorama = $fotoramaDiv.data('fotorama');
			fotorama.destroy();*/
			$mdDialog.hide();
		}

		init();

		function init()
		{

			vm.dataFotorama = [];
			var fotoramaDiv = angular.element(".testingelement");

			var fit = (cropFormats) ? 'scaledown' : 'contain';
			vm.fotoramaoptions = {
				width: '100%',
				height: '80%',
				captions: true,
				loop: true,
				keyboard: true,
				allowfullscreen: true,
				nav: 'thumbs',
				ratio: 16 / 9,
				fit: fit,
			};

			if (!cropFormats) {
				if (!_.isArray(Images)) {
					var ImagesArray = [];
					ImagesArray.push(Images);
					Images = ImagesArray;
				}


				for (var i = 0; i < Images.length; i++) {

					var attachment = Images[i];
					var imagesCrops = [];

					for (var iCrop = 0; iCrop < Images[i].cropstatus.length; iCrop++) {
						var imageCrop = Images[i].cropstatus[iCrop];
						imagesCrops.push(Images[i].cropstatus[iCrop]);
					}

					if (ImageSelected) {
						var selected = (Images[i].id_media === ImageSelected.id_media) ? true : false;
					} else {
						var selected = false;
					}

					if (Images[i].media_type !== 1) {
						// continue;
					}

					// .container.view_url}}{{image.cropstatus[0].fileName

					if (attachment.media_type == 1) {

						if (MediaFull) {
							var cropstatus = _.find(Images[i].cropstatus, {
								'id_cropformats': sessionService.getMediaThumbnailCropformatId()
							});

							var cropstatus = _.find(Images[i].cropstatus, {
								'id_cropformats': sessionService.getMediaFullCropformatId()
							});
							var urlImage = cropstatus.container.view_url + cropstatus.fileName;
							vm.dataFotorama.push({
								imageUrl: urlImage,
								thumb: urlImage,
								dataCaption: '#' + attachment.id_media + ' | ' + urlImage,
								html: '<div>123</div>',
								selected: selected
							})
						} else {
							var cropstatus = _.find(attachment.cropstatus, {
								'id_cropformats': sessionService.getMediaFullCropformatId()
							});

							if(!cropstatus){
								var urlImage = attachment.container.view_url + 'original/m' + attachment.id_media + '_' + attachment.filename;
							}else{
								var urlImage = cropstatus.container.view_url + cropstatus.fileName;
							}
								vm.dataFotorama.push({
									imageUrl: urlImage,
									thumb: urlImage,
									dataCaption: '#' + attachment.id_media + ' | ' + urlImage,
									html: '<div>123</div>',
									selected: selected
								})
						}
					}

					if (attachment.media_type == 2) {
						var videoUrl = '';
						if (!attachment.embed) {
							videoUrl = attachment.container.view_url + 'videos/m' + attachment.id_media + '_' + attachment.filename;
						} else {
							if (attachment.embed.indexOf('yt|') !== -1) {
								var YT_VideoSource = attachment.embed.split('yt|')[1];
								videoUrl = 'http://youtube.com/' + YT_VideoSource;
							} else if (attachment.embed.indexOf('fb|') !== -1) {
								var embed_url = angular.element(attachment.embed_url);
								videoUrl = embed_url.attr('src');
							}
						}

						vm.dataFotorama.push({
							imageUrl: attachment.embed_thumb,
							thumb: attachment.embed_thumb,
							full: attachment.embed_thumb, // Separate image for the fullscreen mode.
							video: videoUrl, // Youtube, Vimeo or custom iframe URL
							id: 'one', // Custom anchor is used with the hash:true option.
							caption: 'The first caption',
							html: '<div>123</div>',
							// html: $('selector'), // ...or '<div>123</div>'. Custom HTML inside the frame.
							fit: 'cover', // Override the global fit option.
							any: 'Any data relative to the frame you want to store',
							selected: selected
						})
					}
				}
				// }else{
				// 	var cropstatus = _.find( Images.cropstatus, {'id_cropformats': sessionService.getMediaThumbnailCropformatId()});
				// 	if(MediaFull){
				// 		var cropstatus = _.find( Images.cropstatus, {'id_cropformats': sessionService.getMediaFullCropformatId()});
				// 		var urlImage = cropstatus.container.view_url + cropstatus.fileName;
				// 	}else{
				//       				var urlImage = cropstatus.container.view_url + 'original/m' + Images.id_media + '_' + Images.filename;
				//       			}
				// 	vm.dataFotorama.push({
				// 					 imageUrl: urlImage,
				// 					 thumb: urlImage,
				// 					 dataCaption: '#' + Images.id_media + ' | ' + Images.filename,
				// 					 html: '<div>123</div>',
				// 					 selected: selected
				// 				 })
				// }
			} else {

				for (var i = 0; i < Images.length; i++) {
					
					var selected = (Images[i].id_cropformats === ImageSelected.id_cropformats && Images[i].container.id_container === ImageSelected.container.id_container) ? true : false;


					if (Images[i].container.use_grid === 1) {
						var urlImage = Images[i].container.view_url + Images[i].grid + '/' + Images[i].fileName;
					} else {
						var urlImage = Images[i].container.view_url + Images[i].fileName;
					}
					vm.dataFotorama.push({
						imageUrl: urlImage,
						thumb: urlImage,
						dataCaption: 'aa#' + Images[i].id_cropformats + ' | ' + urlImage,
						html: '<div>123</div>',
						selected: selected
					})
				}
			}

			// $fotoramaDiv.data({
			// 	data: vm.dataFotorama
			// });

		}

		function changeView(view) {
			if (vm.views[view]) {
				vm.loadingView = true;
				vm.showSearchAndPaginator = false;
				vm.defaultView = view;
				vm.currentView = view;
			}
		}


		function edit() {
			var $fotoramaDiv = angular.element("#fotorama1");
		}

	}
})();

(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('DialogFormController', DialogFormController);

    /** @ngInject */
    function DialogFormController($mdDialog, $document, usersService, clientsService, sessionService, owner, type, documentsService, positionsIds, idCompany, $filter, $mdMenu, requestContext, Upload, user_type, title, fields, users, $translate, alreadySelected, branchId, storagePrefix, $anchorScroll, $timeout, $scope, $sce, msUtils, COMMON, isTiny, $log, defaultDivision, defaultJob) {

        var vm = this;
        var originatorEv;
        vm.owner = owner;
        vm.type = type;
        sessionService.getQuota().then(function (quota) {
            vm.quota = quota;
        });

        vm.userLogued = sessionService.getUser();
        vm.fields = fields;
        var foundFiles = _.find(vm.fields, function (field) {
            return field.field == 'files';
        });
        vm.files = (foundFiles && foundFiles.value) ? (Array.isArray(foundFiles.value) ? foundFiles.value : [foundFiles.value]) : [];
        vm.emailOriginal = _.find(vm.fields, function (field) {
            if (field.field == 'email') {
                return true
            }
        }).value;
        vm.openMenu = openMenu;
        vm.user_type = user_type;
        vm.positionsIds = positionsIds;

        vm.alreadySelected = [];
        vm.branchId = branchId;
        vm.storagePrefix = storagePrefix;
        vm.deleteAvatar = deleteAvatar;
        vm.noDivisionJobSelected = true;
        vm.jobPositionId = '';
        vm.divisionId = '';
        vm.alreadySelected = alreadySelected;
        vm.indexDivision = null;
        vm.indexPosition = null;
        vm.translate = function (text) {
            return $translate.instant(text);
        }

        for (var i = 0; i < vm.fields.length; i++) {
            if (vm.fields[i].field == 'division') {
                vm.indexDivision = i;
                break;
            }
        }
        for (var i = 0; i < vm.fields.length; i++) {
            if (vm.fields[i].field == 'position') {
                vm.indexPosition = i;
                break;
            }
        }



        var originatorEv;

        function openMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        }

        function deleteAvatar(file) {
            var options = {
                owner: vm.owner,
                id: file.id
            }
            documentsService.deleteDocument(options).then(function () {
                vm.files = [];
            })
        }

        if (defaultDivision) {
            vm.divisionId = defaultDivision;
        }
        if (defaultJob) {
            vm.jobPositionId = defaultJob;
        }



        // Methods
        vm.closeDialog = closeDialog;
        vm.sendForm = sendForm;
        vm.disabledPosition = disabledPosition;
        vm.showSector = showSector;
        vm.selectUser = selectUser;
        vm.showUserImage = showUserImage;
        vm.showSelectPosition = showSelectPosition;
        vm.selectJobDivision = selectJobDivision;
        vm.unSelectJobDivision = unSelectJobDivision;
        vm.divisionJobSelected = divisionJobSelected;
        vm.showJobDivision = showJobDivision;
        vm.isSendDisabled = isSendDisabled;

        init();

        function init() {
            vm.loading = true;
            if (title === 'branch') {
                vm.title = 'GLOBAL.NEW_BRANCH';
            } else if (title === 'administrator') {
                vm.title = 'GLOBAL.ADMINISTRATOR';
            } else if (title === 'managerLegal') {
                vm.title = 'GLOBAL.LEGAL_MANAGER';
            } else if (title === 'personnel' && defaultJob == "") {
                vm.title = 'GLOBAL.BRANCH_PERSONNEL';
            } else if (title === 'personnel' && defaultJob == 3) {
                vm.title = 'GLOBAL.COMPLIANCE_OFFICER';
            } else if (title === 'personnel' && defaultJob == 4) {
                vm.title = 'GLOBAL.REPORT_COMMITTEE';
            } else if (title === 'personnel' && defaultJob == 5) {
                vm.title = 'GLOBAL.DELEGATE_DATA_PROTECCTION';
            } else if (title === 'personnel' && defaultJob == 2) {
                vm.title = 'GLOBAL.ADMINISTRATOR';
            } else if (title === 'personnel' && defaultJob == 1) {
                vm.title = 'GLOBAL.LEGAL_MANAGER';
            }
            getUsersByCompany(idCompany)
            getUsersAdministrators()
        }


        function getUsersByCompany(idCompany) {
            var options = {
                owner: vm.owner,
                inCompany: idCompany,
                resultsPerPage: 500
            };
            clientsService.getUsers(options).then(function (response) {
                vm.users = response.data;
            })
        }
        function getUsersAdministrators() {
            var options = {
                owner: vm.owner,
                resultsPerPage: 100
            };
            usersService.getUsers(options).then(function (response) {
                vm.usersAll = response.data;
            })
        }


        function closeDialog() {
            $mdDialog.hide();
        }
        function isSendDisabled() {
            for (var i = 0; i < vm.fields.length; i++) {
                const element = vm.fields[i];
                if (element.required && !element.value) {
                    return true;
                }
            }
            return false;
        }

        function checkUploadsAndUpdateUser() {
            var noUpdate = false;
            if (vm.files) {
                angular.forEach(vm.files, function (file) {
                    if (angular.isUndefined(file.progress) || file.progress < 100) {
                        noUpdate = true;
                    }
                })
                if (!noUpdate && !$scope.uploadingFile) {
                    initState()
                    vm.loadingReadPane = false;
                    $rootScope.pagination_resetquery();
                } else {
                    $timeout(function () {
                        vm.checkUploadsAndUpdateUser();
                    }, 1000)
                }
            } else {
                initState()
                vm.loadingReadPane = false;
                $rootScope.pagination_resetquery();

            }
        }

        function sendForm(ev) {
            for (var i = 0; i < vm.fields.length; i++) {
                if (vm.fields[i].field === 'position' && !vm.fields[i].value) {
                    vm.fields[i].value = vm.jobPositionId;
                }
                else if (vm.fields[i].field === 'division' && !vm.fields[i].value) {
                    vm.fields[i].value = vm.divisionId;
                } else if (vm.fields[i].field === 'email' && vm.fields[i].value == '') {
                    delete vm.fields[i].value;
                }
            }
            if (((vm.positionsIds.compliance_officer == vm.jobPositionId
                || vm.positionsIds.compliance_comite == vm.jobPositionId
                || vm.positionsIds.data_protection == vm.jobPositionId)
                && vm.quota.users_registered >= vm.quota.max_allowed_users)
            ) {
                $mdDialog.show({
                    controller: 'UserQuotaDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/dialogs/userQuotaDialog/userQuotaDialog.html',
                    preserveScope: true,
                    autoWrap: true,
                    multiple: true,
                    locals: {
                        user: vm.userLogued,
                        quota: vm.quota,
                        quotaComplaint: null
                    }
                }).then(function (res) {
                    if (res && res.type) {
                        if (res.type == 'upgrade') {
                            console.log("go upgrade screen");
                        } else {
                            createUser(true);
                        }
                    }
                });
            } else {
                createUser();
            }



        }

        function createUser(quotaexceded) {


            var email = _.find(vm.fields, function (field) {
                if (field.field == 'email') {
                    return true
                }
            }).value;

            if (vm.emailOriginal === email) {
                vm.fields.files = vm.files;
                $mdDialog.hide({ fields: vm.fields, quotaexceded: quotaexceded });
                return
            }
            var options = {
                owner: vm.owner,
                searchStringFilter: email
            };
            usersService.getUsersWithTrashed(options).then(function (response) {

                var existedUser = _.find(response.data, function (user) {
                    if (user.email == email && (!vm.userSelected || user.id !== vm.userSelected.id)) {
                        return true;
                    }
                });

                if (!existedUser) {
                    vm.fields.files = vm.files;
                    $mdDialog.hide({ fields: vm.fields, quotaexceded: quotaexceded });
                } else {
                    alert = $mdDialog.alert({
                        title: vm.translate('GLOBAL.ATTENTION'),
                        textContent: vm.translate('GLOBAL.USER_ALREADY_EXISTS'),
                        ok: vm.translate('GLOBAL.CLOSE'),
                    }).multiple(true);

                    $mdDialog
                        .show(alert)
                        .finally(function () {
                            alert = undefined;
                        });
                }
            })





        }

        function disabledPosition(field) {
            var idAdmin;
            var idManagerLegal;
            var idComplaints;
            var idReport;
            for (var i = 0; i < field.options.length; i++) {
                if (field.options[i].field === 'ADMINISTRADOR') {
                    idAdmin = field.options[i].id;
                } else if (field.options[i].field === 'REPRESENTANTE LEGAL') {
                    idManagerLegal = field.options[i].id
                } else if (field.options[i].field === 'Complaints committee') {
                    idComplaints = field.options[i].id
                } else if (field.options[i].field === 'Reports committee') {
                    idReport = field.options[i].id
                }
            }

            if (vm.title === 'managerLegal') {
                field.value = idManagerLegal;
                return true;
            } else if (vm.title === 'administrator') {
                field.value = idAdmin;
                return true;
            } else if (vm.title === 'compliance') {
                field.value = idComplaints;
                return true;
            } else if (vm.title === 'report') {
                field.value = idReport;
                return true;
            }
        }

        function showSector() {
            if (title === 'personnel') {
                return true;
            }
        }

        function selectUser(user) {
            for (var i = 0; i < vm.fields.length; i++) {
                if (vm.fields[i].field === 'first_name') {
                    vm.fields[i].value = user.first_name
                } else if (vm.fields[i].field === 'last_name') {
                    vm.fields[i].value = user.last_name;
                } else if (vm.fields[i].field === 'email') {
                    vm.fields[i].value = user.email;
                } else if (vm.fields[i].field === 'nif') {
                    vm.fields[i].value = user.id_number;
                } else if (vm.fields[i].field === 'position') {
                    vm.fields[i].value = vm.jobPositionId;
                } else if (vm.fields[i].field === 'division') {
                    vm.fields[i].value = vm.divisionId;
                } else if (vm.fields[i].field === 'profile_color') {
                    vm.fields[i].value = user.profile_color;
                } else if (vm.fields[i].field === 'user_type') {
                    vm.fields[i].value = user.user_type;
                }
            }

            vm.fields.push({ field: 'id', value: user.id });
            vm.fields.push({ field: 'files', value: user.files });
            if (vm.quota.users_registered >= vm.quota.max_allowed_users && (user.user_type > 3)) {
                $mdDialog.show({
                    controller: 'UserQuotaDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/dialogs/userQuotaDialog/userQuotaDialog.html',
                    preserveScope: true,
                    autoWrap: true,
                    multiple: true,
                    locals: {
                        user: vm.userLogued,
                        quota: vm.quota,
                        quotaComplaint: null
                    }
                }).then(function (res) {
                    if (res && res.type) {
                        if (res.type == 'upgrade') {
                            console.log("go upgrade screen");
                        } else {
                            $mdDialog.hide({ fields: vm.fields, existUser: true, quotaexceded: vm.quota.users_registered >= vm.quota.max_allowed_users });
                        }
                    }
                });
            } else {
                $mdDialog.hide({ fields: vm.fields, existUser: true, quotaexceded: vm.quota.users_registered >= vm.quota.max_allowed_users });
            }

        }

        $scope.filterAlreadyAdded = function (item) {
            if (vm.fields[vm.indexDivision].value && vm.fields[vm.indexPosition].value) {
                var found = $filter('filter')(vm.alreadySelected, { id: item.id, position: vm.fields[vm.indexPosition].value, division: vm.fields[vm.indexDivision].value });
                return found.length == 0;;
            } else {
                var found = _.find(vm.alreadySelected, function (_item) { return _item.id == item.id });
                return !found;
            }
        };

        function showUserImage(user) {
            return vm.storagePrefix + user.files.url
        }

        function showSelectPosition() {
            if (vm.branchId && vm.noDivisionJobSelected) {
                return true;
            }
            return false;
        }

        function selectJobDivision() {
            vm.noDivisionJobSelected = false;
        }

        function divisionJobSelected() {
            var ret1 = false;
            var ret2 = false;
            for (var i = 0; i < vm.fields.length; i++) {
                if (vm.fields[i].field === 'position' && vm.fields[i].value) {
                    vm.jobPositionId = vm.fields[i].value;
                    ret1 = true;
                }
                if (vm.fields[i].field === 'division' && vm.fields[i].value) {
                    vm.divisionId = vm.fields[i].value;
                    ret2 = true;
                }
            }

            return (!ret1 || !ret2);
        }

        function unSelectJobDivision() {
            vm.noDivisionJobSelected = true;
        }

        function showJobDivision() {
            if (vm.branchId) {
                return true;
            }
            return false;
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.mail')
        .controller('ComposeDialogController', ComposeDialogController);

    /** @ngInject */
    function ComposeDialogController($mdDialog, selectedMail)
    {
        var vm = this;

        // Data
        vm.form = {
            from: 'johndoe@creapond.com'
        };

        vm.hiddenCC = true;
        vm.hiddenBCC = true;

        // If replying
        if ( angular.isDefined(selectedMail) )
        {
            vm.form.to = selectedMail.from.email;
            vm.form.subject = 'RE: ' + selectedMail.subject;
            vm.form.message = '<blockquote>' + selectedMail.message + '</blockquote>';
        }

        // Methods
        vm.closeDialog = closeDialog;

        //////////

        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.blank', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_blank', {
            url  : '/ui/page-layouts/blank',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/blank/blank.html',
                    controller : 'BlankController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.blank')
        .controller('BlankController', BlankController);

    /** @ngInject */
    function BlankController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-500', {
            url      : '/pages/errors/error-500',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-500': {
                    templateUrl: 'app/main/pages/errors/500/error-500.html',
                    controller : 'Error500Controller as vm'
                }
            },
            bodyClass: 'error-500'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/500');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.errors.error-500', {
            title : '500',
            state : 'app.pages_errors_error-500',
            weight: 2
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500')
        .controller('Error500Controller', Error500Controller);

    /** @ngInject */
    function Error500Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-404', {
            url      : '/pages/errors/error-404',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-404': {
                    templateUrl: 'app/main/pages/errors/404/error-404.html',
                    controller : 'Error404Controller as vm'
                }
            },
            bodyClass: 'error-404'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/404');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.errors', {
            title : 'Errors',
            icon  : 'icon-alert',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('pages.errors.error-404', {
            title : '404',
            state : 'app.pages_errors_error-404',
            weight: 1
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404')
        .controller('Error404Controller', Error404Controller);

    /** @ngInject */
    function Error404Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.reset-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_reset-password', {
            url      : '/pages/auth/reset-password',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_reset-password': {
                    templateUrl: 'app/main/pages/auth/reset-password/reset-password.html',
                    controller : 'ResetPasswordController as vm'
                }
            },
            bodyClass: 'reset-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/reset-password');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.reset-password', {
            title : 'Reset Password',
            state : 'app.pages_auth_reset-password',
            weight: 6
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.reset-password')
        .controller('ResetPasswordController', ResetPasswordController);

    /** @ngInject */
    function ResetPasswordController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register-v2', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_register-v2', {
            url      : '/pages/auth/register-v2',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_register-v2': {
                    templateUrl: 'app/main/pages/auth/register-v2/register-v2.html',
                    controller : 'RegisterV2Controller as vm'
                }
            },
            bodyClass: 'register-v2'
        });

        // Translate
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/register-v2');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.register-v2', {
            title : 'Register v2',
            state : 'app.pages_auth_register-v2',
            weight: 4
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register-v2')
        .controller('RegisterV2Controller', RegisterV2Controller);

    /** @ngInject */
    function RegisterV2Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_login', {
            url      : '/pages/auth/login',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_login': {
                    templateUrl: 'app/main/pages/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/login');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth', {
            title : 'Authentication',
            icon  : 'icon-lock',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('pages.auth.login', {
            title : 'Login',
            state : 'app.pages_auth_login',
            weight: 1
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login')
        .controller('LoginV2Controller', LoginV2Controller);

    /** @ngInject */
    function LoginV2Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_register', {
            url      : '/pages/auth/register',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_register': {
                    templateUrl: 'app/main/pages/auth/register/register.html',
                    controller : 'RegisterController as vm'
                }
            },
            bodyClass: 'register'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/register');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.register', {
            title : 'Register',
            state : 'app.pages_auth_register',
            weight: 3
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register')
        .controller('RegisterController', RegisterController);

    /** @ngInject */
    function RegisterController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_forgot-password', {
            url      : '/pages/auth/forgot-password',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_forgot-password': {
                    templateUrl: 'app/main/pages/auth/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'forgot-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/forgot-password');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.forgot-password', {
            title : 'Forgot Password',
            state : 'app.pages_auth_forgot-password',
            weight: 5
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.forgot-password')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.lock', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_lock', {
            url      : '/pages/auth/lock',
            views    : {
                'main@'                      : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_lock': {
                    templateUrl: 'app/main/pages/auth/lock/lock.html',
                    controller : 'LockController as vm'
                }
            },
            bodyClass: 'lock'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/lock');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.lock', {
            title : 'Lock Screen',
            state : 'app.pages_auth_lock',
            weight: 7
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.lock')
        .controller('LockController', LockController);

    /** @ngInject */
    function LockController()
    {
        var vm = this;

        // Data
        vm.form = {
            username: 'Jane Doe'
        };

        // Methods

        //////////
    }
})();
(function () {
    'use strict';

    angular
        .module('app.staffsroi', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider , msUtilProvider, msNavigationServiceProvider) {
        // State


        $stateProvider.state('app.personalsroi', {
            url: '/personalsroi',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/staffsroi/staffsroi.html',
                    controller: 'StaffsroiController as vm'
                }
            },
            bodyClass: 'staff'
        });

        $stateProvider
            .state('app.site_overview.personalsroi', {
                abstract: true,
                url: '/personalsroi',
                onEnter: function ($stateParams) {


                },
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                    section: function ($stateParams) {             
                        return $stateParams.owner
                    },
                },


            })
            .state('app.site_overview.personalsroi.list', {
                url: '/list',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/staffsroi/staffsroi.html',
                        controller: 'StaffsroiController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.personalsroi.complaints', {
                url: '/complaints',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/staffsroi/staffsroi.html',
                        controller: 'StaffsroiController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.personalsroi.list.thread', {
                url: '/list/:id',
                bodyClass: 'staff'
            })
        // Translation
        var base = 'app/main/apps/staffsroi';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.staffsroi')
        .factory("transformsroiStaff", transformsroiStaff);



    /** @ngInject */
    function transformsroiStaff() {

        var service = {
            duplicateStaff: duplicateStaff,
            checkFieldsStaff: checkFieldsStaff
            
        };

        function duplicateStaff(item) {
            var copy = {
                first_name: item.first_name + ' Copy',
                last_name: item.last_name,
                //email: item.email,
                phone: item.phone,
                job_position_id: item.job_position_id,
                id_type: item.id_type,
                id_number: item.id_number
            };
            return copy;
        }

        function checkFieldsStaff(item) {
            if(item.first_name && item.last_name && item.phone && item.email && item.job_position_id)
                return false;
            return true;
        }


        return service;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.stakeholders', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider,
        msUtilProvider, msNavigationServiceProvider, ivhTreeviewOptionsProvider) {


        ivhTreeviewOptionsProvider.set({
            defaultSelectedState: false,
            validate: true,
            expandToDepth: -1,
            twistieCollapsedTpl: '<md-icon md-font-icon="icon-chevron-right"></md-icon>',
            twistieExpandedTpl: '<md-icon md-font-icon="icon-chevron-left"></md-icon>',
            twistieLeafTpl: '<span style="cursor: default;">&#8192;&#8192;</span>'
        });





        // State


        $stateProvider.state('app.stakeholders', {
            url: '/stakeholders',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/stakeholders/stakeholders.html',
                    controller: 'stakeholdersController as vm'
                }
            },
            bodyClass: 'stakeholders'
        });

        $stateProvider
            .state('app.site_overview.stakeholders', {
                abstract: true,
                url: '/stakeholders',
                onEnter: function ($stateParams) {


                },
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                    section: function ($stateParams) {
                        return $stateParams.owner
                    },
                    is_owner: function ($stateParams) {
                        return false
                    },
                },


            })
            .state('app.site_overview.stakeholders.list', {
                url: '/list',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/stakeholders/stakeholders.html',
                        controller: 'stakeholdersController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.stakeholders.complaints', {
                url: '/compliance',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/stakeholders/stakeholders.html',
                        controller: 'stakeholdersController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.stakeholders.list.thread', {
                url: '/list/:id',
                bodyClass: 'stakeholders'
            });
        // Translation
        var base = 'app/main/apps/stakeholders';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.stakeholders')
        .factory("transformStakeholders", transformStakeholders);


    /** @ngInject */
    function transformStakeholders() {

        var colors = ['md-blue-300-bg', 'md-blue-grey-300-bg', 'md-orange-300-bg', 'md-pink-300-bg', 'md-purple-300-bg', 'md-red-300-bg', 'md-yellow-300-bg', 'md-light-blue-300-bg'];
        var service = {
            getValueFromField: getValueFromField,
            getUserType: getUserType,
            companyToDTO: companyToDTO,
            proyectToDTO: proyectToDTO,
            createBranch: createBranch,
            companyToForm: companyToForm,
            branchToForm: branchToForm,
            getIdBranch: getIdBranch,
            branchesToForm: branchesToForm,
            clientToDTO: clientToDTO,
            userToDTO: userToDTO,
            addIdToForm: addIdToForm,
            addFieldToForm: addFieldToForm,
            getIdFromForm: getIdFromForm,
            updateFullName: updateFullName,
            setFullName: setFullName,
            getAnswer: getAnswer
        };

        function getAnswer(questions) {
            var result = [];
            for (var i = 0; i < questions.length; i++) {
                if (questions[i].value === 'yes') {
                    result.push(questions[i].id);
                }
            }
            return result;
        }

        function setFullName(subForm) {
            var name;
            var surnames;
            for (var i = 0; i < subForm.length; i++) {
                if (subForm[i].field === 'name') {
                    var name = subForm[i].value;

                }
                if (subForm[i].field === 'surnames') {
                    var surnames = subForm[i].value;
                }
            }
            var fullName = name + ' ' + surnames;
            subForm.unshift({ field: 'fullName', value: fullName });
        }

        function updateFullName(subForm) {
            var name;
            var surnames;
            for (var i = 0; i < subForm.length; i++) {
                if (subForm[i].field === 'name') {
                    var name = subForm[i].value;
                }
                if (subForm[i].field === 'surnames') {
                    var surnames = subForm[i].value;
                }
            }
            var fullName = name + ' ' + surnames;
            for (var i = 0; i < subForm.length; i++) {
                if (subForm[i].field === 'fullName') {
                    subForm[i].value = fullName;
                }
            }
        }

        function addIdToForm(subForm, id) {
            subForm.push({ field: 'id', value: id });
        }

        function addFieldToForm(subForm, title, val) {
            subForm.push({ field: title, value: val });
        }

        function userToDTO(subForm, type) {
            var userData = {};
            angular.forEach(subForm, function (field) {
                userData[field.field] = field.value;
            })
            if (!userData.profile_color) {
                userData.profile_color = colors[Math.floor(Math.random() * colors.length)]
            }
            return userData;
        }

        function clientToDTO(form, idCompany) {
            return {
                name: form.name,
                company_id: idCompany,
                country_id: 209,
                language_id: 1
            };
        }

        function getIdBranch(branch) {
            for (var i = 0; i < branch.length; i++) {
                if (branch[i].field == 'id') {
                    return branch[i].value;
                }
            }
            return false;
        }

        function branchesToForm(fields, branches, formWizard, arrayBranches) {
            var result = [];
            for (var i = 0; i < branches.length; i++) {
                if (branches[i].is_main) {
                    mainBranchToForm(formWizard, branches[i]);
                }
                else {
                    result.push(branchToForm(fields, branches[i]));
                }
                arrayBranches.push({ id: branches[i].id, name: branches[i].name });
            }
            return result;
        }

        function mainBranchToForm(formWizard, branch) {
            formWizard.main_branch = {};
            formWizard.main_branch.name = branch.name;
            formWizard.main_branch.address1 = branch.address1;
            formWizard.main_branch.email = branch.email;
            formWizard.main_branch.postcode = branch.postcode;
            formWizard.main_branch.state = branch.state;
            formWizard.main_branch.city = branch.city;
            formWizard.main_branch.phone = branch.phone;
            formWizard.main_branch.id = branch.id;
        }


        function branchToForm(fields, branch) {
            var array = [];
            var result = angular.copy(fields);
            for (var i = 0; i < result.length; i++) {
                switch (result[i].field) {
                    case 'name':
                        if (branch.name) {
                            result[i].value = branch.name;
                        }
                        break;
                    case 'email':
                        if (branch.email) {
                            result[i].value = branch.email;
                        }
                        break;
                    case 'phone':
                        if (branch.phone) {
                            result[i].value = parseInt(branch.phone);
                        }
                        break;
                    case 'address':
                        if (branch.address1) {
                            result[i].value = branch.address1;
                        }
                        break;
                    case 'city':
                        if (branch.city) {
                            result[i].value = branch.city;
                        }
                        break;
                    case 'state':
                        if (branch.state) {
                            result[i].value = branch.state;
                        }
                        break;
                    case 'postcode':
                        if (branch.postcode) {
                            result[i].value = parseInt(branch.postcode);
                        }
                        break;
                }
            }
            result.push({ field: 'id', value: branch.id });
            return result;

        }

        function companyToForm(company) {
            return {
                name: company.name,
                description: company.description,
                tax_id_type: company.tax_id_type,
                tax_id_number: company.tax_id_number,
                sector_id: company.sector_id,
                employee_count: company.employee_count,
                gain_loss_model_id: company.gain_loss_model_id,
                turnover_volume: company.turnover_volume,
                extra_data: JSON.parse(company.extra_data)
            }
        }

        function createBranch(subForm, company_id, isMain, region) {
            if (!isMain) {
                isMain = false;
            }
            var item = {
                country_id: 209,
                is_main: isMain,
                company_id: company_id
            };

            item.name = subForm.name;
            item.email = subForm.email;
            item.phone = String(subForm.phone);
            item.address1 = subForm.address1;
            item.state = subForm.state;
            item.city = subForm.city;
            item.region_id = region;
            item.postcode = String(subForm.postcode);
            return item;
        }

        function getIdFromForm(form) {
            return getValueFromField(form, 'id');
        }

        function getValueFromField(form, field) {
            for (var j = 0; j < form.length; j++) {
                if (form[j].field === field) {
                    return form[j].value;
                }
            }
        }

        function getUserType(type) {
            // TODO sacar esto de BBDD 
            if (type === 'administrator') {
                return 1;
            }
            else if (type === 'managerLegal') {
                return 2;
            }
            else if (type === 'compliance') {
                return 3;
            }
            else if (type === 'report') {
                return 4;
            }
        }

        function companyToDTO(form) {
            if (!form.company.extra_data) {
                form.company.extra_data = {};
            }
            return {
                name: form.company.stakeholfer,
                company_id: form.company.company_id,
                input: form.company.input,
                output: form.company.ouput
                //fulfillment_committee_document: form.company.fulfillment_committee_document,
                //complaints_committee_document: form.complaints_committee_document
            };
        } 
        function proyectToDTO(form) {
//            if (!form.company.extra_data) {
//                form.company.extra_data = {};
//            }
//            console.log(form);
//            return;
            if(!form.company.output) {
                form.company.output = 0;
            }
            if(!form.company.input) {
                form.company.input = 0;
            }
           return {
                stakeholder: form.company.stakeholder,
                company_id: form.company.company_id,
                input: form.company.input,
                output: form.company.output,
                comments: form.company.comments,
                description: form.company.description
                //fulfillment_committee_document: form.company.fulfillment_committee_document,
                //complaints_committee_document: form.complaints_committee_document
            };
        }


        return service;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.users', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msUtilProvider, msNavigationServiceProvider) {
        // State


        $stateProvider.state('app.users', {
            url: '/users',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/users/users.html',
                    controller: 'UsersController as vm'
                }
            },
            bodyClass: 'users'
        });

        $stateProvider
            .state('app.site_overview.users', {
                abstract: true,
                url: '/users',
                onEnter: function ($stateParams) {


                },
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                    section: function ($stateParams) {
                        return $stateParams.owner
                    },
                },


            })
            .state('app.site_overview.users.list', {
                url: '',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/users/users.html',
                        controller: 'UsersController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.users.list.thread', {
                url: '/:id',
                bodyClass: 'users'
            })
        // Translation
        var base = 'app/main/apps/users';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.users')
        .factory("transformUsers", transformUsers);



    /** @ngInject */
    function transformUsers() {

        var service = {
            duplicateUser: duplicateUser,
            checkFieldsUser: checkFieldsUser
            
        };

        function duplicateUser(user) {
            var copy = {
                first_name: user.first_name + ' Copy',
                last_name: user.last_name,
                //email: user.email,
                phone: user.phone,
                job_position_id: user.job_position_id,
                id_type: user.id_type,
                id_number: user.id_number
            };
            return copy;
        }

        function checkFieldsUser(user) {
            if(user.first_name && user.last_name && user.phone && user.email && user.job_position_id)
                return false;
            return true;
        }


        return service;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.staff', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider , msUtilProvider, msNavigationServiceProvider) {
        // State


        $stateProvider.state('app.personal', {
            url: '/personal',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/staff/staff.html',
                    controller: 'StaffController as vm'
                }
            },
            bodyClass: 'staff'
        });

        $stateProvider
            .state('app.site_overview.personal', {
                abstract: true,
                url: '/personal',
                onEnter: function ($stateParams) {


                },
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                    section: function ($stateParams) {             
                        return $stateParams.owner
                    },
                },


            })
            .state('app.site_overview.personal.list', {
                url: '/list',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/staff/staff.html',
                        controller: 'StaffController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.personal.complaints', {
                url: '/complaints',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/staff/staff.html',
                        controller: 'StaffController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.personal.list.thread', {
                url: '/list/:id',
                bodyClass: 'staff'
            })
        // Translation
        var base = 'app/main/apps/staff';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.staff')
        .factory("transformStaff", transformStaff);



    /** @ngInject */
    function transformStaff() {

        var service = {
            duplicateStaff: duplicateStaff,
            checkFieldsStaff: checkFieldsStaff
            
        };

        function duplicateStaff(item) {
            var copy = {
                first_name: item.first_name + ' Copy',
                last_name: item.last_name,
                //email: item.email,
                phone: item.phone,
                job_position_id: item.job_position_id,
                id_type: item.id_type,
                id_number: item.id_number
            };
            return copy;
        }

        function checkFieldsStaff(item) {
            if(item.first_name && item.last_name && item.phone && item.email && item.job_position_id)
                return false;
            return true;
        }


        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .factory('CardFilters', CardFiltersService);

    /** @ngInject */
    function CardFiltersService()
    {
        var service = {
            name   : '',
            labels : [],
            members: [],
            clear  : clear,
            isOn   : isOn
        };

        /**
         * Clear
         */
        function clear()
        {
            service.name = '';
            service.labels = [];
            service.members = [];
        }

        /**
         * Is on
         *
         * @returns {boolean}
         */
        function isOn()
        {
            return (service.name === '' && service.labels.length === 0 && service.members.length === 0 ) ? false : true;
        }

        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .factory('DialogService', DialogService);

    /** @ngInject */
    function DialogService($mdDialog, $document)
    {
        var service = {
            openCardDialog: openCardDialog
        };

        //////////

        /**
         * Open card dialog
         *
         * @param ev
         * @param cardId
         */
        function openCardDialog(ev, cardId)
        {
            $mdDialog.show({
                templateUrl        : 'app/main/apps/scrumboard/dialogs/card/card-dialog.html',
                controller         : 'ScrumboardCardDialogController',
                controllerAs       : 'vm',
                parent             : $document.find('#scrumboard'),
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                locals             : {
                    cardId: cardId
                }
            });
        }

        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .factory('BoardService', BoardService);

    /** @ngInject */
    function BoardService($q, msApi)
    {
        var service = {
            data        : {},
            addNewBoard : addNewBoard,
            getBoardData: getBoardData
        };

        /**
         * Get board data from the server
         *
         * @param boardId
         * @returns {*}
         */
        function getBoardData(boardId)
        {
            // Create a new deferred object
            var deferred = $q.defer();

            msApi.request('scrumboard.board@get', {id: boardId},

                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the promise
                    deferred.resolve(response);
                },

                // ERROR
                function (response)
                {
                    // Reject the promise
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        /**
         * Create an empty board object and set it.
         *
         * For the demonstration purposes, we are creating the
         * empty object in the javascript which you wouldn't do
         * it in real life. Rather, you would make an API call
         * to your server to generate an empty object that fills
         * some of the areas for you like an ID, labels, members
         * or the default board settings.
         *
         * Then you would grab the response that comes from
         * the API call and attach it to the service.data object.
         */
        function addNewBoard()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // Here you would make an API call to your server...
            _generateEmptyScrumboardObject().then(
                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the response
                    deferred.resolve(response);
                },
                // ERROR
                function (response)
                {
                    // Reject the response
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        /**
         * Dummy function for generating an empty
         * scrumboard object for demonstration
         * purposes
         *
         * @private
         * returns {$promise}
         */
        function _generateEmptyScrumboardObject()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // Fake id generator
            var id = parseInt(new Date().valueOf(), 16);

            // Prepare an empty scrumboard object
            var emptyObject = {
                data: {
                    name    : 'Untitled Board',
                    uri     : 'untitled-board',
                    id      : id,
                    settings: {
                        color          : '',
                        subscribed     : false,
                        cardCoverImages: true
                    },
                    lists   : [],
                    cards   : [],
                    members : [
                        {
                            id    : '56027c1930450d8bf7b10758',
                            name  : 'Alice Freeman',
                            avatar: 'assets/images/avatars/alice.jpg'
                        },
                        {
                            id    : '26027s1930450d8bf7b10828',
                            name  : 'Danielle Obrien',
                            avatar: 'assets/images/avatars/danielle.jpg'
                        },
                        {
                            id    : '76027g1930450d8bf7b10958',
                            name  : 'James Lewis',
                            avatar: 'assets/images/avatars/james.jpg'
                        },
                        {
                            id    : '36027j1930450d8bf7b10158',
                            name  : 'Vincent Munoz',
                            avatar: 'assets/images/avatars/vincent.jpg'
                        }
                    ],
                    labels  : [
                        {
                            id   : '26022e4129ad3a5sc28b36cd',
                            name : 'High Priority',
                            color: 'red'
                        },
                        {
                            id   : '56027e4119ad3a5dc28b36cd',
                            name : 'Design',
                            color: 'orange'
                        },
                        {
                            id   : '5640635e19ad3a5dc21416b2',
                            name : 'App',
                            color: 'blue'
                        },
                        {
                            id   : '6540635g19ad3s5dc31412b2',
                            name : 'Feature',
                            color: 'green'
                        }
                    ]
                }
            };

            // Resolve the promise
            deferred.resolve(emptyObject);

            return deferred.promise;
        }

        return service;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.reports')
        .factory("transformReports", transformReports);



    /** @ngInject */
    function transformReports() {

        var service = {
            duplicateReport: duplicateReport,
            checkFields: checkFields

        };

        function duplicateReport(report) {
            var copy = {
                title: report.title + ' (1)',
            };
            return copy;
        }

        function checkFields(report) {
            if (report.title)
                return false;
            return true;
        }


        return service;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.questions')
        .factory("transformQuestionsMaster", transformQuestionsMaster);



    /** @ngInject */
    function transformQuestionsMaster() {

        var service = {
            duplicateQuestionMaster: duplicateQuestionMaster,
            checkFields: checkFields
            
        };

        function duplicateQuestionMaster(question) {
            var copy = {
                name: question.name + ' (1)',
            };
            return copy;
        }

        function checkFields(question) {
            if(question.name)
                return false;
            return true;
        }


        return service;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.proyects', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider,
        msUtilProvider, msNavigationServiceProvider, ivhTreeviewOptionsProvider) {


        ivhTreeviewOptionsProvider.set({
            defaultSelectedState: false,
            validate: true,
            expandToDepth: -1,
            twistieCollapsedTpl: '<md-icon md-font-icon="icon-chevron-right"></md-icon>',
            twistieExpandedTpl: '<md-icon md-font-icon="icon-chevron-left"></md-icon>',
            twistieLeafTpl: '<span style="cursor: default;">&#8192;&#8192;</span>'
        });





        // State


        $stateProvider.state('app.proyects', {
            url: '/proyects',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/proyects/proyects.html',
                    controller: 'proyectsController as vm'
                }
            },
            bodyClass: 'proyects'
        });

        $stateProvider
            .state('app.site_overview.proyects', {
                abstract: true,
                url: '/proyects',
                onEnter: function ($stateParams) {


                },
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                    section: function ($stateParams) {
                        return $stateParams.owner
                    },
                    is_owner: function ($stateParams) {
                        return false
                    },
                },


            })
            .state('app.site_overview.proyects.list', {
                url: '/list',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/proyects/proyects.html',
                        controller: 'proyectsController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.proyects.complaints', {
                url: '/compliance',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/proyects/proyects.html',
                        controller: 'proyectsController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.proyects.list.thread', {
                url: '/list/:id',
                bodyClass: 'proyects'
            });
        // Translation
        var base = 'app/main/apps/proyects';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.proyects')
        .factory("transformproyects", transformproyects);


    /** @ngInject */
    function transformproyects() {

        var colors = ['md-blue-300-bg', 'md-blue-grey-300-bg', 'md-orange-300-bg', 'md-pink-300-bg', 'md-purple-300-bg', 'md-red-300-bg', 'md-yellow-300-bg', 'md-light-blue-300-bg'];
        var service = {
            getValueFromField: getValueFromField,
            getUserType: getUserType,
            companyToDTO: companyToDTO,
            createBranch: createBranch,
            companyToForm: companyToForm,
            branchToForm: branchToForm,
            getIdBranch: getIdBranch,
            branchesToForm: branchesToForm,
            clientToDTO: clientToDTO,
            userToDTO: userToDTO,
            addIdToForm: addIdToForm,
            addFieldToForm: addFieldToForm,
            getIdFromForm: getIdFromForm,
            updateFullName: updateFullName,
            setFullName: setFullName,
            getAnswer: getAnswer
        };

        function getAnswer(questions) {
            var result = [];
            for (var i = 0; i < questions.length; i++) {
                if (questions[i].value === 'yes') {
                    result.push(questions[i].id);
                }
            }
            return result;
        }

        function setFullName(subForm) {
            var name;
            var surnames;
            for (var i = 0; i < subForm.length; i++) {
                if (subForm[i].field === 'name') {
                    var name = subForm[i].value;

                }
                if (subForm[i].field === 'surnames') {
                    var surnames = subForm[i].value;
                }
            }
            var fullName = name + ' ' + surnames;
            subForm.unshift({ field: 'fullName', value: fullName });
        }

        function updateFullName(subForm) {
            var name;
            var surnames;
            for (var i = 0; i < subForm.length; i++) {
                if (subForm[i].field === 'name') {
                    var name = subForm[i].value;
                }
                if (subForm[i].field === 'surnames') {
                    var surnames = subForm[i].value;
                }
            }
            var fullName = name + ' ' + surnames;
            for (var i = 0; i < subForm.length; i++) {
                if (subForm[i].field === 'fullName') {
                    subForm[i].value = fullName;
                }
            }
        }

        function addIdToForm(subForm, id) {
            subForm.push({ field: 'id', value: id });
        }

        function addFieldToForm(subForm, title, val) {
            subForm.push({ field: title, value: val });
        }

        function userToDTO(subForm, type) {
            var userData = {};
            angular.forEach(subForm, function (field) {
                userData[field.field] = field.value;
            })
            if (!userData.profile_color) {
                userData.profile_color = colors[Math.floor(Math.random() * colors.length)]
            }
            return userData;
        }

        function clientToDTO(form, idCompany) {
            return {
                name: form.name,
                company_id: idCompany,
                country_id: 209,
                language_id: 1
            };
        }

        function getIdBranch(branch) {
            for (var i = 0; i < branch.length; i++) {
                if (branch[i].field == 'id') {
                    return branch[i].value;
                }
            }
            return false;
        }

        function branchesToForm(fields, branches, formWizard, arrayBranches) {
            var result = [];
            for (var i = 0; i < branches.length; i++) {
                if (branches[i].is_main) {
                    mainBranchToForm(formWizard, branches[i]);
                }
                else {
                    result.push(branchToForm(fields, branches[i]));
                }
                arrayBranches.push({ id: branches[i].id, name: branches[i].name });
            }
            return result;
        }

        function mainBranchToForm(formWizard, branch) {
            formWizard.main_branch = {};
            formWizard.main_branch.name = branch.name;
            formWizard.main_branch.address1 = branch.address1;
            formWizard.main_branch.email = branch.email;
            formWizard.main_branch.postcode = branch.postcode;
            formWizard.main_branch.state = branch.state;
            formWizard.main_branch.city = branch.city;
            formWizard.main_branch.phone = branch.phone;
            formWizard.main_branch.id = branch.id;
        }


        function branchToForm(fields, branch) {
            var array = [];
            var result = angular.copy(fields);
            for (var i = 0; i < result.length; i++) {
                switch (result[i].field) {
                    case 'name':
                        if (branch.name) {
                            result[i].value = branch.name;
                        }
                        break;
                    case 'email':
                        if (branch.email) {
                            result[i].value = branch.email;
                        }
                        break;
                    case 'phone':
                        if (branch.phone) {
                            result[i].value = parseInt(branch.phone);
                        }
                        break;
                    case 'address':
                        if (branch.address1) {
                            result[i].value = branch.address1;
                        }
                        break;
                    case 'city':
                        if (branch.city) {
                            result[i].value = branch.city;
                        }
                        break;
                    case 'state':
                        if (branch.state) {
                            result[i].value = branch.state;
                        }
                        break;
                    case 'postcode':
                        if (branch.postcode) {
                            result[i].value = parseInt(branch.postcode);
                        }
                        break;
                }
            }
            result.push({ field: 'id', value: branch.id });
            return result;

        }

        function companyToForm(company) {
            return {
                name: company.name,
                description: company.description,
                tax_id_type: company.tax_id_type,
                tax_id_number: company.tax_id_number,
                sector_id: company.sector_id,
                employee_count: company.employee_count,
                gain_loss_model_id: company.gain_loss_model_id,
                turnover_volume: company.turnover_volume,
                extra_data: JSON.parse(company.extra_data)
            }
        }

        function createBranch(subForm, company_id, isMain, region) {
            if (!isMain) {
                isMain = false;
            }
            var item = {
                country_id: 209,
                is_main: isMain,
                company_id: company_id
            };

            item.name = subForm.name;
            item.email = subForm.email;
            item.phone = String(subForm.phone);
            item.address1 = subForm.address1;
            item.state = subForm.state;
            item.city = subForm.city;
            item.region_id = region;
            item.postcode = String(subForm.postcode);
            return item;
        }

        function getIdFromForm(form) {
            return getValueFromField(form, 'id');
        }

        function getValueFromField(form, field) {
            for (var j = 0; j < form.length; j++) {
                if (form[j].field === field) {
                    return form[j].value;
                }
            }
        }

        function getUserType(type) {
            // TODO sacar esto de BBDD 
            if (type === 'administrator') {
                return 1;
            }
            else if (type === 'managerLegal') {
                return 2;
            }
            else if (type === 'compliance') {
                return 3;
            }
            else if (type === 'report') {
                return 4;
            }
        }

        function companyToDTO(form) {
            if (!form.company.extra_data) {
                form.company.extra_data = {};
            }
            let arr_interes = Array.from(form.company.type_interest);
            var interes = "";
            for (let i = 0; i < arr_interes.length; i++) {
                if  ((arr_interes[i] >= "0" && arr_interes[i] <= "9") || arr_interes[i] == ".")
                {
                 interes = interes +   arr_interes[i];  
                }
                if  (arr_interes[i] == ",")
                {
                 interes = interes +   ".";  
                }
            }
            if(interes == "")  {
                interes = "0";
            }
            form.company.type_interest  = interes;   
//            console.log(interes);
            return {
                name: form.company.name,
                sector_id: parseInt(form.company.sector_id),
                logo: form.company.logo,
                //gain_loss_model_id: parseInt(form.company.pgModel), TODO BACKEND
                region_id: form.company.region_id ? form.company.region_id : 1,
                employee_count: form.company.employee_count,
                description: form.company.description,
                turnover_volume: parseInt(form.company.turnover_volume),
                turnover_volume_currency_id: 1,
                tax_id_type: form.company.tax_id_type,
                tax_id_number: form.company.tax_id_number,
                entity_name: form.company.entity_name,
                input_year: form.company.input_year,
                money_symbol: form.company.money_symbol,
//                type_interest: form.company.type_interest,
                type_interest: interes,
                extra_data: JSON.stringify(form.company.extra_data)
                //fulfillment_committee_document: form.company.fulfillment_committee_document,
                //complaints_committee_document: form.complaints_committee_document
            };
        }


        return service;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.inputs', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider,
        msUtilProvider, msNavigationServiceProvider, ivhTreeviewOptionsProvider) {


        ivhTreeviewOptionsProvider.set({
            defaultSelectedState: false,
            validate: true,
            expandToDepth: -1,
            twistieCollapsedTpl: '<md-icon md-font-icon="icon-chevron-right"></md-icon>',
            twistieExpandedTpl: '<md-icon md-font-icon="icon-chevron-left"></md-icon>',
            twistieLeafTpl: '<span style="cursor: default;">&#8192;&#8192;</span>'
        });





        // State


        $stateProvider.state('app.inputs', {
            url: '/inputs',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/inputs/inputs.html',
                    controller: 'inputsController as vm'
                }
            },
            bodyClass: 'inputs'
        });

        $stateProvider
            .state('app.site_overview.inputs', {
                abstract: true,
                url: '/inputs',
                onEnter: function ($stateParams) {


                },
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                    section: function ($stateParams) {
                        return $stateParams.owner
                    },
                    is_owner: function ($stateParams) {
                        return false
                    },
                },


            })
            .state('app.site_overview.inputs.list', {
                url: '/list',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/inputs/inputs.html',
                        controller: 'inputsController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.inputs.complaints', {
                url: '/compliance',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/inputs/inputs.html',
                        controller: 'inputsController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.inputs.list.thread', {
                url: '/list/:id',
                bodyClass: 'inputs'
            });
        // Translation
        var base = 'app/main/apps/inputs';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.inputs')
        .factory("transformoutputs", transformoutputs);


    /** @ngInject */
    function transformoutputs() {

        var colors = ['md-blue-300-bg', 'md-blue-grey-300-bg', 'md-orange-300-bg', 'md-pink-300-bg', 'md-purple-300-bg', 'md-red-300-bg', 'md-yellow-300-bg', 'md-light-blue-300-bg'];
        var service = {
            getValueFromField: getValueFromField,
            getUserType: getUserType,
            companyToDTO: companyToDTO,
            outputToDTO: outputToDTO,
            createBranch: createBranch,
            companyToForm: companyToForm,
            branchToForm: branchToForm,
            getIdBranch: getIdBranch,
            branchesToForm: branchesToForm,
            clientToDTO: clientToDTO,
            userToDTO: userToDTO,
            addIdToForm: addIdToForm,
            addFieldToForm: addFieldToForm,
            getIdFromForm: getIdFromForm,
            updateFullName: updateFullName,
            setFullName: setFullName,
            getAnswer: getAnswer
        };

        function getAnswer(questions) {
            var result = [];
            for (var i = 0; i < questions.length; i++) {
                if (questions[i].value === 'yes') {
                    result.push(questions[i].id);
                }
            }
            return result;
        }

        function setFullName(subForm) {
            var name;
            var surnames;
            for (var i = 0; i < subForm.length; i++) {
                if (subForm[i].field === 'name') {
                    var name = subForm[i].value;

                }
                if (subForm[i].field === 'surnames') {
                    var surnames = subForm[i].value;
                }
            }
            var fullName = name + ' ' + surnames;
            subForm.unshift({ field: 'fullName', value: fullName });
        }

        function updateFullName(subForm) {
            var name;
            var surnames;
            for (var i = 0; i < subForm.length; i++) {
                if (subForm[i].field === 'name') {
                    var name = subForm[i].value;
                }
                if (subForm[i].field === 'surnames') {
                    var surnames = subForm[i].value;
                }
            }
            var fullName = name + ' ' + surnames;
            for (var i = 0; i < subForm.length; i++) {
                if (subForm[i].field === 'fullName') {
                    subForm[i].value = fullName;
                }
            }
        }

        function addIdToForm(subForm, id) {
            subForm.push({ field: 'id', value: id });
        }

        function addFieldToForm(subForm, title, val) {
            subForm.push({ field: title, value: val });
        }

        function userToDTO(subForm, type) {
            var userData = {};
            angular.forEach(subForm, function (field) {
                userData[field.field] = field.value;
            })
            if (!userData.profile_color) {
                userData.profile_color = colors[Math.floor(Math.random() * colors.length)]
            }
            return userData;
        }

        function clientToDTO(form, idCompany) {
            return {
                name: form.name,
                company_id: idCompany,
                country_id: 209,
                language_id: 1
            };
        }




        function companyToForm(company) {
            return {
                name: company.name,
                description: company.description,
                tax_id_type: company.tax_id_type,
                tax_id_number: company.tax_id_number,
                sector_id: company.sector_id,
                employee_count: company.employee_count,
                gain_loss_model_id: company.gain_loss_model_id,
                turnover_volume: company.turnover_volume,
                extra_data: JSON.parse(company.extra_data)
            }
        }


        function getIdFromForm(form) {
            return getValueFromField(form, 'id');
        }

        function getValueFromField(form, field) {
            for (var j = 0; j < form.length; j++) {
                if (form[j].field === field) {
                    return form[j].value;
                }
            }
        }


        function companyToDTO(form) {
            if (!form.company.InputStructure) {
                form.company.InputStructure = {};
            }
            return {
                name: form.company.input,
                proyect_id: form.company.proyect_id,
                stakeholder_id: form.company.stakeholder_id,
                yearsContribution: form.company.yearsContribution,
                InputStructure: form.company.InputStructure,
                descriptionI: form.company.descriptionI
                //fulfillment_committee_document: form.company.fulfillment_committee_document,
                //complaints_committee_document: form.complaints_committee_document
            };
        }
        function getUserType(type) {
            // TODO sacar esto de BBDD 
            if (type === 'administrator') {
                return 1;
            }
            else if (type === 'managerLegal') {
                return 2;
            }
            else if (type === 'compliance') {
                return 3;
            }
            else if (type === 'report') {
                return 4;
            }
        }

        function createBranch(subForm, company_id, isMain, region) {
            if (!isMain) {
                isMain = false;
            }
            var item = {
                country_id: 209,
                is_main: isMain,
                company_id: company_id
            };

            item.name = subForm.name;
            item.email = subForm.email;
            item.phone = String(subForm.phone);
            item.address1 = subForm.address1;
            item.state = subForm.state;
            item.city = subForm.city;
            item.region_id = region;
            item.postcode = String(subForm.postcode);
            return item;
        }
        function branchToForm(fields, branch) {
            var array = [];
            var result = angular.copy(fields);
            for (var i = 0; i < result.length; i++) {
                switch (result[i].field) {
                    case 'name':
                        if (branch.name) {
                            result[i].value = branch.name;
                        }
                        break;
                    case 'email':
                        if (branch.email) {
                            result[i].value = branch.email;
                        }
                        break;
                    case 'phone':
                        if (branch.phone) {
                            result[i].value = parseInt(branch.phone);
                        }
                        break;
                    case 'address':
                        if (branch.address1) {
                            result[i].value = branch.address1;
                        }
                        break;
                    case 'city':
                        if (branch.city) {
                            result[i].value = branch.city;
                        }
                        break;
                    case 'state':
                        if (branch.state) {
                            result[i].value = branch.state;
                        }
                        break;
                    case 'postcode':
                        if (branch.postcode) {
                            result[i].value = parseInt(branch.postcode);
                        }
                        break;
                }
            }
            result.push({ field: 'id', value: branch.id });
            return result;

        }

        function getIdBranch(branch) {
            for (var i = 0; i < branch.length; i++) {
                if (branch[i].field == 'id') {
                    return branch[i].value;
                }
            }
            return false;
        }

        function branchesToForm(fields, branches, formWizard, arrayBranches) {
            var result = [];
            for (var i = 0; i < branches.length; i++) {
                if (branches[i].is_main) {
                    mainBranchToForm(formWizard, branches[i]);
                }
                else {
                    result.push(branchToForm(fields, branches[i]));
                }
                arrayBranches.push({ id: branches[i].id, name: branches[i].name });
            }
            return result;
        }

        function outputToDTO(form) {
            if (!form.company.description_output) {
                form.company.description_output = "";
            } 
            if (!form.company.years_input) {
                form.company.years_input = " ";
            }
            return {
                output: form.company.output,
                proyect_id: form.company.proyect_id,
                stakeholder_id: form.company.stakeholder_id,
                years_input: form.company.years_input,
                description_output: form.company.description_output
            };
         }


        return service;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.jobpositions', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msUtilProvider, msNavigationServiceProvider) {
        // State


        $stateProvider.state('app.jobpositions', {
            url: '/jobpositions',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/jobpositions/jobpositions.html',
                    controller: 'JobPositionsController as vm'
                }
            },
            bodyClass: 'jobs'
        });

        $stateProvider
            .state('app.site_overview.jobpositions', {
                abstract: true,
                url: '/jobpositions',
                onEnter: function ($stateParams) {


                },
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                    section: function ($stateParams) {
                        return $stateParams.owner
                    },
                },


            })
            .state('app.site_overview.jobpositions.list', {
                url: '',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/jobpositions/jobpositions.html',
                        controller: 'JobPositionsController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.jobpositions.list.thread', {
                url: '/:id',
                bodyClass: 'jobs'
            })
        // Translation
        var base = 'app/main/apps/jobpositions';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.jobpositions')
        .factory("transformJobPositions", transformJobPositions);



    /** @ngInject */
    function transformJobPositions() {

        var service = {
            duplicateJobPosition: duplicateJobPosition,
            checkFields: checkFields
            
        };

        function duplicateJobPosition(job) {
            var copy = {
                name: job.name + ' (1)',
            };
            return copy;
        }

        function checkFields(job) {
            if(job.name)
                return false;
            return true;
        }


        return service;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.outcomes', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider,
        msUtilProvider, msNavigationServiceProvider, ivhTreeviewOptionsProvider) {


        ivhTreeviewOptionsProvider.set({
            defaultSelectedState: false,
            validate: true,
            expandToDepth: -1,
            twistieCollapsedTpl: '<md-icon md-font-icon="icon-chevron-right"></md-icon>',
            twistieExpandedTpl: '<md-icon md-font-icon="icon-chevron-left"></md-icon>',
            twistieLeafTpl: '<span style="cursor: default;">&#8192;&#8192;</span>'
        });





        // State


        $stateProvider.state('app.outcomes', {
            url: '/outcomes',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/outcomes/outcomes.html',
                    controller: 'outcomesController as vm'
                }
            },
            bodyClass: 'outcomes'
        });

        $stateProvider
            .state('app.site_overview.outcomes', {
                abstract: true,
                url: '/outcomes',
                onEnter: function ($stateParams) {


                },
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                    section: function ($stateParams) {
                        return $stateParams.owner
                    },
                    is_owner: function ($stateParams) {
                        return false
                    },
                },


            })
            .state('app.site_overview.outcomes.list', {
                url: '/list',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/outcomes/outcomes.html',
                        controller: 'outcomesController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.outcomes.complaints', {
                url: '/compliance',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/outcomes/outcomes.html',
                        controller: 'outcomesController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.outcomes.list.thread', {
                url: '/list/:id',
                bodyClass: 'outcomes'
            });
        // Translation
        var base = 'app/main/apps/outcomes';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.outcomes')
        .factory("transformoutcomes", transformoutcomes);


    /** @ngInject */
    function transformoutcomes() {

        var colors = ['md-blue-300-bg', 'md-blue-grey-300-bg', 'md-orange-300-bg', 'md-pink-300-bg', 'md-purple-300-bg', 'md-red-300-bg', 'md-yellow-300-bg', 'md-light-blue-300-bg'];
        var service = {
            getValueFromField: getValueFromField,
            getUserType: getUserType,
            companyToDTO: companyToDTO,
            outcomeToDTO: outcomeToDTO,
            createBranch: createBranch,
            companyToForm: companyToForm,
            branchToForm: branchToForm,
            getIdBranch: getIdBranch,
            branchesToForm: branchesToForm,
            clientToDTO: clientToDTO,
            userToDTO: userToDTO,
            addIdToForm: addIdToForm,
            addFieldToForm: addFieldToForm,
            getIdFromForm: getIdFromForm,
            updateFullName: updateFullName,
            setFullName: setFullName,
            getAnswer: getAnswer
        };

        function getAnswer(questions) {
            var result = [];
            for (var i = 0; i < questions.length; i++) {
                if (questions[i].value === 'yes') {
                    result.push(questions[i].id);
                }
            }
            return result;
        }

        function setFullName(subForm) {
            var name;
            var surnames;
            for (var i = 0; i < subForm.length; i++) {
                if (subForm[i].field === 'name') {
                    var name = subForm[i].value;

                }
                if (subForm[i].field === 'surnames') {
                    var surnames = subForm[i].value;
                }
            }
            var fullName = name + ' ' + surnames;
            subForm.unshift({ field: 'fullName', value: fullName });
        }

        function updateFullName(subForm) {
            var name;
            var surnames;
            for (var i = 0; i < subForm.length; i++) {
                if (subForm[i].field === 'name') {
                    var name = subForm[i].value;
                }
                if (subForm[i].field === 'surnames') {
                    var surnames = subForm[i].value;
                }
            }
            var fullName = name + ' ' + surnames;
            for (var i = 0; i < subForm.length; i++) {
                if (subForm[i].field === 'fullName') {
                    subForm[i].value = fullName;
                }
            }
        }

        function addIdToForm(subForm, id) {
            subForm.push({ field: 'id', value: id });
        }

        function addFieldToForm(subForm, title, val) {
            subForm.push({ field: title, value: val });
        }

        function userToDTO(subForm, type) {
            var userData = {};
            angular.forEach(subForm, function (field) {
                userData[field.field] = field.value;
            })
            if (!userData.profile_color) {
                userData.profile_color = colors[Math.floor(Math.random() * colors.length)]
            }
            return userData;
        }

        function clientToDTO(form, idCompany) {
            return {
                name: form.name,
                company_id: idCompany,
                country_id: 209,
                language_id: 1
            };
        }

        function getIdBranch(branch) {
            for (var i = 0; i < branch.length; i++) {
                if (branch[i].field == 'id') {
                    return branch[i].value;
                }
            }
            return false;
        }

        function branchesToForm(fields, branches, formWizard, arrayBranches) {
            var result = [];
            for (var i = 0; i < branches.length; i++) {
                if (branches[i].is_main) {
                    mainBranchToForm(formWizard, branches[i]);
                }
                else {
                    result.push(branchToForm(fields, branches[i]));
                }
                arrayBranches.push({ id: branches[i].id, name: branches[i].name });
            }
            return result;
        }

        function mainBranchToForm(formWizard, branch) {
            formWizard.main_branch = {};
            formWizard.main_branch.name = branch.name;
            formWizard.main_branch.address1 = branch.address1;
            formWizard.main_branch.email = branch.email;
            formWizard.main_branch.postcode = branch.postcode;
            formWizard.main_branch.state = branch.state;
            formWizard.main_branch.city = branch.city;
            formWizard.main_branch.phone = branch.phone;
            formWizard.main_branch.id = branch.id;
        }


        function branchToForm(fields, branch) {
            var array = [];
            var result = angular.copy(fields);
            for (var i = 0; i < result.length; i++) {
                switch (result[i].field) {
                    case 'name':
                        if (branch.name) {
                            result[i].value = branch.name;
                        }
                        break;
                    case 'email':
                        if (branch.email) {
                            result[i].value = branch.email;
                        }
                        break;
                    case 'phone':
                        if (branch.phone) {
                            result[i].value = parseInt(branch.phone);
                        }
                        break;
                    case 'address':
                        if (branch.address1) {
                            result[i].value = branch.address1;
                        }
                        break;
                    case 'city':
                        if (branch.city) {
                            result[i].value = branch.city;
                        }
                        break;
                    case 'state':
                        if (branch.state) {
                            result[i].value = branch.state;
                        }
                        break;
                    case 'postcode':
                        if (branch.postcode) {
                            result[i].value = parseInt(branch.postcode);
                        }
                        break;
                }
            }
            result.push({ field: 'id', value: branch.id });
            return result;

        }

        function companyToForm(company) {
            return {
                name: company.name,
                description: company.description,
                tax_id_type: company.tax_id_type,
                tax_id_number: company.tax_id_number,
                sector_id: company.sector_id,
                employee_count: company.employee_count,
                gain_loss_model_id: company.gain_loss_model_id,
                turnover_volume: company.turnover_volume,
                extra_data: JSON.parse(company.extra_data)
            }
        }

        function createBranch(subForm, company_id, isMain, region) {
            if (!isMain) {
                isMain = false;
            }
            var item = {
                country_id: 209,
                is_main: isMain,
                company_id: company_id
            };

            item.name = subForm.name;
            item.email = subForm.email;
            item.phone = String(subForm.phone);
            item.address1 = subForm.address1;
            item.state = subForm.state;
            item.city = subForm.city;
            item.region_id = region;
            item.postcode = String(subForm.postcode);
            return item;
        }

        function getIdFromForm(form) {
            return getValueFromField(form, 'id');
        }

        function getValueFromField(form, field) {
            for (var j = 0; j < form.length; j++) {
                if (form[j].field === field) {
                    return form[j].value;
                }
            }
        }

        function getUserType(type) {
            // TODO sacar esto de BBDD 
            if (type === 'administrator') {
                return 1;
            }
            else if (type === 'managerLegal') {
                return 2;
            }
            else if (type === 'compliance') {
                return 3;
            }
            else if (type === 'report') {
                return 4;
            }
        }

        function companyToDTO(form) {
            if (!form.company.outcome_structure) {
                form.company.outcome_structure = {};
            }
            return {
                name: form.company.outcome,
                proyect_id: form.company.proyect_id,
                stakeholder_id: form.company.stakeholder_id,
                years_contribution: form.company.years_contribution,
                outcome_structure: form.company.outcome_structure,
                outcome_structure: form.company.years,
                description_outcome: form.company.description_outcome
            };
        }
        function outcomeToDTO(form) {
            if (!form.company.outcome_structure) {
                form.company.outcome_structure = {"calculation": "0","formula": [],"outcomes": []};  
                      }
            if (!form.company.description_outcome) {
                form.company.description_outcome = " ";
            }
            if (!form.company.result) {
                form.company.result  = 0;
            }
            if (!form.company.subresult) {
                form.company.subresult  = 0;
            }
            return {
                outcome: form.company.outcome,
                proyect_id: form.company.proyect_id,
                stakeholder_id: form.company.stakeholder_id,
                years_input: form.company.years_input,
                outcome_structure: JSON.stringify(form.company.outcome_structure),
                result: form.company.result,
                sub_result: form.company.sub_result,
                years: form.company.years,
                comments: form.company.comments,
                dead_weight: form.company.dead_weight,
                displacement: form.company.displacement,
                attribution: form.company.attribution,
                decrease: form.company.decrease,
                description_outcome: form.company.description_outcome
            };
         }


        return service;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.items', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider,
        msUtilProvider, msNavigationServiceProvider, ivhTreeviewOptionsProvider) {


        ivhTreeviewOptionsProvider.set({
            defaultSelectedState: false,
            validate: true,
            expandToDepth: -1,
            twistieCollapsedTpl: '<md-icon md-font-icon="icon-chevron-right"></md-icon>',
            twistieExpandedTpl: '<md-icon md-font-icon="icon-chevron-left"></md-icon>',
            twistieLeafTpl: '<span style="cursor: default;">&#8192;&#8192;</span>'
        });





        // State


        $stateProvider.state('app.items', {
            url: '/items',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/items/items.html',
                    controller: 'itemsController as vm'
                }
            },
            bodyClass: 'items'
        });

        $stateProvider
            .state('app.site_overview.items', {
                abstract: true,
                url: '/items',
                onEnter: function ($stateParams) {


                },
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                    section: function ($stateParams) {
                        return $stateParams.owner
                    },
                    is_owner: function ($stateParams) {
                        return false
                    },
                },


            })
            .state('app.site_overview.items.list', {
                url: '/list',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/items/items.html',
                        controller: 'itemsController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.items.complaints', {
                url: '/compliance',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/items/items.html',
                        controller: 'itemsController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.items.list.thread', {
                url: '/list/:id',
                bodyClass: 'items'
            });
        // Translation
        var base = 'app/main/apps/items';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.items')
        .factory("transformitems", transformitems);


    /** @ngInject */
    function transformitems() {

        var colors = ['md-blue-300-bg', 'md-blue-grey-300-bg', 'md-orange-300-bg', 'md-pink-300-bg', 'md-purple-300-bg', 'md-red-300-bg', 'md-yellow-300-bg', 'md-light-blue-300-bg'];
        var service = {
            getValueFromField: getValueFromField,
            getUserType: getUserType,
            companyToDTO: companyToDTO,
            itemToDTO: itemToDTO,
            createBranch: createBranch,
            companyToForm: companyToForm,
            branchToForm: branchToForm,
            getIdBranch: getIdBranch,
            branchesToForm: branchesToForm,
            clientToDTO: clientToDTO,
            userToDTO: userToDTO,
            addIdToForm: addIdToForm,
            addFieldToForm: addFieldToForm,
            getIdFromForm: getIdFromForm,
            updateFullName: updateFullName,
            setFullName: setFullName,
            getAnswer: getAnswer
        };

        function getAnswer(questions) {
            var result = [];
            for (var i = 0; i < questions.length; i++) {
                if (questions[i].value === 'yes') {
                    result.push(questions[i].id);
                }
            }
            return result;
        }

        function setFullName(subForm) {
            var name;
            var surnames;
            for (var i = 0; i < subForm.length; i++) {
                if (subForm[i].field === 'name') {
                    var name = subForm[i].value;

                }
                if (subForm[i].field === 'surnames') {
                    var surnames = subForm[i].value;
                }
            }
            var fullName = name + ' ' + surnames;
            subForm.unshift({ field: 'fullName', value: fullName });
        }

        function updateFullName(subForm) {
            var name;
            var surnames;
            for (var i = 0; i < subForm.length; i++) {
                if (subForm[i].field === 'name') {
                    var name = subForm[i].value;
                }
                if (subForm[i].field === 'surnames') {
                    var surnames = subForm[i].value;
                }
            }
            var fullName = name + ' ' + surnames;
            for (var i = 0; i < subForm.length; i++) {
                if (subForm[i].field === 'fullName') {
                    subForm[i].value = fullName;
                }
            }
        }

        function addIdToForm(subForm, id) {
            subForm.push({ field: 'id', value: id });
        }

        function addFieldToForm(subForm, title, val) {
            subForm.push({ field: title, value: val });
        }

        function userToDTO(subForm, type) {
            var userData = {};
            angular.forEach(subForm, function (field) {
                userData[field.field] = field.value;
            })
            if (!userData.profile_color) {
                userData.profile_color = colors[Math.floor(Math.random() * colors.length)]
            }
            return userData;
        }

        function clientToDTO(form, idCompany) {
            return {
                name: form.name,
                company_id: idCompany,
                country_id: 209,
                language_id: 1
            };
        }

        function getIdBranch(branch) {
            for (var i = 0; i < branch.length; i++) {
                if (branch[i].field == 'id') {
                    return branch[i].value;
                }
            }
            return false;
        }

        function branchesToForm(fields, branches, formWizard, arrayBranches) {
            var result = [];
            for (var i = 0; i < branches.length; i++) {
                if (branches[i].is_main) {
                    mainBranchToForm(formWizard, branches[i]);
                }
                else {
                    result.push(branchToForm(fields, branches[i]));
                }
                arrayBranches.push({ id: branches[i].id, name: branches[i].name });
            }
            return result;
        }

        function mainBranchToForm(formWizard, branch) {
            formWizard.main_branch = {};
            formWizard.main_branch.name = branch.name;
            formWizard.main_branch.address1 = branch.address1;
            formWizard.main_branch.email = branch.email;
            formWizard.main_branch.postcode = branch.postcode;
            formWizard.main_branch.state = branch.state;
            formWizard.main_branch.city = branch.city;
            formWizard.main_branch.phone = branch.phone;
            formWizard.main_branch.id = branch.id;
        }


        function branchToForm(fields, branch) {
            var array = [];
            var result = angular.copy(fields);
            for (var i = 0; i < result.length; i++) {
                switch (result[i].field) {
                    case 'name':
                        if (branch.name) {
                            result[i].value = branch.name;
                        }
                        break;
                    case 'email':
                        if (branch.email) {
                            result[i].value = branch.email;
                        }
                        break;
                    case 'phone':
                        if (branch.phone) {
                            result[i].value = parseInt(branch.phone);
                        }
                        break;
                    case 'address':
                        if (branch.address1) {
                            result[i].value = branch.address1;
                        }
                        break;
                    case 'city':
                        if (branch.city) {
                            result[i].value = branch.city;
                        }
                        break;
                    case 'state':
                        if (branch.state) {
                            result[i].value = branch.state;
                        }
                        break;
                    case 'postcode':
                        if (branch.postcode) {
                            result[i].value = parseInt(branch.postcode);
                        }
                        break;
                }
            }
            result.push({ field: 'id', value: branch.id });
            return result;

        }

        function companyToForm(company) {
            return {
                name: company.name,
                description: company.description,
                tax_id_type: company.tax_id_type,
                tax_id_number: company.tax_id_number,
                sector_id: company.sector_id,
                employee_count: company.employee_count,
                gain_loss_model_id: company.gain_loss_model_id,
                turnover_volume: company.turnover_volume,
                extra_data: JSON.parse(company.extra_data)
            }
        }

        function createBranch(subForm, company_id, isMain, region) {
            if (!isMain) {
                isMain = false;
            }
            var item = {
                country_id: 209,
                is_main: isMain,
                company_id: company_id
            };

            item.name = subForm.name;
            item.email = subForm.email;
            item.phone = String(subForm.phone);
            item.address1 = subForm.address1;
            item.state = subForm.state;
            item.city = subForm.city;
            item.region_id = region;
            item.postcode = String(subForm.postcode);
            return item;
        }

        function getIdFromForm(form) {
            return getValueFromField(form, 'id');
        }

        function getValueFromField(form, field) {
            for (var j = 0; j < form.length; j++) {
                if (form[j].field === field) {
                    return form[j].value;
                }
            }
        }

        function getUserType(type) {
            // TODO sacar esto de BBDD 
            if (type === 'administrator') {
                return 1;
            }
            else if (type === 'managerLegal') {
                return 2;
            }
            else if (type === 'compliance') {
                return 3;
            }
            else if (type === 'report') {
                return 4;
            }
        }

        function companyToDTO(form) {
            if (!form.company.extra_data) {
                form.company.extra_data = {};
            }
            return {
                name: form.company.stakeholfer,
                company_id: form.company.company_id,
                input: form.company.input,
                output: form.company.ouput
                //fulfillment_committee_document: form.company.fulfillment_committee_document,
                //complaints_committee_document: form.complaints_committee_document
            };
        } 
        function itemToDTO(form) {
            if(!form.company.value)  {
                form.company.value = "0";
            }
            let arr_interes = Array.from(form.company.value);
            var interes = "";
            for (let i = 0; i < arr_interes.length; i++) {
                if  ((arr_interes[i] >= "0" && arr_interes[i] <= "9") || arr_interes[i] == ".")
                {
                 interes = interes +   arr_interes[i];  
                }
                if  (arr_interes[i] == ",")
                {
                 interes = interes +   ".";  
                }
            }
            if(interes == "")  {
                interes = "0";
            }
            form.company.value  = interes;   
           return {
                name: form.company.name,
                proyect_id: form.company.company_id,
                description_item: form.company.description_item,
                value: form.company.value,
                type: form.company.type,
                edit_item: form.company.edit_item
                //fulfillment_committee_document: form.company.fulfillment_committee_document,
                //complaints_committee_document: form.complaints_committee_document
            };
        }


        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .factory('NotesService', NotesService);

    /** @ngInject */
    function NotesService(msApi, $q)
    {
        var service = {
            data      : [],
            addNote   : addNote,
            updateNote: updateNote,
            deleteNote: deleteNote,
            getData   : getData
        };

        /**
         * Add Note
         * @param note
         */
        function addNote(note)
        {
            service.data.push(note);
        }

        /**
         * Update Note
         * @param note
         */
        function updateNote(note)
        {
            for ( var i = 0; i < service.data.length; i++ )
            {
                if ( service.data[i].id === note.id )
                {
                    service.data[i] = note;
                }
            }
        }

        /**
         * Delete Note
         * @param note
         */
        function deleteNote(note)
        {
            for ( var i = 0; i < service.data.length; i++ )
            {
                if ( service.data[i].id === note.id )
                {
                    service.data.splice(i, 1);
                }
            }
        }

        /**
         * Get service data
         * @returns {Array}
         */
        function getData()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            msApi.request('notes.notes@get', {},
                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the promise
                    deferred.resolve(response);
                },

                // ERROR
                function (response)
                {
                    // Reject the promise
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        return service;

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .factory('LabelsService', LabelsService);

    /** @ngInject */
    function LabelsService(msUtils, NotesService, msApi, $q)
    {
        var service = {
            data       : [],
            addLabel   : addLabel,
            updateLabel: updateLabel,
            deleteLabel: deleteLabel,
            getData    : getData
        };

        /**
         * Add label
         * @param newLabel
         */
        function addLabel(newLabel)
        {
            if ( newLabel.name === '' )
            {
                return;
            }

            service.data.push({
                id   : msUtils.guidGenerator(),
                name : newLabel.name,
                color: newLabel.color || ''
            });
        }

        /**
         * Update Label
         * @param note
         */
        function updateLabel(note)
        {
            for ( var i = 0; i < service.data.length; i++ )
            {
                if ( service.data[i].id === note.id )
                {
                    service.data[i] = note;
                }
            }
        }

        /**
         * Delete Label
         * @param label
         */
        function deleteLabel(label)
        {
            var notes = NotesService.data;

            // Look for all notes if they have the labels
            for ( var j = 0; j < notes.length; j++ )
            {
                if ( notes[j].labels.indexOf(label.id) > -1 )
                {
                    notes[j].labels.splice(notes[j].labels.indexOf(label.id), 1);
                }
            }

            // Delete label from service data
            for ( var i = 0; i < service.data.length; i++ )
            {
                if ( service.data[i].id === label.id )
                {
                    service.data.splice(i, 1);
                }
            }

        }

        /**
         * Get service data
         * @returns {Array}
         */
        function getData()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            msApi.request('notes.labels@get', {},
                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the promise
                    deferred.resolve(response);
                },

                // ERROR
                function (response)
                {
                    // Reject the promise
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        return service;

    }
})();
(function () {
    'use strict';

    angular
        .module('app.inputs')
        .factory("transforminputs", transforminputs);


    /** @ngInject */
    function transforminputs() {

        var colors = ['md-blue-300-bg', 'md-blue-grey-300-bg', 'md-orange-300-bg', 'md-pink-300-bg', 'md-purple-300-bg', 'md-red-300-bg', 'md-yellow-300-bg', 'md-light-blue-300-bg'];
        var service = {
            getValueFromField: getValueFromField,
            getUserType: getUserType,
            companyToDTO: companyToDTO,
            inputToDTO: inputToDTO,
            createBranch: createBranch,
            companyToForm: companyToForm,
            branchToForm: branchToForm,
            getIdBranch: getIdBranch,
            branchesToForm: branchesToForm,
            clientToDTO: clientToDTO,
            userToDTO: userToDTO,
            addIdToForm: addIdToForm,
            addFieldToForm: addFieldToForm,
            getIdFromForm: getIdFromForm,
            updateFullName: updateFullName,
            setFullName: setFullName,
            getAnswer: getAnswer
        };

        function getAnswer(questions) {
            var result = [];
            for (var i = 0; i < questions.length; i++) {
                if (questions[i].value === 'yes') {
                    result.push(questions[i].id);
                }
            }
            return result;
        }

        function setFullName(subForm) {
            var name;
            var surnames;
            for (var i = 0; i < subForm.length; i++) {
                if (subForm[i].field === 'name') {
                    var name = subForm[i].value;

                }
                if (subForm[i].field === 'surnames') {
                    var surnames = subForm[i].value;
                }
            }
            var fullName = name + ' ' + surnames;
            subForm.unshift({ field: 'fullName', value: fullName });
        }

        function updateFullName(subForm) {
            var name;
            var surnames;
            for (var i = 0; i < subForm.length; i++) {
                if (subForm[i].field === 'name') {
                    var name = subForm[i].value;
                }
                if (subForm[i].field === 'surnames') {
                    var surnames = subForm[i].value;
                }
            }
            var fullName = name + ' ' + surnames;
            for (var i = 0; i < subForm.length; i++) {
                if (subForm[i].field === 'fullName') {
                    subForm[i].value = fullName;
                }
            }
        }

        function addIdToForm(subForm, id) {
            subForm.push({ field: 'id', value: id });
        }

        function addFieldToForm(subForm, title, val) {
            subForm.push({ field: title, value: val });
        }

        function userToDTO(subForm, type) {
            var userData = {};
            angular.forEach(subForm, function (field) {
                userData[field.field] = field.value;
            })
            if (!userData.profile_color) {
                userData.profile_color = colors[Math.floor(Math.random() * colors.length)]
            }
            return userData;
        }

        function clientToDTO(form, idCompany) {
            return {
                name: form.name,
                company_id: idCompany,
                country_id: 209,
                language_id: 1
            };
        }

        function getIdBranch(branch) {
            for (var i = 0; i < branch.length; i++) {
                if (branch[i].field == 'id') {
                    return branch[i].value;
                }
            }
            return false;
        }

        function branchesToForm(fields, branches, formWizard, arrayBranches) {
            var result = [];
            for (var i = 0; i < branches.length; i++) {
                if (branches[i].is_main) {
                    mainBranchToForm(formWizard, branches[i]);
                }
                else {
                    result.push(branchToForm(fields, branches[i]));
                }
                arrayBranches.push({ id: branches[i].id, name: branches[i].name });
            }
            return result;
        }

        function mainBranchToForm(formWizard, branch) {
            formWizard.main_branch = {};
            formWizard.main_branch.name = branch.name;
            formWizard.main_branch.address1 = branch.address1;
            formWizard.main_branch.email = branch.email;
            formWizard.main_branch.postcode = branch.postcode;
            formWizard.main_branch.state = branch.state;
            formWizard.main_branch.city = branch.city;
            formWizard.main_branch.phone = branch.phone;
            formWizard.main_branch.id = branch.id;
        }


        function branchToForm(fields, branch) {
            var array = [];
            var result = angular.copy(fields);
            for (var i = 0; i < result.length; i++) {
                switch (result[i].field) {
                    case 'name':
                        if (branch.name) {
                            result[i].value = branch.name;
                        }
                        break;
                    case 'email':
                        if (branch.email) {
                            result[i].value = branch.email;
                        }
                        break;
                    case 'phone':
                        if (branch.phone) {
                            result[i].value = parseInt(branch.phone);
                        }
                        break;
                    case 'address':
                        if (branch.address1) {
                            result[i].value = branch.address1;
                        }
                        break;
                    case 'city':
                        if (branch.city) {
                            result[i].value = branch.city;
                        }
                        break;
                    case 'state':
                        if (branch.state) {
                            result[i].value = branch.state;
                        }
                        break;
                    case 'postcode':
                        if (branch.postcode) {
                            result[i].value = parseInt(branch.postcode);
                        }
                        break;
                }
            }
            result.push({ field: 'id', value: branch.id });
            return result;

        }

        function companyToForm(company) {
            return {
                name: company.name,
                description: company.description,
                tax_id_type: company.tax_id_type,
                tax_id_number: company.tax_id_number,
                sector_id: company.sector_id,
                employee_count: company.employee_count,
                gain_loss_model_id: company.gain_loss_model_id,
                turnover_volume: company.turnover_volume,
                extra_data: JSON.parse(company.extra_data)
            }
        }

        function createBranch(subForm, company_id, isMain, region) {
            if (!isMain) {
                isMain = false;
            }
            var item = {
                country_id: 209,
                is_main: isMain,
                company_id: company_id
            };

            item.name = subForm.name;
            item.email = subForm.email;
            item.phone = String(subForm.phone);
            item.address1 = subForm.address1;
            item.state = subForm.state;
            item.city = subForm.city;
            item.region_id = region;
            item.postcode = String(subForm.postcode);
            return item;
        }

        function getIdFromForm(form) {
            return getValueFromField(form, 'id');
        }

        function getValueFromField(form, field) {
            for (var j = 0; j < form.length; j++) {
                if (form[j].field === field) {
                    return form[j].value;
                }
            }
        }

        function getUserType(type) {
            // TODO sacar esto de BBDD 
            if (type === 'administrator') {
                return 1;
            }
            else if (type === 'managerLegal') {
                return 2;
            }
            else if (type === 'compliance') {
                return 3;
            }
            else if (type === 'report') {
                return 4;
            }
        }

        function companyToDTO(form) {
            if (!form.company.input_structure) {
                form.company.input_structure = {};
            }
            return {
                name: form.company.input,
                proyect_id: form.company.proyect_id,
                stakeholder_id: form.company.stakeholder_id,
                years_contribution: form.company.years_contribution,
                input_structure: form.company.input_structure,
                input_structure: form.company.years,
                description_input: form.company.description_input
            };
        }
        function inputToDTO(form) {
            if (!form.company.input_structure) {
                form.company.input_structure = {"calculation": "0","formula": [],"inputs": []};  
                      }
            if (!form.company.description_input) {
                form.company.description_input = " ";
            }
            if (!form.company.result) {
                form.company.result  = 0;
            }
            if (!form.company.subresult) {
                form.company.subresult  = 0;
            }
           return {
                input: form.company.input,
                proyect_id: form.company.proyect_id,
                stakeholder_id: form.company.stakeholder_id,
                years_contribution: form.company.years_contribution,
                input_structure: JSON.stringify(form.company.input_structure),
                result: form.company.result,
                sub_result: form.company.sub_result,
                years: form.company.years,
                comments: form.company.comments,
                description_input: form.company.description_input
            };
         }


        return service;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.documents')
        .factory("transformDocuments", transformDocuments);



    /** @ngInject */
    function transformDocuments() {

        var service = {
            listToTree: listToTree
        };

        function listToTree(groups) {
            var map = {}, node, roots = [], i;
            for (i = 0; i < groups.length; i += 1) {
                map[groups[i].id] = i; // initialize the map
                groups[i].children = []; // initialize the children
            }
            for (i = 0; i < groups.length; i += 1) {
                node = groups[i];
                if (node.parent_id !== null) {
                    // if you have dangling branches check that map[node.parentId] exists
                    groups[map[node.parent_id]].children.push(node);
                } else {
                    roots.push(node);
                }
            }
            return roots;
        }
        return service;
    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.dashboards.server', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.dashboards_server', {
            url      : '/dashboard-server',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/server/dashboard-server.html',
                    controller : 'DashboardServerController as vm'
                }
            },
            resolve  : {
                DashboardData: function (msApi)
                {
                    return msApi.resolve('dashboard.server@get');
                }
            },
            bodyClass: 'dashboard-server'
        });

        // Api
        msApiProvider.register('dashboard.server', ['app/data/dashboard/server/data.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.server')
        .controller('DashboardServerController', DashboardServerController);

    /** @ngInject */
    function DashboardServerController($scope, $interval, DashboardData)
    {
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;

        // Widget 1
        vm.widget1 = {
            title: vm.dashboardData.widget1.title,
            chart: {
                options: {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#4caf50', '#3f51b5', '#ff5722'],
                        height                 : 320,
                        margin                 : {
                            top   : 32,
                            right : 32,
                            bottom: 32,
                            left  : 48
                        },
                        useInteractiveGuideline: true,
                        clipVoronoi            : false,
                        interpolate            : 'cardinal',
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                return d + ' min.';
                            },
                            showMaxMin: false
                        },
                        yAxis                  : {
                            tickFormat: function (d)
                            {
                                return d + ' MB';
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        },
                        legend                 : {
                            margin    : {
                                top   : 8,
                                right : 0,
                                bottom: 32,
                                left  : 0
                            },
                            rightAlign: false
                        }
                    }
                },
                data   : vm.dashboardData.widget1.chart
            }
        };

        // Widget 2
        vm.widget2 = vm.dashboardData.widget2;

        // Widget 3
        vm.widget3 = vm.dashboardData.widget3;

        // Widget 4
        vm.widget4 = {
            title   : vm.dashboardData.widget4.title,
            value   : vm.dashboardData.widget4.value,
            footnote: vm.dashboardData.widget4.footnote,
            detail  : vm.dashboardData.widget4.detail,
            chart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'lineChart',
                        color       : ['rgba(0, 0, 0, 0.27)'],
                        height      : 50,
                        margin      : {
                            top   : 8,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        duration    : 1,
                        clipEdge    : true,
                        interpolate : 'cardinal',
                        interactive : false,
                        isArea      : true,
                        showLegend  : false,
                        showControls: false,
                        showXAxis   : false,
                        showYAxis   : false,
                        x           : function (d)
                        {
                            return d.x;
                        },
                        y           : function (d)
                        {
                            return d.y;
                        },
                        yDomain     : [0, 4]
                    }
                },
                data   : vm.dashboardData.widget4.chart
            },
            init    : function ()
            {
                // Run this function once to initialize the widget

                // Grab the x value
                var lastIndex = vm.dashboardData.widget4.chart[0].values.length - 1,
                    x = vm.dashboardData.widget4.chart[0].values[lastIndex].x;

                /**
                 * Emulate constant data flow
                 *
                 * @param min
                 * @param max
                 */
                function latencyTicker(min, max)
                {
                    // Increase the x value
                    x++;

                    var randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;

                    var newValue = {
                        x: x,
                        y: randomNumber
                    };

                    vm.widget4.chart.data[0].values.shift();
                    vm.widget4.chart.data[0].values.push(newValue);

                    // Randomize the value
                    vm.widget4.value = 20 + randomNumber + 'ms';
                }

                // Set interval
                var latencyTickerInterval = $interval(function ()
                {
                    latencyTicker(1, 4);
                }, 1000);

                // Cleanup
                $scope.$on('$destroy', function ()
                {
                    $interval.cancel(latencyTickerInterval);
                });
            }
        };

        // Widget 5
        vm.widget5 = vm.dashboardData.widget5;

        // Widget 6
        vm.widget6 = {
            title: vm.dashboardData.widget6.title,
            chart: {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#03A9F4'],
                        height                 : 140,
                        margin                 : {
                            top   : 8,
                            right : 32,
                            bottom: 16,
                            left  : 48
                        },
                        duration               : 1,
                        clipEdge               : true,
                        clipVoronoi            : false,
                        interpolate            : 'cardinal',
                        isArea                 : true,
                        useInteractiveGuideline: true,
                        showLegend             : false,
                        showControls           : false,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        yDomain                : [0, 100],
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                return d + ' sec.';
                            },
                            showMaxMin: false
                        },
                        yAxis                  : {
                            tickFormat: function (d)
                            {
                                return d + '%';
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data   : vm.dashboardData.widget6.chart
            },
            init : function ()
            {
                // Run this function once to initialize the widget

                // Grab the x value
                var lastIndex = vm.dashboardData.widget6.chart[0].values.length - 1,
                    x = vm.dashboardData.widget6.chart[0].values[lastIndex].x;

                /**
                 * Emulate constant data flow
                 *
                 * @param min
                 * @param max
                 */
                function cpuTicker(min, max)
                {
                    // Increase the x value
                    x = x + 5;

                    var newValue = {
                        x: x,
                        y: Math.floor(Math.random() * (max - min + 1)) + min
                    };

                    vm.widget6.chart.data[0].values.shift();
                    vm.widget6.chart.data[0].values.push(newValue);
                }

                // Set interval
                var cpuTickerInterval = $interval(function ()
                {
                    cpuTicker(0, 100);
                }, 5000);

                // Cleanup
                $scope.$on('$destroy', function ()
                {
                    $interval.cancel(cpuTickerInterval);
                });
            }
        };

        // Widget 7
        vm.widget7 = {
            title    : vm.dashboardData.widget7.title,
            table    : vm.dashboardData.widget7.table,
            dtOptions: {
                dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                pageLength: 10,
                lengthMenu: [10, 20, 50, 100],
                autoWidth : false,
                responsive: true,
                columnDefs: [
                    {
                        width  : '20%',
                        targets: [0, 1, 2, 3, 4]
                    }
                ],
                columns   : [
                    {},
                    {},
                    {
                        render: function (data, type)
                        {
                            if ( type === 'display' )
                            {
                                return data + ' KB/s';
                            }
                            else
                            {
                                return data;
                            }
                        }
                    },
                    {
                        render: function (data, type)
                        {
                            if ( type === 'display' )
                            {
                                return data + '%';
                            }
                            else
                            {
                                return data;
                            }
                        }
                    },
                    {
                        render: function (data, type)
                        {
                            if ( type === 'display' )
                            {
                                var el = angular.element(data);
                                el.html(el.text() + ' MB');

                                return el[0].outerHTML;
                            }
                            else
                            {
                                return data;
                            }
                        }
                    }
                ]
            }
        };

        // Widget 8
        vm.widget8 = vm.dashboardData.widget8;

        // Methods

        //////////

        // Init Widget 4
        vm.widget4.init();

        // Init Widget 6
        vm.widget6.init();
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.project', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.dashboards_project', {
            url      : '/dashboard-project',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/project/init.html',
                    controller : 'DashboardProjectController as vm'
                }
            },
            resolve  : {
                DashboardData: function (msApi)
                {
                    return msApi.resolve('dashboard.project@get');
                },
                DashboardAnalyticsData: function (msApi)
                {
                    return msApi.resolve('dashboard.analytics@get');
                }
            },
            bodyClass: 'dashboard-project'
        });

        // Api
        msApiProvider.register('dashboard.project', ['app/data/dashboard/project/data.json']);
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.dashboards.project')
        .controller('DashboardProjectController', DashboardProjectController);

    /** @ngInject */
    function DashboardProjectController($scope, $interval, $mdSidenav, DashboardData, DashboardAnalyticsData, uiGmapGoogleMapApi)
    {
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;
        vm.DashboardAnalyticsData = DashboardAnalyticsData;
        vm.projects = vm.dashboardData.projects;

        // Widget 2
        vm.widget2_analytics = {
            title: vm.DashboardAnalyticsData.widget2.title
        };

        // Widget 3
        vm.widget3_analytics = {
            title       : vm.DashboardAnalyticsData.widget3.title,
            pages       : vm.DashboardAnalyticsData.widget3.pages,
            ranges      : vm.DashboardAnalyticsData.widget3.ranges,
            currentRange: vm.DashboardAnalyticsData.widget3.currentRange,
            changeRange : function (range)
            {
                vm.widget3.currentRange(range);
            }
        };


        // Widget 1
        vm.widget1 = vm.dashboardData.widget1;

        // Widget 2
        vm.widget2 = vm.dashboardData.widget2;

        // Widget 3
        vm.widget3 = vm.dashboardData.widget3;

        // Widget 4
        vm.widget4 = vm.dashboardData.widget4;

        // Widget 5
        vm.widget5 = {
            title       : vm.dashboardData.widget5.title,
            mainChart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'multiBarChart',
                        color       : ['#03a9f4', '#b3e5fc'],
                        height      : 420,
                        margin      : {
                            top   : 8,
                            right : 16,
                            bottom: 32,
                            left  : 32
                        },
                        clipEdge    : true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked     : true,
                        duration    : 250,
                        x           : function (d)
                        {
                            return d.x;
                        },
                        y           : function (d)
                        {
                            return d.y;
                        },
                        yAxis       : {
                            tickFormat: function (d)
                            {
                                return d;
                            }
                        },
                        legend      : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        controls    : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : []
            },
            supporting  : {
                widgets: {
                    created  : {
                        data : vm.dashboardData.widget5.supporting.created,
                        chart: {
                            data: []
                        }
                    },
                    closed   : {
                        data : vm.dashboardData.widget5.supporting.closed,
                        chart: {
                            data: []
                        }
                    },
                    reOpened : {
                        data : vm.dashboardData.widget5.supporting.reOpened,
                        chart: {
                            data: []
                        }
                    },
                    wontFix  : {
                        data : vm.dashboardData.widget5.supporting.wontFix,
                        chart: {
                            data: []
                        }
                    },
                    needsTest: {
                        data : vm.dashboardData.widget5.supporting.needsTest,
                        chart: {
                            data: []
                        }
                    },
                    fixed    : {
                        data : vm.dashboardData.widget5.supporting.fixed,
                        chart: {
                            data: []
                        }
                    }
                },
                chart  : {
                    config : {
                        refreshDataOnly: true,
                        deepWatchData  : true
                    },
                    options: {
                        chart: {
                            type                   : 'lineChart',
                            color                  : ['#03A9F4'],
                            height                 : 50,
                            margin                 : {
                                top   : 8,
                                right : 0,
                                bottom: 0,
                                left  : 0
                            },
                            isArea                 : true,
                            interpolate            : 'cardinal',
                            clipEdge               : true,
                            duration               : 500,
                            showXAxis              : false,
                            showYAxis              : false,
                            showLegend             : false,
                            useInteractiveGuideline: true,
                            x                      : function (d)
                            {
                                return d.x;
                            },
                            y                      : function (d)
                            {
                                return d.y;
                            },
                            yDomain                : [0, 9],
                            xAxis                  : {
                                tickFormat: function (d)
                                {
                                    return vm.widget5.days[d];
                                }
                            },
                            interactiveLayer       : {
                                tooltip: {
                                    gravity: 'e',
                                    classes: 'gravity-e'
                                }
                            }
                        }
                    },
                    data   : []
                }
            },
            days        : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges      : vm.dashboardData.widget5.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget5.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboardData.widget5.mainChart, function (chartData, index)
                {
                    vm.widget5.mainChart.data[index] = {
                        key   : chartData.key,
                        values: chartData.values[range]
                    };
                });

                /**
                 * Do the same thing for the supporting widgets but they
                 * only have 1 dataset so we can do [0] without needing to
                 * iterate through in their data arrays
                 */
                angular.forEach(vm.dashboardData.widget5.supporting, function (widget, name)
                {
                    vm.widget5.supporting.widgets[name].chart.data[0] = {
                        key   : widget.chart.key,
                        values: widget.chart.values[range]
                    };
                });
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget5.changeRange('TW');
            }
        };

        // Widget 6
        vm.widget6 = {
            title       : vm.dashboardData.widget6.title,
            mainChart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'pieChart',
                        color       : ['#f44336', '#9c27b0', '#03a9f4', '#e91e63'],
                        height      : 400,
                        margin      : {
                            top   : 0,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        donut       : true,
                        clipEdge    : true,
                        cornerRadius: 0,
                        labelType   : 'percent',
                        padAngle    : 0.02,
                        x           : function (d)
                        {
                            return d.label;
                        },
                        y           : function (d)
                        {
                            return d.value;
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : []
            },
            footerLeft  : vm.dashboardData.widget6.footerLeft,
            footerRight : vm.dashboardData.widget6.footerRight,
            ranges      : vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget6.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboardData.widget6.mainChart, function (data, index)
                {
                    vm.widget6.mainChart.data[index] = {
                        label: data.label,
                        value: data.values[range]
                    };
                });
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget6.changeRange('TW');
            }
        };

        // Widget 7
        vm.widget7 = {
            title       : vm.dashboardData.widget7.title,
            ranges      : vm.dashboardData.widget7.ranges,
            schedule    : vm.dashboardData.widget7.schedule,
            currentRange: 'T'
        };

        // Widget 8
        vm.widget8 = {
            title    : vm.dashboardData.widget8.title,
            mainChart: {
                options: {
                    chart: {
                        type     : 'pieChart',
                        color    : ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
                        height   : 400,
                        margin   : {
                            top   : 0,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        labelType: 'percent',
                        x        : function (d)
                        {
                            return d.label;
                        },
                        y        : function (d)
                        {
                            return d.value;
                        },
                        tooltip  : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : vm.dashboardData.widget8.mainChart
            }
        };

        // Widget 9
        vm.widget9 = {
            title       : vm.dashboardData.widget9.title,
            weeklySpent : {
                title    : vm.dashboardData.widget9.weeklySpent.title,
                count    : vm.dashboardData.widget9.weeklySpent.count,
                chartData: []
            },
            totalSpent  : {
                title    : vm.dashboardData.widget9.totalSpent.title,
                count    : vm.dashboardData.widget9.totalSpent.count,
                chartData: []
            },
            remaining   : {
                title    : vm.dashboardData.widget9.remaining.title,
                count    : vm.dashboardData.widget9.remaining.count,
                chartData: []
            },
            totalBudget : vm.dashboardData.widget9.totalBudget,
            chart       : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#00BCD4'],
                        height                 : 50,
                        margin                 : {
                            top   : 8,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        yDomain                : [0, 9],
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                return vm.widget9.days[d];
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 'e',
                                classes: 'gravity-e'
                            }
                        }
                    }
                }
            },
            days        : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges      : vm.dashboardData.widget9.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget9.currentRange = range;

                /**
                 * Update mini charts. They only have 1 dataset
                 * so we can do [0] without needing to iterate
                 * through in their data arrays
                 */
                vm.widget9.weeklySpent.chartData[0] = {
                    key   : vm.dashboardData.widget9.weeklySpent.chart.label,
                    values: vm.dashboardData.widget9.weeklySpent.chart.values[range]
                };

                vm.widget9.totalSpent.chartData[0] = {
                    key   : vm.dashboardData.widget9.totalSpent.chart.label,
                    values: vm.dashboardData.widget9.totalSpent.chart.values[range]
                };

                vm.widget9.remaining.chartData[0] = {
                    key   : vm.dashboardData.widget9.remaining.chart.label,
                    values: vm.dashboardData.widget9.remaining.chart.values[range]
                };
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget9.changeRange('TW');
            }
        };

        // Widget 10
        vm.widget10 = vm.dashboardData.widget10;

        // Widget 11
        vm.widget11 = {
            title    : vm.dashboardData.widget11.title,
            table    : vm.dashboardData.widget11.table,
            dtOptions: {
                dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth : false,
                responsive: true,
                order     : [1, 'asc'],
                columnDefs: [
                    {
                        width    : '40',
                        orderable: false,
                        targets  : [0]
                    },
                    {
                        width  : '20%',
                        targets: [1, 2, 3, 4, 5]
                    }
                ]
            }
        };

        // Now widget
        vm.nowWidget = {
            now   : {
                second: '',
                minute: '',
                hour  : '',
                day   : '',
                month : '',
                year  : ''
            },
            ticker: function ()
            {
                var now = moment();
                vm.nowWidget.now = {
                    second : now.format('ss'),
                    minute : now.format('mm'),
                    hour   : now.format('h'),
                    day    : now.format('D'),
                    weekDay: now.format('dddd'),
                    month  : now.format('MMMM'),
                    year   : now.format('YYYY'),
                    ampm   : now.format('A')
                };
            }
        };

        // Google Maps
        vm.polylines = [];
        uiGmapGoogleMapApi.then(function ()
        {
            vm.widget2_analytics.map = vm.DashboardAnalyticsData.widget2.map;
            vm.polylines = [
              {
                  id: 1,
                  path: [
                      {
                          latitude: 45,
                          longitude: -74
                      },
                      {
                          latitude: 60,
                          longitude: -95
                      }
                  ],
                  stroke: {
                      color: '#6060FB',
                      weight: 3
                  },
                  editable: false,
                  draggable: true,
                  geodesic: true,
                  visible: true,
                  icons: [{
                      icon: {
                          path: google.maps.SymbolPath.BACKWARD_OPEN_ARROW
                      },
                      offset: '25px',
                      repeat: '50px'
                  }]
              },
              {
                  id: 2,
                  path: [
                      {
                          latitude: 32,
                          longitude: -89
                      },
                      {
                          latitude: 32.7338051,
                          longitude: -117.1954925
                      }
                  ],
                  stroke: {
                      color: '#6060FB',
                      weight: 3
                  },
                  editable: false,
                  draggable: true,
                  geodesic: true,
                  visible: true,
                  icons: [{
                      icon: {
                          path: google.maps.SymbolPath.BACKWARD_OPEN_ARROW
                      },
                      offset: '25px',
                      repeat: '50px'
                  }]
              },
              {
                  id: 3,
                  path: [
                      {
                          latitude: 39.8560963,
                          longitude: -104.6759263
                      },
                      {
                          latitude: 25.795865,
                          longitude: -80.2892397
                      }
                  ],
                  stroke: {
                      color: '#6060FB',
                      weight: 3
                  },
                  editable: false,
                  draggable: true,
                  geodesic: true,
                  visible: true,
                  icons: [{
                      icon: {
                          path: google.maps.SymbolPath.BACKWARD_OPEN_ARROW
                      },
                      offset: '25px',
                      repeat: '50px'
                  }]
              },
              {
                  id: 4,
                  path: [
                      {
                          latitude: 47.4502499,
                          longitude: -122.3110052
                      },
                      {
                          latitude: 29.6463365,
                          longitude: -95.2790236
                      }
                  ],
                  stroke: {
                      color: '#6060FB',
                      weight: 3
                  },
                  editable: false,
                  draggable: true,
                  geodesic: true,
                  visible: true,
                  icons: [{
                      icon: {
                          path: google.maps.SymbolPath.BACKWARD_OPEN_ARROW
                      },
                      offset: '25px',
                      repeat: '50px'
                  }]
              },
              {
                  id: 5,
                  path: [
                      {
                          latitude: 40.6413111,
                          longitude: -73.7803278
                      },
                      {
                          latitude: 33.9415889,
                          longitude: -118.4107187
                      }
                  ],
                  stroke: {
                      color: '#6060FB',
                      weight: 3
                  },
                  editable: false,
                  draggable: true,
                  geodesic: true,
                  visible: true,
                  icons: [{
                      icon: {
                          path: google.maps.SymbolPath.BACKWARD_OPEN_ARROW
                      },
                      offset: '25px',
                      repeat: '50px'
                  }]
              }
          ];
        });





        // Weather widget
        vm.weatherWidget = vm.dashboardData.weatherWidget;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.selectProject = selectProject;

        //////////
        vm.selectedProject = vm.projects[0];

        // Initialize Widget 5
        vm.widget5.init();

        // Initialize Widget 6
        vm.widget6.init();

        // Initialize Widget 9
        vm.widget9.init();

        // Now widget ticker
        vm.nowWidget.ticker();

        var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

        $scope.$on('$destroy', function ()
        {
            $interval.cancel(nowWidgetTicker);
        });

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Select project
         */
        function selectProject(project)
        {
            vm.selectedProject = project;
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.dashboards.analytics', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.dashboards_analytics', {
            url      : '/dashboard-analytics',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/analytics/dashboard-analytics.html',
                    controller : 'DashboardAnalyticsController as vm'
                }
            },
            resolve  : {
                DashboardData: function (msApi)
                {
                    return msApi.resolve('dashboard.analytics@get');
                }
            },
            bodyClass: 'dashboard-analytics'
        });

        // Api
        msApiProvider.register('dashboard.analytics', ['app/data/dashboard/analytics/data.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.analytics')
        .controller('DashboardAnalyticsController', DashboardAnalyticsController);

    /** @ngInject */
    function DashboardAnalyticsController(DashboardData, uiGmapGoogleMapApi)
    {
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];

        vm.widget1 = {
            title             : vm.dashboardData.widget1.title,
            onlineUsers       : vm.dashboardData.widget1.onlineUsers,
            bigChart          : {
                options: {
                    chart: {
                        type                   : 'lineWithFocusChart',
                        color                  : ['#2196F3'],
                        height                 : 400,
                        margin                 : {
                            top   : 32,
                            right : 32,
                            bottom: 64,
                            left  : 48
                        },
                        isArea                 : true,
                        useInteractiveGuideline: true,
                        duration               : 1,
                        clipEdge               : true,
                        clipVoronoi            : false,
                        interpolate            : 'cardinal',
                        showLegend             : false,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            showMaxMin: false,
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%b %d')(date);
                            }
                        },
                        yAxis                  : {
                            showMaxMin: false
                        },
                        x2Axis                 : {
                            showMaxMin: false,
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%b %d')(date);
                            }
                        },
                        y2Axis                 : {
                            showMaxMin: false
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        },
                        legend                 : {
                            margin    : {
                                top   : 8,
                                right : 0,
                                bottom: 32,
                                left  : 0
                            },
                            rightAlign: false
                        }
                    }
                },
                data   : vm.dashboardData.widget1.bigChart.chart
            },
            sessions          : {
                title   : vm.dashboardData.widget1.sessions.title,
                value   : vm.dashboardData.widget1.sessions.value,
                previous: vm.dashboardData.widget1.sessions.previous,
                options : {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#03A9F4'],
                        height                 : 40,
                        margin                 : {
                            top   : 4,
                            right : 4,
                            bottom: 4,
                            left  : 4
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data    : vm.dashboardData.widget1.sessions.chart
            },
            pageviews         : {
                title   : vm.dashboardData.widget1.pageviews.title,
                value   : vm.dashboardData.widget1.pageviews.value,
                previous: vm.dashboardData.widget1.pageviews.previous,
                options : {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#3F51B5'],
                        height                 : 40,
                        margin                 : {
                            top   : 4,
                            right : 4,
                            bottom: 4,
                            left  : 4
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data    : vm.dashboardData.widget1.pageviews.chart
            },
            pagesSessions     : {
                title   : vm.dashboardData.widget1.pagesSessions.title,
                value   : vm.dashboardData.widget1.pagesSessions.value,
                previous: vm.dashboardData.widget1.pagesSessions.previous,
                options : {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#E91E63'],
                        height                 : 40,
                        margin                 : {
                            top   : 4,
                            right : 4,
                            bottom: 4,
                            left  : 4
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data    : vm.dashboardData.widget1.pagesSessions.chart
            },
            avgSessionDuration: {
                title   : vm.dashboardData.widget1.avgSessionDuration.title,
                value   : vm.dashboardData.widget1.avgSessionDuration.value,
                previous: vm.dashboardData.widget1.avgSessionDuration.previous,
                options : {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#009688'],
                        height                 : 40,
                        margin                 : {
                            top   : 4,
                            right : 4,
                            bottom: 4,
                            left  : 4
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        yAxis                  : {
                            tickFormat: function (d)
                            {
                                var formatTime = d3.time.format('%M:%S');
                                return formatTime(new Date('2012', '0', '1', '0', '0', d));
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data    : vm.dashboardData.widget1.avgSessionDuration.chart
            }
        };

        // Widget 2
        vm.widget2 = {
            title: vm.dashboardData.widget2.title
        };

        // Widget 3
        vm.widget3 = {
            title       : vm.dashboardData.widget3.title,
            pages       : vm.dashboardData.widget3.pages,
            ranges      : vm.dashboardData.widget3.ranges,
            currentRange: vm.dashboardData.widget3.currentRange,
            changeRange : function (range)
            {
                vm.widget3.currentRange(range);
            }
        };

        // Widget 4
        vm.widget4 = vm.dashboardData.widget4;


        // Methods

        //////////

        // Widget 2
        uiGmapGoogleMapApi.then(function ()
        {
            vm.widget2.map = vm.dashboardData.widget2.map;
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.complaints')
        .factory("fieldsTemplateForms", fieldsTemplateForms);



    /** @ngInject */
    function fieldsTemplateForms() {
        var allCountries;
        var service = {
            addNewStructureField: addNewStructureField,
            saveFieldStructure: saveFieldStructure,
            toDTOStructureField: toDTOStructureField,
            tostructureFieldFromDTO: tostructureFieldFromDTO,
            cancelEditFieldStructure: cancelEditFieldStructure,
            removeFieldStructure: removeFieldStructure,
            hideFieldStructure: hideFieldStructure,
            showFieldStructure: showFieldStructure,
            formatUserGroups: formatUserGroups,
            DTOtoStructuredField: DTOtoStructuredField,
            findAndCheck: findAndCheck,
            editFieldStructure: editFieldStructure,
            closeOthers: closeOthers
        };
        var timeOptions = []
        for (var i = 0; i < 23; i++) {
            var hour;
            if (i > 9) {
                hour = i;
            } else {
                hour = '0' + i;
            }
            timeOptions.push({ value: hour + ':00', name: hour + ':00' });
            timeOptions.push({ value: hour + ':05', name: hour + ':05' });
            timeOptions.push({ value: hour + ':10', name: hour + ':10' });
            timeOptions.push({ value: hour + ':15', name: hour + ':15' });
            timeOptions.push({ value: hour + ':20', name: hour + ':20' });
            timeOptions.push({ value: hour + ':25', name: hour + ':25' });
            timeOptions.push({ value: hour + ':30', name: hour + ':30' });
            timeOptions.push({ value: hour + ':35', name: hour + ':35' });
            timeOptions.push({ value: hour + ':40', name: hour + ':40' });
            timeOptions.push({ value: hour + ':45', name: hour + ':45' });
            timeOptions.push({ value: hour + ':50', name: hour + ':50' });
            timeOptions.push({ value: hour + ':55', name: hour + ':55' });
        }

        function DTOtoStructuredField(complaintCanal) {
            if (complaintCanal) {
                complaintCanal.fields = complaintCanal.fields.map(x => {
                    if (x.key === 'complaint_type') {
                        if (x.templateOptions.options) {
                            x.templateOptions.options = x.templateOptions.options.map(y => {
                                if (complaintCanal.form_types && complaintCanal.form_types.find(z => z.complaint_type_id == y.value)) {
                                    y.users = complaintCanal.form_types.find(z => z.complaint_type_id == y.value).assigned_users;
                                }
                                return y;
                            })
                        }
                    }
                    return x;
                })
            }
            return complaintCanal;
        }



        function addNewStructureField(array) {
            array.push({
                className: "",
                key: "",
                name: "",
                type: "",
                templateOptions: {
                    label: "",
                    tooltip: "",
                    type: null,
                    disabled: false,
                    errorField: "",
                    placeholder: "",
                    required: false,
                    value: false,
                    options: [],
                    refreshURL: '',
                    datepickerOptions: [],
                    showWeeks: false,
                },
                extra: true,
                temporary: true,
                editing: true
            });
        }

        function saveFieldStructure(index, array) {

            array[index].temporary = false;
            array[index].editing = false;
        }

        function getHighestUnusedKeyIndex(array) {
            var indexes = [];
            for (var i = 0; i < array.length; i++) {
                if (array[i].key) {
                    var keyIndex = array[i].key.split('_').pop();
                    if (!isNaN(keyIndex)) {
                        indexes.push(parseInt(keyIndex))
                    }
                }
            }
            if (indexes.length === 0) return 0;
            var maxIndex = indexes.reduce(function(a, b) {
                return Math.max(a, b);
            });
            return maxIndex + 1;
        }

        function getDuplicateKeys(array) {
            var duplicates = [];
            var uniques = [];
            for (var i = 0; i < array.length; i++) {
                if (array[i].key) {
                    if (!uniques.includes(array[i].key)) {
                        uniques.push(array[i].key)
                    } else {
                        duplicates.push(array[i].key);
                    }
                }
            }
            return duplicates;
        }

        function toDTOStructureField(array, config) {
            var nextKeyIndex = getHighestUnusedKeyIndex(array);
            var duplicateKeys = getDuplicateKeys(array);
            if (array) {
                for (var i = 0; i < array.length; i++) {
                    if (array[i].type !== 'hidden') {
                        if (array[i].type === 'separator') {
                            array[i].name = array[i].className;
                            delete array[i].key;
                            delete array[i].validation;
                            delete array[i].validators;
                        } else {
                            array[i].className = array[i].templateOptions.label.toLowerCase().replace(/ /g, '_').replace(/[^a-zA-Z0-9 ]/g, '');
                            if ((!array[i].key || array[i].key.length == 0) ||
                                ( array[i].key && duplicateKeys.includes(array[i].key))
                            ) {
                                array[i].key = 'extra_' + array[i].className + '_' + nextKeyIndex;
                                nextKeyIndex++;
                            }
                            delete array[i].name;
                        }
                        if (array[i].type !== 'checkbox') {
                            delete array[i].templateOptions.value;
                        }
                        if (array[i].type == 'country') {
                            array[i].templateOptions.type = 'country';
                            array[i].templateOptions.options = allCountries; // countries
                            array[i].type = 'select';
                        }
                        if (array[i].type == 'time') {
                            array[i].templateOptions.type = 'time';
                            array[i].templateOptions.options = timeOptions;
                            array[i].type = 'select';
                        }
                        if (array[i].type !== 'datepicker') {
                            delete array[i].templateOptions.datepickerOptions;
                            delete array[i].templateOptions.showWeeks;
                        }
                        if (array[i].type == 'dropzone') {
                        if (!array[i].templateOptions.placeholder) {
                            if (config.currentLang.startsWith('en')) {
                                array[i].templateOptions.placeholder = 'Click or drag your files here.';
                            } else if (config.currentLang.startsWith('de')) {
                                array[i].templateOptions.placeholder = 'Klicken oder ziehen Sie Ihre Dateien hier';
                            } else if (config.currentLang.startsWith('it')) {
                                array[i].templateOptions.placeholder = 'Fate clic o trascinate qui i vostri file.';
                            } else if (config.currentLang.startsWith('fr')) {
                                array[i].templateOptions.placeholder = 'Cliquez ou faites glisser vos fichiers ici.';
                            } else if (config.currentLang.startsWith('ca')) {
                                array[i].templateOptions.placeholder = 'Feu clic o arrossegueu els vostres fitxers aquí.';
                            } else if (config.currentLang.startsWith('pt')) {
                                array[i].templateOptions.placeholder = 'Adicione os seus arquivos aqui';
                            } else {
                                array[i].templateOptions.placeholder = 'Click o arrastre sus archivos aquí.';
                            }
                        }
                        }
                        if (array[i].type !== 'multiCheckbox' && array[i].type !== 'input') {
                            delete array[i].templateOptions.type;
                        }
                        if (array[i].type !== 'multiCheckbox' || array[i].templateOptions.type == 'default') {
                            delete array[i].templateOptions.groupType;
                            delete array[i].templateOptions.status;
                        }
                        if (array[i].type == 'multiCheckbox' && array[i].templateOptions.type == 'users_group') {
                            array[i].key = 'group_' + array[i].key;
                        }
                        if (array[i].type !== 'select' && array[i].type !== 'select-search' && array[i].type !== 'single-suggest' && array[i].type !== 'multiCheckbox' && array[i].type !== 'radio' && array[i].type !== 'dropzone') {
                            delete array[i].templateOptions.options;
                        }
                        if (array[i].type == 'select') {
                            array[i].templateOptions.options = array[i].templateOptions.options.map(x => {
                                delete x.users;
                                return x;
                            })
                        }
                        if (array[i].type == 'checkbox') {
                            if (array[i].templateOptions.checkbox_policy) {
                                array[i].templateOptions.label = '<a target="_blank" href="' + array[i].templateOptions.policy_link + '">' + array[i].templateOptions.policy_label + '</a><p>' + array[i].templateOptions.policy + (array[i].templateOptions.required ? '' : '') + '</p>';
                                array[i].className = 'checkboxpolicy';
                                array[i].key = 'extra_checkboxpolicy';
                            }
                            if (array[i].templateOptions.checkbox_complaint) {
                                array[i].templateOptions.label = '<a target="_blank" href="' + array[i].templateOptions.complaint_link + '">' + array[i].templateOptions.complaint_label + '</a><p>' + (array[i].templateOptions.required ? '' : '') + '</p>';
                                array[i].className = 'checkboxcomplaint';
                                array[i].key = 'extra_checkboxcomplaint';
                                }
                            }
                        if (array[i].type !== 'single-suggest') {
                            delete array[i].templateOptions.funcQ;
                            delete array[i].templateOptions.funcHttp;
                            delete array[i].templateOptions.refreshURL;
                            delete array[i].templateOptions.refresh;
                            delete array[i].templateOptions.refreshDelay;
                            delete array[i].templateOptions.minimumInputLength;
                        } else {
                            array[i].templateOptions.refresh = "|| var promise; if (!param2) { promise = param1.funcQ.when({data: {results: []}}); } else { var params = {txt: param2, sensor: false}; var endpoint = " + array[i].templateOptions.refreshURL + "; promise = param1.funcHttp.get(endpoint, {params: params}); } return promise.then(function (response) { if (response.data.results.length == 1) { } param3.templateOptions.options = response.data.results; });"
                        }

                    }
                    delete array[i].editing;
                    delete array[i].temporary;
                    delete array[i].extra;
                    delete array[i].showAdvanced;
                }
            }
            return array;
        }

        function tostructureFieldFromDTO(array) {
            if (array) {
                for (var i = 0; i < array.length; i++) {
                    if (array[i].templateOptions.type == 'country') {
                        array[i].type = 'country';
                    }
                    if (array[i].templateOptions.type == 'time') {
                        array[i].type = 'time';
                    }
                }
            }
            return array;
        }

        function cancelEditFieldStructure(index, array, copyStructure) {
            if (array[index].temporary) {
                array.splice(index, 1);
            } else {
                array[index] = copyStructure; //var copyStructure;
                array[index].editing = false;
            }
        }

        function removeFieldStructure(index, array, noexistchangues) {
            if (noexistchangues !== null)
                noexistchangues = false;
            array.splice(index, 1);
        }
        function hideFieldStructure(index, array, noexistchangues) {
            if (noexistchangues !== null)
                noexistchangues = false;
            array[index].templateOptions.oldHideExpresion = array[index].hideExpression;
            array[index].hideExpression = "true";
        }
        function showFieldStructure(index, array, noexistchangues) {
            if (noexistchangues !== null)
                noexistchangues = false;
            array[index].hideExpression = array[index].templateOptions.oldHideExpresion;
            delete array[index].templateOptions.oldHideExpresion;
        }

        function editFieldStructure(index, array, copyStructure) {
            closeOthers();
            copyStructure = array[index];
            array[index].editing = true;
        }
        function formatUserGroups(userGroups) {
            var result = [];
            for (var i = 0; i < userGroups.length; i++) {
                const element = userGroups[i];
                result = result.concat(getElementsUserGroup(element));
            }
            return result;
        }


        function getElementsUserGroup(userGroup) {
            var result = [];
            var hasChildBoolean = (userGroup.children && userGroup.children.length > 0) ? true : false
            if (userGroup.checked) {
                var resultObj = {
                    value: userGroup.id_group.toString(),
                    name: userGroup.name,
                    disabled: userGroup.allow_users == 1 ? false : true,
                    hasChild: hasChildBoolean ? 1 : 0
                }
                if (userGroup.parent) {
                    resultObj.parent = userGroup.parent.toString();
                }
                result.push(resultObj);
            }
            if (hasChildBoolean) {
                for (var i = 0; i < userGroup.children.length; i++) {
                    const element = userGroup.children[i];
                    result = result.concat(getElementsUserGroup(element));
                }

            }
            return result;
        }

        function findAndCheck(array, arraySelected) {

            for (var i = 0; i < array.length; i++) {
                const element = array[i];
                if (arraySelected.indexOf(element.id_group) > -1) {
                    element.checked = true
                }
                if (element.children) {
                    array.children = findAndCheck(element.children, arraySelected);
                }
            }
            return array;
        }

        function closeOthers(array) {
            if (array) {
                for (var i = 0; i < array.length; i++) {
                    if (array[i].temporary) {
                        array.splice(i, 1);
                        i--;
                    } else {
                        saveFieldStructure(i, array);
                    }
                }
            }
        }

        return service;
    }
})();

(function () {
	'use strict';

	angular
		.module('app.complaints')
		.controller('ActionDialogController', ActionDialogController);

	/** @ngInject */
	function ActionDialogController($mdDialog, $scope, owner, complaint_id, $translate, Upload, complaintsService, tinyMceService, $timeout) {
		var vm = this;

		vm.closeDialog = closeDialog;
		vm.owner = owner;
		vm.complaint_id = complaint_id;
		vm.upload = upload;
		vm.createAction = createAction;
		vm.isLoading = false;
		vm.importError = false;
		vm.tinymceOptions = tinyMceService.getOptions($scope);
		vm.tinymceOptions.height = 250;
		vm.tinymceOptions.min_height = 250;
		vm.tinymceOptions.resize = false;
		vm.tinymceOptions.plugins = [];
		vm.tinymceOptions.toolbar1 = 'bold italic backcolor | alignleft aligncenter ' +
			'alignright alignjustify | bullist numlist outdent indent | ' +
			'removeformat | help';
		vm.translate = function (text) {
			return $translate.instant(text);
		}


		function createAction() {
			vm.isLoading = true;
			var options = {
				owner: vm.owner,
				item: {
					complaint_id: vm.complaint_id,
					action: vm.actionName
				}
			}
			complaintsService.createComplaintAction(options).then(function (response) {
				$mdDialog.hide({ update: true });
			});
		}


		$scope.$watch('vm.files', function () {
			$scope.formUpload = false;
			if (vm.files != null) {
				// make files array for not multiple to be able to be used in ng-repeat in the ui
				if (!angular.isArray(vm.files)) {
					$timeout(function () {
						$scope.files = vm.files = [vm.files];
					});
					return;
				}
				for (var i = 0; i < vm.files.length; i++) {
					$scope.errorMsg = null;
					(function (f) {
						vm.upload(f, true);
					})(vm.files[i]);
				}
			}
		});


		function upload(file) {
			if (!file.$error) {
				//				console.debug("UPLOAD______****", file)
				complaintsService.getS3UploadPreSignedUrl({
					owner: vm.owner,
					fileName: file.name
				})
					.then(function (resp) {
						vm.token = resp.token;
						file.upload = Upload.http({
							url: resp.url,
							skipAuthorization: true,
							method: 'PUT',
							headers: {
								"Content-Type": file.type != '' ? file.type : 'application/octet-stream'
							},
							data: file
						});

						file.upload.then(function (response) {
							file.result = response.data;
							$timeout(function () {
								$scope.log = 'file: ' +
									file.name +
									', Response: ' + JSON.stringify(response.data) +
									', ID: ' + file.id_media +
									'\n' + $scope.log;
							});

							complaintsService.finishedUploadingFile({
								owner: vm.owner,
								token: vm.token
							}).then(function (response) {
								console.log("test");
							})
						}, function (response) {
							if (response.status > 0)
								$scope.errorMsg = response.status + ': ' + response.data;
						});



						file.upload.progress(function (evt) {
							file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});

					})
			}
		};


		function closeDialog() {
			$mdDialog.hide();
		}
	}

})();

(function () {
    'use strict';

    angular
        .module('app.divisions', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider , msUtilProvider, msNavigationServiceProvider) {
        // State


        $stateProvider.state('app.divisions', {
            url: '/divisions',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/divisions/divisions.html',
                    controller: 'DivisionsController as vm'
                }
            },
            bodyClass: 'divisions'
        });

        $stateProvider
            .state('app.site_overview.divisions', {
                abstract: true,
                url: '/divisions',
                onEnter: function ($stateParams) {


                },
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                    section: function ($stateParams) {             
                        return $stateParams.owner
                    },
                },


            })
            .state('app.site_overview.divisions.list', {
                url: '',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/divisions/divisions.html',
                        controller: 'DivisionsController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.divisions.list.thread', {
                url: '/:id',
                bodyClass: 'divisions'
            })
        // Translation
        var base = 'app/main/apps/divisions';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.divisions')
        .factory("transformDivision", transformDivision);



    /** @ngInject */
    function transformDivision() {

        var service = {
            duplicateDivision: duplicateDivision,
            checkFields: checkFields
            
        };

        function duplicateDivision(division) {
            var copy = {
                name: division.name + ' (1)',
            };
            return copy;
        }

        function checkFields(division) {
            if(division.name)
                return false;
            return true;
        }


        return service;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients-complaints')
        .factory("transformClients", transformClients);


    /** @ngInject */
    function transformClients() {

        var colors = ['md-blue-300-bg', 'md-blue-grey-300-bg', 'md-orange-300-bg', 'md-pink-300-bg', 'md-purple-300-bg', 'md-red-300-bg', 'md-yellow-300-bg', 'md-light-blue-300-bg'];
        var service = {
            getValueFromField: getValueFromField,
            getUserType: getUserType,
            companyToDTO: companyToDTO,
            createBranch: createBranch,
            companyToForm: companyToForm,
            branchToForm: branchToForm,
            getIdBranch: getIdBranch,
            branchesToForm: branchesToForm,
            clientToDTO: clientToDTO,
            userToDTO: userToDTO,
            addIdToForm: addIdToForm,
            addFieldToForm: addFieldToForm,
            getIdFromForm: getIdFromForm,
            updateFullName: updateFullName,
            setFullName: setFullName,
            getAnswer: getAnswer
        };

        function getAnswer(questions) {
            var result = [];
            for (var i = 0; i < questions.length; i++) {
                if (questions[i].value === 'yes') {
                    result.push(questions[i].id);
                }
            }
            return result;
        }

        function setFullName(subForm) {
            var name;
            var surnames;
            for (var i = 0; i < subForm.length; i++) {
                if (subForm[i].field === 'name') {
                    var name = subForm[i].value;

                }
                if (subForm[i].field === 'surnames') {
                    var surnames = subForm[i].value;
                }
            }
            var fullName = name + ' ' + surnames;
            subForm.unshift({ field: 'fullName', value: fullName });
        }

        function updateFullName(subForm) {
            var name;
            var surnames;
            for (var i = 0; i < subForm.length; i++) {
                if (subForm[i].field === 'name') {
                    var name = subForm[i].value;
                }
                if (subForm[i].field === 'surnames') {
                    var surnames = subForm[i].value;
                }
            }
            var fullName = name + ' ' + surnames;
            for (var i = 0; i < subForm.length; i++) {
                if (subForm[i].field === 'fullName') {
                    subForm[i].value = fullName;
                }
            }
        }

        function addIdToForm(subForm, id) {
            subForm.push({ field: 'id', value: id });
        }

        function addFieldToForm(subForm, title, val) {
            subForm.push({ field: title, value: val });
        }

        function userToDTO(subForm, type) {
            var userData = {};
            angular.forEach(subForm, function (field) {
                userData[field.field] = field.value;
            })
            if (!userData.profile_color) {
                userData.profile_color = colors[Math.floor(Math.random() * colors.length)]
            }
            return userData;
        }

        function clientToDTO(form, idCompany) {
            return {
                name: form.name,
                company_id: idCompany,
                country_id: 209,
                language_id: 1
            };
        }

        function getIdBranch(branch) {
            for (var i = 0; i < branch.length; i++) {
                if (branch[i].field == 'id') {
                    return branch[i].value;
                }
            }
            return false;
        }

        function branchesToForm(fields, branches, formWizard, arrayBranches) {
            var result = [];
            for (var i = 0; i < branches.length; i++) {
                if (branches[i].is_main) {
                    mainBranchToForm(formWizard, branches[i]);
                }
                else {
                    result.push(branchToForm(fields, branches[i]));
                }
                arrayBranches.push({ id: branches[i].id, name: branches[i].name });
            }
            return result;
        }

        function mainBranchToForm(formWizard, branch) {
            formWizard.main_branch = {};
            formWizard.main_branch.name = branch.name;
            formWizard.main_branch.address1 = branch.address1;
            formWizard.main_branch.email = branch.email;
            formWizard.main_branch.postcode = branch.postcode;
            formWizard.main_branch.state = branch.state;
            formWizard.main_branch.city = branch.city;
            formWizard.main_branch.phone = branch.phone;
            formWizard.main_branch.id = branch.id;
        }


        function branchToForm(fields, branch) {
            var array = [];
            var result = angular.copy(fields);
            for (var i = 0; i < result.length; i++) {
                switch (result[i].field) {
                    case 'name':
                        if (branch.name) {
                            result[i].value = branch.name;
                        }
                        break;
                    case 'email':
                        if (branch.email) {
                            result[i].value = branch.email;
                        }
                        break;
                    case 'phone':
                        if (branch.phone) {
                            result[i].value = parseInt(branch.phone);
                        }
                        break;
                    case 'address':
                        if (branch.address1) {
                            result[i].value = branch.address1;
                        }
                        break;
                    case 'city':
                        if (branch.city) {
                            result[i].value = branch.city;
                        }
                        break;
                    case 'state':
                        if (branch.state) {
                            result[i].value = branch.state;
                        }
                        break;
                    case 'postcode':
                        if (branch.postcode) {
                            result[i].value = parseInt(branch.postcode);
                        }
                        break;
                }
            }
            result.push({ field: 'id', value: branch.id });
            return result;

        }

        function companyToForm(company) {
            return {
                name: company.name,
                description: company.description,
                tax_id_type: company.tax_id_type,
                tax_id_number: company.tax_id_number,
                sector_id: company.sector_id,
                employee_count: company.employee_count,
                gain_loss_model_id: company.gain_loss_model_id,
                turnover_volume: company.turnover_volume,
                extra_data: JSON.parse(company.extra_data)
            }
        }

        function createBranch(subForm, company_id, isMain, region) {
            if (!isMain) {
                isMain = false;
            }
            var item = {
                country_id: 209,
                is_main: isMain,
                company_id: company_id
            };

            item.name = subForm.name;
            item.email = subForm.email;
            item.phone = String(subForm.phone);
            item.address1 = subForm.address1;
            item.state = subForm.state;
            item.city = subForm.city;
            item.region_id = region;
            item.postcode = String(subForm.postcode);
            return item;
        }

        function getIdFromForm(form) {
            return getValueFromField(form, 'id');
        }

        function getValueFromField(form, field) {
            for (var j = 0; j < form.length; j++) {
                if (form[j].field === field) {
                    return form[j].value;
                }
            }
        }

        function getUserType(type) {
            // TODO sacar esto de BBDD 
            if (type === 'administrator') {
                return 1;
            }
            else if (type === 'managerLegal') {
                return 2;
            }
            else if (type === 'compliance') {
                return 3;
            }
            else if (type === 'report') {
                return 4;
            }
        }

        function companyToDTO(form) {
            if (!form.company.extra_data) {
                form.company.extra_data = {};
            }
            return {
                name: form.company.name,
                sector_id: parseInt(form.company.sector_id),
                logo: form.company.logo,
                //gain_loss_model_id: parseInt(form.company.pgModel), TODO BACKEND
                region_id: form.company.region_id ? form.company.region_id : 1,
                employee_count: form.company.employee_count,
                description: form.company.description,
                turnover_volume: parseInt(form.company.turnover_volume),
                turnover_volume_currency_id: 1,
                tax_id_type: form.company.tax_id_type,
                tax_id_number: form.company.tax_id_number,
                extra_data: JSON.stringify(form.company.extra_data)
                //fulfillment_committee_document: form.company.fulfillment_committee_document,
                //complaints_committee_document: form.complaints_committee_document
            };
        }


        return service;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .factory("transformClients", transformClients);


    /** @ngInject */
    function transformClients() {

        var colors = ['md-blue-300-bg', 'md-blue-grey-300-bg', 'md-orange-300-bg', 'md-pink-300-bg', 'md-purple-300-bg', 'md-red-300-bg', 'md-yellow-300-bg', 'md-light-blue-300-bg'];
        var service = {
            getValueFromField: getValueFromField,
            getUserType: getUserType,
            companyToDTO: companyToDTO,
            createBranch: createBranch,
            companyToForm: companyToForm,
            branchToForm: branchToForm,
            getIdBranch: getIdBranch,
            branchesToForm: branchesToForm,
            clientToDTO: clientToDTO,
            userToDTO: userToDTO,
            addIdToForm: addIdToForm,
            addFieldToForm: addFieldToForm,
            getIdFromForm: getIdFromForm,
            updateFullName: updateFullName,
            setFullName: setFullName,
            getAnswer: getAnswer
        };

        function getAnswer(questions) {
            var result = [];
            for (var i = 0; i < questions.length; i++) {
                if (questions[i].value === 'yes') {
                    result.push(questions[i].id);
                }
            }
            return result;
        }

        function setFullName(subForm) {
            var name;
            var surnames;
            for (var i = 0; i < subForm.length; i++) {
                if (subForm[i].field === 'name') {
                    var name = subForm[i].value;

                }
                if (subForm[i].field === 'surnames') {
                    var surnames = subForm[i].value;
                }
            }
            var fullName = name + ' ' + surnames;
            subForm.unshift({ field: 'fullName', value: fullName });
        }

        function updateFullName(subForm) {
            var name;
            var surnames;
            for (var i = 0; i < subForm.length; i++) {
                if (subForm[i].field === 'name') {
                    var name = subForm[i].value;
                }
                if (subForm[i].field === 'surnames') {
                    var surnames = subForm[i].value;
                }
            }
            var fullName = name + ' ' + surnames;
            for (var i = 0; i < subForm.length; i++) {
                if (subForm[i].field === 'fullName') {
                    subForm[i].value = fullName;
                }
            }
        }

        function addIdToForm(subForm, id) {
            subForm.push({ field: 'id', value: id });
        }

        function addFieldToForm(subForm, title, val) {
            subForm.push({ field: title, value: val });
        }

        function userToDTO(subForm, type) {
            var userData = {};
            angular.forEach(subForm, function (field) {
                userData[field.field] = field.value;
            })
            if (!userData.profile_color) {
                userData.profile_color = colors[Math.floor(Math.random() * colors.length)]
            }
            return userData;
        }

        function clientToDTO(form, idCompany) {
            return {
                name: form.name,
                company_id: idCompany,
                country_id: 209,
                language_id: 1
            };
        }

        function getIdBranch(branch) {
            for (var i = 0; i < branch.length; i++) {
                if (branch[i].field == 'id') {
                    return branch[i].value;
                }
            }
            return false;
        }

        function branchesToForm(fields, branches, formWizard, arrayBranches) {
            var result = [];
            for (var i = 0; i < branches.length; i++) {
                if (branches[i].is_main) {
                    mainBranchToForm(formWizard, branches[i]);
                }
                else {
                    result.push(branchToForm(fields, branches[i]));
                }
                arrayBranches.push({ id: branches[i].id, name: branches[i].name });
            }
            return result;
        }

        function mainBranchToForm(formWizard, branch) {
            formWizard.main_branch = {};
            formWizard.main_branch.name = branch.name;
            formWizard.main_branch.address1 = branch.address1;
            formWizard.main_branch.email = branch.email;
            formWizard.main_branch.postcode = branch.postcode;
            formWizard.main_branch.state = branch.state;
            formWizard.main_branch.city = branch.city;
            formWizard.main_branch.phone = branch.phone;
            formWizard.main_branch.id = branch.id;
        }


        function branchToForm(fields, branch) {
            var array = [];
            var result = angular.copy(fields);
            for (var i = 0; i < result.length; i++) {
                switch (result[i].field) {
                    case 'name':
                        if (branch.name) {
                            result[i].value = branch.name;
                        }
                        break;
                    case 'email':
                        if (branch.email) {
                            result[i].value = branch.email;
                        }
                        break;
                    case 'phone':
                        if (branch.phone) {
                            result[i].value = parseInt(branch.phone);
                        }
                        break;
                    case 'address':
                        if (branch.address1) {
                            result[i].value = branch.address1;
                        }
                        break;
                    case 'city':
                        if (branch.city) {
                            result[i].value = branch.city;
                        }
                        break;
                    case 'state':
                        if (branch.state) {
                            result[i].value = branch.state;
                        }
                        break;
                    case 'postcode':
                        if (branch.postcode) {
                            result[i].value = parseInt(branch.postcode);
                        }
                        break;
                }
            }
            result.push({ field: 'id', value: branch.id });
            return result;

        }

        function companyToForm(company) {
            return {
                name: company.name,
                description: company.description,
                tax_id_type: company.tax_id_type,
                tax_id_number: company.tax_id_number,
                sector_id: company.sector_id,
                employee_count: company.employee_count,
                gain_loss_model_id: company.gain_loss_model_id,
                turnover_volume: company.turnover_volume,
                extra_data: JSON.parse(company.extra_data)
            }
        }

        function createBranch(subForm, company_id, isMain, region) {
            if (!isMain) {
                isMain = false;
            }
            var item = {
                country_id: 209,
                is_main: isMain,
                company_id: company_id
            };

            item.name = subForm.name;
            item.email = subForm.email;
            item.phone = String(subForm.phone);
            item.address1 = subForm.address1;
            item.state = subForm.state;
            item.city = subForm.city;
            item.region_id = region;
            item.postcode = String(subForm.postcode);
            return item;
        }

        function getIdFromForm(form) {
            return getValueFromField(form, 'id');
        }

        function getValueFromField(form, field) {
            for (var j = 0; j < form.length; j++) {
                if (form[j].field === field) {
                    return form[j].value;
                }
            }
        }

        function getUserType(type) {
            // TODO sacar esto de BBDD 
            if (type === 'administrator') {
                return 1;
            }
            else if (type === 'managerLegal') {
                return 2;
            }
            else if (type === 'compliance') {
                return 3;
            }
            else if (type === 'report') {
                return 4;
            }
        }

        function companyToDTO(form) {
            if (!form.company.extra_data) {
                form.company.extra_data = {};
            }
            return {
                name: form.company.name,
                sector_id: parseInt(form.company.sector_id),
                logo: form.company.logo,
                //gain_loss_model_id: parseInt(form.company.pgModel), TODO BACKEND
                region_id: form.company.region_id ? form.company.region_id : 1,
                employee_count: form.company.employee_count,
                description: form.company.description,
                turnover_volume: parseInt(form.company.turnover_volume),
                turnover_volume_currency_id: 1,
                tax_id_type: form.company.tax_id_type,
                tax_id_number: form.company.tax_id_number,
                extra_data: JSON.stringify(form.company.extra_data)
                //fulfillment_committee_document: form.company.fulfillment_committee_document,
                //complaints_committee_document: form.complaints_committee_document
            };
        }


        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.components.tables.simple-table', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        $stateProvider.state('app.components_tables_simple-table', {
            url  : '/components/table/simple-table',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/tables/simple-table/simple-table.html',
                    controller : 'SimpleTableController as vm'
                }
            },
            resolve: {
                Employees: function (msApi)
                {
                    return msApi.resolve('tables.employees@get');
                }
            }
        });

        // Api
        msApiProvider.register('tables.employees', ['app/data/tables/employees.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.tables.simple-table')
        .controller('SimpleTableController', SimpleTableController);

    /** @ngInject */
    function SimpleTableController(Employees)
    {
        var vm = this;

        // Data
        vm.employees = Employees.data;

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.tables.datatable', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        $stateProvider.state('app.components_tables_datatable', {
            url    : '/components/table/datatable',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/components/tables/datatable/datatable.html',
                    controller : 'DatatableController as vm'
                }
            },
            resolve: {
                Employees: function (msApi)
                {
                    return msApi.resolve('tables.employees100@get');
                }
            }
        });

        // Api
        msApiProvider.register('tables.employees100', ['app/data/tables/employees100.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.tables.datatable')
        .controller('DatatableController', DatatableController);

    /** @ngInject */
    function DatatableController(Employees)
    {
        var vm = this;

        // Data
        vm.employees = Employees.data;

        vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    /**
     * Replace those for demo assets
     * img/                     >>>            assets/angular-material-assets/img/
     * 'icons                   >>>            'assets/angular-material-assets/icons/
     */
    angular
        .module('app.components.material-docs', ['ngMaterial', 'ngMessages'])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider, $stateProvider, ELEMENTS_NAVIGATION, LAYOUT_NAVIGATION)
    {
        msNavigationServiceProvider.saveItem('components.elements', {
            title : 'Angular Material Elements',
            icon  : 'icon-layers',
            weight: 0
        });

        msNavigationServiceProvider.saveItem('components.elements.inputs', {
            title : 'Inputs',
            weight: 0
        });

        msNavigationServiceProvider.saveItem('components.elements.buttons', {
            title : 'Buttons',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('components.elements.content-elements', {
            title : 'Content Elements',
            weight: 2
        });

        msNavigationServiceProvider.saveItem('components.elements.lists', {
            title : 'Lists',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('components.elements.menus', {
            title : 'Menus',
            weight: 4
        });

        msNavigationServiceProvider.saveItem('components.elements.progress', {
            title : 'Progress',
            weight: 5
        });

        msNavigationServiceProvider.saveItem('components.elements.others', {
            title : 'Others',
            weight: 6
        });

        msNavigationServiceProvider.saveItem('components.material_layout', {
            title : 'Angular Material Layout',
            icon  : 'icon-view-quilt',
            weight: 1
        });


        angular.forEach(ELEMENTS_NAVIGATION, function (component)
        {

            $stateProvider.state('app.docs_' + component.stateName, {
                url  : '/components/angular-material-elements/' + component.url,
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/material-docs/material-doc-template.html',
                        controller : 'DocTemplateController as vm'
                    }
                },
                data : component
            });

            // Navigation
            msNavigationServiceProvider.saveItem(component.navPath + '.' + component.url, {
                title : component.name,
                state : 'app.docs_' + component.stateName,
                weight: component.weight
            });
        });

        angular.forEach(LAYOUT_NAVIGATION, function (component)
        {

            $stateProvider.state('app.docs_' + component.stateName, {
                url  : '/components/angular-material-elements/' + component.url,
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/material-docs/layout/layout-template.html',
                        controller : 'LayoutTemplateController as vm',
                    },
                },
                data : component
            });

            // Navigation
            msNavigationServiceProvider.saveItem('components.material_layout.' + component.url, {
                title : component.name,
                state : 'app.docs_' + component.stateName,
                weight: component.weight
            });
        });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.components.material-docs')
        .controller('LayoutCtrl', LayoutCtrl)
        .controller('LayoutTipsCtrl', LayoutTipsCtrl);

    /** @ngInject */
    function LayoutCtrl($scope, $attrs, $location, $rootScope)
    {
        $rootScope.currentComponent = $rootScope.currentDoc = null;

        $scope.exampleNotEditable = true;
        $scope.layoutDemo = {
            mainAxis : 'center',
            crossAxis: 'center',
            direction: 'row'
        };
        $scope.layoutAlign = function ()
        {
            return $scope.layoutDemo.mainAxis +
                   ($scope.layoutDemo.crossAxis ? ' ' + $scope.layoutDemo.crossAxis : '');
        };
    }

    /** @ngInject */
    function LayoutTipsCtrl()
    {
        var self = this;

        /*
         * Flex Sizing - Odd
         */
        self.toggleButtonText = 'Hide';

        self.toggleContentSize = function ()
        {
            var contentEl = angular.element(document.getElementById('toHide'));

            contentEl.toggleClass('ng-hide');

            self.toggleButtonText = contentEl.hasClass('ng-hide') ? 'Show' : 'Hide';
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.material-docs')
        .controller('LayoutTemplateController', LayoutTemplateController);

    /** @ngInject */
    function LayoutTemplateController($state)
    {
        var vm = this;
        vm.materialVersion = '1.0.8';
        vm.component = $state.current.data;
    }

})();
angular.module('app.components.material-docs')
    .constant('LAYOUT_NAVIGATION', [
        {
            name       : 'Introduction',
            stateName  : 'material_components_layout_introduction',
            id         : 'layoutIntro',
            url        : 'layout/introduction',
            templateUrl: 'layout-introduction',
            weight     : 1
        },
        {
            name       : 'Layout Containers',
            stateName  : 'material_components_layout_containers',
            id         : 'layoutContainers',
            url        : 'layout/container',
            templateUrl: 'layout-container',
            weight     : 2
        },
        {
            name       : 'Layout Children',
            stateName  : 'material_components_layout_grid',
            id         : 'layoutGrid',
            url        : 'layout/children',
            templateUrl: 'layout-children',
            weight     : 3
        },
        {
            name       : 'Child Alignment',
            stateName  : 'material_components_layout_align',
            id         : 'layoutAlign',
            url        : 'layout/alignment',
            templateUrl: 'layout-alignment',
            weight     : 4
        },
        {
            name       : 'Extra Options',
            stateName  : 'material_components_layout_options',
            id         : 'layoutOptions',
            url        : 'layout/options',
            templateUrl: 'layout-options',
            weight     : 5
        },
        {
            name       : 'Troubleshooting',
            stateName  : 'material_components_layout_tips',
            id         : 'layoutTips',
            url        : 'layout/tips',
            templateUrl: 'layout-tips',
            weight     : 6
        }
    ]);
(function ()
{
    'use strict';

    angular
        .module('app.components.material-docs')
        .constant('ELEMENTS_NAVIGATION', [
            /* INPUTS */
            {
                name      : 'Autocomplete',
                url       : 'autocomplete',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.autocomplete',
                stateName : 'material_components_autocomplete',
                weight    : 1
            },
            {
                name      : 'Checkbox',
                url       : 'checkbox',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.checkbox',
                stateName : 'material_components_checkbox',
                weight    : 2
            },
            {
                name      : 'Chips',
                url       : 'chips',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.chips',
                stateName : 'material_components_chips',
                weight    : 3
            },
            {
                name      : 'Date Picker',
                url       : 'date-picker',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.datepicker',
                stateName : 'material_components_datepicker',
                weight    : 4
            },
            {
                name      : 'Input',
                url       : 'input',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.input',
                stateName : 'material_components_input',
                weight    : 5
            },
            {
                name      : 'Radio Button',
                url       : 'radio-button',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.radioButton',
                stateName : 'material_components_radioButton',
                weight    : 6
            },
            {
                name      : 'Select',
                url       : 'select',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.select',
                stateName : 'material_components_select',
                weight    : 7
            },
            {
                name      : 'Slider',
                url       : 'slider',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.slider',
                stateName : 'material_components_slider',
                weight    : 8
            },
            {
                name      : 'Switch',
                url       : 'switch',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.switch',
                stateName : 'material_components_switch',
                weight    : 9
            },
            /* BUTTONS */
            {
                name      : 'Button',
                url       : 'button',
                navPath   : 'components.elements.buttons',
                moduleName: 'material.components.button',
                stateName : 'material_components_button',
                weight    : 1
            },
            {
                name      : 'Fab Actions',
                url       : 'fab-actions',
                navPath   : 'components.elements.buttons',
                moduleName: 'material.components.fabActions',
                stateName : 'material_components_fabActions',
                weight    : 2
            },
            {
                name      : 'Fab Speed Dial',
                url       : 'fab-speed-dial',
                navPath   : 'components.elements.buttons',
                moduleName: 'material.components.fabSpeedDial',
                stateName : 'material_components_fabSpeedDial',
                weight    : 3
            },
            {
                name      : 'Fab Toolbar',
                url       : 'fab-toolbar',
                navPath   : 'components.elements.buttons',
                moduleName: 'material.components.fabToolbar',
                stateName : 'material_components_fabToolbar',
                weight    : 4
            },
            /* CONTENT ELEMENTS */
            {
                name      : 'Bottom Sheet',
                url       : 'bottom-sheet',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.bottomSheet',
                stateName : 'material_components_bottomSheet',
                weight    : 1
            },
            {
                name      : 'Card',
                url       : 'card',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.card',
                stateName : 'material_components_card',
                weight    : 2
            },
            {
                name      : 'Content',
                url       : 'content',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.content',
                stateName : 'material_components_content',
                weight    : 3
            },
            {
                name      : 'Dialog',
                url       : 'dialog',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.dialog',
                stateName : 'material_components_dialog',
                weight    : 4
            },
            {
                name       : 'Icon',
                url        : 'icon',
                navPath    : 'components.elements.content-elements',
                moduleName : 'material.components.icon',
                stateName  : 'material_components_icon',
                excludeDemo: true,
                weight     : 5
            },
         /*   {
                name      : 'Navbar',
                url       : 'navbar',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.navBar',
                stateName : 'material_components_navBar',
                weight    : 6
            },*/
            {
                name      : 'Panel',
                url       : 'panel',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.panel',
                stateName : 'material_components_panel',
                weight    : 7
            },
            {
                name      : 'Sidenav',
                url       : 'sidenav',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.sidenav',
                stateName : 'material_components_sidenav',
                weight    : 8
            },
            {
                name      : 'Subheader',
                url       : 'subheader',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.subheader',
                stateName : 'material_components_subheader',
                weight    : 9
            },
            {
                name      : 'Tabs',
                url       : 'tabs',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.tabs',
                stateName : 'material_components_tabs',
                weight    : 10
            },
            {
                name      : 'Toast',
                url       : 'toast',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.toast',
                stateName : 'material_components_toast',
                weight    : 11
            },
            {
                name      : 'Toolbar',
                url       : 'toolbar',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.toolbar',
                stateName : 'material_components_toolbar',
                weight    : 12
            },
            {
                name      : 'Tooltip',
                url       : 'tooltip',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.tooltip',
                stateName : 'material_components_tooltip',
                weight    : 13
            },
            {
                name      : 'Whiteframe',
                url       : 'whiteframe',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.whiteframe',
                stateName : 'material_components_whiteframe',
                weight    : 14
            },
            /* LISTS */
            {
                name      : 'Grid List',
                url       : 'grid-list',
                navPath   : 'components.elements.lists',
                moduleName: 'material.components.gridList',
                stateName : 'material_components_gridList',
                weight    : 1
            },
            {
                name      : 'List',
                url       : 'list',
                navPath   : 'components.elements.lists',
                moduleName: 'material.components.list',
                stateName : 'material_components_list',
                weight    : 2
            },
            /* MENUS */
            {
                name      : 'Menu',
                url       : 'menu',
                navPath   : 'components.elements.menus',
                moduleName: 'material.components.menu',
                stateName : 'material_components_menu',
                weight    : 1
            },
            {
                name      : 'Menu Bar',
                url       : 'menu-bar',
                navPath   : 'components.elements.menus',
                moduleName: 'material.components.menuBar',
                stateName : 'material_components_menu-bar',
                weight    : 2
            },
            /* PROGRESS */
            {
                name      : 'Progress Circular',
                url       : 'progress-circular',
                navPath   : 'components.elements.progress',
                moduleName: 'material.components.progressCircular',
                stateName : 'material_components_progressCircular',
                weight    : 1
            },
            {
                name      : 'Progress Linear',
                url       : 'progress-linear',
                navPath   : 'components.elements.progress',
                moduleName: 'material.components.progressLinear',
                stateName : 'material_components_progressLinear',
                weight    : 2
            },
            /* OTHERS */
           /* {
                name      : 'Colors',
                url       : 'colors',
                navPath   : 'components.elements.others',
                moduleName: 'material.components.colors',
                stateName : 'material_components_colors',
                weight    : 1
            },*/
            {
                name      : 'Divider',
                url       : 'divider',
                navPath   : 'components.elements.others',
                moduleName: 'material.components.divider',
                stateName : 'material_components_divider',
                weight    : 2
            },
            {
                name      : 'Ripple',
                url       : 'ripple',
                navPath   : 'components.elements.others',
                moduleName: 'material.core.ripple',
                stateName : 'material_core_ripple',
                weight    : 3
            },
            {
                name      : 'Sticky',
                url       : 'sticky',
                navPath   : 'components.elements.others',
                moduleName: 'material.components.sticky',
                stateName : 'material_components_sticky',
                weight    : 4
            },
            {
                name      : 'Swipe',
                url       : 'swipe',
                navPath   : 'components.elements.others',
                moduleName: 'material.components.swipe',
                stateName : 'material_components_swipe',
                weight    : 5
            },
            {
                name      : 'Util',
                url       : 'util',
                navPath   : 'components.elements.others',
                moduleName: 'material.core.util',
                stateName : 'material_core_util',
                weight    : 6
            },
            {
                name      : 'Virtual Repeat',
                url       : 'virtual-repeat',
                navPath   : 'components.elements.others',
                moduleName: 'material.components.virtualRepeat',
                stateName : 'material_components_virtualRepeat',
                weight    : 7
            }
        ]);
})();
angular.module('app.components.material-docs')
    .constant('DEMOS', [
        {
            'name'      : 'autocomplete',
            'moduleName': 'material.components.autocomplete',
            'label'     : 'Autocomplete',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'autocompleteDemo',
                        'module'      : 'autocompleteDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'autocompletedemoBasicUsage',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/autocomplete/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.autocomplete',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/autocomplete/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'autocompleteCustomTemplateDemo',
                        'module'      : 'autocompleteCustomTemplateDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'autocompletedemoCustomTemplate',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/autocomplete/demoCustomTemplate/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/autocomplete/demoCustomTemplate/script.js'
                        }
                    ],
                    'moduleName': 'material.components.autocomplete',
                    'name'      : 'demoCustomTemplate',
                    'label'     : 'Custom Template',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/autocomplete/demoCustomTemplate/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'autocompleteFloatingLabelDemo',
                        'module'      : 'autocompleteFloatingLabelDemo',
                        'dependencies': [
                            'ngMaterial',
                            'ngMessages'
                        ]
                    },
                    'id'        : 'autocompletedemoFloatingLabel',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/autocomplete/demoFloatingLabel/script.js'
                        }
                    ],
                    'moduleName': 'material.components.autocomplete',
                    'name'      : 'demoFloatingLabel',
                    'label'     : 'Floating Label',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/autocomplete/demoFloatingLabel/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'autocompleteDemoInsideDialog',
                        'module'      : 'autocompleteDemoInsideDialog',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'autocompletedemoInsideDialog',
                    'css'       : [],
                    'html'      : [
                        {
                            'name'      : 'dialog.tmpl.html',
                            'label'     : 'dialog.tmpl.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/autocomplete/demoInsideDialog/dialog.tmpl.html'
                        }
                    ],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/autocomplete/demoInsideDialog/script.js'
                        }
                    ],
                    'moduleName': 'material.components.autocomplete',
                    'name'      : 'demoInsideDialog',
                    'label'     : 'Inside Dialog',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/autocomplete/demoInsideDialog/index.html'
                    }
                }
            ],
            'url'       : 'demo/autocomplete'
        },
        {
            'name'      : 'bottomSheet',
            'moduleName': 'material.components.bottomSheet',
            'label'     : 'Bottom Sheet',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'bottomSheetDemo1',
                        'module'      : 'bottomSheetDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'bottomSheetdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/bottomSheet/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [
                        {
                            'name'      : 'bottom-sheet-grid-template.html',
                            'label'     : 'bottom-sheet-grid-template.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/bottomSheet/demoBasicUsage/bottom-sheet-grid-template.html'
                        },
                        {
                            'name'      : 'bottom-sheet-list-template.html',
                            'label'     : 'bottom-sheet-list-template.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/bottomSheet/demoBasicUsage/bottom-sheet-list-template.html'
                        },
                        {
                            'name'      : 'readme.html',
                            'label'     : 'readme.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/bottomSheet/demoBasicUsage/readme.html'
                        }
                    ],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/bottomSheet/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.bottomSheet',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/bottomSheet/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/bottomSheet'
        },
        {
            'name'      : 'button',
            'moduleName': 'material.components.button',
            'label'     : 'Button',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'buttonsDemo1',
                        'module'      : 'buttonsDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'buttondemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/button/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/button/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.button',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/button/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/button'
        },
        {
            'name'      : 'card',
            'moduleName': 'material.components.card',
            'label'     : 'Card',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'cardDemo1',
                        'module'      : 'cardDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'carddemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/card/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/card/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.card',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/card/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'cardDemo2',
                        'module'      : 'cardDemo2',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'carddemoCardActionButtons',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/card/demoCardActionButtons/script.js'
                        }
                    ],
                    'moduleName': 'material.components.card',
                    'name'      : 'demoCardActionButtons',
                    'label'     : 'Card Action Buttons',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/card/demoCardActionButtons/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'cardDemo3',
                        'module'      : 'cardDemo3',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'carddemoInCardActions',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/card/demoInCardActions/script.js'
                        }
                    ],
                    'moduleName': 'material.components.card',
                    'name'      : 'demoInCardActions',
                    'label'     : 'In Card Actions',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/card/demoInCardActions/index.html'
                    }
                }
            ],
            'url'       : 'demo/card'
        },
        {
            'name'      : 'checkbox',
            'moduleName': 'material.components.checkbox',
            'label'     : 'Checkbox',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'checkboxDemo1',
                        'module'      : 'checkboxDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'checkboxdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/checkbox/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/checkbox/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.checkbox',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/checkbox/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'checkboxDemo3',
                        'module'      : 'checkboxDemo3',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'checkboxdemoSelectAll',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/checkbox/demoSelectAll/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/checkbox/demoSelectAll/script.js'
                        }
                    ],
                    'moduleName': 'material.components.checkbox',
                    'name'      : 'demoSelectAll',
                    'label'     : 'Select All',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/checkbox/demoSelectAll/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'checkboxDemo2',
                        'module'      : 'checkboxDemo2',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'checkboxdemoSyncing',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/checkbox/demoSyncing/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/checkbox/demoSyncing/script.js'
                        }
                    ],
                    'moduleName': 'material.components.checkbox',
                    'name'      : 'demoSyncing',
                    'label'     : 'Syncing',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/checkbox/demoSyncing/index.html'
                    }
                }
            ],
            'url'       : 'demo/checkbox'
        },
        {
            'name'      : 'chips',
            'moduleName': 'material.components.chips',
            'label'     : 'Chips',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'chipsDemo',
                        'module'      : 'chipsDemo',
                        'dependencies': [
                            'ngMaterial',
                            'ngMessages'
                        ]
                    },
                    'id'        : 'chipsdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/chips/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/chips/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.chips',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/chips/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'contactChipsDemo',
                        'module'      : 'contactChipsDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'chipsdemoContactChips',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/chips/demoContactChips/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/chips/demoContactChips/script.js'
                        }
                    ],
                    'moduleName': 'material.components.chips',
                    'name'      : 'demoContactChips',
                    'label'     : 'Contact Chips',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/chips/demoContactChips/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'chipsCustomInputDemo',
                        'module'      : 'chipsCustomInputDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'chipsdemoCustomInputs',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/chips/demoCustomInputs/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/chips/demoCustomInputs/script.js'
                        }
                    ],
                    'moduleName': 'material.components.chips',
                    'name'      : 'demoCustomInputs',
                    'label'     : 'Custom Inputs',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/chips/demoCustomInputs/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'chipsCustomSeparatorDemo',
                        'module'      : 'chipsCustomSeparatorDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'chipsdemoCustomSeparatorKeys',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/chips/demoCustomSeparatorKeys/script.js'
                        }
                    ],
                    'moduleName': 'material.components.chips',
                    'name'      : 'demoCustomSeparatorKeys',
                    'label'     : 'Custom Separator Keys',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/chips/demoCustomSeparatorKeys/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'staticChipsDemo',
                        'module'      : 'staticChipsDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'chipsdemoStaticChips',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/chips/demoStaticChips/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/chips/demoStaticChips/script.js'
                        }
                    ],
                    'moduleName': 'material.components.chips',
                    'name'      : 'demoStaticChips',
                    'label'     : 'Static Chips',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/chips/demoStaticChips/index.html'
                    }
                }
            ],
            'url'       : 'demo/chips'
        },
        {
            'name'      : 'colors',
            'moduleName': 'material.components.colors',
            'label'     : 'Colors',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'colorsDemo',
                        'module'      : 'colorsDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'colorsdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/colors/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [
                        {
                            'name'      : 'regularCard.tmpl.html',
                            'label'     : 'regularCard.tmpl.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/colors/demoBasicUsage/regularCard.tmpl.html'
                        },
                        {
                            'name'      : 'userCard.tmpl.html',
                            'label'     : 'userCard.tmpl.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/colors/demoBasicUsage/userCard.tmpl.html'
                        }
                    ],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/colors/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.colors',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/colors/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'colorsThemePickerDemo',
                        'module'      : 'colorsThemePickerDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'colorsdemoThemePicker',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/colors/demoThemePicker/style.css'
                        }
                    ],
                    'html'      : [
                        {
                            'name'      : 'themePreview.tmpl.html',
                            'label'     : 'themePreview.tmpl.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/colors/demoThemePicker/themePreview.tmpl.html'
                        }
                    ],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/colors/demoThemePicker/script.js'
                        }
                    ],
                    'moduleName': 'material.components.colors',
                    'name'      : 'demoThemePicker',
                    'label'     : 'Theme Picker',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/colors/demoThemePicker/index.html'
                    }
                }
            ],
            'url'       : 'demo/colors'
        },
        {
            'name'      : 'content',
            'moduleName': 'material.components.content',
            'label'     : 'Content',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'contentDemo1',
                        'module'      : 'contentDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'contentdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/content/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/content/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.content',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/content/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/content'
        },
        {
            'name'      : 'datepicker',
            'moduleName': 'material.components.datepicker',
            'label'     : 'Datepicker',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'datepickerBasicUsage',
                        'module'      : 'datepickerBasicUsage',
                        'dependencies': [
                            'ngMaterial',
                            'ngMessages'
                        ]
                    },
                    'id'        : 'datepickerdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/datepicker/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/datepicker/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.datepicker',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/datepicker/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/datepicker'
        },
        {
            'name'      : 'dialog',
            'moduleName': 'material.components.dialog',
            'label'     : 'Dialog',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'dialogDemo1',
                        'module'      : 'dialogDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'dialogdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/dialog/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [
                        {
                            'name'      : 'dialog1.tmpl.html',
                            'label'     : 'dialog1.tmpl.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/dialog/demoBasicUsage/dialog1.tmpl.html'
                        },
                        {
                            'name'      : 'tabDialog.tmpl.html',
                            'label'     : 'tabDialog.tmpl.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/dialog/demoBasicUsage/tabDialog.tmpl.html'
                        }
                    ],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/dialog/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.dialog',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/dialog/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'dialogDemo2',
                        'module'      : 'dialogDemo2',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'dialogdemoOpenFromCloseTo',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/dialog/demoOpenFromCloseTo/script.js'
                        }
                    ],
                    'moduleName': 'material.components.dialog',
                    'name'      : 'demoOpenFromCloseTo',
                    'label'     : 'Open From Close To',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/dialog/demoOpenFromCloseTo/index.html'
                    }
                }
            ],
            'url'       : 'demo/dialog'
        },
        {
            'name'      : 'divider',
            'moduleName': 'material.components.divider',
            'label'     : 'Divider',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'dividerDemo1',
                        'module'      : 'dividerDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'dividerdemoBasicUsage',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/divider/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.divider',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/divider/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/divider'
        },
        {
            'name'      : 'fabSpeedDial',
            'moduleName': 'material.components.fabSpeedDial',
            'label'     : 'FAB Speed Dial',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'fabSpeedDialDemoBasicUsage',
                        'module'      : 'fabSpeedDialDemoBasicUsage',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'fabSpeedDialdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/fabSpeedDial/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/fabSpeedDial/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.fabSpeedDial',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/fabSpeedDial/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'fabSpeedDialDemoMoreOptions',
                        'module'      : 'fabSpeedDialDemoMoreOptions',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'fabSpeedDialdemoMoreOptions',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/fabSpeedDial/demoMoreOptions/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/fabSpeedDial/demoMoreOptions/script.js'
                        }
                    ],
                    'moduleName': 'material.components.fabSpeedDial',
                    'name'      : 'demoMoreOptions',
                    'label'     : 'More Options',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/fabSpeedDial/demoMoreOptions/index.html'
                    }
                }
            ],
            'url'       : 'demo/fabSpeedDial'
        },
        {
            'name'      : 'fabToolbar',
            'moduleName': 'material.components.fabToolbar',
            'label'     : 'FAB Toolbar',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'fabToolbarBasicUsageDemo',
                        'module'      : 'fabToolbarBasicUsageDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'fabToolbardemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/fabToolbar/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/fabToolbar/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.fabToolbar',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/fabToolbar/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/fabToolbar'
        },
        {
            'name'      : 'gridList',
            'moduleName': 'material.components.gridList',
            'label'     : 'Grid List',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'gridListDemo1',
                        'module'      : 'gridListDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'gridListdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'styles.css',
                            'label'     : 'styles.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/gridList/demoBasicUsage/styles.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/gridList/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.gridList',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/gridList/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'gridListDemoApp',
                        'module'      : 'gridListDemoApp',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'gridListdemoDynamicTiles',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/gridList/demoDynamicTiles/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/gridList/demoDynamicTiles/script.js'
                        }
                    ],
                    'moduleName': 'material.components.gridList',
                    'name'      : 'demoDynamicTiles',
                    'label'     : 'Dynamic Tiles',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/gridList/demoDynamicTiles/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'gridListDemo2',
                        'module'      : 'gridListDemo2',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'gridListdemoResponsiveUsage',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/gridList/demoResponsiveUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.gridList',
                    'name'      : 'demoResponsiveUsage',
                    'label'     : 'Responsive Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/gridList/demoResponsiveUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/gridList'
        },
        {
            'name'      : 'icon',
            'moduleName': 'material.components.icon',
            'label'     : 'Icon',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'appDemoFontIconsWithClassnames',
                        'module'      : 'appDemoFontIconsWithClassnames',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'icondemoFontIconsWithClassnames',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/icon/demoFontIconsWithClassnames/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/icon/demoFontIconsWithClassnames/script.js'
                        }
                    ],
                    'moduleName': 'material.components.icon',
                    'name'      : 'demoFontIconsWithClassnames',
                    'label'     : 'Font Icons With Classnames',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/icon/demoFontIconsWithClassnames/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'appDemoFontIconsWithLigatures',
                        'module'      : 'appDemoFontIconsWithLigatures',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'icondemoFontIconsWithLigatures',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/icon/demoFontIconsWithLigatures/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/icon/demoFontIconsWithLigatures/script.js'
                        }
                    ],
                    'moduleName': 'material.components.icon',
                    'name'      : 'demoFontIconsWithLigatures',
                    'label'     : 'Font Icons With Ligatures',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/icon/demoFontIconsWithLigatures/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'appDemoSvgIcons',
                        'module'      : 'appDemoSvgIcons',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'icondemoLoadSvgIconsFromUrl',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/icon/demoLoadSvgIconsFromUrl/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/icon/demoLoadSvgIconsFromUrl/script.js'
                        }
                    ],
                    'moduleName': 'material.components.icon',
                    'name'      : 'demoLoadSvgIconsFromUrl',
                    'label'     : 'Load Svg Icons From Url',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/icon/demoLoadSvgIconsFromUrl/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'appSvgIconSets',
                        'module'      : 'appSvgIconSets',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'icondemoSvgIconSets',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/icon/demoSvgIconSets/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/icon/demoSvgIconSets/script.js'
                        }
                    ],
                    'moduleName': 'material.components.icon',
                    'name'      : 'demoSvgIconSets',
                    'label'     : 'Svg Icon Sets',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/icon/demoSvgIconSets/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'appUsingTemplateCache',
                        'module'      : 'appUsingTemplateCache',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'icondemoUsingTemplateRequest',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/icon/demoUsingTemplateRequest/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/icon/demoUsingTemplateRequest/script.js'
                        }
                    ],
                    'moduleName': 'material.components.icon',
                    'name'      : 'demoUsingTemplateRequest',
                    'label'     : 'Using Template Request',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/icon/demoUsingTemplateRequest/index.html'
                    }
                }
            ],
            'url'       : 'demo/icon'
        },
        {
            'name'      : 'input',
            'moduleName': 'material.components.input',
            'label'     : 'Input',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'inputBasicDemo',
                        'module'      : 'inputBasicDemo',
                        'dependencies': [
                            'ngMaterial',
                            'ngMessages'
                        ]
                    },
                    'id'        : 'inputdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/input/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/input/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.input',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/input/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'inputErrorsApp',
                        'module'      : 'inputErrorsApp',
                        'dependencies': [
                            'ngMaterial',
                            'ngMessages'
                        ]
                    },
                    'id'        : 'inputdemoErrors',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/input/demoErrors/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/input/demoErrors/script.js'
                        }
                    ],
                    'moduleName': 'material.components.input',
                    'name'      : 'demoErrors',
                    'label'     : 'Errors',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/input/demoErrors/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'inputErrorsAdvancedApp',
                        'module'      : 'inputErrorsAdvancedApp',
                        'dependencies': [
                            'ngMaterial',
                            'ngMessages'
                        ]
                    },
                    'id'        : 'inputdemoErrorsAdvanced',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/input/demoErrorsAdvanced/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/input/demoErrorsAdvanced/script.js'
                        }
                    ],
                    'moduleName': 'material.components.input',
                    'name'      : 'demoErrorsAdvanced',
                    'label'     : 'Errors Advanced',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/input/demoErrorsAdvanced/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'inputIconDemo',
                        'module'      : 'inputIconDemo',
                        'dependencies': [
                            'ngMaterial',
                            'ngMessages'
                        ]
                    },
                    'id'        : 'inputdemoIcons',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/input/demoIcons/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/input/demoIcons/script.js'
                        }
                    ],
                    'moduleName': 'material.components.input',
                    'name'      : 'demoIcons',
                    'label'     : 'Icons',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/input/demoIcons/index.html'
                    }
                }
            ],
            'url'       : 'demo/input'
        },
        {
            'name'      : 'list',
            'moduleName': 'material.components.list',
            'label'     : 'List',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'listDemo1',
                        'module'      : 'listDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'listdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/list/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/list/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.list',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/list/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'listDemo2',
                        'module'      : 'listDemo2',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'listdemoListControls',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/list/demoListControls/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/list/demoListControls/script.js'
                        }
                    ],
                    'moduleName': 'material.components.list',
                    'name'      : 'demoListControls',
                    'label'     : 'List Controls',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/list/demoListControls/index.html'
                    }
                }
            ],
            'url'       : 'demo/list'
        },
        {
            'name'      : 'menu',
            'moduleName': 'material.components.menu',
            'label'     : 'Menu',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'menuDemoBasic',
                        'module'      : 'menuDemoBasic',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'menudemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/menu/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/menu/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.menu',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/menu/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'menuDemoPosition',
                        'module'      : 'menuDemoPosition',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'menudemoMenuPositionModes',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/menu/demoMenuPositionModes/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/menu/demoMenuPositionModes/script.js'
                        }
                    ],
                    'moduleName': 'material.components.menu',
                    'name'      : 'demoMenuPositionModes',
                    'label'     : 'Menu Position Modes',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/menu/demoMenuPositionModes/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'menuDemoWidth',
                        'module'      : 'menuDemoWidth',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'menudemoMenuWidth',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/menu/demoMenuWidth/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/menu/demoMenuWidth/script.js'
                        }
                    ],
                    'moduleName': 'material.components.menu',
                    'name'      : 'demoMenuWidth',
                    'label'     : 'Menu Width',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/menu/demoMenuWidth/index.html'
                    }
                }
            ],
            'url'       : 'demo/menu'
        },
        {
            'name'      : 'menuBar',
            'moduleName': 'material.components.menuBar',
            'label'     : 'Menu Bar',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'menuBarDemoBasic',
                        'module'      : 'menuBarDemoBasic',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'menuBardemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/menuBar/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/menuBar/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.menuBar',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/menuBar/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/menuBar'
        },
        {
            'name'      : 'navBar',
            'moduleName': 'material.components.navBar',
            'label'     : 'Nav Bar',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'navBarDemoBasicUsage',
                        'module'      : 'navBarDemoBasicUsage',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'navBardemoBasicUsage',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/navBar/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.navBar',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/navBar/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/navBar'
        },
        {
            'name'      : 'panel',
            'moduleName': 'material.components.panel',
            'label'     : 'Panel',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'panelDemo',
                        'module'      : 'panelDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'paneldemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.global.css',
                            'label'     : 'style.global.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/panel/demoBasicUsage/style.global.css'
                        }
                    ],
                    'html'      : [
                        {
                            'name'      : 'panel.tmpl.html',
                            'label'     : 'panel.tmpl.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/panel/demoBasicUsage/panel.tmpl.html'
                        }
                    ],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/panel/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.panel',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/panel/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'panelAnimationsDemo',
                        'module'      : 'panelAnimationsDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'paneldemoPanelAnimations',
                    'css'       : [
                        {
                            'name'      : 'style.global.css',
                            'label'     : 'style.global.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/panel/demoPanelAnimations/style.global.css'
                        }
                    ],
                    'html'      : [
                        {
                            'name'      : 'panel.tmpl.html',
                            'label'     : 'panel.tmpl.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/panel/demoPanelAnimations/panel.tmpl.html'
                        }
                    ],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/panel/demoPanelAnimations/script.js'
                        }
                    ],
                    'moduleName': 'material.components.panel',
                    'name'      : 'demoPanelAnimations',
                    'label'     : 'Panel Animations',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/panel/demoPanelAnimations/index.html'
                    }
                }
            ],
            'url'       : 'demo/panel'
        },
        {
            'name'      : 'progressCircular',
            'moduleName': 'material.components.progressCircular',
            'label'     : 'Progress Circular',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'progressCircularDemo1',
                        'module'      : 'progressCircularDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'progressCirculardemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/progressCircular/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/progressCircular/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.progressCircular',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/progressCircular/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/progressCircular'
        },
        {
            'name'      : 'progressLinear',
            'moduleName': 'material.components.progressLinear',
            'label'     : 'Progress Linear',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'progressLinearDemo1',
                        'module'      : 'progressLinearDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'progressLineardemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/progressLinear/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/progressLinear/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.progressLinear',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/progressLinear/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/progressLinear'
        },
        {
            'name'      : 'radioButton',
            'moduleName': 'material.components.radioButton',
            'label'     : 'Radio Button',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'radioDemo1',
                        'module'      : 'radioDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'radioButtondemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/radioButton/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/radioButton/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.radioButton',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/radioButton/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'radioDemo2',
                        'module'      : 'radioDemo2',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'radioButtondemoMultiColumn',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/radioButton/demoMultiColumn/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/radioButton/demoMultiColumn/script.js'
                        }
                    ],
                    'moduleName': 'material.components.radioButton',
                    'name'      : 'demoMultiColumn',
                    'label'     : 'Multi Column',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/radioButton/demoMultiColumn/index.html'
                    }
                }
            ],
            'url'       : 'demo/radioButton'
        },
        {
            'name'      : 'select',
            'moduleName': 'material.components.select',
            'label'     : 'Select',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'selectDemoBasic',
                        'module'      : 'selectDemoBasic',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'selectdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/select/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/select/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.select',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/select/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'selectDemoOptGroups',
                        'module'      : 'selectDemoOptGroups',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'selectdemoOptionGroups',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/select/demoOptionGroups/script.js'
                        }
                    ],
                    'moduleName': 'material.components.select',
                    'name'      : 'demoOptionGroups',
                    'label'     : 'Option Groups',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/select/demoOptionGroups/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'selectDemoOptionsAsync',
                        'module'      : 'selectDemoOptionsAsync',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'selectdemoOptionsWithAsyncSearch',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/select/demoOptionsWithAsyncSearch/script.js'
                        }
                    ],
                    'moduleName': 'material.components.select',
                    'name'      : 'demoOptionsWithAsyncSearch',
                    'label'     : 'Options With Async Search',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/select/demoOptionsWithAsyncSearch/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'selectDemoSelectHeader',
                        'module'      : 'selectDemoSelectHeader',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'selectdemoSelectHeader',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/select/demoSelectHeader/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/select/demoSelectHeader/script.js'
                        }
                    ],
                    'moduleName': 'material.components.select',
                    'name'      : 'demoSelectHeader',
                    'label'     : 'Select Header',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/select/demoSelectHeader/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'selectDemoSelectedText',
                        'module'      : 'selectDemoSelectedText',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'selectdemoSelectedText',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/select/demoSelectedText/script.js'
                        }
                    ],
                    'moduleName': 'material.components.select',
                    'name'      : 'demoSelectedText',
                    'label'     : 'Selected Text',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/select/demoSelectedText/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'selectDemoValidation',
                        'module'      : 'selectDemoValidation',
                        'dependencies': [
                            'ngMaterial',
                            'ngMessages'
                        ]
                    },
                    'id'        : 'selectdemoValidations',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/select/demoValidations/script.js'
                        }
                    ],
                    'moduleName': 'material.components.select',
                    'name'      : 'demoValidations',
                    'label'     : 'Validations',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/select/demoValidations/index.html'
                    }
                }
            ],
            'url'       : 'demo/select'
        },
        {
            'name'      : 'sidenav',
            'moduleName': 'material.components.sidenav',
            'label'     : 'Sidenav',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'sidenavDemo1',
                        'module'      : 'sidenavDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'sidenavdemoBasicUsage',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/sidenav/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.sidenav',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/sidenav/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/sidenav'
        },
        {
            'name'      : 'slider',
            'moduleName': 'material.components.slider',
            'label'     : 'Slider',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'sliderDemo1',
                        'module'      : 'sliderDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'sliderdemoBasicUsage',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/slider/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.slider',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/slider/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'sliderDemo2',
                        'module'      : 'sliderDemo2',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'sliderdemoVertical',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/slider/demoVertical/script.js'
                        }
                    ],
                    'moduleName': 'material.components.slider',
                    'name'      : 'demoVertical',
                    'label'     : 'Vertical',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/slider/demoVertical/index.html'
                    }
                }
            ],
            'url'       : 'demo/slider'
        },
        {
            'name'      : 'subheader',
            'moduleName': 'material.components.subheader',
            'label'     : 'Subheader',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'subheaderBasicDemo',
                        'module'      : 'subheaderBasicDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'subheaderdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/subheader/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/subheader/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.subheader',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/subheader/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/subheader'
        },
        {
            'name'      : 'swipe',
            'moduleName': 'material.components.swipe',
            'label'     : 'Swipe',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'demoSwipe',
                        'module'      : 'demoSwipe',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'swipedemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/swipe/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [
                        {
                            'name'      : 'readme.html',
                            'label'     : 'readme.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/swipe/demoBasicUsage/readme.html'
                        }
                    ],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/swipe/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.swipe',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/swipe/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/swipe'
        },
        {
            'name'      : 'switch',
            'moduleName': 'material.components.switch',
            'label'     : 'Switch',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'switchDemo1',
                        'module'      : 'switchDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'switchdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/switch/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/switch/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.switch',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/switch/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/switch'
        },
        {
            'name'      : 'tabs',
            'moduleName': 'material.components.tabs',
            'label'     : 'Tabs',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'tabsDemoDynamicHeight',
                        'module'      : 'tabsDemoDynamicHeight',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'tabsdemoDynamicHeight',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/tabs/demoDynamicHeight/style.css'
                        }
                    ],
                    'html'      : [
                        {
                            'name'      : 'readme.html',
                            'label'     : 'readme.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/tabs/demoDynamicHeight/readme.html'
                        }
                    ],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/tabs/demoDynamicHeight/script.js'
                        }
                    ],
                    'moduleName': 'material.components.tabs',
                    'name'      : 'demoDynamicHeight',
                    'label'     : 'Dynamic Height',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/tabs/demoDynamicHeight/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'tabsDemoDynamicTabs',
                        'module'      : 'tabsDemoDynamicTabs',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'tabsdemoDynamicTabs',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/tabs/demoDynamicTabs/style.css'
                        }
                    ],
                    'html'      : [
                        {
                            'name'      : 'readme.html',
                            'label'     : 'readme.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/tabs/demoDynamicTabs/readme.html'
                        }
                    ],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/tabs/demoDynamicTabs/script.js'
                        }
                    ],
                    'moduleName': 'material.components.tabs',
                    'name'      : 'demoDynamicTabs',
                    'label'     : 'Dynamic Tabs',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/tabs/demoDynamicTabs/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'tabsDemoStaticTabs',
                        'module'      : 'tabsDemoStaticTabs',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'tabsdemoStaticTabs',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/tabs/demoStaticTabs/style.css'
                        }
                    ],
                    'html'      : [
                        {
                            'name'      : 'readme.html',
                            'label'     : 'readme.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/tabs/demoStaticTabs/readme.html'
                        }
                    ],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/tabs/demoStaticTabs/script.js'
                        }
                    ],
                    'moduleName': 'material.components.tabs',
                    'name'      : 'demoStaticTabs',
                    'label'     : 'Static Tabs',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/tabs/demoStaticTabs/index.html'
                    }
                }
            ],
            'url'       : 'demo/tabs'
        },
        {
            'name'      : 'toast',
            'moduleName': 'material.components.toast',
            'label'     : 'Toast',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'toastDemo1',
                        'module'      : 'toastDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'toastdemoBasicUsage',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/toast/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.toast',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/toast/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'toastDemo2',
                        'module'      : 'toastDemo2',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'toastdemoCustomUsage',
                    'css'       : [],
                    'html'      : [
                        {
                            'name'      : 'toast-template.html',
                            'label'     : 'toast-template.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/toast/demoCustomUsage/toast-template.html'
                        }
                    ],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/toast/demoCustomUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.toast',
                    'name'      : 'demoCustomUsage',
                    'label'     : 'Custom Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/toast/demoCustomUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/toast'
        },
        {
            'name'      : 'toolbar',
            'moduleName': 'material.components.toolbar',
            'label'     : 'Toolbar',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'toolbarDemo1',
                        'module'      : 'toolbarDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'toolbardemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/toolbar/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/toolbar/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.toolbar',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/toolbar/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'toolbarDemo2',
                        'module'      : 'toolbarDemo2',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'toolbardemoScrollShrink',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/toolbar/demoScrollShrink/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/toolbar/demoScrollShrink/script.js'
                        }
                    ],
                    'moduleName': 'material.components.toolbar',
                    'name'      : 'demoScrollShrink',
                    'label'     : 'Scroll Shrink',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/toolbar/demoScrollShrink/index.html'
                    }
                }
            ],
            'url'       : 'demo/toolbar'
        },
        {
            'name'      : 'tooltip',
            'moduleName': 'material.components.tooltip',
            'label'     : 'Tooltip',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'tooltipDemo1',
                        'module'      : 'tooltipDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'tooltipdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/tooltip/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/tooltip/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.tooltip',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/tooltip/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/tooltip'
        },
        {
            'name'      : 'virtualRepeat',
            'moduleName': 'material.components.virtualRepeat',
            'label'     : 'Virtual Repeat',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'virtualRepeatDeferredLoadingDemo',
                        'module'      : 'virtualRepeatDeferredLoadingDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'virtualRepeatdemoDeferredLoading',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/virtualRepeat/demoDeferredLoading/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/virtualRepeat/demoDeferredLoading/script.js'
                        }
                    ],
                    'moduleName': 'material.components.virtualRepeat',
                    'name'      : 'demoDeferredLoading',
                    'label'     : 'Deferred Loading',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/virtualRepeat/demoDeferredLoading/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'virtualRepeatHorizontalDemo',
                        'module'      : 'virtualRepeatHorizontalDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'virtualRepeatdemoHorizontalUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/virtualRepeat/demoHorizontalUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/virtualRepeat/demoHorizontalUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.virtualRepeat',
                    'name'      : 'demoHorizontalUsage',
                    'label'     : 'Horizontal Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/virtualRepeat/demoHorizontalUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'virtualRepeatInfiniteScrollDemo',
                        'module'      : 'virtualRepeatInfiniteScrollDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'virtualRepeatdemoInfiniteScroll',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/virtualRepeat/demoInfiniteScroll/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/virtualRepeat/demoInfiniteScroll/script.js'
                        }
                    ],
                    'moduleName': 'material.components.virtualRepeat',
                    'name'      : 'demoInfiniteScroll',
                    'label'     : 'Infinite Scroll',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/virtualRepeat/demoInfiniteScroll/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'virtualRepeatScrollToDemo',
                        'module'      : 'virtualRepeatScrollToDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'virtualRepeatdemoScrollTo',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/virtualRepeat/demoScrollTo/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/virtualRepeat/demoScrollTo/script.js'
                        }
                    ],
                    'moduleName': 'material.components.virtualRepeat',
                    'name'      : 'demoScrollTo',
                    'label'     : 'Scroll To',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/virtualRepeat/demoScrollTo/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'virtualRepeatVerticalDemo',
                        'module'      : 'virtualRepeatVerticalDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'virtualRepeatdemoVerticalUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/virtualRepeat/demoVerticalUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/virtualRepeat/demoVerticalUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.virtualRepeat',
                    'name'      : 'demoVerticalUsage',
                    'label'     : 'Vertical Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/virtualRepeat/demoVerticalUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/virtualRepeat'
        },
        {
            'name'      : 'whiteframe',
            'moduleName': 'material.components.whiteframe',
            'label'     : 'Whiteframe',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'whiteframeBasicUsage',
                        'module'      : 'whiteframeBasicUsage',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'whiteframedemoBasicClassUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/whiteframe/demoBasicClassUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/whiteframe/demoBasicClassUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.whiteframe',
                    'name'      : 'demoBasicClassUsage',
                    'label'     : 'Basic Class Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/whiteframe/demoBasicClassUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'whiteframeDirectiveUsage',
                        'module'      : 'whiteframeDirectiveUsage',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'whiteframedemoDirectiveAttributeUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/whiteframe/demoDirectiveAttributeUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/whiteframe/demoDirectiveAttributeUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.whiteframe',
                    'name'      : 'demoDirectiveAttributeUsage',
                    'label'     : 'Directive Attribute Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/whiteframe/demoDirectiveAttributeUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/whiteframe'
        }
    ]);
angular.module('app.components.material-docs')
    .constant('COMPONENTS', [
        {
            'name'      : 'material.components.autocomplete',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.autocomplete/index.html',
            'url'       : 'api/material.components.autocomplete',
            'label'     : 'material.components.autocomplete',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/autocomplete/autocomplete.js',
            'docs'      : [
                {
                    'name'      : 'mdAutocomplete',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.autocomplete/directive/mdAutocomplete.html',
                    'url'       : 'api/directive/mdAutocomplete',
                    'label'     : 'mdAutocomplete',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/autocomplete/js/autocompleteDirective.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : 'mdHighlightText',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.autocomplete/directive/mdHighlightText.html',
                    'url'       : 'api/directive/mdHighlightText',
                    'label'     : 'mdHighlightText',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/autocomplete/js/highlightDirective.js'
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.bottomSheet',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.bottomSheet/index.html',
            'url'       : 'api/material.components.bottomSheet',
            'label'     : 'material.components.bottomSheet',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/bottomSheet/bottom-sheet.js',
            'docs'      : [
                {
                    'name'      : '$mdBottomSheet',
                    'type'      : 'service',
                    'outputPath': 'partials/api/material.components.bottomSheet/service/$mdBottomSheet.html',
                    'url'       : 'api/service/$mdBottomSheet',
                    'label'     : '$mdBottomSheet',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/bottomSheet/bottom-sheet.js',
                    'hasDemo'   : false
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.button',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.button/index.html',
            'url'       : 'api/material.components.button',
            'label'     : 'material.components.button',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/button/button.js',
            'docs'      : [
                {
                    'name'      : 'mdButton',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.button/directive/mdButton.html',
                    'url'       : 'api/directive/mdButton',
                    'label'     : 'mdButton',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/button/button.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.card',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.card/index.html',
            'url'       : 'api/material.components.card',
            'label'     : 'material.components.card',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/card/card.js',
            'docs'      : [
                {
                    'name'      : 'mdCard',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.card/directive/mdCard.html',
                    'url'       : 'api/directive/mdCard',
                    'label'     : 'mdCard',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/card/card.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.checkbox',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.checkbox/index.html',
            'url'       : 'api/material.components.checkbox',
            'label'     : 'material.components.checkbox',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/checkbox/checkbox.js',
            'docs'      : [
                {
                    'name'      : 'mdCheckbox',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.checkbox/directive/mdCheckbox.html',
                    'url'       : 'api/directive/mdCheckbox',
                    'label'     : 'mdCheckbox',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/checkbox/checkbox.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.chips',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.chips/index.html',
            'url'       : 'api/material.components.chips',
            'label'     : 'material.components.chips',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/chips/chips.js',
            'docs'      : [
                {
                    'name'      : 'mdChip',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.chips/directive/mdChip.html',
                    'url'       : 'api/directive/mdChip',
                    'label'     : 'mdChip',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/chips/js/chipDirective.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : 'mdChipRemove',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.chips/directive/mdChipRemove.html',
                    'url'       : 'api/directive/mdChipRemove',
                    'label'     : 'mdChipRemove',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/chips/js/chipRemoveDirective.js'
                },
                {
                    'name'      : 'mdChips',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.chips/directive/mdChips.html',
                    'url'       : 'api/directive/mdChips',
                    'label'     : 'mdChips',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/chips/js/chipsDirective.js'
                },
                {
                    'name'      : 'mdContactChips',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.chips/directive/mdContactChips.html',
                    'url'       : 'api/directive/mdContactChips',
                    'label'     : 'mdContactChips',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/chips/js/contactChipsDirective.js'
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.colors',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.colors/index.html',
            'url'       : 'api/material.components.colors',
            'label'     : 'material.components.colors',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/colors/colors.js',
            'docs'      : [
                {
                    'name'      : '$mdColors',
                    'type'      : 'service',
                    'outputPath': 'partials/api/material.components.colors/service/$mdColors.html',
                    'url'       : 'api/service/$mdColors',
                    'label'     : '$mdColors',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/colors/colors.js',
                    'hasDemo'   : false
                },
                {
                    'name'      : 'mdColors',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.colors/directive/mdColors.html',
                    'url'       : 'api/directive/mdColors',
                    'label'     : 'mdColors',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/colors/colors.js'
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.content',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.content/index.html',
            'url'       : 'api/material.components.content',
            'label'     : 'material.components.content',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/content/content.js',
            'docs'      : [
                {
                    'name'      : 'mdContent',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.content/directive/mdContent.html',
                    'url'       : 'api/directive/mdContent',
                    'label'     : 'mdContent',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/content/content.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.datepicker',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.datepicker/index.html',
            'url'       : 'api/material.components.datepicker',
            'label'     : 'material.components.datepicker',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/datepicker/calendar.js',
            'docs'      : [
                {
                    'name'      : '$mdDateLocaleProvider',
                    'type'      : 'service',
                    'outputPath': 'partials/api/material.components.datepicker/service/$mdDateLocaleProvider.html',
                    'url'       : 'api/service/$mdDateLocaleProvider',
                    'label'     : '$mdDateLocaleProvider',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/datepicker/dateLocaleProvider.js',
                    'hasDemo'   : false
                },
                {
                    'name'      : 'mdDatepicker',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.datepicker/directive/mdDatepicker.html',
                    'url'       : 'api/directive/mdDatepicker',
                    'label'     : 'mdDatepicker',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/datepicker/datePicker.js'
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.dialog',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.dialog/index.html',
            'url'       : 'api/material.components.dialog',
            'label'     : 'material.components.dialog',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/dialog/dialog.js',
            'docs'      : [
                {
                    'name'      : 'mdDialog',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.dialog/directive/mdDialog.html',
                    'url'       : 'api/directive/mdDialog',
                    'label'     : 'mdDialog',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/dialog/dialog.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : '$mdDialog',
                    'type'      : 'service',
                    'outputPath': 'partials/api/material.components.dialog/service/$mdDialog.html',
                    'url'       : 'api/service/$mdDialog',
                    'label'     : '$mdDialog',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/dialog/dialog.js'
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.divider',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.divider/index.html',
            'url'       : 'api/material.components.divider',
            'label'     : 'material.components.divider',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/divider/divider.js',
            'docs'      : [
                {
                    'name'      : 'mdDivider',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.divider/directive/mdDivider.html',
                    'url'       : 'api/directive/mdDivider',
                    'label'     : 'mdDivider',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/divider/divider.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.fabActions',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.fabActions/index.html',
            'url'       : 'api/material.components.fabActions',
            'label'     : 'material.components.fabActions',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/fabActions/fabActions.js',
            'docs'      : [
                {
                    'name'      : 'mdFabActions',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.fabActions/directive/mdFabActions.html',
                    'url'       : 'api/directive/mdFabActions',
                    'label'     : 'mdFabActions',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/fabActions/fabActions.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.fabSpeedDial',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.fabSpeedDial/index.html',
            'url'       : 'api/material.components.fabSpeedDial',
            'label'     : 'material.components.fabSpeedDial',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/fabSpeedDial/fabSpeedDial.js',
            'docs'      : [
                {
                    'name'      : 'mdFabSpeedDial',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.fabSpeedDial/directive/mdFabSpeedDial.html',
                    'url'       : 'api/directive/mdFabSpeedDial',
                    'label'     : 'mdFabSpeedDial',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/fabSpeedDial/fabSpeedDial.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : 'mdFabTrigger',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.fabSpeedDial/directive/mdFabTrigger.html',
                    'url'       : 'api/directive/mdFabTrigger',
                    'label'     : 'mdFabTrigger',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/fabTrigger/fabTrigger.js'
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.fabToolbar',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.fabToolbar/index.html',
            'url'       : 'api/material.components.fabToolbar',
            'label'     : 'material.components.fabToolbar',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/fabToolbar/fabToolbar.js',
            'docs'      : [
                {
                    'name'      : 'mdFabToolbar',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.fabToolbar/directive/mdFabToolbar.html',
                    'url'       : 'api/directive/mdFabToolbar',
                    'label'     : 'mdFabToolbar',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/fabToolbar/fabToolbar.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.gridList',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.gridList/index.html',
            'url'       : 'api/material.components.gridList',
            'label'     : 'material.components.gridList',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/gridList/grid-list.js',
            'docs'      : [
                {
                    'name'      : 'mdGridList',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.gridList/directive/mdGridList.html',
                    'url'       : 'api/directive/mdGridList',
                    'label'     : 'mdGridList',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/gridList/grid-list.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : 'mdGridTile',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.gridList/directive/mdGridTile.html',
                    'url'       : 'api/directive/mdGridTile',
                    'label'     : 'mdGridTile',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/gridList/grid-list.js'
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.icon',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.icon/index.html',
            'url'       : 'api/material.components.icon',
            'label'     : 'material.components.icon',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/icon/icon.js',
            'docs'      : [
                {
                    'name'      : 'mdIcon',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.icon/directive/mdIcon.html',
                    'url'       : 'api/directive/mdIcon',
                    'label'     : 'mdIcon',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/icon/js/iconDirective.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : '$mdIconProvider',
                    'type'      : 'service',
                    'outputPath': 'partials/api/material.components.icon/service/$mdIconProvider.html',
                    'url'       : 'api/service/$mdIconProvider',
                    'label'     : '$mdIconProvider',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/icon/js/iconService.js'
                },
                {
                    'name'      : '$mdIcon',
                    'type'      : 'service',
                    'outputPath': 'partials/api/material.components.icon/service/$mdIcon.html',
                    'url'       : 'api/service/$mdIcon',
                    'label'     : '$mdIcon',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/icon/js/iconService.js'
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.input',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.input/index.html',
            'url'       : 'api/material.components.input',
            'label'     : 'material.components.input',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/input/input.js',
            'docs'      : [
                {
                    'name'      : 'mdInputContainer',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.input/directive/mdInputContainer.html',
                    'url'       : 'api/directive/mdInputContainer',
                    'label'     : 'mdInputContainer',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/input/input.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : 'mdInput',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.input/directive/mdInput.html',
                    'url'       : 'api/directive/mdInput',
                    'label'     : 'mdInput',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/input/input.js'
                },
                {
                    'name'      : 'mdSelectOnFocus',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.input/directive/mdSelectOnFocus.html',
                    'url'       : 'api/directive/mdSelectOnFocus',
                    'label'     : 'mdSelectOnFocus',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/input/input.js'
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.list',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.list/index.html',
            'url'       : 'api/material.components.list',
            'label'     : 'material.components.list',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/list/list.js',
            'docs'      : [
                {
                    'name'      : 'mdList',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.list/directive/mdList.html',
                    'url'       : 'api/directive/mdList',
                    'label'     : 'mdList',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/list/list.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : 'mdListItem',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.list/directive/mdListItem.html',
                    'url'       : 'api/directive/mdListItem',
                    'label'     : 'mdListItem',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/list/list.js'
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.menu',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.menu/index.html',
            'url'       : 'api/material.components.menu',
            'label'     : 'material.components.menu',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/menu/menu.js',
            'docs'      : [
                {
                    'name'      : 'mdMenu',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.menu/directive/mdMenu.html',
                    'url'       : 'api/directive/mdMenu',
                    'label'     : 'mdMenu',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/menu/js/menuDirective.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.menu-bar',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.menu-bar/index.html',
            'url'       : 'api/material.components.menu-bar',
            'label'     : 'material.components.menu-bar',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/menuBar/menu-bar.js',
            'docs'      : [
                {
                    'name'      : 'mdMenuBar',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.menu-bar/directive/mdMenuBar.html',
                    'url'       : 'api/directive/mdMenuBar',
                    'label'     : 'mdMenuBar',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/menuBar/js/menuBarDirective.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.navBar',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.navBar/index.html',
            'url'       : 'api/material.components.navBar',
            'label'     : 'material.components.navBar',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/navBar/navBar.js',
            'docs'      : [
                {
                    'name'      : 'mdNavBar',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.navBar/directive/mdNavBar.html',
                    'url'       : 'api/directive/mdNavBar',
                    'label'     : 'mdNavBar',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/navBar/navBar.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : 'mdNavItem',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.navBar/directive/mdNavItem.html',
                    'url'       : 'api/directive/mdNavItem',
                    'label'     : 'mdNavItem',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/navBar/navBar.js'
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.panel',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.panel/index.html',
            'url'       : 'api/material.components.panel',
            'label'     : 'material.components.panel',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/panel/panel.js',
            'docs'      : [
                {
                    'name'      : '$mdPanel',
                    'type'      : 'service',
                    'outputPath': 'partials/api/material.components.panel/service/$mdPanel.html',
                    'url'       : 'api/service/$mdPanel',
                    'label'     : '$mdPanel',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/panel/panel.js',
                    'hasDemo'   : false
                },
                {
                    'name'      : 'MdPanelRef',
                    'type'      : 'type',
                    'outputPath': 'partials/api/material.components.panel/type/MdPanelRef.html',
                    'url'       : 'api/type/MdPanelRef',
                    'label'     : 'MdPanelRef',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/panel/panel.js'
                },
                {
                    'name'      : 'MdPanelPosition',
                    'type'      : 'type',
                    'outputPath': 'partials/api/material.components.panel/type/MdPanelPosition.html',
                    'url'       : 'api/type/MdPanelPosition',
                    'label'     : 'MdPanelPosition',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/panel/panel.js'
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.progressCircular',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.progressCircular/index.html',
            'url'       : 'api/material.components.progressCircular',
            'label'     : 'material.components.progressCircular',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/progressCircular/progress-circular.js',
            'docs'      : [
                {
                    'name'      : 'mdProgressCircular',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.progressCircular/directive/mdProgressCircular.html',
                    'url'       : 'api/directive/mdProgressCircular',
                    'label'     : 'mdProgressCircular',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/progressCircular/js/progressCircularDirective.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : '$mdProgressCircular',
                    'type'      : 'service',
                    'outputPath': 'partials/api/material.components.progressCircular/service/$mdProgressCircular.html',
                    'url'       : 'api/service/$mdProgressCircular',
                    'label'     : '$mdProgressCircular',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/progressCircular/js/progressCircularProvider.js'
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.progressLinear',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.progressLinear/index.html',
            'url'       : 'api/material.components.progressLinear',
            'label'     : 'material.components.progressLinear',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/progressLinear/progress-linear.js',
            'docs'      : [
                {
                    'name'      : 'mdProgressLinear',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.progressLinear/directive/mdProgressLinear.html',
                    'url'       : 'api/directive/mdProgressLinear',
                    'label'     : 'mdProgressLinear',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/progressLinear/progress-linear.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.radioButton',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.radioButton/index.html',
            'url'       : 'api/material.components.radioButton',
            'label'     : 'material.components.radioButton',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/radioButton/radio-button.js',
            'docs'      : [
                {
                    'name'      : 'mdRadioGroup',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.radioButton/directive/mdRadioGroup.html',
                    'url'       : 'api/directive/mdRadioGroup',
                    'label'     : 'mdRadioGroup',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/radioButton/radio-button.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : 'mdRadioButton',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.radioButton/directive/mdRadioButton.html',
                    'url'       : 'api/directive/mdRadioButton',
                    'label'     : 'mdRadioButton',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/radioButton/radio-button.js'
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.select',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.select/index.html',
            'url'       : 'api/material.components.select',
            'label'     : 'material.components.select',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/select/select.js',
            'docs'      : [
                {
                    'name'      : 'mdSelect',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.select/directive/mdSelect.html',
                    'url'       : 'api/directive/mdSelect',
                    'label'     : 'mdSelect',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/select/select.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.sidenav',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.sidenav/index.html',
            'url'       : 'api/material.components.sidenav',
            'label'     : 'material.components.sidenav',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/sidenav/sidenav.js',
            'docs'      : [
                {
                    'name'      : '$mdSidenav',
                    'type'      : 'service',
                    'outputPath': 'partials/api/material.components.sidenav/service/$mdSidenav.html',
                    'url'       : 'api/service/$mdSidenav',
                    'label'     : '$mdSidenav',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/sidenav/sidenav.js',
                    'hasDemo'   : false
                },
                {
                    'name'      : 'mdSidenavFocus',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.sidenav/directive/mdSidenavFocus.html',
                    'url'       : 'api/directive/mdSidenavFocus',
                    'label'     : 'mdSidenavFocus',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/sidenav/sidenav.js'
                },
                {
                    'name'      : 'mdSidenav',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.sidenav/directive/mdSidenav.html',
                    'url'       : 'api/directive/mdSidenav',
                    'label'     : 'mdSidenav',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/sidenav/sidenav.js'
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.slider',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.slider/index.html',
            'url'       : 'api/material.components.slider',
            'label'     : 'material.components.slider',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/slider/slider.js',
            'docs'      : [
             /*   {
                    'name'      : 'mdSliderContainer',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.slider/directive/mdSliderContainer.html',
                    'url'       : 'api/directive/mdSliderContainer',
                    'label'     : 'mdSliderContainer',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/slider/slider.js',
                    'hasDemo'   : true
                },*/
                {
                    'name'      : 'mdSlider',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.slider/directive/mdSlider.html',
                    'url'       : 'api/directive/mdSlider',
                    'label'     : 'mdSlider',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/slider/slider.js'
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.sticky',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.sticky/index.html',
            'url'       : 'api/material.components.sticky',
            'label'     : 'material.components.sticky',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/sticky/sticky.js',
            'docs'      : [
                {
                    'name'      : '$mdSticky',
                    'type'      : 'service',
                    'outputPath': 'partials/api/material.components.sticky/service/$mdSticky.html',
                    'url'       : 'api/service/$mdSticky',
                    'label'     : '$mdSticky',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/sticky/sticky.js',
                    'hasDemo'   : false
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.subheader',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.subheader/index.html',
            'url'       : 'api/material.components.subheader',
            'label'     : 'material.components.subheader',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/subheader/subheader.js',
            'docs'      : [
                {
                    'name'      : 'mdSubheader',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.subheader/directive/mdSubheader.html',
                    'url'       : 'api/directive/mdSubheader',
                    'label'     : 'mdSubheader',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/subheader/subheader.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.swipe',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.swipe/index.html',
            'url'       : 'api/material.components.swipe',
            'label'     : 'material.components.swipe',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/swipe/swipe.js',
            'docs'      : [
                {
                    'name'      : 'mdSwipeLeft',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.swipe/directive/mdSwipeLeft.html',
                    'url'       : 'api/directive/mdSwipeLeft',
                    'label'     : 'mdSwipeLeft',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/swipe/swipe.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : 'mdSwipeRight',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.swipe/directive/mdSwipeRight.html',
                    'url'       : 'api/directive/mdSwipeRight',
                    'label'     : 'mdSwipeRight',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/swipe/swipe.js'
                },
                {
                    'name'      : 'mdSwipeUp',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.swipe/directive/mdSwipeUp.html',
                    'url'       : 'api/directive/mdSwipeUp',
                    'label'     : 'mdSwipeUp',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/swipe/swipe.js'
                },
                {
                    'name'      : 'mdSwipeDown',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.swipe/directive/mdSwipeDown.html',
                    'url'       : 'api/directive/mdSwipeDown',
                    'label'     : 'mdSwipeDown',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/swipe/swipe.js'
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.switch',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.switch/index.html',
            'url'       : 'api/material.components.switch',
            'label'     : 'material.components.switch',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/switch/switch.js',
            'docs'      : [
                {
                    'name'      : 'mdSwitch',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.switch/directive/mdSwitch.html',
                    'url'       : 'api/directive/mdSwitch',
                    'label'     : 'mdSwitch',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/switch/switch.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.tabs',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.tabs/index.html',
            'url'       : 'api/material.components.tabs',
            'label'     : 'material.components.tabs',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/tabs/tabs.js',
            'docs'      : [
                {
                    'name'      : 'mdTab',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.tabs/directive/mdTab.html',
                    'url'       : 'api/directive/mdTab',
                    'label'     : 'mdTab',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/tabs/js/tabDirective.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : 'mdTabs',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.tabs/directive/mdTabs.html',
                    'url'       : 'api/directive/mdTabs',
                    'label'     : 'mdTabs',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/tabs/js/tabsDirective.js'
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.toast',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.toast/index.html',
            'url'       : 'api/material.components.toast',
            'label'     : 'material.components.toast',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/toast/toast.js',
            'docs'      : [
                {
                    'name'      : '$mdToast',
                    'type'      : 'service',
                    'outputPath': 'partials/api/material.components.toast/service/$mdToast.html',
                    'url'       : 'api/service/$mdToast',
                    'label'     : '$mdToast',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/toast/toast.js',
                    'hasDemo'   : false
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.toolbar',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.toolbar/index.html',
            'url'       : 'api/material.components.toolbar',
            'label'     : 'material.components.toolbar',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/toolbar/toolbar.js',
            'docs'      : [
                {
                    'name'      : 'mdToolbar',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.toolbar/directive/mdToolbar.html',
                    'url'       : 'api/directive/mdToolbar',
                    'label'     : 'mdToolbar',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/toolbar/toolbar.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.tooltip',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.tooltip/index.html',
            'url'       : 'api/material.components.tooltip',
            'label'     : 'material.components.tooltip',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/tooltip/tooltip.js',
            'docs'      : [
                {
                    'name'      : 'mdTooltip',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.tooltip/directive/mdTooltip.html',
                    'url'       : 'api/directive/mdTooltip',
                    'label'     : 'mdTooltip',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/tooltip/tooltip.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.virtualRepeat',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.virtualRepeat/index.html',
            'url'       : 'api/material.components.virtualRepeat',
            'label'     : 'material.components.virtualRepeat',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/virtualRepeat/virtual-repeater.js',
            'docs'      : [
                {
                    'name'      : 'mdVirtualRepeatContainer',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.virtualRepeat/directive/mdVirtualRepeatContainer.html',
                    'url'       : 'api/directive/mdVirtualRepeatContainer',
                    'label'     : 'mdVirtualRepeatContainer',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/virtualRepeat/virtual-repeater.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : 'mdVirtualRepeat',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.virtualRepeat/directive/mdVirtualRepeat.html',
                    'url'       : 'api/directive/mdVirtualRepeat',
                    'label'     : 'mdVirtualRepeat',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/virtualRepeat/virtual-repeater.js'
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.whiteframe',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.whiteframe/index.html',
            'url'       : 'api/material.components.whiteframe',
            'label'     : 'material.components.whiteframe',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/whiteframe/whiteframe.js',
            'docs'      : [
                {
                    'name'      : 'mdWhiteframe',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.components.whiteframe/directive/mdWhiteframe.html',
                    'url'       : 'api/directive/mdWhiteframe',
                    'label'     : 'mdWhiteframe',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/whiteframe/whiteframe.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.core.ripple',
            'type'      : 'module',
            'outputPath': 'partials/api/material.core.ripple/index.html',
            'url'       : 'api/material.core.ripple',
            'label'     : 'material.core.ripple',
            'module'    : 'material.core',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/services/ripple/ripple.js',
            'docs'      : [
                {
                    'name'      : 'mdInkRipple',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.core.ripple/directive/mdInkRipple.html',
                    'url'       : 'api/directive/mdInkRipple',
                    'label'     : 'mdInkRipple',
                    'module'    : 'material.core',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/services/ripple/ripple.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : '$mdInkRipple',
                    'type'      : 'service',
                    'outputPath': 'partials/api/material.core.ripple/service/$mdInkRipple.html',
                    'url'       : 'api/service/$mdInkRipple',
                    'label'     : '$mdInkRipple',
                    'module'    : 'material.core',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/services/ripple/ripple.js'
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.core.util',
            'type'      : 'module',
            'outputPath': 'partials/api/material.core.util/index.html',
            'url'       : 'api/material.core.util',
            'label'     : 'material.core.util',
            'module'    : 'material.core',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/util/util.js',
            'docs'      : [
                {
                    'name'      : 'mdAutofocus',
                    'type'      : 'directive',
                    'outputPath': 'partials/api/material.core.util/directive/mdAutofocus.html',
                    'url'       : 'api/directive/mdAutofocus',
                    'label'     : 'mdAutofocus',
                    'module'    : 'material.core',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/util/autofocus.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        }
    ]);
(function ()
{
    'use strict';
    angular
        .module('app.components.material-docs')
        .factory('$demoAngularScripts', DemoAngularScripts);

    function DemoAngularScripts()
    {
        var scripts = [
            'angular.js',
            'angular-animate.min.js',
            'angular-route.min.js',
            'angular-aria.min.js',
            'angular-messages.min.js'
        ];

        return {
            all: allAngularScripts
        };

        function allAngularScripts()
        {
            return scripts.map(fullPathToScript);
        }

        function fullPathToScript(script)
        {
            return "https://ajax.googleapis.com/ajax/libs/angularjs/1.4.8/" + script;
            //return "https://ajax.googleapis.com/ajax/libs/angularjs/" + BUILDCONFIG.ngVersion + "/" + script;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.components.material-docs')
        .directive('demoInclude', demoInclude)

    function demoInclude($q, $http, $compile, $templateCache, $timeout)
    {
        return {
            restrict: 'E',
            link    : postLink
        };

        function postLink(scope, element, attr)
        {
            var demoContainer;

            // Interpret the expression given as `demo-include files="something"`
            var files = scope.$eval(attr.files) || {};
            var ngModule = scope.$eval(attr.module) || '';

            $timeout(handleDemoIndexFile);

            /**
             * Fetch the index file, and if it contains its own ngModule
             * then bootstrap a new angular app with that ngModule. Otherwise, compile
             * the demo into the current ng-app.
             */
            function handleDemoIndexFile()
            {
                files.index.contentsPromise.then(function (contents)
                {
                    demoContainer = angular.element(
                        '<div class="demo-content ' + ngModule + '">'
                    );

                    var isStandalone = !!ngModule;
                    var demoScope;
                    var demoCompileService;
                    if ( isStandalone )
                    {
                        angular.bootstrap(demoContainer[0], [ngModule]);
                        demoScope = demoContainer.scope();
                        demoCompileService = demoContainer.injector().get('$compile');

                        scope.$on('$destroy', function ()
                        {
                            demoScope.$destroy();
                        });

                    }
                    else
                    {
                        demoScope = scope.$new();
                        demoCompileService = $compile;
                    }

                    // Once everything is loaded, put the demo into the DOM
                    $q.all([
                        handleDemoStyles(),
                        handleDemoTemplates()
                    ]).finally(function ()
                    {

                        demoScope.$evalAsync(function ()
                        {
                            element.append(demoContainer);
                            demoContainer.html(contents);
                            demoCompileService(demoContainer.contents())(demoScope);
                        });


                    });
                });

            }


            /**
             * Fetch the demo styles, and append them to the DOM.
             */
            function handleDemoStyles()
            {
                return $q.all(files.css.map(function (file)
                    {
                        return file.contentsPromise;
                    }))
                    .then(function (styles)
                    {
                        styles = styles.join('\n'); //join styles as one string

                        var styleElement = angular.element('<style>' + styles + '</style>');
                        document.body.appendChild(styleElement[0]);

                        scope.$on('$destroy', function ()
                        {
                            styleElement.remove();
                        });
                    });

            }

            /**
             * Fetch the templates for this demo, and put the templates into
             * the demo app's templateCache, with a url that allows the demo apps
             * to reference their templates local to the demo index file.
             *
             * For example, make it so the dialog demo can reference templateUrl
             * 'my-dialog.tmpl.html' instead of having to reference the url
             * 'generated/material.components.dialog/demo/demo1/my-dialog.tmpl.html'.
             */
            function handleDemoTemplates()
            {

                return $q.all(files.html.map(function (file)
                {

                    return file.contentsPromise.then(function (contents)
                    {
                        // Get the $templateCache instance that goes with the demo's specific ng-app.
                        var demoTemplateCache = demoContainer.injector().get('$templateCache');
                        demoTemplateCache.put(file.name, contents);

                        scope.$on('$destroy', function ()
                        {
                            demoTemplateCache.remove(file.name);
                        });

                    });

                }));

            }

        }

    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.components.material-docs')
        .directive('docsDemo', docsDemo)
        .directive('demoFile', demoFile)
        .filter('toHtml', toHtml)
        .directive('layoutAlign', function ()
        {
            return angular.noop;
        })
        .directive('layout', function ()
        {
            return angular.noop;
        });

    /** @ngInject */
    function docsDemo($mdUtil)
    {
        return {
            restrict        : 'E',
            scope           : true,
            templateUrl     : 'app/main/components/material-docs/demo/docs-demo.tmpl.html',
            transclude      : true,
            controller      :DocsDemoCtrl,
            controllerAs    : 'demoCtrl',
            bindToController: true
        };

        function DocsDemoCtrl($scope, $element, $attrs, $interpolate)
        {
            var self = this;

            self.interpolateCode = angular.isDefined($attrs.interpolateCode);
            self.demoId = $interpolate($attrs.demoId || '')($scope.$parent);
            self.demoTitle = $interpolate($attrs.demoTitle || '')($scope.$parent);
            self.demoModule = $interpolate($attrs.demoModule || '')($scope.$parent);
            self.files = {
                css : [],
                js  : [],
                html: []
            };

            self.addFile = function (name, contentsPromise)
            {
                var file = {
                    name           : convertName(name),
                    contentsPromise: contentsPromise,
                    fileType       : name.split('.').pop()
                };
                contentsPromise.then(function (contents)
                {
                    file.contents = contents;
                });

                if ( name === 'index.html' )
                {
                    self.files.index = file;
                }
                else if ( name === 'readme.html' )
                {
                    self.demoDescription = file;
                }
                else
                {
                    self.files[file.fileType] = self.files[file.fileType] || [];
                    self.files[file.fileType].push(file);
                }

                self.orderedFiles = []
                    .concat(self.files.index || [])
                    .concat(self.files.js || [])
                    .concat(self.files.css || [])
                    .concat(self.files.html || []);

            };

            self.editOnCodepen = function ()
            {
                codepen.editOnCodepen({
                    title : self.demoTitle,
                    files : self.files,
                    id    : self.demoId,
                    module: self.demoModule
                });
            };

            function convertName(name)
            {
                switch ( name )
                {
                    case "index.html" :
                        return "HTML";
                    case "script.js" :
                        return "JS";
                    case "style.css" :
                        return "CSS";
                    default :
                        return name;
                }
            }

        }
    }

    /** @ngInject */
    function demoFile($q, $interpolate)
    {
        return {
            restrict: 'E',
            require : '^docsDemo',
            compile : compile
        };

        function compile(element, attr)
        {
            var contentsAttr = attr.contents;
            var html = element.html();
            var name = attr.name;
            element.contents().remove();

            return function postLink(scope, element, attr, docsDemoCtrl)
            {
                docsDemoCtrl.addFile(
                    $interpolate(name)(scope),
                    $q.when(scope.$eval(contentsAttr) || html)
                );
                element.remove();
            };
        }
    }

    /** @ngInject */
    function toHtml($sce)
    {
        return function (str)
        {
            return $sce.trustAsHtml(str);
        };
    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.components.material-docs')
        .factory('$demoAngularScripts', DemoAngularScripts);

    function DemoAngularScripts()
    {
        var scripts = [
            'angular.js',
            'angular-animate.min.js',
            'angular-route.min.js',
            'angular-aria.min.js',
            'angular-messages.min.js'
        ];

        return {
            all: allAngularScripts
        };

        function allAngularScripts()
        {
            return scripts.map(fullPathToScript);
        }

        function fullPathToScript(script)
        {
            return "https://ajax.googleapis.com/ajax/libs/angularjs/" + angular.version.full + "/" + script;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.components.charts.nvd3', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_charts_nvd3', {
            url  : '/components/charts/nvd3',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/charts/nvd3/nvd3.html',
                    controller : 'Nvd3Controller as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.nvd3')
        .controller('Nvd3Controller', Nvd3Controller);

    function Nvd3Controller(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.lineChart = {
            options: {
                chart   : {
                    type                   : 'lineChart',
                    height                 : 450,
                    margin                 : {
                        top   : 20,
                        right : 20,
                        bottom: 40,
                        left  : 55
                    },
                    x                      : function (d)
                    {
                        return d.x;
                    },
                    y                      : function (d)
                    {
                        return d.y;
                    },
                    useInteractiveGuideline: true,
                    xAxis                  : {
                        axisLabel: 'Time (ms)'
                    },
                    yAxis                  : {
                        axisLabel        : 'Voltage (v)',
                        tickFormat       : function (d)
                        {
                            return d3.format('.02f')(d);
                        },
                        axisLabelDistance: 30
                    }
                },
                title   : {
                    enable: true,
                    text  : 'Title for Line Chart'
                },
                subtitle: {
                    enable: true,
                    text  : 'Subtitle for simple line chart. Lorem ipsum dolor sit amet, at eam blandit sadipscing, vim adhuc sanctus disputando ex, cu usu affert alienum urbanitas.',
                    css   : {
                        'text-align': 'center',
                        'margin'    : '10px 13px 0px 7px'
                    }
                },
                caption : {
                    enable: true,
                    html  : '<b>Figure 1.</b> Lorem ipsum dolor sit amet, at eam blandit sadipscing, <span style="text-decoration: underline;">vim adhuc sanctus disputando ex</span>, cu usu affert alienum urbanitas. <i>Cum in purto erat, mea ne nominavi persecuti reformidans.</i> Docendi blandit abhorreant ea has, minim tantas alterum pro eu. <span style="color: darkred;">Exerci graeci ad vix, elit tacimates ea duo</span>. Id mel eruditi fuisset. Stet vidit patrioque in pro, eum ex veri verterem abhorreant, id unum oportere intellegam nec<sup>[1, <a href="https://github.com/krispo/angular-nvd3" target="_blank">2</a>, 3]</sup>.',
                    css   : {
                        'text-align': 'justify',
                        'margin'    : '10px 13px 0px 7px'
                    }
                }
            },
            data   : sinAndCos()
        };

        vm.stackedAreaChart = {
            options: {
                chart: {
                    type                   : 'stackedAreaChart',
                    height                 : 450,
                    margin                 : {
                        top   : 20,
                        right : 20,
                        bottom: 60,
                        left  : 40
                    },
                    x                      : function (d)
                    {
                        return d[0];
                    },
                    y                      : function (d)
                    {
                        return d[1];
                    },
                    useVoronoi             : false,
                    clipEdge               : true,
                    transitionDuration     : 500,
                    useInteractiveGuideline: true,
                    xAxis                  : {
                        showMaxMin: false,
                        tickFormat: function (d)
                        {
                            return d3.time.format('%x')(new Date(d));
                        }
                    },
                    yAxis                  : {
                        tickFormat: function (d)
                        {
                            return d3.format(',.2f')(d);
                        }
                    }
                }
            },

            data: [
                {
                    'key'   : 'North America',
                    'values': [[1025409600000, 23.041422681023], [1028088000000, 19.854291255832], [1030766400000, 21.02286281168], [1033358400000, 22.093608385173], [1036040400000, 25.108079299458], [1038632400000, 26.982389242348], [1041310800000, 19.828984957662], [1043989200000, 19.914055036294], [1046408400000, 19.436150539916], [1049086800000, 21.558650338602], [1051675200000, 24.395594061773], [1054353600000, 24.747089309384], [1056945600000, 23.491755498807], [1059624000000, 23.376634878164], [1062302400000, 24.581223154533], [1064894400000, 24.922476843538], [1067576400000, 27.357712939042], [1070168400000, 26.503020572593], [1072846800000, 26.658901244878], [1075525200000, 27.065704156445], [1078030800000, 28.735320452588], [1080709200000, 31.572277846319], [1083297600000, 30.932161503638], [1085976000000, 31.627029785554], [1088568000000, 28.728743674232], [1091246400000, 26.858365172675], [1093924800000, 27.279922830032], [1096516800000, 34.408301211324], [1099195200000, 34.794362930439], [1101790800000, 35.609978198951], [1104469200000, 33.574394968037], [1107147600000, 31.979405070598], [1109566800000, 31.19009040297], [1112245200000, 31.083933968994], [1114833600000, 29.668971113185], [1117512000000, 31.490638014379], [1120104000000, 31.818617451128], [1122782400000, 32.960314008183], [1125460800000, 31.313383196209], [1128052800000, 33.125486081852], [1130734800000, 32.791805509149], [1133326800000, 33.506038030366], [1136005200000, 26.96501697216], [1138683600000, 27.38478809681], [1141102800000, 27.371377218209], [1143781200000, 26.309915460827], [1146369600000, 26.425199957518], [1149048000000, 26.823411519396], [1151640000000, 23.850443591587], [1154318400000, 23.158355444054], [1156996800000, 22.998689393695], [1159588800000, 27.9771285113], [1162270800000, 29.073672469719], [1164862800000, 28.587640408904], [1167541200000, 22.788453687637], [1170219600000, 22.429199073597], [1172638800000, 22.324103271052], [1175313600000, 17.558388444187], [1177905600000, 16.769518096208], [1180584000000, 16.214738201301], [1183176000000, 18.729632971229], [1185854400000, 18.814523318847], [1188532800000, 19.789986451358], [1191124800000, 17.070049054933], [1193803200000, 16.121349575716], [1196398800000, 15.141659430091], [1199077200000, 17.175388025297], [1201755600000, 17.286592443522], [1204261200000, 16.323141626568], [1206936000000, 19.231263773952], [1209528000000, 18.446256391095], [1212206400000, 17.822632399764], [1214798400000, 15.53936647598], [1217476800000, 15.255131790217], [1220155200000, 15.660963922592], [1222747200000, 13.254482273698], [1225425600000, 11.920796202299], [1228021200000, 12.122809090924], [1230699600000, 15.691026271393], [1233378000000, 14.720881635107], [1235797200000, 15.387939360044], [1238472000000, 13.765436672228], [1241064000000, 14.631445864799], [1243742400000, 14.292446536221], [1246334400000, 16.170071367017], [1249012800000, 15.948135554337], [1251691200000, 16.612872685134], [1254283200000, 18.778338719091], [1256961600000, 16.756026065421], [1259557200000, 19.385804443146], [1262235600000, 22.950590240168], [1264914000000, 23.61159018141], [1267333200000, 25.708586989581], [1270008000000, 26.883915999885], [1272600000000, 25.893486687065], [1275278400000, 24.678914263176], [1277870400000, 25.937275793024], [1280548800000, 29.461381693838], [1283227200000, 27.357322961861], [1285819200000, 29.057235285673], [1288497600000, 28.549434189386], [1291093200000, 28.506352379724], [1293771600000, 29.449241421598], [1296450000000, 25.796838168807], [1298869200000, 28.740145449188], [1301544000000, 22.091744141872], [1304136000000, 25.07966254541], [1306814400000, 23.674906973064], [1309406400000, 23.418002742929], [1312084800000, 23.24364413887], [1314763200000, 31.591854066817], [1317355200000, 31.497112374114], [1320033600000, 26.67238082043], [1322629200000, 27.297080015495], [1325307600000, 20.174315530051], [1327986000000, 19.631084213898], [1330491600000, 20.366462219461], [1333166400000, 19.284784434185], [1335758400000, 19.157810257624]]
                },

                {
                    'key'   : 'Africa',
                    'values': [[1025409600000, 7.9356392949025], [1028088000000, 7.4514668527298], [1030766400000, 7.9085410566608], [1033358400000, 5.8996782364764], [1036040400000, 6.0591869346923], [1038632400000, 5.9667815800451], [1041310800000, 8.65528925664], [1043989200000, 8.7690763386254], [1046408400000, 8.6386160387453], [1049086800000, 5.9895557449743], [1051675200000, 6.3840324338159], [1054353600000, 6.5196511461441], [1056945600000, 7.0738618553114], [1059624000000, 6.5745957367133], [1062302400000, 6.4658359184444], [1064894400000, 2.7622758754954], [1067576400000, 2.9794782986241], [1070168400000, 2.8735432712019], [1072846800000, 1.6344817513645], [1075525200000, 1.5869248754883], [1078030800000, 1.7172279157246], [1080709200000, 1.9649927409867], [1083297600000, 2.0261695079196], [1085976000000, 2.0541261923929], [1088568000000, 3.9466318927569], [1091246400000, 3.7826770946089], [1093924800000, 3.9543021004028], [1096516800000, 3.8309891064711], [1099195200000, 3.6340958946166], [1101790800000, 3.5289755762525], [1104469200000, 5.702378559857], [1107147600000, 5.6539569019223], [1109566800000, 5.5449506370392], [1112245200000, 4.7579993280677], [1114833600000, 4.4816139372906], [1117512000000, 4.5965558568606], [1120104000000, 4.3747066116976], [1122782400000, 4.4588822917087], [1125460800000, 4.4460351848286], [1128052800000, 3.7989113035136], [1130734800000, 3.7743883140088], [1133326800000, 3.7727852823828], [1136005200000, 7.2968111448895], [1138683600000, 7.2800122043237], [1141102800000, 7.1187787503354], [1143781200000, 8.351887016482], [1146369600000, 8.4156698763993], [1149048000000, 8.1673298604231], [1151640000000, 5.5132447126042], [1154318400000, 6.1152537710599], [1156996800000, 6.076765091942], [1159588800000, 4.6304473798646], [1162270800000, 4.6301068469402], [1164862800000, 4.3466656309389], [1167541200000, 6.830104897003], [1170219600000, 7.241633040029], [1172638800000, 7.1432372054153], [1175313600000, 10.608942063374], [1177905600000, 10.914964549494], [1180584000000, 10.933223880565], [1183176000000, 8.3457524851265], [1185854400000, 8.1078413081882], [1188532800000, 8.2697185922474], [1191124800000, 8.4742436475968], [1193803200000, 8.4994601179319], [1196398800000, 8.7387319683243], [1199077200000, 6.8829183612895], [1201755600000, 6.984133637885], [1204261200000, 7.0860136043287], [1206936000000, 4.3961787956053], [1209528000000, 3.8699674365231], [1212206400000, 3.6928925238305], [1214798400000, 6.7571718894253], [1217476800000, 6.4367313362344], [1220155200000, 6.4048441521454], [1222747200000, 5.4643833239669], [1225425600000, 5.3150786833374], [1228021200000, 5.3011272612576], [1230699600000, 4.1203601430809], [1233378000000, 4.0881783200525], [1235797200000, 4.1928665957189], [1238472000000, 7.0249415663205], [1241064000000, 7.006530880769], [1243742400000, 6.994835633224], [1246334400000, 6.1220222336254], [1249012800000, 6.1177436137653], [1251691200000, 6.1413396231981], [1254283200000, 4.8046006145874], [1256961600000, 4.6647600660544], [1259557200000, 4.544865006255], [1262235600000, 6.0488249316539], [1264914000000, 6.3188669540206], [1267333200000, 6.5873958262306], [1270008000000, 6.2281189839578], [1272600000000, 5.8948915746059], [1275278400000, 5.5967320482214], [1277870400000, 0.99784432084837], [1280548800000, 1.0950794175359], [1283227200000, 0.94479734407491], [1285819200000, 1.222093988688], [1288497600000, 1.335093106856], [1291093200000, 1.3302565104985], [1293771600000, 1.340824670897], [1296450000000, 0], [1298869200000, 0], [1301544000000, 0], [1304136000000, 0], [1306814400000, 0], [1309406400000, 0], [1312084800000, 0], [1314763200000, 0], [1317355200000, 4.4583692315], [1320033600000, 3.6493043348059], [1322629200000, 3.8610064091761], [1325307600000, 5.5144800685202], [1327986000000, 5.1750695220791], [1330491600000, 5.6710066952691], [1333166400000, 5.5611890039181], [1335758400000, 5.5979368839939]]
                },

                {
                    'key'   : 'South America',
                    'values': [[1025409600000, 7.9149900245423], [1028088000000, 7.0899888751059], [1030766400000, 7.5996132380614], [1033358400000, 8.2741174301034], [1036040400000, 9.3564460833513], [1038632400000, 9.7066786059904], [1041310800000, 10.213363052343], [1043989200000, 10.285809585273], [1046408400000, 10.222053149228], [1049086800000, 8.6188592137975], [1051675200000, 9.3335447543566], [1054353600000, 8.9312402186628], [1056945600000, 8.1895089343658], [1059624000000, 8.260622135079], [1062302400000, 7.7700786851364], [1064894400000, 7.9907428771318], [1067576400000, 8.7769091865606], [1070168400000, 8.4855077060661], [1072846800000, 9.6277203033655], [1075525200000, 9.9685913452624], [1078030800000, 10.615085181759], [1080709200000, 9.2902488079646], [1083297600000, 8.8610439830061], [1085976000000, 9.1075344931229], [1088568000000, 9.9156737639203], [1091246400000, 9.7826003238782], [1093924800000, 10.55403610555], [1096516800000, 10.926900264097], [1099195200000, 10.903144818736], [1101790800000, 10.862890389067], [1104469200000, 10.64604998964], [1107147600000, 10.042790814087], [1109566800000, 9.7173391591038], [1112245200000, 9.6122415755443], [1114833600000, 9.4337921146562], [1117512000000, 9.814827171183], [1120104000000, 12.059260396788], [1122782400000, 12.139649903873], [1125460800000, 12.281290663822], [1128052800000, 8.8037085409056], [1130734800000, 8.6300618239176], [1133326800000, 9.1225708491432], [1136005200000, 12.988124170836], [1138683600000, 13.356778764353], [1141102800000, 13.611196863271], [1143781200000, 6.8959030061189], [1146369600000, 6.9939633271353], [1149048000000, 6.7241510257676], [1151640000000, 5.5611293669517], [1154318400000, 5.6086488714041], [1156996800000, 5.4962849907033], [1159588800000, 6.9193153169278], [1162270800000, 7.0016334389778], [1164862800000, 6.7865422443273], [1167541200000, 9.0006454225383], [1170219600000, 9.2233916171431], [1172638800000, 8.8929316009479], [1175313600000, 10.345937520404], [1177905600000, 10.075914677026], [1180584000000, 10.089006188111], [1183176000000, 10.598330295008], [1185854400000, 9.9689546533009], [1188532800000, 9.7740580198146], [1191124800000, 10.558483060626], [1193803200000, 9.9314651823603], [1196398800000, 9.3997715873769], [1199077200000, 8.4086493387262], [1201755600000, 8.9698309085926], [1204261200000, 8.2778357995396], [1206936000000, 8.8585045600123], [1209528000000, 8.7013756413322], [1212206400000, 7.7933605469443], [1214798400000, 7.0236183483064], [1217476800000, 6.9873088186829], [1220155200000, 6.8031713070097], [1222747200000, 6.6869531315723], [1225425600000, 6.138256993963], [1228021200000, 5.6434994016354], [1230699600000, 5.495220262512], [1233378000000, 4.6885326869846], [1235797200000, 4.4524349883438], [1238472000000, 5.6766520778185], [1241064000000, 5.7675774480752], [1243742400000, 5.7882863168337], [1246334400000, 7.2666010034924], [1249012800000, 7.5191821322261], [1251691200000, 7.849651451445], [1254283200000, 10.383992037985], [1256961600000, 9.0653691861818], [1259557200000, 9.6705248324159], [1262235600000, 10.856380561349], [1264914000000, 11.27452370892], [1267333200000, 11.754156529088], [1270008000000, 8.2870811422455], [1272600000000, 8.0210264360699], [1275278400000, 7.5375074474865], [1277870400000, 8.3419527338039], [1280548800000, 9.4197471818443], [1283227200000, 8.7321733185797], [1285819200000, 9.6627062648126], [1288497600000, 10.187962234548], [1291093200000, 9.8144201733476], [1293771600000, 10.275723361712], [1296450000000, 16.796066079353], [1298869200000, 17.543254984075], [1301544000000, 16.673660675083], [1304136000000, 17.963944353609], [1306814400000, 16.63774086721], [1309406400000, 15.84857094609], [1312084800000, 14.767303362181], [1314763200000, 24.778452182433], [1317355200000, 18.370353229999], [1320033600000, 15.253137429099], [1322629200000, 14.989600840649], [1325307600000, 16.052539160125], [1327986000000, 16.424390322793], [1330491600000, 17.884020741104], [1333166400000, 18.372698836036], [1335758400000, 18.315881576096]]
                },

                {
                    'key'   : 'Asia',
                    'values': [[1025409600000, 13.153938631352], [1028088000000, 12.456410521864], [1030766400000, 12.537048663919], [1033358400000, 13.947386398309], [1036040400000, 14.421680682568], [1038632400000, 14.143238262286], [1041310800000, 12.229635347478], [1043989200000, 12.508479916948], [1046408400000, 12.155368409526], [1049086800000, 13.335455563994], [1051675200000, 12.888210138167], [1054353600000, 12.842092790511], [1056945600000, 12.513816474199], [1059624000000, 12.21453674494], [1062302400000, 11.750848343935], [1064894400000, 10.526579636787], [1067576400000, 10.873596086087], [1070168400000, 11.019967131519], [1072846800000, 11.235789380602], [1075525200000, 11.859910850657], [1078030800000, 12.531031616536], [1080709200000, 11.360451067019], [1083297600000, 11.456244780202], [1085976000000, 11.436991407309], [1088568000000, 11.638595744327], [1091246400000, 11.190418301469], [1093924800000, 11.835608007589], [1096516800000, 11.540980244475], [1099195200000, 10.958762325687], [1101790800000, 10.885791159509], [1104469200000, 13.605810720109], [1107147600000, 13.128978067437], [1109566800000, 13.119012086882], [1112245200000, 13.003706129783], [1114833600000, 13.326996807689], [1117512000000, 13.547947991743], [1120104000000, 12.807959646616], [1122782400000, 12.931763821068], [1125460800000, 12.795359993008], [1128052800000, 9.6998935538319], [1130734800000, 9.3473740089131], [1133326800000, 9.36902067716], [1136005200000, 14.258619539875], [1138683600000, 14.21241095603], [1141102800000, 13.973193618249], [1143781200000, 15.218233920664], [1146369600000, 14.382109727451], [1149048000000, 13.894310878491], [1151640000000, 15.593086090031], [1154318400000, 16.244839695189], [1156996800000, 16.017088850647], [1159588800000, 14.183951830057], [1162270800000, 14.148523245696], [1164862800000, 13.424326059971], [1167541200000, 12.974450435754], [1170219600000, 13.232470418021], [1172638800000, 13.318762655574], [1175313600000, 15.961407746104], [1177905600000, 16.287714639805], [1180584000000, 16.24659058389], [1183176000000, 17.564505594808], [1185854400000, 17.872725373164], [1188532800000, 18.018998508756], [1191124800000, 15.584518016602], [1193803200000, 15.480850647182], [1196398800000, 15.699120036985], [1199077200000, 19.184281817226], [1201755600000, 19.691226605205], [1204261200000, 18.982314051293], [1206936000000, 18.707820309008], [1209528000000, 17.459630929759], [1212206400000, 16.500616076782], [1214798400000, 18.086324003978], [1217476800000, 18.929464156259], [1220155200000, 18.233728682084], [1222747200000, 16.315776297325], [1225425600000, 14.632892190251], [1228021200000, 14.667835024479], [1230699600000, 13.946993947309], [1233378000000, 14.394304684398], [1235797200000, 13.724462792967], [1238472000000, 10.930879035807], [1241064000000, 9.8339915513708], [1243742400000, 10.053858541872], [1246334400000, 11.786998438286], [1249012800000, 11.780994901769], [1251691200000, 11.305889670277], [1254283200000, 10.918452290083], [1256961600000, 9.6811395055706], [1259557200000, 10.971529744038], [1262235600000, 13.330210480209], [1264914000000, 14.592637568961], [1267333200000, 14.605329141157], [1270008000000, 13.936853794037], [1272600000000, 12.189480759072], [1275278400000, 11.676151385046], [1277870400000, 13.058852800018], [1280548800000, 13.62891543203], [1283227200000, 13.811107569918], [1285819200000, 13.786494560786], [1288497600000, 14.045162857531], [1291093200000, 13.697412447286], [1293771600000, 13.677681376221], [1296450000000, 19.96151186453], [1298869200000, 21.049198298156], [1301544000000, 22.687631094009], [1304136000000, 25.469010617433], [1306814400000, 24.88379943712], [1309406400000, 24.203843814249], [1312084800000, 22.138760964036], [1314763200000, 16.034636966228], [1317355200000, 15.394958944555], [1320033600000, 12.62564246197], [1322629200000, 12.973735699739], [1325307600000, 15.78601833615], [1327986000000, 15.227368020134], [1330491600000, 15.899752650733], [1333166400000, 15.661317319168], [1335758400000, 15.359891177281]]
                },

                {
                    'key'   : 'Europe',
                    'values': [[1025409600000, 9.3433263069351], [1028088000000, 8.4583069475546], [1030766400000, 8.0342398154196], [1033358400000, 8.1538966876572], [1036040400000, 10.743604786849], [1038632400000, 12.349366155851], [1041310800000, 10.742682503899], [1043989200000, 11.360983869935], [1046408400000, 11.441336039535], [1049086800000, 10.897508791837], [1051675200000, 11.469101547709], [1054353600000, 12.086311476742], [1056945600000, 8.0697180773504], [1059624000000, 8.2004392233445], [1062302400000, 8.4566434900643], [1064894400000, 7.9565760979059], [1067576400000, 9.3764619255827], [1070168400000, 9.0747664160538], [1072846800000, 10.508939004673], [1075525200000, 10.69936754483], [1078030800000, 10.681562399145], [1080709200000, 13.184786109406], [1083297600000, 12.668213052351], [1085976000000, 13.430509403986], [1088568000000, 12.393086349213], [1091246400000, 11.942374044842], [1093924800000, 12.062227685742], [1096516800000, 11.969974363623], [1099195200000, 12.14374574055], [1101790800000, 12.69422821995], [1104469200000, 9.1235211044692], [1107147600000, 8.758211757584], [1109566800000, 8.8072309258443], [1112245200000, 11.687595946835], [1114833600000, 11.079723082664], [1117512000000, 12.049712896076], [1120104000000, 10.725319428684], [1122782400000, 10.844849996286], [1125460800000, 10.833535488461], [1128052800000, 17.180932407865], [1130734800000, 15.894764896516], [1133326800000, 16.412751299498], [1136005200000, 12.573569093402], [1138683600000, 13.242301508051], [1141102800000, 12.863536342041], [1143781200000, 21.034044171629], [1146369600000, 21.419084618802], [1149048000000, 21.142678863692], [1151640000000, 26.56848967753], [1154318400000, 24.839144939906], [1156996800000, 25.456187462166], [1159588800000, 26.350164502825], [1162270800000, 26.478333205189], [1164862800000, 26.425979547846], [1167541200000, 28.191461582256], [1170219600000, 28.930307448808], [1172638800000, 29.521413891117], [1175313600000, 28.188285966466], [1177905600000, 27.704619625831], [1180584000000, 27.49086242483], [1183176000000, 28.770679721286], [1185854400000, 29.06048067145], [1188532800000, 28.240998844973], [1191124800000, 33.004893194128], [1193803200000, 34.075180359928], [1196398800000, 32.548560664834], [1199077200000, 30.629727432729], [1201755600000, 28.642858788159], [1204261200000, 27.973575227843], [1206936000000, 27.393351882726], [1209528000000, 28.476095288522], [1212206400000, 29.29667866426], [1214798400000, 29.222333802896], [1217476800000, 28.092966093842], [1220155200000, 28.107159262922], [1222747200000, 25.482974832099], [1225425600000, 21.208115993834], [1228021200000, 20.295043095268], [1230699600000, 15.925754618402], [1233378000000, 17.162864628346], [1235797200000, 17.084345773174], [1238472000000, 22.24600710228], [1241064000000, 24.530543998508], [1243742400000, 25.084184918241], [1246334400000, 16.606166527359], [1249012800000, 17.239620011628], [1251691200000, 17.336739127379], [1254283200000, 25.478492475754], [1256961600000, 23.017152085244], [1259557200000, 25.617745423684], [1262235600000, 24.061133998641], [1264914000000, 23.223933318646], [1267333200000, 24.425887263936], [1270008000000, 35.501471156693], [1272600000000, 33.775013878675], [1275278400000, 30.417993630285], [1277870400000, 30.023598978467], [1280548800000, 33.327519522436], [1283227200000, 31.963388450372], [1285819200000, 30.49896723209], [1288497600000, 32.403696817913], [1291093200000, 31.47736071922], [1293771600000, 31.53259666241], [1296450000000, 41.760282761548], [1298869200000, 45.605771243237], [1301544000000, 39.986557966215], [1304136000000, 43.84633051005], [1306814400000, 39.857316881858], [1309406400000, 37.675127768207], [1312084800000, 35.775077970313], [1314763200000, 48.631009702578], [1317355200000, 42.830831754505], [1320033600000, 35.611502589362], [1322629200000, 35.320136981738], [1325307600000, 31.564136901516], [1327986000000, 32.074407502433], [1330491600000, 35.053013769977], [1333166400000, 33.873085184128], [1335758400000, 32.321039427046]]
                },

                {
                    'key'   : 'Australia',
                    'values': [[1025409600000, 5.1162447683392], [1028088000000, 4.2022848306513], [1030766400000, 4.3543715758736], [1033358400000, 5.4641223667245], [1036040400000, 6.0041275884577], [1038632400000, 6.6050520064486], [1041310800000, 5.0154059912793], [1043989200000, 5.1835708554647], [1046408400000, 5.1142682006164], [1049086800000, 5.0271381717695], [1051675200000, 5.3437782653456], [1054353600000, 5.2105844515767], [1056945600000, 6.552565997799], [1059624000000, 6.9873363581831], [1062302400000, 7.010986789097], [1064894400000, 4.4254242025515], [1067576400000, 4.9613848042174], [1070168400000, 4.8854920484764], [1072846800000, 4.0441111794228], [1075525200000, 4.0219596813179], [1078030800000, 4.3065749225355], [1080709200000, 3.9148434915404], [1083297600000, 3.8659430654512], [1085976000000, 3.9572824600686], [1088568000000, 4.7372190641522], [1091246400000, 4.6871476374455], [1093924800000, 5.0398702564196], [1096516800000, 5.5221787544964], [1099195200000, 5.424646299798], [1101790800000, 5.9240223067349], [1104469200000, 5.9936860983601], [1107147600000, 5.8499523215019], [1109566800000, 6.4149040329325], [1112245200000, 6.4547895561969], [1114833600000, 5.9385382611161], [1117512000000, 6.0486751030592], [1120104000000, 5.23108613838], [1122782400000, 5.5857797121029], [1125460800000, 5.3454665096987], [1128052800000, 5.0439154120119], [1130734800000, 5.054634702913], [1133326800000, 5.3819451380848], [1136005200000, 5.2638869269803], [1138683600000, 5.5806167415681], [1141102800000, 5.4539047069985], [1143781200000, 7.6728842432362], [1146369600000, 7.719946716654], [1149048000000, 8.0144619912942], [1151640000000, 7.942223133434], [1154318400000, 8.3998279827444], [1156996800000, 8.532324572605], [1159588800000, 4.7324285199763], [1162270800000, 4.7402397487697], [1164862800000, 4.9042069355168], [1167541200000, 5.9583963430882], [1170219600000, 6.3693899239171], [1172638800000, 6.261153903813], [1175313600000, 5.3443942184584], [1177905600000, 5.4932111235361], [1180584000000, 5.5747393101109], [1183176000000, 5.3833633060013], [1185854400000, 5.5125898831832], [1188532800000, 5.8116112661327], [1191124800000, 4.3962296939996], [1193803200000, 4.6967663605521], [1196398800000, 4.7963004350914], [1199077200000, 4.1817985183351], [1201755600000, 4.3797643870182], [1204261200000, 4.6966642197965], [1206936000000, 4.3609995132565], [1209528000000, 4.4736290996496], [1212206400000, 4.3749762738128], [1214798400000, 3.3274661194507], [1217476800000, 3.0316184691337], [1220155200000, 2.5718140204728], [1222747200000, 2.7034994044603], [1225425600000, 2.2033786591364], [1228021200000, 1.9850621240805], [1230699600000, 0], [1233378000000, 0], [1235797200000, 0], [1238472000000, 0], [1241064000000, 0], [1243742400000, 0], [1246334400000, 0], [1249012800000, 0], [1251691200000, 0], [1254283200000, 0.44495950017788], [1256961600000, 0.33945469262483], [1259557200000, 0.38348269455195], [1262235600000, 0], [1264914000000, 0], [1267333200000, 0], [1270008000000, 0], [1272600000000, 0], [1275278400000, 0], [1277870400000, 0], [1280548800000, 0], [1283227200000, 0], [1285819200000, 0], [1288497600000, 0], [1291093200000, 0], [1293771600000, 0], [1296450000000, 0.52216435716176], [1298869200000, 0.59275786698454], [1301544000000, 0], [1304136000000, 0], [1306814400000, 0], [1309406400000, 0], [1312084800000, 0], [1314763200000, 0], [1317355200000, 0], [1320033600000, 0], [1322629200000, 0], [1325307600000, 0], [1327986000000, 0], [1330491600000, 0], [1333166400000, 0], [1335758400000, 0]]
                },

                {
                    'key'   : 'Antarctica',
                    'values': [[1025409600000, 1.3503144674343], [1028088000000, 1.2232741112434], [1030766400000, 1.3930470790784], [1033358400000, 1.2631275030593], [1036040400000, 1.5842699103708], [1038632400000, 1.9546996043116], [1041310800000, 0.8504048300986], [1043989200000, 0.85340686311353], [1046408400000, 0.843061357391], [1049086800000, 2.119846992476], [1051675200000, 2.5285382124858], [1054353600000, 2.5056570712835], [1056945600000, 2.5212789901005], [1059624000000, 2.6192011642534], [1062302400000, 2.5382187823805], [1064894400000, 2.3393223047168], [1067576400000, 2.491219888698], [1070168400000, 2.497555874906], [1072846800000, 1.734018115546], [1075525200000, 1.9307268299646], [1078030800000, 2.2261679836799], [1080709200000, 1.7608893704206], [1083297600000, 1.6242690616808], [1085976000000, 1.7161663801295], [1088568000000, 1.7183554537038], [1091246400000, 1.7179780759145], [1093924800000, 1.7314274801784], [1096516800000, 1.2596883356752], [1099195200000, 1.381177053009], [1101790800000, 1.4408819615814], [1104469200000, 3.4743581836444], [1107147600000, 3.3603749903192], [1109566800000, 3.5350883257893], [1112245200000, 3.0949644237828], [1114833600000, 3.0796455899995], [1117512000000, 3.3441247640644], [1120104000000, 4.0947643978168], [1122782400000, 4.4072631274052], [1125460800000, 4.4870979780825], [1128052800000, 4.8404549457934], [1130734800000, 4.8293016233697], [1133326800000, 5.2238093263952], [1136005200000, 3.382306337815], [1138683600000, 3.7056975170243], [1141102800000, 3.7561118692318], [1143781200000, 2.861913700854], [1146369600000, 2.9933744103381], [1149048000000, 2.7127537218463], [1151640000000, 3.1195497076283], [1154318400000, 3.4066964004508], [1156996800000, 3.3754571113569], [1159588800000, 2.2965579982924], [1162270800000, 2.4486818633018], [1164862800000, 2.4002308848517], [1167541200000, 1.9649579750349], [1170219600000, 1.9385263638056], [1172638800000, 1.9128975336387], [1175313600000, 2.3412869836298], [1177905600000, 2.4337870351445], [1180584000000, 2.62179703171], [1183176000000, 3.2642864957929], [1185854400000, 3.3200396223709], [1188532800000, 3.3934212707572], [1191124800000, 4.2822327088179], [1193803200000, 4.1474964228541], [1196398800000, 4.1477082879801], [1199077200000, 5.2947122916128], [1201755600000, 5.2919843508028], [1204261200000, 5.198978305031], [1206936000000, 3.5603057673513], [1209528000000, 3.3009087690692], [1212206400000, 3.1784852603792], [1214798400000, 4.5889503538868], [1217476800000, 4.401779617494], [1220155200000, 4.2208301828278], [1222747200000, 3.89396671475], [1225425600000, 3.0423832241354], [1228021200000, 3.135520611578], [1230699600000, 1.9631418164089], [1233378000000, 1.8963543874958], [1235797200000, 1.8266636017025], [1238472000000, 0.93136635895188], [1241064000000, 0.92737801918888], [1243742400000, 0.97591889805002], [1246334400000, 2.6841193805515], [1249012800000, 2.5664341140531], [1251691200000, 2.3887523699873], [1254283200000, 1.1737801663681], [1256961600000, 1.0953582317281], [1259557200000, 1.2495674976653], [1262235600000, 0.36607452464754], [1264914000000, 0.3548719047291], [1267333200000, 0.36769242398939], [1270008000000, 0], [1272600000000, 0], [1275278400000, 0], [1277870400000, 0], [1280548800000, 0], [1283227200000, 0], [1285819200000, 0.85450741275337], [1288497600000, 0.91360317921637], [1291093200000, 0.89647678692269], [1293771600000, 0.87800687192639], [1296450000000, 0], [1298869200000, 0], [1301544000000, 0.43668720882994], [1304136000000, 0.4756523602692], [1306814400000, 0.46947368328469], [1309406400000, 0.45138896152316], [1312084800000, 0.43828726648117], [1314763200000, 2.0820861395316], [1317355200000, 0.9364411075395], [1320033600000, 0.60583907839773], [1322629200000, 0.61096950747437], [1325307600000, 0], [1327986000000, 0], [1330491600000, 0], [1333166400000, 0], [1335758400000, 0]]
                }

            ]
        };

        vm.historicalBarChart = {
            options: {
                chart: {
                    type              : 'historicalBarChart',
                    height            : 450,
                    margin            : {
                        top   : 20,
                        right : 20,
                        bottom: 60,
                        left  : 50
                    },
                    x                 : function (d)
                    {
                        return d[0];
                    },
                    y                 : function (d)
                    {
                        return d[1] / 100000;
                    },
                    showValues        : true,
                    valueFormat       : function (d)
                    {
                        return d3.format(',.1f')(d);
                    },
                    transitionDuration: 500,
                    xAxis             : {
                        axisLabel   : 'X Axis',
                        tickFormat  : function (d)
                        {
                            return d3.time.format('%x')(new Date(d));
                        },
                        rotateLabels: 50,
                        showMaxMin  : false
                    },
                    yAxis             : {
                        axisLabel        : 'Y Axis',
                        axisLabelDistance: 35,
                        tickFormat       : function (d)
                        {
                            return d3.format(',.1f')(d);
                        }
                    }
                }
            },

            data: [
                {
                    'key'   : 'Quantity',
                    'bar'   : true,
                    'values': [[1159588800000, 3899486.0], [1162270800000, 3899486.0], [1164862800000, 3899486.0], [1167541200000, 3564700.0], [1170219600000, 3564700.0], [1172638800000, 3564700.0], [1175313600000, 2648493.0], [1177905600000, 2648493.0], [1180584000000, 2648493.0], [1183176000000, 2522993.0], [1185854400000, 2522993.0], [1188532800000, 2522993.0], [1191124800000, 2906501.0], [1193803200000, 2906501.0], [1196398800000, 2906501.0], [1199077200000, 2206761.0], [1201755600000, 2206761.0], [1204261200000, 2206761.0], [1206936000000, 2287726.0], [1209528000000, 2287726.0], [1212206400000, 2287726.0], [1214798400000, 2732646.0], [1217476800000, 2732646.0], [1220155200000, 2732646.0], [1222747200000, 2599196.0], [1225425600000, 2599196.0], [1228021200000, 2599196.0], [1230699600000, 1924387.0], [1233378000000, 1924387.0], [1235797200000, 1924387.0], [1238472000000, 1756311.0], [1241064000000, 1756311.0], [1243742400000, 1756311.0], [1246334400000, 1743470.0], [1249012800000, 1743470.0], [1251691200000, 1743470.0], [1254283200000, 1519010.0], [1256961600000, 1519010.0], [1259557200000, 1519010.0], [1262235600000, 1591444.0], [1264914000000, 1591444.0], [1267333200000, 1591444.0], [1270008000000, 1543784.0], [1272600000000, 1543784.0], [1275278400000, 1543784.0], [1277870400000, 1309915.0], [1280548800000, 1309915.0], [1283227200000, 1309915.0], [1285819200000, 1331875.0], [1288497600000, 1331875.0], [1291093200000, 1331875.0], [1293771600000, 1331875.0], [1296450000000, 1154695.0], [1298869200000, 1154695.0], [1301544000000, 1194025.0], [1304136000000, 1194025.0], [1306814400000, 1194025.0], [1309406400000, 1194025.0], [1312084800000, 1194025.0], [1314763200000, 1244525.0], [1317355200000, 475000.0], [1320033600000, 475000.0], [1322629200000, 475000.0], [1325307600000, 690033.0], [1327986000000, 690033.0], [1330491600000, 690033.0], [1333166400000, 514733.0], [1335758400000, 514733.0]]
                }]
        };

        vm.multiBarHorizontalChart = {
            options: {
                chart: {
                    type              : 'multiBarHorizontalChart',
                    height            : 450,
                    x                 : function (d)
                    {
                        return d.label;
                    },
                    y                 : function (d)
                    {
                        return d.value;
                    },
                    showControls      : true,
                    showValues        : true,
                    transitionDuration: 500,
                    xAxis             : {
                        showMaxMin: false
                    },
                    yAxis             : {
                        axisLabel : 'Values',
                        tickFormat: function (d)
                        {
                            return d3.format(',.2f')(d);
                        }
                    }
                }
            },
            data   : [
                {
                    'key'   : 'Series1',
                    'color' : '#d62728',
                    'values': [
                        {
                            'label': 'Group A',
                            'value': -1.8746444827653
                        },
                        {
                            'label': 'Group B',
                            'value': -8.0961543492239
                        },
                        {
                            'label': 'Group C',
                            'value': -0.57072943117674
                        },
                        {
                            'label': 'Group D',
                            'value': -2.4174010336624
                        },
                        {
                            'label': 'Group E',
                            'value': -0.72009071426284
                        },
                        {
                            'label': 'Group F',
                            'value': -0.77154485523777
                        },
                        {
                            'label': 'Group G',
                            'value': -0.90152097798131
                        },
                        {
                            'label': 'Group H',
                            'value': -0.91445417330854
                        },
                        {
                            'label': 'Group I',
                            'value': -0.055746319141851
                        }
                    ]
                },
                {
                    'key'   : 'Series2',
                    'color' : '#1f77b4',
                    'values': [
                        {
                            'label': 'Group A',
                            'value': 25.307646510375
                        },
                        {
                            'label': 'Group B',
                            'value': 16.756779544553
                        },
                        {
                            'label': 'Group C',
                            'value': 18.451534877007
                        },
                        {
                            'label': 'Group D',
                            'value': 8.6142352811805
                        },
                        {
                            'label': 'Group E',
                            'value': 7.8082472075876
                        },
                        {
                            'label': 'Group F',
                            'value': 5.259101026956
                        },
                        {
                            'label': 'Group G',
                            'value': 0.30947953487127
                        },
                        {
                            'label': 'Group H',
                            'value': 0
                        },
                        {
                            'label': 'Group I',
                            'value': 0
                        }
                    ]
                }
            ]
        };

        vm.pieChart = {
            options: {
                chart: {
                    type              : 'pieChart',
                    height            : 500,
                    x                 : function (d)
                    {
                        return d.key;
                    },
                    y                 : function (d)
                    {
                        return d.y;
                    },
                    showLabels        : true,
                    transitionDuration: 500,
                    labelThreshold    : 0.01,
                    legend            : {
                        margin: {
                            top   : 5,
                            right : 35,
                            bottom: 5,
                            left  : 0
                        }
                    }
                }
            },
            data   : [
                {
                    key: 'One',
                    y  : 5
                },
                {
                    key: 'Two',
                    y  : 2
                },
                {
                    key: 'Three',
                    y  : 9
                },
                {
                    key: 'Four',
                    y  : 7
                },
                {
                    key: 'Five',
                    y  : 4
                },
                {
                    key: 'Six',
                    y  : 3
                },
                {
                    key: 'Seven',
                    y  : 0.5
                }
            ]
        };

        vm.donutChart = {
            options: {
                chart: {
                    type      : 'pieChart',
                    height    : 450,
                    donut     : true,
                    x         : function (d)
                    {
                        return d.key;
                    },
                    y         : function (d)
                    {
                        return d.y;
                    },
                    showLabels: true,

                    pie               : {
                        startAngle: function (d)
                        {
                            return d.startAngle / 2 - Math.PI / 2;
                        },
                        endAngle  : function (d)
                        {
                            return d.endAngle / 2 - Math.PI / 2;
                        }
                    },
                    transitionDuration: 500,
                    legend            : {
                        margin: {
                            top   : 5,
                            right : 70,
                            bottom: 5,
                            left  : 0
                        }
                    }
                }
            },

            data: [
                {
                    key: 'One',
                    y  : 5
                },
                {
                    key: 'Two',
                    y  : 2
                },
                {
                    key: 'Three',
                    y  : 9
                },
                {
                    key: 'Four',
                    y  : 7
                },
                {
                    key: 'Five',
                    y  : 4
                },
                {
                    key: 'Six',
                    y  : 3
                },
                {
                    key: 'Seven',
                    y  : 0.5
                }
            ]

        };

        vm.sparklineChart = {
            options: {
                chart: {
                    type              : 'sparklinePlus',
                    height            : 450,
                    x                 : function (d, i)
                    {
                        return i;
                    },
                    xTickFormat       : function (d)
                    {
                        return d3.time.format('%x')(new Date(vm.sparklineChart.data[d].x));
                    },
                    transitionDuration: 250
                }
            },

            //$scope.data = sine();
            data: volatileChart(130.0, 0.02)
        };

        vm.bulletChart = {
            options: {
                chart: {
                    type              : 'bulletChart',
                    transitionDuration: 500
                }
            },
            data   : {
                'title'   : 'Revenue',
                'subtitle': 'US$, in thousands',
                'ranges'  : [150, 225, 300],
                'measures': [220],
                'markers' : [250]
            }
        };

        vm.scatterChart = {
            options: {
                chart: {
                    type              : 'scatterChart',
                    height            : 450,
                    color             : d3.scale.category10().range(),
                    scatter           : {
                        onlyCircles: false
                    },
                    showDistX         : true,
                    showDistY         : true,
                    tooltipContent    : function (key)
                    {
                        return '<h3>' + key + '</h3>';
                    },
                    transitionDuration: 350,
                    xAxis             : {
                        axisLabel : 'X Axis',
                        tickFormat: function (d)
                        {
                            return d3.format('.02f')(d);
                        }
                    },
                    yAxis             : {
                        axisLabel        : 'Y Axis',
                        tickFormat       : function (d)
                        {
                            return d3.format('.02f')(d);
                        },
                        axisLabelDistance: 30
                    }
                }
            },
            data   : generateData(4, 5)
        };

        // Methods


        //////////

        /*Random Data Generator */
        function sinAndCos()
        {
            var sin = [], sin2 = [],
                cos = [];

            //Data is represented as an array of {x,y} pairs.
            for ( var i = 0; i < 100; i++ )
            {
                sin.push({
                    x: i,
                    y: Math.sin(i / 10)
                });
                sin2.push({
                    x: i,
                    y: (i % 10 === 5 ? null : Math.sin(i / 10) * 0.25 + 0.5)
                });
                cos.push({
                    x: i,
                    y: 0.5 * Math.cos(i / 10 + 2) + Math.random() / 10
                });
            }

            //Line chart data should be sent as an array of series objects.
            return [
                {
                    values: sin,      //values - represents the array of {x,y} data points
                    key   : 'Sine Wave', //key  - the name of the series.
                    color : '#ff7f0e'  //color - optional: choose your own line color.
                },
                {
                    values: cos,
                    key   : 'Cosine Wave',
                    color : '#2ca02c'
                },
                {
                    values: sin2,
                    key   : 'Another sine wave',
                    color : '#7777ff',
                    area  : true      //area - set to true if you want this line to turn into a filled area chart.
                }
            ];
        }

        function volatileChart(startPrice, volatility, numPoints)
        {
            var rval = [];
            var now = +new Date();
            numPoints = numPoints || 100;
            for ( var i = 1; i < numPoints; i++ )
            {
                rval.push({
                    x: now + i * 1000 * 60 * 60 * 24,
                    y: startPrice
                });
                var rnd = Math.random();
                var changePct = 2 * volatility * rnd;
                if ( changePct > volatility )
                {
                    changePct -= (2 * volatility);
                }
                startPrice = startPrice + startPrice * changePct;
            }
            return rval;
        }

        /* Random Data Generator (took from nvd3.org) */
        function generateData(groups, points)
        {
            var data = [],
                shapes = ['circle', 'cross', 'triangle-up', 'triangle-down', 'diamond', 'square'],
                random = d3.random.normal();

            for ( var i = 0; i < groups; i++ )
            {
                data.push({
                    key   : 'Group ' + i,
                    values: []
                });

                for ( var j = 0; j < points; j++ )
                {
                    data[i].values.push(
                        {
                            x    : random(),
                            y    : random(),
                            size : Math.random(),
                            shape: shapes[j % 6]
                        });
                }
            }
            return data;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.chartist', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_charts_chartist', {
            url  : '/components/charts/chartist',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/charts/chartist/chartist.html',
                    controller : 'ChartistController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.chartist')
        .controller('ChartistController', ChartistController);

    function ChartistController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;


        // line chart
        vm.lineChart = {
            data   : {
                labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
                series: [
                    [12, 9, 7, 8, 5],
                    [2, 1, 3.5, 7, 3],
                    [1, 3, 4, 5, 6]
                ]
            },
            options: {
                fullWidth   : true,
                chartPadding: {
                    right: 40
                }
            }
        };

        // line Area chart
        vm.lineAreaChart = {
            data   : {
                labels: [1, 2, 3, 4, 5, 6, 7, 8],
                series: [
                    [5, 9, 7, 8, 5, 3, 5, 4]
                ]
            },
            options: {
                low     : 0,
                showArea: true
            }
        };

        vm.biPolarLineChart = {
            data   : {
                labels: [1, 2, 3, 4, 5, 6, 7, 8],
                series: [
                    [1, 2, 3, 1, -2, 0, 1, 0],
                    [-2, -1, -2, -1, -2.5, -1, -2, -1],
                    [0, 0, 0, 1, 2, 2.5, 2, 1],
                    [2.5, 2, 1, 0.5, 1, 0.5, -1, -2.5]
                ]
            },
            options: {
                high     : 3,
                low      : -3,
                showArea : true,
                showLine : false,
                showPoint: false,
                fullWidth: true,
                axisX    : {
                    showLabel: false,
                    showGrid : false
                }
            }
        };

        vm.stackedBarChart = {
            data   : {
                labels: ['Q1', 'Q2', 'Q3', 'Q4'],
                series: [
                    [800000, 1200000, 1400000, 1300000],
                    [200000, 400000, 500000, 300000],
                    [100000, 200000, 400000, 600000]
                ]
            },
            options: {
                stackBars: true,
                axisY    : {
                    labelInterpolationFnc: function (value)
                    {
                        return (value / 1000) + 'k';
                    }
                }
            },
            events : {
                draw: function (data)
                {
                    if ( data.type === 'bar' )
                    {
                        data.element.attr({
                            style: 'stroke-width: 30px'
                        });
                    }
                }
            }
        };

        // bar chart
        vm.barChart = {
            data             : {
                labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                series: [
                    [5, 4, 3, 7, 5, 10, 3, 4, 8, 10, 6, 8],
                    [3, 2, 9, 5, 4, 6, 4, 6, 7, 8, 7, 4]
                ]
            },
            options          : {
                seriesBarDistance: 15
            },
            responsiveOptions: [
                ['screen and (min-width: 641px) and (max-width: 1024px)', {
                    seriesBarDistance: 10,
                    axisX            : {
                        labelInterpolationFnc: function (value)
                        {
                            return value;
                        }
                    }
                }],
                ['screen and (max-width: 640px)', {
                    seriesBarDistance: 5,
                    axisX            : {
                        labelInterpolationFnc: function (value)
                        {
                            return value[0];
                        }
                    }
                }]
            ]
        };

        // Horizontal bar chart
        vm.horizontalBarChart = {
            data   : {
                labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
                series: [
                    [5, 4, 3, 7, 5, 10, 3],
                    [3, 2, 9, 5, 4, 6, 4]
                ]
            },
            options: {
                seriesBarDistance: 10,
                reverseData      : true,
                horizontalBars   : true,
                axisY            : {
                    offset: 70
                }
            }
        };

        vm.biPolarBarChart = {
            data   : {
                labels: ['W1', 'W2', 'W3', 'W4', 'W5', 'W6', 'W7', 'W8', 'W9', 'W10'],
                series: [
                    [1, 2, 4, 8, 6, -2, -1, -4, -6, -2]
                ]
            },
            options: {
                high : 10,
                low  : -10,
                axisX: {
                    labelInterpolationFnc: function (value, index)
                    {
                        return index % 2 === 0 ? value : null;
                    }
                }
            }
        };

        // pie chart
        vm.pieChart = {
            data             : {
                labels: ['Bananas', 'Apples', 'Grapes'],
                series: [20, 15, 40]
            },
            options          : {
                labelInterpolationFnc: function (value)
                {
                    return value[0];
                }
            },
            responsiveOptions: [
                ['screen and (min-width: 640px)', {
                    chartPadding         : 40,
                    labelOffset          : 150,
                    labelDirection       : 'explode',
                    labelInterpolationFnc: function (value)
                    {
                        return value;
                    }
                }],
                ['screen and (min-width: 1024px)', {
                    labelOffset : 120,
                    chartPadding: 30
                }]
            ]

        };

        // donut chart
        vm.donutChart = {
            data   : {
                series: [20, 10, 30, 40]
            },
            options: {
                donut: true
            }
        };

        vm.gaugeChart = {
            data   : {
                series: [20, 10, 30, 40]
            },
            options: {
                donut     : true,
                donutWidth: 60,
                startAngle: 270,
                total     : 200,
                showLabel : true
            }
        };
        // Methods

        //////////

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.c3', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_charts_c3', {
            url  : '/components/charts/c3',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/charts/c3/c3.html',
                    controller : 'C3Controller as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.c3')
        .controller('C3Controller', C3Controller);

    function C3Controller(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        // Methods

        //////////

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.chart-js', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_charts_chart-js', {
            url  : '/components/charts/chart-js',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/charts/chart-js/chart-js.html',
                    controller : 'ChartJsController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.chart-js')
        .controller('ChartJsController', ChartJsController);

    function ChartJsController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.lineChart = {
            labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
            series: ['Series A', 'Series B'],
            data  : [
                [65, 59, 80, 81, 56, 55, 40],
                [28, 48, 40, 19, 86, 27, 90]
            ]
        };

        vm.barChart = {
            labels: ['2006', '2007', '2008', '2009', '2010', '2011', '2012'],
            series: ['Series A', 'Series B'],
            data  : [
                [65, 59, 80, 81, 56, 55, 40],
                [28, 48, 40, 19, 86, 27, 90]
            ]
        };

        vm.doughnutChart = {
            labels: ['Download Sales', 'In-Store Sales', 'Mail-Order Sales'],
            data  : [300, 500, 100]
        };

        vm.radarChart = {
            labels: ['Eating', 'Drinking', 'Sleeping', 'Designing', 'Coding', 'Cycling', 'Running'],
            data  : [
                [65, 59, 90, 81, 56, 55, 40],
                [28, 48, 40, 19, 96, 27, 100]
            ]
        };

        vm.pieChart = {
            labels: ['Download Sales', 'In-Store Sales', 'Mail-Order Sales'],
            data  : [300, 500, 100]
        };

        vm.polarChart = {
            labels: ['Download Sales', 'In-Store Sales', 'Mail-Order Sales', 'Tele Sales', 'Corporate Sales'],
            data  : [300, 500, 100, 40, 120]
        };

        // Methods

        //////////

    }

})();
(function () {
    'use strict';

    angular
        .module('app.core', [
            'ngAnimate',
            'ngAria',
            'ngCookies',
            'ngMessages',
            'ngResource',
            'ngSanitize',
            'ngMaterial',
            'angular-chartist',
            'chart.js',
            'datatables',
            'gridshore.c3js.chart',
            'nvd3',
            'pascalprecht.translate',
            'timer',
            'ui.router',
            'underscore',
            'uiGmapgoogle-maps',
            'textAngular',
            'ui.sortable',
            'ng-sortable',
            'xeditable',
            'angularMoment',
            'mdPickers',
            'ui.tinymce',
            'ngFileUpload',
            'ngIntercom',
            'angular.filter',
            'ivh.treeview',
            angularDragula(angular)
        ]);
})();
(function () {
	'use strict';

	angular
		.module('app.core')
		.controller('MessageDialogController', MessageDialogController);

	/** @ngInject */
	function MessageDialogController($mdDialog, $scope, tinyMceService, complaint_id, relatedtype, $translate, chatService, sessionService, $stateParams, Upload) {
		var vm = this;
		vm.userLogued = sessionService.getUser();
		vm.closeDialog = closeDialog;
		vm.complaint_id = complaint_id;
		vm.relatedtype = relatedtype;
		vm.createMessage = createMessage;
		vm.replyMessage = '';
		vm.private = false;
		vm.files = [];
		vm.tinymceOptions = tinyMceService.getOptions($scope);
		vm.tinymceOptions.height = 250;
		vm.tinymceOptions.min_height = 250;
		vm.tinymceOptions.resize = false;
		vm.tinymceOptions.plugins = [];
		vm.tinymceOptions.toolbar1 = 'bold italic backcolor | alignleft aligncenter ' +
			'alignright alignjustify | bullist numlist outdent indent | ' +
			'removeformat | help';
		vm.translate = function (text) {
			return $translate.instant(text);
		}


		function createMessage() {
			var options = {
				owner: $stateParams.owner,
				item: {
					"is_private": vm.private,
					"user_id": vm.userLogued.id,
					"text": vm.replyMessage,
					"related_type": vm.relatedtype,
					"related_id": vm.complaint_id
				}
			}
			chatService.sendMessage(options).then(res => {
				if (vm.files.length > 0) {
					uploadFiles(res.id);
				} else {
					$mdDialog.hide(true);
				}
			}, error => {
				console.log(error)
			});
		}
		function uploadFiles(messageId) {
			vm.filesUploaded = 0;
			for (var i = 0; i < vm.files.length; i++) {
				const file = vm.files[i];
				uploadFile(file, messageId);
			}
		}
		function uploadFile(file, messageId) {
			if (!file.$error) {
				chatService.getS3UploadPreSignedUrl({
					owner: $stateParams.owner,
					uploadKey: 'message',
					fileName: file.name,
					rowId: messageId
				}).then(function (resp) {
					file.upload = Upload.http({
						url: resp.url,
						skipAuthorization: true,
						method: 'PUT',
						headers: {
							"Content-Type": file.type != '' ? file.type : 'application/octet-stream'
						},
						data: file
					});

					file.upload.progress(function (evt) {
						file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
					});

					file.upload.then(function (response) {
						chatService.finishedUploadingFile({
							owner: $stateParams.owner,
							token: resp.token
						}).then(function () {
							vm.filesUploaded++;
							if (vm.filesUploaded === vm.files.length) {
								$mdDialog.hide(true);
							}
						});
					}, function (response) {
						console.log('Error uploading file:', response);
					});
				});
			}
		}

		function closeDialog() {
			$mdDialog.hide();
		}
	}

})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();




(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .directive('compareTo', compareTo)
        .controller('ChangePassDialogcontroller', ChangePassDialogcontroller);

    /** @ngInject */
    function ChangePassDialogcontroller($mdDialog, user, $mdToast, $translate, usersService) {
        var vm = this;

        vm.closeDialog = closeDialog;
        vm.containsNumber = containsNumber;
        vm.containUpperCaseAndLowerCase = containUpperCaseAndLowerCase;
        vm.save = save;
        vm.user = user;
        console.log(vm.user)


        function containsNumber() {
            return vm.password && vm.password.match(/\d+/g);
        }
        function containUpperCaseAndLowerCase() {
            return vm.password && vm.password.match(/[a-z]/) && vm.password.match(/[A-Z]/);
        }
        function closeDialog() {
            $mdDialog.hide();
        }

        function save() {
            console.log(vm.password);
            var options = {
                site: vm.user.domain_active.domain_name,
                id: vm.user.id_user,
                item: {
                    "id_user": vm.user.id_user,
                    "email": vm.user.email,
                    "password": vm.password
                }
            };


            usersService.updateUserPass(options).then(function (response) {
                $mdDialog.hide();
                var message = $translate.instant('ACCOUNTS.SAVED');
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
            })
        }

    }
})();



function compareTo() {

    return {
        require: "ngModel",
        scope: {
            compareTolValue: "=compareTo"
        },
        link: function (scope, element, attributes, ngModel) {

            ngModel.$validators.compareTo = function (modelValue) {

                return modelValue == scope.compareTolValue;
            };

            scope.$watch("compareTolValue", function () {
                ngModel.$validate();
            });
        }
    };
}

(function () {
    'use strict';
  
    angular
      .module('app.toolbar')
      .service('stripeService', stripeService);
  
    /** @ngInject */
    function stripeService($q, $resource, COMMON) {
  
      var resourceStripeSecret = $resource(COMMON.BASE_API + "/owner/:owner/stripe/secret", {
        owner: '@owner'
      }, {
        get: {
          method: "GET",
          isArray: false
        }
      });
  
      var resourceStripePortal = $resource(COMMON.BASE_API + "/owner/:owner/stripe/portal", {
        owner: '@owner'
      }, {
        get: {
          method: "GET",
          isArray: false
        }
      });
  
      function getClientSecret(options) {
        var deferred = $q.defer();
        resourceStripeSecret.get({ owner: options.owner },
          function (response) {
            deferred.resolve(response);
          },
          function (e) {
            deferred.reject(e);
          }
        );
        return deferred.promise;
      }
  
      function getPortalUrl(options) {
        var deferred = $q.defer();
        resourceStripePortal.get({ owner: options.owner },
          function (response) {
            deferred.resolve(response);
          },
          function (e) {
            deferred.reject(e);
          }
        );
        return deferred.promise;
      }
  
      return {
        getClientSecret: getClientSecret,
        getPortalUrl: getPortalUrl
      };
    }
  })();
(function () {
  'use strict';

  angular
    .module('app.toolbar')
    .controller('StripeCheckoutDialogController', StripeCheckoutDialogController);

  /** @ngInject */
  function StripeCheckoutDialogController($mdDialog, $timeout, $stateParams, stripeService) {
    var vm = this;
    var checkoutInstance = null;

    vm.closeDialog = closeDialog;

    function closeDialog() {
      $mdDialog.cancel();

      if (checkoutInstance && typeof checkoutInstance.destroy === 'function') {
        checkoutInstance.destroy();
        checkoutInstance = null;
      }
    }

    $timeout(function () {
      const owner = $stateParams.owner;

      if (!owner) {
        return;
      }

      stripeService.getClientSecret({ owner: owner }).then(function (res) {
        const clientSecret = res.client_secret;
        //staging
        //const stripe = Stripe('pk_test_51RCLJaE6IMmU6QZcGELe1uIWcWFInq2bTDaNoIXR0bRUYv1UxY63PmiC4lMb958NdAwL7EsLLztebnKHVyuSMg3M00QNHYZjYY');
        //production
         const stripe = Stripe('pk_live_NiCEHITqLZBHPuWGjgeQ2dDl');
        stripe.initEmbeddedCheckout({
          fetchClientSecret: function () {
            return clientSecret;
          }
        }).then(function (checkout) {
          checkoutInstance = checkout;
          checkout.mount('#stripe-embedded-checkout');
        }).catch(closeDialog);

      }).catch(closeDialog);
    }, 0);
  }
})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.logout', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.pages_auth_logout', {
            url: '/pages/auth/logout',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.pages_auth_logout': {
                    // templateUrl: 'app/main/pages/auth/logout/logout.html',
                    controller: 'LogoutController as vm'
                }
            },
            bodyClass: 'logout'
        });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/pages/auth/logout');

        // Navigation
        // msNavigationServiceProvider.saveItem('pages.auth.logout', {
        //     title : 'Logout',
        //     state : 'app.pages_auth_logout',
        //     weight: 2
        // });
    }

})();
(function() {
    'use strict';

    angular
        .module('app.logout')
        .controller('LogoutController', LogoutController);

    /** @ngInject */
    function LogoutController($auth, $location, $cookies, $scope, $rootScope, sessionService) {

        if (!$auth.isAuthenticated()) {
            return;
        }
        $auth.logout()
            .then(function() {

                sessionService.cleanAllStorage();
                $cookies.put('owner', '');
                $rootScope.user = '';
                // toastr.info('You have been logged out');
				window.location.href = '/login'
            });

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.ui.theme-colors')
        .controller('ThemeColorsController', ThemeColorsController);

    /** @ngInject */
    function ThemeColorsController(fuseTheming, $mdDialog, $document)
    {
        var vm = this;
        // Data
        vm.themes = fuseTheming.themes;

        // Methods
        vm.createTheme = createTheme;
        //////////

        function createTheme(ev)
        {
            $mdDialog.show({
                controller         : 'CustomThemeDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/ui/theme-colors/dialogs/custom-theme/custom-theme-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }

    }
})();



(function ()
{
    'use strict';

    angular
        .module('app.ui.typography', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_typography', {
            url      : '/ui/typography',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/typography/typography.html',
                    controller : 'TypographyController as vm'
                }
            },
            bodyClass: 'typography'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.typography')
        .controller('TypographyController', TypographyController);

    /** @ngInject */
    function TypographyController()
    {
        // Data

        // Methods

        //////////
    }
})();



(function ()
{
    'use strict';

    angular
        .module('app.ui.material-colors', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_material-colors', {
            url  : '/ui/material-colors',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/material-colors/material-colors.html',
                    controller : 'MaterialColorsController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.material-colors')
        .controller('MaterialColorsController', MaterialColorsController);

    /** @ngInject */
    function MaterialColorsController($mdColorPalette)
    {
        var vm = this;

        // Data
        vm.palettes = $mdColorPalette;

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.forms', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_forms', {
            url      : '/ui/forms',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/forms/forms.html',
                    controller : 'FormsController as vm'
                }
            },
            bodyClass: 'forms'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.forms')
        .controller('FormsController', FormsController);

    /** @ngInject */
    function FormsController($mdDialog)
    {
        var vm = this;

        // Data
        vm.stepper = {
            step1: {},
            step2: {},
            step3: {},
            step4: {},
            step5: {}
        };

        vm.basicForm = {};
        vm.formWizard = {};
        vm.states = ('AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS ' +
        'MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI ' +
        'WY').split(' ').map(function (state)
        {
            return {abbrev: state};
        });

        // Methods
        vm.sendForm = sendForm;
        vm.submitStepper = submitStepper;

        //////////

        /**
         * Submit stepper form
         *
         * @param ev
         */
        function submitStepper(ev)
        {
            // You can do an API call here to send the form to your server

            // Show the sent data.. you can delete this safely.
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    };
                },
                template           : '<md-dialog>' +
                '  <md-dialog-content><h1>You have sent the form with the following data</h1><div><pre>{{formWizardData | json}}</pre></div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Close' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: vm.stepper
                },
                clickOutsideToClose: true
            });

            // Reset the form model
            vm.stepper = {
                step1: {},
                step2: {},
                step3: {}
            };
        }

        /**
         * Send form
         */
        function sendForm(ev)
        {
            // You can do an API call here to send the form to your server

            // Show the sent data.. you can delete this safely.
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    };
                },
                template           : '<md-dialog>' +
                '  <md-dialog-content><h1>You have sent the form with the following data</h1><div><pre>{{formWizardData | json}}</pre></div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Close' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: vm.formWizard
                },
                clickOutsideToClose: true
            });

            // Clear the form data
            vm.formWizard = {};
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.icons', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        $stateProvider.state('app.ui_icons', {
            url      : '/ui/icons',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/icons/icons.html',
                    controller : 'IconsController as vm'
                }
            },
            resolve  : {
                Icons: function (msApi)
                {
                    return msApi.resolve('icons@get');
                }
            },
            bodyClass: 'icons'
        });

        // Api
        msApiProvider.register('icons', ['assets/icons/selection.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.icons')
        .controller('IconsController', IconsController);

    /** @ngInject */
    function IconsController(Icons)
    {
        var vm = this;

        // Data
        vm.icons = Icons.icons;

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.helper-classes', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_helper-classes', {
            url      : '/ui/helper-classes',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/helper-classes/helper-classes.html',
                    controller : 'HelperClassesController as vm'
                }
            },
            bodyClass: 'helper-classes'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.helper-classes')
        .controller('HelperClassesController', HelperClassesController);

    /** @ngInject */
    function HelperClassesController()
    {
        // Data

        // Methods

        //////////
    }
})();



(function ()
{
    'use strict';

    angular
        .module('app.pages.timeline', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pages_timeline', {
                url      : '/pages/timeline',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/timeline/timeline.html',
                        controller : 'TimelineController as vm'
                    }
                },
                resolve  : {
                    Timeline: function (msApi)
                    {
                        return msApi.resolve('timeline.page1@get');
                    }
                },
                bodyClass: 'timeline'
            })
            .state('app.pages_timeline_left', {
                url      : '/pages/timeline-left',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/timeline/timeline-left.html',
                        controller : 'TimelineController as vm'
                    }
                },
                resolve  : {
                    Timeline: function (msApi)
                    {
                        return msApi.resolve('timeline.page1@get');
                    }
                },
                bodyClass: 'timeline-left'
            })
            .state('app.pages_timeline_right', {
                url      : '/pages/timeline-right',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/timeline/timeline-right.html',
                        controller : 'TimelineController as vm'
                    }
                },
                resolve  : {
                    Timeline: function (msApi)
                    {
                        return msApi.resolve('timeline.page1@get');
                    }
                },
                bodyClass: 'timeline-right'
            });

        // API
        msApiProvider.register('timeline.page1', ['app/data/timeline/page-1.json']);
        msApiProvider.register('timeline.page2', ['app/data/timeline/page-2.json']);
        msApiProvider.register('timeline.page3', ['app/data/timeline/page-3.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('pages.timeline', {
            title : 'Timeline',
            icon  : 'icon-view-stream',
            weight: 8
        });

        msNavigationServiceProvider.saveItem('pages.timeline.default', {
            title: 'Default',
            state: 'app.pages_timeline'
        });

        msNavigationServiceProvider.saveItem('pages.timeline.left-aligned', {
            title: 'Left Aligned',
            state: 'app.pages_timeline_left'
        });

        msNavigationServiceProvider.saveItem('pages.timeline.right-aligned', {
            title: 'Right Aligned',
            state: 'app.pages_timeline_right'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.timeline')
        .controller('TimelineController', TimelineController);

    /** @ngInject */
    function TimelineController($q, msApi, Timeline)
    {
        var vm = this;

        // Data
        vm.timeline = Timeline.data;
        vm.timelineOptions = {
            scrollEl: '#content'
        };
        vm.currentPage = 1;
        vm.totalPages = 3;
        vm.pauseScroll = false;

        // Methods
        vm.loadNextPage = loadNextPage;

        //////////

        /**
         * Load next page
         * @returns promise
         */
        function loadNextPage()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // Increase the current page number
            vm.currentPage = vm.currentPage + 1;

            // Check if we still have pages that we can load
            if ( vm.currentPage > vm.totalPages )
            {
                // Reject the promise
                deferred.reject('No more pages');
            }
            else
            {
                // Emulate the api call and load new timeline items in
                var pageName = 'timeline.page' + vm.currentPage + '@get';

                msApi.request(pageName, {},

                    // SUCCESS
                    function (response)
                    {
                        for ( var i = 0; i < response.data.length; i++ )
                        {
                            vm.timeline.push(response.data[i]);
                        }

                        // Resolve the promise
                        deferred.resolve(response);
                    },

                    // ERROR
                    function (response)
                    {
                        // Reject the promise
                        deferred.reject(response);
                    }
                );
            }

            return deferred.promise;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.profile', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        $stateProvider.state('app.pages_profile', {
            url      : '/pages/profile',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/profile/profile.html',
                    controller : 'ProfileController as vm'
                }
            },
            resolve  : {
                Timeline    : function (msApi)
                {
                    return msApi.resolve('profile.timeline@get');
                },
                About       : function (msApi)
                {
                    return msApi.resolve('profile.about@get');
                },
                PhotosVideos: function (msApi)
                {
                    return msApi.resolve('profile.photosVideos@get');
                }
            },
            bodyClass: 'profile'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/profile');

        // Api
        msApiProvider.register('profile.timeline', ['app/data/profile/timeline.json']);
        msApiProvider.register('profile.about', ['app/data/profile/about.json']);
        msApiProvider.register('profile.photosVideos', ['app/data/profile/photos-videos.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('pages.profile', {
            title : 'Profile',
            icon  : 'icon-account',
            state : 'app.pages_profile',
            weight: 6
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.profile')
        .controller('ProfileController', ProfileController);

    /** @ngInject */
    function ProfileController(Timeline, About, PhotosVideos)
    {
        var vm = this;

        // Data
        vm.posts = Timeline.posts;
        vm.activities = Timeline.activities;
        vm.about = About.data;
        vm.photosVideos = PhotosVideos.data;

        // Methods

        //////////
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.search', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_search', {
            url      : '/pages/search',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/search/search.html',
                    controller : 'SearchController as vm'
                }
            },
            resolve  : {
                Classic : function (msApi)
                {
                    return msApi.resolve('search.classic@get');
                },
                Mails   : function (msApi)
                {
                    return msApi.resolve('search.mails@get');
                },
                Users   : function (msApi)
                {
                    return msApi.resolve('search.users@get');
                },
                Contacts: function (msApi)
                {
                    return msApi.resolve('search.contacts@get');
                }
            },
            bodyClass: 'search'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/search');

        // Api
        msApiProvider.register('search.classic', ['app/data/search/classic.json']);
        msApiProvider.register('search.mails', ['app/data/search/mails.json']);
        msApiProvider.register('search.users', ['app/data/search/users.json']);
        msApiProvider.register('search.contacts', ['app/data/search/contacts.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('pages.search', {
            title : 'Search',
            icon  : 'icon-magnify',
            state : 'app.pages_search',
            weight: 7
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.search')
        .controller('SearchController', SearchController);

    /** @ngInject */
    function SearchController(Classic, Mails, Users, Contacts)
    {
        var vm = this;

        // Data
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];

        vm.classic = Classic.data;
        vm.mails = Mails.data;
        vm.users = Users.data;
        vm.contacts = Contacts.data;

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.maintenance', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_maintenance', {
            url      : '/pages/maintenance',
            views    : {
                'main@'                        : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_maintenance': {
                    templateUrl: 'app/main/pages/maintenance/maintenance.html',
                    controller : 'MaintenanceController as vm'
                }
            },
            bodyClass: 'maintenance'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/maintenance');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.maintenance', {
            title : 'Maintenance',
            icon  : 'icon-oil',
            state : 'app.pages_maintenance',
            weight: 5
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.maintenance')
        .controller('MaintenanceController', MaintenanceController);

    /** @ngInject */
    function MaintenanceController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.invoice', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pages_invoice_modern', {
                url      : '/pages/invoice/modern',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/invoice/views/modern/modern.html',
                        controller : 'InvoiceController as vm'
                    }
                },
                resolve  : {
                    Invoice: function (msApi)
                    {
                        return msApi.resolve('invoice@get');
                    }
                },
                bodyClass: 'invoice printable'
            })
            .state('app.pages_invoice_compact', {
                url      : '/pages/invoice/compact',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/invoice/views/compact/compact.html',
                        controller : 'InvoiceController as vm'
                    }
                },
                resolve  : {
                    Invoice: function (msApi)
                    {
                        return msApi.resolve('invoice@get');
                    }
                },
                bodyClass: 'invoice printable'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/invoice');

        // Api
        msApiProvider.register('invoice', ['app/data/invoice/invoice.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('pages.invoice', {
            title : 'Invoice',
            icon  : 'icon-receipt',
            weight: 4
        });

        msNavigationServiceProvider.saveItem('pages.invoice.modern', {
            title : 'Modern',
            state : 'app.pages_invoice_modern'
        });

        msNavigationServiceProvider.saveItem('pages.invoice.compact', {
            title : 'Compact',
            state : 'app.pages_invoice_compact'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.invoice')
        .controller('InvoiceController', InvoiceController);

    /** @ngInject */
    function InvoiceController(Invoice)
    {
        var vm = this;

        // Data
        vm.invoice = Invoice.data;

        // Methods

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dialogs', [ ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
    
    }
})();
(function () {
    'use strict';

    angular
        .module('app.dialogs')
        .controller('UserQuotaDialogController', UserQuotaDialogController);

    /** @ngInject */
    function UserQuotaDialogController($mdDialog, sessionService, user,  quotaComplaint) {
        var vm = this;
        vm.user = sessionService.getUser();
        if (quotaComplaint) {
            vm.quota = quotaComplaint;
        }
        if (!vm.quota) {
            sessionService.getQuota().then(function (quota) {
                vm.quota = quota;
            });
        }
        vm.saveDialog = saveDialog;
        vm.closeDialog = closeDialog;
        /**
         * Save contact
         */
        function saveDialog(upgrade) {
            if (upgrade) {
                $mdDialog.hide({ type: 'upgrade' });
            } else {
                $mdDialog.hide({ type: 'noupgrade' });
            }
        }


        /**
         * Close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.coming-soon', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_coming-soon', {
            url      : '/pages/coming-soon',
            views    : {
                'main@'                        : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_coming-soon': {
                    templateUrl: 'app/main/pages/coming-soon/coming-soon.html',
                    controller : 'ComingSoonController as vm'
                }
            },
            bodyClass: 'coming-soon'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/coming-soon');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.coming-soon', {
            title : 'Coming Soon',
            icon  : 'icon-alarm-check',
            state : 'app.pages_coming-soon',
            weight: 2
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.coming-soon')
        .controller('ComingSoonController', ComingSoonController);

    /** @ngInject */
    function ComingSoonController()
    {
        var vm = this;

        // Data
        vm.endTime = 1472975790000;

        // Methods

        //////////
    }
})();
(function () {
    'use strict';

    angular
        .module('app.dialogs')
        .controller('SelectUsersController', SelectUsersController);

    /** @ngInject */
    function SelectUsersController($mdDialog, storagePrefix, users, $filter, title) {
        var vm = this;
        vm.users = users;
        vm.title = title;
        vm.usersSearch = null;


        var vm = this;
        vm.usersObj = {};
        vm.allUsers = users;
        angular.forEach(vm.allUsers, function (u) {
            u.storagePrefix = storagePrefix;
            u.selected = false;
        })
        vm.closeDialog = function () {
            $mdDialog.hide();
        }
        vm.apply = function () {
            var returnUsers = $filter('filter')(vm.allUsers, { selected: true })
            $mdDialog.hide(returnUsers);
        };

    }
})();
(function () {
    'use strict';

    angular
        .module('app.dialogs')
        .controller('SelectUser', SelectUser);

    /** @ngInject */
    function SelectUser($mdDialog, title, currentUsers, usersSelected, availableUsers, storagePrefix) {
        var vm = this;
        vm.title = title;
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
        vm.usersObj = {};
        vm.allUsers = [];
        vm.usersSelected = usersSelected ? usersSelected : [];
        vm.usersSelectedObjectArray = vm.usersSelected.map(x => {
            if (x.id) {
                return availableUsers.find(y => y.id == x.id);
            } else {
                return availableUsers.find(y => y.id == x);
            }
        })
        angular.forEach(availableUsers, function (user) {
            if (angular.isUndefined(vm.usersObj[user.id])) {
                vm.allUsers.push(user);
                vm.usersObj[user.id] = user;
            }
        })
        vm.currentUsers = currentUsers;
        angular.forEach(vm.allUsers, function (u) {
            if (angular.isUndefined(u.profile_color)) {
                u.profile_color = vm.colors[Math.floor(Math.random() * vm.colors.length)];
            }
            u.storagePrefix = storagePrefix;
            u.selected = false;
            angular.forEach(vm.currentUsers, function (user) {
                user.profile_color = u.profile_color;
                if (user.id == u.id) {
                    u.selected = true;
                }
            })
        })
        vm.closeDialog = function () {
            $mdDialog.hide();
        }
        vm.saveDialog = function () {
            $mdDialog.hide({ multiple: vm.shared_task ? 0 : 1, users: vm.usersSelectedObjectArray });
        }
        vm.selectUser = function (user) {
            var found = vm.usersSelectedObjectArray.findIndex(x => x.id === user.id)
            if (found >= 0) {
                vm.usersSelectedObjectArray.splice(found, 1)
            } else {
                vm.usersSelectedObjectArray.push(user);
            }
        };
        vm.isSelected = function (user) {
            var found = vm.usersSelectedObjectArray.findIndex(x => x.id === user.id)
            return found >= 0;
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.dialogs')
        .controller('TaskDetailsDialogController', TaskDetailsDialogController);

    /** @ngInject */
    function TaskDetailsDialogController($scope, $mdDialog, $document, tinyMceService, $translate, task, Owner, taskDetailsUtil, storagePrefix, sessionService, showRecurrence,  availableusers, currentUsers, $window, filesService, msUtils) {
        var vm = this;
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg', 'red-bg', 'yellow-bg', 'light-blue-bg'];
        vm.statusTask = taskDetailsUtil.status;
        vm.window = true;
        vm.reccurentType = taskDetailsUtil.reccurentType;
        vm.storagePrefix = storagePrefix;
        vm.availableusers = availableusers;
        vm.showRecurrence = showRecurrence;
        vm.calculateHeightChat = calculateHeightChat;
        vm.editTask = editTask;
        vm.currentUsers = currentUsers;
        vm.openDialogUser = openDialogUser;
        vm.openDialogAlerts = openDialogAlerts;
        vm.showUserImage = showUserImage;
        vm.changeTaskStatusDialog = changeTaskStatusDialog;
        vm.dateExpired = dateExpired;
        vm.tinymceOptions = tinyMceService.getBasicOptions($scope);
        vm.tinymceOptions.height = 100;
        vm.userLogued = sessionService.getUser();
        if (vm.userLogued.user_type >= 4 && !task.id) {
            vm.userLocked = true;
            task.assigned_multiple.users.push(vm.userLogued);
            task.assigned_to_user_id = vm.userLogued.id;
        }
        vm.taskData = {
            task: task,
            files: []
        };
        vm.taskData.task = taskDetailsUtil.fromDTO(vm.taskData.task);
        vm.idChat = vm.taskData.task.id;

        function changeTaskStatusDialog(e, task) {
            $mdDialog.show({
                controller: 'TaskEditStatusController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/tasks/dialogs/task-edit-status-dialog/task-edit-status-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: true,
                fullscreen: true,
                multiple: true,
                locals: {
                    task: task
                }
            }).then(function (resp) {
            });
        }

        vm.toggleRecurrence = function () {
            if (vm.showRecurrence) {
                vm.taskData.task.recurrent_interval = null;
                vm.taskData.task.recurrent_type = null;
            } else {
                vm.taskData.task.recurrent_interval = 1;
                vm.taskData.task.recurrent_type = "week";
            }
            vm.showRecurrence = !vm.showRecurrence
        }

        vm.translate = function (text) {
            return $translate.instant(text);
        }
        vm.closeDialog = function () {
            $mdDialog.hide();
        }
        vm.save = function () {
            vm.taskData = taskDetailsUtil.prepareToSave(vm.taskData);
            $mdDialog.hide(vm.taskData);
        };

        function calculateHeightChat() {
            return 320;
        }


        function openDialogAlerts(ev) {
            taskDetailsUtil.openDialogAlerts(ev, vm.storagePrefix, vm.taskData.task.alerts).then(resp => {
                if (resp) {
                    vm.taskData.task.alerts = resp;
                }
            })
        }

        function showUserImage(user) {
            return vm.storagePrefix + user.files.url
        }

        function openDialogUser(ev) {
            taskDetailsUtil.openDialogUser(ev, vm.taskData, vm.availableusers, vm.currentUsers, vm.storagePrefix).then(resp => {
                vm.taskData = resp;
            })
        }

        vm.showFileInfo = function (f, ev) {
            msUtils.showFileInfo(Owner, f, ev);
        }

        vm.downloadFile = function (f) {
            taskDetailsUtil.downloadFile(Owner, f);
        }

        vm.unasignedUserTask = function (user) {
            if (vm.taskData.task.assigned_to_user_id && vm.taskData.task.assigned_to_user_id.id == user.id) {
                vm.taskData.task.assigned_to_user_id = null;
            } else {
                vm.taskData.task.assigned_multiple.users.splice(vm.taskData.task.assigned_multiple.users.indexOf(user), 1);
            }
        }
        function dateExpired(stringDate) {
            return moment.utc(stringDate) < moment.utc();
        }
        function editTask(task) {
            vm.showRecurrence = (vm.taskData.task.recurrent_interval || vm.taskData.task.recurrent_type) ? true : false;
            vm.edit = true;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.dialogs')
        .factory("taskDetailsUtil", taskDetailsUtil);



    /** @ngInject */
    function taskDetailsUtil($mdDialog, $translate, $q, filesService, mediaService, $window, Upload, $timeout, sessionService, riskService) {


        var status = {
            1: 'RISK.TASK_PENDING',
            2: 'RISK.TASK_IN_PROGRESS',
            3: 'RISK.TASK_COMPLETED'
        };
        var reccurentType = {
            "day": 'RISK.RECURRENT_DAY',
            "week": 'RISK.RECURRENT_WEEK',
            "month": 'RISK.RECURRENT_MONTH',
            "year": 'RISK.RECURRENT_YEAR'
        };

        function openDialogUser(ev, taskData, availableUsers, currentUsers, storagePrefix) {
            var deferred = $q.defer();
            var usersSelected;
            if (taskData.task.assigned_multiple && taskData.task.assigned_multiple.users && taskData.task.assigned_multiple.users.length > 0) {
                usersSelected = angular.copy(taskData.task.assigned_multiple.users);
            } else if (taskData.task.assigned_to_user_id) {
                usersSelected = angular.copy([taskData.task.assigned_to_user_id])
            }
            $mdDialog.show({
                controller: 'SelectUser',
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/selectUser/selectUser.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                multiple: true,
                locals: {
                    availableUsers: availableUsers,
                    currentUsers: currentUsers,
                    usersSelected: usersSelected,
                    title: $translate.instant('GLOBAL.USERS'),
                    storagePrefix: storagePrefix
                },
            })
                .then(function (resp) {
                    if (resp) {
                        if (resp.users.length === 1) {
                            if (!taskData.task.assigned_multiple) {
                                taskData.task.assigned_multiple = {};
                            }
                            taskData.task.assigned_multiple.users = []
                            taskData.task.assigned_to_user_id = resp.users[0];
                        } else {
                            taskData.task.assigned_to_user_id = null;
                            taskData.task.assigned_multiple.users = resp.users;
                        }
                        taskData.task.status_multiple = resp.multiple;
                    }
                    deferred.resolve(taskData);
                });

            return (deferred.promise);
        }

        function openDialogAlerts(ev, storagePrefix, alerts) {
            var deferred = $q.defer();
            $mdDialog.show({
                controller: 'CreateAlerts',
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/createAlerts/createAlerts.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                multiple: true,
                locals: {
                    title: 'GLOBAL.ALERTS',
                    storagePrefix: storagePrefix,
                    alerts: alerts
                },
            }).then(function (resp) {
                deferred.resolve(resp);
            });

            return (deferred.promise);
        }
        function createNewTask(related_type, id) {
            var companySelected = sessionService.get('companySelected');

            // TODO quitar el control por defecto
            var task = {
                company_id: companySelected.id,
                status_id: 1,
                communication: {
                    assigned: true,
                    compliance_officers: true,
                    in_charge: true,
                    participants: false
                },
                assigned_to_user_id: null,
                assigned_multiple: {
                    users: []
                },
                recurrent_end_date: moment().add(3, 'months').toDate(),
                is_complete: false,
                due_by_date: null,
                title: '',
                files: [],
                text: ''
            };
            task.due_by_date = moment(new Date()).add(1, 'days').toDate();
            if (related_type) {
                task.related_id = id;
                task.related_type = related_type;
            }
            return task
        }

        function prepareToSave(taskData) {
            if (taskData.task.due_by_date) {
                taskData.task.due_by_date = moment.utc(taskData.task.due_by_date).format('YYYY-MM-DD HH:mm:ss');
            }
            if (taskData.task.recurrent_end_date) {
                taskData.task.recurrent_end_date = moment.utc(taskData.task.recurrent_end_date).format('YYYY-MM-DD HH:mm:ss');
            }
            if (taskData.task.assigned_to_user_id) {
                taskData.task.assigned_to_user_id = taskData.task.assigned_to_user_id.id;
            }
            if (taskData.task.assigned_multiple && taskData.task.assigned_multiple.users) {
                taskData.task.assigned_multiple.users = taskData.task.assigned_multiple.users.map(x => x.id);
                if (taskData.task.assigned_multiple.users.length == 1) {
                    taskData.task.assigned_to_user_id = taskData.task.assigned_multiple.users[0];
                    delete taskData.task.assigned_multiple;
                }
            }
            return taskData;
        }
        function fromDTO(taskData) {
            if (taskData.due_by_date) {
                taskData.due_by_date = new Date(moment.utc(taskData.due_by_date).local().format('YYYY/MM/DD HH:mm:ss'));
            }
            if (taskData.recurrent_end_date) {
                taskData.recurrent_end_date = new Date(moment.utc(taskData.recurrent_end_date).local().format('YYYY/MM/DD HH:mm:ss'));
            }
            if (taskData.assigned_multiple && taskData.id) {
                taskData.assigned_multiple.users = taskData.assigned_users
            }
            if (taskData.id) {
                taskData.assigned_to_user_id = taskData.assigned_to_user
            }
            return taskData;
        }
        function downloadFile(Owner, f) {
            filesService.getPresignedUrl({
                owner: Owner,
                file: f
            }).then(function (res) {
                $window.location.href = res.url;
            })
        }

        function saveTask(owner, data, files) {
            var deferred = $q.defer();
            if (data.id) {
                riskService.updateTask({
                    owner: owner,
                    item: data
                }).then(function (res) {
                    var newFiles = files.find(x => !x.id);
                    if (newFiles) {
                        angular.forEach(files, function (f) {
                            uploadMedia(f, res.id, 'task', owner)
                        })
                        checkUploadsAndUpdateTasks(deferred, files);
                    } else {
                        deferred.resolve(res);
                    }
                }, function (err) {
                    deferred.reject(err);
                })
            } else {
                riskService.postTask({
                    owner: owner,
                    item: data
                }).then(function (res) {
                    angular.forEach(files, function (f) {
                        uploadMedia(f, res.id, 'task', owner)
                    })
                    checkUploadsAndUpdateTasks(deferred, files);
                })
            }
            return (deferred.promise);
        }
        function updateTaskStatus(owner, data) {
            var deferred = $q.defer();
            riskService.updateTask({
                owner: owner,
                item: data
            }).then(function (res) {
                deferred.resolve(res);
            }, function (err) {
                deferred.reject(err);
            })
            return (deferred.promise);
        }

        function checkUploadsAndUpdateTasks(deferred, files) {
            var noUpdate = false;
            if (files.length > 0) {
                angular.forEach(files, function (file) {
                    if ((angular.isUndefined(file.progress) || file.progress < 100) || !file.finished) {
                        noUpdate = true;
                    }
                })
                if (!noUpdate) {
                    deferred.resolve(true);
                } else {
                    $timeout(function () {
                        checkUploadsAndUpdateTasks(deferred, files);
                    }, 1000)
                }
            } else {
                deferred.resolve(true);
            }
        }


        function uploadMedia(file, idValue, uploadKey, owner) {
            if (!file.$error) {
                file.finished = false;
                var token = undefined;
                mediaService.getS3UploadPreSignedUrl({
                    owner: owner,
                    uploadKey: uploadKey,
                    fileName: file.name,
                    rowId: idValue
                }).then(function (resp) {
                    token = resp.token;
                    file.id_media = resp.id_media;
                    file.upload = Upload.http({
                        url: resp.url,
                        skipAuthorization: true,
                        method: 'PUT',
                        headers: {
                            "Content-Type": file.type != '' ? file.type : 'application/octet-stream'
                        },
                        data: file
                    })
                    file.upload.then(function (response) {
                        file.result = response.data;
                        mediaService.finishedUploadingFileToCdn({
                            owner: owner,
                            idMedia: file.id_media,
                            token: token
                        }).then(function (res) {
                            file.finished = true;
                            finishFile(owner, idValue, [res.id]);
                        });
                    }, function (response) {
                        console.log(response)
                    });

                    file.upload.progress(function (evt) {
                        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                    });
                })
            }
        };

        function finishFile(owner, taskId, mediaIds) {
            mediaService.finishFile({
                owner: owner,
                taskId: taskId,
                mediaIds: mediaIds
            }).then(function (res) {
                console.log(res);
            })
        }

        var service = {
            openDialogUser: openDialogUser,
            openDialogAlerts: openDialogAlerts,
            createNewTask: createNewTask,
            prepareToSave: prepareToSave,
            fromDTO: fromDTO,
            downloadFile: downloadFile,
            saveTask: saveTask,
            updateTaskStatus: updateTaskStatus,
            status: status,
            reccurentType: reccurentType,
        };

        return service;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.dialogs')
        .controller('selectDivisionsController', selectDivisionsController);

    /** @ngInject */
    function selectDivisionsController($mdDialog, divisions, currentDivisions, $filter, title) {
        var vm = this;
        vm.divisions = divisions;
        vm.currentDivisions = currentDivisions;
        vm.title = title;
        vm.divisionsSearch = null;

        var vm = this;
        vm.divisionObj = {};
        vm.allDivisions = divisions;


        angular.forEach(vm.allDivisions, function (d) {
            d.selected = false;
            angular.forEach(vm.currentDivisions, function (division) {
                if (division.id == d.id) {
                    d.selected = true;
                }
            })
        })
        vm.closeDialog = function () {
            $mdDialog.hide();
        }
        vm.apply = function () {
            $mdDialog.hide(vm.allDivisions);
        };

    }
})();
(function () {
    'use strict';

    angular
        .module('app.dialogs')
        .controller('CreateAlerts', CreateAlerts);

    /** @ngInject */
    function CreateAlerts($mdDialog, title, alerts) {
        var vm = this;
        vm.title = title;

        vm.alertReccurent = {
            "hour": 'RISK.RECURRENT_HOUR',
            "day": 'RISK.RECURRENT_DAY',
            "week": 'RISK.RECURRENT_WEEK',
            "month": 'RISK.RECURRENT_MONTH',
            "year": 'RISK.RECURRENT_YEAR'
        }
        vm.alertType = {
            1: 'RISK.ALERT_TYPE_WEB_PUSH',
            2: 'RISK.ALERT_TYPE_EMAIL',
            3: 'RISK.ALERT_TYPE_APP_PUSH',
            4: 'RISK.ALERT_TYPE_SMS'
        }
        vm.alert = {};
        vm.alert.amount = 1;
        vm.alert.periodity = "day";
        vm.alert.type = 2;
        if (!alerts) {
            vm.alerts = [];
        } else {
            vm.alerts = alerts;
        }
        vm.closeDialog = function () {
            $mdDialog.hide();
        }
        vm.addAlert = function (alert) {
            vm.alerts.push(angular.copy(alert));
            vm.alert = {
                periodity: "day",
                amount: 1,
                type: "2"
            }
        }
        vm.saveAlerts = function () {
            $mdDialog.hide(vm.alerts);
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.dialogs')
        .controller('fileDetailsDialogController', fileDetailsDialogController);

    /** @ngInject */
    function fileDetailsDialogController($mdDialog, file, Owner, filesService, $window) {
        var vm = this;

        vm.file = file;
        vm.options = {
            owner: Owner,
            file: file
        }
        vm.isLoading = true;
        vm.processing = true;
        filesService.getTimeStampInfo(vm.options).then(function (res) {
            vm.isLoading = false;
            vm.processing = false
            vm.timeStamp = res;
        })

        vm.closeDialog = closeDialog;
        vm.getTSRFile = getTSRFile;
        vm.getTSQFile = getTSQFile;
        vm.downloadFile = downloadFile;

        function closeDialog() {
            $mdDialog.hide();
        }

        function getTSRFile() {
            vm.processing = true;
            filesService.getTSRFile(vm.options)
                .then(function (res) {
                    vm.processing = false;
                    $window.location.href = res.url;
                })
                .catch(function (err) {
                    vm.processing = false;
                })
        }

        function getTSQFile() {
            vm.processing = true;
            filesService.getTSQFile(vm.options)
                .then(function (res) {
                    vm.processing = false;
                    $window.location.href = res.url;
                })
                .catch(function (err) {
                    vm.processing = false;
                })
        }

        function downloadFile() {
            filesService.getPresignedUrl(vm.options)
                .then(function (res) {
                    $window.location.href = res.url;
                })
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.dialogs')
        .controller('CompanyQuotaDialogController', CompanyQuotaDialogController);

    /** @ngInject */
    function CompanyQuotaDialogController($mdDialog, sessionService, $rootScope) {
        var vm = this;
        vm.user = sessionService.getUser();
        sessionService.getQuota().then(function (quota) {
            vm.quota = quota;
        });
        vm.saveDialog = saveDialog;
        vm.closeDialog = closeDialog;
        vm.openStripeDialog = openStripeDialog;

        /**
         * Save contact
         */
        function saveDialog(upgrade) {
            if (upgrade) {
                $mdDialog.hide({ type: 'upgrade' });
            } else {
                $mdDialog.hide({ type: 'noupgrade' });
            }
        }

        /**
         * Close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /**
         * Open Stripe Dialog
         */
        function openStripeDialog(ev) {
            $mdDialog.hide();
            $rootScope.$broadcast('open-stripe-dialog', ev);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.staffsroi')
        .controller('StaffsroiController', StaffsroiController);

    /** @ngInject */
    function StaffsroiController($scope, $rootScope, $mdMenu, documentsService, $stateParams, $translate, $document, $mdDialog, complaintsService, $mdToast,
        $mdMedia, $mdSidenav, $state, msApi, tinyMceService, requestContext, usersService, companyService, clientsService, mediaService, sessionService,
        $timeout, staffsroiService, transformsroiStaff, Upload) {
        var vm = this;
        if ($state.current.name == "app.site_overview.personalsroi.complaints") {
            vm.fromComplaint = true;
        }
        vm.loadingPositions = false;
        vm.userLogued = sessionService.getUser();
        sessionService.getQuota().then(function (quota) {
            vm.quota = quota;
        });
        vm.companies = sessionService.getUser().companies;
        vm.deleteAvatar = deleteAvatar;
        vm.openMenu = openMenu;
        vm.selectUserNew = selectUserNew;
        vm.mainCompany = _.find(vm.companies, { 'is_owner': true });
        // Data
        vm.accounts = {
            'creapond': 'johndoe@creapond.com',
            'withinpixels': 'johndoe@withinpixels.com'
        };
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
        vm.selectedAccount = 'creapond';

        vm.folders = 'Folders.data';
        vm.labels = 'Labels.data';
        vm.loadingThreads = true;

        vm.currentFilter = {
            type: $state.params.type,
            filter: $state.params.filter
        };
        vm.currentThread = null;
        vm.selectedThreads = [];

        vm.views = {
            split: 'app/main/apps/staffsroi/views/list/split-view.html',
            nosplit: 'app/main/apps/staffsroi/views/list/nosplit-view.html'
        };
        vm.defaultView = 'split';
        vm.currentView = 'split';

        vm.editData = false;
        vm.editCompanies = false;
        vm.previewData = false;
        vm.files = [];

        vm.idCompany = undefined;
        vm.companySelected = undefined;
        vm.isCompanySelected = isCompanySelected;

        vm.readView = true;
        vm.loadingReadPane = false;

        //Methods
        vm.openThread = openThread;
        vm.closeThread = closeThread;

        vm.isSelected = isSelected;
        vm.toggleSelectThread = toggleSelectThread;
        vm.selectThreads = selectThreads;
        vm.deselectThreads = deselectThreads;
        vm.toggleSelectThreads = toggleSelectThreads;

        vm.setThreadStatus = setThreadStatus;
        vm.toggleThreadStatus = toggleThreadStatus;
        vm.toggleStaffStatusEdit = toggleStaffStatusEdit;

        vm.checkUploadsAndUpdateStaff = checkUploadsAndUpdateStaff;

        vm.showUserImage = showUserImage;

        vm.changeView = changeView;
        vm.toggleSidenav = toggleSidenav;
        vm.tinymceOptions = tinyMceService.getOptions($scope);

        vm.openStaff = openStaff;
        vm.closeStaff = closeStaff;
        vm.isAvailableConfigureMenu = isAvailableConfigureMenu;
        vm.saveStaff = saveStaff;
        vm.deleteStaff = deleteStaff;
        vm.duplicateStaff = duplicateStaff;
        vm.newStaff = newStaff;
        vm.checkFields = checkFields;
        vm.selectBranch = selectBranch;
        vm.selectDivision = selectDivision;
        vm.addUserJob = addUserJob;
        vm.firstLoad = true;
        vm.getPositionNameById = getPositionNameById;

        vm.config = sessionService.config;
        vm.showFormAdd = false;
        vm.staffHasCompany = staffHasCompany;
        vm.staffHasBranch = staffHasBranch;
        vm.tabActive = 'preview';
        vm.viewEditData = viewEditData;
        vm.viewEditDataNew = viewEditDataNew;
        vm.viewPreviewData = viewPreviewData;
        vm.viewEditCompanies = viewEditCompanies;
        vm.viewActivity = viewActivity;
        vm.viewTask = viewTask;
        vm.viewConfigureTabs = viewConfigureTabs;
        vm.resetStaffSelected = resetStaffSelected;
        vm.uploadMedia = uploadMedia;
        vm.checkUploadsAndUpdateStaff = checkUploadsAndUpdateStaff;

        vm.branchSelected = undefined;
        vm.divisionSelected = undefined;

        vm.isBranchSelected = isBranchSelected;
        vm.setCompanyBranches = setCompanyBranches;
        vm.searchDivisionText = '';
        vm.searchBranchText = '';
        vm.formNewPosition = {};
        //////////

        $scope.$on('pagination:loadStart', function (event) {
            $scope.isLoading = true;
        });

        $scope.$on('pagination:loadPage', function (event) {
            $scope.isLoading = false;
        });


        vm.translate = function (text) {
            return $translate.instant(text);
        }


        function isCompanySelected() {
            if (angular.isObject(vm.companySelected)) {
                return true;
            }
            return false;
        }


        function setCompanyBranches(branches) {
            vm.companyBranches = branches;
        }

        function getCompanyBranches(idCompany, idBranch) {
            companyService.getBranches({
                owner: $scope.owner,
                company_id: idCompany,
                withUsers: true,
            })
                .then(function (branchesResponse) {
                    $scope.isLoading = false;
                    if (branchesResponse.total > 0) {
                        vm.setCompanyBranches(branchesResponse.data);
                    }
                    else {
                        vm.branchSelected = undefined;
                        vm.searchBranchText = '';
                        vm.companyBranches = [];
                    }
                });
        }
        function getDivisions() {
            var options = {
                owner: $scope.owner
            };
            usersService.getDivisions(options).then(function (response) {
                vm.divisions = [];
                for (var i = 0; i < response.data.length; i++) {
                    vm.divisions.push({ name: response.data[i].name, id: response.data[i].id });
                }
                vm.divisions = divisions;
            })
        }

        function selectBranch(branch, noFirst) {
            staffsroiService.setBranch(branch)
            vm.branchSelected = branch;
            $rootScope.$broadcast('company-selected');
        }
        function selectDivision(division, noFirst) {
            staffsroiService.setDivision(division)
            vm.divisionSelected = division;
            $rootScope.$broadcast('company-selected');
        }
        var companySelectEvent = $rootScope.$on('company-selected', function (event) {
            vm.companySelected = sessionService.get('companySelected');
            companyService.setCompanyId(vm.companySelected.id);
            if (!vm.firstLoad) {
                $rootScope.pagination_resetquery();
            }
            getCompanyBranches(vm.companySelected.id);
            if (vm.fromComplaint) {
                getComplaintSettings();
                getAdminUsers();
            }
            staffsroiService.getMainBranch({ owner: $scope.owner, id_company: vm.companySelected.id }).then(res => {
                vm.mainBranch = res.data[0];
            })
            vm.firstLoad = false;
        });

        $scope.$on('$destroy', companySelectEvent);
        $scope.$on('$destroy', function () {
            staffsroiService.setBranch(null)
            staffsroiService.setDivision(null)
        });

        vm.getRegionLiteral = getRegionLiteral;
        $scope.owner = $stateParams.owner;
        init();

        /////////////////

        function init() {
            if (sessionService.get('companySelected')) {
                $rootScope.$broadcast('company-selected');
            }
            getPositions();
            getDivisions();



            mediaService.getStoragePrefix({
                owner: $scope.owner,
            }).then(function (res) {
                $scope.storagePrefix = res.prefix;
            })
            clientsService.getFileRegions().then(function (res) {
                vm.regionsLiterals = res;
            })
        }

        function selectUserNew(user) {
            console.log(user);
            clientsService.addUserToCompany({
                owner: $scope.owner,
                user_id: user.id,
                company_id: vm.companySelected.id
            }).then(res => {
                var message = vm.translate('STAFF.USER_ADDED_SUCCESSFULLY')
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content bg-green">' + message + '</div></md-toast>',
                    hideDelay: 3000,
                    position: 'top right',
                    parent: '#content'
                });
                vm.resetStaffSelected();
                $rootScope.pagination_resetquery();
            })
        }
        function getComplaintSettings() {
            complaintsService.getComplaintSettings({ owner: $scope.owner, id: vm.companySelected.id }).then(res => {
                vm.complaintSettings = res.data[0];
//                console.log(vm.complaintSettings);
            })
        }
        function isBranchSelected() {
            if (staffService.branch) {
                return true;
            }
            return false;
        }


        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'nosplit';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big)
                vm.currentView = 'nosplit';

        });

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small)
                vm.currentView = 'split';

        });

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                if (vm.defaultView === 'split') {
                    vm.currentView = 'split';
                }
            }
        });

        var originatorEv;

        function openMenu($mdOpenMenu, ev) {
            originatorEv = ev;
            $mdOpenMenu(ev);
        }

        function openStaff(item) {
            vm.files = [];
            vm.tabNewSelected = 'new';
            vm.staffNew = undefined;
            vm.editData = false;
            vm.editCompanies = false;
            if (vm.staffNew)
                vm.staffNew = undefined;
            if (item) {
                vm.loadingReadPane = true;
                vm.files = item.files ? [item.files] : [];
                var options = {
                    id: item.id,
                    owner: $scope.owner
                };
                staffsroiService.getStaffItem(options)
                    .then(function (resp) {
                        vm.staffSelected = resp;
                        vm.originalEmail = resp.email;
                        vm.viewPreviewData();
                        vm.loadingReadPane = false;
                    })

            }
        }

        function deleteAvatar(file) {
            var options = {
                owner: $scope.owner,
                id: file.id
            }
            documentsService.deleteDocument(options).then(function () {
                vm.files = [];
                $rootScope.pagination_resetquery();
            })
        }

        function closeStaff() {
            vm.staffSelected = undefined;
            vm.staffNew = undefined;
        }

        function isAvailableConfigureMenu() {
            var result = false;
            if (vm.userLogued.user_type <= 2) {
                result = true
            }
            if (vm.userLogued.user_type == 2 && vm.userSelected) {
                result = vm.userLogued.id === vm.userSelected.id || vm.userSelected.user_type > 2;
            }
            if (vm.userLogued.user_type == 3 && vm.userSelected) {
                result = vm.userLogued.id === vm.userSelected.id;
            }
            return result && vm.staffSelected;
        }

        function saveStaff(ev) {
            if (!vm.originalEmail || vm.originalEmail !== vm.staffSelected.email) {
                var options = {
                    owner: $scope.owner,
                    searchStringFilter: vm.staffSelected ? vm.staffSelected.email : vm.staffNew.email
                };
                usersService.getUsersWithTrashed(options).then(function (response) {

                    var existedUser = _.find(response.data, function (user) {
                        if (user.email == options.searchStringFilter && (!vm.userSelected || user.id !== vm.userSelected.id)) {
                            return true;
                        }
                    });

                    if (!existedUser) {
                        if (vm.staffSelected) {
                            updateStaff();
                        } else if (vm.staffNew) {
                            createStaff();
                        }
                    } else {
                        alert = $mdDialog.alert({
                            title: vm.translate('GLOBAL.ATTENTION'),
                            textContent: vm.translate('GLOBAL.USER_ALREADY_EXISTS'),
                            ok: vm.translate('GLOBAL.CLOSE'),
                        }).multiple(true);

                        $mdDialog
                            .show(alert)
                            .finally(function () {
                                alert = undefined;
                            });
                    }
                })
            } else {
                if (vm.staffSelected) {
                    updateStaff();
                } else if (vm.staffNew) {
                    createStaff();
                }
            }

        }

        function createStaff() {
            vm.loadingReadPane = true;
            vm.staffNew.region_id = 1;
            vm.staffNew.job_position_id = 1;
            if (!vm.fromComplaint) {
                if (vm.staffNew.password) {
                    vm.staffNew.user_type = 4;
                } else {
                    vm.staffNew.user_type = 5;
                }
            } else {
                vm.staffNew.region_id = vm.companySelected.region_id;
                vm.staffNew.is_complaint = true;
            }
            if (vm.companySelected) {
                vm.staffNew.company_id = vm.companySelected.id;
            }
            if (vm.mainBranch) {
                vm.staffNew.branch_id = vm.mainBranch.id;
            }
            var options = {
                owner: $scope.owner,
                item: vm.staffNew
            }
            console.log(options);
            staffsroiService.createStaff(options).then(function (response) {
                angular.forEach(vm.files, function (f) {
                    vm.uploadMedia(f, response.id, 'user_photo')
                })
                Promise.all([
                    clientsService.addUserToCompany({
                        owner: $scope.owner,
                        user_id: response.id,
                        company_id: vm.companySelected.id
                    }),
                    clientsService.addUserJobPosition({
                        owner: $scope.owner,
                        user_id: response.id,
                        branch_id: vm.mainBranch.id,
                        division_id: 1,
                        job_position_id: response.job_position_id
                    })
                ]).then(function (response) {
                    $rootScope.pagination_resetquery();
                })
                vm.checkUploadsAndUpdateStaff();
            }, function (err) {
                vm.loadingReadPane = false;
            })
        }

        function updateStaff(item) {
            vm.loadingReadPane = true;
            var updatePicture = false;
            if (vm.fromComplaint) {
                vm.staffSelected.is_complaint = true;
            }
            var options = {
                owner: $scope.owner,
                item: item ? item : vm.staffSelected,
                id: item ? item.id : vm.staffSelected.id
            }
            staffsroiService.updateStaff(options).then(function (response) {
                angular.forEach(vm.files, function (f) {
                    if (!f.url) {
                        vm.uploadMedia(f, response.id, 'user_photo')
                        updatePicture = true;
                    }
                })
                if (item) {
                    for (var i = 0; i < vm.staffsroi.length; i++) {
                        if (item.id == vm.staffsroi[i].id) {
                            vm.staffsroi[i] = item;
                        }
                    }
                }
                if (updatePicture) {
                    vm.checkUploadsAndUpdateStaff();
                } else {
                    initState()
                    vm.loadingReadPane = false;
                    $rootScope.pagination_resetquery();
                }
            })
        }

        function checkUploadsAndUpdateStaff() {
            var noUpdate = false;
            if (vm.files && vm.files.length > 0) {
                angular.forEach(vm.files, function (file) {
                    if (angular.isUndefined(file.progress) || file.progress < 100) {
                        noUpdate = true;
                    }
                })
                if (!noUpdate && !$scope.uploadingFile) {
                    initState()
                    vm.loadingReadPane = false;
                    $rootScope.pagination_resetquery();
                } else {
                    $timeout(function () {
                        vm.checkUploadsAndUpdateStaff();
                    }, 1000)
                }
            } else {
                initState()
                vm.loadingReadPane = false;
                $rootScope.pagination_resetquery();

            }
        }


        function getPositions() {
            var options = {
                owner: $scope.owner,
                resultsPerPage: 1000
            };
            staffsroiService.getPositions(options).then(function (response) {
                vm.positions = [];
                for (var i = 0; i < response.data.length; i++) {
                    vm.positions.push({ name: response.data[i].name, id: response.data[i].id });
                }
            })
        }
        function getDivisions() {
            var options = {
                owner: $scope.owner,
                resultsPerPage: 1000
            };
            staffsroiService.getDivisions(options).then(function (response) {
                vm.divisions = [];
                for (var i = 0; i < response.data.length; i++) {
                    vm.divisions.push({ name: response.data[i].name, id: response.data[i].id });
                }
            })
        }

        function getPositionNameById(id) {
            if (id) {
                for (var i = 0; i < vm.positions.length; i++) {
                    if (vm.positions[i].id === id) return vm.positions[i].name;
                }
            }
            return null;
        }

        function deleteStaff(ev) {
            const message = $translate.instant('GLOBAL.ARE_YOU_SURE');
            const yes = $translate.instant('GLOBAL.YES');
            const no = $translate.instant('GLOBAL.NO');

            const confirm = $mdDialog.confirm()
                .title(message)
                .targetEvent(ev)
                .ok(yes)
                .cancel(no);

            $mdDialog.show(confirm).then(e => {
                var threads = angular.copy(vm.selectedThreads);
                vm.selectedThreads = [];
                for (var j = 0; j < threads.length; j++) {
                    var options = {
                        owner: $scope.owner,
                        id: threads[j].id
                    };
                    staffsroiService.deleteStaff(options).then(function (response) {
                        $rootScope.pagination_resetquery();
                    })
                    initState();
                }
            })

        }

        function duplicateStaff() {
            var threads = angular.copy(vm.selectedThreads);
            vm.selectedThreads = [];
            for (var j = 0; j < threads.length; j++) {
                var options = {
                    owner: $scope.owner,
                    item: transformsroiStaff.duplicateStaff(threads[j])
                };
                staffsroiService.createStaff(options).then(function (response) {
                    clientsService.addUserToCompany({
                        owner: $scope.owner,
                        user_id: response.id,
                        company_id: vm.mainCompany.id
                    }).then(function (response) {
                        $rootScope.pagination_resetquery();
                    })

                })
                initState();
            }
        }

        function addUserJob(user, branchId, divisionId, jobPositionId) {
            vm.loadingPositions = true;
            clientsService.addUserJobPosition({
                owner: $scope.owner,
                user_id: user.id,
                branch_id: branchId,
                division_id: divisionId,
                job_position_id: jobPositionId
            }).then(function (response) {
                console.log(response)
                vm.showFormAdd = false;
                vm.formNewPosition = {};
                staffsroiService.getStaffItem({
                    id: vm.staffSelected.id,
                    owner: $scope.owner
                })
                    .then(function (resp) {
                        vm.staffSelected = resp;
                        vm.loadingPositions = false;
                    })
            })
        }

        function getRegionLiteral(literalKey) {
            if (vm.companySelected.region_id && vm.regionsLiterals) {
                const literalsObject = vm.regionsLiterals.find(x => x.region_id === vm.companySelected.region_id)
                return literalsObject.literals[literalKey];
            } else {
                return '';
            }
        }

        $scope.$watch('vm.files', function () {
            console.debug("WATCH!!:::!:!:!:!: ")

        });

        function showUserImage(user) {
            return $scope.storagePrefix + user.files.url
        }
        function getAdminUsers() {
            var options = {
                owner: $scope.owner,
                inCompany: vm.companySelected.id,
                resultsPerPage: 100
            };
            usersService.getUsers(options).then(res => {
                vm.adminUsers = res.data;
//                console.log(vm.adminUsers);
            })
        }
        function newStaff(ev) {
            vm.originalEmail = null;
            if (vm.fromComplaint) {
                if (!vm.complaintSettings) {
                    alert('Por favor, contacta con un administrador para que defina un plan en esta empresa.');
                }
                if (vm.staffsroi.length >= vm.complaintSettings.max_allowed_users) {
                    let quota = {};
                    if (vm.complaintSettings) {
                        quota = vm.complaintSettings;
                        quota.users_registered = vm.staffsroi.length
                    }
                    $mdDialog.show({
                        controller: 'UserQuotaDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/dialogs/userQuotaDialog/userQuotaDialog2.html',
                        parent: angular.element($document.body),
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        locals: {
                            user: vm.userLogued,
                            quotaComplaint: quota
                        }
                    }).then(function (res) {
                        if (res && res.type) {
                            if (res.type == 'upgrade') {
                                console.log("go upgrade screen");
                            }
                        }
                    });
                } else {
                    newStaffData();
                }
            } else {
                if (vm.quota.users_registered >= vm.quota.max_allowed_users) {
                    $mdDialog.show({
                        controller: 'UserQuotaDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/dialogs/userQuotaDialog/userQuotaDialog2.html',
                        parent: angular.element($document.body),
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        locals: {
                            user: vm.userLogued,
                            quotaComplaint: null
                        }
                    }).then(function (res) {
                        if (res && res.type) {
                            if (res.type == 'upgrade') {
                                console.log("go upgrade screen");
                            }
                        }

                    });

                } else {
                    newStaffData();
                }
            }
        }

        function newStaffData() {
            vm.files = [];
            if (vm.staffSelected)
                vm.staffSelected = undefined;
            vm.staffNew = {};
            vm.staffNew.enabled = false;
            vm.viewEditDataNew();
        }

        function initState() {
            vm.staffSelected = undefined;
            vm.staffNew = undefined;
        }

        function checkFields() {
            if (vm.staffNew) {
                return transformsroiStaff.checkFieldsStaff(vm.staffNew);
            } else if (vm.staffSelected) {
                return transformsroiStaff.checkFieldsStaff(vm.staffSelected);
            }
        }



        /**
         * Open thread
         *
         * @param thread
         */
        function openThread(thread) {
            // // Set the read status on the thread
            // thread.read = true;

            // // Assign thread as the current thread
            // vm.currentThread = thread;

            // // Update the state without reloading the controller
            // $state.go('app.aircrafts.threads.thread', { threadId: thread.id }, { notify: false });
        }

        /**
         * Close thread
         */
        function closeThread() {
            // vm.currentThread = null;

            // // Update the state without reloading the controller
            // $state.go('app.aircrafts.threads', {
            //     type: vm.currentFilter.type,
            //     filter: vm.currentFilter.filter
            // }, { notify: false });
        }

        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        function isSelected(thread) {
            return vm.selectedThreads.indexOf(thread) > -1;
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        function toggleSelectThread(thread, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedThreads.indexOf(thread) > -1) {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            } else {
                vm.selectedThreads.push(thread);
            }
        }

        /**
         * Select threads. If key/value pair given,
         * threads will be tested against them.
         *
         * @param [key]
         * @param [value]
         */
        function selectThreads(key, value) {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedThreads = [];

            for (var i = 0; i < vm.staffsroi.length; i++) {
                if (angular.isUndefined(key) && angular.isUndefined(value)) {
                    vm.selectedThreads.push(vm.staffsroi[i]);
                    continue;
                }

                if (angular.isDefined(key) && angular.isDefined(value) && vm.staffsroi[i][key] === value) {
                    vm.selectedThreads.push(vm.staffsroi[i]);
                }
            }
        }

        /**
         * Deselect threads
         */
        function deselectThreads() {
            vm.selectedThreads = [];
        }

        /**
         * Toggle select threads
         */
        function toggleSelectThreads() {
            if (vm.selectedThreads.length > 0) {
                vm.deselectThreads();
            } else {
                vm.selectThreads();
            }
        }

        /**
         * Set the status on given thread, current thread or selected threads
         *
         * @param key
         * @param value
         * @param [thread]
         * @param [event]
         */
        function setThreadStatus(key, value, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                thread[key] = value;
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                vm.currentThread[key] = value;
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                vm.selectedThreads[x][key] = value;
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleThreadStatus(key, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                if (typeof (thread[key]) !== 'boolean') {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                if (typeof (vm.currentThread[key]) !== 'boolean') {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                if (typeof (vm.selectedThreads[x][key]) !== 'boolean') {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }




        /**
         * Change the view
         *
         * @param view
         */
        function changeView(view) {
            if (vm.views[view]) {
                vm.defaultView = view;
                vm.currentView = view;
            }
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function staffHasBranch(branch) {
            var hasBranch = false;
            angular.forEach(vm.staffSelected.division_jobs, function (divisionJobs) {
                if (divisionJobs.branch_id == branch.id) {
                    hasBranch = true;
                }
            })
            return hasBranch;
        }

        function staffHasCompany(company) {
            var hasCompany = false;
            angular.forEach(company.branches, function (branch) {
                if (vm.staffHasBranch(branch)) {
                    hasCompany = true;
                }
            })
            return hasCompany;
        }

        function viewEditData() {
            vm.copyStaff = angular.copy(vm.staffSelected);
            vm.editData = true;
            vm.tabActive = 'edit';
            vm.editCompanies = false;
            vm.previewData = false;
        }
        function viewEditDataNew() {
            vm.tabActive = 'editnew';
        }
        function viewPreviewData() {
            vm.tabActive = 'preview';
        }
        function viewEditCompanies() {
            vm.tabActive = 'companies';
        }
        function viewActivity() {
            vm.tabActive = 'activity';
        }
        function viewTask() {
            vm.tabActive = 'tasks';
        }
        function viewConfigureTabs() {
            vm.tabActive = 'configuretabs';
        }
        function resetStaffSelected() {
            vm.staffSelected = null;
            vm.staffNew = null;
            vm.tabNewSelected = 'new';
        }
        var originatorEv;

        function openMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        }

        function toggleStaffStatusEdit(fieldName, item, save) {

            event.stopPropagation();
            if (item) {
                if (angular.isUndefined(item[fieldName])) {
                    item[fieldName] = 0;
                }
                var thread = item[fieldName];
                thread = (thread) ? false : true;
                item[fieldName] = thread;
                updateStaff(item);
            } else {
                if (vm.staffSelected) {
                    var thread = vm.staffSelected[fieldName];
                    thread = (thread) ? false : true;
                    vm.staffSelected[fieldName] = thread;
                } else {
                    if (angular.isUndefined(vm.staffNew[fieldName])) {
                        vm.staffNew[fieldName] = 0;
                    }
                    var thread = vm.staffNew[fieldName];
                    thread = (thread) ? false : true;
                    vm.staffNew[fieldName] = thread;
                }
            }
            vm.basicForm.$setDirty()
        }

        function uploadMedia(file, idValue, uploadKey) {
            if (!file.$error) {
                var token = undefined;
                $scope.uploadingFile = true;
                console.debug("UPLOAD STARTED______****", file)
                mediaService.getS3UploadPreSignedUrl({
                    owner: $scope.owner,
                    uploadKey: uploadKey,
                    fileName: file.name,
                    rowId: idValue
                })
                    .then(function (resp) {
                        token = resp.token;
                        file.id_media = resp.id_media;
                        file.upload = Upload.http({
                            url: resp.url,
                            skipAuthorization: true,
                            method: 'PUT',
                            headers: {
                                "Content-Type": file.type != '' ? file.type : 'application/octet-stream'
                            },
                            data: file
                        })
                        file.upload.then(function (response) {
                            file.result = response.data;
                            $timeout(function () {
                                $scope.log = 'file: ' +
                                    file.name +
                                    ', Response: ' + JSON.stringify(response.data) +
                                    ', ID: ' + file.id_media +
                                    '\n' + $scope.log;
                            });
                            console.debug("FINISHING UPLOAD______****", file)
                            mediaService.finishedUploadingFileToCdn({
                                owner: $scope.owner,
                                idMedia: file.id_media,
                                token: token
                            }).then(function () {
                                $scope.uploadingFile = false;
                            })

                        }, function (response) {
                            if (response.status > 0)
                                $scope.errorMsg = response.status + ': ' + response.data;
                        });

                        file.upload.progress(function (evt) {
                            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                        });
                    })
            }
        };



    }
})();

(function () {
    'use strict';

    angular
        .module('app.staffsroi')
        .service('staffsroiService', staffsroiService);

    /** @ngInject */
    // I provide access to the session store.
    function staffsroiService($q, $rootScope, $resource, settingsDomainService, companyService, sessionService, COMMON, $window, $mdToast) {
        var branch = {};
        var division = {};
        function getStaff(options) {
            var deferred = $q.defer();
            var opt = {
                owner: options.owner,
                inCompany: companyService.getCompanyId(),

                withFiles: true,
                withCompanies: true,
                search: options.searchStringFilter,
                page: options.page,
                resultsPerPage: options.resultsPerPage,
                sortField: options.sortField ? options.sortField : 'id'

            };
            if (companyService.getCompanyId() && branch && branch.id) {
                opt.inBranch = branch.id;
            }
            if (companyService.getCompanyId() && division && division.id) {
                opt.inDivision = division.id;
            }
            resourceStaff.get(opt,
                function (response) {
//                    console.log(response);
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getStaffItem(options) {
            var deferred = $q.defer();
            resourceStaffItem.get({
                id: options.id,
                owner: options.owner
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getActivityUser(options) {
            var deferred = $q.defer();
            resourceActivityStaff.get({
                id: options.id,
                owner: options.owner
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getTasksUser(options) {
            var deferred = $q.defer();
            resourceTasksStaff.get(options,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateStaff(options) {
            var deferred = $q.defer();
            resourceStaffItem.update({
                owner: options.owner,
                id: options.id
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function createStaff(options) {
            var deferred = $q.defer();
            resourceStaffItem.post({
                owner: options.owner
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function deleteStaff(options) {
            var deferred = $q.defer();
            resourceStaffItem.delete({
                owner: options.owner,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getFilters(options) {
            var deferred = $q.defer();

            return (deferred.promise);
        }


        function getPositions(options) {
            var deferred = $q.defer();
            resourcePositions.get({
                owner: options.owner,
                resultsPerPage: options.resultsPerPage
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getDivisions(options) {
            var deferred = $q.defer();
            resourceDivisions.get({
                owner: options.owner,
                resultsPerPage: options.resultsPerPage
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getMainBranch(options) {
            var deferred = $q.defer();
            resourceMainBranch.get({
                owner: options.owner,
                id_company: options.id_company
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        function setBranch(branchData) {
            branch = branchData;
        }

        function setDivision(divisionData) {
            division = divisionData;
        }

        var resourcePositions = $resource(COMMON.BASE_API + "/owner/:owner/jobPosition", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        });
        var resourceDivisions = $resource(COMMON.BASE_API + "/owner/:owner/division", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        });
        var resourceMainBranch = $resource(COMMON.BASE_API + "/owner/:owner/branch?company_id=:id_company&is_main=1", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        });



        var resourceStaffItem = $resource(COMMON.BASE_API + "/owner/:owner/user/:id", {
            // is_complaint: '@is_complaints',
        }, {
            get: {
                method: "GET",
                isArray: false
            },

            post: {
                method: "POST",
                isArray: false
            },

            delete: {
                method: "DELETE",
                isArray: false
            },

            update: {
                method: "PUT",
                isArray: false
            },
        });


        var resourceStaff = $resource(COMMON.BASE_API + "/owner/:owner/user", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        });

        var resourceActivityStaff = $resource(COMMON.BASE_API + "/owner/:owner/user/activities?sortField=date&sortDir=desc&parentsOnly&withUser&userId=:id&resultsPerPage=100", {
            // No default data
        }, {
            get: {
                method: "GET"
                // isArray: false
            }
        });

        var resourceTasksStaff = $resource(COMMON.BASE_API + "/owner/:owner/activeTree/all?user_id=:id", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        });


        return ({
            get: getStaff,
            getStaff: getStaff,
            getMainBranch: getMainBranch,
            getStaffItem: getStaffItem,
            setBranch: setBranch,
            setDivision: setDivision,
            getFilters: getFilters,
            getPositions: getPositions,
            getDivisions: getDivisions,
            getActivityUser: getActivityUser,
            getTasksUser: getTasksUser,
            updateStaff: updateStaff,
            deleteStaff: deleteStaff,
            createStaff: createStaff

        });

    }

})();

(function () {
    'use strict';

    angular
        .module('app.stakeholders')
        .controller('stakeholdersController', stakeholdersController);

    /** @ngInject */
    function stakeholdersController($scope, $rootScope, $stateParams, companyService, $translate, $document, $mdDialog,
        $mdMedia, $mdSidenav, $state, msApi, tinyMceService, requestContext, evidencesControlsService, stakeholdersService,
        transformStakeholders, mediaService, Upload, $filter, $timeout, msUtils, documentsService, sessionService, $cookies, is_owner) {
        var vm = this;
        vm.userLogued = sessionService.getUser();

        vm.loadingStep = false;
        vm.folders = 'Folders.data';
        vm.labels = 'Labels.data';
        vm.loadingThreads = true;
        vm.saveDialog = saveDialog;
        vm.currentFilter = {
            type: $state.params.type,
            filter: $state.params.filter
        };
        vm.currentThread = null;
        vm.selectedThreads = [];
        vm.stakeElemen = [];
        vm.stakeholder = [];
//        vm.isCompanySelected = isCompanySelected;
        vm.views = {
            split: 'app/main/apps/stakeholders/views/list/split-view.html',
            nosplit: 'app/main/apps/stakeholders/views/list/nosplit-view.html'
        };
        vm.defaultView = 'split';
        vm.currentView = 'split';
        //        console.log($rootScope.companySel);
        vm.readView = false;
        vm.closeDialog = closeDialog;

        vm.administratorFields = vm.personFields;
        vm.managerLegalFields = vm.personFields;
        vm.complianceFields = vm.personFields;
        vm.reportFields = vm.personFields;
        vm.personnelFields = vm.personFields;
//        vm.getRegionLiteral = getRegionLiteral;

        vm.companySelectEvent  = companySelectEvent;
//        vm.getSectorById = getSectorById;


        vm.idClient = undefined;
        vm.idCompany = undefined;
        vm.updateLogotype = false;
        vm.showForm = true;
        vm.allQuestions = true;
        $scope.storagePrefix = '';


        vm.isSelected = isSelected;
        vm.toggleSelectThread = toggleSelectThread;
        vm.newForm = newForm;

        vm.deleteStakeholder = deleteStakeholder;
        vm.edit = false;
        vm.openCompany = openCompany;
        vm.editCompany = editCompany;
        vm.getProyects = getProyects;
        vm.deletestake = deletestake;


        //////////
        var companySelectEvent = $rootScope.$on('company-selected', function (event) {
            getProyects();
            //           getComplianceOfficers();
        });

        $scope.$on('pagination:loadStart', function (event) {
            $scope.isLoading = true;
            $scope.isLoadingP = true;
        });

        $scope.$on('pagination:loadPage', function (event) {
            $scope.isLoading = false;
            vm.is_owner = vm.companies.length <= 1;
            //            getProyects();
            init();
        });
        //        init();
        $scope.owner = $stateParams.owner;


        this.awesomeCallback = function (node, tree) {
            // Do something with node or tree
        };

        this.otherAwesomeCallback = function (node, isSelected, tree) {
            // Do soemthing with node or tree based on isSelected
        };
        if ($rootScope.companySel) {
            getProyects();
        }

        function init() {
            mediaService.getStoragePrefix({
                owner: $scope.owner,
            }).then(function (res) {
                $scope.storagePrefix = res.prefix;
            })
            evidencesControlsService.getCurrencies({ owner: $scope.owner }).then(function (res) {
                vm.currencies = res.data;
            })
            stakeholdersService.getRegions({ owner: $scope.owner }).then(function (res) {
                vm.regions = res.data;
            })
            stakeholdersService.getFileRegions().then(function (res) {
                vm.regionsLiterals = res;
            })
        }

        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'nosplit';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big) {
                vm.currentView = 'nosplit';
            }

        });

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small) {
                vm.currentView = 'split';
            }

        });

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                if (vm.defaultView === 'split') {
                    vm.currentView = 'split';
                }
            }
        });


        var originatorEv;

        function openMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        }

        function getProyects(idCompany, inOwner) {
            var options = {
                owner: $scope.owner,
                company_id: $rootScope.companySel,
                withFiles: true
            };
            //           console.log(vm.stakeElemen);
            stakeholdersService.getProyects(options).then(function (response) {
                vm.stakeholder = response;
                $scope.isLoadingP = false;
            } , function(response) {
                vm.stakeholder  = [];
//                $scope.isLoadingP = true;
                   }
            )
                }

        function openCompany(company, ev) {
            vm.company = company;
            vm.edit = true;
        }

        function saveDialog(company, ev) {
            if (company.id) {
                vm.formWizard = {};
                $scope.isLoading = true;
                vm.idCompany = company.id;
                vm.formWizard.company = company;
                vm.edit = false;
            }
            else {
                //            vm.formWizard = {};
                $scope.isLoading = true;
                //           vm.idCompany = company.id;
                vm.formWizard = {};
                vm.formWizard.company = vm.company;
                vm.edit = false;
                vm.formWizard.company.company_id = $rootScope.companySel;
            }
            createProyect(null, true);
        }
        function closeDialog() {
            vm.edit = false;
        }
        function editCompany() {
            vm.users = [];
            $rootScope.$broadcast('select-company', vm.formWizard.company);
            sessionService.set('companySelected', vm.formWizard.company);
            angular.forEach(vm.formWizard.personnel, function (u) {
                var userExists = $filter('filter')(vm.users, { id: u.id });
                if (userExists.length < 1) {
                    vm.users.push(u);
                }
            })
            vm.readView = true;
            vm.preview = false;
        }


        function newForm(ev) {
            vm.idCompany = null;
            vm.company = [];
            vm.edit = true;
        }

        function closeForm(preview) {
            if (vm.idCompany) {
                getDataCompany(vm.idCompany);
                vm.readView = false;
                vm.preview = preview;
            } else {
                vm.goClients();
            }
        }



        function createProyect(msWizard, close) {
            //           console.log(vm.formWizard);
            var options = {
                owner: $scope.owner,
                item: transformStakeholders.proyectToDTO(vm.formWizard)
            };
            //            console.log(transformStakeholders.proyectToDTO(vm.formWizard));
            //            return;
            //            vm.formWizard.company.region_id = options.item.region_id;
            //            return;
            if (vm.idCompany) {
                options.id = vm.idCompany;
                //               console.log(options);
                stakeholdersService.updateProyect(options).then(function (response) {

                });


            } else {
                //               options.item.is_owner = vm.companies.length > 0 ? 0 : true;
                stakeholdersService.createProyect(options).then(function (response) {
                    //                    sessionService.authenticate($cookies.get('owner'));
                    $scope.isLoadingP = true;
                    vm.idCompany = response.id;
                    getProyects();

                })
            }
        }
        
        function deleteStakeholder(ev){
            var threads = angular.copy(vm.selectedThreads);
            const confirm = $mdDialog   .confirm()
                                        .title($translate.instant('GLOBAL.ARE_YOU_SURE'))
                                        .targetEvent(ev)
                                        .ok($translate.instant('GLOBAL.YES'))
                                        .cancel($translate.instant('GLOBAL.NO'));
            $mdDialog.show(confirm).then(e => {
                for( var i = 0; i < threads.length; i++){
                        var options = {
                            owner: $scope.owner,
                            stake_id: threads[i].id,
                        }
//                        console.log(options);
                        stakeholdersService.deleteStakeholder(options).then(function (response) {
                            vm.edit = false;
                            getProyects();
                        })    
                }
            })
            vm.edit = false;
            vm.selectedThreads = [];
        }

        // function deleteStakeholder(ev) {
        //     var threads = angular.copy(vm.selectedThreads);
        //     const message = $translate.instant('GLOBAL.ARE_YOU_SURE');
        //     const yes = $translate.instant('GLOBAL.YES');
        //     const no = $translate.instant('GLOBAL.NO');
        //     const confirm = $mdDialog.confirm()
        //             .title(message)
        //             .targetEvent(ev)
        //             .ok(yes)
        //             .cancel(no);
        //     $mdDialog.show(confirm).then(e => {
        //         for (var j = 0; j < vm.selectedThreads.lenght; j++){
        //             var options = {
        //                 owner: $scope.owner,
        //                 stake_id: threads[j].id
        //             };
        //             stakeholdersService.deleteStakeholder(options).then(function(response) {
        //                 vm.edit = false;
        //                 getProyects();
        //             })
        //         }
        //     }).catch(err => { })
        // }
                
        //                 stakeholdersService.deleteStakeholder(options).then(function (response) {
        //                         //                    $rootScope.pagination_resetquery();
        //                         //                    sessionService.authenticate($cookies.get('owner'));
        // //                        $rootScope.$broadcast('select-company', {});
        //                         vm.edit = false;
        //                         getProyects();
        //                         //                    companyService.setCompanyId(null);
        //                         //                    sessionService.set('companySelected', null);
        //                     })
        //                 })
        //                     .catch(err => { })
        
        //             //            console.log(threads);
        //             vm.selectedThreads = [];
        //             for (var j = 0; j < threads.length; j++) {
        //                 //                console.log(threads[j].id);
                        
        //             }
        //             //           getProyects();
        //         }

        function isSelected(thread) {
            return vm.selectedThreads.indexOf(thread) > -1;
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        function toggleSelectThread(thread, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedThreads.indexOf(thread) > -1) {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            }
            else {
                vm.selectedThreads.push(thread);
            }
        }
        function deletestake(ev) {
            const message = $translate.instant('GLOBAL.ARE_YOU_SURE');
            const yes = $translate.instant('GLOBAL.YES');
            const no = $translate.instant('GLOBAL.NO');

            const confirm = $mdDialog.confirm()
                .title(message)
                .targetEvent(ev)
                .ok(yes)
                .cancel(no);

            $mdDialog.show(confirm).then(e => {
                vm.deleteStakeholder();
            })
                .catch(err => { })

        }
        }
})();

(function () {
    'use strict';

    angular
        .module('app.stakeholders')
        .service('stakeholdersService', stakeholdersService);

    /** @ngInject */
    // I provide access to the session store.
    function stakeholdersService($q, $resource, settingsDomainService, sessionService, COMMON, $window, $mdToast, $state) {
        function deleteStakeholder(options) {
//           console.log(options);
            var deferred = $q.defer();
            resourceProyect.delete({
                owner: options.owner,
                stake_id: options.stake_id
            },
                function (response) {
//                    console.log(response);
                    deferred.resolve(response);
                },

                function (e) {
                    console.log(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateProyect(options) {
            var deferred = $q.defer();
            resourceProyect.update({
                owner: options.owner,
                id: options.id
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    console.log(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function createProyect(options) {
            var deferred = $q.defer();
 //           console.log(options);
            resourceProyect.post({
                owner: options.owner
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    console.log(e);
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getProyects(options) {
            var deferred = $q.defer();
            resourceProyect.get(options,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    console.log(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        var resourceFile = $resource("/assets/json-i18n/region-literals.json", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: true
                }
            });

            var resourceClients = $resource(COMMON.BASE_API + "/owner/:owner/company/:id", {
                // No default data
            }, {
                    get: {
                        method: "GET",
                        isArray: false
                    },
    
                    post: {
                        method: "POST",
                        isArray: false
                    },
    
                    delete: {
                        method: "DELETE",
                        isArray: false
                    },
    
                    update: {
                        method: "PUT",
                        isArray: false
                    },
                });
    
    
            var resourceProyect = $resource(COMMON.BASE_API + "/owner/:owner/stakeholder/:id", {
                // No default data
            }, {
                    get: {
                        method: "GET",
                        isArray: true
                    },
    
                    post: {
                        method: "POST",
                        isArray: false
                    },
    
                    delete: {
                        method: "DELETE",
                        isArray: true
                    },
    
                    update: {
                        method: "PUT",
                        isArray: false
                    },
                });
    
        var resourceSectors = $resource(COMMON.BASE_API + "/owner/:owner/sector", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });

        var resourceCompany = $resource(COMMON.BASE_API + "/owner/:owner/company/:id", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                }
            });

        var resourceUser = $resource(COMMON.BASE_API + "/owner/:owner/user/:id/", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                }
            });

        var resourceAddToCompany = $resource(COMMON.BASE_API + "/owner/:owner/user/addToCompany", {
            // No default data
        }, {
                put: {
                    method: "PUT",
                    isArray: false
                }
            });

        var resourceAddJobPosition = $resource(COMMON.BASE_API + "/owner/:owner/user/addDivisionJobPosition", {
            // No default data
        }, {
                put: {
                    method: "PUT",
                    isArray: false
                }
            });

        var resourceRemoveJobPosition = $resource(COMMON.BASE_API + "/owner/:owner/user/removeDivisionJobPosition/:user_id/:branch_id/:division_id/:job_position_id", {
            // No default data
        }, {
                delete: {
                    method: "DELETE",
                    isArray: false
                }
            });

        var resourceQuestion = $resource(COMMON.BASE_API + "/owner/:owner/question/:evaluateAnswer", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                }
            });

        var resourceBranch = $resource(COMMON.BASE_API + "/owner/:owner/branch/:id", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                },
                delete: {
                    method: "DELETE",
                    isArray: false
                }
            });
        var resourceBranches = $resource(COMMON.BASE_API + "/owner/:owner/branch/", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });
        var resourceStoragePrefix = $resource(COMMON.BASE_API + "/owner/:owner/upload/storagePrefix", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });

        var resourcePositions = $resource(COMMON.BASE_API + "/owner/:owner/jobPosition", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });

        var resourceDivisions = $resource(COMMON.BASE_API + "/owner/:owner/division", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });
        var resourceLegalFolder = $resource(COMMON.BASE_API + "/owner/:owner/fileGroup/legalDocuments/:id_company", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });
        var resourceRegions = $resource(COMMON.BASE_API + "/owner/:owner/region", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });


        return ({
            updateProyect: updateProyect,
            deleteStakeholder: deleteStakeholder,
            getProyects: getProyects,
            createProyect: createProyect,
        });

    }

})();
(function () {
    'use strict';

    angular
        .module('app.users')
        .controller('UsersController', UsersController);

    /** @ngInject */
    function UsersController($scope, $rootScope, $mdMenu, documentsService, $stateParams, $translate, $document, $mdDialog,
        $mdMedia, $mdSidenav, $state, msApi, tinyMceService, requestContext, companyService, clientsService, mediaService, sessionService, $timeout, usersService, transformUsers, Upload) {
        var vm = this;
        // vm.is_owner = is_owner;
        vm.ivhOptions = {
            defaultSelectedState: false,
            validate: true,
            expandToDepth: -1,
            useCheckboxes: true,
            twistieCollapsedTpl: '<md-icon md-font-icon="icon-chevron-right"></md-icon>',
            twistieExpandedTpl: '<md-icon md-font-icon="icon-chevron-down"></md-icon>',
            twistieLeafTpl: '<span style="cursor: default;">&#8192;&#8192;</span>'
        };

        vm.tabActive = 'edit';
        vm.userLogued = sessionService.getUser();
        sessionService.getQuota().then(function (quota) {
            vm.quota = quota;
        });
        vm.companies = sessionService.getUser().companies;
        vm.deleteAvatar = deleteAvatar;
        vm.deleteAvatarUserLogued = deleteAvatarUserLogued;
        vm.openMenu = openMenu;
        vm.mainCompany = _.find(vm.companies, { 'is_owner': true });
        // Data
        vm.accounts = {
            'creapond': 'johndoe@creapond.com',
            'withinpixels': 'johndoe@withinpixels.com'
        };
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
        vm.selectedAccount = 'creapond';

        vm.folders = 'Folders.data';
        vm.labels = 'Labels.data';
        vm.loadingThreads = true;

        vm.currentFilter = {
            type: $state.params.type,
            filter: $state.params.filter
        };
        vm.currentThread = null;
        vm.selectedThreads = [];

        vm.views = {
            split: 'app/main/apps/users/views/list/split-view.html',
            nosplit: 'app/main/apps/users/views/list/nosplit-view.html'
        };
        vm.defaultView = 'split';
        vm.currentView = 'split';

        vm.editData = false;
        vm.editCompanies = false;
        vm.files = [];
        vm.userTabsList = [];
        vm.readView = true;
        vm.loadingReadPane = false;

        //Methods
        vm.isAvailableConfigureMenu = isAvailableConfigureMenu;
        vm.openThread = openThread;
        vm.closeThread = closeThread;

        vm.isSelected = isSelected;
        vm.toggleSelectThread = toggleSelectThread;
        vm.selectThreads = selectThreads;
        vm.deselectThreads = deselectThreads;
        vm.toggleSelectThreads = toggleSelectThreads;

        vm.setThreadStatus = setThreadStatus;
        vm.toggleThreadStatus = toggleThreadStatus;
        vm.toggleUserStatusEdit = toggleUserStatusEdit;
        //vm.updateUserTab = updateUserTab;
        vm.toggleUserTabEdit = toggleUserTabEdit;

        vm.getRegionLiteral = getRegionLiteral;

        vm.containsNumber = containsNumber;
        vm.containUpperCaseAndLowerCase = containUpperCaseAndLowerCase;
        vm.closePassword = function() {
            $mdDialog.hide();
        };   
        vm.changeView = changeView;
        vm.toggleSidenav = toggleSidenav;
        vm.tinymceOptions = tinyMceService.getOptions($scope);

        vm.openUser = openUser;
        vm.closeUser = closeUser;
        vm.saveUser = saveUser;
        vm.deleteUser = deleteUser;
        vm.duplicateUser = duplicateUser;
        vm.newUser = newUser;
        vm.checkFields = checkFields;

        vm.getPositionNameById = getPositionNameById;

        vm.config = sessionService.config;

        vm.userHasCompany = userHasCompany;
        vm.userHasBranch = userHasBranch;
        vm.viewEditData = viewEditData;
        vm.viewActivity = viewActivity;
        vm.viewTasks = viewTasks;
        vm.viewMenu = viewMenu;
        vm.viewEditCompanies = viewEditCompanies;
        vm.uploadMedia = uploadMedia;
        vm.checkUploadsAndUpdateUser = checkUploadsAndUpdateUser;
        vm.translate = function (text) {
            return $translate.instant(text);
        }
        //////////

        $scope.$on('pagination:loadStart', function (event) {
            $scope.isLoading = true;
        });

        $scope.$on('pagination:loadPage', function (event) {
            $scope.isLoading = false;
        });


        $scope.owner = $stateParams.owner;
        init();

        /////////////////

        function init() {
            getPositions();
            getDivisions();
            mediaService.getStoragePrefix({
                owner: $scope.owner,
            }).then(function (res) {
                $scope.storagePrefix = res.prefix;
            })
            clientsService.getFileRegions().then(function (res) {
                vm.regionsLiterals = res;
            })
        }

        var companySelectEvent = $rootScope.$on('company-selected', function (event) {
            vm.companySelected = sessionService.get('companySelected');
            companyService.setCompanyId(vm.companySelected.id);
        });
        $scope.$on('$destroy', companySelectEvent);

        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'nosplit';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big)
                vm.currentView = 'nosplit';

        });

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small)
                vm.currentView = 'split';

        });

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                if (vm.defaultView === 'split') {
                    vm.currentView = 'split';
                }
            }
        });

        var originatorEv;

        function openMenu($mdOpenMenu, ev) {
            originatorEv = ev;
            $mdOpenMenu(ev);
        }
        function containsNumber() {
            return vm.password && vm.password.match(/\d+/g);
        }
        function containUpperCaseAndLowerCase() {
            return vm.password && vm.password.match(/[a-z]/) && vm.password.match(/[A-Z]/);
        }

        function openUser(user) {
            vm.files = [];
            if (!user && !vm.userSelected && !vm.userNew) {
                vm.userNew = {};
                vm.tabActive = 'editnew';
                return;
            }
            if (vm.userNew) {
                return;
            }
            if (user) {
                vm.loadingReadPane = true;
                vm.files = user.files ? [user.files] : [];
                usersService.getUser({
                    id: user.id,
                    owner: $scope.owner
                })
                    .then(function (resp) {
                        vm.userSelected = resp;
                        vm.viewEditData();
                        vm.loadingReadPane = false;
                    });
            } else if (vm.userLogued) {
                vm.userSelected = vm.userLogued;
                vm.viewEditData(); 
                
            }
        }

        function deleteAvatar(file) {
            var options = {
                owner: $scope.owner,
                id: file.id
            }
            documentsService.deleteDocument(options).then(function () {
                vm.files = [];
                $rootScope.pagination_resetquery();
            })
        }

        function deleteAvatarUserLogued(file) {
            var options = {
                owner: $scope.owner,
                id: file.id
            };
            documentsService.deleteDocument(options).then(function () {
                vm.files = [];
        
                // Forzar la recarga del estado actual para refrescar el toolbar
                $state.reload(); 
            });
        }

        vm.hiddenAvatarUserLogued = function(file) {
            // Simplemente eliminamos la imagen del array de archivos sin hacer solicitudes al servidor
            const index = vm.files.indexOf(file);
            if (index !== -1) {
                vm.files.splice(index, 1);  // Quita la imagen del array de archivos
            }
        
            // Mostrar la imagen original si no hay más imágenes nuevas cargadas
            if (vm.files.length === 0) {
                vm.showOriginalImage = true; // Vuelve a mostrar la imagen original del usuario
            }
        };
        
        
        
        
        function closeUser() {
            vm.userSelected = undefined;
            vm.userNew = undefined;
        }


        function saveUser(ev) {
            var email = vm.userSelected ? vm.userSelected.email : vm.userNew ? vm.userNew.email : vm.userLogued.email;     
            var options = {
                owner: $scope.owner,
                searchStringFilter: email
            };
            usersService.getUsersWithTrashed(options).then(function (response) {
                var existedUser = _.find(response.data, function (user) {
                    if (user.email === email && 
                        ((!vm.userSelected || user.id !== vm.userSelected.id) && 
                        (!vm.userNew || user.id !== vm.userNew.id) && 
                        (!vm.userLogued || user.id !== vm.userLogued.id))) {
                        return true;
                    }
                });
                if (!existedUser) {
                    if (vm.userSelected) {
                        updateUser(vm.userSelected);
                    } else if (vm.userNew) {
                        createUser();
                    } else {
                        updateUser(vm.userLogued);
                    }
                } else {
                    var alert = $mdDialog.alert({
                        title: vm.translate('GLOBAL.ATTENTION'),
                        textContent: vm.translate('GLOBAL.USER_ALREADY_EXISTS'),
                        ok: vm.translate('GLOBAL.CLOSE'),
                    });
        
                    $mdDialog
                        .show(alert)
                        .finally(function () {
                            alert = undefined;
                        });
                }
            })
            .catch(function(error) {
                console.error('Error en el servicio getUsersWithTrashed:', error);
            });
        
            $mdDialog.hide();};
            

        function createUser() {
            vm.loadingReadPane = true;
            vm.userNew.division_id = 1;
            vm.userNew.job_position_id = 1;
            vm.userNew.region_id = vm.mainCompany.region_id;
            var options = {
                owner: $scope.owner,
                item: vm.userNew
            }
            usersService.createUser(options).then(function (response) {
                angular.forEach(vm.files, function (f) {
                    vm.uploadMedia(f, response.id, 'user_photo')
                })
                clientsService.addUserToCompany({
                    owner: $scope.owner,
                    user_id: response.id,
                    company_id: vm.mainCompany.id
                }).then(function (response) {
                    $rootScope.pagination_resetquery();
                })
                vm.checkUploadsAndUpdateUser();
            }, function (err) {
                vm.loadingReadPane = false;
            })
        }

        function updateUser(user) {
            vm.loadingReadPane = true;
            var updatePicture = false;
            if (vm.password) {
                user.password = vm.password;
            }
            var options = {
                owner: $scope.owner,
                item: user ? user : vm.userSelected,
                id: user ? user.id : vm.userSelected.id
            };
            usersService.updateUser(options).then(function (response) {
                angular.forEach(vm.files, function (f) {
                    if (!f.url) {
                        vm.uploadMedia(f, response.id, 'user_photo');
                        updatePicture = true;
                    }
                });
                if (vm.users && vm.users.length) {
                    for (var i = 0; i < vm.users.length; i++) {
                        if (user.id === vm.users[i].id) {
                            vm.users[i] = user;
                        }
                    }
                }
                if (updatePicture) {
                    vm.checkUploadsAndUpdateUser();
                } else {
                    initState();
                    vm.loadingReadPane = false;
                    if ($rootScope.pagination_resetquery) {
                        $rootScope.pagination_resetquery();
                    }
                }
                vm.closeUser();
               
            })
            .catch(function (error) {
                console.error('Error al actualizar el usuario:', error);
            });
        }

        function checkUploadsAndUpdateUser() {
            var noUpdate = false;
            if (vm.files && vm.files.length > 0) {
                angular.forEach(vm.files, function (file) {
                    if (angular.isUndefined(file.progress) || file.progress < 100) {
                        noUpdate = true;
                    }
                })
                if (!noUpdate && !$scope.uploadingFile) {
                    initState()
                    vm.loadingReadPane = false;
                    //$rootScope.pagination_resetquery();
                } else {
                    $timeout(function () {
                        vm.checkUploadsAndUpdateUser();
                    }, 1000)
                }
            } else {
                initState()
                vm.loadingReadPane = false;
                $rootScope.pagination_resetquery();

            }
        }


        function getPositions() {
            var options = {
                owner: $scope.owner
            };
            usersService.getPositions(options).then(function (response) {
                vm.positions = [];
                for (var i = 0; i < response.data.length; i++) {
                    vm.positions.push({ name: response.data[i].name, id: response.data[i].id });
                }
            })
        }
        function getDivisions() {
            var options = {
                owner: $scope.owner
            };
            usersService.getDivisions(options).then(function (response) {
                vm.divisions = [];
                for (var i = 0; i < response.data.length; i++) {
                    vm.divisions.push({ name: response.data[i].name, id: response.data[i].id });
                }
            })
        }

        function isAvailableConfigureMenu() {
            var result = false;
            if (vm.userLogued.user_type == 1) {
                result = true
            }
            if (vm.userLogued.user_type == 2 && vm.userSelected) {
                result = vm.userLogued.id === vm.userSelected.id || vm.userSelected.user_type > 2;
            }
            if (vm.userLogued.user_type == 3 && vm.userSelected) {
                result = vm.userLogued.id === vm.userSelected.id;
            }
            return result && vm.tabActive !== 'editnew';
        }

        function getRegionLiteral(literalKey) {
            if (vm.companySelected && vm.companySelected.region_id) {
                const literalsObject = vm.regionsLiterals.find(x => x.region_id === vm.companySelected.region_id)
                return literalsObject.literals[literalKey];
            } else {
                const literalsObject = vm.regionsLiterals[0]
                return literalsObject.literals[literalKey];
            }
        }

        function getPositionNameById(id) {
            if (id) {
                for (var i = 0; i < vm.positions.length; i++) {
                    if (vm.positions[i].id === id) return vm.positions[i].name;
                }
            }
            return null;
        }

        function deleteUser(ev) {
            const message = $translate.instant('GLOBAL.ARE_YOU_SURE');
            const yes = $translate.instant('GLOBAL.YES');
            const no = $translate.instant('GLOBAL.NO');

            const confirm = $mdDialog.confirm()
                .title(message)
                .targetEvent(ev)
                .ok(yes)
                .cancel(no);

            $mdDialog.show(confirm).then(e => {
                var threads = angular.copy(vm.selectedThreads);
                vm.selectedThreads = [];
                for (var j = 0; j < threads.length; j++) {
                    var options = {
                        owner: $scope.owner,
                        id: threads[j].id
                    };
                    usersService.deleteUser(options).then(function (response) {
                        $rootScope.pagination_resetquery();
                    })
                    initState();
                }
            });

        }

        function duplicateUser() {
            var threads = angular.copy(vm.selectedThreads);
            vm.selectedThreads = [];
            for (var j = 0; j < threads.length; j++) {
                var options = {
                    owner: $scope.owner,
                    item: transformUsers.duplicateUser(threads[j])
                };
                usersService.createUser(options).then(function (response) {
                    clientsService.addUserToCompany({
                        owner: $scope.owner,
                        user_id: response.id,
                        company_id: vm.mainCompany.id
                    }).then(function (response) {
                        $rootScope.pagination_resetquery();
                    })

                })
                initState();
            }
        }

        $scope.$watch('vm.files', function () {
            console.debug("WATCH!!:::!:!:!:!: ")

        });
        function newUser(ev) {
            if (vm.quota.users_registered >= vm.quota.max_allowed_users) {
                $mdDialog.show({
                    controller: 'UserQuotaDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/dialogs/userQuotaDialog/userQuotaDialog2.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        user: vm.userLogued,
                        quotaComplaint: null
                    }
                }).then(function (res) {
                    if (res && res.type) {
                        if (res.type == 'upgrade') {
                            console.log("go upgrade screen");
                        }
                    }

                });

            } else {
                vm.files = [];
                if (vm.userSelected)
                    vm.userSelected = undefined;
                vm.userNew = {};
                vm.tabActive = 'editnew';
                vm.userNew.enabled = false;
            }
        }

        function initState() {
            vm.userSelected = undefined;
            vm.userNew = undefined;
        }

        function checkFields() {
            if (vm.userNew) {
                return transformUsers.checkFieldsUser(vm.userNew);
            } else if (vm.userSelected) {
                return transformUsers.checkFieldsUser(vm.userSelected);
            }
        }



        /**
         * Open thread
         *
         * @param thread
         */
        function openThread(thread) {
            // // Set the read status on the thread
            // thread.read = true;

            // // Assign thread as the current thread
            // vm.currentThread = thread;

            // // Update the state without reloading the controller
            // $state.go('app.aircrafts.threads.thread', { threadId: thread.id }, { notify: false });
        }

        /**
         * Close thread
         */
        function closeThread() {
            // vm.currentThread = null;

            // // Update the state without reloading the controller
            // $state.go('app.aircrafts.threads', {
            //     type: vm.currentFilter.type,
            //     filter: vm.currentFilter.filter
            // }, { notify: false });
        }

        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        function isSelected(thread) {
            return vm.selectedThreads.indexOf(thread) > -1;
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        function toggleSelectThread(thread, event) {
            if (event) {
                event.stopPropagation();
            }
            console.log(0);
            if (vm.selectedThreads.indexOf(thread) > -1) {
                console.log(1);
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            } else {
                console.log(2);
                vm.selectedThreads.push(thread);
            }
        }

        /**
         * Select threads. If key/value pair given,
         * threads will be tested against them.
         *
         * @param [key]
         * @param [value]
         */
        function selectThreads(key, value) {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedThreads = [];

            for (var i = 0; i < vm.users.length; i++) {
                if (angular.isUndefined(key) && angular.isUndefined(value)) {
                    vm.selectedThreads.push(vm.users[i]);
                    continue;
                }

                if (angular.isDefined(key) && angular.isDefined(value) && vm.users[i][key] === value) {
                    vm.selectedThreads.push(vm.users[i]);
                }
            }
        }

        /**
         * Deselect threads
         */
        function deselectThreads() {
            vm.selectedThreads = [];
        }

        /**
         * Toggle select threads
         */
        function toggleSelectThreads() {
            if (vm.selectedThreads.length > 0) {
                vm.deselectThreads();
            } else {
                vm.selectThreads();
            }
        }

        /**
         * Set the status on given thread, current thread or selected threads
         *
         * @param key
         * @param value
         * @param [thread]
         * @param [event]
         */
        function setThreadStatus(key, value, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                thread[key] = value;
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                vm.currentThread[key] = value;
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                vm.selectedThreads[x][key] = value;
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleThreadStatus(key, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                if (typeof (thread[key]) !== 'boolean') {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                if (typeof (vm.currentThread[key]) !== 'boolean') {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                if (typeof (vm.selectedThreads[x][key]) !== 'boolean') {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }




        /**
         * Change the view
         *
         * @param view
         */
        function changeView(view) {
            if (vm.views[view]) {
                vm.defaultView = view;
                vm.currentView = view;
            }
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function userHasBranch(branch) {
            var hasBranch = false;
            angular.forEach(vm.userSelected.division_jobs, function (divisionJobs) {
                if (divisionJobs.branch_id == branch.id) {
                    hasBranch = true;
                }
            })
            return hasBranch;
        }

        function userHasCompany(company) {
            var hasCompany = false;
            angular.forEach(company.branches, function (branch) {
                if (vm.userHasBranch(branch)) {
                    hasCompany = true;
                }
            })
            return hasCompany;
        }

        function viewEditData() {
            vm.tabActive = 'edit';
        }
        function viewActivity() {
            vm.tabActive = 'activity';
        }
        function viewTasks() {
            vm.tabActive = 'tasks';
        }
        function viewMenu() {
            vm.tabActive = 'menu';
        }

        function viewEditCompanies() {
            vm.tabActive = 'companies';
        }
        var originatorEv;

        function openMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        }

        function toggleUserTabEdit(user, tab) {
            event.stopPropagation();
            console.log(user);
            console.log(tab);

        }

        function toggleUserStatusEdit(fieldName, user, event) {
            if (event) {
                event.stopPropagation();
            }
            if (user) {
                if (angular.isUndefined(user[fieldName])) {
                    user[fieldName] = 0;
                }
                var thread = user[fieldName];
                thread = (thread) ? false : true;
                user[fieldName] = thread;
                updateUser(user);
            } else {
                if (vm.userSelected) {
                    var thread = vm.userSelected[fieldName];
                    thread = (thread) ? false : true;
                    vm.userSelected[fieldName] = thread;
                } else {
                    if (angular.isUndefined(vm.userNew[fieldName])) {
                        vm.userNew[fieldName] = 0;
                    }
                    var thread = vm.userNew[fieldName];
                    thread = (thread) ? false : true;
                    vm.userNew[fieldName] = thread;
                }
            }
        
            vm.basicForm.$setDirty();
        }        



        function uploadMedia(file, idValue, uploadKey) {
            if (!file.$error) {
                var token = undefined;
                $scope.uploadingFile = true;
                console.debug("UPLOAD STARTED______****", file)
                mediaService.getS3UploadPreSignedUrl({
                    owner: $scope.owner,
                    uploadKey: uploadKey,
                    fileName: file.name,
                    rowId: idValue
                })
                    .then(function (resp) {
                        token = resp.token;
                        file.id_media = resp.id_media;
                        file.upload = Upload.http({
                            url: resp.url,
                            skipAuthorization: true,
                            method: 'PUT',
                            headers: {
                                "Content-Type": file.type != '' ? file.type : 'application/octet-stream'
                            },
                            data: file
                        })
                        file.upload.then(function (response) {
                            file.result = response.data;
                            $timeout(function () {
                                $scope.log = 'file: ' +
                                    file.name +
                                    ', Response: ' + JSON.stringify(response.data) +
                                    ', ID: ' + file.id_media +
                                    '\n' + $scope.log;
                            });
                            console.debug("FINISHING UPLOAD______****", file)
                            mediaService.finishedUploadingFileToCdn({
                                owner: $scope.owner,
                                idMedia: file.id_media,
                                token: token
                            }).then(function () {
                                $scope.uploadingFile = false;
                            })

                        }, function (response) {
                            if (response.status > 0)
                                $scope.errorMsg = response.status + ': ' + response.data;
                        });

                        file.upload.progress(function (evt) {
                            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                        });
                    })
            }
        };



    }
})();
(function () {
    'use strict';

    angular
        .module('app.users')
        .service('usersService', usersService);

    /** @ngInject */
    // I provide access to the session store.
    function usersService($q, $rootScope, $resource, settingsDomainService, sessionService, COMMON, $window, $mdToast) {

        function getUsers(options) {
            var deferred = $q.defer();
            var opts = {
                owner: options.owner,
                withFiles: true,
                withCompanies: true,
                search: options.searchStringFilter,
                page: options.page,
                resultsPerPage: options.resultsPerPage,
                sortField: options.sortField ? options.sortField : 'id'

            }
            if (options.withtrashed){
                opts.withTrashed = true
            }
            if (options.withCompanies != undefined){
                opts.withCompanies = options.withCompanies
            }
            if (options.withFiles != undefined){
                opts.withFiles = options.withFiles
            }
            opts.resultsPerPage = 500;
            resourceUsersFiltered.get(opts,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getUsersWithTrashed(options) {
            var deferred = $q.defer();
            var opts = {
                owner: options.owner,
                search: options.searchStringFilter,
                resultsPerPage: 100
            }
            resourceUsersFilteredWithTrashed.get(opts,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getUser(options) {
            var deferred = $q.defer();
            resourceUsers.get({
                id: options.id,
                owner: options.owner
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateUser(options) {
            var deferred = $q.defer();
            resourceUsers.update({
                owner: options.owner,
                id: options.id
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function createUser(options) {
            var deferred = $q.defer();
            resourceUsers.post({
                owner: options.owner,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function deleteUser(options) {
            var deferred = $q.defer();
            resourceUsers.delete({
                owner: options.owner,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getFilters(options) {
            var deferred = $q.defer();

            return (deferred.promise);
        }


        function getPositions(options) {
            var deferred = $q.defer();
            resourcePositions.get({
                owner: options.owner
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getDivisions(options) {
            var deferred = $q.defer();
            resourceDivisions.get({
                owner: options.owner
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getMenu(options) {
            var deferred = $q.defer();
            resourceTabs.get({
                owner: options.owner
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        
        function getUserTabs(options) {
            var deferred = $q.defer();
            resourceUserTabs.post({
                owner: options.owner
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    console.log("e ", e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        
        function getUserTabsOwner(options) {
            var deferred = $q.defer();
            resourceUserTabsOwner.get({
                owner: options.owner
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.log("e ", e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function insertUserTabs(options) {
            var deferred = $q.defer();
            insertarUserTabs.post({
                owner: options.owner
            }, options.item,
                function (response) {
                    console.log("response insertUserTabs: ", response);
                    deferred.resolve(response);
                },

                function (e) {
                    console.log("e insertUserTabs: ", e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function eliminarUserTabs(options) {
            var deferred = $q.defer();
            deleteUserTabs.delete({
                owner: options.owner,
                tab_id: options.item.tab_id,
                user_id: options.item.user_id
            },
                function (response) {
                    deferred.resolve(response);
                    console.log("response eliminarUserTabs: ", response);
                },

                function (e) {
                    console.log("e eliminarUserTabs: ", e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        var resourcePositions = $resource(COMMON.BASE_API + "/owner/:owner/jobPosition", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });
        var resourceDivisions = $resource(COMMON.BASE_API + "/owner/:owner/division", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });

        var resourceTabs = $resource(COMMON.BASE_API + "/owner/:owner/getMenu", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        });

        var resourceUsers = $resource(COMMON.BASE_API + "/owner/:owner/user/:id", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                delete: {
                    method: "DELETE",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                },
            });

        var resourceUserTabs = $resource(COMMON.BASE_API + "/owner/:owner/usertabs", {
            // No default data
        }, {
            post: {
                method: "POST",
                isArray: true
            }
        });
        var resourceUserTabsOwner = $resource(COMMON.BASE_API + "/owner/:owner/allTabs", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        });

        var insertarUserTabs = $resource(COMMON.BASE_API + "/owner/:owner/usertab", {
            // No default data
        }, {
            post: {
                method: "POST",
                isArray: false
            }
        });

        var deleteUserTabs = $resource(COMMON.BASE_API + "/owner/:owner/usertab", {
            // No default data
        }, {
            delete: {
                method: "DELETE",
                isArray: false
            }
        });


        var resourceUsersFiltered = $resource(COMMON.BASE_API + "/owner/:owner/user?userTypes[]=1&userTypes[]=2&userTypes[]=3&userTypes[]=6", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });
        var resourceUsersFilteredWithTrashed = $resource(COMMON.BASE_API + "/owner/:owner/user?withTrashed", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });




        return ({
            get: getUsers,
            getUsers: getUsers,
            getUsersWithTrashed: getUsersWithTrashed,
            getUser: getUser,
            insertUserTabs: insertUserTabs,
            eliminarUserTabs: eliminarUserTabs,
            getMenu: getMenu,
            getUserTabs: getUserTabs,
            getUserTabsOwner: getUserTabsOwner,
            getFilters: getFilters,
            getPositions: getPositions,
            getDivisions: getDivisions,
            updateUser: updateUser,
            deleteUser: deleteUser,
            createUser: createUser

        });

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.todo')
        .controller('TodoController', TodoController);

    /** @ngInject */
    function TodoController($document, $mdDialog, $mdSidenav, Tasks, Tags)
    {
        var vm = this;

        // Data
        vm.tasks = Tasks.data;
        vm.tags = Tags.data;
        vm.completed = [];
        vm.colors = ['blue', 'blue-grey', 'orange', 'pink', 'purple'];
        vm.projects = {
            'creapond'    : 'Project Creapond',
            'withinpixels': 'Project Withinpixels'
        };
        vm.selectedFilter = {
            filter : 'Start Date',
            dueDate: 'Next 3 days'
        };
        vm.selectedProject = 'creapond';

        // Tasks will be filtered against these models
        vm.taskFilters = {
            search   : '',
            tags     : [],
            completed: '',
            deleted  : false,
            important: '',
            starred  : '',
            startDate: '',
            dueDate  : ''
        };
        vm.taskFiltersDefaults = angular.copy(vm.taskFilters);
        vm.showAllTasks = true;

        vm.taskOrder = '';
        vm.taskOrderDescending = false;

        vm.sortableOptions = {
            handle        : '.handle',
            forceFallback : true,
            ghostClass    : 'todo-item-placeholder',
            fallbackClass : 'todo-item-ghost',
            fallbackOnBody: true,
            sort          : true
        };
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.preventDefault = preventDefault;
        vm.openTaskDialog = openTaskDialog;
        vm.toggleCompleted = toggleCompleted;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleFilter = toggleFilter;
        vm.toggleFilterWithEmpty = toggleFilterWithEmpty;
        vm.filterByStartDate = filterByStartDate;
        vm.filterByDueDate = filterByDueDate;
        vm.resetFilters = resetFilters;
        vm.toggleTagFilter = toggleTagFilter;
        vm.isTagFilterExists = isTagFilterExists;

        init();

        //////////

        /**
         * Initialize the controller
         */
        function init()
        {
            angular.forEach(vm.tasks, function (task)
            {
                if ( task.startDate )
                {
                    task.startDate = new Date(task.startDate);
                    task.startDateTimestamp = task.startDate.getTime();
                }

                if ( task.dueDate )
                {
                    task.dueDate = new Date(task.dueDate);
                    task.dueDateTimestamp = task.dueDate.getTime();
                }
            });
        }

        /**
         * Prevent default
         *
         * @param e
         */
        function preventDefault(e)
        {
            e.preventDefault();
            e.stopPropagation();
        }

        /**
         * Open new task dialog
         *
         * @param ev
         * @param task
         */
        function openTaskDialog(ev, task)
        {
            $mdDialog.show({
                controller         : 'TaskDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/todo/dialogs/task/task-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Task : task,
                    Tasks: vm.tasks,
                    event: ev
                }
            });
        }

        /**
         * Toggle completed status of the task
         *
         * @param task
         * @param event
         */
        function toggleCompleted(task, event)
        {
            event.stopPropagation();
            task.completed = !task.completed;
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggles filter with true or false
         *
         * @param filter
         */
        function toggleFilter(filter)
        {
            vm.taskFilters[filter] = !vm.taskFilters[filter];

            checkFilters();
        }

        /**
         * Toggles filter with true or empty string
         * @param filter
         */
        function toggleFilterWithEmpty(filter)
        {
            if ( vm.taskFilters[filter] === '' )
            {
                vm.taskFilters[filter] = true;
            }
            else
            {
                vm.taskFilters[filter] = '';
            }

            checkFilters();
        }

        /**
         * Reset filters
         */
        function resetFilters()
        {
            vm.showAllTasks = true;
            vm.taskFilters = angular.copy(vm.taskFiltersDefaults);
        }

        /**
         * Check filters and mark showAllTasks
         * as true if no filters selected
         */
        function checkFilters()
        {
            vm.showAllTasks = !!angular.equals(vm.taskFiltersDefaults, vm.taskFilters);
        }

        /**
         * Filter by startDate
         *
         * @param item
         * @returns {boolean}
         */
        function filterByStartDate(item)
        {
            if ( vm.taskFilters.startDate === true )
            {
                return item.startDate === new Date();
            }

            return true;
        }

        /**
         * Filter Due Date
         *
         * @param item
         * @returns {boolean}
         */
        function filterByDueDate(item)
        {
            if ( vm.taskFilters.dueDate === true )
            {
                return !(item.dueDate === null || item.dueDate.length === 0);
            }

            return true;
        }

        /**
         * Toggles tag filter
         *
         * @param tag
         */
        function toggleTagFilter(tag)
        {
            var i = vm.taskFilters.tags.indexOf(tag);

            if ( i > -1 )
            {
                vm.taskFilters.tags.splice(i, 1);
            }
            else
            {
                vm.taskFilters.tags.push(tag);
            }

            checkFilters();
        }

        /**
         * Returns if tag exists in the tagsFilter
         *
         * @param tag
         * @returns {boolean}
         */
        function isTagFilterExists(tag)
        {
            return vm.taskFilters.tags.indexOf(tag) > -1;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.tasks')
        .controller('TasksController', TasksController);

    /** @ngInject */
    function TasksController($scope, $rootScope, $stateParams, $translate, $document, $mdDialog, msUtils, taskDetailsUtil, staffService,
        $mdMedia, $mdSidenav, $state, tinyMceService, sessionService, chatService, $timeout, tasksService, companyService, mediaService, Upload, $mdMenu) {
        var vm = this;
        vm.loadingThreads = true;
        vm.firstLoad = true;
        vm.isTaskSection = true;
        vm.statusTask = taskDetailsUtil.status;
        vm.filterStatusSelected = null;
        vm.reccurentType = taskDetailsUtil.reccurentType;
        vm.numUsersPreview = 3;
        vm.openDialogUser = openDialogUser;
        vm.userLogued = sessionService.getUser();
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg', 'red-bg', 'yellow-bg', 'light-blue-bg'];
        vm.openDialogAlerts = openDialogAlerts;
        vm.filterOptionsDate = [
            { 'name': 'TASKS.TODAY', type: 'today' },
            { 'name': 'TASKS.YESTERDAY', type: 'yesterday' },
            { 'name': 'TASKS.LAST_WEEK', type: 'last_week' },
            { 'name': 'TASKS.THIS_WEEK', type: 'this_week' },
            { 'name': 'TASKS.LAST_MONTH', type: 'last_month' },
            { 'name': 'TASKS.THIS_MONTH', type: 'this_month' },
            { 'name': 'TASKS.CUSTOM', 'type': 'custom' }
        ];
        vm.currentFilter = {
            type: $state.params.type,
            filter: $state.params.filter
        };
        vm.priorities = [
            { id: 0, name: "Baja" },
            { id: 1, name: "Media" },
            { id: 2, name: "Alta" },
            { id: 3, name: "Crítica" }
        ]
        vm.status = [
            { id: 0, name: "Cerrada" },
            { id: 1, name: "Revisión" },
            { id: 2, name: "Nueva" },
        ]
        vm.statusFilter = [];
        Object.keys(vm.statusTask).forEach(x => {
            vm.statusFilter.push({ id: x, name: vm.statusTask[x] })
        })

        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
        vm.currentThread = null;
        vm.selectedThreads = [];
        vm.editData = false;
        vm.views = {
            split: 'app/main/apps/tasks/views/list/split-view.html',
            nosplit: 'app/main/apps/tasks/views/list/nosplit-view.html'
        };
        vm.defaultView = 'split';
        vm.currentView = 'split';

        vm.idCompany = undefined;
        vm.companySelected = undefined;
        vm.isCompanySelected = isCompanySelected;

        vm.readView = true;
        vm.loadingReadPane = false;


        vm.editTask = editTask;
        vm.createNewTask = createNewTask;


        vm.calculateHeightChat = calculateHeightChat;

        vm.isSelected = isSelected;
        vm.toggleSelectThread = toggleSelectThread;
        vm.selectThreads = selectThreads;
        vm.deselectThreads = deselectThreads;
        vm.toggleSelectThreads = toggleSelectThreads;

        vm.setThreadStatus = setThreadStatus;
        vm.toggleThreadStatus = toggleThreadStatus;

        vm.changeView = changeView;
        vm.toggleSidenav = toggleSidenav;

        vm.getFormUrl = getFormUrl;
        vm.openTask = openTask;
        vm.closeTask = closeTask;
        vm.saveTask = saveTask;
        vm.deleteTask = deleteTask;
        vm.openMenu = openMenu;
        vm.config = sessionService.config;
        vm.timeAgo = msUtils.timeAgo;
        vm.viewEditData = viewEditData;
        vm.dateExpired = dateExpired;
        vm.changeTaskStatusDialog = changeTaskStatusDialog;
        vm.openMenu = openMenu;
        vm.showUserImage = showUserImage;
        vm.selectFilterDate = selectFilterDate;
        vm.selectFilterStatus = selectFilterStatus;
        vm.applyFilter = applyFilter;
        vm.clearFilterDate = clearFilterDate;
        vm.clearFilterStatus = clearFilterStatus;
        vm.showUserImageFromId = showUserImageFromId;
        //////////
        vm.reccurentType = {
            "day": 'RISK.RECURRENT_DAY',
            "week": 'RISK.RECURRENT_WEEK',
            "month": 'RISK.RECURRENT_MONTH',
            "year": 'RISK.RECURRENT_YEAR'
        };
        $scope.$on('pagination:loadStart', function (event) {
            $scope.isLoading = true;
        });

        $scope.$on('pagination:loadPage', function (event) {
            $scope.isLoading = false;
        });


        var originatorEv;

        function openMenu($mdOpenMenu, ev) {
            originatorEv = ev;
            $mdOpenMenu.open(ev);
        }
        var formatDate = 'YYYY-MM-DD HH:mm:ss';
        function applyFilter() {
            if (!vm.from_date) {
                vm.from_date = new Date();
            }
            if (!vm.to_date) {
                vm.to_date = new Date();
            }
            vm.from_date = setFromDateHours(vm.from_date);
            vm.to_date = setToDateHours(vm.to_date);
            reloadTaskByDate(moment(vm.from_date).utc().format(formatDate), moment(vm.to_date).utc().format(formatDate));
        }
        function selectFilterDate(filter) {
            vm.filterDateSelected = filter;
            let from_date;
            let to_date;
            switch (filter.type) {
                case 'today':
                    from_date = new Date();
                    to_date = new Date();
                    break;
                case 'yesterday':
                    var date = new Date();
                    var date2 = new Date();
                    date.setDate(new Date().getDate() - 1);
                    date2.setDate(new Date().getDate() - 1);
                    from_date = date;
                    to_date = date2;
                    break;
                case 'last_week':
                    var date = new Date();
                    date.setDate(new Date().getDate() - 7);
                    from_date = date;
                    to_date = new Date();
                    break;
                case 'this_week':
                    from_date = moment().startOf('week').toDate();
                    to_date = moment().endOf('week').toDate();
                    break;
                case 'last_month':
                    var date = new Date();
                    date.setDate(new Date().getDate() - 30);
                    from_date = date
                    to_date = new Date();
                    break;
                case 'this_month':
                    from_date = moment().startOf('month').toDate();
                    to_date = moment().endOf('month').toDate();
                    break;
                case 'custom':
                    return;
                default:
                    reloadTaskByDate();
                    return;
            }
            from_date = setFromDateHours(from_date);
            to_date = setToDateHours(to_date);
            reloadTaskByDate(moment(from_date).utc().format(formatDate), moment(to_date).utc().format(formatDate));
        }
        function selectFilterStatus(filter) {
            vm.filterStatusSelected = filter;
            reloadTaskByDate();
        }

        function setToDateHours(date) {
            date.setHours(23);
            date.setMinutes(59);
            date.setSeconds(59);
            return date
        }
        function setFromDateHours(date) {
            date.setHours(0);
            date.setMinutes(0);
            date.setSeconds(0);
            return date
        }

        function clearFilterDate() {
            vm.filterDateSelected = null;
            reloadTaskByDate();
        }
        function clearFilterStatus() {
            vm.filterStatusSelected = null;
            reloadTaskByDate();
        }

        $scope.owner = $stateParams.owner;


        var companySelectEvent = $rootScope.$on('company-selected', function (event) {
            vm.companySelected = sessionService.get('companySelected');
            companyService.setCompanyId(vm.companySelected.id);
            var options = {
                owner: $scope.owner,
                resultsPerPage: 500,
                sortField: 'first_name'
            }
            staffService.get(options).then(function (res) {
                vm.availableUsers = res.data;
            });
            if (!vm.firstLoad) {
                loadTasks(vm.companySelected.id);
            }
            vm.firstLoad = false;
        });

        $scope.$on('$destroy', companySelectEvent);



        init();

        /////////////////

        function init() {
            if (sessionService.get('companySelected')) {
                $rootScope.$broadcast('company-selected');
            }

            mediaService.getStoragePrefix({
                owner: $scope.owner,
            }).then(function (res) {
                vm.storagePrefix = res.prefix;
            })

            if ($state.current.name === "app.site_overview.tasks.list.active_task") {
                vm.openTask($state.params.id);
            }

        }

        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'nosplit';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big)
                vm.currentView = 'nosplit';

        });

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small)
                vm.currentView = 'split';

        });

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                if (vm.defaultView === 'split') {
                    vm.currentView = 'split';
                }
            }
        });


        var originatorEv;


        function showUserImage(user) {
            return vm.storagePrefix + user.files.url
        }
        function showUserImageFromId(userId) {
            angular.forEach(vm.allUsers, function (u) {
                if (u.id == userId) {
                    if (!angular.isUndefined(u.files.id)) {
                        return vm.storagePrefix + u.files.url
                    } else {
                        return false;
                    }
                }
            });
        }

        function openMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        }


        function openDialogAlerts(ev) {
            taskDetailsUtil.openDialogAlerts(ev, vm.storagePrefix, vm.taskData.task.alerts).then(resp => {
                if (resp) {
                    vm.taskData.task.alerts = resp;
                }
            })
        }

        function openDialogUser(ev) {
            taskDetailsUtil.openDialogUser(ev, vm.taskData, vm.availableUsers, vm.currentUsers, vm.storagePrefix).then(resp => {
                vm.taskData = resp;
            })
        }
        function isCompanySelected() {
            if (angular.isObject(vm.companySelected)) {
                return true;
            }
            return false;
        }


        function dateExpired(stringDate) {
            return moment.utc(stringDate) < moment.utc();
        }

        function changeTaskStatusDialog(e, task) {
            var currentParentTask = vm.taskSelected ? vm.taskSelected.id : null;
            $mdDialog.show({
                controller: 'TaskEditStatusController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/tasks/dialogs/task-edit-status-dialog/task-edit-status-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    task: angular.copy(task)
                }
            }).then(function (resp) {
                if (resp) {
                    const toSave = taskDetailsUtil.prepareToSave({ task: resp });
                    delete toSave.task.assigned_multiple;
                    vm.loadingReadPane = true;
                    vm.closeTask();
                    taskDetailsUtil.updateTaskStatus($scope.owner, toSave.task).then(function (res) {
                        reloadTaskOnHot();
                        vm.loadingReadPane = false;
                        if (currentParentTask) {
                            vm.openTask(currentParentTask)
                        }
                    }, function (err) {
                        reloadTaskOnHot();
                        vm.loadingReadPane = false;
                    })
                }
            });
        }
        function createNewTask() {
            vm.taskSelected = null;
            var task = taskDetailsUtil.createNewTask();
            if (vm.userLogued.user_type >= 4) {
                vm.userLocked = true;
                task.assigned_multiple.users.push(vm.userLogued);
                // task.assigned_to_user_id = vm.userLogued.id;
            }
            vm.taskData = {
                task: task,
                files: []
            };
            vm.edit = false;
        }
        function editTask(task) {
            var task = task;
            vm.taskData = {
                task: task,
                files: []
            };
            vm.showRecurrence = (vm.taskData.task.recurrent_interval || vm.taskData.task.recurrent_type) ? true : false;
            vm.edit = true;
        }
        vm.toggleRecurrence = function () {
            if (vm.showRecurrence) {
                vm.taskData.task.recurrent_interval = null;
                vm.taskData.task.recurrent_type = null;
            } else {
                vm.taskData.task.recurrent_interval = 1;
                vm.taskData.task.recurrent_type = "week";
            }
            vm.showRecurrence = !vm.showRecurrence
        }
        vm.showFileInfo = function (f, ev) {
            msUtils.showFileInfo(Owner, f, ev);
        }

        vm.downloadFile = function (f) {
            taskDetailsUtil.downloadFile(Owner, f);
        }


        vm.unasignedUserTask = function (user) {
            if ((vm.taskData.task.assigned_to_user_id && vm.taskData.task.assigned_to_user_id.id == user.id) || vm.taskData.task.assigned_to_user_id == user.id) {
                vm.taskData.task.assigned_to_user_id = null;
            } else {
                vm.taskData.task.assigned_multiple.users.splice(vm.taskData.task.assigned_multiple.users.indexOf(user), 1);
            }
        }

        function openTask(id) {
            vm.replyMessage = '';
            vm.chat = null;
            $state.go('app.site_overview.tasks.list.active_task', {
                id: id,
                domain: $state.params.domain
            }, {
                notify: false,
                inherit: true,
                location: true
            });
            if (vm.basicForm) {
                vm.basicForm.$setPristine();
            }
            vm.edit = false;
            vm.taskData = undefined;
            vm.editData = false;
            vm.loadingReadPane = true;
            vm.idChat = id;
            var options = {
                id: id,
                owner: $scope.owner
            };
            tasksService.getTask(options)
                .then(function (resp) {
                    vm.taskSelected = taskDetailsUtil.fromDTO(resp);
                    vm.viewEditData();

                    vm.loadingReadPane = false;
                    
                });

        }





        function getFormUrl(filename) {
            return vm.urlForm.replace('%filename%', filename)
        }




        function calculateHeightChat() {
            return window.innerHeight - ($('#head-container').height() + 242);
        }

        function reloadTaskByDate(date_from, date_to) {
            $scope.isLoading = true;
            var opt = {
                from: $rootScope.pagination_page,
                resultsPerPage: $rootScope.perPage,
                owner: $scope.owner,
                status: vm.filterStatusSelected ? [vm.filterStatusSelected.id] : [],
                sort: $rootScope.sortField
            }
            if (date_from) {
                opt.date_from = date_from;
            }
            if (date_to) {
                opt.date_to = date_to;
            }
            tasksService.getTasks(opt).then(function (res) {
                vm.tasks = res.data;
                $scope.isLoading = false;

            })
        }


        function reloadTaskOnHot() {
            $scope.isLoading = true;
            // $rootScope.pagination_resetquery();
            var opt = {
                from: $rootScope.pagination_page,
                resultsPerPage: $rootScope.perPage,
                owner: $scope.owner,
                sort: $rootScope.sortField
            }
            tasksService.getTasks(opt).then(function (res) {
                var newTasks = [];
                vm.newResults = res.data.filter(x => !vm.tasks.find(y => y.id === x.id));
                vm.newResults.forEach(element => {
                    vm.tasks.unshift(element);
                });
                vm.tasks = vm.tasks.map(function (task) {
                    var found = res.data.find(x => x.id == task.id);
                    if (found) {
                        found.expanded = task.expanded
                        return found;
                    }
                    return task;
                });
                $scope.isLoading = false;

            })
        }


        function loadTasks(idCompany) {
            $scope.isLoading = true;
            $rootScope.pagination_resetquery();
        }


        function closeTask() {
            vm.taskSelected = undefined;
            vm.taskData = undefined;
            vm.edit = false;
            $state.go('app.site_overview.tasks.list', {
                domain: $state.params.domain
            }, {
                notify: false,
                inherit: true,
                location: true
            });
        }

        function saveTask() {
            console.log(vm.taskData)
            vm.taskData = taskDetailsUtil.prepareToSave(vm.taskData);
            vm.loadingReadPane = true;
            taskDetailsUtil.saveTask($scope.owner, vm.taskData.task, vm.taskData.files).then(function (res) {
                reloadTaskOnHot();
                vm.loadingReadPane = false;
                vm.closeTask();
            })
        }

        function deleteTask(ev) {
            const message = $translate.instant('GLOBAL.ARE_YOU_SURE');
            const yes = $translate.instant('GLOBAL.YES');
            const no = $translate.instant('GLOBAL.NO');

            const confirm = $mdDialog.confirm()
                .title(message)
                .targetEvent(ev)
                .ok(yes)
                .cancel(no);

            $mdDialog.show(confirm).then(e => {
                var threads = angular.copy(vm.selectedThreads);
                vm.selectedThreads = [];
                for (var j = 0; j < threads.length; j++) {
                    var options = {
                        owner: $scope.owner,
                        id: threads[j].id
                    };
                    tasksService.deleteTask(options).then(function (response) {
                        loadTasks(vm.companySelected.id);
                    })
                    initState();
                }
            })

        }


        vm.translate = msUtils.translate;


        function initState() {
            vm.taskSelected = undefined;
            vm.taskData = undefined;
        }




        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        function isSelected(thread) {
            return vm.selectedThreads.indexOf(thread) > -1;
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        function toggleSelectThread(thread, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedThreads.indexOf(thread) > -1) {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            } else {
                vm.selectedThreads.push(thread);
            }
        }

        /**
         * Select threads. If key/value pair given,
         * threads will be tested against them.
         *
         * @param [key]
         * @param [value]
         */
        function selectThreads(key, value) {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedThreads = [];

            for (var i = 0; i < vm.tasks.length; i++) {
                if (angular.isUndefined(key) && angular.isUndefined(value)) {
                    vm.selectedThreads.push(vm.tasks[i]);
                    continue;
                }

                if (angular.isDefined(key) && angular.isDefined(value) && vm.tasks[i][key] === value) {
                    vm.selectedThreads.push(vm.tasks[i]);
                }
            }
        }

        /**
         * Deselect threads
         */
        function deselectThreads() {
            vm.selectedThreads = [];
        }

        /**
         * Toggle select threads
         */
        function toggleSelectThreads() {
            if (vm.selectedThreads.length > 0) {
                vm.deselectThreads();
            } else {
                vm.selectThreads();
            }
        }

        /**
         * Set the status on given thread, current thread or selected threads
         *
         * @param key
         * @param value
         * @param [thread]
         * @param [event]
         */
        function setThreadStatus(key, value, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                thread[key] = value;
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                vm.currentThread[key] = value;
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                vm.selectedThreads[x][key] = value;
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleThreadStatus(key, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                if (typeof (thread[key]) !== 'boolean') {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                if (typeof (vm.currentThread[key]) !== 'boolean') {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                if (typeof (vm.selectedThreads[x][key]) !== 'boolean') {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }




        /**
         * Change the view
         *
         * @param view
         */
        function changeView(view) {
            if (vm.views[view]) {
                vm.defaultView = view;
                vm.currentView = view;
            }
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }


        function viewEditData() {
            vm.editData = true;
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.tasks')
        .service('tasksService', TasksService);

    /** @ngInject */
    // I provide access to the session store.
    function TasksService($q, $resource, settingsDomainService, sessionService, companyService, COMMON, $window, $mdToast) {

        var userLogued = sessionService.getUser();

        function getTasks(options) {
            var deferred = $q.defer();
            var opt = {
                owner: options.owner,
                company_id: companyService.getCompanyId(),
                search: options.searchStringFilter,
                sortField: options.sortField ? options.sortField : 'id',
                withChilds: (userLogued.user_type == 4) ? false : true,
                mine: userLogued.user_type == 4,
                date_from: options.date_from,
                date_to: options.date_to,
                'status[]': options.status,
                resultsPerPage: 1000,
                page: options.page
            }
            if (!opt.mine) {
                delete opt.mine;
            }
            if (!opt.withChilds) {
                delete opt.withChilds;
            }
            if (!opt.date_from) {
                delete opt.date_from;
            }
            if (!opt.date_to) {
                delete opt.date_to;
            }
            if (!opt.status) {
                delete opt.status;
            }
            resourceTasks.get(opt,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }


        function getTask(options) {
            var deferred = $q.defer();

            var opt = {
                id: options.id,
                owner: options.owner,
                withChilds: true,
                mine: userLogued.user_type == 4,
                withFiles: true
            };
            if (!opt.mine) {
                delete opt.mine;
            }
            resourceTasks.get(opt,
                function (response) {
                    for (var i = 0; i < response.files.length; i++) {
                        var element = response.files[i];
                        element.updated_at_format = moment.utc(element.updated_at).format('DD MMM YYYY HH:mm:00');
                        element.created_at_format = moment.utc(element.created_at).format('DD MMM YYYY HH:mm:00');
                    }
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function finishFilesTask(options) {
            var deferred = $q.defer();

            resource_finish_files.update({
                // owner: options.owner,
            },
                options.item,
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

  

        function updateTask(options) {
            var deferred = $q.defer();
            resourceTasks.update({
                owner: options.owner,
                id: options.id
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function createTask(options) {
            var deferred = $q.defer();
            resourceTasks.post({
                owner: options.owner,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }


        function deleteTask(options) {
            var deferred = $q.defer();
            resourceTasks.delete({
                owner: options.owner,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }


        function getFilters(options) {
            var deferred = $q.defer();

            return (deferred.promise);
        }



        var resourceTasks = $resource(COMMON.BASE_API + "/owner/:owner/task/:id", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            },

            post: {
                method: "POST",
                isArray: false
            },

            delete: {
                method: "DELETE",
                isArray: false
            },

            update: {
                method: "PUT",
                isArray: false
            },
        });

        var resource_finish_files = $resource(COMMON.BASE_API + "/owner/:owner/task/:id", {
            // No default data
        }, {
            update: {
                method: "PUT",
                isArray: false
            },
        });

        return ({
            get: getTasks,
            getTasks: getTasks,
            getTask: getTask,
            finishFilesTask: finishFilesTask,
            getFilters: getFilters,
            updateTask: updateTask,
            deleteTask: deleteTask,
            createTask: createTask

        });

    }

})();

(function () {
    'use strict';

    angular
        .module('app.staff')
        .controller('StaffController', StaffController);

    /** @ngInject */
    function StaffController($scope, $rootScope, $mdMenu, documentsService, $stateParams, $translate, $document, $mdDialog, complaintsService, $mdToast,
        $mdMedia, $mdSidenav, $state, msApi, tinyMceService, requestContext, usersService, companyService, clientsService, mediaService, sessionService,
        $timeout, staffService, transformStaff, Upload, $location, loginService, $auth, COMMON, $window, $http) {
        var vm = this;
        if ($state.current.name == "app.site_overview.personal.complaints") {
            vm.fromComplaint = true;
        }
        vm.loadingPositions = false;
        vm.userLogued = sessionService.getUser();
        sessionService.getQuota().then(function (quota) {
            vm.quota = quota;
        });
        vm.companies = sessionService.getUser().companies;
        vm.deleteAvatar = deleteAvatar;
        vm.openMenu = openMenu;
        vm.selectUserNew = selectUserNew;
        vm.mainCompany = _.find(vm.companies, { 'is_owner': true });
        // Data
        vm.accounts = {
            'creapond': 'johndoe@creapond.com',
            'withinpixels': 'johndoe@withinpixels.com'
        };
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
        vm.selectedAccount = 'creapond';

        vm.folders = 'Folders.data';
        vm.labels = 'Labels.data';
        vm.loadingThreads = true;

        vm.currentFilter = {
            type: $state.params.type,
            filter: $state.params.filter
        };
        vm.currentThread = null;
        vm.selectedThreads = [];

        vm.views = {
            split: 'app/main/apps/staff/views/list/split-view.html',
            nosplit: 'app/main/apps/staff/views/list/nosplit-view.html'
        };
        vm.defaultView = 'split';
        vm.currentView = 'split';

        vm.editData = false;
        vm.editCompanies = false;
        vm.previewData = false;
        vm.files = [];

        vm.idCompany = undefined;
        vm.companySelected = undefined;
        vm.isCompanySelected = isCompanySelected;

        vm.readView = true;
        vm.loadingReadPane = false;

        //Methods
        vm.openThread = openThread;
        vm.closeThread = closeThread;

        vm.isSelected = isSelected;
        vm.toggleSelectThread = toggleSelectThread;
        vm.selectThreads = selectThreads;
        vm.deselectThreads = deselectThreads;
        vm.toggleSelectThreads = toggleSelectThreads;

        vm.setThreadStatus = setThreadStatus;
        vm.toggleThreadStatus = toggleThreadStatus;
        vm.toggleStaffStatusEdit = toggleStaffStatusEdit;

        vm.checkUploadsAndUpdateStaff = checkUploadsAndUpdateStaff;

        vm.showUserImage = showUserImage;

        vm.changeView = changeView;
        vm.toggleSidenav = toggleSidenav;
        vm.tinymceOptions = tinyMceService.getOptions($scope);

        vm.openStaff = openStaff;
        vm.closeStaff = closeStaff;
        vm.isAvailableConfigureMenu = isAvailableConfigureMenu;
        vm.saveStaff = saveStaff;
        vm.deleteStaff = deleteStaff;
        vm.duplicateStaff = duplicateStaff;
        vm.newStaff = newStaff;
        vm.checkFields = checkFields;
        vm.selectBranch = selectBranch;
        vm.selectDivision = selectDivision;
        vm.addUserJob = addUserJob;
        vm.firstLoad = true;
        vm.getPositionNameById = getPositionNameById;

        vm.config = sessionService.config;
        vm.showFormAdd = false;
        vm.staffHasCompany = staffHasCompany;
        vm.staffHasBranch = staffHasBranch;
        vm.tabActive = 'preview';
        vm.viewEditData = viewEditData;
        vm.viewEditDataNew = viewEditDataNew;
        vm.viewPreviewData = viewPreviewData;
        vm.viewEditCompanies = viewEditCompanies;
        vm.viewActivity = viewActivity;
        vm.viewTask = viewTask;
        vm.viewConfigureTabs = viewConfigureTabs;
        vm.viewPasswordEmail = viewPasswordEmail;
        vm.reset2FA = reset2FA;
        vm.linkGoogle = linkGoogle;
        vm.unlinkGoogle = unlinkGoogle;
        vm.getGoogleLinkStatus = getGoogleLinkStatus;
        vm.googleLinked = false;
        vm.resetStaffSelected = resetStaffSelected;
        vm.uploadMedia = uploadMedia;
        vm.checkUploadsAndUpdateStaff = checkUploadsAndUpdateStaff;
        vm.toggleStripe = toggleStripe;
        vm.form = {};

        function getAccountAliasFromURL() {
            var pathSegments = $location.path().split('/');
            var ownerIndex = pathSegments.indexOf('owner');
            if (ownerIndex !== -1 && pathSegments[ownerIndex + 1]) {
                return pathSegments[ownerIndex + 1];
            }

            return null;
        }
        vm.form.account_alias = getAccountAliasFromURL();
        vm.sendPasswordEmail = function () {
            if (!vm.staffSelected || !vm.staffSelected.email) {
                alert("No hay un usuario seleccionado para enviar el correo.");
                return;
            }
            if (vm.staffSelected.enabled === false) {
                var alert = $mdDialog.alert({
                    title: vm.translate('STAFF.ATTENTION'),
                    textContent: vm.translate('STAFF.ACTIVATE_USER_TO_SEND_EMAIL'),
                    ok: vm.translate('STAFF.CLOSE')
                });

                $mdDialog.show(alert).finally(function () {
                    alert = undefined;
                });
                return;
            }

            const message = $translate.instant('STAFF.ARE_YOU_SURE');
            const yes = $translate.instant('STAFF.YES');
            const no = $translate.instant('STAFF.NO');
            const description = $translate.instant('STAFF.CONFIRM_EMAIL_SEND');

            var confirm = $mdDialog.confirm()
                .title(message)
                .textContent(description)
                .ariaLabel('Confirm Send Password Email')
                .ok(yes)
                .cancel(no);

            $mdDialog.show(confirm).then(function () {
                enviarCorreoRestablecimiento();
            }, function () {
            });
        };
        function enviarCorreoRestablecimiento() {
            if (!vm.form.account_alias) {
                vm.form.account_alias = getAccountAliasFromURL();
            }
            if (!vm.form.account_alias) {
                alert("El campo account_alias es obligatorio.");
                return;
            }
            var options = {
                email: vm.staffSelected.email,
                account_alias: vm.form.account_alias
            };

            loginService.reset(options).then(function (res) {
                var message = $translate.instant('STAFF.PASSWORD_RESET_EMAIL_SENT');

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center start">' +
                            '<div class="md-toast-content bg-green">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position: 'top right',
                    parent: '#content'
                });

                setTimeout(function() {
                    var toastrContainer = document.querySelector('.md-toast');
                    if (toastrContainer) {
                        toastrContainer.style.position = 'fixed';
                        toastrContainer.style.top = '5px';
                        toastrContainer.style.left = '50%';
                        toastrContainer.style.transform = 'translateX(-50%)';
                        toastrContainer.style.width = 'auto';
                    }
                }, 100);

            }).catch(function (error) {
                alert("Hubo un error al enviar el correo de restablecimiento. Por favor, intenta nuevamente.");
            });
        }        
        vm.reset2FA = function () {
            if (!vm.staffSelected) {
                alert("No hay un usuario seleccionado para resetear 2FA.");
                return;
            }
            if (vm.staffSelected.enabled === false) {
                var alert = $mdDialog.alert({
                    title: $translate.instant('STAFF.ATTENTION'),
                    textContent: $translate.instant('STAFF.ACTIVATE_USER_TO_RESET_2FA'),
                    ok: $translate.instant('STAFF.CLOSE')
                });
    
                $mdDialog.show(alert).finally(function () {
                    alert = undefined;
                });
                return;
            }
    
            var message = $translate.instant('STAFF.CONFIRM_RESET_2FA');
            var yes = $translate.instant('STAFF.YES');
            var no = $translate.instant('STAFF.NO');
            var description = $translate.instant('STAFF.CONFIRM_RESET_2FA_DESC');
    
            var confirm = $mdDialog.confirm()
                .title(message)
                .textContent(description)
                .ariaLabel('Confirm Reset 2FA')
                .ok(yes)
                .cancel(no);
    
            $mdDialog.show(confirm).then(function () {
                ejecutarReset2FA();
            }, function () {});
        };
    
        function ejecutarReset2FA() {
            var ownerId = getAccountAliasFromURL();
    
            if (!ownerId) {
                alert("El campo account_alias es obligatorio.");
                return;
            }
    
            var options = {
                owner: ownerId,
                user_id: vm.staffSelected.id
            };
    
            loginService.resetSecret(options).then(function (response) {
                var message = $translate.instant('STAFF.TWO_FACTOR_RESET_SUCCESS');
    
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center start">' +
                              '<div class="md-toast-content bg-green">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position: 'top right',
                    parent: '#content'
                });
    
                setTimeout(function() {
                    var toastrContainer = document.querySelector('.md-toast');
                    if (toastrContainer) {
                        toastrContainer.style.position = 'fixed';
                        toastrContainer.style.top = '5px';
                        toastrContainer.style.left = '50%';
                        toastrContainer.style.transform = 'translateX(-50%)';
                        toastrContainer.style.width = 'auto';
                    }
                }, 100);
    
            }).catch(function () {
                alert("Hubo un error al resetear el 2FA. Por favor, intenta nuevamente.");
            });
        }

        /**
         * Open a pop-up to link the account with Google (Gmail).
         * POST /api/v1/owner/{owner}/auth/google/link-ticket (Bearer) → recibe { path } → abre BASE_API + path.
         * The popup returns to redirect_uri?linked=1 and closes; the main window listens to postMessage and displays toast.
         */
        function linkGoogle() {
            var ownerId = getAccountAliasFromURL();
            if (!ownerId) {
                alert("No se pudo obtener el tenant. Por favor, recarga la página.");
                return;
            }
            var redirectUri = $window.location.origin + '/auth/google-linked';

            $http.post(COMMON.BASE_API + '/owner/' + encodeURIComponent(ownerId) + '/auth/google/link-ticket', { redirect_uri: redirectUri })
                .then(function (response) {
                    var path = response.data && response.data.path;
                    if (!path) {
                        alert("No se pudo obtener la URL para vincular. Inténtalo de nuevo.");
                        return;
                    }
                    var apiOrigin;
                    try {
                        apiOrigin = new URL(COMMON.BASE_API).origin;
                    } catch (e) {
                        var m = COMMON.BASE_API.match(/^(https?:\/\/[^\/]+)/);
                        apiOrigin = m ? m[1] : '';
                    }
                    var fullUrl = path.indexOf('http') === 0 ? path : (path.charAt(0) === '/' ? apiOrigin + path : COMMON.BASE_API + '/' + path);
                    var popup = $window.open(fullUrl, 'linkGoogle', 'width=520,height=640,scrollbars=yes,resizable=yes');
                    if (!popup) {
                        alert("Por favor, permite las ventanas emergentes para vincular tu cuenta con Google.");
                        return;
                    }
                    var messageHandler = function (event) {
                        if (event.origin !== $window.location.origin || !event.data || event.data.type !== 'google-linked') {
                            return;
                        }
                        $window.removeEventListener('message', messageHandler);
                        if (event.data.success) {
                            getGoogleLinkStatus();
                            var message = $translate.instant('STAFF.GOOGLE_LINKED_SUCCESS');
                            $mdToast.show({
                                template: '<md-toast id="language-message" layout="column" layout-align="center start">' +
                                    '<div class="md-toast-content bg-green">' + message + '</div></md-toast>',
                                hideDelay: 7000,
                                position: 'top right',
                                parent: '#content'
                            });
                            $timeout(function () {
                                var toastrContainer = document.querySelector('.md-toast');
                                if (toastrContainer) {
                                    toastrContainer.style.position = 'fixed';
                                    toastrContainer.style.top = '5px';
                                    toastrContainer.style.left = '50%';
                                    toastrContainer.style.transform = 'translateX(-50%)';
                                    toastrContainer.style.width = 'auto';
                                }
                            }, 100);
                        }
                    };
                    $window.addEventListener('message', messageHandler);
                })
                .catch(function () {
                    alert("No se pudo iniciar el proceso de vinculación. Por favor, intenta de nuevo.");
                });
        }

        /**
         * Gets if the current user has the account linked with Google.
         * GET /api/v1/owner/{owner}/auth/google/status
         */
        function getGoogleLinkStatus() {
            var ownerId = getAccountAliasFromURL();
            if (!ownerId || !vm.staffSelected || vm.staffSelected.id !== vm.userLogued.id) {
                vm.googleLinked = false;
                return;
            }
            $http.get(COMMON.BASE_API + '/owner/' + encodeURIComponent(ownerId) + '/auth/google/status')
                .then(function (response) {
                    vm.googleLinked = response.data && response.data.linked === true;
                })
                .catch(function () {
                    vm.googleLinked = false;
                });
        }

        /**
         * Unlinks the Google account from the current user.
         * POST /api/v1/owner/{owner}/auth/google/unlink
         */
        function unlinkGoogle() {
            var ownerId = getAccountAliasFromURL();
            if (!ownerId) {
                alert("No se pudo obtener el tenant. Por favor, recarga la página.");
                return;
            }
            $http.post(COMMON.BASE_API + '/owner/' + encodeURIComponent(ownerId) + '/auth/google/unlink')
                .then(function (response) {
                    vm.googleLinked = false;
                    var message = $translate.instant('STAFF.GOOGLE_UNLINKED_SUCCESS');
                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center start">' +
                            '<div class="md-toast-content bg-green">' + message + '</div></md-toast>',
                        hideDelay: 7000,
                        position: 'top right',
                        parent: '#content'
                    });
                    $timeout(function () {
                        var toastrContainer = document.querySelector('.md-toast');
                        if (toastrContainer) {
                            toastrContainer.style.position = 'fixed';
                            toastrContainer.style.top = '5px';
                            toastrContainer.style.left = '50%';
                            toastrContainer.style.transform = 'translateX(-50%)';
                            toastrContainer.style.width = 'auto';
                        }
                    }, 100);
                })
                .catch(function () {
                    alert("Hubo un error al desvincular la cuenta de Google. Por favor, intenta de nuevo.");
                });
        }

        vm.branchSelected = undefined;
        vm.divisionSelected = undefined;

        vm.isBranchSelected = isBranchSelected;
        vm.setCompanyBranches = setCompanyBranches;
        vm.searchDivisionText = '';
        vm.searchBranchText = '';
        vm.formNewPosition = {};
        //////////

        $scope.$on('pagination:loadStart', function (event) {
            $scope.isLoading = true;
        });

        $scope.$on('pagination:loadPage', function (event) {
            $scope.isLoading = false;
        });

        // When opening your profile, log in if you have Google linked to show Link/Unlink buttons.
        $scope.$watch('vm.staffSelected', function (newVal) {
            if (newVal && vm.userLogued && newVal.id === vm.userLogued.id) {
                getGoogleLinkStatus();
            } else {
                vm.googleLinked = false;
            }
        }, true);


        vm.translate = function (text) {
            return $translate.instant(text);
        }


        function isCompanySelected() {
            if (angular.isObject(vm.companySelected)) {
                return true;
            }
            return false;
        }


        function setCompanyBranches(branches) {
            vm.companyBranches = branches;
        }

        function getCompanyBranches(idCompany, idBranch) {
            companyService.getBranches({
                owner: $scope.owner,
                company_id: idCompany,
                withUsers: true,
            })
                .then(function (branchesResponse) {
                    $scope.isLoading = false;
                    if (branchesResponse.total > 0) {
                        vm.setCompanyBranches(branchesResponse.data);
                    }
                    else {
                        vm.branchSelected = undefined;
                        vm.searchBranchText = '';
                        vm.companyBranches = [];
                    }
                });
        }
        function getDivisions() {
            var options = {
                owner: $scope.owner
            };
            usersService.getDivisions(options).then(function (response) {
                vm.divisions = [];
                for (var i = 0; i < response.data.length; i++) {
                    vm.divisions.push({ name: response.data[i].name, id: response.data[i].id });
                }
                vm.divisions = divisions;
            })
        }

        function selectBranch(branch, noFirst) {
            staffService.setBranch(branch)
            vm.branchSelected = branch;
            $rootScope.$broadcast('company-selected');
        }
        function selectDivision(division, noFirst) {
            staffService.setDivision(division)
            vm.divisionSelected = division;
            $rootScope.$broadcast('company-selected');
        }

        var companySelectEvent = $rootScope.$on('company-selected', function (event) {
            vm.companySelected = sessionService.get('companySelected');
            companyService.setCompanyId(vm.companySelected.id);
            if (!vm.firstLoad) {
                $rootScope.pagination_resetquery();
            }
            getCompanyBranches(vm.companySelected.id);
            if (vm.fromComplaint) {
                getComplaintSettings();
                getAdminUsers();
            }
            staffService.getMainBranch({ owner: $scope.owner, id_company: vm.companySelected.id }).then(res => {
                vm.mainBranch = res.data[0];
            })
            vm.firstLoad = false;
        });

        $scope.$on('$destroy', companySelectEvent);
        $scope.$on('$destroy', function () {
            staffService.setBranch(null)
            staffService.setDivision(null)
        });

        vm.getRegionLiteral = getRegionLiteral;
        $scope.owner = $stateParams.owner;
        init();

        /////////////////

        function init() {
            if (sessionService.get('companySelected')) {
                $rootScope.$broadcast('company-selected');
            }
            getPositions();
            getDivisions();



            mediaService.getStoragePrefix({
                owner: $scope.owner,
            }).then(function (res) {
                $scope.storagePrefix = res.prefix;
            })
            clientsService.getFileRegions().then(function (res) {
                vm.regionsLiterals = res;
            })
        }

        function selectUserNew(user) {
            //console.log(user);
            clientsService.addUserToCompany({
                owner: $scope.owner,
                user_id: user.id,
                company_id: vm.companySelected.id
            }).then(res => {
                var message = vm.translate('STAFF.USER_ADDED_SUCCESSFULLY')
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content bg-green">' + message + '</div></md-toast>',
                    hideDelay: 3000,
                    position: 'top right',
                    parent: '#content'
                });
                vm.resetStaffSelected();
                $rootScope.pagination_resetquery();
            })
        }
        function getComplaintSettings() {
            complaintsService.getComplaintSettings({ owner: $scope.owner, id: vm.companySelected.id }).then(res => {
                vm.complaintSettings = res.data[0];
                //console.log(vm.complaintSettings);
            })
        }
        function isBranchSelected() {
            if (staffService.branch) {
                return true;
            }
            return false;
        }


        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'nosplit';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big)
                vm.currentView = 'nosplit';

        });

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small)
                vm.currentView = 'split';

        });

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                if (vm.defaultView === 'split') {
                    vm.currentView = 'split';
                }
            }
        });

        var originatorEv;

        function openMenu($mdOpenMenu, ev) {
            originatorEv = ev;
            $mdOpenMenu(ev);
        }

        function openStaff(item) {
            vm.files = [];
            vm.tabNewSelected = 'new';
            vm.staffNew = undefined;
            vm.editData = false;
            vm.editCompanies = false;
            if (vm.staffNew)
                vm.staffNew = undefined;
            if (item) {
                vm.loadingReadPane = true;
                vm.files = item.files ? [item.files] : [];
                var options = {
                    id: item.id,
                    owner: $scope.owner
                };
                staffService.getStaffItem(options)
                    .then(function (resp) {
                        vm.staffSelected = resp;
                        vm.originalEmail = resp.email;
                        vm.viewPreviewData();
                        vm.loadingReadPane = false;
                    })

            }
        }

        function deleteAvatar(file) {
            var options = {
                owner: $scope.owner,
                id: file.id
            }
            documentsService.deleteDocument(options).then(function () {
                vm.files = [];
                $rootScope.pagination_resetquery();
            })
        }

        function closeStaff() {
            vm.staffSelected = undefined;
            vm.staffNew = undefined;
        }

        function isAvailableConfigureMenu() {
            var result = false;
            if (vm.userLogued.user_type <= 2) {
                result = true
            }
            if (vm.userLogued.user_type == 2 && vm.userSelected) {
                result = vm.userLogued.id === vm.userSelected.id || vm.userSelected.user_type > 2;
            }
            if (vm.userLogued.user_type == 3 && vm.userSelected) {
                result = vm.userLogued.id === vm.userSelected.id;
            }
            return result && vm.staffSelected;
        }

        function saveStaff(ev) {
            if (!vm.originalEmail || vm.originalEmail !== vm.staffSelected.email) {
                var options = {
                    owner: $scope.owner,
                    searchStringFilter: vm.staffSelected ? vm.staffSelected.email : vm.staffNew.email
                };
                usersService.getUsersWithTrashed(options).then(function (response) {

                    var existedUser = _.find(response.data, function (user) {
                        if (user.email == options.searchStringFilter && (!vm.userSelected || user.id !== vm.userSelected.id)) {
                            return true;
                        }
                    });

                    if (!existedUser) {
                        if (vm.staffSelected) {
                            updateStaff();
                        } else if (vm.staffNew) {
                            createStaff();
                        }
                    } else {
                        alert = $mdDialog.alert({
                            title: vm.translate('GLOBAL.ATTENTION'),
                            textContent: vm.translate('GLOBAL.USER_ALREADY_EXISTS'),
                            ok: vm.translate('GLOBAL.CLOSE'),
                        }).multiple(true);

                        $mdDialog
                            .show(alert)
                            .finally(function () {
                                alert = undefined;
                            });
                    }
                })
            } else {
                if (vm.staffSelected) {
                    updateStaff();
                } else if (vm.staffNew) {
                    createStaff();
                }
            }

        }

        function createStaff() {
            vm.loadingReadPane = true;
            vm.staffNew.region_id = 1;
            vm.staffNew.job_position_id = 1;
            if (!vm.fromComplaint) {
                if (vm.staffNew.password) {
                    vm.staffNew.user_type = 4;
                } else {
                    vm.staffNew.user_type = 5;
                }
            } else {
                vm.staffNew.region_id = vm.companySelected.region_id;
                vm.staffNew.is_complaint = true;
            }
            if (vm.companySelected) {
                vm.staffNew.company_id = vm.companySelected.id;
            }
            if (vm.mainBranch) {
                vm.staffNew.branch_id = vm.mainBranch.id;
            }
            var options = {
                owner: $scope.owner,
                item: vm.staffNew
            }
            staffService.createStaff(options).then(function (response) {
                angular.forEach(vm.files, function (f) {
                    vm.uploadMedia(f, response.id, 'user_photo')
                })
                Promise.all([
                    clientsService.addUserToCompany({
                        owner: $scope.owner,
                        user_id: response.id,
                        company_id: vm.companySelected.id
                    }),
                    clientsService.addUserJobPosition({
                        owner: $scope.owner,
                        user_id: response.id,
                        branch_id: vm.mainBranch.id,
                        division_id: 1,
                        job_position_id: response.job_position_id
                    })
                ]).then(function (response) {
                    $rootScope.pagination_resetquery();
                })
                vm.checkUploadsAndUpdateStaff();
            }, function (err) {
                vm.loadingReadPane = false;
                var message = (err && err.data && err.data.message) ? err.data.message : (err && err.data && err.data.error) ? err.data.error : (err && err.message) ? err.message : $translate.instant('STAFF.USER_ADDED_ERROR');
                $mdToast.show({
                    template: '<md-toast id="language-message"><div class="md-toast-content bg-red">' + message + '</div></md-toast>',
                    hideDelay: 12000,
                    position: 'top',
                    parent: '#toast-center-container'
                });
            })
        }

        function updateStaff(item) {
            vm.loadingReadPane = true;
            var updatePicture = false;
            if (vm.fromComplaint) {
                vm.staffSelected.is_complaint = true;
            }
            var itemToSend = item ? angular.copy(item) : angular.copy(vm.staffSelected);
            if (!itemToSend.password || (typeof itemToSend.password === 'string' && itemToSend.password.trim() === '')) {
                delete itemToSend.password;
            }
            var options = {
                owner: $scope.owner,
                id: itemToSend.id,
                item: itemToSend
            }
            staffService.updateStaff(options).then(function (response) {
                angular.forEach(vm.files, function (f) {
                    if (!f.url) {
                        vm.uploadMedia(f, response.id, 'user_photo')
                        updatePicture = true;
                    }
                })
                if (itemToSend) {
                    for (var i = 0; i < vm.staff.length; i++) {
                        if (itemToSend.id == vm.staff[i].id) {
                            vm.staff[i] = itemToSend;
                        }
                    }
                }
                if (updatePicture) {
                    vm.checkUploadsAndUpdateStaff();
                } else {
                    initState()
                    vm.loadingReadPane = false;
                    $rootScope.pagination_resetquery();
                }
            }, function (err) {
                vm.loadingReadPane = false;
                var message = (err && err.data && err.data.message) ? err.data.message : (err && err.data && err.data.error) ? err.data.error : (err && err.message) ? err.message : $translate.instant('STAFF.USER_UPDATE_ERROR');
                $mdToast.show({
                    template: '<md-toast id="language-message"><div class="md-toast-content bg-red">' + message + '</div></md-toast>',
                    hideDelay: 12000,
                    position: 'top',
                    parent: '#toast-center-container'
                });
            })
        }

        function checkUploadsAndUpdateStaff() {
            var noUpdate = false;
            if (vm.files && vm.files.length > 0) {
                angular.forEach(vm.files, function (file) {
                    if (angular.isUndefined(file.progress) || file.progress < 100) {
                        noUpdate = true;
                    }
                })
                if (!noUpdate && !$scope.uploadingFile) {
                    initState()
                    vm.loadingReadPane = false;
                    $rootScope.pagination_resetquery();
                } else {
                    $timeout(function () {
                        vm.checkUploadsAndUpdateStaff();
                    }, 1000)
                }
            } else {
                initState()
                vm.loadingReadPane = false;
                $rootScope.pagination_resetquery();

            }
        }


        function getPositions() {
            var options = {
                owner: $scope.owner,
                resultsPerPage: 1000
            };
            staffService.getPositions(options).then(function (response) {
                vm.positions = [];
                for (var i = 0; i < response.data.length; i++) {
                    vm.positions.push({ name: response.data[i].name, id: response.data[i].id });
                }
            })
        }
        function getDivisions() {
            var options = {
                owner: $scope.owner,
                resultsPerPage: 1000
            };
            staffService.getDivisions(options).then(function (response) {
                vm.divisions = [];
                for (var i = 0; i < response.data.length; i++) {
                    vm.divisions.push({ name: response.data[i].name, id: response.data[i].id });
                }
            })
        }

        function getPositionNameById(id) {
            if (id) {
                for (var i = 0; i < vm.positions.length; i++) {
                    if (vm.positions[i].id === id) return vm.positions[i].name;
                }
            }
            return null;
        }

        function deleteStaff(ev) {
            const message = $translate.instant('GLOBAL.ARE_YOU_SURE');
            const yes = $translate.instant('GLOBAL.YES');
            const no = $translate.instant('GLOBAL.NO');

            const confirm = $mdDialog.confirm()
                .title(message)
                .targetEvent(ev)
                .ok(yes)
                .cancel(no);

            $mdDialog.show(confirm).then(e => {
                var threads = angular.copy(vm.selectedThreads);
                vm.selectedThreads = [];
                for (var j = 0; j < threads.length; j++) {
                    var userToDelete = threads[j];
                    var originalEmail = userToDelete.email;
                    
                    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                    var hash = '';
                    for (var i = 0; i < 3; i++) {
                        hash += chars.charAt(Math.floor(Math.random() * chars.length));
                    }
                    
                    var modifiedEmail = originalEmail + 'delete' + hash;
                    
                    var updateOptions = {
                        owner: $scope.owner,
                        id: userToDelete.id,
                        item: Object.assign({}, userToDelete, {
                            email: modifiedEmail
                        })
                    };
                    
                    staffService.updateStaff(updateOptions).then(function (updateResponse) {
                        var deleteOptions = {
                            owner: $scope.owner,
                            id: userToDelete.id
                        };
                        staffService.deleteStaff(deleteOptions).then(function (response) {
                            $rootScope.pagination_resetquery();
                        }).catch(function (error) {
                            console.error('Error al eliminar usuario:', error);
                        });
                    }).catch(function (error) {
                        console.error('Error al modificar email del usuario:', error);
                        var deleteOptions = {
                            owner: $scope.owner,
                            id: userToDelete.id
                        };
                        staffService.deleteStaff(deleteOptions).then(function (response) {
                            $rootScope.pagination_resetquery();
                        }).catch(function (deleteError) {
                            console.error('Error al eliminar usuario:', deleteError);
                        });
                    });
                }
                initState();
            })
        }

        function duplicateStaff() {
            var threads = angular.copy(vm.selectedThreads);
            vm.selectedThreads = [];
            for (var j = 0; j < threads.length; j++) {
                var options = {
                    owner: $scope.owner,
                    item: transformStaff.duplicateStaff(threads[j])
                };
                staffService.createStaff(options).then(function (response) {
                    clientsService.addUserToCompany({
                        owner: $scope.owner,
                        user_id: response.id,
                        company_id: vm.mainCompany.id
                    }).then(function (response) {
                        $rootScope.pagination_resetquery();
                    })

                })
                initState();
            }
        }

        function addUserJob(user, branchId, divisionId, jobPositionId) {
            vm.loadingPositions = true;
            clientsService.addUserJobPosition({
                owner: $scope.owner,
                user_id: user.id,
                branch_id: branchId,
                division_id: divisionId,
                job_position_id: jobPositionId
            }).then(function (response) {
                //console.log(response)
                vm.showFormAdd = false;
                vm.formNewPosition = {};
                staffService.getStaffItem({
                    id: vm.staffSelected.id,
                    owner: $scope.owner
                })
                    .then(function (resp) {
                        vm.staffSelected = resp;
                        vm.loadingPositions = false;
                    })
            })
        }

        function getRegionLiteral(literalKey) {
            if (vm.companySelected.region_id && vm.regionsLiterals) {
                const literalsObject = vm.regionsLiterals.find(x => x.region_id === vm.companySelected.region_id)
                return literalsObject.literals[literalKey];
            } else {
                return '';
            }
        }

        $scope.$watch('vm.files', function () {
            console.debug("WATCH!!:::!:!:!:!: ")

        });

        function showUserImage(user) {
            return $scope.storagePrefix + user.files.url
        }
        function getAdminUsers() {
            var options = {
                owner: $scope.owner,
                inCompany: vm.companySelected.id,
                resultsPerPage: 100
            };
            usersService.getUsers(options).then(res => {
                vm.adminUsers = res.data;
                //console.log(vm.adminUsers);
            })
        }
        function newStaff(ev) {
            vm.originalEmail = null;
            if (vm.fromComplaint) {
                if (!vm.complaintSettings) {
                    alert('Por favor, contacta con un administrador para que defina un plan en esta empresa.');
                }
                if (vm.staff.length >= vm.complaintSettings.max_allowed_users) {
                    let quota = {};
                    if (vm.complaintSettings) {
                        quota = vm.complaintSettings;
                        quota.users_registered = vm.staff.length
                    }
                    $mdDialog.show({
                        controller: 'UserQuotaDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/dialogs/userQuotaDialog/userQuotaDialog2.html',
                        parent: angular.element($document.body),
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        locals: {
                            user: vm.userLogued,
                            quotaComplaint: quota
                        }
                    }).then(function (res) {
                        if (res && res.type) {
                            if (res.type == 'upgrade') {
                                console.log("go upgrade screen");
                            }
                        }
                    });
                } else {
                    newStaffData();
                }
            } else {
                if (vm.quota.users_registered >= vm.quota.max_allowed_users) {
                    $mdDialog.show({
                        controller: 'UserQuotaDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/dialogs/userQuotaDialog/userQuotaDialog2.html',
                        parent: angular.element($document.body),
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        locals: {
                            user: vm.userLogued,
                            quotaComplaint: null
                        }
                    }).then(function (res) {
                        if (res && res.type) {
                            if (res.type == 'upgrade') {
                                console.log("go upgrade screen");
                            }
                        }

                    });

                } else {
                    newStaffData();
                }
            }
        }

        function newStaffData() {
            vm.files = [];
            if (vm.staffSelected)
                vm.staffSelected = undefined;
            vm.staffNew = {};
            vm.staffNew.enabled = false;
            vm.viewEditDataNew();
        }

        function initState() {
            vm.staffSelected = undefined;
            vm.staffNew = undefined;
        }

        function checkFields() {
            if (vm.staffNew) {
                return transformStaff.checkFieldsStaff(vm.staffNew);
            } else if (vm.staffSelected) {
                return transformStaff.checkFieldsStaff(vm.staffSelected);
            }
        }



        /**
         * Open thread
         *
         * @param thread
         */
        function openThread(thread) {
            // // Set the read status on the thread
            // thread.read = true;

            // // Assign thread as the current thread
            // vm.currentThread = thread;

            // // Update the state without reloading the controller
            // $state.go('app.aircrafts.threads.thread', { threadId: thread.id }, { notify: false });
        }

        /**
         * Close thread
         */
        function closeThread() {
            // vm.currentThread = null;

            // // Update the state without reloading the controller
            // $state.go('app.aircrafts.threads', {
            //     type: vm.currentFilter.type,
            //     filter: vm.currentFilter.filter
            // }, { notify: false });
        }

        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        function isSelected(thread) {
            return vm.selectedThreads.indexOf(thread) > -1;
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        function toggleSelectThread(thread, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedThreads.indexOf(thread) > -1) {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            } else {
                vm.selectedThreads.push(thread);
            }
        }

        /**
         * Select threads. If key/value pair given,
         * threads will be tested against them.
         *
         * @param [key]
         * @param [value]
         */
        function selectThreads(key, value) {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedThreads = [];

            for (var i = 0; i < vm.staff.length; i++) {
                if (angular.isUndefined(key) && angular.isUndefined(value)) {
                    vm.selectedThreads.push(vm.staff[i]);
                    continue;
                }

                if (angular.isDefined(key) && angular.isDefined(value) && vm.staff[i][key] === value) {
                    vm.selectedThreads.push(vm.staff[i]);
                }
            }
        }

        /**
         * Deselect threads
         */
        function deselectThreads() {
            vm.selectedThreads = [];
        }

        /**
         * Toggle select threads
         */
        function toggleSelectThreads() {
            if (vm.selectedThreads.length > 0) {
                vm.deselectThreads();
            } else {
                vm.selectThreads();
            }
        }

        /**
         * Set the status on given thread, current thread or selected threads
         *
         * @param key
         * @param value
         * @param [thread]
         * @param [event]
         */
        function setThreadStatus(key, value, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                thread[key] = value;
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                vm.currentThread[key] = value;
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                vm.selectedThreads[x][key] = value;
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleThreadStatus(key, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                if (typeof (thread[key]) !== 'boolean') {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                if (typeof (vm.currentThread[key]) !== 'boolean') {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                if (typeof (vm.selectedThreads[x][key]) !== 'boolean') {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }




        /**
         * Change the view
         *
         * @param view
         */
        function changeView(view) {
            if (vm.views[view]) {
                vm.defaultView = view;
                vm.currentView = view;
            }
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function staffHasBranch(branch) {
            var hasBranch = false;
            angular.forEach(vm.staffSelected.division_jobs, function (divisionJobs) {
                if (divisionJobs.branch_id == branch.id) {
                    hasBranch = true;
                }
            })
            return hasBranch;
        }

        function staffHasCompany(company) {
            var hasCompany = false;
            angular.forEach(company.branches, function (branch) {
                if (vm.staffHasBranch(branch)) {
                    hasCompany = true;
                }
            })
            return hasCompany;
        }

        function viewEditData() {
            vm.copyStaff = angular.copy(vm.staffSelected);
            vm.editData = true;
            vm.tabActive = 'edit';
            vm.editCompanies = false;
            vm.previewData = false;
        }
        function viewEditDataNew() {
            vm.tabActive = 'editnew';
        }
        function viewPreviewData() {
            vm.tabActive = 'preview';
        }
        function viewEditCompanies() {
            vm.tabActive = 'companies';
        }
        function viewActivity() {
            vm.tabActive = 'activity';
        }
        function viewTask() {
            vm.tabActive = 'tasks';
        }
        function viewConfigureTabs() {
            vm.tabActive = 'configuretabs';
        }
        function viewPasswordEmail() {
            vm.tabActive = 'sendpasswordemail';
        }
        function reset2FA() {
            vm.tabActive = 'reset2fa';
        }
        function resetStaffSelected() {
            vm.staffSelected = null;
            vm.staffNew = null;
            vm.tabNewSelected = 'new';
        }
        var originatorEv;

        function openMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        }

        function toggleStaffStatusEdit(fieldName, item, event) {
            if (event) {
                event.stopPropagation();
            }
            if (item) {
                if (angular.isUndefined(item[fieldName])) {
                    item[fieldName] = 0;
                }
                var thread = item[fieldName];
                thread = (thread) ? false : true;
                item[fieldName] = thread;
                updateStaff(item);
            } else {
                if (vm.staffSelected) {
                    var thread = vm.staffSelected[fieldName];
                    thread = (thread) ? false : true;
                    vm.staffSelected[fieldName] = thread;
                } else {
                    if (angular.isUndefined(vm.staffNew[fieldName])) {
                        vm.staffNew[fieldName] = 0;
                    }
                    var thread = vm.staffNew[fieldName];
                    thread = (thread) ? false : true;
                    vm.staffNew[fieldName] = thread;
                }
            }
        
            vm.basicForm.$setDirty();
        }        

        function uploadMedia(file, idValue, uploadKey) {
            if (!file.$error) {
                var token = undefined;
                $scope.uploadingFile = true;
                console.debug("UPLOAD STARTED______****", file)
                mediaService.getS3UploadPreSignedUrl({
                    owner: $scope.owner,
                    uploadKey: uploadKey,
                    fileName: file.name,
                    rowId: idValue
                })
                    .then(function (resp) {
                        token = resp.token;
                        file.id_media = resp.id_media;
                        file.upload = Upload.http({
                            url: resp.url,
                            skipAuthorization: true,
                            method: 'PUT',
                            headers: {
                                "Content-Type": file.type != '' ? file.type : 'application/octet-stream'
                            },
                            data: file
                        })
                        file.upload.then(function (response) {
                            file.result = response.data;
                            $timeout(function () {
                                $scope.log = 'file: ' +
                                    file.name +
                                    ', Response: ' + JSON.stringify(response.data) +
                                    ', ID: ' + file.id_media +
                                    '\n' + $scope.log;
                            });
                            console.debug("FINISHING UPLOAD______****", file)
                            mediaService.finishedUploadingFileToCdn({
                                owner: $scope.owner,
                                idMedia: file.id_media,
                                token: token
                            }).then(function () {
                                $scope.uploadingFile = false;
                            })

                        }, function (response) {
                            if (response.status > 0)
                                $scope.errorMsg = response.status + ': ' + response.data;
                        });

                        file.upload.progress(function (evt) {
                            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                        });
                    })
            }
        };

        function toggleStripe() {
            if (!vm.staffSelected) {
                alert("No hay un usuario seleccionado para modificar Stripe.");
                return;
            }

            if (vm.staffSelected.enabled === false) {
                var alert = $mdDialog.alert({
                    title: $translate.instant('STAFF.ATTENTION'),
                    textContent: $translate.instant('STAFF.ACTIVATE_USER_TO_MODIFY_STRIPE'),
                    ok: $translate.instant('STAFF.CLOSE')
                });

                $mdDialog.show(alert).finally(function () {
                    alert = undefined;
                });
                return;
            }

            var message = $translate.instant('STAFF.CONFIRM_TOGGLE_STRIPE');
            var yes = $translate.instant('STAFF.YES');
            var no = $translate.instant('STAFF.NO');
            var description = vm.staffSelected.stripe ? 
                $translate.instant('STAFF.CONFIRM_DISABLE_STRIPE_DESC') : 
                $translate.instant('STAFF.CONFIRM_ENABLE_STRIPE_DESC');

            var confirm = $mdDialog.confirm()
                .title(message)
                .textContent(description)
                .ariaLabel('Confirm Toggle Stripe')
                .ok(yes)
                .cancel(no);

            $mdDialog.show(confirm).then(function () {
                ejecutarToggleStripe();
            }, function () {});
        }

        function ejecutarToggleStripe() {
            var ownerId = getAccountAliasFromURL();

            if (!ownerId) {
                alert("El campo account_alias es obligatorio.");
                return;
            }

            var options = {
                owner: ownerId,
                id: vm.staffSelected.id,
                item: Object.assign({}, vm.staffSelected, {
                    stripe: vm.staffSelected.stripe ? false : true
                })
            };

            staffService.updateStaff(options).then(function (res) {
                if (res) {
                    vm.staffSelected.stripe = options.item.stripe;
                    var message = vm.staffSelected.stripe ? 
                        $translate.instant('STAFF.STRIPE_ENABLED') : 
                        $translate.instant('STAFF.STRIPE_DISABLED');

                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center start">' +
                                '<div class="md-toast-content bg-green">' + message + '</div></md-toast>',
                        hideDelay: 7000,
                        position: 'top right',
                        parent: '#content'
                    });

                    setTimeout(function() {
                        var toastrContainer = document.querySelector('.md-toast');
                        if (toastrContainer) {
                            toastrContainer.style.position = 'fixed';
                            toastrContainer.style.top = '5px';
                            toastrContainer.style.left = '50%';
                            toastrContainer.style.transform = 'translateX(-50%)';
                            toastrContainer.style.width = 'auto';
                        }
                    }, 100);
                }
            }).catch(function (error) {
                alert("Hubo un error al modificar Stripe. Por favor, intenta nuevamente.");
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.staff')
        .service('staffService', staffService);

    /** @ngInject */
    // I provide access to the session store.
    function staffService($q, $rootScope, $resource, settingsDomainService, companyService, sessionService, COMMON, $window, $mdToast) {
        var branch = {};
        var division = {};
        function getStaff(options) {
            var deferred = $q.defer();
            var opt = {
                owner: options.owner,
                inCompany: companyService.getCompanyId(),

                withFiles: true,
                withCompanies: true,
                search: options.searchStringFilter,
                page: options.page,
                resultsPerPage: options.resultsPerPage,
                sortField: options.sortField ? options.sortField : 'id'

            };
            if (companyService.getCompanyId() && branch && branch.id) {
                opt.inBranch = branch.id;
            }
            if (companyService.getCompanyId() && division && division.id) {
                opt.inDivision = division.id;
            }
            resourceStaff.get(opt,
                function (response) {
//                    console.log(response);
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getStaffItem(options) {
            var deferred = $q.defer();
            resourceStaffItem.get({
                id: options.id,
                owner: options.owner
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getActivityUser(options) {
            var deferred = $q.defer();
            resourceActivityStaff.get({
                id: options.id,
                owner: options.owner
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getTasksUser(options) {
            var deferred = $q.defer();
            resourceTasksStaff.get(options,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateStaff(options) {
            var deferred = $q.defer();
            resourceStaffItem.update({
                owner: options.owner,
                id: options.id
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function createStaff(options) {
            var deferred = $q.defer();
            resourceStaffItem.post({
                owner: options.owner
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function deleteStaff(options) {
            var deferred = $q.defer();
            resourceStaffItem.delete({
                owner: options.owner,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getFilters(options) {
            var deferred = $q.defer();

            return (deferred.promise);
        }


        function getPositions(options) {
            var deferred = $q.defer();
            resourcePositions.get({
                owner: options.owner,
                resultsPerPage: options.resultsPerPage
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getDivisions(options) {
            var deferred = $q.defer();
            resourceDivisions.get({
                owner: options.owner,
                resultsPerPage: options.resultsPerPage
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getMainBranch(options) {
            var deferred = $q.defer();
            resourceMainBranch.get({
                owner: options.owner,
                id_company: options.id_company
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        function setBranch(branchData) {
            branch = branchData;
        }

        function setDivision(divisionData) {
            division = divisionData;
        }

        var resourcePositions = $resource(COMMON.BASE_API + "/owner/:owner/jobPosition", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        });
        var resourceDivisions = $resource(COMMON.BASE_API + "/owner/:owner/division", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        });
        var resourceMainBranch = $resource(COMMON.BASE_API + "/owner/:owner/branch?company_id=:id_company&is_main=1", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        });



        var resourceStaffItem = $resource(COMMON.BASE_API + "/owner/:owner/user/:id", {
            // is_complaint: '@is_complaints',
        }, {
            get: {
                method: "GET",
                isArray: false
            },

            post: {
                method: "POST",
                isArray: false
            },

            delete: {
                method: "DELETE",
                isArray: false
            },

            update: {
                method: "PUT",
                isArray: false
            },
        });


        var resourceStaff = $resource(COMMON.BASE_API + "/owner/:owner/user", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        });

        var resourceActivityStaff = $resource(COMMON.BASE_API + "/owner/:owner/user/activities?sortField=date&sortDir=desc&parentsOnly&withUser&userId=:id&resultsPerPage=100", {
            // No default data
        }, {
            get: {
                method: "GET"
                // isArray: false
            }
        });

        var resourceTasksStaff = $resource(COMMON.BASE_API + "/owner/:owner/activeTree/all?user_id=:id", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        });


        return ({
            get: getStaff,
            getStaff: getStaff,
            getMainBranch: getMainBranch,
            getStaffItem: getStaffItem,
            setBranch: setBranch,
            setDivision: setDivision,
            getFilters: getFilters,
            getPositions: getPositions,
            getDivisions: getDivisions,
            getActivityUser: getActivityUser,
            getTasksUser: getTasksUser,
            updateStaff: updateStaff,
            deleteStaff: deleteStaff,
            createStaff: createStaff

        });

    }

})();

(function () {
    'use strict';

    angular
        .module('app.riskconfig')
        .controller('RiskConfigController', RiskConfigController);

    /** @ngInject */
    function RiskConfigController($scope, $rootScope, $stateParams, $translate, $document, $mdDialog, $filter,
        $mdMedia, $mdMenu, $mdToast, $mdSidenav, $state, msApi, tinyMceService, companyService, riskConfigService, requestContext,
        mediaService, Upload, $timeout, sessionService, msUtils) {
        var vm = this;
        vm.branding = msUtils.getBranding()
        vm.showDeleted = false;
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
        vm.loadingThreads = true;
        vm.currentRisk = null;
        vm.showDeleted = false;
        vm.allRegions = sessionService.config.regions;
        vm.searchRegionText = '';
        vm.regionSelected = riskConfigService.currentRegion;

        vm.currentThread = null;
        vm.selectedThreads = [];

        vm.views = {
            split: 'app/main/apps/riskconfig/views/list/split-view.html',
            nosplit: 'app/main/apps/riskconfig/views/list/nosplit-view.html'
        };
        vm.defaultView = 'split';
        vm.currentView = 'split';

        vm.readView = false;

        vm.reloadToggleDeleted = reloadToggleDeleted;
        vm.reloadThreads = reloadThreads;
        vm.updateRiskLevels = updateRiskLevels;

        vm.editRisk = editRisk;
        vm.editNameDialog = editNameDialog;
        vm.isSelected = isSelected;
        vm.toggleSelectThread = toggleSelectThread;
        vm.selectThreads = selectThreads;
        vm.deleteRisk = deleteRisk;
        vm.deleteRiskById = deleteRiskById;
        vm.deleteControl = deleteControl;
        vm.deleteProcess = deleteProcess;
        vm.restoreProcess = restoreProcess;
        vm.restoreControl = restoreControl;
        vm.deselectThreads = deselectThreads;
        vm.toggleSelectThreads = toggleSelectThreads;
        vm.openDelegationsDialog = openDelegationsDialog;
        vm.openCreateProcessDialog = openCreateProcessDialog;
        vm.openCreateControlDialog = openCreateControlDialog;
        vm.openCreateRiskDialog = openCreateRiskDialog;
        vm.selectRegion = selectRegion;

        vm.changeView = changeView;
        vm.toggleSidenav = toggleSidenav;
        vm.openMenu = openMenu;

        vm.tinymceOptions = tinyMceService.getBasicOptions($scope);

        //////////

        vm.risks = [];
        vm.files = [];
        vm.searchBranchText = '';
        vm.companyBranches = [];
        vm.editMode = false;

        vm.taskData = {};
        vm.loadingTasks = false;
        vm.savingTask = false;

        vm.controlTabsIndex = 0;

        vm.totalRiskControls = totalRiskControls;
        vm.impactColor = impactColor;
        vm.openRisk = openRisk;
        vm.loadRisk = loadRisk;
        vm.closeRisk = closeRisk;
        vm.showUserImage = showUserImage;
        vm.showUserImageFromId = showUserImageFromId;
        vm.showRiskLevel = showRiskLevel;
        vm.openDialogText = openDialogText;
        vm.updateProcessScore = updateProcessScore;

        vm.controlAverageColor = msUtils.controlAverageColor;
        vm.controlAverageColorText = msUtils.controlAverageColorText;
        vm.controlAverageText = msUtils.controlAverageText;


        vm.translate = msUtils.translate;
        vm.timeAgo = msUtils.timeAgo;



        //////////

        $scope.$on('pagination:loadStart', function (event) {
            $scope.isLoading = true;
        });

        $scope.$on('pagination:loadPage', function (event) {
            $scope.isLoading = false;
        });

        $scope.owner = $stateParams.owner;

        init();

        /////////////////

        function init() {
            vm.selectRegion(vm.regionSelected);
            if (sessionService.get('companySelected')) {
                $rootScope.$broadcast('company-selected');
            }

            mediaService.getStoragePrefix({
                owner: $scope.owner,
            }).then(function (res) {
                $scope.storagePrefix = res.prefix;
            })
        }

        $scope.$watch('vm.risks', function () {
            if ($state.params.id) {
                vm.openRisk({ id: $state.params.id });
            }
        });
        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'nosplit';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big)
                vm.currentView = 'nosplit';

        });

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small)
                vm.currentView = 'split';

        });

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                if (vm.defaultView === 'split') {
                    vm.currentView = 'split';
                }
            }
        });

        var originatorEv;

        function openMenu($mdOpenMenu, ev) {
            originatorEv = ev;
            $mdOpenMenu(ev);
        }


        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        function isSelected(thread) {
            return vm.selectedThreads.indexOf(thread) > -1;
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        function toggleSelectThread(thread, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedThreads.indexOf(thread) > -1) {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            } else {
                vm.selectedThreads.push(thread);
            }
        }

        function updateRiskLevels(risk) {
            console.log(risk)
            var options = {
                owner: $scope.owner,
                id: risk.id,
                item: risk
            }
            riskConfigService.updaterisk(options)
                .then(function (response) {
                    var message = $translate.instant('GLOBAL.UPDATED_SUCCESSFULLY')
                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content bg-green">' + message + '</div></md-toast>',
                        hideDelay: 7000,
                        position: 'top right',
                        parent: '#content'
                    });
                })
                .catch(function (response) {
                    console.log('err', response);
                });
        }

        /**
         * Select threads. If key/value pair given,
         * threads will be tested against them.
         *
         * @param [key]
         * @param [value]
         */
        function selectThreads(key, value) {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedThreads = [];

            for (var i = 0; i < vm.risks.length; i++) {
                if (angular.isUndefined(key) && angular.isUndefined(value)) {
                    vm.selectedThreads.push(vm.risks[i]);
                    continue;
                }

                if (angular.isDefined(key) && angular.isDefined(value) && vm.risks[i][key] === value) {
                    vm.selectedThreads.push(vm.risks[i]);
                }
            }
        }

        /**
         * Deselect threads
         */
        function deselectThreads() {
            vm.selectedThreads = [];
        }

        /**
         * Toggle select threads
         */
        function toggleSelectThreads() {
            if (vm.selectedThreads.length > 0) {
                vm.deselectThreads();
            } else {
                vm.selectThreads();
            }
        }



        /**
         * Change the view
         *
         * @param view
         */
        function changeView(view) {
            if (vm.views[view]) {
                vm.defaultView = view;
                vm.currentView = view;
            }
        }

        function deleteRiskById(id, ev) {
            var message = $translate.instant('GLOBAL.ARE_YOU_SURE');
            var yes = $translate.instant('GLOBAL.YES');
            var no = $translate.instant('GLOBAL.NO');
            var confirm = $mdDialog.confirm()
                .title(message)
                // .htmlContent('<b>' + vm.contact.name + ' ' + vm.contact.lastName + '</b>' + ' will be deleted.')
                .targetEvent(ev)
                .ok(yes)
                .cancel(no);

            $mdDialog.show(confirm).then(function () {
                $scope.isLoading = true;
                var options = {
                    owner: $scope.owner,
                    id: id
                };
                riskConfigService.deleteRisk(options).then(function (response) {
                    $scope.isLoading = false;
                    $rootScope.pagination_resetquery();
                    vm.closeRisk();
                }).catch(function (err) {
                    var message = $translate.instant('GLOBAL.ERROR') + '<br>' + err.data.detail;

                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                        hideDelay: 5000,
                        position: 'top',
                        parent: '#content-container'
                    });
                });
            });
        }

        function deleteRisk(ev) {
            const message = $translate.instant('GLOBAL.ARE_YOU_SURE');
            const yes = $translate.instant('GLOBAL.YES');
            const no = $translate.instant('GLOBAL.NO');

            const confirm = $mdDialog.confirm()
                .title(message)
                .targetEvent(ev)
                .ok(yes)
                .cancel(no);

            $mdDialog.show(confirm).then(e => {
                $scope.isLoading = true;
                vm.closeRisk();
                var count = 0;
                for (var i = 0; i < vm.selectedThreads.length; i++) {
                    var options = {
                        owner: $scope.owner,
                        id: vm.selectedThreads[i].id
                    };
                    riskConfigService.deleteRisk(options).then(function (response) {
                        count++;
                        if (count == vm.selectedThreads.length) {
                            deselectThreads();
                            $rootScope.pagination_resetquery();
                            $scope.isLoading = false;
                        }
                    }).catch(function (err) {
                        var message = $translate.instant('GLOBAL.ERROR') + '<br>' + err.data.detail;
    
                        $mdToast.show({
                            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                            hideDelay: 5000,
                            position: 'top',
                            parent: '#content-container'
                        });
                    });
                }
            });

 
        }
        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }


        function reloadToggleDeleted() {
            $scope.isLoading = true;
            vm.showDeleted = !vm.showDeleted;
            if (vm.showDeleted) {
                $rootScope.withTrashed = vm.showDeleted;
            } else {
                delete $rootScope.withTrashed;
            }
            vm.reloadThreads();
        }

        function reloadThreads() {
            var options = {
                owner: $scope.owner,
                region_id: vm.regionSelected.id
            }
            riskConfigService.get(options).then(function (res) {
                $rootScope.pagination_totalItems = res.result.total;
                $rootScope.pagination_total_pages = res.result.last_page;
                $rootScope.pagination_page = res.result.current_page;
                vm.risks = res.result.data;
                $scope.isLoading = false;
            }).catch(function (err) {
                var message = $translate.instant('GLOBAL.ERROR') + '<br>' + err.data.detail;

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
            })
        }

        function impactColor(impact) {
            var color;
            if (impact >= 1 && impact <= 4) {
                color = 'green';
            } else if (impact >= 5 && impact <= 9) {
                color = 'yellow';
            } else if (impact >= 10 && impact <= 15) {
                color = 'orange';
            } else if (impact >= 16 && impact <= 25) {
                color = 'red';
            }
            return color;
        }


        function totalRiskControls(risk) {
            var totalControls = 0;
            angular.forEach(risk.processes, function (proc) {
                totalControls += proc.controls.length;
            })
            return totalControls
        }

        function openRisk(risk) {
            $state.go('app.site_overview.riskconfig.active_risk', {
                id: risk.id,
                domain: $state.params.domain
            }, {
                    notify: false,
                    inherit: true,
                    location: true
                });
            var options = {
                owner: $scope.owner,
                id: risk.id
            };
            riskConfigService.getRiskById(options).then(function (res) {
                vm.currentRisk = res.result;
            })
        }


        function loadRisk(riskId) {
            for (var i = 0; i < vm.risks.length; i++) {
                const risk = vm.risks[i];
                if (risk.id == riskId) {
                    vm.currentRisk = risk;
                    break;
                }
            }

        }

        function closeRisk() {
            vm.currentRisk = undefined;
            vm.currentControl = undefined;
            vm.currentEditRisk = undefined;
            $state.go('app.site_overview.riskconfig.list', {
                domain: $state.params.domain
            }, {
                    notify: false,
                    inherit: true,
                    location: true
                });
        }


        function showUserImage(user) {
            return $scope.storagePrefix + user.files.url
        }
        function showUserImageFromId(userId) {
            angular.forEach(vm.allUsers, function (u) {
                if (u.id == userId) {
                    if (!angular.isUndefined(u.files.id)) {
                        return $scope.storagePrefix + u.files.url
                    } else {
                        return false;
                    }
                }
            });
        }

        function showRiskLevel(riskLevel) {
            return vm.translate('RISKCONFIG.RISK_LEVELS_' + riskLevel);
        }

        function openDialogText($event, text, title) {
            $mdDialog.show({
                controller: function ($timeout, $q, $scope, $mdDialog, $filter, title, text) {
                    var vm = this;
                    vm.text = text;
                    vm.title = title;
                    vm.closeDialog = function () {
                        $mdDialog.hide();
                    }
                },
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/textDialog/textDialog.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    title: title,
                    text: text
                },
            })
                .then(function (resp) {
                });

        }
        function editRisk($event, risk) {
            //console.log("vm.regionSelected:", vm.regionSelected);
            $mdDialog.show({
                controller: 'EditRiskDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/riskconfig/dialogs/edit-risk-dialog/edit-risk-dialog.controller.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    risk: risk,
                    regionSelected: vm.regionSelected
                },
            })
                .then(function (resp) {
                    if (resp && resp.id) {
                        vm.updateRiskLevels(resp);
                        vm.currentRisk = resp;
                        for (var i = 0; i < vm.risks.length; i++) {
                            if (vm.risks[i].id == resp.id) {
                                vm.risks[i] = resp;
                                break;
                            }
                        }
                    } else if (resp) {
                        vm.country_id = 1;
                        vm.language_id = 1;
                        var options = {
                            owner: $scope.owner,
                            name: resp.name,
                            description: resp.description,
                            code: resp.code,
                            external_link: resp.external_link,
                            conducts: resp.conducts,
                            factual_causes: resp.factual_causes,
                            reputation_impact: resp.reputation_impact,
                            penal_code_impact: resp.penal_code_impact,
                            client_loss: resp.client_loss,
                            country_id: vm.country_id,
                            language_id: vm.language_id,
                            region_id: vm.regionSelected.id
                        }
                        riskConfigService.createRisk(options).then(function (response) {
                            $rootScope.pagination_resetquery();
                        }).catch(function (err) {
                            var message = $translate.instant('GLOBAL.ERROR') + '<br>' + err.data.detail;

                            $mdToast.show({
                                template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                                hideDelay: 5000,
                                position: 'top',
                                parent: '#content-container'
                            });
                        });
                    }
                });

        }

        function editNameDialog($event, type, item, process) {
            $mdDialog.show({
                controller: function ($timeout, $q, $scope, $mdDialog, riskConfigService, Owner, type, item) {
                    var vm = this;
                    vm.item = angular.copy(item);
                    vm.process = process;
                    vm.type = type;
                    vm.closeDialog = function () {
                        $mdDialog.hide();
                    }
                    vm.saveDialog = function () {
                        var options = {
                            owner: Owner,
                            item: vm.item
                        }
                        if (vm.type == "process") {
                            riskConfigService.updateProcess(options).then(function () {
                                $mdDialog.hide({ completed: true });
                            })
                        }
                        if (vm.type == "control") {
                            options.process = vm.process;
                            riskConfigService.updateControl(options).then(function () {
                                $mdDialog.hide({ completed: true });
                            })
                        }
                    }
                },
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/riskconfig/dialogs/edit-name/edit-name-dialog.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    Owner: $scope.owner,
                    type: type,
                    process: process,
                    item: item
                },
            })
                .then(function (resp) {
                    if (resp && resp.completed) {
                        vm.openRisk(vm.currentRisk);
                    }
                });
        }

        function openDelegationsDialog($event, text) {
            $mdDialog.show({
                controller: 'DelegationsDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/riskconfig/dialogs/delegations-dialog/delegations-dialog.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    Owner: $scope.owner,
                    selectedRisks: vm.selectedThreads
                },
            })
                .then(function (resp) {
                    if (resp && resp.completed) {
                        vm.toggleSelectThreads();
                    }
                });

        }

        function openCreateRiskDialog($event) {
            vm.editRisk();
            // $mdDialog.show({
            //     controller: 'CreateRiskDialog',
            //     controllerAs: 'vm',
            //     templateUrl: 'app/main/apps/riskconfig/dialogs/create-risk-dialog/create-risk-dialog.controller.html',
            //     parent: angular.element(document.body),
            //     targetEvent: $event,
            //     clickOutsideToClose: true,
            //     locals: {
            //         Owner: $scope.owner
            //     },
            // })
            //     .then(function (resp) {
            //         if (resp && resp.risk) {
            //             vm.openRisk(resp.risk);
            //             $rootScope.pagination_resetquery();
            //         }
            //     });

        }
        function openCreateProcessDialog($event) {
            $mdDialog.show({
                controller: 'CreateProcessDialog',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/riskconfig/dialogs/create-process-dialog/create-process-dialog.controller.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    Owner: $scope.owner,
                    risk: vm.currentRisk,
                    regionSelected: vm.regionSelected
                },
            })
                .then(function (resp) {
                    if (resp && resp.completed) {
                        vm.openRisk(vm.currentRisk);
                        $rootScope.pagination_resetquery();
                    }
                })

        }
        function openCreateControlDialog($event, process) {
            $mdDialog.show({
                controller: 'CreateControlDialog',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/riskconfig/dialogs/create-control-dialog/create-control-dialog.controller.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    Owner: $scope.owner,
                    process: process
                },
            })
                .then(function (resp) {
                    if (resp && resp.completed) {
                        vm.openRisk(vm.currentRisk);
                        $rootScope.pagination_resetquery();
                    }
                }).catch(function (err) {
                    var message = $translate.instant('GLOBAL.ERROR') + '<br>' + err.data.detail;

                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                        hideDelay: 5000,
                        position: 'top',
                        parent: '#content-container'
                    });
                });

        }

        function selectRegion(region, noFirst) {
            $scope.isLoading = true;
            vm.regionSelected = region;
            riskConfigService.setCurrentRegion(region);
            vm.searchRegionText = '';
            reloadThreads()
        }

        function deleteControl(control) {
            var options = {
                owner: $scope.owner,
                id: control.id
            };
            riskConfigService.deleteControl(options).then(function () {
                vm.openRisk(vm.currentRisk);
                $rootScope.pagination_resetquery();
            }).catch(function (err) {
                var message = $translate.instant('GLOBAL.ERROR') + '<br>' + err.data.detail;

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
            })
        }

        function deleteProcess(process) {
            var options = {
                owner: $scope.owner,
                id: process.id
            };
            riskConfigService.deleteProcess(options).then(function () {
                vm.openRisk(vm.currentRisk);
                $rootScope.pagination_resetquery();
            }).catch(function (err) {
                var message = $translate.instant('GLOBAL.ERROR') + '<br>' + err.data.detail;

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
            })
        }
        function restoreProcess(process) {
            var options = {
                owner: $scope.owner,
                id: process.id
            };
            riskConfigService.restoreProcess(options).then(function () {
                vm.openRisk(vm.currentRisk);
                $rootScope.pagination_resetquery();
            }).catch(function (err) {
                var message = $translate.instant('GLOBAL.ERROR') + '<br>' + err.data.detail;

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
            })
        }
        function restoreControl(control) {
            var options = {
                owner: $scope.owner,
                id: control.id
            };
            riskConfigService.restoreControl(options).then(function () {
                vm.openRisk(vm.currentRisk);
                $rootScope.pagination_resetquery();
            }).catch(function (err) {
                var message = $translate.instant('GLOBAL.ERROR') + '<br>' + err.data.detail;

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
            })
        }

        function updateProcessScore($event, process) {
            console.log(vm.currentRisk.company_id);
            var options = {
                owner: $scope.owner,
                companyId: vm.currentRisk.company_id,
                branch: vm.currentRisk.branch_id,
                process_id: process.id,
                date: moment().format('YYYY-MM-DD'),
                odds: process.oddsOfOccurrence,
                comment: ''
            }
            $mdDialog.show({
                controller: function ($timeout, $q, $scope, $mdDialog, score) {
                    var vm = this;
                    vm.score = score;
                    vm.comment = '';
                    vm.closeDialog = function () {
                        $mdDialog.hide();
                    }
                    vm.answer = function (answer) {
                        $mdDialog.hide(answer);
                    };
                },
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/process/oddOfOccurrence.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    score: options.odds
                },
            })
                .then(function (answer) {
                    if (answer) {
                        options.odds = answer.score;
                        options.comment = !angular.isUndefined(answer.comment) ? answer.comment : '';
                        riskConfigService.processOddOfOccurrence(options)
                            .then(function (response) {

                            }).catch(function (err) {
                                var message = $translate.instant('GLOBAL.ERROR') + '<br>' + err.data.detail;

                                $mdToast.show({
                                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                                    hideDelay: 5000,
                                    position: 'top',
                                    parent: '#content-container'
                                });
                            })
                    }
                });
        }





    }
})();
(function () {
    'use strict';

    angular
        .module('app.riskconfig')
        .service('riskConfigService', riskConfigService);

    /** @ngInject */
    // I provide access to the session store.
    function riskConfigService($q, $resource, settingsDomainService, sessionService, companyService, COMMON, $rootScope, $window, $mdToast, $filter) {

        function getRisks(options) {
            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });

            resourceRisks.get({
                owner: options.owner,
                company_id: companyService.getCompanyId(),
                branch_id: companyService.getCompanyId() ? companyService.getBranch().id : '',
                region_id: currentRegion.id,
                page: options.page,
                withTrashed: $rootScope.withTrashed,
                search: options.searchStringFilter,
                paginate: options.paginate,
                sortField: options.sortField,
                sortDir: options.sortDir,
                resultsPerPage: 15, //options.resultsPerPage,
                filters: JSON.stringify(filters),
            },
                function (responseResult) {
                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getRiskActive(options) {
            var deferred = $q.defer();
            resourceActiveRisk.get({
                owner: options.owner,
                id: options.id,
            },
                function (responseResult) {
                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getRiskById(options) {
            var deferred = $q.defer();
            resourceRisk.get({
                owner: options.owner,
                id: options.id,
                withTrashed: 1
            },
                function (responseResult) {
                    if (responseResult.data.length > 0) {
                        deferred.resolve({
                            result: responseResult.data[0]
                        });
                    } else {
                        deferred.reject(e);
                    }
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function createRisk(options) {
            var deferred = $q.defer();
            resourceRisk.post({
                owner: options.owner,
            }, {
                name: options.name,
                description: options.description,
                code: options.code,
                external_link: options.external_link,
                conducts: options.conducts,
                factual_causes: options.factual_causes,
                reputation_impact: options.reputation_impact,
                penal_code_impact: options.penal_code_impact,
                client_loss: options.client_loss,
                country_id: options.country_id,
                language_id: options.language_id,
                region_id: options.region_id
            },
                function (responseResult) {
                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getrisk(options) {
            var deferred = $q.defer();
            resourceRisksID.get({
                owner: options.owner,
                id: options.id
            }, function (responseResult) {
                deferred.resolve({
                    result: responseResult
                });
            },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updaterisk(options) {
            var deferred = $q.defer();
            resourceRisksID.put({
                owner: options.owner,
                id: options.id
            }, options.item,
                function (responseResult) {
                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        function activateRisk(options) {
            var deferred = $q.defer();
            resourceActivateRisk.post({
                owner: options.owner
            }, {
                risk_id: options.risk_id,
                company_id: options.company_id,
                branch_id: options.branch_id,
                exclude: options.exclude
            },
                function (responseResult) {
                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function createProcess(options) {
            var deferred = $q.defer();
            resourceProcess.post({
                owner: options.owner
            }, {
                name: options.name,
                region_id: options.region_id
            },
                function (responseResult) {
                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateProcess(options) {
            var deferred = $q.defer();
            resourceProcess.update({
                owner: options.owner,
                id: options.item.id
            }, {
                name: options.item.name
            },
                function (responseResult) {
                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateControl(options) {
            var deferred = $q.defer();
            resourceControl.update({
                owner: options.owner,
                id: options.item.id
            }, {
                name: options.item.name,
                process_id: options.process.id
            },
                function (responseResult) {
                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function createControl(options) {

            var deferred = $q.defer();
            resourceControl.post({
                owner: options.owner,
            }, {
                name: options.name,
                process_id: options.process_id
            },
                function (responseResult) {
                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function createProcessInRisk(options) {
            var deferred = $q.defer();
            resourceProcessInRisk.post({
                owner: options.owner,
                risk_id: options.risk_id,
                process_id: options.process_id,
            }, {
                process_id: options.process_id
            },
                function (responseResult) {
                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        function deleteRisk(options) {
            var deferred = $q.defer();
            resourceRisksID.delete({
                owner: options.owner,
                id: options.id
            }, {
                id: options.id,
            },
                function (responseResult) {
                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function deleteControl(options) {
            var deferred = $q.defer();
            resourceControl.delete({
                owner: options.owner,
                id: options.id
            }, {
                id: options.id,
            },
                function (responseResult) {
                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function deleteProcess(options) {
            var deferred = $q.defer();
            resourceProcess.delete({
                owner: options.owner,
                id: options.id
            }, {
                id: options.id,
            },
                function (responseResult) {
                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function restoreProcess(options) {
            var deferred = $q.defer();
            resourceRestoreProcess.update({
                owner: options.owner,
                id: options.id
            }, {
                id: options.id,
            },
                function (responseResult) {
                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function restoreControl(options) {
            var deferred = $q.defer();
            resourceRestoreControl.update({
                owner: options.owner,
                id: options.id
            }, {
                id: options.id,
            },
                function (responseResult) {
                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getFilters(options) {
            var deferred = $q.defer();

            return (deferred.promise);
        }


        var resourceRisks = $resource(COMMON.BASE_API + "/owner/:owner/risk?withProcesses", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            },

            post: {
                method: "POST",
                isArray: false
            },

            delete: {
                method: "DELETE",
                isArray: false
            },
        });
        var resourceRisksID = $resource(COMMON.BASE_API + "/owner/:owner/risk/:id", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            },
            put: {
                method: "PUT",
                isArray: false
            },
            delete: {
                method: "DELETE",
                isArray: false
            }
        });

        var resourceActiveRisk = $resource(COMMON.BASE_API + "/owner/:owner/activeTree/risk/:id?withProcesses", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        });
        var resourceRisk = $resource(COMMON.BASE_API + "/owner/:owner/risk?id=:id", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            },
            post: {
                method: "POST",
                isArray: false
            },
            put: {
                method: "PUT",
                isArray: false
            },
            delete: {
                method: "DELETE",
                isArray: false
            }
        });


        var resourceActivateRisk = $resource(COMMON.BASE_API + "/owner/:owner/risk/makeActive", {
            // No default data
        }, {
            post: {
                method: "POST",
                isArray: true
            }
        });

        var resourceProcess = $resource(COMMON.BASE_API + "/owner/:owner/process/:id", {
            // No default data
        }, {
            post: {
                method: "POST",
                isArray: false
            },
            update: {
                method: "PUT",
                isArray: false
            },
            delete: {
                method: "DELETE",
                isArray: false
            }
        });
        var resourceRestoreProcess = $resource(COMMON.BASE_API + "/owner/:owner/process/:id/restore", {
            // No default data
        }, {
            update: {
                method: "PUT",
                isArray: false
            }
        });
        var resourceControl = $resource(COMMON.BASE_API + "/owner/:owner/control/:id", {
            // No default data
        }, {
            post: {
                method: "POST",
                isArray: false
            },
            update: {
                method: "PUT",
                isArray: false
            },
            delete: {
                method: "DELETE",
                isArray: false
            }
        });
        var resourceRestoreControl = $resource(COMMON.BASE_API + "/owner/:owner/control/:id/restore", {
            // No default data
        }, {
            update: {
                method: "PUT",
                isArray: false
            }
        });
        var resourceProcessInRisk = $resource(COMMON.BASE_API + "/owner/:owner/risk/:risk_id/process", {
            // No default data
        }, {
            post: {
                method: "POST",
                isArray: true
            }
        });

        var currentRegion = $filter('filter')(sessionService.config.regions, { id: sessionService.user.region_id }, true)[0];

        function setCurrentRegion(region) {
            currentRegion = region;
        }

        return ({
            get: getRisks,
            getRiskActive: getRiskActive,
            getRiskById: getRiskById,
            activateRisk: activateRisk,
            createProcess: createProcess,
            createControl: createControl,
            createProcessInRisk: createProcessInRisk,
            getrisk: getrisk,
            deleteRisk: deleteRisk,
            deleteControl: deleteControl,
            deleteProcess: deleteProcess,
            restoreProcess: restoreProcess,
            updateProcess: updateProcess,
            updateControl: updateControl,
            restoreControl: restoreControl,
            createRisk: createRisk,
            updaterisk: updaterisk,
            getFilters: getFilters,
            setCurrentRegion: setCurrentRegion,
            currentRegion: currentRegion
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ScrumboardController', ScrumboardController);

    /** @ngInject */
    function ScrumboardController($mdSidenav, BoardService, BoardList, CardFilters)
    {
        var vm = this;

        // Data
        vm.currentView = 'board';
        vm.board = BoardService.data;
        vm.boardList = BoardList.data;
        vm.boardSelectorVisible = false;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.updateBoardUri = updateBoardUri;
        vm.clearFilters = CardFilters.clear;
        vm.filteringIsOn = CardFilters.isOn;

        ////////

        /**
         * Update Board Uri
         *
         * Once you connect your app to your server,
         * you would do this on your API server.
         */
        function updateBoardUri()
        {
            if ( vm.boardList.getById(vm.board.id) )
            {
                vm.boardList.getById(vm.board.id).name = vm.board.name;
                vm.boardList.getById(vm.board.id).uri = vm.board.uri = encodeURIComponent(vm.board.name).replace(/%20/g, '-').toLowerCase();
            }
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };

    }
})();

(function () {
    'use strict';

    angular
        .module('app.riskmap')
        .controller('RiskMapController', RiskMapController);

    /** @ngInject */
    function RiskMapController($scope, $rootScope, $stateParams, $translate, $document, $mdDialog,
        $mdMedia, $mdSidenav, $state, msApi, tinyMceService, companyService, riskMapService, requestContext,
        transformClients, mediaService, Upload, $timeout, sessionService, msUtils, html2canvasAngular) {
        $scope.ignore = false;
        $scope.owner = $stateParams.owner;
        var vm = this;
        vm.userLogued = sessionService.getUser();
        vm.branding = msUtils.getBranding();
        $scope.loadingMapProcess = false;
        vm.colors = [
            '#007bff',
            '#6c757d',
            '#28a745',
            '#dc3545',
            '#fac107',
            '#17a2b8',
            '#6c757d',
            '#343a40'
        ];
        vm.isLoading = true;
        vm.is_inherent = $state.params.isInherent ? true : false;
        var dateCurrentMonth = new Date();
        var firstDay = new Date(dateCurrentMonth.getFullYear(), dateCurrentMonth.getMonth(), 1);
        var lastDay = new Date(dateCurrentMonth.getFullYear(), dateCurrentMonth.getMonth() + 1, 0);
        vm.currentFilter = {
            owner: $stateParams.owner,
            company_id: null,
            branch_id: null,
            fromDate: vm.is_inherent ? null : moment(firstDay).format('YYYY-MM-DD'),
            toDate: vm.is_inherent ? null : moment(lastDay).format('YYYY-MM-DD')
        };
        vm.currentFilterProgression = {
            owner: $stateParams.owner,
            company_id: null,
            branch_id: null,
            fromDate: vm.is_inherent ? null : moment(firstDay).format('YYYY-MM-DD'),
            toDate: vm.is_inherent ? null : moment(lastDay).format('YYYY-MM-DD')
        };

        vm.resizeChart = resizeChart;
        vm.currentRisk = null;
        vm.views = {
            split: 'app/main/apps/riskmap/views/main/split-view.html',
            nosplit: 'app/main/apps/riskmap/views/main/nosplit-view.html'
        };
        vm.defaultView = 'split';
        vm.currentView = 'split';

        vm.firstLoad = true;
        vm.risksMap = undefined;
        vm.companySelected = '';
        vm.branchSelected = undefined;
        vm.searchBranchText = '';
        vm.companyBranches = [];

        vm.defaultRiskOrder = {
            sort: 'computed_process',
            sortReverse: true,
            sortSelect: '_computed_process',
            filter: {}

        }
        vm.riskOrder = angular.copy(vm.defaultRiskOrder);
        vm.translate = msUtils.translate;
        vm.timeAgo = msUtils.timeAgo;
        vm.tinymceOptions = tinyMceService.getOptions($scope);

        $scope.$watch(
            function () {
                if (document.getElementById('snaphost')) {
                    return [document.getElementById('snaphost').offsetWidth, document.getElementById('snaphost').offsetHeight].join('x');
                } else {
                    return false;
                }
            },
            function (value) {
                if (value) {
                    resizeChart(window.innerWidth < 600 ? true : false)
                }
            }
        )


        function resizeChart(mov) {
            if (mov) {
                vm.optionsDonut = {
                    chart: {
                        type: 'pieChart',
                        height: 300,
                        width: '100%',
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: -100,
                            left: 0
                        },
                        donut: true,
                        x: function (d) { return d.key; },
                        y: function (d) { return d.y; },
                        showLabels: false,
                        showLegend: false,
                        pie: {
                            startAngle: function (d) { return d.startAngle / 2 - Math.PI / 2 },
                            endAngle: function (d) { return d.endAngle / 2 - Math.PI / 2 }
                        },
                        duration: 500,
                        tooltip: {
                            enabled: false
                        }
                    }
                };
            } else {
                vm.optionsDonut = {
                    chart: {
                        type: 'pieChart',
                        height: 480,
                        width: $('#snaphost').width() / 2,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: -280,
                            left: 0
                        },
                        donut: true,
                        x: function (d) { return d.key; },
                        y: function (d) { return d.y; },
                        showLabels: false,
                        showLegend: false,
                        pie: {
                            startAngle: function (d) { return d.startAngle / 2 - Math.PI / 2 },
                            endAngle: function (d) { return d.endAngle / 2 - Math.PI / 2 }
                        },
                        duration: 500,
                        tooltip: {
                            enabled: false
                        }
                    }
                };
            }
            vm.optionsChart = {
                chart: {
                    type: 'lineChart',
                    height: 450,
                    width: $('#monthly_chart').width(),
                    margin: {
                        top: 40,
                        right: 60,
                        bottom: 60,
                        left: 75
                    },
                    x: function (d) { return d ? d.x : null },
                    y: function (d) { return d ? d.y : null },
                    useInteractiveGuideline: true,
                    xAxis: {
                        axisLabel: vm.translate('GLOBAL.MONTHS'),
                        tickFormat: function (d) {
                            if (vm.d3DataRisks[0].values.length > vm.d3DataRisks[0].values.length - 1 - d && (vm.d3DataRisks[0].values.length - 1 - d) > 0) {
                                var dx = vm.d3DataRisks[0].values[vm.d3DataRisks[0].values.length - 1 - d];
                                dx.label = dx.label.charAt(0).toUpperCase() + dx.label.slice(1);
                                return dx.label
                            }
                            return '';
                        }
                    },
                    yAxis: {
                        tickValues: [0, 16, 36, 60, 100],
                        axisLabel: vm.translate('RISK.RISK'),
                        tickFormat: function (d) {
                            return d + '%';
                        },
                        axisLabelDistance: -10
                    },
                    forceY: [0, 100],
                },
            };
            vm.optionsDonutBranches = {
                chart: {
                    type: 'pieChart',
                    height: 300,
                    width: $('#branch-donut').width(),
                    margin: {
                        top: 0,
                        right: 0,
                        bottom: -100,
                        left: 0
                    },
                    donut: true,
                    x: function (d) { return d.key; },
                    y: function (d) { return d.y; },
                    showLabels: false,
                    showLegend: false,
                    pie: {
                        startAngle: function (d) { return d.startAngle / 2 - Math.PI / 2 },
                        endAngle: function (d) { return d.endAngle / 2 - Math.PI / 2 }
                    },
                    duration: 500,
                    tooltip: {
                        enabled: false
                    }
                }
            };
        }
        $scope.$watch(function () {
            return $mdMedia('max-width: 600px');
        }, function (mov) {
            resizeChart(mov);
        });




        vm.d3Data = {};
        vm.d3DataRisks = [];
        vm.riskChartType = 'global';

        vm.calculateMapByCompany = calculateMapByCompany;
        vm.saveCanvas = saveCanvas;
        vm.saveCanvasPDF = saveCanvasPDF;
        vm.changeView = changeView;
        vm.updateCompany = updateCompany;
        vm.setCompanyBranches = setCompanyBranches;
        vm.isCompanySelected = isCompanySelected;
        vm.isBranchSelected = isBranchSelected;
        vm.selectBranch = selectBranch;
        vm.getRiskMap = getRiskMap;
        vm.setRiskMapDate = setRiskMapDate;
        vm.setCurrentRiskMap = setCurrentRiskMap;
        vm.riskLevelPercent = riskLevelPercent;
        vm.riskLevelColor = riskLevelColor;
        vm.forceRealodChart = forceRealodChart;
        vm.riskLevelClass = riskLevelClass;
        vm.riskLevelPercentage = riskLevelPercentage;
        vm.riskLevelText = riskLevelText;
        vm.branchName = branchName;
        vm.getChartValues = getChartValues;
        vm.getChartDates = getChartDates;
        vm.getChartColors = getChartColors;
        vm.riskMapDate = riskMapDate;
        vm.riskMapUpdateDate = riskMapUpdateDate;
        vm.formatDate = formatDate;
        vm.formatDateFull = formatDateFull;
        vm.processRiskTable = processRiskTable;
        vm.showRiskTable = showRiskTable;
        vm.riskOrderChange = riskOrderChange;
        vm.risksFilterChange = risksFilterChange;
        vm.d3DataProcess = d3DataProcess;
        vm.risksHasFilter = risksHasFilter;
        vm.editRisk = editRisk;
        vm.forceChartRedraw = forceChartRedraw;
        vm.forceCompleteChartRefresh = forceCompleteChartRefresh;
        vm.saveCanvas = saveCanvas;
        vm.setRiskDataForChart = setRiskDataForChart;

        var companySelectEvent = $rootScope.$on('company-selected', function (event) {
            vm.showChart = false;
            vm.showChartProgression = false;
            vm.updateCompany();
        });

        $scope.$on('$destroy', companySelectEvent);

        //////////

        $scope.$on('pagination:loadStart', function (event) {
            $scope.isLoading = true;
        });

        $scope.$on('pagination:loadPage', function (event) {
            $scope.isLoading = false;
        });


        init();

        /////////////////

        function init() {
            if (sessionService.get('companySelected')) {
                $rootScope.$broadcast('company-selected');
            }
            vm.isLoading = false;
        }

        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'split';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big) {
                vm.currentView = 'split';
            }

        });

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small) {
                vm.currentView = 'split';
            }

        });

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                if (vm.defaultView === 'split') {
                    vm.currentView = 'split';
                }
            }
        });


        /**
         * Change the view
         *
         * @param view
         */
        function changeView(view) {
            if (vm.views[view]) {
                vm.defaultView = view;
                vm.currentView = view;
            }
        }

        ////////////////////

        function updateCompany() {
            $scope.isLoading = true;
            vm.risksMap = [];
            vm.companySelected = sessionService.get('companySelected');
            vm.currentFilter.company_id = vm.companySelected.id;
            vm.branchSelected = undefined;
            vm.searchBranchText = '';
            var options = {
                owner: $scope.owner,
                company_id: vm.companySelected.id
            }
            riskMapService.getAvailableDates(options).then(function (dates) {
                vm.datesAvailables = dates.result;
                vm.selectedDate = moment(vm.datesAvailables[0].date).format('YYYY-MM-DD');
                companyService.setCompanyId(vm.companySelected.id);
                companyService.getBranches({
                    owner: $scope.owner,
                    company_id: vm.companySelected.id
                })
                    .then(function (branchesResponse) {
                        $scope.isLoading = false;
                        if (branchesResponse.total > 0) {
                            vm.setCompanyBranches(branchesResponse.data);
                            vm.getRiskMap();
                        }
                        else {
                            vm.branchSelected = undefined;
                            vm.searchBranchText = '';
                            vm.companyBranches = [];
                        }
                    });
            })

        }


        function isCompanySelected() {
            if (angular.isObject(vm.companySelected)) {
                return true;
            }
            return false;
        }

        function isBranchSelected() {
            if (companyService.branch) {
                return true;
            }
            return false;
        }

        function selectBranch(branch, idBranch) {
            vm.showChart = false;
            vm.showChartProgression = false;
            var branchId = undefined;
            if (idBranch) {
                var branch = undefined;
                angular.forEach(vm.companyBranches, function (br) {
                    if (br.id == idBranch) {
                        branch = br;
                    }
                })
            }
            if (branch) {
                branchId = branch.id
                companyService.setBranch(branch)
            }
            vm.branchSelected = branch;
            vm.searchBranchText = '';
            vm.currentFilter.branch_id = branchId;
            vm.getRiskMap();
        }

        function setCompanyBranches(branches) {
            vm.companyBranches = branches;
            vm.branchSelected = '';
        }

        function forceRealodChart() {
            resizeChart(window.innerWidth < 600 ? true : false)
        }

        function forceChartRedraw() {
            vm.showChart = false;
            
            $timeout(function() {
                vm.showChart = true;
                
                $timeout(function() {
                    vm.forceRealodChart();
                    
                    $timeout(function() {
                        var nvd3Charts = document.querySelectorAll('nvd3');
                        angular.forEach(nvd3Charts, function(chart) {
                            var chartScope = angular.element(chart).scope();
                            if (chartScope && chartScope.api) {
                                chartScope.api.update();
                            }
                        });
                        
                        vm.forceRealodChart();
                    }, 200);
                }, 100);
            }, 50);
        }

        function forceCompleteChartRefresh() {
            if (vm.currentRiskMap) {
                vm.d3DataProcess(vm.currentRiskMap);
                
                vm.showChart = false;
                
                $timeout(function() {
                    vm.showChart = true;
                    
                    $timeout(function() {
                        vm.forceRealodChart();
                        
                        $timeout(function() {
                            var nvd3Charts = document.querySelectorAll('nvd3');
                            angular.forEach(nvd3Charts, function(chart) {
                                var chartScope = angular.element(chart).scope();
                                if (chartScope && chartScope.api) {
                                    chartScope.api.update();
                                }
                            });
                        }, 100);
                    }, 100);
                }, 50);
            }
        }
        function getRiskMap() {
            vm.currentRiskMap = undefined;
            vm.d3Data = {};
            vm.loadingData = true;
            vm.currentFilter.company_id = vm.companySelected.id
            if (vm.branchSelected) {
                vm.currentFilter.branch_id = vm.branchSelected.id
                delete vm.currentFilter.company_id;
            } else {
                delete vm.currentFilter.branch_id;
            }
            riskMapService.get(vm.currentFilter)
                .then(function (response) {
                    vm.risksMap = response.result;
                    if (vm.risksMap.length > 0) {
                        vm.setCurrentRiskMap(vm.risksMap[0]);
                    }
                    vm.loadingData = false;
                    $timeout(() => {
                        vm.showChart = true
                    }, 100);
                }, function (er) {
                    vm.loadingData = false;
                });
            if (!vm.is_inherent) {
                vm.currentFilterProgression.company_id = vm.companySelected.id
                if (vm.branchSelected) {
                    vm.currentFilterProgression.branch_id = vm.branchSelected.id
                    delete vm.currentFilterProgression.company_id;
                } else {
                    delete vm.currentFilterProgression.branch_id;
                }

                var firstDate = moment(vm.datesAvailables[vm.datesAvailables.length - 1].date).format('YYYY-MM-DD');
                vm.currentFilterProgression.fromDate = firstDate;
                riskMapService.get(vm.currentFilterProgression)
                    .then(function (response) {
                        vm.risksMapProgression = response.result;
                        vm.d3DataRisks = vm.setRiskDataForChart()
                        $timeout(() => {
                            vm.showChartProgression = true
                        }, 100);
                    }, function (er) {
                        vm.loadingData = false;
                    });
            }
        }




        function setRiskDataForChart() {
            var arrData = []
            var arrBranches = {};
            angular.forEach(vm.companyBranches, function (branch) {
                arrBranches[branch.id] = [];
            })
            angular.forEach(vm.risksMapProgression, function (showData, i) {
                arrData.push({
                    x: vm.risksMapProgression.length - 1 - i,
                    y: ((showData.average * 100) / 25),
                    label: vm.formatDate(showData.valid_until)
                })
                angular.forEach(showData.branches, function (branch) {
                    arrBranches[branch.branch_id].push({
                        x: vm.risksMapProgression.length - 1 - i,
                        y: ((branch.average * 100) / 25),
                        label: vm.formatDate(branch.valid_until)
                    })
                })
            })
            var mainLabel = vm.translate('RISKMAP.CHART_GLOBAL');
            if (vm.branchSelected) {
                var mainLabel = vm.branchName(vm.branchSelected.id);
            }

            var returnArr = [
                {
                    values: arrData,
                    key: mainLabel,
                    color: '#cdcdcd',
                    classed: 'line-global',
                    area: true
                }
            ];
            if (!vm.branchSelected) {
                var copyColors = angular.copy(vm.colors);

                angular.forEach(vm.companyBranches, function (branch) {
                    var random = Math.floor(Math.random() * copyColors.length);
                    var selectedColor = copyColors.splice(random, 1);
                    returnArr.push({
                        values: arrBranches[branch.id],
                        key: vm.branchName(branch.id),
                        color: selectedColor,
                        classed: 'line-branches',
                        disabled: false
                    })
                })
            }
            return returnArr;

        }
        function setRiskMapDate(riskMapDate) {
            var newRiskMap = '';
            var date = moment(riskMapDate).utc();
            vm.selectedDate = date.format('YYYY-MM-DD');
            var firstDay = date.startOf('month').format('YYYY-MM-DD');
            var lastDay = date.endOf('month').format('YYYY-MM-DD');;
            vm.currentFilter.fromDate = firstDay;
            vm.currentFilter.toDate = lastDay;
            vm.showChart = false;
            vm.showChartProgression = false;
            $scope.loadingMapProcess = false;
            vm.getRiskMap();
        }

        function setCurrentRiskMap(riskMap) {
            vm.riskOrder = angular.copy(vm.defaultRiskOrder);
            vm.currentRiskMap = riskMap;
            vm.d3Data[0] = vm.d3DataProcess(vm.currentRiskMap);
            angular.forEach(riskMap.branches, function (branch) {
                vm.d3Data[branch.branch_id] = vm.d3DataProcess(branch);
            })
            vm.processRiskTable();
        }

        function d3DataProcess(riskMap) {
            return [
                {
                    key: vm.riskLevelPercent(riskMap.average),
                    y: riskMap.average,
                    color: vm.riskLevelColor(riskMap.average)
                },
                {
                    key: '',
                    y: (25 - (riskMap.average * 1)),
                    color: '#EFEFEF'
                }
            ];
        }

        function riskLevelPercent(average) {
            return average;
            // return ((average * 100) / 25) + '%';
        }
        function riskLevelColor(average) {
            // if (average >= 1 && average <= 4) {
            //     return 'green';
            // } else if (average >= 5 && average <= 9) {
            //     return 'yellow';
            // } else if (average >= 10 && average <= 15) {
            //     return 'orange';
            // } else if (average >= 16 && average <= 25) {
            //     return 'red';
            // }
            switch (true) {
                case average == 1:
                    return 'rgb(98,198,153)';
                case average == 2:
                    return 'rgb(148,222,146)';
                case average == 3:
                    return 'rgb(148,215,146)';
                case average == 4:
                    return 'rgb(210,236,152)';
                case average == 5:
                    return 'rgb(255,243,173)';
                case average == 6 || average == 7:
                    return 'rgb(255,246,163)';
                case average == 8:
                    return 'rgb(255,234,143)';
                case average == 9:
                    return 'rgb(255,224,108)';
                case average == 10 || average == 11:
                    return 'rgb(255,205,105)';
                case average == 12 || average == 13 || average == 14:
                    return 'rgb(255,198,113)';
                case average == 15:
                    return 'rgb(253,174,97)';
                case average == 16 || average == 17 || average == 18 || average == 19:
                    return 'rgb(236,110,116)';
                case average == 20 || average == 21 || average == 22 || average == 23 || average == 24:
                    return 'rgb(232,81,88)';
                case average == 25:
                    return 'rgb(209,45,65)';
                default:
                    return null;
            }

        }

        function riskLevelClass(average) {
            switch (true) {
                case average == 1:
                    return 'green-one-bg';
                case average == 2:
                    return 'green-two-bg';
                case average == 3:
                    return 'green-three-bg';
                case average == 4:
                    return 'green-four-bg';
                case average == 5:
                    return 'yellow-one-bg';
                case average == 6 || average == 7:
                    return 'yellow-two-bg';
                case average == 8:
                    return 'yellow-three-bg';
                case average == 9:
                    return 'yellow-four-bg';
                case average == 10 || average == 11:
                    return 'yellow-five-bg';
                case average == 12 || average == 13 || average == 14:
                    return 'orange-one-bg';
                case average == 15:
                    return 'orange-two-bg';
                case average == 16 || average == 17 || average == 18 || average == 19:
                    return 'red-one-bg';
                case average == 20 || average == 21 || average == 22 || average == 23 || average == 24:
                    return 'red-two-bg';
                case average == 25:
                    return 'red-three-bg';
                default:
                    return null;
            }
        }
        function riskLevelPercentage(average) {
            // var percentage;
            // if (average >= 1 && average <= 4) {
            //     percentage = '20%';
            // } else if (average >= 5 && average <= 9) {
            //     percentage = '40%';
            // } else if (average >= 10 && average <= 15) {
            //     percentage = '60%';
            // } else if (average >= 16 && average < 25) {
            //     percentage = '80%';
            // } else if (average == 25) {
            //     percentage = '100%';
            // }
            // return average * 4 + '%';
            return average;
        }

        function calculateMapByCompany() {
            $scope.loadingMapProcess = true;
            var date = new Date();
            var options = {
                owner: $scope.owner,
                company_id: vm.companySelected.id,
                year: date.getFullYear(),
                month: date.getMonth() + 1
            };
            riskMapService.calculateMapByCompany(options).then(function (response) {
                vm.showChart = false;
                vm.showChartProgression = false;
                $scope.loadingMapProcess = false;
                vm.updateCompany();
            })
        }

        function riskLevelText(average) {
            var txt;
            if (average >= 1 && average <= 4) {
                txt = $translate.instant('RISK.RISK_LOW');
            } else if (average >= 5 && average <= 9) {
                txt = $translate.instant('RISK.RISK_MEDIUM');
            } else if (average >= 10 && average <= 15) {
                txt = $translate.instant('RISK.RISK_HIGH');
            } else if (average >= 16 && average <= 25) {
                txt = $translate.instant('RISK.RISK_VERY_HIGH');
            }
            return txt;
        }

        function branchName(branchId) {
            var branchName = '';
            angular.forEach(vm.companyBranches, function (branch) {
                if (branch.id == branchId) {
                    branchName = branch.name
                }
            })
            return branchName;
        }

        function getChartValues(color) {
            var chartValues = '';
            angular.forEach(vm.risksMap, function (risk) {
                if (color) {
                    var average = risk.average;
                    if (color == 'green' && (average >= 1 && average <= 4)) {
                        chartValues += risk.average + ',';
                    } else if (color == 'yellow' && (average >= 5 && average <= 9)) {
                        chartValues += risk.average + ',';
                    } else if (color == 'orange' && (average >= 10 && average <= 15)) {
                        chartValues += risk.average + ',';
                    } else if (color == 'red' && (average >= 16 && average <= 25)) {
                        chartValues += risk.average + ',';
                    }
                    else {
                        chartValues += 0 + ',';
                    }
                } else {
                    chartValues += risk.average + ',';
                }
            })
            chartValues = chartValues.substr(0, (chartValues.length - 1))
            return chartValues;
        }

        function getChartDates() {
            var chartValues = '';
            angular.forEach(vm.risksMap, function (risk) {
                chartValues += moment.utc(risk.valid_until).format('MMMM YYYY') + ',';
            })
            return chartValues;
        }

        function getChartColors() {
            var chartValues = '';
            angular.forEach(vm.risksMap, function (risk) {
                chartValues += vm.riskLevelColor(risk.average) + ',';
            })
            return chartValues;
        }

        function riskMapDate() {
            return moment.utc(vm.currentRiskMap.valid_until).format('MMMM YYYY');
        }
        function riskMapUpdateDate() {
            return moment.utc(vm.currentRiskMap.risk_map[vm.currentRiskMap.risk_map.length - 1].updated_at).format('DD-MM-YYYY');
        }

        function formatDate(curDate) {
            return moment.utc(curDate).format('MMMM YYYY');
        }
        function formatDateFull(curDate) {
            return moment.utc(curDate).format('YYYY-MM-DD');
        }

        function processRiskTable() {
            vm.riskTable = {};
            angular.forEach(vm.currentRiskMap.risk_map, function (activeRisk) {
                if (angular.isUndefined(vm.riskTable[activeRisk.process_probability])) {
                    vm.riskTable[activeRisk.process_probability] = {}
                }
                if (angular.isUndefined(vm.riskTable[activeRisk.process_probability][activeRisk.risk_impact])) {
                    vm.riskTable[activeRisk.process_probability][activeRisk.risk_impact] = 0
                }
                vm.riskTable[activeRisk.process_probability][activeRisk.risk_impact]++;
            })
        }

        function showRiskTable(probability, impact) {
            var showNumber = '';
            if (!angular.isUndefined(vm.riskTable[probability]) && !angular.isUndefined(vm.riskTable[probability][impact])) {
                showNumber = vm.riskTable[probability][impact];
            }
            if (showNumber) {
                showNumber += ' <span class="risk-table-label">' + (showNumber > 1 ? vm.translate('RISKMAP.RISKS') : vm.translate('RISKMAP.RISK')) + '</span>';
            }
            return showNumber;
        }

        function riskOrderChange() {
            if (vm.riskOrder.sortSelect.substr(0, 1) == '_') {
                vm.riskOrder.sortReverse = true;
                vm.riskOrder.sort = vm.riskOrder.sortSelect.substr(1);
            } else {
                vm.riskOrder.sortReverse = false;
                vm.riskOrder.sort = vm.riskOrder.sortSelect;
            }
        }

        function risksFilterChange(probability, impact) {
            var newFilter = {}
            if (probability) {
                newFilter.process_probability = probability;
            }
            if (impact) {
                newFilter.risk_impact = impact;
            }
            vm.riskOrder.filter = newFilter;
        }



        function risksHasFilter() {
            var len = 0;
            angular.forEach(vm.riskOrder.filter, function (f) {
                len++
            })
            return len;
        }

        function editRisk(risk) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/riskmap/views/dialogs/edit-risk-dialog.html',
                controller: 'RiskMapEditRiskDialogController',
                controllerAs: 'vm',
                locals: {
                    risk: risk,
                    owner: $scope.owner
                },
                clickOutsideToClose: false
            }).then(function (updatedRisk) {
                vm.getRiskMap();
                
                $timeout(function() {
                    vm.forceCompleteChartRefresh();
                }, 800);
            });
        }

        function saveCanvas(id, background, height) {
            $scope.isLoading = true;
            if (!$scope.capturing) {
                $scope.capturing = true;
                html2canvasAngular.renderElement(document.getElementById(id), background, height).then(function (canvas) {
                    canvas.id = "canvas-to-remove";
                    document.body.appendChild(canvas);
                    html2canvasAngular.renderElement(document.getElementById(id), background, height).then(function (canvas) {
                        var imgdata = canvas.toDataURL();
                        var download = document.createElement('a');
                        download.href = imgdata;
                        download.download = 'canvas.png';
                        download.click();
                        $scope.capturing = false;
                        var element = document.getElementById("canvas-to-remove");
                        document.body.removeChild(element);
                        $scope.isLoading = false;
                        $scope.ignore = false;

                    });
                });
            }
        }
        function saveCanvasPDF(id) {
            $scope.isLoading = true;
            if (!$scope.capturing) {
                $scope.capturing = true;
                html2canvasAngular.renderElement(document.getElementById(id)).then(function (canvas) {
                    canvas.id = "canvas-to-remove";
                    document.body.appendChild(canvas);
                    html2canvasAngular.renderElement(document.getElementById(id)).then(function (canvas) {
                        var imgData = canvas.toDataURL("image/jpeg", 1.0);
                        var pdf = new jsPDF();
                        pdf.addImage(imgData, 'JPEG', 15, 15, 180, 500);
                        pdf.save("download.pdf");
                        $scope.capturing = false;
                        var element = document.getElementById("canvas-to-remove");
                        document.body.removeChild(element);
                        $scope.isLoading = false;
                    });
                });
            }
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.riskmap')
        .service('riskMapService', riskMapService);

    /** @ngInject */
    // I provide access to the session store.
    function riskMapService($q, $resource, settingsDomainService, sessionService, companyService, COMMON, $rootScope, $window, $mdToast) {

        function getRisksMap(options) {
            var deferred = $q.defer();
            var filters = [];

            resourceRisksMap.get(options,
                function (responseResult) {
                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getAvailableDates(options) {
            var deferred = $q.defer();
            var filters = [];

            resourceAvailableDates.get(options,
                function (responseResult) {
                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function calculateMap(options) {
            var deferred = $q.defer();
            resourceCalculate.post(options, options,
                function (responseResult) {
                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function calculateMapByCompany(options) {
            var deferred = $q.defer();
            resourceCalculateCompany.post(options, options,
                function (responseResult) {
                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateRiskValues(owner, activeRiskId, values) {
            var deferred = $q.defer();

            resourceUpdateRisk.put({
                owner: owner,
                activeRiskId: activeRiskId
            }, {
                reputation_impact: values.reputation_impact,
                penal_code_impact: values.penal_code_impact,
                client_loss: values.client_loss
            },
            function (responseResult) {
                deferred.resolve({
                    result: responseResult
                });
            },
            function (e) {
                deferred.reject(e);
            });

            // Return the promise.
            return (deferred.promise);
        }

        function updateRiskMapItem(owner, riskMapId, values) {
            var deferred = $q.defer();

            resourceUpdateRiskMap.put({
                owner: owner,
                riskMapId: riskMapId
            }, {
                reputation_impact: values.reputation_impact,
                penal_code_impact: values.penal_code_impact,
                client_loss: values.client_loss,
                risk_impact: values.risk_impact,
                process_odds_of_occurrence: values.process_odds_of_occurrence,
                evidence_average: values.evidence_average,
                process_probability: values.process_probability,
                computed_process: values.computed_process
            },
            function (responseResult) {
                deferred.resolve({
                    result: responseResult
                });
            },
            function (e) {
                deferred.reject(e);
            });

            return deferred.promise;
        }

        function getFilters(options) {
            var deferred = $q.defer();

            return (deferred.promise);
        }

        var resourceCalculate = $resource(COMMON.BASE_API + "/owner/:owner/riskMap/calculateAll", {
            // No default data
        }, {
                post: {
                    method: "POST"
                }
            });

        var resourceCalculateCompany = $resource(COMMON.BASE_API + "/owner/:owner/riskMap/calculateCompany", {
            // No default data
        }, {
                post: {
                    method: "POST"
                }
            });
        var resourceRisksMap = $resource(COMMON.BASE_API + "/owner/:owner/riskMap", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: true
                }
            });
        var resourceAvailableDates = $resource(COMMON.BASE_API + "/owner/:owner/riskMap/availableDates", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: true
                }
            });

        var resourceUpdateRisk = $resource(COMMON.BASE_API + "/owner/:owner/riskMap/:activeRiskId", {
            // No default data
        }, {
                put: {
                    method: "PUT"
                }
            });

        var resourceUpdateRiskMap = $resource(COMMON.BASE_API + "/owner/:owner/riskMap/item/:riskMapId", {
            // No default data
        }, {
            put: {
                method: "PUT"
            }
        });

        return ({
            get: getRisksMap,
            calculateMap: calculateMap,
            calculateMapByCompany: calculateMapByCompany,
            getAvailableDates: getAvailableDates,
            updateRiskValues: updateRiskValues,
            updateRiskMapItem: updateRiskMapItem,
            getFilters: getFilters,
        });

    }

})();
(function () {
    'use strict';

    angular
        .module('app.register-book')
        .service('registerBookService', registerBookService);

    /** @ngInject */
    function registerBookService($http, companyService, COMMON) {

        function getEntries(options) {
            var params = {
                company_id: options.company_id || companyService.getCompanyId(),
                resultsPerPage: options.resultsPerPage || 1000
            };

            if (options.page) {
                params.page = options.page;
            }

            return $http.get(COMMON.BASE_API + '/owner/' + options.owner + '/registerBook', {
                params: params
            }).then(function (response) {
                return {
                    data: decorateEntries(extractEntries(response.data)),
                    raw: response.data
                };
            });
        }

        function extractEntries(payload) {
            if (angular.isArray(payload)) {
                return payload;
            }

            if (payload && angular.isArray(payload.data)) {
                return payload.data;
            }

            if (payload && angular.isArray(payload.results)) {
                return payload.results;
            }

            if (payload && payload.data && angular.isArray(payload.data.results)) {
                return payload.data.results;
            }

            return [];
        }

        function decorateEntries(entries) {
            return entries.map(function (entry) {
                if (entry.created_at) {
                    entry.created_at_format = moment.utc(entry.created_at).local().format('DD MMM YYYY HH:mm');
                } else if (entry.created_at_format) {
                    entry.created_at_format = removeSecondsFromTime(entry.created_at_format);
                }

                if (entry.updated_at) {
                    entry.updated_at_format = moment.utc(entry.updated_at).local().format('DD MMM YYYY HH:mm');
                } else if (entry.updated_at_format) {
                    entry.updated_at_format = removeSecondsFromTime(entry.updated_at_format);
                }

                return entry;
            });
        }

        function removeSecondsFromTime(value) {
            return String(value).replace(/(\d{2}:\d{2}):\d{2}\b/, '$1');
        }

        function getComplaintReportPreSignedUrl(options) {
            return $http.post(
                COMMON.BASE_API + '/owner/' + options.owner + '/complaintReport/getS3ReportPreSignedUrl',
                {
                    report_id: options.report_id,
                    reportKey: options.reportKey
                }
            ).then(function (response) {
                return response.data;
            });
        }

        function createComplaintReport(options) {
            return $http.post(
                COMMON.BASE_API + '/owner/' + options.owner + '/complaintReport',
                options.item
            ).then(function (response) {
                return response.data;
            });
        }

        return ({
            get: getEntries,
            getEntries: getEntries,
            getComplaintReportPreSignedUrl: getComplaintReportPreSignedUrl,
            createComplaintReport: createComplaintReport,
            createCompanyRegisterBookReport: createComplaintReport
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.register-book')
        .controller('RegisterBookController', RegisterBookController);

    /** @ngInject */
    function RegisterBookController($scope, $rootScope, $state, $stateParams, $translate, $mdDialog, $mdMedia, $document, $mdToast, $timeout, $window,
        sessionService, complaintsService, registerBookService, companyService, fieldsTemplateForms, msUtils) {
        var vm = this;

        vm.owner = $stateParams.owner;
        var branding = msUtils.getBranding();
        vm.selectionAccentColor = (branding && branding.navigationColorBorder) ? branding.navigationColorBorder : '#d46537';
        vm.companySelected = sessionService.get('companySelected');
        vm.entries = [];
        vm.loading = false;
        vm.selected = null;
        vm.complaintFormsFiltered = null;
        vm.searchQuery = '';
        vm.statusFilter = null;
        vm.registerBookSearchExpanded = false;

        vm.processSteps = [
            { id: 2, labelKey: 'COMPLAINTS.NEW', icon: 'icon-file-document', colorClass: 'process-step-red' },
            { id: 1, labelKey: 'COMPLAINTS.REVIEW', icon: 'icon-magnify', colorClass: 'process-step-orange' },
            { id: 4, labelKey: 'COMPLAINTS.UNDER_INVESTIGATION', icon: 'icon-file-find', colorClass: 'process-step-blue' },
            { id: 5, labelKey: 'COMPLAINTS.REFERRED_TO_PROSECUTOR', icon: 'icon-gavel', colorClass: 'process-step-purple' },
            { id: 3, labelKey: 'COMPLAINTS.NOT_ADMITTED', icon: 'icon-file-outline', colorClass: 'process-step-grey' },
            { id: 0, labelKey: 'COMPLAINTS.CLOSED', icon: 'icon-check-circle', colorClass: 'process-step-green' }
        ];

        vm.translate = function (key) {
            return $translate.instant(key);
        };

        vm.isCompanySelected = function () {
            return angular.isObject(vm.companySelected);
        };

        vm.loadEntries = loadEntries;
        vm.selectEntry = selectEntry;
        vm.clearSelection = clearSelection;
        vm.openReportDialog = openReportDialog;
        vm.hasSelectedReportOutput = hasSelectedReportOutput;
        vm.openSelectedReportOutput = openSelectedReportOutput;
        vm.showMobileSelectionView = showMobileSelectionView;
        vm.generateRegisterBook = generateRegisterBook;
        vm.confirmTechnicalCertificate = confirmTechnicalCertificate;
        vm.getStatusStep = getStatusStep;
        vm.displayCaseRef = displayCaseRef;
        vm.registerBookSearchPredicate = registerBookSearchPredicate;
        vm.toggleRegisterBookSearch = toggleRegisterBookSearch;
        vm.onRegisterBookSearchBlur = onRegisterBookSearchBlur;
        vm.isRegisterBookSearchEmpty = isRegisterBookSearchEmpty;

        var companySelectEvent = $rootScope.$on('company-selected', function () {
            vm.companySelected = sessionService.get('companySelected');
            if (vm.companySelected) {
                companyService.setCompanyId(vm.companySelected.id);
            }
            vm.complaintFormsFiltered = null;
            vm.searchQuery = '';
            vm.statusFilter = null;
            vm.registerBookSearchExpanded = false;
            loadEntries();
        });

        var deregisterState = $rootScope.$on('$stateChangeSuccess', function () {
            syncSelectionFromRoute();
        });

        $scope.$on('$destroy', function () {
            companySelectEvent();
            deregisterState();
        });

        $scope.$watch(function () {
            return (vm.entries && vm.entries.length) ? vm.entries.length : 0;
        }, function () {
            syncSelectionFromRoute();
        });

        init();

        function init() {
            if (sessionService.get('companySelected')) {
                vm.companySelected = sessionService.get('companySelected');
                companyService.setCompanyId(vm.companySelected.id);
                loadEntries();
            }
            syncSelectionFromRoute();
        }

        function syncSelectionFromRoute() {
            var id = $state.params.id;
            if (!id || !vm.entries || !vm.entries.length) {
                vm.selected = null;
                return;
            }
            vm.selected = vm.entries.find(function (e) {
                return String(e.id) === String(id);
            }) || null;
        }

        function loadEntries() {
            if (!vm.isCompanySelected()) {
                vm.entries = [];
                vm.selected = null;
                return;
            }

            companyService.setCompanyId(vm.companySelected.id);
            vm.loading = true;

            registerBookService.get({
                owner: vm.owner,
                company_id: vm.companySelected.id,
                resultsPerPage: 1000
            }).then(function (res) {
                vm.entries = res.data || [];
                vm.loading = false;
                syncSelectionFromRoute();
            }, function () {
                vm.loading = false;
                vm.entries = [];
            });
        }

        function selectEntry(entry) {
            vm.selected = entry;
            $state.go('app.site_overview.register-book.list.entry', {
                owner: vm.owner,
                domain: $state.params.domain,
                id: entry.id
            }, { notify: true, inherit: true, location: true });
        }

        function clearSelection() {
            vm.selected = null;
            $state.go('app.site_overview.register-book.list', {
                owner: vm.owner,
                domain: $state.params.domain
            }, { notify: true, inherit: true, location: true });
        }

        function ensureFormsForReport(callback) {
            if (vm.complaintFormsFiltered && vm.complaintFormsFiltered.length) {
                callback();
                return;
            }
            Promise.all([
                complaintsService.getCanal({ owner: vm.owner, id: vm.companySelected.id }),
                complaintsService.getFormTypes({ owner: vm.owner, company_id: vm.companySelected.id })
            ]).then(function (res) {
                var complaintFormTypes = res[1].data;
                var complaintForms = res[0].data.map(function (x) {
                    return fieldsTemplateForms.DTOtoStructuredField(x);
                });
                var formFilters = ($rootScope.permissionsComplaints && angular.isArray($rootScope.permissionsComplaints))
                    ? $rootScope.permissionsComplaints.filter(function (x) {
                        return x.field === 'form_id';
                    })
                    : null;
                if (!formFilters) {
                    vm.complaintFormsFiltered = complaintForms.filter(function (x) {
                        x.subfilter = complaintFormTypes.filter(function (ct) {
                            return ct.form_id === x.id;
                        });
                        return true;
                    });
                } else {
                    vm.complaintFormsFiltered = complaintForms.filter(function (formRow) {
                        var found = formFilters.find(function (y) {
                            return y.value == formRow.id;
                        });
                        if (!formFilters || formFilters.length === 0 || found) {
                            if (found) {
                                formRow.subfilter = complaintFormTypes.filter(function (ct) {
                                    return ct.form_id == found.value && found.subfilter.find(function (y) {
                                        return y.value === ct.complaint_type_id;
                                    });
                                });
                            } else {
                                formRow.subfilter = complaintFormTypes.filter(function (ct) {
                                    return ct.form_id === formRow.id;
                                });
                            }
                            return true;
                        }
                        return false;
                    });
                }
                callback();
            });
        }

        function openReportDialog(ev) {
            if (!vm.selected) {
                return;
            }
            ensureFormsForReport(function () {
                if (!vm.complaintFormsFiltered || !vm.complaintFormsFiltered.length) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant('REGISTER_BOOK.NO_FORMS_FOR_REPORT'))
                            .position('top right')
                            .hideDelay(4000)
                            .parent('#content')
                    );
                    return;
                }
                $mdDialog.show({
                    controller: 'NewReportDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/complaints/dialogs/new-report-dialog/new-report-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        forms: vm.complaintFormsFiltered,
                        companySelected: vm.companySelected,
                        owner: vm.owner,
                        complaint: { id: vm.selected.id }
                    }
                }).then(function (res) {
                    if (res) {
                        loadEntries();
                    }
                });
            });
        }

        function generateRegisterBook(ev) {
            if (!vm.companySelected) {
                return;
            }

            $mdDialog.show({
                controller: 'RegisterBookReportDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/register-book/dialogs/create-report/register-book-report-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $mdMedia('xs') || $mdMedia('sm'),
                locals: {
                    companySelected: vm.companySelected,
                    owner: vm.owner
                }
            }).then(function (created) {
                if (created) {
                    var message = $translate.instant('COMPLAINTS.REPORT_CREATED_SUCCESSFULLY');
                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content bg-green">' + message + '</div></md-toast>',
                        hideDelay: 11000,
                        position: 'top right',
                        parent: '#content'
                    });
                }
            });
        }

        function confirmTechnicalCertificate(ev) {
            if (!vm.selected || !vm.companySelected) {
                return;
            }

            var confirm = $mdDialog.confirm()
                .title($translate.instant('GLOBAL.ARE_YOU_SURE'))
                .textContent($translate.instant('REGISTER_BOOK.TECHNICAL_CERTIFICATE_CONFIRM_MESSAGE'))
                .ariaLabel($translate.instant('REGISTER_BOOK.TECHNICAL_CERTIFICATE_ACTION'))
                .targetEvent(ev)
                .ok($translate.instant('GLOBAL.YES'))
                .cancel($translate.instant('GLOBAL.NO'));

            $mdDialog.show(confirm).then(function () {
                createTechnicalCertificate();
            }, angular.noop);
        }

        function createTechnicalCertificate() {
            var payload = {
                title: $translate.instant('REGISTER_BOOK.TECHNICAL_CERTIFICATE_TITLE'),
                report_type: 'company_certificate',
                company_id: vm.companySelected.id,
                language_code: normalizeLanguageCode(localStorage.getItem('LANG_CODE') || 'es'),
                config_data: {
                    show_company_logo: true,
                    show_certificate_badge: true
                }
            };

            var activeBrand = getActiveBrand();
            if (activeBrand) {
                payload.brand = activeBrand;
            }

            registerBookService.createComplaintReport({
                owner: vm.owner,
                item: payload
            }).then(function () {
                var message = $translate.instant('COMPLAINTS.REPORT_CREATED_SUCCESSFULLY');
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content bg-green">' + message + '</div></md-toast>',
                    hideDelay: 11000,
                    position: 'top right',
                    parent: '#content'
                });
            }, function () {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent($translate.instant('GLOBAL.ERROR'))
                        .position('top right')
                        .hideDelay(4000)
                        .parent('#content')
                );
            });
        }

        function getActiveBrand() {
            var activeBranding = msUtils.getBranding();
            var ownerBranding = msUtils.getBranding(vm.owner);

            if (!activeBranding || !ownerBranding) {
                return null;
            }

            if (!activeBranding.tenant || !ownerBranding.tenant) {
                return null;
            }

            if (normalizeIdentifier(activeBranding.tenant) !== normalizeIdentifier(ownerBranding.tenant)) {
                return null;
            }

            return vm.owner;
        }

        function normalizeIdentifier(value) {
            if (!value) {
                return '';
            }

            return String(value).trim().toLowerCase();
        }

        function normalizeLanguageCode(lang) {
            if (!lang) {
                return 'es';
            }

            return String(lang).trim().toLowerCase().split(/[_-]/)[0] || 'es';
        }

        function showMobileSelectionView() {
            return !!vm.selected && ($mdMedia('xs') || $mdMedia('sm'));
        }

        function hasSelectedReportOutput(key) {
            return !!getSelectedReportForKey(key);
        }

        function openSelectedReportOutput(key) {
            var report = getSelectedReportForKey(key);

            if (!report) {
                return;
            }

            registerBookService.getComplaintReportPreSignedUrl({
                owner: vm.owner,
                report_id: report.id,
                reportKey: key
            }).then(function (res) {
                if (res && res.url) {
                    if (key === 'html') {
                        openHtmlPreviewDialog(res.url);
                    } else {
                        $window.open(res.url, '_blank');
                    }
                }
            }, function () {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent($translate.instant('GLOBAL.ERROR'))
                        .position('top right')
                        .hideDelay(4000)
                        .parent('#content')
                );
            });
        }

        function openHtmlPreviewDialog(previewUrl) {
            $mdDialog.show({
                controller: 'RegisterBookPreviewDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/register-book/dialogs/preview/register-book-preview-dialog.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                fullscreen: $mdMedia('xs') || $mdMedia('sm'),
                locals: {
                    previewUrl: previewUrl
                }
            });
        }

        function getStatusStep(statusId) {
            return vm.processSteps.find(function (s) {
                return s.id === statusId;
            });
        }

        function getSelectedReportForKey(key) {
            if (!vm.selected || !angular.isArray(vm.selected.complaints_reports)) {
                return null;
            }

            var reports = vm.selected.complaints_reports.slice().sort(compareReportsDesc);

            for (var i = 0; i < reports.length; i++) {
                var report = reports[i];
                if (report && report.output && report.output.status && report.output[key]) {
                    return report;
                }
            }

            return null;
        }

        function compareReportsDesc(a, b) {
            return getReportSortValue(b) - getReportSortValue(a);
        }

        function getReportSortValue(report) {
            if (!report) {
                return 0;
            }

            var dateFields = ['executed_at', 'updated_at', 'created_at'];

            for (var i = 0; i < dateFields.length; i++) {
                var rawValue = report[dateFields[i]];
                if (rawValue && rawValue !== '0000-00-00' && rawValue !== '0000-00-00 00:00:00') {
                    var timeValue = new Date(rawValue).getTime();
                    if (!isNaN(timeValue)) {
                        return timeValue;
                    }
                }
            }

            return parseInt(report.id, 10) || 0;
        }

        function getVisibleElement(selectors) {
            var doc = $document[0];

            for (var i = 0; i < selectors.length; i++) {
                var nodes = doc.querySelectorAll(selectors[i]);
                for (var j = 0; j < nodes.length; j++) {
                    var node = nodes[j];
                    if (node && node.offsetParent !== null) {
                        return node;
                    }
                }
            }

            return null;
        }

        function displayCaseRef(entry) {
            if (!entry) {
                return '';
            }
            var cn = entry.case_number ? String(entry.case_number).trim() : '';
            if (cn) {
                return cn;
            }
            var subj = entry.subject ? String(entry.subject).trim() : '';
            if (subj) {
                return subj;
            }
            return '#' + entry.id;
        }

        function registerBookSearchPredicate(entry) {
            if (!matchesStatusFilter(entry)) {
                return false;
            }

            var q = (vm.searchQuery && String(vm.searchQuery).trim().toLowerCase()) || '';
            if (!q) {
                return true;
            }
            var ref = displayCaseRef(entry).toLowerCase();
            if (ref.indexOf(q) !== -1) {
                return true;
            }
            if (entry.created_at_format && String(entry.created_at_format).toLowerCase().indexOf(q) !== -1) {
                return true;
            }
            if (entry.updated_at_format && String(entry.updated_at_format).toLowerCase().indexOf(q) !== -1) {
                return true;
            }
            if (entry.case_number && String(entry.case_number).toLowerCase().indexOf(q) !== -1) {
                return true;
            }
            if (entry.subject && String(entry.subject).toLowerCase().indexOf(q) !== -1) {
                return true;
            }
            return String(entry.id).indexOf(q) !== -1;
        }

        function matchesStatusFilter(entry) {
            if (vm.statusFilter === null || angular.isUndefined(vm.statusFilter) || vm.statusFilter === '') {
                return true;
            }

            return String(entry.status) === String(vm.statusFilter);
        }

        function toggleRegisterBookSearch() {
            if (vm.registerBookSearchExpanded) {
                var qOpen = (vm.searchQuery && String(vm.searchQuery).trim()) || '';
                if (!qOpen) {
                    vm.registerBookSearchExpanded = false;
                    return;
                }
            } else {
                vm.registerBookSearchExpanded = true;
            }
            focusRegisterBookSearchInput();
        }

        function focusRegisterBookSearchInput() {
            $timeout(function () {
                var el = getVisibleElement([
                    '#site-register-book #register-book-search-input-mobile',
                    '#site-register-book #register-book-search-input'
                ]);
                if (el) {
                    el.focus();
                }
            }, 120);
        }

        function onRegisterBookSearchBlur() {
            $timeout(function () {
                var doc = $document[0];
                var ae = doc.activeElement;
                var searchBtn = getVisibleElement(['#site-register-book .register-book-hero-search-btn']);
                if (searchBtn && (ae === searchBtn || searchBtn.contains(ae))) {
                    return;
                }
                var field = getVisibleElement([
                    '#site-register-book .register-book-search-field-mobile',
                    '#site-register-book .register-book-search-field'
                ]);
                if (field && field.contains(ae)) {
                    return;
                }
                var qBlur = (vm.searchQuery && String(vm.searchQuery).trim()) || '';
                if (!qBlur) {
                    vm.registerBookSearchExpanded = false;
                }
            }, 150);
        }

        function isRegisterBookSearchEmpty() {
            if (vm.loading || !vm.entries || !vm.entries.length) {
                return false;
            }
            var q = (vm.searchQuery && String(vm.searchQuery).trim()) || '';
            if (!q) {
                return false;
            }
            for (var i = 0; i < vm.entries.length; i++) {
                if (registerBookSearchPredicate(vm.entries[i])) {
                    return false;
                }
            }
            return true;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.results', ['nvd3'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider , msUtilProvider, msNavigationServiceProvider) {
        // State


        $stateProvider.state('app.results', {
            url: '/results',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/results/resultsSROI.html',
                    controller: 'resultsController as vm'
                }
            },
            bodyClass: 'dashboard'
        });

        $stateProvider
            .state('app.site_overview.results', {
                abstract: true,
                url: '/results',
                onEnter: function ($stateParams) {


                },
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                    section: function ($stateParams) {
                        return $stateParams.owner
                    },
                },


            })
            .state('app.site_overview.results.list', {
                url: '',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/results/resultsSROI.html',
                        controller: 'resultsController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.results.results', {
                url: '/overview',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/results/resultsSROI.html',
                        controller: 'resultsController as vm'
                    }
                },
                onEnter: function () {
                },
                params: {
                    is_dashboard_data: true
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
        // Translation
        var base = 'app/main/apps/results';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.results')
        .service('resultsService', resultsService);

    /** @ngInject */
    // I provide access to the session store.
    function resultsService($q, $resource, settingsDomainService, sessionService, companyService, COMMON, $rootScope, $window, $mdToast) {



        function getData(options) {
            var deferred = $q.defer();
            var opt = {
                owner: options.owner
            }
            if (options.company_id) {
                opt.company_id = options.company_id;
            }
            resourceData.get(opt,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        var resourceData = $resource(COMMON.BASE_API + "/owner/:owner/results", {
            owner: '@owner',
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            },
        });


        return ({
            getData: getData,
        });

    }

})();
(function () {
    'use strict';

    angular
        .module('app.results')
        .controller('resultsController', resultsController);

    /** @ngInject */
    function resultsController($scope, $state, owner, $cookies, $location, $rootScope, $timeout,
        sessionService, $mdDialog, mediaService, $stateParams, msUtils, $translate, $document,
        resultsService, inputsService, outcomesService, stakeholdersService) {
        var vm = this;
        vm.is_dashboard_data = $state.params.is_dashboard_data;
        vm.isLoadingData = true;
        vm.init = init;
        vm.inputsTotal = 0;
        vm.outcomesTotal = 0;
        vm.sroiTotal = 0;
        vm.owner = owner;
        vm.openDialog = openDialog;
        vm.d3DataProcess = d3DataProcess;
        vm.getClassbySize = getClassbySize;
        vm.riskLevelPercent = riskLevelPercent;
        vm.riskLevelText = riskLevelText;
        vm.riskLevelColor = riskLevelColor;
        vm.resizeChart = resizeChart;
        vm.selectCompany = selectCompany;
        vm.forceRealodChart = forceRealodChart;
        vm.companies = sessionService.getUser().companies;
        vm.companySelectEvent = companySelectEvent;
        vm.companyId = 0;
        vm.companySelected = undefined;
        vm.getProyects = getProyects;
        $scope.owner = $stateParams.owner;
        /*        if (!vm.brandname) {
                    var hostSplited = $location.$$host.split('.');
                    if ((hostSplited.length >= 2 && hostSplited[1] == 'h2c' || hostSplited[1] == 'localhost') && hostSplited[0] != 'www') {
                        vm.brandname = hostSplited[0];
                    } else {
                        vm.brandname = $cookies.get('ownerRemember');
                    }
                }
                vm.branding = msUtils.getBranding();;*/
        vm.calendarUiConfig = {
            calendar: {
                lang: 'es',
                buttonText: {
                    today: 'Hoy',
                    month: 'Mes',
                    week: 'Semana',
                    day: 'Dia',
                    list: 'Lista'
                },
                height: 717,
                editable: false,
                eventLimit: false,
                header: {
                    left: 'month basicWeek',
                    center: 'title',
                    right: 'today prev,next'
                },
                handleWindowResize: false,
                aspectRatio: 1,
                dayNames: ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'],
                dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
                viewRender: function (view) {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                    vm.currentMonthShort = vm.calendar.getDate().format('MMM');
                },
                columnFormat: {
                    month: 'ddd',
                    week: 'ddd D',
                    day: 'ddd M'
                },
                eventClick: showEventDetailDialog,
                selectable: true,
                selectHelper: true,
                select: select
            }
        };

        vm.stakeholdersContainer = [];
        /*            {
                        name: "CIE",
                        total: 12500000.00,
                        inputs: [
                            {
                                name: "Nombre input",
                                value: 2500000.00
                            },
                            {
                                name: "Nombre input 2"
                            }
                        ],
                        outcomes: [
                            {
                                name: "Nombre outcome 1",
                                value: 3500000.00
                            }
                        ]
                    },
                    {
                        name: "CAIXA",
                        total: 12500000.00,
                        inputs: [
                            {
                                name: "Nombre input",
                                value: 2500000.00
                            },
                            {
                                name: "Nombre input 2"
                            },
                            {
                                name: "Nombre input 3"
                            }
                        ]
                    }
                ]
        */
        vm.inputsContainer = [];
        /*            {
                        name: "Nombre input 1",
                        value: 2500000,
                    },
                    {
                        name: "Nombre input 2",
                    },
                    {
                        name: "Nombre input 3",
                    },
                    {
                        name: "Nombre input 4",
                        value: 3500000,
                    },
                    {
                        name: "Nombre input 5",
                        value: 3500000,
                    },
                ]*/

        vm.outcomesContainer = []
        /*            {
                        name: "Nombre outcome 1",
                        value: 2500000,
                    },
                    {
                        name: "Nombre outcome 2",
                    },
                    {
                        name: "Nombre outcome 3",
                    },
                    {
                        name: "Nombre outcome 4",
                        value: 3500000,
                    },
                    {
                        name: "Nombre outcome 5",
                        value: 3500000,
                    },
                ]*/
        /*        var companySelectEvent = $rootScope.$on('select-company', function (event, company) {
                    vm.selectCompany(company);
                });*/

        /*        $scope.$on('$destroy', companySelectEvent);
                if ($rootScope.companySel) {
                    vm.init()
                }*/
        /*                if ($rootScope.companySel != vm.companyId) {
                            init();
                        }*/


        var companySelectEvent = $rootScope.$on('company-selected', function (event) {
            //     vm.companySelected = sessionService.get('companySelected');
            //     vm.data.riskmap = vm.alldata.riskmap.filter(x => x.id_company === vm.companySelected.id);
            //     vm.data.tasks_next = vm.alldata.tasks_next.filter(x => x.id_company === vm.companySelected.id)
            //     vm.data.tasks_due = vm.alldata.tasks_due.filter(x => x.id_company === vm.companySelected.id)
            //     vm.data.evidences = vm.alldata.evidences.filter(x => x.id_company === vm.companySelected.id)
            //     vm.data.activities = vm.alldata.activities.filter(x => x.id_company === vm.companySelected.id)
            //     vm.data.files = vm.alldata.files.filter(x => x.id_company === vm.companySelected.id)
            //     vm.d3Data = vm.d3DataProcess(vm.data.riskmap[0]);
            //     vm.forceRealodChart();
            vm.companyId = $rootScope.companySel;
            init();
        });
        if ($rootScope.companySel != vm.companyId) {
            init();
            vm.companyId = $rootScope.companySel;
        }

        /*        mediaService.getStoragePrefix({
                    owner: $stateParams.owner,
                }).then(function (res) {
                    $scope.storagePrefix = res.prefix;
                })*/

        function selectCompany(company) {
            vm.companySelected = [];
            $timeout(function () {
                vm.companySelected = company;
                //            vm.init(vm.companySelected.id)
            })
        }
        function getProyects(idCompany, inOwner) {
            var options = {
                owner: $scope.owner,
                company_id: $rootScope.companySel,
                withFiles: true
            };
            outcomesService.getProyects(options).then(function (response) {
                vm.stakeholder = response;
                $scope.isLoadingP = false;
            }, function (response) {
                vm.stakeholder = [];
            }
            )
        }
        function showEventDetailDialog(calendarEvent, e) {
            $mdDialog.show({
                controller: 'EventDetailFTDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/calendar/dialogs/event-detail-ft/event-detail-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    calendarEvent: calendarEvent,
                    showEventFormDialog: showEventFormDialog,
                    event: e
                }
            });
        }
        function showEventFormDialog(type, calendarEvent, start, end, e) {
            var dialogData = {
                type: type,
                calendarEvent: calendarEvent,
                start: start,
                end: end
            };

            $mdDialog.show({
                controller: 'EventFormFTDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/calendar/dialogs/event-form-ft/event-form-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: true,
                locals: {
                    dialogData: dialogData,
                    Contacts: Contacts,
                    ContactsCrew: ContactsCrew,
                }
            }).then(function (response) {
            });
        }

        function select(start, end, e) {
            showEventFormDialog('add', false, start, end, e);
        }



        function d3DataProcess(riskMap) {
            return [
                {
                    key: vm.riskLevelPercent(riskMap.average),
                    y: riskMap.average,
                    color: vm.riskLevelColor(riskMap.average)
                },
                {
                    key: '',
                    y: (25 - (riskMap.average * 1)),
                    color: '#EFEFEF'
                }
            ];
        }

        function getClassbySize(size) {
            if (size == 0) {
                return '#039be5';
            }
            if (size >= 1 && size < 10) {
                return 'light-blue-fg';
            }
            if (size >= 10 && size < 20) {
                return 'orange';
            }
            if (size >= 20) {
                return '#039be5';
            }
            return '';
        }
        function riskLevelPercent(average) {
            return average;
            // return ((average * 100) / 25) + '%';
        }

        function riskLevelText(average) {
            var txt;
            if (average >= 1 && average <= 4) {
                txt = $translate.instant('RISK.RISK_LOW');
            } else if (average >= 5 && average <= 9) {
                txt = $translate.instant('RISK.RISK_MEDIUM');
            } else if (average >= 10 && average <= 15) {
                txt = $translate.instant('RISK.RISK_HIGH');
            } else if (average >= 16 && average <= 25) {
                txt = $translate.instant('RISK.RISK_VERY_HIGH');
            }
            return txt;
        }

        function riskLevelColor(average) {
            var color;
            if (average >= 1 && average <= 4) {
                color = '#039be5';
            } else if (average >= 5 && average <= 9) {
                color = 'yellow';
            } else if (average >= 10 && average <= 15) {
                color = 'orange';
            } else if (average >= 16 && average <= 25) {
                color = '#039be5';
            }
            return color;
        }
        function mapTask(color) {
            return function mapTaskColor(x) {
                return {
                    id: x.id,
                    title: x.title,
                    start: new Date(x.date),
                    end: null,
                    color: color
                }
            }
        }
        function init(company_id) {
            
            vm.stakeholdersContainer = [];
            vm.inputsContainer = [];
            vm.outcomesContainer = [];
            
            var options = {
                owner: $scope.owner,
                company_id: $rootScope.companySel,
                withFiles: true
            };
            stakeholdersService.getProyects(options).then(function (response) {
                vm.stakeholder = response;
                let itStake = 0;
                vm.stakeholder.forEach(function (stakeH, index) {
                    vm.stakeholdersContainer[itStake] = { name: stakeH.stakeholder, total: 0, id: stakeH.id, inputs: [], outcomes: [] };
                    itStake = itStake + 1;
                });
                //                itStakeI  = 0;
                //                itStakeO  = 0;
                $scope.isLoadingP = false;
                var options = {
                    owner: $scope.owner,
                    proyect_id: $rootScope.companySel,
                    withFiles: true
                };
                inputsService.getInputs(options).then(function (response) {
                    vm.input = response;
                    vm.inputsTotal = 0;
                    vm.inputsGraph = 0;
                    let it = 0;
                    vm.input.forEach(function (input1, index) {
                        vm.inputsTotal = parseFloat(vm.inputsTotal) + parseFloat(input1.result);
                        vm.inputsContainer[it] = { name: input1.input, value: input1.result };
                        it = it + 1;
                        vm.stakeholdersContainer.forEach(function (stakeH, index) {
                            if (stakeH.id == input1.stakeholder_id) {
                                let stakeIndi = stakeH.inputs.length;
                                stakeH.inputs[stakeIndi] = { name: input1.input, value: input1.result };
                                stakeH.total = parseFloat(stakeH.total) + parseFloat(input1.result);
                            }
                        });
                        if(input1.result != undefined){
                            vm.inputsGraph = parseFloat(vm.inputsGraph) + parseFloat(input1.result);
                        }
                        
                    });
                    vm.sroiTotal = 0;
                    if (vm.inputsTotal > 0) {
                        vm.sroiTotal = vm.outcomesTotal / vm.inputsTotal;
                    }
                    
                    outcomesService.getOutcomes(options).then(function (response) {
                        vm.input = response;
                        vm.outcomesTotal = 0;
                        vm.outcomesGraph = 0;
                        let it = 0;
                        vm.input.forEach(function (input1, index) {
                            vm.outcomesTotal = parseFloat(vm.outcomesTotal) + parseFloat(input1.result);
                            vm.outcomesContainer[it] = { name: input1.outcome, value: input1.result };
                            it = it + 1;
                            vm.stakeholdersContainer.forEach(function (stakeH, index) {
                                if (stakeH.id == input1.stakeholder_id) {
                                    let stakeIndi = stakeH.outcomes.length;
                                    stakeH.outcomes[stakeIndi] = { name: input1.outcome, value: input1.result };
                                    stakeH.total = parseFloat(stakeH.total) + parseFloat(input1.result);
                                }
                            });
                            if(input1.result != undefined){
                                vm.outcomesGraph = parseFloat(vm.outcomesGraph) + parseFloat(input1.result);
                            }
                        });
                        vm.sroiTotal = 0;
                        if (vm.inputsTotal > 0) {
                            vm.sroiTotal = vm.outcomesTotal / vm.inputsTotal;
                        }
                        
                         //NVD3
                        $scope.options = {
                            chart: {
                                type: 'pieChart',
                                height: 500,
                                x: function (d) { return d.key; },
                                y: function (d) { return d.y; },
                                showLabels: true,
                                duration: 5,
                                labelThreshold: 0.01,
                                labelSunbeamLayout: true,
                                legend: {
                                    margin: {
                                        top: 5,
                                        right: 35,
                                        bottom: 5,
                                        left: 0
                                    }
                                }
                            }
                        };
                    
                        $scope.data = [
                            {
                                key: "INPUTS",
                                y: vm.inputsGraph,
                                color: "#DF433C"
                            },
                            {
                                key: "OUTCOMES",
                                y: vm.outcomesGraph,
                                color: "#3CC2DF"
                            },
                        ];
                        //!NVD3
                    }, function (response) {
                        vm.outcomesTotal = 0;
                        //$scope.isLoadingP = false;
                    }
                    )
                    
                }, function (response) {
                    vm.inputsTotal = 0;
                    //                $scope.isLoadingP = false;
                }
                )
            }
            )
            // var options = {
            //     owner: $scope.owner
            // };
            // resultsService.getData(options).then(function (response) {
             // });
        }

        function openDialog(items, type, ev) {
            $mdDialog.show({
                controller: 'ViewItemListresultsDialog',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/results/dialogs/view-item-list-results.dialog/view-item-list-results.dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    items: items,
                    type: type
                }
            }).then(function (selectedItem) {
                if (selectedItem) {
                    if (selectedItem.item.company_id) {
                        $rootScope.$broadcast('company-selected-from', vm.companies.find(x => x.id = selectedItem.item.company_id));
                        setTimeout(() => {
                            if (selectedItem.type === 'RISKS') {
                                $state.go('app.site_overview.risk.active_risk', { id: selectedItem.item.id, domain: $state.params.domain });
                            }
                            if (selectedItem.type === 'COMPLAINTS') {
                                $state.go('app.site_overview.complaints.list.active_complaint', { id: selectedItem.item.id, domain: $state.params.domain });
                            }
                        }, 500);
                    }

                }
            });
        }
        function forceRealodChart() {
            resizeChart(window.innerWidth < 600 ? true : false)
        }


        function resizeChart(mov) {
            if (mov) {
                vm.optionsDonut = {
                    chart: {
                        type: 'pieChart',
                        height: 65,
                        width: '100%',
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: -50,
                            left: 0
                        },
                        donut: true,
                        x: function (d) { return d.key; },
                        y: function (d) { return d.y; },
                        showLabels: false,
                        showLegend: false,
                        pie: {
                            startAngle: function (d) { return d.startAngle / 2 - Math.PI / 2 },
                            endAngle: function (d) { return d.endAngle / 2 - Math.PI / 2 }
                        },
                        duration: 500,
                        tooltip: {
                            enabled: false
                        }
                    }
                };
            } else {
                vm.optionsDonut = {
                    chart: {
                        type: 'pieChart',
                        height: 118,
                        width: '100%',
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: -50,
                            left: 0
                        },
                        donut: true,
                        x: function (d) { return d.key; },
                        y: function (d) { return d.y; },
                        showLabels: false,
                        showLegend: false,
                        pie: {
                            startAngle: function (d) { return d.startAngle / 2 - Math.PI / 2 },
                            endAngle: function (d) { return d.endAngle / 2 - Math.PI / 2 }
                        },
                        duration: 500,
                        tooltip: {
                            enabled: false
                        }
                    }
                };
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.risk')
        .controller('RiskController', RiskController);

    /** @ngInject */
    function RiskController($scope, $rootScope, $stateParams, $translate, $document, $mdDialog, $filter,
        $mdMedia, $mdSidenav, $state, msApi, tinyMceService, companyService, riskService, requestContext, tasksService,
        transformClients, mediaService, Upload, questionsService, $timeout, riskConfigService, taskDetailsUtil,
        evidencesControlsService, sessionService, msUtils, staffService, clientsService, $mdToast, html2canvasAngular) {
        var vm = this;
        vm.branding = msUtils.getBranding()
        $rootScope.showAllControls = false;
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
        vm.loadingThreads = true;
        $scope.loadingRisk = false;
        vm.currentFilter = {
            type: $state.params.type,
            filter: $state.params.filter
        };

        vm.searchNameText = '';
        vm.userLogued = sessionService.getUser();
        console.log(vm.userLogued);
        vm.is_evidences = $state.params.isEvidences ? true : false;
        vm.currentThread = null;
        vm.selectedThreads = [];
        vm.timeAgo = msUtils.timeAgo;
        vm.hasProp = msUtils.hasProp;
        vm.views = {
            split: 'app/main/apps/risk/views/list/split-view.html',
            nosplit: 'app/main/apps/risk/views/list/nosplit-view.html'
        };
        vm.defaultView = 'split';
        vm.currentView = 'split';

        vm.readView = false;

        vm.saveCanvas = saveCanvas;
        vm.isComplianceOfficer = isComplianceOfficer;

        vm.idCompany = undefined;
        vm.updateLogotype = false;
        vm.showForm = true;
        vm.allQuestions = true;


        vm.openThread = openThread;
        vm.closeThread = closeThread;


        vm.uploadMedia = uploadMedia;

        vm.updateRiskLevels = updateRiskLevels;
        vm.formatLabel = formatLabel;
        vm.editNameDialog = editNameDialog;

        vm.changeTaskStatusDialog = changeTaskStatusDialog;

        vm.isSelected = isSelected;
        vm.toggleSelectThread = toggleSelectThread;
        vm.selectThreads = selectThreads;
        vm.deselectThreads = deselectThreads;
        vm.toggleSelectThreads = toggleSelectThreads;

        vm.getSymbolCurrency = getSymbolCurrency;
        vm.setThreadStatus = setThreadStatus;
        vm.toggleThreadStatus = toggleThreadStatus;
        vm.changeView = changeView;
        vm.toggleSidenav = toggleSidenav;
        vm.openMenu = openMenu;

        vm.tinymceOptions = tinyMceService.getBasicOptions($scope);

        vm.mediaDialogSingle = mediaDialogSingle;
        vm.openImageDialog = openImageDialog;
        vm.uploadMediaQueue = uploadMediaQueue;
        vm.openRiskAndControlsSelectDialog = openRiskAndControlsSelectDialog;
        vm.dateExpired = dateExpired;

        //////////

        vm.firstLoad = true;
        vm.risks = [];
        vm.files = [];
        vm.companySelected = undefined;
        vm.branchSelected = undefined;
        vm.searchBranchText = '';
        vm.companyBranches = [];
        vm.editMode = false;

        vm.evidenceData = {};
        vm.loadingEvidences = false;
        vm.savingEvidence = false;

        vm.taskData = {};
        vm.loadingTasks = false;
        vm.savingTask = false;

        vm.controlTabsIndex = 0;

        vm.isCompanySelected = isCompanySelected;
        vm.isBranchSelected = isBranchSelected;
        vm.selectBranch = selectBranch;
        vm.setCompanyBranches = setCompanyBranches;
        vm.requireAttention = requireAttention;
        vm.totalRiskControls = totalRiskControls;
        vm.impactColor = impactColor;
        vm.impactText = impactText;
        vm.openRisk = openRisk;
        vm.openRiskAndControl = openRiskAndControl;
        vm.loadRisk = loadRisk;
        vm.closeRisk = closeRisk;
        vm.editRisk = editRisk;
        vm.closeEdit = closeEdit;
        vm.openControl = openControl;
        vm.openProcess = openProcess;
        vm.closeControl = closeControl;
        vm.closeControlAndRisk = closeControlAndRisk;
        vm.closeProcess = closeProcess;
        vm.saveEvidence = saveEvidence;
        vm.updateEvidences = updateEvidences;
        vm.checkUploadsAndUpdateEvidences = checkUploadsAndUpdateEvidences;
        vm.clearEvidence = clearEvidence;
        vm.showUserImage = showUserImage;
        vm.showUserImageFromId = showUserImageFromId;
        vm.openDialogUsers = openDialogUsers;
        vm.openDialogDivisions = openDialogDivisions;
        vm.getCompanyBranches = getCompanyBranches;
        vm.setUsersForControl = setUsersForControl;
        vm.setDivisionForControl = setDivisionForControl;
        vm.showRiskLevel = showRiskLevel;
        vm.openDialogText = openDialogText;
        vm.updateProcessScore = updateProcessScore;
        vm.openEvidence = openEvidence;

        vm.completeTask = completeTask;
        vm.getDivisions = getDivisions;

        vm.controlAverageColor = msUtils.controlAverageColor;
        vm.controlAverageColorText = msUtils.controlAverageColorText;
        vm.controlAverageText = msUtils.controlAverageText;
        vm.deleteActiveControl = deleteActiveControl;
        vm.deleteActiveRisk = deleteActiveRisk;

        vm.evidenceScoreColor = msUtils.evidenceScoreColor;
        vm.evidenceScoreText = msUtils.evidenceScoreText;
        vm.showAllToggle = showAllToggle;
        vm.selectUser = selectUser;
        vm.getFilteredControls = getFilteredControls;

        vm.translate = msUtils.translate;
        vm.timeAgo = msUtils.timeAgo;
        vm.hasProp = msUtils.hasProp;
        vm.showAll = false;
        var companySelectEvent = $rootScope.$on('company-selected', function (event) {
            $scope.isLoading = true;
            vm.risks = [];
            vm.companySelected = sessionService.get('companySelected');
            companyService.setCompanyId(vm.companySelected.id);
            companyService.getBranches({
                owner: $scope.owner,
                company_id: vm.companySelected.id,
                withUsers: true
            })
                .then(function (branchesResponse) {
                    if (branchesResponse.total > 0) {
                        vm.setCompanyBranches(branchesResponse.data);
                        var mainBranch = $filter('filter')(branchesResponse.data, { is_main: true });
                        if (mainBranch && mainBranch[0]) {
                            vm.selectBranch(mainBranch[0])
                        } else {
                            vm.selectBranch(branchesResponse.data[0])
                        }
                    } else {
                        vm.branchSelected = undefined;
                        vm.searchBranchText = '';
                        vm.companyBranches = [];
                    }
                    if (vm.is_evidences && $state.params.id_active_control && $state.params.id_active_risk) {
                        evidencesControlsService.get({
                            owner: $scope.owner,
                        })
                            .then(function (resp) {
                                vm.risks = resp.result.data;
                                vm.openRiskAndControl($state.params.id_active_risk, $state.params.id_active_control, $state.params.tab)
                            })

                    }
                    var options = {
                        owner: $scope.owner,
                        page: 1,
                        inCompany: vm.companySelected.id,
                        resultsPerPage: 500
                    };
                    staffService.getStaff(options).then(function (res) {
                        console.log(res.data);
                        vm.usersToSearch = res.data;
                    })
                });
            getComplianceOfficers();
        });

        $scope.$on('$destroy', companySelectEvent);

        //////////

        $scope.$on('pagination:loadStart', function (event) {
            $scope.isLoading = true;
        });

        $scope.$on('pagination:loadPage', function (event) {
            $scope.isLoading = false;
        });

        $scope.owner = $stateParams.owner;
        var originatorEv;

        function openMenu($mdOpenMenu, ev) {
            originatorEv = ev;
            $mdOpenMenu.open(ev);
        }

        function selectUser(user) {
            vm.userSelected = user;
            vm.searchNameText = '';
        }
        function getFilteredControls(controls) {
            if (!vm.userSelected) {
                return controls;
            } else {
                var result = controls.filter(x => x.users.find(y => y.user_id == vm.userSelected.id));
                console.log(result);
                return result;
            }
        }

        init();

        /////////////////

        function init() {
            mediaService.getStoragePrefix({
                owner: $scope.owner,
            }).then(function (res) {
                $scope.storagePrefix = res.prefix;
            })
            evidencesControlsService.getCurrencies({ owner: $scope.owner }).then(function (res) {
                vm.currencies = res.data;
            })
            if (sessionService.get('companySelected')) {
                $rootScope.$broadcast('company-selected');
            }
            if ($state.params.id_company) {
                $rootScope.$broadcast('select-company-id', $state.params.id_company);
                return;
            }
            vm.startLoad = true;
            if ($state.params.id && vm.companySelected) {
                vm.loadRisk($state.params.id);
            }
            if (!vm.companySelected) {
                if (vm.is_evidences) {
                    $state.go('app.site_overview.evidences.list', { domain: $state.params.domain }, { notify: false, inherit: true, location: true });
                } else {
                    $state.go('app.site_overview.risk.list', { domain: $state.params.domain }, { notify: false, inherit: true, location: true });
                }
            } else {
                getComplianceOfficers();
            }


            vm.getDivisions();

        }

        function getComplianceOfficers() {
            vm.companySelected = sessionService.get('companySelected');
            companyService.getComplianceOfficers({ owner: $scope.owner, id: vm.companySelected.id }).then(function (res) {
                vm.complianceOfficers = res;
            })
        }

        function getDivisions() {
            var options = {
                owner: $scope.owner,
                resultsPerPage: 1000
            };
            clientsService.getDivisions(options).then(function (response) {
                vm.divisions = response.data;
            })
        }

        function isComplianceOfficer() {

            var found = _.find(vm.complianceOfficers, function (user) {
                return user.user_id == vm.userLogued.id
            })
            return found != undefined;
        }

        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'nosplit';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big)
                vm.currentView = 'nosplit';

        });

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small)
                vm.currentView = 'split';

        });

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                if (vm.defaultView === 'split') {
                    vm.currentView = 'split';
                }
            }
        });

        var originatorEv;

        function openMenu($mdOpenMenu, ev) {
            originatorEv = ev;
            $mdOpenMenu(ev);
        }

        /**
         * Open thread
         *
         * @param thread
         */
        function openThread(thread) {
            // // Set the read status on the thread
            // thread.read = true;

            // // Assign thread as the current thread
            // vm.currentThread = thread;

            // // Update the state without reloading the controller
            // $state.go('app.aircrafts.threads.thread', { threadId: thread.id }, { notify: false });
        }

        /**
         * Close thread
         */
        function closeThread() {
            // vm.currentThread = null;

            // // Update the state without reloading the controller
            // $state.go('app.aircrafts.threads', {
            //     type: vm.currentFilter.type,
            //     filter: vm.currentFilter.filter
            // }, { notify: false });
        }

        function showAllToggle() {
            if (vm.showAll) {
                $rootScope.showAllControls = true;
                $rootScope.pagination_resetquery();
            } else {
                $rootScope.showAllControls = false;
                $rootScope.pagination_resetquery();
            }
        }


        function uploadMediaQueue(files, idValue, uploadKey) {
            if (count(files) > 0) {
                vm.uploadingFiles = true;
                var file = files[0];
                if (!file.$error) {
                    var token = undefined;
                    console.debug("UPLOAD______****", file)
                    mediaService.getS3UploadPreSignedUrl({
                        owner: $scope.owner,
                        uploadKey: uploadKey,
                        fileName: file.name,
                        rowId: idValue
                    })
                        .then(function (resp) {
                            token = resp.token;
                            file.id_media = resp.id_media;
                            file.upload = Upload.http({
                                url: resp.url,
                                skipAuthorization: true,
                                method: 'PUT',
                                headers: {
                                    "Content-Type": file.type != '' ? file.type : 'application/octet-stream'
                                },
                                data: file
                            })
                            file.upload.then(function (response) {
                                file.result = response.data;
                                $timeout(function () {
                                    $scope.log = 'file: ' +
                                        file.name +
                                        ', Response: ' + JSON.stringify(response.data) +
                                        ', ID: ' + file.id_media +
                                        '\n' + $scope.log;
                                });
                                console.debug("SEND_TO_CROP______****", file)
                                mediaService.finishedUploadingFileToCdn({
                                    owner: $scope.owner,
                                    idMedia: file.id_media,
                                    token: token
                                })
                                    .then(function () {
                                        vm.files.splice(0, 1);
                                        vm.uploadMediaQueue(files, idValue, uploadKey)
                                    })

                            }, function (response) {
                                if (response.status > 0)
                                    $scope.errorMsg = response.status + ': ' + response.data;
                            });

                            file.upload.progress(function (evt) {
                                file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                            });
                        })
                }
            } else {
                vm.uploadingFiles = false;
            }
        };

        function openImageDialog(ev, index, images, img) {
            var imagesCopy = [];
            imagesCopy.push(img);
            $mdDialog.show({
                controller: 'ImageDialogClientsController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/clients/dialogs/image/image-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Images: imagesCopy,
                    ImageSelected: img,
                    cropFormats: false,
                    MediaFull: false
                }
            });
        }

        function deleteActiveControl(ev, control) {
            var confirm = $mdDialog.confirm()
                .title($translate.instant('GLOBAL.ARE_YOU_SURE'))
                .ariaLabel('DELETE CONTROL')
                .targetEvent(ev)
                .ok($translate.instant('GLOBAL.YES'))
                .cancel($translate.instant('GLOBAL.NO'));

            $mdDialog.show(confirm).then(function () {

                var options = {
                    owner: $scope.owner,
                    controlId: control.active_control_id
                }
                // console.log(control.id, control)
                questionsService.deleteActiveControl(options)
                    .then(function (response) {
                        if (!angular.isUndefined(response.result.active_risk_removed) && response.result.active_risk_removed) {
                            var message = $translate.instant('RISK.CONTROL_RISK_DELETED_SUCCESS')
                            $mdToast.show({
                                template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content bg-green">' + message + '</div></md-toast>',
                                hideDelay: 3000,
                                position: 'top right',
                                parent: '#content'
                            });
                            vm.closeEdit();
                            vm.closeRisk();
                            $rootScope.pagination_resetquery();
                        } else {
                            openRisk(vm.currentRisk);
                        }
                        vm.closeControl();
                    });


            });
        }
        function deleteActiveRisk(ev) {
            const message = $translate.instant('GLOBAL.ARE_YOU_SURE');
            const yes = $translate.instant('GLOBAL.YES');
            const no = $translate.instant('GLOBAL.NO');

            const confirm = $mdDialog.confirm()
                .title(message)
                .targetEvent(ev)
                .ok(yes)
                .cancel(no);

            $mdDialog.show(confirm).then(e => {
                var threads = angular.copy(vm.selectedThreads);
                vm.selectedThreads = [];
                for (var j = 0; j < threads.length; j++) {
                    var options = {
                        owner: $scope.owner,
                        id: threads[j].activeRisk.id
                    };
                    riskService.deleteActiveRisk(options).then(function (response) {
                        $rootScope.pagination_resetquery();
                    })
                };
            })

        }

        function editNameDialog($event, type, item, process) {
            $mdDialog.show({
                controller: function ($timeout, $q, $scope, $mdDialog, riskService, Owner, type, item) {
                    var vm = this;
                    vm.item = angular.copy(item);
                    vm.item.name = vm.item.rename ? vm.item.rename : vm.item.name;
                    vm.process = process;
                    vm.type = type;
                    vm.closeDialog = function () {
                        $mdDialog.hide();
                    }
                    vm.saveDialog = function () {
                        if (vm.type == "process") {
                            for (var i = 0; i < vm.item.controls.length; i++) {
                                const control = vm.item.controls[i];
                                var options = {
                                    owner: Owner,
                                    item: control,
                                    rename: {
                                        process_rename: vm.item.name
                                    }
                                }
                                riskService.updateControl(options).then(function () {
                                    $mdDialog.hide({ rename: vm.item.name });
                                })
                            }
                        }
                        if (vm.type == "control") {
                            var options = {
                                owner: Owner,
                                item: vm.item,
                                rename: {
                                    control_rename: vm.item.name
                                }
                            }
                            riskService.updateControl(options).then(function () {
                                $mdDialog.hide({ rename: vm.item.name });
                            })
                        }
                    }
                },
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/risk/dialogs/edit-name/edit-name-dialog.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    Owner: $scope.owner,
                    type: type,
                    process: process,
                    item: item
                },
            })
                .then(function (resp) {
                    if (resp && resp.rename) {
                        if (vm.type == "control") {
                            vm.openRisk(vm.currentRisk);
                            vm.currentControl.rename = resp.rename;
                        } else {
                            vm.currentProcess.rename = resp.rename;
                        }
                    }
                });
        }

        function saveCanvas(id) {
            // $scope.loadingRisk = true;
            if (!$scope.capturing) {
                $scope.capturing = true;
                html2canvasAngular.renderElement(document.getElementById(id)).then(function (canvas) {
                    canvas.id = "canvas-to-remove";
                    document.body.appendChild(canvas);
                    html2canvasAngular.renderElement(document.getElementById(id)).then(function (canvas) {
                        var imgdata = canvas.toDataURL();
                        var download = document.createElement('a');
                        download.href = imgdata;
                        download.download = 'canvas.png';
                        download.click();
                        $scope.capturing = false;
                        var element = document.getElementById("canvas-to-remove");
                        document.body.removeChild(element);
                        // $scope.loadingRisk = false;
                    });
                });
            }
        }

        function mediaDialogSingle(ev, field) {
            $mdDialog.show({
                controller: 'MediaClientsController',
                controllerAs: 'vm',
                locals: {
                    owner: $scope.owner,
                    multipleSelection: true,
                    isTiny: false
                },
                templateUrl: 'app/main/apps/clients/dialogs/media/media-clients.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true

            }).then(function (image) {
                if (image) {
                    if (($scope.image && vm.idCompany) || vm.idCompany)
                        vm.updateLogotype = true;
                    $scope.image = image;
                }
            });
        }

        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        function isSelected(thread) {
            return vm.selectedThreads.indexOf(thread) > -1;
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        function toggleSelectThread(thread, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedThreads.indexOf(thread) > -1) {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            } else {
                vm.selectedThreads.push(thread);
            }
        }

        /**
         * Select threads. If key/value pair given,
         * threads will be tested against them.
         *
         * @param [key]
         * @param [value]
         */
        function selectThreads(key, value) {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedThreads = [];

            for (var i = 0; i < vm.risks.length; i++) {
                if (angular.isUndefined(key) && angular.isUndefined(value)) {
                    vm.selectedThreads.push(vm.risks[i]);
                    continue;
                }

                if (angular.isDefined(key) && angular.isDefined(value) && vm.risks[i][key] === value) {
                    vm.selectedThreads.push(vm.risks[i]);
                }
            }
        }

        /**
         * Deselect threads
         */
        function deselectThreads() {
            vm.selectedThreads = [];
        }

        /**
         * Toggle select threads
         */
        function toggleSelectThreads() {
            if (vm.selectedThreads.length > 0) {
                vm.deselectThreads();
            } else {
                vm.selectThreads();
            }
        }

        /**
         * Set the status on given thread, current thread or selected threads
         *
         * @param key
         * @param value
         * @param [thread]
         * @param [event]
         */
        function setThreadStatus(key, value, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                thread[key] = value;
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                vm.currentThread[key] = value;
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                vm.selectedThreads[x][key] = value;
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleThreadStatus(key, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                if (typeof (thread[key]) !== 'boolean') {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                if (typeof (vm.currentThread[key]) !== 'boolean') {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                if (typeof (vm.selectedThreads[x][key]) !== 'boolean') {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }


        /**
         * Change the view
         *
         * @param view
         */
        function changeView(view) {
            if (vm.views[view]) {
                vm.defaultView = view;
                vm.currentView = view;
            }
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }


        ////////////////////

        function isCompanySelected() {
            if (angular.isObject(vm.companySelected)) {
                return true;
            }
            return false;
        }

        function isBranchSelected() {
            if (riskService.branch) {
                return true;
            }
            return false;
        }

        function formatLabel(data) {
            return data / 4;
        }
        function updateRiskLevels(risk) {
            var options = {
                owner: $scope.owner,
                id: risk.activeRisk.id,
                item: {
                    reputation_impact: risk.activeRisk.reputation_impact,
                    penal_code_impact: risk.activeRisk.penal_code_impact,
                    client_loss: risk.activeRisk.client_loss
                }
            }
            $scope.isLoading = true;
            $scope.loadingChart = true;
            riskService.updateRisk(options)
                .then(function (response) {
                    openRisk(vm.currentRisk, true);
                    var message = $translate.instant('GLOBAL.UPDATED_SUCCESSFULLY')
                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content bg-green">' + message + '</div></md-toast>',
                        hideDelay: 3000,
                        position: 'top right',
                        parent: '#content'
                    });
                })
                .catch(function (response) {
                    console.log('err', response);
                });
        }


        function selectBranch(branch, noFirst) {
            $scope.isLoading = true;
            vm.risks = [];
            companyService.setBranch(branch)
            vm.branchSelected = branch;
            vm.searchBranchText = '';
            if (vm.firstLoad) {
                if (!noFirst) {
                    vm.firstLoad = false;
                }
            } else {
                if (vm.is_evidences) {
                    evidencesControlsService.get({
                        owner: $scope.owner,
                    })
                        .then(function (resp) {
                            vm.risks = resp.result.data;
                            $scope.isLoading = false;
                        })
                } else {
                    riskService.get({
                        owner: $scope.owner,
                    })
                        .then(function (resp) {
                            vm.risks = resp.result.data;
                            $scope.isLoading = false;
                        })
                }
            }
        }

        function setCompanyBranches(branches) {
            vm.companyBranches = branches;
        }

        function getCompanyBranches(idCompany, idBranch) {
            companyService.getBranches({
                owner: $scope.owner,
                company_id: idCompany,
                withUsers: true,
            })
                .then(function (branchesResponse) {
                    $scope.isLoading = false;
                    if (branchesResponse.total > 0) {
                        vm.setCompanyBranches(branchesResponse.data);
                        angular.forEach(branchesResponse.data, function (branch) {
                            if (branch.id == idBranch) {
                                vm.selectBranch(branch, 1)
                            }
                        })

                    }
                    else {
                        vm.branchSelected = undefined;
                        vm.searchBranchText = '';
                        vm.companyBranches = [];
                    }
                });
        }

        function requireAttention(risk) {
            var reqAttention = false;
            angular.forEach(risk.processes, function (proc) {
                if (proc.averageEvidenceScoreNullCount > 0) {
                    reqAttention = true;
                }
            })
            return reqAttention;
        }

        function impactColor(impact) {
            switch (true) {
                case impact == 1:
                    return 'rgb(98,198,153)';
                case impact == 2:
                    return 'rgb(148,222,146)';
                case impact == 3:
                    return 'rgb(148,215,146)';
                case impact == 4:
                    return 'rgb(210,236,152)';
                case impact == 5:
                    return 'rgb(255,243,173)';
                case impact == 6 || impact == 7:
                    return 'rgb(255,246,163)';
                case impact == 8:
                    return 'rgb(255,234,143)';
                case impact == 9:
                    return 'rgb(255,224,108)';
                case impact == 10 || impact == 11:
                    return 'rgb(255,205,105)';
                case impact == 12 || impact == 13 || impact == 14:
                    return 'rgb(255,198,113)';
                case impact == 15:
                    return 'rgb(253,174,97)';
                case impact == 16 || impact == 17 || impact == 18 || impact == 19:
                    return 'rgb(236,110,116)';
                case impact == 20 || impact == 21 || impact == 22 || impact == 23 || impact == 24:
                    return 'rgb(232,81,88)';
                case impact == 25:
                    return 'rgb(209,45,65)';
                default:
                    return null;
            }
            // var color;
            // if (impact >= 1 && impact <= 4) {
            //     color = 'green';
            // } else if (impact >= 5 && impact <= 9) {
            //     color = 'rgb(255, 217, 0)';
            // } else if (impact >= 10 && impact <= 15) {
            //     color = 'orange';
            // } else if (impact >= 16 && impact <= 25) {
            //     color = 'red';
            // }
            // return color;
        }

        function impactText(impact) {
            var txt;
            if (impact >= 1 && impact <= 4) {
                txt = $translate.instant('RISK.RISK_LOW');
            } else if (impact >= 5 && impact <= 9) {
                txt = $translate.instant('RISK.RISK_MEDIUM');
            } else if (impact >= 10 && impact <= 15) {
                txt = $translate.instant('RISK.RISK_HIGH');
            } else if (impact >= 16 && impact <= 25) {
                txt = $translate.instant('RISK.RISK_VERY_HIGH');
            }
            return txt;
        }

        function totalRiskControls(risk) {
            var totalControls = 0;
            angular.forEach(risk.processes, function (proc) {
                totalControls += proc.controls.length;
            })
            return totalControls
        }

        function openRiskAndControl(id_active_risk, id_active_control, tabselected) {
            $scope.loadingRisk = true;
            riskService.getRisk({
                owner: $scope.owner,
                id: id_active_risk
            }).then(function (resp) {
                vm.currentRisk = resp.result
                $state.go('app.site_overview.evidences.active_control', {
                    id_active_control: id_active_control,
                    id_company: vm.companySelected.id,
                    id_active_risk: id_active_risk,
                    tab: tabselected,
                    domain: $state.params.domain
                }, {
                    notify: false,
                    inherit: true,
                    location: true
                });
                // for (var i = 0; i < vm.risks.length; i++) {
                //     if (vm.risks[i].id == vm.currentRisk.id) {
                //         vm.risks[i] = vm.currentRisk;
                //     }
                // }

                $scope.loadingChart = false;
                $scope.loadingRisk = false;
                $scope.isLoading = false;
                vm.openControl(id_active_control);
            })

        }
        function openRisk(risk) {
            $state.go('app.site_overview.risk.active_risk', {
                id: risk.activeRisk.id,
                domain: $state.params.domain
            }, {
                notify: false,
                inherit: true,
                location: true
            });
            loadRisk(risk.activeRisk.id)
        }

        function loadRisk(riskId, userType) {
            $scope.loadingRisk = true;
            riskService.getRisk({
                owner: $scope.owner,
                id: riskId
            }).then(function (resp) {
                vm.currentRisk = resp.result
                for (var i = 0; i < vm.risks.length; i++) {
                    if (vm.risks[i].id == vm.currentRisk.id) {
                        vm.risks[i] = vm.currentRisk;
                    }
                }
                $scope.loadingChart = false;
                $scope.loadingRisk = false;
                $scope.isLoading = false;
                if (userType) {
                    var control;
                    for (let i = 0; i < vm.currentRisk.processes.length; i++) {
                        const element = vm.currentRisk.processes[i];
                        var found = element.controls.find(x => x.id == vm.currentControl.id);
                        if (found) {
                            control = found;
                            break;
                        };

                    }
                    var type = (userType == 'IN_CHARGE') ? 1 : 2;
                    vm.currentControlDivisions[userType] = control.divisions.filter(x => x.active_control_user_type_id == type).map(x => x.division);
                }
                // vm.getCompanyBranches(vm.currentRisk.activeRisk.company_id, vm.currentRisk.activeRisk.branch_id);
            })
        }

        function closeRisk() {
            vm.currentRisk = undefined;
            vm.currentControl = undefined;
            vm.currentProcess = undefined;
            vm.currentEditRisk = undefined;
        }

        function editRisk(risk) {
            vm.currentEditRisk = risk;
            vm.currentControl = undefined;
            vm.currentProcess = undefined;
            vm.editMode = true;
        }

        function closeEdit() {
            vm.currentControl = undefined;
            vm.currentProcess = undefined;
            vm.currentEditRisk = undefined;
            vm.editMode = false;
        }

        function clearEvidence() {
            vm.evidenceData = {
                active_control_id: vm.currentControl && vm.currentControl.active_control_id,
                score: null,
                title: '',
                text: ''
            };
        }

        function openControl(id_active_control) {
            vm.currentTask = undefined;
            vm.currentProcess = undefined;
            vm.currentControl = findControl(id_active_control);

            switch ($state.params.tab) {
                case 'evidences':
                    vm.controlTabsIndex = 0;
                    break;
                case 'tasks':
                    vm.controlTabsIndex = 1;
                    break;
                default:
                    vm.controlTabsIndex = 0;
                    break;
            }
            vm.processComments = undefined;
            vm.setUsersForControl();
            vm.setDivisionForControl();
            vm.clearEvidence();
            vm.updateEvidences();
        }

        function findControl(id_active_control) {
            var found;
            for (var i = 0; i < Object.values(vm.risks).length; i++) {
                var risk = Object.values(vm.risks)[i];
                for (var j = 0; j < Object.values(risk.processes).length; j++) {
                    found = _.find(Object.values(risk.processes)[j].controls, function (control) {
                        return control.active_control_id == id_active_control;
                    });
                    if (found) {
                        break;
                    }
                }
                if (found) {
                    break;
                }
            }
            return found;
        }


        function openProcess(process) {
            vm.currentTask = undefined;
            vm.currentControl = undefined;
            vm.currentProcess = undefined;
            vm.controlTabsIndex = undefined;
            vm.currentProcess = process;
            getCommentsProcess(process);
        }
        function getCommentsProcess(process) {
            var options = {
                owner: $scope.owner,
                process_id: process.id,
                company_id: vm.companySelected.id,
                branch_id: vm.branchSelected.id
            }
            riskService.getProcessOddOfOccurrenceComments(options).then(function (response) {
                vm.processComments = response.result.data;
            })
        }

        $scope.filterUserControlType = function (control, type) {
            return function (item) {
                return item.active_control_id === control && item.active_control_user_type_id == type;
            };
        };


        function setUsersForControl() {
            vm.currentControlUsers = {
                IN_CHARGE: [],
                PARTICIPANT: []
            };
            angular.forEach(vm.currentRisk.users, function (user) {
                if (vm.currentControl && user.active_control_id == vm.currentControl.active_control_id) {
                    if (user.active_control_user_type_id == 1) {
                        vm.currentControlUsers.IN_CHARGE.push(user.user);
                    } else if (user.active_control_user_type_id == 2) {
                        vm.currentControlUsers.PARTICIPANT.push(user.user);
                    }
                }
            })
        }

        function setDivisionForControl() {
            vm.currentControlDivisions = {
                IN_CHARGE: [],
                PARTICIPANT: []
            };
            if (vm.currentControl) {
                angular.forEach(vm.currentControl.divisions, function (division) {
                    if (division.active_control_id == vm.currentControl.active_control_id) {
                        if (division.active_control_user_type_id == 1) {
                            vm.currentControlDivisions.IN_CHARGE.push(division.division);
                        } else if (division.active_control_user_type_id == 2) {
                            vm.currentControlDivisions.PARTICIPANT.push(division.division);
                        }
                    }
                })
            }
        }

        function closeControl() {
            vm.currentControl = undefined;
        }
        function closeControlAndRisk() {
            vm.currentControl = undefined;
            vm.currentRisk = undefined;
        }
        function closeProcess() {
            vm.currentProcess = undefined;
            vm.processComments = undefined;
        }

        function saveEvidence() {
            riskService.postEvidence({
                owner: $scope.owner,
                item: vm.evidenceData
            }).then(function (res) {
                // vm.openRisk(vm.currentRisk, true);
                angular.forEach(vm.files, function (f) {
                    vm.uploadMedia(f, res.id, 'evidence')
                })
                vm.checkUploadsAndUpdateEvidences();
            })
        }

        function uploadMedia(file, idValue, uploadKey) {
            if (!file.$error) {
                var token = undefined;
                console.debug("UPLOAD______****", file)
                mediaService.getS3UploadPreSignedUrl({
                    owner: $scope.owner,
                    uploadKey: uploadKey,
                    fileName: file.name,
                    rowId: idValue
                })
                    .then(function (resp) {
                        token = resp.token;
                        file.id_media = resp.id_media;
                        file.upload = Upload.http({
                            url: resp.url,
                            skipAuthorization: true,
                            method: 'PUT',
                            headers: {
                                "Content-Type": file.type != '' ? file.type : 'application/octet-stream'
                            },
                            data: file
                        });

                        file.upload.then(function (response) {
                            file.result = response.data;
                            $timeout(function () {
                                $scope.log = 'file: ' +
                                    file.name +
                                    ', Response: ' + JSON.stringify(response.data) +
                                    ', ID: ' + file.id_media +
                                    '\n' + $scope.log;
                            });
                            console.debug("SEND_TO_CROP______****", file)
                            mediaService.finishedUploadingFileToCdn({
                                owner: $scope.owner,
                                idMedia: file.id_media,
                                token: token
                            }).then(res => {
                                vm.files.splice(0, 1);
                            })


                        }, function (response) {
                            if (response.status > 0)
                                $scope.errorMsg = response.status + ': ' + response.data;
                        });

                        file.upload.progress(function (evt) {
                            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                        });

                    })
            }
        };
        function checkUploadsAndUpdateEvidences() {
            var noUpdate = false;
            if (vm.files.length > 0) {
                angular.forEach(vm.files, function (file) {
                    if ((angular.isUndefined(file.progress) || file.progress < 100) || !file.finished) {
                        noUpdate = true;
                    }
                })
                if (!noUpdate) {
                    vm.updateEvidences();
                } else {
                    $timeout(function () {
                        vm.checkUploadsAndUpdateEvidences();
                    }, 1000)
                }
            } else {
                vm.updateEvidences();
            }
        }
        function updateEvidences() {
            vm.loadingEvidences = true;
            vm.currentEvidences = undefined;
            riskService.getEvidences({
                activeControlId: vm.currentControl && vm.currentControl.active_control_id,
                owner: $scope.owner,
                withMessages: true,
                withUser: true,
                withFiles: true,
                sortField: 'updated_at',
                sortDir: 'DESC'
            })
                .then(function (res) {
                    if (res.total > 0) {
                        vm.currentEvidences = res.data;
                    }
                    vm.loadingEvidences = false;
                    vm.clearEvidence();
                    vm.savingEvidence = false;
                })
        }
        function changeTaskStatusDialog(e, task) {
            $mdDialog.show({
                controller: 'TaskEditStatusController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/tasks/dialogs/task-edit-status-dialog/task-edit-status-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    task: angular.copy(task)
                }
            }).then(function (resp) {
                if (resp) {
                    const toSave = taskDetailsUtil.prepareToSave({ task: resp });
                    vm.loadingReadPane = true;
                    console.log(toSave);
                    taskDetailsUtil.updateTaskStatus($scope.owner, toSave.task).then(function (res) {
                        vm.updateTasks();
                        $rootScope.pagination_resetquery();
                        vm.loadingReadPane = false;
                    }, function (err) {
                        $rootScope.pagination_resetquery();
                        vm.loadingReadPane = false;
                    })
                }
            });
        }
        function showUserImage(user) {
            return $scope.storagePrefix + user.files.url
        }
        function showUserImageFromId(userId) {
            angular.forEach(vm.allUsers, function (u) {
                if (u.id == userId) {
                    if (!angular.isUndefined(u.files.id)) {
                        return $scope.storagePrefix + u.files.url
                    } else {
                        return false;
                    }
                }
            });
        }

        function openDialogUsers($event, processControl, usersType) {
            $mdDialog.show({
                controller: function ($timeout, $q, $scope, title, $mdDialog, $filter, currentUsers, availableUsers, storagePrefix) {
                    var vm = this;
                    vm.title = title;
                    vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
                    vm.usersObj = {};
                    vm.allUsers = [];
                    angular.forEach(availableUsers, function (user) {
                        if (angular.isUndefined(vm.usersObj[user.id])) {
                            vm.allUsers.push(user);
                            vm.usersObj[user.id] = user;
                        }
                    })
                    vm.currentUsers = currentUsers;
                    angular.forEach(vm.allUsers, function (u) {
                        if (angular.isUndefined(u.profile_color)) {
                            u.profile_color = vm.colors[Math.floor(Math.random() * vm.colors.length)];
                        }
                        u.storagePrefix = storagePrefix;
                        u.selected = false;
                        angular.forEach(vm.currentUsers, function (user) {
                            user.profile_color = u.profile_color;
                            if (user.id == u.id) {
                                u.selected = true;
                            }
                        })
                    })
                    vm.closeDialog = function () {
                        $mdDialog.hide();
                    }
                    vm.apply = function () {
                        var returnUsers = $filter('filter')(vm.allUsers, { selected: true })
                        $mdDialog.hide(returnUsers);
                    };
                },
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/selectUsers/selectUsers.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    title: $translate.instant('GLOBAL.USERS'),
                    availableUsers: vm.branchSelected.users,
                    currentUsers: vm.currentControlUsers[usersType],
                    storagePrefix: $scope.storagePrefix
                },
            })
                .then(function (resp) {
                    if (resp) {
                        var options = {
                            owner: $scope.owner,
                            controlId: vm.currentControl.active_control_id,
                            users: resp ? resp : [],
                            usersType: usersType
                        }
                        riskService.updateControlUsers(options)
                            .then(function (response) {
                                vm.currentControlUsers[usersType] = resp;
                                vm.loadRisk(vm.currentRisk.activeRisk.id)
                            })
                            .catch(function (response) {
                                console.log('err', response);
                            });
                    }
                });

        }

        function openDialogDivisions($event, processControl, usersType) {
            $mdDialog.show({
                controller: 'selectDivisionsController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/selectDivisions/selectDivisions.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    title: $translate.instant('RISK.DIVISIONS'),
                    divisions: vm.divisions,
                    currentDivisions: vm.currentControlDivisions[usersType],
                },
            })
                .then(function (resp) {
                    if (resp) {
                        var count = 0;
                        resp.forEach(element => {
                            if (element.selected && vm.currentControlDivisions[usersType].find(x => x.id == element.id)) {
                                count++;
                                if (count == resp.length) {
                                    vm.loadRisk(vm.currentRisk.activeRisk.id, usersType)
                                }
                            } else if (!element.selected && !vm.currentControlDivisions[usersType].find(x => x.id == element.id)) {
                                count++;
                                if (count == resp.length) {
                                    vm.loadRisk(vm.currentRisk.activeRisk.id, usersType)
                                }
                            } else if (element.selected && !vm.currentControlDivisions[usersType].find(x => x.id == element.id)) {
                                var options = {
                                    owner: $scope.owner,
                                    controlId: vm.currentControl.active_control_id,
                                    division: element.id,
                                    usersType: usersType
                                }
                                riskService.updateControlDivision(options)
                                    .then(function (response) {
                                        count++;
                                        // vm.currentControlDivisions[usersType].push(element);
                                        if (count == resp.length) {
                                            vm.loadRisk(vm.currentRisk.activeRisk.id, usersType)
                                        }
                                    })
                                    .catch(function (response) {
                                        vm.loadRisk(vm.currentRisk.activeRisk.id, usersType)
                                        console.log('err', response);
                                    });
                            } else if (!element.selected && vm.currentControlDivisions[usersType].find(x => x.id == element.id)) {
                                var options = {
                                    owner: $scope.owner,
                                    controlId: vm.currentControl.active_control_id,
                                    division: element.id,
                                    usersType: usersType
                                }
                                riskService.deleteControlDivision(options)
                                    .then(function (response) {
                                        count++;
                                        // vm.currentControlDivisions[usersType].splice(vm.currentControlDivisions[usersType].findIndex(x => x.id == element.id), 1);
                                        if (count == resp.length) {
                                            vm.loadRisk(vm.currentRisk.activeRisk.id, usersType)
                                        }
                                    })
                                    .catch(function (response) {
                                        vm.loadRisk(vm.currentRisk.activeRisk.id, usersType)
                                        console.log('err', response);
                                    });
                            }
                        });
                    }
                });

        }

        function showRiskLevel(riskLevel) {
            return vm.translate('RISK.RISK_LEVELS_' + riskLevel);
        }

        function openDialogText($event, text, title) {
            $mdDialog.show({
                controller: function ($timeout, $q, $scope, $mdDialog, $filter, title, text) {
                    var vm = this;
                    vm.text = text;
                    vm.title = title;
                    vm.closeDialog = function () {
                        $mdDialog.hide();
                    }
                },
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/textDialog/textDialog.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    title: title,
                    text: text
                },
            })
                .then(function (resp) {
                });

        }


        function updateProcessScore($event, process) {
            console.log(vm.currentRisk.activeRisk.company_id);
            var options = {
                owner: $scope.owner,
                companyId: vm.currentRisk.activeRisk.company_id,
                branch: vm.currentRisk.activeRisk.branch_id,
                process_id: process.id,
                date: moment().format('YYYY-MM-DD'),
                odds: process.oddsOfOccurrence,
                comment: ''
            }
            $mdDialog.show({
                controller: function ($timeout, $q, $scope, $mdDialog, score) {
                    var vm = this;
                    vm.score = score;
                    vm.comment = '';
                    vm.closeDialog = function () {
                        $mdDialog.hide();
                    }
                    vm.answer = function (answer) {
                        $mdDialog.hide(answer);
                    };
                },
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/process/oddOfOccurrence.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    score: options.odds
                },
            })
                .then(function (answer) {
                    if (answer) {
                        options.odds = answer.score;
                        options.comment = !angular.isUndefined(answer.comment) ? answer.comment : '';
                        riskService.processOddOfOccurrence(options)
                            .then(function (response) {
                                getCommentsProcess(process);
                                openRisk(vm.currentRisk, true);
                            })
                            .catch(function (response) {
                                console.log('err', response);
                            });
                    }
                });
        }

        function openEvidence(evidence, $event) {
            if (!evidence) {
                var evidence = {
                    active_control_id: vm.currentControl.active_control_id,
                    communication: {
                        compliance_officers: true,
                        in_charge: true,
                        participants: false
                    },
                    score: null,
                    title: '',
                    text: ''
                };
            }
            $mdDialog.show({
                controller: function ($timeout, $q, $scope, isComplianceOfficer, $mdDialog, tinyMceService, Owner, evidencesControlsService, evidence, storagePrefix, msUtils, $mdToast, $translate, $window, filesService) {
                    var vm = this;
                    vm.isComplianceOfficer = isComplianceOfficer;
                    console.log(vm.isComplianceOfficer)
                    vm.evidenceData = {
                        evidence: evidence,
                        files: []
                    };
                    var options = {
                        owner: Owner
                    }
                    evidencesControlsService.getCurrencies(options).then(function (res) {
                        vm.currencies = res.data;
                    })
                    vm.storagePrefix = storagePrefix;
                    vm.tinymceOptions = tinyMceService.getBasicOptions($scope);
                    vm.closeDialog = function () {
                        $mdDialog.hide();
                    }
                    vm.evidenceScoreColor = msUtils.evidenceScoreColor;
                    vm.save = function () {
                        $mdDialog.hide(vm.evidenceData);
                    };

                    vm.showFileInfo = function (f, ev) {
                        msUtils.showFileInfo(Owner, f, ev);
                    }
                    vm.updateEvidence = function () {
                        riskService.putEvidence({
                            owner: Owner,
                            item: vm.evidenceData.evidence
                        }).then(function (res) {
                            vm.updatingScore = false;
                        })
                    }

                    vm.downloadFile = function (f) {
                        filesService.getPresignedUrl({
                            owner: Owner,
                            file: f
                        }).then(function (res) {
                            $window.location.href = res.url;
                        })
                    }
                },
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/evidenceDetails/evidenceDetails.html',
                parent: angular.element(document.body),
                multiple: true,
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    evidence: evidence,
                    isComplianceOfficer: vm.isComplianceOfficer(),
                    Owner: $scope.owner,
                    storagePrefix: $scope.storagePrefix
                },
            })
                .then(function (newData) {
                    if (newData) {
                        vm.savingEvidence = true;
                        vm.evidenceData = newData.evidence;
                        vm.files = newData.files;
                        vm.saveEvidence();
                    }
                });

        }

        function getSymbolCurrency(id) {
            var found = _.find(vm.currencies, function (c) { if (c.id == id) { return true; } });
            return found ? found.symbol : null;
        }
        vm.openControlAssignDialogDirect = function(ev, process, risk) {
            if (!vm.companySelected) {
                console.error('vm.companySelected is undefined');
                return;
            }
        
            $mdDialog.show({
                controller: 'SelectControlDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/risk/dialogs/selectControlDialog/selectControlDialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Owner: $scope.owner,
                    process: process,
                    risk: risk,
                    company: vm.companySelected,
                    region_id: vm.companySelected.region_id
                }
            }).then(function(result) {
                if (result && result.selectedControls) {
                    // Manejar los controles seleccionados
                    console.log(result.selectedControls);
                    // Por ejemplo, añadir los controles seleccionados al proceso actual
                    process.controls = process.controls.concat(result.selectedControls);
                }
            });
        };
        
        
        
        

    


        function openRiskAndControlsSelectDialog(ev) {

            $mdDialog.show({
                controller: 'SelectRiskDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/risk/dialogs/selectRiskDialog/selectRiskDialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Owner: $scope.owner,
                    alreadySelected: vm.risks,
                    company: vm.companySelected
                }
            }).then(function (data) {
                if (data) {
                    $scope.isLoading = true;
                    var options = {
                        owner: $scope.owner,
                        risk_id: data.selectedRisk.id,
                        company_id: vm.companySelected.id,
                        branch_id: vm.branchSelected.id,
                        exclude: data.exclude
                    };
                    riskConfigService.activateRisk(options).then(function (response) {
                        $rootScope.pagination_resetquery();
                        var message = $translate.instant('RISKCONFIG.RISK_ADDED_SUCCESSFULLY');
                        $mdToast.show({
                            template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content bg-green">' + message + '</div></md-toast>',
                            hideDelay: 7000,
                            position: 'top right',
                            parent: '#content'
                        });
                        $mdDialog.hide({ completed: true });
                    });
                }
            });
        }

        function completeTask(task) {
            $timeout(function () {
                riskService.completeTask({
                    owner: $scope.owner,
                    id: task.id,
                    item: {
                        is_complete: task.is_complete
                    }
                }).then(function (res) {
                })

            })
        }

        function dateExpired(stringDate) {
            return moment.utc(stringDate) < moment.utc();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.risk')
        .service('riskService', riskService);

    /** @ngInject */
    // I provide access to the session store.
    function riskService($q, $resource, settingsDomainService, sessionService, companyService, COMMON, $rootScope, $window, $mdToast) {

        function getRisks(options) {
            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });

            resourceRisks.get({
                owner: options.owner,
                company_id: companyService.getCompanyId(),
                branch_id: companyService.getCompanyId() ? companyService.getBranch().id : '',
                page: options.page,
                resultsPerPage: options.resultsPerPage,
                search: options.searchStringFilter,
                paginate: options.paginate,
                sortField: options.sortField,
                sortDir: options.sortDir,
                filters: JSON.stringify(filters),
            },
                function (responseResult) {
                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getRisk(options) {
            var deferred = $q.defer();
            resourceRisk.get({
                owner: options.owner,
                id: options.id,
            },
                function (responseResult) {
                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function deleteActiveRisk(options) {
            var deferred = $q.defer();
            resourceRisk.delete({
                owner: options.owner,
                id: options.id,
            },
                function (responseResult) {
                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function updateRisk(options) {
            var deferred = $q.defer();
            resourceRisk.put({
                owner: options.owner,
                id: options.id,
            }, options.item,
                function (responseResult) {
                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function updateControl(options) {
            var deferred = $q.defer();
            resourceControl.put({
                owner: options.owner,
                id: options.item.active_control_id,
            }, {
                owner: options.owner,
                control: options.rename
            },
                function (responseResult) {
                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getEvidences(options) {
            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });

            resourceEvidences.get({
                owner: options.owner,
                active_control_id: options.activeControlId,
                withMessages: options.withMessages,
                withUser: options.withUser,
                withFiles: options.withFiles,
                sortField: options.sortField,
                sortDir: options.sortDir

            },
                function (responseResult) {
                    deferred.resolve(responseResult);
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function postEvidence(options) {
            var deferred = $q.defer();
            resourceEvidences.post({
                owner: options.owner,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function putEvidence(options) {
            var deferred = $q.defer();
            resourceUpdateEvidences.put({
                owner: options.owner,
                id: options.item.id,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getTasks(options) {
            var deferred = $q.defer();
            var filters = [];
            var userLogued = sessionService.getUser();
            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });
            var opt = {
                owner: options.owner,
                related_type: 'active_controls',
                related_id: options.activeControlId,
                withMessages: options.withMessages,
                mine: userLogued.user_type == 4,
                withUser: options.withUser,
                withFiles: options.withFiles,
                sortField: options.sortField,
                sortDir: options.sortDir

            }
            if (!opt.mine) {
                delete opt.mine;
            }
            resourceTasks.get(opt,
                function (responseResult) {
                    deferred.resolve(responseResult);
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getRisksMaster(options) {
            var deferred = $q.defer();
            var filters = [];
            const region = options.region_id;
            const params = region ? { owner: options.owner, resultsPerPage: 1000, region_id: region }
                : { owner: options.owner, resultsPerPage: 1000 };
            resourceRisksMaster.get(params,
                function (responseResult) {
                    deferred.resolve(responseResult);
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function postTask(options) {
            var deferred = $q.defer();
            resourceTasks.post({
                owner: options.owner,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateTask(options) {
            var deferred = $q.defer();
            resourceTask.put({
                owner: options.owner,
                id: options.item.id
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function completeTask(options) {
            var deferred = $q.defer();
            resourceTaskComplete.put({
                owner: options.owner,
                id: options.id,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getStoragePrefix(options) {
            var deferred = $q.defer();
            resourceStoragePrefix.get({
                owner: options.owner,
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getCompany(options) {
            var deferred = $q.defer();
            resourceCompany.get({
                owner: options.owner,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getBranches(options) {
            var deferred = $q.defer();
            resourceBranches.get(options,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function evaluateAnswer(options) {
            var deferred = $q.defer();
            resourceQuestion.post({
                owner: options.owner,
                evaluateAnswer: 'evaluateAnswers'
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getFilters(options) {
            var deferred = $q.defer();

            return (deferred.promise);
        }

        function updateControlUsers(options) {
            var deferred = $q.defer();

            resourceUpdateControlUsers.put({
                owner: options.owner,
                id: options.controlId,
                users: options.users,
                usersType: options.usersType
            },
                function (response) {
                    deferred.resolve({
                        result: response
                    });
                },
                function (e) {
                    deferred.reject({
                        result: e.data
                    });
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function updateControlDivision(options) {
            var deferred = $q.defer();

            resourceUpdateControlDivision.put({
                owner: options.owner,
                id: options.controlId,
                division: options.division,
                usersType: options.usersType
            },
                function (response) {
                    deferred.resolve({
                        result: response
                    });
                },
                function (e) {
                    deferred.reject({
                        result: e.data
                    });
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function deleteControlDivision(options) {
            var deferred = $q.defer();

            resourceUpdateControlDivision.delete({
                owner: options.owner,
                id: options.controlId,
                division: options.division,
                usersType: options.usersType
            },
                function (response) {
                    deferred.resolve({
                        result: response
                    });
                },
                function (e) {
                    deferred.reject({
                        result: e.data
                    });
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function processOddOfOccurrence(options) {
            var deferred = $q.defer();
            resourceOddOfOccurrence.post({
                owner: options.owner,
                process_id: options.process_id,
                company_id: options.companyId,
                branch_id: options.branch,
                date: options.date,
                odds: options.odds,
                comment: options.comment,
            },
                function (response) {
                    deferred.resolve({
                        result: response
                    });
                },
                function (e) {
                    deferred.reject({
                        result: e.data
                    });
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getProcessOddOfOccurrenceComments(options) {
            var deferred = $q.defer();

            resourceOddOfOccurrence.get({
                owner: options.owner,
                process_id: options.process_id,
                company_id: options.companyId,
                branch_id: options.branch_id
            },
                function (response) {
                    deferred.resolve({
                        result: response
                    });
                },
                function (e) {
                    deferred.reject({
                        result: e.data
                    });
                }
            );

            // Return the promise.
            return (deferred.promise);
        }



        var resourceRisks = $resource(COMMON.BASE_API + "/owner/:owner/activeTree/all", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            },

            post: {
                method: "POST",
                isArray: false
            },

            delete: {
                method: "DELETE",
                isArray: false
            },

            update: {
                method: "PUT",
                isArray: false
            },
        });
        var resourceRisksMaster = $resource(COMMON.BASE_API + "/owner/:owner/risk", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        });
        var resourceControl = $resource(COMMON.BASE_API + "/owner/:owner/activeTree/activeControl/:id", {
            // No default data
        }, {
            put: {
                method: "PUT",
                isArray: false
            },
        });

        var resourceRisk = $resource(COMMON.BASE_API + "/owner/:owner/activeTree/activeRisk/:id", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            },
            put: {
                method: "PUT",
                isArray: false
            },
            delete: {
                method: "DELETE",
                isArray: false
            }

        });

        var resourceEvidences = $resource(COMMON.BASE_API + "/owner/:owner/evidence", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            },
            post: {
                method: "POST",
                isArray: false
            },
        });
        var resourceUpdateEvidences = $resource(COMMON.BASE_API + "/owner/:owner/evidence/:id", {
            // No default data
        }, {
            put: {
                method: "PUT",
                isArray: false
            }
        });

        var resourceTasks = $resource(COMMON.BASE_API + "/owner/:owner/task", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            },
            post: {
                method: "POST",
                isArray: false
            },
            put: {
                method: "PUT",
                isArray: false
            },
        });

        var resourceTask = $resource(COMMON.BASE_API + "/owner/:owner/task/:id", {
            // No default data
        }, {
            put: {
                method: "PUT",
                isArray: false
            },
        });

        var resourceTaskComplete = $resource(COMMON.BASE_API + "/owner/:owner/task/:id/complete", {
            // No default data
        }, {
            put: {
                method: "PUT",
                isArray: false
            },
        });

        var resourceCompany = $resource(COMMON.BASE_API + "/owner/:owner/company/:id", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            },
        });

        var resourceBranches = $resource(COMMON.BASE_API + "/owner/:owner/branch/", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        });

        var resourceStoragePrefix = $resource(COMMON.BASE_API + "/owner/:owner/upload/storagePrefix", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        });

        var resourceUpdateControlUsers = $resource(COMMON.BASE_API + "/owner/:owner/activeTree/activeControlUsers/:id", {
            owner: '@owner',
            id: '@id'
            // No default data
        }, {
            put: {
                method: "PUT",
                isArray: false
            },
        });
        var resourceUpdateControlDivision = $resource(COMMON.BASE_API + "/owner/:owner/activeTree/activeControlDivisions/:id", {
            owner: '@owner',
            id: '@id'
            // No default data
        }, {
            put: {
                method: "PUT",
                isArray: false
            },
            delete: {
                method: "DELETE",
                isArray: false
            },
        });

        var resourceOddOfOccurrence = $resource(COMMON.BASE_API + "/owner/:owner/processOddsOfOccurrence", {
            owner: '@owner',
            // No default data
        }, {
            post: {
                method: "POST",
                isArray: false
            },
            get: {
                method: "GET",
                isArray: false
            },
        });


        return ({
            get: getRisks,
            getRisksMaster: getRisksMaster,
            getRisk: getRisk,
            updateRisk: updateRisk,
            getEvidences: getEvidences,
            postEvidence: postEvidence,
            putEvidence: putEvidence,
            getTasks: getTasks,
            postTask: postTask,
            updateTask: updateTask,
            updateControl: updateControl,
            completeTask: completeTask,
            deleteActiveRisk: deleteActiveRisk,
            getFilters: getFilters,
            getCompany: getCompany,
            getStoragePrefix: getStoragePrefix,
            getBranches: getBranches,
            evaluateAnswer: evaluateAnswer,
            updateControlUsers: updateControlUsers,
            updateControlDivision: updateControlDivision,
            deleteControlDivision: deleteControlDivision,
            processOddOfOccurrence: processOddOfOccurrence,
            getProcessOddOfOccurrenceComments: getProcessOddOfOccurrenceComments
        });

    }

})();
(function () {
    'use strict';

    angular
        .module('app.risk')
        .service('evidencesControlsService', evidencesControlsService);

    /** @ngInject */
    // I provide access to the session store.
    function evidencesControlsService($q, $resource, companyService, COMMON, $rootScope, $window, $mdToast) {

        function getControls(options) {
            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });

            var resources = $rootScope.showAllControls ? resourceRisksAll : resourceRisks;
            resources.get({
                owner: options.owner,
                company_id: companyService.getCompanyId(),
                branch_id: companyService.getCompanyId() ? companyService.getBranch().id : '',
                page: options.page,
                resultsPerPage: options.resultsPerPage,
                search: options.searchStringFilter,
                paginate: options.paginate,
                sortField: options.sortField,
                    sortDir: options.sortDir,
                filters: JSON.stringify(filters),
            },
                function (responseResult) {
                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getCurrencies(options) {


            var deferred = $q.defer();
            resourceCurrency.get({
                owner: options.owner
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);


        }

        function getFilters(options) {
            var deferred = $q.defer();

            return (deferred.promise);
        }

        var resourceCurrency = $resource(COMMON.BASE_API + "/owner/:owner/currency", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });

        var resourceRisks = $resource(COMMON.BASE_API + "/owner/:owner/activeTree/all?mine", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                delete: {
                    method: "DELETE",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                },
            });

        var resourceRisksAll = $resource(COMMON.BASE_API + "/owner/:owner/activeTree/all", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                delete: {
                    method: "DELETE",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                },
            });




        return ({
            get: getControls,
            getCurrencies: getCurrencies,
            getFilters: getFilters
        });

    }

})();
(function () {
	'use strict';

	angular.module('app.reports').controller('ReportsController', ReportsController);

	/** @ngInject */
	function ReportsController($scope, $rootScope, $stateParams, $translate, $document, $mdDialog, $mdMedia, $mdSidenav, $state, msApi, tinyMceService,
		divisionsService, riskService, jobPositionsService, requestContext, companyService, sessionService, mediaService, $timeout, reportsService, transformReports, $window
	) {
		var vm = this;

		vm.firstLoad = true;
		// Data
		vm.accounts = {
			creapond: 'johndoe@creapond.com',
			withinpixels: 'johndoe@withinpixels.com'
		};
		vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
		vm.selectedAccount = 'creapond';

		vm.folders = 'Folders.data';
		vm.labels = 'Labels.data';
		vm.loadingThreads = true;
		vm.companyBranches = [];
		vm.currentFilter = {
			type: $state.params.type,
			filter: $state.params.filter
		};
		vm.currentThread = null;
		vm.selectedThreads = [];

		vm.views = {
			split: 'app/main/apps/reports/views/list/split-view.html',
			nosplit: 'app/main/apps/reports/views/list/nosplit-view.html'
		};
		vm.defaultView = 'split';
		vm.currentView = 'split';

		vm.companySelected = undefined;
		vm.isCompanySelected = isCompanySelected;
		vm.readView = true;

		vm.isSelected = isSelected;
		vm.toggleSelectThread = toggleSelectThread;
		vm.selectThreads = selectThreads;
		vm.deselectThreads = deselectThreads;
		vm.toggleSelectThreads = toggleSelectThreads;
		vm.checkState = checkState;

		vm.setThreadStatus = setThreadStatus;
		vm.toggleThreadStatus = toggleThreadStatus;

		vm.changeView = changeView;
		vm.toggleSidenav = toggleSidenav;
		vm.tinymceOptions = tinyMceService.getOptions($scope);

		vm.openReport = openReport;
		vm.closeReport = closeReport;
		vm.sendReport = sendReport;
		vm.deleteReport = deleteReport;
		vm.duplicateReport = duplicateReport;
		vm.newReport = newReport;
		vm.checkFields = checkFields;

		vm.getPositionNameById = getPositionNameById;
		vm.openPreviewDialog = openPreviewDialog;
		vm.downloadReport = downloadReport;

		//////////

		$scope.$on('pagination:loadStart', function (event) {
			$scope.isLoading = true;
		});

		$scope.$on('pagination:loadPage', function (event) {
			$scope.isLoading = false;
		});

		vm.translate = function (text) {
			return $translate.instant(text);
		}

		vm.companySelectEvent = $rootScope.$on('company-selected', function (event) {
			vm.companySelected = sessionService.get('companySelected');
			$state.go('app.site_overview.report.list', {
				domain: $state.params.domain
			}, {
				notify: false,
				inherit: true,
				location: true
			});
			companyService.setCompanyId(vm.companySelected.id);
			getBranches();
			vm.closeReport();
			if ($state.current.name === "app.site_overview.report.list.active_report") {
				vm.openReport({ id_company: $state.params.id_company, id: $state.params.id });
			}
			if (!vm.firstLoad) {
				$timeout(function () {
					$rootScope.pagination_resetquery();
				});
			}

			vm.checkState();
			vm.firstLoad = false;
		});
		$scope.$on('$destroy', vm.companySelectEvent);
		$scope.$on('$destroy', function () {
			$timeout.cancel(vm.timeout);
		});
		function getBranches() {
			companyService
				.getBranches({
					owner: $scope.owner,
					company_id: vm.companySelected.id
				})
				.then(function (branchesResponse) {
					vm.companyBranches = branchesResponse.data;
					vm.companyBranches.push({
						id: null,
						name: vm.translate('REPORTS.ALL_BRANCHES')
					})
				});
		}
		function isCompanySelected() {
			if (angular.isObject(vm.companySelected)) {
				return true;
			}
			return false;
		}

		vm.monthFormat = buildLocaleProvider("MMM-YYYY");


		function buildLocaleProvider(formatString) {
			return {
				formatDate: function (date) {
					if (date) return moment(date).format(formatString);
					else return null;
				},
				parseDate: function (dateString) {
					if (dateString) {
						var m = moment(dateString, formatString, true);
						return m.isValid() ? m.toDate() : new Date(NaN);
					}
					else return null;
				}
			};
		}


		$scope.dateFields = [
			{
				type: 'date',
				required: false,
				binding: 'applicant.expectedGraduation',
				startView: 'month',
				label: 'Credit Card Expiry - Year/Month picker',
				mode: 'month',
				locale: vm.monthFormat
			}
		];



		$scope.owner = $stateParams.owner;
		init();

		/////////////////

		function init() {
			if (sessionService.get('companySelected')) {
				$rootScope.$broadcast('company-selected');
			}
			if (vm.companySelected) {
				getBranches();
			}
			var options = {
				owner: $scope.owner,
				resultsPerPage: 100
			};

			mediaService.getStoragePrefix({
				owner: $scope.owner,
			}).then(function (res) {
				$scope.storagePrefix = res.prefix;
			})
			divisionsService.getDivisions(options).then(function (res) {
				vm.divisions = res.result.data;
			});
			jobPositionsService.getJobs(options).then(function (res) {
				vm.jobpositions = res.result.data;
			});

			vm.people = [];

			riskService.getRisksMaster(options).then(function (res) {
				vm.risks = res.data;
			});
			if ($state.params.id_company) {
				$rootScope.$broadcast('select-company-id', $state.params.id_company);
			}
			vm.checkState();
		}

		function checkState() {
			if (vm.timeout) {
				$timeout.cancel(vm.timeout);
			}
			vm.timeout = $timeout(() => {
				if (vm.reports) {
					var found = vm.reports.find(x => !x.output || !x.output.status)
					if (found) {
						var options = {
							owner: $scope.owner,
							company_id: vm.companySelected.id,
							page: $rootScope.pagination_page
						}
						reportsService.get(options).then(function (response) {
							vm.reports = vm.reports.map(x => {
								if (!x.output || !x.output.status) {
									return response.result.data.find(y => y.id = x.id);
								}
								return x;
							});
							vm.checkState();
						})
					}
				}
			}, 30000);
		}


		// Watch screen size to change view modes
		$scope.$watch(
			function () {
				return $mdMedia('lt-sm');
			},
			function (current, old) {
				if (angular.equals(current, old)) {
					return;
				}

				if (current) {
					vm.currentView = 'nosplit';
				}
			}
		);

		$scope.$watch(
			function () {
				return $mdMedia('max-width: 960px');
			},
			function (big) {
				if (big) vm.currentView = 'nosplit';
			}
		);

		$scope.$watch(
			function () {
				return $mdMedia('min-width: 960px');
			},
			function (small) {
				if (small) vm.currentView = 'split';
			}
		);

		$scope.$watch(
			function () {
				return $mdMedia('gt-sm');
			},
			function (current, old) {
				if (angular.equals(current, old)) {
					return;
				}

				if (current) {
					if (vm.defaultView === 'split') {
						vm.currentView = 'split';
					}
				}
			}
		);

		var originatorEv;

		function openMenu($mdOpenMenu, ev) {
			originatorEv = ev;
			$mdOpenMenu(ev);
		}

		function openReport(report) {
			$state.go('app.site_overview.report.list.active_report', {
				id: report.id,
				id_company: vm.companySelected ? vm.companySelected.id : report.id_company,
				domain: $state.params.domain
			}, {
				notify: false,
				inherit: true,
				location: true
			});
			if (vm.reportNew) vm.reportNew = undefined;
			var options = {
				owner: $scope.owner,
				id: report.id
			};
			reportsService.getReportById(options).then(function (res) {
				vm.reportSelected = res;
				vm.keysReport = [];
				if (vm.reportSelected.output && vm.reportSelected.output.status && vm.reportSelected.executed_at !== '0000-00-00') {
					vm.keysReport = Object.keys(res.output);
					vm.keysReport.splice(vm.keysReport.indexOf('status'), 1);
					vm.keysReport.forEach(key => {
						vm.reportSelected['currentKeyUrl' + key] = true;
					});
				}
			});

		}

		function closeReport() {
			vm.reportSelected = undefined;
			vm.reportNew = undefined;
			$state.go('app.site_overview.report.list', {
				domain: $state.params.domain
			}, {
				notify: false,
				inherit: true,
				location: true
			});
		}

		function sendReport() {
			if (vm.reportSelected) {
				updateReport();
			} else if (vm.reportNew) {
				createReport();
			}
			initState();
		}

		function createReport() {
			adaptDates(vm.reportNew);

			var options = {
				owner: $scope.owner,
				item: vm.reportNew
			};
			reportsService.createReport(options).then(function (response) {
				vm.reportNew = undefined;
				$rootScope.pagination_resetquery();
				vm.checkState();
			});
		}

		function adaptDates(report, update) {
			if (report.from_date) {
				report.from_date = moment(report.from_date).format('YYYY-MM-DD');
			}
			var toDate;
			if (report.to_date) {
				if (update) {
					toDate = new Date(report.to_date);
				} else {
					toDate = report.to_date;
				}
			} else if (report.from_date) {
				toDate = new Date(report.from_date);
			}
			if (toDate) {
				report.to_date = new Date(toDate.getFullYear(), toDate.getMonth() + 1, 0);
				report.to_date = moment(report.to_date).format('YYYY-MM-DD');
			}
		}

		function updateReport() {
			adaptDates(vm.reportSelected, true)
			var options = {
				owner: $scope.owner,
				item: vm.reportSelected,
				id: vm.reportSelected.id
			};
			reportsService.updateReport(options).then(function (response) {
				vm.reportSelected = undefined;
				$rootScope.pagination_resetquery();
				vm.checkState();
			});
		}

		function openPreviewDialog() {
			$mdDialog.show({
				controller: 'dialogPreview',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/reports/dialogs/dialog-preview/dialog-preview.html',
				preserveScope: true,
				autoWrap: true,
				multiple: true,
				locals: {
					owner: $scope.owner,
					reportId: vm.reportSelected.id
				}
			}).then(function (res) {
				if (res && res.type) {
					if (res.type == 'upgrade') {
						console.log("go upgrade screen");
					} else {
						createUser(true);
					}
				}
			});
		}

		function downloadReport(key) {
			reportsService.getS3ReportPreSignedUrl({
				owner: $scope.owner,
				id: vm.reportSelected.id,
				key: key,
			}).then(function (res) {
				$window.location.href = res.url;
			})
		}

		function getPositionNameById(id) {
			for (var i = 0; i < vm.positions.length; i++) {
				if (vm.positions[i].id === id) return vm.positions[i].name;
			}
			return null;
		}

		function deleteReport(ev) {
			const message = $translate.instant('GLOBAL.ARE_YOU_SURE');
            const yes = $translate.instant('GLOBAL.YES');
            const no = $translate.instant('GLOBAL.NO');

            const confirm = $mdDialog.confirm()
                .title(message)
                .targetEvent(ev)
                .ok(yes)
                .cancel(no);

            $mdDialog.show(confirm).then(e => {
				var threads = angular.copy(vm.selectedThreads);
				vm.selectedThreads = [];
				for (var j = 0; j < threads.length; j++) {
					var options = {
						owner: $scope.owner,
						id: threads[j].id
					};
					reportsService.deleteReport(options).then(function (response) {
						$rootScope.pagination_resetquery();
					});
					initState();
				}
            })

		}

		function duplicateReport() {
			var threads = angular.copy(vm.selectedThreads);
			vm.selectedThreads = [];
			for (var j = 0; j < threads.length; j++) {
				var options = {
					owner: $scope.owner,
					item: transformReports.duplicateReport(threads[j])
				};
				reportsService.createReport(options).then(function (response) {
					$rootScope.pagination_resetquery();
					vm.checkState();
				});
				initState();
			}
		}

		function newReport() {
			if (vm.reportSelected) vm.reportSelected = undefined;
			vm.reportNew = {
				company_id: vm.companySelected.id,
				branch_id: null,
				title: '',
				from_date: '',
				to_date: '',
				data_json: {
					"filterType": null,
					"filterValue": [],
					"employees": {
						"active": false
					},
					"questionnaires": {
						"active": false,
						"no": false,
						"not_answered": false,
						"yes": {
							"active": false,
							"controls_no": false,
							"controls_yes": false,
							"controls_not_apply": false
						}
					},
					"risks": {
						"active": false,
						"conducts": false,
						"penalties": false,
						"factual_causes": false,
						"risk_level": false,
						"processes": {
							"active": false,
							"controls": {
								"active": false,
								"evidences": false,
								"action_plan": false,
								"nonconformity": false
							}
						}
					},
					"risk_map": {
						"active": false,
						"residual": false,
						"inherent": false
					}
				},
				is_recurrent: false,
				recurrent_frecuency: '',
				recurrent_range: ''
			};
		}

		function initState() {
			vm.reportSelected = undefined;
			vm.reportNew = undefined;
		}

		function checkFields() {
			if (vm.reportNew) {
				return transformReports.checkFields(vm.reportNew);
			} else if (vm.reportSelected) {
				return transformReports.checkFields(vm.reportSelected);
			}
		}


		/**
		 * Return selected status of the thread
		 *
		 * @param thread
		 * @returns {boolean}
		 */
		function isSelected(thread) {
			return vm.selectedThreads.indexOf(thread) > -1;
		}

		/**
		 * Toggle selected status of the thread
		 *
		 * @param thread
		 * @param event
		 */
		function toggleSelectThread(thread, event) {
			if (event) {
				event.stopPropagation();
			}

			if (vm.selectedThreads.indexOf(thread) > -1) {
				vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
			} else {
				vm.selectedThreads.push(thread);
			}
		}

		/**
		 * Select threads. If key/value pair given,
		 * threads will be tested against them.
		 *
		 * @param [key]
		 * @param [value]
		 */
		function selectThreads(key, value) {
			// Make sure the current selection is cleared
			// before trying to select new threads
			vm.selectedThreads = [];

			for (var i = 0; i < vm.reports.length; i++) {
				if (angular.isUndefined(key) && angular.isUndefined(value)) {
					vm.selectedThreads.push(vm.reports[i]);
					continue;
				}

				if (angular.isDefined(key) && angular.isDefined(value) && vm.reports[i][key] === value) {
					vm.selectedThreads.push(vm.reports[i]);
				}
			}
		}

		/**
		 * Deselect threads
		 */
		function deselectThreads() {
			vm.selectedThreads = [];
		}

		/**
		 * Toggle select threads
		 */
		function toggleSelectThreads() {
			if (vm.selectedThreads.length > 0) {
				vm.deselectThreads();
			} else {
				vm.selectThreads();
			}
		}

		/**
		 * Set the status on given thread, current thread or selected threads
		 *
		 * @param key
		 * @param value
		 * @param [thread]
		 * @param [event]
		 */
		function setThreadStatus(key, value, thread, event) {
			// Stop the propagation if event provided
			// This will stop unwanted actions on button clicks
			if (event) {
				event.stopPropagation();
			}

			// If the thread provided, do the changes on that
			// particular thread
			if (thread) {
				thread[key] = value;
				return;
			}

			// If the current thread is available, do the
			// changes on that one
			if (vm.currentThread) {
				vm.currentThread[key] = value;
				return;
			}

			// Otherwise do the status update on selected threads
			for (var x = 0; x < vm.selectedThreads.length; x++) {
				vm.selectedThreads[x][key] = value;
			}
		}

		/**
		 * Toggle the value of the given key on given thread, current
		 * thread or selected threads. Given key value must be boolean.
		 *
		 * @param key
		 * @param thread
		 * @param event
		 */
		function toggleThreadStatus(key, thread, event) {
			// Stop the propagation if event provided
			// This will stop unwanted actions on button clicks
			if (event) {
				event.stopPropagation();
			}

			// If the thread provided, do the changes on that
			// particular thread
			if (thread) {
				if (typeof thread[key] !== 'boolean') {
					return;
				}

				thread[key] = !thread[key];
				return;
			}

			// If the current thread is available, do the
			// changes on that one
			if (vm.currentThread) {
				if (typeof vm.currentThread[key] !== 'boolean') {
					return;
				}

				vm.currentThread[key] = !vm.currentThread[key];
				return;
			}

			// Otherwise do the status update on selected threads
			for (var x = 0; x < vm.selectedThreads.length; x++) {
				if (typeof vm.selectedThreads[x][key] !== 'boolean') {
					continue;
				}

				vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
			}
		}

		/**
		 * Change the view
		 *
		 * @param view
		 */
		function changeView(view) {
			if (vm.views[view]) {
				vm.defaultView = view;
				vm.currentView = view;
			}
		}

		/**
		 * Toggle sidenav
		 *
		 * @param sidenavId
		 */
		function toggleSidenav(sidenavId) {
			$mdSidenav(sidenavId).toggle();
		}
	}
})();

(function () {
	'use strict';

	angular.module('app.reports').service('reportsService', reportsService);

	/** @ngInject */
	// I provide access to the session store.
	function reportsService($q, $resource, settingsDomainService, sessionService, COMMON, $window, $mdToast) {
		function getReports(options) {
			var deferred = $q.defer();
			var filters = [];

			_.forEach(options, function (value, key, list) {
				if (_.isObject(list[key])) {
					_.forEach(list[key], function (filter, keyFilter, listFilter) {
						if (!_.isEmpty(filter.selected)) {
							filters.push({
								field: filter.field,
								name: filter.name,
								values: filter.selected
							});
						}
					});
				}
			});

			resourceReportsList.get(
				{
					owner: options.owner,
					company_id: options.companyId,
					sortField: 'updated_at',
					sortDir: 'desc',
					page: options.page
				},
				function (responseResult) {
					// angular.copy(response, modulecontent);
					// setActiveDomain(domain);

					deferred.resolve({
						result: responseResult
					});
				},
				function (e) {
					deferred.reject();
				}
			);

			// deferred.resolve({
			//     result: {
			//         data: [
			//             { name: "Test 1" }
			//         ]
			//     }

			// });

			// Return the promise.
			return deferred.promise;
		}

		function getReportById(options) {
			var deferred = $q.defer();
			resourceReports.get(
				{
					owner: options.owner,
					id: options.id
				},
				options.item,
				function (response) {
					deferred.resolve(response);
				},

				function (e) {
					deferred.reject();
				}
			);

			// Return the promise.
			return deferred.promise;
		}
		function getS3ReportPreSignedUrl(options) {
			var deferred = $q.defer();
			resourceReportsPresigned.post(
				{
					owner: options.owner
				},
				{
					report_id: options.id,
					reportKey: options.key
				},
				function (response) {
					deferred.resolve(response);
				},

				function (e) {
					deferred.reject();
				}
			);

			// Return the promise.
			return deferred.promise;
		}

		function updateReport(options) {
			var deferred = $q.defer();
			resourceReports.update(
				{
					owner: options.owner,
					id: options.id
				},
				options.item,
				function (response) {
					deferred.resolve(response);
				},

				function (e) {
					deferred.reject();
				}
			);

			// Return the promise.
			return deferred.promise;
		}

		function createReport(options) {
			var deferred = $q.defer();
			if (!options.item.is_recurrent) {
				delete options.item.recurrent_frecuency;
				delete options.item.recurrent_range;
			}
			resourceReportsCreate.post(
				{
					owner: options.owner
				},
				options.item,
				function (response) {
					deferred.resolve(response);
				},

				function (e) {
					deferred.reject();
				}
			);

			// Return the promise.
			return deferred.promise;
		}

		function deleteReport(options) {
			var deferred = $q.defer();
			resourceReports.delete(
				{
					owner: options.owner,
					id: options.id
				},
				function (response) {
					deferred.resolve(response);
				},

				function (e) {
					deferred.reject();
				}
			);

			// Return the promise.
			return deferred.promise;
		}

		function getFilters(options) {
			var deferred = $q.defer();

			return deferred.promise;
		}

		var resourceReports = $resource(
			COMMON.BASE_API + '/owner/:owner/report/:id?withChilds',
			{
				// No default data
			},
			{
				get: {
					method: 'GET',
					isArray: false
				},

				delete: {
					method: 'DELETE',
					isArray: false
				},

				update: {
					method: 'PUT',
					isArray: false
				}
			}
		);
		var resourceReportsCreate = $resource(
			COMMON.BASE_API + '/owner/:owner/report/:id',
			{
				// No default data
			},
			{
				post: {
					method: 'POST',
					isArray: false
				}
			}
		);
		var resourceReportsPresigned = $resource(
			COMMON.BASE_API + '/owner/:owner/report/getS3ReportPreSignedUrl',
			{
				// No default data
			},
			{
				post: {
					method: 'POST',
					isArray: false
				}
			}
		);
		var resourceReportsList = $resource(
			COMMON.BASE_API + '/owner/:owner/report?parentOnly',
			{
				// No default data
			},
			{
				get: {
					method: 'GET',
					isArray: false
				}
			}
		);

		return {
			get: getReports,
			getFilters: getFilters,
			getReportById: getReportById,
			getS3ReportPreSignedUrl: getS3ReportPreSignedUrl,
			updateReport: updateReport,
			createReport: createReport,
			deleteReport: deleteReport
		};
	}
})();

(function () {
    'use strict';

    angular
        .module('app.questions')
        .controller('QuestionsMasterController', QuestionsMasterController);

    /** @ngInject */
    function QuestionsMasterController($scope, $rootScope, $stateParams, $translate, $document, $mdDialog, $filter,
        $mdMedia, $mdSidenav, $state, msApi, tinyMceService, sessionService, clientsService, requestContext, mediaService, $timeout, questionsMasterService, transformQuestionsMaster) {
        var vm = this;
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
        vm.selectedAccount = 'creapond';

        vm.folders = 'Folders.data';
        vm.labels = 'Labels.data';
        vm.loadingThreads = true;
        vm.loadingReadPane = false;
        vm.currentFilter = {
            type: $state.params.type,
            filter: $state.params.filter
        };
        vm.currentThread = null;
        vm.selectedThreads = [];

        vm.views = {
            split: 'app/main/apps/questions-master/views/list/split-view.html',
            nosplit: 'app/main/apps/questions-master/views/list/nosplit-view.html'
        };
        vm.defaultView = 'split';
        vm.currentView = 'split';

        vm.readView = true;

        vm.allRegions = sessionService.config.regions;
        vm.searchRegionText = '';
        vm.regionSelected = questionsMasterService.currentRegion;

        //Methods
        vm.openThread = openThread;
        vm.closeThread = closeThread;

        vm.isSelected = isSelected;
        vm.toggleSelectThread = toggleSelectThread;
        vm.selectThreads = selectThreads;
        vm.deselectThreads = deselectThreads;
        vm.toggleSelectThreads = toggleSelectThreads;

        vm.setThreadStatus = setThreadStatus;
        vm.toggleThreadStatus = toggleThreadStatus;


        vm.changeView = changeView;
        vm.toggleSidenav = toggleSidenav;
        vm.tinymceOptions = tinyMceService.getOptions($scope);

        vm.openQuestion = openQuestion;
        vm.closeQuestion = closeQuestion;
        vm.sendQuestion = sendQuestion;
        vm.deleteQuestion = deleteQuestion;
        vm.duplicateQuestion = duplicateQuestion;
        vm.newQuestion = newQuestion;
        vm.checkFields = checkFields;
        vm.editProcessDialog = editProcessDialog;

        vm.getPositionNameById = getPositionNameById;
        vm.selectRegion = selectRegion;


        //////////

        $scope.$on('pagination:loadStart', function (event) {
            $scope.isLoading = true;
        });

        $scope.$on('pagination:loadPage', function (event) {
            $scope.isLoading = false;
        });


        $scope.owner = $stateParams.owner;
        init();

        /////////////////

        function init() {
            // getPositions();
            getRegions();
        }

        function getRegions() {
            clientsService.getRegions({ owner: $scope.owner }).then(function (res) {
                vm.regions = res.data;
            })
        }

        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'nosplit';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big)
                vm.currentView = 'nosplit';

        });

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small)
                vm.currentView = 'split';

        });

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                if (vm.defaultView === 'split') {
                    vm.currentView = 'split';
                }
            }
        });

        var originatorEv;

        function openMenu($mdOpenMenu, ev) {
            originatorEv = ev;
            $mdOpenMenu(ev);
        }

        function openQuestion(question) {
            vm.loadingReadPane = true;
            if (vm.questionNew) {
                vm.questionNew = undefined;

            } else {
                var options = {
                    owner: $scope.owner,
                    id: question.id
                }
                questionsMasterService.getQuestionById(options).then(function (response) {
                    vm.questionSelected = response;
                    if (vm.questionSelected.processes && vm.questionSelected.processes.length > 0) {
                        for (var i = 0; i < vm.questionSelected.processes.length; i++) {
                            var optionsProcess = {
                                id: vm.questionSelected.processes[i].id,
                                owner: $scope.owner,
                            }
                            var index = i;
                            questionsMasterService.getProcessById(optionsProcess).then(function (response) {
                                vm.questionSelected.processes[index] = JSON.parse(JSON.stringify(response));
                                vm.loadingReadPane = false;
                            });
                        }
                    } else {
                        vm.loadingReadPane = false;
                    }
                })
            }

        }

        function editProcessDialog(ev, questionRegionId) {
            if (!questionRegionId) {
                console.log('region required')
                return;
            }
            var currentRegion = $filter('filter')(sessionService.config.regions, {id: questionRegionId}, true)[0];
            $mdDialog.show({
                controller: 'SelectProcessDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/questions-master/dialogs/selectProcessDialog/selectProcessDialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Owner: $scope.owner,
                    regionSelected: currentRegion
                }
            }).then(function (newProcess) {
                if (newProcess) {
                    var optionsProcess = {
                        id: newProcess.id,
                        owner: $scope.owner,
                    }
                    questionsMasterService.getProcessById(optionsProcess).then(function (response) {
                        newProcess = response;
                        if (vm.questionSelected) {
                            if (vm.questionSelected.processes && vm.questionSelected.processes.length > 0) {
                                var optionsDelete = {
                                    owner: $scope.owner,
                                    id: vm.questionSelected.id,
                                    process_id: vm.questionSelected.processes[0].id
                                }
                                questionsMasterService.deleteProcessQuestion(optionsDelete).then(function (res) {
                                    updateProcess(vm.questionSelected, newProcess);
                                });
                            } else {
                                updateProcess(vm.questionSelected, newProcess);
                            }
                        } else {
                            createQuestion(newProcess)
                        }
                    });
                }
            });
        }

        function updateProcess(question, newProcess) {
            var options = {
                owner: $scope.owner,
                id: question.id,
                process_id: newProcess.id
            }
            questionsMasterService.updateProcessQuestion(options).then(function (res) {
                if (vm.questionNew) {
                    closeQuestion();
                    openQuestion(question);
                } else {
                    question.processes[0] = JSON.parse(JSON.stringify(newProcess));
                    $rootScope.pagination_resetquery();
                }
            })
        }

        function closeQuestion() {
            vm.questionSelected = undefined;
            vm.questionNew = undefined;
        }

        function sendQuestion() {
            if (vm.questionSelected) {
                updateQuestion();
            } else if (vm.questionNew) {
                createQuestion();
            }
            initState();
        }

        function createQuestion(newProcess) {
            var options = {
                owner: $scope.owner,
                item: vm.questionNew
            }
            questionsMasterService.createQuestionMaster(options).then(function (response) {
                if (!newProcess) {
                    vm.questionNew = undefined;
                    $rootScope.pagination_resetquery();
                } else {
                    updateProcess(response, newProcess);
                }
            })
        }

        function updateQuestion() {
            vm.questionSelected.region_id = parseInt(vm.questionSelected.region_id, 10);
            var options = {
                owner: $scope.owner,
                item: vm.questionSelected,
                id: vm.questionSelected.id
            }
            questionsMasterService.updateQuestionMaster(options).then(function (response) {
                vm.questionSelected = undefined;
                $rootScope.pagination_resetquery();
            })
        }



        function getPositionNameById(id) {
            for (var i = 0; i < vm.positions.length; i++) {
                if (vm.positions[i].id === id) return vm.positions[i].name;
            }
            return null;
        }

        function selectRegion(region, noFirst) {
            $scope.isLoading = true;
            vm.regionSelected = region;
            questionsMasterService.setCurrentRegion(region);
            vm.searchRegionText = '';
            $rootScope.pagination_resetquery();
        }


        function deleteQuestion() {
            var threads = angular.copy(vm.selectedThreads);
            vm.selectedThreads = [];
            for (var j = 0; j < threads.length; j++) {
                var options = {
                    owner: $scope.owner,
                    id: threads[j].id
                };
                questionsMasterService.deleteQuestionMaster(options).then(function (response) {
                    $rootScope.pagination_resetquery();
                })
                initState();
            }
        }

        function duplicateQuestion() {
            var threads = angular.copy(vm.selectedThreads);
            vm.selectedThreads = [];
            for (var j = 0; j < threads.length; j++) {
                var options = {
                    owner: $scope.owner,
                    item: transformQuestionsMaster.duplicateQuestionMaster(threads[j])
                };
                questionsMasterService.createQuestionMaster(options).then(function (response) {
                    $rootScope.pagination_resetquery();
                })
                initState();
            }
        }

        function newQuestion() {
            if (vm.questionSelected)
                vm.questionSelected = undefined;
            vm.questionNew = {};
        }

        function initState() {
            vm.questionSelected = undefined;
            vm.questionNew = undefined;
        }

        function checkFields() {
            if (vm.questionNew) {
                return transformQuestionsMaster.checkFields(vm.questionNew);
            } else if (vm.questionSelected) {
                return transformQuestionsMaster.checkFields(vm.questionSelected);
            }
        }



        /**
         * Open thread
         *
         * @param thread
         */
        function openThread(thread) {
            // // Set the read status on the thread
            // thread.read = true;

            // // Assign thread as the current thread
            // vm.currentThread = thread;

            // // Update the state without reloading the controller
            // $state.go('app.aircrafts.threads.thread', { threadId: thread.id }, { notify: false });
        }

        /**
         * Close thread
         */
        function closeThread() {
            // vm.currentThread = null;

            // // Update the state without reloading the controller
            // $state.go('app.aircrafts.threads', {
            //     type: vm.currentFilter.type,
            //     filter: vm.currentFilter.filter
            // }, { notify: false });
        }

        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        function isSelected(thread) {
            return vm.selectedThreads.indexOf(thread) > -1;
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        function toggleSelectThread(thread, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedThreads.indexOf(thread) > -1) {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            } else {
                vm.selectedThreads.push(thread);
            }
        }

        /**
         * Select threads. If key/value pair given,
         * threads will be tested against them.
         *
         * @param [key]
         * @param [value]
         */
        function selectThreads(key, value) {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedThreads = [];

            for (var i = 0; i < vm.questions.length; i++) {
                if (angular.isUndefined(key) && angular.isUndefined(value)) {
                    vm.selectedThreads.push(vm.questions[i]);
                    continue;
                }

                if (angular.isDefined(key) && angular.isDefined(value) && vm.questions[i][key] === value) {
                    vm.selectedThreads.push(vm.questions[i]);
                }
            }
        }

        /**
         * Deselect threads
         */
        function deselectThreads() {
            vm.selectedThreads = [];
        }

        /**
         * Toggle select threads
         */
        function toggleSelectThreads() {
            if (vm.selectedThreads.length > 0) {
                vm.deselectThreads();
            } else {
                vm.selectThreads();
            }
        }

        /**
         * Set the status on given thread, current thread or selected threads
         *
         * @param key
         * @param value
         * @param [thread]
         * @param [event]
         */
        function setThreadStatus(key, value, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                thread[key] = value;
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                vm.currentThread[key] = value;
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                vm.selectedThreads[x][key] = value;
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleThreadStatus(key, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                if (typeof (thread[key]) !== 'boolean') {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                if (typeof (vm.currentThread[key]) !== 'boolean') {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                if (typeof (vm.selectedThreads[x][key]) !== 'boolean') {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }




        /**
         * Change the view
         *
         * @param view
         */
        function changeView(view) {
            if (vm.views[view]) {
                vm.defaultView = view;
                vm.currentView = view;
            }
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.questions')
        .service('questionsMasterService', QuestionsMasterService);

    /** @ngInject */
    // I provide access to the session store.
    function QuestionsMasterService($q, $resource, settingsDomainService, sessionService, COMMON, $window, $mdToast, $filter) {

        function getQuestionsMaster(options) {
            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });


            resourceQuestionsMaster.get({
                owner: options.owner,
                page: options.page,
                region_id: currentRegion.id,
                resultsPerPage: options.resultsPerPage,
                search: options.searchStringFilter,
                paginate: options.paginate,
                sortField: 'name',
                sortDir: 'asc',
                filters: JSON.stringify(filters),
            },
                function (responseResult) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        function updateQuestionMaster(options) {
            var deferred = $q.defer();
            resourceQuestionsMaster.update({
                owner: options.owner,
                id: options.id
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function updateProcessQuestion(options) {
            var deferred = $q.defer();
            resourceProcessQuestion.post({
                owner: options.owner,
                id: options.id
            }, {
                    process_id: options.process_id
                },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function deleteProcessQuestion(options) {
            var deferred = $q.defer();
            resourceProcessQuestion.delete({
                owner: options.owner,
                id: options.id,
                process_id: options.process_id
            }, {
                    process_id: options.process_id
                },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function createQuestionMaster(options) {
            var deferred = $q.defer();
            resourceQuestionsMaster.post({
                owner: options.owner,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function deleteQuestionMaster(options) {
            var deferred = $q.defer();
            resourceQuestionsMaster.delete({
                owner: options.owner,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getFilters(options) {
            var deferred = $q.defer();

            return (deferred.promise);
        }

        function getQuestionById(options) {
            var deferred = $q.defer();
            resourceQuestionsMaster.get({
                owner: options.owner,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        function getProcessById(options) {
            var deferred = $q.defer();
            resourceProcess.get({
                owner: options.owner,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }



        function getProcesses(options) {
            var deferred = $q.defer();
            resourceProcess.get({
                owner: options.owner,
                region_id: options.region_id,
                resultsPerPage: 200,
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getRiskWithProcesses(options) {
            var deferred = $q.defer();
            resourceRisksWithProcesses.get({
                owner: options.owner,
                region_id: options.region_id,
                resultsPerPage: 200,
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }






        var resourceQuestionsMaster = $resource(COMMON.BASE_API + "/owner/:owner/question/:id", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                delete: {
                    method: "DELETE",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                },
            });

        var resourceProcessQuestion = $resource(COMMON.BASE_API + "/owner/:owner/question/:id/process", {
            // No default data
        }, {
                post: {
                    method: "POST",
                    isArray: true
                },

                delete: {
                    method: "DELETE",
                    isArray: false
                }
            });

        var resourceProcess = $resource(COMMON.BASE_API + "/owner/:owner/process/:id", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });
        var resourceRisksWithProcesses = $resource(COMMON.BASE_API + "/owner/:owner/risk?withProcesses", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });

        var currentRegion = $filter('filter')(sessionService.config.regions, {id: sessionService.user.region_id}, true)[0];

        function setCurrentRegion(region) {
            currentRegion = region;
        }

        return ({
            get: getQuestionsMaster,
            getQuestionsMaster: getQuestionsMaster,
            getFilters: getFilters,
            updateQuestionMaster: updateQuestionMaster,
            updateProcessQuestion: updateProcessQuestion,
            deleteProcessQuestion: deleteProcessQuestion,
            getQuestionById: getQuestionById,
            getProcessById: getProcessById,
            getProcesses: getProcesses,
            getRiskWithProcesses: getRiskWithProcesses,
            deleteQuestionMaster: deleteQuestionMaster,
            createQuestionMaster: createQuestionMaster,
            setCurrentRegion: setCurrentRegion,
            currentRegion: currentRegion

        });

    }

})();
(function () {
    'use strict';

    angular
        .module('app.proyects')
        .controller('proyectsController', proyectsController);

    /** @ngInject */
    function proyectsController($scope, $rootScope, $stateParams, companyService, $translate, $document, $mdDialog,
        $mdMedia, $mdSidenav, $state, msApi, tinyMceService, proyectsService, requestContext, evidencesControlsService,
        transformproyects, mediaService, Upload, $filter, $timeout, msUtils, documentsService, sessionService, $cookies, is_owner) {
        var vm = this;
        vm.userLogued = sessionService.getUser();
        if ($state.current.name == "app.site_overview.proyects.complaints") {
            vm.fromComplaint = true;
        }
        sessionService.getQuota().then(function (quota) {
            vm.quota = quota;
        });
        vm.companiesSROI = sessionService.getUser().companies;

        // vm.is_owner = is_owner;
        vm.ivhOptions = {
            defaultSelectedState: false,
            validate: true,
            expandToDepth: -1,
            useCheckboxes: true,
            twistieCollapsedTpl: '<md-icon md-font-icon="icon-chevron-right"></md-icon>',
            twistieExpandedTpl: '<md-icon md-font-icon="icon-chevron-down"></md-icon>',
            twistieLeafTpl: '<span style="cursor: default;">&#8192;&#8192;</span>'
        };
        vm.financing_options = [
            { id: 1, name: "Bancaria" },
            { id: 2, name: "Inversión de socio nacional" },
            { id: 3, name: "Inversión de socio extranjero" },
            { id: 4, name: "Capital riesgo" },
            { id: 5, name: "Subvenciones" },
            { id: 6, name: "Donaciones" }
        ];
        vm.sector_regulations_options = [
            { id: 1, name: "Protección de datos personales" },
            { id: 2, name: "Prevención de riesgos laborales" },
            { id: 3, name: "Blanqueo de Capitales" },
            { id: 4, name: "Normativa de defensa de la competencia" }
        ];
        vm.implemented_measures_options = [
            { id: 1, name: "Welcome pack" },
            { id: 2, name: "Canal de comunicaciones o denuncias" },
            { id: 3, name: "Código ético/Código de Conducta" },
            { id: 4, name: "Régimen disciplinario laboral" },
            { id: 5, name: "Formación a empleados" },
            { id: 6, name: "Otras" }
        ];
/*        vm.tipemoney = [
            { symbol: '€'},
            { symbol: '$' },
            { symbol: '£' }
        ];*/
        vm.showOptions = false;
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg', 'red-bg', 'yellow-bg', 'light-blue-bg'];
        vm.positionsIds = {
            administrator: 1,
            managerLegal: 2,
            compliance_officer: 3,
            compliance_comite: 5,
            data_protection: 4,
            collaborator: 24
        }

        vm.divisionsId = {
            administrator: 3,
            managerLegal: 3,
            compliance_officer: 1,
            compliance_comite: 1,
            data_protection: 2,
            collaborator: 1
        }

        // Data
        vm.accounts = {
            'creapond': 'johndoe@creapond.com',
            'withinpixels': 'johndoe@withinpixels.com'
        };
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
        vm.profileColors = ['md-blue-300-bg', 'md-blue-grey-300-bg', 'md-orange-300-bg', 'md-pink-300-bg', 'md-purple-300-bg', 'md-red-300-bg', 'md-yellow-300-bg', 'md-light-blue-300-bg'];
        vm.selectedAccount = 'creapond';

        vm.loadingStep = false;
        vm.folders = 'Folders.data';
        vm.labels = 'Labels.data';
        vm.loadingThreads = true;

        vm.currentFilter = {
            type: $state.params.type,
            filter: $state.params.filter
        };
        vm.currentThread = null;
        vm.selectedThreads = [];

        vm.views = {
            split: 'app/main/apps/proyects/views/list/split-view.html',
            nosplit: 'app/main/apps/proyects/views/list/nosplit-view.html'
        };
        vm.defaultView = 'split';
        vm.currentView = 'split';

        vm.readView = false;

        vm.branchFields = [
            { name: 'Nombre', type: 'text', field: 'name', translate: 'GLOBAL.NAME' },
            { name: 'Domicilio', type: 'text', field: 'address1', translate: 'GLOBAL.ADDRESS' },
            { name: 'Población', type: 'text', field: 'city', translate: 'GLOBAL.CITY' },
            { name: 'Provincia', type: 'text', field: 'state', translate: 'GLOBAL.PROVINCE' },
            { name: 'Codigo postal', type: 'number', field: 'postcode', translate: 'GLOBAL.POSTAL_CODE' },
            { name: 'Telefono', type: 'number', field: 'phone', translate: 'GLOBAL.PHONE' },
            { name: 'Email', type: 'email', field: 'email', translate: 'GLOBAL.EMAIL' }
        ];

        vm.personFields = [
            { name: 'Name', type: 'text', field: 'first_name', translate: 'GLOBAL.NAME', required: true },
            { name: 'Apellidos', type: 'text', field: 'last_name', translate: 'GLOBAL.SURNAMES', required: true },
            { name: 'NIF', type: 'text', field: 'id_number', translate: 'GLOBAL.NIF_CIF', required: true },
            { name: 'Email', type: 'text', field: 'email', translate: 'GLOBAL.EMAIL', required: true },
            { name: 'Password', type: 'password', field: 'password', translate: 'LOGIN.PASSWORD', required: false },
            { name: 'Picture', type: 'picture', field: 'picture', translate: '', required: false },
            { name: '3rd Party Company', type: 'text', field: '3rd_party_company_name', translate: 'proyects.3RD_PARTY_COMPANY' },
            { name: 'Profile Color', type: 'text', field: 'profile_color', translate: 'GLOBAL.PROFILE_COLOR', hidden: true },
            { name: 'User type', type: 'text', field: 'user_type', translate: 'GLOBAL.PROFILE_COLOR', hidden: true },
            // { name: 'Files', type: 'text', field: 'files', translate: 'GLOBAL.FILES', hidden: true },
            { name: 'Files', type: '', field: 'files', hidden: true, value: [] },
        ];

        vm.administratorFields = vm.personFields;
        vm.managerLegalFields = vm.personFields;
        vm.complianceFields = vm.personFields;
        vm.reportFields = vm.personFields;
        vm.personnelFields = vm.personFields;
        vm.getRegionLiteral = getRegionLiteral;
        vm.readView = false;
        vm.preview = false;


        vm.getSectorById = getSectorById;


        vm.idClient = undefined;
        vm.idCompany = undefined;
        vm.updateLogotype = false;
        vm.showForm = true;
        vm.allQuestions = true;
        $scope.storagePrefix = '';


        vm.isSelected = isSelected;
        vm.toggleSelectThread = toggleSelectThread;
        vm.selectThreads = selectThreads;
        vm.deselectThreads = deselectThreads;
        vm.toggleSelectThreads = toggleSelectThreads;

        vm.setThreadStatus = setThreadStatus;
        vm.toggleThreadStatus = toggleThreadStatus;


        vm.changeView = changeView;


        vm.toggleSidenav = toggleSidenav;
        vm.newForm = newForm;
        vm.closeForm = closeForm;
        vm.uploadMedia = uploadMedia;
        vm.upload = upload;
        vm.openDialogForm = openDialogForm;
        vm.openMenu = openMenu;
        vm.nextStep = nextStep;
        vm.prevStep = prevStep;
        vm.previousStep = previousStep;
        vm.deleteClient = deleteClient;
        vm.removeBranch = removeBranch;
        vm.editBranchDialog = editBranchDialog;
        vm.removeBranchFromForm = removeBranchFromForm;

        vm.tinymceOptions = tinyMceService.getOptions($scope);

        vm.mediaDialogSingle = mediaDialogSingle;
        vm.deleteLogotype = deleteLogotype;
        vm.openImageDialog = openImageDialog;
        vm.sendForm = sendForm;
        vm.goClients = goClients;
        vm.goQuestions = goQuestions;
        vm.finishQuestion = finishQuestion;
        vm.openCompany = openCompany;
        vm.editCompany = editCompany;
        vm.showUserImage = showUserImage;
        vm.editUser = editUser;
        vm.removeUser = removeUser;
        vm.addUsersJob = addUsersJob;
        vm.addUsersJobFromUserId = addUsersJobFromUserId;
        vm.getDivisionName = getDivisionName;
        vm.getPositionName = getPositionName;
        vm.isFromType = isFromType;
        vm.areFromType = areFromType;
        vm.getRegion = getRegion;

        vm.deleteCompany = deleteCompany;

        //////////
        $scope.$on('pagination:loadStart', function (event) {
            $scope.isLoading = true;
        });

        $scope.$on('pagination:loadPage', function (event) {
            $scope.isLoading = false;
            vm.is_owner = vm.companiesSROI.length <= 1;
            init();
        });


        $scope.owner = $stateParams.owner;


        vm.bag = [{
            label: 'Glasses',
            value: 'glasses',
            children: [{
                label: 'Top Hat',
                value: 'top_hat',
                children: [{
                    label: 'Top Hat',
                    value: 'top_hat',
                    children: [{
                        label: 'Top Hat',
                        value: 'top_hat'
                    }]
                }]
            }, {
                label: 'Curly Mustache',
                value: 'mustachio'
            }]
        }];

        this.awesomeCallback = function (node, tree) {
            // Do something with node or tree
        };

        this.otherAwesomeCallback = function (node, isSelected, tree) {
            // Do soemthing with node or tree based on isSelected
        };




        /////////////////

        function init() {
            getSectors();
            getDivisions();
            getPositions();
            getUsers();
            mediaService.getStoragePrefix({
                owner: $scope.owner,
            }).then(function (res) {
                $scope.storagePrefix = res.prefix;
            })
            evidencesControlsService.getCurrencies({ owner: $scope.owner }).then(function (res) {
                vm.currencies = res.data;
            })
            proyectsService.getRegions({ owner: $scope.owner }).then(function (res) {
                vm.regions = res.data;
            })
            proyectsService.getFileRegions().then(function (res) {
                vm.regionsLiterals = res;
            })
        }

        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'nosplit';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big) {
                vm.currentView = 'nosplit';
            }

        });

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small) {
                vm.currentView = 'split';
            }

        });

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                if (vm.defaultView === 'split') {
                    vm.currentView = 'split';
                }
            }
        });


        var originatorEv;

        function openMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        }

        function initFieldsForm(title) {
            let fields;
            if (title === 'branch') {
                fields = angular.copy(vm.branchFields);
            }
            else if (title === 'administrator') {
                fields = angular.copy(vm.administratorFields);
            }
            else if (title === 'managerLegal') {
                fields = angular.copy(vm.managerLegalFields);
            }
            else if (title === 'compliance') {
                fields = angular.copy(vm.complianceFields);
            }
            else if (title === 'report') {
                fields = angular.copy(vm.reportFields);
            }
            else if (title === 'personnel') {
                fields = angular.copy(vm.personnelFields);
            }
            fields.forEach(item => {
                if (item.name == 'Población') {
                    item.translate = vm.getRegionLiteral('city');
                }
                if (item.name == 'Provincia') {
                    item.translate = vm.getRegionLiteral('state');
                }
                if (item.name == 'NIF') {
                    item.translate = vm.getRegionLiteral('id_number');
                }
            })
            return fields;
        }
        function getRegionLiteral(literalKey) {
            if (!angular.isUndefined(vm.formWizard) && !angular.isUndefined(vm.formWizard.company) && vm.formWizard.company.region_id) {
                const literalsObject = vm.regionsLiterals.find(x => x.region_id === vm.formWizard.company.region_id)
                return literalsObject.literals[literalKey];
            } else {
                return '';
            }
        }

        function getSectorById(sector_id) {
            var found;
            if (vm.sectors) {
                for (var i = 0; i < vm.sectors.length; i++) {
                    if (vm.sectors[i].id == sector_id) {
                        found = vm.sectors[i]
                        break;
                    }
                }
            }
            return found;
        }

        function openDialogForm(title, branchId, saveNow, model, index, type) {
            var hasModel = true;
            var divisionId = '';
            var jobId = '';
            if (model === undefined || !model) {
                hasModel = false;
                var fields = initFieldsForm(title);
            }
            else {
                //var fields = angular.copy(model);
                var fields = initFieldsForm(title);
                angular.forEach(fields, function (f) {
                    if (!angular.isUndefined(model[f.field])) {
                        f.value = model[f.field];
                        if (f.field == 'division') {
                            divisionId = f.value;
                        } else if (f.field == 'position') {
                            jobId = f.value;
                        }
                    }
                })
            }

            if (!divisionId && type && !angular.isUndefined(vm.divisionsId[type])) {
                divisionId = vm.divisionsId[type];
            }
            if (!jobId && type && !angular.isUndefined(vm.positionsIds[type])) {
                jobId = vm.positionsIds[type];
            }

            if (angular.isUndefined(vm.formWizard[title])) {
                vm.formWizard[title] = [];
            }
            if (!vm.users) {
                vm.users = [];
            }
            if (!vm.mainUsers) {
                vm.mainUsers = [];
            }
            var usersDialog = vm.users.concat(vm.mainUsers);
            usersDialog = _.uniq(usersDialog, function (e) {
                return e.id;
            });
            $mdDialog.show({
                controller: 'DialogFormController',
                controllerAs: 'vm',
                locals: {
                    title: title,
                    fields: fields,
                    type: type,
                    users: angular.copy(usersDialog),
                    alreadySelected: type ? vm.areFromType(vm.formWizard[title], type) : vm.formWizard[title],
                    storagePrefix: $scope.storagePrefix,
                    branchId: branchId,
                    defaultDivision: divisionId,
                    owner: $scope.owner,
                    defaultJob: jobId,
                    positionsIds: vm.positionsIds,
                    idCompany: vm.idCompany,
                    user_type: model ? model.user_type : undefined,
                    isTiny: false
                },
                templateUrl: 'app/main/apps/proyects/dialogs/forms/dialog-view.html',
                parent: angular.element($document.body),
                targetEvent: 'ev',
                disableParentScroll: true,
                clickOutsideToClose: true,

            }).then(function (result) {

                if (result) {
                    if (result.fields && result.fields.files) {
                        vm.files = result.fields.files;
                        delete result.fields.files;
                    }
                    vm.quotaexceded = result.quotaexceded;
                    var existUser = result.existUser;
                    if (hasModel) {
                        angular.forEach(result.fields, function (f) {
                            // no se por que hay que tener el if siguiente pero las dejo ya que imagino que alguien las puso por algo.
                            if (!angular.isUndefined(model[f.field])) {
                                model[f.field] = f.value;
                            }
                            if (f.field == 'password' && !angular.isUndefined(f.value)) {
                                model[f.field] = f.value;
                            }
                        })
                        if (title !== 'branch') {
                            updateUser(title, index);
                        }

                    }
                    else {

                        if (branchId) {
                            var subIndex = createSubForm(title, result.fields, true, branchId);
                            if (!existUser) {
                                createUser(title, result.fields, subIndex, true);
                            } else {
                                var itemUser = vm.formWizard[title][subIndex];
                                upgradeRol(title, subIndex, itemUser)
                                vm.addUsersJobFromUserId(itemUser.division, itemUser.position, itemUser.branch_id, itemUser, true)
                            }
                        } else {
                            var subIndex = createSubForm(title, result.fields, true);
                            if (title !== 'branch') {
                                if (!existUser) {
                                    createUser(title, result.fields, subIndex, true);
                                } else {
                                    var itemUser = vm.formWizard[title][subIndex];
                                    upgradeRol(title, subIndex, itemUser)
                                    vm.addUsersJobFromUserId(itemUser.division, itemUser.position, itemUser.branch_id, itemUser, true)
                                }
                            }
                            else if (title === 'branch') {
                                saveRemainBranches();
                                //addBranchToForm(result.fields, subIndex);
                            }
                        }
                    }
                }
            });
        }

        function upgradeRol(title, index, itemUser) {
            if ((vm.positionsIds.compliance_officer == itemUser.position
                || vm.positionsIds.compliance_comite == itemUser.position
                || vm.positionsIds.data_protection == itemUser.position)
                && (itemUser.user_type > 3) && !vm.quotaexceded) {
                vm.formWizard[title][index].user_type = 3;
                updateUser(title, index);
            }
        }

        function getRegion(id) {
            if (vm.regions) {
                return vm.regions.find(x => x.id === id).name
            } else {
                return '';
            }
        }

        function getPositions() {
            var options = {
                owner: $scope.owner,
                resultsPerPage: 1000
            };
            proyectsService.getPositions(options).then(function (response) {
                vm.positions = response.data;
                var positionField = {
                    name: 'Position',
                    type: 'selector',
                    field: 'position',
                    translate: 'GLOBAL.POSITION',
                    options: [],
                    hidden: true
                }
                for (var i = 0; i < response.data.length; i++) {
                    positionField.options.push({ field: response.data[i].name, id: response.data[i].id });
                }
                vm.personFields.push(positionField);
            })
        }

        function getUsers(idCompany, inOwner) {
            var options = {
                owner: $scope.owner,
                //                inOwner: '',
                withFiles: true
            };
            proyectsService.getUsers(options).then(function (response) {
                vm.mainUsers = response.data;
            })
        }

        function getSectors() {
            var options = {
                owner: $scope.owner,
                resultsPerPage: 1000
            };
            proyectsService.getSectors(options).then(function (response) {
                vm.sectors = response.data;
            })
        }
        function getDivisions() {
            var options = {
                owner: $scope.owner,
                resultsPerPage: 1000
            };
            proyectsService.getDivisions(options).then(function (response) {
                vm.divisions = response.data;
                var divisionField = {
                    name: 'Division',
                    type: 'selector',
                    field: 'division',
                    translate: 'GLOBAL.DIVISION',
                    options: [],
                    hidden: true
                }
                for (var i = 0; i < response.data.length; i++) {
                    divisionField.options.push({ field: response.data[i].name, id: response.data[i].id });
                }
                vm.personFields.push(divisionField);

            })
        }


        function getCompany(id) {
            var options = {
                owner: $scope.owner,
                id: id
            };
            proyectsService.getCompany(options).then(function (response) {

                vm.idCompany = response.id;
                vm.formWizard.company = {};
                vm.formWizard.company = response;
                if (vm.formWizard.company.extra_data) {
                    vm.formWizard.company.extra_data = JSON.parse(vm.formWizard.company.extra_data);
                }
                destroyWatchers();
                initWatchers();
                vm.formWizard.branches = angular.copy(response.branches);
                vm.formWizard.branch = vm.formWizard.branches;
                delete (vm.formWizard.company.branches);

                if (response.logo.length > 0) {
                    proyectsService.getStoragePrefix(options).then(function (res) {
                        $scope.imageUrl = res.prefix + response.logo[0].url;
                        vm.logoIsLoaded = true;
                    })
                }
                else {
                    vm.logoIsLoaded = true;
                }
                var mainBranch = $filter('filter')(vm.formWizard.branches, { is_main: true });
                if (mainBranch) {
                    vm.formWizard.main_branch = mainBranch[0];
                    vm.mainBranch = vm.formWizard.main_branch;
                }
                initTree();
            })
        }

        function getBranches(idCompany) {
            var options = {
                owner: $scope.owner,
                company_id: idCompany
            };

            proyectsService.getBranches(options).then(function (response) {
                vm.branches = [];
                vm.formWizard.branches = transformproyects.branchesToForm(vm.branchFields, response.data, vm.formWizard, vm.branches);
                if (vm.formWizard.main_branch) {
                    vm.mainBranch = true;
                }
                initTree();
            })
        }

        function initTree() {
            vm.tree = [];
            vm.formWizard.personnel = [];
            angular.forEach(vm.formWizard.branches, function (branch) {
                var divisions = {};
                angular.forEach(branch.division_users, function (divisionUser) {
                    if (angular.isUndefined(divisions[divisionUser.division_id])) {
                        divisions[divisionUser.division_id] = {
                            label: divisionUser.division.name,
                            type: 'division',
                            children: [],
                            positions: {}
                        };
                    }
                    if (angular.isUndefined(divisions[divisionUser.division_id].positions[divisionUser.job_position_id])) {
                        divisions[divisionUser.division_id].positions[divisionUser.job_position_id] = {
                            label: divisionUser.job_position ? divisionUser.job_position.name : '',
                            type: 'job_position',
                            children: []
                        }
                    }

                    divisions[divisionUser.division_id].positions[divisionUser.job_position_id].children.push({
                        label: divisionUser.user.first_name + ' ' + divisionUser.user.last_name,
                        type: 'user',
                        user: divisionUser.user,
                        storagePrefix: $scope.storagePrefix
                    })
                    var personnel = angular.copy(divisionUser.user);
                    personnel.branch_id = branch.id;
                    personnel.division = divisionUser.division.id;
                    personnel.position = divisionUser.job_position ? divisionUser.job_position.id : divisionUser.job_position_id;
                    vm.formWizard.personnel.push(personnel);

                    divisions[divisionUser.division_id].children = [];
                    for (var key in divisions[divisionUser.division_id].positions) {
                        divisions[divisionUser.division_id].children.push(divisions[divisionUser.division_id].positions[key]);
                    }
                })
                var object = {
                    label: branch.name,
                    type: 'branch',
                    children: [
                    ]
                };
                for (var key in divisions) {
                    object.children.push(divisions[key]);
                }

                /*
                {
                            label: 'Dirección',
                            children: [
                                {
                                    label: 'Director'
                                },
                                {
                                    label: 'Administrador'
                                }
                            ]
                        }
                 */
                vm.tree.push(object);
            })
        }

        function getDataCompany(idCompany) {
            getCompany(idCompany);
        }

        function getInfoCompany(company) {
            companyToForm(company);
            getDataCompany(company.id);
            vm.legalDocumentsFolderID = null;
            var options = {
                owner: $scope.owner,
                id_company: company.id
            }
            proyectsService.getLegalFolder(options).then(function (res) {
                vm.legalDocumentsFolderID = res.id;
            })
        }

        function companyToForm(company) {
            vm.formWizard = {};
            vm.formWizard.company = {};
            vm.formWizard.company.name = company.name;
            vm.formWizard.personnel = [];
            vm.formWizard.branch = [];

        }

        function branchToForm(id) {
            var options = {
                owner: $scope.owner,
                id: id
            };
            proyectsService.getBranch(options).then(function (response) {
                vm.formWizard.branches = [];
                vm.formWizard.branches.push(transformproyects.branchToForm(angular.copy(vm.branchFields), response));
            })
        }

        function openCompany(company, ev) {
//            console.log(company);
            if (vm.fromComplaint) {
                $mdDialog.show({
                    controller: 'NewProyectDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/proyects/dialogs/new-proyect-dialog/new-proyect-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        company: company,
                        main_branch: {},
                        sectors: vm.sectors,
                        regions: vm.regions,
                        regionsLiterals: vm.regionsLiterals
                    }
                }).then(function (res) {
                    if (res) {
                        vm.formWizard = {};
                        vm.formWizard.company = res.company;
                        vm.formWizard.main_branch = res.branch;
                        delete vm.formWizard.company.extra_data;
                        $scope.image = res.image
                        vm.updateLogotype = res.updateLogotype;
                        $scope.isLoading = true;
                        vm.idCompany = res.company.id
                        vm.updateAfterLogo = true;
                        vm.forceUpdateBranch = true;
                        createCompany(null, true);
                    }
                });
            } else {
                vm.idCompany = company.id;
                //vm.readView = true;
                vm.preview = true;
                getInfoCompany(company);
            }

        }

        function editCompany() {
            vm.users = [];
            $rootScope.$broadcast('select-company', vm.formWizard.company);
            sessionService.set('companySelected', vm.formWizard.company);
            angular.forEach(vm.formWizard.personnel, function (u) {
                var userExists = $filter('filter')(vm.users, { id: u.id });
                if (userExists.length < 1) {
                    vm.users.push(u);
                }
            })
            vm.readView = true;
            vm.preview = false;
        }


        function createUser(type, subForm, subIndex, noPush) {
            //var itemUser = transformproyects.userToDTO(subForm, type);
            var itemUser = vm.formWizard[type][subIndex];
            if ((vm.positionsIds.compliance_officer == itemUser.position || vm.positionsIds.compliance_comite == itemUser.position || vm.positionsIds.data_protection == itemUser.position && itemUser.user_type > 3) && !vm.quotaexceded) {
                itemUser.user_type = 3;
            } else if (vm.positionsIds.collaborator == itemUser.position && !itemUser.user_type) {
                itemUser.user_type = 6; // Usuario COLLABORATOR
            } else if (itemUser.user_type > 4 || !itemUser.user_type) {
                if (itemUser.password) {
                    itemUser.user_type = 4;
                } else {
                    itemUser.user_type = 5;
                }
            }
            itemUser.region_id = vm.formWizard.company.region_id;
            if (!angular.isUndefined(itemUser.password) && itemUser.password.length == 0) {
                delete itemUser.password;
            }
            var options = {
                owner: $scope.owner,
                item: itemUser
            };
            proyectsService.createUser(options).then(function (response) {
                vm.users.push(response);
                vm.formWizard[type][subIndex].id = response.id;
                if (!angular.isUndefined(itemUser.position) && !angular.isUndefined(itemUser.division) && !angular.isUndefined(itemUser.branch_id)) {
                    vm.addUsersJobFromUserId(itemUser.division, itemUser.position, itemUser.branch_id, itemUser, noPush)
                }
                $scope.uploadingFotoUserId = response.id;
                if (vm.files.length > 0) {
                    angular.forEach(vm.files, function (f) {
                        vm.uploadMedia(f, response.id, 'user_photo')
                    })
                } else {
                    delete $scope.uploadingFotoUserId;
                    delete vm.files;
                }

            }, function (error) {
                getUsers();
                getDataCompany(vm.idCompany);
            })
        }

        function uploadMedia(file, idValue, uploadKey) {
            if (!file.$error) {
                var token = undefined;
                $scope.uploadingFile = true;
                console.debug("UPLOAD STARTED______****", file)
                mediaService.getS3UploadPreSignedUrl({
                    owner: $scope.owner,
                    uploadKey: uploadKey,
                    fileName: file.name,
                    rowId: idValue
                })
                    .then(function (resp) {
                        token = resp.token;
                        file.id_media = resp.id_media;
                        file.upload = Upload.http({
                            url: resp.url,
                            skipAuthorization: true,
                            method: 'PUT',
                            headers: {
                                "Content-Type": file.type != '' ? file.type : 'application/octet-stream'
                            },
                            data: file
                        })
                        file.upload.then(function (response) {
                            file.result = response.data;
                            $timeout(function () {
                                $scope.log = 'file: ' +
                                    file.name +
                                    ', Response: ' + JSON.stringify(response.data) +
                                    ', ID: ' + file.id_media +
                                    '\n' + $scope.log;
                            });
                            console.debug("FINISHING UPLOAD______****", file)
                            mediaService.finishedUploadingFileToCdn({
                                owner: $scope.owner,
                                idMedia: file.id_media,
                                token: token
                            }).then(function () {
                                $scope.uploadingFile = false;
                                getCompany(vm.idCompany);
                                delete $scope.uploadingFotoUserId;
                                delete vm.files;
                            })

                        }, function (response) {
                            if (response.status > 0)
                                $scope.errorMsg = response.status + ': ' + response.data;
                        });

                        file.upload.progress(function (evt) {
                            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                        });
                    })
            }
        };


        function updateUser(type, subIndex) {
            var itemUser = vm.formWizard[type][subIndex];
            if (itemUser.password && itemUser.user_type > 4) {
                itemUser.user_type = 4;
            }
            var options = {
                owner: $scope.owner,
                id: itemUser.id,
                item: itemUser
            };
            proyectsService.updateUser(options).then(function () {
                $scope.uploadingFotoUserId = itemUser.id;
                delete itemUser.password;
                if (vm.files && vm.files.length > 0) {
                    var uploading = false;
                    angular.forEach(vm.files, function (f) {
                        if (!f.url) {
                            uploading = true;
                            vm.uploadMedia(f, itemUser.id, 'user_photo')
                        }
                    })
                    if (!uploading) {
                        delete $scope.uploadingFotoUserId;
                        delete vm.files;
                    }
                } else {
                    delete $scope.uploadingFotoUserId;
                    delete vm.files;
                }
                getUsers();
                getDataCompany(vm.idCompany);
            });
        }

        function addUsersJob(divisionId, jobPositionId, branchId, title) {
            if (!angular.isUndefined(vm.formWizard[title]) && vm.formWizard[title].length > 0) {
                angular.forEach(vm.formWizard[title], function (u) {
                    if (angular.isUndefined(u.isAdded)) {
                        proyectsService.addUserToCompany({
                            owner: $scope.owner,
                            user_id: u.id,
                            company_id: vm.idCompany
                        }).then(function (response) {

                        })
                        proyectsService.addUserJobPosition({
                            owner: $scope.owner,
                            user_id: u.id,
                            branch_id: branchId,
                            division_id: divisionId,
                            job_position_id: jobPositionId
                        }).then(function (response) {
                            u.branch_id = branchId;
                            u.division = divisionId;
                            u.position = jobPositionId;
                            u.isAdded = true;
                            vm.formWizard.personnel.push(u);
                        })
                    }
                })
            }

        }
        function addUsersJobFromUserId(divisionId, jobPositionId, branchId, user, noPush) {
            if (angular.isUndefined(user.isAdded) && divisionId && jobPositionId && branchId) {
                proyectsService.addUserToCompany({
                    owner: $scope.owner,
                    user_id: user.id,
                    company_id: vm.idCompany
                }).then(function (response) {

                })
                proyectsService.addUserJobPosition({
                    owner: $scope.owner,
                    user_id: user.id,
                    branch_id: branchId,
                    division_id: divisionId,
                    job_position_id: jobPositionId
                }).then(function (response) {
                    user.branch_id = branchId;
                    user.division = divisionId;
                    user.position = jobPositionId;
                    user.isAdded = true;
                    if (!noPush) {
                        vm.formWizard.personnel.push(user);
                    }
                })
            }
        }
        function createBranch(subForm, isMain, addUsers, msWizard, close) {
            var item = transformproyects.createBranch(subForm, vm.idCompany, isMain, vm.formWizard.company.region_id);
            var options = {
                owner: $scope.owner,
                item: item,
            };
            proyectsService.createBranch(options).then(function (response) {
                if (isMain && vm.formWizard.main_branch) {
                    vm.formWizard.main_branch.id = response.id;
                    if (msWizard) {
                        if (!close) {
                            msWizard.nextStep();
                        } else {
                            vm.closeForm(true);
                        }
                        $timeout(function () {
                            angular.element('.content')[0].scrollTop = 0
                            vm.loadingStep = false;
                        })
                    }
                    if (addUsers) {
                        if (angular.isUndefined(vm.formWizard.personnel)) {
                            vm.formWizard.personnel = [];
                        }
                        var allAdministrators = $filter('filter')(vm.formWizard.personnel, { division: vm.divisionsId.administrator, position: vm.positionsIds.administrator });
                        var allManagers = $filter('filter')(vm.formWizard.personnel, { division: vm.divisionsId.managerLegal, position: vm.positionsIds.managerLegal });

                        angular.forEach(allAdministrators, function (u) {
                            u.branch_id = vm.formWizard.main_branch.id;
                            vm.addUsersJobFromUserId(u.division, u.position, u.branch_id, u, true)
                        })
                        angular.forEach(allManagers, function (u) {
                            u.branch_id = vm.formWizard.main_branch.id;
                            vm.addUsersJobFromUserId(u.division, u.position, u.branch_id, u, true)
                        })
                    }
                } else {
                    subForm.id = response.id;
                }
                if (!vm.branches) {
                    vm.branches = [];
                }
                vm.branches.push(response);
                if (!vm.formWizard.branch) {
                    vm.formWizard.branch = [];
                }
                    for (var i = 0; i < vm.formWizard.branch.length; i++) {
                    if (response.id == vm.formWizard.branch[i].id) {
                        vm.formWizard.branch[i] = response;
                    }
                }
                // getCompany(vm.idCompany)
            })
        }

        function addBranchToForm(subForm, isMain) {
            if (!vm.formWizard.branch) {
                vm.formWizard.branch = [];
            }
            vm.formWizard.branch.push(subForm);
        }

        function removeBranchFromForm($index) {
            if (!angular.isUndefined(vm.formWizard.branch[$index])) {
                var branchData = vm.formWizard.branch[$index];
                var options = {
                    owner: $scope.owner,
                    id: branchData.id,
                };
                proyectsService.deleteBranch(options)
                    .then(function (response) {
                        vm.formWizard.branch.splice($index, 1)
                    });
            }
        }

        function removeBranch($index) {
            var elementsToRemove = vm.formWizard.branches.splice($index, 1)
            var branch_id = transformproyects.getIdBranch(elementsToRemove[0]);
            var options = {
                owner: $scope.owner,
                id: branch_id,
            };
            proyectsService.deleteBranch(options);
        }
        function editBranchDialog($event, $index) {
            var branchSelected = vm.formWizard.branches[$index]
            $mdDialog.show({
                controller: 'EditBranchDialog',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/proyects/dialogs/edit-branch/edit-branch-dialog.controller.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    region_id: vm.formWizard.company.region_id,
                    branch: branchSelected
                },
            })
                .then(function (resp) {
                    if (resp) {
                        var options = {
                            owner: $scope.owner,
                            id: resp.id,
                            item: resp
                        };
                        proyectsService.updateBranch(options).then(function (response) {
                            vm.formWizard.branches[$index] = response;
                        })
                    }
                });
        }

        function getIdBranch(form, isMain) {
            if (isMain) {
                return form.id;
            }
            else {
                return transformproyects.getIdFromForm(form);
            }
        }

        function updateBranch(form, isMain, addUsers) {
            var options = {
                owner: $scope.owner,
                item: transformproyects.createBranch(form, vm.idCompany, isMain, vm.formWizard.company.region_id),
                id: getIdBranch(form, isMain)
            };
            proyectsService.updateBranch(options).then(function (response) {
            });
        }

        function updateSubForm(title, subForm, index) {
            transformproyects.updateFullName(subForm);
            vm.formWizard[title][index] = subForm;
        }

        function createSubForm(title, subForm, noFields, branchId) {
            if (noFields) {
                var newData = {};
                if (branchId) {
                    newData.branch_id = branchId;
                } else if (vm.formWizard.main_branch && vm.formWizard.main_branch.id) {
                    newData.branch_id = vm.formWizard.main_branch.id;
                }
                angular.forEach(subForm, function (field) {
                    if (field.field == 'profile_color') {
                        newData[field.field] = vm.profileColors[Math.floor(Math.random() * vm.profileColors.length)];
                    } else {
                        newData[field.field] = field.value;
                    }
                })
                subForm = newData
            } else {
                transformproyects.setFullName(subForm);
            }
            if (!vm.formWizard) {
                vm.formWizard = {};
            }
            if (angular.isUndefined(vm.formWizard[title])) {
                vm.formWizard[title] = [];
            }
            vm.formWizard[title].push(subForm);
            return (vm.formWizard[title].length > 0) ? vm.formWizard[title].length - 1 : undefined;
        }

        function newForm(ev) {
            if (vm.quota.companies_registered >= vm.quota.max_allowed_companies) {
                $mdDialog.show({
                    controller: 'CompanyQuotaDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/dialogs/companyQuotaDialog/companyQuotaDialog.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                    }
                }).then(function (res) {
                    if (res && res.type) {
                        if (res.type == 'upgrade') {
                            console.log("go upgrade screen");
                        } else {
                            vm.idCompany = '';
                            vm.mainBranch = {};
                            vm.readView = true;
                        }
                    }
                });
            } else {
                if (vm.fromComplaint) {
                    vm.idCompany = '';
                    $mdDialog.show({
                        controller: 'NewProyectDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/apps/proyects/dialogs/new-proyect-dialog/new-proyect-dialog.html',
                        parent: angular.element($document.body),
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        locals: {
                            company: null,
                            main_branch: null,
                            sectors: vm.sectors,
                            regions: vm.regions,
                            regionsLiterals: vm.regionsLiterals
                        }
                    }).then(function (res) {
                        if (res) {
                            vm.formWizard = {};
                            vm.formWizard.company = res.company;
                            vm.formWizard.main_branch = res.branch;
                            $scope.image = res.image
                            $scope.isLoading = true;
                            vm.forceCreateBranch = true;
                            createCompany(null, true);
                        }
                    });
                } else {
                    vm.idCompany = '';
                    vm.mainBranch = {};
                    vm.readView = true;
                    $timeout(function () {
                        vm.formWizard.company.region_id = sessionService.user.region_id;
                    }, 1000)
                }
            }
        }

        function closeForm(preview) {
            if (vm.idCompany) {
                getDataCompany(vm.idCompany);
                vm.readView = false;
                vm.preview = preview;
            } else {
                vm.goproyects();
            }
        }



        function createCompany(msWizard, close) {
            var options = {
                owner: $scope.owner,
                item: transformproyects.companyToDTO(vm.formWizard)
            };
//            console.log(options);
            vm.formWizard.company.region_id = options.item.region_id;
            if (vm.idCompany) {
                options.id = vm.idCompany;
                proyectsService.updateCompany(options).then(function (response) {
                    if (!close) {
                        msWizard.nextStep();
                    } else {
                        vm.closeForm(vm.fromComplaint ? false : true);
                        if (!vm.updateAfterLogo) {
                            $scope.isLoading = false;
                        }
                    }
                    if (vm.forceUpdateBranch) {
                        vm.formWizard.main_branch.name = vm.formWizard.company.name;
                        updateBranch(vm.formWizard.main_branch, true, true);
                    }
                });
                $timeout(function () {
                    angular.element('.content')[0].scrollTop = 0
                    vm.loadingStep = false;
                })

                if (vm.updateLogotype && $scope.image) {
                    uploadImage($scope.image, vm.idCompany, 'company_logo');
                    vm.updateLogotype = false;
                } else {
                    $scope.isLoading = false;
                }
            } else {
                options.item.is_owner = vm.companiesSROI.length > 0 ? 0 : true;
                proyectsService.createCompany(options).then(function (response) {
                        sessionService.authenticate($cookies.get('owner'));

                    vm.idCompany = response.id;
                    if (!vm.formWizard.main_branch) {
                        vm.formWizard.main_branch = {
                            name: msUtils.translate('GLOBAL.MAIN_BRANCH')
                        }
                    }
                    if (vm.forceCreateBranch) {
                        createBranch(vm.formWizard.main_branch, true, true, msWizard, false);
                    }
                    vm.formWizard.administrator = [];
                    vm.formWizard.managerLegal = [];
                    vm.formWizard.branches = [];
                    initWatchers();
                    getInfoCompany(response)
                    if ($scope.image) {
                        uploadImage($scope.image, vm.idCompany, 'company_logo', response);
                    } else {
                        $rootScope.$broadcast('select-company', response);
                        $scope.isLoading = false;
                    }
                    if (!close) {
                        msWizard.nextStep();
                        $timeout(function () {
                            angular.element('.content')[0].scrollTop = 0
                            vm.loadingStep = false;
                        })
                        $rootScope.pagination_resetquery();
                    }
                    $rootScope.pagination_resetquery();
                    sessionService.authenticate($cookies.get('owner'));
                    $rootScope.$broadcast('select-company', null);
                    companyService.setCompanyId(null);
                    sessionService.set('companySelected', null);
                })
            }
        }

        function uploadImage(file, idCompany, uploadKey, responseAndclose) {
            if (!file.$error) {
                var token = undefined;
                mediaService.getS3UploadPreSignedUrl({
                    owner: $scope.owner,
                    uploadKey: uploadKey,
                    fileName: file.name,
                    rowId: idCompany
                })
                    .then(function (resp) {
                        token = resp.token;
                        file.id_media = resp.id_media;
                        file.upload = Upload.http({
                            url: resp.url,
                            skipAuthorization: true,
                            method: 'PUT',
                            headers: {
                                "Content-Type": file.type != '' ? file.type : 'application/octet-stream'
                            },
                            data: file
                        });

                        file.upload.then(function (response) {
                            file.result = response.data;
                            $timeout(function () {
                                $scope.log = 'file: ' +
                                    file.name +
                                    ', Response: ' + JSON.stringify(response.data) +
                                    ', ID: ' + file.id_media +
                                    '\n' + $scope.log;
                            });
                            mediaService.finishedUploadingFileToCdn({
                                owner: $scope.owner,
                                idMedia: file.id_media,
                                token: token
                            }).then(res => {
                                if (responseAndclose || vm.updateAfterLogo) {
                                    vm.updateAfterLogo = false;
                                    $rootScope.$broadcast('select-company', responseAndclose);
                                    $rootScope.pagination_resetquery();
                                    $scope.isLoading = false;
                                }
                            })


                        }, function (response) {
                            if (response.status > 0) {
                                $scope.errorMsg = response.status + ': ' + response.data;
                            }
                        });

                        file.upload.progress(function (evt) {
                            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                        });

                    })
            }
        };

        function nextStep(msWizard, close) {
            vm.loadingStep = true;
            if (msWizard.selectedIndex === 0 || msWizard.selectedIndex === 1) {
                createCompany(msWizard, close);
            } else if (msWizard.selectedIndex === 2) {
                if (vm.formWizard.main_branch.id) {
                    updateBranch(vm.formWizard.main_branch, true, true);
                    if (!close) {
                        msWizard.nextStep();
                    } else {
                        vm.closeForm(true);
                    }
                    $timeout(function () {
                        angular.element('.content')[0].scrollTop = 0
                        vm.loadingStep = false;
                    })
                }
                else {
                    createBranch(vm.formWizard.main_branch, true, true, msWizard, close);
                    vm.mainBranch = true;
                    saveRemainBranches();
                }
            }
            else {
                msWizard.nextStep();
                $timeout(function () {
                    angular.element('.content')[0].scrollTop = 0
                    vm.loadingStep = false;
                })

            }
        }

        function saveRemainBranches() {
            if (!angular.isUndefined(vm.formWizard.branch) && vm.formWizard.branch.length > 0) {
                angular.forEach(vm.formWizard.branch, function (b) {
                    if (angular.isUndefined(b.id)) {
                        createBranch(b);
                    }
                })
            }

        }
        function previousStep(msWizard) {
            if (msWizard.selectedIndex === 0) {
                return true;
            }
            return false;
        }

        function prevStep(msWizard) {
            vm.loadingStep = true;
            msWizard.previousStep()
            $timeout(function () {
                angular.element('.content')[0].scrollTop = 0
                vm.loadingStep = false;
            })

        }
        function deleteClient() {
            var threads = angular.copy(vm.selectedThreads);
            vm.selectedThreads = [];
            for (var j = 0; j < threads.length; j++) {
                var options = {
                    owner: $scope.owner,
                    id: threads[j].id
                };
                proyectsService.deleteClient(options).then(function (response) {

                    $rootScope.pagination_resetquery();
                    sessionService.authenticate($cookies.get('owner'));
                    $rootScope.$broadcast('select-company', null);
                    companyService.setCompanyId(null);
                    sessionService.set('companySelected', null);
                 })
            }
        }

        function deleteLogotype() {
            if (vm.formWizard.company.logo.length > 0) {
                for (var i = 0; i < vm.formWizard.company.logo.length; i++) {
                    const itemLogo = vm.formWizard.company.logo[i];
                    var options = {
                        owner: $scope.owner,
                        id: itemLogo.id
                    }
                    documentsService.deleteDocument(options).then(function () {
                        vm.formWizard.company.logo = null;
                    })
                }
            }
            $scope.image = undefined;
            $scope.imageUrl = undefined;
        }

        function openImageDialog(ev, index, images, img) {
            var imagesCopy = [];
            imagesCopy.push(img);
            $mdDialog.show({
                controller: 'ImageDialogproyectsController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/proyects/dialogs/image/image-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Images: imagesCopy,
                    ImageSelected: img,
                    cropFormats: false,
                    MediaFull: false
                }
            });
        }


        function mediaDialogSingle(ev, field) {
            $mdDialog.show({
                controller: 'MediaproyectsController',
                controllerAs: 'vm',
                locals: {
                    owner: $scope.owner,
                    multipleSelection: true,
                    isTiny: false
                },
                templateUrl: 'app/main/apps/proyects/dialogs/media/media-clients.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true

            }).then(function (image) {
                if (image) {
                    if (($scope.image && vm.idCompany) || vm.idCompany) {
                        vm.updateLogotype = true;
                    }
                    $scope.image = image;
                }
            });
        }

        function sendForm() {
            vm.showForm = false;
        }

        function goClients() {
            vm.formWizard = {};
            $scope.image = undefined;
            $scope.imageUrl = undefined;
            vm.readView = false;
            vm.preview = false;
            vm.isQuestions = false;
            vm.showForm = true;
            vm.idCompany = '';
            vm.mainBranch = {};
            vm.branchQuestion = undefined;
            destroyWatchers()
            $rootScope.pagination_resetquery();
        }

        function goQuestions(sector) {
            var options = {
                owner: $scope.owner
            };
            if (!vm.allQuestions) {
                options.sector_id = vm.formWizard.company.sector_id;
            }
            proyectsService.getQuestions(options).then(function (response) {
                vm.questions = response.data;
                vm.isQuestions = true;
            })
        }

        function getAnswer() {
            return transformproyects.getAnswer(vm.questions);
        }

        function finishQuestion() {
            var item = {
                questions: getAnswer(),
                client_id: vm.idClient,
                branches: vm.branchQuestion
            };
            var options = {
                owner: $scope.owner,
                item: item
            };
            proyectsService.evaluateAnswer(options).then(function (response) {
            })
            goClients();
        }


        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        function isSelected(thread) {
            return vm.selectedThreads.indexOf(thread) > -1;
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        function toggleSelectThread(thread, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedThreads.indexOf(thread) > -1) {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            }
            else {
                vm.selectedThreads.push(thread);
            }
        }

        /**
         * Select threads. If key/value pair given,
         * threads will be tested against them.
         *
         * @param [key]
         * @param [value]
         */
        function selectThreads(key, value) {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedThreads = [];

            for (var i = 0; i < vm.proyects.length; i++) {
                if (angular.isUndefined(key) && angular.isUndefined(value)) {
                    vm.selectedThreads.push(vm.proyects[i]);
                    continue;
                }

                if (angular.isDefined(key) && angular.isDefined(value) && vm.proyects[i][key] === value) {
                    vm.selectedThreads.push(vm.proyects[i]);
                }
            }
        }

        /**
         * Deselect threads
         */
        function deselectThreads() {
            vm.selectedThreads = [];
        }

        /**
         * Toggle select threads
         */
        function toggleSelectThreads() {
            if (vm.selectedThreads.length > 0) {
                vm.deselectThreads();
            }
            else {
                vm.selectThreads();
            }
        }

        /**
         * Set the status on given thread, current thread or selected threads
         *
         * @param key
         * @param value
         * @param [thread]
         * @param [event]
         */
        function setThreadStatus(key, value, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                thread[key] = value;
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                vm.currentThread[key] = value;
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                vm.selectedThreads[x][key] = value;
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleThreadStatus(key, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                if (typeof (thread[key]) !== 'boolean') {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                if (typeof (vm.currentThread[key]) !== 'boolean') {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                if (typeof (vm.selectedThreads[x][key]) !== 'boolean') {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }


        /**
         * Change the view
         *
         * @param view
         */
        function changeView(view) {
            if (vm.views[view]) {
                vm.defaultView = view;
                vm.currentView = view;
            }
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function showUserImage(user) {
            return $scope.storagePrefix + user.files.url
        }

        function removeUser(usersArray, idx, type, branch) {
            var userToRemove = angular.copy(usersArray[idx]);
            var userId = userToRemove.id;
            var jobId = userToRemove.position;
            var typeRemove = type;
            var divisionId = userToRemove.division;
            var branchId = vm.formWizard.main_branch.id;
            if (branch) {
                branchId = branch.id;
            }
            if (!branchId) {
                usersArray.splice(idx, 1)
            } else {
                proyectsService.removeUserJobPosition({
                    owner: $scope.owner,
                    user_id: userId,
                    branch_id: branchId,
                    division_id: divisionId,
                    job_position_id: jobId
                }).then(function (response) {
                    angular.forEach(vm.formWizard.personnel, function (u, idx2) {
                        if (u.branch_id == branchId && u.id == userId && u.division == divisionId && u.position == jobId) {
                            vm.formWizard.personnel.splice(idx2, 1);
                        }
                    })
                }).catch(function () {
                    console.log('already removed');
                    angular.forEach(vm.formWizard.personnel, function (u, idx2) {
                        if (u.branch_id == branchId && u.id == userId && u.division == divisionId && u.position == jobId) {
                            vm.formWizard.personnel.splice(idx2, 1);
                        }
                    })
                })
            }
        }

        function editUser(usersArray, idx) {
            vm.openDialogForm('personnel', '', '', usersArray[idx], idx)
        }

        function getDivisionName(divisionId) {

            var x = vm.divisions.filter(function (division) {
                return (division.id == divisionId);
            });
            return x;
        }

        function getPositionName(positionId) {
            var x = vm.positions.filter(function (position) {
                return (position.id == positionId);
            });
            return x;
        }


        function areFromType(users, type) {
            var result = [];
            for (var i = 0; i < users.length; i++) {
                if (vm.isFromType(users[i], type)) {
                    result.push(users[i]);
                }
            }
            return result;
        }
        function isFromType(user, type) {
            if ((!user.branch_id || user.branch_id == vm.formWizard.main_branch.id) && user.position == vm.positionsIds[type] && user.division == vm.divisionsId[type]) {
                return true
            }
            return false;
        }


        function initWatchers() {
            vm.watchers = [];
            initWatcher('files_belogns_to_holding', 'belogns_to_holding');
            initWatcher('files_social_responsability', 'social_responsability');
            initWatcher('files_iva', 'iva');
            initWatcher('files_is', 'is');
        }
        function initWatcher(files_property, key) {
            vm.watchers.push($scope.$watch('vm.' + files_property, function () {
                $scope.formUpload = false;
                if (vm[files_property] != null) {
                    console.log(vm[files_property])
                    // make files array for not multiple to be able to be used in ng-repeat in the ui
                    if (!angular.isArray(vm[files_property])) {
                        $timeout(function () {
                            $scope[files_property] = vm[files_property] = [vm[files_property]];
                        });
                        return;
                    }
                    for (var i = 0; i < vm[files_property].length; i++) {
                        $scope.errorMsg = null;
                        (function (f) {
                            vm.upload(f, key);
                        })(vm[files_property][i]);
                    }
                }
            }));
        }

        function destroyWatchers() {
            if (vm.watchers) {
                for (var i = 0; i < vm.watchers.length; i++) {
                    const watcher = vm.watchers[i];
                    watcher();
                }
                vm.watchers = [];
            }
        }

        function deleteCompany(ev) {
            const message = $translate.instant('GLOBAL.ARE_YOU_SURE');
            const yes = $translate.instant('GLOBAL.YES');
            const no = $translate.instant('GLOBAL.NO');

            const confirm = $mdDialog.confirm()
                .title(message)
                .targetEvent(ev)
                .ok(yes)
                .cancel(no);

            $mdDialog.show(confirm).then(e => {
                vm.deleteClient();
            })
                .catch(err => { })

        }

        function upload(file, tag) {
            $scope[tag + '_isLoading'] = true;
            if (!file.$error) {
                //				console.debug("UPLOAD______****", file)
                documentsService.getS3UploadPreSignedUrl({
                    owner: $scope.owner,
                    fileName: file.name,
                    groupId: vm.legalDocumentsFolderID
                })
                    .then(function (resp) {
                        var token = resp.token;
                        file.upload = Upload.http({
                            url: resp.url,
                            skipAuthorization: true,
                            method: 'PUT',
                            headers: {
                                "Content-Type": file.type != '' ? file.type : 'application/octet-stream'
                            },
                            data: file
                        });

                        file.upload.then(function (response) {
                            file.result = response.data;
                            $timeout(function () {
                                $scope.log = 'file: ' +
                                    file.name +
                                    ', Response: ' + JSON.stringify(response.data) +
                                    ', ID: ' + file.id_media +
                                    '\n' + $scope.log;
                            });

                            vm.isLoading = true;
                            documentsService.finishedUploadingFile({
                                owner: $scope.owner,
                                token: token
                            }).then(function (response) {
                                vm.isLoading = false;
                                if (!vm.formWizard.company.extra_data[tag + '_files']) {
                                    vm.formWizard.company.extra_data[tag + '_files'] = [];
                                }
                                vm.formWizard.company.extra_data[tag + '_files'].push(JSON.parse(angular.toJson(response)))
                                $scope[tag + '_isLoading'] = false;
                                var options = {
                                    owner: $scope.owner,
                                    id: vm.idCompany,
                                    item: transformproyects.companyToDTO(vm.formWizard)
                                };
                                proyectsService.updateCompany(options).then(function (response) {
                                });
                                $mdDialog.hide({ update: true });
                            }, function (error) {
                                vm.isLoading = false;
                                vm.importError = error;
                            })
                            vm.importFinished = true;
                        }, function (response) {
                            if (response.status > 0)
                                $scope.errorMsg = response.status + ': ' + response.data;
                        });

                        file.upload.progress(function (evt) {
                            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                        });

                    })
            }
        };

        $scope.$on('$destroy', function () {
            destroyWatchers();
        });

    }
})();

(function () {
    'use strict';

    angular
        .module('app.proyects')
        .service('proyectsService', proyectsService);

    /** @ngInject */
    // I provide access to the session store.
    function proyectsService($q, $resource, settingsDomainService, sessionService, COMMON, $window, $mdToast, $state) {

        function getClients(options) {
            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });

            // var is_woner = 0;
            // if ($state.current.name.indexOf('mycompany') >= 0) {
            //     is_woner = 1;
            // }

            resourceClients.get({
                owner: options.owner,
                page: options.page,
                search: options.searchStringFilter,
                paginate: options.paginate,
                sortField: options.sortField,
                sortDir: options.sortDir,
                filters: JSON.stringify(filters),
                resultsPerPage: options.resultsPerPage,
                withCompany: options.withCompany,
                withLogo: true
            },
                function (responseResult) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getStoragePrefix(options) {
            var deferred = $q.defer();
            resourceStoragePrefix.get({
                owner: options.owner,
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateClient(options) {
            var deferred = $q.defer();
            resourceClients.update({
                owner: options.owner,
                id: options.id
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);

        }

        function createClient(options) {
            var deferred = $q.defer();
            resourceClients.post({
                owner: options.owner
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);

        }

        function createBranch(options) {
            var deferred = $q.defer();
            resourceBranch.post({
                owner: options.owner
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }



        function deleteBranch(options) {
            var deferred = $q.defer();
            resourceBranch.delete(options, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function deleteClient(options) {
            var deferred = $q.defer();
            resourceClients.delete({
                owner: options.owner,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateCompany(options) {
            var deferred = $q.defer();
            resourceCompany.update({
                owner: options.owner,
                id: options.id
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    console.log(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function createCompany(options) {
            var deferred = $q.defer();
            resourceCompany.post({
                owner: options.owner
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function createUser(options) {
            var deferred = $q.defer();
            resourceUser.post({
                owner: options.owner
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateUser(options) {
            var deferred = $q.defer();
            resourceUser.update({
                owner: options.owner,
                id: options.id
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function addUserToCompany(options) {
            var deferred = $q.defer();
            resourceAddToCompany.put({
                owner: options.owner
            }, {
                    user_id: options.user_id,
                    company_id: options.company_id
                },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function addUserJobPosition(options) {
            var deferred = $q.defer();
            resourceAddJobPosition.put({
                owner: options.owner
            }, {
                    user_id: options.user_id,
                    branch_id: options.branch_id,
                    division_id: options.division_id,
                    job_position_id: options.job_position_id
                },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function removeUserJobPosition(options) {
            var deferred = $q.defer();
            resourceRemoveJobPosition.delete({
                owner: options.owner,
                user_id: options.user_id,
                branch_id: options.branch_id,
                division_id: options.division_id,
                job_position_id: options.job_position_id
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getUsers(options) {
            var deferred = $q.defer();
            resourceUser.get(options,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateBranch(options) {
            var deferred = $q.defer();
            resourceBranch.update({
                owner: options.owner,
                id: options.id
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getQuestions(options) {
            var deferred = $q.defer();
            resourceQuestion.get({
                owner: options.owner,
                id_sector: options.sector_id
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getSectors(options) {
            var deferred = $q.defer();
            resourceSectors.get({
                owner: options.owner,
                resultsPerPage: options.resultsPerPage
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);

        }

        function getPositions(options) {
            var deferred = $q.defer();
            resourcePositions.get({
                owner: options.owner,
                resultsPerPage: options.resultsPerPage
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getFileRegions() {
            var deferred = $q.defer();
            resourceFile.get({},
                function (responseResult) {
                    deferred.resolve(JSON.parse(angular.toJson(responseResult)));
                },
                function (e) {
                    showError(e)
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getDivisions(options) {
            var deferred = $q.defer();
            resourceDivisions.get({
                owner: options.owner,
                resultsPerPage: options.resultsPerPage
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getLegalFolder(options) {
            var deferred = $q.defer();
            resourceLegalFolder.get({
                owner: options.owner,
                id_company: options.id_company
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getRegions(options) {
            var deferred = $q.defer();
            resourceRegions.get({
                owner: options.owner
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getCompany(options) {
            var deferred = $q.defer();
            resourceCompany.get({
                owner: options.owner,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getBranches(options) {
            var deferred = $q.defer();
            resourceBranches.get(options,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function evaluateAnswer(options) {
            var deferred = $q.defer();
            resourceQuestion.post({
                owner: options.owner,
                evaluateAnswer: 'evaluateAnswers'
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getFilters(options) {
            var deferred = $q.defer();

            return (deferred.promise);
        }

        var resourceFile = $resource("/assets/json-i18n/region-literals.json", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: true
                }
            });


        var resourceClients = $resource(COMMON.BASE_API + "/owner/:owner/company/:id", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                delete: {
                    method: "DELETE",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                },
            });

        var resourceSectors = $resource(COMMON.BASE_API + "/owner/:owner/sector", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });

        var resourceCompany = $resource(COMMON.BASE_API + "/owner/:owner/company/:id", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                }
            });

        var resourceUser = $resource(COMMON.BASE_API + "/owner/:owner/user/:id/", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                }
            });

        var resourceAddToCompany = $resource(COMMON.BASE_API + "/owner/:owner/user/addToCompany", {
            // No default data
        }, {
                put: {
                    method: "PUT",
                    isArray: false
                }
            });

        var resourceAddJobPosition = $resource(COMMON.BASE_API + "/owner/:owner/user/addDivisionJobPosition", {
            // No default data
        }, {
                put: {
                    method: "PUT",
                    isArray: false
                }
            });

        var resourceRemoveJobPosition = $resource(COMMON.BASE_API + "/owner/:owner/user/removeDivisionJobPosition/:user_id/:branch_id/:division_id/:job_position_id", {
            // No default data
        }, {
                delete: {
                    method: "DELETE",
                    isArray: false
                }
            });

        var resourceQuestion = $resource(COMMON.BASE_API + "/owner/:owner/question/:evaluateAnswer", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                }
            });

        var resourceBranch = $resource(COMMON.BASE_API + "/owner/:owner/branch/:id", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                },
                delete: {
                    method: "DELETE",
                    isArray: false
                }
            });
        var resourceBranches = $resource(COMMON.BASE_API + "/owner/:owner/branch/", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });
        var resourceStoragePrefix = $resource(COMMON.BASE_API + "/owner/:owner/upload/storagePrefix", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });

        var resourcePositions = $resource(COMMON.BASE_API + "/owner/:owner/jobPosition", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });

        var resourceDivisions = $resource(COMMON.BASE_API + "/owner/:owner/division", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });
        var resourceLegalFolder = $resource(COMMON.BASE_API + "/owner/:owner/fileGroup/legalDocuments/:id_company", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });
        var resourceRegions = $resource(COMMON.BASE_API + "/owner/:owner/region", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });


        return ({
            get: getClients,
            getFilters: getFilters,
            getFileRegions: getFileRegions,
            getRegions: getRegions,
            createClient: createClient,
            createCompany: createCompany,
            deleteClient: deleteClient,
            updateClient: updateClient,
            updateCompany: updateCompany,
            createUser: createUser,
            updateUser: updateUser,
            addUserToCompany: addUserToCompany,
            addUserJobPosition: addUserJobPosition,
            removeUserJobPosition: removeUserJobPosition,
            getSectors: getSectors,
            getQuestions: getQuestions,
            createBranch: createBranch,
            getLegalFolder: getLegalFolder,
            updateBranch: updateBranch,
            deleteBranch: deleteBranch,
            getCompany: getCompany,
            getStoragePrefix: getStoragePrefix,
            getBranches: getBranches,
            getPositions: getPositions,
            getDivisions: getDivisions,
            getUsers: getUsers,
            evaluateAnswer: evaluateAnswer
        });

    }

})();
(function () {
    'use strict';

    angular
        .module('app.questions')
        .controller('QuestionsController', QuestionsController);

    /** @ngInject */
    function QuestionsController($scope, $rootScope, $stateParams, $translate, $document, $mdDialog,
        $mdMedia, $mdSidenav, $state, msApi, tinyMceService, companyService, questionsService, riskService, evidencesControlsService, mediaService, Upload, requestContext,
        $timeout, sessionService, msUtils, $mdToast) {
        var vm = this;
        vm.branding = msUtils.getBranding();
        vm.userLogued = sessionService.getUser();
        $scope.owner = $stateParams.owner;
        $scope.isLoading = true;
        vm.riskSelected = null;
        vm.views = {
            split: 'app/main/apps/questions/views/questionnaires/split-view.html',
            nosplit: 'app/main/apps/questions/views/questionnaires/nosplit-view.html',
            // basic: 'app/main/apps/questions/views/questionnaires/basic.html',
            advanced: 'app/main/apps/questions/views/questionnaires/advanced.html'
        };

        vm.defaultView = 'split';
        vm.currentView = 'split';
        vm.detailsView = 'advanced';

        vm.readView = false;
        vm.firstLoad = true;

        vm.isAllChecked = isAllChecked;
        vm.selectAllQuestions = selectAllQuestions;
        vm.unselectAllQuestions = unselectAllQuestions;
        vm.changeView = changeView;
        vm.isCompanySelected = isCompanySelected;
        vm.isComplianceOfficer = isComplianceOfficer;
        vm.totalRiskControls = totalRiskControls;
        vm.totalRiskProcess = totalRiskProcess;
        vm.isBranchSelected = isBranchSelected;
        vm.setCompanySector = setCompanySector;
        vm.setCompanyBranches = setCompanyBranches;
        vm.setRisksToFilter = setRisksToFilter;
        vm.getAllSectors = getAllSectors;
        vm.startQuestionnaire = startQuestionnaire;
        vm.getQuestionnaire = getQuestionnaire;
        vm.closeQuestionnaire = closeQuestionnaire;
        vm.closeQuestion = closeQuestion;
        vm.answerQuestion = answerQuestion;
        vm.finishQuestion = finishQuestion;
        vm.answerQuestionControl = answerQuestionControl;
        vm.updateActiveControl = updateActiveControl;
        vm.deleteActiveControl = deleteActiveControl;
        vm.updateCompany = updateCompany;
        vm.selectBranch = selectBranch;
        vm.selectRisk = selectRisk;
        vm.getSymbolCurrency = getSymbolCurrency;
        vm.openQuestion = openQuestion;
        vm.getOddsProcess = getOddsProcess;
        vm.getQuestionAnswerClass = getQuestionAnswerClass;
        vm.setControlsData = setControlsData;
        vm.initControlsData = initControlsData;
        vm.initCurrentControl = initCurrentControl;
        vm.initEvidenceData = initEvidenceData;
        vm.saveEvidence = saveEvidence;
        vm.updateEvidences = updateEvidences;
        vm.checkUploadsAndUpdateEvidences = checkUploadsAndUpdateEvidences;
        vm.clearEvidence = clearEvidence;
        vm.showNewEvidence = showNewEvidence;
        vm.processQuestion = processQuestion;
        vm.updateRiskLevels = updateRiskLevels;
        vm.updateProcessScore = updateProcessScore;
        vm.openDialogUsers = openDialogUsers;
        vm.openDialogText = openDialogText;
        vm.toggleRename = toggleRename;
        vm.renameProcessOrControl = renameProcessOrControl;
        vm.showRiskLevel = showRiskLevel;
        vm.uploadMedia = uploadMedia;
        vm.showUserImage = showUserImage;
        vm.showUserImageFromId = showUserImageFromId;
        vm.showAddMoreQuestions = showAddMoreQuestions;
        vm.addMoreQuestions = addMoreQuestions;
        vm.cancelAddMoreQuestions = cancelAddMoreQuestions;
        vm.filterQuestions = filterQuestions;
        vm.hasChanges = hasChanges;
        vm.openEvidence = openEvidence;
        vm.editNameDialog = editNameDialog;

        vm.processAverageColor = msUtils.processAverageColor;
        vm.processAverageText = msUtils.processAverageText;
        vm.tinymceOptions = tinyMceService.getOptions($scope);
        vm.translate = msUtils.translate;
        vm.timeAgo = msUtils.timeAgo;

        vm.msScrollOptions = {
            suppressScrollX: true
        };

        vm.allSectors = [];
        vm.sectorSelected = '';
        vm.questionnaireType = '';
        vm.allUsers = [];
        vm.files = [];
        vm.checkAllSectors = true;

        function editNameDialog($event, type, item, process) {
            $mdDialog.show({
                controller: function ($timeout, $q, $scope, $mdDialog, riskService, Owner, type, item) {
                    var vm = this;
                    vm.item = angular.copy(item);
                    vm.item.name = vm.item.rename ? vm.item.rename : vm.item.name;
                    vm.process = process;
                    vm.type = type;
                    vm.closeDialog = function () {
                        $mdDialog.hide();
                    }
                    vm.saveDialog = function () {
                        var options = {
                            owner: Owner,
                            item: vm.item,
                            rename: {
                                control_rename: vm.item.name
                            }
                        }
                        riskService.updateControl(options).then(function () {
                            $mdDialog.hide({ rename: vm.item.name });
                        })
                    }
                },
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/risk/dialogs/edit-name/edit-name-dialog.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    Owner: $scope.owner,
                    type: type,
                    process: process,
                    item: item
                },
            })
                .then(function (resp) {
                    console.log(resp)
                    // if (resp && resp.rename) {
                    //     if (vm.type == "control") {
                    //         vm.openRisk(vm.currentRisk);
                    //         vm.currentControl.rename = resp.rename;
                    //     } else {
                    //         vm.currentProcess.rename = resp.rename;
                    //     }
                    // }
                });
        }

        function getAllSectors() {
            if (vm.allSectors.length == 0) {
                companyService.getSectors({
                    owner: $scope.owner,
                })
                    .then(function (sectorsResponse) {
                        if (sectorsResponse.total > 0) {
                            vm.allSectors = sectorsResponse.data;
                        }
                        else {
                            vm.allSectors = [];
                        }
                    });
            }
        }

        var companySelectEvent = $rootScope.$on('company-selected', function (event) {
            vm.updateCompany();
            getComplianceOfficers();
        });

        $scope.$on('$destroy', companySelectEvent);

        vm.currentQuestionaire = {
            company_id: '',
            branch_id: '',
            sector_id: '',
            questions: []
        }

        init();

        function init() {
            companyService.getSectors({
                owner: $scope.owner,
            })
                .then(function (sectorsResponse) {
                    if (sectorsResponse.total > 0) {
                        vm.allSectors = sectorsResponse.data;
                    }
                    else {
                        vm.allSectors = [];
                    }
                }).then(function () {
                    mediaService.getStoragePrefix({
                        owner: $scope.owner,
                    }).then(function (res) {
                        $scope.storagePrefix = res.prefix;
                    })

                    if (sessionService.get('companySelected')) {
                        vm.updateCompany();
                    }

                });
            evidencesControlsService.getCurrencies({ owner: $scope.owner }).then(function (res) {
                vm.currencies = res.data;
            })

            vm.loadingQuestions = false;
            vm.companySelected = sessionService.get('companySelected');
            if (vm.companySelected) {
                getComplianceOfficers();
            }

        }
        function selectAllQuestions() {
            var questionsToUpdate = vm.showAddMoreQuestionsDialog ? vm.availableQuestions : vm.allQuestions;
            questionsToUpdate = questionsToUpdate.map(x => {
                x.selected = true;
                return x;
            });
        }
        function unselectAllQuestions() {
            var questionsToUpdate = vm.showAddMoreQuestionsDialog ? vm.availableQuestions : vm.allQuestions;
            questionsToUpdate = questionsToUpdate.map(x => {
                x.selected = false;
                return x;
            });
        }
        function isAllChecked() {
            var questionsToCheck = vm.showAddMoreQuestionsDialog ? vm.availableQuestions : vm.allQuestions;
            return questionsToCheck.find(x => !x.selected) === undefined;
        }

        function getComplianceOfficers() {
            vm.companySelected = sessionService.get('companySelected');
            companyService.getComplianceOfficers({ owner: $scope.owner, id: vm.companySelected.id }).then(function (res) {
                vm.complianceOfficers = res;
            })
        }


        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'nosplit';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big)
                vm.currentView = 'nosplit';

        });

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small)
                vm.currentView = 'split';

        });

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                if (vm.defaultView === 'split') {
                    vm.currentView = 'split';
                }
            }
        });

        /**
         * Change the view
         *
         * @param view
         */
        function changeView(view) {
            if (vm.views[view]) {
                vm.defaultView = view;
                vm.currentView = view;
            }
        }

        function isCompanySelected() {
            if (angular.isObject(vm.companySelected)) {
                return true;
            }
            return false;
        }
        function isComplianceOfficer() {

            var found = _.find(vm.complianceOfficers, function (user) {
                return user.user_id == vm.userLogued.id
            })
            return found != undefined;
        }

        function isBranchSelected() {
            if (companyService.branch) {
                return true;
            }
            return false;
        }

        function setCompanySector() {
            angular.forEach(vm.allSectors, function (item) {
                if (item.id == vm.companySelected.sector_id) {
                    vm.sectorSelected = item;
                }
            })
        }

        function totalRiskControls(risks) {
            var totalControls = 0;
            angular.forEach(risks, function (risk) {
                angular.forEach(risk.processes, function (proc) {
                    totalControls += proc.controls.length;
                })
            })
            return totalControls
        }
        function totalRiskProcess(risks) {
            var totalProcess = 0;
            angular.forEach(risks, function (risk) {
                totalProcess += risk.processes.length;
            })
            return totalProcess
        }

        function setCompanyBranches(branches) {
            vm.companyBranches = branches;
            vm.branchSelected = '';
        }
        function setRisksToFilter(questions) {
            vm.risksToFilter = [];
            for (var i = 0; i < questions.length; i++) {
                var question = questions[i];
                if (question.question.processes[0]) {
                    if (!_.find(vm.risksToFilter, { 'id': question.question.processes[0].risks[0].id })) {
                        vm.risksToFilter.push(question.question.processes[0].risks[0]);
                    }
                }
            }
            vm.riskSelected = null;
        }

        function startQuestionnaire() {
            vm.loadingQuestions = true;
            var options = {
                owner: $scope.owner,
                companyId: vm.companySelected.id,
                branchId: vm.branchSelected.id,
                questionnaireType: vm.detailsView,
                sectorId: !vm.checkAllSectors ? vm.sectorSelected.id : null,
                "questions": vm.allQuestions.filter(x => x.selected).map(x => x.id)
            };
            questionsService.startQuestionnaire(options)
                .then(function (response) {
                    vm.loadingQuestions = false;
                    vm.getQuestionnaire();
                })
                .catch(function (response) {
                    console.log('err: questionnaire already started');
                });
        }

        function getQuestionnaire() {
            $scope.isLoading = true;
            questionsService.getQuestionnaire({
                owner: $scope.owner,
                companyId: vm.companySelected.id,
                branchId: vm.branchSelected.id,
            })
                .then(function (response) {
                    vm.currentQuestions = response.result.data
                    for (var i = 0; i < vm.currentQuestions.length; i++) {
                        const question = vm.currentQuestions[i];
                        question.index = i + 1;
                        if (question.question.processes[0]) {
                            question.id_risk = question.question.processes[0].risks[0].id;
                        }
                    }
                    vm.setRisksToFilter(vm.currentQuestions)
                    if (response.result.data.length > 0) {
                        vm.detailsView = response.result.data[0].questionnaire_type;
                    }
                    $scope.isLoading = false;
                })
                .catch(function (response) {
                    console.log(response);
                    $scope.isLoading = false;
                });
        }

        function closeQuestionnaire() {
            vm.currentQuestions = [];
            vm.currentView = 'options'
        }
        function closeQuestion() {
            vm.currentQuestion = null;
        }


        function processAnswerQuestion(question) {
            vm.currentQuestion.isLoading = true;
            questionsService.restoreAnswer({
                owner: $scope.owner,
                companyId: vm.companySelected.id,
                branch: vm.branchSelected.id,
                question: question.question.id,
            })
                .then(function (respAnswer) {
                    var idActiveRisk = respAnswer.result.activeRisks[0][0].id;
                    riskService.getRisk({
                        owner: $scope.owner,
                        id: idActiveRisk
                    }).then(function (resp) {
                        vm.currentRisk = resp.result;
                        angular.forEach(respAnswer.result.activeRisks, function (activeRisks) {
                            angular.forEach(activeRisks, function (activeRisk) {
                                angular.forEach(vm.currentQuestion.risks, function (processRisk) {
                                    if (processRisk.id == activeRisk.risk_id) {
                                        processRisk.id_active_risk = activeRisk.id;
                                        processRisk.reputation_impact = activeRisk.reputation_impact;
                                        processRisk.penal_code_impact = activeRisk.penal_code_impact;
                                        processRisk.client_loss = activeRisk.client_loss;
                                    }
                                })
                            })
                        })
                        angular.forEach(respAnswer.result.activeControls, function (activeControls) {
                            angular.forEach(activeControls, function (activeControl) {
                                angular.forEach(vm.currentQuestion.risks, function (risks) {
                                    angular.forEach(risks.processes, function (process) {
                                        angular.forEach(process.controls, function (processControl) {
                                            if (processControl.id == activeControl.control_id && processControl.process_id == activeControl.process_id) {
                                                vm.setControlsData(activeControl.process_id, activeControl.control_id, activeControl);
                                            }
                                        })
                                    })
                                })
                            })
                        })
                        if (vm.currentQuestion.is_answered &&
                            vm.currentQuestion.answer &&
                            vm.currentQuestion.is_finished === 0 &&
                            vm.currentQuestion.answer_json &&
                            vm.currentQuestion.answer_json.renames
                        ){
                            angular.forEach(vm.currentQuestion.risks, function (risks) {
                                angular.forEach(risks.processes, function (process) {
                                    if(vm.currentQuestion.answer_json.renames.processes &&
                                        vm.currentQuestion.answer_json.renames.processes.hasOwnProperty(process.id)
                                    ) {
                                        process.rename = vm.currentQuestion.answer_json.renames.processes[process.id]
                                    }
                                    angular.forEach(process.controls, function (control) {
                                        if (vm.currentQuestion.answer_json.renames.controls &&
                                            vm.currentQuestion.answer_json.renames.controls.hasOwnProperty(control.id)
                                        ) {
                                            control.rename = vm.currentQuestion.answer_json.renames.controls[control.id]
                                        }
                                    })
                                })
                            })
                        }
                        vm.currentQuestion.isLoading = false;
                    })
                });
        }

        function answerQuestion(ev, answer) {
            var message;
            if (answer) {
                message = $translate.instant('GLOBAL.ARE_YOU_SURE_YES');
            } else {
                message = $translate.instant('GLOBAL.ARE_YOU_SURE_NO');
            }
            var yes = $translate.instant('GLOBAL.YES');
            var no = $translate.instant('GLOBAL.NO');

            var confirm = $mdDialog.confirm()
                .title(message)
                // .htmlContent('<b>' + vm.contact.name + ' ' + vm.contact.lastName + '</b>' + ' will be deleted.')
                .targetEvent(ev)
                .ok(yes)
                .cancel(no);

            $mdDialog.show(confirm).then(function () {
                var question = vm.currentQuestion;
                if (!(question.is_answered == 1)) {
                    question.isLoading = true;
                    questionsService.answerQuestion({
                        owner: $scope.owner,
                        companyId: vm.companySelected.id,
                        branchId: vm.branchSelected.id,
                        questionId: question.question_id,
                        answer: answer
                    })
                        .then(function (response) {
                            var currQuestion = vm.currentQuestions.filter(function (item) {
                                return item.id === question.id;
                            })[0];
                            currQuestion.is_answered = 1;
                            currQuestion.answer = answer;

                            if (answer) {
                                questionsService.evaluateAnswer({
                                    owner: $scope.owner,
                                    companyId: vm.companySelected.id,
                                    branch: vm.branchSelected.id,
                                    question: question.question.id,
                                })
                                    .then(function (respAnswer) {
                                        if (vm.detailsView == 'advanced') {
                                            angular.forEach(respAnswer.result.activeRisks, function (activeRisks) {
                                                angular.forEach(activeRisks, function (activeRisk) {
                                                    angular.forEach(vm.currentQuestion.risks, function (processRisk) {
                                                        if (processRisk.id == activeRisk.risk_id) {
                                                            processRisk.id_active_risk = activeRisk.id;
                                                            processRisk.reputation_impact = activeRisk.reputation_impact;
                                                            processRisk.penal_code_impact = activeRisk.penal_code_impact;
                                                            processRisk.client_loss = activeRisk.client_loss;
                                                        }
                                                    })
                                                })
                                            })
                                            angular.forEach(respAnswer.result.activeControls, function (activeControls) {
                                                angular.forEach(activeControls, function (activeControl) {
                                                    angular.forEach(vm.currentQuestion.risks, function (risks) {
                                                        angular.forEach(risks.processes, function (process) {
                                                            angular.forEach(process.controls, function (processControl) {
                                                                if (processControl.id == activeControl.control_id && processControl.process_id == activeControl.process_id) {
                                                                    processControl.id_active_control = activeControl.id;
                                                                    vm.setControlsData(process.id, processControl.id, activeControl)
                                                                }

                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        }
                                        question.is_answered = 1;
                                        question.answer = answer;
                                        question.isLoading = false;

                                    })
                            }
                            else {
                                question.is_answered = 1;
                                question.answer = answer;
                                question.isLoading = false;
                                finish();
                            }
                        })
                        .catch(function (response) {
                            question.isLoading = false;
                        });
                }


            });

        }

        function finishQuestion(ev) {
            var message = $translate.instant('GLOBAL.ARE_YOU_SURE');
            var yes = $translate.instant('GLOBAL.YES');
            var no = $translate.instant('GLOBAL.NO');

            var confirm = $mdDialog.confirm()
                .title(message)
                // .htmlContent('<b>' + vm.contact.name + ' ' + vm.contact.lastName + '</b>' + ' will be deleted.')
                .targetEvent(ev)
                .ok(yes)
                .cancel(no);

            $mdDialog.show(confirm).then(function () {
                finish();
            })

        }

        function finish() {
            var question = angular.copy(vm.currentQuestion);
            if (!question.is_finished) {
                question.isLoading = true;
                questionsService.finishQuestion({
                    owner: $scope.owner,
                    companyId: vm.companySelected.id,
                    branchId: vm.branchSelected.id,
                    questionId: question.question_id,
                })
                    .then(function (response) {
                        var processRename, controlRename;
                        if (question.answer_json.renames) {
                            angular.forEach(question.risks, function (risks) {
                                angular.forEach(risks.processes, function (process) {
                                    processRename = false;
                                    if (question.answer_json.renames.processes.hasOwnProperty(process.id)) {
                                        processRename = question.answer_json.renames.processes[process.id]
                                    }
                                    angular.forEach(process.controls, function (processControl) {
                                        controlRename = false;
                                        if (question.answer_json.renames.controls.hasOwnProperty(processControl.id)) {
                                            controlRename = question.answer_json.renames.controls[processControl.id]
                                        }
                                        renameActiveControl(process, processRename, processControl, controlRename)
                                    })
                                })
                            })
                        }
                        question.isLoading = false;
                        var currQuestion = vm.currentQuestions.filter(function (item) {
                            return item.id === question.id;
                        })[0];
                        currQuestion.is_finished = true;
                        vm.currentQuestion.is_finished = true;
                        vm.closeQuestion();

                    })
                    .catch(function (response) {
                        question.isLoading = false;
                    });
            }
        }

        function renameActiveControl(process, processRename, control, controlRename) {
            vm.initCurrentControl();
            vm.currentControl.process = process.id;
            vm.currentControl.control = control.id;
            if (processRename !== false) {
                vm.controlsData[process.id][control.id].process_rename = processRename;
            }
            if (controlRename !== false) {
                vm.controlsData[process.id][control.id].control_rename = controlRename;
            }
            vm.updateActiveControl();
        }

        function answerQuestionControl(process, control, visible) {
            vm.initCurrentControl();

            if (!(vm.controlsData[process.id][control.id].is_answered == 1)) {
                vm.currentControl.process = process.id;
                vm.currentControl.control = control.id;
                if (control.id_active_control) {
                    vm.currentControl.id = control.id_active_control;
                    vm.controlsData[process.id][control.id].id_active_control = control.id_active_control;
                }
                vm.controlsData[process.id][control.id].visible = visible;
                vm.controlsData[process.id][control.id].is_answered = 1;
                if (visible) {
                    control.IN_CHARGE = angular.copy(process.IN_CHARGE);
                    control.PARTICIPANT = angular.copy(process.PARTICIPANT);
                    vm.controlsData[process.id][control.id].IN_CHARGE = control.IN_CHARGE;
                    vm.controlsData[process.id][control.id].PARTICIPANT = control.PARTICIPANT;
                }

                vm.updateActiveControl();
            }

        }
        function deleteActiveControl(process, control) {
            vm.currentControl.process = process.id;
            vm.currentControl.control = control.id;
            if (control.id_active_control) {
                vm.currentControl.id = control.id_active_control;
                vm.controlsData[process.id][control.id].id_active_control = control.id_active_control;
            }
            var options = {
                owner: $scope.owner,
                controlId: vm.controlsData[vm.currentControl.process][vm.currentControl.control].id_active_control
            }
            // console.log(control.id, control)
            questionsService.deleteActiveControl(options)
                .then(function (response) {
                    vm.controlsData[vm.currentControl.process][vm.currentControl.control] = null;
                });
        }

        function updateActiveControl() {
            var controlData = vm.controlsData[vm.currentControl.process][vm.currentControl.control];
            var options = {
                owner: $scope.owner,
                controlId: controlData.id_active_control,
                control: controlData
            }
            questionsService.updateControl(options)
                .then(function (response) {
                    if (controlData.IN_CHARGE.length > 0) {
                        var options = {
                            owner: $scope.owner,
                            controlId: controlData.id_active_control,
                            users: controlData.IN_CHARGE,
                            usersType: 'IN_CHARGE'
                        }
                        questionsService.updateControlUsers(options)
                            .then(function (response) {
                                console.log(response);
                            })
                            .catch(function (response) {
                                console.log('err', response);
                            });
                    }

                    if (controlData.PARTICIPANT.length > 0) {
                        var options = {
                            owner: $scope.owner,
                            controlId: controlData.id_active_control,
                            users: controlData.PARTICIPANT,
                            usersType: 'PARTICIPANT'
                        }
                        questionsService.updateControlUsers(options)
                            .then(function (response) {
                                console.log(response);
                            })
                            .catch(function (response) {
                                console.log('err', response);
                            });
                    }
                })
                .catch(function (response) {
                    console.log('err', response);
                });

            ;
        }

        function uploadMedia(file, idValue, uploadKey) {
            if (!file.$error) {
                var token = undefined;
                console.debug("UPLOAD______****", file)
                mediaService.getS3UploadPreSignedUrl({
                    owner: $scope.owner,
                    uploadKey: uploadKey,
                    fileName: file.name,
                    rowId: idValue
                })
                    .then(function (resp) {
                        token = resp.token;
                        file.id_media = resp.id_media;
                        file.upload = Upload.http({
                            url: resp.url,
                            skipAuthorization: true,
                            method: 'PUT',
                            headers: {
                                "Content-Type": file.type != '' ? file.type : 'application/octet-stream'
                            },
                            data: file
                        });

                        file.upload.then(function (response) {
                            file.result = response.data;
                            $timeout(function () {
                                $scope.log = 'file: ' +
                                    file.name +
                                    ', Response: ' + JSON.stringify(response.data) +
                                    ', ID: ' + file.id_media +
                                    '\n' + $scope.log;
                            });
                            console.debug("SEND_TO_CROP______****", file)
                            mediaService.finishedUploadingFileToCdn({
                                owner: $scope.owner,
                                idMedia: file.id_media,
                                token: token
                            })


                        }, function (response) {
                            if (response.status > 0)
                                $scope.errorMsg = response.status + ': ' + response.data;
                        });

                        file.upload.progress(function (evt) {
                            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                        });

                    })
            }
        };

        function updateCompany() {
            $scope.isLoading = true;
            vm.currentQuestion = '';
            vm.risks = [];
            vm.companySelected = sessionService.get('companySelected');
            vm.branchSelected = '';
            vm.sectorSelected = '';
            companyService.setCompanyId(vm.companySelected.id);
            vm.setCompanySector();
            questionsService.getAllQuestions({
                owner: $scope.owner,
                resultsPerPage: 1500,
                withProcesses: true,
                region_id: vm.companySelected.region_id
            }).then(function (res) {
                vm.allQuestions = res.result.data
            })
            companyService.getBranches({
                owner: $scope.owner,
                company_id: vm.companySelected.id,
                withUsers: true,
            })
                .then(function (branchesResponse) {
                    $scope.isLoading = false;
                    if (branchesResponse.total > 0) {
                        vm.setCompanyBranches(branchesResponse.data);
                        if ($state.params.branch) {
                            angular.forEach(branchesResponse.data, function (b) {
                                if (b.id == $state.params.branch) {
                                    vm.selectBranch(b);
                                }
                            })
                        } else {
                            var mainBranch = _.find(branchesResponse.data, function (item) {
                                return item.is_main;
                            })
                            vm.selectBranch(mainBranch)
                        }
                    }
                    else {
                        vm.branchSelected = undefined;
                        vm.searchBranchText = '';
                        vm.companyBranches = [];
                    }
                });
        }

        function selectBranch(branch) {
            vm.currentQuestion = '';
            vm.risks = [];
            companyService.setBranch(branch)
            vm.branchSelected = branch;
            vm.searchBranchText = '';
            $state.go('.', {
                domain: vm.companySelected.id,
                branch: branch.id
            });
            vm.getQuestionnaire();
        }
        function selectRisk(risk) {
            vm.riskSelected = risk;
            vm.searchRiskText = '';
        }

        function openQuestion(question) {
            vm.initControlsData();
            vm.initCurrentControl();
            vm.currentQuestion = angular.copy(question);
            vm.processQuestion(vm.currentQuestion);
            vm.selectedQuestionID = question.id
            vm.detailsView = question.questionnaire_type;
            if (vm.currentQuestion.is_answered == 1) {
                processAnswerQuestion(vm.currentQuestion);
            }
            // if (vm.currentQuestion.is_finished) {
            //     vm.detailsView = 'basic';
            // }

        }


        function getOddsProcess(_process) {
            _process.score = _process.default_odds_of_occurrence;
            var options = {
                owner: $scope.owner,
                id_process: _process.id,
                company_id: vm.companySelected.id,
                branch_id: vm.branchSelected.id
            };
            questionsService.getProcessOdds(options).then(function (res) {
                if (res.result.data.length > 0) {
                    _process.score = res.result.data[res.result.data.length - 1].odds;
                    _process.id_score = res.result.data[res.result.data.length - 1].id;
                }
            });


        }

        function getQuestionAnswerClass(question) {
            if (question.is_finished) {
                if (question.answer) {
                    return 'md-green-600-bg';
                }
                else {
                    return 'md-red-600-bg';
                }
            }
            else if (question.is_answered == 1) {
                return 'md-yellow-600-bg';
            }
            else {
                return 'md-blue-300-bg';
            }

        }

        function setControlsData(processId, controlId, controlData) {
            if (angular.isUndefined(vm.controlsData[processId])) {
                vm.controlsData[processId] = {};
            }
            if (angular.isUndefined(vm.controlsData[processId][controlId])) {
                vm.controlsData[processId][controlId] = {
                    id_active_control: '',
                    isLoading: false,
                    is_answered: 0,
                    visible: false,
                    newEvidence: false,
                    evidences: [],
                    IN_CHARGE: [],
                    PARTICIPANT: []
                };
            }
            if (controlData) {
                vm.controlsData[processId][controlId].id_active_control = controlData.id;
                vm.controlsData[processId][controlId].control_rename = controlData.control_rename;
                vm.controlsData[processId].process_rename = controlData.process_rename;
                vm.controlsData[processId][controlId].is_answered = controlData.is_answered;
                vm.controlsData[processId][controlId].visible = controlData.visible;
                if (vm.currentRisk && vm.currentRisk.users) {
                    angular.forEach(vm.currentRisk.users, function (user) {
                        if (user.active_control_id == vm.controlsData[processId][controlId].id_active_control) {
                            if (user.active_control_user_type_id == 1) {
                                vm.controlsData[processId][controlId].IN_CHARGE.push(user.user);
                            } else if (user.active_control_user_type_id == 2) {
                                vm.controlsData[processId][controlId].PARTICIPANT.push(user.user);
                            }
                        }
                    })
                }
                vm.updateEvidences(processId, controlId, controlData.id);
            }
        }

        function initControlsData() {
            vm.controlsData = {};
        }

        function initCurrentControl() {
            vm.currentControl = {
                process: '',
                control: '',
                id: ''
            }
        }

        function initEvidenceData() {
            vm.evidenceData = {
                active_control_id: '',
                score: null,
                title: '',
                text: ''
            };
        }

        function checkUploadsAndUpdateEvidences(processId, controlId, active_control_id) {
            var noUpdate = false;
            if (vm.files.length > 0) {
                angular.forEach(vm.files, function (file) {
                    if (angular.isUndefined(file.progress) || file.progress < 100) {
                        noUpdate = true;
                    }
                })
                if (!noUpdate) {
                    vm.updateEvidences(processId, controlId, active_control_id);
                } else {
                    $timeout(function () {
                        vm.checkUploadsAndUpdateEvidences(processId, controlId, active_control_id);
                    }, 1000)
                }
            } else {
                vm.updateEvidences(processId, controlId, active_control_id);
            }
        }
        function updateEvidences(processId, controlId, active_control_id) {
            vm.loadingEvidences = true;
            vm.currentEvidences = undefined;
            riskService.getEvidences({
                activeControlId: active_control_id,
                owner: $scope.owner,
                withMessages: true,
                withUser: true,
                sortField: 'updated_at',
                sortDir: 'DESC'
            })
                .then(function (res) {
                    if (res.total > 0) {
                        vm.controlsData[processId][controlId].evidences = res.data;
                    }
                    vm.loadingEvidences = false;
                    vm.controlsData[processId][controlId].newEvidence = false;
                    vm.clearEvidence();
                })
        }

        function clearEvidence() {
            vm.evidenceData = {
                active_control_id: vm.currentControl.id,
                score: null,
                title: '',
                text: ''
            };
        }

        function showNewEvidence(processId, controlId) {
            vm.initEvidenceData();
            vm.files = [];
            vm.controlsData[processId][controlId].newEvidence = true;
        }

        function saveEvidence(processId, controlId, active_control_id) {
            riskService.postEvidence({
                owner: $scope.owner,
                item: vm.evidenceData
            }).then(function (res) {
                angular.forEach(vm.files, function (f) {
                    vm.uploadMedia(f, res.id, 'evidence')
                })
                vm.checkUploadsAndUpdateEvidences(processId, controlId, active_control_id);
            })
        }

        function processQuestion(question) {

            vm.currentQuestion.risks = {}
            angular.forEach(question.question.processes, function (process) {
                var _process = angular.copy(process);
                delete _process.risks;
                delete _process.pivot;
                _process.PARTICIPANT = []
                _process.IN_CHARGE = []

                angular.forEach(process.risks, function (risk) {
                    if (angular.isUndefined(vm.currentQuestion.risks[risk.id])) {
                        vm.currentQuestion.risks[risk.id] = risk;
                        vm.currentQuestion.risks[risk.id].processes = [];
                    }
                    vm.getOddsProcess(_process);
                    vm.currentQuestion.risks[risk.id].processes.push(_process);
                })
            })
            delete vm.currentQuestion.question.processes;
        }

        function openEvidence($event, processId, control) {
            if (!evidence) {
                var evidence = {
                    active_control_id: vm.controlsData[processId][control.id].id_active_control,
                    communication: {
                        compliance_officers: true,
                        in_charge: true,
                        participants: false
                    },
                    score: null,
                    title: '',
                    text: ''
                };
            }
            $mdDialog.show({
                controller: function ($timeout, $q, $scope, isComplianceOfficer, $mdDialog, tinyMceService, evidencesControlsService, evidence, Owner, storagePrefix, msUtils) {
                    var vm = this;
                    vm.isComplianceOfficer = isComplianceOfficer;
                    console.log(vm.isComplianceOfficer)
                    vm.evidenceData = {
                        evidence: evidence,
                        files: []
                    };
                    var options = {
                        owner: Owner
                    }
                    evidencesControlsService.getCurrencies(options).then(function (res) {
                        vm.currencies = res.data;
                    })
                    vm.storagePrefix = storagePrefix;
                    vm.tinymceOptions = tinyMceService.getBasicOptions($scope);
                    vm.closeDialog = function () {
                        $mdDialog.hide();
                    }
                    vm.updateEvidence = function () {
                        riskService.putEvidence({
                            owner: Owner,
                            item: vm.evidenceData.evidence
                        }).then(function (res) {
                            vm.updatingScore = false;
                        })
                    }
                    vm.evidenceScoreColor = msUtils.evidenceScoreColor;
                    vm.save = function () {
                        $mdDialog.hide(vm.evidenceData);
                    };
                },
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/evidenceDetails/evidenceDetails.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    evidence: evidence,
                    isComplianceOfficer: vm.isComplianceOfficer(),
                    Owner: $scope.owner,
                    storagePrefix: $scope.storagePrefix
                },
            })
                .then(function (newData) {
                    if (newData) {
                        vm.savingEvidence = true;
                        vm.evidenceData = newData.evidence;
                        vm.files = newData.files;
                        vm.saveEvidence(processId, control.id, vm.controlsData[processId][control.id].id_active_control);
                    }
                });

        }


        function updateRiskLevels(risk) {
            var options = {
                owner: $scope.owner,
                id: risk.id_active_risk,
                item: {
                    reputation_impact: risk.reputation_impact,
                    penal_code_impact: risk.penal_code_impact,
                    client_loss: risk.client_loss
                }
            }
            riskService.updateRisk(options)
                .then(function (response) {
                    var message = $translate.instant('GLOBAL.UPDATED_SUCCESSFULLY')
                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content bg-green">' + message + '</div></md-toast>',
                        hideDelay: 7000,
                        position: 'top right',
                        parent: '#content'
                    });
                })
                .catch(function (response) {
                    console.log('err', response);
                });
        }

        function getSymbolCurrency(id) {
            var found = _.find(vm.currencies, function (c) { if (c.id == id) { return true; } });
            return found ? found.symbol : null;
        }

        function updateProcessScore($event, process) {
            console.log(process);
            var options = {
                owner: $scope.owner,
                companyId: vm.companySelected.id,
                branch: vm.branchSelected.id,
                process_id: process.id,
                date: moment().format('YYYY-MM-DD'),
                odds: process.score,
                comment: ''
            }
            $mdDialog.show({
                controller: function ($timeout, $q, $scope, $mdDialog, score) {
                    var vm = this;
                    vm.score = score;
                    vm.comment = '';
                    vm.closeDialog = function () {
                        $mdDialog.hide();
                    }
                    vm.answer = function (answer) {
                        $mdDialog.hide(answer);
                    };
                },
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/process/oddOfOccurrence.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    score: process.score
                },
            })
                .then(function (answer) {
                    options.comment = answer.comment
                    options.odds = answer.score;

                    if (process.id_score) {
                        options.id_score = process.id_score;
                        questionsService.updateProcessOddOfOccurrence(options)
                            .then(function (response) {
                                process.score = answer.score;
                            })
                            .catch(function (response) {
                                console.log('err', response);
                            });
                    } else {
                        questionsService.processOddOfOccurrence(options)
                            .then(function (response) {
                                process.score = answer.score;
                                process.id_score = response.result.id;
                            })
                            .catch(function (response) {
                                console.log('err', response);
                            });
                    }
                });
        }

        function openDialogUsers($event, process, control, usersType) {
            $mdDialog.show({
                controller: function ($timeout, $q, $scope, $mdDialog, $filter, currentUsers, currentBranch, storagePrefix) {
                    var vm = this;
                    vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
                    vm.usersObj = {};
                    vm.allUsers = [];
                    angular.forEach(currentBranch.users, function (user) {
                        if (angular.isUndefined(vm.usersObj[user.id])) {
                            vm.allUsers.push(user);
                            vm.usersObj[user.id] = user;
                        }
                    })
                    vm.currentUsers = currentUsers;
                    angular.forEach(vm.allUsers, function (u) {
                        if (angular.isUndefined(u.profile_color)) {
                            u.profile_color = vm.colors[Math.floor(Math.random() * vm.colors.length)];
                        }
                        u.storagePrefix = storagePrefix;
                        u.selected = false;
                        angular.forEach(vm.currentUsers, function (user) {
                            user.profile_color = u.profile_color;
                            if (user.id == u.id) {
                                u.selected = true;
                            }
                        })
                    })
                    vm.closeDialog = function () {
                        $mdDialog.hide();
                    }
                    vm.apply = function () {
                        var returnUsers = $filter('filter')(vm.allUsers, { selected: true })
                        $mdDialog.hide(returnUsers);
                    };
                },
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/selectUsers/selectUsers.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    currentBranch: vm.branchSelected,
                    currentUsers: control ? vm.controlsData[process.id][control.id][usersType] : process[usersType],
                    storagePrefix: $scope.storagePrefix
                },
            })
                .then(function (people) {
                    if (people) {
                        if (control) {
                            fillControlUsersPeople(usersType, process, control, people);
                        } else {
                            process[usersType] = people;
                        }
                    }

                });

        }

        function fillControlUsersPeople(usersType, process, control, people) {
            var controlData = vm.controlsData[process.id][control.id];
            var options = {
                owner: $scope.owner,
                controlId: controlData.id_active_control,
                users: people,
                usersType: usersType
            }
            questionsService.updateControlUsers(options)
                .then(function (response) {
                    vm.controlsData[process.id][control.id][usersType] = people;
                })
                .catch(function (response) {
                    console.log('err', response);
                });

            ;
        }

        function openDialogText($event, text, title) {
            $mdDialog.show({
                controller: function ($timeout, $q, $scope, $mdDialog, $filter, title, text) {
                    var vm = this;
                    vm.text = text;
                    vm.title = title;
                    vm.closeDialog = function () {
                        $mdDialog.hide();
                    }
                },
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/textDialog/textDialog.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    title: title,
                    text: text
                },
            })
                .then(function (resp) {
                });

        }

        function toggleRename(item, processId, controlId, isCancel) {
            if (isCancel) {
                item.rename = angular.copy(item.name_current);
            } else {
                var controlsDataRename = false;
                if (controlId) {
                    controlsDataRename = vm.controlsData[processId][controlId].control_rename || false;
                } else {
                    controlsDataRename = vm.controlsData[processId].process_rename || false;
                }
                item.rename = item.rename || controlsDataRename || item.name;
                item.name_current = angular.copy(item.rename);
            }
            item.isRenaming = !item.isRenaming;
            item.isLoading = false;
        }

        function renameProcessOrControl(item, processId, controlId) {
            item.isLoading = true;
            var answerJson = vm.currentQuestion.answer_json;

            if (answerJson instanceof Array && answerJson.length == 0) {
                answerJson = {renames: {processes: {}, controls: {}}};
            } else {
                if (!answerJson.hasOwnProperty('renames')) {
                    answerJson.renames = {processes: {}, controls: {}};
                }
            }
            if (controlId) {
                if (answerJson.renames.controls instanceof Array) {
                    answerJson.renames.controls = {};
                }
                answerJson.renames.controls[controlId] = item.rename;
            } else {
                if (answerJson.renames.processes instanceof Array) {
                    answerJson.renames.processes = {};
                }
                answerJson.renames.processes[processId] = item.rename;
            }
            updateAnswerQuestionJson(answerJson)
                .then(function (response) {
                    var currentQuestion = vm.currentQuestions.find(function (question) {
                        return vm.currentQuestion.id == question.id
                    })
                    if (currentQuestion) {
                        currentQuestion.answer_json = answerJson;
                    }
                    toggleRename(item, processId, controlId)
                })
        }


        function updateAnswerQuestionJson(answerJson) {
            return questionsService.answerQuestion({
                owner: $scope.owner,
                companyId: vm.companySelected.id,
                branchId: vm.branchSelected.id,
                questionId: vm.currentQuestion.question_id,
                answer_json: answerJson
            })
        }

        function showRiskLevel(riskLevel) {
            return vm.translate('RISK.RISK_LEVELS_' + riskLevel);
        }

        function showUserImage(user) {
            return $scope.storagePrefix + user.files.url
        }
        function showUserImageFromId(userId) {
            angular.forEach(vm.allUsers, function (u) {
                if (u.id == userId) {
                    if (!angular.isUndefined(u.files.id)) {
                        return $scope.storagePrefix + u.files.url
                    } else {
                        return false;
                    }
                }
            });
        }

        function showAddMoreQuestions() {
            vm.availableQuestions = angular.copy(vm.allQuestions);
            
            var currentQuestionIds = vm.currentQuestions.map(q => q.question_id);
            vm.availableQuestions.forEach(q => {
                q.selected = currentQuestionIds.includes(q.id);
                
                if (q.selected) {
                    var currentQuestion = vm.currentQuestions.find(cq => cq.question_id === q.id);
                    if (currentQuestion) {
                        q.is_finished = currentQuestion.is_finished;
                    }
                }
            });
            
            vm.searchQuestionText = '';
            vm.filteredQuestions = vm.availableQuestions;
            
            $scope.$watch('vm.searchQuestionText', function(newValue, oldValue) {
                if (newValue !== oldValue) {
                    vm.filterQuestions();
                }
            });

            if (vm.availableQuestions.length === 0) {
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center start">' +
                        '<div class="md-toast-content bg-blue">' +
                        '<span translate="QUESTIONS.NO_QUESTIONS_AVAILABLE">No hay más preguntas disponibles para añadir</span>' +
                        '</div></md-toast>',
                    hideDelay: 3000,
                    position: 'top right',
                    parent: '#content'
                });
                return;
            }
            
            vm.showAddMoreQuestionsDialog = true;
        }

        function addMoreQuestions() {
            vm.showAddMoreQuestionsDialog = false;
            vm.loadingQuestions = true;
            
            var allSelectedQuestions = vm.availableQuestions.filter(x => x.selected).map(x => x.id);
            var currentQuestionIds = vm.currentQuestions.map(q => q.question_id);
            
            var questionsToAdd = allSelectedQuestions.filter(id => !currentQuestionIds.includes(id));
            
            var questionsToRemove = currentQuestionIds.filter(id => {
                if (!allSelectedQuestions.includes(id)) {
                    var currentQuestion = vm.currentQuestions.find(cq => cq.question_id === id);
                    return currentQuestion && currentQuestion.is_finished != 1;
                }
                return false;
            });
            
            if (questionsToAdd.length === 0 && questionsToRemove.length === 0) {
                vm.loadingQuestions = false;
                return;
            }
            
            var options = {
                owner: $scope.owner,
                companyId: vm.companySelected.id,
                branchId: vm.branchSelected.id,
                questionnaireType: vm.detailsView,
                questions: questionsToAdd,
                questionsToRemove: questionsToRemove
            };
            
            questionsService.addMoreQuestions(options)
                .then(function (response) {
                    vm.loadingQuestions = false;
                    vm.getQuestionnaire();
                    
                    var message = '';
                    if (questionsToAdd.length > 0 && questionsToRemove.length > 0) {
                        message = 'Preguntas actualizadas exitosamente';
                    } else if (questionsToAdd.length > 0) {
                        message = 'Preguntas añadidas exitosamente';
                    } else if (questionsToRemove.length > 0) {
                        message = 'Preguntas eliminadas exitosamente';
                    }
                    
                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center start">' +
                            '<div class="md-toast-content bg-green">' + message + '</div></md-toast>',
                        hideDelay: 3000,
                        position: 'top right',
                        parent: '#content'
                    });
                })
                .catch(function (response) {
                    vm.loadingQuestions = false;
                    console.log('Error updating questions:', response);
                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center start">' +
                            '<div class="md-toast-content bg-red">' +
                            '<span translate="QUESTIONS.ERROR_ADDING_QUESTIONS">Error al actualizar preguntas</span>' +
                            '</div></md-toast>',
                        hideDelay: 3000,
                        position: 'top right',
                        parent: '#content'
                    });
                });
        }

        function cancelAddMoreQuestions() {
            vm.showAddMoreQuestionsDialog = false;
        }

        function filterQuestions() {
            if (!vm.searchQuestionText || vm.searchQuestionText.trim() === '') {
                vm.filteredQuestions = vm.availableQuestions;
                return;
            }
            
            var searchText = vm.searchQuestionText.toLowerCase().trim();
            vm.filteredQuestions = vm.availableQuestions.filter(function(question) {
                if (question.name && question.name.toLowerCase().includes(searchText)) {
                    return true;
                }
                
                if (question.processes && question.processes.length > 0) {
                    for (var i = 0; i < question.processes.length; i++) {
                        if (question.processes[i].name && question.processes[i].name.toLowerCase().includes(searchText)) {
                            return true;
                        }
                    }
                }
                
                if (question.processes && question.processes.length > 0 && 
                    question.processes[0].risks && question.processes[0].risks.length > 0) {
                    for (var j = 0; j < question.processes[0].risks.length; j++) {
                        if (question.processes[0].risks[j].name && 
                            question.processes[0].risks[j].name.toLowerCase().includes(searchText)) {
                            return true;
                        }
                    }
                }
                
                return false;
            });
        }

        function hasChanges() {
            if (!vm.availableQuestions) {
                return false;
            }
            
            var selectedQuestions = vm.availableQuestions.filter(x => x.selected).map(x => x.id);
            var currentQuestionIds = vm.currentQuestions.map(q => q.question_id);
            
            var questionsToAdd = selectedQuestions.filter(id => !currentQuestionIds.includes(id));
            
            var questionsToRemove = currentQuestionIds.filter(id => {
                if (!selectedQuestions.includes(id)) {
                    var currentQuestion = vm.currentQuestions.find(cq => cq.question_id === id);
                    return currentQuestion && currentQuestion.is_finished != 1;
                }
                return false;
            });
            
            return questionsToAdd.length > 0 || questionsToRemove.length > 0;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.questions')
        .service('questionsService', questionsService);

    /** @ngInject */
    // I provide access to the session store.
    function questionsService($q, $resource, settingsDomainService, sessionService, COMMON, $mdToast) {

        function startQuestionnaire(options) {
            var deferred = $q.defer();

            resourceStartQuestionnaire.post({
                owner: options.owner,
                company_id: options.companyId,
                branch_id: options.branchId,
                sector_id: options.sectorId,
                questions: options.questions,
                questionnaire_type: options.questionnaireType
            },
                function (response) {
                    deferred.resolve({
                        result: response
                    });
                },
                function (e) {
                    deferred.reject({
                        result: e.data
                    });
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function addMoreQuestions(options) {
            var deferred = $q.defer();

            var promises = [];

            if (options.questions && options.questions.length > 0) {
                var addPromise = resourceAddQuestionsToQuestionnaire.post({
                    owner: options.owner,
                    company_id: options.companyId,
                    branch_id: options.branchId,
                    questionnaire_type: options.questionnaireType,
                    question_ids: options.questions
                }).$promise;
                promises.push(addPromise);
            }

            if (options.questionsToRemove && options.questionsToRemove.length > 0) {
                var removePromise = resourceRemoveQuestionsFromQuestionnaire.post({
                    owner: options.owner,
                    company_id: options.companyId,
                    branch_id: options.branchId,
                    question_ids: options.questionsToRemove
                }).$promise;
                promises.push(removePromise);
            }

            if (promises.length === 0) {
                deferred.resolve({ result: { message: 'No hay cambios que realizar' } });
                return deferred.promise;
            }

            $q.all(promises).then(
                function (responses) {
                    deferred.resolve({
                        result: { message: 'Preguntas actualizadas correctamente' }
                    });
                },
                function (error) {
                    deferred.reject({
                        result: error.data || error
                    });
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getAvailableQuestions(options) {
            var deferred = $q.defer();

            resourceGetAvailableQuestions.get({
                owner: options.owner,
                company_id: options.companyId,
                branch_id: options.branchId,
                sector_id: options.sectorId
            },
                function (response) {
                    deferred.resolve({
                        result: response
                    });
                },
                function (e) {
                    deferred.reject({
                        result: e.data
                    });
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getAllQuestions(options) {
            var deferred = $q.defer();

            resourceGetQuestions.get({
                owner: options.owner,
                withProcesses: options.withProcesses,
                resultsPerPage: options.resultsPerPage,
                user_region: options.user_region,
                region_id: options.region_id
            },
                function (response) {
                    deferred.resolve({
                        result: response
                    });
                },
                function (e) {
                    deferred.reject({
                        result: e.data
                    });
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getQuestionnaire(options) {
            var deferred = $q.defer();

            resourceGetQuestionnaire.get({
                owner: options.owner,
                company_id: options.companyId,
                branch_id: options.branchId,
                resultsPerPage: 1500,
                withQuestion: true
            },
                function (response) {
                    deferred.resolve({
                        result: response
                    });
                },
                function (e) {
                    deferred.reject({
                        result: e.data
                    });
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function answerQuestion(options) {
            var deferred = $q.defer();

            resourceAnswerQuestion.update({
                owner: options.owner,
                company_id: options.companyId,
                branch_id: options.branchId,
                question_id: options.questionId,
                answer_json: options.answer_json,
                answer: options.answer
            },
                function (response) {
                    deferred.resolve({
                        result: response
                    });
                },
                function (e) {
                    deferred.reject({
                        result: e.data
                    });
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function finishQuestion(options) {
            var deferred = $q.defer();

            resourceFinishQuestion.update({
                owner: options.owner,
                company_id: options.companyId,
                branch_id: options.branchId,
                question_id: options.questionId,
            },
                function (response) {
                    deferred.resolve({
                        result: response
                    });
                },
                function (e) {
                    deferred.reject({
                        result: e.data
                    });
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function evaluateAnswer(options) {
            var deferred = $q.defer();

            resourceEvaluateAnswer.post({
                owner: options.owner,
                company_id: options.companyId,
                branch: options.branch,
                question: options.question,
            },
                function (response) {
                    deferred.resolve({
                        result: response
                    });
                },
                function (e) {
                    deferred.reject({
                        result: e.data
                    });
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function restoreAnswer(options) {
            var deferred = $q.defer();

            resourceRestoreAnswer.post({
                owner: options.owner,
                company_id: options.companyId,
                branch: options.branch,
                question: options.question,
            },
                function (response) {
                    deferred.resolve({
                        result: response
                    });
                },
                function (e) {
                    deferred.reject({
                        result: e.data
                    });
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function processOddOfOccurrence(options) {
            var deferred = $q.defer();

            resourceOddOfOccurrence.post({
                owner: options.owner,
                process_id: options.process_id,
                company_id: options.companyId,
                branch_id: options.branch,
                date: options.date,
                odds: options.odds,
                comment: options.comment,
            },
                function (response) {
                    deferred.resolve({
                        result: response
                    });
                },
                function (e) {
                    deferred.reject({
                        result: e.data
                    });
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function updateProcessOddOfOccurrence(options) {
            var deferred = $q.defer();

            updateResourceOddOfOccurrence.put({
                id: options.id_score
            }, {
                owner: options.owner,
                process_id: options.process_id,
                company_id: options.companyId,
                branch_id: options.branch,
                date: options.date,
                odds: options.odds,
                id: options.id_score,
                comment: options.comment,
            },
                function (response) {
                    deferred.resolve({
                        result: response
                    });
                },
                function (e) {
                    deferred.reject({
                        result: e.data
                    });
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getProcessOdds(options) {
            var deferred = $q.defer();

            resourceOddOfOccurrence.get({
                owner: options.owner,
                process_id: options.id_process,
                branch_id: options.branch_id
            },
                function (response) {
                    deferred.resolve({
                        result: response
                    });
                },
                function (e) {
                    deferred.reject({
                        result: e.data
                    });
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateRisk(options) {
            var deferred = $q.defer();

            resourceUpdateRisk.put({
                owner: options.owner,
                id: options.riskId,
                reputation_impact: options.reputation_impact,
                penal_code_impact: options.penal_code_impact,
                client_loss: options.client_loss
            },
                function (response) {
                    deferred.resolve({
                        result: response
                    });
                },
                function (e) {
                    deferred.reject({
                        result: e.data
                    });
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateControl(options) {
            var deferred = $q.defer();

            resourceUpdateControl.put({
                owner: options.owner,
                id: options.controlId,
                control: options.control
            },
                function (response) {
                    deferred.resolve({
                        result: response
                    });
                },
                function (e) {
                    deferred.reject({
                        result: e.data
                    });
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function deleteActiveControl(options) {
            var deferred = $q.defer();

            resourcedeleteActiveControl.delete({
                owner: options.owner,
                id: options.controlId
            },
                function (response) {
                    deferred.resolve({
                        result: response
                    });
                },
                function (e) {
                    deferred.reject({
                        result: e.data
                    });
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateControlUsers(options) {
            var deferred = $q.defer();

            resourceUpdateControlUsers.put({
                owner: options.owner,
                id: options.controlId,
                users: options.users,
                usersType: options.usersType
            },
                function (response) {
                    deferred.resolve({
                        result: response
                    });
                },
                function (e) {
                    deferred.reject({
                        result: e.data
                    });
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getCompany(options) {
            var deferred = $q.defer();
            resourceCompany.get({
                owner: options.owner,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getBranches(options) {
            var deferred = $q.defer();
            resourceBranches.get(options,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function setCompanyId(idCompany) {
            companyId = idCompany;
        }

        function setBranch(branchData) {
            branch = branchData;
        }

        var resourceStartQuestionnaire = $resource(COMMON.BASE_API + "/owner/:owner/question/startQuestionnaire", {
            owner: '@owner',
            // No default data
        }, {
            post: {
                method: "POST",
                isArray: false
            },
        });

        var resourceAddQuestionsToQuestionnaire = $resource(COMMON.BASE_API + "/owner/:owner/question/addQuestionsToQuestionnaire", {
            owner: '@owner',
            // No default data
        }, {
            post: {
                method: "POST",
                isArray: false
            },
        });

        var resourceRemoveQuestionsFromQuestionnaire = $resource(COMMON.BASE_API + "/owner/:owner/question/removeQuestionsFromQuestionnaire", {
            owner: '@owner',
            // No default data
        }, {
            post: {
                method: "POST",
                isArray: false
            },
        });

        var resourceGetAvailableQuestions = $resource(COMMON.BASE_API + "/owner/:owner/question/getAvailableQuestionsForQuestionnaire", {
            owner: '@owner',
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            },
        });

        var resourceGetQuestions = $resource(COMMON.BASE_API + "/owner/:owner/question", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            },
        });
        var resourceGetQuestionnaire = $resource(COMMON.BASE_API + "/owner/:owner/question/getQuestionnaire", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            },
        });

        var resourceAnswerQuestion = $resource(COMMON.BASE_API + "/owner/:owner/question/updateAnswer", {
            owner: '@owner',
            // No default data
        }, {
            update: {
                method: "PUT",
                isArray: false
            },
        });

        var resourceFinishQuestion = $resource(COMMON.BASE_API + "/owner/:owner/question/finishAnswer", {
            owner: '@owner',
            // No default data
        }, {
            update: {
                method: "PUT",
                isArray: false
            },
        });

        var resourceEvaluateAnswer = $resource(COMMON.BASE_API + "/owner/:owner/question/evaluateAnswer", {
            owner: '@owner',
            // No default data
        }, {
            post: {
                method: "POST",
                isArray: false
            },
        });

        var resourceRestoreAnswer = $resource(COMMON.BASE_API + "/owner/:owner/question/restoreAnswer", {
            owner: '@owner',
            // No default data
        }, {
            post: {
                method: "POST",
                isArray: false
            },
        });

        var resourceOddOfOccurrence = $resource(COMMON.BASE_API + "/owner/:owner/processOddsOfOccurrence?process_id=:process_id&branch_id=:branch_id", {
            owner: '@owner',
            // No default data
        }, {
            post: {
                method: "POST",
                isArray: false
            },
            get: {
                method: "GET",
                isArray: false
            }
        });
        var updateResourceOddOfOccurrence = $resource(COMMON.BASE_API + "/owner/:owner/processOddsOfOccurrence/:id", {
            owner: '@owner',
            // No default data
        }, {
            put: {
                method: "PUT",
                isArray: false
            }
        });

        var resourceUpdateRisk = $resource(COMMON.BASE_API + "/owner/:owner/riskMap/:id", {
            owner: '@owner',
            id: '@id'
            // No default data
        }, {
            put: {
                method: "PUT",
                isArray: false
            },
        });

        var resourceUpdateControl = $resource(COMMON.BASE_API + "/owner/:owner/activeTree/activeControl/:id", {
            owner: '@owner',
            id: '@id'
            // No default data
        }, {
            put: {
                method: "PUT",
                isArray: false
            },
        });
        var resourcedeleteActiveControl = $resource(COMMON.BASE_API + "/owner/:owner/activeTree/activeControl/:id", {
            owner: '@owner',
            id: '@id'
            // No default data
        }, {
            delete: {
                method: "DELETE",
                isArray: false
            },
        });

        var resourceUpdateControlUsers = $resource(COMMON.BASE_API + "/owner/:owner/activeTree/activeControlUsers/:id", {
            owner: '@owner',
            id: '@id'
            // No default data
        }, {
            put: {
                method: "PUT",
                isArray: false
            },
        });

        var resourceCompany = $resource(COMMON.BASE_API + "/owner/:owner/company/:id", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            },
        });

        var resourceBranches = $resource(COMMON.BASE_API + "/owner/:owner/branch/", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        });

        var companyId = '';
        var branch = {};

        return ({
            getAllQuestions: getAllQuestions,
            getAvailableQuestions: getAvailableQuestions,
            startQuestionnaire: startQuestionnaire,
            addMoreQuestions: addMoreQuestions,
            getQuestionnaire: getQuestionnaire,
            answerQuestion: answerQuestion,
            finishQuestion: finishQuestion,
            evaluateAnswer: evaluateAnswer,
            restoreAnswer: restoreAnswer,
            deleteActiveControl: deleteActiveControl,
            processOddOfOccurrence: processOddOfOccurrence,
            updateProcessOddOfOccurrence: updateProcessOddOfOccurrence,
            getProcessOdds: getProcessOdds,
            updateRisk: updateRisk,
            updateControl: updateControl,
            updateControlUsers: updateControlUsers,
            getCompany: getCompany,
            getBranches: getBranches,
            setCompanyId: setCompanyId,
            setBranch: setBranch,
            getCompanyId: companyId,
            branch: branch
        });

    }

})();

(function () {
    'use strict';

    angular
        .module('app.outputs', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider,
        msUtilProvider, msNavigationServiceProvider, ivhTreeviewOptionsProvider) {


        ivhTreeviewOptionsProvider.set({
            defaultSelectedState: false,
            validate: true,
            expandToDepth: -1,
            twistieCollapsedTpl: '<md-icon md-font-icon="icon-chevron-right"></md-icon>',
            twistieExpandedTpl: '<md-icon md-font-icon="icon-chevron-left"></md-icon>',
            twistieLeafTpl: '<span style="cursor: default;">&#8192;&#8192;</span>'
        });





        // State


        $stateProvider.state('app.outputs', {
            url: '/outputs',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/outputs/outputs.html',
                    controller: 'outputsController as vm'
                }
            },
            bodyClass: 'outputs'
        });

        $stateProvider
            .state('app.site_overview.outputs', {
                abstract: true,
                url: '/outputs',
                onEnter: function ($stateParams) {


                },
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                    section: function ($stateParams) {
                        return $stateParams.owner
                    },
                    is_owner: function ($stateParams) {
                        return false
                    },
                },


            })
            .state('app.site_overview.outputs.list', {
                url: '/list',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/outputs/outputs.html',
                        controller: 'outputsController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.outputs.complaints', {
                url: '/compliance',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/outputs/outputs.html',
                        controller: 'outputsController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.outputs.list.thread', {
                url: '/list/:id',
                bodyClass: 'outputs'
            });
        // Translation
        var base = 'app/main/apps/outputs';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.outputs')
        .controller('outputsController', outputsController);

    /** @ngInject */
    function outputsController($scope, $rootScope, $stateParams, companyService, $translate, $document, $mdDialog, inputsService, outcomesService,
        $mdMedia, $mdSidenav, $state, msApi, tinyMceService, requestContext, evidencesControlsService, outputsService, itemsService,
        transformitems, transforminputs, transformoutcomes, transformoutputs, mediaService, Upload, $filter, $timeout, msUtils, documentsService, sessionService, $cookies, is_owner) {
            var vm = this;
            //        vm.userLogued = sessionService.getUser();
            
                    vm.saveInput = saveInput;
                    vm.saveOutcome = saveOutcome;
                    vm.input = [];
                    vm.loadingStep = false;
                    vm.folders = 'Folders.data';
                    vm.labels = 'Labels.data';
                    vm.loadingThreads = true;
                    vm.saveDialog = saveDialog;
                    vm.changeValue = changeValue;
            //        vm.calculoAnual = calculo;
                    vm.calculoAnual = calculoAnual;
            //    vm.calculoAnualO = calculoO;
                    vm.calculoAnualO = calculoAnualO;
                    vm.cambio = false;
                    vm.currentFilter = {
                        type: $state.params.type,
                        filter: $state.params.filter
                    };
                    vm.operator = ['+', '-', '/', '*', "(", ")"];
                    vm.currentThread = null;
                    vm.selectedThreads = [];
                    vm.itemElemen = [];
                    vm.item = [];
                    //        vm.isCompanySelected = isCompanySelected;
                    vm.views = {
                        split: 'app/main/apps/outputs/views/list/split-view.html',
                        nosplit: 'app/main/apps/outputs/views/list/nosplit-view.html'
                    };
                    vm.defaultView = 'split';
                    vm.currentView = 'split';
                    //        console.log($rootScope.companySel);
                    vm.readView = false;
                    vm.closeDialog = closeDialog;
            
                    vm.administratorFields = vm.personFields;
                    vm.managerLegalFields = vm.personFields;
                    vm.complianceFields = vm.personFields;
                    vm.reportFields = vm.personFields;
                    vm.personnelFields = vm.personFields;
                    //        vm.getRegionLiteral = getRegionLiteral;
            
                    vm.companySelectEvent = companySelectEvent;
                    //        vm.getSectorById = getSectorById;
            
            
                    vm.idClient = undefined;
                    vm.idCompany = undefined;
                    vm.updateLogotype = false;
                    vm.showForm = true;
                    vm.allQuestions = true;
                    $scope.storagePrefix = '';
                    vm.tipefield = [
                        { number: '1', name: $translate.instant('ITEM.PROXY') },
                        { number: '2', name: $translate.instant('ITEM.INDICATOR') },
                        { number: '3', name: $translate.instant('ITEM.OUTPUT') }
                    ];
                    vm.editfield = [
                        { number: '0', name: $translate.instant('ITEM.NOT') },
                        { number: '1', name: $translate.instant('ITEM.YES') }
                    ];
            
            
                    vm.isSelected = isSelected;
                    vm.toggleSelectThread = toggleSelectThread;
                    vm.newForm = newForm;
            
            //        vm.deleteitem = deleteitem;
                    vm.edit = false;
                    vm.openCompany = openCompany;
                    vm.editCompany = editCompany;
                    vm.getProyects = getProyects;
                    vm.deleteitem = deleteitem;
            
            
                    //////////
                    var companySelectEvent = $rootScope.$on('company-selected', function (event) {
                       getProyects();
                        //           getComplianceOfficers();
                    });
            
                    $scope.$on('pagination:loadStart', function (event) {
                        $scope.isLoading = true;
                        $scope.isLoadingP = true;
                    });
            
                    $scope.$on('pagination:loadPage', function (event) {
                        $scope.isLoading = false;
                        vm.is_owner = vm.companies.length <= 1;
                        //            getProyects();
            //            init();
                    });
                    //        init();
                    $scope.owner = $stateParams.owner;
            
            
                    this.awesomeCallback = function (node, tree) {
                        // Do something with node or tree
                    };
            
                    this.otherAwesomeCallback = function (node, isSelected, tree) {
                        // Do soemthing with node or tree based on isSelected
                    };
                    if ($rootScope.companySel) {
                        getProyects();
                    }
            
                    function init() {
                        mediaService.getStoragePrefix({
                            owner: $scope.owner,
                        }).then(function (res) {
                            $scope.storagePrefix = res.prefix;
                        })
                        evidencesControlsService.getCurrencies({ owner: $scope.owner }).then(function (res) {
                            vm.currencies = res.data;
                        })
                        itemsService.getRegions({ owner: $scope.owner }).then(function (res) {
                            vm.regions = res.data;
                        })
                        itemsService.getFileRegions().then(function (res) {
                            vm.regionsLiterals = res;
                        })
                    }
            
                    // Watch screen size to change view modes
                    $scope.$watch(function () {
                        return $mdMedia('lt-sm');
                    }, function (current, old) {
                        if (angular.equals(current, old)) {
                            return;
                        }
            
                        if (current) {
                            vm.currentView = 'nosplit';
                        }
                    });
            
                    $scope.$watch(function () {
                        return $mdMedia('max-width: 960px');
                    }, function (big) {
            
                        if (big) {
                            vm.currentView = 'nosplit';
                        }
            
                    });
            
                    $scope.$watch(function () {
                        return $mdMedia('min-width: 960px');
                    }, function (small) {
            
                        if (small) {
                            vm.currentView = 'split';
                        }
            
                    });
            
                    $scope.$watch(function () {
                        return $mdMedia('gt-sm');
                    }, function (current, old) {
                        if (angular.equals(current, old)) {
                            return;
                        }
            
                        if (current) {
                            if (vm.defaultView === 'split') {
                                vm.currentView = 'split';
                            }
                        }
                    });
            
            
                    var originatorEv;
            
                    function openMenu($mdMenu, ev) {
                        originatorEv = ev;
                        $mdMenu.open(ev);
                    }
            
                    function newForm(ev) {
                        vm.idCompany = null;
                        vm.company = [];
                        vm.edit = true;
                    }
            
                    function getProyects(idCompany, inOwner) {
                        var options = {
                            owner: $scope.owner,
                            proyect_id: $rootScope.companySel,
                            withFiles: true
                        };
                        //           console.log(vm.itemElemen);
                        itemsService.getProyects(options).then(function (response) {
                            vm.item = response;
                            $scope.isLoadingP = false;
                        }, function (response) {
                            vm.item = [];
                            //                $scope.isLoadingP = true;
                        }
                        )
                    }
            
                    function openCompany(company, ev) {
                        vm.company = company;
            //            console.log(vm.company);
                        vm.edit = true;
                    }
            
                    function changeValue(itemC) {
            //            console.log(itemC);
                        if (vm.cambio && itemC.id) {
                            var options = {
                                owner: $scope.owner,
                                proyect_id: $rootScope.companySel,
                                withFiles: true
                            };
                            inputsService.getInputs(options).then(function (response) {
                                vm.input = response;
                                vm.input.forEach(function (input1, index) {
                                    input1.input_structure = JSON.parse(input1.input_structure);
                                    var inputF1 = input1.input_structure.inputs;
                                    inputF1.forEach(function (input1F, indexF) {
                                        if(itemC.id == input1F.id_item) {
            //                                console.log(input1F);    
                                            input1F.data = itemC.value;
                                            input1F.fieldEdit  = itemC.edit_item;
            //                                console.log(input1F);
                                            calculo(input1);
                                            calculoAnual(input1);
                                            saveInput(input1);
                                    }
                                    });
                                });
                            }, function (response) {
                                vm.input = [];
                                $scope.isLoadingP = false;
                            }
                            )
                            outcomesService.getOutcomes(options).then(function (response) {
                                vm.input = response;
                                vm.input.forEach(function (input1, index) {
                                    input1.outcome_structure = JSON.parse(input1.outcome_structure);
                                    var inputF1 = input1.outcome_structure.outcomes;
                                    inputF1.forEach(function (input1F, indexF) {
                                        if(itemC.id == input1F.id_item) {
                                            input1F.data = itemC.value;
                                            input1F.fieldEdit  = itemC.edit_item;
                                            calculoO(input1);
                                            calculoAnualO(input1);
                                            saveOutcome(input1);
                                    }
                                    });
                                });
                            }, function (response) {
                                vm.input = [];
                                $scope.isLoadingP = false;
                            }
                            )
                        }
                        vm.cambio = false;
                    }
                    function saveOutcome(inputC) {
            
                        var inputC1 = {};
                        inputC1.company = inputC;
                        var options = {
                            owner: $scope.owner,
                            item: transformoutcomes.outcomeToDTO(inputC1)
                        };
                            options.id =inputC.id;
                            outcomesService.updateOutcome(options).then(function (response) {
            
                            });
            
                    }
            
                    function saveInput(inputC) {
            
                        var inputC1 = {};
                        inputC1.company = inputC;
                        var options = {
                            owner: $scope.owner,
                            item: transforminputs.inputToDTO(inputC1)
                        };
                            options.id =inputC.id;
                            inputsService.updateInput(options).then(function (response) {
            
                            });
            
                    }
                    function calculoO(inputC) {
                        if (inputC.outcome_structure) {
                            var valor = 0;
                            var valorParen = [];
                            var cantidad = 0;
                            var cantidadt = 0;
                            var indi = 0;
                            var datainput = [];
                            var operadorU = [];
                            if (inputC.outcome_structure.formula.length == 0) {
                                datainput[0] = 0;
                            }
                            for (let it = 0; it < inputC.outcome_structure.formula.length; it++) {
                                var findv = false;
                                var parametro = inputC.outcome_structure.formula[it];
                                for (let i = 0; i < inputC.outcome_structure.outcomes.length; i++) {
                                    if (inputC.outcome_structure.outcomes[i].fieldName == parametro) {
                                        cantidad = inputC.outcome_structure.outcomes[i].data;
                                        if (!datainput[indi]) {
                                            datainput[indi] = cantidad;
                                        }
                                        findv = true;
                                        break;
                                    }
                                }
                                if (parametro == "(") {
                                    indi = indi + 1;
                                    continue;
                                }
                                if (parametro == ")") {
                                    cantidad = datainput[indi];
                                    datainput[indi] = 0;
                                    indi = indi - 1;
                                }
                                if (inputC.outcome_structure.formula[it + 1] && (inputC.outcome_structure.formula[it + 1] == "*" || inputC.outcome_structure.formula[it + 1] == "/")) {
                                    var operadorA = inputC.outcome_structure.formula[it + 1];
                                    if (!inputC.outcome_structure.formula[it + 2]) {
                                        datainput[0] = $translate.instant('INPUT.FORMULA_ERROR');
                                        break;
                                    }
                                    var parametro = inputC.outcome_structure.formula[it + 2];
                                    for (let i = 0; i < inputC.outcome_structure.outcomes.length; i++) {
                                        if (inputC.outcome_structure.outcomes[i].fieldName == parametro) {
                                            var cantidadMD = inputC.outcome_structure.outcomes[i].data;
                                            break;
                                        }
                                    }
                                    switch (operadorA) {
                                        case '*':
                                            cantidad = cantidadMD * cantidad;
                                            break;
                                        case '/':
                                            if (cantidad > 0) {
                                                cantidad = cantidad / cantidadMD;
                                                break;
                                            }
                                    }
                                    if (!operadorU[indi]) {
                                        datainput[indi] = cantidad;
                                    }
                                    it = it + 2;
                                }
                                switch (operadorU[indi]) {
                                    case '+':
                                        datainput[indi] = parseFloat(datainput[indi]) + parseFloat(cantidad);
                                        break;
                                    case '-':
                                        datainput[indi] = datainput[indi] - cantidad;
                                        break;
                                    case '*':
                                        datainput[indi] = datainput[indi] * cantidad;
                                        break;
                                    case '/':
                                        if (cantidad > 0) {
                                            datainput[indi] = datainput[indi] / cantidad;
                                        }
                                        break;
                                }
                                operadorU[indi] = "";
                                if (!findv) {
                                    for (let i = 0; i < vm.operator.length - 2; i++) {
                                        if (vm.operator[i] == parametro) {
                                            operadorU[indi] = parametro;
                                            break;
                                        }
                                    }
            
                                }
                            }
                            inputC.outcome_structure.calculation = datainput[0];
                            inputC.sub_result = datainput[0];
                        }
                    }
                    function calculoAnualO(inputC) {
            
                        var interes = 1 + ($rootScope.typeInterest / 100);
                        var totalCalc  =  0;
                        if (inputC.years_input > 1) {
                            if(inputC.dead_weight == 0) {
                                inputC.dead_weight = 100;
                            }
                            if(inputC.displacement == 0) {
                                inputC.displacement = 100;
                            }
                            if(inputC.attribution == 0) {
                                inputC.attribution = 100;
                            }
                            var anual  = (inputC.sub_result / inputC.years_input) * (inputC.dead_weight/100) * (inputC.displacement/100) * (inputC.attribution/100);
                            totalCalc = anual;    
                            for (let i = 2; i <= inputC.years_input; i++) {
                                anual = (anual * (1 - inputC.decrease /100) / interes);
                                totalCalc = totalCalc + anual;
                            }
                        }
                        else {
                          totalCalc  = inputC.sub_result * (inputC.dead_weight/100) * (inputC.displacement/100) * (inputC.attribution/100);  
                        }
                        inputC.result = totalCalc;
                    }
                    function calculo(inputC) {
                        if (inputC.input_structure) {
                            var valor = 0;
                            var valorParen = [];
                            var cantidad = 0;
                            var cantidadt = 0;
                            var indi = 0;
                            var datainput = [];
                            var operadorU = [];
                            if (inputC.input_structure.formula.length == 0) {
                                datainput[0] = 0;
                            }
                            for (let it = 0; it < inputC.input_structure.formula.length; it++) {
                                var findv = false;
                                var parametro = inputC.input_structure.formula[it];
                                for (let i = 0; i < inputC.input_structure.inputs.length; i++) {
                                    if (inputC.input_structure.inputs[i].fieldName == parametro) {
                                        cantidad = inputC.input_structure.inputs[i].data;
                                        if (!datainput[indi]) {
                                            datainput[indi] = cantidad;
                                        }
                                        findv = true;
                                        break;
                                    }
                                }
                                if (parametro == "(") {
                                    indi = indi + 1;
                                    continue;
                                }
                                if (parametro == ")") {
                                    cantidad = datainput[indi];
                                    datainput[indi] = 0;
                                    indi = indi - 1;
                                }
                                if (inputC.input_structure.formula[it + 1] && (inputC.input_structure.formula[it + 1] == "*" || inputC.input_structure.formula[it + 1] == "/")) {
                                    var operadorA = inputC.input_structure.formula[it + 1];
                                    if (!inputC.input_structure.formula[it + 2]) {
                                        datainput[0] = $translate.instant('INPUT.FORMULA_ERROR');
                                        break;
                                    }
                                    var parametro = inputC.input_structure.formula[it + 2];
                                    for (let i = 0; i < inputC.input_structure.inputs.length; i++) {
                                        if (inputC.input_structure.inputs[i].fieldName == parametro) {
                                            var cantidadMD = inputC.input_structure.inputs[i].data;
                                            break;
                                        }
                                    }
                                    switch (operadorA) {
                                        case '*':
                                            cantidad = cantidadMD * cantidad;
                                            break;
                                        case '/':
                                            if (cantidad > 0) {
                                                cantidad = cantidad / cantidadMD;
                                                break;
                                            }
                                    }
                                    if (!operadorU[indi]) {
                                        datainput[indi] = cantidad;
                                    }
                                    it = it + 2;
                                }
                                switch (operadorU[indi]) {
                                    case '+':
                                        datainput[indi] = parseFloat(datainput[indi]) + parseFloat(cantidad);
                                        break;
                                    case '-':
                                        datainput[indi] = datainput[indi] - cantidad;
                                        break;
                                    case '*':
                                        datainput[indi] = datainput[indi] * cantidad;
                                        break;
                                    case '/':
                                        if (cantidad > 0) {
                                            datainput[indi] = datainput[indi] / cantidad;
                                        }
                                        break;
                                }
                                operadorU[indi] = "";
                                if (!findv) {
                                    for (let i = 0; i < vm.operator.length - 2; i++) {
                                        if (vm.operator[i] == parametro) {
                                            operadorU[indi] = parametro;
                                            break;
                                        }
                                    }
            
                                }
                            }
                            inputC.input_structure.calculation = datainput[0];
                            inputC.sub_result = datainput[0];
                        }
                    }
                    function calculoAnual(inputC) {
                        var interes = 1 + ($rootScope.typeInterest / 100);
                        var totalCalc  =  0;
                        if (inputC.years > 1) {
                            var anual  = inputC.sub_result / inputC.years;
                            totalCalc = anual;    
                            for (let i = 2; i <= inputC.years; i++) {
                                anual = anual / interes;
                                totalCalc = totalCalc + anual;
                            }
                        }
                        else {
                          totalCalc  = inputC.sub_result  
                        }
                        inputC.result = totalCalc;
                    }
                    function saveDialog(company, ev) {
                        vm.company.type  = 3;
                        if (company.id) {
                            vm.formWizard = {};
                            $scope.isLoading = true;
                            vm.idCompany = company.id;
                            vm.formWizard.company = company;
                            vm.edit = false;
                        }
                        else {
                            //            vm.formWizard = {};
                            $scope.isLoading = true;
                            //           vm.idCompany = company.id;
                            vm.formWizard = {};
                            vm.formWizard.company = vm.company;
                            vm.edit = false;
                            vm.formWizard.company.company_id = $rootScope.companySel;
                        }
                        createProyect(null, true);
                    }
                    function closeDialog() {
                        vm.edit = false;
                    }
                    function editCompany() {
                        vm.users = [];
                        $rootScope.$broadcast('select-company', vm.formWizard.company);
                        sessionService.set('companySelected', vm.formWizard.company);
                        angular.forEach(vm.formWizard.personnel, function (u) {
                            var userExists = $filter('filter')(vm.users, { id: u.id });
                            if (userExists.length < 1) {
                                vm.users.push(u);
                            }
                        })
                        vm.readView = true;
                        vm.preview = false;
                    }
            
            
                    function closeForm(preview) {
                        if (vm.idCompany) {
                            getDataCompany(vm.idCompany);
                            vm.readView = false;
                            vm.preview = preview;
                        } else {
                            vm.goClients();
                        }
                    }
            
            
            
                    function createProyect(msWizard, close) {
                        //                       console.log(vm.formWizard);
                        var options = {
                            owner: $scope.owner,
                            item: transformitems.itemToDTO(vm.formWizard)
                        };
                        //                        console.log(transformitems.itemToDTO(vm.formWizard));
                        if (vm.idCompany) {
                            options.id = vm.idCompany;
                            //               console.log(options);
                            itemsService.updateProyect(options).then(function (response) {
            
                            });
            
            
                        } else {
                            //               options.item.is_owner = vm.companies.length > 0 ? 0 : true;
                            itemsService.createProyect(options).then(function (response) {
                                //                    sessionService.authenticate($cookies.get('owner'));
                                $scope.isLoadingP = true;
                                vm.idCompany = response.id;
                                getProyects();
            
                            })
                        }
                    }
            
                    function deleteitem(ev) {
                        var threads = angular.copy(vm.selectedThreads);
                        const confirm = $mdDialog.confirm()
                            .title($translate.instant('GLOBAL.ARE_YOU_SURE'))
                            .targetEvent(ev)
                            .ok($translate.instant('GLOBAL.YES'))
                            .cancel($translate.instant('GLOBAL.NO'));
                        $mdDialog.show(confirm).then(e => {
                            for (var i = 0; i < threads.length; i++) {
                                var options = {
                                    owner: $scope.owner,
                                    item_id: threads[i].id,
                                }
                                //                        console.log(options);
                                itemsService.deleteItem(options).then(function (response) {
                                    vm.edit = false;
                                    getProyects();
                                })
                            }
                        })
                        vm.edit = false;
                        vm.selectedThreads = [];
                    }
            
                    function isSelected(thread) {
                        return vm.selectedThreads.indexOf(thread) > -1;
                    }
            
                    /**
                     * Toggle selected status of the thread
                     *
                     * @param thread
                     * @param event
                     */
                    function toggleSelectThread(thread, event) {
                        if (event) {
                            event.stopPropagation();
                        }
            
                        if (vm.selectedThreads.indexOf(thread) > -1) {
                            vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
                        }
                        else {
                            vm.selectedThreads.push(thread);
                        }
                    }
                    function deleteitem1(ev) {
                        const message = $translate.instant('GLOBAL.ARE_YOU_SURE');
                        const yes = $translate.instant('GLOBAL.YES');
                        const no = $translate.instant('GLOBAL.NO');
            
                        const confirm = $mdDialog.confirm()
                            .title(message)
                            .targetEvent(ev)
                            .ok(yes)
                            .cancel(no);
            
                        $mdDialog.show(confirm).then(e => {
                            vm.deleteItem();
                        })
                            .catch(err => { })
            
                    }
                }
            })();
            
(function () {
    'use strict';

    angular
        .module('app.outputs')
        .service('outputsService', outputsService);

    /** @ngInject */
    // I provide access to the session store.
    function outputsService($q, $resource, settingsDomainService, sessionService, COMMON, $window, $mdToast, $state) {
        function deleteOutput(options) {
//           console.log(options);
            var deferred = $q.defer();
            resourceoutput.delete({
                owner: options.owner,
                Output_id: options.stake_id
            },
                function (response) {
//                    console.log(response);
                    deferred.resolve(response);
                },

                function (e) {
//                    console.log(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateOutput(options) {
            var deferred = $q.defer();
            resourceoutput.update({
                owner: options.owner,
                id: options.id
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    console.log(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function createOutput(options) {
            var deferred = $q.defer();
 //           console.log(options);
            resourceoutput.post({
                owner: options.owner
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    console.log(e);
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getoutputs(options) {
            var deferred = $q.defer();
//            console.log(options);
            resourceoutput.get(options,
                function (response) {
//                    console.log(options);
                    deferred.resolve(response);
                },

                function (e) {
//                    console.log(options);
                    console.log(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getProyects(options) {
            var deferred = $q.defer();
            resourceProyect.get(options,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    console.log(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        var resourceoutput = $resource(COMMON.BASE_API + "/owner/:owner/output/:id", {
            }, {
                    get: {
                        method: "GET",
//                        isArray: true,
                        isArray: true
                    },
    
                    post: {
                        method: "POST",
                        isArray: false
                    },
    
                    delete: {
                        method: "DELETE",
                        isArray: true
                    },
    
                    update: {
                        method: "PUT",
                        isArray: false
                    },
                });
        var resourceProyect = $resource(COMMON.BASE_API + "/owner/:owner/stakeholder/:id", {
                    // No default data
                }, {
                        get: {
                            method: "GET",
                            isArray: true
                        },
        
                        post: {
                            method: "POST",
                            isArray: false
                        },
        
                        delete: {
                            method: "DELETE",
                            isArray: true
                        },
        
                        update: {
                            method: "PUT",
                            isArray: false
                        },
                    });
        

        return ({
            updateOutput: updateOutput,
            deleteOutput: deleteOutput,
            getoutputs: getoutputs,
            createOutput: createOutput,
            getProyects: getProyects,
        });

    }

})();
(function () {
    'use strict';

    angular
        .module('app.jobpositions')
        .controller('JobPositionsController', JobPositionsController);

    /** @ngInject */
    function JobPositionsController($scope, $rootScope, $stateParams, $translate, $document, $mdDialog,
        $mdMedia, $mdSidenav, $state, msApi, tinyMceService, requestContext, mediaService, $timeout, jobPositionsService, transformJobPositions) {
        var vm = this;
        // Data
        vm.accounts = {
            'creapond': 'johndoe@creapond.com',
            'withinpixels': 'johndoe@withinpixels.com'
        };
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
        vm.selectedAccount = 'creapond';

        vm.folders = 'Folders.data';
        vm.labels = 'Labels.data';
        vm.loadingThreads = true;

        vm.currentFilter = {
            type: $state.params.type,
            filter: $state.params.filter
        };
        vm.currentThread = null;
        vm.selectedThreads = [];

        vm.views = {
            split: 'app/main/apps/jobpositions/views/list/split-view.html',
            nosplit: 'app/main/apps/jobpositions/views/list/nosplit-view.html'
        };
        vm.defaultView = 'split';
        vm.currentView = 'split';

        vm.readView = true;

        //Methods
        vm.openThread = openThread;
        vm.closeThread = closeThread;

        vm.isSelected = isSelected;
        vm.toggleSelectThread = toggleSelectThread;
        vm.selectThreads = selectThreads;
        vm.deselectThreads = deselectThreads;
        vm.toggleSelectThreads = toggleSelectThreads;

        vm.setThreadStatus = setThreadStatus;
        vm.toggleThreadStatus = toggleThreadStatus;


        vm.changeView = changeView;
        vm.toggleSidenav = toggleSidenav;
        vm.tinymceOptions = tinyMceService.getOptions($scope);

        vm.openJob = openJob;
        vm.closeJobs = closeJobs;
        vm.sendJob = sendJob;
        vm.deleteJob = deleteJob;
        vm.duplicateJob = duplicateJob;
        vm.newJob = newJob;
        vm.checkFields = checkFields;

        vm.getPositionNameById = getPositionNameById;


        //////////

        $scope.$on('pagination:loadStart', function (event) {
            $scope.isLoading = true;
        });

        $scope.$on('pagination:loadPage', function (event) {
            $scope.isLoading = false;
        });


        $scope.owner = $stateParams.owner;
        init();

        /////////////////

        function init() {
            // getPositions();
        }

        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'nosplit';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big)
                vm.currentView = 'nosplit';

        });

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small)
                vm.currentView = 'split';

        });

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                if (vm.defaultView === 'split') {
                    vm.currentView = 'split';
                }
            }
        });

        var originatorEv;

        function openMenu($mdOpenMenu, ev) {
            originatorEv = ev;
            $mdOpenMenu(ev);
        }

        function openJob(job) {
            if (vm.jobNew)
                vm.jobNew = undefined;
            vm.jobSelected = angular.copy(job);
        }

        function closeJobs() {
            vm.jobSelected = undefined;
            vm.jobNew = undefined;
        }

        function sendJob() {
            if (vm.jobSelected) {
                updateJob();
            } else if (vm.jobNew) {
                createJob();
            }
            initState();
        }

        function createJob() {
            var options = {
                owner: $scope.owner,
                item: vm.jobNew
            }
            jobPositionsService.createJob(options).then(function (response) {
                vm.jobNew = undefined;
                $rootScope.pagination_resetquery();
            })
        }

        function updateJob() {
            var options = {
                owner: $scope.owner,
                item: vm.jobSelected,
                id: vm.jobSelected.id
            }
            jobPositionsService.updateJobs(options).then(function (response) {
                vm.jobSelected = undefined;
                $rootScope.pagination_resetquery();
            })
        }

        function getPositions() {
            var options = {
                owner: $scope.owner
            };
            jobPositionsService.getPositions(options).then(function (response) {
                vm.positions = [];
                for (var i = 0; i < response.data.length; i++) {
                    vm.positions.push({ name: response.data[i].name, id: response.data[i].id });
                }
            })
        }

        function getPositionNameById(id) {
            for (var i = 0; i < vm.positions.length; i++) {
                if (vm.positions[i].id === id) return vm.positions[i].name;
            }
            return null;
        }

        function deleteJob(ev) {
            const message = $translate.instant('GLOBAL.ARE_YOU_SURE');
            const yes = $translate.instant('GLOBAL.YES');
            const no = $translate.instant('GLOBAL.NO');

            const confirm = $mdDialog.confirm()
                .title(message)
                .targetEvent(ev)
                .ok(yes)
                .cancel(no);

            $mdDialog.show(confirm).then(e => {
                var threads = angular.copy(vm.selectedThreads);
                vm.selectedThreads = [];
                for (var j = 0; j < threads.length; j++) {
                    var options = {
                        owner: $scope.owner,
                        id: threads[j].id
                    };
                    jobPositionsService.deleteJob(options).then(function (response) {
                        $rootScope.pagination_resetquery();
                    })
                    initState();
                }
            });

        }

        function duplicateJob() {
            var threads = angular.copy(vm.selectedThreads);
            vm.selectedThreads = [];
            for (var j = 0; j < threads.length; j++) {
                var options = {
                    owner: $scope.owner,
                    item: transformJobPositions.duplicateJobPosition(threads[j])
                };
                jobPositionsService.createJob(options).then(function (response) {
                    $rootScope.pagination_resetquery();
                })
                initState();
            }
        }

        function newJob() {
            if (vm.jobSelected)
                vm.jobSelected = undefined;
            vm.jobNew = {};
        }

        function initState() {
            vm.jobSelected = undefined;
            vm.jobNew = undefined;
        }

        function checkFields() {
            if (vm.jobNew) {
                return transformJobPositions.checkFields(vm.jobNew);
            } else if (vm.jobSelected) {
                return transformJobPositions.checkFields(vm.jobSelected);
            }
        }



        /**
         * Open thread
         *
         * @param thread
         */
        function openThread(thread) {
            // // Set the read status on the thread
            // thread.read = true;

            // // Assign thread as the current thread
            // vm.currentThread = thread;

            // // Update the state without reloading the controller
            // $state.go('app.aircrafts.threads.thread', { threadId: thread.id }, { notify: false });
        }

        /**
         * Close thread
         */
        function closeThread() {
            // vm.currentThread = null;

            // // Update the state without reloading the controller
            // $state.go('app.aircrafts.threads', {
            //     type: vm.currentFilter.type,
            //     filter: vm.currentFilter.filter
            // }, { notify: false });
        }

        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        function isSelected(thread) {
            return vm.selectedThreads.indexOf(thread) > -1;
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        function toggleSelectThread(thread, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedThreads.indexOf(thread) > -1) {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            } else {
                vm.selectedThreads.push(thread);
            }
        }

        /**
         * Select threads. If key/value pair given,
         * threads will be tested against them.
         *
         * @param [key]
         * @param [value]
         */
        function selectThreads(key, value) {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedThreads = [];

            for (var i = 0; i < vm.jobs.length; i++) {
                if (angular.isUndefined(key) && angular.isUndefined(value)) {
                    vm.selectedThreads.push(vm.jobs[i]);
                    continue;
                }

                if (angular.isDefined(key) && angular.isDefined(value) && vm.jobs[i][key] === value) {
                    vm.selectedThreads.push(vm.jobs[i]);
                }
            }
        }

        /**
         * Deselect threads
         */
        function deselectThreads() {
            vm.selectedThreads = [];
        }

        /**
         * Toggle select threads
         */
        function toggleSelectThreads() {
            if (vm.selectedThreads.length > 0) {
                vm.deselectThreads();
            } else {
                vm.selectThreads();
            }
        }

        /**
         * Set the status on given thread, current thread or selected threads
         *
         * @param key
         * @param value
         * @param [thread]
         * @param [event]
         */
        function setThreadStatus(key, value, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                thread[key] = value;
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                vm.currentThread[key] = value;
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                vm.selectedThreads[x][key] = value;
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleThreadStatus(key, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                if (typeof (thread[key]) !== 'boolean') {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                if (typeof (vm.currentThread[key]) !== 'boolean') {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                if (typeof (vm.selectedThreads[x][key]) !== 'boolean') {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }




        /**
         * Change the view
         *
         * @param view
         */
        function changeView(view) {
            if (vm.views[view]) {
                vm.defaultView = view;
                vm.currentView = view;
            }
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.jobpositions')
        .service('jobPositionsService', jobPositionsService);

    /** @ngInject */
    // I provide access to the session store.
    function jobPositionsService($q, $resource, settingsDomainService, sessionService, COMMON, $window, $mdToast) {

        function getJobs(options) {
            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });


            resourceJobs.get({
                owner: options.owner,
                page: options.page,
                resultsPerPage: options.resultsPerPage,
                search: options.searchStringFilter,
                paginate: options.paginate,
                sortField: 'name',
                sortDir: 'asc',
                filters: JSON.stringify(filters),
            },
                function (responseResult) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }



        function updateJobs(options) {
            var deferred = $q.defer();
            resourceJobs.update({
                owner: options.owner,
                id: options.id
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function createJob(options) {
            var deferred = $q.defer();
            resourceJobs.post({
                owner: options.owner,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function deleteJob(options) {
            var deferred = $q.defer();
            resourceJobs.delete({
                owner: options.owner,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getFilters(options) {
            var deferred = $q.defer();

            return (deferred.promise);
        }

        function getPositions(options) {
            var deferred = $q.defer();
            resourcePositions.get({
                owner: options.owner
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        var resourcePositions = $resource(COMMON.BASE_API + "/owner/:owner/jobPosition", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });



        var resourceJobs = $resource(COMMON.BASE_API + "/owner/:owner/jobPosition/:id", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                delete: {
                    method: "DELETE",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                },
            });



        return ({
            get: getJobs,
            getJobs: getJobs,
            getFilters: getFilters,
            getPositions: getPositions,
            updateJobs: updateJobs,
            deleteJob: deleteJob,
            createJob: createJob

        });

    }

})();
(function () {
    'use strict';

    angular
        .module('app.outcomes')
        .directive('stringToNumber', function() {
            return {
              require: 'ngModel',
              link: function(scope, element, attrs, ngModel) {
                ngModel.$parsers.push(function(value) {
                  return '' + value;
                });
                ngModel.$formatters.push(function(value) {
                  return parseFloat(value);
                });
              }
            };
          })
        .controller('outcomesController', outcomesController);

    /** @ngInject */
    function outcomesController($scope, $rootScope, $stateParams, companyService, $translate, $document, $mdDialog,
        $mdMedia, $mdSidenav, $state, msApi, tinyMceService, requestContext, evidencesControlsService, outcomesService, itemsService, inputsService,
        transformoutcomes, transformitems, transforminputs, mediaService, Upload, $filter, $timeout, msUtils, documentsService, dragulaService, sessionService, $cookies, is_owner) {
        var vm = this;
        vm.userLogued = sessionService.getUser();

        vm.loadingStep = false;
        vm.folders = 'Folders.data';
        vm.labels = 'Labels.data';
        vm.loadingThreads = true;
        vm.items  = [];
        vm.saveDialog = saveDialog;
        vm.currentFilter = {
            type: $state.params.type,
            filter: $state.params.filter
        };
        vm.index = 0;
        vm.currentThread = null;
        vm.selectedThreads = [];
        vm.stakeElemen = [];
        vm.selectedFields = [];
        vm.outcome = [];
        vm.getProyects = getProyects;
        //        vm.isCompanySelected = isCompanySelected;
        vm.cambio = false;
        vm.views = {
            split: 'app/main/apps/outcomes/views/list/split-view.html',
            nosplit: 'app/main/apps/outcomes/views/list/nosplit-view.html'
        };
        vm.defaultView = 'split';
        vm.currentView = 'split';
        vm.readView = false;
        vm.selectOp = "exit";
        vm.closeDialog = closeDialog;
        vm.addOperator = addOperator;
        vm.selectFields = selectFields;
        vm.addOpeField = addOpeField;
        vm.editOpeField = editOpeField;
        vm.nuevo = false;
        vm.salvar = false;
        vm.editOperator = editOperator;
        vm.deleteOperator = deleteOperator;
        vm.stakeholder = [];
        vm.tabActive = 'preview';
        vm.addelement = false;
        vm.editelement = false;
        vm.fieldAdd = false;
        vm.fieldEdit = false;
        vm.fieldMove = false;
        vm.campo = campo;
        vm.tipefield = [
            { number: '1', name: $translate.instant('ITEM.PROXY') },
            { number: '2', name: $translate.instant('ITEM.INDICATOR') },
            { number: '3', name: $translate.instant('ITEM.OUTPUT') }
        ];
        vm.operator = ['+', '-', '/', '*', "(", ")"];
        vm.element = "";
        vm.tipeFields = { fieldName: '', fieldType: "1", fieldEdit: "0", data: "0" };

        //        vm.tipefield = JSON.parse(vm.tipefield1);  
        //          console.log(vm.tipefield);
        //        vm.typeF = "";
        vm.addFields = addFields;
        vm.clearFields = clearFields;
        vm.calculo = calculo;
        vm.calculoAnual = calculoAnual;
        vm.deleteFields = deleteFields;
        vm.editFields = editFields;
        vm.administratorFields = vm.personFields;
        vm.managerLegalFields = vm.personFields;
        vm.complianceFields = vm.personFields;
        vm.reportFields = vm.personFields;
        vm.personnelFields = vm.personFields;
        //        vm.getRegionLiteral = getRegionLiteral;

        vm.companySelectEvent = companySelectEvent;
        //        vm.getSectorById = getSectorById;
        $scope.Inout = function (item) {
            return item === '1';
        };

        vm.idClient = undefined;
        vm.idCompany = undefined;
        vm.updateLogotype = false;
        vm.showForm = true;
        vm.allQuestions = true;
        $scope.storagePrefix = '';


        vm.isSelected = isSelected;
        vm.toggleSelectThread = toggleSelectThread;
        vm.newForm = newForm;
        vm.isSelectedField = isSelectedField;

        vm.deleteOutcome = deleteOutcome;
        vm.edit = false;
        vm.openCompany = openCompany;
        vm.getInputs = getInputs;
        vm.editCompany = editCompany;
        vm.getoutcomes = getoutcomes;
        vm.deletestake = deletestake;
        vm.getItems = getItems;


        //////////
        var companySelectEvent = $rootScope.$on('company-selected', function (event) {
            vm.addelement = false;
            vm.editelement = false;
            vm.fieldAdd = false;
            vm.fieldEdit = false;
            vm.edit = false;
            vm.tabActive = '';
            getProyects();
            getoutcomes();
            getItems();
            getInputs();
        });
        /*        dragulaService.options($scope, 'dragbag', {
        /*            copy: false,
                    copySortSource: false,
                    removeOnSpill: false,
                    direction: 'vertical',
                    moves: function (el, source, handle) {
        //                var result = handle.classList.contains('drag');
                        console.log("moves");
        //                return result;
                          return;
                    },
                    invalid: function (el, handle) {
                        return false; // don't prevent any drags from initiating by default
                    }
                });*/

        $scope.$on('pagination:loadStart', function (event) {
            $scope.isLoading = true;
            $scope.isLoadingP = true;
        });

        $scope.$on('dragbag.out', function (e, el) {
            vm.fieldMove = true;
        });
        $scope.$on('dragbagFormula.out', function (e, el) {
            vm.salvar = true;
        });

        $scope.$on('pagination:loadPage', function (event) {
            $scope.isLoading = false;
            vm.is_owner = vm.companies.length <= 1;
            //            getoutcomes();
            init();
        });
        //        init();
        $scope.owner = $stateParams.owner;


        this.awesomeCallback = function (node, tree) {
            // Do something with node or tree
        };

        this.otherAwesomeCallback = function (node, isSelected, tree) {
            // Do soemthing with node or tree based on isSelected
        };
        if ($rootScope.companySel) {
            getoutcomes();
            getProyects();
            getItems();
            getInputs();
        }

        function init() {
            mediaService.getStoragePrefix({
                owner: $scope.owner,
            }).then(function (res) {
                $scope.storagePrefix = res.prefix;
            })
            evidencesControlsService.getCurrencies({ owner: $scope.owner }).then(function (res) {
                vm.currencies = res.data;
            })
            outcomesService.getRegions({ owner: $scope.owner }).then(function (res) {
                vm.regions = res.data;
            })
            outcomesService.getFileRegions().then(function (res) {
                vm.regionsLiterals = res;
            })
        }

        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'nosplit';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big) {
                vm.currentView = 'nosplit';
            }

        });

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small) {
                vm.currentView = 'split';
            }

        });

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                if (vm.defaultView === 'split') {
                    vm.currentView = 'split';
                }
            }
        });


        var originatorEv;

        function openMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        }
        function addOpeField() {
            if (!vm.editelement) {
                vm.addelement = true;
                vm.element = '';
            }
        }
        function editOpeField() {
            if (!vm.addelement) {
                vm.editelement = true;
            }
        }

        function getoutcomes(idCompany, inOwner) {
            var options = {
                owner: $scope.owner,
                proyect_id: $rootScope.companySel,
                withFiles: true
            };
            outcomesService.getOutcomes(options).then(function (response) {
                vm.outcome = response;
                $scope.isLoadingP = false;
            }, function (response) {
                vm.outcome = [];
                $scope.isLoadingP = false;
            }
            )
        }
        function getInputs(idCompany, inOwner) {
            var options = {
                owner: $scope.owner,
                proyect_id: $rootScope.companySel,
                withFiles: true
            };
            inputsService.getInputs(options).then(function (response) {
                vm.input = response;
                $scope.isLoadingP = false;
            }, function (response) {
                vm.input = [];
                $scope.isLoadingP = false;
            }
            )
        }
        function clearFields() {
            vm.fieldAdd = true;
            vm.tipeFields = { fieldName: " ", fieldType: "1", fieldEdit: "0", data: "0", id_item: "0" };
        }
        function addFields(fieldsNew, ev) {
            vm.fieldsNew = fieldsNew;
            if (!vm.company.outcome_structure) {
                vm.company.outcome_structure = {"calculation": "0","formula": [],"outcomes": []};  
            }
            //            vm.tipeFields = { fieldName: '', fieldType: "1", fieldEdit: "0", data: "0" };
            vm.formWizard = {};
            if (vm.nuevo) {
                vm.formWizardItem = {};
//                vm.formWizardItem.company = vm.tipeFields;
                vm.formWizardItem.company = Object.assign({} , vm.tipeFields);

//                console.log(vm.tipeFields);
                vm.formWizardItem.company.company_id = $rootScope.companySel;
                vm.formWizardItem.company.name = vm.formWizardItem.company.fieldName;
                vm.formWizardItem.company.description_item = "";
                vm.formWizardItem.company.value = vm.formWizardItem.company.data;
                vm.formWizardItem.company.type = vm.formWizardItem.company.fieldType;
//                console.log(vm.formWizardItem);
                var options = {
                    owner: $scope.owner,
                    item: transformitems.itemToDTO(vm.formWizardItem)
                };
                itemsService.createProyect(options).then(function (response) {
                    vm.idItem = response.id;
                    vm.tipeFields.id_item  = vm.idItem;
//                    console.log(vm.tipeFields);
                    vm.company.outcome_structure.outcomes.push(vm.tipeFields);
                    vm.formWizard.company = vm.company;
                    vm.idCompany = vm.company.id;
                    vm.nuevo = false;
                    createProyect();

                })
                }
            else {
            if (vm.fieldAdd) {
                vm.company.outcome_structure.outcomes.push(vm.tipeFields);
            }
            if (vm.fieldEdit) {
                vm.company.outcome_structure.outcomes[vm.index].fieldName = vm.tipeFields.fieldName;
                vm.company.outcome_structure.outcomes[vm.index].tipefield = vm.tipeFields.tipefield;
                vm.company.outcome_structure.outcomes[vm.index].fieldEdit = vm.tipeFields.fieldEdit;
                vm.company.outcome_structure.outcomes[vm.index].id_item = vm.tipeFields.id_item;
            }
            vm.formWizard.company = vm.company;
            vm.idCompany = vm.company.id;
            createProyect(vm.fieldsNew);
            if (vm.cambio) {
                changeValue(vm.tipeFields);
                vm.cambio = false;
            }
    }
        }
        function changeValue(itemC) {
            //                        return;
            var options = {
                owner: $scope.owner,
                proyect_id: vm.company.id,
                withFiles: true
            };
            vm.input.forEach(function (input1, index) {
                if (!input1.input_structure.inputs) {
                    input1.input_structure = JSON.parse(input1.input_structure);
                }
                var inputF1 = input1.input_structure.inputs;
                inputF1.forEach(function (input1F, indexF) {
                    if (itemC.id_item == input1F.id_item && input1F.id_item != itemC.data) {
                        input1F.data = itemC.data;
                        input1F.fieldEdit = itemC.fieldEdit;
                        calculoI(input1);
                        calculoAnualI(input1);
                        saveInput(input1);
                    }
                });
            });
            vm.outcome.forEach(function (input1, index) {
                if (!input1.outcome_structure.outcomes) {
                    input1.outcome_structure = JSON.parse(input1.outcome_structure);
                }
                var inputF1 = input1.outcome_structure.outcomes;
                inputF1.forEach(function (input1F, indexF) {
                    if (itemC.id_item == input1F.id_item && input1F.id_item != itemC.data) {
                        input1F.data = itemC.data;
                        input1F.fieldEdit = itemC.fieldEdit;
                        calculo(input1);
                        calculoAnual(input1);
                        saveOutcome(input1);
                    }
                });
            });
            //                getinputs();
            //                getoutcomes();
            vm.items.forEach(function (item1, index) {
                if (item1.id == itemC.id_item) {
                    item1.value = itemC.data;
                    item1.edit_item = itemC.fieldEdit;
                    updateItem(item1, "");
                }
            });
            vm.cambio = false;
            //            vm.edit = false;
        }
        function saveInput(inputC) {
            var inputC1 = {};
            inputC1.company = inputC;
            var options = {
                owner: $scope.owner,
                item: transforminputs.inputToDTO(inputC1)
            };
            options.id = inputC.id;
            inputsService.updateInput(options).then(function (response) {
            });
        }
        function updateItem(itemUpdate, close) {
            vm.formWizard = {};
            vm.formWizard.company = itemUpdate;
            if (itemUpdate.id) {
                var options = {
                    owner: $scope.owner,
                    item: transformitems.itemToDTO(vm.formWizard)
                };
                options.id = itemUpdate.id;
                itemsService.updateProyect(options).then(function (response) {

                });


            }
        }
        function calculoI(inputC) {
            if (inputC.input_structure) {
                var valor = 0;
                var valorParen = [];
                var cantidad = 0;
                var cantidadt = 0;
                var indi = 0;
                var datainput = [];
                var operadorU = [];
                if (inputC.input_structure.formula.length == 0) {
                    datainput[0] = 0;
                }
                for (let it = 0; it < inputC.input_structure.formula.length; it++) {
                    var findv = false;
                    var parametro = inputC.input_structure.formula[it];
                    for (let i = 0; i < inputC.input_structure.inputs.length; i++) {
                        if (inputC.input_structure.inputs[i].fieldName == parametro) {
                            cantidad = inputC.input_structure.inputs[i].data;
                            if (!datainput[indi]) {
                                datainput[indi] = cantidad;
                            }
                            findv = true;
                            break;
                        }
                    }
                    if (parametro == "(") {
                        indi = indi + 1;
                        continue;
                    }
                    if (parametro == ")") {
                        cantidad = datainput[indi];
                        datainput[indi] = 0;
                        indi = indi - 1;
                    }
                    if (inputC.input_structure.formula[it + 1] && (inputC.input_structure.formula[it + 1] == "*" || inputC.input_structure.formula[it + 1] == "/")) {
                        var operadorA = inputC.input_structure.formula[it + 1];
                        if (!inputC.input_structure.formula[it + 2]) {
                            datainput[0] = $translate.instant('INPUT.FORMULA_ERROR');
                            break;
                        }
                        var parametro = inputC.input_structure.formula[it + 2];
                        for (let i = 0; i < inputC.input_structure.inputs.length; i++) {
                            if (inputC.input_structure.inputs[i].fieldName == parametro) {
                                var cantidadMD = inputC.input_structure.inputs[i].data;
                                break;
                            }
                        }
                        switch (operadorA) {
                            case '*':
                                cantidad = cantidadMD * cantidad;
                                break;
                            case '/':
                                if (cantidad > 0) {
                                    cantidad = cantidad / cantidadMD;
                                    break;
                                }
                        }
                        if (!operadorU[indi]) {
                            datainput[indi] = cantidad;
                        }
                        it = it + 2;
                    }
                    switch (operadorU[indi]) {
                        case '+':
                            datainput[indi] = parseFloat(datainput[indi]) + parseFloat(cantidad);
                            break;
                        case '-':
                            datainput[indi] = datainput[indi] - cantidad;
                            break;
                        case '*':
                            datainput[indi] = datainput[indi] * cantidad;
                            break;
                        case '/':
                            if (cantidad > 0) {
                                datainput[indi] = datainput[indi] / cantidad;
                            }
                            break;
                    }
                    operadorU[indi] = "";
                    if (!findv) {
                        for (let i = 0; i < vm.operator.length - 2; i++) {
                            if (vm.operator[i] == parametro) {
                                operadorU[indi] = parametro;
                                break;
                            }
                        }

                    }
                }
                inputC.input_structure.calculation = datainput[0];
                inputC.sub_result = datainput[0];
            }
        }
        function calculoAnualI(inputC) {
            var interes = 1 + ($rootScope.typeInterest / 100);
            var totalCalc = 0;
            if (inputC.years > 1) {
                var anual = inputC.sub_result / inputC.years;
                totalCalc = anual;
                for (let i = 2; i <= inputC.years; i++) {
                    anual = anual / interes;
                    totalCalc = totalCalc + anual;
                }
            }
            else {
                totalCalc = inputC.sub_result
            }
            inputC.result = totalCalc;
        }
        function saveOutcome(inputC) {

            var inputC1 = {};
            inputC1.company = inputC;
            var options = {
                owner: $scope.owner,
                item: transformoutcomes.outcomeToDTO(inputC1)
            };
            options.id = inputC.id;
//    console.log(options);
            outcomesService.updateOutcome(options).then(function (response) {

            });

        }
        function deleteFields(fieldsNew, ev) {
            vm.fieldsNew = fieldsNew;
            vm.formWizard = {};
            vm.company.outcome_structure.outcomes.splice(vm.index, 1);
            vm.fieldEdit = false;
            vm.fieldAdd = false;
            addFields();
        }
        function editFields(inputt, ev) {
            vm.tipeFields = inputt;
            vm.index = ev;
            vm.fieldEdit = true;
        }
        function selectFields(inputt, ev) {
            if (inputt != "NEW") {
                vm.tipeFields.fieldName = inputt.name;
                vm.tipeFields.data = inputt.value;
                vm.tipeFields.fieldEdit = inputt.edit_item;
                vm.nuevo = false;
            }
            else {
                vm.tipeFields.fieldName = "";
                vm.tipeFields.data = 0;
                vm.nuevo = true;
            }
            }
        function addOperator() {
            if (vm.selectOp != "exit") {
                if(!vm.element){
                    switch (vm.selectOp) {
                        case 0:
                            vm.element = vm.operator[0];
                            vm.company.outcome_structure.formula.push(vm.element);
                        break;
                        case 1:
                            vm.element = vm.operator[1];
                            vm.company.outcome_structure.formula.push(vm.element);
                        break;
                        case 2:
                            vm.element = vm.operator[2];
                            vm.company.outcome_structure.formula.push(vm.element);
                        break;
                        case 3:
                            vm.element = vm.operator[3];
                            vm.company.outcome_structure.formula.push(vm.element);
                        break;
                        case 4:
                            vm.element = vm.operator[4];
                            vm.company.outcome_structure.formula.push(vm.element);
                        break;
                        case 5:
                            vm.element = vm.operator[5];
                            vm.company.outcome_structure.formula.push(vm.element);
                        break;
                    }
                }else{
                    vm.company.outcome_structure.formula.push(vm.element);
                }
            }
            else {
                vm.salvar = true;
                vm.addelement = false;
            }
            vm.element = '';
            vm.selectOp = "exit";
        }
        function editOperator(ev) {
            if (vm.element == "Eliminar") {
                vm.company.outcome_structure.formula.splice(vm.index, 1);
            }
            else {
                if (vm.selectOp != "exit") {
                    vm.company.outcome_structure.formula[vm.index] = vm.element;
                }
            }
            vm.editelement = false;
            vm.element = '';
            vm.salvar = true;
            vm.selectOp = "exit";
        }
        function deleteOperator(ev) {
            vm.company.outcome_structure.formula.splice(vm.index, 1);
            vm.salvar = true;
            vm.selectOp = "exit";
        }
        function campo(ev) {
            return (ev);
        }
        function calculo() {
            if (vm.company.outcome_structure) {
                var valor = 0;
                var valorParen = [];
                var cantidad = 0;
                var cantidadt = 0;
                var indi = 0;
                var datainput = [];
                var operadorU = [];
                if (vm.company.outcome_structure.formula.length == 0) {
                    datainput[0] = 0;
                }
                    for (let it = 0; it < vm.company.outcome_structure.formula.length; it++) {
                    var findv = false;
                    var parametro = vm.company.outcome_structure.formula[it];
                    for (let i = 0; i < vm.company.outcome_structure.outcomes.length; i++) {
                        if (vm.company.outcome_structure.outcomes[i].fieldName == parametro) {
                            cantidad = vm.company.outcome_structure.outcomes[i].data;
                            if (!datainput[indi]) {
                                datainput[indi] = cantidad;
                            }
                            findv = true;
                            break;
                        }
                    }
                    if (parametro == "(") {
                        indi = indi + 1;
                        continue;
                    }
                    if (parametro == ")") {
                        cantidad = datainput[indi];
                        datainput[indi] = 0;
                        indi = indi - 1;
                    }
                    if (vm.company.outcome_structure.formula[it + 1] && (vm.company.outcome_structure.formula[it + 1] == "*" || vm.company.outcome_structure.formula[it + 1] == "/")) {
                        var operadorA = vm.company.outcome_structure.formula[it + 1];
                        if (!vm.company.outcome_structure.formula[it + 2]) {
                            datainput[0] = $translate.instant('INPUT.FORMULA_ERROR');
                            break;
                        }
                        var parametro = vm.company.outcome_structure.formula[it + 2];
                        for (let i = 0; i < vm.company.outcome_structure.outcomes.length; i++) {
                            if (vm.company.outcome_structure.outcomes[i].fieldName == parametro) {
                                var cantidadMD = vm.company.outcome_structure.outcomes[i].data;
                                break;
                            }
                        }
                        switch (operadorA) {
                            case '*':
                                cantidad = cantidadMD * cantidad;
                                break;
                            case '/':
                                if (cantidad > 0) {
                                    cantidad = cantidad / cantidadMD;
                                    break;
                                }
                        }
                        if (!operadorU[indi]) {
                            datainput[indi] = cantidad;
                        }
                        it = it + 2;
                    }
                    switch (operadorU[indi]) {
                        case '+':
                            datainput[indi] = parseFloat(datainput[indi]) + parseFloat(cantidad);
                            break;
                        case '-':
                            datainput[indi] = datainput[indi] - cantidad;
                            break;
                        case '*':
                            datainput[indi] = datainput[indi] * cantidad;
                            break;
                        case '/':
                            if (cantidad > 0) {
                                datainput[indi] = datainput[indi] / cantidad;
                            }
                            break;
                    }
                    operadorU[indi] = "";
                    if (!findv) {
                        for (let i = 0; i < vm.operator.length - 2; i++) {
                            if (vm.operator[i] == parametro) {
                                operadorU[indi] = parametro;
                                break;
                            }
                        }

                    }
                }
                vm.company.outcome_structure.calculation = datainput[0];
                vm.company.sub_result = datainput[0];
            }
        }
        function calculoAnual() {
            var interes = 1 + ($rootScope.typeInterest / 100);
            var totalCalc  =  0;
            if (vm.company.years_input > 1) {
                if(vm.company.dead_weight == 0) {
                    vm.company.dead_weight = 100;
                }
                if(vm.company.displacement == 0) {
                    vm.company.displacement = 100;
                }
                if(vm.company.attribution == 0) {
                    vm.company.attribution = 100;
                }
                var anual  = (vm.company.sub_result / vm.company.years_input) * (vm.company.dead_weight/100) * (vm.company.displacement/100) * (vm.company.attribution/100);
                totalCalc = anual;    
                for (let i = 2; i <= vm.company.years_input; i++) {
                    anual = (anual * (1 - vm.company.decrease /100) / interes);
                    totalCalc = totalCalc + anual;
                }
            }
            else {
              totalCalc  = vm.company.sub_result  * (vm.company.dead_weight/100) * (vm.company.displacement/100) * (vm.company.attribution/100); 
            }
            vm.company.result = totalCalc;
        }
        function getItems(idCompany, inOwner) {
            var options = {
                owner: $scope.owner,
                proyect_id: $rootScope.companySel,
                withFiles: true
            };
            itemsService.getProyects(options).then(function (response) {
                vm.items = response;
            } , function(response) {
                vm.items  = [];
//                $scope.isLoadingP = true;
                   }
            )
                }
        function openCompany(inputSel, ev) {
            vm.company = inputSel;
            if (!vm.company.outcome_structure.calculation) {
                vm.company.outcome_structure = JSON.parse(vm.company.outcome_structure);
            }
            vm.edit = true;
            vm.tabActive = 'preview';
        }

        function saveDialog(company, ev) {
            if (company.id) {
                vm.formWizard = {};
                $scope.isLoading = true;
                vm.idCompany = company.id;
                vm.formWizard.company = company;
                vm.edit = false;
                vm.tabActive = '';
            }
            else {
                $scope.isLoading = true;
                vm.formWizard = {};
                vm.formWizard.company = vm.company;
                vm.edit = false;
                vm.tabActive = '';
                vm.formWizard.company.proyect_id = $rootScope.companySel;
            }
            vm.addelement = false;
            createProyect(null, true);
            for (var i = 0; i < vm.selectedFields.length; i++) {
                vm.cambio = true;
                changeValue(vm.selectedFields[i]);
                vm.cambio = false;
            }
            vm.selectedFields = [];
        }
        function closeDialog() {
            vm.edit = false;
            vm.tabActive = '';
        }
        function editCompany() {
            vm.users = [];
            $rootScope.$broadcast('select-company', vm.formWizard.company);
            sessionService.set('companySelected', vm.formWizard.company);
            angular.forEach(vm.formWizard.personnel, function (u) {
                var userExists = $filter('filter')(vm.users, { id: u.id });
                if (userExists.length < 1) {
                    vm.users.push(u);
                }
            })
            vm.readView = true;
            vm.preview = false;
        }


        function newForm(ev) {
            vm.idCompany = null;
            vm.company = [];
            vm.edit = true;
            vm.tabActive = 'edit';
        }

        function closeForm(preview) {
            if (vm.idCompany) {
                getDataCompany(vm.idCompany);
                vm.readView = false;
                vm.preview = preview;
            } else {
                vm.goClients();
            }
        }
        function createProyect(msWizard, close) {
            var options = {
                owner: $scope.owner,
                item: transformoutcomes.outcomeToDTO(vm.formWizard)
            };
            if (vm.idCompany) {
                options.id = vm.idCompany;
                outcomesService.updateOutcome(options).then(function (response) {
                    vm.fieldAdd = false;
                    vm.fieldEdit = false;
                    vm.tipeFields = { fieldName: '', fieldType: "1", fieldEdit: "0", data: "0", id_item: "0" };
                    getoutcomes();

                });


            } else {
                outcomesService.createOutcome(options).then(function (response) {
                    $scope.isLoadingP = true;
                    vm.idCompany = response.id;
                    vm.fieldEdit = false;
                    vm.fieldAdd = false;
                    getoutcomes();

                })
            }
        }

        function deleteOutcome(ev) {
            var threads = angular.copy(vm.selectedThreads);
            const message = $translate.instant('GLOBAL.ARE_YOU_SURE');
            const yes = $translate.instant('GLOBAL.YES');
            const no = $translate.instant('GLOBAL.NO');

            vm.selectedThreads = [];
            for (var j = 0; j < threads.length; j++) {
                var options = {
                    owner: $scope.owner,
                    stake_id: threads[j].id
                };
                const confirm = $mdDialog.confirm()
                    .title(message)
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);
                $mdDialog.show(confirm).then(e => {
                    outcomesService.deleteOutcome(options).then(function (response) {
                        vm.edit = false;
                        getoutcomes();
                    })
                })
                    .catch(err => { })
            }
            //           getoutcomes();
        }

        function isSelected(thread) {
            return vm.selectedThreads.indexOf(thread) > -1;
        }
        function isSelectedField(thread) {
            if (vm.selectedFields.indexOf(thread) == -1) {
                vm.selectedFields.push(thread);
            }
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        function toggleSelectThread(thread, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedThreads.indexOf(thread) > -1) {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            }
            else {
                vm.selectedThreads.push(thread);
            }
        }
        function deletestake(ev) {
            const message = $translate.instant('GLOBAL.ARE_YOU_SURE');
            const yes = $translate.instant('GLOBAL.YES');
            const no = $translate.instant('GLOBAL.NO');

            const confirm = $mdDialog.confirm()
                .title(message)
                .targetEvent(ev)
                .ok(yes)
                .cancel(no);

            $mdDialog.show(confirm).then(e => {
                vm.deleteOutcome();
            })
                .catch(err => { })

        }
        function getProyects(idCompany, inOwner) {
            var options = {
                owner: $scope.owner,
                company_id: $rootScope.companySel,
                withFiles: true
            };
            outcomesService.getProyects(options).then(function (response) {
                vm.stakeholder = response;
                $scope.isLoadingP = false;
            }, function (response) {
                vm.stakeholder = [];
            }
            )
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('app.outcomes')
        .service('outcomesService', outcomesService);

    /** @ngInject */
    // I provide access to the session store.
    function outcomesService($q, $resource, settingsDomainService, sessionService, COMMON, $window, $mdToast, $state) {
        function deleteOutcome(options) {
//           console.log(options);
            var deferred = $q.defer();
            resourceoutcome.delete({
                owner: options.owner,
                outcome_id: options.stake_id
            },
                function (response) {
//                    console.log(response);
                    deferred.resolve(response);
                },

                function (e) {
                    console.log(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateOutcome(options) {
            var deferred = $q.defer();
            resourceoutcome.update({
                owner: options.owner,
                id: options.id
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    console.log(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function createOutcome(options) {
            var deferred = $q.defer();
 //           console.log(options);
            resourceoutcome.post({
                owner: options.owner
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    console.log(e);
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getOutcomes(options) {
            var deferred = $q.defer();
//            console.log(options);
            resourceoutcome.get(options,
                function (response) {
//                    console.log(response);
                    deferred.resolve(response);
                },

                function (e) {
//                    console.log(options);
                    console.log(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getProyects(options) {
            var deferred = $q.defer();
            resourceProyect.get(options,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    console.log(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        var resourceoutcome = $resource(COMMON.BASE_API + "/owner/:owner/outcome/:id", {
//            var resourceoutcome = $resource(COMMON.BASE_API + "/owner/:owner/outcome/", {
                // No default data
            }, {
                    get: {
                        method: "GET",
                        isArray: true
                    },
    
                    post: {
                        method: "POST",
                        isArray: false
                    },
    
                    delete: {
                        method: "DELETE",
                        isArray: true
                    },
    
                    update: {
                        method: "PUT",
                        isArray: false
                    },
                });
        var resourceProyect = $resource(COMMON.BASE_API + "/owner/:owner/stakeholder/:id", {
                    // No default data
                }, {
                        get: {
                            method: "GET",
                            isArray: true
                        },
        
                        post: {
                            method: "POST",
                            isArray: false
                        },
        
                        delete: {
                            method: "DELETE",
                            isArray: true
                        },
        
                        update: {
                            method: "PUT",
                            isArray: false
                        },
                    });
        

        return ({
            updateOutcome: updateOutcome,
            deleteOutcome: deleteOutcome,
            getOutcomes: getOutcomes,
            createOutcome: createOutcome,
            getProyects: getProyects,
        });

    }

})();
(function () {
    'use strict';

    angular
        .module('app.items')
        .directive('stringToNumber', function () {
            return {
                require: 'ngModel',
                link: function (scope, element, attrs, ngModel) {
                    ngModel.$parsers.push(function (value) {
                        return '' + value;
                    });
                    ngModel.$formatters.push(function (value) {
                        return parseFloat(value);
                    });
                }
            };
        })
        .controller('itemsController', itemsController);

    /** @ngInject */
    function itemsController($scope, $rootScope, $stateParams, companyService, $translate, $document, $mdDialog, inputsService, outcomesService,
        $mdMedia, $mdSidenav, $state, msApi, tinyMceService, requestContext, evidencesControlsService, itemsService,
        transformitems, transforminputs, transformoutcomes, mediaService, Upload, $filter, $timeout, msUtils, documentsService, sessionService, $cookies, is_owner) {
        var vm = this;
//        vm.userLogued = sessionService.getUser();

        vm.saveInput = saveInput;
        vm.saveOutcome = saveOutcome;
        vm.input = [];
        vm.loadingStep = false;
        vm.folders = 'Folders.data';
        vm.labels = 'Labels.data';
        vm.loadingThreads = true;
        vm.saveDialog = saveDialog;
        vm.changeValue = changeValue;
//        vm.calculoAnual = calculo;
        vm.calculoAnual = calculoAnual;
//    vm.calculoAnualO = calculoO;
        vm.calculoAnualO = calculoAnualO;
        vm.cambio = false;
        vm.currentFilter = {
            type: $state.params.type,
            filter: $state.params.filter
        };
        vm.operator = ['+', '-', '/', '*', "(", ")"];
        vm.currentThread = null;
        vm.selectedThreads = [];
        vm.itemElemen = [];
        vm.item = [];
        //        vm.isCompanySelected = isCompanySelected;
        vm.views = {
            split: 'app/main/apps/items/views/list/split-view.html',
            nosplit: 'app/main/apps/items/views/list/nosplit-view.html'
        };
        vm.defaultView = 'split';
        vm.currentView = 'split';
        //        console.log($rootScope.companySel);
        vm.readView = false;
        vm.closeDialog = closeDialog;

        vm.administratorFields = vm.personFields;
        vm.managerLegalFields = vm.personFields;
        vm.complianceFields = vm.personFields;
        vm.reportFields = vm.personFields;
        vm.personnelFields = vm.personFields;
        //        vm.getRegionLiteral = getRegionLiteral;

        vm.companySelectEvent = companySelectEvent;
        //        vm.getSectorById = getSectorById;


        vm.idClient = undefined;
        vm.idCompany = undefined;
        vm.updateLogotype = false;
        vm.showForm = true;
        vm.allQuestions = true;
        $scope.storagePrefix = '';
        vm.tipefield = [
            { number: '1', name: $translate.instant('ITEM.PROXY') },
            { number: '2', name: $translate.instant('ITEM.INDICATOR') },
            { number: '3', name: $translate.instant('ITEM.OUTPUT') }
        ];
        vm.editfield = [
            { number: '0', name: $translate.instant('ITEM.NOT') },
            { number: '1', name: $translate.instant('ITEM.YES') }
        ];


        vm.isSelected = isSelected;
        vm.toggleSelectThread = toggleSelectThread;
        vm.newForm = newForm;

//        vm.deleteitem = deleteitem;
        vm.edit = false;
        vm.openCompany = openCompany;
        vm.editCompany = editCompany;
        vm.getProyects = getProyects;
        vm.deleteitem = deleteitem;


        //////////
        var companySelectEvent = $rootScope.$on('company-selected', function (event) {
           getProyects();
            //           getComplianceOfficers();
        });

        $scope.$on('pagination:loadStart', function (event) {
            $scope.isLoading = true;
            $scope.isLoadingP = true;
        });

        $scope.$on('pagination:loadPage', function (event) {
            $scope.isLoading = false;
            vm.is_owner = vm.companies.length <= 1;
            //            getProyects();
//            init();
        });
        //        init();
        $scope.owner = $stateParams.owner;


        this.awesomeCallback = function (node, tree) {
            // Do something with node or tree
        };

        this.otherAwesomeCallback = function (node, isSelected, tree) {
            // Do soemthing with node or tree based on isSelected
        };
        if ($rootScope.companySel) {
            getProyects();
        }

        function init() {
            mediaService.getStoragePrefix({
                owner: $scope.owner,
            }).then(function (res) {
                $scope.storagePrefix = res.prefix;
            })
            evidencesControlsService.getCurrencies({ owner: $scope.owner }).then(function (res) {
                vm.currencies = res.data;
            })
            itemsService.getRegions({ owner: $scope.owner }).then(function (res) {
                vm.regions = res.data;
            })
            itemsService.getFileRegions().then(function (res) {
                vm.regionsLiterals = res;
            })
        }

        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'nosplit';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big) {
                vm.currentView = 'nosplit';
            }

        });

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small) {
                vm.currentView = 'split';
            }

        });

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                if (vm.defaultView === 'split') {
                    vm.currentView = 'split';
                }
            }
        });


        var originatorEv;

        function openMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        }

        function newForm(ev) {
            vm.idCompany = null;
            vm.company = [];
            vm.edit = true;
        }

        function getProyects(idCompany, inOwner) {
            var options = {
                owner: $scope.owner,
                proyect_id: $rootScope.companySel,
                withFiles: true
            };
            //           console.log(vm.itemElemen);
            itemsService.getProyects(options).then(function (response) {
                vm.item = response;
                $scope.isLoadingP = false;
            }, function (response) {
                vm.item = [];
                //                $scope.isLoadingP = true;
            }
            )
        }

        function openCompany(company, ev) {
            vm.company = company;
//            console.log(vm.company);
            vm.edit = true;
        }

        function changeValue(itemC) {
//            console.log(itemC);
            if (vm.cambio && itemC.id) {
                var options = {
                    owner: $scope.owner,
                    proyect_id: $rootScope.companySel,
                    withFiles: true
                };
                inputsService.getInputs(options).then(function (response) {
                    vm.input = response;
                    vm.input.forEach(function (input1, index) {
                        input1.input_structure = JSON.parse(input1.input_structure);
                        var inputF1 = input1.input_structure.inputs;
                        inputF1.forEach(function (input1F, indexF) {
                            if(itemC.id == input1F.id_item) {
//                                console.log(input1F);    
                                input1F.data = itemC.value;
                                input1F.fieldEdit  = itemC.edit_item;
//                                console.log(input1F);
                                calculo(input1);
                                calculoAnual(input1);
                                saveInput(input1);
                        }
                        });
                    });
                }, function (response) {
                    vm.input = [];
                    $scope.isLoadingP = false;
                }
                )
                outcomesService.getOutcomes(options).then(function (response) {
                    vm.input = response;
                    vm.input.forEach(function (input1, index) {
                        input1.outcome_structure = JSON.parse(input1.outcome_structure);
                        var inputF1 = input1.outcome_structure.outcomes;
                        inputF1.forEach(function (input1F, indexF) {
                            if(itemC.id == input1F.id_item) {
                                input1F.data = itemC.value;
                                input1F.fieldEdit  = itemC.edit_item;
                                calculoO(input1);
                                calculoAnualO(input1);
                                saveOutcome(input1);
                        }
                        });
                    });
                }, function (response) {
                    vm.input = [];
                    $scope.isLoadingP = false;
                }
                )
            }
            vm.cambio = false;
        }
        function saveOutcome(inputC) {

            var inputC1 = {};
            inputC1.company = inputC;
            var options = {
                owner: $scope.owner,
                item: transformoutcomes.outcomeToDTO(inputC1)
            };
                options.id =inputC.id;
                outcomesService.updateOutcome(options).then(function (response) {

                });

        }

        function saveInput(inputC) {

            var inputC1 = {};
            inputC1.company = inputC;
            var options = {
                owner: $scope.owner,
                item: transforminputs.inputToDTO(inputC1)
            };
                options.id =inputC.id;
                inputsService.updateInput(options).then(function (response) {

                });

        }
        function calculoO(inputC) {
            if (inputC.outcome_structure) {
                var valor = 0;
                var valorParen = [];
                var cantidad = 0;
                var cantidadt = 0;
                var indi = 0;
                var datainput = [];
                var operadorU = [];
                if (inputC.outcome_structure.formula.length == 0) {
                    datainput[0] = 0;
                }
                for (let it = 0; it < inputC.outcome_structure.formula.length; it++) {
                    var findv = false;
                    var parametro = inputC.outcome_structure.formula[it];
                    for (let i = 0; i < inputC.outcome_structure.outcomes.length; i++) {
                        if (inputC.outcome_structure.outcomes[i].fieldName == parametro) {
                            cantidad = inputC.outcome_structure.outcomes[i].data;
                            if (!datainput[indi]) {
                                datainput[indi] = cantidad;
                            }
                            findv = true;
                            break;
                        }
                    }
                    if (parametro == "(") {
                        indi = indi + 1;
                        continue;
                    }
                    if (parametro == ")") {
                        cantidad = datainput[indi];
                        datainput[indi] = 0;
                        indi = indi - 1;
                    }
                    if (inputC.outcome_structure.formula[it + 1] && (inputC.outcome_structure.formula[it + 1] == "*" || inputC.outcome_structure.formula[it + 1] == "/")) {
                        var operadorA = inputC.outcome_structure.formula[it + 1];
                        if (!inputC.outcome_structure.formula[it + 2]) {
                            datainput[0] = $translate.instant('INPUT.FORMULA_ERROR');
                            break;
                        }
                        var parametro = inputC.outcome_structure.formula[it + 2];
                        for (let i = 0; i < inputC.outcome_structure.outcomes.length; i++) {
                            if (inputC.outcome_structure.outcomes[i].fieldName == parametro) {
                                var cantidadMD = inputC.outcome_structure.outcomes[i].data;
                                break;
                            }
                        }
                        switch (operadorA) {
                            case '*':
                                cantidad = cantidadMD * cantidad;
                                break;
                            case '/':
                                if (cantidad > 0) {
                                    cantidad = cantidad / cantidadMD;
                                    break;
                                }
                        }
                        if (!operadorU[indi]) {
                            datainput[indi] = cantidad;
                        }
                        it = it + 2;
                    }
                    switch (operadorU[indi]) {
                        case '+':
                            datainput[indi] = parseFloat(datainput[indi]) + parseFloat(cantidad);
                            break;
                        case '-':
                            datainput[indi] = datainput[indi] - cantidad;
                            break;
                        case '*':
                            datainput[indi] = datainput[indi] * cantidad;
                            break;
                        case '/':
                            if (cantidad > 0) {
                                datainput[indi] = datainput[indi] / cantidad;
                            }
                            break;
                    }
                    operadorU[indi] = "";
                    if (!findv) {
                        for (let i = 0; i < vm.operator.length - 2; i++) {
                            if (vm.operator[i] == parametro) {
                                operadorU[indi] = parametro;
                                break;
                            }
                        }

                    }
                }
                inputC.outcome_structure.calculation = datainput[0];
                inputC.sub_result = datainput[0];
            }
        }
        function calculoAnualO(inputC) {

            var interes = 1 + ($rootScope.typeInterest / 100);
            var totalCalc  =  0;
            if (inputC.years_input > 1) {
                if(inputC.dead_weight == 0) {
                    inputC.dead_weight = 100;
                }
                if(inputC.displacement == 0) {
                    inputC.displacement = 100;
                }
                if(inputC.attribution == 0) {
                    inputC.attribution = 100;
                }
                var anual  = (inputC.sub_result / inputC.years_input) * (inputC.dead_weight/100) * (inputC.displacement/100) * (inputC.attribution/100);
                totalCalc = anual;    
                for (let i = 2; i <= inputC.years_input; i++) {
                    anual = (anual * (1 - inputC.decrease /100) / interes);
                    totalCalc = totalCalc + anual;
                }
            }
            else {
              totalCalc  = inputC.sub_result * (inputC.dead_weight/100) * (inputC.displacement/100) * (inputC.attribution/100);  
            }
            inputC.result = totalCalc;
        }
        function calculo(inputC) {
            if (inputC.input_structure) {
                var valor = 0;
                var valorParen = [];
                var cantidad = 0;
                var cantidadt = 0;
                var indi = 0;
                var datainput = [];
                var operadorU = [];
                if (inputC.input_structure.formula.length == 0) {
                    datainput[0] = 0;
                }
                for (let it = 0; it < inputC.input_structure.formula.length; it++) {
                    var findv = false;
                    var parametro = inputC.input_structure.formula[it];
                    for (let i = 0; i < inputC.input_structure.inputs.length; i++) {
                        if (inputC.input_structure.inputs[i].fieldName == parametro) {
                            cantidad = inputC.input_structure.inputs[i].data;
                            if (!datainput[indi]) {
                                datainput[indi] = cantidad;
                            }
                            findv = true;
                            break;
                        }
                    }
                    if (parametro == "(") {
                        indi = indi + 1;
                        continue;
                    }
                    if (parametro == ")") {
                        cantidad = datainput[indi];
                        datainput[indi] = 0;
                        indi = indi - 1;
                    }
                    if (inputC.input_structure.formula[it + 1] && (inputC.input_structure.formula[it + 1] == "*" || inputC.input_structure.formula[it + 1] == "/")) {
                        var operadorA = inputC.input_structure.formula[it + 1];
                        if (!inputC.input_structure.formula[it + 2]) {
                            datainput[0] = $translate.instant('INPUT.FORMULA_ERROR');
                            break;
                        }
                        var parametro = inputC.input_structure.formula[it + 2];
                        for (let i = 0; i < inputC.input_structure.inputs.length; i++) {
                            if (inputC.input_structure.inputs[i].fieldName == parametro) {
                                var cantidadMD = inputC.input_structure.inputs[i].data;
                                break;
                            }
                        }
                        switch (operadorA) {
                            case '*':
                                cantidad = cantidadMD * cantidad;
                                break;
                            case '/':
                                if (cantidad > 0) {
                                    cantidad = cantidad / cantidadMD;
                                    break;
                                }
                        }
                        if (!operadorU[indi]) {
                            datainput[indi] = cantidad;
                        }
                        it = it + 2;
                    }
                    switch (operadorU[indi]) {
                        case '+':
                            datainput[indi] = parseFloat(datainput[indi]) + parseFloat(cantidad);
                            break;
                        case '-':
                            datainput[indi] = datainput[indi] - cantidad;
                            break;
                        case '*':
                            datainput[indi] = datainput[indi] * cantidad;
                            break;
                        case '/':
                            if (cantidad > 0) {
                                datainput[indi] = datainput[indi] / cantidad;
                            }
                            break;
                    }
                    operadorU[indi] = "";
                    if (!findv) {
                        for (let i = 0; i < vm.operator.length - 2; i++) {
                            if (vm.operator[i] == parametro) {
                                operadorU[indi] = parametro;
                                break;
                            }
                        }

                    }
                }
                inputC.input_structure.calculation = datainput[0];
                inputC.sub_result = datainput[0];
            }
        }
        function calculoAnual(inputC) {
            var interes = 1 + ($rootScope.typeInterest / 100);
            var totalCalc  =  0;
            if (inputC.years > 1) {
                var anual  = inputC.sub_result / inputC.years;
                totalCalc = anual;    
                for (let i = 2; i <= inputC.years; i++) {
                    anual = anual / interes;
                    totalCalc = totalCalc + anual;
                }
            }
            else {
              totalCalc  = inputC.sub_result  
            }
            inputC.result = totalCalc;
        }
        function saveDialog(company, ev) {
            if (company.id) {
                vm.formWizard = {};
                $scope.isLoading = true;
                vm.idCompany = company.id;
                vm.formWizard.company = company;
                vm.edit = false;
            }
            else {
                //            vm.formWizard = {};
                $scope.isLoading = true;
                //           vm.idCompany = company.id;
                vm.formWizard = {};
                vm.formWizard.company = vm.company;
                vm.edit = false;
                vm.formWizard.company.company_id = $rootScope.companySel;
            }
            createProyect(null, true);
        }
        function closeDialog() {
            vm.edit = false;
        }
        function editCompany() {
            vm.users = [];
            $rootScope.$broadcast('select-company', vm.formWizard.company);
            sessionService.set('companySelected', vm.formWizard.company);
            angular.forEach(vm.formWizard.personnel, function (u) {
                var userExists = $filter('filter')(vm.users, { id: u.id });
                if (userExists.length < 1) {
                    vm.users.push(u);
                }
            })
            vm.readView = true;
            vm.preview = false;
        }


        function closeForm(preview) {
            if (vm.idCompany) {
                getDataCompany(vm.idCompany);
                vm.readView = false;
                vm.preview = preview;
            } else {
                vm.goClients();
            }
        }



        function createProyect(msWizard, close) {
            //                       console.log(vm.formWizard);
            var options = {
                owner: $scope.owner,
                item: transformitems.itemToDTO(vm.formWizard)
            };
            //                        console.log(transformitems.itemToDTO(vm.formWizard));
            if (vm.idCompany) {
                options.id = vm.idCompany;
                //               console.log(options);
                itemsService.updateProyect(options).then(function (response) {

                });


            } else {
                //               options.item.is_owner = vm.companies.length > 0 ? 0 : true;
                itemsService.createProyect(options).then(function (response) {
                    //                    sessionService.authenticate($cookies.get('owner'));
                    $scope.isLoadingP = true;
                    vm.idCompany = response.id;
                    getProyects();

                })
            }
        }

        function deleteitem(ev) {
            var threads = angular.copy(vm.selectedThreads);
            const confirm = $mdDialog.confirm()
                .title($translate.instant('GLOBAL.ARE_YOU_SURE'))
                .targetEvent(ev)
                .ok($translate.instant('GLOBAL.YES'))
                .cancel($translate.instant('GLOBAL.NO'));
            $mdDialog.show(confirm).then(e => {
                for (var i = 0; i < threads.length; i++) {
                    var options = {
                        owner: $scope.owner,
                        item_id: threads[i].id,
                    }
                    //                        console.log(options);
                    itemsService.deleteItem(options).then(function (response) {
                        vm.edit = false;
                        getProyects();
                    })
                }
            })
            vm.edit = false;
            vm.selectedThreads = [];
        }

        function isSelected(thread) {
            return vm.selectedThreads.indexOf(thread) > -1;
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        function toggleSelectThread(thread, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedThreads.indexOf(thread) > -1) {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            }
            else {
                vm.selectedThreads.push(thread);
            }
        }
        function deleteitem1(ev) {
            const message = $translate.instant('GLOBAL.ARE_YOU_SURE');
            const yes = $translate.instant('GLOBAL.YES');
            const no = $translate.instant('GLOBAL.NO');

            const confirm = $mdDialog.confirm()
                .title(message)
                .targetEvent(ev)
                .ok(yes)
                .cancel(no);

            $mdDialog.show(confirm).then(e => {
                vm.deleteItem();
            })
                .catch(err => { })

        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.items')
        .service('itemsService', itemsService);

    /** @ngInject */
    // I provide access to the session store.
    function itemsService($q, $resource, settingsDomainService, sessionService, COMMON, $window, $mdToast, $state) {
        function deleteItem(options) {
//           console.log(options);
            var deferred = $q.defer();
            resourceProyect.delete({
                owner: options.owner,
                item_id: options.item_id
            },
                function (response) {
//                    console.log(response);
                    deferred.resolve(response);
                },

                function (e) {
                    console.log(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateProyect(options) {
            var deferred = $q.defer();
            resourceProyect.update({
                owner: options.owner,
                id: options.id
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    console.log(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function createProyect(options) {
            var deferred = $q.defer();
 //           console.log(options);
            resourceProyect.post({
                owner: options.owner
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    console.log(e);
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getProyects(options) {
            var deferred = $q.defer();
            resourceProyect.get(options,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    console.log(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        var resourceFile = $resource("/assets/json-i18n/region-literals.json", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: true
                }
            });

            var resourceClients = $resource(COMMON.BASE_API + "/owner/:owner/company/:id", {
                // No default data
            }, {
                    get: {
                        method: "GET",
                        isArray: false
                    },
    
                    post: {
                        method: "POST",
                        isArray: false
                    },
    
                    delete: {
                        method: "DELETE",
                        isArray: false
                    },
    
                    update: {
                        method: "PUT",
                        isArray: false
                    },
                });
    
    
            var resourceProyect = $resource(COMMON.BASE_API + "/owner/:owner/item/:id", {
                // No default data
            }, {
                    get: {
                        method: "GET",
                        isArray: true
                    },
    
                    post: {
                        method: "POST",
                        isArray: false
                    },
    
                    delete: {
                        method: "DELETE",
                        isArray: true
                    },
    
                    update: {
                        method: "PUT",
                        isArray: false
                    },
                });
    
        var resourceSectors = $resource(COMMON.BASE_API + "/owner/:owner/sector", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });

        var resourceCompany = $resource(COMMON.BASE_API + "/owner/:owner/company/:id", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                }
            });

        var resourceUser = $resource(COMMON.BASE_API + "/owner/:owner/user/:id/", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                }
            });

        var resourceAddToCompany = $resource(COMMON.BASE_API + "/owner/:owner/user/addToCompany", {
            // No default data
        }, {
                put: {
                    method: "PUT",
                    isArray: false
                }
            });

        var resourceAddJobPosition = $resource(COMMON.BASE_API + "/owner/:owner/user/addDivisionJobPosition", {
            // No default data
        }, {
                put: {
                    method: "PUT",
                    isArray: false
                }
            });

        var resourceRemoveJobPosition = $resource(COMMON.BASE_API + "/owner/:owner/user/removeDivisionJobPosition/:user_id/:branch_id/:division_id/:job_position_id", {
            // No default data
        }, {
                delete: {
                    method: "DELETE",
                    isArray: false
                }
            });

        var resourceQuestion = $resource(COMMON.BASE_API + "/owner/:owner/question/:evaluateAnswer", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                }
            });

        var resourceBranch = $resource(COMMON.BASE_API + "/owner/:owner/branch/:id", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                },
                delete: {
                    method: "DELETE",
                    isArray: false
                }
            });
        var resourceBranches = $resource(COMMON.BASE_API + "/owner/:owner/branch/", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });
        var resourceStoragePrefix = $resource(COMMON.BASE_API + "/owner/:owner/upload/storagePrefix", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });

        var resourcePositions = $resource(COMMON.BASE_API + "/owner/:owner/jobPosition", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });

        var resourceDivisions = $resource(COMMON.BASE_API + "/owner/:owner/division", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });
        var resourceLegalFolder = $resource(COMMON.BASE_API + "/owner/:owner/fileGroup/legalDocuments/:id_company", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });
        var resourceRegions = $resource(COMMON.BASE_API + "/owner/:owner/region", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });


        return ({
            updateProyect: updateProyect,
            deleteItem: deleteItem,
            getProyects: getProyects,
            createProyect: createProyect,
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .controller('NotesController', NotesController);

    /** @ngInject */
    function NotesController($document, $timeout, $scope, $mdSidenav, NotesService, LabelsService, $mdDialog)
    {
        var vm = this;

        // Data
        vm.notes = NotesService.data;
        vm.labels = LabelsService.data;
        vm.search = '';
        vm.searchToolbar = false;
        vm.filters = {
            archive: false
        };
        vm.labelFilterIds = [];
        vm.noteListType = 'notes';

        // Methods
        vm.filterChange = filterChange;
        vm.openSearchToolbar = openSearchToolbar;
        vm.closeSearchToolbar = closeSearchToolbar;
        vm.editNote = editNote;
        vm.deleteLabel = deleteLabel;
        vm.toggleSidenav = toggleSidenav;
        vm.addNewLabel = LabelsService.addLabel;

        //////////

        /**
         * Change Notes Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.noteListType = type;

            if ( type === 'notes' )
            {
                vm.labelFilterIds = [];
                vm.filters = {
                    archive: false
                };
            }
            else if ( type === 'archive' )
            {
                vm.labelFilterIds = [];
                vm.filters = {
                    archive: true
                };
            }
            else if ( type === 'reminders' )
            {
                vm.labelFilterIds = [];
                vm.filters = {
                    reminder: '',
                    archive : false
                };
            }
            else if ( angular.isObject(type) )
            {
                vm.labelFilterIds = [];
                vm.labelFilterIds.push(type.id);
            }

            $mdSidenav('main-sidenav').close();

        }

        /**
         * Edit Note
         * @param ev
         * @param noteId
         */
        function editNote(ev, noteId)
        {
            $mdDialog.show({
                template           : '<md-dialog ms-scroll><ms-note-form note-type="\'edit\'" note-id="\'' + noteId + '\'"></ms-note-form></md-dialog>',
                parent             : $document.find('#notes'),
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true
            });
        }

        /**
         * Delete Label
         * @param ev
         * @param label
         */
        function deleteLabel(ev, label)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the label?')
                .htmlContent('The "' + label.name + '" label will be deleted permanently.')
                .ariaLabel('delete label')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                LabelsService.deleteLabel(label);
            });
        }

        /**
         * Open Search Toolbar
         */
        function openSearchToolbar()
        {
            vm.searchToolbar = true;

            $timeout(function ()
            {
                angular.element($document.find('#search-notes-input')).trigger('focus');

            });

            $document.on('keyup', escKeyEvent);
        }

        /**
         * Close Search Toolbar
         */
        function closeSearchToolbar()
        {
            $scope.$evalAsync(function ()
            {
                vm.searchToolbar = false;
                vm.search = '';
            });

            $document.off('keyup', escKeyEvent);
        }

        /**
         * Escape key event
         */
        function escKeyEvent(e)
        {
            if ( e.keyCode === 27 )
            {
                closeSearchToolbar();
            }
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.mail')
        .controller('MailController', MailController);

    /** @ngInject */
    function MailController($scope, $rootScope, $document, $mdDialog, $mdMedia, $mdSidenav, $state, msApi, Folders, Labels)
    {
        var vm = this;

        // Data
        vm.accounts = {
            'creapond'    : 'johndoe@creapond.com',
            'withinpixels': 'johndoe@withinpixels.com'
        };
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
        vm.selectedAccount = 'creapond';

        vm.folders = Folders.data;
        vm.labels = Labels.data;
        vm.loadingThreads = true;

        vm.currentFilter = {
            type  : $state.params.type,
            filter: $state.params.filter
        };
        vm.currentThread = null;
        vm.selectedThreads = [];

        vm.views = {
            classic: 'app/main/apps/mail/views/classic/classic-view.html',
            outlook: 'app/main/apps/mail/views/outlook/outlook-view.html'
        };
        vm.defaultView = 'outlook';
        vm.currentView = 'outlook';

        // Methods
        vm.loadFolder = loadFolder;
        vm.loadLabel = loadLabel;
        vm.isFolderActive = isFolderActive;
        vm.isLabelActive = isLabelActive;

        vm.openThread = openThread;
        vm.closeThread = closeThread;

        vm.isSelected = isSelected;
        vm.toggleSelectThread = toggleSelectThread;
        vm.selectThreads = selectThreads;
        vm.deselectThreads = deselectThreads;
        vm.toggleSelectThreads = toggleSelectThreads;

        vm.setThreadStatus = setThreadStatus;
        vm.toggleThreadStatus = toggleThreadStatus;

        vm.getLabel = getLabel;
        vm.getLabelColor = getLabelColor;
        vm.getLabelTitle = getLabelTitle;
        vm.toggleLabel = toggleLabel;
        vm.isLabelExist = isLabelExist;

        vm.changeView = changeView;

        vm.composeDialog = composeDialog;
        vm.replyDialog = replyDialog;

        vm.toggleSidenav = toggleSidenav;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Figure out the api name
            var apiName = 'mail.' + ($state.params.type || 'folder') + '.' + $state.params.filter + '@get';

            // Request the mails
            msApi.request(apiName).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.threads = response.data;

                    // Hide the loading screen
                    vm.loadingThreads = false;

                    // Open the thread if needed
                    if ( $state.params.threadId )
                    {
                        for ( var i = 0; i < vm.threads.length; i++ )
                        {
                            if ( vm.threads[i].id === $state.params.threadId )
                            {
                                vm.openThread(vm.threads[i]);
                                break;
                            }
                        }
                    }
                }
            );
        }

        // Watch screen size to change view modes
        $scope.$watch(function ()
        {
            return $mdMedia('xs');
        }, function (current, old)
        {
            if ( angular.equals(current, old) )
            {
                return;
            }

            if ( current )
            {
                vm.currentView = 'classic';
            }
        });

        $scope.$watch(function ()
        {
            return $mdMedia('gt-xs');
        }, function (current, old)
        {
            if ( angular.equals(current, old) )
            {
                return;
            }

            if ( current )
            {
                if ( vm.defaultView === 'outlook' )
                {
                    vm.currentView = 'outlook';
                }
            }
        });

        /**
         * Load folder
         *
         * @param name
         */
        function loadFolder(name)
        {
            // If we are already in the selected folder and
            // there is an open thread just close it
            if ( vm.isFolderActive(name) )
            {
                // Close the current thread if open
                if ( vm.currentThread )
                {
                    vm.closeThread();
                }

                return;
            }

            // Show loader
            $rootScope.loadingProgress = true;

            // // Update the state without reloading the controller
            // $state.go('app.mail.threads', {
            //     type  : null,
            //     filter: name
            // }, {notify: false});

            // // Build the API name
            // var apiName = 'mail.folder.' + name + '@get';

            // // Make the call
            // msApi.request(apiName).then(
            //     // Success
            //     function (response)
            //     {
            //         // Load new threads
            //         vm.threads = response.data;

            //         // Set the current filter
            //         vm.currentFilter = {
            //             type  : null,
            //             filter: name
            //         };

            //         // Close the current thread if open
            //         if ( vm.currentThread )
            //         {
            //             vm.closeThread();
            //         }

            //         // Hide loader
            //         $rootScope.loadingProgress = false;
            //     }
            // );
        }

        /**
         * Load label
         *
         * @param name
         */
        function loadLabel(name)
        {
            // Update the state without reloading the controller
            $state.go('app.mail.threads', {
                type  : 'label',
                filter: name
            }, {notify: false});

            // If we are already in the selected folder and
            // there is an open thread just close it
            if ( vm.isLabelActive(name) )
            {
                // Close the current thread if open
                if ( vm.currentThread )
                {
                    vm.closeThread();
                }

                return;
            }

            // Show loader
            $rootScope.loadingProgress = true;

            // Build the API name
            var apiName = 'mail.label.' + name + '@get';

            // Make the call
            msApi.request(apiName).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.threads = response.data;

                    // Set the current filter
                    vm.currentFilter = {
                        type  : 'label',
                        filter: name
                    };

                    // Close the current thread if open
                    if ( vm.currentThread )
                    {
                        vm.closeThread();
                    }

                    // Hide loader
                    $rootScope.loadingProgress = false;
                }
            );
        }

        /**
         * Is the folder with the given name active?
         *
         * @param name
         * @returns {boolean}
         */
        function isFolderActive(name)
        {
            return (vm.currentFilter.type === null && vm.currentFilter.filter === name);
        }

        /**
         * Is the label with the given name active?
         *
         * @param name
         * @returns {boolean}
         */
        function isLabelActive(name)
        {
            return (vm.currentFilter.type === 'label' && vm.currentFilter.filter === name);
        }

        /**
         * Open thread
         *
         * @param thread
         */
        function openThread(thread)
        {
            // Set the read status on the thread
            thread.read = true;

            // Assign thread as the current thread
            vm.currentThread = thread;

            // Update the state without reloading the controller
            $state.go('app.mail.threads.thread', {threadId: thread.id}, {notify: false});
        }

        /**
         * Close thread
         */
        function closeThread()
        {
            vm.currentThread = null;

            // Update the state without reloading the controller
            $state.go('app.mail.threads', {
                type  : vm.currentFilter.type,
                filter: vm.currentFilter.filter
            }, {notify: false});
        }

        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        function isSelected(thread)
        {
            return vm.selectedThreads.indexOf(thread) > -1;
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        function toggleSelectThread(thread, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            if ( vm.selectedThreads.indexOf(thread) > -1 )
            {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            }
            else
            {
                vm.selectedThreads.push(thread);
            }
        }

        /**
         * Select threads. If key/value pair given,
         * threads will be tested against them.
         *
         * @param [key]
         * @param [value]
         */
        function selectThreads(key, value)
        {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedThreads = [];

            for ( var i = 0; i < vm.threads.length; i++ )
            {
                if ( angular.isUndefined(key) && angular.isUndefined(value) )
                {
                    vm.selectedThreads.push(vm.threads[i]);
                    continue;
                }

                if ( angular.isDefined(key) && angular.isDefined(value) && vm.threads[i][key] === value )
                {
                    vm.selectedThreads.push(vm.threads[i]);
                }
            }
        }

        /**
         * Deselect threads
         */
        function deselectThreads()
        {
            vm.selectedThreads = [];
        }

        /**
         * Toggle select threads
         */
        function toggleSelectThreads()
        {
            if ( vm.selectedThreads.length > 0 )
            {
                vm.deselectThreads();
            }
            else
            {
                vm.selectThreads();
            }
        }

        /**
         * Set the status on given thread, current thread or selected threads
         *
         * @param key
         * @param value
         * @param [thread]
         * @param [event]
         */
        function setThreadStatus(key, value, thread, event)
        {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if ( event )
            {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if ( thread )
            {
                thread[key] = value;
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if ( vm.currentThread )
            {
                vm.currentThread[key] = value;
                return;
            }

            // Otherwise do the status update on selected threads
            for ( var x = 0; x < vm.selectedThreads.length; x++ )
            {
                vm.selectedThreads[x][key] = value;
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleThreadStatus(key, thread, event)
        {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if ( event )
            {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if ( thread )
            {
                if ( typeof(thread[key]) !== 'boolean' )
                {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if ( vm.currentThread )
            {
                if ( typeof(vm.currentThread[key]) !== 'boolean' )
                {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for ( var x = 0; x < vm.selectedThreads.length; x++ )
            {
                if ( typeof(vm.selectedThreads[x][key]) !== 'boolean' )
                {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }

        /**
         * Get label object content
         *
         * @param id
         * @returns {*}
         */
        function getLabel(id)
        {
            for ( var i = 0; i < vm.labels.length; i++ )
            {
                if ( vm.labels[i].id === id )
                {
                    return vm.labels[i];
                }
            }
        }

        /**
         * Get label color from label object
         *
         * @param id
         * @returns {*}
         */
        function getLabelColor(id)
        {
            return vm.getLabel(id).color;
        }

        /**
         * Get label title from label object
         *
         * @param id
         * @returns {*}
         */
        function getLabelTitle(id)
        {
            return vm.getLabel(id).title;
        }

        /**
         * Toggle label
         *
         * @param label
         */
        function toggleLabel(label)
        {
            // Toggle label on the currently open thread
            if ( vm.currentThread )
            {
                if ( vm.currentThread.labels.indexOf(label.id) > -1 )
                {
                    vm.currentThread.labels.splice(vm.currentThread.labels.indexOf(label.id), 1);
                }
                else
                {
                    vm.currentThread.labels.push(label.id);
                }

                return;
            }

            // Toggle labels on selected threads
            // Toggle action will be determined by the first thread from the selection.
            if ( vm.selectedThreads.length > 0 )
            {
                // Decide if we are going to remove or add labels
                var removeLabels = (vm.selectedThreads[0].labels.indexOf(label.id) > -1);

                for ( var i = 0; i < vm.selectedThreads.length; i++ )
                {
                    if ( !removeLabels )
                    {
                        vm.selectedThreads[i].labels.push(label.id);
                        continue;
                    }

                    if ( vm.selectedThreads[i].labels.indexOf(label.id) > -1 )
                    {
                        vm.selectedThreads[i].labels.splice(vm.selectedThreads[i].labels.indexOf(label.id), 1);
                    }
                }
            }
        }

        /**
         * Is label exist?
         *
         * @param label
         * @returns {boolean}
         */
        function isLabelExist(label)
        {
            if ( vm.currentThread && vm.currentThread.labels )
            {
                return (vm.currentThread.labels.indexOf(label.id) > -1);
            }
        }

        /**
         * Change the view
         *
         * @param view
         */
        function changeView(view)
        {
            if ( vm.views[view] )
            {
                vm.defaultView = view;
                vm.currentView = view;
            }
        }

        /**
         * Open compose dialog
         *
         * @param ev
         */

        function composeDialog(ev)
        {
            $mdDialog.show({
                controller         : 'ComposeDialogController',
                controllerAs       : 'vm',
                locals             : {
                    selectedMail: undefined
                },
                templateUrl        : 'app/main/apps/mail/dialogs/compose/compose-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }

        /**
         * Open reply dialog
         *
         * @param ev
         */
        function replyDialog(ev)
        {
            $mdDialog.show({
                controller         : 'ComposeDialogController',
                controllerAs       : 'vm',
                locals             : {
                    selectedMail: vm.selectedMail
                },
                templateUrl        : 'app/main/apps/mail/dialogs/compose/compose-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.help', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider , msUtilProvider, msNavigationServiceProvider) {
        // State


        $stateProvider.state('app.help', {
            url: '/help',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/help/help.html',
                    controller: 'HelpController as vm'
                }
            },
            bodyClass: 'help'
        });

        $stateProvider
            .state('app.site_overview.help', {
                abstract: true,
                url: '/help',
                onEnter: function ($stateParams) {


                },
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                    section: function ($stateParams) {
                        return $stateParams.owner
                    },
                },


            })
            .state('app.site_overview.help.list', {
                url: '',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/help/help.html',
                        controller: 'HelpController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
        // Translation
        var base = 'app/main/apps/help';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.help')
        .controller('HelpController', HelpController);

    /** @ngInject */
    function HelpController($scope, $rootScope, $stateParams, $translate, section) {
        var vm = this;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.help')
        .service('helpService', helpService);

    /** @ngInject */
    // I provide access to the session store.
    function helpService($q, $resource, settingsDomainService, sessionService, companyService, COMMON, $window, $mdToast, $rootScope) {

        function get(options) {
            if (options.groupIds !== undefined) {
                return getDocumentsByGroups(options);
            } else {
                var deferred = $q.defer();
                deferred.resolve({
                    result: { data: [] }
                });
                return (deferred.promise);
            }
        }


        function getDocumentsByGroups(options) {
            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });


            resourceDocuments.get({
                owner: options.owner,
                page: options.page,
                search: options.searchStringFilter,
                paginate: options.paginate,
                sortField: options.sortField,
                sortDir: options.sortDir,
                'related_id[]': options.groupIds,
                filters: JSON.stringify(filters)
            },
                function (responseResult) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);
                    for (var i = 0; i < responseResult.data.length; i++) {
                        var element = responseResult.data[i];
                        element.updated_at_format = moment.utc(element.updated_at).format('DD MMM YYYY HH:mm:00');
                        element.created_at_format = moment.utc(element.created_at).format('DD MMM YYYY HH:mm:00');
                    }
                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        };



        function getFilters(options) {
            var deferred = $q.defer();

            return (deferred.promise);
        }

        function deleteDocument(options) {
            var deferred = $q.defer();
            resourceDocumentsById.delete({
                owner: options.owner,
                id: options.id,
            },
                function (responseResult) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        function unnestGalleries(node, groups, includeSubGroups) {
            groups.push(node);
            if (includeSubGroups && typeof node.children !== 'undefined' && node.children.length > 0) {
                angular.forEach(node.children, function (data) {
                    unnestGroups(data, groups, includeSubGroups);
                });
            }
            return groups;
        }

        function triggerFilesByGroup(groupNode, includeSubGroups) {
            var groups = false;
            if (groupNode) {
                var node = angular.fromJson(groupNode);
                groups = unnestGalleries(node, [], includeSubGroups);
            }
            $rootScope.$broadcast('loadFilesByGroup', groups);
        }

        function triggerSelectGroup(groupNode) {
            $rootScope.$broadcast('selectGroup', groupNode);
        }


        function triggerFilesByGroups(groupNode, includeSubgroups) {
            var groups = false;
            if (groupNode) {
                var node = angular.fromJson(groupNode);
                groups = unnestGroups(node, [], includeSubgroups);
            }
            $rootScope.$broadcast('loadFilesByGroup', groups);
        }

        function unnestGroups(node, groups, includeSubgroups) {
            groups.push(node);
            if (includeSubgroups && typeof node.children !== 'undefined' && node.children.length > 0) {
                angular.forEach(node.children, function (data) {
                    unnestGroups(data, groups, includeSubgroups);
                });
            }
            return groups;
        }


        function getGroups(options) {
            var deferred = $q.defer();

            resourceGroupDocumentsNested.get({
                owner: options.owner,
                company: companyService.getCompanyId()
            },
                function (responseResult) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject();
                }
            );

            return (deferred.promise);
        }

        function deleteGroup(owner, id) {
            var deferred = $q.defer();

            resourceGroupDocuments.delete({
                owner: owner,
                id: id
            },
                function (responseResult) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject();
                }
            );

            return (deferred.promise);
        }

        function saveGroup(owner, id, groupParentId, groupName) {
            var deferred = $q.defer();

            resourceGroupDocuments.update({
                owner: owner,
                name: groupName,
                parent_id: groupParentId,
                company_id: companyService.getCompanyId(),
                id: id
            },
                function (responseResult) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject();
                }
            );

            return (deferred.promise);
        }
        function createGroup(owner, groupParentId, groupName) {
            var deferred = $q.defer();

            resourceGroupDocuments.post({
                owner: owner,
                name: groupName,
                company_id: companyService.getCompanyId(),
                parent_id: groupParentId
            },
                function (responseResult) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject();
                }
            );

            return (deferred.promise);
        }
        function shareFile(owner, users, fileId) {
            var deferred = $q.defer();

            resourceShareFile.post({
                owner: owner,
                id: fileId
            },{
                users: users
            },
                function (responseResult) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject();
                }
            );

            return (deferred.promise);
        }




        function getS3UploadPreSignedUrl(options) {
            var deferred = $q.defer();

            resource_s3_presigned_url.get({
                uploadKey: 'file_group',
                owner: options.owner,
                fileName: options.fileName,
                rowId: options.groupId
                // lang: get("language")
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        function getDownloadUrl(options) {
            var deferred = $q.defer();

            resource_download_url.get({
                // lang: get("language")
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        function triggerGroupDialog(group) {
            $rootScope.$broadcast('openGroupDialog', group);
        }

        function triggerSelectParentGroup(groupNode) {
            $rootScope.$broadcast('selectParentGroup', groupNode);
        }

        function finishedUploadingFile(options) {
            var deferred = $q.defer();
            var options = {
                owner: options.owner,
                token: options.token
            }
            resource_finish_upload_file.post(options,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        var resource_download_url = $resource(
            COMMON.BASE_API + "/owner/:owner/upload/downloadUrl", {
                // No default data.
            }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            }
        );

        var resource_s3_presigned_url = $resource(
            COMMON.BASE_API + "/owner/:owner/upload/getS3UploadPreSignedUrl", {
                // No default data.
            }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            }
        );


        var resource_finish_upload_file = $resource(
            COMMON.BASE_API + "/owner/:owner/upload/finishedUploadingFile", {
                owner: '@owner',
            }, {
                post: {
                    method: "POST",
                    isArray: false
                }
            }
        );

        var resourceDocuments = $resource(COMMON.BASE_API + "/owner/:owner/file?upload_key=file_group", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });


        var resourceDocumentsById = $resource(COMMON.BASE_API + "/owner/:owner/file/:id", {
            // No default data
        }, {

                post: {
                    method: "POST",
                    isArray: false
                },

                delete: {
                    method: "DELETE",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                },
            });

        var resourceGroupDocumentsNested = $resource(COMMON.BASE_API + "/owner/:owner/fileGroupNested/:id", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: true
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                delete: {
                    method: "DELETE",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                },
            });
        var resourceShareFile = $resource(COMMON.BASE_API + "/owner/:owner/file/:id/share", {
            owner: '@owner',
            id: '@id'
        }, {
                post: {
                    method: "POST",
                    isArray: false
                }
            });

        var resourceGroupDocuments = $resource(COMMON.BASE_API + "/owner/:owner/fileGroup/:id", {
            owner: '@owner',
            id: '@id'
        }, {
                get: {
                    method: "GET",
                    isArray: true
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                delete: {
                    method: "DELETE",
                    isArray: true
                },

                update: {
                    method: "PUT",
                    isArray: false
                },
            });

        return ({
            get: get,
            getGroups: getGroups,
            deleteDocument: deleteDocument,
            getS3UploadPreSignedUrl: getS3UploadPreSignedUrl,
            getDownloadUrl: getDownloadUrl,
            finishedUploadingFile: finishedUploadingFile,
            triggerSelectParentGroup: triggerSelectParentGroup,
            triggerFilesByGroup: triggerFilesByGroup,
            triggerFilesByGroups: triggerFilesByGroups,
            triggerGroupDialog: triggerGroupDialog,
            triggerSelectGroup: triggerSelectGroup,
            deleteGroup: deleteGroup,
            saveGroup: saveGroup,
            createGroup: createGroup,
            shareFile: shareFile,
            getFilters: getFilters
        });

    }

})();
(function () {
    'use strict';

    angular
        .module('app.inputs')
        .directive('stringToNumber', function () {
            return {
                require: 'ngModel',
                link: function (scope, element, attrs, ngModel) {
                    ngModel.$parsers.push(function (value) {
                        return '' + value;
                    });
                    ngModel.$formatters.push(function (value) {
                        return parseFloat(value);
                    });
                }
            };
        })
        .controller('inputsController', inputsController);

    /** @ngInject */
    function inputsController($scope, $rootScope, $stateParams, companyService, $translate, $document, $mdDialog,
        $mdMedia, $mdSidenav, $state, msApi, tinyMceService, requestContext, evidencesControlsService, inputsService, itemsService, outcomesService,
        transforminputs, transformitems, transformoutcomes, mediaService, Upload, $filter, $timeout, msUtils, documentsService, dragulaService, sessionService, $cookies, is_owner) {
        var vm = this;
        vm.userLogued = sessionService.getUser();

        vm.loadingStep = false;
        vm.folders = 'Folders.data';
        vm.labels = 'Labels.data';
        vm.loadingThreads = true;
        vm.items = [];
        vm.saveDialog = saveDialog;
        vm.currentFilter = {
            type: $state.params.type,
            filter: $state.params.filter
        };
        vm.index = 0;
        vm.currentThread = null;
        vm.selectedThreads = [];
        vm.selectedFields = [];
        vm.stakeElemen = [];
        vm.input = [];
        vm.getProyects = getProyects;
        //        vm.isCompanySelected = isCompanySelected;
        vm.views = {
            split: 'app/main/apps/inputs/views/list/split-view.html',
            nosplit: 'app/main/apps/inputs/views/list/nosplit-view.html'
        };
        vm.cambio = false;
        vm.visible = false;
        vm.defaultView = 'split';
        vm.currentView = 'split';
        vm.readView = false;
        vm.selectOp = "exit";
        vm.closeDialog = closeDialog;
        vm.addOperator = addOperator;
        vm.selectFields = selectFields;
        vm.nuevo = false;
        vm.addOpeField = addOpeField;
        vm.editOpeField = editOpeField;
        vm.salvar = false;
        vm.editOperator = editOperator;
        vm.deleteOperator = deleteOperator;
        vm.stakeholder = [];
        vm.tabActive = 'preview';
        vm.addelement = false;
        vm.editelement = false;
        vm.fieldAdd = false;
        vm.fieldEdit = false;
        vm.changeValue = changeValue;
        vm.fieldMove = false;
        vm.campo = campo;
        vm.tipefield = [
            { number: '1', name: $translate.instant('ITEM.PROXY') },
            { number: '2', name: $translate.instant('ITEM.INDICATOR') },
            { number: '3', name: $translate.instant('ITEM.OUTPUT') }
        ];
        vm.operator = ['+', '-', '/', '*', "(", ")"];
        vm.element = "";
        vm.tipeFields = { fieldName: '', fieldType: "1", fieldEdit: "0", data: "0" };

        //        vm.tipefield = JSON.parse(vm.tipefield1);  
        //          console.log(vm.tipefield);
        //        vm.typeF = "";
        vm.addFields = addFields;
        vm.clearFields = clearFields;
        vm.calculo = calculo;
        vm.calculoAnual = calculoAnual;
        vm.deleteFields = deleteFields;
        vm.editFields = editFields;
        vm.administratorFields = vm.personFields;
        vm.managerLegalFields = vm.personFields;
        vm.complianceFields = vm.personFields;
        vm.reportFields = vm.personFields;
        vm.personnelFields = vm.personFields;
        //        vm.getRegionLiteral = getRegionLiteral;

        vm.companySelectEvent = companySelectEvent;
        //        vm.getSectorById = getSectorById;
        $scope.Inout = function (item) {
            return item === '1';
        };

        vm.idClient = undefined;
        vm.idCompany = undefined;
        vm.updateLogotype = false;
        vm.showForm = true;
        vm.allQuestions = true;
        $scope.storagePrefix = '';


        vm.isSelected = isSelected;
        vm.isSelectedField = isSelectedField;
        vm.toggleSelectThread = toggleSelectThread;
        vm.newForm = newForm;

        vm.deleteInput = deleteInput;
        vm.edit = false;
        vm.openCompany = openCompany;
        vm.editCompany = editCompany;
        vm.getInputs = getInputs;
        vm.getoutcomes = getoutcomes;
        vm.deletestake = deletestake;
        vm.getItems = getItems;


        //////////
        var companySelectEvent = $rootScope.$on('company-selected', function (event) {
            vm.addelement = false;
            vm.editelement = false;
            vm.fieldAdd = false;
            vm.fieldEdit = false;
            vm.edit = false;
            vm.tabActive = '';
            getProyects();
            getInputs();
            getItems();
            getoutcomes();
        });
        /*        dragulaService.options($scope, 'dragbag', {
        /*            copy: false,
                    copySortSource: false,
                    removeOnSpill: false,
                    direction: 'vertical',
                    moves: function (el, source, handle) {
        //                var result = handle.classList.contains('drag');
                        console.log("moves");
        //                return result;
                          return;
                    },
                    invalid: function (el, handle) {
                        return false; // don't prevent any drags from initiating by default
                    }
                });*/

        $scope.$on('pagination:loadStart', function (event) {
            $scope.isLoading = true;
            $scope.isLoadingP = true;
        });

        $scope.$on('dragbag.out', function (e, el) {
            vm.fieldMove = true;
        });
        $scope.$on('dragbagFormula.out', function (e, el) {
            vm.salvar = true;
        });

        $scope.$on('pagination:loadPage', function (event) {
            $scope.isLoading = false;
            vm.is_owner = vm.companies.length <= 1;
            //            getInputs();
            init();
        });
        //        init();
        $scope.owner = $stateParams.owner;


        this.awesomeCallback = function (node, tree) {
            // Do something with node or tree
        };

        this.otherAwesomeCallback = function (node, isSelected, tree) {
            // Do soemthing with node or tree based on isSelected
        };
        if ($rootScope.companySel) {
            getInputs();
            getProyects();
            getItems();
            getoutcomes();
        }

        function init() {
            mediaService.getStoragePrefix({
                owner: $scope.owner,
            }).then(function (res) {
                $scope.storagePrefix = res.prefix;
            })
            evidencesControlsService.getCurrencies({ owner: $scope.owner }).then(function (res) {
                vm.currencies = res.data;
            })
            inputsService.getRegions({ owner: $scope.owner }).then(function (res) {
                vm.regions = res.data;
            })
            inputsService.getFileRegions().then(function (res) {
                vm.regionsLiterals = res;
            })
        }

        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'nosplit';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big) {
                vm.currentView = 'nosplit';
            }

        });

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small) {
                vm.currentView = 'split';
            }

        });

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                if (vm.defaultView === 'split') {
                    vm.currentView = 'split';
                }
            }
        });


        var originatorEv;

        function openMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        }
        function addOpeField() {
            if (!vm.editelement) {
                vm.addelement = true;
                vm.element = '';
            }
        }
        function editOpeField() {
            if (!vm.addelement) {
                vm.editelement = true;
            }
        }

        function getoutcomes(idCompany, inOwner) {
            var options = {
                owner: $scope.owner,
                proyect_id: $rootScope.companySel,
                withFiles: true
            };
            outcomesService.getOutcomes(options).then(function (response) {
                vm.outcome = response;
            }, function (response) {
                vm.outcome = [];
                $scope.isLoadingP = false;
            }
            )
        }
        function getInputs(idCompany, inOwner) {
            var options = {
                owner: $scope.owner,
                proyect_id: $rootScope.companySel,
                withFiles: true
            };
            inputsService.getInputs(options).then(function (response) {
                vm.input = response;
                $scope.isLoadingP = false;
            }, function (response) {
                vm.input = [];
                $scope.isLoadingP = false;
            }
            )
        }
        function clearFields() {
            vm.fieldAdd = true;
            vm.tipeFields = { fieldName: " ", fieldType: "1", fieldEdit: "0", data: "0", id_item: "0" };
        }
        function addFields(fieldsNew, ev) {
            vm.fieldsNew = fieldsNew;
            if (!vm.company.input_structure) {
                vm.company.input_structure = { "calculation": "0", "formula": [], "inputs": [] };
            }
            //            vm.tipeFields = { fieldName: '', fieldType: "1", fieldEdit: "0", data: "0" };
            vm.formWizard = {};

            if (vm.nuevo) {
                vm.formWizardItem = {};
                //                vm.formWizardItem.company = vm.tipeFields;
                vm.formWizardItem.company = Object.assign({}, vm.tipeFields);

                //                console.log(vm.tipeFields);
                vm.formWizardItem.company.company_id = $rootScope.companySel;
                vm.formWizardItem.company.name = vm.formWizardItem.company.fieldName;
                vm.formWizardItem.company.description_item = "";
                vm.formWizardItem.company.value = vm.formWizardItem.company.data;
                vm.formWizardItem.company.type = vm.formWizardItem.company.fieldType;
                //                console.log(vm.formWizardItem);
                var options = {
                    owner: $scope.owner,
                    item: transformitems.itemToDTO(vm.formWizardItem)
                };
                itemsService.createProyect(options).then(function (response) {
                    vm.idItem = response.id;
                    vm.tipeFields.id_item = vm.idItem;
                    //                    console.log(vm.tipeFields);
                    vm.company.input_structure.inputs.push(vm.tipeFields);
                    vm.formWizard.company = vm.company;
                    vm.idCompany = vm.company.id;
                    vm.nuevo = false;
                    createProyect();

                })
            }
            else {
                if (vm.fieldAdd) {
                    vm.company.input_structure.inputs.push(vm.tipeFields);
                }
                if (vm.fieldEdit) {
                    vm.company.input_structure.inputs[vm.index].fieldName = vm.tipeFields.fieldName;
                    vm.company.input_structure.inputs[vm.index].tipefield = vm.tipeFields.tipefield;
                    vm.company.input_structure.inputs[vm.index].fieldEdit = vm.tipeFields.fieldEdit;
                    vm.company.input_structure.inputs[vm.index].id_item = vm.tipeFields.id_item;
                }
                vm.formWizard.company = vm.company;
                vm.idCompany = vm.company.id;
                createProyect(vm.fieldsNew);
                if (vm.cambio) {
                    changeValue(vm.tipeFields);
                    vm.cambio = false;
                }
            }
        }
        function changeValue(itemC) {
//                        console.log(itemC);
            if (vm.cambio) {
                var options = {
                    owner: $scope.owner,
                    proyect_id: vm.company.id,
                    withFiles: true
                };
                vm.input.forEach(function (input1, index) {
                    if (!input1.input_structure.inputs) {
                        input1.input_structure = JSON.parse(input1.input_structure);
                    }
                    var inputF1 = input1.input_structure.inputs;
                    //                      console.log(inputF1);
                    inputF1.forEach(function (input1F, indexF) {
                        if (itemC.id_item == input1F.id_item && input1F.id_item != itemC.data) {
                            input1F.data = itemC.data;
                            input1F.fieldEdit = itemC.fieldEdit;
                            //                        console.log(input1); vm.tipeFields.fieldEdit
                            calculo(input1);
                            calculoAnual(input1);
                            saveInput(input1);
                        }
                    });
                });
                vm.outcome.forEach(function (input1, index) {
                    if (!input1.outcome_structure.outcomes) {
                        input1.outcome_structure = JSON.parse(input1.outcome_structure);
                    }
                        var inputF1 = input1.outcome_structure.outcomes;
                    inputF1.forEach(function (input1F, indexF) {
                        if (itemC.id_item == input1F.id_item && input1F.id_item != itemC.data) {
                            input1F.data = itemC.data;
                            input1F.fieldEdit = itemC.fieldEdit;
                            calculoO(input1);
                            calculoAnualO(input1);
                            saveOutcome(input1);
                        }
                    });
                });
                //                getinputs();
                //                getoutcomes();
                vm.items.forEach(function (item1, index) {
                    if (item1.id == itemC.id_item) {
                        item1.value = itemC.data;
                        item1.edit_item = itemC.fieldEdit;
                        updateItem(item1, "");
                    }
                });
                vm.cambio = false;
                //            vm.edit = false;
            }
        }
        function saveInput(inputC) {
            var inputC1 = {};
            inputC1.company = inputC;
            var options = {
                owner: $scope.owner,
                item: transforminputs.inputToDTO(inputC1)
            };
            options.id = inputC.id;
            inputsService.updateInput(options).then(function (response) {
            });
        }
        function updateItem(itemUpdate, close) {
            vm.formWizard = {};
            vm.formWizard.company = itemUpdate;
            //            console.log(vm.formWizard);
            if (itemUpdate.id) {
                var options = {
                    owner: $scope.owner,
                    item: transformitems.itemToDTO(vm.formWizard)
                };
                //                        console.log(transformitems.itemToDTO(vm.formWizard));
                options.id = itemUpdate.id;
                //                $scope.isLoading = true;
                //                vm.idCompany = company.id;
                //                vm.formWizard.company = company;
                //                vm.edit = false;
                //               console.log(options);
                itemsService.updateProyect(options).then(function (response) {

                });


            }
        }
        function calculoO(inputC) {
            if (inputC.outcome_structure) {
                var valor = 0;
                var valorParen = [];
                var cantidad = 0;
                var cantidadt = 0;
                var indi = 0;
                var datainput = [];
                var operadorU = [];
                if (inputC.outcome_structure.formula.length == 0) {
                    datainput[0] = 0;
                }
                for (let it = 0; it < inputC.outcome_structure.formula.length; it++) {
                    var findv = false;
                    var parametro = inputC.outcome_structure.formula[it];
                    for (let i = 0; i < inputC.outcome_structure.outcomes.length; i++) {
                        if (inputC.outcome_structure.outcomes[i].fieldName == parametro) {
                            cantidad = inputC.outcome_structure.outcomes[i].data;
                            if (!datainput[indi]) {
                                datainput[indi] = cantidad;
                            }
                            findv = true;
                            break;
                        }
                    }
                    if (parametro == "(") {
                        indi = indi + 1;
                        continue;
                    }
                    if (parametro == ")") {
                        cantidad = datainput[indi];
                        datainput[indi] = 0;
                        indi = indi - 1;
                    }
                    if (inputC.outcome_structure.formula[it + 1] && (inputC.outcome_structure.formula[it + 1] == "*" || inputC.outcome_structure.formula[it + 1] == "/")) {
                        var operadorA = inputC.outcome_structure.formula[it + 1];
                        if (!inputC.outcome_structure.formula[it + 2]) {
                            datainput[0] = $translate.instant('INPUT.FORMULA_ERROR');
                            break;
                        }
                        var parametro = inputC.outcome_structure.formula[it + 2];
                        for (let i = 0; i < inputC.outcome_structure.outcomes.length; i++) {
                            if (inputC.outcome_structure.outcomes[i].fieldName == parametro) {
                                var cantidadMD = inputC.outcome_structure.outcomes[i].data;
                                break;
                            }
                        }
                        switch (operadorA) {
                            case '*':
                                cantidad = cantidadMD * cantidad;
                                break;
                            case '/':
                                if (cantidad > 0) {
                                    cantidad = cantidad / cantidadMD;
                                    break;
                                }
                        }
                        if (!operadorU[indi]) {
                            datainput[indi] = cantidad;
                        }
                        it = it + 2;
                    }
                    switch (operadorU[indi]) {
                        case '+':
                            datainput[indi] = parseFloat(datainput[indi]) + parseFloat(cantidad);
                            break;
                        case '-':
                            datainput[indi] = datainput[indi] - cantidad;
                            break;
                        case '*':
                            datainput[indi] = datainput[indi] * cantidad;
                            break;
                        case '/':
                            if (cantidad > 0) {
                                datainput[indi] = datainput[indi] / cantidad;
                            }
                            break;
                    }
                    operadorU[indi] = "";
                    if (!findv) {
                        for (let i = 0; i < vm.operator.length - 2; i++) {
                            if (vm.operator[i] == parametro) {
                                operadorU[indi] = parametro;
                                break;
                            }
                        }

                    }
                }
                inputC.outcome_structure.calculation = datainput[0];
                inputC.sub_result = datainput[0];
            }
        }
        function calculoAnualO(inputC) {
            var interes = 1 + ($rootScope.typeInterest / 100);
            var totalCalc = 0;
            if (inputC.years_input > 1) {
                if (inputC.dead_weight == 0) {
                    inputC.dead_weight = 100;
                }
                if (inputC.displacement == 0) {
                    inputC.displacement = 100;
                }
                if (inputC.attribution == 0) {
                    inputC.attribution = 100;
                }
                var anual = (inputC.sub_result / inputC.years_input) * (inputC.dead_weight / 100) * (inputC.displacement / 100) * (inputC.attribution / 100);
                totalCalc = anual;
                for (let i = 2; i <= inputC.years_input; i++) {
                    anual = (anual * (1 - inputC.decrease / 100) / interes);
                    totalCalc = totalCalc + anual;
                }
            }
            else {
                totalCalc = inputC.sub_result * (inputC.dead_weight / 100) * (inputC.displacement / 100) * (inputC.attribution / 100);
            }
            inputC.result = totalCalc;
        }
        function saveOutcome(inputC) {

            var inputC1 = {};
            inputC1.company = inputC;
            var options = {
                owner: $scope.owner,
                item: transformoutcomes.outcomeToDTO(inputC1)
            };
            options.id = inputC.id;
            outcomesService.updateOutcome(options).then(function (response) {

            });

        }
        function deleteFields(fieldsNew, ev) {
            vm.fieldsNew = fieldsNew;
            vm.formWizard = {};
            vm.company.input_structure.inputs.splice(vm.index, 1);
            vm.fieldEdit = false;
            vm.fieldAdd = false;
            addFields();
        }
        function editFields(inputt, ev) {
            vm.tipeFields = inputt;
            vm.index = ev;
            vm.fieldEdit = true;
        }
        function selectFields(inputt, ev) {
            if (inputt != "NEW") {
                vm.tipeFields.fieldName = inputt.name;
                vm.tipeFields.data = inputt.value;
                vm.tipeFields.fieldEdit = inputt.edit_item;
                vm.nuevo = false;
            }
            else {
                vm.tipeFields.fieldName = "";
                vm.tipeFields.data = 0;
                vm.nuevo = true;
            }
        }
        function addOperator() {
            if (vm.selectOp != "exit") {
                if (!vm.element) {
                    switch (vm.selectOp) {
                        case 0:
                            vm.element = vm.operator[0];
                            vm.company.input_structure.formula.push(vm.element);
                            break;
                        case 1:
                            vm.element = vm.operator[1];
                            vm.company.input_structure.formula.push(vm.element);
                            break;
                        case 2:
                            vm.element = vm.operator[2];
                            vm.company.input_structure.formula.push(vm.element);
                            break;
                        case 3:
                            vm.element = vm.operator[3];
                            vm.company.input_structure.formula.push(vm.element);
                            break;
                        case 4:
                            vm.element = vm.operator[4];
                            vm.company.input_structure.formula.push(vm.element);
                            break;
                        case 5:
                            vm.element = vm.operator[5];
                            vm.company.input_structure.formula.push(vm.element);
                            break;
                    }
                } else {
                    vm.company.input_structure.formula.push(vm.element);
                }
            }
            else {
                vm.salvar = true;
                vm.addelement = false;
            }
            vm.element = '';
            vm.selectOp = "exit";
        }
        function editOperator(ev) {
            if (vm.element == "Eliminar") {
                vm.company.input_structure.formula.splice(vm.index, 1);
            }
            else {
                if (vm.selectOp != "exit") {
                    vm.company.input_structure.formula[vm.index] = vm.element;
                }
            }
            vm.editelement = false;
            vm.element = '';
            vm.salvar = true;
            vm.selectOp = "exit";
        }
        function deleteOperator(ev) {
            vm.company.input_structure.formula.splice(vm.index, 1);
            vm.salvar = true;
            vm.selectOp = "exit";
        }
        function campo(ev) {
            return (ev);
        }
        function calculo() {
            if (vm.company.input_structure) {
                var valor = 0;
                var valorParen = [];
                var cantidad = 0;
                var cantidadt = 0;
                var indi = 0;
                var datainput = [];
                var operadorU = [];
                if (vm.company.input_structure.formula.length == 0) {
                    datainput[0] = 0;
                }
                for (let it = 0; it < vm.company.input_structure.formula.length; it++) {
                    var findv = false;
                    var parametro = vm.company.input_structure.formula[it];
                    for (let i = 0; i < vm.company.input_structure.inputs.length; i++) {
                        if (vm.company.input_structure.inputs[i].fieldName == parametro) {
                            cantidad = vm.company.input_structure.inputs[i].data;
                            if (!datainput[indi]) {
                                datainput[indi] = cantidad;
                            }
                            findv = true;
                            break;
                        }
                    }
                    if (parametro == "(") {
                        indi = indi + 1;
                        continue;
                    }
                    if (parametro == ")") {
                        cantidad = datainput[indi];
                        datainput[indi] = 0;
                        indi = indi - 1;
                    }
                    if (vm.company.input_structure.formula[it + 1] && (vm.company.input_structure.formula[it + 1] == "*" || vm.company.input_structure.formula[it + 1] == "/")) {
                        var operadorA = vm.company.input_structure.formula[it + 1];
                        if (!vm.company.input_structure.formula[it + 2]) {
                            datainput[0] = $translate.instant('INPUT.FORMULA_ERROR');
                            break;
                        }
                        var parametro = vm.company.input_structure.formula[it + 2];
                        for (let i = 0; i < vm.company.input_structure.inputs.length; i++) {
                            if (vm.company.input_structure.inputs[i].fieldName == parametro) {
                                var cantidadMD = vm.company.input_structure.inputs[i].data;
                                break;
                            }
                        }
                        switch (operadorA) {
                            case '*':
                                cantidad = cantidadMD * cantidad;
                                break;
                            case '/':
                                if (cantidad > 0) {
                                    cantidad = cantidad / cantidadMD;
                                    break;
                                }
                        }
                        if (!operadorU[indi]) {
                            datainput[indi] = cantidad;
                        }
                        it = it + 2;
                    }
                    switch (operadorU[indi]) {
                        case '+':
                            datainput[indi] = parseFloat(datainput[indi]) + parseFloat(cantidad);
                            break;
                        case '-':
                            datainput[indi] = datainput[indi] - cantidad;
                            break;
                        case '*':
                            datainput[indi] = datainput[indi] * cantidad;
                            break;
                        case '/':
                            if (cantidad > 0) {
                                datainput[indi] = datainput[indi] / cantidad;
                            }
                            break;
                    }
                    operadorU[indi] = "";
                    if (!findv) {
                        for (let i = 0; i < vm.operator.length - 2; i++) {
                            if (vm.operator[i] == parametro) {
                                operadorU[indi] = parametro;
                                break;
                            }
                        }

                    }
                }
                vm.company.input_structure.calculation = datainput[0];
                vm.company.sub_result = datainput[0];
            }
        }
        function calculoAnual() {
            var interes = 1 + ($rootScope.typeInterest / 100);
            var totalCalc = 0;
            if (vm.company.years > 1) {
                var anual = vm.company.sub_result / vm.company.years;
                totalCalc = anual;
                for (let i = 2; i <= vm.company.years; i++) {
                    anual = anual / interes;
                    totalCalc = totalCalc + anual;
                }
            }
            else {
                totalCalc = vm.company.sub_result
            }
            vm.company.result = totalCalc;
        }
        function getItems(idCompany, inOwner) {
            var options = {
                owner: $scope.owner,
                proyect_id: $rootScope.companySel,
                withFiles: true
            };
            itemsService.getProyects(options).then(function (response) {
                vm.items = response;
            }, function (response) {
                vm.items = [];
                //                $scope.isLoadingP = true;
            }
            )
        }
        function openCompany(inputSel, ev) {
            vm.company = inputSel;
            if (!vm.company.input_structure.calculation) {
                vm.company.input_structure = JSON.parse(vm.company.input_structure);
            }
            vm.edit = true;
            vm.tabActive = 'preview';
        }

        function saveDialog(company, ev) {
            if (company.id) {
                vm.formWizard = {};
                $scope.isLoading = true;
                vm.idCompany = company.id;
                vm.formWizard.company = company;
                vm.edit = false;
                vm.tabActive = '';
            }
            else {
                $scope.isLoading = true;
                vm.formWizard = {};
                vm.formWizard.company = vm.company;
                vm.edit = false;
                vm.tabActive = '';
                vm.formWizard.company.proyect_id = $rootScope.companySel;
            }
            vm.addelement = false;
            createProyect(null, true);
            for (var i = 0; i < vm.selectedFields.length; i++) {
                vm.cambio = true;
                changeValue(vm.selectedFields[i]);
                vm.cambio = false;
            }
        vm.selectedFields = [];
        }
        function closeDialog() {
            vm.edit = false;
            vm.tabActive = '';
        }
        function editCompany() {
            vm.users = [];
            $rootScope.$broadcast('select-company', vm.formWizard.company);
            sessionService.set('companySelected', vm.formWizard.company);
            angular.forEach(vm.formWizard.personnel, function (u) {
                var userExists = $filter('filter')(vm.users, { id: u.id });
                if (userExists.length < 1) {
                    vm.users.push(u);
                }
            })
            vm.readView = true;
            vm.preview = false;
        }


        function newForm(ev) {
            vm.idCompany = null;
            vm.company = [];
            vm.edit = true;
            vm.tabActive = 'edit';
        }

        function closeForm(preview) {
            if (vm.idCompany) {
                getDataCompany(vm.idCompany);
                vm.readView = false;
                vm.preview = preview;
            } else {
                vm.goClients();
            }
        }
        function createProyect(msWizard, close) {
            var options = {
                owner: $scope.owner,
                item: transforminputs.inputToDTO(vm.formWizard)
            };
            if (vm.idCompany) {
                options.id = vm.idCompany;
                inputsService.updateInput(options).then(function (response) {
                    vm.fieldAdd = false;
                    vm.fieldEdit = false;
                    vm.tipeFields = { fieldName: '', fieldType: "1", fieldEdit: "0", data: "0", id_item: "0" };
                    getInputs();

                });


            } else {
                inputsService.createInput(options).then(function (response) {
                    $scope.isLoadingP = true;
                    vm.idCompany = response.id;
                    vm.fieldEdit = false;
                    vm.fieldAdd = false;
                    getInputs();

                })
            }
        }

        function deleteInput(ev) {
            var threads = angular.copy(vm.selectedThreads);
            const message = $translate.instant('GLOBAL.ARE_YOU_SURE');
            const yes = $translate.instant('GLOBAL.YES');
            const no = $translate.instant('GLOBAL.NO');

            vm.selectedThreads = [];
            for (var j = 0; j < threads.length; j++) {
                var options = {
                    owner: $scope.owner,
                    stake_id: threads[j].id
                };
                const confirm = $mdDialog.confirm()
                    .title(message)
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);
                $mdDialog.show(confirm).then(e => {
                    inputsService.deleteInput(options).then(function (response) {
                        vm.edit = false;
                        getInputs();
                    })
                })
                    .catch(err => { })
            }
            //           getInputs();
        }

        function isSelected(thread) {
            return vm.selectedThreads.indexOf(thread) > -1;
        }
        function isSelectedField(thread) {
            if (vm.selectedFields.indexOf(thread) == -1) {
                vm.selectedFields.push(thread);
            }
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        function toggleSelectThread(thread, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedThreads.indexOf(thread) > -1) {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            }
            else {
                vm.selectedThreads.push(thread);
            }
        }
        function deletestake(ev) {
            const message = $translate.instant('GLOBAL.ARE_YOU_SURE');
            const yes = $translate.instant('GLOBAL.YES');
            const no = $translate.instant('GLOBAL.NO');

            const confirm = $mdDialog.confirm()
                .title(message)
                .targetEvent(ev)
                .ok(yes)
                .cancel(no);

            $mdDialog.show(confirm).then(e => {
                vm.deleteInput();
            })
                .catch(err => { })

        }
        function getProyects(idCompany, inOwner) {
            var options = {
                owner: $scope.owner,
                company_id: $rootScope.companySel,
                withFiles: true
            };
            inputsService.getProyects(options).then(function (response) {
                vm.stakeholder = response;
                $scope.isLoadingP = false;
            }, function (response) {
                vm.stakeholder = [];
            }
            )
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('app.inputs')
        .service('inputsService', inputsService);

    /** @ngInject */
    // I provide access to the session store.
    function inputsService($q, $resource, settingsDomainService, sessionService, COMMON, $window, $mdToast, $state) {
        function deleteInput(options) {
//           console.log(options);
            var deferred = $q.defer();
            resourceinput.delete({
                owner: options.owner,
                input_id: options.stake_id
            },
                function (response) {
//                    console.log(response);
                    deferred.resolve(response);
                },

                function (e) {
                    console.log(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateInput(options) {
            var deferred = $q.defer();
            resourceinput.update({
                owner: options.owner,
                id: options.id
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    console.log(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function createInput(options) {
            var deferred = $q.defer();
 //           console.log(options);
            resourceinput.post({
                owner: options.owner
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    console.log(e);
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getInputs(options) {
            var deferred = $q.defer();
//            console.log(options);
            resourceinput.get(options,
                function (response) {
//                    console.log(response);
                    deferred.resolve(response);
                },

                function (e) {
//                    console.log(options);
                    console.log(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getProyects(options) {
            var deferred = $q.defer();
            resourceProyect.get(options,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    console.log(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        var resourceinput = $resource(COMMON.BASE_API + "/owner/:owner/input/:id", {
//            var resourceinput = $resource(COMMON.BASE_API + "/owner/:owner/input/", {
                // No default data
            }, {
                    get: {
                        method: "GET",
                        isArray: true
                    },
    
                    post: {
                        method: "POST",
                        isArray: false
                    },
    
                    delete: {
                        method: "DELETE",
                        isArray: true
                    },
    
                    update: {
                        method: "PUT",
                        isArray: false
                    },
                });
        var resourceProyect = $resource(COMMON.BASE_API + "/owner/:owner/stakeholder/:id", {
                    // No default data
                }, {
                        get: {
                            method: "GET",
                            isArray: true
                        },
        
                        post: {
                            method: "POST",
                            isArray: false
                        },
        
                        delete: {
                            method: "DELETE",
                            isArray: true
                        },
        
                        update: {
                            method: "PUT",
                            isArray: false
                        },
                    });
        

        return ({
            updateInput: updateInput,
            deleteInput: deleteInput,
            getInputs: getInputs,
            createInput: createInput,
            getProyects: getProyects,
        });

    }

})();
(function ()
{
    'use strict';

    angular.module('app.gantt-chart')
        .controller('GanttChartController', GanttChartController);

    /** @ngInject */
    function GanttChartController($mdDialog, $document, $animate, $scope, $timeout, ganttUtils, GanttObjectModel, ganttDebounce, moment, Tasks, Timespans, $window, $mdSidenav, msApi)
    {
        var vm = this;
        var objectModel;

        // Data
        vm.live = {};
        vm.options = {
            mode                    : 'custom',
            scale                   : 'day',
            sortMode                : undefined,
            sideMode                : 'Tree',
            daily                   : true,
            maxHeight               : 300,
            width                   : true,
            zoom                    : 1,
            rowSortable             : true,
            columns                 : ['model.name', 'from', 'to'],
            treeTableColumns        : ['from', 'to'],
            columnsHeaders          : {
                'model.name': 'Name',
                'from'      : 'Start Time',
                'to'        : 'End Time'
            },
            columnsClasses          : {
                'model.name': 'gantt-column-name',
                'from'      : 'gantt-column-from',
                'to'        : 'gantt-column-to'
            },
            columnsFormatters       : {
                'from': function (from)
                {
                    return angular.isDefined(from) ? from.format('lll') : undefined;
                },
                'to'  : function (to)
                {
                    return angular.isDefined(to) ? to.format('lll') : undefined;
                }
            },
            treeHeaderContent       : '{{getHeader()}}',
            columnsHeaderContents   : {
                'model.name': '{{getHeader()}}',
                'from'      : '{{getHeader()}}',
                'to'        : '{{getHeader()}}'
            },
            autoExpand              : 'both',
            taskOutOfRange          : 'truncate',
            fromDate                : '',
            toDate                  : '',
            rowContentEnabled       : true,
            rowContent              : '{{row.model.name}}',
            taskContentEnabled      : true,
            taskContent             : '<i ng-click="scope.vm.editDialog($event, \'task\', task)" class="gantt-task-edit-button icon-pencil s12 icon"\n   aria-label="edit task">\n</i>\n<span class="gantt-task-name">\n    {{task.model.name}}\n    <md-tooltip md-direction="top" class="gantt-chart-task-tooltip">\n        <div layout="column" layout-align="center center">\n            <div class="tooltip-name">\n                {{task.model.name}}\n            </div>\n            <div class="tooltip-date">\n                <span>\n                    {{task.model.from.format(\'MMM DD, HH:mm\')}}\n                </span>\n                <span>-</span>\n                <span>\n                    {{task.model.to.format(\'MMM DD, HH:mm\')}}\n                </span>\n            </div>\n        </div>\n    </md-tooltip>\n</span>',
            allowSideResizing       : false,
            labelsEnabled           : true,
            currentDate             : 'line',
            currentDateValue        : new Date(),
            draw                    : true,
            readOnly                : false,
            groupDisplayMode        : 'group',
            filterTask              : '',
            filterRow               : '',
            timeFrames              : {
                'day'    : {
                    start  : moment('8:00', 'HH:mm'),
                    end    : moment('20:00', 'HH:mm'),
                    working: true,
                    default: true
                },
                'noon'   : {
                    start  : moment('12:00', 'HH:mm'),
                    end    : moment('13:30', 'HH:mm'),
                    working: false,
                    default: true
                },
                'weekend': {
                    working: false
                },
                'holiday': {
                    working: false,
                    color  : 'red',
                    classes: ['gantt-timeframe-holiday']
                }
            },
            dateFrames              : {
                'weekend'    : {
                    evaluator: function (date)
                    {
                        return date.isoWeekday() === 6 || date.isoWeekday() === 7;
                    },
                    targets  : ['weekend']
                },
                '11-november': {
                    evaluator: function (date)
                    {
                        return date.month() === 10 && date.date() === 11;
                    },
                    targets  : ['holiday']
                }
            },
            timeFramesWorkingMode   : 'hidden',
            timeFramesNonWorkingMode: 'visible',
            columnMagnet            : '15 minutes',
            timeFramesMagnet        : true,
            dependencies            : true,
            canDraw                 : function (event)
            {
                var isLeftMouseButton = event.button === 0 || event.button === 1;
                return vm.options.draw && !vm.options.readOnly && isLeftMouseButton;
            },
            drawTaskFactory         : function ()
            {
                return {
                    id   : ganttUtils.randomUuid(),  // Unique id of the task.
                    name : 'Drawn task', // Name shown on top of each task.
                    color: '#AA8833' // Color of the task in HEX format (Optional).
                };
            },
            api                     : function (ganttApi)
            {
                // API Object is used to control methods and events from angular-gantt.
                vm.api = ganttApi;

                vm.api.core.on.ready($scope, function ()
                {
                    // When gantt is ready, load data.
                    // `data` attribute could have been used too.
                    vm.load();

                    // DOM events
                    vm.api.directives.on.new($scope, function (directiveName, directiveScope, element)
                    {
                        /**
                         * Gantt Task
                         */
                        if ( directiveName === 'ganttTask' )
                        {
                            element.on('mousedown touchstart', function (event)
                            {
                                event.preventDefault();
                                event.stopPropagation();
                                vm.live.row = directiveScope.task.row.model;
                                if ( angular.isDefined(directiveScope.task.originalModel) )
                                {
                                    vm.live.task = directiveScope.task.originalModel;
                                }
                                else
                                {
                                    vm.live.task = directiveScope.task.model;
                                }
                                $scope.$digest();
                            });

                        }

                        /**
                         * Gantt Row
                         */
                        else if ( directiveName === 'ganttRow' )
                        {

                            element.on('click', function (event)
                            {
                                event.stopPropagation();
                            });

                            element.on('mousedown touchstart', function (event)
                            {
                                event.stopPropagation();
                                vm.live.row = directiveScope.row.model;
                                $scope.$digest();
                            });

                        }

                        /**
                         * Gantt Row Label
                         */
                        else if ( directiveName === 'ganttRowLabel' )
                        {
                            // Fix for double trigger due to gantt-sortable plugin
                            element.off('click');

                            element.on('click', function (event)
                            {
                                event.preventDefault();
                                editDialog(event, 'row', directiveScope.row);
                            });

                            element.on('mousedown touchstart', function ()
                            {
                                vm.live.row = directiveScope.row.model;
                                $scope.$digest();
                            });

                        }
                    });

                    vm.api.tasks.on.rowChange($scope, function (task)
                    {
                        vm.live.row = task.row.model;
                    });

                    objectModel = new GanttObjectModel(vm.api);
                });
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.search = search;
        vm.setSortMode = setSortMode;
        vm.addDialog = addDialog;
        vm.editDialog = editDialog;
        vm.canAutoWidth = canAutoWidth;
        vm.getColumnWidth = getColumnWidth;
        vm.load = load;
        vm.reload = reload;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Set Gantt Chart height at the init
            calculateHeight();

            angular.element($window).on('resize', function ()
            {
                $scope.$apply(function ()
                {
                    calculateHeight();
                });
            });
        }

        /**
         * Max Height Fix
         */
        function calculateHeight()
        {
            vm.options.maxHeight = $document.find('#chart-container').offsetHeight;
        }

        /**
         * Add New Row
         */
        function addDialog(ev)
        {
            $mdDialog.show({
                controller         : 'GanttChartAddEditDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/gantt-chart/dialogs/add-edit/add-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    dialogData: {
                        chartData : vm.data,
                        dialogType: 'add'
                    }
                }
            });
        }

        /**
         * Edit Dialog
         */
        function editDialog(ev, formView, formData)
        {
            $mdDialog.show({
                controller         : 'GanttChartAddEditDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/gantt-chart/dialogs/add-edit/edit-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    dialogData: {
                        chartData : vm.data,
                        dialogType: 'edit',
                        formView  : formView,
                        formData  : formData
                    }
                }
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Search
         * @param sidenavId
         */
        function search(option, keyword)
        {
            if ( option === 'rows' )
            {
                vm.options.filterRow = keyword;
            }
            else if ( option === 'tasks' )
            {
                vm.options.filterTask = keyword;
            }
        }

        /**
         * Sort Mode
         * @param mode
         */
        function setSortMode(mode)
        {
            vm.options.sortMode = mode;

            if ( angular.isUndefined(mode) )
            {
                vm.options.rowSortable = true;
            }
            else
            {
                vm.options.rowSortable = false;
            }
        }

        /**
         * Side Mode
         */
        $scope.$watch('vm.options.sideMode', function (newValue, oldValue)
        {
            if ( newValue !== oldValue )
            {
                vm.api.side.setWidth(undefined);

                $timeout(function ()
                {
                    vm.api.columns.refresh();
                });
            }
        });

        function canAutoWidth(scale)
        {
            if ( scale.match(/.*?hour.*?/) || scale.match(/.*?minute.*?/) )
            {
                return false;
            }

            return true;
        }

        function getColumnWidth(widthEnabled, scale, zoom)
        {
            if ( !widthEnabled && vm.canAutoWidth(scale) )
            {
                return undefined;
            }

            if ( scale.match(/.*?week.*?/) )
            {
                return 150 * zoom;
            }

            if ( scale.match(/.*?month.*?/) )
            {
                return 300 * zoom;
            }

            if ( scale.match(/.*?quarter.*?/) )
            {
                return 500 * zoom;
            }

            if ( scale.match(/.*?year.*?/) )
            {
                return 800 * zoom;
            }

            return 40 * zoom;
        }

        // Reload data action
        function load()
        {
            vm.data = Tasks.data;
            vm.timespans = Timespans.data;

            // Fix for Angular-gantt-chart issue
            $animate.enabled(true);
            $animate.enabled($document.find('#gantt'), false);

        }

        /**
         * Reload Data
         */
        function reload()
        {
            msApi.resolve('ganttChart.tasks@get', function (response)
            {
                vm.data = response.data;
            });

            msApi.resolve('ganttChart.timespans@get', function (response)
            {
                vm.timespans = response.data;
            });
        }

        // Visual two way binding.
        var ganttDebounceValue = 1000;

        var listenTaskJson = ganttDebounce(function (taskJson)
        {
            if ( angular.isDefined(taskJson) )
            {
                var task = angular.fromJson(taskJson);
                objectModel.cleanTask(task);
                var model = vm.live.task;
                angular.extend(model, task);
            }
        }, ganttDebounceValue);

        $scope.$watch('vm.live.taskJson', listenTaskJson);

        var listenRowJson = ganttDebounce(function (rowJson)
        {
            if ( angular.isDefined(rowJson) )
            {
                var row = angular.fromJson(rowJson);
                objectModel.cleanRow(row);
                var tasks = row.tasks;

                delete row.tasks;
                var rowModel = vm.live.row;

                angular.extend(rowModel, row);

                var newTasks = {};
                var i, l;

                if ( angular.isDefined(tasks) )
                {
                    for ( i = 0, l = tasks.length; i < l; i++ )
                    {
                        objectModel.cleanTask(tasks[i]);
                    }

                    for ( i = 0, l = tasks.length; i < l; i++ )
                    {
                        newTasks[tasks[i].id] = tasks[i];
                    }

                    if ( angular.isUndefined(rowModel.tasks) )
                    {
                        rowModel.tasks = [];
                    }

                    for ( i = rowModel.tasks.length - 1; i >= 0; i-- )
                    {
                        var existingTask = rowModel.tasks[i];
                        var newTask = newTasks[existingTask.id];

                        if ( angular.isUndefined(newTask) )
                        {
                            rowModel.tasks.splice(i, 1);
                        }
                        else
                        {
                            objectModel.cleanTask(newTask);
                            angular.extend(existingTask, newTask);

                            delete newTasks[existingTask.id];
                        }
                    }
                }
                else
                {
                    delete rowModel.tasks;
                }

                angular.forEach(newTasks, function (newTask)
                {
                    rowModel.tasks.push(newTask);
                });
            }
        }, ganttDebounceValue);

        $scope.$watch('vm.live.rowJson', listenRowJson);

        $scope.$watchCollection('vm.live.task', function (task)
        {
            vm.live.taskJson = angular.toJson(task, true);
            vm.live.rowJson = angular.toJson(vm.live.row, true);
        });

        $scope.$watchCollection('vm.live.row', function (row)
        {
            vm.live.rowJson = angular.toJson(row, true);
            if ( angular.isDefined(row) && angular.isDefined(row.tasks) && row.tasks.indexOf(vm.live.task) < 0 )
            {
                vm.live.task = row.tasks[0];
            }
        });

        $scope.$watchCollection('vm.live.row.tasks', function ()
        {
            vm.live.rowJson = angular.toJson(vm.live.row, true);
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.file-manager', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msUtilProvider)
    {
        // State
        $stateProvider.state('app.file-manager', {
            url      : '/file-manager',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/file-manager/file-manager.html',
                    controller : 'FileManagerController as vm'
                }
            },
            resolve  : {
                Documents: function (msApi)
                {
                    return msApi.resolve('fileManager.documents@get');
                }
            },
            bodyClass: 'file-manager'
        });

        // Translation
        var base = 'app/main/apps/file-manager';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }
        // Api
        msApiProvider.register('fileManager.documents', ['app/data/file-manager/documents.json']);

        // Navigation
        // msNavigationServiceProvider.saveItem('apps.file-manager', {
        //     title : 'File Manager',
        //     icon  : 'icon-folder',
        //     state : 'app.file-manager',
        //     weight: 6
        // });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.file-manager')
        .controller('FileManagerController', FileManagerController);

    /** @ngInject */
    function FileManagerController($mdSidenav, Documents)
    {
        var vm = this;

        // Data
        vm.accounts = {
            'creapond'    : 'johndoe@creapond.com',
            'withinpixels': 'johndoe@withinpixels.com'
        };
        vm.selectedAccount = 'creapond';
        vm.currentView = 'list';
        vm.showDetails = true;

        vm.path = Documents.data.path;
        vm.folders = Documents.data.folders;
        vm.files = Documents.data.files;
        vm.selected = vm.files[0];

        vm.ngFlowOptions = {
            // You can configure the ngFlow from here
            /*target                   : 'api/media/image',
             chunkSize                : 15 * 1024 * 1024,
             maxChunkRetries          : 1,
             simultaneousUploads      : 1,
             testChunks               : false,
             progressCallbacksInterval: 1000*/
        };
        vm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {}
        };

        // Methods
        vm.fileAdded = fileAdded;
        vm.upload = upload;
        vm.fileSuccess = fileSuccess;

        vm.select = select;
        vm.toggleDetails = toggleDetails;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleView = toggleView;

        //////////

        /**
         * File added callback
         * Triggers when files added to the uploader
         *
         * @param file
         */
        function fileAdded(file)
        {
            // Prepare the temp file data for file list
            var uploadingFile = {
                id       : file.uniqueIdentifier,
                file     : file,
                type     : '',
                owner    : 'Emily Bennett',
                size     : '',
                modified : moment().format('MMMM D, YYYY'),
                opened   : '',
                created  : moment().format('MMMM D, YYYY'),
                extention: '',
                location : 'My Files > Documents',
                offline  : false,
                preview  : 'assets/images/etc/sample-file-preview.jpg'
            };

            // Append it to the file list
            vm.files.push(uploadingFile);
        }

        /**
         * Upload
         * Automatically triggers when files added to the uploader
         */
        function upload()
        {
            // Set headers
            vm.ngFlow.flow.opts.headers = {
                'X-Requested-With': 'XMLHttpRequest',
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
            };

            vm.ngFlow.flow.upload();
        }

        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function fileSuccess(file, message)
        {
            // Iterate through the file list, find the one we
            // are added as a temp and replace its data
            // Normally you would parse the message and extract
            // the uploaded file data from it
            angular.forEach(vm.files, function (item, index)
            {
                if ( item.id && item.id === file.uniqueIdentifier )
                {
                    // Normally you would update the file from
                    // database but we are cheating here!

                    // Update the file info
                    item.name = file.file.name;
                    item.type = 'document';

                    // Figure out & upddate the size
                    if ( file.file.size < 1024 )
                    {
                        item.size = parseFloat(file.file.size).toFixed(2) + ' B';
                    }
                    else if ( file.file.size >= 1024 && file.file.size < 1048576 )
                    {
                        item.size = parseFloat(file.file.size / 1024).toFixed(2) + ' Kb';
                    }
                    else if ( file.file.size >= 1048576 && file.file.size < 1073741824 )
                    {
                        item.size = parseFloat(file.file.size / (1024 * 1024)).toFixed(2) + ' Mb';
                    }
                    else
                    {
                        item.size = parseFloat(file.file.size / (1024 * 1024 * 1024)).toFixed(2) + ' Gb';
                    }
                }
            });
        }

        /**
         * Select an item
         *
         * @param item
         */
        function select(item)
        {
            vm.selected = item;
        }

        /**
         * Toggle details
         *
         * @param item
         */
        function toggleDetails(item)
        {
            vm.selected = item;
            toggleSidenav('details-sidenav');
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggle view
         */
        function toggleView()
        {
            vm.currentView = vm.currentView === 'list' ? 'grid' : 'list';
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.faqs', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider,
        msUtilProvider, msNavigationServiceProvider, ivhTreeviewOptionsProvider) {


        ivhTreeviewOptionsProvider.set({
            defaultSelectedState: false,
            validate: true,
            expandToDepth: -1,
            twistieCollapsedTpl: '<md-icon md-font-icon="icon-chevron-right"></md-icon>',
            twistieExpandedTpl: '<md-icon md-font-icon="icon-chevron-left"></md-icon>',
            twistieLeafTpl: '<span style="cursor: default;">&#8192;&#8192;</span>'
        });

        // State

        $stateProvider.state('app.faqs', {
            url: '/faqs',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/faqs/faqs.html',
                    controller: 'faqsController as vm'
                }
            },
            bodyClass: 'faqs'
        });

        $stateProvider
            .state('app.site_overview.faqs', {
                abstract: true,
                url: '/faqs',
                onEnter: function ($stateParams) {


                },
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                    section: function ($stateParams) {
                        return $stateParams.owner
                    },
                    is_owner: function ($stateParams) {
                        return false
                    },
                },


            })
            .state('app.site_overview.faqs.list', {
                url: '/list',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/faqs/faqs.html',
                        controller: 'faqsController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{owner}}'
                },
                resolve: {

                },
            })
            .state('app.site_overview.faqs.list.thread', {
                url: '/list/:id',
                bodyClass: 'faqs'
            });
        // Translation
        var base = 'app/main/apps/faqs';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.faqs')
        .controller('faqsController', faqsController);

    /** @ngInject */
    function faqsController(faqsService, $sce) {
        var vm = this;

        vm.faqs = [];
        vm.loading = true;
        vm.searchQuery = '';
        vm.filteredFAQs = [];
        

        vm.toggleFAQ = function(faq) {
            vm.faqs.forEach(function(item) {
                if (item !== faq) {
                    item.isOpen = false;
                }
            });

            faq.isOpen = !faq.isOpen;
        };
        vm.hasFAQsOfType = function(type_id) {
            return vm.filteredFAQs.some(function(faq) {
                return faq.type_id === type_id;
            });
        };
        

        function normalizeString(str) {
            return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        }
        vm.getTrustedHtml = function(faq) {
            return $sce.trustAsHtml(faq.answer);
        };

        vm.searchFAQs = function() {
            if (vm.searchQuery) {
                var normalizedQuery = normalizeString(vm.searchQuery);
                var queryWords = normalizedQuery.split(/\s+/);

                vm.filteredFAQs = vm.faqs.filter(function(faq) {
                    var normalizedQuestion = normalizeString(faq.question);
                    var normalizedAnswer = normalizeString(faq.answer);

                    return queryWords.every(function(word) {
                        return normalizedQuestion.includes(word) || normalizedAnswer.includes(word);
                    });
                });
            } else {
                vm.filteredFAQs = vm.faqs;
            }
        };

        function loadFAQs() {
            faqsService.getFAQs().then(function (response) {
                vm.faqs = response;
                vm.filteredFAQs = vm.faqs;
                vm.loading = false;
            }, function (error) {
                console.error('Error al cargar FAQs', error);
                vm.loading = false;
            });
        }

        loadFAQs();
    }
})();

(function () {
    'use strict';

    angular
        .module('app.faqs')
        .service('faqsService', faqsService);

    /** @ngInject */
    function faqsService($q, $translate) {
        var service = {
            getFAQs: getFAQs
        };

        return service;
        
        var FAQ_TYPES = {
            1: 'general',
            2: 'Dashboard',
            3: 'clients',
            4: 'users',
            5: 'tasks',
            6: 'complaints',
            7: 'documents',
            8: 'forms',
            9: 'language',
            10: 'login'
        };

        function getFAQs() {
            var deferred = $q.defer();

            var faqs = [
                {
                    question: $translate.instant('FAQS.QUESTION_1'),
                    answer: $translate.instant('FAQS.ANSWER_1'),
                    type_id: 2, // Dashboard
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_2'),
                    answer: $translate.instant('FAQS.ANSWER_2'),
                    type_id: 2, // Dashboard
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_3'),
                    answer: $translate.instant('FAQS.ANSWER_3'),
                    type_id: 2, // Dashboard
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_4'),
                    answer: $translate.instant('FAQS.ANSWER_4'),
                    type_id: 2, // Dashboard
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_5'),
                    answer: $translate.instant('FAQS.ANSWER_5'),
                    type_id: 2, // Dashboard
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_6'),
                    answer: $translate.instant('FAQS.ANSWER_6'),
                    type_id: 2, // Dashboard
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_7'),
                    answer: $translate.instant('FAQS.ANSWER_7'),
                    type_id: 2, // Dashboard
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_8'),
                    answer: $translate.instant('FAQS.ANSWER_8'),
                    type_id: 2, // Dashboard
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_9'),
                    answer: $translate.instant('FAQS.ANSWER_9'),
                    type_id: 3, // clients
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_10'),
                    answer: $translate.instant('FAQS.ANSWER_10'),
                    type_id: 3, // clients
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_11'),
                    answer: $translate.instant('FAQS.ANSWER_11'),
                    type_id: 3, // clients
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_12'),
                    answer: $translate.instant('FAQS.ANSWER_12'),
                    type_id: 3, // clients
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_13'),
                    answer: $translate.instant('FAQS.ANSWER_13'),
                    type_id: 3, // clients
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_14'),
                    answer: $translate.instant('FAQS.ANSWER_14'),
                    type_id: 3, // clients
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_15'),
                    answer: $translate.instant('FAQS.ANSWER_15'),
                    type_id: 4, // users
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_16'),
                    answer: $translate.instant('FAQS.ANSWER_16'),
                    type_id: 4, // users
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_17'),
                    answer: $translate.instant('FAQS.ANSWER_17'),
                    type_id: 4, // users
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_18'),
                    answer: $translate.instant('FAQS.ANSWER_18'),
                    type_id: 4, // users
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_19'),
                    answer: $translate.instant('FAQS.ANSWER_19'),
                    type_id: 4, // users
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_20'),
                    answer: $translate.instant('FAQS.ANSWER_20'),
                    type_id: 4, // users
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_21'),
                    answer: $translate.instant('FAQS.ANSWER_21'),
                    type_id: 4, // users
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_22'),
                    answer: $translate.instant('FAQS.ANSWER_22'),
                    type_id: 4, // users
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_23'),
                    answer: $translate.instant('FAQS.ANSWER_23'),
                    type_id: 10, // login
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_24'),
                    answer: $translate.instant('FAQS.ANSWER_24'),
                    type_id: 10, // login
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_25'),
                    answer: $translate.instant('FAQS.ANSWER_25'),
                    type_id: 10, // login
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_26'),
                    answer: $translate.instant('FAQS.ANSWER_26'),
                    type_id: 10, // login
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_27'),
                    answer: $translate.instant('FAQS.ANSWER_27'),
                    type_id: 10, // login
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_28'),
                    answer: $translate.instant('FAQS.ANSWER_28'),
                    type_id: 10, // login
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_29'),
                    answer: $translate.instant('FAQS.ANSWER_29'),
                    type_id: 10, // login
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_30'),
                    answer: $translate.instant('FAQS.ANSWER_30'),
                    type_id: 10, // login
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_31'),
                    answer: $translate.instant('FAQS.ANSWER_31'),
                    type_id: 10, // login
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_32'),
                    answer: $translate.instant('FAQS.ANSWER_32'),
                    type_id: 10, // login
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_33'),
                    answer: $translate.instant('FAQS.ANSWER_33'),
                    type_id: 10, // login
                    isOpen: false
                },
                {
                    question: $translate.instant('FAQS.QUESTION_34'),
                    answer: $translate.instant('FAQS.ANSWER_34'),
                    type_id: 10, // login
                    isOpen: false
                },                
                {
                    question: $translate.instant('FAQS.QUESTION_40'),
                    answer: $translate.instant('FAQS.ANSWER_40') + 
                        '<div class="video-container">' + 
                        '<iframe width="560" height="315" src="https://www.youtube.com/embed/isplU8OqxV8" ' +
                        'title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; ' +
                        'gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>' +
                        '</div>',
                    type_id: 1, // general
                    isOpen: false
                },                
                {
                    question: $translate.instant('FAQS.QUESTION_41'),
                    answer: $translate.instant('FAQS.ANSWER_41'),
                    type_id: 1, // general
                    isOpen: false
                },
            ];
            deferred.resolve(faqs);
            return deferred.promise;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.documents')
        .directive('h2cOnClickLoadFilesByGroups', ['documentsService', loadFilesByGroup])
        .directive('h2cIcon', Directive)
        .directive('h2cOnClickOpenGroupEditDialog', ['documentsService', OpenGroupEditDialog])
        .controller('DocumentsController', DocumentsController);

    /** @ngInject */
    function DocumentsController($scope, $rootScope, $stateParams, mediaService, sessionService, companyService, $mdToast, $translate, $document, $mdDialog,
        $mdMedia, $mdSidenav, documentsService, filesService, $window, msUtils,
        $timeout, $mdMenu) {
        var vm = this;

        vm.firstLoad = true;
        vm.selectedThreads = [];
        $scope.includeSubgroups = true;
        vm.documentIDSelected = null;
        vm.isLoading = true;
        $scope.owner = $stateParams.owner;
        vm.toggleSidenav = toggleSidenav;

        vm.searchGroupText = '';

        vm.isSelected = isSelected;
        vm.openMenu = openMenu;
        vm.unselectGroups = unselectGroups;
        vm.toggleSelectThread = toggleSelectThread;
        vm.deleteDocument = deleteDocument;
        vm.loadAllGroups = loadAllGroups;
        vm.selectThreads = selectThreads;
        vm.deselectThreads = deselectThreads;
        vm.toggleincludeSubgroups = toggleincludeSubgroups;
        vm.toggleSelectThreads = toggleSelectThreads;
        vm.openImportDialog = openImportDialog;
        vm.createGroupDocuments = createGroupDocuments;
        vm.shareFile = shareFile;
        vm.openDialogUsers = openDialogUsers;
        vm.updateCompany = updateCompany;

        vm.isCompanySelected = isCompanySelected;

        vm.downloadFile = downloadFile;
        vm.showFileInfo = showFileInfo;

        var companySelectEvent = $rootScope.$on('company-selected', function (event) {
            vm.updateCompany();
            vm.loadAllGroups();
            vm.firstLoad = false;
        });

        $scope.$on('$destroy', companySelectEvent);


        init();

        /////////////////

        function init() {
            if (sessionService.get('companySelected')) {
                $rootScope.$broadcast('company-selected');

            }
            mediaService.getStoragePrefix({
                owner: $scope.owner,
            }).then(function (res) {
                $scope.storagePrefix = res.prefix;
            })
        }

        function updateCompany() {
            vm.companySelected = sessionService.get('companySelected');
            companyService.setCompanyId(vm.companySelected.id);
            companyService.getBranches({
                owner: $scope.owner,
                company_id: vm.companySelected.id,
                withUsers: true,
            })
                .then(function (branchesResponse) {
                    vm.users = [];
                    branchesResponse.data.forEach(branch => {
                        vm.users = vm.users.concat(branch.users)
                    });
                    vm.users = _.uniq(vm.users, function (e) {
                        return e.id;
                    });
                });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId)
                .toggle();
        }


        function findFolder(folders, id) {
            for (var i = 0; i < folders.length; i++) {
                var folder = folders[i];
                if (folder.id == id) {
                    return folder;
                } else {
                    if (folder.children) {
                        var found = findFolder(folder.children, id)
                        if (found) {
                            return found
                        }
                    }
                }
            }
            return false;
        }



        function shareFile(fileId, users) {
            documentsService.shareFile($scope.owner, users, fileId).then(function (res) {
                var message = $translate.instant('GLOBAL.DELETED');
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 3000,
                    position: 'top',
                    parent: '#content-container'
                });
                $mdDialog.hide(true);
            })
        }

        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        function isSelected(thread) {
            return vm.selectedThreads.indexOf(thread) > -1;
        }

        function isCompanySelected() {
            if (angular.isObject(vm.companySelected)) {
                return true;
            }
            return false;
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        function toggleSelectThread(thread, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedThreads.indexOf(thread) > -1) {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            } else {
                vm.selectedThreads.push(thread);
            }
        }


        /**
         * Deselect threads
         */
        function deselectThreads() {
            vm.selectedThreads = [];
        }

        /**
         * Toggle select threads
         */
        function toggleSelectThreads() {
            if (vm.selectedThreads.length > 0) {
                vm.deselectThreads();
            } else {
                vm.selectThreads();
            }
        }

        /**
         * Select threads. If key/value pair given,
         * threads will be tested against them.
         *
         * @param [key]
         * @param [value]
         */
        function selectThreads(key, value) {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedThreads = [];

            for (var i = 0; i < vm.documents.length; i++) {
                if (angular.isUndefined(key) && angular.isUndefined(value)) {
                    vm.selectedThreads.push(vm.documents[i]);
                    continue;
                }

                if (angular.isDefined(key) && angular.isDefined(value) && vm.documents[i][key] === value) {
                    vm.selectedThreads.push(vm.documents[i]);
                }
            }
        }
        $scope.$on('pagination:loadPage', function (event) {

            vm.dataAlreadyLoaded = true;
            $timeout(function () {
                vm.isLoading = false;
            }, 1000);
        });

        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'nosplit';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big) {
                vm.currentView = 'nosplit';
            }

        });

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small) {
                vm.currentView = 'split';
            }

        });

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                if (vm.defaultView === 'split') {
                    vm.currentView = 'split';
                }
            }
        });


        $scope.$on('loadFilesByGroup', function (event, groups) {
            if (groups) {
                loadFilesByGroups(groups, groups[0]);
            } else {
                unselectGroups();
            }
        });


        function openImportDialog(ev) {
            $mdDialog.show({
                controller: 'ImportDialogController',
                controllerAs: 'vm',
                locals: {
                    owner: $scope.owner,
                    groups: vm.groups
                },
                templateUrl: 'app/main/apps/documents/dialogs/import/import-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            }).then(function (result) {
                if (result && result.update) {
                    $rootScope.pagination_resetquery();
                }
            });
        }

        function deleteDocument(ev) {
            if (vm.selectedThreads.length === 0) return false;


            $mdDialog.show({
                controller: 'DeleteDocumentDialogController',
                controllerAs: 'vm',
                locals: {
                    selectedThreads: vm.selectedThreads,
                    owner: $scope.owner
                },
                templateUrl: 'app/main/apps/documents/dialogs/delete-dialog/delete-document-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            }).then(function (deleted) {
                if (deleted) {
                    vm.deselectThreads();
                    $rootScope.pagination_resetquery();
                }
            });

        }

        function loadAllGroups() {
            vm.isLoading = true;
            var options = {
                owner: $scope.owner
            };
            documentsService.getGroups(options).then(function (response) {
                vm.isLoading = false;
                vm.groups = JSON.parse(angular.toJson(response.result));
                loadAllFiles(vm.groups);
            });
        }
        function loadAllFiles(groups) {
            var groupsFlatten = [];
            for (var i = 0; i < groups.length; i++) {
                var element = groups[i];
                groupsFlatten.push(element)
                if (element.children && element.children.length > 0) {
                    groupsFlatten = groupsFlatten.concat(getGroupChildren(element.children));
                }
            }
            loadFilesByGroups(groupsFlatten, null);
        }

        function getGroupChildren(array) {
            var result = [];
            for (var i = 0; i < array.length; i++) {
                var element = array[i];
                result.push(element)
            }
            return result
        }



        function openDialogUsers(ev, fileId) {
            $mdDialog.show({
                controller: 'SelectUsersController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/selectUsers/selectUsers.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                multiple: true,
                locals: {
                    storagePrefix: $scope.storagePrefix,
                    users: vm.users,
                    title: $translate.instant('GLOBAL.USERS')
                },
            })
                .then(function (resp) {
                    if (resp && resp.length > 0){
                        resp = resp.map(x => x.id)
                        vm.shareFile(fileId, resp)
                    }
                });

        }

        function loadFilesByGroups(groups, groupSelected) {
            var groupIds = [];
            angular.forEach(groups, function (group) {
                groupIds.push(group.id);
            });
            if (groupIds.length > 1 && !$scope.includeSubgroups) {
                vm.toggleincludeSubgroups();
                return;
            }
            if (groupIds.length > 0) {
                var options = {
                    owner: $scope.owner,
                    groupIds: groupIds,
                    sortDir: $rootScope.sortDir,
                    sortField: $rootScope.sortField
                };
                vm.groupSelected = groupSelected;
                documentsService.get(options).then(function (response) {
                    $rootScope.pagination_groupIds = groupIds;
                    vm.documents = response.result.data;
                    $rootScope.pagination_totalItems = response.result.total;
                    $rootScope.pagination_total_pages = response.result.last_page;
                    $rootScope.pagination_page = response.result.current_page;
                });
            } else {
                vm.documents = [];
                $rootScope.pagination_totalItems = 0;
                $rootScope.pagination_total_pages = 1;
                $rootScope.pagination_page = 1;
            }

        }


        $scope.$on('openGroupDialog', function (ev, group) {
            openGroupDialog(ev, group);
        });


        function unselectGroups() {
            vm.groupSelected = false;
            $rootScope.pagination_groupIds = false;
            var elemList = document.querySelectorAll('.group-row');
            elemList.forEach(function (elem) {
                elem.classList.remove('selected');
            });
            vm.loadAllGroups();
        }

        function toggleincludeSubgroups() {
            $scope.includeSubgroups = !$scope.includeSubgroups;
            var element = $("#treeview-group-" + vm.groupSelected.id);
            documentsService.triggerFilesByGroups(element.attr("data-group-node"), $scope.includeSubgroups);
        }


        var originatorEv;

        function openMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        }


        function openGroupDialog(ev, group) {
            $mdDialog.show({
                controller: 'EditGroupDialogController',
                controllerAs: 'vm',
                locals: {
                    group: group,
                    groups: vm.groups,
                    edit: true,
                    groupParentId: group.parent_id,
                    owner: $scope.owner
                    //nestedGroups:
                },
                templateUrl: 'app/main/apps/documents/dialogs/groups/edit-group.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
            }).then(function (data) {
                if (data.update) {
                    vm.loadAllGroups();
                }
            });
        }

        function createGroupDocuments(ev, group) {
            $mdDialog.show({
                controller: 'EditGroupDialogController',
                controllerAs: 'vm',
                locals: {
                    group: {},
                    groups: vm.groups,
                    edit: false,
                    groupParentId: null,
                    owner: $scope.owner
                    //nestedGroups:
                },
                templateUrl: 'app/main/apps/documents/dialogs/groups/edit-group.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
            }).then(function (data) {
                if (data.update) {
                    vm.loadAllGroups();
                }
            });
        }

        function downloadFile(f) {
            filesService.getPresignedUrl({
                owner: $scope.owner,
                file: f
            }).then(function (res) {
                $window.location.href = res.url;
            })
        }

        function showFileInfo(f, ev) {
            msUtils.showFileInfo($scope.owner, f, ev);
        }
    }



    function loadFilesByGroup(documentsService) {

        function unselectAllGroups() {
            var elemList = document.querySelectorAll('.group-row');
            elemList.forEach(function (elem) {
                elem.classList.remove('selected');
            });
        }

        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {
                    var groupNode = false;
                    if (element.parent().hasClass('selected')) {
                        unselectAllGroups();
                    } else {
                        unselectAllGroups();
                        element.parent().addClass('selected');
                        groupNode = scope.node;
                    }
                    var temp = $('#includeSubgroups').attr("data-include-subgroups");
                    var includeSubgroups = temp == 'true' || temp == '';
                    documentsService.triggerFilesByGroup(groupNode, includeSubgroups);
                });
            }
        };
    }


    /** @ngInject */
    function Directive($timeout, $q, $interpolate, msUtils, $compile) {

        return {
            restrict: 'E',

            scope: {
                file: '=file',
            },

            link: function (scope, element, attrs) {
                var file = scope.file || null;
                if (file != null) {
                    var fontIcon = msUtils.getExtensionIcon(file);
                    var html = '<md-icon class="s56 mr-5 ml-10" md-font-icon="' + fontIcon + '"></md-icon>';
                    var e = $compile(html)(scope);
                    element.replaceWith(e);
                }
            }
        };
    }
    function OpenGroupEditDialog(documentsService) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {
                    var groupNode = scope.node;
                    documentsService.triggerGroupDialog(groupNode);
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.documents')
        .service('documentsService', documentsService);

    /** @ngInject */
    // I provide access to the session store.
    function documentsService($q, $resource, settingsDomainService, sessionService, companyService, COMMON, $window, $mdToast, $rootScope) {

        function get(options) {
            if (options.groupIds !== undefined) {
                return getDocumentsByGroups(options);
            } else {
                var deferred = $q.defer();
                deferred.resolve({
                    result: { data: [] }
                });
                return (deferred.promise);
            }
        }


        function getDocumentsByGroups(options) {
            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });


            resourceDocuments.get({
                owner: options.owner,
                page: options.page,
                search: options.searchStringFilter,
                paginate: options.paginate,
                sortField: options.sortField,
                sortDir: options.sortDir,
                'related_id[]': options.groupIds,
                filters: JSON.stringify(filters)
            },
               // function (responseResult) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);
                   // for (var i = 0; i < responseResult.data.length; i++) {
                       // var element = responseResult.data[i];
                       // element.updated_at_format = moment.utc(element.updated_at).format('DD MMM YYYY HH:mm:00');
                       // element.created_at_format = moment.utc(element.created_at).format('DD MMM YYYY HH:mm:00');
                   // }
                   // deferred.resolve({
                    //    result: responseResult
                   // });
               // },

                function (responseResult) {
    // angular.copy(response, modulecontent);
    // setActiveDomain(domain);
    for (var i = 0; i < responseResult.data.length; i++) {
        var element = responseResult.data[i];
        
        // Convierte la hora UTC a la hora local del dispositivo
        var localUpdatedAt = moment.utc(element.updated_at).local();
        var localCreatedAt = moment.utc(element.created_at).local();

        // Formatea las fechas en un formato legible
        element.updated_at_format = localUpdatedAt.format('DD MMM YYYY HH:mm:ss');
        element.created_at_format = localCreatedAt.format('DD MMM YYYY HH:mm:ss');
    }
    deferred.resolve({
        result: responseResult
    });
},


                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        };



        function getFilters(options) {
            var deferred = $q.defer();

            return (deferred.promise);
        }

        function deleteDocument(options) {
            var deferred = $q.defer();
            resourceDocumentsById.delete({
                owner: options.owner,
                id: options.id,
            },
                function (responseResult) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        function unnestGalleries(node, groups, includeSubGroups) {
            groups.push(node);
            if (includeSubGroups && typeof node.children !== 'undefined' && node.children.length > 0) {
                angular.forEach(node.children, function (data) {
                    unnestGroups(data, groups, includeSubGroups);
                });
            }
            return groups;
        }

        function triggerFilesByGroup(groupNode, includeSubGroups) {
            var groups = false;
            if (groupNode) {
                var node = angular.fromJson(groupNode);
                groups = unnestGalleries(node, [], includeSubGroups);
            }
            $rootScope.$broadcast('loadFilesByGroup', groups);
        }

        function triggerSelectGroup(groupNode) {
            $rootScope.$broadcast('selectGroup', groupNode);
        }


        function triggerFilesByGroups(groupNode, includeSubgroups) {
            var groups = false;
            if (groupNode) {
                var node = angular.fromJson(groupNode);
                groups = unnestGroups(node, [], includeSubgroups);
            }
            $rootScope.$broadcast('loadFilesByGroup', groups);
        }

        function unnestGroups(node, groups, includeSubgroups) {
            groups.push(node);
            if (includeSubgroups && typeof node.children !== 'undefined' && node.children.length > 0) {
                angular.forEach(node.children, function (data) {
                    unnestGroups(data, groups, includeSubgroups);
                });
            }
            return groups;
        }


        function getGroups(options) {
            var deferred = $q.defer();

            resourceGroupDocumentsNested.get({
                owner: options.owner,
                company: companyService.getCompanyId()
            },
                function (responseResult) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject();
                }
            );

            return (deferred.promise);
        }

        function deleteGroup(owner, id) {
            var deferred = $q.defer();

            resourceGroupDocuments.delete({
                owner: owner,
                id: id
            },
                function (responseResult) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject();
                }
            );

            return (deferred.promise);
        }

        function saveGroup(owner, id, groupParentId, groupName) {
            var deferred = $q.defer();

            resourceGroupDocuments.update({
                owner: owner,
                name: groupName,
                parent_id: groupParentId,
                company_id: companyService.getCompanyId(),
                id: id
            },
                function (responseResult) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject();
                }
            );

            return (deferred.promise);
        }
        function createGroup(owner, groupParentId, groupName) {
            var deferred = $q.defer();

            resourceGroupDocuments.post({
                owner: owner,
                name: groupName,
                company_id: companyService.getCompanyId(),
                parent_id: groupParentId
            },
                function (responseResult) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject();
                }
            );

            return (deferred.promise);
        }
        function shareFile(owner, users, fileId) {
            var deferred = $q.defer();

            resourceShareFile.post({
                owner: owner,
                id: fileId
            },{
                users: users
            },
                function (responseResult) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject();
                }
            );

            return (deferred.promise);
        }




        function getS3UploadPreSignedUrl(options) {
            var deferred = $q.defer();

            resource_s3_presigned_url.get({
                uploadKey: 'file_group',
                owner: options.owner,
                fileName: options.fileName,
                rowId: options.groupId
                // lang: get("language")
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        function getDownloadUrl(options) {
            var deferred = $q.defer();

            resource_download_url.get({
                // lang: get("language")
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        function triggerGroupDialog(group) {
            $rootScope.$broadcast('openGroupDialog', group);
        }

        function triggerSelectParentGroup(groupNode) {
            $rootScope.$broadcast('selectParentGroup', groupNode);
        }

        function finishedUploadingFile(options) {
            var deferred = $q.defer();
            var options = {
                owner: options.owner,
                token: options.token
            }
            resource_finish_upload_file.post(options,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        var resource_download_url = $resource(
            COMMON.BASE_API + "/owner/:owner/upload/downloadUrl", {
                // No default data.
            }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            }
        );

        var resource_s3_presigned_url = $resource(
            COMMON.BASE_API + "/owner/:owner/upload/getS3UploadPreSignedUrl", {
                // No default data.
            }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            }
        );


        var resource_finish_upload_file = $resource(
            COMMON.BASE_API + "/owner/:owner/upload/finishedUploadingFile", {
                owner: '@owner',
            }, {
                post: {
                    method: "POST",
                    isArray: false
                }
            }
        );

        var resourceDocuments = $resource(COMMON.BASE_API + "/owner/:owner/file?upload_key=file_group", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });


        var resourceDocumentsById = $resource(COMMON.BASE_API + "/owner/:owner/file/:id", {
            // No default data
        }, {

                post: {
                    method: "POST",
                    isArray: false
                },

                delete: {
                    method: "DELETE",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                },
            });

        var resourceGroupDocumentsNested = $resource(COMMON.BASE_API + "/owner/:owner/fileGroupNested/:id", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: true
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                delete: {
                    method: "DELETE",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                },
            });
        var resourceShareFile = $resource(COMMON.BASE_API + "/owner/:owner/file/:id/share", {
            owner: '@owner',
            id: '@id'
        }, {
                post: {
                    method: "POST",
                    isArray: false
                }
            });

        var resourceGroupDocuments = $resource(COMMON.BASE_API + "/owner/:owner/fileGroup/:id", {
            owner: '@owner',
            id: '@id'
        }, {
                get: {
                    method: "GET",
                    isArray: true
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                delete: {
                    method: "DELETE",
                    isArray: true
                },

                update: {
                    method: "PUT",
                    isArray: false
                },
            });

        return ({
            get: get,
            getGroups: getGroups,
            deleteDocument: deleteDocument,
            getS3UploadPreSignedUrl: getS3UploadPreSignedUrl,
            getDownloadUrl: getDownloadUrl,
            finishedUploadingFile: finishedUploadingFile,
            triggerSelectParentGroup: triggerSelectParentGroup,
            triggerFilesByGroup: triggerFilesByGroup,
            triggerFilesByGroups: triggerFilesByGroups,
            triggerGroupDialog: triggerGroupDialog,
            triggerSelectGroup: triggerSelectGroup,
            deleteGroup: deleteGroup,
            saveGroup: saveGroup,
            createGroup: createGroup,
            shareFile: shareFile,
            getFilters: getFilters
        });

    }

})();
(function () {
    'use strict';

    angular
        .module('app.complaints')
        .controller('ComplaintsController', ComplaintsController);

    /** @ngInject */
    function ComplaintsController($scope, $rootScope, $stateParams, $translate, $document, $mdDialog, fieldsTemplateForms, dragulaService, COMMON, usersService, msUtils,
        $mdMedia, $mdSidenav, $state, tinyMceService, staffService, sessionService, $timeout, complaintsService, companyService, mediaService, $http, Upload, $mdMenu, $mdToast) {
        var vm = this;
        vm.urlForm = COMMON.URL_FORM;
        vm.loadingThreads = true;
        vm.formTab = 'edit';
        vm.userLogued = sessionService.getUser();
        if ($state.current.name === "app.site_overview.complaints.formslist") {
            vm.isFormList = true;
        }
        // vm.firstLoad = true;
        vm.currentFilter = {
            type: $state.params.type,
            filter: $state.params.filter
        };
        vm.selectedIndex = 0;
        vm.modelExample = {};
        vm.noexistchangues = true;
        vm.priorities = [
            { id: 0, name: "Baja" },
            { id: 1, name: "Media" },
            { id: 2, name: "Alta" },
            { id: 3, name: "Crítica" }
        ]
        vm.status = [
            { id: 2, name: "Nueva" },
            { id: 1, name: "Revisión" },
            { id: 4, name: "En investigación" },
            { id: 5, name: "Remitida a fiscalía" },
            { id: 3, name: "No admitida" },
            { id: 0, name: "Cerrada" }
        ];
        vm.processSteps = [
            { id: 2, labelKey: 'COMPLAINTS.NEW', icon: 'icon-file-document', colorClass: 'process-step-red' },
            { id: 1, labelKey: 'COMPLAINTS.REVIEW', icon: 'icon-magnify', colorClass: 'process-step-orange' },
            { id: 4, labelKey: 'COMPLAINTS.UNDER_INVESTIGATION', icon: 'icon-file-find', colorClass: 'process-step-blue' },
            { id: 5, labelKey: 'COMPLAINTS.REFERRED_TO_PROSECUTOR', icon: 'icon-gavel', colorClass: 'process-step-purple' },
            { id: 3, labelKey: 'COMPLAINTS.NOT_ADMITTED', icon: 'icon-file-outline', colorClass: 'process-step-grey' },
            { id: 0, labelKey: 'COMPLAINTS.CLOSED', icon: 'icon-check-circle', colorClass: 'process-step-green' }
        ];
        vm.canSeeAdminOnlyStatuses = [1, 2, 3, 14].indexOf(vm.userLogued.user_type) !== -1;
        vm.complaintLanguages = [
            { value: 'es', name: 'Español (España)' },
            { value: 'de', name: 'Alemán' },
            { value: 'en', name: 'Inglés' },
            { value: 'ca', name: 'Catalán' },
            { value: 'pt', name: 'Portugués' },
            { value: 'eu', name: 'Euskera' },
            { value: 'fr', name: 'Francés' },
            { value: 'gl', name: 'Gallego' },
            { value: 'it', name: 'Italiano' },
        ];
        
        vm.branding = msUtils.getBranding();
        if (vm.branding.hideDefaultForms) {
            vm.complaintLanguages = [];
        }
        if (vm.branding.customform) {
            for (let i = 0; i < vm.branding.customform.length; i++) {
                const element = vm.branding.customform[i];
                vm.complaintLanguages.push({ value: element.file, name: element.name })
            }
        }

        vm.typeFields = [{ value: 'textarea', text: 'COMPLAINTS.TEXTAREA' }, { value: 'input', text: 'COMPLAINTS.INPUT' }, { value: 'select', text: 'COMPLAINTS.SELECT_INPUT' }, { value: 'radio', text: 'COMPLAINTS.RADIO' },
        { value: 'separator', text: 'COMPLAINTS.SEPARATOR' }, { value: 'multiCheckbox', text: 'COMPLAINTS.MULTICHECK' }, { value: 'checkbox', text: 'COMPLAINTS.CHECK' }, { value: 'datepicker', text: 'COMPLAINTS.DATEPICKER' }, { value: 'dropzone', text: 'COMPLAINTS.DROPZONE' }];
        vm.typesInput = ['text', 'number', 'email', 'password', 'tel', 'hidden'];
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
        vm.currentThread = null;
        vm.selectedThreads = [];
        vm.editData = false;
        vm.views = {
            split: 'app/main/apps/complaints/views/list/split-view.html',
            nosplit: 'app/main/apps/complaints/views/list/nosplit-view.html'
        };
        vm.defaultView = 'split';
        vm.currentView = 'split';

        vm.idCompany = undefined;
        vm.companySelected = undefined;
        vm.isCompanySelected = isCompanySelected;

        // Method to enable editing
        $scope.editingEnabled = false;
        $scope.toggleEditing = function() {
        $scope.editingEnabled = !$scope.editingEnabled;
        };
        vm.openForm = openForm;
        vm.closeFormDetail = closeFormDetail;

        vm.startComplaintCanal = startComplaintCanal;
        vm.userImages = {};
        vm.userDetails = {};
        vm.showUserImage = showUserImage;
        vm.selectLanguageComplaintCanal = selectLanguageComplaintCanal;
        vm.finishInitComplaintForm = finishInitComplaintForm;
        vm.updateComplaintCanal = updateComplaintCanal;
        vm.editComplaintCanal = editComplaintCanal;
        vm.togglePredeterminated = togglePredeterminated;
        vm.setMultipleFormsAsPredetermined = setMultipleFormsAsPredetermined;
        vm.getDefaultButtonInfo = getDefaultButtonInfo;

        vm.readView = true;
        vm.loadingReadPane = false;

        vm.getComplaintFormName = getComplaintFormName;
        vm.getComplaintListTitle = getComplaintListTitle;

        vm.newComplaintForm = newComplaintForm;
        vm.deleteForm = deleteForm;
        vm.selectForm = selectForm;
        vm.selectFormType = selectFormType;


        vm.getComplaintFormTypeNameById = getComplaintFormTypeNameById;
        vm.calculateHeightChat = calculateHeightChat;
        vm.openValidationsDialog = openValidationsDialog;
        vm.openOptionsDialog = openOptionsDialog;
        vm.openOptionsComplaint = openOptionsComplaint;
        vm.setTOOptions = setTOOptions;
        vm.openDialogUsers = openDialogUsers;
        vm.openDialogBlockedUsers = openDialogBlockedUsers;
        vm.editFieldStructure = editFieldStructure;
        vm.closeOthers = closeOthers;
        vm.saveFieldStructure = saveFieldStructure;
        vm.cancelEditFieldStructure = cancelEditFieldStructure;
        vm.removeFieldStructure = removeFieldStructure;
        vm.hideFieldStructure = hideFieldStructure;
        vm.showFieldStructure = showFieldStructure;
        vm.addNewStructureField = addNewStructureField;
        vm.isSelected = isSelected;
        vm.toggleSelectThread = toggleSelectThread;
        vm.selectThreads = selectThreads;
        vm.deselectThreads = deselectThreads;
        vm.toggleSelectThreads = toggleSelectThreads;

        vm.setThreadStatus = setThreadStatus;
        vm.toggleThreadStatus = toggleThreadStatus;
        vm.toggleComplaintStatusEdit = toggleComplaintStatusEdit;

        vm.complaintCanal = null;
        vm.showFormDetailMobile = false;
        vm.changeView = changeView;
        vm.toggleSidenav = toggleSidenav;
        vm.tinymceOptions = tinyMceService.getOptions($scope);

        vm.openModalEmbedCode = openModalEmbedCode;
        vm.openModalSelectLang = openModalSelectLang;
        vm.getFormUrl = getFormUrl;
        vm.getFormUrlNew = getFormUrlNew;
        vm.openComplaint = openComplaint;
        vm.deleteComplaintAction = deleteComplaintAction;
        vm.closeComplaint = closeComplaint;
        vm.newComplaint = newComplaint;
        vm.newReport = newReport;
        vm.saveComplaint = saveComplaint;
        vm.deleteComplaint = deleteComplaint;
        vm.newAction = newAction;
        vm.uploadFile = uploadFile;
        vm.saveAction = saveAction;
        vm.openMenu = openMenu;
        vm.getActionUser = getActionUser;
        vm.getActionUserImage = getActionUserImage;
        vm.getActionUserName = getActionUserName;
        vm.getActionUserInitial = getActionUserInitial;
        vm.config = sessionService.config;

        vm.viewEditData = viewEditData;
        vm.startEditCaseNumber = startEditCaseNumber;
        vm.onCaseNumberChange = onCaseNumberChange;

        vm.translate = function (text) {
            return $translate.instant(text);
        };

        //////////

        $scope.$on('pagination:loadStart', function (event) {
            $scope.isLoading = true;
        });

        $scope.$on('pagination:loadPage', function (event) {
            $scope.isLoading = false;
        });


        $scope.owner = $stateParams.owner;


        var companySelectEvent = $rootScope.$on('company-selected', function (event) {
            vm.closeComplaint();
            vm.companySelected = sessionService.get('companySelected');
            companyService.setCompanyId(vm.companySelected.id);

            vm.showFormStartComplaintCanal = false;
            vm.showLanguageSelectorComplaintCanal = false;
            $rootScope.pagination_page = 1;
            var options = {
                owner: $scope.owner,
                resultsPerPage: 2500,
                sortField: 'first_name'
            }
            staffService.get(options).then(function (res) {
                vm.availableUsers = res.data;
            });

            // if (!vm.firstLoad) {
            $scope.isLoadingCanal = true;
            loadComplaint(vm.companySelected.id);
            // }
            // vm.firstLoad = false;
        });

        $scope.$on('$destroy', companySelectEvent);



        init();

        /////////////////

        function init() {
            if (sessionService.get('companySelected')) {
                $rootScope.$broadcast('company-selected');
            }

            mediaService.getStoragePrefix({
                owner: $scope.owner,
            }).then(function (res) {
                $scope.storagePrefix = res.prefix;
            })

            if ($state.current.name === "app.site_overview.complaints.list.active_complaint") {
                vm.openComplaint($state.params.id);
            }
        }

        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'nosplit';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big)
                vm.currentView = 'nosplit';

        });

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small)
                vm.currentView = 'split';

        });

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                if (vm.defaultView === 'split') {
                    vm.currentView = 'split';
                }
            }
        });


        var originatorEv;

        function openMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        }

        function isCompanySelected() {
            if (angular.isObject(vm.companySelected)) {
                return true;
            }
            return false;
        }
        function getComplaintFormName(complaint) {
            var form = vm.complaintForms.find(x => x.id == complaint.form_id);
            return form ? form.name : $translate.instant('COMPLAINTS.FORMNOTAVAILABLE');
        }

        function getComplaintListTitle(complaint) {
            var cn = complaint.case_number ? String(complaint.case_number).trim() : '';
            var subj = complaint.subject ? String(complaint.subject).trim() : '';
            if (cn && subj) { return cn + ' - ' + subj; }
            if (cn) { return cn; }
            return subj;
        }

        function startEditCaseNumber() {
            if (vm.caseNumberEditing) { return; }
            vm.caseNumberEditing = true;
            $timeout(function () {
                var el = document.querySelector('#site-complaints .toolbar-case-number-input');
                if (el) { el.focus(); }
            }, 0);
        }

        function onCaseNumberChange() {
            if (vm.basicForm) {
                vm.basicForm.$setDirty();
            }
        }

        function openComplaint(id) {
            vm.showFormStartComplaintCanal = false;
            vm.showLanguageSelectorComplaintCanal = false;
            vm.complaintSelected = null;
            $state.go('app.site_overview.complaints.list.active_complaint', {
                id: id,
                domain: $state.params.domain
            }, {
                notify: false,
                inherit: true,
                location: true
            });
            if (vm.basicForm) {
                vm.basicForm.$setPristine();
            }
            vm.complaintNew = undefined;
            vm.editData = false;
            vm.loadingReadPane = true;
            vm.idChat = id;
            vm.idTasksRelated = id;
            complaintsService.getComplaint({
                id: id,
                owner: $scope.owner
            })
                .then(function (resp) {
                    //console.log(resp);
                    vm.complaintSelected = resp;
                    vm.caseNumberEditing = false;
                    // Agregar un log para verificar el JSON
        // console.log("JSON de la comunicación seleccionada:", vm.complaintSelected);
         if (resp.users && resp.users.length > 0) {
                    resp.users.forEach(function(userId) {
                        // console.log('Fetching details for user ID:', userId);
    
                        usersService.getUser({ id: userId, owner: $scope.owner })
                        .then(function (userResp) {
                            // console.log('User Details Response:', userResp);
                            vm.userDetails[userId] = userResp;
                        })
                        .catch(function (error) {
                            // console.error('Error fetching user details:', error);
                        });
                    });
                }
                if (resp.blocked_users && resp.blocked_users.length > 0) {
                    resp.blocked_users.forEach(function(userId) {
                        usersService.getUser({ id: userId, owner: $scope.owner })
                        .then(function (userResp) {
                            vm.userDetails[userId] = userResp;
                        })
                        .catch(function (error) {
                            // console.error('Error fetching blocked user details:', error);
                        });
                    });
                }
                    if (resp.form) {
                        vm.extraFields = resp.form.fields.filter(x => {
                            return x.key && x.key.indexOf('extra_') == 0 && x.key !== 'extra_checkboxpolicy' && x.key !== 'extra_checkboxcomplaint';
                        });
                        if (vm.complaintSelected.extra) {
                            vm.extraFields = vm.extraFields.map(x => {
                                x.value = vm.complaintSelected.extra[x.key.split('extra_')[1]];
                                if (Array.isArray(x.value)) {
                                    let result = '';
                                    x.value.forEach(element => {
                                        result += ', ' + element;
                                    });
                                    x.value = result.slice(2, result.length);
                                }
                                return x;
                            })
                        }
                    }
                    vm.viewEditData();

                    vm.loadingReadPane = false;
                })

                $scope.editingEnabled = false;
        }
        vm.openAnalyzeDialog = function (ev) {
            $mdDialog.show({
                controller: 'AnalyzeDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/complaints/dialogs/analyze-dialog/analyze-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                locals: {
                    complaint: vm.complaintSelected // Pasar los datos de la queja seleccionada
                }
            }).then(result => {
                if (result) {
                    vm.analyzeCommunication(result); // Llama a la función de análisis con los datos procesados
                }
            });
        };

        //  Alternative Exclude
    //     function filterCommunicationJson(communicationJson) {
    //        const excludedFields = [
    //            "hash",
    //            "company_id",
    //            "form",
    //            "files",
    //            "actions",
    //            "updated_at",
    //            "users"
    //        ];
        
    //        return Object.keys(communicationJson)
    //            .filter(key => !excludedFields.includes(key))
    //            .reduce((obj, key) => {
    //                obj[key] = communicationJson[key];
    //                return obj;
    //            }, {});
    //    } 

       function filterCommunicationJson(communicationJson) {
           const allowedFields = [
               "id",
               "subject",
               "description",
               "anonymous_complaint",
               "complaint_type",
               "created_at",
               "priority"
           ];
        
           return Object.keys(communicationJson)
               .filter(key => allowedFields.includes(key))
               .reduce((obj, key) => {
                   obj[key] = communicationJson[key];
                   return obj;
               }, {});
       }

       vm.analyzeCommunication = function (communicationJson) {
           if (!communicationJson) {
               console.error("No se encontró ninguna comunicación seleccionada.");
               return;
           }
       
           const filteredJson = filterCommunicationJson(communicationJson);
       
           $http.post(
               'https://s7nqx6kx1e.execute-api.us-east-1.amazonaws.com/dev/send-json',
               filteredJson,
               {
                   headers: {
                       'Content-Type': 'application/json'
                   }
               }
           )
           .then(response => {
               alert("JSON enviado exitosamente. Ver consola para más detalles.");
           })
           .catch(error => {
               console.error("Error al enviar el JSON:", error);
               alert("Ocurrió un error al enviar el JSON.");
           });
       };

$scope.confirmAnonymised = function(ev) {
  if (vm.complaintSelected.anonymised === 1) {
    const message = $translate.instant('GLOBAL.ARE_YOU_SURE');
    const yes = $translate.instant('GLOBAL.YES');
    const no = $translate.instant('GLOBAL.NO');
    const description = $translate.instant('GLOBAL.MESSAGE_ANONYMISED'); // description message

    const confirm = $mdDialog.confirm()
      .title(message)
      .textContent(description) //  here you add the description message
      .targetEvent(ev)
      .ok(yes)
      .cancel(no);

    $mdDialog.show(confirm).then(function() {
      // Action to be taken if anonymisation is confirmed
      vm.complaintSelected.anonymised = 1;
      $scope.isButtonDisabled = true;
    }, function() {
      // Action to be taken if anonymisation is cancelled
      vm.complaintSelected.anonymised = 0;
    });
  } else {
    // Action to be taken if the checkbox is unchecked
    vm.complaintSelected.anonymised = 0;
  }
};
$scope.$watch('vm.complaintSelected.complaint_type', function(newValue, oldValue) {
    // console.log('complaint_type changed:', newValue);
});

$scope.$watch('vm.complaintSelected.hash', function(newValue, oldValue) {
    // console.log('hash changed:', newValue);
});




        function calculateHeightChat() {
            return window.innerHeight - 358;
        }

        function setTOOptions(field) {
            if (field.type == 'dropzone') {
                field.templateOptions.options = {
                    url: '/',
                    maxFilesize: 5,
                    method: 'PUT',
                    paramName: '',
                    maxThumbnailFilesize: 5,
                    autoProcessQueue: false,
                    maxFiles: 1,
                    acceptedFiles: '.doc,.docx,.pdf,.ogg,.mp3',
                    uploadMultiple: false,
                    thumbnailMethod: 'contain',
                    thumbnailWidth: 300,
                    thumbnailHeight: 300,
                    previewTemplate: "<div class=\"dz-preview dz-file-preview dz-processing dz-success dz-complete\"><div class=\"dz-image\"><img data-dz-thumbnail /></div><div class=\"dz-details\"><div class=\"dz-filename\"><span data-dz-name></span></div><div class=\"dz-size\"><span data-dz-size></span></div><button data-dz-remove class=\"btn btn-danger delete\"><i class=\"ion-md-close\" aria-hidden=\"true\"></i></button></div><div class=\"dz-progress\"><span class=\"dz-upload\" data-dz-uploadprogress></span></div><div class=\"dz-error-message\"><span data-dz-errormessage></span></div></div>",
                    dictFileTooBig: "El archivo es más grande que el máximo permitido ({{maxFilesize}}MB)",
                    dictInvalidFileType: "Este tipo de archivo no está permitido."
                }
            } else {
                field.templateOptions.options = [];
            }
        }

        function editFieldStructure(index) {
            closeOthers();
            vm.copyStructure = angular.copy(vm.complaintFormDefault.fields[index]);
            vm.complaintFormDefault.fields[index].editing = true;
        }
        function closeOthers() {
            fieldsTemplateForms.closeOthers(vm.complaintFormDefault.fields);
        }

        function saveFieldStructure(index) {
            fieldsTemplateForms.saveFieldStructure(index, vm.complaintFormDefault.fields);
        }

        function cancelEditFieldStructure(index) {
            fieldsTemplateForms.cancelEditFieldStructure(index, vm.complaintFormDefault.fields, vm.copyStructure);
        }

        function removeFieldStructure(index) {
            fieldsTemplateForms.removeFieldStructure(index, vm.complaintFormDefault.fields, vm.noexistchangues);
        }
        function hideFieldStructure(index) {
            fieldsTemplateForms.hideFieldStructure(index, vm.complaintFormDefault.fields, vm.noexistchangues);
        }
        function showFieldStructure(index) {
            fieldsTemplateForms.showFieldStructure(index, vm.complaintFormDefault.fields, vm.noexistchangues);
        }
        function addNewStructureField() {
            fieldsTemplateForms.addNewStructureField(vm.complaintFormDefault.fields);
        }



        function openOptionsDialog(ev, index, title, arrayName) {
            $mdDialog.show({
                controller: 'OptionsController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/complaints/dialogs/init-form-complaint/options-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                locals: {
                    Index: index,
                    Title: title,
                    ArrayName: arrayName,
                    complaintPlan: vm.complaintPlan,
                    idCompany: vm.companySelected.id,
                    Field: vm.complaintFormDefault.fields[index],
                    Fields: vm.complaintFormDefault.fields,
                    event: ev
                }
            }).then(res => {
                if (res) {
                    vm.complaintFormDefault.fields[index].templateOptions.options = res;
                    if (vm.complaintFormDefault.fields[index].templateOptions.selecttypecomplaint) {
                        vm.complaintFormDefault.form_types = angular.copy(res);
                        if (vm.complaintCanal) {
                            vm.complaintCanal.form_types = angular.copy(res);
                        }
                    }
                }
                //console.log(vm.complaintFormDefault);
            });
        }
        function openOptionsComplaint(ev) {
        if (!Array.isArray(vm.complaintSelected.blocked_users)) {
            vm.complaintSelected.blocked_users = [];
        }
        $mdDialog.show({
        controller: DialogController,
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/complaints/dialogs/new-complaint-dialog/open-options-complaint.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        bindToController: true,
        locals: {
            companySelected: vm.companySelected,
            complaintSelected: vm.complaintSelected,
            complaintPlan: vm.complaintPlan,
            openDialogUsers: vm.openDialogUsers,
            openDialogBlockedUsers: vm.openDialogBlockedUsers,
            userImages: vm.userImages,
            showUserImage: vm.showUserImage,
            userDetails: vm.userDetails,
            userLogued: vm.userLogued,
        }
    }).then(function(dataFromDialog) {
        if (typeof dataFromDialog !== 'undefined') {
            saveComplaint(dataFromDialog);
        }
    }, function() {
    });
}
vm.removeUser = function(user) {
    var index = vm.complaintSelected.users.indexOf(user);
    if (index !== -1) {
        vm.complaintSelected.users.splice(index, 1);
    }
};
vm.getRandomColor = function() {
    var r = Math.floor(Math.random() * 256);
    var g = Math.floor(Math.random() * 256);
    var b = Math.floor(Math.random() * 256);
    return 'rgb(' + r + ',' + g + ',' + b + ')';
}
function showUserImage(userId) {
    if (!vm.userDetails[userId]) {
        return null;
    }
    if (!vm.userDetails[userId].color) {
        vm.userDetails[userId].color = vm.getRandomColor();
    }
    if (vm.userDetails[userId].files && vm.userDetails[userId].files.url) {
        return $scope.storagePrefix + vm.userDetails[userId].files.url;
    }
    return null;
}

function getActionUser(action) {
    if (!action) {
        return null;
    }
    if (action.user) {
        return action.user;
    }
    var candidateIds = [action.user_id, action.created_by, action.created_by_user_id, action.staff_id];
    for (var i = 0; i < candidateIds.length; i++) {
        var userId = candidateIds[i];
        if (userId && vm.userDetails[userId]) {
            return vm.userDetails[userId];
        }
        if (userId && vm.userLogued && userId === vm.userLogued.id) {
            return vm.userLogued;
        }
    }
    return null;
}

function getActionUserImage(action) {
    var user = getActionUser(action);
    if (!user || !user.files || !user.files.url) {
        return null;
    }
    if (user.files.url.indexOf('http') === 0) {
        return user.files.url;
    }
    return $scope.storagePrefix + user.files.url;
}

function getActionUserName(action) {
    var user = getActionUser(action);
    if (user) {
        return ((user.first_name || '') + ' ' + (user.last_name || '')).trim() || user.name || '';
    }
    return action && (action.user_name || action.created_by_name) ? (action.user_name || action.created_by_name) : '';
}

function getActionUserInitial(action) {
    var user = getActionUser(action);
    var source = '';
    if (user) {
        source = user.first_name || user.name || '';
    } else if (action) {
        source = action.user_name || action.created_by_name || '';
    }
    return source ? source.charAt(0).toUpperCase() : '?';
}
function openDialogUsers(ev, option) {
    if (!Array.isArray(option.users)) {
        option.users = [];
    }
    let alreadySelectedUsers = option.users.map(userId => ({
        id: userId,
        idCompany: vm.companySelected.id,
        email: vm.userDetails[userId] ? vm.userDetails[userId].email : '',
        first_name: vm.userDetails[userId] ? vm.userDetails[userId].first_name : '',
        files: {
            url: vm.userDetails[userId] && vm.userDetails[userId].files ? vm.userDetails[userId].files.url : null
        }
    }));
        $mdDialog.show({
            controller: 'SelectUserDialog',
            controllerAs: 'vm',
            templateUrl: 'app/main/apps/complaints/dialogs/select-user-dialog/select-user-dialog.html',
            parent: angular.element($document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            multiple: true,
                locals: {
                    alreadySelected: alreadySelectedUsers,
                    idCompany: vm.companySelected.id
                }
            }).then(res => {
                if (res) {
                    if (!option.users.includes(res.id)) {
                        option.users.push(res.id);
                        vm.userDetails[res.id] = res;
                    } else {
                    }
                }
            });
}
function openDialogBlockedUsers(ev, option) {
    if (!Array.isArray(option.blocked_users)) {
        option.blocked_users = [];
    }
    var alreadySelectedBlocked = option.blocked_users.map(function(userId) {
        return {
            id: userId,
            idCompany: vm.companySelected.id,
            email: vm.userDetails[userId] ? vm.userDetails[userId].email : '',
            first_name: vm.userDetails[userId] ? vm.userDetails[userId].first_name : '',
            files: {
                url: vm.userDetails[userId] && vm.userDetails[userId].files ? vm.userDetails[userId].files.url : null
            }
        };
    });
    $mdDialog.show({
        controller: 'SelectUserDialog',
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/complaints/dialogs/select-user-dialog/select-user-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        multiple: true,
        locals: {
            alreadySelected: alreadySelectedBlocked,
            idCompany: vm.companySelected.id
        }
    }).then(function(res) {
        if (res && !option.blocked_users.includes(res.id)) {
            option.blocked_users.push(res.id);
            vm.userDetails[res.id] = res;
        }
    });
}

        function openValidationsDialog(ev, index) {
            $mdDialog.show({
                controller: 'ValidationsController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/complaints/dialogs/init-form-complaint/validations-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                locals: {
                    Index: index,
                    Field: vm.complaintFormDefault.fields[index],
                    Fields: vm.complaintFormDefault.fields,
                    event: ev
                }
            });
        }


        function openModalEmbedCode($event) {
            $mdDialog.show({
                controller: function ($timeout, $q, $scope, $mdDialog, tinyMceService, canal, url) {
                    var vm = this;
                    vm.canal = canal
                    vm.url = url
                    vm.text = '<iframe allowtransparency="true" style="background-color: transparent;"  name="form-complaint" src="' + vm.url.replace('%filename%', vm.canal.filename) + '" frameborder="0" border="0" width="100%" height="2300"></iframe>';
                    vm.closeDialog = function () {
                        $mdDialog.hide();
                    }
                },
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/complaints/dialogs/embed-code-dialog/embed-code-dialog.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    canal: vm.complaintCanal,
                    url: vm.urlForm,
                },
            })
                .then(function () { });

        }
        function openModalSelectLang($event) {
    $mdDialog.show({
        controller: function ($timeout, $q, $scope, $mdDialog, tinyMceService, canal, url) {
            var vm = this;
            vm.canal = canal
            vm.url = url
            vm.text = 'Aquí va el contenido o configuración específica para la funcionalidad de seleccionar idioma.';
            vm.closeDialog = function () {
                $mdDialog.hide();
            }
        },
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/complaints/dialogs/embed-code-dialog/embed-code-dialog.html',
        parent: angular.element(document.body),
        targetEvent: $event,
        clickOutsideToClose: true,
        locals: {
            canal: vm.complaintCanal,
            url: vm.urlForm,
        },
    })
    .then(function () { });
}

        function getFormUrl(filename) {
            return vm.urlForm.replace('%filename%', filename);
        }

        function getFormUrlNew(filename) {
            return 'https://' + filename + '.canal.h2c.app/new-form.html';
        }
        function newAction($event) {
            var action = {
                action: '',
                complaint_id: vm.complaintSelected.id,
                id: null
            };
            $mdDialog.show({
                controller: function ($timeout, $q, $scope, $mdDialog, tinyMceService, action, storagePrefix) {
                    var vm = this;
                    vm.actionData = {
                        action: action,
                        files: []
                    };
                    vm.tinymceOptions = tinyMceService.getOptions($scope);
                    vm.tinymceOptions.height = 250;
                    vm.tinymceOptions.min_height = 250;
                    vm.tinymceOptions.resize = false;
                    vm.tinymceOptions.plugins = [];
                    vm.tinymceOptions.toolbar1 = 'bold italic backcolor | alignleft aligncenter ' +
                        'alignright alignjustify | bullist numlist outdent indent | ' +
                        'removeformat | help';
                    vm.storagePrefix = storagePrefix;
                    vm.closeDialog = function () {
                        $mdDialog.hide();
                    }
                    vm.save = function () {
                        $mdDialog.hide(vm.actionData);
                    };
                },
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/complaints/dialogs/action-dialog.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    action: action,
                    storagePrefix: $scope.storagePrefix
                },
            })
                .then(function (newData) {
                    if (newData) {
                        vm.savinAction = true;
                        vm.actionData = newData.action;
                        vm.files = newData.files;
                        vm.saveAction();
                    }
                });

        }




        function saveAction() {
            vm.loadingReadPane = true;
            complaintsService.createComplaintAction({
                owner: $scope.owner,
                item: vm.actionData
            }).then(function (res) {
                vm.filesUploaded = 0;
                for (var i = 0; i < vm.files.length; i++) {
                    const f = vm.files[i];
                    vm.uploadFile(f, res.id, vm.files.length)
                }
                if (vm.files.length == 0) {
                    vm.openComplaint(vm.complaintSelected.id);
                }
            })
        }



        function uploadFile(file, idValue, numFiles) {
            if (!file.$error) {
                file.finished = false;
                var token = undefined;
                complaintsService.getS3UploadPreSignedUrl({
                    owner: $scope.owner,
                    uploadKey: 'complaints_actions',
                    fileName: file.name,
                    rowId: idValue
                })
                    .then(function (resp) {
                        token = resp.token;
                        file.upload = Upload.http({
                            url: resp.url,
                            skipAuthorization: true,
                            method: 'PUT',
                            headers: {
                                "Content-Type": file.type != '' ? file.type : 'application/octet-stream'
                            },
                            data: file
                        })
                        file.upload.then(function (response) {
                            file.result = response.data;
                            $timeout(function () {
                                $scope.log = 'file: ' +
                                    file.name +
                                    ', Response: ' + JSON.stringify(response.data) +
                                    '\n' + $scope.log;
                            });
                            complaintsService.finishedUploadingFile({
                                owner: $scope.owner,
                                token: token
                            }).then(function (response) {
                                file.finished = true;
                                vm.filesUploaded++;
                                if (vm.filesUploaded == numFiles) {
                                    vm.openComplaint(vm.complaintSelected.id);
                                }
                            })
                        }, function (response) {
                            if (response.status > 0)
                                $scope.errorMsg = response.status + ': ' + response.data;
                        });

                        file.upload.progress(function (evt) {
                            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                        });
                    })
            }
        };

        function openForm(form) {
            vm.formTab = 'edit';
            vm.complaintCanal = angular.copy(form);
            vm.showFormDetailMobile = true;
            vm.embed = '<iframe allowtransparency="true" style="background-color: transparent;"  name="form-complaint" allow="microphone" src="' + vm.getFormUrl(vm.complaintCanal.filename) + '" frameborder="0" border="0" width="100%" height="2300"></iframe>'
            vm.embednew = '<iframe allowtransparency="true" style="background-color: transparent;" name="form-complaint" allow="microphone" src="' + vm.getFormUrlNew(vm.complaintCanal.filename) + '" frameborder="0" border="0" width="100%" height="2300"></iframe>'
            editComplaintCanal();
        }

        function closeFormDetail() {
            vm.showFormDetailMobile = false;
        }

        function selectForm(form) {
            vm.formSelected = form;
            vm.formTypeSelected = null;
            $scope.isLoading = true;
            loadComplaint(vm.companySelected.id);
        }
        function selectFormType(form, formType) {
            vm.formSelected = form;
            vm.formTypeSelected = formType;
            $scope.isLoading = true;
            loadComplaint(vm.companySelected.id);
        }

        vm.nextPage = function () {
            if ($rootScope.pagination_page == $rootScope.pagination_total_pages) {
                return;
            }
            $rootScope.pagination_page++;
            loadComplaint(vm.companySelected.id);
        }
        vm.prevPage = function () {
            if ($rootScope.pagination_page == 1) {
                return;
            }
            $rootScope.pagination_page--;
            loadComplaint(vm.companySelected.id);
        }
        vm.selectStatus = function(status) {
            vm.selectedStatus = status;
            $rootScope.pagination_page = 1;
            loadComplaint(vm.companySelected.id)
        }

        function loadComplaint(idCompany, perPage) {
            // $scope.isLoadingCanal = true;
            if ($rootScope.permissionsComplaints != null) {
                Promise.all([
                    complaintsService.getCanal({ owner: $scope.owner, id: idCompany }),
                    complaintsService.getComplaintSettings({ owner: $scope.owner, id: idCompany }),
                    complaintsService.get({ owner: $scope.owner, company_id: idCompany, form: vm.formSelected, formType: vm.formTypeSelected, page: vm.selectedStatus ? 1 : $rootScope.pagination_page, resultsPerPage: vm.selectedStatus ? 10000 : perPage })
                ]).then(function (res) {
                    vm.complaints = res[2].data;
                    if (res[1].data.length > 0) {
                        vm.complaintPlan = res[1].data[0];
                    }
                    if (vm.selectedStatus) {
                        complaintsService.get({ owner: $scope.owner, company_id: idCompany, form: vm.formSelected, formType: vm.formTypeSelected, resultsPerPage: 10000})
                            .then(function(res) {
                                vm.complaints = res.data.filter(function(complaint) {
                                    return complaint.status === vm.selectedStatus.id;
                                });
                                $rootScope.pagination_totalItems = vm.complaints.length;
                                $rootScope.pagination_total_pages = 1;
                                $rootScope.pagination_page = 1;
                            });
                    }
                    processComplaintCanalData(res);
                })
            } else {
                setTimeout(() => {
                    loadComplaint(idCompany)
                }, 200);
            }
        }

        vm.isUserAssigned = function(complaint) {
    //console.log("Assigned users: ", complaint.users);
    //console.log("Current user ID: ", vm.userLogued.id);
    //console.log("Current user type: ", vm.userLogued.user_type);


    if (vm.userLogued.user_type == 1 || vm.userLogued.user_type == 2) {
        return true;
    } else if (vm.userLogued.user_type > 2 && complaint.users && complaint.users.includes(vm.userLogued.id)) {
        return true;
    } else {
        return false;
    }
};


        function processComplaintCanalData(res) {
            vm.complaintCanal = fieldsTemplateForms.DTOtoStructuredField(res[0].data[0]);
            vm.showFormDetailMobile = false;
            $rootScope.pagination_totalItems_forms = res[0].total;
            $rootScope.pagination_total_pages_forms = res[0].last_page;
            $rootScope.pagination_page_forms = res[0].current_page;
            $rootScope.pagination_totalItems = res[2].total;
            $rootScope.pagination_total_pages = res[2].last_page;
            $rootScope.pagination_page = res[2].current_page;
            complaintsService.getFormTypes({ owner: $scope.owner, company_id: vm.companySelected.id }).then(types => {
                vm.complaintFormTypes = types.data;
                vm.complaintForms = res[0].data.map(x => fieldsTemplateForms.DTOtoStructuredField(x));
                var formFilters = ($rootScope.permissionsComplaints && angular.isArray($rootScope.permissionsComplaints)) ? $rootScope.permissionsComplaints.filter(x => x.field === "form_id") : null;
                if (!formFilters) {
                    vm.complaintFormsFiltered = vm.complaintForms.filter(x => {
                        x.subfilter = vm.complaintFormTypes.filter(ct => ct.form_id === x.id);
                        return true;
                    })
                } else {
                    vm.complaintFormsFiltered = vm.complaintForms.filter(x => {
                        const found = formFilters.find(y => {
                            return y.value == x.id;
                        });
                        if (!formFilters || formFilters.length == 0 || found) {
                            if (found) {
                                x.subfilter = vm.complaintFormTypes.filter(x => (x.form_id == found.value && found.subfilter.find(y => y.value === x.complaint_type_id)))
                            } else {
                                x.subfilter = vm.complaintFormTypes.filter(ct => ct.form_id === x.id);
                            }
                            return true;
                        }
                        return false;
                    });
                }
                //console.log(vm.complaintFormsFiltered);
                $scope.isLoadingCanal = false;
                $scope.isLoading = false;
            });
        }

        function getComplaintFormTypeNameById(complaint) {
            if (vm.complaintFormTypes) {
                const result = vm.complaintFormTypes.find(x => x.form_id == complaint.form_id && x.complaint_type_id == complaint.complaint_type);
                if (result) {
                    return result.name;
                } else {
                    return '';
                }
            }
            return '';
        }

        function selectLanguageComplaintCanal() {
            vm.showLanguageSelectorComplaintCanal = true;
        }

        function startComplaintCanal(callback) {
            vm.showLanguageSelectorComplaintCanal = false;
            vm.showFormStartComplaintCanal = true;

            var selectedOption = vm.complaintLanguagesWithPredetermined ? 
                vm.complaintLanguagesWithPredetermined.find(opt => opt.value === vm.complaintCanalLang) : null;
            
            if (selectedOption && selectedOption.isPredetermined) {

                vm.complaintFormDefault = angular.copy(selectedOption.formData);
                
                if (!vm.complaintFormDefault.config) {
                    vm.complaintFormDefault.config = {};
                }
                if (!vm.complaintFormDefault.fields) {
                    vm.complaintFormDefault.fields = [];
                }
                if (!vm.complaintFormDefault.form_types) {
                    vm.complaintFormDefault.form_types = [];
                }
                
                if (vm.complaintFormDefault.fields && vm.complaintFormDefault.fields.length > 0) {
                    var complaintTypeField = vm.complaintFormDefault.fields.find(function(field) {
                        return field.key === 'complaint_type';
                    });
                    
                    if (complaintTypeField && complaintTypeField.templateOptions && complaintTypeField.templateOptions.options) {

                    
                        vm.complaintFormDefault.form_types = complaintTypeField.templateOptions.options.map(function(option) {
                            return {
                                value: option.value,
                                name: option.name,
                                users: []
                            };
                        });
                        

                    }
                }
                
                
                if (vm.complaintFormDefault.form_types && vm.complaintFormDefault.form_types.length > 0) {
                    vm.complaintFormDefault.form_types = vm.complaintFormDefault.form_types.map(function(formType) {

                        return {
                            value: formType.value || formType.complaint_type_id,
                            name: formType.name,
                            users: Array.isArray(formType.users) ? formType.users : []
                        };
                    });

                }
                
                delete vm.complaintFormDefault.id;       
                delete vm.complaintFormDefault.target_url;
                delete vm.complaintFormDefault.filename;
                
                if (vm.complaintFormDefault.config && vm.complaintFormDefault.config.languages) {
                    Object.keys(vm.complaintFormDefault.config.languages).forEach(function(langKey) {
                        if (vm.complaintFormDefault.config.languages[langKey]) {
                            vm.complaintFormDefault.config.languages[langKey].url = null;
                            vm.complaintFormDefault.config.languages[langKey].filename = null;
                        }
                    });

                }
                
                let zones = dragulaService.find($scope, 'dragbag');
                if (zones) {
                    dragulaService.destroy($scope, 'dragbag');
                }
                dragulaService.options($scope, 'dragbag', {
                    copy: false,
                    copySortSource: false,
                    removeOnSpill: false,
                    direction: 'vertical',
                    moves: function (el, source, handle) {
                        var result = handle.classList.contains('drag');
                        return result;
                    },
                    invalid: function (el, handle) {
                        return false;
                    }
                });
                if (callback) {
                    callback()
                }
            } else {
                complaintsService.getFormCustom(vm.complaintCanalLang ? vm.complaintCanalLang : vm.complaintCanal.language_code, vm.companySelected.name, vm.userLogued.email).then(res => {
                    vm.complaintFormDefault = res;
                    let zones = dragulaService.find($scope, 'dragbag');
                    if (zones) {
                        dragulaService.destroy($scope, 'dragbag');
                    }
                    dragulaService.options($scope, 'dragbag', {
                        copy: false,
                        copySortSource: false,
                        removeOnSpill: false,
                        direction: 'vertical',
                        moves: function (el, source, handle) {
                            var result = handle.classList.contains('drag');
                            return result;
                        },
                        invalid: function (el, handle) {
                            return false;
                        }
                    });
                    if (callback) {
                        callback()
                    }
                });
            }
        }

        function mapFormTypes(x) {
            if (x.users.length > 0 && x.users[0].id) {
                x.users = x.users.map(y => y.id)
            }
            return {
                value: x.value ? x.value : x.complaint_type_id,
                name: x.name,
                users: x.users
            };
        }

        function finishInitComplaintForm() {
            if (vm.complaintFormDefault.config) {
                ensureAllLanguagesExist(vm.complaintFormDefault.config, vm.complaintFormDefault.language_code);
            }
            
            vm.complaintFormDefault.fields = fieldsTemplateForms.toDTOStructureField(vm.complaintFormDefault.fields, vm.complaintFormDefault.config);
            vm.complaintFormDefault.form_types = vm.complaintFormDefault.form_types.map(mapFormTypes);
 
            if (!Array.isArray(vm.complaintFormDefault.recipients)) {
                vm.complaintFormDefault.recipients = [];
            }

            const name = vm.complaintFormDefault.name ? vm.complaintFormDefault.name : vm.companySelected.name;
            complaintsService.createComplaintCanal({
                owner: $scope.owner,
                name: name,
                form: vm.complaintFormDefault,
                target_url: vm.complaintFormDefault.target_url ? vm.complaintFormDefault.target_url : vm.urlForm,
                id: vm.companySelected.id
            }).then(function (response) {
                vm.complaintCanal = fieldsTemplateForms.DTOtoStructuredField(response);
                $scope.isLoadingCanal = true;
                loadComplaint(vm.companySelected.id)
                vm.showFormStartComplaintCanal = false;
                vm.showLanguageSelectorComplaintCanal = false;
            })
        }
        $scope.startsWithLanguage = function(item){
            var languages = ['en', 'es', 'pt', 'ca', 'de', 'eu', 'fr', 'gl', 'it'];
            return languages.some(lang => item.language_code.startsWith(lang));
        };
        
        $scope.selectLangForm = function(filename, idioma) {
            
            if (filename) {
                $scope.vm.complaintFormDefault.config.languages[idioma].filename = filename;
                $scope.vm.complaintFormDefault.config.languages[idioma].url = "https://" + filename + ".canal.h2c.app/new-form.html";
            } else {
                $scope.vm.complaintFormDefault.config.languages[idioma].filename = null;
                $scope.vm.complaintFormDefault.config.languages[idioma].url = "";
            }
        };
        function ensureAllLanguagesExist(config, languageCode) {
            // Only run if the language is Spanish
            if (!languageCode || !languageCode.startsWith('es')) {
                return;
            }
            
            if (!config.languages) {
                config.languages = {};
            }
            
            var requiredLanguages = {
                german: { url: "", filename: "", language: "LANG_DE" },
                english: { url: "", filename: "", language: "LANG_EN" },
                catalan: { url: "", filename: "", language: "LANG_CA" },
                portuguese: { url: "", filename: "", language: "LANG_PT" },
                spanish: { url: "", filename: "", language: "LANG_ES" },
                euskera: { url: "", filename: "", language: "LANG_EU" },
                france: { url: "", filename: "", language: "LANG_FR" },
                gallego: { url: "", filename: "", language: "LANG_GL" },
                italy: { url: "", filename: "", language: "LANG_IT" }
            };
            
            angular.forEach(requiredLanguages, function(value, key) {
                if (!config.languages[key]) {
                    config.languages[key] = value;
                }
            });
        }

        function editComplaintCanal() {
            vm.editingComplaintForm = true;
            startComplaintCanal(function () {
                vm.complaintFormDefault.name = vm.complaintCanal.name;
                vm.complaintFormDefault.config = vm.complaintCanal.config || {};
                
                ensureAllLanguagesExist(vm.complaintFormDefault.config, vm.complaintCanal.language_code);
                
                if (vm.complaintCanal.language_code.startsWith("es")) {
                    vm.complaintFormDefault.config.languages.spanish.url = `https://${vm.complaintCanal.filename}.canal.h2c.app/new-form.html`;
                    vm.complaintFormDefault.config.languages.spanish.filename = `${vm.complaintCanal.filename}`;
                }

                vm.complaintFormDefault.target_url = vm.complaintCanal.target_url;
                vm.complaintFormDefault.id = vm.complaintCanal.id;
                vm.complaintFormDefault.fields = vm.complaintCanal.fields;
                vm.complaintFormDefault.config.buttonColor = vm.complaintFormDefault.config.buttonColor || '#039BE5';
                vm.complaintFormDefault.config.textColor = vm.complaintFormDefault.config.textColor || '#333333';
                vm.complaintFormDefault.form_types = vm.complaintCanal.form_types.map(mapFormTypes);
                setTimeout(() => {
                    let zones = dragulaService.find($scope, 'dragbag');
                    if (zones) {
                        dragulaService.destroy($scope, 'dragbag');
                    }
                    dragulaService.options($scope, 'dragbag', {
                        copy: false,
                        copySortSource: false,
                        removeOnSpill: false,
                        direction: 'vertical',
                        moves: function (el, source, handle) {
                            var result = handle.classList.contains('drag');
                            console.log("moves")
                            return result;
                        },
                        invalid: function (el, handle) {
                            return !handle.classList.contains('drag'); // don't prevent any drags from initiating by default
                        }
                    });
                }, 10000);
            });

        }

        function updateComplaintCanal() {
            if (vm.complaintFormDefault.config) {
                ensureAllLanguagesExist(vm.complaintFormDefault.config, vm.complaintFormDefault.language_code);
            }
            
            complaintsService.updateComplaintCanal({
                owner: $scope.owner,
                name: vm.complaintFormDefault.name,
                target_url: vm.complaintFormDefault.target_url ? vm.complaintFormDefault.target_url : vm.urlForm,
                id: vm.complaintFormDefault.id,
                config: vm.complaintFormDefault.config,
                form_types: vm.complaintFormDefault.form_types.map(mapFormTypes),
                fields: fieldsTemplateForms.toDTOStructureField(vm.complaintFormDefault.fields, vm.complaintFormDefault.config)
            }).then(function (response) {
                vm.complaintCanal = fieldsTemplateForms.DTOtoStructuredField(response);
                vm.showFormStartComplaintCanal = false;
                vm.showLanguageSelectorComplaintCanal = false;
                vm.editingComplaintForm = false;
                $scope.isLoadingCanal = true;
                loadComplaint(vm.companySelected.id)
            })
        }

        function closeComplaint() {
            vm.editingComplaintForm = false;
            vm.showLanguageSelectorComplaintCanal = false;
            vm.showFormStartComplaintCanal = false;
            vm.complaintSelected = undefined;
            vm.complaintNew = undefined;
        }

        function newComplaintForm(ev) {
            if (vm.complaintPlan.max_allowed_forms <= vm.complaintForms.length) {
                let quota = {};
                quota = vm.complaintPlan;
                quota.forms_registered = vm.complaintForms.length
                $mdDialog.show({
                    controller: 'UserQuotaDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/dialogs/userQuotaDialog/userQuotaDialogForms.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        user: vm.userLogued,
                        quotaComplaint: quota
                    }
                }).then(function (res) {
                    if (res && res.type) {
                        if (res.type == 'upgrade') {
    
                        }
                    }
                });
                return;
            }
            
            var hasPredetermined = vm.complaintForms && vm.complaintForms.some(function(form) {
                return form.is_predetermined;
            });
            
            var getDefaultFormsCall = hasPredetermined ? 
                complaintsService.getDefaultForms() : 
                complaintsService.getDefaultForms(vm.companySelected.id);
                
            getDefaultFormsCall.then(function(predetermined) {
                var optionsPredetermined = [];
                if (predetermined && predetermined.length > 0) {
                    predetermined.forEach(function(form) {
                        optionsPredetermined.push({
                            value: 'predetermined_' + form.id,
                            name: form.name,
                            isPredetermined: true,
                            formData: form
                        });
                    });
                }
                vm.complaintLanguagesWithPredetermined = vm.complaintLanguages.concat(optionsPredetermined);
                
                vm.formTab = 'edit';
                vm.selectLanguageComplaintCanal();
            });
        }
        function newComplaint(ev) {
            var hasPredetermined = vm.complaintForms && vm.complaintForms.some(function(form) {
                return form.is_predetermined;
            });
            
            var getDefaultFormsCall = hasPredetermined ? 
                complaintsService.getDefaultForms() : 
                complaintsService.getDefaultForms(vm.companySelected.id);
                
            getDefaultFormsCall.then(function(predetermined) {
                var formsMap = {};
                (vm.complaintFormsFiltered || []).forEach(function(f) { formsMap[f.id] = f; });
                (predetermined || []).forEach(function(f) { formsMap[f.id] = f; });
                var formsForDialog = Object.values(formsMap);
            $mdDialog.show({
                controller: 'NewComplaintDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/complaints/dialogs/new-complaint-dialog/new-complaint-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                locals: {
                    forms: formsForDialog,
                }
            }).then(res => {
                if (res) {
                    $scope.isLoadingCanal = true;
                    loadComplaint(vm.companySelected.id)
                }
            });
            });
        }

        function newReport(ev) {
           $mdDialog.show({
               controller: 'NewReportDialogController',
               controllerAs: 'vm',
               templateUrl: 'app/main/apps/complaints/dialogs/new-report-dialog/new-report-dialog.html',
               parent: angular.element($document.body),
               targetEvent: ev,
               locals: {
                   forms: vm.complaintFormsFiltered,
                   companySelected: vm.companySelected,
                   owner: $scope.owner,
                   complaint: vm.complaintSelected 
               }
           }).then(res => {
               if (res) {
                   $scope.isLoadingCanal = true;
                   loadComplaint(vm.companySelected.id)
               }
           });
        }

        function saveComplaint() {
            vm.loadingReadPane = true;
            // Ensure that all extraFields are correctly assigned.
            if (vm.extraFields && vm.complaintSelected.extra) {
                vm.extraFields.forEach(field => {
                    if (Array.isArray(vm.complaintSelected.extra[field.key.split('extra_')[1]])) {
                        vm.complaintSelected.extra[field.key.split('extra_')[1]] = field.value.split(', ');
                    } else {
                        vm.complaintSelected.extra[field.key.split('extra_')[1]] = field.value;
                    }
                });
            }
            var options = {
                owner: $scope.owner,
                item: vm.complaintSelected,
                id: vm.complaintSelected.id
            };
            complaintsService.updateComplaint(options).then(function (response) {
                vm.loadingReadPane = false;
                $scope.isLoadingCanal = true;
                loadComplaint(vm.companySelected.id);
            });
        }

        function deleteForm(ev) {
            const message = $translate.instant('GLOBAL.ARE_YOU_SURE');
            const yes = $translate.instant('GLOBAL.YES');
            const no = $translate.instant('GLOBAL.NO');
            const description = $translate.instant('GLOBAL.MESSAGE_DELETEFORM')

            const confirm = $mdDialog.confirm()
                .title(message)
                .textContent(description)
                .targetEvent(ev)
                .ok(yes)
                .cancel(no);

            $mdDialog.show(confirm).then(e => {

                var threads = angular.copy(vm.selectedThreads);
                vm.selectedThreads = [];
                var count = 0;
                for (var j = 0; j < threads.length; j++) {
                    var options = {
                        owner: $scope.owner,
                        id: threads[j].id
                    };
                    complaintsService.deleteForm(options).then(function (response) {
                        count++;
                        if (count == threads.length) {
                            $scope.isLoadingCanal = true;
                            loadComplaint(vm.companySelected.id)
                        }
                    })
                }
            });

        }

    function deleteComplaint(ev) {
            const message = $translate.instant('GLOBAL.ARE_YOU_SURE');
            const yes = $translate.instant('GLOBAL.YES');
            const no = $translate.instant('GLOBAL.NO');
            const description = $translate.instant('GLOBAL.MESSAGE_DELETECOMPLAINT');

            const confirm = $mdDialog.confirm()
                .title(message)
                .textContent(description)
                .targetEvent(ev)
                .ok(yes)
                .cancel(no);

            $mdDialog.show(confirm).then(() => {
                var threads = angular.copy(vm.selectedThreads);
                vm.selectedThreads = [];
                var deleteCount = 0; // Counter for deleted complaints

                for (var j = 0; j < threads.length; j++) {
                    var options = {
                        owner: $scope.owner,
                        id: threads[j].id
                    };
                    complaintsService.deleteComplaint(options).then(function (response) {
                        deleteCount++;
                        if (deleteCount === threads.length) {
                            // Call to update the UI, similar to deleteForm
                            $scope.isLoadingCanal = true;
                            loadComplaint(vm.companySelected.id); // Update the list of complaints
                        }
                    });
                    initState();
                }
            }, () => {
                
            });
        }

        function deleteComplaintAction(id) {
            var options = {
                owner: $scope.owner,
                id: id
            };
            complaintsService.deleteComplaintAction(options).then(function (response) {
                vm.openComplaint(vm.complaintSelected.id);
            })
        }


        function initState() {
            vm.complaintSelected = undefined;
            vm.complaintNew = undefined;
        }




        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        function isSelected(thread) {
            return vm.selectedThreads.indexOf(thread) > -1;
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        function toggleSelectThread(thread, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedThreads.indexOf(thread) > -1) {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            } else {
                vm.selectedThreads.push(thread);
            }
        }

        /**
         * Select threads. If key/value pair given,
         * threads will be tested against them.
         *
         * @param [key]
         * @param [value]
         */
        function selectThreads(key, value) {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedThreads = [];

            for (var i = 0; i < vm.complaints.length; i++) {
                if (angular.isUndefined(key) && angular.isUndefined(value)) {
                    vm.selectedThreads.push(vm.complaints[i]);
                    continue;
                }

                if (angular.isDefined(key) && angular.isDefined(value) && vm.complaints[i][key] === value) {
                    vm.selectedThreads.push(vm.complaints[i]);
                }
            }
        }

        /**
         * Deselect threads
         */
        function deselectThreads() {
            vm.selectedThreads = [];
        }

        /**
         * Toggle select threads
         */
        function toggleSelectThreads() {
            if (vm.selectedThreads.length > 0) {
                vm.deselectThreads();
            } else {
                vm.selectThreads();
            }
        }

        /**
         * Set the status on given thread, current thread or selected threads
         *
         * @param key
         * @param value
         * @param [thread]
         * @param [event]
         */
        function setThreadStatus(key, value, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                thread[key] = value;
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                vm.currentThread[key] = value;
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                vm.selectedThreads[x][key] = value;
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleThreadStatus(key, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                if (typeof (thread[key]) !== 'boolean') {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                if (typeof (vm.currentThread[key]) !== 'boolean') {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                if (typeof (vm.selectedThreads[x][key]) !== 'boolean') {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }




        /**
         * Change the view
         *
         * @param view
         */
        function changeView(view) {
            if (vm.views[view]) {
                vm.defaultView = view;
                vm.currentView = view;
            }
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }


        function viewEditData() {
            vm.editData = true;
        }


        function toggleComplaintStatusEdit(fieldName) {

            event.stopPropagation();
            if (vm.complaintSelected) {
                var thread = vm.complaintSelected[fieldName];
                thread = (thread === 1) ?
                    0 :
                    1;

                vm.complaintSelected[fieldName] = thread;
            } else {
                if (angular.isUndefined(vm.complaintNew[fieldName])) {
                    vm.complaintNew[fieldName] = 0;
                }
                var thread = vm.complaintNew[fieldName];
                thread = (thread === 1) ?
                    0 :
                    1;

                vm.complaintNew[fieldName] = thread;
            }
            vm.basicForm.$setDirty()
        }
        function togglePredeterminated(form, $event) {
            $event.stopPropagation();
            var newValue = !form.is_predetermined;
            complaintsService.setDefaultForm(form.id, newValue)
                .then(function(response) {
                    form.is_predetermined = response.is_predetermined !== undefined ? response.is_predetermined : newValue;
                });
        }

        function setMultipleFormsAsPredetermined($event) {
            if (vm.selectedThreads.length === 0) {
                return;
            }

            $event.stopPropagation();
            
            var promises = [];
            for (var i = 0; i < vm.selectedThreads.length; i++) {
                var form = vm.selectedThreads[i];
                var newValue = !form.is_predetermined;
                promises.push(complaintsService.setDefaultForm(form.id, newValue));
            }

            Promise.all(promises).then(function(responses) {
                var message;
                if (vm.selectedThreads.length === 1) {
                    var form = vm.selectedThreads[0];
                    if (form.is_predetermined) {
                        message = $translate.instant('COMPLAINTS.FORM_UNMARKED_AS_DEFAULT');
                    } else {
                        message = $translate.instant('COMPLAINTS.FORM_MARKED_AS_DEFAULT');
                    }
                } else {
                    var allMarked = true;
                    var allUnmarked = true;
                    
                    for (var k = 0; k < vm.selectedThreads.length; k++) {
                        if (!vm.selectedThreads[k].is_predetermined) {
                            allMarked = false;
                        } else {
                            allUnmarked = false;
                        }
                    }
                    
                    if (allMarked) {
                        message = $translate.instant('COMPLAINTS.FORMS_MARKED_AS_DEFAULT');
                    } else if (allUnmarked) {
                        message = $translate.instant('COMPLAINTS.FORMS_UNMARKED_AS_DEFAULT');
                    } else {
                        message = $translate.instant('COMPLAINTS.FORMS_DEFAULT_UPDATED');
                    }
                }
                
                for (var j = 0; j < vm.selectedThreads.length; j++) {
                    var selectedForm = vm.selectedThreads[j];
                    selectedForm.is_predetermined = !selectedForm.is_predetermined;
                }
                
                vm.selectedThreads = [];
                
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center start">' +
                            '<div class="md-toast-content bg-green">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position: 'top right',
                    parent: '#content'
                });

                setTimeout(function() {
                    var toastrContainer = document.querySelector('.md-toast');
                    if (toastrContainer) {
                        toastrContainer.style.position = 'fixed';
                        toastrContainer.style.top = '5px';
                        toastrContainer.style.left = '50%';
                        toastrContainer.style.transform = 'translateX(-50%)';
                        toastrContainer.style.width = 'auto';
                    }
                }, 100);
            }).catch(function(error) {
                console.error('Error updating forms:', error);
            });
        }

        function getDefaultButtonInfo() {
            if (vm.selectedThreads.length === 0) {
                return { icon: 'icon-check-circle', text: 'COMPLAINTS.TOGGLE_DEFAULT' };
            }
            
            var firstForm = vm.selectedThreads[0];
            if (firstForm.is_predetermined) {
                return { icon: 'icon-checkbox-blank-circle-outline', text: 'COMPLAINTS.UNMARK_AS_DEFAULT' };
            } else {
                return { icon: 'icon-check-circle', text: 'COMPLAINTS.MARK_AS_DEFAULT' };
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.complaints')
        .service('complaintsService', complaintsService);



    /** @ngInject */
    // I provide access to the session store.
    function complaintsService($q, $resource, $rootScope, settingsDomainService, sessionService, companyService, COMMON, $window, $mdToast) {

        function createComplaintReport(options) {
			var deferred = $q.defer();
			if (!options.item.is_recurrent) {
				delete options.item.recurrent_frecuency;
				delete options.item.recurrent_range;
			}
			resourceComplaintReportsCreate.post(
				{
					owner: options.owner
				},
				options.item,
				function (response) {
					deferred.resolve(response);
				},

				function (e) {
					deferred.reject();
				}
			);

			// Return the promise.
			return deferred.promise;
		}

        function getFormCustom(complaintCanalLang, companyName, email) {
            var deferred = $q.defer();
            var fileLang = complaintCanalLang;
            var resourceFile = $resource("/assets/forms/" + fileLang + ".json");

            resourceFile.get({},
                function (formCustom) {
                    var formCustomCopy = angular.copy(formCustom)
                    formCustomCopy.fields.find(x => x.className == 'privacy_policy').templateOptions.policy = formCustomCopy.fields.find(x => x.className == 'privacy_policy').templateOptions.policy.replace('{{companyName}}', companyName).replace('{{email}}', email)
                    formCustomCopy.config.currentLang = complaintCanalLang;
                    return deferred.resolve(formCustomCopy);
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getComplaints(options) {
            var deferred = $q.defer();
            var id_forms = null;
            var complaint_types = null;
            var formFilters = ($rootScope.permissionsComplaints && angular.isArray($rootScope.permissionsComplaints)) ? $rootScope.permissionsComplaints.filter(x => x.field === "form_id") : null;
            var complaintTypeFilters = ($rootScope.permissionsComplaints && angular.isArray($rootScope.permissionsComplaints)) ? $rootScope.permissionsComplaints.filter(x => x.subfilter && x.subfilter.filter(y => y.field === "complaint_type")) : null;
            if (options.form) {
                id_forms = options.form.id;
            } else if (formFilters && formFilters.length > 0) {
                id_forms = formFilters.map(y => y.value);
            }
            if (options.formType) {
                complaint_types = options.formType.complaint_type_id;
            } else if (complaintTypeFilters && complaintTypeFilters.length > 0) {
                complaint_types = [];
                angular.forEach(complaintTypeFilters,function(filter) {
                    angular.forEach(filter.subfilter,function(sub) {
                        complaint_types.push(sub.value);
                    })
                })
            }

            let params = {
                owner: options.owner,
                company_id: companyService.getCompanyId(),
                search: options.searchStringFilter,
                sortField: options.sortField || 'id',
                withComplaintFormTypeName:'',
                page: options.page || 1,
                resultsPerPage: options.resultsPerPage
            };
            if (options.form && options.form.id) {
                params['form_id[]'] = [options.form.id];
            }
            if (options.formType && options.formType.complaint_type_id) {
                params['complaint_type[]'] = [options.formType.complaint_type_id];
            }
                resourceComplaints.get(params,
                function (response) {
                    for (let i = 0; i < response.data.length; i++) {
                        const element = response.data[i];
                        element.updated_at_format = moment.utc(element.updated_at).local().format('DD MMM YYYY HH:mm:00');
                        element.created_at_format = moment.utc(element.created_at).local().format('DD MMM YYYY HH:mm:00');
                    }
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getComplaint(options) {
            var deferred = $q.defer();
            resourceComplaints.get({
                id: options.id,
                owner: options.owner
            },
                function (response) {
                    response.updated_at_format = moment.utc(response.updated_at).local().format('DD MMM YYYY HH:mm:00');
                    response.created_at_format = moment.utc(response.created_at).local().format('DD MMM YYYY HH:mm:00');
                    for (var i = 0; i < response.actions.length; i++) {
                        const element = response.actions[i];
                        element.created_at_format = moment.utc(element.created_at).local().format('DD MMM YYYY HH:mm:00');
                        for (var j = 0; j < element.files.length; j++) {
                            const file = element.files[j];
                            file.created_at_format = moment.utc(file.created_at).local().format('DD MMM YYYY HH:mm:00');
                        }
                    }
                    if (response.form_files) {
                        response.data_files = response.form_files.upload_files ? response.form_files.upload_files : [];
                        if (response.form_files.messages) {
                            var message_files = Object.values(response.form_files.messages);
                            for (let i = 0; i < message_files.length; i++) {
                                const element = message_files[i];
                                response.data_files = [...response.data_files, ...element];
                            }
                        }
                    }
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getComplaintSettings(options) {
            var deferred = $q.defer();
            resourceComplaintsSettings.get({
                owner: options.owner,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getCanal(options) {
            var deferred = $q.defer();
            resourceComplaintsCanal.get({
                owner: options.owner,
                resultsPerPage: 2500,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getFormTypes(options) {
            var deferred = $q.defer();
            var params = {
                owner: options.owner,
                resultsPerPage: 2500,
                company_id: options.company_id
            };
            if (options.id) {
                params.form_id = options.id
            }
            resourceFormTypes.get(params,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function createComplaintCanal(options) {
            var deferred = $q.defer();
            options.form.company_id = options.id;
            options.form.name = options.name;
            options.form.target_url = options.target_url;
            resourceComplaintsCanal.post({
                owner: options.owner
            }, options.form,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function updateComplaintCanal(options) {
            var deferred = $q.defer();
            const data = {
                name: options.name,
                target_url: options.target_url,
                fields: options.fields,
                config: options.config,
                form_types: options.form_types
            }
            resourceUpdateComplaintsCanal.update({
                owner: options.owner,
                id: options.id
            }, data,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateComplaint(options) {
            var deferred = $q.defer();
            resourceComplaints.update({
                owner: options.owner,
                id: options.id
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function createComplaint(options) {
            var deferred = $q.defer();
            resourceComplaints.post({
                owner: options.owner,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function createComplaintAction(options) {
            var deferred = $q.defer();
            resourceComplaintsActions.post({
                owner: options.owner,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function deleteForm(options) {
            var deferred = $q.defer();
            resourceUpdateComplaintsCanal.delete({
                owner: options.owner,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function deleteComplaint(options) {
            var deferred = $q.defer();
            resourceComplaints.delete({
                owner: options.owner,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function deleteComplaintAction(options) {
            var deferred = $q.defer();
            resourceComplaintsActions.delete({
                owner: options.owner,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getFilters(options) {
            var deferred = $q.defer();

            return (deferred.promise);
        }


        function getS3UploadPreSignedUrl(options) {
            var deferred = $q.defer();

            resource_s3_presigned_url.get({
                uploadKey: 'complaints_actions',
                owner: options.owner,
                fileName: options.fileName,
                rowId: options.rowId
            },
                function (response) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }



        function finishedUploadingFile(options) {
            var deferred = $q.defer();
            var options = {
                owner: options.owner,
                token: options.token
            }
            resource_finish_upload_file.post(options,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        var resource_s3_presigned_url = $resource(
            COMMON.BASE_API + "/owner/:owner/upload/getS3UploadPreSignedUrl", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        }
        );


        var resource_finish_upload_file = $resource(
            COMMON.BASE_API + "/owner/:owner/upload/finishedUploadingFile", {
            owner: '@owner',
        }, {
            post: {
                method: "POST",
                isArray: false
            }
        }
        );


        var resourceComplaintsCanal = $resource(COMMON.BASE_API + "/owner/:owner/complaintForm?company_id=:id&withFormsTypes", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            },

            post: {
                method: "POST",
                isArray: false
            }
        });

        var resourceFormTypes = $resource(COMMON.BASE_API + "/owner/:owner/complaintFormTypes", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        });

        var resourceUpdateComplaintsCanal = $resource(COMMON.BASE_API + "/owner/:owner/complaintForm/:id", {
            // No default data
        }, {
            update: {
                method: "PUT",
                isArray: false
            },
            delete: {
                method: "DELETE",
                isArray: false
            },

        });

        var resourceComplaintsSettings = $resource(COMMON.BASE_API + "/owner/:owner/complaintSettings?company_id=:id", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        });


        var resourceComplaints = $resource(COMMON.BASE_API + "/owner/:owner/complaint/:id", {
            form_id: '@id_forms',
            complaint_type: '@complaint_types',
        }, {
            get: {
                method: "GET",
                isArray: false
            },

            post: {
                method: "POST",
                isArray: false
            },

            delete: {
                method: "DELETE",
                isArray: false
            },

            update: {
                method: "PUT",
                isArray: false
            },
        });
        
        var resourceComplaintsActions = $resource(COMMON.BASE_API + "/owner/:owner/complaint/action/:id", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            },

            post: {
                method: "POST",
                isArray: false
            },

            delete: {
                method: "DELETE",
                isArray: false
            },

            update: {
                method: "PUT",
                isArray: false
            },
        });

        var resourceComplaintReportsCreate = $resource(
			COMMON.BASE_API + '/owner/:owner/complaintReport',
            {},
			{
				post: {
					method: 'POST',
					isArray: false
				}
			}
		);

        var resourceDefaultForms = $resource(COMMON.BASE_API + '/owner/:owner/complaintForm/predetermined', {}, {
            get: { method: 'GET', isArray: true }
        });
        var resourceSetDefaultForm = $resource(COMMON.BASE_API + '/owner/:owner/complaintForm/:id/set-predetermined', { id: '@id' }, {
            post: { method: 'POST', isArray: false }
        });

        function getDefaultForms(companyId) {
            var deferred = $q.defer();
            
            var params = { 
                owner: $rootScope.owner || sessionService.get('owner')
            };
            
            if (companyId) {
                params.company_id = companyId;
            }
            
            resourceDefaultForms.get(params,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject(e);
                }
            );
            return deferred.promise;
        }

        function setDefaultForm(formId, isPredetermined) {
            var deferred = $q.defer();
            resourceSetDefaultForm.post({ 
                id: formId,
                owner: $rootScope.owner || sessionService.get('owner')
            }, { is_predetermined: isPredetermined },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject(e);
                }
            );
            return deferred.promise;
        }


        return ({
            getFormCustom: getFormCustom,
            getFormTypes: getFormTypes,
            get: getComplaints,
            getComplaints: getComplaints,
            getComplaint: getComplaint,
            getCanal: getCanal,
            getComplaintSettings: getComplaintSettings,
            createComplaintCanal: createComplaintCanal,
            getFilters: getFilters,
            updateComplaint: updateComplaint,
            updateComplaintCanal: updateComplaintCanal,
            deleteComplaint: deleteComplaint,
            deleteForm: deleteForm,
            deleteComplaintAction: deleteComplaintAction,
            createComplaint: createComplaint,
            getS3UploadPreSignedUrl: getS3UploadPreSignedUrl,
            finishedUploadingFile: finishedUploadingFile,
            createComplaintAction: createComplaintAction,
            createComplaintReport: createComplaintReport,
            getDefaultForms: getDefaultForms,
            setDefaultForm: setDefaultForm
        });

    }

})();

(function () {
    'use strict';

    angular
        .module('app.dashboard-complaints')
        .service('dashboardService', dashboardService);

    /** @ngInject */
    // I provide access to the session store.
    function dashboardService($q, $resource, settingsDomainService, sessionService, companyService, COMMON, $rootScope, $window, $mdToast) {



        function getData(options) {
            var deferred = $q.defer();
            var opt = {
                owner: options.owner
            }
            if (options.company_id) {
                opt.company_id = options.company_id;
            }
            resourceData.get(opt,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        var resourceData = $resource(COMMON.BASE_API + "/owner/:owner/dashboard", {
            owner: '@owner',
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            },
        });


        return ({
            getData: getData,
        });

    }

})();
(function () {
    'use strict';

    angular
        .module('app.dashboard-complaints')
        .controller('DashboardComplaintsController', DashboardComplaintsController);

    /** @ngInject */
    function DashboardComplaintsController($scope, $state, owner, $cookies, $location, $rootScope, $timeout, sessionService, $mdDialog, mediaService, $stateParams, msUtils, $translate, $document, dashboardService, complaintsService) {
        var vm = this;
        vm.is_dashboard_data = $state.params.is_dashboard_data;
        vm.isLoadingData = true;
        vm.complaintFormTypes = [];
        vm.init = init;
        vm.owner = owner;
        vm.openDialog = openDialog;
        vm.openCompanyPerformanceDialog = openCompanyPerformanceDialog;
        vm.openCategoryDialog = openCategoryDialog;
        vm.selectCompany = selectCompany;
        vm.selectAllClients = selectAllClients;
        vm.userLogued = sessionService.getUser();
        vm.canSeeAdminOnlyStatuses = [1, 2, 3, 14].indexOf(vm.userLogued.user_type) !== -1;
        vm.companies = vm.userLogued.companies;
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg', 'red-bg', 'yellow-bg', 'light-blue-bg'];
        vm.handleEventClick = handleEventClick;
        
        vm.getTrendClass = getTrendClass;
        vm.getTrendDirection = getTrendDirection;
        vm.getTrendPercentage = getTrendPercentage;
        vm.getPreviousMonthData = getPreviousMonthData;
        vm.getAverageResolutionTime = getAverageResolutionTime;
        vm.getPercentageByStatus = getPercentageByStatus;
        vm.getNewComplaintsToday = getNewComplaintsToday;
        vm.getTasksDueThisWeek = getTasksDueThisWeek;
        vm.getTaskCompletionRate = getTaskCompletionRate;
        vm.getOverdueDays = getOverdueDays;
        vm.getOverduePercentage = getOverduePercentage;
        vm.getRecentDocuments = getRecentDocuments;
        vm.getTotalFileSize = getTotalFileSize;
        vm.getStatusSummary = getStatusSummary;
        vm.getPriorityPercentage = getPriorityPercentage;
        vm.getPrioritySummary = getPrioritySummary;
        
        vm.getMonthlyTrend = getMonthlyTrend;
        vm.getCompanyPerformanceSummary = getCompanyPerformanceSummary;
        vm.getTopCategory = getTopCategory;

        vm.companySelected = undefined;
        if (vm.is_dashboard_data) {
            vm.init()
        }
        if (!vm.brandname) {
            var hostSplited = $location.$$host.split('.');
            if ((hostSplited.length >= 2 && hostSplited[1] == 'h2c' || hostSplited[1] == 'localhost') && hostSplited[0] != 'www') {
                vm.brandname = hostSplited[0];
            } else {
                vm.brandname = $cookies.get('ownerRemember');
            }
        }
        vm.branding = msUtils.getBranding();;

        function handleEventClick(event) {
            var item = event;
            var type = event.type;

            if (item.company_id) {
                $rootScope.$broadcast('company-selected-from', vm.companies.find(x => x.id = item.company_id));
                $timeout(() => {
                    switch (type) {
                        case 'RISKS':
                            $state.go('app.site_overview.risk.active_risk', { id: item.id, domain: $state.params.domain });
                            break;
                        case 'complaint':
                            $state.go('app.site_overview.complaints.list.active_complaint', { id: item.id, domain: $state.params.domain });
                            break;
                        case 'task':
                            $state.go('app.site_overview.tasks.list.active_task', { id: item.id, domain: $state.params.domain });
                            break;
                        case 'EVIDENCES':
                            $state.go('app.site_overview.evidences.active_control', { id: item.id, domain: $state.params.domain });
                            break;
                    }
                }, 0);
            }
        }
        vm.calendarUiConfig = {
            calendar: {
                displayEventTime: false,
                eventRender: function(event, element) {
    var iconClass = event.type === 'task' ? 'icon-clipboard-check' : 'icon-email-secure';
    var startTime = event.start.clone().add(2, 'hours');
    element.find('.fc-title').html("<div class='icon-time-container'><i class='" + iconClass + "'></i></div><span class='event-time'>" + startTime.format('hh:mm A') + "</span><br/>" + event.title);
},
                lang: 'es',
                buttonText: {
                    today: $translate.instant('DASHBOARD-COMPLAINTS.TODAY'),
                    month: $translate.instant('DASHBOARD-COMPLAINTS.MONTH'),
                    week: $translate.instant('DASHBOARD-COMPLAINTS.WEEK'),
                    day: $translate.instant('DASHBOARD-COMPLAINTS.DAY'),
                    list: $translate.instant('DASHBOARD-COMPLAINTS.LIST')
                },
                height: 'auto',
                editable: false,
                eventLimit: 2,
                eventLimitText: function(n) {
                    return $translate.instant('DASHBOARD-COMPLAINTS.MORE', {n: n});
                },
                header: {
                    left: 'month basicWeek',
                    center: 'title',
                    right: 'today prev,next'
                },
                handleWindowResize: false,
                aspectRatio: 1,
                dayNames: [
                    $translate.instant('DASHBOARD-COMPLAINTS.SUNDAY'),
                    $translate.instant('DASHBOARD-COMPLAINTS.MONDAY'),
                    $translate.instant('DASHBOARD-COMPLAINTS.TUESDAY'),
                    $translate.instant('DASHBOARD-COMPLAINTS.WEDNESDAY'),
                    $translate.instant('DASHBOARD-COMPLAINTS.THURSDAY'),
                    $translate.instant('DASHBOARD-COMPLAINTS.FRIDAY'),
                    $translate.instant('DASHBOARD-COMPLAINTS.SATURDAY')
                ],
                dayNamesShort: [
                    $translate.instant('DASHBOARD-COMPLAINTS.SUN'),
                    $translate.instant('DASHBOARD-COMPLAINTS.MON'),
                    $translate.instant('DASHBOARD-COMPLAINTS.TUE'),
                    $translate.instant('DASHBOARD-COMPLAINTS.WED'),
                    $translate.instant('DASHBOARD-COMPLAINTS.THU'),
                    $translate.instant('DASHBOARD-COMPLAINTS.FRI'),
                    $translate.instant('DASHBOARD-COMPLAINTS.SAT')
                ],
                monthNames: [
                    $translate.instant('DASHBOARD-COMPLAINTS.JANUARY'),
                    $translate.instant('DASHBOARD-COMPLAINTS.FEBRUARY'),
                    $translate.instant('DASHBOARD-COMPLAINTS.MARCH'),
                    $translate.instant('DASHBOARD-COMPLAINTS.APRIL'),
                    $translate.instant('DASHBOARD-COMPLAINTS.MAYO'),
                    $translate.instant('DASHBOARD-COMPLAINTS.JUNE'),
                    $translate.instant('DASHBOARD-COMPLAINTS.JULY'),
                    $translate.instant('DASHBOARD-COMPLAINTS.AUGUST'),
                    $translate.instant('DASHBOARD-COMPLAINTS.SEPTEMBER'),
                    $translate.instant('DASHBOARD-COMPLAINTS.OCTOBER'),
                    $translate.instant('DASHBOARD-COMPLAINTS.NOVEMBER'),
                    $translate.instant('DASHBOARD-COMPLAINTS.DECEMBER')
                ],
                monthNamesShort: [
                    $translate.instant('DASHBOARD-COMPLAINTS.JAN'),
                    $translate.instant('DASHBOARD-COMPLAINTS.FEB'),
                    $translate.instant('DASHBOARD-COMPLAINTS.MAR'),
                    $translate.instant('DASHBOARD-COMPLAINTS.APR'),
                    $translate.instant('DASHBOARD-COMPLAINTS.MAY'),
                    $translate.instant('DASHBOARD-COMPLAINTS.JUN'),
                    $translate.instant('DASHBOARD-COMPLAINTS.JUL'),
                    $translate.instant('DASHBOARD-COMPLAINTS.AUG'),
                    $translate.instant('DASHBOARD-COMPLAINTS.SEP'),
                    $translate.instant('DASHBOARD-COMPLAINTS.OCT'),
                    $translate.instant('DASHBOARD-COMPLAINTS.NOV'),
                    $translate.instant('DASHBOARD-COMPLAINTS.DEC')
                ],
                viewRender: function (view) {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                    vm.currentMonthShort = vm.calendar.getDate().format('MMM');
                },
                columnFormat: {
                    month: 'ddd',
                    week: 'ddd D',
                    day: 'ddd M'
                },
                eventClick: handleEventClick,
                selectable: true,
                selectHelper: true,
                select: select
            }
        };
        var companySelectEvent = $rootScope.$on('select-company', function (event, company) {
            vm.selectCompany(company);
        });

        $scope.$on('$destroy', companySelectEvent);



        mediaService.getStoragePrefix({
            owner: $stateParams.owner,
        }).then(function (res) {
            $scope.storagePrefix = res.prefix;
        })

        function selectCompany(company) {
            vm.companySelected = [];
            $timeout(function () {
                vm.companySelected = company;
                vm.init(vm.companySelected.id)
            })
        }

        function selectAllClients() {
            vm.companySelected = null;
            $timeout(function () {
                vm.init();
            })
        }
        function showEventDetailDialog(calendarEvent, e) {
            $mdDialog.show({
                controller: 'EventDetailFTDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/calendar/dialogs/event-detail-ft/event-detail-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    calendarEvent: calendarEvent,
                    showEventFormDialog: showEventFormDialog,
                    event: e
                }
            });
        }
        function showEventFormDialog(type, calendarEvent, start, end, e) {
            if (!calendarEvent) {
                return;
            }
            var dialogData = {
                type: type,
                calendarEvent: calendarEvent,
                start: start,
                end: end
            };

            $mdDialog.show({
                controller: 'EventFormFTDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/calendar/dialogs/event-form-ft/event-form-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: true,
                locals: {
                    dialogData: dialogData,
                    Contacts: Contacts,
                    ContactsCrew: ContactsCrew,
                }
            }).then(function (response) {
            });
        }

        function select(start, end, e) {
            showEventFormDialog('add', false, start, end, e);
        }







       function mapTask(color, type) {
            return function mapTaskColor(x) {
                return {
                    id: x.id,
                    title: x.title,
                    description: x.description,
                    start: new Date(x.date),
                    end: null,
                    color: color,
                    priority: x.priority,
                    status: x.status,
                    type: type,
                    company_id: x.company_id,
                }
            }
        }
        function init(company_id) {
            complaintsService.getFormTypes({ owner: vm.owner, company_id: company_id }).then(types => {
                vm.complaintFormTypes = types.data;
                
                return dashboardService.getData({ owner: vm.owner, company_id: company_id });
            }).then(result => {
                vm.isLoadingData = false;
                
                vm.data = angular.copy(result);
                var newEventsArray = result.tasks_next.map(mapTask('#000000', 'task'));
                newEventsArray = newEventsArray.concat(result.tasks_due.map(mapTask('#000000', 'task')));
                newEventsArray = newEventsArray.concat(vm.data.complaints.filter(complaint => complaint.status === 0).map(mapTask('#008000', 'complaint')));
                newEventsArray = newEventsArray.concat(vm.data.complaints.filter(complaint => complaint.status === 1).map(mapTask('#FFA500', 'complaint')));
                newEventsArray = newEventsArray.concat(vm.data.complaints.filter(complaint => complaint.status === 2).map(mapTask('#FF0000', 'complaint')));
                newEventsArray = newEventsArray.concat(vm.data.complaints.filter(complaint => complaint.status === 3).map(mapTask('#808080', 'complaint')));
                newEventsArray = newEventsArray.concat(vm.data.complaints.filter(complaint => complaint.status === 4).map(mapTask('#2196F3', 'complaint')));
                newEventsArray = newEventsArray.concat(vm.data.complaints.filter(complaint => complaint.status === 5).map(mapTask('#9C27B0', 'complaint')));
                vm.events = [
                    newEventsArray
                ];
                
                initializeEnhancedData();
                
                
            })

        }

        function openDialog(items, type, ev) {
            var processedItems = items;
            if ((type === 'COMPLAINTS' || type === 'DUE_TASKS' || type === 'FILES') && items && items.length > 0) {
                processedItems = items.map(function(item) {
                    var processedItem = angular.copy(item);
                    
                    var companyId = processedItem.company_id || (processedItem.company && processedItem.company.id) || processedItem.id_company;
                    if (companyId === '' || companyId === 0) {
                        companyId = null;
                    }
                    
                    if (!companyId && vm.companySelected && vm.companySelected.id) {
                        companyId = vm.companySelected.id;
                    }
                    
                    if (companyId && vm.companies) {
                        var companyData = vm.companies.find(function(company) {
                            return company.id === companyId;
                        });
                        
                        if (companyData && companyData.files && companyData.files.length > 0 && companyData.files[0].url) {
                            if (!processedItem.company) {
                                processedItem.company = {};
                            }
                            processedItem.company.logo = 'https://h2c-clients-upload.s3.amazonaws.com/' + companyData.files[0].url;
                            processedItem.company.name = companyData.name;
                        }
                    }
                    
                    return processedItem;
                });
            }
            
            $mdDialog.show({
                controller: 'ViewItemListDashboardDialog',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/dashboard-complaints/dialogs/view-item-list-dashboard-complaints.dialog/view-item-list-dashboard-complaints.dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    items: processedItems,
                    type: type
                }
            }).then(function (selectedItem) {
                if (selectedItem) {
                    if (selectedItem.item.company_id) {
                        $rootScope.$broadcast('company-selected-from', vm.companies.find(x => x.id = selectedItem.item.company_id));
                        setTimeout(() => {
                            if (selectedItem.type === 'RISKS') {
                                $state.go('app.site_overview.risk.active_risk', { id: selectedItem.item.id, domain: $state.params.domain });
                            }
                            if (selectedItem.type === 'COMPLAINTS') {
                                $state.go('app.site_overview.complaints.list.active_complaint', { id: selectedItem.item.id, domain: $state.params.domain });
                                }
                            if (selectedItem.type === 'DUE_TASKS') {
                                $state.go('app.site_overview.tasks.list.active_task', { id: selectedItem.item.id, domain: $state.params.domain });
                            }
                            if (selectedItem.type === 'PENDING_TASKS') {
                                $state.go('app.site_overview.tasks.list.active_task', { id: selectedItem.item.id, domain: $state.params.domain });
                            }
                            if (selectedItem.type === 'EVIDENCES') {
                                $state.go('app.site_overview.evidences.active_control', { id: selectedItem.item.id, domain: $state.params.domain });
                            }

                        }, 500);
                    }

                }
            });
        }

        function openCompanyPerformanceDialog(ev) {
            try {
                var allCompaniesData = generateAllCompanyPerformanceData();
                
                $mdDialog.show({
                    controller: 'CompanyPerformanceDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/dashboard-complaints/dialogs/company-performance-dialog/company-performance-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        companiesData: allCompaniesData
                    }
                }).catch(function(error) {
                    console.error('Error opening dialog:', error);
                });
            } catch (error) {
                console.error('Error generating company data:', error);
            }
        }

        function openCategoryDialog(ev) {
            try {
                $mdDialog.show({
                    controller: 'CategoryDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/dashboard-complaints/dialogs/category-dialog/category-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        categoriesData: vm.categoryData || []
                    }
                }).catch(function(error) {
                    console.error('Error opening dialog:', error);
                });
            } catch (error) {
                console.error('Error opening category dialog:', error);
            }
        }

        function generateAllCompanyPerformanceData() {
            var companyPerformance = [];
            
            if (!vm.data || !vm.data.complaints || !vm.data.complaints.length) {
                console.warn('No complaints data available');
                return companyPerformance;
            }
                var companies = {};
                
                vm.data.complaints.forEach(function(complaint) {
                    var companyId = complaint.company_id;
                    var companyName = complaint.company ? complaint.company.name : 'Empresa ' + companyId;
                    
                    if (!companies[companyId]) {
                        companies[companyId] = {
                            id: companyId,
                            name: companyName,
                            complaints: [],
                            closedComplaints: []
                        };
                    }
                    
                    companies[companyId].complaints.push(complaint);
                    
                    if (complaint.status === 0 && complaint.updated_at) {
                        companies[companyId].closedComplaints.push(complaint);
                    }
                });
                
                Object.keys(companies).forEach(function(companyId) {
                    var company = companies[companyId];
                    var totalComplaints = company.complaints.length;
                    var closedCount = company.closedComplaints.length;
                    
                    var avgResolutionDays = 0;
                    if (closedCount > 0) {
                        var totalDays = company.closedComplaints.reduce(function(sum, complaint) {
                            var createdDate = new Date(complaint.date);
                            var updatedDate = new Date(complaint.updated_at);
                            var days = Math.ceil((updatedDate - createdDate) / (1000 * 60 * 60 * 24));
                            return sum + days;
                        }, 0);
                        avgResolutionDays = Math.round(totalDays / closedCount);
                    }
                    
                    var logo = null;
                    if (vm.companies && vm.companies.length > 0) {
                        var companyData = vm.companies.find(function(c) {
                            return c.id == companyId;
                        });
                        if (companyData && companyData.files && companyData.files.length > 0 && companyData.files[0].url) {
                            logo = 'https://h2c-clients-upload.s3.amazonaws.com/' + companyData.files[0].url;
                        }
                    }
                    
                    companyPerformance.push({
                        id: companyId,
                        name: company.name,
                        logo: logo,
                        totalComplaints: totalComplaints,
                        resolvedCount: closedCount,
                        avgResolutionDays: avgResolutionDays || 'N/A',
                        color: getRandomColor(parseInt(companyId))
                    });
                });
                
                companyPerformance = companyPerformance.filter(function(company) {
                    return company.avgResolutionDays !== 'N/A' && company.avgResolutionDays > 0;
                });
                
                companyPerformance.sort(function(a, b) {
                    return b.avgResolutionDays - a.avgResolutionDays;
                });
                
                var minDays = companyPerformance.length > 0 ? 
                    Math.min.apply(Math, companyPerformance.map(function(c) {
                        return c.avgResolutionDays;
                    })) : 0;
                var maxDays = companyPerformance.length > 0 ? 
                    Math.max.apply(Math, companyPerformance.map(function(c) {
                        return c.avgResolutionDays;
                    })) : 0;
                
                companyPerformance.forEach(function(company) {
                    company.color = getPerformanceColor(company.avgResolutionDays, minDays, maxDays);
                });
            
            return companyPerformance;
        }




        function initializeEnhancedData() {
            if (!vm.data || !vm.data.complaints) {
                console.warn('No hay datos de complaints disponibles');
                vm.complaintsPieData = [];
                vm.priorityDistributionData = [];
                return;
            }

            vm.complaintsPieData = [
                { key: $translate.instant('DASHBOARD-COMPLAINTS.COMPLAINTS_STATUS_2'), y: vm.data.complaints.filter(c => c.status === 2).length, color: '#FF0000' },
                { key: $translate.instant('DASHBOARD-COMPLAINTS.COMPLAINTS_STATUS_1'), y: vm.data.complaints.filter(c => c.status === 1).length, color: '#FFA500' },
                { key: $translate.instant('DASHBOARD-COMPLAINTS.COMPLAINTS_STATUS_4'), y: vm.data.complaints.filter(c => c.status === 4).length, color: '#2196F3' },
                { key: $translate.instant('DASHBOARD-COMPLAINTS.COMPLAINTS_STATUS_5'), y: vm.data.complaints.filter(c => c.status === 5).length, color: '#9C27B0' },
                { key: $translate.instant('DASHBOARD-COMPLAINTS.COMPLAINTS_STATUS_3'), y: vm.data.complaints.filter(c => c.status === 3).length, color: '#808080' },
                { key: $translate.instant('DASHBOARD-COMPLAINTS.COMPLAINTS_STATUS_0'), y: vm.data.complaints.filter(c => c.status === 0).length, color: '#4CAF50' }
            ];

            
            vm.priorityDistributionData = [
                { key: $translate.instant('DASHBOARD-COMPLAINTS.PRIORITY_LOW'), y: vm.data.complaints.filter(c => c.priority === 0).length, color: '#4CAF50' },
                { key: $translate.instant('DASHBOARD-COMPLAINTS.PRIORITY_MEDIUM'), y: vm.data.complaints.filter(c => c.priority === 1).length, color: '#FFA500' },
                { key: $translate.instant('DASHBOARD-COMPLAINTS.PRIORITY_HIGH'), y: vm.data.complaints.filter(c => c.priority === 2).length, color: '#FF5722' },
                { key: $translate.instant('DASHBOARD-COMPLAINTS.PRIORITY_CRITICAL'), y: vm.data.complaints.filter(c => c.priority === 3).length, color: '#F44336' }
            ];

            vm.monthlyData = generateMonthlyBarData();
            vm.resolutionTimeData = generateResolutionTimeData();
            vm.categoryData = generateCategoryBarData();
            
            vm.companyPerformanceData = generateCompanyPerformanceData();
            


            vm.miniPieOptions = {
                    chart: {
                        type: 'pieChart',
                    height: 80,
                    width: 80,
                    margin: { top: 0, right: 0, bottom: 0, left: 0 },
                        showLabels: false,
                        showLegend: false,
                    donut: true,
                    x: function(d) { return d.key; },
                    y: function(d) { return d.y; }
                }
            };

            vm.trendOptions = {
                chart: {
                    type: 'lineChart',
                    height: 200,
                    margin: { top: 20, right: 20, bottom: 40, left: 40 },
                    showLegend: true,
                    showXAxis: true,
                    showYAxis: true,
                    x: function(d) { return d.x; },
                    y: function(d) { return d.y; },
                    xAxis: { axisLabel: 'Días' },
                    yAxis: { axisLabel: 'Complaints' }
                }
            };

            vm.distributionOptions = {
                    chart: {
                        type: 'pieChart',
                    height: 250,
                    margin: { top: 10, right: 10, bottom: 10, left: 10 },
                    showLabels: true,
                    showLegend: true,
                        donut: true,
                    donutRatio: 0.35,
                    x: function(d) { return d.key; },
                    y: function(d) { return d.y; },
                    labelType: 'percent',
                    labelSunbeamLayout: true
                }
            };

            vm.barChartOptions = {
                chart: {
                    type: 'lineChart',
                    height: 250,
                    margin: { top: 20, right: 20, bottom: 40, left: 40 },
                    showLegend: true,
                    showXAxis: true,
                    showYAxis: true,
                    x: function(d) { return d.label; },
                    y: function(d) { return d.value; },
                    xAxis: { axisLabel: 'Mes' },
                    yAxis: { axisLabel: 'Complaints' }
                }
            };

            vm.areaChartOptions = {
                chart: {
                    type: 'lineChart',
                    height: 250,
                    margin: { top: 20, right: 20, bottom: 40, left: 40 },
                    showLegend: true,
                    showXAxis: true,
                    showYAxis: true,
                    x: function(d) { return d.x; },
                    y: function(d) { return d.y; },
                    xAxis: { axisLabel: 'Semana' },
                    yAxis: { axisLabel: 'Complaints' }
                }
            };

            vm.scatterOptions = {
                chart: {
                    type: 'lineChart',
                    height: 250,
                    margin: { top: 20, right: 20, bottom: 40, left: 40 },
                    showLegend: true,
                    showXAxis: true,
                    showYAxis: true,
                    x: function(d) { return d.x; },
                    y: function(d) { return d.y; },
                    xAxis: { axisLabel: 'Complejidad' },
                    yAxis: { axisLabel: 'Días de Resolución' }
                }
            };

            vm.horizontalBarOptions = {
                chart: {
                    type: 'lineChart',
                    height: 250,
                    margin: { top: 20, right: 20, bottom: 40, left: 40 },
                    showLegend: true,
                    showXAxis: true,
                    showYAxis: true,
                    x: function(d) { return d.label; },
                    y: function(d) { return d.value; },
                    xAxis: { axisLabel: 'Categoría' },
                    yAxis: { axisLabel: 'Cantidad' }
                }
            };

            vm.gaugeOptions = {
                chart: {
                    type: 'pieChart',
                    height: 250,
                    margin: { top: 10, right: 10, bottom: 10, left: 10 },
                    showLabels: true,
                        showLegend: false,
                    donut: true,
                    donutRatio: 0.5,
                    x: function(d) { return d.key; },
                    y: function(d) { return d.y; },
                    labelType: 'percent'
                }
            };

        }


        function getTrendClass(type) {
            var currentMonth = getCurrentMonthData();
            var previousMonth = getPreviousMonthData();
            
            if (currentMonth > previousMonth) return 'trend-up';
            if (currentMonth < previousMonth) return 'trend-down';
            return 'trend-stable';
        }

        function getTrendDirection(type) {
            var currentMonth = getCurrentMonthData();
            var previousMonth = getPreviousMonthData();
            
            if (currentMonth > previousMonth) return 'up';
            if (currentMonth < previousMonth) return 'down';
            return 'stable';
        }

        function getTrendPercentage(type) {
            var currentMonth = getCurrentMonthData();
            var previousMonth = getPreviousMonthData();
            
            if (previousMonth === 0) {
                return currentMonth;
            }
            
            var percentage = ((currentMonth - previousMonth) / previousMonth) * 100;
            return Math.round(Math.abs(percentage));
        }

        function getCurrentMonthData() {
            if (!vm.data.complaints) return 0;
            var now = new Date();
            var startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
            
            return vm.data.complaints.filter(function(complaint) {
                if (!complaint.date) return false;
                var complaintDate = new Date(complaint.date);
                return complaintDate >= startOfMonth;
            }).length;
        }

        function getPreviousMonthData() {
            if (!vm.data.complaints) return 0;
            var now = new Date();
            var weekAgo = new Date(now);
            weekAgo.setDate(now.getDate() - 14);
            var twoWeeksAgo = new Date(weekAgo);
            twoWeeksAgo.setDate(weekAgo.getDate() - 7);
            
            return vm.data.complaints.filter(function(complaint) {
                if (!complaint.date) return false;
                var complaintDate = new Date(complaint.date);
                return complaintDate >= twoWeeksAgo && complaintDate < weekAgo;
            }).length;
        }

        function getAverageResolutionTime(status) {
            if (!vm.data.complaints) return 0;
            
            var complaintsWithStatus = vm.data.complaints.filter(function(complaint) {
                return complaint.status === status;
            });
            
            if (complaintsWithStatus.length === 0) return 0;
            
            if (status === 2 || status === 1 || status === 4) {
                var maxDays = 0;
                complaintsWithStatus.forEach(function(complaint) {
                    if (complaint.date) {
                        var createdDate = new Date(complaint.date);
                        var today = new Date();
                        var daysDiff = Math.floor((today - createdDate) / (1000 * 60 * 60 * 24));
                        if (daysDiff >= 0 && daysDiff > maxDays) {
                            maxDays = daysDiff;
                        }
                    }
                });
                return maxDays;
            }
            
            var totalDays = 0;
            var validComplaints = 0;
            
            complaintsWithStatus.forEach(function(complaint) {
                if (complaint.date) {
                    var createdDate = new Date(complaint.date);
                    var endDate = new Date();
                    
                    if (status === 3 && complaint.resolved_at) {
                        endDate = new Date(complaint.resolved_at);
                    } else if (status === 3 && complaint.updated_at) {
                        endDate = new Date(complaint.updated_at);
                    }
                    
                    var daysDiff = Math.floor((endDate - createdDate) / (1000 * 60 * 60 * 24));
                    if (daysDiff >= 0) {
                        totalDays += daysDiff;
                        validComplaints++;
                    }
                }
            });
            
            return validComplaints > 0 ? Math.round(totalDays / validComplaints) : 0;
        }

        function getPercentageByStatus(status) {
            var total = vm.data.complaints.length;
            if (total === 0) return 0;
            var count = vm.data.complaints.filter(c => c.status === status).length;
            return Math.round((count / total) * 100);
        }

        function getNewComplaintsToday() {
            if (!vm.data.complaints) return 0;
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            
            return vm.data.complaints.filter(function(complaint) {
                if (!complaint.date) return false;
                var complaintDate = new Date(complaint.date);
                complaintDate.setHours(0, 0, 0, 0);
                return complaintDate.getTime() === today.getTime() && complaint.status === 0;
            }).length;
        }

        function getTasksDueThisWeek() {
            if (!vm.data.tasks_next) return 0;
            var today = new Date();
            var weekEnd = new Date(today);
            weekEnd.setDate(today.getDate() + 7);
            
            return vm.data.tasks_next.filter(function(task) {
                if (!task.date) return false;
                var taskDate = new Date(task.date);
                return taskDate >= today && taskDate <= weekEnd;
            }).length;
        }

        function getTaskCompletionRate() {
            var totalTasks = (vm.data.tasks_next ? vm.data.tasks_next.length : 0) + (vm.data.tasks_due ? vm.data.tasks_due.length : 0);
            if (totalTasks === 0) return 100;
            var completedTasks = vm.data.tasks_due ? vm.data.tasks_due.length : 0;
            return Math.round((completedTasks / totalTasks) * 100);
        }

        function getOverdueDays() {
            if (!vm.data.tasks_due || vm.data.tasks_due.length === 0) return 0;
            
            var today = new Date();
            var maxDays = 0;
            
            vm.data.tasks_due.forEach(function(task) {
                var dateField = task.date || task.due_date || task.created_at;
                if (dateField) {
                    var taskDate = new Date(dateField);
                    var daysOverdue = Math.floor((today - taskDate) / (1000 * 60 * 60 * 24));
                    if (daysOverdue > maxDays) {
                        maxDays = daysOverdue;
                    }
                }
            });
            
            return maxDays;
        }

        function getOverduePercentage() {
            var totalTasks = (vm.data.tasks_next ? vm.data.tasks_next.length : 0) + (vm.data.tasks_due ? vm.data.tasks_due.length : 0);
            if (totalTasks === 0) return 0;
            var overdueTasks = vm.data.tasks_due ? vm.data.tasks_due.length : 0;
            return Math.round((overdueTasks / totalTasks) * 100);
        }

        function getRecentDocuments() {
            if (!vm.data.files) return 0;
            var weekAgo = new Date();
            weekAgo.setDate(weekAgo.getDate() - 7);
            
            return vm.data.files.filter(function(file) {
                if (!file.date) return false;
                var fileDate = new Date(file.date);
                return fileDate >= weekAgo;
            }).length;
        }

        function getTotalFileSize() {
            if (!vm.data.files) return 0;
            
            var totalSize = 0;
            vm.data.files.forEach(function(file) {
                if (file.size) {
                    totalSize += parseInt(file.size);
                } else {
                    var extension = file.name ? file.name.split('.').pop().toLowerCase() : '';
                    switch(extension) {
                        case 'pdf': totalSize += 2500; break;
                        case 'jpg':
                        case 'jpeg':
                        case 'png': totalSize += 800; break;
                        case 'doc':
                        case 'docx': totalSize += 500; break;
                        default: totalSize += 1000; break;
                    }
                }
            });
            
            return Math.round(totalSize / 1024);
        }


        function getStatusSummary() {
            var total = vm.data.complaints.length;
            if (total === 0) return $translate.instant('DASHBOARD-COMPLAINTS.NO_COMPLAINTS');
            var critical = vm.data.complaints.filter(c => c.status === 2).length;
            return critical > 0 ? critical + ' ' + $translate.instant('DASHBOARD-COMPLAINTS.CRITICAL') : $translate.instant('DASHBOARD-COMPLAINTS.EVERYTHING_NORMAL');
        }

        function getPriorityPercentage(count) {
            var total = vm.data.complaints.length;
            if (total === 0) return 0;
            return Math.round((count / total) * 100);
        }

        function getPrioritySummary() {
            var total = vm.data.complaints.length;
            if (total === 0) return $translate.instant('DASHBOARD-COMPLAINTS.NO_DATA');
            var critical = vm.data.complaints.filter(c => c.priority === 3).length;
            return critical > 0 ? critical + ' ' + $translate.instant('DASHBOARD-COMPLAINTS.CRITICAL') : $translate.instant('DASHBOARD-COMPLAINTS.EVERYTHING_NORMAL');
        }






        function getMonthlyTrend() {
            if (!vm.monthlyData || vm.monthlyData.length < 2) return $translate.instant('DASHBOARD-COMPLAINTS.INSUFFICIENT_DATA');
            
            var current = vm.monthlyData[vm.monthlyData.length - 1].value;
            var previous = vm.monthlyData[vm.monthlyData.length - 2].value;
            
            if (current > previous) return '+' + (current - previous) + ' ' + $translate.instant('DASHBOARD-COMPLAINTS.VS_PREVIOUS_MONTH');
            if (current < previous) return '-' + (previous - current) + ' ' + $translate.instant('DASHBOARD-COMPLAINTS.VS_PREVIOUS_MONTH');
            return $translate.instant('DASHBOARD-COMPLAINTS.STABLE');
        }



        function getCompanyPerformanceSummary() {
            if (!vm.companyPerformanceData || vm.companyPerformanceData.length === 0) {
                return $translate.instant('DASHBOARD-COMPLAINTS.NO_COMPANY_DATA');
            }
            
            var totalResolved = vm.companyPerformanceData.reduce(function(sum, company) {
                return sum + company.resolvedCount;
            }, 0);
            
            var avgResolution = 0;
            var companiesWithData = 0;
            vm.companyPerformanceData.forEach(function(company) {
                if (company.avgResolutionDays !== 'N/A' && company.avgResolutionDays > 0) {
                    avgResolution += company.avgResolutionDays;
                    companiesWithData++;
                }
            });
            
            if (companiesWithData > 0) {
                avgResolution = Math.round(avgResolution / companiesWithData);
                return avgResolution + ' días promedio';
            } else {
                return totalResolved + ' comunicaciones cerradas';
            }
        }

        function getTopCategory() {
            if (!vm.categoryData || vm.categoryData.length === 0) return $translate.instant('DASHBOARD-COMPLAINTS.NO_CATEGORIES');
            var topCategory = vm.categoryData[0];
            return topCategory.name + ' (' + topCategory.count + ')';
        }


        function generateMonthlyBarData() {
            var now = new Date();
            var monthlyData = [];
            var maxValue = 0;
            
            
            
            for (var i = 5; i >= 0; i--) {
                var month = new Date(now.getFullYear(), now.getMonth() - i, 1);
                var monthName = month.toLocaleDateString('es-ES', { month: 'short' });
                
                var monthComplaints = 0;
                if (vm.data.complaints) {
                    monthComplaints = vm.data.complaints.filter(function(complaint) {
                        if (!complaint.date) return false;
                        
                        
                        var complaintDate;
                        try {
                            complaintDate = new Date(complaint.date);
                            if (isNaN(complaintDate.getTime())) {
                                return false;
                            }
                        } catch (e) {
                            return false;
                        }
                        
                        
                        return complaintDate.getMonth() === month.getMonth() && 
                               complaintDate.getFullYear() === month.getFullYear();
                    }).length;
                }
                
                
                if (monthComplaints > maxValue) maxValue = monthComplaints;
                
                monthlyData.push({
                    name: monthName,
                    value: monthComplaints,
                    color: getRandomColor(i)
                });
            }
            
            
            monthlyData.forEach(function(month) {
                month.percentage = maxValue > 0 ? (month.value / maxValue) * 100 : 0;
            });
            
            return monthlyData;
        }


        function generateResolutionTimeData() {
            var resolutionData = [];
            var total = vm.data.complaints ? vm.data.complaints.length : 0;
            var quickResolution = 0;
            var mediumResolution = 0;
            var slowResolution = 0;
            
            if (total > 0) {
                vm.data.complaints.forEach(function(complaint) {
                    if (complaint.date && complaint.status === 3) {
                        var createdDate = new Date(complaint.date);
                        var resolvedDate = complaint.resolved_at ? new Date(complaint.resolved_at) : new Date();
                        var resolutionTime = Math.floor((resolvedDate - createdDate) / (1000 * 60 * 60 * 24));
                        
                        if (resolutionTime <= 3) quickResolution++;
                        else if (resolutionTime <= 7) mediumResolution++;
                        else slowResolution++;
                    }
                });
                
            }
            
            var resolutions = [
                { name: $translate.instant('DASHBOARD-COMPLAINTS.RESOLUTION_FAST'), count: quickResolution, color: '#4CAF50', icon: 'icon-clock-fast' },
                { name: $translate.instant('DASHBOARD-COMPLAINTS.RESOLUTION_MEDIUM'), count: mediumResolution, color: '#FFA500', icon: 'icon-clock' },
                { name: $translate.instant('DASHBOARD-COMPLAINTS.RESOLUTION_SLOW'), count: slowResolution, color: '#FF0000', icon: 'icon-clock-slow' }
            ];
            
            resolutions.forEach(function(resolution) {
                if (resolution.count > 0) {
                    resolution.percentage = total > 0 ? (resolution.count / total) * 100 : 0;
                    resolutionData.push(resolution);
                }
            });
            
            return resolutionData;
        }


        function getComplaintTypeName(complaint) {
            if (!vm.complaintFormTypes || !complaint.complaint_type || !complaint.form_id) {
                return 'General';
            }
            
            var type = vm.complaintFormTypes.find(function(t) {
                return t.form_id == complaint.form_id && t.complaint_type_id == complaint.complaint_type;
            });
            
            return type ? type.name : 'General';
        }

        function generateCompanyPerformanceData() {
            var companyPerformance = [];
            
            if (vm.data.complaints && vm.data.complaints.length > 0) {
                var companies = {};
                
                vm.data.complaints.forEach(function(complaint) {
                    var companyId = complaint.company_id;
                    var companyName = complaint.company ? complaint.company.name : 'Empresa ' + companyId;
                    
                    
                    if (!companies[companyId]) {
                        companies[companyId] = {
                            id: companyId,
                            name: companyName,
                            complaints: [],
                            closedComplaints: []
                        };
                    }
                    
                    companies[companyId].complaints.push(complaint);
                    
                    if (complaint.status === 0 && complaint.updated_at) {
                        companies[companyId].closedComplaints.push(complaint);
                    }
                });
                
                Object.keys(companies).forEach(function(companyId) {
                    var company = companies[companyId];
                    var totalComplaints = company.complaints.length;
                    var closedCount = company.closedComplaints.length;
                    
                    var avgResolutionDays = 0;
                    if (closedCount > 0) {
                        var totalDays = company.closedComplaints.reduce(function(sum, complaint) {
                            var createdDate = new Date(complaint.date);
                            var updatedDate = new Date(complaint.updated_at);
                            var days = Math.ceil((updatedDate - createdDate) / (1000 * 60 * 60 * 24));
                            return sum + days;
                        }, 0);
                        avgResolutionDays = Math.round(totalDays / closedCount);
                    }
                    
                    var logo = null;
                    if (vm.companies && vm.companies.length > 0) {
                        var companyData = vm.companies.find(function(c) {
                            return c.id == companyId;
                        });
                        if (companyData && companyData.files && companyData.files.length > 0 && companyData.files[0].url) {
                            logo = 'https://h2c-clients-upload.s3.amazonaws.com/' + companyData.files[0].url;
                        }
                    }
                    
                    
                    companyPerformance.push({
                        id: companyId,
                        name: company.name,
                        logo: logo,
                        totalComplaints: totalComplaints,
                        resolvedCount: closedCount,
                        avgResolutionDays: avgResolutionDays || 'N/A',
                        color: getRandomColor(parseInt(companyId))
                    });
                });
                
                companyPerformance = companyPerformance.filter(function(company) {
                    return company.avgResolutionDays !== 'N/A' && company.avgResolutionDays > 0;
                });
                
                companyPerformance.sort(function(a, b) {
                    return b.avgResolutionDays - a.avgResolutionDays;
                });
                
                var minDays = companyPerformance.length > 0 ? 
                    Math.min.apply(Math, companyPerformance.map(function(c) {
                        return c.avgResolutionDays;
                    })) : 0;
                var maxDays = companyPerformance.length > 0 ? 
                    Math.max.apply(Math, companyPerformance.map(function(c) {
                        return c.avgResolutionDays;
                    })) : 0;
                
                companyPerformance.forEach(function(company) {
                    company.color = getPerformanceColor(company.avgResolutionDays, minDays, maxDays);
                });
                
                companyPerformance = companyPerformance.slice(0, 3);
                
                vm.maxResolutionDays = maxDays;
            }
            
            return companyPerformance;
        }

        function generateCategoryBarData() {
            var categoryData = [];
            var categories = {};
            var total = 0;
            
            
            if (vm.data.complaints && vm.data.complaints.length > 0) {
                vm.data.complaints.forEach(function(complaint) {
                    var category = getComplaintTypeName(complaint);
                    
                    categories[category] = (categories[category] || 0) + 1;
                    total++;
                });
                
            }
            
            
            var colors = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7', '#DDA0DD'];
            var colorIndex = 0;
            
            var maxCount = 0;
            Object.keys(categories).forEach(function(key) {
                if (categories[key] > maxCount && key !== 'General') {
                    maxCount = categories[key];
                }
            });
            
            if (maxCount === 0 && categories['General'] > 0) {
                maxCount = categories['General'];
            }
            
            Object.keys(categories).forEach(function(key) {
                if (categories[key] > 0 && key !== 'General') {
                    categoryData.push({
                        name: key,
                        count: categories[key],
                        color: colors[colorIndex % colors.length],
                        percentage: maxCount > 0 ? (categories[key] / maxCount) * 80 : 0
                    });
                    colorIndex++;
                }
            });
            
            if (categoryData.length === 0 && categories['General'] > 0) {
                categoryData.push({
                    name: 'General',
                    count: categories['General'],
                    color: colors[0],
                    percentage: 80
                });
            }
            
            categoryData.sort(function(a, b) { return b.count - a.count; });
            
            return categoryData.slice(0, 5);
        }

        function getRandomColor(index) {
            var colors = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7', '#DDA0DD'];
            return colors[index % colors.length];
        }

        function getPerformanceColor(days, minDays, maxDays) {
            if (!days || days === 'N/A' || maxDays === 0) {
                return '#95a5a6';
            }
            
            var percentage = (days - minDays) / (maxDays - minDays);
            
            percentage = Math.max(0, Math.min(1, percentage));
            
            if (percentage <= 0.33) {
                var factor = percentage / 0.33;
                return interpolateColor('#2ECC71', '#F1C40F', factor);
            } else if (percentage <= 0.66) {
                var factor = (percentage - 0.33) / 0.33;
                return interpolateColor('#F1C40F', '#E67E22', factor);
            } else {
                // Naranja a rojo (66-100%)
                var factor = (percentage - 0.66) / 0.34;
                return interpolateColor('#E67E22', '#E74C3C', factor);
            }
        }

        function interpolateColor(color1, color2, factor) {
            function hexToRgb(hex) {
                var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
                return result ? {
                    r: parseInt(result[1], 16),
                    g: parseInt(result[2], 16),
                    b: parseInt(result[3], 16)
                } : null;
            }
            
            function rgbToHex(r, g, b) {
                return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
            }
            
            var rgb1 = hexToRgb(color1);
            var rgb2 = hexToRgb(color2);
            
            var r = Math.round(rgb1.r + (rgb2.r - rgb1.r) * factor);
            var g = Math.round(rgb1.g + (rgb2.g - rgb1.g) * factor);
            var b = Math.round(rgb1.b + (rgb2.b - rgb1.b) * factor);
            
            return rgbToHex(r, g, b);
        }


        function getStatusPercentage(count) {
            var total = vm.data.complaints ? vm.data.complaints.length : 0;
            if (total === 0) return 0;
            return Math.round((count / total) * 100);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.divisions')
        .controller('DivisionsController', DivisionsController);

    /** @ngInject */
    function DivisionsController($scope, $rootScope, $stateParams, $translate, $document, $mdDialog,
        $mdMedia, $mdSidenav, $state, msApi, tinyMceService, requestContext, mediaService, $timeout, divisionsService, transformDivision) {
        var vm = this;
        // Data
        vm.accounts = {
            'creapond': 'johndoe@creapond.com',
            'withinpixels': 'johndoe@withinpixels.com'
        };
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
        vm.selectedAccount = 'creapond';

        vm.folders = 'Folders.data';
        vm.labels = 'Labels.data';
        vm.loadingThreads = true;

        vm.currentFilter = {
            type: $state.params.type,
            filter: $state.params.filter
        };
        vm.currentThread = null;
        vm.selectedThreads = [];

        vm.views = {
            split: 'app/main/apps/divisions/views/list/split-view.html',
            nosplit: 'app/main/apps/divisions/views/list/nosplit-view.html'
        };
        vm.defaultView = 'split';
        vm.currentView = 'split';

        vm.readView = true;

        //Methods
        vm.openThread = openThread;
        vm.closeThread = closeThread;

        vm.isSelected = isSelected;
        vm.toggleSelectThread = toggleSelectThread;
        vm.selectThreads = selectThreads;
        vm.deselectThreads = deselectThreads;
        vm.toggleSelectThreads = toggleSelectThreads;

        vm.setThreadStatus = setThreadStatus;
        vm.toggleThreadStatus = toggleThreadStatus;


        vm.changeView = changeView;
        vm.toggleSidenav = toggleSidenav;
        vm.tinymceOptions = tinyMceService.getOptions($scope);

        vm.openDivision = openDivision;
        vm.closeDivision = closeDivision;
        vm.sendDivision = sendDivision;
        vm.deleteDivision = deleteDivision;
        vm.duplicateDivision = duplicateDivision;
        vm.newDivision = newDivision;
        vm.checkFields = checkFields;

        vm.getPositionNameById = getPositionNameById;


        //////////

        $scope.$on('pagination:loadStart', function (event) {
            $scope.isLoading = true;
        });

        $scope.$on('pagination:loadPage', function (event) {
            $scope.isLoading = false;
        });


        $scope.owner = $stateParams.owner;
        init();

        /////////////////

        function init() {
            // getPositions();
        }

        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'nosplit';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big)
                vm.currentView = 'nosplit';

        });

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small)
                vm.currentView = 'split';

        });

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                if (vm.defaultView === 'split') {
                    vm.currentView = 'split';
                }
            }
        });

        var originatorEv;

        function openMenu($mdOpenMenu, ev) {
            originatorEv = ev;
            $mdOpenMenu(ev);
        }

        function openDivision(division) {
            if (vm.divisionNew)
                vm.divisionNew = undefined;
            vm.divisionSelected = angular.copy(division);
        }

        function closeDivision() {
            vm.divisionSelected = undefined;
            vm.divisionNew = undefined;
        }

        function sendDivision() {
            if (vm.divisionSelected) {
                updateDivision();
            } else if (vm.divisionNew) {
                createDivision();
            }
            initState();
        }

        function createDivision() {
            var options = {
                owner: $scope.owner,
                item: vm.divisionNew
            }
            divisionsService.createDivision(options).then(function (response) {
                vm.divisionNew = undefined;
                $rootScope.pagination_resetquery();
            })
        }

        function updateDivision() {
            var options = {
                owner: $scope.owner,
                item: vm.divisionSelected,
                id: vm.divisionSelected.id
            }
            divisionsService.updateDivision(options).then(function (response) {
                vm.divisionSelected = undefined;
                $rootScope.pagination_resetquery();
            })
        }



        function getPositionNameById(id) {
            for (var i = 0; i < vm.positions.length; i++) {
                if (vm.positions[i].id === id) return vm.positions[i].name;
            }
            return null;
        }

        function deleteDivision(ev) {
            const message = $translate.instant('GLOBAL.ARE_YOU_SURE');
            const yes = $translate.instant('GLOBAL.YES');
            const no = $translate.instant('GLOBAL.NO');

            const confirm = $mdDialog.confirm()
                .title(message)
                .targetEvent(ev)
                .ok(yes)
                .cancel(no);

            $mdDialog.show(confirm).then(e => {
                var threads = angular.copy(vm.selectedThreads);
                vm.selectedThreads = [];
                for (var j = 0; j < threads.length; j++) {
                    var options = {
                        owner: $scope.owner,
                        id: threads[j].id
                    };
                    divisionsService.deleteDivision(options).then(function (response) {
                        $rootScope.pagination_resetquery();
                    })
                    initState();
                }
            });

        }

        function duplicateDivision() {
            var threads = angular.copy(vm.selectedThreads);
            vm.selectedThreads = [];
            for (var j = 0; j < threads.length; j++) {
                var options = {
                    owner: $scope.owner,
                    item: transformDivision.duplicateDivision(threads[j])
                };
                divisionsService.createDivision(options).then(function (response) {
                    $rootScope.pagination_resetquery();
                })
                initState();
            }
        }

        function newDivision() {
            if (vm.divisionSelected)
                vm.divisionSelected = undefined;
            vm.divisionNew = {};
        }

        function initState() {
            vm.divisionSelected = undefined;
            vm.divisionNew = undefined;
        }

        function checkFields() {
            if (vm.divisionNew) {
                return transformDivision.checkFields(vm.divisionNew);
            } else if (vm.divisionSelected) {
                return transformDivision.checkFields(vm.divisionSelected);
            }
        }



        /**
         * Open thread
         *
         * @param thread
         */
        function openThread(thread) {
            // // Set the read status on the thread
            // thread.read = true;

            // // Assign thread as the current thread
            // vm.currentThread = thread;

            // // Update the state without reloading the controller
            // $state.go('app.aircrafts.threads.thread', { threadId: thread.id }, { notify: false });
        }

        /**
         * Close thread
         */
        function closeThread() {
            // vm.currentThread = null;

            // // Update the state without reloading the controller
            // $state.go('app.aircrafts.threads', {
            //     type: vm.currentFilter.type,
            //     filter: vm.currentFilter.filter
            // }, { notify: false });
        }

        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        function isSelected(thread) {
            return vm.selectedThreads.indexOf(thread) > -1;
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        function toggleSelectThread(thread, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedThreads.indexOf(thread) > -1) {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            } else {
                vm.selectedThreads.push(thread);
            }
        }

        /**
         * Select threads. If key/value pair given,
         * threads will be tested against them.
         *
         * @param [key]
         * @param [value]
         */
        function selectThreads(key, value) {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedThreads = [];

            for (var i = 0; i < vm.divisions.length; i++) {
                if (angular.isUndefined(key) && angular.isUndefined(value)) {
                    vm.selectedThreads.push(vm.divisions[i]);
                    continue;
                }

                if (angular.isDefined(key) && angular.isDefined(value) && vm.divisions[i][key] === value) {
                    vm.selectedThreads.push(vm.divisions[i]);
                }
            }
        }

        /**
         * Deselect threads
         */
        function deselectThreads() {
            vm.selectedThreads = [];
        }

        /**
         * Toggle select threads
         */
        function toggleSelectThreads() {
            if (vm.selectedThreads.length > 0) {
                vm.deselectThreads();
            } else {
                vm.selectThreads();
            }
        }

        /**
         * Set the status on given thread, current thread or selected threads
         *
         * @param key
         * @param value
         * @param [thread]
         * @param [event]
         */
        function setThreadStatus(key, value, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                thread[key] = value;
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                vm.currentThread[key] = value;
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                vm.selectedThreads[x][key] = value;
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleThreadStatus(key, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                if (typeof (thread[key]) !== 'boolean') {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                if (typeof (vm.currentThread[key]) !== 'boolean') {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                if (typeof (vm.selectedThreads[x][key]) !== 'boolean') {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }




        /**
         * Change the view
         *
         * @param view
         */
        function changeView(view) {
            if (vm.views[view]) {
                vm.defaultView = view;
                vm.currentView = view;
            }
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.divisions')
        .service('divisionsService', divisionsService);

    /** @ngInject */
    // I provide access to the session store.
    function divisionsService($q, $resource, settingsDomainService, sessionService, COMMON, $window, $mdToast) {

        function getDivisions(options) {
            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });


            resourceDivisions.get({
                owner: options.owner,
                page: options.page,
                resultsPerPage: options.resultsPerPage,
                search: options.searchStringFilter,
                paginate: options.paginate,
                sortField: 'name',
                sortDir: 'asc',
                filters: JSON.stringify(filters),
            },
                function (responseResult) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        function updateDivision(options) {
            var deferred = $q.defer();
            resourceDivisions.update({
                owner: options.owner,
                id: options.id
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function createDivision(options) {
            var deferred = $q.defer();
            resourceDivisions.post({
                owner: options.owner,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function deleteDivision(options) {
            var deferred = $q.defer();
            resourceDivisions.delete({
                owner: options.owner,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getFilters(options) {
            var deferred = $q.defer();

            return (deferred.promise);
        }

        function getPositions(options) {
            var deferred = $q.defer();
            resourcePositions.get({
                owner: options.owner
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        var resourcePositions = $resource(COMMON.BASE_API + "/owner/:owner/jobPosition", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });



        var resourceDivisions = $resource(COMMON.BASE_API + "/owner/:owner/division/:id", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                delete: {
                    method: "DELETE",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                },
            });



        return ({
            get: getDivisions,
            getDivisions: getDivisions,
            getFilters: getFilters,
            getPositions: getPositions,
            updateDivision: updateDivision,
            deleteDivision: deleteDivision,
            createDivision: createDivision

        });

    }

})();
(function () {
    'use strict';

    angular
        .module('app.dashboard')
        .service('dashboardService', dashboardService);

    /** @ngInject */
    // I provide access to the session store.
    function dashboardService($q, $resource, settingsDomainService, sessionService, companyService, COMMON, $rootScope, $window, $mdToast) {



        function getData(options) {
            var deferred = $q.defer();
            var opt = {
                owner: options.owner
            }
            if (options.company_id) {
                opt.company_id = options.company_id;
            }
            resourceData.get(opt,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        var resourceData = $resource(COMMON.BASE_API + "/owner/:owner/dashboard", {
            owner: '@owner',
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            },
        });


        return ({
            getData: getData,
        });

    }

})();
(function () {
    'use strict';

    angular
        .module('app.dashboard')
        .controller('DashboardController', DashboardController);

    /** @ngInject */
    function DashboardController($scope, $state, owner, $cookies, $location, $rootScope, $timeout, sessionService, $mdDialog, mediaService, $stateParams, msUtils, $translate, $document, dashboardService) {
        var vm = this;
        //console.log("start dash")
        vm.is_dashboard_data = $state.params.is_dashboard_data;
        vm.isLoadingData = true;
        vm.init = init;
        vm.owner = owner;
        vm.openDialog = openDialog;
        vm.d3DataProcess = d3DataProcess;
        vm.getClassbySize = getClassbySize;
        vm.riskLevelPercent = riskLevelPercent;
        vm.riskLevelText = riskLevelText;
        vm.riskLevelColor = riskLevelColor;
        vm.resizeChart = resizeChart;
        vm.selectCompany = selectCompany;
        vm.forceRealodChart = forceRealodChart;
        vm.companies = sessionService.getUser().companies;

        vm.companySelected = undefined;
        if (vm.is_dashboard_data) {
            vm.init()
        }
        if (!vm.brandname) {
            var hostSplited = $location.$$host.split('.');
            if ((hostSplited.length >= 2 && hostSplited[1] == 'h2c' || hostSplited[1] == 'localhost') && hostSplited[0] != 'www') {
                vm.brandname = hostSplited[0];
            } else {
                vm.brandname = $cookies.get('ownerRemember');
            }
        }
        vm.branding = msUtils.getBranding();;


        vm.calendarUiConfig = {
            calendar: {
                lang: 'es',
                buttonText: {
                    today: 'Hoy',
                    month: 'Mes',
                    week: 'Semana',
                    day: 'Dia',
                    list: 'Lista'
                },
                height: 717,
                editable: false,
                eventLimit: false,
                header: {
                    left: 'month basicWeek',
                    center: 'title',
                    right: 'today prev,next'
                },
                handleWindowResize: false,
                aspectRatio: 1,
                dayNames: ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'],
                dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
                viewRender: function (view) {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                    vm.currentMonthShort = vm.calendar.getDate().format('MMM');
                },
                columnFormat: {
                    month: 'ddd',
                    week: 'ddd D',
                    day: 'ddd M'
                },
                eventClick: showEventDetailDialog,
                selectable: true,
                selectHelper: true,
                select: select
            }
        };
        var companySelectEvent = $rootScope.$on('select-company', function (event, company) {
            vm.selectCompany(company);
        });

        $scope.$on('$destroy', companySelectEvent);


        // var companySelectEvent = $rootScope.$on('company-selected', function (event) {
        //     vm.companySelected = sessionService.get('companySelected');
        //     vm.data.riskmap = vm.alldata.riskmap.filter(x => x.id_company === vm.companySelected.id);
        //     vm.data.tasks_next = vm.alldata.tasks_next.filter(x => x.id_company === vm.companySelected.id)
        //     vm.data.tasks_due = vm.alldata.tasks_due.filter(x => x.id_company === vm.companySelected.id)
        //     vm.data.evidences = vm.alldata.evidences.filter(x => x.id_company === vm.companySelected.id)
        //     vm.data.activities = vm.alldata.activities.filter(x => x.id_company === vm.companySelected.id)
        //     vm.data.files = vm.alldata.files.filter(x => x.id_company === vm.companySelected.id)
        //     vm.d3Data = vm.d3DataProcess(vm.data.riskmap[0]);
        //     vm.forceRealodChart();
        // });

        mediaService.getStoragePrefix({
            owner: $stateParams.owner,
        }).then(function (res) {
            $scope.storagePrefix = res.prefix;
        })

        function selectCompany(company) {
            vm.companySelected = [];
            $timeout(function () {
                vm.companySelected = company;
                vm.init(vm.companySelected.id)
            })


        }
        function showEventDetailDialog(calendarEvent, e) {
            $mdDialog.show({
                controller: 'EventDetailFTDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/calendar/dialogs/event-detail-ft/event-detail-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    calendarEvent: calendarEvent,
                    showEventFormDialog: showEventFormDialog,
                    event: e
                }
            });
        }
        function showEventFormDialog(type, calendarEvent, start, end, e) {
            var dialogData = {
                type: type,
                calendarEvent: calendarEvent,
                start: start,
                end: end
            };

            $mdDialog.show({
                controller: 'EventFormFTDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/calendar/dialogs/event-form-ft/event-form-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: true,
                locals: {
                    dialogData: dialogData,
                    Contacts: Contacts,
                    ContactsCrew: ContactsCrew,
                }
            }).then(function (response) {
            });
        }

        function select(start, end, e) {
            showEventFormDialog('add', false, start, end, e);
        }



        function d3DataProcess(riskMap) {
            return [
                {
                    key: vm.riskLevelPercent(riskMap.average),
                    y: riskMap.average,
                    color: vm.riskLevelColor(riskMap.average)
                },
                {
                    key: '',
                    y: (25 - (riskMap.average * 1)),
                    color: '#EFEFEF'
                }
            ];
        }

        function getClassbySize(size) {
            if (size == 0) {
                return '#039be5';
            }
            if (size >= 1 && size < 20) {
                return 'light-blue-fg';
            }
            if (size >= 20 && size < 50) {
                return 'orange';
            }
            if (size >= 50) {
                return 'red';
            }
            return '';
        }
        function riskLevelPercent(average) {
            return average;
            // return ((average * 100) / 25) + '%';
        }

        function riskLevelText(average) {
            var txt;
            if (average >= 1 && average <= 4) {
                txt = $translate.instant('RISK.RISK_LOW');
            } else if (average >= 5 && average <= 9) {
                txt = $translate.instant('RISK.RISK_MEDIUM');
            } else if (average >= 10 && average <= 15) {
                txt = $translate.instant('RISK.RISK_HIGH');
            } else if (average >= 16 && average <= 25) {
                txt = $translate.instant('RISK.RISK_VERY_HIGH');
            }
            return txt;
        }

        function riskLevelColor(average) {
            var color;
            if (average >= 1 && average <= 4) {
                color = '#039be5';
            } else if (average >= 5 && average <= 9) {
                color = 'yellow';
            } else if (average >= 10 && average <= 15) {
                color = 'orange';
            } else if (average >= 16 && average <= 25) {
                color = '#039be5';
            }
            return color;
        }
        function mapTask(color) {
            return function mapTaskColor(x) {
                return {
                    id: x.id,
                    title: x.title,
                    start: new Date(x.date),
                    end: null,
                    color: color
                }
            }
        }
        function init(company_id) {
            dashboardService.getData({ owner: vm.owner, company_id: company_id }).then(result => {
                vm.isLoadingData = false;
                vm.data = angular.copy(result);
               vm.d3Data = vm.d3DataProcess(vm.data.riskmap[0]);
                vm.alldata = angular.copy(result);
                vm.forceRealodChart();
                var newEventsArray = result.tasks_next.map(mapTask('#039be5'));
                newEventsArray = newEventsArray.concat(result.tasks_due.map(mapTask('#999999')))
                newEventsArray = newEventsArray.concat(result.complaints.map(mapTask('#e0519c')))
                vm.events = [
                    newEventsArray
                ];
            })

        }

        function openDialog(items, type, ev) {
            $mdDialog.show({
                controller: 'ViewItemListDashboardDialog',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/dashboard/dialogs/view-item-list-dashboard.dialog/view-item-list-dashboard.dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    items: items,
                    type: type
                }
            }).then(function (selectedItem) {
                if (selectedItem) {
                    console.log(selectedItem);
                    if (selectedItem.item.company_id) {
                        $rootScope.$broadcast('company-selected-from', vm.companies.find(x => x.id = selectedItem.item.company_id));
                        setTimeout(() => {
                            if (selectedItem.type === 'RISKS') {
                                $state.go('app.site_overview.risk.active_risk', { id: selectedItem.item.id, domain: $state.params.domain });
                            }
                            if (selectedItem.type === 'COMPLAINTS') {
                                $state.go('app.site_overview.complaints.list.active_complaint', { id: selectedItem.item.id, domain: $state.params.domain });
                                }
                            if (selectedItem.type === 'DUE_TASKS') {
                                $state.go('app.site_overview.tasks.list.active_task', { id: selectedItem.item.id, domain: $state.params.domain });
                            }
                            if (selectedItem.type === 'PENDING_TASKS') {
                                $state.go('app.site_overview.tasks.list.active_task', { id: selectedItem.item.id, domain: $state.params.domain });
                            }
                            if (selectedItem.type === 'EVIDENCES') {
                                $state.go('app.site_overview.evidences.active_control', { id: selectedItem.item.id, domain: $state.params.domain });
                            }

                        }, 500);
                    }

                }
            });
        }
        function forceRealodChart() {
            resizeChart(window.innerWidth < 600 ? true : false)
        }


        function resizeChart(mov) {
            if (mov) {
                vm.optionsDonut = {
                    chart: {
                        type: 'pieChart',
                        height: 65,
                        width: '100%',
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: -50,
                            left: 0
                        },
                        donut: true,
                        x: function (d) { return d.key; },
                        y: function (d) { return d.y; },
                        showLabels: false,
                        showLegend: false,
                        pie: {
                            startAngle: function (d) { return d.startAngle / 2 - Math.PI / 2 },
                            endAngle: function (d) { return d.endAngle / 2 - Math.PI / 2 }
                        },
                        duration: 500,
                        tooltip: {
                            enabled: false
                        }
                    }
                };
            } else {
                vm.optionsDonut = {
                    chart: {
                        type: 'pieChart',
                        height: 'auto',
                        width: 'auto',
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: -50,
                            left: 0
                        },
                        donut: true,
                        x: function (d) { return d.key; },
                        y: function (d) { return d.y; },
                        showLabels: false,
                        showLegend: false,
                        pie: {
                            startAngle: function (d) { return d.startAngle / 2 - Math.PI / 2 },
                            endAngle: function (d) { return d.endAngle / 2 - Math.PI / 2 }
                        },
                        duration: 500,
                        tooltip: {
                            enabled: false
                        }
                    }
                };
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.contacts')
        .controller('ContactsController', ContactsController);

    /** @ngInject */
    function ContactsController($scope, $mdSidenav, Contacts, User, msUtils, $mdDialog, $document)
    {

        var vm = this;

        // Data
        vm.contacts = Contacts.data;
        vm.user = User.data;
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'name';
        vm.listOrderAsc = false;
        vm.selectedContacts = [];
        vm.newGroupName = '';

        // Methods
        vm.filterChange = filterChange;
        vm.openContactDialog = openContactDialog;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.deleteContact = deleteContact;
        vm.deleteSelectedContacts = deleteSelectedContacts;
        vm.toggleSelectContact = toggleSelectContact;
        vm.deselectContacts = deselectContacts;
        vm.selectAllContacts = selectAllContacts;
        vm.deleteContact = deleteContact;
        vm.addNewGroup = addNewGroup;
        vm.deleteGroup = deleteGroup;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;

        //////////

        /**
         * Change Contacts List Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.listType = type;

            if ( type === 'all' )
            {
                vm.filterIds = null;
            }
            else if ( type === 'frequent' )
            {
                vm.filterIds = vm.user.frequentContacts;
            }
            else if ( type === 'starred' )
            {
                vm.filterIds = vm.user.starred;
            }
            else if ( angular.isObject(type) )
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }

        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openContactDialog(ev, contact)
        {
            $mdDialog.show({
                controller         : 'ContactDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/contacts/dialogs/contact/contact-dialog.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Contact : contact,
                    User    : vm.user,
                    Contacts: vm.contacts
                }
            });
        }

        /**
         * Delete Contact Confirm Dialog
         */
        function deleteContactConfirm(contact, ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the contact?')
                .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                deleteContact(contact);
                vm.selectedContacts = [];

            }, function ()
            {

            });
        }

        /**
         * Delete Contact
         */
        function deleteContact(contact)
        {
            vm.contacts.splice(vm.contacts.indexOf(contact), 1);
        }

        /**
         * Delete Selected Contacts
         */
        function deleteSelectedContacts(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the selected contacts?')
                .htmlContent('<b>' + vm.selectedContacts.length + ' selected</b>' + ' will be deleted.')
                .ariaLabel('delete contacts')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                vm.selectedContacts.forEach(function (contact)
                {
                    deleteContact(contact);
                });

                vm.selectedContacts = [];

            });

        }

        /**
         * Toggle selected status of the contact
         *
         * @param contact
         * @param event
         */
        function toggleSelectContact(contact, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            if ( vm.selectedContacts.indexOf(contact) > -1 )
            {
                vm.selectedContacts.splice(vm.selectedContacts.indexOf(contact), 1);
            }
            else
            {
                vm.selectedContacts.push(contact);
            }
        }

        /**
         * Deselect contacts
         */
        function deselectContacts()
        {
            vm.selectedContacts = [];
        }

        /**
         * Sselect all contacts
         */
        function selectAllContacts()
        {
            vm.selectedContacts = $scope.filteredContacts;
        }

        /**
         *
         */
        function addNewGroup()
        {
            if ( vm.newGroupName === '' )
            {
                return;
            }

            var newGroup = {
                'id'        : msUtils.guidGenerator(),
                'name'      : vm.newGroupName,
                'contactIds': []
            };

            vm.user.groups.push(newGroup);
            vm.newGroupName = '';
        }

        /**
         * Delete Group
         */
        function deleteGroup(ev)
        {
            var group = vm.listType;

            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the group?')
                .htmlContent('<b>' + group.name + '</b>' + ' will be deleted.')
                .ariaLabel('delete group')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                vm.user.groups.splice(vm.user.groups.indexOf(group), 1);

                filterChange('all');
            });

        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }

})();
(function () {
    'use strict';

    angular
        .module('app.clients-complaints')
        .controller('ClientsComplaintsController', ClientsComplaintsController);

    /** @ngInject */
    function ClientsComplaintsController($scope, $rootScope, $stateParams, companyService, $translate, $document, $mdDialog,
        $mdMedia, $mdSidenav, $state, msApi, tinyMceService, clientsService, requestContext, evidencesControlsService,
        transformClients, mediaService, Upload, $filter, $timeout, msUtils, documentsService, sessionService, $cookies, is_owner) {
        var vm = this;
        vm.userLogued = sessionService.getUser();
        if ($state.current.name == "app.site_overview.clients.complaints") {
            vm.fromComplaint = true;
        }
        sessionService.getQuota().then(function (quota) {
            vm.quota = quota;
        });

        // vm.is_owner = is_owner;
        vm.ivhOptions = {
            defaultSelectedState: false,
            validate: true,
            expandToDepth: -1,
            useCheckboxes: true,
            twistieCollapsedTpl: '<md-icon md-font-icon="icon-chevron-right"></md-icon>',
            twistieExpandedTpl: '<md-icon md-font-icon="icon-chevron-down"></md-icon>',
            twistieLeafTpl: '<span style="cursor: default;">&#8192;&#8192;</span>'
        };
        vm.financing_options = [
            { id: 1, name: "Bancaria" },
            { id: 2, name: "Inversión de socio nacional" },
            { id: 3, name: "Inversión de socio extranjero" },
            { id: 4, name: "Capital riesgo" },
            { id: 5, name: "Subvenciones" },
            { id: 6, name: "Donaciones" }
        ];
        vm.sector_regulations_options = [
            { id: 1, name: "Protección de datos personales" },
            { id: 2, name: "Prevención de riesgos laborales" },
            { id: 3, name: "Blanqueo de Capitales" },
            { id: 4, name: "Normativa de defensa de la competencia" }
        ];
        vm.implemented_measures_options = [
            { id: 1, name: "Welcome pack" },
            { id: 2, name: "Canal de comunicaciones o denuncias" },
            { id: 3, name: "Código ético/Código de Conducta" },
            { id: 4, name: "Régimen disciplinario laboral" },
            { id: 5, name: "Formación a empleados" },
            { id: 6, name: "Otras" }
        ];
        vm.showOptions = false;
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg', 'red-bg', 'yellow-bg', 'light-blue-bg'];

        vm.positionsIds = {
            administrator: 1,
            managerLegal: 2,
            compliance_officer: 3,
            compliance_comite: 5,
            data_protection: 4,
            collaborator: 24
        }

        vm.divisionsId = {
            administrator: 3,
            managerLegal: 3,
            compliance_officer: 1,
            compliance_comite: 1,
            data_protection: 2,
            collaborator: 1
        }

        // Data
        vm.accounts = {
            'creapond': 'johndoe@creapond.com',
            'withinpixels': 'johndoe@withinpixels.com'
        };
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
        vm.profileColors = ['md-blue-300-bg', 'md-blue-grey-300-bg', 'md-orange-300-bg', 'md-pink-300-bg', 'md-purple-300-bg', 'md-red-300-bg', 'md-yellow-300-bg', 'md-light-blue-300-bg'];
        vm.selectedAccount = 'creapond';

        vm.loadingStep = false;
        vm.folders = 'Folders.data';
        vm.labels = 'Labels.data';
        vm.loadingThreads = true;

        vm.currentFilter = {
            type: $state.params.type,
            filter: $state.params.filter
        };
        vm.currentThread = null;
        vm.selectedThreads = [];

        vm.views = {
            split: 'app/main/apps/clients-complaints/views/list/split-view.html',
            nosplit: 'app/main/apps/clients-complaints/views/list/nosplit-view.html'
        };
        vm.defaultView = 'split';
        vm.currentView = 'split';

        vm.readView = false;

        vm.branchFields = [
            { name: 'Nombre', type: 'text', field: 'name', translate: 'GLOBAL.NAME' },
            { name: 'Domicilio', type: 'text', field: 'address1', translate: 'GLOBAL.ADDRESS' },
            { name: 'Población', type: 'text', field: 'city', translate: 'GLOBAL.CITY' },
            { name: 'Provincia', type: 'text', field: 'state', translate: 'GLOBAL.PROVINCE' },
            { name: 'Codigo postal', type: 'number', field: 'postcode', translate: 'GLOBAL.POSTAL_CODE' },
            { name: 'Telefono', type: 'number', field: 'phone', translate: 'GLOBAL.PHONE' },
            { name: 'Email', type: 'email', field: 'email', translate: 'GLOBAL.EMAIL' }
        ];

        vm.personFields = [
            { name: 'Name', type: 'text', field: 'first_name', translate: 'GLOBAL.NAME', required: true },
            { name: 'Apellidos', type: 'text', field: 'last_name', translate: 'GLOBAL.SURNAMES', required: true },
            { name: 'NIF', type: 'text', field: 'id_number', translate: 'GLOBAL.NIF_CIF', required: true },
            { name: 'Email', type: 'text', field: 'email', translate: 'GLOBAL.EMAIL', required: true },
            { name: 'Password', type: 'password', field: 'password', translate: 'LOGIN.PASSWORD', required: false },
            { name: 'Picture', type: 'picture', field: 'picture', translate: '', required: false },
            { name: '3rd Party Company', type: 'text', field: '3rd_party_company_name', translate: 'CLIENTS.3RD_PARTY_COMPANY' },
            { name: 'Profile Color', type: 'text', field: 'profile_color', translate: 'GLOBAL.PROFILE_COLOR', hidden: true },
            { name: 'User type', type: 'text', field: 'user_type', translate: 'GLOBAL.PROFILE_COLOR', hidden: true },
            // { name: 'Files', type: 'text', field: 'files', translate: 'GLOBAL.FILES', hidden: true },
            { name: 'Files', type: '', field: 'files', hidden: true, value: [] },
        ];

        vm.administratorFields = vm.personFields;
        vm.managerLegalFields = vm.personFields;
        vm.complianceFields = vm.personFields;
        vm.reportFields = vm.personFields;
        vm.personnelFields = vm.personFields;
        vm.getRegionLiteral = getRegionLiteral;


        vm.getSectorById = getSectorById;


        vm.idClient = undefined;
        vm.idCompany = undefined;
        vm.updateLogotype = false;
        vm.showForm = true;
        vm.allQuestions = true;
        $scope.storagePrefix = '';


        vm.isSelected = isSelected;
        vm.toggleSelectThread = toggleSelectThread;
        vm.selectThreads = selectThreads;
        vm.deselectThreads = deselectThreads;
        vm.toggleSelectThreads = toggleSelectThreads;

        vm.setThreadStatus = setThreadStatus;
        vm.toggleThreadStatus = toggleThreadStatus;


        vm.changeView = changeView;


        vm.toggleSidenav = toggleSidenav;
        vm.newForm = newForm;
        vm.closeForm = closeForm;
        vm.uploadMedia = uploadMedia;
        vm.upload = upload;
        vm.openDialogForm = openDialogForm;
        vm.openMenu = openMenu;
        vm.nextStep = nextStep;
        vm.prevStep = prevStep;
        vm.previousStep = previousStep;
        vm.deleteClient = deleteClient;
        vm.removeBranch = removeBranch;
        vm.editBranchDialog = editBranchDialog;
        vm.removeBranchFromForm = removeBranchFromForm;

        vm.tinymceOptions = tinyMceService.getOptions($scope);

        vm.mediaDialogSingle = mediaDialogSingle;
        vm.deleteLogotype = deleteLogotype;
        vm.openImageDialog = openImageDialog;
        vm.sendForm = sendForm;
        vm.goClients = goClients;
        vm.goQuestions = goQuestions;
        vm.finishQuestion = finishQuestion;
        vm.openCompany = openCompany;
        vm.editCompany = editCompany;
        vm.showUserImage = showUserImage;
        vm.editUser = editUser;
        vm.removeUser = removeUser;
        vm.addUsersJob = addUsersJob;
        vm.addUsersJobFromUserId = addUsersJobFromUserId;
        vm.getDivisionName = getDivisionName;
        vm.getPositionName = getPositionName;
        vm.isFromType = isFromType;
        vm.areFromType = areFromType;
        vm.getRegion = getRegion;

        vm.deleteCompany = deleteCompany;

        //////////

        $scope.$on('pagination:loadStart', function (event) {
            $scope.isLoading = true;
        });

        $scope.$on('pagination:loadPage', function (event) {
            $scope.isLoading = false;
            vm.is_owner = vm.companies.length <= 1;
            init();
        });


        $scope.owner = $stateParams.owner;


        vm.bag = [{
            label: 'Glasses',
            value: 'glasses',
            children: [{
                label: 'Top Hat',
                value: 'top_hat',
                children: [{
                    label: 'Top Hat',
                    value: 'top_hat',
                    children: [{
                        label: 'Top Hat',
                        value: 'top_hat'
                    }]
                }]
            }, {
                label: 'Curly Mustache',
                value: 'mustachio'
            }]
        }];

        this.awesomeCallback = function (node, tree) {
            // Do something with node or tree
        };

        this.otherAwesomeCallback = function (node, isSelected, tree) {
            // Do soemthing with node or tree based on isSelected
        };




        /////////////////

        function init() {
            getSectors();
            getDivisions();
            getPositions();
            getUsers();
            mediaService.getStoragePrefix({
                owner: $scope.owner,
            }).then(function (res) {
                $scope.storagePrefix = res.prefix;
            })
            evidencesControlsService.getCurrencies({ owner: $scope.owner }).then(function (res) {
                vm.currencies = res.data;
            })
            clientsService.getRegions({ owner: $scope.owner }).then(function (res) {
                vm.regions = res.data;
            })
            clientsService.getFileRegions().then(function (res) {
                vm.regionsLiterals = res;
            })
        }

        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'nosplit';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big) {
                vm.currentView = 'nosplit';
            }

        });

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small) {
                vm.currentView = 'split';
            }

        });

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                if (vm.defaultView === 'split') {
                    vm.currentView = 'split';
                }
            }
        });


        var originatorEv;

        function openMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        }

        function initFieldsForm(title) {
            let fields;
            if (title === 'branch') {
                fields = angular.copy(vm.branchFields);
            }
            else if (title === 'administrator') {
                fields = angular.copy(vm.administratorFields);
            }
            else if (title === 'managerLegal') {
                fields = angular.copy(vm.managerLegalFields);
            }
            else if (title === 'compliance') {
                fields = angular.copy(vm.complianceFields);
            }
            else if (title === 'report') {
                fields = angular.copy(vm.reportFields);
            }
            else if (title === 'personnel') {
                fields = angular.copy(vm.personnelFields);
            }
            fields.forEach(item => {
                if (item.name == 'Población') {
                    item.translate = vm.getRegionLiteral('city');
                }
                if (item.name == 'Provincia') {
                    item.translate = vm.getRegionLiteral('state');
                }
                if (item.name == 'NIF') {
                    item.translate = vm.getRegionLiteral('id_number');
                }
            })
            return fields;
        }
        function getRegionLiteral(literalKey) {
            if (!angular.isUndefined(vm.formWizard) && !angular.isUndefined(vm.formWizard.company) && vm.formWizard.company.region_id) {
                const literalsObject = vm.regionsLiterals.find(x => x.region_id === vm.formWizard.company.region_id)
                return literalsObject.literals[literalKey];
            } else {
                return '';
            }
        }

        function getSectorById(sector_id) {
            var found;
            if (vm.sectors) {
                for (var i = 0; i < vm.sectors.length; i++) {
                    if (vm.sectors[i].id == sector_id) {
                        found = vm.sectors[i]
                        break;
                    }
                }
            }
            return found;
        }

        function openDialogForm(title, branchId, saveNow, model, index, type) {
            var hasModel = true;
            var divisionId = '';
            var jobId = '';
            if (model === undefined || !model) {
                hasModel = false;
                var fields = initFieldsForm(title);
            }
            else {
                //var fields = angular.copy(model);
                var fields = initFieldsForm(title);
                angular.forEach(fields, function (f) {
                    if (!angular.isUndefined(model[f.field])) {
                        f.value = model[f.field];
                        if (f.field == 'division') {
                            divisionId = f.value;
                        } else if (f.field == 'position') {
                            jobId = f.value;
                        }
                    }
                })
            }

            if (!divisionId && type && !angular.isUndefined(vm.divisionsId[type])) {
                divisionId = vm.divisionsId[type];
            }
            if (!jobId && type && !angular.isUndefined(vm.positionsIds[type])) {
                jobId = vm.positionsIds[type];
            }

            if (angular.isUndefined(vm.formWizard[title])) {
                vm.formWizard[title] = [];
            }
            if (!vm.users) {
                vm.users = [];
            }
            if (!vm.mainUsers) {
                vm.mainUsers = [];
            }
            var usersDialog = vm.users.concat(vm.mainUsers);
            usersDialog = _.uniq(usersDialog, function (e) {
                return e.id;
            });
            $mdDialog.show({
                controller: 'DialogFormController',
                controllerAs: 'vm',
                locals: {
                    title: title,
                    fields: fields,
                    type: type,
                    users: angular.copy(usersDialog),
                    alreadySelected: type ? vm.areFromType(vm.formWizard[title], type) : vm.formWizard[title],
                    storagePrefix: $scope.storagePrefix,
                    branchId: branchId,
                    defaultDivision: divisionId,
                    owner: $scope.owner,
                    defaultJob: jobId,
                    positionsIds: vm.positionsIds,
                    idCompany: vm.idCompany,
                    user_type: model ? model.user_type : undefined,
                    isTiny: false
                },
                templateUrl: 'app/main/apps/clients-complaints/dialogs/forms/dialog-view.html',
                parent: angular.element($document.body),
                targetEvent: 'ev',
                disableParentScroll: true,
                clickOutsideToClose: true,

            }).then(function (result) {

                if (result) {
                    if (result.fields && result.fields.files) {
                        vm.files = result.fields.files;
                        delete result.fields.files;
                    }
                    vm.quotaexceded = result.quotaexceded;
                    var existUser = result.existUser;
                    if (hasModel) {
                        angular.forEach(result.fields, function (f) {
                            // no se por que hay que tener el if siguiente pero las dejo ya que imagino que alguien las puso por algo.
                            if (!angular.isUndefined(model[f.field])) {
                                model[f.field] = f.value;
                            }
                            if (f.field == 'password' && !angular.isUndefined(f.value)) {
                                model[f.field] = f.value;
                            }
                        })
                        if (title !== 'branch') {
                            updateUser(title, index);
                        }

                    }
                    else {

                        if (branchId) {
                            var subIndex = createSubForm(title, result.fields, true, branchId);
                            if (!existUser) {
                                createUser(title, result.fields, subIndex, true);
                            } else {
                                var itemUser = vm.formWizard[title][subIndex];
                                upgradeRol(title, subIndex, itemUser)
                                vm.addUsersJobFromUserId(itemUser.division, itemUser.position, itemUser.branch_id, itemUser, true)
                            }
                        } else {
                            var subIndex = createSubForm(title, result.fields, true);
                            if (title !== 'branch') {
                                if (!existUser) {
                                    createUser(title, result.fields, subIndex, true);
                                } else {
                                    var itemUser = vm.formWizard[title][subIndex];
                                    upgradeRol(title, subIndex, itemUser)
                                    vm.addUsersJobFromUserId(itemUser.division, itemUser.position, itemUser.branch_id, itemUser, true)
                                }
                            }
                            else if (title === 'branch') {
                                saveRemainBranches();
                                //addBranchToForm(result.fields, subIndex);
                            }
                        }
                    }
                }
            });
        }

        function upgradeRol(title, index, itemUser) {
            if ((vm.positionsIds.compliance_officer == itemUser.position
                || vm.positionsIds.compliance_comite == itemUser.position
                || vm.positionsIds.data_protection == itemUser.position)
                && (itemUser.user_type > 3) && !vm.quotaexceded) {
                vm.formWizard[title][index].user_type = 3;
                updateUser(title, index);
            }
        }

        function getRegion(id) {
            if (vm.regions) {
                return vm.regions.find(x => x.id === id).name
            } else {
                return '';
            }
        }

        function getPositions() {
            var options = {
                owner: $scope.owner,
                resultsPerPage: 1000
            };
            clientsService.getPositions(options).then(function (response) {
                vm.positions = response.data;
                var positionField = {
                    name: 'Position',
                    type: 'selector',
                    field: 'position',
                    translate: 'GLOBAL.POSITION',
                    options: [],
                    hidden: true
                }
                for (var i = 0; i < response.data.length; i++) {
                    positionField.options.push({ field: response.data[i].name, id: response.data[i].id });
                }
                vm.personFields.push(positionField);
            })
        }

        function getUsers(idCompany, inOwner) {
            var options = {
                owner: $scope.owner,
                //                inOwner: '',
                withFiles: true
            };
            clientsService.getUsers(options).then(function (response) {
                vm.mainUsers = response.data;
            })
        }

        function getSectors() {
            var options = {
                owner: $scope.owner,
                resultsPerPage: 1000
            };
            clientsService.getSectors(options).then(function (response) {
                vm.sectors = response.data;
            })
        }
        function getDivisions() {
            var options = {
                owner: $scope.owner,
                resultsPerPage: 1000
            };
            clientsService.getDivisions(options).then(function (response) {
                vm.divisions = response.data;
                var divisionField = {
                    name: 'Division',
                    type: 'selector',
                    field: 'division',
                    translate: 'GLOBAL.DIVISION',
                    options: [],
                    hidden: true
                }
                for (var i = 0; i < response.data.length; i++) {
                    divisionField.options.push({ field: response.data[i].name, id: response.data[i].id });
                }
                vm.personFields.push(divisionField);

            })
        }


        function getCompany(id) {
            var options = {
                owner: $scope.owner,
                id: id
            };
            clientsService.getCompany(options).then(function (response) {

                vm.idCompany = response.id;
                vm.formWizard.company = {};
                vm.formWizard.company = response;
                if (vm.formWizard.company.extra_data) {
                    vm.formWizard.company.extra_data = JSON.parse(vm.formWizard.company.extra_data);
                }
                destroyWatchers();
                initWatchers();
                vm.formWizard.branches = angular.copy(response.branches);
                vm.formWizard.branch = vm.formWizard.branches;
                delete (vm.formWizard.company.branches);

                if (response.logo.length > 0) {
                    clientsService.getStoragePrefix(options).then(function (res) {
                        $scope.imageUrl = res.prefix + response.logo[0].url;
                        vm.logoIsLoaded = true;
                    })
                }
                else {
                    vm.logoIsLoaded = true;
                }
                var mainBranch = $filter('filter')(vm.formWizard.branches, { is_main: true });
                if (mainBranch) {
                    vm.formWizard.main_branch = mainBranch[0];
                    vm.mainBranch = vm.formWizard.main_branch;
                }
                initTree();
            })
        }

        function getBranches(idCompany) {
            var options = {
                owner: $scope.owner,
                company_id: idCompany
            };

            clientsService.getBranches(options).then(function (response) {
                vm.branches = [];
                vm.formWizard.branches = transformClients.branchesToForm(vm.branchFields, response.data, vm.formWizard, vm.branches);
                if (vm.formWizard.main_branch) {
                    vm.mainBranch = true;
                }
                initTree();
            })
        }

        function initTree() {
            vm.tree = [];
            vm.formWizard.personnel = [];
            angular.forEach(vm.formWizard.branches, function (branch) {
                var divisions = {};
                angular.forEach(branch.division_users, function (divisionUser) {
                    if (angular.isUndefined(divisions[divisionUser.division_id])) {
                        divisions[divisionUser.division_id] = {
                            label: divisionUser.division.name,
                            type: 'division',
                            children: [],
                            positions: {}
                        };
                    }
                    if (angular.isUndefined(divisions[divisionUser.division_id].positions[divisionUser.job_position_id])) {
                        divisions[divisionUser.division_id].positions[divisionUser.job_position_id] = {
                            label: divisionUser.job_position ? divisionUser.job_position.name : '',
                            type: 'job_position',
                            children: []
                        }
                    }

                    divisions[divisionUser.division_id].positions[divisionUser.job_position_id].children.push({
                        label: divisionUser.user.first_name + ' ' + divisionUser.user.last_name,
                        type: 'user',
                        user: divisionUser.user,
                        storagePrefix: $scope.storagePrefix
                    })
                    var personnel = angular.copy(divisionUser.user);
                    personnel.branch_id = branch.id;
                    personnel.division = divisionUser.division.id;
                    personnel.position = divisionUser.job_position ? divisionUser.job_position.id : divisionUser.job_position_id;
                    vm.formWizard.personnel.push(personnel);

                    divisions[divisionUser.division_id].children = [];
                    for (var key in divisions[divisionUser.division_id].positions) {
                        divisions[divisionUser.division_id].children.push(divisions[divisionUser.division_id].positions[key]);
                    }
                })
                var object = {
                    label: branch.name,
                    type: 'branch',
                    children: [
                    ]
                };
                for (var key in divisions) {
                    object.children.push(divisions[key]);
                }

                /*
                {
                            label: 'Dirección',
                            children: [
                                {
                                    label: 'Director'
                                },
                                {
                                    label: 'Administrador'
                                }
                            ]
                        }
                 */
                vm.tree.push(object);
            })
        }

        function getDataCompany(idCompany) {
            getCompany(idCompany);
        }

        function getInfoCompany(company) {
            companyToForm(company);
            getDataCompany(company.id);
            vm.legalDocumentsFolderID = null;
            var options = {
                owner: $scope.owner,
                id_company: company.id
            }
            clientsService.getLegalFolder(options).then(function (res) {
                vm.legalDocumentsFolderID = res.id;
            })
        }

        function companyToForm(company) {
            vm.formWizard = {};
            vm.formWizard.company = {};
            vm.formWizard.company.name = company.name;
            vm.formWizard.personnel = [];
            vm.formWizard.branch = [];

        }

        function branchToForm(id) {
            var options = {
                owner: $scope.owner,
                id: id
            };
            clientsService.getBranch(options).then(function (response) {
                vm.formWizard.branches = [];
                vm.formWizard.branches.push(transformClients.branchToForm(angular.copy(vm.branchFields), response));
            })
        }

        function openCompany(company, ev) {
            if (vm.fromComplaint) {
                $mdDialog.show({
                    controller: 'NewClientDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/clients-complaints/dialogs/new-client-dialog/new-client-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        company: company,
                        main_branch: {},
                        sectors: vm.sectors,
                        regions: vm.regions,
                        regionsLiterals: vm.regionsLiterals
                    }
                }).then(function (res) {
                    if (res) {
                        vm.formWizard = {};
                        vm.formWizard.company = res.company;
                        vm.formWizard.main_branch = res.branch;
                        delete vm.formWizard.company.extra_data;
                        $scope.image = res.image
                        vm.updateLogotype = res.updateLogotype;
                        $scope.isLoading = true;
                        vm.idCompany = res.company.id
                        vm.updateAfterLogo = true;
                        vm.forceUpdateBranch = true;
                        createCompany(null, true);
                    }
                });
            } else {
                vm.idCompany = company.id;
                //vm.readView = true;
                vm.preview = true;
                getInfoCompany(company);
            }

        }

        function editCompany() {
            vm.users = [];
            $rootScope.$broadcast('select-company', vm.formWizard.company);
            sessionService.set('companySelected', vm.formWizard.company);
            angular.forEach(vm.formWizard.personnel, function (u) {
                var userExists = $filter('filter')(vm.users, { id: u.id });
                if (userExists.length < 1) {
                    vm.users.push(u);
                }
            })
            vm.readView = true;
            vm.preview = false;
        }


        function createUser(type, subForm, subIndex, noPush) {
            //var itemUser = transformClients.userToDTO(subForm, type);
            var itemUser = vm.formWizard[type][subIndex];
            if ((vm.positionsIds.compliance_officer == itemUser.position || vm.positionsIds.compliance_comite == itemUser.position || vm.positionsIds.data_protection == itemUser.position && itemUser.user_type > 3) && !vm.quotaexceded) {
                itemUser.user_type = 3;
            } else if (vm.positionsIds.collaborator == itemUser.position && !itemUser.user_type) {
                itemUser.user_type = 6; // Usuario COLLABORATOR
            } else if (itemUser.user_type > 4 || !itemUser.user_type) {
                if (itemUser.password) {
                    itemUser.user_type = 4;
                } else {
                    itemUser.user_type = 5;
                }
            }
            itemUser.region_id = vm.formWizard.company.region_id;
            if (!angular.isUndefined(itemUser.password) && itemUser.password.length == 0) {
                delete itemUser.password;
            }
            var options = {
                owner: $scope.owner,
                item: itemUser
            };
            clientsService.createUser(options).then(function (response) {
                vm.users.push(response);
                vm.formWizard[type][subIndex].id = response.id;
                if (!angular.isUndefined(itemUser.position) && !angular.isUndefined(itemUser.division) && !angular.isUndefined(itemUser.branch_id)) {
                    vm.addUsersJobFromUserId(itemUser.division, itemUser.position, itemUser.branch_id, itemUser, noPush)
                }
                $scope.uploadingFotoUserId = response.id;
                if (vm.files.length > 0) {
                    angular.forEach(vm.files, function (f) {
                        vm.uploadMedia(f, response.id, 'user_photo')
                    })
                } else {
                    delete $scope.uploadingFotoUserId;
                    delete vm.files;
                }

            }, function (error) {
                getUsers();
                getDataCompany(vm.idCompany);
            })
        }

        function uploadMedia(file, idValue, uploadKey) {
            if (!file.$error) {
                var token = undefined;
                $scope.uploadingFile = true;
                console.debug("UPLOAD STARTED______****", file)
                mediaService.getS3UploadPreSignedUrl({
                    owner: $scope.owner,
                    uploadKey: uploadKey,
                    fileName: file.name,
                    rowId: idValue
                })
                    .then(function (resp) {
                        token = resp.token;
                        file.id_media = resp.id_media;
                        file.upload = Upload.http({
                            url: resp.url,
                            skipAuthorization: true,
                            method: 'PUT',
                            headers: {
                                "Content-Type": file.type != '' ? file.type : 'application/octet-stream'
                            },
                            data: file
                        })
                        file.upload.then(function (response) {
                            file.result = response.data;
                            $timeout(function () {
                                $scope.log = 'file: ' +
                                    file.name +
                                    ', Response: ' + JSON.stringify(response.data) +
                                    ', ID: ' + file.id_media +
                                    '\n' + $scope.log;
                            });
                            console.debug("FINISHING UPLOAD______****", file)
                            mediaService.finishedUploadingFileToCdn({
                                owner: $scope.owner,
                                idMedia: file.id_media,
                                token: token
                            }).then(function () {
                                $scope.uploadingFile = false;
                                getCompany(vm.idCompany);
                                delete $scope.uploadingFotoUserId;
                                delete vm.files;
                            })

                        }, function (response) {
                            if (response.status > 0)
                                $scope.errorMsg = response.status + ': ' + response.data;
                        });

                        file.upload.progress(function (evt) {
                            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                        });
                    })
            }
        };


        function updateUser(type, subIndex) {
            var itemUser = vm.formWizard[type][subIndex];
            if (itemUser.password && itemUser.user_type > 4) {
                itemUser.user_type = 4;
            }
            var options = {
                owner: $scope.owner,
                id: itemUser.id,
                item: itemUser
            };
            clientsService.updateUser(options).then(function () {
                $scope.uploadingFotoUserId = itemUser.id;
                delete itemUser.password;
                if (vm.files && vm.files.length > 0) {
                    var uploading = false;
                    angular.forEach(vm.files, function (f) {
                        if (!f.url) {
                            uploading = true;
                            vm.uploadMedia(f, itemUser.id, 'user_photo')
                        }
                    })
                    if (!uploading) {
                        delete $scope.uploadingFotoUserId;
                        delete vm.files;
                    }
                } else {
                    delete $scope.uploadingFotoUserId;
                    delete vm.files;
                }
                getUsers();
                getDataCompany(vm.idCompany);
            });
        }

        function addUsersJob(divisionId, jobPositionId, branchId, title) {
            if (!angular.isUndefined(vm.formWizard[title]) && vm.formWizard[title].length > 0) {
                angular.forEach(vm.formWizard[title], function (u) {
                    if (angular.isUndefined(u.isAdded)) {
                        clientsService.addUserToCompany({
                            owner: $scope.owner,
                            user_id: u.id,
                            company_id: vm.idCompany
                        }).then(function (response) {

                        })
                        clientsService.addUserJobPosition({
                            owner: $scope.owner,
                            user_id: u.id,
                            branch_id: branchId,
                            division_id: divisionId,
                            job_position_id: jobPositionId
                        }).then(function (response) {
                            u.branch_id = branchId;
                            u.division = divisionId;
                            u.position = jobPositionId;
                            u.isAdded = true;
                            vm.formWizard.personnel.push(u);
                        })
                    }
                })
            }

        }
        function addUsersJobFromUserId(divisionId, jobPositionId, branchId, user, noPush) {
            if (angular.isUndefined(user.isAdded) && divisionId && jobPositionId && branchId) {
                clientsService.addUserToCompany({
                    owner: $scope.owner,
                    user_id: user.id,
                    company_id: vm.idCompany
                }).then(function (response) {

                })
                clientsService.addUserJobPosition({
                    owner: $scope.owner,
                    user_id: user.id,
                    branch_id: branchId,
                    division_id: divisionId,
                    job_position_id: jobPositionId
                }).then(function (response) {
                    user.branch_id = branchId;
                    user.division = divisionId;
                    user.position = jobPositionId;
                    user.isAdded = true;
                    if (!noPush) {
                        vm.formWizard.personnel.push(user);
                    }
                })
            }
        }
        function createBranch(subForm, isMain, addUsers, msWizard, close) {
            var item = transformClients.createBranch(subForm, vm.idCompany, isMain, vm.formWizard.company.region_id);
            var options = {
                owner: $scope.owner,
                item: item,
            };
            clientsService.createBranch(options).then(function (response) {
                if (isMain && vm.formWizard.main_branch) {
                    vm.formWizard.main_branch.id = response.id;
                    if (msWizard) {
                        if (!close) {
                            msWizard.nextStep();
                        } else {
                            vm.closeForm(true);
                        }
                        $timeout(function () {
                            angular.element('.content')[0].scrollTop = 0
                            vm.loadingStep = false;
                        })
                    }
                    if (addUsers) {
                        if (angular.isUndefined(vm.formWizard.personnel)) {
                            vm.formWizard.personnel = [];
                        }
                        var allAdministrators = $filter('filter')(vm.formWizard.personnel, { division: vm.divisionsId.administrator, position: vm.positionsIds.administrator });
                        var allManagers = $filter('filter')(vm.formWizard.personnel, { division: vm.divisionsId.managerLegal, position: vm.positionsIds.managerLegal });

                        angular.forEach(allAdministrators, function (u) {
                            u.branch_id = vm.formWizard.main_branch.id;
                            vm.addUsersJobFromUserId(u.division, u.position, u.branch_id, u, true)
                        })
                        angular.forEach(allManagers, function (u) {
                            u.branch_id = vm.formWizard.main_branch.id;
                            vm.addUsersJobFromUserId(u.division, u.position, u.branch_id, u, true)
                        })
                    }
                } else {
                    subForm.id = response.id;
                }
                if (!vm.branches) {
                    vm.branches = [];
                }
                vm.branches.push(response);
                for (var i = 0; i < vm.formWizard.branch.length; i++) {
                    if (response.id == vm.formWizard.branch[i].id) {
                        vm.formWizard.branch[i] = response;
                    }
                }
                // getCompany(vm.idCompany)
            })
        }

        function addBranchToForm(subForm, isMain) {
            if (!vm.formWizard.branch) {
                vm.formWizard.branch = [];
            }
            vm.formWizard.branch.push(subForm);
        }

        function removeBranchFromForm($index) {
            if (!angular.isUndefined(vm.formWizard.branch[$index])) {
                var branchData = vm.formWizard.branch[$index];
                var options = {
                    owner: $scope.owner,
                    id: branchData.id,
                };
                clientsService.deleteBranch(options)
                    .then(function (response) {
                        vm.formWizard.branch.splice($index, 1)
                    });
            }
        }

        function removeBranch($index) {
            var elementsToRemove = vm.formWizard.branches.splice($index, 1)
            var branch_id = transformClients.getIdBranch(elementsToRemove[0]);
            var options = {
                owner: $scope.owner,
                id: branch_id,
            };
            clientsService.deleteBranch(options);
        }
        function editBranchDialog($event, $index) {
            var branchSelected = vm.formWizard.branches[$index]
            $mdDialog.show({
                controller: 'EditBranchDialog',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/clients-complaints/dialogs/edit-branch/edit-branch-dialog.controller.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    region_id: vm.formWizard.company.region_id,
                    branch: branchSelected
                },
            })
                .then(function (resp) {
                    if (resp) {
                        var options = {
                            owner: $scope.owner,
                            id: resp.id,
                            item: resp
                        };
                        clientsService.updateBranch(options).then(function (response) {
                            vm.formWizard.branches[$index] = response;
                        })
                    }
                });
        }

        function getIdBranch(form, isMain) {
            if (isMain) {
                return form.id;
            }
            else {
                return transformClients.getIdFromForm(form);
            }
        }

        function updateBranch(form, isMain, addUsers) {
            var options = {
                owner: $scope.owner,
                item: transformClients.createBranch(form, vm.idCompany, isMain, vm.formWizard.company.region_id),
                id: getIdBranch(form, isMain)
            };
            clientsService.updateBranch(options).then(function (response) {
            });
        }

        function updateSubForm(title, subForm, index) {
            transformClients.updateFullName(subForm);
            vm.formWizard[title][index] = subForm;
        }

        function createSubForm(title, subForm, noFields, branchId) {
            if (noFields) {
                var newData = {};
                if (branchId) {
                    newData.branch_id = branchId;
                } else if (vm.formWizard.main_branch && vm.formWizard.main_branch.id) {
                    newData.branch_id = vm.formWizard.main_branch.id;
                }
                angular.forEach(subForm, function (field) {
                    if (field.field == 'profile_color') {
                        newData[field.field] = vm.profileColors[Math.floor(Math.random() * vm.profileColors.length)];
                    } else {
                        newData[field.field] = field.value;
                    }
                })
                subForm = newData
            } else {
                transformClients.setFullName(subForm);
            }
            if (!vm.formWizard) {
                vm.formWizard = {};
            }
            if (angular.isUndefined(vm.formWizard[title])) {
                vm.formWizard[title] = [];
            }
            vm.formWizard[title].push(subForm);
            return (vm.formWizard[title].length > 0) ? vm.formWizard[title].length - 1 : undefined;
        }
        // Asegurarse de que implemented_measures esté inicializado
vm.initializeImplementedMeasures = function () {
    if (!vm.formWizard.company.extra_data) {
        vm.formWizard.company.extra_data = {};
    }
    if (!vm.formWizard.company.extra_data.implemented_measures) {
        vm.formWizard.company.extra_data.implemented_measures = [];
    }
};

        function newForm(ev) {
    if (vm.quota.companies_registered >= vm.quota.max_allowed_companies) {
        $mdDialog.show({
            controller: 'CompanyQuotaDialogController',
            controllerAs: 'vm',
            templateUrl: 'app/main/dialogs/companyQuotaDialog/companyQuotaDialog.html',
            parent: angular.element($document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
            }
        }).then(function (res) {
            if (res && res.type) {
                if (res.type == 'upgrade') {
                    console.log("go upgrade screen");
                } else {
                    vm.idCompany = '';
                    vm.mainBranch = {};
                    vm.readView = true;
                }
            }
        });
    } else {
        // Llama a resetFormWizard() antes de establecer vm.idCompany y vm.mainBranch
        resetFormWizard();

        if (vm.fromComplaint) {
            $mdDialog.show({
                controller: 'NewClientDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/clients-complaints/dialogs/new-client-dialog/new-client-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    company: null,
                    main_branch: null,
                    sectors: vm.sectors,
                    regions: vm.regions,
                    regionsLiterals: vm.regionsLiterals
                }
            }).then(function (res) {
                if (res) {
                    vm.formWizard = {};
                    vm.formWizard.company = res.company;
                    vm.formWizard.main_branch = res.branch;
                    $scope.image = res.image
                    $scope.isLoading = true;
                    vm.forceCreateBranch = true;
                    createCompany(null, true);
                }
            });
        } else {
            vm.idCompany = '';
            vm.mainBranch = {};
            vm.readView = true;
            $timeout(function () {
                vm.formWizard.company.region_id = sessionService.user.region_id;
            }, 1000)
        }
    }
}


        function closeForm(preview) {
            if (vm.idCompany) {
                getDataCompany(vm.idCompany);
                vm.readView = false;
                vm.preview = preview;
            } else {
                vm.goClients();
            }
        }

function resetFormWizard() {
    vm.formWizard = {
        company: {},
        main_branch: {},
        administrator: [],
        managerLegal: [],
        branches: []
    };
    $scope.imageUrl = null;
}





        function createCompany(msWizard, close) {
            var options = {
                owner: $scope.owner,
                item: transformClients.companyToDTO(vm.formWizard)
            };
            vm.formWizard.company.region_id = options.item.region_id;
            if (vm.idCompany) {
                options.id = vm.idCompany;
                clientsService.updateCompany(options).then(function (response) {
                    if (!close) {
                        msWizard.nextStep();
                    } else {
                        vm.closeForm(vm.fromComplaint ? false : true);
                        if (!vm.updateAfterLogo) {
                            $scope.isLoading = false;
                        }
                    }
                    if (vm.forceUpdateBranch) {
                        vm.formWizard.main_branch.name = vm.formWizard.company.name;
                        updateBranch(vm.formWizard.main_branch, true, true);
                    }
                });
                $timeout(function () {
                    angular.element('.content')[0].scrollTop = 0
                    vm.loadingStep = false;
                })

                if (vm.updateLogotype && $scope.image) {
                    uploadImage($scope.image, vm.idCompany, 'company_logo');
                    vm.updateLogotype = false;
                } else {
                    $scope.isLoading = false;
                }
            } else {
                options.item.is_owner = vm.companies.length > 0 ? 0 : true;
                clientsService.createCompany(options).then(function (response) {
                    sessionService.authenticate($cookies.get('owner'));

                    vm.idCompany = response.id;
                    if (!vm.formWizard.main_branch) {
                        vm.formWizard.main_branch = {
                            name: msUtils.translate('GLOBAL.MAIN_BRANCH')
                        }
                    }
                    if (vm.forceCreateBranch) {
                        createBranch(vm.formWizard.main_branch, true, true, msWizard, false);
                    }
                    vm.formWizard.administrator = [];
                    vm.formWizard.managerLegal = [];
                    vm.formWizard.branches = [];
                    initWatchers();
                    getInfoCompany(response)
                    if ($scope.image) {
                        uploadImage($scope.image, vm.idCompany, 'company_logo', response);
                    } else {
                        $rootScope.$broadcast('select-company', response);
                        $scope.isLoading = false;
                    }

                    if (!close) {
                        msWizard.nextStep();
                        $timeout(function () {
                            angular.element('.content')[0].scrollTop = 0
                            vm.loadingStep = false;
                        })
                        $rootScope.pagination_resetquery();
                    }

                })
            }
        }

        function uploadImage(file, idCompany, uploadKey, responseAndclose) {
            if (!file.$error) {
                var token = undefined;
                mediaService.getS3UploadPreSignedUrl({
                    owner: $scope.owner,
                    uploadKey: uploadKey,
                    fileName: file.name,
                    rowId: idCompany
                })
                    .then(function (resp) {
                        token = resp.token;
                        file.id_media = resp.id_media;
                        file.upload = Upload.http({
                            url: resp.url,
                            skipAuthorization: true,
                            method: 'PUT',
                            headers: {
                                "Content-Type": file.type != '' ? file.type : 'application/octet-stream'
                            },
                            data: file
                        });

                        file.upload.then(function (response) {
                            file.result = response.data;
                            $timeout(function () {
                                $scope.log = 'file: ' +
                                    file.name +
                                    ', Response: ' + JSON.stringify(response.data) +
                                    ', ID: ' + file.id_media +
                                    '\n' + $scope.log;
                            });
                            mediaService.finishedUploadingFileToCdn({
                                owner: $scope.owner,
                                idMedia: file.id_media,
                                token: token
                            }).then(res => {
                                if (responseAndclose || vm.updateAfterLogo) {
                                    vm.updateAfterLogo = false;
                                    $rootScope.$broadcast('select-company', responseAndclose);
                                    $rootScope.pagination_resetquery();
                                    $scope.isLoading = false;
                                }
                            })


                        }, function (response) {
                            if (response.status > 0) {
                                $scope.errorMsg = response.status + ': ' + response.data;
                            }
                        });

                        file.upload.progress(function (evt) {
                            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                        });

                    })
            }
        };

        function nextStep(msWizard, close) {
    vm.loadingStep = true;
    if (msWizard.selectedIndex === 0) {
        createCompany(msWizard, close);
    } else if (msWizard.selectedIndex === 1) { 
        if (vm.formWizard.main_branch.id) {
            updateBranch(vm.formWizard.main_branch, true, true);
            if (!close) {
                msWizard.nextStep();
            } else {
                vm.closeForm(true);
            }
            $timeout(function () {
                angular.element('.content')[0].scrollTop = 0;
                vm.loadingStep = false;
            });
        }
        else {
            createBranch(vm.formWizard.main_branch, true, true, msWizard, close);
            vm.mainBranch = true;
            saveRemainBranches();
        }
    }
    else {
        msWizard.nextStep();
        $timeout(function () {
            angular.element('.content')[0].scrollTop = 0;
            vm.loadingStep = false;
        });
    }
}


        function saveRemainBranches() {
            if (!angular.isUndefined(vm.formWizard.branch) && vm.formWizard.branch.length > 0) {
                angular.forEach(vm.formWizard.branch, function (b) {
                    if (angular.isUndefined(b.id)) {
                        createBranch(b);
                    }
                })
            }

        }
        function previousStep(msWizard) {
            if (msWizard.selectedIndex === 0) {
                return true;
            }
            return false;
        }

        function prevStep(msWizard) {
            vm.loadingStep = true;
            msWizard.previousStep()
            $timeout(function () {
                angular.element('.content')[0].scrollTop = 0
                vm.loadingStep = false;
            })

        }
        function deleteClient() {
            var threads = angular.copy(vm.selectedThreads);
            vm.selectedThreads = [];
            for (var j = 0; j < threads.length; j++) {
                var options = {
                    owner: $scope.owner,
                    id: threads[j].id
                };
                clientsService.deleteClient(options).then(function (response) {
                    $rootScope.pagination_resetquery();
                    sessionService.authenticate($cookies.get('owner'));
                    $rootScope.$broadcast('select-company', null);
                    companyService.setCompanyId(null);
                    sessionService.set('companySelected', null);
                })
            }
        }

        function deleteLogotype() {
            if (vm.formWizard.company.logo.length > 0) {
                for (var i = 0; i < vm.formWizard.company.logo.length; i++) {
                    const itemLogo = vm.formWizard.company.logo[i];
                    var options = {
                        owner: $scope.owner,
                        id: itemLogo.id
                    }
                    documentsService.deleteDocument(options).then(function () {
                        vm.formWizard.company.logo = null;
                    })
                }
            }
            $scope.image = undefined;
            $scope.imageUrl = undefined;
        }

        function openImageDialog(ev, index, images, img) {
            var imagesCopy = [];
            imagesCopy.push(img);
            $mdDialog.show({
                controller: 'ImageDialogClientsController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/clients-complaints/dialogs/image/image-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Images: imagesCopy,
                    ImageSelected: img,
                    cropFormats: false,
                    MediaFull: false
                }
            });
        }


        function mediaDialogSingle(ev, field) {
            $mdDialog.show({
                controller: 'MediaClientsController',
                controllerAs: 'vm',
                locals: {
                    owner: $scope.owner,
                    multipleSelection: true,
                    isTiny: false
                },
                templateUrl: 'app/main/apps/clients-complaints/dialogs/media/media-clients.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true

            }).then(function (image) {
                if (image) {
                    if (($scope.image && vm.idCompany) || vm.idCompany) {
                        vm.updateLogotype = true;
                    }
                    $scope.image = image;
                }
            });
        }

        function sendForm() {
            vm.showForm = false;
        }

        function goClients() {
            vm.formWizard = {};
            $scope.image = undefined;
            $scope.imageUrl = undefined;
            vm.readView = false;
            vm.preview = false;
            vm.isQuestions = false;
            vm.showForm = true;
            vm.idCompany = '';
            vm.mainBranch = {};
            vm.branchQuestion = undefined;
            destroyWatchers()
            $rootScope.pagination_resetquery();
        }

        function goQuestions(sector) {
            var options = {
                owner: $scope.owner
            };
            if (!vm.allQuestions) {
                options.sector_id = vm.formWizard.company.sector_id;
            }
            clientsService.getQuestions(options).then(function (response) {
                vm.questions = response.data;
                vm.isQuestions = true;
            })
        }

        function getAnswer() {
            return transformClients.getAnswer(vm.questions);
        }

        function finishQuestion() {
            var item = {
                questions: getAnswer(),
                client_id: vm.idClient,
                branches: vm.branchQuestion
            };
            var options = {
                owner: $scope.owner,
                item: item
            };
            clientsService.evaluateAnswer(options).then(function (response) {
            })
            goClients();
        }


        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        function isSelected(thread) {
            return vm.selectedThreads.indexOf(thread) > -1;
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        function toggleSelectThread(thread, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedThreads.indexOf(thread) > -1) {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            }
            else {
                vm.selectedThreads.push(thread);
            }
        }

        /**
         * Select threads. If key/value pair given,
         * threads will be tested against them.
         *
         * @param [key]
         * @param [value]
         */
        function selectThreads(key, value) {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedThreads = [];

            for (var i = 0; i < vm.clients.length; i++) {
                if (angular.isUndefined(key) && angular.isUndefined(value)) {
                    vm.selectedThreads.push(vm.clients[i]);
                    continue;
                }

                if (angular.isDefined(key) && angular.isDefined(value) && vm.clients[i][key] === value) {
                    vm.selectedThreads.push(vm.clients[i]);
                }
            }
        }

        /**
         * Deselect threads
         */
        function deselectThreads() {
            vm.selectedThreads = [];
        }

        /**
         * Toggle select threads
         */
        function toggleSelectThreads() {
            if (vm.selectedThreads.length > 0) {
                vm.deselectThreads();
            }
            else {
                vm.selectThreads();
            }
        }

        /**
         * Set the status on given thread, current thread or selected threads
         *
         * @param key
         * @param value
         * @param [thread]
         * @param [event]
         */
        function setThreadStatus(key, value, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                thread[key] = value;
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                vm.currentThread[key] = value;
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                vm.selectedThreads[x][key] = value;
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleThreadStatus(key, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                if (typeof (thread[key]) !== 'boolean') {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                if (typeof (vm.currentThread[key]) !== 'boolean') {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                if (typeof (vm.selectedThreads[x][key]) !== 'boolean') {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }


        /**
         * Change the view
         *
         * @param view
         */
        function changeView(view) {
            if (vm.views[view]) {
                vm.defaultView = view;
                vm.currentView = view;
            }
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function showUserImage(user) {
            return $scope.storagePrefix + user.files.url
        }

        function removeUser(usersArray, idx, type, branch) {
            var userToRemove = angular.copy(usersArray[idx]);
            var userId = userToRemove.id;
            var jobId = userToRemove.position;
            var typeRemove = type;
            var divisionId = userToRemove.division;
            var branchId = vm.formWizard.main_branch.id;
            if (branch) {
                branchId = branch.id;
            }
            if (!branchId) {
                usersArray.splice(idx, 1)
            } else {
                clientsService.removeUserJobPosition({
                    owner: $scope.owner,
                    user_id: userId,
                    branch_id: branchId,
                    division_id: divisionId,
                    job_position_id: jobId
                }).then(function (response) {
                    angular.forEach(vm.formWizard.personnel, function (u, idx2) {
                        if (u.branch_id == branchId && u.id == userId && u.division == divisionId && u.position == jobId) {
                            vm.formWizard.personnel.splice(idx2, 1);
                        }
                    })
                }).catch(function () {
                    console.log('already removed');
                    angular.forEach(vm.formWizard.personnel, function (u, idx2) {
                        if (u.branch_id == branchId && u.id == userId && u.division == divisionId && u.position == jobId) {
                            vm.formWizard.personnel.splice(idx2, 1);
                        }
                    })
                })
            }
        }

        function editUser(usersArray, idx) {
            vm.openDialogForm('personnel', '', '', usersArray[idx], idx)
        }

        function getDivisionName(divisionId) {

            var x = vm.divisions.filter(function (division) {
                return (division.id == divisionId);
            });
            return x;
        }

        function getPositionName(positionId) {
            var x = vm.positions.filter(function (position) {
                return (position.id == positionId);
            });
            return x;
        }


        function areFromType(users, type) {
            var result = [];
            for (var i = 0; i < users.length; i++) {
                if (vm.isFromType(users[i], type)) {
                    result.push(users[i]);
                }
            }
            return result;
        }
        function isFromType(user, type) {
            if ((!user.branch_id || user.branch_id == vm.formWizard.main_branch.id) && user.position == vm.positionsIds[type] && user.division == vm.divisionsId[type]) {
                return true
            }
            return false;
        }


        function initWatchers() {
            vm.watchers = [];
            initWatcher('files_belogns_to_holding', 'belogns_to_holding');
            initWatcher('files_social_responsability', 'social_responsability');
            initWatcher('files_iva', 'iva');
            initWatcher('files_is', 'is');
        }
        function initWatcher(files_property, key) {
            vm.watchers.push($scope.$watch('vm.' + files_property, function () {
                $scope.formUpload = false;
                if (vm[files_property] != null) {
                    console.log(vm[files_property])
                    // make files array for not multiple to be able to be used in ng-repeat in the ui
                    if (!angular.isArray(vm[files_property])) {
                        $timeout(function () {
                            $scope[files_property] = vm[files_property] = [vm[files_property]];
                        });
                        return;
                    }
                    for (var i = 0; i < vm[files_property].length; i++) {
                        $scope.errorMsg = null;
                        (function (f) {
                            vm.upload(f, key);
                        })(vm[files_property][i]);
                    }
                }
            }));
        }

        function destroyWatchers() {
            if (vm.watchers) {
                for (var i = 0; i < vm.watchers.length; i++) {
                    const watcher = vm.watchers[i];
                    watcher();
                }
                vm.watchers = [];
            }
        }

        function deleteCompany(ev) {
            const message = $translate.instant('GLOBAL.ARE_YOU_SURE');
            const yes = $translate.instant('GLOBAL.YES');
            const no = $translate.instant('GLOBAL.NO');

            const confirm = $mdDialog.confirm()
                .title(message)
                .targetEvent(ev)
                .ok(yes)
                .cancel(no);

            $mdDialog.show(confirm).then(e => {
                vm.deleteClient();
            })
                .catch(err => { })

        }

        function upload(file, tag) {
            $scope[tag + '_isLoading'] = true;
            if (!file.$error) {
                //				console.debug("UPLOAD______****", file)
                documentsService.getS3UploadPreSignedUrl({
                    owner: $scope.owner,
                    fileName: file.name,
                    groupId: vm.legalDocumentsFolderID
                })
                    .then(function (resp) {
                        var token = resp.token;
                        file.upload = Upload.http({
                            url: resp.url,
                            skipAuthorization: true,
                            method: 'PUT',
                            headers: {
                                "Content-Type": file.type != '' ? file.type : 'application/octet-stream'
                            },
                            data: file
                        });

                        file.upload.then(function (response) {
                            file.result = response.data;
                            $timeout(function () {
                                $scope.log = 'file: ' +
                                    file.name +
                                    ', Response: ' + JSON.stringify(response.data) +
                                    ', ID: ' + file.id_media +
                                    '\n' + $scope.log;
                            });

                            vm.isLoading = true;
                            documentsService.finishedUploadingFile({
                                owner: $scope.owner,
                                token: token
                            }).then(function (response) {
                                vm.isLoading = false;
                                if (!vm.formWizard.company.extra_data[tag + '_files']) {
                                    vm.formWizard.company.extra_data[tag + '_files'] = [];
                                }
                                vm.formWizard.company.extra_data[tag + '_files'].push(JSON.parse(angular.toJson(response)))
                                $scope[tag + '_isLoading'] = false;
                                var options = {
                                    owner: $scope.owner,
                                    id: vm.idCompany,
                                    item: transformClients.companyToDTO(vm.formWizard)
                                };
                                clientsService.updateCompany(options).then(function (response) {
                                });
                                $mdDialog.hide({ update: true });
                            }, function (error) {
                                vm.isLoading = false;
                                vm.importError = error;
                            })
                            vm.importFinished = true;
                        }, function (response) {
                            if (response.status > 0)
                                $scope.errorMsg = response.status + ': ' + response.data;
                        });

                        file.upload.progress(function (evt) {
                            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                        });

                    })
            }
        };

        $scope.$on('$destroy', function () {
            destroyWatchers();
        });

    }
})();

(function () {
    'use strict';

    angular
        .module('app.clients-complaints')
        .service('clientsService', clientsService);

    /** @ngInject */
    // I provide access to the session store.
    function clientsService($q, $resource, settingsDomainService, sessionService, COMMON, $window, $mdToast, $state) {

        function getClients(options) {
            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });

            // var is_woner = 0;
            // if ($state.current.name.indexOf('mycompany') >= 0) {
            //     is_woner = 1;
            // }

            resourceClients.get({
                owner: options.owner,
                page: options.page,
                search: options.searchStringFilter,
                paginate: options.paginate,
                sortField: options.sortField,
                sortDir: options.sortDir,
                filters: JSON.stringify(filters),
                resultsPerPage: options.resultsPerPage,
                withCompany: options.withCompany,
                withLogo: true
            },
                function (responseResult) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getStoragePrefix(options) {
            var deferred = $q.defer();
            resourceStoragePrefix.get({
                owner: options.owner,
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateClient(options) {
            var deferred = $q.defer();
            resourceClients.update({
                owner: options.owner,
                id: options.id
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);

        }

        function createClient(options) {
            var deferred = $q.defer();
            resourceClients.post({
                owner: options.owner
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);

        }

        function createBranch(options) {
            var deferred = $q.defer();
            resourceBranch.post({
                owner: options.owner
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }



        function deleteBranch(options) {
            var deferred = $q.defer();
            resourceBranch.delete(options, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function deleteClient(options) {
            var deferred = $q.defer();
            resourceClients.delete({
                owner: options.owner,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateCompany(options) {
            var deferred = $q.defer();
            resourceCompany.update({
                owner: options.owner,
                id: options.id
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function createCompany(options) {
            var deferred = $q.defer();
            resourceCompany.post({
                owner: options.owner
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function createUser(options) {
            var deferred = $q.defer();
            resourceUser.post({
                owner: options.owner
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateUser(options) {
            var deferred = $q.defer();
            resourceUser.update({
                owner: options.owner,
                id: options.id
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function addUserToCompany(options) {
            var deferred = $q.defer();
            resourceAddToCompany.put({
                owner: options.owner
            }, {
                    user_id: options.user_id,
                    company_id: options.company_id
                },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function addUserJobPosition(options) {
            var deferred = $q.defer();
            resourceAddJobPosition.put({
                owner: options.owner
            }, {
                    user_id: options.user_id,
                    branch_id: options.branch_id,
                    division_id: options.division_id,
                    job_position_id: options.job_position_id
                },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function removeUserJobPosition(options) {
            var deferred = $q.defer();
            resourceRemoveJobPosition.delete({
                owner: options.owner,
                user_id: options.user_id,
                branch_id: options.branch_id,
                division_id: options.division_id,
                job_position_id: options.job_position_id
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getUsers(options) {
            var deferred = $q.defer();
            resourceUser.get(options,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateBranch(options) {
            var deferred = $q.defer();
            resourceBranch.update({
                owner: options.owner,
                id: options.id
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getQuestions(options) {
            var deferred = $q.defer();
            resourceQuestion.get({
                owner: options.owner,
                id_sector: options.sector_id
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getSectors(options) {
            var deferred = $q.defer();
            resourceSectors.get({
                owner: options.owner,
                resultsPerPage: options.resultsPerPage
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);

        }

        function getPositions(options) {
            var deferred = $q.defer();
            resourcePositions.get({
                owner: options.owner,
                resultsPerPage: options.resultsPerPage
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getFileRegions() {
            var deferred = $q.defer();
            resourceFile.get({},
                function (responseResult) {
                    deferred.resolve(JSON.parse(angular.toJson(responseResult)));
                },
                function (e) {
                    showError(e)
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getDivisions(options) {
            var deferred = $q.defer();
            resourceDivisions.get({
                owner: options.owner,
                resultsPerPage: options.resultsPerPage
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getLegalFolder(options) {
            var deferred = $q.defer();
            resourceLegalFolder.get({
                owner: options.owner,
                id_company: options.id_company
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getRegions(options) {
            var deferred = $q.defer();
            resourceRegions.get({
                owner: options.owner
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getCompany(options) {
            var deferred = $q.defer();
            resourceCompany.get({
                owner: options.owner,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getBranches(options) {
            var deferred = $q.defer();
            resourceBranches.get(options,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function evaluateAnswer(options) {
            var deferred = $q.defer();
            resourceQuestion.post({
                owner: options.owner,
                evaluateAnswer: 'evaluateAnswers'
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getFilters(options) {
            var deferred = $q.defer();

            return (deferred.promise);
        }

        var resourceFile = $resource("/assets/json-i18n/region-literals.json", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: true
                }
            });


        var resourceClients = $resource(COMMON.BASE_API + "/owner/:owner/company/:id", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                delete: {
                    method: "DELETE",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                },
            });

        var resourceSectors = $resource(COMMON.BASE_API + "/owner/:owner/sector", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });

        var resourceCompany = $resource(COMMON.BASE_API + "/owner/:owner/company/:id", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                }
            });

        var resourceUser = $resource(COMMON.BASE_API + "/owner/:owner/user/:id/", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                }
            });

        var resourceAddToCompany = $resource(COMMON.BASE_API + "/owner/:owner/user/addToCompany", {
            // No default data
        }, {
                put: {
                    method: "PUT",
                    isArray: false
                }
            });

        var resourceAddJobPosition = $resource(COMMON.BASE_API + "/owner/:owner/user/addDivisionJobPosition", {
            // No default data
        }, {
                put: {
                    method: "PUT",
                    isArray: false
                }
            });

        var resourceRemoveJobPosition = $resource(COMMON.BASE_API + "/owner/:owner/user/removeDivisionJobPosition/:user_id/:branch_id/:division_id/:job_position_id", {
            // No default data
        }, {
                delete: {
                    method: "DELETE",
                    isArray: false
                }
            });

        var resourceQuestion = $resource(COMMON.BASE_API + "/owner/:owner/question/:evaluateAnswer", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                }
            });

        var resourceBranch = $resource(COMMON.BASE_API + "/owner/:owner/branch/:id", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                },
                delete: {
                    method: "DELETE",
                    isArray: false
                }
            });
        var resourceBranches = $resource(COMMON.BASE_API + "/owner/:owner/branch/", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });
        var resourceStoragePrefix = $resource(COMMON.BASE_API + "/owner/:owner/upload/storagePrefix", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });

        var resourcePositions = $resource(COMMON.BASE_API + "/owner/:owner/jobPosition", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });

        var resourceDivisions = $resource(COMMON.BASE_API + "/owner/:owner/division", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });
        var resourceLegalFolder = $resource(COMMON.BASE_API + "/owner/:owner/fileGroup/legalDocuments/:id_company", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });
        var resourceRegions = $resource(COMMON.BASE_API + "/owner/:owner/region", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });


        return ({
            get: getClients,
            getFilters: getFilters,
            getFileRegions: getFileRegions,
            getRegions: getRegions,
            createClient: createClient,
            createCompany: createCompany,
            deleteClient: deleteClient,
            updateClient: updateClient,
            updateCompany: updateCompany,
            createUser: createUser,
            updateUser: updateUser,
            addUserToCompany: addUserToCompany,
            addUserJobPosition: addUserJobPosition,
            removeUserJobPosition: removeUserJobPosition,
            getSectors: getSectors,
            getQuestions: getQuestions,
            createBranch: createBranch,
            getLegalFolder: getLegalFolder,
            updateBranch: updateBranch,
            deleteBranch: deleteBranch,
            getCompany: getCompany,
            getStoragePrefix: getStoragePrefix,
            getBranches: getBranches,
            getPositions: getPositions,
            getDivisions: getDivisions,
            getUsers: getUsers,
            evaluateAnswer: evaluateAnswer
        });

    }

})();
(function () {
    'use strict';

    angular
        .module('app.calendar')
        .controller('CalendarController', CalendarController);

    /** @ngInject */
    function CalendarController($mdDialog, $document, Contacts, ContactsCrew) {
        var vm = this;

        // Data
        var date = new Date();
        var d = date.getDate();
        var m = date.getMonth();
        var y = date.getFullYear();

        function getRandomInt(min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        }
        function guid() {
            function s4() {
                return Math.floor((1 + Math.random()) * 0x10000)
                    .toString(16)
                    .substring(1);
            }
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
                s4() + '-' + s4() + s4() + s4();
        }

        vm.events = [
            [
                {
                    id: 1,
                    title: 'N001B MDW > BJC 5 13:45 CST > 16:15 MST',
                    start: new Date(y, m, 1),
                    end: null,
                    color: 'red'
                },
                {
                    id: 2,
                    title: 'N001B COO > BJC 2 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d - 5),
                    end: null,
                    color: 'blue'
                },
                {
                    id: 3,
                    title: 'N001B LAX > NYC 1 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d - 3, 16, 0),
                    end: null,
                    color: 'violet'
                },
                {
                    id: 4,
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d + 4, 16, 0),
                    end: null,
                    color: 'green'
                },
                {
                    id: 5,
                    title: 'N001B LAX > NYC 1 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d + 1, 19, 0),
                    end: null,
                    color: 'red'
                },
                {
                    id: 6,
                    title: 'N001B COO > BJC 2 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d + 8, 16, 0),
                    end: null,
                    color: 'green'
                },
                {
                    id: 7,
                    title: 'N001B LAX > NYC 1 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d + 12, 16, 0),
                    end: null,
                    color: 'red'
                },
                {
                    id: 8,
                    title: 'N001B COO > BJC 2 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d + 14, 2, 0),
                    end: null,
                    color: 'blue'
                },
                {
                    id: 9,
                    title: 'N001B LAX > NYC 1 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d + 14, 4, 0),
                    end: null,
                    color: 'red'
                },
                {
                    id: 10,
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d + 14, 2, 0),
                    end: null,
                    color: 'violet'
                },
                {
                    id: 11,
                    title: 'N001B LAX > NYC 1 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d + 7, 4, 0),
                    end: null,
                    color: 'red'
                },
                {
                    id: 12,
                    title: 'N001B COO > BJC 2 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d + 6, 2, 0),
                    end: null,
                    color: 'green'
                },
                {
                    id: 13,
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d + 6, 4, 0),
                    end: null,
                    color: 'blue'
                },
                {
                    id: 14,
                    title: 'N001B COO > BJC 2 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d + 7, 4, 0),
                    end: null,
                    color: 'red'
                },
                {
                    id: 15,
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d + 22, 4, 0),
                    end: null,
                    color: 'violet'
                },
                {
                    id: 16,
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d + 25, 4, 0),
                    end: null,
                    color: 'blue'
                },
                {
                    id: 17,
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d + 27, 4, 0),
                    end: null,
                    color: 'blue'
                },
                {
                    id: 18,
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d + 24, 4, 0),
                    end: null,
                    color: 'blue'
                },
                {
                    id: 19,
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d + 22, 4, 0),
                    end: null,
                    color: 'blue'
                },
                {
                    id: 20,
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d + 29, 4, 0),
                    end: null,
                    color: 'red'
                },
                {
                    id: 21,
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d + 27, 4, 0),
                    end: null,
                    color: 'blue'
                },
                {
                    id: 22,
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d + 29, 4, 0),
                    end: null,
                    color: 'blue'
                },
                {
                    id: 23,
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d + 28, 4, 0),
                    end: null,
                    color: 'green'
                },
                {
                    id: 24,
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d + 13, 4, 0),
                    end: null,
                    color: 'blue'
                },
                {
                    id: 25,
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d + 12, 4, 0),
                    end: null,
                    color: 'violet'
                },
                {
                    id: 26,
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d + 11, 4, 0),
                    end: null,
                    color: 'blue'
                },



                {
                    id: guid(),
                    title: 'N001B MDW > BJC 5 12:45 CST > 16:15 MST',
                    start: new Date(y, m, 1),
                    end: null,
                    color: 'red'
                },
                {
                    id: guid(),
                    title: 'N001B COO > BJC 2 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) - getRandomInt(1, 25)),
                    end: null,
                    color: 'blue'
                },
                {
                    id: guid(),
                    title: 'N001B LAX > NYC 1 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) - getRandomInt(1, 25), 16, 0),
                    end: null,
                    color: 'violet'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 16, 0),
                    end: null,
                    color: 'green'
                },
                {
                    id: guid(),
                    title: 'N001B LAX > NYC 1 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 19, 0),
                    end: null,
                    color: 'red'
                },
                {
                    id: guid(),
                    title: 'N001B COO > BJC 2 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 16, 0),
                    end: null,
                    color: 'green'
                },
                {
                    id: guid(),
                    title: 'N001B LAX > NYC 1 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 16, 0),
                    end: null,
                    color: 'red'
                },
                {
                    id: guid(),
                    title: 'N001B COO > BJC 2 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 2, 0),
                    end: null,
                    color: 'blue'
                },
                {
                    id: guid(),
                    title: 'N001B LAX > NYC 1 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'red'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 2, 0),
                    end: null,
                    color: 'violet'
                },
                {
                    id: guid(),
                    title: 'N001B LAX > NYC 1 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'red'
                },
                {
                    id: guid(),
                    title: 'N001B COO > BJC 2 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 2, 0),
                    end: null,
                    color: 'green'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'blue'
                },
                {
                    id: guid(),
                    title: 'N001B COO > BJC 2 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'red'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'violet'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'blue'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'blue'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'blue'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'blue'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'red'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'blue'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'blue'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'green'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'blue'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'violet'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'blue'
                },


                {
                    id: guid(),
                    title: 'N001B MDW > BJC 5 12:45 CST > 16:15 MST',
                    start: new Date(y, m, 1),
                    end: null,
                    color: 'red'
                },
                {
                    id: guid(),
                    title: 'N001B COO > BJC 2 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) - getRandomInt(1, 25)),
                    end: null,
                    color: 'blue'
                },
                {
                    id: guid(),
                    title: 'N001B LAX > NYC 1 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) - getRandomInt(1, 25), 16, 0),
                    end: null,
                    color: 'violet'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 16, 0),
                    end: null,
                    color: 'green'
                },
                {
                    id: guid(),
                    title: 'N001B LAX > NYC 1 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 19, 0),
                    end: null,
                    color: 'red'
                },
                {
                    id: guid(),
                    title: 'N001B COO > BJC 2 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 16, 0),
                    end: null,
                    color: 'green'
                },
                {
                    id: guid(),
                    title: 'N001B LAX > NYC 1 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 16, 0),
                    end: null,
                    color: 'red'
                },
                {
                    id: guid(),
                    title: 'N001B COO > BJC 2 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 2, 0),
                    end: null,
                    color: 'blue'
                },
                {
                    id: guid(),
                    title: 'N001B LAX > NYC 1 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'red'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 2, 0),
                    end: null,
                    color: 'violet'
                },
                {
                    id: guid(),
                    title: 'N001B LAX > NYC 1 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'red'
                },
                {
                    id: guid(),
                    title: 'N001B COO > BJC 2 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 2, 0),
                    end: null,
                    color: 'green'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'blue'
                },
                {
                    id: guid(),
                    title: 'N001B COO > BJC 2 11:45 CST > 16:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'red'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'violet'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'blue'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'blue'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'blue'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'blue'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'red'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'blue'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'blue'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'green'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'blue'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'violet'
                },
                {
                    id: guid(),
                    title: 'N001B NYC > LAS 1 10:45 CST > 12:15 MST',
                    start: new Date(y, m, d - getRandomInt(1, 10) + getRandomInt(1, 25), 4, 0),
                    end: null,
                    color: 'blue'
                },

            ]
        ];

        vm.calendarUiConfig = {
            calendar: {
                editable: true,
                eventLimit: true,
                header: {
                    left: 'month basicWeek basicDay agendaWeek agendaDay',
                    center: 'title',
                    right: 'today prev,next'
                },
                handleWindowResize: false,
                aspectRatio: 1,
                dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                viewRender: function (view) {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                    vm.currentMonthShort = vm.calendar.getDate().format('MMM');
                },
                columnFormat: {
                    month: 'ddd',
                    week: 'ddd D',
                    day: 'ddd M'
                },
                eventClick: eventDetail,
                selectable: true,
                selectHelper: true,
                select: select
            }
        };

        // Methods
        vm.addEvent = addEvent;
        vm.next = next;
        vm.prev = prev;

        //////////

        /**
         * Go to next on current view (week, month etc.)
         */
        function next() {
            vm.calendarView.calendar.next();
        }

        /**
         * Go to previous on current view (week, month etc.)
         */
        function prev() {
            vm.calendarView.calendar.prev();
        }

        /**
         * Show event detail
         *
         * @param calendarEvent
         * @param e
         */
        function eventDetail(calendarEvent, e) {
            showEventDetailDialog(calendarEvent, e);
        }

        /**
         * Add new event in between selected dates
         *
         * @param start
         * @param end
         * @param e
         */
        function select(start, end, e) {
            showEventFormDialog('add', false, start, end, e);
        }

        /**
         * Add event
         *
         * @param e
         */
        function addEvent(e) {
            var start = new Date(),
                end = new Date();

            showEventFormDialog('add', false, start, end, e);
        }

        /**
         * Show event detail dialog
         * @param calendarEvent
         * @param e
         */
        function showEventDetailDialog(calendarEvent, e) {
            $mdDialog.show({
                controller: 'EventDetailFTDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/calendar/dialogs/event-detail-ft/event-detail-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    calendarEvent: calendarEvent,
                    showEventFormDialog: showEventFormDialog,
                    event: e
                }
            });
            // $mdDialog.show({
            //     controller         : 'EventDetailDialogController',
            //     controllerAs       : 'vm',
            //     templateUrl        : 'app/main/apps/calendar/dialogs/event-detail/event-detail-dialog.html',
            //     parent             : angular.element($document.body),
            //     targetEvent        : e,
            //     clickOutsideToClose: true,
            //     locals             : {
            //         calendarEvent      : calendarEvent,
            //         showEventFormDialog: showEventFormDialog,
            //         event              : e
            //     }
            // });
        }

        /**
         * Show event add/edit form dialog
         *
         * @param type
         * @param calendarEvent
         * @param start
         * @param end
         * @param e
         */
        function showEventFormDialog(type, calendarEvent, start, end, e) {
            var dialogData = {
                type: type,
                calendarEvent: calendarEvent,
                start: start,
                end: end
            };

            $mdDialog.show({
                controller: 'EventFormFTDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/calendar/dialogs/event-form-ft/event-form-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: true,
                locals: {
                    dialogData: dialogData,
                    Contacts: Contacts,
                    ContactsCrew: ContactsCrew,
                }
            }).then(function (response) {
                if (response.type === 'add') {
                    // Add new
                    vm.events[0].push({
                        id: vm.events[0].length + 20,
                        title: response.calendarEvent.title,
                        start: response.calendarEvent.start,
                        end: response.calendarEvent.end
                    });
                }
                else {
                    for (var i = 0; i < vm.events[0].length; i++) {
                        // Update
                        if (vm.events[0][i].id === response.calendarEvent.id) {
                            vm.events[0][i] = {
                                title: response.calendarEvent.title,
                                start: response.calendarEvent.start,
                                end: response.calendarEvent.end
                            };

                            break;
                        }
                    }
                }
            });
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('ClientsController', ClientsController);

    /** @ngInject */
    function ClientsController($scope, $rootScope, $stateParams, companyService, $translate, $document, $mdDialog,
        $mdMedia, $mdSidenav, $state, msApi, tinyMceService, clientsService, requestContext, evidencesControlsService,
        transformClients, mediaService, Upload, $filter, $timeout, msUtils, documentsService, sessionService, $cookies, is_owner) {
        var vm = this;
        vm.userLogued = sessionService.getUser();
        if ($state.current.name == "app.site_overview.clients.complaints") {
            vm.fromComplaint = true;
        }
        sessionService.getQuota().then(function (quota) {
            vm.quota = quota;
        });

        // vm.is_owner = is_owner;
        vm.ivhOptions = {
            defaultSelectedState: false,
            validate: true,
            expandToDepth: -1,
            useCheckboxes: true,
            twistieCollapsedTpl: '<md-icon md-font-icon="icon-chevron-right"></md-icon>',
            twistieExpandedTpl: '<md-icon md-font-icon="icon-chevron-down"></md-icon>',
            twistieLeafTpl: '<span style="cursor: default;">&#8192;&#8192;</span>'
        };
        vm.financing_options = [
            { id: 1, name: "Bancaria" },
            { id: 2, name: "Inversión de socio nacional" },
            { id: 3, name: "Inversión de socio extranjero" },
            { id: 4, name: "Capital riesgo" },
            { id: 5, name: "Subvenciones" },
            { id: 6, name: "Donaciones" }
        ];
        vm.sector_regulations_options = [
            { id: 1, name: "Protección de datos personales" },
            { id: 2, name: "Prevención de riesgos laborales" },
            { id: 3, name: "Blanqueo de Capitales" },
            { id: 4, name: "Normativa de defensa de la competencia" }
        ];
        vm.implemented_measures_options = [
            { id: 1, name: "Welcome pack" },
            { id: 2, name: "Canal de comunicaciones o denuncias" },
            { id: 3, name: "Código ético/Código de Conducta" },
            { id: 4, name: "Régimen disciplinario laboral" },
            { id: 5, name: "Formación a empleados" },
            { id: 6, name: "Otras" }
        ];
        vm.showOptions = false;
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg', 'red-bg', 'yellow-bg', 'light-blue-bg'];

        vm.positionsIds = {
            administrator: 1,
            managerLegal: 2,
            compliance_officer: 3,
            compliance_comite: 5,
            data_protection: 4,
            collaborator: 24
        }

        vm.divisionsId = {
            administrator: 3,
            managerLegal: 3,
            compliance_officer: 1,
            compliance_comite: 1,
            data_protection: 2,
            collaborator: 1
        }

        // Data
        vm.accounts = {
            'creapond': 'johndoe@creapond.com',
            'withinpixels': 'johndoe@withinpixels.com'
        };
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
        vm.profileColors = ['md-blue-300-bg', 'md-blue-grey-300-bg', 'md-orange-300-bg', 'md-pink-300-bg', 'md-purple-300-bg', 'md-red-300-bg', 'md-yellow-300-bg', 'md-light-blue-300-bg'];
        vm.selectedAccount = 'creapond';

        vm.loadingStep = false;
        vm.folders = 'Folders.data';
        vm.labels = 'Labels.data';
        vm.loadingThreads = true;

        vm.currentFilter = {
            type: $state.params.type,
            filter: $state.params.filter
        };
        vm.currentThread = null;
        vm.selectedThreads = [];

        vm.views = {
            split: 'app/main/apps/clients/views/list/split-view.html',
            nosplit: 'app/main/apps/clients/views/list/nosplit-view.html'
        };
        vm.defaultView = 'split';
        vm.currentView = 'split';

        vm.readView = false;

        vm.branchFields = [
            { name: 'Nombre', type: 'text', field: 'name', translate: 'GLOBAL.NAME' },
            { name: 'Domicilio', type: 'text', field: 'address1', translate: 'GLOBAL.ADDRESS' },
            { name: 'Población', type: 'text', field: 'city', translate: 'GLOBAL.CITY' },
            { name: 'Provincia', type: 'text', field: 'state', translate: 'GLOBAL.PROVINCE' },
            { name: 'Codigo postal', type: 'number', field: 'postcode', translate: 'GLOBAL.POSTAL_CODE' },
            { name: 'Telefono', type: 'number', field: 'phone', translate: 'GLOBAL.PHONE' },
            { name: 'Email', type: 'email', field: 'email', translate: 'GLOBAL.EMAIL' }
        ];

        vm.personFields = [
            { name: 'Name', type: 'text', field: 'first_name', translate: 'GLOBAL.NAME', required: true },
            { name: 'Apellidos', type: 'text', field: 'last_name', translate: 'GLOBAL.SURNAMES', required: true },
            { name: 'NIF', type: 'text', field: 'id_number', translate: 'GLOBAL.NIF_CIF', required: true },
            { name: 'Email', type: 'text', field: 'email', translate: 'GLOBAL.EMAIL', required: true },
            { name: 'Password', type: 'password', field: 'password', translate: 'LOGIN.PASSWORD', required: false },
            { name: 'Picture', type: 'picture', field: 'picture', translate: '', required: false },
            { name: '3rd Party Company', type: 'text', field: '3rd_party_company_name', translate: 'CLIENTS.3RD_PARTY_COMPANY' },
            { name: 'Profile Color', type: 'text', field: 'profile_color', translate: 'GLOBAL.PROFILE_COLOR', hidden: true },
            { name: 'User type', type: 'text', field: 'user_type', translate: 'GLOBAL.PROFILE_COLOR', hidden: true },
            // { name: 'Files', type: 'text', field: 'files', translate: 'GLOBAL.FILES', hidden: true },
            { name: 'Files', type: '', field: 'files', hidden: true, value: [] },
        ];

        vm.administratorFields = vm.personFields;
        vm.managerLegalFields = vm.personFields;
        vm.complianceFields = vm.personFields;
        vm.reportFields = vm.personFields;
        vm.personnelFields = vm.personFields;
        vm.getRegionLiteral = getRegionLiteral;


        vm.getSectorById = getSectorById;


        vm.idClient = undefined;
        vm.idCompany = undefined;
        vm.updateLogotype = false;
        vm.showForm = true;
        vm.allQuestions = true;
        $scope.storagePrefix = '';


        vm.isSelected = isSelected;
        vm.toggleSelectThread = toggleSelectThread;
        vm.selectThreads = selectThreads;
        vm.deselectThreads = deselectThreads;
        vm.toggleSelectThreads = toggleSelectThreads;

        vm.setThreadStatus = setThreadStatus;
        vm.toggleThreadStatus = toggleThreadStatus;


        vm.changeView = changeView;


        vm.toggleSidenav = toggleSidenav;
        vm.newForm = newForm;
        vm.closeForm = closeForm;
        vm.uploadMedia = uploadMedia;
        vm.upload = upload;
        vm.openDialogForm = openDialogForm;
        vm.openMenu = openMenu;
        vm.nextStep = nextStep;
        vm.prevStep = prevStep;
        vm.previousStep = previousStep;
        vm.deleteClient = deleteClient;
        vm.removeBranch = removeBranch;
        vm.editBranchDialog = editBranchDialog;
        vm.removeBranchFromForm = removeBranchFromForm;

        vm.tinymceOptions = tinyMceService.getOptions($scope);

        vm.mediaDialogSingle = mediaDialogSingle;
        vm.deleteLogotype = deleteLogotype;
        vm.openImageDialog = openImageDialog;
        vm.sendForm = sendForm;
        vm.goClients = goClients;
        vm.goQuestions = goQuestions;
        vm.finishQuestion = finishQuestion;
        vm.openCompany = openCompany;
        vm.editCompany = editCompany;
        vm.showUserImage = showUserImage;
        vm.editUser = editUser;
        vm.removeUser = removeUser;
        vm.addUsersJob = addUsersJob;
        vm.addUsersJobFromUserId = addUsersJobFromUserId;
        vm.getDivisionName = getDivisionName;
        vm.getPositionName = getPositionName;
        vm.isFromType = isFromType;
        vm.areFromType = areFromType;
        vm.getRegion = getRegion;

        vm.deleteCompany = deleteCompany;

        //////////

        $scope.$on('pagination:loadStart', function (event) {
            $scope.isLoading = true;
        });

        $scope.$on('pagination:loadPage', function (event) {
            $scope.isLoading = false;
            vm.is_owner = vm.companies.length <= 1;
            init();
        });


        $scope.owner = $stateParams.owner;


        vm.bag = [{
            label: 'Glasses',
            value: 'glasses',
            children: [{
                label: 'Top Hat',
                value: 'top_hat',
                children: [{
                    label: 'Top Hat',
                    value: 'top_hat',
                    children: [{
                        label: 'Top Hat',
                        value: 'top_hat'
                    }]
                }]
            }, {
                label: 'Curly Mustache',
                value: 'mustachio'
            }]
        }];

        this.awesomeCallback = function (node, tree) {
            // Do something with node or tree
        };

        this.otherAwesomeCallback = function (node, isSelected, tree) {
            // Do soemthing with node or tree based on isSelected
        };




        /////////////////

        function init() {
            getSectors();
            getDivisions();
            getPositions();
            getUsers();
            mediaService.getStoragePrefix({
                owner: $scope.owner,
            }).then(function (res) {
                $scope.storagePrefix = res.prefix;
            })
            evidencesControlsService.getCurrencies({ owner: $scope.owner }).then(function (res) {
                vm.currencies = res.data;
            })
            clientsService.getRegions({ owner: $scope.owner }).then(function (res) {
                vm.regions = res.data;
            })
            clientsService.getFileRegions().then(function (res) {
                vm.regionsLiterals = res;
            })
        }

        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'nosplit';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big) {
                vm.currentView = 'nosplit';
            }

        });

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small) {
                vm.currentView = 'split';
            }

        });

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                if (vm.defaultView === 'split') {
                    vm.currentView = 'split';
                }
            }
        });


        var originatorEv;

        function openMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        }

        function initFieldsForm(title) {
            let fields;
            if (title === 'branch') {
                fields = angular.copy(vm.branchFields);
            }
            else if (title === 'administrator') {
                fields = angular.copy(vm.administratorFields);
            }
            else if (title === 'managerLegal') {
                fields = angular.copy(vm.managerLegalFields);
            }
            else if (title === 'compliance') {
                fields = angular.copy(vm.complianceFields);
            }
            else if (title === 'report') {
                fields = angular.copy(vm.reportFields);
            }
            else if (title === 'personnel') {
                fields = angular.copy(vm.personnelFields);
            }
            fields.forEach(item => {
                if (item.name == 'Población') {
                    item.translate = vm.getRegionLiteral('city');
                }
                if (item.name == 'Provincia') {
                    item.translate = vm.getRegionLiteral('state');
                }
                if (item.name == 'NIF') {
                    item.translate = vm.getRegionLiteral('id_number');
                }
            })
            return fields;
        }
        function getRegionLiteral(literalKey) {
            if (!angular.isUndefined(vm.formWizard) && !angular.isUndefined(vm.formWizard.company) && vm.formWizard.company.region_id) {
                const literalsObject = vm.regionsLiterals.find(x => x.region_id === vm.formWizard.company.region_id)
                return literalsObject.literals[literalKey];
            } else {
                return '';
            }
        }

        function getSectorById(sector_id) {
            var found;
            if (vm.sectors) {
                for (var i = 0; i < vm.sectors.length; i++) {
                    if (vm.sectors[i].id == sector_id) {
                        found = vm.sectors[i]
                        break;
                    }
                }
            }
            return found;
        }

        function openDialogForm(title, branchId, saveNow, model, index, type) {
            var hasModel = true;
            var divisionId = '';
            var jobId = '';
            if (model === undefined || !model) {
                hasModel = false;
                var fields = initFieldsForm(title);
            }
            else {
                //var fields = angular.copy(model);
                var fields = initFieldsForm(title);
                angular.forEach(fields, function (f) {
                    if (!angular.isUndefined(model[f.field])) {
                        f.value = model[f.field];
                        if (f.field == 'division') {
                            divisionId = f.value;
                        } else if (f.field == 'position') {
                            jobId = f.value;
                        }
                    }
                })
            }

            if (!divisionId && type && !angular.isUndefined(vm.divisionsId[type])) {
                divisionId = vm.divisionsId[type];
            }
            if (!jobId && type && !angular.isUndefined(vm.positionsIds[type])) {
                jobId = vm.positionsIds[type];
            }

            if (angular.isUndefined(vm.formWizard[title])) {
                vm.formWizard[title] = [];
            }
            if (!vm.users) {
                vm.users = [];
            }
            if (!vm.mainUsers) {
                vm.mainUsers = [];
            }
            var usersDialog = vm.users.concat(vm.mainUsers);
            usersDialog = _.uniq(usersDialog, function (e) {
                return e.id;
            });
            $mdDialog.show({
                controller: 'DialogFormController',
                controllerAs: 'vm',
                locals: {
                    title: title,
                    fields: fields,
                    type: type,
                    users: angular.copy(usersDialog),
                    alreadySelected: type ? vm.areFromType(vm.formWizard[title], type) : vm.formWizard[title],
                    storagePrefix: $scope.storagePrefix,
                    branchId: branchId,
                    defaultDivision: divisionId,
                    owner: $scope.owner,
                    defaultJob: jobId,
                    positionsIds: vm.positionsIds,
                    idCompany: vm.idCompany,
                    user_type: model ? model.user_type : undefined,
                    isTiny: false
                },
                templateUrl: 'app/main/apps/clients/dialogs/forms/dialog-view.html',
                parent: angular.element($document.body),
                targetEvent: 'ev',
                disableParentScroll: true,
                clickOutsideToClose: true,

            }).then(function (result) {

                if (result) {
                    if (result.fields && result.fields.files) {
                        vm.files = result.fields.files;
                        delete result.fields.files;
                    }
                    vm.quotaexceded = result.quotaexceded;
                    var existUser = result.existUser;
                    if (hasModel) {
                        angular.forEach(result.fields, function (f) {
                            // no se por que hay que tener el if siguiente pero las dejo ya que imagino que alguien las puso por algo.
                            if (!angular.isUndefined(model[f.field])) {
                                model[f.field] = f.value;
                            }
                            if (f.field == 'password' && !angular.isUndefined(f.value)) {
                                model[f.field] = f.value;
                            }
                        })
                        if (title !== 'branch') {
                            updateUser(title, index);
                        }

                    }
                    else {

                        if (branchId) {
                            var subIndex = createSubForm(title, result.fields, true, branchId);
                            if (!existUser) {
                                createUser(title, result.fields, subIndex, true);
                            } else {
                                var itemUser = vm.formWizard[title][subIndex];
                                upgradeRol(title, subIndex, itemUser)
                                vm.addUsersJobFromUserId(itemUser.division, itemUser.position, itemUser.branch_id, itemUser, true)
                            }
                        } else {
                            var subIndex = createSubForm(title, result.fields, true);
                            if (title !== 'branch') {
                                if (!existUser) {
                                    createUser(title, result.fields, subIndex, true);
                                } else {
                                    var itemUser = vm.formWizard[title][subIndex];
                                    upgradeRol(title, subIndex, itemUser)
                                    vm.addUsersJobFromUserId(itemUser.division, itemUser.position, itemUser.branch_id, itemUser, true)
                                }
                            }
                            else if (title === 'branch') {
                                saveRemainBranches();
                                //addBranchToForm(result.fields, subIndex);
                            }
                        }
                    }
                }
            });
        }

        function upgradeRol(title, index, itemUser) {
            if ((vm.positionsIds.compliance_officer == itemUser.position
                || vm.positionsIds.compliance_comite == itemUser.position
                || vm.positionsIds.data_protection == itemUser.position)
                && (itemUser.user_type > 3) && !vm.quotaexceded) {
                vm.formWizard[title][index].user_type = 3;
                updateUser(title, index);
            }
        }

        function getRegion(id) {
            if (vm.regions) {
                return vm.regions.find(x => x.id === id).name
            } else {
                return '';
            }
        }

        function getPositions() {
            var options = {
                owner: $scope.owner,
                resultsPerPage: 1000
            };
            clientsService.getPositions(options).then(function (response) {
                vm.positions = response.data;
                var positionField = {
                    name: 'Position',
                    type: 'selector',
                    field: 'position',
                    translate: 'GLOBAL.POSITION',
                    options: [],
                    hidden: true
                }
                for (var i = 0; i < response.data.length; i++) {
                    positionField.options.push({ field: response.data[i].name, id: response.data[i].id });
                }
                vm.personFields.push(positionField);
            })
        }

        function getUsers(idCompany, inOwner) {
            var options = {
                owner: $scope.owner,
                //                inOwner: '',
                withFiles: true
            };
            clientsService.getUsers(options).then(function (response) {
                vm.mainUsers = response.data;
            })
        }

        function getSectors() {
            var options = {
                owner: $scope.owner,
                resultsPerPage: 1000
            };
            clientsService.getSectors(options).then(function (response) {
                vm.sectors = response.data;
            })
        }
        function getDivisions() {
            var options = {
                owner: $scope.owner,
                resultsPerPage: 1000
            };
            clientsService.getDivisions(options).then(function (response) {
                vm.divisions = response.data;
                var divisionField = {
                    name: 'Division',
                    type: 'selector',
                    field: 'division',
                    translate: 'GLOBAL.DIVISION',
                    options: [],
                    hidden: true
                }
                for (var i = 0; i < response.data.length; i++) {
                    divisionField.options.push({ field: response.data[i].name, id: response.data[i].id });
                }
                vm.personFields.push(divisionField);

            })
        }


        function getCompany(id) {
            var options = {
                owner: $scope.owner,
                id: id
            };
            clientsService.getCompany(options).then(function (response) {

                vm.idCompany = response.id;
                vm.formWizard.company = {};
                vm.formWizard.company = response;
                if (vm.formWizard.company.extra_data) {
                    vm.formWizard.company.extra_data = JSON.parse(vm.formWizard.company.extra_data);
                }
                destroyWatchers();
                initWatchers();
                vm.formWizard.branches = angular.copy(response.branches);
                vm.formWizard.branch = vm.formWizard.branches;
                delete (vm.formWizard.company.branches);

                if (response.logo.length > 0) {
                    clientsService.getStoragePrefix(options).then(function (res) {
                        $scope.imageUrl = res.prefix + response.logo[0].url;
                        vm.logoIsLoaded = true;
                    })
                }
                else {
                    vm.logoIsLoaded = true;
                }
                var mainBranch = $filter('filter')(vm.formWizard.branches, { is_main: true });
                if (mainBranch) {
                    vm.formWizard.main_branch = mainBranch[0];
                    vm.mainBranch = vm.formWizard.main_branch;
                }
                initTree();
            })
        }

        function getBranches(idCompany) {
            var options = {
                owner: $scope.owner,
                company_id: idCompany
            };

            clientsService.getBranches(options).then(function (response) {
                vm.branches = [];
                vm.formWizard.branches = transformClients.branchesToForm(vm.branchFields, response.data, vm.formWizard, vm.branches);
                if (vm.formWizard.main_branch) {
                    vm.mainBranch = true;
                }
                initTree();
            })
        }

        function initTree() {
            vm.tree = [];
            vm.formWizard.personnel = [];
            angular.forEach(vm.formWizard.branches, function (branch) {
                var divisions = {};
                angular.forEach(branch.division_users, function (divisionUser) {
                    if (angular.isUndefined(divisions[divisionUser.division_id])) {
                        divisions[divisionUser.division_id] = {
                            label: divisionUser.division.name,
                            type: 'division',
                            children: [],
                            positions: {}
                        };
                    }
                    if (angular.isUndefined(divisions[divisionUser.division_id].positions[divisionUser.job_position_id])) {
                        divisions[divisionUser.division_id].positions[divisionUser.job_position_id] = {
                            label: divisionUser.job_position ? divisionUser.job_position.name : '',
                            type: 'job_position',
                            children: []
                        }
                    }

                    divisions[divisionUser.division_id].positions[divisionUser.job_position_id].children.push({
                        label: divisionUser.user.first_name + ' ' + divisionUser.user.last_name,
                        type: 'user',
                        user: divisionUser.user,
                        storagePrefix: $scope.storagePrefix
                    })
                    var personnel = angular.copy(divisionUser.user);
                    personnel.branch_id = branch.id;
                    personnel.division = divisionUser.division.id;
                    personnel.position = divisionUser.job_position ? divisionUser.job_position.id : divisionUser.job_position_id;
                    vm.formWizard.personnel.push(personnel);

                    divisions[divisionUser.division_id].children = [];
                    for (var key in divisions[divisionUser.division_id].positions) {
                        divisions[divisionUser.division_id].children.push(divisions[divisionUser.division_id].positions[key]);
                    }
                })
                var object = {
                    label: branch.name,
                    type: 'branch',
                    children: [
                    ]
                };
                for (var key in divisions) {
                    object.children.push(divisions[key]);
                }

                /*
                {
                            label: 'Dirección',
                            children: [
                                {
                                    label: 'Director'
                                },
                                {
                                    label: 'Administrador'
                                }
                            ]
                        }
                 */
                vm.tree.push(object);
            })
        }

        function getDataCompany(idCompany) {
            getCompany(idCompany);
        }

        function getInfoCompany(company) {
            companyToForm(company);
            getDataCompany(company.id);
            vm.legalDocumentsFolderID = null;
            var options = {
                owner: $scope.owner,
                id_company: company.id
            }
            clientsService.getLegalFolder(options).then(function (res) {
                vm.legalDocumentsFolderID = res.id;
            })
        }

        function companyToForm(company) {
            vm.formWizard = {};
            vm.formWizard.company = {};
            vm.formWizard.company.name = company.name;
            vm.formWizard.personnel = [];
            vm.formWizard.branch = [];

        }

        function branchToForm(id) {
            var options = {
                owner: $scope.owner,
                id: id
            };
            clientsService.getBranch(options).then(function (response) {
                vm.formWizard.branches = [];
                vm.formWizard.branches.push(transformClients.branchToForm(angular.copy(vm.branchFields), response));
            })
        }

        function openCompany(company, ev) {
            if (vm.fromComplaint) {
                $mdDialog.show({
                    controller: 'NewClientDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/clients/dialogs/new-client-dialog/new-client-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        company: company,
                        main_branch: {},
                        sectors: vm.sectors,
                        regions: vm.regions,
                        regionsLiterals: vm.regionsLiterals
                    }
                }).then(function (res) {
                    if (res) {
                        vm.formWizard = {};
                        vm.formWizard.company = res.company;
                        vm.formWizard.main_branch = res.branch;
                        delete vm.formWizard.company.extra_data;
                        $scope.image = res.image
                        vm.updateLogotype = res.updateLogotype;
                        $scope.isLoading = true;
                        vm.idCompany = res.company.id
                        vm.updateAfterLogo = true;
                        vm.forceUpdateBranch = true;
                        createCompany(null, true);
                    }
                });
            } else {
                vm.idCompany = company.id;
                //vm.readView = true;
                vm.preview = true;
                getInfoCompany(company);
            }

        }

        function editCompany() {
            vm.users = [];
            $rootScope.$broadcast('select-company', vm.formWizard.company);
            sessionService.set('companySelected', vm.formWizard.company);
            angular.forEach(vm.formWizard.personnel, function (u) {
                var userExists = $filter('filter')(vm.users, { id: u.id });
                if (userExists.length < 1) {
                    vm.users.push(u);
                }
            })
            vm.readView = true;
            vm.preview = false;
        }


        function createUser(type, subForm, subIndex, noPush) {
            //var itemUser = transformClients.userToDTO(subForm, type);
            var itemUser = vm.formWizard[type][subIndex];
            if ((vm.positionsIds.compliance_officer == itemUser.position || vm.positionsIds.compliance_comite == itemUser.position || vm.positionsIds.data_protection == itemUser.position && itemUser.user_type > 3) && !vm.quotaexceded) {
                itemUser.user_type = 3;
            } else if (vm.positionsIds.collaborator == itemUser.position && !itemUser.user_type) {
                itemUser.user_type = 6; // Usuario COLLABORATOR
            } else if (itemUser.user_type > 4 || !itemUser.user_type) {
                if (itemUser.password) {
                    itemUser.user_type = 4;
                } else {
                    itemUser.user_type = 5;
                }
            }
            itemUser.region_id = vm.formWizard.company.region_id;
            if (!angular.isUndefined(itemUser.password) && itemUser.password.length == 0) {
                delete itemUser.password;
            }
            var options = {
                owner: $scope.owner,
                item: itemUser
            };
            clientsService.createUser(options).then(function (response) {
                vm.users.push(response);
                vm.formWizard[type][subIndex].id = response.id;
                if (!angular.isUndefined(itemUser.position) && !angular.isUndefined(itemUser.division) && !angular.isUndefined(itemUser.branch_id)) {
                    vm.addUsersJobFromUserId(itemUser.division, itemUser.position, itemUser.branch_id, itemUser, noPush)
                }
                $scope.uploadingFotoUserId = response.id;
                if (vm.files.length > 0) {
                    angular.forEach(vm.files, function (f) {
                        vm.uploadMedia(f, response.id, 'user_photo')
                    })
                } else {
                    delete $scope.uploadingFotoUserId;
                    delete vm.files;
                }

            }, function (error) {
                getUsers();
                getDataCompany(vm.idCompany);
            })
        }

        function uploadMedia(file, idValue, uploadKey) {
            if (!file.$error) {
                var token = undefined;
                $scope.uploadingFile = true;
                console.debug("UPLOAD STARTED______****", file)
                mediaService.getS3UploadPreSignedUrl({
                    owner: $scope.owner,
                    uploadKey: uploadKey,
                    fileName: file.name,
                    rowId: idValue
                })
                    .then(function (resp) {
                        token = resp.token;
                        file.id_media = resp.id_media;
                        file.upload = Upload.http({
                            url: resp.url,
                            skipAuthorization: true,
                            method: 'PUT',
                            headers: {
                                "Content-Type": file.type != '' ? file.type : 'application/octet-stream'
                            },
                            data: file
                        })
                        file.upload.then(function (response) {
                            file.result = response.data;
                            $timeout(function () {
                                $scope.log = 'file: ' +
                                    file.name +
                                    ', Response: ' + JSON.stringify(response.data) +
                                    ', ID: ' + file.id_media +
                                    '\n' + $scope.log;
                            });
                            console.debug("FINISHING UPLOAD______****", file)
                            mediaService.finishedUploadingFileToCdn({
                                owner: $scope.owner,
                                idMedia: file.id_media,
                                token: token
                            }).then(function () {
                                $scope.uploadingFile = false;
                                getCompany(vm.idCompany);
                                delete $scope.uploadingFotoUserId;
                                delete vm.files;
                            })

                        }, function (response) {
                            if (response.status > 0)
                                $scope.errorMsg = response.status + ': ' + response.data;
                        });

                        file.upload.progress(function (evt) {
                            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                        });
                    })
            }
        };


        function updateUser(type, subIndex) {
            var itemUser = vm.formWizard[type][subIndex];
            if (itemUser.password && itemUser.user_type > 4) {
                itemUser.user_type = 4;
            }
            var options = {
                owner: $scope.owner,
                id: itemUser.id,
                item: itemUser
            };
            clientsService.updateUser(options).then(function () {
                $scope.uploadingFotoUserId = itemUser.id;
                delete itemUser.password;
                if (vm.files && vm.files.length > 0) {
                    var uploading = false;
                    angular.forEach(vm.files, function (f) {
                        if (!f.url) {
                            uploading = true;
                            vm.uploadMedia(f, itemUser.id, 'user_photo')
                        }
                    })
                    if (!uploading) {
                        delete $scope.uploadingFotoUserId;
                        delete vm.files;
                    }
                } else {
                    delete $scope.uploadingFotoUserId;
                    delete vm.files;
                }
                getUsers();
                getDataCompany(vm.idCompany);
            });
        }

        function addUsersJob(divisionId, jobPositionId, branchId, title) {
            if (!angular.isUndefined(vm.formWizard[title]) && vm.formWizard[title].length > 0) {
                angular.forEach(vm.formWizard[title], function (u) {
                    if (angular.isUndefined(u.isAdded)) {
                        clientsService.addUserToCompany({
                            owner: $scope.owner,
                            user_id: u.id,
                            company_id: vm.idCompany
                        }).then(function (response) {

                        })
                        clientsService.addUserJobPosition({
                            owner: $scope.owner,
                            user_id: u.id,
                            branch_id: branchId,
                            division_id: divisionId,
                            job_position_id: jobPositionId
                        }).then(function (response) {
                            u.branch_id = branchId;
                            u.division = divisionId;
                            u.position = jobPositionId;
                            u.isAdded = true;
                            vm.formWizard.personnel.push(u);
                        })
                    }
                })
            }

        }
        function addUsersJobFromUserId(divisionId, jobPositionId, branchId, user, noPush) {
            if (angular.isUndefined(user.isAdded) && divisionId && jobPositionId && branchId) {
                clientsService.addUserToCompany({
                    owner: $scope.owner,
                    user_id: user.id,
                    company_id: vm.idCompany
                }).then(function (response) {

                })
                clientsService.addUserJobPosition({
                    owner: $scope.owner,
                    user_id: user.id,
                    branch_id: branchId,
                    division_id: divisionId,
                    job_position_id: jobPositionId
                }).then(function (response) {
                    user.branch_id = branchId;
                    user.division = divisionId;
                    user.position = jobPositionId;
                    user.isAdded = true;
                    if (!noPush) {
                        vm.formWizard.personnel.push(user);
                    }
                })
            }
        }
        function createBranch(subForm, isMain, addUsers, msWizard, close) {
            var item = transformClients.createBranch(subForm, vm.idCompany, isMain, vm.formWizard.company.region_id);
            var options = {
                owner: $scope.owner,
                item: item,
            };
            clientsService.createBranch(options).then(function (response) {
                if (isMain && vm.formWizard.main_branch) {
                    vm.formWizard.main_branch.id = response.id;
                    if (msWizard) {
                        if (!close) {
                            msWizard.nextStep();
                        } else {
                            vm.closeForm(true);
                        }
                        $timeout(function () {
                            angular.element('.content')[0].scrollTop = 0
                            vm.loadingStep = false;
                        })
                    }
                    if (addUsers) {
                        if (angular.isUndefined(vm.formWizard.personnel)) {
                            vm.formWizard.personnel = [];
                        }
                        var allAdministrators = $filter('filter')(vm.formWizard.personnel, { division: vm.divisionsId.administrator, position: vm.positionsIds.administrator });
                        var allManagers = $filter('filter')(vm.formWizard.personnel, { division: vm.divisionsId.managerLegal, position: vm.positionsIds.managerLegal });

                        angular.forEach(allAdministrators, function (u) {
                            u.branch_id = vm.formWizard.main_branch.id;
                            vm.addUsersJobFromUserId(u.division, u.position, u.branch_id, u, true)
                        })
                        angular.forEach(allManagers, function (u) {
                            u.branch_id = vm.formWizard.main_branch.id;
                            vm.addUsersJobFromUserId(u.division, u.position, u.branch_id, u, true)
                        })
                    }
                } else {
                    subForm.id = response.id;
                }
                if (!vm.branches) {
                    vm.branches = [];
                }
                vm.branches.push(response);
                for (var i = 0; i < vm.formWizard.branch.length; i++) {
                    if (response.id == vm.formWizard.branch[i].id) {
                        vm.formWizard.branch[i] = response;
                    }
                }
                // getCompany(vm.idCompany)
            })
        }

        function addBranchToForm(subForm, isMain) {
            if (!vm.formWizard.branch) {
                vm.formWizard.branch = [];
            }
            vm.formWizard.branch.push(subForm);
        }

        function removeBranchFromForm($index) {
            if (!angular.isUndefined(vm.formWizard.branch[$index])) {
                var branchData = vm.formWizard.branch[$index];
                var options = {
                    owner: $scope.owner,
                    id: branchData.id,
                };
                clientsService.deleteBranch(options)
                    .then(function (response) {
                        vm.formWizard.branch.splice($index, 1)
                    });
            }
        }

        function removeBranch($index) {
            var elementsToRemove = vm.formWizard.branches.splice($index, 1)
            var branch_id = transformClients.getIdBranch(elementsToRemove[0]);
            var options = {
                owner: $scope.owner,
                id: branch_id,
            };
            clientsService.deleteBranch(options);
        }
        function editBranchDialog($event, $index) {
            var branchSelected = vm.formWizard.branches[$index]
            $mdDialog.show({
                controller: 'EditBranchDialog',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/clients/dialogs/edit-branch/edit-branch-dialog.controller.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    region_id: vm.formWizard.company.region_id,
                    branch: branchSelected
                },
            })
                .then(function (resp) {
                    if (resp) {
                        var options = {
                            owner: $scope.owner,
                            id: resp.id,
                            item: resp
                        };
                        clientsService.updateBranch(options).then(function (response) {
                            vm.formWizard.branches[$index] = response;
                        })
                    }
                });
        }

        function getIdBranch(form, isMain) {
            if (isMain) {
                return form.id;
            }
            else {
                return transformClients.getIdFromForm(form);
            }
        }

        function updateBranch(form, isMain, addUsers) {
            var options = {
                owner: $scope.owner,
                item: transformClients.createBranch(form, vm.idCompany, isMain, vm.formWizard.company.region_id),
                id: getIdBranch(form, isMain)
            };
            clientsService.updateBranch(options).then(function (response) {
            });
        }

        function updateSubForm(title, subForm, index) {
            transformClients.updateFullName(subForm);
            vm.formWizard[title][index] = subForm;
        }

        function createSubForm(title, subForm, noFields, branchId) {
            if (noFields) {
                var newData = {};
                if (branchId) {
                    newData.branch_id = branchId;
                } else if (vm.formWizard.main_branch && vm.formWizard.main_branch.id) {
                    newData.branch_id = vm.formWizard.main_branch.id;
                }
                angular.forEach(subForm, function (field) {
                    if (field.field == 'profile_color') {
                        newData[field.field] = vm.profileColors[Math.floor(Math.random() * vm.profileColors.length)];
                    } else {
                        newData[field.field] = field.value;
                    }
                })
                subForm = newData
            } else {
                transformClients.setFullName(subForm);
            }
            if (!vm.formWizard) {
                vm.formWizard = {};
            }
            if (angular.isUndefined(vm.formWizard[title])) {
                vm.formWizard[title] = [];
            }
            vm.formWizard[title].push(subForm);
            return (vm.formWizard[title].length > 0) ? vm.formWizard[title].length - 1 : undefined;
        }

        function newForm(ev) {
            if (vm.quota.companies_registered >= vm.quota.max_allowed_companies) {
                $mdDialog.show({
                    controller: 'CompanyQuotaDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/dialogs/companyQuotaDialog/companyQuotaDialog.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                    }
                }).then(function (res) {
                    if (res && res.type) {
                        if (res.type == 'upgrade') {
                            console.log("go upgrade screen");
                        } else {
                            vm.idCompany = '';
                            vm.mainBranch = {};
                            vm.readView = true;
                        }
                    }
                });
            } else {
                if (vm.fromComplaint) {
                    $mdDialog.show({
                        controller: 'NewClientDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/apps/clients/dialogs/new-client-dialog/new-client-dialog.html',
                        parent: angular.element($document.body),
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        locals: {
                            company: null,
                            main_branch: null,
                            sectors: vm.sectors,
                            regions: vm.regions,
                            regionsLiterals: vm.regionsLiterals
                        }
                    }).then(function (res) {
                        if (res) {
                            vm.formWizard = {};
                            vm.formWizard.company = res.company;
                            vm.formWizard.main_branch = res.branch;
                            $scope.image = res.image
                            $scope.isLoading = true;
                            vm.forceCreateBranch = true;
                            createCompany(null, true);
                        }
                    });
                } else {
                    vm.idCompany = '';
                    vm.mainBranch = {};
                    vm.readView = true;
                    $timeout(function () {
                        vm.formWizard.company.region_id = sessionService.user.region_id;
                    }, 1000)
                }
            }
        }

        function closeForm(preview) {
            if (vm.idCompany) {
                getDataCompany(vm.idCompany);
                vm.readView = false;
                vm.preview = preview;
            } else {
                vm.goClients();
            }
        }



        function createCompany(msWizard, close) {
            var options = {
                owner: $scope.owner,
                item: transformClients.companyToDTO(vm.formWizard)
            };
            vm.formWizard.company.region_id = options.item.region_id;
            if (vm.idCompany) {
                options.id = vm.idCompany;
                clientsService.updateCompany(options).then(function (response) {
                    if (!close) {
                        msWizard.nextStep();
                    } else {
                        vm.closeForm(vm.fromComplaint ? false : true);
                        if (!vm.updateAfterLogo) {
                            $scope.isLoading = false;
                        }
                    }
                    if (vm.forceUpdateBranch) {
                        vm.formWizard.main_branch.name = vm.formWizard.company.name;
                        updateBranch(vm.formWizard.main_branch, true, true);
                    }
                });
                $timeout(function () {
                    angular.element('.content')[0].scrollTop = 0
                    vm.loadingStep = false;
                })

                if (vm.updateLogotype && $scope.image) {
                    uploadImage($scope.image, vm.idCompany, 'company_logo');
                    vm.updateLogotype = false;
                } else {
                    $scope.isLoading = false;
                }
            } else {
                options.item.is_owner = vm.companies.length > 0 ? 0 : true;
                clientsService.createCompany(options).then(function (response) {
                    sessionService.authenticate($cookies.get('owner'));

                    vm.idCompany = response.id;
                    if (!vm.formWizard.main_branch) {
                        vm.formWizard.main_branch = {
                            name: msUtils.translate('GLOBAL.MAIN_BRANCH')
                        }
                    }
                    if (vm.forceCreateBranch) {
                        createBranch(vm.formWizard.main_branch, true, true, msWizard, false);
                    }
                    vm.formWizard.administrator = [];
                    vm.formWizard.managerLegal = [];
                    vm.formWizard.branches = [];
                    initWatchers();
                    getInfoCompany(response)
                    if ($scope.image) {
                        uploadImage($scope.image, vm.idCompany, 'company_logo', response);
                    } else {
                        $rootScope.$broadcast('select-company', response);
                        $scope.isLoading = false;
                    }

                    if (!close) {
                        msWizard.nextStep();
                        $timeout(function () {
                            angular.element('.content')[0].scrollTop = 0
                            vm.loadingStep = false;
                        })
                        $rootScope.pagination_resetquery();
                    }

                })
            }
        }

        function uploadImage(file, idCompany, uploadKey, responseAndclose) {
            if (!file.$error) {
                var token = undefined;
                mediaService.getS3UploadPreSignedUrl({
                    owner: $scope.owner,
                    uploadKey: uploadKey,
                    fileName: file.name,
                    rowId: idCompany
                })
                    .then(function (resp) {
                        token = resp.token;
                        file.id_media = resp.id_media;
                        file.upload = Upload.http({
                            url: resp.url,
                            skipAuthorization: true,
                            method: 'PUT',
                            headers: {
                                "Content-Type": file.type != '' ? file.type : 'application/octet-stream'
                            },
                            data: file
                        });

                        file.upload.then(function (response) {
                            file.result = response.data;
                            $timeout(function () {
                                $scope.log = 'file: ' +
                                    file.name +
                                    ', Response: ' + JSON.stringify(response.data) +
                                    ', ID: ' + file.id_media +
                                    '\n' + $scope.log;
                            });
                            mediaService.finishedUploadingFileToCdn({
                                owner: $scope.owner,
                                idMedia: file.id_media,
                                token: token
                            }).then(res => {
                                if (responseAndclose || vm.updateAfterLogo) {
                                    vm.updateAfterLogo = false;
                                    $rootScope.$broadcast('select-company', responseAndclose);
                                    $rootScope.pagination_resetquery();
                                    $scope.isLoading = false;
                                }
                            })


                        }, function (response) {
                            if (response.status > 0) {
                                $scope.errorMsg = response.status + ': ' + response.data;
                            }
                        });

                        file.upload.progress(function (evt) {
                            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                        });

                    })
            }
        };

        function nextStep(msWizard, close) {
            vm.loadingStep = true;
            if (msWizard.selectedIndex === 0 || msWizard.selectedIndex === 1) {
                createCompany(msWizard, close);
            } else if (msWizard.selectedIndex === 2) {
                if (vm.formWizard.main_branch.id) {
                    updateBranch(vm.formWizard.main_branch, true, true);
                    if (!close) {
                        msWizard.nextStep();
                    } else {
                        vm.closeForm(true);
                    }
                    $timeout(function () {
                        angular.element('.content')[0].scrollTop = 0
                        vm.loadingStep = false;
                    })
                }
                else {
                    createBranch(vm.formWizard.main_branch, true, true, msWizard, close);
                    vm.mainBranch = true;
                    saveRemainBranches();
                }
            }
            else {
                msWizard.nextStep();
                $timeout(function () {
                    angular.element('.content')[0].scrollTop = 0
                    vm.loadingStep = false;
                })

            }
        }

        function saveRemainBranches() {
            if (!angular.isUndefined(vm.formWizard.branch) && vm.formWizard.branch.length > 0) {
                angular.forEach(vm.formWizard.branch, function (b) {
                    if (angular.isUndefined(b.id)) {
                        createBranch(b);
                    }
                })
            }

        }
        function previousStep(msWizard) {
            if (msWizard.selectedIndex === 0) {
                return true;
            }
            return false;
        }

        function prevStep(msWizard) {
            vm.loadingStep = true;
            msWizard.previousStep()
            $timeout(function () {
                angular.element('.content')[0].scrollTop = 0
                vm.loadingStep = false;
            })

        }
        function deleteClient() {
            var threads = angular.copy(vm.selectedThreads);
            vm.selectedThreads = [];
            for (var j = 0; j < threads.length; j++) {
                var options = {
                    owner: $scope.owner,
                    id: threads[j].id
                };
                clientsService.deleteClient(options).then(function (response) {
                    $rootScope.pagination_resetquery();
                    sessionService.authenticate($cookies.get('owner'));
                    $rootScope.$broadcast('select-company', null);
                    companyService.setCompanyId(null);
                    sessionService.set('companySelected', null);
                })
            }
        }

        function deleteLogotype() {
            if (vm.formWizard.company.logo.length > 0) {
                for (var i = 0; i < vm.formWizard.company.logo.length; i++) {
                    const itemLogo = vm.formWizard.company.logo[i];
                    var options = {
                        owner: $scope.owner,
                        id: itemLogo.id
                    }
                    documentsService.deleteDocument(options).then(function () {
                        vm.formWizard.company.logo = null;
                    })
                }
            }
            $scope.image = undefined;
            $scope.imageUrl = undefined;
        }

        function openImageDialog(ev, index, images, img) {
            var imagesCopy = [];
            imagesCopy.push(img);
            $mdDialog.show({
                controller: 'ImageDialogClientsController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/clients/dialogs/image/image-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Images: imagesCopy,
                    ImageSelected: img,
                    cropFormats: false,
                    MediaFull: false
                }
            });
        }


        function mediaDialogSingle(ev, field) {
            $mdDialog.show({
                controller: 'MediaClientsController',
                controllerAs: 'vm',
                locals: {
                    owner: $scope.owner,
                    multipleSelection: true,
                    isTiny: false
                },
                templateUrl: 'app/main/apps/clients/dialogs/media/media-clients.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true

            }).then(function (image) {
                if (image) {
                    if (($scope.image && vm.idCompany) || vm.idCompany) {
                        vm.updateLogotype = true;
                    }
                    $scope.image = image;
                }
            });
        }

        function sendForm() {
            vm.showForm = false;
        }

        function goClients() {
            vm.formWizard = {};
            $scope.image = undefined;
            $scope.imageUrl = undefined;
            vm.readView = false;
            vm.preview = false;
            vm.isQuestions = false;
            vm.showForm = true;
            vm.idCompany = '';
            vm.mainBranch = {};
            vm.branchQuestion = undefined;
            destroyWatchers()
            $rootScope.pagination_resetquery();
        }

        function goQuestions(sector) {
            var options = {
                owner: $scope.owner
            };
            if (!vm.allQuestions) {
                options.sector_id = vm.formWizard.company.sector_id;
            }
            clientsService.getQuestions(options).then(function (response) {
                vm.questions = response.data;
                vm.isQuestions = true;
            })
        }

        function getAnswer() {
            return transformClients.getAnswer(vm.questions);
        }

        function finishQuestion() {
            var item = {
                questions: getAnswer(),
                client_id: vm.idClient,
                branches: vm.branchQuestion
            };
            var options = {
                owner: $scope.owner,
                item: item
            };
            clientsService.evaluateAnswer(options).then(function (response) {
            })
            goClients();
        }


        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        function isSelected(thread) {
            return vm.selectedThreads.indexOf(thread) > -1;
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        function toggleSelectThread(thread, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedThreads.indexOf(thread) > -1) {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            }
            else {
                vm.selectedThreads.push(thread);
            }
        }

        /**
         * Select threads. If key/value pair given,
         * threads will be tested against them.
         *
         * @param [key]
         * @param [value]
         */
        function selectThreads(key, value) {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedThreads = [];

            for (var i = 0; i < vm.clients.length; i++) {
                if (angular.isUndefined(key) && angular.isUndefined(value)) {
                    vm.selectedThreads.push(vm.clients[i]);
                    continue;
                }

                if (angular.isDefined(key) && angular.isDefined(value) && vm.clients[i][key] === value) {
                    vm.selectedThreads.push(vm.clients[i]);
                }
            }
        }

        /**
         * Deselect threads
         */
        function deselectThreads() {
            vm.selectedThreads = [];
        }

        /**
         * Toggle select threads
         */
        function toggleSelectThreads() {
            if (vm.selectedThreads.length > 0) {
                vm.deselectThreads();
            }
            else {
                vm.selectThreads();
            }
        }

        /**
         * Set the status on given thread, current thread or selected threads
         *
         * @param key
         * @param value
         * @param [thread]
         * @param [event]
         */
        function setThreadStatus(key, value, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                thread[key] = value;
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                vm.currentThread[key] = value;
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                vm.selectedThreads[x][key] = value;
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleThreadStatus(key, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                if (typeof (thread[key]) !== 'boolean') {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                if (typeof (vm.currentThread[key]) !== 'boolean') {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                if (typeof (vm.selectedThreads[x][key]) !== 'boolean') {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }


        /**
         * Change the view
         *
         * @param view
         */
        function changeView(view) {
            if (vm.views[view]) {
                vm.defaultView = view;
                vm.currentView = view;
            }
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function showUserImage(user) {
            return $scope.storagePrefix + user.files.url
        }

        function removeUser(usersArray, idx, type, branch) {
            var userToRemove = angular.copy(usersArray[idx]);
            var userId = userToRemove.id;
            var jobId = userToRemove.position;
            var typeRemove = type;
            var divisionId = userToRemove.division;
            var branchId = vm.formWizard.main_branch.id;
            if (branch) {
                branchId = branch.id;
            }
            if (!branchId) {
                usersArray.splice(idx, 1)
            } else {
                clientsService.removeUserJobPosition({
                    owner: $scope.owner,
                    user_id: userId,
                    branch_id: branchId,
                    division_id: divisionId,
                    job_position_id: jobId
                }).then(function (response) {
                    angular.forEach(vm.formWizard.personnel, function (u, idx2) {
                        if (u.branch_id == branchId && u.id == userId && u.division == divisionId && u.position == jobId) {
                            vm.formWizard.personnel.splice(idx2, 1);
                        }
                    })
                }).catch(function () {
                    console.log('already removed');
                    angular.forEach(vm.formWizard.personnel, function (u, idx2) {
                        if (u.branch_id == branchId && u.id == userId && u.division == divisionId && u.position == jobId) {
                            vm.formWizard.personnel.splice(idx2, 1);
                        }
                    })
                })
            }
        }

        function editUser(usersArray, idx) {
            vm.openDialogForm('personnel', '', '', usersArray[idx], idx)
        }

        function getDivisionName(divisionId) {

            var x = vm.divisions.filter(function (division) {
                return (division.id == divisionId);
            });
            return x;
        }

        function getPositionName(positionId) {
            var x = vm.positions.filter(function (position) {
                return (position.id == positionId);
            });
            return x;
        }


        function areFromType(users, type) {
            var result = [];
            for (var i = 0; i < users.length; i++) {
                if (vm.isFromType(users[i], type)) {
                    result.push(users[i]);
                }
            }
            return result;
        }
        function isFromType(user, type) {
            if ((!user.branch_id || user.branch_id == vm.formWizard.main_branch.id) && user.position == vm.positionsIds[type] && user.division == vm.divisionsId[type]) {
                return true
            }
            return false;
        }


        function initWatchers() {
            vm.watchers = [];
            initWatcher('files_belogns_to_holding', 'belogns_to_holding');
            initWatcher('files_social_responsability', 'social_responsability');
            initWatcher('files_iva', 'iva');
            initWatcher('files_is', 'is');
        }
        function initWatcher(files_property, key) {
            vm.watchers.push($scope.$watch('vm.' + files_property, function () {
                $scope.formUpload = false;
                if (vm[files_property] != null) {
                    console.log(vm[files_property])
                    // make files array for not multiple to be able to be used in ng-repeat in the ui
                    if (!angular.isArray(vm[files_property])) {
                        $timeout(function () {
                            $scope[files_property] = vm[files_property] = [vm[files_property]];
                        });
                        return;
                    }
                    for (var i = 0; i < vm[files_property].length; i++) {
                        $scope.errorMsg = null;
                        (function (f) {
                            vm.upload(f, key);
                        })(vm[files_property][i]);
                    }
                }
            }));
        }

        function destroyWatchers() {
            if (vm.watchers) {
                for (var i = 0; i < vm.watchers.length; i++) {
                    const watcher = vm.watchers[i];
                    watcher();
                }
                vm.watchers = [];
            }
        }

        function deleteCompany(ev) {
            const message = $translate.instant('GLOBAL.ARE_YOU_SURE');
            const yes = $translate.instant('GLOBAL.YES');
            const no = $translate.instant('GLOBAL.NO');

            const confirm = $mdDialog.confirm()
                .title(message)
                .targetEvent(ev)
                .ok(yes)
                .cancel(no);

            $mdDialog.show(confirm).then(e => {
                vm.deleteClient();
            })
                .catch(err => { })

        }

        function upload(file, tag) {
            $scope[tag + '_isLoading'] = true;
            if (!file.$error) {
                //				console.debug("UPLOAD______****", file)
                documentsService.getS3UploadPreSignedUrl({
                    owner: $scope.owner,
                    fileName: file.name,
                    groupId: vm.legalDocumentsFolderID
                })
                    .then(function (resp) {
                        var token = resp.token;
                        file.upload = Upload.http({
                            url: resp.url,
                            skipAuthorization: true,
                            method: 'PUT',
                            headers: {
                                "Content-Type": file.type != '' ? file.type : 'application/octet-stream'
                            },
                            data: file
                        });

                        file.upload.then(function (response) {
                            file.result = response.data;
                            $timeout(function () {
                                $scope.log = 'file: ' +
                                    file.name +
                                    ', Response: ' + JSON.stringify(response.data) +
                                    ', ID: ' + file.id_media +
                                    '\n' + $scope.log;
                            });

                            vm.isLoading = true;
                            documentsService.finishedUploadingFile({
                                owner: $scope.owner,
                                token: token
                            }).then(function (response) {
                                vm.isLoading = false;
                                if (!vm.formWizard.company.extra_data[tag + '_files']) {
                                    vm.formWizard.company.extra_data[tag + '_files'] = [];
                                }
                                vm.formWizard.company.extra_data[tag + '_files'].push(JSON.parse(angular.toJson(response)))
                                $scope[tag + '_isLoading'] = false;
                                var options = {
                                    owner: $scope.owner,
                                    id: vm.idCompany,
                                    item: transformClients.companyToDTO(vm.formWizard)
                                };
                                clientsService.updateCompany(options).then(function (response) {
                                });
                                $mdDialog.hide({ update: true });
                            }, function (error) {
                                vm.isLoading = false;
                                vm.importError = error;
                            })
                            vm.importFinished = true;
                        }, function (response) {
                            if (response.status > 0)
                                $scope.errorMsg = response.status + ': ' + response.data;
                        });

                        file.upload.progress(function (evt) {
                            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                        });

                    })
            }
        };

        $scope.$on('$destroy', function () {
            destroyWatchers();
        });

    }
})();

(function () {
    'use strict';

    angular
        .module('app.clients')
        .service('clientsService', clientsService);

    /** @ngInject */
    // I provide access to the session store.
    function clientsService($q, $resource, settingsDomainService, sessionService, COMMON, $window, $mdToast, $state) {

        function getClients(options) {
            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });

            // var is_woner = 0;
            // if ($state.current.name.indexOf('mycompany') >= 0) {
            //     is_woner = 1;
            // }

            resourceClients.get({
                owner: options.owner,
                page: options.page,
                search: options.searchStringFilter,
                paginate: options.paginate,
                sortField: options.sortField,
                sortDir: options.sortDir,
                filters: JSON.stringify(filters),
                resultsPerPage: options.resultsPerPage,
                withCompany: options.withCompany,
                withLogo: true
            },
                function (responseResult) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getStoragePrefix(options) {
            var deferred = $q.defer();
            resourceStoragePrefix.get({
                owner: options.owner,
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateClient(options) {
            var deferred = $q.defer();
            resourceClients.update({
                owner: options.owner,
                id: options.id
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);

        }

        function createClient(options) {
            var deferred = $q.defer();
            resourceClients.post({
                owner: options.owner
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);

        }

        function createBranch(options) {
            var deferred = $q.defer();
            resourceBranch.post({
                owner: options.owner
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }



        function deleteBranch(options) {
            var deferred = $q.defer();
            resourceBranch.delete(options, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function deleteClient(options) {
            var deferred = $q.defer();
            resourceClients.delete({
                owner: options.owner,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateCompany(options) {
            var deferred = $q.defer();
            resourceCompany.update({
                owner: options.owner,
                id: options.id
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function createCompany(options) {
            var deferred = $q.defer();
            resourceCompany.post({
                owner: options.owner
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function createUser(options) {
            var deferred = $q.defer();
            resourceUser.post({
                owner: options.owner
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateUser(options) {
            var deferred = $q.defer();
            resourceUser.update({
                owner: options.owner,
                id: options.id
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function addUserToCompany(options) {
            var deferred = $q.defer();
            resourceAddToCompany.put({
                owner: options.owner
            }, {
                    user_id: options.user_id,
                    company_id: options.company_id
                },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function addUserJobPosition(options) {
            var deferred = $q.defer();
            resourceAddJobPosition.put({
                owner: options.owner
            }, {
                    user_id: options.user_id,
                    branch_id: options.branch_id,
                    division_id: options.division_id,
                    job_position_id: options.job_position_id
                },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function removeUserJobPosition(options) {
            var deferred = $q.defer();
            resourceRemoveJobPosition.delete({
                owner: options.owner,
                user_id: options.user_id,
                branch_id: options.branch_id,
                division_id: options.division_id,
                job_position_id: options.job_position_id
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getUsers(options) {
            var deferred = $q.defer();
            resourceUser.get(options,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateBranch(options) {
            var deferred = $q.defer();
            resourceBranch.update({
                owner: options.owner,
                id: options.id
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getQuestions(options) {
            var deferred = $q.defer();
            resourceQuestion.get({
                owner: options.owner,
                id_sector: options.sector_id
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getSectors(options) {
            var deferred = $q.defer();
            resourceSectors.get({
                owner: options.owner,
                resultsPerPage: options.resultsPerPage
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);

        }

        function getPositions(options) {
            var deferred = $q.defer();
            resourcePositions.get({
                owner: options.owner,
                resultsPerPage: options.resultsPerPage
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getFileRegions() {
            var deferred = $q.defer();
            resourceFile.get({},
                function (responseResult) {
                    deferred.resolve(JSON.parse(angular.toJson(responseResult)));
                },
                function (e) {
                    showError(e)
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getDivisions(options) {
            var deferred = $q.defer();
            resourceDivisions.get({
                owner: options.owner,
                resultsPerPage: options.resultsPerPage
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getLegalFolder(options) {
            var deferred = $q.defer();
            resourceLegalFolder.get({
                owner: options.owner,
                id_company: options.id_company
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getRegions(options) {
            var deferred = $q.defer();
            resourceRegions.get({
                owner: options.owner
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getCompany(options) {
            var deferred = $q.defer();
            resourceCompany.get({
                owner: options.owner,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getBranches(options) {
            var deferred = $q.defer();
            resourceBranches.get(options,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function evaluateAnswer(options) {
            var deferred = $q.defer();
            resourceQuestion.post({
                owner: options.owner,
                evaluateAnswer: 'evaluateAnswers'
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getFilters(options) {
            var deferred = $q.defer();

            return (deferred.promise);
        }

        var resourceFile = $resource("/assets/json-i18n/region-literals.json", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: true
                }
            });


        var resourceClients = $resource(COMMON.BASE_API + "/owner/:owner/company/:id", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                delete: {
                    method: "DELETE",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                },
            });

        var resourceSectors = $resource(COMMON.BASE_API + "/owner/:owner/sector", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });

        var resourceCompany = $resource(COMMON.BASE_API + "/owner/:owner/company/:id", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                }
            });

        var resourceUser = $resource(COMMON.BASE_API + "/owner/:owner/user/:id/", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                }
            });

        var resourceAddToCompany = $resource(COMMON.BASE_API + "/owner/:owner/user/addToCompany", {
            // No default data
        }, {
                put: {
                    method: "PUT",
                    isArray: false
                }
            });

        var resourceAddJobPosition = $resource(COMMON.BASE_API + "/owner/:owner/user/addDivisionJobPosition", {
            // No default data
        }, {
                put: {
                    method: "PUT",
                    isArray: false
                }
            });

        var resourceRemoveJobPosition = $resource(COMMON.BASE_API + "/owner/:owner/user/removeDivisionJobPosition/:user_id/:branch_id/:division_id/:job_position_id", {
            // No default data
        }, {
                delete: {
                    method: "DELETE",
                    isArray: false
                }
            });

        var resourceQuestion = $resource(COMMON.BASE_API + "/owner/:owner/question/:evaluateAnswer", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                }
            });

        var resourceBranch = $resource(COMMON.BASE_API + "/owner/:owner/branch/:id", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },

                post: {
                    method: "POST",
                    isArray: false
                },

                update: {
                    method: "PUT",
                    isArray: false
                },
                delete: {
                    method: "DELETE",
                    isArray: false
                }
            });
        var resourceBranches = $resource(COMMON.BASE_API + "/owner/:owner/branch/", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });
        var resourceStoragePrefix = $resource(COMMON.BASE_API + "/owner/:owner/upload/storagePrefix", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });

        var resourcePositions = $resource(COMMON.BASE_API + "/owner/:owner/jobPosition", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });

        var resourceDivisions = $resource(COMMON.BASE_API + "/owner/:owner/division", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });
        var resourceLegalFolder = $resource(COMMON.BASE_API + "/owner/:owner/fileGroup/legalDocuments/:id_company", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });
        var resourceRegions = $resource(COMMON.BASE_API + "/owner/:owner/region", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });


        return ({
            get: getClients,
            getFilters: getFilters,
            getFileRegions: getFileRegions,
            getRegions: getRegions,
            createClient: createClient,
            createCompany: createCompany,
            deleteClient: deleteClient,
            updateClient: updateClient,
            updateCompany: updateCompany,
            createUser: createUser,
            updateUser: updateUser,
            addUserToCompany: addUserToCompany,
            addUserJobPosition: addUserJobPosition,
            removeUserJobPosition: removeUserJobPosition,
            getSectors: getSectors,
            getQuestions: getQuestions,
            createBranch: createBranch,
            getLegalFolder: getLegalFolder,
            updateBranch: updateBranch,
            deleteBranch: deleteBranch,
            getCompany: getCompany,
            getStoragePrefix: getStoragePrefix,
            getBranches: getBranches,
            getPositions: getPositions,
            getDivisions: getDivisions,
            getUsers: getUsers,
            evaluateAnswer: evaluateAnswer
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.chat', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msUtilProvider)
    {

        // State
        $stateProvider.state('app.chat', {
            url    : '/chat',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/chat/chat.html',
                    controller : 'ChatController as vm'
                }
            },
            resolve: {
                Contacts: function (msApi)
                {
                    return msApi.resolve('chat.contacts@get');
                },
                User    : function (msApi)
                {
                    return msApi.resolve('chat.user@get');
                }
            }
        });

        // Translation
        var base = 'app/main/apps/chat';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }
        // Api

        // Contacts data must be alphabatically ordered.
        msApiProvider.register('chat.contacts', ['app/data/chat/contacts.json']);

        msApiProvider.register('chat.chats', ['app/data/chat/chats/:id.json']);

        msApiProvider.register('chat.user', ['app/data/chat/user.json']);


        // Navigation
        // msNavigationServiceProvider.saveItem('apps.chat', {
        //     title : 'Messages',
        //     icon  : 'icon-hangouts',
        //     state : 'app.chat',
        //     badge : {
        //         content: 13,
        //         color  : '#09d261'
        //     },
        //     weight: 5
        // });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.chat')
        .controller('ChatController', ChatController);

    /** @ngInject */
    function ChatController(Contacts, ChatsService, $mdSidenav, User, $timeout, $document, $mdMedia)
    {

        var vm = this;

        // Data
        vm.contacts = ChatsService.contacts = Contacts.data;
        vm.chats = ChatsService.chats;
        vm.user = User.data;
        vm.leftSidenavView = false;
        vm.chat = undefined;

        // Methods
        vm.getChat = getChat;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleLeftSidenavView = toggleLeftSidenavView;
        vm.reply = reply;
        vm.setUserStatus = setUserStatus;
        vm.clearMessages = clearMessages;

        //////////

        /**
         * Get Chat by Contact id
         * @param contactId
         */
        function getChat(contactId)
        {
            ChatsService.getContactChat(contactId).then(function (response)
            {
                vm.chatContactId = contactId;
                vm.chat = response;

                // Reset the reply textarea
                resetReplyTextarea();

                // Scroll to the last message
                scrollToBottomOfChat();

                if ( !$mdMedia('gt-md') )
                {
                    $mdSidenav('left-sidenav').close();
                }

                // Reset Left Sidenav View
                vm.toggleLeftSidenavView(false);

            });
        }

        /**
         * Reply
         */
        function reply($event)
        {
            // If "shift + enter" pressed, grow the reply textarea
            if ( $event && $event.keyCode === 13 && $event.shiftKey )
            {
                vm.textareaGrow = true;
                return;
            }

            // Prevent the reply() for key presses rather than the"enter" key.
            if ( $event && $event.keyCode !== 13 )
            {
                return;
            }

            // Check for empty messages
            if ( vm.replyMessage === '' )
            {
                resetReplyTextarea();
                return;
            }

            // Message
            var message = {
                who    : 'user',
                message: vm.replyMessage,
                time   : new Date().toISOString()
            };

            // Add the message to the chat
            vm.chat.push(message);

            // Update Contact's lastMessage
            vm.contacts.getById(vm.chatContactId).lastMessage = message;

            // Reset the reply textarea
            resetReplyTextarea();

            // Scroll to the new message
            scrollToBottomOfChat();

        }

        /**
         * Clear Chat Messages
         */
        function clearMessages()
        {
            vm.chats[vm.chatContactId] = vm.chat = [];
            vm.contacts.getById(vm.chatContactId).lastMessage = null;
        }

        /**
         * Reset reply textarea
         */
        function resetReplyTextarea()
        {
            vm.replyMessage = '';
            vm.textareaGrow = false;
        }

        /**
         * Scroll Chat Content to the bottom
         * @param speed
         */
        function scrollToBottomOfChat()
        {
            $timeout(function ()
            {
                var chatContent = angular.element($document.find('#chat-content'));

                chatContent.animate({
                    scrollTop: chatContent[0].scrollHeight
                }, 400);
            }, 0);

        }

        /**
         * Set User Status
         */
        function setUserStatus(status)
        {
            vm.user.status = status;
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggle Left Sidenav View
         *
         * @param view id
         */
        function toggleLeftSidenavView(id)
        {
            vm.leftSidenavView = id;
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.aircrafts', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msUtilProvider) {
        // State
        $stateProvider
            .state('app.aircrafts', {
                abstract: true,
                url: '/aircraft',
                resolve: {
                    Folders: function(msApi) {
                        return msApi.resolve('mail.folders@get');
                    },
                    Labels: function(msApi) {
                        return msApi.resolve('mail.labels@get');
                    }
                }
            })
            .state('app.aircrafts.threads', {
                url: '/{type:(?:label)}/:filter',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/aircrafts/mail.html',
                        controller: 'AircraftsController as vm'
                    }
                },
                params: {
                    type: {
                        value: null,
                        squash: true
                    }
                },
                bodyClass: 'mail'
            })
            .state('app.aircrafts.threads.thread', {
                url: '/:threadId',
                bodyClass: 'mail'
            });

        // Translation
        var base = 'app/main/apps/aircrafts';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }
        // Api
        msApiProvider.register('mail.folders', ['app/data/aircrafts/folders.json']);
        msApiProvider.register('mail.labels', ['app/data/aircrafts/labels.json']);

        msApiProvider.register('mail.label.notes', ['app/data/aircrafts/labels/notes.json']);
        msApiProvider.register('mail.label.paypal', ['app/data/aircrafts/labels/paypal.json']);
        msApiProvider.register('mail.label.invoices', ['app/data/aircrafts/labels/invoices.json']);
        msApiProvider.register('mail.label.amazon', ['app/data/aircrafts/labels/amazon.json']);

        msApiProvider.register('mail.folder.list', ['app/data/aircrafts/folders/list.json']);
        msApiProvider.register('mail.folder.sent', ['app/data/aircrafts/folders/sent.json']);
        msApiProvider.register('mail.folder.drafts', ['app/data/aircrafts/folders/drafts.json']);
        msApiProvider.register('mail.folder.spam', ['app/data/aircrafts/folders/spam.json']);
        msApiProvider.register('mail.folder.trash', ['app/data/aircrafts/folders/trash.json']);
        msApiProvider.register('mail.folder.starred', ['app/data/aircrafts/folders/starred.json']);
        msApiProvider.register('mail.folder.important', ['app/data/aircrafts/folders/important.json']);

        // Navigation
        // msNavigationServiceProvider.saveItem('apps.aircrafts', {
        //     title: 'Aircraft',
        //     icon: 'icon-airplane',
        //     state: 'app.aircrafts.threads',
        //     stateParams: {
        //         filter: 'list'
        //     },
        //     badge: {
        //         content: 25,
        //         color: '#F44336'
        //     },
        //     weight: 4
        // });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.aircrafts')
        .controller('AircraftsController', AircraftsController);

    /** @ngInject */
    function AircraftsController($scope, $rootScope, $document, $mdDialog, $mdMedia, $mdSidenav, $state, msApi, Folders, Labels, tinyMceService)
    {
        var vm = this;

        // Data
        vm.accounts = {
            'creapond'    : 'johndoe@creapond.com',
            'withinpixels': 'johndoe@withinpixels.com'
        };
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
        vm.selectedAccount = 'creapond';

        vm.folders = Folders.data;
        vm.labels = Labels.data;
        vm.loadingThreads = true;

        vm.currentFilter = {
            type  : $state.params.type,
            filter: $state.params.filter
        };
        vm.currentThread = null;
        vm.selectedThreads = [];

        vm.views = {
            classic: 'app/main/apps/aircrafts/views/classic/classic-view.html',
            outlook: 'app/main/apps/aircrafts/views/outlook/outlook-view.html'
        };
        vm.defaultView = 'outlook';
        vm.currentView = 'outlook';

        // Methods
        vm.loadFolder = loadFolder;
        vm.loadLabel = loadLabel;
        vm.isFolderActive = isFolderActive;
        vm.isLabelActive = isLabelActive;

        vm.openThread = openThread;
        vm.closeThread = closeThread;

        vm.isSelected = isSelected;
        vm.toggleSelectThread = toggleSelectThread;
        vm.selectThreads = selectThreads;
        vm.deselectThreads = deselectThreads;
        vm.toggleSelectThreads = toggleSelectThreads;

        vm.setThreadStatus = setThreadStatus;
        vm.toggleThreadStatus = toggleThreadStatus;

        vm.getLabel = getLabel;
        vm.getLabelColor = getLabelColor;
        vm.getLabelTitle = getLabelTitle;
        vm.toggleLabel = toggleLabel;
        vm.isLabelExist = isLabelExist;

        vm.changeView = changeView;

        vm.composeDialog = composeDialog;
        vm.replyDialog = replyDialog;

        vm.toggleSidenav = toggleSidenav;

        vm.tinymceOptions = tinyMceService.getOptions($scope);

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Figure out the api name
            var apiName = 'mail.' + ($state.params.type || 'folder') + '.' + $state.params.filter + '@get';

            // Request the mails
            msApi.request(apiName).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.threads = response.data;

                    // Hide the loading screen
                    vm.loadingThreads = false;

                    // Open the thread if needed
                    if ( $state.params.threadId )
                    {
                        for ( var i = 0; i < vm.threads.length; i++ )
                        {
                            if ( vm.threads[i].id === $state.params.threadId )
                            {
                                vm.openThread(vm.threads[i]);
                                break;
                            }
                        }
                    }
                }
            );
        }

        // Watch screen size to change view modes
        $scope.$watch(function ()
        {
            return $mdMedia('xs');
        }, function (current, old)
        {
            if ( angular.equals(current, old) )
            {
                return;
            }

            if ( current )
            {
                vm.currentView = 'classic';
            }
        });

        $scope.$watch(function ()
        {
            return $mdMedia('gt-xs');
        }, function (current, old)
        {
            if ( angular.equals(current, old) )
            {
                return;
            }

            if ( current )
            {
                if ( vm.defaultView === 'outlook' )
                {
                    vm.currentView = 'outlook';
                }
            }
        });

        /**
         * Load folder
         *
         * @param name
         */
        function loadFolder(name)
        {
            // If we are already in the selected folder and
            // there is an open thread just close it
            if ( vm.isFolderActive(name) )
            {
                // Close the current thread if open
                if ( vm.currentThread )
                {
                    vm.closeThread();
                }

                return;
            }

            // Show loader
            $rootScope.loadingProgress = true;

            // Update the state without reloading the controller
            $state.go('app.aircrafts.threads', {
                type  : null,
                filter: name
            }, {notify: false});

            // Build the API name
            var apiName = 'mail.folder.' + name + '@get';

            // Make the call
            msApi.request(apiName).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.threads = response.data;

                    // Set the current filter
                    vm.currentFilter = {
                        type  : null,
                        filter: name
                    };

                    // Close the current thread if open
                    if ( vm.currentThread )
                    {
                        vm.closeThread();
                    }

                    // Hide loader
                    $rootScope.loadingProgress = false;
                }
            );
        }

        /**
         * Load label
         *
         * @param name
         */
        function loadLabel(name)
        {
            // Update the state without reloading the controller
            $state.go('app.aircrafts.threads', {
                type  : 'label',
                filter: name
            }, {notify: false});

            // If we are already in the selected folder and
            // there is an open thread just close it
            if ( vm.isLabelActive(name) )
            {
                // Close the current thread if open
                if ( vm.currentThread )
                {
                    vm.closeThread();
                }

                return;
            }

            // Show loader
            $rootScope.loadingProgress = true;

            // Build the API name
            var apiName = 'mail.label.' + name + '@get';

            // Make the call
            msApi.request(apiName).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.threads = response.data;

                    // Set the current filter
                    vm.currentFilter = {
                        type  : 'label',
                        filter: name
                    };

                    // Close the current thread if open
                    if ( vm.currentThread )
                    {
                        vm.closeThread();
                    }

                    // Hide loader
                    $rootScope.loadingProgress = false;
                }
            );
        }

        /**
         * Is the folder with the given name active?
         *
         * @param name
         * @returns {boolean}
         */
        function isFolderActive(name)
        {
            return (vm.currentFilter.type === null && vm.currentFilter.filter === name);
        }

        /**
         * Is the label with the given name active?
         *
         * @param name
         * @returns {boolean}
         */
        function isLabelActive(name)
        {
            return (vm.currentFilter.type === 'label' && vm.currentFilter.filter === name);
        }

        /**
         * Open thread
         *
         * @param thread
         */
        function openThread(thread)
        {
            // Set the read status on the thread
            thread.read = true;

            // Assign thread as the current thread
            vm.currentThread = thread;

            // Update the state without reloading the controller
            $state.go('app.aircrafts.threads.thread', {threadId: thread.id}, {notify: false});
        }

        /**
         * Close thread
         */
        function closeThread()
        {
            vm.currentThread = null;

            // Update the state without reloading the controller
            $state.go('app.aircrafts.threads', {
                type  : vm.currentFilter.type,
                filter: vm.currentFilter.filter
            }, {notify: false});
        }

        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        function isSelected(thread)
        {
            return vm.selectedThreads.indexOf(thread) > -1;
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        function toggleSelectThread(thread, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            if ( vm.selectedThreads.indexOf(thread) > -1 )
            {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            }
            else
            {
                vm.selectedThreads.push(thread);
            }
        }

        /**
         * Select threads. If key/value pair given,
         * threads will be tested against them.
         *
         * @param [key]
         * @param [value]
         */
        function selectThreads(key, value)
        {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedThreads = [];

            for ( var i = 0; i < vm.threads.length; i++ )
            {
                if ( angular.isUndefined(key) && angular.isUndefined(value) )
                {
                    vm.selectedThreads.push(vm.threads[i]);
                    continue;
                }

                if ( angular.isDefined(key) && angular.isDefined(value) && vm.threads[i][key] === value )
                {
                    vm.selectedThreads.push(vm.threads[i]);
                }
            }
        }

        /**
         * Deselect threads
         */
        function deselectThreads()
        {
            vm.selectedThreads = [];
        }

        /**
         * Toggle select threads
         */
        function toggleSelectThreads()
        {
            if ( vm.selectedThreads.length > 0 )
            {
                vm.deselectThreads();
            }
            else
            {
                vm.selectThreads();
            }
        }

        /**
         * Set the status on given thread, current thread or selected threads
         *
         * @param key
         * @param value
         * @param [thread]
         * @param [event]
         */
        function setThreadStatus(key, value, thread, event)
        {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if ( event )
            {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if ( thread )
            {
                thread[key] = value;
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if ( vm.currentThread )
            {
                vm.currentThread[key] = value;
                return;
            }

            // Otherwise do the status update on selected threads
            for ( var x = 0; x < vm.selectedThreads.length; x++ )
            {
                vm.selectedThreads[x][key] = value;
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleThreadStatus(key, thread, event)
        {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if ( event )
            {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if ( thread )
            {
                if ( typeof(thread[key]) !== 'boolean' )
                {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if ( vm.currentThread )
            {
                if ( typeof(vm.currentThread[key]) !== 'boolean' )
                {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for ( var x = 0; x < vm.selectedThreads.length; x++ )
            {
                if ( typeof(vm.selectedThreads[x][key]) !== 'boolean' )
                {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }

        /**
         * Get label object content
         *
         * @param id
         * @returns {*}
         */
        function getLabel(id)
        {
            for ( var i = 0; i < vm.labels.length; i++ )
            {
                if ( vm.labels[i].id === id )
                {
                    return vm.labels[i];
                }
            }
        }

        /**
         * Get label color from label object
         *
         * @param id
         * @returns {*}
         */
        function getLabelColor(id)
        {
            return vm.getLabel(id).color;
        }

        /**
         * Get label title from label object
         *
         * @param id
         * @returns {*}
         */
        function getLabelTitle(id)
        {
            return vm.getLabel(id).title;
        }

        /**
         * Toggle label
         *
         * @param label
         */
        function toggleLabel(label)
        {
            // Toggle label on the currently open thread
            if ( vm.currentThread )
            {
                if ( vm.currentThread.labels.indexOf(label.id) > -1 )
                {
                    vm.currentThread.labels.splice(vm.currentThread.labels.indexOf(label.id), 1);
                }
                else
                {
                    vm.currentThread.labels.push(label.id);
                }

                return;
            }

            // Toggle labels on selected threads
            // Toggle action will be determined by the first thread from the selection.
            if ( vm.selectedThreads.length > 0 )
            {
                // Decide if we are going to remove or add labels
                var removeLabels = (vm.selectedThreads[0].labels.indexOf(label.id) > -1);

                for ( var i = 0; i < vm.selectedThreads.length; i++ )
                {
                    if ( !removeLabels )
                    {
                        vm.selectedThreads[i].labels.push(label.id);
                        continue;
                    }

                    if ( vm.selectedThreads[i].labels.indexOf(label.id) > -1 )
                    {
                        vm.selectedThreads[i].labels.splice(vm.selectedThreads[i].labels.indexOf(label.id), 1);
                    }
                }
            }
        }

        /**
         * Is label exist?
         *
         * @param label
         * @returns {boolean}
         */
        function isLabelExist(label)
        {
            if ( vm.currentThread && vm.currentThread.labels )
            {
                return (vm.currentThread.labels.indexOf(label.id) > -1);
            }
        }

        /**
         * Change the view
         *
         * @param view
         */
        function changeView(view)
        {
            if ( vm.views[view] )
            {
                vm.defaultView = view;
                vm.currentView = view;
            }
        }

        /**
         * Open compose dialog
         *
         * @param ev
         */

        function composeDialog(ev)
        {
            $mdDialog.show({
                controller         : 'ComposeDialogController',
                controllerAs       : 'vm',
                locals             : {
                    selectedMail: undefined
                },
                templateUrl        : 'app/main/apps/mail/dialogs/compose/compose-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }

        /**
         * Open reply dialog
         *
         * @param ev
         */
        function replyDialog(ev)
        {
            $mdDialog.show({
                controller         : 'ComposeDialogController',
                controllerAs       : 'vm',
                locals             : {
                    selectedMail: vm.selectedMail
                },
                templateUrl        : 'app/main/apps/mail/dialogs/compose/compose-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.components.widgets', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_widgets', {
            url  : '/components/widgets',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/widgets/widgets.html',
                    controller : 'WidgetsController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.widgets')
        .controller('WidgetsController', WidgetsController);

    /** @ngInject */
    function WidgetsController()
    {
        var vm = this;

        // Data
        vm.widget1 = {
            title        : 'WEEKLY TRANSACTIONS',
            value        : 30342,
            lastWeekValue: 30002,
            lastWeekDiff : '+ 1,12%',
            detail       : 'This is the back side. You can show detailed information here.'
        };

        vm.widget2 = {
            title        : 'SALES QUOTA',
            value        : 40,
            lastWeekValue: 85,
            lastWeekDiff : '- 45%',
            detail       : 'This is the back side. You can show detailed information here.'
        };

        vm.widget3 = {
            title : 'BOUNCE RATE',
            value : 80,
            detail: 'This is the back side. You can show detailed information here.'
        };

        vm.widget4 = {
            title        : 'STOCK COUNT',
            value        : 5583,
            lastWeekValue: 5583,
            lastWeekDiff : '- 0%',
            detail       : 'This is the back side. You can show detailed information here.'
        };

        vm.widget5 = {
            title: 'USERS ONLINE',
            value: 658
        };

        vm.widget6 = {
            title: 'WASTELANDERS',
            value: 358
        };

        vm.widget7 = {
            title: 'VAULTS SEALED',
            value: 24
        };

        vm.widget8 = {
            title: 'VAULTS OPEN',
            value: 62
        };

        vm.widget9 = {
            title: 'SONGS',
            value: 210
        };

        vm.widget10 = {
            title: 'VIDEOS',
            value: 54
        };

        vm.widget11 = {
            title: 'DOCUMENTS',
            value: 1252
        };

        vm.widget12 = {
            date       : 'June 27, Saturday',
            temperature: 28,
            event      : 'Sunny',
            icon       : 'icon-weather-cloudy',
            location   : 'New York, NY',
            detail     : [
                {
                    day        : 'Sun',
                    icon       : 'icon-weather-rainy',
                    temperature: 24,
                    event      : 'Rainy'
                },
                {
                    day        : 'Mon',
                    icon       : 'icon-weather-pouring',
                    temperature: 23,
                    event      : 'Rainy'
                },
                {
                    day        : 'Tue',
                    icon       : 'icon-weather-cloudy',
                    temperature: 29,
                    event      : 'Overcast'
                },
                {
                    day        : 'Wed',
                    icon       : 'icon-weather-partlycloudy',
                    temperature: 28,
                    event      : 'Sunny'
                },
                {
                    day        : 'Thu',
                    icon       : 'icon-weather-partlycloudy',
                    temperature: 31,
                    event      : 'Sunny'
                }
            ]
        };

        vm.widget13 = {
            date       : 'June 28, Saturday',
            temperature: 16,
            event      : 'Rainy',
            icon       : 'icon-weather-rainy',
            location   : 'Moscow',
            detail     : [
                {
                    day        : 'Sun',
                    icon       : 'icon-weather-rainy',
                    temperature: 24,
                    event      : 'Rainy'
                },
                {
                    day        : 'Mon',
                    icon       : 'icon-weather-pouring',
                    temperature: 23,
                    event      : 'Rainy'
                },
                {
                    day        : 'Tue',
                    icon       : 'icon-weather-cloudy',
                    temperature: 29,
                    event      : 'Overcast'
                },
                {
                    day        : 'Wed',
                    icon       : 'icon-weather-partlycloudy',
                    temperature: 28,
                    event      : 'Sunny'
                },
                {
                    day        : 'Thu',
                    icon       : 'icon-weather-partlycloudy',
                    temperature: 31,
                    event      : 'Sunny'
                }
            ]
        };

        vm.widget14 = {
            title: 'Visitor Demographics',
            tabs : [
                {
                    label : '30 days',
                    groups: [
                        {
                            title: 'Genders',
                            data : [
                                {
                                    title: 'Male',
                                    value: 40
                                },
                                {
                                    title: 'Female',
                                    value: 41
                                }
                            ]
                        },
                        {
                            title: 'Age',
                            data : [
                                {
                                    title: '25 - 34',
                                    value: 32
                                },
                                {
                                    title: '35 - 44',
                                    value: 85
                                }
                            ]
                        }
                    ]
                },
                {
                    label : '10 days',
                    groups: [
                        {
                            title: 'Genders',
                            data : [
                                {
                                    title: 'Male',
                                    value: 32
                                },
                                {
                                    title: 'Female',
                                    value: 49
                                }
                            ]
                        },
                        {
                            title: 'Age',
                            data : [
                                {
                                    title: '25 - 34',
                                    value: 85
                                },
                                {
                                    title: '35 - 44',
                                    value: 60
                                }
                            ]
                        }
                    ]
                },
                {
                    label : '1 day',
                    groups: [
                        {
                            title: 'Genders',
                            data : [
                                {
                                    title: 'Male',
                                    value: 28
                                },
                                {
                                    title: 'Female',
                                    value: 60
                                }
                            ]
                        },
                        {
                            title: 'Age',
                            data : [
                                {
                                    title: '25 - 34',
                                    value: 17
                                },
                                {
                                    title: '35 - 44',
                                    value: 64
                                }
                            ]
                        }
                    ]
                }
            ]
        };

        vm.widget15 = {
            title: 'CPU USAGE',
            value: 200,
            chart: {
                columns: [
                    {
                        id    : 'CPU',
                        name  : 'CPU',
                        color : 'white',
                        values: '30,200,100,400,150,250',
                        type  : 'spline'
                    }
                ]
            }
        };

        vm.widget16 = {
            title        : 'STOCK COUNT',
            value        : 5583,
            lastWeekValue: 5583,
            lastWeekDiff : '- 0%',
            chart        : {
                columns: [
                    {
                        id    : 'STOCK',
                        name  : 'STOCK',
                        color : 'purple',
                        values: '30,200,100,400,150,250',
                        type  : 'area'
                    }
                ]
            }
        };

        vm.widget17 = {
            title   : 'IO RATE',
            subtitle: 'Showing last 5 hours',
            chart   : {
                columns: [
                    {
                        id    : 'Input',
                        name  : 'Input',
                        color : 'green',
                        values: '30,75,290,400,150,250',
                        type  : 'spline'
                    },
                    {
                        id    : 'Output',
                        name  : 'Output',
                        color : 'blue',
                        values: '500,300,120,600,50,80',
                        type  : 'spline'
                    }
                ]
            }
        };

        vm.widget18 = {
            title        : 'WEEKLY VISITORS',
            value        : 30342,
            lastWeekValue: 30002,
            lastWeekDiff : '1.12%',
            chart        : {
                columns: [
                    {
                        id    : 'Visitors',
                        name  : 'Visitors',
                        color : 'steelblue',
                        values: '30,75,290,400,150,250,75,210,125,92,30,75,290,400',
                        type  : 'bar'
                    }
                ]
            }
        };

        vm.widget19 = {
            title   : 'Google Inc.',
            subtitle: 'NASDAQ: GOOG',
            value   : '531.69',
            diff    : '2.29%',
            chart   : {
                columns: [
                    {
                        id    : 'GOOG',
                        name  : 'GOOG',
                        color : 'white',
                        values: '30,75,290,400,150,250,75,210,125,92,30,75,290,400',
                        type  : 'bar'
                    }
                ]
            }
        };

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.price-tables', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_price-tables', {
            url  : '/components/price-tables',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/price-tables/price-tables.html'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.price-tables')
        .controller('PriceTablesController', PriceTablesController);

    /** @ngInject */
    function PriceTablesController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.material-docs')
        .controller('DocTemplateController', DocTemplateController);

    /** @ngInject */
    function DocTemplateController(DEMOS, COMPONENTS, $state, $http, $templateCache)
    {
        var vm = this;
        var component = $state.current.data;
        vm.materialVersion = '1.0.8';

        vm.componentName = component.name;

        vm.component = getComponent(component.moduleName);

        if ( !component.excludeDemo )
        {
            vm.demo = getDemo(component.moduleName);
        }

        if ( vm.component )
        {
            vm.docs = vm.component.docs;
        }

        if ( vm.demo )
        {
            vm.demos = [];

            angular.forEach(vm.demo.demos, function (demo)
            {
                // Get displayed contents (un-minified)
                var files = [demo.index]
                    .concat(demo.js || [])
                    .concat(demo.css || [])
                    .concat(demo.html || []);
                files.forEach(function (file)
                {
                    file.httpPromise = $http.get('app/main/components/material-docs/' + file.outputPath, {cache: $templateCache})
                        .then(function (response)
                        {
                            file.contents = response.data
                                .replace('<head/>', '');
                            return file.contents;
                        });
                });
                demo.$files = files;
                vm.demos.push(demo);
            });

            vm.demos = vm.demos.sort(function (a, b)
            {
                return a.name > b.name ? 1 : -1;
            });
        }

        // Data

        // Methods

        //////////

        function getDemo(value)
        {
            return DEMOS.filter(function (x)
            {
                return x.moduleName === value;
            })[0];
        }

        function getComponent(value)
        {
            return COMPONENTS.filter(function (x)
            {
                return x.name === value;
            })[0];
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.maps', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.components_maps', {
                url  : '/components/maps',
                views: {
                    'content@app'                   : {
                        templateUrl: 'app/main/components/maps/maps.html',
                        controller : 'MapsController as vm'
                    },
                    'tabContent@app.components_maps': {
                        templateUrl: 'app/main/components/maps/tabs/simple.html'
                    }
                }
            })

            .state('app.components_maps.satellite', {
                url  : '/satellite',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/satellite.html'
                    }
                }
            })

            .state('app.components_maps.terrain', {
                url  : '/terrain',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/terrain.html'
                    }
                }
            })

            .state('app.components_maps.simple-marker', {
                url  : '/simple-marker',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/simple-marker.html'
                    }
                }
            })

            .state('app.components_maps.custom-marker', {
                url  : '/custom-marker',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/custom-marker.html'
                    }
                }
            })

            .state('app.components_maps.info-window', {
                url  : '/info-window',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/info-window.html'
                    }
                }
            });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.maps')
        .controller('MapsController', MapsController);

    /** @ngInject */
    function MapsController($state, uiGmapGoogleMapApi)
    {
        var vm = this;

        // Data
        var currentState = $state.current.name;

        switch ( currentState )
        {
            case 'app.components_maps':
                vm.selectedIndex = 0;
                break;

            case 'app.components_maps.satellite':
                vm.selectedIndex = 1;
                break;

            case 'app.components_maps.terrain':
                vm.selectedIndex = 2;
                break;

            case 'app.components_maps.simple-marker':
                vm.selectedIndex = 3;
                break;

            case 'app.components_maps.custom-marker':
                vm.selectedIndex = 4;
                break;

            case 'app.components_maps.info-window':
                vm.selectedIndex = 5;
                break;

            default:
                vm.selectedIndex = 0;
        }

        // Methods

        //////////

        uiGmapGoogleMapApi.then(function (maps)
        {
            vm.simpleMap = {
                center: {
                    latitude : -34.397,
                    longitude: 150.644
                },
                zoom  : 8
            };

            vm.satelliteMap = {
                center : {
                    latitude : -34.397,
                    longitude: 150.644
                },
                zoom   : 8,
                options: {
                    mapTypeId: maps.MapTypeId.SATELLITE
                }
            };

            vm.terrainMap = {
                center : {
                    latitude : -34.397,
                    longitude: 150.644
                },
                zoom   : 8,
                options: {
                    mapTypeId: maps.MapTypeId.TERRAIN
                }
            };

            vm.simpleMarkerMap = {
                center: {
                    latitude : -25.363882,
                    longitude: 131.044922
                },
                zoom  : 8,
                marker: {
                    id    : 0,
                    coords: {
                        latitude : -25.363882,
                        longitude: 131.044922
                    }
                }
            };

            vm.customMarkerMap = {
                center: {
                    latitude : -25.363882,
                    longitude: 131.044922
                },
                zoom  : 8,
                marker: {
                    id     : 0,
                    coords : {
                        latitude : -25.363882,
                        longitude: 131.044922
                    },
                    options: {
                        icon: {
                            anchor: new maps.Point(36, 36),
                            origin: new maps.Point(0, 0),
                            url   : '//google-developers.appspot.com/maps/documentation/javascript/examples/full/images/beachflag.png'
                        }
                    }
                }
            };

        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.custom-directives', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.components_custom-directives', {
                abstract: true,
                url     : '/components/custom-directives'
            })
            .state('app.components_custom-directives_ms-card', {
                url  : '/ms-card',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-card.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives_ms-form-wizard', {
                url  : '/ms-form-wizard',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-form-wizard.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives_ms-info-bar', {
                url  : '/ms-info-bar',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-info-bar.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives_ms-masonry', {
                url  : '/ms-masonry',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-masonry.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives_ms-material-color-picker', {
                url  : '/ms-material-color-picker',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-material-color-picker.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives_ms-nav', {
                url  : '/ms-nav',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-nav.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives_ms-navigation', {
                url  : '/ms-navigation',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-navigation.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives_ms-random-class', {
                url  : '/ms-random-class',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-random-class.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives_ms-responsive-table', {
                url  : '/ms-responsive-table',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-responsive-table.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives_ms-scroll', {
                url  : '/ms-scroll',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-scroll.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives_ms-search-bar', {
                url  : '/ms-search-bar',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-search-bar.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives_ms-shortcuts', {
                url  : '/ms-shortcuts',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-shortcuts.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives_ms-sidenav-helper', {
                url  : '/ms-sidenav-helper',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-sidenav-helper.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives_ms-splash-screen', {
                url  : '/ms-splash-screen',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-splash-screen.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives_ms-stepper', {
                url  : '/ms-stepper',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-stepper.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives_ms-timeline', {
                url  : '/ms-timeline',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-timeline.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives_ms-widget', {
                url  : '/ms-widget',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-widget.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('components.custom-directives', {
            title : 'Custom Directives',
            icon  : 'icon-star',
            weight: 2
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-card', {
            title : 'ms-card',
            state : 'app.components_custom-directives_ms-card',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-form-wizard', {
            title : 'ms-form-wizard',
            state : 'app.components_custom-directives_ms-form-wizard',
            weight: 2
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-info-bar', {
            title : 'ms-info-bar',
            state : 'app.components_custom-directives_ms-info-bar',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-masonry', {
            title : 'ms-masonry',
            state : 'app.components_custom-directives_ms-masonry',
            weight: 4
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-material-color-picker', {
            title : 'ms-material-color-picker',
            state : 'app.components_custom-directives_ms-material-color-picker',
            weight: 5
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-nav', {
            title : 'ms-nav',
            state : 'app.components_custom-directives_ms-nav',
            weight: 6
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-navigation', {
            title : 'ms-navigation',
            state : 'app.components_custom-directives_ms-navigation',
            weight: 7
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-random-class', {
            title : 'ms-random-class',
            state : 'app.components_custom-directives_ms-random-class',
            weight: 8
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-responsive-table', {
            title : 'ms-responsive-table',
            state : 'app.components_custom-directives_ms-responsive-table',
            weight: 9
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-scroll', {
            title : 'ms-scroll',
            state : 'app.components_custom-directives_ms-scroll',
            weight: 10
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-search-bar', {
            title : 'ms-search-bar',
            state : 'app.components_custom-directives_ms-search-bar',
            weight: 11
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-shortcuts', {
            title : 'ms-shortcuts',
            state : 'app.components_custom-directives_ms-shortcuts',
            weight: 12
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-sidenav-helper', {
            title : 'ms-sidenav-helper',
            state : 'app.components_custom-directives_ms-sidenav-helper',
            weight: 13
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-splash-screen', {
            title : 'ms-splash-screen',
            state : 'app.components_custom-directives_ms-splash-screen',
            weight: 14
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-stepper', {
            title : 'ms-stepper',
            state : 'app.components_custom-directives_ms-stepper',
            weight: 15
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-timeline', {
            title : 'ms-timeline',
            state : 'app.components_custom-directives_ms-timeline',
            weight: 16
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-widget', {
            title : 'ms-widget',
            state : 'app.components_custom-directives_ms-widget',
            weight: 17
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.components.custom-directives')
        .controller('CustomDirectivesController', CustomDirectivesController);

    /** @ngInject */
    function CustomDirectivesController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.components.cards', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        $stateProvider.state('app.components_cards', {
            url    : '/components/cards',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/components/cards/cards.html',
                    controller : 'CardsController as vm'
                }
            },
            resolve: {
                Cards: function (msApi)
                {
                    return msApi.resolve('cards@get');
                }
            }
        });

        // Api
        msApiProvider.register('cards', ['app/data/cards/cards.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.cards')
        .controller('CardsController', CardsController);

    /** @ngInject */
    function CardsController(Cards)
    {
        var vm = this;

        // Data
        vm.cards = Cards.data;

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    }, {passive: true});
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    },{passive: true});
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    },{passive: true});
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    })
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function () {
    'use strict';

    // 1 2 5 10 25 50 100 250 500 etc
    function quantizedNumber(i) {
        var adjust = [1, 2.5, 5];
        return Math.floor(Math.pow(10, Math.floor(i / 3)) * adjust[i % 3]);
    }

    // the j such that quantizedNumber(j) is closest to i
    function quantizedIndex(i) {
        if (i < 1) {
            return 0;
        }
        var group = Math.floor(Math.log(i) / Math.LN10),
            offset = i / (2.5 * Math.pow(10, group));
        if (offset >= 3) {
            group++;
            offset = 0;
        }
        return 3 * group + Math.round(Math.min(2, offset));
    }

    function quantize(i) {
        if (i === Infinity) {
            return Infinity;
        }
        return quantizedNumber(quantizedIndex(i));
    }

    // don't overwrite default response transforms
    function appendTransform(defaults, transform) {
        defaults = angular.isArray(defaults) ? defaults : [defaults];
        return (transform) ? defaults.concat(transform) : defaults;
    }

    angular
        .module('app.core')
        .directive('h2cPagination', function () {

            var defaultLinkGroupSize = 3,
                defaultClientLimit = 150,
                defaultPerPage = 50,
                defaultSortDir = 'DESC';

            return {
                restrict: 'AE',
                scope: {
                    // required
                    url: '=',
                    collection: '=',
                    service: '=',

                    // optional
                    totalItems: '=?',
                    owner: '=?',
                    columns: '=?',
                    columnsGrouped: '=?',
                    fieldsFilters: '=?',
                    menuFilters: '=?',
                    mediaZones: '=?',
                    fieldsSearch: '=?',
                    fieldsSort: '=?',
                    fieldsGroup: '=?',
                    groupby: '=?',
                    urlParams: '=?',
                    headers: '=?',
                    page: '=?',
                    perPage: '=?',
                    perPagePresets: '=?',
                    autoPresets: '=?',
                    clientLimit: '=?',
                    linkGroupSize: '=?',
                    reloadPage: '=?',
                    size: '=?',
                    passive: '@',
                    transformResponse: '=?',
                    // templateUrl: "app/core/directives/pagination/pagination.html"
                    // directive -> app communication only
                    numPages: '=?',
                    numItems: '=?',
                    serverLimit: '=?',
                    rangeFrom: '=?',
                    rangeTo: '=?',
                    filterByMediaType: '=?',
                    companyId: '=?'
                },
                templateUrl: function (element, attr) {
                    return attr.templateUrl || 'app/core/directives/pagination/pagination_fuse_1.html';
                    // return attr.templateUrl || 'src/paginate-anything.html';
                },
                replace: true,
                controller: ['$scope', '$rootScope', '$http', '$attrs', '$injector', 'requestContext', '$location', '_', '$mdSidenav',
                    function ($scope, $rootScope, $http, $attrs, $injector, requestContext, $location, _, $mdSidenav) {
                        $scope.collection = [];
                        var ServiceInject = $injector.get($attrs.service);
                        $scope.menuFiltersID = $attrs.menuFilters;
                        $rootScope.sortField = $attrs.sortField ? $attrs.sortField : null;
                        $rootScope.sortDir = $attrs.sortDir ? $attrs.sortDir : defaultSortDir;

                        var filterByMediaType = $scope.filterByMediaType ? $scope.filterByMediaType : null;

                        var owner = requestContext.getParam("owner");

                        $scope.preventFiltering = false;


                        // if ($location.search()
                            // .page && $location.search()
                                // .page > 0) {
                            // $rootScope.pagination_page = $location.search().page;
                            // $scope.pagination_page = $location.search().page;
                        // } else {
                            $rootScope.pagination_page = 1;
                            // $scope.pagination_page = 1;
                        // }

                        $scope.isLoading = true;

                        $scope.reloadPage = false;
                        $scope.filterables = [];
                        $rootScope.pagination_searchquery = 'test';
                        $scope.serverLimit = Infinity; // it's not known yet
                        $scope.Math = window.Math; // Math for the template


                        if (typeof $scope.autoPresets !== 'boolean') {
                            $scope.autoPresets = true;
                        }

                        var lgs = $scope.linkGroupSize,
                            cl = $scope.clientLimit;
                        $scope.linkGroupSize = typeof lgs === 'number' ? lgs : defaultLinkGroupSize;
                        $scope.clientLimit = typeof cl === 'number' ? cl : defaultClientLimit;

                        $scope.loadedFilters = false;

                        $scope.updatePresets = function () {

                            if ($scope.autoPresets) {

                                $rootScope.perPage = defaultPerPage;
                                $location.search('page', $rootScope.pagination_page);

                                $location.search('perPage', $rootScope.perPage);


                                var presets = [],
                                    i;
                                for (i = Math.min(3, quantizedIndex($rootScope.perPage || defaultPerPage)); i <= quantizedIndex(Math.min($scope.clientLimit, $scope.serverLimit)); i++) {
                                    presets.push(quantizedNumber(i));
                                }
                                $rootScope.perPagePresets = presets;
                            } else {
                                $rootScope.perPagePresets = $rootScope.perPagePresets.filter(
                                    function (preset) {
                                        return preset <= $scope.serverLimit;
                                    }
                                )
                                    .concat([$scope.serverLimit]);
                            }
                        };

                        $scope.gotoPage = function (i) {
                            $scope.isLoading = true;

                            if (i < 0 || i * $rootScope.perPage >= $scope.numItems) {
                                return;
                            }
                            $rootScope.pagination_page = i;
                            $location.search('page', $rootScope.pagination_page);
                        };

                        $rootScope.pagination_setOrderBy = function (i) {
                            var Sort = new Array;
                            Sort.push(i)


                            $rootScope.sortable = i;
                            $scope.preventFiltering = true;
                            $rootScope.pagination_page = 1;
                            updateLocation();
                            requestRange({
                                from: $rootScope.pagination_page,
                                resultsPerPage: $rootScope.perPage,
                                filters: $scope.fieldsFilters,
                                query: $scope.fieldsSearch,
                                sort: $rootScope.sortable
                            });


                        }

                        $rootScope.pagination_setSortField = function (field, dir) {

                            $rootScope.sortField = field ? field : $rootScope.sortField;
                            $rootScope.sortDir = dir ? dir : $rootScope.sortDir;

                            $scope.preventFiltering = true;
                            $rootScope.pagination_page = 1;
                            updateLocation();
                            requestRange({
                                from: $rootScope.pagination_page,
                                resultsPerPage: $rootScope.perPage,
                                filters: $scope.fieldsFilters,
                                query: $scope.fieldsSearch,
                                sortField: $rootScope.sortField,
                                sortDir: $rootScope.sortDir
                            });


                        }

                        $rootScope.pagination_resetOrderBy = function (i) {
                            $rootScope.sortField = null;
                        }

                        $rootScope.pagination_morePages = function () {

                            if ($rootScope.pagination_page == $scope.numPages) return true;
                            return false;

                        };
                        $rootScope.pagination_firstPage = function () {

                            if ($rootScope.pagination_page == 1) return true;
                            return false;

                        };

                        $rootScope.pagination_search = function (query) {
                            $rootScope.pagination_searchquery = true;
                            $rootScope.pagination_page = 1;
                            updateLocation();
                            requestRange({
                                from: $rootScope.pagination_page,
                                resultsPerPage: $rootScope.perPage,
                                filters: $scope.fieldsFilters,
                                sort: $rootScope.sortField,
                                searchStringFilter: query
                            });


                        }

                        $rootScope.pagination_resetquery = function (query) {
                            $rootScope.modelSearch = '';
                            $rootScope.pagination_searchquery = false;
                            $rootScope.pagination_page = 1;
                            _.each($scope.fieldsFilters, function (value, key, list) {
                                //									console.log($scope.fieldsFilters[key])
                                $scope.fieldsFilters[key]['selected'] = new Array;
                            });
                            updateLocation();
                            requestRange({
                                from: $rootScope.pagination_page,
                                resultsPerPage: $rootScope.perPage,
                                filters: $scope.fieldsFilters,
                                sort: $rootScope.sortField,
                            });


                        }

                        $rootScope.pagination_prevPage = function () {

                            var i = $rootScope.pagination_page;
                            i--;

                            if (i <= 0) {
                                return;
                            }
                            $rootScope.pagination_page = i;
                            $scope.isLoading = true;
                            $location.search('page', $rootScope.pagination_page);
                        };

                        $rootScope.pagination_nextPage = function (loadMore) {
                            if (loadMore) {
                                $rootScope.loadMore = true;
                            }
                            var i = $rootScope.pagination_page;
                            i++;

                            if (i > $scope.numPages) {
                                return;
                            }
                            $rootScope.pagination_page = i;
                            $scope.isLoading = true;
                            $location.search('page', $rootScope.pagination_page);
                        };

                        $rootScope.pagination_gotoPage = function (i) {
                            $scope.isLoading = true;

                            if (i < 0 || i * $rootScope.perPage >= $scope.numItems) {
                                return;
                            }
                            $rootScope.pagination_page = i;
                            $location.search('page', $rootScope.pagination_page);
                        };

                        $scope.linkGroupFirst = function () {
                            var rightDebt = Math.max(1,
                                $scope.linkGroupSize - ($scope.numPages - 1 - ($rootScope.pagination_page + 2))
                            );
                            return Math.max(1,
                                $rootScope.pagination_page - ($scope.linkGroupSize + rightDebt)
                            );
                        };

                        $scope.linkGroupLast = function () {
                            var leftDebt = Math.max(1,
                                $scope.linkGroupSize - ($rootScope.pagination_page - 2)
                            );
                            return Math.min($scope.numPages,
                                $rootScope.pagination_page + ($scope.linkGroupSize + leftDebt)
                            );
                        };

                        $scope.isFinite = function () {
                            return $scope.numPages < Infinity;
                        };

                        function updateLocation() {
                            $location.search('page', $rootScope.pagination_page);
                            $location.search('perPage', $rootScope.perPage);
                        }

                        function requestRange(request) {


                            if (!$scope.loadedFilters) {
                                // if (_.isEmpty($scope.filterables) || $scope.filterables === null) {
                                ServiceInject.getFilters({
                                    owner: owner
                                })
                                    .then(function (response) {

                                        $scope.fieldsFilters = new Array;
                                        $scope.fieldsSort = new Array;
                                        $scope.fieldsGroup = new Array;

                                        if (response.filters) {

                                            _.each(response.filters, function (value, key, list) {

                                                // value.name = newValuee.name.toLowerCase();
                                                var name = value.name.toLowerCase();
                                                _.extend(value, {
                                                    selected: []
                                                });

                                                var fieldFilterable = new Array;
                                                fieldFilterable['name'] = value.name.toLowerCase();
                                                fieldFilterable['selected'] = new Array;

                                                // $scope.fieldsFilters.push({ name : value });
                                                $scope.fieldsFilters[value.field] = (value);
                                                // $scope.filterables[value.name] = (value);

                                                // $scope.filters[value.name] = (value);


                                            });







                                            $scope.filters = angular.copy(response.filters);
                                            $scope.fieldsFilters = angular.copy(response.filters);
                                            $scope.mediaZones = angular.copy(response.media_zones);
                                        } else {

                                            $scope.filters = angular.copy(response);
                                            $scope.fieldsFilters = angular.copy(response);

                                        }


                                        if (response.sort.length > 0) {
                                            _.each(response.sort, function (value, key, list) {
                                                // value.name = value.name.toLowerCase();
                                                _.extend(value, {
                                                    order: 'DESC'
                                                });

                                                $scope.fieldsSort[value.name] = (value);

                                            });
                                            $scope.fieldsSort = angular.copy(response.sort);

                                        }

                                        if (response.group) {
                                            _.each(response.sort, function (value, key, list) {
                                                // value.name = value.name.toLowerCase();
                                                _.extend(value, {
                                                    order: 'DESC'
                                                });

                                                $scope.fieldsGroup[value.name] = (value);

                                            });
                                            $scope.fieldsGroup = angular.copy(response.group);


                                        }

                                        $scope.loadedFilters = true;



                                    });

                            }

                            $scope.$emit('pagination:loadStart', request);
                            // $scope.numPages = 100;
                            $scope.isLoading = true;

                            var options = {
                                page: request.newPage,
                                resultsPerPage: request.resultsPerPage,
                                owner: owner
                            };

                            // Common Options
                            if ($rootScope.sortField) options['sortField'] = $rootScope.sortField;
                            if ($rootScope.SortField) options['SortField'] = $rootScope.SortField;
                            if ($rootScope.sortDir) options['sortDir'] = $rootScope.sortDir;
                            if ($scope.companyId) options['companyId'] = $scope.companyId;
                            if (request.searchStringFilter) options['searchStringFilter'] = request.searchStringFilter;
                            if (request.filters) options['filters'] = request.filters;

                            // groups upload
                            if ($rootScope.pagination_groupIds) options['groupIds'] = $rootScope.pagination_groupIds;


                            // Media
                            if (filterByMediaType) options['media_type'] = filterByMediaType;

                            if (owner !== undefined) {

                                ServiceInject.get(options)
                                    .then(

                                        function (response) {

                                            $scope.hasLoaded = true;
                                            $scope.medialist = [];
                                            if ($rootScope.loadMore) {
                                                $scope.collection = $scope.collection.concat(response.data || response.result.data);
                                                $rootScope.loadMore = false;
                                            } else {
                                                $scope.collection = response.data || response.result.data;
                                            }
                                            if (!angular.isUndefined(response.result)) {
                                                var data = response.result;
                                            } else if (!angular.isUndefined(response.data)) {
                                                var data = response;
                                            }

                                            $scope.columns = response.ref;

                                            if (ServiceInject.setSubsec) {
                                                ServiceInject.setSubsec(response.reference_sections);
                                            }

                                            if ($attrs.groupby) {
                                                $scope.columnsGrouped = _.groupBy($scope.columns, function (m) {
                                                    return m[$attrs.groupby];
                                                });

                                                // console.log('$scope.columnsGrouped', $scope.columnsGrouped);
                                            }

                                            // if(!angular.isUndefined(response.result)){
                                            // 	$scope.totalItems = response.total 
                                            // }else if(!angular.isUndefined(response.result.total)){
                                            // 	$scope.totalItems = response.result.total;
                                            // }
                                            $scope.totalItems = data.total;


                                            $rootScope.pagination_totalItems = data.total;
                                            $scope.from = data.from;
                                            $rootScope.pagination_from = data.from || 0;
                                            $scope.to = data.to;
                                            $rootScope.pagination_to = data.to;
                                            $rootScope.pagination_current_page = data.current_page || 0;
                                            // $rootScope.pagination_page = response.current_page || response.result.current_page;
                                            $scope.last_page = data.last_page;
                                            $rootScope.pagination_total_pages = data.last_page;
                                            // $scope.currentPage = data.current_page;
                                            $scope.maxSize = 500;
                                            $scope.bigTotalItems = 175;
                                            $scope.isLoading = false;

                                            // $scope.numPages = Math.ceil($scope.numItems / ($rootScope.perPage || defaultPerPage));
                                            $scope.numPages = data.last_page;


                                            $scope.$emit('pagination:loadPage');
                                            $scope.preventFiltering = false;

                                            // allow the UI to catch up first
                                            // $timeout(function() {
                                            //     $scope.isLoading = false;
                                            //     $scope.isBusy = false;
                                            // });
                                            // $scope.bigCurrentPage = 1;
                                        })

                            } else {
                                // alert("no")
                                ServiceInject.get({
                                    page: request.newPage,
                                    owner: owner,
                                    section: section,
                                    // filter: searchStringFilter
                                    // lang: get("language")
                                }, function (data, status, headers, config) {

                                    // var response = parseRange(headers('Content-Range'));
                                    // if(status === 204 || (response && response.total === 0)) {
                                    //   $scope.numItems = 0;
                                    //   $scope.collection = [];
                                    // } else {
                                    //   $scope.numItems = response ? response.total : data.result.data.length;
                                    $scope.collection = data.data && data.result.data || [];

                                    $scope.isLoading = false;
                                    // }

                                    // if(response) {
                                    // $scope.rangeFrom = response.from;
                                    // $scope.rangeTo   = response.to;
                                    // if(length(response) < response.total) {
                                    //   if(
                                    //     ( request.to < response.total - 1) ||
                                    //     (response.to < response.total - 1 && response.total < request.to)
                                    //   ) {
                                    //     if(!$rootScope.perPage || length(response) < $rootScope.perPage) {
                                    //       if($scope.autoPresets) {
                                    //         var idx = quantizedIndex(length(response));
                                    //         if(quantizedNumber(idx) > length(response)) {
                                    //           idx--;
                                    //         }
                                    //         $scope.serverLimit = quantizedNumber(idx);
                                    //       } else {
                                    //         $scope.serverLimit = length(response);
                                    //       }
                                    //       $rootScope.perPage = $scope.Math.min(
                                    //         $scope.serverLimit,
                                    //         $scope.clientLimit
                                    //       );
                                    //     }
                                    //   }
                                    // }
                                    // }

                                }, function (e) {
                                    // alert("Database connection error")
                                    // deferred.reject();
                                });

                            }

                            // $http({
                            //   method: 'GET',
                            //   url: 'http://v3-api.qiusystem.dev/api/v1/admin/domains',
                            //   // params: $scope.urlParams,
                            //   params: {page:request.newPage},
                            //   headers: angular.extend(
                            //     {}, $scope.headers,
                            //     { 'Range-Unit': 'items', Range: [request.from, request.to].join('-') }
                            //   ),
                            //   transformResponse: appendTransform($http.defaults.transformResponse, $scope.transformResponse)
                            // }).success(function (data, status, headers, config) {
                            //   var response = parseRange(headers('Content-Range'));
                            //   if(status === 204 || (response && response.total === 0)) {
                            //     $scope.numItems = 0;
                            //     $scope.collection = [];
                            //   } else {
                            //     $scope.numItems = response ? response.total : data.result.data.length;
                            //     $scope.collection = data.result.data || [];
                            //   }

                            //   if(response) {
                            //     $scope.rangeFrom = response.from;
                            //     $scope.rangeTo   = response.to;
                            //     if(length(response) < response.total) {
                            //       if(
                            //         ( request.to < response.total - 1) ||
                            //         (response.to < response.total - 1 && response.total < request.to)
                            //       ) {
                            //         if(!$rootScope.perPage || length(response) < $rootScope.perPage) {
                            //           if($scope.autoPresets) {
                            //             var idx = quantizedIndex(length(response));
                            //             if(quantizedNumber(idx) > length(response)) {
                            //               idx--;
                            //             }
                            //             $scope.serverLimit = quantizedNumber(idx);
                            //           } else {
                            //             $scope.serverLimit = length(response);
                            //           }
                            //           $rootScope.perPage = $scope.Math.min(
                            //             $scope.serverLimit,
                            //             $scope.clientLimit
                            //           );
                            //         }
                            //       }
                            //     }
                            //   }
                            //   $scope.numPages = Math.ceil($scope.numItems / ($rootScope.perPage || defaultPerPage));
                            //   $scope.numPages = 10;

                            //   $scope.$emit('pagination:loadPage', status, config);
                            // }).error(function (data, status, headers, config) {
                            //   $scope.$emit('pagination:error', status, config);
                            // });
                            // $http({
                            //   method: 'GET',
                            //   url: $scope.url,
                            //   params: $scope.urlParams,
                            //   headers: angular.extend(
                            //     {}, $scope.headers,
                            //     { 'Range-Unit': 'items', Range: [request.from, request.to].join('-') }
                            //   ),
                            //   transformResponse: appendTransform($http.defaults.transformResponse, $scope.transformResponse)
                            // }).success(function (data, status, headers, config) {
                            //   var response = parseRange(headers('Content-Range'));
                            //   if(status === 204 || (response && response.total === 0)) {
                            //     $scope.numItems = 0;
                            //     $scope.collection = [];
                            //   } else {
                            //     $scope.numItems = response ? response.total : data.length;
                            //     $scope.collection = data || [];
                            //   }

                            //   if(response) {
                            //     $scope.rangeFrom = response.from;
                            //     $scope.rangeTo   = response.to;
                            //     if(length(response) < response.total) {
                            //       if(
                            //         ( request.to < response.total - 1) ||
                            //         (response.to < response.total - 1 && response.total < request.to)
                            //       ) {
                            //         if(!$rootScope.perPage || length(response) < $rootScope.perPage) {
                            //           if($scope.autoPresets) {
                            //             var idx = quantizedIndex(length(response));
                            //             if(quantizedNumber(idx) > length(response)) {
                            //               idx--;
                            //             }
                            //             $scope.serverLimit = quantizedNumber(idx);
                            //           } else {
                            //             $scope.serverLimit = length(response);
                            //           }
                            //           $rootScope.perPage = $scope.Math.min(
                            //             $scope.serverLimit,
                            //             $scope.clientLimit
                            //           );
                            //         }
                            //       }
                            //     }
                            //   }
                            //   $scope.numPages = Math.ceil($scope.numItems / ($rootScope.perPage || defaultPerPage));
                            //   $scope.numPages = 10;

                            //   $scope.$emit('pagination:loadPage', status, config);
                            // }).error(function (data, status, headers, config) {
                            //   $scope.$emit('pagination:error', status, config);
                            // });
                        }

                        $rootScope.pagination_page = $rootScope.pagination_page || 0;
                        $scope.size = $scope.size || 'md';
                        if ($scope.autoPresets) {
                            $scope.updatePresets();
                        }


                        // $rootScope.$watch($attrs.filters, function (newPage, oldPage) {

                        // 	alert("ok")
                        // });

                        $scope.watchers = [];

                        $scope.watchers.push($scope.$watch('fieldsFilters', function (newFilter, oldFilter) {

                            if (newFilter !== oldFilter && !angular.isUndefined(oldFilter)) {
                                $scope.preventFiltering = true;
                                $rootScope.pagination_page = 1;

                                _.each($scope.fieldsFilters, function (value, key, list) {
                                    if ($scope.fieldsFilters[key]['selected'].length > 0) {
                                        $rootScope.pagination_searchquery = true;
                                        $mdSidenav($scope.menuFiltersID)
                                            .toggle();
                                    }
                                });
                                updateLocation();
                                requestRange({
                                    from: $rootScope.pagination_page,
                                    resultsPerPage: $rootScope.perPage,
                                    filters: $scope.fieldsFilters
                                });
                            }
                            // vm.live.rowJson = angular.toJson(vm.live.row, true);
                        }, true));

                        $scope.watchers.push($rootScope.$watch('pagination_searchquery', function (newSearch, oldSearch) { }));
                        $scope.watchers.push($scope.$watch('fieldsSearch', function (newSearch, oldSearch) {



                            // if (newFilter !== oldFilter && !angular.isUndefined(oldFilter)) {
                            // 	$scope.preventFiltering = true;
                            // 	$rootScope.pagination_page = 1;
                            // 	updateLocation();
                            // 	requestRange({
                            // 		from: $rootScope.pagination_page,
                            // 		paginate: $rootScope.perPage,
                            // 		filters: $scope.fieldsFilters
                            // 	});
                            // }
                            // vm.live.rowJson = angular.toJson(vm.live.row, true);
                        }, true));

                        // $rootScope.$watch('sortDir', function (newSortDir, oldSort) {
                        // 	console.log(newSortDir)
                        // 	console.log(oldSort)

                        // 	if (newSortDir !== oldSort && !angular.isUndefined(oldSort)) {

                        // 		$scope.preventFiltering = true;
                        // 		$rootScope.pagination_page = 1;
                        // 		updateLocation();
                        // 		requestRange({
                        // 			from: $rootScope.pagination_page,
                        // 			resultsPerPage: $rootScope.perPage,
                        // 			filters: $scope.fieldsFilters,
                        // 			sortDir: newSortDir
                        // 		});
                        // 	}
                        // 	// vm.live.rowJson = angular.toJson(vm.live.row, true);
                        // }, true);

                        $scope.watchers.push($rootScope.$watch('pagination_page', function (newPage, oldPage) {
                            if ($scope.passive === 'true') {
                                return;
                            }
                            if (newPage !== oldPage && $scope.preventFiltering !== true) {
                                if (newPage < 0 || newPage * $rootScope.perPage >= $scope.numItems) {
                                    return;
                                }

                                var pp = $rootScope.perPage || defaultPerPage;

                                if ($scope.autoPresets) {
                                    pp = quantize(pp);
                                }
                                updateLocation();
                                requestRange({
                                    from: newPage * pp,
                                    to: (newPage + 1) * pp - 1,
                                    newPage: newPage,
                                    paginate: $rootScope.perPage,
                                    filters: $scope.fieldsFilters,
                                    sort: $rootScope.sortField,
                                    resultsPerPage: $rootScope.perPage
                                });
                            }
                        }));

                        $scope.watchers.push($rootScope.$watch('perPage', function (newPp, oldPp) {
                            if ($scope.passive === 'true') {
                                return;
                            }
                            if (typeof (oldPp) === 'number' && newPp !== oldPp) {
                                var first = $rootScope.pagination_page * oldPp;
                                var newPage = Math.floor(first / newPp);

                                // if($rootScope.pagination_page !== newPage) {
                                //   $rootScope.pagination_page = newPage;
                                // } else {
                                //   alert("nre")
                                requestRange({
                                    from: $rootScope.pagination_page * newPp,
                                    to: ($rootScope.pagination_page + 1) * newPp - 1,
                                    resultsPerPage: newPp,
                                    newPage: 1,
                                    filters: $scope.fieldsFilters,
                                    sort: $rootScope.sortField
                                });
                                // }
                            }
                        }));

                        $scope.watchers.push($scope.$watch('serverLimit', function (newLimit, oldLimit) {
                            if ($scope.passive === 'true') {
                                return;
                            }

                            if (newLimit !== oldLimit) {
                                $scope.updatePresets();
                            }
                        }));

                        $scope.watchers.push($scope.$watch('url', function (newUrl, oldUrl) {
                            if ($scope.passive === 'true') {
                                return;
                            }

                            if (newUrl !== oldUrl) {
                                if ($rootScope.pagination_page === 0) {
                                    $scope.reloadPage = true;
                                } else {
                                    $rootScope.pagination_page = 1;
                                }
                            }
                        }));

                        $scope.watchers.push($scope.$watch('urlParams', function (newParams, oldParams) {
                            if ($scope.passive === 'true') {
                                return;
                            }

                            if (!angular.equals(newParams, oldParams)) {
                                if ($rootScope.pagination_page === 0) {
                                    $scope.reloadPage = true;
                                } else {
                                    $rootScope.pagination_page = 1;
                                }
                            }
                        }, true));

                        $scope.watchers.push($scope.$watch('headers', function (newHeaders, oldHeaders) {
                            if ($scope.passive === 'true') {
                                return;
                            }

                            if (!angular.equals(newHeaders, oldHeaders)) {
                                if ($rootScope.pagination_page === 0) {
                                    $scope.reloadPage = true;
                                } else {
                                    $rootScope.pagination_page = 1;
                                }
                            }
                        }, true));

                        $scope.watchers.push($scope.$watch('reloadPage', function (newVal, oldVal) {
                            if ($scope.passive === 'true') {
                                return;
                            }

                            if (newVal === true && oldVal === false) {
                                $scope.reloadPage = false;

                                requestRange({
                                    from: $rootScope.pagination_page * $rootScope.perPage,
                                    to: ($rootScope.pagination_page + 1) * $rootScope.perPage - 1
                                });
                            }
                        }));


                        // $scope.$watch(
                        //                function watchFoo( scope ) {
                        //                    // Return the "result" of the watch expression.
                        //                    return( $scope.filterables );
                        //                },
                        //                function handleFooChange( newValue, oldValue ) {
                        //                }
                        //            , true);

                        $scope.watchers.push($scope.$watch('transformResponse', function (newTransform, oldTransform) {
                            if ($scope.passive === 'true') {
                                return;
                            }
                            if (!newTransform || !oldTransform) {
                                return;
                            }

                            // If applying a transform to returned data, it makes sense to start at the first page if changed
                            // Unfortunately it's not really possible to compare function equality
                            // In lieu of that, for now we'll compare string representations of them.
                            if (!angular.equals(newTransform.toString(), oldTransform.toString())) {
                                if ($rootScope.pagination_page === 0) {
                                    $scope.reloadPage = true;
                                } else {
                                    $rootScope.pagination_page = 1;
                                }
                            }
                        }, true));

                        var pp = $rootScope.perPage || defaultPerPage;

                        if ($scope.autoPresets) {
                            pp = quantize(pp);
                        }

                        $scope.$on('$destroy', function () {
                            for (var i = 0; i < $scope.watchers.length; ++i) {
                                if (typeof $scope.watchers[i] === 'function') {
                                    $scope.watchers[i]();
                                }
                            }
                        });

                        requestRange({
                            from: $rootScope.pagination_page * pp,
                            to: ($rootScope.pagination_page + 1) * pp - 1,
                            resultsPerPage: $rootScope.perPage,
                            newPage: $rootScope.pagination_page

                        });
                    }
                ]
            };
        })
        .

        filter('makeRange', function () {
            // http://stackoverflow.com/a/14932395/3102996
            return function (input) {
                var lowBound, highBound;
                switch (input.length) {
                    case 1:
                        lowBound = 0;
                        highBound = parseInt(input[0], 10) - 1;
                        break;
                    case 2:
                        lowBound = parseInt(input[0], 10);
                        highBound = parseInt(input[1], 10);
                        break;
                    default:
                        return input;
                }
                var result = [];
                for (var i = lowBound; i <= highBound; i++) {
                    result.push(i);
                }
                return result;
            };
        });


    function parseRange(hdr) {
        var m = hdr && hdr.match(/^(?:items )?(\d+)-(\d+)\/(\d+|\*)$/);
        if (m) {
            return {
                from: +m[1],
                to: +m[2],
                total: m[3] === '*' ? Infinity : +m[3]
            };
        } else if (hdr === '*/0') {
            return {
                total: 0
            };
        }
        return null;
    }

    function length(range) {
        return range.to - range.from + 1;
    }
}());

// angular.module('bgf.paginateAnything').run(['$templateCache', function($templateCache) {
//   'use strict';

//   $templateCache.put('src/paginate-anything.html',
//     "<div class=paginate-anything><ul class=\"pagination pagination-{{size}} links\" ng-if=\"numPages > 1\"><li ng-class=\"{disabled: page <= 0}\"><a href ng-click=gotoPage(page-1)>&laquo;</a></li><li ng-if=\"linkGroupFirst() > 0\"><a href ng-click=gotoPage(0)>1</a></li><li ng-if=\"linkGroupFirst() > 1\" class=disabled><a href>&hellip;</a></li><li ng-repeat=\"p in [linkGroupFirst(), linkGroupLast()] | makeRange\" ng-class=\"{active: p === page}\"><a href ng-click=gotoPage(p)>{{p+1}}</a></li><li ng-if=\"linkGroupLast() < numPages - 2\" class=disabled><a href>&hellip;</a></li><li ng-if=\"isFinite() && linkGroupLast() < numPages - 1\"><a href ng-click=gotoPage(numPages-1)>{{numPages}}</a></li><li ng-class=\"{disabled: page >= numPages - 1}\"><a href ng-click=gotoPage(page+1)>&raquo;</a></li></ul><div class=per-page ng-if=\"perPagePresets.length > 0 && numPages > 1\"><select ng-model=$parent.perPage ng-options=\"p for p in perPagePresets\"></select>per page</div></div>"
//   );

// }]);

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msStepper', msStepperDirective)
        .directive('msStepperStep', msStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            // Hide all steps
            for ( var i = 0; i < vm.steps.length; i++ )
            {
                vm.steps[i].element.hide();
            }

            // Show the current step
            vm.steps[vm.currentStepNumber - 1].element.show();
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure
            // we will land to a one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure
            // we will land to a one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msStepperDirective()
    {
        return {
            restrict        : 'A',
            require         : ['form', 'msStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?',
                hideStep    : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Chat',
                        'icon'       : 'icon-hangouts',
                        'state'      : 'app.chat',
                        'badge'      : {
                            'content': 13,
                            'color'  : '#09d261'
                        },
                        'weight'     : 5,
                        'children'   : [],
                        '_id'        : 'chat',
                        '_path'      : 'apps.chat',
                        'uisref'     : 'app.chat',
                        'hasShortcut': true
                    }, {
                        'title'      : 'Contacts',
                        'icon'       : 'icon-account-box',
                        'state'      : 'app.contacts',
                        'weight'     : 10,
                        'children'   : [],
                        '_id'        : 'contacts',
                        '_path'      : 'apps.contacts',
                        'uisref'     : 'app.contacts',
                        'hasShortcut': true
                    }, {
                        'title'      : 'Notes',
                        'icon'       : 'icon-lightbulb',
                        'state'      : 'app.notes',
                        'weight'     : 11,
                        'children'   : [],
                        '_id'        : 'notes',
                        '_path'      : 'apps.notes',
                        'uisref'     : 'app.notes',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.core')
        .directive('msSearchBar', msSearchBarDirective);
    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope: {
              modelSearch: '=',
             //bindAttr: '='
            },
            templateUrl: 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile    : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');
                return function postLink(scope, iElement)
                {
                    var expanderEl,
                        collapserEl,
                        enterButton;
                    // Initialize
                    init();
                    function init()
                    {
                        expanderEl = iElement.find('#ms-search-bar-expander');
                        collapserEl = iElement.find('#ms-search-bar-collapser');
                        enterButton = iElement.find('#ms-search-bar-button')[0];
                        expanderEl.on('click', expand);
                        collapserEl.on('click', collapse);
                    }
                    /**
                     * Expand
                     */
                    function expand()
                    {
                        iElement.addClass('expanded');
                        // Esc key event
                        $document.on('keyup', escKeyEvent);
                    }
                    /**
                     * Collapse
                     */
                    function collapse()
                    {
                        iElement.removeClass('expanded');
                    }
                    /**
                     * Search
                     */
                    function search()
                    {
                        enterButton.click(); 
                    }
                    /**
                     * Escape key event
                     *
                     * @param e
                     */
                    function escKeyEvent(e)
                    {
                        if ( e.keyCode === 27 )
                        {
                            collapse();
                            $document.off('keyup', escKeyEvent);
                        }
                        if ( e.keyCode === 13 )
                        {
                           search();
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider() {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item) {
            if (!angular.isString(path)) {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for (var i = 0; i < parent.length; i++) {
                if (parent[i]._id === id) {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if (updateItem) {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if (angular.isUndefined(item.weight) || !angular.isNumber(item.weight)) {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path) {
            if (!angular.isString(path)) {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for (var p = 0; p < parts.length; p++) {
                var id = parts[p];

                for (var i = 0; i < item.length; i++) {
                    if (item[i]._id === id) {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if (item[i]._path === path) {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent) {
            // If parent not provided, sort the root items
            if (!parent) {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for (var i = 0; i < parent.length; i++) {
                var children = parent[i].children;

                if (children.length > 1) {
                    children.sort(_byWeight);
                }

                if (children.length > 0) {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts) {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if (parts.length === 1) {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for (var i = 0; i < parts.length; i++) {
                var _id = parts[i],
                    createParent = true;

                for (var p = 0; p < parent.length; p++) {
                    if (parent[p]._id === _id) {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if (createParent) {
                    var item = {
                        _id: _id,
                        _path: parts.join('.'),
                        title: _id,
                        weight: 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y) {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item) {
            var uisref = '';

            if (angular.isDefined(item.state)) {
                uisref = item.state;

                if (angular.isDefined(item.stateParams) && angular.isObject(item.stateParams)) {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function () {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null,
                _flatNavigation = [];

            var service = {
                saveItem: saveItem,
                deleteItem: deleteItem,
                sort: sortByWeight,
                clearNavigation: clearNavigation,
                setActiveItem: setActiveItem,
                getActiveItem: getActiveItem,
                getNavigation: getNavigation,
                getFlatNavigation: getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded: setFolded,
                getFolded: getFolded,
                setFoldedOpen: setFoldedOpen,
                getFoldedOpen: getFoldedOpen,
                toggleFolded: toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation() {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if (navigationScope) {
                    navigationScope.vm.navigation = [];
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope) {
                activeItem = {
                    node: node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem() {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root) {
                if (root) {
                    for (var i = 0; i < navigation.length; i++) {
                        if (navigation[i]._id === root) {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root) {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope) {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status) {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded() {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status) {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen() {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded() {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation) {
                var flatNav = [];

                for (var x = 0; x < navigation.length; x++) {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if (navigation[x].children.length > 0) {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService, sessionService) {
        var vm = this;



        // Data
        if ($scope.root) {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService) {
        return {
            restrict: 'E',
            scope: {
                folded: '=',
                root: '@'
            },
            controller: 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude: true,
            compile: function (tElement) {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement) {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init() {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if (msNavigationService.getFolded() === null) {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if (msNavigationService.getFolded()) {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function () {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function () {
                        return sidenav.isLockedOpen();
                    }, function (current, old) {
                        if (angular.isUndefined(current) || angular.equals(current, old)) {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if (folded) {
                            if (current) {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if (activeItem) {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old) {
                        if (angular.isUndefined(current) || angular.equals(current, old)) {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded) {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if (folded) {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if (activeItem) {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander() {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function () {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser() {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser() {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event) {
                        if (event) {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if (activeItem) {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event) {
                        if (event) {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function () {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function () {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function () {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msUtils, msNavigationService, sessionService) {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;
        vm.branding = msUtils.getBranding();

        vm.getBrandingColorBack = function (node) {
            if (node.state.startsWith($state.current.name + '({owner:')) {
                return vm.branding.accentColor ? vm.branding.accentColor : 'inherit';
            } else {
                return 'inherit';
            }
        }
        vm.getBrandingBackgroundColor = function (node) {
            if (node.state.startsWith($state.current.name + '({owner:')) {
                return vm.branding.BackgroundColor ? vm.branding.BackgroundColor : 'inherit';
            } else {
                return 'inherit';
            }
        }
        vm.getBrandingColorFont = function (node) {
            if (node.state.startsWith($state.current.name + '({owner:')) {
                return vm.branding.accentColorFont ? vm.branding.accentColorFont : '#fff';
            } else {
                return '#868aa8';
            }
        }

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if (!vm.hasChildren || vm.group) {
                vm.collapsable = false;
            }
            else {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if (!vm.collapsable) {
                vm.collapsed = false;
            }
            else {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function () {
                // Expand if the current scope is collapsable and is collapsed
                if (vm.collapsable && vm.collapsed) {
                    $scope.$evalAsync(function () {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path) {
                if (vm.collapsed || !vm.collapsable) {
                    return;
                }

                // If there is no path defined, collapse
                if (angular.isUndefined(path)) {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if (activeItem) {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if (givenPathParts.indexOf(vm.node._id) > -1) {
                        return;
                    }

                    // Test for active path
                    if (activePathParts.indexOf(vm.node._id) > -1) {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function () {
                if (vm.node.state === $state.current.name) {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ($state.includes(vm.node.state)) {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed() {
            if (vm.collapsed) {
                vm.expand();
            }
            else {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse() {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function () {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height': height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function () {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height': ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand() {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position': 'absolute',
                'visibility': 'hidden',
                'display': 'block',
                'height': 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position': '',
                'visibility': '',
                'display': '',
                'height': ''
            });

            $scope.$evalAsync(function () {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height': '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function () {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass() {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden() {
            if (angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden)) {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective() {
        return {
            restrict: 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller: 'MsNavigationNodeController as vm',
            compile: function (tElement) {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if (MsNavigationNodeCtrl.group) {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective() {
        return {
            restrict: 'A',
            require: '^msNavigationNode',
            compile: function (tElement) {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
                    // If the item is collapsable...
                    if (MsNavigationNodeCtrl.collapsable) {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function () {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService) {
        return {
            restrict: 'E',
            scope: {
                root: '@'
            },
            controller: 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude: true,
            compile: function (tElement) {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope) {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService) {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function () {
                // Mark as active if has children
                if (vm.hasChildren) {
                    $scope.$evalAsync(function () {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function () {
                if (!vm.hasChildren) {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if (activeItem) {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if (activePathParts.indexOf(vm.node._id) > -1) {
                    $scope.$evalAsync(function () {
                        vm.isActive = true;
                    });
                }
                else {
                    $scope.$evalAsync(function () {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function () {
                if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass() {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective() {
        return {
            restrict: 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller: 'MsNavigationHorizontalNodeController as vm',
            compile: function (tElement) {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if (MsNavigationHorizontalNodeCtrl.group) {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia) {
        return {
            restrict: 'A',
            require: '^msNavigationHorizontalNode',
            compile: function (tElement) {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
                    iElement.on('click', onClick);

                    function onClick() {
                        if (!MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md')) {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function () {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {

                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    var refTop = Math.min.apply(Math, referenceArr);

                    var column = referenceArr.indexOf(refTop);

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});

                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }

                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {

            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {

            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {

            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }

    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });

            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        }

    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function () {
	'use strict';

	angular
		.module('app.core')
		.directive('videoonload', videoonload);

	/** @ngInject */
	function videoonload($timeout, $q, $interpolate, $compile) {

		return {
			restrict: 'A',
			link: function (scope, element, attrs) {

				var wrapper = angular.element('<md-progress-circular md-mode="indeterminate" md-diameter="20"></md-progress-circular>');

				element[0].addEventListener("error", function () {
					wrapper.remove();

					if(!attrs.errSrc){
						element.attr('src', 'assets/images/common/no_image_available_10.png');
					}else{
						element.attr('src', attrs.errSrc);
					}

			     });


				element[0].addEventListener("load", function () {

				    $compile(wrapper)(scope);
				    element.before(wrapper);

				});

				// scope.$watch('ngSrc', function () {
				// 	element.addClass('hide spinner-hide');
				//     $compile(wrapper)(scope);
				//     element.before(wrapper);
				   
				// }, function (value) {
				// 	if (!value) {
				// 		element.attr('src', attrs.errSrc);
				// 	}
				// });

				// element.bind('error', function () {
				// 	if(!attrs.errSrc){
				// 		element.attr('src', 'assets/images/common/no_image_available_10.png');
				// 	}else{
				// 		element.attr('src', attrs.errSrc);
				// 	}
					
				// });
			}
		};
	}
})();
(function () {
	'use strict';

	angular
		.module('app.core')
		.provider('msMediaService', msMediaServiceProvider)
		.directive('media', MediaItemDirective)
		.controller('MediaItemController', MediaItemController);

	/** @ngInject */
	function msMediaServiceProvider() {
		// Inject $log service
		var $log = angular.injector(['ng'])
			.get('$log');

		// Navigation array

		var service = this;

		// Methods


		//////////

		/* ----------------- */
		/* Private Functions */
		/* ----------------- */



		/* ----------------- */
		/* Service           */
		/* ----------------- */

		this.$get = function () {
			var activeItem = null,
				navigationScope = null,
				thumbnailScope = null,
				thumbsScope = null,
				viewImage = null;

			var service = {
				setAttachmentScope: setAttachmentScope,
				setThumbnailScope: setThumbnailScope,
				getNavigationScope: getNavigationScope,
				setThumbsScope: setThumbsScope,
				getThumbsScope: getThumbsScope,
				setOpenImageMethod: setOpenImageMethod,
				callOpenImageMethod: callOpenImageMethod,
			};

			return service;

			//////////


			/**
			 * Store navigation's scope for later use
			 *
			 * @param scope
			 */
			function setAttachmentScope(scope) {
				navigationScope = scope;
			}

			/**
			 * Store thumbnail's scope for later use
			 *
			 * @param scope
			 */
			function setThumbnailScope(scope) {
				thumbnailScope = scope;
			}

			/**
			 * Store navigation's scope for later use
			 *
			 * @param scope
			 */
			function setThumbsScope(scope) {
				thumbsScope = scope;
			}

			/**
			 * Store navigation's scope for later use
			 *
			 * @param scope
			 */
			function getThumbsScope() {
				return thumbsScope;
			}

			/**
			 * Store navigation's scope for later use
			 *
			 * @param scope
			 */
			function getNavigationScope() {
				return navigationScope;
			}


			/**
			 * Toggle fold on stored navigation's scope
			 */
			function setOpenImageMethod(fn) {
				// alert("ok")
				viewImage = fn;
			}

			/**
			 * Toggle fold on stored navigation's scope
			 */
			function callOpenImageMethod(event, thumbs, attachment) {
				viewImage(event, thumbs, attachment)
			}


		};
	}

	/** @ngInject */
	function MediaItemDirective(msMediaService, $compile, sessionService, CommonMediaService, $log, $timeout) {
		return {
			restrict: 'E',
			transclude: true,
			replace: true,
			scope: {
				thumbsGallery: '=',
				attachment: '=',
				thumbnail: '@',
				cropFormat: '@',
				openImage: '&',
				forceClass: '@',
				useDefault: '@',
				// vm          : '=viewModel'
			},
			// transclude : true,
			templateUrl: 'app/core/directives/media/item-media.html',
			controller: 'MediaItemController as vm',
			link: function (scope, element, attrs) {



				/**
				 * Initialize / Watch model changes
				 */
				scope.$watch('attachment', setItemMedia);


				/**
				 * Set ItemMedia by model type
				 */
				function setItemMedia() {
					scope.image = false;
					scope.video = false;
					scope.audio = false;
					scope.file = false;
					scope.thumbnail = false;
					scope.urlvideo = false;
					scope.urlvideoEmbed = false;
					scope.isYoutube = false;
					scope.videoID = false;

					var embed = attrs.embed ? attrs.embed : false;

					scope.class = attrs.classImg || '';
					scope.forceClass = 'forceClass' in attrs;
					scope.useDefault = 'useDefault' in attrs;
          
        
					if (angular.isArray(scope.attachment)) {} else if (angular.isObject(scope.attachment)) {

						scope.thumbnail = !angular.isUndefined(attrs.thumbnail) ? attrs.thumbnail : false;
						switch (parseInt(scope.attachment.media_type)) {
							//
							// Image
							//
						case 1:

							var cropFormatId = attrs.cropFormat || sessionService.getMediaThumbnailCropformatId();
							scope.class += ' image';
							if (angular.isObject(scope.attachment) && angular.isObject(scope.attachment.cropstatus) && scope.attachment.cropstatus.length > 0) {
								var cropstatus = _.find(scope.attachment.cropstatus, function (c) {
									if (c.id_cropformats == cropFormatId) {
										return true;
									}
								});
								if (!angular.isUndefined(cropstatus)) {
									if (cropstatus.fileName.includes(".gif")) {
										var containerOriginal = sessionService.getContainerByID(scope.attachment.cdnContainer);

										scope.url = containerOriginal.view_url + 'original/m' + scope.attachment.id_media + '_' + scope.attachment.filename;

									} else {


										var container = sessionService.getContainerByID(cropstatus.id_container);
										// $timeout(function(){
										// scope.$apply(function(){
										scope.url = container.view_url + cropstatus.fileName;
										// });
										// });
									}
								} else {
									scope.url = '';
								}
							} else if (scope.attachment.id_media) {
								var options = {
									id_media: [scope.attachment.id_media],
									// id_cropformat: 1002,
									// id_container: 2
								};

								CommonMediaService.getUrl(options)
									.then(function (response) {
										if (response.length > 0) {
											var cropstatus = _.find(response, {
												'id_cropformats': cropFormatId
											});
											scope.url = cropstatus.url;
										} else {
											// Original showed
											var containerOriginal = sessionService.getContainerByID(scope.attachment.cdnContainer);
											if (!angular.isUndefined(containerOriginal)) {
												scope.url = containerOriginal.view_url + 'original/m' + scope.attachment.id_media + '_' + scope.attachment.filename;
											}
										}
									});
							}

							scope.image = true;
							break;

							//
							// Video
							//
						case 2:
							if (scope.attachment.thumb) {
								var cropFormatId = attrs.cropFormat || sessionService.getMediaThumbnailCropformatId();
								var options = {
									id_media: [scope.attachment.thumb],
									// id_cropformat: 1002,
									// id_container: 2
								};
								CommonMediaService.getUrl(options)
									.then(function (response) {
										if (response.length > 0) {
											var cropstatus = _.find(response, function (c) {
												if (c.id_cropformats == cropFormatId) {
													return true;
												}
											});
											scope.url = cropstatus.url;
										}
									})
							}

							if (scope.attachment.embed != null) {
								var videoTypeSplit = scope.attachment.embed.split("|");
								var videoType = videoTypeSplit[0];
								var videoID = videoTypeSplit[1];

								if (videoType === 'yt') {
									scope.isYoutube = true;
									scope.videoID = videoID;
									if (embed) {
										scope.urlvideoEmbed = 'https://www.youtube.com/embed/' + videoID;
										element.removeClass('image');
										element.addClass('videoEmbed');

									} else {
										if (scope.attachment.embed_thumb) {
											scope.url = scope.attachment.embed_thumb;
											scope.video = true;
										}
									}
								} else if (videoType === 'vimeo') {

								} else {

									if (scope.attachment.embed_thumb) {
										scope.url = scope.attachment.embed_thumb;
										scope.video = true;
									}
								}
							} else if (!scope.attachment.embed && !scope.attachment.embed_code && !scope.attachment.embed_thumb && !scope.attachment.embed_url) {
								scope.urlvideo = scope.attachment.container.view_url + 'videos/m' + scope.attachment.id_media + '_' + scope.attachment.filename;
							}


							break;

							//
							// Audio
							//
						case 3:
							//
							scope.audio = true;
							break;

							// File
						case 4:
							//
							scope.url = scope.attachment.filename;
							scope.file = true;
							break;
						default:

						}

					} else {

						if (scope.useDefault) {
							scope.url = 'assets/images/common/no_image_available_10.png';
							scope.image = true;
						}

						console.warn("FAIL")
					}
				  // $compile(element)(scope);
        }

			}

		};
	}

	/** @ngInject */
	function MediaItemController($scope, msMediaService, $mdDialog, $document, CommonMediaService) {
		var vm = this;

		var attachment = msMediaService.getNavigationScope();

		vm.attachmentMedia = attachment;

		// Methods
		vm.openImageDialog = openImageDialog;

		//////////

		init();

		/**
		 * Initialize
		 */
		function init() {

		}

		/**
		 * Open Image dialog
		 *
		 * @param ev
		 * @param task
		 */
		function openImageDialog(ev, ImageSelected) {
			$mdDialog.show({
				controller: 'ImageDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/clients/dialogs/image/image-dialog.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: true,
				locals: {
					Images: msMediaService.getThumbsScope(),
					ImageSelected: ImageSelected,
					cropFormats: false,
					MediaFull: false,
					// Tasks: vm.tasks,
					// event: ev
				}
			});
		}
	}

})();
(function () {
	'use strict';

	angular
		.module('app.core')
		.directive('imageonload', imageonload);

	/** @ngInject */
	function imageonload($timeout, $q, $interpolate, $compile) {

		return {
			restrict: 'A',
			link: function (scope, element, attrs) {

				var wrapper = angular.element('<md-progress-circular md-mode="indeterminate" md-diameter="20"></md-progress-circular>');

				element.on('load', function () {
					element.removeClass('spinner-hide');
					element.addClass('show spinner-show');

					wrapper.remove();
				});

				scope.$watch('ngSrc', function () {
					element.addClass('hide spinner-hide');
				    $compile(wrapper)(scope);
				    element.before(wrapper);
				   
				}, function (value) {
					if (!value) {
						element.attr('src', attrs.errSrc);
					}
				});

				element.bind('error', function () {
					if(!attrs.errSrc){
						element.attr('src', 'assets/images/common/no_image_available_10.png');
					}else{
						element.attr('src', attrs.errSrc);
					}
					
				});
			}
		};
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('focusPoint', focusPointDirective);

    /** @ngInject */
    function focusPointDirective($timeout, $q, $interpolate)
    {
      return {
          restrict: 'A',
          replace: true,
          scope: {
              model: '=ngModel',
              fromDirectiveFn: '=method'
          },
          template: '<div class="focus-point">' +
          '<div class="focus-area">' +
          '<span class="target" style="left: {{ x }}%; top: {{ y }}%"></span>' +
          '<img src="{{ src }}" alt="" ng-mousemove="onMouseMove($event)" ng-mousedown="onMouseDown($event)" ng-mouseup="onMouseUp($event)" draggable="false" class="source" />' +
          '</div>' +
          // '<span style="background-image: url(\'{{ src }}\'); background-position: {{ x }}% {{ y }}%" class="preview-portrait"></span>' +
          // '<span style="background-image: url(\'{{ src }}\'); background-position: {{ x }}% {{ y }}%" class="preview"></span>' +
          // '<span style="background-image: url(\'{{ src }}\'); background-position: {{ x }}% {{ y }}%" class="preview-landscape"></span>' +
          // '<span style="background-image: url(\'{{ src }}\'); background-position: {{ x }}% {{ y }}%" class="preview-wide"></span>' +
          '<div class="info">X: {{ x }}% | Y: {{ y }}%</div>' +
          '</div>',
          link: function (scope, element, attr) {
              var dragging = false;
              scope.src = attr.src;

              scope.x = parseFloat(attr.x * 100).toFixed(0);
              scope.y = parseFloat(attr.y * 100).toFixed(0);

              scope.onMouseDown = function (e) {
                  scope.update(e);
                  dragging = true;
              };

              scope.onMouseMove = function (e) {
                  if (dragging === true) {
                      scope.update(e);
                  }
              };

              scope.onMouseUp = function (e) {
                  e.preventDefault();
                  dragging = false;
              };

              scope.update = function (e) {
                  e.preventDefault();
                  var offset = scope.offset(e.target);
                  scope.x = Math.round(((e.pageX - offset.left) / e.target.clientWidth) * 100);
                  scope.y = Math.round(((e.pageY - offset.top) / e.target.clientHeight) * 100);
                  scope.updateMediaFn(scope.x / 100, scope.y / 100);

              };

              scope.updateMediaFn = function () {
                scope.fromDirectiveFn(scope.x / 100, scope.y / 100);
              };

              scope.offset = function (elm) {
                  try { return elm.offset(); } catch (e) { }
                  var body = document.documentElement || document.body;
                  return {
                      left: elm.getBoundingClientRect().left + (window.pageXOffset || body.scrollLeft),
                      top: elm.getBoundingClientRect().top + (window.pageYOffset || body.scrollTop)
                  };
              };
          }
      };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('userAvatar', UserAvatarDirective)
        .factory("avatarService", avatarService);

    /** @ngInject */
    function UserAvatarDirective($timeout, $q, $interpolate, avatarService, sessionService) {

        var controller = function ($scope) {
            $scope.ImageAvailable = false;
            if (angular.isDefined($scope.User)) {
                $scope.GenericAvatar = avatarService.getAvatar($scope.User);
            } else {
                $scope.ImageAvailable = true;
            }

            $scope.getAvatar = function () {
                if (angular.isDefined($scope.User)) {
                    return avatarService.getAvatar($scope.User).Avatar;
                }
            }

        };
        return {
            restrict: 'E',
            replace: 'true',
            scope: {
                User: '=user'
            },
            // template: '<div class="avatar generic-avatar">' +
            // 	'<a class="thumb spacer animated fadeIn color" style="background-color:{{GenericAvatar.Background}}"></a>' +
            // 	'<a class="name">{{GenericAvatar.Initials}}</a>' +
            // 	'<a class="img" data-ng-if="ImageAvailable" style="background-image:url({{User.Avatar}})"></a>' +
            // 	'</div>',
            template: '<div ng-bind-html="getAvatar()"></div>',
            controller: controller
        };
    }

    /** @ngInject */
    function avatarService(sessionService) {

        var service = {
            getAvatar: getAvatar
        };

        return service;

		/**
		 * Get the random colors 
		 * @returns {String}
		 */
        function getRandomColors() {
            var letters = '0123456789ABCDEF'.split('');
            var _color = '#';
            for (var i = 0; i < 6; i++) {
                _color += letters[Math.floor(Math.random() * 16)];
            }
            return _color;
        }
		/**
		 * Get Avatar
		 * @param  scope user
		 * @return array
		 */
        function getAvatar(user) {

            var Ret = ({
                "Initials": '',
                "Background": '',
                "Avatar": ''
            })
            if (!angular.isUndefined(user.files) && user.files && !angular.isUndefined(user.files.url)) {
                var userAvatar = sessionService.config.storagePrefix + user.files.url;
                Ret.Avatar = '<img class="avatar" src="' + userAvatar + '" >';
            } else {
                var colorCodes = {
                    1: "#F29691",
                    2: "#92D6C2",
                    3: "#6C6229",
                    4: "#FACA82",
                    5: "#D7ADE0",
                    6: "#BF994E",
                    7: "#5F9AE0",
                    8: "#DE6DA8"
                };
                var colours = ["#1abc9c", "#34495e", "#16a085", "#27ae60", "#2ecc71", "#3498db", "#9b59b6", "#2980b9", "#8e44ad", "#2c3e50", "#f1c40f", "#e67e22", "#e74c3c", "#95a5a6", "#f39c12", "#d35400", "#c0392b", "#bdc3c7", "#7f8c8d"];

                var i1 = "",
                    i2 = "",
                    nameArray = [];
                if (angular.isDefined(user.first_name)) {
                    i1 = angular.uppercase(user.first_name.charAt(0));
                    var FullName = user.first_name + ' ' + user.last_name;
                    nameArray = user.first_name.split(" ");
                    nameArray = FullName.split(" ");
                    if (nameArray.length > 2) {
                        i2 = angular.uppercase(nameArray[nameArray.length - 1].charAt(0));
                    }
                    else {
                        i2 = angular.uppercase(nameArray[1].charAt(0));
                    }
                }
                else {
                    if (user.first_name) {
                        i1 = angular.uppercase(user.first_name.charAt(0));
                    }
                    else {
                        i1 = angular.uppercase(user.email.charAt(0));
                    }
                    if (user.last_name) {
                        nameArray = user.last_name.split(" ");

                        if (nameArray.length > 2) {
                            i2 = nameArray[nameArray.length - 1].charAt(0);
                        }
                        else {
                            i2 = angular.uppercase(nameArray[0].charAt(0));
                        }
                    }
                }
                // var initials = i1 + i2;
                var initials = i1;
                var charCode = initials.charCodeAt(0) + initials.charCodeAt(1);

                charCode = charCode >= 130 && charCode <= 144 ? 1 :
                    charCode >= 145 && charCode <= 147 ? 2 :
                        charCode >= 148 && charCode <= 149 ? 3 :
                            charCode >= 150 && charCode <= 151 ? 4 :
                                charCode >= 152 && charCode <= 157 ? 5 :
                                    charCode > 158 && charCode <= 172 ? 6 :
                                        charCode >= 173 && charCode <= 186 ? 7 : 8;
                var background = colorCodes[charCode];
                // var background = user.profile_color;
                var charIndex = initials.charCodeAt(0) - 65,
                    colourIndex = charIndex % colours.length;
                var background = colours[colourIndex];
                var avatar = '<div class="avatar generic-avatar" style="background-color:' + background + '"><span>' + initials + '</span></div>';

                Ret = ({
                    "Initials": initials,
                    "Background": background,
                    "Avatar": avatar
                });
            }

            return Ret;
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .directive('mdTreeviewBox', mdTreeviewBox);

    function mdTreeviewBox(ivhTreeviewMgr) {
        return {
            restrict: 'AE',
            template: [
                '<span class="ascii-box">',
                '<span ng-show="node.selected" class="x"><md-checkbox style="min-height: 100%; line-height: 0" aria-label="checked" ng-checked="true"></md-checkbox></span>',
                '<span ng-show="node.__ivhTreeviewIndeterminate" class="y"><md-checkbox style="min-height: 100%; line-height: 0" aria-label="checked" ng-checked="false"></md-checkbox></span>',
                '<span ng-hide="node.selected || node.__ivhTreeviewIndeterminate"><md-checkbox style="min-height: 100%; line-height: 0" aria-label="checked" ng-checked="false"></md-checkbox></span>',
                '</span>',
            ].join(''),
            link: function(scope, element, attrs) {
                element.on('click', function() {
                    scope.trvw.toggleSelected(scope.node); 
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('controlView', controlView);


    /** @ngInject */
    function controlView() {
        var controller = function ($scope, $stateParams, msUtils, evidencesControlsService, riskService, $translate, $filter, mediaService) {

            let vm = this;
            vm.controlTabsIndex = 0;
            vm.loadingEvidences = false;
            vm.$onInit = function () {
                getEvidences();
                getTasks()
                setUsersForControl()
                evidencesControlsService.getCurrencies({ owner: $stateParams.owner }).then(function (res) {
                    vm.currencies = res.data;
                })
            }

            function getEvidences() {
                vm.currentEvidences = undefined;
                riskService.getEvidences({
                    activeControlId: vm.control.active_control_id,
                    owner: $stateParams.owner,
                    withMessages: true,
                    withUser: true,
                    withFiles: true,
                    sortField: 'updated_at',
                    sortDir: 'DESC'
                })
                    .then(function (res) {
                        if (res.total > 0) {
                            vm.currentEvidences = res.data;
                        }
                        vm.loadingEvidences = false;
                    })


            }

            function getTasks() {
                vm.loadingTasks = true;
                vm.currentTasks = undefined;
                riskService.getTasks({
                    activeControlId: vm.control.active_control_id,
                    owner: $stateParams.owner,
                    withMessages: true,
                    withUser: true,
                    withFiles: true,
                    sortField: 'updated_at',
                    sortDir: 'DESC'
                })
                    .then(function (res) {
                        if (res.total > 0) {
                            vm.currentTasks = $filter('orderBy')(res.data, 'is_complete', false);

                        }
                        vm.loadingTasks = false;
                    })
            }

            function setUsersForControl() {
                vm.controlUsers = {
                    IN_CHARGE: [],
                    PARTICIPANT: []
                };
                angular.forEach(vm.risk.users, function (user) {
                    if (user.active_control_id == vm.control.active_control_id) {
                        if (user.active_control_user_type_id == 1) {
                            vm.controlUsers.IN_CHARGE.push(user.user);
                        } else if (user.active_control_user_type_id == 2) {
                            vm.controlUsers.PARTICIPANT.push(user.user);
                        }
                    }
                })
            }


            mediaService.getStoragePrefix({
                owner: $stateParams.owner,
            }).then(function (res) {
                $scope.storagePrefix = res.prefix;
            })

            vm.translate = function (text) {
                return $translate.instant(text);
            }

            function getSymbolCurrency(id) {
                var found = _.find(vm.currencies, function (c) { if (c.id == id) { return true; } });
                return found ? found.symbol : null;
            }


            vm.showUserImage = function showUserImage(user) {
                if ($scope.storagePrefix) {
                    return $scope.storagePrefix + user.files.url
                }
                return null;
            }
            vm.getSymbolCurrency = getSymbolCurrency;
            vm.evidenceScoreText = msUtils.evidenceScoreText;
            vm.evidenceScoreColor = msUtils.evidenceScoreColor;
            vm.timeAgo = msUtils.timeAgo;

        };
        return {
            bindToController: true,
            restrict: 'E',
            scope: {
                control: '=',
                risk: '='
            },
            link: function (scope, elem) { },
            templateUrl: 'app/core/components/control-view/control-view.component.html',
            controller: controller,
            controllerAs: 'vm'
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('tasksUser', tasksUser);


    /** @ngInject */
    function tasksUser() {
        var controller = function ($scope, $rootScope, staffService, $timeout, companyService, $stateParams) {

            let vm = this;
            vm.$onInit = function () {
                loadData();
            }

            var companySelectEvent = $rootScope.$on('company-selected', function (event) {
                $timeout(() => {
                    loadData();
                }, 100);
            });
            $scope.$on('$destroy', companySelectEvent);

            function loadData() {
                vm.loadTasksUser = true;
                var options = {
                    id: vm.idUser,
                    company_id: companyService.getCompanyId(),
                    branch_id: 1,
                    owner: $stateParams.owner
                };
                staffService.getTasksUser(options).then(function (resp) {
                    vm.tasksUser = resp.data;
                    console.log(vm.tasksUser)
                    vm.loadTasksUser = false;
                })
            }

            vm.openControl = function (control, task) {
                vm.currentControl = control;
                vm.currentTask = task;
            }



        };
        return {
            bindToController: true,
            restrict: 'E',
            scope: {
                idUser: '='
            },
            link: function (scope, elem) { },
            templateUrl: 'app/core/components/tasks-user/tasks-user.component.html',
            controller: controller,
            controllerAs: 'vm'
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .service('taskViewSectionservice', TaskViewSectionservice);
    function TaskViewSectionservice($q, $resource, COMMON, sessionService) {

        function getTasks(options) {
            var deferred = $q.defer();
            var filters = [];
            var userLogued = sessionService.getUser();
            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });
            var opt = {
                owner: options.owner,
                related_type: options.related_type,
                related_id: options.id,
                withMessages: options.withMessages,
                mine: userLogued.user_type == 4,
                withUser: options.withUser,
                resultsPerPage: 500,
                withFiles: options.withFiles,
                sortField: options.sortField,
                sortDir: options.sortDir
            }
            if (!opt.mine) {
                delete opt.mine;
            }
            resourceTasks.get(opt,
                function (responseResult) {
                    deferred.resolve(responseResult);
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        var resourceTasks = $resource(COMMON.BASE_API + "/owner/:owner/task", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            },
            post: {
                method: "POST",
                isArray: false
            },
            put: {
                method: "PUT",
                isArray: false
            },
        });


        return ({
            getTasks: getTasks
        });

    }

})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('tasksSectionView', tasksSectionView);


    /** @ngInject */
    function tasksSectionView() {
        var controller = function ($scope, mediaService, $document, $filter, tasksService, $mdDialog, riskService, taskViewSectionservice, taskDetailsUtil, $stateParams) {

            var vm = this;
            vm.openTask = openTask;
            vm.updateTasks = updateTasks;
            vm.saveTask = saveTask;
            vm.showUserImage = showUserImage;
            vm.changeTaskStatusDialog = changeTaskStatusDialog;
            vm.loadingTasks = false;
            vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];


            mediaService.getStoragePrefix({
                owner: $stateParams.owner,
            }).then(function (res) {
                $scope.storagePrefix = res.prefix;
            })

            vm.$onInit = function () {
                vm.updateTasks();
            }
            $scope.$watch('vm.availableusers', function (newVal, oldVal) {
                if (newVal != oldVal) {
                    vm.updateTasks();
                }
            });
            $scope.$watch('vm.currentcontrolusers', function (newVal, oldVal) {
                if (newVal != oldVal) {
                    vm.updateTasks();
                }
            });
            $scope.$watch('vm.currentcontrol', function (newVal, oldVal) {
                if (newVal != oldVal) {
                    vm.updateTasks();
                }
            });
            function showUserImage(user) {
                return $scope.storagePrefix + user.files.url
            }
            function openTask(task, $event) {
                if (!task) {
                    if (vm.relatedtype == 'active_controls') {
                        vm.idrelated = vm.currentcontrol && vm.currentcontrol.active_control_id;
                    }
                    task = taskDetailsUtil.createNewTask(vm.relatedtype, vm.idrelated);
                    openDialogTask(task, $event)
                } else {
                    tasksService.getTask({
                        id: task.id,
                        owner: $stateParams.owner
                    })
                        .then(function (resp) {
                            openDialogTask(resp, $event)
                        })
                }


            }

            function changeTaskStatusDialog(e, task) {
                $mdDialog.show({
                    controller: 'TaskEditStatusController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/tasks/dialogs/task-edit-status-dialog/task-edit-status-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        task: task
                    }
                }).then(function (resp) {
                    if (resp){
                        const toSave = taskDetailsUtil.prepareToSave({ task: resp });
                        taskDetailsUtil.updateTaskStatus($stateParams.owner, toSave.task).then(function (res) {
                            updateTasks();
                        }, function (err) {
                            updateTasks();
                        })
                    }

                });
            }


            function openDialogTask(task, ev) {
                $mdDialog.show({
                    controller: 'TaskDetailsDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/dialogs/taskDetails/taskDetails.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    multiple: true,
                    locals: {
                        task: angular.copy(task),
                        availableusers: vm.availableusers,
                        currentUsers: vm.currentcontrolusers && vm.currentcontrolusers['IN_CHARGE'],
                        storagePrefix: $scope.storagePrefix,
                        showRecurrence: (task.recurrent_interval || task.recurrent_type) ? true : false,
                        Owner: $stateParams.owner
                    }
                }).then(function (newData) {
                    if (newData) {
                        vm.savingTask = true;
                        vm.taskData = newData.task;
                        vm.files = newData.files;
                        vm.saveTask();
                    }
                });
            }

            function saveTask() {
                taskDetailsUtil.saveTask($stateParams.owner, vm.taskData, vm.files).then(function (res) {
                    vm.updateTasks();
                })
            }
            function updateTasks() {
                vm.loadingTasks = true;
                vm.currentTasks = undefined;
                if (vm.relatedtype == 'active_controls') {
                    vm.idrelated = vm.currentcontrol && vm.currentcontrol.active_control_id;
                }
                var promise = taskViewSectionservice.getTasks({
                    id: vm.idrelated,
                    related_type: vm.relatedtype,
                    owner: $stateParams.owner,
                    withMessages: true,
                    withUser: true,
                    withFiles: true,
                    sortField: 'updated_at',
                    sortDir: 'DESC'
                });


                promise.then(function (res) {
                    if (res.total > 0) {
                        vm.currentTasks = $filter('orderBy')(res.data, 'is_complete', false);
                    }
                    vm.loadingTasks = false;
                    vm.savingTask = false;
                })
            }

        };
        return {
            bindToController: true,
            restrict: 'E',
            scope: {
                nolistadd: '=',
                relatedtype: '=',
                availableusers: '=',
                currentcontrolusers: '=',
                currentcontrol: '=',
                idrelated: '=?'
            },
            link: function (scope, elem) { },
            templateUrl: 'app/core/components/tasks-section-view/tasks-section-view.component.html',
            controller: controller,
            controllerAs: 'vm'
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('activityUser', activityUser);


    /** @ngInject */
    function activityUser() {
        var controller = function ($scope, staffService, msUtils, $stateParams) {

            var vm = this;
            vm.$onInit = function () {
                vm.loadAtivityUser = true;
                var options = {
                    id: vm.idUser,
                    owner: $stateParams.owner
                };
                staffService.getActivityUser(options).then(function (resp) {
                    for (var i = 0; i < resp.data.length; i++) {
                        resp.data[i].dateWithoutHours = moment(resp.data[i].date).format("MMM DD");
                    }
                    vm.activityUser = resp.data;
                    vm.loadAtivityUser = false;
                })
            }
            vm.timeAgo = msUtils.timeAgo;



        };
        return {
            bindToController: true,
            restrict: 'E',
            scope: {
                idUser: '=',
                owner: '='
            },
            link: function (scope, elem) { },
            templateUrl: 'app/core/components/activity-user/activity-user.component.html',
            controller: controller,
            controllerAs: 'vm'
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('chatView', chatView);


    /** @ngInject */
    function chatView() {
        var controller = function ($scope, $mdDialog, $translate, chatService, msUtils, $timeout, $document, mediaService, sessionService, $stateParams) {

            var vm = this;

            vm.userLogued = sessionService.getUser();
            vm.sendMessage = sendMessage;
            vm.showReceipt = showReceipt;

            vm.scrollToBottomOfChat = scrollToBottomOfChat;
            vm.resetReplyTextarea = resetReplyTextarea;
            vm.showUserImage = showUserImage;

            mediaService.getStoragePrefix({
                owner: $stateParams.owner
            }).then(function (res) {
                $scope.storagePrefix = res.prefix;
            })
            vm.$onInit = function () {
                getChat();
            }
            vm.timeAgo = msUtils.timeAgo;


            function getChat() {
                resetReplyTextarea();

                var options = {
                    id: vm.id,
                    related_type: vm.relatedtype,
                    owner: $stateParams.owner
                };
                chatService.getChatByTask({
                    id: vm.id,
                    related_type: vm.relatedtype,
                    owner: $stateParams.owner,
                    withFiles: true
                }).then(function (resp) {
                    vm.chat = resp.data;
                    scrollToBottomOfChat();
                });

            }

            const fileTypeMap = {
                image: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'],
                video: ['mp4', 'webm', 'ogg', 'mov'],
                pdf: ['pdf'],
                word: ['doc', 'docx'],
                excel: ['xls', 'xlsx'],
                audio: ['mp3', 'wav', 'ogg', 'm4a', 'aac'],
                zip: ['zip', 'rar', '7z', 'tar', 'gz']
            };
            $scope.isFileType = function(url, type) {
                if (!url) return false;
                var urlWithoutParams = url.split('?')[0];
                var extension = urlWithoutParams.split('.').pop().toLowerCase();
                return fileTypeMap[type] && fileTypeMap[type].includes(extension);
            };            


            function sendMessage($event) {
                $mdDialog.show({
                    controller: 'MessageDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/core/components/chat-view/dialogs/message-dialog.controller.html',
                    parent: angular.element(document.body),
                    targetEvent: $event,
                    clickOutsideToClose: true,
                    locals: {
                        relatedtype: vm.relatedtype,
                        complaint_id: vm.id
                    },
                })
                    .then(function (res) {
                        if (res) {
                            getChat(vm.id);
                        }
                    });

            }

            function resetReplyTextarea() {
                vm.replyMessage = '';
                vm.textareaGrow = false;
            }
            function scrollToBottomOfChat() {
                $timeout(function () {
                    var chatContent = angular.element($document.find('#chat-content'));

                    chatContent.animate({
                        scrollTop: chatContent[0].scrollHeight
                    }, 400);
                }, 0);

            }

            function showUserImage(user) {
                return $scope.storagePrefix + user.files.url
            }

            function showReceipt($event, dialog) {
                if ($event) {
                    $event.stopPropagation();
                }

                if (!dialog) {
                    return;
                }

                var isRead = !!dialog.complainant_viewed_at;
                var titleKey = isRead ? 'COMPLAINTS.MESSAGE_READ_DIALOG_TITLE' : 'COMPLAINTS.MESSAGE_DELIVERED_DIALOG_TITLE';
                var subtitleKey = isRead ? 'COMPLAINTS.MESSAGE_READ_DIALOG_SUBTITLE' : 'COMPLAINTS.MESSAGE_DELIVERED_DIALOG_SUBTITLE';

                var deliveredAt = dialog.created_at && dialog.created_at.clone
                    ? dialog.created_at.clone().local()
                    : moment.utc(dialog.created_at).local();

                var readAt = isRead
                    ? (dialog.complainant_viewed_at && dialog.complainant_viewed_at.clone
                        ? dialog.complainant_viewed_at.clone().local()
                        : moment.utc(dialog.complainant_viewed_at).local())
                    : null;

                var deliveredAtFormatted = deliveredAt.format('L LTS');
                var readAtFormatted = readAt ? readAt.format('L LTS') : null;

                $mdDialog.show({
                    parent: angular.element(document.body),
                    targetEvent: $event,
                    clickOutsideToClose: true,
                    escapeToClose: true,
                    locals: {
                        titleKey: titleKey,
                        subtitleKey: subtitleKey,
                        deliveredLabelKey: isRead ? 'COMPLAINTS.MESSAGE_READ_DIALOG_DELIVERED_LABEL' : 'COMPLAINTS.MESSAGE_DELIVERED_DIALOG_DATE_LABEL',
                        readLabelKey: 'COMPLAINTS.MESSAGE_READ_DIALOG_READ_LABEL',
                        deliveredAtFormatted: deliveredAtFormatted,
                        readAtFormatted: readAtFormatted,
                        iconName: isRead ? 'icon-check-all' : 'icon-check',
                        iconClass: isRead ? 'chat-read-receipt-dialog__icon--read' : 'chat-read-receipt-dialog__icon--delivered'
                    },
                    controller: function DialogController(
                        $scope,
                        $mdDialog,
                        $translate,
                        titleKey,
                        subtitleKey,
                        deliveredLabelKey,
                        readLabelKey,
                        deliveredAtFormatted,
                        readAtFormatted,
                        iconName,
                        iconClass
                    ) {
                        $scope.title = $translate.instant(titleKey);
                        $scope.subtitle = $translate.instant(subtitleKey);
                        $scope.deliveredLabel = $translate.instant(deliveredLabelKey);
                        $scope.readLabel = $translate.instant(readLabelKey);
                        $scope.closeLabel = $translate.instant('COMPLAINTS.MESSAGE_READ_DIALOG_CLOSE');
                        $scope.deliveredAtFormatted = deliveredAtFormatted;
                        $scope.readAtFormatted = readAtFormatted;
                        $scope.iconName = iconName;
                        $scope.iconClass = iconClass;
                        $scope.close = function () {
                            $mdDialog.hide();
                        };
                    },
                    template:
                        '<md-dialog class="chat-read-receipt-dialog" aria-label="{{title}}">' +
                        '  <md-dialog-content class="chat-read-receipt-dialog__content">' +
                        '    <div class="chat-read-receipt-dialog__header" layout="row" layout-align="start center">' +
                        '      <div class="chat-read-receipt-dialog__icon {{iconClass}}" aria-hidden="true">' +
                        '        <md-icon md-font-icon="{{iconName}}"></md-icon>' +
                        '      </div>' +
                        '      <div class="chat-read-receipt-dialog__titles">' +
                        '        <div class="chat-read-receipt-dialog__title">{{title}}</div>' +
                        '        <div class="chat-read-receipt-dialog__subtitle">{{subtitle}}</div>' +
                        '      </div>' +
                        '    </div>' +
                        '    <div class="chat-read-receipt-dialog__meta" layout="column" layout-align="start stretch">' +
                        '      <div class="chat-read-receipt-dialog__meta-row" layout="row" layout-align="space-between center">' +
                        '        <div class="chat-read-receipt-dialog__meta-label">{{deliveredLabel}}</div>' +
                        '        <div class="chat-read-receipt-dialog__meta-value">{{deliveredAtFormatted}}</div>' +
                        '      </div>' +
                        '      <div class="chat-read-receipt-dialog__meta-row" ng-if="readAtFormatted" layout="row" layout-align="space-between center">' +
                        '        <div class="chat-read-receipt-dialog__meta-label">{{readLabel}}</div>' +
                        '        <div class="chat-read-receipt-dialog__meta-value">{{readAtFormatted}}</div>' +
                        '      </div>' +
                        '    </div>' +
                        '  </md-dialog-content>' +
                        '  <md-dialog-actions layout="row" layout-align="end center">' +
                        '    <md-button class="md-primary" ng-click="close()">{{closeLabel}}</md-button>' +
                        '  </md-dialog-actions>' +
                        '</md-dialog>'
                });
            }

        };
        return {
            bindToController: true,
            restrict: 'E',
            scope: {
                id: '=',
                files: '=',
                anonymousname: '=',
                anonymous: '=',
                relatedtype: '='
            },
            link: function (scope, elem) { },
            templateUrl: 'app/core/components/chat-view/chat-view.component.html',
            controller: controller,
            controllerAs: 'vm'
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .service('chatService', ChatService);


    function ChatService($q, $resource, COMMON, Upload) {
        function getChatByTask(opt) {
            var deferred = $q.defer();
            opt.resultsPerPage = 1000;
            resourceChat.get(opt,
                function (response) {
                    response.data = response.data.map(x => {
                        x.created_at = moment.utc(x.created_at);
                        if (x.complainant_viewed_at) {
                            x.complainant_viewed_at = moment.utc(x.complainant_viewed_at);
                        }
                        return x;
                    })
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }
        function sendMessage(opt) {
            var deferred = $q.defer();
            resourceCreateMessage.post({ owner: opt.owner }, opt.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }
        function getS3UploadPreSignedUrl(options) {
            var deferred = $q.defer();
        
            resource_s3_presigned_url.get({
                owner: options.owner,
                uploadKey: 'message',
                fileName: options.fileName,
                rowId: options.rowId
            },
            function (response) {
                deferred.resolve(response);
            },
            function (e) {
                deferred.reject();
            });
        
            return deferred.promise;
        }
        
        function finishedUploadingFile(options) {
            var deferred = $q.defer();
            
            resource_finish_upload_file.post({
                owner: options.owner,
                token: options.token
            },
            {},
            function (response) {
                deferred.resolve(response);
            },
            function (e) {
                deferred.reject(e);
            });
        
            return deferred.promise;
        }
        
        function uploadFile(file, messageId, owner) {
            var deferred = $q.defer();

            getS3UploadPreSignedUrl({
                owner: owner,
                fileName: file.name,
                rowId: messageId
            }).then(function (resp) {
                var token = resp.token;

                file.upload = Upload.http({
                    url: resp.url,
                    skipAuthorization: true,
                    method: 'PUT',
                    headers: {
                        "Content-Type": file.type || 'application/octet-stream'
                    },
                    data: file
                });

                file.upload.then(function (response) {
                    finishedUploadingFile({
                        owner: owner,
                        token: token
                    }).then(function () {
                        deferred.resolve(response);
                    });
                }, function (error) {
                    deferred.reject(error);
                });

                file.upload.progress(function (evt) {
                    file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                });
            }, function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        var resource_s3_presigned_url = $resource(
            COMMON.BASE_API + "/owner/:owner/upload/getS3UploadPreSignedUrl", {}, {
                get: {
                    method: "GET",
                    isArray: false
                }
            }
        );

        var resource_finish_upload_file = $resource(
            COMMON.BASE_API + "/owner/:owner/upload/finishedUploadingFile", {}, {
                post: {
                    method: "POST",
                    isArray: false
                }
            }
        );
      
        var resourceChat = $resource(COMMON.BASE_API + "/owner/:owner/message?related_type=:related_type&related_id=:id", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        });
        var resourceCreateMessage = $resource(COMMON.BASE_API + "/owner/:owner/message", {
            // No default data
        }, {
            post: {
                method: "POST",
                isArray: false
            },
        });



        return ({
            getChatByTask: getChatByTask,
            sendMessage: sendMessage,
            getS3UploadPreSignedUrl: getS3UploadPreSignedUrl,
            uploadFile: uploadFile,
            finishedUploadingFile: finishedUploadingFile
        });

    }

})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('configureTabs', configureTabs);


    /** @ngInject */
    function configureTabs() {
        var controller = function ($scope, $rootScope, usersService, $timeout, companyService, $stateParams) {

            let vm = this;
            vm.count = 0;
            $scope.owner = $stateParams.owner;
            vm.loadingReadPane = true;

            vm.ivhOptions = {
                defaultSelectedState: false,
                validate: true,
                expandToDepth: -1,
                useCheckboxes: true,
                twistieCollapsedTpl: '<md-icon md-font-icon="icon-chevron-right"></md-icon>',
                twistieExpandedTpl: '<md-icon md-font-icon="icon-chevron-down"></md-icon>',
                twistieLeafTpl: '<span style="cursor: default;">&#8192;&#8192;</span>'
            };

            vm.$onInit = function () {
                checkUserTabs();
            }

            function checkUserTabs() {
                var options = {
                    owner: $scope.owner,
                    item: {
                        user_id: vm.userSelected.id
                    }
                };
                usersService.getUserTabs(options).then(function (response) {
                    vm.userTabsList = response;
                    getTabMenu(options);
                }).catch(function (err) {
                    vm.loadingReadPane = false;
                    console.log(err);
                });

            }


            function createTree(list, parent) {
                var result = [];
                result = list.filter(x => x.parent_id == parent);
                for (let i = 0; i < result.length; i++) {
                    const parent = result[i];
                    parent.submenu = createTree(list, parent.id)
                }
                return result;
            }
            function selectUserTab(node, user_id, active) {
                // vm.loadingReadPane = true;
                var finalOptions = {
                    owner: $scope.owner,
                    item: {
                        user_id: user_id,
                        tab_id: node.tab_id,
                        sort: node.sort
                    }
                };
                if (node.active || active === false) {
                    vm.count++;
                    node.usrSrv.eliminarUserTabs(finalOptions)
                        .then(function (response) {
                            node.active = false;
                            if (node.children && node.children.length > 0) {
                                node.children.forEach(element => {
                                    if (element.active) {
                                        selectUserTab(element, user_id, false);
                                    }
                                });
                            }
                            vm.count--;
                            if (vm.count === 0) {
                                checkUserTabs();
                            }
                        }).catch(function (err) {
                            console.log(err);
                        });
                } else {
                    vm.count++;
                    node.usrSrv.insertUserTabs(finalOptions)
                        .then(function (response) {
                            node.active = true;
                            if (node.children && node.children.length > 0) {
                                node.children.forEach(element => {
                                    if (!element.active) {
                                        selectUserTab(element, user_id, true);
                                    }
                                });
                            }
                            vm.count--;
                            if (vm.count === 0) {
                                checkUserTabs();
                            }
                        }).catch(function (err) {
                            console.log(err);
                        });
                }
            }


            function getTabMenu(opt) {
                var options = {
                    owner: $scope.owner
                };
                var request;
                if (vm.userLogued.user_type === 1) {
                    request = usersService.getUserTabsOwner(options);
                } else {
                    request = usersService.getMenu(options);
                }
                request.then(function (response) {
                    if (vm.userLogued.user_type === 1) {
                        response = createTree(response, null);
                        response = response.reduce(function (map, obj) {
                            map[obj.id] = obj;
                            return map;
                        }, {});
                        response = { menu: { app: response } }
                    }
                    vm.tabMenu = [];
                    var tmpMenu = [];
                    for (var app in response.menu.app) {
                        if (response.menu.app[app].submenu) {
                            response.menu.app[app].submenu.sort(function (a, b) {
                                return a.sort - b.sort;
                            });
                        }
                        tmpMenu.push(response.menu.app[app]);

                    }
                    tmpMenu.sort(function (a, b) {
                        return a.sort - b.sort;
                    });

                    response.menu.app = Object.assign({}, tmpMenu);
                    for (var app in response.menu.app) {
                        var children = [];
                        //console.log(response.menu.app[app]);
                        if (response.menu.app[app].submenu) {
                            for (var child in response.menu.app[app].submenu) {
                                //console.log("subTree: ", response.menu.app[app].submenu[child]);
                                var subTree = {
                                    label: response.menu.app[app].submenu[child].title,
                                    icon: response.menu.app[app].submenu[child].icon,
                                    tab_id: response.menu.app[app].submenu[child].id,
                                    sort: response.menu.app[app].submenu[child].sort,
                                    type: "user",
                                    usrSrv: usersService,
                                    __ivhTreeviewExpanded: false
                                }
                                subTree.active = false;
                                for (var tab in vm.userTabsList) {
                                    if (vm.userTabsList[tab].tab_id == response.menu.app[app].submenu[child].id) {
                                        subTree.active = true;
                                    }
                                }
                                subTree.imprimir = function (node) {
                                    //console.log("472 usersService: ", us)
                                    selectUserTab(node, vm.userSelected.id);
                                }
                                children.push(subTree);

                            }
                        }
                        //console.log(response.menu.app[app])
                        var tree = {
                            children: children,
                            label: response.menu.app[app].title,
                            icon: response.menu.app[app].icon,
                            tab_id: response.menu.app[app].id,
                            sort: response.menu.app[app].sort,
                            type: "branch",
                            usrSrv: usersService,
                            __ivhTreeviewExpanded: true
                        }

                        tree.active = false;
                        for (var tab in vm.userTabsList) {
                            if (vm.userTabsList[tab].tab_id == response.menu.app[app].id) {
                                tree.active = true;
                            }
                        }
                        //console.log("tree: ", response.menu.app[app]);
                        tree.imprimir = function (node) {
                            //console.log("imprmir usersService: ", us);
                            selectUserTab(node, vm.userSelected.id);
                        }
                        vm.tabMenu.push(tree);
                        vm.loadingReadPane = false;
                    }
                });
            }
        };
        return {
            bindToController: true,
            restrict: 'E',
            scope: {
                userSelected: '=',
                userLogued: '='
            },
            link: function (scope, elem) { },
            templateUrl: 'app/core/components/configure-tabs/configure-tabs.component.html',
            controller: controller,
            controllerAs: 'vm'
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.public', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msUtilProvider) {
        $stateProvider.state('public.login', {
            url: '/login',
            // resolve: {
            //     skipIfLoggedIn: skipIfLoggedIn
            // },
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@public.login': {
                    templateUrl: 'app/main/public/login.html',
                    controller: 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        });

        // State
        $stateProvider
            .state('public.forgot', {
                url: '/forgot',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@public.forgot': {
                        templateUrl: 'app/main/public/login-forgot.html',
                        controller: 'ForgotController as vm'
                    }
                },
                bodyClass: 'forgot'
            });
        $stateProvider
            .state('public.recover', {
                url: '/newPasswordConfirm',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@public.recover': {
                        templateUrl: 'app/main/public/login-recover.html',
                        controller: 'RecoverController as vm'
                    }
                },
                bodyClass: 'recover'
            });
        $stateProvider
            .state('public.setup_2fa', {
                url: '/setup_2fa/:owner',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@public.setup_2fa': {
                        templateUrl: 'app/main/public/login-setup.html',
                        controller: 'SetupController as vm'
                    }
                },
                bodyClass: 'setup_2fa'
            });
        $stateProvider
            .state('public.2fa_auth', {
                url: '/2fa_auth/:owner',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@public.2fa_auth': {
                        templateUrl: 'app/main/public/login-2fa.html',
                        controller: 'TwofaController as vm'
                    }
                },
                bodyClass: '2fa_auth'
            });
        // Callback after Google login; the backend redirects here with token and next_step
        $stateProvider
            .state('public.authCallback', {
                url: '/auth/callback?token&next_step&owner',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@public.authCallback': {
                        templateUrl: 'app/main/public/auth-callback.html',
                        controller: 'AuthCallbackController as vm'
                    }
                },
                bodyClass: 'login'
            });

        // Translation
        var base = 'app/main/public';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }
        // Api
        msApiProvider.register('sample', ['app/data/sample/sample.json']);

        // Navigation
        // msNavigationServiceProvider.saveItem('fuse', {
        //     title : 'SAMPLE',
        //     group : true,
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('fuse.sample', {
        //     title    : 'Sample',
        //     icon     : 'icon-tile-four',
        //     state    : 'app.sample',
        //     /*stateParams: {
        //         'param1': 'page'
        //      },*/
        //     translate: 'SAMPLE.SAMPLE_NAV',
        //     weight   : 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.public')
        .controller('TwofaController', TwofaController);

    /** @ngInject */
    function TwofaController($scope, $location, $auth, $cookies, $translate, msUtils, requestContext, $mdToast, loginService) {
        var vm = this;
        vm.branding = msUtils.getBranding();

        vm.validate = function (code) {
            var options = {
                code: code,
                owner: requestContext.getParam("owner")
            }
            loginService.auth2fa(options).then(function (response) {

                $cookies.put('ownerRemember', requestContext.getParam("owner"));
                loginSucess(response.token);
            })
        }

        function loginSucess(token) {
            $auth.setToken(token);
            var message = $translate.instant('GLOBAL.WELCOME_AGAIN');;
            // console.log(vm.user)
            $mdToast.show({
                template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                hideDelay: 7000,
                position: 'top right',
                parent: '#content'
            });
            // toastr.success('You have successfully signed in');
            $scope.$emit('loginSucess', vm.user);
            var returnUrl = $location.search().returnUrl;
            if (returnUrl) {
                $location.path(decodeURI(returnUrl));
            } else {
                $location.path('/');
            }
        }
        //////////
    }
})();
(function () {
    'use strict';

    angular
        .module('app.public')
        .controller('SetupController', SetupController);

    /** @ngInject */
    function SetupController($scope, $location, msUtils, requestContext, loginService) {
        var vm = this;
        vm.branding = msUtils.getBranding();

        var options = {
            owner: requestContext.getParam("owner")
        }
        loginService.resetSecret(options).then(function (res) {
            vm.secret = res;
        })

        vm.validate = function (code) {
            var options = {
                code: code,
                owner: requestContext.getParam("owner")
            }
            loginService.validateSecret(options).then(function (res) {
                vm.success = true;
            })
        }
        //////////
    }
})();
(function () {
    'use strict';

    angular
        .module('app.public')
        .controller('RecoverController', RecoverController);

    /** @ngInject */
    function RecoverController($scope, $location, msUtils, loginService) {
        var vm = this;
        vm.branding = msUtils.getBranding();

        var token = $location.$$search.token
        if (!token) {
            $location.path("/login")
        }
        vm.form = {};

        if (!vm.form.account_alias) {
            var hostSplited = $location.$$host.split('.');
            if ((hostSplited.length >= 2 && hostSplited[1] == 'h2c' || hostSplited[1] == 'localhost') && hostSplited[0] != 'www') {
                vm.form.account_alias = hostSplited[0];
            }
        }
        $scope.restore = function (recoverForm) {
            if (vm.form.password == vm.form.passwordRepeat) {
                var options = {
                    token: token,
                    password: vm.form.password,
                    account_alias: vm.form.account_alias
                }
                loginService.restore(options).then(function (res) {
                    vm.notmatch = false;
                    vm.success = true;
                })
            } else {
                vm.notmatch = true;
                console.log("not match")
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.risk')
        .service('loginService', loginService);

    /** @ngInject */
    // I provide access to the session store.
    function loginService($q, $resource, COMMON, $mdToast) {



        function reset(options) {


            var deferred = $q.defer();
            resourceReset.post({
                email: options.email,
                account_alias: options.account_alias
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);


        }


        function resetSecret(options) {
            var deferred = $q.defer();
            resourceResetSecret.post({ owner: options.owner }, { owner: options.owner, user_id: options.user_id },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function validateSecret(options) {
            var deferred = $q.defer();
            resourceValidateSecret.post({ owner: options.owner, code: options.code }, { owner: options.owner, code: options.code },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function auth2fa(options) {


            var deferred = $q.defer();
            resourceAuth2fa.post({
                owner: options.owner
            },{'2fa_code': options.code},
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);


        }
        function restore(options) {


            var deferred = $q.defer();
            resourceRestore.post({
                token: options.token,
                password: options.password,
                account_alias: options.account_alias
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);


        }


        var resourceReset = $resource(COMMON.BASE_API + "/auth/requestPasswordReset", {
            // No default data
        }, {
                post: {
                    method: "POST",
                    isArray: false
                }
            });
        var resourceRestore = $resource(COMMON.BASE_API + "/auth/requestPasswordConfirm", {
            // No default data
        }, {
                post: {
                    method: "POST",
                    isArray: false
                }
            });
        var resourceResetSecret = $resource(COMMON.BASE_API + "/owner/:owner/user2fa/resetSecret", {
            // No default data
        }, {
                post: {
                    method: "POST",
                    isArray: false
                }
            });
        var resourceValidateSecret = $resource(COMMON.BASE_API + "/owner/:owner/user2fa/validateSecret", {
            // No default data
        }, {
                post: {
                    method: "POST",
                    isArray: false
                }
            });
        var resourceAuth2fa = $resource(COMMON.BASE_API + "/owner/:owner/auth/login2FA", {
            // No default data
        }, {
                post: {
                    method: "POST",
                    isArray: false
                }
            });




        return ({
            reset: reset,
            resetSecret: resetSecret,
            validateSecret: validateSecret,
            auth2fa: auth2fa,
            restore: restore
        });

    }

})();
(function () {
    'use strict';

    angular
        .module('app.public')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($scope, $auth, $cookies, $mdToast, $location, $state, $translate, msUtils, sessionService, COMMON, $window) {
        var vm = this;
        vm.branding = msUtils.getBranding();

        // Data
        vm.languages = {
            en: {
                'title': 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code': 'en',
                'flag': 'us'
            },
            es: {
                'title': 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code': 'es',
                'flag': 'es'
            },
            pt: {
                'title': 'Portugues',
                'translation': 'TOOLBAR.PORTUGUESE',
                'code': 'pt',
                'flag': 'pt'
            },
            de: {
                'title': 'German',
                'translation': 'TOOLBAR.GERMAN',
                'code': 'de',
                'flag': 'de'
            },
             ca: {
                 'title': 'TOOLBAR.CATALAN',
                 'translation': 'TOOLBAR.CATALAN',
                 'code': 'ca',
                 'flag': 'ca'
             },
             fr: {
                'title': 'TOOLBAR.FRENCH',
                'translation': 'TOOLBAR.FRENCH',
                'code': 'fr',
                'flag': 'fr'
            },
            it: {
                'title': 'TOOLBAR.ITALIAN',
                'translation': 'TOOLBAR.ITALIAN',
                'code': 'it',
                'flag': 'it'
            }
        };
        vm.form = {};

        if (!vm.form.account_alias) {
            var hostSplited = $location.$$host.split('.');
            if ((hostSplited.length >= 2 && hostSplited[1] == 'h2c' || hostSplited[1] == 'localhost') && hostSplited[0] != 'www') {
                vm.form.account_alias = hostSplited[0];
            } else {
                vm.form.account_alias = $cookies.get('ownerRemember');
            }
        }
        vm.brandname = angular.copy(vm.form.account_alias);
        vm.loading = false;

        // Methods
        vm.changeLanguage = changeLanguage;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];

            var params = $location.search();

            // If the backend redirected with ?error=... (Google login failed), show message and clear URL
            if (params.error) {
                showGoogleLoginError(params.error);
                $location.search({});
                return;
            }

            // If the backend redirected to /login?token=...&owner=...&next_step=... (Google callback),
            // process as callback and redirect to dashboard or 2FA
            if (params.token) {
                handleGoogleCallback(params);
                return;
            }
        }

        /**
         * Show the error message according to the code that the backend sends when Google login fails.
         */
        function showGoogleLoginError(errorCode) {
            var keyMap = {
                invalid_state: 'LOGIN.GOOGLE_ERROR_INVALID_STATE',
                invalid_account: 'LOGIN.GOOGLE_ERROR_INVALID_ACCOUNT',
                google_exchange_failed: 'LOGIN.GOOGLE_ERROR_GOOGLE_EXCHANGE_FAILED',
                no_account_found: 'LOGIN.GOOGLE_ERROR_NO_ACCOUNT_FOUND',
                account_not_linked: 'LOGIN.GOOGLE_ERROR_ACCOUNT_NOT_LINKED',
                account_disabled: 'LOGIN.GOOGLE_ERROR_ACCOUNT_DISABLED',
                google_signin_failed: 'LOGIN.GOOGLE_ERROR_GOOGLE_SIGNIN_FAILED'
            };
            var messageKey = keyMap[errorCode] || 'LOGIN.GOOGLE_ERROR_GOOGLE_SIGNIN_FAILED';
            // Esperar a que las traducciones carguen (tras full reload desde auth-callback en prod)
            $translate(messageKey).then(function (message) {
                $mdToast.show({
                    template: '<md-toast id="language-message">' +
                        '<div class="md-toast-content bg-red">' + message + '</div></md-toast>',
                    hideDelay: 12000,
                    position: 'top',
                    parent: '#toast-center-container'
                });
            });
        }

        /**
         * Process the Google login callback when the backend redirects to /login with token in the URL.
         */
        function handleGoogleCallback(params) {
            var token = params.token;
            var nextStep = params.next_step;
            var owner = params.owner || $cookies.get('owner');

            if (!owner) {
                return;
            }

            $auth.setToken(token);
            $cookies.put('owner', owner);
            $cookies.put('ownerRemember', owner);

            $translate('GLOBAL.WELCOME_AGAIN').then(function (message) {
                $mdToast.show({
                    template: '<md-toast id="language-message">' +
                        '<div class="md-toast-content bg-green">' + message + '</div></md-toast>',
                    hideDelay: 8000,
                    position: 'top',
                    parent: '#toast-center-container'
                });
            });

            if (!nextStep || nextStep === '') {
                $state.go('app.site_overview.dashboard.list', { owner: owner });
            } else if (nextStep === 'setup_2fa') {
                $state.go('public.setup_2fa', { owner: owner });
            } else if (nextStep === 'validate_2fa') {
                $state.go('public.2fa_auth', { owner: owner });
            } else {
                $state.go('app.site_overview.dashboard.list', { owner: owner });
            }
        }

        function changeLanguage(lang) {
            vm.selectedLanguage = lang;
            sessionService.changeLanguage(lang.code)
        }

        function loginSucess(token) {
            $auth.setToken(token);
            $translate('GLOBAL.WELCOME_AGAIN').then(function (message) {
                $mdToast.show({
                    template: '<md-toast id="language-message">' +
                        '<div class="md-toast-content bg-green">' + message + '</div></md-toast>',
                    hideDelay: 8000,
                    position: 'top',
                    parent: '#toast-center-container'
                });
            });

            $scope.$emit('loginSucess', vm.user);
            var returnUrl = $location.search().returnUrl;
            if (returnUrl) {
                $location.path(decodeURI(returnUrl));
            } else {
                // Explicitly redirect to the owner's dashboard (e.g.: /owner/canalbeta/dashboard)
                $state.go('app.site_overview.dashboard.list', { owner: vm.form.account_alias });
            }
        }

        function loginError(message) {
            // var message = response.data.error;

            //$mdToast.show({
            //    template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
            //    hideDelay: 7000,
            //    position: 'top right',
            //    parent: '#content'
            //});
        }

        // Scope
        $scope.login = function (loginForm) {
            toggleLoading();
            $cookies.put('owner', vm.form.account_alias);
            var that = $auth;
            $auth.login(vm.form)
                .then(function (response) {
                    if (response.data.next_step == null) {
                        $cookies.put('ownerRemember', vm.form.account_alias);
                        loginSucess(response.data.token);
                    } else if (response.data.next_step == 'validate_2fa') {
                        $state.go('public.2fa_auth', { owner: vm.form.account_alias });
                    } else if (response.data.next_step == 'setup_2fa') {
                        $state.go('public.setup_2fa', { owner: vm.form.account_alias });
                    }

                })
                .catch(function (response) {
                    toggleLoading();
                    if (response.data) {
                        loginError(response.data.status + ' ' + response.data.title);
                    } else if (response.status === -1) {
                        loginError('Login error, please contact with support team');
                    }
                    loginForm.$setPristine();
                    loginForm.$setUntouched();
                    vm.form.password = '';
                });
        };
        $scope.authenticate = function (provider) {
            $auth.authenticate(provider)
                .then(function (response) {
                    loginSucess(response.data.token);
                })
                .catch(function (error) {
                    if (error.error) {
                        // Popup error - invalid redirect_uri, pressed cancel button, etc.
                        loginError(error.error);
                    } else if (error.status == 401) {
                        if (error.data.error) {
                            loginError(error.data.error);
                        } else if (error.data.message) {
                            loginError(error.data.message);
                        }
                    } else if (error.data) {
                        // HTTP response error from server
                        loginError(error.data.message, error.status);
                    } else {
                        loginError(error);
                    }
                });
        };

        /**
         * Redirect to the Google login API.
         * GET /api/v1/auth/google/redirect?account_alias=xxx&redirect_uri=xxx
         * The backend redirects back to /auth/callback?token=...&next_step=...&owner=...
         */
        vm.loginWithGoogle = function () {
            if (!vm.form.account_alias || !vm.form.account_alias.trim()) {
                loginError($translate.instant('LOGIN.ERRORS.ACCOUNT_REQUIRED'));
                return;
            }
            // Save owner in cookie before exiting; the callback will use it if the backend does not return it in the URL
            $cookies.put('owner', vm.form.account_alias);
            $cookies.put('ownerRemember', vm.form.account_alias);
            var redirectUri = $window.location.origin + '/auth/callback?owner=' + encodeURIComponent(vm.form.account_alias);
            var url = COMMON.BASE_API + '/auth/google/redirect';
            url += '?account_alias=' + encodeURIComponent(vm.form.account_alias);
            url += '&redirect_uri=' + encodeURIComponent(redirectUri);
            $window.location.href = url;
        };

        function toggleLoading() {
            vm.loading = (vm.loading) ? false : true;
        }

        //////////
    }
})();
(function () {
    'use strict';

    angular
        .module('app.public')
        .controller('ForgotController', ForgotController);

    /** @ngInject */
    function ForgotController($scope, $location, msUtils, loginService) {
        var vm = this;

        vm.branding = msUtils.getBranding();

        vm.form = {};

        if (!vm.form.account_alias) {
            var hostSplited = $location.$$host.split('.');
            if ((hostSplited.length >= 2 && hostSplited[1] == 'h2c' || hostSplited[1] == 'localhost') && hostSplited[0] != 'www') {
                vm.form.account_alias = hostSplited[0];
            }
        }
        $scope.forgot = function (forgotForm) {
            var options = {
                email: vm.form.email,
                account_alias: vm.form.account_alias
            }
            loginService.reset(options).then(function (res) {
                vm.success = true;
            })
        };
        //////////
    }
})();
(function () {
    'use strict';

    angular
        .module('app.public')
        .controller('AuthGoogleLinkedController', AuthGoogleLinkedController);

    /** @ngInject */
    function AuthGoogleLinkedController($location, $window, $timeout) {
        var vm = this;
        var linked = $location.search().linked === '1' || $location.search().linked === true;

        if (linked && $window.opener) {
            try {
                $window.opener.postMessage({ type: 'google-linked', success: true }, $window.location.origin);
            } catch (e) {}
            $timeout(function () {
                $window.close();
            }, 5000);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.public')
        .controller('AuthCallbackController', AuthCallbackController);

    /** @ngInject */
    function AuthCallbackController($location, $state, $auth, $cookies, $translate, $mdToast, $window, msUtils) {
        var vm = this;
        vm.branding = msUtils.getBranding();
        var params = $location.search();

        // If the backend redirected with ?error=... (Google login failed), redirect to login with the error in URL.
        // $state.go ignores query params; $window.location preserves them so LoginController can read and show the toast.
        if (params.error) {
            $window.location.href = '/login?error=' + encodeURIComponent(params.error);
            return;
        }

        var token = params.token;
        var nextStep = params.next_step;
        var owner = params.owner;

        if (!token) {
            $state.go('public.login');
            return;
        }

        var resolvedOwner = owner || $cookies.get('owner');
        if (!resolvedOwner) {
            $state.go('public.login');
            return;
        }

        $auth.setToken(token);
        $cookies.put('owner', resolvedOwner);
        $cookies.put('ownerRemember', resolvedOwner);

        if (!nextStep || nextStep === '') {
            $translate('GLOBAL.WELCOME_AGAIN').then(function (message) {
                $mdToast.show({
                    template: '<md-toast id="language-message">' +
                        '<div class="md-toast-content bg-green">' + message + '</div></md-toast>',
                    hideDelay: 8000,
                    position: 'top',
                    parent: '#toast-center-container'
                });
            });
            $state.go('app.site_overview.dashboard.list', { owner: resolvedOwner });
        } else if (nextStep === 'setup_2fa') {
            $state.go('public.setup_2fa', { owner: resolvedOwner });
        } else if (nextStep === 'validate_2fa') {
            $state.go('public.2fa_auth', { owner: resolvedOwner });
        } else {
            $state.go('app.site_overview.dashboard.list', { owner: resolvedOwner });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;
        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // Set active theme
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions()
    {
        return {
            restrict   : 'E',
            scope      : {
                panelOpen: '=?'
            },
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        backdropEl = angular.element('<div class="ms-theme-options-backdrop"></div>');

                    // Panel open status
                    scope.panelOpen = scope.panelOpen || false;

                    /**
                     * Toggle options panel
                     */
                    function toggleOptionsPanel()
                    {
                        if ( scope.panelOpen )
                        {
                            closeOptionsPanel();
                        }
                        else
                        {
                            openOptionsPanel();
                        }
                    }

                    function openOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = true;

                        // Add open class
                        iElement.addClass('open');

                        // Append the backdrop
                        bodyEl.append(backdropEl);

                        // Register the event
                        backdropEl.on('click touch', closeOptionsPanel);
                    }

                    /**
                     * Close options panel
                     */
                    function closeOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = false;

                        // Remove open class
                        iElement.removeClass('open');

                        // De-register the event
                        backdropEl.off('click touch', closeOptionsPanel);

                        // Remove the backdrop
                        backdropEl.remove();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsPanel = toggleOptionsPanel;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseTheming', fuseThemingProvider);

    /** @ngInject */
    function fuseThemingProvider()
    {
        // Inject Cookies Service
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        var registeredPalettes,
            registeredThemes;

        // Methods
        this.setRegisteredPalettes = setRegisteredPalettes;
        this.setRegisteredThemes = setRegisteredThemes;

        //////////

        /**
         * Set registered palettes
         *
         * @param _registeredPalettes
         */
        function setRegisteredPalettes(_registeredPalettes)
        {
            registeredPalettes = _registeredPalettes;
        }

        /**
         * Set registered themes
         *
         * @param _registeredThemes
         */
        function setRegisteredThemes(_registeredThemes)
        {
            registeredThemes = _registeredThemes;
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getRegisteredPalettes: getRegisteredPalettes,
                getRegisteredThemes  : getRegisteredThemes,
                setActiveTheme       : setActiveTheme,
                setThemesList        : setThemesList,
                themes               : {
                    list  : {},
                    active: {
                        'name' : '',
                        'theme': {}
                    }
                }
            };

            return service;

            //////////

            /**
             * Get registered palettes
             *
             * @returns {*}
             */
            function getRegisteredPalettes()
            {
                return registeredPalettes;
            }

            /**
             * Get registered themes
             *
             * @returns {*}
             */
            function getRegisteredThemes()
            {
                return registeredThemes;
            }

            /**
             * Set active theme
             *
             * @param themeName
             */
            function setActiveTheme(themeName)
            {
                // If theme does not exist, fallback to the default theme
                if ( angular.isUndefined(service.themes.list[themeName]) )
                {
                    // If there is no theme called "default"...
                    if ( angular.isUndefined(service.themes.list.default) )
                    {
                        $log.error('You must have at least one theme named "default"');
                        return;
                    }

                    $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                    // Otherwise set theme to default theme
                    service.themes.active.name = 'default';
                    service.themes.active.theme = service.themes.list.default;
                    $cookies.put('selectedTheme', service.themes.active.name);

                    return;
                }

                service.themes.active.name = themeName;
                // service.themes.active.theme = service.themes.list[themeName];
                // $cookies.put('selectedTheme', 'teal');
                // $cookies.put('selectedTheme', themeName);
            }

            /**
             * Set available themes list
             *
             * @param themeList
             */
            function setThemesList(themeList)
            {
                service.themes.list = themeList;
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes, fuseThemingProvider)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });

        // Store generated PALETTES and THEMES objects from $mdThemingProvider
        // in our custom provider, so we can inject them into other areas
        fuseThemingProvider.setRegisteredPalettes($mdThemingProvider._PALETTES);
        fuseThemingProvider.setRegisteredThemes($mdThemingProvider._THEMES);
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        'default'  : {
            primary   : {
                name: 'fuse-pale-blue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'red'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'pink': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'blue'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'teal'     : {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'deep-orange'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-pale-blue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            var registeredThemes = fuseTheming.getRegisteredThemes();
            var registeredPalettes = fuseTheming.getRegisteredPalettes();

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .service("userService", Service);

    /** @ngInject */
    // I provide access to the screen store.
    function Service(
        //_
    ) {

        //publicly exposed dictionary
        var userProperties = {
            firstName: "firstName",
            initials: "initials",
            isSystemAvatar: "isSystemAvatar",
            hasSystemAvatar: "hasSystemAvatar",
            onlineStatus: "onlineStatus",
            shortName: "shortName"
        };

        //I add dynamic properties to a list of users
        function addPropsToUsers(users, propertyNames) {

            //for each user, add the passed in properties
            // _.forEach(users, function(user) {
            // 	_.forEach(propertyNames, function(property) {
            // 		switch (property) {
            // 			case userProperties.firstName:
            // 				user.firstName = getFirstName( user.name );
            // 				break;
            // 			case userProperties.initals:
            // 				user.initals = getInitials( user.name );
            // 				break;
            // 			case userProperties.isSystemAvatar:
            // 				user.isSystemAvatar = isSystemAvatar( user.avatarID );
            // 				break;
            // 			case userProperties.hasSystemAvatar:
            // 				user.hasSystemAvatar = isSystemAvatar( user.avatarID );
            // 				break;
            // 			case userProperties.onlineStatus:
            // 				user.onlineStatus = getOnlineStatus( user.avatarID );
            // 				break;
            // 			case userProperties.shortName:
            // 				user.shortName = getShortName(user.shortName);
            // 				break;
            // 			default:
            // 				break;
            // 		}
            // 	});
            // });

            return users;
        }

        // I get the first and last initials of the given name.
        function getInitials(name) {

            // If no value was passed-in, return nothing.
            if (!name) {

                return ("");

            }

            // Trim and split on white-space.
            var nameParts = name
                .replace(/^\s+|\s+$/i, "")
                .split(/\s+/i);

            // Get references to the two parts of the name that we want to use - the
            // first name and the last name (ignores any middle name tokens).
            var firstName = (nameParts.shift() || "");
            var lastName = (nameParts.pop() || "");

            return (
                firstName.slice(0, 1).toUpperCase() +
                lastName.slice(0, 1).toUpperCase()
            );

        }


        // I get the online status given the date of the last request.
        function getOnlineStatus(lastRequestAt) {

            var now = (new Date()).getTime();
            var onlineCutoff = (10 * 60 * 1000); // 10 minutes.
            var awayCutoff = (30 * 60 * 1000); // 30 minutes.

            if (lastRequestAt > (now - onlineCutoff)) {

                return ("Online");

            } else if (lastRequestAt > (now - awayCutoff)) {

                return ("Away");

            }

            return ("Offline");

        }


        // I get the first name plus the last initial, if it is available.
        function getShortName(name) {

            // If no value was passed-in, return nothing.
            if (!name) {

                return ("");

            }

            var nameParts = name.replace(/^\s+|\s+$/i, "").split(/\s+/i);
            var namePartsCount = nameParts.length;

            // If we have multiple parts, get the first part and first inital of the last one.
            if (namePartsCount > 1) {

                return (
                    nameParts[0] +
                    " " +
                    nameParts[namePartsCount - 1].slice(0, 1) +
                    ((nameParts[namePartsCount - 1].length > 1) ? "." : "")
                );

            }

            // If we only have one part, just get the first part.
            return (nameParts[0]);

        }


        function getFirstName(name) {

            // If no value was passed-in, return nothing.
            if (!name) {

                return ("");

            }

            var nameParts = name.replace(/^\s+|\s+$/i, "").split(/\s+/i);

            // If we only have one part, just get the first part.
            return (nameParts[0]);

        }


        // I determine if the given avatar is a system-generated avatar; or, one of the
        // user's choosing.
        function isSystemAvatar(avatarID) {

            // All the system-generated avatars start with a string of zeros (they are not
            // true UUID values).
            return (avatarID && avatarID.indexOf("00000000") === 0);

        }

        // Returns "Me" if the user is the current user
        function getNiceUsername(defaultUsername, userID, currentUserID) {

            return userID === currentUserID ? "me" : defaultUsername;

        }

        var ROLES = {
            ADMIN: 1,
            MANAGER: 2,
            CONTRIBUTOR: 3,
            REVIEWER: 4
        };

        // -------------------------------------------------- //
        // -------------------------------------------------- //


        // Return the public API.
        return ({
            addPropsToUsers: addPropsToUsers,
            getInitials: _.memoize(getInitials),
            // getOnlineStatus: getOnlineStatus,
            // getShortName: _.memoize( getShortName ),
            // getFirstName: _.memoize( getFirstName ),
            isSystemAvatar: _.memoize(isSystemAvatar),
            getNiceUsername: getNiceUsername,
            userProperties: userProperties,
            ROLES: ROLES
        });


    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .service("tinyMceService", tinyMce);

    /** @ngInject */
    // I provide access to the session store.
    function tinyMce($q, $resource, $window, $rootScope) {

        function setQiuMediaTextContent(content, event) {
            console.log(content, event)
        }

        function getOptions($scope) {
            var tinymceOptions  = {
                theme                  : 'modern',
                language: 'es',
                height                 : 500,
                remove_script_host     : false,
                allow_script_urls      : true,
                convert_urls           : false,
                extended_valid_elements: 'script[language|type|src|async|charset]',
                paste_retain_style_properties: "color font-size",
                plugins                : [
                    'paste qiupaste media advlist autolink lists link image charmap preview hr anchor pagebreak', 'searchreplace wordcount visualblocks visualchars code imagetools', 'nonbreaking table contextmenu', 'template textcolor colorpicker textpattern'
                ],
                toolbar1               : ' insertfile undo redo | bold italic underline | alignleft aligncenter alignright alignjustify | forecolor backcolor | fontselect fontsizeselect | bullist numlist outdent indent | link unlink image media | code removeformat buttonadv',
                toolbar2               : '',
                content_style          : "#tinymce { font-size: 16px;line-height:1.6;font-family:'Helvetica Neue', sans-serif; }" +
                ".align-left { text-align:left }" +
                ".align-center { text-align:center }" +
                ".align-right { text-align:right }" +
                ".size-25 { width:25% }" +
                ".size-50 { width:50% }" +
                ".size-75 { width:75% }" +
                ".size-100 { width:100% }" +
                ".qiumedia-video { border: 2px solid #FF0000 }" +
                "img { max-width: 250px; max-height: 250px; }",
                image_advtab           : true,
                image_dimensions       : false,
                image_resizing         : false,
                menubar                : false,
                setup                  : function (editor) {
                    var vm              = $scope.vm;
                    editor.on('change', function (e) {
                        if (vm.basicForm)
                            vm.basicForm.$setDirty();
                    });

                    editor.on('ObjectResizeStart', function(e) {
                        if (e.target.nodeName.toLowerCase() === 'img') {
                            e.preventDefault();
                        }
                    });
                    editor.on('ObjectSelected', function(e) {
                        if (e.target.nodeName.toLowerCase() === 'img') {
                            editor.editorCommands.execCommand('mceResize', false, false);
                        }
                    });
                
                    /*
                    editor.addButton('buttonadv', {
                        type: 'listbox',
                        text: 'Advanced',
                        icon: false,
                        onselect: function (e) {
                            console.log(editor.plugins.qiupaste.showDialog();
                            console.log(this.value());
                        },
                        values: [
                            {
                                text: 'Insert Social Embed',
                                value: 'qiupaste'
                            }, {
                                text: 'Insert Video/Image',
                                value: 'qiumedia'
                            }
                        ]
                    });
                    */
                    // editor.on('BeforeSetcontent', function(event){
                    //     var 1   = vm.setTinyMceContent(event);
                    //     var cont	= event.content;
                    //     var newCont	= cont;
                    //     var validData	= {
                    //         left: 'align-left',
                    //         center: 'align-center',
                    //         right: 'align-right',
                    //         25: 'size-25',
                    //         50: 'size-50',
                    //         75: 'size-75',
                    //         100: 'size-100',
                    //     }

                    //     var regex = /(\[image\|([^\]]*)\])/g;

                    //     var m;
                    //     while ((m = regex.exec(cont)) !== null) {
                    //         var expCont	= '';
                    //         var mediaData	= {
                    //             type: '',
                    //             sort: '',
                    //             class: ''
                    //         };
                    //         var mediaExtra	= '';
                    //         // This is necessary to avoid infinite loops with zero-width matches
                    //         if (m.index === regex.lastIndex) {
                    //             regex.lastIndex++;
                    //         }
                    //         if (m[2]) {
                    //             expCont	= m[2].split('|');
                    //             mediaData.type	= 'image';
                    //             for (var i = 0; i < expCont.length; i++) {
                    //                 if (i == 0) {
                    //                     mediaData.sort	= expCont[i];
                    //                 } else {
                    //                     mediaExtra	= expCont[i];
                    //                     if (!angular.isUndefined(validData[mediaExtra])) {
                    //                         mediaData.class	+= validData[mediaExtra] + ' ';
                    //                     }
                    //                 }
                    //             }
                    //             var newHtml = '<div contentEditable="false" class="qiumedia" data-qiumedia="' + m[0].substr(1,(m[0].length-2)) + '"><img src="' + zoneMedia[1][mediaData.sort].cropstatus[0].container.view_url + zoneMedia[1][mediaData.sort].cropstatus[0].fileName + '" class="qiumedia-image ' + mediaData.class + '"></div>';
                    //             newCont		= newCont.replace(m[0], newHtml);
                    //             event.content = newCont;
                    //         }
                    //     }
                    //     var regex = /(\[video\|([^\]]*)\])/g;

                    //     var n;

                    //     while ((n = regex.exec(cont)) !== null) {
                    //         var expCont	= '';
                    //         var mediaData	= {
                    //             type: '',
                    //             sort: '',
                    //             class: ''
                    //         };
                    //         var mediaExtra	= '';
                    //         // This is necessary to avoid infinite loops with zero-width matches
                    //         if (n.index === regex.lastIndex) {
                    //             regex.lastIndex++;
                    //         }
                    //         if (n[2]) {
                    //             expCont	= n[2].split('|');
                    //             mediaData.type	= 'video';
                    //             for (var i = 0; i < expCont.length; i++) {
                    //                 if (i == 0) {
                    //                     mediaData.sort	= expCont[i];
                    //                 } else {
                    //                     mediaExtra	= expCont[i];
                    //                     if (!angular.isUndefined(validData[mediaExtra])) {
                    //                         mediaData.class	+= validData[mediaExtra] + ' ';
                    //                     }
                    //                 }
                    //             }
                    //             var newHtml = '<div contentEditable="false" class="qiumedia" data-qiumedia="' + n[0].substr(1,(n[0].length-2)) + '"><img src="' + zoneMedia[2][mediaData.sort].embed_thumb + '" class="qiumedia-video ' + mediaData.class + '"></div>';
                    //             newCont		= newCont.replace(n[0], newHtml);
                    //             event.content = newCont;
                    //         }
                    //     }
                    // });
                }
            };
            return tinymceOptions;
        }

        function getBasicOptions($scope) {
            var tinymceOptions  = {
                theme                  : 'modern',
                language: 'es',
                height                 : 500,
                remove_script_host     : false,
                allow_script_urls      : true,
                convert_urls           : false,
                paste_retain_style_properties: "",
                plugins                : [
                    'paste qiupaste media advlist autolink lists link image charmap preview hr anchor pagebreak', 'searchreplace wordcount visualblocks visualchars code imagetools', 'nonbreaking table contextmenu', 'template textcolor colorpicker textpattern'
                ],
                toolbar1               : ' undo redo | bold italic underline | removeformat',
                toolbar2               : '',
                content_style          : "#tinymce { font-size: 16px;line-height:1.6;font-family:'Helvetica Neue', sans-serif; }" +
                ".align-left { text-align:left }" +
                ".align-center { text-align:center }" +
                ".align-right { text-align:right }" +
                ".size-25 { width:25% }" +
                ".size-50 { width:50% }" +
                ".size-75 { width:75% }" +
                ".size-100 { width:100% }" +
                ".qiumedia-video { border: 2px solid #FF0000 }",
                image_advtab           : true,
                menubar                : false,
                setup                  : function (editor) {
                    var vm              = $scope.vm;
                    editor.on('change', function (e) {
                        if (vm.basicForm)
                            vm.basicForm.$setDirty();
                    });
                }
            };
            return tinymceOptions;
        }
        // Return the public API.
        return ({
            setQiuMediaTextContent: setQiuMediaTextContent,
            getOptions: getOptions,
            getBasicOptions: getBasicOptions
        });


    }


})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .service('sessionService', sessionService);

    /** @ngInject */
    // I provide access to the session store.
    function sessionService($q, $resource, $translate, $timeout, $cookies, userService, settingsDomainService, COMMON, $window, requestContext, $rootScope, msNavigationService, $auth, $location, msUtils, $filter) {
        var vm = this;
        vm.rediretToLogout = false;
        // I attempt to login the current user. I return a promise that will resolve or reject
        // depending on whether or not the login request works.
        function authenticate(owner) {
            var deferred = $q.defer();
            if (vm.rediretToLogout) {
                return;
            }
            user_settings_resource.get({
                owner: owner
            },
                function (response) {
                    if (response.user.is_owner){

                    }
                    if (!user) {
                        user = {
                            id: 0,
                            files: [],
                            companies: [],
                            menu: []
                        };
                    }
                    loadinLog(owner);
                    angular.extend(user, response.user);
                    angular.extend(config, response.config);
                    $rootScope.$broadcast('reset-clients', {});
                    deferred.resolve(response);
                },
                function () {

                    $timeout(function () {
                        user_settings_resource.get({
                            owner: owner
                        },
                            function (response) {
                                angular.extend(user, response.user);
                                angular.extend(config, response.config);
                                $rootScope.$broadcast('reset-clients', {});
                                deferred.resolve(response);
                            },
                            function () {
                                vm.rediretToLogout = true;
                                console.log('retry failed...logout');
                                $auth.logout()
                                    .then(function () {
                                        cleanAllStorage();
                                        $location.path('/login');
                                        $window.location.reload();
                                    });
                                deferred.reject();
                            }
                        );
                    }, 200)
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getQuota() {
            var deferred = $q.defer();
            owner_quota_resource.get({
                owner: owner
            }, function (quota) {
                deferred.resolve(quota);
            })
            return (deferred.promise);
        }
        function logoutLog() {
            var deferred = $q.defer();
            logout_resource.post({ owner: owner }, {

            }, function (quota) {
                deferred.resolve(quota);
            })
            return (deferred.promise);
        }
        function loadinLog(ownerParam) {
            var deferred = $q.defer();
            loadin_resource.post({ owner: ownerParam }, {

            }, function (quota) {
                deferred.resolve(quota);
            })
            return (deferred.promise);
        }

        function getMenu() {
            var deferred = $q.defer();
            menu_resource.get({
                owner: owner
            },
                function (response) {
                    deferred.resolve(response.menu);
                },
                function () {
                    deferred.reject();
                }
            )
            return (deferred.promise);
        }

        function setMenu() {
            if ($rootScope.is_logout || !owner) {
                delete $rootScope.is_logout;
                return;
            }
            msNavigationService.clearNavigation();
            getMenu()
                .then(function (response) {
                    const permisionsTab = Object.values(response.app).filter(x => x.frontend_state === 'complaints.list')[0];
                    // $rootScope.permissionsComplaints = (permisionsTab && permisionsTab.permissions) ? permisionsTab.permissions : 'empty';
                    $rootScope.permissionsComplaints = [];
                    var i = 1;
                    angular.forEach(response, function (mainMenu, name) {
                        msNavigationService.saveItem(name, {
                            title: 'MENU.' + name,
                            group: true,
                            weight: i
                        });

                        var menuData = _.values(mainMenu);
                        var menuSorted = $filter('orderBy')(menuData, 'sort');
                        angular.forEach(menuSorted, function (m) {
                            msNavigationService.saveItem(name + '.' + m.name, {
                                title: 'MENU.' + m.title,
                                icon: m.icon,
                                custom_name: m.custom_name,
                                state: m.frontend_state ? 'app.site_overview.' + m.frontend_state + '({owner:"' + owner + '"})' : '',
                                weight: m.sort
                            });
                            if (!angular.isUndefined(m.submenu)) {
                                var submenuData = _.values(m.submenu);
                                var submenuSorted = $filter('orderBy')(submenuData, 'sort');
                                angular.forEach(submenuSorted, function (m2) {
                                    msNavigationService.saveItem(name + '.' + m2.name, {
                                        title: 'MENU.' + m2.title,
                                        icon: m2.icon,
                                        state: m2.frontend_state ? 'app.site_overview.' + m2.frontend_state + '({owner:"' + owner + '"})' : '',
                                        weight: m2.sort
                                    });
                                })
                            }
                        })
                    })
                })
                .catch(function (response) {
                    console.log('err: ', response);
                })

        }

        function cleanAllStorage() {
            user = null;
            Object.keys($window.sessionStorage)
                .forEach(function (k) {
                    $window.sessionStorage.removeItem(k);
                });
        }

        function setDefaultDomain(domain, siteID) {
            var deferred = $q.defer();

            var domainStorage = $window.sessionStorage.getItem("domain")
            var domainStorageJson = JSON.parse(domainStorage);

            // var siteID = requestContext.getParam("siteId");
            deferred.resolve();

            if (siteID) {

                user.domain_active = _.find(domains, {
                    'subdomain': siteID
                });
                $window.sessionStorage.setItem("domain", JSON.stringify(user.domain_active));
                setSiteOperative(user.domain_active)
                    .then(function () {
                        deferred.resolve();
                    })
            } else {
                if (_.isEmpty(domainStorage)) {
                    // alert("is empty set:::"+ domain.subdomain)
                    $window.sessionStorage.setItem("domain", JSON.stringify(domain));
                    setSiteOperative(domain)
                        .then(function () {
                            deferred.resolve();
                        })
                } else {
                    console.log(domainStorageJson.id_domain + '-' + domainStorageJson.subdomain)

                    // alert("NOT is empty set:::"+ domainStorageJson.subdomain)

                    setSiteOperative(JSON.parse(domainStorage))
                        .then(function () {
                            deferred.resolve();
                        })
                }
            }
            return (deferred.promise);

        }


        function updateMenu() {
            if (owner) {
                var domainStorage = $window.sessionStorage.getItem("domain")
                var domainStorageJson = JSON.parse(domainStorage);

                getMenu(domainStorageJson)
                    .then(function (resp) {
                        angular.extend(site_operative, resp);
                        setMenu();
                        $rootScope.$emit('site:loadFinished', site_operative);

                    });
            }
        }

        function setActiveDomain(domain) {
            var domainStorage = $window.sessionStorage.getItem("domain")
            // if(_.isEmpty(domainStorage)){
            $window.sessionStorage.setItem("domain", JSON.stringify(domain));
            // setSiteOperative(domain)
            // }
        }

        function changeLanguage(lang_code) {
            if (!lang_code) {
                var langStorage = localStorage.getItem("LANG_CODE");
                if (langStorage) {
                    $translate.use(langStorage);
                }
            } else {
                moment.locale(lang_code);
                console.log(lang_code);
                $translate.use(lang_code);
                localStorage.setItem("LANG_CODE", lang_code);
            }
            updateMenu();
        }

        function getLanguage(lang_code) {
            var langStorage = localStorage.getItem("LANG_CODE");
            if (langStorage) {
                return localStorage.getItem("LANG_CODE");
            } else {
                return $translate.preferredLanguage();
            }
        }

        // I get the data at the given key (or return the given default if the key is undefined).
        function get(key, defaultValue) {

            var localKey = getDataKey(key);

            // If the key exists, return its value.
            if (data.hasOwnProperty(localKey)) {

                return (data[localKey]);

                // If the key doesn't exist, but we have a default value, STORE it and return it.
            } else if (!angular.isUndefined(defaultValue)) {

                data[localKey] = defaultValue;

                return (defaultValue);

            }

        }
        // I get the data at the given key (or return the given default if the key is undefined).
        function getSettings() {
            return (defaultValue);

        }

        function getSiteLanguages() {
            var languagesArray = {};
            angular.forEach(site_operative.languages, function (lang) {
                languagesArray[lang.id_lang] = lang;
            })
            return languagesArray;

        }

        // Set session domain
        function setSiteOperative(domain) {

        }


        function getAlgo() {
            return "YES";
        }

        function setModuleSection(domain) {
            var deferred = $q.defer();
            domain_module_resource.get({
                domain: domain.subdomain,
                resultsPerPage: 1000,
                sortField: 'section',
                sortDir: 'ASC',
                // lang: get("language")
            },
                function (response) {

                    angular.copy(response.data, modulecontent);
                    setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function setActiveSection(sectionName) {
            var deferred = $q.defer();

            var _ActiveSection = _.find(modulecontent, {
                'section': sectionName
            });


            angular.copy(_ActiveSection, ActiveSection);


            deferred.resolve(ActiveSection);

            // Return the promise.
            return (deferred.promise);
        }

        // I get the data key to use in the data-cache look-up. The key is decorated so as not to
        // collide with a standard JavaScript key.
        function getDataKey(key) {

            return ("session__" + key);

        }

        function getUser() {
            return user;
        }

        // I return whether or not the user has been authenticated.
        function isAuthenticated() {

            return (user.isAccountAuthenticated);

        }


        // I store the given value in the session.
        function set(key, value) {

            var localKey = getDataKey(key);
            return (data[localKey] = value);

        }

        function getMediaThumbnailCropformatId() {
            return site_operative.mediaThumbnailCropformatId;
        }

        function getMediaFullCropformatId() {
            return site_operative.mediaFullCropformatId;
        }

        function getCropformatByID(id) {
            return _.find(site_operative.cropformats, {
                'id_cropformats': id
            });
        }


        function getContainerByID(id) {
            return _.find(site_operative.cdnContainers, {
                'id_container': id
            });
        }

        // I reload the authenticated user (if information has changed).
        function update() {

            // Make the request to the server.
            resource.get({},
                function (response) {

                    angular.extend(user, response.account);
                    angular.extend(subscription, response.subscription);

                    // Update the initials and avatar status.
                    user.initials = userService.getInitials(user.name);
                    user.hasSystemAvatar = userService.isSystemAvatar(user.avatarID);

                }
            );

        }

        function getTenant() {
            return msUtils.getTenant();
        }

        function setOwner(newOwner) {
            owner = newOwner
        }


        // -------------------------------------------------- //
        // -------------------------------------------------- //

        var owner = '';

        var menu_resource = $resource(
            COMMON.BASE_API + "/owner/:owner/getMenu", {
            // No default data.
        }, {
            get: {
                method: "GET",
                // isArray: true
            }
        }
        );

        var user_settings_resource = $resource(
            COMMON.BASE_API + "/owner/:owner/getSettings", {
            // No default data.
        }, {
            get: {
                method: "GET",
                //					isArray: true
            }
        }
        );
        var owner_quota_resource = $resource(
            COMMON.BASE_API + "/owner/:owner/getQuota", {
            // No default data.
        }, {
            get: {
                method: "GET",
                //					isArray: true
            }
        }
        );
        var logout_resource = $resource(
            COMMON.BASE_API + "/owner/:owner/logout", {
            // No default data.
        }, {
            post: {
                method: "POST",
                isArray: true
            }
        }
        );
        var loadin_resource = $resource(
            COMMON.BASE_API + "/owner/:owner/loadin", {
            // No default data.
        }, {
            post: {
                method: "POST",
                isArray: true
            }
        }
        );

        var user_settings_resource2 = $resource(
            COMMON.BASE_API + "/owner/:owner/getSettings", {
            // No default data.
        }, {
            get: {
                method: "GET",
                //					isArray: true
            }
        }
        );

        // Store the default authenticating user.
        var user = {
            id: 0,
            files: [],
            companies: [],
            menu: []
        };
        var quota = {
            max_allowed_companies: 0,
            max_allowed_users: 0,
            companies_registered: 0,
            users_registered: 0
        }

        // Store domains for the authenticating user.
        // array()
        var config = {};
        var data = {};

        // -------------------------------------------------- //
        // -------------------------------------------------- //


        // Return the public API.
        return ({
            authenticate: authenticate,
            cleanAllStorage: cleanAllStorage,
            setMenu: setMenu,
            get: get,
            isAuthenticated: isAuthenticated,
            set: set,
            update: update,
            user: user,
            quota: quota,
            setOwner: setOwner,
            getTenant: getTenant,
            updateMenu: updateMenu,
            getOwner: owner,
            getQuota: getQuota,
            logoutLog: logoutLog,
            loadinLog: loadinLog,
            getUser: getUser,
            config: config,
            getSiteLanguages: getSiteLanguages,
            changeLanguage: changeLanguage,
            getLanguage: getLanguage,
        });


    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')



    .service("requestContext", RequestContext);


    // I provide access to the project store.
    /** @ngInject */
    function RequestContext(RenderContext) {

        // Store the injected properties.
        this.RenderContext = RenderContext;

        // Store the current action path.
        this._action = "";

        // Store the action as an array of parts so we can more easily examine parts of it.
        this._sections = [];

        // Store the current route param.
        this._params = {};

        // Store the previous action and route params. We'll use these to make a comparison from
        // one route change to the next.
        this._previousAction = "";
        this._previousParams = {};

        // Return this object reference.
        return (this);

    }


    // Define the instance methods.
    RequestContext.prototype = {

        // I get the current action.
        getAction: function() {

            return (this._action);

        },


        // I get the next section at the given location on the action path.
        getNextSection: function(prefix) {

            // Make sure the prefix is actually in the current action.
            if (!this.startsWith(prefix)) {

                return (null);

                // throw(
                // 	new Error( "Invalid prefix for current action: " + this._action )
                // );

            }

            // If the prefix is empty, return the first section.
            if (prefix === "") {

                return (this._sections[0]);

            }

            // Now that we know the prefix is valid, lets figure out the depth of the current path.
            var depth = prefix.split(".").length;

            // If the depth is out of bounds, meaning the current action doesn't define sections
            // to that path (they are equal), then return null.
            if (depth === this._sections.length) {

                return (null);

            }

            // Return the section.
            return (this._sections[depth]);

        },


        // I return the param with the given name, or null.
        getParam: function(name) {

            return (this._params[name] || null);

        },

        // I return the param with the given name, or null.
        getParams: function() {

            return (this._params || null);

        },


        // I return the param as an int. If the param cannot be returned as an int, the given 
        // default value is returned. If no default value is defined, the return will be zero.
        getParamAsInt: function(name, defaultValue) {

            // Try to parse the number.
            var valueAsInt = parseInt(this.getParam(name));

            // Check to see if the coersion failed. If so, return the default.
            if (isNaN(valueAsInt)) {

                return (defaultValue || 0);

            } else {

                return (valueAsInt);

            }

        },


        // I return the render context for the given action prefix and sub-set of route params.
        getRenderContext: function(requestActionLocation, paramNames) {

            // Default the requestion action.
            requestActionLocation = (requestActionLocation || "");

            // Default the param names. 
            paramNames = (paramNames || []);

            // The param names can be passed in as a single name; or, as an array of names. If a 
            // single name was provided, let's convert it to the array.
            if (!angular.isArray(paramNames)) {

                paramNames = [paramNames];

            }

            return (
                new this.RenderContext(this, requestActionLocation, paramNames)
            );

        },


        // I determine if the action has changed in this particular request context.
        hasActionChanged: function() {

            return (this._action !== this._previousAction);

        },


        // I determine if the given param has changed in this particular request context. This 
        // change comparison can be made against a specific value (paramValue); or, if only the
        // param name is defined, the comparison will be made agains the previous snapshot.
        hasParamChanged: function(paramName, paramValue) {

            // If the param value exists, then we simply want to use that to compare against the
            // current snapshot. 
            if (!angular.isUndefined(paramValue)) {

                return (!this.isParam(paramName, paramValue));

            }

            // If the param was NOT in the previous snapshot, then we'll consider it changing.
            if (!(paramName in this._previousParams) &&
                (paramName in this._params)
            ) {

                return (true);

                // If the param was in the previous snapshot, but NOT in the current, we'll consider 
                // it to be changing.
            } else if (
                (paramName in this._previousParams) &&
                !(paramName in this._params)
            ) {

                return (true);

            }

            // If we made it this far, the param existence has not change; as such, let's compare
            // their actual values.
            return (this._previousParams[paramName] !== this._params[paramName]);

        },


        // I determine if any of the given params have changed in this particular request context.
        haveParamsChanged: function(paramNames) {

            for (var i = 0, length = paramNames.length; i < length; i++) {

                if (this.hasParamChanged(paramNames[i])) {

                    // If one of the params has changed, return true - no need to continue checking
                    // the other parameters.
                    return (true);

                }

            }

            // If we made it this far then none of the params have changed.
            return (false);

        },


        // I check to see if the given param is still the given value.
        isParam: function(paramName, paramValue) {

            // When comparing, using the coersive equals since we may be comparing parsed value 
            // against non-parsed values.
            if (
                (paramName in this._params) &&
                (this._params[paramName] == paramValue)
            ) {

                return (true);

            }

            // If we made it this far then param is either a different value; or, is no longer 
            // available in the route.
            return (false);

        },


        // I set the new request context conditions.
        setContext: function(action, routeParams) {

            // Copy the current action and params into the previous snapshots.
            this._previousAction = this._action;
            this._previousParams = this._params;

            // Set the action.
            if (!_.isUndefined(action)) {
                this._action = action;


                // Split the action to determine the sections.
                this._sections = action.split(".");
            }

            // Update the params collection.
            this._params = angular.copy(routeParams);

        },


        // I determine if the current action starts with the given path.
        startsWith: function(prefix) {

            // When checking, we want to make sure we don't match partial sections for false
            // positives. So, either it matches in entirety; or, it matches with an additional
            // dot at the end.
            if (!prefix.length ||
                (this._action === prefix) ||
                (this._action.indexOf(prefix + ".") === 0)
            ) {

                return (true);

            }

            return (false);

        }

    };


})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .value("RenderContext", RenderContext);


    // I provide a proxy to the render conditions that understands a given request action and set
    // of param names and can negotiate when a change needs to be processed.
    /** @ngInject */
    function RenderContext(requestContext, actionPrefix, paramNames) {

        // Store the injected properties.
        this._requestContext = requestContext;
        this._actionPrefix = actionPrefix;
        this._paramNames = paramNames;

        // Return this object reference.
        return (this);

    }


    // Define the instance methods.
    RenderContext.prototype = {

        // I return the next section after the location being watched.
        getNextSection: function() {

            return (
                this._requestContext.getNextSection(this._actionPrefix)
            );

        },


        // I check to see if the action has changed (and is local to the current location).
        isChangeLocal: function() {

            return (
                this._requestContext.startsWith(this._actionPrefix)
            );

        },


        // I determine if the last change in the request context is relevant to the action and route
        // params being observed in this render context.
        isChangeRelevant: function() {

            // If the action is not local to the action prefix, then we don't even want to bother
            // checking the params.
            if (!this._requestContext.startsWith(this._actionPrefix)) {

                return (false);

            }

            // If the action has changed, we don't need to bother checking the params.
            if (this._requestContext.hasActionChanged()) {

                return (true);

            }

            // If we made it this far, we know that the action has not changed. As such, we''ll 
            // have to make the change determination based on the observed parameters.
            return (
                this._paramNames.length &&
                this._requestContext.haveParamsChanged(this._paramNames)
            );

        }

    };

})();
(function () {
    'use strict';
    angular
        .module('app.core')
        .factory('msUtils', msUtils)
        .provider('msUtil', msUtilsProvider);


    //////////
    //////////
    var firstTLDs = "ac|ad|ae|af|online|ag|ai|al|am|an|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|be|bf|bg|bh|bi|bj|bm|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|cl|cm|cn|co|cr|cu|cv|cw|cx|cz|de|dj|dk|dm|do|dz|ec|ee|eg|es|et|eu|fi|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|im|in|io|iq|ir|is|it|je|jo|jp|kg|ki|km|kn|kp|kr|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mk|ml|mn|mo|mp|mq|mr|ms|mt|mu|mv|mw|mx|my|na|nc|ne|nf|ng|nl|no|nr|nu|nz|om|pa|pe|pf|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ro|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|st|su|sv|sx|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tp|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|yt".split('|');
    var secondTLDs = "com|edu|gov|online|net|mil|org|nom|sch|caa|res|off|gob|int|tur|ip6|uri|urn|asn|act|nsw|qld|tas|vic|pro|biz|adm|adv|agr|arq|art|ato|bio|bmd|cim|cng|cnt|ecn|eco|emp|eng|esp|etc|eti|far|fnd|fot|fst|g12|ggf|imb|ind|inf|jor|jus|leg|lel|mat|med|mus|not|ntr|odo|ppg|psc|psi|qsl|rec|slg|srv|teo|tmp|trd|vet|zlg|web|ltd|sld|pol|fin|k12|lib|pri|aip|fie|eun|sci|prd|cci|pvt|mod|idv|rel|sex|gen|nic|abr|bas|cal|cam|emr|fvg|laz|lig|lom|mar|mol|pmn|pug|sar|sic|taa|tos|umb|vao|vda|ven|mie|北海道|和歌山|神奈川|鹿児島|ass|rep|tra|per|ngo|soc|grp|plc|its|air|and|bus|can|ddr|jfk|mad|nrw|nyc|ski|spy|tcm|ulm|usa|war|fhs|vgs|dep|eid|fet|fla|flå|gol|hof|hol|sel|vik|cri|iwi|ing|abo|fam|gok|gon|gop|gos|aid|atm|gsm|sos|elk|waw|est|aca|bar|cpa|jur|law|sec|plo|www|bir|cbg|jar|khv|msk|nov|nsk|ptz|rnd|spb|stv|tom|tsk|udm|vrn|cmw|kms|nkz|snz|pub|fhv|red|ens|nat|rns|rnu|bbs|tel|bel|kep|nhs|dni|fed|isa|nsn|gub|e12|tec|орг|обр|упр|alt|nis|jpn|mex|ath|iki|nid|gda|inc".split('|');

    function removeSubdomain(s) {
        s = s.replace(/^www\./, '');
        var parts;
        while (subDomain(s)) {
            parts = s.split('.');
            parts.shift();
            s = parts.join('.');
        }

        if (!parts) {
            parts = s.split('.');
        }
        while (parts.length > 3) {
            parts.shift();
        }

        if (parts.length === 3 && ((parts[1].length > 2 && parts[2].length > 2) || (secondTLDs.indexOf(parts[1]) === -1) && firstTLDs.indexOf(parts[2]) === -1)) {
            parts.shift();
        }

        return parts.join('.');
    };

    function subDomain(url) {

        // IF THERE, REMOVE WHITE SPACE FROM BOTH ENDS
        url = url.replace(new RegExp(/^\s+/), ""); // START
        url = url.replace(new RegExp(/\s+$/), ""); // END

        // IF FOUND, CONVERT BACK SLASHES TO FORWARD SLASHES
        url = url.replace(new RegExp(/\\/g), "/");

        // IF THERE, REMOVES 'http://', 'https://' or 'ftp://' FROM THE START
        url = url.replace(new RegExp(/^http\:\/\/|^https\:\/\/|^ftp\:\/\//i), "");

        // IF THERE, REMOVES 'www.' FROM THE START OF THE STRING
        url = url.replace(new RegExp(/^www\./i), "");
        url = url.replace(".online", "");

        // REMOVE COMPLETE STRING FROM FIRST FORWARD SLASH ON
        url = url.replace(new RegExp(/\/(.*)/), "");

        // REMOVES '.??.??' OR '.???.??' FROM END - e.g. '.CO.UK', '.COM.AU'
        if (url.match(new RegExp(/\.[a-z]{2,3}\.[a-z]{2}$/i))) {
            url = url.replace(new RegExp(/\.[a-z]{2,3}\.[a-z]{2}$/i), "");

            // REMOVES '.??' or '.???' or '.????' FROM END - e.g. '.US', '.COM', '.INFO'
        } else if (url.match(new RegExp(/\.[a-z]{2,4}$/i))) {
            url = url.replace(new RegExp(/\.[a-z]{2,4}$/i), "");
        }

        // CHECK TO SEE IF THERE IS A DOT '.' LEFT IN THE STRING
        var subDomain = (url.match(new RegExp(/\./g))) ? true : false;

        return (subDomain);

    }

    function getTenant() {
        let tenant = '';
        // let domainUrl = removeSubdomain(window.location.href);
        // let domainUrl = removeSubdomain('https://garberipenal.h2c.online');
        let domainUrl = removeSubdomain(window.location.hostname);
        if (domainUrl == 'h2c.app' || domainUrl == 'h2c.online' || domainUrl == 'localhost') {
            var hostSplited = window.location.hostname.split('.');
            if ((hostSplited.length >= 2 && hostSplited[1] == 'h2c' || hostSplited[1] == 'localhost') && hostSplited[0] != 'www') {
                tenant = hostSplited[0];
            }
            if (localStorage.getItem('mocktenant')) {
                tenant = localStorage.getItem('mocktenant');
            }
        }
        else {
            tenant = domainUrl.split('.')[0];
        }
        return tenant;
    }


    function getTenantTranslate(url) {
        const branding = getBranding();
        if (branding.i18n) {
            var request = new XMLHttpRequest();
            request.open('HEAD', url + branding.i18n + '/i18n/es.json', false);
            request.send();
            if (request.status == 200) {
                return branding.i18n
            }
        }
        return null;
    }

    function getBranding(tenantOverride) {
        let tenant = tenantOverride || getTenant();
        let branding = {};
        switch (tenant) {
            case 'test':
                branding = {
                    tenant: 'test',
                    companyname: 'Fligh Track',
                    navigationColorBorder: '#900529',
                    accentColor: '#a9002c',
                    sidenav: '#000000',
                    favicon: 'assets/icons/logos/h2c.ico',
                    logoLogin: 'assets/images/logos/h2c-check.png',
                    logo: 'assets/images/logos/h2c-check.png',
                    sublogo: 'assets/images/logos/h2c.png',
                    loginBackground: '/assets/images/backgrounds/homeh2c.jpg',
                    dashboardBackground: '/assets/images/backgrounds/homeh2c.jpg',
                    customform: [{ file: 'es_checklistgnloculto', name: 'Check-Lis' }]
                }
                break;
            case 'beguardian':
            case 'guardian':
                branding = {
                    tenant: 'guardian',
                    companyname: 'Guardian',
                    navBackgroundLogoColor: '#f5f5f5',
                    navIconcollapseColor: '#232323',
                    navigationColorBorder: '#2cac84',
                    accentColor: '#2cac84',
                    accentColorFont: '#FFFFFF',
                    sidenav: '#232323',
                    favicon: 'assets/images/logos/guardian-login.png',
                    logoLogin: 'assets/images/logos/guardian-login.png',
                    logo: 'assets/images/logos/guardian-A.png',
                    sublogo: 'assets/images/logos/guardian-B.png',
                    loginBackground: '/assets/images/backgrounds/guardian-background.jpg',
                    dashboardBackground: '/assets/images/backgrounds/homeh2c.jpg',
                    i18n: 'guardian',
                    hideDefaultForms : true,
                    customform: [{ file: 'es_guardian', name: 'Español' }, { file: 'en_guardian', name: 'English' }, { file: 'de_guardian', name: 'German' }, { file: 'ca_guardian', name: 'Català' }]
                }
                break;
            case 'vigia':
                branding = {
                    tenant: 'vigia',
                    companyname: 'Vigia',
                    navBackgroundLogoColor: '#f5f5f5',
                    navIconcollapseColor: '#232323',
                    navigationColorBorder: '#2cac84',
                    accentColor: '#2cac84',
                    accentColorFont: '#FFFFFF',
                    sidenav: '#232323',
                    favicon: 'assets/images/logos/vigia-login.png',
                    logoLogin: 'assets/images/logos/vigia-login.png',
                    logo: 'assets/images/logos/vigia-A.png',
                    loginBackground: '/assets/images/backgrounds/guardian-background.jpg',
                    dashboardBackground: '/assets/images/backgrounds/homeh2c.jpg',
                    i18n: 'guardian',
                    hideDefaultForms : true,
                    customform: [{ file: 'es_guardian', name: 'Español' }, { file: 'en_guardian', name: 'English' }, { file: 'de_guardian', name: 'German' }]
                }
                break;
            case 'c2vid':
            case 'tias':
                branding = {
                    tenant: 'c2vid',
                    companyname: 'C2vid',
                    navBackgroundLogoColor: '#f5f5f5',
                    navIconcollapseColor: '#000000',
                    navigationColorBorder: '#782c2c',
                    accentColor: '#782c2c',
                    accentColorFont: '#FFFFFF',
                    sidenav: '#f5f5f5',
                    favicon: 'assets/images/logos/C2vid-login.png',
                    logoLogin: 'assets/images/logos/C2vid-login.png',
                    logo: 'assets/images/logos/C2vid-A.png',
                    sublogo: 'assets/images/logos/C2vid-B.png',
                    loginBackground: '/assets/images/backgrounds/C2vid-background.jpg',
                    dashboardBackground: '/assets/images/backgrounds/homeh2c.jpg',
                    hideDefaultForms : true,
                    i18n: 'covid',
                    customform: [{ file: 'es_covid', name: 'Español' }, { file: 'es_covidavanzado', name: 'Español Avanzado' }]
                }
                break;
            case 'cumplenorm':
            case 'canalcumplenorm':
            case 'compliancecumplenorm':
                branding = {
                    tenant: 'cumplenorm',
                    companyname: 'Cumplenorm',
                    navBackgroundLogoColor: '#f5f5f5',
                    navIconcollapseColor: '#000000',
                    navigationColorBorder: '#485463',
                    accentColor: '#485463',
                    accentColorFont: '#FFFFFF',
                    sidenav: '#f5f5f5',
                    favicon: 'assets/images/logos/cumplenorm-login.png',
                    logoLogin: 'assets/images/logos/cumplenorm-login.png',
                    logo: 'assets/images/logos/cumplenorm-A.png',
                    sublogo: 'assets/images/logos/cumplenorm-B.png',
                    loginBackground: '/assets/images/backgrounds/cumplenorm-background.jpg',
                    dashboardBackground: '/assets/images/backgrounds/homeh2c.jpg',
                    hideDefaultForms : false
                }
                break;
            case 'vi2gen':
                branding = {
                    tenant: 'vi2gen',
                    companyname: 'Vi2gen',
                    navBackgroundLogoColor: '#f5f5f5',
                    navIconcollapseColor: '#2A0055',
                    navigationColorBorder: '#6a41c1',
                    accentColor: '#6a41c1',
                    accentColorFont: '#1C3845',
                    sidenav: '#f5f5f5',
                    favicon: 'assets/images/logos/vi2gen-login.png',
                    logoLogin: 'assets/images/logos/vi2gen-login.png',
                    logo: 'assets/images/logos/vi2gen-A.png',
                    sublogo: 'assets/images/logos/vi2gen-B.png',
                    loginBackground: '/assets/images/backgrounds/vi2gen-1-min.gif',
                    dashboardBackground: '/assets/images/backgrounds/homeh2c.jpg',
                    hideDefaultForms : true,
                    i18n: 'vi2gen',
                    customform: [{ file: 'es_vi2genavanzado', name: 'Español Avanzado' }, { file: 'es_vi2genexpedientes', name: 'Expedientes' },]
                }
                break;
            case 'alertaokupa':
                branding = {
                    tenant: 'alertaokupa',
                    companyname: 'AlertaOkupa',
                    navBackgroundLogoColor: '#f5f5f5',
                    navIconcollapseColor: '#000000',
                    navigationColorBorder: '#fdaa5f',
                    accentColor: '#fdaa5f',
                    accentColorFont: '#1C3845',
                    sidenav: '#f5f5f5',
                    favicon: 'assets/images/logos/alertaokupa-login.png',
                    logoLogin: 'assets/images/logos/alertaokupa-login.png',
                    logo: 'assets/images/logos/alertaokupa-A.png',
                    sublogo: 'assets/images/logos/alertaokupa-B.png',
                    loginBackground: '/assets/images/backgrounds/alertaportada.png',
                    dashboardBackground: '/assets/images/backgrounds/homealertaokupa.png',
                    hideDefaultForms : true,
                    i18n: 'vi2gen',
                    customform: [{ file: 'es_alertaokupa', name: 'Español' },]
                }
                break;
            case 'sroipruebas':
                branding = {
                    tenant: 'sroipruebas',
                    companyname: 'SROI',
                    navBackgroundLogoColor: '#f5f5f5',
                    navIconcollapseColor: '#2A0055',
                    navigationColorBorder: '#6a41c1',
                    accentColor: '#6a41c1',
                    accentColorFont: '#1C3845',
                    sidenav: '#f5f5f5',
                    favicon: 'assets/images/logos/sroi-login.png',
                    logoLogin: 'assets/images/logos/sroi-login.png',
                    logo: 'assets/images/logos/sroi-A.png',
                    sublogo: 'assets/images/logos/sroi-B.png',
                    loginBackground: '/assets/images/backgrounds/sroi.jpeg',
                    dashboardBackground: '/assets/images/backgrounds/sroi2.jpeg',
                    hideDefaultForms : true,
                    i18n: 'sroi'
                }
                break;
            case 'pcruz':
                branding = {
                    tenant: 'pcruz',
                    companyname: 'Centro Municipal de las Mujeres',
                    navBackgroundLogoColor: '#f5f5f5',
                    navIconcollapseColor: '#17006a',
                    navigationColorBorder: '#17006a',
                    accentColor: '#17006a',
                    accentColorFont: '#f5f5f5',
                    sidenav: '#f5f5f5',
                    favicon: 'assets/images/logos/pcruz-login.png',
                    logoLogin: 'assets/images/logos/pcruz-login.png',
                    logo: 'assets/images/logos/pcruz-A.png',
                    sublogo: 'assets/images/logos/pcruz-B.png',
                    loginBackground: '/assets/images/backgrounds/vi2gen-1-min.gif',
                    dashboardBackground: '/assets/images/backgrounds/homeh2c.jpg',
                    hideDefaultForms : true,
                    i18n: 'vi2gen',
                    customform: [{ file: 'es_vi2genavanzado', name: 'Español Avanzado' }]
                }
                break;
            case 'terrinches':
                branding = {
                    tenant: 'terrinches',
                    companyname: 'Vi2gen',
                    navBackgroundLogoColor: '#e51a4c',
                    navIconcollapseColor: '#2A0055',
                    navigationColorBorder: '#e51a4c',
                    accentColor: '#e51a4c',
                    accentColorFont: '#ffffff',
                    sidenav: '#f5f5f5',
                    favicon: 'assets/images/logos/terrinches-login.png',
                    logoLogin: 'assets/images/logos/terrinches-login.png',
                    logo: 'assets/images/logos/terrinches-A.png',
                    sublogo: 'assets/images/logos/terrinches-B.png',
                    loginBackground: '/assets/images/backgrounds/vi2gen-1-min.gif',
                    dashboardBackground: '/assets/images/backgrounds/homeh2c.jpg',
                    hideDefaultForms : true,
                    i18n: 'vi2gen',
                    customform: [{ file: 'es_vi2genavanzado', name: 'Español Avanzado' }]
                }
                break;
            case 'cuentaconmigo':
                branding = {
                    tenant: 'cuentaconmigo',
                    companyname: 'Vi2gen',
                    navBackgroundLogoColor: '#f5f5f5',
                    navIconcollapseColor: '#2A0055',
                    navigationColorBorder: '#6a41c1',
                    accentColor: '#6a41c1',
                    accentColorFont: '#1C3845',
                    sidenav: '#f5f5f5',
                    favicon: 'assets/images/logos/cuentaconmigo-login.png',
                    logoLogin: 'assets/images/logos/cuentaconmigo-login.png',
                    logo: 'assets/images/logos/cuentaconmigo-A.png',
                    sublogo: 'assets/images/logos/cuentaconmigo-B.png',
                    loginBackground: '/assets/images/backgrounds/fondo_Vi2gen_Adeje-01.png',
                    dashboardBackground: '/assets/images/backgrounds/homeh2c.jpg',
                    hideDefaultForms : true,
                    i18n: 'vi2gen',
                    customform: [{ file: 'es_vi2genavanzado', name: 'Español Avanzado' }]
                }
                break;
            case 'claro':
                branding = {
                    tenant: 'claro',
                    companyname: 'Claro',
                    navBackgroundLogoColor: '#f5f5f5',
                    navIconcollapseColor: '#000000',
                    navigationColorBorder: '#da291c',
                    navigationColorBorder: '#a7a8aa',
                    accentColor: '#a7a8aa',
                    accentColorFont: '#FFFFFF',
                    sidenav: '#2d2926',
                    favicon: 'assets/images/logos/claro-login.png',
                    logoLogin: 'assets/images/logos/claro-login.png',
                    logo: 'assets/images/logos/claro-A.png',
                    loginBackground: '/assets/images/backgrounds/header-bg-old.png',
                    dashboardBackground: '/assets/images/backgrounds/homeh2c.jpg'
                }
                break;
            case 'ethical':
            case 'ethicalgrc':
                branding = {
                    tenant: 'ethical',
                    companyname: 'Ethical',
                    navBackgroundLogoColor: '#f5f5f5',
                    navIconcollapseColor: '#000000',
                    navigationColorBorder: '#568b44',
                    accentColor: '#568b44',
                    accentColorFont: '#FFFFFF',
                    sidenav: '#FFFFFF',
                    favicon: 'assets/images/logos/ethical-login.png',
                    logoLogin: 'assets/images/logos/ethical-login.png',
                    logo: 'assets/images/logos/ethical-A.png',
                    sublogo: 'assets/images/logos/ethical-B.png',
                    loginBackground: '/assets/images/backgrounds/ethical-background.jpeg',
                    dashboardBackground: '/assets/images/backgrounds/homeh2c.jpg'
                }
                break;
            case 'garberipenal':
                branding = {
                    tenant: 'garberipenal',
                    companyname: 'Garberi Penal',
                    navigationColorBorder: '#B48F5A',
                    accentColor: '#B48F5A',
                    sidenav: '#2d323e',
                    favicon: 'assets/icons/logos/garberi-logo1.png',
                    logoLogin: 'assets/icons/logos/garberi-logo1.png',
                    logo: 'assets/icons/logos/garberi-logo1.png',
                    sublogo: 'assets/icons/logos/garberi-logo2.png',
                    loginBackground: '/assets/images/backgrounds/garberi-background-login.jpg',
                    dashboardBackground: '/assets/images/backgrounds/homeh2c.jpg'
                }
                break;
            case 'smc':
            case 'smccompliance':
            case 'canalsmc':
                branding = {
                    tenant: 'smc',
                    companyname: 'SMC COMPLIANCE',
                    navigationColorBorder: '#8596a3',
                    accentColor: '#8596a3',
                    sidenav: '#2d323e',
                    favicon: 'assets/images/logos/smc-A.png',
                    logoLogin: 'assets/images/logos/smc-A.png',
                    logo: 'assets/images/logos/smc-A.png',
                    sublogo: 'assets/images/logos/smc-B.png',
                    loginBackground: '/assets/images/backgrounds/smc-background.jpg',
                    dashboardBackground: '/assets/images/backgrounds/homeh2c.jpg'
                }
                break;
            case 'etthico':
                branding = {
                    tenant: 'etthico',
                    companyname: 'etth!co',
                    navBackgroundLogoColor: '#ffffff',
                    navIconcollapseColor: '#1a1a1a',
                    navigationColorBorder: '#d06561',
                    accentColor: '#d06561',
                    accentColorFont: '#ffffff',
                    sidenav: '#f5f5f5',
                    favicon: 'assets/images/logos/etthico-favicon.png',
                    logoLogin: 'assets/images/logos/etthico-login.png',
                    logo: 'assets/images/logos/etthico-A.png',
                    sublogo: 'assets/images/logos/etthico-B.png',
                    loginBackground: '/assets/images/backgrounds/header-bg-old.png',
                    dashboardBackground: '/assets/images/backgrounds/homeh2c.jpg',
                    customform: [{ file: 'en_etthico', name: 'English etthico' }]
                }
                break;
            case 'cpc':
                branding = {
                    tenant: 'cpc',
                    companyname: 'cpc',
                    navBackgroundLogoColor: '#f5f5f5',
                    navIconcollapseColor: '#1a1a1a',
                    navigationColorBorder: '#f9b500',
                    accentColor: '#f9b500',
                    accentColorFont: '#ffffff',
                    sidenav: '#f5f5f5',
                    favicon: 'assets/images/logos/cpc-favicon.png',
                    logoLogin: 'assets/images/logos/cpc-login.png',
                    logo: 'assets/images/logos/cpc-A.png',
                    sublogo: 'assets/images/logos/cpc-B.png',
                    loginBackground: '/assets/images/backgrounds/cpc-background.jpg',
                    dashboardBackground: '/assets/images/backgrounds/homeh2c.jpg'
                }
                break;
            case 'btconsulting':
            case 'bakertilly':
            case 'bakertillyec':
                branding = {
                    tenant: 'bakertilly',
                    companyname: 'Bakertilly',
                    navigationColorBorder: '#d7fa39',
                    accentColor: '#d7fa39',
                    accentColorFont: '#000000',
                    sidenav: '#000000',
                    favicon: 'assets/images/logos/logobakertilly-login.png',
                    logoLogin: 'assets/images/logos/logobakertilly-login.png',
                    logo: 'assets/images/logos/logobakertilly-A.png',
                    sublogo: 'assets/images/logos/logobakertilly-B.png',
                    loginBackground: '/assets/images/backgrounds/bakertilly-background.jpg',
                    dashboardBackground: '/assets/images/backgrounds/homeh2c.jpg'
                }
                break;
            case 'brg':
                branding = {
                    tenant: 'brg',
                    companyname: 'BRG',
                    navigationColorBorder: '#2FBDE5',
                    accentColor: '#2FBDE5',
                    accentColorFont: '#FFFFFF',
                    sidenav: '#2d323e',
                    favicon: 'assets/images/logos/brg-login.png',
                    logoLogin: 'assets/images/logos/brg-login.png',
                    logo: 'assets/images/logos/brg-A.png',
                    sublogo: 'assets/images/logos/brg-B.png',
                    loginBackground: '/assets/images/backgrounds/brg-background.jpg',
                    dashboardBackground: '/assets/images/backgrounds/homeh2c.jpg'
                }
                break;
            case 'risktest':
            case 'bst':
            case 'consulting':
                branding = {
                    tenant: 'risktest',
                    companyname: 'BST Global Consulting',
                    navigationColorBorder: '#009345',
                    accentColor: '#009345',
                    accentColorFont: '#FFFFFF',
                    sidenav: '#000',
                    favicon: 'assets/images/logos/bst-login.png',
                    logoLogin: 'assets/images/logos/bst-login.png',
                    logo: 'assets/images/logos/bst-A.png',
                    sublogo: 'assets/images/logos/bst-B.png',
                    loginBackground: '/assets/images/backgrounds/bst-background.png',
                    dashboardBackground: '/assets/images/backgrounds/homeh2c.jpg'
                }
                break;
            case 'b2compliance':
                branding = {
                    tenant: 'b2compliance',
                    companyname: 'b2compliance',
                    navigationColorBorder: '#2b80b5',
                    accentColor: '#2b80b5',
                    accentColorFont: '#FFFFFF',
                    sidenav: '#f5f5f5',
                    favicon: 'assets/images/logos/b2compliance-login.png',
                    logoLogin: 'assets/images/logos/b2compliance-login.png',
                    logo: 'assets/images/logos/b2compliance-A.png',
                    sublogo: 'assets/images/logos/b2compliance-B.png',
                    loginBackground: '/assets/images/backgrounds/garberi-background-login.jpg',
                    dashboardBackground: '/assets/images/backgrounds/homeh2c.jpg'
                }
                break;
            case 'canalnormon':
                branding = {
                    tenant: 'canalnormon',
                    companyname: 'Normon',
                    navBackgroundLogoColor: '#f5f5f5',
                    navIconcollapseColor: '#00336d',
                    navigationColorBorder: '#009de0',
                    accentColor: '#009de0',
                    accentColorFont: '#FFFFFF',
                    sidenav: '#00336d',
                    favicon: 'assets/images/logos/normon-login.png',
                    logoLogin: 'assets/images/logos/normon-login.png',
                    logo: 'assets/images/logos/normon-A.png',
                    sublogo: 'assets/images/logos/normon-B.png',
                    loginBackground: '/assets/images/backgrounds/garberi-background-login.jpg',
                    dashboardBackground: '/assets/images/backgrounds/homeh2c.jpg'
                }
                break;
            case 'gnl':
            case 'gnlcompliance':
                branding = {
                    tenant: 'gnlcompliance',
                    companyname: 'GNL Comply',
                    navigationColorBorder: '#0b5099',
                    accentColor: '#0b5099',
                    sidenav: '#000',
                    favicon: 'assets/images/logos/gnl-login.png',
                    logoLogin: 'assets/images/logos/gnl-login.png',
                    logo: 'assets/images/logos/gnl-A.png',
                    sublogo: 'assets/images/logos/gnl-B.png',
                    loginBackground: '/assets/images/backgrounds/gnl-background.jpg',
                    dashboardBackground: '/assets/images/backgrounds/homeh2c.jpg',
                    i18n: 'gnl',
                    hideDefaultForms: false,
                    customform: [{ file: 'ss_gnl_1', name: 'Directivos' }, { file: 'es_gnl_2', name: 'Empleados' }, { file: 'es_checklistgnl', name: 'Check-List' }, { file: 'it', name: 'Italiano' }, { file: 'fr', name: 'Francés' }]
                }
                break;
            case 'rapinformes':
            case 'canalrapinformes':
                branding = {
                    tenant: 'rapinformes',
                    companyname: 'Rapinformes',
                    navigationColorBorder: '#003c4c',
                    accentColor: '#003c4c',
                    accentColorFont: '#f7b334',
                    sidenav: '#fffff',
                    favicon: 'assets/images/logos/rapinformes-favicon.ico',
                    logoLogin: 'assets/images/logos/rapinformes-login.png',
                    logo: 'assets/images/logos/rapinformes-A.png',
                    sublogo: 'assets/images/logos/rapinformes-B.png',
                    loginBackground: '/assets/images/backgrounds/fondo-rapinformes.png',
                    dashboardBackground: '/assets/images/backgrounds/homeh2c.jpg',
                    hideDefaultForms: false,
                    customform: [{ file: 'es_rapinformes', name: 'Rapinformes (Español)' }, { file: 'es_rapinformescanal', name: 'Rapinformes canal denuncias' }, { file: 'es_rapinformesacoso', name: 'Rapinformes Acoso' }]
                }
                break;
            case 'pons':
                branding = {
                    tenant: 'pons',
                    companyname: 'Pons Compliance',
                    navigationColorBorder: '#003c4c',
                    accentColor: '#1d1d1d',
                    accentColorFont: '#ffffff',
                    sidenav: '#fffff',
                    favicon: 'assets/images/logos/pons-login.png',
                    logoLogin: 'assets/images/logos/pons-login.png',
                    logo: 'assets/images/logos/pons-A.png',
                    sublogo: 'assets/images/logos/pons-B.png',
                    loginBackground: '/assets/images/backgrounds/pons-background.png',
                    dashboardBackground: '/assets/images/backgrounds/pons-background-home.png'
                }
                break;
            case 'maat':
                branding = {
                    tenant: 'maat',
                    companyname: 'Maat Compliance and Ethical',
                    navigationColorBorder: '#f79133',
                    navIconcollapseColor: '#f79133',
                    accentColor: '#f79133',
                    accentColorFont: '#ffffff',
                    sidenav: '#fffff',
                    favicon: 'assets/images/logos/mat-favicon.ico',
                    logoLogin: 'assets/images/logos/maat-login.png',
                    logo: 'assets/images/logos/maat-A.png',
                    sublogo: 'assets/images/logos/maat-B.png',
                    loginBackground: '/assets/images/backgrounds/fondo-maat.jpg',
                    dashboardBackground: '/assets/images/backgrounds/fondo-maat.jpg'
                }
                break;
            case 'sroi':
                branding = {
                    tenant: 'sroi',
                    companyname: 'H2C',
                    navigationColorBorder: '#89e4df',
                    accentColor: '#89e4df',
                    sidenav: '#ffffff',
                    favicon: 'assets/images/logos/sroi-A.png',
                    logoLogin: 'assets/images/logos/sroi-A.png',
                    logo: 'assets/images/logos/sroi-A.png',
                    sublogo: 'assets/images/logos/sroi-B.png',
                    loginBackground: '/assets/images/backgrounds/homesroi.jpg',
                    dashboardBackground: '/assets/images/backgrounds/homesroi.jpg'
                }
                break;
            case 'adabogados':
                branding = {
                    tenant: 'adabogados',
                    companyname: 'AD Abogados',
                    navigationColorBorder: '#afafaf',
                    accentColor: '#afafaf',
                    sidenav: '#ffffff',
                    favicon: 'assets/images/logos/ada-A.png',
                    logoLogin: 'assets/images/logos/ada-A.png',
                    logo: 'assets/images/logos/ada-A.png',
                    sublogo: 'assets/images/logos/ada-B.png',
                    loginBackground: '/assets/images/backgrounds/fondo-ada.jpg',
                    dashboardBackground: '/assets/images/backgrounds/fondo-ada.jpg'
                }
                break;
            case 'prodat':
            case 'prodat-cyl':
            case 'prodat-cat':
            case 'prodat-val':
            case 'prodat-ext':
            case 'prodat-cantabria':
            case 'prodat-principado':
            case 'prodat-malaga':
            case 'prodat-galicia':
            case 'prodat-euskadi':
                branding = {
                    tenant: 'prodat',
                    companyname: 'Prodat',
                    navigationColorBorder: '#006dca',
                    navIconcollapseColor: '#006dca',
                    accentColor: '#006dca',
                    sidenav: '#ffffff',
                    favicon: 'assets/images/logos/prodat-favicon.ico',
                    logoLogin: 'assets/images/logos/prodat-login.png',
                    logo: 'assets/images/logos/prodat-A.png',
                    sublogo: 'assets/images/logos/prodat-B.png',
                    loginBackground: '/assets/images/backgrounds/brg-background.jpg',
                    dashboardBackground: '/assets/images/backgrounds/brg-background.jpg',
                    hideDefaultForms: false,
                    customform: [{ file: 'es_prodat', name: 'Prodat (ES)' }]
                }
                break;
            case 'apdtic':
                branding = {
                    tenant: 'apdtic',
                    companyname: 'APDTIC',
                    navBackgroundLogoColor: '#f5f5f5',
                    navIconcollapseColor: '#cd0d36',
                    navigationColorBorder: '#cd0d36',
                    accentColor: '#cd0d36',
                    accentColorFont: '#FFFFFF',
                    sidenav: '#f5f5f5',
                    favicon: 'assets/images/logos/apdtic-favicon.ico',
                    logoLogin: 'assets/images/logos/apdtic-login.png',
                    logo: 'assets/images/logos/apdtic-A.png',
                    sublogo: 'assets/images/logos/apdtic-B.png',
                    loginBackground: '/assets/images/backgrounds/apdtic-background.png',
                    dashboardBackground: '/assets/images/backgrounds/apdtic-background.png'
                }
                break;
            case 'northcompliance':
                branding = {
                    tenant: 'northcompliance',
                    companyname: 'North Compliance',
                    navBackgroundLogoColor: '#f5f5f5',
                    navIconcollapseColor: '#cd0d36',
                    navigationColorBorder: '#cd0d36',
                    accentColor: '#cd0d36',
                    accentColorFont: '#FFFFFF',
                    sidenav: '#f5f5f5',
                    favicon: 'assets/images/logos/nc-favicon.ico',
                    logoLogin: 'assets/images/logos/nc-login.png',
                    logo: 'assets/images/logos/nc-A.png',
                    sublogo: 'assets/images/logos/nc-B.png',
                    loginBackground: '/assets/images/backgrounds/nc-background.png',
                    dashboardBackground: '/assets/images/backgrounds/nc-background.png'
                }
                break;
            case 'ethicalreport':
            case 'ethical-report':
                branding = {
                    tenant: 'ethical-report',
                    companyname: 'Ethical Report',
                    navBackgroundLogoColor: '#f5f5f5',
                    navIconcollapseColor: '#473ea0',
                    navigationColorBorder: '#fca92e',
                    accentColor: '#fca92e',
                    accentColorFont: '#FFFFFF',
                    sidenav: '#f5f5f5',
                    favicon: 'assets/images/logos/ethicalreport-favicon.ico',
                    logoLogin: 'assets/images/logos/ethicalreport-login.png',
                    logo: 'assets/images/logos/ethicalreport-A.png',
                    sublogo: 'assets/images/logos/ethicalreport-B.png',
                    loginBackground: '/assets/images/backgrounds/ethicalreport-background.png',
                    dashboardBackground: '/assets/images/backgrounds/ethicalreport-background.png'
                }
                break;
            case 'i-cumplimiento':
                branding = {
                    tenant: 'i-cumplimiento',
                    companyname: 'Innovación y Cumplimiento',
                    navBackgroundLogoColor: '#f5f5f5',
                    navIconcollapseColor: '#273878',
                    navigationColorBorder: '#273878',
                    accentColor: '#273878',
                    accentColorFont: '#FFFFFF',
                    sidenav: '#f5f5f5',
                    favicon: 'assets/images/logos/i-cumplimiento-favicon.ico',
                    logoLogin: 'assets/images/logos/i-cumplimiento-login.png',
                    logo: 'assets/images/logos/i-cumplimiento-A.png',
                    //sublogo: 'assets/images/logos/ethicalreport-B.png',
                    loginBackground: '/assets/images/backgrounds/i-cumplimiento-background.jpg',
                    dashboardBackground: '/assets/images/backgrounds/i-cumplimiento-background.jpg'
                }
                break;
            case 'soluciona':
                branding = {
                    tenant: 'soluciona',
                    companyname: 'Soluciona',
                    navBackgroundLogoColor: '#F1FAEE',
                    navIconcollapseColor: '#1f487e',
                    navigationColorBorder: '#1f487e',
                    accentColor: '#1f487e',
                    BackgroundColor: '#F1FAEE',
                    accentColorFont: '#FFFFFF',
                    sidenav: '#F1FAEE',
                    favicon: 'assets/images/logos/grupo-investigo-favicon.ico',
                    logoLogin: 'assets/images/logos/grupo-investigo-login.png',
                    logo: 'assets/images/logos/grupo-investigo-A.png',
                    sublogo: 'assets/images/logos/grupo-investigo-B.png',
                    loginBackground: '/assets/images/backgrounds/background-grupo-investigo.jpg',
                    dashboardBackground: '/assets/images/backgrounds/background-home-grupo-investigo.jpg'
                }
                break;
            case 'ethicalstrategists':
                branding = {
                    tenant: 'ethicalstrategists',
                    companyname: 'Ethical Strategists',
                    navBackgroundLogoColor: '#f5f5f5',
                    navIconcollapseColor: '#113182',
                    navigationColorBorder: '#113182',
                    accentColor: '#f5f5f5',
                    BackgroundColor: '#f5f5f5',
                    accentColorFont: '#113182',
                    sidenav: '#f5f5f5',
                    favicon: 'assets/images/logos/ethical-strategists-favicon.ico',
                    logoLogin: 'assets/images/logos/ethical-strategists-login.png',
                    logo: 'assets/images/logos/ethical-strategists-A.png',
                    sublogo: 'assets/images/logos/ethical-strategists-B.png',
                    loginBackground: '/assets/images/backgrounds/background-ethical-strategists.jpg',
                    dashboardBackground: '/assets/images/backgrounds/background-ethical-strategists.jpg'
                }
                break;
            case 'canal-transparenta':
            case 'grc-transparenta':
                branding = {
                    tenant: 'canal-transparenta',
                    companyname: 'Transparenta',
                    navBackgroundLogoColor: '#f5f5f5',
                    navIconcollapseColor: '#414042',
                    navigationColorBorder: '#be1e2d',
                    accentColor: '#be1e2d',
                    BackgroundColor: '#f5f5f5',
                    accentColorFont: '#f5f5f5',
                    sidenav: '#f5f5f5',
                    favicon: 'assets/images/logos/transparenta-favicon.ico',
                    logoLogin: 'assets/images/logos/transparenta-login.png',
                    logo: 'assets/images/logos/transparenta-A.png',
                    sublogo: 'assets/images/logos/transparenta-B.png',
                    loginBackground: '/assets/images/backgrounds/background-transparenta.jpg',
                    dashboardBackground: '/assets/images/backgrounds/background-transparenta.jpg'
                }
                break;
            case 'negotia':
                branding = {
                    tenant: 'negotia',
                    companyname: 'Negotia',
                    navBackgroundLogoColor: '#f5f5f5',
                    navIconcollapseColor: '#cca874',
                    navigationColorBorder: '#cca874',
                    accentColor: '#cca874',
                    BackgroundColor: '#f5f5f5',
                    accentColorFont: '#f5f5f5',
                    sidenav: '#f5f5f5',
                    favicon: 'assets/images/logos/negotia-favicon.ico',
                    logoLogin: 'assets/images/logos/negotia-login.png',
                    logo: 'assets/images/logos/negotia-A.png',
                    sublogo: 'assets/images/logos/negotia-B.png',
                    loginBackground: '/assets/images/backgrounds/background-negotia.png',
                    dashboardBackground: '/assets/images/backgrounds/background-negotia.png'
                }
                break;
            case 'realvalladolid':
                branding = {
                    tenant: 'realvalladolid',
                    companyname: 'Real Valladolid Club de Futbol',
                    navBackgroundLogoColor: '#f5f5f5',
                    navIconcollapseColor: '#63257e',
                    navigationColorBorder: '#63257e',
                    accentColor: '#63257e',
                    BackgroundColor: '#f5f5f5',
                    accentColorFont: '#f5f5f5',
                    sidenav: '#f5f5f5',
                    favicon: 'assets/images/logos/valladolid-favicon.ico',
                    logoLogin: 'assets/images/logos/valladolid-login.png',
                    logo: 'assets/images/logos/valladolid-A.png',
                    sublogo: 'assets/images/logos/valladolid-B.png',
                    loginBackground: '/assets/images/backgrounds/valladolid-background.png',
                    dashboardBackground: '/assets/images/backgrounds/valladolid-background.png'
                }
                break;
            case 'transtorres':
                branding = {
                    tenant: 'transtorres',
                    companyname: 'Transportes Remedios Torres',
                    navBackgroundLogoColor: '#f5f5f5',
                    navIconcollapseColor: '#002475',
                    navigationColorBorder: '#002475',
                    accentColor: '#002475',
                    BackgroundColor: '#f5f5f5',
                    accentColorFont: '#f5f5f5',
                    sidenav: '#f5f5f5',
                    favicon: 'assets/images/logos/transtorres-favicon.ico',
                    logoLogin: 'assets/images/logos/transtorres-login.png',
                    logo: 'assets/images/logos/transtorres-A.png',
                    sublogo: 'assets/images/logos/transtorres-B.png',
                    loginBackground: '/assets/images/backgrounds/transtorres-background.png',
                    dashboardBackground: '/assets/images/backgrounds/transtorres-background.png'
                }
                break;
            case 'jesuitas':
                    branding = {
                        tenant: 'jesuitas',
                        companyname: 'Jesuitas',
                        navBackgroundLogoColor: '#f5f5f5',
                        navIconcollapseColor: '#009DC2',
                        navigationColorBorder: '#009DC2',
                        accentColor: '#009DC2',
                        BackgroundColor: '#f5f5f5',
                        accentColorFont: '#f5f5f5',
                        sidenav: '#f5f5f5',
                        favicon: 'assets/icons/logos/jesuitas-favicon.ico',
                        logoLogin: 'assets/images/logos/jesuitas-login.png',
                        logo: 'assets/images/logos/jesuitas-A.png',
                        sublogo: 'assets/images/logos/jesuitas-B.png',
                        loginBackground: '/assets/images/backgrounds/jesuitas-background.png',
                        dashboardBackground: '/assets/images/backgrounds/jesuitas-background.png',
                        hideDefaultForms: false,
                        customform: [{ file: 'es_jesuitas', name: 'Jesuitas' }, { file: 'eu_jesuitas', name: 'Jesuitas' }, { file: 'gl_jesuitas', name: 'Jesuitas' }, { file: 'ca_jesuitas', name: 'Jesuitas' }]
                    }
                break;

            default:
                branding = {
                    tenant: null,
                    companyname: 'H2C',
                    navigationColorBorder: '#d46537',
                    accentColor: '#b12f8d',
                    sidenav: '#2d323e',
                    favicon: 'assets/icons/logos/h2c.ico',
                    logoLogin: 'assets/images/logos/h2c-check.png',
                    logo: 'assets/images/logos/h2c-check.png',
                    sublogo: 'assets/images/logos/h2c.png',
                    loginBackground: '/assets/images/backgrounds/homeh2c.jpg',
                    dashboardBackground: '/assets/images/backgrounds/homeh2c.jpg'
                }
                break;
        }
        return branding;
    }



    /** @ngInject */
    function msUtils($window, $translate, $q, $resource, COMMON, $mdDialog, $document) {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            hasProp: hasProp,
            getTenant: getTenant,
            getTenantTranslate: getTenantTranslate,
            getBranding: getBranding,
            exists: exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile: isMobile,
            toggleInArray: toggleInArray,
            timeAgo: timeAgo,
            translate: translate,
            controlAverageColor: controlAverageColor,
            controlAverageColorText: controlAverageColorText,
            getExtensionIcon: getExtensionIcon,
            controlAverageText: controlAverageText,
            evidenceScoreColor: evidenceScoreColor,
            evidenceScoreText: evidenceScoreText,
            showFileInfo: showFileInfo
        };

        return service;



        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

         /**
         * Check if object has property
         * @param  {object}  o
         * @param  {string}  prop
         * @return {Boolean}
         */
        function hasProp(o, prop) {
            if (o == undefined) {
                return false;
            }
            return o.hasOwnProperty(prop);
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser() {
            // If we already tested, do not test again
            if (browserInfo) {
                return browserInfo;
            }

            var browserData = [
                {
                    string: $window.navigator.userAgent,
                    subString: 'Edge',
                    versionSearch: 'Edge',
                    identity: 'Edge'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity: 'Chrome'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity: 'OmniWeb'
                },
                {
                    string: $window.navigator.vendor,
                    subString: 'Apple',
                    versionSearch: 'Version',
                    identity: 'Safari'
                },
                {
                    prop: $window.opera,
                    identity: 'Opera'
                },
                {
                    string: $window.navigator.vendor,
                    subString: 'iCab',
                    identity: 'iCab'
                },
                {
                    string: $window.navigator.vendor,
                    subString: 'KDE',
                    identity: 'Konqueror'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity: 'Firefox'
                },
                {
                    string: $window.navigator.vendor,
                    subString: 'Camino',
                    identity: 'Camino'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity: 'Netscape'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'MSIE',
                    identity: 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Trident/7',
                    identity: 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Gecko',
                    identity: 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Mozilla',
                    identity: 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string: $window.navigator.platform,
                    subString: 'Win',
                    identity: 'Windows'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'Mac',
                    identity: 'Mac'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'Linux',
                    identity: 'Linux'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'iPhone',
                    identity: 'iPhone'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'iPod',
                    identity: 'iPod'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'iPad',
                    identity: 'iPad'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'Android',
                    identity: 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data) {
                for (var i = 0; i < data.length; i++) {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if (dataString) {
                        if (dataString.indexOf(data[i].subString) !== -1) {
                            return data[i].identity;

                        }
                    }
                    else if (dataProp) {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString) {
                var index = dataString.indexOf(versionSearchString);

                if (index === -1) {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os: os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator() {
            var S4 = function () {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile() {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array) {
            if (array.indexOf(item) === -1) {
                array.push(item);
            }
            else {
                array.splice(array.indexOf(item), 1);
            }
        }

        function timeAgo(momentTime) {
            var dateFormatted = moment.utc(momentTime).format();
            return moment.utc(dateFormatted).fromNow();
        }

        function translate(varName) {
            return $translate.instant(varName);
        }

        function controlAverageColor(control) {
            var returnColor = 'black';
            if (control.averageEvidenceScore == 0) {
                returnColor = 'green';
            } else if (control.averageEvidenceScore == 1) {
                returnColor = 'green';
            } else if (control.averageEvidenceScore == 2) {
                returnColor = 'rgb(255, 217, 0)';
            } else if (control.averageEvidenceScore == 3) {
                returnColor = 'orange';
            } else if (control.averageEvidenceScore == 4) {
                returnColor = 'orange';
            } else if (control.averageEvidenceScore == 5) {
                returnColor = 'red';
            }
            return returnColor
        }

        function controlAverageColorText(control) {
            var returnColor = 'white';
            if (control.averageEvidenceScore == 2) {
                returnColor = 'white';
            }
            return returnColor
        }

        function controlAverageText(control) {
            var txt;
            if (control.averageEvidenceScore == 0) {
                txt = $translate.instant('RISK.CONTROL_SCORE_0');
            } else if (control.averageEvidenceScore == 1) {
                txt = $translate.instant('RISK.CONTROL_SCORE_1');
            } else if (control.averageEvidenceScore == 2) {
                txt = $translate.instant('RISK.CONTROL_SCORE_2');
            } else if (control.averageEvidenceScore == 3) {
                txt = $translate.instant('RISK.CONTROL_SCORE_3');
            } else if (control.averageEvidenceScore == 4) {
                txt = $translate.instant('RISK.CONTROL_SCORE_4');
            } else if (control.averageEvidenceScore == 5) {
                txt = $translate.instant('RISK.CONTROL_SCORE_5');
            }
            return txt
        }

        function evidenceScoreColor(evidence) {
            var returnColor = 'black';
            if (evidence.score == 0) {
                returnColor = 'green';
            } else if (evidence.score == 1) {
                returnColor = 'green';
            } else if (evidence.score == 2) {
                returnColor = 'rgb(255, 217, 0)';
            } else if (evidence.score == 3) {
                returnColor = 'orange';
            } else if (evidence.score == 4) {
                returnColor = 'orange';
            } else if (evidence.score == 5) {
                returnColor = 'red';
            }
            return returnColor
        }

        function evidenceScoreText(evidence) {
            var txt;
            if (evidence.score == 0) {
                txt = $translate.instant('RISK.CONTROL_SCORE_0');
            } else if (evidence.score == 1) {
                txt = $translate.instant('RISK.CONTROL_SCORE_1');
            } else if (evidence.score == 2) {
                txt = $translate.instant('RISK.CONTROL_SCORE_2');
            } else if (evidence.score == 3) {
                txt = $translate.instant('RISK.CONTROL_SCORE_3');
            } else if (evidence.score == 4) {
                txt = $translate.instant('RISK.CONTROL_SCORE_4');
            } else if (evidence.score == 5) {
                txt = $translate.instant('RISK.CONTROL_SCORE_5');
            }
            return txt
        }

        function showFileInfo(Owner, file, ev) {
            $mdDialog.show({
                controller: 'fileDetailsDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/fileDetails/fileDetailsDialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                multiple: true,
                clickOutsideToClose: true,
                locals: {
                    file: file,
                    Owner: Owner
                }
            })

        }

        function getExtensionIcon(filename) {

            var found = false;
            var iconData = [
                {
                    extension: ['pdf'],
                    icon: 'icon-file-pdf-box'
                },
                {
                    extension: ['doc', 'docx'],
                    icon: 'icon-file-word-box'
                },
                {
                    extension: ['xls', 'xlsx'],
                    icon: 'icon-file-excel-box'
                },
                {
                    extension: ['ppt', 'pptx'],
                    icon: 'icon-file-powerpoint-box'
                },
                {
                    extension: ['txt', 'rtf'],
                    icon: 'icon-file-document'
                },
                {
                    extension: ['zip', 'rar', 'tgz'],
                    icon: 'icon-zip-box'
                },
                {
                    extension: ['pdf'],
                    icon: 'icon-file-pdf-box'
                },
                {
                    extension: ['mp3', 'wav', 'wma'],
                    icon: 'icon-file-music'
                },
            ];

            var extension = filename.split('.')
                .pop();
            for (var i = 0; i < iconData.length; i++) {
                if (_.includes(iconData[i].extension, extension)) {
                    found = true;
                    return iconData[i].icon;
                }
            }
            if (!found) {
                return 'no-icon';
            }
        }
    }



    /** @ngInject **/
    function msUtilsProvider() {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url) {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl() {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject() {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource) {
            if (!angular.isString(key)) {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if (!angular.isArray(resource)) {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url: baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions: resource[2] || [],
                options: resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function () {
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register: register,
                getTenant: getTenant,
                getTenantTranslate: getTenantTranslate,
                getBranding: getBranding
            };
            return service;
        };

    }
}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);


    /** @ngInject **/
    function msApiProvider() {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url) {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl() {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject() {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource) {
            if (!angular.isString(key)) {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if (!angular.isArray(resource)) {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url: baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions: resource[2] || [],
                options: resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($q, $log, $resource) {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register: register,
                resolve: resolve,
                request: request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters) {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if (!resource || !method) {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if (!apiObject) {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response) {
                            deferred.resolve(response);
                        },

                        // Error
                        function (response) {
                            deferred.reject(response);
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error) {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if (!resource || !method) {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if (!apiObject) {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response) {
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if (angular.isDefined(success) && angular.isFunction(success)) {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response) {
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if (angular.isDefined(error) && angular.isFunction(error)) {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .service("mediaService", mediaService);

    /** @ngInject */
    // I provide access to the session store.
    function mediaService($q, $resource, userService, settingsDomainService, sessionService, COMMON, $window) {


        var reference_sections = [];

        function get(options) {
            var deferred = $q.defer();
            var filters = [];
            var media_type = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });

            if (angular.isArray(options.media_type)) {
                console.log("array")
                media_type = JSON.stringify(options.media_type);
            } else {
                media_type = options.media_type;
            }

            resourceMedia.get({
                //domain: options.siteID,
                domain: 'americascup_tirar',
                media_type: media_type,
                name: options.section,
                page: options.page,
                search: options.searchStringFilter,
                resultsPerPage: options.resultsPerPage,
                sort: options.sort,
                sortField: options.sortField,
                sortDir: options.sortDir,
                withCropStatus: true,
                withGalleries: true,
                withContainer: true,
                withMediaChildren: options.withMediaChildren,
                id_media: options.idMedia,
                withFilters: JSON.stringify(filters),
                // lang: get("language")
            },
                function (response) {
                    if (response.total == 1) {

                    }

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getFilters(options) {
            var deferred = $q.defer();


            resourceMediaFilters.get({
                domain: options.site,
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        var resourceMedia = $resource(
            COMMON.BASE_API + "/owner/:owner/media", {
            //'http://v3-api.qiusystem.com/api/v1' + "/domain/:domain/media", {
            // No default data.
        }, {
            'get': { method: "GET", isArray: false },
            'post': { method: "POST", isArray: false },
            'update': { method: "PUT" },
        }
        );

        var resourceMediaFilters = $resource(
            COMMON.BASE_API + "/domain/:domain/media/options", {
            // No default data.
        }, {
            get: {
                method: "GET",
                // isArray: true
            }
        }
        );

        var resource_s3_presigned_url = $resource(
            COMMON.BASE_API + "/owner/:owner/upload/getS3UploadPreSignedUrl", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        }
        );

        var resource_finish_file = $resource(
            COMMON.BASE_API + "/owner/:owner/task/:id/finishFiles", {
            // No default data.
        }, {
            update: {
                method: "PUT",
                isArray: false
            }
        }
        );
        var resource_finished_uploading_file_to_cdn = $resource(
            COMMON.BASE_API + "/owner/:owner/upload/finishedUploadingFile", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: false
            },
            post: {
                method: "POST",
                isArray: false
            }
        }
        );

        var resource_storage_prefix = $resource(
            COMMON.BASE_API + "/owner/:owner/upload/storagePrefix", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        }
        );

        function getS3UploadPreSignedUrl(options) {
            var deferred = $q.defer();

            resource_s3_presigned_url.get({
                owner: options.owner,
                uploadKey: options.uploadKey,
                fileName: options.fileName,
                rowId: options.rowId
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function finishedUploadingFileToCdn(options) {
            var deferred = $q.defer();

            resource_finished_uploading_file_to_cdn.post({
                owner: options.owner,
                id_media: options.idMedia,
                // lang: get("language")
            },
                { token: options.token },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function finishFile(options) {
            var deferred = $q.defer();

            resource_finish_file.update({
                owner: options.owner,
                id: options.taskId
            }, {
                "attach": options.mediaIds
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function importFromUrl(options) {
            var deferred = $q.defer();

            resource_import_from_url.post({
                domain: options.siteID,
                url: options.url,
                execute: options.execute
                // lang: get("language")
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getStoragePrefix(options) {
            var deferred = $q.defer();

            resource_storage_prefix.get({
                owner: options.owner,
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        // Return the public API.
        return ({
            get: get,
            getFilters: getFilters,
            finishFile: finishFile,
            getS3UploadPreSignedUrl: getS3UploadPreSignedUrl,
            finishedUploadingFileToCdn: finishedUploadingFileToCdn,
            importFromUrl: importFromUrl,
            getStoragePrefix: getStoragePrefix

        });


    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('filesService', filesService);

    /** @ngInject */
    function filesService($q, $resource, COMMON)
    {

        function getPresignedUrl(options) {

            var deferred = $q.defer();
            resourcePresigned.get({
                    owner: options.owner,
                    file: options.file.id
                },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);

        }

        function getTSRFile(options) {

            var deferred = $q.defer();
            resourceTSR.get({
                    owner: options.owner,
                    file: options.file.id
                },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);

        }

        function getTSQFile(options) {

            var deferred = $q.defer();
            resourceTSQ.get({
                    owner: options.owner,
                    file: options.file.id
                },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);

        }

        function getTimeStampInfo(options) {

            var deferred = $q.defer();
            resourceTimeStamp.get({
                    owner: options.owner,
                    file: options.file.id
                },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);

        }


        // Define the resource that will translate requests locally to server-side resources.
        var resourcePresigned = $resource(COMMON.BASE_API + "/owner/:owner/file/:file/downloadUrl", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            },
        });

        var resourceTSR = $resource(COMMON.BASE_API + "/owner/:owner/upload/getTimeStampRequestFile/:file", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            },
        });

        var resourceTSQ = $resource(COMMON.BASE_API + "/owner/:owner/upload/getTimeStampQueryFile/:file", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            },
        });

        var resourceTimeStamp = $resource(COMMON.BASE_API + "/owner/:owner/upload/verifyTimeStampAndInfo/:file", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            },
        });

        return ({
            getPresignedUrl: getPresignedUrl,
            getTSRFile: getTSRFile,
            getTSQFile: getTSQFile,
            getTimeStampInfo: getTimeStampInfo
        });
    }
}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .service("settingsDomainService", settingsDomainService);

    /** @ngInject */
    // I provide access to the session store.
    function settingsDomainService($q, $resource, userService, COMMON, $window) {


        function getSettingsDomain() {

            // Create our deferred results.
            var deferred = $q.defer();

            // Make the request to the server.
            resource.get({
                    // No data needs to be passed - cookies will take care of passing the authentication
                    // token that has been provided by the server.
                },
                function(response) {

                    // Store the account and subscription information.
                    // ng.extend(user, response.account);
                    // ng.extend(subscription, response.subscription);
                    // ng.extend(domains, response.domains);

                    // user.projectsUrl = response.projectsUrl;

                    // // Get the initials for use throughout the application (avatars).
                    // user.initials = userService.getInitials(user.name);

                    // // Determine whether or not the user is currently using a system avatar.
                    // user.hasSystemAvatar = userService.isSystemAvatar(user.avatarID);

                    // // Information about sync connections
                    // if (response && response.sync) {
                    //     user.isSyncEnabled = response.sync.enabled;
                    //     user.syncClients = response.sync.clients;
                    // }
                    // if (user.default_domain) {
                    //     user.domain_active = _.find(domains, {
                    //         'id_domain': user.default_domain
                    //     });
                    //     setDefaultDomain(user.domain_active)
                    // }

                    // // Used to set Enterprise details
                    // user.companyInfo = response.companyInfo;

                    // Resolve the promise.
                    deferred.resolve(response);

                },
                function() {

                    deferred.reject();

                }
            );

            // Return the promise.
            return (deferred.promise);

        }


        // -------------------------------------------------- //
        // -------------------------------------------------- //


        // Define the resource that will translate requests locally to server-side resources.
        var resource = $resource(
            COMMON.BASE_API + "/", {
                // No default data.
            }, {
                getUser: {
                    method: "GET"
                }
            }
        );

        // Store the default authenticating user.
        var user = {
            id: 0,
            name: "",
            initials: "",
            hasSystemAvatar: true,
            email: "",
            isAccountAuthenticated: false
        };

        // Store the default subscription for the authenticating user.
        var subscription = {};

        // Store the active Site for the authenticating user.
        var site_operative = {};

        // Store domains for the authenticating user. 
        // array()
        var domains = [];

        // I store session data that the controllers can use to store some small stateful items.
        var data = {};

        // Copy the feature flags into the session.



        // -------------------------------------------------- //
        // -------------------------------------------------- //


        // Return the public API.
        return ({
            // authenticate: authenticate,
            // setActiveDomain: setActiveDomain,
            // featureFlags: featureFlags,
            // get: get,
            // isAuthenticated: isAuthenticated,
            // set: set,
            // update: update,
            // subscription: subscription,
            // user: user,
            // site_operative: site_operative,
            // domains: domains
        });

    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .service('companyService', companyService);

    /** @ngInject */
    function companyService($q, $resource, settingsDomainService, sessionService, COMMON) {

        var companyId = '';
        var branch = {};

        function getCompany(options) {
            var deferred = $q.defer();
            resourceCompany.get({
                owner: options.owner,
                id: options.id,
                withUsers: options.withUsers
            },
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getBranches(options) {
            var deferred = $q.defer();
            resourceBranches.get(options,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getSectors(options) {
            var deferred = $q.defer();
            resourceSectors.get(options,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getComplianceOfficers(options) {
            var deferred = $q.defer();
            resourceComplianceOfficers.get(options,
                function (response) {
                    deferred.resolve(response);
                },

                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function setCompanyId(idCompany) {
            companyId = idCompany;
        }

        function getCompanyId() {
            return companyId;
        }

        function setBranch(branchData) {
            branch = branchData;
        }

        function getBranch() {
            return branch;
        }

        var resourceCompany = $resource(COMMON.BASE_API + "/owner/:owner/company/:id", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                },
            });

        var resourceBranches = $resource(COMMON.BASE_API + "/owner/:owner/branch/", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });

        var resourceSectors = $resource(COMMON.BASE_API + "/owner/:owner/sector/", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });



        var resourceComplianceOfficers = $resource(COMMON.BASE_API + "/owner/:owner/company/complianceOfficers/:id", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: true
                }
            });

        return ({
            getCompany: getCompany,
            getBranches: getBranches,
            getSectors: getSectors,
            getComplianceOfficers: getComplianceOfficers,
            setCompanyId: setCompanyId,
            setBranch: setBranch,
            getCompanyId: getCompanyId,
            getBranch: getBranch,
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .service("CommonMediaService", CommonMediaService);

    /** @ngInject */
    function CommonMediaService($q, $resource, userService, settingsDomainService, sessionService, COMMON, $window) {

        /*
         * @array
         */
        function getUrl(options) {
            var deferred = $q.defer();

            var array = [];
            angular.forEach(options.id_media, function(media) {
                array.push(media)
            });

            resource_content_getUrl.post({
                    //domain: sessionService.site_operative.domain_name,
                    domain: 'americascup_tirar', //TODO
                    id_media: array,
                    id_cropformat: options.id_cropformat,
                    id_container: options.id_container,
                },
                function(response) {
                    deferred.resolve(response);
                },
                function(e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        var resource_content_getUrl = $resource(
            //COMMON.BASE_API + "/domain/:domain/media/url", {
                'http://v3-api.qiusystem.com/api/v1' + "/domain/:domain/media/url", {
                domain: '@domain',
            }, {
                get: {
                    method: "GET",
                },
                post: {
                    method: 'POST',
                    cache: false,
                    isArray: true,
                    headers: { 'Content-Type': 'application/json; charset=UTF-8' }
                },
                update: {
                    method: "PUT",
                },
            }
        );

        // Return the public API.
        return ({
            getUrl: getUrl,
        });
    }

})();
(function () {
	'use strict';

	angular
		.module('app.core')
		.factory('html2canvasAngular', html2CanvasAngular);

	/** @ngInject */
	function html2CanvasAngular($q) {
		var self = {};
		self.renderElement = function renderElement(element, background, height) {
			var deferred = $q.defer();
			var options = {
				async: true,
				removeContainer: true,
				background: background ? background : '#FFFFFF',
				onrendered: function (canvas) {
					deferred.resolve(canvas);
				}
			};
			if (height) {
				options.height = height;
			}
			html2canvas(element, options);
			return deferred.promise;
		}
		return self;
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'E',
            compile : function (element, attr)
            {
                var code;
                //No attribute? code is the content
                if ( !attr.code )
                {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr)
                {

                    if ( attr.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();


(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('resourceInterceptor', resourceInterceptor)

    function resourceInterceptor($injector, $q) {

        function showError(e) {
            var $mdToast = $injector.get('$mdToast');
        
            var message = "Ha ocurrido un error inesperado.";
        
            if (e.status === 401 && e.data && e.data.detail === "Error") {
                message = "Acceso denegado. No tienes permisos para ver este contenido.";
            } else if (e.data && e.data.detail) {
                message = e.data.detail;
            }
        
            $mdToast.show({
                template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content bg-red">' + message + '</div></md-toast>',
                hideDelay: 4000,
                position: 'top right',
                parent: '#content'
            });
        }
        var responseInterceptor = {
            responseError: function (responseError) {
                showError(responseError)
                return $q.reject(responseError);;
            }
        };


        return responseInterceptor;


    }




})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('monthDate', monthDate);

    /** @ngInject */
    function monthDate() {
        return function (value) {
            return moment(value).format('MMM YYYY');
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('fullDateWithoutHours', fullDateWithoutHours);

    /** @ngInject */
    function fullDateWithoutHours() {
        return function (value) {
            return moment(value).format('DD MMM YYYY');
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('fullDate', fullDate);

    /** @ngInject */
    function fullDate() {
        return function (value) {
            return moment(value).format('DD MMM YYYY HH:mm');
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('toTrustedResource', toTrustedResourceFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter)
        .filter('buildFileUrl', buildFileUrlFilter);

    /** @ngInject */
    function toTrustedFilter($sce) {
        return function (value) {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function toTrustedResourceFilter($sce) {
        return function (value) {
            if (value.length > 0)
                return $sce.trustAsResourceUrl(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter() {
        return function (text) {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter() {
        return function (value) {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter() {
        return function (doc) {
            if (!doc) {
                return;
            }
            if (doc.type === 'directive') {
                return doc.name.replace(/([A-Z])/g, function ($1) {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

    /** @ngInject */
    function buildFileUrlFilter() {
        return function (fileUrl, storagePrefix) {
            if (!fileUrl) {
                return '';
            }
            
            // Si la URL ya es completa (empieza con http:// o https://), devolverla tal cual
            if (fileUrl.indexOf('http://') === 0 || fileUrl.indexOf('https://') === 0) {
                return fileUrl;
            }
            
            // Si no, concatenar con el storagePrefix
            if (storagePrefix) {
                return storagePrefix + fileUrl;
            }
            
            return fileUrl;
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate($translate) {
        function capitalizeFirstLetter(string) {
            // Only capitalises the first alphabetic letter if it is not directly preceded by a sequence of digits
            return string.replace(/^(?!\d+\s)([a-z])/, function(match, firstLetter) {
                return firstLetter.toUpperCase();
            });
        }

        function lowercaseTranslation(key) {
            return $translate.instant(key).toLowerCase();
        }

        return function (value) {
            var dateValue = moment(value).local(); // Convert date value to local time
            if (!dateValue.isValid()) {
                return value;
            }

            var now = moment().local(); // Get the current time in local time
            var diff = now.diff(dateValue);

            const ONE_HOUR = 60 * 60 * 1000;
            const ONE_DAY = 24 * ONE_HOUR;
            const ONE_WEEK = 7 * ONE_DAY;
    
            let result;

            if (diff < 0) {
                result = moment(dateValue).calendar();
            }
            else if (diff < ONE_HOUR) {
                result = moment(dateValue).fromNow();
            }
            else if (now.isSame(dateValue, 'day')) {
                result = $translate.instant('APP.TODAY_AT') + ' ' + moment(dateValue).format('HH:mm');
            }
            else if (now.subtract(1, 'days').isSame(dateValue, 'day')) {
                result = $translate.instant('APP.YESTERDAY_AT') + ' ' + moment(dateValue).format('HH:mm');
            }
            else if (diff < ONE_WEEK) {
                result = $translate.instant('APP.ON') + ' ' + lowercaseTranslation(moment(dateValue).format('dddd')) + ' ' + $translate.instant('APP.AT') + ' ' + moment(dateValue).format('HH:mm');
            }
            else {
                result = moment(dateValue).format('DD/MM/YYYY') + ' ' + lowercaseTranslation('APP.AT') + ' ' + moment(dateValue).format('HH:mm');
            }
            
            return capitalizeFirstLetter(result);
        };
    }    
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $scope, $cookies, $stateParams, sessionService, $q, $state, $timeout, $mdSidenav, $mdDialog, $translate, $mdToast, $location, msNavigationService, msUtils, stripeService, $window) {
        var vm = this;
        // Data
        $rootScope.global = {
            search: ''
        };
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg', 'red-bg', 'yellow-bg', 'light-blue-bg'];

        vm.branding = msUtils.getBranding();

        $scope.owner = $cookies.get('owner');
        vm.bodyEl = angular.element('body');
        vm.user = sessionService.getUser();
        vm.companies = sessionService.getUser().companies;
        vm.config = sessionService.config;
        vm.companySelected = undefined;
        vm.translate = msUtils.translate;
        vm.userLogued = sessionService.getUser();
        vm.userStatusOptions = [{
            'title': 'Online',
            'icon': 'icon-checkbox-marked-circle',
            'color': '#4CAF50'
        },
        {
            'title': 'Away',
            'icon': 'icon-clock',
            'color': '#FFC107'
        },
        {
            'title': 'Do not Disturb',
            'icon': 'icon-minus-circle',
            'color': '#F44336'
        },
        {
            'title': 'Invisible',
            'icon': 'icon-checkbox-blank-circle-outline',
            'color': '#BDBDBD'
        },
        {
            'title': 'Offline',
            'icon': 'icon-checkbox-blank-circle-outline',
            'color': '#616161'
        }
        ];
        vm.languages = {
            en: {
                'title': 'TOOLBAR.ENGLISH',
                'translation': 'TOOLBAR.ENGLISH',
                'code': 'en',
                'flag': 'us'
            },
            es: {
                'title': 'TOOLBAR.SPANISH',
                'translation': 'TOOLBAR.SPANISH',
                'code': 'es',
                'flag': 'es'
            },
            pt: {
                'title': 'TOOLBAR.PORTUGUESE',
                'translation': 'TOOLBAR.PORTUGUESE',
                'code': 'pt',
                'flag': 'pt'
            },
            de: {
                'title': 'TOOLBAR.GERMAN',
                'translation': 'TOOLBAR.GERMAN',
                'code': 'de',
                'flag': 'de'
            },
            ca: {
                'title': 'TOOLBAR.CATALAN',
                'translation': 'TOOLBAR.CATALAN',
                'code': 'ca',
                'flag': 'ca'
            },
            fr: {
            'title': 'TOOLBAR.FRENCH',
            'translation': 'TOOLBAR.FRENCH',
            'code': 'fr',
            'flag': 'fr'
            },
            it: {
                'title': 'TOOLBAR.ITALIAN',
                'translation': 'TOOLBAR.ITALIAN',
                'code': 'it',
                'flag': 'it'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.openPassDialog = openPassDialog;
        vm.openStripeDialog = openStripeDialog;
        vm.openStripePortal = openStripePortal;
        vm.isUserOwner = sessionService.getUser().is_owner === true;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;
        vm.selectCompany = selectCompany;
        vm.getFilteredCompanies = getFilteredCompanies;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];

            if (!angular.isUndefined($state.params.domain) && $state.params.domain) {
                angular.forEach(vm.companies, function (c) {
                    if (c.id == $state.params.domain) {
                        vm.selectCompany(c);
                    }
                })
            }
            if (vm.companies.length == 1) {
                vm.selectCompany(vm.companies[0]);
            }
            var companySelectEvent = $rootScope.$on('company-selected-from', function (event, data) {
                selectCompany(data)
            });

            var openStripeDialogEvent = $rootScope.$on('open-stripe-dialog', function (event, ev) {
                openStripeDialog(ev);
            });

            $scope.$on('$destroy', companySelectEvent);
            $scope.$on('$destroy', openStripeDialogEvent);
        }

        function selectCompany(company) {
            vm.companySelected = [];
            $timeout(function () {
                vm.companySelected = company;
                $state.params.domain = company.id;
                sessionService.set('companySelected', company);

                $rootScope.companySel  =  vm.companySelected.id;
                $rootScope.typeInterest  =  vm.companySelected.type_interest;
                $rootScope.symbolMoney  =  vm.companySelected.money_symbol;
                if(!vm.companySelected.money_symbol) {
                    $rootScope.symbolMoney  =  "€";
                }
                // var intercomObjectUser = {
                //     email: sessionService.getUser().email,
                //     name: sessionService.getUser().first_name + ' ' + sessionService.getUser().last_name + '(' + $scope.owner + ')',
                //     created_at: new Date(),
                //     user_id:$scope.owner +'-'+ sessionService.getUser().id
                // }
                // $intercom.update(intercomObjectUser);
                $rootScope.$broadcast('company-selected', {});
            })


        }

        $rootScope.$on('reset-clients', function (event) {
            vm.companies = sessionService.getUser().companies;
        });

        $rootScope.$on('select-company', function (event, company) {
            vm.selectCompany(company);
        });
        $rootScope.$on('select-company-id', function (event, id_company) {
            var company = _.find(vm.companies, function (company) {
                return id_company == company.id;
            })
            vm.selectCompany(company);
        });

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }
        vm.goToFAQs = function() {
            $state.go('app.site_overview.faqs.list');
        };
        function openPassDialog(ev) {
            $mdDialog.show({
                controller: 'ChangePassDialogcontroller',
                controllerAs: 'vm',
                locals: {
                    user: vm.users
                },
                templateUrl: 'app/toolbar/dialogs/change-password/change-password.html',
                targetEvent: ev,
                multiple: true,
                clickOutsideToClose: false
            }).then(function (response) {
                if (response) {
                    vm.loadPages();
                }
            });
        }
        function openStripeDialog(ev) {
            $mdDialog.show({
                controller: 'StripeCheckoutDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/toolbar/dialogs/stripe-checkout/stripe-checkout.html',
                targetEvent: ev,
                multiple: true,
                clickOutsideToClose: true
            });
        }
        function openStripePortal(ev) {
            const owner = $scope.owner || $cookies.get('owner');
        
            if (!owner) {
                return;
            }
        
            stripeService.getPortalUrl({ owner: owner }).then(function (res) {
                if (res && res.url) {
                    $window.open(res.url, '_blank');
                }
            });
        }
        function getFilteredCompanies() {
            if (vm.searchText && vm.searchText.length > 0) {
                return vm.companies.filter(x => {
                    return x.name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(vm.searchText.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")) >= 0
                });
            } else {
                return vm.companies;
            }
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status) {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout() {
            $rootScope.is_logout = true;
           // $intercom.shutdown();
            sessionService.set('companySelected', null);
            $state.go('app.pages_auth_logout');
            sessionService.logoutLog().then(res => console.log(res));
            // Do logout here..
        }

        /**
         * Change Language
         */
        function changeLanguage(lang) {
            vm.selectedLanguage = lang;
            sessionService.changeLanguage(lang.code)

            //!-- Deprecated - Now is used in sessionService

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             *
             if ( lang.code !== 'en' )
             {
                var message = 'Qiu supports translations, but currently we do not have all translations completely. If you want to help us, send us a message please.';
        
                $mdToast.show({
                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position : 'top right',
                    parent   : '#content'
                });
        
                // return;
            }
             */
            // Change the language
            // $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded() {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query) {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for (var x = 0; x < flatNavigation.length; x++) {
                if (flatNavigation[x].uisref) {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if (query) {
                navigation = navigation.filter(function (item) {
                    if (angular.lowercase(item.title).search(angular.lowercase(query)) > -1) {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function () {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item) {
            // If item has a link
            if (item.uisref) {
                // If there are state params,
                // use them...
                if (item.stateParams) {
                    $state.go(item.state, item.stateParams);
                } else {
                    $state.go(item.state);
                }
            }
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function() {
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', ['satellizer',
            'ngConstants',

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick panel
            'app.quick-panel',

            // Apps
            'app.calendar',
            'app.contacts',
            'app.dialogs',
            'app.logout',
            'app.clients',
            'app.stakeholders',
            'app.items',
            'app.inputs',
            'app.outputs',
            'app.outcomes',
            'app.proyects',
            'app.documents',
            'app.users',
            'app.staff',
            'app.staffsroi',
            'app.complaints',
            'app.register-book',
            'app.tasks',
            'app.reports',
            'app.divisions',
            'app.jobpositions',
            'app.risk',
            'app.imputation',
            'app.evolution',
            'app.riskconfig',
            'app.riskmap',
            'app.help',
            'app.questions',
            'app.dashboard',
            'app.dashboard-complaints',
            'app.dashboards',
            'app.results',
            'app.public',
            'app.proyects',
            'app.outputs',
            'app.faqs',
            'app.clients-complaints',

        ]);
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, $window, $cookies, sessionService, $location, $timeout, $state, $mdSidenav, companyService, mediaService) {

        var vm = this;

        function init() {
            var lang = window.navigator.languages ? window.navigator.languages[0] : null;
            lang = lang || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage;
            if (lang.indexOf('-') !== -1)
                lang = lang.split('-')[0];

            if (lang.indexOf('_') !== -1)
                lang = lang.split('_')[0];

            sessionService.set("language", lang);

            //company roles for Enterprise
            $scope.user = sessionService.getUser();
            $scope.domains = sessionService.domains;

            // Set scope Domain
            setOwner()

            $rootScope.$broadcast('msSplashScreen::remove');

        }

        function setOwner() {
            if ($scope.user && $scope.user.id)
            {
                sessionService.set("owner", $cookies.get('owner'));
                $scope.owner = sessionService.setOwner($cookies.get('owner'));
                sessionService.setMenu();
            }
        }

        init();

        $scope.isInAppMode = false;

        $scope.isAuthenticated = function () {
            return $auth.isAuthenticated();
        };

        $rootScope.$on('site:loginRequired', function (event) {
            $scope.loadPageMessage = "";
            $scope.isLoaded = true;
        });

        $rootScope.$on('site:loadStart', function (event) {
            $scope.isLoaded = false;
            $rootScope.loadPageMessage = "Autenticando";
        });

        $rootScope.$on('site:loadStartDomain', function (event, data) {
            $scope.isLoaded = false;
            $rootScope.loadPageMessage = "Loading site: " + data.subdomain;
        });

        $rootScope.$on('site:loadFinished', function (event) {

            $rootScope.$broadcast('msSplashScreen::remove');
            $timeout(function () {
                $rootScope.loadPageMessage = "";
                $scope.isLoaded = true;
            }, 0);
        });

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event) {
            if (event.targetScope.$id === $scope.$id) {

            }
        });

        $scope.closeToast = function () {
            if (isDlgOpen) return;

            $mdToast
                .hide()
                .then(function () {
                    isDlgOpen = false;
                });
        };
    }


})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function () {
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope, $mdMedia, $rootScope, $cookies, msUtils, sessionService) {
        var vm = this;
        vm.companySelected = sessionService.companySelected

        vm.branding = msUtils.getBranding();

        // Data
        vm.bodyEl = angular.element('body');
        // vm.folded = true;
        if ($cookies.get('navigationFolded')) {
            vm.folded = $cookies.get('navigationFolded');
        } else {
            vm.folded = 'folded';
            $cookies.put('navigationFolded', vm.folded);
        }

        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        $rootScope.$on('company-selected', function (event) {
            vm.companySelected = sessionService.get('companySelected');
        });


        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded() {
            if (vm.folded == 'folded') {
                vm.folded = 'no';
            } else {
                vm.folded = 'folded';
            }
            $cookies.put('navigationFolded', vm.folded);
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function () {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });

        // $scope.$watch(function() { return $mdMedia('sm'); }, function(big) {
        //     vm.folded=true;
        // });

        // $scope.$watch(function() { return $mdMedia('lg'); }, function(big) {
        //     vm.folded=false;
        // });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig, sessionService, amMoment, $translate)
    {
        //amMoment.changeLocale('de');
        var defaultLang = 'es';
        
        var currentLanguage = sessionService.getLanguage() || defaultLang;

        amMoment.changeLocale(currentLanguage);
        moment.locale(currentLanguage);
        $translate.use(currentLanguage);
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }

        // Set Language
        sessionService.changeLanguage();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('requestHeaderIdUserTab', requestHeaderIdUserTab, ['$rootScope', '$location'])
        .constant('INTERCOM_APPID', 'rj3ade7y')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $httpProvider, $logProvider, msScrollConfigProvider, uiGmapGoogleMapApiProvider,
        $translateProvider, $provide, fuseConfigProvider, $intercomProvider, INTERCOM_APPID, $mdDateLocaleProvider) {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        $mdDateLocaleProvider.formatDate = function (date) {
            var m = moment(date);
            return m.isValid() ? m.format('DD-MM-YYYY') : '';
        };
        $mdDateLocaleProvider.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        $mdDateLocaleProvider.shortMonths = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
        $mdDateLocaleProvider.days = ['Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado', 'Domingo'];
        $mdDateLocaleProvider.shortDays = ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa',];
        $mdDateLocaleProvider.firstDayOfWeek = 1;


        $intercomProvider
            .appID(INTERCOM_APPID);

        // you can include the Intercom's script yourself or use the built in async loading feature
        $intercomProvider
            .asyncLoading(true)

        // uiGmapgoogle-maps configuration
        uiGmapGoogleMapApiProvider.configure({
            key: 'AIzaSyByByR4p9MOOk-j3hpduPBEQzd0Ml5Evcs',
            v: '3.exp',
            libraries: 'weather,geometry,visualization'
        });

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json',
        });
        if (!localStorage.getItem('LANG_CODE')) {
            let lang = 'es'
            switch (true) {
                case navigator.language.startsWith('es') || navigator.language.startsWith('gl'):
                    lang = 'es';
                    break;
                case navigator.language.startsWith('ca'):
                    lang = 'ca';
                    break;
                case navigator.language.startsWith('en'):
                    lang = 'en';
                    break;
                case navigator.language.startsWith('pt'):
                    lang = 'pt';
                    break;
                case navigator.language.startsWith('de'):
                    lang = 'de';
                    break;
                case navigator.language.startsWith('fr'):
                    lang = 'fr';
                    break;
                case navigator.language.startsWith('it'):
                    lang = 'it';
                    break;

                default:
                    break;
            }
            localStorage.setItem('LANG_CODE', lang);
        }
        $translateProvider.preferredLanguage(localStorage.getItem('LANG_CODE'));
        $translateProvider.useSanitizeValueStrategy('sanitize');

        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate', function (taOptions) {
                taOptions.toolbar = [
                    ['bold', 'italics', 'underline', 'ul', 'ol', 'quote']
                ];

                taOptions.classes = {
                    focussed: 'focussed',
                    toolbar: 'ta-toolbar',
                    toolbarGroup: 'ta-group',
                    toolbarButton: 'md-button',
                    toolbarButtonActive: 'active',
                    disabled: '',
                    textEditor: 'form-control',
                    htmlEditor: 'form-control'
                };

                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate', function (taTools) {
                taTools.quote.iconclass = 'icon-format-quote';
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.redo.iconclass = 'icon-redo';
                taTools.undo.iconclass = 'icon-undo';
                taTools.clear.iconclass = 'icon-close-circle-outline';
                taTools.justifyLeft.iconclass = 'icon-format-align-left';
                taTools.justifyCenter.iconclass = 'icon-format-align-center';
                taTools.justifyRight.iconclass = 'icon-format-align-right';
                taTools.justifyFull.iconclass = 'icon-format-align-justify';
                taTools.indent.iconclass = 'icon-format-indent-increase';
                taTools.outdent.iconclass = 'icon-format-indent-decrease';
                taTools.html.iconclass = 'icon-code-tags';
                taTools.insertImage.iconclass = 'icon-file-image-box';
                taTools.insertLink.iconclass = 'icon-link';
                taTools.insertVideo.iconclass = 'icon-filmstrip';

                return taTools;
            }
        ]);


        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars': false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile': true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });



        $httpProvider.interceptors.push(function ($q, $rootScope, $location) {
            return {
                request: function (config) {
                    if (!angular.isUndefined($rootScope.idUserTab)) {
                        config.headers["H2C-IdUsersTabs"] = $rootScope.idUserTab;
                    } else {
                        config.headers["H2C-IdUsersTabs"] = 1;
                    }
                    return config;
                }
            }
        });

        /*eslint-enable */
    }


    function requestHeaderIdUserTab($rootScope, $location) {

        return {
            request: function (config) {
                if (!angular.isUndefined($rootScope.isUserTab)) {
                    $location.hash('idUserTab:' + $rootScope.isUserTab)
                    config.headers["H2C-IdUsersTabs"] = $rootScope.isUserTab;
                }
                return config;
            }
        }
    }
})();
angular.module("ngConstants", [])

.constant("COMMON", {
	"GOOGLE_CLIENTID": "1020588837196-29919orgvrsn1gt7ggrcogf47qckeu07.apps.googleusercontent.com",
	"GOOGLE_URL": "",
	"BASE_API_": "http://localhost:1502/api/v1",
	"BASE_API": "https://api.h2c.online/api/v1",
	"URL_FORM": "https://%filename%.canal.h2c.app/new-form.html#",
	"IPKEY": "ef96fbc7812def",
	"FBAPPID": "931777000212163",
	"STRIPE_KEY": "pk_test_DSv8XaiBKLSQjALxpYiGbK9D",
	"URL_ASSETS": "http://test.dev/assets/",
	"DEBUG": false
})

.constant("ENV", "production")

;
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();
(function () {
	'use strict';
	angular
		.module('fuse')
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider, $locationProvider, $authProvider, COMMON) {
		// Prevent erratic behavior at close Sattelizer Authenticate
		$locationProvider.html5Mode(true).hashPrefix('!');

		/**
		 * Layout Style Switcher
		 *
		 * This code is here for demonstration purposes.
		 * If you don't need to switch between the layout
		 * styles like in the demo, you can set one manually by
		 * typing the template urls into the `State definitions`
		 * area and remove this code
		 */
		// Inject $cookies
		var $cookies;
		angular.injector(['ngCookies'])
			.invoke(['$cookies',
				function (_$cookies) {
					$cookies = _$cookies;
				}
			]);
		$urlRouterProvider.otherwise(function () {
			/* return '/dashboard-project'; */
			var owner = $cookies.get('owner');
			if (owner) {
				return '/owner/' + owner + '/dashboard';
			} else {

				return '/pages/auth/logout'
			}
		});
		// Get active layout
		var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';
		var layouts = {
			verticalNavigation: {
				main: 'app/core/layouts/vertical-navigation.html',
				toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
				navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
			}, horizontalNavigation: {
				main: 'app/core/layouts/horizontal-navigation.html',
				toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
				navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
			}, contentOnly: {
				main: 'app/core/layouts/content-only.html', toolbar: '', navigation: ''
			}, contentWithToolbar: {
				main: 'app/core/layouts/content-with-toolbar.html',
				toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
				navigation: ''
			}
		};
		// END - Layout Style Switcher
		// State definitions
		$stateProvider
			.state('app', {
				abstract: true, views: {
					'main@': {
						templateUrl: layouts[layoutStyle].main, controller: 'MainController as vm'
					}, 'toolbar@app': {
						templateUrl: layouts[layoutStyle].toolbar, controller: 'ToolbarController as vm'
					}, 'navigation@app': {
						templateUrl: layouts[layoutStyle].navigation, controller: 'NavigationController as vm'
					}, 'quickPanel@app': {
						templateUrl: 'app/quick-panel/quick-panel.html', controller: 'QuickPanelController as vm'
					}/*'domainPanel@app': {
							 templateUrl: 'app/domain-panel/domain-panel.html',
							 controller: 'DomainPanelController as vm'
							 }*/
				}, resolve: {
					loginRequired: loginRequired, sessionAuth: function (sessionService, $rootScope, $cookies) {
						$rootScope.$emit('site:loadStart', '');
						return sessionService.authenticate($cookies.get('owner'));
					}
				}
			});
		$stateProvider
			.state('app.site_overview', {
				url: '/owner/:owner',
				data: {
					displayName: '{{owner}}'
				}, resolve: {
					owner: function ($stateParams, $q, sessionService) {
						return $stateParams.owner;
					}
				}
			});
		// Callback after linking Google account (popup); redirect_uri from the backend points here
		$stateProvider
			.state('app.authGoogleLinked', {
				url: '/auth/google-linked',
				views: {
					'content@app': {
						templateUrl: 'app/main/public/auth-google-linked.html',
						controller: 'AuthGoogleLinkedController as vm'
					}
				}
			});
		$stateProvider
			.state('public', {
				abstract: true, views: {
					'main@': {
						templateUrl: layouts[layoutStyle].main, controller: 'MainController as vm'
					}, 'toolbar@app': {
						templateUrl: layouts[layoutStyle].toolbar, controller: 'ToolbarController as vm'
					}, 'navigation@app': {
						templateUrl: layouts[layoutStyle].navigation, controller: 'NavigationController as vm'
					}, 'quickPanel@app': {
						templateUrl: 'app/quick-panel/quick-panel.html', controller: 'QuickPanelController as vm'
					}
				}, resolve: {
					loginRequired: skipIfLoggedIn
				}
			});
		$authProvider.httpInterceptor = true;
		$authProvider.withCredentials = true;
		$authProvider.tokenRoot = null;
		$authProvider.cordova = false;
		$authProvider.baseUrl = COMMON.BASE_API;
		$authProvider.loginUrl = '/auth/login';
		$authProvider.signupUrl = '/auth/signup';
		$authProvider.accountAlias = 'tenant1';
		$authProvider.unlinkUrl = '/auth/unlink/';
		$authProvider.tokenName = 'token';
		$authProvider.tokenPrefix = 'satellizer';
		$authProvider.authHeader = 'Authorization';
		$authProvider.authToken = 'Bearer';
		$authProvider.storageType = 'localStorage';
		// Google
		$authProvider.google({
			url: '/auth/google',
			authorizationEndpoint: 'https://accounts.google.com/o/oauth2/auth',
			redirectUri: window.location.origin,
			requiredUrlParams: ['scope'],
			optionalUrlParams: ['display'],
			scope: ['profile',
				'email'
			],
			scopePrefix: 'openid',
			scopeDelimiter: ' ',
			display: 'popup',
			type: '2.0',
			clientId: COMMON.GOOGLE_CLIENTID,
			popupOptions: {
				width: 452, height: 633
			}
		});

		function skipIfLoggedIn($q, $auth) {
			var deferred = $q.defer();
			if ($auth.isAuthenticated()) {
				window.location.href = '/'
				deferred.reject();
			} else {
				deferred.resolve();
			}
			return deferred.promise;
		}

		function loginRequired($q, $auth) {
			var deferred = $q.defer();
			if ($auth.isAuthenticated()) {
				deferred.resolve();
			} else {
				if (window.location.pathname.indexOf('logout' >= 0)) {
					window.location.href = '/login';
				} else {
					window.location.href = '/login?returnUrl=' + window.location.pathname;
				}
			}
			return deferred.promise;
		}
	}
}
)();

(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController)
        .filter('capitalizeFirstLetter', function () {
            return function (input) {
                return (!!input) ? input.charAt(0).toUpperCase() : '';
            }
        });

    /** @ngInject */
    function IndexController(fuseTheming, $scope, msUtils, requestContext, $state, $auth, $location, $stateParams, $mdToast) {
        var vm = this;

        vm.themes = fuseTheming.themes;
        //////////
        vm.branding = msUtils.getBranding();
        document.title = vm.branding.companyname;
        // Listen for route changes so that we can trigger request-context change events.
        function changeFavicon(src) {
            var link = document.createElement('link'),
                oldLink = document.getElementById('dynamic-favicon');
            link.id = 'dynamic-favicon';
            link.rel = 'shortcut icon';
            link.href = src;
            if (oldLink) {
                document.head.removeChild(oldLink);
            }
            document.head.appendChild(link);
        }

        changeFavicon(vm.branding.favicon);

        $scope.$on(
            "$stateChangeSuccess",
            // "$locationChangeSuccess",
            // "$routeChangeSuccess",
            function (event, currentRoute, previousRoute) {

                if (currentRoute.name === 'site_overview') {
                    $state.go('site_overview.dashboard')
                }


                $scope.currentPageName = $state.current.name;

                // If this is a redirect directive, then there's no action to be taken.
                // if (isRouteRedirect($state)) {
                // return;
                // }

                // Check to make sure the session has been authenticated. If the session has not yet
                // been authenticated, we have to show the loading screen.
                // if (!sessionService.isAuthenticated()) {
                if (!$auth.isAuthenticated()) {
                    // An unauthenticated user can only see the loading screen.
                    if ($state.current.action !== "loading" && $state.current.name !== 'public.forgot' && $state.current.name !== 'public.recover' && $state.current.name !== 'public.setup_2fa' && $state.current.name !== 'public.2fa_auth') {

                        // $state.go('login');
                        // Redirect to the loading sequence.
                        return (
                            $location.path("/login")
                        );

                    }
                    // If the user is authenticated, make sure they aren't going to the loading sequence.
                } else if ($state.current.action === "loading") {
                    // Redirect to the default page.

                    return (
                        $location.path("/")
                    );

                }
                // If we made it this far then the user has been authenticated and can view the
                // requested route.

                // Update the current request action change.
                // console.debug("set context", $state.current)
                // console.debug("set context", $stateParams)
                requestContext.setContext($state.current.action, $stateParams);

                // Trigger the change in render conditions.
                $scope.$emit("requestContextChanged", requestContext);

            }
        );
    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config(ivhTreeviewOptionsProvider, $httpProvider) {
        // Put your custom configurations here

        ivhTreeviewOptionsProvider.set({
            defaultSelectedState: false,
            validate: true,
            expandToDepth: -1,
            twistieCollapsedTpl: '<md-icon md-svg-icon="assets/angular-material-assets/img/icons/ic_chevron_right_24px.svg"></md-icon>',
            twistieExpandedTpl: '<md-icon md-svg-icon="assets/angular-material-assets/img/icons/ic_expand_more_black_24px.svg"></md-icon>',
            twistieLeafTpl: '<span style="cursor: default;">&#8192;&#8192;</span>'
        });
        $httpProvider.interceptors.push('resourceInterceptor');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        /**
         * Here you can find all the definitions that the Demo Project requires
         *
         * If you wish to use this method, you can create your API definitions
         * in a similar way.
         */

        /*
         api.dashboard = {
         project  : $resource(api.baseUrl + 'dashboard/project/data.json'),
         server   : $resource(api.baseUrl + 'dashboard/server/data.json'),
         analytics: $resource(api.baseUrl + 'dashboard/analytics/data.json')
         };

         api.cards = $resource(api.baseUrl + 'cards/cards.json');

         api.fileManager = {
         documents: $resource(api.baseUrl + 'file-manager/documents.json')
         };

         api.ganttChart = {
         tasks: $resource(api.baseUrl + 'gantt-chart/tasks.json'),
         timespans : $resource(api.baseUrl + 'gantt-chart/timespans.json')
         };

         api.icons = $resource('assets/icons/selection.json');

         api.invoice = $resource(api.baseUrl + 'invoice/invoice.json');

         api.mail = {
         inbox: $resource(api.baseUrl + 'mail/inbox.json')
         };

         api.profile = {
         timeline    : $resource(api.baseUrl + 'profile/timeline.json'),
         about       : $resource(api.baseUrl + 'profile/about.json'),
         photosVideos: $resource(api.baseUrl + 'profile/photos-videos.json')
         };

         api.quickPanel = {
         activities: $resource(api.baseUrl + 'quick-panel/activities.json'),
         contacts  : $resource(api.baseUrl + 'quick-panel/contacts.json'),
         events    : $resource(api.baseUrl + 'quick-panel/events.json'),
         notes     : $resource(api.baseUrl + 'quick-panel/notes.json')
         };

         api.search = {
         classic : $resource(api.baseUrl + 'search/classic.json'),
         mails   : $resource(api.baseUrl + 'search/mails.json'),
         users   : $resource(api.baseUrl + 'search/users.json'),
         contacts: $resource(api.baseUrl + 'search/contacts.json')
         };

         api.scrumboard = {
         boardList: $resource(api.baseUrl + 'scrumboard/boardList.json'),
         board    : $resource(api.baseUrl + 'scrumboard/boards/:id.json')
         };

         api.tables = {
         employees   : $resource(api.baseUrl + 'tables/employees.json'),
         employees100: $resource(api.baseUrl + 'tables/employees100.json')
         };

         api.timeline = {
         page1: $resource(api.baseUrl + 'timeline/page-1.json'),
         page2: $resource(api.baseUrl + 'timeline/page-2.json'),
         page3: $resource(api.baseUrl + 'timeline/page-3.json')
         };

         api.todo = {
         tasks: $resource(api.baseUrl + 'todo/tasks.json'),
         tags : $resource(api.baseUrl + 'todo/tags.json')
         };
         */

        return api;
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login-v2', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_login-v2', {
            url      : '/pages/auth/login-v2',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_login-v2': {
                    templateUrl: 'app/main/pages/auth/login-v2/login-v2.html',
                    controller : 'LoginV2Controller as vm'
                }
            },
            bodyClass: 'login-v2'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/login-v2');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.login-v2', {
            title : 'Login v2',
            state : 'app.pages_auth_login-v2',
            weight: 2
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.evolution', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider,msUtilProvider) {

        // State


        $stateProvider.state('app.evolution', {
            url: '/evolution',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/evolution/evolution.html'
                    // controller: 'RiskController as vm'
                }
            },
            bodyClass: 'evolution'
        });

        $stateProvider
            .state('app.site_overview.evolution', {
                abstract: true,
                url: '/evolution',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/evolution/evolution.html'
                        // controller: 'RiskController as vm'
                    }
                },
                onEnter: function ($stateParams) {
                },
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                },
            })
            .state('app.site_overview.evolution.list', {
                url: '/:domain',
                onEnter: function () {
                },
                data: {
                },
                resolve: {
                },
            })
        // Translation
        var base = 'app/main/apps/evolution';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.imputation', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msUtilProvider) {

        // State


        $stateProvider.state('app.imputation', {
            url: '/imputation',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/imputation/imputation.html'
                    // controller: 'RiskController as vm'
                }
            },
            bodyClass: 'imputation'
        });

        $stateProvider
            .state('app.site_overview.imputation', {
                abstract: true,
                url: '/imputation',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/imputation/imputation.html'
                        // controller: 'RiskController as vm'
                    }
                },
                onEnter: function ($stateParams) {
                },
                data: {
                    displayName: '{{owner}}'
                },
                resolve: {
                },
            })
            .state('app.site_overview.imputation.list', {
                url: '/:domain',
                onEnter: function () {
                },
                data: {
                },
                resolve: {
                },
            })
        // Translation
        var base = 'app/main/apps/imputation';
        var base18 = base + '/i18n/';
        $translatePartialLoaderProvider.addPart(base);
        if (msUtilProvider.$get().getTenantTranslate(base18)) {
            $translatePartialLoaderProvider.addPart(base18 + msUtilProvider.$get().getBranding().i18n);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards', [
            'app.dashboards.project',
            'app.dashboards.server',
            'app.dashboards.analytics'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.ui', [
            'app.ui.forms',
            //'app.ui.treeview',
            'app.ui.helper-classes',
            'app.ui.icons',
            'app.ui.material-colors',
            'app.ui.page-layouts.blank',
            'app.ui.page-layouts.carded.fullwidth',
            'app.ui.page-layouts.carded.fullwidth-ii',
            'app.ui.page-layouts.carded.left-sidenav',
            'app.ui.page-layouts.carded.left-sidenav-ii',
            'app.ui.page-layouts.carded.right-sidenav',
            'app.ui.page-layouts.carded.right-sidenav-ii',
            'app.ui.page-layouts.simple.fullwidth',
            'app.ui.page-layouts.simple.left-sidenav',
            'app.ui.page-layouts.simple.left-sidenav-ii',
            'app.ui.page-layouts.simple.left-sidenav-iii',
            'app.ui.page-layouts.simple.right-sidenav',
            'app.ui.page-layouts.simple.right-sidenav-ii',
            'app.ui.page-layouts.simple.right-sidenav-iii',
            'app.ui.page-layouts.simple.tabbed',
            'app.ui.theme-colors',
            'app.ui.typography'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('ui', {
            title : 'USER INTERFACE',
            group : true,
            weight: 3
        });

        msNavigationServiceProvider.saveItem('ui.forms', {
            title: 'Forms',
            icon : 'icon-window-restore',
            state: 'app.ui_forms'
        });

        msNavigationServiceProvider.saveItem('ui.icons', {
            title: 'Icons',
            icon : 'icon-file-image-box',
            state: 'app.ui_icons'
        });

        msNavigationServiceProvider.saveItem('ui.typography', {
            title: 'Typography',
            icon : 'icon-format-size',
            state: 'app.ui_typography'
        });

        msNavigationServiceProvider.saveItem('ui.helper-classes', {
            title: 'Helper Classes',
            icon : 'icon-help-circle',
            state: 'app.ui_helper-classes'
        });

        msNavigationServiceProvider.saveItem('ui.theme-colors', {
            title: 'Theme Colors',
            icon : 'icon-palette-advanced',
            state: 'app.ui_theme-colors'
        });

        msNavigationServiceProvider.saveItem('ui.material-colors', {
            title: 'Material Colors',
            icon : 'icon-palette',
            state: 'app.ui_material-colors'
        });


        msNavigationServiceProvider.saveItem('ui.page-layouts', {
            title: 'Page Layouts',
            icon : 'icon-view-quilt'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded', {
            title: 'Carded'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.fullwidth', {
            title: 'Full Width (I)',
            state: 'app.ui_page-layouts_carded_fullwidth'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.fullwidth-ii', {
            title: 'Full Width (II)',
            state: 'app.ui_page-layouts_carded_fullwidth-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.left-sidenav', {
            title: 'Left Sidenav (I)',
            state: 'app.ui_page-layouts_carded_left-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.left-sidenav-ii', {
            title: 'Left Sidenav (II)',
            state: 'app.ui_page-layouts_carded_left-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.right-sidenav', {
            title: 'Right Sidenav (I)',
            state: 'app.ui_page-layouts_carded_right-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.right-sidenav-ii', {
            title: 'Right Sidenav (II)',
            state: 'app.ui_page-layouts_carded_right-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple', {
            title: 'Simple'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.fullwidth', {
            title: 'Full Width (I)',
            state: 'app.ui_page-layouts_simple_fullwidth'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.left-sidenav', {
            title: 'Left Sidenav (I)',
            state: 'app.ui_page-layouts_simple_left-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.left-sidenav-ii', {
            title: 'Left Sidenav (II)',
            state: 'app.ui_page-layouts_simple_left-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.left-sidenav-iii', {
            title: 'Left Sidenav (III)',
            state: 'app.ui_page-layouts_simple_left-sidenav-iii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.right-sidenav', {
            title: 'Right Sidenav (I)',
            state: 'app.ui_page-layouts_simple_right-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.right-sidenav-ii', {
            title: 'Right Sidenav (II)',
            state: 'app.ui_page-layouts_simple_right-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.right-sidenav-iii', {
            title: 'Right Sidenav (III)',
            state: 'app.ui_page-layouts_simple_right-sidenav-iii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.tabbed', {
            title: 'Tabbed',
            state: 'app.ui_page-layouts_simple_tabbed'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.blank', {
            title: 'Blank',
            state: 'app.ui_page-layouts_blank'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages', [
            'app.pages.auth.login',
            'app.pages.auth.login-v2',
            'app.pages.auth.register',
            'app.pages.auth.register-v2',
            'app.pages.auth.forgot-password',
            'app.pages.auth.reset-password',
            'app.pages.auth.lock',
            'app.pages.coming-soon',
            'app.pages.error-404',
            'app.pages.error-500',
            'app.pages.invoice',
            'app.pages.maintenance',
            'app.pages.profile',
            'app.pages.search',
            'app.pages.timeline'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('pages', {
            title : 'PAGES',
            group : true,
            weight: 2
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.components', [
            'app.components.cards',
            'app.components.charts.c3',
            'app.components.charts.chartist',
            'app.components.charts.chart-js',
            'app.components.charts.nvd3',
            'app.components.custom-directives',
            'app.components.maps',
            'app.components.price-tables',
            'app.components.tables.simple-table',
            'app.components.tables.datatable',
            'app.components.widgets',
            'app.components.material-docs'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('components', {
            title : 'COMPONENTS',
            group : true,
            weight: 4
        });

        msNavigationServiceProvider.saveItem('components.cards', {
            title : 'Cards',
            icon  : 'icon-content-copy',
            state : 'app.components_cards',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('components.charts', {
            title : 'Charts',
            icon  : 'icon-poll',
            weight: 4
        });

        msNavigationServiceProvider.saveItem('components.charts.c3', {
            title: 'C3',
            state: 'app.components_charts_c3'
        });

        msNavigationServiceProvider.saveItem('components.charts.chart-js', {
            title: 'Chart.js',
            state: 'app.components_charts_chart-js'
        });

        msNavigationServiceProvider.saveItem('components.charts.chartist', {
            title: 'Chartist',
            state: 'app.components_charts_chartist'
        });

        msNavigationServiceProvider.saveItem('components.charts.nvd3', {
            title: 'nvD3',
            state: 'app.components_charts_nvd3'
        });

        msNavigationServiceProvider.saveItem('components.maps', {
            title: 'Maps',
            icon : 'icon-map-marker',
            state: 'app.components_maps',
            weight: 5
        });

        msNavigationServiceProvider.saveItem('components.price-tables', {
            title: 'Price Tables',
            icon : 'icon-view-carousel',
            state: 'app.components_price-tables',
            weight: 6
        });

        msNavigationServiceProvider.saveItem('components.tables', {
            title: 'Tables',
            icon : 'icon-table-large',
            weight: 7
        });

        msNavigationServiceProvider.saveItem('components.tables.simple-table', {
            title: 'Simple Table',
            state: 'app.components_tables_simple-table',
            weight: 8
        });

        msNavigationServiceProvider.saveItem('components.tables.datatable', {
            title: 'Datatable',
            state: 'app.components_tables_datatable',
            weight: 9
        });

        msNavigationServiceProvider.saveItem('components.widgets', {
            title: 'Widgets',
            icon : 'icon-apps',
            state: 'app.components_widgets',
            weight: 10
        });
    }
})();
angular.module('fuse').run(['$templateCache', function($templateCache) {$templateCache.put('app/quick-panel/quick-panel.html','<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs="always"><md-tab><md-tab-label><span \ntranslate="QUICKPANEL.TODAY">TODAY</span></md-tab-label><md-tab-body><md-content class="today-tab scrollable" \nms-scroll ng-include="\'app/quick-panel/tabs/today/today-tab.html\'"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate="QUICKPANEL.CHAT">CHAT</span></md-tab-label><md-tab-body><md-content \nclass="chat-tab scrollable" ms-scroll ng-include="\'app/quick-panel/tabs/chat/chat-tab.html\'" \nng-controller="ChatTabController as vm"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate="QUICKPANEL.ACTIVITY">ACTIVITY</span></md-tab-label><md-tab-body><md-content class="activity-tab scrollable" \nms-scroll ng-include="\'app/quick-panel/tabs/activity/activity-tab.html\'"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>');
$templateCache.put('app/core/theme-options/theme-options.html','<div class="ms-theme-options-panel" layout="row" layout-align="start start"><div \nclass="ms-theme-options-panel-button md-primary-bg" ng-click="toggleOptionsPanel()"><md-icon md-font-icon="icon-cog" \nclass="white-text"></md-icon></div><div class="ms-theme-options-list" layout="column"><div class="theme-option"><div \nclass="option-title">Layout Style:</div><md-radio-group layout="column" ng-model="vm.layoutStyle" \nng-change="vm.updateLayoutStyle()"><md-radio-button value="verticalNavigation">Vertical Navigation</md-radio-button>\n<md-radio-button value="verticalNavigationFullwidthToolbar">Vertical Navigation with Fullwidth Toolbar\n</md-radio-button><md-radio-button value="verticalNavigationFullwidthToolbar2">\nVertical Navigation with Fullwidth Toolbar 2</md-radio-button><md-radio-button value="horizontalNavigation">\nHorizontal Navigation</md-radio-button><md-radio-button value="contentOnly">Content Only</md-radio-button>\n<md-radio-button value="contentWithToolbar">Content with Toolbar</md-radio-button></md-radio-group></div><md-divider>\n</md-divider><div class="theme-option"><div class="option-title">Layout Mode:</div><md-radio-group layout="row" \nlayout-align="start center" ng-model="vm.layoutMode" ng-change="vm.updateLayoutMode()"><md-radio-button value="boxed">\nBoxed</md-radio-button><md-radio-button value="wide">Wide</md-radio-button></md-radio-group></div><md-divider>\n</md-divider><div class="theme-option"><div class="option-title">Color Palette:</div><md-menu-item \nng-repeat="(themeName, theme) in vm.themes.list" class="theme"><md-button class="md-raised theme-button" \naria-label="{{themeName}}" ng-click="vm.setActiveTheme(themeName)" \nng-style="{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}" \nng-class="themeName"><span><md-icon ng-style="{\'color\': theme.primary.contrast1}" md-font-icon="icon-palette">\n</md-icon><span>{{themeName}}</span></span></md-button></md-menu-item></div></div></div>');
$templateCache.put('app/core/layouts/content-only.html','<div id="layout-content-only" class="template-layout" layout="column" flex><md-content id="content" \nclass="animate-slide-up md-background md-hue-1" ui-view="content" flex></md-content></div>');
$templateCache.put('app/core/layouts/content-with-toolbar.html','<div id="layout-content-with-toolbar" class="template-layout" layout="column" flex><md-toolbar id="toolbar" \nclass="md-menu-toolbar md-whiteframe-1dp" ui-view="toolbar"></md-toolbar><md-content id="content" \nclass="animate-slide-up md-background md-hue-1" ui-view="content" flex></md-content><md-sidenav id="quick-panel" \nclass="md-sidenav-right md-whiteframe-4dp" md-component-id="quick-panel" ms-scroll ui-view="quickPanel"></md-sidenav>\n</div>');
$templateCache.put('app/core/layouts/horizontal-navigation.html','<div id="layout-horizontal-navigation" class="template-layout" layout="column" flex><md-toolbar id="toolbar" \nclass="md-menu-toolbar" ui-view="toolbar"></md-toolbar><div id="horizontal-navigation" class="md-whiteframe-1dp" \nui-view="navigation"></div><div id="content-container" flex layout="column"><md-content id="content" \nclass="animate-slide-up md-background md-hue-1" ms-scroll ui-view="content" flex></md-content></div><md-sidenav \nid="quick-panel" class="md-sidenav-right md-whiteframe-4dp" md-component-id="quick-panel" ms-scroll \nui-view="quickPanel"></md-sidenav></div>');
$templateCache.put('app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html','<div id="layout-vertical-navigation-fullwidth-toolbar-2" class="template-layout" layout="column" flex><md-toolbar \nid="toolbar" class="md-menu-toolbar md-whiteframe-1dp md-accent" ui-view="toolbar"></md-toolbar><div \nid="main-container" layout="row" flex><md-sidenav id="vertical-navigation" class="md-primary-bg" \nmd-is-locked-open="$mdMedia(\'gt-sm\')" md-component-id="navigation" ms-scroll ui-view="navigation"></md-sidenav><div \nid="content-container" flex layout="column"><md-content id="content" class="animate-slide-up md-background md-hue-1" \nms-scroll ui-view="content" flex></md-content></div><md-sidenav id="quick-panel" \nclass="md-sidenav-right md-whiteframe-4dp" md-component-id="quick-panel" ms-scroll ui-view="quickPanel"></md-sidenav>\n</div></div>');
$templateCache.put('app/core/layouts/vertical-navigation-fullwidth-toolbar.html','<div id="layout-vertical-navigation-fullwidth-toolbar" class="template-layout" layout="column" flex><md-toolbar \nid="toolbar" class="md-menu-toolbar md-whiteframe-1dp md-accent" ui-view="toolbar"></md-toolbar><div \nid="main-container" layout="row" flex><md-sidenav id="vertical-navigation" class="md-primary-bg" \nmd-is-locked-open="$mdMedia(\'gt-sm\')" md-component-id="navigation" ms-scroll ui-view="navigation"></md-sidenav><div \nid="content-container" flex layout="column"><md-content id="content" class="animate-slide-up md-background md-hue-1" \nms-scroll ui-view="content" flex></md-content></div><md-sidenav id="quick-panel" \nclass="md-sidenav-right md-whiteframe-4dp" md-component-id="quick-panel" ms-scroll ui-view="quickPanel"></md-sidenav>\n</div></div>');
$templateCache.put('app/core/layouts/vertical-navigation.html','<div id="layout-vertical-navigation" class="template-layout" layout="row" flex><md-sidenav id="vertical-navigation" \nng-style="{\'background-color\' : vm.branding.sidenav }" class="md-primary-bg" md-is-locked-open="$mdMedia(\'gt-sm\')" \nmd-component-id="navigation" ms-scroll ui-view="navigation"></md-sidenav><div id="content-container" flex \nlayout="column"><md-toolbar id="toolbar" class="md-menu-toolbar md-whiteframe-1dp" ui-view="toolbar" \nng-style="{\'background-color\': vm.branding.BackgroundColor, \'border-bottom\': \'6px solid \' + vm.branding.accentColor}">\n</md-toolbar><md-content id="content" class="animate-slide-up md-background md-hue-1" ms-scroll ui-view="content" flex>\n</md-content></div><md-sidenav id="quick-panel" class="md-sidenav-right md-whiteframe-4dp" \nmd-component-id="quick-panel" ms-scroll ui-view="quickPanel"></md-sidenav></div>');
$templateCache.put('app/main/public/auth-callback.html','<div id="login" \nng-style="{\'background-image\': \'url(\' + ((vm.branding && vm.branding.loginBackground) || \'/assets/images/backgrounds/homeh2c.jpg\') + \')\', \'background-repeat\': \'no-repeat\', \'background-size\': \'cover\'}" \nclass="flex-scrollable" layout="column" ms-scroll><div id="login-form-wrapper" layout="column" \nlayout-align="center center"><div id="login-form" class="md-whiteframe-8dp"><div class="logo"><img \nng-src="{{vm.branding.logoLogin}}"></div><div class="title">\n{{ \'LOGIN.INTRO_TITLEQ\' | translate | uppercase }} {{(vm.branding.companyname ? vm.branding.companyname : \'H2C\') | uppercase}}\n</div><div layout="column" layout-align="center center" class="p-24"><md-progress-circular md-mode="indeterminate" \nmd-diameter="48"></md-progress-circular><p class="md-body-1 mt-16" translate="LOGIN.PROCESSING_LOGIN"></p></div></div>\n</div></div>');
$templateCache.put('app/main/public/auth-google-linked.html','<div class="auth-google-linked p-24" layout="column" layout-align="center center" flex><md-card \nclass="md-whiteframe-4dp" style="max-width: 400px;"><md-card-content class="p-24" layout="column" \nlayout-align="center center"><md-icon md-font-icon="icon-check-circle" class="s72 green-fg mb-16"></md-icon><h2 \nclass="md-title mb-8" translate="STAFF.GOOGLE_LINKED_SUCCESS"></h2><p class="md-body-1 grey-600-fg" \ntranslate="STAFF.GOOGLE_LINKED_CLOSING"></p></md-card-content></md-card></div>');
$templateCache.put('app/main/public/login-2fa.html','<div id="login" style="background : url({{vm.branding.loginBackground}}) no-repeat; background-size: cover;" \nclass="flex-scrollable" layout="column" ms-scroll><div id="login-form-wrapper" layout="column" \nlayout-align="center center"><div ng-if="!vm.success" id="login-form" class="md-whiteframe-8dp"><div class="logo"><img \nng-src="{{vm.branding.logoLogin}}"></div><div class="title">\n{{ \'LOGIN.INTRO_TITLEQ\' | translate | uppercase }} {{(vm.branding.companyname ? vm.branding.companyname : \'H2C\') | uppercase}}\n</div><div flex layout-align="space-between center" ng-if="vm.loading"><md-progress-circular md-mode="indeterminate">\n</md-progress-circular></div><div><form name="forgotForm" novalidate ng-submit="forgot(forgotForm)"><md-input-container\n class="md-block" md-no-float><input type="text" name="code" ng-model="vm.code" placeholder="code" translate \ntranslate-attr-placeholder="LOGIN.CODE" required></md-input-container><md-button ng-click="vm.validate(vm.code)" \ntype="submit" class="md-raised md-accent submit-button" aria-label="LOG IN" ng-disabled="!vm.code" \ntranslate="LOGIN.LOG_IN" translate-attr-aria-label="LOGIN.LOG_IN">LOG_IN</md-button></form></div></div></div></div>');
$templateCache.put('app/main/public/login-forgot.html','<div id="login" style="background : url({{vm.branding.loginBackground}}) no-repeat; background-size: cover;" \nclass="flex-scrollable" layout="column" ms-scroll><div id="login-form-wrapper" layout="column" \nlayout-align="center center"><div ng-if="!vm.success" id="login-form" class="md-whiteframe-8dp"><div class="logo"><img \nng-src="{{vm.branding.logoLogin}}"></div><div class="title" translate="LOGIN.RECOVER_PASSWORD"></div><div flex \nlayout-align="space-between center" ng-if="vm.loading"><md-progress-circular md-mode="indeterminate">\n</md-progress-circular></div><div><form name="forgotForm" novalidate ng-submit="forgot(forgotForm)"><md-input-container\n class="md-block" md-no-float><input type="text" name="account" ng-model="vm.form.account_alias" placeholder="Account" \ntranslate translate-attr-placeholder="LOGIN.ACCOUNT" required><div ng-messages="forgotForm.account.$error" \nrole="alert"><div ng-message="required"><span translate="LOGIN.ERRORS.ACCOUNT_REQUIRED"></span></div></div>\n</md-input-container><md-input-container class="md-block" md-no-float><input type="text" name="email" \nng-model="vm.form.email" placeholder="Email" translate translate-attr-placeholder="LOGIN.EMAIL" required><div \nng-messages="forgotForm.email.$error" role="alert"><div ng-message="required"><span \ntranslate="LOGIN.ERRORS.EMAIL_REQUIRED"></span></div></div></md-input-container><md-button type="submit" \nclass="md-raised md-accent submit-button" aria-label="LOG IN" \nng-disabled="forgotForm.$invalid || forgotForm.$pristine" translate="LOGIN.RECOVER" \ntranslate-attr-aria-label="LOGIN.RECOVER">RECOVER</md-button><div class="remember-forgot-password" layout="row" \nlayout-sm="column" layout-align="space-between center"><a ui-sref="public.login" \nclass="forgot-password pointer md-accent-color m-auto" translate="LOGIN.BACK">Volver</a></div></form></div></div><div \nng-if="vm.success" id="login-form" class="md-whiteframe-8dp"><div class="logo"><img ng-src="{{vm.branding.logoLogin}}">\n</div><div class="title" translate="LOGIN.RECOVER_PASSWORD_SUCCESSFULLY"></div><div flex \nlayout-align="space-between center" ng-if="vm.loading"><md-progress-circular md-mode="indeterminate">\n</md-progress-circular></div></div></div></div>');
$templateCache.put('app/main/public/login-recover.html','<div id="login" style="background : url({{vm.branding.loginBackground}}) no-repeat; background-size: cover;" \nclass="flex-scrollable" layout="column" ms-scroll><div id="login-form-wrapper" layout="column" \nlayout-align="center center"><div ng-if="!vm.success" id="login-form" class="md-whiteframe-8dp"><div class="logo"><img \nng-src="{{vm.branding.logo}}"></div><div class="title" translate="LOGIN.RECOVER_PASSWORD"></div><div flex \nlayout-align="space-between center" ng-if="vm.loading"><md-progress-circular md-mode="indeterminate">\n</md-progress-circular></div><div><form name="recoverForm" novalidate ng-submit="restore(recoverForm)">\n<md-input-container class="md-block" md-no-float><input type="text" name="account" ng-model="vm.form.account_alias" \nplaceholder="Account" translate translate-attr-placeholder="LOGIN.ACCOUNT" required><div \nng-messages="recoverForm.account.$error" role="alert"><div ng-message="required"><span \ntranslate="LOGIN.ERRORS.ACCOUNT_REQUIRED"></span></div></div></md-input-container><md-input-container class="md-block" \nmd-no-float><input type="password" name="password" ng-model="vm.form.password" placeholder="Password" translate \ntranslate-attr-placeholder="LOGIN.PASSWORD" required><div ng-messages="recoverForm.password.$error" role="alert"><div \nng-message="required"><span translate="LOGIN.ERRORS.PASSWORD_REQUIRED"></span></div></div></md-input-container>\n<md-input-container class="md-block" md-no-float><input type="password" name="passwordRepeat" \nng-model="vm.form.passwordRepeat" placeholder="Password repeat" translate \ntranslate-attr-placeholder="LOGIN.PASSWORD_REPEAT" required><div ng-messages="recoverForm.passwordRepeat.$error" \nrole="alert"><div ng-message="required"><span translate="LOGIN.ERRORS.PASSWORD_REQUIRED"></span></div></div>\n</md-input-container><div ng-if="vm.notmatch" role="alert" multiple="" \nclass="md-input-messages-animation md-auto-hide ng-active" aria-live="assertive"><div \nclass="md-input-message-animation ng-scope" style="opacity: 1; margin-top: 0px; color: red"><span \ntranslate="LOGIN.ERRORS.PASSWORD_NOT_MATCH" class="ng-scope"></span></div></div><md-button type="submit" \nclass="md-raised md-accent submit-button" aria-label="LOG IN" \nng-disabled="recoverForm.$invalid || forgotForm.$pristine" translate="LOGIN.RESTORE" \ntranslate-attr-aria-label="LOGIN.RESTORE">RESTORE</md-button><div class="remember-forgot-password" layout="row" \nlayout-sm="column" layout-align="space-between center"><a ui-sref="public.login" \nclass="forgot-password pointer md-accent-color m-auto" translate="LOGIN.BACK_TO_LOGIN">Volver a login</a></div></form>\n</div></div><div ng-if="vm.success" id="login-form" class="md-whiteframe-8dp"><div class="logo"><img \nng-src="{{vm.branding.logoLogin}}"></div><div class="title" translate="LOGIN.RESTORE_PASSWORD_SUCCESSFULLY"></div><div \nclass="remember-forgot-password" layout="row" layout-sm="column" layout-align="space-between center"><a \nui-sref="public.login" class="forgot-password pointer md-accent-color m-auto" translate="LOGIN.BACK_TO_LOGIN">\nVolver a login</a></div></div></div></div>');
$templateCache.put('app/main/public/login-setup.html','<div id="login" style="background : url({{vm.branding.loginBackground}}) no-repeat; background-size: cover;" \nclass="flex-scrollable" layout="column" ms-scroll><div id="login-form-wrapper" layout="column" \nlayout-align="center center"><div ng-if="!vm.success" id="login-form" class="md-whiteframe-8dp" \nstyle="padding-top: 0px;"><div class="logo" style="margin-bottom: 0px;"><img class="logo-responsive" \nng-src="{{vm.branding.logoLogin}}"></div><div class="title" style="margin: 0px" translate="LOGIN.SETUP_MESSAGE"></div>\n<p translate="LOGIN.SETUP_MESSAGE_1"></p><div class="so" layout="column" layout-align="center center"><a \nhref="https://apple.co/2J2U1dD" target="_blank" style="margin-bottom: 10px;"><img height="60" \nsrc="assets/images/download-apple.png"> </a><a href="http://bit.ly/2TBSEGZ" target="_blank"><img height="60" \nsrc="assets/images/download-google.png"></a></div><p translate="LOGIN.SETUP_MESSAGE_2"></p><div flex \nlayout-align="space-between center" ng-if="vm.loading"><md-progress-circular md-mode="indeterminate">\n</md-progress-circular></div><div><form name="setupForm" class="text-center" novalidate><h4 class="mb-0 text-center">\n{{vm.secret.secret}}</h4><div class="text-center"><img style="height: 150px" ng-src="{{vm.secret.qrCode}}"></div>\n<md-input-container class="md-block" md-no-float><input type="text" name="email" ng-model="vm.code" \nplaceholder="{{ \'LOGIN.CODE\' | translate}}" translate translate-attr-placeholder="LOGIN.CODE" required>\n</md-input-container><md-button type="submit" class="md-raised md-accent submit-button" \nng-click="vm.validate(vm.code)" ng-disabled="!vm.code" translate="LOGIN.VALIDATE" \ntranslate-attr-aria-label="LOGIN.VALIDATE">VALIDATE</md-button></form></div></div><div ng-if="vm.success" \nid="login-form" class="md-whiteframe-8dp"><div class="logo"><img ng-src="{{vm.branding.logoLogin}}"></div><div \nclass="title" translate="LOGIN.SETUP_MESSAGE_3"></div><div class="remember-forgot-password" layout="row" \nlayout-sm="column" layout-align="space-between center"><a ui-sref="public.login" \nclass="forgot-password pointer md-accent-color m-auto" translate="LOGIN.LOGIN">Ir al login.</a></div><div flex \nlayout-align="space-between center" ng-if="vm.loading"><md-progress-circular md-mode="indeterminate">\n</md-progress-circular></div></div></div></div>');
$templateCache.put('app/main/public/login.html','<div id="login" style="background : url({{vm.branding.loginBackground}}) no-repeat; background-size: cover;" \nclass="flex-scrollable" layout="column" ms-scroll><div id="login-form-wrapper" layout="column" \nlayout-align="center center"><div id="login-form" class="md-whiteframe-8dp"><div class="logo"><img \nng-src="{{vm.branding.logoLogin}}"></div><div class="title">\n{{ \'LOGIN.INTRO_TITLEQ\' | translate | uppercase }} {{(vm.branding.companyname ? vm.branding.companyname : \'H2C\') | uppercase}}\n</div><div flex layout-align="space-between center" ng-if="vm.loading"><md-progress-circular md-mode="indeterminate">\n</md-progress-circular></div><div ng-if="!vm.loading"><form name="loginForm" novalidate ng-submit="login(loginForm)">\n<md-input-container class="md-block" md-no-float><input type="text" name="account" ng-model="vm.form.account_alias" \nplaceholder="Account" translate translate-attr-placeholder="LOGIN.ACCOUNT" required><div \nng-messages="loginForm.account.$error" role="alert"><div ng-message="required"><span \ntranslate="LOGIN.ERRORS.ACCOUNT_REQUIRED"></span></div></div></md-input-container><md-input-container class="md-block" \nmd-no-float><input type="email" name="email" ng-model="vm.form.email" placeholder="Email" translate \ntranslate-attr-placeholder="LOGIN.EMAIL" ng-pattern="/^.+@.+\\..+$/" required autocomplete="username"><div \nng-messages="loginForm.email.$error" role="alert" multiple="multiple"><div ng-message="required"><span \ntranslate="LOGIN.ERRORS.EMAIL_REQUIRED">Email field is required</span></div><div ng-message="pattern"><span \ntranslate="LOGIN.ERRORS.EMAIL_MUST_VALID">Email must be a valid e-mail address</span></div></div></md-input-container>\n<md-input-container class="md-block" md-no-float><input type="password" name="password" ng-model="vm.form.password" \nplaceholder="Password" translate translate-attr-placeholder="LOGIN.PASSWORD" required autocomplete="current-password">\n<div ng-messages="loginForm.password.$error" role="alert"><div ng-message="required"><span \ntranslate="LOGIN.ERRORS.PASSWORD_REQUIRED">Password field is required</span></div></div></md-input-container><div \nclass="remember-forgot-password" layout="row" layout-sm="column" layout-align="space-between center"><md-checkbox \nclass="remember-me" ng-model="data.cb1" aria-label="Remember Me"><span translate="LOGIN.REMEMBER_ME">Remember Me</span>\n</md-checkbox><a ui-sref="public.forgot" class="forgot-password md-accent-color" translate="LOGIN.FORGOT_PASSWORD">\nForgot Password?</a></div><md-button type="submit" class="md-raised md-accent submit-button" aria-label="LOG IN" \nng-disabled="loginForm.$invalid || loginForm.$pristine" translate="LOGIN.LOG_IN" \ntranslate-attr-aria-label="LOGIN.LOG_IN">LOG IN</md-button><div class="separator mt-16 mb-8"></div><md-button \nclass="md-raised google-login-button" ng-click="vm.loginWithGoogle()" \nng-disabled="!vm.form.account_alias || !vm.form.account_alias.trim()" aria-label="Iniciar sesi\xF3n con Google"><md-icon \nmd-svg-src="assets/angular-material-assets/img/icons/google.svg" class="s20 mr-8"></md-icon><span \ntranslate="LOGIN.WITH_GOOGLE">Iniciar sesi\xF3n con Google</span></md-button></form><md-menu id="language-menu" \nmd-offset="0 52" md-position-mode="target-left target"><md-button class="language-button" ng-click="$mdMenu.open()" \naria-label="Language" md-menu-origin md-menu-align-target><div layout="row" layout-align="center center"><img \nclass="flag img-flag" ng-src="assets/images/flags/{{vm.selectedLanguage.flag}}.png"> <span class="iso">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width="3" id="language-menu-content">\n<md-menu-item ng-repeat="(iso, lang) in vm.languages"><md-button ng-click="vm.changeLanguage(lang)" \naria-label="{{lang.title}}" translate translate-attr-aria-label="{{lang.title}}"><span layout="row" \nlayout-align="start center"><img class="flag img-flag" ng-src="assets/images/flags/{{lang.flag}}.png">&nbsp; <span \ntranslate="{{lang.translation}}">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n</div></div></div></div>');
$templateCache.put('app/main/public/sample.html','<h1>{{vm.helloText}}</h1>');
$templateCache.put('app/core/components/activity-user/activity-user.component.html','<div ng-if="vm.loadAtivityUser" class="content thread-detail" layout="row" layout-align="center center" flex><div flex \nlayout="column" layout-align="center center" class="loading-container"><md-progress-circular md-mode="indeterminate" \nmd-diameter="50"></md-progress-circular></div></div><div ng-if="!vm.loadAtivityUser"><div ng-if="vm.activityUser" \nclass="content-wrapper mb-100" flex="" layout="row"><div class="content thread-list mail-list-pane" flex \nid="thread-list"><div id="users-activity" ms-scroll="vm.msScrollOptions" \nclass="page-layout simple fullwidth mail-content content-edit" \nng-class="{\'pb-100\' : pagination_total_pages == vm.page}" layout="column"><div class="pl-25" \nng-if="vm.activityUser.length > 0" ng-repeat="(key, value) in vm.activityUser | groupBy: \'dateWithoutHours\'"><div \nclass="date">{{ key }}</div><div id="timeline" ng-repeat="event in value" class="timeline-left ms-timeline"><div \nclass="ms-timeline-item" layout="row" layout-align="start center"><div class="timeline-point md-accent-bg"><md-icon \nmd-font-icon="icon-telegram"></md-icon></div><h3 class="name mt-0 mb-0 ml-15" flex-xs="80"><div class="event">\n{{\'STAFF.\'+event.action_id.toUpperCase() | translate }} <a class="pointer" \nng-click="vm.openImageDialog($event, event.action_brief.link, false, false, true)" target="_blank">\n{{event.action_brief.name}}</a></div></h3><div class="timeline-detail" layout="row" layout-align="start center"><div \nclass="time" ng-bind-html="vm.timeAgo(event.date)"></div></div></div></div></div><div \nng-if="pagination_total_pages > vm.page &&  !vm.isLoading && vm.activityUser.length > 0" class="load-more" \nlayout="row" layout-sm="column" layout-align="center center" layout-wrap=""><md-button ng-click="vm.loadMore()" \nclass="md-raised">{{ \'GLOBAL.LOAD_MORE\' |\xA0translate}}</md-button></div><div \nng-if="!isLoading && pagination_total_pages== vm.page && vm.activityUser.length == 0 && (isLoading || vm.activityUser.length !== 0)" \nclass="content font-2rem mb-100" layout="column" layout-align="top center"><div class="message" \ntranslate="GLOBAL.NO_MORE_ACTIVITY"></div></div><div ng-if="!isLoading && vm.activityUser.length === 0" \nclass="content font-2rem" layout="column" layout-align="top center"><div class="message" \ntranslate="GLOBAL.NO_ACTIVITY"></div></div></div></div></div></div>');
$templateCache.put('app/core/components/chat-view/chat-view.component.html','<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"><div \nid="chat-app" class="page-layout carded fullwidth"><div class="center p0"><div class="content-card" \nstyle="background: #fff;" layout="column" flex><div ng-if="vm.chat" class="chat" layout="column" flex><md-content \nid="chat-content" flex ms-scroll><div ng-if="vm.chat.length> 0" class="chat-messages" ng-if="vm.chat"><div \nlayout="column" fill-width ng-repeat="dialog in vm.chat" class="md-padding message-row" \nng-class="{\'private\' : dialog.is_private}"><div layout="row"><img ng-if="!dialog.user" src="assets/images/anonimo.jpg" \nclass="avatar"> <img ng-if="dialog.user && dialog.user.files.id" ng-src="{{vm.showUserImage(dialog.user)}}" \nclass="avatar"><div class="avatar s40" \nng-class="dialog.user.profile_color ? dialog.user.profile_color : \'md-blue-grey-300-bg\'" \nng-if="dialog.user && !dialog.user.files.id" ng-bind="dialog.user.first_name | capitalizeFirstLetter"></div><div \nclass=""><strong class="grey-800-fg" ng-if="dialog.user" \nng-bind-html="dialog.user.first_name + \' \' + dialog.user.last_name"></strong> <strong class="grey-800-fg" \nng-if="!dialog.user && vm.anonymous">{{\'COMPLAINTS.ANONYMOUS\' | translate}}</strong> <strong class="grey-800-fg" \nng-if="!dialog.user && !vm.anonymous">{{vm.anonymousname}}</strong> <span class="ml-5 time secondary-text"><i \nclass="fa fa-clock-o"></i> {{dialog.created_at|altDate}}</span><md-button class="md-icon-button chat-read-receipt" \ntranslate-attr-aria-label="COMPLAINTS.MESSAGE_READ_RECEIPT_ARIA" ng-if="dialog.user_id && !dialog.is_private" \nng-click="vm.showReceipt($event, dialog)"><md-icon \nmd-font-icon="{{ dialog.complainant_viewed_at ? \'icon-check-all\' : \'icon-check\' }}" \nng-class="dialog.complainant_viewed_at ? \'chat-read-receipt-icon\' : \'chat-delivered-receipt-icon\'"></md-icon>\n<md-tooltip md-direction="bottom">\n{{ (dialog.complainant_viewed_at ? \'COMPLAINTS.MESSAGE_READ_RECEIPT_TOOLTIP\' : \'COMPLAINTS.MESSAGE_DELIVERED_RECEIPT_TOOLTIP\') | translate }}\n</md-tooltip></md-button><span class="ml-5" ng-if="dialog.is_private"><md-icon md-font-icon="icon-eye-off"><md-tooltip \nmd-direction="bottom">{{\'COMPLAINTS.PRIVATE\' |translate}}</md-tooltip></md-icon></span><div class="message" \nng-bind-html="dialog.text"></div></div></div><div class="m-10" \nng-if="(dialog.files && dialog.files.length > 0) || (vm.files[dialog.id] && vm.files[dialog.id].length > 0)" \nlayout="column"><div class="mail-list-item attachment mv-5 pointer" ng-repeat="file in dialog.files" \ndata-id="{{file.id}}"><a style="text-decoration: none;" href="{{file.url | buildFileUrl:storagePrefix}}" \ntarget="_blank"><div layout="row" layout-align="start center"><div fill-width layout="row" layout-align="start center">\n<div ng-if="isFileType(file.url, \'image\')" class="preview"><img ng-src="{{file.url | buildFileUrl:storagePrefix}}" \nalt="{{file.original_name}}" style="max-width: 100px; max-height: 100px;"></div><div \nng-if="isFileType(file.url, \'video\')" class="preview-video" \nstyle="position: relative; max-width: 100px; max-height: 100px;"><video \nng-src="{{file.url | buildFileUrl:storagePrefix}}" style="max-width: 100%; max-height: 100%;" muted></video><div \nclass="play-button" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"><md-icon \nmd-font-icon="icon-play" class="white-fg" style="font-size: 30px;"></md-icon></div></div><div \nng-if="isFileType(file.url, \'pdf\')" class="preview-pdf m-10"><md-icon md-font-icon="icon-file-pdf" class="red-fg" \nstyle="font-size: 40px;"></md-icon></div><div ng-if="isFileType(file.url, \'word\')" class="preview-word m-10"><md-icon \nmd-font-icon="icon-file-word" class="blue-fg" style="font-size: 40px;"></md-icon></div><div \nng-if="isFileType(file.url, \'excel\')" class="preview-excel m-10"><md-icon md-font-icon="icon-file-excel" \nclass="green-fg" style="font-size: 40px;"></md-icon></div><div ng-if="isFileType(file.url, \'audio\')" \nclass="preview-audio m-10"><i class="fa fa-music" aria-hidden="true" style="font-size: 40px; color: #1e88e5;"></i>\n</div><div ng-if="isFileType(file.url, \'zip\')" class="preview-zip m-10"><md-icon md-font-icon="icon-file-zip" \nclass="yellow-fg" style="font-size: 40px;"></md-icon></div><div \nng-if="!isFileType(file.url, \'image\') && !isFileType(file.url, \'video\') && !isFileType(file.url, \'pdf\') && !isFileType(file.url, \'word\') && !isFileType(file.url, \'excel\') && !isFileType(file.url, \'audio\') && !isFileType(file.url, \'zip\')">\n<md-icon md-font-icon="icon-attachment" class="grey-400-fg m-10" style="font-size: 40px;"></md-icon></div><div \nclass="info ml-10" flex layout="column"><div class="subject text-truncate grey-500-fg" layout="row" \nlayout-align="start center"></div><div class="name" layout="row" layout-align="start center"><span \nng-if="file.original_name">{{file.original_name}}</span></div></div></div></div></a></div><div \nclass="mail-list-item attachment mv-5 pointer" ng-repeat="file in vm.files[dialog.id]" data-id="{{file.id}}"><a \nstyle="text-decoration: none;" href="{{file.url | buildFileUrl:storagePrefix}}" target="_blank"><div layout="row" \nlayout-align="start center"><div fill-width layout="row" layout-align="start center"><div \nng-if="isFileType(file.url, \'image\')" class="preview"><img ng-src="{{file.url | buildFileUrl:storagePrefix}}" \nalt="{{file.original_filename}}" style="max-width: 100px; max-height: 100px;"></div><div \nng-if="isFileType(file.url, \'video\')" class="preview-video" \nstyle="position: relative; max-width: 100px; max-height: 100px;"><video \nng-src="{{file.url | buildFileUrl:storagePrefix}}" style="max-width: 100%; max-height: 100%;" muted></video><div \nclass="play-button" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"><md-icon \nmd-font-icon="icon-play" class="white-fg" style="font-size: 30px;"></md-icon></div></div><div \nng-if="isFileType(file.url, \'pdf\')" class="preview-pdf m-10"><md-icon md-font-icon="icon-file-pdf" class="red-fg" \nstyle="font-size: 40px;"></md-icon></div><div ng-if="isFileType(file.url, \'word\')" class="preview-word m-10"><md-icon \nmd-font-icon="icon-file-word" class="blue-fg" style="font-size: 40px;"></md-icon></div><div \nng-if="isFileType(file.url, \'excel\')" class="preview-excel m-10"><md-icon md-font-icon="icon-file-excel" \nclass="green-fg" style="font-size: 40px;"></md-icon></div><div ng-if="isFileType(file.url, \'audio\')" \nclass="preview-audio m-10"><i class="fa fa-music" aria-hidden="true" style="font-size: 40px; color: #1e88e5;"></i>\n</div><div ng-if="isFileType(file.url, \'zip\')" class="preview-zip m-10"><md-icon md-font-icon="icon-file-zip" \nclass="yellow-fg" style="font-size: 40px;"></md-icon></div><div \nng-if="!isFileType(file.url, \'image\') && !isFileType(file.url, \'video\') && !isFileType(file.url, \'pdf\') && !isFileType(file.url, \'word\') && !isFileType(file.url, \'excel\') && !isFileType(file.url, \'audio\') && !isFileType(file.url, \'zip\')">\n<md-icon md-font-icon="icon-attachment" class="grey-400-fg m-10" style="font-size: 40px;"></md-icon></div><div \nclass="info ml-10" flex layout="column"><div class="subject text-truncate grey-500-fg m-10" layout="row" \nlayout-align="start center"></div><div class="name" layout="row" layout-align="start center"><span \nng-if="file.original_filename">{{file.original_filename}}</span></div></div></div></div></a></div></div></div></div>\n<div style="margin-top: 20%;" ng-if="vm.chat.length == 0" class="text-center"><div class="no-thread-selected" \nlayout="column" layout-align="center center" flex><md-icon md-font-icon="icon-timelapse" class="s120 grey-400-fg">\n</md-icon><span class="hint-text">{{\'COMPLAINTS.NO_MESSAGES\' | translate}}</span></div></div><div \nclass="chat-compose-fab" layout="row" layout-align="end center"><button \nclass="add-event-button md-fab md-warn md-button md-default-theme" type="button" ng-click="vm.sendMessage($event)">\n<md-icon md-font-icon="icon-plus" role="img" aria-hidden="true"></md-icon></button></div></md-content></div></div>\n</div></div>');
$templateCache.put('app/core/components/configure-tabs/configure-tabs.component.html','<div class="toolbar grey-100-bg colored-bg" layout="row" layout-align="space-between center" \nng-if="vm.staffSelected || vm.staffNew" scroll=""><div layout="row" layout-align="start center"><div layout="column" \nlayout-align="start center"><span translate="USERS.MENU">MENU</span></div></div></div><div \nclass="mb-100 without-line scrollable preview" flex="100"><div ivh-treeview="vm.tabMenu" \nivh-treeview-options="vm.ivhOptions" class="treeview"><script type="text/ng-template">\n<div class="level-card">\n                    <span ivh-treeview-toggle>\n                        <span ivh-treeview-twistie></span>\n                    </span>\n                    <md-icon md-font-icon="{{node.icon}}"></md-icon>\n                    <span class="ivh-treeview-node-label" ivh-treeview-toggle translate="MENU.{{node.label}}">{{trvw.label(node)}}</span>\n                    <div style="float:right;">\n                        <md-icon md-font-icon="icon-checkbox-marked-circle" class="on green-fg s24" ng-if="node.active" ng-click="node.imprimir(node)"></md-icon>\n                        <md-icon md-font-icon="icon-checkbox-blank-circle-outline" class="on red-fg s24" ng-if="!node.active" ng-click="node.imprimir(node)"></md-icon>\n                    </div>\n                </div>\n                <div ivh-treeview-children></div>\n</script></div></div>');
$templateCache.put('app/core/components/control-view/control-view.component.html','<div class="content thread-detail" layout="row" layout-align="center center" flex ng-if="!vm.control"><div \nclass="no-thread-selected" layout="column" layout-align="center center" flex><md-icon md-font-icon="icon-timelapse" \nclass="s120 grey-400-fg"></md-icon><span class="hint-text">{{\'RISK.DETAILS_VIEW\' | translate}}</span></div></div><div \nclass="risk-detail-view p0" ng-if="vm.control"><div class="ph-15" flex layout="row" layout-align="start start"><div \nclass="avatar mr-10" ng-style="{\'background\': \'rgba(132,173,78,1)\'}">C</div><h1 \nng-bind-html="vm.control.rename ? vm.control.rename : vm.control.name" class="mt-0 mr-24 mb-0"></h1></div></div><div \nlayout="row" layout-align="start start" flex="100" ng-if="vm.control"><md-content flex="100"><md-tabs \nmd-dynamic-height md-border-bottom flex="100" md-selected="vm.controlTabsIndex"><md-tab><md-tab-label><span>\n{{\'RISK.EVIDENCES\' | translate}}</span></md-tab-label><md-tab-body><md-content class="" flex="100"><div \nng-if="!vm.currentEvidences" fill-width style="margin-top: 20%;" class="text-center"><div class="no-thread-selected" \nlayout="column" layout-align="center center" flex><md-icon md-font-icon="icon-timelapse" class="s120 grey-400-fg">\n</md-icon><span class="hint-text">{{\'RISK.NO_EVIDENCES_FOUND\' | translate}}</span></div></div><md-list \nng-if="vm.currentEvidences" flex="100" class="p-0" ng-show="!vm.loadingEvidences"><div \nng-repeat="evidence in vm.currentEvidences" class="evidence cursor-default" \nng-click="vm.openEvidence(evidence, $event)"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 ph-15 pb-10"><div class="info" flex layout="column"><div class="name" layout="row"><div layout="row" \nlayout-align="start center" flex="100"><div class="avatar-wrapper"><img class="avatar s24" \nng-src="{{vm.showUserImage(evidence.user)}}" ng-if="evidence.user.files.id"><div class="avatar s24" \nng-class="evidence.user.profile_color" ng-if="!evidence.user.files.id" \nng-bind="evidence.user.first_name | capitalizeFirstLetter"></div></div><div class="field mr-10 ml-10" flex><strong \nclass="grey-800-fg">{{evidence.user.first_name}} {{evidence.user.last_name}}</strong></div><div \nlayout-align="end start"><div layout="row" layout-align="space-between center"><div class="field" \nng-if="evidence.files.length> 0"><md-button class="md-icon-button" md-menu-origin md-menu-align-target><md-icon \nmd-font-icon="icon-paperclip s24"></md-icon><md-tooltip>{{evidence.files.length}} {{ \'RISK.FILES\' | translate}}\n</md-tooltip></md-button></div><strong class="grey-800-fg mr-10">\n{{evidence.amount}}{{vm.getSymbolCurrency(evidence.currency_id)}}</strong><div class="field" \nng-bind-html="vm.timeAgo(evidence.updated_at)"></div><div class="field"><md-button aria-label="ACTIONS" \nclass="md-icon-button" md-menu-origin md-menu-align-target><md-tooltip>{{vm.evidenceScoreText(evidence)}}</md-tooltip>\n<md-icon md-font-icon="icon-checkbox-blank-circle s24" ng-style="{\'color\': vm.evidenceScoreColor(evidence)}"></md-icon>\n</md-button></div></div></div></div></div><div layout="row" layout-align="start center" flex="100"><div \nclass="field mr-10 ml-10" flex><strong class="grey-800-fg" ng-bind-html="evidence.title"></strong><div \nng-if="evidence.text" class="field-evidence grey-600-fg" \nng-bind-html="(evidence.text | limitTo: 50) + (evidence.text.length> 50 ? \'...\' : \'\')"></div></div></div></div></div>\n<md-divider></md-divider></div></md-list><md-list ng-show="vm.loadingEvidences"><div class="evidence"><md-list-item>\n<div layout="row" layout-align="space-between center" flex="100" class="pt-10 pb-10"><div layout="row" \nlayout-align="start center" flex><div class="field"><md-progress-circular md-mode="indeterminate" md-diameter="30">\n</md-progress-circular></div></div></div></md-list-item></div></md-list></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span ng-bind-html="vm.translate(\'RISK.TASKS\')"></span></md-tab-label><md-tab-body><md-content><md-list \nflex="100" class="p-0" ng-show="!vm.loadingTasks"><md-list-item class="evidence" ng-if="!vm.currentTasks"><div \nlayout="row" layout-align="space-between center" flex="100" class="pt-10 pb-10"><div layout="row" \nlayout-align="start center" flex><div class="field"><p><strong class="grey-800-fg" translate="RISK.NO_TASKS_FOUND">\n</strong></p></div></div></div></md-list-item><div ng-repeat="task in vm.currentTasks" class="evidence cursor-default" \nng-if="vm.currentTasks" ng-click="vm.openTask(task, $event)" ng-class="{ \'task-complete\' : task.is_complete }"><div \nlayout="row" layout-align="start center" flex="100" class="pt-10 ph-15 pb-10"><div class="info" flex layout="column">\n<div class="name" layout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper">\n<img class="avatar s24" ng-src="{{vm.showUserImage(task.user)}}" ng-if="task.user.files.id"><div class="avatar s24" \nng-class="task.user.profile_color" ng-if="!task.user.files.id" ng-bind="task.user.first_name | capitalizeFirstLetter">\n</div></div><div class="field mr-10 ml-10" flex><strong class="grey-800-fg">\n{{task.user.first_name}} {{task.user.last_name}}</strong></div><div layout-align="end start"><div layout="row" \nlayout-align="space-between center"><div class="field" ng-if="task.files.length> 0"><md-icon \nmd-font-icon="icon-paperclip s24"></md-icon></div><div class="field" ng-bind-html="vm.timeAgo(task.updated_at)"></div>\n</div></div></div></div><div layout="row"><div class="field mr-10" flex><div class="field"><strong>Fecha vencimiento: \n</strong>{{task.due_by_date | amDateFormat:\'DD MMM YYYY\'}}</div></div></div><div layout="row"><div class="field mr-10" \nflex><strong class="grey-800-fg" ng-bind-html="task.title"></strong><div ng-if="task.text" class="field grey-600-fg" \nng-bind-html="(task.text | limitTo: 50) + (task.text.length> 50 ? \'...\' : \'\')"></div></div></div></div></div>\n<md-divider></md-divider></div></md-list><md-list ng-show="vm.loadingTasks"><div class="evidence"><md-list-item><div \nlayout="row" layout-align="space-between center" flex="100" class="pt-10 pb-10"><div layout="row" \nlayout-align="start center" flex><div class="field"><md-progress-circular md-mode="indeterminate" md-diameter="30">\n</md-progress-circular></div></div></div></md-list-item></div></md-list></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span ng-bind-html="vm.translate(\'RISK.USERS_PARTICIPANTS\')"></span></md-tab-label><md-tab-body>\n<md-content flex="100" class="responsables pt-15"><md-input-container layout="row" class="group-form border-bottom" \nflex="100" flex-gt-xs="100"><div flex layout="row" layout-align="start center"><h3 class="bold m-15">\n{{vm.translate(\'RISK.USERS_ADMIN\')}}</h3></div></md-input-container><div \nng-if="!vm.controlUsers.IN_CHARGE || vm.controlUsers.IN_CHARGE.length == 0" layout="row" \nlayout-align="space-between center" flex="100" class="pt-10 pb-10"><div layout="row" layout-align="start center" flex>\n<div class="field p-15"><p><strong class="grey-800-fg" translate="RISK.NO_USERS_FOUND"></strong></p></div></div></div>\n<md-list-item class="border-bottom" ng-repeat="user in vm.controlUsers.IN_CHARGE"><div layout="row" \nlayout-align="start center" flex="100" class="pt-10 pb-10"><div class="info" flex layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><img \nclass="avatar s24" ng-src="{{vm.showUserImage(user)}}" ng-if="user.files.id"><div class="avatar s24" \nng-class="user.profile_color" ng-if="!user.files.id" ng-bind="user.first_name | capitalizeFirstLetter"></div></div><div\n class="field mr-10 ml-10" flex><strong class="grey-800-fg" ng-bind-html="user.first_name + \' \' + user.last_name">\n</strong></div></div></div></div></div></md-list-item></md-content><md-content class="responsables pt-15">\n<md-input-container layout="row" class="group-form border-bottom" flex="100" flex-gt-xs="100"><div flex layout="row" \nlayout-align="start center"><h3 class="bold m-15">{{vm.translate(\'RISK.USERS_PARTICIPANTS\')}}</h3></div>\n</md-input-container><div ng-if="!vm.controlUsers.PARTICIPANT || vm.controlUsers.PARTICIPANT.length == 0" layout="row" \nlayout-align="space-between center" flex="100" class="pt-10 pb-10"><div layout="row" layout-align="start center" flex>\n<div class="field p-15"><p><strong class="grey-800-fg" translate="RISK.NO_USERS_FOUND"></strong></p></div></div></div>\n<md-list-item class="border-bottom" ng-repeat="user in vm.controlUsers.PARTICIPANT"><div layout="row" \nlayout-align="start center" flex="100" class="pt-10 pb-10"><div class="info" flex layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><img \nclass="avatar s24" ng-src="{{vm.showUserImage(user)}}" ng-if="user.files.id"><div class="avatar s24" \nng-class="user.profile_color" ng-if="!user.files.id" ng-bind="user.first_name | capitalizeFirstLetter"></div></div><div\n class="field mr-10 ml-10" flex><strong class="grey-800-fg" ng-bind-html="user.first_name + \' \' + user.last_name">\n</strong></div></div></div></div></div></md-list-item></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \nng-bind-html="vm.translate(\'RISK.NONCONFORMITIES_IMPROVEMENTS\')"></span></md-tab-label><md-tab-body><md-content \nclass="nonconformities"><div id="site-questions" class="page-layout carded left-sidenav" layout="row"><div \nclass="content-wrapper" layout="row" flex><div class="content thread-detail" style="min-height: 300px;" layout="row" \nlayout-align="center center" flex><div class="no-client-selected no-thread-selected" layout="column" \nlayout-align="center center" flex><md-icon md-font-icon="icon-alert" class="s120 grey-400-fg"></md-icon><span \nclass="hint-text" translate="QUESTIONS.NOT_AVAILABLE_YET"></span></div></div></div></div></md-content></md-tab-body>\n</md-tab></md-tabs></md-content></div>');
$templateCache.put('app/core/components/tasks-section-view/tasks-section-view.component.html','<div ng-if="!vm.loaded" class="fill-width" style="max-height: 100%; overflow: auto;"><div ng-if="vm.savingTask" \nlayout="row" layout-align="center center" flex><div flex layout="column" layout-align="center center" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="50"></md-progress-circular></div>\n</div><div ng-if="!vm.currentTasks" style="margin-top: 20%;" layout="row" layout-align="space-between center" \nflex="100" class="pt-10 pb-10"><div class="no-thread-selected" layout="column" layout-align="center center" flex>\n<md-icon md-font-icon="icon-timelapse" class="s120 grey-400-fg"></md-icon><span class="hint-text">\n{{\'COMPLAINTS.NO_TASKS\' | translate}}</span></div></div><md-list ng-if="vm.currentTasks.length> 0" flex="100" \nclass="p-0 wrapper-tasks" ng-show="!vm.loadingTasks"><div class="pointer" ng-repeat="task in vm.currentTasks" \nclass="evidence no-padding" ng-if="vm.currentTasks" ng-click="vm.openTask(task, $event)" \nng-class="{ \'task-complete\' : task.is_complete }"><div fill-width \nng-include="\'app/main/apps/risk/views/templates/task-row-template.html\'"></div></div></md-list><md-list \nng-show="vm.loadingTasks"><div class="evidence"><md-list-item><div layout="row" layout-align="space-between center" \nflex="100" class="pt-10 pb-10"><div layout="row" layout-align="start center" flex><div class="field">\n<md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div></div></div></md-list-item>\n</div></md-list><div class="chat-compose-fab" layout="row" layout-align="end center" ng-if="!vm.savingTask"><button \nclass="add-event-button md-fab md-warn md-button md-default-theme" type="button" ng-click="vm.openTask(\'\')"><md-icon \nmd-font-icon="icon-plus" role="img" aria-hidden="true"></md-icon></button></div></div>');
$templateCache.put('app/core/components/tasks-user/tasks-user.component.html','<div ng-if="vm.loadTasksUser" class="content thread-detail" layout="row" layout-align="center center" flex><div flex \nlayout="column" layout-align="center center" class="loading-container"><md-progress-circular md-mode="indeterminate" \nmd-diameter="50"></md-progress-circular></div></div><div ng-if="!vm.loadTasksUser &&  !vm.currentControl"><div \nid="list-content-data" ng-style="{\'opacity\' : isLoading ? 0.5 : 1}" ng-if="vm.tasksUser.length > 0"><span \nng-repeat="task in vm.tasksUser"><span ng-repeat="process in task.processes"><div \nclass="mail-list-item p-15 border-bottom pointer" \nng-class="{\'selected\': vm.currentControl.active_control_id == control.active_control_id}" \nng-repeat="control in process.controls" ng-init="parentIndex = $index" md-no-ink \nng-click="vm.openControl(control, task)"><div layout="row" layout-align-gt-xs="start center" \nlayout-align-xs="space-between stretch"><div class="avatar" ng-style="{\'background\': \'rgba(132,173,78,1)\'}">C</div><div\n class="info" flex layout="column"><div class="name" layout="row"><span>{{control.name}}</span></div><div layout="row">\n{{\'RISK.PROCESS\' | translate}}: <span class="grey-400-fg">{{process.name}}</span></div></div></div></div></span></span>\n<div ng-if="!isLoading && pagination_total_pages > pagination_page && vm.tasksUser.length > 0" \nclass="load-more white p-30" layout="row" layout-sm="column" layout-align="center center" layout-wrap=""><md-button \nng-click="pagination_nextPage(true)" class="md-raised">{{\'GLOBAL.LOAD_MORE\' |\xA0translate}}</md-button></div><div \nng-if="pagination_total_pages == pagination_page && pagination_page > 1" class="load-more white p-30" layout="row" \nlayout-sm="column" layout-align="center center" layout-wrap=""><div class="message" translate="GLOBAL.NO_MORE_ITEMS">\n</div></div></div></div><div ng-if="vm.currentControl && vm.currentTask"><div class="risk-detail-view p-15"><div \nlayout="row" class="mb-0 risk-main-toolbar ng-scope"><a class="pointer" \nng-click="vm.currentControl = null; vm.currentTask = null"><md-icon md-font-icon="icon-chevron-left"></md-icon></a><p \nclass="font-size-16 section-title m-0">{{ \'RISK.CONTROL\' | translate | uppercase}}</p></div></div><control-view \nrisk="vm.currentTask" control="vm.currentControl"></control-view></div>');
$templateCache.put('app/core/directives/media/item-media.html','<div><qiu-icon mediafile="attachment.filename" class="mr-10" ng-if="audio"></qiu-icon><qiu-icon \nmediafile="attachment.filename" class="mr-10" ng-if="file"></qiu-icon><img ng-if="image" class="{{class}}" \nng-src="{{url}}" imageonload> <img class="{{class}}" ng-src="{{url}}" ng-if="video" imageonload><div \nng-if="video && !thumbnail" class="fotorama__video-play" style="opacity:1;"></div><video width="100%" \npreload="metadata" ng-if="urlvideo" class="{{class}}"><source type="video/mp4" \nng-src="{{urlvideo | toTrustedResource}}">Your browser does not support the video tag.</video><iframe id="ytplayer" \ntype="text/html" width="100%" height="100%" ng-if="urlvideoEmbed" ng-src="{{urlvideoEmbed | toTrustedResource}}" \nframeborder="0"></div>');
$templateCache.put('app/core/directives/ms-info-bar/ms-info-bar.html','<div id="ms-info-bar" layout="row" layout-align="start center" flex><div id="ms-info-bar-message" ng-transclude flex>\n</div><md-button id="ms-info-bar-close" class="md-icon-button" aria-label="Close" ng-click="removeInfoBar()"><md-icon \nmd-font-icon="icon-close s24"></md-icon></md-button></div>');
$templateCache.put('app/core/directives/ms-material-color-picker/ms-material-color-picker.html','<md-menu md-position-mode="target-right target"><div ng-click="$mdMenu.open($event)"><ms-color-picker-button><md-button\n aria-label="Row Color" md-menu-origin ng-click="$mdMenu.open($event)" ng-class="vm.selectedColor.class"><span \nng-show="vm.selectedColor.palette">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show="!vm.selectedColor.palette">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass="ms-material-color-picker-menu-content" layout-column><header \nng-class="vm.selectedColor.class || \'md-accent-bg\'" class="md-whiteframe-4dp" layout="row" \nlayout-align="space-between center"><md-button md-prevent-menu-close ng-click="vm.activateHueSelection(false,false)" \nclass="md-icon-button" ng-class="{\'hidden\':!vm.selectedPalette}" aria-label="Palette"><md-icon \nmd-font-icon="icon-arrow-left" class="s20"></md-icon></md-button><span ng-if="vm.selectedColor.palette">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if="!vm.selectedColor.palette">Select Color\n</span><md-button class="remove-color-button md-icon-button" ng-click="vm.removeColor()" aria-label="Remove Color">\n<md-icon md-font-icon="icon-delete" class="s20"></md-icon></md-button></header><div class="colors" ms-scroll><div \nng-show="!vm.selectedPalette" layout="row" layout-wrap><div class="color" ng-class="\'md-\'+palette+\'-500-bg\'" \nng-repeat="(palette, hues) in vm.palettes" ng-click="vm.activateHueSelection(palette,hues)" layout="row" \nlayout-align="start end" md-prevent-menu-close md-ink-ripple><span class="label">{{palette}}</span></div></div><div \nng-show="vm.selectedPalette" layout="row" layout-wrap><div class="color" \nng-class="\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'" ng-repeat="(hue, values) in vm.selectedHues" \nng-click="vm.selectColor(vm.selectedPalette,hue)" layout="row" layout-align="start end" md-ink-ripple><span \nclass="label">{{hue}} </span><i ng-if="vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue" \nclass="s16 icon-check"></i></div></div></div></md-menu-content></md-menu>');
$templateCache.put('app/core/directives/ms-search-bar/ms-search-bar.html','<div class="search-bar" flex layout="row" layout-align="start center"><label for="ms-search-bar-input"><md-icon \nid="ms-search-bar-expander" md-font-icon="icon-magnify" class="md-icon-button md-button"><md-tooltip hide show-gt-xs>\n<span translate="TOOLBAR.SEARCH">Search</span></md-tooltip></md-icon></label> <input id="ms-search-bar-input" \ntype="text" ng-model="$root.modelSearch" placeholder="Search" md-autofocus translate \ntranslate-attr-placeholder="TOOLBAR.SEARCH" flex ng-enter="$root.pagination_search($root.modelSearch)"><md-icon \nid="ms-search-bar-collapser" md-font-icon="icon-close-circle" class="icon s24"></md-icon><md-button hide show-gt-xs \nid="ms-search-bar-button" class="md-accent md-raised" ng-click="$root.pagination_search($root.modelSearch)" \naria-label="description" md-no-ink="true" md-ripple-size="auto" translate="TOOLBAR.SEARCH"></md-button><md-button hide \nshow-xs id="ms-search-bar-button" class="md-accent md-raised md-icon-button" \nng-click="$root.pagination_search($root.modelSearch)" aria-label="description" md-no-ink="true" md-ripple-size="auto">\n<md-icon md-font-icon="icon-chevron-right"></md-icon></md-button></div>');
$templateCache.put('app/core/directives/ms-shortcuts/ms-shortcuts.html','<div class="shortcuts-container" layout="row" layout-align="start center" flex><div class="shortcuts" layout="row" \nlayout-align="start center" ms-scroll ng-if="MsShortcuts.shortcuts.length > 0" \nng-sortable="MsShortcuts.sortableOptions"><div ng-repeat="shortcut in MsShortcuts.shortcuts" layout="row" \nlayout-align="start center"><md-button class="md-icon-button shortcut" aria-label="{{shortcut.title}}" \nui-sref="{{shortcut.uisref}}"><md-icon ng-if="shortcut.icon" md-font-icon="{{shortcut.icon}}" class="icon s24">\n</md-icon><div ng-if="!shortcut.icon" class="first-letter">{{shortcut.title.charAt(0)}}</div><md-tooltip \nmd-direction="bottom">{{shortcut.title}}</md-tooltip></md-button></div></div><md-menu md-offset="8 56"><md-button \nclass="md-icon-button add-shortcut-button" aria-label="Add shortcut" ng-click="$mdMenu.open($event)"><md-icon \nmd-menu-origin md-font-icon="icon-star" class="icon amber-600-fg s20"></md-icon><md-tooltip md-direction="bottom">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id="ms-shortcut-add-menu"><div \nclass="shortcut-search" layout="row" layout-align="start center"><div class="search-icon" layout="row" \nlayout-align="center center" ng-if="!MsShortcuts.resultsLoading"><md-icon md-menu-align-target \nmd-font-icon="icon-magnify" class="icon s24"></md-icon></div><div class="shortcut-loader" layout="row" \nlayout-align="center center" ng-if="MsShortcuts.resultsLoading"><md-progress-circular class="md-accent" \nmd-diameter="40" md-mode="indeterminate"></md-progress-circular></div><input type="text" placeholder="Search" flex \nng-model="MsShortcuts.query" ng-model-options="MsShortcuts.queryOptions" \nng-keydown="MsShortcuts.handleKeydown($event)"></div><div class="results" ng-if="MsShortcuts.results" ms-scroll><div \nclass="no-results" ng-if="MsShortcuts.results.length === 0">No Results!</div><div class="result" \nng-repeat="result in MsShortcuts.results" ng-click="MsShortcuts.handleResultClick(result)" \nng-mouseenter="MsShortcuts.handleMouseenter($index)" ng-mousedown="MsShortcuts.absorbEvent($event)" \nng-class="{\'selected\': $index == MsShortcuts.selectedResultIndex}" md-prevent-menu-close="md-prevent-menu-close" \nmd-ink-ripple><div layout="row" layout-align="start space-between"><div layout="row" layout-align="start center" flex>\n<div class="icon-container" layout="row" layout-align="center center"><i ng-if="result.icon" class="{{result.icon}}">\n</i><div ng-if="!result.icon" class="square md-accent-bg"></div></div><div><div class="title">{{result.title}}</div>\n</div></div><md-icon md-font-icon="icon-pin" class="icon s18" ng-class="{\'fade-text\': !result.hasShortcut}"></md-icon>\n</div></div></div></div></md-menu-content></md-menu></div>');
$templateCache.put('app/core/directives/pagination/pagination-simple.html','<md-table-pagination md-limit="query.limit" md-limit-options="[5, 10, 15]" md-page="query.page" md-total="2306" \nmd-on-paginate="getDesserts" md-page-select="" class="md-table-pagination"><div class="limit-select" \nng-if="$pagination.limitOptions"><div class="label">Rows per page:</div><md-select \nclass="md-table-select ng-pristine ng-untouched ng-valid" ng-model="$pagination.limit" \nmd-container-class="md-pagination-select" ng-disabled="$pagination.disabled" aria-label="Rows: 5" placeholder="5" \nrole="listbox" aria-expanded="false" aria-multiselectable="false" id="select_4" aria-owns="select_container_5" \naria-disabled="false" tabindex="0" aria-invalid="false"><md-select-value class="md-select-value" \nid="select_value_label_1"><span><div class="md-text">5</div></span><span class="md-select-icon" aria-hidden="true">\n</span></md-select-value><div class="md-select-menu-container md-pagination-select" aria-hidden="true" \nid="select_container_5"><md-select-menu><md-content><md-option ng-repeat="rows in $pagination.limitOptions" \nng-value="rows" tabindex="0" class="md-ink-ripple" role="option" aria-selected="true" id="select_option_7" value="5" \nselected="selected"><div class="md-text">5</div></md-option><md-option ng-repeat="rows in $pagination.limitOptions" \nng-value="rows" tabindex="0" class="md-ink-ripple" role="option" aria-selected="false" id="select_option_8" value="10">\n<div class="md-text">10</div></md-option><md-option ng-repeat="rows in $pagination.limitOptions" ng-value="rows" \ntabindex="0" class="md-ink-ripple" role="option" aria-selected="false" id="select_option_9" value="15"><div \nclass="md-text">15</div></md-option></md-content></md-select-menu></div></md-select></div><div class="buttons"><div \nclass="label">{{pagination_from}} \u2013 {{pagination_to}} of {{pagination_totalItems}}</div><md-button \naria-label="Previous" class="md-icon-button arrow" hide="" ng-click="gotoPage(numPages-1)" show-gt-xs="" translate="" \ntranslate-attr-aria-label="MAIL.PREVIOUS"><md-icon md-font-icon="icon-chevron-left"></md-icon><md-tooltip><span \ntranslate="MAIL.PREVIOUS">Previous</span></md-tooltip></md-button><md-button aria-label="Next" \nclass="md-icon-button arrow" hide="" ng-click="gotoPage(numPages+1)" show-gt-xs="" translate="" \ntranslate-attr-aria-label="MAIL.NEXT"><md-icon md-font-icon="icon-chevron-right"></md-icon><md-tooltip><span \ntranslate="MAIL.NEXT">Next</span></md-tooltip></md-button><button class="md-icon-button md-button md-ink-ripple" \ntype="button" ng-click="pagination_prevPage()" ng-disabled="pagination_firstPage()" aria-label="Previous"><md-icon \nmd-svg-icon="navigate-before.svg" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="100%" \nheight="100%" viewBox="0 0 24 24" fit="" preserveAspectRatio="xMidYMid meet"><path \nd="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path></svg></md-icon></button> <button \nclass="md-icon-button md-button md-ink-ripple" type="button" ng-click="$pagination.next()" \nng-disabled="$pagination.disabled || !$pagination.hasNext()" aria-label="Next" aria-disabled="false"><md-icon \nmd-svg-icon="navigate-next.svg" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" \nviewBox="0 0 24 24" fit="" preserveAspectRatio="xMidYMid meet"><path \nd="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path></svg></md-icon></button></div></md-table-pagination>');
$templateCache.put('app/core/directives/pagination/pagination.html','<div class="simple-pagination"><md-button class="pagination-item disabled" md-no-ink ng-href="#" \naria-label="Go to previous page" translate translate-attr-aria-label="SEARCH.GO_TO_PREVIOUS"><md-icon \nmd-font-icon="icon-chevron-left"></md-icon></md-button><md-button class="pagination-item active" md-no-ink \naria-label="Go to page 1" ng-repeat="p in [linkGroupFirst(), linkGroupLast()] | makeRange" ng-click="gotoPage(p)">\n<span>{{p}}</span></md-button><md-button class="pagination-item" aria-label="Go to next page" translate \ntranslate-attr-aria-label="SEARCH.GO_TO_NEXT" ng-click="gotoPage(page+1)"><md-icon md-font-icon="icon-chevron-right">\n</md-icon></md-button><div class="row"><div class="results_count"><p>{{from}} \u2013 {{to}} de {{totalItems}}</p></div><div \nclass="paginate-anything"><ul class="pagination pagination-{{size}} links" ng-if="numPages > 1"><li ng-show="page>1"><a\n href ng-click="gotoPage(page-1)"><i class="fa fa-caret-left"></i></a></li><li ng-if="linkGroupFirst() > 1"><a href \nng-click="gotoPage(1)">1</a></li><li ng-if="linkGroupFirst() > 1" class="disabled"><a href>&hellip;</a></li><li \nng-repeat="p in [linkGroupFirst(), linkGroupLast()] | makeRange" ng-class="{active: p === page}" data="{{p}}"><a href \nng-click="gotoPage(p)">{{p}}</a></li><li ng-if="linkGroupLast() < numPages - 2" class="disabled"><a href>&hellip;</a>\n</li><li ng-if="isFinite() && linkGroupLast() < numPages - 1"><a href ng-click="gotoPage(numPages-1)">{{numPages}}</a>\n</li><li ng-class="{disabled: page >= numPages - 1}"><a href ng-click="gotoPage(page+1)"><i class="fa fa-caret-right">\n</i></a></li></ul><div class="per-page" ng-if="perPagePresets.length > 0 && numPages > 1"><select \nng-model="$parent.perPage" ng-options="p for p in perPagePresets"></select> per page</div></div></div></div>');
$templateCache.put('app/core/directives/pagination/pagination_fuse.html','<div class="layout-row"><div class="simple-pagination" ng-show="numPages > 1"><md-button class="pagination-item" \nng-href="#" aria-label="Go to previous page" translate translate-attr-aria-label="SEARCH.GO_TO_PREVIOUS" \nng-click="$root.pagination_gotoPage($root.pagination_page-1)"><md-icon md-font-icon="icon-chevron-left"></md-icon>\n</md-button><md-button class="pagination-item" ng-class="{active: p === $root.pagination_page}" \naria-label="Go to page {{p}}" ng-repeat="p in [linkGroupFirst(), linkGroupLast()] | makeRange" \nng-click="$root.pagination_gotoPage(p)"><span>{{p}}</span></md-button><md-button class="pagination-item" \nng-class="{disabled: $root.pagination_page >= numPages }" \nng-click="$root.pagination_gotoPage($root.pagination_page+1)"><md-icon md-font-icon="icon-chevron-right"></md-icon>\n</md-button></div></div>');
$templateCache.put('app/core/directives/pagination/pagination_fuse_1.html','<div></div>');
$templateCache.put('app/main/apps/calendar/calendar.html','<div id="calendar" class="page-layout simple fullwidth" layout="column"><div class="header" \nng-class="vm.currentMonthShort"><div class="header-content" layout="column" layout-align="space-between"><div \nclass="header-top" layout="row" layout-align="space-between center" layout-xs="column"><div class="logo" layout="row" \nlayout-align="start center"><span class="logo-icon"><md-icon md-font-icon="icon-calendar-today"></md-icon></span><span \nclass="logo-text" translate="CALENDAR.CALENDAR">Calendar</span></div><div class="toolbar" layout="row" \nlayout-align="start center"><md-button class="md-icon-button" aria-label="Search" translate \ntranslate-attr-aria-label="CALENDAR.SEARCH"><md-icon md-font-icon="icon-magnify"></md-icon><md-tooltip><span \ntranslate="CALENDAR.SEARCH">Search</span></md-tooltip></md-button><md-button class="md-icon-button" \nng-click="vm.calendar.today()" aria-label="Today" translate translate-attr-aria-label="CALENDAR.TODAY"><md-icon \nmd-font-icon="icon-calendar-today"></md-icon><md-tooltip><span translate="CALENDAR.TODAY">Today</span></md-tooltip>\n</md-button><md-button class="md-icon-button" ng-click="vm.calendar.changeView(\'agendaDay\')" aria-label="Day" \ntranslate translate-attr-aria-label="CALENDAR.DAY"><md-icon md-font-icon="icon-view-day"></md-icon><md-tooltip><span \ntranslate="CALENDAR.DAY">Day</span></md-tooltip></md-button><md-button class="md-icon-button" \nng-click="vm.calendar.changeView(\'agendaWeek\')" aria-label="Week" translate translate-attr-aria-label="CALENDAR.WEEK">\n<md-icon md-font-icon="icon-view-week"></md-icon><md-tooltip><span translate="CALENDAR.WEEK">Week</span></md-tooltip>\n</md-button><md-button class="md-icon-button" ng-click="vm.calendar.changeView(\'month\')" aria-label="Month" translate \ntranslate-attr-aria-label="CALENDAR.MONTH"><md-icon md-font-icon="icon-view-module"></md-icon><md-tooltip><span \ntranslate="CALENDAR.MONTH">Month</span></md-tooltip></md-button></div></div><div class="header-bottom" layout="row" \nlayout-align="center center"><md-button class="md-icon-button arrow" ng-click="vm.calendar.prev()" \naria-label="Previous" translate translate-attr-aria-label="CALENDAR.PREVIOUS"><md-icon \nmd-font-icon="icon-chevron-left"></md-icon></md-button><div class="title">{{vm.calendarView.title}}</div><md-button \nclass="md-icon-button arrow" ng-click="vm.calendar.next()" aria-label="Next" translate \ntranslate-attr-aria-label="CALENDAR.NEXT"><md-icon md-font-icon="icon-chevron-right"></md-icon></md-button></div></div>\n<md-button class="add-event-button md-fab md-warn" ng-click="vm.addEvent($event)" aria-label="Add event" translate \ntranslate-attr-aria-label="CALENDAR.ADD_EVENT"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div><div \nclass="content"><div id="calendarView" ui-calendar="vm.calendarUiConfig.calendar" ng-model="vm.events" calendar="main">\n</div></div></div>');
$templateCache.put('app/main/apps/chat/chat.html','<div id="chat-app" class="page-layout carded fullwidth"><div class="top-bg md-accent-bg"></div><div class="center"><div\n class="content-card" layout="row" flex><md-sidenav class="sidenav left-sidenav md-sidenav-left" \nmd-is-locked-open="$mdMedia(\'gt-md\')" md-component-id="left-sidenav" ms-sidenav-helper \nng-include="\'app/main/apps/chat/sidenavs/left/left-sidenav.html\'" layout="column"></md-sidenav><div \nclass="start-point" ng-if="!vm.chat" flex layout="column" flex layout-align="center center"><div \nclass="big-circle md-whiteframe-4dp"><md-icon class="s128 md-accent" md-font-icon="icon-hangouts"></md-icon></div><span\n class="app-title" translate="CHAT.APP_TITLE">Chat App</span> <span class="hide show-gt-md secondary-text" \ntranslate="CHAT.START_MESSAGE">Select contact to start the chat!..</span><md-button class="md-raised hide-gt-md" \nng-click="vm.toggleSidenav(\'left-sidenav\')" translate="CHAT.START_MESSAGE">Select contact to start the chat!..\n</md-button></div><div ng-if="vm.chat" class="chat" layout="column" flex><md-toolbar class="chat-toolbar"><div \nclass="md-toolbar-tools"><md-button class="hide-gt-md responsive-chats-button md-icon-button" \nng-click="vm.toggleLeftSidenavView(false);vm.toggleSidenav(\'left-sidenav\')" aria-label="chats button"><md-icon \nmd-font-icon="icon-hangouts s36"></md-icon></md-button><div class="chat-contact" layout="row" \nlayout-align="start center" ng-click="vm.toggleSidenav(\'right-sidenav\')"><div class="avatar-wrapper"><img \nng-src="{{vm.contacts.getById(vm.chatContactId).avatar}}" class="avatar" \nalt="{{vm.contacts.getById(vm.chatContactId).name}}"> <i class="icon icon- s16 status" \nng-class="vm.contacts.getById(vm.chatContactId).status"></i></div><div class="chat-contact-name">\n{{vm.contacts.getById(vm.chatContactId).name}}</div></div><md-menu md-position-mode="target-right target"><md-button \nclass="md-icon-button" ng-click="$mdMenu.open()" aria-label="more"><md-icon md-font-icon="icon-dots-vertical">\n</md-icon></md-button><md-menu-content width="3"><md-menu-item><md-button ng-click="vm.toggleSidenav(\'right-sidenav\')" \ntranslate="CHAT.CONTACT_INFO">Contact Info</md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.clearMessages()" translate="CHAT.CLEAR_MESSAGES">Clear Messages</md-button></md-menu-item>\n</md-menu-content></md-menu></div></md-toolbar><md-content id="chat-content" flex ms-scroll><div class="chat-messages" \nng-if="vm.chat"><div layout="row" ng-repeat="dialog in vm.chat" class="md-padding message-row" ng-class="dialog.who">\n<img ng-if="dialog.who ===\'contact\'" ng-src="{{vm.contacts.getById(vm.chatContactId).avatar}}" class="avatar" \nalt="{{vm.contacts.getById(vm.chatContactId).name}}"> <img ng-if="dialog.who ===\'user\'" class="avatar" \nng-src="{{vm.user.avatar}}"><div class="bubble"><div class="message">{{dialog.message}}</div><div \nclass="time secondary-text">{{dialog.time | altDate}}</div></div></div></div></md-content><div \nclass="chat-footer flex-noshrink" layout="row" layout-align="center center"><form ng-submit="vm.reply()" flex \nclass="reply-form" layout="row" layout-align="start center"><md-input-container flex md-no-float><textarea \nng-keyup="vm.reply($event)" md-no-autogrow ng-model="vm.replyMessage" ng-class="{\'grow\': vm.textareaGrow}" \nplaceholder="Type and hit enter to send message" translate translate-attr-placeholder="CHAT.REPLY_PLACEHOLDER">\n                            </textarea></md-input-container><md-button class="md-fab" type="submit" \naria-label="Send message" translate translate-attr-aria-label="CHAT.SEND_MESSAGE"><md-icon md-font-icon="icon-send">\n</md-icon></md-button></form></div></div><md-sidenav class="sidenav right-sidenav md-sidenav-right" layout="column" \nmd-component-id="right-sidenav" ms-sidenav-helper ng-include="\'app/main/apps/chat/sidenavs/right/right-sidenav.html\'">\n</md-sidenav></div></div></div>');
$templateCache.put('app/main/apps/aircrafts/mail.html','<div id="site-content" class="page-layout carded left-sidenav" layout="row"><div class="top-bg md-accent-bg"></div><div\n class="center" layout="column" flex><div class="header" layout="row" layout-align="start center"><div \nclass="search-wrapper md-whiteframe-4dp" layout="row" layout-align="start center" flex><md-button \nclass="md-icon-button sidenav-toggle" ng-click="vm.toggleSidenav(\'main-sidenav\')" hide-gt-md \naria-label="Toggle Sidenav" translate translate-attr-aria-label="MAIL.TOGGLE_SIDENAV"><md-icon class="icon" \nmd-font-icon="icon-menu"></md-icon></md-button><div class="search" flex layout="row" layout-align="start center">\n<md-icon md-font-icon="icon-magnify" class="icon s24"></md-icon><input flex ng-model="vm.search" type="text" \nplaceholder="Search for an e-mail or contact" translate translate-attr-placeholder="MAIL.SEARCH_PLACEHOLDER"></div>\n</div></div><div class="content-card" ng-class="vm.currentView" layout="column" flex \nng-include="vm.views[vm.currentView]"></div></div></div>');
$templateCache.put('app/main/apps/clients/clients.html','<div id="site-client" class="page-layout carded left-sidenav" layout="row"><div class="center" layout="column" flex>\n<div class="content-card" layout="column" flex ng-include="vm.views[vm.currentView]" md-no-ink></div></div>\n<h2c-pagination collection="vm.companies" url="\'http://\'" service="clientsService" style="display:none;">\n</h2c-pagination></div>');
$templateCache.put('app/main/apps/clients-complaints/clients-complaints.html','<div id="site-client-complaints" class="page-layout carded left-sidenav" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex ng-include="vm.views[vm.currentView]" md-no-ink>\n</div></div><h2c-pagination collection="vm.companies" url="\'http://\'" service="clientsService" style="display:none;">\n</h2c-pagination></div>');
$templateCache.put('app/main/apps/dashboard-complaints/dashboard-complaints.html','<div id="dashboard-container" class="page-layout carded left-sidenav justify-center" layout="column" \nlayout-align="stretch space-between"><div id="site-dashboard" \nstyle="background : url({{vm.branding.dashboardBackground}}) no-repeat; background-size: cover;" \nclass="white-fg ph-20 pv-30" flex="45" layout="column" layout-align="center center"><h1 \nclass="m-0 font-weight-400 font-size-48">\n{{ \'LOGIN.INTRO_TITLEQ\' | translate }} {{(vm.branding.companyname ? vm.branding.companyname : \'H2C\') | uppercase}}</h1>\n<span class="mt-10 mb-30 font-size-20">{{ \'LOGIN.SLOGAN\' | translate }}</span></div></div>');
$templateCache.put('app/main/apps/dashboard-complaints/dashboard5-complaints.html','<div id="dashboard-container" class="page-layout carded left-sidenav justify-center" layout="column" \nlayout-align="stretch space-between"><div id="site-dashboard" \nstyle="background : url({{vm.branding.dashboardBackground}}) no-repeat; background-size: cover;" \nclass="white-fg ph-20 pv-30" flex="45" layout="column" layout-align="center center"><h1 \nclass="m-0 font-weight-400 font-size-48">\n{{ \'LOGIN.INTRO_TITLEQ\' | translate }} {{(vm.branding.companyname ? vm.branding.companyname : \'H2C\') | uppercase}}</h1>\n<span class="mt-10 mb-30 font-size-20">{{ \'LOGIN.SLOGAN\' | translate }}</span></div><div id="site-dashboard-bottom" \nflex="55" layout="column" layout-align="center center"><div class="dashboard-bottom-container" layout="column" \nlayout-align="start stretch" layout-gt-sm="row" layout-align-gt-sm="space-between center"><div layout="column" \nlayout-align="start center" layout-align-gt-sm="start start" flex="100" class="ph-20"><h2 \nclass="m-0 font-weight-400 font-size-38">{{ \'LOGIN.QUICK_GUIDE\' | translate }}</h2><span \nclass="mt-10 mb-30 font-size-16">{{ \'LOGIN.DASHBOARD_DESC\' | translate }}</span><md-button \nhref="https://ayuda.h2c.app/es/" target="_blank" class="ml-0 md-raised md-accent font-size-16 pv-5 ph-20">\n{{ \'LOGIN.YOUTUBE_CANAL\' | translate }}</md-button></div></div></div></div>');
$templateCache.put('app/main/apps/dashboard-complaints/dashboarddata-complaints.html','<div id="site-dashboard-data" class="widget-group" layout="column" layout-align="start-start" flex="100"><md-list-item \nclass="md-toolbar-tools grey-100-bg"><md-menu-bar class="user-menu"><md-menu md-position-mode="left bottom"><md-button \nclass="user-button" ng-click="vm.companies.length> 1 ? $mdMenu.open() : null" aria-label="User settings" translate \ntranslate-attr-aria-label="TOOLBAR.USER_SETTINGS"><div layout="row" layout-align="space-between center"><div \nclass="avatar-wrapper" ng-show="!vm.companySelected"><img md-menu-align-target class="avatar" \nsrc="assets/images/logos/generic-company.jpg"></div><div class="avatar-wrapper" \nng-show="vm.companySelected && vm.companySelected.files && vm.companySelected.files.length> 0"><img \nmd-menu-align-target class="avatar" ng-src="{{storagePrefix}}{{vm.companySelected.files[0].url}}"></div><div \nclass="avatar-wrapper" \nng-show="vm.companySelected && (!vm.companySelected.files || vm.companySelected.files.length === 0)"><div \nclass="avatar small img" ms-random-class="vm.colors" ng-bind="vm.companySelected.name | capitalizeFirstLetter"></div>\n</div><span ng-if="!vm.companySelected" class="username" translate="GLOBAL.SELECT_CLIENT"></span> <span \nng-if="vm.companySelected" class="username">{{vm.companySelected.name}}</span><md-icon ng-if="vm.companies.length> 1" \nmd-font-icon="icon-chevron-down" class="icon s16" hide-xs></md-icon></div></md-button><md-menu-content width="3" \nclass="clients"><md-menu-item class="md-indent"><div class="search-input-wrapper" layout="row" \nlayout-align="start center"><label for="search"><md-icon md-font-icon="icon-magnify" class="search-icon"></md-icon>\n</label><md-input-container md-no-float class="m-0" layout="row" layout-align="start center"><input id="search" \nplaceholder="{{\'CONTACTS.SEARCH_FOR_ANYONE\' | translate}}" type="text" ng-model="searchText"></md-input-container>\n</div></md-menu-item><div class="results"><md-menu-item ng-if="vm.companySelected" ng-click="vm.selectAllClients()" \nclass="md-indent bar-client all-clients-option"><div layout="row" layout-align="start center"><div \nclass="avatar-wrapper"><img md-menu-align-target class="avatar" src="assets/images/logos/generic-company.jpg"></div>\n<button class="btn-clients">{{ \'DASHBOARD-COMPLAINTS.ALL_CLIENTS\' | translate }}</button></div></md-menu-item>\n<md-menu-item ng-click="vm.selectCompany(company)" class="md-indent bar-client" \nng-repeat="company in vm.companies | filter:searchText"><div layout="row" layout-align="start center"><div \nng-if="company.files[0].url" class="avatar-wrapper"><img md-menu-align-target class="avatar" \nng-src="{{storagePrefix}}{{company.files[0].url}}"></div><div ng-if="!company.files[0].url" class="avatar small img" \nms-random-class="vm.colors" ng-bind="company.name | capitalizeFirstLetter"></div><button class="btn-clients">\n{{company.name}}</button></div></md-menu-item></div></md-menu-content></md-menu></md-menu-bar></md-list-item><div \nlayout="column" ng-if="!vm.isLoadingData" style="width: 100%;" class="chart-section"><div layout="column" \nlayout-gt-md="row"><div class="widget-group m-h-auto" flex="100" layout="row" layout-align="start start" layout-wrap \nng-include="\'app/main/apps/dashboard-complaints/views/general-widgets-complaints.html\'"></div><div ng-if="vm.events" \nflex="100" class="mt-10 mh-25 calendar-section"><div class="content"><div id="calendarView" \nui-calendar="vm.calendarUiConfig.calendar" ng-model="vm.events" calendar="main"></div></div><div \nclass="bottom-widgets mt-20 mh-25" flex="100" layout="row" layout-wrap layout-align="start start"><ms-widget \nflippable="false" layout="row" flex="49" class="enhanced-widget bar-chart-widget ms-widget"><ms-widget-front \nclass="white-bg enhanced-card bar-chart-card"><div class="widget-header ph-16 border-bottom" layout="row" \nlayout-align="space-between center"><div class="h3 pv-10"><md-icon md-font-icon="icon-chart-bar" \nclass="widget-icon chart-icon"></md-icon>{{ \'DASHBOARD-COMPLAINTS.COMMUNICATIONS_BY_MONTH\' | translate }}</div></div>\n<div class="widget-content bar-chart-content"><div class="simple-chart-container" style="height: 180px; padding: 8px;">\n<div class="monthly-bars"><div ng-repeat="month in vm.monthlyData" class="month-bar" layout="column" \nlayout-align="end start"><div class="bar-label">{{month.name}}</div><div class="bar-container"><div class="bar" \nng-style="{\'height\': month.percentage + \'%\', \'background-color\': month.color}"></div><div class="bar-value">\n{{month.value}}</div></div></div></div></div></div><div class="widget-footer ph-16 pt-8 border-top"><div layout="row" \nlayout-align="space-between center"><span class="caption-text">{{ \'DASHBOARD-COMPLAINTS.LAST_6_MONTHS\' | translate }}\n</span> <span class="caption-text bar-chart-summary">{{vm.getMonthlyTrend()}}</span></div></div></ms-widget-front>\n</ms-widget><ms-widget ng-click="vm.openCategoryDialog($event)" flippable="false" layout="row" flex="49" \nclass="enhanced-widget horizontal-bar-widget ms-widget"><ms-widget-front \nclass="white-bg enhanced-card horizontal-bar-card"><div class="widget-header ph-16 border-bottom" layout="row" \nlayout-align="space-between center"><div class="h3 pv-10"><md-icon md-font-icon="icon-chart-bar" \nclass="widget-icon chart-icon"></md-icon>{{ \'DASHBOARD-COMPLAINTS.MOST_FREQUENT_COMMUNICATION_TYPES\' | translate }}\n</div></div><div class="widget-content horizontal-bar-content"><div class="simple-chart-container" \nstyle="height: 180px; padding: 10px;"><div class="category-list"><div \nng-repeat="category in vm.categoryData | limitTo: 3" class="category-item"><div class="bar-label"><div \nclass="category-info" layout="row" layout-align="start center"><div class="category-dot" \nng-style="{\'background-color\': category.color}"></div><span class="category-name" title="{{category.name}}">\n{{category.name}}</span></div><span class="bar-value">{{category.count}}</span></div><div class="bar-container"><div \nclass="category-bar" ng-style="{\'width\': category.percentage + \'%\', \'background-color\': category.color}"></div></div>\n</div></div></div></div><div class="widget-footer ph-16 pt-8 border-top"><div layout="row" \nlayout-align="space-between center"><span class="caption-text">\n{{ \'DASHBOARD-COMPLAINTS.MOST_FREQUENT_CATEGORIES\' | translate }}</span> <span class="caption-text horizontal-summary" \nng-if="vm.categoryData && vm.categoryData.length > 0" \ntitle="{{vm.categoryData[0].name}} ({{vm.categoryData[0].count}})"><span class="summary-text">\n{{vm.categoryData[0].name}}</span> <span class="summary-count">({{vm.categoryData[0].count}})</span> </span><span \nclass="caption-text" ng-if="!vm.categoryData || vm.categoryData.length === 0">\n{{ \'DASHBOARD-COMPLAINTS.NO_CATEGORIES\' | translate }}</span></div></div></ms-widget-front></ms-widget><ms-widget \nng-click="vm.openCompanyPerformanceDialog($event)" flippable="false" layout="row" flex="49" \nclass="enhanced-widget scatter-widget ms-widget"><ms-widget-front class="white-bg enhanced-card scatter-card"><div \nclass="widget-header ph-16 border-bottom" layout="row" layout-align="space-between center"><div class="h3 pv-10">\n<md-icon md-font-icon="icon-clock" class="widget-icon chart-icon"></md-icon>\n{{ \'DASHBOARD-COMPLAINTS.AVERAGE_MANAGEMENT_TIME\' | translate }}</div></div><div \nclass="widget-content scatter-content"><div class="simple-chart-container" style="height: 180px; padding: 10px;"><div \nclass="company-performance-bars"><div \nng-repeat="company in vm.companyPerformanceData | filter:{avgResolutionDays: \'!N/A\'} | limitTo: 3" \nclass="company-bar-item"><div class="bar-label"><div class="company-info"><div class="company-logo"><img \nng-if="company.logo" ng-src="{{company.logo}}" alt="{{company.name}}" class="avatar avatar-dashboard"><div \nng-if="!company.logo" class="avatar avatar-dashboard small img">{{company.name | capitalizeFirstLetter}}</div></div>\n<span class="company-name">{{company.name}}</span></div><span class="bar-value">\n{{company.avgResolutionDays}} {{ \'DASHBOARD-COMPLAINTS.DAYS\' | translate }}</span></div><div class="bar-container"><div\n class="bar-fill" \nng-style="{\'width\': (company.avgResolutionDays / vm.maxResolutionDays * 100) + \'%\', \'background-color\': company.color}">\n</div></div></div></div><div ng-if="!vm.companyPerformanceData || vm.companyPerformanceData.length === 0" \nclass="no-data-message"><md-icon md-font-icon="icon-clock" style="font-size: 48px; color: #ccc;"></md-icon><span \nstyle="color: #999; margin-top: 8px;">{{ \'DASHBOARD-COMPLAINTS.NO_COMPANIES_WITH_CLOSED_COMMUNICATIONS\' | translate }}\n</span></div></div></div><div class="widget-footer ph-16 pt-8 border-top"><div layout="row" \nlayout-align="space-between center"><span class="caption-text">\n{{ \'DASHBOARD-COMPLAINTS.AVERAGE_MANAGEMENT_TIME_CAPTION\' | translate }}</span> <span \nclass="caption-text scatter-summary">{{vm.getCompanyPerformanceSummary()}}</span></div></div></ms-widget-front>\n</ms-widget><ms-widget flippable="false" layout="row" flex="49" class="enhanced-widget distribution-widget ms-widget">\n<ms-widget-front class="white-bg enhanced-card distribution-card"><div class="widget-header ph-16 border-bottom" \nlayout="row" layout-align="space-between center"><div class="h3 pv-10"><md-icon md-font-icon="icon-alert-circle" \nclass="widget-icon chart-icon"></md-icon>{{ \'DASHBOARD-COMPLAINTS.PRIORITY_DISTRIBUTION\' | translate }}</div></div><div\n class="widget-content distribution-content"><div class="simple-chart-container" style="height: 180px; padding: 8px;">\n<div ng-if="vm.priorityDistributionData && vm.priorityDistributionData.length > 0" class="status-pie"><div \nng-repeat="priority in vm.priorityDistributionData" class="status-slice" layout="row" \nlayout-align="space-between center"><div class="status-info" layout="row" layout-align="start center"><div \nclass="status-indicator" ng-style="{\'background-color\': priority.color}"></div><span class="status-name">\n{{priority.key}}</span></div><div class="status-stats" layout="row" layout-align="end center"><span \nclass="status-count">{{priority.y}}</span> <span class="status-percentage">{{vm.getPriorityPercentage(priority.y)}}%\n</span></div></div></div><div ng-if="!vm.priorityDistributionData || vm.priorityDistributionData.length === 0" \nclass="no-data-message" layout="column" layout-align="center center"><md-icon md-font-icon="icon-alert-circle" \nstyle="font-size: 48px; color: #ccc;"></md-icon><span style="color: #999; margin-top: 8px;">\n{{ \'DASHBOARD-COMPLAINTS.NO_DISTRIBUTION_DATA_AVAILABLE\' | translate }}</span></div></div></div><div \nclass="widget-footer ph-16 pt-8 border-top"><div layout="row" layout-align="space-between center"><span \nclass="caption-text">{{ \'DASHBOARD-COMPLAINTS.CURRENT_PRIORITY\' | translate }}</span> <span \nclass="caption-text distribution-summary">{{vm.getPrioritySummary()}}</span></div></div></ms-widget-front></ms-widget>\n</div></div></div></div></div>');
$templateCache.put('app/main/apps/complaints/complaints.html','<div id="site-complaints" class="page-layout carded left-sidenav" layout="row"><div flex layout="column" \nlayout-align="center center" layout-padding layout-margin ng-if="isLoadingCanal" class="loading-container">\n<md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div><div class="center" \nlayout="column" flex ng-class="{\'forms-mobile-view\': vm.isFormList}" \nng-if="((vm.complaintPlan.plan_id <= 5 || vm.userLogued.user_type >= 2 && vm.isCompanySelected() || vm.complaintsSelected) && (vm.complaintCanal && !isLoadingCanal && !vm.editingComplaintForm || vm.isFormList))">\n<div class="content-card" layout="column" flex ng-class="{\'forms-mobile-view\': vm.isFormList}" \nng-include="vm.views[vm.currentView]" md-no-ink></div></div><div class="content-wrapper" layout="row" flex \nng-if="!vm.complaintCanal && vm.isCompanySelected() && !vm.showFormStartComplaintCanal && !vm.showLanguageSelectorComplaintCanal && !isLoadingCanal && !vm.isFormList">\n<div class="content thread-detail" layout="row" layout-align="center center" flex><div class="no-questionnaire" \nlayout="column" layout-align="center center" flex><span class="hint-text" translate="COMPLAINTS.NO_COMPLAINT_STARTED">\n</span><div class="text-center"><md-button aria-label="Start questionnaire" class="md-raised md-accent" \nng-click="vm.selectLanguageComplaintCanal()"><span translate="COMPLAINTS.START_COMPLAINT"></span></md-button></div>\n</div></div></div><div class="content-wrapper" layout="row" \nng-include="\'app/main/apps/complaints/views/list/language-selector.html\'" flex \nng-if="vm.showLanguageSelectorComplaintCanal && !isLoadingCanal && !vm.isFormList"></div><div layout="row" flex \nng-if="vm.showFormStartComplaintCanal && !isLoadingCanal && !vm.isFormList" \nng-include="\'app/main/apps/complaints/views/list/init-complaint-canal.html\'"></div><div class="content-wrapper" \nlayout="row" flex ng-if="!vm.isCompanySelected() && !vm.complaintsSelected && !isLoadingCanal"><div \nclass="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-timelapse" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="COMPLAINTS.SELECT_COMPANY_FIRST"></span></div></div></div><h2c-pagination ng-if="vm.companySelected" \ncollection="vm.complaints" service="complaintsService" owner="owner" company-id="vm.companySelected.id" \nstyle="display:none;"></h2c-pagination></div>');
$templateCache.put('app/main/apps/contacts/contacts.html','<div id="contacts" class="page-layout simple left-sidenav inner-sidenav"><div class="header md-accent-bg" layout="row" \nlayout-align="space-between center"><div layout="row" layout-align="start center"><md-button \nclass="md-icon-button sidenav-toggle" hide-gt-md ng-click="vm.toggleSidenav(\'sidenav\')" aria-label="Toggle sidenav" \ntranslate translate-attr-aria-label="CONTACTS.TOGGLE_SIDENAV"><md-icon md-font-icon="icon-menu" class="icon"></md-icon>\n</md-button><div class="logo" layout="row" layout-align="start center"><span class="logo-icon"><md-icon \nmd-font-icon="icon-account-box" class="s24"></md-icon></span><span class="logo-text" translate="CONTACTS.CONTACTS">\nContacts</span></div></div><div class="search-input-wrapper" layout="row" layout-align="start center"><label \nfor="search"><md-icon md-font-icon="icon-magnify"></md-icon></label><md-input-container md-no-float class="m-0"><input \nid="search" placeholder="{{\'CONTACTS.SEARCH_FOR_ANYONE\' |\xA0translate}}" type="text" ng-model="vm.search" translate \ntranslate-attr-placeholder="CONTACTS.SEARCH_FOR_ANYONE"></md-input-container></div></div><div \nng-show="vm.selectedContacts.length > 0" class="selected-bar header animate-slide-down md-accent-bg" layout="row" \nlayout-align="start center"><div class="close-button-wrapper" ng-click="vm.selectedContacts =[]"><md-button \nlayout="row" layout-align="start center"><md-icon md-font-icon="icon-arrow-left" class="mr-8"></md-icon><span \ntranslate="CONTACTS.BACK">Back</span></md-button></div><div flex layout="row" layout-align="space-between center"><div>\n<span class="selected-contacts-count"><span>{{vm.selectedContacts.length}}</span> <span translate="CONTACTS.SELECTED">\nselected</span></span><md-menu class="select-menu" ng-if="!vm.currentThread"><md-button class="md-icon-button" \nng-click="$mdMenu.open($event)" aria-label="multi select toggle" translate \ntranslate-attr-aria-label="CONTACTS.MULTI_SELECT_TOGGLE"><md-icon md-font-icon="icon-menu-down"></md-icon></md-button>\n<md-menu-content width="3"><md-menu-item><md-button ng-click="vm.selectAllContacts()" translate="CONTACTS.SELECT_ALL">\nSelect all</md-button></md-menu-item><md-menu-item><md-button ng-click="vm.deselectContacts()" \ntranslate="CONTACTS.SELECT_NONE">Select none</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass="multi-select-actions"><md-button class="md-icon-button" ng-click="vm.deleteSelectedContacts($event)" \naria-label="delete selected" translate translate-attr-label="CONTACTS.DELETE_SELECTED"><md-icon \nmd-font-icon="icon-delete"></md-icon></md-button></div></div></div><div class="content" md-background-bg layout="row" \nlayout-align="start start"><md-sidenav class="sidenav main-sidenav md-white-bg" ms-scroll \nmd-is-locked-open="$mdMedia(\'gt-md\')" md-component-id="sidenav" ms-sidenav-helper \nng-include="\'app/main/apps/contacts/sidenavs/main/main-sidenav.html\'"></md-sidenav><div class="main" ms-scroll><md-list\n class="contacts-list"><md-subheader class="md-no-sticky md-white-bg"><div layout="row" \nlayout-align="space-between center"><div class="list-title" layout="row" layout-align="start center" \nng-hide="editGroupForm.$visible"><span ng-if="vm.listType === \'all\'" translate="CONTACTS.ALL_CONTACTS">All contacts\n</span> <span ng-if="vm.listType === \'frequent\'" translate="CONTACTS.FREQUENTLY_CONTACTED">Frequnetly contacted</span> \n<span ng-if="vm.listType === \'starred\'" translate="CONTACTS.STARRED_CONTACTS">Starred contacts</span> <span \nng-if="vm.listType.name">{{vm.listType.name}}</span> <span ng-if="filteredContacts.length" \nclass="secondary-text contacts-count">({{filteredContacts.length}})</span></div><div class="edit-group-form" \nng-show="vm.listType.name" layout="row" layout-align="start center"><span ng-show="editGroupForm.$visible" \neditable-text="vm.listType.name" e-form="editGroupForm" onaftersave="vm.editGroup()"></span><md-button \nclass="md-icon-button edit-group-button" ng-click="editGroupForm.$show()" ng-hide="editGroupForm.$visible" \naria-label="edit group name" translate translate-attr-label="CONTACTS.EDIT_GROUP_NAME"><md-icon \nmd-font-icon="icon-pencil s18"></md-icon></md-button><md-button class="md-icon-button edit-group-button" \nng-click="vm.deleteGroup($event)" ng-hide="editGroupForm.$visible" aria-label="delete group" translate \ntranslate-attr-label="CONTACTS.DELETE_GROUP"><md-icon md-font-icon="icon-delete s18"></md-icon></md-button></div><div \nflex></div><md-menu><md-button class="md-icon-button" aria-label="Sort" translate \ntranslate-attr-aria-label="CONTACTS.SORT"><md-icon md-font-icon="icon-sort-alphabetical" \nng-click="$mdMenu.open($event)"></md-icon></md-button><md-menu-content width="3"><md-menu-item><md-button \nng-click="vm.listOrder = \'name\';vm.listOrderAsc = false" \nng-style="vm.listOrder === \'name\' && vm.listOrderAsc=== false && {\'font-weight\':\'500\'}"><span \ntranslate="CONTACTS.FIRST_NAME">First Name</span> <small translate="CONTACTS.A_TO_Z">(A to Z)</small></md-button>\n</md-menu-item><md-menu-item><md-button ng-click="vm.listOrder = \'name\'; vm.listOrderAsc = true" \nng-style="vm.listOrder === \'name\' && vm.listOrderAsc=== true && {\'font-weight\':\'500\'}"><span \ntranslate="CONTACTS.FIRST_NAME">First Name</span> <small translate="CONTACTS.Z_TO_A">(Z to A)</small></md-button>\n</md-menu-item><md-menu-item><md-button ng-click="vm.listOrder = \'lastName\';vm.listOrderAsc = false" \nng-style="vm.listOrder === \'lastName\' && vm.listOrderAsc=== false && {\'font-weight\':\'500\'}"><span \ntranslate="CONTACTS.LAST_NAME">Last Name</span> <small translate="CONTACTS.A_TO_Z">(A to Z)</small></md-button>\n</md-menu-item><md-menu-item><md-button ng-click="vm.listOrder = \'lastName\'; vm.listOrderAsc = true" \nng-style="vm.listOrder === \'lastName\' && vm.listOrderAsc=== true && {\'font-weight\':\'500\'}"><span \ntranslate="CONTACTS.LAST_NAME">Last Name</span> <small translate="CONTACTS.Z_TO_A">(Z to A)</small></md-button>\n</md-menu-item></md-menu-content></md-menu></div></md-subheader><md-list-item class="contact-item md-white-bg" \nmd-ink-ripple \nng-repeat="contact in vm.contacts | filter: vm.search | filter: global.search | filterByIds:vm.filterIds |  orderBy: vm.listOrder :vm.listOrderAsc | filter:query as filteredContacts track by contact.id " \nng-click="vm.openContactDialog($event, contact)" \nng-style="{\'transform\': \'translate3d(0px, \'+$index * 100+\'%, 0px)\', \'z-index\': filteredContacts.length - $index}" \nng-class="{\'selected\': vm.isSelected(contact)}"><md-checkbox ng-checked="vm.exists(contact, vm.selectedContacts)" \nng-click="vm.toggleSelectContact(contact, $event)" \naria-label="{{vm.exists(contact, vm.selectedContacts) ? \'Deselect\' : \'Select\'}}"></md-checkbox><img class="md-avatar" \nng-if="contact.avatar" alt="{{contact.name}}" ng-src="{{contact.avatar}}"><p class="text-truncate font-weight-600">\n{{contact.name}} {{contact.lastName}}</p><p class="email text-truncate hide show-gt-sm">{{contact.email}}</p><p \nclass="phone text-truncate hide show-gt-md">{{contact.phone}}</p><p class="job-title text-truncate hide show-gt-lg">\n{{contact.jobTitle}}</p><p class="company text-truncate hide show-gt-lg">{{contact.company}}</p><div class="actions" \nlayout="row" layout-align="start center"><md-button class="md-icon-button hide show-gt-xs" \nng-click="$event.stopPropagation();vm.toggleInArray(contact.id, vm.user.starred)" aria-label="Toggle starred" \ntranslate translate-attr-aria-label="CONTACTS.TOGGLE_STARRED"><md-icon ng-if="vm.exists(contact.id,vm.user.starred)" \nmd-font-icon="icon-star" class="amber-fg"></md-icon><md-icon ng-if="!vm.exists(contact.id,vm.user.starred)" \nmd-font-icon="icon-star-outline"></md-icon></md-button><md-menu><md-button class="md-icon-button" aria-label="More" \ntranslate translate-attr-aria-label="CONTACTS.MORE"><md-icon md-font-icon="icon-dots-vertical" \nng-click="$mdMenu.open($event)"></md-icon></md-button><md-menu-content width="3"><md-menu-item><md-button \nng-click="vm.deleteContactConfirm(contact, ev)" translate="CONTACTS.DELETE_CONTACT">Delete Contact</md-button>\n</md-menu-item><md-divider ng-if="vm.user.groups"></md-divider><md-subheader class="md-no-sticky" \nng-if="vm.user.groups">Groups</md-subheader><md-list-item ng-if="vm.user.groups" ng-repeat="group in vm.user.groups" \nng-click="vm.toggleInArray(contact.id,group.contactIds)"><p class="pl-8" \nng-style="vm.exists(contact.id,group.contactIds) && {\'font-weight\':\'500\'}">{{group.name}}</p></md-list-item>\n</md-menu-content></md-menu></div></md-list-item></md-list><md-list-item class="no-results md-white-bg" \nng-show="filteredContacts.length === 0"><p translate="CONTACTS.NO_RESULTS">No results..</p></md-list-item></div></div>\n<md-button class="md-fab md-accent md-icon-button" id="add-contact-button" ng-click="vm.openContactDialog($event)" \naria-label="add contact" translate translate-attr-aria-label="CONTACTS.ADD_CONTACT"><md-icon \nmd-font-icon="icon-account-plus"></md-icon></md-button></div>');
$templateCache.put('app/main/apps/contacts/empty.html','');
$templateCache.put('app/main/apps/divisions/divisions.html','<div id="site-division" class="page-layout carded left-sidenav" layout="row"><div class="center" layout="column" flex>\n<div class="content-card" layout="column" flex ng-include="vm.views[vm.currentView]" md-no-ink></div></div>\n<h2c-pagination collection="vm.divisions" url="\'http://\'" service="divisionsService" style="display:none;">\n</h2c-pagination></div>');
$templateCache.put('app/main/apps/dashboard/dashboard.html','<div id="site-dashboard" \nng-style="{\'background\': \'url(\' + vm.branding.dashboardBackground + \') no-repeat center center / cover\'}" \nclass="white-fg ph-20 pv-30" layout="column" layout-align="center center"><img class="logo-image-dashboard" \nng-src="{{vm.branding.logo}}" alt="{{vm.branding.companyname}}"><h1 class="m-0 font-weight-400 font-size-48">\n{{ \'LOGIN.INTRO_TITLEQ\' | translate }} {{(vm.branding.companyname ? vm.branding.companyname : \'H2C\') | uppercase}}</h1>\n<span class="mt-10 mb-30 font-size-20">{{ \'LOGIN.SLOGAN\' | translate }}</span></div>');
$templateCache.put('app/main/apps/dashboard/dashboard5.html','<div id="dashboard-container" class="page-layout carded left-sidenav justify-center" layout="column" \nlayout-align="stretch space-between"><div id="site-dashboard" \nstyle="background : url({{vm.branding.dashboardBackground}}) no-repeat; background-size: cover;" \nclass="white-fg ph-20 pv-30" flex="45" layout="column" layout-align="center center"><h1 \nclass="m-0 font-weight-400 font-size-48">\n{{ \'LOGIN.INTRO_TITLEQ\' | translate }} {{(vm.branding.companyname ? vm.branding.companyname : \'H2C\') | uppercase}}</h1>\n<span class="mt-10 mb-30 font-size-20">{{ \'LOGIN.SLOGAN\' | translate }}</span></div><div id="site-dashboard-bottom" \nflex="55" layout="column" layout-align="center center"><div class="dashboard-bottom-container" layout="column" \nlayout-align="start stretch" layout-gt-sm="row" layout-align-gt-sm="space-between center"><div layout="column" \nlayout-align="start center" layout-align-gt-sm="start start" flex="100" class="ph-20"><h2 \nclass="m-0 font-weight-400 font-size-38">{{ \'LOGIN.QUICK_GUIDE\' | translate }}</h2><span \nclass="mt-10 mb-30 font-size-16">{{ \'LOGIN.DASHBOARD_DESC\' | translate }}</span><md-button \nhref="https://ayuda.h2c.app/es/" target="_blank" class="ml-0 md-raised md-accent font-size-16 pv-5 ph-20">\n{{ \'LOGIN.YOUTUBE_CANAL\' | translate }}</md-button></div></div></div></div>');
$templateCache.put('app/main/apps/dashboard/dashboarddata.html','<div id="site-dashboard-data" class="widget-group" layout="column" layout-align="start-start" flex="100"><md-list-item \nclass="md-toolbar-tools grey-100-bg"><md-menu-bar class="user-menu"><md-menu md-position-mode="left bottom"><md-button \nclass="user-button" ng-click="vm.companies.length> 1 ? $mdMenu.open() : null" aria-label="User settings" translate \ntranslate-attr-aria-label="TOOLBAR.USER_SETTINGS"><div layout="row" layout-align="space-between center"><div \nclass="avatar-wrapper" ng-show="!vm.companySelected"><img md-menu-align-target class="avatar" \nsrc="assets/images/logos/generic-company.jpg"></div><div class="avatar-wrapper" \nng-show="vm.companySelected && vm.companySelected.files.length> 0"><img md-menu-align-target class="avatar" \nng-src="{{storagePrefix}}{{vm.companySelected.files[0].url}}"></div><span ng-if="!vm.companySelected" class="username" \ntranslate="GLOBAL.SELECT_CLIENT" hide show-gt-sm></span> <span ng-if="vm.companySelected" class="username" hide \nshow-gt-sm>{{vm.companySelected.name}}</span><md-icon ng-if="vm.companies.length> 1" md-font-icon="icon-chevron-down" \nclass="icon s16" hide-xs></md-icon></div></md-button><md-menu-content width="3" class="clients"><md-menu-item \nclass="md-indent"><div class="search-input-wrapper" layout="row" layout-align="start center"><label for="search">\n<md-icon md-font-icon="icon-magnify" class="search-icon"></md-icon></label><md-input-container md-no-float class="m-0" \nlayout="row" layout-align="start center"><input id="search" placeholder="{{\'CONTACTS.SEARCH_FOR_ANYONE\' | translate}}" \ntype="text" ng-model="searchText"></md-input-container></div></md-menu-item><div class="results"><md-menu-item \nng-click="vm.selectCompany(company)" class="md-indent bar-client" \nng-repeat="company in vm.companies | filter:searchText"><div layout="row" layout-align="start center"><div \nng-if="company.files[0].url" class="avatar-wrapper"><img md-menu-align-target class="avatar" \nng-src="{{storagePrefix}}{{company.files[0].url}}"></div><div ng-if="!company.files[0].url" class="avatar small img" \nng-bind="company.name | capitalizeFirstLetter"></div><button class="btn-clients">{{company.name}}</button></div>\n</md-menu-item></div></md-menu-content></md-menu></md-menu-bar></md-list-item><div layout="column" layout-gt-md="row" \nng-if="!vm.isLoadingData" style="width: 100%;" class="chart-section"><div class="widget-group m-h-auto" flex="100" \nlayout="row" layout-align="start start" layout-wrap ng-include="\'app/main/apps/dashboard/views/general-widgets.html\'">\n</div><div ng-if="vm.events" flex="100" class="mt-10 mh-25 calendar-section"><div class="content"><div \nid="calendarView" ui-calendar="vm.calendarUiConfig.calendar" ng-model="vm.events" calendar="main"></div></div></div>\n</div></div>');
$templateCache.put('app/main/apps/documents/documents.html','<div id="site-documents" class="page-layout carded left-sidenav" layout="row" md-no-ink><md-sidenav md-is-open="true" \nng-if="vm.isCompanySelected() || vm.documentSelected" class="sidenav groups-tree sidenav-users sidenav-groups" \nmd-component-id="documents-sidenav" ng-include="\'app/main/apps/documents/sidenavs/documents/documents-sidenav.html\'" \nms-scroll ms-sidenav-helper md-no-ink></md-sidenav><div class="center" layout="column" \nng-if="vm.isCompanySelected() || vm.documentSelected" flex><div class="content-card split" \nng-class="{\'edited\':vm.documentSelected}" layout="column" flex \nng-include="\'app/main/apps/documents/views/list/items-view.html\'" md-no-ink></div></div><h2c-pagination \ncollection="vm.documents" url="\'http://\'" service="documentsService" style="display:none;" ng-if="!vm.firstLoad">\n</h2c-pagination><div class="content-wrapper" layout="row" flex \nng-if="!vm.isCompanySelected() && !vm.documentSelected"><div class="content thread-detail" layout="row" \nlayout-align="center center" flex><div class="no-client-selected no-thread-selected" layout="column" \nlayout-align="center center" flex><md-icon md-font-icon="icon-timelapse" class="s120 grey-400-fg"></md-icon><span \nclass="hint-text" translate="DOCUMENTS.SELECT_COMPANY_FIRST"></span></div></div></div></div>');
$templateCache.put('app/main/apps/e-commerce/e-commerce.html','<div id="ecommerce" class="page-layout carded left-sidenav" layout="row"><div class="top-bg md-accent-bg"></div>\n<md-sidenav class="sidenav" md-is-locked-open="$mdMedia(\'gt-md\')" md-component-id="main-sidenav" \nng-include="\'app/main/apps/mail/sidenavs/main/main-sidenav.html\'" ms-scroll ms-sidenav-helper></md-sidenav><div \nclass="center" layout="column" flex><div class="header" layout="row" layout-align="start center"><div \nclass="search-wrapper md-whiteframe-4dp" layout="row" layout-align="start center" flex><md-button \nclass="md-icon-button sidenav-toggle" ng-click="vm.toggleSidenav(\'main-sidenav\')" hide-gt-md \naria-label="Toggle Sidenav" translate translate-attr-aria-label="MAIL.TOGGLE_SIDENAV"><md-icon class="icon" \nmd-font-icon="icon-menu"></md-icon></md-button><div class="search" flex layout="row" layout-align="start center">\n<md-icon md-font-icon="icon-magnify" class="icon s24"></md-icon><input flex ng-model="vm.search" type="text" \nplaceholder="Search for an e-mail or contact" translate translate-attr-placeholder="MAIL.SEARCH_PLACEHOLDER"></div>\n</div></div><div class="content-card" layout="column" flex>Ecommerce Dashboard</div></div></div>');
$templateCache.put('app/main/apps/faqs/faqs.html','<div class="wrapper"><div class="faq-container"><h2 class="md-headline text-center faq-title-top" \ntranslate="FAQS.TITLE"></h2><div class="faq-search"><input type="text" ng-model="vm.searchQuery" \nng-change="vm.searchFAQs()" placeholder="{{ \'FAQS.SEARCH_PLACEHOLDER\' | translate }}" class="faq-search-input"></div>\n<div ng-if="!vm.loading && vm.filteredFAQs.length === 0" class="no-results-message" translate="FAQS.NO_RESULTS"></div>\n<div ng-if="vm.loading" class="text-center"><md-progress-circular md-mode="indeterminate" class="md-accent">\n</md-progress-circular></div><h3 class="md-headline faq-second-title-top" ng-if="vm.hasFAQsOfType(1)" \ntranslate="FAQS.GENERAL"></h3><md-card ng-repeat="faq in vm.filteredFAQs | filter:{type_id: 1}:true" \nclass="faq-item bg-white shadow-3 md-padding"><md-card-header class="faq-header" ng-click="vm.toggleFAQ(faq)"><div \nclass="faq-question"><md-card-header-text><span class="md-title">{{ faq.question }}</span></md-card-header-text></div>\n<md-buttons class="arrow-button-faqs"><i class="icon-chevron-right" \nng-class="{\'icon-chevron-down\': faq.isOpen, \'icon-chevron-right\': !faq.isOpen}"></i></md-buttons></md-card-header>\n<md-card-content class="faq-answer" ng-class="{\'faq-answer-open\': faq.isOpen}" layout="column" \nlayout-align="start stretch"><p class="md-body-1" ng-bind-html="vm.getTrustedHtml(faq)"></p></md-card-content>\n</md-card><h3 class="md-headline faq-second-title-top" ng-if="vm.hasFAQsOfType(2)" translate="FAQS.DASHBOARD"></h3>\n<md-card ng-repeat="faq in vm.filteredFAQs | filter:{type_id: 2}:true" class="faq-item bg-white shadow-3 md-padding">\n<md-card-header class="faq-header" ng-click="vm.toggleFAQ(faq)"><div class="faq-question"><md-card-header-text><span \nclass="md-title">{{ faq.question }}</span></md-card-header-text></div><md-buttons class="arrow-button-faqs"><i \nclass="icon-chevron-right" ng-class="{\'icon-chevron-down\': faq.isOpen, \'icon-chevron-right\': !faq.isOpen}"></i>\n</md-buttons></md-card-header><md-card-content class="faq-answer" ng-class="{\'faq-answer-open\': faq.isOpen}" \nlayout="column" layout-align="start stretch"><p class="md-body-1" ng-bind-html="vm.getTrustedHtml(faq)"></p>\n</md-card-content></md-card><h3 class="md-headline faq-second-title-top" ng-if="vm.hasFAQsOfType(3)" \ntranslate="FAQS.CLIENTS"></h3><md-card ng-repeat="faq in vm.filteredFAQs | filter:{type_id: 3}:true" \nclass="faq-item bg-white shadow-3 md-padding"><md-card-header class="faq-header" ng-click="vm.toggleFAQ(faq)"><div \nclass="faq-question"><md-card-header-text><span class="md-title">{{ faq.question }}</span></md-card-header-text></div>\n<md-buttons class="arrow-button-faqs"><i class="icon-chevron-right" \nng-class="{\'icon-chevron-down\': faq.isOpen, \'icon-chevron-right\': !faq.isOpen}"></i></md-buttons></md-card-header>\n<md-card-content class="faq-answer" ng-class="{\'faq-answer-open\': faq.isOpen}" layout="column" \nlayout-align="start stretch"><p class="md-body-1" ng-bind-html="vm.getTrustedHtml(faq)"></p></md-card-content>\n</md-card><h3 class="md-headline faq-second-title-top" ng-if="vm.hasFAQsOfType(4)" translate="FAQS.USERS"></h3><md-card\n ng-repeat="faq in vm.filteredFAQs | filter:{type_id: 4}:true" class="faq-item bg-white shadow-3 md-padding">\n<md-card-header class="faq-header" ng-click="vm.toggleFAQ(faq)"><div class="faq-question"><md-card-header-text><span \nclass="md-title">{{ faq.question }}</span></md-card-header-text></div><md-buttons class="arrow-button-faqs"><i \nclass="icon-chevron-right" ng-class="{\'icon-chevron-down\': faq.isOpen, \'icon-chevron-right\': !faq.isOpen}"></i>\n</md-buttons></md-card-header><md-card-content class="faq-answer" ng-class="{\'faq-answer-open\': faq.isOpen}" \nlayout="column" layout-align="start stretch"><p class="md-body-1" ng-bind-html="vm.getTrustedHtml(faq)"></p>\n</md-card-content></md-card><h3 class="md-headline faq-second-title-top" ng-if="vm.hasFAQsOfType(5)" \ntranslate="FAQS.TASKS"></h3><md-card ng-repeat="faq in vm.filteredFAQs | filter:{type_id: 5}:true" \nclass="faq-item bg-white shadow-3 md-padding"><md-card-header class="faq-header" ng-click="vm.toggleFAQ(faq)"><div \nclass="faq-question"><md-card-header-text><span class="md-title">{{ faq.question }}</span></md-card-header-text></div>\n<md-buttons class="arrow-button-faqs"><i class="icon-chevron-right" \nng-class="{\'icon-chevron-down\': faq.isOpen, \'icon-chevron-right\': !faq.isOpen}"></i></md-buttons></md-card-header>\n<md-card-content class="faq-answer" ng-class="{\'faq-answer-open\': faq.isOpen}" layout="column" \nlayout-align="start stretch"><p class="md-body-1" ng-bind-html="vm.getTrustedHtml(faq)"></p></md-card-content>\n</md-card><h3 class="md-headline faq-second-title-top" ng-if="vm.hasFAQsOfType(6)" translate="FAQS.COMPLAINTS"></h3>\n<md-card ng-repeat="faq in vm.filteredFAQs | filter:{type_id: 6}:true" class="faq-item bg-white shadow-3 md-padding">\n<md-card-header class="faq-header" ng-click="vm.toggleFAQ(faq)"><div class="faq-question"><md-card-header-text><span \nclass="md-title">{{ faq.question }}</span></md-card-header-text></div><md-buttons class="arrow-button-faqs"><i \nclass="icon-chevron-right" ng-class="{\'icon-chevron-down\': faq.isOpen, \'icon-chevron-right\': !faq.isOpen}"></i>\n</md-buttons></md-card-header><md-card-content class="faq-answer" ng-class="{\'faq-answer-open\': faq.isOpen}" \nlayout="column" layout-align="start stretch"><p class="md-body-1" ng-bind-html="vm.getTrustedHtml(faq)"></p>\n</md-card-content></md-card><h3 class="md-headline faq-second-title-top" ng-if="vm.hasFAQsOfType(7)" \ntranslate="FAQS.DOCUMENTS"></h3><md-card ng-repeat="faq in vm.filteredFAQs | filter:{type_id: 7}:true" \nclass="faq-item bg-white shadow-3 md-padding"><md-card-header class="faq-header" ng-click="vm.toggleFAQ(faq)"><div \nclass="faq-question"><md-card-header-text><span class="md-title">{{ faq.question }}</span></md-card-header-text></div>\n<md-buttons class="arrow-button-faqs"><i class="icon-chevron-right" \nng-class="{\'icon-chevron-down\': faq.isOpen, \'icon-chevron-right\': !faq.isOpen}"></i></md-buttons></md-card-header>\n<md-card-content class="faq-answer" ng-class="{\'faq-answer-open\': faq.isOpen}" layout="column" \nlayout-align="start stretch"><p class="md-body-1" ng-bind-html="vm.getTrustedHtml(faq)"></p></md-card-content>\n</md-card><h3 class="md-headline faq-second-title-top" ng-if="vm.hasFAQsOfType(8)" translate="FAQS.FORMS"></h3><md-card\n ng-repeat="faq in vm.filteredFAQs | filter:{type_id: 8}:true" class="faq-item bg-white shadow-3 md-padding">\n<md-card-header class="faq-header" ng-click="vm.toggleFAQ(faq)"><div class="faq-question"><md-card-header-text><span \nclass="md-title">{{ faq.question }}</span></md-card-header-text></div><md-buttons class="arrow-button-faqs"><i \nclass="icon-chevron-right" ng-class="{\'icon-chevron-down\': faq.isOpen, \'icon-chevron-right\': !faq.isOpen}"></i>\n</md-buttons></md-card-header><md-card-content class="faq-answer" ng-class="{\'faq-answer-open\': faq.isOpen}" \nlayout="column" layout-align="start stretch"><p class="md-body-1" ng-bind-html="vm.getTrustedHtml(faq)"></p>\n</md-card-content></md-card><h3 class="md-headline faq-second-title-top" ng-if="vm.hasFAQsOfType(9)" \ntranslate="FAQS.LANG"></h3><md-card ng-repeat="faq in vm.filteredFAQs | filter:{type_id: 9}:true" \nclass="faq-item bg-white shadow-3 md-padding"><md-card-header class="faq-header" ng-click="vm.toggleFAQ(faq)"><div \nclass="faq-question"><md-card-header-text><span class="md-title">{{ faq.question }}</span></md-card-header-text></div>\n<md-buttons class="arrow-button-faqs"><i class="icon-chevron-right" \nng-class="{\'icon-chevron-down\': faq.isOpen, \'icon-chevron-right\': !faq.isOpen}"></i></md-buttons></md-card-header>\n<md-card-content class="faq-answer" ng-class="{\'faq-answer-open\': faq.isOpen}" layout="column" \nlayout-align="start stretch"><p class="md-body-1" ng-bind-html="vm.getTrustedHtml(faq)"></p></md-card-content>\n</md-card></div></div>');
$templateCache.put('app/main/apps/file-manager/file-manager.html','<div id="file-manager" class="page-layout simple right-sidenav" layout="row"><md-sidenav class="main-sidenav" \nmd-component-id="main-sidenav" ng-include="\'app/main/apps/file-manager/sidenavs/main/main-sidenav.html\'" ms-scroll \nms-sidenav-helper></md-sidenav><div class="center" layout="column" flex><div class="header md-accent-bg"><div \nclass="header-content" layout="column" layout-align="space-between"><div class="toolbar" layout="row" \nlayout-align="space-between"><md-button class="md-icon-button main-sidenav-toggle" \nng-click="vm.toggleSidenav(\'main-sidenav\')" aria-label="Toggle Main Sidenav" translate \ntranslate-attr-aria-label="FILE.TOOGLE_MAIN_SIDENAV"><md-icon md-font-icon="icon-menu" class="icon"></md-icon>\n</md-button><div class="right-side" layout="row"><md-button class="md-icon-button" aria-label="Search" translate \ntranslate-attr-aria-label="FM.SEARCH"><md-icon md-font-icon="icon-magnify"></md-icon><md-tooltip><span \ntranslate="FM.SEARCH">Search</span></md-tooltip></md-button><md-button ng-if="vm.currentView === \'list\'" \nclass="md-icon-button" ng-click="vm.toggleView()" aria-label="view type" translate \ntranslate-attr-aria-label="FM.GRID_VIEW"><md-icon md-font-icon="icon-view-module"></md-icon><md-tooltip><span \ntranslate="FM.GRID_VIEW">Grid View</span></md-tooltip></md-button><md-button ng-if="vm.currentView === \'grid\'" \nclass="md-icon-button" aria-label="view type" ng-click="vm.toggleView()" translate \ntranslate-attr-aria-label="FM.LIST_VIEW"><md-icon md-font-icon="icon-view-headline"></md-icon><md-tooltip><span \ntranslate="FM.LIST_VIEW">List View</span></md-tooltip></md-button></div></div><div class="breadcrumb text-truncate" \nlayout="row" layout-align="start center"><span data-ng-repeat="path in vm.path">{{path}}<md-icon \nmd-font-icon="icon-chevron-right" class="icon separator"></md-icon></span></div></div><div id="file-uploader" \nflow-init="vm.ngFlowOptions" flow-name="vm.ngFlow.flow" flow-files-submitted="vm.upload()" \nflow-file-added="vm.fileAdded($file)" flow-file-success="vm.fileSuccess($file, $message)" \nflow-complete="vm.uploadComplete()"><md-button flow-btn class="add-file-button md-fab md-warn" \nng-click="vm.addFile($event)" aria-label="Add file" translate translate-attr-aria-label="FM.ADD_FILE"><md-icon \nmd-font-icon="icon-plus"></md-icon></md-button></div></div><md-content class="content" flex ms-scroll><div \nng-if="vm.currentView === \'grid\'" ng-include="\'app/main/apps/file-manager/views/grid/grid-view.html\'"></div><div \nng-if="vm.currentView === \'list\'" ng-include="\'app/main/apps/file-manager/views/list/list-view.html\'"></div>\n</md-content></div><md-sidenav class="sidenav details-sidenav md-sidenav-right" md-is-locked-open="$mdMedia(\'gt-md\')" \nmd-component-id="details-sidenav" ng-include="\'app/main/apps/file-manager/sidenavs/details/details-sidenav.html\'" \nms-scroll ms-sidenav-helper></md-sidenav></div>');
$templateCache.put('app/main/apps/gantt-chart/gantt-chart.html','<div id="gantt-chart" class="page-layout carded fullwidth" \nng-class="{\'date-filter-active\':vm.dateFilterActive, \'search-active\': vm.searchActive}" layout="row"><md-sidenav \nclass="sidenav settings-sidenav md-sidenav-right" md-component-id="settings-sidenav" \nng-include="\'app/main/apps/gantt-chart/sidenavs/settings/settings-sidenav.html\'" ms-scroll ms-sidenav-helper>\n</md-sidenav><div class="top-bg md-accent-bg"></div><div class="center" layout="column" flex><div class="header" \nlayout="column"><div class="toolbar" layout="row" layout-align="space-between center"><div class="logo" layout="row" \nlayout-align="start center"><span class="logo-icon"><md-icon md-font-icon="icon-calendar-text" class="icon"></md-icon>\n</span><span class="logo-text" translate="GANTT.GANTT_CHART">Gantt Chart</span></div><div layout="row" \nlayout-align="end center"><md-button class="md-icon-button" ng-click="vm.searchActive = !vm.searchActive" \naria-label="Search" translate translate-attr-aria-label="GANTT.SEARCH"><md-icon md-font-icon="icon-magnify"></md-icon>\n<md-tooltip><span translate="GANTT.SEARCH">Search</span></md-tooltip></md-button><md-button class="md-icon-button" \nng-click="vm.dateFilterActive = !vm.dateFilterActive" aria-label="Filter Date" translate \ntranslate-attr-aria-label="GANTT.FILTER_DATE"><md-icon md-font-icon="icon-calendar"></md-icon><md-tooltip><span \ntranslate="GANTT.FILTER_DATE">Filter Date</span></md-tooltip></md-button><md-button ng-click="vm.reload()" \nclass="md-icon-button" aria-label="Reload" translate translate-attr-aria-label="GANTT.RELOAD"><md-icon \nmd-font-icon="icon-reload"></md-icon><md-tooltip><span translate="GANTT.RELOAD">RELOAD</span></md-tooltip></md-button>\n<md-button ng-click="vm.toggleSidenav(\'settings-sidenav\')" class="md-icon-button" aria-label="Settings" translate \ntranslate-attr-aria-label="GANTT.SETTINGS"><md-icon md-font-icon="icon-cog"></md-icon><md-tooltip><span \ntranslate="GANTT.SETTINGS">Settings</span></md-tooltip></md-button></div></div><div class="bottom" layout="column" \nlayout-gt-sm="row" layout-align-gt-sm="end center"><div class="search-boxes" flex ng-show="vm.searchActive" \nlayout="column" layout-gt-xs="row"><div class="search md-whiteframe-3dp mr-8" flex layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-magnify" class="icon s24"></md-icon><input flex \nng-model="vm.searchRowKeyword" ng-change="vm.search(\'rows\', vm.searchRowKeyword)" type="text" \nplaceholder="Search in rows" translate translate-attr-placeholder="GANTT.SEARCH_IN_ROWS"></div><div \nclass="search md-whiteframe-3dp" flex layout="row" layout-align="start center"><md-icon md-font-icon="icon-magnify" \nclass="icon s24"></md-icon><input flex ng-model="vm.searchTaskKeyword" \nng-change="vm.search(\'tasks\', vm.searchTaskKeyword)" type="text" placeholder="Search in tasks" translate \ntranslate-attr-placeholder="GANTT.SEARCH_IN_TASKS"></div></div><div class="date-filter-box md-whiteframe-3dp" \nng-show="vm.dateFilterActive" layout="column" layout-gt-xs="row" layout-align-gt-xs="center center"><div layout="row" \nlayout-align="center center" class="filter from"><span class="label">From:</span><md-datepicker ms-datepicker-fix \nng-model="vm.options.fromDate" md-max-date="vm.options.toDate" md-placeholder="Enter date"></md-datepicker></div><div \nlayout="row" layout-align="center center" class="filter to"><span class="label">To:</span><md-datepicker \nms-datepicker-fix ng-model="vm.options.toDate" md-min-date="vm.options.fromDate" md-placeholder="Enter date">\n</md-datepicker></div></div></div></div><div class="content-card" layout="column" flex><div class="toolbar" \nlayout="row" layout-align="space-between center"><div layout="row" layout-align="start center"><md-button \nng-click="vm.addDialog($event)" class="md-icon-button add-row-button" aria-label="Add" translate \ntranslate-attr-aria-label="GANTT.ADD"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div><div layout="row" \nlayout-align="start center"><div class="zoom" layout="row" layout-align="end center"><span class="label">Zoom:</span>\n<div class="input-wrapper" layout="row" layout-align="center center"><md-button class="md-icon-button" \naria-label="minus" ng-click="vm.options.zoom  = vm.options.zoom - 0.1"><md-icon md-font-icon="icon-minus"></md-icon>\n</md-button><input type="number" ng-model="vm.options.zoom" step="0.1" min="0.1" max="5"><md-button \nclass="md-icon-button" aria-label="plus" ng-click="vm.options.zoom =vm.options.zoom + 0.1"><md-icon \nmd-font-icon="icon-plus"></md-icon></md-button></div></div><md-select class="simplified select-scale" \nng-model="vm.options.scale" placeholder="Scale"><md-option value="hour" translate="GANTT.HOUR">hour</md-option>\n<md-option value="3 hours" translate="GANTT.3_HOURS">3 hours</md-option><md-option value="day" translate="GANTT.DAY">\nday</md-option><md-option value="week" translate="GANTT.WEEK">week</md-option><md-option value="2 weeks" \ntranslate="GANTT.2_WEEKS">2 weeks</md-option><md-option value="month" translate="GANTT.MONTH">month</md-option>\n<md-option value="quarter" translate="GANTT.QUARTER">quarter</md-option><md-option value="6 months" \ntranslate="GANTT.6_MONTHS">6 months</md-option><md-option value="year" translate="GANTT.YEAR">year</md-option>\n</md-select><div class="divider-vertical"></div><md-menu><md-button class="md-icon-button" \nng-click="$mdMenu.open($event)" aria-label="Filters" translate translate-attr-aria-label="MAIL.FILTERS"><md-icon \nmd-font-icon="icon-sort"></md-icon></md-button><md-menu-content width="3"><md-menu-item><md-button \naria-label="disabled" ng-click="vm.setSortMode(undefined)" translate="GANTT.DISABLED" \ntranslate-attr-aria-label="GANTT.DISABLED">disabled</md-button></md-menu-item><md-menu-item><md-button \naria-label="disabled" ng-click="vm.setSortMode(\'from\')" translate="GANTT.FROM" translate-attr-aria-label="GANTT.FROM">\nfrom</md-button></md-menu-item><md-menu-item><md-button aria-label="disabled" ng-click="vm.setSortMode(\'to\')" \ntranslate="GANTT.TO" translate-attr-aria-label="GANTT.TO">to</md-button></md-menu-item><md-menu-item><md-button \naria-label="disabled" ng-click="vm.setSortMode(\'model.name\')" translate="GANTT.NAME" \ntranslate-attr-aria-label="GANTT.NAME">name</md-button></md-menu-item></md-menu-content></md-menu></div></div>\n<md-content id="chart-container" class="content" flex layout="column"><div flex layout-fill id="gantt" gantt \ndata="vm.data" timespans="vm.timespans" show-side="vm.options.labelsEnabled" daily="vm.options.daily" \nfilter-task="{\'name\': vm.options.filterTask}" filter-row="{\'name\': vm.options.filterRow}" \nsort-mode="vm.options.sortMode" view-scale="vm.options.scale" \ncolumn-width="vm.getColumnWidth(vm.options.width, vm.options.scale, vm.options.zoom)" \nauto-expand="vm.options.autoExpand" task-out-of-range="vm.options.taskOutOfRange" from-date="vm.options.fromDate" \nto-date="vm.options.toDate" allow-side-resizing="vm.options.allowSideResizing" \ntask-content="vm.options.taskContentEnabled ? vm.options.taskContent : undefined" \nrow-content="vm.options.rowContentEnabled ? vm.options.rowContent : undefined" current-date="vm.options.currentDate" \ncurrent-date-value="vm.options.currentDateValue" \nheaders="vm.options.width && vm.options.shortHeaders || vm.options.longHeaders" max-height="vm.options.maxHeight" \ntime-frames="vm.options.timeFrames" date-frames="vm.options.dateFrames" \ntime-frames-non-working-mode="vm.options.timeFramesNonWorkingMode" time-frames-magnet="vm.options.timeFramesMagnet" \napi="vm.options.api" column-magnet="vm.options.columnMagnet"><gantt-tree \nenabled="vm.options.sideMode === \'Tree\' || vm.options.sideMode === \'TreeTable\'" \nheader-content="vm.options.treeHeaderContent" keep-ancestor-on-filter-row="true"></gantt-tree><gantt-table \nenabled="vm.options.sideMode === \'Table\' || vm.options.sideMode === \'TreeTable\'" \ncolumns="vm.options.sideMode === \'TreeTable\' ? vm.options.treeTableColumns : vm.options.columns" \nheaders="vm.options.columnsHeaders" classes="vm.options.columnsClasses" formatters="vm.options.columnsFormatters" \ncontents="vm.options.columnsContents" header-contents="vm.options.columnsHeaderContents"></gantt-table><gantt-groups \nenabled="vm.options.groupDisplayMode === \'group\' || vm.options.groupDisplayMode === \'overview\' || vm.options.groupDisplayMode === \'promote\'" \ndisplay="vm.options.groupDisplayMode"></gantt-groups><gantt-bounds></gantt-bounds><gantt-progress></gantt-progress>\n<gantt-sortable></gantt-sortable><gantt-movable enabled="!vm.options.readOnly"></gantt-movable><gantt-draw-task \nenabled="vm.options.canDraw" move-threshold="2" task-factory="vm.options.drawTaskFactory"></gantt-draw-task>\n<gantt-overlap></gantt-overlap><gantt-resize-sensor></gantt-resize-sensor><gantt-dependencies></gantt-dependencies>\n</div></md-content></div></div></div>');
$templateCache.put('app/main/apps/evolution/evolution.html','<div id="site-questions" class="page-layout carded left-sidenav" layout="row"><div class="content-wrapper" \nlayout="row" flex><div class="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-alert" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="QUESTIONS.NOT_AVAILABLE_YET"></span></div></div></div></div>');
$templateCache.put('app/main/apps/imputation/imputation.html','<div id="site-questions" class="page-layout carded left-sidenav" layout="row"><div class="content-wrapper" \nlayout="row" flex><div class="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-alert" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="QUESTIONS.NOT_AVAILABLE_YET"></span></div></div></div></div>');
$templateCache.put('app/main/apps/inputs/inputs.html','<div id="site-client" class="page-layout carded left-sidenav" layout="row"><div class="center" layout="column" flex>\n<div class="content-card" layout="column" flex ng-include="vm.views[vm.currentView]" md-no-ink ng-if="companySel"><h1>\nFONT END</h1></div><div class="content-wrapper" layout="row" flex ng-if="!companySel"><div \nclass="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-briefcase" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="GLOBAL.SELECT_PROYECT_FIRST"></span></div></div></div></div></div>');
$templateCache.put('app/main/apps/help/help.html','<div id="site-help" class="page-layout carded left-sidenav" layout="row"><div class="center" layout="column" flex><div \nclass="content-card" layout="column" flex md-no-ink><iframe id="help-show" src="http://ayuda.help2comply.com/es/" \nframeborder="0" height="100%" width="100%"></iframe></div></div></div>');
$templateCache.put('app/main/apps/items/items.html','<div id="site-client" class="page-layout carded left-sidenav" layout="row"><div class="center" layout="column" flex>\n<div class="content-card" layout="column" flex ng-include="vm.views[vm.currentView]" md-no-ink ng-if="companySel"><h1>\nFONT END</h1></div><div class="content-wrapper" layout="row" flex ng-if="!companySel"><div \nclass="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-briefcase" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="GLOBAL.SELECT_PROYECT_FIRST"></span></div></div></div></div></div>');
$templateCache.put('app/main/apps/notes/notes.html','<div id="notes" class="" layout="column"><md-sidenav class="sidenav main-sidenav md-white-bg" ms-scroll \nmd-component-id="main-sidenav" ms-sidenav-helper ng-include="\'app/main/apps/notes/sidenavs/main/main-sidenav.html\'">\n</md-sidenav><md-toolbar class="md-accent"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><div layout="row"><md-button class="md-icon-button sidenav-toggle" \nng-click="vm.toggleSidenav(\'main-sidenav\')" aria-label="Toggle sidenav" translate \ntranslate-attr-aria-label="NOTES.TOGGLE_SIDENAV"><md-icon md-font-icon="icon-menu" class="icon"></md-icon></md-button>\n<div class="main-title" layout="row" layout-align="start center"><md-icon class="logo-icon mr-8" \nmd-font-icon="icon-lightbulb"></md-icon><span class="title" ng-if="vm.noteListType === \'notes\'" \ntranslate="NOTES.NOTES">Notes</span> <span class="title" ng-if="vm.noteListType === \'reminders\'" \ntranslate="NOTES.REMINDERS">Reminders</span> <span class="title" ng-if="vm.noteListType === \'archive\'" \ntranslate="NOTES.ARCHIVE">Archive</span> <span class="title" ng-if="vm.noteListType.name">{{vm.noteListType.name}}\n</span> <span ng-if="filteredNotes.length" class="pl-8 white-text secondary-text notes-count">\n({{filteredNotes.length}})</span></div></div><div flex></div><md-button class="md-icon-button sidenav-toggle" \nng-click="vm.openSearchToolbar()" aria-label="open search toolbar" translate \ntranslate-attr-aria-label="NOTES.OPEN_SEARCH_TOOLBAR"><md-icon md-font-icon="icon-magnify" class="icon"></md-icon>\n</md-button></div><div ng-show="vm.searchToolbar" \nclass="md-toolbar-tools search-toolbar animate-slide-down md-accent-bg" layout="row" layout-align="start center">\n<md-button class="md-icon-button" ng-click="vm.closeSearchToolbar()" translate translate-attr-aria-label="NOTES.CLOSE" \naria-label="close"><md-icon md-font-icon="icon-close" class="mr-8"></md-icon></md-button><input \nid="search-notes-input" placeholder="Search notes" type="text" ng-model="vm.search" translate \ntranslate-attr-placeholder="NOTES.SEARCH_NOTES" ng-model-options="{\'debounce\': 200}" flex></div></md-toolbar>\n<md-content ms-scroll flex><ms-new-note ng-hide="vm.noteListType === \'archive\'" class="md-whiteframe-2dp">\n</ms-new-note><ms-masonry class="notes" options=\'{"columnCount":5}\'><ms-masonry-item class="note" \nng-repeat="note in vm.notes | filter:vm.search | filter:vm.filters | filterByPropIds:\'labels\':vm.labelFilterIds |  orderBy: \'time\':true | filter:query as filteredNotes track by note.id " \nms-note-item="note" ng-click="vm.editNote($event, note.id)"></ms-masonry-item></ms-masonry><div \nclass="no-results text-center" ng-if="filteredNotes.length === 0 &&  vm.search === \'\'"><div class="message" \nng-if="vm.noteListType === \'notes\'"><md-icon class="message-icon s96" md-font-icon="icon-lightbulb"></md-icon><div \nclass="message-text" translate="NOTES.NO_NOTES_YET">No notes yet...</div></div><div class="message" \nng-if="vm.noteListType === \'reminders\'"><md-icon class="message-icon s96" md-font-icon="icon-bell"></md-icon><div \nclass="message-text" translate="NOTES.NO_NOTES_WITH_REMINDERS">No notes with reminders</div></div><div class="message" \nng-if="vm.noteListType === \'archive\'"><md-icon class="message-icon s96" md-font-icon="icon-archive"></md-icon><div \nclass="message-text" translate="NOTES.NO_ARCHIVED_NOTES">No archived Notes</div></div><div class="message" \nng-if="vm.noteListType.name"><md-icon class="message-icon s96" md-font-icon="icon-label"></md-icon><div \nclass="message-text" translate="NOTES.NO_NOTES_WITH_THIS_LABEL">No notes with this label</div></div></div><div \nclass="no-results text-center" ng-if="filteredNotes.length === 0 &&  vm.search !== \'\'"><div class="message"><md-icon \nclass="message-icon s96" md-font-icon="icon-lightbulb"></md-icon><div class="message-text" \ntranslate="NOTES.NO_RESULTS">No results...</div></div></div></md-content></div>');
$templateCache.put('app/main/apps/jobpositions/jobpositions.html','<div id="site-jobs" class="page-layout carded left-sidenav" layout="row"><div class="center" layout="column" flex><div \nclass="content-card" layout="column" flex ng-include="vm.views[vm.currentView]" md-no-ink></div></div><h2c-pagination \ncollection="vm.jobs" url="\'http://\'" service="jobPositionsService" style="display:none;"></h2c-pagination></div>');
$templateCache.put('app/main/apps/mail/mail.html','<div id="mail" class="page-layout carded left-sidenav" layout="row"><div class="top-bg md-accent-bg"></div><md-sidenav \nclass="sidenav" md-is-locked-open="$mdMedia(\'gt-md\')" md-component-id="main-sidenav" \nng-include="\'app/main/apps/mail/sidenavs/main/main-sidenav.html\'" ms-scroll ms-sidenav-helper></md-sidenav><div \nclass="center" layout="column" flex><div class="header" layout="row" layout-align="start center"><div \nclass="search-wrapper md-whiteframe-4dp" layout="row" layout-align="start center" flex><md-button \nclass="md-icon-button sidenav-toggle" ng-click="vm.toggleSidenav(\'main-sidenav\')" hide-gt-md \naria-label="Toggle Sidenav" translate translate-attr-aria-label="MAIL.TOGGLE_SIDENAV"><md-icon class="icon" \nmd-font-icon="icon-menu"></md-icon></md-button><div class="search" flex layout="row" layout-align="start center">\n<md-icon md-font-icon="icon-magnify" class="icon s24"></md-icon><input flex ng-model="vm.search" type="text" \nplaceholder="Search for an e-mail or contact" translate translate-attr-placeholder="MAIL.SEARCH_PLACEHOLDER"></div>\n</div></div><div class="content-card" ng-class="vm.currentView" layout="column" flex \nng-include="vm.views[vm.currentView]"></div></div></div>');
$templateCache.put('app/main/apps/proyects/proyects.html','<div id="site-client" class="page-layout carded left-sidenav" layout="row"><div class="center" layout="column" flex>\n<div class="content-card" layout="column" flex ng-include="vm.views[vm.currentView]" md-no-ink></div></div>\n<h2c-pagination collection="vm.companies" url="\'http://\'" service="proyectsService" style="display:none;">\n</h2c-pagination></div>');
$templateCache.put('app/main/apps/outcomes/outcomes.html','<div id="site-client" class="page-layout carded left-sidenav" layout="row"><div class="center" layout="column" flex>\n<div class="content-card" layout="column" flex ng-include="vm.views[vm.currentView]" md-no-ink ng-if="companySel"><h1>\nFONT END</h1></div><div class="content-wrapper" layout="row" flex ng-if="!companySel"><div \nclass="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-briefcase" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="GLOBAL.SELECT_PROYECT_FIRST"></span></div></div></div></div></div>');
$templateCache.put('app/main/apps/outputs/outputs.html','<div id="site-client" class="page-layout carded left-sidenav" layout="row"><div class="center" layout="column" flex>\n<div class="content-card" layout="column" flex ng-include="vm.views[vm.currentView]" md-no-ink ng-if="companySel"><h1>\nFONT END</h1></div><div class="content-wrapper" layout="row" flex ng-if="!companySel"><div \nclass="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-briefcase" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="GLOBAL.SELECT_PROYECT_FIRST"></span></div></div></div></div></div>');
$templateCache.put('app/main/apps/questions-master/questions-master.html','<div id="site-questions-master" class="page-layout carded left-sidenav" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex ng-include="vm.views[vm.currentView]" md-no-ink>\n</div></div><h2c-pagination collection="vm.questions" url="\'http://\'" service="questionsMasterService" \nstyle="display:none;"></h2c-pagination></div>');
$templateCache.put('app/main/apps/results/resultsSROI.html','<div id="site-dashboard-data" ng-if="companySel"><div id="widgets" class="widget-group" layout="row" \nlayout-align="start-start" flex="100"><ms-widget ng-click="vm.openDialog(vm.data.risks,\'RISKS\', $event)" \nflippable="false" layout="row" flex="100" flex-gt-sm="50" class="pb-0"><ms-widget-front class="white-bg"><div \nclass="ph-16 border-bottom" layout="row" layout-align="space-between center"><div class="h3 pv-10">\n{{ \'RESULT.INPUTS\' | translate}}</div></div><div layout="row" layout-align="center center" class="risk-details-gauge">\n<div class="pt-8 pb-15" layout="column" layout-align="center center"><div \nclass="font-size-36 line-height-72 {{vm.getClassbySize(vm.data.risks.length)}}">\n{{vm.inputsTotal | currency:symbolMoney:2}}</div><div class="h3 secondary-text font-weight-500">\n{{ \'RESULT.TOTALINPUTS\' | translate}}</div></div></div></ms-widget-front></ms-widget><ms-widget \nng-click="vm.openDialog(vm.data.tasks_next,\'PENDING_TASKS\', $event)" flippable="false" layout="row" flex="100" \nflex-gt-sm="50" class="pb-0"><ms-widget-front class="white-bg"><div class="ph-16 border-bottom" layout="row" \nlayout-align="space-between center"><div class="h3 pv-10">{{ \'RESULT.OUTCOMES\' | translate}}</div></div><div \nlayout="row" layout-align="center center" class="risk-details-gauge"><div class="pt-8 pb-15" layout="column" \nlayout-align="center center"><div class="font-size-36 line-height-72 {{vm.getClassbySize(vm.data.tasks_next.length)}}">\n{{vm.outcomesTotal | currency:symbolMoney:2 }}</div><div class="h3 secondary-text font-weight-500">\n{{ \'RESULT.TOTALOUTCOMES\' | translate}}</div></div></div></ms-widget-front></ms-widget><ms-widget \nng-click="vm.openDialog(vm.data.tasks_next,\'PENDING_TASKS\', $event)" flippable="false" layout="row" flex="100" \nflex-gt-sm="50" class="pb-0"><ms-widget-front class="white-bg"><div class="ph-16 border-bottom" layout="row" \nlayout-align="space-between center"><div class="h3 pv-10">{{ \'RESULT.SROI\' | translate}}</div></div><div layout="row" \nlayout-align="center center" class="risk-details-gauge"><div class="pt-8 pb-15" layout="column" \nlayout-align="center center"><div class="font-size-36 line-height-72 {{vm.getClassbySize(vm.data.tasks_next.length)}}">\n{{vm.sroiTotal | currency:symbolMoney:2 }}</div><div class="h3 secondary-text font-weight-500">\n{{ \'RESULT.TOTALSROI\' | translate}}</div></div></div></ms-widget-front></ms-widget></div><div><nvd3 options="options" \ndata="data"></nvd3></div><div class="bars-container"><h1>STAKEHOLDERS</h1><div \nng-repeat="stakeholder in vm.stakeholdersContainer"><h3>Stakeholder: <span><strong class="font-size-20">\n{{stakeholder.name}}</strong></span></h3><div class="content-container" ng-repeat="input in stakeholder.inputs"><span \nclass="names-container"><span>{{input.name}}</span> <span>{{input.value | currency:symbolMoney:2}}</span></span><div \nclass="bar-container"><div ng-if="input.value" class="bar input" \nstyle="width: {{(input.value/stakeholder.total)*100}}%"></div><div ng-if="!input.value" class="bar input" \nstyle="width: 5%"></div></div></div><div class="content-container" ng-repeat="outcome in stakeholder.outcomes"><span \nclass="names-container"><span>{{outcome.name}}</span> <span>{{outcome.value | currency:symbolMoney:2}}</span></span>\n<div class="bar-container"><div ng-if="outcome.value" class="bar outcome" \nstyle="width: {{(outcome.value/stakeholder.total)*100}}%"></div><div ng-if="!outcome.value" class="bar outcome" \nstyle="width: 5%"></div></div></div><span class="total">{{stakeholder.total | currency:symbolMoney:2}}</span></div>\n<div><h1>INPUTS</h1><div class="content-container" ng-repeat="input in vm.inputsContainer"><span \nclass="names-container"><span>{{input.name}}</span> <span>{{input.value | currency:symbolMoney:2}}</span></span><div \nclass="bar-container"><div ng-if="input.value" class="bar input" style="width: {{(input.value/vm.inputsTotal)*100}}%">\n</div><div ng-if="!input.value" class="bar input" style="width: 5%"></div></div></div><span \nng-if="vm.inputsContainer.length > 0" class="total">{{vm.inputsTotal | currency:symbolMoney:2 }}</span></div><div><h1>\nOUTCOMES</h1><div class="content-container" ng-repeat="outcome in vm.outcomesContainer"><span class="names-container">\n<span>{{outcome.name}}</span> <span>{{outcome.value | currency:symbolMoney:2}}</span></span><div class="bar-container">\n<div ng-if="outcome.value" class="bar outcome" style="width: {{(outcome.value/vm.outcomesTotal)*100}}%"></div><div \nng-if="!outcome.value" class="bar outcome" style="width: 5%"></div></div></div><span \nng-if="vm.outcomesContainer.length > 0" class="total">{{vm.outcomesTotal | currency:symbolMoney:2 }}</span></div></div>\n</div><div class="content-wrapper" layout="row" flex ng-if="!companySel"><div class="content thread-detail" \nlayout="row" layout-align="center center" flex><div class="no-client-selected no-thread-selected" layout="column" \nlayout-align="center center" flex><md-icon md-font-icon="icon-briefcase" class="s120 grey-400-fg"></md-icon><span \nclass="hint-text" translate="GLOBAL.SELECT_PROYECT_FIRST"></span></div></div></div>');
$templateCache.put('app/main/apps/questions/questionnaire.html','<div id="site-questions" class="page-layout carded left-sidenav" layout="row"><div class="center" layout="column" flex \nng-if="vm.isCompanySelected()"><div class="content-card" layout="column" flex ng-include="vm.views[vm.currentView]" \nmd-no-ink></div></div><div class="content-wrapper" layout="row" flex ng-if="!vm.isCompanySelected()"><div \nclass="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-briefcase" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="GLOBAL.SELECT_CLIENT_FIRST"></span></div></div></div></div>');
$templateCache.put('app/main/apps/questions/questions.html','<div id="site-questions" class="page-layout carded left-sidenav" layout="row"><div class="content-wrapper" \nlayout="row" flex><div class="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-alert" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="QUESTIONS.NOT_AVAILABLE_YET"></span></div></div></div></div>');
$templateCache.put('app/main/apps/register-book/register-book.html','<div id="site-register-book" class="page-layout carded left-sidenav register-book-page" layout="row" flex \nng-style="{\'--register-book-selection-accent\': vm.selectionAccentColor}"><div class="content-wrapper" layout="row" \nflex ng-if="!vm.isCompanySelected()"><div class="content thread-detail" layout="row" layout-align="center center" flex>\n<div class="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-timelapse" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="COMPLAINTS.SELECT_COMPANY_FIRST"></span></div></div></div><div ng-if="vm.isCompanySelected()" \nclass="register-book-shell" layout="column" flex><header class="register-book-hero" layout="row" \nlayout-align="space-between center" layout-wrap hide-sm hide-xs><div class="register-book-hero-left" layout="row" \nlayout-align="start center" flex><md-button class="md-raised md-accent green-500-bg register-book-hero-cta" \nng-click="vm.generateRegisterBook($event)"><md-icon md-font-icon="icon-file-pdf-box" \nclass="register-book-cta-icon icon-file-pdf-box"></md-icon><span class="register-book-hero-cta-text" \ntranslate="REGISTER_BOOK.GENERATE_BOOK"></span></md-button><md-input-container \nclass="register-book-status-filter register-book-status-filter--hero md-block"><label \ntranslate="REGISTER_BOOK.STATUS_FILTER_LABEL"></label><md-select ng-model="vm.statusFilter" \naria-label="{{ \'REGISTER_BOOK.STATUS_FILTER_LABEL\' | translate }}"><md-option ng-value="null"><span \ntranslate="REGISTER_BOOK.STATUS_FILTER_ALL"></span></md-option><md-option \nng-repeat="step in vm.processSteps track by step.id" ng-value="step.id"><span translate="{{ step.labelKey }}"></span>\n</md-option></md-select></md-input-container><md-button type="button" \nclass="md-icon-button register-book-hero-search-btn" ng-click="vm.toggleRegisterBookSearch()" \ntranslate-attr-aria-label="REGISTER_BOOK.SEARCH_ARIA" ng-attr-aria-expanded="{{ !!vm.registerBookSearchExpanded }}">\n<md-icon md-font-icon="icon-magnify"></md-icon></md-button><div class="register-book-search-field" \nng-class="{\'is-expanded\': vm.registerBookSearchExpanded}"><md-input-container \nclass="register-book-search-input md-block" flex><input id="register-book-search-input" type="text" \nng-model="vm.searchQuery" ng-blur="vm.onRegisterBookSearchBlur()" \nplaceholder="{{ \'REGISTER_BOOK.SEARCH_PLACEHOLDER\' | translate }}"></md-input-container></div></div><div \nclass="register-book-hero-right" layout="row" layout-align="end center"><div class="register-book-stat-chip" \nng-if="!vm.loading && vm.entries.length" translate="REGISTER_BOOK.ENTRIES_COUNT" \ntranslate-values="{ count: vm.entries.length }"></div></div></header><header \nclass="register-book-hero register-book-hero--mobile" layout="column" hide-gt-sm><div \nclass="register-book-hero-mobile-top" layout="row" layout-align="start center"><md-button \nclass="md-raised md-accent green-500-bg register-book-hero-cta register-book-hero-cta--mobile" \nng-click="vm.generateRegisterBook($event)"><md-icon md-font-icon="icon-file-pdf-box" \nclass="register-book-cta-icon icon-file-pdf-box"></md-icon><span class="register-book-hero-cta-text" \ntranslate="REGISTER_BOOK.GENERATE_BOOK"></span></md-button></div><div class="register-book-hero-mobile-toolbar" \nlayout="row" layout-align="space-between center"><div class="register-book-hero-mobile-controls" layout="row" \nlayout-align="start center" flex><md-input-container \nclass="register-book-status-filter register-book-status-filter--hero md-block"><label \ntranslate="REGISTER_BOOK.STATUS_FILTER_LABEL"></label><md-select ng-model="vm.statusFilter" \naria-label="{{ \'REGISTER_BOOK.STATUS_FILTER_LABEL\' | translate }}"><md-option ng-value="null"><span \ntranslate="REGISTER_BOOK.STATUS_FILTER_ALL"></span></md-option><md-option \nng-repeat="step in vm.processSteps track by step.id" ng-value="step.id"><span translate="{{ step.labelKey }}"></span>\n</md-option></md-select></md-input-container><md-button type="button" \nclass="md-icon-button register-book-hero-search-btn" ng-click="vm.toggleRegisterBookSearch()" \ntranslate-attr-aria-label="REGISTER_BOOK.SEARCH_ARIA" ng-attr-aria-expanded="{{ !!vm.registerBookSearchExpanded }}">\n<md-icon md-font-icon="icon-magnify"></md-icon></md-button></div><div class="register-book-hero-right" layout="row" \nlayout-align="end center"><div class="register-book-stat-chip" ng-if="!vm.loading && vm.entries.length" \ntranslate="REGISTER_BOOK.ENTRIES_COUNT" translate-values="{ count: vm.entries.length }"></div></div></div><div \nclass="register-book-search-field-mobile" ng-if="vm.registerBookSearchExpanded"><md-input-container \nclass="register-book-search-input md-block" flex><input id="register-book-search-input-mobile" type="text" \nng-model="vm.searchQuery" ng-blur="vm.onRegisterBookSearchBlur()" \nplaceholder="{{ \'REGISTER_BOOK.SEARCH_PLACEHOLDER\' | translate }}"></md-input-container></div></header><div \nlayout="row" flex class="register-book-body" ng-if="!vm.showMobileSelectionView()"><md-content \nclass="register-book-list" layout="column" flex="45" flex-md="40" flex-sm="100" flex-xs="100" ms-scroll><div \nclass="register-book-list-header" ng-if="vm.loading || vm.entries.length > 0" layout="row" \nlayout-align="space-between center" layout-wrap><span class="register-book-list-heading" \ntranslate="REGISTER_BOOK.LIST_HEADING"></span></div><div class="register-book-loading" layout="column" \nlayout-align="center center" ng-if="vm.loading" flex><md-progress-circular md-mode="indeterminate" md-diameter="44" \nclass="register-book-spinner"></md-progress-circular><span class="register-book-loading-label md-body-1" \ntranslate="REGISTER_BOOK.LOADING"></span></div><div class="content thread-detail register-book-list-empty-pane" \nlayout="row" layout-align="center center" flex ng-if="!vm.loading && (!vm.entries || vm.entries.length === 0)"><div \nclass="no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-clipboard-account" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="COMPLAINTS.NO_COMPLAINTS_FOUND"></span></div></div><div class="register-book-no-search-results" \nlayout="column" layout-align="center center" flex \nng-if="!vm.loading && vm.entries.length > 0 && vm.isRegisterBookSearchEmpty()"><span class="hint-text" \ntranslate="REGISTER_BOOK.NO_SEARCH_RESULTS"></span></div><md-list \nng-if="!vm.loading && vm.entries.length > 0 && !vm.isRegisterBookSearchEmpty()" class="register-book-md-list">\n<md-list-item class="register-book-list-item" \nng-repeat="entry in vm.entries | filter: vm.registerBookSearchPredicate track by entry.id" \nng-click="vm.selectEntry(entry)" ng-class="{\'is-selected\': vm.selected && vm.selected.id === entry.id}"><div \nclass="register-book-list-item-inner" layout="row" layout-align="start center" flex><div \nclass="register-book-list-item-glyph" layout="row" layout-align="center center" hide-xs><md-icon \nmd-font-icon="icon-file-document" class="register-book-file-icon"></md-icon></div><div \nclass="md-list-item-text register-book-list-item-text" layout="column" flex><div class="register-book-row-title" \nng-bind="vm.displayCaseRef(entry)"></div><div class="register-book-row-meta"><span class="register-book-meta-pill">\n<md-icon md-font-icon="icon-calendar-plus" class="register-book-meta-icon"></md-icon><span \ntranslate="COMPLAINTS.CREATED"></span>: {{ entry.created_at_format }} </span><span class="register-book-meta-pill">\n<md-icon md-font-icon="icon-calendar-clock" class="register-book-meta-icon"></md-icon><span \ntranslate="COMPLAINTS.UPDATED"></span>: {{ entry.updated_at_format }}</span></div></div><div \nclass="register-book-row-status" ng-if="vm.getStatusStep(entry.status)"><span \nclass="list-status-badge {{ vm.getStatusStep(entry.status).colorClass }}" layout="row" layout-align="center center">\n<md-icon md-font-icon="{{ vm.getStatusStep(entry.status).icon }}" class="list-status-badge-icon"></md-icon><span \nclass="list-status-badge-label" translate="{{ vm.getStatusStep(entry.status).labelKey }}"></span></span></div></div>\n</md-list-item></md-list></md-content><md-content class="register-book-detail" layout="column" flex hide show-gt-sm \nms-scroll><div class="content thread-detail register-book-detail-empty-pane" layout="row" layout-align="center center" \nflex ng-if="!vm.selected"><div class="no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-clipboard-account" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="COMPLAINTS.SELECT_COMPLAINT"></span></div></div><div ng-if="vm.selected" class="register-book-detail-card">\n<div class="register-book-detail-hero"><div class="register-book-detail-hero-inner" layout="row" \nlayout-align="space-between start"><div class="register-book-detail-hero-main" layout="row" \nlayout-align="start center" flex><button type="button" class="register-book-detail-certified-trigger" \nng-click="vm.confirmTechnicalCertificate($event)" \nng-attr-aria-label="{{ \'REGISTER_BOOK.TECHNICAL_CERTIFICATE_ACTION\' | translate }}"><img \nclass="register-book-detail-certified-logo" src="assets/angular-material-assets/img/icons/certified-h2c.png" alt="" \naria-hidden="true"></button><div layout="column" flex><div class="register-book-detail-kicker" \ntranslate="REGISTER_BOOK.CASE_SUMMARY"></div><div class="register-book-detail-ref"><span \nclass="register-book-detail-ref-text" ng-bind="vm.displayCaseRef(vm.selected)"></span></div></div></div><div \nng-if="vm.getStatusStep(vm.selected.status)" class="register-book-detail-status"><div \nclass="list-status-badge {{ vm.getStatusStep(vm.selected.status).colorClass }}" layout="row" \nlayout-align="center center"><md-icon md-font-icon="{{ vm.getStatusStep(vm.selected.status).icon }}" \nclass="list-status-badge-icon"></md-icon><span class="list-status-badge-label" \ntranslate="{{ vm.getStatusStep(vm.selected.status).labelKey }}"></span></div></div></div></div><div \nclass="register-book-detail-body"><div class="register-book-info-grid" layout="row" layout-wrap><div \nclass="register-book-info-tile" flex flex-xs="100"><div class="register-book-info-tile-icon" layout="row" \nlayout-align="center center"><md-icon md-font-icon="icon-calendar-plus"></md-icon></div><div \nclass="register-book-info-tile-text" layout="column"><span class="register-book-info-label" \ntranslate="COMPLAINTS.CREATED"></span> <span class="register-book-info-value">{{ vm.selected.created_at_format }}\n</span></div></div><div class="register-book-info-tile" flex flex-xs="100"><div class="register-book-info-tile-icon" \nlayout="row" layout-align="center center"><md-icon md-font-icon="icon-calendar-clock"></md-icon></div><div \nclass="register-book-info-tile-text" layout="column"><span class="register-book-info-label" \ntranslate="COMPLAINTS.UPDATED"></span> <span class="register-book-info-value">{{ vm.selected.updated_at_format }}\n</span></div></div></div><div class="register-book-detail-actions" layout="row" layout-align="start center" \nlayout-wrap><md-button class="md-raised md-accent green-500-bg register-book-action-primary" \nng-click="vm.openReportDialog($event)"><md-icon md-font-icon="icon-file-find"></md-icon><span \ntranslate="REGISTER_BOOK.REPORT_ACTION"></span></md-button><md-button class="md-raised register-book-action-output" \nng-if="vm.hasSelectedReportOutput(\'html\')" ng-click="vm.openSelectedReportOutput(\'html\')"><md-icon \nmd-font-icon="icon-eye"></md-icon><span translate="REGISTER_BOOK.VIEW_ACTION"></span></md-button><md-button \nclass="md-raised register-book-action-output" ng-if="vm.hasSelectedReportOutput(\'pdf\')" \nng-click="vm.openSelectedReportOutput(\'pdf\')"><md-icon md-font-icon="icon-download"></md-icon><span>PDF</span>\n</md-button><md-button class="md-raised md-warn register-book-action-secondary" ng-click="vm.clearSelection()"><span \ntranslate="REGISTER_BOOK.CLOSE_DETAIL"></span></md-button></div></div></div></md-content></div><div \nclass="register-book-mobile-detail" hide-gt-sm ng-if="vm.showMobileSelectionView()" layout="column" flex><div \nclass="register-book-mobile-card"><div class="register-book-mobile-topbar" layout="row" \nlayout-align="space-between center"><md-button class="md-raised register-book-mobile-back" \nng-click="vm.clearSelection()"><md-icon md-font-icon="icon-arrow-left"></md-icon><span translate="GLOBAL.BACK"></span>\n</md-button><div ng-if="vm.getStatusStep(vm.selected.status)" class="register-book-mobile-status"><div \nclass="list-status-badge {{ vm.getStatusStep(vm.selected.status).colorClass }}" layout="row" \nlayout-align="center center"><md-icon md-font-icon="{{ vm.getStatusStep(vm.selected.status).icon }}" \nclass="list-status-badge-icon"></md-icon><span class="list-status-badge-label" \ntranslate="{{ vm.getStatusStep(vm.selected.status).labelKey }}"></span></div></div></div><div \nclass="register-book-mobile-header" layout="row" layout-align="start center"><button type="button" \nclass="register-book-detail-certified-trigger register-book-detail-certified-trigger--mobile" \nng-click="vm.confirmTechnicalCertificate($event)" \nng-attr-aria-label="{{ \'REGISTER_BOOK.TECHNICAL_CERTIFICATE_ACTION\' | translate }}"><img \nclass="register-book-detail-certified-logo" src="assets/angular-material-assets/img/icons/certified-h2c.png" alt="" \naria-hidden="true"></button><div class="register-book-mobile-header-copy" layout="column" flex><div \nclass="register-book-detail-kicker" translate="REGISTER_BOOK.CASE_SUMMARY"></div><div \nclass="register-book-mobile-title" ng-bind="vm.displayCaseRef(vm.selected)"></div></div></div><div \nclass="register-book-mobile-tiles" layout="row" layout-wrap><div \nclass="register-book-info-tile register-book-info-tile--compact" flex="50" flex-xs="100"><div \nclass="register-book-info-tile-icon" layout="row" layout-align="center center"><md-icon \nmd-font-icon="icon-calendar-plus"></md-icon></div><div class="register-book-info-tile-text" layout="column"><span \nclass="register-book-info-label" translate="COMPLAINTS.CREATED"></span> <span class="register-book-info-value">\n{{ vm.selected.created_at_format }}</span></div></div><div \nclass="register-book-info-tile register-book-info-tile--compact" flex="50" flex-xs="100"><div \nclass="register-book-info-tile-icon" layout="row" layout-align="center center"><md-icon \nmd-font-icon="icon-calendar-clock"></md-icon></div><div class="register-book-info-tile-text" layout="column"><span \nclass="register-book-info-label" translate="COMPLAINTS.UPDATED"></span> <span class="register-book-info-value">\n{{ vm.selected.updated_at_format }}</span></div></div></div><div layout="row" layout-wrap \nclass="register-book-mobile-actions"><md-button class="md-raised md-accent green-500-bg register-book-action-primary" \nflex flex-xs="100" ng-click="vm.openReportDialog($event)"><md-icon md-font-icon="icon-file-find"></md-icon><span \ntranslate="REGISTER_BOOK.REPORT_ACTION"></span></md-button><md-button class="md-raised register-book-action-output" \nflex flex-xs="100" ng-if="vm.hasSelectedReportOutput(\'html\')" ng-click="vm.openSelectedReportOutput(\'html\')"><md-icon \nmd-font-icon="icon-eye"></md-icon><span translate="REGISTER_BOOK.VIEW_ACTION"></span></md-button><md-button \nclass="md-raised register-book-action-output" flex flex-xs="100" ng-if="vm.hasSelectedReportOutput(\'pdf\')" \nng-click="vm.openSelectedReportOutput(\'pdf\')"><md-icon md-font-icon="icon-download"></md-icon><span>PDF</span>\n</md-button></div></div></div></div></div>');
$templateCache.put('app/main/apps/reports/reports.html','<div id="site-reports" class="page-layout carded left-sidenav" layout="row"><div class="center" layout="column" flex \nng-if="vm.isCompanySelected() || vm.reportSelected"><div class="content-card" layout="column" flex \nng-include="vm.views[vm.currentView]" md-no-ink></div></div><h2c-pagination collection="vm.reports" url="\'http://\'" \nservice="reportsService" style="display:none;" ng-if="!vm.firstLoad" company-id="vm.companySelected.id">\n</h2c-pagination><div class="content-wrapper" layout="row" flex ng-if="!vm.isCompanySelected() && !vm.reportSelected">\n<div class="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-timelapse" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="REPORTS.SELECT_COMPANY_FIRST"></span></div></div></div></div>');
$templateCache.put('app/main/apps/riskmap/riskmap.html','<div id="site-riskmap" class="page-layout carded left-sidenav" layout="row"><div flex layout="column" \nlayout-align="center center" layout-padding layout-margin ng-if="vm.loadingData || loadingMapProcess" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="center" layout="column" flex ng-if="vm.risksMap && !vm.loadingData && !loadingMapProcess"><div \nclass="content-card" layout="column" flex ng-include="vm.views[vm.currentView]" md-no-ink></div></div><div \nclass="content-wrapper" layout="row" flex ng-if="!vm.isCompanySelected() && !vm.loadingData"><div \nclass="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-timelapse" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="GLOBAL.SELECT_CLIENT_FIRST"></span></div></div></div></div>');
$templateCache.put('app/main/apps/riskconfig/riskconfig.html','<div id="site-riskconfig" class="page-layout carded left-sidenav" layout="row"><div class="center" layout="column" \nflex><div class="content-card" layout="column" flex ng-include="vm.views[vm.currentView]" md-no-ink></div></div>\n<h2c-pagination collection="vm.risks" url="\'http://\'" fields-filters="vm.refFilterables" service="riskConfigService" \nstyle="display:none;"></h2c-pagination></div>');
$templateCache.put('app/main/apps/risk/evidences.html','<div id="site-risk" class="page-layout carded left-sidenav" layout="row"><div class="center" layout="column" flex \nng-if="vm.isCompanySelected() || vm.currentRisk"><div class="content-card" layout="column" flex \nng-include="vm.views[vm.currentView]" md-no-ink></div></div><h2c-pagination collection="vm.risks" url="\'http://\'" \nservice="evidencesControlsService" style="display:none;" ng-if="!vm.firstLoad"></h2c-pagination><div \nclass="content-wrapper" layout="row" flex ng-if="!vm.isCompanySelected() && !vm.currentRisk"><div \nclass="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-timelapse" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="RISK.SELECT_COMPANY_FIRST"></span></div></div></div></div>');
$templateCache.put('app/main/apps/risk/risk.html','<div id="site-risk" class="page-layout carded left-sidenav" layout="row"><div class="center" layout="column" flex \nng-if="vm.isCompanySelected() || vm.currentRisk"><div class="content-card" layout="column" flex \nng-include="vm.views[vm.currentView]" md-no-ink></div></div><h2c-pagination collection="vm.risks" url="\'http://\'" \nservice="riskService" style="display:none;" ng-if="!vm.firstLoad"></h2c-pagination><div class="content-wrapper" \nlayout="row" flex ng-if="!vm.isCompanySelected() && !vm.currentRisk"><div class="content thread-detail" layout="row" \nlayout-align="center center" flex><div class="no-client-selected no-thread-selected" layout="column" \nlayout-align="center center" flex><md-icon md-font-icon="icon-briefcase" class="s120 grey-400-fg"></md-icon><span \nclass="hint-text text-center" translate="RISK.SELECT_COMPANY_FIRST"></span></div></div></div></div>');
$templateCache.put('app/main/apps/stakeholders/stakeholders.html','<div id="site-client" class="page-layout carded left-sidenav" layout="row"><div class="center" layout="column" flex>\n<div class="content-card" layout="column" flex ng-include="vm.views[vm.currentView]" md-no-ink ng-if="companySel"><h1>\nFONT END</h1></div><div class="content-wrapper" layout="row" flex ng-if="!companySel"><div \nclass="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-briefcase" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="GLOBAL.SELECT_PROYECT_FIRST"></span></div></div></div></div></div>');
$templateCache.put('app/main/apps/scrumboard/scrumboard.html','<div id="scrumboard" class="page-layout simple fullwidth" layout="column"><div class="header md-accent-bg" \nng-class="\'md-\'+vm.board.settings.color+\'-bg\'" layout="column"><div class="header-content" layout="row" \nlayout-align="space-between" layout-wrap flex><div layout="row" layout-align="center center" flex-order="1" \nflex-order-xs="2"><md-button class="md-accent md-raised md-hue-2 header-boards-button" \nng-class="\'md-\'+vm.board.settings.color+\'-700-bg\'" ng-click="vm.boardSelectorVisible = !vm.boardSelectorVisible" \naria-label="boards button" translate translate-attr-aria-label="SB.BOARDS_BUTTON"><md-icon md-font-icon="icon-trello" \nclass="icon"></md-icon><span translate="SB.BOARDS">BOARDS</span></md-button></div><div class="header-board-name" \nlayout="row" layout-align="center center" flex-order="2" flex-order-xs="1" flex-xs="100"><i \nng-if="vm.board.settings.subscribed" class="board-subscribe s16 icon-eye"></i> <span editable-text="vm.board.name" \nonaftersave="vm.updateBoardUri()">{{vm.board.name}}</span></div><div class="toolbar" layout="row" \nlayout-align="space-between center" flex-order="3"><md-button ui-sref-active-eq="ng-hide" class="md-icon-button" \nui-sref="app.scrumboard.boards.board.calendar" aria-label="Calendar" translate translate-attr-aria-label="SB.CALENDAR">\n<md-icon md-font-icon="icon-calendar"></md-icon><md-tooltip><span translate="SB.CALENDAR">Calendar</span></md-tooltip>\n</md-button><md-button ui-sref-active-eq="ng-hide" class="md-icon-button" ui-sref="app.scrumboard.boards.board" \naria-label="Board" translate translate-attr-aria-label="SB.BOARD"><md-icon md-font-icon="icon-trello"></md-icon>\n<md-tooltip><span translate="SB.BOARD">Board</span></md-tooltip></md-button><md-button ng-if="vm.filteringIsOn()" \nclass="md-icon-button" ng-click="vm.clearFilters()" aria-label="Clear Filters" translate \ntranslate-attr-aria-label="SB.CLEAR_FILTERS"><md-icon md-font-icon="icon-filter-remove"></md-icon><md-tooltip \nsb.clear_filters>Clear Filters</md-tooltip></md-button><md-button class="md-icon-button" \nng-click="vm.toggleSidenav(\'filters-sidenav\')" aria-label="Filter Cards" translate \ntranslate-attr-aria-label="SB.FILTER_CARDS"><md-icon md-font-icon="icon-filter-variant"></md-icon><md-tooltip><span \ntranslate="SB.FILTER_CARDS">Filter Cards</span></md-tooltip></md-button><md-button class="md-icon-button" \nng-click="vm.toggleSidenav(\'settings-sidenav\')" aria-label="Settings" translate \ntranslate-attr-aria-label="SB.SETTINGS"><md-icon md-font-icon="icon-cog"></md-icon><md-tooltip><span \ntranslate="SB.SETTINGS">Settings</span></md-tooltip></md-button></div></div></div><div \nng-show="vm.boardSelectorVisible" id="board-selector" \nclass="md-accent-bg animate-slide-down board-list md-whiteframe-3dp" ng-class="\'md-\'+vm.board.settings.color+\'-bg\'" \nlayout="row" layout-align="start center"><div class="board-list-item" ng-repeat="board in vm.boardList" \nui-sref="app.scrumboard.boards.board({id:board.id, uri:board.uri})" layout="column" \nlayout-align="space-between center"><div class="board-icon"><i class="icon-trello s64"></i></div><div flex \nclass="board-name">{{board.name}}</div><div class="board-options"><i class="icon-dots-horizontal"></i></div><div \nng-if="board.id === vm.board.id" class="selected-icon green-bg"><i class="icon-check s24"></i></div></div><div \nclass="board-list-item add-new-board" ui-sref="app.scrumboard.boards.addBoard" ui-sref-active="hidden" layout="column" \nlayout-align="space-between center"><div class="board-icon"><i class="icon-trello s64"></i></div><div flex \nclass="board-name" translate="SB.ADD_NEW_BOARD">Add New Board</div></div></div><md-backdrop \nclass="board-selector-backdrop md-dialog-backdrop md-opaque" ng-show="vm.boardSelectorVisible" \nng-click="vm.boardSelectorVisible = false" aria-hidden="true"></md-backdrop><md-content class="content" flex \nlayout="column" ui-view="scrumboardContent"></md-content><md-sidenav class="settings-sidenav md-sidenav-right" \nmd-component-id="settings-sidenav" ng-include="\'app/main/apps/scrumboard/sidenavs/settings/settings-sidenav.html\'" \nng-controller="SettingsSidenavController as vm" ms-sidenav-helper></md-sidenav><md-sidenav \nclass="filters-sidenav md-sidenav-right" md-component-id="filters-sidenav" \nng-include="\'app/main/apps/scrumboard/sidenavs/filters/filters-sidenav.html\'" \nng-controller="FiltersSidenavController as vm" ms-sidenav-helper></md-sidenav></div>');
$templateCache.put('app/main/apps/staff/staff.html','<div id="site-staff" class="page-layout carded left-sidenav" layout="row"><div class="center" layout="column" flex \nng-if="vm.isCompanySelected()"><div class="content-card" layout="column" flex ng-include="vm.views[vm.currentView]" \nmd-no-ink></div></div><h2c-pagination ng-if="vm.companySelected" collection="vm.staff" url="\'http://\'" \nservice="staffService" style="display:none;"></h2c-pagination><div class="content-wrapper" layout="row" flex \nng-if="!vm.isCompanySelected()"><div class="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-timelapse" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="RISK.SELECT_COMPANY_FIRST"></span></div></div></div></div>');
$templateCache.put('app/main/apps/staffsroi/staffsroi.html','<div id="site-staff" class="page-layout carded left-sidenav" layout="row"><div class="center" layout="column" flex \nng-if="vm.isCompanySelected()"><div class="content-card" layout="column" flex ng-include="vm.views[vm.currentView]" \nmd-no-ink></div></div><h2c-pagination ng-if="vm.companySelected" collection="vm.staffsroi" url="\'http://\'" \nservice="staffsroiService" style="display:none;"></h2c-pagination><div class="content-wrapper" layout="row" flex \nng-if="!vm.isCompanySelected()"><div class="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-timelapse" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="RISK.SELECT_COMPANY_FIRST"></span></div></div></div></div>');
$templateCache.put('app/main/apps/tasks/tasks.html','<div id="site-tasks" class="page-layout carded left-sidenav" layout="row"><div class="center" layout="column" flex \nng-if="vm.isCompanySelected()"><div class="content-card" layout="column" flex ng-include="vm.views[vm.currentView]" \nmd-no-ink></div></div><h2c-pagination collection="vm.tasks" url="\'http://\'" service="tasksService" \nstyle="display:none;" ng-if="vm.isCompanySelected() && !vm.firstLoad"></h2c-pagination><div class="content-wrapper" \nlayout="row" flex ng-if="!vm.isCompanySelected()"><div class="content thread-detail" layout="row" \nlayout-align="center center" flex><div class="no-client-selected no-thread-selected" layout="column" \nlayout-align="center center" flex><md-icon md-font-icon="icon-timelapse" class="s120 grey-400-fg"></md-icon><span \nclass="hint-text" translate="TASKS.SELECT_COMPANY_FIRST"></span></div></div></div></div>');
$templateCache.put('app/main/apps/todo/todo.html','<div id="todo" class="page-layout carded left-sidenav" layout="row"><div class="top-bg md-accent-bg"></div><md-sidenav \nclass="sidenav" md-is-locked-open="$mdMedia(\'gt-md\')" md-component-id="main-sidenav" \nng-include="\'app/main/apps/todo/sidenavs/main/main-sidenav.html\'" ms-scroll ms-sidenav-helper></md-sidenav><div \nclass="center" layout="column" flex><div class="header" layout="row" layout-align="start center"><div \nclass="search-wrapper md-whiteframe-4dp" flex layout="row" layout-align="start center"><md-button \nclass="md-icon-button sidenav-toggle" ng-click="vm.toggleSidenav(\'main-sidenav\')" hide-gt-md \naria-label="Toggle sidenav" translate translate-attr-aria-label="TODO.TOGGLE_SIDENAV"><md-icon \nmd-font-icon="icon-menu" class="icon"></md-icon></md-button><div class="search" flex layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-magnify" class="icon s24"></md-icon><input flex \nng-model="vm.taskFilters.search" type="text" placeholder="Search for a task or tag" translate \ntranslate-attr-placeholder="TODO.SEARCH"></div></div></div><div class="content-card" layout="column" flex><div \nclass="toolbar" layout="row" layout-align="space-between center"><md-select class="simplified" \nng-model="vm.selectedFilter.dueDate" placeholder="Due Date"><md-option value="Next 3 days" \ntranslate="TODO.NEXT_3_DAYS">Next 3 days</md-option><md-option value="Next 7 days" translate="TODO.NEXT_7_DAYS">\nNext 7 days</md-option><md-option value="Next 2 weeks" translate="TODO.NEXT_2_WEEKS">Next 2 weeks</md-option><md-option\n value="Next month" translate="TODO.NEXT_MONTH">Next month</md-option></md-select><div layout="row" \nlayout-align="start center"><md-select class="simplified" ng-model="vm.taskOrder" placeholder="Order" \nng-change="vm.taskOrderDescending = vm.taskOrder === \'\' ? false : vm.taskOrderDescending"><md-option \nvalue="startDateTimestamp" translate="TODO.START_DATE">Start Date</md-option><md-option value="dueDateTimestamp" \ntranslate="TODO.DUE_DATE">Due Date</md-option><md-option value="" translate="TODO.MANUAL">Manual</md-option><md-option \nvalue="title" translate="TODO.TITLE">Title</md-option></md-select><md-button class="md-icon-button" \nng-disabled="vm.taskOrder === \'\'" ng-click="vm.taskOrderDescending = !vm.taskOrderDescending" \naria-label="Sort Direction" translate translate-attr-aria-label="TODO.SORT_DIRECTION"><md-icon \nmd-font-icon="icon-sort-ascending" ng-if="vm.taskOrderDescending === false"></md-icon><md-icon \nmd-font-icon="icon-sort-descending" ng-if="vm.taskOrderDescending === true"></md-icon></md-button></div></div><div \nclass="content" layout="row" flex><md-content class="todo-list-pane" flex \nng-include="\'app/main/apps/todo/views/list/list-view.html\'" ms-scroll="vm.msScrollOptions"></md-content></div></div>\n</div></div>');
$templateCache.put('app/main/apps/users/users.html','<div id="site-user" class="page-layout carded left-sidenav" layout="row"><div class="center" layout="column" flex><div \nclass="content-card" layout="column" flex ng-include="vm.views[vm.currentView]" md-no-ink></div></div><h2c-pagination \ncollection="vm.users" url="\'http://\'" service="usersService" style="display:none;"></h2c-pagination></div>');
$templateCache.put('app/main/components/cards/cards.html','<div id="cards" class="page-layout simple fullwidth doc-page"><div class="header md-accent-bg" layout="row" \nlayout-align="space-between"><div layout="column" layout-align="center start"><div class="breadcrumb" layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-home" class="s16"></md-icon><md-icon \nmd-font-icon="icon-chevron-right" class="s16 separator"></md-icon><span class="parent">COMPONENTS</span></div><div \nclass="title">Cards</div></div></div><div class="content" md-background-bg><p>\nCards are useful for showing excerpts, quick information or notifications. Using <code>ms-card</code>\n directive you can easily create different cards compatible with Google\'s Material Design specifications.</p><p><code>\nms-card</code>\n directive templates have pre-defined content areas. The reason for that is to force you to create cards that follows both Google\'s Material Design specifications and Fuse Theme\'s general design rules. But of course you can create your own designs and templates and use them with \n<code>ms-card</code> directive.</p><div><div class="md-title mt-32">Template 1</div><ms-card \ntemplate="\'app/core/directives/ms-card/templates/template-1/template-1.html\'" ng-model="vm.cards[0]"></ms-card><div \nclass="md-title mt-48">Template 2</div><ms-card \ntemplate="\'app/core/directives/ms-card/templates/template-2/template-2.html\'" ng-model="vm.cards[1]"></ms-card><div \nclass="md-title mt-48">Template 3</div><ms-card \ntemplate="\'app/core/directives/ms-card/templates/template-3/template-3.html\'" ng-model="vm.cards[2]"></ms-card><div \nclass="md-title mt-48">Template 4</div><ms-card \ntemplate="\'app/core/directives/ms-card/templates/template-4/template-4.html\'" ng-model="vm.cards[3]"></ms-card><div \nclass="md-title mt-48">Template 5</div><ms-card \ntemplate="\'app/core/directives/ms-card/templates/template-5/template-5.html\'" ng-model="vm.cards[4]"></ms-card><div \nclass="md-title mt-48">Template 6</div><ms-card \ntemplate="\'app/core/directives/ms-card/templates/template-6/template-6.html\'" ng-model="vm.cards[5]"></ms-card><div \nclass="md-title mt-48">Template 7</div><ms-card \ntemplate="\'app/core/directives/ms-card/templates/template-7/template-7.html\'" ng-model="vm.cards[6]"></ms-card><div \nclass="md-title mt-48">Template 8</div><ms-card \ntemplate="\'app/core/directives/ms-card/templates/template-8/template-8.html\'" ng-model="vm.cards[7]"></ms-card><div \nclass="md-title mt-48">Template 9</div><ms-card \ntemplate="\'app/core/directives/ms-card/templates/template-9/template-9.html\'" ng-model="vm.cards[8]"></ms-card><div \nclass="md-title mt-48">Template 10</div><ms-card \ntemplate="\'app/core/directives/ms-card/templates/template-10/template-10.html\'" ng-model="vm.cards[9]"></ms-card></div>\n</div></div>');
$templateCache.put('app/main/components/maps/maps.html','<div id="maps" class="page-layout simple tabbed doc-page" layout="column"><div class="header md-accent-bg" \nlayout="row" layout-align="space-between"><div layout="column" layout-align="center start"><div class="breadcrumb" \nlayout="row" layout-align="start center"><md-icon md-font-icon="icon-home" class="s16"></md-icon><md-icon \nmd-font-icon="icon-chevron-right" class="s16 separator"></md-icon><span class="parent">COMPONENTS</span></div><div \nclass="title">Maps</div></div><div layout="row" layout-align="start center"><md-button \nclass="md-raised reference-button" href="http://angular-ui.github.io/angular-google-maps/" target="_blank"><md-icon \nmd-font-icon="icon-link"></md-icon><span>Reference</span></md-button></div></div><div class="content"><md-tabs \nmd-stretch-tabs md-selected="vm.selectedIndex"><md-tab ui-sref="app.components_maps">Simple Map</md-tab><md-tab \nui-sref="app.components_maps.satellite">Satellite Map</md-tab><md-tab ui-sref="app.components_maps.terrain">Terrain Map\n</md-tab><md-tab ui-sref="app.components_maps.simple-marker">Simple Marker</md-tab><md-tab \nui-sref="app.components_maps.custom-marker">Custom Marker</md-tab><md-tab ui-sref="app.components_maps.info-window">\nInfo Window</md-tab></md-tabs><md-content ui-view="tabContent" flex class="card md-whiteframe-4dp"></md-content></div>\n</div>');
$templateCache.put('app/main/components/price-tables/price-tables.html','<div id="price-tables" class="page-layout simple fullwidth doc-page"><div class="header md-accent-bg" layout="row" \nlayout-align="space-between"><div layout="column" layout-align="center start"><div class="breadcrumb" layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-home" class="s16"></md-icon><md-icon \nmd-font-icon="icon-chevron-right" class="s16 separator"></md-icon><span class="parent">PAGES</span></div><div \nclass="title">Price Tables</div></div></div><div class="content"><div class="md-title">Style 1</div><div \nclass="price-tables" flex layout="row" layout-wrap><div class="price-table style-1 md-whiteframe-1dp" layout="column">\n<div class="package-type md-primary-bg"><span>BASIC</span></div><div class="price" layout="row" \nlayout-align="center start"><div class="currency">$</div><div layout="row" layout-align="center end"><div \nclass="value">4</div><div class="period">/ month</div></div></div><md-divider></md-divider><div class="terms" \nlayout="column"><div class="term"><span class="text-bold">10</span> Projects</div><div class="term"><span \nclass="text-bold">10</span> Pages</div><div class="term"><span class="text-bold">100</span> Mb Disk Space</div></div>\n<md-button class="cta-button md-raised md-accent">BUY NOW</md-button></div><div \nclass="price-table style-1 md-whiteframe-8dp" layout="column"><div class="package-type md-primary-bg" layout="row" \nlayout-align="space-between center"><span>STANDARD</span> <span class="sale md-accent-color md-hue-1">Save 15%</span>\n</div><div class="price" layout="row" layout-align="center start"><div class="currency">$</div><div layout="row" \nlayout-align="center end"><div class="value">8</div><div class="period">/ month</div></div></div><md-divider>\n</md-divider><div class="terms" layout="column"><div class="term"><span class="text-bold">20</span> Projects</div><div \nclass="term"><span class="text-bold">20</span> Pages</div><div class="term"><span class="text-bold">200</span>\n Mb Disk Space</div></div><md-button class="cta-button md-raised md-accent">BUY NOW</md-button></div><div \nclass="price-table style-1 md-whiteframe-1dp" layout="column"><div class="package-type md-primary-bg" layout="row">\n<span>ADVANCED</span></div><div class="price" layout="row" layout-align="center start"><div class="currency">$</div>\n<div layout="row" layout-align="center end"><div class="value">12</div><div class="period">/ month</div></div></div>\n<md-divider></md-divider><div class="terms" layout="column"><div class="term"><span class="text-bold">40</span>\n Projects</div><div class="term"><span class="text-bold">40</span> Pages</div><div class="term"><span \nclass="text-bold">500</span> Mb Disk Space</div></div><md-button class="cta-button md-raised md-accent">BUY NOW\n</md-button></div></div><div class="md-title">Style 2</div><div class="price-tables" flex layout="row" layout-wrap><div\n class="price-table style-2 md-whiteframe-1dp" layout="column"><div class="package-type md-accent-fg">SILVER PACKAGE\n</div><div class="price" layout="row" layout-align="center start"><div class="currency">$</div><div class="value">99\n</div></div><div class="period">PER MONTH</div><div class="terms" layout="column" layout-align="start center"><div \nclass="term"><span class="text-bold">10</span> Projects</div><div class="term"><span class="text-bold">10</span> Pages\n</div><div class="term"><span class="text-bold">100</span> Mb Disk Space</div></div><md-button \nclass="cta-button md-raised md-accent">GET STARTED</md-button></div><div class="price-table style-2 md-whiteframe-8dp" \nlayout="column"><div class="badge md-warn-bg">BEST VALUE</div><div class="package-type md-accent-fg">GOLD PACKAGE</div>\n<div class="price" layout="row" layout-align="center start"><div class="currency">$</div><div class="value">299</div>\n</div><div class="period">PER MONTH</div><div class="terms" layout="column" layout-align="start center"><div \nclass="term"><span class="text-bold">20</span> Projects</div><div class="term"><span class="text-bold">20</span> Pages\n</div><div class="term"><span class="text-bold">200</span> Mb Disk Space</div></div><md-button \nclass="cta-button md-raised md-accent">GET STARTED</md-button></div><div class="price-table style-2 md-whiteframe-1dp" \nlayout="column"><div class="package-type md-accent-fg">PLATINUM PACKAGE</div><div class="price" layout="row" \nlayout-align="center start"><div class="currency">$</div><div class="value">499</div></div><div class="period">\nPER MONTH</div><div class="terms" layout="column" layout-align="start center"><div class="term"><span \nclass="text-bold">40</span> Projects</div><div class="term"><span class="text-bold">40</span> Pages</div><div \nclass="term"><span class="text-bold">500</span> Mb Disk Space</div></div><md-button \nclass="cta-button md-raised md-accent">GET STARTED</md-button></div></div><div class="md-title">Style 3</div><div \nclass="price-tables" flex layout="row" layout-align="start start" layout-wrap><div \nclass="price-table style-3 md-whiteframe-1dp" layout="column"><div class="package-type"><div class="title">Starter\n</div><div class="subtitle">For small teams</div></div><div class="price md-primary-bg md-hue-3" layout="row" \nlayout-align="center start"><div class="currency">$</div><div layout="row" layout-align="center end"><div \nclass="value">29</div><div class="period">monthly per user</div></div></div><div class="terms" layout="column" \nlayout-align="start center"><div class="term">Unlimited projects</div><div class="term">Unlimited pages</div><div \nclass="term">Unlimited disk space</div><div class="term">24 / 7 Free support</div></div><md-button \nclass="cta-button md-raised md-accent">GET STARTED FREE</md-button><div class="note">7 day free trial to start</div>\n</div><div class="price-table style-3 md-whiteframe-8dp" layout="column"><div class="package-type"><div class="title">\nPro</div><div class="subtitle">For larger teams</div></div><div class="price md-primary-bg" layout="row" \nlayout-align="center start"><div class="currency">$</div><div layout="row" layout-align="center end"><div \nclass="value">59</div><div class="period">monthly per user</div></div></div><div class="terms" layout="column" \nlayout-align="start center"><div class="term">Unlimited projects</div><div class="term">Unlimited pages</div><div \nclass="term">Unlimited disk space</div><div class="term">24 / 7 Free support</div><div class="term md-warn-fg">\nAdvanced reporting</div><div class="term md-warn-fg">Customizable interface</div><div class="term md-warn-fg">\nCRM Integration</div></div><md-button class="cta-button md-raised md-accent">GET STARTED FREE</md-button><div \nclass="note">30 day free trial to start</div></div><div class="price-table style-3 md-whiteframe-1dp" layout="column">\n<div class="package-type"><div class="title">Enterprise</div><div class="subtitle">For big teams</div></div><div \nclass="price md-primary-bg md-hue-3" layout="row" layout-align="center start"><div class="currency">$</div><div \nlayout="row" layout-align="center end"><div class="value">99</div><div class="period">monthly per user</div></div>\n</div><div class="terms" layout="column" layout-align="start center"><div class="term">Unlimited projects</div><div \nclass="term">Unlimited pages</div><div class="term">Unlimited disk space</div><div class="term">\nFor full feature list, call us</div></div><md-button class="cta-button md-raised md-accent">CALL US</md-button><div \nclass="note">90 day free trial to start</div></div></div></div></div>');
$templateCache.put('app/main/components/widgets/widgets.html','<div id="widgets" class="page-layout simple fullwidth doc-page"><div class="header md-accent-bg" layout="row" \nlayout-align="space-between"><div layout="column" layout-align="center start"><div class="breadcrumb" layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-home" class="s16"></md-icon><md-icon \nmd-font-icon="icon-chevron-right" class="s16 separator"></md-icon><span class="parent">COMPONENTS</span></div><div \nclass="title">Widgets</div></div></div><div class="content"><p class="h3 m-16">\nHere you can see some of the other widget styles. These are just tiny example of what you can do with using <code \nclass="no-highlight">ms-widget</code>\n directive and helper classes. You are not limited to these styles or widgets, you can easily create wide variety of widgets.\n</p><div class="widget-group" layout="row" flex="100" layout-wrap><ms-widget flippable="true" layout="column" \nflex="100" flex-gt-xs="50" flex-gt-md="25"><ms-widget-front class="h-170 p-16 light-blue-bg"><div class="pb-8" \nlayout="row" layout-align="space-between center"><div class="h4 font-weight-500 secondary-text">{{vm.widget1.title}}\n</div><md-menu><md-button aria-label="more" class="md-icon-button" ng-click="$mdMenu.open($event)"><md-icon \nmd-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content width="2"><md-menu-item><md-button \nng-click="flipWidget()" aria-label="Flip widget">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click="refreshWidget()" aria-label="Refresh widget">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class="white-fg" layout="column" layout-align="space-between" flex><div class="md-display-1" layout="row" \nlayout-align="start center"><span>{{vm.widget1.value | number}}</span><md-icon md-font-icon="icon-trending-up" \nclass="s36 ml-16"></md-icon></div><div layout="row" layout-align="start center"><span>\nLast week: {{vm.widget1.lastWeekValue | number}}</span> <span class="text-boxed-light">{{vm.widget1.lastWeekDiff}}\n</span></div></div></ms-widget-front><ms-widget-back class="p-16 light-blue-bg white-fg"><div class="flip-to-front">\n<md-button class="md-icon-button" ng-click="flipWidget()" aria-label="Flip widget"><md-icon md-font-icon="icon-close" \nclass="s16"></md-icon></md-button></div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget \nflippable="true" layout="column" flex="100" flex-gt-xs="50" flex-gt-md="25"><ms-widget-front \nclass="h-170 p-16 green-bg"><div class="pb-8" layout="row" layout-align="space-between center"><div \nclass="h4 font-weight-500 secondary-text">{{vm.widget2.title}}</div><md-menu><md-button aria-label="more" \nclass="md-icon-button" ng-click="$mdMenu.open($event)"><md-icon md-font-icon="icon-dots-vertical"></md-icon>\n</md-button><md-menu-content width="2"><md-menu-item><md-button ng-click="flipWidget()" aria-label="Flip widget">\nDetails</md-button></md-menu-item><md-menu-item><md-button ng-click="refreshWidget()" aria-label="Refresh widget">\nRefresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class="white-fg" layout="column" \nlayout-align="space-between" flex><div><div class="md-display-1 pb-16">{{vm.widget2.value}}%</div><div class="pb-16">\n<md-progress-linear md-mode="determinate" value="{{vm.widget2.value}}"></md-progress-linear></div></div><div \nlayout="row" layout-align="start center"><span>Last week: {{vm.widget2.lastWeekValue}}%</span> <span \nclass="text-boxed-light">{{vm.widget2.lastWeekDiff}}</span></div></div></ms-widget-front><ms-widget-back \nclass="p-16 green-bg white-fg"><div class="flip-to-front"><md-button class="md-icon-button" ng-click="flipWidget()" \naria-label="Flip widget"><md-icon md-font-icon="icon-close" class="s16"></md-icon></md-button></div><div>\n{{vm.widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable="true" layout="column" flex="100" \nflex-gt-xs="50" flex-gt-md="25"><ms-widget-front class="h-170 p-16 blue-grey-bg white-fg"><div class="pb-8" \nlayout="row" layout-align="space-between center"><div class="h4 font-weight-500 secondary-text">{{vm.widget3.title}}\n</div><md-menu><md-button aria-label="more" class="md-icon-button" ng-click="$mdMenu.open($event)"><md-icon \nmd-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content width="2"><md-menu-item><md-button \nng-click="flipWidget()" aria-label="Flip widget">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click="refreshWidget()" aria-label="Refresh widget">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div layout="column" layout-align="space-between" flex><div><div class="md-display-1 pb-16">{{vm.widget3.value}}%\n</div><div class="pb-8"><md-progress-linear md-mode="determinate" value="{{vm.widget3.value}}"></md-progress-linear>\n</div></div><div>See more details...</div></div></ms-widget-front><ms-widget-back class="p-16 blue-grey-bg white-fg">\n<div class="flip-to-front"><md-button class="md-icon-button" ng-click="flipWidget()" aria-label="Flip widget"><md-icon \nmd-font-icon="icon-close" class="s16"></md-icon></md-button></div><div>{{vm.widget3.detail}}</div></ms-widget-back>\n</ms-widget><ms-widget flippable="true" layout="column" flex="100" flex-gt-xs="50" flex-gt-md="25"><ms-widget-front \nclass="h-170 p-16 deep-purple-bg white-fg"><div class="pb-8" layout="row" layout-align="space-between center"><div \nclass="h4 font-weight-500 secondary-text">{{vm.widget4.title}}</div><md-menu><md-button aria-label="more" \nclass="md-icon-button" ng-click="$mdMenu.open($event)"><md-icon md-font-icon="icon-dots-vertical"></md-icon>\n</md-button><md-menu-content width="2"><md-menu-item><md-button ng-click="flipWidget()" aria-label="Flip widget">\nDetails</md-button></md-menu-item><md-menu-item><md-button ng-click="refreshWidget()" aria-label="Refresh widget">\nRefresh</md-button></md-menu-item></md-menu-content></md-menu></div><div layout="column" layout-align="space-between" \nflex><div class="md-display-1 pb-8" layout="row" layout-align="start center"><span>{{vm.widget4.value | number}}</span>\n<md-icon md-font-icon="icon-trending-down" class="s36 ml-16"></md-icon></div><div>See more details...</div></div>\n</ms-widget-front><ms-widget-back class="p-16 deep-purple-bg white-fg"><div class="flip-to-front"><md-button \nclass="md-icon-button" ng-click="flipWidget()" aria-label="Flip widget"><md-icon md-font-icon="icon-close" class="s16">\n</md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back></ms-widget></div><div \nclass="widget-group" layout="row" flex="100" layout-wrap><ms-widget class="h-140" layout="column" flex="100" \nflex-gt-xs="50" flex-gt-md="25"><ms-widget-front class="p-16 white-bg" layout="row" flex><div class="pt-8 pb-8" \nlayout="column" layout-align="center center" flex><div class="md-display-1 pb-8">{{vm.widget5.value}}</div><div \nclass="font-weight-500 secondary-text">{{vm.widget5.title}}</div></div></ms-widget-front></ms-widget><ms-widget \nclass="h-140" layout="column" flex="100" flex-gt-xs="50" flex-gt-md="25"><ms-widget-front class="p-16 white-bg" \nlayout="row" flex><div class="pt-8 pb-8" layout="column" layout-align="center center" flex><div \nclass="font-weight-500 secondary-text pb-8">{{vm.widget6.title}}</div><div class="md-display-1">{{vm.widget6.value}}\n</div></div></ms-widget-front></ms-widget><ms-widget class="h-140" layout="column" flex="100" flex-gt-xs="50" \nflex-gt-md="25"><ms-widget-front class="p-16 white-bg" layout="row" flex><div class="pt-8 pb-8" layout="row" \nlayout-align="space-between center" flex><div class="pl-8" layout="column" layout-align="center start"><span \nclass="md-display-1 pb-8">{{vm.widget7.value}}</span> <span class="font-weight-500 secondary-text">{{vm.widget7.title}}\n</span></div><div><md-icon md-font-icon="icon-thumb-up" class="s48 hint-text"></md-icon></div></div></ms-widget-front>\n</ms-widget><ms-widget class="h-140" layout="column" flex="100" flex-gt-xs="50" flex-gt-md="25"><ms-widget-front \nclass="p-16 white-bg" layout="row" flex><div class="pt-8 pb-8" layout="row" layout-align="space-between center" flex>\n<div><md-icon md-font-icon="icon-lock-unlocked" class="s48 hint-text"></md-icon></div><div class="pr-8" \nlayout="column" layout-align="center end"><div class="md-display-1 pb-8">{{vm.widget8.value}}</div><div \nclass="font-weight-500 secondary-text">{{vm.widget8.title}}</div></div></div></ms-widget-front></ms-widget></div><div \nclass="widget-group" layout="row" flex="100" layout-wrap><ms-widget class="h-300" layout="column" flex="100" \nflex-gt-xs="50" flex-gt-md="25"><ms-widget-front class="p-16 deep-orange-bg white-fg" layout="row" flex><div \nlayout="column" layout-align="center center" flex><div class="md-display-3 pb-8">{{vm.widget9.value}}</div><div \nclass="h3 font-weight-500">{{vm.widget9.title}}</div></div><div class="background-image-center"><md-icon \nmd-font-icon="icon-music-note" class="s256 faint-text"></md-icon></div></ms-widget-front></ms-widget><ms-widget \nclass="h-300" layout="column" flex="100" flex-gt-xs="50" flex-gt-md="25"><ms-widget-front \nclass="p-16 cyan-bg white-fg" layout="row" flex><div layout="column" layout-align="center center" flex><div \nclass="md-display-3 pb-8">{{vm.widget10.value}}</div><div class="h3 font-weight-500">{{vm.widget10.title}}</div></div>\n<div class="background-image-center"><md-icon md-font-icon="icon-filmstrip" class="s256 faint-text"></md-icon></div>\n</ms-widget-front></ms-widget><ms-widget class="h-300" layout="column" flex="100" flex-gt-md="50"><ms-widget-front \nclass="p-16 teal-bg white-fg" layout="row" flex><div layout="column" layout-align="center center" flex><div \nclass="md-display-3 pb-8">{{vm.widget11.value}}</div><div class="h3 font-weight-500">{{vm.widget11.title}}</div></div>\n<div class="background-image-center"><md-icon md-font-icon="icon-file-document" class="s256 faint-text"></md-icon>\n</div></ms-widget-front></ms-widget></div><div class="widget-group" layout="row" flex="100" layout-wrap><ms-widget \nflippable="true" layout="column" flex="100" flex-gt-xs="50" flex-gt-md="25"><ms-widget-front \nclass="p-16 light-blue-bg" layout="column" flex><div class="pb-8" layout="row" layout-align="space-between center"><div\n class="h4 secondary-text"><md-icon md-font-icon="icon-arrow-left" class="s16 mr-8"></md-icon><span \nclass="font-weight-500">{{vm.widget12.date}}</span><md-icon md-font-icon="icon-arrow-right" class="s16 ml-8"></md-icon>\n</div><md-menu><md-button aria-label="more" class="md-icon-button" ng-click="$mdMenu.open($event)"><md-icon \nmd-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content width="2"><md-menu-item><md-button \nng-click="flipWidget()" aria-label="Flip widget">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click="refreshWidget()" aria-label="Refresh widget">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class="white-fg" layout="column" layout-align="center center" flex><div><md-icon \nmd-font-icon="{{vm.widget12.icon}}" class="s96"></md-icon></div><div class="pt-16" layout="row" \nlayout-align="center center"><div class="md-display-2">{{vm.widget12.temperature}}&deg;</div><div class="pl-16" \nlayout="column"><div class="h1 text-semibold">{{vm.widget12.event}}</div><div class="h4 secondary-text">\n{{vm.widget12.location}}</div></div></div><div class="pt-32" layout="row" layout-align="center center"><div \nlayout="row" layout-align="start center"><md-icon md-font-icon="icon-weather-windy" class="s16"></md-icon><span \nclass="pl-8">22 km/h</span></div><div class="pl-16" layout="row" layout-align="start center"><md-icon \nmd-font-icon="icon-compass" class="s16"></md-icon><span class="pl-8">NW</span></div></div></div></ms-widget-front>\n<ms-widget-back class="p-16 light-blue-bg" layout="column" flex><div class="flip-to-front"><md-button \nclass="md-icon-button" ng-click="flipWidget()" aria-label="Flip widget"><md-icon md-font-icon="icon-close" class="s16">\n</md-icon></md-button></div><div class="pt-16 pb-16 white-fg"><span class="h1">Next 5 days</span></div><div \nclass="pl-8 pr-8" layout="row" layout-align="space-between"><div layout="column" layout-align="start center" \nng-repeat="detail in vm.widget12.detail"><div class="h4 pb-8 black-fg secondary-text">{{detail.day}}</div><md-icon \nmd-font-icon="{{detail.icon}}" class="s36 white-fg"></md-icon><div class="h3 pt-8 white-fg">{{detail.temperature}}&deg;\n</div></div></div></ms-widget-back></ms-widget><ms-widget flippable="true" layout="column" flex="100" flex-gt-xs="50" \nflex-gt-md="25"><ms-widget-front class="p-16 white-bg" layout="column" flex><div class="pb-8" layout="row" \nlayout-align="space-between center"><div class="h4 secondary-text"><md-icon md-font-icon="icon-arrow-left" \nclass="s16 mr-8"></md-icon><span class="font-weight-500">{{vm.widget13.date}}</span><md-icon \nmd-font-icon="icon-arrow-right" class="s16 ml-8"></md-icon></div><md-menu><md-button aria-label="more" \nclass="md-icon-button" ng-click="$mdMenu.open($event)"><md-icon md-font-icon="icon-dots-vertical"></md-icon>\n</md-button><md-menu-content width="2"><md-menu-item><md-button ng-click="flipWidget()" aria-label="Flip widget">\nDetails</md-button></md-menu-item><md-menu-item><md-button ng-click="refreshWidget()" aria-label="Refresh widget">\nRefresh</md-button></md-menu-item></md-menu-content></md-menu></div><div layout="column" layout-align="center center" \nflex><div><md-icon md-font-icon="{{vm.widget13.icon}}" class="s96"></md-icon></div><div class="pt-16" layout="row" \nlayout-align="center center"><div class="md-display-2">{{vm.widget13.temperature}}&deg;</div><div class="pl-16" \nlayout="column"><div class="h1 text-semibold">{{vm.widget13.event}}</div><div class="h4 secondary-text">\n{{vm.widget13.location}}</div></div></div><div class="pt-32" layout="row" layout-align="center center"><div \nlayout="row" layout-align="start center"><md-icon md-font-icon="icon-weather-windy" class="s16"></md-icon><span \nclass="pl-8">22 km/h</span></div><div class="pl-16" layout="row" layout-align="start center"><md-icon \nmd-font-icon="icon-compass" class="s16"></md-icon><span class="pl-8">NW</span></div></div></div></ms-widget-front>\n<ms-widget-back class="p-16 light-blue-bg" layout="column" flex><div class="flip-to-front"><md-button \nclass="md-icon-button" ng-click="flipWidget()" aria-label="Flip widget"><md-icon md-font-icon="icon-close" class="s16">\n</md-icon></md-button></div><div class="pt-16 pb-16 white-fg"><span class="h1">Next 5 days</span></div><div \nclass="pl-8 pr-8" layout="row" layout-align="space-between"><div layout="column" layout-align="start center" \nng-repeat="detail in vm.widget13.detail"><div class="h4 pb-8 black-fg secondary-text">{{detail.day}}</div><md-icon \nmd-font-icon="{{detail.icon}}" class="s36 white-fg"></md-icon><div class="h3 pt-8 white-fg">{{detail.temperature}}&deg;\n</div></div></div></ms-widget-back></ms-widget><ms-widget layout="column" flex="100" flex-gt-md="50"><ms-widget-front \nclass="white-bg"><div class="ph-16 pt-16 pb-8 md-accent-bg"><div class="h3">{{vm.widget14.title}}</div></div><md-tabs \nclass="md-accent no-radius" md-dynamic-height><md-tab label="{{tab.label}}" ng-repeat="tab in vm.widget14.tabs"><div \nlayout="row" layout-align="start center" layout-wrap><div flex="100" flex-gt-md="50" ng-repeat="group in tab.groups">\n<div class="h2 m-16 pb-16 border-bottom">{{group.title}}</div><div class="p-16 pb-32" ng-repeat="data in group.data">\n<div class="pb-8" layout="row" layout-align="space-between start"><span class="h3">{{data.title}}</span> <span \nclass="h3 secondary-text font-weight-500">{{data.value}}%</span></div><md-progress-linear \nclass="{{data.progressColor}}" md-mode="determinate" value="{{data.value}}"></md-progress-linear></div></div></div>\n</md-tab></md-tabs></ms-widget-front></ms-widget></div><div class="widget-group" layout="row" flex="100" layout-wrap>\n<ms-widget class="h-250" layout="column" flex="100" flex-gt-xs="50" flex-gt-md="25"><ms-widget-front \nclass="p-16 red-bg white-fg" layout="column" layout-align="space-between" flex><div class="pb-16"><div \nclass="h4 weight-500 pb-8">{{vm.widget15.title}}</div><div layout="row" layout-align="start center"><div class="pr-8">\n<md-icon md-font-icon="icon-alert" class="s24 hint-text"></md-icon></div><div class="h1 secondary-text">\n{{vm.widget15.value}}%</div></div></div><div><c3chart class="c3 stroke-2" bindto-id="cpu-usage"><chart-column \nng-repeat="column in vm.widget15.chart.columns" column-id="{{column.id}}" column-name="{{column.name}}" \ncolumn-color="{{column.color}}" column-values="{{column.values}}" column-type="{{column.type}}"><chart-axis>\n<chart-axis-y show="false"></chart-axis-y></chart-axis><chart-legend show-legend="false"><chart-size \nchart-height="120"></c3chart></div></ms-widget-front></ms-widget><ms-widget class="h-250" layout="column" flex="100" \nflex-gt-xs="50" flex-gt-md="25"><ms-widget-front class="p-16 white-bg" layout="column" layout-align="space-between" \nflex><div class="pb-16"><div class="h4 weight-500 pb-8">{{vm.widget16.title}}</div><div layout="row" \nlayout-align="start center"><div class="h1 secondary-text">{{vm.widget16.value}}</div><md-icon \nmd-font-icon="icon-trending-up" class="mh-8"></md-icon></div></div><div><c3chart class="c3 stroke-2" bindto-id="stock">\n<chart-column ng-repeat="column in vm.widget16.chart.columns" column-id="{{column.id}}" column-name="{{column.name}}" \ncolumn-color="{{column.color}}" column-values="{{column.values}}" column-type="{{column.type}}"><chart-axis>\n<chart-axis-x show="false"></chart-axis-x><chart-axis-y show="false"></chart-axis-y></chart-axis><chart-legend \nshow-legend="false"><chart-size chart-height="120"></c3chart></div></ms-widget-front></ms-widget><ms-widget \nclass="h-250" layout="column" flex="100" flex-gt-md="50"><ms-widget-front class="p-16 white-bg" layout="column" \nlayout-align="space-between" flex><div class="pb-16"><div class="h4 weight-500 pb-8">{{vm.widget17.title}}</div><div \nclass="secondary-text">{{vm.widget17.subtitle}}</div></div><div><c3chart class="c3 stroke-2" bindto-id="io-rate">\n<chart-column ng-repeat="column in vm.widget17.chart.columns" column-id="{{column.id}}" column-name="{{column.name}}" \ncolumn-color="{{column.color}}" column-values="{{column.values}}" column-type="{{column.type}}"><chart-axis>\n<chart-axis-y show="false"></chart-axis-y></chart-axis><chart-size chart-height="120"></c3chart></div>\n</ms-widget-front></ms-widget></div><div class="widget-group" layout="row" flex="100" layout-wrap><ms-widget \nclass="h-300" layout="column" flex="100" flex-gt-md="50"><ms-widget-front class="p-16 white-bg"><div layout="row" \nlayout-align="space-between"><div class="mr-16"><div class="h4 weight-500 pb-8">{{vm.widget18.title}}</div><div \nclass="h1 secondary-text">{{vm.widget18.value | number}}</div><div class="pt-8" layout="row" \nlayout-align="start center"><div>LW: {{vm.widget18.lastWeekValue | number}}</div><div class="text-boxed">\n{{vm.widget18.lastWeekDiff}}</div></div></div><c3chart flex bindto-id="weekly-visitors"><chart-column \nng-repeat="column in vm.widget18.chart.columns" column-id="{{column.id}}" column-name="{{column.name}}" \ncolumn-color="{{column.color}}" column-values="{{column.values}}" column-type="{{column.type}}"><chart-legend \nshow-legend="false"><chart-bar width="10"><chart-size chart-height="240"></c3chart></div></ms-widget-front></ms-widget>\n<ms-widget class="h-300" layout="column" flex="100" flex-gt-md="50"><ms-widget-front \nclass="p-16 light-blue-bg white-fg"><div layout="row" layout-align="space-between"><div class="mr-16"><div \nclass="h1 weight-500 pb-8">{{vm.widget19.title}}</div><div class="h4 secondary-text weight-500 pb-8">\n{{vm.widget19.subtitle}}</div><div layout="row" layout-align="start center"><div class="md-display-1 pr-8">\n{{vm.widget19.value}}</div><md-icon md-font-icon="icon-trending-up" class="s24"></md-icon></div></div><c3chart flex \nbindto-id="goog-nasdaq"><chart-column ng-repeat="column in vm.widget19.chart.columns" column-id="{{column.id}}" \ncolumn-name="{{column.name}}" column-color="{{column.color}}" column-values="{{column.values}}" \ncolumn-type="{{column.type}}"><chart-legend show-legend="false"><chart-bar width="10"><chart-size chart-height="240">\n</c3chart></div></ms-widget-front></ms-widget></div></div></div>');
$templateCache.put('app/main/components/material-docs/material-doc-template.html','<div class="doc-page material-docs doc-template page-layout simple tabbed" layout="column"><div \nclass="header md-accent-bg" layout="row" layout-align="space-between"><div layout="column" layout-align="center start">\n<div class="breadcrumb" layout="row" layout-align="start center"><md-icon md-font-icon="icon-home" class="s16">\n</md-icon><md-icon md-font-icon="icon-chevron-right" class="s16 separator"></md-icon><span class="parent">\nANGULAR MATERIAL ELEMENTS</span></div><div class="title">{{vm.componentName}}</div></div></div><div flex \nclass="content"><md-tabs md-selected="selectedIndex" md-dynamic-height><md-tab ng-if="vm.demo"><md-tab-label>\n{{vm.demo.label}} (Demo)</md-tab-label><md-tab-body><a class="reference-link md-yellow-200-bg" \nhref="https://material.angularjs.org/{{vm.materialVersion}}/demo/{{vm.demo.name}}" target="_blank">\nGo to official Angular Material <b>{{vm.demo.name}}</b> demo page</a><docs-demo ng-repeat="demo in vm.demos" \ndemo-id="{{demo.id}}" demo-title="{{demo.label}}" demo-module="{{demo.ngModule.module}}"><demo-file \nng-repeat="file in demo.$files" name="{{file.name}}" contents="file.httpPromise"></demo-file></docs-demo></md-tab-body>\n</md-tab><md-tab ng-repeat="doc in vm.docs"><md-tab-label>{{doc.name}} ({{doc.type}})</md-tab-label><md-tab-body><a \nclass="reference-link md-yellow-200-bg" \nhref="https://material.angularjs.org/{{vm.materialVersion}}/api/{{doc.type}}/{{doc.name}}" target="_blank">\nGo to official Angular Material <b>{{doc.name}} {{doc.type}}</b> documentation page</a><div class="" \nng-include="\'app/main/components/material-docs/\'+doc.outputPath"></div></md-tab-body></md-tab></md-tabs></div></div>');
$templateCache.put('app/main/dialogs/evidenceDetails/evidenceDetails.html','<md-dialog id="dialog-view" class="risk-dialog form-dialog add-media" aria-label="Odds of occurence"><md-toolbar \nclass="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><h4 \nclass="text-uppercase ml-20" ng-if="!vm.evidenceData.evidence.id" translate="RISK.NEW_EVIDENCE"></h4><h4 \nclass="text-uppercase ml-20" ng-if="vm.evidenceData.evidence.id" translate="RISK.EVIDENCE"></h4><div \nclass="absolute-right pr-10" layout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog" tranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></div></md-toolbar><md-dialog-content flex class="content-card p-0" md-no-ink><md-content \nng-if="vm.evidenceData.evidence.id" class="md-padding p0" style="overflow: visible;"><div \nclass="grey-100-bg top-data pv-10 ph-24 border-bottom" layout="row" layout-align="space-between center"><div \nlayout="row" layout-align="start center"><img class="avatar s24" \nng-src="{{vm.storagePrefix + vm.evidenceData.evidence.user.files.url}}" ng-if="vm.evidenceData.evidence.user.files.id">\n<div class="avatar s24" ng-class="vm.evidenceData.evidence.user.profile_color" \nng-if="!vm.evidenceData.evidence.user.files.id" \nng-bind="vm.evidenceData.evidence.user.first_name | capitalizeFirstLetter"></div><span class="grey-600-fg">\n{{vm.evidenceData.evidence.user.first_name}} {{vm.evidenceData.evidence.user.last_name}}</span></div><div layout="row" \nlayout-align="end center"><span class="grey-600-fg" hide show-gt-xs>{{\'RISK.EVIDENCE_CREATED_AT\' | translate}}</span>\n<md-icon class="ml-10 mr-0 s20" md-font-icon="icon-calendar-clock"></md-icon><span class="grey-600-fg">\n{{vm.evidenceData.evidence.updated_at | amDateFormat:\'DD MMM YYYY HH:mm\' | uppercase}}</span></div></div><div \nlayout="column" layout-align="start stretch" layout-gt-xs="row" layout-align-gt-xs="space-between start" \nclass="name ph-24 pt-20 pb-20"><div ng-if="vm.hasProp(vm.evidenceData.evidence, \'score\')" layout="row" \nlayout-align="end center" hide-gt-xs class="mb-20"><span \nng-style="{\'background\': vm.evidenceScoreColor(vm.evidenceData.evidence),\'color\':vm.controlAverageColorText(vm.evidenceData.evidence)}" \nclass="badge"><span ng-if="vm.evidenceData.evidence.score == 0" translate="RISK.CONTROL_SCORE_0"></span> <span \nng-if="vm.evidenceData.evidence.score == 1" translate="RISK.CONTROL_SCORE_1"></span> <span \nng-if="vm.evidenceData.evidence.score == 2" translate="RISK.CONTROL_SCORE_2"></span> <span \nng-if="vm.evidenceData.evidence.score == 3" translate="RISK.CONTROL_SCORE_3"></span> <span \nng-if="vm.evidenceData.evidence.score == 4" translate="RISK.CONTROL_SCORE_4"></span> <span \nng-if="vm.evidenceData.evidence.score == 5" translate="RISK.CONTROL_SCORE_5"></span></span></div><h3 \nif="vm.hasProp(vm.evidenceData.evidence, \'score\')" class="mb-0 mt-0 mr-20" flex><strong \nng-bind="vm.evidenceData.evidence.title"></strong></h3><div \nng-if="!vm.hasProp(vm.evidenceData.evidence, \'score\') && !vm.updatingScore" layout="row" layout-align="start center" \nhide show-gt-xs><span \nng-style="{\'background\': vm.evidenceScoreColor(vm.evidenceData.evidence),\'color\':vm.controlAverageColorText(vm.evidenceData.evidence)}" \nclass="badge"><span ng-if="vm.evidenceData.evidence.score == 0" translate="RISK.CONTROL_SCORE_0"></span> <span \nng-if="vm.evidenceData.evidence.score == 1" translate="RISK.CONTROL_SCORE_1"></span> <span \nng-if="vm.evidenceData.evidence.score == 2" translate="RISK.CONTROL_SCORE_2"></span> <span \nng-if="vm.evidenceData.evidence.score == 3" translate="RISK.CONTROL_SCORE_3"></span> <span \nng-if="vm.evidenceData.evidence.score == 4" translate="RISK.CONTROL_SCORE_4"></span> <span \nng-if="vm.evidenceData.evidence.score == 5" translate="RISK.CONTROL_SCORE_5"></span></span></div><p flex \nng-if="!vm.evidenceData.evidence.hasOwnProperty(\'score\') && !vm.updatingScore" class="text-right">\n{{ \'RISK.NO_SCORED_YET\' | translate}}</p><div ng-if="vm.isComplianceOfficer && vm.updatingScore" layout="column" \nlayout-align="end end" layout-gt-xs="row" layout-align-gt-xs="space-between start" class="ml-20"><md-input-contaimer \nclass="md-block" flex><md-select class="m0" ng-model="vm.evidenceData.evidence.score" \nplaceholder="{{ \'RISK.SCORE\' | translate}}"><md-option ng-value="0" translate="RISK.CONTROL_SCORE_0"></md-option>\n<md-option ng-value="1" translate="RISK.CONTROL_SCORE_1"></md-option><md-option ng-value="2" \ntranslate="RISK.CONTROL_SCORE_2"></md-option><md-option ng-value="3" translate="RISK.CONTROL_SCORE_3"></md-option>\n<md-option ng-value="4" translate="RISK.CONTROL_SCORE_4"></md-option><md-option ng-value="5" \ntranslate="RISK.CONTROL_SCORE_5"></md-option></md-select></md-input-contaimer></div><div \nng-if="vm.isComplianceOfficer" layout="column" layout-align="start stretch" layout-gt-xs="row" \nlayout-align-gt-xs="space-between start" class="ml-20"><md-icon ng-if="!vm.updatingScore" \nng-click="vm.updatingScore= true;" class="pointer" md-font-icon="icon-pencil"></md-icon><md-icon \nng-if="vm.updatingScore" ng-click="vm.updateEvidence()" class="pointer" md-font-icon="icon-check"></md-icon></div>\n</div><div layout="row" layout-align="start center" flex="100" class="ph-24 name"><div \nng-bind-html="vm.evidenceData.evidence.text"></div></div><div layout="row" layout-align="start center" flex="100" \nclass="mt-10 mh-24 border-bottom evidence-file-group"><div layout="column" layout-align="center stretch" flex="100">\n<div ng-repeat="f in vm.evidenceData.evidence.files" flex class="evidence-file"><div class="pv-10 pl-10 border-top" \nflex><div layout="row" layout-align="space-between center" flex><div><md-icon md-font-icon="icon-file" class="mr-5" \nhide show-gt-xs></md-icon><span>{{f.original_name}}</span></div><div layout="column" layout-align="center center" \nlayout-gt-xs="row" layout-align-gt-xs="end center"><button class="ml-10 md-icon-button md-button md-ink-ripple" \nng-click="vm.downloadFile(f)" target="_blank"><md-icon md-font-icon="icon-link"></md-icon><md-tooltip hide show-gt-xs>\n{{\'RISK.DOWNLOAD_FILE\' | translate}}</md-tooltip></button> <button \nclass="ml-10 md-icon-button md-button md-ink-ripple" ng-click="vm.showFileInfo(f, $event)" target="_blank"><md-icon \nmd-font-icon="icon-lock"></md-icon><md-tooltip hide show-gt-xs>{{\'RISK.CHECK_TIMESTAMP\' | translate}}</md-tooltip>\n</button></div></div><md-progress-linear md-mode="determinate" value="{{f.progress}}" ng-show="f.progress <100">\n</md-progress-linear></div></div></div></div></md-content><md-content style="overflow-x: hidden;" \nng-if="!vm.evidenceData.evidence.id" class="md-padding p-24"><div layout="column" layout-gt-xs="row">\n<md-input-container class="md-block" flex><label translate="GLOBAL.TITLE"></label> <input \nng-model="vm.evidenceData.evidence.title"></md-input-container></div><div ng-if="vm.isComplianceOfficer" \nlayout="column" layout-gt-xs="row"><md-input-contaimer class="md-block" flex><md-select \nng-model="vm.evidenceData.evidence.score" placeholder="{{ \'RISK.SCORE\' | translate}}"><md-option ng-value="0" \ntranslate="RISK.CONTROL_SCORE_0"></md-option><md-option ng-value="1" translate="RISK.CONTROL_SCORE_1"></md-option>\n<md-option ng-value="2" translate="RISK.CONTROL_SCORE_2"></md-option><md-option ng-value="3" \ntranslate="RISK.CONTROL_SCORE_3"></md-option><md-option ng-value="4" translate="RISK.CONTROL_SCORE_4"></md-option>\n<md-option ng-value="5" translate="RISK.CONTROL_SCORE_5"></md-option></md-select></md-input-contaimer></div><div \nlayout="column" layout-gt-xs="row"><md-input-contaimer class="md-block" flex><md-select \nng-model="vm.evidenceData.evidence.currency_id" placeholder="{{ \'GLOBAL.CURRENCY\' | translate}}"><md-option \nmd-option-empty ng-value="undefined">---</md-option><md-option ng-repeat="currency in vm.currencies" \nng-value="currency.id">{{currency.symbol}}</md-option></md-select></md-input-contaimer><md-input-container \nng-if="vm.evidenceData.evidence.currency_id" class="md-block" flex><label translate="GLOBAL.AMOUNT"></label> <input \ntype="number" required ng-model="vm.evidenceData.evidence.amount"></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><p translate="GLOBAL.SEND_COPY_EMAIL_TO"></p></div><div layout="column" layout-gt-xs="row">\n<md-checkbox flex ng-disabled="true" ng-checked="vm.evidenceData.evidence.communication.compliance_officers">\n{{\'GLOBAL.COMPLIANCE_OFFICER\' | translate}}</md-checkbox><md-checkbox flex \nng-checked="vm.evidenceData.evidence.communication.in_charge" \nng-click="vm.evidenceData.evidence.communication.in_charge= !vm.evidenceData.evidence.communication.in_charge">\n{{\'RISK.USERS_ADMIN\' | translate}}</md-checkbox><md-checkbox flex \nng-checked="vm.evidenceData.evidence.communication.participants" \nng-click="vm.evidenceData.evidence.communication.participants= !vm.evidenceData.evidence.communication.participants">\n{{\'RISK.USERS_PARTICIPANTS_WITH_ACCESS\' | translate}}</md-checkbox></div><div layout="column" layout-gt-xs="row">\n<md-input-container class="md-block" flex><textarea ui-tinymce="vm.tinymceOptions" \nng-model="vm.evidenceData.evidence.text" rows="3" md-select-on-focus></textarea></md-input-container></div><div \nlayout="column" layout-gt-xs="row" ng-if="vm.evidenceData.evidence.id"><div \nng-repeat="f in vm.evidenceData.evidence.files" class="ms-card" flex><div class="ms-card-content-wrapper"><div \nclass="template-9"><div class="header p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size" layout="row" layout-align="start left"><strong class="mr-5" ng-if="f.id">#{{f.id}}</strong> <span \nclass="grey-500-fg"><span>{{f.url.substr(-3,3)}}</span> </span><a ng-href="{{vm.storagePrefix + f.url}}" \ntarget="_blank"><md-icon md-font-icon="icon-link"></md-icon></a></div></div></div><md-progress-linear \nmd-mode="determinate" value="{{f.progress}}" ng-show="f.progress <100"></md-progress-linear></div></div></div></div>\n<div fill-width layout="column" layout-gt-xs="row" ng-if="!vm.evidenceData.evidence.id"><div fill-width><div ngf-drop \nngf-select ng-model="vm.evidenceData.files" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" \nngf-allow-dir="true" accept="image/*,video/*,audio/*,.pdf,.txt,.doc,.docx,.xls,.xlsx,!.js,!.sh,.zip" \nngf-pattern="\'image/*,video/*,audio/*,.pdf,.txt,.doc,.docx,.xls,.xlsx,!.js,!.sh,.zip\'"><div layout="column"><div flex \ntranslate="GLOBAL.DROP_HERE">Drop here or click to upload</div><div flex translate="GLOBAL.OR"></div><div flex>\n<md-button class="send-button md-accent md-raised" aria-label="Select files" translate="GLOBAL.SELECT_FILES">\n</md-button></div></div></div><div ngf-no-file-drop translate="GLOBAL.FILE_DRAG_DROP"></div><div \nng-repeat="f in vm.evidenceData.files" class="ms-card" flex><div class="ms-card-content-wrapper"><div \nclass="template-9"><div class="media" flex layout="row" layout-align="center center"><img \nngf-thumbnail="!f.$error && f" class="image"></div><div class="header p-16" flex><div layout="row" \nlayout-align="space-between center" flex><div class="size" layout="row" layout-align="start left"><strong class="mr-5" \nng-if="f.id">#{{f.id}}</strong> <span class="grey-500-fg"><span ng-if="f.name">{{f.name}}</span></span></div></div>\n</div><md-progress-linear md-mode="determinate" value="{{f.progress}}" ng-show="f.progress <100"></md-progress-linear>\n</div></div></div><div ngf-no-file-drop translate="GLOBAL.FILE_DRAG_DROP"></div></div><div style="overflow: hidden" \nng-repeat="f in vm.evidenceData.files" class="ms-card" flex><div class="ms-card-content-wrapper"><div \nclass="template-9"><div class="media" flex layout="row" layout-align="center center"><img \nngf-thumbnail="!f.$error && f" class="image"></div><div class="header p-16" flex><div layout="row" \nlayout-align="space-between center" flex><div class="size" layout="row" layout-align="start left"><strong class="mr-5" \nng-if="f.id">#{{f.id}}</strong> <span class="grey-500-fg"><span ng-if="f.name">{{f.name}}</span></span></div></div>\n</div><md-progress-linear md-mode="determinate" value="{{f.progress}}" ng-show="f.progress <100"></md-progress-linear>\n</div></div></div></div></md-content></md-dialog-content><md-dialog-actions layout="row" layout-align="end center" \nclass="grey-100-bg" ng-if="!vm.evidenceData.evidence.id"><md-button \nng-disabled="!vm.evidenceData.evidence.title || (vm.evidenceData.evidence.currency_id && !vm.evidenceData.evidence.amount)" \nng-click="vm.save()" class="send-button md-accent md-raised" aria-label="Save" translate="RISK.SAVE" \ntranslate-attr-aria-label="RISK.SAVE"></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/main/dialogs/createAlerts/createAlerts.html','<md-dialog id="create-alerts-view" class="form-dialog add-media select-user" aria-label="Odds of occurence"><md-toolbar\n class="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><h3 class="ph-15" \ntranslate="{{ vm.title }}"></h3><div class="absolute-right pr-10" layout="row  "><button \nclass="md-icon-button md-button md-ink-ripple md-default-theme" ng-click="vm.closeDialog()" aria-label="Close dialog" \ntranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></button></div></div>\n</md-toolbar><md-dialog-content class="mediadialog-content mail-list-item" flex><div class="content-wrapper" flex \nlayout="row"><div class="content thread-list mail-list-pane p0" flex="" id="thread-list"><div id="list-content-data" \nng-style="{\'opacity\' : isLoading ? 0.5 : 1}"><md-list><div ng-repeat="alert in vm.alerts" class="p-0"><div \nlayout="row" flex class="ml-5 mt-10 mb-10"><span flex="25" class="md-block pr-20" align="right">{{alert.amount}} \n</span><span flex="30" class="md-block">{{vm.alertReccurent[alert.periodity] | translate}} </span><span flex="30" \nclass="md-block">{{vm.alertType[alert.type] | translate}}</span> <button flex class="md-block ml-10" \nclass="md-icon-button md-button" ng-click="vm.alerts.splice(vm.alerts.indexOf(alert), 1)"><md-icon \nmd-font-icon="icon-delete"></md-icon></button></div></div></md-list><div flex layout="row"><md-input-container \nflex="25" class="md-block" ng-required="false"><label translate="RISK.ALERT_INTERVAL"></label> <input type="number" \nng-model="vm.alert.amount" style="text-align: right;"></md-input-container><md-input-container flex="30" \nclass="md-block" ng-required="false"><label translate="RISK.ALERT_RECURRENT"></label><md-select \nng-model="vm.alert.periodity"><md-option ng-repeat="(key, value) in vm.alertReccurent" value="{{key}}">\n{{ value | translate }}</md-option></md-select></md-input-container><md-input-container flex="30" class="md-block" \nng-required="false"><label translate="RISK.ALERT_TYPE"></label><md-select ng-model="vm.alert.type"><md-option \nng-repeat="(key, value) in vm.alertType" value="{{key}}">{{ value | translate }}</md-option></md-select>\n</md-input-container><md-input-container flex class="ml-5"><button class="md-icon-button md-button md-accent" \nng-click="vm.addAlert(vm.alert)" ng-disabled="!vm.alert.type || !vm.alert.amount || !vm.alert.periodity"><md-icon \nmd-font-icon="icon-plus-circle"></md-icon></button></md-input-container></div></div></div></div></md-dialog-content>\n<md-dialog-actions layout="row" layout-align="end center" class="grey-100-bg"><md-button \nng-disabled="vm.alerts.length == 0" ng-click="vm.saveAlerts()" class="send-button md-accent md-raised" \naria-label="Apply" translate="RISK.APPLY" translate-attr-aria-label="RISK.APPLY"></md-button></md-dialog-actions>\n</md-dialog>');
$templateCache.put('app/main/dialogs/companyQuotaDialog/companyQuotaDialog.html','<md-dialog id="quota-company-dialog" class="form-dialog" aria-label="Odds of occurence"><md-toolbar class="md-accent">\n<div class="md-toolbar-tools" layout="row" layout-align="space-between center"><h1>\n{{\'GLOBAL.QUOTA_EXCEDED\' | translate}}</h1><div class="absolute-right pr-10" layout="row"><md-button \nclass="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content class="mediadialog-content p-24" flex><div ng-if="vm.user.user_type == 1"><p>\n{{\'GLOBAL.QUOTA_EXCEDED_COMPANIES_DESC_1\' | translate:{value1: vm.quota.companies_registered, value2: vm.quota.max_allowed_companies} }}\n</p><p>{{\'GLOBAL.QUOTA_EXCEDED_COMPANIES_DESC_2\' | translate}}</p></div><div ng-if="vm.user.user_type !== 1"><p>\n{{\'GLOBAL.QUOTA_EXCEDED_COMPANIES_DESC_3\' | translate}}</p><p>{{\'GLOBAL.QUOTA_EXCEDED_COMPANIES_DESC_4\' | translate}}\n</p></div></md-dialog-content><md-dialog-actions ng-if="vm.user.is_owner && vm.user.stripe" layout="row" \nlayout-align="end center" class="grey-100-bg"><md-button translate="GLOBAL.CANCEL" type="button" \nng-click="vm.closeDialog()" class="md-raised md-warn" aria-label="Cancel"></md-button><md-button \nng-click="vm.openStripeDialog($event)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="GLOBAL.UPGRADE_PLAN" translate-attr-aria-label="GLOBAL.UPGRADE_PLAN"></md-button></md-dialog-actions>\n<md-dialog-actions ng-if="!vm.user.is_owner || !vm.user.stripe" layout="row" layout-align="end center" \nclass="grey-100-bg"><md-button translate="GLOBAL.CANCEL" type="button" ng-click="vm.closeDialog()" \nclass="md-raised md-warn" aria-label="Cancel"></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/main/dialogs/selectDivisions/selectDivisions.html','<md-dialog id="dialog-view" class="form-dialog add-media select-users" aria-label="Odds of occurence"><md-toolbar \nclass="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><h3 class="ph-15">\n{{vm.title}}</h3><div class="absolute-right pr-10" layout="row"><button \nclass="md-icon-button md-button md-ink-ripple md-default-theme" ng-click="vm.closeDialog()" aria-label="Close dialog" \ntranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></button></div></div>\n</md-toolbar><md-toolbar><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><div></div>\n<ms-search-bar-none flex class="expanded ms-search-bar" debounce="300" layout="row" layout-align="start center"><div \nflex layout="row" layout-align="start center"><label for="ms-search-bar-input"><md-icon id="ms-search-bar-expander" \nmd-font-icon="icon-magnify" class="md-icon-button md-button md-default-theme md-font material-icons icon-magnify" \naria-label="Search" aria-hidden="true"></md-icon></label><md-icon md-font-icon="icon-magnify" aria-hidden="true">\n</md-icon><input id="ms-search-bar-input" type="text" name="tabSearch" ng-model="vm.divisionsSearch" \nplaceholder="Search" md-autofocus translate translate-attr-placeholder="TOOLBAR.SEARCH" flex \nclass="ng-pristine ng-valid ng-scope ng-empty md-autofocus ng-touched" aria-invalid="false"></div></ms-search-bar-none>\n</div></md-toolbar><md-dialog-content class="mediadialog-content" flex><div class="content-wrapper" flex layout="row">\n<div ng-if="vm.allDivisions" class="treeview small" ivh-treeview="vm.allDivisions" \nivh-treeview-filter="vm.divisionsSearch" flex><script type="text/ng-template">\n<div class="level-card" layout="row" layout-align="space-between center">\n                        <div layout="row" layout-align="start center" class="mr-24">\n                            <span>{{node.name}}</span>\n                        </div>\n                        <md-treeview-box></md-treeview-box>\n                    </div>\n                    <div ivh-treeview-children></div>\n</script></div></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center" class="grey-100-bg">\n<md-button ng-click="vm.apply()" class="send-button md-accent md-raised" aria-label="Apply" translate="RISK.APPLY" \ntranslate-attr-aria-label="RISK.APPLY"></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/main/dialogs/fileDetails/fileDetailsDialog.html','<md-dialog id="dialog-view" class="form-dialog add-media" aria-label="Odds of occurence"><md-toolbar class="md-accent">\n<div class="md-toolbar-tools" layout="row" layout-align="space-between center"><h4 class="text-uppercase ml-20" \nng-bind-html="vm.file.original_name"></h4><div class="absolute-right pr-10" layout="row  "><md-button \nclass="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content flex class="content-card p-24" md-no-ink><md-content class="md-padding p0"><div flex \nlayout="column" layout-align="center center" ng-if="vm.isLoading" class="loading-container"><md-progress-circular \nmd-mode="indeterminate" md-diameter="30"></md-progress-circular></div><div layout="row" \nlayout-align="space-between center" class="mb-20"><div layout="row" layout-align="start center" \nng-if="!vm.isLoading && vm.timeStamp.isValid"><span class="mr-10" translate="GLOBAL.FILE_TIMESTAMP_DATE"></span> \n<strong ng-bind-html="vm.timeStamp.timestamp"></strong></div><div layout="row" layout-align="end center" \nng-if="!vm.isLoading && vm.timeStamp.isValid"><strong translate="GLOBAL.FILE_SIGNATURE_VALID" class="mr-10"></strong>\n<md-icon md-font-icon="icon-checkbox-marked-circle" class="green-fg"></md-icon></div></div><div layout="column" \nlayout-align="start start" ng-if="!vm.isLoading && vm.timeStamp.isValid" class="p-10 border grey-100-bg"><div \nclass="mb-5" ng-repeat="info in vm.timeStamp.info" ng-bind-html="info"></div></div><div layout="row" \nlayout-align="start center" ng-if="!vm.isLoading && !vm.timeStamp.isValid"><md-icon md-font-icon="icon-close-circle" \nclass="s18 red-fg"></md-icon><span translate="GLOBAL.FILE_SIGNATURE_INVALID"></span></div></md-content>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="space-between center" class="border-top"><div \nlayout="row" layout-align="start center"><a \nhref="http://ayuda.help2comply.com/funcionalidades/sellado-de-tiempo-o-timestamping" \nclass="ml-10 md-icon-button md-button md-ink-ripple" target="_blank"><md-icon md-font-icon="icon-help-circle">\n</md-icon></a></div><div layout="row" layout-align="end center"><md-button ng-click="vm.downloadFile()" \nng-disabled="vm.processing" class="send-button md-accent md-raised" aria-label="Download File" \ntranslate="GLOBAL.DOWNLOAD_FILE" translate-attr-aria-label="GLOBAL.DOWNLOAD_FILE"></md-button><md-button \nng-click="vm.getTSRFile()" ng-disabled="vm.processing" class="send-button md-accent md-raised" \naria-label="Download TSR" translate="GLOBAL.DOWNLOAD_TSR_FILE" translate-attr-aria-label="GLOBAL.DOWNLOAD_TSR_FILE">\n</md-button><md-button ng-click="vm.getTSQFile()" ng-disabled="vm.processing" class="send-button md-accent md-raised" \naria-label="Download TSQ" translate="GLOBAL.DOWNLOAD_TSQ_FILE" translate-attr-aria-label="GLOBAL.DOWNLOAD_TSQ_FILE">\n</md-button></div></md-dialog-actions></md-dialog>');
$templateCache.put('app/main/dialogs/process/oddOfOccurrence.html','<md-dialog id="dialog-view" class="form-dialog add-media" aria-label="Odds of occurence"><md-toolbar class="md-accent">\n<div class="md-toolbar-tools" layout="row" layout-align="space-between center"><h4 class="text-uppercase ml-20" \ntranslate="RISK.DIALOG_TITLE_ODD_COMMENT"></h4><div class="absolute-right pr-10" layout="row  "><button \nclass="md-icon-button md-button md-ink-ripple md-default-theme" ng-click="vm.closeDialog()" aria-label="Close dialog" \ntranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></button></div></div>\n</md-toolbar><md-dialog-content flex class="content-card p-24" md-no-ink><md-content class="md-padding p0"><div \nlayout-gt-xs="row"><md-input-contaimer class="md-block"><md-select ng-model="vm.score" placeholder="Score"><md-option \nng-value="1" ng-disabled="$index === 1" translate="RISK.PROCESS_AVERAGE_1"></md-option><md-option ng-value="2" \nng-disabled="$index === 2" translate="RISK.PROCESS_AVERAGE_2"></md-option><md-option ng-value="3" \nng-disabled="$index === 3" translate="RISK.PROCESS_AVERAGE_3"></md-option><md-option ng-value="4" \nng-disabled="$index === 4" translate="RISK.PROCESS_AVERAGE_4"></md-option><md-option ng-value="5" \nng-disabled="$index === 5" translate="RISK.PROCESS_AVERAGE_5"></md-option></md-select></md-input-contaimer></div><div \nlayout-gt-xs="row"><md-input-container class="md-block" flex-gt-xs=""><label><span translate="RISK.ODDS_ENTER_COMMENT">\n</span></label> <textarea ng-model="vm.comment" rows="3" md-select-on-focus></textarea></md-input-container></div>\n</md-content></md-dialog-content><md-dialog-actions layout="row" layout-align="end center" class="grey-100-bg">\n<md-button ng-click="vm.answer(vm)" class="md-raised md-accent" translate="RISK.SAVE" aria-label="SAVE"></md-button>\n</md-dialog-actions></md-dialog>');
$templateCache.put('app/main/dialogs/textDialog/textDialog.html','<md-dialog id="dialog-view" class="form-dialog add-media" aria-label="Odds of occurence"><md-toolbar class="md-accent">\n<div class="md-toolbar-tools" layout="row" layout-align="space-between center"><h1>{{ vm.title | translate}}</h1><div \nclass="absolute-right pr-10" layout="row  "><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog" tranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></div></md-toolbar><md-dialog-content class="mediadialog-content p-24" flex><div \nclass="content-wrapper" flex layout="row"><div ng-bind-html="vm.text"></div></div></md-dialog-content></md-dialog>');
$templateCache.put('app/main/dialogs/taskDetails/task-new-content.html','<md-content class="md-padding p-24"><div layout="column"><md-input-container flex class="md-block m-0" flex="100">\n<label translate="RISK.TASK_TITLE"></label> <input ng-model="vm.taskData.task.title"></md-input-container><div \nlayout="row"><md-input-container flex class="md-block m-0"><label translate="RISK.TASK_STATE"></label><md-select \nng-model="vm.taskData.task.status_id"><md-option ng-repeat="(key, value) in vm.statusTask" value="{{key}}">\n{{ value | translate }}</md-option></md-select><div class="md-errors-spacer"></div></md-input-container><div \nlayout="row"><label class="label-tasks">{{ \'RISK.TASK_DUE_BY_DATE\' | translate }}</label><md-datepicker \nstyle="margin-right: 10px;" flex class="due-date-input" ng-model="vm.taskData.task.due_by_date" \nmd-placeholder="{{ \'RISK.TASK_DUE_BY_DATE\' | translate }}" ng-required="false"></md-datepicker><mdp-time-picker \nclass="clock-taks" mdp-auto-switch="true" mdp-open-on-click="true" ng-model="vm.taskData.task.due_by_date">\n</mdp-time-picker></div></div></div><div class="recurrence-area" layout="column" layout-gt-xs="row"><md-checkbox \nstyle="max-height: 18px;" flex ng-checked="vm.showRecurrence" ng-click="vm.toggleRecurrence()" ng-required="false">\n{{\'RISK.TASK_RECURRENCE\' | translate}}</md-checkbox><label ng-if="vm.showRecurrence" class="label-each" \ntranslate="RISK.EACH"></label><md-input-container style="max-width: 60px;" ng-if="vm.showRecurrence" flex \nclass="md-block m-0 ml-30" ng-required="false"><label translate="RISK.RECURRENT_INTERVAL"></label><md-select \nng-model="vm.taskData.task.recurrent_interval"><md-option ng-repeat="key in [1,2,3,4,5,6]" value="{{key}}">{{ key }}\n</md-option></md-select><div class="md-errors-spacer"></div></md-input-container><md-input-container \nng-if="vm.showRecurrence" flex class="md-block m-0 ml-15" ng-required="false"><label translate="RISK.RECURRENT_TYPE">\n</label><md-select ng-model="vm.taskData.task.recurrent_type"><md-option ng-repeat="(key, value) in vm.reccurentType" \nvalue="{{key}}">{{ value | translate }}</md-option></md-select><div class="md-errors-spacer"></div>\n</md-input-container><label ng-if="vm.showRecurrence" class="label-each ml-25" translate="RISK.ENDS"></label>\n<md-datepicker ng-if="vm.showRecurrence" flex class="due-date-input" ng-model="vm.taskData.task.recurrent_end_date" \nmd-placeholder="{{ \'RISK.RECURRENT_END_DATE\' | translate }}" ng-required="false"></md-datepicker></div><div \nlayout="column" layout-gt-xs="row"><md-input-container class="group-form m-0" flex="100" flex-gt-xs="100"><div \nclass="field"><div ng-if="vm.taskData.task.assigned_multiple && vm.taskData.task.assigned_multiple.users.length> 0" \nng-repeat="userAsigned in vm.taskData.task.assigned_multiple.users"><div class="name mb-20" layout="row" \nlayout-align="start center" ng-if="userAsigned"><img class="avatar" \nng-src="{{vm.storagePrefix + userAsigned.files.url}}" ng-if="userAsigned.files.id"><div class="avatar" \nms-random-class="vm.colors" ng-if="!userAsigned.files.id" ng-bind="userAsigned.first_name | capitalizeFirstLetter">\n</div><span>{{userAsigned.first_name}} {{userAsigned.last_name}}</span><md-button ng-if="!vm.userLocked" \nng-click="vm.unasignedUserTask(userAsigned)" class="md-accent md-icon-button" type="button" aria-label="ACTIONS">\n<md-icon md-font-icon="icon-delete" class="s20"><md-tooltip hide show-gt-xs md-direction="bottom">\n{{\'RISK.DELETE_ASSIGNED_USER\' | translate }}</md-tooltip></md-icon></md-button></div></div><div><div \nclass="name mb-20" layout="row" layout-align="start center" \nng-if="vm.taskData.task.assigned_to_user_id && !vm.userLocked"><img class="avatar" \nng-src="{{vm.storagePrefix + vm.taskData.task.assigned_to_user_id.files.url}}" \nng-if="vm.taskData.task.assigned_to_user_id.files.id"><div class="avatar" ms-random-class="vm.colors" \nng-class="vm.taskData.task.assigned_to_user_id.profile_color" ng-if="!vm.taskData.task.assigned_to_user_id.files.id" \nng-bind="vm.taskData.task.assigned_to_user_id.first_name | capitalizeFirstLetter"></div><span>\n{{vm.taskData.task.assigned_to_user_id.first_name}} {{vm.taskData.task.assigned_to_user_id.last_name}}</span><md-button\n ng-if="!vm.userLocked" ng-click="vm.unasignedUserTask(vm.taskData.task.assigned_to_user_id)" \nclass="md-accent md-icon-button" type="button" aria-label="ACTIONS"><md-icon md-font-icon="icon-delete" class="s20">\n<md-tooltip hide show-gt-xs md-direction="bottom">{{\'RISK.DELETE_ASSIGNED_USER\' | translate }}</md-tooltip></md-icon>\n</md-button></div></div><div ng-if="!vm.userLocked" class="mb-20" layout="row" layout-align="start center" \nng-if="vm.taskData.task.assigned_multiple.users.length === 0"><div layout="row" layout-align="start center"><md-button \nng-click="vm.openDialogUser($event)" ng-if="vm.userLogued.user_type <4" \nclass="ml-0 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-account-plus"></md-icon></md-button>\n<span translate="RISK.ASSIGN_TO_USER"></span></div></div></div></md-input-container></div><div \nng-if="!vm.taskData.task.id" layout="column" layout-gt-xs="row"><p translate="GLOBAL.SEND_COPY_EMAIL_TO"></p></div><div\n ng-if="!vm.taskData.task.id" layout="column" layout-gt-xs="row"><md-checkbox flex \nng-checked="vm.taskData.task.communication.assigned">{{\'RISK.ASIGNED\' | translate}}</md-checkbox><md-checkbox flex \nng-disabled="true" ng-checked="vm.taskData.task.communication.compliance_officers">\n{{\'GLOBAL.COMPLIANCE_OFFICER\' | translate}}</md-checkbox><md-checkbox flex \nng-checked="vm.taskData.task.communication.in_charge" \nng-click="vm.taskData.task.communication.in_charge= !vm.taskData.task.communication.in_charge">\n{{\'RISK.USERS_ADMIN\' | translate}}</md-checkbox><md-checkbox flex \nng-checked="vm.taskData.task.communication.participants" \nng-click="vm.taskData.task.communication.participants= !vm.taskData.task.communication.participants">\n{{\'RISK.USERS_PARTICIPANTS_WITH_ACCESS\' | translate}}</md-checkbox></div><div class="upload-area" layout="column" \nlayout-gt-xs="column"><div flex><div ngf-drop ngf-select ng-model="vm.taskData.files" class="drop-box" \nngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="image/*,video/*,audio/*,.pdf,.txt,.doc,.docx,.xls,.xlsx,!.js,!.sh" \nngf-pattern="\'image/*,video/*,audio/*,.pdf,.txt,.doc,.docx,.xls,.xlsx,!.js,!.sh\'"><div layout="row" flex><div \nclass="upload-area-text" flex translate="GLOBAL.DROP_HERE">Drop here or click to upload</div><div \nclass="upload-area-button" flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.SELECT_FILES"></md-button></div></div></div><div ngf-no-file-drop translate="GLOBAL.FILE_DRAG_DROP">\n</div></div><div ng-repeat="f in vm.taskData.files.concat(vm.taskData.task.files)" class="ms-card" flex="15"><div \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><img ng-if="!f.url" ngf-thumbnail="!f.$error && f" class="image"> <img height="50" \nng-if="f.url" ng-src="{{vm.storagePrefix+f.url}}" alt=""></div><div class="p-16" flex><div layout="row" \nlayout-align="space-between center" flex><div class="size" layout="row" layout-align="start left"><strong class="mr-5" \nng-if="f.id">#{{f.id}}</strong> <span class="grey-500-fg"><h2c-icon file="f.name"></h2c-icon><span ng-if="f.name">\n{{f.name}}</span> <span ng-if="f.original_name">{{f.original_name}}</span></span></div></div></div><md-progress-linear \nmd-mode="determinate" value="{{f.progress}}" ng-show="f.progress <100"></md-progress-linear></div></div></div></div>\n<div layout="column" layout-gt-xs="row"><md-input-container class="md-block" flex><textarea \nui-tinymce="vm.tinymceOptions" ng-model="vm.taskData.task.text" rows="3" md-select-on-focus></textarea>\n</md-input-container></div></md-content>');
$templateCache.put('app/main/dialogs/taskDetails/taskDetails.html','<md-dialog id="dialog-view" class="risk-dialog form-dialog add-media task-detail" aria-label="Odds of occurence">\n<md-toolbar class="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><h4 \nclass="text-uppercase ml-20" ng-if="!vm.taskData.task.id" translate="RISK.NEW_TASK"></h4><h4 \nclass="text-uppercase ml-20" ng-if="vm.taskData.task.id" translate="RISK.TASK"></h4><div class="absolute-right pr-10" \nlayout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content flex class="content-card p-0" md-no-ink><div \nclass="content thread-detail mail-read-pane scrollable p0" flex="" id="thread-detail" ms-scroll="vm.msScrollOptions" \nng-include="\'app/main/apps/tasks/views/edit/edit-view.html\'"></div></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="end center" class="grey-100-bg"><md-button translate="GLOBAL.CANCEL" type="button" \nng-click="vm.closeDialog()" class="md-raised md-warn" aria-label="Cancel"></md-button><md-button \nng-disabled="!vm.taskData.task.title || (vm.taskData.task.assigned_multiple.users.length === 0 && !vm.taskData.task.assigned_to_user_id) || !vm.taskData.task.status_id" \nng-click="vm.save()" class="send-button md-accent md-raised" aria-label="Save" translate="RISK.SAVE" \ntranslate-attr-aria-label="RISK.SAVE"></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/main/dialogs/selectUser/selectUser.html','<md-dialog id="select-user-view" class="form-dialog add-media select-user" aria-label="Odds of occurence"><md-toolbar \nclass="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><h3 class="ph-15">\n{{vm.title}}</h3><div class="absolute-right pr-10" layout="row"><button \nclass="md-icon-button md-button md-ink-ripple md-default-theme" ng-click="vm.closeDialog()" aria-label="Close dialog" \ntranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></button></div></div>\n</md-toolbar><div style="min-height: 95px; display: list-item; overflow: scroll;" \nng-if="vm.usersSelectedObjectArray.length> 0" class="p-10"><md-chips ng-model="vm.usersSelectedObjectArray" \nmd-removable="true" readonly="true"><md-chip-template><span>{{$chip.first_name}} {{$chip.last_name}}</span>\n</md-chip-template></md-chips></div><md-toolbar><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><div></div><ms-search-bar-none flex class="expanded ms-search-bar" debounce="300" \nlayout="row" layout-align="start center"><div flex layout="row" layout-align="start center"><label \nfor="ms-search-bar-input"><md-icon id="ms-search-bar-expander" md-font-icon="icon-magnify" \nclass="md-icon-button md-button md-default-theme md-font material-icons icon-magnify" aria-label="Search" \naria-hidden="true"></md-icon></label><md-icon md-font-icon="icon-magnify" aria-hidden="true"></md-icon><input \nid="ms-search-bar-input" type="text" name="tabSearch" ng-model="vm.usersSearch" placeholder="Search" md-autofocus \ntranslate translate-attr-placeholder="TOOLBAR.SEARCH" flex \nclass="ng-pristine ng-valid ng-scope ng-empty md-autofocus ng-touched" aria-invalid="false"></div></ms-search-bar-none>\n</div></md-toolbar><md-dialog-content class="mediadialog-content" flex><div class="content-wrapper" flex layout="row">\n<div class="content thread-list mail-list-pane p0" flex="" id="thread-list"><div id="list-content-data" \nng-style="{\'opacity\' : isLoading ? 0.5 : 1}"><div class="mail-list-item" \nng-style="{ \'opacity\' : vm.isSelected(user) ? 0.5 : 1 }" ng-repeat="user in vm.allUsers | filter: vm.usersSearch" \nng-init="parentIndex= $index" md-no-ink ng-click="vm.selectUser(user)"><div layout="row" layout-align="start center">\n<div class="info layout-column flex" flex="" layout="column"><div class="name text-truncate" layout="row" \nlayout-align="start center"><img class="avatar" ng-src="{{user.storagePrefix + user.files.url}}" ng-if="user.files.id">\n<div class="avatar" ms-random-class="vm.colors" ng-if="!user.files.id" \nng-bind="user.first_name | capitalizeFirstLetter"></div><span>{{user.first_name}} {{user.last_name}}</span></div></div>\n</div></div></div></div></div></md-dialog-content><md-dialog-actions layout="row" layout-align="start center" \nclass="grey-100-bg"><div layout="row" layout-align="start center"><md-checkbox flex ng-checked="vm.shared_task" \nng-click="vm.shared_task= !vm.shared_task" ng-required="false">{{\'RISK.SHARED_TASK\' | translate}}</md-checkbox></div>\n<div layout="row" layout-align="end center" flex><md-button ng-click="vm.saveDialog()" \nclass="send-button md-accent md-raised" aria-label="Apply" translate="RISK.ASIGN" \ntranslate-attr-aria-label="RISK.APPLY"></md-button></div></md-dialog-actions></md-dialog>');
$templateCache.put('app/main/dialogs/selectUsers/selectUsers.html','<md-dialog id="dialog-view" class="form-dialog add-media select-users" aria-label="Odds of occurence"><md-toolbar \nclass="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><h3 class="ph-15">\n{{vm.title}}</h3><div class="absolute-right pr-10" layout="row  "><button \nclass="md-icon-button md-button md-ink-ripple md-default-theme" ng-click="vm.closeDialog()" aria-label="Close dialog" \ntranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></button></div></div>\n</md-toolbar><md-toolbar><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><div></div>\n<ms-search-bar-none flex class="expanded ms-search-bar" debounce="300" layout="row" layout-align="start center"><div \nflex layout="row" layout-align="start center"><label for="ms-search-bar-input"><md-icon id="ms-search-bar-expander" \nmd-font-icon="icon-magnify" class="md-icon-button md-button md-default-theme md-font material-icons icon-magnify" \naria-label="Search" aria-hidden="true"></md-icon></label><md-icon md-font-icon="icon-magnify" aria-hidden="true">\n</md-icon><input id="ms-search-bar-input" type="text" name="tabSearch" ng-model="vm.usersSearch" placeholder="Search" \nmd-autofocus translate translate-attr-placeholder="TOOLBAR.SEARCH" flex \nclass="ng-pristine ng-valid ng-scope ng-empty md-autofocus ng-touched" aria-invalid="false"></div></ms-search-bar-none>\n</div></md-toolbar><md-dialog-content class="mediadialog-content" flex><div class="content-wrapper" flex layout="row">\n<div ng-if="vm.allUsers" class="treeview small" ivh-treeview="vm.allUsers" ivh-treeview-filter="vm.usersSearch" flex>\n<script type="text/ng-template">\n<div class="level-card" layout="row" layout-align="space-between center">\n                        <div layout="row" layout-align="start center" class="mr-24">\n                            <img class="avatar " ng-src="{{node.storagePrefix + node.files.url}}" ng-if="node.files.id">\n                            <div class="avatar"  ms-random-class="[\'blue-bg\', \'blue-grey-bg\', \'orange-bg\', \'pink-bg\', \'purple-bg\']" ng-if="!node.files.id" ng-bind="node.first_name | capitalizeFirstLetter"></div>\n                            <span>{{node.first_name}} {{node.last_name}}</span>\n                        </div>\n                        <md-treeview-box></md-treeview-box>\n                    </div>\n                    <div ivh-treeview-children></div>\n</script></div></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center" class="grey-100-bg">\n<md-button ng-click="vm.apply()" class="send-button md-accent md-raised" aria-label="Apply" translate="RISK.APPLY" \ntranslate-attr-aria-label="RISK.APPLY"></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/main/dialogs/userQuotaDialog/userQuotaDialog.html','<md-dialog id="quota-user-dialog" class="form-dialog" aria-label="Odds of occurence"><md-toolbar class="md-accent"><div\n class="md-toolbar-tools" layout="row" layout-align="space-between center"><h1>{{\'GLOBAL.QUOTA_EXCEDED\' |translate}}\n</h1><div class="absolute-right pr-10" layout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog" tranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></div></md-toolbar><md-dialog-content class="mediadialog-content p-24" flex><div \nng-if="vm.user.user_type == 1"><p>\n{{\'GLOBAL.QUOTA_EXCEDED_DESC_1\' | translate:{value1: vm.quota.users_registered, value2: vm.quota.max_allowed_users} }}\n</p><p ng-bind-html="{{\'GLOBAL.QUOTA_EXCEDED_DESC_2\'}}"></p></div><div ng-if="vm.user.user_type !== 1"><p>\n{{\'GLOBAL.QUOTA_EXCEDED_DESC_3\'}}</p><p ng-bind-html="{{\'GLOBAL.QUOTA_EXCEDED_DESC_4\'}}"></p></div></md-dialog-content>\n<md-dialog-actions ng-if="vm.user.user_type == 1" layout="row" layout-align="end center" class="grey-100-bg"><md-button\n translate="GLOBAL.CANCEL" type="button" ng-click="vm.closeDialog()" class="md-raised md-warn" aria-label="Cancel">\n</md-button><md-button ng-click="vm.saveDialog(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="GLOBAL.UPGRADE_PLAN" translate-attr-aria-label="GLOBAL.UPGRADE_PLAN"></md-button><md-button \nng-click="vm.saveDialog(false)" class="send-button md-accent md-raised" aria-label="Save" translate="GLOBAL.SAVE" \ntranslate-attr-aria-label="GLOBAL.SAVE"></md-button></md-dialog-actions><md-dialog-actions \nng-if="vm.user.user_type != 1" layout="row" layout-align="end center" class="grey-100-bg"><md-button \ntranslate="GLOBAL.CANCEL" type="button" ng-click="vm.closeDialog()" class="md-raised md-warn" aria-label="Cancel">\n</md-button><md-button ng-click="vm.saveDialog(false)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="GLOBAL.SAVE" translate-attr-aria-label="GLOBAL.SAVE"></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/main/dialogs/userQuotaDialog/userQuotaDialog2.html','<md-dialog id="quota-user-dialog" class="form-dialog" aria-label="Odds of occurence"><md-toolbar class="md-accent"><div\n class="md-toolbar-tools" layout="row" layout-align="space-between center"><h1>{{\'GLOBAL.QUOTA_EXCEDED\' |translate}}\n</h1><div class="absolute-right pr-10" layout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog" tranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></div></md-toolbar><md-dialog-content class="mediadialog-content p-24" flex><div \nng-if="vm.user.user_type == 1"><p>\n{{\'GLOBAL.QUOTA_EXCEDED_DESC_1\' | translate:{value1: vm.quota.users_registered, value2: vm.quota.max_allowed_users} }}\n</p></div><div ng-if="vm.user.user_type !== 1"><p>{{\'GLOBAL.QUOTA_EXCEDED_DESC_3\' | translate}}</p></div>\n</md-dialog-content><md-dialog-actions ng-if="vm.user.user_type == 1" layout="row" layout-align="end center" \nclass="grey-100-bg"><md-button translate="GLOBAL.CANCEL" type="button" ng-click="vm.closeDialog()" \nclass="md-raised md-warn" aria-label="Cancel"></md-button><md-button ng-click="vm.saveDialog(true)" \nclass="send-button md-accent md-raised" aria-label="Save" translate="GLOBAL.UPGRADE_PLAN" \ntranslate-attr-aria-label="GLOBAL.UPGRADE_PLAN"></md-button></md-dialog-actions><md-dialog-actions \nng-if="vm.user.user_type != 1" layout="row" layout-align="end center" class="grey-100-bg"><md-button \ntranslate="GLOBAL.CANCEL" type="button" ng-click="vm.closeDialog()" class="md-raised md-warn" aria-label="Cancel">\n</md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/main/dialogs/userQuotaDialog/userQuotaDialogForms.html','<md-dialog id="quota-user-dialog" class="form-dialog" aria-label="Odds of occurence"><md-toolbar class="md-accent"><div\n class="md-toolbar-tools" layout="row" layout-align="space-between center"><h1>{{\'GLOBAL.QUOTA_EXCEDED\' |translate}}\n</h1><div class="absolute-right pr-10" layout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog" tranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></div></md-toolbar><md-dialog-content class="mediadialog-content p-24" flex><div><p>\n{{\'GLOBAL.QUOTA_EXCEDED_FORM\' | translate:{value1: vm.quota.forms_registered, value2: vm.quota.max_allowed_forms} }}\n</p></div></md-dialog-content><md-dialog-actions ng-if="vm.user.user_type == 1" layout="row" layout-align="end center" \nclass="grey-100-bg"><md-button translate="GLOBAL.CANCEL" type="button" ng-click="vm.closeDialog()" \nclass="md-raised md-warn" aria-label="Cancel"></md-button><md-button ng-click="vm.saveDialog(true)" \nclass="send-button md-accent md-raised" aria-label="Save" translate="GLOBAL.UPGRADE_PLAN" \ntranslate-attr-aria-label="GLOBAL.UPGRADE_PLAN"></md-button></md-dialog-actions><md-dialog-actions \nng-if="vm.user.user_type != 1" layout="row" layout-align="end center" class="grey-100-bg"><md-button \ntranslate="GLOBAL.CANCEL" type="button" ng-click="vm.closeDialog()" class="md-raised md-warn" aria-label="Cancel">\n</md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/main/pages/coming-soon/coming-soon.html','<div id="coming-soon" class="flex-scrollable" layout="column" ms-scroll><div id="coming-soon-form-wrapper" \nlayout="column" layout-align="center center"><div id="coming-soon-form" class="md-whiteframe-8dp"><div class="top"><div\n class="logo md-accent-bg"><span>F</span></div><div class="title" translate="COMINGSOON.TITLE">\nHey! Thank you for checking out our app.</div><div class="subtitle" translate="COMINGSOON.SUBTITLE">\nIt\u2019s not quite ready yet, but we are working hard and it will be ready in approximately:</div><timer \nend-time="vm.endTime" layout="row" layout-wrap><div flex-xs="50"><div class="value">{{days}}</div><div class="type" \ntranslate="COMINGSOON.DAYS">days</div></div><div flex-xs="50"><div class="value">{{hours}}</div><div class="type" \ntranslate="COMINGSOON.HOURS">hours</div></div><div flex-xs="50"><div class="value">{{minutes}}</div><div class="type" \ntranslate="COMINGSOON.MINUTES">minutes</div></div><div flex-xs="50"><div class="value">{{seconds}}</div><div \nclass="type" translate="COMINGSOON.SECONDS">seconds</div></div></timer></div><form><div class="message" \ntranslate="COMINGSOON.MESSAGE">\nIf you would like to be notified when the app is ready, you can subscribe to our e-mail list.</div><md-input-container \nflex md-no-float><input type="email" placeholder="Email address" translate \ntranslate-attr-placeholder="COMINGSOON.EMAIL_ADRESS"></md-input-container><md-button class="md-raised md-accent" \naria-label="SUBSCRIBE" translate="COMINGSOON.SUBSCRIBE" translate-attr-aria-label="COMINGSOON.SUBSCRIBE">SUBSCRIBE\n</md-button></form></div></div></div>');
$templateCache.put('app/main/pages/profile/profile.html','<div id="profile" class="page-layout simple tabbed"><div class="header md-accent-bg" layout="column" \nlayout-align="center center" layout-gt-sm="row" layout-align-gt-sm="space-between end"><div class="user-info" \nlayout="column" layout-align="center center" layout-gt-sm="row" layout-align-gt-sm="start center"><img \nclass="profile-image avatar huge" src="assets/images/avatars/katherine.jpg"><div class="name">Katherine Wilson</div>\n</div><div class="actions" layout="row" layout-align="end center"><md-button class="md-raised md-accent" \naria-label="Follow" translate="PROFILE.FOLLOW" translate-attr-aria-label="PROFILE.FOLLOW">Follow</md-button><md-button \nclass="md-raised md-primary" translate="PROFILE.SEND_MESSAGE" translate-attr-aria-label="PROFILE.SEND_MESSAGE">\nSend Message</md-button></div></div><div class="content" flex><md-tabs md-dynamic-height><md-tab><md-tab-label><span \ntranslate="PROFILE.TIMELINE">Timeline</span></md-tab-label><md-tab-body><md-content class="timeline-tab" \nng-include="\'app/main/pages/profile/tabs/timeline/timeline.html\'"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate="PROFILE.ABOUT">About</span></md-tab-label><md-tab-body><md-content class="about-tab" \nng-include="\'app/main/pages/profile/tabs/about/about.html\'"></md-content></md-tab-body></md-tab><md-tab><md-tab-label>\n<span translate="PROFILE.PHOTOS_VIDEOS">Photos & Videos</span></md-tab-label><md-tab-body><md-content \nclass="photos-videos-tab" ng-include="\'app/main/pages/profile/tabs/photos-videos/photos-videos.html\'"></md-content>\n</md-tab-body></md-tab></md-tabs></div></div>');
$templateCache.put('app/main/pages/maintenance/maintenance.html','<div id="maintenance" class="flex-scrollable" layout="column" ms-scroll><div id="maintenance-form-wrapper" \nlayout="column" layout-align="center center"><div id="maintenance-form" class="md-whiteframe-8dp"><div \nclass="logo md-accent-bg"><span>F</span></div><div class="title" translate="MAINTENANCE.TITLE">\nClosed for scheduled maintenance!</div><div class="subtitle" translate="MAINTENANCE.SUBTITLE">\nWe\'re sorry for the inconvenience.<br>Please check back later.</div></div></div></div>');
$templateCache.put('app/main/ui/helper-classes/helper-classes.html','<div id="helper-classes" class="page-layout simple tabbed doc-page" layout="column"><div class="header md-accent-bg" \nlayout="row" layout-align="space-between"><div layout="column" layout-align="center start"><div class="breadcrumb" \nlayout="row" layout-align="start center"><md-icon md-font-icon="icon-home" class="s16"></md-icon><md-icon \nmd-font-icon="icon-chevron-right" class="s16 separator"></md-icon><span class="parent">USER INTERFACE</span></div><div \nclass="title">Helper Classes</div></div></div><div class="content" layout="column"><md-tabs md-dynamic-height><md-tab \nlabel="Padding & Margin Helpers"><div class="md-title">Padding Helpers</div><div class="card md-whiteframe-4dp" \nlayout="column"><div layout="column" layout-gt-md="row"><div class="preview" layout="column" layout-align="center" \nflex><span>no-padding</span></div><hljs lang="html" class="source-code" layout="column" layout-align="center" flex>\n<span class="no-padding">No padding</span></hljs></div><div layout="column" layout-gt-md="row"><div class="preview" \nlayout="column" layout-align="center" flex><div class="md-caption mb-16">Multiples of 5, Max:100</div><span>\npadding-(5x)</span></div><hljs lang="html" class="source-code" layout="column" layout-align="center" flex><span \nclass="padding-5">5px padding</span></hljs></div><div layout="column" layout-gt-md="row"><div class="preview" \nlayout="column" layout-align="center" flex><div class="md-caption mb-16">Multiples of 5, Max:100</div><span>p-(5x)\n</span></div><hljs lang="html" class="source-code" layout="column" layout-align="center" flex><span class="p-15">\n15px padding</span></hljs></div><div layout="column" layout-gt-md="row"><div class="preview" layout="column" \nlayout-align="center" flex><div class="md-caption mb-16">Multiples of 8, Max:96</div><span>padding-(8x)</span></div>\n<hljs lang="html" class="source-code" layout="column" layout-align="center" flex><span class="padding-8">8px padding\n</span></hljs></div><div layout="column" layout-gt-md="row"><div class="preview" layout="column" layout-align="center" \nflex><div class="md-caption mb-16">Multiples of 8, Max:96</div><span>p-(8x)</span></div><hljs lang="html" \nclass="source-code" layout="column" layout-align="center" flex><span class="p-32">32px padding</span></hljs></div>\n</div><div class="md-title">Direction Specific Padding Helpers</div><div class="card md-whiteframe-4dp" \nlayout="column"><div layout="column" layout-gt-md="row"><div class="preview" layout="column" layout-align="center" \nflex><div class="md-caption mb-16">Multiples of 5, Max:100</div><span>padding-top-(5x)</span> <span>padding-right-(5x)\n</span> <span>padding-bottom-(5x)</span> <span>padding-left-(5x)</span> <span>padding-horizontal-(5x)</span> <span>\npadding-vertical-(5x)</span></div><hljs lang="html" class="source-code" layout="column" layout-align="center" flex>\n<span class="padding-top-5">5px from top</span> <span class="padding-right-25">25px from right</span> <span \nclass="padding-bottom-10">10px from bottom</span> <span class="padding-left-20">20px from left</span> <span \nclass="padding-horizontal-5">5px from left and right</span> <span class="padding-vertical-5">5px from top and bottom\n</span></hljs></div><div layout="column" layout-gt-md="row"><div class="preview" layout="column" layout-align="center" \nflex><div class="md-caption mb-16">Multiples of 5, Max:100</div><span>pt-(5x)</span> <span>pr-(5x)</span> <span>pb-(5x)\n</span> <span>pl-(5x)</span> <span>ph-(5x)</span> <span>pv-(5x)</span></div><hljs lang="html" class="source-code" \nlayout="column" layout-align="center" flex><span class="pt-5">5px from top</span> <span class="pr-25">25px from right\n</span> <span class="pb-10">10px from bottom</span> <span class="pl-20">20px from left</span> <span class="ph-5">\n5px from left and right</span> <span class="pv-5">5px from top and bottom</span></hljs></div><div layout="column" \nlayout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><div class="md-caption mb-16">\nMultiples of 8, Max:96</div><span>padding-top-(8x)</span> <span>padding-right-(8x)</span> <span>padding-bottom-(8x)\n</span> <span>padding-left-(8x)</span> <span>padding-horizontal-(8x)</span> <span>padding-vertical-(8x)</span></div>\n<hljs lang="html" class="source-code" layout="column" layout-align="center" flex><span class="padding-top-8">\n8px from top</span> <span class="padding-right-24">24px from right</span> <span class="padding-bottom-16">\n16px from bottom</span> <span class="padding-left-8">8px from left</span> <span class="padding-horizontal-8">\n8px from left and right</span> <span class="padding-vertical-8">8px from top and bottom</span></hljs></div><div \nlayout="column" layout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><div \nclass="md-caption mb-16">Multiples of 8, Max:96</div><span>pt-(8x)</span> <span>pr-(8x)</span> <span>pb-(8x)</span> \n<span>pl-(8x)</span> <span>ph-(8x)</span> <span>pv-(8x)</span></div><hljs lang="html" class="source-code" \nlayout="column" layout-align="center" flex><span class="pt-8">8px from top</span> <span class="pr-24">24px from right\n</span> <span class="pb-16">16px from bottom</span> <span class="pl-8">8px from left</span> <span class="ph-8">\n8px from left and right</span> <span class="pv-8">8px from top and bottom</span></hljs></div></div><div \nclass="md-title">Margin Helpers</div><div class="card md-whiteframe-4dp" layout="column"><div layout="column" \nlayout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><span>no-margin</span></div><hljs \nlang="html" class="source-code" layout="column" layout-align="center" flex><span class="no-margin">No margin</span>\n</hljs></div><div layout="column" layout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex>\n<div class="md-caption mb-16">Multiples of 5, Max:100</div><span>margin-(5x)</span></div><hljs lang="html" \nclass="source-code" layout="column" layout-align="center" flex><span class="margin-5">5px margin</span></hljs></div>\n<div layout="column" layout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><div \nclass="md-caption mb-16">Multiples of 5, Max:100</div><span>m-(5x)</span></div><hljs lang="html" class="source-code" \nlayout="column" layout-align="center" flex><span class="m-15">15px margin</span></hljs></div><div layout="column" \nlayout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><div class="md-caption mb-16">\nMultiples of 8, Max:96</div><span>margin-(8x)</span></div><hljs lang="html" class="source-code" layout="column" \nlayout-align="center" flex><span class="margin-8">8px margin</span></hljs></div><div layout="column" \nlayout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><div class="md-caption mb-16">\nMultiples of 8, Max:96</div><span>m-(8x)</span></div><hljs lang="html" class="source-code" layout="column" \nlayout-align="center" flex><span class="m-32">32px margin</span></hljs></div></div><div class="md-title">\nDirection Specific Margin Helpers</div><div class="card md-whiteframe-4dp" layout="column"><div layout="column" \nlayout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><div class="md-caption mb-16">\nMultiples of 5, Max:100</div><span>margin-top-(5x)</span> <span>margin-right-(5x)</span> <span>margin-bottom-(5x)\n</span> <span>margin-left-(5x)</span> <span>margin-horizontal-(5x)</span> <span>margin-vertical-(5x)</span></div><hljs \nlang="html" class="source-code" layout="column" layout-align="center" flex><span class="margin-top-5">5px from top\n</span> <span class="margin-right-25">25px from right</span> <span class="margin-bottom-10">10px from bottom</span> \n<span class="margin-left-20">20px from left</span> <span class="margin-horizontal-5">5px from left and right</span> \n<span class="margin-vertical-5">5px from top and bottom</span></hljs></div><div layout="column" layout-gt-md="row"><div\n class="preview" layout="column" layout-align="center" flex><div class="md-caption mb-16">Multiples of 5, Max:100</div>\n<span>mt-(5x)</span> <span>mr-(5x)</span> <span>mb-(5x)</span> <span>ml-(5x)</span> <span>mh-(5x)</span> <span>mv-(5x)\n</span></div><hljs lang="html" class="source-code" layout="column" layout-align="center" flex><span class="mt-5">\n5px from top</span> <span class="mr-25">25px from right</span> <span class="mb-10">10px from bottom</span> <span \nclass="ml-20">20px from left</span> <span class="mh-5">5px from left and right</span> <span class="mv-5">\n5px from top and bottom</span></hljs></div><div layout="column" layout-gt-md="row"><div class="preview" \nlayout="column" layout-align="center" flex><div class="md-caption mb-16">Multiples of 8, Max:96</div><span>\nmargin-top-(8x)</span> <span>margin-right-(8x)</span> <span>margin-bottom-(8x)</span> <span>margin-left-(8x)</span> \n<span>margin-horizontal-(8x)</span> <span>margin-vertical-(8x)</span></div><hljs lang="html" class="source-code" \nlayout="column" layout-align="center" flex><span class="margin-top-8">8px from top</span> <span \nclass="margin-right-24">24px from right</span> <span class="margin-bottom-16">16px from bottom</span> <span \nclass="margin-left-8">8px from left</span> <span class="margin-horizontal-8">8px from left and right</span> <span \nclass="margin-vertical-8">8px from top and bottom</span></hljs></div><div layout="column" layout-gt-md="row"><div \nclass="preview" layout="column" layout-align="center" flex><div class="md-caption mb-16">Multiples of 8, Max:96</div>\n<span>mt-(8x)</span> <span>mr-(8x)</span> <span>mb-(8x)</span> <span>ml-(8x)</span> <span>mh-(8x)</span> <span>mv-(8x)\n</span></div><hljs lang="html" class="source-code" layout="column" layout-align="center" flex><span class="mt-8">\n8px from top</span> <span class="mr-24">24px from right</span> <span class="mb-16">16px from bottom</span> <span \nclass="ml-8">8px from left</span> <span class="mh-8">8px from left and right</span> <span class="mv-8">\n8px from top and bottom</span></hljs></div></div></md-tab><md-tab label="Width & Height Helpers"><div class="md-title">\nWidth Helpers</div><div class="card md-whiteframe-4dp" layout="column"><div layout="column" layout-gt-md="row"><div \nclass="preview" layout="column" layout-align="center" flex><div class="md-caption mb-16">Multiples of 5, Max:500</div>\n<span>width-(5x)</span></div><hljs lang="html" class="source-code" layout="column" layout-align="center" flex><span \nclass="width-5">5px fixed width</span></hljs></div><div layout="column" layout-gt-md="row"><div class="preview" \nlayout="column" layout-align="center" flex><div class="md-caption mb-16">Multiples of 5, Max:500</div><span>w-(5x)\n</span></div><hljs lang="html" class="source-code" layout="column" layout-align="center" flex><span class="w-350">\n350px fixed width</span></hljs></div><div layout="column" layout-gt-md="row"><div class="preview" layout="column" \nlayout-align="center" flex><div class="md-caption mb-16">Multiples of 8, Max:800</div><span>width-(8x)</span></div>\n<hljs lang="html" class="source-code" layout="column" layout-align="center" flex><span class="width-8">8px fixed width\n</span></hljs></div><div layout="column" layout-gt-md="row"><div class="preview" layout="column" layout-align="center" \nflex><div class="md-caption mb-16">Multiples of 8, Max:800</div><span>w-(8x)</span></div><hljs lang="html" \nclass="source-code" layout="column" layout-align="center" flex><span class="w-560">560px fixed width</span></hljs>\n</div></div><div class="md-title">Height Helpers</div><div class="card md-whiteframe-4dp" layout="column"><div \nlayout="column" layout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><div \nclass="md-caption mb-16">Multiples of 5, Max:500</div><span>height-(5x)</span></div><hljs lang="html" \nclass="source-code" layout="column" layout-align="center" flex><span class="height-5">5px fixed height</span></hljs>\n</div><div layout="column" layout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><div \nclass="md-caption mb-16">Multiples of 5, Max:500</div><span>h-(5x)</span></div><hljs lang="html" class="source-code" \nlayout="column" layout-align="center" flex><span class="h-350">350px fixed height</span></hljs></div><div \nlayout="column" layout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><div \nclass="md-caption mb-16">Multiples of 8, Max:800</div><span>height-(8x)</span></div><hljs lang="html" \nclass="source-code" layout="column" layout-align="center" flex><span class="height-8">8px fixed height</span></hljs>\n</div><div layout="column" layout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><div \nclass="md-caption mb-16">Multiples of 8, Max:800</div><span>h-(8x)</span></div><hljs lang="html" class="source-code" \nlayout="column" layout-align="center" flex><span class="h-560">560px fixed height</span></hljs></div></div></md-tab>\n<md-tab label="Border Helpers"><div class="md-title">Border Helpers</div><div class="card md-whiteframe-4dp" \nlayout="column"><div layout="column" layout-gt-md="row"><div class="preview" layout="column" layout-align="center" \nflex><span>border</span></div><hljs lang="html" class="source-code" layout="column" layout-align="center" flex><span \nclass="border">Border on all sides</span></hljs></div><div layout="column" layout-gt-md="row"><div class="preview" \nlayout="column" layout-align="center" flex><span>b</span></div><hljs lang="html" class="source-code" layout="column" \nlayout-align="center" flex><span class="b">Border on all sides</span></hljs></div></div><div class="md-title">\nDirection Specific Border Helpers</div><div class="card md-whiteframe-4dp" layout="column"><div layout="column" \nlayout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><span>border-top</span> <span>\nborder-right</span> <span>border-bottom</span> <span>border-left</span> <span>border-horizontal</span> <span>\nborder-vertical</span></div><hljs lang="html" class="source-code" layout="column" layout-align="center" flex><span \nclass="border-top">Border top</span> <span class="border-right">Border right</span> <span class="border-bottom">\nBorder bottom</span> <span class="border-left">Border left</span> <span class="border-horizontal">Border left and right\n</span> <span class="border-vertical">Border top and bottom</span></hljs></div><div layout="column" layout-gt-md="row">\n<div class="preview" layout="column" layout-align="center" flex><span>bt</span> <span>br</span> <span>bb</span> <span>\nbl</span> <span>bh</span> <span>bv</span></div><hljs lang="html" class="source-code" layout="column" \nlayout-align="center" flex><span class="bt">Border top</span> <span class="br">Border right</span> <span class="bb">\nBorder bottom</span> <span class="bl">Border left</span> <span class="bh">Border left and right</span> <span \nclass="bv">Border top and bottom</span></hljs></div></div><div class="md-title">Border Radius Helpers</div><div \nclass="card md-whiteframe-4dp" layout="column"><div layout="column" layout-gt-md="row"><div class="preview" \nlayout="column" layout-align="center" flex><div class="md-caption mb-16">Multiples of 1, Max:12</div><span>brad-*\n</span></div><hljs lang="html" class="source-code" layout="column" layout-align="center" flex><span class="brad-2">\n2px border radius</span> <span class="brad-5">5px border radius</span></hljs></div></div></md-tab></md-tabs></div>\n</div>');
$templateCache.put('app/main/pages/search/search.html','<div id="search" class="page-layout simple tabbed"><div class="header md-accent-bg" layout="row" \nlayout-align="start center"><div class="search" flex layout="row" layout-align="start center"><md-icon \nmd-font-icon="icon-magnify" class="icon search-icon"></md-icon><input class="search-input" ng-model="vm.search" \ntype="text" placeholder="Search.." translate translate-attr-placeholder="SEARCH.SEARCH" flex></div><md-menu \nclass="search-settings" md-position-mode="target-right target"><md-button class="md-icon-button" \nng-click="$mdMenu.open()" aria-label="Search settings" translate translate-attr-aria-label="SEARCH.SEARCH_SETTINGS">\n<md-icon md-menu-origin md-menu-align-target md-font-icon="icon-cog" class="icon s16"></md-icon></md-button>\n<md-menu-content width="3"><md-menu-item><md-button ng-click="vm.dummyFunction()"><p translate="SEARCH.SETTINGS_1">\nSettings 1</p></md-button></md-menu-item><md-menu-item><md-button ng-click="vm.dummyFunction()"><p \ntranslate="SEARCH.SETTINGS_2">Settings 2</p></md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass="content" flex><md-tabs md-dynamic-height><md-tab label="Classic"><md-content class="classic-tab" \nng-include="\'app/main/pages/search/tabs/classic/classic.html\'"></md-content></md-tab><md-tab label="Emails"><md-content\n class="emails-tab" ng-include="\'app/main/pages/search/tabs/emails/emails.html\'"></md-content></md-tab><md-tab \nlabel="Users"><md-content class="users-tab" ng-include="\'app/main/pages/search/tabs/users/users.html\'"></md-content>\n</md-tab><md-tab label="Contacts"><md-content class="contacts-tab" \nng-include="\'app/main/pages/search/tabs/contacts/contacts.html\'"></md-content></md-tab></md-tabs></div></div>');
$templateCache.put('app/main/ui/forms/forms.html','<div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="header md-accent-bg" \nlayout="row" layout-align="space-between"><div layout="column" layout-align="space-between"><div class="breadcrumb" \nlayout="row" layout-align="start center"><md-icon md-font-icon="icon-home" class="s16"></md-icon><md-icon \nmd-font-icon="icon-chevron-right" class="s16 separator"></md-icon><span class="parent">USER INTERFACE</span></div><div \nclass="title">Forms</div></div></div><div class="content" layout="column"><div class="md-title">Stepper</div><div \nclass="pb-16"><b>ms-stepper</b>\n is a custom made form wizard directive. It follows Google\'s Material Design specifications and we recommend you to use it. If for some reason, it\'s not suitable for your project, you can always use the Form Wizard that we put together using md-tabs and forms.\n</div><form name="stepper" ms-stepper ng-submit="vm.submitStepper()" ng-model="vm.stepper" novalidate><ms-stepper-step \nng-form="step1" step="1" step-title="\'Personal Information\'"><div \nng-include="\'app/main/ui/forms/stepper-steps/step-1.html\'"></div></ms-stepper-step><ms-stepper-step ng-form="step2" \nstep="2" step-title="\'Birthplace\'" optional-step hide-step="!MsStepper.model.step1.lastname"><div \nng-include="\'app/main/ui/forms/stepper-steps/step-2.html\'"></div></ms-stepper-step><ms-stepper-step ng-form="step3" \nstep="3" step-title="\'SSN\'" optional-step hide-step="!MsStepper.model.step2.birthplace"><div \nng-include="\'app/main/ui/forms/stepper-steps/step-3.html\'"></div></ms-stepper-step><ms-stepper-step ng-form="step4" \nstep="4" step-title="\'Address\'" optional-step><div ng-include="\'app/main/ui/forms/stepper-steps/step-4.html\'"></div>\n</ms-stepper-step><ms-stepper-step ng-form="step5" step="5" step-title="\'Payment Method\'"><div \nng-include="\'app/main/ui/forms/stepper-steps/step-5.html\'"></div></ms-stepper-step></form><div class="md-title mt-32">\nForm Wizard</div><div class="pb-16">\nForm wizard is a combination of md-tabs and forms that we have created for you. You can have as many steps as you want.\n</div><div layout="row"><ms-form-wizard flex><md-tabs md-dynamic-height md-selected="msWizard.selectedIndex" \nmd-center-tabs="true"><md-tab><md-tab-label><span class="ms-form-wizard-step-label"><span \nclass="ms-form-wizard-step-number md-accent-bg" ng-if="wizardStep1.$invalid">1</span> <span \nclass="ms-form-wizard-step-number md-accent-bg" ng-if="wizardStep1.$valid"><i class="icon-check s16"></i> </span><span \nclass="ms-form-wizard-step-text">Personal Information</span></span></md-tab-label><md-tab-body><form \nname="wizardStep1" class="md-inline-form" ms-form-wizard-form novalidate><div layout="column" layout-gt-xs="row" flex>\n<md-input-container flex="100" flex-gt-xs="50"><input type="text" name="firstname" ng-model="vm.formWizard.firstname" \nplaceholder="Firstname" required><div ng-messages="wizardStep1.firstname.$error" role="alert"><div \nng-message="required"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container \nflex="100" flex-gt-xs="50"><input type="text" name="lastname" ng-model="vm.formWizard.lastname" placeholder="Lastname" \nrequired><div ng-messages="wizardStep1.lastname.$error" role="alert"><div ng-message="required"><span>\nLastname field is required.</span></div></div></md-input-container></div><md-input-container class="md-block"><input \ntype="email" name="email" ng-model="vm.formWizard.email" placeholder="Email" ng-pattern="/^.+@.+\\..+$/" required><div \nng-messages="wizardStep1.email.$error" role="alert" multiple="multiple"><div ng-message="required"><span>\nEmail field is required</span></div><div ng-message="pattern"><span>Email must be a valid e-mail address</span></div>\n</div></md-input-container><div layout="column" layout-gt-sm="row" flex><md-input-container flex="100" flex-gt-xs="50">\n<input type="password" name="password" ng-model="vm.formWizard.password" placeholder="Password" required><div \nng-messages="wizardStep1.password.$error" role="alert"><div ng-message="required"><span>Password field is required.\n</span></div></div></md-input-container><md-input-container flex="100" flex-gt-xs="50"><input type="password" \nname="passwordConfirm" ng-model="vm.formWizard.passwordConfirm" placeholder="Password (Confirm)" required><div \nng-messages="wizardStep1.passwordConfirm.$error" role="alert"><div ng-message="required"><span>\nPassword (Confirm) field is required.</span></div></div></md-input-container></div></form></md-tab-body></md-tab>\n<md-tab ng-disabled="wizardStep1.$invalid"><md-tab-label><span class="ms-form-wizard-step-label"><span \nclass="ms-form-wizard-step-number md-accent-bg" ng-if="wizardStep2.$invalid">2</span> <span \nclass="ms-form-wizard-step-number md-accent-bg" ng-if="wizardStep2.$valid"><i class="icon-check s16"></i> </span><span \nclass="ms-form-wizard-step-text">Address</span></span></md-tab-label><md-tab-body><form name="wizardStep2" \nms-form-wizard-form novalidate><div layout="column" layout-gt-xs="row"><md-input-container flex><label>City</label> \n<input type="text" name="city" ng-model="vm.formWizard.city"></md-input-container><md-input-container flex><label>State\n</label><md-select ng-model="vm.formWizard.state"><md-option ng-repeat="state in vm.states" value="{{state.abbrev}}">\n{{state.abbrev}}</md-option></md-select></md-input-container><md-input-container flex><label>Postal Code</label> <input\n name="postalcode" ng-model="vm.formWizard.postalCode" placeholder="12345" required ng-pattern="/^[0-9]{5}$/" \nmd-maxlength="5"><div ng-messages="wizardStep2.postalcode.$error" role="alert" multiple="multiple"><div \nng-message="required"><span>You must supply a postal code.</span></div><div ng-message="pattern"><span>\nThat doesn\'t look like a valid postal code.</span></div><div ng-message="md-maxlength"><span>\nPostal code can\'t be longer than 5 characters.</span></div></div></md-input-container></div><md-input-container \nclass="md-block"><label>Address</label> <textarea ng-model="vm.formWizard.address" columns="1" md-maxlength="150" \nrows="5" required></textarea><div ng-messages="wizardStep2.address.$error" role="alert" multiple="multiple"><div \nng-message="required"><span>Address field is required.</span></div><div ng-message="md-maxlength"><span>\nAddress can\'t be longer than 150 characters.</span></div></div></md-input-container></form></md-tab-body></md-tab>\n<md-tab ng-disabled="wizardStep1.$invalid || wizardStep2.$invalid"><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" ng-if="wizardStep3.$invalid">3\n</span> <span class="ms-form-wizard-step-number md-accent-bg" ng-if="wizardStep3.$valid"><i class="icon-check s16"></i>\n </span><span class="ms-form-wizard-step-text">Payment Method</span></span></md-tab-label><md-tab-body><form \nname="wizardStep3" ms-form-wizard-form novalidate><md-input-container class="md-block"><input type="text" \nname="cardholder" ng-model="vm.formWizard.cardholder" placeholder="Card Holder" required><div \nng-messages="wizardStep3.cardholder.$error" role="alert"><div ng-message="required"><span>\nCard holder field is required.</span></div></div></md-input-container><div layout="column" layout-gt-xs="row">\n<md-input-container flex="100" flex-gt-xs="33"><input type="text" name="cardnumber" \nng-model="vm.formWizard.cardnumber" placeholder="Card Number" required><div \nng-messages="wizardStep3.cardnumber.$error" role="alert"><div ng-message="required"><span>\nCard number field is required.</span></div></div></md-input-container><md-input-container flex="100" flex-gt-xs="33">\n<input type="text" name="CC2" ng-model="vm.formWizard.cc2" placeholder="CC2" md-maxlength="3" required><div \nng-messages="wizardStep3.cc2.$error" role="alert" multipl><div ng-message="required"><span>CC2 field is required.\n</span></div><div ng-message="md-maxlength"><span>CC2 can\'t be longer than 3 characters.</span></div></div>\n</md-input-container><md-input-container flex="100" flex-gt-xs="33"><input type="text" name="expirationDate" \nng-model="vm.formWizard.expirationDate" placeholder="Expiration Date" required><div \nng-messages="wizardStep3.expirationDate.$error" role="alert"><div ng-message="required"><span>\nExpiration date field is required.</span></div></div></md-input-container></div></form></md-tab-body></md-tab>\n</md-tabs><div class="navigation" flex layout="row" layout-align="center center"><md-button \nclass="md-raised md-accent" ng-click="msWizard.previousStep()" ng-disabled="msWizard.isFirstStep()">Previous\n</md-button><div class="steps"><span ng-repeat="form in msWizard.forms" \nng-class="{\'selected md-accent-bg\':msWizard.selectedIndex === $index}"></span></div><md-button \nclass="md-raised md-accent" ng-click="msWizard.nextStep()" ng-hide="msWizard.isLastStep()" \nng-disabled="msWizard.currentStepInvalid()">Next</md-button><md-button class="md-raised md-warn" \nng-click="vm.sendForm(); msWizard.resetForm();" ng-show="msWizard.isLastStep()" \nng-disabled="msWizard.formsIncomplete()">Send</md-button></div></ms-form-wizard></div><div class="md-title mt-32">\nBasic form with validation</div><div class="pb-16">\nWith this form example, Submit button will only be activated if all the required fields are filled and if there is no error on the form.\n</div><div layout="row"><div class="form-wrapper md-whiteframe-1dp" flex="60"><form name="basicForm" \nclass="md-inline-form" novalidate><div class="form-title">Optional form title</div><div layout="column" \nlayout-gt-sm="row"><md-input-container flex><input type="text" name="firstname" ng-model="vm.basicForm.firstname" \nplaceholder="Firstname" required><div ng-messages="basicForm.firstname.$error" role="alert"><div ng-message="required">\n<span>Firstname field is required.</span></div></div></md-input-container><md-input-container flex><input type="text" \nname="lastname" ng-model="vm.basicForm.lastname" placeholder="Lastname" required><div \nng-messages="basicForm.lastname.$error" role="alert"><div ng-message="required"><span>Lastname field is required.\n</span></div></div></md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label>\nCity</label> <input type="text" name="city" ng-model="vm.basicForm.city"></md-input-container><md-input-container flex>\n<label>State</label><md-select ng-model="vm.basicForm.state"><md-option ng-repeat="state in vm.states" \nvalue="{{state.abbrev}}">{{state.abbrev}}</md-option></md-select></md-input-container><md-input-container flex><label>\nPostal Code</label> <input name="postalcode" ng-model="vm.basicForm.postalCode" placeholder="12345" required \nng-pattern="/^[0-9]{5}$/" md-maxlength="5"><div ng-messages="basicForm.postalcode.$error" role="alert" \nmultiple="multiple"><div ng-message="required"><span>You must supply a postal code.</span></div><div \nng-message="pattern"><span>That doesn\'t look like a valid postal code.</span></div><div ng-message="md-maxlength">\n<span>Postal code can\'t be longer than 5 characters.</span></div></div></md-input-container></div><md-input-container \nclass="md-block"><label>Biography</label> <textarea ng-model="vm.basicForm.biography" columns="1" md-maxlength="150" \nrows="5"></textarea></md-input-container><md-button type="submit" class="md-raised md-accent" aria-label="Submit" \nng-disabled="basicForm.$invalid || basicForm.$pristine">Submit</md-button></form></div><div \nclass="form-wrapper form-data-wrapper md-whiteframe-1dp" flex="40"><div class="form-title">Form ng-model data</div><div\n class="json-data-wrapper"><pre>{{vm.basicForm | json}}</pre></div></div></div></div></div>');
$templateCache.put('app/main/pages/timeline/timeline-left.html','<div id="timeline" class="timeline-left" ms-timeline="vm.timelineOptions" ms-timeline-load-more="vm.loadNextPage()">\n<div ms-timeline-item layout="column" layout-align="center center" layout-gt-md="row" \nlayout-align-gt-md="center start" ng-repeat="timelineItem in vm.timeline"><div \nclass="timeline-point md-accent-bg md-whiteframe-2dp"><md-icon md-font-icon="{{timelineItem.icon}}"></md-icon></div>\n<div class="timeline-detail" flex="50"><div class="time">{{timelineItem.time}}</div><div class="event">\n{{timelineItem.event}}</div></div><div class="timeline-card" layout="row" flex="50"><ms-card \ntemplate="timelineItem.card.template" ng-model="timelineItem.card"></ms-card></div></div></div>');
$templateCache.put('app/main/pages/timeline/timeline-right.html','<div id="timeline" class="timeline-right" ms-timeline="vm.timelineOptions" ms-timeline-load-more="vm.loadNextPage()">\n<div ms-timeline-item layout="column" layout-align="center center" layout-gt-md="row" \nlayout-align-gt-md="center start" ng-repeat="timelineItem in vm.timeline"><div \nclass="timeline-point md-accent-bg md-whiteframe-2dp"><md-icon md-font-icon="{{timelineItem.icon}}"></md-icon></div>\n<div class="timeline-detail" flex="50"><div class="time">{{timelineItem.time}}</div><div class="event">\n{{timelineItem.event}}</div></div><div class="timeline-card" layout="row" flex="50"><ms-card \ntemplate="timelineItem.card.template" ng-model="timelineItem.card"></ms-card></div></div></div>');
$templateCache.put('app/main/pages/timeline/timeline.html','<div id="timeline" ms-timeline="vm.timelineOptions" ms-timeline-load-more="vm.loadNextPage()"><div ms-timeline-item \nlayout="column" layout-align="center center" layout-gt-md="row" layout-align-gt-md="center start" \nng-repeat="timelineItem in vm.timeline"><div class="timeline-point md-accent-bg md-whiteframe-2dp"><md-icon \nmd-font-icon="{{timelineItem.icon}}"></md-icon></div><div class="timeline-detail" flex="50"><div class="time">\n{{timelineItem.time}}</div><div class="event">{{timelineItem.event}}</div></div><div class="timeline-card" \nlayout="row" flex="50"><ms-card template="timelineItem.card.template" ng-model="timelineItem.card"></ms-card></div>\n</div></div>');
$templateCache.put('app/main/ui/icons/icons.html','<div id="icons" class="page-layout simple fullwidth doc-page" layout="column"><div class="header md-accent-bg" \nlayout="row" layout-align="space-between"><div layout="column" layout-align="center start"><div class="breadcrumb" \nlayout="row" layout-align="start center"><md-icon md-font-icon="icon-home" class="s16"></md-icon><md-icon \nmd-font-icon="icon-chevron-right" class="s16 separator"></md-icon><span class="parent">USER INTERFACE</span></div><div \nclass="title">Icons</div></div><div layout="row" layout-align="start center"><md-button \nclass="md-raised reference-button" href="https://materialdesignicons.com/" target="_blank"><md-icon \nmd-font-icon="icon-link"></md-icon><span>Reference</span></md-button></div></div><div class="content" layout="column">\n<div id="icons-list" class="card md-whiteframe-1dp" layout="row" layout-wrap><div class="item" \nng-repeat="icon in ::vm.icons track by icon.properties.id" layout-align="start center"><i \nclass="icon icon-{{::icon.properties.name}} s40"></i><div class="name secondary-text text-center">\nicon-{{::icon.properties.name}}</div></div></div></div></div>');
$templateCache.put('app/main/ui/theme-colors/theme-colors.html','<div id="theme-colors" class="page-layout simple tabbed doc-page" layout="column"><div class="header md-accent-bg" \nlayout="row" layout-align="space-between"><div layout="column" layout-align="center start"><div class="breadcrumb" \nlayout="row" layout-align="start center"><md-icon md-font-icon="icon-home" class="s16"></md-icon><md-icon \nmd-font-icon="icon-chevron-right" class="s16 separator"></md-icon><span class="parent">USER INTERFACE</span></div><div \nclass="title">Theme Colors</div></div><div layout="row" layout-align="start center"><md-button \nclass="md-raised md-warn reference-button" ng-click="vm.createTheme($event);"><md-icon md-font-icon="icon-palette">\n</md-icon><span>Create Your Own Theme!</span></md-button></div></div><div class="content"><md-tabs class="color-tabs" \nmd-dynamic-height md-swipe-content md-stretch-tabs="always"><md-tab label="Primary Color"><md-content \nclass="color-tab" ng-include="\'app/main/ui/theme-colors/tabs/primary/primary.html\'"></md-content></md-tab><md-tab \nlabel="Accent Color"><md-content class="color-tab" ng-include="\'app/main/ui/theme-colors/tabs/accent/accent.html\'">\n</md-content></md-tab><md-tab label="Warn Color"><md-content class="color-tab" \nng-include="\'app/main/ui/theme-colors/tabs/warn/warn.html\'"></md-content></md-tab><md-tab label="Background Color">\n<md-content class="color-tab" ng-include="\'app/main/ui/theme-colors/tabs/background/background.html\'"></md-content>\n</md-tab></md-tabs></div></div>');
$templateCache.put('app/main/ui/material-colors/material-colors.html','<div id="material-colors" class="page-layout simple tabbed doc-page" layout="column"><div class="header md-accent-bg" \nlayout="row" layout-align="space-between"><div layout="column" layout-align="center start"><div class="breadcrumb" \nlayout="row" layout-align="start center"><md-icon md-font-icon="icon-home" class="s16"></md-icon><md-icon \nmd-font-icon="icon-chevron-right" class="s16 separator"></md-icon><span class="parent">USER INTERFACE</span></div><div \nclass="title">Material Colors</div></div><div layout="row" layout-align="start center"><md-button \nclass="md-raised reference-button" href="https://www.google.com/design/spec/style/color.html#color-color-palette" \ntarget="_blank"><md-icon md-font-icon="icon-link"></md-icon><span>Reference</span></md-button></div></div><div \nclass="content"><md-tabs class="color-tabs" md-dynamic-height md-swipe-content><md-tab \nng-repeat="(paletteName, palette) in vm.palettes" \nmd-on-select="vm.selected = paletteName; vm.selectedPalette = palette"><md-tab-label><span class="text-capitalize">\n{{paletteName}}</span></md-tab-label></md-tab></md-tabs><md-content class="color-tab"><div class="h3 pb-16">\nFuse has classes for every single color from <a \nhref="https://www.google.com/design/spec/style/color.html#color-color-palette" target="_blank">\nMaterial Design Color Palette</a>\n for your convenient. You can use them with pretty much every element except Angular Material directives.</div><div \nclass="color-header colored-bg" ng-class="\'md-\'+vm.selected+\'-bg\'" layout="row" layout-align="start start" layout-wrap \nlayout-padding><div flex="100"><h3 class="text-capitalize">{{vm.selected}}</h3></div><div layout="row" \nlayout-align="space-between center" flex="100"><div>500</div><div>\nrgb({{vm.selectedPalette[\'500\'].value[0]}},{{vm.selectedPalette[\'500\'].value[1]}},{{vm.selectedPalette[\'500\'].value[2]}})\n</div></div></div><div class="color" layout="row" layout-wrap layout-align="center center"><div class="colored-bg" \nng-repeat="(hue, hueValue) in vm.selectedPalette" flex="100" layout="row" layout-sm="column" layout-padding \nng-class="vm.selected+\'-\'+hue+\'-bg\'"><div flex>{{hue}}</div><div class="colored-bg" \nng-class="\'md-\'+vm.selected+\'-\'+hue+\'-bg\'" flex>.{{\'md-\'+vm.selected+\'-\'+hue+\'-bg\'}}</div><div flex>\n.{{vm.selected+\'-\'+hue+\'-bg\'}}</div><div class="fg-box white-bg md-whiteframe-2dp" \nng-class="vm.selected+\'-\'+hue+\'-fg\'">.{{vm.selected+\'-\'+hue+\'-fg\'}}</div></div></div></md-content></div></div>');
$templateCache.put('app/main/ui/typography/typography.html','<div id="typography" class="page-layout simple tabbed doc-page" layout="column"><div class="header md-accent-bg" \nlayout="column" layout-align="center start"><div class="breadcrumb" layout="row" layout-align="start center"><md-icon \nmd-font-icon="icon-home" class="s16"></md-icon><md-icon md-font-icon="icon-chevron-right" class="s16 separator">\n</md-icon><span class="parent">USER INTERFACE</span></div><div class="title">Typography</div></div><div \nclass="content"><md-tabs md-dynamic-height><md-tab label="Headings"><div class="md-title">Material design headings\n</div><div class="card md-whiteframe-4dp" layout="column"><div layout="column" layout-gt-md="row"><div class="preview" \nlayout="column" layout-align="center" flex><div class="md-caption secondary-text">112px</div><span \nclass="md-display-4">Display 4</span></div><hljs lang="html" class="source-code" layout="column" layout-align="center" \nflex><span class="md-display-4">Display 4</span></hljs></div><div layout="column" layout-gt-md="row"><div \nclass="preview" layout="column" layout-align="center" flex><div class="md-caption secondary-text">56px</div><span \nclass="md-display-3">Display 3</span></div><hljs lang="html" class="source-code" layout="column" layout-align="center" \nflex><span class="md-display-3">Display 3</span></hljs></div><div layout="column" layout-gt-md="row"><div \nclass="preview" layout="column" layout-align="center" flex><div class="md-caption secondary-text">45px</div><span \nclass="md-display-2">Display 2</span></div><hljs lang="html" class="source-code" layout="column" layout-align="center" \nflex><span class="md-display-2">Display 2</span></hljs></div><div layout="column" layout-gt-md="row"><div \nclass="preview" layout="column" layout-align="center" flex><div class="md-caption secondary-text">34px</div><span \nclass="md-display-1">Display 1</span></div><hljs lang="html" class="source-code" layout="column" layout-align="center" \nflex><span class="md-display-1">Display 1</span></hljs></div><div layout="column" layout-gt-md="row"><div \nclass="preview" layout="column" layout-align="center" flex><div class="md-caption secondary-text">24px</div><span \nclass="md-headline">Headline</span></div><hljs lang="html" class="source-code" layout="column" layout-align="center" \nflex><span class="md-headline">Headline</span></hljs></div><div layout="column" layout-gt-md="row"><div \nclass="preview" layout="column" layout-align="center" flex><div class="md-caption secondary-text">20px</div><span \nclass="md-title">Title</span></div><hljs lang="html" class="source-code" layout="column" layout-align="center" flex>\n<span class="md-title">Title</span></hljs></div><div layout="column" layout-gt-md="row"><div class="preview" \nlayout="column" layout-align="center" flex><div class="md-caption secondary-text">16px</div><span class="md-subhead">\nSubhead</span></div><hljs lang="html" class="source-code" layout="column" layout-align="center" flex><span \nclass="md-subhead">Subhead</span></hljs></div></div><div class="md-title">Headings</div><div \nclass="card md-whiteframe-4dp" layout="column"><div layout="column" layout-gt-md="row"><div class="preview" \nlayout="column" layout-align="center" flex><div class="md-caption secondary-text">24px</div><h1>Heading 1</h1></div>\n<hljs lang="html" class="source-code" layout="column" layout-align="center" flex><h1>Heading 1</h1><div class="h1">\nHeading 1</div></hljs></div><div layout="column" layout-gt-md="row"><div class="preview" layout="column" \nlayout-align="center" flex><div class="md-caption secondary-text">20px</div><h2>Heading 2</h2></div><hljs lang="html" \nclass="source-code" layout="column" layout-align="center" flex><h2>Heading 2</h2><div class="h2">Heading 2</div></hljs>\n</div><div layout="column" layout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><div \nclass="md-caption secondary-text">16px</div><h3>Heading 3</h3></div><hljs lang="html" class="source-code" \nlayout="column" layout-align="center" flex><h3>Heading 3</h3><div class="h3">Heading 3</div></hljs></div><div \nlayout="column" layout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><div \nclass="md-caption secondary-text">14px</div><h4>Heading 4</h4></div><hljs lang="html" class="source-code" \nlayout="column" layout-align="center" flex><h4>Heading 4</h4><div class="h4">Heading 4</div></hljs></div><div \nlayout="column" layout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><div \nclass="md-caption secondary-text">13px</div><h5>Heading 5</h5></div><hljs lang="html" class="source-code" \nlayout="column" layout-align="center" flex><h5>Heading 5</h5><div class="h5">Heading 5</div></hljs></div><div \nlayout="column" layout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><div \nclass="md-caption secondary-text">12px</div><h6>Heading 6</h6></div><hljs lang="html" class="source-code" \nlayout="column" layout-align="center" flex><h6>Heading 6</h6><div class="h6">Heading 6</div></hljs></div></div>\n</md-tab><md-tab label="Inline Text Elements"><div class="card md-whiteframe-4dp" layout="column"><div layout="column" \nlayout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><span><abbr \ntitle="Cascaded Style Sheet">CSS</abbr></span></div><hljs lang="html" class="source-code" layout="column" \nlayout-align="center" flex ms-scroll><abbr title="Cascaded Style Sheet">CSS</abbr></hljs></div><div layout="column" \nlayout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><span>This is a <mark>marked</mark>\n text.</span></div><hljs lang="html" class="source-code" layout="column" layout-align="center" flex ms-scroll>\nThis is a <mark>marked</mark> text.</hljs></div><div layout="column" layout-gt-md="row"><div class="preview" \nlayout="column" layout-align="center" flex><span><del>This is a deleted text.</del></span></div><hljs lang="html" \nclass="source-code" layout="column" layout-align="center" flex ms-scroll><del>This is a deleted text.</del></hljs>\n</div><div layout="column" layout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><span><s>\nThis is a strike-through text.</s></span></div><hljs lang="html" class="source-code" layout="column" \nlayout-align="center" flex ms-scroll><s>This is a strike-through text.</s></hljs></div><div layout="column" \nlayout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><span><u>This is an underlined text.\n</u></span></div><hljs lang="html" class="source-code" layout="column" layout-align="center" flex ms-scroll><u>\nThis is an underlined text.</u></hljs></div><div layout="column" layout-gt-md="row"><div class="preview" \nlayout="column" layout-align="center" flex><span><small>This is a small text.</small></span></div><hljs lang="html" \nclass="source-code" layout="column" layout-align="center" flex ms-scroll><small>This is a small text.</small></hljs>\n</div><div layout="column" layout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><span>\n<strong>This is a strong text.</strong></span></div><hljs lang="html" class="source-code" layout="column" \nlayout-align="center" flex ms-scrollx><strong>This is a strong text.</strong></hljs></div><div layout="column" \nlayout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><span><em>This is an italic text.\n</em></span></div><hljs lang="html" class="source-code" layout="column" layout-align="center" flex ms-scroll><em>\nThis is an italic text.</em></hljs></div><div layout="column" layout-gt-md="row"><div class="preview" layout="column" \nlayout-align="center" flex><span>This is a <span class="text-super">super</span> text.</span></div><hljs lang="html" \nclass="source-code" layout="column" layout-align="center" flex ms-scroll>This is a <span class="text-super">super\n</span> text.</hljs></div><div layout="column" layout-gt-md="row"><div class="preview" layout="column" \nlayout-align="center" flex><span>This is a <span class="text-sub">sub</span> text.</span></div><hljs lang="html" \nclass="source-code" layout="column" layout-align="center" flex ms-scroll>This is a <span class="text-sub">sub</span>\n text.</hljs></div><div layout="column" layout-gt-md="row"><div class="preview" layout="column" layout-align="center" \nflex><span>This is a <span class="text-capitalize">capitalized</span> text.</span></div><hljs lang="html" \nclass="source-code" layout="column" layout-align="center" flex ms-scroll>This is a <span class="text-capitalized">\ncapitalized</span> text.</hljs></div><div layout="column" layout-gt-md="row"><div class="preview" layout="column" \nlayout-align="center" flex><span>This is an <span class="text-uppercase">uppercase</span> text.</span></div><hljs \nlang="html" class="source-code" layout="column" layout-align="center" flex ms-scroll>This is an <span \nclass="text-uppercase">uppercase</span> text.</hljs></div><div layout="column" layout-gt-md="row"><div class="preview" \nlayout="column" layout-align="center" flex><span>This is a <span class="text-lowercase">LOWERCASE</span> text.</span>\n</div><hljs lang="html" class="source-code" layout="column" layout-align="center" flex ms-scroll>This is a <span \nclass="text-lowercase">LOWERCASE</span> text.</hljs></div></div></md-tab><md-tab label="Blockquotes & Lists"><div \nclass="md-title">Blockquotes</div><div class="card md-whiteframe-4dp" layout="column"><div layout="column" \nlayout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><blockquote><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment.</p></blockquote></div><hljs \nlang="html" class="source-code" layout="column" layout-align="center" flex ms-scroll><blockquote><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment.</p></blockquote></hljs></div><div \nlayout="column" layout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><blockquote><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment.</p><footer>John Doe</footer>\n</blockquote></div><hljs lang="html" class="source-code" layout="column" layout-align="center" flex ms-scroll>\n<blockquote><p>The bedding was hardly able to cover it and seemed ready to slide off any moment.</p><footer>John Doe\n</footer></blockquote></hljs></div><div layout="column" layout-gt-md="row"><div class="preview" layout="column" \nlayout-align="center" flex><blockquote class="reverse"><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment.</p><footer>John Doe</footer>\n</blockquote></div><hljs lang="html" class="source-code" layout="column" layout-align="center" flex ms-scroll>\n<blockquote class="reverse"><p>The bedding was hardly able to cover it and seemed ready to slide off any moment.</p>\n<footer>John Doe</footer></blockquote></hljs></div></div><div class="md-title">Lists</div><div \nclass="card md-whiteframe-4dp" layout="column"><div layout="column" layout-gt-md="row"><div class="preview" \nlayout="column" layout-align="center" flex><ol><li>Ordered list item</li><li>Ordered list item<ol><li>Ordered list item\n</li><li>Ordered list item</li></ol></li><li>Ordered list item</li><li>Ordered list item</li></ol></div><hljs \nlang="html" class="source-code" layout="column" layout-align="center" flex ms-scroll><ol><li>Ordered list item</li><li>\nOrdered list item<ol><li>Ordered list item</li><li>Ordered list item</li></ol></li><li>Ordered list item</li><li>\nOrdered list item</li></ol></hljs></div><div layout="column" layout-gt-md="row"><div class="preview" layout="column" \nlayout-align="center" flex><ul><li>Unordered list item</li><li>Unordered list item<ul><li>Unordered list item</li><li>\nUnordered list item</li></ul></li><li>Unordered list item</li><li>Unordered list item</li></ul></div><hljs lang="html" \nclass="source-code" layout="column" layout-align="center" flex ms-scroll><ul><li>Unordered list item</li><li>\nUnordered list item<ul><li>Unordered list item</li><li>Unordered list item</li></ul></li><li>Unordered list item</li>\n<li>Unordered list item</li></ul></hljs></div></div><div class="md-title">Definition lists</div><div \nclass="card md-whiteframe-4dp" layout="column"><div layout="column" layout-gt-md="row"><div class="preview" \nlayout="column" layout-align="center" flex><dl><dt>Definition term</dt><dd>This is the definition description</dd><dt>\nAnother definition term</dt><dd>This is also another definition description</dd></dl></div><hljs lang="html" \nclass="source-code" layout="column" layout-align="center" flex ms-scroll><dl><dt>Definition term</dt><dd>\nThis is the definition description</dd><dt>Another definition term</dt><dd>This is also another definition description\n</dd></dl></hljs></div></div></md-tab><md-tab label="Helpers"><div class="md-title">Font weight</div><div \nclass="card md-whiteframe-4dp" layout="column"><div layout="column" layout-gt-md="row"><div class="preview" \nlayout="column" layout-align="center" flex><div class="md-caption mb-16">From 100 to 900</div><span \nclass="font-weight-100">font-weight: 100</span> <span>...</span> <span class="font-weight-900">font-weight: 900</span>\n</div><hljs lang="html" class="source-code" layout="column" layout-align="center" flex ms-scroll><span \nclass="font-weight-100">100 font weight</span> ... <span class="font-weight-900">900 font weight</span></hljs></div>\n</div><div class="md-title">Font Size</div><div class="card md-whiteframe-4dp" layout="column"><div layout="column" \nlayout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><div class="md-caption mb-16">\nMultiplies of 2, max: 120</div><span class="font-size-20">font-size: 20</span></div><hljs lang="html" \nclass="source-code" layout="column" layout-align="center" flex ms-scroll><span class="font-size-20">font-size: 20\n</span></hljs></div></div><div class="md-title">Line Height</div><div class="card md-whiteframe-4dp" layout="column">\n<div layout="column" layout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><div \nclass="md-caption mb-16">Multiplies of 2, max: 120</div><span>line-height: 2</span> <span>...</span> <span>\nline-height: 120</span></div><hljs lang="html" class="source-code" layout="column" layout-align="center" flex \nms-scroll><span class="line-height-2">2px line height</span> ... <span class="line-height-120">120px line height</span>\n</hljs></div></div><div class="md-title">Other helpers</div><div class="card md-whiteframe-4dp" layout="column"><div \nlayout="column" layout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><div \nclass="text-left">Left aligned text</div></div><hljs lang="html" class="source-code" layout="column" \nlayout-align="center" flex ms-scroll><div class="text-left">Left aligned text</div></hljs></div><div layout="column" \nlayout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><div class="text-center">\nCenter aligned text</div></div><hljs lang="html" class="source-code" layout="column" layout-align="center" flex \nms-scroll><div class="text-center">Center aligned text</div></hljs></div><div layout="column" layout-gt-md="row"><div \nclass="preview" layout="column" layout-align="center" flex><div class="text-right">Right aligned text</div></div><hljs \nlang="html" class="source-code" layout="column" layout-align="center" flex ms-scroll><div class="text-right">\nRight aligned text</div></hljs></div><div layout="column" layout-gt-md="row"><div class="preview" layout="column" \nlayout-align="center" flex><p><span class="text-boxed">Boxed text</span></p></div><hljs lang="html" \nclass="source-code" layout="column" layout-align="center" flex ms-scroll><p><span class="text-boxed">Boxed text</span>\n</p></hljs></div><div layout="column" layout-gt-md="row"><div class="preview md-grey-700-bg" layout="column" \nlayout-align="center" flex><p><span class="text-boxed-light">Boxed text light</span></p></div><hljs lang="html" \nclass="source-code" layout="column" layout-align="center" flex ms-scroll><p><span class="text-boxed-light">\nBoxed text light</span></p></hljs></div><div layout="column" layout-gt-md="row"><div class="preview" layout="column" \nlayout-align="center" flex><p><span class="text-strike">Strike-through text</span></p></div><hljs lang="html" \nclass="source-code" layout="column" layout-align="center" flex ms-scroll><p><span class="text-strike">\nStrike-through text</span></p></hljs></div><div layout="column" layout-gt-md="row"><div class="preview" \nlayout="column" layout-align="center" flex><div class="text-italic">Italic text</div></div><hljs lang="html" \nclass="source-code" layout="column" layout-align="center" flex ms-scroll><div class="text-italic">Italic text</div>\n</hljs></div><div layout="column" layout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex>\n<div class="text-semibold">Semi-bold text</div></div><hljs lang="html" class="source-code" layout="column" \nlayout-align="center" flex ms-scroll><div class="text-semibold">Semi-bold text</div></hljs></div><div layout="column" \nlayout-gt-md="row"><div class="preview" layout="column" layout-align="center" flex><div class="text-bold">Bold text\n</div></div><hljs lang="html" class="source-code" layout="column" layout-align="center" flex ms-scroll><div \nclass="text-bold">Bold text</div></hljs></div><div layout="column" layout-gt-md="row"><div class="preview" \nlayout="column" layout-align="center" flex><span class="text-truncate">\nThis is a truncated text. It will be truncated if it\'s too long. Vivamus convallis dui porta massa fermentum dictum. Aenean mollis molestie felis, ut interdum ex vehicula a.\n</span></div><hljs lang="html" class="source-code" layout="column" layout-align="center" flex ms-scroll><span \nclass="text-truncate">\nThis is a truncated text. It will be truncated if it\'s too long. Vivamus convallis dui porta massa fermentum dictum. Aenean mollis molestie felis, ut interdum ex vehicula a.\n</span></hljs></div></div></md-tab></md-tabs></div></div>');
$templateCache.put('app/navigation/layouts/vertical-navigation/navigation.html','<md-toolbar class="navigation-header md-whiteframe-1dp" layout="row" layout-align="space-between center" \nng-style="{\'background-color\' : \'{{vm.branding.navBackgroundLogoColor ? vm.branding.navBackgroundLogoColor : vm.branding.sidenav}}\',  \'border-bottom\': \'6px solid {{vm.branding.navigationColorBorder}}\'}">\n<div class="logo" layout="row" layout-align="start center"><a class="logo-image" ng-href="/"><img \nng-src="{{vm.branding.logo}}" class="image" alt="H2C"> </a><span class="logo-text"><img ng-if="vm.branding.sublogo" \nng-src="{{vm.branding.sublogo}}" class="image" alt="H2C"></span></div><md-icon \nng-style="{\'color\' : \'{{vm.branding.navIconcollapseColor ? vm.branding.navIconcollapseColor : \'#ffffff\'}}\'}" \nclass="fold-toggle s18" md-font-icon="icon-backburger" hide show-gt-sm ng-click="vm.toggleMsNavigationFolded()">\n</md-icon></md-toolbar><ms-navigation class="scrollable" folded="vm.folded == \'folded\'" ms-scroll="vm.msScrollOptions">\n</ms-navigation>');
$templateCache.put('app/navigation/layouts/horizontal-navigation/navigation.html','<div layout="row" layout-align="start center"><ms-navigation-horizontal></ms-navigation-horizontal></div>');
$templateCache.put('app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html','<ms-navigation class="scrollable" folded="vm.folded" ms-scroll="vm.msScrollOptions"></ms-navigation>');
$templateCache.put('app/main/public/logout/logout.html','<div id="login-v2" layout="row" layout-align="start"><div id="login-v2-intro" flex hide show-gt-sm><div \nclass="logo md-accent-bg"><span>Q</span></div><div class="title" translate="LOGIN_V2.INTRO_TITLE">\nWelcome to the New QiuSystem!</div><div class="description" translate="LOGIN_V2.INTRO_DESCRIPTION">\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ullamcorper nisl erat, vel convallis elit fermentum pellentesque. Sed mollis velit facilisis facilisis viverra.\n</div></div><div id="login-v2-form-wrapper" class="flex-scrollable md-whiteframe-8dp" ms-scroll><div \nid="login-v2-form"><div class="logo md-accent-bg" hide-gt-sm><span>Q</span></div><div class="title" \ntranslate="LOGIN_V2.TITLE">Log in to your account</div><div class="description" translate="LOGIN_V2.DESCRIPTION">\nSed mollis velit facilisis facilisis viverra</div><form name="loginForm" novalidate ng-submit="login()">\n<md-input-container class="md-block" md-no-float><input type="email" name="email" ng-model="vm.form.email" \nplaceholder="Email" translate translate-attr-placeholder="LOGIN_V2.EMAIL" ng-pattern="/^.+@.+\\..+$/" required><div \nng-messages="loginForm.email.$error" role="alert" multiple="multiple"><div ng-message="required"><span \ntranslate="LOGIN_V2.ERRORS.EMAIL_REQUIRED">Email field is required</span></div><div ng-message="pattern"><span \ntranslate="LOGIN_V2.ERRORS.EMAIL_MUST_VALID">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-input-container class="md-block" md-no-float><input type="password" name="password" \nng-model="vm.form.password" placeholder="Password" translate translate-attr-placeholder="LOGIN_V2.PASSWORD" required>\n<div ng-messages="loginForm.password.$error" role="alert"><div ng-message="required"><span \ntranslate="LOGIN_V2.ERRORS.PASSWORD_REQUIRED">Password field is required</span></div></div></md-input-container><div \nclass="remember-forgot-password" layout="row" layout-sm="column" layout-align="space-between center"><md-checkbox \nclass="remember-me" ng-model="data.cb1" aria-label="Remember Me"><span translate="LOGIN_V2.REMEMBER_ME">Remember Me\n</span></md-checkbox><a ui-sref="app.pages_auth_forgot-password" class="forgot-password md-accent-color" \ntranslate="LOGIN_V2.FORGOT_PASSWORD">Forgot Password?</a></div><md-button type="submit" \nclass="md-raised md-accent submit-button" aria-label="LOG IN" ng-disabled="loginForm.$invalid || loginForm.$pristine" \ntranslate="LOGIN_V2.LOG_IN" translate-attr-aria-label="LOGIN_V2.LOG_IN">LOG IN</md-button></form><div \nclass="separator"><span class="text" translate="LOGIN_V2.OR">OR</span></div><div layout="column" \nlayout-align="start center"><md-button class="md-raised google"><div layout="row" layout-align="center center"><span>\n<md-icon md-font-icon="icon-google-plus" class="s16"></md-icon><span translate="LOGIN_V2.WITH_GOOGLE">\nLog in with Google</span></span></div></md-button></div></div></div></div>');
$templateCache.put('app/quick-panel/tabs/today/today-tab.html','<md-list class="date"><md-subheader class="md-no-sticky"><span translate="QUICKPANEL.TODAY">Today</span></md-subheader>\n<md-list-item class="md-display-1 md-2-line" layout="column" layout-align="start start"><div class="secondary-text">\n<div>{{vm.date | date:\'EEEE\'}}</div><div layout="row" layout-align="start start"><span>{{vm.date | date:\'d\'}}</span> \n<span class="md-subhead">th</span> <span>{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list>\n<md-divider></md-divider><md-list><md-subheader class="md-no-sticky"><span translate="QUICKPANEL.EVENTS">Events</span>\n</md-subheader><md-list-item class="md-2-line" ng-repeat="event in vm.events" ng-click="dummyFunction()"><div \nclass="md-list-item-text"><h3>{{event.title}}</h3><p>{{event.detail}}</p></div></md-list-item></md-list><md-divider>\n</md-divider><md-list><md-subheader class="md-no-sticky"><span translate="QUICKPANEL.NOTES">Notes</span></md-subheader>\n<md-list-item class="md-2-line" ng-repeat="note in vm.notes" ng-click="dummyFunction()"><div class="md-list-item-text">\n<h3>{{note.title}}</h3><p>{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list>\n<md-subheader class="md-no-sticky"><span translate="QUICKPANEL.QUICK_SETTINGS">Quick Settings</span></md-subheader>\n<md-list-item><h3 translate="QUICKPANEL.NOTIFICATIONS">Notifications</h3><md-switch class="md-secondary" \nng-model="vm.settings.notify" aria-label="Notifications" translate \ntranslate-attr-aria-label="QUICKPANEL.NOTIFICATIONS"></md-switch></md-list-item><md-list-item><h3 \ntranslate="QUICKPANEL.CLOUD_SYNC">Cloud Sync</h3><md-switch class="md-secondary" ng-model="vm.settings.cloud" \naria-label="Cloud Sync" translate translate-attr-aria-label="QUICKPANEL.CLOUD_SYNC"></md-switch></md-list-item>\n<md-list-item><h3 translate="QUICKPANEL.RETRO_THRUSTERS">Retro Thrusters</h3><md-switch class="md-secondary md-warn" \nng-model="vm.settings.retro" aria-label="Retro Thrusters" translate \ntranslate-attr-aria-label="QUICKPANEL.RETRO_THRUSTERS"></md-switch></md-list-item></md-list>');
$templateCache.put('app/quick-panel/tabs/activity/activity-tab.html','<md-list class="friends"><md-subheader class="md-no-sticky"><span translate="QUICKPANEL.FRIENDS">Friends</span>\n</md-subheader><md-list-item class="friend md-3-line" ng-repeat="friend in vm.activities.friends"><img \nng-src="{{friend.avatar}}" class="md-avatar" alt="{{friend.name}}"><div class="status {{friend.status}}"></div><div \nng-if="contact.unread" class="md-accent-bg unread-message-count">{{contact.unread}}</div><div \nclass="md-list-item-text"><h3 class="message">{{friend.message}}</h3><p class="time">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class="servers"><md-subheader class="md-no-sticky"><span \ntranslate="QUICKPANEL.APP_SERVERS">Application Servers</span></md-subheader><md-list-item class="server md-3-line" \nng-repeat="server in vm.activities.servers"><md-icon md-font-icon="icon-checkbox-blank-circle" class="s16 status" \nng-class="server.status"></md-icon><div class="md-list-item-text"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class="stats"><md-subheader class="md-no-sticky"><span\n translate="QUICKPANEL.USER_STATS">User Stats</span></md-subheader><md-list-item class="stat md-2-line" \nng-repeat="stat in vm.activities.stats"><div class="md-list-item-text"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class="stat.status" \nmd-mode="determinate" value="{{stat.percent}}"></md-progress-linear></div></md-list-item></md-list>');
$templateCache.put('app/quick-panel/tabs/chat/chat-tab.html','<div class="main animate-slide-left" ng-hide="vm.chatActive"><md-list class="recent"><md-subheader \nclass="md-no-sticky"><span translate="QUICKPANEL.RECENT">Recent</span></md-subheader><md-list-item \nclass="contact md-3-line" ng-repeat="contact in vm.contacts.recent" ng-click="vm.toggleChat(contact)"><img \nng-src="{{contact.avatar}}" class="md-avatar" alt="{{contact.name}}"><div class="status {{contact.status}}"></div><div \nng-if="contact.unread" class="md-accent-bg unread-message-count">{{contact.unread}}</div><div \nclass="md-list-item-text"><h3>{{contact.name}}</h3><p class="last-message">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class="all"><md-subheader class="md-no-sticky"><span \ntranslate="QUICKPANEL.START_NEW_CHAT">Start New Chat</span></md-subheader><md-list-item class="contact" \nng-repeat="contact in vm.contacts.all" ng-click="vm.toggleChat(contact)"><img ng-src="{{contact.avatar}}" \nclass="md-avatar" alt="{{contact.name}}"><div class="status {{contact.status}}"></div><div class="md-list-item-text">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass="chat animate-slide-right" ng-show="vm.chatActive" layout="column"><md-toolbar class="md-accent"><div \nclass="md-toolbar-tools" layout="row" layout-align="space-between center"><div layout="row" \nlayout-align="start center"><md-button class="md-icon-button" ng-click="vm.toggleChat()" aria-label="Back" translate \ntranslate-attr-aria-label="QUICKPANEL.BACK"><md-icon md-font-icon="icon-keyboard-backspace"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout="row" layout-align="end center"><md-button \nclass="md-icon-button" aria-label="Call" translate translate-attr-aria-label="QUICKPANEL.CALL"><md-icon \nmd-font-icon="icon-phone"></md-icon></md-button><md-button class="md-icon-button" aria-label="More" translate \ntranslate-attr-aria-label="QUICKPANEL.MORE"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id="chat-dialog"><div layout="row" \nng-repeat="dialog in vm.chat.contact.dialog" class="md-padding message-row" ng-class="dialog.who"><img \nng-if="dialog.who ===\'contact\'" ng-src="{{vm.chat.contact.avatar}}" class="avatar" alt="{{vm.chat.contact.name}}"> <img\n ng-if="dialog.who ===\'user\'" class="avatar" src="assets/images/avatars/profile.jpg"><div class="bubble" flex><div \nclass="message">{{dialog.message}}</div><div class="time secondary-text">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit="vm.reply()" layout="row" class="reply" layout-align="start center"><textarea \nng-keyup="$event.keyCode == 13 ? vm.reply() : null" flex ng-model="vm.replyMessage" \nplaceholder="Type and hit enter to send message" translate translate-attr-placeholder="QUICKPANEL.REPLY_PLACEHOLDER">\n</textarea><md-button class="md-fab" type="submit" aria-label="Send message" translate \ntranslate-attr-aria-label="QUICKPANEL.SEND_MESSAGE"><md-icon md-font-icon="icon-send"></md-icon></md-button></form>\n</div>');
$templateCache.put('app/toolbar/dialogs/stripe-checkout/stripe-checkout.html','<md-dialog class="stripe-checkout" aria-label="Stripe Embedded Checkout"><md-toolbar class="stripe-toolbar"><div \nclass="md-toolbar-tools"><h2>{{\'TOOLBAR.ADD_LICENCES\' | translate}}</h2><span flex></span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog()"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout-padding><div id="stripe-embedded-checkout" style="min-height: 400px;">\n</div></div></md-dialog-content></md-dialog>');
$templateCache.put('app/toolbar/dialogs/change-password/change-password.html','<md-dialog class="change-password" ng-controller="UsersController as vm"><form style="height: 100%;" name="taskForm" \nclass="md-inline-form" novalidate><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between"><h1 class="title">{{\'TOOLBAR.CHANGE_PASS\' | translate}}</h1><md-button \nclass="md-icon-button" ng-click="vm.closePassword()"><md-icon md-font-icon="icon-close" aria-label="Close dialog" \nstyle="margin-top: 10px;"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class="p-15"><div \nng-if="vm.userLogued.user_type == 1 || vm.userLogued.user_type != 1" class="md-block"><div \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media image-container" flex layout="row" \nlayout-align="center center" style="position: relative;"><img ng-if="vm.files.length > 0" \nngf-thumbnail="!vm.files[0].$error && vm.files[0]" class="image" \nstyle="width: 100px; height: 100px; border-radius: 50%; object-fit: cover;"> <img \nng-if="vm.files.length === 0 && vm.userLogued.files.url" ng-src="{{storagePrefix + vm.userLogued.files.url}}" \nalt="User Image" style="width: 100px; height: 100px; border-radius: 50%; object-fit: cover;" \nclass="image original-image"> <img ng-if="vm.files.length === 0 && !vm.userLogued.files.url" \nsrc="assets/images/avatars/profile.jpg" alt="Default Image" \nstyle="width: 100px; height: 100px; border-radius: 50%; object-fit: cover;" class="image default-image"><md-button \nclass="md-icon-button delete-btn" \nng-click="vm.files.length > 0 ? vm.hiddenAvatarUserLogued(vm.files[0]) : vm.deleteAvatarUserLogued(vm.userLogued.files)" \naria-label="Delete Image"><md-icon md-font-icon="icon-delete" class="md-default-theme md-font material-icons">\n</md-icon></md-button></div></div></div><div><div ngf-drop ngf-select ng-model="vm.files" class="drop-box" \nngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" accept="image/*" ngf-pattern="\'image/*\'" \nstyle="border-radius: 10px;"><div layout="column"><div flex translate="TOOLBAR.DROP_HERE">Drop here or click to upload\n</div><div flex translate="GLOBAL.OR"></div><div flex><md-button class="send-button md-accent md-raised" \naria-label="Select files" translate="TOOLBAR.SELECT_FILES"></md-button></div></div></div><div ngf-no-file-drop \ntranslate="GLOBAL.FILE_DRAG_DROP"></div></div></div><br><br><md-input-container style="min-width: 300px" \nclass="md-block" flex-gt-sm><label>{{ \'STAFF.FIRSTNAME\' | translate }}</label> <input type="input" name="first_name" \nng-model="vm.userLogued.first_name"></md-input-container><md-input-container style="min-width: 300px" class="md-block" \nflex-gt-sm><label>{{ \'STAFF.LASTNAME\' | translate }}</label> <input type="input" name="last_name" \nng-model="vm.userLogued.last_name"></md-input-container><md-input-container style="min-width: 300px" class="md-block" \nflex-gt-sm><label>{{ \'STAFF.PASSWORD\' | translate }}</label> <input type="password" name="password" \nng-model="vm.password" autocomplete="new-password" required><div ng-messages="passwordForm.password.$error" \nrole="alert" class="form-errors first-name-error"><div ng-if="passwordForm.$dirty && !vm.password">\n{{ \'TOOLBAR.PASSWORD_REQUIRED\' | translate }}</div><div ng-if="vm.password && vm.password.length < 6">\n{{ \'TOOLBAR.PASSWORD_MIN_LENGTH\' | translate }}</div><div ng-if="vm.password && !vm.containsNumber()">\n{{ \'TOOLBAR.PASSWORD_MUST_CONTAIN_NUMBER\' | translate }}</div><div \nng-if="vm.password && !vm.containUpperCaseAndLowerCase()">{{ \'TOOLBAR.PASSWORD_MUST_CONTAIN_UPPER_LOWER\' | translate }}\n</div></div></md-input-container><md-input-container style="min-width: 300px" class="md-block" flex-gt-sm><label>\n{{ \'TOOLBAR.CONFIRM_PASSWORD\' | translate }}</label> <input type="password" name="confirm_password" \nng-model="vm.confirm_password" autocomplete="new-password" required><div \nng-messages="passwordForm.confirm_password.$error" role="alert" class="form-errors first-name-error"><div \nng-if="vm.password !== vm.confirm_password">{{ \'TOOLBAR.PASSWORD_MISMATCH\' | translate }}</div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout="row" layout-align="space-between center"><div\n flex layout="row" layout-align="end center"><md-button type="button" class="md-raised md-warn" \nng-click="vm.closePassword()" translate="CANCELAR">Cancelar</md-button><md-button \nng-disabled="vm.password !== vm.confirm_password || vm.password.length < 6 || !vm.containsNumber() || !vm.containUpperCaseAndLowerCase()" \nng-click="vm.saveUser()" class="send-button md-accent md-raised" aria-label="save">{{ \'GUARDAR\' | translate }}\n</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/toolbar/layouts/horizontal-navigation/toolbar.html','<div layout="row" layout-align="space-between center"><div layout="row" layout-align="start center"><div \nclass="navigation-toggle" hide-gt-sm><md-button class="md-icon-button" ng-click="vm.toggleHorizontalMobileMenu()" \naria-label="Toggle Mobile Navigation"><md-icon md-font-icon="icon-menu"></md-icon></md-button></div><div class="logo" \nlayout="row" layout-align="start center"><span class="logo-image">F</span> <span class="logo-text">FUSE</span></div>\n<div class="toolbar-separator"></div><ms-shortcuts></ms-shortcuts></div><div layout="row" layout-align="start center">\n<md-progress-circular id="toolbar-progress" ng-if="$root.loadingProgress" class="md-accent" md-mode="indeterminate" \nmd-diameter="64"></md-progress-circular><md-menu-bar id="user-menu"><md-menu md-position-mode="left bottom"><md-button \nclass="user-button" ng-click="$mdMenu.open()" aria-label="User settings" translate \ntranslate-attr-aria-label="TOOLBAR.USER_SETTINGS"><div layout="row" layout-align="space-between center"><div \nclass="avatar-wrapper"><img md-menu-align-target class="avatar" src="assets/images/avatars/profile.jpg"><md-icon \nmd-font-icon ng-class="vm.userStatus.icon" ng-style="{\'color\': vm.userStatus.color }" class="icon status s16">\n</md-icon></div><span class="username" hide-sm>John Smith</span><md-icon md-font-icon="icon-chevron-down" \nclass="icon s16" hide-sm></md-icon></div></md-button><md-menu-content width="3"><md-menu-item class="md-indent" \nui-sref="app.pages_profile"><md-icon md-font-icon="icon-account" class="icon"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class="md-indent" ui-sref="app.mail"><md-icon md-font-icon="icon-email" \nclass="icon"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class="md-indent"><md-icon \nmd-font-icon ng-class="vm.userStatus.icon" ng-style="{\'color\': vm.userStatus.color }" class="icon"></md-icon><md-menu \nid="user-status-menu"><md-button ng-click="$mdMenu.open()" class="status" ng-class="vm.userStatus.class">\n{{vm.userStatus.title}}</md-button><md-menu-content width="2"><md-menu-item class="status md-indent" \nng-class="{\'selected\': status === vm.userStatus}" ng-repeat="status in vm.userStatusOptions"><md-icon \nmd-font-icon="{{status.icon}}" ng-style="{\'color\': status.color }" class="icon"></md-icon><md-button \nng-click="vm.setUserStatus(status)">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class="md-indent"><md-icon md-font-icon="icon-logout" \nclass="icon"></md-icon><md-button ui-sref="app.pages_auth_logout">Logout</md-button></md-menu-item></md-menu-content>\n</md-menu></md-menu-bar><ms-search-bar on-search="vm.search(query)" on-result-click="vm.searchResultClick(item)" \ndebounce="300"></ms-search-bar><md-menu id="language-menu" md-offset="0 72" md-position-mode="target-right target">\n<md-button class="language-button" ng-click="$mdMenu.open()" aria-label="Language" md-menu-origin md-menu-align-target>\n<div layout="row" layout-align="center center"><img height="11px" class="flag" \nng-src="assets/images/flags/{{vm.selectedLanguage.flag}}.png"> <span class="iso">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width="3" id="language-menu-content"><md-menu-item \nng-repeat="(iso, lang) in vm.languages"><md-button ng-click="vm.changeLanguage(lang)" aria-label="{{lang.title}}" \ntranslate translate-attr-aria-label="{{lang.title}}"><span layout="row" layout-align="start center"><img height="11px" \nclass="flag" ng-src="assets/images/flags/{{lang.flag}}.png"> <span translate="{{lang.translation}}">{{lang.title}}\n</span></span></md-button></md-menu-item></md-menu-content></md-menu><md-button id="quick-panel-toggle" \nclass="md-icon-button" ng-click="vm.toggleSidenav(\'quick-panel\')" aria-label="Toggle quick panel" translate \ntranslate-attr-aria-label="TOOLBAR.TOGGLE_QUICK_PANEL"><md-icon md-font-icon="icon-format-list-bulleted" class="icon">\n</md-icon></md-button></div></div>');
$templateCache.put('app/toolbar/layouts/content-with-toolbar/toolbar.html','<div layout="row" layout-align="space-between center"><div layout="row" layout-align="start center"><div class="logo" \nlayout="row" layout-align="start center"><span class="logo-image">F</span> <span class="logo-text">FUSE</span></div>\n<div class="toolbar-separator"></div><ms-shortcuts></ms-shortcuts><div class="toolbar-separator"></div></div><div \nlayout="row" layout-align="start center"><md-progress-circular id="toolbar-progress" ng-if="$root.loadingProgress" \nclass="md-accent" md-mode="indeterminate" md-diameter="64"></md-progress-circular><div class="toolbar-separator"></div>\n<md-menu-bar id="user-menu"><md-menu md-position-mode="left bottom"><md-button class="user-button" \nng-click="$mdMenu.open()" aria-label="User settings" translate translate-attr-aria-label="TOOLBAR.USER_SETTINGS"><div \nlayout="row" layout-align="space-between center"><div class="avatar-wrapper"><img md-menu-align-target class="avatar" \nsrc="assets/images/avatars/profile.jpg"><md-icon md-font-icon ng-class="vm.userStatus.icon" \naria-label="vm.userStatus.icon" ng-style="{\'color\': vm.userStatus.color }" class="icon status s16"></md-icon></div>\n<span class="username" hide-sm>John Smith</span><md-icon md-font-icon="icon-chevron-down" class="icon s16" hide-sm>\n</md-icon></div></md-button><md-menu-content width="3"><md-menu-item class="md-indent" ui-sref="app.pages_profile">\n<md-icon md-font-icon="icon-account" class="icon"></md-icon><md-button>My Profile</md-button></md-menu-item>\n<md-menu-item class="md-indent" ui-sref="app.mail"><md-icon md-font-icon="icon-email" class="icon"></md-icon>\n<md-button>Inbox</md-button></md-menu-item><md-menu-item class="md-indent"><md-icon md-font-icon \nng-class="vm.userStatus.icon" aria-label="vm.userStatus.icon" ng-style="{\'color\': vm.userStatus.color }" class="icon">\n</md-icon><md-menu id="user-status-menu"><md-button ng-click="$mdMenu.open()" class="status" \nng-class="vm.userStatus.class">{{vm.userStatus.title}}</md-button><md-menu-content width="2"><md-menu-item \nclass="status md-indent" ng-class="{\'selected\': status === vm.userStatus}" ng-repeat="status in vm.userStatusOptions">\n<md-icon md-font-icon="{{status.icon}}" ng-style="{\'color\': status.color }" class="icon"></md-icon><md-button \nng-click="vm.setUserStatus(status)">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class="md-indent"><md-icon md-font-icon="icon-logout" \nclass="icon"></md-icon><md-button ui-sref="app.pages_auth_logout">Logout</md-button></md-menu-item></md-menu-content>\n</md-menu></md-menu-bar><div class="toolbar-separator"></div><ms-search-bar on-search="vm.search(query)" \non-result-click="vm.searchResultClick(item)" debounce="300"></ms-search-bar><div class="toolbar-separator"></div>\n<md-menu id="language-menu" md-offset="0 72" md-position-mode="target-right target"><md-button class="language-button" \nng-click="$mdMenu.open()" aria-label="Language" md-menu-origin md-menu-align-target><div layout="row" \nlayout-align="center center"><img height="11px" class="flag" \nng-src="assets/images/flags/{{vm.selectedLanguage.flag}}.png"> <span class="iso">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width="3" id="language-menu-content"><md-menu-item \nng-repeat="(iso, lang) in vm.languages"><md-button ng-click="vm.changeLanguage(lang)" aria-label="{{lang.title}}" \ntranslate translate-attr-aria-label="{{lang.title}}"><span layout="row" layout-align="start center"><img height="11px" \nclass="flag" ng-src="assets/images/flags/{{lang.flag}}.png"> <span translate="{{lang.translation}}">{{lang.title}}\n</span></span></md-button></md-menu-item></md-menu-content></md-menu><div class="toolbar-separator"></div><md-button \nid="quick-panel-toggle" class="md-icon-button" ng-click="vm.toggleSidenav(\'quick-panel\')" \naria-label="Toggle quick panel" translate translate-attr-aria-label="TOOLBAR.TOGGLE_QUICK_PANEL"><md-icon \nmd-font-icon="icon-format-list-bulleted" class="icon"></md-icon></md-button></div></div>');
$templateCache.put('app/toolbar/layouts/vertical-navigation/toolbar.html','<div layout="row bb" layout-align="start center"><div layout="row" layout-align="start center" flex><md-button \nid="navigation-toggle" class="md-icon-button" ng-click="vm.toggleSidenav(\'navigation\')" hide-gt-sm \naria-label="Toggle navigation" translate translate-attr-aria-label="TOOLBAR.TOGGLE_NAVIGATION"><md-icon \nmd-font-icon="icon-menu" class="icon"></md-icon></md-button><div class="toolbar-separator"></div></div><div \nlayout="row" layout-align="start center"><md-progress-circular id="toolbar-progress" ng-if="$root.loadingProgress" \nclass="md-accent" md-mode="indeterminate" md-diameter="64"></md-progress-circular><md-menu-bar class="user-menu">\n<md-menu md-position-mode="left bottom"><md-button class="user-button" \nng-click="vm.companies.length > 1 ? $mdMenu.open() : null" aria-label="User settings" translate \ntranslate-attr-aria-label="TOOLBAR.USER_SETTINGS"><div layout="row" layout-align="space-between center"><div \nclass="avatar-wrapper" ng-show="!vm.companySelected"><img md-menu-align-target class="avatar" \nsrc="assets/images/logos/generic-company.jpg"></div><div class="avatar-wrapper" \nng-show="vm.companySelected && vm.companySelected.files && vm.companySelected.files.length > 0"><img \nmd-menu-align-target class="avatar" ng-src="{{vm.config.storagePrefix}}{{vm.companySelected.files[0].url}}"></div><div \nclass="avatar-wrapper" \nng-show="vm.companySelected && (!vm.companySelected.files || vm.companySelected.files.length === 0)"><div \nclass="avatar small img" ms-random-class="vm.colors" ng-bind="vm.companySelected.name | capitalizeFirstLetter"></div>\n</div><span ng-if="!vm.companySelected" class="username" translate="GLOBAL.SELECT_CLIENT"></span> <span \nng-if="vm.companySelected" class="username">{{vm.companySelected.name}}</span><md-icon ng-if="vm.companies.length > 1" \nmd-font-icon="icon-chevron-down" class="icon s16" hide-xs></md-icon></div></md-button><md-menu-content width="3" \nclass="clients"><md-menu-item class="md-indent"><div class="search-input-wrapper" layout="row" \nlayout-align="start center"><label for="search"><md-icon md-font-icon="icon-magnify" class="search-icon"></md-icon>\n</label><md-input-container md-no-float class="m-0" layout="row" layout-align="start center"><input id="search" \nplaceholder="{{\'CONTACTS.SEARCH_FOR_ANYONE\' |\xA0translate}}" type="text" ng-model="vm.searchText"></md-input-container>\n</div></md-menu-item><div class="results"><md-menu-item ng-click="vm.selectCompany(company)" \nclass="md-indent bar-client" ng-repeat="company in vm.getFilteredCompanies()"><div layout="row" \nlayout-align="start center"><div ng-if="company.files[0].url" class="avatar-wrapper"><img md-menu-align-target \nclass="avatar" ng-src="{{vm.config.storagePrefix}}{{company.files[0].url}}"></div><div ng-if="!company.files[0].url" \nclass="avatar small img" ng-bind="company.name | capitalizeFirstLetter" ms-random-class="vm.colors"></div><button \nclass="btn-clients">{{company.name}}</button></div></md-menu-item></div></md-menu-content></md-menu></md-menu-bar><div \nlayout="row" layout-align="start center" \nng-if="vm.userLogued.email === \'roni@h2c.es\' || vm.userLogued.email === \'indi@h2c.es\'"><md-button \nclass="md-icon-button faqs-button" aria-label="FAQs" ng-click="vm.goToFAQs()"></md-button></div><div \nclass="toolbar-separator"></div><md-menu-bar id="user-menu" class="user-menu"><md-menu md-position-mode="left bottom">\n<md-button class="user-button" ng-click="$mdMenu.open()" aria-label="User settings" translate \ntranslate-attr-aria-label="TOOLBAR.USER_SETTINGS"><div layout="row" layout-align="space-between center"><div \nclass="avatar-wrapper"><img md-menu-align-target class="avatar" src="assets/images/avatars/profile.jpg" \nng-if="!vm.user.files"> <img md-menu-align-target class="avatar" \nng-src="{{vm.config.storagePrefix + vm.user.files.url}}" ng-if="vm.user.files"></div><md-icon \nmd-font-icon="icon-chevron-down" class="icon s16" hide-xs></md-icon></div></md-button><md-menu-content width="3" \nclass="clients"><md-menu-item class="md-indent"><div layout="row" layout-align="start center"><button><strong \nng-bind-html="user.first_name + \' \'+ user.last_name"></strong></button></div></md-menu-item><md-menu-item \nng-click="vm.openPassDialog($event)" class="md-indent"><div layout="row" layout-align="start center"><md-icon \nmd-font-icon="icon-lock" class="icon"></md-icon><button>{{ \'TOOLBAR.CHANGE_PASS\' |\xA0translate}}</button></div>\n</md-menu-item><md-menu-item ng-if="vm.isUserOwner && vm.user.stripe" ng-click="vm.openStripeDialog($event)" \nclass="md-indent"><div layout="row" layout-align="start center"><md-icon md-font-icon="icon-credit-card" class="icon">\n</md-icon><button>{{ \'TOOLBAR.ADD_LICENCES\' |\xA0translate}}</button></div></md-menu-item><md-menu-item \nng-if="vm.isUserOwner && vm.user.stripe" ng-click="vm.openStripePortal($event)" class="md-indent"><div layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-receipt" class="icon"></md-icon><span>\n{{ \'TOOLBAR.MANAGE_SUBSCRIPTION\' | translate }}</span></div></md-menu-item><md-menu-item class="md-indent"><div \nlayout="row" layout-align="start center" class="pr-5"><md-menu flex><div layout="row" \nlayout-align="space-between center"><div layout="row" layout-align="start center"><md-icon md-font-icon="icon-earth" \nclass="icon s20"></md-icon><button ng-click="$mdMenu.open()" translate="GLOBAL.SELECT_LANGUAGE"></button></div><md-icon\n md-font-icon="icon-chevron-right" class="icon s20 mr-0"></md-icon></div><md-menu-content width="3" class="clients">\n<md-menu-item ng-click="vm.changeLanguage(lang)" ng-repeat="(iso, lang) in vm.languages" class="md-indent"><div \nlayout="row" layout-align="start center"><img height="11px" class="flag" \nng-src="assets/images/flags/{{lang.flag}}.png"> <button aria-label="{{lang.title}}" translate \ntranslate-attr-aria-label="{{lang.title}}"><span translate="{{lang.translation}}">{{lang.title}}</span></button></div>\n</md-menu-item></md-menu-content></md-menu></div></md-menu-item><md-menu-item ng-click="vm.logout()" class="md-indent">\n<div layout="row" layout-align="start center"><md-icon md-font-icon="icon-logout" class="icon s20"></md-icon><button \ntranslate="GLOBAL.LOGOUT"></button></div></md-menu-item></md-menu-content></md-menu></md-menu-bar></div><script \nsrc="https://js.stripe.com/v3/"></script></div>');
$templateCache.put('app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html','<div layout="row" layout-align="start center"><div layout="row" layout-align="start center" flex><div class="logo" \nlayout="row" layout-align="start center"><img src="assets/images/logos/h2c-logo.png" class="image" alt="H2C"> <img \nsrc="assets/images/logos/h2c-logo2.png" class="image-logo" alt="H2C" hide-xs></div><div class="toolbar-separator">\n</div><md-button id="navigation-toggle" class="md-icon-button" ng-click="vm.toggleSidenav(\'navigation\')" hide-gt-sm \naria-label="Toggle navigation" translate translate-attr-aria-label="TOOLBAR.TOGGLE_NAVIGATION"><md-icon \nmd-font-icon="icon-menu" class="icon"></md-icon></md-button><md-button class="md-icon-button navigation-fold-toggle" \nhide show-gt-sm aria-label="Toggle navigation fold" translate \ntranslate-attr-aria-label="TOOLBAR.TOGGLE_NAVIGATION_FOLD" ng-click="vm.toggleMsNavigationFolded()"><md-icon \nclass="s18" md-font-icon="icon-backburger"></md-icon></md-button><ms-shortcuts></ms-shortcuts><div \nclass="toolbar-separator"></div></div><div layout="row" layout-align="start center"><md-progress-circular \nid="toolbar-progress" ng-if="$root.loadingProgress" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular><md-menu-bar id="user-menu"><md-menu md-position-mode="left bottom"><md-button \nclass="user-button" ng-click="$mdMenu.open()" aria-label="User settings" translate \ntranslate-attr-aria-label="TOOLBAR.USER_SETTINGS"><div layout="row" layout-align="space-between center"><div \nclass="avatar-wrapper"><img md-menu-align-target class="avatar" src="assets/images/avatars/profile.jpg"><md-icon \nmd-font-icon ng-class="vm.userStatus.icon" aria-label="vm.userStatus.icon" ng-style="{\'color\': vm.userStatus.color }" \nclass="icon status s16"></md-icon></div><span class="username" hide-sm>John Smith</span><md-icon \nmd-font-icon="icon-chevron-down" class="icon s16" hide-sm></md-icon></div></md-button><md-menu-content width="3">\n<md-menu-item class="md-indent" ui-sref="app.pages_profile"><md-icon md-font-icon="icon-account" class="icon">\n</md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item class="md-indent" ui-sref="app.mail"><md-icon \nmd-font-icon="icon-email" class="icon"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item \nclass="md-indent"><md-icon md-font-icon ng-class="vm.userStatus.icon" aria-label="vm.userStatus.icon" \nng-style="{\'color\': vm.userStatus.color }" class="icon"></md-icon><md-menu id="user-status-menu"><md-button \nng-click="$mdMenu.open()" class="status" ng-class="vm.userStatus.class">{{vm.userStatus.title}}</md-button>\n<md-menu-content width="2"><md-menu-item class="status md-indent" ng-class="{\'selected\': status === vm.userStatus}" \nng-repeat="status in vm.userStatusOptions"><md-icon md-font-icon="{{status.icon}}" ng-style="{\'color\': status.color }" \naria-label="status.icon" class="icon"></md-icon><md-button ng-click="vm.setUserStatus(status)">{{status.title}}\n</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item \nclass="md-indent"><md-icon md-font-icon="icon-logout" class="icon"></md-icon><md-button \nui-sref="app.pages_auth_logout">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div \nclass="toolbar-separator"></div><ms-search-bar on-search="vm.search(query)" \non-result-click="vm.searchResultClick(item)" debounce="300"></ms-search-bar><div class="toolbar-separator"></div>\n<md-menu id="language-menu" md-offset="0 72" md-position-mode="target-right target"><md-button class="language-button" \nng-click="$mdMenu.open()" aria-label="Language" md-menu-origin md-menu-align-target><div layout="row" \nlayout-align="center center"><img height="11px" class="flag" \nng-src="assets/images/flags/{{vm.selectedLanguage.flag}}.png"> <span class="iso">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width="3" id="language-menu-content"><md-menu-item \nng-repeat="(iso, lang) in vm.languages"><md-button ng-click="vm.changeLanguage(lang)" aria-label="{{lang.title}}" \ntranslate translate-attr-aria-label="{{lang.title}}"><span layout="row" layout-align="start center"><img class="flag" \nng-src="assets/images/flags/{{lang.flag}}.png"> <span translate="{{lang.translation}}">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class="toolbar-separator"></div><md-button \nid="quick-panel-toggle" class="md-icon-button" ng-click="vm.toggleSidenav(\'quick-panel\')" \naria-label="Toggle quick panel" translate translate-attr-aria-label="TOOLBAR.TOGGLE_QUICK_PANEL"><md-icon \nmd-font-icon="icon-format-list-bulleted" class="icon"></md-icon></md-button></div></div>');
$templateCache.put('app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html','<div layout="row" layout-align="start center"><div layout="row" layout-align="start center" flex><md-button \nid="navigation-toggle" class="md-icon-button" ng-click="vm.toggleSidenav(\'navigation\')" hide-gt-sm \naria-label="Toggle navigation" translate translate-attr-aria-label="TOOLBAR.TOGGLE_NAVIGATION"><md-icon \nmd-font-icon="icon-menu" class="icon"></md-icon></md-button><ms-search-bar on-search="vm.search(query)" \non-result-click="vm.searchResultClick(item)" debounce="300"></ms-search-bar><div class="toolbar-separator"></div>\n<ms-shortcuts></ms-shortcuts><div class="toolbar-separator"></div></div><div layout="row" layout-align="start center">\n<md-progress-circular id="toolbar-progress" ng-if="$root.loadingProgress" class="md-accent" md-mode="indeterminate" \nmd-diameter="64"></md-progress-circular><md-menu-bar id="user-menu"><md-menu md-position-mode="left bottom"><md-button \nclass="user-button" ng-click="$mdMenu.open()" aria-label="User settings" translate \ntranslate-attr-aria-label="TOOLBAR.USER_SETTINGS"><div layout="row" layout-align="space-between center"><div \nclass="avatar-wrapper"><img md-menu-align-target class="avatar" src="assets/images/avatars/profile.jpg"><md-icon \nmd-font-icon ng-class="vm.userStatus.icon" ng-style="{\'color\': vm.userStatus.color }" class="icon status s16">\n</md-icon></div><span class="username" hide-sm>John Smith</span><md-icon md-font-icon="icon-chevron-down" \nclass="icon s16" hide-sm></md-icon></div></md-button><md-menu-content width="3"><md-menu-item class="md-indent" \nui-sref="app.pages_profile"><md-icon md-font-icon="icon-account" class="icon"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class="md-indent" ui-sref="app.mail"><md-icon md-font-icon="icon-email" \nclass="icon"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class="md-indent"><md-icon \nmd-font-icon ng-class="vm.userStatus.icon" ng-style="{\'color\': vm.userStatus.color }" class="icon"></md-icon><md-menu \nid="user-status-menu"><md-button ng-click="$mdMenu.open()" class="status" ng-class="vm.userStatus.class">\n{{vm.userStatus.title}}</md-button><md-menu-content width="2"><md-menu-item class="status md-indent" \nng-class="{\'selected\': status === vm.userStatus}" ng-repeat="status in vm.userStatusOptions"><md-icon \nmd-font-icon="{{status.icon}}" ng-style="{\'color\': status.color }" class="icon"></md-icon><md-button \nng-click="vm.setUserStatus(status)">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class="md-indent"><md-icon md-font-icon="icon-logout" \nclass="icon"></md-icon><md-button ui-sref="app.pages_auth_logout">Logout</md-button></md-menu-item></md-menu-content>\n</md-menu></md-menu-bar><div class="toolbar-separator"></div><md-menu id="language-menu" md-offset="0 72" \nmd-position-mode="target-right target"><md-button class="language-button" ng-click="$mdMenu.open()" \naria-label="Language" md-menu-origin md-menu-align-target><div layout="row" layout-align="center center"><img \nheight="11px" class="flag" ng-src="assets/images/flags/{{vm.selectedLanguage.flag}}.png"> <span class="iso">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width="3" id="language-menu-content">\n<md-menu-item ng-repeat="(iso, lang) in vm.languages"><md-button ng-click="vm.changeLanguage(lang)" \naria-label="{{lang.title}}" translate translate-attr-aria-label="{{lang.title}}"><span layout="row" \nlayout-align="start center"><img class="flag" ng-src="assets/images/flags/{{lang.flag}}.png"> <span \ntranslate="{{lang.translation}}">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class="toolbar-separator"></div><md-button id="quick-panel-toggle" class="md-icon-button" \nng-click="vm.toggleSidenav(\'quick-panel\')" aria-label="Toggle quick panel" translate \ntranslate-attr-aria-label="TOOLBAR.TOGGLE_QUICK_PANEL"><md-icon md-font-icon="icon-format-list-bulleted" class="icon">\n</md-icon></md-button></div></div>');
$templateCache.put('app/core/components/chat-view/dialogs/message-dialog.controller.html','<md-dialog id="message-dialog" class="message-dialog"><md-toolbar class="md-accent"><div class="md-toolbar-tools" \nlayout="row" layout-align="space-between center"><h4 class="text-uppercase ml-20" translate="COMPLAINTS.NEW_MESSAGE">\n</h4><div class="absolute-right pr-10" layout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog" tranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></div></md-toolbar><md-dialog-content flex class="content-card p-24" md-no-ink><div \nlayout="column"><md-input-container flex class="m0 p0"><textarea ui-tinymce="vm.tinymceOptions" \nng-model="vm.replyMessage" aria-label="notes"></textarea></md-input-container></div><div layout="column"><div ngf-drop \nngf-select ng-model="vm.files" class="drop-box" ngf-multiple="true" ngf-allow-dir="true"><div layout="column"><div \nflex translate="GLOBAL.DROP_HERE">Drop here or click to upload</div><div flex translate="GLOBAL.OR"></div><div flex>\n<md-button class="send-button md-accent md-raised" aria-label="Select files" translate="GLOBAL.SELECT_FILES">\n</md-button></div></div></div><div ng-repeat="f in vm.files" class="ms-card" flex><div class="ms-card-content-wrapper" \nstyle="margin: auto;"><div class="template-9"><div class="media" flex layout="row" layout-align="center center"><img \nngf-thumbnail="!f.$error && f" class="image"></div><div class="header p-16" flex><div layout="row" \nlayout-align="space-between center" flex><div class="size" layout="row" layout-align="start left"><strong class="mr-5" \nng-if="f.id">#{{f.id}}</strong> <span class="grey-500-fg"><span ng-if="f.name">{{f.name}}</span></span></div></div>\n</div><md-progress-linear md-mode="determinate" value="{{f.progress}}" ng-show="f.progress <100"></md-progress-linear>\n</div></div></div></div></md-dialog-content><md-dialog-actions layout="row" flex layout-align="start center" \nclass="grey-100-bg"><div layout="row" flex layout-align="start center"><md-checkbox ng-checked="vm.private" \nng-click="vm.private= !vm.private">{{\'COMPLAINTS.PRIVATE_MESSAGE\' | translate}}</md-checkbox></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.createMessage()" ng-disabled="!vm.replyMessage" \nclass="send-button md-accent md-raised" aria-label="Save" translate="COMPLAINTS.SEND"></md-button></div>\n</md-dialog-actions></md-dialog>');
$templateCache.put('app/core/directives/ms-navigation/templates/horizontal.html','<div class="navigation-toggle" hide-gt-sm><md-button class="md-icon-button" ng-click="vm.toggleHorizontalMobileMenu()" \naria-label="Toggle Mobile Navigation"><md-icon md-font-icon="icon-menu"></md-icon></md-button></div><ul \nclass="horizontal"><li ng-repeat="node in vm.navigation" ms-navigation-horizontal-node="node" \nng-class="{\'has-children\': vm.hasChildren}" ng-include="\'navigation-horizontal-nested.html\'"></li></ul><script \ntype="text/ng-template" id="navigation-horizontal-nested.html">\n<div ms-navigation-horizontal-item layout="row" ng-if="!vm.isHidden()">\n\n        <div class="ms-navigation-horizontal-button" ng-if="!node.uisref && node.title"\n             ng-class="{\'active md-accent-bg\': vm.isActive}">\n            <i class="icon s18 {{node.icon}}" ng-if="node.icon"></i>\n            <span class="title" translate="{{node.translate}}" flex>{{node.title}}</span>\n            <span class="badge white-fg" style="background: {{node.badge.color}}" ng-if="node.badge">{{node.badge.content}}</span>\n            <i class="icon-chevron-right s18 arrow" ng-if="vm.hasChildren"></i>\n        </div>\n\n        <a class="ms-navigation-horizontal-button" ui-sref="{{node.uisref}}" ui-sref-active="active md-accent-bg"\n           ng-class="{\'active md-accent-bg\': vm.isActive}"\n           ng-if="node.uisref && node.title">\n            <i class="icon s18 {{node.icon}}" ng-if="node.icon"></i>\n            <span class="title" translate="{{node.translate}}" flex>{{node.title}}</span>\n            <span class="badge white-fg" style="background: {{node.badge.color}}" ng-if="node.badge">{{node.badge.content}}</span>\n            <i class="icon-chevron-right s18 arrow" ng-if="vm.hasChildren"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if="vm.hasChildren && !vm.isHidden()">\n        <li ng-repeat="node in node.children" ms-navigation-horizontal-node="node"\n            ng-class="{\'has-children\': vm.hasChildren}"\n            ng-include="\'navigation-horizontal-nested.html\'"></li>\n    </ul>\n</script>');
$templateCache.put('app/core/directives/ms-navigation/templates/vertical.html','<ul><li ng-repeat="node in vm.navigation" ms-navigation-node="node" \nng-class="{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}" ng-include="\'navigation-nested.html\'"></li></ul>\n<script type="text/ng-template" id="navigation-nested.html">\n<div ms-navigation-item layout="row" ng-if="!vm.isHidden()">\n\n        <div class="ms-navigation-button"  ng-if="!node.uisref && node.title">\n            <i class="icon s16 {{node.icon}}" ng-if="node.icon"></i>\n            <span class="title" translate="{{node.translate}}" flex>{{node.title }}</span>\n            <span class="badge white-fg" ng-style="{\'background\': node.badge.color}" ng-if="node.badge">{{node.badge.content}}</span>\n            <i class="icon-chevron-right s16 arrow" ng-if="vm.collapsable && vm.hasChildren"></i>\n        </div>\n\n        <a class="ms-navigation-button" ng-style="{\'background-color\' : vm.getBrandingColorBack(node) , color:  vm.getBrandingColorFont(node)}" ui-sref="{{node.uisref}}" ui-sref-active="active md-accent-bg"\n           ng-if="node.uisref && node.title">\n            <i ng-style="{ color:  vm.getBrandingColorFont(node)}" class="icon s16 {{node.icon}}" ng-if="node.icon"></i>\n            <span class="title" translate="{{node.translate}}" flex>{{node.custom_name ? node.custom_name : node.title }} </span>\n            <span class="badge white-fg" ng-style="{\'background\': node.badge.color}" ng-if="node.badge">{{node.badge.content}}</span>\n            <i class="icon-chevron-right s16 arrow" ng-if="vm.collapsable && vm.hasChildren"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if="vm.hasChildren && !vm.isHidden()">\n        <li ng-repeat="node in node.children" ms-navigation-node="node"\n            ng-class="{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}"\n            ng-include="\'navigation-nested.html\'"></li>\n    </ul>\n</script>');
$templateCache.put('app/main/apps/complaints/dialogs/action-dialog.html','<md-dialog id="action-dialog" class="action-dialog"><md-toolbar class="md-accent"><div class="md-toolbar-tools" \nlayout="row" layout-align="space-between center"><h4 class="text-uppercase ml-20" translate="COMPLAINTS.NEW_ACTION">\n</h4><div class="absolute-right pr-10" layout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog" tranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></div></md-toolbar><md-dialog-content flex class="content-card" md-no-ink><md-content \nclass="md-padding p0"><div layout="column" layout-gt-xs="row"><md-input-container flex \nclass="m0 p0 md-block md-input-has-value"><textarea ui-tinymce="vm.tinymceOptions" \nng-model="vm.actionData.action.action" aria-label="notes"></textarea></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><div ng-repeat="f in vm.actionData.action.files" class="ms-card" flex><div \nclass="ms-card-content-wrapper" style="margin: auto;"><div class="template-9"><div class="header p-16" flex><div \nlayout="row" layout-align="space-between center" flex><div class="size" layout="row" layout-align="start left"><strong \nclass="mr-5" ng-if="f.id">#{{f.id}}</strong> <span class="grey-500-fg"><span>{{f.url.substr(-3,3)}}</span> </span><a \nng-href="{{f.url | buildFileUrl:vm.storagePrefix}}" target="_blank"><md-icon md-font-icon="icon-link"></md-icon></a>\n</div></div></div><md-progress-linear md-mode="determinate" value="{{f.progress}}" ng-show="f.progress <100">\n</md-progress-linear></div></div></div></div><div layout="column"><div fill-width><div ngf-drop ngf-select \nng-model="vm.actionData.files" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" \nngf-allow-dir="true"><div layout="column"><div flex translate="GLOBAL.DROP_HERE">Drop here or click to upload</div><div\n flex translate="GLOBAL.OR"></div><div flex><md-button class="send-button md-accent md-raised" \naria-label="Select files" translate="GLOBAL.SELECT_FILES"></md-button></div></div></div><div ngf-no-file-drop \ntranslate="GLOBAL.FILE_DRAG_DROP"></div></div><div ng-repeat="f in vm.actionData.files" class="ms-card" flex><div \nclass="ms-card-content-wrapper" style="margin: auto;"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><img ngf-thumbnail="!f.$error && f" class="image"></div><div class="header p-16" flex><div\n layout="row" layout-align="space-between center" flex><div class="size" layout="row" layout-align="start left"><strong\n class="mr-5" ng-if="f.id">#{{f.id}}</strong> <span class="grey-500-fg"><span ng-if="f.name">{{f.name}}</span></span>\n</div></div></div><md-progress-linear md-mode="determinate" value="{{f.progress}}" ng-show="f.progress <100">\n</md-progress-linear></div></div></div></div></md-content></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="end center" class="grey-100-bg" ng-if="!vm.actionData.action.id"><md-button \nng-disabled="!vm.actionData.action.action" ng-click="vm.save()" class="send-button md-accent md-raised" \naria-label="Save" translate="RISK.SAVE" translate-attr-aria-label="RISK.SAVE"></md-button></md-dialog-actions>\n</md-dialog>');
$templateCache.put('app/main/apps/dashboard-complaints/views/general-widgets-complaints.html','<ms-widget ng-click="vm.openDialog(vm.data.complaints,\'COMPLAINTS\', $event)" flippable="false" layout="row" flex="100" \nflex-gt-sm="48" class="enhanced-widget"><ms-widget-front class="white-bg enhanced-card"><div \nclass="widget-header ph-16 border-bottom" layout="row" layout-align="space-between center"><div class="h3 pv-10">\n<md-icon md-font-icon="icon-email-secure" class="widget-icon"></md-icon>\n{{ \'DASHBOARD-COMPLAINTS.ALL_COMPLAINTS\' | translate}}</div><div class="trend-indicator" \nng-class="vm.getTrendClass(\'total\')"><md-icon md-font-icon="icon-trending-up" \nng-if="vm.getTrendDirection(\'total\') === \'up\'"></md-icon><md-icon md-font-icon="icon-trending-down" \nng-if="vm.getTrendDirection(\'total\') === \'down\'"></md-icon><span class="trend-stable-line" \nng-if="vm.getTrendDirection(\'total\') === \'stable\'" aria-hidden="true"></span></div></div><div layout="column" \nlayout-align="center center" class="widget-content"><div class="pt-8 pb-15" layout="column" \nlayout-align="center center" flex="100"><div class="main-number font-size-72 line-height-72 primary-color">\n{{vm.data.complaints.length}}</div><div class="secondary-text font-weight-500">\n{{vm.data.complaints.length &lt;= 1 ? (\'DASHBOARD-COMPLAINTS.COMPLAINT\' | translate) : (\'DASHBOARD-COMPLAINTS.COMPLAINTS\' | translate)}}\n</div></div><div class="mini-chart-container" flex="100" layout="column" layout-align="center center"><div \nclass="mini-pie-chart" nvd3-pie-chart data="vm.complaintsPieData" options="vm.miniPieOptions" flex="100"></div></div>\n</div><div class="widget-footer ph-16 pt-8 border-top"><div layout="row" layout-align="space-between center"><span \nclass="caption-text">{{ \'DASHBOARD-COMPLAINTS.THIS_MONTH\' | translate}}</span> <span \nclass="caption-text trend-percentage" ng-class="vm.getTrendClass(\'total\')">{{vm.getTrendPercentage(\'total\')}}<span \nng-if="vm.getPreviousMonthData() > 0">%</span></span></div></div></ms-widget-front></ms-widget><ms-widget \nng-click="vm.openDialog(vm.data.complaints | filter: {status: 2},\'COMPLAINTS\', $event)" flippable="false" layout="row" \nflex="100" flex-gt-sm="48" class="enhanced-widget critical-widget"><ms-widget-front \nclass="white-bg enhanced-card critical-card"><div class="widget-header ph-16 border-bottom" layout="row" \nlayout-align="space-between center"><div class="h3 pv-10"><md-icon md-font-icon="icon-alert-circle" \nclass="widget-icon critical-icon"></md-icon>{{ \'DASHBOARD-COMPLAINTS.COMPLAINTS_STATUS_2\' | translate}}</div><div \nclass="priority-badge critical" layout="row" layout-align="center center" layout-wrap><md-icon \nmd-font-icon="icon-file-document" class="widget-badge-icon"></md-icon><span>{{ \'COMPLAINTS.NEW\' | translate }}</span>\n</div></div><div layout="row" layout-align="center center" class="widget-content"><div class="pt-8 pb-15" \nlayout="column" layout-align="center center" flex="60"><div \nclass="main-number font-size-72 line-height-72 critical-color">{{(vm.data.complaints | filter: {status: 2}).length}}\n</div><div class="secondary-text font-weight-500">\n{{(vm.data.complaints | filter: {status: 2}).length &lt;= 1 ? (\'DASHBOARD-COMPLAINTS.COMPLAINT\' | translate) : (\'DASHBOARD-COMPLAINTS.COMPLAINTS\' | translate)}}\n</div></div><div class="metric-container" flex="40" layout="column" layout-align="center center"><div \nclass="metric-item"><div class="metric-value">{{vm.getAverageResolutionTime(2)}}</div><div class="metric-label">\n{{ \'DASHBOARD-COMPLAINTS.PENDING_DAYS\' | translate }}</div></div></div></div><div \nclass="widget-footer ph-16 pt-8 border-top"><div layout="row" layout-align="space-between center"><span \nclass="caption-text">{{ \'DASHBOARD-COMPLAINTS.NEW_COMMUNICATIONS\' | translate }}</span> <span \nclass="caption-text critical-percentage">\n{{vm.getPercentageByStatus(2)}}% {{ \'DASHBOARD-COMPLAINTS.OF_TOTAL\' | translate }}</span></div></div></ms-widget-front>\n</ms-widget><ms-widget ng-click="vm.openDialog(vm.data.complaints | filter: {status: 1},\'COMPLAINTS\', $event)" \nflippable="false" layout="row" flex="100" flex-gt-sm="47" class="enhanced-widget warning-widget"><ms-widget-front \nclass="white-bg enhanced-card warning-card"><div class="widget-header ph-16 border-bottom" layout="row" \nlayout-align="space-between center"><div class="h3 pv-10"><md-icon md-font-icon="icon-clock" \nclass="widget-icon warning-icon"></md-icon>{{ \'DASHBOARD-COMPLAINTS.COMPLAINTS_STATUS_1\' | translate}}</div><div \nclass="priority-badge warning" layout="row" layout-align="center center" layout-wrap><md-icon \nmd-font-icon="icon-magnify" class="widget-badge-icon"></md-icon><span>{{ \'COMPLAINTS.REVIEW\' | translate }}</span>\n</div></div><div layout="row" layout-align="center center" class="widget-content"><div class="pt-8 pb-15" \nlayout="column" layout-align="center center" flex="60"><div \nclass="main-number font-size-72 line-height-72 warning-color">{{(vm.data.complaints | filter: {status: 1}).length}}\n</div><div class="secondary-text font-weight-500">\n{{(vm.data.complaints | filter: {status: 1}).length &lt;= 1 ? (\'DASHBOARD-COMPLAINTS.COMPLAINT\' | translate) : (\'DASHBOARD-COMPLAINTS.COMPLAINTS\' | translate)}}\n</div></div><div class="metric-container" flex="40" layout="column" layout-align="center center"><div \nclass="metric-item"><div class="metric-value">{{vm.getAverageResolutionTime(1)}}</div><div class="metric-label">\n{{ \'DASHBOARD-COMPLAINTS.DAYS_IN_PROCESS\' | translate }}</div></div></div></div><div \nclass="widget-footer ph-16 pt-8 border-top"><div layout="row" layout-align="space-between center"><span \nclass="caption-text">{{ \'DASHBOARD-COMPLAINTS.IN_PROGRESS\' | translate }}</span> <span \nclass="caption-text warning-percentage">\n{{vm.getPercentageByStatus(1)}}% {{ \'DASHBOARD-COMPLAINTS.OF_TOTAL\' | translate }}</span></div></div></ms-widget-front>\n</ms-widget><ms-widget ng-click="vm.openDialog(vm.data.complaints | filter: {status: 4},\'COMPLAINTS\', $event)" \nflippable="false" layout="row" flex="100" flex-gt-sm="47" class="enhanced-widget primary-widget"><ms-widget-front \nclass="white-bg enhanced-card primary-card"><div class="widget-header ph-16 border-bottom" layout="row" \nlayout-align="space-between center"><div class="h3 pv-10"><md-icon md-font-icon="icon-search" \nclass="widget-icon primary-icon"></md-icon>{{ \'DASHBOARD-COMPLAINTS.COMPLAINTS_STATUS_4\' | translate}}</div><div \nclass="priority-badge primary" layout="row" layout-align="center center" layout-wrap><md-icon \nmd-font-icon="icon-file-find" class="widget-badge-icon"></md-icon><span>\n{{ \'COMPLAINTS.UNDER_INVESTIGATION\' | translate }}</span></div></div><div layout="row" layout-align="center center" \nclass="widget-content"><div class="pt-8 pb-15" layout="column" layout-align="center center" flex="60"><div \nclass="main-number font-size-72 line-height-72 primary-widget-color">\n{{(vm.data.complaints | filter: {status: 4}).length}}</div><div class="secondary-text font-weight-500">\n{{(vm.data.complaints | filter: {status: 4}).length &lt;= 1 ? (\'DASHBOARD-COMPLAINTS.COMPLAINT\' | translate) : (\'DASHBOARD-COMPLAINTS.COMPLAINTS\' | translate)}}\n</div></div><div class="metric-container" flex="40" layout="column" layout-align="center center"><div \nclass="metric-item"><div class="metric-value">{{vm.getAverageResolutionTime(4)}}</div><div class="metric-label">\n{{ \'DASHBOARD-COMPLAINTS.DAYS_IN_PROCESS\' | translate }}</div></div></div></div><div \nclass="widget-footer ph-16 pt-8 border-top"><div layout="row" layout-align="space-between center"><span \nclass="caption-text">{{ \'DASHBOARD-COMPLAINTS.IN_PROGRESS\' | translate }}</span> <span \nclass="caption-text primary-percentage">\n{{vm.getPercentageByStatus(4)}}% {{ \'DASHBOARD-COMPLAINTS.OF_TOTAL\' | translate }}</span></div></div></ms-widget-front>\n</ms-widget><ms-widget ng-if="vm.canSeeAdminOnlyStatuses" \nng-click="vm.openDialog(vm.data.complaints | filter: {status: 5},\'COMPLAINTS\', $event)" flippable="false" layout="row" \nflex="100" flex-gt-sm="47" class="enhanced-widget accent-widget"><ms-widget-front \nclass="white-bg enhanced-card accent-card"><div class="widget-header ph-16 border-bottom" layout="row" \nlayout-align="space-between center"><div class="h3 pv-10"><md-icon md-font-icon="icon-gavel" \nclass="widget-icon accent-icon"></md-icon>{{ \'DASHBOARD-COMPLAINTS.COMPLAINTS_STATUS_5\' | translate}}</div><div \nclass="priority-badge accent" layout="row" layout-align="center center" layout-wrap><md-icon md-font-icon="icon-gavel" \nclass="widget-badge-icon"></md-icon><span>{{ \'COMPLAINTS.REFERRED_TO_PROSECUTOR\' | translate }}</span></div></div><div \nlayout="column" layout-align="center center" class="widget-content"><div class="pt-8 pb-15" layout="column" \nlayout-align="center center" flex="100"><div class="main-number font-size-72 line-height-72 accent-color">\n{{(vm.data.complaints | filter: {status: 5}).length}}</div><div class="secondary-text font-weight-500">\n{{(vm.data.complaints | filter: {status: 5}).length &lt;= 1 ? (\'DASHBOARD-COMPLAINTS.COMPLAINT\' | translate) : (\'DASHBOARD-COMPLAINTS.COMPLAINTS\' | translate)}}\n</div></div></div><div class="widget-footer ph-16 pt-8 border-top"><div layout="row" \nlayout-align="space-between center"><span class="caption-text">\n{{ \'DASHBOARD-COMPLAINTS.REFERRED_COMMUNICATIONS\' | translate }}</span> <span class="caption-text accent-percentage">\n{{vm.getPercentageByStatus(5)}}% {{ \'DASHBOARD-COMPLAINTS.OF_TOTAL\' | translate }}</span></div></div></ms-widget-front>\n</ms-widget><ms-widget ng-if="vm.canSeeAdminOnlyStatuses" \nng-click="vm.openDialog(vm.data.complaints | filter: {status: 3},\'COMPLAINTS\', $event)" flippable="false" layout="row" \nflex="100" flex-gt-sm="47" class="enhanced-widget success-widget"><ms-widget-front \nclass="white-bg enhanced-card success-card"><div class="widget-header ph-16 border-bottom" layout="row" \nlayout-align="space-between center"><div class="h3 pv-10"><md-icon md-font-icon="icon-check-circle" \nclass="widget-icon success-icon"></md-icon>{{ \'DASHBOARD-COMPLAINTS.COMPLAINTS_STATUS_3\' | translate}}</div><div \nclass="priority-badge success" layout="row" layout-align="center center" layout-wrap><md-icon \nmd-font-icon="icon-file-outline" class="widget-badge-icon"></md-icon><span>{{ \'COMPLAINTS.NOT_ADMITTED\' | translate }}\n</span></div></div><div layout="column" layout-align="center center" class="widget-content"><div class="pt-8 pb-15" \nlayout="column" layout-align="center center" flex="100"><div \nclass="main-number font-size-72 line-height-72 success-color">{{(vm.data.complaints | filter: {status: 3}).length}}\n</div><div class="secondary-text font-weight-500">\n{{(vm.data.complaints | filter: {status: 3}).length &lt;= 1 ? (\'DASHBOARD-COMPLAINTS.COMPLAINT\' | translate) : (\'DASHBOARD-COMPLAINTS.COMPLAINTS\' | translate)}}\n</div></div></div><div class="widget-footer ph-16 pt-8 border-top"><div layout="row" \nlayout-align="space-between center"><span class="caption-text">\n{{ \'DASHBOARD-COMPLAINTS.NOT_ADMITTED_COMMUNICATIONS\' | translate }}</span> <span \nclass="caption-text success-percentage">\n{{vm.getPercentageByStatus(3)}}% {{ \'DASHBOARD-COMPLAINTS.OF_TOTAL\' | translate }}</span></div></div></ms-widget-front>\n</ms-widget><ms-widget ng-if="vm.canSeeAdminOnlyStatuses" \nng-click="vm.openDialog(vm.data.complaints | filter: {status: 0},\'COMPLAINTS\', $event)" flippable="false" layout="row" \nflex="100" flex-gt-sm="47" class="enhanced-widget info-widget"><ms-widget-front \nclass="white-bg enhanced-card info-card"><div class="widget-header ph-16 border-bottom" layout="row" \nlayout-align="space-between center"><div class="h3 pv-10"><md-icon md-font-icon="icon-plus-circle" \nclass="widget-icon info-icon"></md-icon>{{ \'DASHBOARD-COMPLAINTS.COMPLAINTS_STATUS_0\' | translate}}</div><div \nclass="priority-badge info" layout="row" layout-align="center center" layout-wrap><md-icon \nmd-font-icon="icon-check-circle" class="widget-badge-icon"></md-icon><span>{{ \'COMPLAINTS.CLOSED\' | translate }}</span>\n</div></div><div layout="row" layout-align="center center" class="widget-content"><div class="pt-8 pb-15" \nlayout="column" layout-align="center center" flex="60"><div class="main-number font-size-72 line-height-72 info-color">\n{{(vm.data.complaints | filter: {status: 0}).length}}</div><div class="secondary-text font-weight-500">\n{{(vm.data.complaints | filter: {status: 0}).length &lt;= 1 ? (\'DASHBOARD-COMPLAINTS.COMPLAINT\' | translate) : (\'DASHBOARD-COMPLAINTS.COMPLAINTS\' | translate)}}\n</div></div><div class="metric-container" flex="40" layout="column" layout-align="center center"><div \nclass="metric-item"><div class="metric-value">{{vm.getNewComplaintsToday()}}</div><div class="metric-label">\n{{ \'DASHBOARD-COMPLAINTS.TODAY\' | translate }}</div></div></div></div><div class="widget-footer ph-16 pt-8 border-top">\n<div layout="row" layout-align="space-between center"><span class="caption-text">\n{{ \'DASHBOARD-COMPLAINTS.CLOSED_COMMUNICATIONS\' | translate }}</span> <span class="caption-text info-percentage">\n{{vm.getPercentageByStatus(0)}}% {{ \'DASHBOARD-COMPLAINTS.OF_TOTAL\' | translate }}</span></div></div></ms-widget-front>\n</ms-widget><ms-widget ng-click="vm.openDialog(vm.data.tasks_next,\'PENDING_TASKS\', $event)" flippable="false" \nlayout="row" flex="100" flex-gt-sm="47" class="enhanced-widget task-widget"><ms-widget-front \nclass="white-bg enhanced-card task-card"><div class="widget-header ph-16 border-bottom" layout="row" \nlayout-align="space-between center"><div class="h3 pv-10"><md-icon md-font-icon="icon-clipboard-check" \nclass="widget-icon task-icon"></md-icon>{{ \'DASHBOARD-COMPLAINTS.PENDING_TASKS\' | translate}}</div><div \nclass="priority-badge task">{{ \'DASHBOARD-COMPLAINTS.PENDING_BADGE\' | translate }}</div></div><div layout="row" \nlayout-align="center center" class="widget-content"><div class="pt-8 pb-15" layout="column" \nlayout-align="center center" flex="60"><div class="main-number font-size-72 line-height-72 task-color">\n{{vm.data.tasks_next.length}}</div><div class="secondary-text font-weight-500">\n{{vm.data.tasks_next.length &lt;= 1 ? (\'DASHBOARD-COMPLAINTS.TASK\' | translate) : (\'DASHBOARD-COMPLAINTS.TASKS\' | translate)}}\n</div></div><div class="metric-container" flex="40" layout="column" layout-align="center center"><div \nclass="metric-item"><div class="metric-value">{{vm.getTasksDueThisWeek()}}</div><div class="metric-label">\n{{ \'DASHBOARD-COMPLAINTS.THIS_WEEK\' | translate }}</div></div></div></div><div \nclass="widget-footer ph-16 pt-8 border-top"><div layout="row" layout-align="space-between center"><span \nclass="caption-text">{{ \'DASHBOARD-COMPLAINTS.TO_COMPLETE\' | translate }}</span> <span \nclass="caption-text task-percentage">{{vm.getTaskCompletionRate()}}% {{ \'DASHBOARD-COMPLAINTS.COMPLETED\' | translate }}\n</span></div></div></ms-widget-front></ms-widget><ms-widget \nng-click="vm.openDialog(vm.data.tasks_due,\'DUE_TASKS\', $event)" flippable="false" layout="row" flex="100" \nflex-gt-sm="47" class="enhanced-widget overdue-widget"><ms-widget-front class="white-bg enhanced-card overdue-card">\n<div class="widget-header ph-16 border-bottom" layout="row" layout-align="space-between center"><div class="h3 pv-10">\n<md-icon md-font-icon="icon-alert-circle" class="widget-icon overdue-icon"></md-icon>\n{{ \'DASHBOARD-COMPLAINTS.DUE_TASKS\' | translate}}</div><div class="priority-badge overdue">\n{{ \'DASHBOARD-COMPLAINTS.OVERDUE_BADGE\' | translate }}</div></div><div layout="row" layout-align="center center" \nclass="widget-content"><div class="pt-8 pb-15" layout="column" layout-align="center center" flex="60"><div \nclass="main-number font-size-72 line-height-72 overdue-color">{{vm.data.tasks_due.length}}</div><div \nclass="secondary-text font-weight-500">\n{{vm.data.tasks_due.length &lt;= 1 ? (\'DASHBOARD-COMPLAINTS.TASK\' | translate) : (\'DASHBOARD-COMPLAINTS.TASKS\' | translate)}}\n</div></div><div class="metric-container" flex="40" layout="column" layout-align="center center"><div \nclass="metric-item"><div class="metric-value">{{vm.getOverdueDays()}}</div><div class="metric-label">\n{{ \'DASHBOARD-COMPLAINTS.OVERDUE_DAYS\' | translate }}</div></div></div></div><div \nclass="widget-footer ph-16 pt-8 border-top"><div layout="row" layout-align="space-between center"><span \nclass="caption-text">{{ \'DASHBOARD-COMPLAINTS.REQUIRE_URGENT_ATTENTION\' | translate }}</span> <span \nclass="caption-text overdue-percentage">\n{{vm.getOverduePercentage()}}% {{ \'DASHBOARD-COMPLAINTS.OF_TOTAL\' | translate }}</span></div></div></ms-widget-front>\n</ms-widget><ms-widget ng-click="vm.openDialog(vm.data.files,\'FILES\', $event)" flippable="false" layout="row" \nflex="100" flex-gt-sm="47" class="enhanced-widget document-widget"><ms-widget-front \nclass="white-bg enhanced-card document-card"><div class="widget-header ph-16 border-bottom" layout="row" \nlayout-align="space-between center"><div class="h3 pv-10"><md-icon md-font-icon="icon-file-document" \nclass="widget-icon document-icon"></md-icon>{{ \'DASHBOARD-COMPLAINTS.LAST_DOCUMENTS\' | translate}}</div><div \nclass="priority-badge document">{{ \'DASHBOARD-COMPLAINTS.DOCUMENTS_BADGE\' | translate }}</div></div><div layout="row" \nlayout-align="center center" class="widget-content"><div class="pt-8 pb-15" layout="column" \nlayout-align="center center" flex="60"><div class="main-number font-size-72 line-height-72 document-color">\n{{vm.data.files.length}}</div><div class="secondary-text font-weight-500">\n{{vm.data.files.length &lt;= 1 ? (\'DASHBOARD-COMPLAINTS.DOCUMENT\' | translate) : (\'DASHBOARD-COMPLAINTS.DOCUMENTS\' | translate)}}\n</div></div><div class="metric-container" flex="40" layout="column" layout-align="center center"><div \nclass="metric-item"><div class="metric-value">{{vm.getRecentDocuments()}}</div><div class="metric-label">\n{{ \'DASHBOARD-COMPLAINTS.THIS_WEEK\' | translate }}</div></div></div></div><div \nclass="widget-footer ph-16 pt-8 border-top"><div layout="row" layout-align="space-between center"><span \nclass="caption-text">{{ \'DASHBOARD-COMPLAINTS.AVAILABLE_FILES\' | translate }}</span> <span \nclass="caption-text document-percentage">{{vm.getTotalFileSize()}} MB</span></div></div></ms-widget-front></ms-widget>');
$templateCache.put('app/main/apps/dashboards/analytics/dashboard-analytics.html','<div id="dashboard-analytics"><div id="widgets"><div class="widget-group" layout="row" flex="100" layout-wrap>\n<ms-widget flippable="false" layout="row" flex="100"><ms-widget-front class="white-bg"><div class="p-24 border-bottom" \nlayout="row" layout-align="space-between center"><div class="h3">{{vm.widget1.title}}</div><div \nclass="text-boxed green-600-bg white-fg">{{vm.widget1.onlineUsers}} online users</div></div><div \nclass="pb-32 border-bottom"><nvd3 class="h-400 remove-x-lines remove-opacity" options="vm.widget1.bigChart.options" \ndata="vm.widget1.bigChart.data"></nvd3></div><div layout="row" layout-align="start center" layout-wrap><div \nclass="p-24 grey-50-bg" layout="row" layout-align="start center" flex="100" flex-gt-xs="50" flex-gt-md="25"><div \nlayout="column" flex><div class="h3 secondary-text pb-8">{{vm.widget1.sessions.title}}</div><div \nclass="font-size-32 line-height-32 pb-16">{{vm.widget1.sessions.value}}</div><div><nvd3 class="h-40" \noptions="vm.widget1.sessions.options" data="vm.widget1.sessions.data"></nvd3></div></div></div><div \nclass="p-24 grey-50-bg" layout="row" layout-align="start center" flex="100" flex-gt-xs="50" flex-gt-md="25"><div \nlayout="column" flex><div class="h3 secondary-text pb-8">{{vm.widget1.pageviews.title}}</div><div \nclass="font-size-32 line-height-32 pb-16">{{vm.widget1.pageviews.value}}</div><div><nvd3 class="h-40" \noptions="vm.widget1.pageviews.options" data="vm.widget1.pageviews.data"></nvd3></div></div></div><div \nclass="p-24 grey-50-bg" layout="row" layout-align="start center" flex="100" flex-gt-xs="50" flex-gt-md="25"><div \nlayout="column" flex><div class="h3 secondary-text pb-8">{{vm.widget1.pagesSessions.title}}</div><div \nclass="font-size-32 line-height-32 pb-16">{{vm.widget1.pagesSessions.value}}</div><div><nvd3 class="h-40" \noptions="vm.widget1.pagesSessions.options" data="vm.widget1.pagesSessions.data"></nvd3></div></div></div><div \nclass="p-24 grey-50-bg" layout="row" layout-align="start center" flex="100" flex-gt-xs="50" flex-gt-md="25"><div \nlayout="column" flex><div class="h3 secondary-text pb-8">{{vm.widget1.avgSessionDuration.title}}</div><div \nclass="font-size-32 line-height-32 pb-16">{{vm.widget1.avgSessionDuration.value}}</div><div><nvd3 class="h-40" \noptions="vm.widget1.avgSessionDuration.options" data="vm.widget1.avgSessionDuration.data"></nvd3></div></div></div>\n</div></ms-widget-front></ms-widget></div><div class="widget-group" layout="row" flex="100" layout-wrap><ms-widget \nflippable="false" layout="column" flex="100" flex-gt-md="65"><ms-widget-front class="white-bg"><div class="p-16" \nlayout="row" layout-align="space-between center"><div class="h3">{{vm.widget2.title}}</div><md-menu><md-button \naria-label="more" class="md-icon-button" ng-click="$mdMenu.open($event)"><md-icon md-font-icon="icon-dots-vertical">\n</md-icon></md-button><md-menu-content width="2"><md-menu-item><md-button ng-click="refreshWidget()" \naria-label="Refresh widget">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div>\n<ui-gmap-google-map center="vm.widget2.map.center" zoom="vm.widget2.map.zoom" options="vm.widget2.map.options">\n<ui-gmap-markers models="vm.widget2.map.markers" coords="\'coords\'"><ui-gmap-windows show="show"><div ng-non-bindable>\n{{sessions}}</div></ui-gmap-windows></ui-gmap-markers></ui-gmap-google-map></div></ms-widget-front></ms-widget>\n<ms-widget flippable="false" layout="column" flex="100" flex-gt-md="35"><ms-widget-front class="white-bg"><div \nclass="ph-16 border-bottom" layout="row" layout-align="space-between center"><div class="h3">{{vm.widget3.title}}</div>\n<div class="pv-16"><md-select class="simplified" ng-model="vm.widget3.currentRange" aria-label="Change range">\n<md-option ng-repeat="(key, range) in vm.widget3.ranges" value="{{key}}">{{range}}</md-option></md-select></div></div>\n<div class="ph-16 pv-20 border-bottom" ng-repeat="page in vm.widget3.pages[vm.widget3.currentRange]" layout="row" \nlayout-align="space-between center"><div layout="column" flex><span class="h4 pb-10">{{page.path}}</span>\n<md-progress-linear class="md-accent" md-mode="determinate" value="{{page.value}}"></md-progress-linear></div><div \nclass="pl-32 h3 font-weight-500 secondary-text">{{page.value}}%</div></div></ms-widget-front></ms-widget></div><div \nclass="widget-group" layout="row" flex="100" layout-wrap><ms-widget flippable="false" layout="row" flex="100">\n<ms-widget-front class="white-bg"><div class="ph-16 pt-16 pb-8 md-accent-bg"><div class="h3">{{vm.widget4.title}}</div>\n</div><md-tabs class="md-accent no-radius" md-dynamic-height><md-tab label="{{tab.label}}" \nng-repeat="tab in vm.widget4.tabs"><div layout="row" layout-align="start center" layout-wrap><div flex="100" \nflex-gt-xs="50" flex-gt-md="25" ng-repeat="group in tab.groups"><div class="h2 m-16 pb-16 border-bottom">\n{{group.title}}</div><div class="p-16 pb-32" ng-repeat="data in group.data"><div class="pb-8" layout="row" \nlayout-align="space-between start"><span class="h3">{{data.title}}</span> <span \nclass="h3 secondary-text font-weight-500">{{data.value}}%</span></div><md-progress-linear \nclass="{{data.progressColor}}" md-mode="determinate" value="{{data.value}}"></md-progress-linear></div></div></div>\n</md-tab></md-tabs></ms-widget-front></ms-widget></div></div></div>');
$templateCache.put('app/main/apps/dashboards/project/dashboard-project.html','<div id="dashboard-project" class="page-layout simple right-sidenav" layout="row"><div class="center" flex ms-scroll>\n<div class="header md-accent-bg" layout="column" layout-align="space-between"><div layout="row" \nlayout-align="space-between"><div><span class="md-display-1 font-weight-300">Welcome back, John!</span></div><div \nclass="toolbar"><md-button class="md-icon-button sidenav-toggle" ng-click="vm.toggleSidenav(\'sidenav\')" hide-gt-md \naria-label="Toggle sidenav"><md-icon md-font-icon="icon-menu" class="icon"></md-icon></md-button></div></div><div \nlayout="row"><div class="selected-project">{{vm.selectedProject.name}}</div></div></div><div class="content"><md-tabs \nmd-dynamic-height><md-tab label="Home"><div class="widget-group" layout="row" flex="100" layout-wrap><ms-widget \nflippable="true" layout="column" flex="100" flex-gt-xs="50" flex-gt-md="25"><ms-widget-front class="white-bg"><div \nclass="ph-8 pv-16 h-55" layout="row" layout-align="space-between center"><md-select class="simplified font-size-16" \nng-model="vm.widget1.currentRange" aria-label="Change range"><md-option ng-repeat="(key, range) in vm.widget1.ranges" \nvalue="{{key}}">{{range}}</md-option></md-select><md-menu><md-button class="md-icon-button" ng-click="$mdMenu.open()" \naria-label="more"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content width="3">\n<md-menu-item><md-button ng-click="flipWidget()" aria-label="Flip widget">Details</md-button></md-menu-item>\n<md-menu-item><md-button ng-click="refreshWidget()" aria-label="Refresh widget">Refresh</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class="pt-8 pb-32" layout="column" layout-align="center center"><div \nclass="light-blue-fg font-size-72 line-height-72">{{vm.widget1.data.count[vm.widget1.currentRange]}}</div><div \nclass="h3 secondary-text font-weight-500">{{vm.widget1.data.label}}</div></div><div class="p-16 grey-50-bg border-top" \nlayout="row" layout-align="start center"><span class="h4 secondary-text text-truncate">{{vm.widget1.data.extra.label}}:\n</span> <span class="h4 ml-8">{{vm.widget1.data.extra.count[vm.widget1.currentRange]}}</span></div></ms-widget-front>\n<ms-widget-back class="p-16 white-bg"><div class="flip-to-front"><md-button class="md-icon-button" \nng-click="flipWidget()" aria-label="Flip widget"><md-icon md-font-icon="icon-close" class="s16"></md-icon></md-button>\n</div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable="true" layout="column" \nflex="100" flex-gt-xs="50" flex-gt-md="25"><ms-widget-front class="white-bg"><div class="pl-16 pr-8 pv-16 h-55" \nlayout="row" layout-align="space-between center"><div class="h3">{{vm.widget2.title}}</div><md-menu><md-button \nclass="md-icon-button" ng-click="$mdMenu.open()" aria-label="more"><md-icon md-font-icon="icon-dots-vertical">\n</md-icon></md-button><md-menu-content width="2"><md-menu-item><md-button ng-click="flipWidget()" \naria-label="Flip widget">Details</md-button></md-menu-item><md-menu-item><md-button ng-click="refreshWidget()" \naria-label="Refresh widget">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass="pt-8 pb-32" layout="column" layout-align="center center"><div class="red-fg font-size-72 line-height-72">\n{{vm.widget2.data.count}}</div><div class="h3 secondary-text font-weight-500">{{vm.widget2.data.label}}</div></div><div\n class="p-16 grey-50-bg border-top" layout="row" layout-align="start center"><span \nclass="h4 secondary-text text-truncate">{{vm.widget2.data.extra.label}}:</span> <span class="h4 ml-8">\n{{vm.widget2.data.extra.count}}</span></div></ms-widget-front><ms-widget-back class="p-16 white-bg"><div \nclass="flip-to-front"><md-button class="md-icon-button" ng-click="flipWidget()" aria-label="Flip widget"><md-icon \nmd-font-icon="icon-close" class="s16"></md-icon></md-button></div><div>{{vm.widget2.detail}}</div></ms-widget-back>\n</ms-widget><ms-widget flippable="true" layout="column" flex="100" flex-gt-xs="50" flex-gt-md="25"><ms-widget-front \nclass="white-bg"><div class="pl-16 pr-8 pv-16 h-55" layout="row" layout-align="space-between center"><div class="h3">\n{{vm.widget3.title}}</div><md-menu><md-button class="md-icon-button" ng-click="$mdMenu.open()" aria-label="more">\n<md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content width="2"><md-menu-item><md-button \nng-click="flipWidget()" aria-label="Flip widget">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click="refreshWidget()" aria-label="Refresh widget">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class="pt-8 pb-32" layout="column" layout-align="center center"><div \nclass="orange-fg font-size-72 line-height-72">{{vm.widget3.data.count}}</div><div \nclass="h3 secondary-text font-weight-500">{{vm.widget3.data.label}}</div></div><div class="p-16 grey-50-bg border-top" \nlayout="row" layout-align="start center"><span class="h4 secondary-text text-truncate">{{vm.widget3.data.extra.label}}:\n</span> <span class="h4 ml-8">{{vm.widget3.data.extra.count}}</span></div></ms-widget-front><ms-widget-back \nclass="p-16 white-bg"><div class="flip-to-front"><md-button class="md-icon-button" ng-click="flipWidget()" \naria-label="Flip widget"><md-icon md-font-icon="icon-close" class="s16"></md-icon></md-button></div><div>\n{{vm.widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable="true" layout="column" flex="100" \nflex-gt-xs="50" flex-gt-md="25"><ms-widget-front class="white-bg"><div class="pl-16 pr-8 pv-16 h-55" layout="row" \nlayout-align="space-between center"><div class="h3">{{vm.widget4.title}}</div><md-menu><md-button \nclass="md-icon-button" ng-click="$mdMenu.open()" aria-label="more"><md-icon md-font-icon="icon-dots-vertical">\n</md-icon></md-button><md-menu-content width="2"><md-menu-item><md-button ng-click="flipWidget()" \naria-label="Flip widget">Details</md-button></md-menu-item><md-menu-item><md-button ng-click="refreshWidget()" \naria-label="Refresh widget">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass="pt-8 pb-32" layout="column" layout-align="center center"><div class="blue-grey-fg font-size-72 line-height-72">\n{{vm.widget4.data.count}}</div><div class="h3 secondary-text font-weight-500">{{vm.widget4.data.label}}</div></div><div\n class="p-16 grey-50-bg border-top" layout="row" layout-align="start center"><span \nclass="h4 secondary-text text-truncate">{{vm.widget4.data.extra.label}}:</span> <span class="h4 ml-8">\n{{vm.widget4.data.extra.count}}</span></div></ms-widget-front><ms-widget-back class="p-16 white-bg"><div \nclass="flip-to-front"><md-button class="md-icon-button" ng-click="flipWidget()" aria-label="Flip widget"><md-icon \nmd-font-icon="icon-close" class="s16"></md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back>\n</ms-widget></div><div class="widget-group" layout="row" flex="100" layout-wrap><ms-widget flippable="false" \nlayout="column" flex="100" flex-gt-md="65"><ms-widget-front class="white-bg"><div class="p-16" layout="row" \nlayout-align="space-between center"><div class="h3">{{vm.widget2_analytics.title}}</div><md-menu><md-button \naria-label="more" class="md-icon-button" ng-click="$mdMenu.open($event)"><md-icon md-font-icon="icon-dots-vertical">\n</md-icon></md-button><md-menu-content width="2"><md-menu-item><md-button ng-click="refreshWidget()" \naria-label="Refresh widget">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div>\n<ui-gmap-google-map center="vm.widget2_analytics.map.center" zoom="vm.widget2_analytics.map.zoom" \noptions="vm.widget2_analytics.map.options"><ui-gmap-polyline ng-repeat="p in vm.polylines" path="p.path" \nstroke="p.stroke" visible="p.visible" geodesic="p.geodesic" fit="false" editable="p.editable" draggable="p.draggable" \nicons="p.icons"></ui-gmap-polyline></ui-gmap-google-map></div></ms-widget-front></ms-widget><ms-widget \nflippable="false" layout="column" flex="100" flex-gt-md="35"><ms-widget-front class="white-bg"><div \nclass="ph-16 border-bottom" layout="row" layout-align="space-between center"><div class="h3">\n{{vm.widget3_analytics.title}}</div><div class="pv-16"><md-select class="simplified" \nng-model="vm.widget3_analytics.currentRange" aria-label="Change range"><md-option \nng-repeat="(key, range) in vm.widget3_analytics.ranges" value="{{key}}">{{range}}</md-option></md-select></div></div>\n<div class="ph-16 pv-20 border-bottom" \nng-repeat="page in vm.widget3_analytics.pages[vm.widget3_analytics.currentRange]" layout="row" \nlayout-align="space-between center"><div layout="column" flex><span class="h4 pb-10">{{page.path}}</span>\n<md-progress-linear class="md-accent" md-mode="determinate" value="{{page.value}}"></md-progress-linear></div><div \nclass="pl-32 h3 font-weight-500 secondary-text">{{page.value}}%</div></div></ms-widget-front></ms-widget></div>\n</md-tab></md-tabs></div></div><md-sidenav class="sidenav md-sidenav-right" md-is-locked-open="$mdMedia(\'gt-md\')" \nmd-component-id="sidenav" ms-scroll ms-sidenav-helper><div class="widget-group"><ms-widget flippable="false" \nclass="sidenav-widget"><ms-widget-front><div class="pl-16 pr-8 pv-16" layout="row" layout-align="space-between center">\n<div class="h3">\n{{vm.nowWidget.now.weekDay}}, {{vm.nowWidget.now.hour}}:{{vm.nowWidget.now.minute}}:{{vm.nowWidget.now.second}} {{vm.nowWidget.now.ampm}}\n</div><md-menu><md-button class="md-icon-button" ng-click="$mdMenu.open()" md-menu-origin md-menu-align-target \naria-label="Options"><md-icon md-font-icon="icon-dots-vertical" class="icon"></md-icon></md-button><md-menu-content \nwidth="3"><md-menu-item><md-button ng-click="vm.nowWidget.dummyFunction()"><md-icon md-font-icon="icon-refresh" \nclass="icon"></md-icon>Refresh</md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.nowWidget.dummyFunction()"><md-icon md-font-icon="icon-cog" class="icon"></md-icon>Settings</md-button>\n</md-menu-item></md-menu-content></md-menu></div><div class="p-16 pb-24" layout="column" layout-align="center center">\n<div class="h1 secondary-text"><span>{{vm.nowWidget.now.month}}</span></div><div \nclass="font-size-72 line-height-88 secondary-text font-weight-400">{{vm.nowWidget.now.day}}</div><div \nclass="h1 secondary-text"><span>{{vm.nowWidget.now.year}}</span></div></div><md-divider></md-divider></ms-widget-front>\n</ms-widget><ms-widget flippable="false" class="sidenav-widget"><ms-widget-front><div class="pl-16 pr-8 pv-16" \nlayout="row" layout-align="space-between center"><div class="h4"><md-icon md-font-icon="icon-map-marker" \nclass="icon mr-8"></md-icon>{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].name}}</div><md-menu>\n<md-button class="md-icon-button" ng-click="$mdMenu.open()" md-menu-origin md-menu-align-target aria-label="Options">\n<md-icon md-font-icon="icon-dots-vertical" class="icon"></md-icon></md-button><md-menu-content width="3"><md-menu-item>\n<md-button ng-click="vm.nowWidget.dummyFunction()"><md-icon md-font-icon="icon-refresh" class="icon"></md-icon>Refresh\n</md-button></md-menu-item><md-menu-item><md-button ng-click="vm.nowWidget.dummyFunction()"><md-icon \nmd-font-icon="icon-cog" class="icon"></md-icon>Settings</md-button></md-menu-item></md-menu-content></md-menu></div>\n<div class="p-16 pb-32" layout="column" layout-align="center center"><div layout="row" layout-align="center center">\n<md-icon md-font-icon="{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].icon}}" class="icon s40 mr-16">\n</md-icon><span class="md-display-2 font-weight-300 secondary-text">\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].temp[vm.weatherWidget.tempUnit]}} </span><span \nclass="font-size-48 font-weight-300 hint-text text-super ml-8">&deg;</span> <span \nclass="md-display-2 font-weight-300 hint-text">{{vm.weatherWidget.tempUnit}}</span></div></div><div \nclass="grey-300-bg p-16" layout="row" layout-align="space-between center"><div layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-weather-windy" class="icon mr-8 s20"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].windSpeed[vm.weatherWidget.speedUnit]}} </span><span \nclass="secondary-text ml-5">{{vm.weatherWidget.speedUnit}}</span></div><div layout="row" layout-align="start center">\n<md-icon md-font-icon="icon-compass-outline" class="icon mr-8 s20"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].windDirection}}</span></div><div layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-umbrella" class="icon mr-8 s20"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].rainProbability}}</span></div></div><div class="pv-16">\n<div class="pv-16 ph-24" layout="row" layout-align="space-between center" \nng-repeat="day in vm.weatherWidget.locations[vm.weatherWidget.currentLocation].next3Days"><span class="h4">{{day.name}}\n</span><div layout="row" layout-align="start center"><md-icon class="mr-16" md-font-icon="{{day.icon}}" class="icon">\n</md-icon><span class="h2">{{day.temp[vm.weatherWidget.tempUnit]}}</span> <span \nclass="h2 font-weight-300 secondary-text text-super">&deg;</span> <span class="h2 font-weight-300 secondary-text">\n{{vm.weatherWidget.tempUnit}}</span></div></div></div><md-divider></md-divider></ms-widget-front></ms-widget></div>\n</md-sidenav></div>');
$templateCache.put('app/main/apps/dashboards/project/init.html','');
$templateCache.put('app/main/apps/dashboards/server/dashboard-server.html','<div id="dashboard-server"><div id="widgets"><div class="widget-group" layout="row" flex="100" layout-wrap><ms-widget \nflippable="false" layout="row" flex="100"><ms-widget-front class="p-16 white-bg"><div class="pb-16" layout="row" \nlayout-align="space-between center"><div class="h3">{{vm.widget1.title}}</div><md-menu><md-button aria-label="more" \nclass="md-icon-button" ng-click="$mdMenu.open($event)"><md-icon md-font-icon="icon-dots-vertical"></md-icon>\n</md-button><md-menu-content width="2"><md-menu-item><md-button ng-click="refreshWidget()" aria-label="Refresh widget">\nRefresh</md-button></md-menu-item></md-menu-content></md-menu></div><div><nvd3 class="h-320" class="remove-x-lines" \noptions="vm.widget1.chart.options" data="vm.widget1.chart.data"></nvd3></div></ms-widget-front></ms-widget></div><div \nclass="widget-group" layout="row" flex="100" layout-wrap><ms-widget flippable="true" layout="column" flex="100" \nflex-gt-xs="50" flex-gt-md="25"><ms-widget-front class="p-16 pink-400-bg white-fg"><div class="pb-24" layout="row" \nlayout-align="space-between center"><div layout="row" layout-align="start center"><md-icon class="m-0 mr-8" \nmd-font-icon="icon-harddisk"></md-icon><div class="h3">{{vm.widget2.title}}</div></div><md-menu><md-button \naria-label="more" class="md-icon-button" ng-click="$mdMenu.open($event)"><md-icon md-font-icon="icon-dots-vertical">\n</md-icon></md-button><md-menu-content width="2"><md-menu-item><md-button ng-click="flipWidget()" \naria-label="Flip widget">Details</md-button></md-menu-item><md-menu-item><md-button ng-click="refreshWidget()" \naria-label="Refresh widget">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class="pb-24" \nlayout="row" layout-align="start center"><div class="h2">{{vm.widget2.value.used}}</div><div \nclass="h2 secondary-text pl-8">/ {{vm.widget2.value.total}}</div></div><md-progress-linear md-mode="determinate" \nvalue="{{vm.widget2.value.percentage}}"></md-progress-linear></ms-widget-front><ms-widget-back \nclass="p-16 pr-32 pink-400-bg white-fg"><div class="flip-to-front"><md-button class="md-icon-button" \nng-click="flipWidget()" aria-label="Flip widget"><md-icon md-font-icon="icon-close" class="s16"></md-icon></md-button>\n</div><div>{{vm.widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable="true" layout="column" \nflex="100" flex-gt-xs="50" flex-gt-md="25"><ms-widget-front class="p-16 blue-bg white-fg"><div class="pb-24" \nlayout="row" layout-align="space-between center"><div layout="row" layout-align="start center"><md-icon \nclass="m-0 mr-8" md-font-icon="icon-server-network"></md-icon><div class="h3">{{vm.widget3.title}}</div></div><md-menu>\n<md-button aria-label="more" class="md-icon-button" ng-click="$mdMenu.open($event)"><md-icon \nmd-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content width="2"><md-menu-item><md-button \nng-click="flipWidget()" aria-label="Flip widget">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click="refreshWidget()" aria-label="Refresh widget">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class="pb-24" layout="row" layout-align="start end"><div class="h2">{{vm.widget3.value.used}}</div><div \nclass="h2 pl-8 secondary-text">/ {{vm.widget3.value.total}}</div></div><md-progress-linear md-mode="determinate" \nvalue="{{vm.widget3.value.percentage}}"></md-progress-linear></ms-widget-front><ms-widget-back \nclass="p-16 pr-32 blue-bg white-fg"><div class="flip-to-front"><md-button class="md-icon-button" \nng-click="flipWidget()" aria-label="Flip widget"><md-icon md-font-icon="icon-close" class="s16"></md-icon></md-button>\n</div><div>{{vm.widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable="true" layout="column" \nflex="100" flex-gt-xs="50" flex-gt-md="25"><ms-widget-front class="p-16 teal-400-bg white-fg"><div class="pb-24" \nlayout="row" layout-align="space-between center"><div layout="row" layout-align="start center"><md-icon \nclass="m-0 mr-8" md-font-icon="icon-clock-fast"></md-icon><div class="h3">{{vm.widget4.title}}</div></div><md-menu>\n<md-button aria-label="more" class="md-icon-button" ng-click="$mdMenu.open($event)"><md-icon \nmd-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content width="2"><md-menu-item><md-button \nng-click="flipWidget()" aria-label="Flip widget">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click="refreshWidget()" aria-label="Refresh widget">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class="pb-8 h1">{{vm.widget4.value}}</div><div class="chart-fill-16"><nvd3 \nclass="h-50 remove-opacity remove-line-stroke" config="vm.widget4.chart.config" options="vm.widget4.chart.options" \ndata="vm.widget4.chart.data"></nvd3></div></ms-widget-front><ms-widget-back class="p-16 pr-32 teal-400-bg white-fg">\n<div class="flip-to-front"><md-button class="md-icon-button" ng-click="flipWidget()" aria-label="Flip widget"><md-icon \nmd-font-icon="icon-close" class="s16"></md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back>\n</ms-widget><ms-widget flippable="true" layout="column" flex="100" flex-gt-xs="50" flex-gt-md="25"><ms-widget-front \nclass="p-16 indigo-400-bg white-fg"><div class="pb-24" layout="row" layout-align="space-between center"><div \nlayout="row" layout-align="start center"><md-icon class="m-0 mr-8" md-font-icon="icon-scale"></md-icon><div class="h3">\n{{vm.widget5.title}}</div></div><md-menu><md-button aria-label="more" class="md-icon-button" \nng-click="$mdMenu.open($event)"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item><md-button ng-click="flipWidget()" aria-label="Flip widget">Details</md-button></md-menu-item>\n<md-menu-item><md-button ng-click="refreshWidget()" aria-label="Refresh widget">Refresh</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div layout="column" layout-align="space-between" flex><div class="h1 pb-8" \nlayout="row" layout-align="start center"><span>{{vm.widget5.value}}</span><md-icon md-font-icon="icon-trending-down" \nclass="ml-16"></md-icon></div><div class="secondary-text">{{vm.widget5.footnote}}</div></div></ms-widget-front>\n<ms-widget-back class="p-16 pr-32 indigo-400-bg white-fg"><div class="flip-to-front"><md-button class="md-icon-button" \nng-click="flipWidget()" aria-label="Flip widget"><md-icon md-font-icon="icon-close" class="s16"></md-icon></md-button>\n</div><div>{{vm.widget5.detail}}</div></ms-widget-back></ms-widget></div><div class="widget-group" layout="row" \nflex="100" layout-wrap><ms-widget flippable="false" layout="row" flex="100"><ms-widget-front class="p-16 white-bg"><div\n class="pb-24" layout="row" layout-align="space-between center"><div class="h3">{{vm.widget6.title}}</div><md-menu>\n<md-button aria-label="more" class="md-icon-button" ng-click="$mdMenu.open($event)"><md-icon \nmd-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content width="2"><md-menu-item><md-button \nng-click="refreshWidget()" aria-label="Refresh widget">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div><nvd3 class="h-140 remove-x-lines remove-opacity" config="vm.widget6.chart.config" \noptions="vm.widget6.chart.options" data="vm.widget6.chart.data"></nvd3></div></ms-widget-front></ms-widget></div><div \nclass="widget-group" layout="row" flex="100" layout-wrap><ms-widget flippable="false" layout="row" flex="100" \nflex-gt-md="60"><ms-widget-front class="white-bg"><div class="ph-16 pv-24 border-bottom" layout="row" \nlayout-align="space-between center"><div layout="row" layout-align="start center"><span class="h3">{{vm.widget7.title}}\n</span> <span class="ml-16 text-boxed pink-bg white-fg">{{vm.widget7.table.rows.length}} processes</span></div>\n<md-menu><md-button aria-label="more" class="md-icon-button" ng-click="$mdMenu.open($event)"><md-icon \nmd-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content width="2"><md-menu-item><md-button \nng-click="refreshWidget()" aria-label="Refresh widget">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><table class="dataTable row-border hover" datatable="ng" dt-options="vm.widget7.dtOptions"><thead><tr><th \nclass="secondary-text" ng-repeat="column in ::vm.widget7.table.columns"><div class="table-header"><span \nclass="column-title">{{column.title}}</span></div></th></tr></thead><tbody><tr \nng-repeat="row in ::vm.widget7.table.rows"><td ng-repeat="cell in row"><span class="{{cell.classes}}">{{cell.value}}\n</span></td></tr></tbody></table></ms-widget-front></ms-widget><ms-widget flippable="false" layout="row" flex="100" \nflex-gt-md="40"><ms-widget-front class="white-bg"><div class="ph-16 pv-24 border-bottom" layout="row" \nlayout-align="space-between center"><div layout="row" layout-align="start center"><span class="h3">{{vm.widget8.title}}\n</span> <span class="ml-16 text-boxed blue-bg white-fg">Showing last {{vm.widget8.activities.length}} activity</span>\n</div><md-menu><md-button aria-label="more" class="md-icon-button" ng-click="$mdMenu.open($event)"><md-icon \nmd-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content width="2"><md-menu-item><md-button \nng-click="refreshWidget()" aria-label="Refresh widget">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class="ph-16 pv-15 border-bottom" layout="row" layout-align="start center" \nng-repeat="activity in vm.widget8.activities"><div><i class="icon pr-16 mr-16 border-right" \nng-class="{\'icon-arrow-down red-fg\':activity.type === \'Input\', \'icon-arrow-up green-fg\':activity.type === \'Output\'}">\n</i></div><div class="h4 text-bold" flex>{{activity.process}}</div><div class="h4 font-weight-500 secondary-text">\n{{activity.value}}</div></div></ms-widget-front></ms-widget></div></div></div>');
$templateCache.put('app/main/apps/dashboard/views/general-widgets.html','<ms-widget ng-click="vm.openDialog(vm.data.risks,\'RISKS\', $event)" flippable="false" layout="row" flex="100" \nflex-gt-sm="50" class="pb-0"><ms-widget-front class="white-bg"><div class="ph-16 border-bottom" layout="row" \nlayout-align="space-between center"><div class="h3 pv-10">{{ \'DASHBOARD.ACTIVE_RISKS\' | translate}}</div></div><div \nlayout="row" layout-align="center center" class="risk-details-gauge"><div class="pt-8 pb-15" layout="column" \nlayout-align="center center"><div class="font-size-72 line-height-72 {{vm.getClassbySize(vm.data.risks.length)}}">\n{{vm.data.risks.length}}</div><div ng-if="vm.data.risks.length<=1" class="h3 secondary-text font-weight-500">\n{{ \'DASHBOARD.NEED_ATTENTION\' | translate}}</div><div ng-if="vm.data.risks.length>1" \nclass="h3 secondary-text font-weight-500">{{ \'DASHBOARD.NEED_ATTENTION_PLURAL\' | translate}}</div></div></div>\n</ms-widget-front></ms-widget><ms-widget ng-click="vm.openDialog(vm.data.tasks_next,\'PENDING_TASKS\', $event)" \nflippable="false" layout="row" flex="100" flex-gt-sm="50" class="pb-0"><ms-widget-front class="white-bg"><div \nclass="ph-16 border-bottom" layout="row" layout-align="center center"><div class="h3 pv-10">\n{{ \'DASHBOARD.TASKS\' | translate}}</div></div><div layout="row" layout-align="center center" \nclass="risk-details-gauge"><div class="pt-8 pb-15" layout="column" layout-align="center center"><div \nclass="font-size-72 line-height-72 {{vm.getClassbySize(vm.data.tasks_next.length)}}">{{vm.data.tasks_next.length}}\n</div><div ng-if="vm.data.tasks_next.length <= 1" class="h3 secondary-text font-weight-500">\n{{ \'DASHBOARD.PENDING_TASKS\' | translate}}</div><div ng-if="vm.data.tasks_next.length> 1" \nclass="h3 secondary-text font-weight-500">{{ \'DASHBOARD.PENDING_TASKS_PLURAL\' | translate}}</div></div></div>\n</ms-widget-front></ms-widget><ms-widget ng-click="vm.openDialog(vm.data.tasks_due,\'DUE_TASKS\', $event)" \nflippable="false" layout="row" flex="100" flex-gt-sm="50" class="pb-0"><ms-widget-front class="white-bg"><div \nclass="ph-16 border-bottom" layout="row" layout-align="center center"><div class="h3 pv-10">\n{{ \'DASHBOARD.TASKS\' | translate}}</div></div><div layout="row" layout-align="center center" \nclass="risk-details-gauge"><div class="pt-8 pb-15" layout="column" layout-align="center center"><div \nclass="font-size-72 line-height-72 {{vm.getClassbySize(vm.data.tasks_due.length)}}">{{vm.data.tasks_due.length}}</div>\n<div ng-if="vm.data.tasks_due.length <= 1" class="h3 secondary-text font-weight-500">\n{{ \'DASHBOARD.DUE_TASKS\' | translate}}</div><div ng-if="vm.data.tasks_due.length> 1" \nclass="h3 secondary-text font-weight-500">{{ \'DASHBOARD.DUE_TASKS_PLURAL\' | translate}}</div></div></div>\n</ms-widget-front></ms-widget><ms-widget ng-click="vm.openDialog(vm.data.evidences,\'EVIDENCES\', $event)" \nflippable="false" layout="row" flex="100" flex-gt-sm="50" class="pb-0"><ms-widget-front class="white-bg"><div \nclass="ph-16 border-bottom" layout="row" layout-align="space-between center"><div class="h3 pv-10">\n{{ \'DASHBOARD.EVIDENCES\' | translate}}</div></div><div layout="row" layout-align="center center" \nclass="risk-details-gauge"><div class="pt-8 pb-15" layout="column" layout-align="center center"><div \nclass="font-size-72 line-height-72 {{vm.getClassbySize(vm.data.evidences.length)}}">{{vm.data.evidences.length}}</div>\n<div ng-if="vm.data.evidences.length <= 1" class="h3 secondary-text font-weight-500">\n{{ \'DASHBOARD.EVIDENCES_NO_QUALIFIED\' | translate}}</div><div ng-if="vm.data.evidences.length> 1" \nclass="h3 secondary-text font-weight-500">{{ \'DASHBOARD.EVIDENCES_NO_QUALIFIED_PLURAL\' | translate}}</div></div></div>\n</ms-widget-front></ms-widget><ms-widget ng-click="vm.openDialog(vm.data.activities,\'ACTIVITIES\', $event)" \nflippable="false" layout="row" flex="100" flex-gt-sm="50" class="pb-0"><ms-widget-front class="white-bg"><div \nclass="ph-16 border-bottom" layout="row" layout-align="space-between center"><div class="h3 pv-10">\n{{ \'DASHBOARD.LAST_ACTIVITY\' | translate}}</div></div><div layout="row" layout-align="center center" \nclass="risk-details-gauge"><div class="pt-8 pb-15" layout="column" layout-align="center center"><div \nclass="font-size-72 line-height-72 {{vm.getClassbySize(vm.data.activities.length)}}">{{vm.data.activities.length}}\n</div><div ng-if="vm.data.activities.length <= 1" class="h3 secondary-text font-weight-500">\n{{ \'DASHBOARD.ACTIVITY\' | translate}}</div><div ng-if="vm.data.activities.length> 1" \nclass="h3 secondary-text font-weight-500">{{ \'DASHBOARD.ACTIVITIES\' | translate}}</div></div></div></ms-widget-front>\n</ms-widget><ms-widget ng-click="vm.openDialog(vm.data.files,\'FILES\', $event)" flippable="false" layout="row" \nflex="100" flex-gt-sm="50" class="pb-0"><ms-widget-front class="white-bg"><div class="ph-16 border-bottom" \nlayout="row" layout-align="center center"><div class="h3 pv-10">{{ \'DASHBOARD.LAST_DOCUMENTS\' | translate}}</div></div>\n<div layout="row" layout-align="center center" class="risk-details-gauge"><div class="pt-8 pb-15" layout="column" \nlayout-align="center center"><div class="font-size-72 line-height-72 {{vm.getClassbySize(vm.data.files.length)}}">\n{{vm.data.files.length}}</div><div ng-if="vm.data.files.length <= 1" class="h3 secondary-text font-weight-500">\n{{ \'DASHBOARD.DOCUMENT\' | translate}}</div><div ng-if="vm.data.files.length> 1" \nclass="h3 secondary-text font-weight-500">{{ \'DASHBOARD.DOCUMENTS\' | translate}}</div></div></div></ms-widget-front>\n</ms-widget><ms-widget ng-click="vm.openDialog(vm.data.complaints,\'COMPLAINTS\', $event)" flippable="false" \nlayout="row" flex="100" flex-gt-sm="50"><ms-widget-front class="white-bg"><div class="ph-16 border-bottom" \nlayout="row" layout-align="center center"><div class="h3 pv-10">{{ \'DASHBOARD.ALL_COMPLAINTS\' | translate}}</div></div>\n<div layout="row" layout-align="center center" class="risk-details-gauge"><div class="pt-8 pb-15" layout="column" \nlayout-align="center center"><div class="font-size-72 line-height-72 {{vm.getClassbySize(vm.data.complaints.length)}}">\n{{vm.data.complaints.length}}</div><div ng-if="vm.data.complaints.length <= 1" \nclass="h3 secondary-text font-weight-500">{{ \'DASHBOARD.COMPLAINT\' | translate}}</div><div \nng-if="vm.data.complaints.length> 1" class="h3 secondary-text font-weight-500">{{ \'DASHBOARD.COMPLAINTS\' | translate}}\n</div></div></div></ms-widget-front></ms-widget><ms-widget flippable="false" layout="row" flex="100" flex-gt-sm="50">\n<ms-widget-front class="white-bg"><div class="ph-16 border-bottom" layout="row" layout-align="space-between center">\n<div class="h3 pv-10">{{ \'DASHBOARD.RISK_MAP\' | translate}}</div></div><div id="pieChart" layout="row" \nlayout-align="center center" class="risk-details-gauge" flex="100"><nvd3 ng-init="vm.forceRealodChart()" \nstyle="margin: auto;" id="snap2" options="vm.optionsDonut" data="vm.d3Data" class="donut-general"></nvd3><div \nclass="graph-data" layout="column"><span style="font-size: 15px;" class="data-percent" \nng-bind-html="vm.riskLevelPercent(vm.data.riskmap[0].average)"></span> <span class="data-text" \nng-bind-html="vm.riskLevelText(vm.data.riskmap[0].average)"></span></div></div></ms-widget-front></ms-widget>');
$templateCache.put('app/main/apps/documents/views/toolbar.html','<div layout="row" layout-align="start center"><md-checkbox class="no-label" \naria-label="{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}" \nng-checked="vm.selectedThreads.length > 0" ng-click="vm.toggleSelectThreads()"></md-checkbox><div \nclass="divider-vertical" hide="" show-gt-xs=""></div><md-button aria-label="ADD NEW" \nng-click="vm.openImportDialog($event)" \nclass="md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme" hide show-gt-sm \ntranslate="DOCUMENTS.ADD" type="button">Add new</md-button><md-button aria-label="ADD NEW" \nng-click="vm.openImportDialog($event)" \nclass="md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme" hide-gt-sm type="button">\n<md-icon md-font-icon="icon-plus"></md-icon></md-button><div class="divider-vertical" hide="" show-gt-xs=""></div><div \nlayout="row" layout-align="start center" class="groups-trigger"><button aria-label="view group" \nclass="md-button md-icon-button" ng-click="vm.toggleSidenav(\'documents-sidenav\')" translate \ntranslate-attr-aria-label="DOCUMENTS.VIEW_FOLDERS"><md-icon \nclass="md-default-theme material-icons icon-folder-multiple"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="DOCUMENTS.VIEW_FOLDERS"></span></md-tooltip></button></div><div aria-hidden="false" class="action-buttons" \nlayout="row" layout-align="start center" ng-show="vm.selectedThreads.length > 0" hide show-gt-xs><div \nclass="divider-vertical" hide="" show-gt-xs=""></div><md-button ng-click="vm.deleteDocument($event)" \naria-label="Delete" class="md-icon-button" hide="" show-gt-sm="" translate="" \ntranslate-attr-aria-label="DOCUMENTS.DELETE"><md-icon md-font-icon="icon-delete"></md-icon><md-tooltip><span \ntranslate="DOCUMENTS.DELETE">Delete</span></md-tooltip></md-button><div class="divider-vertical" hide="" show-gt-xs="">\n</div></div><div class="divider-vertical" hide="" show-gt-xs=""></div><ms-search-bar debounce="300" \nmodel-search="$root.pagination_searchquery" on-result-click="vm.searchResultClick(item)" on-search="vm.search(query)" \nlayout="row" layout-align="start center"></ms-search-bar></div><div layout="row" layout-align="start center" \ntranslate-attr-aria-label="DOCUMENTS.REFRESH" class="qiu-pagination" ng-hide="isLoading"><span class="page-info" \nhide="" show-gt-xs="">{{pagination_totalItems | number}} <span translate="GLOBAL.ITEMS_FOUND"></span></span><md-button \naria-label="Previous" class="md-icon-button arrow" hide="" ng-click="pagination_prevPage()" \nng-disabled="pagination_firstPage()" show-gt-xs="" translate="" translate-attr-aria-label="DOCUMENTS.PREVIOUS"><md-icon\n md-font-icon="icon-chevron-left"></md-icon><md-tooltip hide show-gt-xs><span translate="DOCUMENTS.PREVIOUS">Previous\n</span></md-tooltip></md-button><div hide show-gt-xs><md-select ng-model="pagination_page" placeholder="Page" \nclass="toolbar-item"><md-option ng-repeat="n in [].constructor(pagination_total_pages) track by $index" \nvalue="{{$index +1}}" ng-click="pagination_gotoPage($index+1)">{{$index+1}}</md-option></md-select><md-tooltip><span \ntranslate="DOCUMENTS.SELECT_PAGE">Select page</span></md-tooltip></div><span class="page-info ml-10" hide="" \nshow-gt-xs="">/ <span class="ml-5">{{pagination_total_pages | number}}</span></span><md-button aria-label="Next" \nclass="md-icon-button arrow" hide="" ng-click="pagination_nextPage()" ng-disabled="pagination_morePages()" \nshow-gt-xs="" translate="" translate-attr-aria-label="DOCUMENTS.NEXT"><md-icon md-font-icon="icon-chevron-right">\n</md-icon><md-tooltip hide show-gt-xs><span translate="DOCUMENTS.NEXT">Next</span></md-tooltip></md-button><div \nclass="divider-vertical" hide hide show-gt-sm></div><div class="limit-select mr-10 ml-10" ng-if="!isLoading" hide \nshow-gt-sm><md-select class="md-table-select" ng-model="$root.perPage" md-container-class="md-pagination-select" \naria-label="Rows" placeholder="{{ $pagination.limitOptions[0] }}"><md-option ng-repeat="p in perPagePresets" \nng-value="p">{{p}} {{::option.label ? option.label : option}}</md-option></md-select><md-tooltip hide show-gt-xs><span \ntranslate="DOCUMENTS.ITEMS_PER_PAGE"></span></md-tooltip></div><div class="divider-vertical" hide hide show-gt-sm>\n</div></div>');
$templateCache.put('app/main/apps/questions/templates/add-more-questions.html','<div ng-if="vm.showAddMoreQuestionsDialog" class="add-questions-overlay" ng-click="vm.cancelAddMoreQuestions()"></div>\n<div id="add-more-questions-dialog" ng-if="vm.showAddMoreQuestionsDialog" class="add-questions-dialog"><div \nclass="dialog-header" layout="row" layout-align="space-between center"><div layout="row" layout-align="start center">\n<h3 class="text-uppercase" translate="QUESTIONS.SELECT_ADDITIONAL_QUESTIONS">Gestionar preguntas del cuestionario</h3>\n</div><div layout="row" layout-align="end center"><md-button class="md-raised" ng-click="vm.cancelAddMoreQuestions()" \ntranslate="GLOBAL.CANCEL">Cancelar</md-button><md-button class="md-raised md-accent" ng-click="vm.addMoreQuestions()" \ntranslate="GLOBAL.ACCEPT" ng-disabled="!vm.hasChanges()">Aceptar</md-button></div></div><div class="search-container" \nlayout="row" layout-align="start center"><md-input-container class="search-input" flex><md-icon \nmd-font-icon="icon-magnify" class="search-icon"></md-icon><input type="text" ng-model="vm.searchQuestionText" \nng-model-options="{debounce: 300}" placeholder="{{\'QUESTIONS.SEARCH_QUESTIONS\' | translate}}"></md-input-container>\n</div><div class="dialog-content"><div class="questions-list"><div class="dialog-question-item" \nng-repeat="question in vm.filteredQuestions track by $index" ng-init="parentIndex= $index" md-no-ink \nng-class="{\'question-active\': question.selected, \'question-answered\': question.is_finished == 1}"><div layout="column" \nlayout-gt-xs="row" layout-align="space-between center" flex="100" class="pt-10 pb-10"><div layout="row" \nlayout-align="start center" flex><md-checkbox class="no-label" ng-checked="question.selected" \nng-click="question.is_finished != 1 && (question.selected = !question.selected)" \nng-disabled="question.is_finished == 1"></md-checkbox><div class="dialog-avatar" \nng-class="question.selected ? \'md-green-300-bg\' : \'md-blue-300-bg\'">{{($index + 1)}}</div><div layout="column" \nclass="dialog-field"><strong class="grey-800-fg" ng-bind-html="question.name"></strong><div><strong \nclass="grey-800-fg">{{\'GLOBAL.RISK\' | translate}}: </strong><strong class="grey-500-fg" \nng-bind-html="question.processes[0].risks[0].name"></strong></div><div class="question-status" \nng-if="question.selected && question.is_finished == 1"><span class="status-badge answered" \ntranslate="QUESTIONS.QUESTION_ANSWERED">Respondida</span></div><div class="question-status" \nng-if="question.selected && question.is_finished != 1"><span class="status-badge active" \ntranslate="QUESTIONS.QUESTION_ACTIVE">Activa</span></div><div class="question-status" ng-if="!question.selected"><span \nclass="status-badge inactive" translate="QUESTIONS.QUESTION_INACTIVE">Inactiva</span></div></div></div></div></div><div\n class="no-results" ng-if="vm.searchQuestionText && vm.filteredQuestions.length === 0" layout="column" \nlayout-align="center center"><md-icon md-font-icon="icon-magnify" class="no-results-icon"></md-icon><p \nclass="no-results-text" translate="QUESTIONS.NO_SEARCH_RESULTS">\nNo se encontraron preguntas que coincidan con tu b\xFAsqueda</p></div></div></div></div>');
$templateCache.put('app/main/apps/questions/templates/init-questions.html','<div id="list-content-data" ng-style="{\'opacity\' : isLoading ? 0.5 : 1}"><div \nclass="fixed z-index-10 md-toolbar-tools grey-100-bg"><md-checkbox class="no-label" ng-checked="vm.isAllChecked()" \nng-click="vm.isAllChecked() ? vm.unselectAllQuestions() : vm.selectAllQuestions()"></md-checkbox><h3 \nclass="text-uppercase" translate="QUESTIONS.SELECT_QUESTIONS"></h3><md-button class="md-accent md-raised" \nng-click="vm.startQuestionnaire()" translate="GLOBAL.ACCEPT"></md-button></div><div class="pt-65"><div \nclass="mail-list-item" ng-repeat="question in vm.allQuestions track by $index" ng-init="parentIndex= $index" md-no-ink>\n<div lauyout="column" layout-gt-xs="row" layout-align="space-between center" flex="100" class="pt-10 pb-10"><div \nlayout="row" layout-align="start center" flex><md-checkbox class="no-label" ng-checked="question.selected" \nng-click="question.selected= !question.selected"></md-checkbox><div class="avatar md-blue-300-bg">{{($index + 1)}}\n</div><div layout="column" class="field"><strong class="grey-800-fg" ng-bind-html="question.name"></strong><div><strong\n class="grey-800-fg">{{\'GLOBAL.RISK\' | translate}}: </strong><strong class="grey-500-fg" \nng-bind-html="question.processes[0].risks[0].name"></strong></div></div></div></div></div></div></div>');
$templateCache.put('app/main/components/charts/c3/c3.html','<div id="c3" class="page-layout simple fullwidth doc-page chart-doc-page"><div class="header md-accent-bg" \nlayout="row" layout-align="space-between"><div layout="column" layout-align="center start"><div class="breadcrumb" \nlayout="row" layout-align="start center"><md-icon md-font-icon="icon-home" class="s16"></md-icon><md-icon \nmd-font-icon="icon-chevron-right" class="s16 separator"></md-icon><span class="parent">COMPONENTS</span><md-icon \nmd-font-icon="icon-chevron-right" class="s16 separator"></md-icon><span class="parent">CHARTS</span></div><div \nclass="title">C3.js</div></div><div layout="row" layout-align="start center"><md-button \nclass="md-raised reference-button" href="http://jettro.github.io/c3-angular-directive/" target="_blank"><md-icon \nmd-font-icon="icon-link"></md-icon><span>Reference</span></md-button></div></div><div class="content"><div \nclass="md-title">Line Chart</div><div class="card md-whiteframe-4dp"><c3chart bindto-id="line-chart"><chart-column \ncolumn-id="data 1" column-name="Data 1" column-color="red" column-values="30,200,100,400,150,250" column-type="line">\n<chart-column column-id="data 2" column-name="Data 2" column-color="green" column-values="50,20,10,40,15,25" \ncolumn-type="line"><chart-grid show-x="false" show-y="true"></chart-grid></c3chart></div><div class="md-title">\nLine Area Chart</div><div class="card md-whiteframe-4dp"><c3chart bindto-id="line-area-chart"><chart-column \ncolumn-id="data 1" column-name="Data 1" column-color="red" column-values="30,200,100,400,150,250" column-type="area">\n<chart-column column-id="data 2" column-name="Data 2" column-color="green" column-values="50,20,10,40,15,25" \ncolumn-type="area"><chart-grid show-x="false" show-y="true"></chart-grid></c3chart></div><div class="md-title">\nSpline Chart</div><div class="card md-whiteframe-4dp"><c3chart bindto-id="spline-chart"><chart-column \ncolumn-id="data 1" column-name="Data 1" column-color="red" column-values="30,200,100,400,150,250" column-type="spline">\n<chart-column column-id="data 2" column-name="Data 2" column-color="green" column-values="50,20,10,40,15,25" \ncolumn-type="spline"><chart-grid show-x="false" show-y="true"></chart-grid></c3chart></div><div class="md-title">\nSpline Area Chart</div><div class="card md-whiteframe-4dp"><c3chart bindto-id="spline-area-chart"><chart-column \ncolumn-id="data 1" column-name="Data 1" column-color="red" column-values="30,200,100,400,150,250" \ncolumn-type="area-spline"><chart-column column-id="data 2" column-name="Data 2" column-color="green" \ncolumn-values="50,20,10,40,15,25" column-type="area-spline"><chart-grid show-x="false" show-y="true"></chart-grid>\n</c3chart></div><div class="md-title">Step Chart</div><div class="card md-whiteframe-4dp"><c3chart \nbindto-id="step-chart"><chart-column column-id="data 1" column-name="Data 1" column-color="red" \ncolumn-values="30,200,100,400,150,250" column-type="step"><chart-column column-id="data 2" column-name="Data 2" \ncolumn-color="green" column-values="50,20,10,40,15,25" column-type="step"><chart-grid show-x="false" show-y="true">\n</chart-grid></c3chart></div><div class="md-title">Step Area Chart</div><div class="card md-whiteframe-4dp"><c3chart \nbindto-id="step-area-chart"><chart-column column-id="data 1" column-name="Data 1" column-color="red" \ncolumn-values="30,200,100,400,150,250" column-type="area-step"><chart-column column-id="data 2" column-name="Data 2" \ncolumn-color="green" column-values="50,20,10,40,15,25" column-type="area-step"><chart-grid show-x="false" \nshow-y="true"></chart-grid></c3chart></div><div class="md-title">Stacked Bar Chart</div><div \nclass="card md-whiteframe-4dp"><c3chart bindto-id="stacked-bar-plot1-chart"><chart-column column-id="data 1" \ncolumn-name="Data 1" column-color="red" column-values="30,200,100,400,150,250" column-type="bar"><chart-column \ncolumn-id="data 2" column-name="Data 2" column-color="green" column-values="50,20,10,40,15,25" column-type="bar">\n<chart-group group-values="data 1,data 2"></c3chart></div><div class="md-title">Scatter Plot Chart</div><div \nclass="card md-whiteframe-4dp"><c3chart bindto-id="scatter-plot2-chart"><chart-column column-id="Data 1 x" \ncolumn-values="3.2, 3.2, 3.1, 2.3, 2.8, 2.8, 3.3, 2.4, 2.9, 2.7, 2.0, 3.0, 2.2, 2.9, 2.9, 3.1, 3.0, 2.7, 2.2, 2.5, 3.2, 2.8, 2.5, 2.8, 2.9, 3.0, 2.8, 3.0, 2.9, 2.6, 2.4, 2.4, 2.7, 2.7, 3.0, 3.4, 3.1, 2.3, 3.0, 2.5, 2.6, 3.0, 2.6, 2.3, 2.7, 3.0, 2.9, 2.9, 2.5, 2.8">\n<chart-column column-id="Data 2 x" \ncolumn-values="3.3, 2.7, 3.0, 2.9, 3.0, 3.0, 2.5, 2.9, 2.5, 3.6, 3.2, 2.7, 3.0, 2.5, 2.8, 3.2, 3.0, 3.8, 2.6, 2.2, 3.2, 2.8, 2.8, 2.7, 3.3, 3.2, 2.8, 3.0, 2.8, 3.0, 2.8, 3.8, 2.8, 2.8, 2.6, 3.0, 3.4, 3.1, 3.0, 3.1, 3.1, 3.1, 2.7, 3.2, 3.3, 3.0, 2.5, 3.0, 3.4, 3.0">\n<chart-column column-id="Data 1" \ncolumn-values="1.4, 1.5, 1.5, 1.3, 1.5, 1.3, 1.6, 1.0, 1.3, 1.4, 1.0, 1.5, 1.0, 1.4, 1.3, 1.4, 1.5, 1.0, 1.5, 1.1, 1.8, 1.3, 1.5, 1.2, 1.3, 1.4, 1.4, 1.7, 1.5, 1.0, 1.1, 1.0, 1.2, 1.6, 1.5, 1.6, 1.5, 1.3, 1.3, 1.3, 1.2, 1.4, 1.2, 1.0, 1.3, 1.2, 1.3, 1.3, 1.1, 1.3" \ncolumn-type="scatter"><chart-column column-id="Data 2" \ncolumn-values="2.5, 1.9, 2.1, 1.8, 2.2, 2.1, 1.7, 1.8, 1.8, 2.5, 2.0, 1.9, 2.1, 2.0, 2.4, 2.3, 1.8, 2.2, 2.3, 1.5, 2.3, 2.0, 2.0, 1.8, 2.1, 1.8, 1.8, 1.8, 2.1, 1.6, 1.9, 2.0, 2.2, 1.5, 1.4, 2.3, 2.4, 1.8, 1.8, 2.1, 2.4, 2.3, 1.9, 2.3, 2.5, 2.3, 1.9, 2.0, 2.3, 1.8" \ncolumn-type="scatter"><chart-axes values-xs="Data 1:Data 1 x,Data 2:Data 2 x"></c3chart></div><div class="md-title">\nPie Chart</div><div class="card md-whiteframe-4dp"><c3chart bindto-id="pie-plot1-chart"><chart-column \ncolumn-id="Data 1" column-values="70" column-type="pie"><chart-column column-id="Data 2" column-values="35" \ncolumn-type="pie"><chart-column column-id="Data 3" column-values="60" column-type="pie"><chart-pie expand="true">\n</c3chart></div><div class="md-title">Donut Chart</div><div class="card md-whiteframe-4dp"><c3chart \nbindto-id="donut-plot1-chart"><chart-column column-id="Data 1" column-values="70" column-type="donut"><chart-column \ncolumn-id="Data 2" column-values="35" column-type="donut"><chart-column column-id="Data 3" column-values="60" \ncolumn-type="donut"><chart-donut title="Donut" width="60"></c3chart></div><div class="md-title">Gauge Chart</div><div \nclass="card md-whiteframe-4dp"><c3chart bindto-id="gauge-plot1-chart"><chart-column column-id="Data 1" \ncolumn-values="70" column-type="gauge"><chart-gauge min="50" max="75" units=" hours" width="39"></c3chart></div></div>\n</div>');
$templateCache.put('app/main/components/charts/chart-js/chart-js.html','<div id="chartJs" class="page-layout simple fullwidth doc-page chart-doc-page"><div class="header md-accent-bg" \nlayout="row" layout-align="space-between"><div layout="column" layout-align="center start"><div class="breadcrumb" \nlayout="row" layout-align="start center"><md-icon md-font-icon="icon-home" class="s16"></md-icon><md-icon \nmd-font-icon="icon-chevron-right" class="s16 separator"></md-icon><span class="parent">COMPONENTS</span><md-icon \nmd-font-icon="icon-chevron-right" class="s16 separator"></md-icon><span class="parent">CHARTS</span></div><div \nclass="title">Chart.js</div></div><div layout="row" layout-align="start center"><md-button \nclass="md-raised reference-button" href="https://github.com/jtblin/angular-chart.js" target="_blank"><md-icon \nmd-font-icon="icon-link"></md-icon><span>Reference</span></md-button></div></div><div class="content"><div \nclass="md-title">Line Chart</div><div class="card md-whiteframe-4dp"><canvas id="line" class="chart chart-line" \nchart-data="vm.lineChart.data" chart-labels="vm.lineChart.labels" chart-legend="true" \nchart-series="vm.lineChart.series"></canvas></div><div class="md-title">Bar Chart</div><div \nclass="card md-whiteframe-4dp"><canvas id="bar" class="chart chart-bar" chart-data="vm.barChart.data" \nchart-labels="vm.barChart.labels"></canvas></div><div class="md-title">Doughnut Chart</div><div \nclass="card md-whiteframe-4dp"><canvas id="doughnut" class="chart chart-doughnut" chart-data="vm.doughnutChart.data" \nchart-labels="vm.doughnutChart.labels"></canvas></div><div class="md-title">Radar Chart</div><div \nclass="card md-whiteframe-4dp"><canvas id="radar" class="chart chart-radar" chart-data="vm.radarChart.data" \nchart-labels="vm.radarChart.labels"></canvas></div><div class="md-title">Pie Chart</div><div \nclass="card md-whiteframe-4dp"><canvas id="pie" class="chart chart-pie" chart-data="vm.pieChart.data" \nchart-labels="vm.pieChart.labels"></canvas></div><div class="md-title">Polar Area Chart</div><div \nclass="card md-whiteframe-4dp"><canvas id="polar-area" class="chart chart-polar-area" chart-data="vm.polarChart.data" \nchart-labels="vm.polarChart.labels"></canvas></div></div></div>');
$templateCache.put('app/main/components/charts/nvd3/nvd3.html','<div id="nvd3" class="page-layout simple fullwidth doc-page chart-doc-page"><div class="header md-accent-bg" \nlayout="row" layout-align="space-between"><div layout="column" layout-align="center start"><div class="breadcrumb" \nlayout="row" layout-align="start center"><md-icon md-font-icon="icon-home" class="s16"></md-icon><md-icon \nmd-font-icon="icon-chevron-right" class="s16 separator"></md-icon><span class="parent">COMPONENTS</span><md-icon \nmd-font-icon="icon-chevron-right" class="s16 separator"></md-icon><span class="parent">CHARTS</span></div><div \nclass="title">nvD3</div></div><div layout="row" layout-align="start center"><md-button \nclass="md-raised reference-button" href="http://krispo.github.io/angular-nvd3/#/" target="_blank"><md-icon \nmd-font-icon="icon-link"></md-icon><span>Reference</span></md-button></div></div><div class="content"><div \nclass="md-title">Line Chart</div><div class="card md-whiteframe-4dp"><nvd3 options="vm.lineChart.options" \ndata="vm.lineChart.data" class="with-3d-shadow with-transitions"></nvd3></div><div class="md-title">Stacked Area Chart\n</div><div class="card md-whiteframe-4dp"><nvd3 options="vm.stackedAreaChart.options" data="vm.stackedAreaChart.data">\n</nvd3></div><div class="md-title">Sparkline Chart</div><div class="card md-whiteframe-4dp"><nvd3 \noptions="vm.sparklineChart.options" data="vm.sparklineChart.data"></nvd3></div><div class="md-title">\nHistorical Bar Chart</div><div class="card md-whiteframe-4dp"><nvd3 options="vm.historicalBarChart.options" \ndata="vm.historicalBarChart.data"></nvd3></div><div class="md-title">Multi Bar Horizontal Chart</div><div \nclass="card md-whiteframe-4dp"><nvd3 options="vm.multiBarHorizontalChart.options" \ndata="vm.multiBarHorizontalChart.data"></nvd3></div><div class="md-title">Pie Chart</div><div \nclass="card md-whiteframe-4dp"><nvd3 options="vm.pieChart.options" data="vm.pieChart.data"></nvd3></div><div \nclass="md-title">Donut Chart</div><div class="card md-whiteframe-4dp"><nvd3 options="vm.donutChart.options" \ndata="vm.donutChart.data"></nvd3></div><div class="md-title">Bullet Chart</div><div class="card md-whiteframe-4dp">\n<nvd3 options="vm.bulletChart.options" data="vm.bulletChart.data"></nvd3></div><div class="md-title">Scatter Chart\n</div><div class="card md-whiteframe-4dp"><nvd3 options="vm.scatterChart.options" data="vm.scatterChart.data"></nvd3>\n</div></div></div>');
$templateCache.put('app/main/components/charts/chartist/chartist.html','<div id="chartist" class="page-layout simple fullwidth doc-page chart-doc-page"><div class="header md-accent-bg" \nlayout="row" layout-align="space-between"><div layout="column" layout-align="center start"><div class="breadcrumb" \nlayout="row" layout-align="start center"><md-icon md-font-icon="icon-home" class="s16"></md-icon><md-icon \nmd-font-icon="icon-chevron-right" class="s16 separator"></md-icon><span class="parent">COMPONENTS</span><md-icon \nmd-font-icon="icon-chevron-right" class="s16 separator"></md-icon><span class="parent">CHARTS</span></div><div \nclass="title">Chartist</div></div><div layout="row" layout-align="start center"><md-button \nclass="md-raised reference-button" href="https://github.com/paradox41/angular-chartist.js" target="_blank"><md-icon \nmd-font-icon="icon-link"></md-icon><span>Reference</span></md-button></div></div><div class="content"><div \nclass="md-title">Line Chart</div><div class="card md-whiteframe-4dp"><chartist class="ct-chart ct-golden-section" \nchartist-data="vm.lineChart.data" chartist-chart-type="Line" chartist-chart-options="vm.lineChart.options"></chartist>\n</div><div class="md-title">Line Area Chart</div><div class="card md-whiteframe-4dp"><chartist \nclass="ct-chart ct-golden-section" chartist-data="vm.lineAreaChart.data" chartist-chart-type="Line" \nchartist-chart-options="vm.lineAreaChart.options"></chartist></div><div class="md-title">\nBi-polar Line Chart With Area Only</div><div class="card md-whiteframe-4dp"><chartist \nclass="ct-chart ct-golden-section" chartist-data="vm.biPolarLineChart.data" chartist-chart-type="Line" \nchartist-chart-options="vm.biPolarLineChart.options"></chartist></div><div class="md-title">Bar Chart</div><div \nclass="card md-whiteframe-4dp"><chartist class="ct-chart ct-golden-section" chartist-data="vm.barChart.data" \nchartist-chart-type="Bar" chartist-chart-options="vm.barChart.options" \nchartist-responsive-options="vm.barChart.responsiveOptions"></chartist></div><div class="md-title">Horizontal Bar Chart\n</div><div class="card md-whiteframe-4dp"><chartist class="ct-chart ct-golden-section" \nchartist-data="vm.horizontalBarChart.data" chartist-chart-type="Bar" \nchartist-chart-options="vm.horizontalBarChart.options"></chartist></div><div class="md-title">Bi-polar Bar Chart</div>\n<div class="card md-whiteframe-4dp"><chartist class="ct-chart ct-golden-section" \nchartist-data="vm.biPolarBarChart.data" chartist-chart-type="Bar" chartist-chart-options="vm.biPolarBarChart.options">\n</chartist></div><div class="md-title">Stacked Bar Chart</div><div class="card md-whiteframe-4dp"><chartist \nclass="ct-chart ct-golden-section" chartist-data="vm.stackedBarChart.data" chartist-chart-type="Bar" \nchartist-chart-options="vm.stackedBarChart.options" chartist-events="vm.stackedBarChart.events"></chartist></div><div \nclass="md-title">Doughnut Chart</div><div class="card md-whiteframe-4dp"><chartist class="ct-chart ct-golden-section" \nchartist-data="vm.donutChart.data" chartist-chart-type="Pie" chartist-chart-options="vm.donutChart.options"></chartist>\n</div><div class="md-title">Pie Chart</div><div class="card md-whiteframe-4dp"><chartist \nclass="ct-chart ct-golden-section" chartist-data="vm.pieChart.data" chartist-chart-type="Pie" \nchartist-chart-options="vm.pieChart.options" chartist-responsive-options="vm.pieChart.responsiveOptions"></chartist>\n</div><div class="md-title">Gauge Chart</div><div class="card md-whiteframe-4dp"><chartist \nclass="ct-chart ct-golden-section" chartist-data="vm.gaugeChart.data" chartist-chart-type="Pie" \nchartist-chart-options="vm.gaugeChart.options"></chartist></div></div></div>');
$templateCache.put('app/main/components/custom-directives/pages/ms-card.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="header md-accent-bg" layout="row" \nlayout-align="space-between"><div layout="column" layout-align="center start"><div class="breadcrumb" layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-home" class="s16"></md-icon><md-icon \nmd-font-icon="icon-chevron-right" class="s16 separator"></md-icon><span class="parent">COMPONENTS</span></div><div \nclass="title">ms-card</div></div></div><div class="content" layout="column"><div class="card md-whiteframe-4dp" \nlayout="column"><p><hljs language="html" class="source-code"><ms-card template="PATH_TO_TEMPLATE" \nng-model="CARD_MODEL_DATA"></ms-card></hljs></p><span class="h2 pt-16">Description:</span><p><b>ms-card</b>\n directive can be used for creating cards that follow Google\'s Material Design specifications. Currently it has 10 different pre-defined templates but you can always create your own templates and use them with the directive.\n</p><div class="simple-table-container md-whiteframe-1dp mv-16"><table class="simple"><thead><tr><th>Attribute</th><th>\nDescription</th></tr></thead><tbody><tr><td>template</td><td>\nThis attribute must be present in order to ms-card directive to work. It works similar to ng-include directive. You can either provide the path of the html template file or the variable that holds the path of the html template file.\n</td></tr><tr><td>ng-model</td><td>\nDirective uses ng-model to hold the card data. Data passed with using ng-model will be available in the template files within variable named card.\n</td></tr></tbody></table></div><span class="h2 pt-16">Example:</span><hljs language="html" class="source-code">\n<ms-card template="\'app/card-templates/my-custom-template.html\'" ng-model="vm.cardModel"></ms-card></hljs><p>\nAbove directive will use <span class="text-boxed">my-custom-template.html</span>\n file as a template. And you will be able to access to the <span class="text-boxed">vm.cardModel</span>\n object through card variable inside the template.</p><p>Consider the following object:<hljs language="js" \nclass="source-code">vm.cardModel = { title : \'My Card\', description: \'My card description\' }</hljs></p><p>\nIt will be available in the template file as:<hljs language="js" class="source-code">\ncard = { title : \'My Card\', description: \'My card description\' }</hljs></p><p>\nSo you will be able to access the title by doing<hljs language="js" class="source-code">{{card.title}}</hljs>\ninside the template file.</p></div></div></div>');
$templateCache.put('app/main/components/custom-directives/pages/ms-form-wizard.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="header md-accent-bg" layout="column" \nlayout-align="center start"><div class="breadcrumb"><span class="parent">Custom Directives</span></div><div \nclass="title">ms-form-wizard</div></div><div class="content" layout="column"><div class="card md-whiteframe-4dp" \nlayout="column"><span class="h2 pt-16">Description:</span><p>\nms-form-wizard directive is a helper directive that will help you to create form wizards. Combined with <b>md-tabs</b>\n and <b>form</b> elements, you will be able to create as much as steps you want.</p><span class="h2 pt-16">Example:\n</span><hljs language="html" class="source-code"><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected="msWizard.selectedIndex" md-center-tabs="true"><md-tab><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" ng-if="wizardStep1.$invalid">1\n</span> <span class="ms-form-wizard-step-number md-accent-bg" ng-if="wizardStep1.$valid"><i class="icon-check s16"></i>\n </span><span class="ms-form-wizard-step-text">Personal Information</span></span></md-tab-label><md-tab-body><form \nname="wizardStep1" class="md-inline-form" ms-form-wizard-form novalidate><div layout="column" layout-gt-xs="row" flex>\n<md-input-container flex="100" flex-gt-xs="50"><input type="text" name="firstname" ng-model="vm.formWizard.firstname" \nplaceholder="Firstname" required><div ng-messages="wizardStep1.firstname.$error" \nng-show="wizardStep1.firstname.$touched" role="alert"><div ng-message="required"><span>Firstname field is required.\n</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled="wizardStep1.$invalid">\n<md-tab-label><span class="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="wizardStep2.$invalid">2</span> <span class="ms-form-wizard-step-number md-accent-bg" ng-if="wizardStep2.$valid">\n<i class="icon-check s16"></i> </span><span class="ms-form-wizard-step-text">Address</span></span></md-tab-label>\n<md-tab-body><form name="wizardStep2" ms-form-wizard-form novalidate><md-input-container class="md-block"><label>\nAddress</label> <textarea ng-model="vm.formWizard.address" columns="1" md-maxlength="150" rows="5" required></textarea>\n<div ng-messages="wizardStep2.address.$error" ng-show="wizardStep2.address.$touched" role="alert" multiple="multiple">\n<div ng-message="required"><span>Address field is required.</span></div><div ng-message="md-maxlength"><span>\nAddress can\'t be longer than 150 characters.</span></div></div></md-input-container></form></md-tab-body></md-tab>\n<md-tab ng-disabled="wizardStep1.$invalid || wizardStep2.$invalid"><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" ng-if="wizardStep3.$invalid">3\n</span> <span class="ms-form-wizard-step-number md-accent-bg" ng-if="wizardStep3.$valid"><i class="icon-check s16"></i>\n </span><span class="ms-form-wizard-step-text">Payment Method</span></span></md-tab-label><md-tab-body><form \nname="wizardStep3" ms-form-wizard-form novalidate><md-input-container class="md-block"><input type="text" \nname="cardholder" ng-model="vm.formWizard.cardholder" placeholder="Card Holder" required><div \nng-messages="wizardStep3.cardholder.$error" ng-show="wizardStep3.cardholder.$dirty" role="alert"><div \nng-message="required"><span>Card holder field is required.</span></div></div></md-input-container></form></md-tab-body>\n</md-tab></md-tabs><div class="navigation" flex layout="row" layout-align="center center"><md-button \nclass="md-raised md-accent" ng-click="msWizard.previousStep()" ng-disabled="msWizard.isFirstStep()">Previous\n</md-button><div class="steps"><span ng-repeat="form in msWizard.forms" \nng-class="{\'selected md-accent-bg\':msWizard.selectedIndex === $index}"></span></div><md-button \nclass="md-raised md-accent" ng-click="msWizard.nextStep()" ng-hide="msWizard.isLastStep()" \nng-disabled="msWizard.currentStepInvalid()">Next</md-button><md-button class="md-raised md-warn" \nng-click="vm.sendForm(); msWizard.resetForm();" ng-show="msWizard.isLastStep()" \nng-disabled="msWizard.formsIncomplete()">Send</md-button></div></ms-form-wizard></hljs><p>\nFor more detailed usage, we recommend you to check <b>Forms</b> page from our demo application.</p></div></div></div>');
$templateCache.put('app/main/components/custom-directives/pages/ms-info-bar.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="header md-accent-bg" layout="column" \nlayout-align="center start"><div class="breadcrumb"><span class="parent">Custom Directives</span></div><div \nclass="title">ms-info-bar</div></div><div class="content" layout="column"><div class="card md-whiteframe-4dp" \nlayout="column"><hljs language="html" class="source-code"><ms-info-bar><div layout="row" layout-align="start center">\n<div class="white-fg" flex hide-xs>\nWe use cookies to ensure that we give you the best experience on our website. If you continue without changing your settings, we\'ll assume that you are happy to receive all cookies from this website.\n</div><md-button class="md-raised" layout="row" layout-align="center center" target="_blank" href="#"><md-icon \nmd-font-icon="icon-cart" class="mr-5 s18"></md-icon><span>Accept</span></md-button></div></ms-info-bar></hljs><span \nclass="h2 pt-16">Description:</span><p><b>ms-info-bar</b>\n is a helper directive that you can use to show information about your app. On close, its scope will be automatically destroyed.\n</p></div></div></div>');
$templateCache.put('app/main/components/custom-directives/pages/ms-masonry.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="header md-accent-bg" layout="column" \nlayout-align="center start"><div class="breadcrumb"><span class="parent">Custom Directives</span></div><div \nclass="title">ms-masonry</div></div><div class="content" layout="column"><div class="card md-whiteframe-4dp" \nlayout="column"><span class="h2 pt-16">Description:</span><p><b>ms-masonry</b>\n is a directive that you can use to create Masonry layouts. At the moment, it has 3 options which you can use to configure the directive:\n</p><hljs language="js" class="source-code">\nvm.masonryOptions = { columnCount : 5, reLayoutDebounce: 400, responsive : { md: 3, sm: 2, xs: 1 } }</hljs><span \nclass="h2 pt-16">Options:</span><div class="simple-table-container md-whiteframe-1dp mv-16"><table class="simple">\n<thead><tr><th>Options</th><th>Description</th></tr></thead><tbody><tr><td>columnCount</td><td>\n(integer) Column count defines the maximum column count of your masonry layout. ms-masonry will adjust the column count automatically based on \n<b>responsive</b> options and some other calculations.</td></tr><tr><td>reLayoutDebounce</td><td>\n(integer) Debounce amount in milliseconds before reLayout can happen. This will prevent reLayout action from happening too much if you are resizing your screen or the device rotation is being changed.\n</td></tr><tr><td>responsive</td><td>\n(object) You can define column counts for individual Angular Material media step definitions.</td></tr></tbody></table>\n</div><span class="h2 pt-16">Example:</span><p><hljs language="js" class="source-code"><ms-masonry \noptions="vm.masonryOptions"><ms-masonry-item></ms-masonry-item><ms-masonry-item></ms-masonry-item><ms-masonry-item>\n</ms-masonry-item>...</ms-masonry></hljs></p></div></div></div>');
$templateCache.put('app/main/components/custom-directives/pages/ms-material-color-picker.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="header md-accent-bg" layout="column" \nlayout-align="center start"><div class="breadcrumb"><span class="parent">Custom Directives</span></div><div \nclass="title">ms-material-color-picker</div></div><div class="content" layout="column"><div \nclass="card md-whiteframe-4dp" layout="column"><span class="h2 pt-16">Description:</span><p><b>ms-material-color-picker\n</b> directive allows you to pick any of the Material Design colors.</p><span class="h2 pt-16">Options:</span><div \nclass="simple-table-container md-whiteframe-1dp mv-16"><table class="simple"><thead><tr><th>Options</th><th>Description\n</th></tr></thead><tbody><tr><td>ms-model-type</td><td>\n(string) Model type of the color picker. Can be either `class` or `obj`</td></tr><tr><td>ng-model (required)</td><td>\nValue that will be updated on color pick</td></tr></tbody></table></div><span class="h2 pt-16">Example:</span><p>\nDepending on <b>ms-model-type</b>\n value, color picker will either update the model with the appropriate class name or the object:</p><hljs \nlanguage="html" class="source-code"><ms-material-color-picker ms-model-type="obj" ng-model="vm.color">\n</ms-material-color-picker></hljs><p>\nYou can also use transclusion to trigger the picker. Like in the below example, you can add a button or any other element to trigger the picker:\n</p><hljs language="html" class="source-code"><ms-material-color-picker ms-model-type="obj" ng-model="vm.color">\n<md-button>Select a Color</md-button></ms-material-color-picker></hljs><p><b>$selectedColor</b>\n variable can be used within the color picker element to access the properties of the selected color:</p><hljs \nlanguage="html" class="source-code"><ms-material-color-picker ms-model-type="obj" ng-model="vm.color"><md-button \nclass="{{$selectedColor}}">Select a Color</md-button></ms-material-color-picker></hljs></div></div></div>');
$templateCache.put('app/main/components/custom-directives/pages/ms-nav.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="header md-accent-bg" layout="column" \nlayout-align="center start"><div class="breadcrumb"><span class="parent">Custom Directives</span></div><div \nclass="title">ms-nav</div></div><div class="content" layout="column"><div class="card md-whiteframe-4dp" \nlayout="column"><p class="note"><b>Note:</b> This directive is deprecated. Use <b>ms-navigation</b> instead.</p><span \nclass="h2 pt-16">Description:</span><p>\nNavigation directive has couple other dependent directives. They all together used for creating the main navigation. \n<b>ms-nav</b> directive is compatible with Angular UI Router module.</p><span class="h2 pt-16">Example:</span><hljs \nlanguage="html" class="source-code"><ms-nav><ms-nav-item ms-nav-title><span>FUSE</span></ms-nav-item><ms-nav-item \nms-nav-toggle><a ms-nav-button md-ink-ripple><i class="icon-tile-four s16"></i> <span class="ms-nav-label" \ntranslate="NAVIGATION.DASHBOARDS">Dashboards</span> <i class="icon-chevron-down s16 arrow"></i></a>\n<ms-nav-toggle-items><ms-nav-item><a ms-nav-button ui-sref="app.dashboard-v1" ui-sref-active="active" md-ink-ripple>\n<span class="ms-nav-label">Dashboard v1</span></a></ms-nav-item><ms-nav-item><a ms-nav-button \nui-sref="app.dashboard-v2" ui-sref-active="active" md-ink-ripple><span class="ms-nav-label">Dashboard v2</span></a>\n</ms-nav-item></ms-nav-toggle-items></ms-nav-item></ms-nav></hljs></div></div></div>');
$templateCache.put('app/main/components/custom-directives/pages/ms-navigation.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="header md-accent-bg" layout="column" \nlayout-align="center start"><div class="breadcrumb"><span class="parent">Custom Directives</span></div><div \nclass="title">ms-navigation</div></div><div class="content" layout="column"><div class="card md-whiteframe-4dp" \nlayout="column"><p><hljs language="js" class="source-code">\nmsNavigationService.saveItem(\'NAVIGATION.ID\', {NAVIGATION_OPTIONS});</hljs></p><span class="h2 pt-16">Description:\n</span><p>\nSince version 1.2.0, Fuse no longer uses html based navigation. This way, you can add, update or remove navigation items at anytime from anywhere. To create navigation items, you can use Angular\'s \n<b>run</b> or <b>config</b> blocks as well as <b>services</b> and <b>controllers</b>.</p><p><b>ms-navigation</b>\n directive works parallel with <b>msNavigationService</b> and there are two main navigation styles: <b>Vertical</b>\n and <b>Horizontal</b>. The preferred style can be used by changing the layout of the template.</p><p>\nTo create a navigation item, you have to use either <b>msNavigationService</b> or <b>msNavigationServiceProvider</b>.\n</p><p class="mt-24">Calling <b>saveItem</b> on <em>msNavigationService</em> or <em>msNavigationServiceProvider</em>\n will either create a menu item, or update an existing one. This way you can update any existing menu item at any times by simply referring to it by using its id.\n</p><span class="h2 pt-16">Navigation Id:</span><p>\nNavigation id is a simple string that uses "dot notation" to create the hierarchy between the navigation items. For example, if you want to have a "Post Blog" navigation item under "Blog" navigation item, you should have "blog.post-blog" as the id of the navigation.\n</p><p>\nTo create a navigation item, you don\'t have to create its parent(s). If you create a navigation item by using "dashboard.project" id, the navigation item with the "dashboard" id will be automatically created for you. Then you can simply update the "dashboard" navigation item to change its options.\n</p><span class="h2 pt-16">Navigation Options:</span><div class="simple-table-container md-whiteframe-1dp mv-16"><table\n class="simple"><thead><tr><th>Options</th><th>Description</th></tr></thead><tbody><tr><td>title</td><td>\n(string) Title of the navigation item</td></tr><tr><td>group</td><td>\n(bool) Determines if the navigation item is going to be used for grouping</td></tr><tr><td>icon</td><td>\n(string) Icon class name of the navigation item</td></tr><tr><td>state</td><td>\n(string) UI-Router state name for the navigation item to be linked</td></tr><tr><td>stateParams</td><td>\n(object) UI-Router state parameters</td></tr><tr><td>translate</td><td>\n(string) angular-translate translation object id (e.g. "NAVIGATION.MAIL")</td></tr><tr><td>class</td><td>\n(string) Custom class name(s) to be applied to the navigation item</td></tr><tr><td>badge</td><td>\n(object) Badge to show in navigation item</td></tr><tr><td>weight</td><td>\n(int) Determines the sort order of the navigation item</td></tr><tr><td>hidden</td><td>\n(function) Determines the visibility of the menu item. The function must return a <b>boolean</b> value.</td></tr>\n</tbody></table></div><span class="h2 pt-16">Example:</span><p>To create a navigation item from <b>Run</b> or <b>Config\n</b> blocks, you must use <b>msNavigationServiceProvider</b>:</p><hljs language="js" class="source-code">\n/** @ngInject */ function config(msNavigationServiceProvider) { // Navigation msNavigationServiceProvider.saveItem(\'apps\', { title : \'APPS\', group : true, weight: 1 }); // Apps.Dashboards msNavigationServiceProvider.saveItem(\'apps.dashboards\', { title : \'Dashboards\', icon : \'icon-tile-four\', class : \'navigation-dashboards\', weight: 1 }); // Apps.Dashboards.Project msNavigationServiceProvider.saveItem(\'apps.dashboards.project\', { title : \'Project\', state : \'app.dashboards_project\', stateParams: {\'id\': 1}, badge : { content: \'21\', color : \'red\' }, translate : \'NAVIGATION.DASHBOARDS.PROJECT\', class : \'navigation-dashboards project-dashboard\', weight : 1 }); // Apps.Dashboards.Server msNavigationServiceProvider.saveItem(\'apps.dashboards.server\', { title : \'Server\', state : \'app.dashboards_server\', stateParams: {\'id\': 1}, translate : \'NAVIGATION.DASHBOARDS.SERVER\', class : \'navigation-dashboards server-dashboard\', weight : 2 }); // Apps.Dashboards.Analytics msNavigationServiceProvider.saveItem(\'apps.dashboards.analytics\', { title : \'Analytics\', state : \'app.dashboards_analytics\', stateParams: {\'id\': 1}, translate : \'NAVIGATION.DASHBOARDS.ANALYTICS\', class : \'navigation-dashboards analytics-dashboard\', weight : 3 }); }\n</hljs><p class="mt-24">To do the same thing in <b>services</b> and <b>controllers</b>, you must use <b>\nmsNavigationService</b>:</p><hljs language="js" class="source-code">\n/** @ngInject */ function TestController(msNavigationService) { // Navigation msNavigationService.saveItem(\'apps\', { title : \'APPS\', group : true, weight: 1 }); // Apps.Dashboards msNavigationService.saveItem(\'apps.dashboards\', { title : \'Dashboards\', icon : \'icon-tile-four\', class : \'navigation-dashboards\', weight: 1 }); // Apps.Dashboards.Project msNavigationService.saveItem(\'apps.dashboards.project\', { title : \'Project\', state : \'app.dashboards_project\', stateParams: {\'id\': 1}, badge : { content: \'21\', color : \'red\' }, translate : \'NAVIGATION.DASHBOARDS.PROJECT\', class : \'navigation-dashboards project-dashboard\', weight : 1 }); // Apps.Dashboards.Server msNavigationService.saveItem(\'apps.dashboards.server\', { title : \'Server\', state : \'app.dashboards_server\', stateParams: {\'id\': 1}, translate : \'NAVIGATION.DASHBOARDS.SERVER\', class : \'navigation-dashboards server-dashboard\', weight : 2 }); // Apps.Dashboards.Analytics msNavigationService.saveItem(\'apps.dashboards.analytics\', { title : \'Analytics\', state : \'app.dashboards_analytics\', stateParams: {\'id\': 1}, translate : \'NAVIGATION.DASHBOARDS.ANALYTICS\', class : \'navigation-dashboards analytics-dashboard\', weight : 3 }); }\n</hljs><p class="mt-24">\nYou can specify a hidden value within your navigation item configuration to have more control on its visibility. It accepts a function and that function must return a boolean value.\n</p><p>\nms-navigation will watch that function and whenever the AuthService.isAdmin value changes, the visibility of the navigation item will be updated automatically.\n</p><hljs language="js" class="source-code">\n/** @ngInject */ function TestController(msNavigationService) { // Navigation msNavigationService.saveItem(\'apps\', { title : \'APPS\', group : true, weight: 1 }); // Apps.Dashboards msNavigationService.saveItem(\'apps.dashboards\', { title : \'Dashboards\', icon : \'icon-tile-four\', class : \'navigation-dashboards\', hidden: function () { return AuthService.isAdmin; // must be a boolean value }, weight: 1 }); }\n</hljs><p class="mt-24">\nIf you wish to remove an item from the navigation at runtime, you can use deleteItem() method. It\'s available in both \n<b>msNavigationService</b> and <b>msNavigationServiceProvider</b>:</p><hljs language="js" class="source-code">\n/** @ngInject */ function TestController(msNavigationService) { // Delete the \'apps\' item msNavigationService.deleteItem(\'apps\'); }\n</hljs><span class="h2 pt-16">Directive:</span><p>To show the navigation, you can use <b>ms-navigation</b> element:</p>\n<hljs lang="html" class="source-code"><ms-navigation class="scrollable" folded="vm.folded" root="apps.dashboards">\n</ms-navigation></hljs><div class="simple-table-container md-whiteframe-1dp mv-16"><table class="simple"><thead><tr>\n<th>Options</th><th>Description</th></tr></thead><tbody><tr><td>folded</td><td>\n(boolean) Sets the initial folded status of the navigation</td></tr><tr><td>root</td><td>\n(string) You can specify the root item key in here to make navigation to show only certain navigation group. This might be useful if you are showing different menu groups to different users or using Fuse as both front and backend apps.\n</td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/main/components/custom-directives/pages/ms-random-class.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="header md-accent-bg" layout="column" \nlayout-align="center start"><div class="breadcrumb"><span class="parent">Custom Directives</span></div><div \nclass="title">ms-random-class</div></div><div class="content" layout="column"><div class="card md-whiteframe-4dp" \nlayout="column"><hljs language="html" class="source-code"><div ms-random-class="vm.colors"></div></hljs><span \nclass="h2 pt-16">Description:</span><p><b>ms-random-class</b>\n directive can be used for adding randomly selected class from an array. It\'s used mainly for generating random background colors in the template, but you can use it anywhere if you find it useful.\n</p><div class="simple-table-container md-whiteframe-1dp mv-16"><table class="simple"><thead><tr><th>Attribute</th><th>\nDescription</th></tr></thead><tbody><tr><td>ms-random-class</td><td>\n(Array) This attribute must be present in order to ms-random-class directive to work.</td></tr></tbody></table></div>\n<span class="h2 pt-16">Example:</span><hljs language="js" class="source-code">\nvm.colors = [ \'yellow\', \'red\', \'blue\', \'orange\', \'green\' ]</hljs><hljs language="html" class="source-code"><div \nms-random-class="vm.colors"></div></hljs></div></div></div>');
$templateCache.put('app/main/components/custom-directives/pages/ms-responsive-table.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="header md-accent-bg" layout="column" \nlayout-align="center start"><div class="breadcrumb"><span class="parent">Custom Directives</span></div><div \nclass="title">ms-responsive-table</div></div><div class="content" layout="column"><div class="card md-whiteframe-4dp" \nlayout="column"><hljs language="html" class="source-code"><table class="simple" ms-responsive-table></table></hljs>\n<span class="h2 pt-16">Description:</span><p><b>ms-responsive-table</b>\n directive is useful for making tables responsive. It will simply add a scrollable wrapper around the table to make them usable in smaller screens.\n</p></div></div></div>');
$templateCache.put('app/main/components/custom-directives/pages/ms-scroll.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="header md-accent-bg" layout="column" \nlayout-align="center start"><div class="breadcrumb"><span class="parent">Custom Directives</span></div><div \nclass="title">ms-scroll</div></div><div class="content" layout="column"><div class="card md-whiteframe-4dp" \nlayout="column"><hljs language="html" class="source-code"><div ms-scroll></div></hljs><span class="h2 pt-16">\nDescription:</span><p><b>ms-scroll</b>\n directive can be used for adding custom scrollbars to the scrollable content. Fuse uses <a \nhref="https://github.com/noraesae/perfect-scrollbar" target="_blank">Perfect Scrollbar</a>\n as a custom scrollbar. You can also use this directive with <em>scrollable</em> helper class. <em>scrollable</em>\n class will make any content scrollable and then you can add custom scrollbars by adding <b>ms-scroll</b>\n directive to the same element:</p><hljs language="html" class="source-code"><div class="scrollable" ms-scroll></div>\n</hljs></div></div></div>');
$templateCache.put('app/main/components/custom-directives/pages/ms-search-bar.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="header md-accent-bg" layout="column" \nlayout-align="center start"><div class="breadcrumb"><span class="parent">Custom Directives</span></div><div \nclass="title">ms-search-bar</div></div><div class="content" layout="column"><div class="card md-whiteframe-4dp" \nlayout="column"><hljs language="html" class="source-code"><ms-search-bar></ms-search-bar></hljs><span class="h2 pt-16">\nDescription:</span><p><b>ms-search-bar</b>\n is an autocomplete supported search bar directive. It has various options and events for you to use.</p><span \nclass="h2 pt-16">Options:</span><div class="simple-table-container md-whiteframe-1dp mv-16"><table class="simple">\n<thead><tr><th>Options</th><th>Description</th></tr></thead><tbody><tr><td>debounce</td><td>\n(integer) Model update debounce. Can be used to stop triggering the on-search event for every keystroke.</td></tr><tr>\n<td>on-search</td><td>\n(function (query)) A callback function that will trigger on model update. Must return an Array or a Promise object that caries an Array. Has \'query\' parameter to access the search query.\n</td></tr><tr><td>on-result-click</td><td>\n(function (item)) A callback function that will trigger on search result click. Has \'item\' parameter to access the clicked item.\n</td></tr><tr><td>on-expand</td><td>(function) A callback function that will trigger when search bar expanded.</td>\n</tr><tr><td>on-collapse</td><td>(function) A callback function that will trigger when search bar collapsed.</td></tr>\n</tbody></table></div><span class="h2 pt-16">Example:</span><hljs language="html" class="source-code"><ms-search-bar \non-search="vm.search(query)" on-result-click="vm.searchResultClick(item)" debounce="300"></ms-search-bar></hljs></div>\n</div></div>');
$templateCache.put('app/main/components/custom-directives/pages/ms-shortcuts.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="header md-accent-bg" layout="column" \nlayout-align="center start"><div class="breadcrumb"><span class="parent">Custom Directives</span></div><div \nclass="title">ms-shortcuts</div></div><div class="content" layout="column"><div class="card md-whiteframe-4dp" \nlayout="column"><span class="h2 pt-16">Description:</span><p><b>ms-shortcuts</b>\n is a directive that you can use to add shortcuts for navigation items. It works in parallel with <b>ms-navigation</b>\n directive to get its data. It has built in search, add and remove shortcut functions.</p><span class="h2 pt-16">\nExample:</span><hljs language="html" class="source-code"><ms-shortcuts></ms-shortcuts></hljs></div></div></div>');
$templateCache.put('app/main/components/custom-directives/pages/ms-sidenav-helper.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="header md-accent-bg" layout="column" \nlayout-align="center start"><div class="breadcrumb"><span class="parent">Custom Directives</span></div><div \nclass="title">ms-sidenav-helper</div></div><div class="content" layout="column"><div class="card md-whiteframe-4dp" \nlayout="column"><hljs language="html" class="source-code"><md-sidenav class="sidenav" md-component-id="main-sidenav" \nms-scroll ms-sidenav-helper></md-sidenav></hljs><span class="h2 pt-16">Description:</span><p><b>ms-sidenav-helper</b>\n directive is required if you use sidenavs inside the page content. You can check out the <em>\napp/main/ui/layouts/simple/left-sidenav/left-sidenav.html</em> file for the simple usage.</p><p>\nSimply, this directive will add a class to the certain elements in order to page and the sidenav act correctly on all devices.\n</p></div></div></div>');
$templateCache.put('app/main/components/custom-directives/pages/ms-splash-screen.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="header md-accent-bg" layout="column" \nlayout-align="center start"><div class="breadcrumb"><span class="parent">Custom Directives</span></div><div \nclass="title">ms-splash-screen</div></div><div class="content" layout="column"><div class="card md-whiteframe-4dp" \nlayout="column"><hljs language="html" class="source-code"><ms-splash-screen></ms-splash-screen></hljs><span \nclass="h2 pt-16">Description:</span><p><b>ms-splash-screen</b>\n is a helper directive that helps splash screen to disappear.</p></div></div></div>');
$templateCache.put('app/main/components/custom-directives/pages/ms-stepper.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="header md-accent-bg" layout="column" \nlayout-align="center start"><div class="breadcrumb"><span class="parent">Custom Directives</span></div><div \nclass="title">ms-stepper</div></div><div class="content" layout="column"><div class="card md-whiteframe-4dp" \nlayout="column"><span class="h2 pt-16">Description:</span><p><b>ms-stepper</b>\n is a form step directive that follows Google\'s Material Design specifications. It allows you to create stepped forms. Unlike \n<b>ms-form-wizard</b>\n, this directive doesn\'t use any other material elements, therefore it\'s a lot more flexible and easy to use:</p><hljs \nlanguage="html" class="source-code"><form name="stepper" ms-stepper ng-submit="vm.submitStepper()" \nng-model="vm.stepper" novalidate><ms-stepper-step ng-form="step1" step="1" step-title="\'Personal Information\'"><div \nng-include="\'app/main/ui/forms/stepper-steps/step-1.html\'"></div></ms-stepper-step><ms-stepper-step ng-form="step2" \nstep="2" step-title="\'Address\'" optional-step><div ng-include="\'app/main/ui/forms/stepper-steps/step-2.html\'"></div>\n</ms-stepper-step><ms-stepper-step ng-form="step3" step="3" step-title="\'Payment Method\'"><div \nng-include="\'app/main/ui/forms/stepper-steps/step-3.html\'"></div></ms-stepper-step></form></hljs><span \nclass="h2 pt-16">ms-stepper-step</span><p>This directive requires <b>ms-stepper</b>\n directive and it\'s used for creating individual steps. You can either directly wrap your forms with this directive, or you can use ng-include to include them.\n</p><span class="h2 pt-16">ms-stepper-step Attributes</span><div \nclass="simple-table-container md-whiteframe-1dp mv-16"><table class="simple"><thead><tr><th>Attribute</th><th>\nDescription</th></tr></thead><tbody><tr><td>ng-form</td><td>\n(string) This attribute/directive is required for steps to work correctly. It requires a unique, string value. You can think this as the unique name of the step.\n</td></tr><tr><td>step [Optional]</td><td>\n(integer) Optional value for the step number. If you want to manually order your steps, you can use this attribute.\n</td></tr><tr><td>step-title</td><td>(string) Step title that will show up in the step navigation.</td></tr><tr><td>\noptional-step [Optional]</td><td>\nIf given, this attribute will make the step optional. Therefore, that step can be passed through without filling its input fields and it will not be included into the main form validity check.\n</td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/main/components/custom-directives/pages/ms-timeline.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="header md-accent-bg" layout="column" \nlayout-align="center start"><div class="breadcrumb"><span class="parent">Custom Directives</span></div><div \nclass="title">ms-timeline</div></div><div class="content" layout="column"><div class="card md-whiteframe-4dp" \nlayout="column"><hljs language="html" class="source-code"><div id="timeline" ms-timeline \nms-timeline-load-more="vm.loadNextPage()"><div ms-timeline-item ng-repeat="timelineItem in vm.timeline"><div \nclass="timeline-card"><ms-card template="timelineItem.card.template" ng-model="timelineItem.card"></ms-card></div><div \nclass="timeline-point md-accent-bg md-whiteframe-2dp"><md-icon md-font-icon="{{timelineItem.icon}}"></md-icon></div>\n<div class="timeline-detail"><div class="time">{{timelineItem.time}}</div><div class="event">{{timelineItem.event}}\n</div></div></div></div></hljs><span class="h2 pt-16">Description:</span><p><b>ms-timeline</b>\n directive is required for timeline. It will help loading and animating the timeline items properly. We highly recommend you to check \n<em>app/main/pages/timeline/timeline.html</em> and <em>app/main/pages/timeline/timeline.controller.js</em>\n to fully understand how to use it.</p></div></div></div>');
$templateCache.put('app/main/components/custom-directives/pages/ms-widget.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="header md-accent-bg" layout="column" \nlayout-align="center start"><div class="breadcrumb"><span class="parent">Custom Directives</span></div><div \nclass="title">ms-widget</div></div><div class="content" layout="column"><div class="card md-whiteframe-4dp" \nlayout="column"><hljs language="html" class="source-code"><ms-widget flippable="true"><ms-widget-front \nclass="padding-16 md-white-bg"></ms-widget-front><ms-widget-back class="padding-16 md-white-bg"></ms-widget-back>\n</ms-widget></hljs><span class="h2 pt-16">Description:</span><p><b>ms-widget</b>\n directive is a helper directive for creating widgets. When it used with helper classes such as padding, margin, height helpers, it\'s very easy to create custom widgets.\n</p><div class="simple-table-container md-whiteframe-1dp mv-16"><table class="simple"><thead><tr><th>Attribute</th><th>\nDescription</th></tr></thead><tbody><tr><td>flippable</td><td>\nIf it\'s true, widget will be flippable. If you don\'t want to make the widget flippable, you can make this attribute false and use only \n<b>&lt;ms-widget-front&gt;&lt;/ms-widget-front&gt;</b> wrapper to show widget content.</td></tr></tbody></table></div>\n</div></div></div>');
$templateCache.put('app/main/components/maps/tabs/custom-marker.html','<ui-gmap-google-map center="vm.customMarkerMap.center" zoom="vm.customMarkerMap.zoom"><ui-gmap-marker \ncoords="vm.customMarkerMap.marker.coords" idkey="vm.customMarkerMap.marker.id" \noptions="vm.customMarkerMap.marker.options"></ui-gmap-marker></ui-gmap-google-map>');
$templateCache.put('app/main/components/maps/tabs/info-window.html','<ui-gmap-google-map center="vm.simpleMarkerMap.center" zoom="vm.simpleMarkerMap.zoom"><ui-gmap-marker \ncoords="vm.simpleMarkerMap.marker.coords" idkey="vm.simpleMarkerMap.marker.id"><ui-gmap-window show="\'true\'"><div \nng-non-bindable=""><div id="siteNotice"></div><h1 id="firstHeading" class="firstHeading">Uluru</h1><div \nid="bodyContent"><p><b>Uluru</b>, also referred to as <b>Ayers Rock</b>\n, is a large sandstone rock formation in the southern part of the Northern Territory, central Australia.</p><p>\nAttribution: Uluru, <a href="//en.wikipedia.org/w/index.php?title=Uluru&amp;oldid=297882194">\nhttp://en.wikipedia.org/w/index.php?title=Uluru</a> (last visited June 22, 2009).</p></div></div></ui-gmap-window>\n</ui-gmap-marker></ui-gmap-google-map>');
$templateCache.put('app/main/components/maps/tabs/satellite.html','<ui-gmap-google-map center="vm.satelliteMap.center" zoom="vm.satelliteMap.zoom" options="vm.satelliteMap.options">\n</ui-gmap-google-map>');
$templateCache.put('app/main/components/maps/tabs/simple-marker.html','<ui-gmap-google-map center="vm.simpleMarkerMap.center" zoom="vm.simpleMarkerMap.zoom"><ui-gmap-marker \ncoords="vm.simpleMarkerMap.marker.coords" idkey="vm.simpleMarkerMap.marker.id"></ui-gmap-marker></ui-gmap-google-map>');
$templateCache.put('app/main/components/maps/tabs/simple.html','<ui-gmap-google-map center="vm.simpleMap.center" zoom="vm.simpleMap.zoom"></ui-gmap-google-map>');
$templateCache.put('app/main/components/maps/tabs/terrain.html','<ui-gmap-google-map center="vm.terrainMap.center" zoom="vm.terrainMap.zoom" options="vm.terrainMap.options">\n</ui-gmap-google-map>');
$templateCache.put('app/main/components/tables/simple-table/simple-table.html','<div id="simple-table" class="page-layout simple fullwidth doc-page element-doc-page"><div class="header md-accent-bg" \nlayout="row" layout-align="space-between"><div layout="column" layout-align="center start"><div class="breadcrumb" \nlayout="row" layout-align="start center"><md-icon md-font-icon="icon-home" class="s16"></md-icon><md-icon \nmd-font-icon="icon-chevron-right" class="s16 separator"></md-icon><span class="parent">Tables</span></div><div \nclass="title">Simple Table</div></div></div><div class="content">\nTables are used to present raw data sets, and usually appear in desktop enterprise products.<p>Data sets may include:\n</p><ul><li>Three or more columns of data</li><li>A corresponding visualization</li><li>\nThe ability for users to query and manipulate data at scale</li></ul><div \nclass="simple-table-container md-whiteframe-4dp"><div class="table-title">Employees</div><table class="simple" \nms-responsive-table><thead><tr><th>Name</th><th>Position</th><th>Office</th><th class="text-right">Age</th><th \nclass="text-right">Start Date</th><th class="text-right">Salary</th></tr></thead><tfoot><tr><td></td></tr></tfoot>\n<tbody><tr ng-repeat="person in vm.employees"><td class="name">{{person.name}}</td><td class="position">\n{{person.position}}</td><td class="office">{{person.office}}</td><td class="age text-right">{{person.age}}</td><td \nclass="start-date text-right">{{person.startDate}}</td><td class="salary text-right">{{person.salary | currency}}</td>\n</tr></tbody></table></div></div></div>');
$templateCache.put('app/main/components/tables/datatable/datatable.html','<div id="simple-table" class="page-layout simple fullwidth doc-page element-doc-page"><div class="header md-accent-bg" \nlayout="row" layout-align="space-between"><div layout="column" layout-align="center start"><div class="breadcrumb" \nlayout="row" layout-align="start center"><md-icon md-font-icon="icon-home" class="s16"></md-icon><md-icon \nmd-font-icon="icon-chevron-right" class="s16 separator"></md-icon><span class="parent">Tables</span></div><div \nclass="title">Datatable</div></div><div layout="row" layout-align="start center"><md-button \nclass="md-raised reference-button" href="https://l-lin.github.io/angular-datatables" target="_blank"><md-icon \nmd-font-icon="icon-link"></md-icon><span>Reference</span></md-button></div></div><div class="content"><div \nclass="md-title mb-32">Zero Configuration</div><div class="white-bg md-whiteframe-4dp"><table \nclass="dataTable row-border hover" datatable="ng" dt-options="vm.dtOptions"><thead><tr><th class="secondary-text"><div \nclass="table-header"><span class="column-title">Name</span></div></th><th class="secondary-text"><div \nclass="table-header"><span class="column-title">Position</span></div></th><th class="secondary-text"><div \nclass="table-header"><span class="column-title">Office</span></div></th><th class="secondary-text"><div \nclass="table-header"><span class="column-title">Age</span></div></th><th class="secondary-text"><div \nclass="table-header"><span class="column-title">Start Date</span></div></th><th class="secondary-text"><div \nclass="table-header"><span class="column-title">Salary</span></div></th></tr></thead><tbody><tr \nng-repeat="employee in ::vm.employees"><td>{{ employee.name }}</td><td>{{ employee.position }}</td><td>\n{{ employee.office }}</td><td>{{ employee.age }}</td><td>{{ employee.startDate }}</td><td>{{ employee.salary }}</td>\n</tr></tbody></table></div></div></div>');
$templateCache.put('app/main/components/material-docs/demo/docs-demo.tmpl.html','<div class="doc-demo-content doc-content"><div flex layout="column" style="z-index:1"><div class="doc-description" \nng-bind-html="demoCtrl.demoDescription.contents | toHtml"></div><div ng-transclude></div><section \nclass="demo-container md-whiteframe-z1" ng-class="{\'show-source\': demoCtrl.$showSource}"><md-toolbar \nclass="demo-toolbar md-primary"><div class="md-toolbar-tools"><h3>{{demoCtrl.demoTitle}}</h3><span flex></span>\n<md-button class="md-icon-button" aria-label="View Source" ng-class="{ active: demoCtrl.$showSource }" \nng-click="demoCtrl.$showSource = !demoCtrl.$showSource"><md-tooltip md-autohide>View Source</md-tooltip><md-icon \nmd-svg-src="assets/angular-material-assets/img/icons/ic_code_24px.svg"></md-icon></md-button></div></md-toolbar>\n<md-tabs class="demo-source-tabs md-primary" md-dynamic-height ng-show="demoCtrl.$showSource"><md-tab \nng-repeat="file in demoCtrl.orderedFiles" label="{{file.name}}"><md-content md-scroll-y class="demo-source-container">\n<hljs class="no-header" code="file.contentsPromise" lang="{{file.fileType}}" \nshould-interpolate="demoCtrl.interpolateCode"></hljs></md-content></md-tab></md-tabs><demo-include \nfiles="demoCtrl.files" module="demoCtrl.demoModule" class="{{demoCtrl.demoId}}"></demo-include></section></div></div>');
$templateCache.put('app/main/components/material-docs/layout/layout-alignment.tmpl.html','<div ng-controller="LayoutCtrl" class="layout-content" ng-cloak><p>The <code>layout-align</code>\n directive takes two words. The first word says how the children will be aligned in the layout\'s direction, and the second word says how the children will be aligned perpendicular to the layout\'s direction.\n</p><p>Only one value is required for this directive. For example, <code>layout="row" layout-align="center"</code>\n would make the elements center horizontally and use the default behavior vertically.</p><p><code>\nlayout="column" layout-align="center end"</code>\n would make children align along the center vertically and along the end (right) horizontally.</p><table \nclass="md-api-table"><thead><tr><th>API</th><th>Sets child alignments within the layout container</th></tr></thead><tr>\n<td>layout-align</td><td>Sets default alignment unless overridden by another breakpoint.</td></tr><tr><td>\nlayout-align-xs</td><td>width &lt; <b>600</b>px</td></tr><tr><td>layout-align-gt-xs</td><td>width &gt;= <b>600</b>px\n</td></tr><tr><td>layout-align-sm</td><td><b>600</b>px &lt;= width &lt; <b>960</b>px</td></tr><tr><td>\nlayout-align-gt-sm</td><td>width &gt;= <b>960</b>px</td></tr><tr><td>layout-align-md</td><td><b>960</b>\npx &lt;= width &lt; <b>1280</b>px</td></tr><tr><td>layout-align-gt-md</td><td>width &gt;= <b>1280</b>px</td></tr><tr>\n<td>layout-align-lg</td><td><b>1280</b>px &lt;= width &lt; <b>1920</b>px</td></tr><tr><td>layout-align-gt-lg</td><td>\nwidth &gt;= <b>1920</b>px</td></tr><tr><td>layout-align-xl</td><td>width &gt;= <b>1920</b>px</td></tr></table><br><p>\nBelow is an interactive demo that lets you explore the visual results of the different settings:</p><div><docs-demo \ndemo-title=\'layout="{{layoutDemo.direction}}" &nbsp; &nbsp; &nbsp; layout-align="{{layoutAlign()}}"\' \nclass="small-demo colorNested" interpolate-code="true"><demo-file name="index.html"><div \nlayout="{{layoutDemo.direction}}" layout-align="{{layoutAlign()}}"><div>one</div><div>two</div><div>three</div></div>\n</demo-file></docs-demo></div><div layout="column" layout-gt-sm="row" layout-align="space-around"><div><md-subheader>\nLayout Direction</md-subheader><md-radio-group ng-model="layoutDemo.direction"><md-radio-button value="row">row\n</md-radio-button><md-radio-button value="column">column</md-radio-button></md-radio-group></div><div><md-subheader>\nAlignment in Layout Direction ({{layoutDemo.direction == \'row\' ? \'horizontal\' : \'vertical\'}})</md-subheader>\n<md-radio-group ng-model="layoutDemo.mainAxis"><md-radio-button value="">none</md-radio-button><md-radio-button \nvalue="start">start (default)</md-radio-button><md-radio-button value="center">center</md-radio-button><md-radio-button\n value="end">end</md-radio-button><md-radio-button value="space-around">space-around</md-radio-button><md-radio-button \nvalue="space-between">space-between</md-radio-button></md-radio-group></div><div><md-subheader>\nAlignment in Perpendicular Direction ({{layoutDemo.direction == \'column\' ? \'horizontal\' : \'vertical\'}})</md-subheader>\n<md-radio-group ng-model="layoutDemo.crossAxis"><md-radio-button value="none"><em>none</em></md-radio-button>\n<md-radio-button value="start">start</md-radio-button><md-radio-button value="center">center</md-radio-button>\n<md-radio-button value="end">end</md-radio-button><md-radio-button value="stretch">stretch (default)</md-radio-button>\n</md-radio-group></div></div></div>');
$templateCache.put('app/main/components/material-docs/layout/layout-children.tmpl.html','<div ng-controller="LayoutCtrl" class="layout-content" ng-cloak><h3>Children within a Layout Container</h3><p>\nTo customize the size and position of elements in a layout <b>container</b>, use the <code>flex</code>, <code>\nflex-order</code>, and <code>flex-offset</code> attributes on the container\'s <u>child</u> elements:</p><docs-demo \ndemo-title="Flex Directive" class="small-demo colorNested"><demo-file name="index.html"><div layout="row"><div \nflex="20">[flex="20"]</div><div flex="70">[flex="70"]</div><div flex hide-sm hide-xs>[flex]</div></div></demo-file>\n</docs-demo><p>Add the <code>flex</code>\n directive to a layout\'s child element and the element will flex (grow or shrink) to fit the area unused by other elements. \n<code>flex</code> defines how the element will adjust its size with respect to its <u>parent</u>\n container and the other elements within the container.</p><docs-demo demo-title="Flex Percent Values" \nclass="small-demo colorNested-noPad"><demo-file name="index.html"><div layout="row" layout-wrap><div flex="30">\n[flex="30"]</div><div flex="45">[flex="45"]</div><div flex="25">[flex="25"]</div><div flex="33">[flex="33"]</div><div \nflex="66">[flex="66"]</div><div flex="50">[flex="50"]</div><div flex>[flex]</div></div></demo-file></docs-demo><p>\nA layout child\'s <code>flex</code>\n directive can be given an integer value from 0-100. The element will stretch to the percentage of available space matching the value. Currently, the \n<code>flex</code> directive value is restricted to multiples of five, 33 or 66.</p><p>For example: <code>\nflex="5", flex="20", flex="33", flex="50", flex="66", flex="75", ... flex="100"</code>.</p><docs-demo \ndemo-title="Responsive Flex Directives" class="small-demo colorNested-noPad"><demo-file name="index.html"><div \nlayout="row"><div flex-gt-sm="66" flex="33">flex 33% on mobile,<br>and 66% on gt-sm devices.</div><div flex-gt-sm="33" \nflex="66">flex 66% on mobile,<br>and 33% on gt-sm devices.</div></div></demo-file></docs-demo><p>See the <a \nhref="layout/options">layout options page</a> for more information on responsive flex directives like <code>hide-sm\n</code> and <code>layout-wrap</code> used in the above examples.</p><br><hr><br><h3>Additional Flex Values</h3><p>\nThere are additional flex values provided by Angular Material to improve flexibility and to make the API easier to understand.\n</p><docs-demo demo-title="Other Flex Values" class="small-demo colorNested-noPad"><demo-file name="index.html"><div \nlayout="row" layout-wrap><div flex="none">[flex="none"]</div><div flex>[flex]</div><div flex="nogrow">[flex="nogrow"]\n</div><div flex="grow">[flex="grow"]</div><div flex="initial">[flex="initial"]</div><div flex="auto">[flex="auto"]\n</div><div flex="noshrink">[flex="noshrink"]</div><div flex="0">[flex="0"]</div></div></demo-file></docs-demo><table \nclass="md-api-table"><tr><td>flex</td><td>Will grow and shrink as needed. Starts with a size of 0%. Same as <code>\nflex="0"</code>.</td></tr><tr><td>flex="none"</td><td>Will not grow or shrink. Sized based on its <code>width</code>\n and <code>height</code> values.</td></tr><tr><td>flex="initial"</td><td>\nWill shrink as needed. Starts with a size based on its <code>width</code> and <code>height</code> values.</td></tr><tr>\n<td>flex="auto"</td><td>Will grow and shrink as needed. Starts with a size based on its <code>width</code> and <code>\nheight</code> values.</td></tr><tr><td>flex="grow"</td><td>\nWill grow and shrink as needed. Starts with a size of 100%. Same as <code>flex="100"</code>.</td></tr><tr><td>\nflex="nogrow"</td><td>Will shrink as needed, but won\'t grow. Starts with a size based on its <code>width</code> and \n<code>height</code> values.</td></tr><tr><td>flex="noshrink"</td><td>\nWill grow as needed, but won\'t shrink. Starts with a size based on its <code>width</code> and <code>height</code>\n values.</td></tr></table><br><hr><br><h3>Ordering HTML Elements</h3><p>Add the <code>flex-order</code>\n directive to a layout child to set its order position within the layout container. Any integer value from -20 to 20 is accepted.\n</p><docs-demo demo-title="Flex-Order Directive" class="small-demo colorNested"><demo-file name="index.html"><div \nlayout="row"><div flex flex-order="-1"><p>[flex-order="-1"]</p></div><div flex flex-order="1" flex-order-gt-md="3"><p \nhide-gt-md>[flex-order="1"]</p><p hide show-gt-md>[flex-order-gt-md="3"]</p></div><div flex flex-order="2"><p>\n[flex-order="2"]</p></div><div flex flex-order="3" flex-order-gt-md="1"><p hide-gt-md>[flex-order="3"]</p><p hide \nshow-gt-md>[flex-order-gt-md="1"]</p></div></div></demo-file></docs-demo><table class="md-api-table"><thead><tr><th>API\n</th><th>Device <b>width</b> when breakpoint overrides default</th></tr></thead><tr><td>flex-order</td><td>\nSets default layout order unless overridden by another breakpoint.</td></tr><tr><td>flex-order-xs</td><td>width &lt; \n<b>600</b>px</td></tr><tr><td>flex-order-gt-xs</td><td>width &gt;= <b>600</b>px</td></tr><tr><td>flex-order-sm</td><td>\n<b>600</b>px &lt;= width &lt; <b>960</b>px</td></tr><tr><td>flex-order-gt-sm</td><td>width &gt;= <b>960</b>px</td></tr>\n<tr><td>flex-order-md</td><td><b>960</b>px &lt;= width &lt; <b>1280</b>px</td></tr><tr><td>flex-order-gt-md</td><td>\nwidth &gt;= <b>1280</b>px</td></tr><tr><td>flex-order-lg</td><td><b>1280</b>px &lt;= width &lt; <b>1920</b>px</td></tr>\n<tr><td>flex-order-gt-lg</td><td>width &gt;= <b>1920</b>px</td></tr><tr><td>flex-order-xl</td><td>width &gt;= <b>1920\n</b>px</td></tr></table><p>See the <a href="layout/options">layout options page</a>\n for more information on directives like <code>hide</code>, <code>hide-gt-md</code>, and <code>show-gt-md</code>\n used in the above examples.</p><br><hr><br><h3>Add Offsets to the Preceding HTML Elements</h3><p>Add the <code>\nflex-offset</code>\n directive to a layout child to set its offset percentage within the layout container. Values must be multiples of \n<code>5</code> or <code>33</code> / <code>66</code>. These offsets establish a <code>margin-left</code>\n with respect to the preceding element or the containers left boundary.</p><p>When using <code>flex-offset</code>\n the margin-left offset is applied... regardless of your choice of <code>flex-order</code>. or if you use a <code>\nflex-direction: reverse</code>.</p><docs-demo demo-title="Flex-Offset Directive" class="small-demo colorNested">\n<demo-file name="index.html"><div layout="row"><div flex="66" flex-offset="15">[flex-offset="15"] [flex="66"]</div><div\n flex>[flex]</div></div></demo-file></docs-demo><table class="md-api-table"><thead><tr><th>API</th><th>\nDevice width when breakpoint overrides default</th></tr></thead><tr><td>flex-offset</td><td>\nSets default margin-left offset (<b>%-based</b>) unless overridden by another breakpoint.</td></tr><tr><td>\nflex-offset-xs</td><td>width &lt; <b>600</b>px</td></tr><tr><td>flex-offset-gt-xs</td><td>width &gt;= <b>600</b>px</td>\n</tr><tr><td>flex-offset-sm</td><td><b>600</b>px &lt;= width &lt; <b>960</b>px</td></tr><tr><td>flex-offset-gt-sm</td>\n<td>width &gt;= <b>960</b>px</td></tr><tr><td>flex-offset-md</td><td><b>960</b>px &lt;= width &lt; <b>1280</b>px</td>\n</tr><tr><td>flex-offset-gt-md</td><td>width &gt;= <b>1280</b>px</td></tr><tr><td>flex-offset-lg</td><td><b>1280</b>\npx &lt;= width &lt; <b>1920</b>px</td></tr><tr><td>flex-offset-gt-lg</td><td>width &gt;= <b>1920</b>px</td></tr><tr>\n<td>flex-offset-xl</td><td>width &gt;= <b>1920</b>px</td></tr></table></div>');
$templateCache.put('app/main/components/material-docs/layout/layout-container.tmpl.html','<div ng-controller="LayoutCtrl" class="layout-content" ng-cloak><h3>Layout and Containers</h3><p>Use the <code>layout\n</code> directive on a container element to specify the layout direction for its children: horizontally in a row (\n<code>layout="row"</code>) or vertically in a column (<code>layout="column"</code>). Note that <code>row</code>\n is the default layout direction if you specify the <code>layout</code> directive without a value.</p><table><tr><td \nstyle="font-weight: bold; background-color: #DBEEF5">row</td><td style="padding-left: 10px;">\nItems arranged horizontally. <code>max-height = 100%</code> and <code>max-width</code>\n is the width of the items in the container.</td></tr><tr><td style="font-weight: bold; background-color: #DBEEF5">\ncolumn</td><td style="padding-left: 10px;">Items arranged vertically. <code>max-width = 100%</code> and <code>\nmax-height</code> is the height of the items in the container.</td></tr></table><br><docs-demo \ndemo-title="Layout Directive" class="small-demo colorNested"><demo-file name="index.html"><div layout="row"><div flex>\nFirst item in row</div><div flex>Second item in row</div></div><div layout="column"><div flex>First item in column\n</div><div flex>Second item in column</div></div></demo-file></docs-demo><p>Note that <code>layout</code>\n only affects the flow direction for that container\'s <b>immediate</b> children.</p><hr><br><h3>\nLayouts and Responsive Breakpoints</h3><p>As discussed in the <a href="layout/introduction">Layout Introduction page\n</a> you can make your layout change depending upon the device view size by using <b>breakpoint alias</b> suffixes.</p>\n<p>To make your layout automatically change depending upon the device screen size, use one to the following <code>\nlayout</code> APIs to set the layout direction for devices with view widths:</p><table class="md-api-table"><thead><tr>\n<th>API</th><th>Device width when breakpoint overrides default</th></tr></thead><tr><td>layout</td><td>\nSets default layout direction unless overridden by another breakpoint.</td></tr><tr><td>layout-xs</td><td>width &lt; \n<b>600</b>px</td></tr><tr><td>layout-gt-xs</td><td>width &gt;= <b>600</b>px</td></tr><tr><td>layout-sm</td><td><b>600\n</b>px &lt;= width &lt; <b>960</b>px</td></tr><tr><td>layout-gt-sm</td><td>width &gt;= <b>960</b>px</td></tr><tr><td>\nlayout-md</td><td><b>960</b>px &lt;= width &lt; <b>1280</b>px</td></tr><tr><td>layout-gt-md</td><td>width &gt;= <b>1280\n</b>px</td></tr><tr><td>layout-lg</td><td><b>1280</b>px &lt;= width &lt; <b>1920</b>px</td></tr><tr><td>layout-gt-lg\n</td><td>width &gt;= <b>1920</b>px</td></tr><tr><td>layout-xl</td><td>width &gt;= <b>1920</b>px</td></tr></table><br>\n<p><a \nhref="https://camo.githubusercontent.com/ad81ae92f8b4285747ce4e48007bf3f104dd5630/687474703a2f2f6d6174657269616c2d64657369676e2e73746f726167652e676f6f676c65617069732e636f6d2f7075626c6973682f6d6174657269616c5f765f342f6d6174657269616c5f6578745f7075626c6973682f3042386f6c5631354a3761625053474678656d46695156527462316b2f6c61796f75745f61646170746976655f627265616b706f696e74735f30312e706e67" \ntarget="_blank" style="text-decoration: none;border: 0 none;"><img \nsrc="https://camo.githubusercontent.com/ad81ae92f8b4285747ce4e48007bf3f104dd5630/687474703a2f2f6d6174657269616c2d64657369676e2e73746f726167652e676f6f676c65617069732e636f6d2f7075626c6973682f6d6174657269616c5f765f342f6d6174657269616c5f6578745f7075626c6973682f3042386f6c5631354a3761625053474678656d46695156527462316b2f6c61796f75745f61646170746976655f627265616b706f696e74735f30312e706e67" \nalt="" style="max-width:100%;text-decoration: none;border: 0 none;"></a></p><p>\nFor the demo below, as you shrink your browser window width notice the flow direction changes to <code>column</code>\n for mobile devices (<code>xs</code>). And as you expand it will reset to <code>row</code> for <code>gt-sm</code>\n view sizes.</p><docs-demo demo-title="Responsive Layouts" class="small-demo colorNested"><demo-file name="index.html">\n<div layout="row" layout-xs="column"><div flex>I\'m above on mobile, and to the left on larger devices.</div><div flex>\nI\'m below on mobile, and to the right on larger devices.</div></div></demo-file></docs-demo><p>See the <a \nhref="layout/options">Layout Options page</a> for more options such as padding, alignments, etc.</p></div>');
$templateCache.put('app/main/components/material-docs/layout/layout-introduction.tmpl.html','<div ng-controller="LayoutCtrl" class="layout-content" ng-cloak><h3>Overview</h3><p>\nAngular Material\'s Layout features provide sugar to enable developers to more easily create modern, responsive layouts on top of CSS3 \n<a href="http://www.w3.org/TR/css3-flexbox/">flexbox</a>\n. The layout API consists of a set of Angular directives that can be applied to any of your application\'s HTML content.\n</p><p>Using <b>HTML Directives</b> as the API provides an easy way to set a value (eg. <code>layout="row"</code>\n) and helps with separation of concerns: Attributes define layout while CSS classes assign styling.</p><table \nclass="md-api-table"><thead><tr><th>HTML Markup API</th><th>Allowed values (raw or interpolated)</th></tr></thead>\n<tbody><tr><td>layout</td><td><code>row | column</code></td></tr><tr><td>flex</td><td>\ninteger (increments of 5 for 0%->100%, 100%/3, 200%/3)</td></tr><tr><td>flex-order</td><td>\ninteger values from -20 to 20</td></tr><tr><td>flex-offset</td><td>\ninteger (increments of 5 for 0%->95%, 100%/3, 200%/3)</td></tr><tr><td>layout-align</td><td><code>\nstart|center|end|space-around|space-between</code> <code>start|center|end|stretch</code></td></tr><tr><td>layout-fill\n</td><td></td></tr><tr><td>layout-wrap</td><td></td></tr><tr><td>layout-nowrap</td><td></td></tr><tr><td>layout-margin\n</td><td></td></tr><tr><td>layout-padding</td><td></td></tr><tr><td>show</td><td></td></tr><tr><td>hide</td><td></td>\n</tr></tbody></table><p>And if we use Breakpoints as specified in Material Design:</p><p><a \nhref="https://camo.githubusercontent.com/ad81ae92f8b4285747ce4e48007bf3f104dd5630/687474703a2f2f6d6174657269616c2d64657369676e2e73746f726167652e676f6f676c65617069732e636f6d2f7075626c6973682f6d6174657269616c5f765f342f6d6174657269616c5f6578745f7075626c6973682f3042386f6c5631354a3761625053474678656d46695156527462316b2f6c61796f75745f61646170746976655f627265616b706f696e74735f30312e706e67" \ntarget="_blank"><img \nsrc="https://camo.githubusercontent.com/ad81ae92f8b4285747ce4e48007bf3f104dd5630/687474703a2f2f6d6174657269616c2d64657369676e2e73746f726167652e676f6f676c65617069732e636f6d2f7075626c6973682f6d6174657269616c5f765f342f6d6174657269616c5f6578745f7075626c6973682f3042386f6c5631354a3761625053474678656d46695156527462316b2f6c61796f75745f61646170746976655f627265616b706f696e74735f30312e706e67" \nalt="" style="max-width:100%;"></a></p><p>We can associate breakpoints with mediaQuery definitions using breakpoint \n<strong>alias(es)</strong>:</p><table class="md-api-table"><thead><tr><th>Breakpoint</th><th>MediaQuery (pixel range)\n</th></tr></thead><tbody><tr><td>xs</td><td>\'(max-width: <b>599</b>px)\'</td></tr><tr><td>gt-xs</td><td>\'(min-width: <b>\n600</b>px)\'</td></tr><tr><td>sm</td><td>\'(min-width: <b>600</b>px) and (max-width: <b>959</b>px)\'</td></tr><tr><td>\ngt-sm</td><td>\'(min-width: <b>960</b>px)\'</td></tr><tr><td>md</td><td>\'(min-width: <b>960</b>px) and (max-width: <b>\n1279</b>px)\'</td></tr><tr><td>gt-md</td><td>\'(min-width: <b>1280</b>px)\'</td></tr><tr><td>lg</td><td>\'(min-width: <b>\n1280</b>px) and (max-width: <b>1919</b>px)\'</td></tr><tr><td>gt-lg</td><td>\'(min-width: <b>1920</b>px)\'</td></tr><tr>\n<td>xl</td><td>\'(min-width: <b>1920</b>px)\'</td></tr></tbody></table><br><hr><h3>API with Responsive Breakpoints</h3>\n<p>Now we can combine the breakpoint <code>alias</code>\n with the Layout API to easily support Responsive breakpoints with our simple Layout markup convention. The <code>alias\n</code> is simply used as <b>suffix</b> extensions to the Layout API keyword.<br>e.g.</p><p>\nThis notation results in, for example, the following table for the <code>layout</code> and <code>flex</code> APIs:</p>\n<table class="md-api-table"><thead><tr><th>layout API</th><th>flex API</th><th>Activates when device</th></tr></thead>\n<tr><td>layout</td><td>flex</td><td>Sets default layout direction &amp; flex unless overridden by another breakpoint.\n</td></tr><tr><td>layout-xs</td><td>flex-xs</td><td>width &lt; <b>600</b>px</td></tr><tr><td>layout-gt-xs</td><td>\nflex-gt-xs</td><td>width &gt;= <b>600</b>px</td></tr><tr><td>layout-sm</td><td>flex-sm</td><td><b>600</b>\npx &lt;= width &lt; <b>960</b>px</td></tr><tr><td>layout-gt-sm</td><td>flex-gt-sm</td><td>width &gt;= <b>960</b>px</td>\n</tr><tr><td>layout-md</td><td>flex-md</td><td><b>960</b>px &lt;= width &lt; <b>1280</b>px</td></tr><tr><td>\nlayout-gt-md</td><td>flex-gt-md</td><td>width &gt;= <b>1280</b>px</td></tr><tr><td>layout-lg</td><td>flex-lg</td><td>\n<b>1280</b>px &lt;= width &lt; <b>1920</b>px</td></tr><tr><td>layout-gt-lg</td><td>flex-gt-lg</td><td>width &gt;= <b>\n1920/b>px</b></td></tr><tr><td>layout-xl</td><td>flex-xl</td><td>width &gt;= <b>1920</b>px</td></tr></table><p>\nBelow is an example usage of the Responsive Layout API:</p><hljs lang="html"><div layout="column" class="zero"><div \nflex="33" flex-md="{{ vm.box1Width }}" class="one"></div><div flex="33" layout="{{ vm.direction }}" layout-md="row" \nclass="two"><div flex="22" flex-md="10" hide-lg class="two_one"></div><div flex="30px" show hide-md="{{ vm.hideBox }}" \nflex-md="25" class="two_two"></div><div flex="20" flex-md="65" class="two_three"></div></div><div flex class="three">\n</div></div></hljs><br><p>\nThis Layout API means it is much easier to set up and maintain flexbox layouts vs. defining everything via CSS. The developer uses the Layout HTML API to specify \n<b><i>intention</i></b> and the Layout engine handles all the issues of CSS flexbox styling.</p><p class="layout_note">\nThe Layout engine will log console warnings when it encounters conflicts or known issues.</p><br><br><hr><br><h3>\nUnder-the-Hood</h3><p>Due to performance problems when using Attribute Selectors with <b>Internet Explorer</b>\n browsers; see the following for more details:</p><p>\nLayout directives dynamically generate class selectors at runtime. And the Layout CSS classNames and styles have each been predefined in the \n<code>angular-material.css</code> stylesheet.</p><p class="layout_note">\nDevelopers should continue to use Layout directives in the HTML markup as the classes may change between releases.</p>\n<p>Let\'s see how this directive-to-className transformation works. Consider the simple use of the <code>layout</code>\n and <code>flex</code> directives (API):</p><hljs lang="html"><div><div layout="row"><div flex>First item in row</div>\n<div flex="20">Second item in row</div></div><div layout="column"><div flex="66">First item in column</div><div \nflex="33">Second item in column</div></div></div></hljs><p>At runtime, these attributes are transformed to CSS classes.\n</p><hljs lang="html"><div><div class="ng-scope layout-row"><div class="flex">First item in row</div><div \nclass="flex-20">Second item in row</div></div><div class="ng-scope layout-column"><div class="flex-33">\nFirst item in column</div><div class="flex-66">Second item in column</div></div></div></hljs><p>\nUsing the style classes above defined in <code>angular-material.css</code></p><hljs lang="css">\n.flex { -webkit-flex: 1 1 0%; -ms-flex: 1 1 0%; flex: 1 1 0%; box-sizing: border-box; } .flex-20 { -webkit-flex: 1 1 20%; -ms-flex: 1 1 20%; flex: 1 1 20%; max-width: 20%; max-height: 100%; box-sizing: border-box; } .layout-row .flex-33 { -webkit-flex: 1 1 calc(100% / 3); -ms-flex: 1 1 calc(100% / 3); flex: 1 1 calc(100% / 3); box-sizing: border-box; } .layout-row .flex-66 { -webkit-flex: 1 1 calc(200% / 3); -ms-flex: 1 1 calc(200% / 3); flex: 1 1 calc(200% / 3); box-sizing: border-box; } .layout-row .flex-33 { max-width: calc(100% / 3); max-height: 100%; } .layout-row .flex-66 { max-width: calc(200% / 3); max-height: 100%; } .layout-column .flex-33 { max-width: 100%; max-height: calc(100% / 3); } .layout-column .flex-66 { max-width: 100%; max-height: calc(200% / 3); }\n</hljs></div>');
$templateCache.put('app/main/components/material-docs/layout/layout-options.tmpl.html','<div ng-controller="LayoutCtrl" class="layout-content layout-options" ng-cloak><docs-demo \ndemo-title="Responsive Layout" class="small-demo colorNested"><demo-file name="index.html"><div layout="row" \nlayout-sm="column"><div flex>I\'m above on mobile, and to the left on larger devices.</div><div flex>\nI\'m below on mobile, and to the right on larger devices.</div></div></demo-file></docs-demo><p>See the <a \nhref="layout/container">Container Elements</a> page for a basic explanation of layout directives.<br>\nTo make your layout change depending upon the device screen size, there are other <code>layout</code>\n directives available:</p><table class="md-api-table"><thead><tr><th>API</th><th>Activates when device</th></tr>\n</thead><tr><td>layout</td><td>Sets default layout direction unless overridden by another breakpoint.</td></tr><tr><td>\nlayout-xs</td><td>width &lt; <b>600</b>px</td></tr><tr><td>layout-gt-xs</td><td>width &gt;= <b>600</b>px</td></tr><tr>\n<td>layout-sm</td><td><b>600</b>px &lt;= width &lt; <b>960</b>px</td></tr><tr><td>layout-gt-sm</td><td>width &gt;= <b>\n960</b>px</td></tr><tr><td>layout-md</td><td><b>960</b>px &lt;= width &lt; <b>1280</b>px</td></tr><tr><td>layout-gt-md\n</td><td>width &gt;= <b>1280</b>px</td></tr><tr><td>layout-lg</td><td><b>1280</b>px &lt;= width &lt; <b>1920</b>px</td>\n</tr><tr><td>layout-gt-lg</td><td>width &gt;= <b>1920</b>px</td></tr><tr><td>layout-xl</td><td>width &gt;= <b>1920</b>\npx</td></tr></table><br><br><hr><br><h3>Layout Margin, Padding, Wrap and Fill</h3><br><docs-demo \ndemo-title="Layout Margin, Padding, and Fill" class="small-demo colorNested-noPad"><demo-file name="index.html"><div \nlayout="row" layout-margin><div flex>Parent layout and this element have margins.</div></div><div layout="row" \nlayout-padding><div flex>Parent layout and this element have padding.</div></div><div layout="row" layout-fill \nstyle="min-height: 224px;"><div flex>Parent layout is set to fill available space.</div></div><div layout="row" \nlayout-padding layout-margin layout-fill style="min-height: 224px;"><div flex>I am using all three at once.</div></div>\n</demo-file></docs-demo><p><code>layout-margin</code> adds margin around each <code>flex</code>\n child. It also adds a margin to the layout container itself.<br><code>layout-padding</code> adds padding inside each \n<code>flex</code> child. It also adds padding to the layout container itself.<br><code>layout-fill</code>\n forces the layout element to fill its parent container.</p><p>Here is a non-trivial group of <code>flex</code>\n elements using <code>layout-wrap</code></p><docs-demo demo-title="Wrap" class="small-demo colorNested-noPad">\n<demo-file name="index.html"><div layout="row" layout-wrap><div flex="33">[flex=33]</div><div flex="66">[flex=66]</div>\n<div flex="66">[flex=66]</div><div flex="33">[flex=33]</div><div flex="33">[flex=33]</div><div flex="33">[flex=33]\n</div><div flex="33">[flex=33]</div></div></demo-file></docs-demo><p><code>layout-wrap</code> allows <code>flex</code>\n children to wrap within the container if the elements use more than 100%.<br></p><br><br><hr><br><h3>Show &amp; Hide\n</h3><p>Use the <code>show</code> <code>hide</code>\n APIs to responsively show or hide elements. While these work similar to <code>ng-show</code> and <code>ng-hide</code>\n, these Angular Material Layout directives are mediaQuery-aware.</p><docs-demo demo-title="Hide and Show Directives" \nclass="small-demo colorNested"><demo-file name="index.html"><div layout="row"><div hide show-gt-sm flex>\nOnly show on gt-sm devices.</div><div hide-gt-sm flex>Shown on small and medium.<br>Hidden on gt-sm devices.</div><div \nshow hide-gt-md flex>Shown on small and medium size devices.<br>Hidden on gt-md devices.</div><div hide show-md flex>\nShown on medium size devices only.</div><div hide show-gt-lg flex>Shown on devices larger than 1200px wide only.</div>\n</div></demo-file></docs-demo><br><table class="md-api-table"><thead><tr><th>hide (display: none)</th><th>\nshow (negates hide)</th><th>Activates when:</th></tr></thead><tr><td>hide-xs</td><td>show-xs</td><td>width &lt; <b>600\n</b>px</td></tr><tr><td>hide-gt-xs</td><td>show-gt-xs</td><td>width &gt;= <b>600</b>px</td></tr><tr><td>hide-sm</td>\n<td>show-sm</td><td><b>600</b>px &lt;= width &lt; <b>960</b>px</td></tr><tr><td>hide-gt-sm</td><td>show-gt-sm</td><td>\nwidth &gt;= <b>960</b>px</td></tr><tr><td>hide-md</td><td>show-md</td><td><b>960</b>px &lt;= width &lt; <b>1280</b>px\n</td></tr><tr><td>hide-gt-md</td><td>show-gt-md</td><td>width &gt;= <b>1280</b>px</td></tr><tr><td>hide-lg</td><td>\nshow-lg</td><td><b>1280</b>px &lt;= width &lt; <b>1920</b>px</td></tr><tr><td>hide-gt-lg</td><td>show-gt-lg</td><td>\nwidth &gt;= <b>1920</b>px</td></tr><tr><td>hide-xl</td><td>show-xl</td><td>width &gt;= <b>1920</b>px</td></tr></table>\n</div>');
$templateCache.put('app/main/components/material-docs/layout/layout-template.html','<div class="doc-page material-docs layout-docs doc-template page-layout simple fullwidth" layout="column"><div \nclass="header md-accent-bg" layout="row" layout-align="space-between"><div layout="column" layout-align="center start">\n<div class="breadcrumb" layout="row" layout-align="start center"><md-icon md-font-icon="icon-home" class="s16">\n</md-icon><md-icon md-font-icon="icon-chevron-right" class="s16 separator"></md-icon><span class="parent">\nANGULAR MATERIAL LAYOUT</span></div><div class="title">{{vm.component.name}}</div></div></div><div flex \nclass="content"><a class="reference-link md-yellow-200-bg" \nhref="https://material.angularjs.org/{{vm.materialVersion}}/{{vm.component.url}}" target="_blank">\nGo to official Angular Material <b>{{vm.component.name}}</b> documentation page</a><div class="" \nng-include="\'app/main/components/material-docs/layout/\'+vm.component.templateUrl+\'.tmpl.html\'"></div></div></div>');
$templateCache.put('app/main/components/material-docs/layout/layout-tips.tmpl.html','<style>ul.spaced li {\n    margin-bottom: 15px;\n  }</style><div ng-controller="LayoutTipsCtrl as tips" \nclass="layout-content"><h3>Overview</h3><p>The Angular Material Layout system uses the current <a \nhref="http://www.w3.org/TR/css3-flexbox/">Flexbox</a>\n feature set. More importantly, it also adds syntactic sugar to allow developers to easily and quickly add Responsive features to HTML containers and elements.\n</p><p>\nAs you use the Layout features, you may encounter scenarios where the layouts do not render as expected; especially with IE 10 and 11 browsers. There may also be cases where you need to add custom HTML, CSS and Javascript to achieve your desired results.\n</p><br><hr><h3>Resources</h3><p>\nIf you are experiencing an issue in a particular browser, we highly recommend using the following resources for known issues and workarounds.\n</p><ul><li><a href="https://github.com/philipwalton/flexbugs#flexbugs" target="_blank">FlexBugs</a></li><li><a \nhref="https://philipwalton.github.io/solved-by-flexbox/" target="_blank">Solved by FlexBugs</a></li><li><a \nhref="http://philipwalton.com/articles/normalizing-cross-browser-flexbox-bugs/" target="_blank">\nNormalizing Cross-browser Flexbox Bugs</a></li><li style="margin-bottom: 20px;"><a \nhref="http://caniuse.com/#search=flex" target="_blank">Can I use flexbox...? ( see the <code>Known Issues</code> tab)\n</a></li><li><a href="https://groups.google.com/forum/#!forum/ngmaterial">Angular Material Forum</a></li><li \nstyle="margin-top: 20px;"><a href="https://css-tricks.com/snippets/css/a-guide-to-flexbox/" target="_blank">\nA Complete Guide to Flexbox</a></li><li style="margin-bottom: 20px;"><a \nhref="https://scotch.io/tutorials/a-visual-guide-to-css3-flexbox-properties" target="_blank">\nA Visual Guide to CSS3 Flexbox Properties</a></li></ul><br><hr><h3>General Tips</h3><p>\nBelow, you will find solutions to some of the more common scenarios and problems that may arise when using Material\'s Layout system. The following sections offer general guidelines and tips when using the \n<code>flex</code> and <code>layout</code> directives within your own applications.</p><ul class="spaced"><li>\nWhen building your application\'s Layout, it is usually best to start with a mobile version that looks and works correctly, and then apply styling for larger devices using the \n<code>flex-gt-*</code> or <code>hide-gt-*</code>\n attributes. This approach typically leads to less frustration than starting big and attempting to fix issues on smaller devices.\n</li><li>Some elements like <code>&lt;fieldset&gt;</code> and <code>&lt;button&gt;</code>\n do not always work correctly with flex. Additionally, some of the Angular Material components provide their own styles. If you are having difficulty with a specific element/component, but not others, try applying the flex attributes to a parent or child \n<code>&lt;div&gt;</code> of the element instead.</li><li>Some Flexbox properties such as <code>flex-direction</code> \n<u>cannot</u> be animated.</li><li>\nFlexbox can behave differently on different browsers. You should test as many as possible on a regular basis so that you can catch and fix layout issues more quickly.\n</li></ul><br><hr><h3>Layout Column</h3><p>In some scenarios <code>layout="column"</code>\n and breakpoints (xs, gt-xs, xs, gt-sm, etc.) may not work as expected due to CSS specificity rules.</p><div \nclass="md-whiteframe-3dp"><iframe height="700" scrolling="no" \nsrc="//codepen.io/team/AngularMaterial/embed/obgapg/?height=700&theme-id=21180&default-tab=result" frameborder="no" \nallowtransparency="true" allowfullscreen="true" style="width: 100%;">See the Pen <a \nhref="http://codepen.io/team/AngularMaterial/pen/obgapg/">Card Layouts (corrected)</a> by Angular Material (<a \nhref="http://codepen.io/AngularMaterial">@AngularMaterial</a>) on <a href="http://codepen.io">CodePen</a>.</iframe>\n</div><p>This is easily fixed simply by inverting the layout logic so that the default is <code>layout=\'row\'</code>\n. To see how the layout changes, shrink the browser window its width is 600 px</p><br><hr><h3>\nLayout Column and Container Heights</h3><p>\nIn Flexbox, some browsers will determine size of the flex containers based on the size of their content. This is particularly noticable if you have a non-flex item (say a toolbar), followed by two flex items in a column layout.\n</p><docs-demo demo-title="Flex Height - Odd (Chrome )" class="small-demo colorNested"><demo-file name="index.html">\n<div layout="column" style="height: 450px !important;"><div style="height: 50px;">Toolbar</div><div flex \nlayout="column" style="overflow: auto;"><md-content flex layout-margin><p>Flex with smaller content...</p><p \nng-repeat="i in [0,1,2,3,4]">Line {{i}}</p></md-content><md-content flex layout-margin><p>Flex with larger content...\n</p><p ng-repeat="i in [0,1,2,3,4]">Line {{i}}</p><div id="toHide"><p ng-repeat="i in [5,6,7,8,9]">Line {{i}}</p></div>\n</md-content></div></div></demo-file></docs-demo><p>\nNotice how in Chrome the second scrollable area is nearly twice as tall as the first. This is because we are using nested flex items and the contents of the second \n<code>&lt;md-content&gt;</code>\n are twice as large as the first. Try clicking the button below to toggle the light blue box; this will make the containers the same size.\n</p><p layout="row" layout-align="center center"><md-button class="md-raised" ng-click="tips.toggleContentSize()">\n{{tips.toggleButtonText}} Blue Box</md-button></p><p>\nIn order to fix this, we must specify the height of the outer flex item. The easiest way to achieve this is to simply set the height to \n<code>100%</code>. When paired with the <code>flex</code> attribute, this achieves the desired result.</p><p><em>\n<strong>Note:</strong> When <code>height: 100%</code> is used without the <code>flex</code>\n attribute, the container will take up as much space as available and squish the toolbar which has been set to a height of \n<code>50px</code>.</em></p><docs-demo demo-title="Chrome Flex Height - Fixed" class="small-demo colorNested"><demo-file\n name="index.html"><div layout="column" style="height: 450px !important;"><div style="height: 50px;">Toolbar</div><div \nflex layout="column" style="overflow: auto; height: 100%;"><md-content flex layout-margin><p>\nFlex with smaller content...</p><p ng-repeat="i in [0,1,2,3,4]">Line {{i}}</p></md-content><md-content flex \nlayout-margin><p>Flex with larger content...</p><p ng-repeat="i in [0,1,2,3,4]">Line {{i}}</p><div><p \nng-repeat="i in [5,6,7,8,9]">Line {{i}}</p></div></md-content></div></div></demo-file></docs-demo><br><hr><h3>\nFlex Element Heights</h3><p>\nFirefox currently has an issue calculating the proper height of flex containers whose children are flex, but have more content than can properly fit within the container.\n</p><p>This is particularly problematic if the <code>flex</code> children are <code>md-content</code>\n components as it will prevent the content from scrolling correctly, instead scrolling the entire body.</p><div \nclass="md-whiteframe-3dp"><iframe height="376" scrolling="no" \nsrc="//codepen.io/team/AngularMaterial/embed/NxKBwW/?height=376&theme-id=0&default-tab=result" frameborder="no" \nallowtransparency="true" allowfullscreen="true" style="width: 100%;">See the Pen <a \nhref="http://codepen.io/team/AngularMaterial/pen/NxKBwW/">Angular Material Basic App</a> by Angular Material (<a \nhref="http://codepen.io/AngularMaterial">@AngularMaterial</a>) on <a href="http://codepen.io">CodePen</a>.</iframe>\n</div><p>Notice in the above Codepen how we must set <code>overflow: auto</code> on the div with the <code>\nchange-my-css</code> class in order for Firefox to properly calculate the height and shrink to the available space.</p>\n</div>');
$templateCache.put('app/main/pages/errors/404/error-404.html','<div id="error-404" layout="column" layout-align="center center"><div class="content" layout="column" \nlayout-align="center center"><div class="error-code" translate="ERROR404.CODE">404</div><div class="message" \ntranslate="ERROR404.MESSAGE">Sorry but we couldn\u2019t find the page you are looking for</div><div \nclass="search md-whiteframe-1dp" layout="row" layout-align="start center"><md-icon md-font-icon="icon-magnify" \nclass="icon s24"></md-icon><input ng-model="vm.search" type="text" placeholder="Search for anything" translate \ntranslate-attr-placeholder="ERROR404.SEARCH" flex></div><a class="back-link md-accent-color" href="/" \ntranslate="ERROR404.GO_BACK">Go back to dashboard</a></div></div>');
$templateCache.put('app/main/pages/errors/500/error-500.html','<div id="error-500" layout="column" layout-align="center center"><div class="content" layout="column" \nlayout-align="center center"><div class="error-code" translate="ERROR500.CODE">500</div><div class="message" \ntranslate="ERROR500.MESSAGE">Well, you broke the internet!</div><div class="sub-message" \ntranslate="ERROR500.SUBMESSAGE">Just kidding, looks like we have an internal issue, please try again in couple minutes\n</div><a class="report-link md-accent-color" href="/" translate="ERROR500.REPORT">Report this problem</a></div></div>');
$templateCache.put('app/main/pages/auth/forgot-password/forgot-password.html','<div id="forgot-password" class="flex-scrollable" layout="column" ms-scroll><div id="forgot-password-form-wrapper" \nlayout="column" layout-align="center center"><div id="forgot-password-form" class="md-whiteframe-8dp"><div \nclass="logo md-accent-bg"><span>F</span></div><div class="title" translate="FORGOTPASSWORD.TITLE">Recover your password\n</div><form name="forgotPasswordForm" novalidate><md-input-container class="md-block" md-no-float><input type="email" \nname="email" ng-model="vm.form.email" placeholder="Email address" translate \ntranslate-attr-placeholder="FORGOTPASSWORD.EMAIL_ADRESS" ng-pattern="/^.+@.+\\..+$/" required><div \nng-messages="forgotPasswordForm.email.$error" role="alert" multiple="multiple"><div ng-message="required"><span \ntranslate="FORGOTPASSWORD.ERRORS.EMAIL_REQUIRED">Email field is required</span></div><div ng-message="pattern"><span \ntranslate="FORGOTPASSWORD.ERRORS.EMAIL_MUST_VALID">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-button type="submit" class="md-raised md-accent submit-button" aria-label="RESET MY PASSWORD" \nng-disabled="forgotPasswordForm.$invalid || forgotPasswordForm.$pristine" translate="FORGOTPASSWORD.SEND_RESET_LINK" \ntranslate-attr-aria-label="FORGOTPASSWORD.SEND_RESET_LINK">SEND RESET LINK</md-button></form><div class="login" \nlayout="row" layout-align="center center"><a class="link" ui-sref="app.pages_auth_login" \ntranslate="FORGOTPASSWORD.GO_BACK">Go back to login</a></div></div></div></div>');
$templateCache.put('app/main/pages/auth/lock/lock.html','<div id="lock" class="flex-scrollable" layout="column" ms-scroll><div id="lock-form-wrapper" layout="column" \nlayout-align="center center"><div id="lock-form" class="md-whiteframe-8dp"><div layout="row" \nlayout-align="start center" layout-sm="column" layout-align-sm="center center"><div class="avatar-container"><img \nclass="avatar big" src="assets/images/avatars/katherine.jpg"><md-icon md-font-icon="icon-lock" \nclass="md-warn-fg s36 md-hue-2"></md-icon></div><div flex layout="column" layout-align="start" \nlayout-align-sm="center center"><div class="title" translate="LOCK.TITLE">Your session is locked</div><div \nclass="subtitle" translate="LOCK.SUBTITLE">Due to inactivity, your session is locked. Enter your password to continue.\n</div></div></div><form name="lockForm" novalidate><md-input-container class="md-block" md-no-float><input \nng-model="vm.form.username" placeholder="Username" translate translate-attr-placeholder="LOCK.USERNAME" \ndisabled="disabled"></md-input-container><md-input-container class="md-block" md-no-float><input type="password" \nname="password" ng-model="vm.form.password" placeholder="Password" translate \ntranslate-attr-placeholder="LOCK.PASSWORD" required><div ng-messages="lockForm.password.$error" role="alert"><div \nng-message="required"><span translate="LOCK.ERRORS.PASSWORD_REQUIRED">Password field is required</span></div></div>\n</md-input-container><md-button type="submit" class="md-raised md-accent submit-button" aria-label="UNLOCK" \nng-disabled="lockForm.$invalid || lockForm.$pristine" translate="LOCK.UNLOCK" translate-attr-aria-label="LOCK.UNLOCK">\nUNLOCK</md-button></form><div class="message"><a ui-sref="app.pages_auth_login" class="md-accent-color"><span \ntranslate="LOCK.ARE_YOU_NOT">Are you not</span><span> Jane Doe?</span></a></div></div></div></div>');
$templateCache.put('app/main/pages/auth/login/login.html','<div id="login" style="background : url({{vm.branding.loginBackground}}) no-repeat; background-size: cover;" \nclass="flex-scrollable" layout="column" ms-scroll><div id="login-form-wrapper" layout="column" \nlayout-align="center center"><div id="login-form" class="md-whiteframe-8dp"><div class="logo md-accent-bg"><span>F\n</span></div><div class="title" translate="LOGIN.TITLE">Log in to your account</div><form name="loginForm" novalidate>\n<md-input-container class="md-block" md-no-float><input type="email" name="email" ng-model="vm.form.email" \nplaceholder="Email" translate translate-attr-placeholder="LOGIN.EMAIL" ng-pattern="/^.+@.+\\..+$/" required><div \nng-messages="loginForm.email.$error" role="alert" multiple="multiple"><div ng-message="required"><span \ntranslate="LOGIN.ERRORS.EMAIL_REQUIRED">Email field is required</span></div><div ng-message="pattern"><span \ntranslate="LOGIN.ERRORS.EMAIL_MUST_VALID">Email must be a valid e-mail address</span></div></div></md-input-container>\n<md-input-container class="md-block" md-no-float><input type="password" name="password" ng-model="vm.form.password" \nplaceholder="Password" translate translate-attr-placeholder="LOGIN.PASSWORD" required><div \nng-messages="loginForm.password.$error" role="alert"><div ng-message="required"><span \ntranslate="LOGIN.ERRORS.PASSWORD_REQUIRED">Password field is required</span></div></div></md-input-container><div \nclass="remember-forgot-password" layout="row" layout-xs="column" layout-align="space-between center"><md-checkbox \nclass="remember-me" ng-model="data.cb1" aria-label="Remember Me"><span translate="LOGIN.REMEMBER_ME">Remember Me</span>\n</md-checkbox><a ui-sref="app.pages_auth_forgot-password" class="forgot-password md-accent-color" \ntranslate="LOGIN.FORGOT_PASSWORD">Forgot Password?</a></div><md-button type="submit" \nclass="md-raised md-accent submit-button" aria-label="LOG IN" ng-disabled="loginForm.$invalid || loginForm.$pristine" \ntranslate="LOGIN.LOG_IN" translate-attr-aria-label="LOGIN.LOG_IN">LOG IN</md-button></form><div class="separator"><span\n class="text" translate="LOGIN.OR">OR</span></div><md-button class="md-raised google"><div layout="row" \nlayout-align="center center"><span><md-icon md-font-icon="icon-google-plus" class="s16"></md-icon><span \ntranslate="LOGIN.WITH_GOOGLE">Log in with Google</span></span></div></md-button><md-button class="md-raised facebook">\n<div layout="row" layout-align="center center"><span><md-icon md-font-icon="icon-facebook" class="s16"></md-icon><span \ntranslate="LOGIN.WITH_FACEBOOK">Log in with Facebook</span></span></div></md-button><div class="register" layout="row" \nlayout-sm="column" layout-align="center center"><span class="text" translate="LOGIN.DONT_HAVE_ACCOUNT">\nDon\'t have an account?</span> <a class="link" ui-sref="app.pages_auth_register" translate="LOGIN.CREATE_ACCOUNT">\nCreate an account</a></div></div></div></div>');
$templateCache.put('app/main/pages/auth/login-v2/login-v2.html','<div id="login-v2" layout="row" layout-align="start"><div id="login-v2-intro" flex hide show-gt-sm><div \nclass="logo md-accent-bg"><span>F</span></div><div class="title" translate="LOGIN_V2.INTRO_TITLE">Welcome to the FUSE!\n</div><div class="description" translate="LOGIN_V2.INTRO_DESCRIPTION">\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ullamcorper nisl erat, vel convallis elit fermentum pellentesque. Sed mollis velit facilisis facilisis viverra.\n</div></div><div id="login-v2-form-wrapper" class="flex-scrollable md-whiteframe-8dp" ms-scroll><div \nid="login-v2-form"><div class="logo md-accent-bg" hide-gt-sm><span>F</span></div><div class="title" \ntranslate="LOGIN_V2.TITLE">Log in to your account</div><div class="description" translate="LOGIN_V2.DESCRIPTION">\nSed mollis velit facilisis facilisis viverra</div><form name="loginForm" novalidate><md-input-container \nclass="md-block" md-no-float><input type="email" name="email" ng-model="vm.form.email" placeholder="Email" translate \ntranslate-attr-placeholder="LOGIN_V2.EMAIL" ng-pattern="/^.+@.+\\..+$/" required><div \nng-messages="loginForm.email.$error" role="alert" multiple="multiple"><div ng-message="required"><span \ntranslate="LOGIN_V2.ERRORS.EMAIL_REQUIRED">Email field is required</span></div><div ng-message="pattern"><span \ntranslate="LOGIN_V2.ERRORS.EMAIL_MUST_VALID">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-input-container class="md-block" md-no-float><input type="password" name="password" \nng-model="vm.form.password" placeholder="Password" translate translate-attr-placeholder="LOGIN_V2.PASSWORD" required>\n<div ng-messages="loginForm.password.$error" role="alert"><div ng-message="required"><span \ntranslate="LOGIN_V2.ERRORS.PASSWORD_REQUIRED">Password field is required</span></div></div></md-input-container><div \nclass="remember-forgot-password" layout="row" layout-sm="column" layout-align="space-between center"><md-checkbox \nclass="remember-me" ng-model="data.cb1" aria-label="Remember Me"><span translate="LOGIN_V2.REMEMBER_ME">Remember Me\n</span></md-checkbox><a ui-sref="app.pages_auth_forgot-password" class="forgot-password md-accent-color" \ntranslate="LOGIN_V2.FORGOT_PASSWORD">Forgot Password?</a></div><md-button type="submit" \nclass="md-raised md-accent submit-button" aria-label="LOG IN" ng-disabled="loginForm.$invalid || loginForm.$pristine" \ntranslate="LOGIN_V2.LOG_IN" translate-attr-aria-label="LOGIN_V2.LOG_IN">LOG IN</md-button></form><div \nclass="separator"><span class="text" translate="LOGIN_V2.OR">OR</span></div><div layout="column" \nlayout-align="start center"><md-button class="md-raised google"><div layout="row" layout-align="center center"><span>\n<md-icon md-font-icon="icon-google-plus" class="s16"></md-icon><span translate="LOGIN_V2.WITH_GOOGLE">\nLog in with Google</span></span></div></md-button><md-button class="md-raised facebook"><div layout="row" \nlayout-align="center center"><span><md-icon md-font-icon="icon-facebook" class="s16"></md-icon><span \ntranslate="LOGIN_V2.WITH_FACEBOOK">Log in with Facebook</span></span></div></md-button></div><div class="register" \nlayout="row" layout-sm="column" layout-align="center center"><span class="text" translate="LOGIN_V2.DONT_HAVE_ACCOUNT">\nDon\'t have an account?</span> <a class="link" ui-sref="app.pages_auth_register-v2" translate="LOGIN_V2.CREATE_ACCOUNT">\nCreate an account</a></div></div></div></div>');
$templateCache.put('app/main/pages/auth/register/register.html','<div id="register" class="flex-scrollable" layout="column" ms-scroll><div id="register-form-wrapper" layout="column" \nlayout-align="center center"><div id="register-form" class="md-whiteframe-8dp"><div class="logo md-accent-bg"><span>F\n</span></div><div class="title" translate="REGISTER.TITLE">Create an account</div><form name="registerForm" novalidate>\n<md-input-container class="md-block" md-no-float><input name="username" ng-model="vm.form.username" placeholder="Name" \ntranslate translate-attr-placeholder="REGISTER.NAME" required><div ng-messages="registerForm.username.$error" \nrole="alert"><div ng-message="required"><span translate="REGISTER.ERRORS.USERNAME_REQUIRED">Username field is required\n</span></div></div></md-input-container><md-input-container class="md-block" md-no-float><input type="email" \nname="email" ng-model="vm.form.email" placeholder="Email" translate translate-attr-placeholder="REGISTER.EMAIL" \nng-pattern="/^.+@.+\\..+$/" required><div ng-messages="registerForm.email.$error" role="alert" multiple="multiple"><div \nng-message="required"><span translate="REGISTER.ERRORS.EMAIL_REQUIRED">Email field is required</span></div><div \nng-message="pattern"><span translate="REGISTER.ERRORS.EMAIL_MUST_VALID">Email must be a valid e-mail address</span>\n</div></div></md-input-container><md-input-container class="md-block" md-no-float><input type="password" \nname="password" ng-model="vm.form.password" placeholder="Password" translate \ntranslate-attr-placeholder="REGISTER.PASSWORD" required><div ng-messages="registerForm.password.$error" role="alert">\n<div ng-message="required"><span translate="REGISTER.ERRORS.PASSWORD_REQUIRED">Password field is required</span></div>\n</div></md-input-container><md-input-container class="md-block" md-no-float><input type="password" \nname="passwordConfirm" ng-model="vm.form.passwordConfirm" placeholder="Password (Confirm)" translate \ntranslate-attr-placeholder="REGISTER.PASSWORD_CONFIRM" required><div ng-messages="registerForm.passwordConfirm.$error" \nrole="alert"><div ng-message="required"><span translate="REGISTER.ERRORS.PASSWORD_CONFIRM_REQUIRED">\nPassword (Confirm) field is required</span></div></div></md-input-container><div class="terms" layout="row" \nlayout-align="center center"><md-checkbox name="terms" ng-model="data.cb1" aria-label="I read and accept" required>\n</md-checkbox><div layout="row" layout-sm="column" layout-align="start center"><span translate="REGISTER.READ_ACCEPT">\nI read and accept</span> <a href="#" class="md-accent-color" translate="REGISTER.TERMS_COND">terms and conditions</a>\n</div></div><md-button type="submit" class="md-raised md-accent submit-button" aria-label="CREATE MY ACCOUNT" \nng-disabled="registerForm.$invalid || registerForm.$pristine" translate="REGISTER.CREATE_ACCOUNT" \ntranslate-attr-aria-label="REGISTER.CREATE_ACCOUNT">CREATE MY ACCOUNT</md-button></form><div class="login" \nlayout="row" layout-xs="column" layout-align="center center"><span class="text" translate="REGISTER.ALREADY_HAVE">\nAlready have an account?</span> <a class="link" ui-sref="app.pages_auth_login" translate="REGISTER.LOGIN">Log in</a>\n</div></div></div></div>');
$templateCache.put('app/main/pages/auth/reset-password/reset-password.html','<div id="reset-password" class="flex-scrollable" layout="column" ms-scroll><div id="reset-password-form-wrapper" \nlayout="column" layout-align="center center"><div id="reset-password-form" class="md-whiteframe-8dp"><div \nclass="logo md-accent-bg"><span>F</span></div><div class="title" translate="RESETPASSWORD.TITLE">Reset your password\n</div><form name="resetPasswordForm" novalidate><md-input-container class="md-block" md-no-float><input type="email" \nname="email" ng-model="vm.form.email" placeholder="Email address" translate \ntranslate-attr-placeholder="RESETPASSWORD.EMAIL_ADRESS" ng-pattern="/^.+@.+\\..+$/" required><div \nng-messages="resetPasswordForm.email.$error" role="alert" multiple="multiple"><div ng-message="required"><span \ntranslate="RESETPASSWORD.ERRORS.EMAIL_REQUIRED">Email field is required</span></div><div ng-message="pattern"><span \ntranslate="RESETPASSWORD.ERRORS.EMAIL_MUST_VALID">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-input-container class="md-block" md-no-float><input type="password" name="password" \nng-model="vm.form.password" placeholder="Password" translate translate-attr-placeholder="RESETPASSWORD.PASSWORD" \nrequired><div ng-messages="registerForm.password.$error" role="alert"><div ng-message="required"><span \ntranslate="RESETPASSWORD.ERRORS.PASSWORD_REQUIRED">Password field is required</span></div></div></md-input-container>\n<md-input-container class="md-block" md-no-float><input type="password" name="passwordConfirm" \nng-model="vm.form.passwordConfirm" placeholder="Password (Confirm)" translate \ntranslate-attr-placeholder="RESETPASSWORD.PASSWORD_CONFIRM" required><div \nng-messages="resetPasswordForm.passwordConfirm.$error" role="alert"><div ng-message="required"><span \ntranslate="RESETPASSWORD.ERRORS.PASSWORD_CONFIRM_REQUIRED">Password (Confirm) field is required</span></div></div>\n</md-input-container><md-button type="submit" class="md-raised md-accent submit-button" \naria-label="UPDATE MY PASSWORD" ng-disabled="resetPasswordForm.$invalid || resetPasswordForm.$pristine" \ntranslate="RESETPASSWORD.UPDATE_PASSWORD" translate-attr-aria-label="RESETPASSWORD.UPDATE_PASSWORD">RESET MY PASSWORD\n</md-button></form></div></div></div>');
$templateCache.put('app/main/pages/auth/register-v2/register-v2.html','<div id="register-v2" layout="row" layout-align="start"><div id="register-v2-intro" flex hide show-gt-sm><div \nclass="logo md-accent-bg"><span>F</span></div><div class="title" translate="REGISTER_V2.INTRO_TITLE">\nWelcome to the FUSE!</div><div class="description" translate="REGISTER_V2.INTRO_DESCRIPTION">\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ullamcorper nisl erat, vel convallis elit fermentum pellentesque. Sed mollis velit facilisis facilisis viverra.\n</div></div><div id="register-v2-form-wrapper" class="flex-scrollable md-whiteframe-8dp" layout="column" flex \nms-scroll><div id="register-v2-form"><div class="logo md-accent-bg" hide-gt-sm><span>F</span></div><div class="title" \ntranslate="REGISTER_V2.TITLE">Create an account</div><div class="description" translate="REGISTER_V2.DESCRIPTION">\nSed mollis velit facilisis facilisis viverra</div><form name="registerForm" novalidate><md-input-container \nclass="md-block" md-no-float><input name="username" ng-model="vm.form.username" placeholder="Name" translate \ntranslate-attr-placeholder="REGISTER_V2.NAME" required><div ng-messages="registerForm.username.$error" role="alert">\n<div ng-message="required"><span translate="REGISTER_V2.ERRORS.USERNAME_REQUIRED">Username field is required</span>\n</div></div></md-input-container><md-input-container class="md-block" md-no-float><input type="email" name="email" \nng-model="vm.form.email" placeholder="Email" translate translate-attr-placeholder="REGISTER_V2.EMAIL" \nng-pattern="/^.+@.+\\..+$/" required><div ng-messages="registerForm.email.$error" role="alert" multiple="multiple"><div \nng-message="required"><span translate="REGISTER_V2.ERRORS.EMAIL_REQUIRED">Email field is required</span></div><div \nng-message="pattern"><span translate="REGISTER_V2.ERRORS.EMAIL_MUST_VALID">Email must be a valid e-mail address</span>\n</div></div></md-input-container><md-input-container class="md-block" md-no-float><input type="password" \nname="password" ng-model="vm.form.password" placeholder="Password" translate \ntranslate-attr-placeholder="REGISTER_V2.PASSWORD" required><div ng-messages="registerForm.password.$error" \nrole="alert"><div ng-message="required"><span translate="REGISTER_V2.ERRORS.PASSWORD_REQUIRED">\nPassword field is required</span></div></div></md-input-container><md-input-container class="md-block" md-no-float>\n<input type="password" name="passwordConfirm" ng-model="vm.form.passwordConfirm" placeholder="Password (Confirm)" \ntranslate translate-attr-placeholder="REGISTER_V2.PASSWORD_CONFIRM" required><div \nng-messages="registerForm.passwordConfirm.$error" role="alert"><div ng-message="required"><span \ntranslate="REGISTER_V2.ERRORS.PASSWORD_CONFIRM_REQUIRED">Password (Confirm) field is required</span></div></div>\n</md-input-container><div class="terms" layout="row" layout-align="center center"><md-checkbox name="terms" \nng-model="data.cb1" aria-label="I read and accept" required></md-checkbox><div layout="row" layout-sm="column" \nlayout-align="start center"><span translate="REGISTER_V2.READ_ACCEPT">I read and accept</span> <a href="#" \nclass="md-accent-color" translate="REGISTER_V2.TERMS_COND">terms and conditions</a></div></div><md-button \ntype="submit" class="md-raised md-accent submit-button" aria-label="CREATE MY ACCOUNT" \nng-disabled="registerForm.$invalid || registerForm.$pristine" translate="REGISTER_V2.CREATE_ACCOUNT" \ntranslate-attr-aria-label="REGISTER_V2.CREATE_ACCOUNT">CREATE MY ACCOUNT</md-button></form><div class="login" \nlayout="row" layout-sm="column" layout-align="center center"><span class="text" translate="REGISTER_V2.ALREADY_HAVE">\nAlready have an account?</span> <a class="link" ui-sref="app.pages_auth_login-v2" translate="REGISTER_V2.LOGIN">Log in\n</a></div></div></div></div>');
$templateCache.put('app/main/ui/page-layouts/blank/blank.html','<div class="page-layout blank" layout="row"><h2>Blank page</h2></div>');
$templateCache.put('app/main/ui/forms/stepper-steps/step-1.html','<div class="md-inline-form"><p>Fill the <span class="text-bold">Lastname</span> field to reveal the conditional step!\n</p><div layout="column" layout-gt-xs="row" flex><md-input-container flex="100" flex-gt-xs="50"><input type="text" \nname="firstname" ng-model="vm.stepper.step1.firstname" placeholder="Firstname" required><div \nng-messages="step1.firstname.$error" ng-show="step1.firstname.$touched" role="alert"><div ng-message="required"><span>\nFirstname field is required.</span></div></div></md-input-container><md-input-container flex="100" flex-gt-xs="50">\n<input type="text" name="lastname" ng-model="vm.stepper.step1.lastname" placeholder="Lastname"><div \nng-messages="step1.lastname.$error" ng-show="step1.lastname.$touched" role="alert"><div ng-message="required"><span>\nLastname field is required.</span></div></div></md-input-container></div></div>');
$templateCache.put('app/main/ui/forms/stepper-steps/step-2.html','<div class="md-inline-form"><p>Fill the <span class="text-bold">Birthplace</span>\n field to reveal another conditional step! Conditional step-ception!</p><div layout="column" layout-gt-xs="row" flex>\n<md-input-container flex="100" flex-gt-xs="50"><input type="text" name="birthplace" \nng-model="vm.stepper.step2.birthplace" placeholder="Birthplace"></md-input-container></div></div>');
$templateCache.put('app/main/ui/forms/stepper-steps/step-3.html','<div class="md-inline-form"><div layout="column" layout-gt-xs="row" flex><md-input-container flex="100" \nflex-gt-xs="50"><input type="text" name="ssn" ng-model="vm.stepper.step3.ssn" placeholder="Social Security Number">\n</md-input-container></div></div>');
$templateCache.put('app/main/ui/forms/stepper-steps/step-4.html','<div class="md-inline-form"><div layout="column" layout-gt-xs="row" flex><md-input-container flex="100"><label>Address\n</label> <textarea ng-model="vm.stepper.step4.address" columns="1" md-maxlength="150" rows="5"></textarea><div \nng-messages="step4.address.$error" ng-show="step4.address.$touched" role="alert"></div></md-input-container></div>\n</div>');
$templateCache.put('app/main/ui/forms/stepper-steps/step-5.html','<div class="md-inline-form"><md-input-container class="md-block"><input type="text" name="cardholder" \nng-model="vm.stepper.step5.cardholder" placeholder="Card Holder" required><div ng-messages="step5.cardholder.$error" \nrole="alert"><div ng-message="required"><span>Card holder field is required.</span></div></div></md-input-container>\n<div layout="column" layout-gt-xs="row"><md-input-container flex="100" flex-gt-xs="33"><input type="text" \nname="cardnumber" ng-model="vm.stepper.step5.cardnumber" placeholder="Card Number" required><div \nng-messages="step5.cardnumber.$error" role="alert"><div ng-message="required"><span>Card number field is required.\n</span></div></div></md-input-container><md-input-container flex="100" flex-gt-xs="33"><input type="text" name="CC2" \nng-model="vm.stepper.step5.cc2" placeholder="CC2" md-maxlength="3" required><div ng-messages="step5.cc2.$error" \nrole="alert" multipl><div ng-message="required"><span>CC2 field is required.</span></div><div \nng-message="md-maxlength"><span>CC2 can\'t be longer than 3 characters.</span></div></div></md-input-container>\n<md-input-container flex="100" flex-gt-xs="33"><input type="text" name="expirationDate" \nng-model="vm.stepper.step5.expirationDate" placeholder="Expiration Date" required><div \nng-messages="step5.expirationDate.$error" role="alert"><div ng-message="required"><span>\nExpiration date field is required.</span></div></div></md-input-container></div></div>');
$templateCache.put('app/main/ui/page-layouts/demo/demo-content.html','<div class="demo-content"><img src="assets/images/etc/early-sunrise.jpg" class="md-card-image" alt="sunrise"><h1>\nEarly Sunrise</h1><h4 class="secondary-text">Demo Content</h4><p>\nOne morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections.\n</p><blockquote><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment. His many legs, pitifully thin compared with the size of the rest of him, waved about helplessly as he looked. "What\'s happened to me? " he thought. It wasn\'t a dream.\n</p><footer>John Doe</footer></blockquote><p>\nHis room, a proper human room although a little too small, lay peacefully between its four familiar walls. A collection of textile samples lay spread out on the table - Samsa was a travelling salesman - and above it there hung a picture that he had recently cut out of an illustrated magazine and housed in a nice, gilded frame.\n</p><p>\nIt showed a lady fitted out with a fur hat and fur boa who sat upright, raising a heavy fur muff that covered the whole of her lower arm towards the viewer. Gregor then turned to look out the window at the dull weather. Drops of rain could be heard hitting the pane, which made him feel quite sad.\n</p><p>\n"How about if I sleep a little bit longer and forget all this nonsense", he thought, but that was something he was unable to do because he was used to sleeping on his right, and in his present state couldn\'t get into that position. However hard he threw himself onto his right, he always rolled back to where he was.\n</p><p>\nHe must have tried it a hundred times, shut his eyes so that he wouldn\'t have to look at the floundering legs, and only stopped when he began to feel a mild, dull pain there that he had never felt before. "Oh, God", he thought, "what a strenuous career it is that I\'ve chosen!\n</p><p>\nTravelling day in and day out. Doing business like this takes much more effort than doing your own business at home, and on top of that there\'s the curse of travelling, worries about making train connections, bad and irregular food, contact with different people all the time so that you can never get to know anyone or become friendly with them.\n</p><p>\n"He felt a slight itch up on his belly; pushed himself slowly up on his back towards the headboard so that he could lift his head better; found where the itch was, and saw that it was covered with lots of little white spots which he didn\'t know what to make of; and when he tried to feel the place with one of his legs he drew it quickly back because as soon as he touched it he was overcome by a cold shudder. He slid back into his former position.\n</p><p>\n"Getting up early all the time", he thought, "it makes you stupid. You\'ve got to get enough sleep. Other travelling salesmen live a life of luxury. For instance, whenever I go back to the guest house during the morning to copy out the contract, these gentlemen are always still sitting there eating their breakfasts. I ought to just try that with my boss; I\'d get kicked out on the spot. But who knows, maybe that would be the best thing for me...\n</p></div>');
$templateCache.put('app/main/ui/page-layouts/demo/demo-sidenav.html','<div class="demo-sidenav"><md-list><md-subheader class="md-no-sticky">Sidenav Demo</md-subheader><md-list-item><p>\nSidenav Item 1</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 2</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 3</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 4</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 5</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 6</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 7</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 8</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 9</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 10</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 11</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 12</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 13</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 14</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 15</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 16</p></md-list-item></md-list></div>');
$templateCache.put('app/core/directives/ms-card/templates/template-1/template-1.html','<div class="template-1"><div class="media"><img class="image" ng-src="{{card.media.image.src}}" \nalt="{{card.media.image.alt}}" ng-show="card.media.image"></div><div class="content pv-24 ph-16"><div class="title h1" \nng-if="card.title">{{card.title}}</div><div class="subtitle secondary-text" ng-if="card.subtitle">{{card.subtitle}}\n</div><div class="text pt-16" ng-if="card.text">{{card.text}}</div></div></div>');
$templateCache.put('app/core/directives/ms-card/templates/template-10/template-10.html','<div class="template-10 p-16"><div class="pb-16" layout="row" layout-align="space-between center"><div class="info">\n<div class="title secondary-text" ng-if="card.title">{{card.title}}</div><div class="subtitle h2" \nng-if="card.subtitle">{{card.subtitle}}</div></div><div class="media ml-16"><img class="image" \nng-src="{{card.media.image.src}}" alt="{{card.media.image.alt}}" ng-show="card.media.image"></div></div><div \nclass="text">{{card.text}}</div></div>');
$templateCache.put('app/core/directives/ms-card/templates/template-2/template-2.html','<div class="template-2"><div class="header p-16" layout="row" layout-align="start center"><div ng-if="card.avatar"><img\n class="avatar mr-16" ng-src="{{card.avatar.src}}" alt="{{card.avatar.alt}}"></div><div class="info"><div \nclass="title" ng-if="card.title">{{card.title}}</div><div class="subtitle secondary-text" ng-if="card.subtitle">\n{{card.subtitle}}</div></div></div><div class="media"><img class="image" ng-src="{{card.media.image.src}}" \nalt="{{card.media.image.alt}}" ng-show="card.media.image"></div><div class="text p-16" ng-if="card.text">{{card.text}}\n</div></div>');
$templateCache.put('app/core/directives/ms-card/templates/template-3/template-3.html','<div class="template-3 p-16 teal-bg white-fg" layout="row" layout-align="space-between"><div layout="column" \nlayout-align="space-between"><div class="info"><div class="title h1" ng-if="card.title">{{card.title}}</div><div \nclass="subtitle h3 secondary-text" ng-if="card.subtitle">{{card.subtitle}}</div></div><div class="cta"><md-button \nclass="m-0">{{card.cta}}</md-button></div></div><div class="media pl-16"><img class="image" \nng-src="{{card.media.image.src}}" alt="{{card.media.image.alt}}" ng-show="card.media.image"></div></div>');
$templateCache.put('app/core/directives/ms-card/templates/template-4/template-4.html','<div class="template-4"><div class="info white-fg ph-16 pv-24"><div class="title h1" ng-if="card.title">{{card.title}}\n</div><div class="text" ng-if="card.text">{{card.text}}</div></div><div class="media"><img class="image" \nng-src="{{card.media.image.src}}" alt="{{card.media.image.alt}}" ng-show="card.media.image"></div></div>');
$templateCache.put('app/core/directives/ms-card/templates/template-5/template-5.html','<div class="template-5 p-16" layout="row" layout-align="space-between start"><div class="info"><div \nclass="title secondary-text" ng-if="card.title">{{card.title}}</div><div class="event h2" ng-if="card.event">\n{{card.event}}</div></div><div class="media ml-16"><img class="image" ng-src="{{card.media.image.src}}" \nalt="{{card.media.image.alt}}" ng-show="card.media.image"></div></div>');
$templateCache.put('app/core/directives/ms-card/templates/template-6/template-6.html','<div class="template-6"><div class="content pv-24 ph-16"><div class="subtitle secondary-text" ng-if="card.subtitle">\n{{card.subtitle}}</div><div class="title h2" ng-if="card.title">{{card.title}}</div><div class="text pt-8" \nng-if="card.text">{{card.text}}</div></div></div>');
$templateCache.put('app/core/directives/ms-card/templates/template-7/template-7.html','<div class="template-7" layout="row" layout-align="space-between"><div class="info" layout="column" \nlayout-align="space-between" layout-fill flex><div class="p-16"><div class="title h1" ng-if="card.title">{{card.title}}\n</div><div class="subtitle h4 secondary-text" ng-if="card.subtitle">{{card.subtitle}}</div><div class="text h4 pt-8" \nng-if="card.text">{{card.text}}</div></div><div><md-divider></md-divider><div class="p-8" layout="row"><md-icon \nmd-font-icon="icon-star-outline" class="mh-5"></md-icon><md-icon md-font-icon="icon-star-outline" class="mh-5">\n</md-icon><md-icon md-font-icon="icon-star-outline" class="mh-5"></md-icon><md-icon md-font-icon="icon-star-outline" \nclass="mh-5"></md-icon><md-icon md-font-icon="icon-star-outline" class="mh-5"></md-icon></div></div></div><div \nclass="media"><img class="image" ng-src="{{card.media.image.src}}" alt="{{card.media.image.alt}}" \nng-show="card.media.image"></div></div>');
$templateCache.put('app/core/directives/ms-card/templates/template-9/template-9.html','<div class="template-9"><div class="header p-16" layout="row" layout-align="start center"><div ng-if="card.avatar"><img\n class="avatar mr-16" ng-src="{{card.avatar.src}}" alt="{{card.avatar.alt}}"></div><div class="info"><div \nclass="title" ng-if="card.title">{{card.title}}</div><div class="subtitle secondary-text" ng-if="card.subtitle">\n{{card.subtitle}}</div></div></div><div class="text ph-16 pb-16" ng-if="card.text">{{card.text}}</div><div \nclass="media"><img class="image" ng-src="{{card.media.image.src}}" alt="{{card.media.image.alt}}" \nng-show="card.media.image"></div><div class="buttons m-8"><md-button class="md-icon-button mr-16" \naria-label="Favorite"><md-icon md-font-icon="icon-heart-outline" class="s24"></md-icon></md-button><md-button \nclass="md-icon-button" aria-label="Share"><md-icon md-font-icon="icon-share" class="s24"></md-icon></md-button></div>\n</div>');
$templateCache.put('app/core/directives/ms-card/templates/template-8/template-8.html','<div class="template-8"><div class="media"><img class="image" ng-src="{{card.media.image.src}}" \nalt="{{card.media.image.alt}}" ng-show="card.media.image"></div><div class="content pv-24 ph-16"><div class="title h1" \nng-if="card.title">{{card.title}}</div><div class="subtitle secondary-text" ng-if="card.subtitle">{{card.subtitle}}\n</div><div class="buttons pt-16"><md-button class="m-0">{{card.button1}}</md-button><md-button class="m-0 md-accent">\n{{card.button2}}</md-button></div><div class="text pt-16" ng-if="card.text">{{card.text}}</div></div></div>');
$templateCache.put('app/core/directives/ms-stepper/templates/horizontal/horizontal.html','<div class="ms-stepper-horizontal"><div class="ms-stepper-navigation-wrapper"><div class="ms-stepper-navigation" \nlayout="row" layout-align="center center"><md-button class="ms-stepper-navigation-item" \nng-class="{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}" \nng-click="MsStepper.gotoStep(step.stepNumber)" ng-disabled="MsStepper.isStepDisabled(step.stepNumber)" \nng-repeat="step in MsStepper.steps | filter:MsStepper.filterHiddenStep" layout="row" layout-align="start center"><div \nclass="step md-accent-bg" layout="row" layout-align="center center"><span \nng-if="!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)">{{$index + 1}} </span>\n<span ng-if="MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)"><i \nclass="icon icon-check s18"></i></span></div><div layout="column" layout-align="start start"><div class="title">\n{{step.stepTitle}}</div><div class="subtitle" ng-if="MsStepper.isStepOptional(step.stepNumber)">Optional</div></div>\n</md-button></div></div><div class="ms-stepper-steps" ng-transclude></div><div class="ms-stepper-controls" \nlayout="row" layout-align="center center"><md-button class="md-accent md-raised" ng-disabled="MsStepper.isFirstStep()" \nng-click="MsStepper.gotoPreviousStep()">Back</md-button><div class="ms-stepper-dots"><span \nng-repeat="step in MsStepper.steps" ng-hide="MsStepper.isStepHidden(step.stepNumber)" \nng-class="{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}"></span></div><md-button \nclass="md-accent md-raised" ng-if="!MsStepper.isLastStep()" \nng-disabled="!MsStepper.isStepValid(MsStepper.currentStepNumber)" ng-click="MsStepper.gotoNextStep()">Next</md-button>\n<md-button type="submit" class="md-accent md-raised" ng-click="MsStepper.resetForm()" ng-if="MsStepper.isLastStep()" \nng-disabled="!MsStepper.isFormValid()">Submit</md-button></div></div>');
$templateCache.put('app/main/apps/calendar/dialogs/event-detail/event-detail-dialog.html','<md-dialog class="event-detail-dialog" aria-label="New Message"><md-toolbar class="md-accent md-hue-2"><div \nclass="md-toolbar-tools"><span class="title">{{vm.calendarEvent.title}}</span> <span flex></span><md-button \nclass="edit-event-button md-fab md-warn" ng-click="vm.editEvent(vm.calendarEvent)" aria-label="Edit event" translate \ntranslate-attr-aria-label="CALENDAR.EDIT_EVENT"><md-icon md-font-icon="icon-pencil"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class="event-details" layout="column"><div class="event-detail-row" \nlayout="row" layout-align="start start"><md-icon md-font-icon="icon-clock"></md-icon><div layout="column" flex><span \nclass="h4">{{vm.calendarEvent.start.format(\'MMMM Do YYYY, h:mm:ss a\')}} <span ng-if="vm.calendarEvent.end">-</span>\n {{vm.calendarEvent.end.format(\'MMMM Do YYYY, h:mm:ss a\')}}</span> <span class="secondary-text">\n{{vm.calendarEvent.repeat || \'Does not repeat\'}}</span></div></div><div class="event-detail-row" layout="row" \nlayout-align="start start"><md-icon md-font-icon="icon-bell-ring-outline"></md-icon><div layout="column" flex><span \nclass="h4" translate="CALENDAR.30_MIN_BEFORE">30 minutes before</span> <span class="h4" \ntranslate="CALENDAR.15_MIN_BEFORE">15 minutes before</span> <span class="h4" translate="CALENDAR.30_MIN_LATER">\n30 minutes later</span></div></div><div class="event-detail-row" layout="row" layout-align="start start"><md-icon \nmd-font-icon="icon-map-marker"></md-icon><div layout="column" flex><span class="h4">Istanbul, Turkey</span></div></div>\n<div class="event-detail-row" layout="row" layout-align="start center"><md-icon md-font-icon="icon-account"></md-icon>\n<div layout="row" flex><img src="assets/images/avatars/alice.jpg" class="avatar" alt="alice"> <img \nsrc="assets/images/avatars/joyce.jpg" class="avatar" alt="joyce"> <img src="assets/images/avatars/vincent.jpg" \nclass="avatar" alt="vincent"></div></div></div></md-dialog-content></md-dialog>');
$templateCache.put('app/main/apps/calendar/dialogs/event-form/event-form-dialog.html','<md-dialog class="event-form-dialog" aria-label="New Message"><form name="eventForm" class="md-inline-form" novalidate>\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n<span class="title">{{vm.dialogTitle}}</span><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog" translate translate-attr-aria-label="CALENDAR.CLOSE_DIALOG"><md-icon \nmd-font-icon="icon-close"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass="md-block"><label translate="CALENDAR.TITLE">Title</label> <input name="title" ng-model="vm.calendarEvent.title" \nrequired><div ng-messages="eventForm.title.$error" ng-show="eventForm.title.$touched" role="alert"><div \nng-message="required"><span translate="CALENDAR.ERRORS.TITLE_REQUIRED">Title field is required</span></div></div>\n</md-input-container><md-list class="all-day"><md-list-item><p translate="CALENDAR.ALL_DAY">All Day</p><md-switch \nclass="md-secondary" ng-model="vm.calendarEvent.allday" aria-label="All day" translate \ntranslate-attr-aria-label="CALENDAR.ALL_DAY"></md-switch></md-list-item></md-list><div layout="row" class="date-row">\n<md-datepicker ng-model="vm.calendarEvent.start" md-placeholder="Start Date"></md-datepicker><md-input-container flex \nmd-no-float><input ng-model="vm.calendarEvent.startTime" placeholder="Start Time" translate \ntranslate-attr-placeholder="CALENDAR.START_TIME"></md-input-container></div><div layout="row" class="date-row">\n<md-datepicker ng-model="vm.calendarEvent.end" md-placeholder="End Date"></md-datepicker><md-input-container flex \nmd-no-float><input ng-model="vm.calendarEvent.endTime" placeholder="End Time" translate \ntranslate-attr-placeholder="CALENDAR.END_TIME"></md-input-container></div><md-input-container class="md-block" flex>\n<label translate="CALENDAR.REPEAT">Repeat</label> <input ng-model="vm.calendarEvent.repeat"></md-input-container>\n<md-input-container class="md-block" flex><label translate="CALENDAR.LOCATION">Location</label> <input \nng-model="vm.calendarEvent.location"></md-input-container><div class="notifications" layout="column"><div \nclass="title" translate="CALENDAR.NOTIFICATIONS">Notifications</div><md-select ng-model="notification" \nplaceholder="Notification" ng-repeat="notification in vm.calendarEvent.notifications"><md-option \nng-repeat="opt in vm.notifications" value="{{opt}}">{{opt}}</md-option></md-select><md-button \naria-label="+ Add Another Notification" translate="CALENDAR.ADD_NOTIFICATION" \ntranslate-attr-aria-label="CALENDAR.ADD_NOTIFICATION">+ Add Another Notification</md-button></div><md-input-container \nflex class="md-block textarea-container"><label translate="CALENDAR.NOTES">Notes</label> <textarea \nng-model="vm.task.notes" md-maxlength="250"></textarea></md-input-container></md-dialog-content><md-dialog-actions \nlayout="row" layout-align="space-between center"><md-button ng-click="vm.saveEvent()" \nclass="save-button md-accent md-raised" aria-label="SAVE" ng-disabled="eventForm.$invalid || eventForm.$pristine" \ntranslate="CALENDAR.SAVE" translate-attr-aria-label="CALENDAR.SAVE">SAVE</md-button><md-button class="md-icon-button" \naria-label="Delete" translate translate-attr-aria-label="CALENDAR.DELETE"><md-icon md-font-icon="icon-delete">\n</md-icon><md-tooltip><span translate="CALENDAR.DELETE">Delete</span></md-tooltip></md-button></md-dialog-actions>\n</form></md-dialog>');
$templateCache.put('app/main/apps/calendar/dialogs/event-detail-ft/event-detail-dialog.html','<md-dialog class="event-detail-dialog" aria-label="New Message"><md-toolbar class="md-accent md-hue-2"><div \nclass="md-toolbar-tools"><span class="title">{{vm.calendarEvent.title}}</span> <span flex></span><div \nclass="absolute-right pr-10" layout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog" tranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></div></md-toolbar><md-dialog-content ms-scroll><div class="event-details" layout="column">\n<div class="event-detail-row" layout="row" layout-align="start start"><md-icon md-font-icon="icon-clock"></md-icon><div\n layout="column" flex><span class="h4">{{vm.calendarEvent.startLocal.format(\'Do MMMM YYYY, HH:mm:ss\')}} <span \nng-if="vm.calendarEvent.end">-</span> {{vm.calendarEvent.end.format(\'MMMM Do YYYY, h:mm:ss a\')}}</span></div></div>\n</div></md-dialog-content></md-dialog>');
$templateCache.put('app/main/apps/calendar/dialogs/event-form-ft/event-form-dialog.html','<md-dialog aria-label="New Message" class="event-form-dialog"><form class="md-inline-form" name="eventForm" \nnovalidate=""><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><span class="title">{{vm.dialogTitle}}</span><md-button aria-label="Close dialog" \nclass="md-icon-button" ng-click="vm.closeDialog()" translate="" translate-attr-aria-label="CALENDAR.CLOSE_DIALOG">\n<md-icon md-font-icon="icon-close"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=""><div \nclass="event-details border-bottom" flex="100" layout="row" layout-padding=""><div class="event-detail-row" flex="30" \nlayout="row" layout-align="start start"><md-input-container class="md-block"><label translate="CALENDAR.TITLE">Title\n</label> <input name="title" ng-model="vm.calendarEvent.title" required=""><div ng-messages="eventForm.title.$error" \nng-show="eventForm.title.$touched" role="alert"><div ng-message="required"><span \ntranslate="CALENDAR.ERRORS.TITLE_REQUIRED">Title field is required</span></div></div></md-input-container></div><div \nclass="event-detail-row" flex="30" layout="row" layout-align="start start"><div class="date-row" layout="row">\n<md-datepicker md-placeholder="Start Date" ng-model="vm.calendarEvent.start"></md-datepicker></div></div><div \nflex="30" layout-align="start start"><md-input-container><label>Trip Status</label><md-select \nmd-selected-text="vm.getSelectedText()" ng-model="vm.selectedItem"><md-option selected="">CONFIRMED</md-option>\n<md-option>DELAYED</md-option></md-select></md-input-container></div><div flex="30" layout-align="start start">\n<md-input-container><label>Seat Status</label><md-select md-selected-text="vm.getSelectedTextSeat()" \nng-model="vm.selectedItemSeat"><md-option selected="">OPEN SEATS</md-option><md-option>CLOSED SEATS</md-option>\n</md-select></md-input-container></div></div><div class="event-details" flex="100" layout="row"><div class="box" \nflex="50" layout="column"><md-list flex="100"><md-list-item layout="row" layout-align="start center" \nng-click="vm.openContactDialog($event, null)"><div flex="15" layout="column" layout-align="start center"><div><span \nclass="leg title">LEG</span></div><div layout-align="start center"><span class="leg number">1</span></div></div><div \nflex="40" layout="row" layout-padding=""><div class="logo" layout="row" layout-align="start center"><img alt="H2C" \nclass="image" src="assets/images/icons8-Airplane Take Off-26.png"></div><div layout="column"><span>LAX </span><span>\n20/05/2017 </span><span>08:00 MST</span></div></div><div flex="40" layout="row" layout-padding=""><div class="logo" \nlayout="row" layout-align="start center"><img alt="H2C" class="image" \nsrc="assets/images/icons8-Airplane Landing-26.png"></div><div layout="column"><span>NYC </span><span>20/05/2017 </span>\n<span>20:00 PST</span></div></div></md-list-item><md-list-item layout="row" layout-align="start center" \nng-click="vm.openContactDialog($event, null)"><div flex="15" layout="column" layout-align="start center"><div><span \nclass="leg title">LEG</span></div><div layout-align="start center"><span class="leg number">2</span></div></div><div \nflex="40" layout="row" layout-padding=""><div class="logo" layout="row" layout-align="start center"><img alt="H2C" \nclass="image" src="assets/images/icons8-Airplane Take Off-26.png"></div><div layout="column"><span>NYC </span><span>\n20/05/2017 </span><span>08:00 MST</span></div></div><div flex="40" layout="row" layout-padding=""><div class="logo" \nlayout="row" layout-align="start center"><img alt="H2C" class="image" \nsrc="assets/images/icons8-Airplane Landing-26.png"></div><div layout="column"><span>MIA </span><span>20/05/2017 </span>\n<span>20:00 PST</span></div></div></md-list-item><md-list-item layout="row" layout-align="start center" \nng-click="vm.openContactDialog($event, null)"><div flex="15" layout="column" layout-align="start center"><div><span \nclass="leg title">LEG</span></div><div layout-align="start center"><span class="leg number">3</span></div></div><div \nflex="40" layout="row" layout-padding=""><div class="logo" layout="row" layout-align="start center"><img alt="H2C" \nclass="image" src="assets/images/icons8-Airplane Take Off-26.png"></div><div layout="column"><span>MIA </span><span>\n20/05/2017 </span><span>08:00 MST</span></div></div><div flex="40" layout="row" layout-padding=""><div class="logo" \nlayout="row" layout-align="start center"><img alt="H2C" class="image" \nsrc="assets/images/icons8-Airplane Landing-26.png"></div><div layout="column"><span>DCA </span><span>20/05/2017 </span>\n<span>20:00 PST</span></div></div></md-list-item><md-list-item layout="row" layout-align="start center" \nng-click="vm.openContactDialog($event, null)"><div flex="15" layout="column" layout-align="start center"><div><span \nclass="leg title">LEG</span></div><div layout-align="start center"><span class="leg number">4</span></div></div><div \nflex="40" layout="row" layout-padding=""><div class="logo" layout="row" layout-align="start center"><img alt="H2C" \nclass="image" src="assets/images/icons8-Airplane Take Off-26.png"></div><div layout="column"><span>DCA </span><span>\n20/05/2017 </span><span>21:00 MST</span></div></div><div flex="40" layout="row" layout-padding=""><div class="logo" \nlayout="row" layout-align="start center"><img alt="H2C" class="image" \nsrc="assets/images/icons8-Airplane Landing-26.png"></div><div layout="column"><span>MAD </span><span>21/05/2017 </span>\n<span>12:00 PST</span></div></div></md-list-item></md-list><div layout="row" layout-align="center center"><md-button \naria-label="Add event" class="add-event-button md-fab md-warn" \nng-click="vm.mediaDialog($event, \'\', vm.currentThread_Edit)" translate="" \ntranslate-attr-aria-label="CALENDAR.ADD_EVENT"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nlayout-padding="">ADD NEW LEG</div></div></div><div class="border-left" flex="50"><div class="content"><md-tabs \nmd-dynamic-height><md-tab label="LEG"><div class="event-details" flex="100" layout="row"><div \nclass="event-details border-bottom" flex="50" layout="column" layout-padding=""><div><md-input-container><label>Leg\n</label><md-select ng-model="ctrl.userState"><md-option><em>None</em></md-option><md-option ng-value="1" \nng-disabled="$index === 1">1</md-option><md-option ng-value="2" ng-disabled="$index === 1">2</md-option><md-option \nng-value="3" ng-disabled="$index === 1">3</md-option><md-option ng-value="4" ng-disabled="$index === 1">4</md-option>\n<md-option ng-value="5" ng-disabled="$index === 1">5</md-option><md-option ng-value="6" ng-disabled="$index === 1">6\n</md-option></md-select></md-input-container></div><div><md-datepicker md-placeholder="Start Date" \nng-model="vm.calendarEvent.start"></md-datepicker></div><div><md-input-container><label>Authorizer</label><md-select \nng-model="ctrl.Authorizer"><md-option><em>--</em></md-option><md-option ng-value="1" ng-selected>EARHART, AMELIA\n</md-option></md-select></md-input-container></div><div class="event-detail-row" flex="30" layout="row" \nlayout-align="start start"><md-input-container class="md-block"><label>Author. Code</label> <input name="title" \nng-model="vm.calendarEvent.authorCode" required=""></md-input-container></div><div><md-input-container><label>\nAircraft ID</label><md-select ng-model="ctrl.Aircraft"><md-option><em>--</em></md-option><md-option ng-value="1" \nng-selected>N0003C</md-option><md-option ng-value="2">A0222E</md-option></md-select></md-input-container></div><div \nclass="event-detail-row" flex="30" layout="row" layout-align="start start"><md-input-container class="md-block"><label>\nPax Seats</label> <input name="title" ng-model="vm.calendarEvent.PaxSeats" required=""></md-input-container></div>\n</div><div flex="50" layout="column" layout-padding=""><div class="event-detail-row" flex="30" layout="row" \nlayout-align="start start"><md-input-container><label>Departure ICAO</label><md-select ng-model="ctrl.Departure">\n<md-option><em>--</em></md-option><md-option ng-value="1" ng-selected>BJC</md-option><md-option ng-value="2">ARE\n</md-option></md-select></md-input-container></div><div class="event-detail-row" flex="30" layout="row" \nlayout-align="start start"><md-input-container class="md-block"><label>ETD [Local]</label> <input name="etd" \nng-model="vm.calendarEvent.etdlocal" required=""></md-input-container></div><div class="event-detail-row" flex="30" \nlayout="row" layout-align="start start"><md-input-container><label>Arrival ICAO</label><md-select \nng-model="ctrl.Arrival"><md-option><em>--</em></md-option><md-option ng-value="1" ng-selected>SLC</md-option><md-option\n ng-value="2">ARE</md-option></md-select></md-input-container></div><div class="event-detail-row" flex="30" \nlayout="row" layout-align="start start"><md-input-container class="md-block"><label>ETA [Local]</label> <input \nname="eta" ng-model="vm.calendarEvent.etalocal" required=""></md-input-container></div><div class="event-detail-row" \nflex="30" layout="row" layout-align="start start"><md-input-container class="md-block"><label>ETE</label> <input \nname="ete" ng-model="vm.calendarEvent.ETE" required=""></md-input-container></div><div class="event-detail-row" \nflex="30" layout="row" layout-align="start start"><md-input-container class="md-block"><label>Ground Time</label> \n<input name="ete" ng-model="vm.calendarEvent.ground" required=""></md-input-container></div><div \nclass="event-detail-row" flex="30" layout="row" layout-align="start start"><md-input-container class="md-block"><label>\nRON</label> <input name="ete" ng-model="vm.calendarEvent.ron" required=""></md-input-container></div><div>\n<md-input-container><label>Leg Category</label><md-select ng-model="ctrl.LegCategory"><md-option><em>--</em>\n</md-option><md-option ng-value="1" ng-disabled="$index === 1">BIZ</md-option><md-option ng-value="2" \nng-disabled="$index === 1">CANCEL</md-option><md-option ng-value="3" ng-disabled="$index === 1">CUST</md-option>\n<md-option ng-value="4" ng-disabled="$index === 1">EXEC</md-option><md-option ng-value="5" ng-disabled="$index === 1">\nFRGHT</md-option><md-option ng-value="6" ng-disabled="$index === 1">GUEST</md-option></md-select></md-input-container>\n</div><div class="event-detail-row" flex="30" layout="row" layout-align="start start"><md-input-container \nclass="md-block"><label>Duty Standard</label> <input name="ete" ng-model="vm.calendarEvent.duty" required="">\n</md-input-container></div></div></div></md-tab><md-tab label="PAX"><div class="content" layout="row" \nlayout-align="start start" md-background-bg=""><div class="main" flex="100" ms-scroll=""><md-list flex="100">\n<md-list-item ng-class="{\'selected\': vm.isSelected(contact)}" ng-click="vm.openContactDialog($event, contact)" \nng-repeat="contact in vm.contacts track by contact.id "><img alt="{{contact.name}}" class="md-avatar" \nng-if="contact.avatar" ng-src="{{contact.avatar}}"><p class="text-truncate font-weight-600">\n{{contact.name}} {{contact.lastName}}</p><div ng-if="vm.exists(contact, vm.selectedContacts)">ADDED</div><md-checkbox \naria-label="{{vm.exists(contact, vm.selectedContacts) ? \'Deselect\' : \'Select\'}}" \nng-checked="vm.exists(contact, vm.selectedContacts)" ng-click="vm.toggleSelectContact(contact, $event)"></md-checkbox>\n</md-list-item></md-list><md-list-item class="no-results md-white-bg" ng-show="filteredContacts.length === 0"><p \ntranslate="CONTACTS.NO_RESULTS">No results..</p></md-list-item></div></div></md-tab><md-tab label="CREW"><div \nclass="content" layout="row" layout-align="start start" md-background-bg=""><div class="main" flex="100" ms-scroll="">\n<md-list flex="100"><md-list-item ng-class="{\'selected\': vm.isSelected(contact)}" \nng-click="vm.openContactDialog($event, contact)" ng-repeat="contact in vm.contactsCrew track by contact.id "><img \nalt="{{contact.name}}" class="md-avatar" ng-if="contact.avatar" ng-src="{{contact.avatar}}"><p \nclass="text-truncate font-weight-600">{{contact.name}} {{contact.lastName}}</p><div \nng-if="vm.exists(contact, vm.selectedContacts)">ADDED</div><md-checkbox \naria-label="{{vm.exists(contact, vm.selectedContacts) ? \'Deselect\' : \'Select\'}}" \nng-checked="vm.exists(contact, vm.selectedContacts)" ng-click="vm.toggleSelectContact(contact, $event)"></md-checkbox>\n</md-list-item></md-list><md-list-item class="no-results md-white-bg" ng-show="filteredContacts.length === 0"><p \ntranslate="CONTACTS.NO_RESULTS">No results..</p></md-list-item></div></div></md-tab><md-tab label="MESSAGES"></md-tab>\n</md-tabs></div></div></div></md-dialog-content><md-dialog-actions layout="row" layout-align="space-between center">\n<md-button aria-label="SAVE" class="save-button md-accent md-raised" ng-click="vm.saveEvent()" \nng-disabled="eventForm.$invalid || eventForm.$pristine" translate="CALENDAR.SAVE" \ntranslate-attr-aria-label="CALENDAR.SAVE">SAVE</md-button><md-button aria-label="Delete" class="md-icon-button" \ntranslate="" translate-attr-aria-label="CALENDAR.DELETE"><md-icon md-font-icon="icon-delete"></md-icon><md-tooltip>\n<span translate="CALENDAR.DELETE">Delete</span></md-tooltip></md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/chat/sidenavs/left/left-sidenav.html','<div ng-show="vm.leftSidenavView === \'contacts\'" class="view contacts-view animate-slide-left" \nng-include="\'app/main/apps/chat/sidenavs/left/views/contacts/contacts-view.html\'" layout="column" flex></div><div \nng-show="vm.leftSidenavView ===\'user\'" class="view user-view animate-slide-left" \nng-include="\'app/main/apps/chat/sidenavs/left/views/user/user-view.html\'" layout="column" flex></div><div \nng-hide="vm.leftSidenavView" class="view chats-view animate-slide-right" \nng-include="\'app/main/apps/chat/sidenavs/left/views/chats/chats-view.html\'" layout="column" flex></div>');
$templateCache.put('app/main/apps/chat/sidenavs/right/right-sidenav.html','<div class="view contact-view" ng-include="\'app/main/apps/chat/sidenavs/right/views/contact/contact-view.html\'" \nlayout="column" flex></div>');
$templateCache.put('app/main/apps/aircrafts/dialogs/compose/compose-dialog.html','<md-dialog class="compose-dialog" aria-label="New Message"><form class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="MAIL.NEW_MESSAGE">New Message</span><md-button class="md-icon-button" \nng-click="vm.closeDialog()" aria-label="Close dialog" tranlate translate-aria-label="MAIL.CLOSE_DIALOG"><md-icon \nmd-font-icon="icon-close"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass="md-block"><label translate="MAIL.FROM">From</label> <input ng-model="vm.form.from" type="email" \ndisabled="disabled"></md-input-container><md-input-container class="md-block to" \nng-class="{\'hidden-cc\': vm.hiddenCC, \'hidden-bcc\': vm.hiddenBCC}"><label translate="MAIL.TO">To</label> <input \nng-model="vm.form.to" type="email"><div class="cc-bcc" layout="row" layout-align="start center"><div class="show-cc" \nng-show="vm.hiddenCC" ng-click="vm.hiddenCC = false">CC</div><div class="show-bcc" ng-show="vm.hiddenBCC" \nng-click="vm.hiddenBCC = false">BCC</div></div></md-input-container><md-input-container class="md-block" \nng-hide="vm.hiddenCC"><label translate="MAIL.CC">Cc</label> <input ng-model="vm.form.cc" type="email">\n</md-input-container><md-input-container class="md-block" ng-hide="vm.hiddenBCC"><label translate="MAIL.BCC">Bcc\n</label> <input ng-model="vm.form.bcc" type="t"></md-input-container><md-input-container class="md-block"><label \ntranslate="MAIL.SUBJECT">Subject</label> <input ng-model="vm.form.subject" type="text"></md-input-container>\n<text-angular ng-model="vm.form.message"></text-angular><div class="attachment-list"><div class="attachment" \nlayout="row" layout-align="space-between center"><div><span class="filename">attachment-2.doc</span> <span \nclass="size">(12 Kb)</span></div><md-button class="md-icon-button" aria-label="Delete attachment" translate \ntranslate-attr-aria-label="MAIL.DELETE_ATTACHMENT"><md-icon md-font-icon="icon-close" class="s16"></md-icon>\n</md-button></div><div class="attachment" layout="row" layout-align="space-between center"><div><span class="filename">\nattachment-1.jpg</span> <span class="size">(350 Kb)</span></div><md-button class="md-icon-button" \naria-label="Delete attachment" translate translate-attr-aria-label="MAIL.DELETE_ATTACHMENT"><md-icon \nmd-font-icon="icon-close" class="s16"></md-icon></md-button></div></div></md-dialog-content><md-dialog-actions \nlayout="row" layout-align="space-between center"><div layout="row" layout-align="start center"><md-button \nng-click="vm.closeDialog()" class="send-button md-accent md-raised" aria-label="Send" translate="MAIL.SEND" \ntranslate-attr-aria-label="MAIL.SEND">SEND</md-button><md-button class="md-icon-button" aria-label="Attach file" \ntranslate-attr-aria-label="MAIL.ATTACH_FILE"><md-icon md-font-icon="icon-paperclip"></md-icon><md-tooltip><span \ntranslate="MAIL.ATTACH_FILE"></span></md-tooltip></md-button></div><div layout="row"><md-button class="md-icon-button" \naria-label="Delete" translate-attr-aria-label="MAIL.DELETE"><md-icon md-font-icon="icon-delete"></md-icon><md-tooltip>\n<span translate="MAIL.DELETE"></span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/aircrafts/sidenavs/main/main-sidenav.html','<div class="header" layout="column" layout-align="space-between start"><div class="logo" layout="row" \nlayout-align="start center"><span class="logo-icon"><md-icon md-font-icon="icon-email" class="icon"></md-icon></span>\n<span class="logo-text" translate="MAIL.MAILBOX">Mailbox</span></div><div class="account"><div class="title">John Doe\n</div><md-select class="account-selection simplified" placeholder="Mail Selection" ng-model="vm.selectedAccount">\n<md-option ng-repeat="(provider, address) in vm.accounts" value="{{provider}}">{{address}}</md-option></md-select>\n</div></div><md-content ms-scroll class="content" flex><div class="compose-button"><md-button \nclass="md-accent md-raised" aria-label="compose" ng-click="vm.composeDialog($event)" translate="MAIL.COMPOSE">COMPOSE\n</md-button></div><div class="navigation-simple" layout="column"><md-button class="item" aria-label="inbox" \nng-repeat="folder in vm.folders" ng-click="vm.loadFolder(folder.name)" \nng-class="{\'selected\':vm.isFolderActive(folder.name)}"><div layout="row" layout-align="start center"><md-icon \nmd-font-icon="{{folder.icon}}" class="s16"></md-icon><span class="title">{{folder.title}}</span></div></md-button><div \nclass="item subheader" translate="MAIL.LABELS">Labels</div><md-button class="item" ng-repeat="label in vm.labels" \nng-click="vm.loadLabel(label.name)" ng-class="{\'selected\':vm.isLabelActive(label.name)}"><div layout="row" \nlayout-align="start center"><div class="h-10 w-10 mr-16" ng-class="label.color"></div><span class="title">\n{{label.title}}</span></div></md-button></div></md-content>');
$templateCache.put('app/main/apps/aircrafts/views/classic/classic-view.html','<div class="toolbar" layout="row" layout-align="space-between center"><div layout="row" layout-align="start center">\n<md-checkbox class="no-label" aria-label="{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}" \nng-checked="vm.selectedThreads.length > 0" ng-click="vm.toggleSelectThreads()" ng-if="!vm.currentThread"></md-checkbox>\n<md-menu class="select-menu" ng-if="!vm.currentThread"><md-button class="md-icon-button" \nng-click="$mdMenu.open($event)" aria-label="Filters" translate translate-attr-aria-label="MAIL.FILTERS"><md-icon \nmd-font-icon="icon-menu-down"></md-icon></md-button><md-menu-content width="3"><md-menu-item><md-button \nng-click="vm.selectThreads()" aria-label="All" translate="MAIL.ALL" translate-attr-aria-label="MAIL.ALL">All\n</md-button></md-menu-item><md-menu-item><md-button ng-click="vm.deselectThreads()" aria-label="None" \ntranslate="MAIL.NONE" translate-attr-aria-label="MAIL.NONE">None</md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.selectThreads(\'read\', true)" aria-label="Read" translate="MAIL.READ" \ntranslate-attr-aria-label="MAIL.READ">Read</md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.selectThreads(\'read\', false)" aria-label="Unread" translate="MAIL.UNREAD" \ntranslate-attr-aria-label="MAIL.UNREAD">Unread</md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.selectThreads(\'important\', true)" aria-label="Important" translate="MAIL.IMPORTANT" \ntranslate-attr-aria-label="MAIL.IMPORTANT">Important</md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.selectThreads(\'important\', false)" aria-label="Not Important" translate="MAIL.NOT_IMPORTANT" \ntranslate-attr-aria-label="MAIL.NOT_IMPORTANT">Not Important</md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.selectThreads(\'starred\', true)" aria-label="Starred" translate="MAIL.STARRED" \ntranslate-attr-aria-label="MAIL.STARRED">Starred</md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.selectThreads(\'starred\', false)" aria-label="Unstarred" translate="MAIL.UNSTARRED" \ntranslate-attr-aria-label="MAIL.UNSTARRED">Unstarred</md-button></md-menu-item></md-menu-content></md-menu><md-button \nclass="md-icon-button close-thread" aria-label="Back" ng-click="vm.closeThread()" ng-if="vm.currentThread" translate \ntranslate-attr-aria-label="MAIL.BACK"><md-icon md-font-icon="icon-keyboard-backspace"></md-icon></md-button><div \nclass="action-buttons" layout="row" layout-align="start center" \nng-show="vm.selectedThreads.length > 0 || vm.currentThread" hide show-gt-xs><div class="divider-vertical"></div>\n<md-button class="md-icon-button" aria-label="Archive" translate translate-attr-aria-label="MAIL.ARCHIVE"><md-icon \nmd-font-icon="icon-archive"></md-icon><md-tooltip><span translate="MAIL.ARCHIVE">Archive</span></md-tooltip>\n</md-button><md-button class="md-icon-button" aria-label="Spam" translate translate-attr-aria-label="MAIL.SPAM">\n<md-icon md-font-icon="icon-alert-octagon"></md-icon><md-tooltip><span translate="MAIL.SPAM">Spam</span></md-tooltip>\n</md-button><md-button class="md-icon-button" aria-label="Delete" translate translate-attr-aria-label="MAIL.DELETE">\n<md-icon md-font-icon="icon-delete"></md-icon><md-tooltip><span translate="MAIL.DELETE">Delete</span></md-tooltip>\n</md-button><div class="divider-vertical"></div><md-button class="md-icon-button" aria-label="Move to" translate \ntranslate-attr-aria-label="MAIL.MOVE_TO"><md-icon md-font-icon="icon-folder"></md-icon><md-tooltip><span \ntranslate="MAIL.MOVE_TO">Move to</span></md-tooltip></md-button><md-menu><md-button class="md-icon-button" \naria-label="Labels" translate translate-attr-aria-label="MAIL.LABELS" ng-click="$mdMenu.open($event)"><md-icon \nmd-font-icon="icon-label"></md-icon><md-tooltip><span translate="MAIL.LABELS">Labels</span></md-tooltip></md-button>\n<md-menu-content class="thread-labels-toggle-list" width="3"><md-list><md-subheader class="md-no-sticky"><span \ntranslate="MAIL.LABELS">Labels</span></md-subheader><md-list-item ng-repeat="label in vm.labels" \nng-click="vm.toggleLabel(label)"><div layout="row" layout-align="start center"><div class="w-10 h-10 mr-16" \nng-class="label.color"></div><div>{{label.title}}</div></div><md-icon md-font-icon="icon-checkbox-blank-outline" \nclass="md-secondary" ng-if="vm.currentThread && !vm.isLabelExist(label)"></md-icon><md-icon \nmd-font-icon="icon-checkbox-marked" class="md-accent md-secondary" ng-if="vm.currentThread && vm.isLabelExist(label)">\n</md-icon></md-list-item></md-list></md-menu-content></md-menu><div class="divider-vertical"></div><md-menu><md-button \nclass="md-icon-button" ng-click="$mdMenu.open($event)" aria-label="MAIL.MORE" translate \ntranslate-attr-aria-label="MAIL.MORE"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content\n width="3"><md-menu-item><md-button ng-click="vm.setThreadStatus(\'read\', true)"><span translate="MAIL.MARK_AS_READ">\nMark as read</span></md-button></md-menu-item><md-menu-item><md-button ng-click="vm.setThreadStatus(\'read\', false)">\n<span translate="MAIL.MARK_AS_UNREAD">Mark as unread</span></md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.setThreadStatus(\'important\', true)"><span translate="MAIL.MARK_AS_IMPORTANT">Mark as important</span>\n</md-button></md-menu-item><md-menu-item><md-button ng-click="vm.setThreadStatus(\'important\', false)"><span \ntranslate="MAIL.MARK_AS_NOT_IMPORTANT">Mark as not important</span></md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.setThreadStatus(\'starred\', true)"><span translate="MAIL.ADD_STAR">Add star</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click="vm.setThreadStatus(\'starred\', false)"><span \ntranslate="MAIL.REMOVE_STAR">Remove star</span></md-button></md-menu-item></md-menu-content></md-menu></div><md-menu \nclass="actions-menu" ng-show="vm.selectedThreads.length > 0 || vm.currentThread" hide-gt-xs><md-button \nclass="md-icon-button" ng-click="$mdMenu.open($event)" aria-label="Mail Actions" translate \ntranslate-attr-aria-label="MAIL.ACTIONS"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button>\n<md-menu-content width="3"><md-menu-item><md-button aria-label="Archive" translate-attr-aria-label="MAIL.ARCHIVE">\n<md-icon md-font-icon="icon-archive"></md-icon><span translate="MAIL.ARCHIVE">Archive</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label="Spam" translate-attr-aria-label="MAIL.SPAM"><md-icon \nmd-font-icon="icon-alert-octagon"></md-icon><span translate="MAIL.SPAM">Spam</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label="Delete" translate-aria-label="MAIL.DELETE"><md-icon md-font-icon="icon-delete">\n</md-icon><span translate="MAIL.DELETE">Delete</span></md-button></md-menu-item><md-menu-item><md-button \naria-label="Move To" translate-attr-aria-label="MAIL.MOVE_TO"><md-icon md-font-icon="icon-folder-move"></md-icon><span \ntranslate="MAIL.MOVE_TO">Move To</span></md-button></md-menu-item><md-menu-item><md-button aria-label="Labels" \ntranslate-attr-aria-label="MAIL.LABELS"><md-icon md-font-icon="icon-label"></md-icon><span translate="MAIL.LABELS">\nLabels</span></md-button></md-menu-item></md-menu-content></md-menu></div><div layout="row" \nlayout-align="start center"><span class="page-info" hide-sm>1 - 100 of 980</span><md-button \nclass="md-icon-button arrow" aria-label="Previous" translate translate-attr-aria-label="MAIL.PREVIOUS"><md-icon \nmd-font-icon="icon-chevron-left"></md-icon><md-tooltip><span translate="MAIL.PREVIOUS">Previous</span></md-tooltip>\n</md-button><md-button class="md-icon-button arrow" aria-label="Next" translate translate-attr-aria-label="MAIL.NEXT">\n<md-icon md-font-icon="icon-chevron-right"></md-icon><md-tooltip><span translate="MAIL.NEXT">Next</span></md-tooltip>\n</md-button><md-menu class="settings-menu"><md-button class="md-icon-button" ng-click="$mdMenu.open($event)" \naria-label="Settings" translate translate-attr-aria-label="MAIL.SETTINGS"><md-icon md-font-icon="icon-cog"></md-icon>\n</md-button><md-menu-content width="3"><md-menu-item><md-button ng-click="vm.changeView(\'classic\')"><md-icon \nmd-font-icon="icon-checkbox-blank-outline" ng-if="vm.currentView !== \'classic\'"></md-icon><md-icon \nmd-font-icon="icon-checkbox-marked" class="md-accent" ng-if="vm.currentView === \'classic\'"></md-icon><span \ntranslate="MAIL.CLASSIC_VIEW">Classic View</span></md-button></md-menu-item><md-menu-item hide-xs><md-button \nng-click="vm.changeView(\'outlook\')"><md-icon md-font-icon="icon-checkbox-blank-outline" \nng-if="vm.currentView !== \'outlook\'"></md-icon><md-icon md-font-icon="icon-checkbox-marked" class="md-accent" \nng-if="vm.currentView === \'outlook\'"></md-icon><span translate="MAIL.OUTLOOK_VIEW">Outlook View</span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div><div class="content-wrapper" layout="column" flex><div \nclass="content thread-detail" ng-if="vm.currentThread" \nng-include="\'app/main/apps/mail/views/classic/detail/detail.html\'" ms-scroll flex></div><div \nclass="content thread-list" ng-if="!vm.currentThread" ng-include="\'app/main/apps/mail/views/classic/list/list.html\'" \nms-scroll flex></div></div>');
$templateCache.put('app/main/apps/aircrafts/views/outlook/outlook-view.html','<div class="toolbar" layout="row" layout-align="space-between center"><div layout="row" layout-align="start center">\n<md-checkbox class="no-label" aria-label="{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}" \nng-checked="vm.selectedThreads.length > 0" ng-click="vm.toggleSelectThreads()"></md-checkbox><md-menu \nclass="select-menu" ng-if="!vm.currentThread"><md-button class="md-icon-button" ng-click="$mdMenu.open($event)" \naria-label="Filters" translate translate-attr-aria-label="MAIL.FILTERS"><md-icon md-font-icon="icon-menu-down">\n</md-icon></md-button><md-menu-content width="3"><md-menu-item><md-button ng-click="vm.selectThreads()" \naria-label="All" translate="MAIL.ALL" translate-attr-aria-label="MAIL.ALL">All</md-button></md-menu-item><md-menu-item>\n<md-button ng-click="vm.deselectThreads()" aria-label="None" translate="MAIL.NONE" \ntranslate-attr-aria-label="MAIL.NONE">None</md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.selectThreads(\'read\', true)" aria-label="Read" translate="MAIL.READ" \ntranslate-attr-aria-label="MAIL.READ">Read</md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.selectThreads(\'read\', false)" aria-label="Unread" translate="MAIL.UNREAD" \ntranslate-attr-aria-label="MAIL.UNREAD">Unread</md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.selectThreads(\'important\', true)" aria-label="Important" translate="MAIL.IMPORTANT" \ntranslate-attr-aria-label="MAIL.IMPORTANT">Important</md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.selectThreads(\'important\', false)" aria-label="Not Important" translate="MAIL.NOT_IMPORTANT" \ntranslate-attr-aria-label="MAIL.NOT_IMPORTANT">Not Important</md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.selectThreads(\'starred\', true)" aria-label="Starred" translate="MAIL.STARRED" \ntranslate-attr-aria-label="MAIL.STARRED">Starred</md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.selectThreads(\'starred\', false)" aria-label="Unstarred" translate="MAIL.UNSTARRED" \ntranslate-attr-aria-label="MAIL.UNSTARRED">Unstarred</md-button></md-menu-item></md-menu-content></md-menu><div \nclass="action-buttons" layout="row" layout-align="start center" \nng-show="vm.selectedThreads.length > 0 || vm.currentThread" hide show-gt-xs><div class="divider-vertical"></div>\n<md-button class="md-icon-button" aria-label="Archive" translate translate-attr-aria-label="MAIL.ARCHIVE"><md-icon \nmd-font-icon="icon-archive"></md-icon><md-tooltip><span translate="MAIL.ARCHIVE">Archive</span></md-tooltip>\n</md-button><md-button class="md-icon-button" aria-label="Spam" translate translate-attr-aria-label="MAIL.SPAM">\n<md-icon md-font-icon="icon-alert-octagon"></md-icon><md-tooltip><span translate="MAIL.SPAM">Spam</span></md-tooltip>\n</md-button><md-button class="md-icon-button" aria-label="Delete" translate translate-attr-aria-label="MAIL.DELETE">\n<md-icon md-font-icon="icon-delete"></md-icon><md-tooltip><span translate="MAIL.DELETE">Delete</span></md-tooltip>\n</md-button><div class="divider-vertical"></div><md-button class="md-icon-button" aria-label="Move to" translate \ntranslate-attr-aria-label="MAIL.MOVE_TO"><md-icon md-font-icon="icon-folder"></md-icon><md-tooltip><span \ntranslate="MAIL.MOVE_TO">Move to</span></md-tooltip></md-button><md-menu><md-button class="md-icon-button" \naria-label="Labels" translate translate-attr-aria-label="MAIL.LABELS" ng-click="$mdMenu.open($event)"><md-icon \nmd-font-icon="icon-label"></md-icon><md-tooltip><span translate="MAIL.LABELS">Labels</span></md-tooltip></md-button>\n<md-menu-content class="thread-labels-toggle-list" width="3"><md-list><md-subheader class="md-no-sticky"><span \ntranslate="MAIL.LABELS">Labels</span></md-subheader><md-list-item ng-repeat="label in vm.labels" \nng-click="vm.toggleLabel(label)"><div layout="row" layout-align="start center"><div class="w-10 h-10 mr-16" \nng-class="label.color"></div><div>{{label.title}}</div></div><md-icon md-font-icon="icon-checkbox-blank-outline" \nclass="md-secondary" ng-if="vm.currentThread && !vm.isLabelExist(label)"></md-icon><md-icon \nmd-font-icon="icon-checkbox-marked" class="md-accent md-secondary" ng-if="vm.currentThread && vm.isLabelExist(label)">\n</md-icon></md-list-item></md-list></md-menu-content></md-menu><div class="divider-vertical"></div><md-menu><md-button \nclass="md-icon-button" ng-click="$mdMenu.open($event)" aria-label="MAIL.MORE" translate \ntranslate-attr-aria-label="MAIL.MORE"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content\n width="3"><md-menu-item><md-button ng-click="vm.setThreadStatus(\'read\', true)"><span translate="MAIL.MARK_AS_READ">\nMark as read</span></md-button></md-menu-item><md-menu-item><md-button ng-click="vm.setThreadStatus(\'read\', false)">\n<span translate="MAIL.MARK_AS_UNREAD">Mark as unread</span></md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.setThreadStatus(\'important\', true)"><span translate="MAIL.MARK_AS_IMPORTANT">Mark as important</span>\n</md-button></md-menu-item><md-menu-item><md-button ng-click="vm.setThreadStatus(\'important\', false)"><span \ntranslate="MAIL.MARK_AS_NOT_IMPORTANT">Mark as not important</span></md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.setThreadStatus(\'starred\', true)"><span translate="MAIL.ADD_STAR">Add star</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click="vm.setThreadStatus(\'starred\', false)"><span \ntranslate="MAIL.REMOVE_STAR">Remove star</span></md-button></md-menu-item></md-menu-content></md-menu></div><md-menu \nclass="actions-menu" ng-show="vm.selectedThreads.length > 0 || vm.currentThread" hide-gt-xs><md-button \nclass="md-icon-button" ng-click="$mdMenu.open($event)" aria-label="Mail Actions" translate \ntranslate-attr-aria-label="MAIL.ACTIONS"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button>\n<md-menu-content width="3"><md-menu-item><md-button aria-label="Archive" translate-attr-aria-label="MAIL.ARCHIVE">\n<md-icon md-font-icon="icon-archive"></md-icon><span translate="MAIL.ARCHIVE">Archive</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label="Spam" translate-attr-aria-label="MAIL.SPAM"><md-icon \nmd-font-icon="icon-alert-octagon"></md-icon><span translate="MAIL.SPAM">Spam</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label="Delete" translate-aria-label="MAIL.DELETE"><md-icon md-font-icon="icon-delete">\n</md-icon><span translate="MAIL.DELETE">Delete</span></md-button></md-menu-item><md-menu-item><md-button \naria-label="Move To" translate-attr-aria-label="MAIL.MOVE_TO"><md-icon md-font-icon="icon-folder-move"></md-icon><span \ntranslate="MAIL.MOVE_TO">Move To</span></md-button></md-menu-item><md-menu-item><md-button aria-label="Labels" \ntranslate-attr-aria-label="MAIL.LABELS"><md-icon md-font-icon="icon-label"></md-icon><span translate="MAIL.LABELS">\nLabels</span></md-button></md-menu-item></md-menu-content></md-menu></div><div layout="row" \nlayout-align="start center"><span class="page-info" hide-sm>1 - 100 of 980</span><md-button \nclass="md-icon-button arrow" aria-label="Previous" translate translate-attr-aria-label="MAIL.PREVIOUS"><md-icon \nmd-font-icon="icon-chevron-left"></md-icon><md-tooltip><span translate="MAIL.PREVIOUS">Previous</span></md-tooltip>\n</md-button><md-button class="md-icon-button arrow" aria-label="Next" translate translate-attr-aria-label="MAIL.NEXT">\n<md-icon md-font-icon="icon-chevron-right"></md-icon><md-tooltip><span translate="MAIL.NEXT">Next</span></md-tooltip>\n</md-button><md-menu class="settings-menu"><md-button class="md-icon-button" ng-click="$mdMenu.open($event)" \naria-label="Settings" translate translate-attr-aria-label="MAIL.SETTINGS"><md-icon md-font-icon="icon-cog"></md-icon>\n</md-button><md-menu-content width="3"><md-menu-item><md-button ng-click="vm.changeView(\'classic\')"><md-icon \nmd-font-icon="icon-checkbox-blank-outline" ng-if="vm.currentView !== \'classic\'"></md-icon><md-icon \nmd-font-icon="icon-checkbox-marked" class="md-accent" ng-if="vm.currentView === \'classic\'"></md-icon><span \ntranslate="MAIL.CLASSIC_VIEW">Classic View</span></md-button></md-menu-item><md-menu-item hide-xs><md-button \nng-click="vm.changeView(\'outlook\')"><md-icon md-font-icon="icon-checkbox-blank-outline" \nng-if="vm.currentView !== \'outlook\'"></md-icon><md-icon md-font-icon="icon-checkbox-marked" class="md-accent" \nng-if="vm.currentView === \'outlook\'"></md-icon><span translate="MAIL.OUTLOOK_VIEW">Outlook View</span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div><div class="content-wrapper" layout="row" flex><div \nclass="content thread-list" ng-include="\'app/main/apps/aircrafts/views/outlook/list/list.html\'" ms-scroll flex="30">\n</div><div class="content thread-detail" ng-include="\'app/main/apps/aircrafts/views/outlook/detail/edit.html\'" \nms-scroll layout="column" flex="70"></div></div>');
$templateCache.put('app/main/apps/clients/views/list/list-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="isLoading" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="no-threads" ng-if="!vm.companies" ng-hide="isLoading" translate="GLOBAL.NO_ITEMS"></div><div \nid="list-content-data" ng-style="{\'opacity\' : isLoading ? 0.5 : 1}"><div class="mail-list-item" \nng-repeat="company in vm.companies | filter: vm.search | filter: global.search" ng-init="parentIndex = $index" \nmd-no-ink ng-click="vm.openCompany(company, $event)" \nng-class="{\'starred\': company.starred, \'selected\': vm.selectedContentID !== client.id_mailing_content, \'checked\': vm.isChecked(company)}">\n<div layout="row" layout-align="start center"><md-checkbox class="no-label" ng-checked="vm.isSelected(company)" \nng-click="vm.toggleSelectThread(company, $event)" aria-label="{{vm.isSelected(company) ? \'Deselect\' : \'Select\'}}">\n</md-checkbox><div ng-if="company.logo[0] && storagePrefix" class="avatar-wrapper"><img md-menu-align-target \nclass="avatar" ng-src="{{storagePrefix}}{{company.logo[0].url}}"></div><div ng-if="!company.logo[0]" class="avatar" \nng-bind="company.name | capitalizeFirstLetter" ms-random-class="vm.colors"></div><div class="info layout-column flex" \nflex="" layout="column"><div class="name text-truncate" style="padding-bottom: 0px; padding-top: 0px;" layout="row" \nlayout-align="start center"><span>{{company.name}}</span> <span ng-if="company.is_owner == 1">\n({{ \'GLOBAL.OWNER\' | translate}})</span></div><div class="grey-500-fg text-truncate" layout="row" \nlayout-align="start center"><span>{{company.tax_id_number}}</span></div><div class="grey-500-fg text-truncate" \nlayout="row" layout-align="start center"><span>{{vm.getRegion(company.region_id)}}</span></div></div></div></div><div \nng-if="!isLoading && pagination_total_pages > pagination_page && vm.companies.length > 0" class="load-more white p-30" \nlayout="row" layout-sm="column" layout-align="center center" layout-wrap=""><md-button \nng-click="pagination_nextPage(true)" class="md-raised">{{\'GLOBAL.LOAD_MORE\' |\xA0translate}}</md-button></div><div \nng-if="pagination_total_pages == pagination_page && pagination_page > 1" class="load-more white p-30" layout="row" \nlayout-sm="column" layout-align="center center" layout-wrap=""><div class="message" translate="GLOBAL.NO_MORE_ITEMS">\n</div></div></div>');
$templateCache.put('app/main/apps/clients/views/list/nosplit-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.preview && !vm.readView" \nng-include="\'app/main/apps/clients/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row">\n<div class="content thread-detail mail-read-pane p0" flex="" id="thread-detail" ms-scroll="vm.msScrollOptions" \nng-if="vm.preview" ng-include="\'app/main/apps/clients/views/read/read-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="!vm.preview && !vm.readView" ng-include="\'app/main/apps/clients/views/list/list-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="vm.readView && vm.showForm" ng-include="\'app/main/apps/clients/views/read/form.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="vm.readView && !vm.showForm" ng-include="\'app/main/apps/clients/views/read/question-form.html\'"></div></div>');
$templateCache.put('app/main/apps/clients/views/list/split-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.readView && !vm.preview" \nng-include="\'app/main/apps/clients/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row">\n<div class="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="!vm.readView && !vm.preview" ng-include="\'app/main/apps/clients/views/list/list-view.html\'"></div><div \nclass="content thread-detail mail-read-pane p0" flex="" id="thread-detail" ng-if="vm.preview" \nng-include="\'app/main/apps/clients/views/read/preview-company.html\'"></div><div \nclass="content thread-detail mail-read-pane p0" flex="" id="thread-list" ng-if="vm.preview" \nng-include="\'app/main/apps/clients/views/read/preview-structure.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="vm.readView && !vm.preview && vm.showForm" ng-include="\'app/main/apps/clients/views/read/form.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="vm.readView && !vm.preview && !vm.showForm" ng-include="\'app/main/apps/clients/views/read/question-form.html\'">\n</div></div>');
$templateCache.put('app/main/apps/clients/views/list/toolbar.html','<div layout="row" layout-align="start center"><md-checkbox class="no-label" \naria-label="{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}" \nng-checked="vm.selectedThreads.length > 0" ng-click="vm.toggleSelectThreads(vm.selectedThreads, vm.contents)">\n</md-checkbox><div ng-if="!vm.fromComplaint || vm.userLogued.user_type <= 2" class="divider-vertical" hide="" \nshow-gt-xs=""></div><md-button ng-if="!vm.fromComplaint || vm.userLogued.user_type <= 2" aria-label="NEW" \nclass="md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme" hide show-gt-sm \nng-click="vm.newForm($event)" translate="CLIENTS-COMPLAINTS.NEW" type="button"></md-button><md-button \nng-if="!vm.fromComplaint || vm.userLogued.user_type <= 2" aria-label="NEW" \nclass="md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme z-index-0" hide-gt-sm \nng-click="vm.newForm($event)" type="button"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="divider-vertical" hide="" show-gt-xs=""></div><div aria-hidden="false" \nclass="action-buttons hide show-gt-xs layout-align-start-center layout-row" layout="row" layout-align="start center" \nng-show="vm.selectedThreads.length > 0"><md-button ng-click="vm.deleteCompany($ev)" aria-label="Delete" \nclass="md-icon-button" hide="" show-gt-xs="" translate=""><md-icon md-font-icon="icon-delete"></md-icon><md-tooltip \nhide show-gt-xs><span translate="GLOBAL.REMOVE"></span></md-tooltip></md-button><div class="divider-vertical" hide="" \nshow-gt-xs=""></div></div><ms-search-bar debounce="300" model-search="$root.pagination_searchquery" \non-result-click="vm.searchResultClick(item)" on-search="vm.search(query)" layout="row" layout-align="start center">\n</ms-search-bar><md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" \ntranslate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nng-if="$root.pagination_searchquery==true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip \nhide show-gt-xs><span>Reset search</span></md-tooltip></md-button><div class="divider-vertical" hide="" show-gt-xs="">\n</div><md-menu hide="" show-gt-xs="" ng-if="refGroupables.length>0"><button aria-label="Filters" \nclass="md-icon-button" ng-click="$mdMenu.open($event)" show-gt-xs="" translate="" \ntranslate-attr-aria-label="GLOBAL.FILTERS"><md-icon md-font-icon="icon-chevron-down"><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.GROUP_BY">Group</span></md-tooltip></md-icon></button><md-menu-content width="4"><md-menu-item \nng-repeat="sortfield in refGroupables"><md-button aria-label="All" ng-click="pagination_setOrderBy(sortfield)"><div \nlayout="row" layout-align="space-between center"><span>Group by {{sortfield.name}} </span><i class="icon-check s16" \nng-if="sortfield.titleId == sortable.titleId"></i></div></md-button></md-menu-item><md-menu-divider ng-if="groupable">\n</md-menu-divider><md-menu-item ng-if="groupable"><md-button aria-label="Remove group" \nng-click="pagination_resetOrderBy()"><md-icon md-font-icon="icon-close "></md-icon><span>Remove order</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div><div layout="row" layout-align="start center" \ntranslate-attr-aria-label="GLOBAL.REFRESH"><span ng-if="!isLoading" class="page-info font-weight-500">\n{{vm.companies.length}} {{ \'GLOBAL.OF\' | translate}} {{pagination_totalItems}} {{ \'GLOBAL.ITEMS\' | translate}}.</span>\n<md-menu class="settings-menu" hide-gt-xs ng-show="vm.selectedThreads.length > 0"><md-button aria-label="Settings" \nclass="md-icon-button" ng-click="$mdMenu.open($event)" translate="GLOBAL.SETTINGS" \ntranslate-attr-aria-label="GLOBAL.SETTINGS"><md-icon md-font-icon="icon-dots-horizontal"></md-icon></md-button>\n<md-menu-content><md-menu-item ng-click="vm.deleteCompany($ev)" show="vm.selectedMail.length > 0 || vm.allChecked">\n<md-button ng-click="vm.massActions(\'delete\')" aria-label="Delete" translate-aria-label="GLOBAL.DELETE"><md-icon \nmd-font-icon="icon-delete"></md-icon><span translate="GLOBAL.DELETE">Delete</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div>');
$templateCache.put('app/main/apps/clients/views/read/form.html','<div id="forms" class="page-layout simple fullwidth doc-page forms" layout="column"><div class="p0" layout="column">\n<div layout="row"><ms-form-wizard class="no-margin" flex><div layout="row" layout-align="start center" flex="100" \nclass="layout-align-start-center layout-row flex-100 toolbar grey-100-bg colored-bg" ng-if="vm.idCompany"><a \nclass="pointer" ng-click="vm.closeForm()"><md-icon md-font-icon="icon-chevron-left"></md-icon></a><div \nclass="avatar-wrapper"><md-icon md-font-icon="icon-city"></md-icon></div><div class="field mr-10 ml-10 flex" flex="">\n<strong class="grey-800-fg ng-binding" ng-bind-html="vm.formWizard.company.name"></strong></div></div><md-tabs \nclass="height-tabs" md-dynamic-height md-selected="msWizard.selectedIndex" md-center-tabs="true"><md-tab><md-tab-label>\n<span class="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 0">1</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 0"><i class="icon-checkbox-blank-circle s16"></i> </span><span \nclass="ms-form-wizard-step-text" translate="GLOBAL.COMPANY_DATA"></span></span></md-tab-label><md-tab-body><form \nname="wizardStep1" ng-include="\'app/main/apps/clients/views/read/form-tabs/step-company.html\'" ms-form-wizard-form \nnovalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.idCompany"><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 1">2</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 1"><i class="icon-checkbox-blank-circle s16"></i> </span><span \nclass="ms-form-wizard-step-text" translate="CLIENTS.OPTIONS"></span></span></md-tab-label><md-tab-body><form \nname="wizardStep1b" ng-include="\'app/main/apps/clients/views/read/form-tabs/step-options.html\'" ms-form-wizard-form \nnovalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.idCompany"><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 2">3</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 2"><i class="icon-checkbox-blank-circle s16"></i> </span><span \nclass="ms-form-wizard-step-text" translate="GLOBAL.FILIATION_DATA"></span></span></md-tab-label><md-tab-body><div \nclass="navigation white-bg mb-50" flex layout="row" layout-align="center center"><div layout="row" flex \nlayout-align="start center"><md-button ng-if="vm.showForm" translate="GLOBAL.CLOSE" type="button" \nng-click="vm.closeForm()" class="md-raised md-warn hide-xs" aria-label="Cancel"></md-button><md-button \nng-if="vm.idCompany" translate="GLOBAL.SAVE" class="md-raised md-accent" ng-click="vm.nextStep(msWizard, true);" \nng-hide="msWizard.isLastStep()" ng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button></div><div \nclass="ml-auto" layout="row" flex layout-align="end center"><div flex layout="column" layout-align="center center" \nlayout-padding layout-margin ng-if="vm.loadingStep" class="loading-container"><md-progress-circular \nmd-mode="indeterminate" md-diameter="30"></md-progress-circular></div><md-button translate="GLOBAL.PREVIOUS" \nclass="md-raised md-accent" ng-click="vm.prevStep(msWizard)" ng-disabled="vm.previousStep(msWizard) || vm.loadingStep">\n</md-button><div class="steps"><span ng-repeat="form in msWizard.forms" \nng-class="{\'selected md-accent-bg\':msWizard.selectedIndex === $index}"></span></div><md-button translate="GLOBAL.NEXT" \nclass="md-raised md-accent" ng-click="vm.nextStep(msWizard)" ng-hide="msWizard.isLastStep()" \nng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button><md-button translate="GLOBAL.FINISH" \nclass="md-raised md-warn" ng-click="vm.sendForm(); msWizard.resetForm();" ng-show="msWizard.isLastStep()" \nng-disabled="msWizard.formsIncomplete()"></md-button></div></div><form name="wizardStep2" \nng-include="\'app/main/apps/clients/views/read/form-tabs/step-branchs.html\'" class="md-inline-form" ms-form-wizard-form \nnovalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.formWizard.main_branch.id"><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 3">4</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 3"><i class="icon-checkbox-blank-circle s16"></i> </span><span \ntranslate="GLOBAL.COMPLIANCE_COMMITTEE" class="ms-form-wizard-step-text"></span></span></md-tab-label><md-tab-body>\n<form ng-include="\'app/main/apps/clients/views/read/form-tabs/step-people.html\'" name="wizardStep3" \nms-form-wizard-form novalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.formWizard.main_branch.id">\n<md-tab-label><span class="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 4">5</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 4"><i class="icon-checkbox-blank-circle s16"></i> </span><span \ntranslate="GLOBAL.BRANCH_PERSONNEL" class="ms-form-wizard-step-text"></span></span></md-tab-label><md-tab-body><form \nng-include="\'app/main/apps/clients/views/read/form-tabs/step-people-global.html\'" name="wizardStep4" \nms-form-wizard-form novalidate></form></md-tab-body></md-tab></md-tabs><div \nclass="navigation white-bg border-top mb-50" flex layout="row" layout-align="center center"><div layout="row" flex \nlayout-align="start center"><md-button hide-xs ng-if="vm.showForm" translate="GLOBAL.CLOSE" type="button" \nng-click="vm.closeForm()" class="md-raised md-warn hide-xs" aria-label="Cancel"></md-button><md-button \nng-if="vm.idCompany" translate="GLOBAL.SAVE" class="md-raised md-accent" ng-click="vm.nextStep(msWizard, true);" \nng-hide="msWizard.isLastStep()" ng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button></div><div \nclass="ml-auto" layout="row" flex layout-align="end center"><div flex layout="column" layout-align="center center" \nlayout-padding layout-margin ng-if="vm.loadingStep" class="loading-container"><md-progress-circular \nmd-mode="indeterminate" md-diameter="30"></md-progress-circular></div><md-button translate="GLOBAL.PREVIOUS" \nclass="md-raised md-accent" ng-click="vm.prevStep(msWizard)" ng-disabled="vm.previousStep(msWizard) || vm.loadingStep">\n</md-button><div class="steps"><span ng-repeat="form in msWizard.forms" \nng-class="{\'selected md-accent-bg\':msWizard.selectedIndex === $index}"></span></div><md-button translate="GLOBAL.NEXT" \nclass="md-raised md-accent" ng-click="vm.nextStep(msWizard)" ng-hide="msWizard.isLastStep()" \nng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button><md-button translate="GLOBAL.FINISH" \nclass="md-raised md-warn" ng-click="vm.sendForm(); msWizard.resetForm();" ng-show="msWizard.isLastStep()" \nng-disabled="msWizard.formsIncomplete()"></md-button></div></div><div class="navigation" flex layout="row" \nlayout-align="center center"><md-button hide-xs ng-if="vm.showForm" translate="GLOBAL.CANCEL" type="button" \nng-click="vm.closeForm()" class="md-raised md-warn show-xs" aria-label="Cancel"></md-button></div></ms-form-wizard>\n</div></div></div>');
$templateCache.put('app/main/apps/clients/views/read/preview-company.html','<div hide show-gt-sm class="toolbar grey-100-bg colored-bg" layout="row" layout-align="space-between center" scroll="">\n<div layout="row" layout-align="start center"><a class="pointer" ng-click="vm.goClients()"><md-icon \nmd-font-icon="icon-chevron-left"></md-icon></a><h2 translate="GLOBAL.COMPANY_DATA"></h2></div></div><div \nclass="md-whiteframe-1dp without-line scrollable preview" flex="100"><form name="vm.basicForm" class="md-inline-form" \nnovalidate><md-input-container class="md-block bb logotype"><img \nngf-thumbnail="!image.$error && image && vm.logoIsLoaded" class="img"> <img \nng-if="!image && imageUrl && vm.logoIsLoaded" src="{{imageUrl}}" class="img"><div \nng-if="!image && !imageUrl && vm.logoIsLoaded" class="avatar img" \nng-bind="vm.formWizard.company.name | capitalizeFirstLetter" ms-random-class="vm.colors"></div><h5 \nclass="padding inline-block m0">{{vm.formWizard.company.name}}</h5></md-input-container><md-input-container \nclass="md-block bb"><label>{{vm.getRegionLiteral(\'tax_ic_number\')}}</label><h5 class="padding">\n{{vm.formWizard.company.tax_id_number}}</h5></md-input-container><md-input-container class="md-block mg-bttm"><label \ntranslate="GLOBAL.SECTOR"></label><h5 class="padding">{{vm.getSectorById(vm.formWizard.company.sector_id).name}}</h5>\n</md-input-container><md-input-container class="md-block border separator mb-30"><h2 class="title" \ntranslate="CLIENTS.OPTIONS"></h2></md-input-container><md-input-container ng-if="vm.formWizard.company.description" \nclass="md-block bb options-preview"><label class="options-preview" translate="GLOBAL.DESCRIPTION"></label><h5 \nclass="padding mv-10">{{vm.formWizard.company.description}}</h5></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.executives_type" class="md-block bb mb-0 options-preview-select"><label \ntranslate="GLOBAL.EXECUTIVE_TYPE"></label><md-select class="disabled" ng-disabled="true" \nng-model="vm.formWizard.company.extra_data.executives_type"><md-option ng-value="1">Accionista \xFAnico</md-option>\n<md-option ng-value="2">Varios accionistas</md-option><md-option ng-value="3">Consejo de administraci\xF3n</md-option>\n<md-option ng-value="4">Administrador \xFAnico</md-option><md-option ng-value="5">Otros</md-option></md-select>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.capital" \nclass="md-block bb mb-0 options-preview-select"><label translate="GLOBAL.SOCIAL_CAPITAL"></label><md-select \nclass="disabled" ng-disabled="true" ng-model="vm.formWizard.company.extra_data.capital"><md-option ng-value="1">Capital\n</md-option><md-option ng-value="2">Aportaciones de socios</md-option><md-option ng-value="3">\nAumentos de capital recientes</md-option></md-select></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.capital_amount" class="md-block bb m0 options-preview"><label \nclass="options-preview" translate="GLOBAL.AMOUNT_CAPITAL"></label><h5 class="padding mv-10">\n{{vm.formWizard.company.extra_data.capital_amount}}</h5></md-input-container><md-input-container \nng-if="vm.formWizard.company.turnover_volume" class="md-block bb m0 options-preview"><label class="options-preview" \ntranslate="GLOBAL.BILLING_LAST_YEAR"></label><h5 class="padding mv-10">{{vm.formWizard.company.turnover_volume}}</h5>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.tax_options" \nclass="md-block bb mb-0 options-preview-select"><label>IVA</label><md-select class="disabled" ng-disabled="true" \nng-model="vm.formWizard.company.extra_data.tax_options"><md-option ng-value="1">Presentaci\xF3n trimestral</md-option>\n<md-option ng-value="2">Presentaci\xF3n mensual</md-option></md-select></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.annual_accounts" class="md-block bb mb-0 options-preview-select"><label>\nCuentas anuales</label><md-select class="disabled" ng-disabled="true" \nng-model="vm.formWizard.company.extra_data.annual_accounts"><md-option ng-value="1">Abreviadas</md-option><md-option \nng-value="2">Normales</md-option><md-option ng-value="3">Pymes</md-option><md-option ng-value="4">Mixtas</md-option>\n</md-select></md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.extra_data" \nclass="md-block bb mb-0 options-preview-select"><label>Auditor\xEDas</label><md-select class="disabled" \nng-disabled="true" ng-model="vm.formWizard.company.extra_data.audits"><md-option ng-value="1">Internas</md-option>\n<md-option ng-value="2">Externas</md-option><md-option ng-value="3">No aplica</md-option></md-select>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.iso_certification" \nclass="md-block bb mb-0 options-preview-select"><label>Certificaciones ISO</label><md-select class="disabled" \nng-disabled="true" ng-model="vm.formWizard.company.extra_data.iso_certification"><md-option ng-value="1">ISO 9001\n</md-option><md-option ng-value="2">ISO 14000</md-option><md-option ng-value="3">ISO 14001</md-option><md-option \nng-value="4">ISO 19600</md-option><md-option ng-value="5">ISO 22000</md-option><md-option ng-value="6">ISO 26000\n</md-option><md-option ng-value="7">ISO 27001</md-option><md-option ng-value="8">ISO 37001</md-option><md-option \nng-value="9">OHSAS 18001</md-option></md-select></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.collective_agreement" class="md-block bb m0 options-preview"><label \nclass="options-preview">Convenio Colectivo Aplicable</label><h5 class="padding mv-10">\n{{vm.formWizard.company.extra_data.collective_agreement}}</h5></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.insurance" class="md-block bb m0 options-preview"><label \nclass="options-preview">Seguros contratados</label><h5 class="padding mv-10">\n{{vm.formWizard.company.extra_data.insurance}}</h5></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.cnae" class="md-block bb m0 options-preview"><label class="options-preview" \ntranslate="GLOBAL.CNAE"></label><h5 class="padding mv-10">{{vm.formWizard.company.extra_data.cnae}}</h5>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.financing.length> 0" \nclass="md-block bb mb-0 options-preview-select"><label class="ph-15" fill-width translate="GLOBAL.FINANCING"></label>\n<md-select class="disabled" ng-disabled="true" multiple="{{false}}" \nng-model="vm.formWizard.company.extra_data.financing"><md-option ng-repeat="option in vm.financing_options" \nng-value="option">{{option.name}}</md-option></md-select></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.sector_regulations.length> 0" class="md-block bb mb-0 options-preview-select">\n<label class="ph-15" fill-width>Normativa Sectorial aplicable</label><md-select class="disabled" ng-disabled="true" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.sector_regulations"><md-option \nng-repeat="option in vm.sector_regulations_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.implemented_measures.length> 0" \nclass="md-block bb mb-20 options-preview-select"><label class="ph-15" fill-width>Medidas implementadas</label>\n<md-select class="disabled" ng-disabled="true" multiple="{{false}}" \nng-model="vm.formWizard.company.extra_data.implemented_measures"><md-option \nng-repeat="option in vm.implemented_measures_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container><md-input-container class="md-block border separator"><h2 class="title" \ntranslate="GLOBAL.MAIN_BRANCH"></h2></md-input-container><md-input-container class="md-block bb"><label \ntranslate="GLOBAL.NAME"></label><h5 class="padding">{{vm.formWizard.main_branch.name}}</h5></md-input-container>\n<md-input-container class="md-block bb"><label translate="GLOBAL.ADDRESS"></label><h5 class="padding">\n{{vm.formWizard.main_branch.address1}}</h5></md-input-container><md-input-container class="md-block bb"><label>\n{{vm.getRegionLiteral(\'city\')}}</label><h5 class="padding">{{vm.formWizard.main_branch.city}}</h5></md-input-container>\n<md-input-container class="md-block border separator"><h2 class="title" translate="GLOBAL.BRANCH"></h2>\n</md-input-container><div class="mail-list-pane s0" ng-if="vm.formWizard.branches && vm.formWizard.branches.length> 0">\n<div class="items" ng-repeat="branch in vm.formWizard.branches track by $index"><div layout="row" \nlayout-align="start center" flex="100" class="p-20 layout-align-start-center layout-row flex-100"><div layout="row" \nlayout-align="start center" flex="100" class="layout-align-start-center layout-row flex-100"><div \nclass="avatar-wrapper"><md-icon md-font-icon="icon-city"></md-icon></div><div class="field mr-10 ml-10 flex" flex="">\n<strong class="grey-800-fg ng-binding" ng-bind-html="branch.name"></strong><div class="field grey-600-fg ng-binding">\n<span ng-if="branch.city" ng-bind-html="branch.city"></span> <span ng-if="branch.city && branch.state">, </span><span \nng-if="branch.state" ng-bind-html="branch.state"></span></div></div></div></div></div></div></form></div>');
$templateCache.put('app/main/apps/clients/views/read/preview-structure.html','<div hide show-gt-sm class="toolbar grey-100-bg colored-bg" layout="row" layout-align="space-between center" scroll="">\n<div layout="row" layout-align="start center"><h2>Organizaci\xF3n de la compa\xF1\xEDa</h2></div><div layout="row" \nlayout-align="end center" hide show-gt-sm><md-button translate="GLOBAL.EDIT" type="button" ng-click="vm.editCompany()" \nclass="md-raised md-accent" aria-label="Edit"></md-button></div><div layout="row" layout-align="end center" hide-gt-sm>\n<md-button type="button" ng-click="vm.editClient()" \nclass="md-accent md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" aria-label="Edit"><md-icon \nmd-font-icon="icon-plus"></md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.EDIT"></span></md-tooltip>\n</md-button></div></div><div class="without-line scrollable preview" flex="100"><div ivh-treeview="vm.tree" \nivh-treeview-options="vm.ivhOptions" class="treeview" \nivh-treeview-on-cb-change="vm.callback(ivhNode, ivhIsSelected, ivhTree)"><script type="text/ng-template">\n<div class="level-card" ng-if="node.type != \'user\'">\n                    <span ivh-treeview-toggle>\n                        <span ivh-treeview-twistie></span>\n                    </span>\n                    <md-icon md-font-icon="icon-city" ng-if="node.type == \'branch\'"></md-icon>\n                    <md-icon md-font-icon="icon-folder-account" ng-if="node.type == \'division\'"></md-icon>\n                    <md-icon md-font-icon="icon-worker" ng-if="node.type == \'job_position\'"></md-icon>\n                    <span class="ivh-treeview-node-label" ivh-treeview-toggle>{{trvw.label(node)}}</span>\n                </div>\n                <div class="level-card" ng-if="node.type == \'user\'">\n                    <div layout="row" layout-align="start center" flex="100">\n                        <div class="avatar-wrapper">\n                            <user-avatar User="node.user"/>\n                        </div>\n                        <div class="field mr-5 ml-5" flex>\n                            <strong class="grey-800-fg" ng-bind-html="node.user.first_name + \' \' + node.user.last_name"></strong>\n                        </div>\n                    </div>\n                </div>\n                <div ivh-treeview-children></div>\n</script></div></div>');
$templateCache.put('app/main/apps/clients/views/read/question-form.html','<div id="forms" class="page-layout simple fullwidth doc-page forms" layout="column"><div ng-if="!vm.isQuestions"><div \nclass="page-layout carded left-sidenav" layout="row"><div class="content-wrapper" layout="row" flex><div \nclass="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-thumb-up" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="CLIENTS.CLIENT_CREATED_SUCCESSFULLY"></span><div layout-gt-xs="row" layout="column" \nlayout-align="center center" class="mt-15"><md-button translate="GLOBAL.BACK_CLIENT_LIST" type="button" \nng-click="vm.goClients()" class="md-raised md-warn" aria-label="Cancel"></md-button><md-button \nclass="md-raised md-accent" ui-sref="app.site_overview.questions.questionnaire" \ntranslate="GLOBAL.CONTINUE_WITH_QUESTIONS"></md-button></div></div></div></div></div></div><div ng-if="vm.isQuestions" \nclass="p0" layout="column"><div class="items outline"><div layout="column" class="selectors"><md-input-container><label\n class="al-left">Criterio</label><md-select ng-model="vm.allQuestions" ng-change="vm.goQuestions(msWizard)"><md-option \nng-value="true">Todas las preguntas</md-option><md-option ng-value="false">Preguntas del sector</md-option></md-select>\n</md-input-container></div><div layout="column" class="selectors"><md-input-container><label class="al-left">Branches\n</label><md-select multiple="{{true}}" ng-model="vm.branchQuestion"><md-option ng-repeat="branch in vm.branches" \nng-value="branch.id">{{branch.name}}</md-option></md-select></md-input-container></div></div><div layout="row" \nng-repeat="question in vm.questions"><div class="question"><div layout="column" layout-gt-xs="row"><md-input-container \nflex><h2>{{question.name}}</h2></md-input-container></div><div layout="column" layout-gt-xs="row"><md-radio-group \nng-model="question.value"><md-radio-button value="yes" class="inline">Si</md-radio-button><md-radio-button value="no" \nclass="inline ml">No</md-radio-button></md-radio-group></div></div></div><div class="navigation pt" flex layout="row" \nlayout-align="center center"><md-button translate="GLOBAL.CANCEL" class="md-raised md-warn" ng-click="vm.goClients()">\n</md-button><md-button translate="GLOBAL.SEND" class="md-raised md-warn" ng-click="vm.finishQuestion()" \nng-disabled="!vm.branchQuestion.length > 0"></md-button></div></div></div>');
$templateCache.put('app/main/apps/clients/views/read/read-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="vm.loadingReadPane" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="fullheight" ng-if="!vm.loadingReadPane"><md-tabs class="fullheight"><md-tab label="Organizaci\xF3n"><content \nclass="" layout="row" ng-include="\'app/main/apps/clients/views/read/preview-company.html\'"></content></md-tab><md-tab \nlabel="Estructura"><content class="" layout="row" \nng-include="\'app/main/apps/clients/views/read/preview-structure.html\'"></content></md-tab><md-tab label="Edit" \nng-click="vm.editClient()"><content class="" ng-if="vm.showForm" layout="row" \nng-include="\'app/main/apps/clients/views/read/form.html\'"></content><content class="" ng-if="!vm.showForm" \nlayout="row" ng-include="\'app/main/apps/clients/views/read/question-form.html\'"></content></md-tab></md-tabs></div>');
$templateCache.put('app/main/apps/clients/dialogs/edit-branch/edit-branch-dialog.controller.html','<md-dialog class="edit-branch-dialog" aria-label="New Task"><form name="taskForm" class="md-inline-form" novalidate>\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between"><h1 \nclass="title">{{vm.branch.name}}</h1><md-button class="md-icon-button" ng-click="vm.closeDialog()"><md-icon \nmd-font-icon="icon-close" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div layout="column" class="p-15"><md-input-container fill-width flex class="md-block mb-0"><label \ntranslate="GLOBAL.NAME"></label> <input ng-model="vm.branch.name" type="text"></md-input-container><md-input-container \nfill-width flex class="md-block mb-0"><label translate="GLOBAL.ADDRESS"></label> <input ng-model="vm.branch.address1" \ntype="text"></md-input-container><md-input-container fill-width flex class="md-block mb-0"><label>\n{{vm.getRegionLiteral(\'city\')}}</label> <input ng-model="vm.branch.city" type="text"></md-input-container>\n<md-input-container fill-width flex class="md-block mb-0"><label>{{vm.getRegionLiteral(\'state\')}}</label> <input \nng-model="vm.branch.state" type="text"></md-input-container><md-input-container fill-width flex class="md-block mb-0">\n<label translate="GLOBAL.POSTAL_CODE"></label> <input ng-model="vm.branch.postcode" type="text"></md-input-container>\n<md-input-container fill-width flex class="md-block mb-0"><label translate="GLOBAL.EMAIL"></label> <input \nng-model="vm.branch.email" type="text"></md-input-container><md-input-container fill-width flex class="md-block mb-0">\n<label translate="GLOBAL.PHONE"></label> <input ng-model="vm.branch.phone" type="text"></md-input-container></div>\n</md-dialog-content><md-dialog-actions class="footer" layout="row" layout-="end"><md-input-container flex layout="row" \nlayout-align="end center"><md-button type="button" class="md-raised md-warn" ng-click="vm.closeDialog()" \ntranslate="RISKCONFIG.CANCEL">Cancel</md-button><md-button ng-disabled="vm.selectedBranchs.length == 0" type="submit" \nclass="send-button md-accent md-raised" ng-click="vm.saveDialog()" translate="GLOBAL.SAVE">ADD</md-button>\n</md-input-container></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/clients/dialogs/forms/dialog-view.html','<md-dialog id="dialog-view" class="form-dialog-client add-media attachment-dialog" aria-label="New Message"><md-toolbar\n class="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><a \nclass="md-button layout-align-center-center layout-row md-default-theme" layout="row" layout-align="center center">\n<span class="ml-15" translate="{{ vm.title }}"></span></a><div class="absolute-right mr-10" layout="row  "><md-button \nclass="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</md-toolbar><form ng-if="vm.title === \'GLOBAL.NEW_BRANCH\'" id="site-content" class="content-card" \nng-class="vm.currentView" ng-include="\'app/main/apps/clients/dialogs/forms/forms-view-delegation.html\'"></form><form \nng-if="vm.title !== \'GLOBAL.NEW_BRANCH\'" id="site-content" flex class="md-inline-form content-card" \nng-class="vm.currentView" ng-include="\'app/main/apps/clients/dialogs/forms/forms-view-user.html\'"></form></md-dialog>');
$templateCache.put('app/main/apps/clients/dialogs/forms/existing-user.html','<md-tabs fill-height-i style="height: 100%;" md-border-bottom><md-tab \nlabel="{{\'CLIENTS.COMPANY_PERSONEL\' | translate}}"><div style="max-height: 100%;" id="site-client"><div \nclass="search-input-wrapper border-bottom" layout="row" layout-align="start center"><md-icon class="mr-10 ml-20" \nmd-font-icon="icon-magnify"></md-icon><input id="search2" placeholder="{{\'CONTACTS.SEARCH_FOR_ANYONE\' | translate}}" \ntype="text" ng-model="searchText" class="flex h-60"></div><div style="max-height: 100%; overflow: hidden;" \nclass="content thread-list mail-list-pane p0" flex="" id="thread-list"><div id="list-content-data" \nng-style="{\'opacity\' : isLoading ? 0.5 : 1}"><div class="mail-list-item p0" \nng-repeat="user in vm.users | filter:{} | filter:searchText | filter:filterAlreadyAdded | orderBy: \'name\'" \nng-init="parentIndex= $index" md-no-ink ng-click="vm.selectUser(user)" \nng-class="{\'starred\': user.starred, \'selected\': vm.selectedContentID !== user.id_mailing_content, \'checked\': vm.isChecked(user)}">\n<div layout="row" layout-align="start center" flex="100" class="pl-15 pt-10 pb-10"><div class="info" flex \nlayout="column"><div class="name" layout="row"><div layout="row" layout-align="start center" flex="100"><div \nclass="avatar-wrapper"><img class="avatar s24" ng-src="{{vm.showUserImage(user)}}" ng-if="user.files.id"><div \nclass="avatar s24" ng-class="user.profile_color ? user.profile_color : \'md-blue-grey-300-bg\'" ng-if="!user.files.id" \nng-bind="user.first_name | capitalizeFirstLetter"></div></div><div layout="column" class="field mr-10 ml-10" flex><div>\n<strong class="grey-800-fg" ng-bind-html="user.first_name + \' \' + user.last_name"></strong></div><div><span \nstyle="font-weight: 300;">{{user.email}}</span></div></div></div></div><div></div></div></div></div></div></div>\n<md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" translate="" \ntranslate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" ng-if="$root.pagination_searchquery==true"><md-icon \nmd-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip hide show-gt-xs><span>Reset search</span></md-tooltip>\n</md-button></div></md-tab><md-tab ng-if="!vm.userLogued || vm.userLogued.user_type <3" \nlabel="{{\'CLIENTS.USER_ADMINISTRATORS\' | translate}}"><div style="max-height: 100%;" id="site-client"><div \nclass="search-input-wrapper border-bottom" layout="row" layout-align="start center"><md-icon class="mr-10 ml-20" \nmd-font-icon="icon-magnify"></md-icon><input id="search2" placeholder="{{\'CONTACTS.SEARCH_FOR_ANYONE\' | translate}}" \ntype="text" ng-model="searchTextAll" class="flex h-60"></div><div style="max-height: 100%; overflow: hidden;" \nclass="content thread-list mail-list-pane p0" flex="" id="thread-list"><div id="list-content-data" \nng-style="{\'opacity\' : isLoading ? 0.5 : 1}"><div class="mail-list-item p0" \nng-repeat="user in vm.usersAll | filter:searchTextAll | filter:filterAlreadyAdded | orderBy: \'name\'" \nng-init="parentIndex= $index" md-no-ink ng-click="vm.selectUser(user)" \nng-class="{\'starred\': user.starred, \'selected\': vm.selectedContentID !== user.id_mailing_content, \'checked\': vm.isChecked(user)}">\n<div layout="row" layout-align="start center" flex="100" class="pl-15 pt-10 pb-10"><div class="info" flex \nlayout="column"><div class="name" layout="row"><div layout="row" layout-align="start center" flex="100"><div \nclass="avatar-wrapper"><img class="avatar s24" ng-src="{{vm.showUserImage(user)}}" ng-if="user.files.id"><div \nclass="avatar s24" ng-class="user.profile_color ? user.profile_color : \'md-blue-grey-300-bg\'" ng-if="!user.files.id" \nng-bind="user.first_name | capitalizeFirstLetter"></div></div><div class="field mr-10 ml-10" flex><strong \nclass="grey-800-fg" ng-bind-html="user.first_name + \' \' + user.last_name"></strong></div></div></div></div></div></div>\n</div></div></div><md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" \ntranslate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nng-if="$root.pagination_searchquery==true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip \nhide show-gt-xs><span>Reset search</span></md-tooltip></md-button></md-tab></md-tabs>');
$templateCache.put('app/main/apps/clients/dialogs/forms/external-user.html','<div id="forms" class="page-layout simple fullwidth doc-page forms scrollable" layout="column" ms-scroll><form \nname="wizardStep1" class="md-inline-form" ms-form-wizard-form novalidate><div \nng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" style="height: auto!important;" \nclass="items mt-10"><md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'text\' && field.field == \'3rd_party_company_name\'"><input type="{{field.type}}" \nng-model="field.value" placeholder="{{ field.translate | translate }}" ng-required="field.required">\n</md-input-container><md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'text\' && field.field != \'3rd_party_company_name\'"><input type="{{field.type}}" \nng-model="field.value" placeholder="{{ field.translate | translate }}" ng-required="field.required">\n</md-input-container><md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'password\'"><input type="{{field.type}}" ng-model="field.value" \nplaceholder="{{ field.translate | translate }}" ng-required="field.required"></md-input-container><md-input-container \nclass="item" ng-repeat="field in vm.fields" ng-if="!field.hidden && field.type == \'selector\'"><md-select \nng-disabled="vm.disabledPosition(field)" ng-if="field.field === \'position\'" ng-model="field.value" \nplaceholder="{{ field.translate | translate }}" required><md-option \nng-repeat="option in field.options track by $index" ng-value="option.id">{{option.field}}</md-option></md-select>\n</md-input-container></div><div ng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" \nlayout="row" flex><md-input-container flex class="item mv-0" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'picture\'"><div class="md-block"><div><div ngf-drop ngf-select \nng-model="vm.files" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="image/*" ngf-pattern="\'image/*\'"><div layout="column"><div flex translate="GLOBAL.DROP_HERE">\nDrop here or click to upload</div><div flex translate="GLOBAL.OR"></div><div flex><md-button \nclass="send-button md-accent md-raised" aria-label="Select files" translate="GLOBAL.SELECT_FILES"></md-button></div>\n</div></div><div ngf-no-file-drop translate="GLOBAL.FILE_DRAG_DROP"></div></div><div ng-repeat="f in vm.files" \nclass="ms-card" flex><div ng-if="!f.url" class="ms-card-content-wrapper"><div class="template-9"><div class="media" \nflex layout="row" layout-align="center center"><img ngf-thumbnail="!f.$error && f" class="image"></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><strong class="mr-5" ng-if="f.id">#{{f.id}}</strong> <span class="grey-500-fg"><span \nng-if="f.name">{{f.name}}</span></span></div></div></div><md-progress-linear md-mode="determinate" \nvalue="{{f.progress}}" ng-show="f.progress <100"></md-progress-linear></div></div><div ng-if="f.url" \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><img class="image" ng-src="{{vm.storagePrefix + f.url}}"></div><div class="header p-16" \nflex layout="row" layout-align="end center"><md-menu class="float-right"><md-button class="md-icon-button" \naria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item><md-button translate="GLOBAL.REMOVE" ng-click="vm.deleteAvatar(f)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item></md-menu-content>\n</md-menu></div><md-progress-linear md-mode="determinate" value="{{f.progress}}" ng-show="f.progress <100">\n</md-progress-linear></div></div></div></div></md-input-container></div><div \nng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" fill-width class="navigation pb-20" flex \nlayout="row" layout-align="center center"><md-button ng-if="vm.showJobDivision()" translate="GLOBAL.BACK" \nclass="md-raised md-warn" ng-click="vm.unSelectJobDivision()"></md-button><md-button ng-disabled="vm.isSendDisabled()" \ntranslate="GLOBAL.SEND" class="md-raised md-accent" ng-click="vm.sendForm($event)" ng-disabled="wizardStep1.$valid">\n</md-button></div><div class="text-center" ng-if="vm.user_type != undefined && vm.user_type != 4 && vm.user_type != 5">\n<h3>{{ \'CLIENTS.EDIT_USER_SECTION_USERS\' | translate}}</h3></div></form></div>');
$templateCache.put('app/main/apps/clients/dialogs/forms/forms-view-delegation.html','<div id="forms" class="form-delegation page-layout simple fullwidth doc-page forms" layout="column"><div class="p0" \nlayout="column"><div layout="row"><ms-form-wizard class="popup" flex><form name="wizardStep1" class="md-inline-form" \nms-form-wizard-form novalidate><div class="items mt-30"><md-input-container class="item" \nng-repeat="field in vm.fields" ng-if="field.field !== \'id\' && field.field !== \'fullName\'"><input \nng-if="field.field !== \'phone\' && field.field !== \'email\' && field.field !== \'position\'" type="{{field.type}}" \nname="{{field.field}}" ng-model="field.value" placeholder="{{ field.translate | translate }}" required> <input \nng-if="field.field === \'phone\' || field.field === \'email\'" type="{{field.type}}" name="{{field.field}}" \nng-model="field.value" placeholder="{{ field.translate | translate }}"><div ng-messages="wizardStep1.email.$error" \nrole="alert" multiple="multiple"><div ng-message="pattern"><span translate="GLOBAL.EMAIL_VALID"></span></div></div>\n</md-input-container></div></form><div class="navigation pt-20" flex layout="row" layout-align="center center">\n<md-button translate="GLOBAL.SEND" class="md-raised md-warn" ng-click="vm.sendForm()" ng-disabled="wizardStep1.$valid">\n</md-button></div></ms-form-wizard></div></div></div>');
$templateCache.put('app/main/apps/clients/dialogs/forms/forms-view-user.html','<div id="forms-position" class="page-layout simple fullwidth doc-page forms scrollable" layout="column" ms-scroll \nng-if="vm.showSelectPosition()"><form name="wizardStep2" class="md-inline-form" ms-form-wizard-form novalidate><h3 \nclass="mh-15" translate="CLIENTS.BEFORE_CONTINUE_PERSONEL"></h3><div class="items ph-15" layout="row">\n<md-input-container flex class="item" ng-if="vm.indexDivision != null" ng-show="vm.showSector()"><md-select \nng-model="vm.fields[vm.indexDivision].value" placeholder="{{ vm.fields[vm.indexDivision].translate | translate }}" \nrequired><md-option ng-repeat="option in vm.fields[vm.indexDivision].options track by $index" ng-value="option.id">\n{{option.field}}</md-option></md-select></md-input-container><md-input-container flex class="item" \nng-if="vm.indexPosition != null"><md-select ng-disabled="vm.disabledPosition(vm.fields[vm.indexPosition])" \nng-model="vm.fields[vm.indexPosition].value" placeholder="{{ vm.fields[vm.indexPosition].translate | translate }}" \nrequired><md-option ng-repeat="option in vm.fields[vm.indexPosition].options track by $index" ng-value="option.id">\n{{option.field}}</md-option></md-select></md-input-container></div></form><div class="navigation pt-20" flex \nlayout="row" layout-align="center center"><md-button translate="GLOBAL.SELECT" class="md-raised md-accent" \nng-click="vm.selectJobDivision()" ng-disabled="vm.divisionJobSelected()"></md-button></div></div><md-tabs \nfill-height-i md-border-bottom ng-if="!vm.showSelectPosition()"><md-tab label="{{\'CLIENTS.NEW_USER\' | translate}}"><div\n ng-include="\'app/main/apps/clients/dialogs/forms/new-user.html\'"></div></md-tab><md-tab \nlabel="{{\'CLIENTS.EXISTING_USER\' | translate}}"><div \nng-style="{\'height\': vm.showJobDivision() ? \'calc(100% - 58px)\' : \'100%\'}" \nng-include="\'app/main/apps/clients/dialogs/forms/existing-user.html\'"></div><div ng-if="vm.showJobDivision()" \nclass="navigation pt-10" flex layout="row" layout-align="center center"><md-button translate="GLOBAL.BACK" \nclass="md-raised md-warn" ng-click="vm.unSelectJobDivision()"></md-button></div></md-tab><md-tab \nlabel="{{\'CLIENTS.COMPANY_OR_EXTERNAL_STAFF\' | translate}}"><div \nng-include="\'app/main/apps/clients/dialogs/forms/external-user.html\'"></div></md-tab></md-tabs>');
$templateCache.put('app/main/apps/clients/dialogs/forms/new-user.html','<div id="forms" class="page-layout simple fullwidth doc-page forms scrollable" layout="column" ms-scroll><form \nname="wizardStep1" class="md-inline-form" ms-form-wizard-form novalidate><div layout="row" \nng-if="!vm.showJobDivision() && !(vm.user_type != undefined && vm.user_type != 4 && vm.user_type != 5)  && !vm.type">\n<md-input-container flex class="item mh-15" ng-if="vm.indexDivision != null" ng-show="vm.showSector()"><md-select \nng-disabled="true" ng-model="vm.fields[vm.indexDivision].value" \nplaceholder="{{ vm.fields[vm.indexDivision].translate | translate }}" required><md-option \nng-repeat="option in vm.fields[vm.indexDivision].options track by $index" ng-value="option.id">{{option.field}}\n</md-option></md-select></md-input-container><md-input-container flex class="item mh-15" \nng-if="vm.indexPosition != null"><md-select ng-disabled="true" ng-model="vm.fields[vm.indexPosition].value" \nplaceholder="{{ vm.fields[vm.indexPosition].translate | translate }}" required><md-option \nng-repeat="option in vm.fields[vm.indexPosition].options track by $index" ng-value="option.id">{{option.field}}\n</md-option></md-select></md-input-container></div><div \nng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" style="height: auto!important;" \nclass="items mt-10"><md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'text\' && field.field != \'3rd_party_company_name\'"><input type="{{field.type}}" \nng-model="field.value" placeholder="{{ field.translate | translate }}" ng-required="field.required">\n</md-input-container><md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'password\'"><input type="{{field.type}}" ng-model="field.value" \nplaceholder="{{ field.translate | translate }}" ng-required="field.required"></md-input-container><md-input-container \nclass="item" ng-repeat="field in vm.fields" ng-if="!field.hidden && field.type == \'selector\'"><md-select \nng-disabled="vm.disabledPosition(field)" ng-if="field.field === \'position\'" ng-model="field.value" \nplaceholder="{{ field.translate | translate }}" required><md-option \nng-repeat="option in field.options track by $index" ng-value="option.id">{{option.field}}</md-option></md-select>\n</md-input-container></div><div ng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" \nlayout="row" flex><md-input-container flex class="item mv-0" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'picture\'"><div class="md-block"><div><div ngf-drop ngf-select \nng-model="vm.files" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="image/*" ngf-pattern="\'image/*\'"><div layout="column"><div flex translate="GLOBAL.DROP_HERE">\nDrop here or click to upload</div><div flex translate="GLOBAL.OR"></div><div flex><md-button \nclass="send-button md-accent md-raised" aria-label="Select files" translate="GLOBAL.SELECT_FILES"></md-button></div>\n</div></div><div ngf-no-file-drop translate="GLOBAL.FILE_DRAG_DROP"></div></div><div ng-repeat="f in vm.files" \nclass="ms-card" flex><div ng-if="!f.url" class="ms-card-content-wrapper"><div class="template-9"><div class="media" \nflex layout="row" layout-align="center center"><img ngf-thumbnail="!f.$error && f" class="image"></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><strong class="mr-5" ng-if="f.id">#{{f.id}}</strong> <span class="grey-500-fg"><span \nng-if="f.name">{{f.name}}</span></span></div></div></div><md-progress-linear md-mode="determinate" \nvalue="{{f.progress}}" ng-show="f.progress <100"></md-progress-linear></div></div><div ng-if="f.url" \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><img class="image" ng-src="{{vm.storagePrefix + f.url}}"></div><div class="header p-16" \nflex layout="row" layout-align="end center"><md-menu class="float-right"><md-button class="md-icon-button" \naria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.deleteAvatar(f)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-content></md-menu></div>\n<md-progress-linear md-mode="determinate" value="{{f.progress}}" ng-show="f.progress <100"></md-progress-linear></div>\n</div></div></div></md-input-container></div><div \nng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" fill-width class="navigation pb-20" flex \nlayout="row" layout-align="center center"><md-button ng-if="vm.showJobDivision()" translate="GLOBAL.BACK" \nclass="md-raised md-warn" ng-click="vm.unSelectJobDivision()"></md-button><md-button ng-disabled="vm.isSendDisabled()" \ntranslate="GLOBAL.SEND" class="md-raised md-accent" ng-click="vm.sendForm($event)" ng-disabled="wizardStep1.$valid">\n</md-button></div><div class="text-center" ng-if="vm.user_type != undefined && vm.user_type != 4 && vm.user_type != 5">\n<h3 ng-bind-html="vm.translate(\'CLIENTS.EDIT_USER_SECTION_USERS\')"></h3></div></form></div>');
$templateCache.put('app/main/apps/clients/dialogs/image/image-dialog.html','<md-dialog class="attachment-dialog" aria-label="New Task"><md-toolbar class="md-accent md-hue-2 md-default-theme"><div\n class="md-toolbar-tools"><div layout="row" hide show-gt-xs><a class="md-button" type="1" layout="row" \nlayout-align="center center" ng-click="vm.changeView(\'fotorama\')"><md-icon md-font-icon="icon-file-image-box" \nclass="s18 mr-5 ml-0"></md-icon><span translate="GLOBAL.PREVIEW">Preview Media</span></a></div><span flex></span><div \nlayout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content class="mediadialog-content" layout-fill><md-content flex class="content-card" \nng-class="vm.currentView" ng-include="vm.views[vm.currentView]" md-no-ink></md-content></md-dialog-content></md-dialog>');
$templateCache.put('app/main/apps/clients/dialogs/media/media-clients-tinymce.html','<md-dialog class="attachment-dialog add-media" aria-label="New Message"><form class="md-inline-form"><md-toolbar \nclass="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><div layout="row" \nhide show-gt-xs><a class="md-button" type="1" layout="row" layout-align="center center" \nng-click="vm.changeViewTiny(\'1\')"><md-icon md-font-icon="icon-file-image-box" class="s18 mr-5 ml-0"></md-icon><span>\nAttached Media</span></a></div><div layout="row" hide-gt-xs show-xs><md-menu><md-button aria-label="Filters" \nng-click="$mdMenu.open($event)" translate="" translate-attr-aria-label="GLOBAL.FILTERS"><span layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-file-image-box" class="s18 mr-5 ml-0"></md-icon><span \nclass="ml-5">Images</span> <i class="icon-chevron-down s20 ml-5"></i></span></md-button><md-menu-content width="3">\n<md-menu-item><md-button type="photos" ng-click="vm.changeViewTiny(\'1\')"><div layout="row" \nlayout-align="space-between center"><div><md-icon md-font-icon="icon-file-image-box" class="s18"></md-icon><span>Images\n</span></div><i class="icon-check s16" ng-if="sortfield.titleId == sortable.titleId"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu></div><div layout="row"><md-button class="md-icon-button" \nng-click="vm.closeDialog()" aria-label="Close dialog" tranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon \nmd-font-icon="icon-close"></md-icon></md-button></div></div></md-toolbar><div flex \nng-include="\'app/main/apps/clients/dialogs/media/views/templates/toolbar-search.html\'"></div><md-dialog-content \nclass="mediadialog-content scrollable" layout-fill ms-scroll><treasure-overlay-spinner active="vm.loading"><div \nlayout="column" flex><md-content flex class="content-card" ng-class="vm.currentViewTiny" \nng-include="vm.viewsTiny[vm.currentViewTiny]" md-no-ink></md-content></div></treasure-overlay-spinner>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="space-between center" ng-if="!vm.loading"><div \nlayout="row" layout-align="start center"></div><div layout="row" layout-align="end right"><md-button \nng-click="vm.attachMediaTiny()" class="send-button md-accent md-raised" aria-label="Send" translate="GLOBAL.ADD_FILE" \ntranslate-attr-aria-label="GLOBAL.ADD_FILE">ADD</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/clients/dialogs/media/media-clients.html','<md-dialog class="attachment-dialog add-media" aria-label="New Message"><form class="md-inline-form"><md-toolbar \nclass="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><div layout="row" \nhide show-gt-xs><a class="md-button" type="upload" layout="row" layout-align="center center" \nng-click="vm.changeView(\'upload\')"><md-icon md-font-icon="icon-import" class="s18 mr-5 ml-0"></md-icon><span \ntranslate="GLOBAL.UPLOAD"></span></a></div><div layout="row" hide-gt-xs show-xs><md-menu><md-button \naria-label="Filters" ng-click="$mdMenu.open($event)" translate="" translate-attr-aria-label="GLOBAL.FILTERS"><span \nlayout="row" layout-align="start center"><md-icon md-font-icon="icon-file-image-box" class="s18 mr-5 ml-0"></md-icon>\n<span class="ml-5" ng-if="vm.currentView===\'upload\'">Upload</span><i class="icon-chevron-down s20 ml-5"></i></span>\n</md-button><md-menu-content width="3"><md-menu-item><md-button type="import" ng-click="vm.changeView(\'import\')"><div \nlayout="row" layout-align="space-between center"><div><md-icon md-font-icon="icon-import" class="s18"></md-icon><span>\nUpload</span></div><i class="icon-check s16" ng-if="vm.currentView===\'upload\'"></i></div></md-button></md-menu-item>\n</md-menu-content></md-menu></div><div layout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog" tranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></div></md-toolbar><md-dialog-content ms-scroll flex class="content-card" \nng-class="vm.currentView" ng-include="vm.views[vm.currentView]"></md-dialog-content></form></md-dialog>');
$templateCache.put('app/main/apps/clients/dialogs/new-client-dialog/new-client-dialog.html','<md-dialog class="new-client-dialog" aria-label="New Task"><form name="taskForm" class="md-inline-form" novalidate>\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between"><h1 \nclass="title" translate="GLOBAL.COMPANY_DATA"></h1><md-button class="md-icon-button" ng-click="vm.closeDialog()">\n<md-icon md-font-icon="icon-close" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content class="p-25" ms-scroll><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="GLOBAL.SOCIAL_REASON"></label> <input type="text" ng-model="vm.company.name" required></md-input-container>\n</div><div layout="column" layout-gt-xs="row"><md-input-container flex><label>{{vm.getRegionLiteral(\'tax_ic_number\')}}\n</label> <input type="text" ng-model="vm.company.tax_id_number"></md-input-container><md-input-container flex><label \ntranslate="GLOBAL.SECTOR"></label><md-select ng-model="vm.company.sector_id"><md-option \nng-repeat="sector in vm.sectors track by $index" ng-value="sector.id">{{sector.name}}</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="GLOBAL.REGION"></label><md-select ng-model="vm.company.region_id"><md-option \nng-repeat="region in vm.regions track by $index" ng-value="region.id">{{region.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><label translate="GLOBAL.ADDRESS"></label> <input \nng-model="vm.main_branch.address1" type="text" required></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container flex><label>{{vm.getRegionLiteral(\'city\')}}</label> <input \nng-model="vm.main_branch.city" type="text" required></md-input-container><md-input-container flex><label>\n{{vm.getRegionLiteral(\'state\')}}</label> <input ng-model="vm.main_branch.state" type="text" required>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="GLOBAL.POSTAL_CODE"></label> <input ng-model="vm.main_branch.postcode" type="text" required>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-align="start center"><md-input-container><p \nclass="mt-0 grey-400-fg" translate="GLOBAL.LOGOTYPE"></p><div class="header simple relative" ng-if="image || imageUrl" \nlayout="row" layout-align="space-between center"><md-menu><button class="md-icon-button" aria-label="More"><div \nlayout="column" layout-align="start center" ng-click="$mdMenu.open($event)"><div class="media" flex layout="row" \nlayout-align="center center"><img ngf-thumbnail="!image.$error && image" class="image"> <img \nng-if="!image && imageUrl" src="{{imageUrl}}" class="image"></div><md-button \nclass="md-mini add-event-button no-sort md-fab md-warn block absolute-top-right" aria-label="Add event"><md-icon \nmd-font-icon="icon-dots-vertical"></md-icon></md-button></div></button><md-menu-content width="3"><md-menu-item>\n<md-button ng-click="vm.deleteLogotype()" aria-label="Toggle done" translate-attr-aria-label="GLOBAL.REMOVE"><md-icon \nmd-font-icon="icon-close" class="s18"></md-icon><span translate="GLOBAL.REMOVE"></span></md-button></md-menu-item>\n</md-menu-content></md-menu></div><div ng-if="!image && !imageUrl" \nng-click="vm.mediaDialogSingle($event, vm.company.logotype)" class="relative"><img \nsrc="assets/images/logos/generic-logo.png" class="image"><md-button \nclass="md-mini add-event-button no-sort md-fab md-warn block absolute-top-right" aria-label="Add event" translate \ntranslate-attr-aria-label="CALENDAR.ADD_EVENT"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions class="footer" layout="row" layout-="end">\n<md-input-container flex layout="row" layout-align="end center"><md-button type="button" class="md-raised md-warn" \nng-click="vm.closeDialog()" translate="RISKCONFIG.CANCEL">Cancel</md-button><md-button ng-disabled="!vm.company.name" \ntype="submit" class="send-button md-accent md-raised" ng-click="vm.saveDialog()" translate="GLOBAL.SAVE">ADD\n</md-button></md-input-container></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/clients-complaints/dialogs/forms/dialog-view.html','<md-dialog id="dialog-view" class="form-dialog-client add-media attachment-dialog" aria-label="New Message"><md-toolbar\n class="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><a \nclass="md-button layout-align-center-center layout-row md-default-theme" layout="row" layout-align="center center">\n<span class="ml-15" translate="{{ vm.title }}"></span></a><div class="absolute-right mr-10" layout="row  "><md-button \nclass="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</md-toolbar><form ng-if="vm.title === \'GLOBAL.NEW_BRANCH\'" id="site-content" class="content-card" \nng-class="vm.currentView" ng-include="\'app/main/apps/clients-complaints/dialogs/forms/forms-view-delegation.html\'">\n</form><form ng-if="vm.title !== \'GLOBAL.NEW_BRANCH\'" id="site-content" flex class="md-inline-form content-card" \nng-class="vm.currentView" ng-include="\'app/main/apps/clients-complaints/dialogs/forms/forms-view-user.html\'"></form>\n</md-dialog>');
$templateCache.put('app/main/apps/clients-complaints/dialogs/forms/existing-user.html','<md-tabs fill-height-i style="height: 100%;" md-border-bottom><md-tab \nlabel="{{\'CLIENTS.COMPANY_PERSONEL\' | translate}}"><div style="max-height: 100%;" id="site-client"><div \nclass="search-input-wrapper border-bottom" layout="row" layout-align="start center"><md-icon class="mr-10 ml-20" \nmd-font-icon="icon-magnify"></md-icon><input id="search2" placeholder="{{\'CONTACTS.SEARCH_FOR_ANYONE\' | translate}}" \ntype="text" ng-model="searchText" class="flex h-60"></div><div style="max-height: 100%; overflow: hidden;" \nclass="content thread-list mail-list-pane p0" flex="" id="thread-list"><div id="list-content-data" \nng-style="{\'opacity\' : isLoading ? 0.5 : 1}"><div class="mail-list-item p0" \nng-repeat="user in vm.users | filter:{} | filter:searchText | filter:filterAlreadyAdded | orderBy: \'name\'" \nng-init="parentIndex= $index" md-no-ink ng-click="vm.selectUser(user)" \nng-class="{\'starred\': user.starred, \'selected\': vm.selectedContentID !== user.id_mailing_content, \'checked\': vm.isChecked(user)}">\n<div layout="row" layout-align="start center" flex="100" class="pl-15 pt-10 pb-10"><div class="info" flex \nlayout="column"><div class="name" layout="row"><div layout="row" layout-align="start center" flex="100"><div \nclass="avatar-wrapper"><img class="avatar s24" ng-src="{{vm.showUserImage(user)}}" ng-if="user.files.id"><div \nclass="avatar s24" ng-class="user.profile_color ? user.profile_color : \'md-blue-grey-300-bg\'" ng-if="!user.files.id" \nng-bind="user.first_name | capitalizeFirstLetter"></div></div><div layout="column" class="field mr-10 ml-10" flex><div>\n<strong class="grey-800-fg" ng-bind-html="user.first_name + \' \' + user.last_name"></strong></div><div><span \nstyle="font-weight: 300;">{{user.email}}</span></div></div></div></div><div></div></div></div></div></div></div>\n<md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" translate="" \ntranslate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" ng-if="$root.pagination_searchquery==true"><md-icon \nmd-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip hide show-gt-xs><span>Reset search</span></md-tooltip>\n</md-button></div></md-tab><md-tab ng-if="!vm.userLogued || vm.userLogued.user_type <3" \nlabel="{{\'CLIENTS.USER_ADMINISTRATORS\' | translate}}"><div style="max-height: 100%;" id="site-client"><div \nclass="search-input-wrapper border-bottom" layout="row" layout-align="start center"><md-icon class="mr-10 ml-20" \nmd-font-icon="icon-magnify"></md-icon><input id="search2" placeholder="{{\'CONTACTS.SEARCH_FOR_ANYONE\' | translate}}" \ntype="text" ng-model="searchTextAll" class="flex h-60"></div><div style="max-height: 100%; overflow: hidden;" \nclass="content thread-list mail-list-pane p0" flex="" id="thread-list"><div id="list-content-data" \nng-style="{\'opacity\' : isLoading ? 0.5 : 1}"><div class="mail-list-item p0" \nng-repeat="user in vm.usersAll | filter:searchTextAll | filter:filterAlreadyAdded | orderBy: \'name\'" \nng-init="parentIndex= $index" md-no-ink ng-click="vm.selectUser(user)" \nng-class="{\'starred\': user.starred, \'selected\': vm.selectedContentID !== user.id_mailing_content, \'checked\': vm.isChecked(user)}">\n<div layout="row" layout-align="start center" flex="100" class="pl-15 pt-10 pb-10"><div class="info" flex \nlayout="column"><div class="name" layout="row"><div layout="row" layout-align="start center" flex="100"><div \nclass="avatar-wrapper"><img class="avatar s24" ng-src="{{vm.showUserImage(user)}}" ng-if="user.files.id"><div \nclass="avatar s24" ng-class="user.profile_color ? user.profile_color : \'md-blue-grey-300-bg\'" ng-if="!user.files.id" \nng-bind="user.first_name | capitalizeFirstLetter"></div></div><div class="field mr-10 ml-10" flex><strong \nclass="grey-800-fg" ng-bind-html="user.first_name + \' \' + user.last_name"></strong></div></div></div></div></div></div>\n</div></div></div><md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" \ntranslate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nng-if="$root.pagination_searchquery==true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip \nhide show-gt-xs><span>Reset search</span></md-tooltip></md-button></md-tab></md-tabs>');
$templateCache.put('app/main/apps/clients-complaints/dialogs/forms/external-user.html','<div id="forms" class="page-layout simple fullwidth doc-page forms scrollable" layout="column" ms-scroll><form \nname="wizardStep1" class="md-inline-form" ms-form-wizard-form novalidate><div \nng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" style="height: auto!important;" \nclass="items mt-10"><md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'text\' && field.field == \'3rd_party_company_name\'"><input type="{{field.type}}" \nng-model="field.value" placeholder="{{ field.translate | translate }}" ng-required="field.required">\n</md-input-container><md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'text\' && field.field != \'3rd_party_company_name\'"><input type="{{field.type}}" \nng-model="field.value" placeholder="{{ field.translate | translate }}" ng-required="field.required">\n</md-input-container><md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'password\'"><input type="{{field.type}}" ng-model="field.value" \nplaceholder="{{ field.translate | translate }}" ng-required="field.required"></md-input-container><md-input-container \nclass="item" ng-repeat="field in vm.fields" ng-if="!field.hidden && field.type == \'selector\'"><md-select \nng-disabled="vm.disabledPosition(field)" ng-if="field.field === \'position\'" ng-model="field.value" \nplaceholder="{{ field.translate | translate }}" required><md-option \nng-repeat="option in field.options track by $index" ng-value="option.id">{{option.field}}</md-option></md-select>\n</md-input-container></div><div ng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" \nlayout="row" flex><md-input-container flex class="item mv-0" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'picture\'"><div class="md-block"><div><div ngf-drop ngf-select \nng-model="vm.files" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="image/*" ngf-pattern="\'image/*\'"><div layout="column"><div flex translate="GLOBAL.DROP_HERE">\nDrop here or click to upload</div><div flex translate="GLOBAL.OR"></div><div flex><md-button \nclass="send-button md-accent md-raised" aria-label="Select files" translate="GLOBAL.SELECT_FILES"></md-button></div>\n</div></div><div ngf-no-file-drop translate="GLOBAL.FILE_DRAG_DROP"></div></div><div ng-repeat="f in vm.files" \nclass="ms-card" flex><div ng-if="!f.url" class="ms-card-content-wrapper"><div class="template-9"><div class="media" \nflex layout="row" layout-align="center center"><img ngf-thumbnail="!f.$error && f" class="image"></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><strong class="mr-5" ng-if="f.id">#{{f.id}}</strong> <span class="grey-500-fg"><span \nng-if="f.name">{{f.name}}</span></span></div></div></div><md-progress-linear md-mode="determinate" \nvalue="{{f.progress}}" ng-show="f.progress <100"></md-progress-linear></div></div><div ng-if="f.url" \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><img class="image" ng-src="{{vm.storagePrefix + f.url}}"></div><div class="header p-16" \nflex layout="row" layout-align="end center"><md-menu class="float-right"><md-button class="md-icon-button" \naria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item><md-button translate="GLOBAL.REMOVE" ng-click="vm.deleteAvatar(f)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item></md-menu-content>\n</md-menu></div><md-progress-linear md-mode="determinate" value="{{f.progress}}" ng-show="f.progress <100">\n</md-progress-linear></div></div></div></div></md-input-container></div><div \nng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" fill-width class="navigation pb-20" flex \nlayout="row" layout-align="center center"><md-button ng-if="vm.showJobDivision()" translate="GLOBAL.BACK" \nclass="md-raised md-warn" ng-click="vm.unSelectJobDivision()"></md-button><md-button ng-disabled="vm.isSendDisabled()" \ntranslate="GLOBAL.SEND" class="md-raised md-accent" ng-click="vm.sendForm($event)" ng-disabled="wizardStep1.$valid">\n</md-button></div><div class="text-center" ng-if="vm.user_type != undefined && vm.user_type != 4 && vm.user_type != 5">\n<h3>{{ \'CLIENTS.EDIT_USER_SECTION_USERS\' | translate}}</h3></div></form></div>');
$templateCache.put('app/main/apps/clients-complaints/dialogs/forms/forms-view-delegation.html','<div id="forms" class="form-delegation page-layout simple fullwidth doc-page forms" layout="column"><div class="p0" \nlayout="column"><div layout="row"><ms-form-wizard class="popup" flex><form name="wizardStep1" class="md-inline-form" \nms-form-wizard-form novalidate><div class="items mt-30"><md-input-container class="item" \nng-repeat="field in vm.fields" ng-if="field.field !== \'id\' && field.field !== \'fullName\'"><input \nng-if="field.field !== \'phone\' && field.field !== \'email\' && field.field !== \'position\'" type="{{field.type}}" \nname="{{field.field}}" ng-model="field.value" placeholder="{{ field.translate | translate }}" required> <input \nng-if="field.field === \'phone\' || field.field === \'email\'" type="{{field.type}}" name="{{field.field}}" \nng-model="field.value" placeholder="{{ field.translate | translate }}"><div ng-messages="wizardStep1.email.$error" \nrole="alert" multiple="multiple"><div ng-message="pattern"><span translate="GLOBAL.EMAIL_VALID"></span></div></div>\n</md-input-container></div></form><div class="navigation pt-20" flex layout="row" layout-align="center center">\n<md-button translate="GLOBAL.SEND" class="md-raised md-warn" ng-click="vm.sendForm()" ng-disabled="wizardStep1.$valid">\n</md-button></div></ms-form-wizard></div></div></div>');
$templateCache.put('app/main/apps/clients-complaints/dialogs/forms/forms-view-user.html','<div id="forms-position" class="page-layout simple fullwidth doc-page forms scrollable" layout="column" ms-scroll \nng-if="vm.showSelectPosition()"><form name="wizardStep2" class="md-inline-form" ms-form-wizard-form novalidate><h3 \nclass="mh-15" translate="CLIENTS.BEFORE_CONTINUE_PERSONEL"></h3><div class="items ph-15" layout="row">\n<md-input-container flex class="item" ng-if="vm.indexDivision != null" ng-show="vm.showSector()"><md-select \nng-model="vm.fields[vm.indexDivision].value" placeholder="{{ vm.fields[vm.indexDivision].translate | translate }}" \nrequired><md-option ng-repeat="option in vm.fields[vm.indexDivision].options track by $index" ng-value="option.id">\n{{option.field}}</md-option></md-select></md-input-container><md-input-container flex class="item" \nng-if="vm.indexPosition != null"><md-select ng-disabled="vm.disabledPosition(vm.fields[vm.indexPosition])" \nng-model="vm.fields[vm.indexPosition].value" placeholder="{{ vm.fields[vm.indexPosition].translate | translate }}" \nrequired><md-option ng-repeat="option in vm.fields[vm.indexPosition].options track by $index" ng-value="option.id">\n{{option.field}}</md-option></md-select></md-input-container></div></form><div class="navigation pt-20" flex \nlayout="row" layout-align="center center"><md-button translate="GLOBAL.SELECT" class="md-raised md-accent" \nng-click="vm.selectJobDivision()" ng-disabled="vm.divisionJobSelected()"></md-button></div></div><md-tabs \nfill-height-i md-border-bottom ng-if="!vm.showSelectPosition()"><md-tab label="{{\'CLIENTS.NEW_USER\' | translate}}"><div\n ng-include="\'app/main/apps/clients-complaints/dialogs/forms/new-user.html\'"></div></md-tab><md-tab \nlabel="{{\'CLIENTS.EXISTING_USER\' | translate}}"><div \nng-style="{\'height\': vm.showJobDivision() ? \'calc(100% - 58px)\' : \'100%\'}" \nng-include="\'app/main/apps/clients-complaints/dialogs/forms/existing-user.html\'"></div><div \nng-if="vm.showJobDivision()" class="navigation pt-10" flex layout="row" layout-align="center center"><md-button \ntranslate="GLOBAL.BACK" class="md-raised md-warn" ng-click="vm.unSelectJobDivision()"></md-button></div></md-tab>\n<md-tab label="{{\'CLIENTS.COMPANY_OR_EXTERNAL_STAFF\' | translate}}"><div \nng-include="\'app/main/apps/clients-complaints/dialogs/forms/external-user.html\'"></div></md-tab></md-tabs>');
$templateCache.put('app/main/apps/clients-complaints/dialogs/forms/new-user.html','<div id="forms" class="page-layout simple fullwidth doc-page forms scrollable" layout="column" ms-scroll><form \nname="wizardStep1" class="md-inline-form" ms-form-wizard-form novalidate><div layout="row" \nng-if="!vm.showJobDivision() && !(vm.user_type != undefined && vm.user_type != 4 && vm.user_type != 5)  && !vm.type">\n<md-input-container flex class="item mh-15" ng-if="vm.indexDivision != null" ng-show="vm.showSector()"><md-select \nng-disabled="true" ng-model="vm.fields[vm.indexDivision].value" \nplaceholder="{{ vm.fields[vm.indexDivision].translate | translate }}" required><md-option \nng-repeat="option in vm.fields[vm.indexDivision].options track by $index" ng-value="option.id">{{option.field}}\n</md-option></md-select></md-input-container><md-input-container flex class="item mh-15" \nng-if="vm.indexPosition != null"><md-select ng-disabled="true" ng-model="vm.fields[vm.indexPosition].value" \nplaceholder="{{ vm.fields[vm.indexPosition].translate | translate }}" required><md-option \nng-repeat="option in vm.fields[vm.indexPosition].options track by $index" ng-value="option.id">{{option.field}}\n</md-option></md-select></md-input-container></div><div \nng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" style="height: auto!important;" \nclass="items mt-10"><md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'text\' && field.field != \'3rd_party_company_name\'"><input type="{{field.type}}" \nng-model="field.value" placeholder="{{ field.translate | translate }}" ng-required="field.required">\n</md-input-container><md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'password\'"><input type="{{field.type}}" ng-model="field.value" \nplaceholder="{{ field.translate | translate }}" ng-required="field.required"></md-input-container><md-input-container \nclass="item" ng-repeat="field in vm.fields" ng-if="!field.hidden && field.type == \'selector\'"><md-select \nng-disabled="vm.disabledPosition(field)" ng-if="field.field === \'position\'" ng-model="field.value" \nplaceholder="{{ field.translate | translate }}" required><md-option \nng-repeat="option in field.options track by $index" ng-value="option.id">{{option.field}}</md-option></md-select>\n</md-input-container></div><div ng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" \nlayout="row" flex><md-input-container flex class="item mv-0" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'picture\'"><div class="md-block"><div><div ngf-drop ngf-select \nng-model="vm.files" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="image/*" ngf-pattern="\'image/*\'"><div layout="column"><div flex translate="GLOBAL.DROP_HERE">\nDrop here or click to upload</div><div flex translate="GLOBAL.OR"></div><div flex><md-button \nclass="send-button md-accent md-raised" aria-label="Select files" translate="GLOBAL.SELECT_FILES"></md-button></div>\n</div></div><div ngf-no-file-drop translate="GLOBAL.FILE_DRAG_DROP"></div></div><div ng-repeat="f in vm.files" \nclass="ms-card" flex><div ng-if="!f.url" class="ms-card-content-wrapper"><div class="template-9"><div class="media" \nflex layout="row" layout-align="center center"><img ngf-thumbnail="!f.$error && f" class="image"></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><strong class="mr-5" ng-if="f.id">#{{f.id}}</strong> <span class="grey-500-fg"><span \nng-if="f.name">{{f.name}}</span></span></div></div></div><md-progress-linear md-mode="determinate" \nvalue="{{f.progress}}" ng-show="f.progress <100"></md-progress-linear></div></div><div ng-if="f.url" \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><img class="image" ng-src="{{vm.storagePrefix + f.url}}"></div><div class="header p-16" \nflex layout="row" layout-align="end center"><md-menu class="float-right"><md-button class="md-icon-button" \naria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.deleteAvatar(f)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-content></md-menu></div>\n<md-progress-linear md-mode="determinate" value="{{f.progress}}" ng-show="f.progress <100"></md-progress-linear></div>\n</div></div></div></md-input-container></div><div \nng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" fill-width class="navigation pb-20" flex \nlayout="row" layout-align="center center"><md-button ng-if="vm.showJobDivision()" translate="GLOBAL.BACK" \nclass="md-raised md-warn" ng-click="vm.unSelectJobDivision()"></md-button><md-button ng-disabled="vm.isSendDisabled()" \ntranslate="GLOBAL.SEND" class="md-raised md-accent" ng-click="vm.sendForm($event)" ng-disabled="wizardStep1.$valid">\n</md-button></div><div class="text-center" ng-if="vm.user_type != undefined && vm.user_type != 4 && vm.user_type != 5">\n<h3 ng-bind-html="vm.translate(\'CLIENTS.EDIT_USER_SECTION_USERS\')"></h3></div></form></div>');
$templateCache.put('app/main/apps/clients-complaints/dialogs/image/image-dialog.html','<md-dialog class="attachment-dialog" aria-label="New Task"><md-toolbar class="md-accent md-hue-2 md-default-theme"><div\n class="md-toolbar-tools"><div layout="row" hide show-gt-xs><a class="md-button" type="1" layout="row" \nlayout-align="center center" ng-click="vm.changeView(\'fotorama\')"><md-icon md-font-icon="icon-file-image-box" \nclass="s18 mr-5 ml-0"></md-icon><span translate="GLOBAL.PREVIEW">Preview Media</span></a></div><span flex></span><div \nlayout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content class="mediadialog-content" layout-fill><md-content flex class="content-card" \nng-class="vm.currentView" ng-include="vm.views[vm.currentView]" md-no-ink></md-content></md-dialog-content></md-dialog>');
$templateCache.put('app/main/apps/clients-complaints/dialogs/media/media-clients-tinymce.html','<md-dialog class="attachment-dialog add-media" aria-label="New Message"><form class="md-inline-form"><md-toolbar \nclass="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><div layout="row" \nhide show-gt-xs><a class="md-button" type="1" layout="row" layout-align="center center" \nng-click="vm.changeViewTiny(\'1\')"><md-icon md-font-icon="icon-file-image-box" class="s18 mr-5 ml-0"></md-icon><span>\nAttached Media</span></a></div><div layout="row" hide-gt-xs show-xs><md-menu><md-button aria-label="Filters" \nng-click="$mdMenu.open($event)" translate="" translate-attr-aria-label="GLOBAL.FILTERS"><span layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-file-image-box" class="s18 mr-5 ml-0"></md-icon><span \nclass="ml-5">Images</span> <i class="icon-chevron-down s20 ml-5"></i></span></md-button><md-menu-content width="3">\n<md-menu-item><md-button type="photos" ng-click="vm.changeViewTiny(\'1\')"><div layout="row" \nlayout-align="space-between center"><div><md-icon md-font-icon="icon-file-image-box" class="s18"></md-icon><span>Images\n</span></div><i class="icon-check s16" ng-if="sortfield.titleId == sortable.titleId"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu></div><div layout="row"><md-button class="md-icon-button" \nng-click="vm.closeDialog()" aria-label="Close dialog" tranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon \nmd-font-icon="icon-close"></md-icon></md-button></div></div></md-toolbar><div flex \nng-include="\'app/main/apps/clients/dialogs/media/views/templates/toolbar-search.html\'"></div><md-dialog-content \nclass="mediadialog-content scrollable" layout-fill ms-scroll><treasure-overlay-spinner active="vm.loading"><div \nlayout="column" flex><md-content flex class="content-card" ng-class="vm.currentViewTiny" \nng-include="vm.viewsTiny[vm.currentViewTiny]" md-no-ink></md-content></div></treasure-overlay-spinner>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="space-between center" ng-if="!vm.loading"><div \nlayout="row" layout-align="start center"></div><div layout="row" layout-align="end right"><md-button \nng-click="vm.attachMediaTiny()" class="send-button md-accent md-raised" aria-label="Send" translate="GLOBAL.ADD_FILE" \ntranslate-attr-aria-label="GLOBAL.ADD_FILE">ADD</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/clients-complaints/dialogs/media/media-clients.html','<md-dialog class="attachment-dialog add-media" aria-label="New Message"><form class="md-inline-form"><md-toolbar \nclass="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><div layout="row" \nhide show-gt-xs><a class="md-button" type="upload" layout="row" layout-align="center center" \nng-click="vm.changeView(\'upload\')"><md-icon md-font-icon="icon-import" class="s18 mr-5 ml-0"></md-icon><span \ntranslate="GLOBAL.UPLOAD"></span></a></div><div layout="row" hide-gt-xs show-xs><md-menu><md-button \naria-label="Filters" ng-click="$mdMenu.open($event)" translate="" translate-attr-aria-label="GLOBAL.FILTERS"><span \nlayout="row" layout-align="start center"><md-icon md-font-icon="icon-file-image-box" class="s18 mr-5 ml-0"></md-icon>\n<span class="ml-5" ng-if="vm.currentView===\'upload\'">Upload</span><i class="icon-chevron-down s20 ml-5"></i></span>\n</md-button><md-menu-content width="3"><md-menu-item><md-button type="import" ng-click="vm.changeView(\'import\')"><div \nlayout="row" layout-align="space-between center"><div><md-icon md-font-icon="icon-import" class="s18"></md-icon><span>\nUpload</span></div><i class="icon-check s16" ng-if="vm.currentView===\'upload\'"></i></div></md-button></md-menu-item>\n</md-menu-content></md-menu></div><div layout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog" tranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></div></md-toolbar><md-dialog-content ms-scroll flex class="content-card" \nng-class="vm.currentView" ng-include="vm.views[vm.currentView]"></md-dialog-content></form></md-dialog>');
$templateCache.put('app/main/apps/clients-complaints/dialogs/edit-branch/edit-branch-dialog.controller.html','<md-dialog class="edit-branch-dialog" aria-label="New Task"><form name="taskForm" class="md-inline-form" novalidate>\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between"><h1 \nclass="title">{{vm.branch.name}}</h1><md-button class="md-icon-button" ng-click="vm.closeDialog()"><md-icon \nmd-font-icon="icon-close" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div layout="column" class="p-15"><md-input-container fill-width flex class="md-block mb-0"><label \ntranslate="GLOBAL.NAME"></label> <input ng-model="vm.branch.name" type="text"></md-input-container><md-input-container \nfill-width flex class="md-block mb-0"><label translate="GLOBAL.ADDRESS"></label> <input ng-model="vm.branch.address1" \ntype="text"></md-input-container><md-input-container fill-width flex class="md-block mb-0"><label>\n{{vm.getRegionLiteral(\'city\')}}</label> <input ng-model="vm.branch.city" type="text"></md-input-container>\n<md-input-container fill-width flex class="md-block mb-0"><label>{{vm.getRegionLiteral(\'state\')}}</label> <input \nng-model="vm.branch.state" type="text"></md-input-container><md-input-container fill-width flex class="md-block mb-0">\n<label translate="GLOBAL.POSTAL_CODE"></label> <input ng-model="vm.branch.postcode" type="text"></md-input-container>\n<md-input-container fill-width flex class="md-block mb-0"><label translate="GLOBAL.EMAIL"></label> <input \nng-model="vm.branch.email" type="text"></md-input-container><md-input-container fill-width flex class="md-block mb-0">\n<label translate="GLOBAL.PHONE"></label> <input ng-model="vm.branch.phone" type="text"></md-input-container></div>\n</md-dialog-content><md-dialog-actions class="footer" layout="row" layout-="end"><md-input-container flex layout="row" \nlayout-align="end center"><md-button type="button" class="md-raised md-warn" ng-click="vm.closeDialog()" \ntranslate="RISKCONFIG.CANCEL">Cancel</md-button><md-button ng-disabled="vm.selectedBranchs.length == 0" type="submit" \nclass="send-button md-accent md-raised" ng-click="vm.saveDialog()" translate="GLOBAL.SAVE">ADD</md-button>\n</md-input-container></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/clients-complaints/dialogs/new-client-dialog/new-client-dialog.html','<md-dialog class="new-client-dialog" aria-label="New Task"><form name="taskForm" class="md-inline-form" novalidate>\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between"><h1 \nclass="title" translate="GLOBAL.COMPANY_DATA"></h1><md-button class="md-icon-button" ng-click="vm.closeDialog()">\n<md-icon md-font-icon="icon-close" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content class="p-25" ms-scroll><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="GLOBAL.SOCIAL_REASON"></label> <input type="text" ng-model="vm.company.name" required></md-input-container>\n</div><div layout="column" layout-gt-xs="row"><md-input-container flex><label>{{vm.getRegionLiteral(\'tax_ic_number\')}}\n</label> <input type="text" ng-model="vm.company.tax_id_number"></md-input-container><md-input-container flex><label \ntranslate="GLOBAL.SECTOR"></label><md-select ng-model="vm.company.sector_id"><md-option \nng-repeat="sector in vm.sectors track by $index" ng-value="sector.id">{{sector.name}}</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="GLOBAL.REGION"></label><md-select ng-model="vm.company.region_id"><md-option \nng-repeat="region in vm.regions track by $index" ng-value="region.id">{{region.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><label translate="GLOBAL.ADDRESS"></label> <input \nng-model="vm.main_branch.address1" type="text" required></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container flex><label>{{vm.getRegionLiteral(\'city\')}}</label> <input \nng-model="vm.main_branch.city" type="text" required></md-input-container><md-input-container flex><label>\n{{vm.getRegionLiteral(\'state\')}}</label> <input ng-model="vm.main_branch.state" type="text" required>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="GLOBAL.POSTAL_CODE"></label> <input ng-model="vm.main_branch.postcode" type="text" required>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-align="start center"><md-input-container><p \nclass="mt-0 grey-400-fg" translate="GLOBAL.LOGOTYPE"></p><div class="header simple relative" ng-if="image || imageUrl" \nlayout="row" layout-align="space-between center"><md-menu><button class="md-icon-button" aria-label="More"><div \nlayout="column" layout-align="start center" ng-click="$mdMenu.open($event)"><div class="media" flex layout="row" \nlayout-align="center center"><img ngf-thumbnail="!image.$error && image" class="image"> <img \nng-if="!image && imageUrl" src="{{imageUrl}}" class="image"></div><md-button \nclass="md-mini add-event-button no-sort md-fab md-warn block absolute-top-right" aria-label="Add event"><md-icon \nmd-font-icon="icon-dots-vertical"></md-icon></md-button></div></button><md-menu-content width="3"><md-menu-item>\n<md-button ng-click="vm.deleteLogotype()" aria-label="Toggle done" translate-attr-aria-label="GLOBAL.REMOVE"><md-icon \nmd-font-icon="icon-close" class="s18"></md-icon><span translate="GLOBAL.REMOVE"></span></md-button></md-menu-item>\n</md-menu-content></md-menu></div><div ng-if="!image && !imageUrl" \nng-click="vm.mediaDialogSingle($event, vm.company.logotype)" class="relative"><img \nsrc="assets/images/logos/generic-logo.png" class="image"><md-button \nclass="md-mini add-event-button no-sort md-fab md-warn block absolute-top-right" aria-label="Add event" translate \ntranslate-attr-aria-label="CALENDAR.ADD_EVENT"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions class="footer" layout="row" layout-="end">\n<md-input-container flex layout="row" layout-align="end center"><md-button type="button" class="md-raised md-warn" \nng-click="vm.closeDialog()" translate="RISKCONFIG.CANCEL">Cancel</md-button><md-button ng-disabled="!vm.company.name" \ntype="submit" class="send-button md-accent md-raised" ng-click="vm.saveDialog()" translate="GLOBAL.SAVE">ADD\n</md-button></md-input-container></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/clients-complaints/views/read/form.html','<div id="forms" class="page-layout simple fullwidth doc-page forms" layout="column"><div class="p0" layout="column">\n<div layout="row"><ms-form-wizard class="no-margin" flex><div layout="row" layout-align="start center" flex="100" \nclass="layout-align-start-center layout-row flex-100 toolbar grey-100-bg colored-bg" ng-if="vm.idCompany"><a \nclass="pointer" ng-click="vm.closeForm()"><md-icon md-font-icon="icon-chevron-left"></md-icon></a><div \nclass="avatar-wrapper"><md-icon md-font-icon="icon-city"></md-icon></div><div class="field mr-10 ml-10 flex" flex="">\n<strong class="grey-800-fg ng-binding" ng-bind-html="vm.formWizard.company.name"></strong></div></div><md-tabs \nclass="height-tabs" md-dynamic-height md-selected="msWizard.selectedIndex" md-center-tabs="true"><md-tab><md-tab-label>\n<span class="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 0">1</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 0"><i class="icon-checkbox-blank-circle s16"></i> </span><span \nclass="ms-form-wizard-step-text" translate="GLOBAL.COMPANY_DATA"></span></span></md-tab-label><md-tab-body><form \nname="wizardStep1" ng-include="\'app/main/apps/clients-complaints/views/read/form-tabs/step-company.html\'" \nms-form-wizard-form novalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.idCompany"><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 1">2</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 1"><i class="icon-checkbox-blank-circle s16"></i> </span><span \nclass="ms-form-wizard-step-text" translate="GLOBAL.FILIATION_DATA"></span></span></md-tab-label><md-tab-body><div \nclass="navigation white-bg mb-50" flex layout="row" layout-align="center center"></div><form name="wizardStep1b" \nng-include="\'app/main/apps/clients-complaints/views/read/form-tabs/step-branchs.html\'" class="md-inline-form" \nms-form-wizard-form novalidate ng-init="initializeImplementedMeasures()"></form></md-tab-body></md-tab><md-tab \nng-disabled="!vm.formWizard.main_branch.id"><md-tab-label><span class="ms-form-wizard-step-label"><span \nclass="ms-form-wizard-step-number md-accent-bg" ng-if="msWizard.selectedIndex != 2">3</span> <span \nclass="ms-form-wizard-step-number md-accent-bg" ng-if="msWizard.selectedIndex == 2"><i \nclass="icon-checkbox-blank-circle s16"></i> </span><span translate="CLIENTS-COMPLAINTS.COMPLIANCE_COMMITTEE" \nclass="ms-form-wizard-step-text"></span></span></md-tab-label><md-tab-body><form \nng-include="\'app/main/apps/clients-complaints/views/read/form-tabs/step-people.html\'" name="wizardStep3" \nms-form-wizard-form novalidate></form></md-tab-body></md-tab></md-tabs><div \nclass="navigation white-bg border-top mb-50" flex layout="row" layout-align="center center"><div layout="row" flex \nlayout-align="start center"><md-button hide-xs ng-if="vm.showForm" translate="GLOBAL.CLOSE" type="button" \nng-click="vm.closeForm()" class="md-raised md-warn hide-xs" aria-label="Cancel"></md-button></div><div class="ml-auto" \nlayout="row" flex layout-align="end center"><div flex layout="column" layout-align="center center" layout-padding \nlayout-margin ng-if="vm.loadingStep" class="loading-container"><md-progress-circular md-mode="indeterminate" \nmd-diameter="30"></md-progress-circular></div><md-button translate="GLOBAL.PREVIOUS" class="md-raised md-accent" \nng-click="vm.prevStep(msWizard)" ng-disabled="vm.previousStep(msWizard) || vm.loadingStep"></md-button><div \nclass="steps"><span ng-repeat="form in msWizard.forms" \nng-class="{\'selected md-accent-bg\':msWizard.selectedIndex === $index}"></span></div><md-button translate="GLOBAL.NEXT" \nclass="md-raised md-accent" ng-click="vm.nextStep(msWizard)" ng-hide="msWizard.isLastStep()" \nng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button><md-button translate="GLOBAL.FINISH" \nclass="md-raised md-warn" ng-click="vm.sendForm(); msWizard.resetForm();" ng-show="msWizard.isLastStep()" \nng-disabled="msWizard.formsIncomplete()"></md-button></div></div><div class="navigation" flex layout="row" \nlayout-align="center center"><md-button hide-xs ng-if="vm.showForm" translate="GLOBAL.CANCEL" type="button" \nng-click="vm.closeForm()" class="md-raised md-warn show-xs" aria-label="Cancel"></md-button></div></ms-form-wizard>\n</div></div></div>');
$templateCache.put('app/main/apps/clients-complaints/views/read/preview-company.html','<div id="forms" class="page-layout simple fullwidth doc-page forms" layout="column"><div class="p0" layout="column">\n<div layout="row"><ms-form-wizard class="no-margin" flex><div layout="row" layout-align="start center" flex="100" \nclass="layout-align-start-center layout-row flex-100 toolbar grey-100-bg colored-bg" ng-if="vm.idCompany"><a \nclass="pointer" ng-click="vm.closeForm()"><md-icon md-font-icon="icon-chevron-left"></md-icon></a><div \nclass="avatar-wrapper"><md-icon md-font-icon="icon-city"></md-icon></div><div class="field mr-10 ml-10 flex" flex="">\n<strong class="grey-800-fg ng-binding" ng-bind-html="vm.formWizard.company.name"></strong></div></div><md-tabs \nclass="height-tabs" md-dynamic-height md-selected="msWizard.selectedIndex" md-center-tabs="true"><md-tab><md-tab-label>\n<span class="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 0">1</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 0"><i class="icon-checkbox-blank-circle s16"></i> </span><span \nclass="ms-form-wizard-step-text" translate="GLOBAL.COMPANY_DATA"></span></span></md-tab-label><md-tab-body><form \nname="wizardStep1" ng-include="\'app/main/apps/clients-complaints/views/read/form-tabs/step-company.html\'" \nms-form-wizard-form novalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.idCompany"><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 1">2</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 1"><i class="icon-checkbox-blank-circle s16"></i> </span><span \nclass="ms-form-wizard-step-text" translate="CLIENTS-COMPLAINTS.FILIATION_DATA"></span></span></md-tab-label>\n<md-tab-body><form name="wizardStep2" \nng-include="\'app/main/apps/clients-complaints/views/read/form-tabs/step-branchs.html\'" class="md-inline-form" \nms-form-wizard-form novalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.formWizard.main_branch.id">\n<md-tab-label><span class="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 2">3</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 2"><i class="icon-checkbox-blank-circle s16"></i> </span><span \ntranslate="CLIENTS-COMPLAINTS.COMPLIANCE_COMMITTEE" class="ms-form-wizard-step-text"></span></span></md-tab-label>\n<md-tab-body><form ng-include="\'app/main/apps/clients-complaints/views/read/form-tabs/step-people.html\'" \nname="wizardStep3" ms-form-wizard-form novalidate></form></md-tab-body></md-tab></md-tabs><div \nclass="white-bg border-top mb-50" flex layout="row" layout-align="center center"><div layout="row" flex \nlayout-align="start center"><md-button hide-xs ng-if="vm.showForm" translate="GLOBAL.CLOSE" type="button" \nng-click="vm.closeForm()" class="md-raised md-warn hide-xs" aria-label="Cancel"></md-button><md-button \nng-if="vm.idCompany" translate="GLOBAL.SAVE" class="md-raised md-accent" ng-click="vm.nextStep(msWizard, true);" \nng-hide="msWizard.isLastStep()" ng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button></div><div \nclass="ml-auto" layout="row" flex layout-align="end center"><div flex layout="column" layout-align="center center" \nlayout-padding layout-margin ng-if="vm.loadingStep" class="loading-container"><md-progress-circular \nmd-mode="indeterminate" md-diameter="30"></md-progress-circular></div><md-button translate="GLOBAL.PREVIOUS" \nclass="md-raised md-accent" ng-click="vm.prevStep(msWizard)" ng-disabled="vm.previousStep(msWizard) || vm.loadingStep">\n</md-button><div class="steps"><span ng-repeat="form in msWizard.forms" \nng-class="{\'selected md-accent-bg\':msWizard.selectedIndex === $index}"></span></div><md-button translate="GLOBAL.NEXT" \nclass="md-raised md-accent" ng-click="vm.nextStep(msWizard)" ng-hide="msWizard.isLastStep()" \nng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button><md-button translate="GLOBAL.FINISH" \nclass="md-raised md-warn" ng-click="vm.sendForm(); msWizard.resetForm(); vm.closeForm();" \nng-show="msWizard.isLastStep()" ng-disabled="msWizard.formsIncomplete()"></md-button></div></div><div \nclass="navigation" flex layout="row" layout-align="center center"><md-button hide-xs ng-if="vm.showForm" \ntranslate="GLOBAL.CANCEL" type="button" ng-click="vm.closeForm()" class="md-raised md-warn show-xs" \naria-label="Cancel"></md-button></div></ms-form-wizard></div></div></div>');
$templateCache.put('app/main/apps/clients-complaints/views/read/preview-structure.html','<div hide show-gt-sm class="toolbar grey-100-bg colored-bg" layout="row" layout-align="space-between center" scroll="">\n<div layout="row" layout-align="start center"></div><div layout="row" layout-align="end center" hide show-gt-sm>\n<md-button translate="GLOBAL.CANCEL" type="button" ng-click="vm.goClients()" class="md-raised md-warn" \naria-label="Cancel"></md-button><md-button translate="GLOBAL.EDIT" type="button" ng-click="vm.editCompany()" \nclass="md-raised md-accent" aria-label="Edit"></md-button></div><div layout="row" layout-align="end center" hide-gt-sm>\n<md-button type="button" ng-click="vm.editClient()" \nclass="md-accent md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" aria-label="Edit"><md-icon \nmd-font-icon="icon-plus"></md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.EDIT"></span></md-tooltip>\n</md-button></div></div>');
$templateCache.put('app/main/apps/clients-complaints/views/read/question-form.html','<div id="forms" class="page-layout simple fullwidth doc-page forms" layout="column"><div ng-if="!vm.isQuestions"><div \nclass="page-layout carded left-sidenav" layout="row"><div class="content-wrapper" layout="row" flex><div \nclass="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-thumb-up" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="CLIENTS.CLIENT_CREATED_SUCCESSFULLY"></span><div layout-gt-xs="row" layout="column" \nlayout-align="center center" class="mt-15"><md-button translate="GLOBAL.BACK_CLIENT_LIST" type="button" \nng-click="vm.goClients()" class="md-raised md-warn" aria-label="Cancel"></md-button></div></div></div></div></div>\n</div></div>');
$templateCache.put('app/main/apps/clients-complaints/views/read/read-view-complaints.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="vm.loadingReadPane" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="fullheight" ng-if="!vm.loadingReadPane"><content class="" layout="row" \nng-include="\'app/main/apps/clients-complaints/views/read/preview-company.html\'"></content></div>');
$templateCache.put('app/main/apps/dashboard-complaints/dialogs/category-dialog/category-dialog.html','<md-dialog id="company-performance-dialog" class="form-dialog" aria-label="Tipos de Comunicaci\xF3n M\xE1s Frecuentes">\n<md-toolbar class="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><h1 \nstyle="background: transparent;">{{ \'DASHBOARD-COMPLAINTS.MOST_FREQUENT_COMMUNICATION_TYPES\' | translate }}</h1><div \nclass="absolute-right pr-10" layout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog" translate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></div></md-toolbar><md-dialog-content class="mediadialog-content" flex><div \nclass="company-performance-dialog"><div ng-if="vm.categoriesData && vm.categoriesData.length > 0" \nclass="companies-list"><div ng-repeat="category in vm.categoriesData" class="company-bar-item"><div class="bar-label">\n<div class="company-info"><div class="company-logo"><div class="category-dot-dialog" \nng-style="{\'background-color\': category.color}"></div></div><div class="company-details"><span class="company-name">\n{{category.name}}</span> <span class="company-stats">\n{{category.count}} {{ \'DASHBOARD-COMPLAINTS.COMMUNICATIONS\' | translate }}</span></div></div><span class="bar-value">\n{{category.count}}</span></div><div class="bar-container"><div class="bar-fill" \nng-style="{\'width\': category.percentage + \'%\', \'background-color\': category.color}"></div></div></div></div><div \nng-if="!vm.categoriesData || vm.categoriesData.length === 0" class="no-data-message"><md-icon \nmd-font-icon="icon-chart-bar" style="font-size: 48px; color: #ccc;"></md-icon><span \nstyle="color: #999; margin-top: 8px;">{{ \'DASHBOARD-COMPLAINTS.NO_CATEGORIES\' | translate }}</span></div></div>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="end center" class="grey-100-bg"><md-button \ntranslate="GLOBAL.CLOSE" type="button" ng-click="vm.closeDialog()" class="md-raised md-accent" aria-label="Close">\n</md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/main/apps/dashboard-complaints/dialogs/company-performance-dialog/company-performance-dialog.html','<md-dialog id="company-performance-dialog" class="form-dialog" aria-label="Tiempo Promedio de Gesti\xF3n por Empresa">\n<md-toolbar class="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><h1 \nstyle="background: transparent;">{{ \'DASHBOARD-COMPLAINTS.AVERAGE_MANAGEMENT_TIME\' | translate }}</h1><div \nclass="absolute-right pr-10" layout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog" translate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></div></md-toolbar><md-dialog-content class="mediadialog-content" flex><div \nclass="company-performance-dialog"><div ng-if="vm.companiesData && vm.companiesData.length > 0" class="companies-list">\n<div ng-repeat="company in vm.companiesData" class="company-bar-item"><div class="bar-label"><div class="company-info">\n<div class="company-logo"><img ng-if="company.logo" ng-src="{{company.logo}}" alt="{{company.name}}" \nclass="avatar avatar-dialog"><div ng-if="!company.logo" class="avatar avatar-dialog small img">\n{{company.name.charAt(0).toUpperCase()}}</div></div><div class="company-details"><span class="company-name">\n{{company.name}}</span> <span class="company-stats">\n{{company.totalComplaints}} {{ \'DASHBOARD-COMPLAINTS.COMMUNICATIONS\' | translate }}, {{company.resolvedCount}} {{ \'DASHBOARD-COMPLAINTS.COMMUNICATIONS_STATUS_0\' | translate }}\n</span></div></div><span class="bar-value">{{company.avgResolutionDays}} {{ \'DASHBOARD-COMPLAINTS.DAYS\' | translate }}\n</span></div><div class="bar-container"><div class="bar-fill" \nng-style="{\'width\': (company.avgResolutionDays / vm.maxResolutionDays * 100) + \'%\', \'background-color\': company.color}">\n</div></div></div></div><div ng-if="!vm.companiesData || vm.companiesData.length === 0" class="no-data-message">\n<md-icon md-font-icon="icon-clock" style="font-size: 48px; color: #ccc;"></md-icon><span \nstyle="color: #999; margin-top: 8px;">{{ \'DASHBOARD-COMPLAINTS.NO_COMPANIES_WITH_CLOSED_COMMUNICATIONS\' | translate }}\n</span></div></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center" class="grey-100-bg">\n<md-button translate="GLOBAL.CLOSE" type="button" ng-click="vm.closeDialog()" class="md-raised md-accent" \naria-label="Close"></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/main/apps/dashboard-complaints/dialogs/view-item-list-dashboard-complaints.dialog/view-item-list-dashboard-complaints.dialog.html','<md-dialog id="view-item-list-dashboard-complaints" class="form-dialog" aria-label="Odds of occurence"><md-toolbar \nclass="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><h1 \nstyle="background: transparent;">{{ \'DASHBOARD.LIST\' | translate}} {{ \'DASHBOARD.\'+vm.type | translate}}</h1><div \nclass="absolute-right pr-10" layout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog" tranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></div></md-toolbar><md-dialog-content class="mediadialog-content" flex><div \nng-if="vm.type === \'COMPLAINTS\' || vm.type === \'DUE_TASKS\' || vm.type === \'FILES\'" class="complaints-bars-container">\n<div ng-repeat="item in vm.items" class="complaint-bar-item" ng-click="vm.selectItem(item)"><div class="bar-label"><div\n class="complaint-info"><div class="company-logo"><img ng-if="item.company.logo" ng-src="{{item.company.logo}}" \nalt="{{item.company.name}}" class="avatar avatar-dialog"><div ng-if="!item.company.logo" \nclass="avatar avatar-dialog small img">{{item.company.name.charAt(0).toUpperCase()}}</div></div><div \nclass="complaint-details"><div class="company-name">{{item.company.name}}</div><div class="complaint-title">\n{{item.title}}</div><div class="complaint-date">{{item.date | amDateFormat:\'DD MMM YYYY\'}}</div></div></div><span \nng-if="vm.isNewComplaints || vm.isInProcessComplaints || vm.isInvestigationComplaints || vm.isDueTasks || vm.isFiles" \nclass="bar-value">{{item.daysLabel}}</span></div><div \nng-if="vm.isNewComplaints || vm.isInProcessComplaints || vm.isInvestigationComplaints || vm.isDueTasks || vm.isFiles" \nclass="bar-container"><div class="bar-fill" \nstyle="width: {{item.daysPending / vm.maxDaysPending * 100}}%; background-color: {{item.color}};"></div></div></div>\n</div><md-list-item ng-if="vm.type !== \'COMPLAINTS\' && vm.type !== \'DUE_TASKS\' && vm.type !== \'FILES\'" \nng-class="{\'bb\' : vm.type !== \'ACTIVITIES\'}" ng-repeat="item in vm.items" ng-click="vm.selectItem(item)"><div \nng-if="vm.type !== \'ACTIVITIES\'" class="ph-25 pv-10" layout="column" fill-width><p class="grey-700-fg bold">\n{{item.title}}</p><p ng-if="item.description && vm.type !== \'COMPLAINTS\'" class="mt-0" \nng-class="{\'bold\': !item.title}" style="line-height: 1.1" ng-bind-html="item.description"></p><p class="grey-700-fg">\n{{item.date | amDateFormat:\'DD MMM YYYY\'}}</p><p class="grey-700-fg">{{item.company.name}} <span ng-if="item.branch">\n({{item.branch.name}})</span></p></div><div ng-if="vm.type == \'ACTIVITIES\'" id="timeline" \nclass="timeline-left ms-timeline"><div style="padding-top: 10px;padding-bottom: 10px;" class="ms-timeline-item" \nlayout="row" layout-align="start center"><div class="timeline-point md-accent-bg"><md-icon \nmd-font-icon="icon-telegram"></md-icon></div><h3 class="name mt-0 mb-0 ml-15" flex-xs="80"><div class="event">\n{{\'STAFF.\'+item.action_id.toUpperCase() | translate }} <a class="pointer" target="_blank">{{item.action_brief.name}}\n</a></div></h3><div class="timeline-detail" layout="row" layout-align="start center"><div class="time" \nng-bind-html="vm.timeAgo(item.date)"></div></div></div></div></md-list-item></md-dialog-content><md-dialog-actions \nlayout="row" layout-align="end center" class="grey-100-bg"><md-button translate="GLOBAL.ACCEPT" type="button" \nng-click="vm.closeDialog()" class="md-raised md-accent" aria-label="Cancel"></md-button></md-dialog-actions>\n</md-dialog>');
$templateCache.put('app/main/apps/clients-complaints/views/list/list-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="isLoading" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="no-threads" ng-if="!vm.companies" ng-hide="isLoading" translate="GLOBAL.NO_ITEMS"></div><div \nid="list-content-data" ng-style="{\'opacity\' : isLoading ? 0.5 : 1}"><div class="mail-list-item" \nng-repeat="company in vm.companies | filter: vm.search | filter: global.search" ng-init="parentIndex = $index" \nmd-no-ink ng-click="vm.openCompany(company, $event)" \nng-class="{\'starred\': company.starred, \'selected\': vm.selectedContentID !== client.id_mailing_content, \'checked\': vm.isChecked(company)}">\n<div layout="row" layout-align="start center"><md-checkbox class="no-label" ng-checked="vm.isSelected(company)" \nng-click="vm.toggleSelectThread(company, $event)" aria-label="{{vm.isSelected(company) ? \'Deselect\' : \'Select\'}}">\n</md-checkbox><div ng-if="company.logo[0] && storagePrefix" class="avatar-wrapper"><img md-menu-align-target \nclass="avatar" ng-src="{{storagePrefix}}{{company.logo[0].url}}"></div><div ng-if="!company.logo[0]" class="avatar" \nng-bind="company.name | capitalizeFirstLetter" ms-random-class="vm.colors"></div><div class="info layout-column flex" \nflex="" layout="column"><div class="name text-truncate" style="padding-bottom: 0px; padding-top: 0px;" layout="row" \nlayout-align="start center"><span>{{company.name}}</span> <span ng-if="company.is_owner == 1">\n({{ \'GLOBAL.OWNER\' | translate}})</span></div><div class="grey-500-fg text-truncate" layout="row" \nlayout-align="start center"><span>{{company.tax_id_number}}</span></div><div class="grey-500-fg text-truncate" \nlayout="row" layout-align="start center"><span>{{vm.getRegion(company.region_id)}}</span></div></div></div></div><div \nng-if="!isLoading && pagination_total_pages > pagination_page && vm.companies.length > 0" class="load-more white p-30" \nlayout="row" layout-sm="column" layout-align="center center" layout-wrap=""><md-button \nng-click="pagination_nextPage(true)" class="md-raised">{{\'GLOBAL.LOAD_MORE\' |\xA0translate}}</md-button></div><div \nng-if="pagination_total_pages == pagination_page && pagination_page > 1" class="load-more white p-30" layout="row" \nlayout-sm="column" layout-align="center center" layout-wrap=""><div class="message" translate="GLOBAL.NO_MORE_ITEMS">\n</div></div></div>');
$templateCache.put('app/main/apps/clients-complaints/views/list/nosplit-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.preview && !vm.readView" \nng-include="\'app/main/apps/clients-complaints/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" \nlayout="row"><div class="content thread-detail mail-read-pane p0" flex="" id="thread-detail" \nms-scroll="vm.msScrollOptions" ng-if="vm.preview" \nng-include="\'app/main/apps/clients-complaints/views/read/read-view-complaints.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="!vm.preview && !vm.readView" ng-include="\'app/main/apps/clients-complaints/views/list/list-view.html\'"></div>\n<div class="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="vm.readView && vm.showForm" ng-include="\'app/main/apps/clients-complaints/views/read/form.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="vm.readView && !vm.showForm" ng-include="\'app/main/apps/clients-complaints/views/read/question-form.html\'">\n</div></div>');
$templateCache.put('app/main/apps/clients-complaints/views/list/split-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.readView && !vm.preview" \nng-include="\'app/main/apps/clients-complaints/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" \nlayout="row"><div class="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" \nid="thread-list" ng-if="!vm.readView && !vm.preview" \nng-include="\'app/main/apps/clients-complaints/views/list/list-view.html\'"></div><div \nclass="content thread-detail mail-read-pane p0" flex="" id="thread-detail" ng-if="vm.preview" \nng-include="\'app/main/apps/clients-complaints/views/read/preview-company.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="vm.readView && !vm.preview && vm.showForm" ng-include="\'app/main/apps/clients-complaints/views/read/form.html\'">\n</div><div class="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" \nid="thread-list" ng-if="vm.readView && !vm.preview && !vm.showForm" \nng-include="\'app/main/apps/clients-complaints/views/read/question-form.html\'"></div></div>');
$templateCache.put('app/main/apps/clients-complaints/views/list/toolbar.html','<div layout="row" layout-align="start center"><md-checkbox class="no-label" \naria-label="{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}" \nng-checked="vm.selectedThreads.length > 0" ng-click="vm.toggleSelectThreads(vm.selectedThreads, vm.contents)">\n</md-checkbox><div ng-if="!vm.fromComplaint || vm.userLogued.user_type <= 2" class="divider-vertical" hide="" \nshow-gt-xs=""></div><md-button ng-if="!vm.fromComplaint || vm.userLogued.user_type <= 2" aria-label="NEW" \nclass="md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme" hide show-gt-sm \nng-click="vm.newForm($event)" translate="CLIENTS-COMPLAINTS.NEW" type="button"></md-button><md-button \nng-if="!vm.fromComplaint || vm.userLogued.user_type <= 2" aria-label="NEW" \nclass="md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme z-index-0" hide-gt-sm \nng-click="vm.newForm($event)" type="button"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="divider-vertical" hide="" show-gt-xs=""></div><div aria-hidden="false" \nclass="action-buttons hide show-gt-xs layout-align-start-center layout-row" layout="row" layout-align="start center" \nng-show="vm.selectedThreads.length > 0"><md-button ng-click="vm.deleteCompany($ev)" aria-label="Delete" \nclass="md-icon-button" hide="" show-gt-xs="" translate=""><md-icon md-font-icon="icon-delete"></md-icon><md-tooltip \nhide show-gt-xs><span translate="GLOBAL.REMOVE"></span></md-tooltip></md-button><div class="divider-vertical" hide="" \nshow-gt-xs=""></div></div><ms-search-bar debounce="300" model-search="$root.pagination_searchquery" \non-result-click="vm.searchResultClick(item)" on-search="vm.search(query)" layout="row" layout-align="start center">\n</ms-search-bar><md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" \ntranslate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nng-if="$root.pagination_searchquery==true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip \nhide show-gt-xs><span>Reset search</span></md-tooltip></md-button><div class="divider-vertical" hide="" show-gt-xs="">\n</div><md-menu hide="" show-gt-xs="" ng-if="refGroupables.length>0"><button aria-label="Filters" \nclass="md-icon-button" ng-click="$mdMenu.open($event)" show-gt-xs="" translate="" \ntranslate-attr-aria-label="GLOBAL.FILTERS"><md-icon md-font-icon="icon-chevron-down"><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.GROUP_BY">Group</span></md-tooltip></md-icon></button><md-menu-content width="4"><md-menu-item \nng-repeat="sortfield in refGroupables"><md-button aria-label="All" ng-click="pagination_setOrderBy(sortfield)"><div \nlayout="row" layout-align="space-between center"><span>Group by {{sortfield.name}} </span><i class="icon-check s16" \nng-if="sortfield.titleId == sortable.titleId"></i></div></md-button></md-menu-item><md-menu-divider ng-if="groupable">\n</md-menu-divider><md-menu-item ng-if="groupable"><md-button aria-label="Remove group" \nng-click="pagination_resetOrderBy()"><md-icon md-font-icon="icon-close "></md-icon><span>Remove order</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div><div layout="row" layout-align="start center" \ntranslate-attr-aria-label="GLOBAL.REFRESH"><span ng-if="!isLoading" class="page-info font-weight-500">\n{{vm.companies.length}} {{ \'GLOBAL.OF\' | translate}} {{pagination_totalItems}} {{ \'GLOBAL.ITEMS\' | translate}}.</span>\n<md-menu class="settings-menu" hide-gt-xs ng-show="vm.selectedThreads.length > 0"><md-button aria-label="Settings" \nclass="md-icon-button" ng-click="$mdMenu.open($event)" translate="GLOBAL.SETTINGS" \ntranslate-attr-aria-label="GLOBAL.SETTINGS"><md-icon md-font-icon="icon-dots-horizontal"></md-icon></md-button>\n<md-menu-content><md-menu-item ng-click="vm.deleteCompany($ev)" show="vm.selectedMail.length > 0 || vm.allChecked">\n<md-button ng-click="vm.massActions(\'delete\')" aria-label="Delete" translate-aria-label="GLOBAL.DELETE"><md-icon \nmd-font-icon="icon-delete"></md-icon><span translate="GLOBAL.DELETE">Delete</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div>');
$templateCache.put('app/main/apps/complaints/dialogs/embed-code-dialog/embed-code-dialog.html','<md-dialog id="embed-dialog" class="embed-dialog add-media"><md-toolbar class="md-accent"><div \nclass="md-toolbar-tools" layout="row" layout-align="space-between center"><h4 class="text-uppercase ml-20" \ntranslate="COMPLAINTS.EMBED_CODE"></h4><div class="absolute-right pr-10" layout="row"><md-button \nclass="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content flex class="content-card p-24" md-no-ink><md-content class="md-padding p0"><pre \nclass="m0 p-25">{{vm.text}}</pre></md-content></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="end center" class="grey-100-bg" ng-if="!vm.actionData.action.id"><md-button ng-click="vm.closeDialog()" \nclass="send-button md-accent md-raised" aria-label="CLOSE" translate="GLOBAL.CLOSE" \ntranslate-attr-aria-label="GLOBAL.CLOSE"></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/main/apps/complaints/dialogs/analyze-dialog/analyze-dialog.html','<md-dialog id="analyze-communication-dialog" class="analyze-communication-dialog stylish-dialog"><md-toolbar \nclass="md-accent stylish-toolbar"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><div \nclass="toolbar-title margin-left"><span class="ng-binding" translate="COMPLAINTS.ANALYZE_COMMUNICATION">Opciones</span>\n</div><md-button class="md-icon-button no-margin" ng-click="vm.closeDialog()" aria-label="Close dialog"><md-icon \nmd-font-icon="icon-close"></md-icon></md-button></div></md-toolbar><md-dialog-content layout="column" \nclass="dialog-content stylish-content"><div ng-if="!vm.isAnalyzing && !vm.result" class="intro-section"><p \nclass="intro-text">{{ \'COMPLAINTS.ANALYSIS_INTRO\' | translate }}</p><md-button \nclass="md-primary md-raised stylish-button" ng-click="vm.startAnalysis()">{{ \'COMPLAINTS.START_ANALYSIS\' | translate }}\n</md-button></div><div ng-if="vm.isAnalyzing" class="loading-section" layout="row" layout-align="center center">\n<md-progress-circular md-mode="indeterminate" class="md-accent stylish-loader"></md-progress-circular><p \nclass="loading-text">{{ \'COMPLAINTS.ANALYZING\' | translate }}</p></div><div ng-if="vm.result && !vm.result.error" \nclass="result-section"><p class="result-title"><strong>{{ \'COMPLAINTS.ANALYSIS_RESULT_MESSAGE\' | translate }}</strong>\n</p><p class="result-message">{{ vm.result.message }}</p><p class="result-title"><strong>\n{{ \'COMPLAINTS.ANALYSIS_SENTIMENT\' | translate }}</strong></p><div ng-if="!vm.isTyping" class="result-sentiment" \nng-bind-html="vm.result.sentiment"></div><div ng-if="vm.isTyping" class="result-sentiment" \nng-bind-html="vm.typingText"></div></div><div ng-if="vm.result && vm.result.error" class="error-section"><p \nclass="error-message">{{ vm.result.error }}</p></div></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="end center" class="stylish-actions"><md-button class="md-warn md-raised stylish-close" \nng-click="vm.closeDialog()">{{ \'GLOBAL.CLOSE\' | translate }}</md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/main/apps/complaints/dialogs/init-form-complaint/options-dialog.html','<md-dialog class="options-dialog" aria-label="New Task"><form name="taskForm" class="md-inline-form" novalidate>\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between"><h1 \nclass="title" translate="{{vm.title}}"></h1><md-button class="md-icon-button" ng-click="vm.closeDialog()"><md-icon \nmd-font-icon="icon-close" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div class="content"><md-input-container ng-if="vm.arrayName == \'datepickerOptions\'" class="md-block">\n<md-checkbox ng-model="vm.field.templateOptions.showWeeks"></md-checkbox><span translate="COMPLAINTS.SHOW_WEEKS">\n</span></md-input-container><div layout="row" layout-align="start"><md-input-container flex="50" flex-sm="100" \nclass="md-block"><label translate="COMPLAINTS.NAME"></label> <input ng-model="vm.option.name" type="text">\n</md-input-container><md-input-container flex="10" flex-sm="100" class="md-block"><md-button \nng-disabled="!vm.option.name" translate="COMPLAINTS.ADD" ng-class="{\'green-500-bg\': vm.option.name}" \nclass="md-accent md-raised md-button md-ink-ripple md-default-theme md-button show-gt-sm hide" \nng-click="vm.addOption(vm.option)"></md-button></md-input-container></div><table class="row-border hover simple" \nms-responsive-table><thead><tr><th><label translate="COMPLAINTS.NAME"></label></th><th ng-if="vm.isComplaintType"></th>\n<th ng-if="vm.isComplaintType" class="large"></th><th class="mini"></th></tr></thead><tbody dragula="\'bag-one\'" \ndragula-model="vm.field.templateOptions[vm.arrayName]" ng-if="!isEditing"><tr \nng-repeat="option in vm.field.templateOptions[vm.arrayName]" class="md-block structure"><td \nng-class="{ \'editing-mode\': isEditing }"><md-icon class="drag icon-equal md-default-theme material-icons" \naria-label="DRAG" style="margin-top: 6px;"></md-icon><span ng-hide="isEditing" title="{{ option.name }}">\n{{ option.name }}</span> <input ng-show="isEditing" type="text" ng-model="option.name" class="editing-input"></td><td \nng-if="vm.isComplaintType"><span style="display: inline-block;" ng-repeat="user in option.users track by $index" \nclass="avatar-wrapper"><img \nstyle="min-width: 25px;width: 25px;height: 25px;line-height: 25px; margin-right: 5px;margin-top: -5px;margin-bottom: -5px;" \nclass="avatar s24" ng-src="{{vm.showUserImage(user)}}" ng-if="user.files.id"><div \nstyle="min-width: 25px;width: 25px;height: 25px;line-height: 25px; margin-right: 5px;margin-top: 0px;margin-bottom: 0px;" \nclass="avatar s24" ms-random-class="vm.colors" ng-if="!user.files.id" \nng-bind="user.first_name | capitalizeFirstLetter"></div><div ng-click="option.users.splice($index, 1)" \nstyle="min-width: 25px;width: 25px;height: 25px;line-height: 25px; margin-right: 5px;;margin-top: 0px;margin-bottom: 0px;" \nclass="avatar s24 delete"><md-icon style="margin-top: -3px;" md-font-icon="icon-close"></md-icon><md-tooltip>\n{{user.email}}</md-tooltip></div></span></td><td class="large text-right add-emails" ng-if="vm.isComplaintType"><div>\n<md-button ng-if="vm.complaintPlan.plan_id >= 2" ng-click="vm.openDialogUsers($event, option)" \nclass="md-mini add-event-button no-sort md-fab md-warn block absolute-top-right" aria-label="Add email" translate>\n<md-icon md-font-icon="icon-plus"></md-icon><md-tooltip>{{\'COMPLAINTS.ADD_EMAILS\' | translate}}</md-tooltip>\n</md-button></div></td><td class="mini trash"><div style="display: inline-block; position: relative;"><md-icon \nng-click="isEditing = !isEditing" md-font-icon="{{ isEditing ? \'icon-check\' : \'icon-pencil\' }}"></md-icon><md-tooltip>\n<span translate="COMPLAINTS.EDIT">Edit</span></md-tooltip></div><span style="display: inline-block;"></span><div \nstyle="display: inline-block; position: relative;"><md-icon \nng-click="vm.field.templateOptions[vm.arrayName].splice($index, 1)" md-font-icon="icon-delete"></md-icon><md-tooltip>\n<span translate="COMPLAINTS.DELETE">Delete</span></md-tooltip></div></td></tr></tbody></table><div \nng-if="vm.field.templateOptions[vm.arrayName].length == 0" class="no-items-message" \ntranslate="COMPLAINTS.NO_ITEMS_OPTIONS"></div></div></md-dialog-content><md-dialog-actions layout="row" layout-="end">\n<md-input-container flex layout="row" layout-align="end center"><md-button type="submit" \nclass="send-button md-accent md-raised" ng-click="vm.saveDialog()" translate="COMPLAINTS.SAVE">SAVE</md-button>\n<md-button type="button" class="md-raised md-warn" ng-click="vm.closeDialog()" translate="COMPLAINTS.CANCEL">Cancel\n</md-button></md-input-container></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/complaints/dialogs/init-form-complaint/validations-dialog.html','<md-dialog class="validations-dialog" aria-label="New Task"><form name="taskForm" class="md-inline-form" novalidate>\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between"><h1 \nclass="title" translate="COMPLAINTS.VALIDATIONS"></h1><md-button class="md-icon-button" ng-click="vm.closeDialog()">\n<md-icon md-font-icon="icon-close" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><md-tabs ms-scroll="vm.msScrollOptions" class="scrollable"><md-tab><md-tab-label>\n{{ vm.translate(\'COMPLAINTS.VALIDATIONS\')}}</md-tab-label><md-tab-body><div class="content"><div class="m-10" \nlayout="row" layout-align="start"><md-input-container class="md-block" flex="30"><label \ntranslate="COMPLAINTS.MESSAGE_TYPE"></label><md-select ng-model="vm.validationObject.type"><md-option \nng-value="\'required\'" translate="COMPLAINTS.REQUIRED"></md-option><md-option ng-value="\'passwordStrength\'" \ntranslate="COMPLAINTS.PASSWORD_STRENGTH"></md-option><md-option ng-value="\'telVerify\'" \ntranslate="COMPLAINTS.TEL_VERIFY"></md-option><md-option ng-value="\'customVerify\'" \ntranslate="COMPLAINTS.CUSTOM_VERIFY"></md-option></md-select></md-input-container><md-input-container flex="55" \nflex-sm="100" class="md-block"><textarea ng-model="vm.validationObject.data" columns="1" rows="1"></textarea>\n</md-input-container><md-input-container flex="15" flex-sm="100" class="md-block"><md-button \nng-disabled="!vm.validationObject.type && !vm.validationObject.data" translate="COMPLAINTS.ADD" \nng-class="{\'green-500-bg\': vm.validationObject.data || vm.validationObject.type}" \nclass="md-accent md-raised md-button md-ink-ripple md-default-theme md-button show-gt-sm hide" \nng-click="vm.addValidation(vm.validationObject)"></md-button></md-input-container></div><table \nclass="row-border hover simple" ms-responsive-table><thead><tr><th class="large"><label \ntranslate="COMPLAINTS.VALIDATION"></label></th><th class="mini"></th><th class="mini"></th></tr></thead><tbody><tr \nng-repeat="(key,message) in vm.field.validation.messages"><td class="large"><span>{{ key }}</span></td><td \nclass="large"><span>{{ message.substring(2, message.length)}}</span></td><td class="mini trash"><md-icon \nng-click="vm.removeValidation(key)" md-font-icon="icon-delete"></md-icon><md-tooltip><span \ntranslate="COMPLAINTS.DELETE">Delete</span></md-tooltip></td></tr></tbody></table><div \nng-if="!vm.field.validation || vm.field.validation.messages.length == 0" class="no-items-message" \ntranslate="COMPLAINTS.NO_ITEMS_VALIDATIONS"></div></div></md-tab-body></md-tab><md-tab><md-tab-label>\n{{ vm.translate(\'COMPLAINTS.VALIDATORS\')}}</md-tab-label><md-tab-body><div class="content"><div class="m-10" \nlayout="row" layout-align="start"><md-input-container class="md-block" flex="30"><label \ntranslate="COMPLAINTS.MESSAGE_TYPE"></label><md-select ng-model="vm.validatorObject.type"><md-option \nng-value="\'passwordStrength\'" translate="COMPLAINTS.PASSWORD_STRENGTH"></md-option><md-option ng-value="\'slugCheck\'" \ntranslate="COMPLAINTS.SLUG_CHECK"></md-option><md-option ng-value="\'customVerify\'" \ntranslate="COMPLAINTS.CUSTOM_VERIFY"></md-option></md-select></md-input-container><md-input-container flex="55" \nflex-sm="100" class="md-block"><textarea ng-model="vm.validatorObject.data" columns="1" rows="1"></textarea>\n</md-input-container><md-input-container flex="15" flex-sm="100" class="md-block"><md-button \nng-disabled="!vm.validatorObject.type && !vm.validatorObject.data" translate="COMPLAINTS.ADD" \nng-class="{\'green-500-bg\': vm.validatorObject.data || vm.validatorObject.type}" \nclass="md-accent md-raised md-button md-ink-ripple md-default-theme md-button show-gt-sm hide" \nng-click="vm.addValidator(vm.validatorObject)"></md-button></md-input-container></div>{{vm.field.validators | json}}\n<table class="row-border hover simple" ms-responsive-table><thead><tr><th><label translate="COMPLAINTS.VALIDATORS">\n</label></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="(key,message) in vm.field.validators"><td \nclass="large"><span>{{ key }}</span></td><td class="large"><span>{{ message.substring(2, message.length)}}</span></td>\n<td class="mini trash"><md-icon ng-click="vm.removeValidator(key)" md-font-icon="icon-delete"></md-icon><md-tooltip>\n<span translate="COMPLAINTS.DELETE">Delete</span></md-tooltip></td></tr></tbody></table><div \nng-if="!vm.field.validators" class="no-items-message" translate="COMPLAINTS.NO_ITEMS_VALIDATORS"></div></div>\n</md-tab-body></md-tab></md-tabs></md-dialog-content><md-dialog-actions layout="row" layout-="end"><md-input-container \nflex layout="row" layout-align="end center"><md-button type="submit" class="send-button md-accent md-raised" \nng-click="vm.saveDialog()" translate="COMPLAINTS.SAVE">SAVE</md-button><md-button type="button" \nclass="md-raised md-warn" ng-click="vm.closeDialog()" translate="COMPLAINTS.CANCEL">Cancel</md-button>\n</md-input-container></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/complaints/dialogs/new-report-dialog/new-report-dialog.html','<md-dialog id="new-complaint-dialog" class="form-dialog add-media"><md-toolbar class="md-accent md-hue-2"><div \nclass="md-toolbar-tools" layout="row" layout-align="space-between center"><div layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-file-document" class="s24 mr-15 ml-15"></md-icon><h3 \nclass="text-uppercase" translate="COMPLAINTS.NEW_REPORT"></h3></div><div class="absolute-right pr-10" layout="row">\n<md-button class="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" \ntranslate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</md-toolbar><div class="dialog-content"><div fill-width layout="column" class="p-24"><div \nclass="form-wrapper md-whiteframe-2dp p-24 mb-24" flex="100"><form name="vm.basicForm" class="md-inline-form" \nnovalidate><div><md-input-container class="md-block"><label translate="COMPLAINTS.NAME"></label> <input required \ntype="text" required name="title" ng-model="vm.newReport.title"></md-input-container></div></form></div><div \nclass="section-header mb-24" layout="row" layout-align="center center"><div layout="row" layout-align="start center">\n<md-icon md-font-icon="icon-clipboard-text" class="s24 mr-15 grey-700-fg"></md-icon><h2 class="title grey-700-fg" \ntranslate="COMPLAINTS.REPORT_DATA">Datos del informe</h2></div></div><form name="vm.reportDataForm" \nclass="md-inline-form" novalidate><div class="options-container"><div class="option-item" layout="row" \nlayout-align="start center"><md-input-container flex><md-checkbox class="no-label" \nng-model="vm.newReport.config_data.data.active" \naria-label="{{vm.newReport.config_data.data.active ? \'Deselect\' : \'Select\'}}"><div layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-file" class="s20 mr-15 grey-700-fg"></md-icon><span \nclass="grey-700-fg">{{\'COMPLAINTS.DATA\' | translate}}</span></div></md-checkbox></md-input-container></div><div \nclass="option-item" layout="row" layout-align="start center"><md-input-container flex><md-checkbox class="no-label" \nng-model="vm.newReport.config_data.messages.active" \naria-label="{{vm.newReport.config_data.messages.active ? \'Deselect\' : \'Select\'}}"><div layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-message-text" class="s20 mr-15 grey-700-fg"></md-icon><span \nclass="grey-700-fg">{{\'COMPLAINTS.MESSAGES\' | translate}}</span></div></md-checkbox></md-input-container></div><div \nclass="option-item" layout="row" layout-align="start center"><md-input-container flex><md-checkbox class="no-label" \nng-model="vm.newReport.config_data.actions.active" \naria-label="{{vm.newReport.config_data.actions.active ? \'Deselect\' : \'Select\'}}"><div layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-checkbox-marked" class="s20 mr-15 grey-700-fg"></md-icon><span \nclass="grey-700-fg">{{\'COMPLAINTS.ACTIONS\' | translate}}</span></div></md-checkbox></md-input-container></div><div \nclass="option-item" layout="row" layout-align="start center"><md-input-container flex><md-checkbox class="no-label" \nng-model="vm.newReport.config_data.tasks.active" \naria-label="{{vm.newReport.config_data.tasks.active ? \'Deselect\' : \'Select\'}}"><div layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-checkbox-marked-circle-outline" class="s20 mr-15 grey-700-fg">\n</md-icon><span class="grey-700-fg">{{\'COMPLAINTS.TASKS\' | translate}}</span></div></md-checkbox></md-input-container>\n</div><div class="option-item" layout="row" layout-align="start center"><md-input-container flex><md-checkbox \nclass="no-label" ng-model="vm.newReport.config_data.files.active" \naria-label="{{vm.newReport.config_data.files.active ? \'Deselect\' : \'Select\'}}"><div layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-file-document" class="s20 mr-15 grey-700-fg"></md-icon><span \nclass="grey-700-fg">{{\'COMPLAINTS.DOCUMENTS\' | translate}}</span></div></md-checkbox></md-input-container></div></div>\n</form></div><md-dialog-actions layout="row" layout-align="end center" class="grey-100-bg p-16"><md-button \nng-if="!vm.showForm" ng-click="vm.sendReport()" class="md-accent md-raised" translate="COMPLAINTS.GENERATE" \nng-disabled="!vm.newReport.title"><md-icon md-font-icon="icon-check" class="mr-10"></md-icon></md-button><md-button \nng-if="vm.showForm" ng-click="vm.closeDialog(true)" class="md-accent md-raised" translate="GLOBAL.CLOSE"><md-icon \nmd-font-icon="icon-close" class="mr-10"></md-icon></md-button></md-dialog-actions></div></md-dialog>');
$templateCache.put('app/main/apps/complaints/dialogs/select-lang-dialog /select-lang-dialog.html','<md-dialog id="embed-dialog" class="embed-dialog add-media"><md-toolbar class="md-accent"><div \nclass="md-toolbar-tools" layout="row" layout-align="space-between center"><h4 class="text-uppercase ml-20" \ntranslate="COMPLAINTS.EMBED_CODE"></h4><div class="absolute-right pr-10" layout="row"><md-button \nclass="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content flex class="content-card p-24" md-no-ink><md-content class="md-padding p0"><pre \nclass="m0 p-25">{{vm.text}}</pre></md-content></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="end center" class="grey-100-bg" ng-if="!vm.actionData.action.id"><md-button ng-click="vm.closeDialog()" \nclass="send-button md-accent md-raised" aria-label="CLOSE" translate="GLOBAL.CLOSE" \ntranslate-attr-aria-label="GLOBAL.CLOSE"></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/main/apps/complaints/dialogs/new-complaint-dialog/new-complaint-dialog.html','<md-dialog id="new-complaint-dialog" class="new-complaint-dialog add-media"><md-toolbar class="md-accent"><div \nclass="md-toolbar-tools" layout="row" layout-align="space-between center"><h4 class="text-uppercase ml-20" \ntranslate="COMPLAINTS.NEW_COMPLAINT"></h4><div class="absolute-right pr-10" layout="row"><md-button \nclass="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content flex class="content-card p-24" md-no-ink><md-content ng-if="!vm.showForm" \nclass="md-padding"><md-input-container class="md-block" flex><label>{{ \'COMPLAINTS.COMUNICATION_TYPE\' | translate }}\n</label><md-select ng-model="vm.type" placeholder="Category"><md-option value="1" selected="selected">\n{{ \'COMPLAINTS.TELEMATICA\' | translate }}</md-option><md-option value="2">{{ \'COMPLAINTS.PHONE\' | translate }}\n</md-option><md-option value="3">{{ \'COMPLAINTS.EMAIL\' | translate }}</md-option><md-option value="4">\n{{ \'COMPLAINTS.PRESENCIAL\' | translate }}</md-option><md-option value="5">{{ \'COMPLAINTS.FAX\' | translate }}\n</md-option></md-select><div class="md-errors-spacer"></div></md-input-container><md-input-container class="md-block" \nflex><label>{{\'COMPLAINTS.FORM\' |translate}}</label><md-select ng-model="vm.formSelected" \nplaceholder="{{\'FORM.FORM\' |translate}}"><md-option ng-repeat="form in vm.forms" ng-value="form" selected="selected">\n<md-icon style="margin-right: 5px;" md-svg-src="assets/angular-material-assets/img/icons/spain.svg" \nng-if="form.language_code.startsWith(\'es\')" aria-label="Spain"></md-icon><md-icon style="margin-right: 5px;" \nmd-svg-src="assets/angular-material-assets/img/icons/portuguese.svg" ng-if="form.language_code.startsWith(\'pt\')" \naria-label="Portuguese"></md-icon><md-icon style="margin-right: 5px;" \nmd-svg-src="assets/angular-material-assets/img/icons/germany.svg" ng-if="form.language_code.startsWith(\'de\')" \naria-label="Germany"></md-icon><md-icon style="margin-right: 5px;" \nmd-svg-src="assets/angular-material-assets/img/icons/united_kingdom.svg" ng-if="form.language_code.startsWith(\'en\')" \naria-label="United Kingdom"></md-icon><md-icon style="margin-right: 5px;" \nmd-svg-src="assets/angular-material-assets/img/icons/catalonia.svg" ng-if="form.language_code.startsWith(\'ca\')" \naria-label="Catalonia"></md-icon><md-icon style="margin-right: 5px;" \nmd-svg-src="assets/angular-material-assets/img/icons/euskera.svg" ng-if="form.language_code.startsWith(\'eu\')" \naria-label="Euskera"></md-icon><md-icon style="margin-right: 5px;" \nmd-svg-src="assets/angular-material-assets/img/icons/france.svg" ng-if="form.language_code.startsWith(\'fr\')" \naria-label="France"></md-icon><md-icon style="margin-right: 5px;" \nmd-svg-src="assets/angular-material-assets/img/icons/gallego.svg" ng-if="form.language_code.startsWith(\'gl\')" \naria-label="Gallego"></md-icon><md-icon style="margin-right: 5px;" \nmd-svg-src="assets/angular-material-assets/img/icons/italy.svg" ng-if="form.language_code.startsWith(\'it\')" \naria-label="Italy"></md-icon>{{form.name}}</md-option></md-select><div class="md-errors-spacer"></div>\n</md-input-container></md-content><md-content ng-if="vm.showForm" class="p0"><iframe id="iframe" \nstyle="width: 100%;height: 60vh; z-index: 2;" flex="100" ng-src="{{vm.urlForm}}" frameborder="0"></iframe></md-content>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="end center" class="grey-100-bg" \nng-if="!vm.actionData.action.id"><md-button ng-if="!vm.showForm" ng-click="vm.next()" \nclass="send-button md-accent md-raised" translate="GLOBAL.NEXT"></md-button><md-button ng-if="vm.showForm" \nng-click="vm.closeDialog(true)" class="send-button md-accent md-raised" translate="GLOBAL.CLOSE"></md-button>\n</md-dialog-actions></md-dialog>');
$templateCache.put('app/main/apps/complaints/dialogs/new-complaint-dialog/open-options-complaint.html','<md-dialog id="open-options-complaint" class="new-complaint-dialog add-media"><md-toolbar class="md-accent"><div \nclass="toolbar-title"><span>{{ \'COMPLAINTS.TITLE_COMPLAINT_OPTION\' | translate }}</span></div><div \nstyle="position: relative; height: 100%; width: 100%;"><button \nclass="md-icon-button md-button md-ink-ripple md-default-theme close-button" type="button" ng-click="hide()"><md-icon \nmd-font-icon="icon-close" aria-label="Close dialog" \nclass="ng-scope md-font material-icons icon-close md-default-theme" role="img"></md-icon><div \nclass="md-ripple-container"></div></button></div></md-toolbar><md-dialog-content flex class="content-card p-24" \nmd-no-ink><md-content ng-if="!vm.showForm" class="md-padding"><md-input-container class="m-0"><div \nng-repeat="v in [0]"><md-input-container ng-if="vm.complaintSelected" class="select-type-formComplaint"><div \nclass="fullwidth mb-15"><label class="title-complaint-option">{{ \'COMPLAINTS.COMPLAINT_TYPE\' | translate }}:</label>\n<div class="select-container"><md-select ng-model="vm.complaintSelected.complaint_type" \nclass="md-no-underline custom-font-size select-width"><md-option \nng-repeat="option in (vm.complaintSelected.form.fields | filter:{key: \'complaint_type\'})[0].templateOptions.options" \nng-value="option.value">{{ option.name }}</md-option></md-select></div></div></md-input-container><md-input-container \nclass="hash" ng-if="vm.companySelected.company_type == 4"><label>Hash</label> <input \nng-model="vm.complaintSelected.hash"></md-input-container></div></md-input-container><div class="fullwidth mb-15">\n<label class="title-complaint-assigned-users ng-binding">{{ \'COMPLAINTS.ASSIGNED_USERS\' | translate }}:</label><div \nlayout="row" layout-align="start center" class="layout-row"><div flex ng-if="vm.complaintSelected.users.length > 0" \nclass="users-container layout-row layout-align-start center"><div ng-repeat="user in vm.complaintSelected.users" \nclass="avatar-wrapper" style="position: relative; margin-right: 10px;"><md-tooltip md-direction="top">\n{{vm.userDetails[user].email || \'Correo electr\xF3nico no disponible\'}}</md-tooltip><img ng-if="vm.showUserImage(user)" \nng-src="{{vm.showUserImage(user)}}" alt="User Image" style="border-radius: 50%; width: 45px; height: 45px;"><div \nng-if="!vm.showUserImage(user)" class="avatar-initials" \nstyle="border-radius: 50%; width: 45px; height: 45px; display: flex; align-items: center; justify-content: center; font-size: 18px; color: white;" \nng-style="{\'background-color\': vm.userDetails[user].color}">{{vm.userDetails[user].first_name.charAt(0)}}</div><div \nclass="remove-user" ng-click="vm.complaintSelected.users.splice($index, 1)" \nstyle="position: absolute; top: -10px; right: -10px; cursor: pointer;"><span class="remove-icon">x</span></div></div>\n</div><div class="text-right add-emails" flex="none"><md-button \nng-click="vm.openDialogUsers($event, vm.complaintSelected)" \nclass="md-mini add-event-button no-sort md-fab md-warn block" aria-label="Add email" translate><md-icon \nmd-font-icon="icon-plus"></md-icon><md-tooltip>{{\'COMPLAINTS.SELECT_USER\' | translate}}</md-tooltip></md-button></div>\n</div></div><div class="fullwidth mb-15"><label class="title-complaint-assigned-users">\n{{ \'COMPLAINTS.BLOCKED_USERS\' | translate }}:</label><div layout="row" layout-align="start center" class="layout-row">\n<div flex ng-if="vm.complaintSelected.blocked_users && vm.complaintSelected.blocked_users.length > 0" \nclass="users-container layout-row layout-align-start center"><div \nng-repeat="user in vm.complaintSelected.blocked_users" class="avatar-wrapper" \nstyle="position: relative; margin-right: 10px;" ng-if="vm.userDetails[user]"><md-tooltip md-direction="top">\n{{vm.userDetails[user].email || \'Correo electr\xF3nico no disponible\'}}</md-tooltip><img ng-if="vm.showUserImage(user)" \nng-src="{{vm.showUserImage(user)}}" alt="User Image" style="border-radius: 50%; width: 45px; height: 45px;"><div \nng-if="!vm.showUserImage(user)" class="avatar-initials" \nstyle="border-radius: 50%; width: 45px; height: 45px; display: flex; align-items: center; justify-content: center; font-size: 18px; color: white;" \nng-style="{\'background-color\': vm.userDetails[user].color}">{{vm.userDetails[user].first_name.charAt(0)}}</div><div \nclass="remove-user" ng-click="vm.complaintSelected.blocked_users.splice($index, 1)" \nstyle="position: absolute; top: -10px; right: -10px; cursor: pointer;"><span class="remove-icon">x</span></div></div>\n</div><div class="text-right add-emails" flex="none"><md-button \nng-click="vm.openDialogBlockedUsers($event, vm.complaintSelected)" \nclass="md-mini add-event-button no-sort md-fab md-warn block" aria-label="Add blocked user" translate><md-icon \nmd-font-icon="icon-plus"></md-icon><md-tooltip>{{\'COMPLAINTS.SELECT_USER\' | translate}}</md-tooltip></md-button></div>\n</div></div></md-content></md-dialog-content><md-dialog-actions><md-button ng-click="answer(\'save\')" \nclass="send-button md-accent md-raised" ng-disabled="vm.basicForm.$invalid || vm.basicForm.$pristine">\n{{ \'COMPLAINTS.SAVE\' | translate }}</md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/main/apps/complaints/dialogs/select-user-dialog/select-user-dialog.html','<md-dialog id="select-user-dialog" class="select-user-dialog add-media"><md-toolbar class="md-accent"><div \nclass="md-toolbar-tools" layout="row" layout-align="space-between center"><h4 class="text-uppercase ml-20" \ntranslate="COMPLAINTS.SELECT_USER"></h4><div class="absolute-right pr-10" layout="row"><md-button \nclass="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content flex class="content-card p-24" md-no-ink><md-content><div style="height: 500px;" \nng-include="\'app/main/apps/clients/dialogs/forms/existing-user.html\'"></div></md-content></md-dialog-content>\n<md-dialog-actions layout="row" layout-align="end center" class="grey-100-bg"><md-button \nng-click="vm.closeDialog(true)" class="send-button md-accent md-raised" translate="GLOBAL.CLOSE"></md-button>\n</md-dialog-actions></md-dialog>');
$templateCache.put('app/main/apps/complaints/views/edit/edit-view.html','<div class="content thread-detail" layout="row" layout-align="center center" flex ng-if="vm.loadingReadPane"><div flex \nlayout="column" layout-align="center center" class="loading-container"><md-progress-circular md-mode="indeterminate" \nmd-diameter="50"></md-progress-circular></div></div><div class="content thread-detail" layout="row" \nlayout-align="center center" flex ng-if="!vm.complaintSelected && !vm.complaintNew && !vm.loadingReadPane"><div \nclass="no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-clipboard-account" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="COMPLAINTS.SELECT_COMPLAINT"></span></div></div><div ng-show="!vm.loadingReadPane" flex><div \nclass="toolbar grey-100-bg colored-bg complaint-main-toolbar" layout="row" layout-align="space-between center" \nng-if="vm.complaintSelected || vm.complaintNew" scroll=""><div layout="row" layout-align="start center"><md-button \nclass="md-icon-button close-thread" aria-label="Back" ng-click="vm.closeComplaint()" translate \ntranslate-attr-aria-label="COMPLAINTS.BACK" \nng-if="(vm.complaintSelected || vm.complaintNew) && vm.currentView==\'nosplit\'"><md-icon \nmd-font-icon="icon-keyboard-backspace"></md-icon></md-button><div class="toolbar-case-number" \nng-if="vm.complaintSelected" layout="row" layout-align="start center"><input type="text" \nclass="toolbar-case-number-input" ng-model="vm.complaintSelected.case_number" ng-readonly="!vm.caseNumberEditing" \nng-click="vm.startEditCaseNumber()" ng-blur="vm.caseNumberEditing = false" ng-change="vm.onCaseNumberChange()" \nmaxlength="32" placeholder="{{ \'COMPLAINTS.CASE_NUMBER\' | translate }}" autocomplete="off"></div></div><div \nlayout="row" layout-align="end center" ng-if="vm.complaintSelected || vm.complaintNew" hide show-gt-sm><button \nclass="md-icon-button md-button ng-scope md-default-theme" type="button" ng-click="vm.openOptionsComplaint($event)" \naria-label="Ajustes" translate="" translate-attr-aria-label="USERS.SETTINGS" \nng-class="{\'tab-selected\': vm.tabActive==\'options\'}"><md-icon md-font-icon="icon-cog" \nclass="md-font material-icons icon-cog" role="img" aria-hidden="true"></md-icon></button><md-button \nng-if="vm.companySelected.company_type == 4" ng-show="vm.selectedIndex == 0" ng-click="toggleEditing()" \nng-disabled="editingEnabled" class="md-primary md-raised md-hue-1" aria-label="report" translate="COMPLAINTS.EDIT" \ntranslate-attr-aria-label="COMPLAINTS.EDIT">EDIT</md-button><md-button \nng-if="vm.userLogued.user_type < 4 || vm.userLogued.user_type == 14" ng-click="vm.newReport()" \nclass="md-warn md-raised md-hue-1 green" aria-label="report" translate="COMPLAINTS.REPORT" \ntranslate-attr-aria-label="COMPLAINTS.REPORT">REPORT</md-button><md-button type="submit" ng-click="vm.saveComplaint()" \nclass="send-button md-accent md-raised" ng-disabled="vm.basicForm.$invalid || vm.basicForm.$pristine" \naria-label="SAVE" translate="COMPLAINTS.SAVE" translate-attr-aria-label="COMPLAINTS.SAVE">SAVE</md-button><md-button \ntype="button" ng-click="vm.closeComplaint()" class="md-raised md-warn" aria-label="Cancel" \ntranslate="COMPLAINTS.CANCEL" translate-attr-aria-label="COMPLAINTS.CANCEL">Cancel</md-button></div><div layout="row" \nlayout-align="end center" ng-if="vm.complaintSelected || vm.complaintNew" hide-gt-sm><md-button type="button" \nclass="md-icon-button" ng-click="vm.openOptionsComplaint($event)" aria-label="Settings" \ntranslate-attr-aria-label="USERS.SETTINGS" ng-class="{\'tab-selected\': vm.tabActive==\'options\'}"><md-icon \nmd-font-icon="icon-cog"></md-icon></md-button><md-button \nng-if="vm.userLogued.user_type < 4 || vm.userLogued.user_type == 14" type="button" class="md-icon-button" \nng-click="vm.newReport()" aria-label="Report" translate-attr-aria-label="COMPLAINTS.REPORT"><md-icon \nmd-font-icon="icon-file-document"></md-icon></md-button><md-button type="submit" ng-click="vm.saveComplaint()" \nclass="md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" \nng-disabled="vm.basicForm.$invalid || vm.basicForm.$pristine" aria-label="SAVE"><md-icon md-font-icon="icon-check" \nng-hide="vm.savingProcess"></md-icon><md-progress-circular md-mode="indeterminate" ng-if="vm.savingProcess">\n</md-progress-circular><md-tooltip hide show-gt-sm><span translate="COMPLAINTS.SAVE">Save</span></md-tooltip>\n</md-button><md-button type="button" ng-click="vm.closeComplaint()" \nclass="md-warn md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" aria-label="Cancel"><md-icon \nmd-font-icon="icon-window-close"></md-icon><md-tooltip hide show-gt-sm><span translate="COMPLAINTS.CANCEL">Cancel\n</span></md-tooltip></md-button></div></div><form name="vm.basicForm" class="md-inline-form" novalidate \nng-if="vm.complaintSelected || vm.complaintNew"><div class="mail-content file-details"><div \nclass="process-flow-wrapper" ng-if="vm.complaintSelected"><svg width="0" height="0" aria-hidden="true" \nclass="process-flow-clip-defs"><defs><clipPath id="process-last-rounded" clipPathUnits="objectBoundingBox"><path \nd="M 0.04 0.5 L 0 0 L 0.92 0 A 0.08 0.08 0 0 1 1 0.08 L 1 0.92 A 0.08 0.08 0 0 1 0.92 1 L 0 1 Z"/></clipPath></defs>\n</svg><div class="process-flow-title">{{ \'COMPLAINTS.MANAGEMENT_PROCESS\' | translate }}</div><div \nclass="process-flow-steps" layout="row" layout-align="start center"><div \nng-repeat="step in vm.processSteps track by step.id" class="process-step {{ step.colorClass }}" \nng-class="{\'process-step-active\': vm.complaintSelected.status === step.id, \'process-step-inactive\': vm.complaintSelected.status !== step.id}">\n<div class="process-step-segment" layout="row" layout-align="center center"><md-icon md-font-icon="{{ step.icon }}" \nclass="process-step-icon"></md-icon></div></div></div></div><md-list-item class="main-item mb-15"><div \nclass="main-read"><div layout="row" layout-align="start center"><h1>{{ \'COMPLAINTS.EXPEDIENTES\' | translate }}\n<md-input-container class="md-block"><script>\nfunction activateTextarea() {\n                        var textarea = document.getElementById("myTextarea");\n                        textarea.disabled = false;\n                        textarea.focus();\n                                }\n</script><style>.icon-pencil:hover {\n    cursor: pointer;\n  }</style><textarea id="myTextarea" cols="50" \nng-model="vm.complaintSelected.subject" disabled="disabled"></textarea><md-icon md-font-icon="icon-pencil" \nclass="ng-scope md-default-theme md-font material-icons icon-pencil" role="img" aria-hidden="true" \nonclick="activateTextarea()"></md-icon></md-input-container></h1></div><div layout="row" layout-align="start center">\n<md-input-container class="m-0"><label translate="COMPLAINTS.PRIORITY"></label><md-select \nclass="priority-select no-border-select" ng-model="vm.complaintSelected.priority"><md-option \nng-repeat="priority in vm.priorities" ng-value="{{priority.id}}"><span ng-if="priority.id == 0" \nclass="dot small green"></span> <span ng-if="priority.id == 1" class="dot small yellow"></span> <span \nng-if="priority.id == 2" class="dot small orange"></span> <span ng-if="priority.id == 3" class="dot small red"></span> \n<span ng-if="priority.id == 0" class="ml-5" translate="COMPLAINTS.LOW"></span> <span ng-if="priority.id == 1" \nclass="ml-5" translate="COMPLAINTS.MEDIUM"></span> <span ng-if="priority.id == 2" class="ml-5" \ntranslate="COMPLAINTS.HIGH"></span> <span ng-if="priority.id == 3" class="ml-5" translate="COMPLAINTS.CRITICAL"></span>\n</md-option></md-select></md-input-container><md-input-container class="m-0"><label translate="COMPLAINTS.STATUS">\n</label><md-select class="status-select no-border-select" ng-model="vm.complaintSelected.status"><md-option \nng-repeat="step in vm.processSteps" ng-value="step.id"><div class="status-option-pill {{ step.colorClass }}" \nlayout="row" layout-align="center center"><md-icon md-font-icon="{{ step.icon }}" class="status-option-icon"></md-icon>\n<span class="status-option-label" translate="{{ step.labelKey }}"></span></div></md-option></md-select>\n</md-input-container><md-input-container class="m-0"><div ng-repeat="v in [0]"><md-checkbox \nng-model="vm.complaintSelected.anonymised" ng-true-value="1" ng-false-value="0" ng-change="confirmAnonymised($event)" \nng-disabled="vm.complaintSelected.anonymised === 1">\n{{ vm.complaintSelected.anonymised === 1 ? (\'COMPLAINTS.ANONYMISED_1\' | translate) : (\'COMPLAINTS.ANONYMISED_0\' | translate) }}\n</md-checkbox></div></md-input-container></div></div></md-list-item><md-tabs md-selected="vm.selectedIndex" \nclass="tabs-complaints" md-dynamic-height flex><md-tab label="{{ \'COMPLAINTS.DATA\' | translate }}"><div layout="row" \nng-include="\'app/main/apps/complaints/views/edit/tabs/datos.html\'"></div></md-tab><md-tab \nng-if="vm.complaintPlan.plan_id >= 2 " label="{{ \'COMPLAINTS.MESSAGES\' | translate }}"><div layout="row" \nng-include="\'app/main/apps/complaints/views/edit/tabs/mensajes.html\'"></div></md-tab><md-tab \nlabel="{{ \'COMPLAINTS.ACCTIONS\' | translate }}"><div layout="row" \nng-include="\'app/main/apps/complaints/views/edit/tabs/acciones.html\'"></div></md-tab><md-tab \nng-if="vm.complaintPlan.plan_id >= 2" label="{{ \'COMPLAINTS.TASKS\' | translate }}"><div layout="row" \nng-include="\'app/main/apps/complaints/views/edit/tabs/tareas.html\'"></div></md-tab><md-tab \nng-if="vm.complaintPlan.plan_id >= 2" label="{{ \'COMPLAINTS.DOCUMENTS\' | translate }}"><div layout="row" \nng-include="\'app/main/apps/complaints/views/edit/tabs/documentos.html\'"></div></md-tab></md-tabs></div></form></div>\n<link rel="stylesheet" \nhref="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0">');
$templateCache.put('app/main/apps/complaints/views/list/form-init.html','<md-list-item class="md-toolbar-tools grey-100-bg"><h3 class="grey-700-fg">{{\'COMPLAINTS.FORM\' |translate}}</h3>\n<md-divider></md-divider></md-list-item><div class="ph-15"><md-input-container style="margin-top: 30px;" \nclass="md-block"><label translate="COMPLAINTS.TITLE_FORM"></label> <input \nng-model="vm.complaintFormDefault.config.main_title" type="text"></md-input-container><md-input-container \nstyle="margin-top: 50px;" class="md-block"><label style="margin-bottom: 30px;" translate="COMPLAINTS.DESCRIPTION_FORM">\n</label> <textarea ui-tinymce="vm.tinymceOptions" ng-model="vm.complaintFormDefault.config.text" columns="1" rows="4">\n</textarea></md-input-container><md-input-container class="md-block"><label \ntranslate="COMPLAINTS.SUCCESS_FORM_MESSAGE"></label> <textarea \nng-model="vm.complaintFormDefault.config.success_message" md-select-on-focus columns="1" rows="3"></textarea>\n</md-input-container></div><md-list dragula="\'dragbag\'" dragula-model="vm.complaintFormDefault.fields" class="">\n<md-list-item ng-show="field.type !== \'media_footer\' && field.type !== \'media_header\' && field.type !== \'hidden\'" \nng-repeat="field in vm.complaintFormDefault.fields track by $index" class="md-block structure" \nng-class="(!field.temporary && !field.editing) ? \'md-block structure\' : \'structure-edited\'"><div layout="column" \nlayout-align="center space-between" flex><div \nng-include="\'app/main/apps/complaints/views/edit/editors/editors-view.html\'"></div><div \nng-include="\'app/main/apps/complaints/views/edit/editors/editors-editing.html\'"></div></div><md-divider \nclass="md-default-theme"></md-divider></md-list-item></md-list><md-list-item class="mb-100"><md-button \nng-if="vm.complaintPlan.plan_id >= 2" ng-click="vm.addNewStructureField()" \nclass="ml-auto mt-25 add-event-button md-fab md-warn" aria-label="ADD"><md-icon md-font-icon="icon-plus"></md-icon>\n</md-button></md-list-item>');
$templateCache.put('app/main/apps/complaints/views/list/init-complaint-canal.html','<div layout="row" flex><div ng-include="\'app/main/apps/complaints/views/list/form-init.html\'" \nstyle="max-height: 100%;overflow: auto;" class="br" layout="column" flex="50"></div><div style="position: relative;" \nlayout="column" flex="50"><md-list-item style="max-height: 47px;" class="md-toolbar-tools grey-100-bg"><h3 \nclass="grey-700-fg">Previsualizaci\xF3n</h3><md-divider></md-divider></md-list-item><div \nstyle="max-height: 100%;overflow: auto;"><div ng-include="\'app/main/apps/complaints/views/edit/editors/preview.html\'">\n</div></div><md-list-item style="z-index: 9;" class="finish-init-form"><md-button ng-if="!vm.editingComplaintForm" \ntranslate="COMPLAINTS.FINISH" \nclass="md-accent green-500-bg md-raised md-button md-ink-ripple md-default-theme md-button" \nng-click="vm.finishInitComplaintForm()"></md-button><md-button ng-if="vm.editingComplaintForm" \ntranslate="COMPLAINTS.SAVE" \nclass="md-accent green-500-bg md-raised md-button md-ink-ripple md-default-theme md-button" \nng-click="vm.updateComplaintCanal()"></md-button></md-list-item></div></div>');
$templateCache.put('app/main/apps/complaints/views/list/language-selector.html','<div class="content thread-detail" layout="row" layout-align="center center" flex><div class="no-questionnaire" \nlayout="column" layout-align="center center" flex><div class="text-center"><md-input-container class="md-block" flex>\n<label>{{field.templateOptions.label}}</label><md-select ng-model="vm.complaintCanalLang" \nplaceholder="{{\'COMPLAINTS.START_COMPLAINT_LANGUAGE\' | translate}}"><md-option \nstyle="padding-top: 4px; padding-left: 10px;" \nng-repeat="option in (vm.complaintLanguagesWithPredetermined || vm.complaintLanguages)" value="{{option.value}}">\n<md-icon style="margin-right: 5px;" md-svg-src="assets/angular-material-assets/img/icons/spain.svg" \nng-if="option.value.startsWith(\'es\')" aria-label="Spain"></md-icon><md-icon style="margin-right: 5px;" \nmd-svg-src="assets/angular-material-assets/img/icons/portuguese.svg" ng-if="option.value.startsWith(\'pt\')" \naria-label="Portuguese"></md-icon><md-icon style="margin-right: 5px;" \nmd-svg-src="assets/angular-material-assets/img/icons/germany.svg" ng-if="option.value.startsWith(\'de\')" \naria-label="Germany"></md-icon><md-icon style="margin-right: 5px;" \nmd-svg-src="assets/angular-material-assets/img/icons/united_kingdom.svg" ng-if="option.value.startsWith(\'en\')" \naria-label="United Kingdom"></md-icon><md-icon style="margin-right: 5px;" \nmd-svg-src="assets/angular-material-assets/img/icons/catalonia.svg" ng-if="option.value.startsWith(\'ca\')" \naria-label="Catalonia"></md-icon><md-icon style="margin-right: 5px;" \nmd-svg-src="assets/angular-material-assets/img/icons/euskera.svg" ng-if="option.value.startsWith(\'eu\')" \naria-label="Euskera"></md-icon><md-icon style="margin-right: 5px;" \nmd-svg-src="assets/angular-material-assets/img/icons/france.svg" ng-if="option.value.startsWith(\'fr\')" \naria-label="France"></md-icon><md-icon style="margin-right: 5px;" \nmd-svg-src="assets/angular-material-assets/img/icons/gallego.svg" ng-if="option.value.startsWith(\'gl\')" \naria-label="Gallego"></md-icon><md-icon style="margin-right: 5px;" \nmd-svg-src="assets/angular-material-assets/img/icons/italy.svg" ng-if="option.value.startsWith(\'it\')" \naria-label="Italy"></md-icon><md-icon style="margin-right: 5px;" \nmd-svg-src="assets/angular-material-assets/img/icons/spain.svg" \nng-if="option.isPredetermined && option.formData.language_code.startsWith(\'es\')" aria-label="Spain"></md-icon><md-icon \nstyle="margin-right: 5px;" md-svg-src="assets/angular-material-assets/img/icons/portuguese.svg" \nng-if="option.isPredetermined && option.formData.language_code.startsWith(\'pt\')" aria-label="Portuguese"></md-icon>\n<md-icon style="margin-right: 5px;" md-svg-src="assets/angular-material-assets/img/icons/germany.svg" \nng-if="option.isPredetermined && option.formData.language_code.startsWith(\'de\')" aria-label="Germany"></md-icon>\n<md-icon style="margin-right: 5px;" md-svg-src="assets/angular-material-assets/img/icons/united_kingdom.svg" \nng-if="option.isPredetermined && option.formData.language_code.startsWith(\'en\')" aria-label="United Kingdom"></md-icon>\n<md-icon style="margin-right: 5px;" md-svg-src="assets/angular-material-assets/img/icons/catalonia.svg" \nng-if="option.isPredetermined && option.formData.language_code.startsWith(\'ca\')" aria-label="Catalonia"></md-icon>\n<md-icon style="margin-right: 5px;" md-svg-src="assets/angular-material-assets/img/icons/euskera.svg" \nng-if="option.isPredetermined && option.formData.language_code.startsWith(\'eu\')" aria-label="Euskera"></md-icon>\n<md-icon style="margin-right: 5px;" md-svg-src="assets/angular-material-assets/img/icons/france.svg" \nng-if="option.isPredetermined && option.formData.language_code.startsWith(\'fr\')" aria-label="France"></md-icon><md-icon\n style="margin-right: 5px;" md-svg-src="assets/angular-material-assets/img/icons/gallego.svg" \nng-if="option.isPredetermined && option.formData.language_code.startsWith(\'gl\')" aria-label="Gallego"></md-icon>\n<md-icon style="margin-right: 5px;" md-svg-src="assets/angular-material-assets/img/icons/italy.svg" \nng-if="option.isPredetermined && option.formData.language_code.startsWith(\'it\')" aria-label="Italy"></md-icon><md-icon \nmd-font-icon="icon-check-circle" class="predetermined-verify-icon" ng-if="option.isPredetermined" \naria-label="Predeterminado"></md-icon>{{option.name}}</md-option></md-select></md-input-container><md-button \nng-disabled="!vm.complaintCanalLang" aria-label="Start questionnaire" class="md-raised md-accent" \nng-click="vm.startComplaintCanal()"><span translate="COMPLAINTS.NEXT"></span></md-button></div></div></div>');
$templateCache.put('app/main/apps/complaints/views/list/list-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="isLoading" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="no-threads" ng-if="!vm.complaints" ng-hide="isLoading" translate="GLOBAL.NO_ITEMS"></div><div \nng-if="vm.complaints && vm.complaints.length> 0" id="list-content-data" ng-style="{\'opacity\' : isLoading ? 0.5 : 1}">\n<div class="mail-list-item" ng-repeat="complaint in vm.complaints | filter: vm.search | filter: global.search" \nng-init="parentIndex= $index" md-no-ink ng-click="vm.openComplaint(complaint.id)" \nng-class="{ \'selected\': vm.complaintSelected.id === complaint.id, \'checked\': vm.isSelected(complaint)}"><div \nlayout="row" layout-align="start center"><md-checkbox class="no-label" ng-checked="vm.isSelected(complaint)" \nng-click="vm.toggleSelectThread(complaint, $event)" aria-label="{{vm.isSelected(complaint) ? \'Deselect\' : \'Select\'}}">\n</md-checkbox><div layout="column" layout-align="start center"><span ng-if="complaint.priority == 0" class="dot green">\n<md-tooltip hide show-gt-xs><span translate="COMPLAINTS.LOW"></span></md-tooltip></span><span \nng-if="complaint.priority == 1" class="dot yellow"><md-tooltip hide show-gt-xs><span translate="COMPLAINTS.MEDIUM">\n</span></md-tooltip></span><span ng-if="complaint.priority == 2" class="dot orange"><md-tooltip hide show-gt-xs><span \ntranslate="COMPLAINTS.HIGH"></span></md-tooltip></span><span ng-if="complaint.priority == 3" class="dot red">\n<md-tooltip hide show-gt-xs><span translate="COMPLAINTS.CRITICAL"></span></md-tooltip></span></div><div \nclass="info layout-column flex" flex="" layout="column"><div class="name text-truncate" layout="row" \nlayout-align="start center"><span ng-bind="vm.getComplaintListTitle(complaint)"></span></div><div layout="row" \nlayout-align="space-between start" class="fullwidth"><span flex="50" class="grey-fg font-size-12"><span \ntranslate="COMPLAINTS.FORM"></span>: {{vm.getComplaintFormName(complaint)}}</span> <span flex="50" \nclass="grey-fg font-size-12"><span translate="COMPLAINTS.CREATED"></span>: {{complaint.created_at_format}}</span></div>\n<div layout="row" layout-align="space-between start" class="fullwidth"><span flex="50" class="grey-fg font-size-12">\n<span translate="COMPLAINTS.COMPLAINT_TYPE"></span>: {{complaint.complaint_form_type_name}}</span> <span flex="50" \nclass="grey-fg font-size-12"><span translate="COMPLAINTS.UPDATED"></span>: {{complaint.updated_at_format}}</span></div>\n</div><div layout="column" layout-align="center center" class="list-status-badge-wrap"><div \nng-repeat="step in vm.processSteps" ng-if="complaint.status === step.id" \nclass="list-status-badge {{ step.colorClass }}" layout="row" layout-align="center center"><md-icon \nmd-font-icon="{{ step.icon }}" class="list-status-badge-icon"></md-icon><span class="list-status-badge-label" \ntranslate="{{ step.labelKey }}"></span></div></div></div></div></div><div class="content thread-detail" layout="row" \nstyle="background: transparent;height: calc(100vh - 192px);" layout-align="center center" flex \nng-if="vm.complaints && vm.complaints.length == 0"><div class="no-thread-selected" layout="column" \nlayout-align="center center" flex><md-icon md-font-icon="icon-clipboard-account" class="s120 grey-400-fg"></md-icon>\n<span class="hint-text" translate="COMPLAINTS.NO_COMPLAINTS_FOUND"></span></div></div><div class="toolbar" \nlayout="row" layout-align="end center"><div layout="row" layout-align="center center" \nng-style="{\'display\' : isLoading ? \'none\' : \'block\'}"><span class="page-info">{{pagination_totalItems}} &nbsp;</span> \n<span class="page-info" translate="GLOBAL.ITEMS_FOUND"></span><md-button aria-label="Previous" \nclass="md-icon-button arrow" ng-click="vm.prevPage()" ng-disabled="pagination_page == 1" translate="" \ntranslate-attr-aria-label="GLOBAL.PREVIOUS"><md-icon md-font-icon="icon-chevron-left"></md-icon></md-button><span \nclass="page-info">{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label="Next" \nclass="md-icon-button arrow" ng-click="vm.nextPage()" ng-disabled="pagination_page == pagination_total_pages" \ntranslate="" translate-attr-aria-label="GLOBAL.NEXT"><md-icon md-font-icon="icon-chevron-right"></md-icon></md-button>\n</div></div>');
$templateCache.put('app/main/apps/complaints/views/list/nosplit-view.html','<div ng-if="!vm.isFormList" class="toolbar" layout="row" layout-align="space-between center" \nng-if="!vm.complaintSelected && !vm.complaintNew" ng-include="\'app/main/apps/complaints/views/list/toolbar.html\'">\n</div><div ng-if="!vm.isFormList" class="content-wrapper" flex="" layout="row"><div \nclass="content thread-detail mail-read-pane p0 scrollable" flex="" id="thread-detail" ms-scroll="vm.msScrollOptions" \nng-if="vm.complaintSelected || vm.complaintNew" ng-include="\'app/main/apps/complaints/views/edit/edit-view.html\'">\n</div><div class="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" \nid="thread-list" ng-if="!vm.complaintSelected && !vm.complaintNew" \nng-include="\'app/main/apps/complaints/views/list/list-view.html\'"></div></div><div ng-if="vm.isFormList" \nclass="forms-mobile-outer" layout="column" flex=""><div ng-if="!vm.showFormDetailMobile" class="toolbar" layout="row" \nlayout-align="space-between center" ng-include="\'app/main/apps/complaints/views/listforms/toolbar.html\'"></div><div \nng-if="vm.showFormDetailMobile" class="toolbar-form-detail-spacer" aria-hidden="true"></div><div \nng-if="vm.showFormDetailMobile" class="toolbar toolbar-form-detail-mobile toolbar-form-detail-fixed" layout="column" \nlayout-align="start stretch" ng-include="\'app/main/apps/complaints/views/editforms/toolbar-mobile.html\'"></div><div \nclass="content-wrapper forms-mobile-content" flex="" layout="row"><div \nclass="content thread-detail mail-read-pane p0 scrollable" flex="" id="thread-detail" ms-scroll="vm.msScrollOptions" \nng-if="vm.showFormDetailMobile" ng-include="\'app/main/apps/complaints/views/editforms/edit-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="!vm.showFormDetailMobile" ng-include="\'app/main/apps/complaints/views/listforms/list-view.html\'"></div></div>\n</div>');
$templateCache.put('app/main/apps/complaints/views/list/split-view.html','<div ng-if="!vm.isFormList" class="toolbar" layout="row" layout-align="space-between center" \nng-include="\'app/main/apps/complaints/views/list/toolbar.html\'"></div><div ng-if="vm.isFormList" class="toolbar" \nlayout="row" layout-align="space-between center" ng-include="\'app/main/apps/complaints/views/listforms/toolbar.html\'">\n</div><div ng-if="!vm.isFormList" class="content-wrapper" flex="" layout="row"><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-include="\'app/main/apps/complaints/views/list/list-view.html\'"></div><div \nclass="content thread-detail mail-read-pane scrollable p0" flex="" id="thread-detail" ms-scroll="vm.msScrollOptions" \nng-include="\'app/main/apps/complaints/views/edit/edit-view.html\'"></div></div><div ng-if="vm.isFormList" \nclass="content-wrapper" flex="" layout="row"><div class="content thread-list mail-list-pane scrollable p0" flex="" \nms-scroll="vm.msScrollOptions" id="thread-list" ng-include="\'app/main/apps/complaints/views/listforms/list-view.html\'">\n</div><div class="content thread-detail mail-read-pane scrollable p0" flex="" id="thread-detail" \nms-scroll="vm.msScrollOptions" ng-include="\'app/main/apps/complaints/views/editforms/edit-view.html\'"></div></div>');
$templateCache.put('app/main/apps/complaints/views/list/toolbar.html','<div layout="row" layout-align="start center"><md-checkbox class="no-label" \naria-label="{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}" \nng-checked="vm.selectedThreads.length > 0" ng-click="vm.toggleSelectThreads(vm.selectedThreads, vm.contents)">\n</md-checkbox><md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" \ntranslate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nng-if="$root.pagination_searchquery==true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip \nhide show-gt-xs><span>Reset search</span></md-tooltip></md-button><md-button ng-if="vm.complaintPlan.plan_id >= 3" \naria-label="NEW" class="md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme" hide \nshow-gt-sm ng-click="vm.newComplaint($event)" translate="COMPLAINTS.NEW_COMPLAINT" type="button"></md-button><div \nclass="divider-vertical" ng-show="vm.selectedThreads.length > 0"></div><div aria-hidden="false" \nclass="action-buttons layout-align-start-center layout-row" layout="row" layout-align="start center" \nng-show="vm.selectedThreads.length > 0"><md-button ng-click="vm.deleteComplaint($event)" aria-label="Delete" \nclass="md-icon-button" translate=""><md-icon md-font-icon="icon-delete"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.REMOVE"></span></md-tooltip></md-button><div class="divider-vertical"></div></div><md-menu-bar \nid="user-menu" class="p0 mobile-layout"><md-menu><md-button class="user-button" ng-click="$mdMenu.open()" \naria-label="Open menu" translate><div layout="row" layout-align="space-between center"><span ng-if="vm.formSelected" \nclass="username truncate-username">\n{{vm.formSelected.name}} {{vm.formTypeSelected ? (\'(\' +vm.formTypeSelected.name + \')\') : \'\'}}</span> <span \nng-if="!vm.formSelected" class="username">{{ \'COMPLAINTS.FILTERS\' | translate}}</span><md-icon \nmd-font-icon="icon-chevron-down" class="icon s16"></md-icon></div></md-button><md-menu-content width="3" \nclass="clients"><md-menu-item ng-click="vm.selectForm(form)" class="md-indent bar-client" \nng-repeat="form in vm.complaintFormsFiltered | filter:vm.searchFormText"><div layout="row" layout-align="start center" \nclass="pr-5"><md-menu flex><div layout="row" layout-align="space-between center"><div layout="row" \nlayout-align="start center"><button class="btn-clients">{{form.name}}</button></div><md-icon \nmd-font-icon="icon-chevron-right" class="icon s20 mr-0"></md-icon></div><md-menu-content width="3" class="clients">\n<md-menu-item ng-click="vm.selectFormType(form, formType)" class="md-indent bar-client" \nng-repeat="formType in form.subfilter"><div layout="row" layout-align="start center"><button class="btn-clients">\n{{formType.name}}</button></div></md-menu-item></md-menu-content></md-menu></div></md-menu-item></md-menu-content>\n</md-menu><md-menu><md-button class="user-button" ng-click="$mdMenu.open()" aria-label="Open menu"><div layout="row" \nlayout-align="space-between center"><span ng-if="vm.selectedStatus && vm.selectedStatus.id == 0" class="username">\n{{ \'COMPLAINTS.CLOSED\' | translate }}</span> <span ng-if="vm.selectedStatus && vm.selectedStatus.id == 1" \nclass="username">{{ \'COMPLAINTS.REVIEW\' | translate }}</span> <span \nng-if="vm.selectedStatus && vm.selectedStatus.id == 2" class="username">{{ \'COMPLAINTS.NEW\' | translate }}</span> <span\n ng-if="vm.selectedStatus && vm.selectedStatus.id == 3" class="username">{{ \'COMPLAINTS.NOT_ADMITTED\' | translate }}\n</span> <span ng-if="vm.selectedStatus && vm.selectedStatus.id == 4" class="username">\n{{ \'COMPLAINTS.UNDER_INVESTIGATION\' | translate }}</span> <span ng-if="vm.selectedStatus && vm.selectedStatus.id == 5" \nclass="username">{{ \'COMPLAINTS.REFERRED_TO_PROSECUTOR\' | translate }}</span> <span ng-if="!vm.selectedStatus" \nclass="username">{{ \'COMPLAINTS.STATUS\' | translate }}</span><md-icon md-font-icon="icon-chevron-down" \nclass="icon s16"></md-icon></div></md-button><md-menu-content width="3" class="clients"><md-menu-item \nng-repeat="status in vm.status" \nng-if="vm.canSeeAdminOnlyStatuses || (status.id !== 0 && status.id !== 3 && status.id !== 5)" \nclass="md-indent bar-client"><div layout="row" layout-align="start center" class="pr-5" \nng-click="vm.selectStatus(status, $event)"><button class="btn-clients"><span ng-if="status.id == 0">\n{{ \'COMPLAINTS.CLOSED\' | translate }}</span> <span ng-if="status.id == 1">{{ \'COMPLAINTS.REVIEW\' | translate }}</span> \n<span ng-if="status.id == 2">{{ \'COMPLAINTS.NEW\' | translate }}</span> <span ng-if="status.id == 3">\n{{ \'COMPLAINTS.NOT_ADMITTED\' | translate }}</span> <span ng-if="status.id == 4">\n{{ \'COMPLAINTS.UNDER_INVESTIGATION\' | translate }}</span> <span ng-if="status.id == 5">\n{{ \'COMPLAINTS.REFERRED_TO_PROSECUTOR\' | translate }}</span></button></div></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><md-icon class="pointer" ng-click="vm.selectForm(null); vm.selectStatus(null);" \nng-if="vm.formSelected || vm.formTypeSelected || vm.selectedStatus" md-font-icon="icon-filter-remove"></md-icon>\n<ms-search-bar debounce="300" model-search="$root.pagination_searchquery" on-result-click="vm.searchResultClick(item)" \non-search="vm.search(query)" layout="row" layout-align="start center"></ms-search-bar></div><div layout="row" \nlayout-align="start center" translate-attr-aria-label="GLOBAL.REFRESH"><span ng-if="!isLoading" \nclass="page-info font-weight-500">\n{{vm.complaints.length}} {{ \'GLOBAL.OF\' | translate}} {{pagination_totalItems}} {{ \'GLOBAL.ITEMS\' | translate}}.</span>\n<md-button class="md-icon-button" ng-click="vm.changeView(\'nosplit\')" ng-if="vm.currentView !== \'nosplit\'" hide \nshow-gt-sm><md-icon md-font-icon="icon-view-list" ng-if="vm.currentView !== \'nosplit\'"></md-icon><md-icon \nclass="md-accent" md-font-icon="icon-checkbox-marked" ng-if="vm.currentView === \'nosplit\'"></md-icon><md-tooltip hide \nshow-gt-xs><span translate="GLOBAL.NOSPLIT_VIEW">No split</span></md-tooltip></md-button><md-button \nclass="md-icon-button" ng-click="vm.changeView(\'split\')" ng-if="vm.currentView !== \'split\'" hide show-gt-sm><md-icon \nmd-font-icon="icon-view-quilt" ng-if="vm.currentView !== \'split\'"></md-icon><md-icon class="md-accent" \nmd-font-icon="icon-checkbox-marked" ng-if="vm.currentView === \'split\'"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.SPLIT_VIEW">split</span></md-tooltip></md-button></div>');
$templateCache.put('app/main/apps/contacts/sidenavs/main/main-sidenav.html','<div class="header md-padding" layout="row" layout-align="start center"><img ng-src="{{vm.user.avatar}}" \nclass="md-avatar avatar mr-16" alt="{{vm.user.name}}"> <span class="font-weight-500 font-size-14">{{vm.user.name}}\n</span></div><md-divider></md-divider><div ms-scroll class="content"><md-list><md-list-item \nng-click="vm.filterChange(\'all\')" ng-class="{\'selected\':vm.listType ===\'all\'}"><p translate="CONTACTS.ALL_CONTACTS">\nAll contacts</p></md-list-item><md-list-item ng-click="vm.filterChange(\'frequent\')" \nng-class="{\'selected\':vm.listType ===\'frequent\'}"><p>Passengers</p></md-list-item><md-list-item \nng-click="vm.filterChange(\'starred\')" ng-class="{\'selected\':vm.listType ===\'starred\'}"><p>Crew</p></md-list-item>\n<md-divider></md-divider></md-list></div>');
$templateCache.put('app/main/apps/complaints/views/editforms/edit-view.html','<div class="content thread-detail" layout="row" layout-align="center center" flex \nng-if="!vm.showLanguageSelectorComplaintCanal && !vm.showFormStartComplaintCanal"><div class="no-thread-selected" \nlayout="column" layout-align="center center" flex><md-icon md-font-icon="icon-clipboard-account" \nclass="s120 grey-400-fg"></md-icon><span class="hint-text" translate="COMPLAINTS.SELECT_FORM"></span></div></div><div \nclass="content-wrapper" layout="row" ng-include="\'app/main/apps/complaints/views/list/language-selector.html\'" flex \nng-if="vm.showLanguageSelectorComplaintCanal && !isLoadingCanal"></div><div \nng-if="!vm.showLanguageSelectorComplaintCanal"><div \nclass="toolbar colored-bg ng-scope layout-align-space-between-center layout-row hide show-gt-sm" layout="row" \nlayout-align="space-between center"><div layout="row" layout-align="start center" flex=""><md-button aria-label="Edit" \nclass="md-icon-button" translate="" ng-click="vm.formTab= \'edit\'" translate-attr-aria-label="COMPLAINTS.EDIT" \nng-class="{\'tab-selected\': vm.formTab==\'edit\'}"><md-icon md-font-icon="icon-pencil"></md-icon><md-tooltip hide \nshow-gt-xs><span translate="COMPLAINTS.EDIT">Edit</span></md-tooltip></md-button><div class="divider-vertical"></div>\n<md-button aria-label="Preview" class="md-icon-button" translate="" ng-click="vm.formTab= \'preview\'" \ntranslate-attr-aria-label="COMPLAINTS.PREVIEW" ng-class="{\'tab-selected\': vm.formTab==\'preview\'}"><md-icon \nmd-font-icon="icon-eye"></md-icon><md-tooltip hide show-gt-xs><span translate="COMPLAINTS.PREVIEW">PREVIEW</span>\n</md-tooltip></md-button><div ng-if="vm.complaintFormDefault.id && vm.complaintPlan.plan_id >= 2" \nclass="divider-vertical"></div><md-button ng-if="vm.complaintFormDefault.id && vm.complaintPlan.plan_id >= 2" \naria-label="SHOW_EMBED_CODE" class="md-icon-button" translate="" ng-click="vm.formTab= \'embed\'" \ntranslate-attr-aria-label="COMPLAINTS.SHOW_EMBED_CODE" ng-class="{\'tab-selected\': vm.formTab==\'embed\'}"><md-icon \nmd-svg-src="assets/angular-material-assets/img/icons/qr_code.svg"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="COMPLAINTS.SHOW_EMBED_CODE">SHOW_EMBED_CODE</span></md-tooltip></md-button><div \nng-if="vm.complaintFormDefault.id && vm.complaintPlan.plan_id >= 2 && vm.complaintCanal.language_code.startsWith(\'es\')" \nclass="divider-vertical"></div><md-button \nng-if="vm.complaintFormDefault.id && vm.complaintPlan.plan_id >= 2 && vm.complaintCanal.language_code.startsWith(\'es\')" \naria-label="SELECT_LANGUAGE" class="md-icon-button" translate="" ng-click="vm.formTab= \'selectLang\'" \ntranslate-attr-aria-label="COMPLAINTS.SELECT_LANGUAGE" ng-class="{\'tab-selected\': vm.formTab==\'selectLang\'}"><md-icon \nmd-svg-src="assets/angular-material-assets/img/icons/translate.svg"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="COMPLAINTS.SELECT_LANGUAGE">Select Language</span></md-tooltip></md-button><div \nng-if="vm.complaintFormDefault.id" class="divider-vertical"></div><a \nhref="{{vm.getFormUrlNew(vm.complaintCanal.filename)}}" target="_blank"><md-button ng-if="vm.complaintFormDefault.id" \naria-label="Task" class="md-icon-button" translate="" translate-attr-aria-label="COMPLAINTS.OPEN_FORM"><md-icon \nmd-svg-src="assets/angular-material-assets/img/icons/external-link.svg"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="COMPLAINTS.OPEN_FORM">TASKS</span></md-tooltip></md-button></a></div><div layout="row" \nlayout-align="end center"><md-button translate="GLOBAL.CANCEL" type="button" \nng-click="vm.showLanguageSelectorComplaintCanal= false; vm.showFormStartComplaintCanal= false" \nclass="md-raised md-warn" aria-label="Cancel"></md-button><md-button ng-if="!vm.complaintFormDefault.id" \ntranslate="GLOBAL.SAVE" type="button" ng-disabled="vm.basicForm.$invalid || vm.basicForm.$pristine" \nng-click="vm.finishInitComplaintForm()" class="md-raised md-accent" aria-label="Save"></md-button><md-button \nng-if="vm.complaintFormDefault.id" translate="GLOBAL.SAVE" type="button" \nng-disabled="vm.basicForm.$invalid || vm.basicForm.$pristine" ng-click="vm.updateComplaintCanal()" \nclass="md-raised md-accent" aria-label="Save"></md-button></div></div><div class="edit-form-scroll-area" \nstyle="max-height: calc(100vh - 192px);overflow: auto;" ng-if="vm.formTab == \'edit\'"><div class="mt-25 ph-15">\n<md-input-container class="md-block m-0"><label translate="COMPLAINTS.CANAL_NAME"></label> <input \nng-model="vm.complaintFormDefault.name" type="text"></md-input-container></div><div \nclass="color-picker-container mt-25 ph-15"><label translate="COMPLAINTS.BUTTON_COLOR"></label><div \nclass="inputs-container"><input class="color-input" ng-model="vm.complaintFormDefault.config.buttonColor" type="color">\n <input class="text-input" ng-model="vm.complaintFormDefault.config.buttonColor" type="text" placeholder="color"></div>\n</div><div class="color-picker-container mt-25 ph-15"><label translate="COMPLAINTS.TEXT_COLOR"></label><div \nclass="inputs-container"><input class="color-input" ng-model="vm.complaintFormDefault.config.textColor" type="color"> \n<input class="text-input" ng-model="vm.complaintFormDefault.config.textColor" type="text" placeholder="color"></div>\n</div><div ng-include="\'app/main/apps/complaints/views/list/form-init.html\'" class="br" layout="column" flex="100">\n</div></div><div ng-if="vm.formTab == \'preview\'" style="position: relative;" layout="column" flex="100"><div \nclass="edit-form-scroll-area" style="max-height: calc(100vh - 192px);overflow: auto;"><md-list-item \nstyle="max-height: 47px;" class="md-toolbar-tools grey-100-bg"><h3 class="grey-700-fg">\n{{ \'COMPLAINTS.PREVIEW\' | translate }}</h3><md-divider></md-divider></md-list-item><div \nng-include="\'app/main/apps/complaints/views/edit/editors/preview.html\'"></div></div></div><div \nng-if="vm.formTab == \'embed\'"><div class="mt-25 ph-15"><p class="mb-40">{{ \'COMPLAINTS.URL_EMBED_DESC\' | translate}}\n</p><md-input-container class="md-block m-0"><label translate="COMPLAINTS.URL_CANAL"></label><script \ntype="text/javascript">\nfunction generateBarCode()\n            {\n                var nric = $(\'#text\').val();\n                var url = \'https://api.qrserver.com/v1/create-qr-code/?size=750x750&data=\' + encodeURIComponent(nric);\n                $(\'#barcode\').attr(\'src\', url);\n                \n                $(\'#qrdownload\').off(\'click\').on(\'click\', function() {\n                    var downloadUrl = \'https://api.qrserver.com/v1/create-qr-code/?size=650x650&margin=0&download=1&data=\' + encodeURIComponent(nric);\n                    window.location.href = downloadUrl;\n                });\n            }\n</script><body><input id="text" type="text" ng-model="vm.complaintFormDefault.target_url" type="text" \nonblur="generateBarCode();" style="vertical-align:middle;margin:10px 0px"><p>{{ \'COMPLAINTS.QR_CODE\' | translate}}</p>\n<img id="barcode" src="https://api.qrserver.com/v1/create-qr-code/?size=750x750&data=H2C" onload="generateBarCode()" \nalt="" title="C\xF3digo QR" width="200" height="200"><md-button style="margin-left: 35px; margin: 80px;" id="qrdownload" \ntarget="_blank" translate="COMPLAINTS.DOWNLOAD_QR" type="button" class="md-raised md-accent" aria-label="Download QR">\n</md-button></body></md-input-container><p>{{ \'COMPLAINTS.EMBED_CODE\' | translate}}</p></div><pre \nstyle="background: #dedede;border: 1px solid #00000038;" class="m-15 p-25">{{vm.embed}}</pre></div><div \nng-if="vm.formTab == \'selectLang\'"><div class="mt-25 ph-15"><p \nclass="font-smaller title-large-center md-toolbar-tools grey-100-bg grey-700-fg">\n{{ \'COMPLAINTS.LANGUAGE_URL_DESC\' | translate }}</p><md-input-container class="md-block input-container-custom" \nng-if="vm.complaintCanal.language_code !== \'en\'"><label>{{ \'COMPLAINTS.ENGLISH_URL\' | translate }}</label><md-select \nng-model="vm.selectedFormEnglish" ng-change="selectLangForm(vm.selectedFormEnglish, \'english\')" \nng-init="vm.selectedFormEnglish = vm.complaintFormDefault.config.languages.english.url.replace(\'https://\', \'\').replace(\'.canal.h2c.app/new-form.html\', \'\')">\n<md-option value=""><em>{{ \'COMPLAINTS.SELECT_NONE\' | translate }}</em></md-option><md-option \nng-repeat="form in vm.complaintForms | filter: startsWithLanguage | filter: vm.search | filter: global.search" \nvalue="{{form.filename}}" ng-if="form.language_code.startsWith(\'en\')"><md-icon style="margin-right: 5px;" \nmd-svg-src="assets/angular-material-assets/img/icons/united_kingdom.svg" ng-if="form.language_code.startsWith(\'en\')" \naria-label="United Kingdom"></md-icon>{{form.name}}</md-option></md-select></md-input-container><md-input-container \nclass="md-block input-container-custom" ng-if="vm.complaintCanal.language_code !== \'de\'"><label>\n{{ \'COMPLAINTS.GERMAN_URL\' | translate }}</label><md-select ng-model="vm.selectedFormGerman" \nng-change="selectLangForm(vm.selectedFormGerman, \'german\')" \nng-init="vm.selectedFormGerman = vm.complaintFormDefault.config.languages.german.url.replace(\'https://\', \'\').replace(\'.canal.h2c.app/new-form.html\', \'\')">\n<md-option value=""><em>{{ \'COMPLAINTS.SELECT_NONE\' | translate }}</em></md-option><md-option \nng-repeat="form in vm.complaintForms | filter: startsWithLanguage | filter: vm.search | filter: global.search" \nvalue="{{form.filename}}" ng-if="form.language_code.startsWith(\'de\')"><md-icon style="margin-right: 5px;" \nmd-svg-src="assets/angular-material-assets/img/icons/germany.svg" ng-if="form.language_code.startsWith(\'de\')" \naria-label="Germany"></md-icon>{{form.name}}</md-option></md-select></md-input-container><md-input-container \nclass="md-block input-container-custom" ng-if="vm.complaintCanal.language_code !== \'ca\'"><label>\n{{ \'COMPLAINTS.CATALAN_URL\' | translate }}</label><md-select ng-model="vm.selectedFormCatalan" \nng-change="selectLangForm(vm.selectedFormCatalan, \'catalan\')" \nng-init="vm.selectedFormCatalan = vm.complaintFormDefault.config.languages.catalan.url.replace(\'https://\', \'\').replace(\'.canal.h2c.app/new-form.html\', \'\')">\n<md-option value=""><em>{{ \'COMPLAINTS.SELECT_NONE\' | translate }}</em></md-option><md-option \nng-repeat="form in vm.complaintForms | filter: startsWithLanguage | filter: vm.search | filter: global.search" \nvalue="{{form.filename}}" ng-if="form.language_code.startsWith(\'ca\')"><md-icon style="margin-right: 5px;" \nmd-svg-src="assets/angular-material-assets/img/icons/catalonia.svg" ng-if="form.language_code.startsWith(\'ca\')" \naria-label="Catalonia"></md-icon>{{form.name}}</md-option></md-select></md-input-container><md-input-container \nclass="md-block input-container-custom" ng-if="vm.complaintCanal.language_code !== \'pt\'"><label>\n{{ \'COMPLAINTS.PORTUGUESE_URL\' | translate }}</label><md-select ng-model="vm.selectedFormPortuguese" \nng-change="selectLangForm(vm.selectedFormPortuguese, \'portuguese\')" \nng-init="vm.selectedFormPortuguese = vm.complaintFormDefault.config.languages.portuguese.url.replace(\'https://\', \'\').replace(\'.canal.h2c.app/new-form.html\', \'\')">\n<md-option value=""><em>{{ \'COMPLAINTS.SELECT_NONE\' | translate }}</em></md-option><md-option \nng-repeat="form in vm.complaintForms | filter: startsWithLanguage | filter: vm.search | filter: global.search" \nvalue="{{form.filename}}" ng-if="form.language_code.startsWith(\'pt\')"><md-icon style="margin-right: 5px;" \nmd-svg-src="assets/angular-material-assets/img/icons/portuguese.svg" ng-if="form.language_code.startsWith(\'pt\')" \naria-label="Portuguese"></md-icon>{{form.name}}</md-option></md-select></md-input-container><md-input-container \nclass="md-block input-container-custom" ng-if="vm.complaintCanal.language_code !== \'eu\'"><label>\n{{ \'COMPLAINTS.EUSKERA_URL\' | translate }}</label><md-select ng-model="vm.selectedFormEuskera" \nng-change="selectLangForm(vm.selectedFormEuskera, \'euskera\')" \nng-init="vm.selectedFormEuskera = vm.complaintFormDefault.config.languages.euskera.url.replace(\'https://\', \'\').replace(\'.canal.h2c.app/new-form.html\', \'\')">\n<md-option value=""><em>{{ \'COMPLAINTS.SELECT_NONE\' | translate }}</em></md-option><md-option \nng-repeat="form in vm.complaintForms | filter: startsWithLanguage | filter: vm.search | filter: global.search" \nvalue="{{form.filename}}" ng-if="form.language_code.startsWith(\'eu\')"><md-icon style="margin-right: 5px;" \nmd-svg-src="assets/angular-material-assets/img/icons/euskera.svg" ng-if="form.language_code.startsWith(\'eu\')" \naria-label="Euskera"></md-icon>{{form.name}}</md-option></md-select></md-input-container><md-input-container \nclass="md-block input-container-custom" ng-if="vm.complaintCanal.language_code !== \'fr\'"><label>\n{{ \'COMPLAINTS.FRANCE_URL\' | translate }}</label><md-select ng-model="vm.selectedFormFrance" \nng-change="selectLangForm(vm.selectedFormFrance, \'france\')" \nng-init="vm.selectedFormFrance = vm.complaintFormDefault.config.languages.france.url.replace(\'https://\', \'\').replace(\'.canal.h2c.app/new-form.html\', \'\')">\n<md-option value=""><em>{{ \'COMPLAINTS.SELECT_NONE\' | translate }}</em></md-option><md-option \nng-repeat="form in vm.complaintForms | filter: startsWithLanguage | filter: vm.search | filter: global.search" \nvalue="{{form.filename}}" ng-if="form.language_code.startsWith(\'fr\')"><md-icon style="margin-right: 5px;" \nstyle="margin-right: 5px;" md-svg-src="assets/angular-material-assets/img/icons/france.svg" \nng-if="form.language_code.startsWith(\'fr\')" aria-label="France"></md-icon>{{form.name}}</md-option></md-select>\n</md-input-container><md-input-container class="md-block input-container-custom" \nng-if="vm.complaintCanal.language_code !== \'gl\'"><label>{{ \'COMPLAINTS.GALLEGO_URL\' | translate }}</label><md-select \nng-model="vm.selectedFormGallego" ng-change="selectLangForm(vm.selectedFormGallego, \'gallego\')" \nng-init="vm.selectedFormGallego = vm.complaintFormDefault.config.languages.gallego.url.replace(\'https://\', \'\').replace(\'.canal.h2c.app/new-form.html\', \'\')">\n<md-option value=""><em>{{ \'COMPLAINTS.SELECT_NONE\' | translate }}</em></md-option><md-option \nng-repeat="form in vm.complaintForms | filter: startsWithLanguage | filter: vm.search | filter: global.search" \nvalue="{{form.filename}}" ng-if="form.language_code.startsWith(\'gl\')"><md-icon style="margin-right: 5px;" \nmd-svg-src="assets/angular-material-assets/img/icons/gallego.svg" ng-if="form.language_code.startsWith(\'gl\')" \naria-label="Gallego"></md-icon>{{form.name}}</md-option></md-select></md-input-container><md-input-container \nclass="md-block input-container-custom" ng-if="vm.complaintCanal.language_code !== \'it\'"><label>\n{{ \'COMPLAINTS.ITALY_URL\' | translate }}</label><md-select ng-model="vm.selectedFormItaly" \nng-change="selectLangForm(vm.selectedFormItaly, \'italy\')" \nng-init="vm.selectedFormItaly = vm.complaintFormDefault.config.languages.italy.url.replace(\'https://\', \'\').replace(\'.canal.h2c.app/new-form.html\', \'\')">\n<md-option value=""><em>{{ \'COMPLAINTS.SELECT_NONE\' | translate }}</em></md-option><md-option \nng-repeat="form in vm.complaintForms | filter: startsWithLanguage | filter: vm.search | filter: global.search" \nvalue="{{form.filename}}" ng-if="form.language_code.startsWith(\'it\')"><md-icon style="margin-right: 5px;" \nmd-svg-src="assets/angular-material-assets/img/icons/italy.svg" ng-if="form.language_code.startsWith(\'it\')" \naria-label="Italy"></md-icon>{{form.name}}</md-option></md-select></md-input-container></div></div></div>');
$templateCache.put('app/main/apps/complaints/views/editforms/toolbar-mobile.html','<div layout="column" layout-align="start stretch" class="fullwidth"><div layout="row" layout-align="end center" \nstyle="margin-bottom: 6px;"><md-button type="button" \nng-click="vm.showLanguageSelectorComplaintCanal= false; vm.showFormStartComplaintCanal= false; vm.closeFormDetail()" \nclass="md-warn md-fab md-mini md-raised" aria-label="Cancel" translate-attr-aria-label="GLOBAL.CANCEL"><md-icon \nmd-font-icon="icon-window-close"></md-icon></md-button><md-button ng-if="!vm.complaintFormDefault.id" type="button" \nng-disabled="vm.basicForm.$invalid || vm.basicForm.$pristine" ng-click="vm.finishInitComplaintForm()" \nclass="md-accent md-fab md-mini md-raised" aria-label="Save" translate-attr-aria-label="GLOBAL.SAVE"><md-icon \nmd-font-icon="icon-check"></md-icon></md-button><md-button ng-if="vm.complaintFormDefault.id" type="button" \nng-disabled="vm.basicForm.$invalid || vm.basicForm.$pristine" ng-click="vm.updateComplaintCanal()" \nclass="md-accent md-fab md-mini md-raised" aria-label="Save" translate-attr-aria-label="GLOBAL.SAVE"><md-icon \nmd-font-icon="icon-check"></md-icon></md-button></div><div class="toolbar-mobile-actions" layout="row" \nlayout-align="start center" flex=""><md-button aria-label="Back" class="md-icon-button" \nng-click="vm.closeFormDetail()" translate-attr-aria-label="COMPLAINTS.BACK"><md-icon \nmd-font-icon="icon-keyboard-backspace"></md-icon></md-button><md-button aria-label="Edit" class="md-icon-button" \nng-click="vm.formTab= \'edit\'" translate-attr-aria-label="COMPLAINTS.EDIT" \nng-class="{\'tab-selected\': vm.formTab==\'edit\'}"><md-icon md-font-icon="icon-pencil"></md-icon></md-button><div \nclass="divider-vertical"></div><md-button aria-label="Preview" class="md-icon-button" ng-click="vm.formTab= \'preview\'" \ntranslate-attr-aria-label="COMPLAINTS.PREVIEW" ng-class="{\'tab-selected\': vm.formTab==\'preview\'}"><md-icon \nmd-font-icon="icon-eye"></md-icon></md-button><div ng-if="vm.complaintFormDefault.id && vm.complaintPlan.plan_id >= 2" \nclass="divider-vertical"></div><md-button ng-if="vm.complaintFormDefault.id && vm.complaintPlan.plan_id >= 2" \naria-label="Embed" class="md-icon-button" ng-click="vm.formTab= \'embed\'" \ntranslate-attr-aria-label="COMPLAINTS.SHOW_EMBED_CODE" ng-class="{\'tab-selected\': vm.formTab==\'embed\'}"><md-icon \nmd-svg-src="assets/angular-material-assets/img/icons/qr_code.svg"></md-icon></md-button><div \nng-if="vm.complaintFormDefault.id && vm.complaintPlan.plan_id >= 2 && vm.complaintCanal.language_code.startsWith(\'es\')" \nclass="divider-vertical"></div><md-button \nng-if="vm.complaintFormDefault.id && vm.complaintPlan.plan_id >= 2 && vm.complaintCanal.language_code.startsWith(\'es\')" \naria-label="Language" class="md-icon-button" ng-click="vm.formTab= \'selectLang\'" \ntranslate-attr-aria-label="COMPLAINTS.SELECT_LANGUAGE" ng-class="{\'tab-selected\': vm.formTab==\'selectLang\'}"><md-icon \nmd-svg-src="assets/angular-material-assets/img/icons/translate.svg"></md-icon></md-button><div \nng-if="vm.complaintFormDefault.id" class="divider-vertical"></div><a ng-if="vm.complaintFormDefault.id" \nhref="{{vm.getFormUrlNew(vm.complaintCanal.filename)}}" target="_blank"><md-button aria-label="Open form" \nclass="md-icon-button" translate-attr-aria-label="COMPLAINTS.OPEN_FORM"><md-icon \nmd-svg-src="assets/angular-material-assets/img/icons/external-link.svg"></md-icon></md-button></a></div></div>');
$templateCache.put('app/main/apps/contacts/dialogs/contact/contact-dialog.html','<md-dialog class="contact-dialog" aria-label="New Task"><form name="contactForm" class="md-inline-form" novalidate>\n<md-toolbar class="md-accent md-tall" layout="column"><div class="md-toolbar-tools md-toolbar-tools-top" layout="row" \nlayout-align="space-between"><span class="title">{{vm.title}}</span><md-button class="md-icon-button" \nng-click="vm.closeDialog()" aria-label="Close dialog" translate translate-attr-aria-label="CONTACTS.CLOSE_DIALOG">\n<md-icon md-font-icon="icon-close"></md-icon></md-button></div><div class="md-toolbar-tools md-toolbar-tools-middle" \nflex layout="column" layout-align="center center"><div layout="column" layout-align="center center"><img \nng-src="{{vm.contact.avatar}}" class="md-avatar avatar contact-avatar huge" alt="{{vm.contact.name}}"><div \nclass="contact-name">{{vm.contact.name}}</div></div></div><div class="md-toolbar-tools md-toolbar-tools-bottom" \nlayout="row" layout-align="center center"><div flex layout="row" layout-align="center center"><md-button \nclass="md-icon-button" ng-click="vm.toggleInArray(vm.contact.id, vm.user.starred)" aria-label="Toggle starred" \ntranslate translate-attr-aria-label="CONTACTS.TOGGLE_STARRED"><md-icon \nng-if="vm.exists(vm.contact.id,vm.user.starred)" md-font-icon="icon-star" class="amber-fg"></md-icon><md-icon \nng-if="!vm.exists(vm.contact.id,vm.user.starred)" md-font-icon="icon-star-outline"></md-icon></md-button><md-menu>\n<md-button class="md-icon-button" aria-label="More" translate translate-attr-aria-label="TODO.MORE"><md-icon \nmd-font-icon="icon-account-multiple-plus" ng-click="$mdMenu.open($event)"></md-icon></md-button><md-menu-content \nwidth="3"><md-list-item ng-if="vm.user.groups" ng-repeat="group in vm.user.groups" \nng-click="vm.toggleInArray(vm.contact.id,group.contactIds)"><p class="pl-8" \nng-style="vm.exists(vm.contact.id,group.contactIds) && {\'font-weight\':\'500\'}">{{group.name}}</p></md-list-item>\n</md-menu-content></md-menu></div></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass="md-icon-float md-block"><label translate="CONTACTS.NAME_REQUIRED">Name (required)</label><md-icon \nmd-font-icon="icon-account" class="name"></md-icon><input ng-model="vm.contact.name" type="text" ng-required>\n</md-input-container><md-input-container class="md-icon-float md-block"><label translate="CONTACTS.LAST_NAME">Last name\n</label><md-icon></md-icon><input ng-model="vm.contact.lastName" type="text"></md-input-container><md-input-container \nclass="md-icon-float md-block"><label translate="CONTACTS.NICKNAME">Nickname</label><md-icon></md-icon><input \nng-model="vm.contact.nickname" type="text"></md-input-container><div ng-if="!vm.allFields" layout="row" \nlayout-align="center center"><md-button class="md-accent" ng-click="vm.allFields = true" \ntranslate="CONTACTS.SHOW_ALL_FIELDS">Show All Fields</md-button></div><div ng-if="vm.allFields"><md-input-container \nclass="md-block"><md-icon md-font-icon="icon-phone"></md-icon><input ng-model="vm.contact.phone" type="text" \nplaceholder="Phone number" translate translate-attr-placeholder="CONTACTS.PHONE_NUMBER"></md-input-container>\n<md-input-container class="md-block"><md-icon md-font-icon="icon-email" class="email"></md-icon><input \nng-model="vm.contact.email" type="email" placeholder="Email" translate translate-attr-placeholder="CONTACTS.EMAIL">\n</md-input-container><md-input-container class="md-block"><md-icon md-font-icon="icon-domain"></md-icon><input \nng-model="vm.contact.company" type="text" placeholder="Company" translate \ntranslate-attr-placeholder="CONTACTS.COMPANY"></md-input-container><md-input-container class="md-block"><md-icon \nmd-font-icon="icon-worker"></md-icon><input ng-model="vm.contact.jobTitle" type="text" placeholder="Job title" \ntranslate translate-attr-placeholder="CONTACTS.JOB_TITLE"></md-input-container><md-datepicker class="birthday-input" \nng-model="vm.contact.birthday" md-placeholder="Birthday" ng-required="false"></md-datepicker><md-input-container \nclass="md-block"><md-icon md-font-icon="icon-home"></md-icon><input ng-model="vm.contact.address" type="text" \nplaceholder="Address" translate translate-attr-placeholder="CONTACTS.ADDRESS"></md-input-container><div layout="row" \nclass="md-block textarea-wrapper" layout-align="start start"><md-icon md-font-icon="icon-note"></md-icon>\n<md-input-container flex><label translate translate-attr-placeholder="CONTACTS.NOTES">Notes</label> <textarea \nng-model="vm.contact.notes" type="text"></textarea></md-input-container></div><div layout="row" \nlayout-align="center center"><md-button class="md-accent" ng-click="vm.allFields = false" \ntranslate="CONTACTS.FEWER_FIELDS">Fewer Fields</md-button></div></div></md-dialog-content><md-dialog-actions \nlayout="row" layout-align="space-between center"><div layout="row" layout-align="start center"><md-button \ntype="submit" ng-if="!vm.newContact" ng-click="vm.saveContact()" class="send-button md-accent md-raised" \nng-disabled="contactForm.$invalid || contactForm.$pristine" aria-label="SAVE" translate="CONTACTS.SAVE" \ntranslate-attr-aria-label="CONTACTS.SAVE">SAVE</md-button><md-button type="submit" ng-if="vm.newContact" \nng-click="vm.addNewContact()" class="send-button md-accent md-raised" \nng-disabled="contactForm.$invalid || contactForm.$pristine" aria-label="Add Task" translate="CONTACTS.ADD_CONTACT" \ntranslate-attr-aria-label="CONTACTS.ADD_CONTACT">ADD CONTACT</md-button></div><div layout="row"><md-button \nclass="md-icon-button" ng-click="vm.deleteContactConfirm($event)" aria-label="Delete" translate \ntranslate-attr-aria-label="CONTACTS.DELETE"><md-icon md-font-icon="icon-delete"></md-icon><md-tooltip><span \ntranslate="CONTACTS.DELETE">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/complaints/views/listforms/list-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="isLoadingCanal" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div style="height: calc(100% - 64px);" class="no-threads" ng-if="!vm.complaintForms || vm.complaintForms.length == 0" \nng-hide="isLoadingCanal" translate="GLOBAL.NO_ITEMS"></div><div id="list-content-data" \nng-style="{\'opacity\' : isLoadingCanal ? 0.5 : 1}"><div class="mail-list-item" \nng-repeat="form in vm.complaintForms | filter: vm.search | filter: global.search" ng-init="parentIndex= $index" \nmd-no-ink ng-click="vm.openForm(form)" \nng-class="{ \'selected\': vm.complaintCanal.id === form.id, \'checked\': vm.isSelected(form)}"><div layout="row" \nlayout-align="start center"><md-checkbox class="no-label" ng-checked="vm.isSelected(form)" \nng-click="vm.toggleSelectThread(form, $event)" aria-label="{{vm.isSelected(form) ? \'Deselect\' : \'Select\'}}">\n</md-checkbox><div class="language-flag-container"><md-icon \nmd-svg-src="assets/angular-material-assets/img/icons/spain.svg" ng-if="form.language_code.startsWith(\'es\')" \naria-label="Spain"></md-icon><md-icon md-svg-src="assets/angular-material-assets/img/icons/portuguese.svg" \nng-if="form.language_code.startsWith(\'pt\')" aria-label="Portuguese"></md-icon><md-icon \nmd-svg-src="assets/angular-material-assets/img/icons/germany.svg" ng-if="form.language_code.startsWith(\'de\')" \naria-label="Germany"></md-icon><md-icon md-svg-src="assets/angular-material-assets/img/icons/united_kingdom.svg" \nng-if="form.language_code.startsWith(\'en\')" aria-label="United Kingdom"></md-icon><md-icon \nmd-svg-src="assets/angular-material-assets/img/icons/catalonia.svg" ng-if="form.language_code.startsWith(\'ca\')" \naria-label="Catalonia"></md-icon><md-icon md-svg-src="assets/angular-material-assets/img/icons/euskera.svg" \nng-if="form.language_code.startsWith(\'eu\')" aria-label="Euskera"></md-icon><md-icon \nmd-svg-src="assets/angular-material-assets/img/icons/france.svg" ng-if="form.language_code.startsWith(\'fr\')" \naria-label="France"></md-icon><md-icon md-svg-src="assets/angular-material-assets/img/icons/gallego.svg" \nng-if="form.language_code.startsWith(\'gl\')" aria-label="Gallego"></md-icon><md-icon \nmd-svg-src="assets/angular-material-assets/img/icons/italy.svg" ng-if="form.language_code.startsWith(\'it\')" \naria-label="Italy"></md-icon><md-icon md-font-icon="icon-check-circle" ng-if="form.is_predetermined" \nclass="default-verified"></md-icon></div><div class="info layout-column flex" flex="" layout="column"><div \nclass="name text-truncate" layout="row" layout-align="start center"><span>{{form.name}}</span></div></div></div></div>\n</div>');
$templateCache.put('app/main/apps/complaints/views/listforms/toolbar.html','<div layout="row" layout-align="start center"><md-button aria-label="NEW" \nclass="md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme" \nng-click="vm.newComplaintForm($event)" translate="COMPLAINTS.NEW_COMPLAINT_FORM" type="button"></md-button><md-button \nng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" translate="" \ntranslate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" ng-if="$root.pagination_searchquery==true"><md-icon \nmd-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip hide show-gt-xs><span>Reset search</span></md-tooltip>\n</md-button><div class="divider-vertical" ng-show="vm.selectedThreads.length > 0"></div><div aria-hidden="false" \nclass="action-buttons layout-align-start-center layout-row" layout="row" layout-align="start center" \nng-show="vm.selectedThreads.length > 0"><md-button ng-if="vm.userLogued.user_type == 1" \nng-click="vm.setMultipleFormsAsPredetermined($event)" aria-label="Toggle Default" class="md-icon-button" translate="" \ntranslate-attr-aria-label="{{vm.getDefaultButtonInfo().text}}"><md-icon \nmd-font-icon="{{vm.getDefaultButtonInfo().icon}}"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="{{vm.getDefaultButtonInfo().text}}"></span></md-tooltip></md-button><md-button \nng-click="vm.deleteForm($ev)" aria-label="Delete" class="md-icon-button" translate=""><md-icon \nmd-font-icon="icon-delete"></md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.REMOVE"></span></md-tooltip>\n</md-button></div></div><div layout="row" layout-align="start center" translate-attr-aria-label="GLOBAL.REFRESH"><span \nclass="page-info" hide show-gt-xs>{{pagination_totalItems_forms}} &nbsp;</span> <span class="page-info" hide="" \nshow-gt-xs="" translate="GLOBAL.ITEMS_FOUND"></span><md-button aria-label="Previous" class="md-icon-button arrow" \nhide="" ng-click="pagination_prevPage()" ng-disabled="pagination_firstPage()" show-gt-xs="" translate="" \ntranslate-attr-aria-label="GLOBAL.PREVIOUS"><md-icon md-font-icon="icon-chevron-left"></md-icon><md-tooltip hide \nshow-gt-xs><span translate="GLOBAL.PREVIOUS">Previous</span></md-tooltip></md-button><span class="page-info" hide="" \nshow-gt-xs="">{{pagination_page_forms}} / {{pagination_total_pages_forms}}</span><md-button aria-label="Next" \nclass="md-icon-button arrow" hide="" ng-click="pagination_nextPage()" ng-disabled="pagination_morePages()" \nshow-gt-xs="" translate="" translate-attr-aria-label="GLOBAL.NEXT"><md-icon md-font-icon="icon-chevron-right">\n</md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.NEXT">Next</span></md-tooltip></md-button></div>');
$templateCache.put('app/main/apps/divisions/views/read/edit.html','<div class="form-wrapper md-whiteframe-1dp without-line" flex="100"><form name="vm.basicForm" class="md-inline-form" \nnovalidate><div><md-input-container class="md-block"><label ng-bind="\'Name\'"></label> <input type="text" name="name" \nng-model="vm.divisionSelected.name"></md-input-container></div></form></div>');
$templateCache.put('app/main/apps/divisions/views/read/new.html','<div class="form-wrapper md-whiteframe-1dp without-line" flex="100"><form name="vm.basicForm" class="md-inline-form" \nnovalidate><div><md-input-container class="md-block"><label>{{ \'GLOBAL.NAME\' | translate}}</label> <input type="text" \nname="name" ng-model="vm.divisionNew.name"></md-input-container></div></form></div>');
$templateCache.put('app/main/apps/divisions/views/read/read-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="vm.loadingReadPane" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="content thread-detail" layout="row" layout-align="center center" flex \nng-if="!vm.divisionSelected && !vm.divisionNew"><div class="no-thread-selected" layout="column" \nlayout-align="center center" flex><md-icon md-font-icon="icon-google-circles-communities" class="s120 grey-400-fg">\n</md-icon><span class="hint-text" translate="GLOBAL.SELECT_ITEM"></span></div></div><div id="read-view" \nclass="fullheight"><div class="toolbar grey-100-bg colored-bg" layout="row" layout-align="space-between center" \nscroll="" ng-if="vm.divisionSelected ||\xA0vm.divisionNew"><div layout="row" layout-align="start center"></div><div \nlayout="row" layout-align="end center" hide show-gt-sm><md-button translate="GLOBAL.CANCEL" type="button" \nng-click="vm.closeDivision()" class="md-raised md-warn" aria-label="Cancel"></md-button><md-button \ntranslate="GLOBAL.SAVE" type="button" ng-disabled="vm.basicForm.$invalid || vm.basicForm.$pristine" \nng-click="vm.sendDivision()" class="md-raised md-accent" aria-label="Save"></md-button></div><div layout="row" \nlayout-align="end center" hide-gt-sm><md-button type="button" ng-click="vm.sendDivision()" \nng-disabled="vm.checkFields()" class="md-accent md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" \naria-label="Send"><md-icon md-font-icon="icon-plus"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.SAVE"></span></md-tooltip></md-button><md-button type="button" ng-click="vm.closeDivision()" \nclass="md-warn md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" aria-label="Cancel"><md-icon \nmd-font-icon="icon-window-close"></md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.CANCEL"></span>\n</md-tooltip></md-button></div></div><div class="main-content"><content ng-if="vm.divisionSelected" class="" \nlayout="row" ng-include="\'app/main/apps/divisions/views/read/edit.html\'"></content><content ng-if="vm.divisionNew" \nclass="" ng-include="\'app/main/apps/divisions/views/read/new.html\'"></content></div></div>');
$templateCache.put('app/main/apps/divisions/views/list/list-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="isLoading" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="no-threads" ng-if="!vm.divisions" ng-hide="isLoading" translate="GLOBAL.NO_ITEMS"></div><div \nid="list-content-data" ng-style="{\'opacity\' : isLoading ? 0.5 : 1}"><div class="mail-list-item" \nng-repeat="division in vm.divisions | filter: vm.search | filter: global.search" ng-init="parentIndex = $index" \nmd-no-ink ng-click="vm.openDivision(division)" \nng-class="{\'starred\': division.starred, \'selected\': vm.divisionSelected.id === division.id, \'checked\': vm.isSelected(division)}">\n<div layout="row" layout-align="start center"><md-checkbox class="no-label" ng-checked="vm.isSelected(division)" \nng-click="vm.toggleSelectThread(division, $event)" aria-label="{{vm.isSelected(division) ? \'Deselect\' : \'Select\'}}">\n</md-checkbox><div class="avatar-wrapper"></div><div class="info layout-column flex" flex="" layout="column"><div \nclass="name text-truncate" layout="row" layout-align="start center"><span>{{division.name}}</span> <span>\n{{division.last_name}}</span> <span ng-if="division.job_position_id">\n({{vm.getPositionNameById(division.job_position_id)}})</span></div><div class="details text-truncate" layout="row" \nlayout-align="start center"><span>{{division.email}}</span></div></div></div></div><div \nng-if="!isLoading && pagination_total_pages > pagination_page && vm.divisions.length > 0" class="load-more white p-30" \nlayout="row" layout-sm="column" layout-align="center center" layout-wrap=""><md-button \nng-click="pagination_nextPage(true)" class="md-raised">{{\'GLOBAL.LOAD_MORE\' |\xA0translate}}</md-button></div><div \nng-if="pagination_total_pages == pagination_page && pagination_page > 1" class="load-more white p-30" layout="row" \nlayout-sm="column" layout-align="center center" layout-wrap=""><div class="message" translate="GLOBAL.NO_MORE_ITEMS">\n</div></div></div>');
$templateCache.put('app/main/apps/divisions/views/list/nosplit-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.divisionSelected && !vm.divisionNew" \nng-include="\'app/main/apps/divisions/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row">\n<div class="content thread-detail mail-read-pane p0" flex="" id="thread-detail" ms-scroll="vm.msScrollOptions" \nng-if="vm.divisionSelected || vm.divisionNew" ng-include="\'app/main/apps/divisions/views/read/read-view.html\'"></div>\n<div class="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="!vm.divisionSelected && !vm.divisionNew" ng-include="\'app/main/apps/divisions/views/list/list-view.html\'"></div>\n</div>');
$templateCache.put('app/main/apps/divisions/views/list/split-view.html','<div class="toolbar" layout="row" layout-align="space-between center" \nng-include="\'app/main/apps/divisions/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row">\n<div class="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-include="\'app/main/apps/divisions/views/list/list-view.html\'"></div><div \nclass="content thread-detail mail-read-pane p0" flex="" id="thread-detail" ms-scroll="vm.msScrollOptions" \nng-include="\'app/main/apps/divisions/views/read/read-view.html\'"></div></div>');
$templateCache.put('app/main/apps/divisions/views/list/toolbar.html','<div layout="row" layout-align="start center"><md-checkbox class="no-label" \naria-label="{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}" \nng-checked="vm.selectedThreads.length > 0" ng-click="vm.toggleSelectThreads(vm.selectedThreads, vm.contents)">\n</md-checkbox><div class="divider-vertical" hide="" show-gt-xs=""></div><md-button aria-label="NEW" \nclass="md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme" hide show-gt-sm \nng-click="vm.newDivision()" translate="GLOBAL.NEW" type="button"></md-button><md-button aria-label="NEW" \nclass="md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme z-index-0" hide-gt-sm \nng-click="vm.newDivision()" type="button"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="divider-vertical" hide="" show-gt-xs=""></div><div aria-hidden="false" \nclass="action-buttons hide show-gt-xs layout-align-start-center layout-row" layout="row" layout-align="start center" \nng-show="vm.selectedThreads.length > 0"><md-button ng-click="vm.deleteDivision($event)" aria-label="Delete" \nclass="md-icon-button" hide="" show-gt-xs="" translate=""><md-icon md-font-icon="icon-delete"></md-icon><md-tooltip \nhide show-gt-xs><span translate="GLOBAL.REMOVE"></span></md-tooltip></md-button><md-button \nng-click="vm.duplicateDivision()" aria-label="Duplicate" class="md-icon-button" hide="" show-gt-sm="" translate="" \ntranslate-attr-aria-label="GLOBAL.DUPLICATE"><md-icon md-font-icon="icon-content-duplicate"></md-icon><md-tooltip><span\n translate="GLOBAL.DUPLICATE"></span></md-tooltip></md-button><div class="divider-vertical" hide="" show-gt-xs="">\n</div></div><ms-search-bar debounce="300" model-search="$root.pagination_searchquery" \non-result-click="vm.searchResultClick(item)" on-search="vm.search(query)" layout="row" layout-align="start center">\n</ms-search-bar><md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" \ntranslate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nng-if="$root.pagination_searchquery==true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip \nhide show-gt-xs><span>Reset search</span></md-tooltip></md-button><div class="divider-vertical" hide="" show-gt-xs="">\n</div><md-menu hide="" show-gt-xs="" ng-if="refGroupables.length>0"><button aria-label="Filters" \nclass="md-icon-button" ng-click="$mdMenu.open($event)" show-gt-xs="" translate="" \ntranslate-attr-aria-label="GLOBAL.FILTERS"><md-icon md-font-icon="icon-chevron-down"><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.GROUP_BY">Group</span></md-tooltip></md-icon></button><md-menu-content width="4"><md-menu-item \nng-repeat="sortfield in refGroupables"><md-button aria-label="All" ng-click="pagination_setOrderBy(sortfield)"><div \nlayout="row" layout-align="space-between center"><span>Group by {{sortfield.name}} </span><i class="icon-check s16" \nng-if="sortfield.titleId == sortable.titleId"></i></div></md-button></md-menu-item><md-menu-divider ng-if="groupable">\n</md-menu-divider><md-menu-item ng-if="groupable"><md-button aria-label="Remove group" \nng-click="pagination_resetOrderBy()"><md-icon md-font-icon="icon-close "></md-icon><span>Remove order</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div><div layout="row" layout-align="start center" \ntranslate-attr-aria-label="GLOBAL.REFRESH"><span ng-if="!isLoading" class="page-info font-weight-500">\n{{vm.divisions.length}} {{ \'GLOBAL.OF\' | translate}} {{pagination_totalItems}} {{ \'GLOBAL.ITEMS\' | translate}}.</span>\n<div class="divider-vertical" hide hide show-gt-sm></div><md-button class="md-icon-button" \nng-click="vm.changeView(\'nosplit\')" ng-if="vm.currentView !== \'nosplit\'" hide show-gt-sm><md-icon \nmd-font-icon="icon-view-list" ng-if="vm.currentView !== \'nosplit\'"></md-icon><md-icon class="md-accent" \nmd-font-icon="icon-checkbox-marked" ng-if="vm.currentView === \'nosplit\'"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.NOSPLIT_VIEW">No split</span></md-tooltip></md-button><md-button class="md-icon-button" \nng-click="vm.changeView(\'split\')" ng-if="vm.currentView !== \'split\'" hide show-gt-sm><md-icon \nmd-font-icon="icon-view-quilt" ng-if="vm.currentView !== \'split\'"></md-icon><md-icon class="md-accent" \nmd-font-icon="icon-checkbox-marked" ng-if="vm.currentView === \'split\'"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.SPLIT_VIEW">split</span></md-tooltip></md-button><md-menu class="settings-menu" hide-gt-xs \nng-show="vm.selectedThreads.length > 0"><md-button aria-label="Settings" class="md-icon-button" \nng-click="$mdMenu.open($event)" translate="GLOBAL.SETTINGS" translate-attr-aria-label="GLOBAL.SETTINGS"><md-icon \nmd-font-icon="icon-dots-horizontal"></md-icon></md-button><md-menu-content><md-menu-item ng-click="vm.deleteClient()" \nshow="vm.selectedMail.length > 0 || vm.allChecked"><md-button ng-click="vm.deleteDivision($event)" aria-label="Delete" \ntranslate-aria-label="GLOBAL.DELETE"><md-icon md-font-icon="icon-delete"></md-icon><span translate="GLOBAL.DELETE">\nDelete</span></md-button><md-button ng-click="vm.duplicateDivision()" aria-label="Duplicate" \ntranslate-aria-label="GLOBAL.DUPLICATE"><md-icon md-font-icon="icon-content-duplicate"></md-icon><span \ntranslate="GLOBAL.DUPLICATE">Duplicate</span></md-button></md-menu-item></md-menu-content></md-menu></div>');
$templateCache.put('app/main/apps/dashboard/dialogs/view-item-list-dashboard.dialog/view-item-list-dashboard.dialog.html','<md-dialog id="view-item-list-dashboard" class="form-dialog" aria-label="Odds of occurence"><md-toolbar \nclass="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><h1 \nstyle="background: transparent;">{{ \'DASHBOARD.LIST\' | translate}} {{ \'DASHBOARD.\'+vm.type | translate}}</h1><div \nclass="absolute-right pr-10" layout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog" tranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></div></md-toolbar><md-dialog-content class="mediadialog-content" flex><md-list-item \nng-class="{\'bb\' : vm.type !== \'ACTIVITIES\'}" ng-repeat="item in vm.items" ng-click="vm.selectItem(item)"><div \nng-if="vm.type !== \'ACTIVITIES\'" class="ph-25 pv-10" layout="column" fill-width><p class="grey-700-fg bold">\n{{item.title}}</p><p ng-if="item.description && vm.type !== \'COMPLAINTS\'" class="mt-0" \nng-class="{\'bold\': !item.title}" style="line-height: 1.1">{{item.description}}</p><p class="grey-700-fg">\n{{item.date | amDateFormat:\'DD MMM YYYY\'}}</p><p class="grey-700-fg">{{item.company.name}} <span ng-if="item.branch">\n({{item.branch.name}})</span></p></div><div ng-if="vm.type == \'ACTIVITIES\'" id="timeline" \nclass="timeline-left ms-timeline"><div style="padding-top: 10px;padding-bottom: 10px;" class="ms-timeline-item" \nlayout="row" layout-align="start center"><div class="timeline-point md-accent-bg"><md-icon \nmd-font-icon="icon-telegram"></md-icon></div><h3 class="name mt-0 mb-0 ml-15" flex-xs="80"><div class="event">\n{{\'STAFF.\'+item.action_id.toUpperCase() | translate }} <a class="pointer" target="_blank">{{item.action_brief.name}}\n</a></div></h3><div class="timeline-detail" layout="row" layout-align="start center"><div class="time" \nng-bind-html="vm.timeAgo(item.date)"></div></div></div></div></md-list-item></md-dialog-content><md-dialog-actions \nlayout="row" layout-align="end center" class="grey-100-bg"><md-button translate="GLOBAL.ACCEPT" type="button" \nng-click="vm.closeDialog()" class="md-raised md-accent" aria-label="Cancel"></md-button></md-dialog-actions>\n</md-dialog>');
$templateCache.put('app/main/apps/documents/dialogs/delete-dialog/delete-document-dialog.html','<md-dialog id="delete-dialog" class="delete-dialog compose-dialog" aria-label="DELETE"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between"><h1 class="title" \ntranslate="DOCUMENTS.CONFIRM_DELETE"></h1><md-button class="md-icon-button" ng-click="vm.cancel()"><md-icon \nmd-font-icon="icon-close" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><div>\n<div class="md-dialog-content-body"><div class="mail-list-item" ng-repeat="document in vm.selectedThreads" \nng-class="{\'selected\': vm.documentIDSelected === document.id}" data-id="{{document.id}}"><div layout="row" \nlayout-align="start center"><div fill-width layout="row" layout-align="start center"><div class="preview" layout="row" \nlayout-align="center center"><img ng-src="https://h2c-clients-upload.s3.amazonaws.com/{{document.url}}" alt=""></div>\n<div class="info" flex layout="column"><div class="subject text-truncate grey-500-fg" layout="row" \nlayout-align="start center"><span>Date uploaded: {{document.created_at}}</span></div><div class="name" layout="row" \nlayout-align="start center"><span ng-bind="document.url" ng-if="document.url"></span></div></div><div \nclass="subject buttons text-truncate grey-500-fg" layout="row" layout-align="start center"><span>#{{document.id}}\n</span></div></div></div></div></div></div></md-dialog-content><md-dialog-actions><md-button \nclass="send-button md-raised" translate="DOCUMENTS.CANCEL" aria-label="CANCEL" ng-click="vm.cancel()"></md-button>\n<md-button class="send-button md-warn md-raised" translate="DOCUMENTS.DELETE" aria-label="DELETE" \nng-click="vm.delete()"></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/main/apps/documents/dialogs/groups/edit-group.html','<md-dialog class="small groups-dialog" aria-label="Edit Group"><form class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><div \nlayout="row" layout-align="start center"><a class="md-button grey-A100-fg" type="import" layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-folder" class="s18 mr-5 ml-0 md-font material-icons" \nrole="img" aria-label="icon-folder"></md-icon><span class="title" ng-if="vm.edit" translate="DOCUMENTS.EDIT"></span> \n<span class="title" ng-if="!vm.edit" translate="DOCUMENTS.CREATE"></span></a></div><div layout="row" \nlayout-align="end center"><md-button class="md-icon-button" ng-click="cancel()" aria-label="Close dialog" \ntranslate-aria-label="GROUP.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class="md-block"><label translate="DOCUMENTS.NAME">\n</label> <input ng-model="vm.groupName" type="text" required></md-input-container><md-input-container \nclass="md-block on-off mt-0"><label class="md-container-ignore" translate="DOCUMENTS.MOVE_TO"></label><md-menu \nid="menu"><button class="mr-0 width-percent-100 pb-5 pt-5 button-select" ng-click="$mdMenu.open($event)" \naria-label="group-menu" layout="row" layout-align="space-between center"><span ng-if="vm.groupParentName" \nclass="font-size-14">{{vm.groupParentName}}</span> <span ng-if="!vm.groupParentName" class="font-size-14" \ntranslate="DOCUMENTS.ROOT"></span><md-icon md-font-icon="icon-menu-down" class="grey-600-fg ml-10 mr-0" \naria-hidden="true"></md-icon></button><md-menu-content class="md-block groups-tree"><div \nng-click="vm.selectParentGroupRoot()" class="level-card p-8 group-row ng-scope" layout="row" \nlayout-align="space-between stretch"><div flex class="layout-align-start-center layout-row flex"><md-icon \nmd-font-icon="icon-folder-multiple" \nclass="orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 ng-scope md-default-theme md-font material-icons icon-folder-multiple" \naria-hidden="true"></md-icon><span translate="DOCUMENTS.ROOT"></span></div></div><div ng-click="$mdCloseMenu($event)" \nng-if="vm.groups" ivh-treeview="vm.groups" class="ivh-treeview-folder small" ivh-treeview-label-attribute="\'name\'">\n<script type="text/ng-template">\n<div class="level-card p-8 group-row select-parent-group-row" layout="row" layout-align="space-between stretch">\n                        <span  ivh-treeview-toggle layout="row" layout-align="center center"></span>\n                        <div h2c-on-click-select-parent-group flex id="treeview-group-{{node.id_group}}" data-group-node={{node}} layout="row" layout-align="start center">\n                            <md-icon  \n                                md-font-icon="icon-folder" \n                                class="orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 " \n                                aria-hidden="true" >\n                            </md-icon>\n                            <span class="ivh-treeview-node-label ng-binding">{{trvw.label(node)}}</span>\n                        </div>\n                      </div>\n                    <div class="ivh-treeview-children-groups" ivh-treeview-children></div>\n</script></div></md-menu-content></md-menu></md-input-container></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="space-between center"><div layout="row" layout-align="start center"><md-button \nng-click="delete(vm.group, $event)" class="md-icon-button" aria-label="Delete" ng-if="vm.edit" \ntranslate-attr-aria-label="DOCUMENTS.DELETE"><md-icon md-font-icon="icon-delete"></md-icon><md-tooltip hide show-gt-xs>\n<span translate="DOCUMENTS.DELETE"></span></md-tooltip></md-button></div><div layout="row" layout-align="end center">\n<md-button ng-click="save(vm.group)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="DOCUMENTS.SAVE" translate-attr-aria-label="DOCUMENTS.SAVE"></md-button><md-button ng-click="cancel()" \nclass="send-button md-warn md-raised" aria-label="Cancel" translate="DOCUMENTS.CANCEL" \ntranslate-attr-aria-label="DOCUMENTS.CANCEL"></md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/documents/dialogs/groups/tree-view.html','<div ng-if="vm.usersGroups" ivh-treeview="vm.usersGroups" class="treeview" \nivh-treeview-on-cb-change="vm.checkGroup(ivhNode, ivhIsSelected, ivhTree)"><script type="text/ng-template">\n<div class="level-card p-8 group-row" layout="row" layout-align="space-between stretch">\n            <span ivh-treeview-twistie ivh-treeview-toggle layout="row" layout-align="center center"></span>\n            <div flex id="treeview-group-{{node.id_group}}" h2c-on-click-load-users-by-groups data-group-node={{node}} layout="row" layout-align="start center">\n                <md-icon ng-if ="!node.children && node.id_group_type == 1" \n                    md-font-icon="icon-folder" \n                    class="orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 " \n                    aria-hidden="true" >\n                </md-icon>\n                <md-icon ng-if ="!node.children && node.id_group_type == 2" \n                    md-font-icon="h2c-icon-file-usermailing" \n                    class="orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 " \n                    aria-hidden="true" >\n                </md-icon>\n                <md-icon ng-if ="!node.children && node.id_group_type == 3" \n                    md-font-icon="h2c-icon-file-usermediacenter" \n                    class="orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 " \n                    aria-hidden="true" >\n                </md-icon>\n                <md-icon ng-if ="!node.children && node.id_group_type == 4" \n                    md-font-icon="h2c-icon-file-usersegment" \n                    class="orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 " \n                    aria-hidden="true" >\n                </md-icon>\n                <md-icon ng-if ="!node.children && node.id_group_type == 5" \n                    md-font-icon="h2c-icon-file-userstore" \n                    class="orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 " \n                    aria-hidden="true" >\n                </md-icon>\n                <md-icon ng-if ="!node.children && node.id_group_type == 6" \n                    md-font-icon="h2c-icon-file-useracreditation" \n                    class="orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 " \n                    aria-hidden="true" >\n                </md-icon>\n                <md-icon \n                    ng-if ="node.children" \n                    md-font-icon="icon-folder-multiple" \n                    class="orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 " \n                    aria-hidden="true" >\n                </md-icon>\n                <span class="ivh-treeview-node-label" ivh-treeview-toggle>{{trvw.label(node)}}</span>\n            </div>\n            <div layout="row" layout-align="end center">\n                <md-select\n                    h2c-on-change-set-in-group-status\n                    ng-model="idIngroupStatus"\n                    placeholder="Select a status"\n                    class="mr-10">\n                    <md-option\n                        ng-value="status.id_ingroup_status"\n                        ng-selected="status.id_ingroup_status == node.id_ingroup_status"\n                        ng-repeat="status in node.ingroup_status"\n                        translate="USERS.INGROUP.STATUS.{{status.name | uppercase}}" />\n                </md-select>\n                <md-checkbox\n                    aria-label="assign group"\n                    h2c-on-check-toggle-assigned-group\n                    class="ml-5 mb-0" />\n            </div>\n        </div>\n        <div ivh-treeview-children />\n</script></div>');
$templateCache.put('app/main/apps/documents/dialogs/groups/users-groups-view.html','<md-dialog class="attachment-dialog add-media" aria-label="New Message"><md-toolbar class="md-accent"><div \nclass="md-toolbar-tools" layout="row" layout-align="space-between center"><div layout="row"><md-button \nclass="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="DOCUMENTS.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content id="site-mailing" ms-scroll flex class="content-card" ng-include="vm.viewUsersGroup">\n</md-dialog-content><md-dialog-actions layout="row" layout-align="space-between center"><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.save()" class="send-button md-accent md-raised" \ntranslate="DOCUMENTS.SAVE"></md-button><md-button ng-click="vm.closeDialog()" \nclass="cancel-button md-accent md-raised" translate="DOCUMENTS.CANCEL"></md-button></div></md-dialog-actions>\n</md-dialog>');
$templateCache.put('app/main/apps/documents/dialogs/import/import-dialog.html','<md-dialog class="import-dialog" aria-label="New Message"><form class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between"><h1 class="title" \ntranslate="DOCUMENTS.IMPORT"></h1><md-button class="md-icon-button" ng-click="vm.closeDialog()"><md-icon \nmd-font-icon="icon-close" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content \nng-if="!vm.importError" ms-scroll flex class="content-card" ng-class="vm.currentView"><div ng-if="!vm.groupId"><div \nclass="text-center label-group-selector"><label>{{ \'DOCUMENTS.SELECT_GROUP_TO_ADD_FILE\' | translate}}</label></div><div\n ng-if="vm.groups && !vm.files " ivh-treeview="vm.groups" ivh-treeview-label-attribute="\'name\'" \nclass="ivh-treeview-folder small selected" ivh-treeview-on-cb-change="callback()"><script type="text/ng-template">\n<div class="level-card p-8 group-row" layout="row" layout-align="space-between stretch">\n                            <span ivh-treeview-twistie ivh-treeview-toggle layout="row" layout-align="center center"></span>\n                            <div flex id="treeview-group-{{node.id}}" h2c-on-select-group data-group-node={{node}} layout="row" layout-align="start center">\n                            <md-icon\n                                        style="cursor: pointer!important"\n                                    md-font-icon="icon-folder"\n                                    class="s24 mr-10 mt-0 ml-0 mb-0 "\n                                    aria-hidden="true" >\n                                </md-icon>\n                                <div class="group-status green-bg" ng-if="node.status ===1" role="button" aria-label="group-status"></div>\n                                <span class="ivh-treeview-node-label ng-binding">{{node.name}}</span>\n                            </div>\n                        </div>\n                        <div ivh-treeview-children></div>\n</script></div></div><div ng-if="vm.groupId" ngf-drop ng-class="{\'disabled\' : !vm.groupId}" ng-disabled="!vm.groupId" \nngf-select ng-model="vm.files" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="false" \nngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.eml,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.eml,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'">\n<div layout="column"><div flex translate="DOCUMENTS.DROP_OR_UPLOAD"></div><div flex translate="DOCUMENTS.OR"></div><div\n flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="DOCUMENTS.SELECT_FROM_COMPUTER"></md-button></div></div><div ng-repeat="f in vm.files" class="ms-card" flex>\n<div class="ms-card-content-wrapper imported-files"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><img ngf-thumbnail="!f.$error && f" class="image"></div><div class="header p-16" flex><div\n layout="row" layout-align="space-between center" flex><div class="size" layout="row" layout-align="start left"><strong\n class="mr-5" ng-if="f.id">#{{f.id}}</strong> <span class="grey-500-fg"><span ng-if="f.name">{{f.name}}</span></span>\n</div></div></div><md-progress-linear md-mode="determinate" value="{{f.progress}}" ng-show="f.progress < 100">\n</md-progress-linear></div></div></div><div flex layout="column" layout-align="center center" ng-if="vm.isLoading" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="50"></md-progress-circular></div>\n</div><div ngf-no-file-drop>File Drag/Drop is not supported for this browser</div></md-dialog-content>\n<md-dialog-content ng-if="vm.importError"><p class="import-error">{{vm.importError}}</p></md-dialog-content>\n<md-dialog-actions layout="row" layout-align="space-between center" ng-if="!vm.loading"><md-input-container flex \nlayout="row" layout-align="end center"><md-button type="button" class="send-button md-accent md-raised" \nng-click="vm.groupId = null; vm.files = null;vm.importFinished = false;" translate="DOCUMENTS.BACK"></md-button>\n<md-button ng-disabled="!vm.files && !vm.importFinished && file.progress !== 100" type="submit" \nclass="send-button md-accent md-raised" ng-click="vm.importFile()" translate="DOCUMENTS.IMPORT"></md-button><md-button \ntype="button" class="md-raised md-warn" ng-click="vm.closeDialog()" translate="DOCUMENTS.CANCEL"></md-button>\n</md-input-container></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/documents/sidenavs/documents/documents-sidenav.html','<md-toolbar class="md-default-theme grey-100-bg grey-600-fg pr-16 pl-16" layout="row" \nlayout-align="space-between center"><div class="md-toolbar-tools p-0" layout="row" layout-align="start center"><div \ntranslate-attr-aria-label="DOCUMENTS.FOLDERS" translate="DOCUMENTS.FOLDERS" class="grey-600-fg"></div></div><div \nlayout="row" layout-align="end center"><md-icon id="" ng-click="vm.createGroupDocuments($event)" \nmd-font-icon="icon-plus" class="m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons" \naria-hidden="true"><md-tooltip><span translate="DOCUMENTS.ADD">Add</span></md-tooltip></md-icon><ms-search-bar \ndebounce="300" model-search="" on-result-click="" on-search="" layout="row" layout-align="start center">\n</ms-search-bar><div class="divider-vertical hide show-gt-xs" hide="" show-gt-xs=""></div><md-icon \nng-click="vm.toggleSidenav(\'documents-sidenav\')" md-font-icon="icon-backburger" \nclass="m-0 grey-600-fg md-icon md-button md-default-theme md-font material-icons md-icon-button icon-backburger" \naria-hidden="true"></md-icon></div></md-toolbar><md-content ms-scroll class="" flex><div class="navigation-simple" \nlayout="column"><div hidden id="includeSubgroups" data-include-subgroups="{{includeSubgroups}}"></div><div \nng-if="vm.groups" ivh-treeview="vm.groups" ivh-treeview-filter="$root.modelSearch" \nivh-treeview-label-attribute="\'name\'" class="ivh-treeview-folder small" ivh-treeview-on-cb-change="callback()"><script \ntype="text/ng-template">\n<div class="level-card p-8 group-row" layout="row" layout-align="space-between stretch">\n                    <span ivh-treeview-twistie ivh-treeview-toggle layout="row" layout-align="center center"></span>\n                    <div flex id="treeview-group-{{node.id}}" h2c-on-click-load-files-by-groups data-group-node={{node}} layout="row" layout-align="start center">\n                       <md-icon\n                                style="cursor: pointer!important"\n                            md-font-icon="icon-folder"\n                            class="s24 mr-10 mt-0 ml-0 mb-0 "\n                            aria-hidden="true" >\n                        </md-icon>\n                        <div class="group-status green-bg" ng-if="node.status ===1" role="button" aria-label="group-status"></div>\n                        <span class="ivh-treeview-node-label ng-binding">{{node.name}}</span>\n                        \n\n                    </div>\n                    <div ng-if="!node.read_only" layout="row" layout-align="end center">\n                            <md-button h2c-on-click-open-group-edit-dialog class="md-icon-button" type="button" aria-label="ACTIONS">\n                                <md-icon md-font-icon="icon-pencil" aria-hidden="true"></md-icon>\n                            </md-button>\n                            <md-icon qiu-on-click-close-sidenav sidenav-id="groups-sidenav" md-font-icon="icon-chevron-right" aria-hidden="true" hide-gt-sm class="mt-0 mb-0"></md-icon>\n                    </div>\n                </div>\n                <div ivh-treeview-children></div>\n</script></div></div></md-content>');
$templateCache.put('app/main/apps/documents/views/list/edit-layout.html','');
$templateCache.put('app/main/apps/documents/views/list/items-view.html','<div class="toolbar" layout="row" layout-align="space-between center" \nng-include="\'app/main/apps/documents/views/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row"><div \nclass="content thread-list mail-list-pane" flex="50" id="thread-list" \nng-include="\'app/main/apps/documents/views/list/list-view.html\'" on-size-changed="vm.logResize" \nng-style="!vm.documentSelected && {\'max-width\': \'100%\'} || {\'max-width\': \'50%\'}"></div><div \nclass="content thread-detail mail-read-pane" flex="50" id="thread-detail" layout="column" \nng-include="\'app/main/apps/documents/views/edit-layout.html\'" ng-if="vm.documentSelected"></div></div>');
$templateCache.put('app/main/apps/documents/views/list/list-view.html','<div flex layout="column" layout-align="center center" ng-show="vm.isLoading" class="loading-container">\n<md-progress-circular md-mode="indeterminate" md-diameter="50"></md-progress-circular></div><div \nclass="mail-list-item filter-selected" ng-if="vm.groupSelected" layout="row" layout-align="start center"><div \nclass="info" flex><div class="name" layout="row" layout-align="start center"><md-icon md-font-icon="icon-folder" \nclass="s20 mr-8 ml-0 mb-0" aria-hidden="true"></md-icon><div class="title text-truncate" layout="row" \nlayout-align="start center">{{vm.groupSelected.name}} ({{pagination_totalItems | number}})</div></div></div><div \nclass="buttons" layout="row" layout-align="start center"><div><md-switch class="no-label" \nng-checked="includeSubgroups" ng-click="vm.toggleincludeSubgroups($event)" \naria-label="{{includeSubgroups ? \'Uncheck\':\'check\'}}"></md-switch><md-tooltip><span \ntranslate="DOCUMENTS.INCLUDE_SUBGROUPS">Include subgroups</span></md-tooltip></div><md-icon \nmd-font-icon="icon-close s20" ng-click="vm.unselectGroups()" class="ml-10"><md-tooltip hide show-gt-xs><span \ntranslate="DOCUMENTS.DESELECT_GROUP">Deselect group</span></md-tooltip></md-icon></div></div><div \nclass="mail-list-item filter-selected" ng-if="$root.pagination_searchquery==true" layout="row" \nlayout-align="start center"><div class="info" flex><div class="name" layout="row" layout-align="start center"><md-icon \nmd-font-icon="icon-filter" class="s20 mr-8 ml-0 mb-0" aria-hidden="true"></md-icon><div class="title" layout="row" \nlayout-align="start center"><div ng-repeat="filterable in refFilterables track by $index" class="inline-block"><div \nng-repeat="label in filterable.values | filterInArray:filterable.selected:\'value\' track by $index" \nclass="mr-5 tag-list inline-block"><span class="grey-50-fg">{{label.name}}</span></div></div></div><div \nclass="title text-truncate pl-10" layout="row" layout-align="start center" ng-if="$root.modelSearch">\n{{$root.modelSearch}}</div></div></div><div class="buttons" layout="row" layout-align="start center"><md-icon \nmd-font-icon="icon-close s20" ng-click="$root.pagination_resetquery()" class="ml-10"><md-tooltip hide show-gt-xs><span \ntranslate="DOCUMENTS.REMOVE_FILTERS">Remove filters</span></md-tooltip></md-icon></div></div><div \nclass="content-wrapper fullheight" layout="row" flex ng-if="!vm.isLoading && vm.documents.length === 0" \nng-hide="vm.isLoading"><div class="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-timelapse" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="DOCUMENTS.THERE_ARE_NO_FILES"></span></div></div></div><div id="list-content-data" \nng-style="{\'opacity\' : vm.isLoading ? 0.2 : 1}" ms-scroll="vm.msScrollOptions" \nng-class="{\'mt-40\' : vm.groupSelected && vm.documents.length > 0,\'group-filter\': vm.selectedGallery,\'other-filter\':$root.pagination_searchquery==true}" \nclass="scrollable" ng-if="vm.documents.length > 0"><div><div class="mail-list-item" \nng-repeat="document in vm.documents" ng-class="{\'selected\': vm.documentIDSelected === document.id}" \ndata-id="{{document.id}}"><div layout="row" layout-align="start center"><div fill-width layout="row" \nlayout-align="start center"><md-checkbox ng-checked="vm.isSelected(document)" \nng-click="vm.toggleSelectThread(document, $event)" aria-label="{{vm.isSelected(document) ? \'Deselect\' : \'Select\'}}" \nclass="mb-0"></md-checkbox><div class="media photos" layout="row" layout-align="center center"><h2c-icon \nfile="document.url"></h2c-icon><img ng-src="{{storagePrefix+document.url}}" alt=""></div><div class="info" flex \nlayout="column"><div class="subject text-truncate grey-500-fg" layout="row" layout-align="start center"><span>\n{{document.created_at_format }}</span></div><div class="name" layout="row" layout-align="start center"><span \nng-if="document.original_name">{{document.original_name}}</span></div></div><div layout="row" \nlayout-align="end center"><md-menu><md-button class="md-icon-button" aria-label="More" \nng-click="vm.openMenu($mdMenu, $event)"><md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg">\n</md-icon></md-button><md-menu-content width="2"><md-menu-item><md-button ng-click="vm.downloadFile(document)" \ntarget="_blank" download aria-label="Edit"><md-icon md-font-icon="icon-download"></md-icon><span \ntranslate="DOCUMENTS.DOWNLOAD"></span></md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.showFileInfo(document, $event)" target="_blank" download aria-label="Edit"><md-icon \nmd-font-icon="icon-lock"></md-icon><span translate="DOCUMENTS.CHECK_TSA_VERIFICATION"></span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click="vm.openDialogUsers($event, document.id)" aria-label="Delete"><md-icon\n md-font-icon="icon-telegram" class="md-default-theme md-font material-icons icon-telegram"></md-icon><span \ntranslate="DOCUMENTS.SEND_BY_EMAIL"></span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div>\n</div></div><md-divider></md-divider><div class="toolbar" layout="row" layout-align="end center"><div layout="row" \nlayout-align="center center" ng-style="{\'display\' : vm.isLoading ? \'none\' : \'block\'}"><span class="page-info">\n{{pagination_totalItems | number}} <span translate="GLOBAL.ITEMS_FOUND"></span></span><md-button aria-label="Previous" \nclass="md-icon-button arrow" ng-click="pagination_prevPage()" ng-disabled="pagination_firstPage()" translate="" \ntranslate-attr-aria-label="DOCUMENTS.PREVIOUS"><md-icon md-font-icon="icon-chevron-left"></md-icon></md-button><span \nclass="page-info">{{pagination_current_page | number}} / {{pagination_total_pages | number}}</span><md-button \naria-label="Next" class="md-icon-button arrow" ng-click="pagination_nextPage()" ng-disabled="pagination_morePages()" \ntranslate="" translate-attr-aria-label="DOCUMENTS.NEXT"><md-icon md-font-icon="icon-chevron-right"></md-icon>\n</md-button></div></div></div>');
$templateCache.put('app/main/apps/e-commerce/views/dashboard/dashboard.html','<div id="dashboard-ecommerce" class="page-layout blank" layout="row"><div class="center" flex ms-scroll><div \nclass="content"><div class="widget-group" layout="row" flex="100" layout-wrap><ms-widget flippable="true" \nlayout="column" flex="100" flex-gt-xs="50" flex-gt-md="25"><ms-widget-front class="white-bg"><div \nclass="ph-8 pv-16 h-55" layout="row" layout-align="space-between center"><md-select class="simplified font-size-16" \nng-model="vm.widget1.currentRange" aria-label="Change range"><md-option ng-repeat="(key, range) in vm.widget1.ranges" \nvalue="{{key}}">{{range}}</md-option></md-select><md-menu><md-button class="md-icon-button" ng-click="$mdMenu.open()" \naria-label="more"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content width="3">\n<md-menu-item><md-button ng-click="flipWidget()" aria-label="Flip widget">Details</md-button></md-menu-item>\n<md-menu-item><md-button ng-click="refreshWidget()" aria-label="Refresh widget">Refresh</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class="pt-8 pb-32" layout="column" layout-align="center center"><div \nclass="light-blue-fg font-size-72 line-height-72">{{vm.widget1.data.count[vm.widget1.currentRange]}}%</div><div \nclass="h3 secondary-text font-weight-500">{{vm.widget1.data.label}}</div></div><div class="p-16 grey-50-bg border-top" \nlayout="row" layout-align="start center"><span class="h4 secondary-text text-truncate">{{vm.widget1.data.extra.label}}:\n</span> <span class="h4 ml-8">{{vm.widget1.data.extra.count[vm.widget1.currentRange]}}</span></div></ms-widget-front>\n<ms-widget-back class="p-16 white-bg"><div class="flip-to-front"><md-button class="md-icon-button" \nng-click="flipWidget()" aria-label="Flip widget"><md-icon md-font-icon="icon-close" class="s16"></md-icon></md-button>\n</div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable="true" layout="column" \nflex="100" flex-gt-xs="50" flex-gt-md="25"><ms-widget-front class="white-bg"><div class="pl-16 pr-8 pv-16 h-55" \nlayout="row" layout-align="space-between center"><div class="h3">{{vm.widget2.title}}</div><md-menu><md-button \nclass="md-icon-button" ng-click="$mdMenu.open()" aria-label="more"><md-icon md-font-icon="icon-dots-vertical">\n</md-icon></md-button><md-menu-content width="2"><md-menu-item><md-button ng-click="flipWidget()" \naria-label="Flip widget">Details</md-button></md-menu-item><md-menu-item><md-button ng-click="refreshWidget()" \naria-label="Refresh widget">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass="pt-8 pb-32" layout="column" layout-align="center center"><div class="red-fg font-size-72 line-height-72">\n${{vm.widget2.data.count}}</div><div class="h3 secondary-text font-weight-500">{{vm.widget2.data.label}}</div></div>\n<div class="p-16 grey-50-bg border-top" layout="row" layout-align="start center"><span \nclass="h4 secondary-text text-truncate">{{vm.widget2.data.extra.label}}:</span> <span class="h4 ml-8">\n${{vm.widget2.data.extra.count}}</span></div></ms-widget-front><ms-widget-back class="p-16 white-bg"><div \nclass="flip-to-front"><md-button class="md-icon-button" ng-click="flipWidget()" aria-label="Flip widget"><md-icon \nmd-font-icon="icon-close" class="s16"></md-icon></md-button></div><div>{{vm.widget2.detail}}</div></ms-widget-back>\n</ms-widget><ms-widget flippable="true" layout="column" flex="100" flex-gt-xs="50" flex-gt-md="25"><ms-widget-front \nclass="white-bg"><div class="pl-16 pr-8 pv-16 h-55" layout="row" layout-align="space-between center"><div class="h3">\n{{vm.widget3.title}}</div><md-menu><md-button class="md-icon-button" ng-click="$mdMenu.open()" aria-label="more">\n<md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content width="2"><md-menu-item><md-button \nng-click="flipWidget()" aria-label="Flip widget">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click="refreshWidget()" aria-label="Refresh widget">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class="pt-8 pb-32" layout="column" layout-align="center center"><div \nclass="orange-fg font-size-72 line-height-72">{{vm.widget3.data.count}}</div><div \nclass="h3 secondary-text font-weight-500">{{vm.widget3.data.label}}</div></div><div class="p-16 grey-50-bg border-top" \nlayout="row" layout-align="start center"><span class="h4 secondary-text text-truncate">{{vm.widget3.data.extra.label}}:\n</span> <span class="h4 ml-8">{{vm.widget3.data.extra.count}}</span></div></ms-widget-front><ms-widget-back \nclass="p-16 white-bg"><div class="flip-to-front"><md-button class="md-icon-button" ng-click="flipWidget()" \naria-label="Flip widget"><md-icon md-font-icon="icon-close" class="s16"></md-icon></md-button></div><div>\n{{vm.widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable="true" layout="column" flex="100" \nflex-gt-xs="50" flex-gt-md="25"><ms-widget-front class="white-bg"><div class="pl-16 pr-8 pv-16 h-55" layout="row" \nlayout-align="space-between center"><div class="h3">{{vm.widget4.title}}</div><md-menu><md-button \nclass="md-icon-button" ng-click="$mdMenu.open()" aria-label="more"><md-icon md-font-icon="icon-dots-vertical">\n</md-icon></md-button><md-menu-content width="2"><md-menu-item><md-button ng-click="flipWidget()" \naria-label="Flip widget">Details</md-button></md-menu-item><md-menu-item><md-button ng-click="refreshWidget()" \naria-label="Refresh widget">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass="pt-8 pb-32" layout="column" layout-align="center center"><div class="blue-grey-fg font-size-72 line-height-72">\n${{vm.widget4.data.count}}</div><div class="h3 secondary-text font-weight-500">{{vm.widget4.data.label}}</div></div>\n<div class="p-16 grey-50-bg border-top" layout="row" layout-align="start center"><span \nclass="h4 secondary-text text-truncate">{{vm.widget4.data.extra.label}}:</span> <span class="h4 ml-8">\n${{vm.widget4.data.extra.count}}</span></div></ms-widget-front><ms-widget-back class="p-16 white-bg"><div \nclass="flip-to-front"><md-button class="md-icon-button" ng-click="flipWidget()" aria-label="Flip widget"><md-icon \nmd-font-icon="icon-close" class="s16"></md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back>\n</ms-widget></div><div class="widget-group" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100">\n<ms-widget-front class="white-bg"><div class="ph-16 pv-8 border-bottom" layout="row" \nlayout-align="space-between center" layout-wrap><div class="pv-8 h3">{{vm.widget5.title}}</div><div class="pv-8" \nlayout="row" layout-align="start center" layout-align-sm="end" flex-sm="100"><md-button class="ph-16" \nng-repeat="(key, range) in vm.widget5.ranges" ng-click="vm.widget5.changeRange(key)" \nng-disabled="vm.widget5.currentRange == key">{{range}}</md-button></div></div><div class="p-16"><nvd3 \nclass="h-420 remove-x-lines" config="vm.widget5.mainChart.config" options="vm.widget5.mainChart.options" \ndata="vm.widget5.mainChart.data"></nvd3></div></ms-widget-front></ms-widget></div><div class="widget-group" \nlayout="row" flex="100" layout-wrap><ms-widget layout="column" flex="100" flex-gt-sm="50"><ms-widget-front \nclass="white-bg"><div class="ph-16 border-bottom" layout="row" layout-align="space-between center"><div class="h3">\n{{vm.widget6.title}}</div><div class="pv-16"><md-select class="simplified" ng-model="vm.widget6.currentRange" \nng-change="vm.widget6.changeRange(vm.widget6.currentRange)" aria-label="Change range"><md-option \nng-repeat="(key, range) in vm.widget6.ranges" value="{{key}}">{{range}}</md-option></md-select></div></div><div \nclass="p-16"><nvd3 class="h-400" config="vm.widget6.mainChart.config" options="vm.widget6.mainChart.options" \ndata="vm.widget6.mainChart.data"></nvd3></div><div class="pv-8 mh-16 border-top" layout="row" \nlayout-align="start center" layout-wrap><div class="pv-8 border-right" layout="column" layout-align="center center" \nflex="100" flex-gt-xs="50"><span class="font-size-32">{{vm.widget6.footerLeft.count[vm.widget6.currentRange]}}</span> \n<span class="h4">{{vm.widget6.footerLeft.title}}</span></div><div class="pv-8" layout="column" \nlayout-align="center center" flex="100" flex-gt-xs="50"><span class="font-size-32">\n{{vm.widget6.footerRight.count[vm.widget6.currentRange]}}</span> <span class="h4">{{vm.widget6.footerRight.title}}\n</span></div></div></ms-widget-front></ms-widget><ms-widget layout="column" flex="100" flex-gt-sm="50"><ms-widget-front\n class="white-bg"><div class="ph-16 border-bottom" layout="row" layout-align="space-between center"><div class="h3">\n{{vm.widget7.title}}</div><div class="pv-16"><md-select class="simplified" ng-model="vm.widget7.currentRange" \naria-label="Change range"><md-option ng-repeat="(key, range) in vm.widget7.ranges" value="{{key}}">{{range}}\n</md-option></md-select></div></div><div class="p-16" layout="row" layout-align="space-between center" \nng-repeat="customer in vm.widget7.customers[vm.widget7.currentRange]"><div><div class="h3">{{customer.name}}</div><span\n ng-if="customer.location">{{customer.location}}</span></div><md-button class="md-icon-button" \naria-label="More information"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button></div></ms-widget-front>\n</ms-widget></div></div></div></div>');
$templateCache.put('app/main/apps/e-commerce/views/order/order.html','<div id="e-commerce-order" class="page-layout simple tabbed" layout="column"><div class="header md-accent-bg" \nlayout="row" layout-align="start center"><div class="white-fg" layout="row" layout-align="start center" flex><md-button\n class="goto-orders-button md-icon-button" aria-label="Go to orders" ng-click="vm.gotoOrders()" translate \ntranslate-attr-aria-label="EC.GO_TO_ORDERS"><md-icon md-font-icon="icon-arrow-left"></md-icon></md-button><div \nlayout="column" layout-align="start start"><div class="h2"><span translate="EC.ORDER">Order</span> <span>\n{{vm.order.reference}}</span></div><div class="subtitle secondary-text"><span translate="EC.FROM">from</span> <span>\n{{vm.order.customer.firstName}} {{vm.order.customer.lastName}}</span></div></div></div></div><div class="content">\n<md-tabs md-dynamic-height><md-tab><md-tab-label><span translate="EC.ORDER_DETAILS">Order Details</span></md-tab-label>\n<md-tab-body><div class="order-detail-form-container customer md-background-bg md-whiteframe-1dp"><div class="pb-16" \nlayout="row" layout-align="start center"><md-icon md-font-icon="icon-account" class="m-0 mr-16"></md-icon><div \nclass="h2 secondary-text" translate="EC.CUSTOMER">Customer</div></div><div class="customer"><table class="simple" \nms-responsive-table><thead><tr><th translate="EC.NAME">Name</th><th translate="EC.EMAIL">Email</th><th \ntranslate="EC.PHONE">Phone</th><th translate="EC.COMPANY">Company</th></tr></thead><tbody><tr><td><div layout="row" \nlayout-align="start center"><img class="avatar" ng-src="{{vm.order.customer.avatar}}"> <span class="name text-nowrap">\n{{vm.order.customer.firstName}} {{vm.order.customer.lastName}}</span></div></td><td><span class="email">\n{{vm.order.customer.email}}</span></td><td><span class="phone">{{vm.order.customer.phone}}</span></td><td><span \nclass="phone">{{vm.order.customer.company}}</span></td><td></td></tr></tbody></table><md-tabs class="addresses">\n<md-tab><md-tab-label><span translate="EC.SHIPPING_ADDRESS">Shipping Address</span></md-tab-label><md-tab-body><div \nclass="address">{{vm.order.customer.shippingAddress}}</div><ui-gmap-google-map center="vm.shippingAddressMap.center" \nzoom="vm.shippingAddressMap.zoom"><ui-gmap-marker coords="vm.shippingAddressMap.center" \nidkey="vm.shippingAddressMap.marker.id"></ui-gmap-marker></ui-gmap-google-map></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate="EC.INVOICE_ADDRESS">Invoice Address</span></md-tab-label><md-tab-body><div \nclass="address">{{vm.order.customer.invoiceAddress}}</div><ui-gmap-google-map center="vm.invoiceAddressMap.center" \nzoom="vm.invoiceAddressMap.zoom"><ui-gmap-marker coords="vm.invoiceAddressMap.center" \nidkey="vm.invoiceAddressMap.marker.id"></ui-gmap-marker></ui-gmap-google-map></md-tab-body></md-tab></md-tabs></div>\n</div><div class="order-detail-form-container status md-background-bg md-whiteframe-1dp"><div class="pb-16" \nlayout="row" layout-align="start center"><md-icon md-font-icon="icon-clock" class="m-0 mr-16"></md-icon><div \nclass="h2 secondary-text" translate="EC.ORDER_STATUS">Order Status</div></div><table class="simple" \nms-responsive-table><thead><tr><th translate="EC.STATUS">Status</th><th translate="EC.UPDATED_ON">Updated On</th></tr>\n</thead><tbody><tr ng-repeat="status in vm.order.status"><td><span class="status {{status.color}}">{{status.name}}\n</span></td><td>{{status.date}}</td></tr></tbody></table><div class="update-status" layout="row" \nlayout-align="start center"><md-input-container flex><label>Select a status</label><md-select ng-model="vm.newStatus">\n<md-option ng-repeat="status in vm.statuses" value="{{status.id}}">{{status.name}}</md-option></md-select>\n</md-input-container><md-button class="md-raised md-accent" ng-click="vm.updateStatus(vm.newStatus)" \nng-disabled="!vm.newStatus">Update Status</md-button></div></div><div \nclass="order-detail-form-container payments md-background-bg md-whiteframe-1dp"><div class="pb-16" layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-cash" class="m-0 mr-16"></md-icon><div \nclass="h2 secondary-text" translate="EC.PAYMENT">Payment</div></div><table class="simple" ms-responsive-table><thead>\n<tr><th translate="EC.TRANSACTION_ID">TransactionID</th><th translate="EC.PAYMENT_METHOD">Payment Method</th><th \ntranslate="EC.AMOUNT">Amount</th><th translate="EC.DATE">Date</th></tr></thead><tbody><tr \nng-repeat="payment in vm.order.payment"><td>{{payment.transactionId}}</td><td>{{payment.method}}</td><td>\n{{payment.amount}}</td><td>{{payment.date}}</td></tr></tbody></table></div><div \nclass="order-detail-form-container shipping md-background-bg md-whiteframe-1dp"><div class="pb-16" layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-truck" class="m-0 mr-16"></md-icon><div \nclass="h2 secondary-text" translate="EC.SHIPPING">Shipping</div></div><table class="simple" ms-responsive-table><thead>\n<tr><th translate="EC.TRACKING_CODE">Tracking Code</th><th translate="EC.CARRIER">Carrier</th><th \ntranslate="EC.WEIGHT">Weight</th><th translate="EC.FEE">Fee</th><th translate="EC.DATE">Date</th></tr></thead><tbody>\n<tr ng-repeat="shipping in vm.order.shippingDetails"><td class="tracking-code" editable-text="shipping.tracking">\n{{shipping.tracking || \'Click to add a tracking code\'}}</td><td>{{shipping.carrier}}</td><td>{{shipping.weight}}</td>\n<td>{{shipping.fee}}</td><td>{{shipping.date}}</td></tr></tbody></table></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate="EC.PRODUCTS">Products</span></md-tab-label><md-tab-body><div \nclass="order-detail-form-container products md-background-bg md-whiteframe-1dp"><table \nclass="dataTable row-border hover" datatable="ng" dt-instance="vm.dtInstance" dt-options="vm.dtOptions"><thead><tr><th \nclass="secondary-text"><div class="table-header"><span class="column-title">ID</span></div></th><th \nclass="secondary-text"><div class="table-header"><span class="column-title">Image</span></div></th><th \nclass="secondary-text"><div class="table-header"><span class="column-title">Name</span></div></th><th \nclass="secondary-text"><div class="table-header"><span class="column-title">Price</span></div></th><th \nclass="secondary-text"><div class="table-header"><span class="column-title">Quantity</span></div></th><th \nclass="secondary-text"><div class="table-header"><span class="column-title">Actions</span></div></th></tr></thead>\n<tbody><tr ng-repeat="product in ::vm.order.products"><td>{{product.id}}</td><td><img class="product-image" \nng-src="{{product.image}}"></td><td>{{product.name}}</td><td>{{product.price}}</td><td>{{product.quantity}}</td><td>\n<md-button class="edit-button md-icon-button" ng-click="vm.gotoProductDetail(product.id)" aria-label="Product details" \ntranslate translate-attr-aria-label="EC.PRODUCT_DETAILS"><md-icon md-font-icon="icon-pencil" class="s16"></md-icon>\n</md-button></td></tr></tbody></table></div></md-tab-body></md-tab><md-tab><md-tab-label><span translate="EC.INVOICE">\nInvoice</span></md-tab-label><md-tab-body><div id="invoice" class="compact"><div class="invoice-container"><div \nclass="card md-whiteframe-8dp"><div class="header"><div class="invoice-date">{{vm.order.date}}</div><div layout="row" \nlayout-align="space-between stretch"><div class="client"><div class="invoice-number mb-8" layout="row" \nlayout-align="start center"><span class="title" translate="INVOICE.INVOICE">INVOICE</span> <span class="number">\n{{vm.order.reference}}</span></div><div class="info"><div class="title">\n{{vm.order.customer.firstName}} {{vm.order.customer.lastName}}</div><div class="address">\n{{vm.order.customer.invoiceAddress}}</div><div class="phone">{{vm.order.customer.phone}}</div><div class="email">\n{{vm.order.customer.email}}</div></div></div><div class="issuer md-accent-bg" layout="row" layout-align="start center">\n<div class="logo" layout="row" layout-align="center center"><span>F</span></div><div class="info"><div class="title">\nFUSE INC.</div><div class="address">2810 Country Club Road Cranford, NJ 07016</div><div class="phone">+66 123 455 87\n</div><div class="email">hello@fuseinc.com</div><div class="website">www.fuseinc.com</div></div></div></div></div><div \nclass="content"><table class="simple invoice-table"><thead><th translate="EC.INVOICE_PRODUCT">PRODUCT</th><th \nclass="text-right" translate="EC.INVOICE_PRICE">PRICE</th><th translate="EC.INVOICE_QUANTITY">QUANTITY</th><th \nclass="text-right" translate="EC.INVOICE_TOTAL">TOTAL</th></thead><tbody><tr ng-repeat="product in vm.order.products">\n<td><div class="title">{{product.name}}</div></td><td class="text-right">{{product.price}}</td><td>{{product.quantity}}\n</td><td class="text-right">{{product.total}}</td></tr></tbody></table><table class="simple invoice-table-footer">\n<tbody><tr class="subtotal"><td translate="EC.INVOICE_SUBTOTAL">SUBTOTAL</td><td>{{vm.order.subtotal}}</td></tr><tr \nclass="tax"><td translate="EC.INVOICE_TAX">TAX</td><td>{{vm.order.tax}}</td></tr><tr class="discount"><td \ntranslate="EC.INVOICE_DISCOUNT">DISCOUNT</td><td>{{vm.order.discount}}</td></tr><tr class="total"><td \ntranslate="EC.INVOICE_TOTAL">TOTAL</td><td>{{vm.order.total}}</td></tr></tbody></table></div><div class="footer"><div \nlayout="row" layout-align="start start"><div class="logo md-accent-bg" layout="row" layout-align="center center"><div>F\n</div></div><div class="small-note">\nIn condimentum malesuada efficitur. Mauris volutpat placerat auctor. Ut ac congue dolor. Quisque scelerisque lacus sed feugiat fermentum. Cras aliquet facilisis pellentesque. Nunc hendrerit quam at leo commodo, a suscipit tellus dapibus. Etiam at felis volutpat est mollis lacinia. Mauris placerat sem sit amet velit mollis, in porttitor ex finibus. Proin eu nibh id libero tincidunt lacinia et eget eros.\n</div></div></div></div><div class="page-break"></div></div></div></md-tab-body></md-tab></md-tabs></div></div>');
$templateCache.put('app/main/apps/e-commerce/views/orders/orders.html','<div id="e-commerce-orders" class="page-layout carded fullwidth" layout="row"><div class="top-bg md-accent-bg"></div>\n<div class="center" layout="column" flex><div class="header" layout="row" layout-align="space-between center"><div \nclass="white-fg" layout="column" layout-align="start start"><div class="h1" layout="row" layout-align="start center">\n<md-icon md-font-icon="icon-cart-outline"></md-icon><span translate="EC.ORDERS">Orders</span></div><div \nclass="order-count secondary-text"><span translate="EC.TOTAL_ORDERS">Total orders:</span> <span>{{vm.orders.length}}\n</span></div></div><div class="search" layout="row" layout-align="start center" flex><md-icon \nmd-font-icon="icon-magnify" class="white-text icon search-icon"></md-icon><input id="e-commerce-products-search" \nclass="search-input" type="text" placeholder="Search" translate translate-attr-placeholder="EC.SEARCH" flex></div>\n</div><div class="content-card" layout="column" flex><div class="content fullpage-datatable" layout="column" flex>\n<table class="dataTable row-border hover" datatable="ng" dt-instance="vm.dtInstance" dt-options="vm.dtOptions"><thead>\n<tr><th class="secondary-text"><div class="table-header"><span class="column-title">ID</span></div></th><th \nclass="secondary-text"><div class="table-header"><span class="column-title">Reference</span></div></th><th \nclass="secondary-text"><div class="table-header"><span class="column-title">Delivery</span></div></th><th \nclass="secondary-text"><div class="table-header"><span class="column-title">Customer</span></div></th><th \nclass="secondary-text"><div class="table-header"><span class="column-title">Total</span></div></th><th \nclass="secondary-text"><div class="table-header"><span class="column-title">Payment</span></div></th><th \nclass="secondary-text"><div class="table-header"><span class="column-title">Status</span></div></th><th \nclass="secondary-text"><div class="table-header"><span class="column-title">Date</span></div></th><th \nclass="secondary-text"><div class="table-header"><span class="column-title">Actions</span></div></th></tr></thead>\n<tbody><tr ng-repeat="order in ::vm.orders"><td>{{order.id}}</td><td>{{order.reference}}</td><td>{{order.delivery}}\n</td><td>{{order.customer}}</td><td>{{order.total}}</td><td>{{order.payment}}</td><td>{{order.status}}</td><td \nclass="date">{{order.date}}</td><td><md-button class="edit-button md-icon-button" \nng-click="vm.gotoOrderDetail(order.id)" aria-label="Order details" translate \ntranslate-attr-aria-label="EC.ORDER_DETAILS"><md-icon md-font-icon="icon-dots-horizontal" class="s16"></md-icon>\n</md-button></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/main/apps/e-commerce/views/product/product.html','<div id="e-commerce-product" class="page-layout simple tabbed" layout="column"><div class="header md-accent-bg" \nlayout="row" layout-align="start center"><div class="white-fg" layout="row" layout-align="start center" flex><md-button\n class="goto-products-button md-icon-button" aria-label="Go to products" ng-click="vm.gotoProducts()" translate \ntranslate-attr-aria-label="EC.GO_TO_PRODUCTS"><md-icon md-font-icon="icon-arrow-left"></md-icon></md-button><div \nlayout="row" layout-align="start center"><div class="product-image" hide-xs><img ng-src="{{vm.product.images[0].url}}">\n</div><div layout="column" layout-align="start start"><div class="h2">{{vm.product.name}}</div><div \nclass="subtitle secondary-text"><span translate="EC.PRODUCT_DETAIL">Product Detail</span></div></div></div></div><div>\n<md-button class="md-raised md-background"><span translate="EC.SAVE">SAVE</span></md-button></div></div><div \nclass="content"><md-tabs md-dynamic-height><md-tab><md-tab-label><span translate="EC.BASIC_INFO">Basic Info</span>\n</md-tab-label><md-tab-body><div class="product-detail-form-container md-background-bg md-whiteframe-1dp"><form>\n<md-input-container class="md-block"><label translate="EC.PRODUCT_NAME">Product Name</label> <input type="text" \nng-model="vm.product.name"></md-input-container><h3 class="secondary-text" translate="EC.PRODUCT_DESCRIPTION">\nProduct Description</h3><text-angular ta-toolbar="vm.taToolbar" ng-model="vm.product.description"></text-angular>\n<md-input-container class="md-block"><label translate="EC.CATEGORIES">Categories</label><md-select \nng-model="vm.product.categories" md-on-open="vm.onCategoriesSelectorOpen()" \nmd-on-close="vm.onCategoriesSelectorClose()" multiple="multiple"><md-select-header><input type="search" \nclass="md-text" ng-model="vm.categoriesSelectFilter" placeholder="Search for a category"></md-select-header>\n<md-optgroup><md-option ng-value="category" \nng-repeat="category in vm.product.categories | filter:vm.categoriesSelectFilter">{{category}}</md-option></md-optgroup>\n</md-select></md-input-container><h3 class="tags secondary-text" translate="EC.TAGS">Tags</h3><md-chips \nng-model="vm.product.tags" placeholder="Enter a tag" delete-button-label="Remove Tag" \ndelete-hint="Press delete to remove tag" secondary-placeholder="+Tag"></md-chips></form></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span translate="EC.PRODUCT_IMAGES">Product Images</span></md-tab-label><md-tab-body><div \nclass="product-detail-form-container md-background-bg md-whiteframe-1dp"><div id="product-image-uploader" \nflow-init="vm.ngFlowOptions" flow-name="vm.ngFlow.flow" flow-files-submitted="vm.upload()" \nflow-file-added="vm.fileAdded($file)" flow-file-success="vm.fileSuccess($file, $message)" \nflow-complete="vm.uploadComplete()" flow-drop flow-drag-enter="vm.dropping=true" flow-drag-leave="vm.dropping=false" \nng-class="{\'dropping\':vm.dropping}"><div class="drop-text hint-text" layout="row" layout-align="center center"><span \ntranslate="EC.DROP_TO_UPLOAD">Drop to upload</span></div><div class="upload-button" layout="column" \nlayout-align="center center"><md-button class="md-accent md-raised" flow-btn>Upload</md-button><span \nclass="secondary-text mt-8">You can also drop images here to upload. Only PNG, JPG - Max. 8MB</span></div><div \nlayout="row" layout-align="start start" layout-wrap><div ng-repeat="image in vm.product.images" ng-switch="image.type">\n<div class="product-image uploading" ng-switch-when="uploading" layout="row" layout-align="center center"><div \nclass="overlay" layout="column" layout-align="center center"><md-progress-linear md-mode="determinate" \nvalue="{{image.file.progress() * 100}}"></md-progress-linear></div><img class="media" flow-img="image.file"></div><div \nclass="product-image" ng-switch-when="image" layout="row" layout-align="center center"><img class="media" \nng-src="{{image.url}}"></div></div></div></div></div></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate="EC.PRICING">Pricing</span></md-tab-label><md-tab-body><div \nclass="product-detail-form-container md-background-bg md-whiteframe-1dp"><form><md-input-container \nclass="md-block md-icon-float"><label translate="EC.TAX_EXCL_PRICE">Tax Excluded Price</label><md-icon \nmd-font-icon="icon icon-currency-usd"></md-icon><input type="number" step="0.01" ng-model="vm.product.priceTaxExcl">\n</md-input-container><md-input-container class="md-block md-icon-float"><label translate="EC.TAX_INCL_PRICE">\nTax Included Price</label><md-icon md-font-icon="icon icon-currency-usd"></md-icon><input type="number" step="0.01" \nng-model="vm.product.priceTaxIncl"></md-input-container><md-input-container class="md-block md-icon-float"><label \ntranslate="EC.TAX_RATE">Tax Rate</label><md-icon md-font-icon="icon icon-percent"></md-icon><input type="number" \nstep="0.01" ng-model="vm.product.taxRate"></md-input-container><md-input-container class="md-block md-icon-float">\n<label translate="EC.COMPARED_PRICE">Compared Price</label><md-icon md-font-icon="icon icon-currency-usd"></md-icon>\n<input type="number" step="0.01" ng-model="vm.product.comparedPrice"><div class="input-hint">\nAdd a compare price to show next to the real price</div></md-input-container></form></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span translate="EC.INVENTORY">Inventory</span></md-tab-label><md-tab-body><div \nclass="product-detail-form-container md-background-bg md-whiteframe-1dp"><form><md-input-container class="md-block">\n<label translate="EC.SKU">SKU</label> <input type="text" ng-model="vm.product.sku"></md-input-container>\n<md-input-container class="md-block"><label translate="EC.BARCODE">Barcode</label> <input type="text" \nng-model="vm.product.barcode"></md-input-container><md-input-container class="md-block"><label translate="EC.QUANTITY">\nQuantity</label> <input type="number" step="1" ng-model="vm.product.quantity"></md-input-container></form></div>\n</md-tab-body></md-tab><md-tab><md-tab-label><span translate="EC.SHIPPING">Shipping</span></md-tab-label><md-tab-body>\n<div class="product-detail-form-container md-background-bg md-whiteframe-1dp"><form><div layout-gt-sm="row" \nlayout-align="start center"><md-input-container class="md-block" flex-gt-sm><label translate="EC.WIDTH">Width</label> \n<input type="text" ng-model="vm.product.width"></md-input-container><md-input-container class="md-block" flex-gt-sm>\n<label translate="EC.HEIGHT">Height</label> <input type="text" ng-model="vm.product.height"></md-input-container>\n<md-input-container class="md-block" flex-gt-sm><label translate="EC.DEPTH">Depth</label> <input type="text" \nng-model="vm.product.depth"></md-input-container></div><md-input-container class="md-block"><label \ntranslate="EC.WEIGHT">Weight</label> <input type="text" ng-model="vm.product.weight"></md-input-container>\n<md-input-container class="md-block md-icon-float"><label translate="EC.EXTRA_SHIPPING_FEE">Extra Shipping Fee</label>\n<md-icon md-font-icon="icon icon-currency-usd"></md-icon><input type="text" ng-model="vm.product.extraShippingFee">\n</md-input-container></form></div></md-tab-body></md-tab></md-tabs></div></div>');
$templateCache.put('app/main/apps/e-commerce/views/products/products.html','<div id="e-commerce-products" class="page-layout carded fullwidth" layout="row"><div class="top-bg md-accent-bg"></div>\n<div class="center" layout="column" flex><div class="header" layout="row" layout-align="space-between center"><div \nclass="white-fg" layout="column" layout-align="start start"><div class="h1" layout="row" layout-align="start center">\n<md-icon md-font-icon="icon-airplane"></md-icon><span translate="EC.PRODUCTS">Products</span></div><div \nclass="product-count secondary-text"><span translate="EC.TOTAL_PRODUCTS">Total products:</span> <span>\n{{vm.products.length}}</span></div></div><div class="search" layout="row" layout-align="start center" flex><md-icon \nmd-font-icon="icon-magnify" class="white-text icon search-icon"></md-icon><input id="e-commerce-products-search" \nclass="search-input" type="text" placeholder="Search" translate translate-attr-placeholder="EC.SEARCH" flex></div>\n</div><div class="content-card" layout="column" flex><div class="content fullpage-datatable" layout="column" flex>\n<table class="dataTable row-border hover" datatable="ng" dt-instance="vm.dtInstance" dt-options="vm.dtOptions"><thead>\n<tr><th class="secondary-text"><div class="table-header"><span class="column-title">ID</span></div></th><th \nclass="secondary-text"><div class="table-header"><span class="column-title">Image</span></div></th><th \nclass="secondary-text"><div class="table-header"><span class="column-title">Name</span></div></th><th \nclass="secondary-text"><div class="table-header"><span class="column-title">Seats</span></div></th><th \nclass="secondary-text"><div class="table-header"><span class="column-title">Active</span></div></th><th \nclass="secondary-text"><div class="table-header"><span class="column-title">Actions</span></div></th></tr></thead>\n<tbody><tr ng-repeat="product in ::vm.products"><td>{{product.id}}</td><td><img class="product-image" \nng-src="{{product.image}}"></td><td>{{product.name}}</td><td>{{product.quantity}}</td><td>{{product.active}}</td><td>\n<md-button class="edit-button md-icon-button" ng-click="vm.gotoProductDetail(product.id)" aria-label="Product details" \ntranslate translate-attr-aria-label="EC.PRODUCT_DETAILS"><md-icon md-font-icon="icon-pencil" class="s16"></md-icon>\n</md-button></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/main/apps/file-manager/sidenavs/details/details-sidenav.html','<div class="header md-accent-bg" layout="column" layout-align="space-between"><div class="toolbar" layout="row" \nlayout-align="end center"><md-button class="md-icon-button" ng-click="vm.delete()" aria-label="Delete" translate \ntranslate-attr-aria-label="FM.DELETE"><md-icon md-font-icon="icon-delete"></md-icon><md-tooltip><span \ntranslate="FM.DELETE">Delete</span></md-tooltip></md-button><md-button class="md-icon-button" aria-label="Download" \ntranslate translate-attr-aria-label="FM.DOWNLOAD"><md-icon md-font-icon="icon-download"></md-icon><md-tooltip><span \ntranslate="FM.DOWNLOAD">Download</span></md-tooltip></md-button><md-button class="md-icon-button" aria-label="More" \ntranslate translate-attr-aria-label="FM.MORE"><md-icon md-font-icon="icon-dots-vertical"></md-icon><md-tooltip><span \ntranslate="FM.MORE">More</span></md-tooltip></md-button></div><div><div class="title">{{vm.selected.name}}</div><div \nclass="subtitle secondary-text"><span translate="FM.EDITED">Edited</span>: {{vm.selected.modified}}</div></div></div>\n<md-content class="content" flex ms-scroll><div class="file-details"><div class="preview file-icon" layout="row" \nlayout-align="center center"><i class="icon-{{vm.selected.type}} s48"></i></div><md-list class="offline-switch">\n<md-list-item><p translate="FM.AVAILABLE_OFFLINE">Available Offline</p><md-switch class="md-secondary" \nng-model="vm.selected.offline" aria-label="Toggle offline" translate translate-attr-aria-label="FM.TOOGLE_OFFLINE">\n</md-switch></md-list-item></md-list><div class="title" translate="FM.INFO">Info</div><table><tr class="type"><th \ntranslate="FM.TYPE">Type</th><td>{{vm.selected.type}}</td></tr><tr class="size"><th translate="FM.SIZE">Size</th><td>\n{{vm.selected.size === \'\' ? \'-\': vm.selected.size}}</td></tr><tr class="location"><th translate="FM.LOCATION">Location\n</th><td>{{vm.selected.location}}</td></tr><tr class="owner"><th translate="FM.OWNER">Owner</th><td>\n{{vm.selected.owner}}</td></tr><tr class="modified"><th translate="FM.MODIFIED">Modified</th><td>\n{{vm.selected.modified}}</td></tr><tr class="opened"><th translate="FM.OPENED">Opened</th><td>{{vm.selected.opened}}\n</td></tr><tr class="created"><th translate="FM.CREATED">Created</th><td>{{vm.selected.created}}</td></tr></table>\n</div></md-content>');
$templateCache.put('app/main/apps/file-manager/sidenavs/main/main-sidenav.html','<div class="header" layout="column" layout-align="space-between start"><div class="logo" layout="row" \nlayout-align="start center"><span class="logo-icon"><md-icon md-font-icon="icon-folder" class="icon s24"></md-icon>\n</span><span class="logo-text" translate="FM.FILE_MANAGER">File Manager</span></div><div class="account"><div \nclass="title">John Smith</div><md-select class="account-selection simplified" ng-model="vm.selectedAccount" \nplaceholder="Select Account"><md-option ng-repeat="(provider, address) in vm.accounts" value="{{provider}}">{{address}}\n</md-option></md-select></div></div><div class="content"><div class="navigation-simple" layout="column"><md-button \nclass="item" aria-label="inbox"><div class="context" layout="row" layout-align="start center"><md-icon \nmd-font-icon="icon-folder" class="s16"></md-icon><div class="title" translate="FM.MY_FILES">My Files</div></div>\n</md-button><md-button class="item" aria-label="starred"><div class="context" layout="row" layout-align="start center">\n<md-icon md-font-icon="icon-star" class="s16"></md-icon><div class="title" translate="FM.STARRED">Starred</div></div>\n</md-button><md-button class="item" aria-label="starred"><div class="context" layout="row" layout-align="start center">\n<md-icon md-font-icon="icon-folder-account" class="s16"></md-icon><div class="title" translate="FM.SHARRED_WITH_ME">\nSharred with me</div></div></md-button><md-button class="item" aria-label="starred"><div class="context" layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-clock" class="s16"></md-icon><div class="title" \ntranslate="FM.RECENT">Recent</div></div></md-button><md-button class="item" aria-label="starred"><div class="context" \nlayout="row" layout-align="start center"><md-icon md-font-icon="icon-checkbox-marked-circle" class="s16"></md-icon><div\n class="title" translate="FM.OFFLINE">Offline</div></div></md-button></div></div>');
$templateCache.put('app/main/apps/file-manager/views/grid/grid-view.html','<div class="grid-view" layout="column"><div class="folders" layout="row" layout-wrap><div \nclass="md-background-bg md-hue-1 md-whiteframe-1dp item folder" ng-click="vm.select(folder)" \nng-repeat="folder in vm.folders | filter:global.search" layout="row" layout-align="space-between center"><div \nlayout="row" class="title" layout-align="start center"><span class="file-icon"><i md-font-icon="icon-{{folder.type}}">\n</i> </span><span class="name">{{folder.name}}</span></div><div class="show-details" hide-gt-md><md-button \nclass="md-icon-button sidenav-toggle" aria-label="Details" translate translate-attr-aria-label="FM.DETAILS"><md-icon \nmd-font-icon="icon-information-outline" ng-click="vm.toggleDetails(folder)"></md-icon></md-button></div></div></div>\n<div class="files" layout="row" layout-wrap><div ng-click="vm.select(file)" class="md-whiteframe-1dp item file" \nng-repeat="file in vm.files | filter:global.search" layout="column"><div class="preview"><img \nng-src="{{file.preview}}"></div><div class="bottom md-background-bg md-hue-1" layout="row" \nlayout-align="space-between center"><div layout="row" class="title" layout-align="start center" flex><span \nclass="file-icon"><i md-font-icon="icon-{{file.type}}"></i> </span><span class="name">{{file.name}}</span></div><div \nclass="show-details" hide-gt-md><md-button class="md-icon-button sidenav-toggle" aria-label="Details" translate \ntranslate-attr-aria-label="FM.DETAILS"><md-icon md-font-icon="icon-information-outline" \nng-click="vm.toggleDetails(file)"></md-icon></md-button></div></div></div></div></div>');
$templateCache.put('app/main/apps/file-manager/views/list/list-view.html','<table class="simple list-view"><thead><tr><th></th><th translate="FM.NAME">Name</th><th hide show-gt-sm \ntranslate="FM.TYPE">Type</th><th hide-xs translate="FM.OWNER">Owner</th><th hide-xs translate="FM.SIZE">Size</th><th \nhide show-gt-md translate="FM.LAST_MODIFIED">Last Modified</th><th hide-gt-md></th></tr></thead><tbody><tr \nng-repeat="folder in vm.folders | filter:global.search" ng-click="vm.select(folder)" \nng-class="{\'selected\' : vm.selected === folder}"><td class="file-icon"><i class="icon-{{folder.type}}"></i></td><td \nclass="name">{{folder.name}}</td><td class="type" hide show-gt-sm>{{folder.type}}</td><td class="owner" hide-xs>\n{{folder.owner}}</td><td class="size" hide-xs>{{folder.size === \'\' ? \'-\': folder.size}}</td><td class="last-modified" \nhide show-gt-md>{{folder.modified}}</td><td class="show-details" hide-gt-md><md-button \nclass="md-icon-button sidenav-toggle" ng-click="vm.toggleDetails(folder)" aria-label="Toggle details sidenav"><md-icon \nmd-font-icon="icon-information-outline"></md-icon></md-button></td></tr><tr \nng-repeat="file in vm.files | filter:global.search" ng-click="vm.select(file)" \nng-class="{\'selected\' : vm.selected === file}"><td class="file-icon"><i class="icon-{{file.type}}"></i></td><td \nclass="name">{{file.name}}</td><td class="type" hide show-gt-sm>{{file.type}}</td><td class="owner" hide-xs>\n{{file.owner}}</td><td class="size" hide-xs>{{file.size === \'\' ? \'-\': file.size}}</td><td class="last-modified" hide \nshow-gt-md>{{file.modified}}</td><td class="show-details" hide-gt-md><md-button class="md-icon-button sidenav-toggle" \nng-click="vm.toggleDetails(file)" aria-label="Details" translate translate-attr-aria-label="FM.DETAILS"><md-icon \nmd-font-icon="icon-information-outline"></md-icon></md-button></td></tr></tbody></table>');
$templateCache.put('app/main/apps/gantt-chart/dialogs/add-edit/add-dialog.html','<md-dialog class="gantt-chart-add-edit-dialog" aria-label="Add Dialog" ng-cloak><md-toolbar class="md-accent" \nng-class="\'md-\'+vm.board.settings.color+\'-bg\'"><div class="md-toolbar-tools"><h2 class="title">Add</h2><span flex>\n</span><md-button class="md-icon-button" ng-click="vm.closeDialog()" aria-label="close dialog"><md-icon \nmd-font-icon="icon-close" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><md-tabs md-dynamic-height><md-tab><md-tab-label><span translate="GANTT.ADD_ROW">Add Row</span>\n</md-tab-label><md-tab-body><div ng-include="\'app/main/apps/gantt-chart/dialogs/add-edit/views/row-form-view.html\'">\n</div></md-tab-body></md-tab><md-tab><md-tab-label><span translate="GANTT.ADD_TASK">Add Task</span></md-tab-label>\n<md-tab-body><div ng-include="\'app/main/apps/gantt-chart/dialogs/add-edit/views/task-form-view.html\'"></div>\n</md-tab-body></md-tab></md-tabs></md-dialog-content></md-dialog>');
$templateCache.put('app/main/apps/gantt-chart/dialogs/add-edit/edit-dialog.html','<md-dialog class="gantt-chart-add-edit-dialog" aria-label="Edit Dialog" ng-cloak><md-toolbar class="md-accent" \nng-class="\'md-\'+vm.board.settings.color+\'-bg\'"><div class="md-toolbar-tools"><h2 class="title">Edit</h2><span flex>\n</span><md-button class="md-icon-button" ng-click="vm.closeDialog()" aria-label="close dialog"><md-icon \nmd-font-icon="icon-close" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll ng-if="vm.formView === \'row\'" \nng-include="\'app/main/apps/gantt-chart/dialogs/add-edit/views/row-form-view.html\'"></md-dialog-content>\n<md-dialog-content ms-scroll ng-if="vm.formView === \'task\'" \nng-include="\'app/main/apps/gantt-chart/dialogs/add-edit/views/task-form-view.html\'"></md-dialog-content></md-dialog>');
$templateCache.put('app/main/apps/gantt-chart/sidenavs/settings/settings-sidenav.html','<md-toolbar class="toolbar md-accent"><div class="md-toolbar-tools"><md-button class="md-icon-button" \naria-label="Settings"><md-icon md-font-icon="icon-cog"></md-icon></md-button><h2><span>Settings</span></h2></div>\n</md-toolbar><md-content class="content" layout-padding><md-list><md-subheader class="md-no-sticky"><span \ntranslate="GANTT.EDIT">Edit</span></md-subheader><md-list-item><md-icon md-font-icon="icon-pencil"></md-icon><p \ntranslate="GANTT.DRAW">Draw</p><md-checkbox class="md-secondary" ng-model="vm.options.draw"></md-checkbox>\n</md-list-item><md-list-item><md-icon md-font-icon="icon-lock"></md-icon><p translate="GANTT.READ_ONLY">Read only</p>\n<md-checkbox class="md-secondary" ng-model="vm.options.readOnly"></md-checkbox></md-list-item><md-divider></md-divider>\n<md-subheader class="md-no-sticky"><span translate="GANTT.SNAP">Snap</span></md-subheader><md-list-item><md-icon \nmd-font-icon="icon-magnet"></md-icon><p translate="GANTT.SNAP_AREA">Snap area</p><md-select \nclass="simplified md-secondary" ng-model="vm.options.columnMagnet" placeholder="Snap area"><md-option value="column" \ntranslate="GANTT.COLUMN">Column</md-option><md-option value="1 second" translate="GANTT.1_SECOND">1 second</md-option>\n<md-option value="1 minute" translate="GANTT.1_MINUTE">1 minute</md-option><md-option value="5 minutes" \ntranslate="GANTT.5_MINUTES">5 minutes</md-option><md-option value="15 minutes" translate="GANTT.15_MINUTES">15 minutes\n</md-option><md-option value="1 hour" translate="GANTT.1_HOUR">1 hour</md-option><md-option value="1 day" \ntranslate="GANTT.1_DAY">1 day</md-option><md-option value="5 days" translate="GANTT.5_DAYS">5 days</md-option>\n</md-select></md-list-item><md-list-item><md-icon md-font-icon="icon-view-day"></md-icon><p translate="GANTT.DAILY">\nDaily</p><md-checkbox class="md-secondary" ng-model="vm.options.daily"></md-checkbox></md-list-item><md-list-item>\n<md-icon md-font-icon="icon-lock"></md-icon><p translate="GANTT.TIME_FRAMES">Time frames</p><md-checkbox \nclass="md-secondary" ng-model="vm.options.timeFramesMagnet"></md-checkbox></md-list-item><md-divider></md-divider>\n<md-subheader class="md-no-sticky"><span translate="GANTT.SIDEBAR">Sidebar</span></md-subheader><md-list-item><md-icon \nmd-font-icon="icon-eye"></md-icon><p translate="GANTT.SHOW_SIDEBAR">Show Sidebar</p><md-checkbox class="md-secondary" \nng-model="vm.options.labelsEnabled"></md-checkbox></md-list-item><md-list-item><md-icon md-font-icon="icon-code-tags">\n</md-icon><p translate="GANTT.RESIZABLE">Resizable</p><md-checkbox class="md-secondary" \nng-model="vm.options.allowSideResizing"></md-checkbox></md-list-item><md-list-item><md-icon \nmd-font-icon="icon-view-headline"></md-icon><p translate="GANTT.LIST_MODE">List Mode</p><md-select \nclass="simplified md-secondary" ng-model="vm.options.sideMode" placeholder="List"><md-option value="Tree" \ntranslate="GANTT.TREE">Tree</md-option><md-option value="Table" translate="GANTT.TABLE">Table</md-option><md-option \nvalue="TreeTable" translate="GANTT.TREE_TABLE">TreeTable</md-option><md-option value="Disabled" \ntranslate="GANTT.DISABLED">Disabled</md-option></md-select></md-list-item><md-divider></md-divider><md-subheader \nclass="md-no-sticky"><span translate="GANTT.TIMELINE">Timeline</span></md-subheader><md-list-item><md-icon \nmd-font-icon="icon-view-headline"></md-icon><p translate="GANTT.GROUPS">Groups</p><md-select \nclass="simplified md-secondary" ng-model="vm.options.groupDisplayMode" placeholder="Groups"><md-option value="group" \ntranslate="GANTT.GROUP">Group</md-option><md-option value="overview" translate="GANTT.OVERVIEW">Overview</md-option>\n<md-option value="promote" translate="GANTT.PROMOTE">Promote</md-option><md-option value="Disabled" \ntranslate="GANTT.DISABLED">Disabled</md-option></md-select></md-list-item><md-divider></md-divider><md-list-item>\n<md-icon md-font-icon="icon-calendar-today"></md-icon><p translate="GANTT.TODAY">Today</p><md-select \nclass="simplified md-secondary" ng-model="vm.options.currentDate" placeholder="Today"><md-option value="none" \ntranslate="GANTT.NONE">None</md-option><md-option value="line" translate="GANTT.LINE">Line</md-option><md-option \nvalue="column" translate="GANTT.COLUMN">Column</md-option></md-select></md-list-item><md-divider></md-divider>\n<md-list-item><md-icon md-font-icon="icon-arrow-expand"></md-icon><p translate="GANTT.EXPAND">Expand</p><md-select \nclass="simplified md-secondary" ng-model="vm.options.autoExpand" placeholder="Today"><md-option value="none" \ntranslate="GANTT.NONE">None</md-option><md-option value="both" translate="GANTT.BOTH">Both</md-option><md-option \nvalue="left" translate="GANTT.LEFT">Left</md-option><md-option value="right" translate="GANTT.RIGHT">Right</md-option>\n</md-select></md-list-item><md-divider></md-divider><md-list-item><md-icon md-font-icon="icon-content-cut"></md-icon><p\n translate="GANTT.OUT_OF_RANGE">Out of range</p><md-select class="simplified md-secondary" \nng-model="vm.options.taskOutOfRange" placeholder="Out of range"><md-option value="expand" translate="GANTT.EXPAND">\nEXPAND</md-option><md-option value="truncate" translate="GANTT.TRUNCATE">Truncate</md-option></md-select>\n</md-list-item><md-divider></md-divider></md-list></md-content>');
$templateCache.put('app/main/apps/inputs/dialogs/new-stake-dialog/new-stake-dialog.html','<md-dialog class="new-client-dialog" aria-label="New Task"><form name="taskForm" class="md-inline-form" novalidate>\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between"><h1 \nclass="title" translate="STAKE.PROYECT_DATA"></h1><md-button class="md-icon-button" ng-click="vm.closeDialog()">\n<md-icon md-font-icon="icon-close" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content class="p-25" ms-scroll><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="STAKE.NAME"></label> <input type="text" ng-model="vm.company.stakeholder" required></md-input-container>\n</div><div layout="column" layout-gt-xs="row"><md-input-container flex><label translate="STAKE.INPUT"></label> <input \ntype="checkbox" ng-model="vm.company.input" value="1" name="input12" required></md-input-container><md-input-container \nflex><label translate="STAKE.OUTPUT"></label> <input ng-model="vm.company.output" type="checkbox" required>\n</md-input-container></div></md-dialog-content><md-dialog-actions class="footer" layout="row" layout-="end">\n<md-input-container flex layout="row" layout-align="end center"><md-button type="button" class="md-raised md-warn" \nng-click="vm.closeDialog()" translate="RISKCONFIG.CANCEL">Cancel</md-button><md-button \nng-disabled="!vm.company.stakeholder" type="submit" class="send-button md-accent md-raised" ng-click="vm.saveDialog()" \ntranslate="GLOBAL.SAVE">ADD</md-button></md-input-container></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/inputs/views/edit/edit-element.html','<div ng-if="vm.fieldEdit || vm.fieldAdd" class="editAdd1"><form name="inputForm" class="md-inline-form" novalidate><div\n layout="row" class="field_edit1"><md-input-container id="inputType"><label translate="INPUT.TYPEF"></label><md-select \nng-model="vm.tipeFields.fieldType"><md-option ng-repeat="typeFi in vm.tipefield" ng-value="typeFi.number"><span>\n{{typeFi.name}}</span></md-option></md-select></md-input-container></div><div layout="row" class="field_edit1">\n<md-input-container id="inputType"><label translate="INPUT.ITEM"></label><md-select ng-model="vm.tipeFields.id_item">\n<md-option ng-repeat="typeFiS in vm.items | filter:{type:vm.tipeFields.fieldType} track by $index" \nng-value="typeFiS.id" ng-click="vm.selectFields(typeFiS, $index)"><span>{{typeFiS.name}}</span></md-option><md-option \nng-value="NEW" ng-click="vm.selectFields(\'NEW\', 0)">{{"INPUT.NEW_FIELD" | translate}}</md-option></md-select>\n</md-input-container></div><div layout="row" class="field_edit1" ng-if="vm.nuevo"><md-input-container id="inputNamef">\n<label translate="INPUT.NAMEF"></label> <input type="text" ng-model="vm.tipeFields.fieldName" ng-disabled="!vm.nuevo" \nrequired></md-input-container></div><div layout="row" class="field_edit1"><md-input-container flex><label>Valor</label>\n <input type="number" ng-blur="vm.calculo()" string-to-number ng-model="vm.tipeFields.data" id="inputType" \nmaxlength="14" size="14" ng-change="vm.cambio=true" required></md-input-container></div><div layout="column" \nclass="field_edit1" ng-if="vm.nuevo"><md-checkbox ng-model="vm.tipeFields.fieldEdit" ng-true-value="\'1\'" \nng-false-value="\'0\'" aria-label="ShowHideAccountant" ng-change="vm.cambio=true"><label translate="INPUT.EDITF"></label>\n</md-checkbox></div><br><md-dialog-actions class="footer" layout="row"><md-input-container flex layout="row" \nlayout-align="end end"><md-button type="button" class="md-raised md-warn" \nng-click="vm.fieldAdd = false; vm.fieldEdit  = false; vm.nuevo = false" translate="INPUT.CANCEL">Cancel</md-button>\n<md-button ng-disabled="!vm.company.input" type="submit" class="send-button md-accent md-raised" \nng-click="vm.addFields()" translate="GLOBAL.SAVE">SAVE</md-button><md-button \nng-disabled="!vm.company.input || !vm.tipeFields.fieldName || !vm.fieldEdit" type="submit" \nclass="send-button md-accent md-raised" ng-click="vm.deleteFields()" translate="INPUT.DELETE">DELETE</md-button>\n</md-input-container></md-dialog-actions></form></div>');
$templateCache.put('app/main/apps/inputs/views/edit/edit-view.html','<div class="content thread-detail" layout="row" layout-align="center center" flex ng-if="!vm.edit"><div \nclass="no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-google-circles-communities" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="GLOBAL.SELECT_ITEM"></span></div></div><div class="form-wrapper md-whiteframe-1dp without-line" \nng-if="vm.edit"><div ng-if="(vm.staffSelected || vm.staffNew || vm.loadingReadPane)" class="toolbarcolored-bg" \nlayout="row" layout-align="space-between center"></div><div layout="row" layout-align="start center" \nclass="toolbar-colored-bg"><md-button aria-label="Preview" class="md-icon-button" id="accountIcon" translate="" \nng-click="vm.tabActive = \'preview\';vm.fieldAdd = false;vm.fieldEdit = false;" \ntranslate-attr-aria-label="INPUT.PREVIEW" ng-class="{\'tab-selected\': vm.tabActive==\'preview\'}"><md-icon \nmd-font-icon="icon-eye"></md-icon><md-tooltip hide show-gt-sm><span translate="INPUT.PREVIEW">Preview</span>\n</md-tooltip></md-button><div class="divider-vertical" hide="" show-gt-sm=""></div><md-button aria-label="Edit" \nclass="md-icon-button" id="accountIcon" translate="" \nng-click="vm.tabActive = \'edit\';vm.fieldAdd = false;vm.fieldEdit = false;" translate-attr-aria-label="STAFF.EDIT" \nng-class="{\'tab-selected\': vm.tabActive==\'preview\' || vm.tabActive==\'editnew\' || vm.tabActive==\'edit\'}"><md-icon \nmd-font-icon="icon-pencil"></md-icon><md-tooltip hide show-gt-sm><span translate="STAFF.EDIT">Edit</span></md-tooltip>\n</md-button><div class="divider-vertical" hide="" show-gt-sm=""></div><md-button aria-label="Menu" \nclass="md-icon-button" translate="" ng-click="vm.tabActive = \'json\'" translate-attr-aria-label="USERS.COMPANIES" \nng-class="{\'tab-selected\': vm.tabActive==\'json\'}" ng-disabled="!vm.company.input_structure"><md-icon \nmd-font-icon="icon-calculator"></md-icon><md-tooltip hide show-gt-sm><span translate="INPUT.JSON">JSON</span>\n</md-tooltip></md-button><md-input-container flex layout="row" layout-align="end center"><md-button type="button" \nclass="md-raised md-warn" ng-click="vm.closeDialog()" translate="RISKCONFIG.CANCEL">Cancel</md-button><md-button \nng-if="vm.tabActive != \'preview\'" ng-disabled="!vm.company.input || !vm.company.stakeholder_id" type="submit" \nclass="send-button md-accent md-raised" ng-click="vm.calculo();vm.calculoAnual();vm.saveDialog(vm.company, $event)" \ntranslate="GLOBAL.SAVE">SAVE</md-button></md-input-container></div></div><div ng-if="vm.tabActive==\'preview\'" \nclass="content1 thread-detail mail-read-pane" ms-scroll><div><md-list class="p0" role="list"><div><md-list-item \nclass="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 class="grey-700.fg" translate="INPUT.PROYECT_NAME">\nStakeholder name</h3><md-divider></md-divider></md-list-item></div></md-list></div><div><md-list-item \nng-if="state.id === vm.company.stakeholder_id" ng-repeat="state in vm.stakeholder" flex="100" role="listitem" \nclass="md-no-proxy"><div class="text-truncate" flex="100"><div class="field"><span class="font-size-16">\n{{state.stakeholder}}</span></div><md-divider></md-divider></div></md-list-item></div><div><md-list class="p0" \nrole="list"><div><md-list-item class="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 class="grey-700.fg" \ntranslate="INPUT.INPUT_NAME">Input name</h3><md-divider></md-divider></md-list-item></div></md-list></div><div>\n<md-list-item flex="100" role="listitem" class="md-no-proxy"><div class="text-truncate" flex="100"><div class="field">\n<span class="font-size-16">{{vm.company.input}}</span></div><md-divider></md-divider></div></md-list-item></div><div>\n<md-list class="p0" role="list"><div><md-list-item class="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 \nclass="grey-700.fg" translate="INPUT.CONTRIBUTION_YEARS">Years of contribution</h3><md-divider></md-divider>\n</md-list-item></div></md-list></div><div><md-list-item flex="100" role="listitem" class="md-no-proxy"><div \nclass="text-truncate" flex="100"><div class="field"><span class="font-size-16">{{vm.company.years}}</span></div>\n<md-divider></md-divider></div></md-list-item></div><div><md-list class="p0" role="list"><div><md-list-item \nclass="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 class="grey-700.fg" translate="INPUT.DESCRIPTION">Description\n</h3><md-divider></md-divider></md-list-item></div></md-list></div><div><md-list-item \nng-if="vm.company.description_input" flex="100" role="listitem"><div><div><br><span class="font-size-161">\n{{vm.company.description_input}}</span></div><md-divider></md-divider><br></div></md-list-item><md-list-item \nng-if="!vm.company.description_input" flex="100" role="listitem" class="md-no-proxy"><div class="text-truncate" \nflex="100"><div class="field"><span class="font-size-16">-</span></div><md-divider></md-divider></div></md-list-item>\n</div><div><md-list class="p0" role="list"><div><md-list-item class="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 \nclass="grey-700.fg" translate="OUTCOME.OBSERVATION">Comments</h3><md-divider></md-divider></md-list-item></div>\n</md-list></div><div><md-list-item ng-if="vm.company.comments" flex="100" role="listitem" class="md-no-proxy"><div \nclass="text-truncate1" flex="100"><div class="font-size-161"><br><span class="font-size-16">{{vm.company.comments}}\n</span></div><md-divider></md-divider><br></div></md-list-item><md-list-item ng-if="!vm.company.comments" flex="100" \nrole="listitem" class="md-no-proxy"><div class="text-truncate" flex="100"><div class="field"><span \nclass="font-size-16">-</span></div><md-divider></md-divider></div></md-list-item></div><div><md-list class="p0" \nrole="list"><div><md-list-item class="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 class="grey-700.fg" \ntranslate="INPUT.CALCULATION">Calc</h3><md-divider></md-divider></md-list-item></div></md-list></div><div><md-list-item\n flex="100" role="listitem" class="md-no-proxy"><div class="text-truncate" flex="100"><div layout="row" \nclass="input-data-container field"><p class="grey-500-fg font-size-16" translate="INPUT.CALCULATIONT">calculo</p><span \nclass="font-size-16">{{vm.company.result | currency:symbolMoney:2}}</span></div><md-divider></md-divider></div>\n</md-list-item></div><div><md-list class="p0" role="list"><div><md-list-item \nclass="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 class="grey-700.fg" translate="INPUT.SUBCALCULATION">Calc</h3>\n<md-divider></md-divider></md-list-item></div></md-list></div><div><md-list-item flex="100" role="listitem" \nclass="md-no-proxy"><div class="text-truncate" flex="100"><div layout="row" class="input-data-container field"><p \nclass="grey-500-fg font-size-16" translate="INPUT.SUBCALCULATIONT">calculo</p><span class="font-size-16">\n{{vm.company.input_structure.calculation | currency:symbolMoney:2}}</span></div><md-divider></md-divider></div>\n</md-list-item></div><div><md-list-item ng-repeat="inputs in vm.company.input_structure.inputs" flex="100" \nrole="listitem" class="md-no-proxy"><div class="text-truncate" flex="100"><div class="input-data-container" \nlayout="row" class="field"><p class="grey-500-fg font-size-16 text-truncate" ng-bind="inputs.fieldName"></p><span \nclass="font-size-16">{{inputs.data | currency:"":2}}</span></div><md-divider></md-divider></div></md-list-item></div>\n<div><md-list-item flex="100" role="listitem" class="md-no-proxy"><div class="text-truncate" flex="100"><div \nlayout="row" class="input-data-container field"><p class="grey-500-fg font-size-16">calculo</p><span \nclass="font-size-16">{{vm.company.input_structure.calculation | currency:symbolMoney:2}}</span></div><md-divider>\n</md-divider></div></md-list-item></div><div><md-list-item flex="100" role="listitem" class="md-no-proxy"><div \nclass="text-truncate" flex="100"><div layout="row" class="input-data-container field"><p \nclass="grey-500-fg font-size-16">calculo</p><span class="font-size-16">\n{{vm.company.input_structure.calculation | currency:symbolMoney:2}}</span></div><md-divider></md-divider></div>\n</md-list-item></div></div><div id="tab-edit-container" ng-if="vm.tabActive==\'edit\'" \nclass="content1 thread-detail mail-read-pane" ms-scroll><div><md-list class="p0" role="list"><div><md-list-item \nclass="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 class="grey-700.fg" translate="INPUT.PROYECT_NAME">\nStakeholder name</h3><md-divider></md-divider></md-list-item></div></md-list></div><div><md-list-item flex="100" \nrole="listitem" class="md-no-proxy"><div class="text-truncate" flex="100"><div class="field"><md-input-container \nflex="100"><md-select ng-model="vm.company.stakeholder_id"><md-option translate="INPUT.NONE"></md-option><md-option \nng-repeat="state in vm.stakeholder" ng-value="state.id" ng-if="state.input==\'1\'"><span class="font-size-16">\n{{state.stakeholder}}</span></md-option></md-select></md-input-container></div><md-divider></md-divider></div>\n</md-list-item></div><div><md-list class="p0" role="list"><div><md-list-item \nclass="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 class="grey-700.fg" translate="INPUT.INPUT_NAME">Input name\n</h3><md-divider></md-divider></md-list-item></div></md-list></div><div><md-list-item flex="100" role="listitem" \nclass="md-no-proxy"><div class="text-truncate" flex="100"><div class="field"><md-input-container flex="100"><input \nclass="font-size-16" type="text" maxlength="50" ng-model="vm.company.input" required></md-input-container></div>\n<md-divider></md-divider></div></md-list-item></div><div><md-list class="p0" role="list"><div><md-list-item \nclass="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 class="grey-700.fg" translate="INPUT.CONTRIBUTION_YEARS">\nYears of contribution</h3><md-divider></md-divider></md-list-item></div></md-list></div><div><md-list-item flex="100" \nrole="listitem" class="md-no-proxy"><div class="text-truncate" flex="100"><div class="field"><md-input-container \nflex="100"><input class="font-size-16" type="text" maxlength="4" ng-model="vm.company.years" required>\n</md-input-container></div><md-divider></md-divider></div></md-list-item></div><div><md-list class="p0" role="list">\n<div><md-list-item class="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 class="grey-700.fg" \ntranslate="INPUT.DESCRIPTION">Description</h3><md-divider></md-divider></md-list-item></div></md-list></div><div><div>\n<br><textarea class="font-size-162" ng-model="vm.company.description_input" maxlength="250"></textarea><md-divider>\n</md-divider></div><br></div><div><md-list class="p0" role="list"><div><md-list-item \nclass="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 class="grey-700.fg" translate="OUTCOME.OBSERVATION">\nObservacion</h3><md-divider></md-divider></md-list-item></div></md-list></div><div><div><br><textarea \nclass="font-size-162" ng-model="vm.company.comments"></textarea><md-divider></md-divider></div><br></div><div><md-list \nclass="p0" role="list"><div><md-list-item class="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 class="grey-700.fg" \ntranslate="INPUT.SUBCALCULATION">Calc</h3><md-divider></md-divider></md-list-item></div></md-list></div><div>\n<md-list-item ng-repeat="inputs in vm.company.input_structure.inputs" flex="100" role="listitem" class="md-no-proxy">\n<div class="text-truncate" flex="100"><div class="input-data-container" layout="row" class="field"><p \nclass="grey-500-fg font-size-16 text-truncate" ng-bind="inputs.fieldName"></p><md-input-container flex="100" \nclass="md-input-has-value"><input ng-disabled="inputs.fieldEdit==0" class="font-size-16" type="number" maxlength="14" \nstring-to-number ng-model="inputs.data" ng-change="vm.isSelectedField(inputs)"></md-input-container></div><md-divider>\n</md-divider></div></md-list-item></div><div><md-list-item flex="100" role="listitem" class="md-no-proxy"><div \nclass="text-truncate" flex="100"><div layout="row" class="input-data-container field"><p \nclass="grey-500-fg font-size-16">calculo</p><span class="font-size-16">\n{{vm.company.input_structure.calculation | currency:symbolMoney:2}}</span></div><md-divider></md-divider></div>\n</md-list-item></div><div><md-list-item flex="100" role="listitem" class="md-no-proxy"><div class="text-truncate" \nflex="100"><div layout="row" class="input-data-container field"><p class="grey-500-fg font-size-16">calculo</p><span \nclass="font-size-16">{{vm.company.input_structure.calculation | currency:symbolMoney:2}}</span></div><md-divider>\n</md-divider></div></md-list-item></div></div><div id="input-form-container" layout="column" \nng-if="vm.tabActive==\'json\'" ms-scroll><div layout="row" layout-align="start start"><label translate="INPUT.FORMULA">\n</label><span>:</span></div><div class="inputseditfield" dragula=\'"dragbagFormula"\' \ndragula-model="vm.company.input_structure.formula" layout="row"><div class="inputsDetailOperator" layout="row" \nng-repeat="elemen in vm.company.input_structure.formula track by $index" ng-init="parentIndex = $index" md-no-ink><div \nlayout="row" layout-align="start start"><div class="nameOperator" layout="row" layout-align="start start"><span><b>\n{{elemen}}</b></span></div><div class="iconDelete" layout="row" layout-align="start start" \nng-click="vm.index = $index;vm.deleteOperator()"><md-icon md-font-icon="icon-close" ng-click="vm.deleteOperator">\n</md-icon></div></div></div></div><div layout="row" id="add-operator-container"><div id="selector-container" \nlayout="row" layout-align="start start" ng-if="vm.addelement && !vm.editelement"><md-input-container><label \ntranslate="INPUT.SELECT_OPERAND"></label><md-select ng-model="vm.element" ng-change="vm.addOperator()" \nclass="mySelect"><md-optgroup label="Operandos"><md-option \nng-repeat="state in vm.company.input_structure.inputs track by $index" ng-value="state.fieldName" \nng-click="vm.selectOp = $index"><span>{{state.fieldName}}</span></md-option></md-optgroup></md-select>\n</md-input-container><md-input-container><button label="Operator" ng-click="vm.selectOp = $index; vm.addOperator()" \nng-repeat="operador in vm.operator track by $index">{{operador}}</button></md-input-container><div class="iconDelete" \nlayout="row" layout-align="start start" ng-click="vm.selectOp = \'exit\'; vm.addOperator();"><md-icon \nmd-font-icon="icon-close"></md-icon></div></div><div layout="row" layout-align="center" class="button-container" \nng-if="!vm.addelement && !vm.editelement"><md-button type="submit" class="send-button md-accent md-raised" \nng-click="vm.addOpeField();" translate="INPUT.ADDELEMENT" \nng-disabled="!vm.company.input || !vm.company.stakeholder_id">ADD</md-button></div></div><div class="lineaCF"></div>\n<div class="content thread-detail mail-read-pane scrollable p0" flex="" id="" ng-if="vm.fieldEdit || vm.fieldAdd" \nms-scroll="vm.msScrollOptions" ng-include="\'app/main/apps/inputs/views/edit/edit-element.html\'"></div><div \nclass="mb-1001" layout="row" layout-align="end center"><md-button aria-label="Add event" \nclass="add-event-button no-sort md-fab md-warn block m-25" translate="" ng-click="vm.clearFields()" \ntranslate-attr-aria-label="USERS.COMPANIES1" ng-class="{\'tab-selected\': vm.tabActive==\'json1\'}"><md-icon \nmd-font-icon="icon-plus"></md-icon><md-tooltip hide show-gt-sm><span translate="INPUT.ADDJSON">JSON</span></md-tooltip>\n</md-button></div><div dragula=\'"dragbag"\' dragula-model="vm.company.input_structure.inputs"><div \nng-repeat="inputs in vm.company.input_structure.inputs track by $index" ng-init="parentIndex = $index" md-no-ink \nng-click="vm.editFields(inputs, $index)"><div layout="row" layout-align="space-between center" \nng-if="!vm.fieldEdit && !vm.fieldAdd" ng-mouseover="vm.visible=true" ng-mouseleave="vm.visible=false"><div \nclass="nametext"><md-icon md-font-icon="icon-drag"></md-icon><span>{{inputs.fieldName}}</span></div><div \nclass="namenumber"><span>{{inputs.data | currency:"":2 }}</span></div></div><hr width="100%" \nng-if="!vm.fieldEdit && !vm.fieldAdd"></div></div></div>');
$templateCache.put('app/main/apps/inputs/views/list/list-table-view.html','<div flex layout="column" layout-align="center center" ng-if="isLoading" class="loading-container">\n<md-progress-circular md-mode="indeterminate" md-diameter="50"></md-progress-circular></div><div \nclass="mail-list-item filter-selected" ng-if="vm.selectedGroup" layout="row" layout-align="start center"><div \nclass="info" flex><div class="name" layout="row" layout-align="start center"><md-icon \nng-if="!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 1" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-font-icon="icon-folder" aria-hidden="true"></md-icon>\n<md-icon ng-if="!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 2" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-font-icon="qiu-icon-file-usermailing" aria-hidden="true">\n</md-icon><md-icon ng-if="vm.selectedGroup.children && vm.selectedGroup.id_group_type == 2" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-svg-src="/assets/icons/svg/icon-folder-mail-multiple.svg" \naria-hidden="true"></md-icon><md-icon ng-if="!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 3" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-font-icon="qiu-icon-file-usermediacenter" \naria-hidden="true"></md-icon><md-icon ng-if="vm.selectedGroup.children && vm.selectedGroup.id_group_type == 3" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-svg-src="/assets/icons/svg/icon-folder-play-multiple.svg" \naria-hidden="true"></md-icon><md-icon ng-if="!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 4" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-font-icon="qiu-icon-file-usersegment" aria-hidden="true">\n</md-icon><md-icon ng-if="vm.selectedGroup.children && vm.selectedGroup.id_group_type == 4" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-svg-src="/assets/icons/svg/icon-folder-share-multiple.svg" \naria-hidden="true"></md-icon><md-icon ng-if="!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 5" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-font-icon="qiu-icon-file-userstore" aria-hidden="true">\n</md-icon><md-icon ng-if="vm.selectedGroup.children && vm.selectedGroup.id_group_type == 5" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-svg-src="/assets/icons/svg/icon-folder-shop-multiple.svg" \naria-hidden="true"></md-icon><md-icon ng-if="!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 6" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-font-icon="qiu-icon-file-useracreditation" \naria-hidden="true"></md-icon><md-icon ng-if="vm.selectedGroup.children && vm.selectedGroup.id_group_type == 6" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-svg-src="/assets/icons/svg/icon-folder-board-multiple.svg" \naria-hidden="true"></md-icon><md-icon ng-if="!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 7" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-svg-src="/assets/icons/svg/icon-folder-chat.svg" \naria-hidden="true"></md-icon><md-icon ng-if="vm.selectedGroup.children && vm.selectedGroup.id_group_type == 7" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-svg-src="/assets/icons/svg/icon-folder-chat-multiple.svg" \naria-hidden="true"></md-icon><md-icon ng-if="!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 8" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-font-icon="icon-folder-remove" aria-hidden="true">\n</md-icon><md-icon ng-if="vm.selectedGroup.children && vm.selectedGroup.id_group_type == 8" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-font-icon="icon-folder-multiple" aria-hidden="true">\n</md-icon><md-icon ng-if="vm.selectedGroup.children && vm.selectedGroup.id_group_type == 1" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-font-icon="icon-folder-multiple" aria-hidden="true">\n</md-icon><div class="title text-truncate" layout="row" layout-align="start center">{{vm.selectedGroup.name}} <span \nng-if="!isLoading">({{pagination_totalItems | number}})</span></div></div></div><div class="buttons" layout="row" \nlayout-align="start center"><div><md-switch class="no-label" ng-checked="vm.includeSubgroups" \nng-click="vm.toggleIncludeSubgroups($event)" aria-label="{{vm.includeSubgroups ? \'Uncheck\':\'check\'}}"></md-switch>\n<md-tooltip><span translate="CONTENT.INCLUDE_SUBGROUPS">Include subgroups</span></md-tooltip></div><md-icon \nng-if="!vm.selectedGroup.is_qiu_restricted" md-font-icon="icon-close s20" ng-click="vm.unselectGroups()" class="ml-10">\n<md-tooltip hide show-gt-xs><span translate="CONTENT.DESELECT_GROUP">Deselect group</span></md-tooltip></md-icon></div>\n</div><div class="mail-list-item filter-selected" ng-if="vm.fieldOrder != undefined || vm.groupBy != undefined" \nlayout="row" layout-align="space-between center"><div layout="row" layout-align="start center" flex><div class="info" \nng-if="vm.groupBy != undefined"><div class="name" layout="row" layout-align="start center"><md-icon \nmd-font-icon="icon-format-list-bulleted" class="s20 mr-5 ml-0 mb-0"></md-icon><div class="title text-truncate" \nlayout="row" layout-align="start center">Grouped by \'{{vm.groupBy}}\'</div></div></div><div class="info" \nng-if="vm.fieldOrder != undefined"><div class="name" layout="row" layout-align="start center"><md-icon \nmd-font-icon="icon-sort-ascending" class="s20 mr-5 ml-0 mb-0" ng-if="sortDir === \'ASC\'"></md-icon><md-icon \nmd-font-icon="icon-sort-descending" class="s20 mr-5 ml-0 mb-0" ng-if="sortDir === \'DESC\'"></md-icon><div \nclass="title text-truncate" layout="row" layout-align="start center">Ordered by \'{{vm.fieldOrder}}\'</div></div></div>\n</div><div class="buttons" layout="row" layout-align="start center"><md-icon md-font-icon="icon-close s20" \nng-click="vm.resetSortField()" class="ml-10"><md-tooltip hide show-gt-xs><span translate="CONTENT.REMOVE">Remove</span>\n</md-tooltip></md-icon></div></div><div class="no-threads" \nng-if="!isLoading && vm.threads.length === 0 && !vm.pleaseSelectGroup" ng-hide="isLoading" translate="USERS.NO_ITEMS">\n</div><div class="no-threads" ng-if="!isLoading && vm.threads.length === 0 && vm.pleaseSelectGroup" \nng-hide="isLoading" translate="USERS.SELECT_GROUP"></div><div id="list-content-data" \nng-style="{\'opacity\' : isLoading ? 0.2 : 1}" \nng-class="{\'group-filter\': vm.selectedGroup,\'other-filter\':vm.fieldOrder != undefined || vm.groupBy != undefined}" \nclass="scrollable" ng-if="vm.threads.length > 0"><table class="table-scrollable row-border hover simple" \nms-responsive-table><thead><tr><th class="mini"></th><th \nng-class="{\'large\': vm.isLarge(column.title), \'medium\' : vm.isMedium(column.title), \'small\' : vm.isSmall(column.title), \'mini\': vm.isMini(column.title)}" \nng-repeat="column in vm.refcolumns | filter: { table_list_position: \'main\'} | orderBy: vm.orderByTableListSort" \nng-if="column.title !== \'lastname\'" ng-switch="column.title"><span ng-switch-when="firstname" translate="USERS.NAME">\n</span> <span ng-switch-default ng-bind="column.field_name"></span></th><th class="group" \nng-repeat="column in vm.flatGroups | filter: { table_list_position: \'main\'}"><span translate="GROUP.GROUP"></span><br>\n<span>"{{column.name}}"</span></th><th class="small"><md-menu-bar><md-menu><md-button class="md-icon-button" \naria-label="Actions" ng-click="$mdMenu.open($event)" layout="row" layout-align="center center"><md-icon \nmd-font-icon="icon-cog"></md-icon><md-tooltip hide show-gt-xs><span translate="USERS.EDIT_COLUMNS">Edit columns</span>\n</md-tooltip></md-button><md-menu-content><md-menu-item \nng-repeat="column in vm.refcolumns | orderBy: vm.orderByTableListSort | filter: vm.filterIsMainOrSecondaryTableListPosition">\n<md-button md-prevent-menu-close="md-prevent-menu-close" \nng-click="column.table_list_position == \'main\' ? column.table_list_position = \'secondary\' : column.table_list_position = \'main\'; $event.stopPropagation();" \naria-label="{{column.field_name}}"><div layout="row" layout-align="space-between center"><div layout="row" \nlayout-align="start between"><span ng-bind="column.field_name"></span></div><i \nng-if="column.table_list_position == \'main\'" class="icon-check s16"></i></div></md-button></md-menu-item><md-menu-item \nng-repeat="column in vm.flatGroups"><md-button md-prevent-menu-close="md-prevent-menu-close" \nng-click="column.table_list_position == \'main\' ? column.table_list_position = \'secondary\' : column.table_list_position = \'main\'; $event.stopPropagation();">\n<div layout="row" layout-align="space-between center"><div layout="row" layout-align="start between"><span \ntranslate="GROUP.GROUP"></span> <span>"{{column.name}}"</span></div><i ng-if="column.table_list_position == \'main\'" \nclass="icon-check s16"></i></div></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></th></tr>\n</thead><tbody><tr ng-click="vm.openThread(thread)" \nng-repeat="thread in vm.threads | filter: vm.search | filter: global.search | groupByUser:[vm.groupBy]" \nng-class="{\'starred\': thread.starred, \'selected\': vm.selectedContentID === thread.id_user, \'checked\': vm.isChecked(thread)}" \nclass="{{thread.status}}"><td class="mini"><md-checkbox class="no-label" ng-checked="vm.isSelected(thread)" \nng-click="vm.toggleSelectThread(thread, $event)" aria-label="{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}">\n</md-checkbox></td><td \nng-class="{\'large\': vm.isLarge(column.title), \'medium\' : vm.isMedium(column.title), \'small\' : vm.isSmall(column.title), \'mini\': vm.isMini(column.title)}" \nng-repeat="column in vm.refcolumns | filter: { table_list_position: \'main\'} | orderBy: vm.orderByTableListSort" \nng-if="column.title !== \'lastname\'" ng-switch="column.title"><a ng-switch-when="email" title="{{thread.email}}" \nhref="mailto:{{thread.email}}">{{thread[column.title]}}</a> <span ng-switch-when="media"><div \nng-if="(!thread.avatar) && thread[vm.refcolumnsgrouped.main[0].title]" class="avatar" \nng-bind="thread[vm.refcolumnsgrouped.main[0].title] | capitalizeFirstLetter" ms-random-class="vm.colors"></div><media \nng-if="thread.avatar" attachment="thread.avatar" class="avatar"></media></span><span title="# {{thread.id_user}}" \nclass="grey-500-fg" ng-switch-when="id_user">#{{thread.id_user}}</span> <span class="large" ng-switch-when="firstname">\n<strong title="{{thread.firstname}} {{thread.lastname}}">{{thread.firstname}} {{thread.lastname}}</strong> </span><span\n class="mini" ng-switch-when="status"><button ng-if="thread.status===0" class="md-icon-button"><md-icon \nmd-font-icon="icon-checkbox-blank-circle-outline" class="off red-fg s24" \nng-click="vm.toggleItemStatus(thread, $event, $index)"></md-icon><md-tooltip><span \ntranslate="USERS.EMAIL_STATUS.IMPORTED">Email imported</span></md-tooltip></button> <button ng-if="thread.status===1" \nclass="md-icon-button"><md-icon md-font-icon="icon-minus-circle" class="on amber-400-fg s24" \nng-click="vm.toggleItemStatus(thread, $event, $index)"></md-icon><md-tooltip><span \ntranslate="USERS.EMAIL_STATUS.NOT_VALIDATED">Email not validated</span></md-tooltip></button> <button \nng-if="thread.status===2" class="md-icon-button"><md-icon md-font-icon="icon-checkbox-marked-circle" \nclass="on green-fg s24" ng-click="vm.toggleItemStatus(thread, $event, $index)"></md-icon><md-tooltip><span \ntranslate="USERS.EMAIL_STATUS.VALIDATED">Email validated</span></md-tooltip></button> <button \nng-if="thread.status!==0 && thread.status!==1 && thread.status!==2" class="md-icon-button"><md-icon \nmd-font-icon="icon-checkbox-blank-circle" class="on grey-fg s24" \nng-click="vm.toggleItemStatus(thread, $event, $index)"></md-icon></button> </span><span class="mini" \nng-switch-when="ingroup_status"><div ng-if="thread.groups.length" class="status-wrapper text-center" layout="row" \nlayout-align="end center"><div ng-repeat="status in vm.ingroupStatus"><span \nng-click="vm.changeInGroupStatusDialog($event, thread, vm.selectedGroup, status)" \nng-if="vm.isShowingLabelGroup(thread, status)" class="{{status.name}} status" \ntranslate="USERS.INGROUP.STATUS.{{status.name | uppercase}}" layout="row" layout-align="center center" \nng-style="{\'background\': status.color || \'\'}"></span></div></div></span><span \ntitle="{{thread.related_country.country}}" ng-switch-when="country">{{thread.related_country.country}}</span> <span \ntitle="{{thread.related_state.state}}" ng-switch-when="state">{{thread.related_state.state}}</span> <span \ntitle="{{thread.related_city.city}}" ng-switch-when="city">{{thread.related_city.city}}</span> <span \ntitle="{{thread[column.title]}}" ng-switch-default>\n{{column.category == \'json\' ? vm.JSONparse(thread.user_params)[column.title] : thread[column.title]}}</span></td><td \nclass="group" ng-repeat="column in vm.flatGroups | filter: { table_list_position: \'main\'}"><md-checkbox \nng-disabled="true" class="no-label" ng-checked="(thread.groups|filter:{\'id_group\':column.id_group}).length > 0" \naria-label="{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}"></md-checkbox></td><td class="small"></td></tr></tbody>\n</table><div class="toolbar border-top" style="padding-bottom: 18px;" layout="row" layout-align="end center"><div \nlayout="row" layout-align="center center" ng-style="{\'display\' : isLoading ? \'none\' : \'block\'}"><span \nclass="page-info">{{pagination_totalItems}} items found.</span><md-button aria-label="Previous" \nclass="md-icon-button arrow" ng-click="pagination_prevPage()" ng-disabled="pagination_firstPage()" translate="" \ntranslate-attr-aria-label="CONTENT.PREVIOUS"><md-icon md-font-icon="icon-chevron-left"></md-icon><md-tooltip hide \nshow-gt-xs><span translate="CONTENT.PREVIOUS">Previous</span></md-tooltip></md-button><span class="page-info">\n{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label="Next" class="md-icon-button arrow" \nng-click="pagination_nextPage()" ng-disabled="pagination_morePages() || pagination_total_pages === pagination_page" \ntranslate="" translate-attr-aria-label="CONTENT.NEXT"><md-icon md-font-icon="icon-chevron-right"></md-icon><md-tooltip \nhide show-gt-xs><span translate="CONTENT.NEXT">Next</span></md-tooltip></md-button></div></div></div>');
$templateCache.put('app/main/apps/inputs/views/list/list-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="isLoadingP" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="no-threads" ng-if="!companySel" ng-hide="isLoadingP" translate="GLOBAL.NO_ITEMS"></div><div \nid="list-content-data" ng-if="!isLoadingP && companySel" ng-style="{\'opacity\' : isLoadingP ? 0.5 : 1}"><table \nms-responsive-table><thead><tr class="font-size-16"><th></th><th><span translate="INPUT.PROYECT_NAME">Stakeholder name\n</span></th><th><span translate="INPUT.INPUT_NAME">Input name</span></th><th><span \ntranslate="INPUT.CONTRIBUTION_YEARS">Contribution years</span></th><th><span translate="INPUT.SUBCALCULATION">Calc\n</span></th><th><span translate="INPUT.CALCULATION">Calc</span></th><th></th><th></th></tr></thead><tbody><tr \nng-repeat="company in vm.input" ng-init="parentIndex = $index" md-no-ink ng-click="vm.openCompany(company, $event)" \nng-class="{\'starred\': company.starred, \'selected\': vm.selectedContentID !== client.id_mailing_content, \'checked\': vm.isChecked(company)}">\n<td><md-checkbox class="no-label" ng-checked="vm.isSelected(company)" \nng-click="vm.toggleSelectThread(company, $event)" aria-label="{{vm.isSelected(company) ? \'Deselect\' : \'Select\'}}">\n</md-checkbox></td><td><span ng-repeat="state in vm.stakeholder" ng-if="state.id === company.stakeholder_id">\n{{state.stakeholder}}</span></td><td><span>{{company.input}}</span></td><td><span>{{company.years}}</span></td><td>\n<span>{{company.sub_result | currency:symbolMoney:2 }}</span></td><td><span>\n{{company.result | currency:symbolMoney:2 }}</span></td><td></td><td></td></tr></tbody></table><div \nng-if="!isLoading && pagination_total_pages > pagination_page && vm.companies.length > 0" class="load-more white p-30" \nlayout="row" layout-sm="column" layout-align="center center" layout-wrap=""><md-button \nng-click="pagination_nextPage(true)" class="md-raised">{{\'GLOBAL.LOAD_MORE\' |\xA0translate}}</md-button></div><div \nng-if="pagination_total_pages == pagination_page && pagination_page > 1" class="load-more white p-30" layout="row" \nlayout-sm="column" layout-align="center center" layout-wrap=""><div class="message" translate="GLOBAL.NO_MORE_ITEMS">\n</div></div></div>');
$templateCache.put('app/main/apps/inputs/views/list/nosplit-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.preview && !vm.readView" \nng-include="\'app/main/apps/clients/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row">\n<div class="content thread-detail mail-read-pane p0" flex="" id="thread-detail" ms-scroll="vm.msScrollOptions" \nng-if="vm.preview" ng-include="\'app/main/apps/clients/views/read/read-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="!vm.preview && !vm.readView" ng-include="\'app/main/apps/clients/views/list/list-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="vm.readView && vm.showForm" ng-include="\'app/main/apps/clients/views/read/form.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="vm.readView && !vm.showForm" ng-include="\'app/main/apps/clients/views/read/question-form.html\'"></div></div>');
$templateCache.put('app/main/apps/inputs/views/list/split-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.readView && !vm.preview" \nng-include="\'app/main/apps/inputs/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row">\n<div class="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="!vm.readView && !vm.preview" ng-include="\'app/main/apps/inputs/views/list/list-view.html\'"></div><div \nclass="content thread-detail mail-read-pane" flex="100" id="thread-detail" \nng-include="\'app/main/apps/inputs/views/edit/edit-view.html\'" ng-style="{\'margin-right\' : vm.edit ? \'0\' : \'-50%\'}">\n</div></div>');
$templateCache.put('app/main/apps/inputs/views/list/table-view.html','<div class="toolbar" layout="row" layout-align="space-between center" \nng-include="\'app/main/apps/users/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row"><div\n class="content thread-list mail-list-pane" flex="100" id="thread-list" \nng-include="\'app/main/apps/users/views/list/list-table-view.html\'"></div><div ng-if="!vm.isAccreditations" \nclass="content thread-detail mail-read-pane edit-pane-users" id="thread-detail" layout="column" \nng-include="\'app/main/apps/users/views/read/read-view.html\'" ng-class="{selected:vm.selectedContent}"></div><div \nng-if="vm.isAccreditations" class="content thread-detail mail-read-pane edit-pane-users" id="thread-detail" \nlayout="column" ng-include="\'app/main/apps/users/views/read/read-view-accreditations.html\'" \nng-class="{selected:vm.selectedContent}"></div></div>');
$templateCache.put('app/main/apps/inputs/views/list/toolbar.html','<div layout="row" layout-align="start center"><md-checkbox class="no-label" \naria-label="{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}" \nng-checked="vm.selectedThreads.length > 0" ng-click="vm.toggleSelectThreads(vm.selectedThreads, vm.contents)">\n</md-checkbox><div ng-if="!vm.fromComplaint || vm.userLogued.user_type <= 2" class="divider-vertical" hide="" \nshow-gt-xs=""></div><md-button ng-if="!vm.fromComplaint || vm.userLogued.user_type <= 2" aria-label="NEW" \nclass="md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme" hide show-gt-sm \nng-click="vm.newForm($event)" translate="INPUT.NEW" type="button"></md-button><md-button \nng-if="!vm.fromComplaint || vm.userLogued.user_type <= 2" aria-label="NEW" \nclass="md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme z-index-0" hide-gt-sm \nng-click="vm.newForm($event)" type="button"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="divider-vertical" hide="" show-gt-xs=""></div><div aria-hidden="false" \nclass="action-buttons hide show-gt-xs layout-align-start-center layout-row" layout="row" layout-align="start center" \nng-show="vm.selectedThreads.length > 0"><md-button ng-click="vm.deleteInput($ev)" aria-label="Delete" \nclass="md-icon-button" hide="" show-gt-xs="" translate=""><md-icon md-font-icon="icon-delete"></md-icon><md-tooltip \nhide show-gt-xs><span translate="GLOBAL.REMOVE"></span></md-tooltip></md-button><div class="divider-vertical" hide="" \nshow-gt-xs=""></div></div><ms-search-bar debounce="300" model-search="$root.pagination_searchquery" \non-result-click="vm.searchResultClick(item)" on-search="vm.search(query)" layout="row" layout-align="start center">\n</ms-search-bar><md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" \ntranslate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nng-if="$root.pagination_searchquery==true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip \nhide show-gt-xs><span>Reset search</span></md-tooltip></md-button><div class="divider-vertical" hide="" show-gt-xs="">\n</div><md-menu hide="" show-gt-xs="" ng-if="refGroupables.length>0"><button aria-label="Filters" \nclass="md-icon-button" ng-click="$mdMenu.open($event)" show-gt-xs="" translate="" \ntranslate-attr-aria-label="GLOBAL.FILTERS"><md-icon md-font-icon="icon-chevron-down"><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.GROUP_BY">Group</span></md-tooltip></md-icon></button><md-menu-content width="4"><md-menu-item \nng-repeat="sortfield in refGroupables"><md-button aria-label="All" ng-click="pagination_setOrderBy(sortfield)"><div \nlayout="row" layout-align="space-between center"><span>Group by {{sortfield.name}} </span><i class="icon-check s16" \nng-if="sortfield.titleId == sortable.titleId"></i></div></md-button></md-menu-item><md-menu-divider ng-if="groupable">\n</md-menu-divider><md-menu-item ng-if="groupable"><md-button aria-label="Remove group" \nng-click="pagination_resetOrderBy()"><md-icon md-font-icon="icon-close "></md-icon><span>Remove order</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div><div layout="row" layout-align="start center" \ntranslate-attr-aria-label="GLOBAL.REFRESH"><md-menu class="settings-menu" hide-gt-xs \nng-show="vm.selectedThreads.length > 0"><md-button aria-label="Settings" class="md-icon-button" \nng-click="$mdMenu.open($event)" translate="GLOBAL.SETTINGS" translate-attr-aria-label="GLOBAL.SETTINGS"><md-icon \nmd-font-icon="icon-dots-horizontal"></md-icon></md-button><md-menu-content><md-menu-item \nng-click="vm.deleteStakeholder($ev)" show="vm.selectedMail.length > 0 || vm.allChecked"><md-button \nng-click="vm.massActions(\'delete\')" aria-label="Delete" translate-aria-label="GLOBAL.DELETE"><md-icon \nmd-font-icon="icon-delete"></md-icon><span translate="GLOBAL.DELETE">Delete</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div>');
$templateCache.put('app/main/apps/inputs/views/read/form.html','<div id="forms" class="page-layout simple fullwidth doc-page forms" layout="column"><div class="p0" layout="column">\n<div layout="row"><ms-form-wizard class="no-margin" flex><div layout="row" layout-align="start center" flex="100" \nclass="layout-align-start-center layout-row flex-100 toolbar grey-100-bg colored-bg" ng-if="vm.idCompany"><a \nclass="pointer" ng-click="vm.closeForm()"><md-icon md-font-icon="icon-chevron-left"></md-icon></a><div \nclass="avatar-wrapper"><md-icon md-font-icon="icon-city"></md-icon></div><div class="field mr-10 ml-10 flex" flex="">\n<strong class="grey-800-fg ng-binding" ng-bind-html="vm.formWizard.company.name"></strong></div></div><md-tabs \nclass="height-tabs" md-dynamic-height md-selected="msWizard.selectedIndex" md-center-tabs="true"><md-tab><md-tab-label>\n<span class="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 0">1</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 0"><i class="icon-checkbox-blank-circle s16"></i> </span><span \nclass="ms-form-wizard-step-text" translate="GLOBAL.COMPANY_DATA"></span></span></md-tab-label><md-tab-body><form \nname="wizardStep1" ng-include="\'app/main/apps/clients/views/read/form-tabs/step-company.html\'" ms-form-wizard-form \nnovalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.idCompany"><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 1">2</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 1"><i class="icon-checkbox-blank-circle s16"></i> </span><span \nclass="ms-form-wizard-step-text" translate="CLIENTS.OPTIONS"></span></span></md-tab-label><md-tab-body><form \nname="wizardStep1b" ng-include="\'app/main/apps/clients/views/read/form-tabs/step-options.html\'" ms-form-wizard-form \nnovalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.idCompany"><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 2">3</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 2"><i class="icon-checkbox-blank-circle s16"></i> </span><span \nclass="ms-form-wizard-step-text" translate="GLOBAL.FILIATION_DATA"></span></span></md-tab-label><md-tab-body><div \nclass="navigation white-bg mb-50" flex layout="row" layout-align="center center"><div layout="row" flex \nlayout-align="start center"><md-button ng-if="vm.showForm" translate="GLOBAL.CLOSE" type="button" \nng-click="vm.closeForm()" class="md-raised md-warn hide-xs" aria-label="Cancel"></md-button><md-button \nng-if="vm.idCompany" translate="GLOBAL.SAVE" class="md-raised md-accent" ng-click="vm.nextStep(msWizard, true);" \nng-hide="msWizard.isLastStep()" ng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button></div><div \nclass="ml-auto" layout="row" flex layout-align="end center"><div flex layout="column" layout-align="center center" \nlayout-padding layout-margin ng-if="vm.loadingStep" class="loading-container"><md-progress-circular \nmd-mode="indeterminate" md-diameter="30"></md-progress-circular></div><md-button translate="GLOBAL.PREVIOUS" \nclass="md-raised md-accent" ng-click="vm.prevStep(msWizard)" ng-disabled="vm.previousStep(msWizard) || vm.loadingStep">\n</md-button><div class="steps"><span ng-repeat="form in msWizard.forms" \nng-class="{\'selected md-accent-bg\':msWizard.selectedIndex === $index}"></span></div><md-button translate="GLOBAL.NEXT" \nclass="md-raised md-accent" ng-click="vm.nextStep(msWizard)" ng-hide="msWizard.isLastStep()" \nng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button><md-button translate="GLOBAL.FINISH" \nclass="md-raised md-warn" ng-click="vm.sendForm(); msWizard.resetForm();" ng-show="msWizard.isLastStep()" \nng-disabled="msWizard.formsIncomplete()"></md-button></div></div><form name="wizardStep2" \nng-include="\'app/main/apps/clients/views/read/form-tabs/step-branchs.html\'" class="md-inline-form" ms-form-wizard-form \nnovalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.formWizard.main_branch.id"><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 3">4</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 3"><i class="icon-checkbox-blank-circle s16"></i> </span><span \ntranslate="GLOBAL.COMPLIANCE_COMMITTEE" class="ms-form-wizard-step-text"></span></span></md-tab-label><md-tab-body>\n<form ng-include="\'app/main/apps/clients/views/read/form-tabs/step-people.html\'" name="wizardStep3" \nms-form-wizard-form novalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.formWizard.main_branch.id">\n<md-tab-label><span class="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 4">5</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 4"><i class="icon-checkbox-blank-circle s16"></i> </span><span \ntranslate="GLOBAL.BRANCH_PERSONNEL" class="ms-form-wizard-step-text"></span></span></md-tab-label><md-tab-body><form \nng-include="\'app/main/apps/clients/views/read/form-tabs/step-people-global.html\'" name="wizardStep4" \nms-form-wizard-form novalidate></form></md-tab-body></md-tab></md-tabs><div \nclass="navigation white-bg border-top mb-50" flex layout="row" layout-align="center center"><div layout="row" flex \nlayout-align="start center"><md-button hide-xs ng-if="vm.showForm" translate="GLOBAL.CLOSE" type="button" \nng-click="vm.closeForm()" class="md-raised md-warn hide-xs" aria-label="Cancel"></md-button><md-button \nng-if="vm.idCompany" translate="GLOBAL.SAVE" class="md-raised md-accent" ng-click="vm.nextStep(msWizard, true);" \nng-hide="msWizard.isLastStep()" ng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button></div><div \nclass="ml-auto" layout="row" flex layout-align="end center"><div flex layout="column" layout-align="center center" \nlayout-padding layout-margin ng-if="vm.loadingStep" class="loading-container"><md-progress-circular \nmd-mode="indeterminate" md-diameter="30"></md-progress-circular></div><md-button translate="GLOBAL.PREVIOUS" \nclass="md-raised md-accent" ng-click="vm.prevStep(msWizard)" ng-disabled="vm.previousStep(msWizard) || vm.loadingStep">\n</md-button><div class="steps"><span ng-repeat="form in msWizard.forms" \nng-class="{\'selected md-accent-bg\':msWizard.selectedIndex === $index}"></span></div><md-button translate="GLOBAL.NEXT" \nclass="md-raised md-accent" ng-click="vm.nextStep(msWizard)" ng-hide="msWizard.isLastStep()" \nng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button><md-button translate="GLOBAL.FINISH" \nclass="md-raised md-warn" ng-click="vm.sendForm(); msWizard.resetForm();" ng-show="msWizard.isLastStep()" \nng-disabled="msWizard.formsIncomplete()"></md-button></div></div><div class="navigation" flex layout="row" \nlayout-align="center center"><md-button hide-xs ng-if="vm.showForm" translate="GLOBAL.CANCEL" type="button" \nng-click="vm.closeForm()" class="md-raised md-warn show-xs" aria-label="Cancel"></md-button></div></ms-form-wizard>\n</div></div></div>');
$templateCache.put('app/main/apps/inputs/views/read/preview-company.html','<div hide show-gt-sm class="toolbar grey-100-bg colored-bg" layout="row" layout-align="space-between center" scroll="">\n<div layout="row" layout-align="start center"><a class="pointer" ng-click="vm.goClients()"><md-icon \nmd-font-icon="icon-chevron-left"></md-icon></a><h2 translate="GLOBAL.COMPANY_DATA"></h2></div></div><div \nclass="md-whiteframe-1dp without-line scrollable preview" flex="100"><form name="vm.basicForm" class="md-inline-form" \nnovalidate><md-input-container class="md-block bb logotype"><img \nngf-thumbnail="!image.$error && image && vm.logoIsLoaded" class="img"> <img \nng-if="!image && imageUrl && vm.logoIsLoaded" src="{{imageUrl}}" class="img"><div \nng-if="!image && !imageUrl && vm.logoIsLoaded" class="avatar img" \nng-bind="vm.formWizard.company.name | capitalizeFirstLetter" ms-random-class="vm.colors"></div><h5 \nclass="padding inline-block m0">{{vm.formWizard.company.name}}</h5></md-input-container><md-input-container \nclass="md-block bb"><label>{{vm.getRegionLiteral(\'tax_ic_number\')}}</label><h5 class="padding">\n{{vm.formWizard.company.tax_id_number}}</h5></md-input-container><md-input-container class="md-block mg-bttm"><label \ntranslate="GLOBAL.SECTOR"></label><h5 class="padding">{{vm.getSectorById(vm.formWizard.company.sector_id).name}}</h5>\n</md-input-container><md-input-container class="md-block border separator mb-30"><h2 class="title" \ntranslate="CLIENTS.OPTIONS"></h2></md-input-container><md-input-container ng-if="vm.formWizard.company.description" \nclass="md-block bb options-preview"><label class="options-preview" translate="GLOBAL.DESCRIPTION"></label><h5 \nclass="padding mv-10">{{vm.formWizard.company.description}}</h5></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.executives_type" class="md-block bb mb-0 options-preview-select"><label \ntranslate="GLOBAL.EXECUTIVE_TYPE"></label><md-select class="disabled" ng-disabled="true" \nng-model="vm.formWizard.company.extra_data.executives_type"><md-option ng-value="1">Accionista \xFAnico</md-option>\n<md-option ng-value="2">Varios accionistas</md-option><md-option ng-value="3">Consejo de administraci\xF3n</md-option>\n<md-option ng-value="4">Administrador \xFAnico</md-option><md-option ng-value="5">Otros</md-option></md-select>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.capital" \nclass="md-block bb mb-0 options-preview-select"><label translate="GLOBAL.SOCIAL_CAPITAL"></label><md-select \nclass="disabled" ng-disabled="true" ng-model="vm.formWizard.company.extra_data.capital"><md-option ng-value="1">Capital\n</md-option><md-option ng-value="2">Aportaciones de socios</md-option><md-option ng-value="3">\nAumentos de capital recientes</md-option></md-select></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.capital_amount" class="md-block bb m0 options-preview"><label \nclass="options-preview" translate="GLOBAL.AMOUNT_CAPITAL"></label><h5 class="padding mv-10">\n{{vm.formWizard.company.extra_data.capital_amount}}</h5></md-input-container><md-input-container \nng-if="vm.formWizard.company.turnover_volume" class="md-block bb m0 options-preview"><label class="options-preview" \ntranslate="GLOBAL.BILLING_LAST_YEAR"></label><h5 class="padding mv-10">{{vm.formWizard.company.turnover_volume}}</h5>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.tax_options" \nclass="md-block bb mb-0 options-preview-select"><label>IVA</label><md-select class="disabled" ng-disabled="true" \nng-model="vm.formWizard.company.extra_data.tax_options"><md-option ng-value="1">Presentaci\xF3n trimestral</md-option>\n<md-option ng-value="2">Presentaci\xF3n mensual</md-option></md-select></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.annual_accounts" class="md-block bb mb-0 options-preview-select"><label>\nCuentas anuales</label><md-select class="disabled" ng-disabled="true" \nng-model="vm.formWizard.company.extra_data.annual_accounts"><md-option ng-value="1">Abreviadas</md-option><md-option \nng-value="2">Normales</md-option><md-option ng-value="3">Pymes</md-option><md-option ng-value="4">Mixtas</md-option>\n</md-select></md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.extra_data" \nclass="md-block bb mb-0 options-preview-select"><label>Auditor\xEDas</label><md-select class="disabled" \nng-disabled="true" ng-model="vm.formWizard.company.extra_data.audits"><md-option ng-value="1">Internas</md-option>\n<md-option ng-value="2">Externas</md-option><md-option ng-value="3">No aplica</md-option></md-select>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.iso_certification" \nclass="md-block bb mb-0 options-preview-select"><label>Certificaciones ISO</label><md-select class="disabled" \nng-disabled="true" ng-model="vm.formWizard.company.extra_data.iso_certification"><md-option ng-value="1">ISO 9001\n</md-option><md-option ng-value="2">ISO 14000</md-option><md-option ng-value="3">ISO 14001</md-option><md-option \nng-value="4">ISO 19600</md-option><md-option ng-value="5">ISO 22000</md-option><md-option ng-value="6">ISO 26000\n</md-option><md-option ng-value="7">ISO 27001</md-option><md-option ng-value="8">ISO 37001</md-option><md-option \nng-value="9">OHSAS 18001</md-option></md-select></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.collective_agreement" class="md-block bb m0 options-preview"><label \nclass="options-preview">Convenio Colectivo Aplicable</label><h5 class="padding mv-10">\n{{vm.formWizard.company.extra_data.collective_agreement}}</h5></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.insurance" class="md-block bb m0 options-preview"><label \nclass="options-preview">Seguros contratados</label><h5 class="padding mv-10">\n{{vm.formWizard.company.extra_data.insurance}}</h5></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.cnae" class="md-block bb m0 options-preview"><label class="options-preview" \ntranslate="GLOBAL.CNAE"></label><h5 class="padding mv-10">{{vm.formWizard.company.extra_data.cnae}}</h5>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.financing.length> 0" \nclass="md-block bb mb-0 options-preview-select"><label class="ph-15" fill-width translate="GLOBAL.FINANCING"></label>\n<md-select class="disabled" ng-disabled="true" multiple="{{false}}" \nng-model="vm.formWizard.company.extra_data.financing"><md-option ng-repeat="option in vm.financing_options" \nng-value="option">{{option.name}}</md-option></md-select></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.sector_regulations.length> 0" class="md-block bb mb-0 options-preview-select">\n<label class="ph-15" fill-width>Normativa Sectorial aplicable</label><md-select class="disabled" ng-disabled="true" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.sector_regulations"><md-option \nng-repeat="option in vm.sector_regulations_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.implemented_measures.length> 0" \nclass="md-block bb mb-20 options-preview-select"><label class="ph-15" fill-width>Medidas implementadas</label>\n<md-select class="disabled" ng-disabled="true" multiple="{{false}}" \nng-model="vm.formWizard.company.extra_data.implemented_measures"><md-option \nng-repeat="option in vm.implemented_measures_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container><md-input-container class="md-block border separator"><h2 class="title" \ntranslate="GLOBAL.MAIN_BRANCH"></h2></md-input-container><md-input-container class="md-block bb"><label \ntranslate="GLOBAL.NAME"></label><h5 class="padding">{{vm.formWizard.main_branch.name}}</h5></md-input-container>\n<md-input-container class="md-block bb"><label translate="GLOBAL.ADDRESS"></label><h5 class="padding">\n{{vm.formWizard.main_branch.address1}}</h5></md-input-container><md-input-container class="md-block bb"><label>\n{{vm.getRegionLiteral(\'city\')}}</label><h5 class="padding">{{vm.formWizard.main_branch.city}}</h5></md-input-container>\n<md-input-container class="md-block border separator"><h2 class="title" translate="GLOBAL.BRANCH"></h2>\n</md-input-container><div class="mail-list-pane s0" ng-if="vm.formWizard.branches && vm.formWizard.branches.length> 0">\n<div class="items" ng-repeat="branch in vm.formWizard.branches track by $index"><div layout="row" \nlayout-align="start center" flex="100" class="p-20 layout-align-start-center layout-row flex-100"><div layout="row" \nlayout-align="start center" flex="100" class="layout-align-start-center layout-row flex-100"><div \nclass="avatar-wrapper"><md-icon md-font-icon="icon-city"></md-icon></div><div class="field mr-10 ml-10 flex" flex="">\n<strong class="grey-800-fg ng-binding" ng-bind-html="branch.name"></strong><div class="field grey-600-fg ng-binding">\n<span ng-if="branch.city" ng-bind-html="branch.city"></span> <span ng-if="branch.city && branch.state">, </span><span \nng-if="branch.state" ng-bind-html="branch.state"></span></div></div></div></div></div></div></form></div>');
$templateCache.put('app/main/apps/inputs/views/read/preview-structure.html','<div hide show-gt-sm class="toolbar grey-100-bg colored-bg" layout="row" layout-align="space-between center" scroll="">\n<div layout="row" layout-align="start center"><h2>Organizaci\xF3n de la compa\xF1\xEDa</h2></div><div layout="row" \nlayout-align="end center" hide show-gt-sm><md-button translate="GLOBAL.EDIT" type="button" ng-click="vm.editCompany()" \nclass="md-raised md-accent" aria-label="Edit"></md-button></div><div layout="row" layout-align="end center" hide-gt-sm>\n<md-button type="button" ng-click="vm.editClient()" \nclass="md-accent md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" aria-label="Edit"><md-icon \nmd-font-icon="icon-plus"></md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.EDIT"></span></md-tooltip>\n</md-button></div></div><div class="without-line scrollable preview" flex="100"><div ivh-treeview="vm.tree" \nivh-treeview-options="vm.ivhOptions" class="treeview" \nivh-treeview-on-cb-change="vm.callback(ivhNode, ivhIsSelected, ivhTree)"><script type="text/ng-template">\n<div class="level-card" ng-if="node.type != \'user\'">\n                    <span ivh-treeview-toggle>\n                        <span ivh-treeview-twistie></span>\n                    </span>\n                    <md-icon md-font-icon="icon-city" ng-if="node.type == \'branch\'"></md-icon>\n                    <md-icon md-font-icon="icon-folder-account" ng-if="node.type == \'division\'"></md-icon>\n                    <md-icon md-font-icon="icon-worker" ng-if="node.type == \'job_position\'"></md-icon>\n                    <span class="ivh-treeview-node-label" ivh-treeview-toggle>{{trvw.label(node)}}</span>\n                </div>\n                <div class="level-card" ng-if="node.type == \'user\'">\n                    <div layout="row" layout-align="start center" flex="100">\n                        <div class="avatar-wrapper">\n                            <user-avatar User="node.user"/>\n                        </div>\n                        <div class="field mr-5 ml-5" flex>\n                            <strong class="grey-800-fg" ng-bind-html="node.user.first_name + \' \' + node.user.last_name"></strong>\n                        </div>\n                    </div>\n                </div>\n                <div ivh-treeview-children></div>\n</script></div></div>');
$templateCache.put('app/main/apps/inputs/views/read/question-form.html','<div id="forms" class="page-layout simple fullwidth doc-page forms" layout="column"><div ng-if="!vm.isQuestions"><div \nclass="page-layout carded left-sidenav" layout="row"><div class="content-wrapper" layout="row" flex><div \nclass="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-thumb-up" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="CLIENTS.CLIENT_CREATED_SUCCESSFULLY"></span><div layout-gt-xs="row" layout="column" \nlayout-align="center center" class="mt-15"><md-button translate="GLOBAL.BACK_CLIENT_LIST" type="button" \nng-click="vm.goClients()" class="md-raised md-warn" aria-label="Cancel"></md-button><md-button \nclass="md-raised md-accent" ui-sref="app.site_overview.questions.questionnaire" \ntranslate="GLOBAL.CONTINUE_WITH_QUESTIONS"></md-button></div></div></div></div></div></div><div ng-if="vm.isQuestions" \nclass="p0" layout="column"><div class="items outline"><div layout="column" class="selectors"><md-input-container><label\n class="al-left">Criterio</label><md-select ng-model="vm.allQuestions" ng-change="vm.goQuestions(msWizard)"><md-option \nng-value="true">Todas las preguntas</md-option><md-option ng-value="false">Preguntas del sector</md-option></md-select>\n</md-input-container></div><div layout="column" class="selectors"><md-input-container><label class="al-left">Branches\n</label><md-select multiple="{{true}}" ng-model="vm.branchQuestion"><md-option ng-repeat="branch in vm.branches" \nng-value="branch.id">{{branch.name}}</md-option></md-select></md-input-container></div></div><div layout="row" \nng-repeat="question in vm.questions"><div class="question"><div layout="column" layout-gt-xs="row"><md-input-container \nflex><h2>{{question.name}}</h2></md-input-container></div><div layout="column" layout-gt-xs="row"><md-radio-group \nng-model="question.value"><md-radio-button value="yes" class="inline">Si</md-radio-button><md-radio-button value="no" \nclass="inline ml">No</md-radio-button></md-radio-group></div></div></div><div class="navigation pt" flex layout="row" \nlayout-align="center center"><md-button translate="GLOBAL.CANCEL" class="md-raised md-warn" ng-click="vm.goClients()">\n</md-button><md-button translate="GLOBAL.SEND" class="md-raised md-warn" ng-click="vm.finishQuestion()" \nng-disabled="!vm.branchQuestion.length > 0"></md-button></div></div></div>');
$templateCache.put('app/main/apps/inputs/views/read/read-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="vm.loadingReadPane" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="fullheight" ng-if="!vm.loadingReadPane"><md-tabs class="fullheight"><md-tab label="Organizaci\xF3n"><content \nclass="" layout="row" ng-include="\'app/main/apps/clients/views/read/preview-company.html\'"></content></md-tab><md-tab \nlabel="Estructura"><content class="" layout="row" \nng-include="\'app/main/apps/clients/views/read/preview-structure.html\'"></content></md-tab><md-tab label="Edit" \nng-click="vm.editClient()"><content class="" ng-if="vm.showForm" layout="row" \nng-include="\'app/main/apps/clients/views/read/form.html\'"></content><content class="" ng-if="!vm.showForm" \nlayout="row" ng-include="\'app/main/apps/clients/views/read/question-form.html\'"></content></md-tab></md-tabs></div>');
$templateCache.put('app/main/apps/items/dialogs/forms/dialog-view.html','<md-dialog id="dialog-view" class="form-dialog-client add-media attachment-dialog" aria-label="New Message"><md-toolbar\n class="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><a \nclass="md-button layout-align-center-center layout-row md-default-theme" layout="row" layout-align="center center">\n<span class="ml-15" translate="{{ vm.title }}"></span></a><div class="absolute-right mr-10" layout="row  "><md-button \nclass="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</md-toolbar><form ng-if="vm.title === \'GLOBAL.NEW_BRANCH\'" id="site-content" class="content-card" \nng-class="vm.currentView" ng-include="\'app/main/apps/clients/dialogs/forms/forms-view-delegation.html\'"></form><form \nng-if="vm.title !== \'GLOBAL.NEW_BRANCH\'" id="site-content" flex class="md-inline-form content-card" \nng-class="vm.currentView" ng-include="\'app/main/apps/clients/dialogs/forms/forms-view-user.html\'"></form></md-dialog>');
$templateCache.put('app/main/apps/items/dialogs/forms/existing-user.html','<md-tabs fill-height-i style="height: 100%;" md-border-bottom><md-tab \nlabel="{{\'CLIENTS.COMPANY_PERSONEL\' | translate}}"><div style="max-height: 100%;" id="site-client"><div \nclass="search-input-wrapper border-bottom" layout="row" layout-align="start center"><md-icon class="mr-10 ml-20" \nmd-font-icon="icon-magnify"></md-icon><input id="search2" placeholder="{{\'CONTACTS.SEARCH_FOR_ANYONE\' | translate}}" \ntype="text" ng-model="searchText" class="flex h-60"></div><div style="max-height: 100%; overflow: hidden;" \nclass="content thread-list mail-list-pane p0" flex="" id="thread-list"><div id="list-content-data" \nng-style="{\'opacity\' : isLoading ? 0.5 : 1}"><div class="mail-list-item p0" \nng-repeat="user in vm.users | filter:{} | filter:searchText | filter:filterAlreadyAdded | orderBy: \'name\'" \nng-init="parentIndex= $index" md-no-ink ng-click="vm.selectUser(user)" \nng-class="{\'starred\': user.starred, \'selected\': vm.selectedContentID !== user.id_mailing_content, \'checked\': vm.isChecked(user)}">\n<div layout="row" layout-align="start center" flex="100" class="pl-15 pt-10 pb-10"><div class="info" flex \nlayout="column"><div class="name" layout="row"><div layout="row" layout-align="start center" flex="100"><div \nclass="avatar-wrapper"><img class="avatar s24" ng-src="{{vm.showUserImage(user)}}" ng-if="user.files.id"><div \nclass="avatar s24" ng-class="user.profile_color ? user.profile_color : \'md-blue-grey-300-bg\'" ng-if="!user.files.id" \nng-bind="user.first_name | capitalizeFirstLetter"></div></div><div layout="column" class="field mr-10 ml-10" flex><div>\n<strong class="grey-800-fg" ng-bind-html="user.first_name + \' \' + user.last_name"></strong></div><div><span \nstyle="font-weight: 300;">{{user.email}}</span></div></div></div></div><div></div></div></div></div></div></div>\n<md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" translate="" \ntranslate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" ng-if="$root.pagination_searchquery==true"><md-icon \nmd-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip hide show-gt-xs><span>Reset search</span></md-tooltip>\n</md-button></div></md-tab><md-tab ng-if="!vm.userLogued || vm.userLogued.user_type <6" \nlabel="{{\'CLIENTS.USER_ADMINISTRATORS\' | translate}}"><div style="max-height: 100%;" id="site-client"><div \nclass="search-input-wrapper border-bottom" layout="row" layout-align="start center"><md-icon class="mr-10 ml-20" \nmd-font-icon="icon-magnify"></md-icon><input id="search2" placeholder="{{\'CONTACTS.SEARCH_FOR_ANYONE\' | translate}}" \ntype="text" ng-model="searchTextAll" class="flex h-60"></div><div style="max-height: 100%; overflow: hidden;" \nclass="content thread-list mail-list-pane p0" flex="" id="thread-list"><div id="list-content-data" \nng-style="{\'opacity\' : isLoading ? 0.5 : 1}"><div class="mail-list-item p0" \nng-repeat="user in vm.usersAll | filter:searchTextAll | filter:filterAlreadyAdded | orderBy: \'name\'" \nng-init="parentIndex= $index" md-no-ink ng-click="vm.selectUser(user)" \nng-class="{\'starred\': user.starred, \'selected\': vm.selectedContentID !== user.id_mailing_content, \'checked\': vm.isChecked(user)}">\n<div layout="row" layout-align="start center" flex="100" class="pl-15 pt-10 pb-10"><div class="info" flex \nlayout="column"><div class="name" layout="row"><div layout="row" layout-align="start center" flex="100"><div \nclass="avatar-wrapper"><img class="avatar s24" ng-src="{{vm.showUserImage(user)}}" ng-if="user.files.id"><div \nclass="avatar s24" ng-class="user.profile_color ? user.profile_color : \'md-blue-grey-300-bg\'" ng-if="!user.files.id" \nng-bind="user.first_name | capitalizeFirstLetter"></div></div><div class="field mr-10 ml-10" flex><strong \nclass="grey-800-fg" ng-bind-html="user.first_name + \' \' + user.last_name"></strong></div></div></div></div></div></div>\n</div></div></div><md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" \ntranslate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nng-if="$root.pagination_searchquery==true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip \nhide show-gt-xs><span>Reset search</span></md-tooltip></md-button></md-tab></md-tabs>');
$templateCache.put('app/main/apps/items/dialogs/forms/external-user.html','<div id="forms" class="page-layout simple fullwidth doc-page forms scrollable" layout="column" ms-scroll><form \nname="wizardStep1" class="md-inline-form" ms-form-wizard-form novalidate><div \nng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" style="height: auto!important;" \nclass="items mt-10"><md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'text\' && field.field == \'3rd_party_company_name\'"><input type="{{field.type}}" \nng-model="field.value" placeholder="{{ field.translate | translate }}" ng-required="field.required">\n</md-input-container><md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'text\' && field.field != \'3rd_party_company_name\'"><input type="{{field.type}}" \nng-model="field.value" placeholder="{{ field.translate | translate }}" ng-required="field.required">\n</md-input-container><md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'password\'"><input type="{{field.type}}" ng-model="field.value" \nplaceholder="{{ field.translate | translate }}" ng-required="field.required"></md-input-container><md-input-container \nclass="item" ng-repeat="field in vm.fields" ng-if="!field.hidden && field.type == \'selector\'"><md-select \nng-disabled="vm.disabledPosition(field)" ng-if="field.field === \'position\'" ng-model="field.value" \nplaceholder="{{ field.translate | translate }}" required><md-option \nng-repeat="option in field.options track by $index" ng-value="option.id">{{option.field}}</md-option></md-select>\n</md-input-container></div><div ng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" \nlayout="row" flex><md-input-container flex class="item mv-0" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'picture\'"><div class="md-block"><div><div ngf-drop ngf-select \nng-model="vm.files" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="image/*" ngf-pattern="\'image/*\'"><div layout="column"><div flex translate="GLOBAL.DROP_HERE">\nDrop here or click to upload</div><div flex translate="GLOBAL.OR"></div><div flex><md-button \nclass="send-button md-accent md-raised" aria-label="Select files" translate="GLOBAL.SELECT_FILES"></md-button></div>\n</div></div><div ngf-no-file-drop translate="GLOBAL.FILE_DRAG_DROP"></div></div><div ng-repeat="f in vm.files" \nclass="ms-card" flex><div ng-if="!f.url" class="ms-card-content-wrapper"><div class="template-9"><div class="media" \nflex layout="row" layout-align="center center"><img ngf-thumbnail="!f.$error && f" class="image"></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><strong class="mr-5" ng-if="f.id">#{{f.id}}</strong> <span class="grey-500-fg"><span \nng-if="f.name">{{f.name}}</span></span></div></div></div><md-progress-linear md-mode="determinate" \nvalue="{{f.progress}}" ng-show="f.progress <100"></md-progress-linear></div></div><div ng-if="f.url" \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><img class="image" ng-src="{{vm.storagePrefix + f.url}}"></div><div class="header p-16" \nflex layout="row" layout-align="end center"><md-menu class="float-right"><md-button class="md-icon-button" \naria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item><md-button translate="GLOBAL.REMOVE" ng-click="vm.deleteAvatar(f)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item></md-menu-content>\n</md-menu></div><md-progress-linear md-mode="determinate" value="{{f.progress}}" ng-show="f.progress <100">\n</md-progress-linear></div></div></div></div></md-input-container></div><div \nng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" fill-width class="navigation pb-20" flex \nlayout="row" layout-align="center center"><md-button ng-if="vm.showJobDivision()" translate="GLOBAL.BACK" \nclass="md-raised md-warn" ng-click="vm.unSelectJobDivision()"></md-button><md-button ng-disabled="vm.isSendDisabled()" \ntranslate="GLOBAL.SEND" class="md-raised md-accent" ng-click="vm.sendForm($event)" ng-disabled="wizardStep1.$valid">\n</md-button></div><div class="text-center" ng-if="vm.user_type != undefined && vm.user_type != 4 && vm.user_type != 5">\n<h3>{{ \'CLIENTS.EDIT_USER_SECTION_USERS\' | translate}}</h3></div></form></div>');
$templateCache.put('app/main/apps/items/dialogs/forms/forms-view-delegation.html','<div id="forms" class="form-delegation page-layout simple fullwidth doc-page forms" layout="column"><div class="p0" \nlayout="column"><div layout="row"><ms-form-wizard class="popup" flex><form name="wizardStep1" class="md-inline-form" \nms-form-wizard-form novalidate><div class="items mt-30"><md-input-container class="item" \nng-repeat="field in vm.fields" ng-if="field.field !== \'id\' && field.field !== \'fullName\'"><input \nng-if="field.field !== \'phone\' && field.field !== \'email\' && field.field !== \'position\'" type="{{field.type}}" \nname="{{field.field}}" ng-model="field.value" placeholder="{{ field.translate | translate }}" required> <input \nng-if="field.field === \'phone\' || field.field === \'email\'" type="{{field.type}}" name="{{field.field}}" \nng-model="field.value" placeholder="{{ field.translate | translate }}"><div ng-messages="wizardStep1.email.$error" \nrole="alert" multiple="multiple"><div ng-message="pattern"><span translate="GLOBAL.EMAIL_VALID"></span></div></div>\n</md-input-container></div></form><div class="navigation pt-20" flex layout="row" layout-align="center center">\n<md-button translate="GLOBAL.SEND" class="md-raised md-warn" ng-click="vm.sendForm()" ng-disabled="wizardStep1.$valid">\n</md-button></div></ms-form-wizard></div></div></div>');
$templateCache.put('app/main/apps/items/dialogs/forms/forms-view-user.html','<div id="forms-position" class="page-layout simple fullwidth doc-page forms scrollable" layout="column" ms-scroll \nng-if="vm.showSelectPosition()"><form name="wizardStep2" class="md-inline-form" ms-form-wizard-form novalidate><h3 \nclass="mh-15" translate="CLIENTS.BEFORE_CONTINUE_PERSONEL"></h3><div class="items ph-15" layout="row">\n<md-input-container flex class="item" ng-if="vm.indexDivision != null" ng-show="vm.showSector()"><md-select \nng-model="vm.fields[vm.indexDivision].value" placeholder="{{ vm.fields[vm.indexDivision].translate | translate }}" \nrequired><md-option ng-repeat="option in vm.fields[vm.indexDivision].options track by $index" ng-value="option.id">\n{{option.field}}</md-option></md-select></md-input-container><md-input-container flex class="item" \nng-if="vm.indexPosition != null"><md-select ng-disabled="vm.disabledPosition(vm.fields[vm.indexPosition])" \nng-model="vm.fields[vm.indexPosition].value" placeholder="{{ vm.fields[vm.indexPosition].translate | translate }}" \nrequired><md-option ng-repeat="option in vm.fields[vm.indexPosition].options track by $index" ng-value="option.id">\n{{option.field}}</md-option></md-select></md-input-container></div></form><div class="navigation pt-20" flex \nlayout="row" layout-align="center center"><md-button translate="GLOBAL.SELECT" class="md-raised md-accent" \nng-click="vm.selectJobDivision()" ng-disabled="vm.divisionJobSelected()"></md-button></div></div><md-tabs \nfill-height-i md-border-bottom ng-if="!vm.showSelectPosition()"><md-tab label="{{\'CLIENTS.NEW_USER\' | translate}}"><div\n ng-include="\'app/main/apps/clients/dialogs/forms/new-user.html\'"></div></md-tab><md-tab \nlabel="{{\'CLIENTS.EXISTING_USER\' | translate}}"><div \nng-style="{\'height\': vm.showJobDivision() ? \'calc(100% - 58px)\' : \'100%\'}" \nng-include="\'app/main/apps/clients/dialogs/forms/existing-user.html\'"></div><div ng-if="vm.showJobDivision()" \nclass="navigation pt-10" flex layout="row" layout-align="center center"><md-button translate="GLOBAL.BACK" \nclass="md-raised md-warn" ng-click="vm.unSelectJobDivision()"></md-button></div></md-tab><md-tab \nlabel="{{\'CLIENTS.COMPANY_OR_EXTERNAL_STAFF\' | translate}}"><div \nng-include="\'app/main/apps/clients/dialogs/forms/external-user.html\'"></div></md-tab></md-tabs>');
$templateCache.put('app/main/apps/items/dialogs/forms/new-user.html','<div id="forms" class="page-layout simple fullwidth doc-page forms scrollable" layout="column" ms-scroll><form \nname="wizardStep1" class="md-inline-form" ms-form-wizard-form novalidate><div layout="row" \nng-if="!vm.showJobDivision() && !(vm.user_type != undefined && vm.user_type != 4 && vm.user_type != 5)  && !vm.type">\n<md-input-container flex class="item mh-15" ng-if="vm.indexDivision != null" ng-show="vm.showSector()"><md-select \nng-disabled="true" ng-model="vm.fields[vm.indexDivision].value" \nplaceholder="{{ vm.fields[vm.indexDivision].translate | translate }}" required><md-option \nng-repeat="option in vm.fields[vm.indexDivision].options track by $index" ng-value="option.id">{{option.field}}\n</md-option></md-select></md-input-container><md-input-container flex class="item mh-15" \nng-if="vm.indexPosition != null"><md-select ng-disabled="true" ng-model="vm.fields[vm.indexPosition].value" \nplaceholder="{{ vm.fields[vm.indexPosition].translate | translate }}" required><md-option \nng-repeat="option in vm.fields[vm.indexPosition].options track by $index" ng-value="option.id">{{option.field}}\n</md-option></md-select></md-input-container></div><div \nng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" style="height: auto!important;" \nclass="items mt-10"><md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'text\' && field.field != \'3rd_party_company_name\'"><input type="{{field.type}}" \nng-model="field.value" placeholder="{{ field.translate | translate }}" ng-required="field.required">\n</md-input-container><md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'password\'"><input type="{{field.type}}" ng-model="field.value" \nplaceholder="{{ field.translate | translate }}" ng-required="field.required"></md-input-container><md-input-container \nclass="item" ng-repeat="field in vm.fields" ng-if="!field.hidden && field.type == \'selector\'"><md-select \nng-disabled="vm.disabledPosition(field)" ng-if="field.field === \'position\'" ng-model="field.value" \nplaceholder="{{ field.translate | translate }}" required><md-option \nng-repeat="option in field.options track by $index" ng-value="option.id">{{option.field}}</md-option></md-select>\n</md-input-container></div><div ng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" \nlayout="row" flex><md-input-container flex class="item mv-0" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'picture\'"><div class="md-block"><div><div ngf-drop ngf-select \nng-model="vm.files" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="image/*" ngf-pattern="\'image/*\'"><div layout="column"><div flex translate="GLOBAL.DROP_HERE">\nDrop here or click to upload</div><div flex translate="GLOBAL.OR"></div><div flex><md-button \nclass="send-button md-accent md-raised" aria-label="Select files" translate="GLOBAL.SELECT_FILES"></md-button></div>\n</div></div><div ngf-no-file-drop translate="GLOBAL.FILE_DRAG_DROP"></div></div><div ng-repeat="f in vm.files" \nclass="ms-card" flex><div ng-if="!f.url" class="ms-card-content-wrapper"><div class="template-9"><div class="media" \nflex layout="row" layout-align="center center"><img ngf-thumbnail="!f.$error && f" class="image"></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><strong class="mr-5" ng-if="f.id">#{{f.id}}</strong> <span class="grey-500-fg"><span \nng-if="f.name">{{f.name}}</span></span></div></div></div><md-progress-linear md-mode="determinate" \nvalue="{{f.progress}}" ng-show="f.progress <100"></md-progress-linear></div></div><div ng-if="f.url" \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><img class="image" ng-src="{{vm.storagePrefix + f.url}}"></div><div class="header p-16" \nflex layout="row" layout-align="end center"><md-menu class="float-right"><md-button class="md-icon-button" \naria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.deleteAvatar(f)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-content></md-menu></div>\n<md-progress-linear md-mode="determinate" value="{{f.progress}}" ng-show="f.progress <100"></md-progress-linear></div>\n</div></div></div></md-input-container></div><div \nng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" fill-width class="navigation pb-20" flex \nlayout="row" layout-align="center center"><md-button ng-if="vm.showJobDivision()" translate="GLOBAL.BACK" \nclass="md-raised md-warn" ng-click="vm.unSelectJobDivision()"></md-button><md-button ng-disabled="vm.isSendDisabled()" \ntranslate="GLOBAL.SEND" class="md-raised md-accent" ng-click="vm.sendForm($event)" ng-disabled="wizardStep1.$valid">\n</md-button></div><div class="text-center" ng-if="vm.user_type != undefined && vm.user_type != 4 && vm.user_type != 5">\n<h3 ng-bind-html="vm.translate(\'CLIENTS.EDIT_USER_SECTION_USERS\')"></h3></div></form></div>');
$templateCache.put('app/main/apps/items/dialogs/edit-branch/edit-branch-dialog.controller.html','<md-dialog class="edit-branch-dialog" aria-label="New Task"><form name="taskForm" class="md-inline-form" novalidate>\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between"><h1 \nclass="title">{{vm.branch.name}}</h1><md-button class="md-icon-button" ng-click="vm.closeDialog()"><md-icon \nmd-font-icon="icon-close" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div layout="column" class="p-15"><md-input-container fill-width flex class="md-block mb-0"><label \ntranslate="GLOBAL.NAME"></label> <input ng-model="vm.branch.name" type="text"></md-input-container><md-input-container \nfill-width flex class="md-block mb-0"><label translate="GLOBAL.ADDRESS"></label> <input ng-model="vm.branch.address1" \ntype="text"></md-input-container><md-input-container fill-width flex class="md-block mb-0"><label>\n{{vm.getRegionLiteral(\'city\')}}</label> <input ng-model="vm.branch.city" type="text"></md-input-container>\n<md-input-container fill-width flex class="md-block mb-0"><label>{{vm.getRegionLiteral(\'state\')}}</label> <input \nng-model="vm.branch.state" type="text"></md-input-container><md-input-container fill-width flex class="md-block mb-0">\n<label translate="GLOBAL.POSTAL_CODE"></label> <input ng-model="vm.branch.postcode" type="text"></md-input-container>\n<md-input-container fill-width flex class="md-block mb-0"><label translate="GLOBAL.EMAIL"></label> <input \nng-model="vm.branch.email" type="text"></md-input-container><md-input-container fill-width flex class="md-block mb-0">\n<label translate="GLOBAL.PHONE"></label> <input ng-model="vm.branch.phone" type="text"></md-input-container></div>\n</md-dialog-content><md-dialog-actions class="footer" layout="row" layout-="end"><md-input-container flex layout="row" \nlayout-align="end center"><md-button type="button" class="md-raised md-warn" ng-click="vm.closeDialog()" \ntranslate="RISKCONFIG.CANCEL">Cancel</md-button><md-button ng-disabled="vm.selectedBranchs.length == 0" type="submit" \nclass="send-button md-accent md-raised" ng-click="vm.saveDialog()" translate="GLOBAL.SAVE">ADD</md-button>\n</md-input-container></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/items/dialogs/image/image-dialog.html','<md-dialog class="attachment-dialog" aria-label="New Task"><md-toolbar class="md-accent md-hue-2 md-default-theme"><div\n class="md-toolbar-tools"><div layout="row" hide show-gt-xs><a class="md-button" type="1" layout="row" \nlayout-align="center center" ng-click="vm.changeView(\'fotorama\')"><md-icon md-font-icon="icon-file-image-box" \nclass="s18 mr-5 ml-0"></md-icon><span translate="GLOBAL.PREVIEW">Preview Media</span></a></div><span flex></span><div \nlayout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content class="mediadialog-content" layout-fill><md-content flex class="content-card" \nng-class="vm.currentView" ng-include="vm.views[vm.currentView]" md-no-ink></md-content></md-dialog-content></md-dialog>');
$templateCache.put('app/main/apps/items/dialogs/new-stake-dialog/new-stake-dialog.html','<md-dialog class="new-client-dialog" aria-label="New Task"><form name="taskForm" class="md-inline-form" novalidate>\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between"><h1 \nclass="title" translate="STAKE.PROYECT_DATA"></h1><md-button class="md-icon-button" ng-click="vm.closeDialog()">\n<md-icon md-font-icon="icon-close" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content class="p-25" ms-scroll><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="STAKE.NAME"></label> <input type="text" ng-model="vm.company.stakeholder" required></md-input-container>\n</div><div layout="column" layout-gt-xs="row"><md-input-container flex><label translate="STAKE.INPUT"></label> <input \ntype="checkbox" ng-model="vm.company.input" value="1" name="input12" required></md-input-container><md-input-container \nflex><label translate="STAKE.OUTPUT"></label> <input ng-model="vm.company.output" type="checkbox" required>\n</md-input-container></div></md-dialog-content><md-dialog-actions class="footer" layout="row" layout-="end">\n<md-input-container flex layout="row" layout-align="end center"><md-button type="button" class="md-raised md-warn" \nng-click="vm.closeDialog()" translate="RISKCONFIG.CANCEL">Cancel</md-button><md-button \nng-disabled="!vm.company.stakeholder" type="submit" class="send-button md-accent md-raised" ng-click="vm.saveDialog()" \ntranslate="GLOBAL.SAVE">ADD</md-button></md-input-container></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/items/dialogs/media/media-clients-tinymce.html','<md-dialog class="attachment-dialog add-media" aria-label="New Message"><form class="md-inline-form"><md-toolbar \nclass="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><div layout="row" \nhide show-gt-xs><a class="md-button" type="1" layout="row" layout-align="center center" \nng-click="vm.changeViewTiny(\'1\')"><md-icon md-font-icon="icon-file-image-box" class="s18 mr-5 ml-0"></md-icon><span>\nAttached Media</span></a></div><div layout="row" hide-gt-xs show-xs><md-menu><md-button aria-label="Filters" \nng-click="$mdMenu.open($event)" translate="" translate-attr-aria-label="GLOBAL.FILTERS"><span layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-file-image-box" class="s18 mr-5 ml-0"></md-icon><span \nclass="ml-5">Images</span> <i class="icon-chevron-down s20 ml-5"></i></span></md-button><md-menu-content width="3">\n<md-menu-item><md-button type="photos" ng-click="vm.changeViewTiny(\'1\')"><div layout="row" \nlayout-align="space-between center"><div><md-icon md-font-icon="icon-file-image-box" class="s18"></md-icon><span>Images\n</span></div><i class="icon-check s16" ng-if="sortfield.titleId == sortable.titleId"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu></div><div layout="row"><md-button class="md-icon-button" \nng-click="vm.closeDialog()" aria-label="Close dialog" tranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon \nmd-font-icon="icon-close"></md-icon></md-button></div></div></md-toolbar><div flex \nng-include="\'app/main/apps/clients/dialogs/media/views/templates/toolbar-search.html\'"></div><md-dialog-content \nclass="mediadialog-content scrollable" layout-fill ms-scroll><treasure-overlay-spinner active="vm.loading"><div \nlayout="column" flex><md-content flex class="content-card" ng-class="vm.currentViewTiny" \nng-include="vm.viewsTiny[vm.currentViewTiny]" md-no-ink></md-content></div></treasure-overlay-spinner>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="space-between center" ng-if="!vm.loading"><div \nlayout="row" layout-align="start center"></div><div layout="row" layout-align="end right"><md-button \nng-click="vm.attachMediaTiny()" class="send-button md-accent md-raised" aria-label="Send" translate="GLOBAL.ADD_FILE" \ntranslate-attr-aria-label="GLOBAL.ADD_FILE">ADD</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/items/dialogs/media/media-clients.html','<md-dialog class="attachment-dialog add-media" aria-label="New Message"><form class="md-inline-form"><md-toolbar \nclass="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><div layout="row" \nhide show-gt-xs><a class="md-button" type="upload" layout="row" layout-align="center center" \nng-click="vm.changeView(\'upload\')"><md-icon md-font-icon="icon-import" class="s18 mr-5 ml-0"></md-icon><span \ntranslate="GLOBAL.UPLOAD"></span></a></div><div layout="row" hide-gt-xs show-xs><md-menu><md-button \naria-label="Filters" ng-click="$mdMenu.open($event)" translate="" translate-attr-aria-label="GLOBAL.FILTERS"><span \nlayout="row" layout-align="start center"><md-icon md-font-icon="icon-file-image-box" class="s18 mr-5 ml-0"></md-icon>\n<span class="ml-5" ng-if="vm.currentView===\'upload\'">Upload</span><i class="icon-chevron-down s20 ml-5"></i></span>\n</md-button><md-menu-content width="3"><md-menu-item><md-button type="import" ng-click="vm.changeView(\'import\')"><div \nlayout="row" layout-align="space-between center"><div><md-icon md-font-icon="icon-import" class="s18"></md-icon><span>\nUpload</span></div><i class="icon-check s16" ng-if="vm.currentView===\'upload\'"></i></div></md-button></md-menu-item>\n</md-menu-content></md-menu></div><div layout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog" tranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></div></md-toolbar><md-dialog-content ms-scroll flex class="content-card" \nng-class="vm.currentView" ng-include="vm.views[vm.currentView]"></md-dialog-content></form></md-dialog>');
$templateCache.put('app/main/apps/items/views/list/list-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="isLoadingP" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="no-threads" ng-if="!companySel" ng-hide="isLoadingP" translate="GLOBAL.NO_ITEMS"></div><div \nid="list-content-data" ng-if="!isLoadingP && companySel" ng-style="{\'opacity\' : isLoadingP ? 0.5 : 1}"><table \nms-responsive-table><thead><tr class="font-size-16"><th></th><th><span translate="ITEM.ITEM_NAME">ITEM name</span></th>\n<th><span translate="ITEM.DESCRIPTION">description</span></th><th><span translate="ITEM.VALUE">value</span></th><th>\n<span translate="ITEM.TYPE">type</span></th><th><span translate="ITEM.EDIT">type</span></th><th></th><th></th></tr>\n</thead><tbody><tr ng-repeat="company in vm.item" ng-init="parentIndex = $index" md-no-ink \nng-click="vm.openCompany(company, $event)" \nng-class="{\'starred\': company.starred, \'selected\': vm.selectedContentID !== client.id_mailing_content, \'checked\': vm.isChecked(company)}">\n<td><md-checkbox class="no-label" ng-checked="vm.isSelected(company)" \nng-click="vm.toggleSelectThread(company, $event)" aria-label="{{vm.isSelected(company) ? \'Deselect\' : \'Select\'}}">\n</md-checkbox></td><td><span>{{company.name}}</span></td><td><span>{{company.description_item}}</span></td><td><span>\n{{company.value | currency:symbolMoney:2 }}</span></td><td><span ng-repeat="state in vm.tipefield" \nng-if="state.number == company.type">{{state.name}}</span></td><td><span ng-repeat="edita in vm.editfield" \nng-if="edita.number == company.edit_item">{{edita.name}}</span></td><td></td><td></td></tr></tbody></table><div \nng-if="!isLoading && pagination_total_pages > pagination_page && vm.companies.length > 0" class="load-more white p-30" \nlayout="row" layout-sm="column" layout-align="center center" layout-wrap=""><md-button \nng-click="pagination_nextPage(true)" class="md-raised">{{\'GLOBAL.LOAD_MORE\' |\xA0translate}}</md-button></div><div \nng-if="pagination_total_pages == pagination_page && pagination_page > 1" class="load-more white p-30" layout="row" \nlayout-sm="column" layout-align="center center" layout-wrap=""><div class="message" translate="GLOBAL.NO_MORE_ITEMS">\n</div></div></div>');
$templateCache.put('app/main/apps/items/views/list/nosplit-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.preview && !vm.readView" \nng-include="\'app/main/apps/clients/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row">\n<div class="content thread-detail mail-read-pane p0" flex="" id="thread-detail" ms-scroll="vm.msScrollOptions" \nng-if="vm.preview" ng-include="\'app/main/apps/clients/views/read/read-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="!vm.preview && !vm.readView" ng-include="\'app/main/apps/clients/views/list/list-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="vm.readView && vm.showForm" ng-include="\'app/main/apps/clients/views/read/form.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="vm.readView && !vm.showForm" ng-include="\'app/main/apps/clients/views/read/question-form.html\'"></div></div>');
$templateCache.put('app/main/apps/items/views/list/split-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.readView && !vm.preview" \nng-include="\'app/main/apps/items/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row"><div\n class="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="!vm.readView && !vm.preview" ng-include="\'app/main/apps/items/views/list/list-view.html\'"></div><div \nclass="content thread-detail mail-read-pane scrollable p0" flex="" id="thread-detail" ms-scroll="vm.msScrollOptions" \nng-include="\'app/main/apps/items/views/edit/edit-view.html\'" ng-style="{\'margin-right\' : vm.edit ? \'0\' : \'-50%\'}">\n</div></div>');
$templateCache.put('app/main/apps/items/views/list/toolbar.html','<div layout="row" layout-align="start center"><md-checkbox class="no-label" \naria-label="{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}" \nng-checked="vm.selectedThreads.length > 0" ng-click="vm.toggleSelectThreads(vm.selectedThreads, vm.contents)">\n</md-checkbox><div ng-if="!vm.fromComplaint || vm.userLogued.user_type <= 2" class="divider-vertical" hide="" \nshow-gt-xs=""></div><md-button ng-if="!vm.fromComplaint || vm.userLogued.user_type <= 2" aria-label="NEW" \nclass="md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme" hide show-gt-sm \nng-click="vm.newForm($event)" translate="ITEM.NEW" type="button"></md-button><md-button \nng-if="!vm.fromComplaint || vm.userLogued.user_type <= 2" aria-label="NEW" \nclass="md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme z-index-0" hide-gt-sm \nng-click="vm.newForm($event)" type="button"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="divider-vertical" hide="" show-gt-xs=""></div><div aria-hidden="false" \nclass="action-buttons hide show-gt-xs layout-align-start-center layout-row" layout="row" layout-align="start center" \nng-show="vm.selectedThreads.length > 0"><md-button ng-click="vm.deleteitem($ev)" aria-label="Delete" \nclass="md-icon-button" hide="" show-gt-xs="" translate=""><md-icon md-font-icon="icon-delete"></md-icon><md-tooltip \nhide show-gt-xs><span translate="GLOBAL.REMOVE"></span></md-tooltip></md-button><div class="divider-vertical" hide="" \nshow-gt-xs=""></div></div><ms-search-bar debounce="300" model-search="$root.pagination_searchquery" \non-result-click="vm.searchResultClick(item)" on-search="vm.search(query)" layout="row" layout-align="start center">\n</ms-search-bar><md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" \ntranslate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nng-if="$root.pagination_searchquery==true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip \nhide show-gt-xs><span>Reset search</span></md-tooltip></md-button><div class="divider-vertical" hide="" show-gt-xs="">\n</div><md-menu hide="" show-gt-xs="" ng-if="refGroupables.length>0"><button aria-label="Filters" \nclass="md-icon-button" ng-click="$mdMenu.open($event)" show-gt-xs="" translate="" \ntranslate-attr-aria-label="GLOBAL.FILTERS"><md-icon md-font-icon="icon-chevron-down"><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.GROUP_BY">Group</span></md-tooltip></md-icon></button><md-menu-content width="4"><md-menu-item \nng-repeat="sortfield in refGroupables"><md-button aria-label="All" ng-click="pagination_setOrderBy(sortfield)"><div \nlayout="row" layout-align="space-between center"><span>Group by {{sortfield.name}} </span><i class="icon-check s16" \nng-if="sortfield.titleId == sortable.titleId"></i></div></md-button></md-menu-item><md-menu-divider ng-if="groupable">\n</md-menu-divider><md-menu-item ng-if="groupable"><md-button aria-label="Remove group" \nng-click="pagination_resetOrderBy()"><md-icon md-font-icon="icon-close "></md-icon><span>Remove order</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div><div layout="row" layout-align="start center" \ntranslate-attr-aria-label="GLOBAL.REFRESH"><md-menu class="settings-menu" hide-gt-xs \nng-show="vm.selectedThreads.length > 0"><md-button aria-label="Settings" class="md-icon-button" \nng-click="$mdMenu.open($event)" translate="GLOBAL.SETTINGS" translate-attr-aria-label="GLOBAL.SETTINGS"><md-icon \nmd-font-icon="icon-dots-horizontal"></md-icon></md-button><md-menu-content><md-menu-item \nng-click="vm.deleteStakeholder($ev)" show="vm.selectedMail.length > 0 || vm.allChecked"><md-button \nng-click="vm.massActions(\'delete\')" aria-label="Delete" translate-aria-label="GLOBAL.DELETE"><md-icon \nmd-font-icon="icon-delete"></md-icon><span translate="GLOBAL.DELETE">Delete</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div>');
$templateCache.put('app/main/apps/items/views/edit/edit-view.html','<div class="content thread-detail" layout="row" layout-align="center center" flex ng-if="!vm.edit"><div \nclass="no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-google-circles-communities" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="GLOBAL.SELECT_ITEM"></span></div></div><div class="form-wrapper md-whiteframe-1dp without-line" \nng-if="vm.edit"><form name="stakeForm" class="md-inline-form" novalidate><div layout="column" class="edit_stake">\n<md-input-container flex><label translate="ITEM.ITEM_NAME"></label> <input type="text" ng-model="vm.company.name" \nrequired></md-input-container><md-input-container flex><label translate="ITEM.DESCRIPTION"></label> <input type="text" \nng-model="vm.company.description_item" required></md-input-container></div><div layout="row" class="edit_stake">\n<md-input-container flex><label translate="ITEM.VALUE"></label> <input type="number" string-to-number \nng-model="vm.company.value" ng-change="vm.cambio=true" required></md-input-container><span>\n&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp</span><md-input-container id="inputType"><label \ntranslate="ITEM.TYPE"></label><md-select ng-model="vm.company.type"><md-option ng-repeat="typeFi in vm.tipefield" \nng-value="typeFi.number"><span>{{typeFi.name}}</span></md-option></md-select></md-input-container></div><div \nlayout="column" class="field_edit"><md-checkbox ng-model="vm.company.edit_item" ng-true-value="\'1\'" ng-false-value="0" \nng-change="vm.cambio=true"><label translate="INPUT.EDITF"></label></md-checkbox></div><md-dialog-actions \nclass="footer" layout="row" layout-="end"><md-input-container flex layout="row" layout-align="end center"><md-button \ntype="button" class="md-raised md-warn" ng-click="vm.closeDialog()" translate="RISKCONFIG.CANCEL">Cancel</md-button>\n<md-button ng-disabled="!vm.company.type" type="submit" class="send-button md-accent md-raised" \nng-click="vm.changeValue(vm.company);vm.saveDialog(vm.company, $event)" translate="GLOBAL.SAVE">ADD</md-button>\n</md-input-container></md-dialog-actions></form><div class="content thread-detail" layout="row" \nlayout-align="center center" flex ng-if="!vm.edit"><div class="no-thread-selected" layout="column" \nlayout-align="center center" flex><md-icon md-font-icon="icon-clipboard-account" class="s120 grey-400-fg"></md-icon>\n<span class="hint-text" translate="STAKE.SELECT_TASK"></span></div></div></div>');
$templateCache.put('app/main/apps/items/views/read/form.html','<div id="forms" class="page-layout simple fullwidth doc-page forms" layout="column"><div class="p0" layout="column">\n<div layout="row"><ms-form-wizard class="no-margin" flex><div layout="row" layout-align="start center" flex="100" \nclass="layout-align-start-center layout-row flex-100 toolbar grey-100-bg colored-bg" ng-if="vm.idCompany"><a \nclass="pointer" ng-click="vm.closeForm()"><md-icon md-font-icon="icon-chevron-left"></md-icon></a><div \nclass="avatar-wrapper"><md-icon md-font-icon="icon-city"></md-icon></div><div class="field mr-10 ml-10 flex" flex="">\n<strong class="grey-800-fg ng-binding" ng-bind-html="vm.formWizard.company.name"></strong></div></div><md-tabs \nclass="height-tabs" md-dynamic-height md-selected="msWizard.selectedIndex" md-center-tabs="true"><md-tab><md-tab-label>\n<span class="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 0">1</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 0"><i class="icon-checkbox-blank-circle s16"></i> </span><span \nclass="ms-form-wizard-step-text" translate="GLOBAL.COMPANY_DATA"></span></span></md-tab-label><md-tab-body><form \nname="wizardStep1" ng-include="\'app/main/apps/clients/views/read/form-tabs/step-company.html\'" ms-form-wizard-form \nnovalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.idCompany"><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 1">2</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 1"><i class="icon-checkbox-blank-circle s16"></i> </span><span \nclass="ms-form-wizard-step-text" translate="CLIENTS.OPTIONS"></span></span></md-tab-label><md-tab-body><form \nname="wizardStep1b" ng-include="\'app/main/apps/clients/views/read/form-tabs/step-options.html\'" ms-form-wizard-form \nnovalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.idCompany"><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 2">3</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 2"><i class="icon-checkbox-blank-circle s16"></i> </span><span \nclass="ms-form-wizard-step-text" translate="GLOBAL.FILIATION_DATA"></span></span></md-tab-label><md-tab-body><div \nclass="navigation white-bg mb-50" flex layout="row" layout-align="center center"><div layout="row" flex \nlayout-align="start center"><md-button ng-if="vm.showForm" translate="GLOBAL.CLOSE" type="button" \nng-click="vm.closeForm()" class="md-raised md-warn hide-xs" aria-label="Cancel"></md-button><md-button \nng-if="vm.idCompany" translate="GLOBAL.SAVE" class="md-raised md-accent" ng-click="vm.nextStep(msWizard, true);" \nng-hide="msWizard.isLastStep()" ng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button></div><div \nclass="ml-auto" layout="row" flex layout-align="end center"><div flex layout="column" layout-align="center center" \nlayout-padding layout-margin ng-if="vm.loadingStep" class="loading-container"><md-progress-circular \nmd-mode="indeterminate" md-diameter="30"></md-progress-circular></div><md-button translate="GLOBAL.PREVIOUS" \nclass="md-raised md-accent" ng-click="vm.prevStep(msWizard)" ng-disabled="vm.previousStep(msWizard) || vm.loadingStep">\n</md-button><div class="steps"><span ng-repeat="form in msWizard.forms" \nng-class="{\'selected md-accent-bg\':msWizard.selectedIndex === $index}"></span></div><md-button translate="GLOBAL.NEXT" \nclass="md-raised md-accent" ng-click="vm.nextStep(msWizard)" ng-hide="msWizard.isLastStep()" \nng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button><md-button translate="GLOBAL.FINISH" \nclass="md-raised md-warn" ng-click="vm.sendForm(); msWizard.resetForm();" ng-show="msWizard.isLastStep()" \nng-disabled="msWizard.formsIncomplete()"></md-button></div></div><form name="wizardStep2" \nng-include="\'app/main/apps/clients/views/read/form-tabs/step-branchs.html\'" class="md-inline-form" ms-form-wizard-form \nnovalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.formWizard.main_branch.id"><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 3">4</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 3"><i class="icon-checkbox-blank-circle s16"></i> </span><span \ntranslate="GLOBAL.COMPLIANCE_COMMITTEE" class="ms-form-wizard-step-text"></span></span></md-tab-label><md-tab-body>\n<form ng-include="\'app/main/apps/clients/views/read/form-tabs/step-people.html\'" name="wizardStep3" \nms-form-wizard-form novalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.formWizard.main_branch.id">\n<md-tab-label><span class="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 4">5</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 4"><i class="icon-checkbox-blank-circle s16"></i> </span><span \ntranslate="GLOBAL.BRANCH_PERSONNEL" class="ms-form-wizard-step-text"></span></span></md-tab-label><md-tab-body><form \nng-include="\'app/main/apps/clients/views/read/form-tabs/step-people-global.html\'" name="wizardStep4" \nms-form-wizard-form novalidate></form></md-tab-body></md-tab></md-tabs><div \nclass="navigation white-bg border-top mb-50" flex layout="row" layout-align="center center"><div layout="row" flex \nlayout-align="start center"><md-button hide-xs ng-if="vm.showForm" translate="GLOBAL.CLOSE" type="button" \nng-click="vm.closeForm()" class="md-raised md-warn hide-xs" aria-label="Cancel"></md-button><md-button \nng-if="vm.idCompany" translate="GLOBAL.SAVE" class="md-raised md-accent" ng-click="vm.nextStep(msWizard, true);" \nng-hide="msWizard.isLastStep()" ng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button></div><div \nclass="ml-auto" layout="row" flex layout-align="end center"><div flex layout="column" layout-align="center center" \nlayout-padding layout-margin ng-if="vm.loadingStep" class="loading-container"><md-progress-circular \nmd-mode="indeterminate" md-diameter="30"></md-progress-circular></div><md-button translate="GLOBAL.PREVIOUS" \nclass="md-raised md-accent" ng-click="vm.prevStep(msWizard)" ng-disabled="vm.previousStep(msWizard) || vm.loadingStep">\n</md-button><div class="steps"><span ng-repeat="form in msWizard.forms" \nng-class="{\'selected md-accent-bg\':msWizard.selectedIndex === $index}"></span></div><md-button translate="GLOBAL.NEXT" \nclass="md-raised md-accent" ng-click="vm.nextStep(msWizard)" ng-hide="msWizard.isLastStep()" \nng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button><md-button translate="GLOBAL.FINISH" \nclass="md-raised md-warn" ng-click="vm.sendForm(); msWizard.resetForm();" ng-show="msWizard.isLastStep()" \nng-disabled="msWizard.formsIncomplete()"></md-button></div></div><div class="navigation" flex layout="row" \nlayout-align="center center"><md-button hide-xs ng-if="vm.showForm" translate="GLOBAL.CANCEL" type="button" \nng-click="vm.closeForm()" class="md-raised md-warn show-xs" aria-label="Cancel"></md-button></div></ms-form-wizard>\n</div></div></div>');
$templateCache.put('app/main/apps/items/views/read/preview-company.html','<div hide show-gt-sm class="toolbar grey-100-bg colored-bg" layout="row" layout-align="space-between center" scroll="">\n<div layout="row" layout-align="start center"><a class="pointer" ng-click="vm.goClients()"><md-icon \nmd-font-icon="icon-chevron-left"></md-icon></a><h2 translate="GLOBAL.COMPANY_DATA"></h2></div></div><div \nclass="md-whiteframe-1dp without-line scrollable preview" flex="100"><form name="vm.basicForm" class="md-inline-form" \nnovalidate><md-input-container class="md-block bb logotype"><img \nngf-thumbnail="!image.$error && image && vm.logoIsLoaded" class="img"> <img \nng-if="!image && imageUrl && vm.logoIsLoaded" src="{{imageUrl}}" class="img"><div \nng-if="!image && !imageUrl && vm.logoIsLoaded" class="avatar img" \nng-bind="vm.formWizard.company.name | capitalizeFirstLetter" ms-random-class="vm.colors"></div><h5 \nclass="padding inline-block m0">{{vm.formWizard.company.name}}</h5></md-input-container><md-input-container \nclass="md-block bb"><label>{{vm.getRegionLiteral(\'tax_ic_number\')}}</label><h5 class="padding">\n{{vm.formWizard.company.tax_id_number}}</h5></md-input-container><md-input-container class="md-block mg-bttm"><label \ntranslate="GLOBAL.SECTOR"></label><h5 class="padding">{{vm.getSectorById(vm.formWizard.company.sector_id).name}}</h5>\n</md-input-container><md-input-container class="md-block border separator mb-30"><h2 class="title" \ntranslate="CLIENTS.OPTIONS"></h2></md-input-container><md-input-container ng-if="vm.formWizard.company.description" \nclass="md-block bb options-preview"><label class="options-preview" translate="GLOBAL.DESCRIPTION"></label><h5 \nclass="padding mv-10">{{vm.formWizard.company.description}}</h5></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.executives_type" class="md-block bb mb-0 options-preview-select"><label \ntranslate="GLOBAL.EXECUTIVE_TYPE"></label><md-select class="disabled" ng-disabled="true" \nng-model="vm.formWizard.company.extra_data.executives_type"><md-option ng-value="1">Accionista \xFAnico</md-option>\n<md-option ng-value="2">Varios accionistas</md-option><md-option ng-value="3">Consejo de administraci\xF3n</md-option>\n<md-option ng-value="4">Administrador \xFAnico</md-option><md-option ng-value="5">Otros</md-option></md-select>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.capital" \nclass="md-block bb mb-0 options-preview-select"><label translate="GLOBAL.SOCIAL_CAPITAL"></label><md-select \nclass="disabled" ng-disabled="true" ng-model="vm.formWizard.company.extra_data.capital"><md-option ng-value="1">Capital\n</md-option><md-option ng-value="2">Aportaciones de socios</md-option><md-option ng-value="3">\nAumentos de capital recientes</md-option></md-select></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.capital_amount" class="md-block bb m0 options-preview"><label \nclass="options-preview" translate="GLOBAL.AMOUNT_CAPITAL"></label><h5 class="padding mv-10">\n{{vm.formWizard.company.extra_data.capital_amount}}</h5></md-input-container><md-input-container \nng-if="vm.formWizard.company.turnover_volume" class="md-block bb m0 options-preview"><label class="options-preview" \ntranslate="GLOBAL.BILLING_LAST_YEAR"></label><h5 class="padding mv-10">{{vm.formWizard.company.turnover_volume}}</h5>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.tax_options" \nclass="md-block bb mb-0 options-preview-select"><label>IVA</label><md-select class="disabled" ng-disabled="true" \nng-model="vm.formWizard.company.extra_data.tax_options"><md-option ng-value="1">Presentaci\xF3n trimestral</md-option>\n<md-option ng-value="2">Presentaci\xF3n mensual</md-option></md-select></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.annual_accounts" class="md-block bb mb-0 options-preview-select"><label>\nCuentas anuales</label><md-select class="disabled" ng-disabled="true" \nng-model="vm.formWizard.company.extra_data.annual_accounts"><md-option ng-value="1">Abreviadas</md-option><md-option \nng-value="2">Normales</md-option><md-option ng-value="3">Pymes</md-option><md-option ng-value="4">Mixtas</md-option>\n</md-select></md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.extra_data" \nclass="md-block bb mb-0 options-preview-select"><label>Auditor\xEDas</label><md-select class="disabled" \nng-disabled="true" ng-model="vm.formWizard.company.extra_data.audits"><md-option ng-value="1">Internas</md-option>\n<md-option ng-value="2">Externas</md-option><md-option ng-value="3">No aplica</md-option></md-select>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.iso_certification" \nclass="md-block bb mb-0 options-preview-select"><label>Certificaciones ISO</label><md-select class="disabled" \nng-disabled="true" ng-model="vm.formWizard.company.extra_data.iso_certification"><md-option ng-value="1">ISO 9001\n</md-option><md-option ng-value="2">ISO 14000</md-option><md-option ng-value="3">ISO 14001</md-option><md-option \nng-value="4">ISO 19600</md-option><md-option ng-value="5">ISO 22000</md-option><md-option ng-value="6">ISO 26000\n</md-option><md-option ng-value="7">ISO 27001</md-option><md-option ng-value="8">ISO 37001</md-option><md-option \nng-value="9">OHSAS 18001</md-option></md-select></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.collective_agreement" class="md-block bb m0 options-preview"><label \nclass="options-preview">Convenio Colectivo Aplicable</label><h5 class="padding mv-10">\n{{vm.formWizard.company.extra_data.collective_agreement}}</h5></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.insurance" class="md-block bb m0 options-preview"><label \nclass="options-preview">Seguros contratados</label><h5 class="padding mv-10">\n{{vm.formWizard.company.extra_data.insurance}}</h5></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.cnae" class="md-block bb m0 options-preview"><label class="options-preview" \ntranslate="GLOBAL.CNAE"></label><h5 class="padding mv-10">{{vm.formWizard.company.extra_data.cnae}}</h5>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.financing.length> 0" \nclass="md-block bb mb-0 options-preview-select"><label class="ph-15" fill-width translate="GLOBAL.FINANCING"></label>\n<md-select class="disabled" ng-disabled="true" multiple="{{false}}" \nng-model="vm.formWizard.company.extra_data.financing"><md-option ng-repeat="option in vm.financing_options" \nng-value="option">{{option.name}}</md-option></md-select></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.sector_regulations.length> 0" class="md-block bb mb-0 options-preview-select">\n<label class="ph-15" fill-width>Normativa Sectorial aplicable</label><md-select class="disabled" ng-disabled="true" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.sector_regulations"><md-option \nng-repeat="option in vm.sector_regulations_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.implemented_measures.length> 0" \nclass="md-block bb mb-20 options-preview-select"><label class="ph-15" fill-width>Medidas implementadas</label>\n<md-select class="disabled" ng-disabled="true" multiple="{{false}}" \nng-model="vm.formWizard.company.extra_data.implemented_measures"><md-option \nng-repeat="option in vm.implemented_measures_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container><md-input-container class="md-block border separator"><h2 class="title" \ntranslate="GLOBAL.MAIN_BRANCH"></h2></md-input-container><md-input-container class="md-block bb"><label \ntranslate="GLOBAL.NAME"></label><h5 class="padding">{{vm.formWizard.main_branch.name}}</h5></md-input-container>\n<md-input-container class="md-block bb"><label translate="GLOBAL.ADDRESS"></label><h5 class="padding">\n{{vm.formWizard.main_branch.address1}}</h5></md-input-container><md-input-container class="md-block bb"><label>\n{{vm.getRegionLiteral(\'city\')}}</label><h5 class="padding">{{vm.formWizard.main_branch.city}}</h5></md-input-container>\n<md-input-container class="md-block border separator"><h2 class="title" translate="GLOBAL.BRANCH"></h2>\n</md-input-container><div class="mail-list-pane s0" ng-if="vm.formWizard.branches && vm.formWizard.branches.length> 0">\n<div class="items" ng-repeat="branch in vm.formWizard.branches track by $index"><div layout="row" \nlayout-align="start center" flex="100" class="p-20 layout-align-start-center layout-row flex-100"><div layout="row" \nlayout-align="start center" flex="100" class="layout-align-start-center layout-row flex-100"><div \nclass="avatar-wrapper"><md-icon md-font-icon="icon-city"></md-icon></div><div class="field mr-10 ml-10 flex" flex="">\n<strong class="grey-800-fg ng-binding" ng-bind-html="branch.name"></strong><div class="field grey-600-fg ng-binding">\n<span ng-if="branch.city" ng-bind-html="branch.city"></span> <span ng-if="branch.city && branch.state">, </span><span \nng-if="branch.state" ng-bind-html="branch.state"></span></div></div></div></div></div></div></form></div>');
$templateCache.put('app/main/apps/items/views/read/preview-structure.html','<div hide show-gt-sm class="toolbar grey-100-bg colored-bg" layout="row" layout-align="space-between center" scroll="">\n<div layout="row" layout-align="start center"><h2>Organizaci\xF3n de la compa\xF1\xEDa</h2></div><div layout="row" \nlayout-align="end center" hide show-gt-sm><md-button translate="GLOBAL.EDIT" type="button" ng-click="vm.editCompany()" \nclass="md-raised md-accent" aria-label="Edit"></md-button></div><div layout="row" layout-align="end center" hide-gt-sm>\n<md-button type="button" ng-click="vm.editClient()" \nclass="md-accent md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" aria-label="Edit"><md-icon \nmd-font-icon="icon-plus"></md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.EDIT"></span></md-tooltip>\n</md-button></div></div><div class="without-line scrollable preview" flex="100"><div ivh-treeview="vm.tree" \nivh-treeview-options="vm.ivhOptions" class="treeview" \nivh-treeview-on-cb-change="vm.callback(ivhNode, ivhIsSelected, ivhTree)"><script type="text/ng-template">\n<div class="level-card" ng-if="node.type != \'user\'">\n                    <span ivh-treeview-toggle>\n                        <span ivh-treeview-twistie></span>\n                    </span>\n                    <md-icon md-font-icon="icon-city" ng-if="node.type == \'branch\'"></md-icon>\n                    <md-icon md-font-icon="icon-folder-account" ng-if="node.type == \'division\'"></md-icon>\n                    <md-icon md-font-icon="icon-worker" ng-if="node.type == \'job_position\'"></md-icon>\n                    <span class="ivh-treeview-node-label" ivh-treeview-toggle>{{trvw.label(node)}}</span>\n                </div>\n                <div class="level-card" ng-if="node.type == \'user\'">\n                    <div layout="row" layout-align="start center" flex="100">\n                        <div class="avatar-wrapper">\n                            <user-avatar User="node.user"/>\n                        </div>\n                        <div class="field mr-5 ml-5" flex>\n                            <strong class="grey-800-fg" ng-bind-html="node.user.first_name + \' \' + node.user.last_name"></strong>\n                        </div>\n                    </div>\n                </div>\n                <div ivh-treeview-children></div>\n</script></div></div>');
$templateCache.put('app/main/apps/items/views/read/question-form.html','<div id="forms" class="page-layout simple fullwidth doc-page forms" layout="column"><div ng-if="!vm.isQuestions"><div \nclass="page-layout carded left-sidenav" layout="row"><div class="content-wrapper" layout="row" flex><div \nclass="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-thumb-up" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="CLIENTS.CLIENT_CREATED_SUCCESSFULLY"></span><div layout-gt-xs="row" layout="column" \nlayout-align="center center" class="mt-15"><md-button translate="GLOBAL.BACK_CLIENT_LIST" type="button" \nng-click="vm.goClients()" class="md-raised md-warn" aria-label="Cancel"></md-button><md-button \nclass="md-raised md-accent" ui-sref="app.site_overview.questions.questionnaire" \ntranslate="GLOBAL.CONTINUE_WITH_QUESTIONS"></md-button></div></div></div></div></div></div><div ng-if="vm.isQuestions" \nclass="p0" layout="column"><div class="items outline"><div layout="column" class="selectors"><md-input-container><label\n class="al-left">Criterio</label><md-select ng-model="vm.allQuestions" ng-change="vm.goQuestions(msWizard)"><md-option \nng-value="true">Todas las preguntas</md-option><md-option ng-value="false">Preguntas del sector</md-option></md-select>\n</md-input-container></div><div layout="column" class="selectors"><md-input-container><label class="al-left">Branches\n</label><md-select multiple="{{true}}" ng-model="vm.branchQuestion"><md-option ng-repeat="branch in vm.branches" \nng-value="branch.id">{{branch.name}}</md-option></md-select></md-input-container></div></div><div layout="row" \nng-repeat="question in vm.questions"><div class="question"><div layout="column" layout-gt-xs="row"><md-input-container \nflex><h2>{{question.name}}</h2></md-input-container></div><div layout="column" layout-gt-xs="row"><md-radio-group \nng-model="question.value"><md-radio-button value="yes" class="inline">Si</md-radio-button><md-radio-button value="no" \nclass="inline ml">No</md-radio-button></md-radio-group></div></div></div><div class="navigation pt" flex layout="row" \nlayout-align="center center"><md-button translate="GLOBAL.CANCEL" class="md-raised md-warn" ng-click="vm.goClients()">\n</md-button><md-button translate="GLOBAL.SEND" class="md-raised md-warn" ng-click="vm.finishQuestion()" \nng-disabled="!vm.branchQuestion.length > 0"></md-button></div></div></div>');
$templateCache.put('app/main/apps/items/views/read/read-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="vm.loadingReadPane" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="fullheight" ng-if="!vm.loadingReadPane"><md-tabs class="fullheight"><md-tab label="Organizaci\xF3n"><content \nclass="" layout="row" ng-include="\'app/main/apps/clients/views/read/preview-company.html\'"></content></md-tab><md-tab \nlabel="Estructura"><content class="" layout="row" \nng-include="\'app/main/apps/clients/views/read/preview-structure.html\'"></content></md-tab><md-tab label="Edit" \nng-click="vm.editClient()"><content class="" ng-if="vm.showForm" layout="row" \nng-include="\'app/main/apps/clients/views/read/form.html\'"></content><content class="" ng-if="!vm.showForm" \nlayout="row" ng-include="\'app/main/apps/clients/views/read/question-form.html\'"></content></md-tab></md-tabs></div>');
$templateCache.put('app/main/apps/notes/directives/ms-new-note/ms-new-note.html','<ms-note-form note-type="\'new\'"></ms-note-form><div ms-new-note-button class="new-note-button"><span \ntranslate="NOTES.TAKE_A_NOTE">Take a note..</span></div>');
$templateCache.put('app/main/apps/notes/directives/ms-note-form/ms-note-form.html','<form ng-submit="MsNoteForm.submit()" ng-class="MsNoteForm.note.color"><div ng-if="MsNoteForm.note.image" \nclass="image-wrapper"><img class="md-card-image" ng-src="{{MsNoteForm.note.image}}"><md-button \nclass="md-fab md-mini delete-image-button" ng-click="MsNoteForm.deleteImage()" aria-label="delete image" translate \ntranslate-attr-aria-label="NOTES.DELETE_IMAGE"><md-icon md-font-icon="icon-delete"></md-icon></md-button></div><input \ntype="text" class="note-title-input" placeholder="Title" ng-model="MsNoteForm.note.title" \nng-class="MsNoteForm.note.color"><md-input-container md-no-float ng-class="MsNoteForm.note.color"><textarea \ntype="text" class="note-description-textarea" placeholder="Take a note.." translate \ntranslate-attr-placeholder="NOTES.TAKE_A_NOTE" ng-model="MsNoteForm.note.description">\n    </textarea>\n</md-input-container><md-list class="checklist" ng-if="MsNoteForm.note.checklist.length > 0"><md-divider></md-divider>\n<md-list-item ng-repeat="item in MsNoteForm.note.checklist"><md-checkbox ng-model="item.checked" \naria-label="toggle check"></md-checkbox><p ng-class="{\'text-strike md-secondary-text\':item.checked}">{{item.text}}</p>\n<md-icon ng-click="$event.preventDefault();$event.stopPropagation();MsNoteForm.deleteCheckItem(item)" \nclass="md-secondary" md-font-icon="icon-close-circle" aria-label="remove"></md-icon><md-divider></md-divider>\n</md-list-item></md-list><div class="checklist-form" \nng-if="MsNoteForm.note.checklist.length > 0 || MsNoteForm.checkListForm" layout="row" layout-align="space-between end">\n<md-input-container class="" md-no-float flex><input id="new-checklist-item-input" type="text" placeholder="List item" \nng-model="MsNoteForm.newCheckListItem" \nng-keydown="$event.keyCode === 13 ? $event.preventDefault() + MsNoteForm.addChecklistItem():\'\';"></md-input-container>\n<md-button class="md-icon-button" ng-click="MsNoteForm.addChecklistItem()" aria-label="add"><md-icon \nmd-font-icon="icon-plus"></md-icon></md-button></div><div class="labels" ng-if="MsNoteForm.note.labels.length > 0" \nlayout="row" layout-wrap layout-align="end start"><div class="label" ng-repeat="labelId in MsNoteForm.note.labels" \nng-class="MsNoteForm.labels.getById(labelId).color">{{MsNoteForm.labels.getById(labelId).name}}</div></div><div \nng-if="MsNoteForm.type ===\'edit\'" class="date text-right p-16">{{MsNoteForm.note.time | altDate}}</div><div \nclass="footer" layout-gt-xs="row" layout-align-gt-xs="space-between center" layout="column" \nlayout-align="center center"><div class="actions" layout="row" layout-align="center center" layout-wrap><div \nid="image-uploader" flow-init="MsNoteForm.ngFlowOptions" flow-name="MsNoteForm.ngFlow.flow" \nflow-files-submitted="MsNoteForm.upload()" flow-file-success="MsNoteForm.imageSuccess($file, $message)" \nflow-complete="MsNoteForm.uploadComplete()" flow-file-added="!!{svg:1,png:1,gif:1,jpg:1,jpeg:1}[$file.getExtension()]">\n<md-button flow-btn class="add-img-button md-icon-button" aria-label="Add image" translate \ntranslate-attr-aria-label="NOTES.ADD_IMAGE"><md-icon md-font-icon="icon-file-image-box" class="s20"></md-icon>\n</md-button></div><md-button class="md-icon-button" aria-label="checklist" ng-click="MsNoteForm.checklistFormToggle()">\n<md-icon md-font-icon="icon-checkbox-multiple-marked" class="s20"></md-icon></md-button><md-menu class="label-menu">\n<md-button class="md-icon-button" aria-label="Label" translate translate-attr-aria-label="NOTES.LABEL" \nng-click="$mdMenu.open($event)"><md-icon md-menu-origin md-font-icon="icon-label" class="s20"></md-icon></md-button>\n<md-menu-content class="notes-labels-menu-content" width="4" ms-scroll><md-menu-item><md-input-container \nclass="no-errors-spacer" md-no-float><input placeholder="Search labels..." type="text" \nng-model="MsNoteForm.labelSearchText" autocomplete="off" translate-attr-palceholder="NOTES.SEARCH_LABELS">\n</md-input-container></md-menu-item><md-menu-item class="label" \nng-repeat="label in MsNoteForm.labels | filter: MsNoteForm.labelSearchText"><md-button class="label-toggle-button" \nmd-prevent-menu-close ng-class="label.color" ng-click="MsNoteForm.toggleInArray(label.id, MsNoteForm.note.labels)" \naria-label="Toggle Label" translate translate-attr-aria-label="NOTES.TOGGLE_LABEL"><div layout="row" \nlayout-align="space-between center"><span>{{label.name}}</span> <i \nng-if="MsNoteForm.exists(label.id, MsNoteForm.note.labels)" class="icon-check s16"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu><md-button class="md-icon-button" ng-click="MsNoteForm.toggleArchive()" \naria-label="archive"><md-icon md-font-icon="icon-archive" class="s20"></md-icon></md-button><ms-material-color-picker \nng-model="MsNoteForm.note.color"><md-button class="md-icon-button" aria-label="color"><md-icon \nmd-font-icon="icon-palette" class="s20"></md-icon></md-button></ms-material-color-picker><md-datepicker \nclass="reminder" ng-model="MsNoteForm.note.reminder" md-placeholder="Add reminder" ms-datepicker-fix></md-datepicker>\n</div><div layout="row" layout-align="end center"><md-button ng-if="MsNoteForm.type ===\'edit\'" \nng-click="MsNoteForm.deleteNote()" class="md-icon-button" aria-label="delete note"><md-icon md-font-icon="icon-delete">\n</md-icon></md-button><md-button ng-if="MsNoteForm.type ===\'edit\'" type="submit" translate="NOTES.SAVE" \nng-disabled="MsNoteForm.isNotValid()">Save</md-button><md-button ng-if="MsNoteForm.type ===\'new\'" type="submit" \ntranslate="NOTES.ADD" ng-disabled="MsNoteForm.isNotValid()">Add</md-button></div></div></form>');
$templateCache.put('app/main/apps/notes/directives/ms-note-item/ms-note-item.html','<md-card ng-class="MsNoteItem.note.color"><img ng-if="MsNoteItem.note.image" class="md-card-image" \nng-src="{{MsNoteItem.note.image}}"><md-card-content><md-card-title ng-if="MsNoteItem.note.title"><md-card-title-text>\n{{MsNoteItem.note.title}}</md-card-title-text></md-card-title><md-description ng-if="MsNoteItem.note.description">\n<span>{{MsNoteItem.note.description}}</span></md-description><div ng-if="MsNoteItem.note.checklist.length > 0" \nclass="checklist"><div class="checklist-item" ng-repeat="checkItem in  MsNoteItem.note.checklist" layout="row" \nlayout-align="start center"><md-checkbox ng-model="checkItem.checked" \nng-click="$event.preventDefault();$event.stopPropagation()" aria-label="{{checkItem.text}}"></md-checkbox><span \nclass="text-truncate" ng-class="{\'text-strike md-secondary-text\':checkItem.checked}" flex>{{checkItem.text}}</span>\n</div></div><div class="labels" ng-if="MsNoteItem.note.labels.length > 0" layout="row" layout-wrap \nlayout-align="end start"><div class="label" ng-repeat="labelId in MsNoteItem.note.labels" \nng-click="$event.preventDefault();$event.stopPropagation();vm.filterChange(vm.labels.getById(labelId))" \nng-class="vm.labels.getById(labelId).color">{{vm.labels.getById(labelId).name}}</div></div><div \nng-if="vm.noteListType ===\'reminders\' && MsNoteItem.note.reminder" class="reminder secondary-text text-right"><md-icon \nmd-font-icon="icon-bell" class="s16 mr-8"></md-icon><span>{{MsNoteItem.note.reminder | altDate}}</span></div>\n</md-card-content></md-card>');
$templateCache.put('app/main/apps/notes/sidenavs/main/main-sidenav.html','<div ms-scroll class="content"><md-list><md-list-item ng-click="vm.filterChange(\'notes\')" \nng-class="{\'selected\':vm.listType ===\'notes\'}"><div layout="row" layout-align="start center"><md-icon \nmd-font-icon="icon-lightbulb" class="mr-16"></md-icon><span translate="NOTES.NOTES">Notes</span></div></md-list-item>\n<md-list-item ng-click="vm.filterChange(\'reminders\')" ng-class="{\'selected\':vm.listType ===\'reminders\'}"><div \nlayout="row" layout-align="start center"><md-icon md-font-icon="icon-bell" class="mr-16"></md-icon><span \ntranslate="NOTES.REMINDERS">Reminders</span></div></md-list-item><md-divider></md-divider><md-subheader \nclass="md-no-sticky"><span translate="NOTES.LABELS">Labels</span></md-subheader><md-list-item \nng-repeat="label in vm.labels" ng-class="{\'selected\':vm.noteListType.name === label.name}" class="label" layout="row" \nlayout-align="start center" flex><ms-material-color-picker ng-model="label.color"><md-icon class="mr-16" \nmd-font-icon="icon-label" ng-style="{color:$selectedColor.bgColorValue}"></md-icon></ms-material-color-picker><span \nclass="label-name text-transclude" flex ng-hide="editLabelForm.$visible" ng-click="vm.filterChange(label)">\n{{label.name}} </span><span flex editable-text="label.name" e-form="editLabelForm" ng-show="editLabelForm.$visible">\n{{label.name}}</span><md-button class="md-icon-button" ng-hide="editLabelForm.$visible" \nng-click="editLabelForm.$show()" aria-label="edit label"><md-icon md-font-icon="icon-pencil" class="s16"></md-icon>\n</md-button><md-button class="md-icon-button" ng-hide="editLabelForm.$visible" \nng-click="vm.deleteLabel($event, label)" aria-label="delete label"><md-icon md-font-icon="icon-delete" class="s16">\n</md-icon></md-button></md-list-item><md-list-item class="new-label-form" ng-show="newLabelForm.$visible"><p \neditable-text="vm.newLabel.name" e-form="newLabelForm" onaftersave="vm.addNewLabel(vm.newLabel)"></p></md-list-item>\n<md-list-item class="" ng-click="newLabelForm.$show()" ng-hide="newLabelForm.$visible"><p class="md-accent-fg" \ntranslate="NOTES.NEW_LABEL">New Label</p></md-list-item><md-divider></md-divider><md-list-item \nng-click="vm.filterChange(\'archive\')" ng-class="{\'selected\':vm.listType ===\'archive\'}"><div layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-archive" class="mr-16"></md-icon><span \ntranslate="NOTES.ARCHIVE">Archive</span></div></md-list-item></md-list></div>');
$templateCache.put('app/main/apps/jobpositions/views/list/list-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="isLoading" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="no-threads" ng-if="!vm.jobs" ng-hide="isLoading" translate="GLOBAL.NO_ITEMS"></div><div \nid="list-content-data" ng-style="{\'opacity\' : isLoading ? 0.5 : 1}"><div class="mail-list-item" \nng-repeat="job in vm.jobs | filter: vm.search | filter: global.search" ng-init="parentIndex = $index" md-no-ink \nng-click="vm.openJob(job)" \nng-class="{\'starred\': job.starred, \'selected\': vm.jobselected.id === job.id, \'checked\': vm.isSelected(job)}"><div \nlayout="row" layout-align="start center"><md-checkbox class="no-label" ng-checked="vm.isSelected(job)" \nng-click="vm.toggleSelectThread(job, $event)" aria-label="{{vm.isSelected(job) ? \'Deselect\' : \'Select\'}}">\n</md-checkbox><div class="avatar-wrapper"></div><div class="info layout-column flex" flex="" layout="column"><div \nclass="name text-truncate" layout="row" layout-align="start center"><span>{{job.name}}</span> <span>{{job.last_name}}\n</span> <span ng-if="job.job_position_id">({{vm.getPositionNameById(job.job_position_id)}})</span></div><div \nclass="details text-truncate" layout="row" layout-align="start center"><span>{{job.email}}</span></div></div></div>\n</div><div ng-if="!isLoading && pagination_total_pages > pagination_page && vm.jobs.length > 0" \nclass="load-more white p-30" layout="row" layout-sm="column" layout-align="center center" layout-wrap=""><md-button \nng-click="pagination_nextPage(true)" class="md-raised">{{\'GLOBAL.LOAD_MORE\' |\xA0translate}}</md-button></div><div \nng-if="pagination_total_pages == pagination_page && pagination_page > 1" class="load-more white p-30" layout="row" \nlayout-sm="column" layout-align="center center" layout-wrap=""><div class="message" translate="GLOBAL.NO_MORE_ITEMS">\n</div></div></div>');
$templateCache.put('app/main/apps/jobpositions/views/list/nosplit-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.jobSelected && !vm.jobNew" \nng-include="\'app/main/apps/jobpositions/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" \nlayout="row"><div class="content thread-detail mail-read-pane p0" flex="" id="thread-detail" \nms-scroll="vm.msScrollOptions" ng-if="vm.jobSelected || vm.jobNew" \nng-include="\'app/main/apps/jobpositions/views/read/read-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="!vm.jobSelected && !vm.jobNew" ng-include="\'app/main/apps/jobpositions/views/list/list-view.html\'"></div></div>');
$templateCache.put('app/main/apps/jobpositions/views/list/split-view.html','<div class="toolbar" layout="row" layout-align="space-between center" \nng-include="\'app/main/apps/jobpositions/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" \nlayout="row"><div class="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" \nid="thread-list" ng-include="\'app/main/apps/jobpositions/views/list/list-view.html\'"></div><div \nclass="content thread-detail mail-read-pane p0" flex="" id="thread-detail" ms-scroll="vm.msScrollOptions" \nng-include="\'app/main/apps/jobpositions/views/read/read-view.html\'"></div></div>');
$templateCache.put('app/main/apps/jobpositions/views/list/toolbar.html','<div layout="row" layout-align="start center"><md-checkbox class="no-label" \naria-label="{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}" \nng-checked="vm.selectedThreads.length > 0" ng-click="vm.toggleSelectThreads(vm.selectedThreads, vm.contents)">\n</md-checkbox><div class="divider-vertical" hide="" show-gt-xs=""></div><md-button aria-label="NEW" \nclass="md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme" hide show-gt-sm \nng-click="vm.newJob()" translate="GLOBAL.NEW" type="button"></md-button><md-button aria-label="NEW" \nclass="md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme z-index-0" hide-gt-sm \nng-click="vm.newJob()" type="button"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="divider-vertical" hide="" show-gt-xs=""></div><div aria-hidden="false" \nclass="action-buttons hide show-gt-xs layout-align-start-center layout-row" layout="row" layout-align="start center" \nng-show="vm.selectedThreads.length > 0"><md-button ng-click="vm.deleteJob($event)" aria-label="Delete" \nclass="md-icon-button" hide="" show-gt-xs="" translate=""><md-icon md-font-icon="icon-delete"></md-icon><md-tooltip \nhide show-gt-xs><span translate="GLOBAL.REMOVE"></span></md-tooltip></md-button><md-button \nng-click="vm.duplicateJob()" aria-label="Duplicate" class="md-icon-button" hide="" show-gt-sm="" translate="" \ntranslate-attr-aria-label="GLOBAL.DUPLICATE"><md-icon md-font-icon="icon-content-duplicate"></md-icon><md-tooltip><span\n translate="GLOBAL.DUPLICATE"></span></md-tooltip></md-button><div class="divider-vertical" hide="" show-gt-xs="">\n</div></div><ms-search-bar debounce="300" model-search="$root.pagination_searchquery" \non-result-click="vm.searchResultClick(item)" on-search="vm.search(query)" layout="row" layout-align="start center">\n</ms-search-bar><md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" \ntranslate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nng-if="$root.pagination_searchquery==true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip \nhide show-gt-xs><span>Reset search</span></md-tooltip></md-button><div class="divider-vertical" hide="" show-gt-xs="">\n</div><md-menu hide="" show-gt-xs="" ng-if="refGroupables.length>0"><button aria-label="Filters" \nclass="md-icon-button" ng-click="$mdMenu.open($event)" show-gt-xs="" translate="" \ntranslate-attr-aria-label="GLOBAL.FILTERS"><md-icon md-font-icon="icon-chevron-down"><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.GROUP_BY">Group</span></md-tooltip></md-icon></button><md-menu-content width="4"><md-menu-item \nng-repeat="sortfield in refGroupables"><md-button aria-label="All" ng-click="pagination_setOrderBy(sortfield)"><div \nlayout="row" layout-align="space-between center"><span>Group by {{sortfield.name}} </span><i class="icon-check s16" \nng-if="sortfield.titleId == sortable.titleId"></i></div></md-button></md-menu-item><md-menu-divider ng-if="groupable">\n</md-menu-divider><md-menu-item ng-if="groupable"><md-button aria-label="Remove group" \nng-click="pagination_resetOrderBy()"><md-icon md-font-icon="icon-close "></md-icon><span>Remove order</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div><div layout="row" layout-align="start center" \ntranslate-attr-aria-label="GLOBAL.REFRESH"><span ng-if="!isLoading" class="page-info font-weight-500">\n{{vm.jobs.length}} {{ \'GLOBAL.OF\' | translate}} {{pagination_totalItems}} {{ \'GLOBAL.ITEMS\' | translate}}.</span><div \nclass="divider-vertical" hide hide show-gt-sm></div><md-button class="md-icon-button" \nng-click="vm.changeView(\'nosplit\')" ng-if="vm.currentView !== \'nosplit\'" hide show-gt-sm><md-icon \nmd-font-icon="icon-view-list" ng-if="vm.currentView !== \'nosplit\'"></md-icon><md-icon class="md-accent" \nmd-font-icon="icon-checkbox-marked" ng-if="vm.currentView === \'nosplit\'"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.NOSPLIT_VIEW">No split</span></md-tooltip></md-button><md-button class="md-icon-button" \nng-click="vm.changeView(\'split\')" ng-if="vm.currentView !== \'split\'" hide show-gt-sm><md-icon \nmd-font-icon="icon-view-quilt" ng-if="vm.currentView !== \'split\'"></md-icon><md-icon class="md-accent" \nmd-font-icon="icon-checkbox-marked" ng-if="vm.currentView === \'split\'"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.SPLIT_VIEW">split</span></md-tooltip></md-button><md-menu class="settings-menu" hide-gt-xs \nng-show="vm.selectedThreads.length > 0"><md-button aria-label="Settings" class="md-icon-button" \nng-click="$mdMenu.open($event)" translate="GLOBAL.SETTINGS" translate-attr-aria-label="GLOBAL.SETTINGS"><md-icon \nmd-font-icon="icon-dots-horizontal"></md-icon></md-button><md-menu-content><md-menu-item ng-click="vm.deleteClient()" \nshow="vm.selectedMail.length > 0 || vm.allChecked"><md-button ng-click="vm.deleteJob($event)" aria-label="Delete" \ntranslate-aria-label="GLOBAL.DELETE"><md-icon md-font-icon="icon-delete"></md-icon><span translate="GLOBAL.DELETE">\nDelete</span></md-button><md-button ng-click="vm.duplicateJob()" aria-label="Duplicate" \ntranslate-aria-label="GLOBAL.DUPLICATE"><md-icon md-font-icon="icon-content-duplicate"></md-icon><span \ntranslate="GLOBAL.DUPLICATE">Duplicate</span></md-button></md-menu-item></md-menu-content></md-menu></div>');
$templateCache.put('app/main/apps/mail/dialogs/compose/compose-dialog.html','<md-dialog class="compose-dialog" aria-label="New Message"><form class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="MAIL.NEW_MESSAGE">New Message</span><md-button class="md-icon-button" \nng-click="vm.closeDialog()" aria-label="Close dialog" tranlate translate-aria-label="MAIL.CLOSE_DIALOG"><md-icon \nmd-font-icon="icon-close"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass="md-block"><label translate="MAIL.FROM">From</label> <input ng-model="vm.form.from" type="email" \ndisabled="disabled"></md-input-container><md-input-container class="md-block to" \nng-class="{\'hidden-cc\': vm.hiddenCC, \'hidden-bcc\': vm.hiddenBCC}"><label translate="MAIL.TO">To</label> <input \nng-model="vm.form.to" type="email"><div class="cc-bcc" layout="row" layout-align="start center"><div class="show-cc" \nng-show="vm.hiddenCC" ng-click="vm.hiddenCC = false">CC</div><div class="show-bcc" ng-show="vm.hiddenBCC" \nng-click="vm.hiddenBCC = false">BCC</div></div></md-input-container><md-input-container class="md-block" \nng-hide="vm.hiddenCC"><label translate="MAIL.CC">Cc</label> <input ng-model="vm.form.cc" type="email">\n</md-input-container><md-input-container class="md-block" ng-hide="vm.hiddenBCC"><label translate="MAIL.BCC">Bcc\n</label> <input ng-model="vm.form.bcc" type="t"></md-input-container><md-input-container class="md-block"><label \ntranslate="MAIL.SUBJECT">Subject</label> <input ng-model="vm.form.subject" type="text"></md-input-container>\n<text-angular ng-model="vm.form.message"></text-angular><div class="attachment-list"><div class="attachment" \nlayout="row" layout-align="space-between center"><div><span class="filename">attachment-2.doc</span> <span \nclass="size">(12 Kb)</span></div><md-button class="md-icon-button" aria-label="Delete attachment" translate \ntranslate-attr-aria-label="MAIL.DELETE_ATTACHMENT"><md-icon md-font-icon="icon-close" class="s16"></md-icon>\n</md-button></div><div class="attachment" layout="row" layout-align="space-between center"><div><span class="filename">\nattachment-1.jpg</span> <span class="size">(350 Kb)</span></div><md-button class="md-icon-button" \naria-label="Delete attachment" translate translate-attr-aria-label="MAIL.DELETE_ATTACHMENT"><md-icon \nmd-font-icon="icon-close" class="s16"></md-icon></md-button></div></div></md-dialog-content><md-dialog-actions \nlayout="row" layout-align="space-between center"><div layout="row" layout-align="start center"><md-button \nng-click="vm.closeDialog()" class="send-button md-accent md-raised" aria-label="Send" translate="MAIL.SEND" \ntranslate-attr-aria-label="MAIL.SEND">SEND</md-button><md-button class="md-icon-button" aria-label="Attach file" \ntranslate-attr-aria-label="MAIL.ATTACH_FILE"><md-icon md-font-icon="icon-paperclip"></md-icon><md-tooltip><span \ntranslate="MAIL.ATTACH_FILE"></span></md-tooltip></md-button></div><div layout="row"><md-button class="md-icon-button" \naria-label="Delete" translate-attr-aria-label="MAIL.DELETE"><md-icon md-font-icon="icon-delete"></md-icon><md-tooltip>\n<span translate="MAIL.DELETE"></span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/jobpositions/views/read/edit.html','<div class="form-wrapper md-whiteframe-1dp without-line" flex="100"><form name="vm.basicForm" class="md-inline-form" \nnovalidate><div><md-input-container class="md-block"><label ng-bind="\'Name\'"></label> <input type="text" name="name" \nng-model="vm.jobSelected.name"></md-input-container></div></form></div>');
$templateCache.put('app/main/apps/jobpositions/views/read/new.html','<div class="form-wrapper md-whiteframe-1dp without-line" flex="100"><form name="vm.basicForm" class="md-inline-form" \nnovalidate><div><md-input-container class="md-block"><label>{{ \'GLOBAL.NAME\' | translate}}</label> <input type="text" \nname="name" ng-model="vm.jobNew.name"></md-input-container></div></form></div>');
$templateCache.put('app/main/apps/jobpositions/views/read/read-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="vm.loadingReadPane" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="content thread-detail" layout="row" layout-align="center center" flex \nng-if="!vm.jobSelected && !vm.jobNew"><div class="no-thread-selected" layout="column" layout-align="center center" \nflex><md-icon md-font-icon="icon-google-circles-communities" class="s120 grey-400-fg"></md-icon><span \nclass="hint-text" translate="GLOBAL.SELECT_ITEM"></span></div></div><div id="read-view" class="fullheight"><div \nclass="toolbar grey-100-bg colored-bg" layout="row" layout-align="space-between center" scroll="" \nng-if="vm.jobSelected ||\xA0vm.jobNew"><div layout="row" layout-align="start center"></div><div layout="row" \nlayout-align="end center" hide show-gt-sm><md-button translate="GLOBAL.CANCEL" type="button" ng-click="vm.closeJobs()" \nclass="md-raised md-warn" aria-label="Cancel"></md-button><md-button translate="GLOBAL.SAVE" type="button" \nng-disabled="vm.checkFields()" ng-click="vm.sendJob()" class="md-raised md-accent" aria-label="Save"></md-button></div>\n<div layout="row" layout-align="end center" hide-gt-sm><md-button type="button" ng-click="vm.sendJob()" \nng-disabled="vm.checkFields()" class="md-accent md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" \naria-label="Save"><md-icon md-font-icon="icon-plus"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.SAVE"></span></md-tooltip></md-button><md-button type="button" ng-click="vm.closeJobs()" \nclass="md-warn md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" aria-label="Cancel"><md-icon \nmd-font-icon="icon-window-close"></md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.CANCEL"></span>\n</md-tooltip></md-button></div></div><div class="main-content"><content ng-if="vm.jobSelected" class="" layout="row" \nng-include="\'app/main/apps/jobpositions/views/read/edit.html\'"></content><content ng-if="vm.jobNew" class="" \nng-include="\'app/main/apps/jobpositions/views/read/new.html\'"></content></div></div>');
$templateCache.put('app/main/apps/mail/sidenavs/main/main-sidenav.html','<div class="header" layout="column" layout-align="space-between start"><div class="logo" layout="row" \nlayout-align="start center"><span class="logo-icon"><md-icon md-font-icon="icon-email" class="icon"></md-icon></span>\n<span class="logo-text" translate="MAIL.MAILBOX">Mailbox</span></div><div class="account"><div class="title">John Doe\n</div><md-select class="account-selection simplified" placeholder="Mail Selection" ng-model="vm.selectedAccount">\n<md-option ng-repeat="(provider, address) in vm.accounts" value="{{provider}}">{{address}}</md-option></md-select>\n</div></div><md-content ms-scroll class="content" flex><div class="compose-button"><md-button \nclass="md-accent md-raised" aria-label="compose" ng-click="vm.composeDialog($event)" translate="MAIL.COMPOSE">COMPOSE\n</md-button></div><div class="navigation-simple" layout="column"><md-button class="item" aria-label="inbox" \nng-repeat="folder in vm.folders" ng-click="vm.loadFolder(folder.name)" \nng-class="{\'selected\':vm.isFolderActive(folder.name)}"><div layout="row" layout-align="start center"><md-icon \nmd-font-icon="{{folder.icon}}" class="s16"></md-icon><span class="title">{{folder.title}}</span></div></md-button><div \nclass="item subheader" translate="MAIL.LABELS">Labels</div><md-button class="item" ng-repeat="label in vm.labels" \nng-click="vm.loadLabel(label.name)" ng-class="{\'selected\':vm.isLabelActive(label.name)}"><div layout="row" \nlayout-align="start center"><div class="h-10 w-10 mr-16" ng-class="label.color"></div><span class="title">\n{{label.title}}</span></div></md-button></div></md-content>');
$templateCache.put('app/main/apps/proyects/dialogs/edit-branch/edit-branch-dialog.controller.html','<md-dialog class="edit-branch-dialog" aria-label="New Task"><form name="taskForm" class="md-inline-form" novalidate>\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between"><h1 \nclass="title">{{vm.branch.name}}</h1><md-button class="md-icon-button" ng-click="vm.closeDialog()"><md-icon \nmd-font-icon="icon-close" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div layout="column" class="p-15"><md-input-container fill-width flex class="md-block mb-0"><label \ntranslate="GLOBAL.NAME"></label> <input ng-model="vm.branch.name" type="text"></md-input-container><md-input-container \nfill-width flex class="md-block mb-0"><label translate="GLOBAL.ADDRESS"></label> <input ng-model="vm.branch.address1" \ntype="text"></md-input-container><md-input-container fill-width flex class="md-block mb-0"><label>\n{{vm.getRegionLiteral(\'city\')}}</label> <input ng-model="vm.branch.city" type="text"></md-input-container>\n<md-input-container fill-width flex class="md-block mb-0"><label>{{vm.getRegionLiteral(\'state\')}}</label> <input \nng-model="vm.branch.state" type="text"></md-input-container><md-input-container fill-width flex class="md-block mb-0">\n<label translate="GLOBAL.POSTAL_CODE"></label> <input ng-model="vm.branch.postcode" type="text"></md-input-container>\n<md-input-container fill-width flex class="md-block mb-0"><label translate="GLOBAL.EMAIL"></label> <input \nng-model="vm.branch.email" type="text"></md-input-container><md-input-container fill-width flex class="md-block mb-0">\n<label translate="GLOBAL.PHONE"></label> <input ng-model="vm.branch.phone" type="text"></md-input-container></div>\n</md-dialog-content><md-dialog-actions class="footer" layout="row" layout-="end"><md-input-container flex layout="row" \nlayout-align="end center"><md-button type="button" class="md-raised md-warn" ng-click="vm.closeDialog()" \ntranslate="RISKCONFIG.CANCEL">Cancel</md-button><md-button ng-disabled="vm.selectedBranchs.length == 0" type="submit" \nclass="send-button md-accent md-raised" ng-click="vm.saveDialog()" translate="GLOBAL.SAVE">ADD</md-button>\n</md-input-container></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/proyects/dialogs/forms/dialog-view.html','<md-dialog id="dialog-view" class="form-dialog-client add-media attachment-dialog" aria-label="New Message"><md-toolbar\n class="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><a \nclass="md-button layout-align-center-center layout-row md-default-theme" layout="row" layout-align="center center">\n<span class="ml-15" translate="{{ vm.title }}"></span></a><div class="absolute-right mr-10" layout="row  "><md-button \nclass="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</md-toolbar><form ng-if="vm.title === \'GLOBAL.NEW_BRANCH\'" id="site-content" class="content-card" \nng-class="vm.currentView" ng-include="\'app/main/apps/clients/dialogs/forms/forms-view-delegation.html\'"></form><form \nng-if="vm.title !== \'GLOBAL.NEW_BRANCH\'" id="site-content" flex class="md-inline-form content-card" \nng-class="vm.currentView" ng-include="\'app/main/apps/clients/dialogs/forms/forms-view-user.html\'"></form></md-dialog>');
$templateCache.put('app/main/apps/proyects/dialogs/forms/existing-user.html','<md-tabs fill-height-i style="height: 100%;" md-border-bottom><md-tab \nlabel="{{\'CLIENTS.COMPANY_PERSONEL\' | translate}}"><div style="max-height: 100%;" id="site-client"><div \nclass="search-input-wrapper border-bottom" layout="row" layout-align="start center"><md-icon class="mr-10 ml-20" \nmd-font-icon="icon-magnify"></md-icon><input id="search2" placeholder="{{\'CONTACTS.SEARCH_FOR_ANYONE\' | translate}}" \ntype="text" ng-model="searchText" class="flex h-60"></div><div style="max-height: 100%; overflow: hidden;" \nclass="content thread-list mail-list-pane p0" flex="" id="thread-list"><div id="list-content-data" \nng-style="{\'opacity\' : isLoading ? 0.5 : 1}"><div class="mail-list-item p0" \nng-repeat="user in vm.users | filter:{} | filter:searchText | filter:filterAlreadyAdded | orderBy: \'name\'" \nng-init="parentIndex= $index" md-no-ink ng-click="vm.selectUser(user)" \nng-class="{\'starred\': user.starred, \'selected\': vm.selectedContentID !== user.id_mailing_content, \'checked\': vm.isChecked(user)}">\n<div layout="row" layout-align="start center" flex="100" class="pl-15 pt-10 pb-10"><div class="info" flex \nlayout="column"><div class="name" layout="row"><div layout="row" layout-align="start center" flex="100"><div \nclass="avatar-wrapper"><img class="avatar s24" ng-src="{{vm.showUserImage(user)}}" ng-if="user.files.id"><div \nclass="avatar s24" ng-class="user.profile_color ? user.profile_color : \'md-blue-grey-300-bg\'" ng-if="!user.files.id" \nng-bind="user.first_name | capitalizeFirstLetter"></div></div><div layout="column" class="field mr-10 ml-10" flex><div>\n<strong class="grey-800-fg" ng-bind-html="user.first_name + \' \' + user.last_name"></strong></div><div><span \nstyle="font-weight: 300;">{{user.email}}</span></div></div></div></div><div></div></div></div></div></div></div>\n<md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" translate="" \ntranslate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" ng-if="$root.pagination_searchquery==true"><md-icon \nmd-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip hide show-gt-xs><span>Reset search</span></md-tooltip>\n</md-button></div></md-tab><md-tab ng-if="!vm.userLogued || vm.userLogued.user_type <6" \nlabel="{{\'CLIENTS.USER_ADMINISTRATORS\' | translate}}"><div style="max-height: 100%;" id="site-client"><div \nclass="search-input-wrapper border-bottom" layout="row" layout-align="start center"><md-icon class="mr-10 ml-20" \nmd-font-icon="icon-magnify"></md-icon><input id="search2" placeholder="{{\'CONTACTS.SEARCH_FOR_ANYONE\' | translate}}" \ntype="text" ng-model="searchTextAll" class="flex h-60"></div><div style="max-height: 100%; overflow: hidden;" \nclass="content thread-list mail-list-pane p0" flex="" id="thread-list"><div id="list-content-data" \nng-style="{\'opacity\' : isLoading ? 0.5 : 1}"><div class="mail-list-item p0" \nng-repeat="user in vm.usersAll | filter:searchTextAll | filter:filterAlreadyAdded | orderBy: \'name\'" \nng-init="parentIndex= $index" md-no-ink ng-click="vm.selectUser(user)" \nng-class="{\'starred\': user.starred, \'selected\': vm.selectedContentID !== user.id_mailing_content, \'checked\': vm.isChecked(user)}">\n<div layout="row" layout-align="start center" flex="100" class="pl-15 pt-10 pb-10"><div class="info" flex \nlayout="column"><div class="name" layout="row"><div layout="row" layout-align="start center" flex="100"><div \nclass="avatar-wrapper"><img class="avatar s24" ng-src="{{vm.showUserImage(user)}}" ng-if="user.files.id"><div \nclass="avatar s24" ng-class="user.profile_color ? user.profile_color : \'md-blue-grey-300-bg\'" ng-if="!user.files.id" \nng-bind="user.first_name | capitalizeFirstLetter"></div></div><div class="field mr-10 ml-10" flex><strong \nclass="grey-800-fg" ng-bind-html="user.first_name + \' \' + user.last_name"></strong></div></div></div></div></div></div>\n</div></div></div><md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" \ntranslate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nng-if="$root.pagination_searchquery==true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip \nhide show-gt-xs><span>Reset search</span></md-tooltip></md-button></md-tab></md-tabs>');
$templateCache.put('app/main/apps/proyects/dialogs/forms/external-user.html','<div id="forms" class="page-layout simple fullwidth doc-page forms scrollable" layout="column" ms-scroll><form \nname="wizardStep1" class="md-inline-form" ms-form-wizard-form novalidate><div \nng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" style="height: auto!important;" \nclass="items mt-10"><md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'text\' && field.field == \'3rd_party_company_name\'"><input type="{{field.type}}" \nng-model="field.value" placeholder="{{ field.translate | translate }}" ng-required="field.required">\n</md-input-container><md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'text\' && field.field != \'3rd_party_company_name\'"><input type="{{field.type}}" \nng-model="field.value" placeholder="{{ field.translate | translate }}" ng-required="field.required">\n</md-input-container><md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'password\'"><input type="{{field.type}}" ng-model="field.value" \nplaceholder="{{ field.translate | translate }}" ng-required="field.required"></md-input-container><md-input-container \nclass="item" ng-repeat="field in vm.fields" ng-if="!field.hidden && field.type == \'selector\'"><md-select \nng-disabled="vm.disabledPosition(field)" ng-if="field.field === \'position\'" ng-model="field.value" \nplaceholder="{{ field.translate | translate }}" required><md-option \nng-repeat="option in field.options track by $index" ng-value="option.id">{{option.field}}</md-option></md-select>\n</md-input-container></div><div ng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" \nlayout="row" flex><md-input-container flex class="item mv-0" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'picture\'"><div class="md-block"><div><div ngf-drop ngf-select \nng-model="vm.files" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="image/*" ngf-pattern="\'image/*\'"><div layout="column"><div flex translate="GLOBAL.DROP_HERE">\nDrop here or click to upload</div><div flex translate="GLOBAL.OR"></div><div flex><md-button \nclass="send-button md-accent md-raised" aria-label="Select files" translate="GLOBAL.SELECT_FILES"></md-button></div>\n</div></div><div ngf-no-file-drop translate="GLOBAL.FILE_DRAG_DROP"></div></div><div ng-repeat="f in vm.files" \nclass="ms-card" flex><div ng-if="!f.url" class="ms-card-content-wrapper"><div class="template-9"><div class="media" \nflex layout="row" layout-align="center center"><img ngf-thumbnail="!f.$error && f" class="image"></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><strong class="mr-5" ng-if="f.id">#{{f.id}}</strong> <span class="grey-500-fg"><span \nng-if="f.name">{{f.name}}</span></span></div></div></div><md-progress-linear md-mode="determinate" \nvalue="{{f.progress}}" ng-show="f.progress <100"></md-progress-linear></div></div><div ng-if="f.url" \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><img class="image" ng-src="{{vm.storagePrefix + f.url}}"></div><div class="header p-16" \nflex layout="row" layout-align="end center"><md-menu class="float-right"><md-button class="md-icon-button" \naria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item><md-button translate="GLOBAL.REMOVE" ng-click="vm.deleteAvatar(f)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item></md-menu-content>\n</md-menu></div><md-progress-linear md-mode="determinate" value="{{f.progress}}" ng-show="f.progress <100">\n</md-progress-linear></div></div></div></div></md-input-container></div><div \nng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" fill-width class="navigation pb-20" flex \nlayout="row" layout-align="center center"><md-button ng-if="vm.showJobDivision()" translate="GLOBAL.BACK" \nclass="md-raised md-warn" ng-click="vm.unSelectJobDivision()"></md-button><md-button ng-disabled="vm.isSendDisabled()" \ntranslate="GLOBAL.SEND" class="md-raised md-accent" ng-click="vm.sendForm($event)" ng-disabled="wizardStep1.$valid">\n</md-button></div><div class="text-center" ng-if="vm.user_type != undefined && vm.user_type != 4 && vm.user_type != 5">\n<h3>{{ \'CLIENTS.EDIT_USER_SECTION_USERS\' | translate}}</h3></div></form></div>');
$templateCache.put('app/main/apps/proyects/dialogs/forms/forms-view-delegation.html','<div id="forms" class="form-delegation page-layout simple fullwidth doc-page forms" layout="column"><div class="p0" \nlayout="column"><div layout="row"><ms-form-wizard class="popup" flex><form name="wizardStep1" class="md-inline-form" \nms-form-wizard-form novalidate><div class="items mt-30"><md-input-container class="item" \nng-repeat="field in vm.fields" ng-if="field.field !== \'id\' && field.field !== \'fullName\'"><input \nng-if="field.field !== \'phone\' && field.field !== \'email\' && field.field !== \'position\'" type="{{field.type}}" \nname="{{field.field}}" ng-model="field.value" placeholder="{{ field.translate | translate }}" required> <input \nng-if="field.field === \'phone\' || field.field === \'email\'" type="{{field.type}}" name="{{field.field}}" \nng-model="field.value" placeholder="{{ field.translate | translate }}"><div ng-messages="wizardStep1.email.$error" \nrole="alert" multiple="multiple"><div ng-message="pattern"><span translate="GLOBAL.EMAIL_VALID"></span></div></div>\n</md-input-container></div></form><div class="navigation pt-20" flex layout="row" layout-align="center center">\n<md-button translate="GLOBAL.SEND" class="md-raised md-warn" ng-click="vm.sendForm()" ng-disabled="wizardStep1.$valid">\n</md-button></div></ms-form-wizard></div></div></div>');
$templateCache.put('app/main/apps/proyects/dialogs/forms/forms-view-user.html','<div id="forms-position" class="page-layout simple fullwidth doc-page forms scrollable" layout="column" ms-scroll \nng-if="vm.showSelectPosition()"><form name="wizardStep2" class="md-inline-form" ms-form-wizard-form novalidate><h3 \nclass="mh-15" translate="CLIENTS.BEFORE_CONTINUE_PERSONEL"></h3><div class="items ph-15" layout="row">\n<md-input-container flex class="item" ng-if="vm.indexDivision != null" ng-show="vm.showSector()"><md-select \nng-model="vm.fields[vm.indexDivision].value" placeholder="{{ vm.fields[vm.indexDivision].translate | translate }}" \nrequired><md-option ng-repeat="option in vm.fields[vm.indexDivision].options track by $index" ng-value="option.id">\n{{option.field}}</md-option></md-select></md-input-container><md-input-container flex class="item" \nng-if="vm.indexPosition != null"><md-select ng-disabled="vm.disabledPosition(vm.fields[vm.indexPosition])" \nng-model="vm.fields[vm.indexPosition].value" placeholder="{{ vm.fields[vm.indexPosition].translate | translate }}" \nrequired><md-option ng-repeat="option in vm.fields[vm.indexPosition].options track by $index" ng-value="option.id">\n{{option.field}}</md-option></md-select></md-input-container></div></form><div class="navigation pt-20" flex \nlayout="row" layout-align="center center"><md-button translate="GLOBAL.SELECT" class="md-raised md-accent" \nng-click="vm.selectJobDivision()" ng-disabled="vm.divisionJobSelected()"></md-button></div></div><md-tabs \nfill-height-i md-border-bottom ng-if="!vm.showSelectPosition()"><md-tab label="{{\'CLIENTS.NEW_USER\' | translate}}"><div\n ng-include="\'app/main/apps/clients/dialogs/forms/new-user.html\'"></div></md-tab><md-tab \nlabel="{{\'CLIENTS.EXISTING_USER\' | translate}}"><div \nng-style="{\'height\': vm.showJobDivision() ? \'calc(100% - 58px)\' : \'100%\'}" \nng-include="\'app/main/apps/clients/dialogs/forms/existing-user.html\'"></div><div ng-if="vm.showJobDivision()" \nclass="navigation pt-10" flex layout="row" layout-align="center center"><md-button translate="GLOBAL.BACK" \nclass="md-raised md-warn" ng-click="vm.unSelectJobDivision()"></md-button></div></md-tab><md-tab \nlabel="{{\'CLIENTS.COMPANY_OR_EXTERNAL_STAFF\' | translate}}"><div \nng-include="\'app/main/apps/clients/dialogs/forms/external-user.html\'"></div></md-tab></md-tabs>');
$templateCache.put('app/main/apps/proyects/dialogs/forms/new-user.html','<div id="forms" class="page-layout simple fullwidth doc-page forms scrollable" layout="column" ms-scroll><form \nname="wizardStep1" class="md-inline-form" ms-form-wizard-form novalidate><div layout="row" \nng-if="!vm.showJobDivision() && !(vm.user_type != undefined && vm.user_type != 4 && vm.user_type != 5)  && !vm.type">\n<md-input-container flex class="item mh-15" ng-if="vm.indexDivision != null" ng-show="vm.showSector()"><md-select \nng-disabled="true" ng-model="vm.fields[vm.indexDivision].value" \nplaceholder="{{ vm.fields[vm.indexDivision].translate | translate }}" required><md-option \nng-repeat="option in vm.fields[vm.indexDivision].options track by $index" ng-value="option.id">{{option.field}}\n</md-option></md-select></md-input-container><md-input-container flex class="item mh-15" \nng-if="vm.indexPosition != null"><md-select ng-disabled="true" ng-model="vm.fields[vm.indexPosition].value" \nplaceholder="{{ vm.fields[vm.indexPosition].translate | translate }}" required><md-option \nng-repeat="option in vm.fields[vm.indexPosition].options track by $index" ng-value="option.id">{{option.field}}\n</md-option></md-select></md-input-container></div><div \nng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" style="height: auto!important;" \nclass="items mt-10"><md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'text\' && field.field != \'3rd_party_company_name\'"><input type="{{field.type}}" \nng-model="field.value" placeholder="{{ field.translate | translate }}" ng-required="field.required">\n</md-input-container><md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'password\'"><input type="{{field.type}}" ng-model="field.value" \nplaceholder="{{ field.translate | translate }}" ng-required="field.required"></md-input-container><md-input-container \nclass="item" ng-repeat="field in vm.fields" ng-if="!field.hidden && field.type == \'selector\'"><md-select \nng-disabled="vm.disabledPosition(field)" ng-if="field.field === \'position\'" ng-model="field.value" \nplaceholder="{{ field.translate | translate }}" required><md-option \nng-repeat="option in field.options track by $index" ng-value="option.id">{{option.field}}</md-option></md-select>\n</md-input-container></div><div ng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" \nlayout="row" flex><md-input-container flex class="item mv-0" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'picture\'"><div class="md-block"><div><div ngf-drop ngf-select \nng-model="vm.files" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="image/*" ngf-pattern="\'image/*\'"><div layout="column"><div flex translate="GLOBAL.DROP_HERE">\nDrop here or click to upload</div><div flex translate="GLOBAL.OR"></div><div flex><md-button \nclass="send-button md-accent md-raised" aria-label="Select files" translate="GLOBAL.SELECT_FILES"></md-button></div>\n</div></div><div ngf-no-file-drop translate="GLOBAL.FILE_DRAG_DROP"></div></div><div ng-repeat="f in vm.files" \nclass="ms-card" flex><div ng-if="!f.url" class="ms-card-content-wrapper"><div class="template-9"><div class="media" \nflex layout="row" layout-align="center center"><img ngf-thumbnail="!f.$error && f" class="image"></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><strong class="mr-5" ng-if="f.id">#{{f.id}}</strong> <span class="grey-500-fg"><span \nng-if="f.name">{{f.name}}</span></span></div></div></div><md-progress-linear md-mode="determinate" \nvalue="{{f.progress}}" ng-show="f.progress <100"></md-progress-linear></div></div><div ng-if="f.url" \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><img class="image" ng-src="{{vm.storagePrefix + f.url}}"></div><div class="header p-16" \nflex layout="row" layout-align="end center"><md-menu class="float-right"><md-button class="md-icon-button" \naria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.deleteAvatar(f)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-content></md-menu></div>\n<md-progress-linear md-mode="determinate" value="{{f.progress}}" ng-show="f.progress <100"></md-progress-linear></div>\n</div></div></div></md-input-container></div><div \nng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" fill-width class="navigation pb-20" flex \nlayout="row" layout-align="center center"><md-button ng-if="vm.showJobDivision()" translate="GLOBAL.BACK" \nclass="md-raised md-warn" ng-click="vm.unSelectJobDivision()"></md-button><md-button ng-disabled="vm.isSendDisabled()" \ntranslate="GLOBAL.SEND" class="md-raised md-accent" ng-click="vm.sendForm($event)" ng-disabled="wizardStep1.$valid">\n</md-button></div><div class="text-center" ng-if="vm.user_type != undefined && vm.user_type != 4 && vm.user_type != 5">\n<h3 ng-bind-html="vm.translate(\'CLIENTS.EDIT_USER_SECTION_USERS\')"></h3></div></form></div>');
$templateCache.put('app/main/apps/proyects/dialogs/image/image-dialog.html','<md-dialog class="attachment-dialog" aria-label="New Task"><md-toolbar class="md-accent md-hue-2 md-default-theme"><div\n class="md-toolbar-tools"><div layout="row" hide show-gt-xs><a class="md-button" type="1" layout="row" \nlayout-align="center center" ng-click="vm.changeView(\'fotorama\')"><md-icon md-font-icon="icon-file-image-box" \nclass="s18 mr-5 ml-0"></md-icon><span translate="GLOBAL.PREVIEW">Preview Media</span></a></div><span flex></span><div \nlayout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content class="mediadialog-content" layout-fill><md-content flex class="content-card" \nng-class="vm.currentView" ng-include="vm.views[vm.currentView]" md-no-ink></md-content></md-dialog-content></md-dialog>');
$templateCache.put('app/main/apps/proyects/dialogs/media/media-clients-tinymce.html','<md-dialog class="attachment-dialog add-media" aria-label="New Message"><form class="md-inline-form"><md-toolbar \nclass="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><div layout="row" \nhide show-gt-xs><a class="md-button" type="1" layout="row" layout-align="center center" \nng-click="vm.changeViewTiny(\'1\')"><md-icon md-font-icon="icon-file-image-box" class="s18 mr-5 ml-0"></md-icon><span>\nAttached Media</span></a></div><div layout="row" hide-gt-xs show-xs><md-menu><md-button aria-label="Filters" \nng-click="$mdMenu.open($event)" translate="" translate-attr-aria-label="GLOBAL.FILTERS"><span layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-file-image-box" class="s18 mr-5 ml-0"></md-icon><span \nclass="ml-5">Images</span> <i class="icon-chevron-down s20 ml-5"></i></span></md-button><md-menu-content width="3">\n<md-menu-item><md-button type="photos" ng-click="vm.changeViewTiny(\'1\')"><div layout="row" \nlayout-align="space-between center"><div><md-icon md-font-icon="icon-file-image-box" class="s18"></md-icon><span>Images\n</span></div><i class="icon-check s16" ng-if="sortfield.titleId == sortable.titleId"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu></div><div layout="row"><md-button class="md-icon-button" \nng-click="vm.closeDialog()" aria-label="Close dialog" tranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon \nmd-font-icon="icon-close"></md-icon></md-button></div></div></md-toolbar><div flex \nng-include="\'app/main/apps/clients/dialogs/media/views/templates/toolbar-search.html\'"></div><md-dialog-content \nclass="mediadialog-content scrollable" layout-fill ms-scroll><treasure-overlay-spinner active="vm.loading"><div \nlayout="column" flex><md-content flex class="content-card" ng-class="vm.currentViewTiny" \nng-include="vm.viewsTiny[vm.currentViewTiny]" md-no-ink></md-content></div></treasure-overlay-spinner>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="space-between center" ng-if="!vm.loading"><div \nlayout="row" layout-align="start center"></div><div layout="row" layout-align="end right"><md-button \nng-click="vm.attachMediaTiny()" class="send-button md-accent md-raised" aria-label="Send" translate="GLOBAL.ADD_FILE" \ntranslate-attr-aria-label="GLOBAL.ADD_FILE">ADD</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/proyects/dialogs/media/media-clients.html','<md-dialog class="attachment-dialog add-media" aria-label="New Message"><form class="md-inline-form"><md-toolbar \nclass="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><div layout="row" \nhide show-gt-xs><a class="md-button" type="upload" layout="row" layout-align="center center" \nng-click="vm.changeView(\'upload\')"><md-icon md-font-icon="icon-import" class="s18 mr-5 ml-0"></md-icon><span \ntranslate="GLOBAL.UPLOAD"></span></a></div><div layout="row" hide-gt-xs show-xs><md-menu><md-button \naria-label="Filters" ng-click="$mdMenu.open($event)" translate="" translate-attr-aria-label="GLOBAL.FILTERS"><span \nlayout="row" layout-align="start center"><md-icon md-font-icon="icon-file-image-box" class="s18 mr-5 ml-0"></md-icon>\n<span class="ml-5" ng-if="vm.currentView===\'upload\'">Upload</span><i class="icon-chevron-down s20 ml-5"></i></span>\n</md-button><md-menu-content width="3"><md-menu-item><md-button type="import" ng-click="vm.changeView(\'import\')"><div \nlayout="row" layout-align="space-between center"><div><md-icon md-font-icon="icon-import" class="s18"></md-icon><span>\nUpload</span></div><i class="icon-check s16" ng-if="vm.currentView===\'upload\'"></i></div></md-button></md-menu-item>\n</md-menu-content></md-menu></div><div layout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog" tranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></div></md-toolbar><md-dialog-content ms-scroll flex class="content-card" \nng-class="vm.currentView" ng-include="vm.views[vm.currentView]"></md-dialog-content></form></md-dialog>');
$templateCache.put('app/main/apps/proyects/dialogs/new-proyect-dialog/edit-viewItem.html','<div class="form-wrapper md-whiteframe-1dp without-line" ng-if="vm.edit"><form name="stakeForm" class="md-inline-form" \nnovalidate><div layout="column" class="edit_stake"><md-input-container flex><label translate="ITEM.ITEM_NAME"></label> \n<input type="text" ng-model="vm.itemE.name" required></md-input-container><md-input-container flex><label \ntranslate="ITEM.DESCRIPTION"></label> <input type="text" ng-model="vm.itemE.description_item" required>\n</md-input-container></div><div layout="row" class="edit_stake"><md-input-container flex><label translate="ITEM.VALUE">\n</label> <input type="number" string-to-number ng-model="vm.itemE.value" ng-change="vm.cambio=true" required>\n</md-input-container><span>&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp</span> <span \nng-repeat="state in vm.tipefield" ng-if="state.number == vm.itemE.type">{{state.name}}</span></div></form><div \nclass="content thread-detail" layout="row" layout-align="center center" flex ng-if="!vm.edit"><div \nclass="no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-clipboard-account" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="STAKE.SELECT_TASK"></span></div></div></div>');
$templateCache.put('app/main/apps/proyects/dialogs/new-proyect-dialog/new-proyect-dialog.html','<md-dialog class="new-proyect-dialog" aria-label="New Task"><form name="taskForm" class="md-inline-form" novalidate>\n<md-toolbar><div class="md-toolbar-tools" layout="row" layout-align="start center"><md-button aria-label="Preview" \nclass="md-icon-buttonI md-raised" translate="CLIENTS.PROYECT_DATA" ng-if="vm.itemActive == \'1\'" \nng-click="vm.itemActive = \'1\'" type="button" translate-attr-aria-label="CLIENTS.PROYECT_DATA"></md-button><md-button \naria-label="Preview" class="md-icon-buttonIO" translate="CLIENTS.PROYECT_DATA" ng-if="vm.itemActive != \'1\'" \nng-click="vm.itemActive = \'1\'" type="button" translate-attr-aria-label="CLIENTS.PROYECT_DATA" md-buttom></md-button>\n<md-button aria-label="Preview" class="md-icon-buttonI" id="accountIcon" translate="CLIENTS.ALL" \nng-if="vm.itemActive == \'4\'" ng-click="vm.itemActive = \'4\'" type="button" translate-attr-aria-label="CLIENTS.ALL" \nclass="md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme"></md-button><md-button \naria-label="Preview" class="md-icon-buttonIO" id="accountIcon" translate="CLIENTS.ALL" ng-if="vm.itemActive != \'4\'" \nng-click="vm.itemActive = \'4\'" type="button" translate-attr-aria-label="CLIENTS.ALL" \nclass="md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme"></md-button><md-button \naria-label="Preview" class="md-icon-buttonI" id="accountIcon" translate="CLIENTS.INPUTS" ng-if="vm.itemActive == \'2\'" \nng-click="vm.itemActive = \'2\'" type="button" translate-attr-aria-label="CLIENTS.INPUTS" \nclass="md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme"></md-button><md-button \naria-label="Preview" class="md-icon-buttonIO" id="accountIcon" translate="CLIENTS.INPUTS" ng-if="vm.itemActive != \'2\'" \nng-click="vm.itemActive = \'2\'" type="button" translate-attr-aria-label="CLIENTS.INPUTS" \nclass="md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme"></md-button><md-button \naria-label="Preview" class="md-icon-buttonI" id="accountIcon" translate="CLIENTS.OUTPUTS" ng-if="vm.itemActive == \'3\'" \nng-click="vm.itemActive = \'3\'" type="button" translate-attr-aria-label="ITEM.INDICATOR"></md-button><md-button \naria-label="Preview" class="md-icon-buttonIO" id="accountIcon" translate="CLIENTS.OUTPUTS" \nng-if="vm.itemActive != \'3\'" ng-click="vm.itemActive = \'3\'" type="button" translate-attr-aria-label="ITEM.INDICATOR">\n</md-button><md-button class="md-icon-button close-icon-container" ng-click="vm.closeDialog()"><md-icon \nmd-font-icon="icon-close" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass="p-25" ms-scroll ng-if="vm.itemActive == \'1\'"><div layout="column" layout-gt-xs="row"><md-input-container flex>\n<label translate="CLIENTS.PROYECT_NAME"></label> <input type="text" ng-model="vm.company.name" required>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="CLIENTS.PROYECT_ENTITY"></label> <input type="text" ng-model="vm.company.entity_name" required>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="CLIENTS.PROYECT_YEAR"></label> <input type="text" ng-model="vm.company.input_year" required>\n</md-input-container><md-input-container flex><label translate="CLIENTS.PROYECT_INTEREST"></label> <input \nng-model="vm.company.type_interest" id="numberInt" type="text" ui-mask="99.99" required></md-input-container>\n<md-input-container flex><label translate="CLIENTS.MONEY"></label><md-select ng-model="vm.company.money_symbol">\n<md-option ng-repeat="typeMo in vm.tipemoney track by $index" ng-value="typeMo"><span>{{typeMo}}</span></md-option>\n</md-select></md-input-container></div></md-dialog-content><md-dialog-content class="p-25"><div \nid="list-content-dataN" ng-style="{\'opacity\' : isLoadingP ? 0.5 : 1}" ng-if="vm.itemActive == \'2\'"><table \nms-responsive-table><thead><tr class="font-size-16"><th><span translate="ITEM.ID">ITEM name</span></th><th><span \ntranslate="ITEM.ITEM_NAME">ITEM name</span></th><th><span translate="ITEM.DESCRIPTION">description</span></th><th><span\n translate="ITEM.VALUE">value</span></th><th><span translate="ITEM.TYPE">type</span></th><th><md-button \naria-label="Edit" class="md-icon-buttonIO" id="accountIcon" translate="GLOBAL.EDIT" \nng-if="vm.itemActive == \'2\' && !vm.edit" translate-attr-aria-label="STAFF.EDIT" \nng-click="vm.openCompany(company, $event)" \nng-class="{\'tab-selected\': vm.tabActive==\'preview\' || vm.tabActive==\'editnew\' || vm.tabActive==\'edit\'}"></md-button>\n<md-button aria-label="Preview" class="md-icon-buttonIO" translate="GLOBAL.SAVE" \nng-if="vm.itemActive == \'2\' && vm.edit" ng-click="vm.edit = false" type="button" \ntranslate-attr-aria-label="CLIENTS.PROYECT_DATA" md-buttom></md-button></th><th></th><th></th></tr></thead><tbody><tr \nng-repeat="company in vm.inputTotal | filter:{ fieldEdit: 1 } track by $index" md-no-ink \nng-click="vm.openCompany(company, $event)" \nng-class="{\'starred\': company.starred, \'selected\': vm.selectedContentID !== client.id_mailing_content, \'checked\': vm.isChecked(company)}">\n<td><span>{{company.id_item}}</span></td><td><span>{{company.fieldName}}</span></td><td><span \nng-repeat="item1 in vm.item" ng-if="item1.id == company.id_item">{{item1.description_item}}</span></td><td><span \nng-show="vm.itemActive == \'2\' && !vm.edit">{{company.data | currency: "": 2 }}</span><md-input-container flex \nng-if="vm.itemActive == \'2\' && vm.edit" class="edit-io" ng-mouseleave="vm.changeValue(company)"><input type="number" \nstring-to-number ng-model="company.data" ng-change="vm.cambio=true" required></md-input-container></td><td><span \nng-repeat="state in vm.tipefield" ng-if="state.number == company.fieldType">{{state.name}}</span></td><td></td><td>\n</td></tr></tbody></table><div class="content-wrapper" layout="row" flex ng-if="!vm.inputTotal"><div \nclass="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><span \nclass="hint-text" translate="ITEM.ADD_FIELDS"></span></div></div></div></div><div id="list-content-dataN" \nng-style="{\'opacity\' : isLoadingP ? 0.5 : 1}" ng-if="vm.itemActive == \'3\'"><table ms-responsive-table><thead><tr \nclass="font-size-16"><th><span translate="ITEM.ID">ITEM name</span></th><th><span translate="ITEM.ITEM_NAME">ITEM name\n</span></th><th><span translate="ITEM.DESCRIPTION">description</span></th><th><span translate="ITEM.VALUE">value</span>\n</th><th><span translate="ITEM.TYPE">type</span></th><th><md-button aria-label="Edit" class="md-icon-buttonIO" \nid="accountIcon" translate="GLOBAL.EDIT" ng-if="vm.itemActive == \'3\' && !vm.edit" \ntranslate-attr-aria-label="STAFF.EDIT" ng-click="vm.openCompany(company, $event)" \nng-class="{\'tab-selected\': vm.tabActive==\'preview\' || vm.tabActive==\'editnew\' || vm.tabActive==\'edit\'}"></md-button>\n<md-button aria-label="Preview" class="md-icon-buttonIO" translate="GLOBAL.SAVE" \nng-if="vm.itemActive == \'3\' && vm.edit" ng-click="vm.edit = false" type="button" \ntranslate-attr-aria-label="CLIENTS.PROYECT_DATA" md-buttom></md-button></th><th></th><th></th></tr></thead><tbody><tr \nng-repeat="company in vm.outcomesTotal | filter:{ fieldEdit: 1 } track by $index" md-no-ink \nng-click="vm.openCompany(company, $event)" \nng-class="{\'starred\': company.starred, \'selected\': vm.selectedContentID !== client.id_mailing_content, \'checked\': vm.isChecked(company)}">\n<td><span>{{company.id_item}}</span></td><td><span>{{company.fieldName}}</span></td><td><span \nng-repeat="item1 in vm.item" ng-if="item1.id == company.id_item">{{item1.description_item}}</span></td><td><span \nng-show="vm.itemActive == \'3\' && !vm.edit">{{company.data | currency: "": 2 }}</span><md-input-container flex \nng-if="vm.itemActive == \'3\' && vm.edit" class="edit-io" ng-mouseleave="vm.changeValue(company)"><input type="number" \nstring-to-number ng-model="company.data" ng-change="vm.cambio=true" required></md-input-container></td><td><span \nng-repeat="state in vm.tipefield" ng-if="state.number == company.fieldType">{{state.name}}</span></td><td></td><td>\n</td><td></td></tr></tbody></table><div class="content-wrapper" layout="row" flex ng-if="vm.outcomesTotal == []"><div \nclass="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><span \nclass="hint-text" translate="ITEM.ADD_FIELDS"></span></div></div></div></div><div id="list-content-dataN" \nng-style="{\'opacity\' : isLoadingP ? 0.5 : 1}" ng-if="vm.itemActive == \'4\'"><table ms-responsive-table><thead><tr \nclass="font-size-16"><th><span translate="ITEM.ID">ITEM name</span></th><th><span translate="ITEM.ITEM_NAME">ITEM name\n</span></th><th><span translate="ITEM.DESCRIPTION">description</span></th><th><span translate="ITEM.VALUE">value</span>\n</th><th><span translate="ITEM.TYPE">type</span></th><th><md-button aria-label="Edit" class="md-icon-buttonIO" \nid="accountIcon" translate="GLOBAL.EDIT" ng-if="vm.itemActive == \'4\' && !vm.edit" \ntranslate-attr-aria-label="STAFF.EDIT" ng-click="vm.openCompany(company, $event)" \nng-class="{\'tab-selected\': vm.tabActive==\'preview\' || vm.tabActive==\'editnew\' || vm.tabActive==\'edit\'}"></md-button>\n<md-button aria-label="Preview" class="md-icon-buttonIO" translate="GLOBAL.SAVE" \nng-if="vm.itemActive == \'4\' && vm.edit" ng-click="vm.edit = false" type="button" \ntranslate-attr-aria-label="CLIENTS.PROYECT_DATA" md-buttom></md-button></th><th></th><th></th></tr></thead><tbody><tr \nng-repeat="company in vm.inputTotal | filter:{ fieldEdit: 1 } track by $index" md-no-ink \nng-click="vm.openCompany(company, $event)" \nng-class="{\'starred\': company.starred, \'selected\': vm.selectedContentID !== client.id_mailing_content, \'checked\': vm.isChecked(company)}">\n<td><span>{{company.id_item}}</span></td><td><span>{{company.fieldName}}</span></td><td><span \nng-repeat="item1 in vm.item" ng-if="item1.id == company.id_item">{{item1.description_item}}</span></td><td><span \nng-show="vm.itemActive == \'4\' && !vm.edit">{{company.data | currency: "": 2 }}</span><md-input-container flex \nng-if="vm.itemActive == \'4\' && vm.edit" class="edit-io" ng-mouseleave="vm.changeValue(company)"><input type="number" \nstring-to-number ng-model="company.data" ng-change="vm.cambio=true" required></md-input-container></td><td><span \nng-repeat="state in vm.tipefield" ng-if="state.number == company.fieldType">{{state.name}}</span></td><td></td><td>\n</td><td></td></tr></tbody><tbody><tr \nng-repeat="company in vm.outcomesTotal | filter:{ fieldEdit: 1 } track by $index" md-no-ink \nng-click="vm.openCompany(company, $event)" \nng-class="{\'starred\': company.starred, \'selected\': vm.selectedContentID !== client.id_mailing_content, \'checked\': vm.isChecked(company)}">\n<td><span>{{company.id_item}}</span></td><td><span>{{company.fieldName}}</span></td><td><span \nng-repeat="item1 in vm.item" ng-if="item1.id == company.id_item">{{item1.description_item}}</span></td><td><span \nng-show="vm.itemActive == \'4\' && !vm.edit">{{company.data | currency: "": 2 }}</span><md-input-container flex \nng-if="vm.itemActive == \'4\' && vm.edit" class="edit-io" ng-mouseleave="vm.changeValue(company)"><input type="number" \nstring-to-number ng-model="company.data" ng-change="vm.cambio=true" required></md-input-container></td><td><span \nng-repeat="state in vm.tipefield" ng-if="state.number == company.fieldType">{{state.name}}</span></td><td></td><td>\n</td><td></td></tr></tbody></table><div class="content-wrapper" layout="row" flex ng-if="vm.outcomesTotal == []"><div \nclass="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><span \nclass="hint-text" translate="ITEM.ADD_FIELDS"></span></div></div></div></div></md-dialog-content><div class="center" \nlayout="column" flex ng-if="vm.itemActive == \'1\'"><md-dialog-actions class="footer" layout="row" layout-="end">\n<md-input-container flex layout="row" layout-align="end center" ng-if="!vm.edit"><md-button type="button" \nclass="md-raised md-warn" ng-click="vm.closeDialog()" translate="RISKCONFIG.CANCEL">Cancel</md-button><md-button \nng-disabled="!vm.company.name || !vm.company.entity_name || !vm.company.input_year || !vm.company.type_interest || vm.edit" \ntype="submit" class="send-button md-accent md-raised" ng-click="vm.saveDialog()" translate="GLOBAL.SAVE">ADD\n</md-button></md-input-container></md-dialog-actions></div></form></md-dialog>');
$templateCache.put('app/main/apps/mail/views/classic/classic-view.html','<div class="toolbar" layout="row" layout-align="space-between center"><div layout="row" layout-align="start center">\n<md-checkbox class="no-label" aria-label="{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}" \nng-checked="vm.selectedThreads.length > 0" ng-click="vm.toggleSelectThreads()" ng-if="!vm.currentThread"></md-checkbox>\n<md-menu class="select-menu" ng-if="!vm.currentThread"><md-button class="md-icon-button" \nng-click="$mdMenu.open($event)" aria-label="Filters" translate translate-attr-aria-label="MAIL.FILTERS"><md-icon \nmd-font-icon="icon-menu-down"></md-icon></md-button><md-menu-content width="3"><md-menu-item><md-button \nng-click="vm.selectThreads()" aria-label="All" translate="MAIL.ALL" translate-attr-aria-label="MAIL.ALL">All\n</md-button></md-menu-item><md-menu-item><md-button ng-click="vm.deselectThreads()" aria-label="None" \ntranslate="MAIL.NONE" translate-attr-aria-label="MAIL.NONE">None</md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.selectThreads(\'read\', true)" aria-label="Read" translate="MAIL.READ" \ntranslate-attr-aria-label="MAIL.READ">Read</md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.selectThreads(\'read\', false)" aria-label="Unread" translate="MAIL.UNREAD" \ntranslate-attr-aria-label="MAIL.UNREAD">Unread</md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.selectThreads(\'important\', true)" aria-label="Important" translate="MAIL.IMPORTANT" \ntranslate-attr-aria-label="MAIL.IMPORTANT">Important</md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.selectThreads(\'important\', false)" aria-label="Not Important" translate="MAIL.NOT_IMPORTANT" \ntranslate-attr-aria-label="MAIL.NOT_IMPORTANT">Not Important</md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.selectThreads(\'starred\', true)" aria-label="Starred" translate="MAIL.STARRED" \ntranslate-attr-aria-label="MAIL.STARRED">Starred</md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.selectThreads(\'starred\', false)" aria-label="Unstarred" translate="MAIL.UNSTARRED" \ntranslate-attr-aria-label="MAIL.UNSTARRED">Unstarred</md-button></md-menu-item></md-menu-content></md-menu><md-button \nclass="md-icon-button close-thread" aria-label="Back" ng-click="vm.closeThread()" ng-if="vm.currentThread" translate \ntranslate-attr-aria-label="MAIL.BACK"><md-icon md-font-icon="icon-keyboard-backspace"></md-icon></md-button><div \nclass="action-buttons" layout="row" layout-align="start center" \nng-show="vm.selectedThreads.length > 0 || vm.currentThread" hide show-gt-xs><div class="divider-vertical"></div>\n<md-button class="md-icon-button" aria-label="Archive" translate translate-attr-aria-label="MAIL.ARCHIVE"><md-icon \nmd-font-icon="icon-archive"></md-icon><md-tooltip><span translate="MAIL.ARCHIVE">Archive</span></md-tooltip>\n</md-button><md-button class="md-icon-button" aria-label="Spam" translate translate-attr-aria-label="MAIL.SPAM">\n<md-icon md-font-icon="icon-alert-octagon"></md-icon><md-tooltip><span translate="MAIL.SPAM">Spam</span></md-tooltip>\n</md-button><md-button class="md-icon-button" aria-label="Delete" translate translate-attr-aria-label="MAIL.DELETE">\n<md-icon md-font-icon="icon-delete"></md-icon><md-tooltip><span translate="MAIL.DELETE">Delete</span></md-tooltip>\n</md-button><div class="divider-vertical"></div><md-button class="md-icon-button" aria-label="Move to" translate \ntranslate-attr-aria-label="MAIL.MOVE_TO"><md-icon md-font-icon="icon-folder"></md-icon><md-tooltip><span \ntranslate="MAIL.MOVE_TO">Move to</span></md-tooltip></md-button><md-menu><md-button class="md-icon-button" \naria-label="Labels" translate translate-attr-aria-label="MAIL.LABELS" ng-click="$mdMenu.open($event)"><md-icon \nmd-font-icon="icon-label"></md-icon><md-tooltip><span translate="MAIL.LABELS">Labels</span></md-tooltip></md-button>\n<md-menu-content class="thread-labels-toggle-list" width="3"><md-list><md-subheader class="md-no-sticky"><span \ntranslate="MAIL.LABELS">Labels</span></md-subheader><md-list-item ng-repeat="label in vm.labels" \nng-click="vm.toggleLabel(label)"><div layout="row" layout-align="start center"><div class="w-10 h-10 mr-16" \nng-class="label.color"></div><div>{{label.title}}</div></div><md-icon md-font-icon="icon-checkbox-blank-outline" \nclass="md-secondary" ng-if="vm.currentThread && !vm.isLabelExist(label)"></md-icon><md-icon \nmd-font-icon="icon-checkbox-marked" class="md-accent md-secondary" ng-if="vm.currentThread && vm.isLabelExist(label)">\n</md-icon></md-list-item></md-list></md-menu-content></md-menu><div class="divider-vertical"></div><md-menu><md-button \nclass="md-icon-button" ng-click="$mdMenu.open($event)" aria-label="MAIL.MORE" translate \ntranslate-attr-aria-label="MAIL.MORE"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content\n width="3"><md-menu-item><md-button ng-click="vm.setThreadStatus(\'read\', true)"><span translate="MAIL.MARK_AS_READ">\nMark as read</span></md-button></md-menu-item><md-menu-item><md-button ng-click="vm.setThreadStatus(\'read\', false)">\n<span translate="MAIL.MARK_AS_UNREAD">Mark as unread</span></md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.setThreadStatus(\'important\', true)"><span translate="MAIL.MARK_AS_IMPORTANT">Mark as important</span>\n</md-button></md-menu-item><md-menu-item><md-button ng-click="vm.setThreadStatus(\'important\', false)"><span \ntranslate="MAIL.MARK_AS_NOT_IMPORTANT">Mark as not important</span></md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.setThreadStatus(\'starred\', true)"><span translate="MAIL.ADD_STAR">Add star</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click="vm.setThreadStatus(\'starred\', false)"><span \ntranslate="MAIL.REMOVE_STAR">Remove star</span></md-button></md-menu-item></md-menu-content></md-menu></div><md-menu \nclass="actions-menu" ng-show="vm.selectedThreads.length > 0 || vm.currentThread" hide-gt-xs><md-button \nclass="md-icon-button" ng-click="$mdMenu.open($event)" aria-label="Mail Actions" translate \ntranslate-attr-aria-label="MAIL.ACTIONS"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button>\n<md-menu-content width="3"><md-menu-item><md-button aria-label="Archive" translate-attr-aria-label="MAIL.ARCHIVE">\n<md-icon md-font-icon="icon-archive"></md-icon><span translate="MAIL.ARCHIVE">Archive</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label="Spam" translate-attr-aria-label="MAIL.SPAM"><md-icon \nmd-font-icon="icon-alert-octagon"></md-icon><span translate="MAIL.SPAM">Spam</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label="Delete" translate-aria-label="MAIL.DELETE"><md-icon md-font-icon="icon-delete">\n</md-icon><span translate="MAIL.DELETE">Delete</span></md-button></md-menu-item><md-menu-item><md-button \naria-label="Move To" translate-attr-aria-label="MAIL.MOVE_TO"><md-icon md-font-icon="icon-folder-move"></md-icon><span \ntranslate="MAIL.MOVE_TO">Move To</span></md-button></md-menu-item><md-menu-item><md-button aria-label="Labels" \ntranslate-attr-aria-label="MAIL.LABELS"><md-icon md-font-icon="icon-label"></md-icon><span translate="MAIL.LABELS">\nLabels</span></md-button></md-menu-item></md-menu-content></md-menu></div><div layout="row" \nlayout-align="start center"><span class="page-info" hide-sm>1 - 100 of 980</span><md-button \nclass="md-icon-button arrow" aria-label="Previous" translate translate-attr-aria-label="MAIL.PREVIOUS"><md-icon \nmd-font-icon="icon-chevron-left"></md-icon><md-tooltip><span translate="MAIL.PREVIOUS">Previous</span></md-tooltip>\n</md-button><md-button class="md-icon-button arrow" aria-label="Next" translate translate-attr-aria-label="MAIL.NEXT">\n<md-icon md-font-icon="icon-chevron-right"></md-icon><md-tooltip><span translate="MAIL.NEXT">Next</span></md-tooltip>\n</md-button><md-menu class="settings-menu"><md-button class="md-icon-button" ng-click="$mdMenu.open($event)" \naria-label="Settings" translate translate-attr-aria-label="MAIL.SETTINGS"><md-icon md-font-icon="icon-cog"></md-icon>\n</md-button><md-menu-content width="3"><md-menu-item><md-button ng-click="vm.changeView(\'classic\')"><md-icon \nmd-font-icon="icon-checkbox-blank-outline" ng-if="vm.currentView !== \'classic\'"></md-icon><md-icon \nmd-font-icon="icon-checkbox-marked" class="md-accent" ng-if="vm.currentView === \'classic\'"></md-icon><span \ntranslate="MAIL.CLASSIC_VIEW">Classic View</span></md-button></md-menu-item><md-menu-item hide-xs><md-button \nng-click="vm.changeView(\'outlook\')"><md-icon md-font-icon="icon-checkbox-blank-outline" \nng-if="vm.currentView !== \'outlook\'"></md-icon><md-icon md-font-icon="icon-checkbox-marked" class="md-accent" \nng-if="vm.currentView === \'outlook\'"></md-icon><span translate="MAIL.OUTLOOK_VIEW">Outlook View</span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div><div class="content-wrapper" layout="column" flex><div \nclass="content thread-detail" ng-if="vm.currentThread" \nng-include="\'app/main/apps/mail/views/classic/detail/detail.html\'" ms-scroll flex></div><div \nclass="content thread-list" ng-if="!vm.currentThread" ng-include="\'app/main/apps/mail/views/classic/list/list.html\'" \nms-scroll flex></div></div>');
$templateCache.put('app/main/apps/mail/views/outlook/outlook-view.html','<div class="toolbar" layout="row" layout-align="space-between center"><div layout="row" layout-align="start center">\n<md-checkbox class="no-label" aria-label="{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}" \nng-checked="vm.selectedThreads.length > 0" ng-click="vm.toggleSelectThreads()"></md-checkbox><md-menu \nclass="select-menu" ng-if="!vm.currentThread"><md-button class="md-icon-button" ng-click="$mdMenu.open($event)" \naria-label="Filters" translate translate-attr-aria-label="MAIL.FILTERS"><md-icon md-font-icon="icon-menu-down">\n</md-icon></md-button><md-menu-content width="3"><md-menu-item><md-button ng-click="vm.selectThreads()" \naria-label="All" translate="MAIL.ALL" translate-attr-aria-label="MAIL.ALL">All</md-button></md-menu-item><md-menu-item>\n<md-button ng-click="vm.deselectThreads()" aria-label="None" translate="MAIL.NONE" \ntranslate-attr-aria-label="MAIL.NONE">None</md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.selectThreads(\'read\', true)" aria-label="Read" translate="MAIL.READ" \ntranslate-attr-aria-label="MAIL.READ">Read</md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.selectThreads(\'read\', false)" aria-label="Unread" translate="MAIL.UNREAD" \ntranslate-attr-aria-label="MAIL.UNREAD">Unread</md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.selectThreads(\'important\', true)" aria-label="Important" translate="MAIL.IMPORTANT" \ntranslate-attr-aria-label="MAIL.IMPORTANT">Important</md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.selectThreads(\'important\', false)" aria-label="Not Important" translate="MAIL.NOT_IMPORTANT" \ntranslate-attr-aria-label="MAIL.NOT_IMPORTANT">Not Important</md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.selectThreads(\'starred\', true)" aria-label="Starred" translate="MAIL.STARRED" \ntranslate-attr-aria-label="MAIL.STARRED">Starred</md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.selectThreads(\'starred\', false)" aria-label="Unstarred" translate="MAIL.UNSTARRED" \ntranslate-attr-aria-label="MAIL.UNSTARRED">Unstarred</md-button></md-menu-item></md-menu-content></md-menu><div \nclass="action-buttons" layout="row" layout-align="start center" \nng-show="vm.selectedThreads.length > 0 || vm.currentThread" hide show-gt-xs><div class="divider-vertical"></div>\n<md-button class="md-icon-button" aria-label="Archive" translate translate-attr-aria-label="MAIL.ARCHIVE"><md-icon \nmd-font-icon="icon-archive"></md-icon><md-tooltip><span translate="MAIL.ARCHIVE">Archive</span></md-tooltip>\n</md-button><md-button class="md-icon-button" aria-label="Spam" translate translate-attr-aria-label="MAIL.SPAM">\n<md-icon md-font-icon="icon-alert-octagon"></md-icon><md-tooltip><span translate="MAIL.SPAM">Spam</span></md-tooltip>\n</md-button><md-button class="md-icon-button" aria-label="Delete" translate translate-attr-aria-label="MAIL.DELETE">\n<md-icon md-font-icon="icon-delete"></md-icon><md-tooltip><span translate="MAIL.DELETE">Delete</span></md-tooltip>\n</md-button><div class="divider-vertical"></div><md-button class="md-icon-button" aria-label="Move to" translate \ntranslate-attr-aria-label="MAIL.MOVE_TO"><md-icon md-font-icon="icon-folder"></md-icon><md-tooltip><span \ntranslate="MAIL.MOVE_TO">Move to</span></md-tooltip></md-button><md-menu><md-button class="md-icon-button" \naria-label="Labels" translate translate-attr-aria-label="MAIL.LABELS" ng-click="$mdMenu.open($event)"><md-icon \nmd-font-icon="icon-label"></md-icon><md-tooltip><span translate="MAIL.LABELS">Labels</span></md-tooltip></md-button>\n<md-menu-content class="thread-labels-toggle-list" width="3"><md-list><md-subheader class="md-no-sticky"><span \ntranslate="MAIL.LABELS">Labels</span></md-subheader><md-list-item ng-repeat="label in vm.labels" \nng-click="vm.toggleLabel(label)"><div layout="row" layout-align="start center"><div class="w-10 h-10 mr-16" \nng-class="label.color"></div><div>{{label.title}}</div></div><md-icon md-font-icon="icon-checkbox-blank-outline" \nclass="md-secondary" ng-if="vm.currentThread && !vm.isLabelExist(label)"></md-icon><md-icon \nmd-font-icon="icon-checkbox-marked" class="md-accent md-secondary" ng-if="vm.currentThread && vm.isLabelExist(label)">\n</md-icon></md-list-item></md-list></md-menu-content></md-menu><div class="divider-vertical"></div><md-menu><md-button \nclass="md-icon-button" ng-click="$mdMenu.open($event)" aria-label="MAIL.MORE" translate \ntranslate-attr-aria-label="MAIL.MORE"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content\n width="3"><md-menu-item><md-button ng-click="vm.setThreadStatus(\'read\', true)"><span translate="MAIL.MARK_AS_READ">\nMark as read</span></md-button></md-menu-item><md-menu-item><md-button ng-click="vm.setThreadStatus(\'read\', false)">\n<span translate="MAIL.MARK_AS_UNREAD">Mark as unread</span></md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.setThreadStatus(\'important\', true)"><span translate="MAIL.MARK_AS_IMPORTANT">Mark as important</span>\n</md-button></md-menu-item><md-menu-item><md-button ng-click="vm.setThreadStatus(\'important\', false)"><span \ntranslate="MAIL.MARK_AS_NOT_IMPORTANT">Mark as not important</span></md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.setThreadStatus(\'starred\', true)"><span translate="MAIL.ADD_STAR">Add star</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click="vm.setThreadStatus(\'starred\', false)"><span \ntranslate="MAIL.REMOVE_STAR">Remove star</span></md-button></md-menu-item></md-menu-content></md-menu></div><md-menu \nclass="actions-menu" ng-show="vm.selectedThreads.length > 0 || vm.currentThread" hide-gt-xs><md-button \nclass="md-icon-button" ng-click="$mdMenu.open($event)" aria-label="Mail Actions" translate \ntranslate-attr-aria-label="MAIL.ACTIONS"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button>\n<md-menu-content width="3"><md-menu-item><md-button aria-label="Archive" translate-attr-aria-label="MAIL.ARCHIVE">\n<md-icon md-font-icon="icon-archive"></md-icon><span translate="MAIL.ARCHIVE">Archive</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label="Spam" translate-attr-aria-label="MAIL.SPAM"><md-icon \nmd-font-icon="icon-alert-octagon"></md-icon><span translate="MAIL.SPAM">Spam</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label="Delete" translate-aria-label="MAIL.DELETE"><md-icon md-font-icon="icon-delete">\n</md-icon><span translate="MAIL.DELETE">Delete</span></md-button></md-menu-item><md-menu-item><md-button \naria-label="Move To" translate-attr-aria-label="MAIL.MOVE_TO"><md-icon md-font-icon="icon-folder-move"></md-icon><span \ntranslate="MAIL.MOVE_TO">Move To</span></md-button></md-menu-item><md-menu-item><md-button aria-label="Labels" \ntranslate-attr-aria-label="MAIL.LABELS"><md-icon md-font-icon="icon-label"></md-icon><span translate="MAIL.LABELS">\nLabels</span></md-button></md-menu-item></md-menu-content></md-menu></div><div layout="row" \nlayout-align="start center"><span class="page-info" hide-sm>1 - 100 of 980</span><md-button \nclass="md-icon-button arrow" aria-label="Previous" translate translate-attr-aria-label="MAIL.PREVIOUS"><md-icon \nmd-font-icon="icon-chevron-left"></md-icon><md-tooltip><span translate="MAIL.PREVIOUS">Previous</span></md-tooltip>\n</md-button><md-button class="md-icon-button arrow" aria-label="Next" translate translate-attr-aria-label="MAIL.NEXT">\n<md-icon md-font-icon="icon-chevron-right"></md-icon><md-tooltip><span translate="MAIL.NEXT">Next</span></md-tooltip>\n</md-button><md-menu class="settings-menu"><md-button class="md-icon-button" ng-click="$mdMenu.open($event)" \naria-label="Settings" translate translate-attr-aria-label="MAIL.SETTINGS"><md-icon md-font-icon="icon-cog"></md-icon>\n</md-button><md-menu-content width="3"><md-menu-item><md-button ng-click="vm.changeView(\'classic\')"><md-icon \nmd-font-icon="icon-checkbox-blank-outline" ng-if="vm.currentView !== \'classic\'"></md-icon><md-icon \nmd-font-icon="icon-checkbox-marked" class="md-accent" ng-if="vm.currentView === \'classic\'"></md-icon><span \ntranslate="MAIL.CLASSIC_VIEW">Classic View</span></md-button></md-menu-item><md-menu-item hide-xs><md-button \nng-click="vm.changeView(\'outlook\')"><md-icon md-font-icon="icon-checkbox-blank-outline" \nng-if="vm.currentView !== \'outlook\'"></md-icon><md-icon md-font-icon="icon-checkbox-marked" class="md-accent" \nng-if="vm.currentView === \'outlook\'"></md-icon><span translate="MAIL.OUTLOOK_VIEW">Outlook View</span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div><div class="content-wrapper" layout="row" flex><div \nclass="content thread-list" ng-include="\'app/main/apps/mail/views/outlook/list/list.html\'" ms-scroll flex="50"></div>\n<div class="content thread-detail" ng-include="\'app/main/apps/mail/views/outlook/detail/detail.html\'" ms-scroll \nlayout="column" flex="50"></div></div>');
$templateCache.put('app/main/apps/proyects/views/list/list-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="isLoadingP" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="no-threads" ng-if="!vm.companies" ng-hide="isLoading" translate="GLOBAL.NO_ITEMS"></div><div \nid="list-content-data" ng-if="!isLoadingP" ng-style="{\'opacity\' : isLoadingP ? 0.5 : 1}"><div class="mail-list-item" \nng-repeat="company in vm.companiesSROI" ng-init="parentIndex = $index" md-no-ink \nng-click="vm.openCompany(company, $event)" \nng-class="{\'starred\': company.starred, \'selected\': vm.selectedContentID !== client.id_mailing_content, \'checked\': vm.isChecked(company)}">\n<div layout="row" layout-align="start center"><md-checkbox class="no-label" ng-checked="vm.isSelected(company)" \nng-click="vm.toggleSelectThread(company, $event)" aria-label="{{vm.isSelected(company) ? \'Deselect\' : \'Select\'}}">\n</md-checkbox><div ng-if="company.logo[0] && storagePrefix" class="avatar-wrapper"><img md-menu-align-target \nclass="avatar" ng-src="{{storagePrefix}}{{company.logo[0].url}}"></div><div ng-if="!company.logo[0]" class="avatar" \nng-bind="company.name | capitalizeFirstLetter" ms-random-class="vm.colors"></div><div class="info layout-column flex" \nflex="" layout="column"><div class="name text-truncate" style="padding-bottom: 0px; padding-top: 0px;" layout="row" \nlayout-align="start center"><span>{{company.name}}</span> <span ng-if="company.is_owner == 1">\n({{ \'GLOBAL.OWNER\' | translate}})</span></div><div class="grey-500-fg text-truncate" layout="row" \nlayout-align="start center"><span>{{company.entity_name}}</span></div><div class="grey-500-fg text-truncate" \nlayout="row" layout-align="start center"><span>{{company.input_year}}</span></div></div></div></div><div \nng-if="!isLoading && pagination_total_pages > pagination_page && vm.companies.length > 0" class="load-more white p-30" \nlayout="row" layout-sm="column" layout-align="center center" layout-wrap=""><md-button \nng-click="pagination_nextPage(true)" class="md-raised">{{\'GLOBAL.LOAD_MORE\' |\xA0translate}}</md-button></div><div \nng-if="pagination_total_pages == pagination_page && pagination_page > 1" class="load-more white p-30" layout="row" \nlayout-sm="column" layout-align="center center" layout-wrap=""><div class="message" translate="GLOBAL.NO_MORE_ITEMS">\n</div></div></div>');
$templateCache.put('app/main/apps/proyects/views/list/nosplit-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.preview && !vm.readView" \nng-include="\'app/main/apps/clients/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row">\n<div class="content thread-detail mail-read-pane p0" flex="" id="thread-detail" ms-scroll="vm.msScrollOptions" \nng-if="vm.preview" ng-include="\'app/main/apps/clients/views/read/read-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="!vm.preview && !vm.readView" ng-include="\'app/main/apps/clients/views/list/list-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="vm.readView && vm.showForm" ng-include="\'app/main/apps/clients/views/read/form.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="vm.readView && !vm.showForm" ng-include="\'app/main/apps/clients/views/read/question-form.html\'"></div></div>');
$templateCache.put('app/main/apps/proyects/views/list/split-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.readView && !vm.preview" \nng-include="\'app/main/apps/proyects/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row">\n<div class="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="!vm.readView && !vm.preview" ng-include="\'app/main/apps/proyects/views/list/list-view.html\'"></div><div \nclass="content thread-detail mail-read-pane p0" flex="" id="thread-detail" ng-if="vm.preview" \nng-include="\'app/main/apps/proyects/views/read/preview-company.html\'"></div><div \nclass="content thread-detail mail-read-pane p0" flex="" id="thread-list" ng-if="vm.preview" \nng-include="\'app/main/apps/proyects/views/read/preview-structure.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="vm.readView && !vm.preview && vm.showForm" ng-include="\'app/main/apps/proyects/views/read/form.html\'"></div><div\n class="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="vm.readView && !vm.preview && !vm.showForm" ng-include="\'app/main/apps/proyects/views/read/question-form.html\'">\n</div></div>');
$templateCache.put('app/main/apps/proyects/views/list/toolbar.html','<div layout="row" layout-align="start center"><md-checkbox class="no-label" \naria-label="{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}" \nng-checked="vm.selectedThreads.length > 0" ng-click="vm.toggleSelectThreads(vm.selectedThreads, vm.contents)">\n</md-checkbox><div ng-if="!vm.fromComplaint || vm.userLogued.user_type <= 2 || vm.userLogued.user_type == 20" \nclass="divider-vertical" hide="" show-gt-xs=""></div><md-button \nng-if="!vm.fromComplaint || vm.userLogued.user_type <= 2 || vm.userLogued.user_type == 20" aria-label="NEW" \nclass="md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme" hide show-gt-sm \nng-click="vm.newForm($event)" translate="CLIENTS.NEWP" type="button"></md-button><md-button \nng-if="!vm.fromComplaint || vm.userLogued.user_type <= 2 || vm.userLogued.user_type == 20" aria-label="NEW" \nclass="md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme z-index-0" hide-gt-sm \nng-click="vm.newForm($event)" type="button"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="divider-vertical" hide="" show-gt-xs=""></div><div aria-hidden="false" \nclass="action-buttons hide show-gt-xs layout-align-start-center layout-row" layout="row" layout-align="start center" \nng-show="vm.selectedThreads.length > 0"><md-button ng-click="vm.deleteCompany($ev)" aria-label="Delete" \nclass="md-icon-button" hide="" show-gt-xs="" translate=""><md-icon md-font-icon="icon-delete"></md-icon><md-tooltip \nhide show-gt-xs><span translate="GLOBAL.REMOVE"></span></md-tooltip></md-button><div class="divider-vertical" hide="" \nshow-gt-xs=""></div></div><ms-search-bar debounce="300" model-search="$root.pagination_searchquery" \non-result-click="vm.searchResultClick(item)" on-search="vm.search(query)" layout="row" layout-align="start center">\n</ms-search-bar><md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" \ntranslate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nng-if="$root.pagination_searchquery==true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip \nhide show-gt-xs><span>Reset search</span></md-tooltip></md-button><div class="divider-vertical" hide="" show-gt-xs="">\n</div><md-menu hide="" show-gt-xs="" ng-if="refGroupables.length>0"><button aria-label="Filters" \nclass="md-icon-button" ng-click="$mdMenu.open($event)" show-gt-xs="" translate="" \ntranslate-attr-aria-label="GLOBAL.FILTERS"><md-icon md-font-icon="icon-chevron-down"><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.GROUP_BY">Group</span></md-tooltip></md-icon></button><md-menu-content width="4"><md-menu-item \nng-repeat="sortfield in refGroupables"><md-button aria-label="All" ng-click="pagination_setOrderBy(sortfield)"><div \nlayout="row" layout-align="space-between center"><span>Group by {{sortfield.name}} </span><i class="icon-check s16" \nng-if="sortfield.titleId == sortable.titleId"></i></div></md-button></md-menu-item><md-menu-divider ng-if="groupable">\n</md-menu-divider><md-menu-item ng-if="groupable"><md-button aria-label="Remove group" \nng-click="pagination_resetOrderBy()"><md-icon md-font-icon="icon-close "></md-icon><span>Remove order</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div><div layout="row" layout-align="start center" \ntranslate-attr-aria-label="GLOBAL.REFRESH"><span ng-if="!isLoading" class="page-info font-weight-500">\n{{vm.companies.length}} {{ \'GLOBAL.OF\' | translate}} {{pagination_totalItems}} {{ \'GLOBAL.ITEMS\' | translate}}.</span>\n<md-menu class="settings-menu" hide-gt-xs ng-show="vm.selectedThreads.length > 0"><md-button aria-label="Settings" \nclass="md-icon-button" ng-click="$mdMenu.open($event)" translate="GLOBAL.SETTINGS" \ntranslate-attr-aria-label="GLOBAL.SETTINGS"><md-icon md-font-icon="icon-dots-horizontal"></md-icon></md-button>\n<md-menu-content><md-menu-item ng-click="vm.deleteCompany($ev)" show="vm.selectedMail.length > 0 || vm.allChecked">\n<md-button ng-click="vm.massActions(\'delete\')" aria-label="Delete" translate-aria-label="GLOBAL.DELETE"><md-icon \nmd-font-icon="icon-delete"></md-icon><span translate="GLOBAL.DELETE">Delete</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div>');
$templateCache.put('app/main/apps/proyects/views/read/form.html','<div id="forms" class="page-layout simple fullwidth doc-page forms" layout="column"><div class="p0" layout="column">\n<div layout="row"><ms-form-wizard class="no-margin" flex><div layout="row" layout-align="start center" flex="100" \nclass="layout-align-start-center layout-row flex-100 toolbar grey-100-bg colored-bg" ng-if="vm.idCompany"><a \nclass="pointer" ng-click="vm.closeForm()"><md-icon md-font-icon="icon-chevron-left"></md-icon></a><div \nclass="avatar-wrapper"><md-icon md-font-icon="icon-city"></md-icon></div><div class="field mr-10 ml-10 flex" flex="">\n<strong class="grey-800-fg ng-binding" ng-bind-html="vm.formWizard.company.name"></strong></div></div><md-tabs \nclass="height-tabs" md-dynamic-height md-selected="msWizard.selectedIndex" md-center-tabs="true"><md-tab><md-tab-label>\n<span class="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 0">1</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 0"><i class="icon-checkbox-blank-circle s16"></i> </span><span \nclass="ms-form-wizard-step-text" translate="GLOBAL.COMPANY_DATA"></span></span></md-tab-label><md-tab-body><form \nname="wizardStep1" ng-include="\'app/main/apps/clients/views/read/form-tabs/step-company.html\'" ms-form-wizard-form \nnovalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.idCompany"><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 1">2</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 1"><i class="icon-checkbox-blank-circle s16"></i> </span><span \nclass="ms-form-wizard-step-text" translate="CLIENTS.OPTIONS"></span></span></md-tab-label><md-tab-body><form \nname="wizardStep1b" ng-include="\'app/main/apps/clients/views/read/form-tabs/step-options.html\'" ms-form-wizard-form \nnovalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.idCompany"><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 2">3</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 2"><i class="icon-checkbox-blank-circle s16"></i> </span><span \nclass="ms-form-wizard-step-text" translate="GLOBAL.FILIATION_DATA"></span></span></md-tab-label><md-tab-body><div \nclass="navigation white-bg mb-50" flex layout="row" layout-align="center center"><div layout="row" flex \nlayout-align="start center"><md-button ng-if="vm.showForm" translate="GLOBAL.CLOSE" type="button" \nng-click="vm.closeForm()" class="md-raised md-warn hide-xs" aria-label="Cancel"></md-button><md-button \nng-if="vm.idCompany" translate="GLOBAL.SAVE" class="md-raised md-accent" ng-click="vm.nextStep(msWizard, true);" \nng-hide="msWizard.isLastStep()" ng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button></div><div \nclass="ml-auto" layout="row" flex layout-align="end center"><div flex layout="column" layout-align="center center" \nlayout-padding layout-margin ng-if="vm.loadingStep" class="loading-container"><md-progress-circular \nmd-mode="indeterminate" md-diameter="30"></md-progress-circular></div><md-button translate="GLOBAL.PREVIOUS" \nclass="md-raised md-accent" ng-click="vm.prevStep(msWizard)" ng-disabled="vm.previousStep(msWizard) || vm.loadingStep">\n</md-button><div class="steps"><span ng-repeat="form in msWizard.forms" \nng-class="{\'selected md-accent-bg\':msWizard.selectedIndex === $index}"></span></div><md-button translate="GLOBAL.NEXT" \nclass="md-raised md-accent" ng-click="vm.nextStep(msWizard)" ng-hide="msWizard.isLastStep()" \nng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button><md-button translate="GLOBAL.FINISH" \nclass="md-raised md-warn" ng-click="vm.sendForm(); msWizard.resetForm();" ng-show="msWizard.isLastStep()" \nng-disabled="msWizard.formsIncomplete()"></md-button></div></div><form name="wizardStep2" \nng-include="\'app/main/apps/clients/views/read/form-tabs/step-branchs.html\'" class="md-inline-form" ms-form-wizard-form \nnovalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.formWizard.main_branch.id"><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 3">4</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 3"><i class="icon-checkbox-blank-circle s16"></i> </span><span \ntranslate="GLOBAL.COMPLIANCE_COMMITTEE" class="ms-form-wizard-step-text"></span></span></md-tab-label><md-tab-body>\n<form ng-include="\'app/main/apps/clients/views/read/form-tabs/step-people.html\'" name="wizardStep3" \nms-form-wizard-form novalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.formWizard.main_branch.id">\n<md-tab-label><span class="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 4">5</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 4"><i class="icon-checkbox-blank-circle s16"></i> </span><span \ntranslate="GLOBAL.BRANCH_PERSONNEL" class="ms-form-wizard-step-text"></span></span></md-tab-label><md-tab-body><form \nng-include="\'app/main/apps/clients/views/read/form-tabs/step-people-global.html\'" name="wizardStep4" \nms-form-wizard-form novalidate></form></md-tab-body></md-tab></md-tabs><div \nclass="navigation white-bg border-top mb-50" flex layout="row" layout-align="center center"><div layout="row" flex \nlayout-align="start center"><md-button hide-xs ng-if="vm.showForm" translate="GLOBAL.CLOSE" type="button" \nng-click="vm.closeForm()" class="md-raised md-warn hide-xs" aria-label="Cancel"></md-button><md-button \nng-if="vm.idCompany" translate="GLOBAL.SAVE" class="md-raised md-accent" ng-click="vm.nextStep(msWizard, true);" \nng-hide="msWizard.isLastStep()" ng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button></div><div \nclass="ml-auto" layout="row" flex layout-align="end center"><div flex layout="column" layout-align="center center" \nlayout-padding layout-margin ng-if="vm.loadingStep" class="loading-container"><md-progress-circular \nmd-mode="indeterminate" md-diameter="30"></md-progress-circular></div><md-button translate="GLOBAL.PREVIOUS" \nclass="md-raised md-accent" ng-click="vm.prevStep(msWizard)" ng-disabled="vm.previousStep(msWizard) || vm.loadingStep">\n</md-button><div class="steps"><span ng-repeat="form in msWizard.forms" \nng-class="{\'selected md-accent-bg\':msWizard.selectedIndex === $index}"></span></div><md-button translate="GLOBAL.NEXT" \nclass="md-raised md-accent" ng-click="vm.nextStep(msWizard)" ng-hide="msWizard.isLastStep()" \nng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button><md-button translate="GLOBAL.FINISH" \nclass="md-raised md-warn" ng-click="vm.sendForm(); msWizard.resetForm();" ng-show="msWizard.isLastStep()" \nng-disabled="msWizard.formsIncomplete()"></md-button></div></div><div class="navigation" flex layout="row" \nlayout-align="center center"><md-button hide-xs ng-if="vm.showForm" translate="GLOBAL.CANCEL" type="button" \nng-click="vm.closeForm()" class="md-raised md-warn show-xs" aria-label="Cancel"></md-button></div></ms-form-wizard>\n</div></div></div>');
$templateCache.put('app/main/apps/proyects/views/read/preview-company.html','<div hide show-gt-sm class="toolbar grey-100-bg colored-bg" layout="row" layout-align="space-between center" scroll="">\n<div layout="row" layout-align="start center"><a class="pointer" ng-click="vm.goClients()"><md-icon \nmd-font-icon="icon-chevron-left"></md-icon></a><h2 translate="GLOBAL.COMPANY_DATA"></h2></div></div><div \nclass="md-whiteframe-1dp without-line scrollable preview" flex="100"><form name="vm.basicForm" class="md-inline-form" \nnovalidate><md-input-container class="md-block bb logotype"><img \nngf-thumbnail="!image.$error && image && vm.logoIsLoaded" class="img"> <img \nng-if="!image && imageUrl && vm.logoIsLoaded" src="{{imageUrl}}" class="img"><div \nng-if="!image && !imageUrl && vm.logoIsLoaded" class="avatar img" \nng-bind="vm.formWizard.company.name | capitalizeFirstLetter" ms-random-class="vm.colors"></div><h5 \nclass="padding inline-block m0">{{vm.formWizard.company.name}}</h5></md-input-container><md-input-container \nclass="md-block bb"><label>{{vm.getRegionLiteral(\'tax_ic_number\')}}</label><h5 class="padding">\n{{vm.formWizard.company.tax_id_number}}</h5></md-input-container><md-input-container class="md-block mg-bttm"><label \ntranslate="GLOBAL.SECTOR"></label><h5 class="padding">{{vm.getSectorById(vm.formWizard.company.sector_id).name}}</h5>\n</md-input-container><md-input-container class="md-block border separator mb-30"><h2 class="title" \ntranslate="CLIENTS.OPTIONS"></h2></md-input-container><md-input-container ng-if="vm.formWizard.company.description" \nclass="md-block bb options-preview"><label class="options-preview" translate="GLOBAL.DESCRIPTION"></label><h5 \nclass="padding mv-10">{{vm.formWizard.company.description}}</h5></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.executives_type" class="md-block bb mb-0 options-preview-select"><label \ntranslate="GLOBAL.EXECUTIVE_TYPE"></label><md-select class="disabled" ng-disabled="true" \nng-model="vm.formWizard.company.extra_data.executives_type"><md-option ng-value="1">Accionista \xFAnico</md-option>\n<md-option ng-value="2">Varios accionistas</md-option><md-option ng-value="3">Consejo de administraci\xF3n</md-option>\n<md-option ng-value="4">Administrador \xFAnico</md-option><md-option ng-value="5">Otros</md-option></md-select>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.capital" \nclass="md-block bb mb-0 options-preview-select"><label translate="GLOBAL.SOCIAL_CAPITAL"></label><md-select \nclass="disabled" ng-disabled="true" ng-model="vm.formWizard.company.extra_data.capital"><md-option ng-value="1">Capital\n</md-option><md-option ng-value="2">Aportaciones de socios</md-option><md-option ng-value="3">\nAumentos de capital recientes</md-option></md-select></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.capital_amount" class="md-block bb m0 options-preview"><label \nclass="options-preview" translate="GLOBAL.AMOUNT_CAPITAL"></label><h5 class="padding mv-10">\n{{vm.formWizard.company.extra_data.capital_amount}}</h5></md-input-container><md-input-container \nng-if="vm.formWizard.company.turnover_volume" class="md-block bb m0 options-preview"><label class="options-preview" \ntranslate="GLOBAL.BILLING_LAST_YEAR"></label><h5 class="padding mv-10">{{vm.formWizard.company.turnover_volume}}</h5>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.tax_options" \nclass="md-block bb mb-0 options-preview-select"><label>IVA</label><md-select class="disabled" ng-disabled="true" \nng-model="vm.formWizard.company.extra_data.tax_options"><md-option ng-value="1">Presentaci\xF3n trimestral</md-option>\n<md-option ng-value="2">Presentaci\xF3n mensual</md-option></md-select></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.annual_accounts" class="md-block bb mb-0 options-preview-select"><label>\nCuentas anuales</label><md-select class="disabled" ng-disabled="true" \nng-model="vm.formWizard.company.extra_data.annual_accounts"><md-option ng-value="1">Abreviadas</md-option><md-option \nng-value="2">Normales</md-option><md-option ng-value="3">Pymes</md-option><md-option ng-value="4">Mixtas</md-option>\n</md-select></md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.extra_data" \nclass="md-block bb mb-0 options-preview-select"><label>Auditor\xEDas</label><md-select class="disabled" \nng-disabled="true" ng-model="vm.formWizard.company.extra_data.audits"><md-option ng-value="1">Internas</md-option>\n<md-option ng-value="2">Externas</md-option><md-option ng-value="3">No aplica</md-option></md-select>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.iso_certification" \nclass="md-block bb mb-0 options-preview-select"><label>Certificaciones ISO</label><md-select class="disabled" \nng-disabled="true" ng-model="vm.formWizard.company.extra_data.iso_certification"><md-option ng-value="1">ISO 9001\n</md-option><md-option ng-value="2">ISO 14000</md-option><md-option ng-value="3">ISO 14001</md-option><md-option \nng-value="4">ISO 19600</md-option><md-option ng-value="5">ISO 22000</md-option><md-option ng-value="6">ISO 26000\n</md-option><md-option ng-value="7">ISO 27001</md-option><md-option ng-value="8">ISO 37001</md-option><md-option \nng-value="9">OHSAS 18001</md-option></md-select></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.collective_agreement" class="md-block bb m0 options-preview"><label \nclass="options-preview">Convenio Colectivo Aplicable</label><h5 class="padding mv-10">\n{{vm.formWizard.company.extra_data.collective_agreement}}</h5></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.insurance" class="md-block bb m0 options-preview"><label \nclass="options-preview">Seguros contratados</label><h5 class="padding mv-10">\n{{vm.formWizard.company.extra_data.insurance}}</h5></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.cnae" class="md-block bb m0 options-preview"><label class="options-preview" \ntranslate="GLOBAL.CNAE"></label><h5 class="padding mv-10">{{vm.formWizard.company.extra_data.cnae}}</h5>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.financing.length> 0" \nclass="md-block bb mb-0 options-preview-select"><label class="ph-15" fill-width translate="GLOBAL.FINANCING"></label>\n<md-select class="disabled" ng-disabled="true" multiple="{{false}}" \nng-model="vm.formWizard.company.extra_data.financing"><md-option ng-repeat="option in vm.financing_options" \nng-value="option">{{option.name}}</md-option></md-select></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.sector_regulations.length> 0" class="md-block bb mb-0 options-preview-select">\n<label class="ph-15" fill-width>Normativa Sectorial aplicable</label><md-select class="disabled" ng-disabled="true" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.sector_regulations"><md-option \nng-repeat="option in vm.sector_regulations_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.implemented_measures.length> 0" \nclass="md-block bb mb-20 options-preview-select"><label class="ph-15" fill-width>Medidas implementadas</label>\n<md-select class="disabled" ng-disabled="true" multiple="{{false}}" \nng-model="vm.formWizard.company.extra_data.implemented_measures"><md-option \nng-repeat="option in vm.implemented_measures_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container><md-input-container class="md-block border separator"><h2 class="title" \ntranslate="GLOBAL.MAIN_BRANCH"></h2></md-input-container><md-input-container class="md-block bb"><label \ntranslate="GLOBAL.NAME"></label><h5 class="padding">{{vm.formWizard.main_branch.name}}</h5></md-input-container>\n<md-input-container class="md-block bb"><label translate="GLOBAL.ADDRESS"></label><h5 class="padding">\n{{vm.formWizard.main_branch.address1}}</h5></md-input-container><md-input-container class="md-block bb"><label>\n{{vm.getRegionLiteral(\'city\')}}</label><h5 class="padding">{{vm.formWizard.main_branch.city}}</h5></md-input-container>\n<md-input-container class="md-block border separator"><h2 class="title" translate="GLOBAL.BRANCH"></h2>\n</md-input-container><div class="mail-list-pane s0" ng-if="vm.formWizard.branches && vm.formWizard.branches.length> 0">\n<div class="items" ng-repeat="branch in vm.formWizard.branches track by $index"><div layout="row" \nlayout-align="start center" flex="100" class="p-20 layout-align-start-center layout-row flex-100"><div layout="row" \nlayout-align="start center" flex="100" class="layout-align-start-center layout-row flex-100"><div \nclass="avatar-wrapper"><md-icon md-font-icon="icon-city"></md-icon></div><div class="field mr-10 ml-10 flex" flex="">\n<strong class="grey-800-fg ng-binding" ng-bind-html="branch.name"></strong><div class="field grey-600-fg ng-binding">\n<span ng-if="branch.city" ng-bind-html="branch.city"></span> <span ng-if="branch.city && branch.state">, </span><span \nng-if="branch.state" ng-bind-html="branch.state"></span></div></div></div></div></div></div></form></div>');
$templateCache.put('app/main/apps/proyects/views/read/preview-structure.html','<div hide show-gt-sm class="toolbar grey-100-bg colored-bg" layout="row" layout-align="space-between center" scroll="">\n<div layout="row" layout-align="start center"><h2>Organizaci\xF3n de la compa\xF1\xEDa</h2></div><div layout="row" \nlayout-align="end center" hide show-gt-sm><md-button translate="GLOBAL.EDIT" type="button" ng-click="vm.editCompany()" \nclass="md-raised md-accent" aria-label="Edit"></md-button></div><div layout="row" layout-align="end center" hide-gt-sm>\n<md-button type="button" ng-click="vm.editClient()" \nclass="md-accent md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" aria-label="Edit"><md-icon \nmd-font-icon="icon-plus"></md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.EDIT"></span></md-tooltip>\n</md-button></div></div><div class="without-line scrollable preview" flex="100"><div ivh-treeview="vm.tree" \nivh-treeview-options="vm.ivhOptions" class="treeview" \nivh-treeview-on-cb-change="vm.callback(ivhNode, ivhIsSelected, ivhTree)"><script type="text/ng-template">\n<div class="level-card" ng-if="node.type != \'user\'">\n                    <span ivh-treeview-toggle>\n                        <span ivh-treeview-twistie></span>\n                    </span>\n                    <md-icon md-font-icon="icon-city" ng-if="node.type == \'branch\'"></md-icon>\n                    <md-icon md-font-icon="icon-folder-account" ng-if="node.type == \'division\'"></md-icon>\n                    <md-icon md-font-icon="icon-worker" ng-if="node.type == \'job_position\'"></md-icon>\n                    <span class="ivh-treeview-node-label" ivh-treeview-toggle>{{trvw.label(node)}}</span>\n                </div>\n                <div class="level-card" ng-if="node.type == \'user\'">\n                    <div layout="row" layout-align="start center" flex="100">\n                        <div class="avatar-wrapper">\n                            <user-avatar User="node.user"/>\n                        </div>\n                        <div class="field mr-5 ml-5" flex>\n                            <strong class="grey-800-fg" ng-bind-html="node.user.first_name + \' \' + node.user.last_name"></strong>\n                        </div>\n                    </div>\n                </div>\n                <div ivh-treeview-children></div>\n</script></div></div>');
$templateCache.put('app/main/apps/proyects/views/read/question-form.html','<div id="forms" class="page-layout simple fullwidth doc-page forms" layout="column"><div ng-if="!vm.isQuestions"><div \nclass="page-layout carded left-sidenav" layout="row"><div class="content-wrapper" layout="row" flex><div \nclass="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-thumb-up" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="CLIENTS.CLIENT_CREATED_SUCCESSFULLY"></span><div layout-gt-xs="row" layout="column" \nlayout-align="center center" class="mt-15"><md-button translate="GLOBAL.BACK_CLIENT_LIST" type="button" \nng-click="vm.goClients()" class="md-raised md-warn" aria-label="Cancel"></md-button><md-button \nclass="md-raised md-accent" ui-sref="app.site_overview.questions.questionnaire" \ntranslate="GLOBAL.CONTINUE_WITH_QUESTIONS"></md-button></div></div></div></div></div></div><div ng-if="vm.isQuestions" \nclass="p0" layout="column"><div class="items outline"><div layout="column" class="selectors"><md-input-container><label\n class="al-left">Criterio</label><md-select ng-model="vm.allQuestions" ng-change="vm.goQuestions(msWizard)"><md-option \nng-value="true">Todas las preguntas</md-option><md-option ng-value="false">Preguntas del sector</md-option></md-select>\n</md-input-container></div><div layout="column" class="selectors"><md-input-container><label class="al-left">Branches\n</label><md-select multiple="{{true}}" ng-model="vm.branchQuestion"><md-option ng-repeat="branch in vm.branches" \nng-value="branch.id">{{branch.name}}</md-option></md-select></md-input-container></div></div><div layout="row" \nng-repeat="question in vm.questions"><div class="question"><div layout="column" layout-gt-xs="row"><md-input-container \nflex><h2>{{question.name}}</h2></md-input-container></div><div layout="column" layout-gt-xs="row"><md-radio-group \nng-model="question.value"><md-radio-button value="yes" class="inline">Si</md-radio-button><md-radio-button value="no" \nclass="inline ml">No</md-radio-button></md-radio-group></div></div></div><div class="navigation pt" flex layout="row" \nlayout-align="center center"><md-button translate="GLOBAL.CANCEL" class="md-raised md-warn" ng-click="vm.goClients()">\n</md-button><md-button translate="GLOBAL.SEND" class="md-raised md-warn" ng-click="vm.finishQuestion()" \nng-disabled="!vm.branchQuestion.length > 0"></md-button></div></div></div>');
$templateCache.put('app/main/apps/proyects/views/read/read-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="vm.loadingReadPane" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="fullheight" ng-if="!vm.loadingReadPane"><md-tabs class="fullheight"><md-tab label="Organizaci\xF3n"><content \nclass="" layout="row" ng-include="\'app/main/apps/clients/views/read/preview-company.html\'"></content></md-tab><md-tab \nlabel="Estructura"><content class="" layout="row" \nng-include="\'app/main/apps/clients/views/read/preview-structure.html\'"></content></md-tab><md-tab label="Edit" \nng-click="vm.editClient()"><content class="" ng-if="vm.showForm" layout="row" \nng-include="\'app/main/apps/clients/views/read/form.html\'"></content><content class="" ng-if="!vm.showForm" \nlayout="row" ng-include="\'app/main/apps/clients/views/read/question-form.html\'"></content></md-tab></md-tabs></div>');
$templateCache.put('app/main/apps/outcomes/dialogs/new-stake-dialog/new-stake-dialog.html','<md-dialog class="new-client-dialog" aria-label="New Task"><form name="taskForm" class="md-inline-form" novalidate>\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between"><h1 \nclass="title" translate="STAKE.PROYECT_DATA"></h1><md-button class="md-icon-button" ng-click="vm.closeDialog()">\n<md-icon md-font-icon="icon-close" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content class="p-25" ms-scroll><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="STAKE.NAME"></label> <input type="text" ng-model="vm.company.stakeholder" required></md-input-container>\n</div><div layout="column" layout-gt-xs="row"><md-input-container flex><label translate="STAKE.INPUT"></label> <input \ntype="checkbox" ng-model="vm.company.input" value="1" name="input12" required></md-input-container><md-input-container \nflex><label translate="STAKE.OUTPUT"></label> <input ng-model="vm.company.output" type="checkbox" required>\n</md-input-container></div></md-dialog-content><md-dialog-actions class="footer" layout="row" layout-="end">\n<md-input-container flex layout="row" layout-align="end center"><md-button type="button" class="md-raised md-warn" \nng-click="vm.closeDialog()" translate="RISKCONFIG.CANCEL">Cancel</md-button><md-button \nng-disabled="!vm.company.stakeholder" type="submit" class="send-button md-accent md-raised" ng-click="vm.saveDialog()" \ntranslate="GLOBAL.SAVE">ADD</md-button></md-input-container></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/outcomes/views/list/list-table-view.html','<div flex layout="column" layout-align="center center" ng-if="isLoading" class="loading-container">\n<md-progress-circular md-mode="indeterminate" md-diameter="50"></md-progress-circular></div><div \nclass="mail-list-item filter-selected" ng-if="vm.selectedGroup" layout="row" layout-align="start center"><div \nclass="info" flex><div class="name" layout="row" layout-align="start center"><md-icon \nng-if="!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 1" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-font-icon="icon-folder" aria-hidden="true"></md-icon>\n<md-icon ng-if="!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 2" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-font-icon="qiu-icon-file-usermailing" aria-hidden="true">\n</md-icon><md-icon ng-if="vm.selectedGroup.children && vm.selectedGroup.id_group_type == 2" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-svg-src="/assets/icons/svg/icon-folder-mail-multiple.svg" \naria-hidden="true"></md-icon><md-icon ng-if="!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 3" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-font-icon="qiu-icon-file-usermediacenter" \naria-hidden="true"></md-icon><md-icon ng-if="vm.selectedGroup.children && vm.selectedGroup.id_group_type == 3" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-svg-src="/assets/icons/svg/icon-folder-play-multiple.svg" \naria-hidden="true"></md-icon><md-icon ng-if="!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 4" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-font-icon="qiu-icon-file-usersegment" aria-hidden="true">\n</md-icon><md-icon ng-if="vm.selectedGroup.children && vm.selectedGroup.id_group_type == 4" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-svg-src="/assets/icons/svg/icon-folder-share-multiple.svg" \naria-hidden="true"></md-icon><md-icon ng-if="!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 5" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-font-icon="qiu-icon-file-userstore" aria-hidden="true">\n</md-icon><md-icon ng-if="vm.selectedGroup.children && vm.selectedGroup.id_group_type == 5" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-svg-src="/assets/icons/svg/icon-folder-shop-multiple.svg" \naria-hidden="true"></md-icon><md-icon ng-if="!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 6" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-font-icon="qiu-icon-file-useracreditation" \naria-hidden="true"></md-icon><md-icon ng-if="vm.selectedGroup.children && vm.selectedGroup.id_group_type == 6" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-svg-src="/assets/icons/svg/icon-folder-board-multiple.svg" \naria-hidden="true"></md-icon><md-icon ng-if="!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 7" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-svg-src="/assets/icons/svg/icon-folder-chat.svg" \naria-hidden="true"></md-icon><md-icon ng-if="vm.selectedGroup.children && vm.selectedGroup.id_group_type == 7" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-svg-src="/assets/icons/svg/icon-folder-chat-multiple.svg" \naria-hidden="true"></md-icon><md-icon ng-if="!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 8" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-font-icon="icon-folder-remove" aria-hidden="true">\n</md-icon><md-icon ng-if="vm.selectedGroup.children && vm.selectedGroup.id_group_type == 8" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-font-icon="icon-folder-multiple" aria-hidden="true">\n</md-icon><md-icon ng-if="vm.selectedGroup.children && vm.selectedGroup.id_group_type == 1" \nclass="{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0" md-font-icon="icon-folder-multiple" aria-hidden="true">\n</md-icon><div class="title text-truncate" layout="row" layout-align="start center">{{vm.selectedGroup.name}} <span \nng-if="!isLoading">({{pagination_totalItems | number}})</span></div></div></div><div class="buttons" layout="row" \nlayout-align="start center"><div><md-switch class="no-label" ng-checked="vm.includeSubgroups" \nng-click="vm.toggleIncludeSubgroups($event)" aria-label="{{vm.includeSubgroups ? \'Uncheck\':\'check\'}}"></md-switch>\n<md-tooltip><span translate="CONTENT.INCLUDE_SUBGROUPS">Include subgroups</span></md-tooltip></div><md-icon \nng-if="!vm.selectedGroup.is_qiu_restricted" md-font-icon="icon-close s20" ng-click="vm.unselectGroups()" class="ml-10">\n<md-tooltip hide show-gt-xs><span translate="CONTENT.DESELECT_GROUP">Deselect group</span></md-tooltip></md-icon></div>\n</div><div class="mail-list-item filter-selected" ng-if="vm.fieldOrder != undefined || vm.groupBy != undefined" \nlayout="row" layout-align="space-between center"><div layout="row" layout-align="start center" flex><div class="info" \nng-if="vm.groupBy != undefined"><div class="name" layout="row" layout-align="start center"><md-icon \nmd-font-icon="icon-format-list-bulleted" class="s20 mr-5 ml-0 mb-0"></md-icon><div class="title text-truncate" \nlayout="row" layout-align="start center">Grouped by \'{{vm.groupBy}}\'</div></div></div><div class="info" \nng-if="vm.fieldOrder != undefined"><div class="name" layout="row" layout-align="start center"><md-icon \nmd-font-icon="icon-sort-ascending" class="s20 mr-5 ml-0 mb-0" ng-if="sortDir === \'ASC\'"></md-icon><md-icon \nmd-font-icon="icon-sort-descending" class="s20 mr-5 ml-0 mb-0" ng-if="sortDir === \'DESC\'"></md-icon><div \nclass="title text-truncate" layout="row" layout-align="start center">Ordered by \'{{vm.fieldOrder}}\'</div></div></div>\n</div><div class="buttons" layout="row" layout-align="start center"><md-icon md-font-icon="icon-close s20" \nng-click="vm.resetSortField()" class="ml-10"><md-tooltip hide show-gt-xs><span translate="CONTENT.REMOVE">Remove</span>\n</md-tooltip></md-icon></div></div><div class="no-threads" \nng-if="!isLoading && vm.threads.length === 0 && !vm.pleaseSelectGroup" ng-hide="isLoading" translate="USERS.NO_ITEMS">\n</div><div class="no-threads" ng-if="!isLoading && vm.threads.length === 0 && vm.pleaseSelectGroup" \nng-hide="isLoading" translate="USERS.SELECT_GROUP"></div><div id="list-content-data" \nng-style="{\'opacity\' : isLoading ? 0.2 : 1}" \nng-class="{\'group-filter\': vm.selectedGroup,\'other-filter\':vm.fieldOrder != undefined || vm.groupBy != undefined}" \nclass="scrollable" ng-if="vm.threads.length > 0"><table class="table-scrollable row-border hover simple" \nms-responsive-table><thead><tr><th class="mini"></th><th \nng-class="{\'large\': vm.isLarge(column.title), \'medium\' : vm.isMedium(column.title), \'small\' : vm.isSmall(column.title), \'mini\': vm.isMini(column.title)}" \nng-repeat="column in vm.refcolumns | filter: { table_list_position: \'main\'} | orderBy: vm.orderByTableListSort" \nng-if="column.title !== \'lastname\'" ng-switch="column.title"><span ng-switch-when="firstname" translate="USERS.NAME">\n</span> <span ng-switch-default ng-bind="column.field_name"></span></th><th class="group" \nng-repeat="column in vm.flatGroups | filter: { table_list_position: \'main\'}"><span translate="GROUP.GROUP"></span><br>\n<span>"{{column.name}}"</span></th><th class="small"><md-menu-bar><md-menu><md-button class="md-icon-button" \naria-label="Actions" ng-click="$mdMenu.open($event)" layout="row" layout-align="center center"><md-icon \nmd-font-icon="icon-cog"></md-icon><md-tooltip hide show-gt-xs><span translate="USERS.EDIT_COLUMNS">Edit columns</span>\n</md-tooltip></md-button><md-menu-content><md-menu-item \nng-repeat="column in vm.refcolumns | orderBy: vm.orderByTableListSort | filter: vm.filterIsMainOrSecondaryTableListPosition">\n<md-button md-prevent-menu-close="md-prevent-menu-close" \nng-click="column.table_list_position == \'main\' ? column.table_list_position = \'secondary\' : column.table_list_position = \'main\'; $event.stopPropagation();" \naria-label="{{column.field_name}}"><div layout="row" layout-align="space-between center"><div layout="row" \nlayout-align="start between"><span ng-bind="column.field_name"></span></div><i \nng-if="column.table_list_position == \'main\'" class="icon-check s16"></i></div></md-button></md-menu-item><md-menu-item \nng-repeat="column in vm.flatGroups"><md-button md-prevent-menu-close="md-prevent-menu-close" \nng-click="column.table_list_position == \'main\' ? column.table_list_position = \'secondary\' : column.table_list_position = \'main\'; $event.stopPropagation();">\n<div layout="row" layout-align="space-between center"><div layout="row" layout-align="start between"><span \ntranslate="GROUP.GROUP"></span> <span>"{{column.name}}"</span></div><i ng-if="column.table_list_position == \'main\'" \nclass="icon-check s16"></i></div></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></th></tr>\n</thead><tbody><tr ng-click="vm.openThread(thread)" \nng-repeat="thread in vm.threads | filter: vm.search | filter: global.search | groupByUser:[vm.groupBy]" \nng-class="{\'starred\': thread.starred, \'selected\': vm.selectedContentID === thread.id_user, \'checked\': vm.isChecked(thread)}" \nclass="{{thread.status}}"><td class="mini"><md-checkbox class="no-label" ng-checked="vm.isSelected(thread)" \nng-click="vm.toggleSelectThread(thread, $event)" aria-label="{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}">\n</md-checkbox></td><td \nng-class="{\'large\': vm.isLarge(column.title), \'medium\' : vm.isMedium(column.title), \'small\' : vm.isSmall(column.title), \'mini\': vm.isMini(column.title)}" \nng-repeat="column in vm.refcolumns | filter: { table_list_position: \'main\'} | orderBy: vm.orderByTableListSort" \nng-if="column.title !== \'lastname\'" ng-switch="column.title"><a ng-switch-when="email" title="{{thread.email}}" \nhref="mailto:{{thread.email}}">{{thread[column.title]}}</a> <span ng-switch-when="media"><div \nng-if="(!thread.avatar) && thread[vm.refcolumnsgrouped.main[0].title]" class="avatar" \nng-bind="thread[vm.refcolumnsgrouped.main[0].title] | capitalizeFirstLetter" ms-random-class="vm.colors"></div><media \nng-if="thread.avatar" attachment="thread.avatar" class="avatar"></media></span><span title="# {{thread.id_user}}" \nclass="grey-500-fg" ng-switch-when="id_user">#{{thread.id_user}}</span> <span class="large" ng-switch-when="firstname">\n<strong title="{{thread.firstname}} {{thread.lastname}}">{{thread.firstname}} {{thread.lastname}}</strong> </span><span\n class="mini" ng-switch-when="status"><button ng-if="thread.status===0" class="md-icon-button"><md-icon \nmd-font-icon="icon-checkbox-blank-circle-outline" class="off red-fg s24" \nng-click="vm.toggleItemStatus(thread, $event, $index)"></md-icon><md-tooltip><span \ntranslate="USERS.EMAIL_STATUS.IMPORTED">Email imported</span></md-tooltip></button> <button ng-if="thread.status===1" \nclass="md-icon-button"><md-icon md-font-icon="icon-minus-circle" class="on amber-400-fg s24" \nng-click="vm.toggleItemStatus(thread, $event, $index)"></md-icon><md-tooltip><span \ntranslate="USERS.EMAIL_STATUS.NOT_VALIDATED">Email not validated</span></md-tooltip></button> <button \nng-if="thread.status===2" class="md-icon-button"><md-icon md-font-icon="icon-checkbox-marked-circle" \nclass="on green-fg s24" ng-click="vm.toggleItemStatus(thread, $event, $index)"></md-icon><md-tooltip><span \ntranslate="USERS.EMAIL_STATUS.VALIDATED">Email validated</span></md-tooltip></button> <button \nng-if="thread.status!==0 && thread.status!==1 && thread.status!==2" class="md-icon-button"><md-icon \nmd-font-icon="icon-checkbox-blank-circle" class="on grey-fg s24" \nng-click="vm.toggleItemStatus(thread, $event, $index)"></md-icon></button> </span><span class="mini" \nng-switch-when="ingroup_status"><div ng-if="thread.groups.length" class="status-wrapper text-center" layout="row" \nlayout-align="end center"><div ng-repeat="status in vm.ingroupStatus"><span \nng-click="vm.changeInGroupStatusDialog($event, thread, vm.selectedGroup, status)" \nng-if="vm.isShowingLabelGroup(thread, status)" class="{{status.name}} status" \ntranslate="USERS.INGROUP.STATUS.{{status.name | uppercase}}" layout="row" layout-align="center center" \nng-style="{\'background\': status.color || \'\'}"></span></div></div></span><span \ntitle="{{thread.related_country.country}}" ng-switch-when="country">{{thread.related_country.country}}</span> <span \ntitle="{{thread.related_state.state}}" ng-switch-when="state">{{thread.related_state.state}}</span> <span \ntitle="{{thread.related_city.city}}" ng-switch-when="city">{{thread.related_city.city}}</span> <span \ntitle="{{thread[column.title]}}" ng-switch-default>\n{{column.category == \'json\' ? vm.JSONparse(thread.user_params)[column.title] : thread[column.title]}}</span></td><td \nclass="group" ng-repeat="column in vm.flatGroups | filter: { table_list_position: \'main\'}"><md-checkbox \nng-disabled="true" class="no-label" ng-checked="(thread.groups|filter:{\'id_group\':column.id_group}).length > 0" \naria-label="{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}"></md-checkbox></td><td class="small"></td></tr></tbody>\n</table><div class="toolbar border-top" style="padding-bottom: 18px;" layout="row" layout-align="end center"><div \nlayout="row" layout-align="center center" ng-style="{\'display\' : isLoading ? \'none\' : \'block\'}"><span \nclass="page-info">{{pagination_totalItems}} items found.</span><md-button aria-label="Previous" \nclass="md-icon-button arrow" ng-click="pagination_prevPage()" ng-disabled="pagination_firstPage()" translate="" \ntranslate-attr-aria-label="CONTENT.PREVIOUS"><md-icon md-font-icon="icon-chevron-left"></md-icon><md-tooltip hide \nshow-gt-xs><span translate="CONTENT.PREVIOUS">Previous</span></md-tooltip></md-button><span class="page-info">\n{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label="Next" class="md-icon-button arrow" \nng-click="pagination_nextPage()" ng-disabled="pagination_morePages() || pagination_total_pages === pagination_page" \ntranslate="" translate-attr-aria-label="CONTENT.NEXT"><md-icon md-font-icon="icon-chevron-right"></md-icon><md-tooltip \nhide show-gt-xs><span translate="CONTENT.NEXT">Next</span></md-tooltip></md-button></div></div></div>');
$templateCache.put('app/main/apps/outcomes/views/list/list-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="isLoadingP" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="no-threads" ng-if="!companySel" ng-hide="isLoadingP" translate="GLOBAL.NO_ITEMS"></div><div \nid="list-content-data" ng-if="!isLoadingP && companySel" ng-style="{\'opacity\' : isLoadingP ? 0.5 : 1}"><table \nms-responsive-table><thead><tr class="font-size-16"><th></th><th><span translate="OUTCOME.PROYECT_NAME">\nStakeholder name</span></th><th><span translate="OUTCOME.OUTCOME_NAME">OUTCOME name</span></th><th><span \ntranslate="OUTCOME.CONTRIBUTION_YEARS">Contribution years</span></th><th><span translate="OUTCOME.DEAD_WEIGHT">Calc\n</span></th><th><span translate="OUTCOME.DISPLACEMENT">Calc</span></th><th><span translate="OUTCOME.ATRIBUTTION">Calc\n</span></th><th><span translate="OUTCOME.DECREASE">Calc</span></th><th><span translate="OUTCOME.SUBCALCULATION">Calc\n</span></th><th><span translate="OUTCOME.CALCULATION">Calc</span></th><th></th><th></th></tr></thead><tbody><tr \nng-repeat="company in vm.outcome" ng-init="parentIndex = $index" md-no-ink ng-click="vm.openCompany(company, $event)" \nng-class="{\'starred\': company.starred, \'selected\': vm.selectedContentID !== client.id_mailing_content, \'checked\': vm.isChecked(company)}">\n<td><md-checkbox class="no-label" ng-checked="vm.isSelected(company)" \nng-click="vm.toggleSelectThread(company, $event)" aria-label="{{vm.isSelected(company) ? \'Deselect\' : \'Select\'}}">\n</md-checkbox></td><td><span ng-repeat="state in vm.stakeholder" ng-if="state.id === company.stakeholder_id">\n{{state.stakeholder}}</span></td><td><span>{{company.outcome}}</span></td><td><span>\n{{company.years_input | currency:"":2}}</span></td><td><span>{{company.dead_weight | currency:"%":0}}</span></td><td>\n<span>{{company.displacement | currency:"%":0}}</span></td><td><span>{{company.attribution | currency:"%":0}}</span>\n</td><td><span>{{company.decrease | currency:"%":0}}</span></td><td><span>\n{{company.sub_result | currency:symbolMoney:2 }}</span></td><td><span>{{company.result | currency:symbolMoney:2 }}\n</span></td><td></td><td></td></tr></tbody></table><div \nng-if="!isLoading && pagination_total_pages > pagination_page && vm.companies.length > 0" class="load-more white p-30" \nlayout="row" layout-sm="column" layout-align="center center" layout-wrap=""><md-button \nng-click="pagination_nextPage(true)" class="md-raised">{{\'GLOBAL.LOAD_MORE\' |\xA0translate}}</md-button></div><div \nng-if="pagination_total_pages == pagination_page && pagination_page > 1" class="load-more white p-30" layout="row" \nlayout-sm="column" layout-align="center center" layout-wrap=""><div class="message" translate="GLOBAL.NO_MORE_ITEMS">\n</div></div></div>');
$templateCache.put('app/main/apps/outcomes/views/list/nosplit-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.preview && !vm.readView" \nng-include="\'app/main/apps/outcomes/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row">\n<div class="content thread-detail mail-read-pane p0" flex="" id="thread-detail" ms-scroll="vm.msScrollOptions" \nng-if="vm.preview" ng-include="\'app/main/apps/outcomes/views/read/read-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="!vm.preview && !vm.readView" ng-include="\'app/main/apps/outcomes/views/list/list-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="vm.readView && vm.showForm" ng-include="\'app/main/apps/outcomes/views/read/form.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="vm.readView && !vm.showForm" ng-include="\'app/main/apps/outcomes/views/read/question-form.html\'"></div></div>');
$templateCache.put('app/main/apps/outcomes/views/list/split-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.readView && !vm.preview" \nng-include="\'app/main/apps/outcomes/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="100" \nlayout="row"><div class="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" \nid="thread-list" ng-if="!vm.readView && !vm.preview" ng-include="\'app/main/apps/outcomes/views/list/list-view.html\'">\n</div><div class="content thread-detail1 mail-read-pane1" flex="100" id="thread-detail" \nng-include="\'app/main/apps/outcomes/views/edit/edit-view.html\'" ng-style="{\'margin-right\' : vm.edit ? \'0\' : \'-50%\'}">\n</div></div>');
$templateCache.put('app/main/apps/outcomes/views/list/table-view.html','<div class="toolbar" layout="row" layout-align="space-between center" \nng-include="\'app/main/apps/outcome/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row">\n<div class="content thread-list mail-list-pane" flex="100" id="thread-list" \nng-include="\'app/main/apps/outcome/views/list/list-table-view.html\'"></div><div ng-if="!vm.isAccreditations" \nclass="content thread-detail mail-read-pane edit-pane-outcome" id="thread-detail" layout="column" \nng-include="\'app/main/apps/outcome/views/read/read-view.html\'" ng-class="{selected:vm.selectedContent}"></div><div \nng-if="vm.isAccreditations" class="content thread-detail mail-read-pane edit-pane-outcome" id="thread-detail" \nlayout="column" ng-include="\'app/main/apps/outcome/views/read/read-view-accreditations.html\'" \nng-class="{selected:vm.selectedContent}"></div></div>');
$templateCache.put('app/main/apps/outcomes/views/list/toolbar.html','<div layout="row" layout-align="start center"><md-checkbox class="no-label" \naria-label="{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}" \nng-checked="vm.selectedThreads.length > 0" ng-click="vm.toggleSelectThreads(vm.selectedThreads, vm.contents)">\n</md-checkbox><div ng-if="!vm.fromComplaint || vm.userLogued.user_type <= 2" class="divider-vertical" hide="" \nshow-gt-xs=""></div><md-button ng-if="!vm.fromComplaint || vm.userLogued.user_type <= 2" aria-label="NEW" \nclass="md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme" hide show-gt-sm \nng-click="vm.newForm($event)" translate="OUTCOME.NEW" type="button"></md-button><md-button \nng-if="!vm.fromComplaint || vm.userLogued.user_type <= 2" aria-label="NEW" \nclass="md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme z-index-0" hide-gt-sm \nng-click="vm.newForm($event)" type="button"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="divider-vertical" hide="" show-gt-xs=""></div><div aria-hidden="false" \nclass="action-buttons hide show-gt-xs layout-align-start-center layout-row" layout="row" layout-align="start center" \nng-show="vm.selectedThreads.length > 0"><md-button ng-click="vm.deleteOutcome($ev)" aria-label="Delete" \nclass="md-icon-button" hide="" show-gt-xs="" translate=""><md-icon md-font-icon="icon-delete"></md-icon><md-tooltip \nhide show-gt-xs><span translate="GLOBAL.REMOVE"></span></md-tooltip></md-button><div class="divider-vertical" hide="" \nshow-gt-xs=""></div></div><ms-search-bar debounce="300" model-search="$root.pagination_searchquery" \non-result-click="vm.searchResultClick(item)" on-search="vm.search(query)" layout="row" layout-align="start center">\n</ms-search-bar><md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" \ntranslate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nng-if="$root.pagination_searchquery==true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip \nhide show-gt-xs><span>Reset search</span></md-tooltip></md-button><div class="divider-vertical" hide="" show-gt-xs="">\n</div><md-menu hide="" show-gt-xs="" ng-if="refGroupables.length>0"><button aria-label="Filters" \nclass="md-icon-button" ng-click="$mdMenu.open($event)" show-gt-xs="" translate="" \ntranslate-attr-aria-label="GLOBAL.FILTERS"><md-icon md-font-icon="icon-chevron-down"><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.GROUP_BY">Group</span></md-tooltip></md-icon></button><md-menu-content width="4"><md-menu-item \nng-repeat="sortfield in refGroupables"><md-button aria-label="All" ng-click="pagination_setOrderBy(sortfield)"><div \nlayout="row" layout-align="space-between center"><span>Group by {{sortfield.name}} </span><i class="icon-check s16" \nng-if="sortfield.titleId == sortable.titleId"></i></div></md-button></md-menu-item><md-menu-divider ng-if="groupable">\n</md-menu-divider><md-menu-item ng-if="groupable"><md-button aria-label="Remove group" \nng-click="pagination_resetOrderBy()"><md-icon md-font-icon="icon-close "></md-icon><span>Remove order</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div><div layout="row" layout-align="start center" \ntranslate-attr-aria-label="GLOBAL.REFRESH"><md-menu class="settings-menu" hide-gt-xs \nng-show="vm.selectedThreads.length > 0"><md-button aria-label="Settings" class="md-icon-button" \nng-click="$mdMenu.open($event)" translate="GLOBAL.SETTINGS" translate-attr-aria-label="GLOBAL.SETTINGS"><md-icon \nmd-font-icon="icon-dots-horizontal"></md-icon></md-button><md-menu-content><md-menu-item \nng-click="vm.deleteStakeholder($ev)" show="vm.selectedMail.length > 0 || vm.allChecked"><md-button \nng-click="vm.massActions(\'delete\')" aria-label="Delete" translate-aria-label="GLOBAL.DELETE"><md-icon \nmd-font-icon="icon-delete"></md-icon><span translate="GLOBAL.DELETE">Delete</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div>');
$templateCache.put('app/main/apps/outcomes/views/edit/edit-element.html','<div ng-if="vm.fieldEdit || vm.fieldAdd" class="editAdd"><form name="inputForm" class="md-inline-form" novalidate><div \nlayout="row" class="field_edit1"><md-input-container id="inputType"><label translate="OUTCOME.TYPEF"></label><md-select\n ng-model="vm.tipeFields.fieldType"><md-option ng-repeat="typeFi in vm.tipefield" ng-value="typeFi.number"><span>\n{{typeFi.name}}</span></md-option></md-select></md-input-container></div><div layout="row" class="field_edit1">\n<md-input-container id="inputType"><label translate="OUTCOME.ITEM"></label><md-select ng-model="vm.tipeFields.id_item">\n<md-option ng-repeat="typeFiS in vm.items | filter:{type:vm.tipeFields.fieldType} track by $index" \nng-value="typeFiS.id" ng-click="vm.selectFields(typeFiS, $index)"><span>{{typeFiS.name}}</span></md-option><md-option \nng-value="NEW" ng-click="vm.selectFields(\'NEW\', 0)">{{"INPUT.NEW_FIELD" | translate}}</md-option></md-select>\n</md-input-container></div><div layout="row" class="field_edit1" ng-if="vm.nuevo"><md-input-container id="inputNamef">\n<label translate="OUTCOME.NAMEF"></label> <input type="text" ng-model="vm.tipeFields.fieldName" required \nng-disabled="!vm.nuevo"></md-input-container></div><div layout="row" class="field_edit1"><md-input-container flex>\n<label>Valor</label> <input type="number" ng-blur="vm.calculo()" string-to-number ng-model="vm.tipeFields.data" \nid="inputType" maxlength="14" size="14" ng-change="vm.cambio=true" required></md-input-container></div><div \nlayout="column" class="field_edit1" ng-if="vm.nuevo"><md-checkbox ng-model="vm.tipeFields.fieldEdit" \nng-true-value="\'1\'" ng-false-value="\'0\'" ng-change="vm.cambio=true"><label translate="OUTCOME.EDITF"></label>\n</md-checkbox></div><br><md-dialog-actions class="footer" layout="row"><md-input-container flex layout="row" \nlayout-align="end end"><md-button type="button" class="md-raised md-warn" \nng-click="vm.fieldAdd = false; vm.fieldEdit  = false;" translate="OUTCOME.CANCEL">Cancel</md-button><md-button \nng-disabled="!vm.company.outcome" type="submit" class="send-button md-accent md-raised" ng-click="vm.addFields()" \ntranslate="GLOBAL.SAVE">SAVE</md-button><md-button \nng-disabled="!vm.company.outcome || !vm.tipeFields.fieldName || !vm.fieldEdit" type="submit" \nclass="send-button md-accent md-raised" ng-click="vm.deleteFields()" translate="OUTCOME.DELETE">DELETE</md-button>\n</md-input-container></md-dialog-actions></form></div>');
$templateCache.put('app/main/apps/outcomes/views/edit/edit-view.html','<div class="content thread-detail" layout="row" layout-align="center center" flex ng-if="!vm.edit"><div \nclass="no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-google-circles-communities" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="GLOBAL.SELECT_ITEM"></span></div></div><div class="form-wrapper md-whiteframe-1dp without-line" \nng-if="vm.edit"><div ng-if="(vm.staffSelected || vm.staffNew || vm.loadingReadPane)" class="toolbarcolored-bg" \nlayout="row" layout-align="space-between center"></div><div layout="row" layout-align="start center" \nclass="toolbar-colored-bg"><md-button aria-label="Preview" class="md-icon-button" id="accountIcon" translate="" \nng-click="vm.tabActive = \'preview\';vm.fieldAdd = false;vm.fieldEdit = false;" \ntranslate-attr-aria-label="INPUT.PREVIEW" ng-class="{\'tab-selected\': vm.tabActive==\'preview\'}"><md-icon \nmd-font-icon="icon-eye"></md-icon><md-tooltip hide show-gt-sm><span translate="INPUT.PREVIEW">Preview</span>\n</md-tooltip></md-button><div class="divider-vertical" hide="" show-gt-sm=""></div><md-button aria-label="Edit" \nclass="md-icon-button" id="accountIcon" translate="" \nng-click="vm.tabActive = \'edit\';vm.fieldAdd = false;vm.fieldEdit = false;" translate-attr-aria-label="STAFF.EDIT" \nng-class="{\'tab-selected\': vm.tabActive==\'preview\' || vm.tabActive==\'editnew\' || vm.tabActive==\'edit\'}"><md-icon \nmd-font-icon="icon-pencil"></md-icon><md-tooltip hide show-gt-sm><span translate="STAFF.EDIT">Edit</span></md-tooltip>\n</md-button><div class="divider-vertical" hide="" show-gt-sm=""></div><md-button aria-label="Menu" \nclass="md-icon-button" translate="" ng-click="vm.tabActive = \'json\'" translate-attr-aria-label="USERS.COMPANIES" \nng-class="{\'tab-selected\': vm.tabActive==\'json\'}" ng-disabled="!vm.company.outcome_structure"><md-icon \nmd-font-icon="icon-calculator"></md-icon><md-tooltip hide show-gt-sm><span translate="INPUT.JSON">JSON</span>\n</md-tooltip></md-button><md-input-container flex layout="row" layout-align="end center"><md-button type="button" \nclass="md-raised md-warn" ng-click="vm.closeDialog()" translate="RISKCONFIG.CANCEL">Cancel</md-button><md-button \nng-if="vm.tabActive != \'preview\'" ng-disabled="!vm.company.outcome || !vm.company.stakeholder_id" type="submit" \nclass="send-button md-accent md-raised" ng-click="vm.calculo();vm.calculoAnual();vm.saveDialog(vm.company, $event)" \ntranslate="GLOBAL.SAVE">ADD</md-button></md-input-container></div></div><div ng-if="vm.tabActive==\'preview\'" \nclass="content1 thread-detail mail-read-pane" ms-scroll><div><md-list class="p0" role="list"><div><md-list-item \nclass="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 class="grey-700.fg" translate="OUTCOME.PROYECT_NAME">\nStakeholder name</h3><md-divider></md-divider></md-list-item></div></md-list></div><div><md-list-item \nng-if="state.id === vm.company.stakeholder_id" ng-repeat="state in vm.stakeholder" flex="100" role="listitem" \nclass="md-no-proxy"><div class="text-truncate" flex="100"><div class="field"><span class="font-size-16">\n{{state.stakeholder}}</span></div><md-divider></md-divider></div></md-list-item></div><div><md-list class="p0" \nrole="list"><div><md-list-item class="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 class="grey-700.fg" \ntranslate="OUTCOME.OUTCOME_NAME">Outcome name</h3><md-divider></md-divider></md-list-item></div></md-list></div><div>\n<md-list-item flex="100" role="listitem" class="md-no-proxy"><div class="text-truncate" flex="100"><div class="field">\n<span class="font-size-16">{{vm.company.outcome}}</span></div><md-divider></md-divider></div></md-list-item></div><div>\n<md-list class="p0" role="list"><div><md-list-item class="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 \nclass="grey-700.fg" translate="INPUT.CONTRIBUTION_YEARS">Years of contribution</h3><md-divider></md-divider>\n</md-list-item></div></md-list></div><div><md-list-item flex="100" role="listitem" class="md-no-proxy"><div \nclass="text-truncate" flex="100"><div class="field"><span class="font-size-16">{{vm.company.years_input}}</span></div>\n<md-divider></md-divider></div></md-list-item></div><div><md-list class="p0" role="list"><div><md-list-item \nclass="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 class="grey-700.fg" translate="OUTCOME.DESCRIPTION">\nDescription</h3><md-divider></md-divider></md-list-item></div></md-list></div><div><md-list-item \nng-if="vm.company.description_outcome" flex="100" role="listitem"><div><div><br><span class="font-size-161">\n{{vm.company.description_outcome}}</span></div><md-divider></md-divider><br></div></md-list-item><md-list-item \nng-if="!vm.company.description_outcome" flex="100" role="listitem" class="md-no-proxy"><div class="text-truncate" \nflex="100"><div class="field"><span class="font-size-16">-</span></div><md-divider></md-divider></div></md-list-item>\n</div><div><md-list class="p0" role="list"><div><md-list-item class="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 \nclass="grey-700.fg" translate="OUTCOME.OBSERVATION">Description</h3><md-divider></md-divider></md-list-item></div>\n</md-list></div><div><md-list-item ng-if="vm.company.comments" flex="100" role="listitem" class="md-no-proxy"><div \nclass="text-truncate1" flex="100"><div class="font-size-161"><br><span class="font-size-16">{{vm.company.comments}}\n</span></div><md-divider></md-divider><br></div></md-list-item><md-list-item ng-if="!vm.company.comments" flex="100" \nrole="listitem" class="md-no-proxy"><div class="text-truncate" flex="100"><div class="field"><span \nclass="font-size-16">-</span></div><md-divider></md-divider></div></md-list-item></div><div><md-list class="p0" \nrole="list"><div><md-list-item class="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 class="grey-700.fg" \ntranslate="OUTCOME.DEAD_WEIGHT">Years of contribution</h3><md-divider></md-divider></md-list-item></div></md-list>\n</div><div><md-list-item flex="100" role="listitem" class="md-no-proxy"><div class="text-truncate" flex="100"><div \nclass="field"><span class="font-size-16">{{vm.company.dead_weight}}</span></div><md-divider></md-divider></div>\n</md-list-item></div><div><md-list class="p0" role="list"><div><md-list-item \nclass="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 class="grey-700.fg" translate="OUTCOME.DISPLACEMENT">\nYears of contribution</h3><md-divider></md-divider></md-list-item></div></md-list></div><div><md-list-item flex="100" \nrole="listitem" class="md-no-proxy"><div class="text-truncate" flex="100"><div class="field"><span \nclass="font-size-16">{{vm.company.displacement}}</span></div><md-divider></md-divider></div></md-list-item></div><div>\n<md-list class="p0" role="list"><div><md-list-item class="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 \nclass="grey-700.fg" translate="OUTCOME.ATRIBUTTION">Years of contribution</h3><md-divider></md-divider></md-list-item>\n</div></md-list></div><div><md-list-item flex="100" role="listitem" class="md-no-proxy"><div class="text-truncate" \nflex="100"><div class="field"><span class="font-size-16">{{vm.company.attribution}}</span></div><md-divider>\n</md-divider></div></md-list-item></div><div><md-list class="p0" role="list"><div><md-list-item \nclass="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 class="grey-700.fg" translate="OUTCOME.DECREASE">\nYears of contribution</h3><md-divider></md-divider></md-list-item></div></md-list></div><div><md-list-item flex="100" \nrole="listitem" class="md-no-proxy"><div class="text-truncate" flex="100"><div class="field"><span \nclass="font-size-16">{{vm.company.decrease}}</span></div><md-divider></md-divider></div></md-list-item></div><div>\n<md-list class="p0" role="list"><div><md-list-item class="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 \nclass="grey-700.fg" translate="OUTCOME.CALCULATION">Calc</h3><md-divider></md-divider></md-list-item></div></md-list>\n</div><div><md-list-item flex="100" role="listitem" class="md-no-proxy"><div class="text-truncate" flex="100"><div \nlayout="row" class="input-data-container field"><p class="grey-500-fg font-size-16" translate="INPUT.CALCULATIONT">\ncalculo</p><span class="font-size-16">{{vm.company.result | currency:symbolMoney:2}}</span></div><md-divider>\n</md-divider></div></md-list-item></div><div><md-list class="p0" role="list"><div><md-list-item \nclass="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 class="grey-700.fg" translate="OUTCOME.SUBCALCULATION">Calc\n</h3><md-divider></md-divider></md-list-item></div></md-list></div><div><md-list-item flex="100" role="listitem" \nclass="md-no-proxy"><div class="text-truncate" flex="100"><div layout="row" class="input-data-container field"><p \nclass="grey-500-fg font-size-16" translate="INPUT.SUBCALCULATIONT">calculo</p><span class="font-size-16">\n{{vm.company.outcome_structure.calculation | currency:symbolMoney:2}}</span></div><md-divider></md-divider></div>\n</md-list-item></div><div><md-list-item ng-repeat="outcomes in vm.company.outcome_structure.outcomes" flex="100" \nrole="listitem" class="md-no-proxy"><div class="text-truncate" flex="100"><div class="input-data-container" \nlayout="row" class="field"><p class="grey-500-fg font-size-16 text-truncate" ng-bind="outcomes.fieldName"></p><span \nclass="font-size-16">{{outcomes.data | currency:symbolMoney:2}}</span></div><md-divider></md-divider></div>\n</md-list-item></div><div><md-list-item flex="100" role="listitem" class="md-no-proxy"><div class="text-truncate" \nflex="100"><div layout="row" class="input-data-container field"><p class="grey-500-fg font-size-16">calculo</p><span \nclass="font-size-16">{{vm.company.outcome_structure.calculation | currency:symbolMoney:2}}</span></div><md-divider>\n</md-divider></div></md-list-item></div><div><md-list-item flex="100" role="listitem" class="md-no-proxy"><div \nclass="text-truncate" flex="100"><div layout="row" class="input-data-container field"><p \nclass="grey-500-fg font-size-16">calculo</p><span class="font-size-16">\n{{vm.company.outcome_structure.calculation | currency:symbolMoney:2}}</span></div><md-divider></md-divider></div>\n</md-list-item></div></div><div id="tab-edit-container" ng-if="vm.tabActive==\'edit\'" \nclass="content1 thread-detail mail-read-pane" ms-scroll><div><md-list class="p0" role="list"><div><md-list-item \nclass="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 class="grey-700.fg" translate="OUTCOME.PROYECT_NAME">\nStakeholder name</h3><md-divider></md-divider></md-list-item></div></md-list></div><div><md-list-item flex="100" \nrole="listitem" class="md-no-proxy"><div class="text-truncate" flex="100"><div class="field"><md-input-container \nflex="100"><md-select ng-model="vm.company.stakeholder_id"><md-option translate="OUTCOME.NONE"></md-option><md-option \nng-repeat="state in vm.stakeholder" ng-value="state.id" ng-if="state.output==\'1\'"><span class="font-size-16">\n{{state.stakeholder}}</span></md-option></md-select></md-input-container></div><md-divider></md-divider></div>\n</md-list-item></div><div><md-list class="p0" role="list"><div><md-list-item \nclass="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 class="grey-700.fg" translate="OUTCOME.OUTCOME_NAME">\nOutcome name</h3><md-divider></md-divider></md-list-item></div></md-list></div><div><md-list-item flex="100" \nrole="listitem" class="md-no-proxy"><div class="text-truncate" flex="100"><div class="field"><md-input-container \nflex="100"><input class="font-size-16" type="text" maxlength="50" ng-model="vm.company.outcome" required>\n</md-input-container></div><md-divider></md-divider></div></md-list-item></div><div><md-list class="p0" role="list">\n<div><md-list-item class="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 class="grey-700.fg" \ntranslate="OUTCOME.CONTRIBUTION_YEARS">Years of Input</h3><md-divider></md-divider></md-list-item></div></md-list>\n</div><div><md-list-item flex="100" role="listitem" class="md-no-proxy"><div class="text-truncate" flex="100"><div \nclass="field"><md-input-container flex="100"><input class="font-size-16" type="number" string-to-number \nng-model="vm.company.years_input" required></md-input-container></div><md-divider></md-divider></div></md-list-item>\n</div><div><md-list class="p0" role="list"><div><md-list-item class="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 \nclass="grey-700.fg" translate="OUTCOME.DESCRIPTION">Description</h3><md-divider></md-divider></md-list-item></div>\n</md-list></div><div><div><div><br><textarea class="font-size-162" ng-model="vm.company.description_outcome">\n</textarea><md-divider></md-divider></div></div><br></div><div><md-list class="p0" role="list"><div><md-list-item \nclass="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 class="grey-700.fg" translate="OUTCOME.OBSERVATION">\nObservacion</h3><md-divider></md-divider></md-list-item></div></md-list></div><div><div><div><br><textarea \nclass="font-size-162" ng-model="vm.company.comments"></textarea><md-divider></md-divider></div></div><br></div><div>\n<md-list class="p0" role="list"><div><md-list-item class="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 \nclass="grey-700.fg" translate="OUTCOME.DEAD_WEIGHT">PesoMuerto</h3><md-divider></md-divider></md-list-item></div>\n</md-list></div><div><md-list-item flex="100" role="listitem" class="md-no-proxy"><div class="text-truncate" \nflex="100"><div class="field"><md-input-container flex="100"><input class="font-size-16" type="number" \nstring-to-number ng-model="vm.company.dead_weight"></md-input-container></div><md-divider></md-divider></div>\n</md-list-item></div><div><md-list class="p0" role="list"><div><md-list-item \nclass="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 class="grey-700.fg" translate="OUTCOME.DISPLACEMENT">\nDesplazamiento</h3><md-divider></md-divider></md-list-item></div></md-list></div><div><md-list-item flex="100" \nrole="listitem" class="md-no-proxy"><div class="text-truncate" flex="100"><div class="field"><md-input-container \nflex="100"><input class="font-size-16" type="number" string-to-number ng-model="vm.company.displacement">\n</md-input-container></div><md-divider></md-divider></div></md-list-item></div><div><md-list class="p0" role="list">\n<div><md-list-item class="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 class="grey-700.fg" \ntranslate="OUTCOME.ATRIBUTTION">Atribucion</h3><md-divider></md-divider></md-list-item></div></md-list></div><div>\n<md-list-item flex="100" role="listitem" class="md-no-proxy"><div class="text-truncate" flex="100"><div class="field">\n<md-input-container flex="100"><input class="font-size-16" type="number" string-to-number \nng-model="vm.company.attribution"></md-input-container></div><md-divider></md-divider></div></md-list-item></div><div>\n<md-list class="p0" role="list"><div><md-list-item class="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 \nclass="grey-700.fg" translate="OUTCOME.DECREASE">Decrecimiento</h3><md-divider></md-divider></md-list-item></div>\n</md-list></div><div><md-list-item flex="100" role="listitem" class="md-no-proxy"><div class="text-truncate" \nflex="100"><div class="field"><md-input-container flex="100"><input class="font-size-16" type="number" \nstring-to-number ng-model="vm.company.decrease"></md-input-container></div><md-divider></md-divider></div>\n</md-list-item></div><div><md-list class="p0" role="list"><div><md-list-item \nclass="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 class="grey-700.fg" translate="OUTCOME.SUBCALCULATION">Calc\n</h3><md-divider></md-divider></md-list-item></div></md-list></div><div><md-list-item \nng-repeat="outcomes in vm.company.outcome_structure.outcomes" flex="100" role="listitem" class="md-no-proxy"><div \nclass="text-truncate" flex="100"><div class="input-data-container" layout="row" class="field"><p \nclass="grey-500-fg font-size-16 text-truncate" ng-bind="outcomes.fieldName"></p><md-input-container flex="100" \nclass="md-input-has-value"><input ng-disabled="outcomes.fieldEdit==0" maxlength="14" class="font-size-16" \ntype="number" string-to-number ng-model="outcomes.data" ng-change="vm.isSelectedField(outcomes)"></md-input-container>\n</div><md-divider></md-divider></div></md-list-item></div><div><md-list-item flex="100" role="listitem" \nclass="md-no-proxy"><div class="text-truncate" flex="100"><div layout="row" class="input-data-container field"><p \nclass="grey-500-fg font-size-16">calculo</p><span class="font-size-16">\n{{vm.company.outcome_structure.calculation | currency:symbolMoney:2}}</span></div><md-divider></md-divider></div>\n</md-list-item></div><div><md-list-item flex="100" role="listitem" class="md-no-proxy"><div class="text-truncate" \nflex="100"><div layout="row" class="input-data-container field"><p class="grey-500-fg font-size-16">calculo</p><span \nclass="font-size-16">{{vm.company.outcome_structure.calculation | currency:symbolMoney:2}}</span></div><md-divider>\n</md-divider></div></md-list-item></div></div><div id="input-form-container" layout="column" \nng-if="vm.tabActive==\'json\'"><div layout="row" layout-align="start start"><label translate="OUTCOME.FORMULA"></label>\n<span>:</span></div><div class="inputseditfield" dragula=\'"dragbagFormula"\' \ndragula-model="vm.company.outcome_structure.formula" layout="row"><div class="inputsDetailOperator" layout="row" \nng-repeat="elemen in vm.company.outcome_structure.formula track by $index" ng-init="parentIndex = $index" md-no-ink>\n<div layout="row" layout-align="start start"><div class="nameOperator" layout="row" layout-align="start start"><span>\n<b>{{elemen}}</b></span></div><div class="iconDelete" layout="row" layout-align="start start" \nng-click="vm.index = $index;vm.deleteOperator()"><md-icon md-font-icon="icon-close" ng-click="vm.deleteOperator">\n</md-icon></div></div></div></div><div layout="row" id="add-operator-container"><div id="selector-container" \nlayout="row" layout-align="start start" ng-if="vm.addelement && !vm.editelement"><md-input-container><label \ntranslate="OUTCOME.SELECT_OPERAND"></label><md-select ng-model="vm.element" ng-change="vm.addOperator()" \nclass="mySelect"><md-optgroup label="Operandos"><md-option \nng-repeat="state in vm.company.outcome_structure.outcomes track by $index" ng-value="state.fieldName" \nng-click="vm.selectOp = $index"><span>{{state.fieldName}}</span></md-option></md-optgroup></md-select>\n</md-input-container><md-input-container><button label="Operator" ng-click="vm.selectOp = $index; vm.addOperator()" \nng-repeat="operador in vm.operator track by $index">{{operador}}</button></md-input-container><div class="iconDelete" \nlayout="row" layout-align="start start" ng-click="vm.selectOp = \'exit\'; vm.addOperator();"><md-icon \nmd-font-icon="icon-close"></md-icon></div></div><div layout="row" layout-align="center" class="button-container" \nng-if="!vm.addelement && !vm.editelement"><md-button type="submit" class="send-button md-accent md-raised" \nng-click="vm.addOpeField();" translate="OUTCOME.ADDELEMENT" \nng-disabled="!vm.company.outcome || !vm.company.stakeholder_id">ADD</md-button></div></div><div class="lineaCF"></div>\n<div class="content thread-detail mail-read-pane scrollable p0" flex="" id="" ng-if="vm.fieldEdit || vm.fieldAdd" \nms-scroll="vm.msScrollOptions" ng-include="\'app/main/apps/outcomes/views/edit/edit-element.html\'"></div><div \nclass="mb-1001" layout="row" layout-align="end center"><md-button aria-label="Add event" \nclass="add-event-button no-sort md-fab md-warn block m-25" translate="" ng-click="vm.clearFields()" \ntranslate-attr-aria-label="USERS.COMPANIES1" ng-class="{\'tab-selected\': vm.tabActive==\'json1\'}"><md-icon \nmd-font-icon="icon-plus"></md-icon><md-tooltip hide show-gt-sm><span translate="OUTCOME.ADDJSON">JSON</span>\n</md-tooltip></md-button></div><div dragula=\'"dragbag"\' dragula-model="vm.company.outcome_structure.outcomes"><div \nng-repeat="outcomes in vm.company.outcome_structure.outcomes track by $index" ng-init="parentIndex = $index" md-no-ink \nng-click="vm.editFields(outcomes, $index)"><div layout="row" layout-align="space-between center" \nng-if="!vm.fieldEdit && !vm.fieldAdd"><div class="nametext" layout="row" layout-align="start center"><md-icon \nmd-font-icon="icon-drag"></md-icon><span>{{outcomes.fieldName}}</span></div><div class="namenumber" layout="row" \nlayout-align="start center"><span>{{outcomes.data | currency:"":2 }}</span></div></div><hr width="100%" \nng-if="!vm.fieldEdit && !vm.fieldAdd"></div></div></div>');
$templateCache.put('app/main/apps/outcomes/views/read/form.html','<div id="forms" class="page-layout simple fullwidth doc-page forms" layout="column"><div class="p0" layout="column">\n<div layout="row"><ms-form-wizard class="no-margin" flex><div layout="row" layout-align="start center" flex="100" \nclass="layout-align-start-center layout-row flex-100 toolbar grey-100-bg colored-bg" ng-if="vm.idCompany"><a \nclass="pointer" ng-click="vm.closeForm()"><md-icon md-font-icon="icon-chevron-left"></md-icon></a><div \nclass="avatar-wrapper"><md-icon md-font-icon="icon-city"></md-icon></div><div class="field mr-10 ml-10 flex" flex="">\n<strong class="grey-800-fg ng-binding" ng-bind-html="vm.formWizard.company.name"></strong></div></div><md-tabs \nclass="height-tabs" md-dynamic-height md-selected="msWizard.selectedIndex" md-center-tabs="true"><md-tab><md-tab-label>\n<span class="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 0">1</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 0"><i class="icon-checkbox-blank-circle s16"></i> </span><span \nclass="ms-form-wizard-step-text" translate="GLOBAL.COMPANY_DATA"></span></span></md-tab-label><md-tab-body><form \nname="wizardStep1" ng-include="\'app/main/apps/clients/views/read/form-tabs/step-company.html\'" ms-form-wizard-form \nnovalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.idCompany"><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 1">2</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 1"><i class="icon-checkbox-blank-circle s16"></i> </span><span \nclass="ms-form-wizard-step-text" translate="CLIENTS.OPTIONS"></span></span></md-tab-label><md-tab-body><form \nname="wizardStep1b" ng-include="\'app/main/apps/clients/views/read/form-tabs/step-options.html\'" ms-form-wizard-form \nnovalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.idCompany"><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 2">3</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 2"><i class="icon-checkbox-blank-circle s16"></i> </span><span \nclass="ms-form-wizard-step-text" translate="GLOBAL.FILIATION_DATA"></span></span></md-tab-label><md-tab-body><div \nclass="navigation white-bg mb-50" flex layout="row" layout-align="center center"><div layout="row" flex \nlayout-align="start center"><md-button ng-if="vm.showForm" translate="GLOBAL.CLOSE" type="button" \nng-click="vm.closeForm()" class="md-raised md-warn hide-xs" aria-label="Cancel"></md-button><md-button \nng-if="vm.idCompany" translate="GLOBAL.SAVE" class="md-raised md-accent" ng-click="vm.nextStep(msWizard, true);" \nng-hide="msWizard.isLastStep()" ng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button></div><div \nclass="ml-auto" layout="row" flex layout-align="end center"><div flex layout="column" layout-align="center center" \nlayout-padding layout-margin ng-if="vm.loadingStep" class="loading-container"><md-progress-circular \nmd-mode="indeterminate" md-diameter="30"></md-progress-circular></div><md-button translate="GLOBAL.PREVIOUS" \nclass="md-raised md-accent" ng-click="vm.prevStep(msWizard)" ng-disabled="vm.previousStep(msWizard) || vm.loadingStep">\n</md-button><div class="steps"><span ng-repeat="form in msWizard.forms" \nng-class="{\'selected md-accent-bg\':msWizard.selectedIndex === $index}"></span></div><md-button translate="GLOBAL.NEXT" \nclass="md-raised md-accent" ng-click="vm.nextStep(msWizard)" ng-hide="msWizard.isLastStep()" \nng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button><md-button translate="GLOBAL.FINISH" \nclass="md-raised md-warn" ng-click="vm.sendForm(); msWizard.resetForm();" ng-show="msWizard.isLastStep()" \nng-disabled="msWizard.formsIncomplete()"></md-button></div></div><form name="wizardStep2" \nng-include="\'app/main/apps/clients/views/read/form-tabs/step-branchs.html\'" class="md-inline-form" ms-form-wizard-form \nnovalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.formWizard.main_branch.id"><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 3">4</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 3"><i class="icon-checkbox-blank-circle s16"></i> </span><span \ntranslate="GLOBAL.COMPLIANCE_COMMITTEE" class="ms-form-wizard-step-text"></span></span></md-tab-label><md-tab-body>\n<form ng-include="\'app/main/apps/clients/views/read/form-tabs/step-people.html\'" name="wizardStep3" \nms-form-wizard-form novalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.formWizard.main_branch.id">\n<md-tab-label><span class="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 4">5</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 4"><i class="icon-checkbox-blank-circle s16"></i> </span><span \ntranslate="GLOBAL.BRANCH_PERSONNEL" class="ms-form-wizard-step-text"></span></span></md-tab-label><md-tab-body><form \nng-include="\'app/main/apps/clients/views/read/form-tabs/step-people-global.html\'" name="wizardStep4" \nms-form-wizard-form novalidate></form></md-tab-body></md-tab></md-tabs><div \nclass="navigation white-bg border-top mb-50" flex layout="row" layout-align="center center"><div layout="row" flex \nlayout-align="start center"><md-button hide-xs ng-if="vm.showForm" translate="GLOBAL.CLOSE" type="button" \nng-click="vm.closeForm()" class="md-raised md-warn hide-xs" aria-label="Cancel"></md-button><md-button \nng-if="vm.idCompany" translate="GLOBAL.SAVE" class="md-raised md-accent" ng-click="vm.nextStep(msWizard, true);" \nng-hide="msWizard.isLastStep()" ng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button></div><div \nclass="ml-auto" layout="row" flex layout-align="end center"><div flex layout="column" layout-align="center center" \nlayout-padding layout-margin ng-if="vm.loadingStep" class="loading-container"><md-progress-circular \nmd-mode="indeterminate" md-diameter="30"></md-progress-circular></div><md-button translate="GLOBAL.PREVIOUS" \nclass="md-raised md-accent" ng-click="vm.prevStep(msWizard)" ng-disabled="vm.previousStep(msWizard) || vm.loadingStep">\n</md-button><div class="steps"><span ng-repeat="form in msWizard.forms" \nng-class="{\'selected md-accent-bg\':msWizard.selectedIndex === $index}"></span></div><md-button translate="GLOBAL.NEXT" \nclass="md-raised md-accent" ng-click="vm.nextStep(msWizard)" ng-hide="msWizard.isLastStep()" \nng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button><md-button translate="GLOBAL.FINISH" \nclass="md-raised md-warn" ng-click="vm.sendForm(); msWizard.resetForm();" ng-show="msWizard.isLastStep()" \nng-disabled="msWizard.formsIncomplete()"></md-button></div></div><div class="navigation" flex layout="row" \nlayout-align="center center"><md-button hide-xs ng-if="vm.showForm" translate="GLOBAL.CANCEL" type="button" \nng-click="vm.closeForm()" class="md-raised md-warn show-xs" aria-label="Cancel"></md-button></div></ms-form-wizard>\n</div></div></div>');
$templateCache.put('app/main/apps/outcomes/views/read/preview-company.html','<div hide show-gt-sm class="toolbar grey-100-bg colored-bg" layout="row" layout-align="space-between center" scroll="">\n<div layout="row" layout-align="start center"><a class="pointer" ng-click="vm.goClients()"><md-icon \nmd-font-icon="icon-chevron-left"></md-icon></a><h2 translate="GLOBAL.COMPANY_DATA"></h2></div></div><div \nclass="md-whiteframe-1dp without-line scrollable preview" flex="100"><form name="vm.basicForm" class="md-inline-form" \nnovalidate><md-input-container class="md-block bb logotype"><img \nngf-thumbnail="!image.$error && image && vm.logoIsLoaded" class="img"> <img \nng-if="!image && imageUrl && vm.logoIsLoaded" src="{{imageUrl}}" class="img"><div \nng-if="!image && !imageUrl && vm.logoIsLoaded" class="avatar img" \nng-bind="vm.formWizard.company.name | capitalizeFirstLetter" ms-random-class="vm.colors"></div><h5 \nclass="padding inline-block m0">{{vm.formWizard.company.name}}</h5></md-input-container><md-input-container \nclass="md-block bb"><label>{{vm.getRegionLiteral(\'tax_ic_number\')}}</label><h5 class="padding">\n{{vm.formWizard.company.tax_id_number}}</h5></md-input-container><md-input-container class="md-block mg-bttm"><label \ntranslate="GLOBAL.SECTOR"></label><h5 class="padding">{{vm.getSectorById(vm.formWizard.company.sector_id).name}}</h5>\n</md-input-container><md-input-container class="md-block border separator mb-30"><h2 class="title" \ntranslate="CLIENTS.OPTIONS"></h2></md-input-container><md-input-container ng-if="vm.formWizard.company.description" \nclass="md-block bb options-preview"><label class="options-preview" translate="GLOBAL.DESCRIPTION"></label><h5 \nclass="padding mv-10">{{vm.formWizard.company.description}}</h5></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.executives_type" class="md-block bb mb-0 options-preview-select"><label \ntranslate="GLOBAL.EXECUTIVE_TYPE"></label><md-select class="disabled" ng-disabled="true" \nng-model="vm.formWizard.company.extra_data.executives_type"><md-option ng-value="1">Accionista \xFAnico</md-option>\n<md-option ng-value="2">Varios accionistas</md-option><md-option ng-value="3">Consejo de administraci\xF3n</md-option>\n<md-option ng-value="4">Administrador \xFAnico</md-option><md-option ng-value="5">Otros</md-option></md-select>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.capital" \nclass="md-block bb mb-0 options-preview-select"><label translate="GLOBAL.SOCIAL_CAPITAL"></label><md-select \nclass="disabled" ng-disabled="true" ng-model="vm.formWizard.company.extra_data.capital"><md-option ng-value="1">Capital\n</md-option><md-option ng-value="2">Aportaciones de socios</md-option><md-option ng-value="3">\nAumentos de capital recientes</md-option></md-select></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.capital_amount" class="md-block bb m0 options-preview"><label \nclass="options-preview" translate="GLOBAL.AMOUNT_CAPITAL"></label><h5 class="padding mv-10">\n{{vm.formWizard.company.extra_data.capital_amount}}</h5></md-input-container><md-input-container \nng-if="vm.formWizard.company.turnover_volume" class="md-block bb m0 options-preview"><label class="options-preview" \ntranslate="GLOBAL.BILLING_LAST_YEAR"></label><h5 class="padding mv-10">{{vm.formWizard.company.turnover_volume}}</h5>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.tax_options" \nclass="md-block bb mb-0 options-preview-select"><label>IVA</label><md-select class="disabled" ng-disabled="true" \nng-model="vm.formWizard.company.extra_data.tax_options"><md-option ng-value="1">Presentaci\xF3n trimestral</md-option>\n<md-option ng-value="2">Presentaci\xF3n mensual</md-option></md-select></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.annual_accounts" class="md-block bb mb-0 options-preview-select"><label>\nCuentas anuales</label><md-select class="disabled" ng-disabled="true" \nng-model="vm.formWizard.company.extra_data.annual_accounts"><md-option ng-value="1">Abreviadas</md-option><md-option \nng-value="2">Normales</md-option><md-option ng-value="3">Pymes</md-option><md-option ng-value="4">Mixtas</md-option>\n</md-select></md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.extra_data" \nclass="md-block bb mb-0 options-preview-select"><label>Auditor\xEDas</label><md-select class="disabled" \nng-disabled="true" ng-model="vm.formWizard.company.extra_data.audits"><md-option ng-value="1">Internas</md-option>\n<md-option ng-value="2">Externas</md-option><md-option ng-value="3">No aplica</md-option></md-select>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.iso_certification" \nclass="md-block bb mb-0 options-preview-select"><label>Certificaciones ISO</label><md-select class="disabled" \nng-disabled="true" ng-model="vm.formWizard.company.extra_data.iso_certification"><md-option ng-value="1">ISO 9001\n</md-option><md-option ng-value="2">ISO 14000</md-option><md-option ng-value="3">ISO 14001</md-option><md-option \nng-value="4">ISO 19600</md-option><md-option ng-value="5">ISO 22000</md-option><md-option ng-value="6">ISO 26000\n</md-option><md-option ng-value="7">ISO 27001</md-option><md-option ng-value="8">ISO 37001</md-option><md-option \nng-value="9">OHSAS 18001</md-option></md-select></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.collective_agreement" class="md-block bb m0 options-preview"><label \nclass="options-preview">Convenio Colectivo Aplicable</label><h5 class="padding mv-10">\n{{vm.formWizard.company.extra_data.collective_agreement}}</h5></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.insurance" class="md-block bb m0 options-preview"><label \nclass="options-preview">Seguros contratados</label><h5 class="padding mv-10">\n{{vm.formWizard.company.extra_data.insurance}}</h5></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.cnae" class="md-block bb m0 options-preview"><label class="options-preview" \ntranslate="GLOBAL.CNAE"></label><h5 class="padding mv-10">{{vm.formWizard.company.extra_data.cnae}}</h5>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.financing.length> 0" \nclass="md-block bb mb-0 options-preview-select"><label class="ph-15" fill-width translate="GLOBAL.FINANCING"></label>\n<md-select class="disabled" ng-disabled="true" multiple="{{false}}" \nng-model="vm.formWizard.company.extra_data.financing"><md-option ng-repeat="option in vm.financing_options" \nng-value="option">{{option.name}}</md-option></md-select></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.sector_regulations.length> 0" class="md-block bb mb-0 options-preview-select">\n<label class="ph-15" fill-width>Normativa Sectorial aplicable</label><md-select class="disabled" ng-disabled="true" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.sector_regulations"><md-option \nng-repeat="option in vm.sector_regulations_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.implemented_measures.length> 0" \nclass="md-block bb mb-20 options-preview-select"><label class="ph-15" fill-width>Medidas implementadas</label>\n<md-select class="disabled" ng-disabled="true" multiple="{{false}}" \nng-model="vm.formWizard.company.extra_data.implemented_measures"><md-option \nng-repeat="option in vm.implemented_measures_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container><md-input-container class="md-block border separator"><h2 class="title" \ntranslate="GLOBAL.MAIN_BRANCH"></h2></md-input-container><md-input-container class="md-block bb"><label \ntranslate="GLOBAL.NAME"></label><h5 class="padding">{{vm.formWizard.main_branch.name}}</h5></md-input-container>\n<md-input-container class="md-block bb"><label translate="GLOBAL.ADDRESS"></label><h5 class="padding">\n{{vm.formWizard.main_branch.address1}}</h5></md-input-container><md-input-container class="md-block bb"><label>\n{{vm.getRegionLiteral(\'city\')}}</label><h5 class="padding">{{vm.formWizard.main_branch.city}}</h5></md-input-container>\n<md-input-container class="md-block border separator"><h2 class="title" translate="GLOBAL.BRANCH"></h2>\n</md-input-container><div class="mail-list-pane s0" ng-if="vm.formWizard.branches && vm.formWizard.branches.length> 0">\n<div class="items" ng-repeat="branch in vm.formWizard.branches track by $index"><div layout="row" \nlayout-align="start center" flex="100" class="p-20 layout-align-start-center layout-row flex-100"><div layout="row" \nlayout-align="start center" flex="100" class="layout-align-start-center layout-row flex-100"><div \nclass="avatar-wrapper"><md-icon md-font-icon="icon-city"></md-icon></div><div class="field mr-10 ml-10 flex" flex="">\n<strong class="grey-800-fg ng-binding" ng-bind-html="branch.name"></strong><div class="field grey-600-fg ng-binding">\n<span ng-if="branch.city" ng-bind-html="branch.city"></span> <span ng-if="branch.city && branch.state">, </span><span \nng-if="branch.state" ng-bind-html="branch.state"></span></div></div></div></div></div></div></form></div>');
$templateCache.put('app/main/apps/outcomes/views/read/preview-structure.html','<div hide show-gt-sm class="toolbar grey-100-bg colored-bg" layout="row" layout-align="space-between center" scroll="">\n<div layout="row" layout-align="start center"><h2>Organizaci\xF3n de la compa\xF1\xEDa</h2></div><div layout="row" \nlayout-align="end center" hide show-gt-sm><md-button translate="GLOBAL.EDIT" type="button" ng-click="vm.editCompany()" \nclass="md-raised md-accent" aria-label="Edit"></md-button></div><div layout="row" layout-align="end center" hide-gt-sm>\n<md-button type="button" ng-click="vm.editClient()" \nclass="md-accent md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" aria-label="Edit"><md-icon \nmd-font-icon="icon-plus"></md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.EDIT"></span></md-tooltip>\n</md-button></div></div><div class="without-line scrollable preview" flex="100"><div ivh-treeview="vm.tree" \nivh-treeview-options="vm.ivhOptions" class="treeview" \nivh-treeview-on-cb-change="vm.callback(ivhNode, ivhIsSelected, ivhTree)"><script type="text/ng-template">\n<div class="level-card" ng-if="node.type != \'user\'">\n                    <span ivh-treeview-toggle>\n                        <span ivh-treeview-twistie></span>\n                    </span>\n                    <md-icon md-font-icon="icon-city" ng-if="node.type == \'branch\'"></md-icon>\n                    <md-icon md-font-icon="icon-folder-account" ng-if="node.type == \'division\'"></md-icon>\n                    <md-icon md-font-icon="icon-worker" ng-if="node.type == \'job_position\'"></md-icon>\n                    <span class="ivh-treeview-node-label" ivh-treeview-toggle>{{trvw.label(node)}}</span>\n                </div>\n                <div class="level-card" ng-if="node.type == \'user\'">\n                    <div layout="row" layout-align="start center" flex="100">\n                        <div class="avatar-wrapper">\n                            <user-avatar User="node.user"/>\n                        </div>\n                        <div class="field mr-5 ml-5" flex>\n                            <strong class="grey-800-fg" ng-bind-html="node.user.first_name + \' \' + node.user.last_name"></strong>\n                        </div>\n                    </div>\n                </div>\n                <div ivh-treeview-children></div>\n</script></div></div>');
$templateCache.put('app/main/apps/outcomes/views/read/question-form.html','<div id="forms" class="page-layout simple fullwidth doc-page forms" layout="column"><div ng-if="!vm.isQuestions"><div \nclass="page-layout carded left-sidenav" layout="row"><div class="content-wrapper" layout="row" flex><div \nclass="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-thumb-up" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="CLIENTS.CLIENT_CREATED_SUCCESSFULLY"></span><div layout-gt-xs="row" layout="column" \nlayout-align="center center" class="mt-15"><md-button translate="GLOBAL.BACK_CLIENT_LIST" type="button" \nng-click="vm.goClients()" class="md-raised md-warn" aria-label="Cancel"></md-button><md-button \nclass="md-raised md-accent" ui-sref="app.site_overview.questions.questionnaire" \ntranslate="GLOBAL.CONTINUE_WITH_QUESTIONS"></md-button></div></div></div></div></div></div><div ng-if="vm.isQuestions" \nclass="p0" layout="column"><div class="items outline"><div layout="column" class="selectors"><md-input-container><label\n class="al-left">Criterio</label><md-select ng-model="vm.allQuestions" ng-change="vm.goQuestions(msWizard)"><md-option \nng-value="true">Todas las preguntas</md-option><md-option ng-value="false">Preguntas del sector</md-option></md-select>\n</md-input-container></div><div layout="column" class="selectors"><md-input-container><label class="al-left">Branches\n</label><md-select multiple="{{true}}" ng-model="vm.branchQuestion"><md-option ng-repeat="branch in vm.branches" \nng-value="branch.id">{{branch.name}}</md-option></md-select></md-input-container></div></div><div layout="row" \nng-repeat="question in vm.questions"><div class="question"><div layout="column" layout-gt-xs="row"><md-input-container \nflex><h2>{{question.name}}</h2></md-input-container></div><div layout="column" layout-gt-xs="row"><md-radio-group \nng-model="question.value"><md-radio-button value="yes" class="inline">Si</md-radio-button><md-radio-button value="no" \nclass="inline ml">No</md-radio-button></md-radio-group></div></div></div><div class="navigation pt" flex layout="row" \nlayout-align="center center"><md-button translate="GLOBAL.CANCEL" class="md-raised md-warn" ng-click="vm.goClients()">\n</md-button><md-button translate="GLOBAL.SEND" class="md-raised md-warn" ng-click="vm.finishQuestion()" \nng-disabled="!vm.branchQuestion.length > 0"></md-button></div></div></div>');
$templateCache.put('app/main/apps/outcomes/views/read/read-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="vm.loadingReadPane" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="fullheight" ng-if="!vm.loadingReadPane"><md-tabs class="fullheight"><md-tab label="Organizaci\xF3n"><content \nclass="" layout="row" ng-include="\'app/main/apps/clients/views/read/preview-company.html\'"></content></md-tab><md-tab \nlabel="Estructura"><content class="" layout="row" \nng-include="\'app/main/apps/clients/views/read/preview-structure.html\'"></content></md-tab><md-tab label="Edit" \nng-click="vm.editClient()"><content class="" ng-if="vm.showForm" layout="row" \nng-include="\'app/main/apps/clients/views/read/form.html\'"></content><content class="" ng-if="!vm.showForm" \nlayout="row" ng-include="\'app/main/apps/clients/views/read/question-form.html\'"></content></md-tab></md-tabs></div>');
$templateCache.put('app/main/apps/outputs/dialogs/new-stake-dialog/new-stake-dialog.html','<md-dialog class="new-client-dialog" aria-label="New Task"><form name="taskForm" class="md-inline-form" novalidate>\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between"><h1 \nclass="title" translate="STAKE.PROYECT_DATA"></h1><md-button class="md-icon-button" ng-click="vm.closeDialog()">\n<md-icon md-font-icon="icon-close" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content class="p-25" ms-scroll><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="STAKE.NAME"></label> <input type="text" ng-model="vm.company.stakeholder" required></md-input-container>\n</div><div layout="column" layout-gt-xs="row"><md-input-container flex><label translate="STAKE.INPUT"></label> <input \ntype="checkbox" ng-model="vm.company.input" value="1" name="input12" required></md-input-container><md-input-container \nflex><label translate="STAKE.OUTPUT"></label> <input ng-model="vm.company.output" type="checkbox" required>\n</md-input-container></div></md-dialog-content><md-dialog-actions class="footer" layout="row" layout-="end">\n<md-input-container flex layout="row" layout-align="end center"><md-button type="button" class="md-raised md-warn" \nng-click="vm.closeDialog()" translate="RISKCONFIG.CANCEL">Cancel</md-button><md-button \nng-disabled="!vm.company.stakeholder" type="submit" class="send-button md-accent md-raised" ng-click="vm.saveDialog()" \ntranslate="GLOBAL.SAVE">ADD</md-button></md-input-container></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/outputs/views/edit/edit-view.html','<div class="content thread-detail" layout="row" layout-align="center center" flex ng-if="!vm.edit"><div \nclass="no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-google-circles-communities" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="GLOBAL.SELECT_ITEM"></span></div></div><div class="form-wrapper md-whiteframe-1dp without-line" \nng-if="vm.edit"><form name="stakeForm" class="md-inline-form" novalidate><div layout="column" class="edit_stake">\n<md-input-container flex><label translate="ITEM.ITEM_NAME"></label> <input type="text" ng-model="vm.company.name" \nrequired></md-input-container><md-input-container flex><label translate="ITEM.DESCRIPTION"></label> <input type="text" \nng-model="vm.company.description_item" required></md-input-container></div><div layout="row" class="edit_stake">\n<md-input-container flex><label translate="ITEM.VALUE"></label> <input type="number" string-to-number \nng-model="vm.company.value" ng-change="vm.cambio=true" required></md-input-container></div><div layout="column" \nclass="field_edit"><md-checkbox ng-model="vm.company.edit_item" ng-true-value="\'1\'" ng-false-value="\'0\'" \nng-change="vm.cambio=true"><label translate="INPUT.EDITF"></label></md-checkbox></div><md-dialog-actions \nclass="footer" layout="row" layout-="end"><md-input-container flex layout="row" layout-align="end center"><md-button \ntype="button" class="md-raised md-warn" ng-click="vm.closeDialog()" translate="RISKCONFIG.CANCEL">Cancel</md-button>\n<md-button ng-disabled="!vm.company.name" type="submit" class="send-button md-accent md-raised" \nng-click="vm.changeValue(vm.company);vm.saveDialog(vm.company, $event)" translate="GLOBAL.SAVE">ADD</md-button>\n</md-input-container></md-dialog-actions></form><div class="content thread-detail" layout="row" \nlayout-align="center center" flex ng-if="!vm.edit"><div class="no-thread-selected" layout="column" \nlayout-align="center center" flex><md-icon md-font-icon="icon-clipboard-account" class="s120 grey-400-fg"></md-icon>\n<span class="hint-text" translate="STAKE.SELECT_TASK"></span></div></div></div>');
$templateCache.put('app/main/apps/outputs/views/list/list-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="isLoadingP" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="no-threads" ng-if="!companySel" ng-hide="isLoadingP" translate="GLOBAL.NO_ITEMS"></div><div \nid="list-content-data" ng-if="!isLoadingP && companySel" ng-style="{\'opacity\' : isLoadingP ? 0.5 : 1}"><table \nms-responsive-table><thead><tr class="font-size-16"><th></th><th><span translate="ITEM.ITEM_NAME">ITEM name</span></th>\n<th><span translate="ITEM.DESCRIPTION">description</span></th><th><span translate="ITEM.VALUE">value</span></th><th>\n<span translate="ITEM.TYPE">type</span></th><th><span translate="ITEM.EDIT">type</span></th><th></th><th></th></tr>\n</thead><tbody><tr ng-repeat="company in vm.item | filter:{type: 3 }" ng-init="parentIndex = $index" md-no-ink \nng-click="vm.openCompany(company, $event)" \nng-class="{\'starred\': company.starred, \'selected\': vm.selectedContentID !== client.id_mailing_content, \'checked\': vm.isChecked(company)}">\n<td><md-checkbox class="no-label" ng-checked="vm.isSelected(company)" \nng-click="vm.toggleSelectThread(company, $event)" aria-label="{{vm.isSelected(company) ? \'Deselect\' : \'Select\'}}">\n</md-checkbox></td><td><span>{{company.name}}</span></td><td><span>{{company.description_item}}</span></td><td><span>\n{{company.value}}</span></td><td><span ng-repeat="state in vm.tipefield" ng-if="state.number == company.type">\n{{state.name}}</span></td><td><span ng-repeat="edita in vm.editfield" ng-if="edita.number == company.edit_item">\n{{edita.name}}</span></td><td></td><td></td></tr></tbody></table><div \nng-if="!isLoading && pagination_total_pages > pagination_page && vm.companies.length > 0" class="load-more white p-30" \nlayout="row" layout-sm="column" layout-align="center center" layout-wrap=""><md-button \nng-click="pagination_nextPage(true)" class="md-raised">{{\'GLOBAL.LOAD_MORE\' |\xA0translate}}</md-button></div><div \nng-if="pagination_total_pages == pagination_page && pagination_page > 1" class="load-more white p-30" layout="row" \nlayout-sm="column" layout-align="center center" layout-wrap=""><div class="message" translate="GLOBAL.NO_MORE_ITEMS">\n</div></div></div>');
$templateCache.put('app/main/apps/outputs/views/list/nosplit-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.preview && !vm.readView" \nng-include="\'app/main/apps/clients/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row">\n<div class="content thread-detail mail-read-pane p0" flex="" id="thread-detail" ms-scroll="vm.msScrollOptions" \nng-if="vm.preview" ng-include="\'app/main/apps/clients/views/read/read-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="!vm.preview && !vm.readView" ng-include="\'app/main/apps/clients/views/list/list-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="vm.readView && vm.showForm" ng-include="\'app/main/apps/clients/views/read/form.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="vm.readView && !vm.showForm" ng-include="\'app/main/apps/clients/views/read/question-form.html\'"></div></div>');
$templateCache.put('app/main/apps/outputs/views/list/split-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.readView && !vm.preview" \nng-include="\'app/main/apps/outputs/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row">\n<div class="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="!vm.readView && !vm.preview" ng-include="\'app/main/apps/outputs/views/list/list-view.html\'"></div><div \nclass="content thread-detail mail-read-pane scrollable p0" flex="" id="thread-detail" ms-scroll="vm.msScrollOptions" \nng-include="\'app/main/apps/outputs/views/edit/edit-view.html\'" ng-style="{\'margin-right\' : vm.edit ? \'0\' : \'-50%\'}">\n</div></div>');
$templateCache.put('app/main/apps/outputs/views/list/toolbar.html','<div layout="row" layout-align="start center"><md-checkbox class="no-label" \naria-label="{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}" \nng-checked="vm.selectedThreads.length > 0" ng-click="vm.toggleSelectThreads(vm.selectedThreads, vm.contents)">\n</md-checkbox><div ng-if="!vm.fromComplaint || vm.userLogued.user_type <= 2" class="divider-vertical" hide="" \nshow-gt-xs=""></div><md-button ng-if="!vm.fromComplaint || vm.userLogued.user_type <= 2" aria-label="NEW" \nclass="md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme" hide show-gt-sm \nng-click="vm.newForm($event)" translate="OUTPUT.NEW" type="button"></md-button><md-button \nng-if="!vm.fromComplaint || vm.userLogued.user_type <= 2" aria-label="NEW" \nclass="md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme z-index-0" hide-gt-sm \nng-click="vm.newForm($event)" type="button"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="divider-vertical" hide="" show-gt-xs=""></div><div aria-hidden="false" \nclass="action-buttons hide show-gt-xs layout-align-start-center layout-row" layout="row" layout-align="start center" \nng-show="vm.selectedThreads.length > 0"><md-button ng-click="vm.deleteitem($ev)" aria-label="Delete" \nclass="md-icon-button" hide="" show-gt-xs="" translate=""><md-icon md-font-icon="icon-delete"></md-icon><md-tooltip \nhide show-gt-xs><span translate="GLOBAL.REMOVE"></span></md-tooltip></md-button><div class="divider-vertical" hide="" \nshow-gt-xs=""></div></div><ms-search-bar debounce="300" model-search="$root.pagination_searchquery" \non-result-click="vm.searchResultClick(item)" on-search="vm.search(query)" layout="row" layout-align="start center">\n</ms-search-bar><md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" \ntranslate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nng-if="$root.pagination_searchquery==true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip \nhide show-gt-xs><span>Reset search</span></md-tooltip></md-button><div class="divider-vertical" hide="" show-gt-xs="">\n</div><md-menu hide="" show-gt-xs="" ng-if="refGroupables.length>0"><button aria-label="Filters" \nclass="md-icon-button" ng-click="$mdMenu.open($event)" show-gt-xs="" translate="" \ntranslate-attr-aria-label="GLOBAL.FILTERS"><md-icon md-font-icon="icon-chevron-down"><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.GROUP_BY">Group</span></md-tooltip></md-icon></button><md-menu-content width="4"><md-menu-item \nng-repeat="sortfield in refGroupables"><md-button aria-label="All" ng-click="pagination_setOrderBy(sortfield)"><div \nlayout="row" layout-align="space-between center"><span>Group by {{sortfield.name}} </span><i class="icon-check s16" \nng-if="sortfield.titleId == sortable.titleId"></i></div></md-button></md-menu-item><md-menu-divider ng-if="groupable">\n</md-menu-divider><md-menu-item ng-if="groupable"><md-button aria-label="Remove group" \nng-click="pagination_resetOrderBy()"><md-icon md-font-icon="icon-close "></md-icon><span>Remove order</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div><div layout="row" layout-align="start center" \ntranslate-attr-aria-label="GLOBAL.REFRESH"><md-menu class="settings-menu" hide-gt-xs \nng-show="vm.selectedThreads.length > 0"><md-button aria-label="Settings" class="md-icon-button" \nng-click="$mdMenu.open($event)" translate="GLOBAL.SETTINGS" translate-attr-aria-label="GLOBAL.SETTINGS"><md-icon \nmd-font-icon="icon-dots-horizontal"></md-icon></md-button><md-menu-content><md-menu-item \nng-click="vm.deleteStakeholder($ev)" show="vm.selectedMail.length > 0 || vm.allChecked"><md-button \nng-click="vm.massActions(\'delete\')" aria-label="Delete" translate-aria-label="GLOBAL.DELETE"><md-icon \nmd-font-icon="icon-delete"></md-icon><span translate="GLOBAL.DELETE">Delete</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div>');
$templateCache.put('app/main/apps/questions-master/dialogs/selectProcessDialog/selectProcessDialog.html','<md-dialog id="select-process-dialog" class="form-dialog" aria-label="Odds of occurence"><md-toolbar class="md-accent">\n<div class="md-toolbar-tools" layout="row" layout-align="space-between center"><h1>Editar proceso</h1><div \nclass="absolute-right pr-10" layout="row  "><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog" tranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></div></md-toolbar><md-dialog-content class="mediadialog-content" flex><md-tabs><md-tab \nlabel="Por proceso"><div flex layout="column" layout-align="center center" ng-if="vm.isLoadingProcesses" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="50"></md-progress-circular></div>\n<div ng-if="!vm.isLoadingProcesses" layout="row" class="search-bar pr-10"><md-icon style="margin-top: 10px" \nmd-font-icon="icon-magnify" class="md-icon-button md-button"><md-tooltip hide show-gt-xs><span \ntranslate="TOOLBAR.SEARCH">Search</span></md-tooltip></md-icon><input id="ms-search-bar-input" type="text" \nng-model="vm.searchQuery" placeholder="Search" md-autofocus translate translate-attr-placeholder="TOOLBAR.SEARCH" flex>\n</div><md-list class="p0"><md-list-item class="bb" \nng-repeat="process in vm.processes | filter: {name : vm.searchQuery}" ng-click="vm.selectProcess(process)"><span \nclass="grey-700-fg mr-15">#{{process.id}}</span><p style="line-height: 1.1">{{process.name}}</p></md-list-item>\n</md-list></md-tab><md-tab label="Por riesgo"><div flex layout="column" layout-align="center center" \nng-if="vm.isLoadingRisks" class="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="50">\n</md-progress-circular></div><div ng-if="!vm.isLoadingRisks" layout="row" class="search-bar pr-10"><md-icon \nstyle="margin-top: 10px" md-font-icon="icon-magnify" class="md-icon-button md-button"><md-tooltip hide show-gt-xs><span\n translate="TOOLBAR.SEARCH">Search</span></md-tooltip></md-icon><input id="ms-search-bar-input" type="text" \nng-model="vm.searchQueryRisk" placeholder="Search" md-autofocus translate translate-attr-placeholder="TOOLBAR.SEARCH" \nflex></div><md-list class="p0"><div class="list-item" ng-class="{\'bb\' : !risk.showChildren}" layout="column" \nng-repeat="risk in vm.risks | filter: {name : vm.searchQueryRisk}"><div fill-width layout="row"><i \nng-if="risk.showChildren" ng-click="risk.showChildren = false" class="icon-chevron-up s30 pointer arrow"></i> <i \nng-if="!risk.showChildren" ng-click="risk.showChildren = true" class="icon-chevron-down s30 pointer arrow"></i><p flex \nstyle="line-height: 1.1">{{risk.name}}</p></div><md-list fill-width ng-if="risk.showChildren" class="p0" \nng-class="{\'bt\' : risk.showChildren}"><md-list-item class="bb pl-25" ng-repeat="process in risk.processes" \nng-click="vm.selectProcess(process)"><span class="grey-700-fg mr-15">#{{process.id}}</span><p style="line-height: 1.1">\n{{process.name}}</p></md-list-item></md-list></div></md-list></md-tab></md-tabs></md-dialog-content><md-dialog-actions \nng-if="vm.user.user_type == 1" layout="row" layout-align="end center" class="grey-100-bg"><md-button \ntranslate="GLOBAL.CANCEL" type="button" ng-click="vm.closeDialog()" class="md-raised md-warn" aria-label="Cancel">\n</md-button><md-button ng-click="vm.saveDialog(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="GLOBAL.UPGRADE_PLAN" translate-attr-aria-label="GLOBAL.UPGRADE_PLAN"></md-button></md-dialog-actions>\n<md-dialog-actions ng-if="vm.user.user_type != 1" layout="row" layout-align="end center" class="grey-100-bg"><md-button\n translate="GLOBAL.CANCEL" type="button" ng-click="vm.closeDialog()" class="md-raised md-warn" aria-label="Cancel">\n</md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/main/apps/outputs/views/read/form.html','<div id="forms" class="page-layout simple fullwidth doc-page forms" layout="column"><div class="p0" layout="column">\n<div layout="row"><ms-form-wizard class="no-margin" flex><div layout="row" layout-align="start center" flex="100" \nclass="layout-align-start-center layout-row flex-100 toolbar grey-100-bg colored-bg" ng-if="vm.idCompany"><a \nclass="pointer" ng-click="vm.closeForm()"><md-icon md-font-icon="icon-chevron-left"></md-icon></a><div \nclass="avatar-wrapper"><md-icon md-font-icon="icon-city"></md-icon></div><div class="field mr-10 ml-10 flex" flex="">\n<strong class="grey-800-fg ng-binding" ng-bind-html="vm.formWizard.company.name"></strong></div></div><md-tabs \nclass="height-tabs" md-dynamic-height md-selected="msWizard.selectedIndex" md-center-tabs="true"><md-tab><md-tab-label>\n<span class="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 0">1</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 0"><i class="icon-checkbox-blank-circle s16"></i> </span><span \nclass="ms-form-wizard-step-text" translate="GLOBAL.COMPANY_DATA"></span></span></md-tab-label><md-tab-body><form \nname="wizardStep1" ng-include="\'app/main/apps/clients/views/read/form-tabs/step-company.html\'" ms-form-wizard-form \nnovalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.idCompany"><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 1">2</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 1"><i class="icon-checkbox-blank-circle s16"></i> </span><span \nclass="ms-form-wizard-step-text" translate="CLIENTS.OPTIONS"></span></span></md-tab-label><md-tab-body><form \nname="wizardStep1b" ng-include="\'app/main/apps/clients/views/read/form-tabs/step-options.html\'" ms-form-wizard-form \nnovalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.idCompany"><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 2">3</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 2"><i class="icon-checkbox-blank-circle s16"></i> </span><span \nclass="ms-form-wizard-step-text" translate="GLOBAL.FILIATION_DATA"></span></span></md-tab-label><md-tab-body><div \nclass="navigation white-bg mb-50" flex layout="row" layout-align="center center"><div layout="row" flex \nlayout-align="start center"><md-button ng-if="vm.showForm" translate="GLOBAL.CLOSE" type="button" \nng-click="vm.closeForm()" class="md-raised md-warn hide-xs" aria-label="Cancel"></md-button><md-button \nng-if="vm.idCompany" translate="GLOBAL.SAVE" class="md-raised md-accent" ng-click="vm.nextStep(msWizard, true);" \nng-hide="msWizard.isLastStep()" ng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button></div><div \nclass="ml-auto" layout="row" flex layout-align="end center"><div flex layout="column" layout-align="center center" \nlayout-padding layout-margin ng-if="vm.loadingStep" class="loading-container"><md-progress-circular \nmd-mode="indeterminate" md-diameter="30"></md-progress-circular></div><md-button translate="GLOBAL.PREVIOUS" \nclass="md-raised md-accent" ng-click="vm.prevStep(msWizard)" ng-disabled="vm.previousStep(msWizard) || vm.loadingStep">\n</md-button><div class="steps"><span ng-repeat="form in msWizard.forms" \nng-class="{\'selected md-accent-bg\':msWizard.selectedIndex === $index}"></span></div><md-button translate="GLOBAL.NEXT" \nclass="md-raised md-accent" ng-click="vm.nextStep(msWizard)" ng-hide="msWizard.isLastStep()" \nng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button><md-button translate="GLOBAL.FINISH" \nclass="md-raised md-warn" ng-click="vm.sendForm(); msWizard.resetForm();" ng-show="msWizard.isLastStep()" \nng-disabled="msWizard.formsIncomplete()"></md-button></div></div><form name="wizardStep2" \nng-include="\'app/main/apps/clients/views/read/form-tabs/step-branchs.html\'" class="md-inline-form" ms-form-wizard-form \nnovalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.formWizard.main_branch.id"><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 3">4</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 3"><i class="icon-checkbox-blank-circle s16"></i> </span><span \ntranslate="GLOBAL.COMPLIANCE_COMMITTEE" class="ms-form-wizard-step-text"></span></span></md-tab-label><md-tab-body>\n<form ng-include="\'app/main/apps/clients/views/read/form-tabs/step-people.html\'" name="wizardStep3" \nms-form-wizard-form novalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.formWizard.main_branch.id">\n<md-tab-label><span class="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 4">5</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 4"><i class="icon-checkbox-blank-circle s16"></i> </span><span \ntranslate="GLOBAL.BRANCH_PERSONNEL" class="ms-form-wizard-step-text"></span></span></md-tab-label><md-tab-body><form \nng-include="\'app/main/apps/clients/views/read/form-tabs/step-people-global.html\'" name="wizardStep4" \nms-form-wizard-form novalidate></form></md-tab-body></md-tab></md-tabs><div \nclass="navigation white-bg border-top mb-50" flex layout="row" layout-align="center center"><div layout="row" flex \nlayout-align="start center"><md-button hide-xs ng-if="vm.showForm" translate="GLOBAL.CLOSE" type="button" \nng-click="vm.closeForm()" class="md-raised md-warn hide-xs" aria-label="Cancel"></md-button><md-button \nng-if="vm.idCompany" translate="GLOBAL.SAVE" class="md-raised md-accent" ng-click="vm.nextStep(msWizard, true);" \nng-hide="msWizard.isLastStep()" ng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button></div><div \nclass="ml-auto" layout="row" flex layout-align="end center"><div flex layout="column" layout-align="center center" \nlayout-padding layout-margin ng-if="vm.loadingStep" class="loading-container"><md-progress-circular \nmd-mode="indeterminate" md-diameter="30"></md-progress-circular></div><md-button translate="GLOBAL.PREVIOUS" \nclass="md-raised md-accent" ng-click="vm.prevStep(msWizard)" ng-disabled="vm.previousStep(msWizard) || vm.loadingStep">\n</md-button><div class="steps"><span ng-repeat="form in msWizard.forms" \nng-class="{\'selected md-accent-bg\':msWizard.selectedIndex === $index}"></span></div><md-button translate="GLOBAL.NEXT" \nclass="md-raised md-accent" ng-click="vm.nextStep(msWizard)" ng-hide="msWizard.isLastStep()" \nng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button><md-button translate="GLOBAL.FINISH" \nclass="md-raised md-warn" ng-click="vm.sendForm(); msWizard.resetForm();" ng-show="msWizard.isLastStep()" \nng-disabled="msWizard.formsIncomplete()"></md-button></div></div><div class="navigation" flex layout="row" \nlayout-align="center center"><md-button hide-xs ng-if="vm.showForm" translate="GLOBAL.CANCEL" type="button" \nng-click="vm.closeForm()" class="md-raised md-warn show-xs" aria-label="Cancel"></md-button></div></ms-form-wizard>\n</div></div></div>');
$templateCache.put('app/main/apps/outputs/views/read/preview-company.html','<div hide show-gt-sm class="toolbar grey-100-bg colored-bg" layout="row" layout-align="space-between center" scroll="">\n<div layout="row" layout-align="start center"><a class="pointer" ng-click="vm.goClients()"><md-icon \nmd-font-icon="icon-chevron-left"></md-icon></a><h2 translate="GLOBAL.COMPANY_DATA"></h2></div></div><div \nclass="md-whiteframe-1dp without-line scrollable preview" flex="100"><form name="vm.basicForm" class="md-inline-form" \nnovalidate><md-input-container class="md-block bb logotype"><img \nngf-thumbnail="!image.$error && image && vm.logoIsLoaded" class="img"> <img \nng-if="!image && imageUrl && vm.logoIsLoaded" src="{{imageUrl}}" class="img"><div \nng-if="!image && !imageUrl && vm.logoIsLoaded" class="avatar img" \nng-bind="vm.formWizard.company.name | capitalizeFirstLetter" ms-random-class="vm.colors"></div><h5 \nclass="padding inline-block m0">{{vm.formWizard.company.name}}</h5></md-input-container><md-input-container \nclass="md-block bb"><label>{{vm.getRegionLiteral(\'tax_ic_number\')}}</label><h5 class="padding">\n{{vm.formWizard.company.tax_id_number}}</h5></md-input-container><md-input-container class="md-block mg-bttm"><label \ntranslate="GLOBAL.SECTOR"></label><h5 class="padding">{{vm.getSectorById(vm.formWizard.company.sector_id).name}}</h5>\n</md-input-container><md-input-container class="md-block border separator mb-30"><h2 class="title" \ntranslate="CLIENTS.OPTIONS"></h2></md-input-container><md-input-container ng-if="vm.formWizard.company.description" \nclass="md-block bb options-preview"><label class="options-preview" translate="GLOBAL.DESCRIPTION"></label><h5 \nclass="padding mv-10">{{vm.formWizard.company.description}}</h5></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.executives_type" class="md-block bb mb-0 options-preview-select"><label \ntranslate="GLOBAL.EXECUTIVE_TYPE"></label><md-select class="disabled" ng-disabled="true" \nng-model="vm.formWizard.company.extra_data.executives_type"><md-option ng-value="1">Accionista \xFAnico</md-option>\n<md-option ng-value="2">Varios accionistas</md-option><md-option ng-value="3">Consejo de administraci\xF3n</md-option>\n<md-option ng-value="4">Administrador \xFAnico</md-option><md-option ng-value="5">Otros</md-option></md-select>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.capital" \nclass="md-block bb mb-0 options-preview-select"><label translate="GLOBAL.SOCIAL_CAPITAL"></label><md-select \nclass="disabled" ng-disabled="true" ng-model="vm.formWizard.company.extra_data.capital"><md-option ng-value="1">Capital\n</md-option><md-option ng-value="2">Aportaciones de socios</md-option><md-option ng-value="3">\nAumentos de capital recientes</md-option></md-select></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.capital_amount" class="md-block bb m0 options-preview"><label \nclass="options-preview" translate="GLOBAL.AMOUNT_CAPITAL"></label><h5 class="padding mv-10">\n{{vm.formWizard.company.extra_data.capital_amount}}</h5></md-input-container><md-input-container \nng-if="vm.formWizard.company.turnover_volume" class="md-block bb m0 options-preview"><label class="options-preview" \ntranslate="GLOBAL.BILLING_LAST_YEAR"></label><h5 class="padding mv-10">{{vm.formWizard.company.turnover_volume}}</h5>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.tax_options" \nclass="md-block bb mb-0 options-preview-select"><label>IVA</label><md-select class="disabled" ng-disabled="true" \nng-model="vm.formWizard.company.extra_data.tax_options"><md-option ng-value="1">Presentaci\xF3n trimestral</md-option>\n<md-option ng-value="2">Presentaci\xF3n mensual</md-option></md-select></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.annual_accounts" class="md-block bb mb-0 options-preview-select"><label>\nCuentas anuales</label><md-select class="disabled" ng-disabled="true" \nng-model="vm.formWizard.company.extra_data.annual_accounts"><md-option ng-value="1">Abreviadas</md-option><md-option \nng-value="2">Normales</md-option><md-option ng-value="3">Pymes</md-option><md-option ng-value="4">Mixtas</md-option>\n</md-select></md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.extra_data" \nclass="md-block bb mb-0 options-preview-select"><label>Auditor\xEDas</label><md-select class="disabled" \nng-disabled="true" ng-model="vm.formWizard.company.extra_data.audits"><md-option ng-value="1">Internas</md-option>\n<md-option ng-value="2">Externas</md-option><md-option ng-value="3">No aplica</md-option></md-select>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.iso_certification" \nclass="md-block bb mb-0 options-preview-select"><label>Certificaciones ISO</label><md-select class="disabled" \nng-disabled="true" ng-model="vm.formWizard.company.extra_data.iso_certification"><md-option ng-value="1">ISO 9001\n</md-option><md-option ng-value="2">ISO 14000</md-option><md-option ng-value="3">ISO 14001</md-option><md-option \nng-value="4">ISO 19600</md-option><md-option ng-value="5">ISO 22000</md-option><md-option ng-value="6">ISO 26000\n</md-option><md-option ng-value="7">ISO 27001</md-option><md-option ng-value="8">ISO 37001</md-option><md-option \nng-value="9">OHSAS 18001</md-option></md-select></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.collective_agreement" class="md-block bb m0 options-preview"><label \nclass="options-preview">Convenio Colectivo Aplicable</label><h5 class="padding mv-10">\n{{vm.formWizard.company.extra_data.collective_agreement}}</h5></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.insurance" class="md-block bb m0 options-preview"><label \nclass="options-preview">Seguros contratados</label><h5 class="padding mv-10">\n{{vm.formWizard.company.extra_data.insurance}}</h5></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.cnae" class="md-block bb m0 options-preview"><label class="options-preview" \ntranslate="GLOBAL.CNAE"></label><h5 class="padding mv-10">{{vm.formWizard.company.extra_data.cnae}}</h5>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.financing.length> 0" \nclass="md-block bb mb-0 options-preview-select"><label class="ph-15" fill-width translate="GLOBAL.FINANCING"></label>\n<md-select class="disabled" ng-disabled="true" multiple="{{false}}" \nng-model="vm.formWizard.company.extra_data.financing"><md-option ng-repeat="option in vm.financing_options" \nng-value="option">{{option.name}}</md-option></md-select></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.sector_regulations.length> 0" class="md-block bb mb-0 options-preview-select">\n<label class="ph-15" fill-width>Normativa Sectorial aplicable</label><md-select class="disabled" ng-disabled="true" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.sector_regulations"><md-option \nng-repeat="option in vm.sector_regulations_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.implemented_measures.length> 0" \nclass="md-block bb mb-20 options-preview-select"><label class="ph-15" fill-width>Medidas implementadas</label>\n<md-select class="disabled" ng-disabled="true" multiple="{{false}}" \nng-model="vm.formWizard.company.extra_data.implemented_measures"><md-option \nng-repeat="option in vm.implemented_measures_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container><md-input-container class="md-block border separator"><h2 class="title" \ntranslate="GLOBAL.MAIN_BRANCH"></h2></md-input-container><md-input-container class="md-block bb"><label \ntranslate="GLOBAL.NAME"></label><h5 class="padding">{{vm.formWizard.main_branch.name}}</h5></md-input-container>\n<md-input-container class="md-block bb"><label translate="GLOBAL.ADDRESS"></label><h5 class="padding">\n{{vm.formWizard.main_branch.address1}}</h5></md-input-container><md-input-container class="md-block bb"><label>\n{{vm.getRegionLiteral(\'city\')}}</label><h5 class="padding">{{vm.formWizard.main_branch.city}}</h5></md-input-container>\n<md-input-container class="md-block border separator"><h2 class="title" translate="GLOBAL.BRANCH"></h2>\n</md-input-container><div class="mail-list-pane s0" ng-if="vm.formWizard.branches && vm.formWizard.branches.length> 0">\n<div class="items" ng-repeat="branch in vm.formWizard.branches track by $index"><div layout="row" \nlayout-align="start center" flex="100" class="p-20 layout-align-start-center layout-row flex-100"><div layout="row" \nlayout-align="start center" flex="100" class="layout-align-start-center layout-row flex-100"><div \nclass="avatar-wrapper"><md-icon md-font-icon="icon-city"></md-icon></div><div class="field mr-10 ml-10 flex" flex="">\n<strong class="grey-800-fg ng-binding" ng-bind-html="branch.name"></strong><div class="field grey-600-fg ng-binding">\n<span ng-if="branch.city" ng-bind-html="branch.city"></span> <span ng-if="branch.city && branch.state">, </span><span \nng-if="branch.state" ng-bind-html="branch.state"></span></div></div></div></div></div></div></form></div>');
$templateCache.put('app/main/apps/outputs/views/read/preview-structure.html','<div hide show-gt-sm class="toolbar grey-100-bg colored-bg" layout="row" layout-align="space-between center" scroll="">\n<div layout="row" layout-align="start center"><h2>Organizaci\xF3n de la compa\xF1\xEDa</h2></div><div layout="row" \nlayout-align="end center" hide show-gt-sm><md-button translate="GLOBAL.EDIT" type="button" ng-click="vm.editCompany()" \nclass="md-raised md-accent" aria-label="Edit"></md-button></div><div layout="row" layout-align="end center" hide-gt-sm>\n<md-button type="button" ng-click="vm.editClient()" \nclass="md-accent md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" aria-label="Edit"><md-icon \nmd-font-icon="icon-plus"></md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.EDIT"></span></md-tooltip>\n</md-button></div></div><div class="without-line scrollable preview" flex="100"><div ivh-treeview="vm.tree" \nivh-treeview-options="vm.ivhOptions" class="treeview" \nivh-treeview-on-cb-change="vm.callback(ivhNode, ivhIsSelected, ivhTree)"><script type="text/ng-template">\n<div class="level-card" ng-if="node.type != \'user\'">\n                    <span ivh-treeview-toggle>\n                        <span ivh-treeview-twistie></span>\n                    </span>\n                    <md-icon md-font-icon="icon-city" ng-if="node.type == \'branch\'"></md-icon>\n                    <md-icon md-font-icon="icon-folder-account" ng-if="node.type == \'division\'"></md-icon>\n                    <md-icon md-font-icon="icon-worker" ng-if="node.type == \'job_position\'"></md-icon>\n                    <span class="ivh-treeview-node-label" ivh-treeview-toggle>{{trvw.label(node)}}</span>\n                </div>\n                <div class="level-card" ng-if="node.type == \'user\'">\n                    <div layout="row" layout-align="start center" flex="100">\n                        <div class="avatar-wrapper">\n                            <user-avatar User="node.user"/>\n                        </div>\n                        <div class="field mr-5 ml-5" flex>\n                            <strong class="grey-800-fg" ng-bind-html="node.user.first_name + \' \' + node.user.last_name"></strong>\n                        </div>\n                    </div>\n                </div>\n                <div ivh-treeview-children></div>\n</script></div></div>');
$templateCache.put('app/main/apps/outputs/views/read/question-form.html','<div id="forms" class="page-layout simple fullwidth doc-page forms" layout="column"><div ng-if="!vm.isQuestions"><div \nclass="page-layout carded left-sidenav" layout="row"><div class="content-wrapper" layout="row" flex><div \nclass="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-thumb-up" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="CLIENTS.CLIENT_CREATED_SUCCESSFULLY"></span><div layout-gt-xs="row" layout="column" \nlayout-align="center center" class="mt-15"><md-button translate="GLOBAL.BACK_CLIENT_LIST" type="button" \nng-click="vm.goClients()" class="md-raised md-warn" aria-label="Cancel"></md-button><md-button \nclass="md-raised md-accent" ui-sref="app.site_overview.questions.questionnaire" \ntranslate="GLOBAL.CONTINUE_WITH_QUESTIONS"></md-button></div></div></div></div></div></div><div ng-if="vm.isQuestions" \nclass="p0" layout="column"><div class="items outline"><div layout="column" class="selectors"><md-input-container><label\n class="al-left">Criterio</label><md-select ng-model="vm.allQuestions" ng-change="vm.goQuestions(msWizard)"><md-option \nng-value="true">Todas las preguntas</md-option><md-option ng-value="false">Preguntas del sector</md-option></md-select>\n</md-input-container></div><div layout="column" class="selectors"><md-input-container><label class="al-left">Branches\n</label><md-select multiple="{{true}}" ng-model="vm.branchQuestion"><md-option ng-repeat="branch in vm.branches" \nng-value="branch.id">{{branch.name}}</md-option></md-select></md-input-container></div></div><div layout="row" \nng-repeat="question in vm.questions"><div class="question"><div layout="column" layout-gt-xs="row"><md-input-container \nflex><h2>{{question.name}}</h2></md-input-container></div><div layout="column" layout-gt-xs="row"><md-radio-group \nng-model="question.value"><md-radio-button value="yes" class="inline">Si</md-radio-button><md-radio-button value="no" \nclass="inline ml">No</md-radio-button></md-radio-group></div></div></div><div class="navigation pt" flex layout="row" \nlayout-align="center center"><md-button translate="GLOBAL.CANCEL" class="md-raised md-warn" ng-click="vm.goClients()">\n</md-button><md-button translate="GLOBAL.SEND" class="md-raised md-warn" ng-click="vm.finishQuestion()" \nng-disabled="!vm.branchQuestion.length > 0"></md-button></div></div></div>');
$templateCache.put('app/main/apps/outputs/views/read/read-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="vm.loadingReadPane" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="fullheight" ng-if="!vm.loadingReadPane"><md-tabs class="fullheight"><md-tab label="Organizaci\xF3n"><content \nclass="" layout="row" ng-include="\'app/main/apps/clients/views/read/preview-company.html\'"></content></md-tab><md-tab \nlabel="Estructura"><content class="" layout="row" \nng-include="\'app/main/apps/clients/views/read/preview-structure.html\'"></content></md-tab><md-tab label="Edit" \nng-click="vm.editClient()"><content class="" ng-if="vm.showForm" layout="row" \nng-include="\'app/main/apps/clients/views/read/form.html\'"></content><content class="" ng-if="!vm.showForm" \nlayout="row" ng-include="\'app/main/apps/clients/views/read/question-form.html\'"></content></md-tab></md-tabs></div>');
$templateCache.put('app/main/apps/questions-master/views/list/list-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="isLoading" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="no-threads" ng-if="!vm.questions" ng-hide="isLoading" translate="GLOBAL.NO_ITEMS"></div><div \nid="list-content-data" ng-style="{\'opacity\' : isLoading ? 0.5 : 1}"><div class="mail-list-item" \nng-repeat="question in vm.questions | filter: vm.search | filter: global.search" ng-init="parentIndex = $index" \nmd-no-ink ng-click="vm.openQuestion(question)" \nng-class="{\'starred\': question.starred, \'selected\': vm.questionSelected.id === question.id, \'checked\': vm.isSelected(question)}">\n<div layout="row" layout-align="start center"><md-checkbox class="no-label" ng-checked="vm.isSelected(question)" \nng-click="vm.toggleSelectThread(question, $event)" aria-label="{{vm.isSelected(question) ? \'Deselect\' : \'Select\'}}">\n</md-checkbox><div class="avatar-wrapper"></div><div class="info layout-column flex" flex="" layout="column"><div \nclass="name text-truncate" layout="row" layout-align="start center"><span>{{question.name}}</span></div><div \nclass="details text-truncate" layout="row" layout-align="start center"></div></div></div></div><div \nng-if="!isLoading && pagination_total_pages > pagination_page && vm.questions.length > 0" class="load-more white p-30" \nlayout="row" layout-sm="column" layout-align="center center" layout-wrap=""><md-button \nng-click="pagination_nextPage(true)" class="md-raised">{{\'GLOBAL.LOAD_MORE\' |\xA0translate}}</md-button></div><div \nng-if="pagination_total_pages == pagination_page && pagination_page > 1" class="load-more white p-30" layout="row" \nlayout-sm="column" layout-align="center center" layout-wrap=""><div class="message" translate="GLOBAL.NO_MORE_ITEMS">\n</div></div></div>');
$templateCache.put('app/main/apps/questions-master/views/list/nosplit-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.questionSelected && !vm.questionNew" \nng-include="\'app/main/apps/questions-master/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" \nlayout="row"><div class="content thread-detail mail-read-pane p0" flex="" id="thread-detail" \nms-scroll="vm.msScrollOptions" ng-if="vm.questionSelected || vm.questionNew" \nng-include="\'app/main/apps/questions-master/views/read/read-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="!vm.questionSelected && !vm.questionNew" \nng-include="\'app/main/apps/questions-master/views/list/list-view.html\'"></div></div>');
$templateCache.put('app/main/apps/questions-master/views/list/split-view.html','<div class="toolbar" layout="row" layout-align="space-between center" \nng-include="\'app/main/apps/questions-master/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" \nlayout="row"><div class="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" \nid="thread-list" ng-include="\'app/main/apps/questions-master/views/list/list-view.html\'"></div><div \nclass="content thread-detail mail-read-pane p0" flex="" id="thread-detail" ms-scroll="vm.msScrollOptions" \nng-include="\'app/main/apps/questions-master/views/read/read-view.html\'"></div></div>');
$templateCache.put('app/main/apps/questions-master/views/list/toolbar.html','<div layout="row" layout-align="start center"><md-checkbox class="no-label" \naria-label="{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}" \nng-checked="vm.selectedThreads.length > 0" ng-click="vm.toggleSelectThreads(vm.selectedThreads, vm.contents)">\n</md-checkbox><div class="divider-vertical" hide="" show-gt-xs=""></div><md-button aria-label="NEW" \nclass="md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme" hide show-gt-sm \nng-click="vm.newQuestion()" translate="GLOBAL.NEW" type="button"></md-button><md-button aria-label="NEW" \nclass="md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme z-index-0" hide-gt-sm \nng-click="vm.newQuestion()" type="button"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="divider-vertical" hide="" show-gt-xs=""></div><md-menu-bar id="region-menu" class="pl-0 pr-0"><md-menu \nmd-position-mode="left bottom"><md-button class="user-button m0" ng-click="$mdMenu.open()" aria-label="User settings" \ntranslate translate-attr-aria-label="TOOLBAR.REGION"><div layout="row" layout-align="space-between center"><span \nng-if="vm.regionSelected" class="username">{{vm.regionSelected.name}}</span><md-icon md-font-icon="icon-chevron-down" \nclass="icon s16"></md-icon></div></md-button><md-menu-content width="3" class="clients"><md-menu-item \nclass="md-indent"><div class="search-input-wrapper" layout="row" layout-align="start center"><label for="search">\n<md-icon md-font-icon="icon-magnify"></md-icon></label><md-input-container md-no-float class="m-0"><input id="search" \nplaceholder="{{\'CONTACTS.SEARCH_FOR_ANYONE\' |\xA0translate}}" type="text" ng-model="vm.searchRegionText">\n</md-input-container></div></md-menu-item><div class="results"><md-menu-item ng-click="vm.selectRegion(region)" \nclass="md-indent bar-client" ng-repeat="region in vm.allRegions | filter:vm.searchRegionText"><div><md-icon \nmd-font-icon="icon-account" class="icon s16" hide-xs></md-icon><button class="btn-clients">{{region.name}}</button>\n</div></md-menu-item></div></md-menu-content></md-menu></md-menu-bar><div aria-hidden="false" \nclass="action-buttons hide show-gt-xs layout-align-start-center layout-row" layout="row" layout-align="start center" \nng-show="vm.selectedThreads.length > 0"><md-button ng-click="vm.deleteQuestion()" aria-label="Delete" \nclass="md-icon-button" hide="" show-gt-xs="" translate=""><md-icon md-font-icon="icon-delete"></md-icon><md-tooltip \nhide show-gt-xs><span translate="GLOBAL.REMOVE"></span></md-tooltip></md-button><md-button \nng-click="vm.duplicateQuestion()" aria-label="Duplicate" class="md-icon-button" hide="" show-gt-sm="" translate="" \ntranslate-attr-aria-label="GLOBAL.DUPLICATE"><md-icon md-font-icon="icon-content-duplicate"></md-icon><md-tooltip><span\n translate="GLOBAL.DUPLICATE"></span></md-tooltip></md-button><div class="divider-vertical" hide="" show-gt-xs="">\n</div></div><ms-search-bar debounce="300" model-search="$root.pagination_searchquery" \non-result-click="vm.searchResultClick(item)" on-search="vm.search(query)" layout="row" layout-align="start center">\n</ms-search-bar><md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" \ntranslate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nng-if="$root.pagination_searchquery==true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip \nhide show-gt-xs><span>Reset search</span></md-tooltip></md-button><div class="divider-vertical" hide="" show-gt-xs="">\n</div><md-menu hide="" show-gt-xs="" ng-if="refGroupables.length>0"><button aria-label="Filters" \nclass="md-icon-button" ng-click="$mdMenu.open($event)" show-gt-xs="" translate="" \ntranslate-attr-aria-label="GLOBAL.FILTERS"><md-icon md-font-icon="icon-chevron-down"><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.GROUP_BY">Group</span></md-tooltip></md-icon></button><md-menu-content width="4"><md-menu-item \nng-repeat="sortfield in refGroupables"><md-button aria-label="All" ng-click="pagination_setOrderBy(sortfield)"><div \nlayout="row" layout-align="space-between center"><span>Group by {{sortfield.name}} </span><i class="icon-check s16" \nng-if="sortfield.titleId == sortable.titleId"></i></div></md-button></md-menu-item><md-menu-divider ng-if="groupable">\n</md-menu-divider><md-menu-item ng-if="groupable"><md-button aria-label="Remove group" \nng-click="pagination_resetOrderBy()"><md-icon md-font-icon="icon-close "></md-icon><span>Remove order</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div><div layout="row" layout-align="start center" \ntranslate-attr-aria-label="GLOBAL.REFRESH"><span ng-if="!isLoading" class="page-info font-weight-500">\n{{vm.questions.length}} {{ \'GLOBAL.OF\' | translate}} {{pagination_totalItems}} {{ \'GLOBAL.ITEMS\' | translate}}.</span>\n<div class="divider-vertical" hide hide show-gt-sm></div><md-button class="md-icon-button" \nng-click="vm.changeView(\'nosplit\')" ng-if="vm.currentView !== \'nosplit\'" hide show-gt-sm><md-icon \nmd-font-icon="icon-view-list" ng-if="vm.currentView !== \'nosplit\'"></md-icon><md-icon class="md-accent" \nmd-font-icon="icon-checkbox-marked" ng-if="vm.currentView === \'nosplit\'"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.NOSPLIT_VIEW">No split</span></md-tooltip></md-button><md-button class="md-icon-button" \nng-click="vm.changeView(\'split\')" ng-if="vm.currentView !== \'split\'" hide show-gt-sm><md-icon \nmd-font-icon="icon-view-quilt" ng-if="vm.currentView !== \'split\'"></md-icon><md-icon class="md-accent" \nmd-font-icon="icon-checkbox-marked" ng-if="vm.currentView === \'split\'"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.SPLIT_VIEW">split</span></md-tooltip></md-button><md-menu class="settings-menu" hide-gt-xs \nng-show="vm.selectedThreads.length > 0"><md-button aria-label="Settings" class="md-icon-button" \nng-click="$mdMenu.open($event)" translate="GLOBAL.SETTINGS" translate-attr-aria-label="GLOBAL.SETTINGS"><md-icon \nmd-font-icon="icon-dots-horizontal"></md-icon></md-button><md-menu-content><md-menu-item ng-click="vm.deleteClient()" \nshow="vm.selectedMail.length > 0 || vm.allChecked"><md-button ng-click="vm.deleteQuestion()" aria-label="Delete" \ntranslate-aria-label="GLOBAL.DELETE"><md-icon md-font-icon="icon-delete"></md-icon><span translate="GLOBAL.DELETE">\nDelete</span></md-button><md-button ng-click="vm.duplicateQuestion()" aria-label="Duplicate" \ntranslate-aria-label="GLOBAL.DUPLICATE"><md-icon md-font-icon="icon-content-duplicate"></md-icon><span \ntranslate="GLOBAL.DUPLICATE">Duplicate</span></md-button></md-menu-item></md-menu-content></md-menu></div>');
$templateCache.put('app/main/apps/questions-master/views/read/edit.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="vm.loadingReadPane" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div ng-if="!vm.loadingReadPane" class="form-wrapper md-whiteframe-1dp without-line" flex="100"><form \nname="vm.basicForm" class="md-inline-form" novalidate><div><md-input-container class="md-block"><label \nng-bind="\'Name\'"></label> <input type="text" name="name" ng-model="vm.questionSelected.name"></md-input-container>\n<md-select name="region" ng-model="vm.questionSelected.region_id" placeholder="Region"><md-option \nng-repeat="region in vm.regions track by $index" value="{{region.id}}">{{region.name}}</md-option></md-select></div>\n</form><div ng-repeat="process in vm.questionSelected.processes" layout="row" layout-align="start center" flex="" \nclass="pt-24 layout-align-start-center layout-row flex"><div class="avatar" \nng-style="{\'background\': \'rgba(25,147,232,1)\'}" style="background: rgb(25, 147, 232);">P</div><div class="field" flex \nlayout="column"><strong class="grey-800-fg ng-binding">{{process.name}}</strong> <span>\nRiesgo: {{process.risks[0].name}}</span></div><md-button aria-label="Edit" class="md-icon-button" \nng-click="vm.editProcessDialog($event, vm.questionSelected.region_id)" translate="" \ntranslate-attr-aria-label="GLOBAL.EDIT"><md-icon md-font-icon="icon-pencil"></md-icon><md-tooltip hide show-gt-xs><span\n translate="GLOBAL.EDIT">Edit</span></md-tooltip></md-button></div><div layout="row" layout-align="start center" \nflex="" ng-if="(!vm.questionSelected.processes || vm.questionSelected.processes.length == 0)"><div class="field" flex \nlayout="column"><span>Seleciona a que proceso pertenece la pregunta</span></div><md-button aria-label="Edit" \nclass="md-icon-button" ng-click="vm.editProcessDialog($event, vm.questionSelected.region_id)" translate="" \ntranslate-attr-aria-label="GLOBAL.EDIT"><md-icon md-font-icon="icon-pencil"></md-icon><md-tooltip hide show-gt-xs><span\n translate="GLOBAL.EDIT">Edit</span></md-tooltip></md-button></div></div>');
$templateCache.put('app/main/apps/questions-master/views/read/new.html','<div class="form-wrapper md-whiteframe-1dp without-line" flex="100"><form name="vm.basicForm" class="md-inline-form" \nnovalidate><div><md-input-container class="md-block"><label>{{ \'GLOBAL.NAME\' | translate}}</label> <input type="text" \nname="name" ng-model="vm.questionNew.name"></md-input-container><md-select name="region" \nng-model="vm.questionNew.region_id" placeholder="Region"><md-option ng-repeat="region in vm.regions track by $index" \nvalue="{{region.id}}">{{region.name}}</md-option></md-select></div></form><div \nng-if="vm.questionNew.processes && vm.questionNew.processes.length > 0" \nng-repeat="process in vm.questionNew.processes" layout="row" layout-align="start center" flex="" class="pt-24"><div \nclass="avatar" ng-style="{\'background\': \'rgba(25,147,232,1)\'}" style="background: rgb(25, 147, 232);">P</div><div \nclass="field" flex layout="column"><strong class="grey-800-fg ng-binding">{{process.name}}</strong> <span>\nRiesgo: {{process.risks[0].name}}</span></div><md-button aria-label="Edit" class="md-icon-button" \nng-click="vm.editProcessDialog($event, vm.questionNew.region_id)" translate="" translate-attr-aria-label="GLOBAL.EDIT">\n<md-icon md-font-icon="icon-pencil"></md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.EDIT">Edit</span>\n</md-tooltip></md-button></div></div>');
$templateCache.put('app/main/apps/questions-master/views/read/read-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="vm.loadingReadPane" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="content thread-detail" layout="row" layout-align="center center" flex \nng-if="!vm.questionSelected && !vm.questionNew"><div class="no-thread-selected" layout="column" \nlayout-align="center center" flex><md-icon md-font-icon="icon-google-circles-communities" class="s120 grey-400-fg">\n</md-icon><span class="hint-text" translate="GLOBAL.SELECT_ITEM"></span></div></div><div id="read-view" \nclass="fullheight"><div class="toolbar grey-100-bg colored-bg" layout="row" layout-align="space-between center" \nscroll="" ng-if="vm.questionSelected ||\xA0vm.questionNew"><div layout="row" layout-align="start center"></div><div \nlayout="row" layout-align="end center" hide show-gt-sm><md-button translate="GLOBAL.CANCEL" type="button" \nng-click="vm.closeQuestion()" class="md-raised md-warn" aria-label="Cancel"></md-button><md-button \ntranslate="GLOBAL.SAVE" type="button" ng-disabled="vm.basicForm.$invalid || vm.basicForm.$pristine" \nng-click="vm.sendQuestion()" class="md-raised md-accent" aria-label="Save"></md-button></div><div layout="row" \nlayout-align="end center" hide-gt-sm><md-button type="button" ng-click="vm.sendQuestion()" \nng-disabled="vm.checkFields()" class="md-accent md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" \naria-label="Send"><md-icon md-font-icon="icon-plus"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.SAVE"></span></md-tooltip></md-button><md-button type="button" ng-click="vm.closeQuestion()" \nclass="md-warn md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" aria-label="Cancel"><md-icon \nmd-font-icon="icon-window-close"></md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.CANCEL"></span>\n</md-tooltip></md-button></div></div><div class="main-content"><content ng-if="vm.questionSelected" class="" \nlayout="row" ng-include="\'app/main/apps/questions-master/views/read/edit.html\'"></content><content \nng-if="vm.questionNew" class="" ng-include="\'app/main/apps/questions-master/views/read/new.html\'"></content></div>\n</div>');
$templateCache.put('app/main/apps/questions/dialogs/forms/dialog-view.html','<md-dialog id="dialog-view" class="form-dialog add-media" aria-label="New Message"><md-toolbar class="md-accent"><div \nclass="md-toolbar-tools" layout="row" layout-align="space-between center"><div class="absolute-right" layout="row  ">\n<md-button class="md-icon-buttona" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</md-toolbar><form class="md-inline-form"><md-dialog-content ng-if="vm.title !== \'branch\'" id="site-content" flex \nclass="content-card over-hidden" ng-class="vm.currentView" \nng-include="\'app/main/apps/clients/dialogs/forms/forms-view-user.html\'"></md-dialog-content><md-dialog-content \nng-if="vm.title === \'branch\'" id="site-content" ms-scroll flex class="content-card" ng-class="vm.currentView" \nng-include="\'app/main/apps/clients/dialogs/forms/forms-view-delegation.html\'"></md-dialog-content></form></md-dialog>');
$templateCache.put('app/main/apps/questions/dialogs/forms/forms-view-delegation.html','<div id="forms" class="page-layout simple fullwidth doc-page forms" layout="column"><div class="p0" layout="column">\n<div layout="row"><ms-form-wizard class="popup" flex><md-tabs class="height-tabs" md-dynamic-height \nmd-selected="msWizard.selectedIndex" md-center-tabs="true"><md-tab><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" ng-if="wizardStep1.$invalid">1\n</span> <span class="ms-form-wizard-step-number md-accent-bg" ng-if="wizardStep1.$valid"><i class="icon-check s16"></i>\n </span><span translate="{{ vm.translate }}" class="ms-form-wizard-step-text"></span></span></md-tab-label>\n<md-tab-body><form name="wizardStep1" class="md-inline-form" ms-form-wizard-form novalidate><div class="items">\n<md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="field.field !== \'id\' && field.field !== \'fullName\'"><input \nng-if="field.field !== \'phone\' && field.field !== \'email\' && field.field !== \'position\'" type="{{field.type}}" \nname="{{field.field}}" ng-model="field.value" placeholder="{{ field.translate | translate }}" required> <input \nng-if="field.field === \'phone\' || field.field === \'email\'" type="{{field.type}}" name="{{field.field}}" \nng-model="field.value" placeholder="{{ field.translate | translate }}"><md-select \nng-disabled="vm.disabledPosition(field)" ng-if="field.field === \'position\'" ng-model="field.value" \nplaceholder="{{ field.translate | translate }}" required><md-option \nng-repeat="option in field.options track by $index" ng-value="option.id">{{option.field}}</md-option></md-select><div \nng-messages="wizardStep1.email.$error" role="alert" multiple="multiple"><div ng-message="pattern"><span \ntranslate="GLOBAL.EMAIL_VALID"></span></div></div></md-input-container></div></form></md-tab-body></md-tab></md-tabs>\n<div class="navigation" flex layout="row" layout-align="center center"><md-button translate="GLOBAL.SEND" \nclass="md-raised md-warn" ng-click="vm.sendForm()" ng-disabled="wizardStep1.$valid"></md-button></div></ms-form-wizard>\n</div></div></div>');
$templateCache.put('app/main/apps/questions/dialogs/forms/forms-view-user.html','<div ng-cloak><md-content><md-tabs md-dynamic-height md-border-bottom><md-tab label="Nuevo usuario"><md-content \nclass="md-padding p0"><div id="forms" class="page-layout simple fullwidth doc-page forms" layout="column"><div \nclass="p0" layout="column"><div layout="row"><ms-form-wizard class="popup" flex><md-tabs class="height-tabs" \nmd-dynamic-height md-selected="msWizard.selectedIndex" md-center-tabs="true"><md-tab><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" ng-if="wizardStep1.$invalid">1\n</span> <span class="ms-form-wizard-step-number md-accent-bg" ng-if="wizardStep1.$valid"><i class="icon-check s16"></i>\n </span><span translate="{{ vm.translate }}" class="ms-form-wizard-step-text"></span></span></md-tab-label>\n<md-tab-body><form name="wizardStep1" class="md-inline-form" ms-form-wizard-form novalidate><div class="items">\n<md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="field.field !== \'id\' && field.field !== \'fullName\'"><input \nng-if="field.field !== \'phone\' && field.field !== \'email\' && field.field !== \'position\'" type="{{field.type}}" \nname="{{field.field}}" ng-model="field.value" placeholder="{{ field.translate | translate }}" required> <input \nng-if="field.field === \'phone\' || field.field === \'email\'" type="{{field.type}}" name="{{field.field}}" \nng-model="field.value" placeholder="{{ field.translate | translate }}"><md-select \nng-disabled="vm.disabledPosition(field)" ng-if="field.field === \'position\'" ng-model="field.value" \nplaceholder="{{ field.translate | translate }}" required><md-option \nng-repeat="option in field.options track by $index" ng-value="option.id">{{option.field}}</md-option></md-select><div \nng-messages="wizardStep1.email.$error" role="alert" multiple="multiple"><div ng-message="pattern"><span \ntranslate="GLOBAL.EMAIL_VALID"></span></div></div></md-input-container></div></form></md-tab-body></md-tab></md-tabs>\n<div class="navigation" flex layout="row" layout-align="center center"><md-button translate="GLOBAL.SEND" \nclass="md-raised md-warn" ng-click="vm.sendForm()" ng-disabled="wizardStep1.$valid"></md-button></div></ms-form-wizard>\n</div></div></div></md-content></md-tab><md-tab label="Usuario existente"><md-content \nstyle="height: 210px; overflow: hidden;" class="md-padding mw-500 p0"><div class="search-input-wrapper" layout="row" \nlayout-align="start center"><label for="search"><md-icon class="icon-search" md-font-icon="icon-magnify"></md-icon>\n</label><md-input-container md-no-float class="m-0" flex="100"><input id="search" \nplaceholder="{{\'CONTACTS.SEARCH_FOR_ANYONE\' |\xA0translate}}" type="text" ng-model="searchText"></md-input-container>\n</div><div id="site-client" class="list-users-scroll"><div class="content thread-list mail-list-pane scrollable p0" \nflex="" ms-scroll="vm.msScrollOptions" id="thread-list"><div id="list-content-data" \nng-style="{\'opacity\' : isLoading ? 0.5 : 1}"><div class="mail-list-item" \nng-repeat="user in vm.users | filter:searchText" ng-init="parentIndex = $index" md-no-ink \nng-click="vm.selectUser(user)" \nng-class="{\'starred\': user.starred, \'selected\': vm.selectedContentID !== user.id_mailing_content, \'checked\': vm.isChecked(user)}">\n<div layout="row" layout-align="start center"><div class="info layout-column flex" flex="" layout="column"><div \nclass="name text-truncate" layout="row" layout-align="start center"><span>\n{{user.first_name}} {{user.last_name}} {{user.job_position.name}}</span></div></div></div></div></div></div></div>\n<md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" translate="" \ntranslate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" ng-if="$root.pagination_searchquery==true"><md-icon \nmd-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip hide show-gt-xs><span>Reset search</span></md-tooltip>\n</md-button></md-content></md-tab></md-tabs></md-content></div>');
$templateCache.put('app/main/apps/questions/dialogs/image/image-dialog.html','<md-dialog class="attachment-dialog" aria-label="New Task"><md-toolbar class="md-accent md-hue-2 md-default-theme"><div\n class="md-toolbar-tools"><div layout="row" hide show-gt-xs><a class="md-button" type="1" layout="row" \nlayout-align="center center" ng-click="vm.changeView(\'fotorama\')"><md-icon md-font-icon="icon-file-image-box" \nclass="s18 mr-5 ml-0"></md-icon><span translate="GLOBAL.PREVIEW">Preview Media</span></a></div><span flex></span><div \nlayout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content class="mediadialog-content" layout-fill><md-content flex class="content-card" \nng-class="vm.currentView" ng-include="vm.views[vm.currentView]" md-no-ink></md-content></md-dialog-content></md-dialog>');
$templateCache.put('app/main/apps/questions/dialogs/media/media-clients-tinymce.html','<md-dialog class="attachment-dialog add-media" aria-label="New Message"><form class="md-inline-form"><md-toolbar \nclass="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><div layout="row" \nhide show-gt-xs><a class="md-button" type="1" layout="row" layout-align="center center" \nng-click="vm.changeViewTiny(\'1\')"><md-icon md-font-icon="icon-file-image-box" class="s18 mr-5 ml-0"></md-icon><span>\nAttached Media</span></a></div><div layout="row" hide-gt-xs show-xs><md-menu><md-button aria-label="Filters" \nng-click="$mdMenu.open($event)" translate="" translate-attr-aria-label="GLOBAL.FILTERS"><span layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-file-image-box" class="s18 mr-5 ml-0"></md-icon><span \nclass="ml-5">Images</span> <i class="icon-chevron-down s20 ml-5"></i></span></md-button><md-menu-content width="3">\n<md-menu-item><md-button type="photos" ng-click="vm.changeViewTiny(\'1\')"><div layout="row" \nlayout-align="space-between center"><div><md-icon md-font-icon="icon-file-image-box" class="s18"></md-icon><span>Images\n</span></div><i class="icon-check s16" ng-if="sortfield.titleId == sortable.titleId"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu></div><div layout="row"><md-button class="md-icon-button" \nng-click="vm.closeDialog()" aria-label="Close dialog" tranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon \nmd-font-icon="icon-close"></md-icon></md-button></div></div></md-toolbar><div flex \nng-include="\'app/main/apps/clients/dialogs/media/views/templates/toolbar-search.html\'"></div><md-dialog-content \nclass="mediadialog-content scrollable" layout-fill ms-scroll><treasure-overlay-spinner active="vm.loading"><div \nlayout="column" flex><md-content flex class="content-card" ng-class="vm.currentViewTiny" \nng-include="vm.viewsTiny[vm.currentViewTiny]" md-no-ink></md-content></div></treasure-overlay-spinner>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="space-between center" ng-if="!vm.loading"><div \nlayout="row" layout-align="start center"></div><div layout="row" layout-align="end right"><md-button \nng-click="vm.attachMediaTiny()" class="send-button md-accent md-raised" aria-label="Send" translate="GLOBAL.ADD_FILE" \ntranslate-attr-aria-label="GLOBAL.ADD_FILE">ADD</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/questions/dialogs/media/media-clients.html','<md-dialog class="attachment-dialog add-media" aria-label="New Message"><form class="md-inline-form"><md-toolbar \nclass="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><div layout="row" \nhide show-gt-xs><a class="md-button" type="upload" layout="row" layout-align="center center" \nng-click="vm.changeView(\'upload\')"><md-icon md-font-icon="icon-import" class="s18 mr-5 ml-0"></md-icon><span>Upload\n</span></a></div><div layout="row" hide-gt-xs show-xs><md-menu><md-button aria-label="Filters" \nng-click="$mdMenu.open($event)" translate="" translate-attr-aria-label="GLOBAL.FILTERS"><span layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-file-image-box" class="s18 mr-5 ml-0"></md-icon><span \nclass="ml-5" ng-if="vm.currentView===\'upload\'">Upload</span><i class="icon-chevron-down s20 ml-5"></i></span>\n</md-button><md-menu-content width="3"><md-menu-item><md-button type="import" ng-click="vm.changeView(\'import\')"><div \nlayout="row" layout-align="space-between center"><div><md-icon md-font-icon="icon-import" class="s18"></md-icon><span>\nUpload</span></div><i class="icon-check s16" ng-if="vm.currentView===\'upload\'"></i></div></md-button></md-menu-item>\n</md-menu-content></md-menu></div><div layout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog" tranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></div></md-toolbar><md-dialog-content ms-scroll flex class="content-card" \nng-class="vm.currentView" ng-include="vm.views[vm.currentView]"></md-dialog-content></form></md-dialog>');
$templateCache.put('app/main/apps/register-book/dialogs/create-report/register-book-report-dialog.html','<md-dialog class="form-dialog register-book-report-dialog" \naria-label="{{ \'REGISTER_BOOK.GENERATE_BOOK\' | translate }}"><md-toolbar class="md-accent md-hue-2"><div \nclass="md-toolbar-tools" layout="row" layout-align="space-between center"><div layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-file-pdf-box" \nclass="s24 mr-15 ml-15 register-book-report-pdf-icon"></md-icon><h3 class="text-uppercase" \ntranslate="REGISTER_BOOK.DIALOG_TITLE"></h3></div><div class="absolute-right pr-10" layout="row"><md-button \nclass="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" \ntranslate-attr-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</md-toolbar><div class="dialog-content"><div fill-width layout="column" class="p-24"><div \nclass="form-wrapper md-whiteframe-2dp p-24 mb-24" flex="100"><form name="vm.registerBookReportForm" \nclass="md-inline-form" novalidate><div layout="row" layout-wrap class="register-book-report-fields"><md-input-container\n class="md-block" flex="100"><label translate="REGISTER_BOOK.REPORT_TITLE_LABEL"></label> <input required type="text" \nname="title" ng-model="vm.form.title"></md-input-container><md-input-container class="md-block" flex="100" \nflex-gt-xs="50"><label translate="REGISTER_BOOK.REPORT_LANGUAGE_LABEL"></label><md-select \nng-model="vm.form.language_code" required><md-option ng-repeat="option in vm.languageOptions track by option.code" \nng-value="option.code">{{ option.label }}</md-option></md-select></md-input-container><div \nclass="register-book-report-range" flex="100"><span class="register-book-report-section-label" \ntranslate="REGISTER_BOOK.REPORT_RANGE_LABEL"></span><md-radio-group ng-model="vm.form.range_mode" \nng-change="vm.onRangeModeChange()"><div class="register-book-report-radio-row" layout="row" \nlayout-align="start center" ng-click="vm.form.range_mode = \'all\'; vm.onRangeModeChange()"><md-radio-button value="all" \nclass="register-book-report-radio" aria-label="{{ \'REGISTER_BOOK.RANGE_MODE_ALL\' | translate }}"></md-radio-button>\n<span class="register-book-report-radio-text" translate="REGISTER_BOOK.RANGE_MODE_ALL"></span></div><div \nclass="register-book-report-radio-row" layout="row" layout-align="start center" \nng-click="vm.form.range_mode = \'date_range\'; vm.onRangeModeChange()"><md-radio-button value="date_range" \nclass="register-book-report-radio" aria-label="{{ \'REGISTER_BOOK.RANGE_MODE_DATE_RANGE\' | translate }}">\n</md-radio-button><span class="register-book-report-radio-text" translate="REGISTER_BOOK.RANGE_MODE_DATE_RANGE"></span>\n</div></md-radio-group></div><div layout="row" layout-wrap ng-if="vm.isDateRange()" class="register-book-report-dates" \nflex="100"><div class="register-book-report-date-field" flex="100" flex-gt-xs="50"><label \nclass="register-book-report-date-label" translate="REGISTER_BOOK.REPORT_FROM_DATE"></label><md-datepicker \nclass="register-book-report-datepicker" ng-model="vm.form.from_date" md-date-locale="vm.dayFormat" \nmd-max-date="vm.form.to_date" md-placeholder="{{ \'REGISTER_BOOK.REPORT_FROM_DATE\' | translate }}"></md-datepicker>\n</div><div class="register-book-report-date-field" flex="100" flex-gt-xs="50"><label \nclass="register-book-report-date-label" translate="REGISTER_BOOK.REPORT_TO_DATE"></label><md-datepicker \nclass="register-book-report-datepicker" ng-model="vm.form.to_date" md-date-locale="vm.dayFormat" \nmd-min-date="vm.form.from_date" md-placeholder="{{ \'REGISTER_BOOK.REPORT_TO_DATE\' | translate }}"></md-datepicker>\n</div></div><div class="register-book-report-date-error" ng-if="vm.isDateRangeInvalid()" flex="100"><span \ntranslate="REGISTER_BOOK.REPORT_DATE_RANGE_INVALID"></span></div></div></form></div></div><md-dialog-actions \nlayout="row" layout-align="end center" class="grey-100-bg p-16"><md-button ng-click="vm.closeDialog()" \nclass="md-raised"><span translate="GLOBAL.CLOSE"></span></md-button><md-button ng-click="vm.submit()" \nclass="md-accent md-raised" ng-disabled="!vm.canSubmit()"><md-icon md-font-icon="icon-check" class="mr-10"></md-icon>\n<span translate="COMPLAINTS.GENERATE"></span></md-button></md-dialog-actions></div></md-dialog>');
$templateCache.put('app/main/apps/register-book/dialogs/preview/register-book-preview-dialog.html','<md-dialog class="form-dialog register-book-preview-dialog" aria-label="{{ \'GLOBAL.PREVIEW\' | translate }}"><md-toolbar\n class="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><h1>\n{{ \'GLOBAL.PREVIEW\' | translate }}</h1><div class="absolute-right pr-10" layout="row"><md-button \nclass="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" \ntranslate-attr-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content class="register-book-preview-content" flex><iframe class="register-book-preview-frame" \nng-src="{{vm.previewUrl | toTrustedResource}}" frameborder="0"></iframe></md-dialog-content><md-dialog-actions \nlayout="row" layout-align="end center" class="grey-100-bg register-book-preview-actions"><md-button \nng-click="vm.closeDialog()" class="send-button md-accent md-raised" aria-label="close" translate="GLOBAL.CLOSE" \ntranslate-attr-aria-label="GLOBAL.CLOSE"></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/main/apps/questions/views/questionnaires/a.html','');
$templateCache.put('app/main/apps/questions/views/questionnaires/advanced.html','<div class="content grey-100-bg thread-detail" layout="row" layout-align="center center" flex \nng-if="!vm.currentQuestion"><div class="no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-question-mark-circle" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="QUESTIONS.SELECT_QUESTION"></span></div></div><div class="without-line scrollable preview" flex="100" \nng-if="vm.currentQuestion"><div layout="column"><div layout="column" layout-gt-xs="row" layout-align="center start" \nlayout-align-gt-xs="space-between center" class="pl-24 pr-24 pt-40 pb-40"><h1 \nng-bind-html="vm.currentQuestion.question.name"></h1><div layout="row" layout-align="center center" \nclass="pl-24 yes-no-combo"><div class="field" ng-if="vm.currentQuestion.isLoading"><md-progress-circular \nmd-mode="indeterminate" md-diameter="30"></md-progress-circular></div><div class="field" \nng-if="!vm.currentQuestion.isLoading" layout="row" layout-align="center center"><md-button aria-label="Yes" \nclass="md-fab md-raised md-accent md-green-600-bg" ng-click="vm.answerQuestion($event, true)" \nng-hide="(vm.totalRiskProcess(vm.currentQuestion.risks) == 0 || vm.totalRiskControls(vm.currentQuestion.risks) == 0) || vm.currentQuestion.is_answered == 1">\n<span translate="GLOBAL.YES"></span></md-button><md-button aria-label="No" \nclass="md-fab md-raised md-accent md-red-600-bg" ng-click="vm.answerQuestion($event, false)" \nng-hide="(vm.totalRiskProcess(vm.currentQuestion.risks) == 0 || vm.totalRiskControls(vm.currentQuestion.risks) == 0) || vm.currentQuestion.is_answered == 1">\n<span translate="GLOBAL.NO"></span></md-button><span \nng-if="vm.totalRiskProcess(vm.currentQuestion.risks) == 0 || vm.totalRiskControls(vm.currentQuestion.risks) == 0" \nclass="badge negative" translate="QUESTIONS.RISK_INCOMPLETE"></span> <span \nng-if="vm.currentQuestion.is_answered == 1 && vm.currentQuestion.answer && vm.currentQuestion.is_finished" \nclass="badge afirmative" translate="GLOBAL.ANSWERED_YES"></span> <span \nng-if="vm.currentQuestion.is_answered == 1 && vm.currentQuestion.answer && !vm.currentQuestion.is_finished" \nclass="badge process" translate="GLOBAL.IN_PROCESS"></span> <span \nng-if="vm.currentQuestion.is_answered == 1 && !vm.currentQuestion.answer" class="badge negative" \ntranslate="GLOBAL.ANSWERED_NO"></span></div></div></div><div ng-repeat="risk in vm.currentQuestion.risks" \nclass="pr-24 pl-24 pb-24"><div class="white-bg border"><div class="toolbar colored-bg" layout="row" \nlayout-align="start center"><div class="font-size-20" ng-bind-html="risk.name"></div></div><md-divider></md-divider>\n<div layout="column" layout-gt-xs="row" layout-align="center start" layout-align-gt-xs="center center" \nclass="pt-32 pb-32 pl-10 pr-10"><a ng-if="risk.external_link" class="md-button" ng-href="{{risk.external_link}}" \ntarget="_blank" layout="row" layout-align="start center"><span translate="RISK.CODIGO_PENAL"></span> <i \nclass="icon-link-variant s16 ml-5"></i></a><md-button ng-if="risk.description" md-no-ink class="md-primary" \nng-click="vm.openDialogText($event, risk.description, \'RISK.DESCRIPTION\')" translate="RISK.DESCRIPTION"></md-button>\n<md-button ng-if="risk.conducts" md-no-ink class="md-primary" \nng-click="vm.openDialogText($event, risk.conducts, \'RISK.CONDUCTS\')" translate="RISK.CONDUCTS"></md-button><md-button \nng-if="risk.factual_causes" md-no-ink class="md-primary" \nng-click="vm.openDialogText($event, risk.factual_causes, \'RISK.FACTUAL_CAUSES\')" translate="RISK.FACTUAL_CAUSES">\n</md-button><md-button ng-if="risk.penalties" md-no-ink class="md-primary" \nng-click="vm.openDialogText($event, risk.penalties, \'RISK.PENALTIES\')" translate="RISK.PENALTIES"></md-button></div>\n<div layout="column" layout-gt-xs="row" layout-align="center space-between" layout-align-gt-xs="center center" \nclass="text-center pb-32" \nng-class="(vm.currentQuestion.is_answered == 1 && vm.currentQuestion.answer) ? \'grey-50-bg pt-32 border-top\' : \'\'">\n<md-input-container ng-if="vm.branding.tenant != \'gnl\'" \nclass="ml-24 mr-20 mt-0 mb-15 pv-24 ph-15 circle-graph white-bg" layout="column" layout-align="center start" \nlayout-align-gt-xs="center center" flex ng-if="!vm.currentQuestion.isLoading"><div class="field grey-500-fg" \ntranslate="RISK.REPUTATION_IMPACT"></div><div class="field" ng-bind-html="vm.showRiskLevel(risk.reputation_impact)" \nng-hide="vm.currentQuestion.is_answered == 1 && vm.currentQuestion.answer"></div><md-select \nng-disabled="vm.currentQuestion.is_finished" ng-model="risk.reputation_impact" placeholder="-" \nng-change="vm.updateRiskLevels(risk)" ng-show="vm.currentQuestion.is_answered == 1 && vm.currentQuestion.answer">\n<md-option class="small" ng-value="1" ng-disabled="$index === 1" translate="RISK.RISK_LEVELS_1"></md-option><md-option \nclass="small" ng-value="2" ng-disabled="$index === 2" translate="RISK.RISK_LEVELS_2"></md-option><md-option \nclass="small" ng-value="3" ng-disabled="$index === 3" translate="RISK.RISK_LEVELS_3"></md-option><md-option \nclass="small" ng-value="4" ng-disabled="$index === 4" translate="RISK.RISK_LEVELS_4"></md-option><md-option \nclass="small" ng-value="5" ng-disabled="$index === 5" translate="RISK.RISK_LEVELS_5"></md-option></md-select>\n</md-input-container><md-input-container class="ml-24 mr-20 mt-0 mb-15 pv-24 ph-15 circle-graph white-bg" \nlayout="column" layout-align="center start" layout-align-gt-xs="center center" flex \nng-if="!vm.currentQuestion.isLoading"><div class="field grey-500-fg" translate="RISK.PENAL_CODE_IMPACT"></div><div \nclass="field" ng-bind-html="vm.showRiskLevel(risk.penal_code_impact)" \nng-hide="vm.currentQuestion.is_answered == 1 && vm.currentQuestion.answer"></div><md-select \nng-disabled="vm.currentQuestion.is_finished" ng-model="risk.penal_code_impact" placeholder="-" \nng-change="vm.updateRiskLevels(risk)" ng-if="vm.currentQuestion.is_answered == 1 && vm.currentQuestion.answer">\n<md-option class="small" ng-value="1" ng-disabled="$index === 1" translate="RISK.RISK_LEVELS_1"></md-option><md-option \nclass="small" ng-value="2" ng-disabled="$index === 2" translate="RISK.RISK_LEVELS_2"></md-option><md-option \nclass="small" ng-value="3" ng-disabled="$index === 3" translate="RISK.RISK_LEVELS_3"></md-option><md-option \nclass="small" ng-value="4" ng-disabled="$index === 4" translate="RISK.RISK_LEVELS_4"></md-option><md-option \nclass="small" ng-value="5" ng-disabled="$index === 5" translate="RISK.RISK_LEVELS_5"></md-option></md-select>\n</md-input-container><md-input-container class="ml-24 mr-20 mt-0 mb-15 pv-24 ph-15 circle-graph white-bg" \nlayout="column" layout-align="center start" layout-align-gt-xs="center center" flex \nng-if="!vm.currentQuestion.isLoading"><div class="field grey-500-fg" translate="RISK.CLIENT_LOSS"></div><div \nclass="field" ng-bind-html="vm.showRiskLevel(risk.client_loss)" \nng-hide="vm.currentQuestion.is_answered == 1 && vm.currentQuestion.answer"></div><md-select \nng-disabled="vm.currentQuestion.is_finished" ng-model="risk.client_loss" placeholder="-" \nng-change="vm.updateRiskLevels(risk)" ng-if="vm.currentQuestion.is_answered == 1 && vm.currentQuestion.answer">\n<md-option class="small" ng-value="1" ng-disabled="$index === 1" translate="RISK.RISK_LEVELS_1"></md-option><md-option \nclass="small" ng-value="2" ng-disabled="$index === 2" translate="RISK.RISK_LEVELS_2"></md-option><md-option \nclass="small" ng-value="3" ng-disabled="$index === 3" translate="RISK.RISK_LEVELS_3"></md-option><md-option \nclass="small" ng-value="4" ng-disabled="$index === 4" translate="RISK.RISK_LEVELS_4"></md-option><md-option \nclass="small" ng-value="5" ng-disabled="$index === 5" translate="RISK.RISK_LEVELS_5"></md-option></md-select>\n</md-input-container></div><md-divider></md-divider><div layout="row" layout-align="start center" class="p-24"><h2 \ntranslate="RISK.PROCESS_AND_CONTROLS" class="mt-0 mb-0"></h2></div><md-divider></md-divider><div layout="row" \nlayout-align="start start"><md-list flex="100" class="p-0"><div ng-repeat="process in risk.processes" class="process" \nng-init="item = process"><md-list-item><div class="info pl-8 pr-8" flex layout="column"><div layout="row" \nlayout-align="space-between center" flex="100"><div layout="row" layout-align="start center" flex class="pt-24"><div \nclass="avatar" ng-style="{\'background\': \'rgba(25,147,232,1)\'}">P</div><div ng-if="!item.isRenaming" class="field">\n<strong class="grey-800-fg">\n{{process.rename ? process.rename : vm.controlsData[process.id].process_rename ? vm.controlsData[process.id].process_rename : process.name}}\n</strong><md-button class="edit-button md-icon-button" ng-click="vm.toggleRename(item, process.id)" \naria-label="rename" translate \nng-if="vm.currentQuestion.is_answered == 1 && vm.currentQuestion.answer && !vm.currentQuestion.is_finished && !item.isRenaming">\n<md-icon md-font-icon="icon-pencil" class="s16"></md-icon></md-button></div><form ng-if="item.isRenaming" \nclass="fullwidth" layout="row" layout-align="center center" ng-submit="vm.renameProcessOrControl(item, process.id)">\n<md-input-container class="fullwidth" class="mt-4"><label translate="QUESTIONS.RENAME"></label> <input \nng-disabled="item.isLoading" flex type="text" ng-model="item.rename"></md-input-container><md-button \nclass="edit-button md-icon-button" type="submit" aria-label="save" translate ng-disabled="item.isLoading"><md-icon \nmd-font-icon="icon-content-save" class="s16"></md-icon></md-button><md-button class="edit-button md-icon-button" \nng-click="vm.toggleRename(item, process.id, null, true)" aria-label="cancel" translate ng-disabled="item.isLoading">\n<md-icon md-font-icon="icon-cancel" class="s16"></md-icon></md-button></form></div></div><md-input-contaimer \nclass="md-block pl-50 pt-5 pb-25" flex="100" flex-gt-xs="33"><div class="field grey-500-fg">\n{{\'RISK.PROCESS_SCORE\' | translate}}: <span class="grey-800-fg" ng-if="process.score == 1" \ntranslate="RISK.PROCESS_AVERAGE_1"></span> <span class="grey-800-fg" ng-if="process.score == 2" \ntranslate="RISK.PROCESS_AVERAGE_2"></span> <span class="grey-800-fg" ng-if="process.score == 3" \ntranslate="RISK.PROCESS_AVERAGE_3"></span> <span class="grey-800-fg" ng-if="process.score == 4" \ntranslate="RISK.PROCESS_AVERAGE_4"></span> <span class="grey-800-fg" ng-if="process.score == 5" \ntranslate="RISK.PROCESS_AVERAGE_5"></span><md-button \nng-if="vm.currentQuestion.is_answered == 1 && vm.currentQuestion.answer && !vm.currentQuestion.is_finished" \nclass="edit-button md-icon-button" ng-click="vm.updateProcessScore($event, process)" aria-label="edit odds" translate>\n<md-icon md-font-icon="icon-pencil" class="s16"></md-icon></md-button></div></md-input-contaimer></div></md-list-item>\n<div ng-hide="!vm.currentQuestion.is_answered == 1" \nng-if="((process.IN_CHARGE.length> 0 || process.PARTICIPANT.length > 0) && vm.currentQuestion.is_finished) || !vm.currentQuestion.is_finished" \nlayout="column" layout-align="center center" layout-align-gt-xs="space-between start" layout-gt-xs="row" \nng-if="vm.currentQuestion.is_answered == 1 && vm.currentQuestion.answer" \nng-class="(vm.currentQuestion.is_answered == 1 && vm.currentQuestion.answer) ? \'grey-50-bg border-top\' : \'text-center\'">\n<div layout="column" layout-align="start start" flex="100" flex-gt-xs="33" class="ml-24 mr-20 pt-32 pb-32"><div \nng-if="!vm.currentQuestion.is_finished && vm.currentQuestion.is_answered == 1" class="grey-500-fg mb-5" layout="row" \nlayout-align="start center"><div class="field" translate="RISK.USERS_ADMIN"></div><a class="pointer" \nng-click="vm.openDialogUsers($event, process, null, \'IN_CHARGE\')" class="ml-5"><md-icon \nmd-font-icon="icon-plus-circle" class="avatar s24"></md-icon></a></div><div ng-if="process.IN_CHARGE.length> 0" \nclass="avatar-wrapper"><div ng-repeat="user in process.IN_CHARGE" class="mb-5" layout="row" \nlayout-align="start center"><img class="avatar s24" ng-src="{{vm.showUserImage(user)}}" ng-if="user.files.id"><div \nclass="avatar s24" ng-class="user.profile_color" ng-if="!user.files.id" \nng-bind="user.first_name | capitalizeFirstLetter"></div><span>{{user.first_name}} {{user.last_name}}</span></div></div>\n</div><div layout="column" layout-align="start start" flex="100" flex-gt-xs="33" class="mr-20 ml-24 pt-32 pb-32"><div \nng-if="!vm.currentQuestion.is_finished && vm.currentQuestion.is_answered == 1" class="grey-500-fg mb-5" layout="row" \nlayout-align="start center"><div class="field" translate="RISK.USERS_PARTICIPANTS"></div><a class="pointer" \nng-click="vm.openDialogUsers($event, process, null, \'PARTICIPANT\')" class="ml-5"><md-icon \nmd-font-icon="icon-plus-circle" class="avatar s24"></md-icon></a></div><div class="avatar-wrapper"><div \nng-repeat="user in process.PARTICIPANT" class="mb-5" layout="row" layout-align="start center"><img class="avatar s24" \nng-src="{{vm.showUserImage(user)}}" ng-if="user.files.id"><div class="avatar s24" ng-class="user.profile_color" \nng-if="!user.files.id" ng-bind="user.first_name | capitalizeFirstLetter"></div><span>\n{{user.first_name}} {{user.last_name}}</span></div></div></div></div><md-divider></md-divider><div \nclass="process-controls" ng-if="process.controls.length> 0" ng-repeat="control in process.controls" \nng-init="vm.setControlsData(process.id, control.id); item = control;"><md-list-item layout="row" \nlayout-align="start center" class="no-padding" \nng-class="(process.id == vm.currentControl.process && control.id == vm.currentControl.control) ? \'current-control\' : \'\'">\n<div layout="row" layout-align="start center" flex="100" class="pl-0 pr-0 pv-20"><div class="info" flex \nlayout="column"><div class="name ph-15" layout="row"><div layout="column" layout-gt-xs="row" \nlayout-align="start center" flex="100"><div layout="row" layout-align="start center" class="fullwidth"><div \nclass="avatar" ng-style="{\'background\': \'rgba(132,173,78,1)\'}">C</div><div ng-if="!item.isRenaming" \nclass="field mr-10 ml-10" flex><strong class="grey-800-fg">\n{{ control.rename ? control.rename : vm.controlsData[process.id][control.id].control_rename? vm.controlsData[process.id][control.id].control_rename :control.name}}\n</strong><md-button class="edit-button md-icon-button" ng-click="vm.toggleRename(item, process.id, control.id)" \naria-label="rename" translate \nng-if="vm.currentQuestion.is_answered == 1 && vm.currentQuestion.answer && !vm.currentQuestion.is_finished && !item.isRenaming">\n<md-icon md-font-icon="icon-pencil" class="s16"></md-icon></md-button></div><form ng-if="item.isRenaming" layout="row" \nlayout-align="center center" class="fullwidth" ng-submit="vm.renameProcessOrControl(item, process.id, control.id)">\n<md-input-container class="fullwidth" class="mt-4" ng-if="item.isRenaming"><label translate="QUESTIONS.RENAME"></label>\n <input ng-disabled="item.isLoading" class="fullwidth" type="text" ng-model="item.rename"></md-input-container>\n<md-button class="edit-button md-icon-button" type="submit" aria-label="save" translate ng-disabled="item.isLoading">\n<md-icon md-font-icon="icon-content-save" class="s16"></md-icon></md-button><md-button \nclass="edit-button md-icon-button" ng-click="vm.toggleRename(item, process.id, control.id, true)" aria-label="cancel" \ntranslate ng-disabled="item.isLoading"><md-icon md-font-icon="icon-cancel" class="s16"></md-icon></md-button></form>\n</div><div layout="row" layout-align="end start" ng-if="vm.currentQuestion.answer && !vm.currentQuestion.isLoading">\n<div layout="row" layout-align="space-between center"><div class="field" \nng-if="vm.controlsData[process.id][control.id].isLoading"><md-progress-circular md-mode="indeterminate" \nmd-diameter="30"></md-progress-circular></div><div layout="row" class="field" \nng-if="!vm.controlsData[process.id][control.id].isLoading && vm.controlsData[process.id][control.id] && vm.controlsData[process.id][control.id].id_active_control">\n<md-button aria-label="Yes" class="md-mini md-fab md-raised md-accent md-green-600-bg" \nng-click="vm.answerQuestionControl(process, control, true)" \nng-show="((vm.controlsData[process.id][control.id].is_answered == 1 || vm.currentQuestion.is_finished) && vm.controlsData[process.id][control.id].visible == 1) || (!vm.currentQuestion.is_finished &&\n                                                                    vm.controlsData[process.id][control.id].is_answered == 0)">\n<span translate="GLOBAL.YES"></span></md-button><md-button aria-label="No" \nclass="md-mini md-fab md-raised md-accent md-red-600-bg" ng-click="vm.answerQuestionControl(process, control, false)" \nng-show="((vm.controlsData[process.id][control.id].is_answered == 1 || vm.currentQuestion.is_finished) && vm.controlsData[process.id][control.id].visible == 0) || (!vm.currentQuestion.is_finished &&\n                                                                    vm.controlsData[process.id][control.id].is_answered == 0)">\n<span translate="GLOBAL.NO"></span></md-button><md-button aria-label="NoApplies" \nclass="md-mini md-raised md-accent md-red-900-bg" ng-click="vm.deleteActiveControl(process, control)" \nng-show="((vm.controlsData[process.id][control.id].is_answered == 1 || vm.currentQuestion.is_finished) && !vm.controlsData[process.id][control.id].visible == null) || (!vm.currentQuestion.is_finished &&\n                                                                    vm.controlsData[process.id][control.id].is_answered == 0)">\n<span translate="GLOBAL.NO_APPLIES"></span></md-button></div><div class="field" \nng-if="!vm.controlsData[process.id][control.id].isLoading && !vm.controlsData[process.id][control.id].id_active_control">\n<md-button aria-label="NoApplies" class="md-mini md-raised md-accent md-red-900-bg"><span \ntranslate="GLOBAL.NO_APPLIES"></span></md-button></div></div></div></div></div><div \nng-hide="((vm.controlsData[process.id][control.id].IN_CHARGE.length == 0 && vm.controlsData[process.id][control.id].PARTICIPANT.length == 0 && vm.controlsData[process.id][control.id].evidences.length == 0) && vm.currentQuestion.is_finished)" \nlayout="column" layout-align="start space-between" \nng-if="vm.controlsData[process.id][control.id].is_answered == 1 && vm.controlsData[process.id][control.id].visible == 1" \nclass="grey-50-bg border-top border-bottom pb-20 ph-20 mt-20"><div layout="column" layout-align="center center" \nlayout-align-gt-xs="space-between start" layout-gt-xs="row"><div class="grey-600-fg pt-32 pb-32" layout="column" \nlayout-align="start start" flex="100" flex-gt-xs="50"><div ng-if="!vm.currentQuestion.is_finished" layout="row" \nlayout-align="start center" class="mb-5"><div class="field" translate="RISK.USERS_ADMIN"></div><a class="pointer" \nng-click="vm.openDialogUsers($event,process, control, \'IN_CHARGE\')" class="ml-5"><md-icon \nmd-font-icon="icon-plus-circle" class="avatar s24"></md-icon></a></div><div class="avatar-wrapper"><div \nng-repeat="user in vm.controlsData[process.id][control.id].IN_CHARGE" class="mb-5" layout="row" \nlayout-align="start center"><img class="avatar s24" ng-src="{{vm.showUserImage(user)}}" ng-if="user.files.id"><div \nclass="avatar s24" ng-class="user.profile_color" ng-if="!user.files.id" \nng-bind="user.first_name | capitalizeFirstLetter"></div><span>{{user.first_name}} {{user.last_name}}</span></div></div>\n</div><div class="grey-600-fg pt-32 pb-32" layout="column" layout-align="start start" flex="100" flex-gt-xs="50"><div \nng-if="!vm.currentQuestion.is_finished" layout="row" layout-align="start center" class="mb-5"><div class="field" \ntranslate="RISK.USERS_PARTICIPANTS"></div><a class="pointer" \nng-click="vm.openDialogUsers($event,process, control, \'PARTICIPANT\')" class="ml-5"><md-icon \nmd-font-icon="icon-plus-circle" class="avatar s24"></md-icon></a></div><div class="avatar-wrapper"><div \nng-repeat="user in vm.controlsData[process.id][control.id].PARTICIPANT track by $index" class="mb-5" layout="row" \nlayout-align="start center"><img class="avatar s24" ng-src="{{vm.showUserImage(user)}}" ng-if="user.files.id"><div \nclass="avatar s24" ng-class="user.profile_color" ng-if="!user.files.id" \nng-bind="user.first_name | capitalizeFirstLetter"></div><span>{{user.first_name}} {{user.last_name}}</span></div></div>\n</div></div><div layout="column" layout-align="start space-between" layout-align-gt-xs="center space-between"><div \nclass="grey-600-fg field" ng-if="vm.controlsData[process.id][control.id].visible">Evidencias</div><div \nng-if="!vm.controlsData[process.id][control.id].evidences || vm.controlsData[process.id][control.id].evidences.length == 0" \nfill-width style="margin-top: 20%;" class="text-center"><div class="no-thread-selected" layout="column" \nlayout-align="center center" flex><md-icon md-font-icon="icon-timelapse" class="s120 grey-400-fg"></md-icon><span \nclass="hint-text">{{\'RISK.NO_EVIDENCES_FOUND\' | translate}}</span></div></div><md-list-item \nng-repeat="evidence in vm.controlsData[process.id][control.id].evidences" class="evidence"><div layout="row" \nlayout-align="start center" flex="100" class="pt-10 pb-10"><div class="info" flex layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><img \nclass="avatar s24" ng-src="{{vm.showUserImage(evidence.user)}}" ng-if="evidence.user.files.id"><div class="avatar s24" \nng-class="evidence.user.profile_color" ng-if="!evidence.user.files.id" \nng-bind="evidence.user.first_name | capitalizeFirstLetter"></div></div><div class="field mr-10 ml-10" flex><strong \nclass="grey-800-fg" ng-bind-html="evidence.title"></strong><div class="grey-600-fg" ng-bind-html="evidence.text"></div>\n</div><div layout-align="end start"><div layout="row" layout-align="space-between center"><strong \nclass="grey-800-fg mr-10">{{evidence.amount}}{{vm.getSymbolCurrency(evidence.currency_id)}}</strong><div class="field" \nng-bind-html="vm.translate(\'RISK.CONTROL_SCORE_\' + evidence.score)"></div></div></div></div></div></div></div>\n<md-divider></md-divider></md-list-item><div layout="row" layout-align="center center" flex="100" \nng-if="vm.controlsData[process.id][control.id].visible"><div class="grey-600-fg add-new-evidence-btn pt-15" flex="100" \nng-if="!vm.controlsData[process.id][control.id].newEvidence"><md-button ng-if="!vm.currentQuestion.is_finished" \ntranslate="RISK.ADD_NEW_EVIDENCE" type="button" ng-click="vm.openEvidence($event, process.id, control)" \nclass="ml-0 md-raised md-accent" aria-label="Edit"></md-button></div><div class="grey-600-fg" flex="100" \nng-if="vm.controlsData[process.id][control.id].newEvidence"><div layout="row" layout-align="start center" flex="100">\n<div class="field new-evidence border"><h2 translate="RISK.NEW_EVIDENCE"></h2><md-input-container class="md-block">\n<label>Title</label> <input ng-model="vm.evidenceData.title"></md-input-container><md-input-container class="md-block">\n<label>Text</label> <textarea ng-model="vm.evidenceData.text" rows="3" md-select-on-focus></textarea>\n</md-input-container><md-input-contaimer class="md-block"><md-select ng-model="vm.evidenceData.score" \nplaceholder="Score"><md-option ng-value="1" translate="RISK.CONTROL_SCORE_1"></md-option><md-option ng-value="2" \ntranslate="RISK.CONTROL_SCORE_2"></md-option><md-option ng-value="3" translate="RISK.CONTROL_SCORE_3"></md-option>\n<md-option ng-value="4" translate="RISK.CONTROL_SCORE_4"></md-option><md-option ng-value="5" \ntranslate="RISK.CONTROL_SCORE_5"></md-option></md-select></md-input-contaimer><div class="mb-10"><div ngf-drop \nngf-select ng-model="vm.files" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" \nngf-allow-dir="true" accept="video/*,image/*,application/pdf,audio/*" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*\'"><div layout="column"><div flex translate="RISK.DROP_HERE">\n</div><div flex translate="RISK.OR"></div><div flex><md-button class="send-button md-accent md-raised" \naria-label="Select files" translate="RISK.SELECT_FILES"></md-button></div></div></div><div ngf-no-file-drop \ntranslate="RISK.FILE_DRAG_DROP"></div><div ng-repeat="f in vm.files" class="ms-card" flex><div \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><img ngf-thumbnail="!f.$error && f" class="image"></div><div class="header p-16" flex><div\n layout="row" layout-align="space-between center" flex><div class="size" layout="row" layout-align="start left"><strong\n class="mr-5" ng-if="f.id">#{{f.id}}</strong> <span class="grey-500-fg"><span ng-if="f.name">{{f.name}}</span></span>\n</div></div></div><md-progress-linear md-mode="determinate" value="{{f.progress}}" ng-show="f.progress <100">\n</md-progress-linear></div></div></div></div><md-button class="md-raised md-accent ml-0" ng-if="!vm.loadingEvidences" \nng-click="vm.saveEvidence(process.id, control.id, control.id_active_control)" translate="RISK.SAVE"></md-button>\n<md-list flex="100" ng-show="vm.controlsData[process.id][control.id].evidences && vm.loadingEvidences"><div \nclass="evidence"><md-list-item><div layout="row" layout-align="space-between center" flex="100" class="pt-10 pb-10">\n<div layout="row" layout-align="start center" flex><div class="field"><md-progress-circular md-mode="indeterminate" \nmd-diameter="30"></md-progress-circular></div></div></div></md-list-item></div></md-list></div></div></div></div></div>\n</div></div></div></md-list-item><md-divider></md-divider></div></div></md-list></div></div></div><div layout="column" \nlayout-gt-xs="row" layout-align="center end" layout-align-gt-xs="end center" class="pl-24 pr-24 pt-40 pb-100"><div \nlayout="row" layout-align="end center" class="pl-24"><div class="field" ng-if="!vm.currentQuestion.isLoading" \nlayout="row" layout-align="end center"><md-button \nng-if="!vm.currentQuestion.is_finished && vm.currentQuestion.is_answered && vm.currentQuestion.answer" \naria-label="NEW" class="md-accent green-500-bg md-raised md-button" ng-click="vm.finishQuestion($event)" \ntranslate="GLOBAL.FINISH_QUESTION" type="button"></md-button></div></div></div></div></div>');
$templateCache.put('app/main/apps/questions/views/questionnaires/basic.html','<div class="content grey-100-bg thread-detail" layout="row" layout-align="center center" flex \nng-if="!vm.currentQuestion"><div class="no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-question-mark-circle" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="QUESTIONS.SELECT_QUESTION"></span></div></div><div class="without-line scrollable preview" flex="100" \nng-if="vm.currentQuestion"><div layout="column"><div layout="column" layout-gt-xs="row" layout-align="center start" \nlayout-align-gt-xs="space-between center" class="pl-24 pr-24 pt-40 pb-40"><h1 \nng-bind-html="vm.currentQuestion.question.name"></h1><div layout="row" layout-align="center center" \nclass="pl-24 yes-no-combo"><div class="field" ng-if="vm.currentQuestion.isLoading"><md-progress-circular \nmd-mode="indeterminate" md-diameter="30"></md-progress-circular></div><div class="field" \nng-if="!vm.currentQuestion.isLoading" layout="row" layout-align="center center"><md-button aria-label="Yes" \nclass="md-fab md-raised md-accent md-green-600-bg" ng-click="vm.answerQuestion($event, true)" \nng-hide="vm.currentQuestion.is_answered == 1"><span translate="GLOBAL.YES"></span></md-button><md-button \naria-label="No" class="md-fab md-raised md-accent md-red-600-bg" ng-click="vm.answerQuestion($event, false)" \nng-hide="vm.currentQuestion.is_answered == 1"><span translate="GLOBAL.NO"></span></md-button><span \nng-if="vm.currentQuestion.is_answered == 1 && vm.currentQuestion.answer" class="badge afirmative" \ntranslate="GLOBAL.ANSWERED_YES"></span> <span \nng-if="vm.currentQuestion.is_answered == 1 && !vm.currentQuestion.answer" class="badge negative" \ntranslate="GLOBAL.ANSWERED_NO"></span></div></div></div><div ng-repeat="risk in vm.currentQuestion.risks" \nclass="pr-24 pl-24 pb-24"><div class="white-bg border"><div class="toolbar colored-bg" layout="row" \nlayout-align="start center"><div class="font-size-20" ng-bind-html="risk.name"></div></div><md-divider></md-divider>\n<div layout="column" layout-gt-xs="row" layout-align="center start" layout-align-gt-xs="center center" \nclass="pt-32 pb-32 pl-10 pr-10"><a ng-if="risk.external_link" class="md-button" ng-href="{{risk.external_link}}" \ntarget="_blank" layout="row" layout-align="start center"><span translate="RISK.CODIGO_PENAL"></span> <i \nclass="icon-link-variant s16 ml-5"></i></a><md-button ng-if="risk.description" md-no-ink class="md-primary" \nng-click="vm.openDialogText($event, risk.description, \'RISK.DESCRIPTION\')" translate="RISK.DESCRIPTION"></md-button>\n<md-button ng-if="risk.conducts" md-no-ink class="md-primary" \nng-click="vm.openDialogText($event, risk.conducts, \'RISK.CONDUCTS\')" translate="RISK.CONDUCTS"></md-button><md-button \nng-if="risk.factual_causes" md-no-ink class="md-primary" \nng-click="vm.openDialogText($event, risk.factual_causes, \'RISK.FACTUAL_CAUSES\')" translate="RISK.FACTUAL_CAUSES">\n</md-button><md-button ng-if="risk.penalties" md-no-ink class="md-primary" \nng-click="vm.openDialogText($event, risk.penalties, \'RISK.PENALTIES\')" translate="RISK.PENALTIES"></md-button></div>\n<div layout="column" layout-gt-xs="row" layout-align="center space-between" layout-align-gt-xs="center center" \nclass="text-center pb-32"><md-input-container ng-if="vm.branding.tenant != \'gnl\'" \nclass="ml-24 mr-20 mt-0 mb-15 pv-24 ph-15 circle-graph white-bg" layout="column" layout-align="center start" \nlayout-align-gt-xs="center center" flex><div class="field grey-500-fg" translate="RISK.REPUTATION_IMPACT"></div><div \nng-bind-html="vm.showRiskLevel(risk.reputation_impact)"></div></md-input-container><md-input-container \nclass="ml-24 mr-20 mt-0 mb-15 pv-24 ph-15 circle-graph white-bg" layout="column" layout-align="center start" \nlayout-align-gt-xs="center center" flex><div class="field grey-500-fg" translate="RISK.PENAL_CODE_IMPACT"></div><div \nng-bind-html="vm.showRiskLevel(risk.penal_code_impact)"></div></md-input-container><md-input-container \nclass="ml-24 mr-20 mt-0 mb-15 pv-24 ph-15 circle-graph white-bg" layout="column" layout-align="center start" \nlayout-align-gt-xs="center center" flex><div class="field grey-500-fg" translate="RISK.CLIENT_LOSS"></div><div \nng-bind-html="vm.showRiskLevel(risk.client_loss)"></div></md-input-container></div><md-divider></md-divider><div \nlayout="row" layout-align="start center" class="p-24"><h2 translate="RISK.PROCESS_AND_CONTROLS" class="mt-0 mb-0"></h2>\n</div><md-divider></md-divider><div layout="row" layout-align="start start"><md-list flex="100" class="p-0"><div \nng-repeat="process in risk.processes" class="process"><md-list-item><div class="info pl-8 pr-8" flex layout="column">\n<div layout="row" layout-align="space-between center" flex="100"><div layout="row" layout-align="start center" flex \nclass="pt-24 pb-24"><div class="avatar" ng-style="{\'background\': \'rgba(25,147,232,1)\'}">P</div><div class="field">\n<strong class="grey-800-fg" ng-bind-html="process.name"></strong></div></div></div></div></md-list-item><div \nclass="process-controls" ng-if="process.controls.length> 0" ng-repeat="control in process.controls" \nng-init="vm.setControlsData(process.id, control.id)"><md-divider></md-divider><md-list-item layout="row" \nlayout-align="start center" \nng-class="(process.id == vm.currentControl.process && control.id == vm.currentControl.id) ? \'current-control\' : \'\'">\n<div layout="row" layout-align="start center" flex="100" class="pt-20 pb-20"><div class="info" flex layout="column">\n<div class="name" layout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar" \nng-style="{\'background\': \'rgba(132,173,78,1)\'}">C</div><div class="field mr-10 ml-10" flex><strong class="grey-800-fg" \nng-bind-html="control.name"></strong></div></div></div></div></div></md-list-item></div><md-divider></md-divider></div>\n</md-list></div></div></div></div></div>');
$templateCache.put('app/main/apps/questions/views/questionnaires/details.html','<div class="content thread-detail" layout="row" layout-align="center center" flex ng-if="!vm.currentQuestion"><div \nclass="no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-question-mark-circle" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="QUESTIONS.SELECT_QUESTION"></span></div></div><div class="without-line scrollable preview" flex="100" \nng-if="vm.currentQuestion"><div layout="column"><div layout="column" class="p-24"><div layout="row" \nlayout-align="start center"><h1 ng-bind-html="vm.currentQuestion.question.name" class="mt-0 mr-24"></h1></div></div>\n<md-divider></md-divider><div layout="column" class="p-24"><div layout="row" layout-align="center center"><div \nclass="field" ng-if="vm.currentQuestion.isLoading"><md-progress-circular md-mode="indeterminate" md-diameter="30">\n</md-progress-circular></div><div class="field" ng-if="!vm.currentQuestion.isLoading"><md-button aria-label="Yes" \nclass="md-fab md-raised md-accent md-green-600-bg" ng-click="vm.answerQuestion($event, true)" \nng-hide="vm.currentQuestion.is_answered == 1"><span translate="GLOBAL.YES"></span></md-button><md-button \naria-label="No" class="md-fab md-raised md-accent md-red-600-bg" ng-click="vm.answerQuestion($event, false)" \nng-hide="vm.currentQuestion.is_answered == 1"><span translate="GLOBAL.NO"></span></md-button><span \nng-if="vm.currentQuestion.is_answered == 1 && vm.currentQuestion.answer" class="badge afirmative" \ntranslate="GLOBAL.ANSWERED_YES"></span> <span \nng-if="vm.currentQuestion.is_answered == 1 && !vm.currentQuestion.answer" class="badge negative" \ntranslate="GLOBAL.ANSWERED_NO"></span></div></div></div><md-divider></md-divider><div \nclass="toolbar grey-100-bg colored-bg" layout="row" layout-align="space-between center"><div layout="row" \nlayout-align="start center"><h2 ng-bind-html="vm.currentQuestion.question.processes[0].risks[0].name"></h2></div></div>\n<div layout="column" class="p-24"><div layout-gt-xs="row" layout-xs="column" layout-align-gt-xs="space-around center" \nlayout-align-xs="center center"><div layout="column"><div class="text h4 pt-8 ng-binding ng-scope"><span \nng-bind-html="vm.currentQuestion.question.processes[0].risks[0].description.substring( 0, 300 ) + \'...\'"></span></div>\n</div></div></div><div layout="row" layout-align="start start"><div layout="row" layout-align="start center"><h2 \nng-bind-html="vm.currentQuestion.question.processes[0].risks[0].name" class="mt-0 mr-24"></h2></div><md-list \nflex="100"><div ng-repeat="process in vm.currentQuestion.question.processes" class="process"><md-list-item><div \nlayout="row" layout-align="space-between center" flex="100" class="pt-10 pb-10"><div layout="row" \nlayout-align="start center" flex><div class="avatar" ng-style="{\'background\': \'rgba(25,147,232,1)\'}">P</div><div \nclass="field"><strong class="grey-800-fg" ng-bind-html="process.name"></strong></div></div></div><md-divider>\n</md-divider></md-list-item><div class="process-controls" ng-if="process.controls.length > 0" \nng-repeat="control in process.controls"><md-list-item layout="row" layout-align="start center" \nng-class="(control.id == vm.currentControl.id) ? \'current-control\' : \'\'"><div layout="row" \nlayout-align="space-between center" flex="100" ng-click="vm.openControl(control.active_control_id)"><div layout="row" \nlayout-align="start center" flex><div class="avatar" ng-style="{\'background\': \'rgba(132,173,78,1)\'}">C</div><div \nclass="field"><strong class="grey-800-fg" ng-bind-html="control.name"></strong><div class="grey-600-fg"><div \nclass="avatar-wrapper"><img class="avatar s24" \nsrc="https://lh5.googleusercontent.com/-EDLhh7Pldgc/AAAAAAAAAAI/AAAAAAAAANQ/LQ1mKKr98aQ/photo.jpg?sz=50"> <img \nclass="avatar s24" \nsrc="https://lh6.googleusercontent.com/-8ToRxkEQIWs/AAAAAAAAAAI/AAAAAAAAAVI/xyASkLZ5z34/photo.jpg?sz=50"></div></div>\n</div></div></div><md-divider></md-divider></md-list-item></div></div></md-list></div></div></div>');
$templateCache.put('app/main/apps/questions/views/questionnaires/list-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="isLoading" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="content-wrapper" layout="row" flex \nng-if="!isLoading && vm.currentQuestions.length == 0 && !vm.showQuestions"><div class="content thread-detail" \nlayout="row" layout-align="center center" flex><div class="no-questionnaire" layout="column" \nlayout-align="center center" flex><span class="hint-text" translate="QUESTIONS.NO_QUESTIONNAIRE_STARTED"></span><div \nclass="text-center"><md-button aria-label="Start questionnaire" class="md-raised md-accent" \nng-click="vm.showQuestions= true; vm.selectAllQuestions()"><span translate="QUESTIONS.START_QUESTIONNAIRE" \nng-if="!vm.loadingQuestions"></span> <span translate="GLOBAL.LOADING" ng-if="vm.loadingQuestions"></span></md-button>\n</div></div></div></div><div ng-if="vm.showQuestions && vm.currentQuestions.length == 0"><div \nng-include="\'app/main/apps/questions/templates/init-questions.html\'"></div></div><div id="list-content-data" \nng-style="{\'opacity\' : isLoading ? 0.5 : 1}" ng-if="vm.currentQuestions.length> 0"><div class="mail-list-item" \nng-repeat="question in vm.currentQuestions | filter: { id_risk : vm.riskSelected.id } : true" \nng-init="parentIndex= $index" md-no-ink ng-click="vm.openQuestion(question)" \nng-class="{\'selected\': vm.selectedQuestionID == question.id}"><div lauyout="column" layout-gt-xs="row" \nlayout-align="space-between center" flex="100" class="pt-10 pb-10"><div layout="row" layout-align="start center" flex>\n<div class="avatar" ng-class="vm.getQuestionAnswerClass(question)">{{(question.index)}}</div><div layout="column" \nclass="field"><strong class="grey-800-fg" ng-bind-html="question.question.name"></strong><div><strong \nclass="grey-800-fg">{{\'GLOBAL.RISK\' | translate}}: </strong><strong class="grey-500-fg" \nng-bind-html="question.question.processes[0].risks[0].name"></strong></div></div></div><div layout="row" \nlayout-align="end center"><span ng-if="question.is_answered == 1 && question.answer && question.is_finished" \nclass="badge afirmative" translate="GLOBAL.ANSWERED_YES"></span> <span \nng-if="question.is_answered == 1 && question.answer && !question.is_finished" class="badge process" \ntranslate="GLOBAL.IN_PROCESS"></span> <span ng-if="question.is_answered == 1 && !question.answer" \nclass="badge negative" translate="GLOBAL.ANSWERED_NO"></span> <span ng-if="!question.is_answered == 1" class="badge" \ntranslate="GLOBAL.NO_ANSWERED"></span><div class="field"><md-button class="md-icon-button" aria-label="Open question">\n<md-icon md-font-icon="icon-chevron-right"></md-icon></md-button></div></div></div></div></div><div class="toolbar" \nlayout="row" layout-align="end center" ng-if="vm.risks.length> 0"><div layout="row" layout-align="center center" \nng-style="{\'display\' : isLoading ? \'none\' : \'block\'}"><span class="page-info" ng-bind-html="pagination_totalItems">\n</span> <span class="page-info" translate="GLOBAL.ITEMS_FOUND"></span><md-button aria-label="Previous" \nclass="md-icon-button arrow" ng-click="pagination_prevPage()" ng-disabled="pagination_firstPage()"><md-icon \nmd-font-icon="icon-chevron-left"></md-icon></md-button><span class="page-info">\n{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label="Next" class="md-icon-button arrow" \nng-click="pagination_nextPage()" ng-disabled="pagination_morePages()"><md-icon md-font-icon="icon-chevron-right">\n</md-icon></md-button></div></div>');
$templateCache.put('app/main/apps/questions/views/questionnaires/nosplit-view.html','<div class="toolbar" layout="row" layout-align="space-between center" \nng-include="\'app/main/apps/questions/views/questionnaires/toolbar.html\'"></div><div \nng-include="\'app/main/apps/questions/templates/add-more-questions.html\'"></div><div class="content-wrapper" flex="" \nlayout="row"><div class="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" \nng-if="!vm.currentQuestion" id="thread-list" \nng-include="\'app/main/apps/questions/views/questionnaires/list-view.html\'"></div><div \nclass="content grey-100-bg thread-detail mail-read-pane p0" flex="" id="thread-preview" ng-if="vm.currentQuestion" \nng-include="vm.views[vm.detailsView]"></div></div>');
$templateCache.put('app/main/apps/questions/views/questionnaires/options.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="isLoading" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<ms-form-wizard flex ng-if="!isLoading"><md-tabs class="height-tabs" md-dynamic-height \nmd-selected="msWizard.selectedIndex" md-center-tabs="true"><md-tab><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" ng-if="wizardStep1.$invalid">1\n</span> <span class="ms-form-wizard-step-number md-accent-bg" ng-if="wizardStep1.$valid"><i class="icon-check s16"></i>\n </span><span class="ms-form-wizard-step-text" ng-bind-html="vm.companySelected.name"></span></span></md-tab-label>\n<md-tab-body><form name="wizardStep1" ms-form-wizard-form novalidate><div class="text-center"><md-input-container flex>\n<label translate="GLOBAL.Branch"></label><md-select ng-model="vm.branchSelected" required \nplaceholder="{{vm.translate(\'QUESTIONS.SELECT_BRANCH\')}}"><md-option \nng-repeat="branch in vm.companyBranches track by $index" ng-value="branch">{{branch.name}}</md-option></md-select>\n</md-input-container></div><div class="text-center" ng-if="vm.branchSelected"><md-input-container flex><label \ntranslate="QUESTIONS.SECTOR"></label><md-select ng-model="vm.sectorSelected" ng-disabled="true" md-no-underline>\n<md-option ng-repeat="sector in vm.allSectors" ng-value="sector">{{sector.name}}</md-option></md-select>\n</md-input-container></div><div class="text-center" ng-if="vm.branchSelected"><md-input-container flex><md-checkbox \nng-model="vm.checkAllSectors" aria-label="All sectors"><span translate="QUESTIONS.CHECK_ALL_SECTORS"></span>\n</md-checkbox></md-input-container></div></form></md-tab-body></md-tab></md-tabs><div class="navigation" flex \nlayout="row" layout-align="center center"><md-button aria-label="Start questionnaire" class="md-raised md-accent" \nng-click="vm.startQuestionnaire()" ng-show="msWizard.isFirstStep()" \nng-disabled="msWizard.currentStepInvalid() || vm.loadingQuestions"><span translate="QUESTIONS.START_QUESTIONNAIRE" \nng-if="!vm.loadingQuestions"></span> <span translate="GLOBAL.LOADING" ng-if="vm.loadingQuestions"></span></md-button>\n</div></ms-form-wizard>');
$templateCache.put('app/main/apps/questions/views/questionnaires/split-view.html','<div class="toolbar" layout="row" layout-align="space-between center" \nng-include="\'app/main/apps/questions/views/questionnaires/toolbar.html\'"></div><div \nng-include="\'app/main/apps/questions/templates/add-more-questions.html\'"></div><div class="content-wrapper" flex="" \nlayout="row"><div class="content thread-list mail-list-pane scrollable p0" flex="40" ms-scroll="vm.msScrollOptions" \nid="thread-list" ng-include="\'app/main/apps/questions/views/questionnaires/list-view.html\'"></div><div \nclass="content grey-100-bg thread-detail mail-read-pane p0" flex="60" id="thread-preview" \nng-if="vm.currentQuestions.length > 0" ng-include="vm.views[vm.detailsView]"></div></div>');
$templateCache.put('app/main/apps/questions/views/questionnaires/toolbar.html','<div layout="row" layout-align="start center" layout-align-xs="start center" flex><div layout="row" \nlayout-align="start center" ng-if="vm.currentQuestion && vm.currentView == \'nosplit\'"><a class="pointer" \nng-click="vm.closeQuestion()"><md-icon md-font-icon="icon-close"></md-icon></a></div><div \nng-if="vm.currentQuestion && vm.currentView == \'nosplit\'" class="divider-vertical"></div><h4 \nclass="text-bold text-uppercase mr-10" hide show-gt-xs>{{vm.companySelected.name}}</h4><div class="divider-vertical" \nhide show-gt-xs></div><md-menu-bar id="user-menu" class="pl-0 pr-0"><md-menu md-position-mode="left bottom"><md-button \nclass="user-button m0" ng-click="$mdMenu.open()" aria-label="User settings" translate \ntranslate-attr-aria-label="TOOLBAR.USER_SETTINGS"><div layout="row" layout-align="space-between center"><span \nng-if="vm.branchSelected" class="username">{{vm.branchSelected.name}}</span><md-icon md-font-icon="icon-chevron-down" \nclass="icon s16"></md-icon></div></md-button><md-menu-content width="3" class="clients"><md-menu-item \nclass="md-indent"><div class="search-input-wrapper" layout="row" layout-align="start center"><label for="search">\n<md-icon md-font-icon="icon-magnify"></md-icon></label><md-input-container md-no-float class="m-0"><input id="search" \nplaceholder="{{\'CONTACTS.SEARCH_FOR_ANYONE\' |\xA0translate}}" type="text" ng-model="vm.searchBranchText">\n</md-input-container></div></md-menu-item><div class="results"><md-menu-item ng-click="vm.selectBranch(branch)" \nclass="md-indent bar-client" ng-repeat="branch in vm.companyBranches | filter:vm.searchBranchText"><div><md-icon \nmd-font-icon="icon-account" class="icon s16" hide-xs></md-icon><button class="btn-clients">{{branch.name}}</button>\n</div></md-menu-item></div></md-menu-content></md-menu></md-menu-bar><md-menu-bar id="user-menu" class="pl-0 pr-0" \nhide show-gt-xs><md-menu md-position-mode="left bottom"><md-button class="user-button m0" ng-click="$mdMenu.open()" \naria-label="User settings" translate translate-attr-aria-label="TOOLBAR.USER_SETTINGS"><div layout="row" \nlayout-align="space-between center"><span ng-if="vm.riskSelected" class="username">{{vm.riskSelected.name}}</span> \n<span ng-if="!vm.riskSelected" class="grey-500-fg" translate="QUESTIONS.SEARCH_BY_RISK"></span><md-icon \nmd-font-icon="icon-chevron-down" class="icon s16"></md-icon></div></md-button><md-menu-content width="3" \nclass="clients"><md-menu-item class="md-indent"><div class="search-input-wrapper" layout="row" \nlayout-align="start center"><label for="search"><md-icon md-font-icon="icon-magnify"></md-icon></label>\n<md-input-container md-no-float class="m-0"><input id="search" \nplaceholder="{{\'QUESTIONS.SEARCH_BY_RISK\' |\xA0translate}}" type="text" ng-model="vm.searchRiskText"></md-input-container>\n</div></md-menu-item><div class="results"><md-menu-item ng-click="vm.selectRisk(risk)" class="md-indent bar-client" \nng-repeat="risk in vm.risksToFilter | filter:vm.searchRiskText"><div><md-icon md-font-icon="icon-account" \nclass="icon s16" hide-xs></md-icon><button class="btn-clients">{{risk.name}}</button></div></md-menu-item></div>\n</md-menu-content></md-menu></md-menu-bar><md-button class="md-raised md-accent" \nng-if="vm.currentQuestions.length > 0 && !vm.showAddMoreQuestionsDialog" ng-click="vm.showAddMoreQuestions()" \naria-label="Gestionar preguntas" style="margin-left: 16px;"><span translate="QUESTIONS.MANAGE_QUESTIONS">\nGestionar preguntas</span></md-button><md-button class="md-icon-button" style="margin-left: auto;" \nng-click="vm.changeView(\'nosplit\')" ng-if="vm.currentView !== \'nosplit\'" hide show-gt-sm><md-icon \nmd-font-icon="icon-view-list" ng-if="vm.currentView !== \'nosplit\'"></md-icon><md-icon class="md-accent" \nmd-font-icon="icon-checkbox-marked" ng-if="vm.currentView === \'nosplit\'"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.NOSPLIT_VIEW">No split</span></md-tooltip></md-button><md-button class="md-icon-button" \nstyle="margin-left: auto;" ng-click="vm.changeView(\'split\')" ng-if="vm.currentView !== \'split\'" hide show-gt-sm>\n<md-icon md-font-icon="icon-view-quilt" ng-if="vm.currentView !== \'split\'"></md-icon><md-icon class="md-accent" \nmd-font-icon="icon-checkbox-marked" ng-if="vm.currentView === \'split\'"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.SPLIT_VIEW">split</span></md-tooltip></md-button><md-button style="min-width: 20px;margin: 0px;" \nng-if="vm.riskSelected" ng-click="vm.riskSelected = null; vm.searchRiskText = \'\';" class="md-icon-buttons" \nng-click="vm.closeDialog()" aria-label="Close dialog"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon>\n</md-button></div>');
$templateCache.put('app/main/apps/reports/dialogs/dialog-preview/dialog-preview.html','<md-dialog id="dialog-preview-pdf" class="form-dialog" aria-label="Odds of occurence"><md-toolbar class="md-accent">\n<div class="md-toolbar-tools" layout="row" layout-align="space-between center"><h1>{{ \'GLOBAL.PREVIEW\' | translate}}\n</h1><div class="absolute-right pr-10" layout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog" tranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></div></md-toolbar><md-dialog-content class="mediadialog-content p-24" flex><div \nng-if="vm.html" ng-bind-html="vm.html"></div></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="end center" class="grey-100-bg"><md-button ng-click="vm.closeDialog()" \nclass="send-button md-accent md-raised" aria-label="close" translate="GLOBAL.CLOSE" \ntranslate-attr-aria-label="GLOBAL.CLOSE"></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/main/apps/reports/views/list/list-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="isLoading" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="no-threads" ng-if="!vm.reports" ng-hide="isLoading" translate="GLOBAL.NO_ITEMS"></div><div \nid="list-content-data" ng-style="{\'opacity\' : isLoading ? 0.5 : 1}"><div class="mail-list-item" \nng-repeat="report in vm.reports | filter: vm.search | filter: global.search" ng-init="parentIndex= $index" md-no-ink \nng-click="vm.openReport(report)" \nng-class="{\'starred\': report.starred, \'selected\': vm.reportSelected.id === report.id, \'checked\': vm.isSelected(report)}">\n<div class="flex" layout="row" layout-align="start center"><div class="name flex" layout="row" \nlayout-align="start center"><md-checkbox class="no-label" ng-checked="vm.isSelected(report)" \nng-click="vm.toggleSelectThread(report, $event)" aria-label="{{vm.isSelected(report) ? \'Deselect\' : \'Select\'}}">\n</md-checkbox><div class="info layout-column flex" flex="" layout="column"><div class="name text-truncate" \nlayout="row" layout-align="start center"><span>{{report.title}} <span ng-if="report.is_recurrent">\n({{\'REPORTS.RECURRENT\' | translate}})</span></span></div></div></div><div layout="row" layout-align="end center"><span \nng-if="report.output.status" class="badge afirmative" translate="GLOBAL.STATUS_FINISHED"></span> <span \nng-if="!report.output.status" class="badge process" translate="GLOBAL.STATUS_PENDING"></span></div></div><div \nlayout="row" layout-align="start center"><div ng-if="!report.is_recurrent" class="text-truncate pt-5" layout="row" \nlayout-align="start center"><span>{{\'GLOBAL.FROM\' | translate}} </span><span ng-if="report.from_date" \nclass="grey-500-fg">{{report.from_date | monthDate}}</span> <span ng-if="!report.from_date" class="grey-500-fg">\n{{\'REPORTS.NO_DATE\' | translate}}</span></div><div ng-if="!report.is_recurrent" class="text-truncate pt-5 ml-5" \nlayout="row" layout-align="start center"><span>{{\'GLOBAL.TO\' | translate}} </span><span ng-if="report.to_date" \nclass="grey-500-fg">{{report.to_date | monthDate}}</span> <span ng-if="!report.to_date" class="grey-500-fg">\n{{\'REPORTS.NO_DATE\' | translate}}</span></div></div><div ng-if="report.is_recurrent" class="text-truncate pt-5" \nlayout="row" layout-align="start center"><span>{{\'GLOBAL.FRECUENCY\' | translate}} </span><span \nng-switch="report.recurrent_frecuency" class="grey-500-fg"><span ng-switch-when="1">1 D\xEDa</span> <span \nng-switch-when="7">1 semana</span> <span ng-switch-when="14">2 semanas</span> <span ng-switch-when="30">1 Mes</span> \n<span ng-switch-when="90">3 Meses</span> <span ng-switch-when="180">6 Meses</span></span></div><div \nng-if="report.is_recurrent" class="text-truncate pt-5" layout="row" layout-align="start center"><span>\n{{\'GLOBAL.RANGE\' | translate}} </span><span ng-switch="report.recurrent_range" class="grey-500-fg"><span \nng-switch-when="1">1 D\xEDa</span> <span ng-switch-when="7">1 semana</span> <span ng-switch-when="14">2 semanas</span> \n<span ng-switch-when="30">1 Mes</span> <span ng-switch-when="90">3 Meses</span> <span ng-switch-when="180">6 Meses\n</span></span></div></div><div ng-if="!isLoading && pagination_total_pages> pagination_page && vm.reports.length > 0" \nclass="load-more white p-30" layout="row" layout-sm="column" layout-align="center center" layout-wrap=""><md-button \nng-click="pagination_nextPage(true)" class="md-raised">{{\'GLOBAL.LOAD_MORE\' | translate}}</md-button></div><div \nng-if="pagination_total_pages == pagination_page && pagination_page> 1" class="load-more white p-30" layout="row" \nlayout-sm="column" layout-align="center center" layout-wrap=""><div class="message" translate="GLOBAL.NO_MORE_ITEMS">\n</div></div></div>');
$templateCache.put('app/main/apps/reports/views/list/nosplit-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.reportSelected && !vm.reportNew" \nng-include="\'app/main/apps/reports/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row">\n<div class="content thread-detail mail-read-pane p0" flex="" id="thread-detail" ms-scroll="vm.msScrollOptions" \nng-if="vm.reportSelected || vm.reportNew" ng-include="\'app/main/apps/reports/views/read/read-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="!vm.reportSelected && !vm.reportNew" ng-include="\'app/main/apps/reports/views/list/list-view.html\'"></div></div>');
$templateCache.put('app/main/apps/reports/views/list/split-view.html','<div class="toolbar" layout="row" layout-align="space-between center" \nng-include="\'app/main/apps/reports/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row">\n<div class="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-include="\'app/main/apps/reports/views/list/list-view.html\'"></div><div \nclass="content thread-detail mail-read-pane p0" flex="" id="thread-detail" ms-scroll="vm.msScrollOptions" \nng-include="\'app/main/apps/reports/views/read/read-view.html\'"></div></div>');
$templateCache.put('app/main/apps/reports/views/list/toolbar.html','<div layout="row" layout-align="start center"><md-checkbox class="no-label" \naria-label="{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}" \nng-checked="vm.selectedThreads.length > 0" ng-click="vm.toggleSelectThreads(vm.selectedThreads, vm.contents)">\n</md-checkbox><div class="divider-vertical" hide="" show-gt-xs=""></div><md-button aria-label="NEW" \nclass="md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme" hide show-gt-sm \nng-click="vm.newReport()" translate="GLOBAL.NEW" type="button"></md-button><md-button aria-label="NEW" \nclass="md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme z-index-0" hide-gt-sm \nng-click="vm.newReport()" type="button"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="divider-vertical" hide="" show-gt-xs=""></div><div aria-hidden="false" \nclass="action-buttons hide show-gt-xs layout-align-start-center layout-row" layout="row" layout-align="start center" \nng-show="vm.selectedThreads.length > 0"><md-button ng-click="vm.deleteReport($event)" aria-label="Delete" \nclass="md-icon-button" hide="" show-gt-xs="" translate=""><md-icon md-font-icon="icon-delete"></md-icon><md-tooltip \nhide show-gt-xs><span translate="GLOBAL.REMOVE"></span></md-tooltip></md-button><md-button \nng-click="vm.duplicateReport()" aria-label="Duplicate" class="md-icon-button" hide="" show-gt-sm="" translate="" \ntranslate-attr-aria-label="GLOBAL.DUPLICATE"><md-icon md-font-icon="icon-content-duplicate"></md-icon><md-tooltip><span\n translate="GLOBAL.DUPLICATE"></span></md-tooltip></md-button><div class="divider-vertical" hide="" show-gt-xs="">\n</div></div><ms-search-bar debounce="300" model-search="$root.pagination_searchquery" \non-result-click="vm.searchResultClick(item)" on-search="vm.search(query)" layout="row" layout-align="start center">\n</ms-search-bar><md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" \ntranslate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nng-if="$root.pagination_searchquery==true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip \nhide show-gt-xs><span>Reset search</span></md-tooltip></md-button><div class="divider-vertical" hide="" show-gt-xs="">\n</div><md-menu hide="" show-gt-xs="" ng-if="refGroupables.length>0"><button aria-label="Filters" \nclass="md-icon-button" ng-click="$mdMenu.open($event)" show-gt-xs="" translate="" \ntranslate-attr-aria-label="GLOBAL.FILTERS"><md-icon md-font-icon="icon-chevron-down"><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.GROUP_BY">Group</span></md-tooltip></md-icon></button><md-menu-content width="4"><md-menu-item \nng-repeat="sortfield in refGroupables"><md-button aria-label="All" ng-click="pagination_setOrderBy(sortfield)"><div \nlayout="row" layout-align="space-between center"><span>Group by {{sortfield.name}} </span><i class="icon-check s16" \nng-if="sortfield.titleId == sortable.titleId"></i></div></md-button></md-menu-item><md-menu-divider ng-if="groupable">\n</md-menu-divider><md-menu-item ng-if="groupable"><md-button aria-label="Remove group" \nng-click="pagination_resetOrderBy()"><md-icon md-font-icon="icon-close "></md-icon><span>Remove order</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div><div layout="row" layout-align="start center" \ntranslate-attr-aria-label="GLOBAL.REFRESH"><span ng-if="!isLoading" class="page-info font-weight-500">\n{{vm.reports.length}} {{ \'GLOBAL.OF\' | translate}} {{pagination_totalItems}} {{ \'GLOBAL.ITEMS\' | translate}}.</span>\n<div class="divider-vertical" hide hide show-gt-sm></div><md-button class="md-icon-button" \nng-click="vm.changeView(\'nosplit\')" ng-if="vm.currentView !== \'nosplit\'" hide show-gt-sm><md-icon \nmd-font-icon="icon-view-list" ng-if="vm.currentView !== \'nosplit\'"></md-icon><md-icon class="md-accent" \nmd-font-icon="icon-checkbox-marked" ng-if="vm.currentView === \'nosplit\'"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.NOSPLIT_VIEW">No split</span></md-tooltip></md-button><md-button class="md-icon-button" \nng-click="vm.changeView(\'split\')" ng-if="vm.currentView !== \'split\'" hide show-gt-sm><md-icon \nmd-font-icon="icon-view-quilt" ng-if="vm.currentView !== \'split\'"></md-icon><md-icon class="md-accent" \nmd-font-icon="icon-checkbox-marked" ng-if="vm.currentView === \'split\'"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.SPLIT_VIEW">split</span></md-tooltip></md-button><md-menu class="settings-menu" hide-gt-xs \nng-show="vm.selectedThreads.length > 0"><md-button aria-label="Settings" class="md-icon-button" \nng-click="$mdMenu.open($event)" translate="GLOBAL.SETTINGS" translate-attr-aria-label="GLOBAL.SETTINGS"><md-icon \nmd-font-icon="icon-dots-horizontal"></md-icon></md-button><md-menu-content><md-menu-item ng-click="vm.deleteClient()" \nshow="vm.selectedMail.length > 0 || vm.allChecked"><md-button ng-click="vm.deleteReport($event)" aria-label="Delete" \ntranslate-aria-label="GLOBAL.DELETE"><md-icon md-font-icon="icon-delete"></md-icon><span translate="GLOBAL.DELETE">\nDelete</span></md-button></md-menu-item></md-menu-content></md-menu></div>');
$templateCache.put('app/main/apps/reports/views/read/edit.html','<div fill-width layout="column"><div class="form-wrapper md-whiteframe-1dp without-line" flex="100"><form \nname="vm.basicForm" class="md-inline-form" novalidate><div><md-input-container class="md-block"><label \nng-bind="\'Name\'"></label> <input required type="text" name="title" ng-model="vm.reportSelected.title">\n</md-input-container><div layout="row" layout-align="start center" class=""><md-input-container flex class="md-block">\n<label class="inline">{{\'REPORTS.BRANCH\' | translate}}</label><md-select ng-model="vm.reportSelected.branch_id">\n<md-option ng-repeat="branch in vm.companyBranches" ng-value="branch.id">{{branch.name}}</md-option></md-select>\n</md-input-container></div><div layout="row" layout-align="start center"><md-datepicker \nng-if="!vm.reportSelected.is_recurrent" ng-model="vm.reportSelected.from_date" \nmd-placeholder="{{\'REPORTS.START_DATE\' | translate}}" ng-required="false" md-date-locale="vm.monthFormat" \nmd-mode="month" md-open-on-focus="true"></md-datepicker><md-datepicker ng-if="!vm.reportSelected.is_recurrent" \nng-model="vm.reportSelected.to_date" md-placeholder="{{\'REPORTS.END_DATE\' | translate}}" ng-required="false" \nmd-date-locale="vm.monthFormat" md-mode="month" md-open-on-focus="true"></md-datepicker><md-input-container \nng-if="vm.reportSelected.is_recurrent" class="md-block ph-15"><label class="inline">\n{{\'REPORTS.DATES_RANGE\' | translate}}</label><md-select ng-model="vm.reportSelected.recurrent_range"><md-option \nvalue="1">1 D\xEDa</md-option><md-option value="7">1 semana</md-option><md-option value="14">2 semanas</md-option>\n<md-option value="30">1 Mes</md-option><md-option value="90">3 Meses</md-option><md-option value="180">6 Meses\n</md-option></md-select></md-input-container><md-input-container ng-if="vm.reportSelected.is_recurrent" \nclass="md-block ph-15"><label class="inline">Frecuencia</label><md-select \nng-model="vm.reportSelected.recurrent_frecuency"><md-option value="1">1 D\xEDa</md-option><md-option value="7">1 semana\n</md-option><md-option value="14">2 semanas</md-option><md-option value="30">1 Mes</md-option><md-option value="90">\n3 Meses</md-option><md-option value="180">6 Meses</md-option></md-select></md-input-container></div></div></form></div>\n<md-input-container class="md-block border separator mb-30 md-default-theme"><h2 class="title ng-scope" \ntranslate="REPORTS.REPORT_DATA">Datos del informe</h2></md-input-container><form name="vm.reportDataForm" \nclass="md-inline-form" novalidate><div class="ph-25 mb-100"><div layout="row" layout-align="start center">\n<md-input-container flex><md-checkbox class="no-label" ng-model="vm.reportSelected.data_json.employees.active" \naria-label="{{vm.reportSelected.data_json.employees.active ? \'Deselect\' : \'Select\'}}">\n{{\'REPORTS.EMPLOYEES\' | translate}}</md-checkbox></md-input-container></div><md-input-container \nclass="md-block border separator fix mb-30 md-default-theme"></md-input-container><div layout="row" \nlayout-align="start center"><md-input-container flex><md-checkbox class="no-label" \nng-model="vm.reportSelected.data_json.questionnaires.active" \naria-label="{{vm.reportSelected.data_json.questionnaires.active ? \'Deselect\' : \'Select\'}}">\n{{\'GLOBAL.QUESTIONNAIRES\' | translate}}</md-checkbox></md-input-container></div><div \nng-if="vm.reportSelected.data_json.questionnaires.active" layout="row" layout-align="start center"><label>\nPreguntas seg\xFAn respuesta</label></div><div ng-if="vm.reportSelected.data_json.questionnaires.active" class="ph-15" \nlayout="row" layout-align="start center"><md-input-container flex><md-checkbox class="no-label" \nng-model="vm.reportSelected.data_json.questionnaires.yes.active" \naria-label="{{vm.reportSelected.data_json.questionnaires.yes.active ? \'Deselect\' : \'Select\'}}">\n{{\'REPORTS.QUESTIONNAIRES_YES\' | translate}}</md-checkbox></md-input-container><md-input-container flex><md-checkbox \nclass="no-label" ng-model="vm.reportSelected.data_json.questionnaires.no" \naria-label="{{vm.reportSelected.data_json.questionnaires.no ? \'Deselect\' : \'Select\'}}">\n{{\'REPORTS.QUESTIONNAIRES_NO\' | translate}}</md-checkbox></md-input-container><md-input-container flex><md-checkbox \nclass="no-label" ng-model="vm.reportSelected.data_json.questionnaires.not_answered" \naria-label="{{vm.reportSelected.data_json.questionnaires.not_answered ? \'Deselect\' : \'Select\'}}">\n{{\'REPORTS.QUESTIONNAIRES_NOT_ANSWERED\' | translate}}</md-checkbox></md-input-container></div><div \nng-if="vm.reportSelected.data_json.questionnaires.yes.active" layout="row" layout-align="start center"><label>\nControles seg\xFAn estado</label></div><div ng-if="vm.reportSelected.data_json.questionnaires.yes.active" class="ph-15" \nlayout="row" layout-align="start center"><md-input-container flex><md-checkbox class="no-label" \nng-model="vm.reportSelected.data_json.questionnaires.yes.controls_yes" \naria-label="{{vm.reportSelected.data_json.questionnaires.yes.controls_yes ? \'Deselect\' : \'Select\'}}">\n{{\'REPORTS.CONTROLS_YES\' | translate}}</md-checkbox></md-input-container><md-input-container flex><md-checkbox \nclass="no-label" ng-model="vm.reportSelected.data_json.questionnaires.yes.controls_no" \naria-label="{{vm.reportSelected.data_json.questionnaires.yes.controls_no ? \'Deselect\' : \'Select\'}}">\n{{\'REPORTS.CONTROLS_NO\' | translate}}</md-checkbox></md-input-container><md-input-container flex><md-checkbox \nclass="no-label" ng-model="vm.reportSelected.data_json.questionnaires.yes.controls_not_apply" \naria-label="{{vm.reportSelected.data_json.questionnaires.yes.controls_not_apply ? \'Deselect\' : \'Select\'}}">\n{{\'REPORTS.CONTROLS_NOT_APPLY\' | translate}}</md-checkbox></md-input-container></div><md-input-container \nclass="md-block border separator fix mb-30 md-default-theme"></md-input-container><div layout="row" \nlayout-align="start center"><md-input-container flex><md-checkbox \nng-change="vm.reportSelected.data_json.risks.processes.active= false;\n                        vm.reportSelected.data_json.risks.processes.controls.active= false;\n                        vm.reportSelected.data_json.risks.processes.controls.action_plan= false;\n                        vm.reportSelected.data_json.risks.processes.controls.evidences= false;\n                        vm.reportSelected.data_json.risks.conducts= false;\n                        vm.reportSelected.data_json.risks.penalties= false;\n                        vm.reportSelected.data_json.risks.factual_causes= false;\n                        vm.reportSelected.data_json.risks.risk_level= false;\n                        vm.reportSelected.data_json.risks.processes.controls.nonconformity= false;" \nclass="no-label" ng-model="vm.reportSelected.data_json.risks.active" \naria-label="{{vm.reportSelected.data_json.risks.active ? \'Deselect\' : \'Select\'}}">{{\'GLOBAL.RISKS\' | translate}}\n</md-checkbox></md-input-container></div><div ng-if="vm.reportSelected.data_json.risks.active" layout="row" \nlayout-align="start center"><label>{{\'REPORTS.RISK_DATA\' | translate}}</label></div><div \nng-if="vm.reportSelected.data_json.risks.active" class="ph-15" layout="row" layout-align="start center">\n<md-input-container flex><md-checkbox class="no-label" ng-model="vm.reportSelected.data_json.risks.conducts" \naria-label="{{vm.reportSelected.data_json.risks.conducts ? \'Deselect\' : \'Select\'}}">{{\'REPORTS.BEHAVIORS\' | translate}}\n</md-checkbox></md-input-container><md-input-container flex><md-checkbox class="no-label" \nng-model="vm.reportSelected.data_json.risks.penalties" \naria-label="{{vm.reportSelected.data_json.risks.penalties ? \'Deselect\' : \'Select\'}}">\n{{\'REPORTS.PENALTIES\' | translate}}</md-checkbox></md-input-container><md-input-container flex><md-checkbox \nclass="no-label" ng-model="vm.reportSelected.data_json.risks.factual_causes" \naria-label="{{vm.reportSelected.data_json.risks.factual_causes ? \'Deselect\' : \'Select\'}}">\n{{\'REPORTS.ASSUMPTIONS\' | translate}}</md-checkbox></md-input-container><md-input-container flex><md-checkbox \nclass="no-label" ng-model="vm.reportSelected.data_json.risks.risk_level" \naria-label="{{vm.reportSelected.data_json.risks.risk_level ? \'Deselect\' : \'Select\'}}">\n{{\'REPORTS.RISK_LEVEL\' | translate}}</md-checkbox></md-input-container></div><div \nng-if="vm.reportSelected.data_json.risks.active" class="ph-15" layout="row" layout-align="start center">\n<md-input-container flex><md-checkbox \nng-change="vm.reportSelected.data_json.risks.processes.controls.active= false;\n                        vm.reportSelected.data_json.risks.processes.controls.action_plan= false;\n                        vm.reportSelected.data_json.risks.processes.controls.evidences= false;\n                        vm.reportSelected.data_json.risks.processes.controls.nonconformity= false;" \nclass="no-label" ng-model="vm.reportSelected.data_json.risks.processes.active" \naria-label="{{vm.reportSelected.data_json.risks.processes.active ? \'Deselect\' : \'Select\'}}">\n{{\'REPORTS.PROCESSES\' | translate}}</md-checkbox></md-input-container></div><div \nng-if="vm.reportSelected.data_json.risks.active && vm.reportSelected.data_json.risks.processes.active" class="ph-15" \nlayout="row" layout-align="start center"><md-input-container flex><md-checkbox \nng-change="vm.reportSelected.data_json.risks.processes.controls.action_plan= false;\n                        vm.reportSelected.data_json.risks.processes.controls.evidences= false;\n                        vm.reportSelected.data_json.risks.processes.controls.nonconformity= false" \nclass="no-label" ng-model="vm.reportSelected.data_json.risks.processes.controls.active" \naria-label="{{vm.reportSelected.data_json.risks.processes.controls.active ? \'Deselect\' : \'Select\'}}">\n{{\'REPORTS.CONTROLS\' | translate}}</md-checkbox></md-input-container><md-input-container \nng-if="vm.reportSelected.data_json.risks.processes.controls.active" flex><md-checkbox class="no-label" \nng-model="vm.reportSelected.data_json.risks.processes.controls.action_plan" \naria-label="{{vm.reportSelected.data_json.risks.processes.controls.action_plan ? \'Deselect\' : \'Select\'}}">\n{{\'REPORTS.ACTION_PLAN\' | translate}}</md-checkbox></md-input-container><md-input-container \nng-if="vm.reportSelected.data_json.risks.processes.controls.active" flex><md-checkbox class="no-label" \nng-model="vm.reportSelected.data_json.risks.processes.controls.evidences" \naria-label="{{vm.reportSelected.data_json.risks.processes.controls.evidences ? \'Deselect\' : \'Select\'}}">\n{{\'REPORTS.EVIDENCES\' | translate}}</md-checkbox></md-input-container><md-input-container \nng-if="vm.reportSelected.data_json.risks.processes.controls.active" flex><md-checkbox class="no-label" \nng-model="vm.reportSelected.data_json.risks.processes.controls.nonconformity" \naria-label="{{vm.reportSelected.data_json.risks.processes.controls.nonconformity ? \'Deselect\' : \'Select\'}}">\n{{\'REPORTS.NON_CONFORMITY\' | translate}}</md-checkbox></md-input-container></div><md-input-container \nclass="md-block border separator fix mb-30 md-default-theme"></md-input-container><div layout="row" \nlayout-align="start center"><md-input-container flex><md-checkbox class="no-label" \nng-model="vm.reportSelected.data_json.risk_map.active" \naria-label="{{vm.reportSelected.data_json.risk_map.active ? \'Deselect\' : \'Select\'}}">{{\'REPORTS.RISK_MAP\' | translate}}\n</md-checkbox></md-input-container></div><div ng-if="vm.reportSelected.data_json.risk_map.active" layout="row" \nlayout-align="start center"><label>Clasificado por:</label></div><div \nng-if="vm.reportSelected.data_json.risk_map.active" class="ph-15" layout="row" layout-align="start center">\n<md-input-container flex><md-checkbox class="no-label" ng-model="vm.reportSelected.data_json.risk_map.residual" \naria-label="{{vm.reportSelected.data_json.residual ? \'Deselect\' : \'Select\'}}">{{\'REPORTS.RESIDUAL\' | translate}}\n</md-checkbox></md-input-container><md-input-container flex><md-checkbox class="no-label" \nng-model="vm.reportSelected.data_json.risk_map.inherent" \naria-label="{{vm.reportSelected.data_json.inherent ? \'Deselect\' : \'Select\'}}">{{\'REPORTS.INHERENT\' | translate}}\n</md-checkbox></md-input-container></div></div></form></div>');
$templateCache.put('app/main/apps/reports/views/read/new.html','<div fill-width layout="column"><div class="form-wrapper md-whiteframe-1dp without-line" flex="100"><form \nname="vm.basicForm" class="md-inline-form" novalidate><div><md-input-container class="md-block"><label \nng-bind="\'Name\'"></label> <input required type="text" required name="title" ng-model="vm.reportNew.title">\n</md-input-container><div layout="row" layout-align="start center" class=""><md-input-container flex class="md-block">\n<label class="inline">{{\'REPORTS.BRANCH\' | translate}}</label><md-select required ng-model="vm.reportNew.branch_id">\n<md-option ng-repeat="branch in vm.companyBranches" ng-value="branch.id">{{branch.name}}</md-option></md-select>\n</md-input-container></div><div layout="row" layout-align="start center"><md-datepicker \nng-if="!vm.reportNew.is_recurrent" ng-model="vm.reportNew.from_date" \nmd-placeholder="{{\'REPORTS.START_DATE\' | translate}}" ng-required="false" md-date-locale="vm.monthFormat" \nmd-mode="month" md-open-on-focus="true"></md-datepicker><md-datepicker class="ml-25" \nng-disabled="!vm.reportNew.from_date" ng-if="!vm.reportNew.is_recurrent" ng-model="vm.reportNew.to_date" \nmd-placeholder="{{\'REPORTS.END_DATE\' | translate}}" ng-required="false" md-date-locale="vm.monthFormat" \nmd-mode="month" md-open-on-focus="true"></md-datepicker></div></div></form></div><md-input-container \nclass="md-block border separator mb-30 md-default-theme"><h2 class="title ng-scope" translate="REPORTS.REPORT_DATA">\nDatos del informe</h2></md-input-container><form name="vm.reportDataForm" class="md-inline-form" novalidate><div \nclass="ph-25 mb-100"><div layout="row" layout-align="start center"><md-input-container flex><md-checkbox \nclass="no-label" ng-model="vm.reportNew.data_json.employees.active" \naria-label="{{vm.reportNew.data_json.employees.active ? \'Deselect\' : \'Select\'}}">{{\'REPORTS.EMPLOYEES\' | translate}}\n</md-checkbox></md-input-container></div><md-input-container \nclass="md-block border separator fix mb-30 md-default-theme"></md-input-container><div layout="row" \nlayout-align="start center"><md-input-container flex><md-checkbox class="no-label" \nng-model="vm.reportNew.data_json.questionnaires.active" \naria-label="{{vm.reportNew.data_json.questionnaires.active ? \'Deselect\' : \'Select\'}}">\n{{\'GLOBAL.QUESTIONNAIRES\' | translate}}</md-checkbox></md-input-container></div><div \nng-if="vm.reportNew.data_json.questionnaires.active" layout="row" layout-align="start center"><label>\nPreguntas seg\xFAn respuesta</label></div><div ng-if="vm.reportNew.data_json.questionnaires.active" class="ph-15" \nlayout="row" layout-align="start center"><md-input-container flex><md-checkbox class="no-label" \nng-model="vm.reportNew.data_json.questionnaires.yes.active" \naria-label="{{vm.reportNew.data_json.questionnaires.yes.active ? \'Deselect\' : \'Select\'}}">\n{{\'REPORTS.QUESTIONNAIRES_YES\' | translate}}</md-checkbox></md-input-container><md-input-container flex><md-checkbox \nclass="no-label" ng-model="vm.reportNew.data_json.questionnaires.no" \naria-label="{{vm.reportNew.data_json.questionnaires.no ? \'Deselect\' : \'Select\'}}">\n{{\'REPORTS.QUESTIONNAIRES_NO\' | translate}}</md-checkbox></md-input-container><md-input-container flex><md-checkbox \nclass="no-label" ng-model="vm.reportNew.data_json.questionnaires.not_answered" \naria-label="{{vm.reportNew.data_json.questionnaires.not_answered ? \'Deselect\' : \'Select\'}}">\n{{\'REPORTS.QUESTIONNAIRES_NOT_ANSWERED\' | translate}}</md-checkbox></md-input-container></div><div \nng-if="vm.reportNew.data_json.questionnaires.yes.active" layout="row" layout-align="start center"><label>\nControles seg\xFAn estado</label></div><div ng-if="vm.reportNew.data_json.questionnaires.yes.active" class="ph-15" \nlayout="row" layout-align="start center"><md-input-container flex><md-checkbox class="no-label" \nng-model="vm.reportNew.data_json.questionnaires.yes.controls_yes" \naria-label="{{vm.reportNew.data_json.questionnaires.yes.controls_yes ? \'Deselect\' : \'Select\'}}">\n{{\'REPORTS.CONTROLS_YES\' | translate}}</md-checkbox></md-input-container><md-input-container flex><md-checkbox \nclass="no-label" ng-model="vm.reportNew.data_json.questionnaires.yes.controls_no" \naria-label="{{vm.reportNew.data_json.questionnaires.yes.controls_no ? \'Deselect\' : \'Select\'}}">\n{{\'REPORTS.CONTROLS_NO\' | translate}}</md-checkbox></md-input-container><md-input-container flex><md-checkbox \nclass="no-label" ng-model="vm.reportNew.data_json.questionnaires.yes.controls_not_apply" \naria-label="{{vm.reportNew.data_json.questionnaires.yes.controls_not_apply ? \'Deselect\' : \'Select\'}}">\n{{\'REPORTS.CONTROLS_NOT_APPLY\' | translate}}</md-checkbox></md-input-container></div><md-input-container \nclass="md-block border separator fix mb-30 md-default-theme"></md-input-container><div layout="row" \nlayout-align="start center"><md-input-container flex><md-checkbox \nng-change="vm.reportNew.data_json.risks.processes.active= false;\n                        vm.reportNew.data_json.risks.processes.controls.active= false;\n                        vm.reportNew.data_json.risks.processes.controls.action_plan= false;\n                        vm.reportNew.data_json.risks.processes.controls.evidences= false;\n                        vm.reportNew.data_json.risks.conducts= false;\n                        vm.reportNew.data_json.risks.penalties= false;\n                        vm.reportNew.data_json.risks.factual_causes= false;\n                        vm.reportNew.data_json.risks.risk_level= false;\n                        vm.reportNew.data_json.risks.processes.controls.nonconformity= false;" \nclass="no-label" ng-model="vm.reportNew.data_json.risks.active" \naria-label="{{vm.reportNew.data_json.risks.active ? \'Deselect\' : \'Select\'}}">{{\'GLOBAL.RISKS\' | translate}}\n</md-checkbox></md-input-container></div><div ng-if="vm.reportNew.data_json.risks.active" layout="row" \nlayout-align="start center"><label>{{\'REPORTS.RISK_DATA\' | translate}}</label></div><div \nng-if="vm.reportNew.data_json.risks.active" class="ph-15" layout="row" layout-align="start center"><md-input-container \nflex><md-checkbox class="no-label" ng-model="vm.reportNew.data_json.risks.conducts" \naria-label="{{vm.reportNew.data_json.risks.conducts ? \'Deselect\' : \'Select\'}}">{{\'REPORTS.BEHAVIORS\' | translate}}\n</md-checkbox></md-input-container><md-input-container flex><md-checkbox class="no-label" \nng-model="vm.reportNew.data_json.risks.penalties" \naria-label="{{vm.reportNew.data_json.risks.penalties ? \'Deselect\' : \'Select\'}}">{{\'REPORTS.PENALTIES\' | translate}}\n</md-checkbox></md-input-container><md-input-container flex><md-checkbox class="no-label" \nng-model="vm.reportNew.data_json.risks.factual_causes" \naria-label="{{vm.reportNew.data_json.risks.factual_causes ? \'Deselect\' : \'Select\'}}">\n{{\'REPORTS.ASSUMPTIONS\' | translate}}</md-checkbox></md-input-container><md-input-container flex><md-checkbox \nclass="no-label" ng-model="vm.reportNew.data_json.risks.risk_level" \naria-label="{{vm.reportNew.data_json.risks.risk_level ? \'Deselect\' : \'Select\'}}">{{\'REPORTS.RISK_LEVEL\' | translate}}\n</md-checkbox></md-input-container></div><div ng-if="vm.reportNew.data_json.risks.active" class="ph-15" layout="row" \nlayout-align="start center"><md-input-container flex><md-checkbox \nng-change="vm.reportNew.data_json.risks.processes.controls.active= false;\n                        vm.reportNew.data_json.risks.processes.controls.action_plan= false;\n                        vm.reportNew.data_json.risks.processes.controls.evidences= false;\n                        vm.reportNew.data_json.risks.processes.controls.nonconformity= false;" \nclass="no-label" ng-model="vm.reportNew.data_json.risks.processes.active" \naria-label="{{vm.reportNew.data_json.risks.processes.active ? \'Deselect\' : \'Select\'}}">\n{{\'REPORTS.PROCESSES\' | translate}}</md-checkbox></md-input-container></div><div \nng-if="vm.reportNew.data_json.risks.active && vm.reportNew.data_json.risks.processes.active" class="ph-15" \nlayout="row" layout-align="start center"><md-input-container flex><md-checkbox \nng-change="vm.reportNew.data_json.risks.processes.controls.action_plan= false;\n                        vm.reportNew.data_json.risks.processes.controls.evidences= false;\n                        vm.reportNew.data_json.risks.processes.controls.nonconformity= false" \nclass="no-label" ng-model="vm.reportNew.data_json.risks.processes.controls.active" \naria-label="{{vm.reportNew.data_json.risks.processes.controls.active ? \'Deselect\' : \'Select\'}}">\n{{\'REPORTS.CONTROLS\' | translate}}</md-checkbox></md-input-container><md-input-container \nng-if="vm.reportNew.data_json.risks.processes.controls.active" flex><md-checkbox class="no-label" \nng-model="vm.reportNew.data_json.risks.processes.controls.action_plan" \naria-label="{{vm.reportNew.data_json.risks.processes.controls.action_plan ? \'Deselect\' : \'Select\'}}">\n{{\'REPORTS.ACTION_PLAN\' | translate}}</md-checkbox></md-input-container><md-input-container \nng-if="vm.reportNew.data_json.risks.processes.controls.active" flex><md-checkbox class="no-label" \nng-model="vm.reportNew.data_json.risks.processes.controls.evidences" \naria-label="{{vm.reportNew.data_json.risks.processes.controls.evidences ? \'Deselect\' : \'Select\'}}">\n{{\'REPORTS.EVIDENCES\' | translate}}</md-checkbox></md-input-container><md-input-container \nng-if="vm.reportNew.data_json.risks.processes.controls.active" flex><md-checkbox class="no-label" \nng-model="vm.reportNew.data_json.risks.processes.controls.nonconformity" \naria-label="{{vm.reportNew.data_json.risks.processes.controls.nonconformity ? \'Deselect\' : \'Select\'}}">\n{{\'REPORTS.NON_CONFORMITY\' | translate}}</md-checkbox></md-input-container></div><md-input-container \nclass="md-block border separator fix mb-30 md-default-theme"></md-input-container><div layout="row" \nlayout-align="start center"><md-input-container flex><md-checkbox class="no-label" \nng-model="vm.reportNew.data_json.risk_map.active" \naria-label="{{vm.reportNew.data_json.risk_map.active ? \'Deselect\' : \'Select\'}}">{{\'REPORTS.RISK_MAP\' | translate}}\n</md-checkbox></md-input-container></div><div ng-if="vm.reportNew.data_json.risk_map.active" layout="row" \nlayout-align="start center"><label>Clasificado por:</label></div><div ng-if="vm.reportNew.data_json.risk_map.active" \nclass="ph-15" layout="row" layout-align="start center"><md-input-container flex><md-checkbox class="no-label" \nng-model="vm.reportNew.data_json.risk_map.residual" \naria-label="{{vm.reportNew.data_json.residual ? \'Deselect\' : \'Select\'}}">{{\'REPORTS.RESIDUAL\' | translate}}\n</md-checkbox></md-input-container><md-input-container flex><md-checkbox class="no-label" \nng-model="vm.reportNew.data_json.risk_map.inherent" \naria-label="{{vm.reportNew.data_json.inherent ? \'Deselect\' : \'Select\'}}">{{\'REPORTS.INHERENT\' | translate}}\n</md-checkbox></md-input-container></div></div></form></div>');
$templateCache.put('app/main/apps/reports/views/read/read-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="vm.loadingReadPane" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="content thread-detail" layout="row" layout-align="center center" flex \nng-if="!vm.reportSelected && !vm.reportNew"><div class="no-thread-selected" layout="column" \nlayout-align="center center" flex><md-icon md-font-icon="icon-google-circles-communities" class="s120 grey-400-fg">\n</md-icon><span class="hint-text" translate="GLOBAL.SELECT_ITEM"></span></div></div><div id="read-view" \nclass="fullheight"><div class="toolbar grey-100-bg colored-bg" layout="row" layout-align="space-between center" \nscroll="" ng-if="vm.reportSelected || vm.reportNew"><div layout="row" layout-align="start center"></div><div \nlayout="row" layout-align="end center" hide show-gt-sm><md-button translate="GLOBAL.CANCEL" type="button" \nng-click="vm.closeReport()" class="md-raised md-warn" aria-label="Cancel"></md-button><md-button \ntranslate="GLOBAL.SAVE" type="button" ng-disabled="vm.checkFields()" ng-click="vm.sendReport()" \nclass="md-raised md-accent" aria-label="Save"></md-button></div><div layout="row" layout-align="end center" hide-gt-sm>\n<md-button type="button" ng-click="vm.sendReport()" ng-disabled="vm.checkFields()" \nclass="md-accent md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" aria-label="Send"><md-icon \nmd-font-icon="icon-plus"></md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.SAVE"></span></md-tooltip>\n</md-button><md-button type="button" ng-click="vm.closeReport()" \nclass="md-warn md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" aria-label="Cancel"><md-icon \nmd-font-icon="icon-window-close"></md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.CANCEL"></span>\n</md-tooltip></md-button></div></div><div ng-if="vm.reportNew" class="main-content"><content ng-if="vm.reportNew" \nclass="" ng-include="\'app/main/apps/reports/views/read/new.html\'"></content></div><div ng-if="vm.reportSelected">\n<md-tabs md-dynamic-height md-border-bottom flex="100"><md-tab><md-tab-label><span \nng-bind-html="vm.translate(\'REPORTS.STATUS\')"></span></md-tab-label><md-tab-body><md-content><content layout="row" \nng-include="\'app/main/apps/reports/views/read/status.html\'"></content></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span ng-bind-html="vm.translate(\'REPORTS.CONFIG\')"></span></md-tab-label><md-tab-body><md-content>\n<content layout="row" ng-include="\'app/main/apps/reports/views/read/edit.html\'"></content></md-content></md-tab-body>\n</md-tab></md-tabs></div></div>');
$templateCache.put('app/main/apps/reports/views/read/status.html','<div fill-width class="ph-15" layout="column"><div class="flex" layout="row" layout-align="start center"><div \nclass="name flex" layout="row" layout-align="start center"><h1>{{vm.reportSelected.title}} <span \nng-if="vm.reportSelected.is_recurrent">({{\'REPORTS.RECURRENT\' | translate}})</span></h1></div><div layout="row" \nlayout-align="end center"><span ng-if="vm.reportSelected.output.status" class="badge afirmative" \ntranslate="GLOBAL.STATUS_FINISHED"></span> <span ng-if="!vm.reportSelected.output.status" class="badge process" \ntranslate="GLOBAL.STATUS_PENDING"></span></div></div><div layout="row" layout-align="start center"><div \nng-if="!vm.reportSelected.is_recurrent" class="text-truncate pt-5" layout="row" layout-align="start center"><span>\n{{\'GLOBAL.FROM\' | translate}} </span><span ng-if="vm.reportSelected.from_date" class="grey-500-fg">\n{{vm.reportSelected.from_date | monthDate}}</span> <span ng-if="!vm.reportSelected.from_date" class="grey-500-fg">\n{{\'REPORTS.NO_DATE\' | translate}}</span></div><div ng-if="!vm.reportSelected.is_recurrent" \nclass="text-truncate pt-5 ml-5" layout="row" layout-align="start center"><span>{{\'GLOBAL.TO\' | translate}} </span><span\n ng-if="vm.reportSelected.to_date" class="grey-500-fg">{{vm.reportSelected.to_date | monthDate}}</span> <span \nng-if="!vm.reportSelected.to_date" class="grey-500-fg">{{\'REPORTS.NO_DATE\' | translate}}</span></div></div><div \nng-if="vm.reportSelected.is_recurrent" class="text-truncate pt-5" layout="row" layout-align="start center"><span>\n{{\'GLOBAL.FRECUENCY\' | translate}} </span><span ng-switch="vm.reportSelected.recurrent_frecuency" class="grey-500-fg">\n<span ng-switch-when="1">1 D\xEDa</span> <span ng-switch-when="7">1 semana</span> <span ng-switch-when="14">2 semanas\n</span> <span ng-switch-when="30">1 Mes</span> <span ng-switch-when="90">3 Meses</span> <span ng-switch-when="180">\n6 Meses</span></span></div><div ng-if="vm.reportSelected.is_recurrent" class="text-truncate pt-5" layout="row" \nlayout-align="start center"><span>{{\'GLOBAL.RANGE\' | translate}} </span><span \nng-switch="vm.reportSelected.recurrent_range" class="grey-500-fg"><span ng-switch-when="1">1 D\xEDa</span> <span \nng-switch-when="7">1 semana</span> <span ng-switch-when="14">2 semanas</span> <span ng-switch-when="30">1 Mes</span> \n<span ng-switch-when="90">3 Meses</span> <span ng-switch-when="180">6 Meses</span></span></div><div flex \nclass="text-truncate mt-15 text-right" layout="row" layout-align="end center"><md-button \nng-if="vm.reportSelected.currentKeyUrlhtml" ng-click="vm.openPreviewDialog()" \nclass="md-raised md-accent md-button ph-10"><span><md-icon class="mr-10" md-font-icon="icon-eye"></md-icon>\n{{\'GLOBAL.PREVIEW\' | translate}}</span></md-button><md-button ng-if="vm.reportSelected.currentKeyUrlpdf" \nclass="md-raised md-accent md-button ph-10"><a class="color-white" ng-click="vm.downloadReport(\'pdf\')" target="_blank" \ndownload><md-icon class="mr-10" md-font-icon="icon-download"></md-icon>{{\'GLOBAL.DOWNLOAD_PDF\' | translate}}</a>\n</md-button><md-button ng-if="vm.reportSelected.currentKeyUrljson" class="md-raised md-accent md-button ph-10"><a \nclass="color-white" ng-click="vm.downloadReport(\'json\')" target="_blank" download><md-icon class="mr-10" \nmd-font-icon="icon-download"></md-icon>{{\'REPORTS.DOWNLOAD_DATA_JSON\' | translate}}</a></md-button></div></div>');
$templateCache.put('app/main/apps/riskmap/views/dialogs/edit-risk-dialog.html','<md-dialog aria-label="Editar Riesgo" class="edit-risk-dialog"><form ng-submit="vm.save()"><md-toolbar \nclass="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><h4 \nclass="text-uppercase ml-20" translate="RISKMAP.EDIT_RISK"></h4><div class="absolute-right pr-10" layout="row">\n<md-button class="md-icon-button" ng-click="vm.cancel()" aria-label="Close dialog" translate \ntranslate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content class="md-dialog-content"><div layout="column" layout-padding><div class="risk-info" \nlayout="column" layout-padding><h3 class="md-headline" ng-bind-html="vm.risk.active_risk.risk.name"></h3><p \nclass="md-body-1"><strong translate="RISK.PROCESS"></strong>: {{vm.risk.process.name}}</p><p class="md-body-1"><strong \ntranslate="GLOBAL.CREATED"></strong>: {{vm.risk.created_at | fullDate}}</p></div><md-divider></md-divider><div \nlayout="column" layout-gutter="16"><div layout="column"><label class="md-body-1" translate="RISK.REPUTATION_IMPACT">\n</label><div layout="row" layout-align="space-between center"><md-slider ng-model="vm.editValues.reputation_impact" \nmin="1" max="5" step="1" class="md-primary" flex></md-slider><span class="md-body-2 impact-label" \nng-bind="vm.getImpactLabel(vm.editValues.reputation_impact)"></span></div></div><div layout="column"><label \nclass="md-body-1" translate="RISK.PENAL_CODE_IMPACT"></label><div layout="row" layout-align="space-between center">\n<md-slider ng-model="vm.editValues.penal_code_impact" min="1" max="5" step="1" class="md-primary" flex></md-slider>\n<span class="md-body-2 impact-label" ng-bind="vm.getImpactLabel(vm.editValues.penal_code_impact)"></span></div></div>\n<div layout="column"><label class="md-body-1" translate="RISK.CLIENT_LOSS"></label><div layout="row" \nlayout-align="space-between center"><md-slider ng-model="vm.editValues.client_loss" min="1" max="5" step="1" \nclass="md-primary" flex></md-slider><span class="md-body-2 impact-label" \nng-bind="vm.getImpactLabel(vm.editValues.client_loss)"></span></div></div><div layout="column"><label \nclass="md-body-1" translate="RISK.RISK_IMPACT"></label><div layout="row" layout-align="space-between center"><md-slider\n ng-model="vm.editValues.risk_impact" min="1" max="5" step="1" class="md-primary" flex></md-slider><span \nclass="md-body-2 impact-label" ng-bind="vm.getImpactLabel(vm.editValues.risk_impact)"></span></div></div><div \nlayout="column"><label class="md-body-1" translate="RISK.PROCESS_ODDS_OF_OCCURRENCE"></label><div layout="row" \nlayout-align="space-between center"><md-slider ng-model="vm.editValues.process_odds_of_occurrence" min="1" max="5" \nstep="1" class="md-primary" flex></md-slider><span class="md-body-2 impact-label" \nng-bind="vm.getImpactLabel(vm.editValues.process_odds_of_occurrence)"></span></div></div><div layout="column"><label \nclass="md-body-1" translate="RISK.EVIDENCE_AVERAGE"></label><div layout="row" layout-align="space-between center">\n<md-slider ng-model="vm.editValues.evidence_average" min="0" max="5" step="1" class="md-primary" flex></md-slider><span\n class="md-body-2 impact-label" ng-bind="vm.getImpactLabel(vm.editValues.evidence_average) || \'N/A\'"></span></div>\n</div><div layout="column"><label class="md-body-1" translate="RISK.PROCESS_PROBABILITY"></label><div layout="row" \nlayout-align="space-between center"><md-slider ng-model="vm.editValues.process_probability" min="1" max="5" step="1" \nclass="md-primary" flex></md-slider><span class="md-body-2 impact-label" \nng-bind="vm.getImpactLabel(vm.editValues.process_probability)"></span></div></div><div layout="column"><label \nclass="md-body-1" translate="RISK.COMPUTED_PROCESS"></label><div layout="row" layout-align="space-between center">\n<md-slider ng-model="vm.editValues.computed_process" min="{{vm.computedProcessConfig.min}}" \nmax="{{vm.computedProcessConfig.max}}" step="{{vm.computedProcessConfig.step}}" class="md-primary" flex></md-slider>\n<span class="md-body-2 impact-label computed-process-label" \nng-bind="vm.getComputedProcessLabel(vm.editValues.computed_process)"></span></div></div></div><md-divider></md-divider>\n<div layout="column" layout-padding class="summary-section"><h4 class="md-subhead" translate="RISKMAP.CURRENT_VALUES">\n</h4><div layout="row" layout-wrap layout-gutter="8"><div flex="25" class="summary-item"><span class="md-caption" \ntranslate="RISK.REPUTATION_IMPACT"></span><div class="md-body-2">\n{{vm.editValues.reputation_impact}} - {{vm.getImpactLabel(vm.editValues.reputation_impact)}}</div></div><div flex="25" \nclass="summary-item"><span class="md-caption" translate="RISK.PENAL_CODE_IMPACT"></span><div class="md-body-2">\n{{vm.editValues.penal_code_impact}} - {{vm.getImpactLabel(vm.editValues.penal_code_impact)}}</div></div><div flex="25" \nclass="summary-item"><span class="md-caption" translate="RISK.CLIENT_LOSS"></span><div class="md-body-2">\n{{vm.editValues.client_loss}} - {{vm.getImpactLabel(vm.editValues.client_loss)}}</div></div><div flex="25" \nclass="summary-item"><span class="md-caption" translate="RISK.RISK_IMPACT"></span><div class="md-body-2">\n{{vm.editValues.risk_impact}} - {{vm.getImpactLabel(vm.editValues.risk_impact)}}</div></div><div flex="25" \nclass="summary-item"><span class="md-caption" translate="RISK.PROCESS_ODDS_OF_OCCURRENCE"></span><div \nclass="md-body-2">\n{{vm.editValues.process_odds_of_occurrence}} - {{vm.getImpactLabel(vm.editValues.process_odds_of_occurrence)}}</div>\n</div><div flex="25" class="summary-item"><span class="md-caption" translate="RISK.EVIDENCE_AVERAGE"></span><div \nclass="md-body-2">\n{{vm.editValues.evidence_average || \'N/A\'}} - {{vm.getImpactLabel(vm.editValues.evidence_average) || \'N/A\'}}</div>\n</div><div flex="25" class="summary-item"><span class="md-caption" translate="RISK.PROCESS_PROBABILITY"></span><div \nclass="md-body-2">{{vm.editValues.process_probability}} - {{vm.getImpactLabel(vm.editValues.process_probability)}}\n</div></div><div flex="25" class="summary-item"><span class="md-caption" translate="RISK.COMPUTED_PROCESS"></span><div \nclass="md-body-2">{{vm.getComputedProcessLabel(vm.editValues.computed_process)}}</div></div></div></div></div>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><md-button ng-click="vm.cancel()" \ntranslate="GLOBAL.CANCEL"></md-button><md-button class="md-primary" ng-click="vm.save()" ng-disabled="vm.loading" \ntranslate="GLOBAL.SAVE"><md-progress-circular ng-if="vm.loading" md-mode="indeterminate" md-diameter="20" \nclass="ml-10"></md-progress-circular></md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/riskmap/views/main/branch.html','<div class="content thread-detail" layout="row" layout-align="center center" flex ng-if="!vm.currentRisk"><div \nclass="no-thread-selected" layout="column" layout-align="center center" flex><md-icon md-font-icon="icon-timelapse" \nclass="s120 grey-400-fg"></md-icon><span class="hint-text" translate="RISK.SELECT_RISK_DETAILS"></span></div></div><div\n class="toolbar grey-100-bg colored-bg" layout="row" layout-align="space-between center" scroll="" \nng-if="vm.currentRisk"><div layout="row" layout-align="start center"><a ng-click="vm.closeRisk()"><md-icon \nmd-font-icon="icon-close"></md-icon></a></div><div layout="row" layout-align="end center" hide show-gt-sm><md-button \ntranslate="GLOBAL.EDIT" type="button" ng-click="vm.editRisk()" class="md-raised md-accent" aria-label="Edit">\n</md-button></div><div layout="row" layout-align="end center" hide-gt-sm><md-button type="button" \nng-click="vm.editRisk()" class="md-accent md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" \naria-label="Edit"><md-icon md-font-icon="icon-pencil"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.EDIT"></span></md-tooltip></md-button></div></div><div class="without-line scrollable preview" \nflex="100" ng-if="vm.currentRisk"><div layout="column"><div layout="column" class="p-24"><div layout="row" \nlayout-align="start center"><div class="title h1 ng-binding ng-scope" ng-bind-html="vm.currentRisk.name"></div></div>\n<div layout-gt-xs="row" layout-xs="column" layout-align-gt-xs="space-around center" layout-align-xs="center center">\n<div layout="column" class="risk-details-gauge"><c3chart bindto-id="gauge-plot{{risk.id}}-chart"><chart-size \nchart-height="200" chart-width="250"><chart-colors color-pattern="#FF0000"><chart-column \ncolumn-id="chartpreview-{{vm.currentRisk.id}}" column-color="{{vm.impactColor(vm.currentRisk.impact)}}" \ncolumn-values="{{vm.currentRisk.impact}}" column-type="gauge"><chart-gauge min="00" max="25" \nunits="{{vm.impactText(vm.currentRisk.computedRisk)}}" width="40" show-label="true" expand="false"></c3chart></div><div\n layout="column"><div class="p-16"><div ng-if="vm.branding.tenant != \'gnl\'" class="text h4 pt-8 ng-binding ng-scope">\n<span translate="RISK.REPUTATION_IMPACT"></span><span>:</span> <span ng-bind-html="vm.currentRisk.reputation_impact">\n</span></div><div class="text h4 pt-8 ng-binding ng-scope"><span translate="RISK.PENAL_CODE_IMPACT"></span><span>:\n</span> <span ng-bind-html="vm.currentRisk.penal_code_impact"></span></div><div \nclass="text h4 pt-8 ng-binding ng-scope"><span translate="RISK.CLIENT_LOSS"></span><span>:</span> <span \nng-bind-html="vm.currentRisk.client_loss"></span></div><div class="text h4 pt-8 ng-binding ng-scope"><span \ntranslate="RISK.COMPUTED_RISK"></span><span>:</span> <span ng-bind-html="vm.currentRisk.computedRisk"></span></div>\n</div></div></div></div><div layout="column"><div class="toolbar grey-100-bg colored-bg" layout="row" \nlayout-align="space-between center"><div layout="row" layout-align="start center"><h2>Actividades</h2></div></div><div \nclass="activities-list"><md-list><md-list-item flex="100"><div layout="row" layout-align="space-between center" \nflex="100"><div layout="row" layout-align="start center"><div class="ml-16 mr-8"><div class="avatar-wrapper"><img \nclass="avatar s24" \nsrc="https://lh6.googleusercontent.com/-8ToRxkEQIWs/AAAAAAAAAAI/AAAAAAAAAVI/xyASkLZ5z34/photo.jpg?sz=50"><md-tooltip>\nRobert Pettinat</md-tooltip></div></div><div class="field"><span class="grey-800-fg">Actividad 3</span></div><div \nclass="field"><span class="grey-800-fg">Hace 2 horas</span></div></div><md-button class="md-icon-button"><md-icon \nmd-font-icon="icon-dots-vertical"></md-icon></md-button></div><md-divider></md-divider></md-list-item><md-list-item \nflex="100"><div layout="row" layout-align="space-between center" flex="100"><div layout="row" \nlayout-align="start center"><div class="ml-16 mr-8"><div class="avatar-wrapper"><img class="avatar s24" \nsrc="https://lh5.googleusercontent.com/-c1-n6huR9u8/AAAAAAAAAAI/AAAAAAAAAXk/BPM7tLw3JK0/photo.jpg?sz=50"><md-tooltip>\nCharles Alonely</md-tooltip></div></div><div class="field"><span class="grey-800-fg">Actividad 2</span></div><div \nclass="field"><span class="grey-800-fg">Hace 6 horas</span></div></div><md-button class="md-icon-button"><md-icon \nmd-font-icon="icon-dots-vertical"></md-icon></md-button></div><md-divider></md-divider></md-list-item><md-list-item \nflex="100"><div layout="row" layout-align="space-between center" flex="100"><div layout="row" \nlayout-align="start center"><div class="ml-16 mr-8"><div class="avatar-wrapper"><img class="avatar s24" \nsrc="https://lh6.googleusercontent.com/-8ToRxkEQIWs/AAAAAAAAAAI/AAAAAAAAAVI/xyASkLZ5z34/photo.jpg?sz=50"><md-tooltip>\nRobert Pettinat</md-tooltip></div></div><div class="field"><span class="grey-800-fg">Actividad 1</span></div><div \nclass="field"><span class="grey-800-fg">Hace 1 d\xEDa</span></div></div><md-button class="md-icon-button"><md-icon \nmd-font-icon="icon-dots-vertical"></md-icon></md-button></div><md-divider></md-divider></md-list-item></md-list></div>\n</div></div></div>');
$templateCache.put('app/main/apps/riskmap/views/main/company.html','<div class="content-wrapper" layout="row" flex \nng-if="vm.isCompanySelected() && vm.risksMap.length == 0 && !vm.loadingData && !loadingMapProcess"><div \nclass="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><span \nclass="hint-text" translate="RISKMAP.NO_MAPS_FOUND"></span></div></div></div><div flex id="snaphost" \nstyle="background: #f6f6f6" class="p-10 scrollable preview" flex="100" \nng-if="vm.isCompanySelected() && vm.risksMap.length> 0 && !vm.loadingData && !loadingMapProcess"><div \nstyle="position: absolute; left: 50%" data-html2canvas-ignore="true" flex layout="column" layout-align="center center" \nlayout-padding layout-margin ng-if="isLoading" class="loading-container"><md-progress-circular md-mode="indeterminate" \nmd-diameter="30"></md-progress-circular></div><div data-html2canvas-ignore="ignore" layout-gt-xs="row" layout="column">\n<div layout="row" layout-align="start center"><div class="h2 pv-16 ph-10 ng-binding" \nstyle="text-transform: capitalize" ng-if="!vm.is_inherent">\n{{vm.translate(\'RISKMAP.RISKMAP\')}} / {{vm.riskMapDate()}} ({{vm.riskMapUpdateDate()}})</div><div \nclass="h2 pv-16 ph-10 ng-binding" ng-if="vm.is_inherent" translate="RISKMAP.RISKMAP_INHERENT"></div><md-button hide \nshow-gt-sm data-html2canvas-ignore="true" ng-click="vm.saveCanvas(\'snaphost\')"><md-icon md-font-icon="icon-download">\n</md-icon><span translate="RISKMAP.DOWNLOAD"></span></md-button></div></div><div id="table-donut" class="scrollable">\n<div class="widget-group" layout="row" flex="100" layout-wrap><ms-widget flippable="false" flex><ms-widget-front \nclass="white-bg"><md-button hide show-gt-sm data-html2canvas-ignore="true" class="download-button" \nng-click="ignore= true; vm.saveCanvas(\'snaphost\', \'#ffffff\', 800)"><md-icon md-font-icon="icon-download"></md-icon>\n<span translate="RISKMAP.DOWNLOAD"></span></md-button><div flex layout="column" layout-gt-md="row" \nlayout-align="space-between stretch"><div layout="row" layout-align="center center" class="risk-details-gauge" \nclass="table-risk" flex="65"><table ng-init="vm.forceRealodChart()" class="simple risk-table" ms-responsive-table><tr>\n<td colspan="2" rowspan="1"></td><td colspan="5" class="p-0"><strong translate="RISK.IMPACT"></strong></td></tr><tr><td\n rowspan="6" class="rotated-content"><div data-html2canvas-ignore="ignore" class="rotate-90"><strong \ntranslate="RISKMAP.PROBABILITY"></strong></div></td><td class="text-right"><div layout="row" layout-align="end center">\n<span class="risk-table-label" translate="RISK.PROCESS_AVERAGE_5"></span><strong class="ml-15 mr-10">5</strong></div>\n</td><td class="yellow-one-bg risk-button" ng-bind-html="vm.showRiskTable(5,1)" ng-click="vm.risksFilterChange(5,1)">\n</td><td class="orange-one-bg risk-button" ng-bind-html="vm.showRiskTable(5,2)" ng-click="vm.risksFilterChange(5,2)">\n</td><td class="orange-two-bg risk-button" ng-bind-html="vm.showRiskTable(5,3)" ng-click="vm.risksFilterChange(5,3)">\n</td><td class="red-two-bg risk-button" ng-bind-html="vm.showRiskTable(5,4)" ng-click="vm.risksFilterChange(5,4)"></td>\n<td class="red-three-bg risk-button" ng-bind-html="vm.showRiskTable(5,5)" ng-click="vm.risksFilterChange(5,5)"></td>\n</tr><tr><td class="text-right"><div layout="row" layout-align="end center"><span class="risk-table-label" \ntranslate="RISK.PROCESS_AVERAGE_4"></span><strong class="ml-15 mr-10">4</strong></div></td><td \nclass="green-four-bg risk-button" ng-bind-html="vm.showRiskTable(4,1)" ng-click="vm.risksFilterChange(4,1)"></td><td \nclass="yellow-four-bg risk-button" ng-bind-html="vm.showRiskTable(4,2)" ng-click="vm.risksFilterChange(4,2)"></td><td \nclass="orange-one-bg risk-button" ng-bind-html="vm.showRiskTable(4,3)" ng-click="vm.risksFilterChange(4,3)"></td><td \nclass="red-one-bg risk-button" ng-bind-html="vm.showRiskTable(4,4)" ng-click="vm.risksFilterChange(4,4)"></td><td \nclass="red-two-bg risk-button" ng-bind-html="vm.showRiskTable(4,5)" ng-click="vm.risksFilterChange(4,5)"></td></tr><tr>\n<td class="text-right"><div layout="row" layout-align="end center"><span class="risk-table-label" \ntranslate="RISK.PROCESS_AVERAGE_3"></span><strong class="ml-15 mr-10">3</strong></div></td><td \nclass="green-three-bg risk-button" ng-bind-html="vm.showRiskTable(3,1)" ng-click="vm.risksFilterChange(3,1)"></td><td \nclass="yellow-one-bg risk-button" ng-bind-html="vm.showRiskTable(3,2)" ng-click="vm.risksFilterChange(3,2)"></td><td \nclass="yellow-four-bg risk-button" ng-bind-html="vm.showRiskTable(3,3)" ng-click="vm.risksFilterChange(3,3)"></td><td \nclass="orange-one-bg risk-button" ng-bind-html="vm.showRiskTable(3,4)" ng-click="vm.risksFilterChange(3,4)"></td><td \nclass="orange-two-bg risk-button" ng-bind-html="vm.showRiskTable(3,5)" ng-click="vm.risksFilterChange(3,5)"></td></tr>\n<tr><td class="text-right"><div layout="row" layout-align="end center"><span class="risk-table-label" \ntranslate="RISK.PROCESS_AVERAGE_2"></span><strong class="ml-15 mr-10">2</strong></div></td><td \nclass="green-two-bg risk-button" ng-bind-html="vm.showRiskTable(2,1)" ng-click="vm.risksFilterChange(2,1)"></td><td \nclass="green-four-bg risk-button" ng-bind-html="vm.showRiskTable(2,2)" ng-click="vm.risksFilterChange(2,2)"></td><td \nclass="yellow-one-bg risk-button" ng-bind-html="vm.showRiskTable(2,3)" ng-click="vm.risksFilterChange(2,3)"></td><td \nclass="yellow-four-bg risk-button" ng-bind-html="vm.showRiskTable(2,4)" ng-click="vm.risksFilterChange(2,4)"></td><td \nclass="orange-one-bg risk-button" ng-bind-html="vm.showRiskTable(2,5)" ng-click="vm.risksFilterChange(2,5)"></td></tr>\n<tr><td class="text-right"><div layout="row" layout-align="end center"><span class="risk-table-label" \ntranslate="RISK.PROCESS_AVERAGE_1"></span><strong class="ml-15 mr-10">1</strong></div></td><td \nclass="green-one-bg risk-button" ng-bind-html="vm.showRiskTable(1,1)" ng-click="vm.risksFilterChange(1,1)"></td><td \nclass="green-two-bg risk-button" ng-bind-html="vm.showRiskTable(1,2)" ng-click="vm.risksFilterChange(1,2)"></td><td \nclass="green-three-bg risk-button" ng-bind-html="vm.showRiskTable(1,3)" ng-click="vm.risksFilterChange(1,3)"></td><td \nclass="green-four-bg risk-button" ng-bind-html="vm.showRiskTable(1,4)" ng-click="vm.risksFilterChange(1,4)"></td><td \nclass="yellow-one-bg risk-button" ng-bind-html="vm.showRiskTable(1,5)" ng-click="vm.risksFilterChange(1,5)"></td></tr>\n<tr><td colspan="1" rowspan="2"></td><td class="force-width" valign="bottom"><strong class="mt-5 block">1</strong> \n<span class="risk-table-label" translate="RISK.RISK_LEVELS_1"></span></td><td class="force-width" valign="bottom">\n<strong class="mt-5 block">2</strong> <span class="risk-table-label" translate="RISK.RISK_LEVELS_2"></span></td><td \nclass="force-width" valign="bottom"><strong class="mt-5 block">3</strong> <span class="risk-table-label" \ntranslate="RISK.RISK_LEVELS_3"></span></td><td class="force-width" valign="bottom"><strong class="mt-5 block">4\n</strong> <span class="risk-table-label" translate="RISK.RISK_LEVELS_4"></span></td><td class="force-width" \nvalign="bottom"><strong class="mt-5 block">5</strong> <span class="risk-table-label" translate="RISK.RISK_LEVELS_5">\n</span></td></tr></table></div><div ng-if="vm.showChart" id="pieChart" layout="row" layout-align="center center" \nclass="risk-details-gauge" flex="35"><nvd3 ng-init="vm.forceRealodChart()" style="margin: auto;" id="snap2" \noptions="vm.optionsDonut" data="vm.d3Data[0]" class="donut-general"></nvd3><div class="graph-data" layout="column">\n<span class="data-percent" ng-bind-html="vm.riskLevelPercent(vm.currentRiskMap.average)"></span> <span \nclass="data-text" ng-bind-html="vm.riskLevelText(vm.currentRiskMap.average)"></span></div></div></div>\n</ms-widget-front></ms-widget></div></div><div data-html2canvas-ignore="ignore" id="list-risks" \nclass="widget-group risk-list" ng-class="{\'mb-100\' : vm.is_inherent}" layout="row" layout-align="start center" \nflex="100" layout-wrap><ms-widget flippable="false" layout="column" flex="100"><ms-widget-front id="risklist" \nclass="white-bg"><md-button hide show-gt-sm data-html2canvas-ignore="true" class="download-button" \nng-click="vm.saveCanvas(\'list-risks\')"><md-icon md-font-icon="icon-download"></md-icon><span \ntranslate="RISKMAP.DOWNLOAD"></span></md-button><div class="ph-16 border-bottom" layout="row" \nlayout-align="space-between center"><div class="h2 pv-16" translate="RISKMAP.RISKS"></div><div class="pv-16" \nlayout="row" layout-align="end center" ng-if="vm.risksHasFilter()"><a translate="RISKMAP.CLEAR_RISKS_FILTERED" \nng-click="vm.risksFilterChange(\'\',\'\')"></a></div><div class="pv-16" layout="row" layout-align="end center"><md-select \nng-model="vm.riskOrder.sortSelect" class="simplified" ng-change="vm.riskOrderChange()"><md-option \nng-value="\'_computed_process\'" translate="RISKMAP.RISK_SORT_HIGH_LOW"></md-option><md-option \nng-value="\'computed_process\'" translate="RISKMAP.RISK_SORT_LOW_HIGH"></md-option></md-select></div></div><div \nlayout="column" class="risk-details-gauge"><div class="ph-16 pv-15 border-bottom risk-item-container" layout="row" \nlayout-align="space-between center" flex \nng-repeat="risk in vm.currentRiskMap.risk_map | filter: vm.riskOrder.filter | orderBy : vm.riskOrder.sort : vm.riskOrder.sortReverse">\n<div layout="column" flex="65" layout-align="center start"><div class="h2 text-bold text-left" flex \nng-bind-html="risk.active_risk.risk.name"></div><div class="h4 text-left mt-5" \nng-bind-html="vm.branchName(risk.branch_id)" hide-gt-xs></div><div class="h4 text-left"><span class="text-bold" \ntranslate="RISK.PROCESS"></span>: {{risk.process.name}}</div><div><span class="text-bold" translate="GLOBAL.CREATED">\n</span>: {{risk.created_at | fullDate}}</div></div><div layout="column" flex="50" layout-align="center start"><div \nclass="fullwidth p-5" flex="100" layout="row"><div id="progressbar"><div \nng-class="vm.riskLevelClass(risk.computed_process)" \nng-style="{\'width\': vm.riskLevelPercentage(risk.computed_process)* 4 + \'%\'}">\n{{vm.riskLevelPercentage(risk.computed_process)}}</div></div></div><div class="fullwidth p-5" flex="100" \nlayout-gt-xs="row" layout-align-gt-xs="end center" layout="column" layout-align="center center"><div \nclass="h4 text-right w-120 mr-20" ng-bind-html="vm.branchName(risk.branch_id)" hide show-gt-xs></div><span \nclass="text-boxed m-0 white-fg w-70" ng-class="vm.riskLevelClass(risk.computed_process)" \nng-bind-html="vm.riskLevelText(risk.computed_process)">MUY ALTO</span></div></div><div class="edit-risk-container" \nng-if="vm.userLogued.email == \'admin@gnlrussellbedford.es\' || vm.userLogued.email == \'dev@h2c.es\' || vm.userLogued.email == \'roni@h2c.es\' ">\n<button class="edit-risk-btn" ng-click="vm.editRisk(risk)" aria-label="Editar riesgo" \ntitle="Editar valores del riesgo"><i class="icon-pencil"></i></button></div></div></div></ms-widget-front></ms-widget>\n</div><div data-html2canvas-ignore="ignore" ng-if="!vm.is_inherent && vm.showChartProgression" id="monthly_chart" \nclass="widget-group" layout="row" layout-align="start center" flex="100" layout-wrap \nng-if="vm.d3DataRisks.length> 0 && !vm.currentFilter.inherent"><ms-widget id="monthly_chart_widget" flippable="false" \nlayout="row" flex="100"><ms-widget-front class="white-bg"><md-button hide show-gt-sm data-html2canvas-ignore="true" \nclass="download-button" ng-click="vm.saveCanvas(\'monthly_chart_widget\')"><md-icon md-font-icon="icon-download">\n</md-icon><span translate="RISKMAP.DOWNLOAD"></span></md-button><div class="ph-16 border-bottom" layout="row" \nlayout-align="space-between center"><div class="h2 pv-16 ng-binding" translate="RISKMAP.PROGRESSION_RISKS"></div></div>\n<div class="risk-details-gauge line-chart" ng-if="vm.riskChartType == \'global\'"><div class="color-line-group"><div \nclass="line-one color-line"></div><div class="line-two color-line"></div><div class="line-three color-line"></div><div \nclass="line-four color-line"></div><div class="line-five color-line"></div></div><nvd3 ng-init="vm.forceRealodChart()" \noptions="vm.optionsChart" data="vm.d3DataRisks"></nvd3></div></ms-widget-front></ms-widget></div><div \nng-if="!vm.is_inherent && vm.showChart" flex layout="row"><md-button hide show-gt-sm data-html2canvas-ignore="true" \nclass="download-button" ng-click="vm.saveCanvas(\'branches-donuts\', \'#f6f6f6\')"><md-icon md-font-icon="icon-download">\n</md-icon><span translate="RISKMAP.DOWNLOAD"></span></md-button></div><div data-html2canvas-ignore="ignore" \nid="branches-donuts" ng-if="!vm.is_inherent && vm.showChart" class="widget-group mb-100" layout="row" \nlayout-align="start center" flex="100" layout-wrap><ms-widget id="branch-donut" flippable="false" layout="row" \nflex="100" flex-gt-xs="50" flex-gt-sm="33" flex-gt-md="25" ng-repeat="branchRisk in vm.currentRiskMap.branches">\n<ms-widget-front class="white-bg"><div class="ph-16 border-bottom" layout="row" layout-align="space-between center">\n<div class="h3 pv-16" ng-bind-html="vm.branchName(branchRisk.branch_id)"></div><md-button aria-label="enlarge" \nclass="md-icon-button launch" ng-click="vm.selectBranch(branchRisk, branchRisk.branch_id)"><md-icon md-menu-origin \nmd-font-icon="icon-eye"></md-icon></md-button></div><div layout="row" layout-align="center center" \nclass="risk-details-gauge"><nvd3 ng-init="vm.forceRealodChart()" options="vm.optionsDonutBranches" \ndata="vm.d3Data[branchRisk.branch_id]" class="donut-general"></nvd3><div class="graph-data" layout="column"><span \nclass="data-percent" ng-bind-html="vm.riskLevelPercent(branchRisk.average)"></span> <span class="data-text" \nng-bind-html="vm.riskLevelText(branchRisk.average)"></span></div></div></ms-widget-front></ms-widget></div></div>');
$templateCache.put('app/main/apps/riskmap/views/main/nosplit-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.editMode && !vm.currentRisk" \nng-include="\'app/main/apps/riskmap/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row">\n<div class="content thread-list mail-list-pane scrollable p0" flex="100" ms-scroll="vm.msScrollOptions" \nid="thread-list" ng-if="!vm.editMode && !vm.currentRisk" ng-include="\'app/main/apps/risk/views/list/list-view.html\'">\n</div><div class="content thread-detail mail-read-pane p0" flex="" id="thread-preview" \nng-if="!vm.editMode && vm.currentRisk" ng-include="\'app/main/apps/risk/views/read/preview-structure.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-edit" \nng-if="vm.editMode" ng-include="\'app/main/apps/risk/views/edit/main-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-details" \nng-if="vm.editMode && vm.controlEdit" ng-include="\'app/main/apps/risk/views/edit/details-view.html\'"></div></div>');
$templateCache.put('app/main/apps/riskmap/views/main/split-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.editMode" \nng-include="\'app/main/apps/riskmap/views/main/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row">\n<div class="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-include="\'app/main/apps/riskmap/views/main/view.html\'"></div></div>');
$templateCache.put('app/main/apps/riskmap/views/main/toolbar.html','<div layout="row" layout-align="start center"><md-menu-bar id="user-menu" class="pl-0 pr-0"><md-menu \nmd-position-mode="left bottom"><md-button class="user-button" ng-click="$mdMenu.open()" aria-label="User settings" \ntranslate translate-attr-aria-label="TOOLBAR.USER_SETTINGS"><div layout="row" layout-align="space-between center"><span\n ng-if="vm.branchSelected" class="username">{{vm.branchSelected.name}}</span> <span ng-if="!vm.branchSelected" \nclass="username" translate="RISKMAP.ALL_COMPANY"></span><md-icon md-font-icon="icon-chevron-down" class="icon s16">\n</md-icon></div></md-button><md-menu-content width="3" class="clients"><md-menu-item class="md-indent"><div \nclass="search-input-wrapper" layout="row" layout-align="start center"><label for="search"><md-icon \nmd-font-icon="icon-magnify"></md-icon></label><md-input-container md-no-float class="m-0"><input id="search" \nplaceholder="{{\'CONTACTS.SEARCH_FOR_ANYONE\' |\xA0translate}}" type="text" ng-model="vm.searchBranchText">\n</md-input-container></div></md-menu-item><div class="results"><md-menu-item ng-click="vm.selectBranch()" \nclass="md-indent bar-client"><div><md-icon md-font-icon="icon-account" class="icon s16" hide-xs></md-icon><button \nclass="btn-clients" translate="RISKMAP.ALL_COMPANY"></button></div></md-menu-item><md-menu-item \nng-click="vm.selectBranch(branch)" class="md-indent bar-client" \nng-repeat="branch in vm.companyBranches | filter:vm.searchBranchText"><div><md-icon md-font-icon="icon-account" \nclass="icon s16" hide-xs></md-icon><button class="btn-clients">{{branch.name}}</button></div></md-menu-item></div>\n</md-menu-content></md-menu></md-menu-bar><div hide show-gt-xs class="divider-vertical"></div><md-menu-bar \nid="user-menu" class="pl-0 pr-0" ng-if="!vm.is_inherent"><md-menu md-position-mode="left bottom"><md-button \nclass="user-button" ng-click="$mdMenu.open()" aria-label="User settings" translate><div layout="row" \nlayout-align="space-between center"><span class="username" hide show-gt-xs>{{vm.formatDate(vm.selectedDate)}}</span>\n<md-icon md-font-icon="icon-calendar" hide-gt-xs></md-icon><md-icon md-font-icon="icon-chevron-down" class="icon s16">\n</md-icon></div></md-button><md-menu-content width="3" class="clients"><div class="results"><md-menu-item \nclass="md-indent bar-client" ng-click="vm.setRiskMapDate(item.date)" ng-repeat="item in vm.datesAvailables"><div>\n<button class="btn-clients">{{vm.formatDate(item.date)}}</button></div></md-menu-item></div></md-menu-content>\n</md-menu></md-menu-bar><div hide show-gt-xs ng-if="!vm.is_inherent" class="divider-vertical"></div><md-button hide \nshow-gt-xs ng-if="!vm.is_inherent" ng-disabled="loadingMapProcess" aria-label="NEW" \nclass="md-accent green-500-bg md-raised md-button" ng-click="vm.calculateMapByCompany()" type="button"><span \nng-if="!loadingMapProcess">{{\'RISKMAP.CALCULATE_NOW\' | translate}}</span></md-button><md-button hide-gt-xs \nng-if="!vm.is_inherent" ng-disabled="loadingMapProcess" aria-label="NEW" \nclass="md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme z-index-0" \nng-click="vm.calculateMapByCompany()" type="button"><md-icon md-font-icon="icon-refresh"></md-icon></md-button><div \naria-hidden="false" class="action-buttons hide show-gt-xs layout-align-start-center layout-row" layout="row" \nlayout-align="start center" ng-show="vm.selectedThreads.length > 0"><md-button ng-click="vm.deleteClient()" \naria-label="Delete" class="md-icon-button" hide="" show-gt-xs="" translate=""><md-icon md-font-icon="icon-delete">\n</md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.REMOVE"></span></md-tooltip></md-button><div \nclass="divider-vertical" hide="" show-gt-xs=""></div></div></div><div layout="row" layout-align="start center" \ntranslate-attr-aria-label="GLOBAL.REFRESH" ng-if="vm.risks.length > 0"><span class="page-info" \nng-bind-html="pagination_totalItems"></span>&nbsp;<span class="page-info" translate="GLOBAL.ITEMS_FOUND"></span>\n<md-button aria-label="Previous" class="md-icon-button arrow" hide="" ng-click="pagination_prevPage()" \nng-disabled="pagination_firstPage()" show-gt-xs="" translate="" translate-attr-aria-label="GLOBAL.PREVIOUS"><md-icon \nmd-font-icon="icon-chevron-left"></md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.PREVIOUS">Previous\n</span></md-tooltip></md-button><span class="page-info" hide="" show-gt-xs="">\n{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label="Next" class="md-icon-button arrow" \nhide="" ng-click="pagination_nextPage()" ng-disabled="pagination_morePages()" show-gt-xs="" \ntranslate-attr-aria-label="GLOBAL.NEXT"><md-icon md-font-icon="icon-chevron-right"></md-icon><md-tooltip hide \nshow-gt-xs><span translate="GLOBAL.NEXT">Next</span></md-tooltip></md-button><div class="divider-vertical" hide hide \nshow-gt-sm></div><md-button class="md-icon-button" ng-click="vm.changeView(\'nosplit\')" \nng-if="vm.currentView !== \'nosplit\'" hide show-gt-sm><md-icon md-font-icon="icon-view-list" \nng-if="vm.currentView !== \'nosplit\'"></md-icon><md-icon class="md-accent" md-font-icon="icon-checkbox-marked" \nng-if="vm.currentView === \'nosplit\'"></md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.NOSPLIT_VIEW">\nNo split</span></md-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.changeView(\'split\')" \nng-if="vm.currentView !== \'split\'" hide show-gt-sm><md-icon md-font-icon="icon-view-quilt" \nng-if="vm.currentView !== \'split\'"></md-icon><md-icon class="md-accent" md-font-icon="icon-checkbox-marked" \nng-if="vm.currentView === \'split\'"></md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.SPLIT_VIEW">split\n</span></md-tooltip></md-button><md-menu class="settings-menu" hide-gt-xs ng-show="vm.selectedThreads.length > 0">\n<md-button aria-label="Settings" class="md-icon-button" ng-click="$mdMenu.open($event)" translate="GLOBAL.SETTINGS" \ntranslate-attr-aria-label="GLOBAL.SETTINGS"><md-icon md-font-icon="icon-dots-horizontal"></md-icon></md-button>\n<md-menu-content><md-menu-item ng-click="vm.deleteClient()" show="vm.selectedMail.length > 0 || vm.allChecked">\n<md-button ng-click="vm.massActions(\'delete\')" aria-label="Delete" translate-aria-label="GLOBAL.DELETE"><md-icon \nmd-font-icon="icon-delete"></md-icon><span translate="GLOBAL.DELETE">Delete</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div>');
$templateCache.put('app/main/apps/riskmap/views/main/view.html','<div class="fullheight" ng-if="!vm.loadingData && !loadingMapProcess"><content class="" layout="row" \nng-include="\'app/main/apps/riskmap/views/main/company.html\'"></content></div>');
$templateCache.put('app/main/apps/riskconfig/dialogs/create-control-dialog/create-control-dialog.controller.html','<md-dialog class="creation-control-dialog" aria-label="New Task"><form name="taskForm" class="md-inline-form" \nnovalidate><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between"><h1 class="title" translate="RISKCONFIG.ADD_CONTROL"></h1><md-button \nclass="md-icon-button" ng-click="vm.closeDialog()"><md-icon md-font-icon="icon-close" aria-label="Close dialog">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div flex layout="row" \nlayout-align="start center" class="p-15"><md-input-container flex="100"><label translate="GLOBAL.NAME"></label> <input \ntype="text" ng-model="vm.name" ng-model="vm.name" required></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout="row" layout-="end"><md-input-container flex layout="row" layout-align="end center">\n<md-button type="button" class="md-raised md-warn" ng-click="vm.closeDialog()" translate="RISKCONFIG.CANCEL">Cancel\n</md-button><md-button type="submit" ng-disabled="!vm.name" class="send-button md-accent md-raised" \nng-click="vm.saveDialog()" translate="RISKCONFIG.ADD">ADD</md-button></md-input-container></md-dialog-actions></form>\n</md-dialog>');
$templateCache.put('app/main/apps/riskconfig/dialogs/create-process-dialog/create-process-dialog.controller.html','<md-dialog class="creation-process-dialog" aria-label="New Task"><form name="taskForm" class="md-inline-form" \nnovalidate><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between"><h1 class="title" translate="RISKCONFIG.ADD_PROCESS"></h1><md-button \nclass="md-icon-button" ng-click="vm.closeDialog()"><md-icon md-font-icon="icon-close" aria-label="Close dialog">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div flex layout="row" \nlayout-align="start center" class="p-15"><md-input-container flex="100"><label translate="GLOBAL.NAME"></label> <input \ntype="text" ng-model="vm.name" required></md-input-container></div></md-dialog-content><md-dialog-actions layout="row" \nlayout-="end"><md-input-container flex layout="row" layout-align="end center"><md-button type="button" \nclass="md-raised md-warn" ng-click="vm.closeDialog()" translate="RISKCONFIG.CANCEL">Cancel</md-button><md-button \ntype="submit" ng-disabled="!vm.name" class="send-button md-accent md-raised" ng-click="vm.saveDialog()" \ntranslate="RISKCONFIG.ADD">ADD</md-button></md-input-container></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/riskconfig/dialogs/create-risk-dialog/create-risk-dialog.controller.html','<md-dialog class="creation-risk-dialog" aria-label="New Task"><form name="taskForm" class="md-inline-form" novalidate>\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between"><h1 \nclass="title" translate="RISKCONFIG.ADD_RISK"></h1><md-button class="md-icon-button" ng-click="vm.closeDialog()">\n<md-icon md-font-icon="icon-close" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content class="ph-15"><div flex layout="row" layout-align="start center"><md-input-container class="mb-0" \nflex="100"><label translate="GLOBAL.NAME"></label> <input type="text" ng-model="vm.name" required></md-input-container>\n</div><div flex layout="row" layout-align="start center"><md-input-container class="mb-0" flex="50"><label \ntranslate="RISKCONFIG.CODE"></label> <input type="text" ng-model="vm.code"></md-input-container><md-input-container \nclass="mb-0" flex="50"><label translate="RISKCONFIG.EXTERNAL_LINK"></label> <input type="text" \nng-model="vm.external_link"></md-input-container></div><div flex layout="row" layout-align="start center">\n<md-input-container class="mb-0" flex="100"><label class="mb-30" translate="RISKCONFIG.DESCRIPTION"></label> <textarea \nui-tinymce="vm.tinymceOptions" ng-model="vm.description" rows="3" md-select-on-focus></textarea></md-input-container>\n</div><div flex layout="row" layout-align="start center"><md-input-container class="mb-0" flex="100"><label \nclass="mb-30" translate="RISKCONFIG.CONDUCTS"></label> <textarea ui-tinymce="vm.tinymceOptions" ng-model="vm.conducts" \nrows="3" md-select-on-focus></textarea></md-input-container></div><div flex layout="row" layout-align="start center">\n<md-input-container class="mb-0" flex="100"><label class="mb-30" translate="RISKCONFIG.FACTUAL_CAUSES"></label> \n<textarea ui-tinymce="vm.tinymceOptions" ng-model="vm.factual_causes" rows="3" md-select-on-focus></textarea>\n</md-input-container></div><div flex layout="row" layout-align="start center"><md-input-container \nng-if="vm.branding.tenant != \'gnl\'" flex><md-select placeholder="{{\'RISKCONFIG.REPUTATION_IMPACT\' | translate}}" \nng-model="vm.reputation_impact"><md-option class="small" ng-value=""><em translate="RISKCONFIG.REPUTATION_IMPACT"></em>\n</md-option><md-option class="small" ng-value="1" translate="RISK.RISK_LEVELS_1"></md-option><md-option class="small" \nng-value="2" translate="RISK.RISK_LEVELS_2"></md-option><md-option class="small" ng-value="3" \ntranslate="RISK.RISK_LEVELS_3"></md-option><md-option class="small" ng-value="4" translate="RISK.RISK_LEVELS_4">\n</md-option><md-option class="small" ng-value="5" translate="RISK.RISK_LEVELS_5"></md-option></md-select>\n</md-input-container><md-input-container flex><md-select placeholder="{{\'RISKCONFIG.PENAL_CODE_IMPACT\' | translate}}" \nng-model="vm.penal_code_impact"><md-option class="small" ng-value=""><em translate="RISKCONFIG.PENAL_CODE_IMPACT"></em>\n</md-option><md-option class="small" ng-value="1" translate="RISK.RISK_LEVELS_1"></md-option><md-option class="small" \nng-value="2" translate="RISK.RISK_LEVELS_2"></md-option><md-option class="small" ng-value="3" \ntranslate="RISK.RISK_LEVELS_3"></md-option><md-option class="small" ng-value="4" translate="RISK.RISK_LEVELS_4">\n</md-option><md-option class="small" ng-value="5" translate="RISK.RISK_LEVELS_5"></md-option></md-select>\n</md-input-container><md-input-container flex><md-select placeholder="{{\'RISKCONFIG.CLIENT_LOSS\' | translate}}" \nng-model="vm.client_loss"><md-option class="small" ng-value=""><em translate="RISKCONFIG.CLIENT_LOSS"></em></md-option>\n<md-option class="small" ng-value="1" translate="RISK.RISK_LEVELS_1"></md-option><md-option class="small" ng-value="2" \ntranslate="RISK.RISK_LEVELS_2"></md-option><md-option class="small" ng-value="3" translate="RISK.RISK_LEVELS_3">\n</md-option><md-option class="small" ng-value="4" translate="RISK.RISK_LEVELS_4"></md-option><md-option class="small" \nng-value="5" translate="RISK.RISK_LEVELS_5"></md-option></md-select></md-input-container></div><div flex layout="row" \nlayout-align="start center"></div></md-dialog-content><md-dialog-actions layout="row" layout-="end"><md-input-container\n flex layout="row" layout-align="end center"><md-button type="button" class="md-raised md-warn" \nng-click="vm.closeDialog()" translate="RISKCONFIG.CANCEL">Cancel</md-button><md-button type="submit" \nng-disabled="!vm.name || !vm.country_id || !vm.language_id" class="send-button md-accent md-raised" \nng-click="vm.saveDialog()" translate="RISKCONFIG.ADD">ADD</md-button></md-input-container></md-dialog-actions></form>\n</md-dialog>');
$templateCache.put('app/main/apps/riskconfig/dialogs/delegations-dialog/delegations-dialog.html','<md-dialog class="delegations-dialog" aria-label="New Task"><form name="taskForm" class="md-inline-form" novalidate>\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between"><h1 \nclass="title" translate="RISKCONFIG.ACTIVATE_RISKS"></h1><md-button class="md-icon-button" ng-click="vm.closeDialog()">\n<md-icon md-font-icon="icon-close" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div flex layout="column" layout-align="center center" ng-if="vm.loading" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="50"></md-progress-circular></div>\n<md-input-container ng-if="!vm.loading" flex class="fullwidth company-selector"><label \ntranslate="RISKCONFIG.SELECT_CLIENT"></label><md-select ng-change="vm.loadCompany()" ng-model="vm.companySelected" \nclass="no-border-bottom"><md-option ng-repeat="company in vm.user.companies track by $index" ng-value="company.id">\n{{company.name}}</md-option></md-select></md-input-container><div ng-if="vm.branches && !vm.loading" class="mb-75" \nid="list-content-data" ng-style="{\'opacity\' : isLoading ? 0.5 : 1}"><div class="title-bar" layout="row" \nlayout-align="start center" translate="RISKCONFIG.SELECT_BRANCH_TO_ACTIVE_RISK"></div><div class="mail-list-item" \nng-repeat="branch in vm.branches" ng-init="parentIndex = $index" md-no-ink><div layout="row" \nlayout-align="start center"><md-checkbox class="no-label" ng-checked="vm.isSelected(branch)" \nng-click="vm.toggleSelectThread(branch, $event)" aria-label="{{vm.isSelected(branch) ? \'Deselect\' : \'Select\'}}">\n</md-checkbox><div class="info layout-column flex" flex="" layout="column"><div class="name text-truncate" \nlayout="row" layout-align="start center"><span>{{branch.name}}</span></div></div></div></div></div></md-dialog-content>\n<md-dialog-actions class="footer" layout="row" layout-="end"><md-input-container flex layout="row" \nlayout-align="end center"><md-button type="button" class="md-raised md-warn" ng-click="vm.closeDialog()" \ntranslate="RISKCONFIG.CANCEL">Cancel</md-button><md-button ng-disabled="vm.selectedBranchs.length == 0" type="submit" \nclass="send-button md-accent md-raised" ng-click="vm.saveDialog()" translate="RISKCONFIG.ADD">ADD</md-button>\n</md-input-container></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/riskconfig/dialogs/edit-name/edit-name-dialog.html','<md-dialog class="creation-control-dialog" aria-label="New Task"><form name="taskForm" class="md-inline-form" \nnovalidate><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between"><h1 ng-if="vm.type==\'process\'" class="title" translate="RISKCONFIG.EDIT_PROCESS"></h1><h1 \nng-if="vm.type==\'control\'" class="title" translate="RISKCONFIG.EDIT_CONTROL"></h1><md-button class="md-icon-button" \nng-click="vm.closeDialog()"><md-icon md-font-icon="icon-close" aria-label="Close dialog"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div flex layout="row" layout-align="start center" class="p-15">\n<md-input-container flex="100"><label translate="GLOBAL.NAME"></label> <input type="text" ng-model="vm.item.name" \nrequired></md-input-container></div></md-dialog-content><md-dialog-actions layout="row" layout-="end">\n<md-input-container flex layout="row" layout-align="end center"><md-button type="button" class="md-raised md-warn" \nng-click="vm.closeDialog()" translate="RISKCONFIG.CANCEL">Cancel</md-button><md-button type="submit" \nng-disabled="!vm.item.name" class="send-button md-accent md-raised" ng-click="vm.saveDialog()" \ntranslate="RISKCONFIG.SAVE">ADD</md-button></md-input-container></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/riskconfig/dialogs/forms/dialog-view.html','<md-dialog id="dialog-view" class="form-dialog add-media" aria-label="New Message"><md-toolbar class="md-accent"><div \nclass="md-toolbar-tools" layout="row" layout-align="space-between center"><div class="absolute-right" layout="row  ">\n<md-button class="md-icon-buttons" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</md-toolbar><form class="md-inline-form"><md-dialog-content ng-if="vm.title !== \'branch\'" id="site-content" flex \nclass="content-card over-hidden" ng-class="vm.currentView" \nng-include="\'app/main/apps/clients/dialogs/forms/forms-view-user.html\'"></md-dialog-content><md-dialog-content \nng-if="vm.title === \'branch\'" id="site-content" ms-scroll flex class="content-card" ng-class="vm.currentView" \nng-include="\'app/main/apps/clients/dialogs/forms/forms-view-delegation.html\'"></md-dialog-content></form></md-dialog>');
$templateCache.put('app/main/apps/riskconfig/dialogs/forms/forms-view-delegation.html','<div id="forms" class="page-layout simple fullwidth doc-page forms" layout="column"><div class="p0" layout="column">\n<div layout="row"><ms-form-wizard class="popup" flex><md-tabs class="height-tabs" md-dynamic-height \nmd-selected="msWizard.selectedIndex" md-center-tabs="true"><md-tab><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" ng-if="wizardStep1.$invalid">1\n</span> <span class="ms-form-wizard-step-number md-accent-bg" ng-if="wizardStep1.$valid"><i class="icon-check s16"></i>\n </span><span translate="{{ vm.translate }}" class="ms-form-wizard-step-text"></span></span></md-tab-label>\n<md-tab-body><form name="wizardStep1" class="md-inline-form" ms-form-wizard-form novalidate><div class="items">\n<md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="field.field !== \'id\' && field.field !== \'fullName\'"><input \nng-if="field.field !== \'phone\' && field.field !== \'email\' && field.field !== \'position\'" type="{{field.type}}" \nname="{{field.field}}" ng-model="field.value" placeholder="{{ field.translate | translate }}" required> <input \nng-if="field.field === \'phone\' || field.field === \'email\'" type="{{field.type}}" name="{{field.field}}" \nng-model="field.value" placeholder="{{ field.translate | translate }}"><md-select \nng-disabled="vm.disabledPosition(field)" ng-if="field.field === \'position\'" ng-model="field.value" \nplaceholder="{{ field.translate | translate }}" required><md-option \nng-repeat="option in field.options track by $index" ng-value="option.id">{{option.field}}</md-option></md-select><div \nng-messages="wizardStep1.email.$error" role="alert" multiple="multiple"><div ng-message="pattern"><span \ntranslate="GLOBAL.EMAIL_VALID"></span></div></div></md-input-container></div></form></md-tab-body></md-tab></md-tabs>\n<div class="navigation" flex layout="row" layout-align="center center"><md-button translate="GLOBAL.SEND" \nclass="md-raised md-warn" ng-click="vm.sendForm()" ng-disabled="wizardStep1.$valid"></md-button></div></ms-form-wizard>\n</div></div></div>');
$templateCache.put('app/main/apps/riskconfig/dialogs/forms/forms-view-user.html','<div ng-cloak><md-content><md-tabs md-dynamic-height md-border-bottom><md-tab label="Nuevo usuario"><md-content \nclass="md-padding p0"><div id="forms" class="page-layout simple fullwidth doc-page forms" layout="column"><div \nclass="p0" layout="column"><div layout="row"><ms-form-wizard class="popup" flex><md-tabs class="height-tabs" \nmd-dynamic-height md-selected="msWizard.selectedIndex" md-center-tabs="true"><md-tab><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" ng-if="wizardStep1.$invalid">1\n</span> <span class="ms-form-wizard-step-number md-accent-bg" ng-if="wizardStep1.$valid"><i class="icon-check s16"></i>\n </span><span translate="{{ vm.translate }}" class="ms-form-wizard-step-text"></span></span></md-tab-label>\n<md-tab-body><form name="wizardStep1" class="md-inline-form" ms-form-wizard-form novalidate><div class="items">\n<md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="field.field !== \'id\' && field.field !== \'fullName\'"><input \nng-if="field.field !== \'phone\' && field.field !== \'email\' && field.field !== \'position\'" type="{{field.type}}" \nname="{{field.field}}" ng-model="field.value" placeholder="{{ field.translate | translate }}" required> <input \nng-if="field.field === \'phone\' || field.field === \'email\'" type="{{field.type}}" name="{{field.field}}" \nng-model="field.value" placeholder="{{ field.translate | translate }}"><md-select \nng-disabled="vm.disabledPosition(field)" ng-if="field.field === \'position\'" ng-model="field.value" \nplaceholder="{{ field.translate | translate }}" required><md-option \nng-repeat="option in field.options track by $index" ng-value="option.id">{{option.field}}</md-option></md-select><div \nng-messages="wizardStep1.email.$error" role="alert" multiple="multiple"><div ng-message="pattern"><span \ntranslate="GLOBAL.EMAIL_VALID"></span></div></div></md-input-container></div></form></md-tab-body></md-tab></md-tabs>\n<div class="navigation" flex layout="row" layout-align="center center"><md-button translate="GLOBAL.SEND" \nclass="md-raised md-warn" ng-click="vm.sendForm()" ng-disabled="wizardStep1.$valid"></md-button></div></ms-form-wizard>\n</div></div></div></md-content></md-tab><md-tab label="Usuario existente"><md-content \nstyle="height: 210px; overflow: hidden;" class="md-padding mw-500 p0"><div class="search-input-wrapper" layout="row" \nlayout-align="start center"><label for="search"><md-icon class="icon-search" md-font-icon="icon-magnify"></md-icon>\n</label><md-input-container md-no-float class="m-0" flex="100"><input id="search" \nplaceholder="{{\'CONTACTS.SEARCH_FOR_ANYONE\' |\xA0translate}}" type="text" ng-model="searchText"></md-input-container>\n</div><div id="site-client" class="list-users-scroll"><div class="content thread-list mail-list-pane scrollable p0" \nflex="" ms-scroll="vm.msScrollOptions" id="thread-list"><div id="list-content-data" \nng-style="{\'opacity\' : isLoading ? 0.5 : 1}"><div class="mail-list-item" \nng-repeat="user in vm.users | filter:searchText" ng-init="parentIndex = $index" md-no-ink \nng-click="vm.selectUser(user)" \nng-class="{\'starred\': user.starred, \'selected\': vm.selectedContentID !== user.id_mailing_content, \'checked\': vm.isChecked(user)}">\n<div layout="row" layout-align="start center"><div class="info layout-column flex" flex="" layout="column"><div \nclass="name text-truncate" layout="row" layout-align="start center"><span>\n{{user.first_name}} {{user.last_name}} {{user.job_position.name}}</span></div></div></div></div></div></div></div>\n<md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" translate="" \ntranslate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" ng-if="$root.pagination_searchquery==true"><md-icon \nmd-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip hide show-gt-xs><span>Reset search</span></md-tooltip>\n</md-button></md-content></md-tab></md-tabs></md-content></div>');
$templateCache.put('app/main/apps/riskconfig/dialogs/edit-risk-dialog/edit-risk-dialog.controller.html','<md-dialog class="edit-risk-dialog" aria-label="New Task"><form name="taskForm" class="md-inline-form" novalidate>\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between"><h1 \nclass="title">{{vm.risk.name}}</h1><md-button class="md-icon-button" ng-click="vm.closeDialog()"><md-icon \nmd-font-icon="icon-close" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><md-tabs md-dynamic-height><md-tab label="{{\'RISKCONFIG.DESCRIPTION\' | translate}}"><md-input-container \nclass="md-block"><label translate="GLOBAL.NAME"></label> <input ng-model="vm.risk.name" type="text">\n</md-input-container><div layout="column" layout-gt-xs="row" layout-align="center space-between" \nlayout-align-gt-xs="center center" class="text-center"><md-input-container ng-if="vm.branding.tenant != \'gnl\'" flex \nclass="mt-0 mb-15 pv-24 ph-5 circle-graph white-bg" layout="column" layout-align="center start" \nlayout-align-gt-xs="center center" flex><div class="field grey-500-fg" translate="RISK.REPUTATION_IMPACT"></div>\n<md-select fill-width ng-model="vm.risk.reputation_impact" placeholder="-"><md-option class="small" ng-value="1" \nng-disabled="$index === 1" translate="RISK.RISK_LEVELS_1"></md-option><md-option class="small" ng-value="2" \nng-disabled="$index === 2" translate="RISK.RISK_LEVELS_2"></md-option><md-option class="small" ng-value="3" \nng-disabled="$index === 3" translate="RISK.RISK_LEVELS_3"></md-option><md-option class="small" ng-value="4" \nng-disabled="$index === 4" translate="RISK.RISK_LEVELS_4"></md-option><md-option class="small" ng-value="5" \nng-disabled="$index === 5" translate="RISK.RISK_LEVELS_5"></md-option></md-select></md-input-container>\n<md-input-container flex class="mt-0 mb-15 pv-24 ph-5 circle-graph white-bg" layout="column" \nlayout-align="center start" layout-align-gt-xs="center center" flex><div class="field grey-500-fg" \ntranslate="RISK.PENAL_CODE_IMPACT"></div><md-select fill-width ng-model="vm.risk.penal_code_impact" placeholder="-">\n<md-option class="small" ng-value="1" ng-disabled="$index === 1" translate="RISK.RISK_LEVELS_1"></md-option><md-option \nclass="small" ng-value="2" ng-disabled="$index === 2" translate="RISK.RISK_LEVELS_2"></md-option><md-option \nclass="small" ng-value="3" ng-disabled="$index === 3" translate="RISK.RISK_LEVELS_3"></md-option><md-option \nclass="small" ng-value="4" ng-disabled="$index === 4" translate="RISK.RISK_LEVELS_4"></md-option><md-option \nclass="small" ng-value="5" ng-disabled="$index === 5" translate="RISK.RISK_LEVELS_5"></md-option></md-select>\n</md-input-container><md-input-container flex class="mt-0 mb-15 pv-24 ph-5 circle-graph white-bg" layout="column" \nlayout-align="center start" layout-align-gt-xs="center center" flex><div class="field grey-500-fg" \ntranslate="RISK.CLIENT_LOSS"></div><md-select fill-width ng-model="vm.risk.client_loss" placeholder="-"><md-option \nclass="small" ng-value="1" ng-disabled="$index === 1" translate="RISK.RISK_LEVELS_1"></md-option><md-option \nclass="small" ng-value="2" ng-disabled="$index === 2" translate="RISK.RISK_LEVELS_2"></md-option><md-option \nclass="small" ng-value="3" ng-disabled="$index === 3" translate="RISK.RISK_LEVELS_3"></md-option><md-option \nclass="small" ng-value="4" ng-disabled="$index === 4" translate="RISK.RISK_LEVELS_4"></md-option><md-option \nclass="small" ng-value="5" ng-disabled="$index === 5" translate="RISK.RISK_LEVELS_5"></md-option></md-select>\n</md-input-container></div><div layout="row" layout-align="start center"><md-input-container flex class="md-block">\n<label translate=" RISKCONFIG.CODE"></label> <input type="text" ng-model="vm.risk.code"></md-input-container>\n<md-input-container flex class="md-block"><label translate="RISKCONFIG.EXTERNAL_LINK"></label> <input \nng-model="vm.risk.external_link" type="text"></md-input-container></div><md-input-container flex \nclass="md-block textarea-container"><label translate="RISKCONFIG.CONDUCTS"></label> <textarea \nui-tinymce="vm.tinymceOptions" ng-model=" vm.risk.description"></textarea></md-input-container></md-tab><md-tab \nlabel="{{\'RISKCONFIG.CONDUCTS\' | translate}}"><md-input-container flex class="md-block textarea-container"><label \ntranslate="RISKCONFIG.CONDUCTS"></label> <textarea ui-tinymce="vm.tinymceOptions" ng-model=" vm.risk.conducts">\n</textarea></md-input-container></md-tab><md-tab label="{{\'RISKCONFIG.FACTUAL_CAUSES\' | translate}}">\n<md-input-container flex class="md-block textarea-container"><label translate="RISKCONFIG.FACTUAL_CAUSES"></label> \n<textarea ui-tinymce="vm.tinymceOptions" ng-model=" vm.risk.factual_causes"></textarea></md-input-container></md-tab>\n<md-tab label="{{\'RISKCONFIG.PENALTIES\' | translate}}"><md-input-container flex class="md-block textarea-container">\n<label translate="RISKCONFIG.PENALTIES"></label> <textarea ui-tinymce="vm.tinymceOptions" \nng-model=" vm.risk.penalties"></textarea></md-input-container></md-tab></md-tabs></md-dialog-content><md-dialog-actions\n class="footer" layout="row" layout-="end"><md-input-container flex layout="row" layout-align="end center"><md-button \ntype="button" class="md-raised md-warn" ng-click="vm.closeDialog()" translate="RISKCONFIG.CANCEL">Cancel</md-button>\n<md-button ng-disabled="vm.selectedBranchs.length == 0" type="submit" class="send-button md-accent md-raised" \nng-click="vm.saveDialog()" translate="GLOBAL.SAVE">ADD</md-button></md-input-container></md-dialog-actions></form>\n</md-dialog>');
$templateCache.put('app/main/apps/riskconfig/dialogs/image/image-dialog.html','<md-dialog class="attachment-dialog" aria-label="New Task"><md-toolbar class="md-accent md-hue-2 md-default-theme"><div\n class="md-toolbar-tools"><div layout="row" hide show-gt-xs><a class="md-button" type="1" layout="row" \nlayout-align="center center" ng-click="vm.changeView(\'fotorama\')"><md-icon md-font-icon="icon-file-image-box" \nclass="s18 mr-5 ml-0"></md-icon><span translate="GLOBAL.PREVIEW">Preview Media</span></a></div><span flex></span><div \nlayout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content class="mediadialog-content" layout-fill><md-content flex class="content-card" \nng-class="vm.currentView" ng-include="vm.views[vm.currentView]" md-no-ink></md-content></md-dialog-content></md-dialog>');
$templateCache.put('app/main/apps/riskconfig/dialogs/media/media-clients-tinymce.html','<md-dialog class="attachment-dialog add-media" aria-label="New Message"><form class="md-inline-form"><md-toolbar \nclass="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><div layout="row" \nhide show-gt-xs><a class="md-button" type="1" layout="row" layout-align="center center" \nng-click="vm.changeViewTiny(\'1\')"><md-icon md-font-icon="icon-file-image-box" class="s18 mr-5 ml-0"></md-icon><span>\nAttached Media</span></a></div><div layout="row" hide-gt-xs show-xs><md-menu><md-button aria-label="Filters" \nng-click="$mdMenu.open($event)" translate="" translate-attr-aria-label="GLOBAL.FILTERS"><span layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-file-image-box" class="s18 mr-5 ml-0"></md-icon><span \nclass="ml-5">Images</span> <i class="icon-chevron-down s20 ml-5"></i></span></md-button><md-menu-content width="3">\n<md-menu-item><md-button type="photos" ng-click="vm.changeViewTiny(\'1\')"><div layout="row" \nlayout-align="space-between center"><div><md-icon md-font-icon="icon-file-image-box" class="s18"></md-icon><span>Images\n</span></div><i class="icon-check s16" ng-if="sortfield.titleId == sortable.titleId"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu></div><div layout="row"><md-button class="md-icon-button" \nng-click="vm.closeDialog()" aria-label="Close dialog" tranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon \nmd-font-icon="icon-close"></md-icon></md-button></div></div></md-toolbar><div flex \nng-include="\'app/main/apps/clients/dialogs/media/views/templates/toolbar-search.html\'"></div><md-dialog-content \nclass="mediadialog-content scrollable" layout-fill ms-scroll><treasure-overlay-spinner active="vm.loading"><div \nlayout="column" flex><md-content flex class="content-card" ng-class="vm.currentViewTiny" \nng-include="vm.viewsTiny[vm.currentViewTiny]" md-no-ink></md-content></div></treasure-overlay-spinner>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="space-between center" ng-if="!vm.loading"><div \nlayout="row" layout-align="start center"></div><div layout="row" layout-align="end right"><md-button \nng-click="vm.attachMediaTiny()" class="send-button md-accent md-raised" aria-label="Send" translate="GLOBAL.ADD_FILE" \ntranslate-attr-aria-label="GLOBAL.ADD_FILE">ADD</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/riskconfig/dialogs/media/media-clients.html','<md-dialog class="attachment-dialog add-media" aria-label="New Message"><form class="md-inline-form"><md-toolbar \nclass="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><div layout="row" \nhide show-gt-xs><a class="md-button" type="upload" layout="row" layout-align="center center" \nng-click="vm.changeView(\'upload\')"><md-icon md-font-icon="icon-import" class="s18 mr-5 ml-0"></md-icon><span>Upload\n</span></a></div><div layout="row" hide-gt-xs show-xs><md-menu><md-button aria-label="Filters" \nng-click="$mdMenu.open($event)" translate="" translate-attr-aria-label="GLOBAL.FILTERS"><span layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-file-image-box" class="s18 mr-5 ml-0"></md-icon><span \nclass="ml-5" ng-if="vm.currentView===\'upload\'">Upload</span><i class="icon-chevron-down s20 ml-5"></i></span>\n</md-button><md-menu-content width="3"><md-menu-item><md-button type="import" ng-click="vm.changeView(\'import\')"><div \nlayout="row" layout-align="space-between center"><div><md-icon md-font-icon="icon-import" class="s18"></md-icon><span>\nUpload</span></div><i class="icon-check s16" ng-if="vm.currentView===\'upload\'"></i></div></md-button></md-menu-item>\n</md-menu-content></md-menu></div><div layout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog" tranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></div></md-toolbar><md-dialog-content ms-scroll flex class="content-card" \nng-class="vm.currentView" ng-include="vm.views[vm.currentView]"></md-dialog-content></form></md-dialog>');
$templateCache.put('app/main/apps/riskconfig/views/read/preview-structure.html','<div class="content thread-detail" layout="row" layout-align="center center" flex ng-if="!vm.currentRisk"><div \nclass="no-thread-selected" layout="column" layout-align="center center" flex><md-icon md-font-icon="icon-timelapse" \nclass="s120 grey-400-fg"></md-icon><span class="hint-text" translate="RISKCONFIG.SELECT_RISK_DETAILS"></span></div>\n</div><div ng-if="vm.currentRisk"><div class="risk-main-toolbar"><div layout="row" layout-align="start center"><div \nlayout="row" layout-align="start center"><a class="pointer" ng-click="vm.closeRisk()"><md-icon \nmd-font-icon="icon-chevron-left"></md-icon></a></div><div flex layout="row" layout-align="end center"><md-menu \nmd-position-mode="target-right target"><md-button class="md-icon-button" ng-click="$mdMenu.open()" aria-label="more">\n<md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content width="3"><md-menu-item><md-button \nng-click="vm.editRisk($event, vm.currentRisk)" translate="GLOBAL.EDIT"><md-icon md-font-icon="icon-pencil" role="img" \naria-label="icon-pencil"></md-icon></md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.deleteRiskById(vm.currentRisk.id, $event)" translate="GLOBAL.DELETE"><md-icon md-font-icon="icon-trash" \nrole="img" aria-label="icon-trash"></md-icon></md-button></md-menu-item></md-menu-content></md-menu></div></div></div>\n<div class="risk-main-view" flex="100"><div layout="row" layout-align="space-between start"><h1 \nng-bind-html="vm.currentRisk.name" class="mt-0 mr-24"></h1></div><div layout="column"><div class=""><div \nclass="white-bg border"><div layout="column" layout-gt-xs="row" layout-align="center start" \nlayout-align-gt-xs="center center" class="pt-32 pb-32 pl-10 pr-10"><a ng-if="vm.currentRisk.external_link" \nclass="md-button" ng-href="{{vm.currentRisk.external_link}}" target="_blank" layout="row" layout-align="start center">\n<span translate="RISKCONFIG.CODIGO_PENAL"></span> <i class="icon-link-variant s16 ml-5"></i></a><md-button \nng-if="vm.currentRisk.description" md-no-ink class="md-primary" \nng-click="vm.openDialogText($event, vm.currentRisk.description, \'RISKCONFIG.DESCRIPTION\')" \ntranslate="RISKCONFIG.DESCRIPTION"></md-button><md-button ng-if="vm.currentRisk.conducts" md-no-ink class="md-primary" \nng-click="vm.openDialogText($event, vm.currentRisk.conducts, \'RISKCONFIG.CONDUCTS\')" translate="RISKCONFIG.CONDUCTS">\n</md-button><md-button ng-if="vm.currentRisk.factual_causes" md-no-ink class="md-primary" \nng-click="vm.openDialogText($event, vm.currentRisk.factual_causes, \'RISKCONFIG.FACTUAL_CAUSES\')" \ntranslate="RISKCONFIG.FACTUAL_CAUSES"></md-button><md-button ng-if="vm.currentRisk.penalties" md-no-ink \nclass="md-primary" ng-click="vm.openDialogText($event, vm.currentRisk.penalties, \'RISKCONFIG.PENALTIES\')" \ntranslate="RISKCONFIG.PENALTIES"></md-button></div><div layout="column" layout-gt-xs="row" \nlayout-align="center space-between" layout-align-gt-xs="center center" \nclass="text-center pb-32 grey-50-bg pt-32 border-top"><md-input-container ng-if="vm.branding.tenant != \'gnl\'" \nclass="ml-24 mr-20 mt-0 mb-15 pv-24 ph-15 circle-graph white-bg" layout="column" layout-align="center start" \nlayout-align-gt-xs="center center" flex><div class="field grey-500-fg" translate="RISK.REPUTATION_IMPACT"></div>\n<md-select ng-disabled="true" ng-model="vm.currentRisk.reputation_impact" placeholder="-" \nng-change="vm.updateRiskLevels(vm.currentRisk)"><md-option class="small" ng-value="1" ng-disabled="$index === 1" \ntranslate="RISK.RISK_LEVELS_1"></md-option><md-option class="small" ng-value="2" ng-disabled="$index === 2" \ntranslate="RISK.RISK_LEVELS_2"></md-option><md-option class="small" ng-value="3" ng-disabled="$index === 3" \ntranslate="RISK.RISK_LEVELS_3"></md-option><md-option class="small" ng-value="4" ng-disabled="$index === 4" \ntranslate="RISK.RISK_LEVELS_4"></md-option><md-option class="small" ng-value="5" ng-disabled="$index === 5" \ntranslate="RISK.RISK_LEVELS_5"></md-option></md-select></md-input-container><md-input-container \nclass="ml-24 mr-20 mt-0 mb-15 pv-24 ph-15 circle-graph white-bg" layout="column" layout-align="center start" \nlayout-align-gt-xs="center center" flex><div class="field grey-500-fg" translate="RISK.PENAL_CODE_IMPACT"></div>\n<md-select ng-disabled="true" ng-model="vm.currentRisk.penal_code_impact" placeholder="-" \nng-change="vm.updateRiskLevels(vm.currentRisk)"><md-option class="small" ng-value="1" ng-disabled="$index === 1" \ntranslate="RISK.RISK_LEVELS_1"></md-option><md-option class="small" ng-value="2" ng-disabled="$index === 2" \ntranslate="RISK.RISK_LEVELS_2"></md-option><md-option class="small" ng-value="3" ng-disabled="$index === 3" \ntranslate="RISK.RISK_LEVELS_3"></md-option><md-option class="small" ng-value="4" ng-disabled="$index === 4" \ntranslate="RISK.RISK_LEVELS_4"></md-option><md-option class="small" ng-value="5" ng-disabled="$index === 5" \ntranslate="RISK.RISK_LEVELS_5"></md-option></md-select></md-input-container><md-input-container \nclass="ml-24 mr-20 mt-0 mb-15 pv-24 ph-15 circle-graph white-bg" layout="column" layout-align="center start" \nlayout-align-gt-xs="center center" flex><div class="field grey-500-fg" translate="RISK.CLIENT_LOSS"></div><md-select \nng-disabled="true" ng-model="vm.currentRisk.client_loss" placeholder="-" \nng-change="vm.updateRiskLevels(vm.currentRisk)"><md-option class="small" ng-value="1" ng-disabled="$index === 1" \ntranslate="RISK.RISK_LEVELS_1"></md-option><md-option class="small" ng-value="2" ng-disabled="$index === 2" \ntranslate="RISK.RISK_LEVELS_2"></md-option><md-option class="small" ng-value="3" ng-disabled="$index === 3" \ntranslate="RISK.RISK_LEVELS_3"></md-option><md-option class="small" ng-value="4" ng-disabled="$index === 4" \ntranslate="RISK.RISK_LEVELS_4"></md-option><md-option class="small" ng-value="5" ng-disabled="$index === 5" \ntranslate="RISK.RISK_LEVELS_5"></md-option></md-select></md-input-container></div><md-divider></md-divider><div \nlayout="row" layout-align="start center" class="pl-24 pt-24 pb-24"><div class="info" flex layout="column"><div \nlayout="row"><div layout="row" layout-align="start center" flex="70"><h2 translate="RISKCONFIG.PROCESS_AND_CONTROLS" \nclass="mt-0 mb-0"></h2></div><div layout="row" layout-align="end center" flex="30"><md-button \nng-click="vm.openCreateProcessDialog($event)" class="ml-20 md-mini add-event-button md-fab md-warn"><md-icon \nmd-font-icon="icon-plus"><md-tooltip>{{\'RISKCONFIG.ADD_PROCESS\' | translate }}</md-tooltip></md-icon></md-button></div>\n</div></div></div><md-divider></md-divider><div layout="row" layout-align="start start"><md-list flex="100" \nclass="p-0"><div \nng-repeat="process in vm.currentRisk.processes | filter : vm.showDeletedFilter | orderBy:\'deleted_at\':true" \nclass="process" ng-class="{\'deleted\': process.deleted_at}"><md-list-item class="child-pr0"><div class="info" flex \nlayout="column"><div layout="row" layout-align="space-between center" flex="100"><div layout="row" \nlayout-align="start center" flex="80" class="pt-24 pb-24"><div class="avatar" \nng-style="{\'background\': \'rgba(25,147,232,1)\'}">P</div><div class="field"><strong class="grey-800-fg" \nng-bind-html="process.name"></strong></div></div><div layout="row" layout-align="end center" flex="20"><md-menu \nmd-position-mode="target-right target"><md-button class="md-icon-button" ng-click="$mdMenu.open()" aria-label="more">\n<md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content width="3"><md-menu-item \nng-if="!process.deleted_at.length"><md-button ng-click="vm.openCreateControlDialog($event, process)" \ntranslate="RISKCONFIG.ADD_CONTROL"></md-button></md-menu-item><md-menu-item ng-if="!process.deleted_at.length">\n<md-button ng-click="vm.editNameDialog($vent, \'process\', process)" translate="RISKCONFIG.EDIT_PROCESS"></md-button>\n</md-menu-item><md-menu-item ng-if="!process.deleted_at.length"><md-button ng-click="vm.deleteProcess(process)" \ntranslate="RISKCONFIG.HIDE_PROCESS"></md-button></md-menu-item><md-menu-item ng-if="process.deleted_at"><md-button \nng-click="vm.restoreProcess(process)" translate="RISKCONFIG.RESTORE_PROCESS"></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div></md-list-item><div class="process-controls" \nng-if="process.controls.length > 0" \nng-class="{\'deleted\': control.deleted_at.length > 0, \'border-bottom\': (process.controls.length - 1) == $index}" \nng-repeat="control in process.controls | filter : vm.showDeletedFilter | orderBy:\'deleted_at\':true track by $index">\n<md-list-item layout="row" layout-align="start center" flex="100" \nng-class="(control.id == vm.currentControl.id) ? \'current-control\' : \'\'"><div layout="row" \nlayout-align="space-between center" flex="100"><div layout="row" layout-align="start center" flex><div class="avatar" \nng-style="{\'background\': \'rgba(132,173,78,1)\'}">C</div><div class="field"><strong class="grey-800-fg" \nng-bind-html="control.name"></strong></div></div></div><div layout="row" layout-align="end center"><md-menu \nng-if="!process.deleted_at.length" md-position-mode="target-right target"><md-button class="md-icon-button" \nng-click="$mdMenu.open()" aria-label="more"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button>\n<md-menu-content width="3"><md-menu-item ng-if="!control.deleted_at.length"><md-button \nng-click="vm.deleteControl(control)" translate="RISKCONFIG.HIDE_CONTROL"></md-button></md-menu-item><md-menu-item \nng-if="!control.deleted_at.length"><md-button ng-click="vm.editNameDialog($event, \'control\', control, process)" \ntranslate="RISKCONFIG.EDIT_CONTROL"></md-button></md-menu-item><md-menu-item ng-if="control.deleted_at"><md-button \nng-click="vm.restoreControl(control)" translate="RISKCONFIG.RESTORE_CONTROL"></md-button></md-menu-item>\n</md-menu-content></md-menu></div></md-list-item></div></div></md-list></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/riskconfig/views/list/list-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="isLoading" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="content-wrapper" layout="row" flex ng-if="vm.risks.length == 0"><div class="content thread-detail" \nlayout="row" layout-align="center center" flex><div class="no-client-selected no-thread-selected" layout="column" \nlayout-align="center center" flex><md-icon md-font-icon="icon-timelapse" class="s120 grey-400-fg"></md-icon><span \nclass="hint-text" translate="RISKCONFIG.NO_RISK_AVAILABLE"></span></div></div></div><div id="list-content-data" \nng-style="{\'opacity\' : isLoading ? 0.5 : 1}" ng-if="vm.risks.length > 0"><div class="mail-list-item" \nng-repeat="risk in vm.risks | filter: vm.search | filter: global.search" ng-init="parentIndex = $index" md-no-ink \nng-click="vm.openRisk(risk)" ng-class="{\'selected\': vm.currentRisk.id == risk.id, \'checked\': vm.isSelected(risk)}"><div\n layout="row" layout-align-gt-xs="start center" layout-align-xs="space-between stretch"><md-checkbox \nng-hide="risk.processes.length == 0 || vm.totalRiskControls(risk) == 0" class="no-label" \nng-checked="vm.isSelected(risk)" ng-click="vm.toggleSelectThread(risk, $event)" \naria-label="{{vm.isSelected(risk) ? \'Deselect\' : \'Select\'}}"></md-checkbox><div class="info" flex layout="column"><div \nclass="name" layout="row"><span>{{risk.name}}</span></div><div layout="row" layout-align="space-between center"><div \nlayout="column"><div layout="row" class="badges"><span class="badge-processes" ng-bind-html="risk.processes.length">\n</span> <span>Procesos</span> <span class="badge-controls" ng-bind-html="vm.totalRiskControls(risk)"></span> <span>\nControles</span></div></div></div></div><div layout="row" layout-align="start center"><div \nng-if="risk.processes.length == 0 || vm.totalRiskControls(risk) == 0"><span class="badge-danger">\n{{ \'RISKCONFIG.INCOMPLETE\' | translate}}</span></div></div><div layout="row" layout-align="start center"><div \nng-if="risk.deleted_at"><span class="badge-danger">{{ \'RISKCONFIG.DELETED\' | translate}}</span></div></div></div></div>\n<div ng-if="!isLoading && pagination_total_pages > pagination_page && vm.risks.length > 0" \nclass="load-more white p-30" layout="row" layout-sm="column" layout-align="center center" layout-wrap=""><md-button \nng-click="pagination_nextPage(true)" class="md-raised">{{\'GLOBAL.LOAD_MORE\' |\xA0translate}}</md-button></div><div \nng-if="pagination_total_pages == pagination_page && pagination_page > 1" class="load-more white p-30" layout="row" \nlayout-sm="column" layout-align="center center" layout-wrap=""><div class="message" translate="GLOBAL.NO_MORE_ITEMS">\n</div></div></div>');
$templateCache.put('app/main/apps/riskconfig/views/list/nosplit-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.editMode && !vm.currentRisk" \nng-include="\'app/main/apps/riskconfig/views/list/toolbar.html\'"></div><div class="toolbar" layout="row" \nlayout-align="space-between center" ng-if="vm.editMode" \nng-include="\'app/main/apps/riskconfig/views/edit/toolbar.html\'"></div><div class="content-wrapper" flex="" \nlayout="row"><div class="content thread-list mail-list-pane scrollable p0" flex="100" ms-scroll="vm.msScrollOptions" \nid="thread-list" ng-if="!vm.editMode && !vm.currentRisk" \nng-include="\'app/main/apps/riskconfig/views/list/list-view.html\'"></div><div \nclass="content toolbar-height thread-detail mail-read-pane p0" flex="" id="thread-preview" \nng-if="!vm.editMode && vm.currentRisk" ng-include="\'app/main/apps/riskconfig/views/read/preview-structure.html\'"></div>\n</div>');
$templateCache.put('app/main/apps/riskconfig/views/list/split-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.editMode" \nng-include="\'app/main/apps/riskconfig/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" \nlayout="row"><div class="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" \nid="thread-list" ng-include="\'app/main/apps/riskconfig/views/list/list-view.html\'"></div><div \nclass="content toolbar-height thread-detail mail-read-pane p0" flex="" id="thread-preview" \nng-include="\'app/main/apps/riskconfig/views/read/preview-structure.html\'"></div></div>');
$templateCache.put('app/main/apps/riskconfig/views/list/toolbar.html','<div layout="row" layout-align="start center"><md-checkbox class="no-label" \naria-label="{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}" \nng-checked="vm.selectedThreads.length > 0" ng-click="vm.toggleSelectThreads(vm.selectedThreads, vm.contents)">\n</md-checkbox><div class="divider-vertical" hide="" show-gt-xs=""></div><md-button aria-label="NEW" \nclass="md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme" hide show-gt-sm \nng-click="vm.openCreateRiskDialog()" translate="GLOBAL.NEW" type="button"></md-button><md-button aria-label="NEW" \nclass="md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme z-index-0" hide-gt-sm \nng-click="vm.openCreateRiskDialog()" type="button"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="divider-vertical" hide="" show-gt-xs=""></div><md-button class="md-icon-button" ng-click="$mdMenu.open($event)" \naria-label="Subscribe" translate translate-attr-aria-label="SB.SUBSCRIBE"><md-icon ng-click="vm.reloadToggleDeleted()" \nmd-menu-origin ng-if="vm.showDeleted" md-font-icon="icon-eye"></md-icon><md-icon ng-click="vm.reloadToggleDeleted()" \nmd-menu-origin ng-if="!vm.showDeleted" md-font-icon="icon-eye-off"></md-icon><md-tooltip hide show-gt-xs><span \nng-show="vm.showDeleted" translate="RISKCONFIG.HIDE_DELETED"></span> <span ng-show="!vm.showDeleted" \ntranslate="RISKCONFIG.SHOW_DELETED"></span></md-tooltip></md-button><div class="divider-vertical" hide="" \nshow-gt-xs=""></div><md-menu-bar id="region-menu" class="pl-0 pr-0"><md-menu md-position-mode="left bottom"><md-button \nclass="user-button m0" ng-click="$mdMenu.open()" aria-label="User settings" translate \ntranslate-attr-aria-label="TOOLBAR.REGION"><div layout="row" layout-align="space-between center"><span \nng-if="vm.regionSelected" class="username">{{vm.regionSelected.name}}</span><md-icon md-font-icon="icon-chevron-down" \nclass="icon s16"></md-icon></div></md-button><md-menu-content width="3" class="clients"><md-menu-item \nclass="md-indent"><div class="search-input-wrapper" layout="row" layout-align="start center"><label for="search">\n<md-icon md-font-icon="icon-magnify"></md-icon></label><md-input-container md-no-float class="m-0"><input id="search" \nplaceholder="{{\'CONTACTS.SEARCH_FOR_ANYONE\' |\xA0translate}}" type="text" ng-model="vm.searchRegionText">\n</md-input-container></div></md-menu-item><div class="results"><md-menu-item ng-click="vm.selectRegion(region)" \nclass="md-indent bar-client" ng-repeat="region in vm.allRegions | filter:vm.searchRegionText"><div><md-icon \nmd-font-icon="icon-account" class="icon s16" hide-xs></md-icon><button class="btn-clients">{{region.name}}</button>\n</div></md-menu-item></div></md-menu-content></md-menu></md-menu-bar><div aria-hidden="false" \nclass="action-buttons hide show-gt-xs layout-align-start-center layout-row" layout="row" layout-align="start center" \nng-show="vm.selectedThreads.length > 0"><md-button ng-click="vm.openDelegationsDialog()" aria-label="ACTIVATE" \nclass="md-icon-button" hide="" show-gt-xs="" translate=""><md-icon md-font-icon="icon-city"></md-icon><md-tooltip hide \nshow-gt-xs><span translate="RISKCONFIG.ACTIVATE_RISKS"></span></md-tooltip></md-button><div class="divider-vertical" \nhide="" show-gt-xs=""></div></div><div aria-hidden="false" \nclass="action-buttons hide show-gt-xs layout-align-start-center layout-row" layout="row" layout-align="start center" \nng-show="vm.selectedThreads.length > 0"><md-button ng-click="vm.deleteRisk($event)" aria-label="Delete" \nclass="md-icon-button" hide="" show-gt-xs="" translate=""><md-icon md-font-icon="icon-delete"></md-icon><md-tooltip \nhide show-gt-xs><span translate="GLOBAL.REMOVE"></span></md-tooltip></md-button><div class="divider-vertical" hide="" \nshow-gt-xs=""></div></div><ms-search-bar debounce="300" model-search="$root.pagination_searchquery" \non-result-click="vm.searchResultClick(item)" on-search="vm.search(query)" layout="row" layout-align="start center">\n</ms-search-bar><md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" \ntranslate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nng-if="$root.pagination_searchquery==true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip \nhide show-gt-xs><span>Reset search</span></md-tooltip></md-button><div class="divider-vertical" hide="" show-gt-xs="">\n</div><md-menu hide="" show-gt-xs="" ng-if="refGroupables.length>0"><button aria-label="Filters" \nclass="md-icon-button" ng-click="$mdMenu.open($event)" show-gt-xs="" translate="" \ntranslate-attr-aria-label="GLOBAL.FILTERS"><md-icon md-font-icon="icon-chevron-down"><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.GROUP_BY">Group</span></md-tooltip></md-icon></button><md-menu-content width="4"><md-menu-item \nng-repeat="sortfield in refGroupables"><md-button aria-label="All" ng-click="pagination_setOrderBy(sortfield)"><div \nlayout="row" layout-align="space-between center"><span>Group by {{sortfield.name}} </span><i class="icon-check s16" \nng-if="sortfield.titleId == sortable.titleId"></i></div></md-button></md-menu-item><md-menu-divider ng-if="groupable">\n</md-menu-divider><md-menu-item ng-if="groupable"><md-button aria-label="Remove group" \nng-click="pagination_resetOrderBy()"><md-icon md-font-icon="icon-close "></md-icon><span>Remove order</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div><div layout="row" layout-align="start center" \ntranslate-attr-aria-label="GLOBAL.REFRESH" ng-if="vm.risks.length > 0"><span ng-if="!isLoading" \nclass="page-info font-weight-500">\n{{vm.risks.length}} {{ \'GLOBAL.OF\' | translate}} {{pagination_totalItems}} {{ \'GLOBAL.ITEMS\' | translate}}.</span><div \nclass="divider-vertical" hide hide show-gt-sm></div><md-button class="md-icon-button" \nng-click="vm.changeView(\'nosplit\')" ng-if="vm.currentView !== \'nosplit\'" hide show-gt-sm><md-icon \nmd-font-icon="icon-view-list" ng-if="vm.currentView !== \'nosplit\'"></md-icon><md-icon class="md-accent" \nmd-font-icon="icon-checkbox-marked" ng-if="vm.currentView === \'nosplit\'"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.NOSPLIT_VIEW">No split</span></md-tooltip></md-button><md-button class="md-icon-button" \nng-click="vm.changeView(\'split\')" ng-if="vm.currentView !== \'split\'" hide show-gt-sm><md-icon \nmd-font-icon="icon-view-quilt" ng-if="vm.currentView !== \'split\'"></md-icon><md-icon class="md-accent" \nmd-font-icon="icon-checkbox-marked" ng-if="vm.currentView === \'split\'"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.SPLIT_VIEW">split</span></md-tooltip></md-button><md-menu class="settings-menu" hide-gt-xs \nng-show="vm.selectedThreads.length > 0"><md-button aria-label="Settings" class="md-icon-button" \nng-click="$mdMenu.open($event)" translate="GLOBAL.SETTINGS" translate-attr-aria-label="GLOBAL.SETTINGS"><md-icon \nmd-font-icon="icon-dots-horizontal"></md-icon></md-button><md-menu-content><md-menu-item \nng-click="vm.openDelegationsDialog()"><md-button ng-click="vm.openDelegationsDialog()" aria-label="Delete" \ntranslate-aria-label="RISKCONFIG.ACTIVATE_RISKS"><md-icon md-font-icon="icon-city"></md-icon><span \ntranslate="RISKCONFIG.ACTIVATE_RISKS"></span></md-button></md-menu-item></md-menu-content></md-menu></div>');
$templateCache.put('app/main/apps/risk/dialogs/edit-name/edit-name-dialog.html','<md-dialog class="creation-control-dialog" aria-label="New Task"><form name="taskForm" class="md-inline-form" \nnovalidate><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between"><h1 ng-if="vm.type==\'process\'" class="title" translate="RISKCONFIG.EDIT_PROCESS"></h1><h1 \nng-if="vm.type==\'control\'" class="title" translate="RISKCONFIG.EDIT_CONTROL"></h1><md-button class="md-icon-button" \nng-click="vm.closeDialog()"><md-icon md-font-icon="icon-close" aria-label="Close dialog"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div flex layout="row" layout-align="start center" class="p-15">\n<md-input-container flex="100"><label translate="GLOBAL.NAME"></label> <input type="text" ng-model="vm.item.name" \nrequired></md-input-container></div></md-dialog-content><md-dialog-actions layout="row" layout-="end">\n<md-input-container flex layout="row" layout-align="end center"><md-button type="button" class="md-raised md-warn" \nng-click="vm.closeDialog()" translate="RISKCONFIG.CANCEL">Cancel</md-button><md-button type="submit" \nng-disabled="!vm.item.name" class="send-button md-accent md-raised" ng-click="vm.saveDialog()" \ntranslate="RISKCONFIG.SAVE">ADD</md-button></md-input-container></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/risk/dialogs/selectControlDialog/selectControlDialog.html','<md-dialog id="select-control-dialog" class="form-dialog" aria-label="Select Controls"><md-toolbar class="md-accent">\n<div class="md-toolbar-tools" layout="row" layout-align="space-between center"><h1 translate="RISK.SELECT_CONTROLS">\n</h1><div class="absolute-right pr-10" layout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog" translate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></div></md-toolbar><md-dialog-content class="mediadialog-content" flex><div flex \nlayout="column" layout-align="center center" ng-if="vm.isLoadingControls" class="loading-container">\n<md-progress-circular md-mode="indeterminate" md-diameter="50"></md-progress-circular></div><div \nng-if="!vm.isLoadingControls" layout="row" class="search-bar pr-10"><md-icon style="margin-top: 10px" \nmd-font-icon="icon-magnify" class="md-icon-button md-button"><md-tooltip hide show-gt-xs><span \ntranslate="TOOLBAR.SEARCH">Search</span></md-tooltip></md-icon><input id="ms-search-bar-input" type="text" \nng-model="vm.searchQuery" placeholder="Search" md-autofocus translate translate-attr-placeholder="TOOLBAR.SEARCH" flex>\n</div><md-list class="p0"><md-list-item class="bb" \nng-repeat="control in vm.controls | filter: {name : vm.searchQuery}" ng-click="vm.toggleControl(control)"><div \nclass="p-15 pl-60 bb" layout="row" layout-align-gt-xs="start center" layout-align-xs="space-between stretch">\n<md-checkbox class="no-label" ng-checked="vm.isSelectedControl(control)" ng-click="vm.toggleControl(control)">\n</md-checkbox><div class="avatar" ng-style="{\'background\': \'rgba(132,173,78,1)\'}">C</div><div class="info" flex \nlayout="column"><div class="name" layout="row"><span>{{control.name}}</span></div></div></div></md-list-item></md-list>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="end center" class="grey-100-bg"><md-button \nng-click="vm.saveDialog()" class="md-raised md-accent" aria-label="Save" translate="GLOBAL.SAVE"></md-button><md-button\n ng-click="vm.closeDialog()" class="md-raised md-warn" aria-label="Cancel" translate="GLOBAL.CANCEL"></md-button>\n</md-dialog-actions></md-dialog>');
$templateCache.put('app/main/apps/risk/dialogs/selectRiskDialog/selectRiskDialog.html','<md-dialog id="select-risk-dialog" class="form-dialog" aria-label="Odds of occurence"><md-toolbar class="md-accent">\n<div class="md-toolbar-tools" layout="row" layout-align="space-between center"><h1 translate="RISK.EDIT_RISKS"></h1>\n<div class="absolute-right pr-10" layout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog" tranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></div></md-toolbar><md-dialog-content ng-if="!vm.selectedRisk" class="mediadialog-content" \nflex><div flex layout="column" layout-align="center center" ng-if="vm.isLoadingRisks" class="loading-container">\n<md-progress-circular md-mode="indeterminate" md-diameter="50"></md-progress-circular></div><div \nng-if="!vm.isLoadingRisks" layout="row" class="search-bar pr-10"><md-icon style="margin-top: 10px" \nmd-font-icon="icon-magnify" class="md-icon-button md-button"><md-tooltip hide show-gt-xs><span \ntranslate="TOOLBAR.SEARCH">Search</span></md-tooltip></md-icon><input id="ms-search-bar-input" type="text" \nng-model="vm.searchQuery" placeholder="Search" md-autofocus translate translate-attr-placeholder="TOOLBAR.SEARCH" flex>\n</div><md-list class="p0"><md-list-item class="bb" ng-repeat="risk in vm.risks | filter: {name : vm.searchQuery}" \nng-click="vm.selectRisk(risk)"><span class="grey-700-fg mr-15">#{{risk.id}}</span><p style="line-height: 1.1">\n{{risk.name}}</p></md-list-item></md-list></md-dialog-content><md-dialog-content ng-if="vm.selectedRisk" \nclass="mediadialog-content" flex><div flex layout="column" layout-align="center center" ng-if="vm.isLoadingRiskDetail" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="50"></md-progress-circular></div>\n<div ng-if="!vm.isLoadingRiskDetail" id="list-content-data"><div class="p-15 bb" layout="row" \nlayout-align-gt-xs="start center" layout-align-xs="space-between stretch"><md-checkbox class="no-label" \nng-checked="vm.isSelectedRisk()" ng-click="vm.toggleRisk()"></md-checkbox><div class="avatar" \nng-style="{\'background\': \'rgb(16, 155, 229)\'}">R</div><div class="info" flex layout="column"><div class="name" \nlayout="row"><span>{{vm.selectedRisk.name}}</span></div></div></div><div \nng-repeat="process in vm.selectedRisk.processes"><div class="process-title"><md-checkbox class="no-label" \nng-checked="vm.isSelectedProcess(process)" ng-click="vm.toggleProcess(process)"></md-checkbox><span>{{process.name}}\n</span></div><div class="mail-list-item" ng-repeat="control in process.controls" md-no-ink><div class="p-15 pl-60 bb" \nlayout="row" layout-align-gt-xs="start center" layout-align-xs="space-between stretch"><md-checkbox class="no-label" \nng-checked="vm.isSelectedControl(control)" ng-click="vm.toggleControl(control, process)"></md-checkbox><div \nclass="avatar" ng-style="{\'background\': \'rgba(132,173,78,1)\'}">C</div><div class="info" flex layout="column"><div \nclass="name" layout="row"><span>{{control.name}}</span></div></div></div></div></div></div></md-dialog-content>\n<md-dialog-actions ng-if="vm.user.user_type == 1" layout="row" layout-align="end center" class="grey-100-bg"><md-button\n ng-if="vm.selectedRisk" translate="GLOBAL.BACK" type="button" ng-click="vm.selectedRisk= null;" class="md-raised" \naria-label="BACK"></md-button><md-button ng-if="!vm.selectedRisk" translate="GLOBAL.CANCEL" type="button" \nng-click="vm.closeDialog()" class="md-raised md-warn" aria-label="Cancel"></md-button><md-button \nng-if="vm.selectedRisk" translate="GLOBAL.SAVE" type="button" ng-click="vm.saveDialog()" class="md-raised md-accent" \naria-label="Save"></md-button><md-button ng-click="vm.saveDialog(true)" class="send-button md-accent md-raised" \naria-label="Save" translate="GLOBAL.UPGRADE_PLAN" translate-attr-aria-label="GLOBAL.UPGRADE_PLAN"></md-button>\n</md-dialog-actions><md-dialog-actions ng-if="vm.user.user_type != 1" layout="row" layout-align="end center" \nclass="grey-100-bg"><md-button ng-if="vm.selectedRisk" translate="GLOBAL.BACK" type="button" \nng-click="vm.selectedRisk= null;" class="md-raised" aria-label="BACK"></md-button><md-button ng-if="!vm.selectedRisk" \ntranslate="GLOBAL.CANCEL" type="button" ng-click="vm.closeDialog()" class="md-raised md-warn" aria-label="Cancel">\n</md-button><md-button ng-if="vm.selectedRisk" translate="GLOBAL.SAVE" type="button" ng-click="vm.saveDialog()" \nclass="md-raised md-accent" aria-label="Save"></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/main/apps/risk/views/edit/details-view-process.html','<div class="content thread-detail" layout="row" layout-align="center center" flex ng-if="!vm.currentProcess"><div \nclass="no-thread-selected" layout="column" layout-align="center center" flex><md-icon md-font-icon="icon-timelapse" \nclass="s120 grey-400-fg"></md-icon><span class="hint-text">{{\'RISK.DETAILS_VIEW\' | translate}}</span></div></div><div \nclass="risk-detail-view p0" ng-if="vm.currentProcess"><div layout="row" class="risk-main-toolbar ng-scope"><a \nclass="pointer" ng-click="vm.closeProcess()"><md-icon md-font-icon="icon-chevron-left"></md-icon></a><p \nclass="section-title m-0">{{ \'RISK.PROCESS\' | translate | uppercase}}</p></div><div class="pt-30 pb-20 ph-24" \nlayout="row" layout-align="space-between start"><div layout="column" layout-gt-xs="row"><div layout="row" \nlayout-align="space-between center" class="mb-15"><div class="avatar mr-10" \nng-style="{\'background\': \'rgb(25, 147, 232)\'}">P</div><div layout="row" layout-align="end center" hide-gt-xs><md-icon \nmd-font-icon="icon-checkbox-blank-circle s24" ng-style="{\'color\': vm.controlAverageColor(vm.currentProcess)}">\n<md-tooltip hide show-gt-xs>{{vm.controlAverageText(vm.currentProcess)}}</md-tooltip></md-icon><md-menu \nng-if="!vm.is_evidences" md-position-mode="target-right target"><md-button class="md-icon-button" \nng-click="$mdMenu.open()" aria-label="more"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button>\n<md-menu-content width="3"><md-menu-item><md-button \nng-click="vm.editNameDialog($event, \'process\', vm.currentProcess, {process_id : vm.currentProcess.process_id})" \ntranslate="RISKCONFIG.EDIT_PROCESS"></md-button></md-menu-item></md-menu-content></md-menu></div></div><h1 \nng-bind-html="vm.currentProcess.rename ? vm.currentProcess.rename : vm.currentProcess.name" class="mt-0 mb-0"></h1>\n</div><div layout="row" layout-align="end center" hide show-gt-xs class="ml-24"><md-icon \nmd-font-icon="icon-checkbox-blank-circle s24" ng-style="{\'color\': vm.controlAverageColor(vm.currentProcess)}">\n<md-tooltip hide show-gt-xs>{{vm.controlAverageText(vm.currentProcess)}}</md-tooltip></md-icon><md-menu \nng-if="!vm.is_evidences" md-position-mode="target-right target"><md-button class="md-icon-button" \nng-click="$mdMenu.open()" aria-label="more"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button>\n<md-menu-content width="3"><md-menu-item><md-button \nng-click="vm.editNameDialog($event, \'process\', vm.currentProcess, {process_id : vm.currentProcess.process_id})" \ntranslate="RISKCONFIG.EDIT_PROCESS"></md-button></md-menu-item></md-menu-content></md-menu></div></div><div \nlayout="row" layout-align="start center" class="ph-15" flex="100"><md-input-contaimer flex="100"><div \nclass="grey-500-fg" layout="row" layout-align="end center"><span translate="RISKCONFIG.ADD_PROB"></span><md-button \nstyle="float: right;" ng-click="vm.updateProcessScore($event, vm.currentProcess)" \nclass="md-mini add-event-button no-sort md-fab md-warn block" aria-label="Add comment"><md-icon \nmd-font-icon="icon-plus"></md-icon></md-button></div></md-input-contaimer></div><md-content flex="100" \nclass="border mh-24 mb-24 mt-10"><md-list flex="100" class="p-0"><md-list-item class="border-bottom" \nng-repeat="comment in vm.processComments  | orderBy: \'-created_at\' track by $index"><div layout="row" \nlayout-align="start center" flex="100" class="pt-10 pb-10"><div class="info" flex layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><label class="font-weight-700" \nng-if="comment.odds == 1" translate="RISK.PROCESS_AVERAGE_1"></label> <label class="font-weight-700" \nng-if="comment.odds == 2" translate="RISK.PROCESS_AVERAGE_2"></label> <label class="font-weight-700" \nng-if="comment.odds == 3" translate="RISK.PROCESS_AVERAGE_3"></label> <label class="font-weight-700" \nng-if="comment.odds == 4" translate="RISK.PROCESS_AVERAGE_4"></label> <label class="font-weight-700" \nng-if="comment.odds == 5" translate="RISK.PROCESS_AVERAGE_5"></label></div><div layout="row" layout-align="end center" \nflex="100"><p ng-bind="vm.timeAgo(comment.created_at)"></p></div></div><div class="name" layout="row"><div \nlayout="row" layout-align="start center" flex="100"><p class="m-0" ng-bind="comment.comment"></p></div></div></div>\n</div></md-list-item><div ng-if="vm.processComments.length == 0" class="grey-800-fg p-15 text-center" \ntranslate="RISK.NO_ODDS_OF_OCCURENCY_EXIST"></div></md-list></md-content></div>');
$templateCache.put('app/main/apps/risk/views/edit/details-view.html','<div class="content thread-detail" layout="row" layout-align="center center" flex ng-if="!vm.currentControl"><div \nclass="no-thread-selected" layout="column" layout-align="center center" flex><md-icon md-font-icon="icon-timelapse" \nclass="s120 grey-400-fg"></md-icon><span class="hint-text">{{\'RISK.DETAILS_VIEW\' | translate}}</span></div></div><div \nclass="risk-detail-view p0" ng-if="vm.currentControl"><div layout="row" class="risk-main-toolbar ng-scope"><a \nclass="pointer" ng-click="vm.is_evidences ? vm.closeControlAndRisk() : vm.closeControl()"><md-icon \nmd-font-icon="icon-chevron-left"></md-icon></a><p class="section-title m-0">{{ \'RISK.CONTROL\' | translate | uppercase}}\n</p></div><div class="pt-30 pb-20 ph-24" layout="row" layout-align="space-between start"><div layout="column" \nlayout-gt-xs="row" flex><div layout="row" layout-align="space-between center" class="mb-15"><div class="avatar mr-10" \nng-style="{\'background\': \'rgba(132,173,78,1)\'}">C</div><div layout="row" layout-align="end center" hide-gt-xs><md-menu \nng-if="!vm.is_evidences" md-position-mode="target-right target"><md-button class="md-icon-button" \nng-click="$mdMenu.open()" aria-label="more"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button>\n<md-menu-content width="3"><md-menu-item><md-button ng-click="vm.deleteActiveControl($event, vm.currentControl)" \ntranslate="RISKCONFIG.DELETE_CONTROL"></md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.editNameDialog($event, \'control\', vm.currentControl, {process_id : vm.currentControl.process_id})" \ntranslate="RISKCONFIG.EDIT_CONTROL"></md-button></md-menu-item></md-menu-content></md-menu></div></div><h1 \nng-bind-html="vm.currentControl.rename ? vm.currentControl.rename : vm.currentControl.name" class="mt-0 mb-0"></h1>\n</div><div layout="row" layout-align="end center" hide show-gt-xs class="ml-24"><md-menu ng-if="!vm.is_evidences" \nmd-position-mode="target-right target"><md-button class="md-icon-button" ng-click="$mdMenu.open()" aria-label="more">\n<md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content width="3"><md-menu-item><md-button \nng-click="vm.deleteActiveControl($event, vm.currentControl)" translate="RISKCONFIG.DELETE_CONTROL"></md-button>\n</md-menu-item><md-menu-item><md-button \nng-click="vm.editNameDialog($event, \'control\', vm.currentControl, {process_id : vm.currentControl.process_id})" \ntranslate="RISKCONFIG.EDIT_CONTROL"></md-button></md-menu-item></md-menu-content></md-menu></div></div></div><div \nstyle="height: auto;; max-height: fit-content; margin-bottom: 100px;" layout="row" layout-align="start start" \nflex="100" ng-if="vm.currentControl" class="m-24 border white-bg"><md-content flex="100"><md-tabs md-dynamic-height \nmd-border-bottom flex="100" md-selected="vm.controlTabsIndex"><md-tab><md-tab-label><span \nng-bind-html="vm.translate(\'RISK.EVIDENCES\')"></span></md-tab-label><md-tab-body><button ng-if="!vm.savingEvidence" \nclass="add-event-button md-fab md-warn md-button md-default-theme absolute" style="right: 15px; top: 15px;" \ntype="button" ng-click="vm.openEvidence(\'\')"><md-icon md-font-icon="icon-plus" role="img" aria-hidden="true"></md-icon>\n</button><md-content class="" flex="100"><md-list ng-if="vm.savingEvidence" flex="100"><div \nclass="add-new-evidence-btn p-10" layout="row" layout-align="center center"><md-progress-circular \nmd-mode="indeterminate" md-diameter="20"></md-progress-circular></div></md-list><div ng-if="!vm.currentEvidences" \nfill-width style="margin-top: 20%;" class="text-center"><div class="no-thread-selected m-15" layout="column" \nlayout-align="center center" flex><md-icon md-font-icon="icon-timelapse" class="s120 grey-400-fg"></md-icon><span \nclass="hint-text">{{\'RISK.NO_EVIDENCES_FOUND\' | translate}}</span></div></div><md-list ng-if="vm.currentEvidences" \nflex="100" class="p-0" ng-show="!vm.loadingEvidences"><md-list-item ng-repeat="evidence in vm.currentEvidences" \nclass="evidence" ng-click="vm.openEvidence(evidence, $event)"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-15"><div class="info" flex layout="column"><div class="name mb-10" layout="row"><div layout="row" \nlayout-align="start center" flex="100"><div class="avatar-wrapper"><img class="avatar s24" \nng-src="{{vm.showUserImage(evidence.user)}}" ng-if="evidence.user.files.id"><div class="avatar s24" \nng-class="evidence.user.profile_color" ng-if="!evidence.user.files.id" \nng-bind="evidence.user.first_name | capitalizeFirstLetter"></div></div><div class="field mr-10" flex><span \nclass="grey-800-fg">{{evidence.user.first_name}} {{evidence.user.last_name}}</span></div><div layout-align="end start">\n<div layout="row" layout-align="space-between center"><div class="field" ng-if="evidence.files.length> 0"><md-button \nclass="md-icon-button" ng-click="vm.openEvidence(evidence, $event)" md-menu-origin md-menu-align-target><md-icon \nmd-font-icon="icon-paperclip s24"></md-icon><md-tooltip hide show-gt-xs>\n{{evidence.files.length}} {{ \'RISK.FILES\' | translate}}</md-tooltip></md-button></div><div class="field grey-fg" \nng-bind-html="vm.timeAgo(evidence.updated_at)"></div><div class="field"><md-button aria-label="ACTIONS" \nclass="md-icon-button" md-menu-origin md-menu-align-target><md-tooltip hide show-gt-xs>\n{{vm.evidenceScoreText(evidence)}}</md-tooltip><md-icon md-font-icon="icon-checkbox-blank-circle s24" \nng-style="{\'color\': vm.evidenceScoreColor(evidence)}"></md-icon></md-button></div></div></div></div></div><div \nlayout="row" layout-align="start center" flex="100"><div class="field" flex><strong \nclass="font-size-15 block grey-800-fg" ng-bind-html="evidence.title"></strong> <span class="grey-800-fg mr-10" \nng-if="evidence.amount">{{evidence.amount}}{{vm.getSymbolCurrency(evidence.currency_id)}}</span><div \nng-if="evidence.text" class="field-evidence grey-600-fg font-size-12" \nng-bind-html="(evidence.text | limitTo: 70) + (evidence.text.length> 70 ? \'...\' : \'\')"></div></div></div></div></div>\n<md-divider></md-divider></md-list-item></md-list><md-list ng-show="vm.loadingEvidences"><div class="evidence">\n<md-list-item><div layout="row" layout-align="space-between center" flex="100" class="pt-10 pb-10"><div layout="row" \nlayout-align="start center" flex><div class="field"><md-progress-circular md-mode="indeterminate" md-diameter="30">\n</md-progress-circular></div></div></div></md-list-item></div></md-list></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span ng-bind-html="vm.translate(\'RISK.TASKS\')"></span></md-tab-label><md-tab-body><md-content>\n<tasks-section-view nolistadd="true" relatedtype="\'active_controls\'" availableusers="vm.branchSelected.users" \ncurrentcontrolusers="vm.currentControlUsers" currentcontrol="vm.currentControl"></tasks-section-view></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label><span ng-bind-html="vm.translate(\'RISK.USERS_PARTICIPANTS\')"></span>\n</md-tab-label><md-tab-body><md-content flex="100" class="responsables pt-15"><md-input-container layout="row" \nclass="group-form" flex="100" flex-gt-xs="100"><div flex layout="row" layout-align="start center"><h3 \nclass="bold m-15">{{vm.translate(\'RISK.USERS_ADMIN\')}}</h3></div><div layout="row" ng-if="!vm.is_evidences" \nlayout-align="end center"><md-button ng-click="vm.openDialogDivisions($event, vm.currentControl, \'IN_CHARGE\')" \nclass="ml-20 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-account-multiple-plus"></md-icon>\n</md-button><md-button ng-click="vm.openDialogUsers($event, vm.currentControl, \'IN_CHARGE\')" \nclass="ml-20 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-account-plus"></md-icon></md-button>\n</div></md-input-container><div \nng-if="(!vm.currentControlUsers.IN_CHARGE || vm.currentControlUsers.IN_CHARGE.length == 0) && (!vm.currentControlDivisions.IN_CHARGE || vm.currentControlDivisions.IN_CHARGE.length == 0)" \nlayout="row" layout-align="space-between center" flex="100" class="pt-10 pb-10"><div layout="row" \nlayout-align="start center" flex><div class="field p-15"><p><strong class="grey-800-fg" \ntranslate="RISK.NO_USERS_FOUND"></strong></p></div></div></div><md-list-item \nng-repeat="division in vm.currentControlDivisions.IN_CHARGE"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex layout="column"><div class="name" layout="row"><div layout="row" \nlayout-align="start center" flex="100"><div class="field mr-10 ml-10" flex><md-icon class="mr-15" \nstyle="margin-left: -10px;" md-font-icon="icon-google-circles-communities"></md-icon><strong class="grey-800-fg" \nng-bind-html="division.name"></strong></div></div></div></div></div></md-list-item><md-list-item \nng-repeat="user in vm.currentControlUsers.IN_CHARGE track by $index"><div layout="row" layout-align="start center" \nflex="100" class="pt-10 pb-10"><div class="info" flex layout="column"><div class="name" layout="row"><div layout="row" \nlayout-align="start center" flex="100"><div class="avatar-wrapper"><img class="avatar s24" \nng-src="{{vm.showUserImage(user)}}" ng-if="user.files.id"><div class="avatar s24" ng-class="user.profile_color" \nng-if="!user.files.id" ng-bind="user.first_name | capitalizeFirstLetter"></div></div><div class="field mr-10 ml-10" \nflex><strong class="grey-800-fg" ng-bind-html="user.first_name + \' \' + user.last_name"></strong></div></div></div>\n</div></div></md-list-item></md-content><md-content class="responsables pt-15"><md-input-container layout="row" \nclass="group-form" flex="100" flex-gt-xs="100"><div flex layout="row" layout-align="start center"><h3 \nclass="bold m-15">{{vm.translate(\'RISK.USERS_PARTICIPANTS\')}}</h3></div><div flex layout="row" \nng-if="!vm.is_evidences" layout-align="end center"><md-button \nng-click="vm.openDialogDivisions($event, vm.currentControl, \'PARTICIPANT\')" \nclass="ml-20 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-account-multiple-plus"></md-icon>\n</md-button><md-button ng-click="vm.openDialogUsers($event, vm.currentControl, \'PARTICIPANT\')" \nclass="ml-20 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-account-plus"></md-icon></md-button>\n</div></md-input-container><div \nng-if="(!vm.currentControlUsers.PARTICIPANT || vm.currentControlUsers.PARTICIPANT.length == 0) && (!vm.currentControlDivisions.PARTICIPANT || vm.currentControlDivisions.PARTICIPANT.length == 0)" \nlayout="row" layout-align="space-between center" flex="100" class="pt-10 pb-10"><div layout="row" \nlayout-align="start center" flex><div class="field p-15"><p><strong class="grey-800-fg" \ntranslate="RISK.NO_USERS_FOUND"></strong></p></div></div></div><md-list-item \nng-repeat="division in vm.currentControlDivisions.PARTICIPANT"><div layout="row" layout-align="start center" \nflex="100" class="pt-10 pb-10"><div class="info" flex layout="column"><div class="name" layout="row"><div layout="row" \nlayout-align="start center" flex="100"><div class="field mr-10 ml-10" flex><md-icon class="mr-15" \nstyle="margin-left: -10px;" md-font-icon="icon-google-circles-communities"></md-icon><strong class="grey-800-fg" \nng-bind-html="division.name"></strong></div></div></div></div></div></md-list-item><md-list-item \nng-repeat="user in vm.currentControlUsers.PARTICIPANT"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex layout="column"><div class="name" layout="row"><div layout="row" \nlayout-align="start center" flex="100"><div class="avatar-wrapper"><img class="avatar s24" \nng-src="{{vm.showUserImage(user)}}" ng-if="user.files.id"><div class="avatar s24" ng-class="user.profile_color" \nng-if="!user.files.id" ng-bind="user.first_name | capitalizeFirstLetter"></div></div><div class="field mr-10 ml-10" \nflex><strong class="grey-800-fg" ng-bind-html="user.first_name + \' \' + user.last_name"></strong></div></div></div>\n</div></div></md-list-item></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \nng-bind-html="vm.translate(\'RISK.NONCONFORMITIES_IMPROVEMENTS\')"></span></md-tab-label><md-tab-body><md-content \nclass="nonconformities"><div id="site-questions" class="page-layout carded left-sidenav" layout="row"><div \nclass="content-wrapper" layout="row" flex><div class="content thread-detail" style="min-height: 300px;" layout="row" \nlayout-align="center center" flex><div class="no-client-selected no-thread-selected" layout="column" \nlayout-align="center center" flex><md-icon md-font-icon="icon-alert" class="s120 grey-400-fg"></md-icon><span \nclass="hint-text" translate="QUESTIONS.NOT_AVAILABLE_YET"></span></div></div></div></div></md-content></md-tab-body>\n</md-tab></md-tabs></md-content></div>');
$templateCache.put('app/main/apps/risk/views/edit/main-view.html','<div class="risk-main-toolbar"><div layout="row" layout-align="start center"><a class="pointer" \nng-click="vm.closeEdit()"><md-icon md-font-icon="icon-chevron-left"></md-icon></a><md-icon \nmd-font-icon="icon-map-marker" role="img" class="s20 ml-5 mr-5" aria-hidden="true"></md-icon><span>\n{{vm.branchSelected.name}}</span><md-tooltip hide show-gt-xs>{{vm.branchSelected.name}}</md-tooltip></div></div><div \nclass="risk-main-view" flex="100"><div layout="row" layout-align="space-between start"><h1 \nng-bind-html="vm.currentRisk.name" class="mt-0 mr-24"></h1></div><div layout-gt-xs="row" layout-xs="column" \nlayout-align-gt-xs="space-around center" layout-align-xs="center center"><div layout="column" \nclass="risk-details-gauge"><c3chart ng-if="!loadingChart" bindto-id="gauge-plot{{risk.id}}-chart"><chart-size \nchart-height="200" chart-width="250"><chart-colors color-pattern="#FF0000"><chart-column \ncolumn-id="{{vm.impactText(vm.currentRisk.computedRisk)}}" \ncolumn-color="{{vm.impactColor(vm.currentRisk.computedRisk)}}" \ncolumn-values="{{vm.currentRisk.computedRisk / 25 * 100}}" column-type="gauge"><chart-gauge min="00" max="100" \nunits="{{ \'RISK.RISK_LEVEL\' | translate}}" label-format-function="vm.formatLabel" width="40" show-label="false" \nexpand="false"></c3chart></div></div><div layout="column"><div class=""><div class="white-bg border mb-50"><div \nlayout="row" layout-align="center center" class="pt-32 pb-32 pl-10 pr-10 layout-wrap"><a class="md-button" \nng-if="vm.currentRisk.external_link" ng-href="{{vm.currentRisk.external_link}}" target="_blank" layout="row" \nlayout-align="start center"><span translate="RISK.CODIGO_PENAL"></span> <i class="icon-link-variant s16 ml-5"></i></a>\n<md-button ng-if="vm.currentRisk.description" md-no-ink class="md-primary" \nng-click="vm.openDialogText($event, vm.currentRisk.description, \'RISK.DESCRIPTION\')" translate="RISK.DESCRIPTION">\n</md-button><md-button ng-if="vm.currentRisk.conducts" md-no-ink class="md-primary" \nng-click="vm.openDialogText($event, vm.currentRisk.conducts, \'RISK.CONDUCTS\')" translate="RISK.CONDUCTS"></md-button>\n<md-button ng-if="vm.currentRisk.factual_causes" md-no-ink class="md-primary" \nng-click="vm.openDialogText($event, vm.currentRisk.factual_causes, \'RISK.FACTUAL_CAUSES\')" \ntranslate="RISK.FACTUAL_CAUSES"></md-button><md-button ng-if="vm.currentRisk.penalties" md-no-ink class="md-primary" \nng-click="vm.openDialogText($event, vm.currentRisk.penalties, \'RISK.PENALTIES\')" translate="RISK.PENALTIES">\n</md-button></div><div layout="column" layout-gt-xs="row" layout-align="center space-between" \nlayout-align-gt-xs="center center" class="text-center pb-32 grey-50-bg pt-32 border-top"><md-input-container \nng-if="vm.branding.tenant != \'gnl\'" class="ml-24 mr-20 mt-0 mb-15 pv-24 ph-15 circle-graph white-bg" layout="column" \nlayout-align="center center" flex><div class="field grey-500-fg" translate="RISK.REPUTATION_IMPACT"></div><md-select \nng-model="vm.currentRisk.activeRisk.reputation_impact" placeholder="-" ng-change="vm.updateRiskLevels(vm.currentRisk)">\n<md-option class="small" ng-value="1" ng-disabled="$index === 1" translate="RISK.RISK_LEVELS_1"></md-option><md-option \nclass="small" ng-value="2" ng-disabled="$index === 2" translate="RISK.RISK_LEVELS_2"></md-option><md-option \nclass="small" ng-value="3" ng-disabled="$index === 3" translate="RISK.RISK_LEVELS_3"></md-option><md-option \nclass="small" ng-value="4" ng-disabled="$index === 4" translate="RISK.RISK_LEVELS_4"></md-option><md-option \nclass="small" ng-value="5" ng-disabled="$index === 5" translate="RISK.RISK_LEVELS_5"></md-option></md-select>\n</md-input-container><md-input-container class="ml-24 mr-20 mt-0 mb-15 pv-24 ph-15 circle-graph white-bg" \nlayout="column" layout-align="center center" flex><div class="field grey-500-fg" translate="RISK.PENAL_CODE_IMPACT">\n</div><md-select ng-model="vm.currentRisk.activeRisk.penal_code_impact" placeholder="-" \nng-change="vm.updateRiskLevels(vm.currentRisk)"><md-option class="small" ng-value="1" ng-disabled="$index === 1" \ntranslate="RISK.RISK_LEVELS_1"></md-option><md-option class="small" ng-value="2" ng-disabled="$index === 2" \ntranslate="RISK.RISK_LEVELS_2"></md-option><md-option class="small" ng-value="3" ng-disabled="$index === 3" \ntranslate="RISK.RISK_LEVELS_3"></md-option><md-option class="small" ng-value="4" ng-disabled="$index === 4" \ntranslate="RISK.RISK_LEVELS_4"></md-option><md-option class="small" ng-value="5" ng-disabled="$index === 5" \ntranslate="RISK.RISK_LEVELS_5"></md-option></md-select></md-input-container><md-input-container \nclass="ml-24 mr-20 mt-0 mb-15 pv-24 ph-15 circle-graph white-bg" layout="column" layout-align="center center" flex><div\n class="field grey-500-fg" translate="RISK.CLIENT_LOSS"></div><md-select \nng-model="vm.currentRisk.activeRisk.client_loss" placeholder="-" ng-change="vm.updateRiskLevels(vm.currentRisk)">\n<md-option class="small" ng-value="1" ng-disabled="$index === 1" translate="RISK.RISK_LEVELS_1"></md-option><md-option \nclass="small" ng-value="2" ng-disabled="$index === 2" translate="RISK.RISK_LEVELS_2"></md-option><md-option \nclass="small" ng-value="3" ng-disabled="$index === 3" translate="RISK.RISK_LEVELS_3"></md-option><md-option \nclass="small" ng-value="4" ng-disabled="$index === 4" translate="RISK.RISK_LEVELS_4"></md-option><md-option \nclass="small" ng-value="5" ng-disabled="$index === 5" translate="RISK.RISK_LEVELS_5"></md-option></md-select>\n</md-input-container></div><md-divider></md-divider><div layout="row" layout-align="start center" class="p-24"><h2 \ntranslate="RISK.PROCESS_AND_CONTROLS" class="mt-0 mb-0"></h2></div><md-divider></md-divider><div layout="row" \nlayout-align="start start"><md-list flex="100" class="p-0"><div ng-repeat="process in vm.currentRisk.processes" \nng-class="(process.id == vm.currentProcess.id) ? \'current-control\' : \'\'" class="process"><md-list-item \nclass="border-bottom pointer" ng-click="vm.openProcess(process)"><div class="info pt-24 pb-24" flex layout="column">\n<div layout="row" layout-align="end center" hide-gt-xs class="mb-10 mr-16"><div class="field"><span \nng-style="{\'background\': vm.controlAverageColor(process)}" class="badge">\n{{vm.controlAverageText(process) ? vm.controlAverageText(process) : \'RISK.NO_SCORED\' | translate}}</span></div></div>\n<div layout="row" layout-align="space-between center" flex="100"><div layout="row" layout-align="start center" flex>\n<div class="avatar" ng-style="{\'background\': \'rgba(25,147,232,1)\'}">P</div><div class="field mr-10"><div \nstyle="line-height: 2rem; font-weight: bolder;" class="grey-800-fg" \nng-bind-html="process.rename ? process.rename : process.name"></div></div></div><div layout="row" \nlayout-align="end center"><div class="field" hide show-gt-xs><span \nng-style="{\'background\': vm.controlAverageColor(process)}" class="badge">\n{{vm.controlAverageText(process) ? vm.controlAverageText(process) : \'RISK.NO_SCORED\' | translate}}</span></div>\n<md-button class="md-icon-button"><md-icon md-font-icon="icon-chevron-right"></md-icon></md-button></div></div></div>\n</md-list-item><div class="process-controls pointer" ng-if="process.controls.length> 0" \nng-repeat="control in process.controls"><md-list-item layout="row" layout-align="start center" \nng-class="(control.id == vm.currentControl.id) ? \'current-control\' : \'\'"><div layout="column" \nlayout-align="center stretch" layout-gt-xs="row" layout-align-gt-xs="space-between center" flex="100" \nng-click="vm.openControl(control.active_control_id)"><div class="field mb-10 mr-16" layout="row" \nlayout-align="end center" hide-gt-xs><span ng-if="control.visible == 1 && control.averageEvidenceScore == 0" \nclass="badge negative" translate="GLOBAL.NO_EVIDENCES"></span> <span ng-if="control.averageEvidenceScore> 0" \nng-style="{\'background\': vm.controlAverageColor(control)}" class="badge">{{vm.controlAverageText(control)}}</span> \n<span ng-if="control.visible == 0 && control.averageEvidenceScore == 0" class="badge undone" translate="GLOBAL.UNDONE">\n</span></div><div layout="row" layout-align="space-between center" flex><div class="avatar" \nng-style="{\'background\': \'rgba(132,173,78,1)\'}">C</div><div class="field mr-10" flex><span class="grey-800-fg" \nng-bind-html="control.rename ? control.rename : control.name"></span><div class="grey-600-fg" layout="row"><div \nng-repeat="activeuser in vm.currentRisk.users | filter:filterUserControlType(control.active_control_id, \'1\')">\n<md-tooltip hide show-gt-xs>{{activeuser.user.first_name + \' \' + activeuser.user.last_name}}</md-tooltip><div \nclass="avatar-wrapper"><img class="avatar s24" ng-src="{{vm.showUserImage(activeuser.user)}}" \nng-if="activeuser.user.files.id"><div class="avatar s24" ng-class="activeuser.user.profile_color" \nng-if="!activeuser.user.files.id" ng-bind="activeuser.user.first_name | capitalizeFirstLetter"></div></div></div></div>\n</div><div layout="row" layout-align="end center"><div class="field" hide show-gt-xs><span \nng-if="control.visible == 1 && control.averageEvidenceScore == 0" class="badge negative" \ntranslate="GLOBAL.NO_EVIDENCES"></span> <span ng-if="control.averageEvidenceScore> 0" \nng-style="{\'background\': vm.controlAverageColor(control)}" class="badge">{{vm.controlAverageText(control)}}</span> \n<span ng-if="control.visible == 0 && control.averageEvidenceScore == 0" class="badge undone" translate="GLOBAL.UNDONE">\n</span></div><md-button class="md-icon-button"><md-icon md-font-icon="icon-chevron-right"></md-icon></md-button></div>\n</div></div><md-divider></md-divider></md-list-item></div></div></md-list></div></div></div></div></div>');
$templateCache.put('app/main/apps/risk/views/edit/toolbar.html','');
$templateCache.put('app/main/apps/risk/views/list/list-view.html','<div flex layout="column" layout-align="center center" ng-if="isLoading" class="loading-container">\n<md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div><div \nclass="content-wrapper" layout="row" flex ng-if="vm.firstLoad"><div class="content thread-detail" layout="row" \nlayout-align="center center" flex><div class="no-client-selected no-thread-selected" layout="column" \nlayout-align="center center" flex><md-icon md-font-icon="icon-timelapse" class="s120 grey-400-fg"></md-icon><span \nclass="hint-text" translate="GLOBAL.SELECT_CLIENT_FIRST"></span></div></div></div><div class="content-wrapper" \nlayout="row" flex ng-if="!vm.firstLoad && vm.risks.length == 0"><div class="content thread-detail" layout="row" \nlayout-align="center center" flex><div class="no-client-selected no-thread-selected" layout="column" \nlayout-align="center center" flex><md-icon md-font-icon="icon-timelapse" class="s120 grey-400-fg"></md-icon><span \nclass="hint-text" translate="RISK.NO_RISK_AVAILABLE"></span></div></div></div><div ng-if="!vm.is_evidences" \nid="list-content-data" ng-style="{\'opacity\' : isLoading ? 0.5 : 1}" ng-if="vm.risks.length> 0"><div \nclass="mail-list-item" ng-repeat="risk in vm.risks | filter: vm.search | filter: global.search" \nng-init="parentIndex= $index" md-no-ink ng-click="vm.openRisk(risk)" \nng-class="{\'selected\': vm.currentRisk.activeRisk.id == risk.activeRisk.id, \'checked\': vm.isSelected(risk),\'attention\':risk.computedRisk >= 15}">\n<div layout="row" layout-align-gt-xs="start center" layout-align-xs="space-between stretch"><md-checkbox \nclass="no-label" ng-checked="vm.isSelected(risk)" ng-click="vm.toggleSelectThread(risk, $event)" \naria-label="{{vm.isSelected(risk) ? \'Deselect\' : \'Select\'}}"></md-checkbox><div class="info" flex-xs="100" flex \nlayout="column"><div class="name" layout="row"><span>{{risk.name}}</span></div><div layout="row" \nlayout-align="space-between center"><div layout="column" flex="100"><div layout="row" class="badges"><div layout="row" \nclass="ph-5"><span class="badge-processes">{{risk.processes.length}} </span><span translate="GLOBAL.PROCESSES"></span>\n</div><div layout="row" class="ph-5"><span class="badge-controls">{{vm.totalRiskControls(risk)}} </span><span \ntranslate="GLOBAL.CONTROLS"></span></div></div><div layout-gt-xs="row" layout-xs="column" \nlayout-align-gt-xs="start start" layout-align-xs="start start" class="mt-10 avatar-activity" flex="100"><div \nlayout="row" class="layout-wrap people-list"><div \nng-repeat="activeuser in risk.users | filter: { active_control_user_type_id: \'1\'} | unique: \'user.id\'" \nclass="people-item"><md-tooltip hide show-gt-xs>{{activeuser.user.first_name + \' \' + activeuser.user.last_name}}\n</md-tooltip><div class="avatar-wrapper"><img class="avatar s24" ng-src="{{vm.showUserImage(activeuser.user)}}" \nng-if="activeuser.user.files.id"><div class="avatar s24" ng-class="activeuser.user.profile_color" \nng-if="!activeuser.user.files.id" ng-bind="activeuser.user.first_name | capitalizeFirstLetter"></div></div></div></div>\n<div class="list-activity" layout="row"><div class="sede"><md-icon md-font-icon="icon-map-marker" role="img" \nclass="s20" aria-hidden="true"></md-icon>{{vm.branchSelected.name}}<md-tooltip hide show-gt-xs>Sede</md-tooltip></div>\n</div></div></div></div></div><div class="tools" layout-gt-xs="row" layout="column" layout-align="center center"><div \nng-if="risk.computedRisk >= 15" layout="column" flex layout-align="center center" class="attention-column"><div \nclass="attention-icon"><md-icon md-font-icon="icon-alert-circle" role="img" class="s32" aria-hidden="true"></md-icon>\n</div><span translate="RISK.ATENTION_REQUIRED"></span></div><div class="avatar-wrapper" hide-gt-xs flex \nlayout="column" layout-align="center center"><div class="avatar ml-8" \nng-style="{\'background\': vm.impactColor(risk.computedRisk)}">{{risk.computedRisk / 25 * 100}}%</div></div><div \nlayout="column" flex hide show-gt-xs><div layout="row" flex layout-align="center center" style="margin-top: -10px;">\n<c3chart ng-if="!loadingChart" bindto-id="gauge-plot{{risk.id}}-chart"><chart-size chart-height="65" chart-width="90">\n<chart-colors color-pattern="#FF0000"><chart-column column-id="{{vm.impactText(risk.computedRisk)}}" \ncolumn-color="{{vm.impactColor(risk.computedRisk)}}" column-values="{{risk.computedRisk / 25 * 100}}" \ncolumn-type="gauge"><chart-gauge min="00" max="100" width="20" show-label="false" \nlabel-format-function="vm.formatLabel" expand="false"></c3chart></div><div style="margin-top: -10px;" layout="column" \nflex layout-align="center center"><div translate="RISK.RISK_LEVEL" translate-attr-aria-label="RISK.RISK_LEVEL">\nNivel de riesgo</div><div class="risk-impact-text" ng-bind-html="vm.impactText(risk.computedRisk)"></div></div></div>\n</div></div></div><div ng-if="!isLoading && pagination_total_pages> pagination_page && vm.risks.length > 0" \nclass="load-more white p-30" layout="row" layout-sm="column" layout-align="center center" layout-wrap=""><md-button \nng-click="pagination_nextPage(true)" class="md-raised">{{\'GLOBAL.LOAD_MORE\' | translate}}</md-button></div><div \nng-if="pagination_total_pages == pagination_page && pagination_page> 1" class="load-more white p-30" layout="row" \nlayout-sm="column" layout-align="center center" layout-wrap=""><div class="message" translate="GLOBAL.NO_MORE_ITEMS">\n</div></div></div><div ng-if="vm.is_evidences" id="list-content-data" ng-style="{\'opacity\' : isLoading ? 0.5 : 1}" \nng-if="vm.risks.length > 0"><span ng-repeat="risk in vm.risks"><span \nng-if="vm.getFilteredControls(process.controls).length > 0" ng-repeat="process in risk.processes "><div \nclass="process-title">{{process.rename ? process.rename : process.name}}</div><div class="mail-list-item" \nng-class="{\'selected\': vm.currentControl.active_control_id == control.active_control_id}" \nng-repeat="control in vm.getFilteredControls(process.controls)" ng-init="parentIndex = $index" md-no-ink \nng-click="vm.openRiskAndControl(risk.activeRisk.id, control.active_control_id)"><div layout="row" \nlayout-align-gt-xs="start center" layout-align-xs="space-between stretch"><div class="avatar" \nng-style="{\'background\': \'rgba(132,173,78,1)\'}">C</div><div class="info" flex layout="column"><div class="name" \nlayout="row"><span>{{control.rename ? control.rename : control.name}}</span></div></div></div></div></span></span><div \nng-if="!isLoading && pagination_total_pages> pagination_page && vm.risks.length > 0" class="load-more white p-30" \nlayout="row" layout-sm="column" layout-align="center center" layout-wrap=""><md-button \nng-click="pagination_nextPage(true)" class="md-raised">{{\'GLOBAL.LOAD_MORE\' | translate}}</md-button></div><div \nng-if="pagination_total_pages == pagination_page && pagination_page> 1" class="load-more white p-30" layout="row" \nlayout-sm="column" layout-align="center center" layout-wrap=""><div class="message" translate="GLOBAL.NO_MORE_ITEMS">\n</div></div></div>');
$templateCache.put('app/main/apps/risk/views/list/nosplit-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.editMode && !vm.currentRisk" \nng-include="\'app/main/apps/risk/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row"><div \nclass="content thread-list mail-list-pane scrollable p0" flex="100" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="!vm.editMode && !vm.currentRisk" ng-include="\'app/main/apps/risk/views/list/list-view.html\'"></div><div \nid="preview-print" class="content thread-detail mail-read-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" \nid="thread-preview" ng-if="!vm.editMode && vm.currentRisk && !vm.is_evidences" \nng-include="\'app/main/apps/risk/views/read/preview-structure.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-edit" \nng-if="vm.editMode && !vm.currentControl && !vm.currentProcess  && !vm.is_evidences" \nng-include="\'app/main/apps/risk/views/edit/main-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-edit" \nng-if="vm.is_evidences" ng-include="\'app/main/apps/risk/views/edit/details-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-details" \nng-if="vm.currentControl && vm.editMode" ng-include="\'app/main/apps/risk/views/edit/details-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-details" \nng-if="vm.currentProcess && vm.editMode" ng-include="\'app/main/apps/risk/views/edit/details-view-process.html\'"></div>\n</div>');
$templateCache.put('app/main/apps/risk/views/list/split-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.editMode" \nng-include="\'app/main/apps/risk/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row"><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="!vm.editMode" ng-include="\'app/main/apps/risk/views/list/list-view.html\'"></div><div \nclass="content thread-detail mail-read-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-preview" \nng-if="!vm.editMode && !vm.is_evidences" ng-include="\'app/main/apps/risk/views/read/preview-structure.html\'"></div><div\n class="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-edit" \nng-if="vm.editMode  && !vm.is_evidences" ng-include="\'app/main/apps/risk/views/edit/main-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0 bg-white" flex="" ms-scroll="vm.msScrollOptions" \nid="thread-edit" ng-if="vm.is_evidences" ng-include="\'app/main/apps/risk/views/edit/details-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-details" \nng-if="!vm.currentProcess && vm.editMode" ng-include="\'app/main/apps/risk/views/edit/details-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-details" \nng-if="vm.currentProcess && vm.editMode" ng-include="\'app/main/apps/risk/views/edit/details-view-process.html\'"></div>\n</div>');
$templateCache.put('app/main/apps/risk/views/list/toolbar.html','<div layout="row" layout-align="start center"><md-checkbox class="no-label" \naria-label="{{vm.selectedThreads.length> 0 ? \'Deselect All\' : \'Select All\'}}" \nng-checked="vm.selectedThreads.length > 0" ng-click="vm.toggleSelectThreads(vm.selectedThreads, vm.contents)">\n</md-checkbox><div class="divider-vertical" hide="" show-gt-xs=""></div><md-menu-bar id="user-menu" class="p0"><md-menu\n md-position-mode="left bottom"><md-button class="user-button" ng-click="$mdMenu.open()" aria-label="User settings" \ntranslate translate-attr-aria-label="TOOLBAR.USER_SETTINGS"><div layout="row" layout-align="space-between center"><span\n ng-if="vm.branchSelected" class="username">{{vm.branchSelected.name}}</span><md-icon md-font-icon="icon-chevron-down" \nclass="icon s16"></md-icon></div></md-button><md-menu-content width="3" class="clients"><md-menu-item \nclass="md-indent"><div class="search-input-wrapper" layout="row" layout-align="start center"><label for="search">\n<md-icon md-font-icon="icon-magnify"></md-icon></label><md-input-container md-no-float class="m-0"><input id="search" \nplaceholder="{{\'RISK.SEARCH_FOR_BRANCH\' | translate}}" type="text" ng-model="vm.searchBranchText"></md-input-container>\n</div></md-menu-item><div class="results"><md-menu-item ng-click="vm.selectBranch(branch)" \nclass="md-indent bar-client" ng-repeat="branch in vm.companyBranches | filter:vm.searchBranchText"><div><md-icon \nmd-font-icon="icon-account" class="icon s16" hide-xs></md-icon><button class="btn-clients">{{branch.name}}</button>\n</div></md-menu-item></div></md-menu-content></md-menu></md-menu-bar><div class="divider-vertical" hide="" \nshow-gt-xs=""></div><md-checkbox ng-if="vm.is_evidences && vm.userLogued.user_type <= 3" \nng-change="vm.showAllToggle()" class="no-label" ng-model="vm.showAll">{{\'RISK.SHOW_ALL\' | translate}}</md-checkbox><div\n ng-if="vm.is_evidences && vm.userLogued.user_type <= 3" class="divider-vertical" hide="" show-gt-xs=""></div>\n<md-menu-bar ng-if="vm.is_evidences && vm.userLogued.user_type <= 3 && vm.showAll" id="user-menu" class="pl-0 pr-0" \nhide show-gt-xs><md-menu md-position-mode="left bottom"><md-button class="user-button m0" \nng-click="vm.openMenu($mdMenu.open, $event)" aria-label="User settings" translate \ntranslate-attr-aria-label="TOOLBAR.USER_SETTINGS"><div layout="row" layout-align="space-between center"><span \nng-if="vm.userSelected" class="username">{{vm.userSelected.first_name +\' \' + vm.userSelected.last_name}}</span> <span \nng-if="!vm.userSelected" class="grey-500-fg" translate="RISK.SEARCH_BY_USER"></span><md-icon \nmd-font-icon="icon-chevron-down" class="icon s16"></md-icon></div></md-button><md-menu-content width="3" \nclass="clients"><md-menu-item class="md-indent"><div class="search-input-wrapper" layout="row" \nlayout-align="start center"><label for="search"><md-icon md-font-icon="icon-magnify"></md-icon></label>\n<md-input-container md-no-float class="m-0"><input id="search" placeholder="{{\'RISK.SEARCH_BY_USER\' | translate}}" \ntype="text" ng-model="vm.searchNameText"></md-input-container></div></md-menu-item><div class="results"><md-menu-item \nng-click="vm.selectUser(user)" class="md-indent bar-client" \nng-repeat="user in vm.usersToSearch | filter:vm.searchNameText"><div><md-icon md-font-icon="icon-account" \nclass="icon s16" hide-xs></md-icon><button class="btn-clients">{{user.first_name +\' \' + user.last_name}}</button></div>\n</md-menu-item></div></md-menu-content></md-menu></md-menu-bar><div \nng-if="vm.is_evidences && vm.userLogued.user_type <= 3 && vm.showAll" class="divider-vertical" hide="" show-gt-xs="">\n</div><div aria-hidden="false" class="action-buttons hide show-gt-xs layout-align-start-center layout-row" \nlayout="row" layout-align="start center" ng-show="vm.selectedThreads.length> 0"><md-button \nng-click="vm.deleteActiveRisk($event)" aria-label="Delete" class="md-icon-button" hide="" show-gt-xs="" translate="">\n<md-icon md-font-icon="icon-delete"></md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.REMOVE"></span>\n</md-tooltip></md-button><div class="divider-vertical" hide="" show-gt-xs=""></div></div><md-button \nng-if="!vm.is_evidences" ng-click="vm.openRiskAndControlsSelectDialog()" aria-label="ACTIVATE" class="md-icon-button" \ntranslate=""><md-icon md-font-icon="icon-timelapse"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="RISK.ADD_NEW_RISK"></span></md-tooltip></md-button><div ng-if="!vm.is_evidences" class="divider-vertical">\n</div><ms-search-bar debounce="300" model-search="$root.pagination_searchquery" \non-result-click="vm.searchResultClick(item)" on-search="vm.search(query)" layout="row" layout-align="start center">\n</ms-search-bar><md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" \ntranslate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nng-if="$root.pagination_searchquery==true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip \nhide show-gt-xs><span>Reset search</span></md-tooltip></md-button><md-menu hide="" show-gt-xs="" \nng-if="refGroupables.length>0"><button aria-label="Filters" class="md-icon-button" ng-click="$mdMenu.open($event)" \nshow-gt-xs="" translate="" translate-attr-aria-label="GLOBAL.FILTERS"><md-icon md-font-icon="icon-chevron-down">\n<md-tooltip hide show-gt-xs><span translate="GLOBAL.GROUP_BY">Group</span></md-tooltip></md-icon></button>\n<md-menu-content width="4"><md-menu-item ng-repeat="sortfield in refGroupables"><md-button aria-label="All" \nng-click="pagination_setOrderBy(sortfield)"><div layout="row" layout-align="space-between center"><span>\nGroup by {{sortfield.name}} </span><i class="icon-check s16" ng-if="sortfield.titleId == sortable.titleId"></i></div>\n</md-button></md-menu-item><md-menu-divider ng-if="groupable"></md-menu-divider><md-menu-item ng-if="groupable">\n<md-button aria-label="Remove group" ng-click="pagination_resetOrderBy()"><md-icon md-font-icon="icon-close"></md-icon>\n<span>Remove order</span></md-button></md-menu-item></md-menu-content></md-menu></div><div layout="row" \nlayout-align="start center" translate-attr-aria-label="GLOBAL.REFRESH" ng-if="vm.risks.length> 0"><span \nng-if="!isLoading" class="page-info font-weight-500">\n{{vm.risks.length}} {{ \'GLOBAL.OF\' | translate}} {{pagination_totalItems}} {{ \'GLOBAL.ITEMS\' | translate}}.</span><div \nclass="divider-vertical" hide hide show-gt-sm></div><md-button class="md-icon-button" \nng-click="vm.changeView(\'nosplit\')" ng-if="vm.currentView !== \'nosplit\'" hide show-gt-sm><md-icon \nmd-font-icon="icon-view-list" ng-if="vm.currentView !== \'nosplit\'"></md-icon><md-icon class="md-accent" \nmd-font-icon="icon-checkbox-marked" ng-if="vm.currentView === \'nosplit\'"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.NOSPLIT_VIEW">No split</span></md-tooltip></md-button><md-button class="md-icon-button" \nng-click="vm.changeView(\'split\')" ng-if="vm.currentView !== \'split\'" hide show-gt-sm><md-icon \nmd-font-icon="icon-view-quilt" ng-if="vm.currentView !== \'split\'"></md-icon><md-icon class="md-accent" \nmd-font-icon="icon-checkbox-marked" ng-if="vm.currentView === \'split\'"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.SPLIT_VIEW">split</span></md-tooltip></md-button><md-menu class="settings-menu" hide-gt-xs \nng-show="vm.selectedThreads.length> 0"><md-button aria-label="Settings" class="md-icon-button" \nng-click="$mdMenu.open($event)" translate="GLOBAL.SETTINGS" translate-attr-aria-label="GLOBAL.SETTINGS"><md-icon \nmd-font-icon="icon-dots-horizontal"></md-icon></md-button><md-menu-content><md-menu-item \nng-click="vm.deleteActiveRisk($event)" show="vm.selectedMail.length> 0 || vm.allChecked"><md-button \nng-click="vm.massActions(\'delete\')" aria-label="Delete" translate-aria-label="GLOBAL.DELETE"><md-icon \nmd-font-icon="icon-delete"></md-icon><span translate="GLOBAL.DELETE">Delete</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div>');
$templateCache.put('app/main/apps/risk/views/read/preview-structure.html','<div flex layout="column" layout-align="center center" ng-if="loadingRisk" class="loading-container">\n<md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div><div \nclass="content thread-detail" layout="row" layout-align="center center" flex ng-if="!vm.currentRisk && !loadingRisk">\n<div class="no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-timelapse" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="RISK.SELECT_RISK_DETAILS"></span></div></div><div class="toolbar grey-100-bg colored-bg" layout="row" \nlayout-align="space-between center" scroll="" ng-if="vm.currentRisk && !loadingRisk"><div layout="row" \nlayout-align="start center"><a class="pointer" ng-click="vm.closeRisk()"><md-icon md-font-icon="icon-close"></md-icon>\n</a></div><div layout="row" layout-align="end center" hide show-gt-sm><md-button translate="RISK.MANAGE_RISK" \ntype="button" ng-click="vm.editRisk()" class="md-raised md-accent" aria-label="Edit"></md-button></div><div \nlayout="row" layout-align="end center" hide-gt-sm><md-button type="button" ng-click="vm.editRisk()" \nclass="md-accent md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" aria-label="Edit"><md-icon \nmd-font-icon="icon-pencil"></md-icon><md-tooltip hide show-gt-xs><span translate="RISK.MANAGE_RISK"></span>\n</md-tooltip></md-button></div></div><div id="preview-print" class="risk-main-view" \nng-if="vm.currentRisk && !loadingRisk"><div layout="row" flex layout-align="space-between start"><h1 \nng-bind-html="vm.currentRisk.name" class="mt-0 mr-24"></h1><div hide show-gt-sm layout="row" layout-align="end start">\n<md-button ng-click="vm.saveCanvas(\'preview-print\')" class="md-raised"><md-icon ng-if="!capturing" \nmd-font-icon="icon-download"></md-icon><span ng-if="!capturing" translate="RISKMAP.DOWNLOAD"></span>\n<md-progress-circular ng-if="capturing" md-mode="indeterminate" md-diameter="30"></md-progress-circular></md-button>\n</div></div><div layout-gt-xs="row" layout-xs="column" layout-align-gt-xs="space-around center" \nlayout-align-xs="center center"><div layout="column" class="risk-details-gauge"><c3chart \nbindto-id="gauge-plot{{vm.currentRisk.id}}-chart2">\xA0\xA0<chart-size chart-height="200" chart-width="250">\xA0\xA0<chart-colors \ncolor-pattern="#FF0000"><chart-column column-id="{{vm.impactText(vm.currentRisk.computedRisk)}}" \ncolumn-color="{{vm.impactColor(vm.currentRisk.computedRisk)}}" \ncolumn-values="{{vm.currentRisk.computedRisk / 25 * 100 }}" column-type="gauge"><chart-gauge min="00" max="100" \nwidth="40" show-label="false" label-format-function="vm.formatLabel" expand="false"></c3chart><div \nstyle="margin-top: -10px;" layout="column" flex layout-align="center center"><div class="risk-impact-text mb-10" \nng-bind-html="vm.impactText(vm.currentRisk.computedRisk)"></div></div></div></div><div layout="column" \nstyle="min-height: 100%; padding-bottom: 200px"><div class="white-bg border"><div layout="row" layout-gt-xs="row" \nlayout-align="center center" layout-align-gt-xs="center center" class="pt-32 pb-32 pl-10 pr-10 layout-wrap"><a \nclass="md-button" ng-if="vm.currentRisk.external_link" ng-href="{{vm.currentRisk.external_link}}" target="_blank" \nlayout="row" layout-align="start center"><span translate="RISK.CODIGO_PENAL"></span> <i \nclass="icon-link-variant s16 ml-5"></i></a><md-button ng-if="vm.currentRisk.description" md-no-ink class="md-primary" \nng-click="vm.openDialogText($event, vm.currentRisk.description, \'RISK.DESCRIPTION\')" translate="RISK.DESCRIPTION">\n</md-button><md-button ng-if="vm.currentRisk.conducts" md-no-ink class="md-primary" \nng-click="vm.openDialogText($event, vm.currentRisk.conducts, \'RISK.CONDUCTS\')" translate="RISK.CONDUCTS"></md-button>\n<md-button ng-if="vm.currentRisk.factual_causes" md-no-ink class="md-primary" \nng-click="vm.openDialogText($event, vm.currentRisk.factual_causes, \'RISK.FACTUAL_CAUSES\')" \ntranslate="RISK.FACTUAL_CAUSES"></md-button><md-button ng-if="vm.currentRisk.penalties" md-no-ink class="md-primary" \nng-click="vm.openDialogText($event, vm.currentRisk.penalties, \'RISK.PENALTIES\')" translate="RISK.PENALTIES">\n</md-button></div><div layout="column" layout-gt-xs="row" layout-align="center stretch" \nlayout-align-gt-xs="center center" class="text-center pb-32"><md-input-container ng-if="vm.branding.tenant != \'gnl\'" \nclass="ml-24 mr-20 mt-0 mb-15 pv-24 ph-15 circle-graph white-bg" layout="column" layout-align="center center" \nlayout-align-gt-xs="center center" flex><div class="field grey-500-fg" translate="RISK.REPUTATION_IMPACT"></div><div \nng-bind-html="vm.showRiskLevel(vm.currentRisk.activeRisk.reputation_impact)"></div></md-input-container>\n<md-input-container class="ml-24 mr-20 mt-0 mb-15 pv-24 ph-15 circle-graph white-bg" layout="column" \nlayout-align="center center" layout-align-gt-xs="center center" flex><div class="field grey-500-fg" \ntranslate="RISK.PENAL_CODE_IMPACT"></div><div \nng-bind-html="vm.showRiskLevel(vm.currentRisk.activeRisk.penal_code_impact)"></div></md-input-container>\n<md-input-container class="ml-24 mr-20 mt-0 mb-15 pv-24 ph-15 circle-graph white-bg" layout="column" \nlayout-align="center center" layout-align-gt-xs="center center" flex><div class="field grey-500-fg" \ntranslate="RISK.CLIENT_LOSS"></div><div ng-bind-html="vm.showRiskLevel(vm.currentRisk.activeRisk.client_loss)"></div>\n</md-input-container></div><md-divider></md-divider><div layout="row" layout-align="start center" class="p-24"><h2 \ntranslate="RISK.PROCESS_AND_CONTROLS" class="mt-0 mb-0"></h2></div><div layout="row" layout-align="start start">\n<md-list flex="100" class="p-0"><div ng-repeat="process in vm.currentRisk.processes" \nng-class="(process.id == vm.currentProcess.id) ? \'current-control\' : \'\'" class="process"><md-list-item \nclass="border-top cursor-default border-bottom"><div class="info" flex layout="column"><div layout="column" \nlayout-align="center stretch " layout-gt-xs="row" layout-align-gt-xs="space-between center " flex="100" class="pv-24">\n<div layout="row" layout-align="end center" hide-gt-xs class="mb-10"><div class="field"><span \nng-style="{\'background\': vm.controlAverageColor(process),\'color\':vm.controlAverageColorText(process)}" class="badge">\n{{vm.controlAverageText(process) ? vm.controlAverageText(process) : \'RISK.NO_SCORED\' | translate}}</span></div></div>\n<div layout="row" layout-align="start center" flex><div class="avatar" ng-style="{\'background\': \'rgba(25,147,232,1)\'}">\nP</div><div class="field mr-10 flex-100"><span style="line-height: 2rem; font-weight: bolder;" class="grey-800-fg" \nng-bind-html="process.rename ? process.rename : process.name"></span></div></div><div layout="row" \nlayout-align="end center" hide show-gt-xs><div class="field"><span \nng-style="{\'background\': vm.controlAverageColor(process),\'color\':vm.controlAverageColorText(process)}" class="badge">\n{{vm.controlAverageText(process) ? vm.controlAverageText(process) : \'RISK.NO_SCORED\' | translate}}</span></div></div>\n</div></div></md-list-item><div class="process-controls" \nng-style="{\'opacity\' : (control.averageEvidenceScore == 0 && !control.visible) ? 0.4 : 1}" \nng-if="process.controls.length > 0" ng-repeat="control in process.controls"><md-list-item class="border-bottom" \nlayout="row" layout-align="start center" ng-class="(control.id == vm.currentControl.id) ? \'current-control\' : \'\'"><div \nlayout="column" layout-align="center stretch " layout-gt-xs="row" layout-align-gt-xs="space-between center " \nflex="100" ng-click="vm.openControl(control.active_control_id)" ng-if="control.visible"><div layout="row" \nlayout-align="end center" hide-gt-xs class="mb-10 mt-5 mr-16"><div class="field"><span \nng-if="control.averageEvidenceScore == 0" class="badge negative" translate="GLOBAL.NO_EVIDENCES"></span> <span \nng-if="control.averageEvidenceScore  > 0" \nng-style="{\'background\': vm.controlAverageColor(control),\'color\':vm.controlAverageColorText(control)}" class="badge">\n{{vm.controlAverageText(control)}}</span></div></div><div layout="row" layout-align="start center" flex><div \nclass="avatar" ng-style="{\'background\': \'rgba(132,173,78,1)\'}">C</div><div class="field mr-10 flex-100"><span \nclass="grey-800-fg" ng-bind-html="control.rename ? control.rename : control.name"></span><div \nclass="grey-600-fg layout-wrap" layout="row"><div \nng-repeat="activeuser in vm.currentRisk.users | filter:filterUserControlType(control.active_control_id, \'1\')">\n<md-tooltip hide show-gt-xs>{{activeuser.user.first_name + \' \' + activeuser.user.last_name}}</md-tooltip><div \nclass="avatar-wrapper"><img class="avatar s24" ng-src="{{vm.showUserImage(activeuser.user)}}" \nng-if="activeuser.user.files.id"><div class="avatar s24" ng-class="activeuser.user.profile_color" \nng-if="!activeuser.user.files.id" ng-bind="activeuser.user.first_name | capitalizeFirstLetter"></div></div></div></div>\n</div></div><div layout="row" layout-align="end center" hide show-gt-xs><div class="field"><span \nng-if="control.averageEvidenceScore == 0" class="badge negative" translate="GLOBAL.NO_EVIDENCES"></span> <span \nng-if="control.averageEvidenceScore  > 0" \nng-style="{\'background\': vm.controlAverageColor(control),\'color\':vm.controlAverageColorText(control)}" class="badge">\n{{vm.controlAverageText(control)}}</span></div></div></div><div class="control-disabled" layout="column" \nlayout-align="center stretch " layout-gt-xs="row" layout-align-gt-xs="space-between center " flex="100" \nng-if="!control.visible"><div layout="row" layout-align="end center" hide-gt-xs class="mb-10 mt-5 mr-16"><div \nclass="field"><md-tooltip hide show-gt-xs ng-bind-html="vm.controlAverageText(control)"></md-tooltip><span \nng-if="control.averageEvidenceScore == 0" class="badge undone" translate="GLOBAL.UNDONE"></span></div></div><div \nlayout="row" layout-align="start center" flex><div class="avatar" ng-style="{\'background\': \'rgba(132,173,78,1)\'}">C\n</div><div class="field mr-10 flex-100"><span class="grey-800-fg" ng-bind-html="control.name"></span><div \nclass="grey-600-fg layout-wrap" layout="row"><div \nng-repeat="activeuser in vm.currentRisk.users | filter:filterUserControlType(control.active_control_id, \'1\')">\n<md-tooltip hide show-gt-xs>{{activeuser.user.first_name + \' \' + activeuser.user.last_name}}</md-tooltip><div \nclass="avatar-wrapper"><img class="avatar s24" ng-src="{{vm.showUserImage(activeuser.user)}}" \nng-if="activeuser.user.files.id"><div class="avatar s24" ng-class="activeuser.user.profile_color" \nng-if="!activeuser.user.files.id" ng-bind="activeuser.user.first_name | capitalizeFirstLetter"></div></div></div></div>\n</div></div><div layout="row" layout-align="end center" hide show-gt-xs><div class="field"><md-tooltip hide show-gt-xs \nng-bind-html="vm.controlAverageText(control)"></md-tooltip><span ng-if="control.averageEvidenceScore == 0" \nclass="badge undone" translate="GLOBAL.UNDONE"></span></div></div></div><md-divider></md-divider></md-list-item></div>\n</div></md-list></div></div></div></div>');
$templateCache.put('app/main/apps/risk/views/templates/task-row-template.html','<div layout="row" layout-align="start center" flex="100" class="p-15 task-row"><md-checkbox ng-if="vm.isTaskSection" \nng-checked="vm.isSelected(task)" ng-click="vm.toggleSelectThread(task, $event)" \naria-label="{{vm.isSelected(task) ? \'Deselect\' : \'Select\'}}" class="mb-0"></md-checkbox><md-icon \nng-click="task.expanded= !task.expanded; $event.stopPropagation();" \nng-if="task.childs && task.childs.length> 0 && !task.expanded" md-font-icon="icon-chevron-right"></md-icon><md-icon \nng-click="task.expanded= !task.expanded; $event.stopPropagation();" \nng-if="task.childs && task.childs.length> 0 && task.expanded" md-font-icon="icon-chevron-down"></md-icon><div \nclass="info" flex layout="column"><div class="name" layout="row"><span class="title block mr-80" \nng-bind-html="task.title"></span></div><div style="font-size: 14px; color: rgba(0, 0, 0, 0.54); font-weight: 400;" \nclass="name mt-10" layout="row"><span ng-if="!vm.nolistadd" style="line-height: 25px; width: 55px;" \nclass="field grey-500-fg ng-scope">{{task.due_by_date | amDateFormat:\'DD MMM \'}}</span> <span ng-if="vm.nolistadd" \nclass="field grey-500-fg time secondary-text" style="line-height: 25px; margin-right: 8px;"><md-icon \nmd-font-icon="icon-clock" class="s16" style="vertical-align: middle; margin-right: 4px;" role="img" aria-hidden="true">\n</md-icon>{{ task.due_by_date | altDate }}</span><div ng-if="task.assigned_to_user" class="avatar-wrapper" \nstyle="margin-top: -3px;"><img \nstyle="min-width: 25px;width: 25px;height: 25px;line-height: 25px; margin-right: 5px; margin-top: 2.5px;" \nclass="avatar s24" ng-src="{{vm.showUserImage(task.assigned_to_user)}}" ng-if="task.assigned_to_user.files.id"><div \nstyle="min-width: 25px;width: 25px;height: 25px;line-height: 25px; margin-right: 5px; margin-top: 2.5px;" \nclass="avatar s24" ms-random-class="vm.colors" ng-if="!task.assigned_to_user.files.id" \nng-bind="task.assigned_to_user.first_name | capitalizeFirstLetter"></div></div><div ng-if="!task.assigned_to_user" \nclass="avatar-wrapper" style="margin-top: -3px;"><div \nstyle="font-size: 12px;border-radius: 10px;text-align: center;width: auto;height: 20px;line-height: 20px;min-width: 20px;background: #1993e8;color: #FFF;margin-right: 5px;padding: 0 10px;" \nclass="avatar s24">{{task.assigned_multiple.users.length}}</div></div><span ng-if="task.assigned_to_user" \nstyle="line-height: 25px;" class="field grey-500-fg ng-scope">\n{{task.assigned_to_user.first_name}} {{task.assigned_to_user.last_name}} </span><span \nng-if="!task.assigned_to_user && task.status_multiple == 0" style="line-height: 25px;" \nclass="field grey-500-fg ng-scope">{{ \'RISK.MULTIPLE_TASK_SHARED\' | translate }} </span><span \nng-if="!task.assigned_to_user && task.status_multiple != 0" style="line-height: 25px;" \nclass="field grey-500-fg ng-scope">{{ \'RISK.MULTIPLE_TASK_INDIVIDUAL\' | translate }}</span><div ng-if="vm.nolistadd" \nclass="field"><span ng-init="taskStatus= task;" ng-include="\'app/main/apps/tasks/views/edit/task-status.html\'"></span>\n</div><md-icon class="mt-0 ml-5" ng-if="task.files && task.files.length> 0" md-font-icon="icon-attachment"></md-icon>\n</div></div><div ng-if="!vm.nolistadd" layout-align="end start"><div class="field"><span ng-init="taskStatus= task;" \nng-include="\'app/main/apps/tasks/views/edit/task-status.html\'"></span></div></div></div><div class="childs" \nng-if="task.childs && task.childs.length> 0 && task.expanded"><div class="mail-list-item" \nng-repeat="task in task.childs" md-no-ink><div style="background-color: white;" fill-width \nng-include="\'app/main/apps/risk/views/templates/task-row-template.html\'"></div></div></div>');
$templateCache.put('app/main/apps/stakeholders/dialogs/edit-branch/edit-branch-dialog.controller.html','<md-dialog class="edit-branch-dialog" aria-label="New Task"><form name="taskForm" class="md-inline-form" novalidate>\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between"><h1 \nclass="title">{{vm.branch.name}}</h1><md-button class="md-icon-button" ng-click="vm.closeDialog()"><md-icon \nmd-font-icon="icon-close" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div layout="column" class="p-15"><md-input-container fill-width flex class="md-block mb-0"><label \ntranslate="GLOBAL.NAME"></label> <input ng-model="vm.branch.name" type="text"></md-input-container><md-input-container \nfill-width flex class="md-block mb-0"><label translate="GLOBAL.ADDRESS"></label> <input ng-model="vm.branch.address1" \ntype="text"></md-input-container><md-input-container fill-width flex class="md-block mb-0"><label>\n{{vm.getRegionLiteral(\'city\')}}</label> <input ng-model="vm.branch.city" type="text"></md-input-container>\n<md-input-container fill-width flex class="md-block mb-0"><label>{{vm.getRegionLiteral(\'state\')}}</label> <input \nng-model="vm.branch.state" type="text"></md-input-container><md-input-container fill-width flex class="md-block mb-0">\n<label translate="GLOBAL.POSTAL_CODE"></label> <input ng-model="vm.branch.postcode" type="text"></md-input-container>\n<md-input-container fill-width flex class="md-block mb-0"><label translate="GLOBAL.EMAIL"></label> <input \nng-model="vm.branch.email" type="text"></md-input-container><md-input-container fill-width flex class="md-block mb-0">\n<label translate="GLOBAL.PHONE"></label> <input ng-model="vm.branch.phone" type="text"></md-input-container></div>\n</md-dialog-content><md-dialog-actions class="footer" layout="row" layout-="end"><md-input-container flex layout="row" \nlayout-align="end center"><md-button type="button" class="md-raised md-warn" ng-click="vm.closeDialog()" \ntranslate="RISKCONFIG.CANCEL">Cancel</md-button><md-button ng-disabled="vm.selectedBranchs.length == 0" type="submit" \nclass="send-button md-accent md-raised" ng-click="vm.saveDialog()" translate="GLOBAL.SAVE">ADD</md-button>\n</md-input-container></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/stakeholders/dialogs/forms/dialog-view.html','<md-dialog id="dialog-view" class="form-dialog-client add-media attachment-dialog" aria-label="New Message"><md-toolbar\n class="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><a \nclass="md-button layout-align-center-center layout-row md-default-theme" layout="row" layout-align="center center">\n<span class="ml-15" translate="{{ vm.title }}"></span></a><div class="absolute-right mr-10" layout="row  "><md-button \nclass="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</md-toolbar><form ng-if="vm.title === \'GLOBAL.NEW_BRANCH\'" id="site-content" class="content-card" \nng-class="vm.currentView" ng-include="\'app/main/apps/clients/dialogs/forms/forms-view-delegation.html\'"></form><form \nng-if="vm.title !== \'GLOBAL.NEW_BRANCH\'" id="site-content" flex class="md-inline-form content-card" \nng-class="vm.currentView" ng-include="\'app/main/apps/clients/dialogs/forms/forms-view-user.html\'"></form></md-dialog>');
$templateCache.put('app/main/apps/stakeholders/dialogs/forms/existing-user.html','<md-tabs fill-height-i style="height: 100%;" md-border-bottom><md-tab \nlabel="{{\'CLIENTS.COMPANY_PERSONEL\' | translate}}"><div style="max-height: 100%;" id="site-client"><div \nclass="search-input-wrapper border-bottom" layout="row" layout-align="start center"><md-icon class="mr-10 ml-20" \nmd-font-icon="icon-magnify"></md-icon><input id="search2" placeholder="{{\'CONTACTS.SEARCH_FOR_ANYONE\' | translate}}" \ntype="text" ng-model="searchText" class="flex h-60"></div><div style="max-height: 100%; overflow: hidden;" \nclass="content thread-list mail-list-pane p0" flex="" id="thread-list"><div id="list-content-data" \nng-style="{\'opacity\' : isLoading ? 0.5 : 1}"><div class="mail-list-item p0" \nng-repeat="user in vm.users | filter:{} | filter:searchText | filter:filterAlreadyAdded | orderBy: \'name\'" \nng-init="parentIndex= $index" md-no-ink ng-click="vm.selectUser(user)" \nng-class="{\'starred\': user.starred, \'selected\': vm.selectedContentID !== user.id_mailing_content, \'checked\': vm.isChecked(user)}">\n<div layout="row" layout-align="start center" flex="100" class="pl-15 pt-10 pb-10"><div class="info" flex \nlayout="column"><div class="name" layout="row"><div layout="row" layout-align="start center" flex="100"><div \nclass="avatar-wrapper"><img class="avatar s24" ng-src="{{vm.showUserImage(user)}}" ng-if="user.files.id"><div \nclass="avatar s24" ng-class="user.profile_color ? user.profile_color : \'md-blue-grey-300-bg\'" ng-if="!user.files.id" \nng-bind="user.first_name | capitalizeFirstLetter"></div></div><div layout="column" class="field mr-10 ml-10" flex><div>\n<strong class="grey-800-fg" ng-bind-html="user.first_name + \' \' + user.last_name"></strong></div><div><span \nstyle="font-weight: 300;">{{user.email}}</span></div></div></div></div><div></div></div></div></div></div></div>\n<md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" translate="" \ntranslate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" ng-if="$root.pagination_searchquery==true"><md-icon \nmd-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip hide show-gt-xs><span>Reset search</span></md-tooltip>\n</md-button></div></md-tab><md-tab ng-if="!vm.userLogued || vm.userLogued.user_type <6" \nlabel="{{\'CLIENTS.USER_ADMINISTRATORS\' | translate}}"><div style="max-height: 100%;" id="site-client"><div \nclass="search-input-wrapper border-bottom" layout="row" layout-align="start center"><md-icon class="mr-10 ml-20" \nmd-font-icon="icon-magnify"></md-icon><input id="search2" placeholder="{{\'CONTACTS.SEARCH_FOR_ANYONE\' | translate}}" \ntype="text" ng-model="searchTextAll" class="flex h-60"></div><div style="max-height: 100%; overflow: hidden;" \nclass="content thread-list mail-list-pane p0" flex="" id="thread-list"><div id="list-content-data" \nng-style="{\'opacity\' : isLoading ? 0.5 : 1}"><div class="mail-list-item p0" \nng-repeat="user in vm.usersAll | filter:searchTextAll | filter:filterAlreadyAdded | orderBy: \'name\'" \nng-init="parentIndex= $index" md-no-ink ng-click="vm.selectUser(user)" \nng-class="{\'starred\': user.starred, \'selected\': vm.selectedContentID !== user.id_mailing_content, \'checked\': vm.isChecked(user)}">\n<div layout="row" layout-align="start center" flex="100" class="pl-15 pt-10 pb-10"><div class="info" flex \nlayout="column"><div class="name" layout="row"><div layout="row" layout-align="start center" flex="100"><div \nclass="avatar-wrapper"><img class="avatar s24" ng-src="{{vm.showUserImage(user)}}" ng-if="user.files.id"><div \nclass="avatar s24" ng-class="user.profile_color ? user.profile_color : \'md-blue-grey-300-bg\'" ng-if="!user.files.id" \nng-bind="user.first_name | capitalizeFirstLetter"></div></div><div class="field mr-10 ml-10" flex><strong \nclass="grey-800-fg" ng-bind-html="user.first_name + \' \' + user.last_name"></strong></div></div></div></div></div></div>\n</div></div></div><md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" \ntranslate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nng-if="$root.pagination_searchquery==true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip \nhide show-gt-xs><span>Reset search</span></md-tooltip></md-button></md-tab></md-tabs>');
$templateCache.put('app/main/apps/stakeholders/dialogs/forms/external-user.html','<div id="forms" class="page-layout simple fullwidth doc-page forms scrollable" layout="column" ms-scroll><form \nname="wizardStep1" class="md-inline-form" ms-form-wizard-form novalidate><div \nng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" style="height: auto!important;" \nclass="items mt-10"><md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'text\' && field.field == \'3rd_party_company_name\'"><input type="{{field.type}}" \nng-model="field.value" placeholder="{{ field.translate | translate }}" ng-required="field.required">\n</md-input-container><md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'text\' && field.field != \'3rd_party_company_name\'"><input type="{{field.type}}" \nng-model="field.value" placeholder="{{ field.translate | translate }}" ng-required="field.required">\n</md-input-container><md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'password\'"><input type="{{field.type}}" ng-model="field.value" \nplaceholder="{{ field.translate | translate }}" ng-required="field.required"></md-input-container><md-input-container \nclass="item" ng-repeat="field in vm.fields" ng-if="!field.hidden && field.type == \'selector\'"><md-select \nng-disabled="vm.disabledPosition(field)" ng-if="field.field === \'position\'" ng-model="field.value" \nplaceholder="{{ field.translate | translate }}" required><md-option \nng-repeat="option in field.options track by $index" ng-value="option.id">{{option.field}}</md-option></md-select>\n</md-input-container></div><div ng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" \nlayout="row" flex><md-input-container flex class="item mv-0" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'picture\'"><div class="md-block"><div><div ngf-drop ngf-select \nng-model="vm.files" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="image/*" ngf-pattern="\'image/*\'"><div layout="column"><div flex translate="GLOBAL.DROP_HERE">\nDrop here or click to upload</div><div flex translate="GLOBAL.OR"></div><div flex><md-button \nclass="send-button md-accent md-raised" aria-label="Select files" translate="GLOBAL.SELECT_FILES"></md-button></div>\n</div></div><div ngf-no-file-drop translate="GLOBAL.FILE_DRAG_DROP"></div></div><div ng-repeat="f in vm.files" \nclass="ms-card" flex><div ng-if="!f.url" class="ms-card-content-wrapper"><div class="template-9"><div class="media" \nflex layout="row" layout-align="center center"><img ngf-thumbnail="!f.$error && f" class="image"></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><strong class="mr-5" ng-if="f.id">#{{f.id}}</strong> <span class="grey-500-fg"><span \nng-if="f.name">{{f.name}}</span></span></div></div></div><md-progress-linear md-mode="determinate" \nvalue="{{f.progress}}" ng-show="f.progress <100"></md-progress-linear></div></div><div ng-if="f.url" \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><img class="image" ng-src="{{vm.storagePrefix + f.url}}"></div><div class="header p-16" \nflex layout="row" layout-align="end center"><md-menu class="float-right"><md-button class="md-icon-button" \naria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item><md-button translate="GLOBAL.REMOVE" ng-click="vm.deleteAvatar(f)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item></md-menu-content>\n</md-menu></div><md-progress-linear md-mode="determinate" value="{{f.progress}}" ng-show="f.progress <100">\n</md-progress-linear></div></div></div></div></md-input-container></div><div \nng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" fill-width class="navigation pb-20" flex \nlayout="row" layout-align="center center"><md-button ng-if="vm.showJobDivision()" translate="GLOBAL.BACK" \nclass="md-raised md-warn" ng-click="vm.unSelectJobDivision()"></md-button><md-button ng-disabled="vm.isSendDisabled()" \ntranslate="GLOBAL.SEND" class="md-raised md-accent" ng-click="vm.sendForm($event)" ng-disabled="wizardStep1.$valid">\n</md-button></div><div class="text-center" ng-if="vm.user_type != undefined && vm.user_type != 4 && vm.user_type != 5">\n<h3>{{ \'CLIENTS.EDIT_USER_SECTION_USERS\' | translate}}</h3></div></form></div>');
$templateCache.put('app/main/apps/stakeholders/dialogs/forms/forms-view-delegation.html','<div id="forms" class="form-delegation page-layout simple fullwidth doc-page forms" layout="column"><div class="p0" \nlayout="column"><div layout="row"><ms-form-wizard class="popup" flex><form name="wizardStep1" class="md-inline-form" \nms-form-wizard-form novalidate><div class="items mt-30"><md-input-container class="item" \nng-repeat="field in vm.fields" ng-if="field.field !== \'id\' && field.field !== \'fullName\'"><input \nng-if="field.field !== \'phone\' && field.field !== \'email\' && field.field !== \'position\'" type="{{field.type}}" \nname="{{field.field}}" ng-model="field.value" placeholder="{{ field.translate | translate }}" required> <input \nng-if="field.field === \'phone\' || field.field === \'email\'" type="{{field.type}}" name="{{field.field}}" \nng-model="field.value" placeholder="{{ field.translate | translate }}"><div ng-messages="wizardStep1.email.$error" \nrole="alert" multiple="multiple"><div ng-message="pattern"><span translate="GLOBAL.EMAIL_VALID"></span></div></div>\n</md-input-container></div></form><div class="navigation pt-20" flex layout="row" layout-align="center center">\n<md-button translate="GLOBAL.SEND" class="md-raised md-warn" ng-click="vm.sendForm()" ng-disabled="wizardStep1.$valid">\n</md-button></div></ms-form-wizard></div></div></div>');
$templateCache.put('app/main/apps/stakeholders/dialogs/forms/forms-view-user.html','<div id="forms-position" class="page-layout simple fullwidth doc-page forms scrollable" layout="column" ms-scroll \nng-if="vm.showSelectPosition()"><form name="wizardStep2" class="md-inline-form" ms-form-wizard-form novalidate><h3 \nclass="mh-15" translate="CLIENTS.BEFORE_CONTINUE_PERSONEL"></h3><div class="items ph-15" layout="row">\n<md-input-container flex class="item" ng-if="vm.indexDivision != null" ng-show="vm.showSector()"><md-select \nng-model="vm.fields[vm.indexDivision].value" placeholder="{{ vm.fields[vm.indexDivision].translate | translate }}" \nrequired><md-option ng-repeat="option in vm.fields[vm.indexDivision].options track by $index" ng-value="option.id">\n{{option.field}}</md-option></md-select></md-input-container><md-input-container flex class="item" \nng-if="vm.indexPosition != null"><md-select ng-disabled="vm.disabledPosition(vm.fields[vm.indexPosition])" \nng-model="vm.fields[vm.indexPosition].value" placeholder="{{ vm.fields[vm.indexPosition].translate | translate }}" \nrequired><md-option ng-repeat="option in vm.fields[vm.indexPosition].options track by $index" ng-value="option.id">\n{{option.field}}</md-option></md-select></md-input-container></div></form><div class="navigation pt-20" flex \nlayout="row" layout-align="center center"><md-button translate="GLOBAL.SELECT" class="md-raised md-accent" \nng-click="vm.selectJobDivision()" ng-disabled="vm.divisionJobSelected()"></md-button></div></div><md-tabs \nfill-height-i md-border-bottom ng-if="!vm.showSelectPosition()"><md-tab label="{{\'CLIENTS.NEW_USER\' | translate}}"><div\n ng-include="\'app/main/apps/clients/dialogs/forms/new-user.html\'"></div></md-tab><md-tab \nlabel="{{\'CLIENTS.EXISTING_USER\' | translate}}"><div \nng-style="{\'height\': vm.showJobDivision() ? \'calc(100% - 58px)\' : \'100%\'}" \nng-include="\'app/main/apps/clients/dialogs/forms/existing-user.html\'"></div><div ng-if="vm.showJobDivision()" \nclass="navigation pt-10" flex layout="row" layout-align="center center"><md-button translate="GLOBAL.BACK" \nclass="md-raised md-warn" ng-click="vm.unSelectJobDivision()"></md-button></div></md-tab><md-tab \nlabel="{{\'CLIENTS.COMPANY_OR_EXTERNAL_STAFF\' | translate}}"><div \nng-include="\'app/main/apps/clients/dialogs/forms/external-user.html\'"></div></md-tab></md-tabs>');
$templateCache.put('app/main/apps/stakeholders/dialogs/forms/new-user.html','<div id="forms" class="page-layout simple fullwidth doc-page forms scrollable" layout="column" ms-scroll><form \nname="wizardStep1" class="md-inline-form" ms-form-wizard-form novalidate><div layout="row" \nng-if="!vm.showJobDivision() && !(vm.user_type != undefined && vm.user_type != 4 && vm.user_type != 5)  && !vm.type">\n<md-input-container flex class="item mh-15" ng-if="vm.indexDivision != null" ng-show="vm.showSector()"><md-select \nng-disabled="true" ng-model="vm.fields[vm.indexDivision].value" \nplaceholder="{{ vm.fields[vm.indexDivision].translate | translate }}" required><md-option \nng-repeat="option in vm.fields[vm.indexDivision].options track by $index" ng-value="option.id">{{option.field}}\n</md-option></md-select></md-input-container><md-input-container flex class="item mh-15" \nng-if="vm.indexPosition != null"><md-select ng-disabled="true" ng-model="vm.fields[vm.indexPosition].value" \nplaceholder="{{ vm.fields[vm.indexPosition].translate | translate }}" required><md-option \nng-repeat="option in vm.fields[vm.indexPosition].options track by $index" ng-value="option.id">{{option.field}}\n</md-option></md-select></md-input-container></div><div \nng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" style="height: auto!important;" \nclass="items mt-10"><md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'text\' && field.field != \'3rd_party_company_name\'"><input type="{{field.type}}" \nng-model="field.value" placeholder="{{ field.translate | translate }}" ng-required="field.required">\n</md-input-container><md-input-container class="item" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'password\'"><input type="{{field.type}}" ng-model="field.value" \nplaceholder="{{ field.translate | translate }}" ng-required="field.required"></md-input-container><md-input-container \nclass="item" ng-repeat="field in vm.fields" ng-if="!field.hidden && field.type == \'selector\'"><md-select \nng-disabled="vm.disabledPosition(field)" ng-if="field.field === \'position\'" ng-model="field.value" \nplaceholder="{{ field.translate | translate }}" required><md-option \nng-repeat="option in field.options track by $index" ng-value="option.id">{{option.field}}</md-option></md-select>\n</md-input-container></div><div ng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" \nlayout="row" flex><md-input-container flex class="item mv-0" ng-repeat="field in vm.fields" \nng-if="!field.hidden && field.type == \'picture\'"><div class="md-block"><div><div ngf-drop ngf-select \nng-model="vm.files" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="image/*" ngf-pattern="\'image/*\'"><div layout="column"><div flex translate="GLOBAL.DROP_HERE">\nDrop here or click to upload</div><div flex translate="GLOBAL.OR"></div><div flex><md-button \nclass="send-button md-accent md-raised" aria-label="Select files" translate="GLOBAL.SELECT_FILES"></md-button></div>\n</div></div><div ngf-no-file-drop translate="GLOBAL.FILE_DRAG_DROP"></div></div><div ng-repeat="f in vm.files" \nclass="ms-card" flex><div ng-if="!f.url" class="ms-card-content-wrapper"><div class="template-9"><div class="media" \nflex layout="row" layout-align="center center"><img ngf-thumbnail="!f.$error && f" class="image"></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><strong class="mr-5" ng-if="f.id">#{{f.id}}</strong> <span class="grey-500-fg"><span \nng-if="f.name">{{f.name}}</span></span></div></div></div><md-progress-linear md-mode="determinate" \nvalue="{{f.progress}}" ng-show="f.progress <100"></md-progress-linear></div></div><div ng-if="f.url" \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><img class="image" ng-src="{{vm.storagePrefix + f.url}}"></div><div class="header p-16" \nflex layout="row" layout-align="end center"><md-menu class="float-right"><md-button class="md-icon-button" \naria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.deleteAvatar(f)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-content></md-menu></div>\n<md-progress-linear md-mode="determinate" value="{{f.progress}}" ng-show="f.progress <100"></md-progress-linear></div>\n</div></div></div></md-input-container></div><div \nng-if="vm.user_type == undefined || vm.user_type == 4 || vm.user_type == 5" fill-width class="navigation pb-20" flex \nlayout="row" layout-align="center center"><md-button ng-if="vm.showJobDivision()" translate="GLOBAL.BACK" \nclass="md-raised md-warn" ng-click="vm.unSelectJobDivision()"></md-button><md-button ng-disabled="vm.isSendDisabled()" \ntranslate="GLOBAL.SEND" class="md-raised md-accent" ng-click="vm.sendForm($event)" ng-disabled="wizardStep1.$valid">\n</md-button></div><div class="text-center" ng-if="vm.user_type != undefined && vm.user_type != 4 && vm.user_type != 5">\n<h3 ng-bind-html="vm.translate(\'CLIENTS.EDIT_USER_SECTION_USERS\')"></h3></div></form></div>');
$templateCache.put('app/main/apps/stakeholders/dialogs/image/image-dialog.html','<md-dialog class="attachment-dialog" aria-label="New Task"><md-toolbar class="md-accent md-hue-2 md-default-theme"><div\n class="md-toolbar-tools"><div layout="row" hide show-gt-xs><a class="md-button" type="1" layout="row" \nlayout-align="center center" ng-click="vm.changeView(\'fotorama\')"><md-icon md-font-icon="icon-file-image-box" \nclass="s18 mr-5 ml-0"></md-icon><span translate="GLOBAL.PREVIEW">Preview Media</span></a></div><span flex></span><div \nlayout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content class="mediadialog-content" layout-fill><md-content flex class="content-card" \nng-class="vm.currentView" ng-include="vm.views[vm.currentView]" md-no-ink></md-content></md-dialog-content></md-dialog>');
$templateCache.put('app/main/apps/stakeholders/dialogs/media/media-clients-tinymce.html','<md-dialog class="attachment-dialog add-media" aria-label="New Message"><form class="md-inline-form"><md-toolbar \nclass="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><div layout="row" \nhide show-gt-xs><a class="md-button" type="1" layout="row" layout-align="center center" \nng-click="vm.changeViewTiny(\'1\')"><md-icon md-font-icon="icon-file-image-box" class="s18 mr-5 ml-0"></md-icon><span>\nAttached Media</span></a></div><div layout="row" hide-gt-xs show-xs><md-menu><md-button aria-label="Filters" \nng-click="$mdMenu.open($event)" translate="" translate-attr-aria-label="GLOBAL.FILTERS"><span layout="row" \nlayout-align="start center"><md-icon md-font-icon="icon-file-image-box" class="s18 mr-5 ml-0"></md-icon><span \nclass="ml-5">Images</span> <i class="icon-chevron-down s20 ml-5"></i></span></md-button><md-menu-content width="3">\n<md-menu-item><md-button type="photos" ng-click="vm.changeViewTiny(\'1\')"><div layout="row" \nlayout-align="space-between center"><div><md-icon md-font-icon="icon-file-image-box" class="s18"></md-icon><span>Images\n</span></div><i class="icon-check s16" ng-if="sortfield.titleId == sortable.titleId"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu></div><div layout="row"><md-button class="md-icon-button" \nng-click="vm.closeDialog()" aria-label="Close dialog" tranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon \nmd-font-icon="icon-close"></md-icon></md-button></div></div></md-toolbar><div flex \nng-include="\'app/main/apps/clients/dialogs/media/views/templates/toolbar-search.html\'"></div><md-dialog-content \nclass="mediadialog-content scrollable" layout-fill ms-scroll><treasure-overlay-spinner active="vm.loading"><div \nlayout="column" flex><md-content flex class="content-card" ng-class="vm.currentViewTiny" \nng-include="vm.viewsTiny[vm.currentViewTiny]" md-no-ink></md-content></div></treasure-overlay-spinner>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="space-between center" ng-if="!vm.loading"><div \nlayout="row" layout-align="start center"></div><div layout="row" layout-align="end right"><md-button \nng-click="vm.attachMediaTiny()" class="send-button md-accent md-raised" aria-label="Send" translate="GLOBAL.ADD_FILE" \ntranslate-attr-aria-label="GLOBAL.ADD_FILE">ADD</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/stakeholders/dialogs/media/media-clients.html','<md-dialog class="attachment-dialog add-media" aria-label="New Message"><form class="md-inline-form"><md-toolbar \nclass="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><div layout="row" \nhide show-gt-xs><a class="md-button" type="upload" layout="row" layout-align="center center" \nng-click="vm.changeView(\'upload\')"><md-icon md-font-icon="icon-import" class="s18 mr-5 ml-0"></md-icon><span \ntranslate="GLOBAL.UPLOAD"></span></a></div><div layout="row" hide-gt-xs show-xs><md-menu><md-button \naria-label="Filters" ng-click="$mdMenu.open($event)" translate="" translate-attr-aria-label="GLOBAL.FILTERS"><span \nlayout="row" layout-align="start center"><md-icon md-font-icon="icon-file-image-box" class="s18 mr-5 ml-0"></md-icon>\n<span class="ml-5" ng-if="vm.currentView===\'upload\'">Upload</span><i class="icon-chevron-down s20 ml-5"></i></span>\n</md-button><md-menu-content width="3"><md-menu-item><md-button type="import" ng-click="vm.changeView(\'import\')"><div \nlayout="row" layout-align="space-between center"><div><md-icon md-font-icon="icon-import" class="s18"></md-icon><span>\nUpload</span></div><i class="icon-check s16" ng-if="vm.currentView===\'upload\'"></i></div></md-button></md-menu-item>\n</md-menu-content></md-menu></div><div layout="row"><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog" tranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></div></md-toolbar><md-dialog-content ms-scroll flex class="content-card" \nng-class="vm.currentView" ng-include="vm.views[vm.currentView]"></md-dialog-content></form></md-dialog>');
$templateCache.put('app/main/apps/stakeholders/dialogs/new-stake-dialog/new-stake-dialog.html','<md-dialog class="new-client-dialog" aria-label="New Task"><form name="taskForm" class="md-inline-form" novalidate>\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between"><h1 \nclass="title" translate="STAKE.PROYECT_DATA"></h1><md-button class="md-icon-button" ng-click="vm.closeDialog()">\n<md-icon md-font-icon="icon-close" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content class="p-25" ms-scroll><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="STAKE.NAME"></label> <input type="text" ng-model="vm.company.stakeholder" required></md-input-container>\n</div><div layout="column" layout-gt-xs="row"><md-input-container flex><label translate="STAKE.INPUT"></label> <input \ntype="checkbox" ng-model="vm.company.input" value="1" name="input12" required></md-input-container><md-input-container \nflex><label translate="STAKE.OUTPUT"></label> <input ng-model="vm.company.output" type="checkbox" required>\n</md-input-container></div></md-dialog-content><md-dialog-actions class="footer" layout="row" layout-="end">\n<md-input-container flex layout="row" layout-align="end center"><md-button type="button" class="md-raised md-warn" \nng-click="vm.closeDialog()" translate="RISKCONFIG.CANCEL">Cancel</md-button><md-button \nng-disabled="!vm.company.stakeholder" type="submit" class="send-button md-accent md-raised" ng-click="vm.saveDialog()" \ntranslate="GLOBAL.SAVE">ADD</md-button></md-input-container></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/stakeholders/views/edit/edit-view.html','<div class="content thread-detail" layout="row" layout-align="center center" flex ng-if="!vm.edit"><div \nclass="no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-google-circles-communities" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="GLOBAL.SELECT_ITEM"></span></div></div><div class="form-wrapper md-whiteframe-1dp without-line" \nng-if="vm.edit"><form name="stakeForm" class="md-inline-form" novalidate><div><md-list class="edit_stake" role="list">\n<div><md-list-item class="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 class="grey-700.fg" translate="STAKE.NAME">\nNombre</h3><md-divider></md-divider></md-list-item></div></md-list></div><div layout="column" class="edit_stake">\n<md-input-container flex><input type="text" ng-model="vm.company.stakeholder" required></md-input-container></div><div>\n<md-list class="edit_stake" role="list"><div><md-list-item class="md-toolbar-tools grey-100-bg md-no-proxy _md"><h3 \nclass="grey-700.fg" translate="INPUT.DESCRIPTION">Description</h3><md-divider></md-divider></md-list-item></div>\n</md-list></div><div layout="column" class="edit_stake"><textarea class="font-size-161" \nng-model="vm.company.description" maxlength="50"></textarea><md-divider></md-divider></div><div layout="row" \nclass="edit_stake"><md-checkbox ng-model="vm.company.input" aria-label="Checkbox 1" ng-true-value="1" \nng-false-value="0"><label translate="STAKE.INPUT"></label></md-checkbox><span>\n&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp</span><md-checkbox ng-model="vm.company.output" \naria-label="Checkbox 1" ng-true-value="1" ng-false-value="0"><label translate="STAKE.OUTPUT"></label></md-checkbox>\n</div><md-dialog-actions class="footer" layout="row" layout-="end"><md-input-container flex layout="row" \nlayout-align="end center"><md-button type="button" class="md-raised md-warn" ng-click="vm.closeDialog()" \ntranslate="RISKCONFIG.CANCEL">Cancel</md-button><md-button ng-disabled="!vm.company.stakeholder" type="submit" \nclass="send-button md-accent md-raised" ng-click="vm.saveDialog(vm.company, $event)" translate="GLOBAL.SAVE">ADD\n</md-button></md-input-container></md-dialog-actions></form><div class="content thread-detail" layout="row" \nlayout-align="center center" flex ng-if="!vm.edit"><div class="no-thread-selected" layout="column" \nlayout-align="center center" flex><md-icon md-font-icon="icon-clipboard-account" class="s120 grey-400-fg"></md-icon>\n<span class="hint-text" translate="STAKE.SELECT_TASK"></span></div></div></div>');
$templateCache.put('app/main/apps/stakeholders/views/list/list-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="isLoadingP" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="no-threads" ng-if="!companySel" ng-hide="isLoadingP" translate="GLOBAL.NO_ITEMS"></div><div \nid="list-content-data" ng-if="!isLoadingP && companySel" ng-style="{\'opacity\' : isLoadingP ? 0.5 : 1}"><div \nclass="mail-list-item" ng-repeat="company in vm.stakeholder" ng-init="parentIndex = $index" md-no-ink \nng-click="vm.openCompany(company, $event)" \nng-class="{\'starred\': company.starred, \'selected\': vm.selectedContentID !== client.id_mailing_content, \'checked\': vm.isChecked(company)}">\n<div layout="row" layout-align="start center"><md-checkbox class="no-label" ng-checked="vm.isSelected(company)" \nng-click="vm.toggleSelectThread(company, $event)" aria-label="{{vm.isSelected(company) ? \'Deselect\' : \'Select\'}}">\n</md-checkbox><div class="info layout-column flex" flex="" layout="column"><div class="name text-truncate" \nstyle="padding-bottom: 0px; padding-top: 0px;" layout="row" layout-align="start center"><span>{{company.stakeholder}}\n</span></div></div></div></div><div \nng-if="!isLoading && pagination_total_pages > pagination_page && vm.companies.length > 0" class="load-more white p-30" \nlayout="row" layout-sm="column" layout-align="center center" layout-wrap=""><md-button \nng-click="pagination_nextPage(true)" class="md-raised">{{\'GLOBAL.LOAD_MORE\' |\xA0translate}}</md-button></div><div \nng-if="pagination_total_pages == pagination_page && pagination_page > 1" class="load-more white p-30" layout="row" \nlayout-sm="column" layout-align="center center" layout-wrap=""><div class="message" translate="GLOBAL.NO_MORE_ITEMS">\n</div></div></div>');
$templateCache.put('app/main/apps/stakeholders/views/list/nosplit-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.preview && !vm.readView" \nng-include="\'app/main/apps/clients/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row">\n<div class="content thread-detail mail-read-pane p0" flex="" id="thread-detail" ms-scroll="vm.msScrollOptions" \nng-if="vm.preview" ng-include="\'app/main/apps/clients/views/read/read-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="!vm.preview && !vm.readView" ng-include="\'app/main/apps/clients/views/list/list-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="vm.readView && vm.showForm" ng-include="\'app/main/apps/clients/views/read/form.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="vm.readView && !vm.showForm" ng-include="\'app/main/apps/clients/views/read/question-form.html\'"></div></div>');
$templateCache.put('app/main/apps/stakeholders/views/list/split-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.readView && !vm.preview" \nng-include="\'app/main/apps/stakeholders/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" \nlayout="row"><div class="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" \nid="thread-list" ng-if="!vm.readView && !vm.preview" \nng-include="\'app/main/apps/stakeholders/views/list/list-view.html\'"></div><div \nclass="content thread-detail mail-read-pane scrollable p0" flex="" id="thread-detail" ms-scroll="vm.msScrollOptions" \nng-include="\'app/main/apps/stakeholders/views/edit/edit-view.html\'" \nng-style="{\'margin-right\' : vm.edit ? \'0\' : \'-50%\'}"></div></div>');
$templateCache.put('app/main/apps/stakeholders/views/list/toolbar.html','<div layout="row" layout-align="start center"><md-checkbox class="no-label" \naria-label="{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}" \nng-checked="vm.selectedThreads.length > 0" ng-click="vm.toggleSelectThreads(vm.selectedThreads, vm.contents)">\n</md-checkbox><div ng-if="!vm.fromComplaint || vm.userLogued.user_type <= 2" class="divider-vertical" hide="" \nshow-gt-xs=""></div><md-button ng-if="!vm.fromComplaint || vm.userLogued.user_type <= 2" aria-label="NEW" \nclass="md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme" hide show-gt-sm \nng-click="vm.newForm($event)" translate="STAKE.NEW" type="button"></md-button><md-button \nng-if="!vm.fromComplaint || vm.userLogued.user_type <= 2" aria-label="NEW" \nclass="md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme z-index-0" hide-gt-sm \nng-click="vm.newForm($event)" type="button"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="divider-vertical" hide="" show-gt-xs=""></div><div aria-hidden="false" \nclass="action-buttons hide show-gt-xs layout-align-start-center layout-row" layout="row" layout-align="start center" \nng-show="vm.selectedThreads.length > 0"><md-button ng-click="vm.deleteStakeholder($ev)" aria-label="Delete" \nclass="md-icon-button" hide="" show-gt-xs="" translate=""><md-icon md-font-icon="icon-delete"></md-icon><md-tooltip \nhide show-gt-xs><span translate="GLOBAL.REMOVE"></span></md-tooltip></md-button><div class="divider-vertical" hide="" \nshow-gt-xs=""></div></div><ms-search-bar debounce="300" model-search="$root.pagination_searchquery" \non-result-click="vm.searchResultClick(item)" on-search="vm.search(query)" layout="row" layout-align="start center">\n</ms-search-bar><md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" \ntranslate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nng-if="$root.pagination_searchquery==true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip \nhide show-gt-xs><span>Reset search</span></md-tooltip></md-button><div class="divider-vertical" hide="" show-gt-xs="">\n</div><md-menu hide="" show-gt-xs="" ng-if="refGroupables.length>0"><button aria-label="Filters" \nclass="md-icon-button" ng-click="$mdMenu.open($event)" show-gt-xs="" translate="" \ntranslate-attr-aria-label="GLOBAL.FILTERS"><md-icon md-font-icon="icon-chevron-down"><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.GROUP_BY">Group</span></md-tooltip></md-icon></button><md-menu-content width="4"><md-menu-item \nng-repeat="sortfield in refGroupables"><md-button aria-label="All" ng-click="pagination_setOrderBy(sortfield)"><div \nlayout="row" layout-align="space-between center"><span>Group by {{sortfield.name}} </span><i class="icon-check s16" \nng-if="sortfield.titleId == sortable.titleId"></i></div></md-button></md-menu-item><md-menu-divider ng-if="groupable">\n</md-menu-divider><md-menu-item ng-if="groupable"><md-button aria-label="Remove group" \nng-click="pagination_resetOrderBy()"><md-icon md-font-icon="icon-close "></md-icon><span>Remove order</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div><div layout="row" layout-align="start center" \ntranslate-attr-aria-label="GLOBAL.REFRESH"><md-menu class="settings-menu" hide-gt-xs \nng-show="vm.selectedThreads.length > 0"><md-button aria-label="Settings" class="md-icon-button" \nng-click="$mdMenu.open($event)" translate="GLOBAL.SETTINGS" translate-attr-aria-label="GLOBAL.SETTINGS"><md-icon \nmd-font-icon="icon-dots-horizontal"></md-icon></md-button><md-menu-content><md-menu-item \nng-click="vm.deleteStakeholder($ev)" show="vm.selectedMail.length > 0 || vm.allChecked"><md-button \nng-click="vm.massActions(\'delete\')" aria-label="Delete" translate-aria-label="GLOBAL.DELETE"><md-icon \nmd-font-icon="icon-delete"></md-icon><span translate="GLOBAL.DELETE">Delete</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div>');
$templateCache.put('app/main/apps/stakeholders/views/read/form.html','<div id="forms" class="page-layout simple fullwidth doc-page forms" layout="column"><div class="p0" layout="column">\n<div layout="row"><ms-form-wizard class="no-margin" flex><div layout="row" layout-align="start center" flex="100" \nclass="layout-align-start-center layout-row flex-100 toolbar grey-100-bg colored-bg" ng-if="vm.idCompany"><a \nclass="pointer" ng-click="vm.closeForm()"><md-icon md-font-icon="icon-chevron-left"></md-icon></a><div \nclass="avatar-wrapper"><md-icon md-font-icon="icon-city"></md-icon></div><div class="field mr-10 ml-10 flex" flex="">\n<strong class="grey-800-fg ng-binding" ng-bind-html="vm.formWizard.company.name"></strong></div></div><md-tabs \nclass="height-tabs" md-dynamic-height md-selected="msWizard.selectedIndex" md-center-tabs="true"><md-tab><md-tab-label>\n<span class="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 0">1</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 0"><i class="icon-checkbox-blank-circle s16"></i> </span><span \nclass="ms-form-wizard-step-text" translate="GLOBAL.COMPANY_DATA"></span></span></md-tab-label><md-tab-body><form \nname="wizardStep1" ng-include="\'app/main/apps/clients/views/read/form-tabs/step-company.html\'" ms-form-wizard-form \nnovalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.idCompany"><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 1">2</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 1"><i class="icon-checkbox-blank-circle s16"></i> </span><span \nclass="ms-form-wizard-step-text" translate="CLIENTS.OPTIONS"></span></span></md-tab-label><md-tab-body><form \nname="wizardStep1b" ng-include="\'app/main/apps/clients/views/read/form-tabs/step-options.html\'" ms-form-wizard-form \nnovalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.idCompany"><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 2">3</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 2"><i class="icon-checkbox-blank-circle s16"></i> </span><span \nclass="ms-form-wizard-step-text" translate="GLOBAL.FILIATION_DATA"></span></span></md-tab-label><md-tab-body><div \nclass="navigation white-bg mb-50" flex layout="row" layout-align="center center"><div layout="row" flex \nlayout-align="start center"><md-button ng-if="vm.showForm" translate="GLOBAL.CLOSE" type="button" \nng-click="vm.closeForm()" class="md-raised md-warn hide-xs" aria-label="Cancel"></md-button><md-button \nng-if="vm.idCompany" translate="GLOBAL.SAVE" class="md-raised md-accent" ng-click="vm.nextStep(msWizard, true);" \nng-hide="msWizard.isLastStep()" ng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button></div><div \nclass="ml-auto" layout="row" flex layout-align="end center"><div flex layout="column" layout-align="center center" \nlayout-padding layout-margin ng-if="vm.loadingStep" class="loading-container"><md-progress-circular \nmd-mode="indeterminate" md-diameter="30"></md-progress-circular></div><md-button translate="GLOBAL.PREVIOUS" \nclass="md-raised md-accent" ng-click="vm.prevStep(msWizard)" ng-disabled="vm.previousStep(msWizard) || vm.loadingStep">\n</md-button><div class="steps"><span ng-repeat="form in msWizard.forms" \nng-class="{\'selected md-accent-bg\':msWizard.selectedIndex === $index}"></span></div><md-button translate="GLOBAL.NEXT" \nclass="md-raised md-accent" ng-click="vm.nextStep(msWizard)" ng-hide="msWizard.isLastStep()" \nng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button><md-button translate="GLOBAL.FINISH" \nclass="md-raised md-warn" ng-click="vm.sendForm(); msWizard.resetForm();" ng-show="msWizard.isLastStep()" \nng-disabled="msWizard.formsIncomplete()"></md-button></div></div><form name="wizardStep2" \nng-include="\'app/main/apps/clients/views/read/form-tabs/step-branchs.html\'" class="md-inline-form" ms-form-wizard-form \nnovalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.formWizard.main_branch.id"><md-tab-label><span \nclass="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 3">4</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 3"><i class="icon-checkbox-blank-circle s16"></i> </span><span \ntranslate="GLOBAL.COMPLIANCE_COMMITTEE" class="ms-form-wizard-step-text"></span></span></md-tab-label><md-tab-body>\n<form ng-include="\'app/main/apps/clients/views/read/form-tabs/step-people.html\'" name="wizardStep3" \nms-form-wizard-form novalidate></form></md-tab-body></md-tab><md-tab ng-disabled="!vm.formWizard.main_branch.id">\n<md-tab-label><span class="ms-form-wizard-step-label"><span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex != 4">5</span> <span class="ms-form-wizard-step-number md-accent-bg" \nng-if="msWizard.selectedIndex == 4"><i class="icon-checkbox-blank-circle s16"></i> </span><span \ntranslate="GLOBAL.BRANCH_PERSONNEL" class="ms-form-wizard-step-text"></span></span></md-tab-label><md-tab-body><form \nng-include="\'app/main/apps/clients/views/read/form-tabs/step-people-global.html\'" name="wizardStep4" \nms-form-wizard-form novalidate></form></md-tab-body></md-tab></md-tabs><div \nclass="navigation white-bg border-top mb-50" flex layout="row" layout-align="center center"><div layout="row" flex \nlayout-align="start center"><md-button hide-xs ng-if="vm.showForm" translate="GLOBAL.CLOSE" type="button" \nng-click="vm.closeForm()" class="md-raised md-warn hide-xs" aria-label="Cancel"></md-button><md-button \nng-if="vm.idCompany" translate="GLOBAL.SAVE" class="md-raised md-accent" ng-click="vm.nextStep(msWizard, true);" \nng-hide="msWizard.isLastStep()" ng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button></div><div \nclass="ml-auto" layout="row" flex layout-align="end center"><div flex layout="column" layout-align="center center" \nlayout-padding layout-margin ng-if="vm.loadingStep" class="loading-container"><md-progress-circular \nmd-mode="indeterminate" md-diameter="30"></md-progress-circular></div><md-button translate="GLOBAL.PREVIOUS" \nclass="md-raised md-accent" ng-click="vm.prevStep(msWizard)" ng-disabled="vm.previousStep(msWizard) || vm.loadingStep">\n</md-button><div class="steps"><span ng-repeat="form in msWizard.forms" \nng-class="{\'selected md-accent-bg\':msWizard.selectedIndex === $index}"></span></div><md-button translate="GLOBAL.NEXT" \nclass="md-raised md-accent" ng-click="vm.nextStep(msWizard)" ng-hide="msWizard.isLastStep()" \nng-disabled="msWizard.currentStepInvalid() || vm.loadingStep"></md-button><md-button translate="GLOBAL.FINISH" \nclass="md-raised md-warn" ng-click="vm.sendForm(); msWizard.resetForm();" ng-show="msWizard.isLastStep()" \nng-disabled="msWizard.formsIncomplete()"></md-button></div></div><div class="navigation" flex layout="row" \nlayout-align="center center"><md-button hide-xs ng-if="vm.showForm" translate="GLOBAL.CANCEL" type="button" \nng-click="vm.closeForm()" class="md-raised md-warn show-xs" aria-label="Cancel"></md-button></div></ms-form-wizard>\n</div></div></div>');
$templateCache.put('app/main/apps/stakeholders/views/read/preview-company.html','<div hide show-gt-sm class="toolbar grey-100-bg colored-bg" layout="row" layout-align="space-between center" scroll="">\n<div layout="row" layout-align="start center"><a class="pointer" ng-click="vm.goClients()"><md-icon \nmd-font-icon="icon-chevron-left"></md-icon></a><h2 translate="GLOBAL.COMPANY_DATA"></h2></div></div><div \nclass="md-whiteframe-1dp without-line scrollable preview" flex="100"><form name="vm.basicForm" class="md-inline-form" \nnovalidate><md-input-container class="md-block bb logotype"><img \nngf-thumbnail="!image.$error && image && vm.logoIsLoaded" class="img"> <img \nng-if="!image && imageUrl && vm.logoIsLoaded" src="{{imageUrl}}" class="img"><div \nng-if="!image && !imageUrl && vm.logoIsLoaded" class="avatar img" \nng-bind="vm.formWizard.company.name | capitalizeFirstLetter" ms-random-class="vm.colors"></div><h5 \nclass="padding inline-block m0">{{vm.formWizard.company.name}}</h5></md-input-container><md-input-container \nclass="md-block bb"><label>{{vm.getRegionLiteral(\'tax_ic_number\')}}</label><h5 class="padding">\n{{vm.formWizard.company.tax_id_number}}</h5></md-input-container><md-input-container class="md-block mg-bttm"><label \ntranslate="GLOBAL.SECTOR"></label><h5 class="padding">{{vm.getSectorById(vm.formWizard.company.sector_id).name}}</h5>\n</md-input-container><md-input-container class="md-block border separator mb-30"><h2 class="title" \ntranslate="CLIENTS.OPTIONS"></h2></md-input-container><md-input-container ng-if="vm.formWizard.company.description" \nclass="md-block bb options-preview"><label class="options-preview" translate="GLOBAL.DESCRIPTION"></label><h5 \nclass="padding mv-10">{{vm.formWizard.company.description}}</h5></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.executives_type" class="md-block bb mb-0 options-preview-select"><label \ntranslate="GLOBAL.EXECUTIVE_TYPE"></label><md-select class="disabled" ng-disabled="true" \nng-model="vm.formWizard.company.extra_data.executives_type"><md-option ng-value="1">Accionista \xFAnico</md-option>\n<md-option ng-value="2">Varios accionistas</md-option><md-option ng-value="3">Consejo de administraci\xF3n</md-option>\n<md-option ng-value="4">Administrador \xFAnico</md-option><md-option ng-value="5">Otros</md-option></md-select>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.capital" \nclass="md-block bb mb-0 options-preview-select"><label translate="GLOBAL.SOCIAL_CAPITAL"></label><md-select \nclass="disabled" ng-disabled="true" ng-model="vm.formWizard.company.extra_data.capital"><md-option ng-value="1">Capital\n</md-option><md-option ng-value="2">Aportaciones de socios</md-option><md-option ng-value="3">\nAumentos de capital recientes</md-option></md-select></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.capital_amount" class="md-block bb m0 options-preview"><label \nclass="options-preview" translate="GLOBAL.AMOUNT_CAPITAL"></label><h5 class="padding mv-10">\n{{vm.formWizard.company.extra_data.capital_amount}}</h5></md-input-container><md-input-container \nng-if="vm.formWizard.company.turnover_volume" class="md-block bb m0 options-preview"><label class="options-preview" \ntranslate="GLOBAL.BILLING_LAST_YEAR"></label><h5 class="padding mv-10">{{vm.formWizard.company.turnover_volume}}</h5>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.tax_options" \nclass="md-block bb mb-0 options-preview-select"><label>IVA</label><md-select class="disabled" ng-disabled="true" \nng-model="vm.formWizard.company.extra_data.tax_options"><md-option ng-value="1">Presentaci\xF3n trimestral</md-option>\n<md-option ng-value="2">Presentaci\xF3n mensual</md-option></md-select></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.annual_accounts" class="md-block bb mb-0 options-preview-select"><label>\nCuentas anuales</label><md-select class="disabled" ng-disabled="true" \nng-model="vm.formWizard.company.extra_data.annual_accounts"><md-option ng-value="1">Abreviadas</md-option><md-option \nng-value="2">Normales</md-option><md-option ng-value="3">Pymes</md-option><md-option ng-value="4">Mixtas</md-option>\n</md-select></md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.extra_data" \nclass="md-block bb mb-0 options-preview-select"><label>Auditor\xEDas</label><md-select class="disabled" \nng-disabled="true" ng-model="vm.formWizard.company.extra_data.audits"><md-option ng-value="1">Internas</md-option>\n<md-option ng-value="2">Externas</md-option><md-option ng-value="3">No aplica</md-option></md-select>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.iso_certification" \nclass="md-block bb mb-0 options-preview-select"><label>Certificaciones ISO</label><md-select class="disabled" \nng-disabled="true" ng-model="vm.formWizard.company.extra_data.iso_certification"><md-option ng-value="1">ISO 9001\n</md-option><md-option ng-value="2">ISO 14000</md-option><md-option ng-value="3">ISO 14001</md-option><md-option \nng-value="4">ISO 19600</md-option><md-option ng-value="5">ISO 22000</md-option><md-option ng-value="6">ISO 26000\n</md-option><md-option ng-value="7">ISO 27001</md-option><md-option ng-value="8">ISO 37001</md-option><md-option \nng-value="9">OHSAS 18001</md-option></md-select></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.collective_agreement" class="md-block bb m0 options-preview"><label \nclass="options-preview">Convenio Colectivo Aplicable</label><h5 class="padding mv-10">\n{{vm.formWizard.company.extra_data.collective_agreement}}</h5></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.insurance" class="md-block bb m0 options-preview"><label \nclass="options-preview">Seguros contratados</label><h5 class="padding mv-10">\n{{vm.formWizard.company.extra_data.insurance}}</h5></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.cnae" class="md-block bb m0 options-preview"><label class="options-preview" \ntranslate="GLOBAL.CNAE"></label><h5 class="padding mv-10">{{vm.formWizard.company.extra_data.cnae}}</h5>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.financing.length> 0" \nclass="md-block bb mb-0 options-preview-select"><label class="ph-15" fill-width translate="GLOBAL.FINANCING"></label>\n<md-select class="disabled" ng-disabled="true" multiple="{{false}}" \nng-model="vm.formWizard.company.extra_data.financing"><md-option ng-repeat="option in vm.financing_options" \nng-value="option">{{option.name}}</md-option></md-select></md-input-container><md-input-container \nng-if="vm.formWizard.company.extra_data.sector_regulations.length> 0" class="md-block bb mb-0 options-preview-select">\n<label class="ph-15" fill-width>Normativa Sectorial aplicable</label><md-select class="disabled" ng-disabled="true" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.sector_regulations"><md-option \nng-repeat="option in vm.sector_regulations_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container><md-input-container ng-if="vm.formWizard.company.extra_data.implemented_measures.length> 0" \nclass="md-block bb mb-20 options-preview-select"><label class="ph-15" fill-width>Medidas implementadas</label>\n<md-select class="disabled" ng-disabled="true" multiple="{{false}}" \nng-model="vm.formWizard.company.extra_data.implemented_measures"><md-option \nng-repeat="option in vm.implemented_measures_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container><md-input-container class="md-block border separator"><h2 class="title" \ntranslate="GLOBAL.MAIN_BRANCH"></h2></md-input-container><md-input-container class="md-block bb"><label \ntranslate="GLOBAL.NAME"></label><h5 class="padding">{{vm.formWizard.main_branch.name}}</h5></md-input-container>\n<md-input-container class="md-block bb"><label translate="GLOBAL.ADDRESS"></label><h5 class="padding">\n{{vm.formWizard.main_branch.address1}}</h5></md-input-container><md-input-container class="md-block bb"><label>\n{{vm.getRegionLiteral(\'city\')}}</label><h5 class="padding">{{vm.formWizard.main_branch.city}}</h5></md-input-container>\n<md-input-container class="md-block border separator"><h2 class="title" translate="GLOBAL.BRANCH"></h2>\n</md-input-container><div class="mail-list-pane s0" ng-if="vm.formWizard.branches && vm.formWizard.branches.length> 0">\n<div class="items" ng-repeat="branch in vm.formWizard.branches track by $index"><div layout="row" \nlayout-align="start center" flex="100" class="p-20 layout-align-start-center layout-row flex-100"><div layout="row" \nlayout-align="start center" flex="100" class="layout-align-start-center layout-row flex-100"><div \nclass="avatar-wrapper"><md-icon md-font-icon="icon-city"></md-icon></div><div class="field mr-10 ml-10 flex" flex="">\n<strong class="grey-800-fg ng-binding" ng-bind-html="branch.name"></strong><div class="field grey-600-fg ng-binding">\n<span ng-if="branch.city" ng-bind-html="branch.city"></span> <span ng-if="branch.city && branch.state">, </span><span \nng-if="branch.state" ng-bind-html="branch.state"></span></div></div></div></div></div></div></form></div>');
$templateCache.put('app/main/apps/stakeholders/views/read/preview-structure.html','<div hide show-gt-sm class="toolbar grey-100-bg colored-bg" layout="row" layout-align="space-between center" scroll="">\n<div layout="row" layout-align="start center"><h2>Organizaci\xF3n de la compa\xF1\xEDa</h2></div><div layout="row" \nlayout-align="end center" hide show-gt-sm><md-button translate="GLOBAL.EDIT" type="button" ng-click="vm.editCompany()" \nclass="md-raised md-accent" aria-label="Edit"></md-button></div><div layout="row" layout-align="end center" hide-gt-sm>\n<md-button type="button" ng-click="vm.editClient()" \nclass="md-accent md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" aria-label="Edit"><md-icon \nmd-font-icon="icon-plus"></md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.EDIT"></span></md-tooltip>\n</md-button></div></div><div class="without-line scrollable preview" flex="100"><div ivh-treeview="vm.tree" \nivh-treeview-options="vm.ivhOptions" class="treeview" \nivh-treeview-on-cb-change="vm.callback(ivhNode, ivhIsSelected, ivhTree)"><script type="text/ng-template">\n<div class="level-card" ng-if="node.type != \'user\'">\n                    <span ivh-treeview-toggle>\n                        <span ivh-treeview-twistie></span>\n                    </span>\n                    <md-icon md-font-icon="icon-city" ng-if="node.type == \'branch\'"></md-icon>\n                    <md-icon md-font-icon="icon-folder-account" ng-if="node.type == \'division\'"></md-icon>\n                    <md-icon md-font-icon="icon-worker" ng-if="node.type == \'job_position\'"></md-icon>\n                    <span class="ivh-treeview-node-label" ivh-treeview-toggle>{{trvw.label(node)}}</span>\n                </div>\n                <div class="level-card" ng-if="node.type == \'user\'">\n                    <div layout="row" layout-align="start center" flex="100">\n                        <div class="avatar-wrapper">\n                            <user-avatar User="node.user"/>\n                        </div>\n                        <div class="field mr-5 ml-5" flex>\n                            <strong class="grey-800-fg" ng-bind-html="node.user.first_name + \' \' + node.user.last_name"></strong>\n                        </div>\n                    </div>\n                </div>\n                <div ivh-treeview-children></div>\n</script></div></div>');
$templateCache.put('app/main/apps/stakeholders/views/read/question-form.html','<div id="forms" class="page-layout simple fullwidth doc-page forms" layout="column"><div ng-if="!vm.isQuestions"><div \nclass="page-layout carded left-sidenav" layout="row"><div class="content-wrapper" layout="row" flex><div \nclass="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-thumb-up" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="CLIENTS.CLIENT_CREATED_SUCCESSFULLY"></span><div layout-gt-xs="row" layout="column" \nlayout-align="center center" class="mt-15"><md-button translate="GLOBAL.BACK_CLIENT_LIST" type="button" \nng-click="vm.goClients()" class="md-raised md-warn" aria-label="Cancel"></md-button><md-button \nclass="md-raised md-accent" ui-sref="app.site_overview.questions.questionnaire" \ntranslate="GLOBAL.CONTINUE_WITH_QUESTIONS"></md-button></div></div></div></div></div></div><div ng-if="vm.isQuestions" \nclass="p0" layout="column"><div class="items outline"><div layout="column" class="selectors"><md-input-container><label\n class="al-left">Criterio</label><md-select ng-model="vm.allQuestions" ng-change="vm.goQuestions(msWizard)"><md-option \nng-value="true">Todas las preguntas</md-option><md-option ng-value="false">Preguntas del sector</md-option></md-select>\n</md-input-container></div><div layout="column" class="selectors"><md-input-container><label class="al-left">Branches\n</label><md-select multiple="{{true}}" ng-model="vm.branchQuestion"><md-option ng-repeat="branch in vm.branches" \nng-value="branch.id">{{branch.name}}</md-option></md-select></md-input-container></div></div><div layout="row" \nng-repeat="question in vm.questions"><div class="question"><div layout="column" layout-gt-xs="row"><md-input-container \nflex><h2>{{question.name}}</h2></md-input-container></div><div layout="column" layout-gt-xs="row"><md-radio-group \nng-model="question.value"><md-radio-button value="yes" class="inline">Si</md-radio-button><md-radio-button value="no" \nclass="inline ml">No</md-radio-button></md-radio-group></div></div></div><div class="navigation pt" flex layout="row" \nlayout-align="center center"><md-button translate="GLOBAL.CANCEL" class="md-raised md-warn" ng-click="vm.goClients()">\n</md-button><md-button translate="GLOBAL.SEND" class="md-raised md-warn" ng-click="vm.finishQuestion()" \nng-disabled="!vm.branchQuestion.length > 0"></md-button></div></div></div>');
$templateCache.put('app/main/apps/stakeholders/views/read/read-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="vm.loadingReadPane" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="fullheight" ng-if="!vm.loadingReadPane"><md-tabs class="fullheight"><md-tab label="Organizaci\xF3n"><content \nclass="" layout="row" ng-include="\'app/main/apps/clients/views/read/preview-company.html\'"></content></md-tab><md-tab \nlabel="Estructura"><content class="" layout="row" \nng-include="\'app/main/apps/clients/views/read/preview-structure.html\'"></content></md-tab><md-tab label="Edit" \nng-click="vm.editClient()"><content class="" ng-if="vm.showForm" layout="row" \nng-include="\'app/main/apps/clients/views/read/form.html\'"></content><content class="" ng-if="!vm.showForm" \nlayout="row" ng-include="\'app/main/apps/clients/views/read/question-form.html\'"></content></md-tab></md-tabs></div>');
$templateCache.put('app/main/apps/scrumboard/directives/ms-sb-add-card/ms-sb-add-card.html','<div class="ms-sb-add-card-button" layout="row" layout-align="start center" ng-hide="formActive"><div><i \nclass="icon-plus s20"></i></div><span translate="SB.ADD_A_CARD">Add a card</span></div><div \nclass="ms-sb-add-card-form-wrapper" ng-hide="!formActive"><form ng-submit="vm.addNewCard()" \nclass="ms-sb-add-card-form" layout="column"><md-input-container flex md-no-float><input placeholder="Card title" \ntype="text" autocomplete="off" ng-model="vm.newCardName" translate-attr-placeholder="SB.CARD_TITLE">\n</md-input-container><div layout="row" layout-align="space-between center"><md-button type="submit" \nclass="add-button md-accent md-raised" aria-label="add" translate-attr-aria-label="SB.ADD"><span translate="SB.ADD">Add\n</span></md-button><md-button ng-click="toggleForm()" class="cancel-button md-icon-button" aria-label="cancel" \ntranslate-attr-aria-label="SB.CANCEL"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></form></div>');
$templateCache.put('app/main/apps/scrumboard/dialogs/card/card-dialog.html','<md-dialog class="card-dialog" aria-label="Card Dialog" ng-cloak><md-toolbar class="md-accent" \nng-class="\'md-\'+vm.board.settings.color+\'-bg\'"><div class="md-toolbar-tools"><div class="due-date"><div \nng-if="!vm.card.due" moment-picker="vm.card.due" format="x" min-view="year" max-view="hour" start-view="month">\n<md-button class="md-icon-button" aria-label="Due date" translate translate-attr-aria-label="SB.DUE_DATE" \nng-click="$mdMenu.open($event)"><md-icon md-font-icon="icon-calendar"></md-icon></md-button></div></div><md-menu \nng-if="vm.card.due" md-offset="0 48" class="remove-due-date"><md-button class="md-icon-button" aria-label="Members" \nng-click="$mdMenu.open($event)"><md-icon md-font-icon="icon-calendar"></md-icon></md-button><md-menu-content \nclass="remove-due-date-menu-content" width="4" ms-scroll><md-menu-item><md-button ng-click="vm.card.due = \'\'" \naria-label="remove due date" translate-attr-aria-label="SB.REMOVE_DUE_DATE"><md-icon md-font-icon="icon-delete">\n</md-icon><span translate="SB.REMOVE_DUE_DATE">Remove Due Date</span></md-button></md-menu-item></md-menu-content>\n</md-menu><md-menu md-offset="0 48" class="labels"><md-button class="md-icon-button" aria-label="Label" translate \ntranslate-attr-aria-label="SB.LABEL" ng-click="vm.labelTabIndex = 0;$mdMenu.open($event)"><md-icon md-menu-origin \nmd-font-icon="icon-label-outline"></md-icon></md-button><md-menu-content class="labels-menu-content" width="4" \nms-scroll><md-tabs md-selected="vm.labelTabIndex" md-dynamic-height><md-tab><md-tab-body><md-menu-item>\n<md-input-container class="no-errors-spacer" md-no-float><input placeholder="Search labels..." type="text" \nng-model="vm.labelSearchText" autocomplete="off" translate-attr-palceholder="SB.SEARCH_LABELS"></md-input-container>\n</md-menu-item><md-menu-item class="label" ng-repeat="label in vm.labels | filter: vm.filterLabel"><md-button \nclass="label-toggle-button" md-prevent-menu-close ng-class="\'md-\'+label.color+\'-bg\'" \nng-click="vm.toggleInArray(label.id, vm.card.idLabels)" aria-label="Toggle Label" translate \ntranslate-attr-aria-label="SB.TOGGLE_LABEL"><div layout="row" layout-align="space-between center"><span>{{label.name}}\n</span> <i ng-if="vm.exists(label.id, vm.card.idLabels)" class="icon-check s16"></i></div></md-button><md-button \nclass="md-icon-button label-edit-button" md-prevent-menu-close \nng-click="vm.editLabelId = label.id; vm.labelTabIndex = 2" aria-label="Edit Label" translate \ntranslate-attr-aria-label="SB.EDIT_LABEL"><md-icon md-font-icon="icon-pencil" class="s16"></md-icon></md-button>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button class="add-label-button" \nmd-prevent-menu-close ng-click="vm.labelTabIndex = 1"><md-icon md-font-icon="icon-plus-circle-outline"></md-icon><span \ntranslate="SB.ADD_NEW_LABEL">Add new label</span></md-button></md-menu-item></md-tab-body></md-tab><md-tab>\n<md-tab-body><div class="add-label-tab-content"><div class="header" layout="row" layout-align="space-between center">\n<md-button class="md-icon-button" md-prevent-menu-close ng-click="vm.labelTabIndex = 0" aria-label="Back" translate \ntranslate-attr-aria-label="SB.BACK"><i class="icon-arrow-left s20"></i></md-button><span flex \ntranslate="SB.CREATE_LABEL">Create Label</span></div><div class="content" layout="column" layout-align="start stretch">\n<form ng-submit="vm.addNewLabel(); vm.labelTabIndex = 0" layout="column"><md-input-container class="no-errors-spacer" \nmd-no-float><input placeholder="Label Name" type="text" ng-model="vm.newLabelName" translate \ntranslate-attr-placeholder="SB.LABEL_NAME"></md-input-container><div class="label-color-picker" layout="row" \nlayout-wrap><label class="color" ng-repeat="(palette, hues) in vm.palettes" \nng-style="{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}" layout="column" \nlayout-align="center center"><input class="ng-hide" type="radio" ng-model="vm.newLabelColor" ng-value="palette" \naria-label="{{palette}}"> <i class="icon-check s18" ng-if="vm.newLabelColor === palette"></i></label></div><md-button \ntype="submit" md-prevent-menu-close class="create-button md-accent md-raised" aria-label="Create" translate \ntranslate-attr-aria-label="SB.CREATE"><span translate="SB.CREATE">Create</span></md-button></form></div></div>\n</md-tab-body></md-tab><md-tab><md-tab-body><div class="edit-label-tab-content"><div class="header" layout="row" \nlayout-align="space-between center"><md-button class="md-icon-button" md-prevent-menu-close \nng-click="vm.labelTabIndex = 0" aria-label="back" translate translate-attr-aria-label="SB.BACK"><i \nclass="icon-arrow-left s20"></i></md-button><span flex translate="SB.EDIT_LABEL">Edit Label</span></div><div \nclass="content" layout="column" layout-align="start stretch"><md-input-container class="no-errors-spacer" md-no-float>\n<input placeholder="Label Name" type="text" ng-model="vm.board.labels.getById(vm.editLabelId).name" translate \ntranslate-attr-placeholder="SB.LABEL_NAME"></md-input-container><div class="label-color-picker" layout="row" \nlayout-wrap><label class="color" ng-repeat="(palette, hues) in vm.palettes" \nng-style="{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}" layout="column" \nlayout-align="center center"><input class="ng-hide" type="radio" \nng-model="vm.board.labels.getById(vm.editLabelId).color" ng-value="palette" aria-label="{{palette}}"> <i \nng-if="vm.board.labels.getById(vm.editLabelId).color === palette" class="icon-check s18"></i></label></div><div \nlayout="row" layout-align="end center" flex><md-button class="remove-button md-icon-button" type="submit" \nmd-prevent-menu-close ng-click="vm.removeLabel(); vm.labelTabIndex=0" aria-label="remove" translate \ntranslate-attr-aria-label="SB.REMOVE"><md-icon md-font-icon="icon-delete"></md-icon></md-button></div></div></div>\n</md-tab-body></md-tab></md-tabs></md-menu-content></md-menu><md-menu md-offset="0 48" class="members"><md-button \nclass="md-icon-button" aria-label="Members" ng-click="$mdMenu.open($event)"><md-icon md-menu-origin \nmd-font-icon="icon-account-multiple"></md-icon></md-button><md-menu-content class="members-menu-content" width="4" \nms-scroll><md-menu-item><md-input-container class="no-errors-spacer" md-no-float><input \nplaceholder="Search members..." autocomplete="off" type="text" ng-model="vm.memberSearchText" translate \ntranslate-attr-placeholder="SB.SEARCH_MEMBERS"></md-input-container></md-menu-item><md-menu-item class="member" \nng-repeat="member in vm.members  | filter: vm.filterMember"><md-button \nng-click="vm.toggleInArray(member.id, vm.card.idMembers)" md-prevent-menu-close aria-label="toggle member" translate \ntranslate-attr-aria-label="SB.TOGGLE_MEMBER"><div layout="row" layout-align="space-between center"><div layout="row" \nlayout-align="start center"><img alt="{{ member.name }}" ng-src="{{ member.avatar }}" class="avatar"><p \nclass="member-name">{{ member.name }}</p></div><i class="icon-check s16" \nng-if="vm.exists(member.id, vm.card.idMembers)"></i></div></md-button></md-menu-item></md-menu-content></md-menu>\n<md-button class="md-icon-button" ng-click="" aria-label="Attachment" translate \ntranslate-attr-aria-label="SB.ATTACHMENT"><md-icon md-font-icon="icon-attachment"></md-icon></md-button><md-menu \nmd-offset="0 48px" class="checklist"><md-button class="md-icon-button" ng-click="$mdMenu.open($event)" \naria-label="checklist" translate translate-attr-aria-label="SB.CHECKLIST"><md-icon md-menu-origin \nmd-font-icon="icon-checkbox-marked"></md-icon></md-button><md-menu-content class="checklist-menu-content" width="4">\n<form ng-submit="vm.createCheckList()" layout="column" layout-align="start end"><md-input-container \nclass="no-errors-spacer" md-no-float><input placeholder="Checklist Title" autocomplete="off" type="text" \nng-model="vm.newCheckListTitle" translate translate-attr-placeholder="SB.CHECKLIST_TITLE"></md-input-container>\n<md-button type="submit" class="md-raised md-accent" aria-label="Add Checklist" translate \ntranslate-attr-aria-label="SB.ADD_CHECKLIST"><span translate="SB.ADD_CHECKLIST">Add Checklist</span></md-button></form>\n</md-menu-content></md-menu><md-menu md-offset="0 48px" class="subscribe"><md-button class="md-icon-button" \nng-click="$mdMenu.open($event)" aria-label="Subscribe" translate translate-attr-aria-label="SB.SUBSCRIBE"><md-icon \nmd-menu-origin ng-if="vm.card.subscribed" md-font-icon="icon-eye"></md-icon><md-icon md-menu-origin \nng-if="!vm.card.subscribed" md-font-icon="icon-eye-off"></md-icon></md-button><md-menu-content \nclass="subscribe-menu-content" width="4"><md-menu-item><md-button ng-click="vm.card.subscribed = !vm.card.subscribed" \naria-label="Subscribed" translate translate-attr-aria-label="SB.SUBSCRIBED"><span ng-if="!vm.card.subscribed" \ntranslate="SB.SUBSCRIBE">Subscribe</span> <span ng-if="vm.card.subscribed" translate="SB.UNSUBSCRIBE">Unsubscribe\n</span></md-button></md-menu-item></md-menu-content></md-menu><md-menu md-offset="0 48px" class="options"><md-button \nclass="md-icon-button" ng-click="$mdMenu.open($event)" aria-label="Options" translate \ntranslate-attr-aria-label="SB.OPTIONS"><md-icon md-menu-origin md-font-icon="icon-dots-horizontal"></md-icon>\n</md-button><md-menu-content class="options-menu-content" width="4"><md-menu-item><md-button \nng-click="vm.removeCard()" aria-label="Remove Card" translate translate-attr-aria-label="SB.REMOVE_CARD"><md-icon \nmd-font-icon="icon-delete" md-menu-align-target></md-icon><span translate="SB.REMOVE_CARD">Remove Card</span>\n</md-button></md-menu-item></md-menu-content></md-menu><span flex></span><md-button class="md-icon-button" \nng-click="vm.closeDialog()" aria-label="Close Dialog" translate translate-attr-aria-label="SB.CLOSE_DIALOG"><md-icon \nmd-font-icon="icon-close"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout="row" \nlayout-align="space-between start"><div layout="column" layout-align="start start"><div class="card-breadcrumb" \nlayout="row" layout-align="start center"><span>{{vm.board.name}}</span> <i class="icon-menu-right"></i> <span>\n{{vm.getCardList().name}}</span></div><div layout="row" layout-align="start center"><md-icon \nng-if="vm.card.subscribed" class="card-subscribe s18" md-font-icon="icon-eye"></md-icon><div class="card-name"><span \neditable-text="vm.card.name">{{vm.card.name}}</span></div></div></div><div ng-if="vm.card.due" class="due-date" \nlayout="row" layout-align="start center"><div class="picker day-picker" moment-picker="vm.card.due" format="x" \nmin-view="year" max-view="month" start-view="month"><div layout="row" layout-align="start center"><i \nclass="s18 icon icon-calendar"></i> <span>{{vm.card.due | date:\'mediumDate\'}}</span></div></div><div \nclass="picker hour-picker" moment-picker="vm.card.due" format="x" min-view="day" max-view="hour" start-view="day"><div \nlayout="row" layout-align="start center"><i class="s18 icon icon-clock"></i> <span>{{vm.card.due | date:\'shortTime\'}}\n</span></div></div><div class="remove-due-date" layout="row" layout-align="center center" ng-click="vm.card.due = \'\'">\n<i class="s16 icon icon-close"></i></div></div></div><div class="description"><md-input-container class="md-block">\n<label translate="SB.DESCRIPTION">Description</label> <textarea ng-model="vm.card.description" columns="1" \nmd-maxlength="150" rows="5"></textarea></md-input-container></div><div class="sections"><div \nng-if="vm.card.idLabels[0] || vm.card.idMembers[0]" class="section" layout="row"><div ng-if="vm.card.idLabels[0]" flex \nclass="labels"><div class="section-header" layout="row" layout-align="start center"><i class="icon-label-outline s18">\n</i> <span class="section-title" translate="SB.LABELS">Labels</span></div><div class="section-content"><md-chips \nclass="label-chips" ng-model="vm.card.idLabels" md-autocomplete-snap md-require-match="true" \nmd-transform-chip="$chip.id"><md-autocomplete md-selected-item="vm.selectedLabel" md-search-text="vm.searchLabelText" \nmd-items="label in vm.labelQuerySearch(vm.searchLabelText)" md-item-text="label.name" placeholder="Search for a label">\n<span md-highlight-text="vm.searchLabelText">{{label.name}}</span></md-autocomplete><md-chip-template \nclass="label-chip" ng-class="\'md-\'+vm.board.labels.getById($chip).color+\'-bg\'"><span>\n{{vm.board.labels.getById($chip).name}}</span></md-chip-template><button md-chip-remove class="md-primary"><md-icon \nmd-font-icon="icon-close" class="s18"></md-icon></button></md-chips></div></div><div ng-if="vm.card.idMembers[0]" flex \nclass="members"><div class="section-header" layout="row" layout-align="start center"><i \nclass="icon-account-multiple s18"></i> <span class="section-title" translate="SB.MEMBERS">Members</span></div><div \nclass="section-content"><md-chips class="member-chips" ng-model="vm.card.idMembers" md-autocomplete-snap \nmd-require-match="true" md-transform-chip="$chip.id"><md-autocomplete md-selected-item="vm.selectedMember" \nmd-search-text="vm.searchText" md-items="member in vm.memberQuerySearch(vm.searchText)" md-item-text="member.name" \nplaceholder="Search for a member"><span md-highlight-text="vm.searchText">{{member.name}}</span></md-autocomplete>\n<md-chip-template class="member-chip"><img class="member-chip-avatar" \nng-src="{{vm.board.members.getById($chip).avatar}}"><md-tooltip>{{vm.board.members.getById($chip).name}}</md-tooltip>\n</md-chip-template><button md-chip-remove class="md-primary"><md-icon md-font-icon="icon-close" class="s18"></md-icon>\n</button></md-chips></div></div></div><div ng-if="vm.card.attachments[0]" class="section"><div class="attachments"><div\n class="section-header" layout="row" layout-align="start center"><i class="icon-attachment s18"></i> <span \nclass="section-title" translate="SB.ATTACHMENTS">Attachments</span></div><div class="section-content"><div \nclass="attachment" ng-repeat="item in vm.card.attachments" ng-switch="item.type"><div ng-switch-when="image" \nlayout="row"><div class="attachment-preview md-whiteframe-2dp" ng-style="{\'background-image\': \'url({{item.src}})\'}">\n</div><div class="attachment-content" layout="column"><div layout="row" layout-align="start center"><span \nclass="attachment-name">{{item.name}}</span> <i ng-if="vm.card.idAttachmentCover === item.id" \nclass="icon-star yellow-700-fg attachment-is-cover s18"></i></div><span class="attachment-time">{{item.time}}</span>\n<md-menu><md-button class="md-raised attachment-actions-button" ng-click="$mdMenu.open($event)" \naria-label="attachment actions"><span layout="row" layout-align="center center"><span translate="SB.ACTIONS">Actions\n</span> <i class="icon-chevron-down s20"></i></span></md-button><md-menu-content><md-menu-item><md-button \nng-click="vm.toggleCoverImage(item.id)" aria-label="Toggle Cover Image" translate \ntranslate-attr-aria-label="SB.TOGGLE_COVER_IMAGE"><span ng-if="vm.card.idAttachmentCover !== item.id" translate \ntranslate="SB.MAKE_COVER">Make Cover</span> <span ng-if="vm.card.idAttachmentCover === item.id" translate \ntranslate="SB.REMOVE_COVER">Remove Cover</span></md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.removeAttachment(item)" aria-label="Remove Attachment" translate \ntranslate-attr-aria-label="SB.REMOVE_ATTACHMENT"><span translate="SB.REMOVE_ATTACHMENT">Remove Attachment</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div></div><div ng-switch-when="link" layout="row"><div \nclass="attachment-preview md-whiteframe-2dp" layout="column" layout-align="center center"><span translate="SB.LINK">\nLINK</span></div><div class="attachment-content" layout="column"><span class="attachment-url">{{item.url}}</span> <span\n class="attachment-time">{{item.time}}</span></div></div></div><md-button class="add-attachment-button" \naria-label="add attachment"><div layout="row" layout-align="start center"><i class="icon-plus s20"></i> <span \ntranslate="SB.ADD_AN_ATTACHMENT">Add an attachment</span></div></md-button></div></div></div><div \nng-if="vm.card.checklists" class="section" ng-repeat="checklist in vm.card.checklists"><div class="checklist"><div \nclass="section-header" layout="row" layout-align="start center"><i class="icon-checkbox-marked s18"></i> <span flex \nclass="section-title" editable-text="checklist.name">{{checklist.name}}</span><md-menu \nmd-position-mode="target-right target" class="options"><md-button class="md-icon-button" \nng-click="$mdMenu.open($event)" aria-label="options" translate translate-attr-aria-label="SB.OPTIONS"><md-icon \nmd-menu-origin md-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content class="options-menu-content" \nwidth="4"><md-menu-item><md-button ng-click="vm.removeChecklist(checklist)" aria-label="Remove Checklist" translate \ntranslate-attr-aria-label="SB.REMOVE_CHECKLIST"><md-icon md-font-icon="icon-delete"></md-icon><span \ntranslate="SB.REMOVE_CHECKLIST">Remove Checklist</span></md-button></md-menu-item></md-menu-content></md-menu></div>\n<div class="section-content"><div class="checklist-progress" layout="row" layout-align="start center"><span \nclass="checklist-progress-value">{{checklist.checkItemsChecked}} / {{checklist.checkItems.length}}</span>\n<md-progress-linear class="md-accent checklist-progressbar" md-mode="determinate" \nvalue="{{100 * checklist.checkItemsChecked / checklist.checkItems.length}}"></md-progress-linear></div><div \nclass="check-items"><div class="check-item" ng-repeat="checkItem in checklist.checkItems"><md-checkbox \nng-model="checkItem.checked" ng-change="vm.updateCheckedCount(checklist)" aria-label="{{checkItem.name}}">\n{{checkItem.name}}</md-checkbox></div></div><form name="newCheckItemForm" class="new-check-item-form" \nng-submit="vm.addCheckItem(vm[checklist.id].newCheckItem, checklist);vm[checklist.id].newCheckItem = \'\'" layout="row" \nlayout-align="start center"><md-input-container class="no-errors-spacer" flex><label layout="row" \nlayout-align="center"><i class="icon-plus s18"></i> <span translate="SB.ADD_AN_ITEM">Add an item</span></label> <input \ntype="text" autocomplete="off" ng-model="vm[checklist.id].newCheckItem"></md-input-container><md-button type="submit" \nclass="md-raised md-accent" aria-label="Add" translate translate-attr-aria-label="SB.ADD"><span translate="SB.ADD">Add\n</span></md-button></form></div></div></div><div class="section"><div class="comments"><div class="section-header" \nlayout="row" layout-align="start center"><i class="icon-comment s18"></i> <span class="section-title" \ntranslate="SB.COMMENTS">Comments</span></div><div class="section-content"><form name="cardCommentForm" \nng-submit="vm.addNewComment(vm.newCommentText); vm.newCommentText =\'\'" class="comment new-comment" layout="column" \nlayout-align="start" no-validate><div layout="row"><img class="comment-member-avatar" \nsrc="assets/images/avatars/profile.jpg"><md-input-container flex md-no-float><textarea ms-scroll \nplaceholder="Write a comment.." ng-model="vm.newCommentText" required translate \ntranslate-attr-placeholder="SB.WRITE_A_COMMENT"></textarea></md-input-container></div><div layout="row" \nlayout-align="end center"><md-button type="submit" class="md-raised md-accent" \nng-disabled="cardCommentForm.$invalid || cardCommentForm.$pristine" aria-label="Add"><span translate="SB.ADD">Add\n</span></md-button></div></form><div class="comment" layout="row" ng-repeat="comment in vm.card.comments"><img \nclass="comment-member-avatar" ng-src="{{vm.board.members.getById(comment.idMember).avatar}}"><div layout="column"><div \nclass="comment-member-name">{{vm.board.members.getById(comment.idMember).name}}</div><div class="comment-bubble">\n{{comment.message}}</div><div class="comment-time secondary-text">{{comment.time}}</div></div></div></div></div></div>\n<div ng-if="vm.card.activities[0]" class="section"><div class="activities"><div class="section-header" layout="row" \nlayout-align="start center"><i class="icon-format-list-bulleted s18"></i> <span class="section-title" \ntranslate="SB.ACTIVITY">Activity</span></div><div class="section-content"><div class="activity" layout="row" \nlayout-align="start center" ng-repeat="activity in vm.card.activities"><img class="activity-member-avatar" \nng-src="{{vm.board.members.getById(activity.idMember).avatar}}"><div class="activity-member-name">\n{{vm.board.members.getById(activity.idMember).name}}</div><div class="activity-message">{{activity.message}}</div><div \nclass="activity-time secondary-text">{{activity.time}}</div></div></div></div></div></div></md-dialog-content>\n</md-dialog>');
$templateCache.put('app/main/apps/scrumboard/sidenavs/settings/settings-sidenav.html','<md-toolbar class="md-accent" ng-class="\'md-\'+vm.board.settings.color+\'-bg\'"><div class="md-toolbar-tools"><md-button \nng-hide="vm.selectedMenu === \'Settings\'" class="md-icon-button" ng-click="vm.selectedMenu = \'Settings\'" \naria-label="back" translate translate-attr-aria-label="SB.BACK"><md-icon md-font-icon="icon-arrow-left"></md-icon>\n</md-button><span flex class="menu-title">{{vm.selectedMenu}}</span></div></md-toolbar><md-content \nng-show="vm.selectedMenu === \'Settings\'" class="animate-slide-right settings" ms-scroll ms-sidenav-helper><md-list>\n<md-list-item class="item" ng-click="vm.selectedMenu = \'Board Color\'"><md-icon md-font-icon="icon-format-color-fill" \nclass="s18"></md-icon><p class="title" translate="SB.BOARD_COLOR">Board Color</p></md-list-item><md-list-item \nclass="item" ng-click="vm.board.settings.cardCoverImages = !vm.board.settings.cardCoverImages"><md-icon \nmd-font-icon="icon-image-area" class="s18"></md-icon><p flex class="title" translate="SB.CARD_COVER_IMAGES">\nCard Cover Images</p><md-icon ng-show="vm.board.settings.cardCoverImages" md-font-icon="icon-check" class="s18">\n</md-icon></md-list-item><md-list-item class="item" \nng-click="vm.board.settings.subscribed = !vm.board.settings.subscribed"><md-icon md-font-icon="icon-eye" class="s18">\n</md-icon><p flex class="title" translate="SB.SUBSCRIBE">Subscribe</p><md-icon ng-show="vm.board.settings.subscribed" \nmd-font-icon="icon-check" class="s18"></md-icon></md-list-item><md-list-item class="item"><md-icon \nmd-font-icon="icon-content-copy" class="s18"></md-icon><p class="title" translate="SB.COPY_BOARD">Copy Board</p>\n</md-list-item><md-list-item class="item"><md-icon md-font-icon="icon-delete" class="s18"></md-icon><p class="title" \ntranslate="SB.DELETE_BOARD">Delete Board</p></md-list-item><md-divider></md-divider><md-list-item class="item" \nng-click="vm.selectedMenu = \'Labels\'" aria-label="inbox"><md-icon md-font-icon="icon-label" class="s18"></md-icon><p \nclass="title" translate="SB.LABELS">Labels</p></md-list-item><md-list-item class="item" \nng-click="vm.selectedMenu = \'Members\'" aria-label="inbox"><md-icon md-font-icon="icon-account-multiple" class="s18">\n</md-icon><p class="title" translate="SB.MEMBERS">Members</p></md-list-item></md-list></md-content><md-content \nng-show="vm.selectedMenu === \'Board Color\'" class="animate-slide-left board-color-selection"><div layout="column" \nlayout-fill ng-include="\'app/main/apps/scrumboard/sidenavs/settings/menus/color/color-menu.html\'" \nng-controller="ColorMenuController as vm"></div></md-content><md-content ng-show="vm.selectedMenu === \'Labels\'" \nclass="animate-slide-left labels"><div layout="column" layout-fill \nng-include="\'app/main/apps/scrumboard/sidenavs/settings/menus/labels/labels-menu.html\'" \nng-controller="LabelsMenuController as vm"></div></md-content><md-content ng-show="vm.selectedMenu === \'Members\'" \nclass="animate-slide-left members"><div layout="column" layout-fill \nng-include="\'app/main/apps/scrumboard/sidenavs/settings/menus/members/members-menu.html\'" \nng-controller="MembersMenuController as vm"></div></md-content>');
$templateCache.put('app/main/apps/scrumboard/sidenavs/filters/filters-sidenav.html','<md-toolbar class="md-accent" ng-class="\'md-\'+vm.board.settings.color+\'-bg\'"><div class="md-toolbar-tools"><span flex \nclass="menu-title" translate="SB.FILTER_CARDS">Filter Cards</span><md-button ng-if="vm.filteringIsOn()" \nng-click="vm.clearFilters()" class="md-icon-button" aria-label="clear filters"><md-icon \nmd-font-icon="icon-filter-remove"></md-icon><md-tooltip><span translate="SB.CLEAR_FILTER">Clear Filters</span>\n</md-tooltip></md-button></div></md-toolbar><md-content class="" ms-scroll><md-list><md-subheader class="md-no-sticky" \ntranslate="SB.FILTER_BY_CARD_NAME">Filter by Card Name</md-subheader><md-list-item><input flex \nplaceholder="Type Card Name" type="text" ng-model="vm.cardFilters.name" translate \ntranslate-attr-placeholder="SB.TYPE_CARD_NAME"></md-list-item><md-divider></md-divider><md-subheader \nclass="md-no-sticky" translate="SB.FILTER_BY_LABELS">Filter by Labels</md-subheader><md-list-item class="label" \nng-repeat="label in vm.labels" ng-click="vm.toggleInArray(label.id, vm.cardFilters.labels)"><md-icon \nmd-font-icon="icon-label" ng-class="label.color+\'-fg\'" class="label-icon"></md-icon><p>{{label.name}}</p><i \nclass="icon-check s16" ng-if="vm.exists(label.id, vm.cardFilters.labels)"></i></md-list-item><md-divider></md-divider>\n<md-subheader class="md-no-sticky" translate="SB.FILTER_BY_MEMBERS">Filter by Members</md-subheader><md-list-item \nclass="member" ng-repeat="member in vm.members" ng-click="vm.toggleInArray(member.id, vm.cardFilters.members)" \naria-label="Toggle Member"><img alt="{{ member.name }}" ng-src="{{ member.avatar }}" class="md-avatar"><p \nclass="member-name">{{ member.name }}</p><i class="icon-check s16" \nng-if="vm.exists(member.id, vm.cardFilters.members)"></i></md-list-item></md-list></md-content>');
$templateCache.put('app/main/apps/scrumboard/views/board/board-view.html','<div id="board" ng-class="vm.board.settings.color+\'-100-bg\'" ui-sortable="vm.sortableListOptions" \nng-model="vm.board.lists" layout="row"><div class="list-wrapper" ng-repeat="list in vm.board.lists track by list.id">\n<div class="list md-whiteframe-1dp" layout="column"><div class="list-header" layout="row" \nlayout-align="space-between center"><div class="list-header-name"><span editable-text="list.name">{{list.name}}</span>\n</div><md-menu md-offset="0 48px" class="options list-header-option-button"><md-button class="md-icon-button" \nng-click="$mdMenu.open($event)" aria-label="Options" translate translate-attr-aria-label="SB.OPTIONS"><md-icon \nmd-menu-origin md-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content class="options-menu-content" \nwidth="4"><md-menu-item><md-button ng-click="vm.removeList($event,list)" aria-label="Remove List" translate \ntranslate-attr-aria-label="SB.REMOVE_LIST"><md-icon md-font-icon="icon-delete" md-menu-align-target></md-icon><span \ntranslate="SB.REMOVE_LIST">Remove List</span></md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass="list-content" layout="column"><div class="list-cards" ui-sortable="vm.sortableCardOptions" \nng-model="list.idCards" ms-scroll><div ng-if="cardId" class="list-card md-whiteframe-2dp" \nng-repeat="cardId in list.idCards | filter: vm.cardFilter track by $index" \nng-click="vm.openCardDialog($event, cardId)"><div \nng-if="vm.board.settings.cardCoverImages && vm.board.cards.getById(cardId).idAttachmentCover" class="list-card-cover">\n<img \nng-src="{{vm.board.cards.getById(cardId).attachments.getById(vm.board.cards.getById(cardId).idAttachmentCover).src}}">\n</div><div class="list-card-details"><div class="list-card-sort-handle"><md-icon md-font-icon="icon-cursor-move" \nclass="icon s16"></md-icon></div><div ng-if="vm.board.cards.getById(cardId).idLabels.length > 0" \nclass="list-card-labels" layout="row" layout-wrap><span class="list-card-label" \nng-class="\'md-\'+vm.board.labels.getById(labelId).color+\'-bg\'" \nng-repeat="labelId in vm.board.cards.getById(cardId).idLabels"><md-tooltip>{{vm.board.labels.getById(labelId).name}}\n</md-tooltip></span></div><div class="list-card-name">{{vm.board.cards.getById(cardId).name}}</div><div \nng-if="vm.board.cards.getById(cardId).due || vm.board.cards.getById(cardId).checkItems" class="list-card-badges" \nlayout="row" layout-align="start center"><span class="badge due-date" \nng-class="{\'overdue\': vm.isOverdue(vm.board.cards.getById(cardId).due)}" ng-if="vm.board.cards.getById(cardId).due" \nlayout="row" layout-align="start center"><i class="icon-clock s16"></i> <span>\n{{vm.board.cards.getById(cardId).due | date:\'mediumDate\'}}</span> </span><span \nng-if="vm.board.cards.getById(cardId).checkItems" class="badge check-items" \nng-class="{\'completed\': vm.board.cards.getById(cardId).checkItemsChecked === vm.board.cards.getById(cardId).checkItems}" \nlayout="row" layout-align="start center"><i class="icon-checkbox-marked-circle s16"></i> <span>\n{{vm.board.cards.getById(cardId).checkItemsChecked}}</span> <span>/</span> <span>\n{{vm.board.cards.getById(cardId).checkItems}}</span></span></div><div \nng-if="vm.board.cards.getById(cardId).idMembers.length > 0" class="list-card-members" layout="row"><div \nclass="list-card-member" ng-repeat="memberId in vm.board.cards.getById(cardId).idMembers"><img \nclass="list-card-member-avatar" ng-src="{{vm.board.members.getById(memberId).avatar}}"><md-tooltip><div class="name">\n{{ vm.board.members.getById(memberId).name}}</div></md-tooltip></div></div></div><div class="list-card-footer" \nlayout="row" layout-align="space-between center"><div layout="row" layout-align="start center"><span \nng-if="vm.board.cards.getById(cardId).subscribed" class="list-card-footer-item" layout="row" \nlayout-align="start center"><i class="icon-eye s18"></i> </span><span \nng-if="vm.board.cards.getById(cardId).description !== \'\'" class="list-card-footer-item" layout="row" \nlayout-align="start center"><i class="icon-document s18"></i></span></div><div layout="row" layout-align="end center">\n<span class="list-card-footer-item" ng-if="vm.board.cards.getById(cardId).attachments" layout="row" \nlayout-align="start center"><i class="icon-attachment s18"></i> <span class="value">\n{{vm.board.cards.getById(cardId).attachments.length}}</span> </span><span class="list-card-footer-item" \nng-if="vm.board.cards.getById(cardId).comments" layout="row" layout-align="start center"><i class="icon-comment s18">\n</i> <span class="value">{{vm.board.cards.getById(cardId).comments.length}}</span></span></div></div></div></div></div>\n<div class="list-footer"><ms-sb-add-card ms-list-id="list.id"></ms-sb-add-card></div></div></div><div \nclass="new-list-wrapper"><div class="list new-list md-whiteframe-1dp"><span editable-text="vm.newListName" \ne-form="newListForm" onaftersave="vm.addNewList()"></span><md-button class="new-list-form-button" \nng-click="newListForm.$show()" ng-hide="newListForm.$visible"><div layout="row" layout-align="start center"><i \nclass="icon-plus md-red-bg"></i> <span translate="SB.ADD_A_LIST">Add a list</span></div></md-button></div></div></div>');
$templateCache.put('app/main/apps/scrumboard/views/boards/boards-view.html','<div id="boards" class="md-accent-bg" layout="column" flex><div id="board-selector" layout="column" \nlayout-align="start center" flex><h1 translate="SB.SCRUMBOARD_APP">Scrumboard App</h1><div class="board-list" \nlayout="row" layout-align="center center" layout-wrap><div class="board-list-item" ng-repeat="board in vm.boardList" \nui-sref="app.scrumboard.boards.board({id:board.id, uri:board.uri})" layout="column" layout-align="center center">\n<md-icon md-font-icon="icon-trello" class="icon s64"></md-icon><div class="board-name">{{board.name}}</div></div><div \nclass="board-list-item add-new-board" layout="column" layout-align="center center" \nui-sref="app.scrumboard.boards.addBoard"><md-icon md-font-icon="icon-plus-circle" class="icon s64"></md-icon><div \nclass="board-name" translate="SB.ADD_NEW_BOARD">Add new board</div></div></div></div></div>');
$templateCache.put('app/main/apps/scrumboard/views/calendar/calendar-view.html','<div id="board-calendar" class="page-layout simple right-sidenav" flex layout="row" \nng-class="vm.board.settings.color+\'-100-bg\'"><md-sidenav class="sidenav scheduled-tasks-sidenav md-sidenav-left" \nmd-is-locked-open="$mdMedia(\'gt-md\')" md-component-id="scheduled-tasks-sidenav" \nng-include="\'app/main/apps/scrumboard/views/calendar/sidenavs/scheduled-tasks/scheduled-tasks-sidenav.html\'" ms-scroll \nms-sidenav-helper></md-sidenav><div id="calendar" class="md-whiteframe-2dp" flex layout="column" \nng-class="vm.currentMonthShort"><div class="calendar-header" layout="row" layout-align="space-between center" \nlayout-xs="column"><md-button hide-gt-md class="md-icon-button" ng-click="vm.toggleSidenav(\'scheduled-tasks-sidenav\')" \naria-label="Scheduled Cards Sidenav"><md-icon md-font-icon="icon-calendar-clock"></md-icon><md-tooltip><span \ntranslate="SB.SCHEDULED_CARDS">Scheduled Cards</span></md-tooltip></md-button><div class="" layout="row" \nlayout-align="start center"><md-button class="md-icon-button arrow" ng-click="vm.calendar.prev()" \naria-label="Previous" translate translate-attr-aria-label="SB.PREVIOUS"><md-icon md-font-icon="icon-chevron-left">\n</md-icon></md-button><div class="title">{{vm.calendarView.title}}</div><md-button class="md-icon-button arrow" \nng-click="vm.calendar.next()" aria-label="Next" translate translate-attr-aria-label="SB.NEXT"><md-icon \nmd-font-icon="icon-chevron-right"></md-icon></md-button></div><div><md-button class="md-icon-button" \nng-click="vm.calendar.today()" aria-label="Today" translate translate-attr-aria-label="SB.TODAY"><md-icon \nmd-font-icon="icon-calendar-today"></md-icon><md-tooltip><span translate="SB.TODAY">Today</span></md-tooltip>\n</md-button><md-button class="md-icon-button" ng-click="vm.calendar.changeView(\'agendaDay\')" aria-label="Day" \ntranslate translate-attr-aria-label="SB.DAY"><md-icon md-font-icon="icon-view-day"></md-icon><md-tooltip><span \ntranslate="SB.DAY">Day</span></md-tooltip></md-button><md-button class="md-icon-button" \nng-click="vm.calendar.changeView(\'agendaWeek\')" aria-label="Week" translate translate-attr-aria-label="SB.WEEK">\n<md-icon md-font-icon="icon-view-week"></md-icon><md-tooltip><span translate="SB.WEEK">Week</span></md-tooltip>\n</md-button><md-button class="md-icon-button" ng-click="vm.calendar.changeView(\'month\')" aria-label="Month" translate \ntranslate-attr-aria-label="SB.MONTH"><md-icon md-font-icon="icon-view-module"></md-icon><md-tooltip><span \ntranslate="SB.MONTH">Month</span></md-tooltip></md-button></div></div><div class="calendar-main" ms-scroll flex \nui-calendar="vm.calendarUiConfig.calendar" ng-model="vm.eventSources" calendar="main"></div></div></div>');
$templateCache.put('app/main/apps/staff/views/complaints/edit-preview.html','<div class="content thread-detail" layout="row" layout-align="center center" flex \nng-if="!vm.staffSelected && !vm.staffNew && !vm.loadingReadPane"><div class="no-thread-selected" layout="column" \nlayout-align="center center" flex><md-icon md-font-icon="icon-clipboard-account" class="s120 grey-400-fg"></md-icon>\n<span class="hint-text" translate="STAFF.SELECT_USER"></span></div></div><div \nng-if="vm.staffSelected || vm.staffNew || vm.loadingReadPane"><md-list class="pv-20 ph-8 border-bottom"><md-list-item \nclass="main-item" style="padding-left: 0px;" flex layout="row" layout-align="start center"><div layout="row" \nlayout-align="start center"><div class="main-read"><div class="avatar-container"><user-avatar user="vm.staffSelected">\n</div></div><div class="main-read"><h1 class="name"><strong ng-bind-html="vm.staffSelected.first_name"></strong> \n<strong ng-bind-html="vm.staffSelected.last_name"></strong></h1><p><span class="font-size-16 text-truncate" \nng-bind-html="vm.staffSelected.email"></span></p></div></div></md-list-item></md-list></div><md-list-item flex="100" \non="field.type" role="listitem" class="first-item-list"><div class="text-truncate" flex="100"><div class="field"><p \nclass="grey-500-fg font-size-14" translate="STAFF.FIRSTNAME"></p><p class="font-size-16 text-truncate" \nng-bind-html="vm.staffSelected.first_name"></p></div></div></md-list-item><md-list-item flex="100" on="field.type" \nrole="listitem" class="item-list"><div class="text-truncate" flex="100"><div class="field"><p \nclass="grey-500-fg font-size-14" translate="STAFF.LASTNAME"></p><p class="font-size-16 text-truncate" \nng-bind-html="vm.staffSelected.last_name"></p></div></div></md-list-item><md-list-item flex="100" on="field.type" \nrole="listitem" class="item-list"><div class="text-truncate" flex="100"><div class="field"><p \nclass="grey-500-fg font-size-14">{{vm.getRegionLiteral(\'id_number\')}}</p><p class="font-size-16 text-truncate" \nng-bind-html="vm.staffSelected.id_number"></p></div></div></md-list-item><md-list-item flex="100" on="field.type" \nrole="listitem" class="item-list"><div class="text-truncate" flex="100"><div class="field"><p \nclass="grey-500-fg font-size-14" translate="STAFF.EMAIL"></p><p class="font-size-16 text-truncate" \nng-bind-html="vm.staffSelected.email"></p></div></div></md-list-item><md-list-item flex="100" on="field.type" \nrole="listitem" class="item-list"><div class="text-truncate" flex="100"><div class="field"><p \nclass="grey-500-fg font-size-14" translate="STAFF.PHONE"></p><p class="font-size-16 text-truncate" \nng-bind-html="vm.staffSelected.phone"></p></div></div></md-list-item><md-list-item flex="100" on="field.type" \nrole="listitem" class="item-list" ng-if="vm.staffSelected[\'3rd_party_company_name\']"><div class="text-truncate" \nflex="100"><div class="field"><p class="grey-500-fg font-size-14" translate="STAFF.3RD_PARTY_COMPANY"></p><p \nclass="font-size-16 text-truncate" ng-bind-html="vm.staffSelected[\'3rd_party_company_name\']"></p></div></div>\n</md-list-item>');
$templateCache.put('app/main/apps/staff/views/list/list-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="isLoading" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="no-threads" ng-if="!vm.staff" ng-hide="isLoading" translate="GLOBAL.NO_ITEMS"></div><div \nid="list-content-data" style="height: 100%;" ng-style="{\'opacity\' : isLoading ? 0.5 : 1}"><div class="mail-list-item" \nng-repeat="item in vm.staff | filter: vm.search | filter: global.search" ng-init="parentIndex = $index" md-no-ink \nng-click="vm.openStaff(item)" \nng-class="{\'starred\': item.starred, \'selected\': vm.staffSelected.id === item.id, \'checked\': vm.isSelected(item)}"><div \nlayout="row" layout-align="start center"><md-checkbox ng-if="item.user_type != 1" class="no-label" \nng-checked="vm.isSelected(item)" ng-click="vm.toggleSelectThread(item, $event)" \naria-label="{{vm.isSelected(item) ? \'Deselect\' : \'Select\'}}"></md-checkbox><div class="avatar-wrapper"><user-avatar \nuser="item"></div><div class="info layout-column flex" flex="" layout="column"><div class="name text-truncate" \nlayout="row" layout-align="start center"><span>{{item.first_name}}</span> <span>{{item.last_name}}</span> <span \nng-if="vm.companySelected.id !== 1 && item[\'3rd_party_company_name\']">({{item[\'3rd_party_company_name\']}})</span></div>\n<div class="details text-truncate" layout="row" layout-align="start center"><span>{{item.email}}</span></div><div \nclass="details text-truncate user-role-label" layout="row" layout-align="start center" ng-switch="item.user_type">\n<md-icon ng-switch-when="2" md-font-icon="icon-account-key" class="s16 icon-tight"></md-icon><md-icon \nng-switch-when="3" md-font-icon="icon-account-multiple" class="s16 icon-tight"></md-icon><md-icon ng-switch-when="14" \nmd-font-icon="icon-shield" class="s16 icon-tight"></md-icon><md-icon ng-switch-when="6" \nmd-font-icon="icon-account-circle" class="s16 icon-tight"></md-icon><span ng-switch-when="2" \ntranslate="GLOBAL.ADMINISTRATOR"></span> <span ng-switch-when="3" translate="STAFF.COMPANY_ADMIN"></span> <span \nng-switch-when="14" translate="STAFF.RSII"></span> <span ng-switch-when="6" translate="STAFF.CANAL_STAFF"></span></div>\n</div><div class="info flex" flex="" layout-align="center end" layout="column"><div layout="row" \nlayout-align="start center"><md-input-container ng-if="item.user_type != 1" class="md-block mt-0 mb-0"><button \nng-if="item.enabled" class="md-icon-button md-button"><md-icon md-font-icon="icon-checkbox-marked-circle" \nclass="on green-fg s24" ng-click="vm.toggleStaffStatusEdit(\'enabled\',item)"></md-icon></button> <button \nng-if="!item.enabled" class="md-icon-button md-button"><md-icon md-font-icon="icon-checkbox-blank-circle-outline" \nclass="off red-fg s24" ng-click="vm.toggleStaffStatusEdit(\'enabled\',item)"></md-icon></button></md-input-container>\n</div></div></div></div><div ng-if="!isLoading && pagination_total_pages > pagination_page && vm.staff.length > 0" \nclass="load-more white p-30" layout="row" layout-sm="column" layout-align="center center" layout-wrap=""><md-button \nng-click="pagination_nextPage(true)" class="md-raised">{{\'GLOBAL.LOAD_MORE\' |\xA0translate}}</md-button></div><div \nng-if="pagination_total_pages == pagination_page && pagination_page > 1" class="load-more white p-30" layout="row" \nlayout-sm="column" layout-align="center center" layout-wrap=""><div class="message" translate="GLOBAL.NO_MORE_ITEMS">\n</div></div><div ng-if="!vm.staff || vm.staff.length == 0" class="content-wrapper fullheight" layout="row" flex \nng-hide="vm.isLoading"><div class="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-timelapse" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="STAFF.THERE_ARE_NO_USERS_WITH_THIS_FILTERS"></span></div></div></div></div>');
$templateCache.put('app/main/apps/staff/views/list/nosplit-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.staffSelected && !vm.staffNew" \nng-include="\'app/main/apps/staff/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row"><div\n class="content thread-detail mail-read-pane p0 scrollable" flex="" id="thread-detail" ms-scroll="vm.msScrollOptions" \nng-if="vm.staffSelected || vm.staffNew" ng-include="\'app/main/apps/staff/views/edit/edit-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="!vm.staffSelected && !vm.staffNew" ng-include="\'app/main/apps/staff/views/list/list-view.html\'"></div></div>');
$templateCache.put('app/main/apps/staff/views/list/split-view.html','<div class="toolbar" layout="row" layout-align="space-between center" \nng-include="\'app/main/apps/staff/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row"><div\n class="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-include="\'app/main/apps/staff/views/list/list-view.html\'"></div><div \nclass="content thread-detail mail-read-pane p0" flex="" id="thread-detail" \nng-include="\'app/main/apps/staff/views/edit/edit-view.html\'"></div></div>');
$templateCache.put('app/main/apps/staff/views/list/toolbar.html','<div layout="row" layout-align="start center"><md-checkbox class="no-label" \naria-label="{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}" \nng-checked="vm.selectedThreads.length > 0" ng-click="vm.toggleSelectThreads(vm.selectedThreads, vm.contents)">\n</md-checkbox><div class="divider-vertical" hide="" show-gt-xs=""></div><md-button aria-label="NEW" \nclass="md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme" hide show-gt-sm \nng-click="vm.newStaff($event)" translate="GLOBAL.NEW" type="button"></md-button><md-button aria-label="NEW" \nclass="md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme z-index-0" hide-gt-sm \nng-click="vm.newStaff($event)" type="button"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="divider-vertical" hide="" show-gt-xs=""></div><div aria-hidden="false" \nclass="action-buttons hide show-gt-xs layout-align-start-center layout-row" layout="row" layout-align="start center" \nng-show="vm.selectedThreads.length > 0"><md-button ng-click="vm.deleteStaff($event)" aria-label="Delete" \nclass="md-icon-button" hide="" show-gt-xs="" translate=""><md-icon md-font-icon="icon-delete"></md-icon><md-tooltip \nhide show-gt-xs><span translate="GLOBAL.REMOVE"></span></md-tooltip></md-button><div class="divider-vertical" hide="" \nshow-gt-xs=""></div></div><md-menu-bar ng-if="!vm.fromComplaint" id="user-menu" class="p0"><md-menu \nmd-position-mode="left bottom"><md-button class="user-button m0" ng-click="$mdMenu.open()" aria-label="User settings" \ntranslate translate-attr-aria-label="TOOLBAR.USER_SETTINGS"><div layout="row" layout-align="space-between center"><span\n ng-if="vm.branchSelected" class="username">{{vm.branchSelected.name}}</span> <span ng-if="!vm.branchSelected" \nclass="username" translate="GLOBAL.ALL_BRANCHES"></span><md-icon md-font-icon="icon-chevron-down" class="icon s16">\n</md-icon></div></md-button><md-menu-content width="3" class="clients"><md-menu-item class="md-indent"><div \nclass="search-input-wrapper" layout="row" layout-align="start center"><label for="search"><md-icon \nmd-font-icon="icon-magnify"></md-icon></label><md-input-container md-no-float class="m-0"><input id="search" \nplaceholder="{{\'RISK.SEARCH_FOR_BRANCH\' |\xA0translate}}" type="text" ng-model="vm.searchBranchText"></md-input-container>\n</div></md-menu-item><div class="results"><md-menu-item ng-if="vm.searchBranchText == \'\'" \nng-click="vm.selectBranch(null)" class="md-indent bar-client"><div><md-icon md-font-icon="icon-account" \nclass="icon s16"></md-icon><button class="btn-clients" translate="GLOBAL.ALL_BRANCHES"></button></div></md-menu-item>\n<md-menu-item ng-click="vm.selectBranch(branch)" class="md-indent bar-client" \nng-repeat="branch in vm.companyBranches | filter:vm.searchBranchText"><div ng-if="branch"><md-icon \nmd-font-icon="icon-account" class="icon s16"></md-icon><button class="btn-clients">{{branch.name}}</button></div>\n</md-menu-item></div></md-menu-content></md-menu></md-menu-bar><div ng-if="!vm.fromComplaint" class="divider-vertical" \nhide="" show-gt-xs=""></div><md-menu-bar ng-if="!vm.fromComplaint" id="user-menu" class="p0"><md-menu \nmd-position-mode="left bottom"><md-button class="user-button m0" ng-click="$mdMenu.open()" aria-label="User settings" \ntranslate translate-attr-aria-label="TOOLBAR.USER_SETTINGS"><div layout="row" layout-align="space-between center"><span\n ng-if="vm.divisionSelected" class="username">{{vm.divisionSelected.name}}</span> <span ng-if="!vm.divisionSelected" \nclass="username" translate="GLOBAL.ALL_DIVISIONS"></span><md-icon md-font-icon="icon-chevron-down" class="icon s16">\n</md-icon></div></md-button><md-menu-content width="3" class="clients"><md-menu-item class="md-indent"><div \nclass="search-input-wrapper" layout="row" layout-align="start center"><label for="search"><md-icon \nmd-font-icon="icon-magnify"></md-icon></label><md-input-container md-no-float class="m-0"><input id="search" \nplaceholder="{{\'RISK.SEARCH_FOR_DIVISION\' |\xA0translate}}" type="text" ng-model="vm.searchDivisionText">\n</md-input-container></div></md-menu-item><div class="results"><md-menu-item ng-if="vm.searchDivisionText == \'\'" \nng-click="vm.selectDivision(null)" class="md-indent bar-client"><div><md-icon md-font-icon="icon-account" \nclass="icon s16"></md-icon><button class="btn-clients" translate="GLOBAL.ALL_DIVISIONS"></button></div></md-menu-item>\n<md-menu-item ng-click="vm.selectDivision(division)" class="md-indent bar-client" \nng-repeat="division in vm.divisions | filter:vm.searchDivisionText"><div ng-if="division"><md-icon \nmd-font-icon="icon-account" class="icon s16"></md-icon><button class="btn-clients">{{division.name}}</button></div><div\n ng-if="!division"><md-icon md-font-icon="icon-account" class="icon s16"></md-icon><button class="btn-clients" \ntranslate="GLOBAL.ALL_DIVISIONS"></button></div></md-menu-item></div></md-menu-content></md-menu></md-menu-bar><div \nng-if="!vm.fromComplaint" class="divider-vertical" hide="" show-gt-xs=""></div><ms-search-bar debounce="300" \nmodel-search="$root.pagination_searchquery" on-result-click="vm.searchResultClick(item)" on-search="vm.search(query)" \nlayout="row" layout-align="start center"></ms-search-bar><md-button ng-click="$root.pagination_resetquery()" \naria-label="view type" class="md-icon-button" translate="" translate-attr-aria-label="GLOBAL.FILTERS" \nclass="md-icon-button" ng-if="$root.pagination_searchquery==true"><md-icon md-font-icon="icon-filter-remove-outline">\n</md-icon><md-tooltip hide show-gt-xs><span>Reset search</span></md-tooltip></md-button><div class="divider-vertical" \nhide="" show-gt-xs=""></div><md-menu hide="" show-gt-xs="" ng-if="refGroupables.length>0"><button aria-label="Filters" \nclass="md-icon-button" ng-click="$mdMenu.open($event)" show-gt-xs="" translate="" \ntranslate-attr-aria-label="GLOBAL.FILTERS"><md-icon md-font-icon="icon-chevron-down"><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.GROUP_BY">Group</span></md-tooltip></md-icon></button><md-menu-content width="4"><md-menu-item \nng-repeat="sortfield in refGroupables"><md-button aria-label="All" ng-click="pagination_setOrderBy(sortfield)"><div \nlayout="row" layout-align="space-between center"><span>Group by {{sortfield.name}} </span><i class="icon-check s16" \nng-if="sortfield.titleId == sortable.titleId"></i></div></md-button></md-menu-item><md-menu-divider ng-if="groupable">\n</md-menu-divider><md-menu-item ng-if="groupable"><md-button aria-label="Remove group" \nng-click="pagination_resetOrderBy()"><md-icon md-font-icon="icon-close "></md-icon><span>Remove order</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div><div layout="row" layout-align="start center" \ntranslate-attr-aria-label="GLOBAL.REFRESH"><span ng-if="!isLoading" class="page-info font-weight-500">\n{{vm.staff.length}} {{ \'GLOBAL.OF\' | translate}} {{pagination_totalItems}} {{ \'GLOBAL.ITEMS\' | translate}}.</span><div \nclass="divider-vertical" hide hide show-gt-sm></div><md-button class="md-icon-button" \nng-click="vm.changeView(\'nosplit\')" ng-if="vm.currentView !== \'nosplit\'" hide show-gt-sm><md-icon \nmd-font-icon="icon-view-list" ng-if="vm.currentView !== \'nosplit\'"></md-icon><md-icon class="md-accent" \nmd-font-icon="icon-checkbox-marked" ng-if="vm.currentView === \'nosplit\'"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.NOSPLIT_VIEW">No split</span></md-tooltip></md-button><md-button class="md-icon-button" \nng-click="vm.changeView(\'split\')" ng-if="vm.currentView !== \'split\'" hide show-gt-sm><md-icon \nmd-font-icon="icon-view-quilt" ng-if="vm.currentView !== \'split\'"></md-icon><md-icon class="md-accent" \nmd-font-icon="icon-checkbox-marked" ng-if="vm.currentView === \'split\'"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.SPLIT_VIEW">split</span></md-tooltip></md-button><md-menu class="settings-menu" hide-gt-xs \nng-show="vm.selectedThreads.length > 0"><md-button aria-label="Settings" class="md-icon-button" \nng-click="$mdMenu.open($event)" translate="GLOBAL.SETTINGS" translate-attr-aria-label="GLOBAL.SETTINGS"><md-icon \nmd-font-icon="icon-dots-horizontal"></md-icon></md-button><md-menu-content><md-menu-item \nshow="vm.selectedMail.length > 0 || vm.allChecked"><md-button ng-click="vm.deleteStaff($event)" aria-label="Delete" \ntranslate-aria-label="GLOBAL.DELETE"><md-icon md-font-icon="icon-delete"></md-icon><span translate="GLOBAL.DELETE">\nDelete</span></md-button></md-menu-item></md-menu-content></md-menu></div>');
$templateCache.put('app/main/apps/staff/views/edit/edit-companies.html','<md-list-item flex="100" on="field.type" role="listitem" class="item-list grey"><div class="text-truncate" flex="100">\n<div class="field"><h2 translate="STAFF.POSITIONS"></h2></div></div></md-list-item><div \nng-repeat="company in vm.staffSelected.companies_branches" ng-init="vm.sortableOpt(virtualgroup)" \nng-if="vm.staffHasCompany(company)"><md-list-item flex="100" class="virtualgroups-item" \nng-repeat="branch in company.branches" ng-if="vm.staffHasBranch(branch)"><div layout="row" layout-align="start center" \nflex><div class="text-truncate mr-20" flex="40"><div class="field ml-45 grey-700-fg"><h3 ng-bind-html="branch.name" \nclass="grey-700-fg"></h3></div></div><div flex="60" layout="column" layout-align="start start"><div layout="row" \nlayout-align="space-between start" class="fullwidth"><div class="field" flex="50"><strong class="grey-700-fg" \ntranslate="STAFF.DIVISION"></strong></div><div class="field" flex="50"><strong class="grey-700-fg" \ntranslate="STAFF.JOB_POSITION"></strong></div></div><div \nng-repeat="jobDivision in vm.staffSelected.division_jobs | filter: {branch_id: branch.id}" layout="row" \nlayout-align="space-between start" class="fullwidth"><div class="field" flex="50"><span class="grey-700-fg" \nng-bind-html="jobDivision.division.name"></span></div><div class="field" flex="50"><span class="grey-700-fg" \nng-bind-html="jobDivision.job_position.name"></span></div></div></div></div><md-divider></md-divider></md-list-item>\n</div><div class="p-25" ng-if="vm.showFormAdd" layout="column"><div layout="row" layout-align="start center">\n<md-input-container flex="33"><md-select ng-model="vm.formNewPosition.branch" \nplaceholder="{{ \'GLOBAL.MAIN_BRANCH\' | translate }}" required><md-option ng-repeat="branch in vm.companyBranches" \nng-value="branch.id">{{branch.name}}</md-option></md-select></md-input-container><md-input-container flex="33">\n<md-select ng-model="vm.formNewPosition.division" placeholder="{{ \'GLOBAL.DIVISION\' | translate }}" required><md-option\n ng-repeat="division in vm.divisions track by $index" ng-value="division.id">{{division.name}}</md-option></md-select>\n</md-input-container><md-input-container flex="33"><md-select ng-model="vm.formNewPosition.position" \nplaceholder="{{ \'GLOBAL.POSITION\' | translate }}" required><md-option \nng-repeat="position in vm.positions track by $index" ng-value="position.id">{{position.name}}</md-option></md-select>\n</md-input-container></div><div layout="row" layout-align="end center"><md-button type="button" \nng-click="vm.showFormAdd = false; vm.formNewPosition = {};" class="md-raised md-warn" aria-label="Cancel" \ntranslate="STAFF.CANCEL" translate-attr-aria-label="STAFF.CANCEL">Cancel</md-button><md-button type="submit" \nng-click="vm.addUserJob(vm.staffSelected, vm.formNewPosition.branch, vm.formNewPosition.division, vm.formNewPosition.position)" \nclass="send-button md-accent md-raised" \nng-disabled="!vm.formNewPosition.division || !vm.formNewPosition.division || !vm.formNewPosition.position" \naria-label="SAVE" translate="STAFF.SAVE" translate-attr-aria-label="STAFF.SAVE">SAVE</md-button></div></div><div \nng-if="!vm.showFormAdd" class="mb-100" layout="row" layout-align="end center"><md-button \nng-click="vm.showFormAdd = true" class="add-event-button no-sort md-fab md-warn block m-25" aria-label="Add event" \ntranslate translate-attr-aria-label="STAFF.ADD_POSITION"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>');
$templateCache.put('app/main/apps/staff/views/edit/edit-data.html','<div class="mail-content file-details scrollable" ms-scroll="vm.msScrollOptions"><div layout="row"><div \nclass="form-wrapper md-whiteframe-1dp" flex="100"><div><md-input-container ng-if=" vm.staffSelected.user_type != 1" \nclass="md-block mt-0 mb-0"><button ng-if="vm.staffSelected.enabled" class="md-icon-button md-button"><md-icon \nmd-font-icon="icon-checkbox-marked-circle" class="on green-fg s24" ng-click="vm.toggleStaffStatusEdit(\'enabled\')">\n</md-icon></button> <button ng-if="!vm.staffSelected.enabled" class="md-icon-button md-button"><md-icon \nmd-font-icon="icon-checkbox-blank-circle-outline" class="off red-fg s24" \nng-click="vm.toggleStaffStatusEdit(\'enabled\')"></md-icon></button> <label class="inline">\n{{vm.staffSelected.enabled ? (\'USERS.ACTIVE\' | translate) : (\'USERS.INACTIVE\' | translate)}}</label>\n</md-input-container><md-input-container ng-if="vm.fromComplaint || vm.userLogued.user_type <= 3" \nclass="md-block mt-0 mb-0"><label translate="STAFF.USER_TYPE"></label><md-select \nng-disabled="vm.userLogued.user_type > 3" required ng-model="vm.staffSelected.user_type"><md-option \nng-if="vm.userLogued.user_type < 3" ng-value="2" translate="GLOBAL.ADMINISTRATOR"></md-option><md-option \nng-if="vm.userLogued.user_type < 4" ng-value="3" translate="STAFF.COMPANY_ADMIN"></md-option><md-option \nng-if="vm.userLogued.user_type < 4" ng-value="14" translate="STAFF.RSII"></md-option><md-option ng-value="6" \ntranslate="STAFF.CANAL_STAFF"></md-option></md-select></md-input-container><md-input-container class="md-block"><label \ntranslate="STAFF.FIRSTNAME"></label> <input ng-disabled="vm.userLogued.user_type > vm.staffSelected.user_type" \ntype="text" name="firstname" ng-model="vm.staffSelected.first_name" placeholder="" autocomplete="false" required>\n</md-input-container><md-input-container class="md-block"><label translate="STAFF.LASTNAME"></label> <input \nng-disabled="vm.userLogued.user_type > vm.staffSelected.user_type" type="text" name="lastname" \nng-model="vm.staffSelected.last_name" placeholder="" autocomplete="false" required></md-input-container>\n<md-input-container class="md-block"><label>{{vm.getRegionLiteral(\'id_number\')}}</label> <input \nng-disabled="vm.userLogued.user_type > vm.staffSelected.user_type" type="text" name="id_number" \nng-model="vm.staffSelected.id_number" placeholder="" autocomplete="false"></md-input-container><md-input-container \nclass="md-block"><label translate="STAFF.EMAIL"></label> <input \nng-disabled="!(vm.userLogued.is_owner || vm.staffSelected.id === vm.userLogued.id)" type="email" name="email" \nng-model="vm.staffSelected.email" placeholder="" autocomplete="false" required><md-tooltip \nng-if="!(vm.userLogued.is_owner || vm.staffSelected.id === vm.userLogued.id)" md-direction="top">\n{{ \'STAFF.PASSWORD_EMAIL_INCORRECT\' | translate }}</md-tooltip></md-input-container><md-input-container \nclass="md-block"><label translate="STAFF.PASSWORD"></label><p style="color: gray; font-weight: lighter;">\n{{ \'STAFF.PASSWORD_DESCRIPTION\' | translate }}</p><input \nng-disabled="!(vm.userLogued.is_owner || vm.staffSelected.id === vm.userLogued.id)" type="password" name="password" \nng-model="vm.staffSelected.password" placeholder="" autocomplete="false" \nng-pattern="/^(|(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d!@#$%^&*(),.?\\:{}\\[\\]|]{8,})$/"><md-tooltip \nng-if="!(vm.userLogued.is_owner || vm.staffSelected.id === vm.userLogued.id)" md-direction="top">\n{{ \'STAFF.PASSWORD_REQUIREMENTS\' | translate }}</md-tooltip><div ng-messages="form.password.$error" role="alert"><div \nng-message="pattern">{{ \'STAFF.PASSWORD_REQUIREMENTS\' | translate }}</div></div></md-input-container>\n<md-input-container class="md-block"><label translate="STAFF.PHONE"></label> <input \nng-disabled="vm.userLogued.user_type > vm.staffSelected.user_type" type="phone" name="phone" \nng-model="vm.staffSelected.phone" placeholder="" autocomplete="false"></md-input-container><md-input-container \nclass="md-block" ng-if="vm.staffSelected[\'3rd_party_company_name\']"><label translate="STAFF.3RD_PARTY_COMPANY"></label>\n <input ng-disabled="vm.userLogued.user_type != 1 && vm.staffSelected.user_type == 1" type="phone" name="phone" \nng-model="vm.staffSelected[\'3rd_party_company_name\']" placeholder="" autocomplete="false"></md-input-container><div \nng-if="vm.userLogued.user_type == 1 || vm.staffSelected.user_type != 1" class="md-block"><div><div ngf-drop ngf-select \nng-model="vm.files" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="image/*" ngf-pattern="\'image/*\'"><div layout="column"><div flex translate="GLOBAL.DROP_HERE">\nDrop here or click to upload</div><div flex translate="GLOBAL.OR"></div><div flex><md-button \nclass="send-button md-accent md-raised" aria-label="Select files" translate="GLOBAL.SELECT_FILES"></md-button></div>\n</div></div><div ngf-no-file-drop translate="GLOBAL.FILE_DRAG_DROP"></div></div><div ng-repeat="f in vm.files" \nclass="ms-card" flex><div ng-if="!f.url" class="ms-card-content-wrapper"><div class="template-9"><div class="media" \nflex layout="row" layout-align="center center"><img ngf-thumbnail="!f.$error && f" class="image"></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><strong class="mr-5" ng-if="f.id">#{{f.id}}</strong> <span class="grey-500-fg"><span \nng-if="f.name">{{f.name}}</span></span></div></div></div><md-progress-linear md-mode="determinate" \nvalue="{{f.progress}}" ng-show="f.progress < 100"></md-progress-linear></div></div><div ng-if="f.url" \nstyle="max-width: 300px;" class="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><img style="max-width: 200px" ng-src="{{storagePrefix + f.url}}" class="image"></div><div \nclass="p-16" flex layout="row" layout-align="end center"><md-menu class="float-right"><md-button \nclass="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.deleteAvatar(f)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-content></md-menu></div>\n<md-progress-linear md-mode="determinate" value="{{f.progress}}" ng-show="f.progress < 100"></md-progress-linear></div>\n</div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/staff/views/edit/edit-new.html','<div class="mail-content file-details scrollable" ms-scroll="vm.msScrollOptions"><div layout="row"><div \nclass="form-wrapper md-whiteframe-1dp" flex="100"><div><md-input-container ng-if="vm.staffNew.user_type != 1" \nclass="md-block mt-0 mb-0"><button ng-if="vm.staffNew.enabled" class="md-icon-button md-button"><md-icon \nmd-font-icon="icon-checkbox-marked-circle" class="on green-fg s24" ng-click="vm.toggleStaffStatusEdit(\'enabled\')">\n</md-icon></button> <button ng-if="!vm.staffNew.enabled" class="md-icon-button md-button"><md-icon \nmd-font-icon="icon-checkbox-blank-circle-outline" class="off red-fg s24" \nng-click="vm.toggleStaffStatusEdit(\'enabled\')"></md-icon></button> <label ng-if="vm.staffNew.enabled" class="inline" \ntranslate="STAFF.ACTIVE"></label> <label ng-if="!vm.staffNew.enabled" class="inline" translate="STAFF.INACTIVE">\n</label></md-input-container><md-input-container ng-if="vm.fromComplaint || vm.userLogued.user_type <= 3" \nclass="md-block mt-0 mb-0"><label translate="STAFF.USER_TYPE"></label><md-select required \nng-model="vm.staffNew.user_type"><md-option ng-if="vm.userLogued.user_type <3" ng-value="2" \ntranslate="GLOBAL.ADMINISTRATOR"></md-option><md-option ng-if="vm.userLogued.user_type <4" ng-value="3" \ntranslate="STAFF.COMPANY_ADMIN"></md-option><md-option ng-if="vm.userLogued.user_type <4" ng-value="14" \ntranslate="STAFF.RSII"></md-option><md-option ng-value="6" translate="STAFF.CANAL_STAFF"></md-option></md-select>\n</md-input-container><md-input-container class="md-block"><label translate="STAFF.FIRSTNAME"></label> <input \ntype="text" name="firstname" ng-model="vm.staffNew.first_name" placeholder="" required autocomplete="false">\n</md-input-container><md-input-container class="md-block"><label translate="STAFF.LASTNAME"></label> <input \ntype="text" name="lastname" ng-model="vm.staffNew.last_name" placeholder="" required autocomplete="false">\n</md-input-container><md-input-container class="md-block"><label>{{vm.getRegionLiteral(\'id_number\')}}</label> <input \ntype="text" name="id_number" ng-model="vm.staffNew.id_number" placeholder="" autocomplete="false"></md-input-container>\n<md-input-container class="md-block"><label translate="STAFF.EMAIL"></label> <input type="email" name="email" \nng-model="vm.staffNew.email" placeholder="" required autocomplete="false"></md-input-container><md-input-container \nclass="md-block"><label translate="STAFF.PASSWORD"></label><p style="color: gray; font-weight: lighter;">\n{{ \'STAFF.PASSWORD_DESCRIPTION\' | translate }}</p><input type="password" name="password" \nng-model="vm.staffNew.password" placeholder="" autocomplete="false" required \nng-pattern="/^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d!@#$%^&*(),.?\\:{}\\[\\]|]{8,}$/"><md-tooltip \nng-if="form.password.$error.pattern" md-direction="top">{{ \'STAFF.PASSWORD_REQUIREMENTS\' | translate }}</md-tooltip>\n<div ng-messages="form.password.$error" role="alert"><div ng-message="pattern">\n{{ \'STAFF.PASSWORD_REQUIREMENTS\' | translate }}</div></div></md-input-container><md-input-container class="md-block">\n<label translate="STAFF.PHONE"></label> <input type="phone" name="phone" ng-model="vm.staffNew.phone" placeholder="" \nautocomplete="false"></md-input-container><div class="md-block"><div><div ngf-drop ngf-select ng-model="vm.files" \nclass="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" accept="image/*" \nngf-pattern="\'image/*\'"><div layout="column"><div flex translate="GLOBAL.DROP_HERE">Drop here or click to upload</div>\n<div flex translate="GLOBAL.OR"></div><div flex><md-button class="send-button md-accent md-raised" \naria-label="Select files" translate="GLOBAL.SELECT_FILES"></md-button></div></div></div><div ngf-no-file-drop \ntranslate="GLOBAL.FILE_DRAG_DROP"></div></div><div ng-repeat="f in vm.files" class="ms-card" flex><div \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><img ngf-thumbnail="!f.$error && f" class="image"></div><div class="header p-16" flex><div\n layout="row" layout-align="space-between center" flex><div class="size" layout="row" layout-align="start left"><strong\n class="mr-5" ng-if="f.id">#{{f.id}}</strong> <span class="grey-500-fg"><span ng-if="f.name">{{f.name}}</span></span>\n</div></div></div><md-progress-linear md-mode="determinate" value="{{f.progress}}" ng-show="f.progress <100">\n</md-progress-linear></div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/staff/views/edit/edit-preview.html','<md-list-item flex="100" on="field.type" role="listitem" class="first-item-list"><div class="text-truncate" flex="100">\n<div class="field"><p class="grey-500-fg font-size-14" translate="STAFF.FIRSTNAME"></p><p \nclass="font-size-16 text-truncate" ng-bind-html="vm.staffSelected.first_name"></p></div></div></md-list-item>\n<md-list-item flex="100" on="field.type" role="listitem" class="item-list"><div class="text-truncate" flex="100"><div \nclass="field"><p class="grey-500-fg font-size-14" translate="STAFF.LASTNAME"></p><p class="font-size-16 text-truncate" \nng-bind-html="vm.staffSelected.last_name"></p></div></div></md-list-item><md-list-item flex="100" on="field.type" \nrole="listitem" class="item-list"><div class="text-truncate" flex="100"><div class="field"><p \nclass="grey-500-fg font-size-14">{{vm.getRegionLiteral(\'id_number\')}}</p><p class="font-size-16 text-truncate" \nng-bind-html="vm.staffSelected.id_number"></p></div></div></md-list-item><md-list-item flex="100" on="field.type" \nrole="listitem" class="item-list"><div class="text-truncate" flex="100"><div class="field"><p \nclass="grey-500-fg font-size-14" translate="STAFF.EMAIL"></p><p class="font-size-16 text-truncate" \nng-bind-html="vm.staffSelected.email"></p></div></div></md-list-item><md-list-item flex="100" on="field.type" \nrole="listitem" class="item-list"><div class="text-truncate" flex="100"><div class="field"><p \nclass="grey-500-fg font-size-14" translate="STAFF.PHONE"></p><p class="font-size-16 text-truncate" \nng-bind-html="vm.staffSelected.phone"></p></div></div></md-list-item><md-list-item flex="100" on="field.type" \nrole="listitem" class="item-list" ng-if="vm.staffSelected[\'3rd_party_company_name\']"><div class="text-truncate" \nflex="100"><div class="field"><p class="grey-500-fg font-size-14" translate="STAFF.3RD_PARTY_COMPANY"></p><p \nclass="font-size-16 text-truncate" ng-bind-html="vm.staffSelected[\'3rd_party_company_name\']"></p></div></div>\n</md-list-item>');
$templateCache.put('app/main/apps/staff/views/edit/edit-tasks.html','test 2');
$templateCache.put('app/main/apps/staff/views/edit/edit-view-nosplit.html','<div flex layout="column" layout-align="center center" ng-if="vm.loadingReadPane" class="loading-container">\n<md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div><div \nng-show="!vm.loadingReadPane"><div class="mail-content" layout="column" layout-align="center center" \nng-if="!vm.staffSelected"><div class="content" layout="column" layout-align="top center"><div class="message">\nPlease select a user to show in this panel</div></div></div><form name="vm.basicForm" class="md-inline-form" \nnovalidate><md-content ng-if="vm.staffSelected && !vm.editData" \nng-include="\'app/main/apps/staff/views/edit/edit-tabs.html\'" class="scrollable"></md-content><md-content \nng-if="vm.staffSelected && vm.editData" ng-include="\'app/main/apps/staff/views/edit/edit-data.html\'" \nclass="scrollable"></md-content></form></div>');
$templateCache.put('app/main/apps/staff/views/edit/edit-view.html','<md-list ng-if="vm.staffSelected" class="pv-20 ph-8 border-bottom"><md-list-item class="main-item" \nstyle="padding-left: 0px;" flex layout="row" layout-align="start center"><div layout="row" layout-align="start center">\n<div class="main-read"><div class="avatar-container"><user-avatar user="vm.staffSelected"></div></div><div \nclass="main-read"><h1 class="name"><strong ng-bind-html="vm.staffSelected.first_name"></strong> <strong \nng-bind-html="vm.staffSelected.last_name"></strong></h1><p><span class="font-size-16 text-truncate" \nng-bind-html="vm.staffSelected.email"></span></p></div></div><div hide show-gt-sm flex layout="row" \nlayout-align="end center"><md-input-container ng-if="vm.staffSelected.user_type != 1" class="md-block mt-0 mb-0">\n<button ng-if="vm.staffSelected.enabled" class="md-icon-button md-button"><md-icon \nmd-font-icon="icon-checkbox-marked-circle" class="on green-fg s24"></md-icon></button> <button \nng-if="!vm.staffSelected.enabled" class="md-icon-button md-button"><md-icon \nmd-font-icon="icon-checkbox-blank-circle-outline" class="off red-fg s24"></md-icon></button></md-input-container><label\n ng-if="vm.staffSelected.enabled" class="inline" translate="STAFF.ACTIVE"></label> <label \nng-if="!vm.staffSelected.enabled" class="inline" translate="STAFF.INACTIVE"></label></div></md-list-item></md-list><div\n ng-if="(vm.staffSelected || vm.staffNew || vm.loadingReadPane)" class="toolbar colored-bg" layout="row" \nlayout-align="space-between center" ng-if="vm.staffSelected || vm.staffNew" scroll=""><div layout="row" \nlayout-align="start center"><md-button aria-label="Edit" class="md-icon-button" translate="" \nng-click="vm.viewPreviewData()" translate-attr-aria-label="STAFF.EDIT" \nng-class="{\'tab-selected\': vm.tabActive==\'preview\' || vm.tabActive==\'editnew\' || vm.tabActive==\'edit\'}"><md-icon \nmd-font-icon="icon-account"></md-icon><md-tooltip hide show-gt-sm><span translate="STAFF.EDIT">Edit</span></md-tooltip>\n</md-button><div ng-if="vm.staffSelected && !vm.fromComplaint" class="divider-vertical" hide="" show-gt-sm=""></div>\n<md-button ng-if="vm.staffSelected && !vm.fromComplaint" aria-label="Companies" class="md-icon-button" translate="" \nng-click="vm.viewEditCompanies();" translate-attr-aria-label="STAFF.POSITIONS" \nng-class="{\'tab-selected\': vm.tabActive==\'companies\'}"><md-icon md-font-icon="icon-city"></md-icon><md-tooltip hide \nshow-gt-sm><span translate="STAFF.POSITIONS">POSITIONS</span></md-tooltip></md-button><div \nng-if="vm.staffSelected && !vm.fromComplaint" class="divider-vertical" hide="" show-gt-sm=""></div><md-button \nng-if="vm.staffSelected && !vm.fromComplaint" aria-label="Activity" class="md-icon-button" translate="" \nng-click="vm.viewActivity();" translate-attr-aria-label="STAFF.ACTIVITY" \nng-class="{\'tab-selected\': vm.tabActive==\'activity\'}"><md-icon md-font-icon="icon-run"></md-icon><md-tooltip hide \nshow-gt-sm><span translate="STAFF.ACTIVITY">ACTIVITY</span></md-tooltip></md-button><div \nng-if="vm.staffSelected && !vm.fromComplaint" class="divider-vertical" hide="" show-gt-sm=""></div><md-button \nng-if="vm.staffSelected && !vm.fromComplaint" aria-label="Task" class="md-icon-button" translate="" \nng-click="vm.viewTask();" translate-attr-aria-label="STAFF.TASKS" ng-class="{\'tab-selected\': vm.tabActive==\'tasks\'}">\n<md-icon md-font-icon="icon-timelapse"></md-icon><md-tooltip hide show-gt-sm><span translate="STAFF.TASKS">TASKS</span>\n</md-tooltip></md-button><div ng-if="vm.staffSelected && !vm.fromComplaint" class="divider-vertical" hide="" \nshow-gt-sm=""></div><md-button ng-if="vm.isAvailableConfigureMenu()" aria-label="Menu" class="md-icon-button" \ntranslate="" ng-click="vm.viewConfigureTabs() " translate-attr-aria-label="USERS.COMPANIES" \nng-class="{\'tab-selected\': vm.tabActive==\'configuretabs\'}"><md-icon md-font-icon="icon-cog"></md-icon><md-tooltip hide \nshow-gt-sm><span translate="USERS.MENU">MENU</span></md-tooltip></md-button><div \nng-if="vm.staffSelected && !vm.fromComplaint" class="divider-vertical" hide="" show-gt-sm=""></div><md-button \nng-if="vm.viewPasswordEmail" aria-label="Menu" class="md-icon-button" translate="" ng-click="vm.sendPasswordEmail()" \ntranslate-attr-aria-label="STAFF.SEND_PASSWORD_EMAIL" ng-class="{\'tab-selected\': vm.tabActive==\'sendpasswordemail\'}">\n<md-icon md-font-icon="icon-lock"></md-icon><md-tooltip hide show-gt-sm><span translate="STAFF.SEND_PASSWORD_EMAIL">\nSEND PASSWORD EMAIL</span></md-tooltip></md-button><div ng-if="vm.staffSelected && !vm.fromComplaint" \nclass="divider-vertical" hide="" show-gt-sm=""></div><md-button ng-if="vm.reset2FA && vm.userLogued.is_owner" \naria-label="Reset 2FA" class="md-icon-button" ng-click="vm.reset2FA()" \nng-class="{\'tab-selected\': vm.tabActive==\'reset2fa\'}"><md-icon \nmd-svg-src="assets/angular-material-assets/img/icons/2fa.svg" aria-label="2FA Icon"></md-icon><md-tooltip hide \nshow-gt-sm><span translate="STAFF.RESET_2FA">Reset 2FA</span></md-tooltip></md-button><div \nng-if="vm.staffSelected && vm.staffSelected.id === vm.userLogued.id" class="divider-vertical" hide="" show-gt-sm="">\n</div><md-button ng-if="vm.staffSelected && vm.staffSelected.id === vm.userLogued.id" \naria-label="{{ vm.googleLinked ? (\'STAFF.UNLINK_GOOGLE\' | translate) : (\'STAFF.LINK_GOOGLE\' | translate) }}" \nclass="md-icon-button" ng-click="vm.googleLinked ? vm.unlinkGoogle() : vm.linkGoogle()"><md-icon \nng-if="!vm.googleLinked" md-svg-src="assets/angular-material-assets/img/icons/google.svg" aria-label="Google Icon">\n</md-icon><md-icon ng-if="vm.googleLinked" md-svg-src="assets/angular-material-assets/img/icons/google-unlink.svg" \naria-label="Google Unlink Icon"></md-icon><md-tooltip hide show-gt-sm><span ng-if="!vm.googleLinked" \ntranslate="STAFF.LINK_GOOGLE">Vincular con Google</span> <span ng-if="vm.googleLinked" translate="STAFF.UNLINK_GOOGLE">\nDesvincular Google</span></md-tooltip></md-button><md-button \nng-if="(vm.userLogued.email === \'indi@h2c.es\' || vm.userLogued.email === \'roni@h2c.es\' || vm.userLogued.email === \'dev@h2c.es\') && vm.staffSelected && vm.staffSelected.is_owner" \naria-label="{{ vm.staffSelected.stripe ? (\'STAFF.DISABLE_STRIPE\' | translate) : (\'STAFF.ENABLE_STRIPE\' | translate) }}" \nclass="md-icon-button" ng-click="vm.toggleStripe()" ng-class="{\'tab-selected\': vm.tabActive==\'stripe\'}"><md-icon \nng-if="!vm.staffSelected.stripe" md-svg-src="assets/angular-material-assets/img/icons/stripe.svg" \naria-label="Enable Stripe"></md-icon><md-icon ng-if="vm.staffSelected.stripe" \nmd-svg-src="assets/angular-material-assets/img/icons/stripe-unlink.svg" aria-label="Disable Stripe"></md-icon>\n<md-tooltip hide show-gt-sm><span ng-if="!vm.staffSelected.stripe" translate="STAFF.ENABLE_STRIPE">Activar Stripe\n</span> <span ng-if="vm.staffSelected.stripe" translate="STAFF.DISABLE_STRIPE">Desactivar Stripe</span></md-tooltip>\n</md-button></div><div ng-if="vm.tabActive == \'preview\'" flex layout="row" layout-align="end center"><div layout="row" \nlayout-align="end center" hide show-gt-sm><md-button type="submit" ng-click="vm.viewEditData()" \nclass="send-button md-accent md-raised" aria-label="EDIT" translate="STAFF.EDIT" \ntranslate-attr-aria-label="STAFF.EDIT">EDIT</md-button></div><div layout="row" layout-align="end center" hide-gt-sm>\n<md-button type="submit" ng-click="vm.viewEditData()" \nclass="md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" aria-label="EDIT"><md-icon \nmd-font-icon="icon-pencil" ng-hide="vm.savingProcess"></md-icon><md-progress-circular md-mode="indeterminate" \nng-if="vm.savingProcess"></md-progress-circular><md-tooltip hide show-gt-sm><span translate="STAFF.EDIT">EDIT</span>\n</md-tooltip></md-button></div></div><div ng-if="vm.tabActive == \'edit\' || vm.tabActive == \'editnew\'" flex \nlayout="row" layout-align="end center"><div layout="row" layout-align="end center" \nng-if="vm.staffSelected || vm.staffNew" hide show-gt-sm><md-button type="button" \nng-click="vm.viewPreviewData(); vm.resetStaffSelected()" class="md-raised md-warn" aria-label="Cancel" \ntranslate="STAFF.CANCEL" translate-attr-aria-label="STAFF.CANCEL">Cancel</md-button><md-button type="submit" \nng-click="vm.saveStaff($event)" class="send-button md-accent md-raised" \nng-disabled="vm.basicForm.$invalid || vm.basicForm.$pristine" aria-label="SAVE" translate="STAFF.SAVE" \ntranslate-attr-aria-label="STAFF.SAVE">SAVE</md-button></div><div layout="row" layout-align="end center" \nng-if="(vm.staffSelected || vm.staffNew)" hide-gt-sm><md-button type="button" \nng-click="vm.viewPreviewData(); vm.resetStaffSelected()" \nclass="md-warn md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" aria-label="Cancel"><md-icon \nmd-font-icon="icon-window-close"></md-icon><md-tooltip hide show-gt-sm><span translate="STAFF.CANCEL">Cancel</span>\n</md-tooltip></md-button><md-button type="submit" ng-click="vm.saveStaff($event)" \nclass="md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" \nng-disabled="vm.basicForm.$invalid || vm.basicForm.$pristine" aria-label="SAVE"><md-icon md-font-icon="icon-check" \nng-hide="vm.savingProcess"></md-icon><md-progress-circular md-mode="indeterminate" ng-if="vm.savingProcess">\n</md-progress-circular><md-tooltip hide show-gt-sm><span translate="STAFF.SAVE">Save</span></md-tooltip></md-button>\n</div></div></div><div class="content thread-detail" layout="row" layout-align="center center" flex \nng-if="vm.loadingReadPane"><div flex layout="column" layout-align="center center" class="loading-container">\n<md-progress-circular md-mode="indeterminate" md-diameter="50"></md-progress-circular></div></div><div \nclass="content thread-detail" layout="row" layout-align="center center" flex \nng-if="!vm.staffSelected && !vm.staffNew && !vm.loadingReadPane"><div class="no-thread-selected" layout="column" \nlayout-align="center center" flex><md-icon md-font-icon="icon-clipboard-account" class="s120 grey-400-fg"></md-icon>\n<span class="hint-text" translate="STAFF.SELECT_USER"></span></div></div><div \nng-if="vm.fromComplaint && vm.tabActive==\'editnew\' &&  !vm.fromComplaint" ng-init="vm.tabNewSelected= \'new\'" \nclass="toolbar colored-bg" layout="row" layout-align="space-between center" scroll=""><div layout="row" \nlayout-align="start center"><md-button aria-label="Edit" class="md-icon-button" translate="" \ntranslate-attr-aria-label="STAFF.EDIT" ng-click="vm.tabNewSelected= \'new\'" \nng-class="{\'tab-selected\': vm.tabNewSelected==\'new\'}"><md-icon md-font-icon="icon-account"></md-icon><md-tooltip hide \nshow-gt-sm><span translate="STAFF.EDIT">New</span></md-tooltip></md-button><div ng-if="vm.userLogued.user_type <= 2" \nclass="divider-vertical" hide="" show-gt-sm=""></div><md-button ng-if="vm.userLogued.user_type <= 2" \naria-label="Admins" class="md-icon-button" translate="" ng-click="vm.tabNewSelected= \'admins\'" \ntranslate-attr-aria-label="STAFF.ADMINS" ng-class="{\'tab-selected\': vm.tabNewSelected==\'admins\'}"><md-icon \nmd-font-icon="icon-city"></md-icon><md-tooltip hide show-gt-sm><span translate="STAFF.ADMINS">ADMINS</span>\n</md-tooltip></md-button></div><div ng-if="vm.tabActive == \'edit\' || vm.tabActive == \'editnew\'" flex layout="row" \nlayout-align="end center"><div layout="row" layout-align="end center" ng-if="vm.staffSelected || vm.staffNew" hide \nshow-gt-sm><md-button type="button" ng-click="vm.viewPreviewData(); vm.resetStaffSelected()" class="md-raised md-warn" \naria-label="Cancel" translate="STAFF.CANCEL" translate-attr-aria-label="STAFF.CANCEL">Cancel</md-button><md-button \ntype="submit" ng-click="vm.saveStaff($event)" class="send-button md-accent md-raised" \nng-disabled="vm.basicForm.$invalid || vm.basicForm.$pristine" aria-label="SAVE" translate="STAFF.SAVE" \ntranslate-attr-aria-label="STAFF.SAVE">SAVE</md-button></div><div layout="row" layout-align="end center" \nng-if="(vm.staffSelected || vm.staffNew)" hide-gt-sm><md-button type="button" \nng-click="vm.viewPreviewData(); vm.resetStaffSelected()" \nclass="md-warn md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" aria-label="Cancel"><md-icon \nmd-font-icon="icon-window-close"></md-icon><md-tooltip hide show-gt-sm><span translate="STAFF.CANCEL">Cancel</span>\n</md-tooltip></md-button><md-button type="submit" ng-click="vm.saveStaff($event)" \nclass="md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" \nng-disabled="vm.basicForm.$invalid || vm.basicForm.$pristine" aria-label="SAVE"><md-icon md-font-icon="icon-check" \nng-hide="vm.savingProcess"></md-icon><md-progress-circular md-mode="indeterminate" ng-if="vm.savingProcess">\n</md-progress-circular><md-tooltip hide show-gt-sm><span translate="STAFF.SAVE">Save</span></md-tooltip></md-button>\n</div></div></div><form name="vm.basicForm" style="height: calc(100% - 64px)" class="md-inline-form" novalidate \nng-if="!vm.loadingReadPane && (vm.staffSelected || vm.staffNew) && vm.tabNewSelected !== \'admins\'"><div \nstyle="height: 100%" class="mail-content file-details scrollable" ms-scroll="vm.msScrollOptions"><md-content \nstyle="margin-bottom: 100px; overflow: hidden;" ng-if="vm.tabActive==\'preview\'" \nng-include="\'app/main/apps/staff/views/edit/edit-preview.html\'" class="scrollable"></md-content><md-content \nstyle="margin-bottom: 100px; overflow: hidden;" ng-if="vm.tabActive==\'editnew\'" \nng-include="\'app/main/apps/staff/views/edit/edit-new.html\'" class="scrollable"></md-content><md-content \nstyle="margin-bottom: 100px; overflow: hidden;" ng-if="vm.tabActive==\'edit\'" \nng-include="\'app/main/apps/staff/views/edit/edit-data.html\'" class="scrollable"></md-content><md-content \nstyle="margin-bottom: 100px; overflow: hidden;" ng-if="vm.tabActive==\'companies\'" \nng-include="\'app/main/apps/staff/views/edit/edit-companies.html\'" class="scrollable"></md-content><activity-user \nng-show="vm.tabActive==\'activity\'" ng-if="vm.staffSelected.id" id-user="vm.staffSelected.id"></activity-user>\n<tasks-user ng-show="vm.tabActive==\'tasks\'" ng-if="vm.staffSelected.id" id-user="vm.staffSelected.id"></tasks-user>\n<configure-tabs ng-show="vm.tabActive==\'configuretabs\'" ng-if="vm.staffSelected.id" user-logued="vm.userLogued" \nuser-selected="vm.staffSelected"></configure-tabs></div></form><div \nstyle="overflow: auto; max-height: calc(100vh - 194px);" ng-if="vm.tabNewSelected == \'admins\' && vm.fromComplaint"><div\n style="max-height: 100%;" id="site-client"><div class="search-input-wrapper border-bottom" layout="row" \nlayout-align="start center"><md-icon class="mr-10 ml-20" md-font-icon="icon-magnify"></md-icon><input id="search2" \nplaceholder="{{\'CONTACTS.SEARCH_FOR_ANYONE\' | translate}}" type="text" ng-model="searchTextAll" class="flex h-60">\n</div><div style="max-height: 100%; overflow: hidden;" class="content thread-list mail-list-pane p0" flex="" \nid="thread-list"><div id="list-content-data" ng-style="{\'opacity\' : isLoading ? 0.5 : 1}"><div \nclass="mail-list-item p0" \nng-repeat="user in vm.adminUsers | filter:searchTextAll | filter:filterAlreadyAdded | orderBy: \'name\'" \nng-init="parentIndex= $index" md-no-ink ng-click="vm.selectUserNew(user)" \nng-class="{\'starred\': user.starred, \'selected\': vm.selectedContentID !== user.id_mailing_content, \'checked\': vm.isChecked(user)}">\n<div layout="row" layout-align="start center" flex="100" class="pl-15 pt-10 pb-10"><div class="info" flex \nlayout="column"><div class="name" layout="row"><div layout="row" layout-align="start center" flex="100"><div \nclass="avatar-wrapper"><img class="avatar s24" ng-src="{{vm.showUserImage(user)}}" ng-if="user.files.id"><div \nclass="avatar s24" ng-class="user.profile_color ? user.profile_color : \'md-blue-grey-300-bg\'" ng-if="!user.files.id" \nng-bind="user.first_name | capitalizeFirstLetter"></div></div><div class="field mr-10 ml-10" flex><strong \nclass="grey-800-fg" ng-bind-html="user.first_name + \' \' + user.last_name"></strong></div></div></div></div></div></div>\n</div></div></div></div>');
$templateCache.put('app/main/apps/staff/views/edit/view-activity.html','<div class="mail-content file-details scrollable" ms-scroll="vm.msScrollOptions"><md-list><md-list-item \nng-if="vm.staffSelectedID" class="main-item"><div class="main-read"><div class="avatar-container"><div \nng-if="(vm.staffSelected.avatar == \'\' || !vm.staffSelected.avatar)" class="avatar" \nng-bind="vm.staffSelected.first_name | capitalizeFirstLetter" \nng-style="{\'background-color\': vm.staffSelected.profile_color }"></div><div ng-if="vm.staffSelected.avatar" \nattachment="vm.staffSelected.avatar"><img class="avatar hide show spinner-show" ng-src="{{vm.staffSelected.avatar}}" \nimageonload=""></div><md-icon ng-if="vm.staffSelected.active ===1" md-font-icon="icon-checkbox-marked-circle" \nclass="on green-fg s24"></md-icon><md-icon ng-if="vm.staffSelected.active !==1" \nmd-font-icon="icon-checkbox-blank-circle-outline" class="off red-fg s24"></md-icon></div></div><div class="main-read">\n<h1 class="name"><strong ng-bind-html="vm.staffSelected.first_name"></strong> <strong \nng-bind-html="vm.staffSelected.last_name"></strong></h1><p><span class="font-size-16 text-truncate" \nng-bind-html="vm.staffSelected.email"></span></p></div></md-list-item><md-divider></md-divider><md-list-item \nclass="md-toolbar-tools grey-100-bg" layout="row" layout-align="space-between center"><div layout="row" \nlayout-align="start center"><h3 class="grey-700-fg" translate="ACCOUNTS.ACTIVITY"></h3></div></md-list-item>\n<md-divider></md-divider><div class="activities-list"><table hide show-gt-lg><tr \nng-repeat="log in vm.staffSelected.log"><td><div layout="row" layout-align="start center"><md-icon \nmd-font-icon="{{log.module.icon_v3}}" class="mr-10 ml-0 s30"><md-tooltip hide show-gt-xs><span>{{log.module.title}}\n</span></md-tooltip></md-icon><div><div class="field module-name" ng-if="log.id_service == 2"><span \nclass="grey-800-fg" ng-bind-html="log.section.languages[0].text"></span></div><div class="field module-name" \nng-if="log.id_service != 2"><span class="grey-800-fg" ng-bind-html="log.module.module_name"></span></div></div></div>\n</td><td><div class="field" layout="row" layout-align="start center"><div layout="row" layout-align="end center"><span \nclass="grey-500-fg" ng-bind-html="vm.timeAgo(log.date)"></span></div></div></td><td><div class="field"><span \nclass="grey-800-fg mr-5">ID #{{log.id_from_section}}</span> <span class="grey-500-fg" ng-bind-html="log.description">\n</span></div></td><td><div class="field" layout="row" layout-align="end center"><span \nclass="status {{log.action.action_name}}" ng-bind-html="log.action.action_name"></span></div></td></tr></table>\n<md-list-item hide-gt-lg ng-repeat="log in vm.staffSelected.log" class="pl-16 pr-16"><div layout="row" \nlayout-align="space-between center" flex="100" class="layout-align-space-between-center layout-row"><md-icon \nmd-font-icon="{{log.module.icon_v3}}" class="mr-16 ml-0 s30" hide show-gt-xs><md-tooltip hide show-gt-xs><span>\n{{log.module.module_name}}</span></md-tooltip></md-icon><div layout="column" layout-align="center space-between " \nclass="field flex"><div layout="row" layout-align-gt-xs="start center" layout-align-xs="space-between center" \nclass="mb-10"><div layout="row" layout-align="start center"><md-icon md-font-icon="{{log.module.icon_v3}}" \nclass="mr-5 ml-0" hide-gt-xs><md-tooltip hide show-gt-xs><span>{{log.module.module_name}}</span></md-tooltip></md-icon>\n<div class="field mr-10 module-name"><span class="grey-800-fg" ng-if="log.id_service == 2" \nng-bind-html="log.section.languages[0].text"></span> <span class="grey-800-fg" ng-if="log.id_service != 2" \nng-bind-html="log.module.module_name"></span></div><span class="grey-500-fg" ng-bind-html="vm.timeAgo(log.date)">\n</span></div><div class="field" hide-gt-xs><span class="status {{log.action.action_name}}" \nng-bind-html="log.action.action_name"></span></div></div><div class="text-truncate"><span class="grey-800-fg mr-5">\nID #{{log.id_from_section}}</span> <span class="grey-500-fg" ng-bind-html="log.description"></span></div></div><div \nlayout="row" layout-align="end center" hide show-gt-xs><div class="field"><span \nclass="status {{log.action.action_name}}" ng-bind-html="log.action.action_name"></span></div></div></div><md-divider \nclass="md-default-theme"></md-divider></md-list-item></div></md-list></div>');
$templateCache.put('app/main/apps/staffsroi/views/complaints/edit-preview.html','<div class="content thread-detail" layout="row" layout-align="center center" flex \nng-if="!vm.staffSelected && !vm.staffNew && !vm.loadingReadPane"><div class="no-thread-selected" layout="column" \nlayout-align="center center" flex><md-icon md-font-icon="icon-clipboard-account" class="s120 grey-400-fg"></md-icon>\n<span class="hint-text" translate="STAFF.SELECT_USER"></span></div></div><div \nng-if="vm.staffSelected || vm.staffNew || vm.loadingReadPane"><md-list class="pv-20 ph-8 border-bottom"><md-list-item \nclass="main-item" style="padding-left: 0px;" flex layout="row" layout-align="start center"><div layout="row" \nlayout-align="start center"><div class="main-read"><div class="avatar-container"><user-avatar user="vm.staffSelected">\n</div></div><div class="main-read"><h1 class="name"><strong ng-bind-html="vm.staffSelected.first_name"></strong> \n<strong ng-bind-html="vm.staffSelected.last_name"></strong></h1><p><span class="font-size-16 text-truncate" \nng-bind-html="vm.staffSelected.email"></span></p></div></div></md-list-item></md-list></div><md-list-item flex="100" \non="field.type" role="listitem" class="first-item-list"><div class="text-truncate" flex="100"><div class="field"><p \nclass="grey-500-fg font-size-14" translate="STAFF.FIRSTNAME"></p><p class="font-size-16 text-truncate" \nng-bind-html="vm.staffSelected.first_name"></p></div></div></md-list-item><md-list-item flex="100" on="field.type" \nrole="listitem" class="item-list"><div class="text-truncate" flex="100"><div class="field"><p \nclass="grey-500-fg font-size-14" translate="STAFF.LASTNAME"></p><p class="font-size-16 text-truncate" \nng-bind-html="vm.staffSelected.last_name"></p></div></div></md-list-item><md-list-item flex="100" on="field.type" \nrole="listitem" class="item-list"><div class="text-truncate" flex="100"><div class="field"><p \nclass="grey-500-fg font-size-14">{{vm.getRegionLiteral(\'id_number\')}}</p><p class="font-size-16 text-truncate" \nng-bind-html="vm.staffSelected.id_number"></p></div></div></md-list-item><md-list-item flex="100" on="field.type" \nrole="listitem" class="item-list"><div class="text-truncate" flex="100"><div class="field"><p \nclass="grey-500-fg font-size-14" translate="STAFF.EMAIL"></p><p class="font-size-16 text-truncate" \nng-bind-html="vm.staffSelected.email"></p></div></div></md-list-item><md-list-item flex="100" on="field.type" \nrole="listitem" class="item-list"><div class="text-truncate" flex="100"><div class="field"><p \nclass="grey-500-fg font-size-14" translate="STAFF.PHONE"></p><p class="font-size-16 text-truncate" \nng-bind-html="vm.staffSelected.phone"></p></div></div></md-list-item><md-list-item flex="100" on="field.type" \nrole="listitem" class="item-list" ng-if="vm.staffSelected[\'3rd_party_company_name\']"><div class="text-truncate" \nflex="100"><div class="field"><p class="grey-500-fg font-size-14" translate="STAFF.3RD_PARTY_COMPANY"></p><p \nclass="font-size-16 text-truncate" ng-bind-html="vm.staffSelected[\'3rd_party_company_name\']"></p></div></div>\n</md-list-item>');
$templateCache.put('app/main/apps/staffsroi/views/edit/edit-companies.html','<md-list-item flex="100" on="field.type" role="listitem" class="item-list grey"><div class="text-truncate" flex="100">\n<div class="field"><h2 translate="STAFF.POSITIONS"></h2></div></div></md-list-item><div \nng-repeat="company in vm.staffSelected.companies_branches" ng-init="vm.sortableOpt(virtualgroup)" \nng-if="vm.staffHasCompany(company)"><md-list-item flex="100" class="virtualgroups-item" \nng-repeat="branch in company.branches" ng-if="vm.staffHasBranch(branch)"><div layout="row" layout-align="start center" \nflex><div class="text-truncate mr-20" flex="40"><div class="field ml-45 grey-700-fg"><h3 ng-bind-html="branch.name" \nclass="grey-700-fg"></h3></div></div><div flex="60" layout="column" layout-align="start start"><div layout="row" \nlayout-align="space-between start" class="fullwidth"><div class="field" flex="50"><strong class="grey-700-fg" \ntranslate="STAFF.DIVISION"></strong></div><div class="field" flex="50"><strong class="grey-700-fg" \ntranslate="STAFF.JOB_POSITION"></strong></div></div><div \nng-repeat="jobDivision in vm.staffSelected.division_jobs | filter: {branch_id: branch.id}" layout="row" \nlayout-align="space-between start" class="fullwidth"><div class="field" flex="50"><span class="grey-700-fg" \nng-bind-html="jobDivision.division.name"></span></div><div class="field" flex="50"><span class="grey-700-fg" \nng-bind-html="jobDivision.job_position.name"></span></div></div></div></div><md-divider></md-divider></md-list-item>\n</div><div class="p-25" ng-if="vm.showFormAdd" layout="column"><div layout="row" layout-align="start center">\n<md-input-container flex="33"><md-select ng-model="vm.formNewPosition.branch" \nplaceholder="{{ \'GLOBAL.MAIN_BRANCH\' | translate }}" required><md-option ng-repeat="branch in vm.companyBranches" \nng-value="branch.id">{{branch.name}}</md-option></md-select></md-input-container><md-input-container flex="33">\n<md-select ng-model="vm.formNewPosition.division" placeholder="{{ \'GLOBAL.DIVISION\' | translate }}" required><md-option\n ng-repeat="division in vm.divisions track by $index" ng-value="division.id">{{division.name}}</md-option></md-select>\n</md-input-container><md-input-container flex="33"><md-select ng-model="vm.formNewPosition.position" \nplaceholder="{{ \'GLOBAL.POSITION\' | translate }}" required><md-option \nng-repeat="position in vm.positions track by $index" ng-value="position.id">{{position.name}}</md-option></md-select>\n</md-input-container></div><div layout="row" layout-align="end center"><md-button type="button" \nng-click="vm.showFormAdd = false; vm.formNewPosition = {};" class="md-raised md-warn" aria-label="Cancel" \ntranslate="STAFF.CANCEL" translate-attr-aria-label="STAFF.CANCEL">Cancel</md-button><md-button type="submit" \nng-click="vm.addUserJob(vm.staffSelected, vm.formNewPosition.branch, vm.formNewPosition.division, vm.formNewPosition.position)" \nclass="send-button md-accent md-raised" \nng-disabled="!vm.formNewPosition.division || !vm.formNewPosition.division || !vm.formNewPosition.position" \naria-label="SAVE" translate="STAFF.SAVE" translate-attr-aria-label="STAFF.SAVE">SAVE</md-button></div></div><div \nng-if="!vm.showFormAdd" class="mb-100" layout="row" layout-align="end center"><md-button \nng-click="vm.showFormAdd = true" class="add-event-button no-sort md-fab md-warn block m-25" aria-label="Add event" \ntranslate translate-attr-aria-label="STAFF.ADD_POSITION"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>');
$templateCache.put('app/main/apps/staffsroi/views/edit/edit-data.html','<div class="mail-content file-details scrollable" ms-scroll="vm.msScrollOptions"><div layout="row"><div \nclass="form-wrapper md-whiteframe-1dp" flex="100"><div><md-input-container ng-if=" vm.staffSelected.user_type != 1" \nclass="md-block mt-0 mb-0"><button ng-if="vm.staffSelected.enabled" class="md-icon-button md-button"><md-icon \nmd-font-icon="icon-checkbox-marked-circle" class="on green-fg s24" ng-click="vm.toggleStaffStatusEdit(\'enabled\')">\n</md-icon></button> <button ng-if="!vm.staffSelected.enabled" class="md-icon-button md-button"><md-icon \nmd-font-icon="icon-checkbox-blank-circle-outline" class="off red-fg s24" \nng-click="vm.toggleStaffStatusEdit(\'enabled\')"></md-icon></button> <label class="inline">\n{{vm.staffSelected.enabled ? (\'USERS.ACTIVE\' | translate) : (\'USERS.INACTIVE\' | translate)}}</label>\n</md-input-container><md-input-container ng-if="vm.fromComplaint" class="md-block mt-0 mb-0"><label \ntranslate="STAFF.USER_TYPE"></label><md-select ng-disabled="vm.userLogued.user_type > 20" required \nng-model="vm.staffSelected.user_type"><md-option ng-if="vm.userLogued.user_type < 21" ng-value="20" \ntranslate="GLOBAL.ADMINISTRATOR"></md-option><md-option ng-if="vm.userLogued.user_type < 22" ng-value="21" \ntranslate="STAFF.COMPANY_ADMIN"></md-option><md-option ng-value="22" translate="STAFF.SRROI_STAFF"></md-option>\n</md-select></md-input-container><md-input-container class="md-block"><label translate="STAFF.FIRSTNAME"></label> \n<input ng-disabled="vm.userLogued.user_type > vm.staffSelected.user_type" type="text" name="firstname" \nng-model="vm.staffSelected.first_name" placeholder="" autocomplete="false" required></md-input-container>\n<md-input-container class="md-block"><label translate="STAFF.LASTNAME"></label> <input \nng-disabled="vm.userLogued.user_type > vm.staffSelected.user_type" type="text" name="lastname" \nng-model="vm.staffSelected.last_name" placeholder="" autocomplete="false" required></md-input-container>\n<md-input-container class="md-block"><label>{{vm.getRegionLiteral(\'id_number\')}}</label> <input \nng-disabled="vm.userLogued.user_type > vm.staffSelected.user_type" type="text" name="id_number" \nng-model="vm.staffSelected.id_number" placeholder="" autocomplete="false"></md-input-container><md-input-container \nclass="md-block"><label translate="STAFF.EMAIL"></label> <input \nng-disabled="vm.userLogued.user_type > vm.staffSelected.user_type" type="email" name="email" \nng-model="vm.staffSelected.email" placeholder="" autocomplete="false" required></md-input-container><md-input-container\n class="md-block"><label translate="STAFF.PASSWORD"></label> <input \nng-disabled="vm.userLogued.user_type > vm.staffSelected.user_type" type="password" name="password" \nng-model="vm.staffSelected.password" placeholder="" autocomplete="false"></md-input-container><md-input-container \nclass="md-block"><label translate="STAFF.PHONE"></label> <input \nng-disabled="vm.userLogued.user_type > vm.staffSelected.user_type" type="phone" name="phone" \nng-model="vm.staffSelected.phone" placeholder="" autocomplete="false"></md-input-container><md-input-container \nclass="md-block" ng-if="vm.staffSelected[\'3rd_party_company_name\']"><label translate="STAFF.3RD_PARTY_COMPANY"></label>\n <input ng-disabled="vm.userLogued.user_type > vm.staffSelected.user_type" type="phone" name="phone" \nng-model="vm.staffSelected[\'3rd_party_company_name\']" placeholder="" autocomplete="false"></md-input-container><div \nng-if="vm.userLogued.user_type > vm.staffSelected.user_type" class="md-block"><div><div ngf-drop ngf-select \nng-model="vm.files" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="image/*" ngf-pattern="\'image/*\'"><div layout="column"><div flex translate="GLOBAL.DROP_HERE">\nDrop here or click to upload</div><div flex translate="GLOBAL.OR"></div><div flex><md-button \nclass="send-button md-accent md-raised" aria-label="Select files" translate="GLOBAL.SELECT_FILES"></md-button></div>\n</div></div><div ngf-no-file-drop translate="GLOBAL.FILE_DRAG_DROP"></div></div><div ng-repeat="f in vm.files" \nclass="ms-card" flex><div ng-if="!f.url" class="ms-card-content-wrapper"><div class="template-9"><div class="media" \nflex layout="row" layout-align="center center"><img ngf-thumbnail="!f.$error && f" class="image"></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><strong class="mr-5" ng-if="f.id">#{{f.id}}</strong> <span class="grey-500-fg"><span \nng-if="f.name">{{f.name}}</span></span></div></div></div><md-progress-linear md-mode="determinate" \nvalue="{{f.progress}}" ng-show="f.progress < 100"></md-progress-linear></div></div><div ng-if="f.url" \nstyle="max-width: 300px;" class="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><img style="max-width: 200px" ng-src="{{storagePrefix + f.url}}" class="image"></div><div \nclass="p-16" flex layout="row" layout-align="end center"><md-menu class="float-right"><md-button \nclass="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.deleteAvatar(f)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-content></md-menu></div>\n<md-progress-linear md-mode="determinate" value="{{f.progress}}" ng-show="f.progress < 100"></md-progress-linear></div>\n</div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/staffsroi/views/edit/edit-new.html','<div class="mail-content file-details scrollable" ms-scroll="vm.msScrollOptions"><div layout="row"><div \nclass="form-wrapper md-whiteframe-1dp" flex="100"><div><md-input-container ng-if="vm.staffNew.user_type != 1" \nclass="md-block mt-0 mb-0"><button ng-if="vm.staffNew.enabled" class="md-icon-button md-button"><md-icon \nmd-font-icon="icon-checkbox-marked-circle" class="on green-fg s24" ng-click="vm.toggleStaffStatusEdit(\'enabled\')">\n</md-icon></button> <button ng-if="!vm.staffNew.enabled" class="md-icon-button md-button"><md-icon \nmd-font-icon="icon-checkbox-blank-circle-outline" class="off red-fg s24" \nng-click="vm.toggleStaffStatusEdit(\'enabled\')"></md-icon></button> <label ng-if="vm.staffNew.enabled" class="inline" \ntranslate="STAFF.ACTIVE"></label> <label ng-if="!vm.staffNew.enabled" class="inline" translate="STAFF.INACTIVE">\n</label></md-input-container><md-input-container ng-if="vm.fromComplaint" class="md-block mt-0 mb-0"><label \ntranslate="STAFF.USER_TYPE"></label><md-select required ng-model="vm.staffNew.user_type"><md-option \nng-if="vm.userLogued.user_type <21" ng-value="20" translate="GLOBAL.ADMINISTRATOR"></md-option><md-option \nng-if="vm.userLogued.user_type <22" ng-value="21" translate="STAFF.COMPANY_ADMIN"></md-option><md-option ng-value="22" \ntranslate="STAFF.SRROI_STAFF"></md-option></md-select></md-input-container><md-input-container class="md-block"><label \ntranslate="STAFF.FIRSTNAME"></label> <input type="text" name="firstname" ng-model="vm.staffNew.first_name" \nplaceholder="" required autocomplete="false"></md-input-container><md-input-container class="md-block"><label \ntranslate="STAFF.LASTNAME"></label> <input type="text" name="lastname" ng-model="vm.staffNew.last_name" placeholder="" \nrequired autocomplete="false"></md-input-container><md-input-container class="md-block"><label>\n{{vm.getRegionLiteral(\'id_number\')}}</label> <input type="text" name="id_number" ng-model="vm.staffNew.id_number" \nplaceholder="" autocomplete="false"></md-input-container><md-input-container class="md-block"><label \ntranslate="STAFF.EMAIL"></label> <input type="email" name="email" ng-model="vm.staffNew.email" placeholder="" required \nautocomplete="false"></md-input-container><md-input-container class="md-block"><label translate="STAFF.PASSWORD">\n</label> <input type="password" name="password" ng-model="vm.staffNew.password" placeholder="" autocomplete="false">\n</md-input-container><md-input-container class="md-block"><label translate="STAFF.PHONE"></label> <input type="phone" \nname="phone" ng-model="vm.staffNew.phone" placeholder="" autocomplete="false"></md-input-container><div \nclass="md-block"><div><div ngf-drop ngf-select ng-model="vm.files" class="drop-box" ngf-drag-over-class="\'dragover\'" \nngf-multiple="true" ngf-allow-dir="true" accept="image/*" ngf-pattern="\'image/*\'"><div layout="column"><div flex \ntranslate="GLOBAL.DROP_HERE">Drop here or click to upload</div><div flex translate="GLOBAL.OR"></div><div flex>\n<md-button class="send-button md-accent md-raised" aria-label="Select files" translate="GLOBAL.SELECT_FILES">\n</md-button></div></div></div><div ngf-no-file-drop translate="GLOBAL.FILE_DRAG_DROP"></div></div><div \nng-repeat="f in vm.files" class="ms-card" flex><div class="ms-card-content-wrapper"><div class="template-9"><div \nclass="media" flex layout="row" layout-align="center center"><img ngf-thumbnail="!f.$error && f" class="image"></div>\n<div class="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" \nlayout="row" layout-align="start left"><strong class="mr-5" ng-if="f.id">#{{f.id}}</strong> <span class="grey-500-fg">\n<span ng-if="f.name">{{f.name}}</span></span></div></div></div><md-progress-linear md-mode="determinate" \nvalue="{{f.progress}}" ng-show="f.progress <100"></md-progress-linear></div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/staffsroi/views/edit/edit-preview.html','<md-list-item flex="100" on="field.type" role="listitem" class="first-item-list"><div class="text-truncate" flex="100">\n<div class="field"><p class="grey-500-fg font-size-14" translate="STAFF.FIRSTNAME"></p><p \nclass="font-size-16 text-truncate" ng-bind-html="vm.staffSelected.first_name"></p></div></div></md-list-item>\n<md-list-item flex="100" on="field.type" role="listitem" class="item-list"><div class="text-truncate" flex="100"><div \nclass="field"><p class="grey-500-fg font-size-14" translate="STAFF.LASTNAME"></p><p class="font-size-16 text-truncate" \nng-bind-html="vm.staffSelected.last_name"></p></div></div></md-list-item><md-list-item flex="100" on="field.type" \nrole="listitem" class="item-list"><div class="text-truncate" flex="100"><div class="field"><p \nclass="grey-500-fg font-size-14">{{vm.getRegionLiteral(\'id_number\')}}</p><p class="font-size-16 text-truncate" \nng-bind-html="vm.staffSelected.id_number"></p></div></div></md-list-item><md-list-item flex="100" on="field.type" \nrole="listitem" class="item-list"><div class="text-truncate" flex="100"><div class="field"><p \nclass="grey-500-fg font-size-14" translate="STAFF.EMAIL"></p><p class="font-size-16 text-truncate" \nng-bind-html="vm.staffSelected.email"></p></div></div></md-list-item><md-list-item flex="100" on="field.type" \nrole="listitem" class="item-list"><div class="text-truncate" flex="100"><div class="field"><p \nclass="grey-500-fg font-size-14" translate="STAFF.PHONE"></p><p class="font-size-16 text-truncate" \nng-bind-html="vm.staffSelected.phone"></p></div></div></md-list-item><md-list-item flex="100" on="field.type" \nrole="listitem" class="item-list" ng-if="vm.staffSelected[\'3rd_party_company_name\']"><div class="text-truncate" \nflex="100"><div class="field"><p class="grey-500-fg font-size-14" translate="STAFF.3RD_PARTY_COMPANY"></p><p \nclass="font-size-16 text-truncate" ng-bind-html="vm.staffSelected[\'3rd_party_company_name\']"></p></div></div>\n</md-list-item>');
$templateCache.put('app/main/apps/staffsroi/views/edit/edit-tasks.html','test 2');
$templateCache.put('app/main/apps/staffsroi/views/edit/edit-view-nosplit.html','<div flex layout="column" layout-align="center center" ng-if="vm.loadingReadPane" class="loading-container">\n<md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div><div \nng-show="!vm.loadingReadPane"><div class="mail-content" layout="column" layout-align="center center" \nng-if="!vm.staffSelected"><div class="content" layout="column" layout-align="top center"><div class="message">\nPlease select a user to show in this panel</div></div></div><form name="vm.basicForm" class="md-inline-form" \nnovalidate><md-content ng-if="vm.staffSelected && !vm.editData" \nng-include="\'app/main/apps/staff/views/edit/edit-tabs.html\'" class="scrollable"></md-content><md-content \nng-if="vm.staffSelected && vm.editData" ng-include="\'app/main/apps/staff/views/edit/edit-data.html\'" \nclass="scrollable"></md-content></form></div>');
$templateCache.put('app/main/apps/staffsroi/views/edit/edit-view.html','<md-list ng-if="vm.staffSelected" class="pv-20 ph-8 border-bottom"><md-list-item class="main-item" \nstyle="padding-left: 0px;" flex layout="row" layout-align="start center"><div layout="row" layout-align="start center">\n<div class="main-read"><div class="avatar-container"><user-avatar user="vm.staffSelected"></div></div><div \nclass="main-read"><h1 class="name"><strong ng-bind-html="vm.staffSelected.first_name"></strong> <strong \nng-bind-html="vm.staffSelected.last_name"></strong></h1><p><span class="font-size-16 text-truncate" \nng-bind-html="vm.staffSelected.email"></span></p></div></div><div hide show-gt-sm flex layout="row" \nlayout-align="end center"><md-input-container ng-if="vm.staffSelected.user_type != 1" class="md-block mt-0 mb-0">\n<button ng-if="vm.staffSelected.enabled" class="md-icon-button md-button"><md-icon \nmd-font-icon="icon-checkbox-marked-circle" class="on green-fg s24"></md-icon></button> <button \nng-if="!vm.staffSelected.enabled" class="md-icon-button md-button"><md-icon \nmd-font-icon="icon-checkbox-blank-circle-outline" class="off red-fg s24"></md-icon></button></md-input-container><label\n ng-if="vm.staffSelected.enabled" class="inline" translate="STAFF.ACTIVE"></label> <label \nng-if="!vm.staffSelected.enabled" class="inline" translate="STAFF.INACTIVE"></label></div></md-list-item></md-list><div\n ng-if="(vm.staffSelected || vm.staffNew || vm.loadingReadPane)" class="toolbar colored-bg" layout="row" \nlayout-align="space-between center" ng-if="vm.staffSelected || vm.staffNew" scroll=""><div layout="row" \nlayout-align="start center"><md-button aria-label="Edit" class="md-icon-button" translate="" \nng-click="vm.viewPreviewData()" translate-attr-aria-label="STAFF.EDIT" \nng-class="{\'tab-selected\': vm.tabActive==\'preview\' || vm.tabActive==\'editnew\' || vm.tabActive==\'edit\'}"><md-icon \nmd-font-icon="icon-account"></md-icon><md-tooltip hide show-gt-sm><span translate="STAFF.EDIT">Edit</span></md-tooltip>\n</md-button><div ng-if="vm.staffSelected && !vm.fromComplaint" class="divider-vertical" hide="" show-gt-sm=""></div>\n<md-button ng-if="vm.staffSelected && !vm.fromComplaint" aria-label="Companies" class="md-icon-button" translate="" \nng-click="vm.viewEditCompanies();" translate-attr-aria-label="STAFF.POSITIONS" \nng-class="{\'tab-selected\': vm.tabActive==\'companies\'}"><md-icon md-font-icon="icon-city"></md-icon><md-tooltip hide \nshow-gt-sm><span translate="STAFF.POSITIONS">POSITIONS</span></md-tooltip></md-button><div \nng-if="vm.staffSelected && !vm.fromComplaint" class="divider-vertical" hide="" show-gt-sm=""></div><md-button \nng-if="vm.staffSelected && !vm.fromComplaint" aria-label="Activity" class="md-icon-button" translate="" \nng-click="vm.viewActivity();" translate-attr-aria-label="STAFF.ACTIVITY" \nng-class="{\'tab-selected\': vm.tabActive==\'activity\'}"><md-icon md-font-icon="icon-run"></md-icon><md-tooltip hide \nshow-gt-sm><span translate="STAFF.ACTIVITY">ACTIVITY</span></md-tooltip></md-button><div \nng-if="vm.staffSelected && !vm.fromComplaint" class="divider-vertical" hide="" show-gt-sm=""></div><md-button \nng-if="vm.staffSelected && !vm.fromComplaint" aria-label="Task" class="md-icon-button" translate="" \nng-click="vm.viewTask();" translate-attr-aria-label="STAFF.TASKS" ng-class="{\'tab-selected\': vm.tabActive==\'tasks\'}">\n<md-icon md-font-icon="icon-timelapse"></md-icon><md-tooltip hide show-gt-sm><span translate="STAFF.TASKS">TASKS</span>\n</md-tooltip></md-button><div ng-if="vm.staffSelected && !vm.fromComplaint" class="divider-vertical" hide="" \nshow-gt-sm=""></div><md-button ng-if="vm.isAvailableConfigureMenu()" aria-label="Menu" class="md-icon-button" \ntranslate="" ng-click="vm.viewConfigureTabs() " translate-attr-aria-label="USERS.COMPANIES" \nng-class="{\'tab-selected\': vm.tabActive==\'configuretabs\'}"><md-icon md-font-icon="icon-cog"></md-icon><md-tooltip hide \nshow-gt-sm><span translate="USERS.MENU">MENU</span></md-tooltip></md-button></div><div \nng-if="vm.tabActive == \'preview\'" flex layout="row" layout-align="end center"><div layout="row" \nlayout-align="end center" hide show-gt-sm><md-button type="submit" ng-click="vm.viewEditData()" \nclass="send-button md-accent md-raised" aria-label="EDIT" translate="STAFF.EDIT" \ntranslate-attr-aria-label="STAFF.EDIT">EDIT</md-button></div><div layout="row" layout-align="end center" hide-gt-sm>\n<md-button type="submit" ng-click="vm.viewEditData()" \nclass="md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" aria-label="EDIT"><md-icon \nmd-font-icon="icon-pencil" ng-hide="vm.savingProcess"></md-icon><md-progress-circular md-mode="indeterminate" \nng-if="vm.savingProcess"></md-progress-circular><md-tooltip hide show-gt-sm><span translate="STAFF.EDIT">EDIT</span>\n</md-tooltip></md-button></div></div><div ng-if="vm.tabActive == \'edit\' || vm.tabActive == \'editnew\'" flex \nlayout="row" layout-align="end center"><div layout="row" layout-align="end center" \nng-if="vm.staffSelected || vm.staffNew" hide show-gt-sm><md-button type="button" \nng-click="vm.viewPreviewData(); vm.resetStaffSelected()" class="md-raised md-warn" aria-label="Cancel" \ntranslate="STAFF.CANCEL" translate-attr-aria-label="STAFF.CANCEL">Cancel</md-button><md-button type="submit" \nng-click="vm.saveStaff($event)" class="send-button md-accent md-raised" \nng-disabled="vm.basicForm.$invalid || vm.basicForm.$pristine" aria-label="SAVE" translate="STAFF.SAVE" \ntranslate-attr-aria-label="STAFF.SAVE">SAVE</md-button></div><div layout="row" layout-align="end center" \nng-if="(vm.staffSelected || vm.staffNew)" hide-gt-sm><md-button type="button" \nng-click="vm.viewPreviewData(); vm.resetStaffSelected()" \nclass="md-warn md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" aria-label="Cancel"><md-icon \nmd-font-icon="icon-window-close"></md-icon><md-tooltip hide show-gt-sm><span translate="STAFF.CANCEL">Cancel</span>\n</md-tooltip></md-button><md-button type="submit" ng-click="vm.saveStaff($event)" \nclass="md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" \nng-disabled="vm.basicForm.$invalid || vm.basicForm.$pristine" aria-label="SAVE"><md-icon md-font-icon="icon-check" \nng-hide="vm.savingProcess"></md-icon><md-progress-circular md-mode="indeterminate" ng-if="vm.savingProcess">\n</md-progress-circular><md-tooltip hide show-gt-sm><span translate="STAFF.SAVE">Save</span></md-tooltip></md-button>\n</div></div></div><div class="content thread-detail" layout="row" layout-align="center center" flex \nng-if="vm.loadingReadPane"><div flex layout="column" layout-align="center center" class="loading-container">\n<md-progress-circular md-mode="indeterminate" md-diameter="50"></md-progress-circular></div></div><div \nclass="content thread-detail" layout="row" layout-align="center center" flex \nng-if="!vm.staffSelected && !vm.staffNew && !vm.loadingReadPane"><div class="no-thread-selected" layout="column" \nlayout-align="center center" flex><md-icon md-font-icon="icon-clipboard-account" class="s120 grey-400-fg"></md-icon>\n<span class="hint-text" translate="STAFF.SELECT_USER"></span></div></div><div \nng-if="vm.fromComplaint && vm.tabActive==\'editnew\' &&  !vm.fromComplaint" ng-init="vm.tabNewSelected= \'new\'" \nclass="toolbar colored-bg" layout="row" layout-align="space-between center" scroll=""><div layout="row" \nlayout-align="start center"><md-button aria-label="Edit" class="md-icon-button" translate="" \ntranslate-attr-aria-label="STAFF.EDIT" ng-click="vm.tabNewSelected= \'new\'" \nng-class="{\'tab-selected\': vm.tabNewSelected==\'new\'}"><md-icon md-font-icon="icon-account"></md-icon><md-tooltip hide \nshow-gt-sm><span translate="STAFF.EDIT">New</span></md-tooltip></md-button><div ng-if="vm.userLogued.user_type <= 2" \nclass="divider-vertical" hide="" show-gt-sm=""></div><md-button ng-if="vm.userLogued.user_type <= 2" \naria-label="Admins" class="md-icon-button" translate="" ng-click="vm.tabNewSelected= \'admins\'" \ntranslate-attr-aria-label="STAFF.ADMINS" ng-class="{\'tab-selected\': vm.tabNewSelected==\'admins\'}"><md-icon \nmd-font-icon="icon-city"></md-icon><md-tooltip hide show-gt-sm><span translate="STAFF.ADMINS">ADMINS</span>\n</md-tooltip></md-button></div><div ng-if="vm.tabActive == \'edit\' || vm.tabActive == \'editnew\'" flex layout="row" \nlayout-align="end center"><div layout="row" layout-align="end center" ng-if="vm.staffSelected || vm.staffNew" hide \nshow-gt-sm><md-button type="button" ng-click="vm.viewPreviewData(); vm.resetStaffSelected()" class="md-raised md-warn" \naria-label="Cancel" translate="STAFF.CANCEL" translate-attr-aria-label="STAFF.CANCEL">Cancel</md-button><md-button \ntype="submit" ng-click="vm.saveStaff($event)" class="send-button md-accent md-raised" \nng-disabled="vm.basicForm.$invalid || vm.basicForm.$pristine" aria-label="SAVE" translate="STAFF.SAVE" \ntranslate-attr-aria-label="STAFF.SAVE">SAVE</md-button></div><div layout="row" layout-align="end center" \nng-if="(vm.staffSelected || vm.staffNew)" hide-gt-sm><md-button type="button" \nng-click="vm.viewPreviewData(); vm.resetStaffSelected()" \nclass="md-warn md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" aria-label="Cancel"><md-icon \nmd-font-icon="icon-window-close"></md-icon><md-tooltip hide show-gt-sm><span translate="STAFF.CANCEL">Cancel</span>\n</md-tooltip></md-button><md-button type="submit" ng-click="vm.saveStaff($event)" \nclass="md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" \nng-disabled="vm.basicForm.$invalid || vm.basicForm.$pristine" aria-label="SAVE"><md-icon md-font-icon="icon-check" \nng-hide="vm.savingProcess"></md-icon><md-progress-circular md-mode="indeterminate" ng-if="vm.savingProcess">\n</md-progress-circular><md-tooltip hide show-gt-sm><span translate="STAFF.SAVE">Save</span></md-tooltip></md-button>\n</div></div></div><form name="vm.basicForm" style="height: calc(100% - 64px)" class="md-inline-form" novalidate \nng-if="!vm.loadingReadPane && (vm.staffSelected || vm.staffNew) && vm.tabNewSelected !== \'admins\'"><div \nstyle="height: 100%" class="mail-content file-details scrollable" ms-scroll="vm.msScrollOptions"><md-content \nstyle="margin-bottom: 100px; overflow: hidden;" ng-if="vm.tabActive==\'preview\'" \nng-include="\'app/main/apps/staffsroi/views/edit/edit-preview.html\'" class="scrollable"></md-content><md-content \nstyle="margin-bottom: 100px; overflow: hidden;" ng-if="vm.tabActive==\'editnew\'" \nng-include="\'app/main/apps/staffsroi/views/edit/edit-new.html\'" class="scrollable"></md-content><md-content \nstyle="margin-bottom: 100px; overflow: hidden;" ng-if="vm.tabActive==\'edit\'" \nng-include="\'app/main/apps/staffsroi/views/edit/edit-data.html\'" class="scrollable"></md-content><md-content \nstyle="margin-bottom: 100px; overflow: hidden;" ng-if="vm.tabActive==\'companies\'" \nng-include="\'app/main/apps/staffsroi/views/edit/edit-companies.html\'" class="scrollable"></md-content><activity-user \nng-show="vm.tabActive==\'activity\'" ng-if="vm.staffSelected.id" id-user="vm.staffSelected.id"></activity-user>\n<tasks-user ng-show="vm.tabActive==\'tasks\'" ng-if="vm.staffSelected.id" id-user="vm.staffSelected.id"></tasks-user>\n<configure-tabs ng-show="vm.tabActive==\'configuretabs\'" ng-if="vm.staffSelected.id" user-logued="vm.userLogued" \nuser-selected="vm.staffSelected"></configure-tabs></div></form><div \nstyle="overflow: auto; max-height: calc(100vh - 194px);" ng-if="vm.tabNewSelected == \'admins\' && vm.fromComplaint"><div\n style="max-height: 100%;" id="site-client"><div class="search-input-wrapper border-bottom" layout="row" \nlayout-align="start center"><md-icon class="mr-10 ml-20" md-font-icon="icon-magnify"></md-icon><input id="search2" \nplaceholder="{{\'CONTACTS.SEARCH_FOR_ANYONE\' | translate}}" type="text" ng-model="searchTextAll" class="flex h-60">\n</div><div style="max-height: 100%; overflow: hidden;" class="content thread-list mail-list-pane p0" flex="" \nid="thread-list"><div id="list-content-data" ng-style="{\'opacity\' : isLoading ? 0.5 : 1}"><div \nclass="mail-list-item p0" \nng-repeat="user in vm.adminUsers | filter:searchTextAll | filter:filterAlreadyAdded | orderBy: \'name\'" \nng-init="parentIndex= $index" md-no-ink ng-click="vm.selectUserNew(user)" \nng-class="{\'starred\': user.starred, \'selected\': vm.selectedContentID !== user.id_mailing_content, \'checked\': vm.isChecked(user)}">\n<div layout="row" layout-align="start center" flex="100" class="pl-15 pt-10 pb-10"><div class="info" flex \nlayout="column"><div class="name" layout="row"><div layout="row" layout-align="start center" flex="100"><div \nclass="avatar-wrapper"><img class="avatar s24" ng-src="{{vm.showUserImage(user)}}" ng-if="user.files.id"><div \nclass="avatar s24" ng-class="user.profile_color ? user.profile_color : \'md-blue-grey-300-bg\'" ng-if="!user.files.id" \nng-bind="user.first_name | capitalizeFirstLetter"></div></div><div class="field mr-10 ml-10" flex><strong \nclass="grey-800-fg" ng-bind-html="user.first_name + \' \' + user.last_name"></strong></div></div></div></div></div></div>\n</div></div></div></div>');
$templateCache.put('app/main/apps/staffsroi/views/edit/view-activity.html','<div class="mail-content file-details scrollable" ms-scroll="vm.msScrollOptions"><md-list><md-list-item \nng-if="vm.staffSelectedID" class="main-item"><div class="main-read"><div class="avatar-container"><div \nng-if="(vm.staffSelected.avatar == \'\' || !vm.staffSelected.avatar)" class="avatar" \nng-bind="vm.staffSelected.first_name | capitalizeFirstLetter" \nng-style="{\'background-color\': vm.staffSelected.profile_color }"></div><div ng-if="vm.staffSelected.avatar" \nattachment="vm.staffSelected.avatar"><img class="avatar hide show spinner-show" ng-src="{{vm.staffSelected.avatar}}" \nimageonload=""></div><md-icon ng-if="vm.staffSelected.active ===1" md-font-icon="icon-checkbox-marked-circle" \nclass="on green-fg s24"></md-icon><md-icon ng-if="vm.staffSelected.active !==1" \nmd-font-icon="icon-checkbox-blank-circle-outline" class="off red-fg s24"></md-icon></div></div><div class="main-read">\n<h1 class="name"><strong ng-bind-html="vm.staffSelected.first_name"></strong> <strong \nng-bind-html="vm.staffSelected.last_name"></strong></h1><p><span class="font-size-16 text-truncate" \nng-bind-html="vm.staffSelected.email"></span></p></div></md-list-item><md-divider></md-divider><md-list-item \nclass="md-toolbar-tools grey-100-bg" layout="row" layout-align="space-between center"><div layout="row" \nlayout-align="start center"><h3 class="grey-700-fg" translate="ACCOUNTS.ACTIVITY"></h3></div></md-list-item>\n<md-divider></md-divider><div class="activities-list"><table hide show-gt-lg><tr \nng-repeat="log in vm.staffSelected.log"><td><div layout="row" layout-align="start center"><md-icon \nmd-font-icon="{{log.module.icon_v3}}" class="mr-10 ml-0 s30"><md-tooltip hide show-gt-xs><span>{{log.module.title}}\n</span></md-tooltip></md-icon><div><div class="field module-name" ng-if="log.id_service == 2"><span \nclass="grey-800-fg" ng-bind-html="log.section.languages[0].text"></span></div><div class="field module-name" \nng-if="log.id_service != 2"><span class="grey-800-fg" ng-bind-html="log.module.module_name"></span></div></div></div>\n</td><td><div class="field" layout="row" layout-align="start center"><div layout="row" layout-align="end center"><span \nclass="grey-500-fg" ng-bind-html="vm.timeAgo(log.date)"></span></div></div></td><td><div class="field"><span \nclass="grey-800-fg mr-5">ID #{{log.id_from_section}}</span> <span class="grey-500-fg" ng-bind-html="log.description">\n</span></div></td><td><div class="field" layout="row" layout-align="end center"><span \nclass="status {{log.action.action_name}}" ng-bind-html="log.action.action_name"></span></div></td></tr></table>\n<md-list-item hide-gt-lg ng-repeat="log in vm.staffSelected.log" class="pl-16 pr-16"><div layout="row" \nlayout-align="space-between center" flex="100" class="layout-align-space-between-center layout-row"><md-icon \nmd-font-icon="{{log.module.icon_v3}}" class="mr-16 ml-0 s30" hide show-gt-xs><md-tooltip hide show-gt-xs><span>\n{{log.module.module_name}}</span></md-tooltip></md-icon><div layout="column" layout-align="center space-between " \nclass="field flex"><div layout="row" layout-align-gt-xs="start center" layout-align-xs="space-between center" \nclass="mb-10"><div layout="row" layout-align="start center"><md-icon md-font-icon="{{log.module.icon_v3}}" \nclass="mr-5 ml-0" hide-gt-xs><md-tooltip hide show-gt-xs><span>{{log.module.module_name}}</span></md-tooltip></md-icon>\n<div class="field mr-10 module-name"><span class="grey-800-fg" ng-if="log.id_service == 2" \nng-bind-html="log.section.languages[0].text"></span> <span class="grey-800-fg" ng-if="log.id_service != 2" \nng-bind-html="log.module.module_name"></span></div><span class="grey-500-fg" ng-bind-html="vm.timeAgo(log.date)">\n</span></div><div class="field" hide-gt-xs><span class="status {{log.action.action_name}}" \nng-bind-html="log.action.action_name"></span></div></div><div class="text-truncate"><span class="grey-800-fg mr-5">\nID #{{log.id_from_section}}</span> <span class="grey-500-fg" ng-bind-html="log.description"></span></div></div><div \nlayout="row" layout-align="end center" hide show-gt-xs><div class="field"><span \nclass="status {{log.action.action_name}}" ng-bind-html="log.action.action_name"></span></div></div></div><md-divider \nclass="md-default-theme"></md-divider></md-list-item></div></md-list></div>');
$templateCache.put('app/main/apps/tasks/dialogs/task-edit-status-dialog/task-edit-status-dialog.html','<md-dialog id="task-edit-status-dialog" class="form-dialog" aria-label="Odds of occurence"><md-toolbar \nclass="md-accent"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><h1 \ntranslate="TASKS.EDIT_STATUS"></h1><div class="absolute-right pr-10" layout="row"><md-button class="md-icon-button" \nng-click="vm.closeDialog()" aria-label="Close dialog" tranlate translate-aria-label="GLOBAL.CLOSE_DIALOG"><md-icon \nmd-font-icon="icon-close"></md-icon></md-button></div></div></md-toolbar><md-dialog-content \nclass="mediadialog-content" flex><div class="ph-25"><md-input-container class="md-block status-radio"><md-radio-group \nng-model="vm.task.status_id"><md-radio-button ng-value="1"><span>{{\'RISK.TASK_PENDING\' | translate}} </span><span \nng-if="vm.dateExpired(vm.task.due_by_date)">({{ \'RISK.TASK_EXPIRED\' | translate}})</span></md-radio-button>\n<md-radio-button ng-value="2"><span>{{\'RISK.TASK_IN_PROGRESS\' | translate}} </span><span \nng-if="vm.dateExpired(vm.task.due_by_date)">({{ \'RISK.TASK_EXPIRED\' | translate}})</span></md-radio-button>\n<md-radio-button ng-value="3"><span>{{\'RISK.TASK_COMPLETED\' | translate}} </span><span \nng-if="vm.dateExpired(vm.task.due_by_date)">({{ \'RISK.TASK_EXPIRED\' | translate}})</span></md-radio-button>\n</md-radio-group></md-input-container></div></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="end center" class="grey-100-bg"><md-button translate="GLOBAL.CANCEL" type="button" \nng-click="vm.closeDialog()" class="md-raised md-warn" aria-label="Cancel"></md-button><md-button \ntranslate="GLOBAL.SAVE" type="button" ng-click="vm.saveDialog()" class="md-raised md-accent" aria-label="Save">\n</md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/main/apps/staffsroi/views/list/list-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="isLoading" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="no-threads" ng-if="!vm.staffsroi" ng-hide="isLoading" translate="GLOBAL.NO_ITEMS"></div><div \nid="list-content-data" style="height: 100%;" ng-style="{\'opacity\' : isLoading ? 0.5 : 1}"><div class="mail-list-item" \nng-repeat="item in vm.staffsroi | filter: vm.search | filter: global.search" ng-init="parentIndex = $index" md-no-ink \nng-click="vm.openStaff(item)" \nng-class="{\'starred\': item.starred, \'selected\': vm.staffSelected.id === item.id, \'checked\': vm.isSelected(item)}"><div \nlayout="row" layout-align="start center"><md-checkbox ng-if="item.user_type != 1" class="no-label" \nng-checked="vm.isSelected(item)" ng-click="vm.toggleSelectThread(item, $event)" \naria-label="{{vm.isSelected(item) ? \'Deselect\' : \'Select\'}}"></md-checkbox><div class="avatar-wrapper"><user-avatar \nuser="item"></div><div class="info layout-column flex" flex="" layout="column"><div class="name text-truncate" \nlayout="row" layout-align="start center"><span>{{item.first_name}}</span> <span>{{item.last_name}}</span></div><div \nclass="details text-truncate" layout="row" layout-align="start center"><span>{{item.email}}</span></div></div><div \nclass="info flex" flex="" layout-align="center end" layout="column"><div layout="row" layout-align="start center">\n<md-input-container ng-if="item.user_type != 1" class="md-block mt-0 mb-0"><button ng-if="item.enabled" \nclass="md-icon-button md-button"><md-icon md-font-icon="icon-checkbox-marked-circle" class="on green-fg s24" \nng-click="vm.toggleStaffStatusEdit(\'enabled\',item)"></md-icon></button> <button ng-if="!item.enabled" \nclass="md-icon-button md-button"><md-icon md-font-icon="icon-checkbox-blank-circle-outline" class="off red-fg s24" \nng-click="vm.toggleStaffStatusEdit(\'enabled\',item)"></md-icon></button></md-input-container></div></div></div></div>\n<div ng-if="!isLoading && pagination_total_pages > pagination_page && vm.staffsroi.length > 0" \nclass="load-more white p-30" layout="row" layout-sm="column" layout-align="center center" layout-wrap=""><md-button \nng-click="pagination_nextPage(true)" class="md-raised">{{\'GLOBAL.LOAD_MORE\' |\xA0translate}}</md-button></div><div \nng-if="pagination_total_pages == pagination_page && pagination_page > 1" class="load-more white p-30" layout="row" \nlayout-sm="column" layout-align="center center" layout-wrap=""><div class="message" translate="GLOBAL.NO_MORE_ITEMS">\n</div></div><div ng-if="!vm.staffsroi || vm.staffsroi.length == 0" class="content-wrapper fullheight" layout="row" \nflex ng-hide="vm.isLoading"><div class="content thread-detail" layout="row" layout-align="center center" flex><div \nclass="no-client-selected no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-timelapse" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="STAFF.THERE_ARE_NO_USERS_WITH_THIS_FILTERS"></span></div></div></div></div>');
$templateCache.put('app/main/apps/staffsroi/views/list/nosplit-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.staffSelected && !vm.staffNew" \nng-include="\'app/main/apps/staffsroi/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row">\n<div class="content thread-detail mail-read-pane p0 scrollable" flex="" id="thread-detail" \nms-scroll="vm.msScrollOptions" ng-if="vm.staffSelected || vm.staffNew" \nng-include="\'app/main/apps/staffsroi/views/edit/edit-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="!vm.staffSelected && !vm.staffNew" ng-include="\'app/main/apps/staffsroi/views/list/list-view.html\'"></div></div>');
$templateCache.put('app/main/apps/staffsroi/views/list/split-view.html','<div class="toolbar" layout="row" layout-align="space-between center" \nng-include="\'app/main/apps/staffsroi/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row">\n<div class="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-include="\'app/main/apps/staffsroi/views/list/list-view.html\'"></div><div \nclass="content thread-detail mail-read-pane p0" flex="" id="thread-detail" \nng-include="\'app/main/apps/staffsroi/views/edit/edit-view.html\'"></div></div>');
$templateCache.put('app/main/apps/staffsroi/views/list/toolbar.html','<div layout="row" layout-align="start center"><md-checkbox class="no-label" \naria-label="{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}" \nng-checked="vm.selectedThreads.length > 0" ng-click="vm.toggleSelectThreads(vm.selectedThreads, vm.contents)">\n</md-checkbox><div class="divider-vertical" hide="" show-gt-xs=""></div><md-button aria-label="NEW" \nclass="md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme" hide show-gt-sm \nng-click="vm.newStaff($event)" translate="GLOBAL.NEW" type="button"></md-button><md-button aria-label="NEW" \nclass="md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme z-index-0" hide-gt-sm \nng-click="vm.newStaff($event)" type="button"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="divider-vertical" hide="" show-gt-xs=""></div><div aria-hidden="false" \nclass="action-buttons hide show-gt-xs layout-align-start-center layout-row" layout="row" layout-align="start center" \nng-show="vm.selectedThreads.length > 0"><div class="divider-vertical" hide="" show-gt-xs=""></div></div><md-menu-bar \nng-if="!vm.fromComplaint" id="user-menu" class="p0"><md-menu md-position-mode="left bottom"><md-button \nclass="user-button m0" ng-click="$mdMenu.open()" aria-label="User settings" translate \ntranslate-attr-aria-label="TOOLBAR.USER_SETTINGS"><div layout="row" layout-align="space-between center"><span \nng-if="vm.branchSelected" class="username">{{vm.branchSelected.name}}</span> <span ng-if="!vm.branchSelected" \nclass="username" translate="GLOBAL.ALL_BRANCHES"></span><md-icon md-font-icon="icon-chevron-down" class="icon s16">\n</md-icon></div></md-button><md-menu-content width="3" class="clients"><md-menu-item class="md-indent"><div \nclass="search-input-wrapper" layout="row" layout-align="start center"><label for="search"><md-icon \nmd-font-icon="icon-magnify"></md-icon></label><md-input-container md-no-float class="m-0"><input id="search" \nplaceholder="{{\'RISK.SEARCH_FOR_BRANCH\' |\xA0translate}}" type="text" ng-model="vm.searchBranchText"></md-input-container>\n</div></md-menu-item><div class="results"><md-menu-item ng-if="vm.searchBranchText == \'\'" \nng-click="vm.selectBranch(null)" class="md-indent bar-client"><div><md-icon md-font-icon="icon-account" \nclass="icon s16"></md-icon><button class="btn-clients" translate="GLOBAL.ALL_BRANCHES"></button></div></md-menu-item>\n<md-menu-item ng-click="vm.selectBranch(branch)" class="md-indent bar-client" \nng-repeat="branch in vm.companyBranches | filter:vm.searchBranchText"><div ng-if="branch"><md-icon \nmd-font-icon="icon-account" class="icon s16"></md-icon><button class="btn-clients">{{branch.name}}</button></div>\n</md-menu-item></div></md-menu-content></md-menu></md-menu-bar><div ng-if="!vm.fromComplaint" class="divider-vertical" \nhide="" show-gt-xs=""></div><md-menu-bar ng-if="!vm.fromComplaint" id="user-menu" class="p0"><md-menu \nmd-position-mode="left bottom"><md-button class="user-button m0" ng-click="$mdMenu.open()" aria-label="User settings" \ntranslate translate-attr-aria-label="TOOLBAR.USER_SETTINGS"><div layout="row" layout-align="space-between center"><span\n ng-if="vm.divisionSelected" class="username">{{vm.divisionSelected.name}}</span> <span ng-if="!vm.divisionSelected" \nclass="username" translate="GLOBAL.ALL_DIVISIONS"></span><md-icon md-font-icon="icon-chevron-down" class="icon s16">\n</md-icon></div></md-button><md-menu-content width="3" class="clients"><md-menu-item class="md-indent"><div \nclass="search-input-wrapper" layout="row" layout-align="start center"><label for="search"><md-icon \nmd-font-icon="icon-magnify"></md-icon></label><md-input-container md-no-float class="m-0"><input id="search" \nplaceholder="{{\'RISK.SEARCH_FOR_DIVISION\' |\xA0translate}}" type="text" ng-model="vm.searchDivisionText">\n</md-input-container></div></md-menu-item><div class="results"><md-menu-item ng-if="vm.searchDivisionText == \'\'" \nng-click="vm.selectDivision(null)" class="md-indent bar-client"><div><md-icon md-font-icon="icon-account" \nclass="icon s16"></md-icon><button class="btn-clients" translate="GLOBAL.ALL_DIVISIONS"></button></div></md-menu-item>\n<md-menu-item ng-click="vm.selectDivision(division)" class="md-indent bar-client" \nng-repeat="division in vm.divisions | filter:vm.searchDivisionText"><div ng-if="division"><md-icon \nmd-font-icon="icon-account" class="icon s16"></md-icon><button class="btn-clients">{{division.name}}</button></div><div\n ng-if="!division"><md-icon md-font-icon="icon-account" class="icon s16"></md-icon><button class="btn-clients" \ntranslate="GLOBAL.ALL_DIVISIONS"></button></div></md-menu-item></div></md-menu-content></md-menu></md-menu-bar><div \nng-if="!vm.fromComplaint" class="divider-vertical" hide="" show-gt-xs=""></div><ms-search-bar debounce="300" \nmodel-search="$root.pagination_searchquery" on-result-click="vm.searchResultClick(item)" on-search="vm.search(query)" \nlayout="row" layout-align="start center"></ms-search-bar><md-button ng-click="$root.pagination_resetquery()" \naria-label="view type" class="md-icon-button" translate="" translate-attr-aria-label="GLOBAL.FILTERS" \nclass="md-icon-button" ng-if="$root.pagination_searchquery==true"><md-icon md-font-icon="icon-filter-remove-outline">\n</md-icon><md-tooltip hide show-gt-xs><span>Reset search</span></md-tooltip></md-button><div class="divider-vertical" \nhide="" show-gt-xs=""></div><md-menu hide="" show-gt-xs="" ng-if="refGroupables.length>0"><button aria-label="Filters" \nclass="md-icon-button" ng-click="$mdMenu.open($event)" show-gt-xs="" translate="" \ntranslate-attr-aria-label="GLOBAL.FILTERS"><md-icon md-font-icon="icon-chevron-down"><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.GROUP_BY">Group</span></md-tooltip></md-icon></button><md-menu-content width="4"><md-menu-item \nng-repeat="sortfield in refGroupables"><md-button aria-label="All" ng-click="pagination_setOrderBy(sortfield)"><div \nlayout="row" layout-align="space-between center"><span>Group by {{sortfield.name}} </span><i class="icon-check s16" \nng-if="sortfield.titleId == sortable.titleId"></i></div></md-button></md-menu-item><md-menu-divider ng-if="groupable">\n</md-menu-divider><md-menu-item ng-if="groupable"><md-button aria-label="Remove group" \nng-click="pagination_resetOrderBy()"><md-icon md-font-icon="icon-close "></md-icon><span>Remove order</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div><div layout="row" layout-align="start center" \ntranslate-attr-aria-label="GLOBAL.REFRESH"><span ng-if="!isLoading" class="page-info font-weight-500">\n{{vm.staffsroi.length}} {{ \'GLOBAL.OF\' | translate}} {{pagination_totalItems}} {{ \'GLOBAL.ITEMS\' | translate}}.</span>\n<div class="divider-vertical" hide hide show-gt-sm></div><md-button class="md-icon-button" \nng-click="vm.changeView(\'nosplit\')" ng-if="vm.currentView !== \'nosplit\'" hide show-gt-sm><md-icon \nmd-font-icon="icon-view-list" ng-if="vm.currentView !== \'nosplit\'"></md-icon><md-icon class="md-accent" \nmd-font-icon="icon-checkbox-marked" ng-if="vm.currentView === \'nosplit\'"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.NOSPLIT_VIEW">No split</span></md-tooltip></md-button><md-button class="md-icon-button" \nng-click="vm.changeView(\'split\')" ng-if="vm.currentView !== \'split\'" hide show-gt-sm><md-icon \nmd-font-icon="icon-view-quilt" ng-if="vm.currentView !== \'split\'"></md-icon><md-icon class="md-accent" \nmd-font-icon="icon-checkbox-marked" ng-if="vm.currentView === \'split\'"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.SPLIT_VIEW">split</span></md-tooltip></md-button><md-menu class="settings-menu" hide-gt-xs \nng-show="vm.selectedThreads.length > 0"><md-button aria-label="Settings" class="md-icon-button" \nng-click="$mdMenu.open($event)" translate="GLOBAL.SETTINGS" translate-attr-aria-label="GLOBAL.SETTINGS"><md-icon \nmd-font-icon="icon-dots-horizontal"></md-icon></md-button><md-menu-content><md-menu-item \nshow="vm.selectedMail.length > 0 || vm.allChecked"><md-button ng-click="vm.deleteStaff($event)" aria-label="Delete" \ntranslate-aria-label="GLOBAL.DELETE"><md-icon md-font-icon="icon-delete"></md-icon><span translate="GLOBAL.DELETE">\nDelete</span></md-button></md-menu-item></md-menu-content></md-menu></div>');
$templateCache.put('app/main/apps/tasks/views/list/list-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="isLoading" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="no-threads" ng-if="!vm.tasks" ng-hide="isLoading" translate="GLOBAL.NO_ITEMS"></div><div \nstyle="margin-top: -1px;" id="list-content-data" ng-style="{\'opacity\' : isLoading ? 0.5 : 1}"><div \nclass="mail-list-item" ng-repeat="task in vm.tasks | filter: vm.search | filter: global.search" \nng-init="parentIndex= $index" md-no-ink ng-click="vm.openTask(task.id)" \nng-class="{ \'selected\': vm.taskSelected.id === task.id, \'checked\': vm.isSelected(task)}"><div fill-width \nng-include="\'app/main/apps/risk/views/templates/task-row-template.html\'"></div></div></div><div class="toolbar" \nlayout="row" layout-align="end center"><div layout="row" layout-align="center center" \nng-style="{\'display\' : isLoading ? \'none\' : \'block\'}"><span class="page-info">{{pagination_totalItems}} &nbsp;</span> \n<span class="page-info" translate="GLOBAL.ITEMS_FOUND"></span><md-button aria-label="Previous" \nclass="md-icon-button arrow" ng-click="pagination_prevPage()" ng-disabled="pagination_firstPage()" translate="" \ntranslate-attr-aria-label="GLOBAL.PREVIOUS"><md-icon md-font-icon="icon-chevron-left"></md-icon></md-button><span \nclass="page-info">{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label="Next" \nclass="md-icon-button arrow" ng-click="pagination_nextPage()" ng-disabled="pagination_morePages()" translate="" \ntranslate-attr-aria-label="GLOBAL.NEXT"><md-icon md-font-icon="icon-chevron-right"></md-icon></md-button></div></div>');
$templateCache.put('app/main/apps/tasks/views/list/nosplit-view.html','<div class="toolbar" layout="row" layout-align="space-between center" \nng-include="\'app/main/apps/tasks/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row"><div\n class="content thread-detail mail-read-pane p0 scrollable" flex="" id="thread-detail" ms-scroll="vm.msScrollOptions" \nng-if="vm.taskSelected || vm.taskData" ng-include="\'app/main/apps/tasks/views/edit/edit-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="!vm.taskSelected && !vm.taskData" ng-include="\'app/main/apps/tasks/views/list/list-view.html\'"></div></div>');
$templateCache.put('app/main/apps/tasks/views/list/split-view.html','<div class="toolbar" layout="row" layout-align="space-between center" \nng-include="\'app/main/apps/tasks/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row"><div\n class="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-include="\'app/main/apps/tasks/views/list/list-view.html\'"></div><div \nclass="content thread-detail mail-read-pane scrollable p0" flex="" id="thread-detail" ms-scroll="vm.msScrollOptions" \nng-include="\'app/main/apps/tasks/views/edit/edit-view.html\'"></div></div>');
$templateCache.put('app/main/apps/tasks/views/list/toolbar.html','<div layout="row" layout-align="start center"><md-checkbox class="no-label" \naria-label="{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}" \nng-checked="vm.selectedThreads.length > 0" ng-click="vm.toggleSelectThreads(vm.selectedThreads, vm.contents)">\n</md-checkbox><div class="divider-vertical" hide="" show-gt-xs=""></div><md-button aria-label="NEW" \nclass="md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme" hide show-gt-sm \nng-click="vm.createNewTask()" translate="GLOBAL.NEW" type="button"></md-button><md-button aria-label="NEW" \nclass="md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme z-index-0" hide-gt-sm \nng-click="vm.createNewTask()" type="button"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="divider-vertical" hide="" show-gt-xs=""></div><div aria-hidden="false" \nclass="action-buttons hide show-gt-xs layout-align-start-center layout-row" layout="row" layout-align="start center" \nng-show="vm.selectedThreads.length > 0"><md-button ng-click="vm.deleteTask($event)" aria-label="Delete" \nclass="md-icon-button" hide="" show-gt-xs="" translate=""><md-icon md-font-icon="icon-delete"></md-icon><md-tooltip \nhide show-gt-xs><span translate="GLOBAL.REMOVE"></span></md-tooltip></md-button><div class="divider-vertical" hide="" \nshow-gt-xs=""></div></div><ms-search-bar debounce="300" model-search="$root.pagination_searchquery" \non-result-click="vm.searchResultClick(item)" on-search="vm.search(query)" layout="row" layout-align="start center">\n</ms-search-bar><md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" \ntranslate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nng-if="$root.pagination_searchquery==true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip \nhide show-gt-xs><span>Resetear la busqueda</span></md-tooltip></md-button><div class="divider-vertical" hide="" \nshow-gt-xs=""></div><md-menu-bar ng-if="vm.userLogued.user_type == 1" id="user-menu" class="p0"><md-menu \nmd-position-mode="left bottom"><md-button class="user-button" ng-click="$mdMenu.open()" aria-label="User settings" \ntranslate translate-attr-aria-label="TOOLBAR.USER_SETTINGS"><div layout="row" layout-align="space-between center"><span\n ng-if="vm.filterStatusSelected" class="username"><md-icon class="mr-15" \nng-click="vm.clearFilterStatus(); $event.stopPropagation();" md-font-icon="icon-filter-remove-outline"></md-icon>\n{{vm.filterStatusSelected.name |\xA0translate}}</span> <span ng-if="!vm.filterStatusSelected" class="username">\n{{\'TASKS.FILTER_BY_STATUS\' |\xA0translate}}</span><md-icon md-font-icon="icon-chevron-down" class="icon s16"></md-icon>\n</div></md-button><md-menu-content width="3" class="clients"><div class="results"><md-menu-item \nng-click="vm.selectFilterStatus(filterOption)" class="md-indent bar-client" \nng-repeat="filterOption in vm.statusFilter"><div><button class="btn-clients">{{filterOption.name | translate}}</button>\n</div></md-menu-item></div></md-menu-content></md-menu></md-menu-bar><div class="divider-vertical" hide="" \nshow-gt-xs=""></div><md-menu-bar ng-if="vm.userLogued.user_type == 1" id="user-menu" class="p0"><md-menu \nmd-position-mode="left bottom"><md-button class="user-button" ng-click="$mdMenu.open()" aria-label="User settings" \ntranslate translate-attr-aria-label="TOOLBAR.USER_SETTINGS"><div layout="row" layout-align="space-between center"><span\n ng-if="vm.filterDateSelected" class="username"><md-icon class="mr-15" \nng-click="vm.clearFilterDate(); $event.stopPropagation();" md-font-icon="icon-filter-remove-outline"></md-icon>\n{{vm.filterDateSelected.name |\xA0translate}}</span> <span ng-if="!vm.filterDateSelected" class="username">\n{{\'TASKS.FILTER_BY_DATE\' |\xA0translate}}</span><md-icon md-font-icon="icon-chevron-down" class="icon s16"></md-icon>\n</div></md-button><md-menu-content width="3" class="clients"><div class="results"><md-menu-item \nng-click="vm.selectFilterDate(filterOption)" class="md-indent bar-client" \nng-repeat="filterOption in vm.filterOptionsDate"><div><button class="btn-clients">{{filterOption.name | translate}}\n</button></div></md-menu-item></div></md-menu-content></md-menu></md-menu-bar><div layout="row" \nng-if="vm.filterDateSelected.type == \'custom\'"><div class="mt-10" layout="row"><label \nstyle="position: absolute;font-size: 10px;color: #9e9e9e;margin-top: -11px;margin-left: 16px;">\n{{\'TASKS.FROM_DATE\' |\xA0translate}}</label><md-datepicker flex class="due-date-input" ng-model="vm.from_date" \nmd-placeholder="{{\'TASKS.FROM_DATE\' |\xA0translate}}" ng-required="false"></md-datepicker></div><div class="mt-10" \nlayout="row"><label style="position: absolute;font-size: 10px;color: #9e9e9e;margin-top: -11px;margin-left: 16px;">\n{{\'TASKS.TO_DATE\' | translate}}</label><md-datepicker flex class="due-date-input" ng-model="vm.to_date" \nmd-placeholder="{{\'TASKS.TO_DATE\' | translate}}" ng-required="false"></md-datepicker></div><md-button \nng-click="vm.applyFilter()" class="send-button md-accent md-raised" aria-label="Apply" translate="RISK.APPLY" \ntranslate-attr-aria-label="RISK.APPLY"></md-button></div><md-menu hide="" show-gt-xs="" ng-if="refGroupables.length>0">\n<button aria-label="Filters" class="md-icon-button" ng-click="$mdMenu.open($event)" show-gt-xs="" translate="" \ntranslate-attr-aria-label="GLOBAL.FILTERS"><md-icon md-font-icon="icon-chevron-down"><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.GROUP_BY">Group</span></md-tooltip></md-icon></button><md-menu-content width="4"><md-menu-item \nng-repeat="sortfield in refGroupables"><md-button aria-label="All" ng-click="pagination_setOrderBy(sortfield)"><div \nlayout="row" layout-align="space-between center"><span>Group by {{sortfield.name}} </span><i class="icon-check s16" \nng-if="sortfield.titleId == sortable.titleId"></i></div></md-button></md-menu-item><md-menu-divider ng-if="groupable">\n</md-menu-divider><md-menu-item ng-if="groupable"><md-button aria-label="Remove group" \nng-click="pagination_resetOrderBy()"><md-icon md-font-icon="icon-close "></md-icon><span>Remove order</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div><div layout="row" layout-align="start center" \ntranslate-attr-aria-label="GLOBAL.REFRESH"><span ng-if="!isLoading" class="page-info font-weight-500">\n{{vm.tasks.length}} {{ \'GLOBAL.OF\' | translate}} {{pagination_totalItems}} {{ \'GLOBAL.ITEMS\' | translate}}.</span><div \nclass="divider-vertical" hide hide show-gt-sm></div><md-button class="md-icon-button" \nng-click="vm.changeView(\'nosplit\')" ng-if="vm.currentView !== \'nosplit\'" hide show-gt-sm><md-icon \nmd-font-icon="icon-view-list" ng-if="vm.currentView !== \'nosplit\'"></md-icon><md-icon class="md-accent" \nmd-font-icon="icon-checkbox-marked" ng-if="vm.currentView === \'nosplit\'"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.NOSPLIT_VIEW">No split</span></md-tooltip></md-button><md-button class="md-icon-button" \nng-click="vm.changeView(\'split\')" ng-if="vm.currentView !== \'split\'" hide show-gt-sm><md-icon \nmd-font-icon="icon-view-quilt" ng-if="vm.currentView !== \'split\'"></md-icon><md-icon class="md-accent" \nmd-font-icon="icon-checkbox-marked" ng-if="vm.currentView === \'split\'"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.SPLIT_VIEW">split</span></md-tooltip></md-button><md-menu class="settings-menu" hide-gt-xs \nng-show="vm.selectedThreads.length > 0"><md-button aria-label="Settings" class="md-icon-button" \nng-click="$mdMenu.open($event)" translate="GLOBAL.SETTINGS" translate-attr-aria-label="GLOBAL.SETTINGS"><md-icon \nmd-font-icon="icon-dots-horizontal"></md-icon></md-button><md-menu-content><md-menu-item \nshow="vm.selectedThreads.length > 0"><md-button ng-click="vm.deleteTask($event)" aria-label="Delete" \ntranslate-aria-label="GLOBAL.DELETE"><md-icon md-font-icon="icon-delete"></md-icon><span translate="GLOBAL.DELETE">\nDelete</span></md-button></md-menu-item></md-menu-content></md-menu></div>');
$templateCache.put('app/main/apps/tasks/views/edit/comments-task.html','<chat-view relatedtype="\'tasks\'" id="vm.idChat"></chat-view>');
$templateCache.put('app/main/apps/tasks/views/edit/description-task.html','<div class="p-20" layout="column"><div layout="row"><p class="m0" ng-bind-html="task.text"></p></div><div \nng-if="task.files && task.files.length> 0" layout="row"><p class="m0 grey-400-fg">{{\'TASKS.ATTACHED\' | translate}}:</p>\n</div><div class="mv-20" ng-if="task.files && task.files.length> 0" layout="column"><div \nclass="mail-list-item attachment mv-5 pointer" ng-repeat="document in task.files" data-id="{{document.id}}"><a \nhref="{{vm.storagePrefix+document.url}}" target="_blank"><div layout="row" layout-align="start center"><div fill-width \nlayout="row" layout-align="start center"><div class="media photos" layout="row" layout-align="center center"><h2c-icon \nfile="document.url"></h2c-icon><img ng-src="{{vm.storagePrefix+document.url}}" alt=""></div><div class="info" flex \nlayout="column"><div class="subject text-truncate grey-500-fg" layout="row" layout-align="start center"><span>\n{{document.created_at_format }}</span></div><div class="name" layout="row" layout-align="start center"><span \nng-if="document.original_name">{{document.original_name}}</span></div></div></div></div></a></div></div><div \nclass="mv-20" layout="row"><div class="name" layout="row" style="height: 20px;"><span class="grey-500-fg mr-5">\n{{\'TASKS.CREATED_BY\' | translate}}:</span><div ng-if="task.user" class="avatar-wrapper"><img \nstyle="min-width: 20px;width: 20px;height: 20px;line-height: 20px; margin: 0px 5px;" class="avatar s24" \nng-src="{{vm.showUserImage(task.user)}}" ng-if="task.user.files.id"><div \nstyle="min-width: 20px;width: 20px;height: 20px;line-height: 20px; margin: 0px 5px; background-color: gray; font-size: 12px;" \nclass="avatar s24" ng-class="task.user.profile_color" ng-if="!task.user.files.id" \nng-bind="task.user.first_name | capitalizeFirstLetter"></div></div><span ng-if="task.user" style="line-height: 20px;" \nclass="grey-500-fg">{{task.user.first_name}} {{task.user.last_name}} </span><span \nstyle="line-height: 20px; margin-left: 10px;" class="grey-500-fg" ng-bind-html="vm.timeAgo(task.created_at)"></span>\n</div></div></div>');
$templateCache.put('app/main/apps/tasks/views/edit/edit-task-view.html','<div ng-if="!vm.window" class="toolbar grey-100-bg colored-bg" layout="row" layout-align="space-between center" \nscroll=""><div layout="row" layout-align="start center"></div><div layout="row" layout-align="end center" hide \nshow-gt-sm><md-button translate="GLOBAL.CANCEL" type="button" ng-click="vm.closeTask()" class="md-raised md-warn" \naria-label="Cancel"></md-button><md-button translate="GLOBAL.SAVE" type="button" \nng-disabled="!vm.taskData.task.title || (vm.taskData.task.assigned_multiple.users.length === 0 && !vm.taskData.task.assigned_to_user_id) || !vm.taskData.task.status_id" \nng-click="vm.saveTask()" class="md-raised md-accent" aria-label="Save"></md-button></div><div layout="row" \nlayout-align="end center" hide-gt-sm><md-button type="button" ng-click="vm.saveTask()" \nng-disabled="!vm.taskData.task.title || (vm.taskData.task.assigned_multiple.users.length === 0 && !vm.taskData.task.assigned_to_user_id) || !vm.taskData.task.status_id" \nclass="md-accent md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" aria-label="Send"><md-icon \nmd-font-icon="icon-plus"></md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.SAVE"></span></md-tooltip>\n</md-button><md-button type="button" ng-click="vm.closeTask()" \nclass="md-warn md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" aria-label="Cancel"><md-icon \nmd-font-icon="icon-window-close"></md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.CANCEL"></span>\n</md-tooltip></md-button></div></div><div ng-include="\'app/main/dialogs/taskDetails/task-new-content.html\'"></div>');
$templateCache.put('app/main/apps/tasks/views/edit/edit-view.html','<div class="content thread-detail" layout="row" layout-align="center center" flex ng-if="vm.loadingReadPane"><div flex \nlayout="column" layout-align="center center" class="loading-container"><md-progress-circular md-mode="indeterminate" \nmd-diameter="50"></md-progress-circular></div></div><div class="toolbar grey-100-bg colored-bg" layout="row" \nlayout-align="space-between center" scroll="" \nng-if="!vm.window && !vm.edit && (vm.taskSelected || vm.taskData.task.id) && !vm.loadingReadPane"><div layout="row" \nlayout-align="start center"></div><div layout="row" layout-align="end center" hide show-gt-sm><md-button \nng-click="vm.closeTask()" translate="GLOBAL.CANCEL" type="button" class="md-raised md-warn" aria-label="Cancel">\n</md-button><md-button ng-if="vm.edit" translate="GLOBAL.SAVE" type="button" class="md-raised md-accent" \naria-label="Save"></md-button></div><div layout="row" layout-align="end center" hide-gt-sm><md-button ng-if="vm.edit" \ntype="button" ng-disabled="vm.checkFields()" \nclass="md-accent md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" aria-label="Send"><md-icon \nmd-font-icon="icon-plus"></md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.SAVE"></span></md-tooltip>\n</md-button><md-button ng-click="vm.closeTask()" type="button" \nclass="md-warn md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" aria-label="Cancel"><md-icon \nmd-font-icon="icon-window-close"></md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.CANCEL"></span>\n</md-tooltip></md-button></div></div><div class="content thread-detail" layout="row" layout-align="center center" flex \nng-if="!vm.taskSelected && !vm.taskData && !vm.loadingReadPane"><div class="no-thread-selected" layout="column" \nlayout-align="center center" flex><md-icon md-font-icon="icon-clipboard-account" class="s120 grey-400-fg"></md-icon>\n<span class="hint-text" translate="TASKS.SELECT_TASK"></span></div></div><div \nng-if="vm.taskData && !vm.taskData.task.id && !vm.loadingReadPane" class="task-edit-view mb-100"><div \nng-include="\'app/main/apps/tasks/views/edit/new-task-view.html\'"></div></div><div \nng-if="vm.edit && (vm.taskSelected || vm.taskData.task.id) && !vm.loadingReadPane" class="task-edit-view mb-100"><div \nng-include="\'app/main/apps/tasks/views/edit/edit-task-view.html\'"></div></div><div \nng-init="vm.taskSelected ? task= vm.taskSelected : task= vm.taskData.task" \nng-if="!vm.edit && (vm.taskSelected || vm.taskData.task.id) && !vm.loadingReadPane" class="task-edit-view" \nng-include="\'app/main/apps/tasks/views/edit/preview-view.html\'"></div>');
$templateCache.put('app/main/apps/tasks/views/edit/history-task.html','<md-select class="mt-0 mb-25 ml-5 no-border-select" style="max-width: 150px;" \nng-init="vm.subtaskSelected= task.childs[0].id" class="account-selection simplified" placeholder="Date Selection" \nng-model="vm.subtaskSelected"><md-option ng-repeat="subTaskOption in task.childs" value="{{subTaskOption.id}}"><span \nstyle="line-height: 20px;width: 90px" class="field grey-500-fg ng-scope">\n{{subTaskOption.due_by_date | amDateFormat:\'DD MMM YYYY\'}}</span></md-option></md-select><div class="history"><div \nng-repeat="subtask in task.childs | filter :{id : vm.subtaskSelected }" layout="column"><div \nng-repeat="subsubtask in subtask.childs" class="mv-5" layout="row"><div style="width: 120px;" class="name" \nlayout="row" style="height: 20px;"><div class="avatar-wrapper"><img \nstyle="min-width: 20px;width: 20px;height: 20px;line-height: 20px; margin: 0px 5px;" class="avatar s24" \nng-src="{{vm.showUserImage(subsubtask.assigned_to_user)}}" ng-if="subsubtask.assigned_to_user.files.id"><div \nstyle="min-width: 20px;width: 20px;height: 20px;line-height: 20px; margin: 0px 5px; background-color: gray; font-size: 12px;" \nclass="avatar s24" ng-class="subsubtask.assigned_to_user.profile_color" ng-if="!subsubtask.assigned_to_user.files.id" \nng-bind="subsubtask.assigned_to_user.first_name | capitalizeFirstLetter"></div></div><span \nng-if="subsubtask.assigned_to_user" \nstyle="line-height: 20px;width: 100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" \nclass="grey-500-fg">{{subsubtask.assigned_to_user.first_name}} {{subsubtask.assigned_to_user.last_name}}</span></div>\n<span class="ml-10" ng-init="taskStatus= subsubtask;" ng-include="\'app/main/apps/tasks/views/edit/task-status.html\'">\n</span></div></div></div>');
$templateCache.put('app/main/apps/tasks/views/edit/new-task-view.html','<div ng-if="!vm.window" class="toolbar grey-100-bg colored-bg" layout="row" layout-align="space-between center" \nscroll=""><div layout="row" layout-align="start center"></div><div layout="row" layout-align="end center" hide \nshow-gt-sm><md-button translate="GLOBAL.CANCEL" type="button" ng-click="vm.closeTask()" class="md-raised md-warn" \naria-label="Cancel"></md-button><md-button translate="GLOBAL.SAVE" type="button" \nng-disabled="!vm.taskData.task.title || ((vm.taskData.task.assigned_multiple.users.length === 0) && !vm.taskData.task.assigned_to_user_id) || !vm.taskData.task.status_id" \nng-click="vm.saveTask()" class="md-raised md-accent" aria-label="Save"></md-button></div><div layout="row" \nlayout-align="end center" hide-gt-sm><md-button type="button" ng-click="vm.saveTask()" \nng-disabled="!vm.taskData.task.title || ((vm.taskData.task.assigned_multiple.users.length === 0) && !vm.taskData.task.assigned_to_user_id) || !vm.taskData.task.status_id" \nclass="md-accent md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" aria-label="Send"><md-icon \nmd-font-icon="icon-plus"></md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.SAVE"></span></md-tooltip>\n</md-button><md-button type="button" ng-click="vm.closeTask()" \nclass="md-warn md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" aria-label="Cancel"><md-icon \nmd-font-icon="icon-window-close"></md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.CANCEL"></span>\n</md-tooltip></md-button></div></div><div ng-include="\'app/main/dialogs/taskDetails/task-new-content.html\'"></div>');
$templateCache.put('app/main/apps/tasks/views/edit/preview-view.html','<div id="head-container" layout="column"><div class="pt-20 pl-20" layout="row"><h1 flex ng-bind-html="task.title" \nclass="m0 title"></h1><div class="field ml-15"><span ng-init="taskStatus= task;" \nng-include="\'app/main/apps/tasks/views/edit/task-status.html\'"></span></div><div style="min-width: 50px;"><md-menu \nng-if="vm.taskSelected.user.id == vm.userLogued.id" md-position-mode="target-right target"><md-button \nclass="md-icon-button" ng-click="$mdMenu.open()" aria-label="more"><md-icon md-font-icon="icon-dots-vertical">\n</md-icon></md-button><md-menu-content width="3"><md-menu-item><md-button \nng-click="vm.taskSelected ? vm.editTask(vm.taskSelected) : vm.editTask(vm.taskData)" aria-label="EDIT" \ntranslate="TASKS.EDIT" translate-attr-aria-label="TASKS.EDIT">All</md-button></md-menu-item></md-menu-content>\n</md-menu></div></div><div class="mv-10 p-20" layout="row"><div layout="column" fill-width><div class="name" \nlayout="row" style="height: 20px;"><span style="line-height: 20px; width: 95px;" class="field grey-500-fg">\n{{task.due_by_date | amDateFormat:\'DD MMM HH:mm\'}}</span><div ng-if="task.assigned_to_user" class="avatar-wrapper"><img\n style="min-width: 20px;width: 20px;height: 20px;line-height: 20px; margin-right: 5px;" class="avatar s24" \nng-src="{{vm.showUserImage(task.assigned_to_user)}}" ng-if="task.assigned_to_user.files.id"><div \nstyle="min-width: 20px;width: 20px;height: 20px;line-height: 20px; margin-right: 5px; background-color: gray; font-size: 12px;" \nclass="avatar s24" ng-class="task.assigned_to_user.profile_color" ng-if="!task.assigned_to_user.files.id" \nng-bind="task.assigned_to_user.first_name | capitalizeFirstLetter"></div></div><div ng-if="!task.assigned_to_user" \nclass="avatar-wrapper"><div \nstyle="min-width: 20px;width: 20px;height: 20px;line-height: 20px; margin-right: 5px; background-color: gray; font-size: 12px;" \nclass="avatar s24">{{task.assigned_multiple.users.length}}</div></div><span ng-if="task.assigned_to_user" \nstyle="line-height: 20px;" class="field grey-500-fg">\n{{task.assigned_to_user.first_name}} {{task.assigned_to_user.last_name}} </span><span \nng-if="!task.assigned_to_user && task.status_multiple == 0" style="line-height: 20px;" class="field grey-500-fg">\nTarea m\xFAltiple: Compartida </span><span ng-if="!task.assigned_to_user && task.status_multiple != 0" \nstyle="line-height: 20px;" class="field grey-500-fg">Tarea m\xFAltiple: Individual </span><span class="grey-500-fg" \nstyle="line-height: 20px; margin-top: 8px;" ng-if="task.recurrent_type">: <label class="label-each" \ntranslate="RISK.EACH"></label> <label class="">{{task.recurrent_interval}}</label> <label class="">\n{{vm.reccurentType[task.recurrent_type] | translate}}</label></span></div><div ng-if="!task.recurrent_type" \nstyle="margin-top: 20px;margin-left: -5px;" fill-width layout="row"><div layout="column"><div \nng-repeat="subtask in task.childs | limitTo: vm.numUsersPreview" class="mv-5" layout="row"><div class="name" \nlayout="row" style="height: 20px;"><div class="avatar-wrapper"><img \nstyle="min-width: 20px;width: 20px;height: 20px;line-height: 20px; margin: 0px 5px;" class="avatar s24" \nng-src="{{vm.showUserImage(subtask.assigned_to_user)}}" ng-if="subtask.assigned_to_user.files.id"><div \nstyle="min-width: 20px;width: 20px;height: 20px;line-height: 20px; margin: 0px 5px; background-color: gray; font-size: 12px;" \nclass="avatar s24" ng-class="subtask.assigned_to_user.profile_color" ng-if="!subtask.assigned_to_user.files.id" \nng-bind="subtask.assigned_to_user.first_name | capitalizeFirstLetter"></div></div><span \nng-if="subtask.assigned_to_user" style="line-height: 20px;" class="grey-500-fg">\n{{subtask.assigned_to_user.first_name}} {{subtask.assigned_to_user.last_name}}</span></div></div></div><divs \nlayout="column"><div ng-repeat="subtask in task.childs | limitTo: vm.numUsersPreview" class="mv-5" layout="row"><span \nclass="ml-10" ng-init="taskStatus= subtask;" ng-include="\'app/main/apps/tasks/views/edit/task-status.html\'"></span>\n</div></divs></div><md-button class="md-raised md-accent" style="max-width: 150px;" \nng-if="!task.recurrent_type && task.childs.length> 3 && vm.numUsersPreview == 3" ng-click="vm.numUsersPreview= 9999">\nMostrar todos</md-button><md-button class="md-raised md-accent" style="max-width: 150px;" \nng-if="!task.recurrent_type && task.childs.length> 3 && vm.numUsersPreview> 3" ng-click="vm.numUsersPreview= 3">\nMostrar menos</md-button></div></div></div><md-tabs md-dynamic-height md-border-bottom flex="100"><md-tab>\n<md-tab-label><span ng-bind-html="vm.translate(\'TASKS.DESCRIPTION\')"></span></md-tab-label><md-tab-body><div \nng-include="\'app/main/apps/tasks/views/edit/description-task.html\'"></div></md-tab-body></md-tab><md-tab \nng-if="task.recurrent_type"><md-tab-label><span ng-bind-html="vm.translate(\'TASKS.HISTORY\')"></span></md-tab-label>\n<md-tab-body><div class="p-20"><div ng-include="\'app/main/apps/tasks/views/edit/history-task.html\'"></div></div>\n</md-tab-body></md-tab><md-tab md-on-select="vm.scrollToBottomOfChat();"><md-tab-label><span \nng-bind-html="vm.translate(\'TASKS.COMMENTS\')"></span></md-tab-label><md-tab-body><div \nng-style="{ \'height\' : vm.calculateHeightChat()}" ng-include="\'app/main/apps/tasks/views/edit/comments-task.html\'">\n</div></md-tab-body></md-tab></md-tabs>');
$templateCache.put('app/main/apps/tasks/views/edit/task-status.html','<span class="pointer" ng-click="vm.changeTaskStatusDialog($event, taskStatus); $event.stopPropagation()"><span \nstyle="text-transform: inherit; width: 100px; display: block; margin-left: 15px;" \nng-if="(taskStatus.status_id == 1 || taskStatus.status_id == 2) && vm.dateExpired(taskStatus.due_by_date)" \nng-style="{\'background\': \'red\'}" class="badge"><span><strong>{{\'RISK.TASK_EXPIRED\' | translate}}</strong></span> \n</span><span style="text-transform: inherit; width: 100px; display: block; margin-left: 15px;" \nng-if="taskStatus.status_id == 1 && !vm.dateExpired(taskStatus.due_by_date)" ng-style="{\'background\': \'gray\'}" \nclass="badge"><span><strong>{{\'RISK.TASK_PENDING\' | translate}}</strong></span> </span><span \nstyle="text-transform: inherit; width: 100px; display: block; margin-left: 15px;" \nng-if="taskStatus.status_id == 2 && !vm.dateExpired(taskStatus.due_by_date)" ng-style="{\'background\': \'orange\'}" \nclass="badge"><span><strong>{{\'RISK.TASK_IN_PROGRESS\' | translate}}</strong></span> </span><span \nstyle="text-transform: inherit; width: 100px; display: block; margin-left: 15px;" ng-if="taskStatus.status_id == 3" \nng-style="{\'background\': \'green\'}" class="badge"><span><strong>{{\'RISK.TASK_COMPLETED\' | translate}}</strong></span>\n</span></span>');
$templateCache.put('app/main/apps/todo/sidenavs/main/main-sidenav.html','<div class="header" layout="column" layout-align="space-between"><div class="logo" layout="row" \nlayout-align="start center"><span class="logo-icon"><md-icon md-font-icon="icon-checkbox-marked" class="s24"></md-icon>\n</span><span class="logo-text" translate="TODO.TO_DO">To-Do</span></div><md-select \nclass="project-selection simplified" ng-model="vm.selectedProject" placeholder="Select Project"><md-option \nng-repeat="(project, title) in vm.projects" value="{{project}}">{{title}}</md-option></md-select></div><md-content \nclass="content" flex ms-scroll><div class="add-task-button"><md-button class="md-accent md-raised" \nng-click="vm.openTaskDialog($event)" aria-label="ADD TASK" translate="TODO.ADD_TASK" \ntranslate-attr-aria-label="TODO.ADD_TASK">ADD TASK</md-button></div><div class="navigation-simple" layout="column">\n<md-button class="item" aria-label="All Tasks" translate translate-attr-aria-label="TODO.ALL_TASKS" \nng-class="{\'selected\':vm.showAllTasks}" ng-click="vm.resetFilters()"><div layout="row" layout-align="start center">\n<md-icon md-font-icon="icon-view-headline" class="s16"></md-icon><span class="title" translate="TODO.ALL_TASKS">\nAll Tasks</span></div></md-button><div class="item subheader" translate="TODO.FILTERS">Filters</div><md-button \nclass="item" aria-label="Starred" translate translate-attr-aria-label="TODO.STARRED" \nng-click="vm.toggleFilterWithEmpty(\'starred\')" ng-class="{\'selected\':vm.taskFilters.starred}"><md-icon \nmd-font-icon="icon-star" class="s16"></md-icon><span class="title" translate="TODO.STARRED">Starred</span></md-button>\n<md-button class="item" aria-label="Priority" translate translate-attr-aria-label="TODO.PRIORITY" \nng-click="vm.toggleFilterWithEmpty(\'important\')" ng-class="{\'selected\':vm.taskFilters.important}"><md-icon \nmd-font-icon="icon-alert-circle" class="s16"></md-icon><span class="title" translate="TODO.PRIORITY">Priority</span>\n</md-button><md-button class="item" aria-label="Scheduled" translate translate-attr-aria-label="TODO.SCHEDULED" \nng-click="vm.toggleFilterWithEmpty(\'dueDate\')" ng-class="{\'selected\':vm.taskFilters.dueDate}"><md-icon \nmd-font-icon="icon-clock" class="s16"></md-icon><span class="title" translate="TODO.SCHEDULED">Scheduled</span>\n</md-button><md-button class="item" aria-label="Today" translate translate-attr-aria-label="TODO.TODAY" \nng-click="vm.toggleFilterWithEmpty(\'startDate\')" ng-class="{\'selected\':vm.taskFilters.startDate}"><md-icon \nmd-font-icon="icon-calendar-today" class="s16"></md-icon><span class="title" translate="TODO.TODAY">Today</span>\n</md-button><md-button class="item" aria-label="Done" translate translate-attr-aria-label="TODO.DONE" \nng-click="vm.toggleFilterWithEmpty(\'completed\')" ng-class="{\'selected\':vm.taskFilters.completed}"><md-icon \nmd-font-icon="icon-check" class="s16"></md-icon><span class="title" translate="TODO.DONE">Done</span></md-button>\n<md-button class="item" aria-label="Deleted" translate translate-attr-aria-label="TODO.DELETED" \nng-click="vm.toggleFilter(\'deleted\')" ng-class="{\'selected\':vm.taskFilters.deleted}"><md-icon \nmd-font-icon="icon-delete" class="s16"></md-icon><span class="title" translate="TODO.DELETED">Deleted</span>\n</md-button><div class="item subheader" translate="TODO.TAGS">Tags</div><md-button class="tag item" \naria-label="tag {{tag.label}}" ng-repeat="tag in vm.tags" ng-click="vm.toggleTagFilter(tag)" \nng-class="{\'selected\':vm.isTagFilterExists(tag)}"><md-icon md-font-icon="icon-label" class="s16" \nng-style="{\'color\' : tag.color}"></md-icon><span class="title">{{tag.label}}</span></md-button></div></md-content>');
$templateCache.put('app/main/apps/todo/dialogs/task/task-dialog.html','<md-dialog class="task-dialog" aria-label="New Task"><form name="taskForm" class="md-inline-form" novalidate>\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between"><span \nclass="title">{{vm.title}}</span><md-button class="md-icon-button" ng-click="vm.closeDialog()"><md-icon \nmd-font-icon="icon-close" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><md-input-container class="md-block"><label translate="TODO.TITLE">Title</label> <input name="title" \nng-model="vm.task.title" required><div ng-messages="taskForm.title.$error" ng-show="taskForm.title.$touched" \nrole="alert"><div ng-message="required"><span translate="TODO.ERRORS.TITLE_REQUIRED">Title field is required</span>\n</div></div></md-input-container><div class="tags"><label translate="TODO.TAGS">Tags</label><md-chips \nng-model="vm.task.tags" md-transform-chip="vm.newTag($chip)"><md-chip-template><span ng-if="$chip.color" class="color" \nng-style="{\'background-color\':$chip.color}"></span> <span>{{$chip.label}}</span></md-chip-template></md-chips></div>\n<div layout-xs="column" layout="row"><div flex class="date-container"><label translate="TODO.START_DATE">Start Date\n</label><md-datepicker flex ng-model="vm.task.startDate" md-placeholder="Start Date"></md-datepicker></div><div flex \nclass="date-container"><label translate="TODO.DUE_DATE">Due Date</label><md-datepicker flex ng-model="vm.task.dueDate" \nmd-placeholder="Due Date"></md-datepicker></div></div><div class="notes"><label translate="TODO.NOTES">Notes</label>\n<text-angular ng-model="vm.task.notes"></text-angular></div><div class="attachment-list"><div class="attachment" \nlayout="row" layout-align="space-between center"><div><span class="filename">attachment-2.doc</span> <span \nclass="size">(12 Kb)</span></div><md-button class="md-icon-button"><md-icon md-font-icon="icon-close" \naria-label="delete attachment" class="s16"></md-icon></md-button></div><div class="attachment" layout="row" \nlayout-align="space-between center"><div><span class="filename">attachment-1.jpg</span> <span class="size">(350 Kb)\n</span></div><md-button class="md-icon-button" aria-label="Delete attachment" translate \ntranslate-attr-aria-label="TODO.DELETE_ATTACHMENT"><md-icon md-font-icon="icon-close" class="s16"></md-icon>\n</md-button></div></div></md-dialog-content><md-dialog-actions layout="row" layout-align="space-between center"><div \nlayout="row" layout-align="start center"><md-button type="submit" ng-if="!vm.newTask" ng-click="vm.saveTask()" \nclass="send-button md-accent md-raised" ng-disabled="taskForm.$invalid || taskForm.$pristine" aria-label="SAVE" \ntranslate="TODO.SAVE" translate-attr-aria-label="TODO.SAVE">SAVE</md-button><md-button type="submit" \nng-if="vm.newTask" ng-click="vm.addNewTask()" class="send-button md-accent md-raised" \nng-disabled="taskForm.$invalid || taskForm.$pristine" aria-label="Add Task" translate="TODO.ADD_TASK" \ntranslate-attr-aria-label="TODO.ADD_TASK">ADD TASK</md-button><md-button class="md-icon-button" \naria-label="Attach file" translate translate-attr-aria-label="TODO.ATTACH_FILE"><md-icon md-font-icon="icon-paperclip">\n</md-icon></md-button><md-button class="md-icon-button" aria-label="Insert picture" translate \ntranslate-attr-aria-label="TODO.INSERT_PICTURE"><md-icon md-font-icon="icon-file-image-box"></md-icon></md-button>\n</div><div layout="row"><md-button class="md-icon-button" ng-click="vm.deleteTask($event)" aria-label="Delete" \ntranslate translate-attr-aria-label="TODO.DELETE"><md-icon md-font-icon="icon-delete"></md-icon><md-tooltip><span \ntranslate="TODO.DELETE">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/apps/todo/views/list/list-view.html','<div class="todo-items" ng-sortable="vm.sortableOptions" ng-model="vm.tasks" \nng-class="{\'sortable\': vm.taskOrder === \'\'}"><div class="todo-item" md-ink-ripple layout="row" \nlayout-align="start center" ng-click="vm.openTaskDialog($event, task)" \nng-repeat="task in vm.tasks | orderBy:vm.taskOrder:vm.taskOrderDescending | filter:global.search | filter:vm.taskFilters.search | filterByTags:vm.taskFilters.tags | filter:{\'completed\': vm.taskFilters.completed} | filter:{\'deleted\': vm.taskFilters.deleted} | filter:{\'important\': vm.taskFilters.important} | filter:{\'starred\':vm.taskFilters.starred} | filter:vm.filterByStartDate | filter:vm.filterByDueDate track by $index" \nng-class="{\'starred\': task.starred, \'selected\': task.selected, \'completed\': task.completed}"><div class="handle" \nng-click="vm.preventDefault($event)"><md-icon md-font-icon="icon-drag-vertical" class="icon"></md-icon></div>\n<md-checkbox class="no-label" ng-checked="task.completed" ng-click="vm.toggleCompleted(task, $event)" \naria-label="{{task.completed ? \'Not completed\' : \'Completed\'}}"></md-checkbox><div layout="row" \nlayout-align="start center" flex><div class="info" flex><div class="title">{{task.title}}</div><div class="notes">\n{{task.notes}}</div><div class="tags" layout="row" layout-align="start center" layout-wrap><div class="tag" \nlayout="row" layout-align="start center" data-ng-repeat="tag in task.tags"><div class="tag-color" \nng-style="{\'background-color\': tag.color}"></div><div class="tag-label">{{tag.label}}</div></div></div></div><div \nclass="buttons" layout="row" layout-align="start center"><md-icon md-font-icon="icon-alert-circle" \nclass="is-important red-600-fg" ng-if="task.important"></md-icon><md-icon md-font-icon="icon-star" \nclass="is-starred amber-600-fg" ng-if="task.starred"></md-icon><md-menu><md-button class="md-icon-button" \naria-label="More" translate translate-attr-aria-label="TODO.MORE"><md-icon md-font-icon="icon-dots-vertical" \nng-click="$mdMenu.open($event)"></md-icon></md-button><md-menu-content width="3"><md-menu-item><md-button \nng-click="task.completed = !task.completed" aria-label="Toggle done" translate-attr-aria-label="TODO.TOGGLE_DONE">\n<md-icon ng-class="task.completed === false ? \'grey-fg\' : \'blue-fg\'" md-font-icon="icon-checkbox-marked-circle" \nclass="s18"></md-icon><span ng-show="!task.completed" translate="TODO.MARK_AS_DONE">Mark as done</span> <span \nng-show="task.completed" translate="TODO.MARK_AS_UNDONE">Mark as undone</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click="task.important = !task.important" aria-label="Toggle important" \ntranslate-attr-aria-label="TODO.TOGGLE_IMPORTANT"><md-icon \nng-class="task.important === false ? \'grey-fg\' : \'red-600-fg\'" md-font-icon="icon-alert-circle" class="s18"></md-icon>\n<span ng-show="!task.important" translate="TODO.MARK_AS_IMPORTANT">Mark as important</span> <span \nng-show="task.important" translate="TODO.REMOVE_IMPORTANT">Remove important</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click="task.starred = !task.starred" aria-label="Toggle star" \ntranslate-attr-aria-label="TODO.TOGGLE_STAR"><md-icon ng-class="task.starred === false ? \'grey-fg\' : \'amber-600-fg\'" \nmd-font-icon="icon-star" class="s18"></md-icon><span ng-show="!task.starred" translate="TODO.ADD_STAR">Add star</span> \n<span ng-show="task.starred" translate="TODO.REMOVE_STAR">Remove star</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div></div>');
$templateCache.put('app/main/apps/users/views/edit/edit-companies.html','<div ng-if="vm.userSelected.companies_branches.length == 0"><div class="content thread-detail" layout="row" \nlayout-align="center center" flex><div class="no-thread-selected" layout="column" layout-align="center center" flex>\n<md-icon md-font-icon="icon-city" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="USERS.USER_HAS_NO_COMPANIES"></span></div></div></div><div \nng-repeat="company in vm.userSelected.companies_branches" ng-init="vm.sortableOpt(virtualgroup)" \nng-if="vm.userHasCompany(company)"><md-list-item class="md-toolbar-tools grey-100-bg"><div layout="row" \nlayout-align="start center" class="pl-5"><h3 class="grey-700-fg" layout="row" layout-align="start center"><div \nclass="avatar-wrapper" ng-show="company.files.length > 0"><img md-menu-align-target class="avatar" \nng-src="{{vm.config.storagePrefix}}{{company.files[0].url}}"></div><span>{{company.name}}</span></h3></div><md-divider>\n</md-divider></md-list-item><md-list-item flex="100" class="virtualgroups-item" ng-repeat="branch in company.branches" \nng-if="vm.userHasBranch(branch)"><div layout="row" layout-align="start center" flex><div class="text-truncate mr-20" \nflex="40"><div class="field ml-45 grey-700-fg"><h3 ng-bind-html="branch.name" class="grey-700-fg"></h3></div></div><div\n flex="60" layout="column" layout-align="start start"><div layout="row" layout-align="space-between start" \nclass="fullwidth"><div class="field" flex="50"><strong class="grey-700-fg" translate="USERS.DIVISION"></strong></div>\n<div class="field" flex="50"><strong class="grey-700-fg" translate="USERS.JOB_POSITION"></strong></div></div><div \nng-repeat="jobDivision in vm.userSelected.division_jobs | filter: {branch_id: branch.id}" layout="row" \nlayout-align="space-between start" class="fullwidth"><div class="field" flex="50"><span class="grey-700-fg" \nng-bind-html="jobDivision.division.name"></span></div><div class="field" flex="50"><span class="grey-700-fg" \nng-bind-html="jobDivision.job_position.name"></span></div></div></div></div><md-divider></md-divider></md-list-item>\n</div>');
$templateCache.put('app/main/apps/users/views/edit/edit-data.html','<div class="mail-content file-details scrollable" ms-scroll="vm.msScrollOptions"><div layout="row"><div \nclass="form-wrapper md-whiteframe-1dp" flex="100"><div><md-input-container ng-if=" vm.userSelected.user_type != 1" \nclass="md-block mt-0 mb-0"><button ng-if="vm.userSelected.enabled" class="md-icon-button md-button"><md-icon \nmd-font-icon="icon-checkbox-marked-circle" class="on green-fg s24" ng-click="vm.toggleUserStatusEdit(\'enabled\')">\n</md-icon></button> <button ng-if="!vm.userSelected.enabled" class="md-icon-button md-button"><md-icon \nmd-font-icon="icon-checkbox-blank-circle-outline" class="off red-fg s24" ng-click="vm.toggleUserStatusEdit(\'enabled\')">\n</md-icon></button> <label class="inline">\n{{vm.userSelected.enabled ? (\'USERS.ACTIVE\' | translate) : (\'USERS.INACTIVE\' | translate)}}</label>\n</md-input-container><md-input-container ng-if="vm.userSelected.user_type !== 1" class="md-block"><md-select \nng-model="vm.userSelected.user_type" placeholder="{{\'GLOBAL.ROLE\' | translate}}"><md-option ng-value="2">\n{{\'GLOBAL.ADMINISTRATOR\' | translate}}</md-option><md-option ng-value="3">{{\'GLOBAL.COMPLIANCE_OFFICER\' | translate}}\n</md-option><md-option ng-value="6">{{\'GLOBAL.COLLABORATOR\' | translate}}</md-option></md-select></md-input-container>\n<md-input-container class="md-block"><label translate="USERS.FIRSTNAME"></label> <input \nng-disabled="vm.userLogued.user_type != 1 && vm.userSelected.user_type == 1" type="search" \nng-model="vm.userSelected.first_name" placeholder="" autocomplete="off"></md-input-container><md-input-container \nclass="md-block"><label translate="USERS.LASTNAME"></label> <input \nng-disabled="vm.userLogued.user_type != 1 && vm.userSelected.user_type == 1" type="search" \nng-model="vm.userSelected.last_name" placeholder="" autocomplete="off"></md-input-container><md-input-container \nclass="md-block"><label>{{vm.getRegionLiteral(\'id_number\')}}</label> <input \nng-disabled="vm.userLogued.user_type != 1 && vm.userSelected.user_type == 1" type="search" \nng-model="vm.userSelected.id_number" placeholder="" autocomplete="off"></md-input-container><md-input-container \nclass="md-block"><label translate="USERS.EMAIL"></label> <input \nng-disabled="vm.userLogued.user_type != 1 && vm.userSelected.user_type == 1" type="email" \nng-model="vm.userSelected.email" placeholder="" autocomplete="off"></md-input-container><md-input-container \nclass="md-block"><label translate="USERS.PASSWORD"></label> <input \nng-disabled="vm.userLogued.user_type != 1 && vm.userSelected.user_type == 1" type="password" \nng-model="vm.userSelected.password" placeholder="" autocomplete="false"></md-input-container><md-input-container \nclass="md-block"><label translate="USERS.PHONE"></label> <input \nng-disabled="vm.userLogued.user_type != 1 && vm.userSelected.user_type == 1" type="phone" \nng-model="vm.userSelected.phone" placeholder="" autocomplete="false"></md-input-container><div \nng-if="vm.userLogued.user_type == 1 || vm.userSelected.user_type != 1" class="md-block"><div><div ngf-drop ngf-select \nng-model="vm.files" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="image/*" ngf-pattern="\'image/*\'"><div layout="column"><div flex translate="GLOBAL.DROP_HERE">\nDrop here or click to upload</div><div flex translate="GLOBAL.OR"></div><div flex><md-button \nclass="send-button md-accent md-raised" aria-label="Select files" translate="GLOBAL.SELECT_FILES"></md-button></div>\n</div></div><div ngf-no-file-drop translate="GLOBAL.FILE_DRAG_DROP"></div></div><div ng-repeat="f in vm.files" \nclass="ms-card" flex><div ng-if="!f.url" class="ms-card-content-wrapper"><div class="template-9"><div class="media" \nflex layout="row" layout-align="center center"><img ngf-thumbnail="!f.$error && f" class="image"></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><strong class="mr-5" ng-if="f.id">#{{f.id}}</strong> <span class="grey-500-fg"><span \nng-if="f.name">{{f.name}}</span></span></div></div></div><md-progress-linear md-mode="determinate" \nvalue="{{f.progress}}" ng-show="f.progress < 100"></md-progress-linear></div></div><div ng-if="f.url" \nstyle="max-width: 300px;" class="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><img style="max-width: 200px" ng-src="{{storagePrefix + f.url}}" class="image"></div><div \nclass="p-16" flex layout="row" layout-align="end center"><md-menu class="float-right"><md-button \nclass="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.deleteAvatar(f)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-content></md-menu></div>\n<md-progress-linear md-mode="determinate" value="{{f.progress}}" ng-show="f.progress < 100"></md-progress-linear></div>\n</div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/users/views/edit/edit-menu.html','<div class="toolbar grey-100-bg colored-bg" layout="row" layout-align="space-between center" \nng-if="vm.userSelected || vm.userNew" scroll=""><div layout="row" layout-align="start center"><div layout="column" \nlayout-align="start center"><span translate="USERS.MENU">MENU</span></div></div></div><div \nclass="mb-100 without-line scrollable preview" flex="100"><div ivh-treeview="vm.tabMenu" \nivh-treeview-options="vm.ivhOptions" class="treeview" \nivh-treeview-on-cb-change="vm.callback(ivhNode, ivhIsSelected, ivhTree)" ivh-treeview-click-handler="alert(0)"><script \ntype="text/ng-template">\n<div class="level-card">\n                    <span ivh-treeview-toggle>\n                        <span ivh-treeview-twistie></span>\n                    </span>\n                    <md-icon md-font-icon="{{node.icon}}"></md-icon>\n                    <span class="ivh-treeview-node-label" ivh-treeview-toggle translate="MENU.{{node.label}}">{{trvw.label(node)}}</span>\n                    <div style="float:right;">\n                        <md-icon md-font-icon="icon-checkbox-marked-circle" class="on green-fg s24" ng-if="node.active" ng-click="node.imprimir(node)"></md-icon>\n                        <md-icon md-font-icon="icon-checkbox-blank-circle-outline" class="on red-fg s24" ng-if="!node.active" ng-click="node.imprimir(node)"></md-icon>\n                    </div>\n                    \n                </div>\n                <div ivh-treeview-children></div>\n</script></div></div>');
$templateCache.put('app/main/apps/users/views/edit/edit-new.html','<div class="mail-content file-details scrollable" ms-scroll="vm.msScrollOptions"><div layout="row"><div \nclass="form-wrapper md-whiteframe-1dp" flex="100"><div><md-input-container ng-if="vm.userNew.user_type != 1" \nclass="md-block mt-0 mb-0"><button ng-if="vm.userNew.enabled" class="md-icon-button md-button"><md-icon \nmd-font-icon="icon-checkbox-marked-circle" class="on green-fg s24" ng-click="vm.toggleUserStatusEdit(\'enabled\')">\n</md-icon></button> <button ng-if="!vm.userNew.enabled" class="md-icon-button md-button"><md-icon \nmd-font-icon="icon-checkbox-blank-circle-outline" class="off red-fg s24" ng-click="vm.toggleUserStatusEdit(\'enabled\')">\n</md-icon></button> <label class="inline">\n{{vm.userNew.enabled ? (\'USERS.ACTIVE\' | translate) : (\'USERS.INACTIVE\' | translate)}}</label></md-input-container>\n<md-input-container class="md-block"><md-select required ng-model="vm.userNew.user_type" \nplaceholder="{{\'GLOBAL.ROLE\' | translate}}"><md-option ng-value="2">{{\'GLOBAL.ADMINISTRATOR\' | translate}}</md-option>\n<md-option ng-value="3">{{\'GLOBAL.COMPLIANCE_OFFICER\' | translate}}</md-option><md-option ng-value="6">\n{{\'GLOBAL.COLLABORATOR\' | translate}}</md-option></md-select></md-input-container><md-input-container class="md-block">\n<label translate="USERS.FIRSTNAME"></label> <input type="search" ng-model="vm.userNew.first_name" placeholder="" \nrequired autocomplete="off"></md-input-container><md-input-container class="md-block"><label \ntranslate="USERS.LASTNAME"></label> <input type="search" ng-model="vm.userNew.last_name" placeholder="" required \nautocomplete="off"></md-input-container><md-input-container class="md-block"><label>\n{{vm.getRegionLiteral(\'id_number\')}}</label> <input type="search" ng-model="vm.userNew.id_number" placeholder="" \nautocomplete="off"></md-input-container><md-input-container class="md-block"><label translate="USERS.EMAIL"></label> \n<input type="email" ng-model="vm.userNew.email" placeholder="" required autocomplete="off"></md-input-container>\n<md-input-container class="md-block"><label translate="USERS.PASSWORD"></label> <input type="new-password" \nng-model="vm.userNew.password" placeholder="" autocomplete="off"></md-input-container><md-input-container \nclass="md-block"><label translate="USERS.PHONE"></label> <input type="phone" ng-model="vm.userNew.phone" \nplaceholder="" autocomplete="off"></md-input-container><div class="md-block"><div><div ngf-drop ngf-select \nng-model="vm.files" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="image/*" ngf-pattern="\'image/*\'"><div layout="column"><div flex translate="GLOBAL.DROP_HERE">\nDrop here or click to upload</div><div flex translate="GLOBAL.OR"></div><div flex><md-button \nclass="send-button md-accent md-raised" aria-label="Select files" translate="GLOBAL.SELECT_FILES"></md-button></div>\n</div></div><div ngf-no-file-drop translate="GLOBAL.FILE_DRAG_DROP"></div></div><div ng-repeat="f in vm.files" \nclass="ms-card" flex><div class="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><img ngf-thumbnail="!f.$error && f" class="image"></div><div class="header p-16" flex><div\n layout="row" layout-align="space-between center" flex><div class="size" layout="row" layout-align="start left"><strong\n class="mr-5" ng-if="f.id">#{{f.id}}</strong> <span class="grey-500-fg"><span ng-if="f.name">{{f.name}}</span></span>\n</div></div></div><md-progress-linear md-mode="determinate" value="{{f.progress}}" ng-show="f.progress <100">\n</md-progress-linear></div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/users/views/edit/edit-view-nosplit.html','<div flex layout="column" layout-align="center center" ng-if="vm.loadingReadPane" class="loading-container">\n<md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div><div \nng-show="!vm.loadingReadPane"><div class="mail-content" layout="column" layout-align="center center" \nng-if="!vm.userSelected"><div class="content" layout="column" layout-align="top center"><div class="message">\nPlease select a user to show in this panel</div></div></div><form name="vm.basicForm" class="md-inline-form" \nnovalidate><md-content ng-if="vm.userSelected && !vm.editData" \nng-include="\'app/main/apps/accounts/views/edit/edit-tabs.html\'" class="scrollable"></md-content><md-content \nng-if="vm.userSelected && vm.editData" ng-include="\'app/main/apps/accounts/views/edit/edit-data.html\'" \nclass="scrollable"></md-content></form></div>');
$templateCache.put('app/main/apps/users/views/edit/edit-view.html','<div class="content thread-detail" layout="row" layout-align="center center" flex ng-if="vm.loadingReadPane"><div flex \nlayout="column" layout-align="center center" class="loading-container"><md-progress-circular md-mode="indeterminate" \nmd-diameter="50"></md-progress-circular></div></div><div class="content thread-detail" layout="row" \nlayout-align="center center" flex ng-if="!vm.userSelected && !vm.userNew && !vm.loadingReadPane"><div \nclass="no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-clipboard-account" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="USERS.SELECT_USER"></span></div></div><div ng-show="!vm.loadingReadPane" flex><div \nclass="toolbar grey-100-bg colored-bg" layout="row" layout-align="space-between center" \nng-if="vm.userSelected || vm.userNew" scroll=""><div layout="row" layout-align="start center"><md-button \nclass="md-icon-button close-thread" aria-label="Back" ng-click="vm.closeUser()" translate \ntranslate-attr-aria-label="USERS.BACK" ng-if="(vm.userSelected || vm.userNew) && vm.currentView==\'nosplit\'"><md-icon \nmd-font-icon="icon-keyboard-backspace"></md-icon></md-button></div><div layout="row" layout-align="end center" \nng-if="vm.userSelected || vm.userNew" hide show-gt-sm><md-button type="button" ng-click="vm.closeUser()" \nclass="md-raised md-warn" aria-label="Cancel" translate="USERS.CANCEL" translate-attr-aria-label="USERS.CANCEL">Cancel\n</md-button><md-button type="submit" ng-click="vm.saveUser($event)" class="send-button md-accent md-raised" \nng-disabled="vm.basicForm.$invalid || vm.basicForm.$pristine" aria-label="SAVE" translate="USERS.SAVE" \ntranslate-attr-aria-label="USERS.SAVE">SAVE</md-button></div><div layout="row" layout-align="end center" \nng-if="vm.userSelected || vm.userNew" hide-gt-sm><md-button type="button" ng-click="vm.closeUser()" \nclass="md-warn md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" aria-label="Cancel"><md-icon \nmd-font-icon="icon-window-close"></md-icon><md-tooltip hide show-gt-sm><span translate="USERS.CANCEL">Cancel</span>\n</md-tooltip></md-button><md-button type="submit" ng-click="vm.saveUser($event)" \nclass="md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme" \nng-disabled="vm.basicForm.$invalid || vm.basicForm.$pristine" aria-label="SAVE"><md-icon md-font-icon="icon-check" \nng-hide="vm.savingProcess"></md-icon><md-progress-circular md-mode="indeterminate" ng-if="vm.savingProcess">\n</md-progress-circular><md-tooltip hide show-gt-sm><span translate="USERS.SAVE">Save</span></md-tooltip></md-button>\n</div></div><form name="vm.basicForm" class="md-inline-form" novalidate ng-if="vm.userSelected || vm.userNew"><div \nclass="mail-content file-details scrollable" ms-scroll="vm.msScrollOptions"><md-list ng-if="vm.userSelected" \nclass="pv-20 ph-8"><md-list-item class="main-item"><div class="main-read"><div class="avatar-container"><user-avatar \nuser="vm.userSelected"></div></div><div class="main-read"><h1 class="name"><strong \nng-bind-html="vm.userSelected.first_name"></strong> <strong ng-bind-html="vm.userSelected.last_name"></strong></h1><p>\n<span class="font-size-16 text-truncate" ng-bind-html="vm.userSelected.email"></span></p></div></md-list-item>\n</md-list><md-divider ng-if="vm.userSelected"></md-divider><div class="toolbar colored-bg" layout="row" \nlayout-align="space-between center" ng-if="vm.userSelected || vm.userNew" scroll=""><div layout="row" \nlayout-align="start center"><md-button aria-label="Edit" class="md-icon-button" translate="" \nng-click="vm.viewEditData()" translate-attr-aria-label="USERS.EDIT" \nng-class="{\'tab-selected\': vm.tabActive==\'edit\' || vm.tabActive==\'editnew\'}"><md-icon md-font-icon="icon-account">\n</md-icon><md-tooltip hide show-gt-sm><span translate="USERS.EDIT">Edit</span></md-tooltip></md-button><div \nclass="divider-vertical" hide="" show-gt-sm=""></div><md-button aria-label="Companies" class="md-icon-button" \ntranslate="" ng-click="vm.viewEditCompanies()" translate-attr-aria-label="USERS.COMPANIES" \nng-class="{\'tab-selected\': vm.tabActive==\'companies\'}"><md-icon md-font-icon="icon-city"></md-icon><md-tooltip hide \nshow-gt-sm><span translate="USERS.COMPANIES">Companies</span></md-tooltip></md-button><md-button \nng-if="vm.tabActive !==\'editnew\'" aria-label="Activity" class="md-icon-button" translate="" \nng-click="vm.viewActivity()" translate-attr-aria-label="USERS.COMPANIES" \nng-class="{\'tab-selected\': vm.tabActive==\'activity\'}"><md-icon md-font-icon="icon-run"></md-icon><md-tooltip hide \nshow-gt-sm><span translate="USERS.ACTIVITY">ACTIVITY</span></md-tooltip></md-button><md-button \nng-if="vm.tabActive !==\'editnew\'" aria-label="Tasks" class="md-icon-button" translate="" ng-click="vm.viewTasks()" \ntranslate-attr-aria-label="USERS.COMPANIES" ng-class="{\'tab-selected\': vm.tabActive==\'tasks\'}"><md-icon \nmd-font-icon="icon-timelapse"></md-icon><md-tooltip hide show-gt-sm><span translate="USERS.TASKS">TASKS</span>\n</md-tooltip></md-button><div class="divider-vertical" hide="" show-gt-sm=""></div><md-button \nng-if="vm.isAvailableConfigureMenu()" aria-label="Menu" class="md-icon-button" translate="" ng-click="vm.viewMenu()" \ntranslate-attr-aria-label="USERS.COMPANIES" ng-class="{\'tab-selected\': vm.tabActive==\'menu\'}"><md-icon \nmd-font-icon="icon-cog"></md-icon><md-tooltip hide show-gt-sm><span translate="USERS.MENU">MENU</span></md-tooltip>\n</md-button></div></div><md-content ng-if="vm.tabActive==\'editnew\'" \nng-include="\'app/main/apps/users/views/edit/edit-new.html\'" class="scrollable"></md-content><md-content \nng-if="vm.tabActive==\'edit\'" ng-include="\'app/main/apps/users/views/edit/edit-data.html\'" class="scrollable">\n</md-content><md-content ng-if="vm.tabActive==\'companies\'" \nng-include="\'app/main/apps/users/views/edit/edit-companies.html\'" class="scrollable"></md-content><activity-user \nng-if="vm.tabActive !==\'editnew\' && vm.tabActive==\'activity\'" id-user="vm.userSelected.id"></activity-user><div \nng-if="vm.companySelected && vm.tabActive !==\'editnew\'"><tasks-user ng-show="vm.tabActive==\'tasks\'" \nid-user="vm.userSelected.id"></tasks-user></div><div ng-if="vm.tabActive ==\'menu\'"><configure-tabs \nng-if="vm.userSelected.id" user-logued="vm.userLogued" user-selected="vm.userSelected"></configure-tabs></div></div>\n</form></div>');
$templateCache.put('app/main/apps/users/views/edit/view-activity.html','<div class="mail-content file-details scrollable" ms-scroll="vm.msScrollOptions"><md-list><md-list-item \nng-if="vm.userSelectedID" class="main-item"><div class="main-read"><div class="avatar-container"><div \nng-if="(vm.userSelected.avatar == \'\' || !vm.userSelected.avatar)" class="avatar" \nng-bind="vm.userSelected.first_name | capitalizeFirstLetter" \nstyle="background-color:{{vm.userSelected.profile_color}}"></div><div ng-if="vm.userSelected.avatar" \nattachment="vm.userSelected.avatar"><img class="avatar hide show spinner-show" ng-src="{{vm.userSelected.avatar}}" \nimageonload=""></div><md-icon ng-if="vm.userSelected.active ===1" md-font-icon="icon-checkbox-marked-circle" \nclass="on green-fg s24"></md-icon><md-icon ng-if="vm.userSelected.active !==1" \nmd-font-icon="icon-checkbox-blank-circle-outline" class="off red-fg s24"></md-icon></div></div><div class="main-read">\n<h1 class="name"><strong ng-bind-html="vm.userSelected.first_name"></strong> <strong \nng-bind-html="vm.userSelected.last_name"></strong></h1><p><span class="font-size-16 text-truncate" \nng-bind-html="vm.userSelected.email"></span></p></div></md-list-item><md-divider></md-divider><md-list-item \nclass="md-toolbar-tools grey-100-bg" layout="row" layout-align="space-between center"><div layout="row" \nlayout-align="start center"><h3 class="grey-700-fg" translate="ACCOUNTS.ACTIVITY"></h3></div></md-list-item>\n<md-divider></md-divider><div class="activities-list"><table hide show-gt-lg><tr \nng-repeat="log in vm.userSelected.log"><td><div layout="row" layout-align="start center"><md-icon \nmd-font-icon="{{log.module.icon_v3}}" class="mr-10 ml-0 s30"><md-tooltip hide show-gt-xs><span>{{log.module.title}}\n</span></md-tooltip></md-icon><div><div class="field module-name" ng-if="log.id_service == 2"><span \nclass="grey-800-fg" ng-bind-html="log.section.languages[0].text"></span></div><div class="field module-name" \nng-if="log.id_service != 2"><span class="grey-800-fg" ng-bind-html="log.module.module_name"></span></div></div></div>\n</td><td><div class="field" layout="row" layout-align="start center"><div layout="row" layout-align="end center"><span \nclass="grey-500-fg" ng-bind-html="vm.timeAgo(log.date)"></span></div></div></td><td><div class="field"><span \nclass="grey-800-fg mr-5">ID #{{log.id_from_section}}</span> <span class="grey-500-fg" ng-bind-html="log.description">\n</span></div></td><td><div class="field" layout="row" layout-align="end center"><span \nclass="status {{log.action.action_name}}" ng-bind-html="log.action.action_name"></span></div></td></tr></table>\n<md-list-item hide-gt-lg ng-repeat="log in vm.userSelected.log" class="pl-16 pr-16"><div layout="row" \nlayout-align="space-between center" flex="100" class="layout-align-space-between-center layout-row"><md-icon \nmd-font-icon="{{log.module.icon_v3}}" class="mr-16 ml-0 s30" hide show-gt-xs><md-tooltip hide show-gt-xs><span>\n{{log.module.module_name}}</span></md-tooltip></md-icon><div layout="column" layout-align="center space-between " \nclass="field flex"><div layout="row" layout-align-gt-xs="start center" layout-align-xs="space-between center" \nclass="mb-10"><div layout="row" layout-align="start center"><md-icon md-font-icon="{{log.module.icon_v3}}" \nclass="mr-5 ml-0" hide-gt-xs><md-tooltip hide show-gt-xs><span>{{log.module.module_name}}</span></md-tooltip></md-icon>\n<div class="field mr-10 module-name"><span class="grey-800-fg" ng-if="log.id_service == 2" \nng-bind-html="log.section.languages[0].text"></span> <span class="grey-800-fg" ng-if="log.id_service != 2" \nng-bind-html="log.module.module_name"></span></div><span class="grey-500-fg" ng-bind-html="vm.timeAgo(log.date)">\n</span></div><div class="field" hide-gt-xs><span class="status {{log.action.action_name}}" \nng-bind-html="log.action.action_name"></span></div></div><div class="text-truncate"><span class="grey-800-fg mr-5">\nID #{{log.id_from_section}}</span> <span class="grey-500-fg" ng-bind-html="log.description"></span></div></div><div \nlayout="row" layout-align="end center" hide show-gt-xs><div class="field"><span \nclass="status {{log.action.action_name}}" ng-bind-html="log.action.action_name"></span></div></div></div><md-divider \nclass="md-default-theme"></md-divider></md-list-item></div></md-list></div>');
$templateCache.put('app/main/apps/users/views/list/list-view.html','<div flex layout="column" layout-align="center center" layout-padding layout-margin ng-if="isLoading" \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n<div class="no-threads" ng-if="!vm.users" ng-hide="isLoading" translate="GLOBAL.NO_ITEMS"></div><div \nid="list-content-data" ng-style="{\'opacity\' : isLoading ? 0.5 : 1}"><div class="mail-list-item" \nng-repeat="user in vm.users | filter: vm.search | filter: global.search" ng-init="parentIndex = $index" md-no-ink \nng-click="vm.openUser(user)" \nng-class="{\'starred\': user.starred, \'selected\': vm.userSelected.id === user.id, \'checked\': vm.isSelected(user)}"><div \nlayout="row" layout-align="start center"><md-checkbox ng-if="user.user_type != 1" class="no-label" \nng-checked="vm.isSelected(user)" ng-click="vm.toggleSelectThread(user, $event)" \naria-label="{{vm.isSelected(user) ? \'Deselect\' : \'Select\'}}"></md-checkbox><div class="avatar-wrapper"><user-avatar \nuser="user"></div><div class="info layout-column flex" flex="" layout="column"><div class="name text-truncate" \nlayout="row" layout-align="start center"><span>{{user.first_name}}</span> <span>{{user.last_name}}</span></div><div \nclass="details text-truncate" layout="row" layout-align="start center"><span>{{user.email}}</span></div></div><div \nclass="info flex" flex="" layout-align="center end" layout="column"><div layout="row" layout-align="start center"><div \nng-repeat="company in user.companies" class="avatar-wrapper" ng-show="company.files.length > 0"><img \nmd-menu-align-target class="avatar" ng-src="{{vm.config.storagePrefix}}{{company.files[0].url}}"></div>\n<md-input-container ng-if="user.user_type != 1" class="md-block mt-0 mb-0"><button ng-if="user.enabled" \nclass="md-icon-button md-button"><md-icon md-font-icon="icon-checkbox-marked-circle" class="on green-fg s24" \nng-click="vm.toggleUserStatusEdit(\'enabled\',user)"></md-icon></button> <button ng-if="!user.enabled" \nclass="md-icon-button md-button"><md-icon md-font-icon="icon-checkbox-blank-circle-outline" class="off red-fg s24" \nng-click="vm.toggleUserStatusEdit(\'enabled\',user)"></md-icon></button></md-input-container></div></div></div></div><div\n ng-if="!isLoading && pagination_total_pages > pagination_page && vm.users.length > 0" class="load-more white p-30" \nlayout="row" layout-sm="column" layout-align="center center" layout-wrap=""><md-button \nng-click="pagination_nextPage(true)" class="md-raised">{{\'GLOBAL.LOAD_MORE\' |\xA0translate}}</md-button></div><div \nng-if="pagination_total_pages == pagination_page && pagination_page > 1" class="load-more white p-30" layout="row" \nlayout-sm="column" layout-align="center center" layout-wrap=""><div class="message" translate="GLOBAL.NO_MORE_ITEMS">\n</div></div></div>');
$templateCache.put('app/main/apps/users/views/list/nosplit-view.html','<div class="toolbar" layout="row" layout-align="space-between center" ng-if="!vm.userSelected && !vm.userNew" \nng-include="\'app/main/apps/users/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row"><div\n class="content thread-detail mail-read-pane p0 scrollable" flex="" id="thread-detail" ms-scroll="vm.msScrollOptions" \nng-if="vm.userSelected || vm.userNew" ng-include="\'app/main/apps/users/views/edit/edit-view.html\'"></div><div \nclass="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-if="!vm.userSelected && !vm.userNew" ng-include="\'app/main/apps/users/views/list/list-view.html\'"></div></div>');
$templateCache.put('app/main/apps/users/views/list/split-view.html','<div class="toolbar" layout="row" layout-align="space-between center" \nng-include="\'app/main/apps/users/views/list/toolbar.html\'"></div><div class="content-wrapper" flex="" layout="row"><div\n class="content thread-list mail-list-pane scrollable p0" flex="" ms-scroll="vm.msScrollOptions" id="thread-list" \nng-include="\'app/main/apps/users/views/list/list-view.html\'"></div><div \nclass="content thread-detail mail-read-pane p0" flex="" id="thread-detail" scrollable ms-scroll="vm.msScrollOptions" \nng-include="\'app/main/apps/users/views/edit/edit-view.html\'"></div></div>');
$templateCache.put('app/main/apps/users/views/list/toolbar.html','<div layout="row" style="min-width: 250px;" layout-align="start center"><md-checkbox class="no-label" \naria-label="{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}" \nng-checked="vm.selectedThreads.length > 0" ng-click="vm.toggleSelectThreads(vm.selectedThreads, vm.contents)">\n</md-checkbox><div class="divider-vertical" hide="" show-gt-xs=""></div><md-button aria-label="NEW" \nclass="md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme" hide show-gt-sm \nng-click="vm.newUser($event)" translate="GLOBAL.NEW" type="button"></md-button><md-button aria-label="NEW" \nclass="md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme z-index-0" hide-gt-sm \nng-click="vm.newUser($event)" type="button"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="divider-vertical" hide="" show-gt-xs=""></div><div aria-hidden="false" \nclass="action-buttons hide show-gt-xs layout-align-start-center layout-row" layout="row" layout-align="start center" \nng-show="vm.selectedThreads.length > 0"><md-button ng-click="vm.deleteUser($event)" aria-label="Delete" \nclass="md-icon-button" hide="" show-gt-xs="" translate=""><md-icon md-font-icon="icon-delete"></md-icon><md-tooltip \nhide show-gt-xs><span translate="GLOBAL.REMOVE"></span></md-tooltip></md-button><div class="divider-vertical" hide="" \nshow-gt-xs=""></div></div><ms-search-bar debounce="300" model-search="$root.pagination_searchquery" \non-result-click="vm.searchResultClick(item)" on-search="vm.search(query)" layout="row" layout-align="start center">\n</ms-search-bar><md-button ng-click="$root.pagination_resetquery()" aria-label="view type" class="md-icon-button" \ntranslate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nng-if="$root.pagination_searchquery==true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon><md-tooltip \nhide show-gt-xs><span>Reset search</span></md-tooltip></md-button><div class="divider-vertical" hide="" show-gt-xs="">\n</div><md-menu hide="" show-gt-xs="" ng-if="refGroupables.length>0"><button aria-label="Filters" \nclass="md-icon-button" ng-click="$mdMenu.open($event)" show-gt-xs="" translate="" \ntranslate-attr-aria-label="GLOBAL.FILTERS"><md-icon md-font-icon="icon-chevron-down"><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.GROUP_BY">Group</span></md-tooltip></md-icon></button><md-menu-content width="4"><md-menu-item \nng-repeat="sortfield in refGroupables"><md-button aria-label="All" ng-click="pagination_setOrderBy(sortfield)"><div \nlayout="row" layout-align="space-between center"><span>Group by {{sortfield.name}} </span><i class="icon-check s16" \nng-if="sortfield.titleId == sortable.titleId"></i></div></md-button></md-menu-item><md-menu-divider ng-if="groupable">\n</md-menu-divider><md-menu-item ng-if="groupable"><md-button aria-label="Remove group" \nng-click="pagination_resetOrderBy()"><md-icon md-font-icon="icon-close "></md-icon><span>Remove order</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div><div layout="row" layout-align="start center" \ntranslate-attr-aria-label="GLOBAL.REFRESH"><span ng-if="!isLoading" class="page-info font-weight-500">\n{{vm.users.length}} {{ \'GLOBAL.OF\' | translate}} {{pagination_totalItems}} {{ \'GLOBAL.ITEMS\' | translate}}.</span><div \nclass="divider-vertical" hide hide show-gt-sm></div><md-button class="md-icon-button" \nng-click="vm.changeView(\'nosplit\')" ng-if="vm.currentView !== \'nosplit\'" hide show-gt-sm><md-icon \nmd-font-icon="icon-view-list" ng-if="vm.currentView !== \'nosplit\'"></md-icon><md-icon class="md-accent" \nmd-font-icon="icon-checkbox-marked" ng-if="vm.currentView === \'nosplit\'"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.NOSPLIT_VIEW">No split</span></md-tooltip></md-button><md-button class="md-icon-button" \nng-click="vm.changeView(\'split\')" ng-if="vm.currentView !== \'split\'" hide show-gt-sm><md-icon \nmd-font-icon="icon-view-quilt" ng-if="vm.currentView !== \'split\'"></md-icon><md-icon class="md-accent" \nmd-font-icon="icon-checkbox-marked" ng-if="vm.currentView === \'split\'"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate="GLOBAL.SPLIT_VIEW">split</span></md-tooltip></md-button><md-menu class="settings-menu" hide-gt-xs \nng-show="vm.selectedThreads.length > 0"><md-button aria-label="Settings" class="md-icon-button" \nng-click="$mdMenu.open($event)" translate="GLOBAL.SETTINGS" translate-attr-aria-label="GLOBAL.SETTINGS"><md-icon \nmd-font-icon="icon-dots-horizontal"></md-icon></md-button><md-menu-content><md-menu-item ng-click="vm.deleteClient()" \nshow="vm.selectedMail.length > 0 || vm.allChecked"><md-button ng-click="vm.deleteUser($event)" aria-label="Delete" \ntranslate-aria-label="GLOBAL.DELETE"><md-icon md-font-icon="icon-delete"></md-icon><span translate="GLOBAL.DELETE">\nDelete</span></md-button></md-menu-item></md-menu-content></md-menu></div>');
$templateCache.put('app/main/components/material-docs/partials/CSS/button.html','<div class="doc-content theming"><h1 id="-lt-md-button-gt-">&lt;md-button&gt;</h1><p>\nBelow is a snapshot of the Angular Material <strong>button</strong>\n component demos with the default themes and standard options:</p><p><img \nsrc="https://cloud.githubusercontent.com/assets/210413/7947020/fafde934-093f-11e5-9584-27eb2deedd0f.png" \nalt="buttonsdemo"></p><p><br></p><h3 id="css-styles">CSS Styles</h3><p>The base CSS class for all <code>\n&lt;md-button&gt;</code> components is <code>.md-button</code>:</p><hljs lang="css">\n.md-button { padding: 0 6px 0 6px; margin: 6px 8px 6px 8px; min-width: 88px; border-radius: 3px; font-size: 14px; text-align: center; text-transform: uppercase; text-decoration:none; border: none; outline: none; }\n</hljs><p>When defining custom CSS overrides, developers should create their own CSS class. For example, to define a \n<code>.btn1</code> override to <strong>md-button</strong> use:</p><hljs lang="css">\n.btn1 { // your custom overrides here }</hljs><hljs lang="html"><md-button class="btn1" ng-click="acceptOffer();">\nAccept</md-button></hljs><p><br></p><h3 id="theme-requirements">Theme Requirements</h3><p>\nAll Angular Material components have specific CSS rules constructed using the theme name and theme-class overrides. For the \n<strong>Default</strong> theme, however, these rules are added to the components styles using the <code>\n.md-default-theme</code> class. If, however, you have configured a custom theme called <code>companyX</code> that is \n<strong>NOT</strong> the default theme, then any CSS overrides <strong>must</strong>\n use fully-specified classname. For <code>&lt;md-button&gt;</code> the <strong>fully-specified classname</strong>\n will be <code>.md-button.md-companyX-theme.btn1</code>.</p><hljs lang="css">\n.md-button.md-companyX-theme.btn1 { } .md-button.md-companyX-theme.md-primary.btn1 { } .md-button.md-companyX-theme.md-accent.btn1 { } .md-button.md-companyX-theme.md-warn.btn1 { }\n</hljs><p><br></p><h2 id="flat-buttons">Flat Buttons</h2><p><img \nsrc="https://cloud.githubusercontent.com/assets/210413/7945984/bda14884-0939-11e5-9196-131ded20ca77.png" \nalt="mdbuttonflatdefault3"></p><hljs lang="html"><md-button>Button</md-button></hljs><hljs lang="css">\n.md-button { color : currentColor; } .md-button:not([disabled]):hover { background-color: rgba(158, 158, 158, 0.2); } .md-button[disabled] { color : rgba(0, 0, 0, 0.26); background-color: transparent; }\n</hljs><p><br></p><h4 id="custom-css-overrides">Custom CSS Overrides</h4><p><img \nsrc="https://cloud.githubusercontent.com/assets/210413/7945987/c1b1c700-0939-11e5-879c-ba804ca03267.png" \nalt="mdbuttonflatdefault_overrides2"></p><hljs lang="html"><md-button class="btn1">Button</md-button></hljs><hljs \nlang="css">\n.btn1 { color : rgb(49, 46, 46); background-color: rgba(255, 222, 121, 0.96); border-radius: 10px 0 0 10px; font-size: 16px; } .btn1:not([disabled]):hover { background-color: rgba(107, 103, 91, 0.96); color: white; } .btn1[disabled] { color : rgb(187, 187, 187); background-color: rgba(230, 230, 229, 0.96); }\n</hljs><p><br></p><h2 id="raised-buttons">Raised Buttons</h2><p><img \nsrc="https://cloud.githubusercontent.com/assets/1292882/7254163/fe898728-e849-11e4-943b-a9cd88ec9573.PNG" \nalt="raisedbutton"></p><p>Add the <code>.md-raised</code> class to create a raised button:</p><hljs lang="html">\n<md-button class="md-raised">Button</md-button></hljs><hljs lang="css">\n.md-button.md-raised:not([disabled]) { box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26); }</hljs><p><br></p><h2 \nid="cornered-buttons">Cornered buttons</h2><p><img \nsrc="https://cloud.githubusercontent.com/assets/1292882/7254379/682592ac-e84b-11e4-8d33-78314cea8bda.PNG" \nalt="corneredbutton"></p><p>Add the <code>.md-cornered</code> class to create a button with corners:</p><hljs \nlang="html"><md-button class="md-raised md-cornered">Button</md-button></hljs><hljs lang="css">\n.md-button.md-cornered { border-radius: 0; }</hljs><p><br></p><h2 id="default-fab-button">Default FAB Button</h2><p>\n<img src="https://cloud.githubusercontent.com/assets/1292882/7254736/8fec7ee8-e84d-11e4-9cf9-58ea9221c3c2.PNG" \nalt="floatingbutton"></p><p>Add the <code>.md-fab</code> class in order to create a floating action button (aka FAB):\n</p><hljs lang="html"><md-button class="md-fab" aria-label="Eat cake"><md-icon \nmd-svg-src="assets/angular-material-assets/img/icons/cake.svg"></md-icon></md-button></hljs><hljs lang="css">\n.md-button.md-fab { line-height: 5.6rem; min-width: 0; width: 5.6rem; height: 5.6rem; border-radius: 50%; }</hljs><p>\n<br></p><h2 id="mini-fab-button">Mini FAB Button</h2><p><img \nsrc="https://cloud.githubusercontent.com/assets/1292882/7273617/1fcca280-e8fe-11e4-9588-231a9e860be1.PNG" \nalt="minibutton"></p><p>Add the <code>.md-mini</code> class in order to create small, mini-FAB buttons:</p><hljs \nlang="html"><md-button class="md-fab md-mini" aria-label="Eat cake"><md-icon \nmd-svg-src="assets/angular-material-assets/img/icons/cake.svg"></md-icon></md-button></hljs><hljs lang="css">\n.md-button.md-fab.md-mini { line-height: 4rem; width: 4rem; height: 4rem; }</hljs><p><br></p><h2 \nid="icon-button-using-svgs">Icon button using SVGs</h2><p><img \nsrc="https://cloud.githubusercontent.com/assets/1292882/7273908/d701bd8a-e900-11e4-84c7-44c580c7372d.PNG" \nalt="iconbutton"></p><p>Create icon buttons by adding the <code>.md-icon-button</code> class and the <code>\n&lt;md-icon ...&gt;</code> component:</p><hljs lang="html"><md-button class="md-icon-button md-primary" \naria-label="Settings"><md-icon md-svg-icon="assets/angular-material-assets/img/icons/menu.svg"></md-icon></md-button>\n</hljs><hljs lang="css">\n.md-button.md-icon-button { margin: 0 0.6rem; height: 4.8rem; min-width: 0; line-height: 4.8rem; padding-left: 0; padding-right: 0; width: 4.8rem; }\n</hljs><p><br></p><h2 id="icon-button-using-font-icons">Icon button using Font-icons</h2><p><img \nsrc="https://cloud.githubusercontent.com/assets/1292882/7670414/f57721ba-fcab-11e4-9a22-67970063797c.PNG" \nalt="fonticonbutton"></p><p>Here is another example of a button with font icons:</p><hljs lang="html"><md-button>\n<md-icon md-font-icon="icon-home" ng-style="{color: \'green\', \'font-size\':\'36px\', height:\'36px\'}"></md-icon></md-button>\n</hljs><p><br></p><h2 id="grouping-with-css-overrides">Grouping with CSS Overrides</h2><p><img \nsrc="https://cloud.githubusercontent.com/assets/210413/7961138/1b48bb16-09cb-11e5-9283-bdda28b8bb66.png" \nalt="mdbuttongroup"></p><p>Using the customization approaches documented above, we can easily create a mdButtonGroup:\n</p><hljs lang="html"><section layout="row" layout-align="center center"><md-button class="groupX left">Apple\n</md-button><md-button class="groupX middle">Samsung</md-button><md-button class="groupX middle">Sony</md-button>\n<md-button class="groupX right">B&amp;O</md-button></section></hljs><hljs lang="css">\n.groupX { font-size: 16px; margin: 20px 0; padding: 3px 15px 3px 15px; color: rgb(49, 46, 46); background-color: rgba(224, 224, 224, 0.96); text-transform: none; font-weight: 400; min-width:100px; } .md-button.left { border-radius: 10px 0 0 10px; } .md-button.middle { border-radius: 0; border-left: 1px solid rgba(230, 230, 230, 0.96); border-right: 1px solid rgba(230, 230, 230, 0.96); } .md-button.right { border-radius: 0 10px 10px 0; } .md-button:not([disabled]):hover { background-color: rgba(193, 193, 193, 0.96); color: rgba(44, 65, 164, 0.96); transition: 0.3s; }\n</hljs></div>');
$templateCache.put('app/main/components/material-docs/partials/CSS/checkbox.html','<div class="doc-content theming"><h2>CSS Styles</h2><p>The css decalaration of the <code>&lt;md-checkbox&gt;</code>\n component is:</p><hljs lang="css">\nmd-checkbox { margin: 8px; cursor: pointer; padding-left: 18px; padding-right: 0; line-height: 26px; min-width: 18px; min-height: 18px; }\n</hljs><p><br></p><h3>Ink color</h3><p>In order to change the color when the checkbox is checked:</p><p><img \nsrc="https://cloud.githubusercontent.com/assets/1292882/8035909/b2130da0-0dfc-11e5-932f-4424d3b46d5b.PNG" \nalt="greencheckbox"></p><hljs lang="html"><md-checkbox class="green">Green Checkbox</md-checkbox></hljs><hljs \nlang="css">md-checkbox.md-checked.green .md-icon { background-color: rgba(0, 255, 0, 0.87); }</hljs><p><br></p><h3>\nDisabled</h3><p>In order to change the color when a disabled checkbox is checked:</p><p><img \nsrc="https://cloud.githubusercontent.com/assets/1292882/8036177/dc941a86-0dfe-11e5-8892-ac19ec6926fe.PNG" \nalt="checkboxdisabledred"><br></p><hljs lang="html"><md-checkbox ng-disabled="true" class="red" ng-model="data.cb4" \nng-init="data.cb4=true">Checkbox: Disabled, Checked</md-checkbox></hljs><hljs lang="css">\nmd-checkbox.md-checked[disabled].red .md-icon { background-color: rgba(255, 0, 0, 0.26); }</hljs><p><br></p><h3>Borders\n</h3><p>In order to add a custom border do the following:</p><img \nsrc="https://cloud.githubusercontent.com/assets/1292882/8037214/388dd40c-0e05-11e5-82a7-4bfa2541e968.PNG" \nalt="checkboxcustomborder"><br><br><hljs lang="html"><div><md-checkbox ng-model="data.cb2" aria-label="Checkbox 2" \nng-true-value="\'yup\'" ng-false-value="\'nope\'">Default Border</md-checkbox></div><div><md-checkbox ng-model="data.cb2" \naria-label="Checkbox 2" ng-true-value="\'yup\'" class="dotted" ng-false-value="\'nope\'">Custom Border</md-checkbox></div>\n</hljs><hljs lang="css">md-checkbox.dotted .md-icon { border-width: 1px; border-style: dashed; }</hljs><br><h3>Bi-Di\n</h3><p>The mdCheckbox directive supports bi-directional specifiers in the <code>&lt;html dir=&quot;rtl&quot;&gt;\n</code> tag:</p><p><img \nsrc="https://cloud.githubusercontent.com/assets/1292882/8036091/fb40bcf6-0dfd-11e5-8319-25e68939d1a3.PNG" \nalt="checkboxrtl"></p></div>');
$templateCache.put('app/main/components/material-docs/partials/CSS/typography.html','<div class="doc-content theming"><p>\nAngular Material provides typography CSS classes you can use to create visual consistency across your application.</p>\n<p><a href="http://www.google.com/design/spec/style/typography.html">\nReference the Material Design specification for Typography.</a></p><section class="demo-container"><md-toolbar \nclass="demo-toolbar"><div class="md-toolbar-tools"><h3>General Typography</h3></div></md-toolbar><div \nclass="md-whiteframe-z1 docs-list"><p>Angular Material is always using the <a \nhref="https://www.google.com/fonts#UsePlace:use/Collection:Roboto">Roboto</a> font for its components.</p><p>The <code>\nRoboto</code> font will be <b>not</b>\n automatically loaded by Angular Material itself. The developer is responsible for loading all fonts used in their application. Shown below is a sample \n<i>link</i> markup used to load the <code>Roboto</code> font from a CDN.</p><hljs lang="html"><link rel="stylesheet" \nhref="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,400italic"></hljs><p></p><h4 class="md-title">\nNotes</h4>When <code>Roboto</code> isn&#39;t loaded, then the typography will fallback to the following fonts:<p>- \n<code>Helvetica Neue</code><br>- <code>sans-serif</code></p><p></p></div></section><section class="demo-container">\n<md-toolbar class="demo-toolbar"><div class="md-toolbar-tools"><h3>Heading Styles</h3></div></md-toolbar><div \nclass="md-whiteframe-z1 docs-list"><p style="margin-top: 0;">To preserve <a \nhref="http://webaim.org/techniques/semanticstructure/">semantic structures</a>, you should style the <code>&lt;h1&gt;\n</code> - <code>&lt;h6&gt;</code> heading tags with the styling classes shown below:</p><div layout="row" \nclass="docs-descriptions"><h4 class="md-body-1" flex="25" id="headings-selectors">Selectors</h4><h4 class="md-body-1" \nid="headings-output">Output</h4></div><md-divider></md-divider><ul><li layout="column" layout-gt-md="row" \nlayout-align="start center"><span flex="25" class="docs-definition" aria-describedby="headings-selectors"><code>\n.md-display-4</code></span><h5 aria-describedby="headings-output" class="md-display-4 docs-output">Light 112px</h5>\n</li><li layout="row" layout-align="start center"><span flex="25" class="docs-definition" \naria-describedby="headings-selectors"><code>.md-display-3</code></span><h5 aria-describedby="headings-output" \nclass="md-display-3 docs-output">Regular 56px</h5></li><li layout="row" layout-align="start center"><span flex="25" \nclass="docs-definition" aria-describedby="headings-selectors"><code>.md-display-2</code></span><h5 \naria-describedby="headings-output" class="md-display-2 docs-output">Regular 45px</h5></li><li layout="row" \nlayout-align="start center"><span flex="25" class="docs-definition" aria-describedby="headings-selectors"><code>\n.md-display-1</code></span><h5 aria-describedby="headings-output" class="md-display-1 docs-output">Regular 34px</h5>\n</li><li layout="row" layout-align="start center"><span flex="25" class="docs-definition" \naria-describedby="headings-selectors"><code>.md-headline</code></span><h5 aria-describedby="headings-output" \nclass="md-headline docs-output">Regular 24px</h5></li><li layout="row" layout-align="start center"><span flex="25" \nclass="docs-definition" aria-describedby="headings-selectors"><code>.md-title</code></span><h5 \naria-describedby="headings-output" class="md-title docs-output">Medium 20px</h5></li><li layout="row" \nlayout-align="start center"><span flex="25" class="docs-definition" aria-describedby="headings-selectors"><code>\n.md-subhead</code></span><h5 aria-describedby="headings-output" class="md-subhead docs-output">Regular 16px</h5></li>\n</ul><h4 class="md-title">Example</h4><hljs lang="html"><h1 class="md-display-3">Headline</h1><h2 class="md-display-1">\nHeadline</h2><h3 class="md-headline">Headline</h3></hljs><br><span class="md-body-1">Note: Base font size is <code>10px\n</code> for easy rem units (1.2rem = 12px). Body font size is <code>14px</code>. sp = scalable pixels.</span></div>\n</section><section class="demo-container"><md-toolbar class="demo-toolbar"><div class="md-toolbar-tools"><h3>Body Copy\n</h3></div></md-toolbar><div class="md-whiteframe-z1 docs-list"><div layout="row" class="docs-descriptions"><h4 \nclass="md-body-1" flex="25" id="body-selectors">Selectors</h4><h4 class="md-body-1" id="body-output">Output</h4></div>\n<md-divider></md-divider><ul><li layout="row" layout-align="start center"><span flex="25" class="docs-definition" \naria-describedby="body-selectors"><code>.md-body-1</code><br></span><p class="docs-output md-body-1" \naria-describedby="body-output">Regular 14px</p></li><li layout="row" layout-align="start center"><span flex="25" \nclass="docs-definition" aria-describedby="body-selectors"><code>.md-body-2</code></span><p \nclass="md-body-2 docs-output" aria-describedby="body-output">Medium 14px</p></li><li layout="row" \nlayout-align="start center"><span flex="25" class="docs-definition" aria-describedby="body-selectors"><code>.md-button\n</code></span><div class="docs-output" aria-describedby="body-output"><md-button class="md-raised" \nstyle="margin-left:0; margin-right:0;">Medium 14px</md-button></div></li><li layout="row" layout-align="start center">\n<span flex="25" class="docs-definition" aria-describedby="body-selectors"><code>.md-caption</code><br></span><div \nclass="docs-output" aria-describedby="body-output"><small class="md-caption">Regular 12px</small></div></li></ul><h4 \nclass="md-title">Examples</h4><hljs lang="html"><p class="md-body-2">Body copy with medium weight.</p><md-button>Button\n</md-button><p class="md-body-1">Regular body copy <small class="md-caption">with small text</small>.</p><span \nclass="md-caption">Caption</span></hljs></div></section></div>');
$templateCache.put('app/main/components/material-docs/partials/Theming/01_introduction.html','<div class="doc-content theming"><p>\nMaterial Design is a visual language with specifications for innovative user experiences (UX) and user interface (UI) elements. Themes convey meaning through color, tones, and contrasts, similar to how Layouts convey meaning through keylines and alignments.\n</p><p>Theme <a href="http://www.google.com/design/spec/style/color.html#color-ui-color-palette"><strong>color palettes\n</strong></a>\n, alphas, and shadows deliver a consistent tone to your application and a unified feel for all Angular Material UI components.\n</p><p>\nTheming allows changing the color of your Angular Material application. If you need more custom styling (such as layout changes including padding, margins, etc) you will need to either write CSS rules with custom selectors, or build a custom version of the \n<code>angular-material.css</code> file using SASS and custom variables.</p><p><img \nsrc="https://cloud.githubusercontent.com/assets/210413/4816236/bf7783dc-5edd-11e4-88ef-1f8b6e87e1d7.png" \nalt="color palette" style="max-width: 100%;"></p><h2 id="theming-approach">Theming Approach</h2><p>\nAngular Material makes it easy to design an app which follows the Material style guide&#39;s suggested design patterns:\n</p><blockquote><p>\nLimit your selection of colors by choosing three color hues from the primary palette and one accent color from the secondary palette. The accent color may or may not need fallback options.\n</p></blockquote><p>This concept is central to how Angular Material approaches theming.</p><h2 id="important-terms">\nImportant Terms</h2><h3 id="hues-shades">Hues / Shades</h3><p>A hue/shade is a single color within a palette.</p><h3 \nid="palettes">Palettes</h3><p>\nA palette is a collection of hues. By default, Angular Material ships with all palettes from the material design spec built in. Valid palettes include:\n</p><ul><li>red</li><li>pink</li><li>purple</li><li>deep-purple</li><li>indigo</li><li>blue</li><li>light-blue</li><li>\ncyan</li><li>teal</li><li>green</li><li>light-green</li><li>lime</li><li>yellow</li><li>amber</li><li>orange</li><li>\ndeep-orange</li><li>brown</li><li>grey</li><li>blue-grey</li></ul><h3 id="color-intentions">Color Intentions</h3><p>\nA color intention is a mapping of a palette for a given intention within your application.</p><p>\nValid color intentions in Angular Material include:</p><ul><li><em>primary</em>\n - used to represent primary interface elements for a user</li><li><em>accent</em>\n - used to represent secondary interface elements for a user</li><li><em>warn</em>\n - used to represent interface elements that the user should be careful of</li></ul><h3 id="themes">Themes</h3><p>\nA theme is a configuration of palettes used for specific color intentions. A theme also specifies a background color palette to be used for the application.\n</p></div>');
$templateCache.put('app/main/components/material-docs/partials/Theming/02_declarative_syntax.html','<div class="doc-content theming"><p>\nTheming in angular material uses classes to apply an intention group to a given component. Most components in Angular Material support intention classes as expected, including:\n</p><ul><li>md-button</li><li>md-checkbox</li><li>md-progress-circular</li><li>md-progress-linear</li><li>\nmd-radio-button</li><li>md-slider</li><li>md-switch</li><li>md-tabs</li><li>md-input-container</li><li>md-toolbar</li>\n</ul><h3 id="specifying-intention-group">Specifying intention group</h3><p>\nThe classes to apply the color intention for a given component are as follows: <code>md-primary</code>, <code>md-accent\n</code>, <code>md-warn</code>.</p><hljs lang="html"><md-button class="md-primary">Click me</md-button><md-button \nclass="md-accent">or maybe me</md-button><md-button class="md-warn">Careful</md-button></hljs><h3 \nid="differentiating-within-an-intention-group-">Differentiating within an intention group.</h3><p>\nIf you need to slightly differentiate an element, you can specify an additional class of <code>md-hue-1</code>, <code>\nmd-hue-2</code>, or <code>md-hue-3</code>. Use these classes sparingly in your application to avoid overwhelming users.\n</p><hljs lang="html"><md-button class="md-primary">Click me</md-button><md-button class="md-primary md-hue-1">Click me\n</md-button><md-button class="md-primary md-hue-2">Click me</md-button></hljs></div>');
$templateCache.put('app/main/components/material-docs/partials/Theming/03_configuring_a_theme.html','<div class="doc-content theming"><h2 id="configuring-a-theme">Configuring a theme</h2><p>\nBy default your Angular Material application will use the default theme, a theme that is pre-configured with the following palettes for intention groups:\n</p><ul><li><em>primary</em> - indigo</li><li><em>accent</em> - pink</li><li><em>warn</em> - red</li><li><em>background\n</em> - grey (note that white is in this palette)</li></ul><p>Configuring of the default theme is done by using the \n<code>$mdThemingProvider</code> during application configuration.</p><h3 id="configuring-color-intentions">\nConfiguring Color Intentions</h3><p>\nYou can specify a color palette for a given color intention by calling the appropriate configuration method (<code>\ntheme.primaryPalette</code>, <code>theme.accentPalette</code>, <code>theme.warnPalette</code>, <code>\ntheme.backgroundPalette</code>).</p><hljs lang="js">\nangular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { $mdThemingProvider.theme(&#39;default&#39;) .primaryPalette(&#39;pink&#39;) .accentPalette(&#39;orange&#39;); });\n</hljs><h3 id="specifying-dark-themes">Specifying Dark Themes</h3><p>You can mark a theme as dark by calling <code>\ntheme.dark()</code>.</p><hljs lang="js">\nangular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { $mdThemingProvider.theme(&#39;default&#39;) .dark(); });\n</hljs><h3 id="specifying-custom-hues-for-color-intentions">Specifying Custom Hues For Color Intentions</h3><p>\nYou can specify the hues from a palette that will be used by an intention group by default and for the <code>md-hue-1\n</code>, <code>md-hue-2</code>, <code>md-hue-3</code> classes.</p><p>By default, shades <code>500</code>, <code>300\n</code> <code>800</code> and <code>A100</code> are used for <code>primary</code> and <code>warn</code>\n intentions, while <code>A200</code>, <code>A100</code>, <code>A400</code> and <code>A700</code> are used for <code>\naccent</code>.</p><hljs lang="js">\nangular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { $mdThemingProvider.theme(&#39;default&#39;) .primaryPalette(&#39;pink&#39;, { &#39;default&#39;: &#39;400&#39;, // by default use shade 400 from the pink palette for primary intentions &#39;hue-1&#39;: &#39;100&#39;, // use shade 100 for the \n<code>md-hue-1</code> class &#39;hue-2&#39;: &#39;600&#39;, // use shade 600 for the <code>md-hue-2</code>\n class &#39;hue-3&#39;: &#39;A100&#39; // use shade A100 for the <code>md-hue-3</code>\n class }) // If you specify less than all of the keys, it will inherit from the // default shades .accentPalette(&#39;purple&#39;, { &#39;default&#39;: &#39;200&#39; // use shade 200 for default, and keep all other shades the same }); });\n</hljs><h3 id="defining-custom-palettes">Defining Custom Palettes</h3><p>\nAs mentioned before, Angular Material ships with the Material Design Spec&#39;s color palettes built in. In the event that you need to define a custom color palette, you can use \n<code>$mdThemingProvider</code>\n to define it, thereby making it available to your theme for use in its intention groups. Note that you must specify all hues in the definition map.\n</p><hljs lang="js">\nangular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { $mdThemingProvider.definePalette(&#39;amazingPaletteName&#39;, { &#39;50&#39;: &#39;ffebee&#39;, &#39;100&#39;: &#39;ffcdd2&#39;, &#39;200&#39;: &#39;ef9a9a&#39;, &#39;300&#39;: &#39;e57373&#39;, &#39;400&#39;: &#39;ef5350&#39;, &#39;500&#39;: &#39;f44336&#39;, &#39;600&#39;: &#39;e53935&#39;, &#39;700&#39;: &#39;d32f2f&#39;, &#39;800&#39;: &#39;c62828&#39;, &#39;900&#39;: &#39;b71c1c&#39;, &#39;A100&#39;: &#39;ff8a80&#39;, &#39;A200&#39;: &#39;ff5252&#39;, &#39;A400&#39;: &#39;ff1744&#39;, &#39;A700&#39;: &#39;d50000&#39;, &#39;contrastDefaultColor&#39;: &#39;light&#39;, // whether, by default, text (contrast) // on this palette should be dark or light &#39;contrastDarkColors&#39;: [&#39;50&#39;, &#39;100&#39;, //hues which contrast should be &#39;dark&#39; by default &#39;200&#39;, &#39;300&#39;, &#39;400&#39;, &#39;A100&#39;], &#39;contrastLightColors&#39;: undefined // could also specify this if default was &#39;dark&#39; }); $mdThemingProvider.theme(&#39;default&#39;) .primaryPalette(&#39;amazingPaletteName&#39;) });\n</hljs><h3 id="extending-existing-palettes">Extending Existing Palettes</h3><p>\nSometimes it is easier to extend an existing color palette to change a few properties than to define a whole new palette. You can use \n<code>$mdThemingProvider.extendPalette</code> to quickly extend an existing color palette.</p><hljs lang="js">\nangular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { // Extend the red theme with a different color and make the contrast color black instead of white. // For example: raised button text will be black instead of white. var neonRedMap = $mdThemingProvider.extendPalette(&#39;red&#39;, { &#39;500&#39;: &#39;#ff0000&#39;, &#39;contrastDefaultColor&#39;: &#39;dark&#39; }); // Register the new color palette map with the name \n<code>neonRed</code>\n $mdThemingProvider.definePalette(&#39;neonRed&#39;, neonRedMap); // Use that theme for the primary intentions $mdThemingProvider.theme(&#39;default&#39;) .primaryPalette(&#39;neonRed&#39;); });\n</hljs></div>');
$templateCache.put('app/main/components/material-docs/partials/Theming/04_multiple_themes.html','<div class="doc-content theming"><p>In most applications, declaring multiple themes is <strong>not</strong>\n necessary. Instead, you should configure the <code>default</code>\n theme for your needs. If you need multiple themes in a single application, Angular Material does provide tools to make this possible.\n</p><h3 id="registering-another-theme">Registering another theme</h3><p>Use the <code>$mdThemingProvider</code>\n to register a second theme within your application. By default all themes will inherit from the <code>default</code>\n theme. Once you have registered the second theme, you can configure it with the same chainable interface used on the default theme.\n</p><hljs lang="js">\nangular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { $mdThemingProvider.theme(&#39;altTheme&#39;) .primaryPalette(&#39;purple&#39;) // specify primary color, all // other color intentions will be inherited // from default });\n</hljs><h3 id="using-another-theme">Using another theme</h3><h4 id="via-the-provider">Via the Provider</h4><p>\nYou can change the default theme to be used across your entire application using the provider:</p><hljs lang="js">\n$mdThemingProvider.setDefaultTheme(&#39;altTheme&#39;);</hljs><h4 id="via-a-directive">Via a Directive</h4><p>\nAngular Material also exposes the <code>md-theme</code>\n directive which will set the theme on an element and all child elements.</p><p>\nIn the following example, the application will use the <code>default</code> theme, while the second child <code>div\n</code> will use the <code>altTheme</code>. This allows you to theme different parts of your application differently.\n</p><hljs lang="html"><div><md-button class="md-primary">I will be blue (by default)</md-button><div \nmd-theme="altTheme"><md-button class="md-primary">I will be purple (altTheme)</md-button></div></div></hljs><h4 \nid="dynamic-themes">Dynamic Themes</h4><p>By default, to save on performance, theming directives will <strong>not\n</strong> watch <code>md-theme</code>\n for changes. If you need themes to be dynamically modified, you will need to use the <code>md-theme-watch</code>\n directive.</p><hljs lang="html"><div><md-button ng-click="dynamicTheme = \'default\'">Default</md-button><md-button \nng-click="dynamicTheme = \'altTheme\'">altTheme</md-button><div md-theme="{{ dynamicTheme }}" md-theme-watch><md-button \nclass="md-primary">I&#39;m dynamic</md-button></div></div></hljs><p>\nIf you need this behavior in your entire application (ie. on all <code>md-theme</code> directives) you can use the \n<code>$mdThemingProvider</code> to enable it.</p><hljs lang="js">$mdThemingProvider.alwaysWatchTheme(true);</hljs>\n</div>');
$templateCache.put('app/main/components/material-docs/partials/Theming/05_under_the_hood.html','<div class="doc-content theming"><h3 id="under-the-hood">Under the Hood</h3><p>\nAngular Material dynamically generates CSS for registered themes by injecting several <code>&lt;script&gt;</code>\n tags into the <code>&lt;head&gt;</code>\n section of the application at runtime. Here is how that process currently works:</p><ol><li><p>\nDuring the Angular Material build process, a function in <code>gulp/util.js</code> called <a \nhref="https://github.com/angular/material/blob/master/gulp/util.js#L187">themeBuildStream()</a> compiles all <code>\n*-theme.scss</code> files from components into a single CSS string that is injected into the <code>material.core</code>\n module as a constant called <code>$MD_THEME_CSS</code>.</p></li><li><p>At runtime, a function in <code>\nsrc/core/services/theming/theming.js</code> called <a \nhref="https://github.com/angular/material/blob/master/src/core/services/theming/theming.js#L450">generateThemes()</a>\n parses <code>$MD_THEME_CSS</code> to generate the <code>&lt;style&gt;</code> tags that are added to the <code>\n&lt;head&gt;</code> section of the application. A closure variable called <code>GENERATED</code>\n is used to keep track of the themes that have had their CSS generated.</p></li><li><p>\nFor each of the four (4) palettes (e.g. <code>primary</code>, <code>accent</code>, <code>warn</code> and <code>\nbackground</code>) <em>in each registered theme</em> (including the default theme), there are four (4) <code>\n&lt;style&gt;</code> tags added to the <code>&lt;head&gt;</code> section (e.g. <code>.md-primary</code>, <code>\n.md-primary.md-hue-1</code>, <code>.md-primary.md-hue-2</code>, <code>.md-primary.md-hue-3</code>\n). Each registered theme results in 16 <code>&lt;style&gt;</code> tags being generated.</p></li></ol></div>');
$templateCache.put('app/main/pages/invoice/views/compact/compact.html','<div id="invoice" class="compact page-layout blank" layout="row" ms-scroll><div class="invoice-container"><div \nclass="card md-whiteframe-8dp"><div class="header"><div class="invoice-date">{{vm.invoice.date}}</div><div \nlayout="row" layout-align="space-between stretch"><div class="client"><div class="invoice-number" layout="row" \nlayout-align="start center"><span class="title" translate="INVOICE.INVOICE">INVOICE</span> <span class="number">\n{{vm.invoice.number}}</span></div><div class="due-date" layout="row" layout-align="start center"><span class="title" \ntranslate="INVOICE.DUE_DATE">DUE DATE</span> <span class="date">{{vm.invoice.dueDate}}</span></div><div class="info">\n<div class="title">{{vm.invoice.client.title}}</div><div ng-if="vm.invoice.client.address" class="address">\n{{vm.invoice.client.address}}</div><div ng-if="vm.invoice.client.phone" class="phone">{{vm.invoice.client.phone}}</div>\n<div ng-if="vm.invoice.client.email" class="email">{{vm.invoice.client.email}}</div><div \nng-if="vm.invoice.client.website" class="website">{{vm.invoice.client.website}}</div></div></div><div \nclass="issuer md-accent-bg" layout="row" layout-align="start center"><div class="logo" layout="row" \nlayout-align="center center"><span>F</span></div><div class="info"><div class="title">{{vm.invoice.from.title}}</div>\n<div ng-if="vm.invoice.from.address" class="address">{{vm.invoice.from.address}}</div><div \nng-if="vm.invoice.from.phone" class="phone">{{vm.invoice.from.phone}}</div><div ng-if="vm.invoice.from.email" \nclass="email">{{vm.invoice.from.email}}</div><div ng-if="vm.invoice.from.website" class="website">\n{{vm.invoice.from.website}}</div></div></div></div></div><div class="content"><table class="simple invoice-table">\n<thead><th translate="INVOICE.SERVICE">SERVICE</th><th translate="INVOICE.UNIT">UNIT</th><th class="text-right" \ntranslate="INVOICE.UNIT_PRICE">UNIT PRICE</th><th class="text-right" translate="INVOICE.QUANTITY">QUANTITY</th><th \nclass="text-right" translate="INVOICE.TOTAL">TOTAL</th></thead><tbody><tr ng-repeat="service in vm.invoice.services">\n<td><div class="title">{{service.title}}</div></td><td>{{service.unit}}</td><td class="text-right">\n{{service.unitPrice | currency}}</td><td class="text-right">{{service.quantity}}</td><td class="text-right">\n{{service.total | currency}}</td></tr><tr ng-repeat="service in vm.invoice.services"><td><div class="title">\n{{service.title}}</div></td><td>{{service.unit}}</td><td class="text-right">{{service.unitPrice | currency}}</td><td \nclass="text-right">{{service.quantity}}</td><td class="text-right">{{service.total | currency}}</td></tr></tbody>\n</table><table class="simple invoice-table-footer"><tbody><tr class="subtotal"><td translate="INVOICE.SUBTOTAL">\nSUBTOTAL</td><td>{{vm.invoice.subtotal | currency}}</td></tr><tr class="tax"><td translate="INVOICE.TAX">TAX</td><td>\n{{vm.invoice.tax | currency}}</td></tr><tr class="discount"><td translate="INVOICE.DISCOUNT">DISCOUNT</td><td>\n-{{vm.invoice.discount | currency}}</td></tr><tr class="total"><td translate="INVOICE.TOTAL">TOTAL</td><td>\n{{vm.invoice.total | currency}}</td></tr></tbody></table></div><div class="footer"><div class="note" \ntranslate="INVOICE.NOTE">Please pay within 15 days. Thank you for your business.</div><div layout="row" \nlayout-align="start start"><div class="logo md-accent-bg" layout="row" layout-align="center center"><div>F</div></div>\n<div class="small-note" translate="INVOICE.SMALL_NOTE">\nIn condimentum malesuada efficitur. Mauris volutpat placerat auctor. Ut ac congue dolor. Quisque scelerisque lacus sed feugiat fermentum. Cras aliquet facilisis pellentesque. Nunc hendrerit quam at leo commodo, a suscipit tellus dapibus. Etiam at felis volutpat est mollis lacinia. Mauris placerat sem sit amet velit mollis, in porttitor ex finibus. Proin eu nibh id libero tincidunt lacinia et eget eros.\n</div></div></div></div><div class="page-break"></div></div></div>');
$templateCache.put('app/main/pages/invoice/views/modern/modern.html','<div id="invoice" class="modern page-layout blank" layout="row" ms-scroll><div class="invoice-container"><div \nclass="card md-whiteframe-8dp"><div class="header" layout="row" layout-align="space-between start"><div class="ids" \nlayout="column"><div layout="row" class="seller" layout-align="start center"><div class="logo md-accent-bg" \nlayout="row" layout-align="center center"><div>F</div></div><div class="divider"></div><div class="detail"><div \nclass="title">{{vm.invoice.from.title}}</div><div ng-if="vm.invoice.from.address" class="address">\n{{vm.invoice.from.address}}</div><div ng-if="vm.invoice.from.phone" class="phone"><span translate="INVOICE.PHONE">Phone\n</span>: {{vm.invoice.from.phone}}</div><div ng-if="vm.invoice.from.email" class="email"><span \ntranslate="INVOICE.EMAIL">Email</span>: {{vm.invoice.from.email}}</div><div ng-if="vm.invoice.from.website" \nclass="website"><span translate="INVOICE.WEB">Web</span>: {{vm.invoice.from.website}}</div></div></div><div \nlayout="row" class="client" layout-align="start center"><div class="label" layout="row" layout-align="end center"><div \ntranslate="INVOICE.CLIENT">CLIENT</div></div><div class="divider"></div><div class="detail"><div class="title">\n{{vm.invoice.client.title}}</div><div ng-if="vm.invoice.client.address" class="address">{{vm.invoice.client.address}}\n</div><div ng-if="vm.invoice.client.phone" class="phone"><span translate="INVOICE.PHONE">Phone</span>\n: {{vm.invoice.client.phone}}</div><div ng-if="vm.invoice.client.email" class="email"><span translate="INVOICE.EMAIL">\nEmail</span>: {{vm.invoice.client.email}}</div><div ng-if="vm.invoice.client.website" class="website"><span \ntranslate="INVOICE.WEB">Web</span>: {{vm.invoice.client.website}}</div></div></div></div><table class="summary"><tr \nclass="code"><td class="label" translate="INVOICE.INVOICE">INVOICE</td><td class="value">{{vm.invoice.number}}</td>\n</tr><tr><td class="label" translate="INVOICE.INVOICE_DATE">INVOICE DATE</td><td class="value">{{vm.invoice.date}}</td>\n</tr><tr><td class="label" translate="INVOICE.DUE_DATE">DUE DATE</td><td class="value">{{vm.invoice.dueDate}}</td></tr>\n<tr><td class="label" translate="INVOICE.TOTAL_DUE">TOTAL DUE</td><td class="value">{{vm.invoice.total | currency}}\n</td></tr></table></div><div class="content"><table class="simple invoice-table"><thead><th \ntranslate="INVOICE.SERVICE">SERVICE</th><th translate="INVOICE.UNIT">UNIT</th><th class="text-right" \ntranslate="INVOICE.UNIT_PRICE">UNIT PRICE</th><th class="text-right" translate="INVOICE.QUANTITY">QUANTITY</th><th \nclass="text-right" translate="INVOICE.TOTAL">TOTAL</th></thead><tbody><tr ng-repeat="service in vm.invoice.services">\n<td><div class="title">{{service.title}}</div><div class="detail">{{service.detail}}</div></td><td>{{service.unit}}\n</td><td class="text-right">{{service.unitPrice | currency}}</td><td class="text-right">{{service.quantity}}</td><td \nclass="text-right">{{service.total | currency}}</td></tr></tbody></table><table class="simple invoice-table-footer">\n<tbody><tr class="subtotal"><td translate="INVOICE.SUBTOTAL">SUBTOTAL</td><td>{{vm.invoice.subtotal | currency}}</td>\n</tr><tr class="tax"><td translate="INVOICE.TAX">TAX</td><td>{{vm.invoice.tax | currency}}</td></tr><tr \nclass="discount"><td translate="INVOICE.DISCOUNT">DISCOUNT</td><td>-{{vm.invoice.discount | currency}}</td></tr><tr \nclass="total"><td translate="INVOICE.TOTAL">TOTAL</td><td>{{vm.invoice.total | currency}}</td></tr></tbody></table>\n</div><div class="footer"><div class="note" translate="INVOICE.NOTE">\nPlease pay within 15 days. Thank you for your business.</div><div layout="row" layout-align="start start"><div \nclass="logo md-accent-bg" layout="row" layout-align="center center"><div>F</div></div><div class="small-note" \ntranslate="INVOICE.SMALL_NOTE">\nIn condimentum malesuada efficitur. Mauris volutpat placerat auctor. Ut ac congue dolor. Quisque scelerisque lacus sed feugiat fermentum. Cras aliquet facilisis pellentesque. Nunc hendrerit quam at leo commodo, a suscipit tellus dapibus. Etiam at felis volutpat est mollis lacinia. Mauris placerat sem sit amet velit mollis, in porttitor ex finibus. Proin eu nibh id libero tincidunt lacinia et eget eros.\n</div></div></div></div><div class="page-break"></div></div></div>');
$templateCache.put('app/main/pages/profile/tabs/about/about.html','<div layout="row" layout-wrap><div class="about" layout="column" flex="100" flex-gt-sm="50" flex-gt-md="65"><div \nclass="profile-box info-box general md-whiteframe-1dp" layout="column"><header class="md-accent-bg"><div class="title" \ntranslate="PROFILE.GENERAL_INFORMATION">General Information</div></header><div class="content"><div class="info-line">\n<div class="title" translate="PROFILE.GENDER">Gender</div><div class="info">{{vm.about.general.gender}}</div></div><div\n class="info-line"><div class="title" translate="PROFILE.BIRTHDAY">Birthday</div><div class="info">\n{{vm.about.general.birthday}}</div></div><div class="info-line"><div class="title" translate="PROFILE.LOCATIONS">\nLocations</div><div class="info location" ng-repeat="location in vm.about.general.locations"><span>{{location}}</span>\n<md-icon md-font-icon="icon-map-marker" class="s16"></md-icon></div></div><div class="info-line"><div class="title" \ntranslate="PROFILE.ABOUT_ME">About Me</div><div class="info">{{vm.about.general.about}}</div></div></div></div><div \nclass="profile-box info-box work md-whiteframe-1dp" layout="column"><header class="md-accent-bg"><div class="title" \ntranslate="PROFILE.WORK">Work</div></header><div class="content"><div class="info-line"><div class="title" \ntranslate="PROFILE.OCCUPATION">Occupation</div><div class="info">{{vm.about.work.occupation}}</div></div><div \nclass="info-line"><div class="title" translate="PROFILE.SKILLS">Skills</div><div class="info">{{vm.about.work.skills}}\n</div></div><div class="info-line"><div class="title" translate="PROFILE.JOBS">Jobs</div><table class="info jobs"><tr \nclass="job" ng-repeat="job in vm.about.work.jobs"><td class="company">{{job.company}}</td><td class="date">{{job.date}}\n</td></tr></table></div></div></div><div class="profile-box info-box contact md-whiteframe-1dp" layout="column"><header\n class="md-accent-bg"><div class="title" translate="PROFILE.CONTACT">Contact</div></header><div class="content"><div \nclass="info-line"><div class="title" translate="PROFILE.ADDRESS">Address</div><div class="info">\n{{vm.about.contact.address}}</div></div><div class="info-line"><div class="title" translate="PROFILE.TEL">Tel.</div>\n<div class="info" ng-repeat="tel in vm.about.contact.tel"><span>{{tel}}</span></div></div><div class="info-line"><div \nclass="title" translate="PROFILE.WEBSITE">Website</div><div class="info" \nng-repeat="website in vm.about.contact.websites"><span>{{website}}</span></div></div><div class="info-line"><div \nclass="title" translate="PROFILE.EMAILS">Emails</div><div class="info" ng-repeat="email in vm.about.contact.emails">\n<span>{{email}}</span></div></div></div></div></div><div class="about-sidebar" layout="column" flex="100" \nflex-gt-sm="50" flex-gt-md="35"><div class="profile-box friends md-whiteframe-1dp" layout="column"><header \nclass="md-accent-bg" layout="row" layout-align="space-between center"><div class="title" translate="PROFILE.FRIENDS">\nFriends</div><div class="more secondary-text"><span translate="PROFILE.SEE">See</span> <span>454</span> <span \ntranslate="PROFILE.MORE">More</span></div></header><div class="content" layout="row" layout-wrap><div class="friend" \nflex="20" ng-repeat="friend in vm.about.friends"><img ng-src="{{friend.avatar}}"></div></div></div><div \nclass="profile-box groups md-whiteframe-1dp" layout="column"><header class="md-accent-bg" layout="row" \nlayout-align="space-between center"><div class="title" translate="PROFILE.JOINED_GROUPS">Joined Groups</div><div \nclass="more secondary-text"><span translate="PROFILE.SEE">See</span> <span>6</span> <span translate="PROFILE.MORE">More\n</span></div></header><div class="content"><div class="group" ng-repeat="group in vm.about.groups" layout="row" \nlayout-align="space-between center"><div layout="row" layout-align="start center"><img ng-src="{{group.logo}}" \nclass="logo" alt="{{group.name}}"><div><div class="name">{{group.name}}</div><div class="category">{{group.category}}\n</div><div class="members">{{group.members}} people</div></div></div><md-button class="md-icon-button" \naria-label="more" translate translate-attr-aria-label="PROFILE.MORE"><md-icon md-font-icon="icon-dots-vertical">\n</md-icon></md-button></div></div></div></div></div>');
$templateCache.put('app/main/pages/profile/tabs/photos-videos/photos-videos.html','<div class="photos-videos"><div class="period" data-ng-repeat="period in vm.photosVideos"><div class="period-title">\n<span class="name">{{period.name}}</span> <span class="info">{{period.info}}</span></div><div class="period-media" \nlayout="row" layout-wrap><div class="media" ng-repeat="media in period.media"><img class="preview" \nng-src="{{media.preview}}" title="{{media.title}}"><div class="title">{{media.title}}</div></div></div></div></div>');
$templateCache.put('app/main/pages/profile/tabs/timeline/timeline.html','<div layout="row" layout-wrap><div class="timeline" layout="column" flex="100" flex-gt-sm="55" flex-gt-md="65" \nflex-order="2" flex-order-gt-sm="1"><div class="profile-box add-post md-whiteframe-1dp"><div class="form" flex>\n<textarea placeholder="Write something.." translate translate-attr-placeholder="PROFILE.WRITE_SOMETHING"></textarea>\n<footer layout="row" layout-align="space-between center"><div layout="row" layout-align="start center"><md-button \nclass="md-icon-button" aria-label="insert photo" translate translate-attr-aria-label="PROFILE.INSERT_PHOTO"><md-icon \nmd-font-icon="icon-file-image-box"></md-icon><md-tooltip><span translate="PROFILE.INSERT_PHOTO">insert photo</span>\n</md-tooltip></md-button><md-button class="md-icon-button" aria-label="add person" translate \ntranslate-attr-aria-label="PROFILE.ADD_PERSON"><md-icon md-font-icon="icon-person-plus"></md-icon><md-tooltip><span \ntranslate="PROFILE.ADD_PERSON">add person</span></md-tooltip></md-button><md-button class="md-icon-button" \naria-label="add location" translate translate-attr-aria-label="PROFILE.LOCATION"><md-icon \nmd-font-icon="icon-map-marker"></md-icon><md-tooltip><span translate="PROFILE.LOCATION">add location</span>\n</md-tooltip></md-button></div><md-button ng-click="" class="post-button md-accent md-raised" aria-label="POST" \ntranslate="PROFILE.POST" translate-attr-aria-label="PROFILE.POST">POST</md-button></footer></div></div><md-divider>\n</md-divider><div class="timeline-item md-whiteframe-1dp" ng-repeat="post in vm.posts"><header layout="row" \nlayout-align="space-between start"><div class="user" layout="row" layout-align="start center"><img class="avatar" \nng-src="{{post.user.avatar}}"><div layout="column"><div class="title"><span class="username md-accent-color">\n{{post.user.name}}</span> <span ng-if="post.type == \'post\'" translate="PROFILE.TYPE_POST">posted on your timeline\n</span> <span ng-if="post.type == \'something\'" translate="PROFILE.TYPE_SOMETHING">shared something with you</span> \n<span ng-if="post.type == \'video\'" translate="PROFILE.TYPE_VIDEO">shared a video with you</span> <span \nng-if="post.type == \'article\'" translate="PROFILE.TYPE_ARTICLE">shared an article with you</span></div><div \nclass="time">{{post.time}}</div></div></div><md-button class="md-icon-button" aria-label="more" translate \ntranslate-attr-aria-label="PROFILE.MORE"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button></header><div\n class="content"><div ng-if="post.message" class="message">{{post.message}}</div><div ng-if="post.media" class="media">\n<img ng-if="post.media.type === \'image\'" ng-src="{{post.media.preview}}"><div ng-if="post.media.type === \'video\'" \nng-bind-html="post.media.embed | toTrusted"></div></div><div ng-if="post.article" layout="column" class="article"><div \nclass="media"><img ng-src="{{post.article.media.preview}}"></div><div class="title">{{post.article.title}}</div><div \nclass="subtitle">{{post.article.subtitle}}</div><div class="excerpt">{{post.article.excerpt}}</div></div><div \nlayout="row" layout-align="start center"><md-button class="like-button"><div layout="row" layout-align="start center">\n<md-icon md-font-icon="icon-heart-outline" class="s16"></md-icon><span translate="PROFILE.LIKE">Like</span>&nbsp;<span>\n({{post.like}})</span></div></md-button><md-button class="share-button"><div layout="row" layout-align="start center">\n<md-icon md-font-icon="icon-share" class="s16"></md-icon><span translate="PROFILE.SHARE">Share</span>&nbsp;<span>\n({{post.share}})</span></div></md-button></div></div><footer class="" layout="column" layout-align="start start"><div \nng-if="post.comments" class="comment-count">{{post.comments.length}} comments<md-icon \nmd-font-icon="icon-keyboard_arrow_down"></md-icon></div><div class="comment" layout="row" layout-fill \nng-repeat="comment in post.comments"><img ng-src="{{comment.user.avatar}}" class="avatar"><div flex layout="column">\n<div layout="row" layout-align="start center"><span class="username">{{comment.user.name}}</span> <span class="time">\n{{comment.time}}</span></div><div class="message">{{comment.message}}</div><div class="actions" layout="row" \nlayout-align="space-between center"><a href="#" class="reply-button md-accent-color" translate="PROFILE.REPLY">Reply\n</a><md-icon flex md-font-icon="icon-flag" class="report-button s16"></md-icon></div></div></div><div class="reply" \nlayout="row" layout-fill><img src="assets/images/avatars/profile.jpg" class="avatar"><form flex><textarea \nplaceholder="Add a comment..." translate translate-attr-placeholder="PROFILE.ADD_COMMENT"></textarea><md-button \nng-click="" class="post-comment-button md-accent md-raised" aria-label="Post Comment" translate="PROFILE.POST_COMMENT" \ntranslate-aria-label="PROFILE.POST_COMMENT">Post Comment</md-button></form></div></footer></div></div><div \nclass="timeline-sidebar" layout="column" flex="100" flex-gt-sm="45" flex-gt-md="35" flex-order="1" \nflex-order-gt-sm="2"><div class="profile-box latest-activity md-whiteframe-1dp" layout="column"><header \nclass="md-accent-bg" layout="row" layout-align="space-between center"><div class="title" \ntranslate="PROFILE.LATEST_ACTIVITY">Latest Activity</div><div class="more secondary-text" translate="PROFILE.SEE_ALL">\nSee All</div></header><div class="content" layout="row" layout-wrap><div class="activities"><div class="activity" \nlayout="row" layout-align="start start" ng-repeat="activity in vm.activities"><img ng-src="{{activity.user.avatar}}" \nclass="avatar" alt="{{activity.user.name}}"><div layout="column"><div><span class="username md-accent-color">\n{{activity.user.name}}</span> <span class="message">{{activity.message}}</span></div><span class="time secondary-text">\n{{activity.time}}</span></div></div></div></div></div></div></div>');
$templateCache.put('app/main/pages/search/tabs/classic/classic.html','<div class="result-info" layout="row" layout-align="space-between center" layout-xs="column" \nlayout-align-xs="start start"><span class="result-count h3 secondary-text"><span>54</span> <span \ntranslate="SEARCH.RESULTS">Results</span></span><div class="pager"><span class="secondary-text"><span \ntranslate="SEARCH.RESULTS">Results</span> <span>:</span> </span><span class="page-info"><span>1</span> <span>-</span> \n<span>10</span> <span translate="SEARCH.OF">of</span> <span>100</span></span><md-button class="md-icon-button" \naria-label="previous page" translate translate-attr-aria-label="SEARCH.PREVIOUS_PAGE"><md-icon \nmd-font-icon="icon-chevron-left"></md-icon></md-button><md-button class="md-icon-button" aria-label="next page" \ntranslate translate-attr-aria-label="SEARCH.NEXT_PAGE"><md-icon md-font-icon="icon-chevron-right"></md-icon>\n</md-button></div></div><div class="results"><div class="result-item" ng-repeat="item in vm.classic"><div \nclass="title">{{item.title}}</div><div class="url">{{item.url}}</div><div class="excerpt">{{item.excerpt}}</div></div>\n</div><div class="simple-pagination"><md-button class="pagination-item disabled" md-no-ink ng-href="#" \naria-label="Go to previous page" translate translate-attr-aria-label="SEARCH.GO_TO_PREVIOUS"><md-icon \nmd-font-icon="icon-chevron-left"></md-icon></md-button><md-button class="pagination-item active" md-no-ink ng-href="#" \naria-label="Go to page 1"><span>1</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to page 2" hide-xs><span>2</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to page 3" hide-xs><span>3</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to page 4" hide-xs><span>4</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to page 5" hide-xs><span>5</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to page 6" hide-xs><span>6</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to page 7" hide-xs><span>7</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to page 8" hide-xs><span>8</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to page 9" hide-xs><span>9</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to page 10" hide-xs><span>10</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to next page" translate translate-attr-aria-label="SEARCH.GO_TO_NEXT"><md-icon \nmd-font-icon="icon-chevron-right"></md-icon></md-button></div>');
$templateCache.put('app/main/pages/search/tabs/contacts/contacts.html','<div class="result-info" layout="row" layout-align="space-between center" layout-xs="column" \nlayout-align-xs="start start"><div><span class="md-title" translate="SEARCH.CONTACTS">Contacts</span> <span \nclass="secondary-text"><span>13</span> <span translate="SEARCH.RESULTS">Results</span></span></div><div class="pager">\n<span class="secondary-text"><span translate="SEARCH.RESULTS">Results</span> <span>:</span> </span><span \nclass="page-info"><span>1</span> <span>-</span> <span>10</span> <span translate="SEARCH.OF">of</span> <span>100</span>\n</span><md-button class="md-icon-button" aria-label="previous page" translate \ntranslate-attr-aria-label="SEARCH.PREVIOUS_PAGE"><md-icon md-font-icon="icon-chevron-left"></md-icon></md-button>\n<md-button class="md-icon-button" aria-label="next page" translate translate-attr-aria-label="SEARCH.NEXT_PAGE">\n<md-icon md-font-icon="icon-chevron-right"></md-icon></md-button></div></div><table class="results simple clickable" \nms-responsive-table><thead><tr><th></th><th translate="SEARCH.NAME">Name</th><th translate="SEARCH.POSITION">Position\n</th><th translate="SEARCH.PHONE">Phone</th><th translate="SEARCH.EMAIL">Email</th></tr></thead><tbody><tr \nclass="result-item" ng-repeat="contact in vm.contacts"><td class="text-left avatar-cell" ng-if="contact.avatar"><img \nclass="avatar" alt="{{contact.name}}" ng-src="{{contact.avatar}}"></td><td class="text-left avatar-cell" \nng-if="!contact.avatar"><div class="avatar" ms-random-class="vm.colors">{{contact.name[0]}}</div></td><td class="name">\n{{contact.name}}</td><td class="position">{{contact.position}}</td><td class="phone">{{contact.phone}}</td><td \nclass="email">{{contact.email}}</td></tr></tbody></table><div class="simple-pagination"><md-button \nclass="pagination-item disabled" md-no-ink ng-href="#" aria-label="Go to previous page" translate \ntranslate-attr-aria-label="SEARCH.GO_TO_PREVIOUS"><md-icon md-font-icon="icon-chevron-left"></md-icon></md-button>\n<md-button class="pagination-item active" md-no-ink ng-href="#" aria-label="Go to page 1"><span>1</span></md-button>\n<md-button class="pagination-item" ng-href="#" aria-label="Go to page 2" hide-xs><span>2</span></md-button><md-button \nclass="pagination-item" ng-href="#" aria-label="Go to page 3" hide-xs><span>3</span></md-button><md-button \nclass="pagination-item" ng-href="#" aria-label="Go to page 4" hide-xs><span>4</span></md-button><md-button \nclass="pagination-item" ng-href="#" aria-label="Go to page 5" hide-xs><span>5</span></md-button><md-button \nclass="pagination-item" ng-href="#" aria-label="Go to page 6" hide-xs><span>6</span></md-button><md-button \nclass="pagination-item" ng-href="#" aria-label="Go to page 7" hide-xs><span>7</span></md-button><md-button \nclass="pagination-item" ng-href="#" aria-label="Go to page 8" hide-xs><span>8</span></md-button><md-button \nclass="pagination-item" ng-href="#" aria-label="Go to page 9" hide-xs><span>9</span></md-button><md-button \nclass="pagination-item" ng-href="#" aria-label="Go to page 10" hide-xs><span>10</span></md-button><md-button \nclass="pagination-item" ng-href="#" aria-label="Go to next page" translate \ntranslate-attr-aria-label="SEARCH.GO_TO_NEXT"><md-icon md-font-icon="icon-chevron-right"></md-icon></md-button></div>');
$templateCache.put('app/main/pages/search/tabs/emails/emails.html','<div class="result-info" layout="row" layout-align="space-between center" layout-xs="column" \nlayout-align-xs="start start"><div><span class="md-title" translate="SEARCH.EMAILS">E-Mails</span> <span \nclass="secondary-text"><span>87</span> <span translate="SEARCH.RESULTS">Results</span></span></div><div class="pager">\n<span class="secondary-text"><span translate="SEARCH.RESULTS">Results</span> <span>:</span> </span><span \nclass="page-info"><span>1</span> <span>-</span> <span>10</span> <span translate="SEARCH.OF">of</span> <span>100</span>\n</span><md-button class="md-icon-button" aria-label="previous page" translate \ntranslate-attr-aria-label="SEARCH.PREVIOUS_PAGE"><md-icon md-font-icon="icon-chevron-left"></md-icon></md-button>\n<md-button class="md-icon-button" aria-label="next page" translate translate-attr-aria-label="SEARCH.NEXT_PAGE">\n<md-icon md-font-icon="icon-chevron-right"></md-icon></md-button></div></div><div class="results"><div \nclass="result-item {{mail.status}}" ng-repeat="mail in vm.mails | filter: vm.search" md-ink-ripple><div layout="row" \nlayout-align="start center"><img class="avatar" ng-if="mail.from.avatar" alt="{{mail.from.name}}" \nng-src="{{mail.from.avatar}}"><div class="avatar" ng-if="!mail.from.avatar" ms-random-class="vm.colors">\n{{mail.from.name[0]}}</div><div class="info" flex layout="column"><div class="name text-truncate">{{mail.from.name}}\n</div><div class="subject secondary-text text-truncate">{{mail.subject}}</div><div \nclass="message secondary-text text-truncate">{{mail.message | htmlToPlaintext}}</div></div><div layout="column" \nlayout-align="center end"><div class="time secondary-text">{{mail.time}}</div></div></div></div></div><div \nclass="simple-pagination"><md-button class="pagination-item disabled" md-no-ink ng-href="#" \naria-label="Go to previous page" translate translate-attr-aria-label="SEARCH.GO_TO_PREVIOUS"><md-icon \nmd-font-icon="icon-chevron-left"></md-icon></md-button><md-button class="pagination-item active" md-no-ink ng-href="#" \naria-label="Go to page 1"><span>1</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to page 2" hide-xs><span>2</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to page 3" hide-xs><span>3</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to page 4" hide-xs><span>4</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to page 5" hide-xs><span>5</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to page 6" hide-xs><span>6</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to page 7" hide-xs><span>7</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to page 8" hide-xs><span>8</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to page 9" hide-xs><span>9</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to page 10" hide-xs><span>10</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to next page" translate translate-attr-aria-label="SEARCH.GO_TO_NEXT"><md-icon \nmd-font-icon="icon-chevron-right"></md-icon></md-button></div>');
$templateCache.put('app/main/pages/search/tabs/users/users.html','<div class="result-info" layout="row" layout-align="space-between center" layout-xs="column" \nlayout-align-xs="start start"><div><span class="md-title" translate="SEARCH.USERS">Users</span> <span \nclass="secondary-text"><span>87</span> <span translate="SEARCH.RESULTS">Results</span></span></div><div class="pager">\n<span class="secondary-text"><span translate="SEARCH.RESULTS">Results</span> <span>:</span> </span><span \nclass="page-info"><span>1</span> <span>-</span> <span>10</span> <span translate="SEARCH.OF">of</span> <span>100</span>\n</span><md-button class="md-icon-button" aria-label="previous page" translate \ntranslate-attr-aria-label="SEARCH.PREVIOUS_PAGE"><md-icon md-font-icon="icon-chevron-left"></md-icon></md-button>\n<md-button class="md-icon-button" aria-label="next page" translate translate-attr-aria-label="SEARCH.NEXT_PAGE">\n<md-icon md-font-icon="icon-chevron-right"></md-icon></md-button></div></div><table class="results simple clickable" \nms-responsive-table><thead><tr><th translate="SEARCH.NAME">Name</th><th translate="SEARCH.POSITION">Position</th><th \ntranslate="SEARCH.OFFICE">Office</th><th class="text-right" translate="SEARCH.AGE">Age</th><th class="text-right" \ntranslate="SEARCH.START_DATE">Start Date</th><th class="text-right" translate="SEARCH.SALARY">Salary</th><th \nclass="text-left" translate="SEARCH.EMAIL">Email</th></tr></thead><tbody><tr class="result-item user" \nng-repeat="user in vm.users"><td class="name">{{user.name}}</td><td class="position">{{user.position}}</td><td \nclass="office">{{user.office}}</td><td class="age text-right">{{user.age}}</td><td class="start-date text-right">\n{{user.startDate}}</td><td class="salary text-right">{{user.salary | currency}}</td><td class="email text-left">\n{{user.email}}</td></tr></tbody></table><div class="simple-pagination"><md-button class="pagination-item disabled" \nmd-no-ink ng-href="#" aria-label="Go to previous page" translate translate-attr-aria-label="SEARCH.GO_TO_PREVIOUS">\n<md-icon md-font-icon="icon-chevron-left"></md-icon></md-button><md-button class="pagination-item active" md-no-ink \nng-href="#" aria-label="Go to page 1"><span>1</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to page 2" hide-xs><span>2</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to page 3" hide-xs><span>3</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to page 4" hide-xs><span>4</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to page 5" hide-xs><span>5</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to page 6" hide-xs><span>6</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to page 7" hide-xs><span>7</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to page 8" hide-xs><span>8</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to page 9" hide-xs><span>9</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to page 10" hide-xs><span>10</span></md-button><md-button class="pagination-item" ng-href="#" \naria-label="Go to next page" translate translate-attr-aria-label="SEARCH.GO_TO_NEXT"><md-icon \nmd-font-icon="icon-chevron-right"></md-icon></md-button></div>');
$templateCache.put('app/main/ui/page-layouts/carded/fullwidth/fullwidth.html','<div class="page-layout carded fullwidth" layout="row"><div class="top-bg md-accent-bg"></div><div class="center" \nlayout="column" flex><div class="header"><span class="h2 white-fg">Fullwidth with independent scroll</span></div><div \nclass="content-card" layout="column" flex><div class="toolbar" layout="row" layout-align="start center"><span>\nContent toolbar</span></div><md-content class="content" flex ms-scroll><div \nng-include="\'app/main/ui/page-layouts/demo/demo-content.html\'"></div></md-content></div></div></div>');
$templateCache.put('app/main/ui/page-layouts/carded/fullwidth-ii/fullwidth-ii.html','<div class="page-layout carded fullwidth single-scroll" layout="row"><div class="top-bg md-accent-bg"></div><div \nclass="center" flex><div class="header"><span class="h2 white-fg">Fullwidth with page scroll</span></div><div \nclass="content-card"><div class="toolbar" layout="row" layout-align="start center"><span>Content toolbar</span></div>\n<md-content class="content" ms-scroll><div ng-include="\'app/main/ui/page-layouts/demo/demo-content.html\'"></div>\n</md-content></div></div></div>');
$templateCache.put('app/main/ui/page-layouts/carded/left-sidenav/left-sidenav.html','<div class="page-layout carded left-sidenav" layout="row"><div class="top-bg md-accent-bg"></div><md-sidenav \nclass="sidenav" md-is-locked-open="$mdMedia(\'gt-md\')" md-component-id="sidenav" ms-scroll ms-sidenav-helper><div \nclass="header"><p>Sidenav header</p></div><md-content class="content" flex ms-scroll><div \nng-include="\'app/main/ui/page-layouts/demo/demo-sidenav.html\'"></div></md-content></md-sidenav><div class="center" \nlayout="column" flex><div class="header" layout="row"><div><span class="h2 white-fg">\nLeft sidenav with independent scroll</span></div></div><div class="content-card" layout="column" flex><div \nclass="toolbar" layout="row" layout-align="start center"><md-button class="md-icon-button sidenav-toggle" \nng-click="vm.toggleSidenav(\'sidenav\')" hide-gt-md aria-label="Toggle left sidenav"><md-icon md-font-icon="icon-menu" \nclass="icon"></md-icon></md-button><p>Content toolbar</p></div><md-content class="content" flex ms-scroll><div \nng-include="\'app/main/ui/page-layouts/demo/demo-content.html\'"></div></md-content></div></div></div>');
$templateCache.put('app/main/ui/page-layouts/carded/left-sidenav-ii/left-sidenav-ii.html','<div class="page-layout carded left-sidenav single-scroll" layout="row"><div class="top-bg md-accent-bg"></div>\n<md-sidenav class="sidenav" md-is-locked-open="$mdMedia(\'gt-md\')" md-component-id="sidenav" ms-scroll \nms-sidenav-helper><div class="header"><p>Sidenav header</p></div><md-content class="content" ms-scroll><div \nng-include="\'app/main/ui/page-layouts/demo/demo-sidenav.html\'"></div></md-content></md-sidenav><div class="center" \nflex><div class="header" layout="row"><div><span class="h2 white-fg">Left sidenav with page scroll</span></div></div>\n<div class="content-card"><div class="toolbar" layout="row" layout-align="start center"><md-button \nclass="md-icon-button sidenav-toggle" ng-click="vm.toggleSidenav(\'sidenav\')" hide-gt-md \naria-label="Toggle left sidenav"><md-icon md-font-icon="icon-menu" class="icon"></md-icon></md-button><p>\nContent toolbar</p></div><md-content class="content" ms-scroll><div \nng-include="\'app/main/ui/page-layouts/demo/demo-content.html\'"></div></md-content></div></div></div>');
$templateCache.put('app/main/ui/page-layouts/carded/right-sidenav-ii/right-sidenav-ii.html','<div class="page-layout carded right-sidenav single-scroll" layout="row"><div class="top-bg md-accent-bg"></div><div \nclass="center" flex><div class="header" layout="row"><div><span class="h2 white-fg">Right sidenav with page scroll\n</span></div></div><div class="content-card"><div class="toolbar" layout="row" layout-align="space-between center"><p>\nContent toolbar</p><md-button class="md-icon-button sidenav-toggle" ng-click="vm.toggleSidenav(\'sidenav\')" hide-gt-md \naria-label="Toggle right pane"><md-icon md-font-icon="icon-menu" class="icon"></md-icon></md-button></div><md-content \nclass="content" ms-scroll><div ng-include="\'app/main/ui/page-layouts/demo/demo-content.html\'"></div></md-content></div>\n</div><md-sidenav class="sidenav md-sidenav-right" md-is-locked-open="$mdMedia(\'gt-md\')" md-component-id="sidenav" \nms-scroll ms-sidenav-helper><div class="header"><p>Sidenav header</p></div><md-content class="content" ms-scroll><div \nng-include="\'app/main/ui/page-layouts/demo/demo-sidenav.html\'"></div></md-content></md-sidenav></div>');
$templateCache.put('app/main/ui/page-layouts/simple/left-sidenav/left-sidenav.html','<div class="page-layout simple left-sidenav" layout="row"><md-sidenav class="sidenav" \nmd-is-locked-open="$mdMedia(\'gt-md\')" md-component-id="sidenav" ms-scroll ms-sidenav-helper><div \nng-include="\'app/main/ui/page-layouts/demo/demo-sidenav.html\'"></div></md-sidenav><div class="center" flex ms-scroll>\n<div class="header md-accent-bg" layout="row"><md-button class="md-icon-button sidenav-toggle" \nng-click="vm.toggleSidenav(\'sidenav\')" hide-gt-md aria-label="Toggle sidenav"><md-icon md-font-icon="icon-menu" \nclass="icon"></md-icon></md-button><div><span class="h2">Left sidenav with independent scroll</span></div></div><div \nclass="content md-background-bg"><div ng-include="\'app/main/ui/page-layouts/demo/demo-content.html\'"></div></div></div>\n</div>');
$templateCache.put('app/main/ui/page-layouts/carded/right-sidenav/right-sidenav.html','<div class="page-layout carded right-sidenav" layout="row"><div class="top-bg md-accent-bg"></div><div class="center" \nlayout="column" flex><div class="header" layout="row"><div><span class="h2 white-fg">\nRight sidenav with independent scroll</span></div></div><div class="content-card" layout="column" flex><div \nclass="toolbar" layout="row" layout-align="space-between center"><p>Content toolbar</p><md-button \nclass="md-icon-button sidenav-toggle" ng-click="vm.toggleSidenav(\'sidenav\')" hide-gt-md aria-label="Toggle right pane">\n<md-icon md-font-icon="icon-menu" class="icon"></md-icon></md-button></div><md-content class="content" flex ms-scroll>\n<div ng-include="\'app/main/ui/page-layouts/demo/demo-content.html\'"></div></md-content></div></div><md-sidenav \nclass="sidenav md-sidenav-right" md-is-locked-open="$mdMedia(\'gt-md\')" md-component-id="sidenav" ms-scroll \nms-sidenav-helper><div class="header"><p>Sidenav header</p></div><md-content class="content" ms-scroll flex><div \nng-include="\'app/main/ui/page-layouts/demo/demo-sidenav.html\'"></div></md-content></md-sidenav></div>');
$templateCache.put('app/main/ui/page-layouts/simple/fullwidth/fullwidth.html','<div class="page-layout simple fullwidth"><div class="header md-accent-bg"><span class="h2">Fullwidth</span></div><div \nclass="content md-background-bg"><div ng-include="\'app/main/ui/page-layouts/demo/demo-content.html\'"></div></div></div>');
$templateCache.put('app/main/ui/page-layouts/simple/left-sidenav-ii/left-sidenav-ii.html','<div class="page-layout simple left-sidenav single-scroll" layout="row"><md-sidenav class="sidenav" \nmd-is-locked-open="$mdMedia(\'gt-md\')" md-component-id="sidenav" ms-scroll ms-sidenav-helper><div \nng-include="\'app/main/ui/page-layouts/demo/demo-sidenav.html\'"></div></md-sidenav><div class="center" flex ms-scroll>\n<div class="header md-accent-bg" layout="row"><md-button class="md-icon-button sidenav-toggle" \nng-click="vm.toggleSidenav(\'sidenav\')" hide-gt-md aria-label="Toggle sidenav"><md-icon md-font-icon="icon-menu" \nclass="icon"></md-icon></md-button><div><span class="h2">Left sidenav with page scroll</span></div></div><div \nclass="content md-background-bg"><div ng-include="\'app/main/ui/page-layouts/demo/demo-content.html\'"></div></div></div>\n</div>');
$templateCache.put('app/main/ui/theme-colors/dialogs/custom-theme/custom-theme-dialog.html','<md-dialog class="custom-theme-dialog" aria-label="Custom Theme"><md-toolbar><div class="md-toolbar-tools"><h2>\nCustom Theme Generator</h2><span flex></span><md-button class="md-icon-button" ng-click="vm.closeDialog()"><md-icon \nmd-font-icon="icon-close" aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nlayout="row" ng-repeat="type in [\'primary\', \'accent\', \'warn\', \'background\']"><h3 class="type">{{type}}</h3>\n<md-input-container><label>Palette</label><md-select ng-model="vm.theme[type].name" \nng-style="{\'background-color\': vm.rgba(vm.palettes[vm.theme[type].name][\'500\'].value), \'color\': vm.rgba(vm.palettes[vm.theme[type].name][\'500\'].contrast, 1)}">\n<md-option ng-value="palette" ng-repeat="(palette, hues) in vm.palettes" \nng-style="{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}">{{palette}}\n</md-option></md-select></md-input-container><div layout="row" \nng-repeat="hueType in [\'default\', \'hue-1\', \'hue-2\', \'hue-3\']"><md-input-container><label>{{hueType}}</label><md-select \nng-model="vm.theme[type].hues[hueType]" \nng-style="{\'background-color\': vm.rgba(vm.palettes[vm.theme[type].name][vm.theme[type].hues[hueType]].value), \'color\': vm.rgba(vm.palettes[vm.theme[type].name][vm.theme[type].hues[hueType]].contrast, 1)}">\n<md-option ng-value="hue" ng-repeat="(hue, opt) in vm.palettes[vm.theme[type].name]" \nng-style="{\'background-color\': vm.rgba(opt.value), \'color\': vm.rgba(opt.contrast, 1)}">{{hue}}</md-option></md-select>\n</md-input-container></div></div><md-divider></md-divider><div layout="row"><p>\nTo make this theme permanent, copy the below code and add it into the "fuseThemes" object in "core/theming/fuse-themes.constant.js" file. You can also replace the "CUSTOM_THEME_NAME" with your theme name.\n</p></div><div layout="row"><textarea readonly="readonly" class="theme-object">"CUSTOM_THEME_NAME" : {{vm.theme}}\n</textarea></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button \nclass="md-raised md-accent" ng-click="vm.setTheme()">Set Theme</md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/main/ui/page-layouts/simple/left-sidenav-iii/left-sidenav-iii.html','<div class="page-layout simple left-sidenav inner-sidenav"><div class="header md-accent-bg"><md-button \nclass="md-icon-button sidenav-toggle" ng-click="vm.toggleSidenav(\'sidenav\')" hide-gt-md aria-label="Toggle sidenav">\n<md-icon md-font-icon="icon-menu" class="icon"></md-icon></md-button><span class="h2">Inner Left Sidenav</span></div>\n<div class="content" md-background-bg layout="row" ms-scroll><md-sidenav class="sidenav" \nmd-is-locked-open="$mdMedia(\'gt-md\')" md-component-id="sidenav" ms-scroll ms-sidenav-helper><div class="header"><p>\nSidenav header</p></div><md-content class="content"><div \nng-include="\'app/main/ui/page-layouts/demo/demo-sidenav.html\'"></div></md-content></md-sidenav><div flex \nng-include="\'app/main/ui/page-layouts/demo/demo-content.html\'"></div></div></div>');
$templateCache.put('app/main/ui/page-layouts/simple/right-sidenav/right-sidenav.html','<div class="page-layout simple right-sidenav" layout="row"><div class="center" flex ms-scroll><div \nclass="header md-accent-bg" layout="row" layout-align="space-between"><div><span class="h2">\nRight sidenav with independent scroll</span></div><md-button class="md-icon-button sidenav-toggle" \nng-click="vm.toggleSidenav(\'sidenav\')" hide-gt-md aria-label="Toggle sidenav"><md-icon md-font-icon="icon-menu" \nclass="icon"></md-icon></md-button></div><div class="content md-background-bg"><div \nng-include="\'app/main/ui/page-layouts/demo/demo-content.html\'"></div></div></div><md-sidenav \nclass="sidenav md-sidenav-right" md-is-locked-open="$mdMedia(\'gt-md\')" md-component-id="sidenav" ms-scroll \nms-sidenav-helper><div ng-include="\'app/main/ui/page-layouts/demo/demo-sidenav.html\'"></div></md-sidenav></div>');
$templateCache.put('app/main/ui/page-layouts/simple/right-sidenav-ii/right-sidenav-ii.html','<div class="page-layout simple right-sidenav single-scroll" layout="row"><div class="center" flex ms-scroll><div \nclass="header md-accent-bg" layout="row" layout-align="space-between"><div><span class="h2">\nRight sidenav with page scroll</span></div><md-button class="md-icon-button sidenav-toggle" \nng-click="vm.toggleSidenav(\'sidenav\')" hide-gt-md aria-label="Toggle sidenav"><md-icon md-font-icon="icon-menu" \nclass="icon"></md-icon></md-button></div><div class="content md-background-bg"><div \nng-include="\'app/main/ui/page-layouts/demo/demo-content.html\'"></div></div></div><md-sidenav \nclass="sidenav md-sidenav-right" md-is-locked-open="$mdMedia(\'gt-md\')" md-component-id="sidenav" ms-scroll \nms-sidenav-helper><div ng-include="\'app/main/ui/page-layouts/demo/demo-sidenav.html\'"></div></md-sidenav></div>');
$templateCache.put('app/main/ui/page-layouts/simple/right-sidenav-iii/right-sidenav-iii.html','<div class="page-layout simple right-sidenav inner-sidenav"><div class="header md-accent-bg"><md-button \nclass="md-icon-button sidenav-toggle" ng-click="vm.toggleSidenav(\'sidenav\')" hide-gt-md aria-label="Toggle sidenav">\n<md-icon md-font-icon="icon-menu" class="icon"></md-icon></md-button><span class="h2">Inner Right Sidenav</span></div>\n<div class="content" md-background-bg layout="row" ms-scroll><div flex \nng-include="\'app/main/ui/page-layouts/demo/demo-content.html\'"></div><md-sidenav class="sidenav md-sidenav-right" \nmd-is-locked-open="$mdMedia(\'gt-md\')" md-component-id="sidenav" ms-scroll ms-sidenav-helper><div class="header"><p>\nSidenav header</p></div><md-content class="content"><div \nng-include="\'app/main/ui/page-layouts/demo/demo-sidenav.html\'"></div></md-content></md-sidenav></div></div>');
$templateCache.put('app/main/ui/page-layouts/simple/tabbed/tabbed.html','<div class="page-layout simple tabbed" layout="column"><div class="header md-accent-bg"><span class="h2">Tabbed</span>\n</div><div class="content"><md-tabs md-dynamic-height><md-tab label="Tab 1"><div \nng-include="\'app/main/ui/page-layouts/demo/demo-content.html\'"></div></md-tab><md-tab label="Tab 2"><div \nng-include="\'app/main/ui/page-layouts/demo/demo-content.html\'"></div></md-tab><md-tab label="Tab 3"><div \nng-include="\'app/main/ui/page-layouts/demo/demo-content.html\'"></div></md-tab></md-tabs></div></div>');
$templateCache.put('app/main/ui/theme-colors/tabs/accent/accent.html','<div class="color" layout="row" layout-wrap layout-align="center center"><div class="md-accent-bg" flex="100" \nlayout="row" layout-padding><div flex>Default</div><div flex>{{vm.themes.active.theme.accent.color}}</div><div flex>\n.md-accent-bg</div></div><div class="md-accent-bg" flex="100" layout="row" layout-padding><div flex>Primary Text</div>\n<div flex>{{vm.themes.active.theme.accent.contrast1}}</div><div flex>.md-accent-bg</div></div><div \nclass="md-accent-bg" flex="100" class="secondary-text" layout="row" layout-padding><div class="secondary-text" flex>\nSecondary Text / Icon</div><div class="secondary-text" flex>{{vm.themes.active.theme.accent.contrast2}}</div><div \nclass="secondary-text" flex>.md-accent-bg .secondary-text</div></div><div class="md-accent-bg" flex="100" \nclass="hint-text" layout="row" layout-padding><div class="hint-text" flex>Hint Text / Disabled Text</div><div \nclass="hint-text" flex>{{vm.themes.active.theme.accent.contrast3}}</div><div class="hint-text" flex>\n.md-accent-bg .hint-text</div></div><div class="md-accent-bg" flex="100" class="divider" layout="row" layout-padding>\n<div class="fade-text" flex>Fade Text / Divider</div><div class="fade-text" flex>\n{{vm.themes.active.theme.accent.contrast4}}</div><div class="fade-text" flex>.md-accent-bg .divider</div></div><div \nflex="100" class="md-accent-fg" layout="row" layout-padding><div flex>As foreground color</div><div flex>\n{{vm.themes.active.theme.accent.color}}</div><div flex>.md-accent-fg</div></div></div><div class="color" layout="row" \nlayout-wrap layout-align="center center"><div class="md-accent-bg md-hue-1" flex="100" layout="row" layout-padding><div\n flex>Hue 1</div><div flex>{{vm.themes.active.theme.accent.hue1.color}}</div><div flex>.md-accent-bg .md-hue-1</div>\n</div><div class="md-accent-bg md-hue-1" flex="100" layout="row" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.accent.hue1.contrast1}}</div><div flex>.md-accent-bg</div></div><div \nclass="md-accent-bg md-hue-1" flex="100" class="secondary-text" layout="row" layout-padding><div \nclass="secondary-text" flex>Secondary Text / Icon</div><div class="secondary-text" flex>\n{{vm.themes.active.theme.accent.hue1.contrast2}}</div><div class="secondary-text" flex>\n.md-accent-bg .md-hue-1 .secondary-text</div></div><div class="md-accent-bg md-hue-1" flex="100" class="hint-text" \nlayout="row" layout-padding><div class="hint-text" flex>Hint Text / Disabled Text</div><div class="hint-text" flex>\n{{vm.themes.active.theme.accent.hue1.contrast3}}</div><div class="hint-text" flex>.md-accent-bg .md-hue-1 .hint-text\n</div></div><div class="md-accent-bg md-hue-1" flex="100" class="divider" layout="row" layout-padding><div \nclass="fade-text" flex>Fade Text / Divider</div><div class="fade-text" flex>\n{{vm.themes.active.theme.accent.hue1.contrast4}}</div><div class="fade-text" flex>.md-accent-bg .md-hue-1 .divider\n</div></div><div flex="100" class="md-accent-fg md-hue-1" layout="row" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.accent.hue1.color}}</div><div flex>.md-accent-fg</div></div></div><div \nclass="color" layout="row" layout-wrap layout-align="center center"><div class="md-accent-bg md-hue-2" flex="100" \nlayout="row" layout-padding><div flex>Hue 2</div><div flex>{{vm.themes.active.theme.accent.hue2.color}}</div><div flex>\n.md-accent-bg .md-hue-2</div></div><div class="md-accent-bg md-hue-2" flex="100" layout="row" layout-padding><div flex>\nPrimary Text</div><div flex>{{vm.themes.active.theme.accent.hue2.contrast1}}</div><div flex>.md-accent-bg</div></div>\n<div class="md-accent-bg md-hue-2" flex="100" class="secondary-text" layout="row" layout-padding><div \nclass="secondary-text" flex>Secondary Text / Icon</div><div class="secondary-text" flex>\n{{vm.themes.active.theme.accent.hue2.contrast2}}</div><div class="secondary-text" flex>\n.md-accent-bg .md-hue-2 .secondary-text</div></div><div class="md-accent-bg md-hue-2" flex="100" class="hint-text" \nlayout="row" layout-padding><div class="hint-text" flex>Hint Text / Disabled Text</div><div class="hint-text" flex>\n{{vm.themes.active.theme.accent.hue2.contrast3}}</div><div class="hint-text" flex>.md-accent-bg .md-hue-2 .hint-text\n</div></div><div class="md-accent-bg md-hue-2" flex="100" class="divider" layout="row" layout-padding><div \nclass="fade-text" flex>Fade Text / Divider</div><div class="fade-text" flex>\n{{vm.themes.active.theme.accent.hue2.contrast4}}</div><div class="fade-text" flex>.md-accent-bg .md-hue-2 .divider\n</div></div><div flex="100" class="md-accent-fg md-hue-2" layout="row" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.accent.hue2.color}}</div><div flex>.md-accent-fg</div></div></div><div \nclass="color" layout="row" layout-wrap layout-align="center center"><div class="md-accent-bg md-hue-3" flex="100" \nlayout="row" layout-padding><div flex>Hue 3</div><div flex>{{vm.themes.active.theme.accent.hue3.color}}</div><div flex>\n.md-accent-bg .md-hue-3</div></div><div class="md-accent-bg md-hue-3" flex="100" layout="row" layout-padding><div flex>\nPrimary Text</div><div flex>{{vm.themes.active.theme.accent.hue3.contrast1}}</div><div flex>.md-accent-bg</div></div>\n<div class="md-accent-bg md-hue-3" flex="100" class="secondary-text" layout="row" layout-padding><div \nclass="secondary-text" flex>Secondary Text / Icon</div><div class="secondary-text" flex>\n{{vm.themes.active.theme.accent.hue3.contrast2}}</div><div class="secondary-text" flex>\n.md-accent-bg .md-hue-3 .secondary-text</div></div><div class="md-accent-bg md-hue-3" flex="100" class="hint-text" \nlayout="row" layout-padding><div class="hint-text" flex>Hint Text / Disabled Text</div><div class="hint-text" flex>\n{{vm.themes.active.theme.accent.hue3.contrast3}}</div><div class="hint-text" flex>.md-accent-bg .md-hue-3 .hint-text\n</div></div><div class="md-accent-bg md-hue-3" flex="100" class="divider" layout="row" layout-padding><div \nclass="fade-text" flex>Fade Text / Divider</div><div class="fade-text" flex>\n{{vm.themes.active.theme.accent.hue3.contrast4}}</div><div class="fade-text" flex>.md-accent-bg .md-hue-3 .divider\n</div></div><div flex="100" class="md-accent-fg md-hue-3" layout="row" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.accent.hue3.color}}</div><div flex>.md-accent-fg</div></div></div>');
$templateCache.put('app/main/ui/theme-colors/tabs/background/background.html','<div class="color" layout="row" layout-wrap layout-align="center center"><div class="md-background-bg" flex="100" \nlayout="row" layout-padding><div flex>Default</div><div flex>{{vm.themes.active.theme.background.color}}</div><div \nflex>.md-background-bg</div></div><div class="md-background-bg" flex="100" layout="row" layout-padding><div flex>\nPrimary Text</div><div flex>{{vm.themes.active.theme.background.contrast1}}</div><div flex>.md-background-bg</div>\n</div><div class="md-background-bg" flex="100" class="secondary-text" layout="row" layout-padding><div \nclass="secondary-text" flex>Secondary Text / Icon</div><div class="secondary-text" flex>\n{{vm.themes.active.theme.background.contrast2}}</div><div class="secondary-text" flex>.md-background-bg .secondary-text\n</div></div><div class="md-background-bg" flex="100" class="hint-text" layout="row" layout-padding><div \nclass="hint-text" flex>Hint Text / Disabled Text</div><div class="hint-text" flex>\n{{vm.themes.active.theme.background.contrast3}}</div><div class="hint-text" flex>.md-background-bg .hint-text</div>\n</div><div class="md-background-bg" flex="100" class="divider" layout="row" layout-padding><div class="fade-text" flex>\nFade Text / Divider</div><div class="fade-text" flex>{{vm.themes.active.theme.background.contrast4}}</div><div \nclass="fade-text" flex>.md-background-bg .divider</div></div><div flex="100" class="md-primary-bg md-background-fg" \nlayout="row" layout-padding><div flex>As foreground color</div><div flex>{{vm.themes.active.theme.background.color}}\n</div><div flex>.md-background-fg</div></div></div><div class="color" layout="row" layout-wrap \nlayout-align="center center"><div class="md-background-bg md-hue-1" flex="100" layout="row" layout-padding><div flex>\nHue 1</div><div flex>{{vm.themes.active.theme.background.hue1.color}}</div><div flex>.md-background-bg .md-hue-1</div>\n</div><div class="md-background-bg md-hue-1" flex="100" layout="row" layout-padding><div flex>Primary Text</div><div \nflex>{{vm.themes.active.theme.background.hue1.contrast1}}</div><div flex>.md-background-bg</div></div><div \nclass="md-background-bg md-hue-1" flex="100" class="secondary-text" layout="row" layout-padding><div \nclass="secondary-text" flex>Secondary Text / Icon</div><div class="secondary-text" flex>\n{{vm.themes.active.theme.background.hue1.contrast2}}</div><div class="secondary-text" flex>\n.md-background-bg .md-hue-1 .secondary-text</div></div><div class="md-background-bg md-hue-1" flex="100" \nclass="hint-text" layout="row" layout-padding><div class="hint-text" flex>Hint Text / Disabled Text</div><div \nclass="hint-text" flex>{{vm.themes.active.theme.background.hue1.contrast3}}</div><div class="hint-text" flex>\n.md-background-bg .md-hue-1 .hint-text</div></div><div class="md-background-bg md-hue-1" flex="100" class="divider" \nlayout="row" layout-padding><div class="fade-text" flex>Fade Text / Divider</div><div class="fade-text" flex>\n{{vm.themes.active.theme.background.hue1.contrast4}}</div><div class="fade-text" flex>\n.md-background-bg .md-hue-1 .divider</div></div><div flex="100" class="md-primary-bg" layout="row" layout-padding><div \nflex class="md-background-fg md-hue-1">As foreground color</div><div flex class="md-background-fg md-hue-1">\n{{vm.themes.active.theme.background.hue1.color}}</div><div flex class="md-background-fg md-hue-1">.md-background-fg\n</div></div></div><div class="color" layout="row" layout-wrap layout-align="center center"><div \nclass="md-background-bg md-hue-2" flex="100" layout="row" layout-padding><div flex>Hue 2</div><div flex>\n{{vm.themes.active.theme.background.hue2.color}}</div><div flex>.md-background-bg .md-hue-2</div></div><div \nclass="md-background-bg md-hue-2" flex="100" layout="row" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.background.hue2.contrast1}}</div><div flex>.md-background-bg</div></div><div \nclass="md-background-bg md-hue-2" flex="100" class="secondary-text" layout="row" layout-padding><div \nclass="secondary-text" flex>Secondary Text / Icon</div><div class="secondary-text" flex>\n{{vm.themes.active.theme.background.hue2.contrast2}}</div><div class="secondary-text" flex>\n.md-background-bg .md-hue-2 .secondary-text</div></div><div class="md-background-bg md-hue-2" flex="100" \nclass="hint-text" layout="row" layout-padding><div class="hint-text" flex>Hint Text / Disabled Text</div><div \nclass="hint-text" flex>{{vm.themes.active.theme.background.hue2.contrast3}}</div><div class="hint-text" flex>\n.md-background-bg .md-hue-2 .hint-text</div></div><div class="md-background-bg md-hue-2" flex="100" class="divider" \nlayout="row" layout-padding><div class="fade-text" flex>Fade Text / Divider</div><div class="fade-text" flex>\n{{vm.themes.active.theme.background.hue2.contrast4}}</div><div class="fade-text" flex>\n.md-background-bg .md-hue-2 .divider</div></div><div flex="100" class="md-primary-bg" layout="row" layout-padding><div \nflex class="md-background-fg md-hue-2">As foreground color</div><div flex class="md-background-fg md-hue-2">\n{{vm.themes.active.theme.background.hue2.color}}</div><div flex class="md-background-fg md-hue-2">.md-background-fg\n</div></div></div><div class="color" layout="row" layout-wrap layout-align="center center"><div \nclass="md-background-bg md-hue-3" flex="100" layout="row" layout-padding><div flex>Hue 3</div><div flex>\n{{vm.themes.active.theme.background.hue3.color}}</div><div flex>.md-background-bg .md-hue-3</div></div><div \nclass="md-background-bg md-hue-3" flex="100" layout="row" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.background.hue3.contrast1}}</div><div flex>.md-background-bg</div></div><div \nclass="md-background-bg md-hue-3" flex="100" class="secondary-text" layout="row" layout-padding><div \nclass="secondary-text" flex>Secondary Text / Icon</div><div class="secondary-text" flex>\n{{vm.themes.active.theme.background.hue3.contrast2}}</div><div class="secondary-text" flex>\n.md-background-bg .md-hue-3 .secondary-text</div></div><div class="md-background-bg md-hue-3" flex="100" \nclass="hint-text" layout="row" layout-padding><div class="hint-text" flex>Hint Text / Disabled Text</div><div \nclass="hint-text" flex>{{vm.themes.active.theme.background.hue3.contrast3}}</div><div class="hint-text" flex>\n.md-background-bg .md-hue-3 .hint-text</div></div><div class="md-background-bg md-hue-3" flex="100" class="divider" \nlayout="row" layout-padding><div class="fade-text" flex>Fade Text / Divider</div><div class="fade-text" flex>\n{{vm.themes.active.theme.background.hue3.contrast4}}</div><div class="fade-text" flex>\n.md-background-bg .md-hue-3 .divider</div></div><div flex="100" class="md-primary-bg" layout="row" layout-padding><div \nflex class="md-background-fg md-hue-3">As foreground color</div><div flex class="md-background-fg md-hue-3">\n{{vm.themes.active.theme.background.hue3.color}}</div><div flex class="md-background-fg md-hue-3">.md-background-fg\n</div></div></div>');
$templateCache.put('app/main/ui/theme-colors/tabs/primary/primary.html','<div class="color" layout="row" layout-wrap layout-align="center center"><div class="md-primary-bg" flex="100" \nlayout="row" layout-padding><div flex>Default</div><div flex>{{vm.themes.active.theme.primary.color}}</div><div flex>\n.md-primary-bg</div></div><div class="md-primary-bg" flex="100" layout="row" layout-padding><div flex>Primary Text\n</div><div flex>{{vm.themes.active.theme.primary.contrast1}}</div><div flex>.md-primary-bg</div></div><div \nclass="md-primary-bg" flex="100" class="secondary-text" layout="row" layout-padding><div class="secondary-text" flex>\nSecondary Text / Icon</div><div class="secondary-text" flex>{{vm.themes.active.theme.primary.contrast2}}</div><div \nclass="secondary-text" flex>.md-primary-bg .secondary-text</div></div><div class="md-primary-bg" flex="100" \nclass="hint-text" layout="row" layout-padding><div class="hint-text" flex>Hint Text / Disabled Text</div><div \nclass="hint-text" flex>{{vm.themes.active.theme.primary.contrast3}}</div><div class="hint-text" flex>\n.md-primary-bg .hint-text</div></div><div class="md-primary-bg" flex="100" class="divider" layout="row" layout-padding>\n<div class="fade-text" flex>Fade Text / Divider</div><div class="fade-text" flex>\n{{vm.themes.active.theme.primary.contrast4}}</div><div class="fade-text" flex>.md-primary-bg .divider</div></div><div \nflex="100" class="md-primary-fg" layout="row" layout-padding><div flex>As foreground color</div><div flex>\n{{vm.themes.active.theme.primary.color}}</div><div flex>.md-primary-fg</div></div></div><div class="color" \nlayout="row" layout-wrap layout-align="center center"><div class="md-primary-bg md-hue-1" flex="100" layout="row" \nlayout-padding><div flex>Hue 1</div><div flex>{{vm.themes.active.theme.primary.hue1.color}}</div><div flex>\n.md-primary-bg .md-hue-1</div></div><div class="md-primary-bg md-hue-1" flex="100" layout="row" layout-padding><div \nflex>Primary Text</div><div flex>{{vm.themes.active.theme.primary.hue1.contrast1}}</div><div flex>.md-primary-bg</div>\n</div><div class="md-primary-bg md-hue-1" flex="100" class="secondary-text" layout="row" layout-padding><div \nclass="secondary-text" flex>Secondary Text / Icon</div><div class="secondary-text" flex>\n{{vm.themes.active.theme.primary.hue1.contrast2}}</div><div class="secondary-text" flex>\n.md-primary-bg .md-hue-1 .secondary-text</div></div><div class="md-primary-bg md-hue-1" flex="100" class="hint-text" \nlayout="row" layout-padding><div class="hint-text" flex>Hint Text / Disabled Text</div><div class="hint-text" flex>\n{{vm.themes.active.theme.primary.hue1.contrast3}}</div><div class="hint-text" flex>.md-primary-bg .md-hue-1 .hint-text\n</div></div><div class="md-primary-bg md-hue-1" flex="100" class="divider" layout="row" layout-padding><div \nclass="fade-text" flex>Fade Text / Divider</div><div class="fade-text" flex>\n{{vm.themes.active.theme.primary.hue1.contrast4}}</div><div class="fade-text" flex>.md-primary-bg .md-hue-1 .divider\n</div></div><div flex="100" class="md-primary-fg md-hue-1" layout="row" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.primary.hue1.color}}</div><div flex>.md-primary-fg</div></div></div><div \nclass="color" layout="row" layout-wrap layout-align="center center"><div class="md-primary-bg md-hue-2" flex="100" \nlayout="row" layout-padding><div flex>Hue 2</div><div flex>{{vm.themes.active.theme.primary.hue2.color}}</div><div \nflex>.md-primary-bg .md-hue-2</div></div><div class="md-primary-bg md-hue-2" flex="100" layout="row" layout-padding>\n<div flex>Primary Text</div><div flex>{{vm.themes.active.theme.primary.hue2.contrast1}}</div><div flex>.md-primary-bg\n</div></div><div class="md-primary-bg md-hue-2" flex="100" class="secondary-text" layout="row" layout-padding><div \nclass="secondary-text" flex>Secondary Text / Icon</div><div class="secondary-text" flex>\n{{vm.themes.active.theme.primary.hue2.contrast2}}</div><div class="secondary-text" flex>\n.md-primary-bg .md-hue-2 .secondary-text</div></div><div class="md-primary-bg md-hue-2" flex="100" class="hint-text" \nlayout="row" layout-padding><div class="hint-text" flex>Hint Text / Disabled Text</div><div class="hint-text" flex>\n{{vm.themes.active.theme.primary.hue2.contrast3}}</div><div class="hint-text" flex>.md-primary-bg .md-hue-2 .hint-text\n</div></div><div class="md-primary-bg md-hue-2" flex="100" class="divider" layout="row" layout-padding><div \nclass="fade-text" flex>Fade Text / Divider</div><div class="fade-text" flex>\n{{vm.themes.active.theme.primary.hue2.contrast4}}</div><div class="fade-text" flex>.md-primary-bg .md-hue-2 .divider\n</div></div><div flex="100" class="md-primary-fg md-hue-2" layout="row" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.primary.hue2.color}}</div><div flex>.md-primary-fg</div></div></div><div \nclass="color" layout="row" layout-wrap layout-align="center center"><div class="md-primary-bg md-hue-3" flex="100" \nlayout="row" layout-padding><div flex>Hue 3</div><div flex>{{vm.themes.active.theme.primary.hue3.color}}</div><div \nflex>.md-primary-bg .md-hue-3</div></div><div class="md-primary-bg md-hue-3" flex="100" layout="row" layout-padding>\n<div flex>Primary Text</div><div flex>{{vm.themes.active.theme.primary.hue3.contrast1}}</div><div flex>.md-primary-bg\n</div></div><div class="md-primary-bg md-hue-3" flex="100" class="secondary-text" layout="row" layout-padding><div \nclass="secondary-text" flex>Secondary Text / Icon</div><div class="secondary-text" flex>\n{{vm.themes.active.theme.primary.hue3.contrast2}}</div><div class="secondary-text" flex>\n.md-primary-bg .md-hue-3 .secondary-text</div></div><div class="md-primary-bg md-hue-3" flex="100" class="hint-text" \nlayout="row" layout-padding><div class="hint-text" flex>Hint Text / Disabled Text</div><div class="hint-text" flex>\n{{vm.themes.active.theme.primary.hue3.contrast3}}</div><div class="hint-text" flex>.md-primary-bg .md-hue-3 .hint-text\n</div></div><div class="md-primary-bg md-hue-3" flex="100" class="divider" layout="row" layout-padding><div \nclass="fade-text" flex>Fade Text / Divider</div><div class="fade-text" flex>\n{{vm.themes.active.theme.primary.hue3.contrast4}}</div><div class="fade-text" flex>.md-primary-bg .md-hue-3 .divider\n</div></div><div flex="100" class="md-primary-fg md-hue-3" layout="row" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.primary.hue3.color}}</div><div flex>.md-primary-fg</div></div></div>');
$templateCache.put('app/main/ui/theme-colors/tabs/warn/warn.html','<div class="color" layout="row" layout-wrap layout-align="center center"><div class="md-warn-bg" flex="100" \nlayout="row" layout-padding><div flex>Default</div><div flex>{{vm.themes.active.theme.warn.color}}</div><div flex>\n.md-warn-bg</div></div><div class="md-warn-bg" flex="100" layout="row" layout-padding><div flex>Primary Text</div><div \nflex>{{vm.themes.active.theme.warn.contrast1}}</div><div flex>.md-warn-bg</div></div><div class="md-warn-bg" \nflex="100" class="secondary-text" layout="row" layout-padding><div class="secondary-text" flex>Secondary Text / Icon\n</div><div class="secondary-text" flex>{{vm.themes.active.theme.warn.contrast2}}</div><div class="secondary-text" flex>\n.md-warn-bg .secondary-text</div></div><div class="md-warn-bg" flex="100" class="hint-text" layout="row" \nlayout-padding><div class="hint-text" flex>Hint Text / Disabled Text</div><div class="hint-text" flex>\n{{vm.themes.active.theme.warn.contrast3}}</div><div class="hint-text" flex>.md-warn-bg .hint-text</div></div><div \nclass="md-warn-bg" flex="100" class="divider" layout="row" layout-padding><div class="fade-text" flex>\nFade Text / Divider</div><div class="fade-text" flex>{{vm.themes.active.theme.warn.contrast4}}</div><div \nclass="fade-text" flex>.md-warn-bg .divider</div></div><div flex="100" class="md-warn-fg" layout="row" layout-padding>\n<div flex>As foreground color</div><div flex>{{vm.themes.active.theme.warn.color}}</div><div flex>.md-warn-fg</div>\n</div></div><div class="color" layout="row" layout-wrap layout-align="center center"><div class="md-warn-bg md-hue-1" \nflex="100" layout="row" layout-padding><div flex>Hue 1</div><div flex>{{vm.themes.active.theme.warn.hue1.color}}</div>\n<div flex>.md-warn-bg .md-hue-1</div></div><div class="md-warn-bg md-hue-1" flex="100" layout="row" layout-padding><div\n flex>Primary Text</div><div flex>{{vm.themes.active.theme.warn.hue1.contrast1}}</div><div flex>.md-warn-bg</div></div>\n<div class="md-warn-bg md-hue-1" flex="100" class="secondary-text" layout="row" layout-padding><div \nclass="secondary-text" flex>Secondary Text / Icon</div><div class="secondary-text" flex>\n{{vm.themes.active.theme.warn.hue1.contrast2}}</div><div class="secondary-text" flex>\n.md-warn-bg .md-hue-1 .secondary-text</div></div><div class="md-warn-bg md-hue-1" flex="100" class="hint-text" \nlayout="row" layout-padding><div class="hint-text" flex>Hint Text / Disabled Text</div><div class="hint-text" flex>\n{{vm.themes.active.theme.warn.hue1.contrast3}}</div><div class="hint-text" flex>.md-warn-bg .md-hue-1 .hint-text</div>\n</div><div class="md-warn-bg md-hue-1" flex="100" class="divider" layout="row" layout-padding><div class="fade-text" \nflex>Fade Text / Divider</div><div class="fade-text" flex>{{vm.themes.active.theme.warn.hue1.contrast4}}</div><div \nclass="fade-text" flex>.md-warn-bg .md-hue-1 .divider</div></div><div flex="100" class="md-warn-fg md-hue-1" \nlayout="row" layout-padding><div flex>As foreground color</div><div flex>{{vm.themes.active.theme.warn.hue1.color}}\n</div><div flex>.md-warn-fg</div></div></div><div class="color" layout="row" layout-wrap layout-align="center center">\n<div class="md-warn-bg md-hue-2" flex="100" layout="row" layout-padding><div flex>Hue 2</div><div flex>\n{{vm.themes.active.theme.warn.hue2.color}}</div><div flex>.md-warn-bg .md-hue-2</div></div><div \nclass="md-warn-bg md-hue-2" flex="100" layout="row" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.warn.hue2.contrast1}}</div><div flex>.md-warn-bg</div></div><div class="md-warn-bg md-hue-2" \nflex="100" class="secondary-text" layout="row" layout-padding><div class="secondary-text" flex>Secondary Text / Icon\n</div><div class="secondary-text" flex>{{vm.themes.active.theme.warn.hue2.contrast2}}</div><div class="secondary-text" \nflex>.md-warn-bg .md-hue-2 .secondary-text</div></div><div class="md-warn-bg md-hue-2" flex="100" class="hint-text" \nlayout="row" layout-padding><div class="hint-text" flex>Hint Text / Disabled Text</div><div class="hint-text" flex>\n{{vm.themes.active.theme.warn.hue2.contrast3}}</div><div class="hint-text" flex>.md-warn-bg .md-hue-2 .hint-text</div>\n</div><div class="md-warn-bg md-hue-2" flex="100" class="divider" layout="row" layout-padding><div class="fade-text" \nflex>Fade Text / Divider</div><div class="fade-text" flex>{{vm.themes.active.theme.warn.hue2.contrast4}}</div><div \nclass="fade-text" flex>.md-warn-bg .md-hue-2 .divider</div></div><div flex="100" class="md-warn-fg md-hue-2" \nlayout="row" layout-padding><div flex>As foreground color</div><div flex>{{vm.themes.active.theme.warn.hue2.color}}\n</div><div flex>.md-warn-fg</div></div></div><div class="color" layout="row" layout-wrap layout-align="center center">\n<div class="md-warn-bg md-hue-3" flex="100" layout="row" layout-padding><div flex>Hue 3</div><div flex>\n{{vm.themes.active.theme.warn.hue3.color}}</div><div flex>.md-warn-bg .md-hue-3</div></div><div \nclass="md-warn-bg md-hue-3" flex="100" layout="row" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.warn.hue3.contrast1}}</div><div flex>.md-warn-bg</div></div><div class="md-warn-bg md-hue-3" \nflex="100" class="secondary-text" layout="row" layout-padding><div class="secondary-text" flex>Secondary Text / Icon\n</div><div class="secondary-text" flex>{{vm.themes.active.theme.warn.hue3.contrast2}}</div><div class="secondary-text" \nflex>.md-warn-bg .md-hue-3 .secondary-text</div></div><div class="md-warn-bg md-hue-3" flex="100" class="hint-text" \nlayout="row" layout-padding><div class="hint-text" flex>Hint Text / Disabled Text</div><div class="hint-text" flex>\n{{vm.themes.active.theme.warn.hue3.contrast3}}</div><div class="hint-text" flex>.md-warn-bg .md-hue-3 .hint-text</div>\n</div><div class="md-warn-bg md-hue-3" flex="100" class="divider" layout="row" layout-padding><div class="fade-text" \nflex>Fade Text / Divider</div><div class="fade-text" flex>{{vm.themes.active.theme.warn.hue3.contrast4}}</div><div \nclass="fade-text" flex>.md-warn-bg .md-hue-3 .divider</div></div><div flex="100" class="md-warn-fg md-hue-3" \nlayout="row" layout-padding><div flex>As foreground color</div><div flex>{{vm.themes.active.theme.warn.hue3.color}}\n</div><div flex>.md-warn-fg</div></div></div>');
$templateCache.put('app/main/apps/aircrafts/views/classic/detail/detail.html','<div class="thread-header" layout="row" layout-align="space-between center"><div><div class="subject" flex>\n{{vm.currentThread.subject}}</div><div class="labels"><div class="label" \nng-repeat="labelId in vm.currentThread.labels" ng-class="vm.getLabelColor(labelId)">{{vm.getLabelTitle(labelId)}}</div>\n</div></div><div class="actions" layout="row" layout-align="start center"><md-button class="md-icon-button" \nng-click="vm.toggleThreadStatus(\'starred\')" aria-label="Toggle starred" translate \ntranslate-attr-toogle-starred="MAIL.TOGGLE_STARRED"><md-icon ng-if="vm.currentThread.starred" md-font-icon="icon-star" \nclass="amber-fg"></md-icon><md-icon ng-if="!vm.currentThread.starred" md-font-icon="icon-star-outline"></md-icon>\n</md-button><md-button class="md-icon-button" ng-click="vm.toggleThreadStatus(\'important\')" \naria-label="Toggle important" translate translate-attr-toogle-starred="MAIL.TOGGLE_IMPORTANT"><md-icon \nng-if="vm.currentThread.important" md-font-icon="icon-label" class="amber-300-fg"></md-icon><md-icon \nng-if="!vm.currentThread.important" md-font-icon="icon-label-outline"></md-icon></md-button></div></div><div \nclass="thread-content"><div class="info" layout="row" layout-align="space-between start"><div layout="column" \nlayout-align="start start"><div layout="row" layout-align="start start"><div><img ng-if="vm.currentThread.from.avatar" \nalt="{{vm.currentThread.from.name}}" ng-src="{{vm.currentThread.from.avatar}}" class="avatar"><div \nng-if="!vm.currentThread.from.avatar" class="avatar" ms-random-class="vm.colors">{{vm.currentThread.from.name[0]}}\n</div></div><div layout="column" layout-align="start start"><div class="name">{{vm.currentThread.from.name}}</div><div \nclass="to" layout="row" layout-align="start center"><div class="to-text" translate="MAIL.INFO.TO">to</div><div>\n{{vm.currentThread.to[0].name}}</div></div></div></div><a class="toggle-details md-accent-color" \nng-hide="vm.selectedMailShowDetails" ng-click="vm.selectedMailShowDetails = !vm.selectedMailShowDetails" \ntranslate="MAIL.SHOW_DETAILS">Show Details </a><a class="toggle-details md-accent-color" \nng-show="vm.selectedMailShowDetails" ng-click="vm.selectedMailShowDetails = !vm.selectedMailShowDetails" \ntranslate="MAIL.HIDE_DETAILS">Hide Details</a><div ng-show="vm.selectedMailShowDetails" class="details" layout="row" \nlayout-align="start start"><div layout="column"><span class="title" translate="MAIL.DETAILS.FROM">From:</span> <span \nclass="title" translate="MAIL.DETAILS.TO">To:</span> <span class="title" translate="MAIL.DETAILS.DATE">Date:</span>\n</div><div layout="column"><span class="detail">{{vm.currentThread.from.email}}</span> <span class="detail">\n{{vm.currentThread.to[0].email}}</span> <span class="detail">{{vm.currentThread.time}}</span></div></div></div>\n<md-menu><md-button aria-label="More" class="md-icon-button" ng-click="$mdMenu.open($event)" translate \ntranslate-aria-label="MAIL.MORE"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content \nwidth="3"><md-menu-item><md-button aria-label="Reply" translate-aria-label="MAIL.REPLY" \nng-click="vm.replyDialog($event)"><md-icon md-font-icon="icon-reply"></md-icon><span translate="MAIL.REPLY">Reply\n</span></md-button></md-menu-item><md-menu-item><md-button aria-label="Forward" translate-aria-label="MAIL.FORWARD">\n<md-icon md-font-icon="icon-forward"></md-icon><span translate="MAIL.FORWARD">Forward</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label="Print" translate-aria-label="MAIL.PRINT"><md-icon md-font-icon="icon-printer">\n</md-icon><span translate="MAIL.PRINT">Print</span></md-button></md-menu-item></md-menu-content></md-menu></div><div \nng-bind-html="vm.currentThread.message"></div></div><div ng-if="vm.currentThread.attachments" \nclass="thread-attachments"><div class="title"><span translte="MAIL.ATTACHMENTS">Attachments</span>\n ({{vm.currentThread.attachments.length}})</div><div class="attachment-list" layout-wrap layout="row"><div \nclass="attachment" layout="column" ng-repeat="attachment in vm.currentThread.attachments"><img class="preview" \nng-src="{{attachment.preview}}"><div layout="column"><a href="#" class="md-accent-color link" translate="MAIL.VIEW">\nView</a> <a href="#" class="md-accent-color link" translate="MAIL.DOWNLOAD">Download</a><div class="size">\n({{attachment.size}})</div></div></div></div></div>');
$templateCache.put('app/main/apps/aircrafts/views/classic/list/list.html','<div class="no-threads" ng-if="vm.threads.length === 0">There are no messages in \'{{vm.currentFilter.filter}}\'!</div>\n<div class="loading-threads" layout="column" layout-align="center center" ng-if="!vm.threads && vm.loadingThreads">\n<md-progress-circular class="md-accent" md-mode="indeterminate" md-diameter="64"></md-progress-circular><div>\nLoading your mails...</div></div><div class="thread {{thread.status}}" md-ink-ripple="false" \nng-if="!vm.loadingThreads" ng-repeat="thread in vm.threads | filter: vm.search | filter: global.search" \nng-click="vm.openThread(thread)" \nng-class="{\'unread\': !thread.read, \'current-thread\': vm.currentThread === thread, \'selected\': vm.isSelected(thread)}">\n<div layout="row" layout-align="start center"><md-checkbox class="no-label" ng-checked="vm.isSelected(thread)" \nng-click="vm.toggleSelectThread(thread, $event)" aria-label="{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}">\n</md-checkbox><div class="info" flex layout="column"><div class="name" layout="row" layout-align="start center"><img \nclass="avatar" ng-if="thread.from.avatar" alt="{{thread.from.name}}" ng-src="{{thread.from.avatar}}"><div \nclass="avatar" ng-if="!thread.from.avatar" ms-random-class="vm.colors">{{thread.from.name[0]}}</div><span \nclass="text-truncate">{{thread.from.name}}</span><md-icon md-font-icon="icon-paperclip" class="has-attachment s16" \nng-if="thread.hasAttachments"></md-icon></div><div class="subject text-truncate">{{thread.subject}}</div><div \nclass="message text-truncate">\n{{thread.message | htmlToPlaintext | limitTo:180}}{{thread.message.length > 180 ? \'...\' : \'\'}}<div class="labels"><div \nclass="label" ng-repeat="labelId in thread.labels" ng-class="vm.getLabelColor(labelId)">{{vm.getLabelTitle(labelId)}}\n</div></div></div></div><div layout="column" layout-align="space-between end"><div class="time">{{thread.time}}</div>\n<div class="actions" layout="row" layout-align="start center"><md-button class="md-icon-button" \nng-click="vm.toggleThreadStatus(\'starred\', thread, $event)" aria-label="Toggle starred" translate \ntranslate-attr-aria-label="MAIL.TOGGLE_STARRED"><md-icon ng-if="thread.starred" md-font-icon="icon-star" \nclass="amber-fg"></md-icon><md-icon ng-if="!thread.starred" md-font-icon="icon-star-outline"></md-icon></md-button>\n<md-button class="md-icon-button" ng-click="vm.toggleThreadStatus(\'important\', thread, $event)" \naria-label="Toggle important" translate translate-attr-aria-label="MAIL.TOGGLE_IMPORTANT"><md-icon \nng-if="thread.important" md-font-icon="icon-label" class="amber-300-fg"></md-icon><md-icon ng-if="!thread.important" \nmd-font-icon="icon-label-outline"></md-icon></md-button></div></div></div></div>');
$templateCache.put('app/main/apps/aircrafts/views/outlook/list/list.html','<div class="no-threads" ng-if="vm.threads.length === 0">There are no messages in \'{{vm.currentFilter.filter}}\'!</div>\n<div class="loading-threads" layout="column" layout-align="center center" ng-if="!vm.threads && vm.loadingThreads">\n<md-progress-circular class="md-accent" md-mode="indeterminate" md-diameter="64"></md-progress-circular><div>\nLoading your mails...</div></div><div class="thread {{thread.status}}" md-ink-ripple ng-if="!vm.loadingThreads" \nng-repeat="thread in vm.threads | filter: vm.search | filter: global.search" ng-click="vm.openThread(thread)" \nng-class="{\'unread\': !thread.read, \'current-thread\': vm.currentThread === thread, \'selected\': vm.isSelected(thread)}">\n<div layout="row" layout-align="start center"><md-checkbox class="no-label" ng-checked="vm.isSelected(thread)" \nng-click="vm.toggleSelectThread(thread, $event)" aria-label="{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}">\n</md-checkbox><div class="info" flex layout="column"><div class="name" layout="row" layout-align="start center"><img \nclass="avatar" ng-if="thread.from.avatar" alt="{{thread.from.name}}" ng-src="{{thread.from.avatar}}"><div \nclass="avatar" ng-if="!thread.from.avatar" ms-random-class="vm.colors">{{thread.from.name[0]}}</div><span \nclass="text-truncate">{{thread.from.name}}</span><md-icon md-font-icon="icon-paperclip" class="has-attachment s16" \nng-if="thread.hasAttachments"></md-icon></div><div class="subject text-truncate">Seats: {{thread.seats}}</div></div>\n<div layout="column" class="time" layout-align="space-between end"><div class="labels"><div class="label" \nng-repeat="labelId in thread.labels" ng-class="vm.getLabelColor(labelId)">{{vm.getLabelTitle(labelId)}}</div></div>\n</div></div></div>');
$templateCache.put('app/main/apps/aircrafts/views/outlook/detail/detail.html','<div ng-if="!vm.currentThread" class="no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-email" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="MAIL.SELECT_MESSAGE_TO_READ">Select a message to read</span></div><div ng-if="vm.currentThread"><div \nclass="thread-header" layout="row" layout-align="space-between center"><div><div class="subject" flex>\n{{vm.currentThread.subject}}</div><div class="labels"><div class="label" \nng-repeat="labelId in vm.currentThread.labels" ng-class="vm.getLabelColor(labelId)">{{vm.getLabelTitle(labelId)}}</div>\n</div></div><div class="actions" layout="row" layout-align="start center"><md-button class="md-icon-button" \nng-click="vm.toggleThreadStatus(\'starred\')" aria-label="Toggle starred" translate \ntranslate-attr-toogle-starred="MAIL.TOGGLE_STARRED"><md-icon ng-if="vm.currentThread.starred" md-font-icon="icon-star" \nclass="amber-fg"></md-icon><md-icon ng-if="!vm.currentThread.starred" md-font-icon="icon-star-outline"></md-icon>\n</md-button><md-button class="md-icon-button" ng-click="vm.toggleThreadStatus(\'important\')" \naria-label="Toggle important" translate translate-attr-toogle-starred="MAIL.TOGGLE_IMPORTANT"><md-icon \nng-if="vm.currentThread.important" md-font-icon="icon-label" class="amber-300-fg"></md-icon><md-icon \nng-if="!vm.currentThread.important" md-font-icon="icon-label-outline"></md-icon></md-button></div></div><div \nclass="thread-content"><div class="info" layout="row" layout-align="space-between start"><div layout="column" \nlayout-align="start start"><div layout="row" layout-align="start start"><div><img ng-if="vm.currentThread.from.avatar" \nalt="{{vm.currentThread.from.name}}" ng-src="{{vm.currentThread.from.avatar}}" class="avatar"><div \nng-if="!vm.currentThread.from.avatar" class="avatar" ms-random-class="vm.colors">{{vm.currentThread.from.name[0]}}\n</div></div><div layout="column" layout-align="start start"><div class="name">{{vm.currentThread.from.name}}</div><div \nclass="to" layout="row" layout-align="start center"><div class="to-text" translate="MAIL.INFO.TO">to</div><div>\n{{vm.currentThread.to[0].name}}</div></div></div></div><a class="toggle-details md-accent-color" \nng-hide="vm.selectedMailShowDetails" ng-click="vm.selectedMailShowDetails = !vm.selectedMailShowDetails" \ntranslate="MAIL.SHOW_DETAILS">Show Details </a><a class="toggle-details md-accent-color" \nng-show="vm.selectedMailShowDetails" ng-click="vm.selectedMailShowDetails = !vm.selectedMailShowDetails" \ntranslate="MAIL.HIDE_DETAILS">Hide Details</a><div ng-show="vm.selectedMailShowDetails" class="details" layout="row" \nlayout-align="start start"><div layout="column"><span class="title" translate="MAIL.DETAILS.FROM">From:</span> <span \nclass="title" translate="MAIL.DETAILS.TO">To:</span> <span class="title" translate="MAIL.DETAILS.DATE">Date:</span>\n</div><div layout="column"><span class="detail">{{vm.currentThread.from.email}}</span> <span class="detail">\n{{vm.currentThread.to[0].email}}</span> <span class="detail">{{vm.currentThread.time}}</span></div></div></div>\n<md-menu><md-button aria-label="More" class="md-icon-button" ng-click="$mdMenu.open($event)" translate \ntranslate-aria-label="MAIL.MORE"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content \nwidth="3"><md-menu-item><md-button aria-label="Reply" translate-aria-label="MAIL.REPLY" \nng-click="vm.replyDialog($event)"><md-icon md-font-icon="icon-reply"></md-icon><span translate="MAIL.REPLY">Reply\n</span></md-button></md-menu-item><md-menu-item><md-button aria-label="Forward" translate-aria-label="MAIL.FORWARD">\n<md-icon md-font-icon="icon-forward"></md-icon><span translate="MAIL.FORWARD">Forward</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label="Print" translate-aria-label="MAIL.PRINT"><md-icon md-font-icon="icon-printer">\n</md-icon><span translate="MAIL.PRINT">Print</span></md-button></md-menu-item></md-menu-content></md-menu></div><div \nng-bind-html="vm.currentThread.message"></div></div><div ng-if="vm.currentThread.attachments" \nclass="thread-attachments"><div class="title"><span translte="MAIL.ATTACHMENTS">Attachments</span>\n ({{vm.currentThread.attachments.length}})</div><div class="attachment-list" layout-wrap layout="row"><div \nclass="attachment" layout="column" ng-repeat="attachment in vm.currentThread.attachments"><img class="preview" \nng-src="{{attachment.preview}}"><div layout="column"><a href="#" class="md-accent-color link" translate="MAIL.VIEW">\nView</a> <a href="#" class="md-accent-color link" translate="MAIL.DOWNLOAD">Download</a><div class="size">\n({{attachment.size}})</div></div></div></div></div></div>');
$templateCache.put('app/main/apps/aircrafts/views/outlook/detail/edit.html','<div class="toolbar grey-100-bg colored-bg" layout="row" layout-align="space-between center" scroll=""><div \nlayout="row" layout-align="start center"><md-button class="md-icon-button close-thread" aria-label="Back" \nng-click="vm.closeThread()" ng-if="vm.currentThread && vm.currentView==\'nosplit\'" translate \ntranslate-attr-aria-label="GLOBAL.BACK"><md-icon md-font-icon="icon-keyboard-backspace"></md-icon></md-button><div \nclass="divider-vertical" hide="" ng-if="vm.activeMailPaneIndex === 1" show-gt-sm=""></div><md-button aria-label="Info" \nclass="md-icon-button" ng-click="vm.viewPreview()" ng-if="vm.selectedContent.id" translate="" \ntranslate-attr-aria-label="GLOBAL.INFORMATION"><md-icon md-font-icon="icon-information-outline"></md-icon><md-tooltip \nhide show-gt-xs><span translate="GLOBAL.INFORMATION">Information</span></md-tooltip></md-button><div \nclass="divider-vertical" hide="" show-gt-sm="" ng-if="vm.selectedContent.id"></div><md-button aria-label="Edit" \nclass="md-icon-button" ng-click="vm.viewEditInline()" translate="" translate-attr-aria-label="GLOBAL.EDIT"><md-icon \nmd-font-icon="icon-pencil"></md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.EDIT">Edit</span></md-tooltip>\n</md-button><div class="divider-vertical" hide="" show-gt-sm="" \nng-if="vm.selectedContent.urlpreview && vm.selectedContent.urlpreview.length > 10"></div><md-button \naria-label="Preview" class="md-icon-button" \nng-if="vm.selectedContent.urlpreview && vm.selectedContent.urlpreview.length > 10" \nng-click="vm.openUrl(vm.selectedContent.urlpreview)" translate="" translate-attr-aria-label="GLOBAL.PREVIEW"><md-icon \nmd-font-icon="icon-eye"></md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.PREVIEW">Preview</span>\n</md-tooltip></md-button><div class="divider-vertical" hide="" show-gt-sm="" ng-if="vm.ActiveSection.web_preview">\n</div><md-button aria-label="Spam" class="md-icon-button" ng-click="" translate="" \ntranslate-attr-aria-label="GLOBAL.LIVE" ng-if="vm.ActiveSection.web_preview"><md-icon md-font-icon="icon-web">\n</md-icon><md-tooltip hide show-gt-xs><span translate="GLOBAL.LIVE">Live Preview</span></md-tooltip></md-button>\n<md-menu hide=""><md-button aria-label="Mail Actions" class="md-icon-button" ng-click="$mdMenu.open($event)" \ntranslate="" translate-attr-aria-label="GLOBAL.ACTIONS"><md-icon md-font-icon="icon-dots-vertical"></md-icon>\n</md-button><md-menu-content width="3"><md-menu-item><md-button aria-label="Archive" \ntranslate-attr-aria-label="GLOBAL.ARCHIVE"><md-icon md-font-icon="icon-archive"></md-icon><span \ntranslate="GLOBAL.ARCHIVE">Archive</span></md-button></md-menu-item><md-menu-item><md-button aria-label="Spam" \ntranslate-attr-aria-label="GLOBAL.SPAM"><md-icon md-font-icon="icon-alert-octagon"></md-icon><span \ntranslate="GLOBAL.SPAM">Spam</span></md-button></md-menu-item><md-menu-item><md-button aria-label="Delete" \ntranslate-aria-label="GLOBAL.DELETE"><md-icon md-font-icon="icon-delete"></md-icon><span translate="GLOBAL.DELETE">\nDelete</span></md-button></md-menu-item><md-menu-item><md-button aria-label="Move To" \ntranslate-attr-aria-label="GLOBAL.MOVE_TO"><md-icon md-font-icon="icon-folder-move"></md-icon><span \ntranslate="GLOBAL.MOVE_TO">Move To</span></md-button></md-menu-item><md-menu-item><md-button aria-label="Labels" \ntranslate-attr-aria-label="GLOBAL.LABELS"><md-icon md-font-icon="icon-label"></md-icon><span translate="GLOBAL.LABELS">\nLabels</span></md-button></md-menu-item></md-menu-content></md-menu></div><div layout="row" layout-align="end center">\n<md-button type="submit" ng-click="vm.saveItem(vm.currentThread_Edit)" class="send-button md-accent md-raised" \nng-disabled="vm.basicForm.$invalid || vm.basicForm.$pristine" aria-label="SAVE">SAVE</md-button><md-button \ntype="button" class="md-raised md-warn" aria-label="Cancel">Cancel</md-button></div></div><md-content \nclass="scrollable"><div id="content-edit" class="nosplited page-layout simple fullwidth mail-content content-edit1" \nlayout="row" hide show-gt-sm><md-tabs md-dynamic-height flex><md-tab label="Aircraft"><div layout="row" \nng-include="\'app/main/apps/aircrafts/views/outlook/detail/tab-edit.html\'"></div></md-tab><md-tab label="Endurance"><div\n layout="row" ng-include="\'app/main/apps/aircrafts/views/outlook/detail/tab-endurance.html\'"></div></md-tab><md-tab \nlabel="Customs"><div layout="row" ng-include="\'app/main/apps/aircrafts/views/outlook/detail/tab-customs.html\'"></div>\n</md-tab><md-tab label="A/C Times"><div layout="row" \nng-include="\'app/main/apps/aircrafts/views/outlook/detail/tab-actimes.html\'"></div></md-tab><md-tab label="Chg Rates">\n<div layout="row" ng-include="\'app/main/apps/aircrafts/views/outlook/detail/tab-chgrates.html\'"></div></md-tab><md-tab \nlabel="Due Items"><div layout="row" ng-include="\'app/main/apps/aircrafts/views/outlook/detail/tab-dueitems.html\'">\n</div></md-tab></md-tabs></div></md-content>');
$templateCache.put('app/main/apps/aircrafts/views/outlook/detail/tab-actimes.html','<div class="form-wrapper md-whiteframe-1dp" flex="100"><form name="vm.basicForm" class="md-inline-form" novalidate>\n<div><div layout="row" layout-align="end center" class="layout-align-end-center layout-row"><md-input-container \nclass="md-block" flex="100"><label>Show</label><md-select ng-model="posttime" placeholder="Post time using Hobbs">\n<md-option value="">---</md-option><md-option value="Current Times" selected="selected">Current Times</md-option>\n<md-option value="Initial Times">Initial Times</md-option></md-select><div class="md-errors-spacer"></div>\n</md-input-container></div><div layout="column" layout-gt-sm="column" class="date-time-picker"><div flex><label>Date\n</label></div><div layout="column" layout-gt-sm="row"><div flex-gt-md="66" flex="100" layout="row"><div flex \nclass="date-container date"><mdp-date-picker mdp-placeholder="Date" mdp-format="DD/MM/YYYY" mdp-open-on-click="true" \nng-model="date"></mdp-date-picker></div><div flex class="date-container time"><mdp-time-picker mdp-placeholder="Time" \nmdp-auto-switch="true" mdp-open-on-click="true" ng-model="date"></mdp-time-picker></div></div></div></div><md-list-item\n class="md-toolbar-tools grey-100-bg"><h3 class="grey-700-fg">Airframe</h3></md-list-item><md-input-container \nclass="md-block" flex><label>Hours</label> <input type="text" name="Hours" ng-model="HoursAirframe" \nplaceholder="Hours"></md-input-container><md-input-container class="md-block" flex><label>Cycles</label> <input \ntype="text" name="Cycles" ng-model="CyclesAirframe" placeholder="Cycles"></md-input-container><md-list-item \nclass="md-toolbar-tools grey-100-bg"><h3 class="grey-700-fg">Engine 1</h3></md-list-item><md-input-container \nclass="md-block" flex><label>Hours</label> <input type="text" name="Hours" ng-model="HoursEngine1" placeholder="Hours">\n</md-input-container><md-input-container class="md-block" flex><label>Cycles</label> <input type="text" name="Cycles" \nng-model="CyclesEngine1" placeholder="Cycles"></md-input-container><md-list-item class="md-toolbar-tools grey-100-bg">\n<h3 class="grey-700-fg">Engine 2</h3></md-list-item><md-input-container class="md-block" flex><label>Hours</label> \n<input type="text" name="Hours" ng-model="HoursEngine2" placeholder="Hours"></md-input-container><md-input-container \nclass="md-block" flex><label>Cycles</label> <input type="text" name="Cycles" ng-model="CyclesEngine2" \nplaceholder="Cycles"></md-input-container><md-list-item class="md-toolbar-tools grey-100-bg"><h3 class="grey-700-fg">\nEngine 3</h3></md-list-item><md-input-container class="md-block" flex><label>Hours</label> <input type="text" \nname="Hours" ng-model="HoursEngine3" placeholder="Hours"></md-input-container><md-input-container class="md-block" \nflex><label>Cycles</label> <input type="text" name="Cycles" ng-model="CyclesEngine3" placeholder="Cycles">\n</md-input-container><md-list-item class="md-toolbar-tools grey-100-bg"><h3 class="grey-700-fg">APU</h3></md-list-item>\n<md-input-container class="md-block" flex><label>Hours</label> <input type="text" name="Hours" ng-model="HoursAPU" \nplaceholder="Hours"></md-input-container><md-input-container class="md-block" flex><label>Cycles</label> <input \ntype="text" name="Cycles" ng-model="CyclesAPU" placeholder="Cycles"></md-input-container></div></form></div>');
$templateCache.put('app/main/apps/aircrafts/views/outlook/detail/tab-chgrates.html','<div class="form-wrapper md-whiteframe-1dp" flex="100"><div><table class="simple list-view"><thead><tr><th>Charge Rate\n</th><th>Category</th><th>Start</th><th>End</th><th>Rate</th><th>By</th><th>Compute</th><th></th></tr></thead><tbody>\n<tr><td class="name">DEFAULT</td><td class="type" hide show-gt-sm>AIRFRAME</td><td class="owner" hide-xs>01/01/10</td>\n<td class="size" hide-xs>12/31/10</td><td class="last-modified" hide show-gt-md>$1700.00</td><td class="last-modified" \nhide show-gt-md>HOUR</td><td class="last-modified" hide show-gt-md>WET</td><td class="show-details"><md-icon \nmd-font-icon="icon-delete"></md-icon></td></tr><tr><td class="name">DEFAULT</td><td class="type" hide show-gt-sm>\nAIRFRAME</td><td class="owner" hide-xs>01/01/10</td><td class="size" hide-xs>12/31/10</td><td class="last-modified" \nhide show-gt-md>$1750.00</td><td class="last-modified" hide show-gt-md>HOUR</td><td class="last-modified" hide \nshow-gt-md>WET</td><td class="show-details"><md-icon md-font-icon="icon-delete"></md-icon></td></tr><tr><td \nclass="name">GOLVERNMENT</td><td class="type" hide show-gt-sm>AIRFRAME</td><td class="owner" hide-xs>01/01/10</td><td \nclass="size" hide-xs>12/31/10</td><td class="last-modified" hide show-gt-md>$1700.00</td><td class="last-modified" \nhide show-gt-md>HOUR</td><td class="last-modified" hide show-gt-md>WET</td><td class="show-details"><md-icon \nmd-font-icon="icon-delete"></md-icon></td></tr><tr><td class="name">DEFAULT</td><td class="type" hide show-gt-sm>\nAIRFRAME</td><td class="owner" hide-xs>01/01/10</td><td class="size" hide-xs>12/31/10</td><td class="last-modified" \nhide show-gt-md>$1700.00</td><td class="last-modified" hide show-gt-md>HOUR</td><td class="last-modified" hide \nshow-gt-md>WET</td><td class="show-details"><md-icon md-font-icon="icon-delete"></md-icon></td></tr></tbody></table>\n</div><div layout="row" layout-align="center center"><md-button aria-label="Add event" \nclass="add-event-button md-fab md-warn" ng-click="vm.mediaDialog($event, \'\', vm.currentThread_Edit)" translate="" \ntranslate-attr-aria-label="CALENDAR.ADD_EVENT"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nlayout-padding="">ADD</div></div></div>');
$templateCache.put('app/main/apps/aircrafts/views/outlook/detail/tab-customs.html','<div class="form-wrapper md-whiteframe-1dp" flex="100"><form name="vm.basicForm" class="md-inline-form" novalidate>\n<div><div layout="row" layout-align="end center" class="layout-align-end-center layout-row"><md-input-container \nclass="md-block" flex><label>Owner</label> <input type="text" name="Owner" ng-model="Owner" placeholder="Owner">\n</md-input-container><md-input-container class="md-block" flex><label>Primary Color</label> <input type="text" \nname="Primary Color" ng-model="PrimaryColor" placeholder="Primary Color"></md-input-container></div><div layout="row" \nlayout-align="end center" class="layout-align-end-center layout-row"><md-input-container class="md-block" flex><label>\nAddress</label> <input type="text" name="Address" ng-model="Address" placeholder="Address"></md-input-container>\n<md-input-container class="md-block" flex><label>Secondary Color</label> <input type="text" name="Secondary Color" \nng-model="SecondaryColor" placeholder="Secondary Color"></md-input-container></div><div layout="row" \nlayout-align="end center" class="layout-align-end-center layout-row"><md-input-container class="md-block" flex><label>\nCity</label> <input type="text" name="City" ng-model="City" placeholder="City"></md-input-container><md-input-container\n class="md-block" flex><label>Trim Color</label> <input type="text" name="Trim Color" ng-model="TrimColor" \nplaceholder="Trim Color"></md-input-container></div><div layout="row" layout-align="end center" \nclass="layout-align-end-center layout-row"><md-input-container class="md-block" flex><label>State/Prov</label>\n<md-select ng-model="State" placeholder="State/Prov"><md-option value="">---</md-option><md-option value="CO" \nselected="selected">CO</md-option></md-select><div class="md-errors-spacer"></div></md-input-container>\n<md-input-container class="md-block" flex><label>ZIP/Postal Code</label> <input type="text" name="ZIP/Postal Code" \nng-model="ZIPPostalCode" placeholder="ZIP/Postal Code"></md-input-container><md-input-container class="md-block" flex>\n<label>Decal Number</label> <input type="text" name="Decal Number" ng-model="DecalNumber" placeholder="Decal Number">\n</md-input-container></div><div layout="row" layout-align="end center" class="layout-align-end-center layout-row">\n<md-input-container class="md-block" flex><label>Country Code</label><md-select ng-model="countrycode" \nplaceholder="Country Code"><md-option value="">---</md-option><md-option value="US" selected="selected">US</md-option>\n</md-select><div class="md-errors-spacer"></div></md-input-container><md-input-container class="md-block" flex><label>\nYear of Mfg</label> <input type="text" name="Year of Mfg" ng-model="YearofMfg" placeholder="Year of Mfg">\n</md-input-container><md-input-container class="md-block" flex><label>Serial Number</label> <input type="text" \nname="Serial Number" ng-model="SerialNumber" placeholder="Serial Number"></md-input-container></div><md-input-container\n flex class="md-block md-input-has-value"><label></label> <textarea ui-tinymce="vm.tinymceOptions" ng-model="notes" \naria-label="notes"></textarea></md-input-container></div></form></div>');
$templateCache.put('app/main/apps/aircrafts/views/outlook/detail/tab-dueitems.html','<div class="form-wrapper md-whiteframe-1dp" flex="100"><div><table class="simple list-view"><thead><tr><th>Code</th>\n<th>Due Description</th><th>Last Hours</th><th>Next Hours</th><th>Last Cycles</th><th>Next Cycles</th><th>Last Date\n</th><th>Next Date</th><th></th></tr></thead><tbody><tr><td class="name">ANNUAL INSPECTION</td><td class="type" hide \nshow-gt-sm>12-MONTH ANNUAL INSPECTION</td><td class="owner" hide-xs></td><td class="size" hide-xs></td><td \nclass="last-modified" hide show-gt-md></td><td class="last-modified" hide show-gt-md></td><td class="last-modified" \nhide show-gt-md>08/01/14</td><td class="last-modified" hide show-gt-md>08/01/15</td><td class="show-details"><md-icon \nmd-font-icon="icon-delete"></md-icon></td></tr><tr><td class="name">ELT BATTERY</td><td class="type" hide show-gt-sm>\nELT BATTERY CHECK</td><td class="owner" hide-xs></td><td class="size" hide-xs></td><td class="last-modified" hide \nshow-gt-md></td><td class="last-modified" hide show-gt-md></td><td class="last-modified" hide show-gt-md>09/15/14</td>\n<td class="last-modified" hide show-gt-md>09/15/16</td><td class="show-details"><md-icon md-font-icon="icon-delete">\n</md-icon></td></tr><tr><td class="name">OIL CHANGE</td><td class="type" hide show-gt-sm>OIL CHANGE</td><td \nclass="owner" hide-xs>1500</td><td class="size" hide-xs>1550</td><td class="last-modified" hide show-gt-md></td><td \nclass="last-modified" hide show-gt-md></td><td class="last-modified" hide show-gt-md></td><td class="last-modified" \nhide show-gt-md></td><td class="show-details"><md-icon md-font-icon="icon-delete"></md-icon></td></tr><tr><td \nclass="name">PITOT STATIC CHECK</td><td class="type" hide show-gt-sm>PITOT STATIC CHECK PER FAR 91.411</td><td \nclass="owner" hide-xs></td><td class="size" hide-xs></td><td class="last-modified" hide show-gt-md></td><td \nclass="last-modified" hide show-gt-md></td><td class="last-modified" hide show-gt-md>09/15/14</td><td \nclass="last-modified" hide show-gt-md>09/15/16</td><td class="show-details"><md-icon md-font-icon="icon-delete">\n</md-icon></td></tr><tr><td class="name">TIRE ROTATION</td><td class="type" hide show-gt-sm>TIRE ROTATION</td><td \nclass="owner" hide-xs></td><td class="size" hide-xs></td><td class="last-modified" hide show-gt-md></td><td \nclass="last-modified" hide show-gt-md></td><td class="last-modified" hide show-gt-md>10/10/14</td><td \nclass="last-modified" hide show-gt-md>04/10/15</td><td class="show-details"><md-icon md-font-icon="icon-delete">\n</md-icon></td></tr></tbody></table></div><div layout="row" layout-align="center center"><md-button \naria-label="Add event" class="add-event-button md-fab md-warn" \nng-click="vm.mediaDialog($event, \'\', vm.currentThread_Edit)" translate="" \ntranslate-attr-aria-label="CALENDAR.ADD_EVENT"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nlayout-padding="">ADD</div></div></div>');
$templateCache.put('app/main/apps/aircrafts/views/outlook/detail/tab-edit.html','<div class="form-wrapper md-whiteframe-1dp" flex="100"><form name="vm.basicForm" class="md-inline-form" novalidate>\n<div><div layout="row" layout-align="end center" class="layout-align-end-center layout-row"><md-input-container \nclass="md-block" flex><label>Aircraft ID</label> <input type="text" name="Aircraft ID" \nng-model="vm.currentThread_Edit[fields.titleId]" placeholder="Aircraft ID"></md-input-container><md-input-container \nclass="md-block" flex><md-checkbox class="no-label" aria-label="IncludeInactive" ng-model="IncludeInactive" \nng-true-value="1" ng-false-value="0">Include Inactive Records</md-checkbox></md-input-container></div><div \nlayout="row" layout-align="end center" class="layout-align-end-center layout-row"><md-input-container class="md-block" \nflex><label>Type</label> <input type="text" name="Type" ng-model="Type" placeholder="Type"></md-input-container>\n<md-input-container class="md-block" flex><label>Number of Pilots</label> <input type="text" name="Type" \nng-model="NumberPilots" placeholder="Type"></md-input-container></div><md-input-container class="md-block" flex><label>\nType Rating Required</label><md-select ng-model="TypeRating" placeholder="Type Rating Required"><md-option value="">---\n</md-option><md-option value="Yes" selected="selected">Yes</md-option><md-option value="No">No</md-option></md-select>\n<div class="md-errors-spacer"></div></md-input-container><div layout="column" layout-gt-sm="column" \nclass="date-time-picker"><div flex><label>Date Refurbished</label></div><div layout="column" layout-gt-sm="row"><div \nflex-gt-md="66" flex="100" layout="row"><div flex class="date-container date"><mdp-date-picker mdp-placeholder="Date" \nmdp-format="DD/MM/YYYY" mdp-open-on-click="true" ng-model="date"></mdp-date-picker></div><div flex \nclass="date-container time"><mdp-time-picker mdp-placeholder="Time" mdp-auto-switch="true" mdp-open-on-click="true" \nng-model="date"></mdp-time-picker></div></div></div></div><div layout="row" layout-align="start start">\n<md-input-container class="md-block" flex="45"><label>Post time using Hobbs</label><md-select ng-model="posttime" \nplaceholder="Post time using Hobbs"><md-option value="">---</md-option><md-option value="Yes" selected="selected">Yes\n</md-option><md-option value="No">No</md-option></md-select><div class="md-errors-spacer"></div></md-input-container>\n<div layout="column" layout-gt-sm="column" class="date-time-picker" flex="65"><div layout="column" layout-gt-sm="row">\n<div flex-gt-md="100" flex="100" layout="row"><div flex class="date-container date" layout="row" \nlayout-align="center center"><label>Yes, as of</label><mdp-date-picker mdp-placeholder="Date" mdp-format="DD/MM/YYYY" \nmdp-open-on-click="true" ng-model="yesasof"></mdp-date-picker></div></div></div></div></div><md-input-container \nclass="md-block" flex><label>Make</label><md-select ng-model="make" placeholder="Make"><md-option value="">---\n</md-option><md-option value="BOMBARDIER" selected="selected">BOMBARDIER</md-option></md-select><div \nclass="md-errors-spacer"></div></md-input-container><md-input-container class="md-block" flex><label>Model</label>\n<md-select ng-model="model" placeholder="Model"><md-option value="">---</md-option><md-option value="CHALLENGER 604" \nselected="selected">CHALLENGER 604</md-option></md-select><div class="md-errors-spacer"></div></md-input-container>\n<md-input-container class="md-block" flex><label>e-Calendar Addr</label> <input type="text" name="e-Calendar Addr" \nng-model="eCalendaraddr" placeholder="e-Calendar Addr"></md-input-container><md-input-container class="md-block" flex>\n<label>Category</label><md-select ng-model="Category" placeholder="Category"><md-option value="">---</md-option>\n<md-option value="AIRPLANE" selected="selected">AIRPLANE</md-option></md-select><div class="md-errors-spacer"></div>\n</md-input-container><md-input-container class="md-block" flex><label>Class</label><md-select ng-model="Class" \nplaceholder="Class"><md-option value="">---</md-option><md-option value="MEL" selected="selected">MEL</md-option>\n</md-select><div class="md-errors-spacer"></div></md-input-container><md-input-container class="md-block" flex><label>\nGroup</label><md-select ng-model="Group" placeholder="Group"><md-option value="">---</md-option><md-option value="JET" \nselected="selected">JET</md-option></md-select><div class="md-errors-spacer"></div></md-input-container>\n<md-input-container class="md-block" flex><label>Fuel type</label><md-select ng-model="Fueltype" \nplaceholder="Fuel type"><md-option value="">---</md-option><md-option value="JET" selected="selected">JET</md-option>\n</md-select><div class="md-errors-spacer"></div></md-input-container><md-input-container class="md-block" flex><label>\nHome Base</label><md-select ng-model="HomeBase" placeholder="Home Base"><md-option value="">---</md-option><md-option \nvalue="KBJC" selected="selected">KBJC</md-option></md-select><div class="md-errors-spacer"></div></md-input-container>\n<md-input-container class="md-block" flex><label>MX Program</label><md-select ng-model="MXProgram" \nplaceholder="MX Program"><md-option value="">---</md-option><md-option value="NONE" selected="selected">NONE\n</md-option></md-select><div class="md-errors-spacer"></div></md-input-container><md-input-container class="md-block" \nflex><label>A/C Usage</label><md-select ng-model="ACUsage" placeholder="A/C Usage"><md-option value="">---</md-option>\n<md-option value="COMPANY" selected="selected">COMPANY</md-option></md-select><div class="md-errors-spacer"></div>\n</md-input-container><md-list-item class="md-toolbar-tools grey-100-bg" ng-if="fields.type==\'label\'"><h3 \nclass="grey-700-fg" ng-bind="fields.field_name"></h3></md-list-item><md-input-container class="md-block" \nng-if="fields.type==\'id_subsec\'" flex><label ng-bind="fields.field_name"></label><md-select \nng-model="vm.currentThread_Edit[fields.type]" placeholder="{{vm.currentThread_Edit[fields.field_name]}}"><md-option \nvalue="">---</md-option><md-option ng-repeat="opt in vm.getValuesReferencesSections(\'subsection\')" \nvalue="{{opt.id_subsec}}">{{opt.subsec}}</md-option></md-select><div class="md-errors-spacer"></div>\n</md-input-container><md-input-container class="md-block" ng-if="fields.type==\'id_cat\'" flex><label \nng-bind="fields.field_name"></label><md-select ng-model="vm.currentThread_Edit[fields.type]" \nplaceholder="{{vm.currentThread_Edit[fields.field_name]}}"><md-option value="">---</md-option><md-option \nng-repeat="opt in vm.getValuesReferencesSections(\'cat\')" value="{{opt.id_cat}}">{{opt.cat}}</md-option></md-select><div\n class="md-errors-spacer"></div></md-input-container><md-input-container class="md-block" \nng-if="fields.type==\'id_subcat\'" flex><label ng-bind="fields.field_name"></label><md-select \nng-model="vm.currentThread_Edit[fields.type]" placeholder="{{vm.currentThread_Edit[fields.field_name]}}"><md-option \nvalue="">---</md-option><md-option ng-repeat="opt in vm.getValuesReferencesSections(\'subcat\')" \nvalue="{{opt.id_subcat}}">{{opt.subcat}}</md-option></md-select><div class="md-errors-spacer"></div>\n</md-input-container><md-input-container class="md-block" ng-if="fields.category==\'input_related\'" flex><label \nng-bind="fields.field_name"></label><md-select ng-model="vm.currentThread_Edit[fields.titleId]" \nplaceholder="{{vm.currentThread_Edit[fields.field_name]}}"><md-option value="">---</md-option><md-option \nng-repeat="opt in fields.values" ng-value="opt.id_{{fields.config}}">{{opt[fields.config]}}</md-option></md-select><div\n class="md-errors-spacer"></div></md-input-container><md-input-container class="md-block" ng-if="fields.type==\'text\'" \nflex><label ng-bind="fields.field_name"></label> <textarea ng-model="vm.currentThread_Edit[fields.titleId]" \ncolumns="1" rows="1"></textarea></md-input-container><md-input-container class="md-block" \nng-if="fields.type==\'status\'" flex><md-checkbox class="no-label" aria-label="{{fields.field_name}}" \nng-model="vm.currentThread_Edit[fields.titleId]" ng-true-value="1" ng-false-value="0">{{fields.field_name}}\n</md-checkbox></md-input-container><md-input-container class="md-block on-off" ng-if="fields.type==\'onoff\'" flex>\n<button ng-if="vm.currentThread_Edit[fields.titleId] ===1" class="md-icon-button md-button" \nng-click="vm.toggleItemStatusEdit(fields.titleId)"><md-icon md-font-icon="icon-checkbox-marked-circle" \nclass="on green-fg s24"></md-icon></button> <button ng-if="vm.currentThread_Edit[fields.titleId] !==1" \nclass="md-icon-button md-button" ng-click="vm.toggleItemStatusEdit(fields.titleId)"><md-icon \nmd-font-icon="icon-checkbox-blank-circle-outline" class="off red-fg s24"></md-icon></button></md-input-container>\n<md-input-container class="md-block" ng-if="fields.type==\'language\'" flex><label ng-bind="fields.field_name"></label>\n<md-select ng-model="vm.currentThread_Edit[fields.titleId]" placeholder="{{vm.currentThread_Edit[fields.field_name]}}">\n<md-option value="">---</md-option><md-option ng-repeat="opt in vm.siteLanguages()" value="{{opt.id_lang}}">\n{{opt.lang_name}}</md-option></md-select><div class="md-errors-spacer"></div></md-input-container><md-input-container \nclass="md-block" ng-if="fields.type==\'single\' || fields.type==\'nume\'"><label ng-bind="fields.field_name"></label> \n<input type="text" name="{{fields.title}}" ng-model="vm.currentThread_Edit[fields.titleId]" \nplaceholder="{{fields.field_name}}"></md-input-container><div layout="column" layout-gt-sm="column" \nclass="date-time-picker" ng-if="fields.type==\'dateHm\' || fields.type==\'date\'"><div flex><label \nng-bind="fields.field_name"></label></div><div layout="column" layout-gt-sm="row"><div flex-gt-md="66" flex="100" \nlayout="row"><div flex class="date-container date"><mdp-date-picker mdp-placeholder="Date" \nmdp-format="{{vm.dateFormat}}" mdp-open-on-click="true" ng-model="vm.currentThread_Edit[fields.titleId].date" \nng-change="vm.updateDatePicker(fields.titleId)"></mdp-date-picker></div><div flex class="date-container time">\n<mdp-time-picker mdp-placeholder="Time" mdp-auto-switch="true" mdp-open-on-click="true" \nng-model="vm.currentThread_Edit[fields.titleId].date" ng-change="vm.updateDatePicker(fields.titleId)">\n</mdp-time-picker></div></div><div flex-gt-md="33" flex="100"><div flex class="date-container utc"><md-input-container \nclass="md-block"><label>UTC Date</label> <input type="text" ng-model="vm.currentThread_Edit[fields.titleId].utcShow" \ndisabled="disabled"></md-input-container></div></div></div></div><md-input-container flex \nclass="md-block md-input-has-value" ng-if="fields.type==\'html\'"><label ng-bind="fields.field_name"></label> <textarea \nui-tinymce="vm.tinymceOptions" ng-model="vm.currentThread_Edit[fields.titleId]" aria-label="{{fields.titleId}}">\n</textarea></md-input-container></div><div \nng-repeat="fields in vm.currentThread_ref | filter: {\'edit_editable\':1, \'edit_position\': \'!header\'} | orderBy:\'edit_sort\'">\n<md-list-item class="md-toolbar-tools grey-100-bg" ng-if="fields.type==\'label\'"><h3 class="grey-700-fg" \nng-bind="fields.field_name"></h3></md-list-item><md-input-container class="md-block" ng-if="fields.type==\'id_subsec\'" \nflex><label ng-bind="fields.field_name"></label><md-select ng-model="vm.currentThread_Edit[fields.type]" \nplaceholder="{{vm.currentThread_Edit[fields.field_name]}}"><md-option value="">---</md-option><md-option \nng-repeat="opt in vm.getValuesReferencesSections(\'subsection\')" value="{{opt.id_subsec}}">{{opt.subsec}}</md-option>\n</md-select><div class="md-errors-spacer"></div></md-input-container><md-input-container class="md-block" \nng-if="fields.type==\'id_cat\'" flex><label ng-bind="fields.field_name"></label><md-select \nng-model="vm.currentThread_Edit[fields.type]" placeholder="{{vm.currentThread_Edit[fields.field_name]}}"><md-option \nvalue="">---</md-option><md-option ng-repeat="opt in vm.getValuesReferencesSections(\'cat\')" value="{{opt.id_cat}}">\n{{opt.cat}}</md-option></md-select><div class="md-errors-spacer"></div></md-input-container><md-input-container \nclass="md-block" ng-if="fields.type==\'id_subcat\'" flex><label ng-bind="fields.field_name"></label><md-select \nng-model="vm.currentThread_Edit[fields.type]" placeholder="{{vm.currentThread_Edit[fields.field_name]}}"><md-option \nvalue="">---</md-option><md-option ng-repeat="opt in vm.getValuesReferencesSections(\'subcat\')" \nvalue="{{opt.id_subcat}}">{{opt.subcat}}</md-option></md-select><div class="md-errors-spacer"></div>\n</md-input-container><md-input-container class="md-block" ng-if="fields.category==\'input_related\'" flex><label \nng-bind="fields.field_name"></label><md-select ng-model="vm.currentThread_Edit[fields.titleId]" \nplaceholder="{{vm.currentThread_Edit[fields.field_name]}}"><md-option value="">---</md-option><md-option \nng-repeat="opt in fields.values" ng-value="opt.id_{{fields.config}}">{{opt[fields.config]}}</md-option></md-select><div\n class="md-errors-spacer"></div></md-input-container><md-input-container class="md-block" ng-if="fields.type==\'text\'" \nflex><label ng-bind="fields.field_name"></label> <textarea ng-model="vm.currentThread_Edit[fields.titleId]" \ncolumns="1" rows="1"></textarea></md-input-container><md-input-container class="md-block" \nng-if="fields.type==\'status\'" flex><md-checkbox class="no-label" aria-label="{{fields.field_name}}" \nng-model="vm.currentThread_Edit[fields.titleId]" ng-true-value="1" ng-false-value="0">{{fields.field_name}}\n</md-checkbox></md-input-container><md-input-container class="md-block on-off" ng-if="fields.type==\'onoff\'" flex>\n<button ng-if="vm.currentThread_Edit[fields.titleId] ===1" class="md-icon-button md-button"><md-icon \nmd-font-icon="icon-checkbox-marked-circle" class="on green-fg s24" ng-click="vm.toggleItemStatusEdit(fields.titleId)">\n</md-icon></button> <button ng-if="vm.currentThread_Edit[fields.titleId] !==1" class="md-icon-button md-button">\n<md-icon md-font-icon="icon-checkbox-blank-circle-outline" class="off red-fg s24" \nng-click="vm.toggleItemStatusEdit(fields.titleId)"></md-icon></button></md-input-container><md-input-container \nclass="md-block" ng-if="fields.type==\'language\'" flex><label ng-bind="fields.field_name"></label><md-select \nng-model="vm.currentThread_Edit[fields.titleId]" placeholder="{{vm.currentThread_Edit[fields.field_name]}}"><md-option \nvalue="">---</md-option><md-option ng-repeat="opt in vm.siteLanguages()" value="{{opt.id_lang}}">{{opt.lang_name}}\n</md-option></md-select><div class="md-errors-spacer"></div></md-input-container><md-input-container class="md-block" \nng-if="fields.type==\'single\' || fields.type==\'nume\'"><label ng-bind="fields.field_name"></label> <textarea \nng-model="vm.currentThread_Edit[fields.titleId]" columns="1" rows="1" placeholder="{{fields.field_name}}"></textarea>\n</md-input-container><md-input-container class="md-block" ng-if="fields.type == \'section\'"><label>{{fields.field_name}}\n</label><md-select ng-model="vm.currentThread_Edit[fields.titleId]" \nplaceholder="{{vm.currentThread_Edit[fields.field_name]}}"><md-option value="">---</md-option><md-option \nng-repeat="sec in vm.getShowAssoc(fields)" value="{{sec.id}}">{{sec.val}}</md-option></md-select><div \nclass="md-errors-spacer"></div></md-input-container><md-input-container class="md-block" \nng-if="fields.type == \'country\'"><label>{{fields.field_name}}</label><md-select \nng-model="vm.currentThread_Edit[fields.titleId]" placeholder="{{vm.currentThread_Edit[fields.field_name]}}"><md-option \nvalue="">---</md-option><md-option ng-repeat="sec in vm.getShowCountries(fields)" value="{{sec.id}}">{{sec.name}}\n</md-option></md-select><div class="md-errors-spacer"></div></md-input-container><div layout="column" \nlayout-gt-sm="column" class="date-time-picker" ng-if="fields.type==\'dateHm\' || fields.type==\'date\'"><div flex><label \nng-bind="fields.field_name"></label></div><div layout="column" layout-gt-sm="row"><div flex class="date-container">\n<mdp-date-picker mdp-placeholder="Date" mdp-format="{{vm.dateFormat}}" mdp-open-on-click="true" \nng-model="vm.currentThread_Edit[fields.titleId].date" ng-change="vm.updateDatePicker(fields.titleId)">\n</mdp-date-picker></div><div flex class="date-container"><mdp-time-picker mdp-placeholder="Time" \nmdp-auto-switch="true" mdp-open-on-click="true" ng-model="vm.currentThread_Edit[fields.titleId].date" \nng-change="vm.updateDatePicker(fields.titleId)"></mdp-time-picker></div><div flex class="date-container">\n<md-input-container class="md-block"><label>UTC Date</label> <input type="text" \nng-model="vm.currentThread_Edit[fields.titleId].utcShow" disabled="disabled"></md-input-container></div></div></div>\n<md-input-container flex class="md-block md-input-has-value" ng-if="fields.type==\'html\'"><label \nng-bind="fields.field_name"></label> <textarea ui-tinymce="vm.tinymceOptions" \nng-model="vm.currentThread_Edit[fields.titleId]" aria-label="{{fields.titleId}}"></textarea></md-input-container></div>\n<div class="tags"><md-input-container class="md-block"><label translate="GLOBAL.TAGS">Tags</label><md-chips \nclass="label-chips" ng-model="vm.currentThread_Edit.tags" md-autocomplete-snap md-require-match="true"><md-autocomplete\n md-min-length="3" md-selected-item="vm.selectedTag" md-search-text="vm.searchTagText" \nmd-items="tag in vm.labelQuerySearch(vm.searchTagText)" md-item-text="tag.tag_name" md-no-cache="true" \nplaceholder="Search for a Tag" ng-model-options="{debounce: 500}"><span md-highlight-text="vm.searchTagText">\n{{tag.tag_name}}</span><md-not-found><span translate="GLOBAL.TAGNOTFOUND"></span> <a \nng-click="vm.newTag(vm.searchTagText)" translate="GLOBAL.TAGADDIT"></a></md-not-found></md-autocomplete>\n<md-chip-template><div class="md-chip-content"><span ng-if="$chip.color" class="color" \nng-style="{\'background-color\':$chip.color}"></span> <span>{{$chip.tag_name}}</span></div></md-chip-template><button \nmd-chip-remove class="md-primary md-chip-remove" layout="row" layout-align="center center"><md-icon \nmd-font-icon="icon-close" class="s18"></md-icon></button></md-chips></md-input-container></div><div layout="row" \nlayout-align="end center" class="layout-align-end-center layout-row"><md-button type="submit" \nng-if="vm.currentThread_Edit" ng-click="vm.saveItem(vm.currentThread_Edit)" class="send-button md-accent md-raised" \nng-disabled="vm.basicForm.$invalid || vm.basicForm.$pristine" aria-label="SAVE" translate="GLOBAL.SAVE" \ntranslate-attr-aria-label="GLOBAL.SAVE">SAVE</md-button><md-button type="button" ng-click="vm.closeThreadEdit()" \nclass="md-raised md-warn" aria-label="Cancel">Cancel</md-button></div></form></div>');
$templateCache.put('app/main/apps/aircrafts/views/outlook/detail/tab-endurance.html','<div class="form-wrapper md-whiteframe-1dp" flex="100"><form name="vm.basicForm" class="md-inline-form" novalidate>\n<div><div layout="row" layout-align="end center" class="layout-align-end-center layout-row"><md-input-container \nclass="md-block" flex><label>Avg. Climb Speed (KTS)</label> <input type="text" name="Avg. Climb Speed (KTS)" \nng-model="avgclimb" placeholder="Avg. Climb Speed (KTS)"></md-input-container><md-input-container class="md-block" \nflex><label>Cruise Altitude (MSL X00)</label> <input type="text" name="Cruise Altitude (MSL X00)" \nng-model="cruisealtitude" placeholder="Cruise Altitude (MSL X00)"></md-input-container><md-input-container \nclass="md-block" flex><label>Max. Takeoff Weight</label> <input type="text" name="Max. Takeoff Weight" \nng-model="maxtakeoff" placeholder="Max. Takeoff Weight"></md-input-container></div><div layout="row" \nlayout-align="end center" class="layout-align-end-center layout-row"><md-input-container class="md-block" flex><label>\nAvg. Climb Rate (FPM)</label> <input type="text" name="Avg. Climb Rate (FPM)" ng-model="avgclimbrate" \nplaceholder="Avg. Climb Rate (FPM)"></md-input-container><md-input-container class="md-block" flex><label>\nHours Cruise Range</label> <input type="text" name="Hours Cruise Range" ng-model="cruiserange" \nplaceholder="Hours Cruise Range"></md-input-container><md-input-container class="md-block" flex><label>Max. Fuel Weight\n</label> <input type="text" name="Max. Fuel Weight" ng-model="maxfuelweight" placeholder="Max. Fuel Weight">\n</md-input-container></div><div layout="row" layout-align="end center" class="layout-align-end-center layout-row">\n<md-input-container class="md-block" flex><label>Avg. Descent Speed (KTS)</label> <input type="text" \nname="Avg. Descent Speed (KTS)" ng-model="avgdescent" placeholder="Avg. Descent Speed (KTS)"></md-input-container>\n<md-input-container class="md-block" flex><label>Cruise Fuel Flow (Lbs/Hr)</label> <input type="text" \nname="Cruise Fuel Flow (Lbs/Hr)" ng-model="cruisefuelflow" placeholder="Cruise Fuel Flow (Lbs/Hr)">\n</md-input-container><md-input-container class="md-block" flex><label>Avg. Cargo Weight</label> <input type="text" \nname="Avg. Cargo Weight" ng-model="avgcargoweight" placeholder="Avg. Cargo Weight"></md-input-container></div><div \nlayout="row" layout-align="end center" class="layout-align-end-center layout-row"><md-input-container class="md-block" \nflex><label>Avg. Descent Rate (FPM)</label> <input type="text" name="Avg. Descent Rate (FPM)" \nng-model="avgdescentrate" placeholder="Avg. Descent Rate (FPM)"></md-input-container><md-input-container \nclass="md-block" flex><label>Basic Operating Weight</label> <input type="text" name="Basic Operating Weight" \nng-model="basicoperating" placeholder="Basic Operating Weight"></md-input-container><md-input-container \nclass="md-block" flex><label>PayLoad</label> <input type="text" name="PayLoad" ng-model="payload" \nplaceholder="PayLoad"></md-input-container></div><div layout="row" layout-align="end center" \nclass="layout-align-end-center layout-row"><md-input-container class="md-block" flex><label>True Air Speed</label> \n<input type="text" name="True Air Speed" ng-model="trueairspeed" placeholder="True Air Speed"></md-input-container>\n<md-input-container class="md-block" flex><label>Avg. Pax Weight</label> <input type="text" name="Avg. Pax Weight" \nng-model="avgpaxweight" placeholder="Avg. Pax Weight"></md-input-container><md-input-container class="md-block" flex>\n<label>Min. Runway Length</label> <input type="text" name="Min. Runway Length" ng-model="minrunway" \nplaceholder="Min. Runway Length"></md-input-container></div></div></form></div>');
$templateCache.put('app/main/apps/clients/views/read/form-tabs/step-branchs.html','<div layout="column" layout-gt-xs="row"><md-input-container flex><h1 translate="GLOBAL.MAIN_BRANCH"></h1>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="GLOBAL.NAME"></label> <input ng-model="vm.formWizard.main_branch.name" type="text"></md-input-container>\n<md-input-container flex><label translate="GLOBAL.ADDRESS"></label> <input \nng-model="vm.formWizard.main_branch.address1" type="text" required></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container flex><label>{{vm.getRegionLiteral(\'city\')}}</label> <input \nng-model="vm.formWizard.main_branch.city" type="text" required></md-input-container><md-input-container flex><label>\n{{vm.getRegionLiteral(\'state\')}}</label> <input ng-model="vm.formWizard.main_branch.state" type="text" required>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="GLOBAL.POSTAL_CODE"></label> <input ng-model="vm.formWizard.main_branch.postcode" type="text" required>\n</md-input-container><md-input-container flex><label translate="GLOBAL.PHONE"></label> <input \nng-model="vm.formWizard.main_branch.phone" type="text"></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container flex><label translate="GLOBAL.EMAIL"></label> <input \nng-model="vm.formWizard.main_branch.email" type="text"></md-input-container><md-input-container flex>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container class="group-form" flex="100" \nflex-gt-xs="100"><div layout="row" layout-align="start center"><h1 translate="GLOBAL.BRANCH"></h1><md-button \nng-click="vm.openDialogForm(\'branch\')" class="ml-10 md-mini add-event-button md-fab md-warn"><md-icon \nmd-font-icon="icon-plus"></md-icon></md-button></div><div class="mail-list-pane s0" \nng-if="vm.formWizard.branch && vm.formWizard.branch.length > 0"><div class="items" ng-if="!branch.is_main" \nng-repeat="branch in vm.formWizard.branch"><div layout="row" layout-align="start center" flex="100" class="p-20"><div \nlayout="row" layout-align="start center" flex="90"><div class="avatar-wrapper"><md-icon md-font-icon="icon-city">\n</md-icon></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding" \nng-bind-html="branch.name"></strong><div class="field grey-600-fg ng-binding"><span ng-if="branch.city" \nng-bind-html="branch.city"></span> <span ng-if="branch.city && branch.state">, </span><span ng-if="branch.state" \nng-bind-html="branch.state"></span></div></div></div><div class="menu" flex="10" layout-align="center end" \nlayout="column"><md-menu class="float-right"><md-button class="md-icon-button" aria-label="More" \nng-click="vm.openMenu($mdMenu, $event)"><md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg">\n</md-icon></md-button><md-menu-content width="2"><md-menu-item><md-button translate="GLOBAL.EDIT" \nng-click="vm.editBranchDialog($event, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div></md-input-container></div>');
$templateCache.put('app/main/apps/clients/views/read/form-tabs/step-company.html','<div layout="column" layout-gt-xs="row"><md-input-container flex><label translate="GLOBAL.SOCIAL_REASON"></label> \n<input type="text" ng-model="vm.formWizard.company.name" required></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container flex><label>{{vm.getRegionLiteral(\'tax_ic_number\')}}</label> <input type="text" \nng-model="vm.formWizard.company.tax_id_number"></md-input-container><md-input-container flex><label \ntranslate="GLOBAL.SECTOR"></label><md-select ng-model="vm.formWizard.company.sector_id"><md-option \nng-repeat="sector in vm.sectors track by $index" ng-value="sector.id">{{sector.name}}</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="GLOBAL.REGION"></label><md-select ng-model="vm.formWizard.company.region_id"><md-option \nng-repeat="region in vm.regions track by $index" ng-value="region.id">{{region.name}}</md-option></md-select>\n</md-input-container><md-input-container flex></md-input-container></div><div layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container><p class="mt-0 grey-400-fg" translate="GLOBAL.LOGOTYPE"></p><div \nclass="header simple relative" ng-if="image || imageUrl" layout="row" layout-align="space-between center"><md-menu>\n<button class="md-icon-button" aria-label="More"><div layout="column" layout-align="start center" \nng-click="$mdMenu.open($event)"><div class="media" flex layout="row" layout-align="center center"><img \nngf-thumbnail="!image.$error && image" class="image"> <img ng-if="!image && imageUrl" src="{{imageUrl}}" class="image">\n</div><md-button class="md-mini add-event-button no-sort md-fab md-warn block absolute-top-right" \naria-label="Add event"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button></div></button><md-menu-content\n width="3"><md-menu-item><md-button ng-click="vm.deleteLogotype()" aria-label="Toggle done" \ntranslate-attr-aria-label="GLOBAL.REMOVE"><md-icon md-font-icon="icon-close" class="s18"></md-icon><span \ntranslate="GLOBAL.REMOVE"></span></md-button></md-menu-item></md-menu-content></md-menu></div><div \nng-if="!image && !imageUrl" ng-click="vm.mediaDialogSingle($event, vm.formWizard.company.logotype)" class="relative">\n<img src="assets/images/logos/generic-logo.png" class="image"><md-button \nclass="md-mini add-event-button no-sort md-fab md-warn block absolute-top-right" aria-label="Add event" translate \ntranslate-attr-aria-label="CALENDAR.ADD_EVENT"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n</md-input-container></div>');
$templateCache.put('app/main/apps/clients/views/read/form-tabs/step-options.html','<div class="options"><div layout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container \nfill-width flex><label translate="GLOBAL.DESCRIPTION"></label> <input type="text" \nng-model="vm.formWizard.company.description"></md-input-container><md-input-container fill-width flex><label \ntranslate="GLOBAL.COMPANY_TYPE"></label><md-select ng-model="vm.formWizard.company.extra_data.company_type"><md-option \nng-value="1">SA</md-option><md-option ng-value="2">SL</md-option><md-option ng-value="3">Cotizada</md-option><md-option\n ng-value="4">Fundaciones/asociaciones</md-option><md-option ng-value="5">Otras</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container\n fill-width flex><label translate="GLOBAL.EXECUTIVE_TYPE"></label><md-select \nng-model="vm.formWizard.company.extra_data.executives_type"><md-option ng-value="1">Accionista \xFAnico</md-option>\n<md-option ng-value="2">Varios accionistas</md-option><md-option ng-value="3">Consejo de administraci\xF3n</md-option>\n<md-option ng-value="4">Administrador \xFAnico</md-option><md-option ng-value="5">Otros</md-option></md-select>\n</md-input-container><md-input-container fill-width flex><label translate="GLOBAL.SOCIAL_CAPITAL"></label><md-select \nng-model="vm.formWizard.company.extra_data.capital"><md-option ng-value="1">Capital</md-option><md-option ng-value="2">\nAportaciones de socios</md-option><md-option ng-value="3">Aumentos de capital recientes</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container\n fill-width flex><label translate="GLOBAL.AMOUNT_CAPITAL"></label> <input type="number" type="text" \nng-model="vm.formWizard.company.extra_data.capital_amount"></md-input-container><md-input-container fill-width flex>\n<label translate="GLOBAL.BILLING_LAST_YEAR"></label> <input type="number" \nng-model="vm.formWizard.company.turnover_volume"></md-input-container></div><div layout="column" layout-gt-xs="row" \nflex layout-align="start center"><md-input-container fill-width flex><label>Cuentas anuales</label><md-select \nng-model="vm.formWizard.company.extra_data.annual_accounts"><md-option ng-value="1">Abreviadas</md-option><md-option \nng-value="2">Normales</md-option><md-option ng-value="3">Pymes</md-option><md-option ng-value="4">Mixtas</md-option>\n</md-select></md-input-container><md-input-container fill-width flex><label>Auditor\xEDas</label><md-select \nng-model="vm.formWizard.company.extra_data.audits"><md-option ng-value="1">Internas</md-option><md-option ng-value="2">\nExternas</md-option><md-option ng-value="3">No aplica</md-option></md-select></md-input-container></div><div \nlayout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container fill-width flex><label>\nCertificaciones ISO</label><md-select ng-model="vm.formWizard.company.extra_data.iso_certification"><md-option \nng-value="1">ISO 9001</md-option><md-option ng-value="2">ISO 14000</md-option><md-option ng-value="3">ISO 14001\n</md-option><md-option ng-value="4">ISO 19600</md-option><md-option ng-value="5">ISO 22000</md-option><md-option \nng-value="6">ISO 26000</md-option><md-option ng-value="7">ISO 27001</md-option><md-option ng-value="8">ISO 37001\n</md-option><md-option ng-value="9">OHSAS 18001</md-option></md-select></md-input-container><md-input-container \nfill-width flex><label>Convenio Colectivo Aplicable</label> <input type="text" \nng-model="vm.formWizard.company.extra_data.collective_agreement"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" flex layout-align="start center"><md-input-container fill-width flex><label>Seguros contratados\n</label> <input type="text" ng-model="vm.formWizard.company.extra_data.insurance"></md-input-container>\n<md-input-container fill-width flex><label translate="GLOBAL.CNAE"></label> <input type="text" \nng-model="vm.formWizard.company.extra_data.cnae"></md-input-container></div><div layout="column" layout-gt-xs="row" \nflex layout-align="start center"><md-input-container fill-width layout="row" layout-align="start center" flex><label \nclass="ph-15" fill-width translate="GLOBAL.FINANCING"></label><md-select flex \nng-init="!vm.formWizard.company.extra_data.financing ? vm.formWizard.company.extra_data.financing = [] : null;" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.financing"><md-option \nng-repeat="option in vm.financing_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container><md-input-container fill-width layout="row" layout-align="start center" flex><label class="ph-15" \nfill-width>Normativa Sectorial aplicable</label><md-select flex \nng-init="!vm.formWizard.company.extra_data.sector_regulations ? vm.formWizard.company.extra_data.sector_regulations = [] : null;" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.sector_regulations"><md-option \nng-repeat="option in vm.sector_regulations_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-align="start center"><md-input-container \nfill-width layout="row" layout-align="start center" flex><label class="ph-15" fill-width>Medidas implementadas</label>\n<md-select flex \nng-init="!vm.formWizard.company.extra_data.implemented_measures ? vm.formWizard.company.extra_data.implemented_measures = [] : null;" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.implemented_measures"><md-option \nng-repeat="option in vm.implemented_measures_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container></div><div class="separator-options" layout="row"><h2>Grupo de sociedades?</h2><md-input-container\n fill-width layout="row" layout-align="start center" flex class="mb-0"><md-checkbox \nng-checked="vm.formWizard.company.extra_data.belogns_to_holding" \nng-model="vm.formWizard.company.extra_data.belogns_to_holding"></md-checkbox></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-align="start center"></div><div \nng-if="vm.formWizard.company.extra_data.belogns_to_holding" layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container fill-width flex><label>Nombre corporaci\xF3n</label> <input type="text" \nng-model="vm.formWizard.company.extra_data.name_corporation"></md-input-container><md-input-container fill-width flex>\n<label>CIF corporaci\xF3n</label> <input type="text" ng-model="vm.formWizard.company.extra_data.cif_corporation">\n</md-input-container></div><div class="mv-25" ng-if="vm.formWizard.company.extra_data.belogns_to_holding" \nlayout="column" layout-gt-xs="row" layout-align="start center"><div fill-width><div ngf-drop ngf-select \nng-model="vm.files_belogns_to_holding" class="drop-box" layout="column" layout-gt-xs="row" \nngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="belogns_to_holding_isLoading"><div flex layout="column" layout-align="center center" layout-padding \nlayout-margin class="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30">\n</md-progress-circular></div></div></div><div layout="column" flex><div \nng-repeat="f in vm.formWizard.company.extra_data.belogns_to_holding_files track by $index" class="border-bottom" flex>\n<div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><div class="media photos" layout="row" layout-align="center center"><h2c-icon \nfile="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" alt=""></div><div class="info ml-15" flex \nlayout="column" layout-align="center center"><div class="name" layout="row" layout-align="center center"><span \nng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu class="float-right"><md-button \nclass="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.belogns_to_holding_files.splice($index, 1);"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></div></div></div><div class="separator-options" \nlayout="row"><h2>Responsabilidad social corporativa?</h2><md-input-container fill-width layout="row" \nlayout-align="start center" flex class="mb-0"><md-checkbox \nng-checked="vm.formWizard.company.extra_data.social_responsability" \nng-model="vm.formWizard.company.extra_data.social_responsability"></md-checkbox></md-input-container></div><div \nclass="mv-25" ng-if="vm.formWizard.company.extra_data.social_responsability" layout="column" layout-gt-xs="row" \nlayout-align="start center"><div fill-width><div ngf-drop ngf-select ng-model="vm.files_social_responsability" \nclass="drop-box" layout="column" layout-gt-xs="row" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" \nngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="social_responsability_isLoading"><div flex layout="column" layout-align="center center" layout-padding \nlayout-margin class="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30">\n</md-progress-circular></div></div></div><div layout="column" flex><div \nng-repeat="f in vm.formWizard.company.extra_data.social_responsability_files track by $index" class="border-bottom" \nflex><div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><div class="media photos" layout="row" layout-align="center center"><h2c-icon \nfile="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" alt=""></div><div class="info ml-15" flex \nlayout="column" layout-align="center center"><div class="name" layout="row" layout-align="center center"><span \nng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu class="float-right"><md-button \nclass="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.social_responsability_files.splice($index, 1);"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></div></div></div><div class="separator-options" \nlayout="row"><h2>IVA</h2></div><div class="mv-25" layout="column"><div layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container fill-width flex><md-select \nng-model="vm.formWizard.company.extra_data.tax_options"><md-option ng-value="1">Presentaci\xF3n trimestral</md-option>\n<md-option ng-value="2">Presentaci\xF3n mensual</md-option></md-select></md-input-container><md-input-container \nfill-width flex></md-input-container></div><div layout="column" layout-gt-xs="row" layout-align="start center"><div \nfill-width><div ngf-drop ngf-select ng-model="vm.files_iva" class="drop-box" layout="column" layout-gt-xs="row" \nngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="iva_isLoading"><div flex layout="column" layout-align="center center" layout-padding layout-margin \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n</div></div><div layout="column" flex><div ng-repeat="f in vm.formWizard.company.extra_data.iva_files track by $index" \nclass="border-bottom" flex><div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size" layout="row" layout-align="start left"><div class="media photos" layout="row" \nlayout-align="center center"><h2c-icon file="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" \nalt=""></div><div class="info ml-15" flex layout="column" layout-align="center center"><div class="name" layout="row" \nlayout-align="center center"><span ng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.iva_files.splice($index, 1);"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div></div></div></div></div><div class="separator-options" layout="row"><h2>\nImpuesto de sociedades</h2></div><div class="mv-25" layout="column"><div layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container fill-width flex><md-datepicker \nng-model="vm.formWizard.company.extra_data.date_is" md-placeholder="Fecha"></md-datepicker></md-input-container>\n<md-input-contaimer class="md-block" flex><md-select ng-model="vm.formWizard.company.extra_data.currency_is" \nplaceholder="{{ \'GLOBAL.CURRENCY\' |\xA0translate}}"><md-option ng-repeat="currency in vm.currencies" \nng-value="currency.id">{{currency.symbol}}</md-option></md-select></md-input-contaimer><md-input-container fill-width \nflex><label translate="GLOBAL.AMOUNT_CAPITAL"></label> <input type="number" type="text" \nng-model="vm.formWizard.company.extra_data.amount_is"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-align="start center"><div fill-width><div ngf-drop ngf-select ng-model="vm.files_is" \nclass="drop-box" layout="column" layout-gt-xs="row" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" \nngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="is_isLoading"><div flex layout="column" layout-align="center center" layout-padding layout-margin \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n</div></div><div layout="column" flex><div ng-repeat="f in vm.formWizard.company.extra_data.is_files track by $index" \nclass="border-bottom" flex><div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size" layout="row" layout-align="start left"><div class="media photos" layout="row" \nlayout-align="center center"><h2c-icon file="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" \nalt=""></div><div class="info ml-15" flex layout="column" layout-align="center center"><div class="name" layout="row" \nlayout-align="center center"><span ng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.is_files.splice($index, 1);"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/clients/views/read/form-tabs/step-people-global.html','<div layout="column" layout-gt-xs="row"><div class="mail-list-pane s0" flex="100"><div layout-gt-xs="row" \nlayout="column" class="mb-20"><div flex="20"><div layout="row" layout-align="start center" flex="100" \nclass="p-20 layout-align-start-center layout-row flex-100"><div layout="row" layout-align="start center" flex="100" \nclass="layout-align-start-center layout-row flex-100"><div class="avatar-wrapper"><md-icon md-font-icon="icon-city">\n</md-icon></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding" \nng-bind-html="vm.formWizard.main_branch.name"></strong><div class="field grey-600-fg ng-binding"><span \nng-if="vm.formWizard.main_branch.city" ng-bind-html="vm.formWizard.main_branch.city"></span> <span \nng-if="vm.formWizard.main_branch.city && vm.formWizard.main_branch.state">, </span><span \nng-if="vm.formWizard.main_branch.state" ng-bind-html="vm.formWizard.main_branch.state"></span></div></div></div></div>\n</div><div flex="80"><div layout="row" layout-align="start center"><div class="mail-list-pane s0" flex="100"><div \nclass="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="user.branch_id == vm.formWizard.main_branch.id"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId != user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong><div class="field grey-600-fg ng-binding"><span>\n{{vm.getDivisionName(user.division)[0].name}} | {{vm.getPositionName(user.position)[0].name}}</span></div></div></div>\n</div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu class="float-right">\n<md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" \nng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\', vm.formWizard.main_branch)"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div><div class="items"><div layout="row" \nlayout-align="start center" flex="100" class="pt-10 pb-10"><div class="info" flex layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><md-button \nng-click="vm.openDialogForm(\'personnel\', vm.formWizard.main_branch.id)" \nclass="md-mini add-event-button md-fab md-warn mh-0"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n</div></div></div></div></div></div></div></div></div><div layout-gt-xs="row" layout="column" class="mb-20" \nng-repeat="branch in vm.formWizard.branch" ng-if="branch.id != vm.formWizard.main_branch.id"><div flex="20"><div \nlayout="row" layout-align="start center" flex="100" class="p-20 layout-align-start-center layout-row flex-100"><div \nlayout="row" layout-align="start center" flex="100" class="layout-align-start-center layout-row flex-100"><div \nclass="avatar-wrapper"><md-icon md-font-icon="icon-city"></md-icon></div><div class="field mr-10 ml-10 flex" flex="">\n<strong class="grey-800-fg ng-binding" ng-bind-html="branch.name"></strong><div class="field grey-600-fg ng-binding">\n<span ng-if="branch.city" ng-bind-html="branch.city"></span> <span ng-if="branch.city && branch.state">, </span><span \nng-if="branch.state" ng-bind-html="branch.state"></span></div></div></div></div></div><div flex="80"><div layout="row" \nlayout-align="start center"><div class="mail-list-pane s0" flex="100"><div class="items" \nng-repeat="user in vm.formWizard.personnel track by $index" ng-if="user.branch_id == branch.id"><div layout="row" \nlayout-align="start center" flex="100" class="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" \nlayout="column"><div class="name" layout="row"><div layout="row" layout-align="start center" flex="100"><div \nclass="avatar-wrapper"><user-avatar ng-if="uploadingFotoUserId != user.id" user="user"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong><div class="field grey-600-fg ng-binding"><span>\n{{vm.getDivisionName(user.division)[0].name}} | {{vm.getPositionName(user.position)[0].name}}</span></div></div></div>\n</div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu class="float-right">\n<md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\', branch)">\n<md-icon md-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div><div class="items"><div layout="row" \nlayout-align="start center" flex="100" class="pt-10 pb-10"><div class="info" flex layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><md-button \nng-click="vm.openDialogForm(\'personnel\', branch.id)" class="md-mini add-event-button md-fab md-warn mh-0"><md-icon \nmd-font-icon="icon-plus"></md-icon></md-button></div></div></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/clients/views/read/form-tabs/step-people.html','<div layout="column" layout-gt-xs="row"><div style="padding: 0px 15px;" flex layout="column"><h1>Direcci\xF3n</h1><div \nlayout="column" layout-gt-xs="row"><md-input-container class="group-form" flex="100" flex-gt-xs="100"><div \nlayout="row" layout-align="start center"><h2 translate="GLOBAL.LEGAL_MANAGER"></h2><md-button \nng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'managerLegal\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n<div class="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'managerLegal\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId !== user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container class="group-form" flex="100" flex-gt-xs="100"><div layout="row" \nlayout-align="start center"><h2 translate="GLOBAL.ADMINISTRATOR"></h2><md-button \nng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'administrator\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n<div class="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'administrator\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId !== user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container></div></div><div \nstyle="padding: 0px 15px;" flex layout="column"><h1>Compliance</h1><md-input-container class="group-form" flex="100" \nflex-gt-xs="100"><h2 translate="GLOBAL.COMPLIANCE_OFFICER" style="display: inline-block;"></h2><md-button \nng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'compliance_officer\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'compliance_officer\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId !== user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container><md-input-container \nclass="group-form" flex="100" flex-gt-xs="100"><h2 translate="GLOBAL.COLLABORATOR" style="display: inline-block;"></h2>\n<md-button ng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'collaborator\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'collaborator\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId != user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container><md-input-container \nclass="group-form" flex="100" flex-gt-xs="100"><h2 translate="GLOBAL.REPORT_COMMITTEE" style="display: inline-block;">\n</h2><md-button ng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'compliance_comite\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'compliance_comite\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId !== user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container><md-input-container \nclass="group-form" flex="100" flex-gt-xs="100"><h2 translate="GLOBAL.DELEGATE_DATA_PROTECCTION" \nstyle="display: inline-block;"></h2><md-button ng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'data_protection\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'data_protection\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId != user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container></div></div>');
$templateCache.put('app/main/apps/clients/dialogs/image/views/fotorama-view.html','<div class="content-wrapper" flex layout="row"><div class="mail-tabs-grid" flex \nmd-dynamic-height="{{vm.dynamicHeight}}"><fotorama options="vm.fotoramaoptions" items="vm.dataFotorama" id="fotorama">\n</fotorama></div></div>');
$templateCache.put('app/main/apps/clients/dialogs/media/views/audios-view.html','<div class="content-wrapper" flex="" layout="row"><div class="mail-tabs-grid" flex \nmd-dynamic-height="{{vm.dynamicHeight}}"><div class="content mail-list-pane-grid" flex ms-scroll><div \nng-repeat="item in vm.items" class="ms-card" flex><div class="ms-card-content-wrapper"><div class="template-9"><div \nclass="media" flex layout="row" layout-align="center center"><div flex layout="column" layout-align="center center" \nclass="media"><media attachment="item" class=""></media><br><span class="grey-500-fg" layout="column" \nlayout-align="center center"><span ng-if="item.title"><strong>{{item.title}}</strong></span> <span \nng-if="item.filename">{{item.filename}}</span></span></div></div><div class="header p-16" flex><div layout="row" \nlayout-align="space-between center" flex><div class="size text-truncate" layout="row" layout-align="start left"><strong\n class="mr-5">#{{item.id_media}}</strong> <span class="grey-500-fg"><span ng-if="item.date_uploaded">\n{{item.date_uploaded}}</span></span></div><md-checkbox ng-checked="vm.alreadySelectedbyZone(vm.selectedImages, item)" \nng-click="vm.toggleSelectedImages(item, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, item) ? \'Deselect\' : \'Select\'}}" class="ml-5"></md-checkbox>\n</div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/clients/dialogs/media/views/files-view.html','<div class="content-wrapper" flex="" layout="row"><div class="mail-tabs-grid" flex=""><div \nclass="content mail-list-pane-grid" flex="" ms-scroll=""><div ng-repeat="item in vm.items" class="ms-card" flex><div \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><div flex layout="column" layout-align="center center" class="media"><media \nattachment="item" class=""></media><br><span class="grey-500-fg" layout="column" layout-align="center center"><span \nng-if="item.title"><strong>{{item.title}}</strong></span> <span ng-if="item.filename">{{item.filename}}</span></span>\n</div></div><div class="header p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size text-truncate" layout="row" layout-align="start left"><strong class="mr-5">#{{item.id_media}}</strong>\n</div><md-checkbox ng-checked="vm.alreadySelectedbyZone(vm.selectedImages, item)" \nng-click="vm.toggleSelectedImages(item, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, item) ? \'Deselect\' : \'Select\'}}" class="ml-5"></md-checkbox>\n</div></div></div></div></div></div></div></div><div layout="column" layout-align="center center"></div>');
$templateCache.put('app/main/apps/clients/dialogs/media/views/import-view.html','<div class="content-wrapper" flex layout="column"><div class="content"><div class="drop-box"><md-input-container \nclass="md-block"><label>Paste the url to import:</label> <input type="text" name="import_field" \nng-model="vm.import_field" placeholder="" ng-disabled="vm.import_disabled"></md-input-container><div \nng-if="vm.imported" class="alert-message success-message" translate="GLOBAL.SUCCESSIMPORT">Imported successfully</div>\n</div><treasure-overlay-spinner active="vm.importing"><div layout="row" layout-align="center start" \nng-if="vm.importPreview" class="white-box sections"><div flex-gt-sm="50" flex="100"><div class="section"><div \nclass="section-header" layout="row" layout-align="start center"><span class="section-title">PREVIEW</span></div><div \nclass="media" flex layout="row" layout-align="center center" ng-bind-html="vm.importPreview.embedCodeSafe"></div></div>\n<div class="header p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size text-truncate" layout="row" layout-align="start left"><span class="grey-500-fg"><span \nng-if="vm.importPreview.title">Title: {{vm.importPreview.title}}</span></span></div></div><div layout="row" \nlayout-align="space-between center" flex><div class="size" layout="row" layout-align="start left"><span \nclass="grey-500-fg"><span ng-if="vm.importPreview.caption">Description: {{vm.importPreview.caption}}</span></span>\n</div></div></div><md-button class="send-button md-accent md-raised" ng-click="vm.importConfirm(1)" \ntranslate="GLOBAL.IMPORT">Import</md-button></div></div><div ng-repeat="f in vm.importedFiles" class="ms-card" flex>\n<div class="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><img ng-src="{{f.embed_thumb}}" class="image"></div><div class="header p-16" flex><div \nlayout="row" layout-align="space-between center" flex><div class="size text-truncate" layout="row" \nlayout-align="start left"><strong class="mr-5">#{{f.id_media}}</strong> <span class="grey-500-fg"><span \nng-if=".filename">{{f.filename}}</span> <span ng-if="f.title">{{f.title}}</span></span></div><md-checkbox \nng-checked="vm.alreadySelectedbyZone(vm.selectedImages, f)" ng-click="vm.toggleSelectedImages(f, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, f) ? \'Deselect\' : \'Select\'}}"></md-checkbox></div></div>\n</div></div></div></treasure-overlay-spinner></div></div>');
$templateCache.put('app/main/apps/clients/dialogs/media/views/photos-view.html','<div class="content-wrapper" flex layout="row"><div class="mail-tabs-grid" flex \nmd-dynamic-height="{{vm.dynamicHeight}}"><div class="content mail-list-pane-grid" flex><div \nng-repeat="photo in vm.items" class="ms-card" flex><div class="ms-card-content-wrapper"><div class="template-9"><div \nclass="media" flex layout="row" layout-align="center center"><media attachment="photo" class=""></media></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size text-truncate" \nlayout="row" layout-align="start left"><strong class="mr-5">#{{photo.id_media}}</strong> <span class="grey-500-fg">\n<span ng-if="photo.filename">{{photo.filename}}</span></span></div><md-checkbox \nng-checked="vm.alreadySelectedbyZone(vm.selectedImages, photo)" ng-click="vm.toggleSelectedImages(photo, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, photo) ? \'Deselect\' : \'Select\'}}" class="ml-5"></md-checkbox>\n</div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/clients/dialogs/media/views/template-grid.html','<div class="template-9"><div class="header p-16" layout="row" layout-align="space-between center" flex><div \nlayout="column" layout-align="start center"><md-checkbox class="no-label" ng-checked="vm.isChecked(mail)" \nng-click="vm.toggleCheck(mail, $event)" aria-label="{{vm.isChecked(mail)? \'Uncheck\':\'check\'}}"></md-checkbox><div \nng-if="refcolumnsgrouped.main"><div class="subject text-truncate"><span \nng-repeat="field in refcolumnsgrouped.header | orderBy: \'list-sort\'" ng-bind="thread.{{field.titleId}}"></span></div>\n</div></div><div layout="column" layout-align="start center"><md-icon md-font-icon="icon-attachment" \nclass="has-attachment s24" ng-if="thread.Thumbnail.length>0"></md-icon><button ng-if="thread.onoff===1" \nclass="md-icon-button"><md-icon md-font-icon="icon-checkbox-marked-circle" class="on green-fg s24"></md-icon></button> \n<button ng-if="thread.onoff!==1" class="md-icon-button"><md-icon md-font-icon="icon-checkbox-blank-circle-outline" \nclass="off red-fg s24"></md-icon></button></div></div><div class="media" flex layout="row" \nlayout-align="center center"><img class="image" ng-src="{{card.Thumbnail[0].crop_status[0].urlformed}}" \nalt="{{card.media.image.alt}}" imageonloadcontrol></div><div class="header p-16" layout="row" layout-align="start"><div\n class="info"><div ng-if="refcolumnsgrouped.main"><div class="name text-truncate" layout="row" \nlayout-align="start center"><span ng-repeat="field in refcolumnsgrouped.main"><span ng-bind="thread.{{field.titleId}}">\n</span>&nbsp;</span></div></div><div ng-repeat="field in refcolumnsgrouped.secondary | orderBy:\'list_sort\'"><div \nng-if="(field.type!==\'date\' && field.type!==\'dateHm\') && field.primary!==1" class="details" layout="row" \nlayout-align="start start"><div layout="column"><span class="title" ng-bind="field.title"></span></div><div \nlayout="column" class="text-truncate"><span class="detail" ng-bind="thread.{{field.titleId}}"></span></div></div></div>\n</div></div></div>');
$templateCache.put('app/main/apps/clients/dialogs/media/views/tiny-attached.html','<div class="content-wrapper" flex layout="row"><div class="mail-tabs-grid" flex \nmd-dynamic-height="{{vm.dynamicHeight}}"><div class="content mail-list-pane-grid" flex><div \nng-repeat="item in vm.selectedImages" class="ms-card" flex><div class="ms-card-content-wrapper" \nng-if="item.media_type == 1"><div class="template-9"><div class="media" flex layout="row" layout-align="center center">\n<img ng-src="{{item.cropstatus[0].container.view_url}}{{item.cropstatus[0].fileName}}" class="image"></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size text-truncate" \nlayout="row" layout-align="start left"><strong class="mr-5">#{{item.id_media}}</strong> <span class="grey-500-fg"><span\n ng-if="item.filename">{{item.filename}}</span></span></div><md-button ng-click="vm.selectMediaTiny(item)" \nclass="send-button md-accent md-raised" aria-label="Select" translate="GLOBAL.SELECT" \ntranslate-attr-aria-label="GLOBAL.SELECT">SELECT</md-button></div></div></div></div><div \nclass="ms-card-content-wrapper" ng-if="item.media_type == 2"><div class="template-9"><div class="media" flex \nlayout="row" layout-align="center center"><img ng-src="{{item.embed_thumb}}" class="image"></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size text-truncate" \nlayout="row" layout-align="start left"><strong class="mr-5">#{{item.id_media}}</strong> <span class="grey-500-fg"><span\n ng-if="item.filename">{{item.filename}}</span> <span ng-if="item.title">{{item.title}}</span></span></div><md-button \nng-click="vm.selectMediaTiny(item)" class="send-button md-accent md-raised" aria-label="Select" \ntranslate="GLOBAL.SELECT" translate-attr-aria-label="GLOBAL.SELECT">SELECT</md-button></div></div></div></div></div>\n</div></div></div>');
$templateCache.put('app/main/apps/clients/dialogs/media/views/tiny-properties.html','<div class="ontent-wrapper" flex="" layout="column"><div class="content"><div class="ms-card" flex><div \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center" ng-if="vm.selectedMediaTiny.media_type == 1"><img \nng-src="{{vm.selectedMediaTiny.cropstatus[0].container.view_url}}{{vm.selectedMediaTiny.cropstatus[0].fileName}}" \nclass="image"></div><div class="media" flex layout="row" layout-align="center center" \nng-if="vm.selectedMediaTiny.media_type == 2"><img ng-src="{{vm.selectedMediaTiny.embed_thumb}}" class="image"></div>\n<div class="header p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size text-truncate" layout="row" layout-align="start left"><strong class="mr-5">\n#{{vm.selectedMediaTiny.id_media}}</strong> <span class="grey-500-fg"><span ng-if="vm.selectedMediaTiny.filename">\n{{vm.selectedMediaTiny.filename}}</span></span></div></div></div></div></div></div><div><md-input-container \nclass="md-block" flex><label translate="GLOBAL.ALIGN" translate-attr-aria-label="GLOBAL.ALIGN">Align:</label><md-select\n ng-model="vm.tinyProperties.align" placeholder="Align"><md-option value="">---</md-option><md-option \nng-repeat="opt in vm.tinyOptions.align" value="{{opt.value}}">{{opt.text}}</md-option></md-select><div \nclass="md-errors-spacer"></div></md-input-container><md-input-container class="md-block" flex><label \ntranslate="GLOBAL.SIZE" translate-attr-aria-label="GLOBAL.SIZE">Size:</label><md-select \nng-model="vm.tinyProperties.size" placeholder="Size"><md-option value="">---</md-option><md-option \nng-repeat="opt in vm.tinyOptions.size" value="{{opt.value}}">{{opt.text}}</md-option></md-select><div \nclass="md-errors-spacer"></div></md-input-container></div></div></div>');
$templateCache.put('app/main/apps/clients/dialogs/media/views/upload-view.html','<div class="content-wrapper" flex="" layout="column"><div class="content"><div ngf-drop ngf-select ng-model="vm.files" \nclass="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="false" ngf-allow-dir="true" accept="image/*" \nngf-pattern="\'image/*\'"><md-button class="md-raised md-accent text-center" ng-model="photo" \ntranslate="GLOBAL.SELECT_FILES" onchange="angular.element(this).scope().file_changed(this)" type="file" \naccept="image/*"></md-button></div><md-progress-linear md-mode="determinate" value="{{vm.files[0].progress}}" \nng-show="vm.files[0].progress < 100"></md-progress-linear></div></div>');
$templateCache.put('app/main/apps/clients/dialogs/media/views/videos-view.html','<div class="content-wrapper" flex layout="row"><div class="mail-tabs-grid" flex><div \nclass="content mail-list-pane-grid" flex><div ng-repeat="item in vm.items" class="ms-card" flex><div \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><media attachment="item" thumbnail="true" class=""></media></div><div class="header p-16" \nflex><div layout="row" layout-align="space-between center" flex><div class="size text-truncate" layout="row" \nlayout-align="start left"><strong class="mr-5">#{{item.id_media}}</strong> <span class="grey-500-fg"><span \nng-if="item.filename">{{item.filename}}</span> <span ng-if="item.title">{{item.title}}</span></span></div><md-checkbox \nng-checked="vm.alreadySelectedbyZone(vm.selectedImages, item)" ng-click="vm.toggleSelectedImages(item, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, item) ? \'Deselect\' : \'Select\'}}"></md-checkbox></div></div>\n</div></div></div></div></div></div>');
$templateCache.put('app/main/apps/clients-complaints/dialogs/image/views/fotorama-view.html','<div class="content-wrapper" flex layout="row"><div class="mail-tabs-grid" flex \nmd-dynamic-height="{{vm.dynamicHeight}}"><fotorama options="vm.fotoramaoptions" items="vm.dataFotorama" id="fotorama">\n</fotorama></div></div>');
$templateCache.put('app/main/apps/clients-complaints/dialogs/media/views/audios-view.html','<div class="content-wrapper" flex="" layout="row"><div class="mail-tabs-grid" flex \nmd-dynamic-height="{{vm.dynamicHeight}}"><div class="content mail-list-pane-grid" flex ms-scroll><div \nng-repeat="item in vm.items" class="ms-card" flex><div class="ms-card-content-wrapper"><div class="template-9"><div \nclass="media" flex layout="row" layout-align="center center"><div flex layout="column" layout-align="center center" \nclass="media"><media attachment="item" class=""></media><br><span class="grey-500-fg" layout="column" \nlayout-align="center center"><span ng-if="item.title"><strong>{{item.title}}</strong></span> <span \nng-if="item.filename">{{item.filename}}</span></span></div></div><div class="header p-16" flex><div layout="row" \nlayout-align="space-between center" flex><div class="size text-truncate" layout="row" layout-align="start left"><strong\n class="mr-5">#{{item.id_media}}</strong> <span class="grey-500-fg"><span ng-if="item.date_uploaded">\n{{item.date_uploaded}}</span></span></div><md-checkbox ng-checked="vm.alreadySelectedbyZone(vm.selectedImages, item)" \nng-click="vm.toggleSelectedImages(item, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, item) ? \'Deselect\' : \'Select\'}}" class="ml-5"></md-checkbox>\n</div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/clients-complaints/dialogs/media/views/files-view.html','<div class="content-wrapper" flex="" layout="row"><div class="mail-tabs-grid" flex=""><div \nclass="content mail-list-pane-grid" flex="" ms-scroll=""><div ng-repeat="item in vm.items" class="ms-card" flex><div \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><div flex layout="column" layout-align="center center" class="media"><media \nattachment="item" class=""></media><br><span class="grey-500-fg" layout="column" layout-align="center center"><span \nng-if="item.title"><strong>{{item.title}}</strong></span> <span ng-if="item.filename">{{item.filename}}</span></span>\n</div></div><div class="header p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size text-truncate" layout="row" layout-align="start left"><strong class="mr-5">#{{item.id_media}}</strong>\n</div><md-checkbox ng-checked="vm.alreadySelectedbyZone(vm.selectedImages, item)" \nng-click="vm.toggleSelectedImages(item, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, item) ? \'Deselect\' : \'Select\'}}" class="ml-5"></md-checkbox>\n</div></div></div></div></div></div></div></div><div layout="column" layout-align="center center"></div>');
$templateCache.put('app/main/apps/clients-complaints/dialogs/media/views/import-view.html','<div class="content-wrapper" flex layout="column"><div class="content"><div class="drop-box"><md-input-container \nclass="md-block"><label>Paste the url to import:</label> <input type="text" name="import_field" \nng-model="vm.import_field" placeholder="" ng-disabled="vm.import_disabled"></md-input-container><div \nng-if="vm.imported" class="alert-message success-message" translate="GLOBAL.SUCCESSIMPORT">Imported successfully</div>\n</div><treasure-overlay-spinner active="vm.importing"><div layout="row" layout-align="center start" \nng-if="vm.importPreview" class="white-box sections"><div flex-gt-sm="50" flex="100"><div class="section"><div \nclass="section-header" layout="row" layout-align="start center"><span class="section-title">PREVIEW</span></div><div \nclass="media" flex layout="row" layout-align="center center" ng-bind-html="vm.importPreview.embedCodeSafe"></div></div>\n<div class="header p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size text-truncate" layout="row" layout-align="start left"><span class="grey-500-fg"><span \nng-if="vm.importPreview.title">Title: {{vm.importPreview.title}}</span></span></div></div><div layout="row" \nlayout-align="space-between center" flex><div class="size" layout="row" layout-align="start left"><span \nclass="grey-500-fg"><span ng-if="vm.importPreview.caption">Description: {{vm.importPreview.caption}}</span></span>\n</div></div></div><md-button class="send-button md-accent md-raised" ng-click="vm.importConfirm(1)" \ntranslate="GLOBAL.IMPORT">Import</md-button></div></div><div ng-repeat="f in vm.importedFiles" class="ms-card" flex>\n<div class="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><img ng-src="{{f.embed_thumb}}" class="image"></div><div class="header p-16" flex><div \nlayout="row" layout-align="space-between center" flex><div class="size text-truncate" layout="row" \nlayout-align="start left"><strong class="mr-5">#{{f.id_media}}</strong> <span class="grey-500-fg"><span \nng-if=".filename">{{f.filename}}</span> <span ng-if="f.title">{{f.title}}</span></span></div><md-checkbox \nng-checked="vm.alreadySelectedbyZone(vm.selectedImages, f)" ng-click="vm.toggleSelectedImages(f, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, f) ? \'Deselect\' : \'Select\'}}"></md-checkbox></div></div>\n</div></div></div></treasure-overlay-spinner></div></div>');
$templateCache.put('app/main/apps/clients-complaints/dialogs/media/views/photos-view.html','<div class="content-wrapper" flex layout="row"><div class="mail-tabs-grid" flex \nmd-dynamic-height="{{vm.dynamicHeight}}"><div class="content mail-list-pane-grid" flex><div \nng-repeat="photo in vm.items" class="ms-card" flex><div class="ms-card-content-wrapper"><div class="template-9"><div \nclass="media" flex layout="row" layout-align="center center"><media attachment="photo" class=""></media></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size text-truncate" \nlayout="row" layout-align="start left"><strong class="mr-5">#{{photo.id_media}}</strong> <span class="grey-500-fg">\n<span ng-if="photo.filename">{{photo.filename}}</span></span></div><md-checkbox \nng-checked="vm.alreadySelectedbyZone(vm.selectedImages, photo)" ng-click="vm.toggleSelectedImages(photo, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, photo) ? \'Deselect\' : \'Select\'}}" class="ml-5"></md-checkbox>\n</div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/clients-complaints/dialogs/media/views/template-grid.html','<div class="template-9"><div class="header p-16" layout="row" layout-align="space-between center" flex><div \nlayout="column" layout-align="start center"><md-checkbox class="no-label" ng-checked="vm.isChecked(mail)" \nng-click="vm.toggleCheck(mail, $event)" aria-label="{{vm.isChecked(mail)? \'Uncheck\':\'check\'}}"></md-checkbox><div \nng-if="refcolumnsgrouped.main"><div class="subject text-truncate"><span \nng-repeat="field in refcolumnsgrouped.header | orderBy: \'list-sort\'" ng-bind="thread.{{field.titleId}}"></span></div>\n</div></div><div layout="column" layout-align="start center"><md-icon md-font-icon="icon-attachment" \nclass="has-attachment s24" ng-if="thread.Thumbnail.length>0"></md-icon><button ng-if="thread.onoff===1" \nclass="md-icon-button"><md-icon md-font-icon="icon-checkbox-marked-circle" class="on green-fg s24"></md-icon></button> \n<button ng-if="thread.onoff!==1" class="md-icon-button"><md-icon md-font-icon="icon-checkbox-blank-circle-outline" \nclass="off red-fg s24"></md-icon></button></div></div><div class="media" flex layout="row" \nlayout-align="center center"><img class="image" ng-src="{{card.Thumbnail[0].crop_status[0].urlformed}}" \nalt="{{card.media.image.alt}}" imageonloadcontrol></div><div class="header p-16" layout="row" layout-align="start"><div\n class="info"><div ng-if="refcolumnsgrouped.main"><div class="name text-truncate" layout="row" \nlayout-align="start center"><span ng-repeat="field in refcolumnsgrouped.main"><span ng-bind="thread.{{field.titleId}}">\n</span>&nbsp;</span></div></div><div ng-repeat="field in refcolumnsgrouped.secondary | orderBy:\'list_sort\'"><div \nng-if="(field.type!==\'date\' && field.type!==\'dateHm\') && field.primary!==1" class="details" layout="row" \nlayout-align="start start"><div layout="column"><span class="title" ng-bind="field.title"></span></div><div \nlayout="column" class="text-truncate"><span class="detail" ng-bind="thread.{{field.titleId}}"></span></div></div></div>\n</div></div></div>');
$templateCache.put('app/main/apps/clients-complaints/dialogs/media/views/tiny-attached.html','<div class="content-wrapper" flex layout="row"><div class="mail-tabs-grid" flex \nmd-dynamic-height="{{vm.dynamicHeight}}"><div class="content mail-list-pane-grid" flex><div \nng-repeat="item in vm.selectedImages" class="ms-card" flex><div class="ms-card-content-wrapper" \nng-if="item.media_type == 1"><div class="template-9"><div class="media" flex layout="row" layout-align="center center">\n<img ng-src="{{item.cropstatus[0].container.view_url}}{{item.cropstatus[0].fileName}}" class="image"></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size text-truncate" \nlayout="row" layout-align="start left"><strong class="mr-5">#{{item.id_media}}</strong> <span class="grey-500-fg"><span\n ng-if="item.filename">{{item.filename}}</span></span></div><md-button ng-click="vm.selectMediaTiny(item)" \nclass="send-button md-accent md-raised" aria-label="Select" translate="GLOBAL.SELECT" \ntranslate-attr-aria-label="GLOBAL.SELECT">SELECT</md-button></div></div></div></div><div \nclass="ms-card-content-wrapper" ng-if="item.media_type == 2"><div class="template-9"><div class="media" flex \nlayout="row" layout-align="center center"><img ng-src="{{item.embed_thumb}}" class="image"></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size text-truncate" \nlayout="row" layout-align="start left"><strong class="mr-5">#{{item.id_media}}</strong> <span class="grey-500-fg"><span\n ng-if="item.filename">{{item.filename}}</span> <span ng-if="item.title">{{item.title}}</span></span></div><md-button \nng-click="vm.selectMediaTiny(item)" class="send-button md-accent md-raised" aria-label="Select" \ntranslate="GLOBAL.SELECT" translate-attr-aria-label="GLOBAL.SELECT">SELECT</md-button></div></div></div></div></div>\n</div></div></div>');
$templateCache.put('app/main/apps/clients-complaints/dialogs/media/views/tiny-properties.html','<div class="ontent-wrapper" flex="" layout="column"><div class="content"><div class="ms-card" flex><div \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center" ng-if="vm.selectedMediaTiny.media_type == 1"><img \nng-src="{{vm.selectedMediaTiny.cropstatus[0].container.view_url}}{{vm.selectedMediaTiny.cropstatus[0].fileName}}" \nclass="image"></div><div class="media" flex layout="row" layout-align="center center" \nng-if="vm.selectedMediaTiny.media_type == 2"><img ng-src="{{vm.selectedMediaTiny.embed_thumb}}" class="image"></div>\n<div class="header p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size text-truncate" layout="row" layout-align="start left"><strong class="mr-5">\n#{{vm.selectedMediaTiny.id_media}}</strong> <span class="grey-500-fg"><span ng-if="vm.selectedMediaTiny.filename">\n{{vm.selectedMediaTiny.filename}}</span></span></div></div></div></div></div></div><div><md-input-container \nclass="md-block" flex><label translate="GLOBAL.ALIGN" translate-attr-aria-label="GLOBAL.ALIGN">Align:</label><md-select\n ng-model="vm.tinyProperties.align" placeholder="Align"><md-option value="">---</md-option><md-option \nng-repeat="opt in vm.tinyOptions.align" value="{{opt.value}}">{{opt.text}}</md-option></md-select><div \nclass="md-errors-spacer"></div></md-input-container><md-input-container class="md-block" flex><label \ntranslate="GLOBAL.SIZE" translate-attr-aria-label="GLOBAL.SIZE">Size:</label><md-select \nng-model="vm.tinyProperties.size" placeholder="Size"><md-option value="">---</md-option><md-option \nng-repeat="opt in vm.tinyOptions.size" value="{{opt.value}}">{{opt.text}}</md-option></md-select><div \nclass="md-errors-spacer"></div></md-input-container></div></div></div>');
$templateCache.put('app/main/apps/clients-complaints/dialogs/media/views/upload-view.html','<div class="content-wrapper" flex="" layout="column"><div class="content"><div ngf-drop ngf-select ng-model="vm.files" \nclass="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="false" ngf-allow-dir="true" accept="image/*" \nngf-pattern="\'image/*\'"><md-button class="md-raised md-accent text-center" ng-model="photo" \ntranslate="GLOBAL.SELECT_FILES" onchange="angular.element(this).scope().file_changed(this)" type="file" \naccept="image/*"></md-button></div><md-progress-linear md-mode="determinate" value="{{vm.files[0].progress}}" \nng-show="vm.files[0].progress < 100"></md-progress-linear></div></div>');
$templateCache.put('app/main/apps/clients-complaints/dialogs/media/views/videos-view.html','<div class="content-wrapper" flex layout="row"><div class="mail-tabs-grid" flex><div \nclass="content mail-list-pane-grid" flex><div ng-repeat="item in vm.items" class="ms-card" flex><div \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><media attachment="item" thumbnail="true" class=""></media></div><div class="header p-16" \nflex><div layout="row" layout-align="space-between center" flex><div class="size text-truncate" layout="row" \nlayout-align="start left"><strong class="mr-5">#{{item.id_media}}</strong> <span class="grey-500-fg"><span \nng-if="item.filename">{{item.filename}}</span> <span ng-if="item.title">{{item.title}}</span></span></div><md-checkbox \nng-checked="vm.alreadySelectedbyZone(vm.selectedImages, item)" ng-click="vm.toggleSelectedImages(item, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, item) ? \'Deselect\' : \'Select\'}}"></md-checkbox></div></div>\n</div></div></div></div></div></div>');
$templateCache.put('app/main/apps/clients-complaints/views/read/form-tabs/step-branchs.html','<div \nng-init="!vm.formWizard.company.extra_data.implemented_measures ? vm.formWizard.company.extra_data.implemented_measures = [] : null;">\n</div><div layout="column" layout-gt-xs="row"><md-input-container flex><h1 translate=""></h1></md-input-container>\n</div><div layout="column" layout-gt-xs="row"><md-input-container flex><label translate="GLOBAL.NAME"></label> <input \nng-model="vm.formWizard.main_branch.name" type="text"></md-input-container><md-input-container flex><label \ntranslate="GLOBAL.ADDRESS"></label> <input ng-model="vm.formWizard.main_branch.address1" type="text" required>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label>\n{{vm.getRegionLiteral(\'city\')}}</label> <input ng-model="vm.formWizard.main_branch.city" type="text" required>\n</md-input-container><md-input-container flex><label>{{vm.getRegionLiteral(\'state\')}}</label> <input \nng-model="vm.formWizard.main_branch.state" type="text" required></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container flex><label translate="GLOBAL.POSTAL_CODE"></label> <input \nng-model="vm.formWizard.main_branch.postcode" type="text" required></md-input-container><md-input-container flex><label\n translate="GLOBAL.PHONE"></label> <input ng-model="vm.formWizard.main_branch.phone" type="text"></md-input-container>\n</div><div layout="column" layout-gt-xs="row"><md-input-container flex><label translate="GLOBAL.EMAIL"></label> <input \nng-model="vm.formWizard.main_branch.email" type="text"></md-input-container><md-input-container flex>\n</md-input-container></div>');
$templateCache.put('app/main/apps/clients-complaints/views/read/form-tabs/step-company.html','<div layout="column" layout-gt-xs="row"><md-input-container class="input-container-mobile" flex><label \ntranslate="GLOBAL.SOCIAL_REASON"></label> <input type="text" ng-model="vm.formWizard.company.name" required>\n</md-input-container></div><div layout="column" layout-gt-xs="row" class="row-container-mobile"><md-input-container \nclass="input-container-mobile tax-id-container-mobile" flex><label>{{vm.getRegionLiteral(\'tax_ic_number\')}}</label> \n<input type="text" ng-model="vm.formWizard.company.tax_id_number"></md-input-container><md-input-container \nclass="input-container-mobile" flex><label translate="GLOBAL.SECTOR"></label><md-select \nng-model="vm.formWizard.company.sector_id"><md-option ng-repeat="sector in vm.sectors track by $index" \nng-value="sector.id">{{sector.name}}</md-option></md-select></md-input-container></div><div layout="column" \nlayout-gt-xs="row" class="row-container-mobile"><md-input-container class="input-container-mobile" flex><label \ntranslate="GLOBAL.REGION"></label><md-select ng-model="vm.formWizard.company.region_id"><md-option \nng-repeat="region in vm.regions track by $index" ng-value="region.id">{{region.name}}</md-option></md-select>\n</md-input-container><md-input-container class="input-container-mobile" flex></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-align="start center"><md-input-container><p class="mt-0 grey-400-fg" \ntranslate="GLOBAL.LOGOTYPE"></p><div class="header simple relative" ng-if="image || imageUrl" layout="row" \nlayout-align="space-between center"><md-menu><button class="md-icon-button" aria-label="More"><div layout="column" \nlayout-align="start center" ng-click="$mdMenu.open($event)"><div class="media" flex layout="row" \nlayout-align="center center"><img ngf-thumbnail="!image.$error && image" class="image"> <img \nng-if="!image && imageUrl" src="{{imageUrl}}" class="image"></div><md-button \nclass="md-mini add-event-button no-sort md-fab md-warn block absolute-top-right" aria-label="Add event"><md-icon \nmd-font-icon="icon-dots-vertical"></md-icon></md-button></div></button><md-menu-content width="3"><md-menu-item>\n<md-button ng-click="vm.deleteLogotype()" aria-label="Toggle done" translate-attr-aria-label="GLOBAL.REMOVE"><md-icon \nmd-font-icon="icon-close" class="s18"></md-icon><span translate="GLOBAL.REMOVE"></span></md-button></md-menu-item>\n</md-menu-content></md-menu></div><div ng-if="!image && !imageUrl" \nng-click="vm.mediaDialogSingle($event, vm.formWizard.company.logotype)" class="relative"><img \nsrc="assets/images/logos/generic-logo.png" class="image"><md-button \nclass="md-mini add-event-button no-sort md-fab md-warn block absolute-top-right" aria-label="Add event" translate \ntranslate-attr-aria-label="CALENDAR.ADD_EVENT"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n</md-input-container></div>');
$templateCache.put('app/main/apps/clients-complaints/views/read/form-tabs/step-options.html','<div class="options"><div layout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container \nfill-width flex><label translate="GLOBAL.DESCRIPTION"></label> <input type="text" \nng-model="vm.formWizard.company.description"></md-input-container><md-input-container fill-width flex><label \ntranslate="GLOBAL.COMPANY_TYPE"></label><md-select ng-model="vm.formWizard.company.extra_data.company_type"><md-option \nng-value="1">SA</md-option><md-option ng-value="2">SL</md-option><md-option ng-value="3">Cotizada</md-option><md-option\n ng-value="4">Fundaciones/asociaciones</md-option><md-option ng-value="5">Otras</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container\n fill-width flex><label translate="GLOBAL.EXECUTIVE_TYPE"></label><md-select \nng-model="vm.formWizard.company.extra_data.executives_type"><md-option ng-value="1">Accionista \xFAnico</md-option>\n<md-option ng-value="2">Varios accionistas</md-option><md-option ng-value="3">Consejo de administraci\xF3n</md-option>\n<md-option ng-value="4">Administrador \xFAnico</md-option><md-option ng-value="5">Otros</md-option></md-select>\n</md-input-container><md-input-container fill-width flex><label translate="GLOBAL.SOCIAL_CAPITAL"></label><md-select \nng-model="vm.formWizard.company.extra_data.capital"><md-option ng-value="1">Capital</md-option><md-option ng-value="2">\nAportaciones de socios</md-option><md-option ng-value="3">Aumentos de capital recientes</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container\n fill-width flex><label translate="GLOBAL.AMOUNT_CAPITAL"></label> <input type="number" type="text" \nng-model="vm.formWizard.company.extra_data.capital_amount"></md-input-container><md-input-container fill-width flex>\n<label translate="GLOBAL.BILLING_LAST_YEAR"></label> <input type="number" \nng-model="vm.formWizard.company.turnover_volume"></md-input-container></div><div layout="column" layout-gt-xs="row" \nflex layout-align="start center"><md-input-container fill-width flex><label>Cuentas anuales</label><md-select \nng-model="vm.formWizard.company.extra_data.annual_accounts"><md-option ng-value="1">Abreviadas</md-option><md-option \nng-value="2">Normales</md-option><md-option ng-value="3">Pymes</md-option><md-option ng-value="4">Mixtas</md-option>\n</md-select></md-input-container><md-input-container fill-width flex><label>Auditor\xEDas</label><md-select \nng-model="vm.formWizard.company.extra_data.audits"><md-option ng-value="1">Internas</md-option><md-option ng-value="2">\nExternas</md-option><md-option ng-value="3">No aplica</md-option></md-select></md-input-container></div><div \nlayout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container fill-width flex><label>\nCertificaciones ISO</label><md-select ng-model="vm.formWizard.company.extra_data.iso_certification"><md-option \nng-value="1">ISO 9001</md-option><md-option ng-value="2">ISO 14000</md-option><md-option ng-value="3">ISO 14001\n</md-option><md-option ng-value="4">ISO 19600</md-option><md-option ng-value="5">ISO 22000</md-option><md-option \nng-value="6">ISO 26000</md-option><md-option ng-value="7">ISO 27001</md-option><md-option ng-value="8">ISO 37001\n</md-option><md-option ng-value="9">OHSAS 18001</md-option></md-select></md-input-container><md-input-container \nfill-width flex><label>Convenio Colectivo Aplicable</label> <input type="text" \nng-model="vm.formWizard.company.extra_data.collective_agreement"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" flex layout-align="start center"><md-input-container fill-width flex><label>Seguros contratados\n</label> <input type="text" ng-model="vm.formWizard.company.extra_data.insurance"></md-input-container>\n<md-input-container fill-width flex><label translate="GLOBAL.CNAE"></label> <input type="text" \nng-model="vm.formWizard.company.extra_data.cnae"></md-input-container></div><div layout="column" layout-gt-xs="row" \nflex layout-align="start center"><md-input-container fill-width layout="row" layout-align="start center" flex><label \nclass="ph-15" fill-width translate="GLOBAL.FINANCING"></label><md-select flex \nng-init="!vm.formWizard.company.extra_data.financing ? vm.formWizard.company.extra_data.financing = [] : null;" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.financing"><md-option \nng-repeat="option in vm.financing_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container><md-input-container fill-width layout="row" layout-align="start center" flex><label class="ph-15" \nfill-width>Normativa Sectorial aplicable</label><md-select flex \nng-init="!vm.formWizard.company.extra_data.sector_regulations ? vm.formWizard.company.extra_data.sector_regulations = [] : null;" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.sector_regulations"><md-option \nng-repeat="option in vm.sector_regulations_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-align="start center"><md-input-container \nfill-width layout="row" layout-align="start center" flex><label class="ph-15" fill-width>Medidas implementadas</label>\n<md-select flex \nng-init="!vm.formWizard.company.extra_data.implemented_measures ? vm.formWizard.company.extra_data.implemented_measures = [] : null;" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.implemented_measures"><md-option \nng-repeat="option in vm.implemented_measures_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container></div><div class="separator-options" layout="row"><h2>Grupo de sociedades?</h2><md-input-container\n fill-width layout="row" layout-align="start center" flex class="mb-0"><md-checkbox \nng-checked="vm.formWizard.company.extra_data.belogns_to_holding" \nng-model="vm.formWizard.company.extra_data.belogns_to_holding"></md-checkbox></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-align="start center"></div><div \nng-if="vm.formWizard.company.extra_data.belogns_to_holding" layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container fill-width flex><label>Nombre corporaci\xF3n</label> <input type="text" \nng-model="vm.formWizard.company.extra_data.name_corporation"></md-input-container><md-input-container fill-width flex>\n<label>CIF corporaci\xF3n</label> <input type="text" ng-model="vm.formWizard.company.extra_data.cif_corporation">\n</md-input-container></div><div class="mv-25" ng-if="vm.formWizard.company.extra_data.belogns_to_holding" \nlayout="column" layout-gt-xs="row" layout-align="start center"><div fill-width><div ngf-drop ngf-select \nng-model="vm.files_belogns_to_holding" class="drop-box" layout="column" layout-gt-xs="row" \nngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="belogns_to_holding_isLoading"><div flex layout="column" layout-align="center center" layout-padding \nlayout-margin class="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30">\n</md-progress-circular></div></div></div><div layout="column" flex><div \nng-repeat="f in vm.formWizard.company.extra_data.belogns_to_holding_files track by $index" class="border-bottom" flex>\n<div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><div class="media photos" layout="row" layout-align="center center"><h2c-icon \nfile="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" alt=""></div><div class="info ml-15" flex \nlayout="column" layout-align="center center"><div class="name" layout="row" layout-align="center center"><span \nng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu class="float-right"><md-button \nclass="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.belogns_to_holding_files.splice($index, 1);"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></div></div></div><div class="separator-options" \nlayout="row"><h2>Responsabilidad social corporativa?</h2><md-input-container fill-width layout="row" \nlayout-align="start center" flex class="mb-0"><md-checkbox \nng-checked="vm.formWizard.company.extra_data.social_responsability" \nng-model="vm.formWizard.company.extra_data.social_responsability"></md-checkbox></md-input-container></div><div \nclass="mv-25" ng-if="vm.formWizard.company.extra_data.social_responsability" layout="column" layout-gt-xs="row" \nlayout-align="start center"><div fill-width><div ngf-drop ngf-select ng-model="vm.files_social_responsability" \nclass="drop-box" layout="column" layout-gt-xs="row" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" \nngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="social_responsability_isLoading"><div flex layout="column" layout-align="center center" layout-padding \nlayout-margin class="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30">\n</md-progress-circular></div></div></div><div layout="column" flex><div \nng-repeat="f in vm.formWizard.company.extra_data.social_responsability_files track by $index" class="border-bottom" \nflex><div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><div class="media photos" layout="row" layout-align="center center"><h2c-icon \nfile="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" alt=""></div><div class="info ml-15" flex \nlayout="column" layout-align="center center"><div class="name" layout="row" layout-align="center center"><span \nng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu class="float-right"><md-button \nclass="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.social_responsability_files.splice($index, 1);"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></div></div></div><div class="separator-options" \nlayout="row"><h2>IVA</h2></div><div class="mv-25" layout="column"><div layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container fill-width flex><md-select \nng-model="vm.formWizard.company.extra_data.tax_options"><md-option ng-value="1">Presentaci\xF3n trimestral</md-option>\n<md-option ng-value="2">Presentaci\xF3n mensual</md-option></md-select></md-input-container><md-input-container \nfill-width flex></md-input-container></div><div layout="column" layout-gt-xs="row" layout-align="start center"><div \nfill-width><div ngf-drop ngf-select ng-model="vm.files_iva" class="drop-box" layout="column" layout-gt-xs="row" \nngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="iva_isLoading"><div flex layout="column" layout-align="center center" layout-padding layout-margin \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n</div></div><div layout="column" flex><div ng-repeat="f in vm.formWizard.company.extra_data.iva_files track by $index" \nclass="border-bottom" flex><div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size" layout="row" layout-align="start left"><div class="media photos" layout="row" \nlayout-align="center center"><h2c-icon file="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" \nalt=""></div><div class="info ml-15" flex layout="column" layout-align="center center"><div class="name" layout="row" \nlayout-align="center center"><span ng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.iva_files.splice($index, 1);"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div></div></div></div></div><div class="separator-options" layout="row"><h2>\nImpuesto de sociedades</h2></div><div class="mv-25" layout="column"><div layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container fill-width flex><md-datepicker \nng-model="vm.formWizard.company.extra_data.date_is" md-placeholder="Fecha"></md-datepicker></md-input-container>\n<md-input-contaimer class="md-block" flex><md-select ng-model="vm.formWizard.company.extra_data.currency_is" \nplaceholder="{{ \'GLOBAL.CURRENCY\' |\xA0translate}}"><md-option ng-repeat="currency in vm.currencies" \nng-value="currency.id">{{currency.symbol}}</md-option></md-select></md-input-contaimer><md-input-container fill-width \nflex><label translate="GLOBAL.AMOUNT_CAPITAL"></label> <input type="number" type="text" \nng-model="vm.formWizard.company.extra_data.amount_is"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-align="start center"><div fill-width><div ngf-drop ngf-select ng-model="vm.files_is" \nclass="drop-box" layout="column" layout-gt-xs="row" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" \nngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="is_isLoading"><div flex layout="column" layout-align="center center" layout-padding layout-margin \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n</div></div><div layout="column" flex><div ng-repeat="f in vm.formWizard.company.extra_data.is_files track by $index" \nclass="border-bottom" flex><div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size" layout="row" layout-align="start left"><div class="media photos" layout="row" \nlayout-align="center center"><h2c-icon file="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" \nalt=""></div><div class="info ml-15" flex layout="column" layout-align="center center"><div class="name" layout="row" \nlayout-align="center center"><span ng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.is_files.splice($index, 1);"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/clients-complaints/views/read/form-tabs/step-people-global.html','<div layout="column" layout-gt-xs="row"><div class="mail-list-pane s0" flex="100"><div layout-gt-xs="row" \nlayout="column" class="mb-20"><div flex="20"><div layout="row" layout-align="start center" flex="100" \nclass="p-20 layout-align-start-center layout-row flex-100"><div layout="row" layout-align="start center" flex="100" \nclass="layout-align-start-center layout-row flex-100"><div class="avatar-wrapper"><md-icon md-font-icon="icon-city">\n</md-icon></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding" \nng-bind-html="vm.formWizard.main_branch.name"></strong><div class="field grey-600-fg ng-binding"><span \nng-if="vm.formWizard.main_branch.city" ng-bind-html="vm.formWizard.main_branch.city"></span> <span \nng-if="vm.formWizard.main_branch.city && vm.formWizard.main_branch.state">, </span><span \nng-if="vm.formWizard.main_branch.state" ng-bind-html="vm.formWizard.main_branch.state"></span></div></div></div></div>\n</div><div flex="80"><div layout="row" layout-align="start center"><div class="mail-list-pane s0" flex="100"><div \nclass="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="user.branch_id == vm.formWizard.main_branch.id"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId != user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong><div class="field grey-600-fg ng-binding"><span>\n{{vm.getDivisionName(user.division)[0].name}} | {{vm.getPositionName(user.position)[0].name}}</span></div></div></div>\n</div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu class="float-right">\n<md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" \nng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\', vm.formWizard.main_branch)"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div><div class="items"><div layout="row" \nlayout-align="start center" flex="100" class="pt-10 pb-10"><div class="info" flex layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><md-button \nng-click="vm.openDialogForm(\'personnel\', vm.formWizard.main_branch.id)" \nclass="md-mini add-event-button md-fab md-warn mh-0"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n</div></div></div></div></div></div></div></div></div><div layout-gt-xs="row" layout="column" class="mb-20" \nng-repeat="branch in vm.formWizard.branch" ng-if="branch.id != vm.formWizard.main_branch.id"><div flex="20"><div \nlayout="row" layout-align="start center" flex="100" class="p-20 layout-align-start-center layout-row flex-100"><div \nlayout="row" layout-align="start center" flex="100" class="layout-align-start-center layout-row flex-100"><div \nclass="avatar-wrapper"><md-icon md-font-icon="icon-city"></md-icon></div><div class="field mr-10 ml-10 flex" flex="">\n<strong class="grey-800-fg ng-binding" ng-bind-html="branch.name"></strong><div class="field grey-600-fg ng-binding">\n<span ng-if="branch.city" ng-bind-html="branch.city"></span> <span ng-if="branch.city && branch.state">, </span><span \nng-if="branch.state" ng-bind-html="branch.state"></span></div></div></div></div></div><div flex="80"><div layout="row" \nlayout-align="start center"><div class="mail-list-pane s0" flex="100"><div class="items" \nng-repeat="user in vm.formWizard.personnel track by $index" ng-if="user.branch_id == branch.id"><div layout="row" \nlayout-align="start center" flex="100" class="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" \nlayout="column"><div class="name" layout="row"><div layout="row" layout-align="start center" flex="100"><div \nclass="avatar-wrapper"><user-avatar ng-if="uploadingFotoUserId != user.id" user="user"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong><div class="field grey-600-fg ng-binding"><span>\n{{vm.getDivisionName(user.division)[0].name}} | {{vm.getPositionName(user.position)[0].name}}</span></div></div></div>\n</div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu class="float-right">\n<md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\', branch)">\n<md-icon md-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div><div class="items"><div layout="row" \nlayout-align="start center" flex="100" class="pt-10 pb-10"><div class="info" flex layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><md-button \nng-click="vm.openDialogForm(\'personnel\', branch.id)" class="md-mini add-event-button md-fab md-warn mh-0"><md-icon \nmd-font-icon="icon-plus"></md-icon></md-button></div></div></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/clients-complaints/views/read/form-tabs/step-people.html','<div layout="column" layout-gt-xs="row" style="overflow-y: auto; max-height: 50vh;"><div style="padding: 0px 15px;" \nflex layout="column"><div style="padding: 0px 15px;" flex layout="column"><h1 translate=""></h1><md-input-container \nclass="group-form" flex="100" flex-gt-xs="100"><div style="display: flex; justify-content: center;"><md-button \nng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'collaborator\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n<div class="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'collaborator\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId != user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container></div></div></div>');
$templateCache.put('app/main/apps/complaints/views/edit/editors/editors-editing.html','<div ng-if="field.temporary || field.editing" class="layout-wrap layout-sm-column layout-row newfield"><div \nng-if="!field.templateOptions.is_default" flex="50" style="margin-top: 45px;"><md-input-container class="md-block">\n<label translate="COMPLAINTS.FIELD_TYPE"></label><md-select ng-change="vm.setTOOptions(field)" ng-model="field.type">\n<md-option ng-repeat="typeField in vm.typeFields" ng-value="typeField.value"><span ng-switch="typeField.value"><md-icon\n md-font-icon="icon-format-float-left" class="mr-5 s20" ng-switch-when="textarea"></md-icon><md-icon \nmd-font-icon="icon-format-text" class="mr-5 s20" ng-switch-when="input"></md-icon><md-icon \nmd-font-icon="icon-chevron-down" class="mr-5 s20" ng-switch-when="select"></md-icon><md-icon md-font-icon="icon-tag" \nclass="mr-5 s20" ng-switch-when="separator"></md-icon><md-icon md-font-icon="icon-checkbox-marked-outline" \nclass="mr-5 s20" ng-switch-when="checkbox"></md-icon><md-icon md-font-icon="icon-checkbox-marked-outline" \nclass="mr-5 s20" ng-switch-when="multiCheckbox"></md-icon><md-icon md-font-icon="icon-radiobox-marked" \nclass="mr-5 s20" ng-switch-when="radio"></md-icon><md-icon md-font-icon="icon-attachment" class="mr-5 s20" \nng-switch-when="dropzone"></md-icon><md-icon md-font-icon="icon-calendar" class="mr-5 s20" ng-switch-when="datepicker">\n</md-icon><md-icon md-font-icon="icon-view-week" class="mr-5 s20" ng-switch-default></md-icon></span><span \nng-if="typeField.value != \'dropzone\' && typeField.value != \'datepicker\'">{{typeField.text |\xA0translate}} </span><span \nng-if="typeField.value == \'dropzone\'">{{\'COMPLAINTS.DROPZONE\' | translate}} </span><span \nng-if="typeField.value == \'datepicker\'">{{\'COMPLAINTS.DATEPICKER\' | translate}}</span></md-option></md-select>\n</md-input-container></div><div ng-if="field.type && field.type == \'input\' && !field.templateOptions.is_default" \nflex="50" style="margin-top: 45px;"><md-input-container class="md-block"><label translate="COMPLAINTS.FIELD_TYPE">\n</label><md-select ng-model="field.templateOptions.type"><md-option ng-repeat="typeInput in vm.typesInput" \nng-value="typeInput"><span ng-switch="typeInput"><md-icon md-font-icon="icon-format-list-numbers" class="mr-5 s20" \nng-switch-when="number"></md-icon><md-icon md-font-icon="icon-cellphone" class="mr-5 s20" ng-switch-when="tel">\n</md-icon><md-icon md-font-icon="icon-file-hidden" class="mr-5 s20" ng-switch-when="hidden"></md-icon><md-icon \nmd-font-icon="icon-email" class="mr-5 s20" ng-switch-when="email"></md-icon><md-icon md-font-icon="icon-format-text" \nclass="mr-5 s20" ng-switch-when="text"></md-icon><md-icon md-font-icon="icon-view-week" class="mr-5 s20" \nng-switch-default></md-icon></span>{{typeInput}}</md-option></md-select></md-input-container></div><div \nng-if="field.templateOptions.checkbox_complaint" flex="100" style="margin-top: 30px;"><md-input-container \nclass="md-block"><label translate="COMPLAINTS.PRIVACY_COMPLAINT_LINK"></label> <input \nng-model="field.templateOptions.complaint_link"></md-input-container><md-input-container class="md-block"><label \ntranslate="COMPLAINTS.COMPLAINT_LABEL"></label> <textarea ng-model="field.templateOptions.complaint_label" columns="1" \nrows="1"></textarea></md-input-container></div><div \nng-if="field.type && !field.templateOptions.checkbox_policy && !field.templateOptions.checkbox_complaint" flex="50" \nstyle="margin-top: 45px;"><md-input-container class="md-block"><label translate="COMPLAINTS.FIELD_NAME"></label> \n<textarea ng-model="field.templateOptions.label" columns="1" rows="1"></textarea></md-input-container></div><div \nng-if="field.templateOptions.checkbox_policy" flex="100" style="margin-top: 30px;"><md-input-container \nclass="md-block"><label translate="COMPLAINTS.PRIVACY_POLICY_LINK"></label> <input \nng-model="field.templateOptions.policy_link"></md-input-container></div><div \nng-if="field.templateOptions.checkbox_policy" flex="100" style="margin-top: 45px;"><md-input-container \nclass="md-block"><label translate="COMPLAINTS.PRIVACY_POLICY"></label> <textarea ui-tinymce="vm.tinymceOptions" \nng-model="field.templateOptions.policy" columns="1" rows="5"></textarea></md-input-container></div><div \nng-if="field.type && field.type === \'dropzone\'" flex="50" style="margin-top: 45px;"><md-input-container \nclass="md-block"><label translate="COMPLAINTS.PLACEHOLDER"></label> <input \nng-model="field.templateOptions.placeholder" columns="1" rows="1" placeholder=""></md-input-container></div><div \nng-if="field.type && field.type !== \'separator\'" \nstyle="margin-top: 45px; display: flex; justify-content: space-around;"><md-input-container class="md-block">\n<md-checkbox ng-model="field.templateOptions.required"></md-checkbox><span translate="COMPLAINTS.REQUIRED"></span>\n</md-input-container><md-input-container class="md-block" ng-if="field.type && field.type === \'checkbox\'"><md-checkbox \nng-model="field.templateOptions.value" \nng-change="field.defaultValue = field.templateOptions.value; vm.updateCheckboxComplaint(field)"></md-checkbox><span \ntranslate="COMPLAINTS.DEFAULT_VALUE"></span></md-input-container><md-input-container class="md-block" \nng-if="field.type && field.type === \'checkbox\'"><md-checkbox ng-model="field.templateOptions.checkbox_complaint">\n</md-checkbox><span translate="COMPLAINTS.CHECKBOX_COMPLAINT"></span></md-input-container></div><div \nng-if="field.type && (field.type === \'checkbox\' )" flex="50"></div><div class="validations-button" \nng-if="field.type && field.type !== \'separator\'" flex="50"><md-button \nng-if="field.type && (field.type === \'radio\' || (field.type === \'multiCheckbox\' && field.templateOptions.type !== \'users_group\') || (field.type === \'select\' ))" \ntranslate="COMPLAINTS.OPTIONS" \nclass="md-accent green-500-bg md-raised md-button md-ink-ripple md-default-theme md-button" \nng-click="vm.openOptionsDialog($event, $index, \'COMPLAINTS.OPTIONS\', \'options\')"></md-button></div><div \nng-if="vm.userLogued.email == \'roni@h2c.es\' ||\xA0vm.userLogued.email == \'test@muevaelvolante.com\' ||\xA0vm.userLogued.email == \'gabriel@muevaelvolante.com\'  ||\xA0vm.userLogued.email == \'gabriel@muevaelvolante.com\'" \nclass="pointer" ng-click="field.showAdvanced = !field.showAdvanced;" flex="100">Advanced<md-icon \nng-if="!field.showAdvanced" md-font-icon="icon-chevron-down"></md-icon><md-icon ng-if="field.showAdvanced" \nmd-font-icon="icon-chevron-down"></md-icon></div><div \nng-if="field.type && field.type !== \'separator\' && field.showAdvanced" flex="100"><md-input-container class="md-block">\n<label translate="COMPLAINTS.HIDE_EXPRESSION"></label> <input type="text" ng-model="field.hideExpression" columns="1" \nrows="1"></md-input-container></div><div class="flex-100" layout="row" layout-align="space-between center">\n<md-input-container ng-if="field.type == \'group\'" class="without-margin-sides" mt-0><md-button \nng-click="vm.groupDialog(field)" class="edit-button md-accent md-raised" ng-disabled="" aria-label="EDIT" \ntranslate="COMPLAINTS.EDIT" translate-attr-aria-label="COMPLAINTS.EDIT"></md-button></md-input-container>\n<md-input-container class="md-block without-margin-sides mt-0" flex layout="row" layout-align="end center"><md-button \ntype="submit" ng-click="vm.saveFieldStructure($index)" class="send-button md-accent md-raised" \nng-disabled="(field.templateOptions.checkbox_complaint && !field.templateOptions.complaint_label) || (!field.templateOptions.checkbox_complaint && !field.templateOptions.label)" \naria-label="SAVE" translate="COMPLAINTS.SAVE" translate-attr-aria-label="COMPLAINTS.SAVE"></md-button><md-button \ntype="button" ng-click="vm.cancelEditFieldStructure($index)" class="md-raised md-warn" aria-label="Cancel" \ntranslate="COMPLAINTS.CANCEL" translate-attr-aria-label="COMPLAINTS.CANCEL"></md-button></md-input-container></div>\n</div>');
$templateCache.put('app/main/apps/complaints/views/edit/editors/editors-view.html','<div class="field-row" ng-style="{\'opacity\' : field.hideExpression == \'true\' ? 0.4 : 1}" layout="row" \nlayout-align="start center" ng-if="(!field.temporary && !field.editing)"><md-icon class="drag icon-equal" \naria-label="DRAG"></md-icon><div ng-switch="field.type"><md-icon md-font-icon="icon-format-float-left" class="mr-30" \nng-switch-when="textarea"><md-tooltip hide show-gt-xs><span translate="textarea">{{\'COMPLAINTS.TEXTAREA\' | translate}}\n</span></md-tooltip></md-icon><md-icon md-font-icon="icon-format-text" class="mr-30" ng-switch-when="input"><md-tooltip\n hide show-gt-xs><span translate="Input">{{\'COMPLAINTS.INPUT\' | translate}}</span></md-tooltip></md-icon><md-icon \nmd-font-icon="icon-chevron-down" class="mr-30" ng-switch-when="select"><md-tooltip hide show-gt-xs><span \ntranslate="select">{{\'COMPLAINTS.SELECT_INPUT\' | translate}}</span></md-tooltip></md-icon><md-icon \nmd-font-icon="icon-radiobox-marked" class="mr-30" ng-switch-when="radio"><md-tooltip hide show-gt-xs><span \ntranslate="Radio">{{\'COMPLAINTS.RADIO\' | translate}}</span></md-tooltip></md-icon><md-icon md-font-icon="icon-tag" \nclass="mr-30" ng-switch-when="separator"><md-tooltip hide show-gt-xs><span translate="separator">\n{{\'COMPLAINTS.SEPARATOR\' | translate}}</span></md-tooltip></md-icon><md-icon \nmd-font-icon="icon-checkbox-marked-outline" class="mr-30" ng-switch-when="multiCheckbox"><md-tooltip hide show-gt-xs>\n<span translate="multiCheckbox">{{\'COMPLAINTS.MULTICHECK\' | translate}}</span></md-tooltip></md-icon><md-icon \nmd-font-icon="icon-checkbox-marked-outline" class="mr-30" ng-switch-when="checkbox"><md-tooltip hide show-gt-xs><span \ntranslate="checkbox">{{\'COMPLAINTS.CHECK\' | translate}}</span></md-tooltip></md-icon><md-icon \nmd-font-icon="icon-format-text" class="mr-30" ng-switch-when="image-crop"><md-tooltip hide show-gt-xs><span \ntranslate="Image">{{\'COMPLAINTS.IMAGE\' | translate}}</span></md-tooltip></md-icon><md-icon \nmd-font-icon="icon-attachment" class="mr-30" ng-switch-when="dropzone"><md-tooltip hide show-gt-xs><span \ntranslate="Image">{{\'COMPLAINTS.DROPZONE\' | translate}}</span></md-tooltip></md-icon><md-icon \nmd-font-icon="icon-calendar" class="mr-30" ng-switch-when="datepicker"><md-tooltip hide show-gt-xs><span \ntranslate="Image">{{\'COMPLAINTS.DATEPICKER\' | translate}}</span></md-tooltip></md-icon><md-icon \nmd-font-icon="icon-view-week" class="mr-30" ng-switch-default><md-tooltip hide show-gt-xs><span translate="checkbox">\n{{field.type}}</span></md-tooltip></md-icon></div><div class="template flex" layout="row" \nlayout-align="space-between center"><div class="field" layout="column"><div><span \nng-if="!field.templateOptions.checkbox_policy && !field.templateOptions.checkbox_complaint" \nclass="font-size-16 grey-700-fg" ng-bind="field.templateOptions.label"></span> <span \nng-if="field.templateOptions.checkbox_policy" class="font-size-16 grey-700-fg">{{field.templateOptions.policy_label}}\n</span> <span ng-if="field.templateOptions.checkbox_complaint" class="font-size-16 grey-700-fg">\n{{field.templateOptions.complaint_label}}</span></div><div class="content-editable" ng-switch="field.type" \nlayout="column"><span ng-switch-when="textBox" class="grey-500-fg font-size-14 mt-5" ng-if="field.defaultValue">\n{{field.defaultValue}}<md-tooltip hide show-gt-xs><span translate="COMPLAINTS.DEFAULT_VALUE">Default value</span>\n</md-tooltip></span><span ng-switch-when="lineSeparator" class="grey-500-fg font-size-14 mt-5" \nng-if="field.defaultValue">{{field.defaultValue}}</span><div \nng-if="!field.templateOptions.checkbox_policy && !field.templateOptions.checkbox_complaint" ng-switch-when="checkbox" \nlayout="row" layout-align="start center" class="mt-5"><span class="grey-500-fg font-size-14 mt-0 mr-5 text-truncate" \ntranslate="COMPLAINTS.DEFAULT_VALUE"></span><md-icon md-font-icon="icon-checkbox-marked" class="s18 m-0" \nng-if="field.templateOptions.value == 1"></md-icon><md-icon md-font-icon="icon-checkbox-blank" class="s18 m-0" \nng-if="field.templateOptions.value == 0"></md-icon><md-tooltip hide show-gt-xs \nng-if="field.templateOptions.value == 1"><span>Checked</span></md-tooltip><md-tooltip hide show-gt-xs \nng-if="field.templateOptions.value == 0"><span>Unchecked</span></md-tooltip></div></div></div><div \nclass="icons-toolbar" layout="row" layout-align="end center"><md-icon class="ml-5" md-font-icon="icon-pencil" \nng-click="vm.editFieldStructure($index)"><md-tooltip md-direction="bottom">{{\'COMPLAINTS.EDIT\' | translate}}\n</md-tooltip></md-icon><md-icon class="ml-5" md-font-icon="icon-delete" \nng-if="field.hideExpression !== \'true\' && field.extra" ng-click="vm.removeFieldStructure($index)" \nclass="md-default-theme md-font material-icons icon-delete"><md-tooltip md-direction="bottom">\n{{\'COMPLAINTS.REMOVE\' | translate}}</md-tooltip></md-icon><md-icon class="ml-5" md-font-icon="icon-eye-off" \nng-if="field.hideExpression !== \'true\' && !field.extra" ng-click="vm.hideFieldStructure($index)" \nclass="md-default-theme md-font material-icons icon-delete"><md-tooltip md-direction="bottom">\n{{\'COMPLAINTS.HIDE\' | translate}}</md-tooltip></md-icon><md-icon class="ml-5" md-font-icon="icon-eye" \nng-if="field.hideExpression == \'true\'" ng-click="vm.showFieldStructure($index)" \nclass="md-default-theme md-font material-icons icon-delete"><md-tooltip md-direction="bottom">\n{{\'COMPLAINTS.SHOW\' | translate}}</md-tooltip></md-icon></div></div></div>');
$templateCache.put('app/main/apps/complaints/views/edit/editors/preview.html','<md-content class="ph-15 pv-20 pb-100"><div ng-hide="field.hideExpression == \'true\'" \nng-repeat="field in vm.complaintFormDefault.fields track by $index"><div ng-if="!field.temporary && !field.editing">\n<div fill-width ng-if="field.type==\'textarea\'"><md-input-container class="md-block"><label>\n{{field.templateOptions.label}}</label> <textarea ng-disabled="field.templateOptions.disabled" rows="3" \nng-required="field.templateOptions.required" ng-model="vm.modelExample[field.key]" \nplaceholder="{{field.templateOptions.label}}"></textarea></md-input-container></div><div fill-width \nng-if="field.type==\'input\'"><md-input-container class="md-block" flex><label>{{field.templateOptions.label}}</label> \n<input ng-disabled="field.templateOptions.disabled" ng-required="field.templateOptions.required" \ntype="{{field.templateOptions.type}}" ng-model="vm.modelExample[field.key]" \nplaceholder="{{field.templateOptions.label}}"></md-input-container></div><div fill-width ng-if="field.type==\'select\'" \nclass="mb-25"><md-input-container class="md-block" flex><label>{{field.templateOptions.label}}</label><md-select \nng-disabled="field.templateOptions.disabled" ng-required="field.templateOptions.required" \nng-model="vm.modelExample[field.key]" placeholder="{{field.templateOptions.label}}"><md-option \nng-repeat="option in field.templateOptions.options" value="{{option.value}}">{{option.name}}</md-option></md-select>\n</md-input-container></div><div fill-width ng-if="field.type==\'radio\'"><label>{{field.templateOptions.label}}</label>\n<div class="mt-15"><md-radio-group ng-disabled="field.templateOptions.disabled" \nng-required="field.templateOptions.required" ng-model="vm.modelExample[field.key]"><div class="mh-15 inline-block" \nng-repeat="option in field.templateOptions.options"><md-radio-button value="{{option.value}}">{{option.name}}\n</md-radio-button></div></md-radio-group></div></div><div fill-width ng-if="field.type==\'separator\'" \nstyle="width: calc(100% + 30px); margin: 15px -15px;margin-bottom: 50px;"><md-list-item \nclass="bt md-toolbar-tools grey-100-bg"><h3 class="grey-700-fg">{{field.templateOptions.label}}</h3><md-divider>\n</md-divider></md-list-item></div><div fill-width ng-if="field.type==\'multiCheckbox\'"><fieldset class="standard">\n<label>{{field.templateOptions.label}}</label><div layout="row" layout-wrap flex><div \nng-repeat="option in field.templateOptions.options"><md-checkbox ng-disabled="field.templateOptions.disabled">\n{{ option.name }}</md-checkbox></div></div></fieldset></div><div fill-width \nng-if="field.type==\'checkbox\' && !field.templateOptions.checkbox_policy && !field.templateOptions.checkbox_complaint">\n<md-input-container><md-checkbox class="no-label" ng-disabled="field.templateOptions.disabled" \nng-model="vm.modelExample[field.key]">{{field.templateOptions.label}}</md-checkbox></md-input-container></div><div \nfill-width ng-if="field.type==\'checkbox\' && field.templateOptions.checkbox_policy"><md-input-container><md-checkbox \nclass="no-label" ng-disabled="field.templateOptions.disabled" ng-model="vm.modelExample[field.key]"><a target="_blank" \nhref="{{field.templateOptions.policy_link}}">{{field.templateOptions.policy_label}}</a></md-checkbox>\n</md-input-container><p ng-bind-html="field.templateOptions.policy"></p></div><div fill-width \nng-if="field.type==\'checkbox\' && field.templateOptions.checkbox_complaint"><md-input-container><md-checkbox \nclass="no-label" ng-disabled="field.templateOptions.disabled" ng-model="vm.modelExample[field.key]"><a target="_blank" \nhref="{{field.templateOptions.complaint_link}}">{{field.templateOptions.complaint_label}}</a></md-checkbox>\n</md-input-container><p ng-bind-html="field.templateOptions.complaint"></p></div><div fill-width \nng-if="field.type==\'datepicker\'"><div flex class="date-container"><label>{{field.templateOptions.label}}</label><div \nclass="mt-15" style="margin-left: -15px;"><md-datepicker ng-required="field.templateOptions.required" \nng-disabled="field.templateOptions.disabled" ng-model="vm.modelExample[field.key]" md-placeholder="--"></md-datepicker>\n</div></div></div><div fill-width ng-if="field.type==\'dropzone\'"><div layout="column"><div fill-width><div ngf-drop \nngf-select ng-model="vm.modelExample.files" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" \nngf-allow-dir="false"><div layout="column"><div flex ng-if="field.templateOptions.placeholder" \nstyle="text-align: center; padding: 20px; color: #666;">{{field.templateOptions.placeholder}}</div><div flex><md-button\n class="send-button md-accent md-raised" aria-label="Select files">{{field.templateOptions.label}}</md-button></div>\n</div></div><div ngf-no-file-drop translate="GLOBAL.FILE_DRAG_DROP"></div></div><div \nng-repeat="f in vm.modelExample.files" class="ms-card" flex><div class="ms-card-content-wrapper" style="margin: auto;">\n<div class="template-9"><div class="media" flex layout="row" layout-align="center center"><img \nngf-thumbnail="!f.$error && f" class="image"></div><div class="header p-16" flex><div layout="row" \nlayout-align="space-between center" flex><div class="size" layout="row" layout-align="start left"><strong class="mr-5" \nng-if="f.id">#{{f.id}}</strong> <span class="grey-500-fg"><span ng-if="f.name">{{f.name}}</span></span></div></div>\n</div><md-progress-linear md-mode="determinate" value="{{f.progress}}" ng-show="f.progress <100"></md-progress-linear>\n</div></div></div></div></div></div></div></md-content>');
$templateCache.put('app/main/apps/complaints/views/edit/tabs/acciones.html','<div style="max-height: 100%; overflow: auto;" class="fill-width"><md-divider></md-divider><md-list-item \nng-if="vm.complaintSelected.actions.length > 0" flex="" fill-width class="list-border" ng-class="{\'mt-10\': $first}" \nng-repeat="action in vm.complaintSelected.actions track by $index"><div class="fullwidth mb-15"><div layout="row"><img \nng-if="vm.getActionUserImage(action)" ng-src="{{vm.getActionUserImage(action)}}" class="avatar"><div \nclass="avatar s40" \nng-class="vm.getActionUser(action) && vm.getActionUser(action).profile_color ? vm.getActionUser(action).profile_color : \'md-blue-grey-300-bg\'" \nng-if="!vm.getActionUserImage(action)" ng-bind="vm.getActionUserInitial(action)"></div><div><strong \nclass="grey-800-fg">{{vm.getActionUserName(action)}}</strong> <span class="ml-5 time secondary-text"><i \nclass="fa fa-clock-o"></i> {{action.created_at|altDate}}</span><div class="message" ng-bind-html="action.action"></div>\n</div></div><div ng-if="action.files && action.files.length> 0" layout="row"><p class="m0 mt-10 grey-400-fg">\n{{\'TASKS.ATTACHED\' | translate}}:</p></div><div class="mv-10" ng-if="action.files && action.files.length> 0" \nlayout="column"><div class="mail-list-item attachment mv-5 pointer" ng-repeat="file in action.files" \ndata-id="{{file.id}}"><a href="{{file.url | buildFileUrl:storagePrefix}}" target="_blank"><div layout="row" \nlayout-align="start center"><div fill-width layout="row" layout-align="start center"><div class="media photos" \nlayout="row" layout-align="center center"><h2c-icon file="file.url"></h2c-icon><img style="max-width: 100px;" \nng-src="{{file.url | buildFileUrl:storagePrefix}}" alt=""></div><div class="info ml-10" flex layout="column"><div \nclass="subject text-truncate grey-500-fg" layout="row" layout-align="start center"><span class="time secondary-text">\n{{ file.created_at | altDate }}</span></div><div class="name" layout="row" layout-align="start center"><span \nng-if="file.original_name">{{file.original_name}}</span></div></div></div></div></a></div></div></div></md-list-item>\n<div ng-if="vm.complaintSelected.actions.length == 0" style="margin-top: 20%;" class="text-center"><div \nclass="no-thread-selected" layout="column" layout-align="center center" flex><md-icon md-font-icon="icon-timelapse" \nclass="s120 grey-400-fg"></md-icon><span class="hint-text">{{\'COMPLAINTS.NO_ACTIONS\' | translate}}</span></div></div>\n<div class="chat-compose-fab" layout="row" layout-align="end center"><button \nclass="add-event-button md-fab md-warn md-button md-default-theme" type="button" ng-click="vm.newAction($event)">\n<md-icon md-font-icon="icon-plus" role="img" aria-hidden="true"></md-icon></button></div></div>');
$templateCache.put('app/main/apps/complaints/views/edit/tabs/datos.html','<md-list style="max-height: 100%;overflow: auto;" ng-if="vm.complaintSelected" class="pv-20 fill-width"><md-list-item \nclass="main-item mb-15"><div class="main-read"><p ng-if="!editingEnabled">{{ vm.complaintSelected.description }}</p><p>\n<md-input-container ng-if="editingEnabled" class="md-block"><textarea id="descriptionTextarea" cols="200" \nng-model="vm.complaintSelected.description" ng-disabled="!editingEnabled"></textarea></md-input-container></p></div>\n</md-list-item><md-divider ng-if="vm.complaintSelected.complainant_name"></md-divider><div \nng-if="vm.complaintSelected.complainant_name"><div \nng-repeat="field in vm.complaintSelected.form.fields track by $index" \nng-if="field.type === \'separator\' && field.name === \'Datos del acusante\'"><md-divider></md-divider><md-list-item \nclass="md-toolbar-tools grey-100-bg"><h3 class="grey-700-fg complaint-field-label-truncate capitalize" \ntitle="{{ field.templateOptions.label }}">{{ field.templateOptions.label | lowercase }}</h3><md-divider></md-divider>\n</md-list-item></div></div><div \nng-if="vm.complaintSelected.complainant_name && !(vm.complaintSelected.form.fields | filter:{type: \'separator\', name: \'Datos del acusante\'}).length">\n<md-list-item class="md-toolbar-tools grey-100-bg"><h3 class="grey-700-fg" translate="COMPLAINTS.COMPLAINANT"></h3>\n<md-divider></md-divider></md-list-item></div><md-list-item ng-if="vm.complaintSelected.complainant_name"><div \nng-if="vm.complaintSelected.complainant_name" class="pv-15" layout="row" layout-align="start center"><div \nclass="avatar-wrapper"><div class="avatar-wrapper"><div class="avatar s24" \nng-bind="vm.complaintSelected.complainant_name | capitalizeFirstLetter" ms-random-class="vm.colors"></div></div></div>\n<div class="info layout-column flex" flex="" layout="column"><div class="name text-truncate" layout="row" \nlayout-align="start center"><span ng-if="vm.complaintSelected.anonymised !== 1">\n{{vm.complaintSelected.complainant_name}}</span> <span ng-if="vm.complaintSelected.anonymised !== 1">\n{{vm.complaintSelected.complainant_lastname}}</span></div><div class="details text-truncate p0" layout="row" \nlayout-align="start center"><span ng-if="vm.complaintSelected.anonymised !== 1">\n{{vm.complaintSelected.complainant_email}}</span> <span class="ml-15" ng-if="vm.complaintSelected.anonymised !== 1">\ntel: <span class="font-size-12">{{vm.complaintSelected.complainant_phone}}</span></span></div><div \nng-if="vm.complaintSelected.anonymised === 1" class="data-anonymized">{{ \'COMPLAINTS.DATA_ANONYMISED\' | translate }}\n</div></div></div><div ng-if="!vm.complaintSelected.complainant_name" class="info layout-column flex" flex="" \nlayout="column"><div class="name text-truncate" layout="row" layout-align="start center"><span \ntranslate="COMPLAINTS.NO_COMPLAINANT_DATA">No complainant data</span></div></div></md-list-item><md-divider \nng-if="vm.complaintSelected.accused_name"></md-divider><div ng-if="vm.complaintSelected.accused_name"><div \nng-repeat="field in vm.complaintSelected.form.fields track by $index" \nng-if="field.type === \'separator\' && field.name === \'Datos del acusado\'"><md-divider></md-divider><md-list-item \nclass="md-toolbar-tools grey-100-bg"><h3 class="grey-700-fg complaint-field-label-truncate capitalize" \ntitle="{{ field.templateOptions.label }}">{{ field.templateOptions.label | lowercase }}</h3><md-divider></md-divider>\n</md-list-item></div></div><div \nng-if="vm.complaintSelected.accused_name && !(vm.complaintSelected.form.fields | filter:{type: \'separator\', name: \'Datos del acusado\'}).length">\n<md-list-item class="md-toolbar-tools grey-100-bg"><h3 class="grey-700-fg" translate="COMPLAINTS.ACCUSED"></h3>\n<md-divider></md-divider></md-list-item></div><md-list-item ng-if="vm.complaintSelected.accused_name"><div \nng-if="vm.complaintSelected.accused_name" class="pv-15" layout="row" layout-align="start center"><div \nclass="avatar-wrapper"><div class="avatar-wrapper"><div class="avatar s24" \nng-bind="vm.complaintSelected.accused_name | capitalizeFirstLetter" ms-random-class="vm.colors"></div></div></div><div \nclass="info layout-column flex" flex="" layout="column"><div class="name text-truncate" layout="row" \nlayout-align="start center"><span ng-if="vm.complaintSelected.anonymised !== 1">{{vm.complaintSelected.accused_name}}\n</span> <span ng-if="vm.complaintSelected.anonymised !== 1">{{vm.complaintSelected.accused_lastname}}</span></div><div \nclass="details text-truncate p0" layout="row" layout-align="start center"><span \nng-if="vm.complaintSelected.anonymised !== 1">{{vm.complaintSelected.accused_division}}</span></div><div \nng-if="vm.complaintSelected.anonymised === 1" class="data-anonymized">{{ \'COMPLAINTS.DATA_ANONYMISED\' | translate }}\n</div></div></div><div ng-if="!vm.complaintSelected.accused_name" class="info layout-column flex" flex="" \nlayout="column"><div class="name text-truncate" layout="row" layout-align="start center"><span \ntranslate="COMPLAINTS.NO_ACCUSED_DATA"></span></div></div></md-list-item><md-divider \nng-if="vm.getComplaintFormTypeNameById(vm.complaintSelected)"></md-divider><md-list-item \nclass="md-toolbar-tools grey-100-bg" ng-if="vm.getComplaintFormTypeNameById(vm.complaintSelected)"><h3 \nclass="grey-700-fg" translate="COMPLAINTS.COMPLAINT_INFO"></h3><md-divider></md-divider></md-list-item><md-list-item \nng-if="vm.complaintSelected"><div class="fullwidth mb-15"><h3 style="display: inline-block;">\n{{ \'COMPLAINTS.COMPLAINT_TYPE\' | translate }}:</h3><div ng-if="editingEnabled" \nstyle="display: inline-block; margin-left: 10px;"><md-select ng-model="vm.complaintSelected.complaint_type" \nclass="md-no-underline custom-font-size"><md-option \nng-repeat="option in (vm.complaintSelected.form.fields | filter:{key: \'complaint_type\'})[0].templateOptions.options" \nng-value="option.value">{{ option.name }}</md-option></md-select></div><div ng-if="!editingEnabled" \nclass="custom-font-size" style="display: inline-block; margin-left: 10px;"><span>\n{{ ((vm.complaintSelected.form.fields | filter:{key: \'complaint_type\'})[0].templateOptions.options | filter:{value: vm.complaintSelected.complaint_type})[0].name }}\n</span></div><div layout="row" layout-align="space-between start" class="fullwidth"><span flex="50" \nclass="grey-fg font-size-12"><span translate="COMPLAINTS.CREATED"></span>: {{vm.complaintSelected.created_at_format}} \n</span><span flex="50" class="grey-fg font-size-12"><span translate="COMPLAINTS.UPDATED"></span>\n: {{vm.complaintSelected.updated_at_format}}</span></div></div></md-list-item><div \nng-repeat="field in vm.extraFields track by $index" ng-if="field.value"><md-list-item \nclass="md-toolbar-tools grey-100-bg"><h3 class="grey-700-fg complaint-field-label-truncate" \ntitle="{{field.templateOptions.label}}">{{field.templateOptions.label}}</h3><md-divider></md-divider></md-list-item>\n<md-list-item role="listitem" class="md-no-proxy _md"><div class="info ng-scope layout-column flex" flex="" \nlayout="column"><div class="name text-truncate layout-align-start-center layout-row" layout="row" \nlayout-align="start center"><span ng-if="!editingEnabled">\n{{ (field.value === true || field.value === \'true\') ? (\'COMPLAINTS.YES\' | translate) : (field.value === false || field.value === \'false\') ? (\'COMPLAINTS.NO\' | translate) : field.value }}\n</span> <span ng-if="editingEnabled"><md-input-container class="md-block"><textarea id="fieldTextarea" cols="50" \nng-model="field.value"></textarea></md-input-container></span></div></div></md-list-item></div><div><md-list-item \nng-if="vm.complaintSelected.form_files && vm.complaintSelected.form_files.upload_files && vm.complaintSelected.form_files.upload_files.length> 0" \nclass="md-toolbar-tools grey-100-bg"><h3 class="grey-700-fg" translate="TASKS.ATTACHED"></h3><md-divider></md-divider>\n</md-list-item><div class="m-10" \nng-if="vm.complaintSelected.form_files && vm.complaintSelected.form_files.upload_files && vm.complaintSelected.form_files.upload_files.length> 0" \nlayout="column"><div class="mail-list-item attachment mv-5 pointer" \nng-repeat="file in vm.complaintSelected.form_files.upload_files" data-id="{{file.id}}"><a \nstyle="text-decoration: none;" href="{{file.url | buildFileUrl:storagePrefix}}" target="_blank"><div layout="row" \nlayout-align="start center"><div fill-width layout="row" layout-align="start center"><div class="media photos" \nlayout="row" layout-align="center center"><h2c-icon file="file.url"></h2c-icon><img style="max-width: 100px;" \nng-src="{{file.url | buildFileUrl:storagePrefix}}" alt=""></div><div class="info ml-10" flex layout="column"><div \nclass="subject text-truncate grey-500-fg" layout="row" layout-align="start center"><span>{{file.created_at }}</span>\n</div><div class="name" layout="row" layout-align="start center"><span ng-if="file.original_filename">\n{{file.original_filename}}</span></div></div></div></div></a></div></div></div></md-list>');
$templateCache.put('app/main/apps/complaints/views/edit/tabs/documentos.html','<div ng-if="!vm.complaintSelected.data_files || vm.complaintSelected.data_files.length == 0" fill-width \nstyle="margin-top: 20%;" class="text-center"><div class="no-thread-selected" layout="column" \nlayout-align="center center" flex><md-icon md-font-icon="icon-timelapse" class="s120 grey-400-fg"></md-icon><span \nclass="hint-text">{{\'COMPLAINTS.NO_DOCUMENTS\' | translate}}</span></div></div><div class="m-10" \nng-if="vm.complaintSelected.data_files && vm.complaintSelected.data_files.length> 0" layout="column"><div \nclass="mail-list-item attachment mv-5 pointer" ng-repeat="file in vm.complaintSelected.data_files" \ndata-id="{{file.id}}"><a style="text-decoration: none;" href="{{file.url | buildFileUrl:storagePrefix}}" \ntarget="_blank"><div layout="row" layout-align="start center"><div fill-width layout="row" layout-align="start center">\n<div class="media photos" layout="row" layout-align="center center"><h2c-icon file="file.url"></h2c-icon><img \nstyle="max-width: 100px;" ng-src="{{file.url | buildFileUrl:storagePrefix}}" alt=""></div><div class="info ml-10" flex \nlayout="column"><div class="subject text-truncate grey-500-fg" layout="row" layout-align="start center"><span>\n{{file.created_at }}</span></div><div class="name" layout="row" layout-align="start center"><span \nng-if="file.original_filename">{{file.original_filename}}</span></div></div></div></div></a></div></div>');
$templateCache.put('app/main/apps/complaints/views/edit/tabs/mensajes.html','<chat-view \nanonymousname="vm.complaintSelected.anonymous_complaint != 0 ? \'\' : (vm.complaintSelected.complainant_name || vm.complaintSelected.complainant_lastname ? (vm.complaintSelected.complainant_name || \'\') + \' \' + (vm.complaintSelected.complainant_lastname || \'\') : vm.translate(\'COMPLAINTS.ANONYMOUS\'))" \nanonymous="vm.complaintSelected.anonymous_complaint != 0" \nfiles="vm.complaintSelected.form_files ? vm.complaintSelected.form_files.messages : null" class="fill-width" \nrelatedtype="\'complaints\'" id="vm.idChat"></chat-view>');
$templateCache.put('app/main/apps/complaints/views/edit/tabs/tareas.html','<tasks-section-view nolistadd="true" availableusers="vm.availableUsers" idrelated="vm.idTasksRelated" fill-width \nrelatedtype="\'complaints\'"></tasks-section-view>');
$templateCache.put('app/main/apps/gantt-chart/dialogs/add-edit/views/row-form-view.html','<div class="row" layout="column"><form name="rowForm" ng-submit="vm.dialogType === \'add\'?vm.addNewRow():vm.saveRow();">\n<div class="form-content"><div layout="row"><div flex class="input-block"><md-input-container flex class="row-name">\n<label>Row Name</label> <input name="name" ng-model="vm.row.name" required></md-input-container></div></div><div \nlayout="column" layout-gt-sm="row" layout-align="start start"><div class="input-block" flex><md-input-container flex>\n<label>Parent Row:</label><md-select ng-model="vm.row.parent"><md-option value="">No Parent</md-option><md-option \nng-repeat="row in vm.chartData" ng-value="row.id">{{row.name}}</md-option></md-select></md-input-container></div><div \nclass="input-block" flex layout="row" layout-align="space-between center"><label>Sortable:</label><md-switch \nng-model="vm.row.sortable" aria-label="Sortable"></md-switch></div></div><div layout="column" layout-gt-sm="row" \nlayout-align="start center"><div class="input-block" flex layout="row" layout-align="space-between center"><label>\nRow Color:</label><ms-material-color-picker ng-model="vm.row.classes[1]"></ms-material-color-picker></div><div flex \nclass="input-block"><md-input-container flex layout="row" layout-align="space-between center"><label>Extra Class\n</label> <input name="name" ng-model="vm.row.classes[0]"></md-input-container></div></div></div><md-dialog-actions>\n<md-button ng-if="vm.dialogType === \'edit\'" class="md-icon-button" ng-click="vm.removeRow()" aria-label="Remove">\n<md-icon md-font-icon="icon-delete"></md-icon></md-button><md-button type="submit" class="md-accent md-raised" \nng-disabled="rowForm.$invalid || rowForm.$pristine" aria-label="Save"><span ng-if="vm.dialogType === \'add\'">Add</span> \n<span ng-if="vm.dialogType === \'edit\'">Save</span></md-button></md-dialog-actions></form></div>');
$templateCache.put('app/main/apps/gantt-chart/dialogs/add-edit/views/task-form-view.html','<div class="task" layout="column"><form name="taskForm" \nng-submit="vm.dialogType === \'add\'?vm.addNewTask():vm.saveTask();"><div class="form-content"><div layout="row"><div \nflex class="input-block"><md-input-container flex class="task-name"><label>Task Name</label> <input name="name" \nng-model="vm.task.name" required></md-input-container></div></div><div layout="column" layout-gt-sm="row" \nlayout-align="start start"><div class="input-block" flex layout="row" layout-align="space-between center"><label>From:\n</label><md-datepicker name="fromDate" ms-datepicker-fix ng-model="vm.task.from" md-placeholder="Select Date" \nng-required></md-datepicker></div><div class="input-block" flex layout="row" layout-align="space-between center">\n<label>To:</label><md-datepicker name="toDate" ms-datepicker-fix ng-model="vm.task.to" md-placeholder="Select Date" \nng-required></md-datepicker></div></div><div ng-if="vm.dialogType === \'add\'" layout="row" layout-align="start start">\n<div flex class="input-block"><md-input-container><label>Row:</label><md-select name="rowId" ng-model="vm.taskRowId" \nrequired><md-option ng-repeat="row in vm.chartData" ng-value="row.id">{{row.name}}</md-option></md-select>\n</md-input-container></div></div><div layout="row" layout-align="start center" class="input-block"><label flex="25">\nProgress: <small>{{vm.task.progress}}</small></label><md-slider flex ng-model="vm.task.progress" step="1" min="0" \nmax="100" aria-label="Progress"></md-slider></div><div layout="column" layout-gt-sm="row" layout-align="start center">\n<div class="input-block" flex layout="row" layout-align="space-between center"><label>Task Color:</label>\n<ms-material-color-picker ng-model="vm.task.classes[1]"></ms-material-color-picker></div><div flex class="input-block">\n<md-input-container flex layout="row" layout-align="space-between center"><label>Extra Class</label> <input \nname="name" ng-model="vm.task.classes[0]"></md-input-container></div></div></div><md-dialog-actions><md-button \nng-if="vm.dialogType === \'edit\'" class="md-icon-button" ng-click="vm.removeTask()" aria-label="Remove"><md-icon \nmd-font-icon="icon-delete"></md-icon></md-button><md-button class="md-accent md-raised" type="submit" \nng-disabled="taskForm.$invalid || taskForm.$pristine" aria-label="Save"><span ng-if="vm.dialogType === \'add\'">Add\n</span> <span ng-if="vm.dialogType === \'edit\'">Save</span></md-button></md-dialog-actions></form></div>');
$templateCache.put('app/main/apps/inputs/views/read/form-tabs/step-branchs.html','<div layout="column" layout-gt-xs="row"><md-input-container flex><h1 translate="GLOBAL.MAIN_BRANCH"></h1>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="GLOBAL.NAME"></label> <input ng-model="vm.formWizard.main_branch.name" type="text"></md-input-container>\n<md-input-container flex><label translate="GLOBAL.ADDRESS"></label> <input \nng-model="vm.formWizard.main_branch.address1" type="text" required></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container flex><label>{{vm.getRegionLiteral(\'city\')}}</label> <input \nng-model="vm.formWizard.main_branch.city" type="text" required></md-input-container><md-input-container flex><label>\n{{vm.getRegionLiteral(\'state\')}}</label> <input ng-model="vm.formWizard.main_branch.state" type="text" required>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="GLOBAL.POSTAL_CODE"></label> <input ng-model="vm.formWizard.main_branch.postcode" type="text" required>\n</md-input-container><md-input-container flex><label translate="GLOBAL.PHONE"></label> <input \nng-model="vm.formWizard.main_branch.phone" type="text"></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container flex><label translate="GLOBAL.EMAIL"></label> <input \nng-model="vm.formWizard.main_branch.email" type="text"></md-input-container><md-input-container flex>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container class="group-form" flex="100" \nflex-gt-xs="100"><div layout="row" layout-align="start center"><h1 translate="GLOBAL.BRANCH"></h1><md-button \nng-click="vm.openDialogForm(\'branch\')" class="ml-10 md-mini add-event-button md-fab md-warn"><md-icon \nmd-font-icon="icon-plus"></md-icon></md-button></div><div class="mail-list-pane s0" \nng-if="vm.formWizard.branch && vm.formWizard.branch.length > 0"><div class="items" ng-if="!branch.is_main" \nng-repeat="branch in vm.formWizard.branch"><div layout="row" layout-align="start center" flex="100" class="p-20"><div \nlayout="row" layout-align="start center" flex="90"><div class="avatar-wrapper"><md-icon md-font-icon="icon-city">\n</md-icon></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding" \nng-bind-html="branch.name"></strong><div class="field grey-600-fg ng-binding"><span ng-if="branch.city" \nng-bind-html="branch.city"></span> <span ng-if="branch.city && branch.state">, </span><span ng-if="branch.state" \nng-bind-html="branch.state"></span></div></div></div><div class="menu" flex="10" layout-align="center end" \nlayout="column"><md-menu class="float-right"><md-button class="md-icon-button" aria-label="More" \nng-click="vm.openMenu($mdMenu, $event)"><md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg">\n</md-icon></md-button><md-menu-content width="2"><md-menu-item><md-button translate="GLOBAL.EDIT" \nng-click="vm.editBranchDialog($event, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div></md-input-container></div>');
$templateCache.put('app/main/apps/inputs/views/read/form-tabs/step-company.html','<div layout="column" layout-gt-xs="row"><md-input-container flex><label translate="GLOBAL.SOCIAL_REASON"></label> \n<input type="text" ng-model="vm.formWizard.company.name" required></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container flex><label>{{vm.getRegionLiteral(\'tax_ic_number\')}}</label> <input type="text" \nng-model="vm.formWizard.company.tax_id_number"></md-input-container><md-input-container flex><label \ntranslate="GLOBAL.SECTOR"></label><md-select ng-model="vm.formWizard.company.sector_id"><md-option \nng-repeat="sector in vm.sectors track by $index" ng-value="sector.id">{{sector.name}}</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="GLOBAL.REGION"></label><md-select ng-model="vm.formWizard.company.region_id"><md-option \nng-repeat="region in vm.regions track by $index" ng-value="region.id">{{region.name}}</md-option></md-select>\n</md-input-container><md-input-container flex></md-input-container></div><div layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container><p class="mt-0 grey-400-fg" translate="GLOBAL.LOGOTYPE"></p><div \nclass="header simple relative" ng-if="image || imageUrl" layout="row" layout-align="space-between center"><md-menu>\n<button class="md-icon-button" aria-label="More"><div layout="column" layout-align="start center" \nng-click="$mdMenu.open($event)"><div class="media" flex layout="row" layout-align="center center"><img \nngf-thumbnail="!image.$error && image" class="image"> <img ng-if="!image && imageUrl" src="{{imageUrl}}" class="image">\n</div><md-button class="md-mini add-event-button no-sort md-fab md-warn block absolute-top-right" \naria-label="Add event"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button></div></button><md-menu-content\n width="3"><md-menu-item><md-button ng-click="vm.deleteLogotype()" aria-label="Toggle done" \ntranslate-attr-aria-label="GLOBAL.REMOVE"><md-icon md-font-icon="icon-close" class="s18"></md-icon><span \ntranslate="GLOBAL.REMOVE"></span></md-button></md-menu-item></md-menu-content></md-menu></div><div \nng-if="!image && !imageUrl" ng-click="vm.mediaDialogSingle($event, vm.formWizard.company.logotype)" class="relative">\n<img src="assets/images/logos/generic-logo.png" class="image"><md-button \nclass="md-mini add-event-button no-sort md-fab md-warn block absolute-top-right" aria-label="Add event" translate \ntranslate-attr-aria-label="CALENDAR.ADD_EVENT"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n</md-input-container></div>');
$templateCache.put('app/main/apps/inputs/views/read/form-tabs/step-options.html','<div class="options"><div layout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container \nfill-width flex><label translate="GLOBAL.DESCRIPTION"></label> <input type="text" \nng-model="vm.formWizard.company.description"></md-input-container><md-input-container fill-width flex><label \ntranslate="GLOBAL.COMPANY_TYPE"></label><md-select ng-model="vm.formWizard.company.extra_data.company_type"><md-option \nng-value="1">SA</md-option><md-option ng-value="2">SL</md-option><md-option ng-value="3">Cotizada</md-option><md-option\n ng-value="4">Fundaciones/asociaciones</md-option><md-option ng-value="5">Otras</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container\n fill-width flex><label translate="GLOBAL.EXECUTIVE_TYPE"></label><md-select \nng-model="vm.formWizard.company.extra_data.executives_type"><md-option ng-value="1">Accionista \xFAnico</md-option>\n<md-option ng-value="2">Varios accionistas</md-option><md-option ng-value="3">Consejo de administraci\xF3n</md-option>\n<md-option ng-value="4">Administrador \xFAnico</md-option><md-option ng-value="5">Otros</md-option></md-select>\n</md-input-container><md-input-container fill-width flex><label translate="GLOBAL.SOCIAL_CAPITAL"></label><md-select \nng-model="vm.formWizard.company.extra_data.capital"><md-option ng-value="1">Capital</md-option><md-option ng-value="2">\nAportaciones de socios</md-option><md-option ng-value="3">Aumentos de capital recientes</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container\n fill-width flex><label translate="GLOBAL.AMOUNT_CAPITAL"></label> <input type="number" type="text" \nng-model="vm.formWizard.company.extra_data.capital_amount"></md-input-container><md-input-container fill-width flex>\n<label translate="GLOBAL.BILLING_LAST_YEAR"></label> <input type="number" \nng-model="vm.formWizard.company.turnover_volume"></md-input-container></div><div layout="column" layout-gt-xs="row" \nflex layout-align="start center"><md-input-container fill-width flex><label>Cuentas anuales</label><md-select \nng-model="vm.formWizard.company.extra_data.annual_accounts"><md-option ng-value="1">Abreviadas</md-option><md-option \nng-value="2">Normales</md-option><md-option ng-value="3">Pymes</md-option><md-option ng-value="4">Mixtas</md-option>\n</md-select></md-input-container><md-input-container fill-width flex><label>Auditor\xEDas</label><md-select \nng-model="vm.formWizard.company.extra_data.audits"><md-option ng-value="1">Internas</md-option><md-option ng-value="2">\nExternas</md-option><md-option ng-value="3">No aplica</md-option></md-select></md-input-container></div><div \nlayout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container fill-width flex><label>\nCertificaciones ISO</label><md-select ng-model="vm.formWizard.company.extra_data.iso_certification"><md-option \nng-value="1">ISO 9001</md-option><md-option ng-value="2">ISO 14000</md-option><md-option ng-value="3">ISO 14001\n</md-option><md-option ng-value="4">ISO 19600</md-option><md-option ng-value="5">ISO 22000</md-option><md-option \nng-value="6">ISO 26000</md-option><md-option ng-value="7">ISO 27001</md-option><md-option ng-value="8">ISO 37001\n</md-option><md-option ng-value="9">OHSAS 18001</md-option></md-select></md-input-container><md-input-container \nfill-width flex><label>Convenio Colectivo Aplicable</label> <input type="text" \nng-model="vm.formWizard.company.extra_data.collective_agreement"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" flex layout-align="start center"><md-input-container fill-width flex><label>Seguros contratados\n</label> <input type="text" ng-model="vm.formWizard.company.extra_data.insurance"></md-input-container>\n<md-input-container fill-width flex><label translate="GLOBAL.CNAE"></label> <input type="text" \nng-model="vm.formWizard.company.extra_data.cnae"></md-input-container></div><div layout="column" layout-gt-xs="row" \nflex layout-align="start center"><md-input-container fill-width layout="row" layout-align="start center" flex><label \nclass="ph-15" fill-width translate="GLOBAL.FINANCING"></label><md-select flex \nng-init="!vm.formWizard.company.extra_data.financing ? vm.formWizard.company.extra_data.financing = [] : null;" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.financing"><md-option \nng-repeat="option in vm.financing_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container><md-input-container fill-width layout="row" layout-align="start center" flex><label class="ph-15" \nfill-width>Normativa Sectorial aplicable</label><md-select flex \nng-init="!vm.formWizard.company.extra_data.sector_regulations ? vm.formWizard.company.extra_data.sector_regulations = [] : null;" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.sector_regulations"><md-option \nng-repeat="option in vm.sector_regulations_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-align="start center"><md-input-container \nfill-width layout="row" layout-align="start center" flex><label class="ph-15" fill-width>Medidas implementadas</label>\n<md-select flex \nng-init="!vm.formWizard.company.extra_data.implemented_measures ? vm.formWizard.company.extra_data.implemented_measures = [] : null;" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.implemented_measures"><md-option \nng-repeat="option in vm.implemented_measures_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container></div><div class="separator-options" layout="row"><h2>Grupo de sociedades?</h2><md-input-container\n fill-width layout="row" layout-align="start center" flex class="mb-0"><md-checkbox \nng-checked="vm.formWizard.company.extra_data.belogns_to_holding" \nng-model="vm.formWizard.company.extra_data.belogns_to_holding"></md-checkbox></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-align="start center"></div><div \nng-if="vm.formWizard.company.extra_data.belogns_to_holding" layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container fill-width flex><label>Nombre corporaci\xF3n</label> <input type="text" \nng-model="vm.formWizard.company.extra_data.name_corporation"></md-input-container><md-input-container fill-width flex>\n<label>CIF corporaci\xF3n</label> <input type="text" ng-model="vm.formWizard.company.extra_data.cif_corporation">\n</md-input-container></div><div class="mv-25" ng-if="vm.formWizard.company.extra_data.belogns_to_holding" \nlayout="column" layout-gt-xs="row" layout-align="start center"><div fill-width><div ngf-drop ngf-select \nng-model="vm.files_belogns_to_holding" class="drop-box" layout="column" layout-gt-xs="row" \nngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="belogns_to_holding_isLoading"><div flex layout="column" layout-align="center center" layout-padding \nlayout-margin class="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30">\n</md-progress-circular></div></div></div><div layout="column" flex><div \nng-repeat="f in vm.formWizard.company.extra_data.belogns_to_holding_files track by $index" class="border-bottom" flex>\n<div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><div class="media photos" layout="row" layout-align="center center"><h2c-icon \nfile="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" alt=""></div><div class="info ml-15" flex \nlayout="column" layout-align="center center"><div class="name" layout="row" layout-align="center center"><span \nng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu class="float-right"><md-button \nclass="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.belogns_to_holding_files.splice($index, 1);"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></div></div></div><div class="separator-options" \nlayout="row"><h2>Responsabilidad social corporativa?</h2><md-input-container fill-width layout="row" \nlayout-align="start center" flex class="mb-0"><md-checkbox \nng-checked="vm.formWizard.company.extra_data.social_responsability" \nng-model="vm.formWizard.company.extra_data.social_responsability"></md-checkbox></md-input-container></div><div \nclass="mv-25" ng-if="vm.formWizard.company.extra_data.social_responsability" layout="column" layout-gt-xs="row" \nlayout-align="start center"><div fill-width><div ngf-drop ngf-select ng-model="vm.files_social_responsability" \nclass="drop-box" layout="column" layout-gt-xs="row" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" \nngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="social_responsability_isLoading"><div flex layout="column" layout-align="center center" layout-padding \nlayout-margin class="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30">\n</md-progress-circular></div></div></div><div layout="column" flex><div \nng-repeat="f in vm.formWizard.company.extra_data.social_responsability_files track by $index" class="border-bottom" \nflex><div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><div class="media photos" layout="row" layout-align="center center"><h2c-icon \nfile="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" alt=""></div><div class="info ml-15" flex \nlayout="column" layout-align="center center"><div class="name" layout="row" layout-align="center center"><span \nng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu class="float-right"><md-button \nclass="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.social_responsability_files.splice($index, 1);"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></div></div></div><div class="separator-options" \nlayout="row"><h2>IVA</h2></div><div class="mv-25" layout="column"><div layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container fill-width flex><md-select \nng-model="vm.formWizard.company.extra_data.tax_options"><md-option ng-value="1">Presentaci\xF3n trimestral</md-option>\n<md-option ng-value="2">Presentaci\xF3n mensual</md-option></md-select></md-input-container><md-input-container \nfill-width flex></md-input-container></div><div layout="column" layout-gt-xs="row" layout-align="start center"><div \nfill-width><div ngf-drop ngf-select ng-model="vm.files_iva" class="drop-box" layout="column" layout-gt-xs="row" \nngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="iva_isLoading"><div flex layout="column" layout-align="center center" layout-padding layout-margin \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n</div></div><div layout="column" flex><div ng-repeat="f in vm.formWizard.company.extra_data.iva_files track by $index" \nclass="border-bottom" flex><div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size" layout="row" layout-align="start left"><div class="media photos" layout="row" \nlayout-align="center center"><h2c-icon file="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" \nalt=""></div><div class="info ml-15" flex layout="column" layout-align="center center"><div class="name" layout="row" \nlayout-align="center center"><span ng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.iva_files.splice($index, 1);"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div></div></div></div></div><div class="separator-options" layout="row"><h2>\nImpuesto de sociedades</h2></div><div class="mv-25" layout="column"><div layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container fill-width flex><md-datepicker \nng-model="vm.formWizard.company.extra_data.date_is" md-placeholder="Fecha"></md-datepicker></md-input-container>\n<md-input-contaimer class="md-block" flex><md-select ng-model="vm.formWizard.company.extra_data.currency_is" \nplaceholder="{{ \'GLOBAL.CURRENCY\' |\xA0translate}}"><md-option ng-repeat="currency in vm.currencies" \nng-value="currency.id">{{currency.symbol}}</md-option></md-select></md-input-contaimer><md-input-container fill-width \nflex><label translate="GLOBAL.AMOUNT_CAPITAL"></label> <input type="number" type="text" \nng-model="vm.formWizard.company.extra_data.amount_is"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-align="start center"><div fill-width><div ngf-drop ngf-select ng-model="vm.files_is" \nclass="drop-box" layout="column" layout-gt-xs="row" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" \nngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="is_isLoading"><div flex layout="column" layout-align="center center" layout-padding layout-margin \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n</div></div><div layout="column" flex><div ng-repeat="f in vm.formWizard.company.extra_data.is_files track by $index" \nclass="border-bottom" flex><div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size" layout="row" layout-align="start left"><div class="media photos" layout="row" \nlayout-align="center center"><h2c-icon file="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" \nalt=""></div><div class="info ml-15" flex layout="column" layout-align="center center"><div class="name" layout="row" \nlayout-align="center center"><span ng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.is_files.splice($index, 1);"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/inputs/views/read/form-tabs/step-people-global.html','<div layout="column" layout-gt-xs="row"><div class="mail-list-pane s0" flex="100"><div layout-gt-xs="row" \nlayout="column" class="mb-20"><div flex="20"><div layout="row" layout-align="start center" flex="100" \nclass="p-20 layout-align-start-center layout-row flex-100"><div layout="row" layout-align="start center" flex="100" \nclass="layout-align-start-center layout-row flex-100"><div class="avatar-wrapper"><md-icon md-font-icon="icon-city">\n</md-icon></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding" \nng-bind-html="vm.formWizard.main_branch.name"></strong><div class="field grey-600-fg ng-binding"><span \nng-if="vm.formWizard.main_branch.city" ng-bind-html="vm.formWizard.main_branch.city"></span> <span \nng-if="vm.formWizard.main_branch.city && vm.formWizard.main_branch.state">, </span><span \nng-if="vm.formWizard.main_branch.state" ng-bind-html="vm.formWizard.main_branch.state"></span></div></div></div></div>\n</div><div flex="80"><div layout="row" layout-align="start center"><div class="mail-list-pane s0" flex="100"><div \nclass="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="user.branch_id == vm.formWizard.main_branch.id"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId != user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong><div class="field grey-600-fg ng-binding"><span>\n{{vm.getDivisionName(user.division)[0].name}} | {{vm.getPositionName(user.position)[0].name}}</span></div></div></div>\n</div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu class="float-right">\n<md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" \nng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\', vm.formWizard.main_branch)"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div><div class="items"><div layout="row" \nlayout-align="start center" flex="100" class="pt-10 pb-10"><div class="info" flex layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><md-button \nng-click="vm.openDialogForm(\'personnel\', vm.formWizard.main_branch.id)" \nclass="md-mini add-event-button md-fab md-warn mh-0"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n</div></div></div></div></div></div></div></div></div><div layout-gt-xs="row" layout="column" class="mb-20" \nng-repeat="branch in vm.formWizard.branch" ng-if="branch.id != vm.formWizard.main_branch.id"><div flex="20"><div \nlayout="row" layout-align="start center" flex="100" class="p-20 layout-align-start-center layout-row flex-100"><div \nlayout="row" layout-align="start center" flex="100" class="layout-align-start-center layout-row flex-100"><div \nclass="avatar-wrapper"><md-icon md-font-icon="icon-city"></md-icon></div><div class="field mr-10 ml-10 flex" flex="">\n<strong class="grey-800-fg ng-binding" ng-bind-html="branch.name"></strong><div class="field grey-600-fg ng-binding">\n<span ng-if="branch.city" ng-bind-html="branch.city"></span> <span ng-if="branch.city && branch.state">, </span><span \nng-if="branch.state" ng-bind-html="branch.state"></span></div></div></div></div></div><div flex="80"><div layout="row" \nlayout-align="start center"><div class="mail-list-pane s0" flex="100"><div class="items" \nng-repeat="user in vm.formWizard.personnel track by $index" ng-if="user.branch_id == branch.id"><div layout="row" \nlayout-align="start center" flex="100" class="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" \nlayout="column"><div class="name" layout="row"><div layout="row" layout-align="start center" flex="100"><div \nclass="avatar-wrapper"><user-avatar ng-if="uploadingFotoUserId != user.id" user="user"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong><div class="field grey-600-fg ng-binding"><span>\n{{vm.getDivisionName(user.division)[0].name}} | {{vm.getPositionName(user.position)[0].name}}</span></div></div></div>\n</div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu class="float-right">\n<md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\', branch)">\n<md-icon md-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div><div class="items"><div layout="row" \nlayout-align="start center" flex="100" class="pt-10 pb-10"><div class="info" flex layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><md-button \nng-click="vm.openDialogForm(\'personnel\', branch.id)" class="md-mini add-event-button md-fab md-warn mh-0"><md-icon \nmd-font-icon="icon-plus"></md-icon></md-button></div></div></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/inputs/views/read/form-tabs/step-people.html','<div layout="column" layout-gt-xs="row"><div style="padding: 0px 15px;" flex layout="column"><h1>Direcci\xF3n</h1><div \nlayout="column" layout-gt-xs="row"><md-input-container class="group-form" flex="100" flex-gt-xs="100"><div \nlayout="row" layout-align="start center"><h2 translate="GLOBAL.LEGAL_MANAGER"></h2><md-button \nng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'managerLegal\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n<div class="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'managerLegal\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId !== user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container class="group-form" flex="100" flex-gt-xs="100"><div layout="row" \nlayout-align="start center"><h2 translate="GLOBAL.ADMINISTRATOR"></h2><md-button \nng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'administrator\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n<div class="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'administrator\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId !== user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container></div></div><div \nstyle="padding: 0px 15px;" flex layout="column"><h1>Compliance</h1><md-input-container class="group-form" flex="100" \nflex-gt-xs="100"><h2 translate="GLOBAL.COMPLIANCE_OFFICER" style="display: inline-block;"></h2><md-button \nng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'compliance_officer\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'compliance_officer\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId !== user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container><md-input-container \nclass="group-form" flex="100" flex-gt-xs="100"><h2 translate="GLOBAL.COLLABORATOR" style="display: inline-block;"></h2>\n<md-button ng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'collaborator\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'collaborator\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId != user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container><md-input-container \nclass="group-form" flex="100" flex-gt-xs="100"><h2 translate="GLOBAL.REPORT_COMMITTEE" style="display: inline-block;">\n</h2><md-button ng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'compliance_comite\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'compliance_comite\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId !== user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container><md-input-container \nclass="group-form" flex="100" flex-gt-xs="100"><h2 translate="GLOBAL.DELEGATE_DATA_PROTECCTION" \nstyle="display: inline-block;"></h2><md-button ng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'data_protection\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'data_protection\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId != user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container></div></div>');
$templateCache.put('app/main/apps/items/dialogs/image/views/fotorama-view.html','<div class="content-wrapper" flex layout="row"><div class="mail-tabs-grid" flex \nmd-dynamic-height="{{vm.dynamicHeight}}"><fotorama options="vm.fotoramaoptions" items="vm.dataFotorama" id="fotorama">\n</fotorama></div></div>');
$templateCache.put('app/main/apps/items/dialogs/media/views/audios-view.html','<div class="content-wrapper" flex="" layout="row"><div class="mail-tabs-grid" flex \nmd-dynamic-height="{{vm.dynamicHeight}}"><div class="content mail-list-pane-grid" flex ms-scroll><div \nng-repeat="item in vm.items" class="ms-card" flex><div class="ms-card-content-wrapper"><div class="template-9"><div \nclass="media" flex layout="row" layout-align="center center"><div flex layout="column" layout-align="center center" \nclass="media"><media attachment="item" class=""></media><br><span class="grey-500-fg" layout="column" \nlayout-align="center center"><span ng-if="item.title"><strong>{{item.title}}</strong></span> <span \nng-if="item.filename">{{item.filename}}</span></span></div></div><div class="header p-16" flex><div layout="row" \nlayout-align="space-between center" flex><div class="size text-truncate" layout="row" layout-align="start left"><strong\n class="mr-5">#{{item.id_media}}</strong> <span class="grey-500-fg"><span ng-if="item.date_uploaded">\n{{item.date_uploaded}}</span></span></div><md-checkbox ng-checked="vm.alreadySelectedbyZone(vm.selectedImages, item)" \nng-click="vm.toggleSelectedImages(item, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, item) ? \'Deselect\' : \'Select\'}}" class="ml-5"></md-checkbox>\n</div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/items/dialogs/media/views/files-view.html','<div class="content-wrapper" flex="" layout="row"><div class="mail-tabs-grid" flex=""><div \nclass="content mail-list-pane-grid" flex="" ms-scroll=""><div ng-repeat="item in vm.items" class="ms-card" flex><div \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><div flex layout="column" layout-align="center center" class="media"><media \nattachment="item" class=""></media><br><span class="grey-500-fg" layout="column" layout-align="center center"><span \nng-if="item.title"><strong>{{item.title}}</strong></span> <span ng-if="item.filename">{{item.filename}}</span></span>\n</div></div><div class="header p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size text-truncate" layout="row" layout-align="start left"><strong class="mr-5">#{{item.id_media}}</strong>\n</div><md-checkbox ng-checked="vm.alreadySelectedbyZone(vm.selectedImages, item)" \nng-click="vm.toggleSelectedImages(item, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, item) ? \'Deselect\' : \'Select\'}}" class="ml-5"></md-checkbox>\n</div></div></div></div></div></div></div></div><div layout="column" layout-align="center center"></div>');
$templateCache.put('app/main/apps/items/dialogs/media/views/import-view.html','<div class="content-wrapper" flex layout="column"><div class="content"><div class="drop-box"><md-input-container \nclass="md-block"><label>Paste the url to import:</label> <input type="text" name="import_field" \nng-model="vm.import_field" placeholder="" ng-disabled="vm.import_disabled"></md-input-container><div \nng-if="vm.imported" class="alert-message success-message" translate="GLOBAL.SUCCESSIMPORT">Imported successfully</div>\n</div><treasure-overlay-spinner active="vm.importing"><div layout="row" layout-align="center start" \nng-if="vm.importPreview" class="white-box sections"><div flex-gt-sm="50" flex="100"><div class="section"><div \nclass="section-header" layout="row" layout-align="start center"><span class="section-title">PREVIEW</span></div><div \nclass="media" flex layout="row" layout-align="center center" ng-bind-html="vm.importPreview.embedCodeSafe"></div></div>\n<div class="header p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size text-truncate" layout="row" layout-align="start left"><span class="grey-500-fg"><span \nng-if="vm.importPreview.title">Title: {{vm.importPreview.title}}</span></span></div></div><div layout="row" \nlayout-align="space-between center" flex><div class="size" layout="row" layout-align="start left"><span \nclass="grey-500-fg"><span ng-if="vm.importPreview.caption">Description: {{vm.importPreview.caption}}</span></span>\n</div></div></div><md-button class="send-button md-accent md-raised" ng-click="vm.importConfirm(1)" \ntranslate="GLOBAL.IMPORT">Import</md-button></div></div><div ng-repeat="f in vm.importedFiles" class="ms-card" flex>\n<div class="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><img ng-src="{{f.embed_thumb}}" class="image"></div><div class="header p-16" flex><div \nlayout="row" layout-align="space-between center" flex><div class="size text-truncate" layout="row" \nlayout-align="start left"><strong class="mr-5">#{{f.id_media}}</strong> <span class="grey-500-fg"><span \nng-if=".filename">{{f.filename}}</span> <span ng-if="f.title">{{f.title}}</span></span></div><md-checkbox \nng-checked="vm.alreadySelectedbyZone(vm.selectedImages, f)" ng-click="vm.toggleSelectedImages(f, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, f) ? \'Deselect\' : \'Select\'}}"></md-checkbox></div></div>\n</div></div></div></treasure-overlay-spinner></div></div>');
$templateCache.put('app/main/apps/items/dialogs/media/views/photos-view.html','<div class="content-wrapper" flex layout="row"><div class="mail-tabs-grid" flex \nmd-dynamic-height="{{vm.dynamicHeight}}"><div class="content mail-list-pane-grid" flex><div \nng-repeat="photo in vm.items" class="ms-card" flex><div class="ms-card-content-wrapper"><div class="template-9"><div \nclass="media" flex layout="row" layout-align="center center"><media attachment="photo" class=""></media></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size text-truncate" \nlayout="row" layout-align="start left"><strong class="mr-5">#{{photo.id_media}}</strong> <span class="grey-500-fg">\n<span ng-if="photo.filename">{{photo.filename}}</span></span></div><md-checkbox \nng-checked="vm.alreadySelectedbyZone(vm.selectedImages, photo)" ng-click="vm.toggleSelectedImages(photo, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, photo) ? \'Deselect\' : \'Select\'}}" class="ml-5"></md-checkbox>\n</div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/items/dialogs/media/views/template-grid.html','<div class="template-9"><div class="header p-16" layout="row" layout-align="space-between center" flex><div \nlayout="column" layout-align="start center"><md-checkbox class="no-label" ng-checked="vm.isChecked(mail)" \nng-click="vm.toggleCheck(mail, $event)" aria-label="{{vm.isChecked(mail)? \'Uncheck\':\'check\'}}"></md-checkbox><div \nng-if="refcolumnsgrouped.main"><div class="subject text-truncate"><span \nng-repeat="field in refcolumnsgrouped.header | orderBy: \'list-sort\'" ng-bind="thread.{{field.titleId}}"></span></div>\n</div></div><div layout="column" layout-align="start center"><md-icon md-font-icon="icon-attachment" \nclass="has-attachment s24" ng-if="thread.Thumbnail.length>0"></md-icon><button ng-if="thread.onoff===1" \nclass="md-icon-button"><md-icon md-font-icon="icon-checkbox-marked-circle" class="on green-fg s24"></md-icon></button> \n<button ng-if="thread.onoff!==1" class="md-icon-button"><md-icon md-font-icon="icon-checkbox-blank-circle-outline" \nclass="off red-fg s24"></md-icon></button></div></div><div class="media" flex layout="row" \nlayout-align="center center"><img class="image" ng-src="{{card.Thumbnail[0].crop_status[0].urlformed}}" \nalt="{{card.media.image.alt}}" imageonloadcontrol></div><div class="header p-16" layout="row" layout-align="start"><div\n class="info"><div ng-if="refcolumnsgrouped.main"><div class="name text-truncate" layout="row" \nlayout-align="start center"><span ng-repeat="field in refcolumnsgrouped.main"><span ng-bind="thread.{{field.titleId}}">\n</span>&nbsp;</span></div></div><div ng-repeat="field in refcolumnsgrouped.secondary | orderBy:\'list_sort\'"><div \nng-if="(field.type!==\'date\' && field.type!==\'dateHm\') && field.primary!==1" class="details" layout="row" \nlayout-align="start start"><div layout="column"><span class="title" ng-bind="field.title"></span></div><div \nlayout="column" class="text-truncate"><span class="detail" ng-bind="thread.{{field.titleId}}"></span></div></div></div>\n</div></div></div>');
$templateCache.put('app/main/apps/items/dialogs/media/views/tiny-attached.html','<div class="content-wrapper" flex layout="row"><div class="mail-tabs-grid" flex \nmd-dynamic-height="{{vm.dynamicHeight}}"><div class="content mail-list-pane-grid" flex><div \nng-repeat="item in vm.selectedImages" class="ms-card" flex><div class="ms-card-content-wrapper" \nng-if="item.media_type == 1"><div class="template-9"><div class="media" flex layout="row" layout-align="center center">\n<img ng-src="{{item.cropstatus[0].container.view_url}}{{item.cropstatus[0].fileName}}" class="image"></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size text-truncate" \nlayout="row" layout-align="start left"><strong class="mr-5">#{{item.id_media}}</strong> <span class="grey-500-fg"><span\n ng-if="item.filename">{{item.filename}}</span></span></div><md-button ng-click="vm.selectMediaTiny(item)" \nclass="send-button md-accent md-raised" aria-label="Select" translate="GLOBAL.SELECT" \ntranslate-attr-aria-label="GLOBAL.SELECT">SELECT</md-button></div></div></div></div><div \nclass="ms-card-content-wrapper" ng-if="item.media_type == 2"><div class="template-9"><div class="media" flex \nlayout="row" layout-align="center center"><img ng-src="{{item.embed_thumb}}" class="image"></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size text-truncate" \nlayout="row" layout-align="start left"><strong class="mr-5">#{{item.id_media}}</strong> <span class="grey-500-fg"><span\n ng-if="item.filename">{{item.filename}}</span> <span ng-if="item.title">{{item.title}}</span></span></div><md-button \nng-click="vm.selectMediaTiny(item)" class="send-button md-accent md-raised" aria-label="Select" \ntranslate="GLOBAL.SELECT" translate-attr-aria-label="GLOBAL.SELECT">SELECT</md-button></div></div></div></div></div>\n</div></div></div>');
$templateCache.put('app/main/apps/items/dialogs/media/views/tiny-properties.html','<div class="ontent-wrapper" flex="" layout="column"><div class="content"><div class="ms-card" flex><div \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center" ng-if="vm.selectedMediaTiny.media_type == 1"><img \nng-src="{{vm.selectedMediaTiny.cropstatus[0].container.view_url}}{{vm.selectedMediaTiny.cropstatus[0].fileName}}" \nclass="image"></div><div class="media" flex layout="row" layout-align="center center" \nng-if="vm.selectedMediaTiny.media_type == 2"><img ng-src="{{vm.selectedMediaTiny.embed_thumb}}" class="image"></div>\n<div class="header p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size text-truncate" layout="row" layout-align="start left"><strong class="mr-5">\n#{{vm.selectedMediaTiny.id_media}}</strong> <span class="grey-500-fg"><span ng-if="vm.selectedMediaTiny.filename">\n{{vm.selectedMediaTiny.filename}}</span></span></div></div></div></div></div></div><div><md-input-container \nclass="md-block" flex><label translate="GLOBAL.ALIGN" translate-attr-aria-label="GLOBAL.ALIGN">Align:</label><md-select\n ng-model="vm.tinyProperties.align" placeholder="Align"><md-option value="">---</md-option><md-option \nng-repeat="opt in vm.tinyOptions.align" value="{{opt.value}}">{{opt.text}}</md-option></md-select><div \nclass="md-errors-spacer"></div></md-input-container><md-input-container class="md-block" flex><label \ntranslate="GLOBAL.SIZE" translate-attr-aria-label="GLOBAL.SIZE">Size:</label><md-select \nng-model="vm.tinyProperties.size" placeholder="Size"><md-option value="">---</md-option><md-option \nng-repeat="opt in vm.tinyOptions.size" value="{{opt.value}}">{{opt.text}}</md-option></md-select><div \nclass="md-errors-spacer"></div></md-input-container></div></div></div>');
$templateCache.put('app/main/apps/items/dialogs/media/views/upload-view.html','<div class="content-wrapper" flex="" layout="column"><div class="content"><div ngf-drop ngf-select ng-model="vm.files" \nclass="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="false" ngf-allow-dir="true" accept="image/*" \nngf-pattern="\'image/*\'"><md-button class="md-raised md-accent text-center" ng-model="photo" \ntranslate="GLOBAL.SELECT_FILES" onchange="angular.element(this).scope().file_changed(this)" type="file" \naccept="image/*"></md-button></div><md-progress-linear md-mode="determinate" value="{{vm.files[0].progress}}" \nng-show="vm.files[0].progress < 100"></md-progress-linear></div></div>');
$templateCache.put('app/main/apps/items/dialogs/media/views/videos-view.html','<div class="content-wrapper" flex layout="row"><div class="mail-tabs-grid" flex><div \nclass="content mail-list-pane-grid" flex><div ng-repeat="item in vm.items" class="ms-card" flex><div \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><media attachment="item" thumbnail="true" class=""></media></div><div class="header p-16" \nflex><div layout="row" layout-align="space-between center" flex><div class="size text-truncate" layout="row" \nlayout-align="start left"><strong class="mr-5">#{{item.id_media}}</strong> <span class="grey-500-fg"><span \nng-if="item.filename">{{item.filename}}</span> <span ng-if="item.title">{{item.title}}</span></span></div><md-checkbox \nng-checked="vm.alreadySelectedbyZone(vm.selectedImages, item)" ng-click="vm.toggleSelectedImages(item, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, item) ? \'Deselect\' : \'Select\'}}"></md-checkbox></div></div>\n</div></div></div></div></div></div>');
$templateCache.put('app/main/apps/items/views/read/form-tabs/step-branchs.html','<div layout="column" layout-gt-xs="row"><md-input-container flex><h1 translate="GLOBAL.MAIN_BRANCH"></h1>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="GLOBAL.NAME"></label> <input ng-model="vm.formWizard.main_branch.name" type="text"></md-input-container>\n<md-input-container flex><label translate="GLOBAL.ADDRESS"></label> <input \nng-model="vm.formWizard.main_branch.address1" type="text" required></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container flex><label>{{vm.getRegionLiteral(\'city\')}}</label> <input \nng-model="vm.formWizard.main_branch.city" type="text" required></md-input-container><md-input-container flex><label>\n{{vm.getRegionLiteral(\'state\')}}</label> <input ng-model="vm.formWizard.main_branch.state" type="text" required>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="GLOBAL.POSTAL_CODE"></label> <input ng-model="vm.formWizard.main_branch.postcode" type="text" required>\n</md-input-container><md-input-container flex><label translate="GLOBAL.PHONE"></label> <input \nng-model="vm.formWizard.main_branch.phone" type="text"></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container flex><label translate="GLOBAL.EMAIL"></label> <input \nng-model="vm.formWizard.main_branch.email" type="text"></md-input-container><md-input-container flex>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container class="group-form" flex="100" \nflex-gt-xs="100"><div layout="row" layout-align="start center"><h1 translate="GLOBAL.BRANCH"></h1><md-button \nng-click="vm.openDialogForm(\'branch\')" class="ml-10 md-mini add-event-button md-fab md-warn"><md-icon \nmd-font-icon="icon-plus"></md-icon></md-button></div><div class="mail-list-pane s0" \nng-if="vm.formWizard.branch && vm.formWizard.branch.length > 0"><div class="items" ng-if="!branch.is_main" \nng-repeat="branch in vm.formWizard.branch"><div layout="row" layout-align="start center" flex="100" class="p-20"><div \nlayout="row" layout-align="start center" flex="90"><div class="avatar-wrapper"><md-icon md-font-icon="icon-city">\n</md-icon></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding" \nng-bind-html="branch.name"></strong><div class="field grey-600-fg ng-binding"><span ng-if="branch.city" \nng-bind-html="branch.city"></span> <span ng-if="branch.city && branch.state">, </span><span ng-if="branch.state" \nng-bind-html="branch.state"></span></div></div></div><div class="menu" flex="10" layout-align="center end" \nlayout="column"><md-menu class="float-right"><md-button class="md-icon-button" aria-label="More" \nng-click="vm.openMenu($mdMenu, $event)"><md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg">\n</md-icon></md-button><md-menu-content width="2"><md-menu-item><md-button translate="GLOBAL.EDIT" \nng-click="vm.editBranchDialog($event, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div></md-input-container></div>');
$templateCache.put('app/main/apps/items/views/read/form-tabs/step-company.html','<div layout="column" layout-gt-xs="row"><md-input-container flex><label translate="GLOBAL.SOCIAL_REASON"></label> \n<input type="text" ng-model="vm.formWizard.company.name" required></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container flex><label>{{vm.getRegionLiteral(\'tax_ic_number\')}}</label> <input type="text" \nng-model="vm.formWizard.company.tax_id_number"></md-input-container><md-input-container flex><label \ntranslate="GLOBAL.SECTOR"></label><md-select ng-model="vm.formWizard.company.sector_id"><md-option \nng-repeat="sector in vm.sectors track by $index" ng-value="sector.id">{{sector.name}}</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="GLOBAL.REGION"></label><md-select ng-model="vm.formWizard.company.region_id"><md-option \nng-repeat="region in vm.regions track by $index" ng-value="region.id">{{region.name}}</md-option></md-select>\n</md-input-container><md-input-container flex></md-input-container></div><div layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container><p class="mt-0 grey-400-fg" translate="GLOBAL.LOGOTYPE"></p><div \nclass="header simple relative" ng-if="image || imageUrl" layout="row" layout-align="space-between center"><md-menu>\n<button class="md-icon-button" aria-label="More"><div layout="column" layout-align="start center" \nng-click="$mdMenu.open($event)"><div class="media" flex layout="row" layout-align="center center"><img \nngf-thumbnail="!image.$error && image" class="image"> <img ng-if="!image && imageUrl" src="{{imageUrl}}" class="image">\n</div><md-button class="md-mini add-event-button no-sort md-fab md-warn block absolute-top-right" \naria-label="Add event"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button></div></button><md-menu-content\n width="3"><md-menu-item><md-button ng-click="vm.deleteLogotype()" aria-label="Toggle done" \ntranslate-attr-aria-label="GLOBAL.REMOVE"><md-icon md-font-icon="icon-close" class="s18"></md-icon><span \ntranslate="GLOBAL.REMOVE"></span></md-button></md-menu-item></md-menu-content></md-menu></div><div \nng-if="!image && !imageUrl" ng-click="vm.mediaDialogSingle($event, vm.formWizard.company.logotype)" class="relative">\n<img src="assets/images/logos/generic-logo.png" class="image"><md-button \nclass="md-mini add-event-button no-sort md-fab md-warn block absolute-top-right" aria-label="Add event" translate \ntranslate-attr-aria-label="CALENDAR.ADD_EVENT"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n</md-input-container></div>');
$templateCache.put('app/main/apps/items/views/read/form-tabs/step-options.html','<div class="options"><div layout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container \nfill-width flex><label translate="GLOBAL.DESCRIPTION"></label> <input type="text" \nng-model="vm.formWizard.company.description"></md-input-container><md-input-container fill-width flex><label \ntranslate="GLOBAL.COMPANY_TYPE"></label><md-select ng-model="vm.formWizard.company.extra_data.company_type"><md-option \nng-value="1">SA</md-option><md-option ng-value="2">SL</md-option><md-option ng-value="3">Cotizada</md-option><md-option\n ng-value="4">Fundaciones/asociaciones</md-option><md-option ng-value="5">Otras</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container\n fill-width flex><label translate="GLOBAL.EXECUTIVE_TYPE"></label><md-select \nng-model="vm.formWizard.company.extra_data.executives_type"><md-option ng-value="1">Accionista \xFAnico</md-option>\n<md-option ng-value="2">Varios accionistas</md-option><md-option ng-value="3">Consejo de administraci\xF3n</md-option>\n<md-option ng-value="4">Administrador \xFAnico</md-option><md-option ng-value="5">Otros</md-option></md-select>\n</md-input-container><md-input-container fill-width flex><label translate="GLOBAL.SOCIAL_CAPITAL"></label><md-select \nng-model="vm.formWizard.company.extra_data.capital"><md-option ng-value="1">Capital</md-option><md-option ng-value="2">\nAportaciones de socios</md-option><md-option ng-value="3">Aumentos de capital recientes</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container\n fill-width flex><label translate="GLOBAL.AMOUNT_CAPITAL"></label> <input type="number" type="text" \nng-model="vm.formWizard.company.extra_data.capital_amount"></md-input-container><md-input-container fill-width flex>\n<label translate="GLOBAL.BILLING_LAST_YEAR"></label> <input type="number" \nng-model="vm.formWizard.company.turnover_volume"></md-input-container></div><div layout="column" layout-gt-xs="row" \nflex layout-align="start center"><md-input-container fill-width flex><label>Cuentas anuales</label><md-select \nng-model="vm.formWizard.company.extra_data.annual_accounts"><md-option ng-value="1">Abreviadas</md-option><md-option \nng-value="2">Normales</md-option><md-option ng-value="3">Pymes</md-option><md-option ng-value="4">Mixtas</md-option>\n</md-select></md-input-container><md-input-container fill-width flex><label>Auditor\xEDas</label><md-select \nng-model="vm.formWizard.company.extra_data.audits"><md-option ng-value="1">Internas</md-option><md-option ng-value="2">\nExternas</md-option><md-option ng-value="3">No aplica</md-option></md-select></md-input-container></div><div \nlayout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container fill-width flex><label>\nCertificaciones ISO</label><md-select ng-model="vm.formWizard.company.extra_data.iso_certification"><md-option \nng-value="1">ISO 9001</md-option><md-option ng-value="2">ISO 14000</md-option><md-option ng-value="3">ISO 14001\n</md-option><md-option ng-value="4">ISO 19600</md-option><md-option ng-value="5">ISO 22000</md-option><md-option \nng-value="6">ISO 26000</md-option><md-option ng-value="7">ISO 27001</md-option><md-option ng-value="8">ISO 37001\n</md-option><md-option ng-value="9">OHSAS 18001</md-option></md-select></md-input-container><md-input-container \nfill-width flex><label>Convenio Colectivo Aplicable</label> <input type="text" \nng-model="vm.formWizard.company.extra_data.collective_agreement"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" flex layout-align="start center"><md-input-container fill-width flex><label>Seguros contratados\n</label> <input type="text" ng-model="vm.formWizard.company.extra_data.insurance"></md-input-container>\n<md-input-container fill-width flex><label translate="GLOBAL.CNAE"></label> <input type="text" \nng-model="vm.formWizard.company.extra_data.cnae"></md-input-container></div><div layout="column" layout-gt-xs="row" \nflex layout-align="start center"><md-input-container fill-width layout="row" layout-align="start center" flex><label \nclass="ph-15" fill-width translate="GLOBAL.FINANCING"></label><md-select flex \nng-init="!vm.formWizard.company.extra_data.financing ? vm.formWizard.company.extra_data.financing = [] : null;" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.financing"><md-option \nng-repeat="option in vm.financing_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container><md-input-container fill-width layout="row" layout-align="start center" flex><label class="ph-15" \nfill-width>Normativa Sectorial aplicable</label><md-select flex \nng-init="!vm.formWizard.company.extra_data.sector_regulations ? vm.formWizard.company.extra_data.sector_regulations = [] : null;" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.sector_regulations"><md-option \nng-repeat="option in vm.sector_regulations_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-align="start center"><md-input-container \nfill-width layout="row" layout-align="start center" flex><label class="ph-15" fill-width>Medidas implementadas</label>\n<md-select flex \nng-init="!vm.formWizard.company.extra_data.implemented_measures ? vm.formWizard.company.extra_data.implemented_measures = [] : null;" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.implemented_measures"><md-option \nng-repeat="option in vm.implemented_measures_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container></div><div class="separator-options" layout="row"><h2>Grupo de sociedades?</h2><md-input-container\n fill-width layout="row" layout-align="start center" flex class="mb-0"><md-checkbox \nng-checked="vm.formWizard.company.extra_data.belogns_to_holding" \nng-model="vm.formWizard.company.extra_data.belogns_to_holding"></md-checkbox></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-align="start center"></div><div \nng-if="vm.formWizard.company.extra_data.belogns_to_holding" layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container fill-width flex><label>Nombre corporaci\xF3n</label> <input type="text" \nng-model="vm.formWizard.company.extra_data.name_corporation"></md-input-container><md-input-container fill-width flex>\n<label>CIF corporaci\xF3n</label> <input type="text" ng-model="vm.formWizard.company.extra_data.cif_corporation">\n</md-input-container></div><div class="mv-25" ng-if="vm.formWizard.company.extra_data.belogns_to_holding" \nlayout="column" layout-gt-xs="row" layout-align="start center"><div fill-width><div ngf-drop ngf-select \nng-model="vm.files_belogns_to_holding" class="drop-box" layout="column" layout-gt-xs="row" \nngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="belogns_to_holding_isLoading"><div flex layout="column" layout-align="center center" layout-padding \nlayout-margin class="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30">\n</md-progress-circular></div></div></div><div layout="column" flex><div \nng-repeat="f in vm.formWizard.company.extra_data.belogns_to_holding_files track by $index" class="border-bottom" flex>\n<div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><div class="media photos" layout="row" layout-align="center center"><h2c-icon \nfile="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" alt=""></div><div class="info ml-15" flex \nlayout="column" layout-align="center center"><div class="name" layout="row" layout-align="center center"><span \nng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu class="float-right"><md-button \nclass="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.belogns_to_holding_files.splice($index, 1);"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></div></div></div><div class="separator-options" \nlayout="row"><h2>Responsabilidad social corporativa?</h2><md-input-container fill-width layout="row" \nlayout-align="start center" flex class="mb-0"><md-checkbox \nng-checked="vm.formWizard.company.extra_data.social_responsability" \nng-model="vm.formWizard.company.extra_data.social_responsability"></md-checkbox></md-input-container></div><div \nclass="mv-25" ng-if="vm.formWizard.company.extra_data.social_responsability" layout="column" layout-gt-xs="row" \nlayout-align="start center"><div fill-width><div ngf-drop ngf-select ng-model="vm.files_social_responsability" \nclass="drop-box" layout="column" layout-gt-xs="row" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" \nngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="social_responsability_isLoading"><div flex layout="column" layout-align="center center" layout-padding \nlayout-margin class="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30">\n</md-progress-circular></div></div></div><div layout="column" flex><div \nng-repeat="f in vm.formWizard.company.extra_data.social_responsability_files track by $index" class="border-bottom" \nflex><div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><div class="media photos" layout="row" layout-align="center center"><h2c-icon \nfile="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" alt=""></div><div class="info ml-15" flex \nlayout="column" layout-align="center center"><div class="name" layout="row" layout-align="center center"><span \nng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu class="float-right"><md-button \nclass="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.social_responsability_files.splice($index, 1);"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></div></div></div><div class="separator-options" \nlayout="row"><h2>IVA</h2></div><div class="mv-25" layout="column"><div layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container fill-width flex><md-select \nng-model="vm.formWizard.company.extra_data.tax_options"><md-option ng-value="1">Presentaci\xF3n trimestral</md-option>\n<md-option ng-value="2">Presentaci\xF3n mensual</md-option></md-select></md-input-container><md-input-container \nfill-width flex></md-input-container></div><div layout="column" layout-gt-xs="row" layout-align="start center"><div \nfill-width><div ngf-drop ngf-select ng-model="vm.files_iva" class="drop-box" layout="column" layout-gt-xs="row" \nngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="iva_isLoading"><div flex layout="column" layout-align="center center" layout-padding layout-margin \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n</div></div><div layout="column" flex><div ng-repeat="f in vm.formWizard.company.extra_data.iva_files track by $index" \nclass="border-bottom" flex><div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size" layout="row" layout-align="start left"><div class="media photos" layout="row" \nlayout-align="center center"><h2c-icon file="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" \nalt=""></div><div class="info ml-15" flex layout="column" layout-align="center center"><div class="name" layout="row" \nlayout-align="center center"><span ng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.iva_files.splice($index, 1);"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div></div></div></div></div><div class="separator-options" layout="row"><h2>\nImpuesto de sociedades</h2></div><div class="mv-25" layout="column"><div layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container fill-width flex><md-datepicker \nng-model="vm.formWizard.company.extra_data.date_is" md-placeholder="Fecha"></md-datepicker></md-input-container>\n<md-input-contaimer class="md-block" flex><md-select ng-model="vm.formWizard.company.extra_data.currency_is" \nplaceholder="{{ \'GLOBAL.CURRENCY\' |\xA0translate}}"><md-option ng-repeat="currency in vm.currencies" \nng-value="currency.id">{{currency.symbol}}</md-option></md-select></md-input-contaimer><md-input-container fill-width \nflex><label translate="GLOBAL.AMOUNT_CAPITAL"></label> <input type="number" type="text" \nng-model="vm.formWizard.company.extra_data.amount_is"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-align="start center"><div fill-width><div ngf-drop ngf-select ng-model="vm.files_is" \nclass="drop-box" layout="column" layout-gt-xs="row" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" \nngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="is_isLoading"><div flex layout="column" layout-align="center center" layout-padding layout-margin \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n</div></div><div layout="column" flex><div ng-repeat="f in vm.formWizard.company.extra_data.is_files track by $index" \nclass="border-bottom" flex><div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size" layout="row" layout-align="start left"><div class="media photos" layout="row" \nlayout-align="center center"><h2c-icon file="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" \nalt=""></div><div class="info ml-15" flex layout="column" layout-align="center center"><div class="name" layout="row" \nlayout-align="center center"><span ng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.is_files.splice($index, 1);"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/items/views/read/form-tabs/step-people-global.html','<div layout="column" layout-gt-xs="row"><div class="mail-list-pane s0" flex="100"><div layout-gt-xs="row" \nlayout="column" class="mb-20"><div flex="20"><div layout="row" layout-align="start center" flex="100" \nclass="p-20 layout-align-start-center layout-row flex-100"><div layout="row" layout-align="start center" flex="100" \nclass="layout-align-start-center layout-row flex-100"><div class="avatar-wrapper"><md-icon md-font-icon="icon-city">\n</md-icon></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding" \nng-bind-html="vm.formWizard.main_branch.name"></strong><div class="field grey-600-fg ng-binding"><span \nng-if="vm.formWizard.main_branch.city" ng-bind-html="vm.formWizard.main_branch.city"></span> <span \nng-if="vm.formWizard.main_branch.city && vm.formWizard.main_branch.state">, </span><span \nng-if="vm.formWizard.main_branch.state" ng-bind-html="vm.formWizard.main_branch.state"></span></div></div></div></div>\n</div><div flex="80"><div layout="row" layout-align="start center"><div class="mail-list-pane s0" flex="100"><div \nclass="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="user.branch_id == vm.formWizard.main_branch.id"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId != user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong><div class="field grey-600-fg ng-binding"><span>\n{{vm.getDivisionName(user.division)[0].name}} | {{vm.getPositionName(user.position)[0].name}}</span></div></div></div>\n</div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu class="float-right">\n<md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" \nng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\', vm.formWizard.main_branch)"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div><div class="items"><div layout="row" \nlayout-align="start center" flex="100" class="pt-10 pb-10"><div class="info" flex layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><md-button \nng-click="vm.openDialogForm(\'personnel\', vm.formWizard.main_branch.id)" \nclass="md-mini add-event-button md-fab md-warn mh-0"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n</div></div></div></div></div></div></div></div></div><div layout-gt-xs="row" layout="column" class="mb-20" \nng-repeat="branch in vm.formWizard.branch" ng-if="branch.id != vm.formWizard.main_branch.id"><div flex="20"><div \nlayout="row" layout-align="start center" flex="100" class="p-20 layout-align-start-center layout-row flex-100"><div \nlayout="row" layout-align="start center" flex="100" class="layout-align-start-center layout-row flex-100"><div \nclass="avatar-wrapper"><md-icon md-font-icon="icon-city"></md-icon></div><div class="field mr-10 ml-10 flex" flex="">\n<strong class="grey-800-fg ng-binding" ng-bind-html="branch.name"></strong><div class="field grey-600-fg ng-binding">\n<span ng-if="branch.city" ng-bind-html="branch.city"></span> <span ng-if="branch.city && branch.state">, </span><span \nng-if="branch.state" ng-bind-html="branch.state"></span></div></div></div></div></div><div flex="80"><div layout="row" \nlayout-align="start center"><div class="mail-list-pane s0" flex="100"><div class="items" \nng-repeat="user in vm.formWizard.personnel track by $index" ng-if="user.branch_id == branch.id"><div layout="row" \nlayout-align="start center" flex="100" class="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" \nlayout="column"><div class="name" layout="row"><div layout="row" layout-align="start center" flex="100"><div \nclass="avatar-wrapper"><user-avatar ng-if="uploadingFotoUserId != user.id" user="user"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong><div class="field grey-600-fg ng-binding"><span>\n{{vm.getDivisionName(user.division)[0].name}} | {{vm.getPositionName(user.position)[0].name}}</span></div></div></div>\n</div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu class="float-right">\n<md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\', branch)">\n<md-icon md-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div><div class="items"><div layout="row" \nlayout-align="start center" flex="100" class="pt-10 pb-10"><div class="info" flex layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><md-button \nng-click="vm.openDialogForm(\'personnel\', branch.id)" class="md-mini add-event-button md-fab md-warn mh-0"><md-icon \nmd-font-icon="icon-plus"></md-icon></md-button></div></div></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/items/views/read/form-tabs/step-people.html','<div layout="column" layout-gt-xs="row"><div style="padding: 0px 15px;" flex layout="column"><h1>Direcci\xF3n</h1><div \nlayout="column" layout-gt-xs="row"><md-input-container class="group-form" flex="100" flex-gt-xs="100"><div \nlayout="row" layout-align="start center"><h2 translate="GLOBAL.LEGAL_MANAGER"></h2><md-button \nng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'managerLegal\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n<div class="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'managerLegal\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId !== user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container class="group-form" flex="100" flex-gt-xs="100"><div layout="row" \nlayout-align="start center"><h2 translate="GLOBAL.ADMINISTRATOR"></h2><md-button \nng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'administrator\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n<div class="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'administrator\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId !== user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container></div></div><div \nstyle="padding: 0px 15px;" flex layout="column"><h1>Compliance</h1><md-input-container class="group-form" flex="100" \nflex-gt-xs="100"><h2 translate="GLOBAL.COMPLIANCE_OFFICER" style="display: inline-block;"></h2><md-button \nng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'compliance_officer\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'compliance_officer\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId !== user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container><md-input-container \nclass="group-form" flex="100" flex-gt-xs="100"><h2 translate="GLOBAL.COLLABORATOR" style="display: inline-block;"></h2>\n<md-button ng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'collaborator\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'collaborator\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId != user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container><md-input-container \nclass="group-form" flex="100" flex-gt-xs="100"><h2 translate="GLOBAL.REPORT_COMMITTEE" style="display: inline-block;">\n</h2><md-button ng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'compliance_comite\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'compliance_comite\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId !== user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container><md-input-container \nclass="group-form" flex="100" flex-gt-xs="100"><h2 translate="GLOBAL.DELEGATE_DATA_PROTECCTION" \nstyle="display: inline-block;"></h2><md-button ng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'data_protection\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'data_protection\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId != user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container></div></div>');
$templateCache.put('app/main/apps/proyects/dialogs/media/views/audios-view.html','<div class="content-wrapper" flex="" layout="row"><div class="mail-tabs-grid" flex \nmd-dynamic-height="{{vm.dynamicHeight}}"><div class="content mail-list-pane-grid" flex ms-scroll><div \nng-repeat="item in vm.items" class="ms-card" flex><div class="ms-card-content-wrapper"><div class="template-9"><div \nclass="media" flex layout="row" layout-align="center center"><div flex layout="column" layout-align="center center" \nclass="media"><media attachment="item" class=""></media><br><span class="grey-500-fg" layout="column" \nlayout-align="center center"><span ng-if="item.title"><strong>{{item.title}}</strong></span> <span \nng-if="item.filename">{{item.filename}}</span></span></div></div><div class="header p-16" flex><div layout="row" \nlayout-align="space-between center" flex><div class="size text-truncate" layout="row" layout-align="start left"><strong\n class="mr-5">#{{item.id_media}}</strong> <span class="grey-500-fg"><span ng-if="item.date_uploaded">\n{{item.date_uploaded}}</span></span></div><md-checkbox ng-checked="vm.alreadySelectedbyZone(vm.selectedImages, item)" \nng-click="vm.toggleSelectedImages(item, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, item) ? \'Deselect\' : \'Select\'}}" class="ml-5"></md-checkbox>\n</div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/proyects/dialogs/media/views/files-view.html','<div class="content-wrapper" flex="" layout="row"><div class="mail-tabs-grid" flex=""><div \nclass="content mail-list-pane-grid" flex="" ms-scroll=""><div ng-repeat="item in vm.items" class="ms-card" flex><div \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><div flex layout="column" layout-align="center center" class="media"><media \nattachment="item" class=""></media><br><span class="grey-500-fg" layout="column" layout-align="center center"><span \nng-if="item.title"><strong>{{item.title}}</strong></span> <span ng-if="item.filename">{{item.filename}}</span></span>\n</div></div><div class="header p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size text-truncate" layout="row" layout-align="start left"><strong class="mr-5">#{{item.id_media}}</strong>\n</div><md-checkbox ng-checked="vm.alreadySelectedbyZone(vm.selectedImages, item)" \nng-click="vm.toggleSelectedImages(item, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, item) ? \'Deselect\' : \'Select\'}}" class="ml-5"></md-checkbox>\n</div></div></div></div></div></div></div></div><div layout="column" layout-align="center center"></div>');
$templateCache.put('app/main/apps/proyects/dialogs/media/views/import-view.html','<div class="content-wrapper" flex layout="column"><div class="content"><div class="drop-box"><md-input-container \nclass="md-block"><label>Paste the url to import:</label> <input type="text" name="import_field" \nng-model="vm.import_field" placeholder="" ng-disabled="vm.import_disabled"></md-input-container><div \nng-if="vm.imported" class="alert-message success-message" translate="GLOBAL.SUCCESSIMPORT">Imported successfully</div>\n</div><treasure-overlay-spinner active="vm.importing"><div layout="row" layout-align="center start" \nng-if="vm.importPreview" class="white-box sections"><div flex-gt-sm="50" flex="100"><div class="section"><div \nclass="section-header" layout="row" layout-align="start center"><span class="section-title">PREVIEW</span></div><div \nclass="media" flex layout="row" layout-align="center center" ng-bind-html="vm.importPreview.embedCodeSafe"></div></div>\n<div class="header p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size text-truncate" layout="row" layout-align="start left"><span class="grey-500-fg"><span \nng-if="vm.importPreview.title">Title: {{vm.importPreview.title}}</span></span></div></div><div layout="row" \nlayout-align="space-between center" flex><div class="size" layout="row" layout-align="start left"><span \nclass="grey-500-fg"><span ng-if="vm.importPreview.caption">Description: {{vm.importPreview.caption}}</span></span>\n</div></div></div><md-button class="send-button md-accent md-raised" ng-click="vm.importConfirm(1)" \ntranslate="GLOBAL.IMPORT">Import</md-button></div></div><div ng-repeat="f in vm.importedFiles" class="ms-card" flex>\n<div class="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><img ng-src="{{f.embed_thumb}}" class="image"></div><div class="header p-16" flex><div \nlayout="row" layout-align="space-between center" flex><div class="size text-truncate" layout="row" \nlayout-align="start left"><strong class="mr-5">#{{f.id_media}}</strong> <span class="grey-500-fg"><span \nng-if=".filename">{{f.filename}}</span> <span ng-if="f.title">{{f.title}}</span></span></div><md-checkbox \nng-checked="vm.alreadySelectedbyZone(vm.selectedImages, f)" ng-click="vm.toggleSelectedImages(f, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, f) ? \'Deselect\' : \'Select\'}}"></md-checkbox></div></div>\n</div></div></div></treasure-overlay-spinner></div></div>');
$templateCache.put('app/main/apps/proyects/dialogs/media/views/photos-view.html','<div class="content-wrapper" flex layout="row"><div class="mail-tabs-grid" flex \nmd-dynamic-height="{{vm.dynamicHeight}}"><div class="content mail-list-pane-grid" flex><div \nng-repeat="photo in vm.items" class="ms-card" flex><div class="ms-card-content-wrapper"><div class="template-9"><div \nclass="media" flex layout="row" layout-align="center center"><media attachment="photo" class=""></media></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size text-truncate" \nlayout="row" layout-align="start left"><strong class="mr-5">#{{photo.id_media}}</strong> <span class="grey-500-fg">\n<span ng-if="photo.filename">{{photo.filename}}</span></span></div><md-checkbox \nng-checked="vm.alreadySelectedbyZone(vm.selectedImages, photo)" ng-click="vm.toggleSelectedImages(photo, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, photo) ? \'Deselect\' : \'Select\'}}" class="ml-5"></md-checkbox>\n</div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/proyects/dialogs/media/views/template-grid.html','<div class="template-9"><div class="header p-16" layout="row" layout-align="space-between center" flex><div \nlayout="column" layout-align="start center"><md-checkbox class="no-label" ng-checked="vm.isChecked(mail)" \nng-click="vm.toggleCheck(mail, $event)" aria-label="{{vm.isChecked(mail)? \'Uncheck\':\'check\'}}"></md-checkbox><div \nng-if="refcolumnsgrouped.main"><div class="subject text-truncate"><span \nng-repeat="field in refcolumnsgrouped.header | orderBy: \'list-sort\'" ng-bind="thread.{{field.titleId}}"></span></div>\n</div></div><div layout="column" layout-align="start center"><md-icon md-font-icon="icon-attachment" \nclass="has-attachment s24" ng-if="thread.Thumbnail.length>0"></md-icon><button ng-if="thread.onoff===1" \nclass="md-icon-button"><md-icon md-font-icon="icon-checkbox-marked-circle" class="on green-fg s24"></md-icon></button> \n<button ng-if="thread.onoff!==1" class="md-icon-button"><md-icon md-font-icon="icon-checkbox-blank-circle-outline" \nclass="off red-fg s24"></md-icon></button></div></div><div class="media" flex layout="row" \nlayout-align="center center"><img class="image" ng-src="{{card.Thumbnail[0].crop_status[0].urlformed}}" \nalt="{{card.media.image.alt}}" imageonloadcontrol></div><div class="header p-16" layout="row" layout-align="start"><div\n class="info"><div ng-if="refcolumnsgrouped.main"><div class="name text-truncate" layout="row" \nlayout-align="start center"><span ng-repeat="field in refcolumnsgrouped.main"><span ng-bind="thread.{{field.titleId}}">\n</span>&nbsp;</span></div></div><div ng-repeat="field in refcolumnsgrouped.secondary | orderBy:\'list_sort\'"><div \nng-if="(field.type!==\'date\' && field.type!==\'dateHm\') && field.primary!==1" class="details" layout="row" \nlayout-align="start start"><div layout="column"><span class="title" ng-bind="field.title"></span></div><div \nlayout="column" class="text-truncate"><span class="detail" ng-bind="thread.{{field.titleId}}"></span></div></div></div>\n</div></div></div>');
$templateCache.put('app/main/apps/proyects/dialogs/media/views/tiny-attached.html','<div class="content-wrapper" flex layout="row"><div class="mail-tabs-grid" flex \nmd-dynamic-height="{{vm.dynamicHeight}}"><div class="content mail-list-pane-grid" flex><div \nng-repeat="item in vm.selectedImages" class="ms-card" flex><div class="ms-card-content-wrapper" \nng-if="item.media_type == 1"><div class="template-9"><div class="media" flex layout="row" layout-align="center center">\n<img ng-src="{{item.cropstatus[0].container.view_url}}{{item.cropstatus[0].fileName}}" class="image"></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size text-truncate" \nlayout="row" layout-align="start left"><strong class="mr-5">#{{item.id_media}}</strong> <span class="grey-500-fg"><span\n ng-if="item.filename">{{item.filename}}</span></span></div><md-button ng-click="vm.selectMediaTiny(item)" \nclass="send-button md-accent md-raised" aria-label="Select" translate="GLOBAL.SELECT" \ntranslate-attr-aria-label="GLOBAL.SELECT">SELECT</md-button></div></div></div></div><div \nclass="ms-card-content-wrapper" ng-if="item.media_type == 2"><div class="template-9"><div class="media" flex \nlayout="row" layout-align="center center"><img ng-src="{{item.embed_thumb}}" class="image"></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size text-truncate" \nlayout="row" layout-align="start left"><strong class="mr-5">#{{item.id_media}}</strong> <span class="grey-500-fg"><span\n ng-if="item.filename">{{item.filename}}</span> <span ng-if="item.title">{{item.title}}</span></span></div><md-button \nng-click="vm.selectMediaTiny(item)" class="send-button md-accent md-raised" aria-label="Select" \ntranslate="GLOBAL.SELECT" translate-attr-aria-label="GLOBAL.SELECT">SELECT</md-button></div></div></div></div></div>\n</div></div></div>');
$templateCache.put('app/main/apps/proyects/dialogs/media/views/tiny-properties.html','<div class="ontent-wrapper" flex="" layout="column"><div class="content"><div class="ms-card" flex><div \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center" ng-if="vm.selectedMediaTiny.media_type == 1"><img \nng-src="{{vm.selectedMediaTiny.cropstatus[0].container.view_url}}{{vm.selectedMediaTiny.cropstatus[0].fileName}}" \nclass="image"></div><div class="media" flex layout="row" layout-align="center center" \nng-if="vm.selectedMediaTiny.media_type == 2"><img ng-src="{{vm.selectedMediaTiny.embed_thumb}}" class="image"></div>\n<div class="header p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size text-truncate" layout="row" layout-align="start left"><strong class="mr-5">\n#{{vm.selectedMediaTiny.id_media}}</strong> <span class="grey-500-fg"><span ng-if="vm.selectedMediaTiny.filename">\n{{vm.selectedMediaTiny.filename}}</span></span></div></div></div></div></div></div><div><md-input-container \nclass="md-block" flex><label translate="GLOBAL.ALIGN" translate-attr-aria-label="GLOBAL.ALIGN">Align:</label><md-select\n ng-model="vm.tinyProperties.align" placeholder="Align"><md-option value="">---</md-option><md-option \nng-repeat="opt in vm.tinyOptions.align" value="{{opt.value}}">{{opt.text}}</md-option></md-select><div \nclass="md-errors-spacer"></div></md-input-container><md-input-container class="md-block" flex><label \ntranslate="GLOBAL.SIZE" translate-attr-aria-label="GLOBAL.SIZE">Size:</label><md-select \nng-model="vm.tinyProperties.size" placeholder="Size"><md-option value="">---</md-option><md-option \nng-repeat="opt in vm.tinyOptions.size" value="{{opt.value}}">{{opt.text}}</md-option></md-select><div \nclass="md-errors-spacer"></div></md-input-container></div></div></div>');
$templateCache.put('app/main/apps/proyects/dialogs/media/views/upload-view.html','<div class="content-wrapper" flex="" layout="column"><div class="content"><div ngf-drop ngf-select ng-model="vm.files" \nclass="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="false" ngf-allow-dir="true" accept="image/*" \nngf-pattern="\'image/*\'"><md-button class="md-raised md-accent text-center" ng-model="photo" \ntranslate="GLOBAL.SELECT_FILES" onchange="angular.element(this).scope().file_changed(this)" type="file" \naccept="image/*"></md-button></div><md-progress-linear md-mode="determinate" value="{{vm.files[0].progress}}" \nng-show="vm.files[0].progress < 100"></md-progress-linear></div></div>');
$templateCache.put('app/main/apps/proyects/dialogs/media/views/videos-view.html','<div class="content-wrapper" flex layout="row"><div class="mail-tabs-grid" flex><div \nclass="content mail-list-pane-grid" flex><div ng-repeat="item in vm.items" class="ms-card" flex><div \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><media attachment="item" thumbnail="true" class=""></media></div><div class="header p-16" \nflex><div layout="row" layout-align="space-between center" flex><div class="size text-truncate" layout="row" \nlayout-align="start left"><strong class="mr-5">#{{item.id_media}}</strong> <span class="grey-500-fg"><span \nng-if="item.filename">{{item.filename}}</span> <span ng-if="item.title">{{item.title}}</span></span></div><md-checkbox \nng-checked="vm.alreadySelectedbyZone(vm.selectedImages, item)" ng-click="vm.toggleSelectedImages(item, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, item) ? \'Deselect\' : \'Select\'}}"></md-checkbox></div></div>\n</div></div></div></div></div></div>');
$templateCache.put('app/main/apps/proyects/dialogs/image/views/fotorama-view.html','<div class="content-wrapper" flex layout="row"><div class="mail-tabs-grid" flex \nmd-dynamic-height="{{vm.dynamicHeight}}"><fotorama options="vm.fotoramaoptions" items="vm.dataFotorama" id="fotorama">\n</fotorama></div></div>');
$templateCache.put('app/main/apps/mail/views/classic/detail/detail.html','<div class="thread-header" layout="row" layout-align="space-between center"><div><div class="subject" flex>\n{{vm.currentThread.subject}}</div><div class="labels"><div class="label" \nng-repeat="labelId in vm.currentThread.labels" ng-class="vm.getLabelColor(labelId)">{{vm.getLabelTitle(labelId)}}</div>\n</div></div><div class="actions" layout="row" layout-align="start center"><md-button class="md-icon-button" \nng-click="vm.toggleThreadStatus(\'starred\')" aria-label="Toggle starred" translate \ntranslate-attr-toogle-starred="MAIL.TOGGLE_STARRED"><md-icon ng-if="vm.currentThread.starred" md-font-icon="icon-star" \nclass="amber-fg"></md-icon><md-icon ng-if="!vm.currentThread.starred" md-font-icon="icon-star-outline"></md-icon>\n</md-button><md-button class="md-icon-button" ng-click="vm.toggleThreadStatus(\'important\')" \naria-label="Toggle important" translate translate-attr-toogle-starred="MAIL.TOGGLE_IMPORTANT"><md-icon \nng-if="vm.currentThread.important" md-font-icon="icon-label" class="amber-300-fg"></md-icon><md-icon \nng-if="!vm.currentThread.important" md-font-icon="icon-label-outline"></md-icon></md-button></div></div><div \nclass="thread-content"><div class="info" layout="row" layout-align="space-between start"><div layout="column" \nlayout-align="start start"><div layout="row" layout-align="start start"><div><img ng-if="vm.currentThread.from.avatar" \nalt="{{vm.currentThread.from.name}}" ng-src="{{vm.currentThread.from.avatar}}" class="avatar"><div \nng-if="!vm.currentThread.from.avatar" class="avatar" ms-random-class="vm.colors">{{vm.currentThread.from.name[0]}}\n</div></div><div layout="column" layout-align="start start"><div class="name">{{vm.currentThread.from.name}}</div><div \nclass="to" layout="row" layout-align="start center"><div class="to-text" translate="MAIL.INFO.TO">to</div><div>\n{{vm.currentThread.to[0].name}}</div></div></div></div><a class="toggle-details md-accent-color" \nng-hide="vm.selectedMailShowDetails" ng-click="vm.selectedMailShowDetails = !vm.selectedMailShowDetails" \ntranslate="MAIL.SHOW_DETAILS">Show Details </a><a class="toggle-details md-accent-color" \nng-show="vm.selectedMailShowDetails" ng-click="vm.selectedMailShowDetails = !vm.selectedMailShowDetails" \ntranslate="MAIL.HIDE_DETAILS">Hide Details</a><div ng-show="vm.selectedMailShowDetails" class="details" layout="row" \nlayout-align="start start"><div layout="column"><span class="title" translate="MAIL.DETAILS.FROM">From:</span> <span \nclass="title" translate="MAIL.DETAILS.TO">To:</span> <span class="title" translate="MAIL.DETAILS.DATE">Date:</span>\n</div><div layout="column"><span class="detail">{{vm.currentThread.from.email}}</span> <span class="detail">\n{{vm.currentThread.to[0].email}}</span> <span class="detail">{{vm.currentThread.time}}</span></div></div></div>\n<md-menu><md-button aria-label="More" class="md-icon-button" ng-click="$mdMenu.open($event)" translate \ntranslate-aria-label="MAIL.MORE"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content \nwidth="3"><md-menu-item><md-button aria-label="Reply" translate-aria-label="MAIL.REPLY" \nng-click="vm.replyDialog($event)"><md-icon md-font-icon="icon-reply"></md-icon><span translate="MAIL.REPLY">Reply\n</span></md-button></md-menu-item><md-menu-item><md-button aria-label="Forward" translate-aria-label="MAIL.FORWARD">\n<md-icon md-font-icon="icon-forward"></md-icon><span translate="MAIL.FORWARD">Forward</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label="Print" translate-aria-label="MAIL.PRINT"><md-icon md-font-icon="icon-printer">\n</md-icon><span translate="MAIL.PRINT">Print</span></md-button></md-menu-item></md-menu-content></md-menu></div><div \nng-bind-html="vm.currentThread.message"></div></div><div ng-if="vm.currentThread.attachments" \nclass="thread-attachments"><div class="title"><span translte="MAIL.ATTACHMENTS">Attachments</span>\n ({{vm.currentThread.attachments.length}})</div><div class="attachment-list" layout-wrap layout="row"><div \nclass="attachment" layout="column" ng-repeat="attachment in vm.currentThread.attachments"><img class="preview" \nng-src="{{attachment.preview}}"><div layout="column"><a href="#" class="md-accent-color link" translate="MAIL.VIEW">\nView</a> <a href="#" class="md-accent-color link" translate="MAIL.DOWNLOAD">Download</a><div class="size">\n({{attachment.size}})</div></div></div></div></div>');
$templateCache.put('app/main/apps/mail/views/classic/list/list.html','<div class="no-threads" ng-if="vm.threads.length === 0">There are no messages in \'{{vm.currentFilter.filter}}\'!</div>\n<div class="loading-threads" layout="column" layout-align="center center" ng-if="!vm.threads && vm.loadingThreads">\n<md-progress-circular class="md-accent" md-mode="indeterminate" md-diameter="64"></md-progress-circular><div>\nLoading your mails...</div></div><div class="thread {{thread.status}}" md-ink-ripple ng-if="!vm.loadingThreads" \nng-repeat="thread in vm.threads | filter: vm.search | filter: global.search" ng-click="vm.openThread(thread)" \nng-class="{\'unread\': !thread.read, \'current-thread\': vm.currentThread === thread, \'selected\': vm.isSelected(thread)}">\n<div layout="row" layout-align="start center"><md-checkbox class="no-label" ng-checked="vm.isSelected(thread)" \nng-click="vm.toggleSelectThread(thread, $event)" aria-label="{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}">\n</md-checkbox><div class="info" flex layout="column"><div class="name" layout="row" layout-align="start center"><img \nclass="avatar" ng-if="thread.from.avatar" alt="{{thread.from.name}}" ng-src="{{thread.from.avatar}}"><div \nclass="avatar" ng-if="!thread.from.avatar" ms-random-class="vm.colors">{{thread.from.name[0]}}</div><span \nclass="text-truncate">{{thread.from.name}}</span><md-icon md-font-icon="icon-paperclip" class="has-attachment s16" \nng-if="thread.hasAttachments"></md-icon></div><div class="subject text-truncate">{{thread.subject}}</div><div \nclass="message text-truncate">\n{{thread.message | htmlToPlaintext | limitTo:180}}{{thread.message.length > 180 ? \'...\' : \'\'}}<div class="labels"><div \nclass="label" ng-repeat="labelId in thread.labels" ng-class="vm.getLabelColor(labelId)">{{vm.getLabelTitle(labelId)}}\n</div></div></div></div><div layout="column" layout-align="space-between end"><div class="time">{{thread.time}}</div>\n<div class="actions" layout="row" layout-align="start center"><md-button class="md-icon-button" \nng-click="vm.toggleThreadStatus(\'starred\', thread, $event)" aria-label="Toggle starred" translate \ntranslate-attr-aria-label="MAIL.TOGGLE_STARRED"><md-icon ng-if="thread.starred" md-font-icon="icon-star" \nclass="amber-fg"></md-icon><md-icon ng-if="!thread.starred" md-font-icon="icon-star-outline"></md-icon></md-button>\n<md-button class="md-icon-button" ng-click="vm.toggleThreadStatus(\'important\', thread, $event)" \naria-label="Toggle important" translate translate-attr-aria-label="MAIL.TOGGLE_IMPORTANT"><md-icon \nng-if="thread.important" md-font-icon="icon-label" class="amber-300-fg"></md-icon><md-icon ng-if="!thread.important" \nmd-font-icon="icon-label-outline"></md-icon></md-button></div></div></div></div>');
$templateCache.put('app/main/apps/mail/views/outlook/detail/detail.html','<div ng-if="!vm.currentThread" class="no-thread-selected" layout="column" layout-align="center center" flex><md-icon \nmd-font-icon="icon-email" class="s120 grey-400-fg"></md-icon><span class="hint-text" \ntranslate="MAIL.SELECT_MESSAGE_TO_READ">Select a message to read</span></div><div ng-if="vm.currentThread"><div \nclass="thread-header" layout="row" layout-align="space-between center"><div><div class="subject" flex>\n{{vm.currentThread.subject}}</div><div class="labels"><div class="label" \nng-repeat="labelId in vm.currentThread.labels" ng-class="vm.getLabelColor(labelId)">{{vm.getLabelTitle(labelId)}}</div>\n</div></div><div class="actions" layout="row" layout-align="start center"><md-button class="md-icon-button" \nng-click="vm.toggleThreadStatus(\'starred\')" aria-label="Toggle starred" translate \ntranslate-attr-toogle-starred="MAIL.TOGGLE_STARRED"><md-icon ng-if="vm.currentThread.starred" md-font-icon="icon-star" \nclass="amber-fg"></md-icon><md-icon ng-if="!vm.currentThread.starred" md-font-icon="icon-star-outline"></md-icon>\n</md-button><md-button class="md-icon-button" ng-click="vm.toggleThreadStatus(\'important\')" \naria-label="Toggle important" translate translate-attr-toogle-starred="MAIL.TOGGLE_IMPORTANT"><md-icon \nng-if="vm.currentThread.important" md-font-icon="icon-label" class="amber-300-fg"></md-icon><md-icon \nng-if="!vm.currentThread.important" md-font-icon="icon-label-outline"></md-icon></md-button></div></div><div \nclass="thread-content"><div class="info" layout="row" layout-align="space-between start"><div layout="column" \nlayout-align="start start"><div layout="row" layout-align="start start"><div><img ng-if="vm.currentThread.from.avatar" \nalt="{{vm.currentThread.from.name}}" ng-src="{{vm.currentThread.from.avatar}}" class="avatar"><div \nng-if="!vm.currentThread.from.avatar" class="avatar" ms-random-class="vm.colors">{{vm.currentThread.from.name[0]}}\n</div></div><div layout="column" layout-align="start start"><div class="name">{{vm.currentThread.from.name}}</div><div \nclass="to" layout="row" layout-align="start center"><div class="to-text" translate="MAIL.INFO.TO">to</div><div>\n{{vm.currentThread.to[0].name}}</div></div></div></div><a class="toggle-details md-accent-color" \nng-hide="vm.selectedMailShowDetails" ng-click="vm.selectedMailShowDetails = !vm.selectedMailShowDetails" \ntranslate="MAIL.SHOW_DETAILS">Show Details </a><a class="toggle-details md-accent-color" \nng-show="vm.selectedMailShowDetails" ng-click="vm.selectedMailShowDetails = !vm.selectedMailShowDetails" \ntranslate="MAIL.HIDE_DETAILS">Hide Details</a><div ng-show="vm.selectedMailShowDetails" class="details" layout="row" \nlayout-align="start start"><div layout="column"><span class="title" translate="MAIL.DETAILS.FROM">From:</span> <span \nclass="title" translate="MAIL.DETAILS.TO">To:</span> <span class="title" translate="MAIL.DETAILS.DATE">Date:</span>\n</div><div layout="column"><span class="detail">{{vm.currentThread.from.email}}</span> <span class="detail">\n{{vm.currentThread.to[0].email}}</span> <span class="detail">{{vm.currentThread.time}}</span></div></div></div>\n<md-menu><md-button aria-label="More" class="md-icon-button" ng-click="$mdMenu.open($event)" translate \ntranslate-aria-label="MAIL.MORE"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content \nwidth="3"><md-menu-item><md-button aria-label="Reply" translate-aria-label="MAIL.REPLY" \nng-click="vm.replyDialog($event)"><md-icon md-font-icon="icon-reply"></md-icon><span translate="MAIL.REPLY">Reply\n</span></md-button></md-menu-item><md-menu-item><md-button aria-label="Forward" translate-aria-label="MAIL.FORWARD">\n<md-icon md-font-icon="icon-forward"></md-icon><span translate="MAIL.FORWARD">Forward</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label="Print" translate-aria-label="MAIL.PRINT"><md-icon md-font-icon="icon-printer">\n</md-icon><span translate="MAIL.PRINT">Print</span></md-button></md-menu-item></md-menu-content></md-menu></div><div \nng-bind-html="vm.currentThread.message"></div></div><div ng-if="vm.currentThread.attachments" \nclass="thread-attachments"><div class="title"><span translte="MAIL.ATTACHMENTS">Attachments</span>\n ({{vm.currentThread.attachments.length}})</div><div class="attachment-list" layout-wrap layout="row"><div \nclass="attachment" layout="column" ng-repeat="attachment in vm.currentThread.attachments"><img class="preview" \nng-src="{{attachment.preview}}"><div layout="column"><a href="#" class="md-accent-color link" translate="MAIL.VIEW">\nView</a> <a href="#" class="md-accent-color link" translate="MAIL.DOWNLOAD">Download</a><div class="size">\n({{attachment.size}})</div></div></div></div></div></div>');
$templateCache.put('app/main/apps/mail/views/outlook/list/list.html','<div class="no-threads" ng-if="vm.threads.length === 0">There are no messages in \'{{vm.currentFilter.filter}}\'!</div>\n<div class="loading-threads" layout="column" layout-align="center center" ng-if="!vm.threads && vm.loadingThreads">\n<md-progress-circular class="md-accent" md-mode="indeterminate" md-diameter="64"></md-progress-circular><div>\nLoading your mails...</div></div><div class="thread {{thread.status}}" md-ink-ripple ng-if="!vm.loadingThreads" \nng-repeat="thread in vm.threads | filter: vm.search | filter: global.search" ng-click="vm.openThread(thread)" \nng-class="{\'unread\': !thread.read, \'current-thread\': vm.currentThread === thread, \'selected\': vm.isSelected(thread)}">\n<div layout="row" layout-align="start center"><md-checkbox class="no-label" ng-checked="vm.isSelected(thread)" \nng-click="vm.toggleSelectThread(thread, $event)" aria-label="{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}">\n</md-checkbox><div class="info" flex layout="column"><div class="name" layout="row" layout-align="start center"><img \nclass="avatar" ng-if="thread.from.avatar" alt="{{thread.from.name}}" ng-src="{{thread.from.avatar}}"><div \nclass="avatar" ng-if="!thread.from.avatar" ms-random-class="vm.colors">{{thread.from.name[0]}}</div><span \nclass="text-truncate">{{thread.from.name}}</span><md-icon md-font-icon="icon-paperclip" class="has-attachment s16" \nng-if="thread.hasAttachments"></md-icon></div><div class="subject text-truncate">{{thread.subject}}</div><div \nclass="message text-truncate">\n{{thread.message | htmlToPlaintext | limitTo:90}}{{thread.message.length > 90 ? \'...\' : \'\'}}<div class="labels"><div \nclass="label" ng-repeat="labelId in thread.labels" ng-class="vm.getLabelColor(labelId)">{{vm.getLabelTitle(labelId)}}\n</div></div></div></div><div layout="column" layout-align="space-between end"><div class="time">{{thread.time}}</div>\n</div></div></div>');
$templateCache.put('app/main/apps/proyects/views/read/form-tabs/step-branchs.html','<div layout="column" layout-gt-xs="row"><md-input-container flex><h1 translate="GLOBAL.MAIN_BRANCH"></h1>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="GLOBAL.NAME"></label> <input ng-model="vm.formWizard.main_branch.name" type="text"></md-input-container>\n<md-input-container flex><label translate="GLOBAL.ADDRESS"></label> <input \nng-model="vm.formWizard.main_branch.address1" type="text" required></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container flex><label>{{vm.getRegionLiteral(\'city\')}}</label> <input \nng-model="vm.formWizard.main_branch.city" type="text" required></md-input-container><md-input-container flex><label>\n{{vm.getRegionLiteral(\'state\')}}</label> <input ng-model="vm.formWizard.main_branch.state" type="text" required>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="GLOBAL.POSTAL_CODE"></label> <input ng-model="vm.formWizard.main_branch.postcode" type="text" required>\n</md-input-container><md-input-container flex><label translate="GLOBAL.PHONE"></label> <input \nng-model="vm.formWizard.main_branch.phone" type="text"></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container flex><label translate="GLOBAL.EMAIL"></label> <input \nng-model="vm.formWizard.main_branch.email" type="text"></md-input-container><md-input-container flex>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container class="group-form" flex="100" \nflex-gt-xs="100"><div layout="row" layout-align="start center"><h1 translate="GLOBAL.BRANCH"></h1><md-button \nng-click="vm.openDialogForm(\'branch\')" class="ml-10 md-mini add-event-button md-fab md-warn"><md-icon \nmd-font-icon="icon-plus"></md-icon></md-button></div><div class="mail-list-pane s0" \nng-if="vm.formWizard.branch && vm.formWizard.branch.length > 0"><div class="items" ng-if="!branch.is_main" \nng-repeat="branch in vm.formWizard.branch"><div layout="row" layout-align="start center" flex="100" class="p-20"><div \nlayout="row" layout-align="start center" flex="90"><div class="avatar-wrapper"><md-icon md-font-icon="icon-city">\n</md-icon></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding" \nng-bind-html="branch.name"></strong><div class="field grey-600-fg ng-binding"><span ng-if="branch.city" \nng-bind-html="branch.city"></span> <span ng-if="branch.city && branch.state">, </span><span ng-if="branch.state" \nng-bind-html="branch.state"></span></div></div></div><div class="menu" flex="10" layout-align="center end" \nlayout="column"><md-menu class="float-right"><md-button class="md-icon-button" aria-label="More" \nng-click="vm.openMenu($mdMenu, $event)"><md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg">\n</md-icon></md-button><md-menu-content width="2"><md-menu-item><md-button translate="GLOBAL.EDIT" \nng-click="vm.editBranchDialog($event, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div></md-input-container></div>');
$templateCache.put('app/main/apps/proyects/views/read/form-tabs/step-company.html','<div layout="column" layout-gt-xs="row"><md-input-container flex><label translate="GLOBAL.SOCIAL_REASON"></label> \n<input type="text" ng-model="vm.formWizard.company.name" required></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container flex><label>{{vm.getRegionLiteral(\'tax_ic_number\')}}</label> <input type="text" \nng-model="vm.formWizard.company.tax_id_number"></md-input-container><md-input-container flex><label \ntranslate="GLOBAL.SECTOR"></label><md-select ng-model="vm.formWizard.company.sector_id"><md-option \nng-repeat="sector in vm.sectors track by $index" ng-value="sector.id">{{sector.name}}</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="GLOBAL.REGION"></label><md-select ng-model="vm.formWizard.company.region_id"><md-option \nng-repeat="region in vm.regions track by $index" ng-value="region.id">{{region.name}}</md-option></md-select>\n</md-input-container><md-input-container flex></md-input-container></div><div layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container><p class="mt-0 grey-400-fg" translate="GLOBAL.LOGOTYPE"></p><div \nclass="header simple relative" ng-if="image || imageUrl" layout="row" layout-align="space-between center"><md-menu>\n<button class="md-icon-button" aria-label="More"><div layout="column" layout-align="start center" \nng-click="$mdMenu.open($event)"><div class="media" flex layout="row" layout-align="center center"><img \nngf-thumbnail="!image.$error && image" class="image"> <img ng-if="!image && imageUrl" src="{{imageUrl}}" class="image">\n</div><md-button class="md-mini add-event-button no-sort md-fab md-warn block absolute-top-right" \naria-label="Add event"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button></div></button><md-menu-content\n width="3"><md-menu-item><md-button ng-click="vm.deleteLogotype()" aria-label="Toggle done" \ntranslate-attr-aria-label="GLOBAL.REMOVE"><md-icon md-font-icon="icon-close" class="s18"></md-icon><span \ntranslate="GLOBAL.REMOVE"></span></md-button></md-menu-item></md-menu-content></md-menu></div><div \nng-if="!image && !imageUrl" ng-click="vm.mediaDialogSingle($event, vm.formWizard.company.logotype)" class="relative">\n<img src="assets/images/logos/generic-logo.png" class="image"><md-button \nclass="md-mini add-event-button no-sort md-fab md-warn block absolute-top-right" aria-label="Add event" translate \ntranslate-attr-aria-label="CALENDAR.ADD_EVENT"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n</md-input-container></div>');
$templateCache.put('app/main/apps/proyects/views/read/form-tabs/step-options.html','<div class="options"><div layout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container \nfill-width flex><label translate="GLOBAL.DESCRIPTION"></label> <input type="text" \nng-model="vm.formWizard.company.description"></md-input-container><md-input-container fill-width flex><label \ntranslate="GLOBAL.COMPANY_TYPE"></label><md-select ng-model="vm.formWizard.company.extra_data.company_type"><md-option \nng-value="1">SA</md-option><md-option ng-value="2">SL</md-option><md-option ng-value="3">Cotizada</md-option><md-option\n ng-value="4">Fundaciones/asociaciones</md-option><md-option ng-value="5">Otras</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container\n fill-width flex><label translate="GLOBAL.EXECUTIVE_TYPE"></label><md-select \nng-model="vm.formWizard.company.extra_data.executives_type"><md-option ng-value="1">Accionista \xFAnico</md-option>\n<md-option ng-value="2">Varios accionistas</md-option><md-option ng-value="3">Consejo de administraci\xF3n</md-option>\n<md-option ng-value="4">Administrador \xFAnico</md-option><md-option ng-value="5">Otros</md-option></md-select>\n</md-input-container><md-input-container fill-width flex><label translate="GLOBAL.SOCIAL_CAPITAL"></label><md-select \nng-model="vm.formWizard.company.extra_data.capital"><md-option ng-value="1">Capital</md-option><md-option ng-value="2">\nAportaciones de socios</md-option><md-option ng-value="3">Aumentos de capital recientes</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container\n fill-width flex><label translate="GLOBAL.AMOUNT_CAPITAL"></label> <input type="number" type="text" \nng-model="vm.formWizard.company.extra_data.capital_amount"></md-input-container><md-input-container fill-width flex>\n<label translate="GLOBAL.BILLING_LAST_YEAR"></label> <input type="number" \nng-model="vm.formWizard.company.turnover_volume"></md-input-container></div><div layout="column" layout-gt-xs="row" \nflex layout-align="start center"><md-input-container fill-width flex><label>Cuentas anuales</label><md-select \nng-model="vm.formWizard.company.extra_data.annual_accounts"><md-option ng-value="1">Abreviadas</md-option><md-option \nng-value="2">Normales</md-option><md-option ng-value="3">Pymes</md-option><md-option ng-value="4">Mixtas</md-option>\n</md-select></md-input-container><md-input-container fill-width flex><label>Auditor\xEDas</label><md-select \nng-model="vm.formWizard.company.extra_data.audits"><md-option ng-value="1">Internas</md-option><md-option ng-value="2">\nExternas</md-option><md-option ng-value="3">No aplica</md-option></md-select></md-input-container></div><div \nlayout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container fill-width flex><label>\nCertificaciones ISO</label><md-select ng-model="vm.formWizard.company.extra_data.iso_certification"><md-option \nng-value="1">ISO 9001</md-option><md-option ng-value="2">ISO 14000</md-option><md-option ng-value="3">ISO 14001\n</md-option><md-option ng-value="4">ISO 19600</md-option><md-option ng-value="5">ISO 22000</md-option><md-option \nng-value="6">ISO 26000</md-option><md-option ng-value="7">ISO 27001</md-option><md-option ng-value="8">ISO 37001\n</md-option><md-option ng-value="9">OHSAS 18001</md-option></md-select></md-input-container><md-input-container \nfill-width flex><label>Convenio Colectivo Aplicable</label> <input type="text" \nng-model="vm.formWizard.company.extra_data.collective_agreement"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" flex layout-align="start center"><md-input-container fill-width flex><label>Seguros contratados\n</label> <input type="text" ng-model="vm.formWizard.company.extra_data.insurance"></md-input-container>\n<md-input-container fill-width flex><label translate="GLOBAL.CNAE"></label> <input type="text" \nng-model="vm.formWizard.company.extra_data.cnae"></md-input-container></div><div layout="column" layout-gt-xs="row" \nflex layout-align="start center"><md-input-container fill-width layout="row" layout-align="start center" flex><label \nclass="ph-15" fill-width translate="GLOBAL.FINANCING"></label><md-select flex \nng-init="!vm.formWizard.company.extra_data.financing ? vm.formWizard.company.extra_data.financing = [] : null;" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.financing"><md-option \nng-repeat="option in vm.financing_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container><md-input-container fill-width layout="row" layout-align="start center" flex><label class="ph-15" \nfill-width>Normativa Sectorial aplicable</label><md-select flex \nng-init="!vm.formWizard.company.extra_data.sector_regulations ? vm.formWizard.company.extra_data.sector_regulations = [] : null;" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.sector_regulations"><md-option \nng-repeat="option in vm.sector_regulations_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-align="start center"><md-input-container \nfill-width layout="row" layout-align="start center" flex><label class="ph-15" fill-width>Medidas implementadas</label>\n<md-select flex \nng-init="!vm.formWizard.company.extra_data.implemented_measures ? vm.formWizard.company.extra_data.implemented_measures = [] : null;" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.implemented_measures"><md-option \nng-repeat="option in vm.implemented_measures_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container></div><div class="separator-options" layout="row"><h2>Grupo de sociedades?</h2><md-input-container\n fill-width layout="row" layout-align="start center" flex class="mb-0"><md-checkbox \nng-checked="vm.formWizard.company.extra_data.belogns_to_holding" \nng-model="vm.formWizard.company.extra_data.belogns_to_holding"></md-checkbox></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-align="start center"></div><div \nng-if="vm.formWizard.company.extra_data.belogns_to_holding" layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container fill-width flex><label>Nombre corporaci\xF3n</label> <input type="text" \nng-model="vm.formWizard.company.extra_data.name_corporation"></md-input-container><md-input-container fill-width flex>\n<label>CIF corporaci\xF3n</label> <input type="text" ng-model="vm.formWizard.company.extra_data.cif_corporation">\n</md-input-container></div><div class="mv-25" ng-if="vm.formWizard.company.extra_data.belogns_to_holding" \nlayout="column" layout-gt-xs="row" layout-align="start center"><div fill-width><div ngf-drop ngf-select \nng-model="vm.files_belogns_to_holding" class="drop-box" layout="column" layout-gt-xs="row" \nngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="belogns_to_holding_isLoading"><div flex layout="column" layout-align="center center" layout-padding \nlayout-margin class="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30">\n</md-progress-circular></div></div></div><div layout="column" flex><div \nng-repeat="f in vm.formWizard.company.extra_data.belogns_to_holding_files track by $index" class="border-bottom" flex>\n<div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><div class="media photos" layout="row" layout-align="center center"><h2c-icon \nfile="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" alt=""></div><div class="info ml-15" flex \nlayout="column" layout-align="center center"><div class="name" layout="row" layout-align="center center"><span \nng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu class="float-right"><md-button \nclass="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.belogns_to_holding_files.splice($index, 1);"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></div></div></div><div class="separator-options" \nlayout="row"><h2>Responsabilidad social corporativa?</h2><md-input-container fill-width layout="row" \nlayout-align="start center" flex class="mb-0"><md-checkbox \nng-checked="vm.formWizard.company.extra_data.social_responsability" \nng-model="vm.formWizard.company.extra_data.social_responsability"></md-checkbox></md-input-container></div><div \nclass="mv-25" ng-if="vm.formWizard.company.extra_data.social_responsability" layout="column" layout-gt-xs="row" \nlayout-align="start center"><div fill-width><div ngf-drop ngf-select ng-model="vm.files_social_responsability" \nclass="drop-box" layout="column" layout-gt-xs="row" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" \nngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="social_responsability_isLoading"><div flex layout="column" layout-align="center center" layout-padding \nlayout-margin class="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30">\n</md-progress-circular></div></div></div><div layout="column" flex><div \nng-repeat="f in vm.formWizard.company.extra_data.social_responsability_files track by $index" class="border-bottom" \nflex><div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><div class="media photos" layout="row" layout-align="center center"><h2c-icon \nfile="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" alt=""></div><div class="info ml-15" flex \nlayout="column" layout-align="center center"><div class="name" layout="row" layout-align="center center"><span \nng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu class="float-right"><md-button \nclass="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.social_responsability_files.splice($index, 1);"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></div></div></div><div class="separator-options" \nlayout="row"><h2>IVA</h2></div><div class="mv-25" layout="column"><div layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container fill-width flex><md-select \nng-model="vm.formWizard.company.extra_data.tax_options"><md-option ng-value="1">Presentaci\xF3n trimestral</md-option>\n<md-option ng-value="2">Presentaci\xF3n mensual</md-option></md-select></md-input-container><md-input-container \nfill-width flex></md-input-container></div><div layout="column" layout-gt-xs="row" layout-align="start center"><div \nfill-width><div ngf-drop ngf-select ng-model="vm.files_iva" class="drop-box" layout="column" layout-gt-xs="row" \nngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="iva_isLoading"><div flex layout="column" layout-align="center center" layout-padding layout-margin \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n</div></div><div layout="column" flex><div ng-repeat="f in vm.formWizard.company.extra_data.iva_files track by $index" \nclass="border-bottom" flex><div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size" layout="row" layout-align="start left"><div class="media photos" layout="row" \nlayout-align="center center"><h2c-icon file="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" \nalt=""></div><div class="info ml-15" flex layout="column" layout-align="center center"><div class="name" layout="row" \nlayout-align="center center"><span ng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.iva_files.splice($index, 1);"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div></div></div></div></div><div class="separator-options" layout="row"><h2>\nImpuesto de sociedades</h2></div><div class="mv-25" layout="column"><div layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container fill-width flex><md-datepicker \nng-model="vm.formWizard.company.extra_data.date_is" md-placeholder="Fecha"></md-datepicker></md-input-container>\n<md-input-contaimer class="md-block" flex><md-select ng-model="vm.formWizard.company.extra_data.currency_is" \nplaceholder="{{ \'GLOBAL.CURRENCY\' |\xA0translate}}"><md-option ng-repeat="currency in vm.currencies" \nng-value="currency.id">{{currency.symbol}}</md-option></md-select></md-input-contaimer><md-input-container fill-width \nflex><label translate="GLOBAL.AMOUNT_CAPITAL"></label> <input type="number" type="text" \nng-model="vm.formWizard.company.extra_data.amount_is"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-align="start center"><div fill-width><div ngf-drop ngf-select ng-model="vm.files_is" \nclass="drop-box" layout="column" layout-gt-xs="row" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" \nngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="is_isLoading"><div flex layout="column" layout-align="center center" layout-padding layout-margin \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n</div></div><div layout="column" flex><div ng-repeat="f in vm.formWizard.company.extra_data.is_files track by $index" \nclass="border-bottom" flex><div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size" layout="row" layout-align="start left"><div class="media photos" layout="row" \nlayout-align="center center"><h2c-icon file="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" \nalt=""></div><div class="info ml-15" flex layout="column" layout-align="center center"><div class="name" layout="row" \nlayout-align="center center"><span ng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.is_files.splice($index, 1);"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/proyects/views/read/form-tabs/step-people-global.html','<div layout="column" layout-gt-xs="row"><div class="mail-list-pane s0" flex="100"><div layout-gt-xs="row" \nlayout="column" class="mb-20"><div flex="20"><div layout="row" layout-align="start center" flex="100" \nclass="p-20 layout-align-start-center layout-row flex-100"><div layout="row" layout-align="start center" flex="100" \nclass="layout-align-start-center layout-row flex-100"><div class="avatar-wrapper"><md-icon md-font-icon="icon-city">\n</md-icon></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding" \nng-bind-html="vm.formWizard.main_branch.name"></strong><div class="field grey-600-fg ng-binding"><span \nng-if="vm.formWizard.main_branch.city" ng-bind-html="vm.formWizard.main_branch.city"></span> <span \nng-if="vm.formWizard.main_branch.city && vm.formWizard.main_branch.state">, </span><span \nng-if="vm.formWizard.main_branch.state" ng-bind-html="vm.formWizard.main_branch.state"></span></div></div></div></div>\n</div><div flex="80"><div layout="row" layout-align="start center"><div class="mail-list-pane s0" flex="100"><div \nclass="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="user.branch_id == vm.formWizard.main_branch.id"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId != user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong><div class="field grey-600-fg ng-binding"><span>\n{{vm.getDivisionName(user.division)[0].name}} | {{vm.getPositionName(user.position)[0].name}}</span></div></div></div>\n</div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu class="float-right">\n<md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" \nng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\', vm.formWizard.main_branch)"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div><div class="items"><div layout="row" \nlayout-align="start center" flex="100" class="pt-10 pb-10"><div class="info" flex layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><md-button \nng-click="vm.openDialogForm(\'personnel\', vm.formWizard.main_branch.id)" \nclass="md-mini add-event-button md-fab md-warn mh-0"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n</div></div></div></div></div></div></div></div></div><div layout-gt-xs="row" layout="column" class="mb-20" \nng-repeat="branch in vm.formWizard.branch" ng-if="branch.id != vm.formWizard.main_branch.id"><div flex="20"><div \nlayout="row" layout-align="start center" flex="100" class="p-20 layout-align-start-center layout-row flex-100"><div \nlayout="row" layout-align="start center" flex="100" class="layout-align-start-center layout-row flex-100"><div \nclass="avatar-wrapper"><md-icon md-font-icon="icon-city"></md-icon></div><div class="field mr-10 ml-10 flex" flex="">\n<strong class="grey-800-fg ng-binding" ng-bind-html="branch.name"></strong><div class="field grey-600-fg ng-binding">\n<span ng-if="branch.city" ng-bind-html="branch.city"></span> <span ng-if="branch.city && branch.state">, </span><span \nng-if="branch.state" ng-bind-html="branch.state"></span></div></div></div></div></div><div flex="80"><div layout="row" \nlayout-align="start center"><div class="mail-list-pane s0" flex="100"><div class="items" \nng-repeat="user in vm.formWizard.personnel track by $index" ng-if="user.branch_id == branch.id"><div layout="row" \nlayout-align="start center" flex="100" class="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" \nlayout="column"><div class="name" layout="row"><div layout="row" layout-align="start center" flex="100"><div \nclass="avatar-wrapper"><user-avatar ng-if="uploadingFotoUserId != user.id" user="user"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong><div class="field grey-600-fg ng-binding"><span>\n{{vm.getDivisionName(user.division)[0].name}} | {{vm.getPositionName(user.position)[0].name}}</span></div></div></div>\n</div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu class="float-right">\n<md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\', branch)">\n<md-icon md-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div><div class="items"><div layout="row" \nlayout-align="start center" flex="100" class="pt-10 pb-10"><div class="info" flex layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><md-button \nng-click="vm.openDialogForm(\'personnel\', branch.id)" class="md-mini add-event-button md-fab md-warn mh-0"><md-icon \nmd-font-icon="icon-plus"></md-icon></md-button></div></div></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/proyects/views/read/form-tabs/step-people.html','<div layout="column" layout-gt-xs="row"><div style="padding: 0px 15px;" flex layout="column"><h1>Direcci\xF3n</h1><div \nlayout="column" layout-gt-xs="row"><md-input-container class="group-form" flex="100" flex-gt-xs="100"><div \nlayout="row" layout-align="start center"><h2 translate="GLOBAL.LEGAL_MANAGER"></h2><md-button \nng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'managerLegal\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n<div class="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'managerLegal\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId !== user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container class="group-form" flex="100" flex-gt-xs="100"><div layout="row" \nlayout-align="start center"><h2 translate="GLOBAL.ADMINISTRATOR"></h2><md-button \nng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'administrator\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n<div class="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'administrator\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId !== user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container></div></div><div \nstyle="padding: 0px 15px;" flex layout="column"><h1>Compliance</h1><md-input-container class="group-form" flex="100" \nflex-gt-xs="100"><h2 translate="GLOBAL.COMPLIANCE_OFFICER" style="display: inline-block;"></h2><md-button \nng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'compliance_officer\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'compliance_officer\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId !== user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container><md-input-container \nclass="group-form" flex="100" flex-gt-xs="100"><h2 translate="GLOBAL.COLLABORATOR" style="display: inline-block;"></h2>\n<md-button ng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'collaborator\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'collaborator\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId != user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container><md-input-container \nclass="group-form" flex="100" flex-gt-xs="100"><h2 translate="GLOBAL.REPORT_COMMITTEE" style="display: inline-block;">\n</h2><md-button ng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'compliance_comite\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'compliance_comite\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId !== user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container><md-input-container \nclass="group-form" flex="100" flex-gt-xs="100"><h2 translate="GLOBAL.DELEGATE_DATA_PROTECCTION" \nstyle="display: inline-block;"></h2><md-button ng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'data_protection\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'data_protection\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId != user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container></div></div>');
$templateCache.put('app/main/apps/outcomes/views/read/form-tabs/step-branchs.html','<div layout="column" layout-gt-xs="row"><md-input-container flex><h1 translate="GLOBAL.MAIN_BRANCH"></h1>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="GLOBAL.NAME"></label> <input ng-model="vm.formWizard.main_branch.name" type="text"></md-input-container>\n<md-input-container flex><label translate="GLOBAL.ADDRESS"></label> <input \nng-model="vm.formWizard.main_branch.address1" type="text" required></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container flex><label>{{vm.getRegionLiteral(\'city\')}}</label> <input \nng-model="vm.formWizard.main_branch.city" type="text" required></md-input-container><md-input-container flex><label>\n{{vm.getRegionLiteral(\'state\')}}</label> <input ng-model="vm.formWizard.main_branch.state" type="text" required>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="GLOBAL.POSTAL_CODE"></label> <input ng-model="vm.formWizard.main_branch.postcode" type="text" required>\n</md-input-container><md-input-container flex><label translate="GLOBAL.PHONE"></label> <input \nng-model="vm.formWizard.main_branch.phone" type="text"></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container flex><label translate="GLOBAL.EMAIL"></label> <input \nng-model="vm.formWizard.main_branch.email" type="text"></md-input-container><md-input-container flex>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container class="group-form" flex="100" \nflex-gt-xs="100"><div layout="row" layout-align="start center"><h1 translate="GLOBAL.BRANCH"></h1><md-button \nng-click="vm.openDialogForm(\'branch\')" class="ml-10 md-mini add-event-button md-fab md-warn"><md-icon \nmd-font-icon="icon-plus"></md-icon></md-button></div><div class="mail-list-pane s0" \nng-if="vm.formWizard.branch && vm.formWizard.branch.length > 0"><div class="items" ng-if="!branch.is_main" \nng-repeat="branch in vm.formWizard.branch"><div layout="row" layout-align="start center" flex="100" class="p-20"><div \nlayout="row" layout-align="start center" flex="90"><div class="avatar-wrapper"><md-icon md-font-icon="icon-city">\n</md-icon></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding" \nng-bind-html="branch.name"></strong><div class="field grey-600-fg ng-binding"><span ng-if="branch.city" \nng-bind-html="branch.city"></span> <span ng-if="branch.city && branch.state">, </span><span ng-if="branch.state" \nng-bind-html="branch.state"></span></div></div></div><div class="menu" flex="10" layout-align="center end" \nlayout="column"><md-menu class="float-right"><md-button class="md-icon-button" aria-label="More" \nng-click="vm.openMenu($mdMenu, $event)"><md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg">\n</md-icon></md-button><md-menu-content width="2"><md-menu-item><md-button translate="GLOBAL.EDIT" \nng-click="vm.editBranchDialog($event, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div></md-input-container></div>');
$templateCache.put('app/main/apps/outcomes/views/read/form-tabs/step-company.html','<div layout="column" layout-gt-xs="row"><md-input-container flex><label translate="GLOBAL.SOCIAL_REASON"></label> \n<input type="text" ng-model="vm.formWizard.company.name" required></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container flex><label>{{vm.getRegionLiteral(\'tax_ic_number\')}}</label> <input type="text" \nng-model="vm.formWizard.company.tax_id_number"></md-input-container><md-input-container flex><label \ntranslate="GLOBAL.SECTOR"></label><md-select ng-model="vm.formWizard.company.sector_id"><md-option \nng-repeat="sector in vm.sectors track by $index" ng-value="sector.id">{{sector.name}}</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="GLOBAL.REGION"></label><md-select ng-model="vm.formWizard.company.region_id"><md-option \nng-repeat="region in vm.regions track by $index" ng-value="region.id">{{region.name}}</md-option></md-select>\n</md-input-container><md-input-container flex></md-input-container></div><div layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container><p class="mt-0 grey-400-fg" translate="GLOBAL.LOGOTYPE"></p><div \nclass="header simple relative" ng-if="image || imageUrl" layout="row" layout-align="space-between center"><md-menu>\n<button class="md-icon-button" aria-label="More"><div layout="column" layout-align="start center" \nng-click="$mdMenu.open($event)"><div class="media" flex layout="row" layout-align="center center"><img \nngf-thumbnail="!image.$error && image" class="image"> <img ng-if="!image && imageUrl" src="{{imageUrl}}" class="image">\n</div><md-button class="md-mini add-event-button no-sort md-fab md-warn block absolute-top-right" \naria-label="Add event"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button></div></button><md-menu-content\n width="3"><md-menu-item><md-button ng-click="vm.deleteLogotype()" aria-label="Toggle done" \ntranslate-attr-aria-label="GLOBAL.REMOVE"><md-icon md-font-icon="icon-close" class="s18"></md-icon><span \ntranslate="GLOBAL.REMOVE"></span></md-button></md-menu-item></md-menu-content></md-menu></div><div \nng-if="!image && !imageUrl" ng-click="vm.mediaDialogSingle($event, vm.formWizard.company.logotype)" class="relative">\n<img src="assets/images/logos/generic-logo.png" class="image"><md-button \nclass="md-mini add-event-button no-sort md-fab md-warn block absolute-top-right" aria-label="Add event" translate \ntranslate-attr-aria-label="CALENDAR.ADD_EVENT"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n</md-input-container></div>');
$templateCache.put('app/main/apps/outcomes/views/read/form-tabs/step-options.html','<div class="options"><div layout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container \nfill-width flex><label translate="GLOBAL.DESCRIPTION"></label> <input type="text" \nng-model="vm.formWizard.company.description"></md-input-container><md-input-container fill-width flex><label \ntranslate="GLOBAL.COMPANY_TYPE"></label><md-select ng-model="vm.formWizard.company.extra_data.company_type"><md-option \nng-value="1">SA</md-option><md-option ng-value="2">SL</md-option><md-option ng-value="3">Cotizada</md-option><md-option\n ng-value="4">Fundaciones/asociaciones</md-option><md-option ng-value="5">Otras</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container\n fill-width flex><label translate="GLOBAL.EXECUTIVE_TYPE"></label><md-select \nng-model="vm.formWizard.company.extra_data.executives_type"><md-option ng-value="1">Accionista \xFAnico</md-option>\n<md-option ng-value="2">Varios accionistas</md-option><md-option ng-value="3">Consejo de administraci\xF3n</md-option>\n<md-option ng-value="4">Administrador \xFAnico</md-option><md-option ng-value="5">Otros</md-option></md-select>\n</md-input-container><md-input-container fill-width flex><label translate="GLOBAL.SOCIAL_CAPITAL"></label><md-select \nng-model="vm.formWizard.company.extra_data.capital"><md-option ng-value="1">Capital</md-option><md-option ng-value="2">\nAportaciones de socios</md-option><md-option ng-value="3">Aumentos de capital recientes</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container\n fill-width flex><label translate="GLOBAL.AMOUNT_CAPITAL"></label> <input type="number" type="text" \nng-model="vm.formWizard.company.extra_data.capital_amount"></md-input-container><md-input-container fill-width flex>\n<label translate="GLOBAL.BILLING_LAST_YEAR"></label> <input type="number" \nng-model="vm.formWizard.company.turnover_volume"></md-input-container></div><div layout="column" layout-gt-xs="row" \nflex layout-align="start center"><md-input-container fill-width flex><label>Cuentas anuales</label><md-select \nng-model="vm.formWizard.company.extra_data.annual_accounts"><md-option ng-value="1">Abreviadas</md-option><md-option \nng-value="2">Normales</md-option><md-option ng-value="3">Pymes</md-option><md-option ng-value="4">Mixtas</md-option>\n</md-select></md-input-container><md-input-container fill-width flex><label>Auditor\xEDas</label><md-select \nng-model="vm.formWizard.company.extra_data.audits"><md-option ng-value="1">Internas</md-option><md-option ng-value="2">\nExternas</md-option><md-option ng-value="3">No aplica</md-option></md-select></md-input-container></div><div \nlayout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container fill-width flex><label>\nCertificaciones ISO</label><md-select ng-model="vm.formWizard.company.extra_data.iso_certification"><md-option \nng-value="1">ISO 9001</md-option><md-option ng-value="2">ISO 14000</md-option><md-option ng-value="3">ISO 14001\n</md-option><md-option ng-value="4">ISO 19600</md-option><md-option ng-value="5">ISO 22000</md-option><md-option \nng-value="6">ISO 26000</md-option><md-option ng-value="7">ISO 27001</md-option><md-option ng-value="8">ISO 37001\n</md-option><md-option ng-value="9">OHSAS 18001</md-option></md-select></md-input-container><md-input-container \nfill-width flex><label>Convenio Colectivo Aplicable</label> <input type="text" \nng-model="vm.formWizard.company.extra_data.collective_agreement"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" flex layout-align="start center"><md-input-container fill-width flex><label>Seguros contratados\n</label> <input type="text" ng-model="vm.formWizard.company.extra_data.insurance"></md-input-container>\n<md-input-container fill-width flex><label translate="GLOBAL.CNAE"></label> <input type="text" \nng-model="vm.formWizard.company.extra_data.cnae"></md-input-container></div><div layout="column" layout-gt-xs="row" \nflex layout-align="start center"><md-input-container fill-width layout="row" layout-align="start center" flex><label \nclass="ph-15" fill-width translate="GLOBAL.FINANCING"></label><md-select flex \nng-init="!vm.formWizard.company.extra_data.financing ? vm.formWizard.company.extra_data.financing = [] : null;" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.financing"><md-option \nng-repeat="option in vm.financing_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container><md-input-container fill-width layout="row" layout-align="start center" flex><label class="ph-15" \nfill-width>Normativa Sectorial aplicable</label><md-select flex \nng-init="!vm.formWizard.company.extra_data.sector_regulations ? vm.formWizard.company.extra_data.sector_regulations = [] : null;" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.sector_regulations"><md-option \nng-repeat="option in vm.sector_regulations_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-align="start center"><md-input-container \nfill-width layout="row" layout-align="start center" flex><label class="ph-15" fill-width>Medidas implementadas</label>\n<md-select flex \nng-init="!vm.formWizard.company.extra_data.implemented_measures ? vm.formWizard.company.extra_data.implemented_measures = [] : null;" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.implemented_measures"><md-option \nng-repeat="option in vm.implemented_measures_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container></div><div class="separator-options" layout="row"><h2>Grupo de sociedades?</h2><md-input-container\n fill-width layout="row" layout-align="start center" flex class="mb-0"><md-checkbox \nng-checked="vm.formWizard.company.extra_data.belogns_to_holding" \nng-model="vm.formWizard.company.extra_data.belogns_to_holding"></md-checkbox></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-align="start center"></div><div \nng-if="vm.formWizard.company.extra_data.belogns_to_holding" layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container fill-width flex><label>Nombre corporaci\xF3n</label> <input type="text" \nng-model="vm.formWizard.company.extra_data.name_corporation"></md-input-container><md-input-container fill-width flex>\n<label>CIF corporaci\xF3n</label> <input type="text" ng-model="vm.formWizard.company.extra_data.cif_corporation">\n</md-input-container></div><div class="mv-25" ng-if="vm.formWizard.company.extra_data.belogns_to_holding" \nlayout="column" layout-gt-xs="row" layout-align="start center"><div fill-width><div ngf-drop ngf-select \nng-model="vm.files_belogns_to_holding" class="drop-box" layout="column" layout-gt-xs="row" \nngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="belogns_to_holding_isLoading"><div flex layout="column" layout-align="center center" layout-padding \nlayout-margin class="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30">\n</md-progress-circular></div></div></div><div layout="column" flex><div \nng-repeat="f in vm.formWizard.company.extra_data.belogns_to_holding_files track by $index" class="border-bottom" flex>\n<div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><div class="media photos" layout="row" layout-align="center center"><h2c-icon \nfile="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" alt=""></div><div class="info ml-15" flex \nlayout="column" layout-align="center center"><div class="name" layout="row" layout-align="center center"><span \nng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu class="float-right"><md-button \nclass="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.belogns_to_holding_files.splice($index, 1);"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></div></div></div><div class="separator-options" \nlayout="row"><h2>Responsabilidad social corporativa?</h2><md-input-container fill-width layout="row" \nlayout-align="start center" flex class="mb-0"><md-checkbox \nng-checked="vm.formWizard.company.extra_data.social_responsability" \nng-model="vm.formWizard.company.extra_data.social_responsability"></md-checkbox></md-input-container></div><div \nclass="mv-25" ng-if="vm.formWizard.company.extra_data.social_responsability" layout="column" layout-gt-xs="row" \nlayout-align="start center"><div fill-width><div ngf-drop ngf-select ng-model="vm.files_social_responsability" \nclass="drop-box" layout="column" layout-gt-xs="row" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" \nngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="social_responsability_isLoading"><div flex layout="column" layout-align="center center" layout-padding \nlayout-margin class="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30">\n</md-progress-circular></div></div></div><div layout="column" flex><div \nng-repeat="f in vm.formWizard.company.extra_data.social_responsability_files track by $index" class="border-bottom" \nflex><div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><div class="media photos" layout="row" layout-align="center center"><h2c-icon \nfile="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" alt=""></div><div class="info ml-15" flex \nlayout="column" layout-align="center center"><div class="name" layout="row" layout-align="center center"><span \nng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu class="float-right"><md-button \nclass="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.social_responsability_files.splice($index, 1);"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></div></div></div><div class="separator-options" \nlayout="row"><h2>IVA</h2></div><div class="mv-25" layout="column"><div layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container fill-width flex><md-select \nng-model="vm.formWizard.company.extra_data.tax_options"><md-option ng-value="1">Presentaci\xF3n trimestral</md-option>\n<md-option ng-value="2">Presentaci\xF3n mensual</md-option></md-select></md-input-container><md-input-container \nfill-width flex></md-input-container></div><div layout="column" layout-gt-xs="row" layout-align="start center"><div \nfill-width><div ngf-drop ngf-select ng-model="vm.files_iva" class="drop-box" layout="column" layout-gt-xs="row" \nngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="iva_isLoading"><div flex layout="column" layout-align="center center" layout-padding layout-margin \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n</div></div><div layout="column" flex><div ng-repeat="f in vm.formWizard.company.extra_data.iva_files track by $index" \nclass="border-bottom" flex><div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size" layout="row" layout-align="start left"><div class="media photos" layout="row" \nlayout-align="center center"><h2c-icon file="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" \nalt=""></div><div class="info ml-15" flex layout="column" layout-align="center center"><div class="name" layout="row" \nlayout-align="center center"><span ng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.iva_files.splice($index, 1);"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div></div></div></div></div><div class="separator-options" layout="row"><h2>\nImpuesto de sociedades</h2></div><div class="mv-25" layout="column"><div layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container fill-width flex><md-datepicker \nng-model="vm.formWizard.company.extra_data.date_is" md-placeholder="Fecha"></md-datepicker></md-input-container>\n<md-input-contaimer class="md-block" flex><md-select ng-model="vm.formWizard.company.extra_data.currency_is" \nplaceholder="{{ \'GLOBAL.CURRENCY\' |\xA0translate}}"><md-option ng-repeat="currency in vm.currencies" \nng-value="currency.id">{{currency.symbol}}</md-option></md-select></md-input-contaimer><md-input-container fill-width \nflex><label translate="GLOBAL.AMOUNT_CAPITAL"></label> <input type="number" type="text" \nng-model="vm.formWizard.company.extra_data.amount_is"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-align="start center"><div fill-width><div ngf-drop ngf-select ng-model="vm.files_is" \nclass="drop-box" layout="column" layout-gt-xs="row" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" \nngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="is_isLoading"><div flex layout="column" layout-align="center center" layout-padding layout-margin \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n</div></div><div layout="column" flex><div ng-repeat="f in vm.formWizard.company.extra_data.is_files track by $index" \nclass="border-bottom" flex><div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size" layout="row" layout-align="start left"><div class="media photos" layout="row" \nlayout-align="center center"><h2c-icon file="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" \nalt=""></div><div class="info ml-15" flex layout="column" layout-align="center center"><div class="name" layout="row" \nlayout-align="center center"><span ng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.is_files.splice($index, 1);"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/outcomes/views/read/form-tabs/step-people-global.html','<div layout="column" layout-gt-xs="row"><div class="mail-list-pane s0" flex="100"><div layout-gt-xs="row" \nlayout="column" class="mb-20"><div flex="20"><div layout="row" layout-align="start center" flex="100" \nclass="p-20 layout-align-start-center layout-row flex-100"><div layout="row" layout-align="start center" flex="100" \nclass="layout-align-start-center layout-row flex-100"><div class="avatar-wrapper"><md-icon md-font-icon="icon-city">\n</md-icon></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding" \nng-bind-html="vm.formWizard.main_branch.name"></strong><div class="field grey-600-fg ng-binding"><span \nng-if="vm.formWizard.main_branch.city" ng-bind-html="vm.formWizard.main_branch.city"></span> <span \nng-if="vm.formWizard.main_branch.city && vm.formWizard.main_branch.state">, </span><span \nng-if="vm.formWizard.main_branch.state" ng-bind-html="vm.formWizard.main_branch.state"></span></div></div></div></div>\n</div><div flex="80"><div layout="row" layout-align="start center"><div class="mail-list-pane s0" flex="100"><div \nclass="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="user.branch_id == vm.formWizard.main_branch.id"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId != user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong><div class="field grey-600-fg ng-binding"><span>\n{{vm.getDivisionName(user.division)[0].name}} | {{vm.getPositionName(user.position)[0].name}}</span></div></div></div>\n</div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu class="float-right">\n<md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" \nng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\', vm.formWizard.main_branch)"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div><div class="items"><div layout="row" \nlayout-align="start center" flex="100" class="pt-10 pb-10"><div class="info" flex layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><md-button \nng-click="vm.openDialogForm(\'personnel\', vm.formWizard.main_branch.id)" \nclass="md-mini add-event-button md-fab md-warn mh-0"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n</div></div></div></div></div></div></div></div></div><div layout-gt-xs="row" layout="column" class="mb-20" \nng-repeat="branch in vm.formWizard.branch" ng-if="branch.id != vm.formWizard.main_branch.id"><div flex="20"><div \nlayout="row" layout-align="start center" flex="100" class="p-20 layout-align-start-center layout-row flex-100"><div \nlayout="row" layout-align="start center" flex="100" class="layout-align-start-center layout-row flex-100"><div \nclass="avatar-wrapper"><md-icon md-font-icon="icon-city"></md-icon></div><div class="field mr-10 ml-10 flex" flex="">\n<strong class="grey-800-fg ng-binding" ng-bind-html="branch.name"></strong><div class="field grey-600-fg ng-binding">\n<span ng-if="branch.city" ng-bind-html="branch.city"></span> <span ng-if="branch.city && branch.state">, </span><span \nng-if="branch.state" ng-bind-html="branch.state"></span></div></div></div></div></div><div flex="80"><div layout="row" \nlayout-align="start center"><div class="mail-list-pane s0" flex="100"><div class="items" \nng-repeat="user in vm.formWizard.personnel track by $index" ng-if="user.branch_id == branch.id"><div layout="row" \nlayout-align="start center" flex="100" class="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" \nlayout="column"><div class="name" layout="row"><div layout="row" layout-align="start center" flex="100"><div \nclass="avatar-wrapper"><user-avatar ng-if="uploadingFotoUserId != user.id" user="user"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong><div class="field grey-600-fg ng-binding"><span>\n{{vm.getDivisionName(user.division)[0].name}} | {{vm.getPositionName(user.position)[0].name}}</span></div></div></div>\n</div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu class="float-right">\n<md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\', branch)">\n<md-icon md-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div><div class="items"><div layout="row" \nlayout-align="start center" flex="100" class="pt-10 pb-10"><div class="info" flex layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><md-button \nng-click="vm.openDialogForm(\'personnel\', branch.id)" class="md-mini add-event-button md-fab md-warn mh-0"><md-icon \nmd-font-icon="icon-plus"></md-icon></md-button></div></div></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/outcomes/views/read/form-tabs/step-people.html','<div layout="column" layout-gt-xs="row"><div style="padding: 0px 15px;" flex layout="column"><h1>Direcci\xF3n</h1><div \nlayout="column" layout-gt-xs="row"><md-input-container class="group-form" flex="100" flex-gt-xs="100"><div \nlayout="row" layout-align="start center"><h2 translate="GLOBAL.LEGAL_MANAGER"></h2><md-button \nng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'managerLegal\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n<div class="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'managerLegal\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId !== user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container class="group-form" flex="100" flex-gt-xs="100"><div layout="row" \nlayout-align="start center"><h2 translate="GLOBAL.ADMINISTRATOR"></h2><md-button \nng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'administrator\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n<div class="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'administrator\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId !== user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container></div></div><div \nstyle="padding: 0px 15px;" flex layout="column"><h1>Compliance</h1><md-input-container class="group-form" flex="100" \nflex-gt-xs="100"><h2 translate="GLOBAL.COMPLIANCE_OFFICER" style="display: inline-block;"></h2><md-button \nng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'compliance_officer\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'compliance_officer\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId !== user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container><md-input-container \nclass="group-form" flex="100" flex-gt-xs="100"><h2 translate="GLOBAL.COLLABORATOR" style="display: inline-block;"></h2>\n<md-button ng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'collaborator\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'collaborator\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId != user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container><md-input-container \nclass="group-form" flex="100" flex-gt-xs="100"><h2 translate="GLOBAL.REPORT_COMMITTEE" style="display: inline-block;">\n</h2><md-button ng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'compliance_comite\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'compliance_comite\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId !== user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container><md-input-container \nclass="group-form" flex="100" flex-gt-xs="100"><h2 translate="GLOBAL.DELEGATE_DATA_PROTECCTION" \nstyle="display: inline-block;"></h2><md-button ng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'data_protection\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'data_protection\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId != user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container></div></div>');
$templateCache.put('app/main/apps/outputs/views/read/form-tabs/step-branchs.html','<div layout="column" layout-gt-xs="row"><md-input-container flex><h1 translate="GLOBAL.MAIN_BRANCH"></h1>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="GLOBAL.NAME"></label> <input ng-model="vm.formWizard.main_branch.name" type="text"></md-input-container>\n<md-input-container flex><label translate="GLOBAL.ADDRESS"></label> <input \nng-model="vm.formWizard.main_branch.address1" type="text" required></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container flex><label>{{vm.getRegionLiteral(\'city\')}}</label> <input \nng-model="vm.formWizard.main_branch.city" type="text" required></md-input-container><md-input-container flex><label>\n{{vm.getRegionLiteral(\'state\')}}</label> <input ng-model="vm.formWizard.main_branch.state" type="text" required>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="GLOBAL.POSTAL_CODE"></label> <input ng-model="vm.formWizard.main_branch.postcode" type="text" required>\n</md-input-container><md-input-container flex><label translate="GLOBAL.PHONE"></label> <input \nng-model="vm.formWizard.main_branch.phone" type="text"></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container flex><label translate="GLOBAL.EMAIL"></label> <input \nng-model="vm.formWizard.main_branch.email" type="text"></md-input-container><md-input-container flex>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container class="group-form" flex="100" \nflex-gt-xs="100"><div layout="row" layout-align="start center"><h1 translate="GLOBAL.BRANCH"></h1><md-button \nng-click="vm.openDialogForm(\'branch\')" class="ml-10 md-mini add-event-button md-fab md-warn"><md-icon \nmd-font-icon="icon-plus"></md-icon></md-button></div><div class="mail-list-pane s0" \nng-if="vm.formWizard.branch && vm.formWizard.branch.length > 0"><div class="items" ng-if="!branch.is_main" \nng-repeat="branch in vm.formWizard.branch"><div layout="row" layout-align="start center" flex="100" class="p-20"><div \nlayout="row" layout-align="start center" flex="90"><div class="avatar-wrapper"><md-icon md-font-icon="icon-city">\n</md-icon></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding" \nng-bind-html="branch.name"></strong><div class="field grey-600-fg ng-binding"><span ng-if="branch.city" \nng-bind-html="branch.city"></span> <span ng-if="branch.city && branch.state">, </span><span ng-if="branch.state" \nng-bind-html="branch.state"></span></div></div></div><div class="menu" flex="10" layout-align="center end" \nlayout="column"><md-menu class="float-right"><md-button class="md-icon-button" aria-label="More" \nng-click="vm.openMenu($mdMenu, $event)"><md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg">\n</md-icon></md-button><md-menu-content width="2"><md-menu-item><md-button translate="GLOBAL.EDIT" \nng-click="vm.editBranchDialog($event, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div></md-input-container></div>');
$templateCache.put('app/main/apps/outputs/views/read/form-tabs/step-company.html','<div layout="column" layout-gt-xs="row"><md-input-container flex><label translate="GLOBAL.SOCIAL_REASON"></label> \n<input type="text" ng-model="vm.formWizard.company.name" required></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container flex><label>{{vm.getRegionLiteral(\'tax_ic_number\')}}</label> <input type="text" \nng-model="vm.formWizard.company.tax_id_number"></md-input-container><md-input-container flex><label \ntranslate="GLOBAL.SECTOR"></label><md-select ng-model="vm.formWizard.company.sector_id"><md-option \nng-repeat="sector in vm.sectors track by $index" ng-value="sector.id">{{sector.name}}</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="GLOBAL.REGION"></label><md-select ng-model="vm.formWizard.company.region_id"><md-option \nng-repeat="region in vm.regions track by $index" ng-value="region.id">{{region.name}}</md-option></md-select>\n</md-input-container><md-input-container flex></md-input-container></div><div layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container><p class="mt-0 grey-400-fg" translate="GLOBAL.LOGOTYPE"></p><div \nclass="header simple relative" ng-if="image || imageUrl" layout="row" layout-align="space-between center"><md-menu>\n<button class="md-icon-button" aria-label="More"><div layout="column" layout-align="start center" \nng-click="$mdMenu.open($event)"><div class="media" flex layout="row" layout-align="center center"><img \nngf-thumbnail="!image.$error && image" class="image"> <img ng-if="!image && imageUrl" src="{{imageUrl}}" class="image">\n</div><md-button class="md-mini add-event-button no-sort md-fab md-warn block absolute-top-right" \naria-label="Add event"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button></div></button><md-menu-content\n width="3"><md-menu-item><md-button ng-click="vm.deleteLogotype()" aria-label="Toggle done" \ntranslate-attr-aria-label="GLOBAL.REMOVE"><md-icon md-font-icon="icon-close" class="s18"></md-icon><span \ntranslate="GLOBAL.REMOVE"></span></md-button></md-menu-item></md-menu-content></md-menu></div><div \nng-if="!image && !imageUrl" ng-click="vm.mediaDialogSingle($event, vm.formWizard.company.logotype)" class="relative">\n<img src="assets/images/logos/generic-logo.png" class="image"><md-button \nclass="md-mini add-event-button no-sort md-fab md-warn block absolute-top-right" aria-label="Add event" translate \ntranslate-attr-aria-label="CALENDAR.ADD_EVENT"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n</md-input-container></div>');
$templateCache.put('app/main/apps/outputs/views/read/form-tabs/step-options.html','<div class="options"><div layout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container \nfill-width flex><label translate="GLOBAL.DESCRIPTION"></label> <input type="text" \nng-model="vm.formWizard.company.description"></md-input-container><md-input-container fill-width flex><label \ntranslate="GLOBAL.COMPANY_TYPE"></label><md-select ng-model="vm.formWizard.company.extra_data.company_type"><md-option \nng-value="1">SA</md-option><md-option ng-value="2">SL</md-option><md-option ng-value="3">Cotizada</md-option><md-option\n ng-value="4">Fundaciones/asociaciones</md-option><md-option ng-value="5">Otras</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container\n fill-width flex><label translate="GLOBAL.EXECUTIVE_TYPE"></label><md-select \nng-model="vm.formWizard.company.extra_data.executives_type"><md-option ng-value="1">Accionista \xFAnico</md-option>\n<md-option ng-value="2">Varios accionistas</md-option><md-option ng-value="3">Consejo de administraci\xF3n</md-option>\n<md-option ng-value="4">Administrador \xFAnico</md-option><md-option ng-value="5">Otros</md-option></md-select>\n</md-input-container><md-input-container fill-width flex><label translate="GLOBAL.SOCIAL_CAPITAL"></label><md-select \nng-model="vm.formWizard.company.extra_data.capital"><md-option ng-value="1">Capital</md-option><md-option ng-value="2">\nAportaciones de socios</md-option><md-option ng-value="3">Aumentos de capital recientes</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container\n fill-width flex><label translate="GLOBAL.AMOUNT_CAPITAL"></label> <input type="number" type="text" \nng-model="vm.formWizard.company.extra_data.capital_amount"></md-input-container><md-input-container fill-width flex>\n<label translate="GLOBAL.BILLING_LAST_YEAR"></label> <input type="number" \nng-model="vm.formWizard.company.turnover_volume"></md-input-container></div><div layout="column" layout-gt-xs="row" \nflex layout-align="start center"><md-input-container fill-width flex><label>Cuentas anuales</label><md-select \nng-model="vm.formWizard.company.extra_data.annual_accounts"><md-option ng-value="1">Abreviadas</md-option><md-option \nng-value="2">Normales</md-option><md-option ng-value="3">Pymes</md-option><md-option ng-value="4">Mixtas</md-option>\n</md-select></md-input-container><md-input-container fill-width flex><label>Auditor\xEDas</label><md-select \nng-model="vm.formWizard.company.extra_data.audits"><md-option ng-value="1">Internas</md-option><md-option ng-value="2">\nExternas</md-option><md-option ng-value="3">No aplica</md-option></md-select></md-input-container></div><div \nlayout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container fill-width flex><label>\nCertificaciones ISO</label><md-select ng-model="vm.formWizard.company.extra_data.iso_certification"><md-option \nng-value="1">ISO 9001</md-option><md-option ng-value="2">ISO 14000</md-option><md-option ng-value="3">ISO 14001\n</md-option><md-option ng-value="4">ISO 19600</md-option><md-option ng-value="5">ISO 22000</md-option><md-option \nng-value="6">ISO 26000</md-option><md-option ng-value="7">ISO 27001</md-option><md-option ng-value="8">ISO 37001\n</md-option><md-option ng-value="9">OHSAS 18001</md-option></md-select></md-input-container><md-input-container \nfill-width flex><label>Convenio Colectivo Aplicable</label> <input type="text" \nng-model="vm.formWizard.company.extra_data.collective_agreement"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" flex layout-align="start center"><md-input-container fill-width flex><label>Seguros contratados\n</label> <input type="text" ng-model="vm.formWizard.company.extra_data.insurance"></md-input-container>\n<md-input-container fill-width flex><label translate="GLOBAL.CNAE"></label> <input type="text" \nng-model="vm.formWizard.company.extra_data.cnae"></md-input-container></div><div layout="column" layout-gt-xs="row" \nflex layout-align="start center"><md-input-container fill-width layout="row" layout-align="start center" flex><label \nclass="ph-15" fill-width translate="GLOBAL.FINANCING"></label><md-select flex \nng-init="!vm.formWizard.company.extra_data.financing ? vm.formWizard.company.extra_data.financing = [] : null;" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.financing"><md-option \nng-repeat="option in vm.financing_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container><md-input-container fill-width layout="row" layout-align="start center" flex><label class="ph-15" \nfill-width>Normativa Sectorial aplicable</label><md-select flex \nng-init="!vm.formWizard.company.extra_data.sector_regulations ? vm.formWizard.company.extra_data.sector_regulations = [] : null;" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.sector_regulations"><md-option \nng-repeat="option in vm.sector_regulations_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-align="start center"><md-input-container \nfill-width layout="row" layout-align="start center" flex><label class="ph-15" fill-width>Medidas implementadas</label>\n<md-select flex \nng-init="!vm.formWizard.company.extra_data.implemented_measures ? vm.formWizard.company.extra_data.implemented_measures = [] : null;" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.implemented_measures"><md-option \nng-repeat="option in vm.implemented_measures_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container></div><div class="separator-options" layout="row"><h2>Grupo de sociedades?</h2><md-input-container\n fill-width layout="row" layout-align="start center" flex class="mb-0"><md-checkbox \nng-checked="vm.formWizard.company.extra_data.belogns_to_holding" \nng-model="vm.formWizard.company.extra_data.belogns_to_holding"></md-checkbox></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-align="start center"></div><div \nng-if="vm.formWizard.company.extra_data.belogns_to_holding" layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container fill-width flex><label>Nombre corporaci\xF3n</label> <input type="text" \nng-model="vm.formWizard.company.extra_data.name_corporation"></md-input-container><md-input-container fill-width flex>\n<label>CIF corporaci\xF3n</label> <input type="text" ng-model="vm.formWizard.company.extra_data.cif_corporation">\n</md-input-container></div><div class="mv-25" ng-if="vm.formWizard.company.extra_data.belogns_to_holding" \nlayout="column" layout-gt-xs="row" layout-align="start center"><div fill-width><div ngf-drop ngf-select \nng-model="vm.files_belogns_to_holding" class="drop-box" layout="column" layout-gt-xs="row" \nngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="belogns_to_holding_isLoading"><div flex layout="column" layout-align="center center" layout-padding \nlayout-margin class="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30">\n</md-progress-circular></div></div></div><div layout="column" flex><div \nng-repeat="f in vm.formWizard.company.extra_data.belogns_to_holding_files track by $index" class="border-bottom" flex>\n<div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><div class="media photos" layout="row" layout-align="center center"><h2c-icon \nfile="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" alt=""></div><div class="info ml-15" flex \nlayout="column" layout-align="center center"><div class="name" layout="row" layout-align="center center"><span \nng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu class="float-right"><md-button \nclass="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.belogns_to_holding_files.splice($index, 1);"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></div></div></div><div class="separator-options" \nlayout="row"><h2>Responsabilidad social corporativa?</h2><md-input-container fill-width layout="row" \nlayout-align="start center" flex class="mb-0"><md-checkbox \nng-checked="vm.formWizard.company.extra_data.social_responsability" \nng-model="vm.formWizard.company.extra_data.social_responsability"></md-checkbox></md-input-container></div><div \nclass="mv-25" ng-if="vm.formWizard.company.extra_data.social_responsability" layout="column" layout-gt-xs="row" \nlayout-align="start center"><div fill-width><div ngf-drop ngf-select ng-model="vm.files_social_responsability" \nclass="drop-box" layout="column" layout-gt-xs="row" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" \nngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="social_responsability_isLoading"><div flex layout="column" layout-align="center center" layout-padding \nlayout-margin class="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30">\n</md-progress-circular></div></div></div><div layout="column" flex><div \nng-repeat="f in vm.formWizard.company.extra_data.social_responsability_files track by $index" class="border-bottom" \nflex><div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><div class="media photos" layout="row" layout-align="center center"><h2c-icon \nfile="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" alt=""></div><div class="info ml-15" flex \nlayout="column" layout-align="center center"><div class="name" layout="row" layout-align="center center"><span \nng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu class="float-right"><md-button \nclass="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.social_responsability_files.splice($index, 1);"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></div></div></div><div class="separator-options" \nlayout="row"><h2>IVA</h2></div><div class="mv-25" layout="column"><div layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container fill-width flex><md-select \nng-model="vm.formWizard.company.extra_data.tax_options"><md-option ng-value="1">Presentaci\xF3n trimestral</md-option>\n<md-option ng-value="2">Presentaci\xF3n mensual</md-option></md-select></md-input-container><md-input-container \nfill-width flex></md-input-container></div><div layout="column" layout-gt-xs="row" layout-align="start center"><div \nfill-width><div ngf-drop ngf-select ng-model="vm.files_iva" class="drop-box" layout="column" layout-gt-xs="row" \nngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="iva_isLoading"><div flex layout="column" layout-align="center center" layout-padding layout-margin \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n</div></div><div layout="column" flex><div ng-repeat="f in vm.formWizard.company.extra_data.iva_files track by $index" \nclass="border-bottom" flex><div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size" layout="row" layout-align="start left"><div class="media photos" layout="row" \nlayout-align="center center"><h2c-icon file="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" \nalt=""></div><div class="info ml-15" flex layout="column" layout-align="center center"><div class="name" layout="row" \nlayout-align="center center"><span ng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.iva_files.splice($index, 1);"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div></div></div></div></div><div class="separator-options" layout="row"><h2>\nImpuesto de sociedades</h2></div><div class="mv-25" layout="column"><div layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container fill-width flex><md-datepicker \nng-model="vm.formWizard.company.extra_data.date_is" md-placeholder="Fecha"></md-datepicker></md-input-container>\n<md-input-contaimer class="md-block" flex><md-select ng-model="vm.formWizard.company.extra_data.currency_is" \nplaceholder="{{ \'GLOBAL.CURRENCY\' |\xA0translate}}"><md-option ng-repeat="currency in vm.currencies" \nng-value="currency.id">{{currency.symbol}}</md-option></md-select></md-input-contaimer><md-input-container fill-width \nflex><label translate="GLOBAL.AMOUNT_CAPITAL"></label> <input type="number" type="text" \nng-model="vm.formWizard.company.extra_data.amount_is"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-align="start center"><div fill-width><div ngf-drop ngf-select ng-model="vm.files_is" \nclass="drop-box" layout="column" layout-gt-xs="row" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" \nngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="is_isLoading"><div flex layout="column" layout-align="center center" layout-padding layout-margin \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n</div></div><div layout="column" flex><div ng-repeat="f in vm.formWizard.company.extra_data.is_files track by $index" \nclass="border-bottom" flex><div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size" layout="row" layout-align="start left"><div class="media photos" layout="row" \nlayout-align="center center"><h2c-icon file="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" \nalt=""></div><div class="info ml-15" flex layout="column" layout-align="center center"><div class="name" layout="row" \nlayout-align="center center"><span ng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.is_files.splice($index, 1);"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/outputs/views/read/form-tabs/step-people-global.html','<div layout="column" layout-gt-xs="row"><div class="mail-list-pane s0" flex="100"><div layout-gt-xs="row" \nlayout="column" class="mb-20"><div flex="20"><div layout="row" layout-align="start center" flex="100" \nclass="p-20 layout-align-start-center layout-row flex-100"><div layout="row" layout-align="start center" flex="100" \nclass="layout-align-start-center layout-row flex-100"><div class="avatar-wrapper"><md-icon md-font-icon="icon-city">\n</md-icon></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding" \nng-bind-html="vm.formWizard.main_branch.name"></strong><div class="field grey-600-fg ng-binding"><span \nng-if="vm.formWizard.main_branch.city" ng-bind-html="vm.formWizard.main_branch.city"></span> <span \nng-if="vm.formWizard.main_branch.city && vm.formWizard.main_branch.state">, </span><span \nng-if="vm.formWizard.main_branch.state" ng-bind-html="vm.formWizard.main_branch.state"></span></div></div></div></div>\n</div><div flex="80"><div layout="row" layout-align="start center"><div class="mail-list-pane s0" flex="100"><div \nclass="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="user.branch_id == vm.formWizard.main_branch.id"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId != user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong><div class="field grey-600-fg ng-binding"><span>\n{{vm.getDivisionName(user.division)[0].name}} | {{vm.getPositionName(user.position)[0].name}}</span></div></div></div>\n</div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu class="float-right">\n<md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" \nng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\', vm.formWizard.main_branch)"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div><div class="items"><div layout="row" \nlayout-align="start center" flex="100" class="pt-10 pb-10"><div class="info" flex layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><md-button \nng-click="vm.openDialogForm(\'personnel\', vm.formWizard.main_branch.id)" \nclass="md-mini add-event-button md-fab md-warn mh-0"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n</div></div></div></div></div></div></div></div></div><div layout-gt-xs="row" layout="column" class="mb-20" \nng-repeat="branch in vm.formWizard.branch" ng-if="branch.id != vm.formWizard.main_branch.id"><div flex="20"><div \nlayout="row" layout-align="start center" flex="100" class="p-20 layout-align-start-center layout-row flex-100"><div \nlayout="row" layout-align="start center" flex="100" class="layout-align-start-center layout-row flex-100"><div \nclass="avatar-wrapper"><md-icon md-font-icon="icon-city"></md-icon></div><div class="field mr-10 ml-10 flex" flex="">\n<strong class="grey-800-fg ng-binding" ng-bind-html="branch.name"></strong><div class="field grey-600-fg ng-binding">\n<span ng-if="branch.city" ng-bind-html="branch.city"></span> <span ng-if="branch.city && branch.state">, </span><span \nng-if="branch.state" ng-bind-html="branch.state"></span></div></div></div></div></div><div flex="80"><div layout="row" \nlayout-align="start center"><div class="mail-list-pane s0" flex="100"><div class="items" \nng-repeat="user in vm.formWizard.personnel track by $index" ng-if="user.branch_id == branch.id"><div layout="row" \nlayout-align="start center" flex="100" class="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" \nlayout="column"><div class="name" layout="row"><div layout="row" layout-align="start center" flex="100"><div \nclass="avatar-wrapper"><user-avatar ng-if="uploadingFotoUserId != user.id" user="user"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong><div class="field grey-600-fg ng-binding"><span>\n{{vm.getDivisionName(user.division)[0].name}} | {{vm.getPositionName(user.position)[0].name}}</span></div></div></div>\n</div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu class="float-right">\n<md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\', branch)">\n<md-icon md-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div><div class="items"><div layout="row" \nlayout-align="start center" flex="100" class="pt-10 pb-10"><div class="info" flex layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><md-button \nng-click="vm.openDialogForm(\'personnel\', branch.id)" class="md-mini add-event-button md-fab md-warn mh-0"><md-icon \nmd-font-icon="icon-plus"></md-icon></md-button></div></div></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/outputs/views/read/form-tabs/step-people.html','<div layout="column" layout-gt-xs="row"><div style="padding: 0px 15px;" flex layout="column"><h1>Direcci\xF3n</h1><div \nlayout="column" layout-gt-xs="row"><md-input-container class="group-form" flex="100" flex-gt-xs="100"><div \nlayout="row" layout-align="start center"><h2 translate="GLOBAL.LEGAL_MANAGER"></h2><md-button \nng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'managerLegal\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n<div class="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'managerLegal\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId !== user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container class="group-form" flex="100" flex-gt-xs="100"><div layout="row" \nlayout-align="start center"><h2 translate="GLOBAL.ADMINISTRATOR"></h2><md-button \nng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'administrator\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n<div class="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'administrator\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId !== user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container></div></div><div \nstyle="padding: 0px 15px;" flex layout="column"><h1>Compliance</h1><md-input-container class="group-form" flex="100" \nflex-gt-xs="100"><h2 translate="GLOBAL.COMPLIANCE_OFFICER" style="display: inline-block;"></h2><md-button \nng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'compliance_officer\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'compliance_officer\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId !== user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container><md-input-container \nclass="group-form" flex="100" flex-gt-xs="100"><h2 translate="GLOBAL.COLLABORATOR" style="display: inline-block;"></h2>\n<md-button ng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'collaborator\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'collaborator\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId != user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container><md-input-container \nclass="group-form" flex="100" flex-gt-xs="100"><h2 translate="GLOBAL.REPORT_COMMITTEE" style="display: inline-block;">\n</h2><md-button ng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'compliance_comite\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'compliance_comite\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId !== user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container><md-input-container \nclass="group-form" flex="100" flex-gt-xs="100"><h2 translate="GLOBAL.DELEGATE_DATA_PROTECCTION" \nstyle="display: inline-block;"></h2><md-button ng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'data_protection\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'data_protection\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId != user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container></div></div>');
$templateCache.put('app/main/apps/questions/dialogs/image/views/fotorama-view.html','<div class="content-wrapper" flex layout="row"><div class="mail-tabs-grid" flex \nmd-dynamic-height="{{vm.dynamicHeight}}"><fotorama options="vm.fotoramaoptions" items="vm.dataFotorama" id="fotorama">\n</fotorama></div></div>');
$templateCache.put('app/main/apps/questions/dialogs/media/views/audios-view.html','<div class="content-wrapper" flex="" layout="row"><div class="mail-tabs-grid" flex \nmd-dynamic-height="{{vm.dynamicHeight}}"><div class="content mail-list-pane-grid" flex ms-scroll><div \nng-repeat="item in vm.items" class="ms-card" flex><div class="ms-card-content-wrapper"><div class="template-9"><div \nclass="media" flex layout="row" layout-align="center center"><div flex layout="column" layout-align="center center" \nclass="media"><media attachment="item" class=""></media><br><span class="grey-500-fg" layout="column" \nlayout-align="center center"><span ng-if="item.title"><strong>{{item.title}}</strong></span> <span \nng-if="item.filename">{{item.filename}}</span></span></div></div><div class="header p-16" flex><div layout="row" \nlayout-align="space-between center" flex><div class="size text-truncate" layout="row" layout-align="start left"><strong\n class="mr-5">#{{item.id_media}}</strong> <span class="grey-500-fg"><span ng-if="item.date_uploaded">\n{{item.date_uploaded}}</span></span></div><md-checkbox ng-checked="vm.alreadySelectedbyZone(vm.selectedImages, item)" \nng-click="vm.toggleSelectedImages(item, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, item) ? \'Deselect\' : \'Select\'}}" class="ml-5"></md-checkbox>\n</div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/questions/dialogs/media/views/files-view.html','<div class="content-wrapper" flex="" layout="row"><div class="mail-tabs-grid" flex=""><div \nclass="content mail-list-pane-grid" flex="" ms-scroll=""><div ng-repeat="item in vm.items" class="ms-card" flex><div \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><div flex layout="column" layout-align="center center" class="media"><media \nattachment="item" class=""></media><br><span class="grey-500-fg" layout="column" layout-align="center center"><span \nng-if="item.title"><strong>{{item.title}}</strong></span> <span ng-if="item.filename">{{item.filename}}</span></span>\n</div></div><div class="header p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size text-truncate" layout="row" layout-align="start left"><strong class="mr-5">#{{item.id_media}}</strong>\n</div><md-checkbox ng-checked="vm.alreadySelectedbyZone(vm.selectedImages, item)" \nng-click="vm.toggleSelectedImages(item, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, item) ? \'Deselect\' : \'Select\'}}" class="ml-5"></md-checkbox>\n</div></div></div></div></div></div></div></div><div layout="column" layout-align="center center"></div>');
$templateCache.put('app/main/apps/questions/dialogs/media/views/import-view.html','<div class="content-wrapper" flex layout="column"><div class="content"><div class="drop-box"><md-input-container \nclass="md-block"><label>Paste the url to import:</label> <input type="text" name="import_field" \nng-model="vm.import_field" placeholder="" ng-disabled="vm.import_disabled"></md-input-container><div \nng-if="vm.imported" class="alert-message success-message" translate="GLOBAL.SUCCESSIMPORT">Imported successfully</div>\n</div><treasure-overlay-spinner active="vm.importing"><div layout="row" layout-align="center start" \nng-if="vm.importPreview" class="white-box sections"><div flex-gt-sm="50" flex="100"><div class="section"><div \nclass="section-header" layout="row" layout-align="start center"><span class="section-title">PREVIEW</span></div><div \nclass="media" flex layout="row" layout-align="center center" ng-bind-html="vm.importPreview.embedCodeSafe"></div></div>\n<div class="header p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size text-truncate" layout="row" layout-align="start left"><span class="grey-500-fg"><span \nng-if="vm.importPreview.title">Title: {{vm.importPreview.title}}</span></span></div></div><div layout="row" \nlayout-align="space-between center" flex><div class="size" layout="row" layout-align="start left"><span \nclass="grey-500-fg"><span ng-if="vm.importPreview.caption">Description: {{vm.importPreview.caption}}</span></span>\n</div></div></div><md-button class="send-button md-accent md-raised" ng-click="vm.importConfirm(1)" \ntranslate="GLOBAL.IMPORT">Import</md-button></div></div><div ng-repeat="f in vm.importedFiles" class="ms-card" flex>\n<div class="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><img ng-src="{{f.embed_thumb}}" class="image"></div><div class="header p-16" flex><div \nlayout="row" layout-align="space-between center" flex><div class="size text-truncate" layout="row" \nlayout-align="start left"><strong class="mr-5">#{{f.id_media}}</strong> <span class="grey-500-fg"><span \nng-if=".filename">{{f.filename}}</span> <span ng-if="f.title">{{f.title}}</span></span></div><md-checkbox \nng-checked="vm.alreadySelectedbyZone(vm.selectedImages, f)" ng-click="vm.toggleSelectedImages(f, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, f) ? \'Deselect\' : \'Select\'}}"></md-checkbox></div></div>\n</div></div></div></treasure-overlay-spinner></div></div>');
$templateCache.put('app/main/apps/questions/dialogs/media/views/photos-view.html','<div class="content-wrapper" flex layout="row"><div class="mail-tabs-grid" flex \nmd-dynamic-height="{{vm.dynamicHeight}}"><div class="content mail-list-pane-grid" flex><div \nng-repeat="photo in vm.items" class="ms-card" flex><div class="ms-card-content-wrapper"><div class="template-9"><div \nclass="media" flex layout="row" layout-align="center center"><media attachment="photo" class=""></media></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size text-truncate" \nlayout="row" layout-align="start left"><strong class="mr-5">#{{photo.id_media}}</strong> <span class="grey-500-fg">\n<span ng-if="photo.filename">{{photo.filename}}</span></span></div><md-checkbox \nng-checked="vm.alreadySelectedbyZone(vm.selectedImages, photo)" ng-click="vm.toggleSelectedImages(photo, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, photo) ? \'Deselect\' : \'Select\'}}" class="ml-5"></md-checkbox>\n</div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/questions/dialogs/media/views/template-grid.html','<div class="template-9"><div class="header p-16" layout="row" layout-align="space-between center" flex><div \nlayout="column" layout-align="start center"><md-checkbox class="no-label" ng-checked="vm.isChecked(mail)" \nng-click="vm.toggleCheck(mail, $event)" aria-label="{{vm.isChecked(mail)? \'Uncheck\':\'check\'}}"></md-checkbox><div \nng-if="refcolumnsgrouped.main"><div class="subject text-truncate"><span \nng-repeat="field in refcolumnsgrouped.header | orderBy: \'list-sort\'" ng-bind="thread.{{field.titleId}}"></span></div>\n</div></div><div layout="column" layout-align="start center"><md-icon md-font-icon="icon-attachment" \nclass="has-attachment s24" ng-if="thread.Thumbnail.length>0"></md-icon><button ng-if="thread.onoff===1" \nclass="md-icon-button"><md-icon md-font-icon="icon-checkbox-marked-circle" class="on green-fg s24"></md-icon></button> \n<button ng-if="thread.onoff!==1" class="md-icon-button"><md-icon md-font-icon="icon-checkbox-blank-circle-outline" \nclass="off red-fg s24"></md-icon></button></div></div><div class="media" flex layout="row" \nlayout-align="center center"><img class="image" ng-src="{{card.Thumbnail[0].crop_status[0].urlformed}}" \nalt="{{card.media.image.alt}}" imageonloadcontrol></div><div class="header p-16" layout="row" layout-align="start"><div\n class="info"><div ng-if="refcolumnsgrouped.main"><div class="name text-truncate" layout="row" \nlayout-align="start center"><span ng-repeat="field in refcolumnsgrouped.main"><span ng-bind="thread.{{field.titleId}}">\n</span>&nbsp;</span></div></div><div ng-repeat="field in refcolumnsgrouped.secondary | orderBy:\'list_sort\'"><div \nng-if="(field.type!==\'date\' && field.type!==\'dateHm\') && field.primary!==1" class="details" layout="row" \nlayout-align="start start"><div layout="column"><span class="title" ng-bind="field.title"></span></div><div \nlayout="column" class="text-truncate"><span class="detail" ng-bind="thread.{{field.titleId}}"></span></div></div></div>\n</div></div></div>');
$templateCache.put('app/main/apps/questions/dialogs/media/views/tiny-attached.html','<div class="content-wrapper" flex layout="row"><div class="mail-tabs-grid" flex \nmd-dynamic-height="{{vm.dynamicHeight}}"><div class="content mail-list-pane-grid" flex><div \nng-repeat="item in vm.selectedImages" class="ms-card" flex><div class="ms-card-content-wrapper" \nng-if="item.media_type == 1"><div class="template-9"><div class="media" flex layout="row" layout-align="center center">\n<img ng-src="{{item.cropstatus[0].container.view_url}}{{item.cropstatus[0].fileName}}" class="image"></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size text-truncate" \nlayout="row" layout-align="start left"><strong class="mr-5">#{{item.id_media}}</strong> <span class="grey-500-fg"><span\n ng-if="item.filename">{{item.filename}}</span></span></div><md-button ng-click="vm.selectMediaTiny(item)" \nclass="send-button md-accent md-raised" aria-label="Select" translate="GLOBAL.SELECT" \ntranslate-attr-aria-label="GLOBAL.SELECT">SELECT</md-button></div></div></div></div><div \nclass="ms-card-content-wrapper" ng-if="item.media_type == 2"><div class="template-9"><div class="media" flex \nlayout="row" layout-align="center center"><img ng-src="{{item.embed_thumb}}" class="image"></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size text-truncate" \nlayout="row" layout-align="start left"><strong class="mr-5">#{{item.id_media}}</strong> <span class="grey-500-fg"><span\n ng-if="item.filename">{{item.filename}}</span> <span ng-if="item.title">{{item.title}}</span></span></div><md-button \nng-click="vm.selectMediaTiny(item)" class="send-button md-accent md-raised" aria-label="Select" \ntranslate="GLOBAL.SELECT" translate-attr-aria-label="GLOBAL.SELECT">SELECT</md-button></div></div></div></div></div>\n</div></div></div>');
$templateCache.put('app/main/apps/questions/dialogs/media/views/tiny-properties.html','<div class="ontent-wrapper" flex="" layout="column"><div class="content"><div class="ms-card" flex><div \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center" ng-if="vm.selectedMediaTiny.media_type == 1"><img \nng-src="{{vm.selectedMediaTiny.cropstatus[0].container.view_url}}{{vm.selectedMediaTiny.cropstatus[0].fileName}}" \nclass="image"></div><div class="media" flex layout="row" layout-align="center center" \nng-if="vm.selectedMediaTiny.media_type == 2"><img ng-src="{{vm.selectedMediaTiny.embed_thumb}}" class="image"></div>\n<div class="header p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size text-truncate" layout="row" layout-align="start left"><strong class="mr-5">\n#{{vm.selectedMediaTiny.id_media}}</strong> <span class="grey-500-fg"><span ng-if="vm.selectedMediaTiny.filename">\n{{vm.selectedMediaTiny.filename}}</span></span></div></div></div></div></div></div><div><md-input-container \nclass="md-block" flex><label translate="GLOBAL.ALIGN" translate-attr-aria-label="GLOBAL.ALIGN">Align:</label><md-select\n ng-model="vm.tinyProperties.align" placeholder="Align"><md-option value="">---</md-option><md-option \nng-repeat="opt in vm.tinyOptions.align" value="{{opt.value}}">{{opt.text}}</md-option></md-select><div \nclass="md-errors-spacer"></div></md-input-container><md-input-container class="md-block" flex><label \ntranslate="GLOBAL.SIZE" translate-attr-aria-label="GLOBAL.SIZE">Size:</label><md-select \nng-model="vm.tinyProperties.size" placeholder="Size"><md-option value="">---</md-option><md-option \nng-repeat="opt in vm.tinyOptions.size" value="{{opt.value}}">{{opt.text}}</md-option></md-select><div \nclass="md-errors-spacer"></div></md-input-container></div></div></div>');
$templateCache.put('app/main/apps/questions/dialogs/media/views/upload-view.html','<div class="content-wrapper" flex="" layout="column"><div class="content"><div ngf-drop ngf-select ng-model="vm.files" \nclass="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="false" ngf-allow-dir="true" accept="image/*" \nngf-pattern="\'image/*\'"><md-button class="md-raised md-accent text-center" ng-model="photo" \ntranslate="GLOBAL.SELECT_FILES" onchange="angular.element(this).scope().file_changed(this)" type="file" \naccept="image/*"></md-button></div><md-progress-linear md-mode="determinate" value="{{vm.files[0].progress}}" \nng-show="vm.files[0].progress < 100"></md-progress-linear></div></div>');
$templateCache.put('app/main/apps/questions/dialogs/media/views/videos-view.html','<div class="content-wrapper" flex layout="row"><div class="mail-tabs-grid" flex><div \nclass="content mail-list-pane-grid" flex><div ng-repeat="item in vm.items" class="ms-card" flex><div \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><media attachment="item" thumbnail="true" class=""></media></div><div class="header p-16" \nflex><div layout="row" layout-align="space-between center" flex><div class="size text-truncate" layout="row" \nlayout-align="start left"><strong class="mr-5">#{{item.id_media}}</strong> <span class="grey-500-fg"><span \nng-if="item.filename">{{item.filename}}</span> <span ng-if="item.title">{{item.title}}</span></span></div><md-checkbox \nng-checked="vm.alreadySelectedbyZone(vm.selectedImages, item)" ng-click="vm.toggleSelectedImages(item, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, item) ? \'Deselect\' : \'Select\'}}"></md-checkbox></div></div>\n</div></div></div></div></div></div>');
$templateCache.put('app/main/apps/riskconfig/dialogs/image/views/fotorama-view.html','<div class="content-wrapper" flex layout="row"><div class="mail-tabs-grid" flex \nmd-dynamic-height="{{vm.dynamicHeight}}"><fotorama options="vm.fotoramaoptions" items="vm.dataFotorama" id="fotorama">\n</fotorama></div></div>');
$templateCache.put('app/main/apps/riskconfig/dialogs/media/views/audios-view.html','<div class="content-wrapper" flex="" layout="row"><div class="mail-tabs-grid" flex \nmd-dynamic-height="{{vm.dynamicHeight}}"><div class="content mail-list-pane-grid" flex ms-scroll><div \nng-repeat="item in vm.items" class="ms-card" flex><div class="ms-card-content-wrapper"><div class="template-9"><div \nclass="media" flex layout="row" layout-align="center center"><div flex layout="column" layout-align="center center" \nclass="media"><media attachment="item" class=""></media><br><span class="grey-500-fg" layout="column" \nlayout-align="center center"><span ng-if="item.title"><strong>{{item.title}}</strong></span> <span \nng-if="item.filename">{{item.filename}}</span></span></div></div><div class="header p-16" flex><div layout="row" \nlayout-align="space-between center" flex><div class="size text-truncate" layout="row" layout-align="start left"><strong\n class="mr-5">#{{item.id_media}}</strong> <span class="grey-500-fg"><span ng-if="item.date_uploaded">\n{{item.date_uploaded}}</span></span></div><md-checkbox ng-checked="vm.alreadySelectedbyZone(vm.selectedImages, item)" \nng-click="vm.toggleSelectedImages(item, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, item) ? \'Deselect\' : \'Select\'}}" class="ml-5"></md-checkbox>\n</div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/riskconfig/dialogs/media/views/files-view.html','<div class="content-wrapper" flex="" layout="row"><div class="mail-tabs-grid" flex=""><div \nclass="content mail-list-pane-grid" flex="" ms-scroll=""><div ng-repeat="item in vm.items" class="ms-card" flex><div \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><div flex layout="column" layout-align="center center" class="media"><media \nattachment="item" class=""></media><br><span class="grey-500-fg" layout="column" layout-align="center center"><span \nng-if="item.title"><strong>{{item.title}}</strong></span> <span ng-if="item.filename">{{item.filename}}</span></span>\n</div></div><div class="header p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size text-truncate" layout="row" layout-align="start left"><strong class="mr-5">#{{item.id_media}}</strong>\n</div><md-checkbox ng-checked="vm.alreadySelectedbyZone(vm.selectedImages, item)" \nng-click="vm.toggleSelectedImages(item, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, item) ? \'Deselect\' : \'Select\'}}" class="ml-5"></md-checkbox>\n</div></div></div></div></div></div></div></div><div layout="column" layout-align="center center"></div>');
$templateCache.put('app/main/apps/riskconfig/dialogs/media/views/import-view.html','<div class="content-wrapper" flex layout="column"><div class="content"><div class="drop-box"><md-input-container \nclass="md-block"><label>Paste the url to import:</label> <input type="text" name="import_field" \nng-model="vm.import_field" placeholder="" ng-disabled="vm.import_disabled"></md-input-container><div \nng-if="vm.imported" class="alert-message success-message" translate="GLOBAL.SUCCESSIMPORT">Imported successfully</div>\n</div><treasure-overlay-spinner active="vm.importing"><div layout="row" layout-align="center start" \nng-if="vm.importPreview" class="white-box sections"><div flex-gt-sm="50" flex="100"><div class="section"><div \nclass="section-header" layout="row" layout-align="start center"><span class="section-title">PREVIEW</span></div><div \nclass="media" flex layout="row" layout-align="center center" ng-bind-html="vm.importPreview.embedCodeSafe"></div></div>\n<div class="header p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size text-truncate" layout="row" layout-align="start left"><span class="grey-500-fg"><span \nng-if="vm.importPreview.title">Title: {{vm.importPreview.title}}</span></span></div></div><div layout="row" \nlayout-align="space-between center" flex><div class="size" layout="row" layout-align="start left"><span \nclass="grey-500-fg"><span ng-if="vm.importPreview.caption">Description: {{vm.importPreview.caption}}</span></span>\n</div></div></div><md-button class="send-button md-accent md-raised" ng-click="vm.importConfirm(1)" \ntranslate="GLOBAL.IMPORT">Import</md-button></div></div><div ng-repeat="f in vm.importedFiles" class="ms-card" flex>\n<div class="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><img ng-src="{{f.embed_thumb}}" class="image"></div><div class="header p-16" flex><div \nlayout="row" layout-align="space-between center" flex><div class="size text-truncate" layout="row" \nlayout-align="start left"><strong class="mr-5">#{{f.id_media}}</strong> <span class="grey-500-fg"><span \nng-if=".filename">{{f.filename}}</span> <span ng-if="f.title">{{f.title}}</span></span></div><md-checkbox \nng-checked="vm.alreadySelectedbyZone(vm.selectedImages, f)" ng-click="vm.toggleSelectedImages(f, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, f) ? \'Deselect\' : \'Select\'}}"></md-checkbox></div></div>\n</div></div></div></treasure-overlay-spinner></div></div>');
$templateCache.put('app/main/apps/riskconfig/dialogs/media/views/photos-view.html','<div class="content-wrapper" flex layout="row"><div class="mail-tabs-grid" flex \nmd-dynamic-height="{{vm.dynamicHeight}}"><div class="content mail-list-pane-grid" flex><div \nng-repeat="photo in vm.items" class="ms-card" flex><div class="ms-card-content-wrapper"><div class="template-9"><div \nclass="media" flex layout="row" layout-align="center center"><media attachment="photo" class=""></media></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size text-truncate" \nlayout="row" layout-align="start left"><strong class="mr-5">#{{photo.id_media}}</strong> <span class="grey-500-fg">\n<span ng-if="photo.filename">{{photo.filename}}</span></span></div><md-checkbox \nng-checked="vm.alreadySelectedbyZone(vm.selectedImages, photo)" ng-click="vm.toggleSelectedImages(photo, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, photo) ? \'Deselect\' : \'Select\'}}" class="ml-5"></md-checkbox>\n</div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/riskconfig/dialogs/media/views/template-grid.html','<div class="template-9"><div class="header p-16" layout="row" layout-align="space-between center" flex><div \nlayout="column" layout-align="start center"><md-checkbox class="no-label" ng-checked="vm.isChecked(mail)" \nng-click="vm.toggleCheck(mail, $event)" aria-label="{{vm.isChecked(mail)? \'Uncheck\':\'check\'}}"></md-checkbox><div \nng-if="refcolumnsgrouped.main"><div class="subject text-truncate"><span \nng-repeat="field in refcolumnsgrouped.header | orderBy: \'list-sort\'" ng-bind="thread.{{field.titleId}}"></span></div>\n</div></div><div layout="column" layout-align="start center"><md-icon md-font-icon="icon-attachment" \nclass="has-attachment s24" ng-if="thread.Thumbnail.length>0"></md-icon><button ng-if="thread.onoff===1" \nclass="md-icon-button"><md-icon md-font-icon="icon-checkbox-marked-circle" class="on green-fg s24"></md-icon></button> \n<button ng-if="thread.onoff!==1" class="md-icon-button"><md-icon md-font-icon="icon-checkbox-blank-circle-outline" \nclass="off red-fg s24"></md-icon></button></div></div><div class="media" flex layout="row" \nlayout-align="center center"><img class="image" ng-src="{{card.Thumbnail[0].crop_status[0].urlformed}}" \nalt="{{card.media.image.alt}}" imageonloadcontrol></div><div class="header p-16" layout="row" layout-align="start"><div\n class="info"><div ng-if="refcolumnsgrouped.main"><div class="name text-truncate" layout="row" \nlayout-align="start center"><span ng-repeat="field in refcolumnsgrouped.main"><span ng-bind="thread.{{field.titleId}}">\n</span>&nbsp;</span></div></div><div ng-repeat="field in refcolumnsgrouped.secondary | orderBy:\'list_sort\'"><div \nng-if="(field.type!==\'date\' && field.type!==\'dateHm\') && field.primary!==1" class="details" layout="row" \nlayout-align="start start"><div layout="column"><span class="title" ng-bind="field.title"></span></div><div \nlayout="column" class="text-truncate"><span class="detail" ng-bind="thread.{{field.titleId}}"></span></div></div></div>\n</div></div></div>');
$templateCache.put('app/main/apps/riskconfig/dialogs/media/views/tiny-attached.html','<div class="content-wrapper" flex layout="row"><div class="mail-tabs-grid" flex \nmd-dynamic-height="{{vm.dynamicHeight}}"><div class="content mail-list-pane-grid" flex><div \nng-repeat="item in vm.selectedImages" class="ms-card" flex><div class="ms-card-content-wrapper" \nng-if="item.media_type == 1"><div class="template-9"><div class="media" flex layout="row" layout-align="center center">\n<img ng-src="{{item.cropstatus[0].container.view_url}}{{item.cropstatus[0].fileName}}" class="image"></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size text-truncate" \nlayout="row" layout-align="start left"><strong class="mr-5">#{{item.id_media}}</strong> <span class="grey-500-fg"><span\n ng-if="item.filename">{{item.filename}}</span></span></div><md-button ng-click="vm.selectMediaTiny(item)" \nclass="send-button md-accent md-raised" aria-label="Select" translate="GLOBAL.SELECT" \ntranslate-attr-aria-label="GLOBAL.SELECT">SELECT</md-button></div></div></div></div><div \nclass="ms-card-content-wrapper" ng-if="item.media_type == 2"><div class="template-9"><div class="media" flex \nlayout="row" layout-align="center center"><img ng-src="{{item.embed_thumb}}" class="image"></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size text-truncate" \nlayout="row" layout-align="start left"><strong class="mr-5">#{{item.id_media}}</strong> <span class="grey-500-fg"><span\n ng-if="item.filename">{{item.filename}}</span> <span ng-if="item.title">{{item.title}}</span></span></div><md-button \nng-click="vm.selectMediaTiny(item)" class="send-button md-accent md-raised" aria-label="Select" \ntranslate="GLOBAL.SELECT" translate-attr-aria-label="GLOBAL.SELECT">SELECT</md-button></div></div></div></div></div>\n</div></div></div>');
$templateCache.put('app/main/apps/riskconfig/dialogs/media/views/tiny-properties.html','<div class="ontent-wrapper" flex="" layout="column"><div class="content"><div class="ms-card" flex><div \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center" ng-if="vm.selectedMediaTiny.media_type == 1"><img \nng-src="{{vm.selectedMediaTiny.cropstatus[0].container.view_url}}{{vm.selectedMediaTiny.cropstatus[0].fileName}}" \nclass="image"></div><div class="media" flex layout="row" layout-align="center center" \nng-if="vm.selectedMediaTiny.media_type == 2"><img ng-src="{{vm.selectedMediaTiny.embed_thumb}}" class="image"></div>\n<div class="header p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size text-truncate" layout="row" layout-align="start left"><strong class="mr-5">\n#{{vm.selectedMediaTiny.id_media}}</strong> <span class="grey-500-fg"><span ng-if="vm.selectedMediaTiny.filename">\n{{vm.selectedMediaTiny.filename}}</span></span></div></div></div></div></div></div><div><md-input-container \nclass="md-block" flex><label translate="GLOBAL.ALIGN" translate-attr-aria-label="GLOBAL.ALIGN">Align:</label><md-select\n ng-model="vm.tinyProperties.align" placeholder="Align"><md-option value="">---</md-option><md-option \nng-repeat="opt in vm.tinyOptions.align" value="{{opt.value}}">{{opt.text}}</md-option></md-select><div \nclass="md-errors-spacer"></div></md-input-container><md-input-container class="md-block" flex><label \ntranslate="GLOBAL.SIZE" translate-attr-aria-label="GLOBAL.SIZE">Size:</label><md-select \nng-model="vm.tinyProperties.size" placeholder="Size"><md-option value="">---</md-option><md-option \nng-repeat="opt in vm.tinyOptions.size" value="{{opt.value}}">{{opt.text}}</md-option></md-select><div \nclass="md-errors-spacer"></div></md-input-container></div></div></div>');
$templateCache.put('app/main/apps/riskconfig/dialogs/media/views/upload-view.html','<div class="content-wrapper" flex="" layout="column"><div class="content"><div ngf-drop ngf-select ng-model="vm.files" \nclass="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="false" ngf-allow-dir="true" accept="image/*" \nngf-pattern="\'image/*\'"><md-button class="md-raised md-accent text-center" ng-model="photo" \ntranslate="GLOBAL.SELECT_FILES" onchange="angular.element(this).scope().file_changed(this)" type="file" \naccept="image/*"></md-button></div><md-progress-linear md-mode="determinate" value="{{vm.files[0].progress}}" \nng-show="vm.files[0].progress < 100"></md-progress-linear></div></div>');
$templateCache.put('app/main/apps/riskconfig/dialogs/media/views/videos-view.html','<div class="content-wrapper" flex layout="row"><div class="mail-tabs-grid" flex><div \nclass="content mail-list-pane-grid" flex><div ng-repeat="item in vm.items" class="ms-card" flex><div \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><media attachment="item" thumbnail="true" class=""></media></div><div class="header p-16" \nflex><div layout="row" layout-align="space-between center" flex><div class="size text-truncate" layout="row" \nlayout-align="start left"><strong class="mr-5">#{{item.id_media}}</strong> <span class="grey-500-fg"><span \nng-if="item.filename">{{item.filename}}</span> <span ng-if="item.title">{{item.title}}</span></span></div><md-checkbox \nng-checked="vm.alreadySelectedbyZone(vm.selectedImages, item)" ng-click="vm.toggleSelectedImages(item, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, item) ? \'Deselect\' : \'Select\'}}"></md-checkbox></div></div>\n</div></div></div></div></div></div>');
$templateCache.put('app/main/apps/stakeholders/dialogs/image/views/fotorama-view.html','<div class="content-wrapper" flex layout="row"><div class="mail-tabs-grid" flex \nmd-dynamic-height="{{vm.dynamicHeight}}"><fotorama options="vm.fotoramaoptions" items="vm.dataFotorama" id="fotorama">\n</fotorama></div></div>');
$templateCache.put('app/main/apps/stakeholders/dialogs/media/views/audios-view.html','<div class="content-wrapper" flex="" layout="row"><div class="mail-tabs-grid" flex \nmd-dynamic-height="{{vm.dynamicHeight}}"><div class="content mail-list-pane-grid" flex ms-scroll><div \nng-repeat="item in vm.items" class="ms-card" flex><div class="ms-card-content-wrapper"><div class="template-9"><div \nclass="media" flex layout="row" layout-align="center center"><div flex layout="column" layout-align="center center" \nclass="media"><media attachment="item" class=""></media><br><span class="grey-500-fg" layout="column" \nlayout-align="center center"><span ng-if="item.title"><strong>{{item.title}}</strong></span> <span \nng-if="item.filename">{{item.filename}}</span></span></div></div><div class="header p-16" flex><div layout="row" \nlayout-align="space-between center" flex><div class="size text-truncate" layout="row" layout-align="start left"><strong\n class="mr-5">#{{item.id_media}}</strong> <span class="grey-500-fg"><span ng-if="item.date_uploaded">\n{{item.date_uploaded}}</span></span></div><md-checkbox ng-checked="vm.alreadySelectedbyZone(vm.selectedImages, item)" \nng-click="vm.toggleSelectedImages(item, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, item) ? \'Deselect\' : \'Select\'}}" class="ml-5"></md-checkbox>\n</div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/stakeholders/dialogs/media/views/files-view.html','<div class="content-wrapper" flex="" layout="row"><div class="mail-tabs-grid" flex=""><div \nclass="content mail-list-pane-grid" flex="" ms-scroll=""><div ng-repeat="item in vm.items" class="ms-card" flex><div \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><div flex layout="column" layout-align="center center" class="media"><media \nattachment="item" class=""></media><br><span class="grey-500-fg" layout="column" layout-align="center center"><span \nng-if="item.title"><strong>{{item.title}}</strong></span> <span ng-if="item.filename">{{item.filename}}</span></span>\n</div></div><div class="header p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size text-truncate" layout="row" layout-align="start left"><strong class="mr-5">#{{item.id_media}}</strong>\n</div><md-checkbox ng-checked="vm.alreadySelectedbyZone(vm.selectedImages, item)" \nng-click="vm.toggleSelectedImages(item, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, item) ? \'Deselect\' : \'Select\'}}" class="ml-5"></md-checkbox>\n</div></div></div></div></div></div></div></div><div layout="column" layout-align="center center"></div>');
$templateCache.put('app/main/apps/stakeholders/dialogs/media/views/import-view.html','<div class="content-wrapper" flex layout="column"><div class="content"><div class="drop-box"><md-input-container \nclass="md-block"><label>Paste the url to import:</label> <input type="text" name="import_field" \nng-model="vm.import_field" placeholder="" ng-disabled="vm.import_disabled"></md-input-container><div \nng-if="vm.imported" class="alert-message success-message" translate="GLOBAL.SUCCESSIMPORT">Imported successfully</div>\n</div><treasure-overlay-spinner active="vm.importing"><div layout="row" layout-align="center start" \nng-if="vm.importPreview" class="white-box sections"><div flex-gt-sm="50" flex="100"><div class="section"><div \nclass="section-header" layout="row" layout-align="start center"><span class="section-title">PREVIEW</span></div><div \nclass="media" flex layout="row" layout-align="center center" ng-bind-html="vm.importPreview.embedCodeSafe"></div></div>\n<div class="header p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size text-truncate" layout="row" layout-align="start left"><span class="grey-500-fg"><span \nng-if="vm.importPreview.title">Title: {{vm.importPreview.title}}</span></span></div></div><div layout="row" \nlayout-align="space-between center" flex><div class="size" layout="row" layout-align="start left"><span \nclass="grey-500-fg"><span ng-if="vm.importPreview.caption">Description: {{vm.importPreview.caption}}</span></span>\n</div></div></div><md-button class="send-button md-accent md-raised" ng-click="vm.importConfirm(1)" \ntranslate="GLOBAL.IMPORT">Import</md-button></div></div><div ng-repeat="f in vm.importedFiles" class="ms-card" flex>\n<div class="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><img ng-src="{{f.embed_thumb}}" class="image"></div><div class="header p-16" flex><div \nlayout="row" layout-align="space-between center" flex><div class="size text-truncate" layout="row" \nlayout-align="start left"><strong class="mr-5">#{{f.id_media}}</strong> <span class="grey-500-fg"><span \nng-if=".filename">{{f.filename}}</span> <span ng-if="f.title">{{f.title}}</span></span></div><md-checkbox \nng-checked="vm.alreadySelectedbyZone(vm.selectedImages, f)" ng-click="vm.toggleSelectedImages(f, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, f) ? \'Deselect\' : \'Select\'}}"></md-checkbox></div></div>\n</div></div></div></treasure-overlay-spinner></div></div>');
$templateCache.put('app/main/apps/stakeholders/dialogs/media/views/photos-view.html','<div class="content-wrapper" flex layout="row"><div class="mail-tabs-grid" flex \nmd-dynamic-height="{{vm.dynamicHeight}}"><div class="content mail-list-pane-grid" flex><div \nng-repeat="photo in vm.items" class="ms-card" flex><div class="ms-card-content-wrapper"><div class="template-9"><div \nclass="media" flex layout="row" layout-align="center center"><media attachment="photo" class=""></media></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size text-truncate" \nlayout="row" layout-align="start left"><strong class="mr-5">#{{photo.id_media}}</strong> <span class="grey-500-fg">\n<span ng-if="photo.filename">{{photo.filename}}</span></span></div><md-checkbox \nng-checked="vm.alreadySelectedbyZone(vm.selectedImages, photo)" ng-click="vm.toggleSelectedImages(photo, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, photo) ? \'Deselect\' : \'Select\'}}" class="ml-5"></md-checkbox>\n</div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/stakeholders/dialogs/media/views/template-grid.html','<div class="template-9"><div class="header p-16" layout="row" layout-align="space-between center" flex><div \nlayout="column" layout-align="start center"><md-checkbox class="no-label" ng-checked="vm.isChecked(mail)" \nng-click="vm.toggleCheck(mail, $event)" aria-label="{{vm.isChecked(mail)? \'Uncheck\':\'check\'}}"></md-checkbox><div \nng-if="refcolumnsgrouped.main"><div class="subject text-truncate"><span \nng-repeat="field in refcolumnsgrouped.header | orderBy: \'list-sort\'" ng-bind="thread.{{field.titleId}}"></span></div>\n</div></div><div layout="column" layout-align="start center"><md-icon md-font-icon="icon-attachment" \nclass="has-attachment s24" ng-if="thread.Thumbnail.length>0"></md-icon><button ng-if="thread.onoff===1" \nclass="md-icon-button"><md-icon md-font-icon="icon-checkbox-marked-circle" class="on green-fg s24"></md-icon></button> \n<button ng-if="thread.onoff!==1" class="md-icon-button"><md-icon md-font-icon="icon-checkbox-blank-circle-outline" \nclass="off red-fg s24"></md-icon></button></div></div><div class="media" flex layout="row" \nlayout-align="center center"><img class="image" ng-src="{{card.Thumbnail[0].crop_status[0].urlformed}}" \nalt="{{card.media.image.alt}}" imageonloadcontrol></div><div class="header p-16" layout="row" layout-align="start"><div\n class="info"><div ng-if="refcolumnsgrouped.main"><div class="name text-truncate" layout="row" \nlayout-align="start center"><span ng-repeat="field in refcolumnsgrouped.main"><span ng-bind="thread.{{field.titleId}}">\n</span>&nbsp;</span></div></div><div ng-repeat="field in refcolumnsgrouped.secondary | orderBy:\'list_sort\'"><div \nng-if="(field.type!==\'date\' && field.type!==\'dateHm\') && field.primary!==1" class="details" layout="row" \nlayout-align="start start"><div layout="column"><span class="title" ng-bind="field.title"></span></div><div \nlayout="column" class="text-truncate"><span class="detail" ng-bind="thread.{{field.titleId}}"></span></div></div></div>\n</div></div></div>');
$templateCache.put('app/main/apps/stakeholders/dialogs/media/views/tiny-attached.html','<div class="content-wrapper" flex layout="row"><div class="mail-tabs-grid" flex \nmd-dynamic-height="{{vm.dynamicHeight}}"><div class="content mail-list-pane-grid" flex><div \nng-repeat="item in vm.selectedImages" class="ms-card" flex><div class="ms-card-content-wrapper" \nng-if="item.media_type == 1"><div class="template-9"><div class="media" flex layout="row" layout-align="center center">\n<img ng-src="{{item.cropstatus[0].container.view_url}}{{item.cropstatus[0].fileName}}" class="image"></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size text-truncate" \nlayout="row" layout-align="start left"><strong class="mr-5">#{{item.id_media}}</strong> <span class="grey-500-fg"><span\n ng-if="item.filename">{{item.filename}}</span></span></div><md-button ng-click="vm.selectMediaTiny(item)" \nclass="send-button md-accent md-raised" aria-label="Select" translate="GLOBAL.SELECT" \ntranslate-attr-aria-label="GLOBAL.SELECT">SELECT</md-button></div></div></div></div><div \nclass="ms-card-content-wrapper" ng-if="item.media_type == 2"><div class="template-9"><div class="media" flex \nlayout="row" layout-align="center center"><img ng-src="{{item.embed_thumb}}" class="image"></div><div \nclass="header p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size text-truncate" \nlayout="row" layout-align="start left"><strong class="mr-5">#{{item.id_media}}</strong> <span class="grey-500-fg"><span\n ng-if="item.filename">{{item.filename}}</span> <span ng-if="item.title">{{item.title}}</span></span></div><md-button \nng-click="vm.selectMediaTiny(item)" class="send-button md-accent md-raised" aria-label="Select" \ntranslate="GLOBAL.SELECT" translate-attr-aria-label="GLOBAL.SELECT">SELECT</md-button></div></div></div></div></div>\n</div></div></div>');
$templateCache.put('app/main/apps/stakeholders/dialogs/media/views/tiny-properties.html','<div class="ontent-wrapper" flex="" layout="column"><div class="content"><div class="ms-card" flex><div \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center" ng-if="vm.selectedMediaTiny.media_type == 1"><img \nng-src="{{vm.selectedMediaTiny.cropstatus[0].container.view_url}}{{vm.selectedMediaTiny.cropstatus[0].fileName}}" \nclass="image"></div><div class="media" flex layout="row" layout-align="center center" \nng-if="vm.selectedMediaTiny.media_type == 2"><img ng-src="{{vm.selectedMediaTiny.embed_thumb}}" class="image"></div>\n<div class="header p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size text-truncate" layout="row" layout-align="start left"><strong class="mr-5">\n#{{vm.selectedMediaTiny.id_media}}</strong> <span class="grey-500-fg"><span ng-if="vm.selectedMediaTiny.filename">\n{{vm.selectedMediaTiny.filename}}</span></span></div></div></div></div></div></div><div><md-input-container \nclass="md-block" flex><label translate="GLOBAL.ALIGN" translate-attr-aria-label="GLOBAL.ALIGN">Align:</label><md-select\n ng-model="vm.tinyProperties.align" placeholder="Align"><md-option value="">---</md-option><md-option \nng-repeat="opt in vm.tinyOptions.align" value="{{opt.value}}">{{opt.text}}</md-option></md-select><div \nclass="md-errors-spacer"></div></md-input-container><md-input-container class="md-block" flex><label \ntranslate="GLOBAL.SIZE" translate-attr-aria-label="GLOBAL.SIZE">Size:</label><md-select \nng-model="vm.tinyProperties.size" placeholder="Size"><md-option value="">---</md-option><md-option \nng-repeat="opt in vm.tinyOptions.size" value="{{opt.value}}">{{opt.text}}</md-option></md-select><div \nclass="md-errors-spacer"></div></md-input-container></div></div></div>');
$templateCache.put('app/main/apps/stakeholders/dialogs/media/views/upload-view.html','<div class="content-wrapper" flex="" layout="column"><div class="content"><div ngf-drop ngf-select ng-model="vm.files" \nclass="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="false" ngf-allow-dir="true" accept="image/*" \nngf-pattern="\'image/*\'"><md-button class="md-raised md-accent text-center" ng-model="photo" \ntranslate="GLOBAL.SELECT_FILES" onchange="angular.element(this).scope().file_changed(this)" type="file" \naccept="image/*"></md-button></div><md-progress-linear md-mode="determinate" value="{{vm.files[0].progress}}" \nng-show="vm.files[0].progress < 100"></md-progress-linear></div></div>');
$templateCache.put('app/main/apps/stakeholders/dialogs/media/views/videos-view.html','<div class="content-wrapper" flex layout="row"><div class="mail-tabs-grid" flex><div \nclass="content mail-list-pane-grid" flex><div ng-repeat="item in vm.items" class="ms-card" flex><div \nclass="ms-card-content-wrapper"><div class="template-9"><div class="media" flex layout="row" \nlayout-align="center center"><media attachment="item" thumbnail="true" class=""></media></div><div class="header p-16" \nflex><div layout="row" layout-align="space-between center" flex><div class="size text-truncate" layout="row" \nlayout-align="start left"><strong class="mr-5">#{{item.id_media}}</strong> <span class="grey-500-fg"><span \nng-if="item.filename">{{item.filename}}</span> <span ng-if="item.title">{{item.title}}</span></span></div><md-checkbox \nng-checked="vm.alreadySelectedbyZone(vm.selectedImages, item)" ng-click="vm.toggleSelectedImages(item, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, item) ? \'Deselect\' : \'Select\'}}"></md-checkbox></div></div>\n</div></div></div></div></div></div>');
$templateCache.put('app/main/apps/stakeholders/views/read/form-tabs/step-branchs.html','<div layout="column" layout-gt-xs="row"><md-input-container flex><h1 translate="GLOBAL.MAIN_BRANCH"></h1>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="GLOBAL.NAME"></label> <input ng-model="vm.formWizard.main_branch.name" type="text"></md-input-container>\n<md-input-container flex><label translate="GLOBAL.ADDRESS"></label> <input \nng-model="vm.formWizard.main_branch.address1" type="text" required></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container flex><label>{{vm.getRegionLiteral(\'city\')}}</label> <input \nng-model="vm.formWizard.main_branch.city" type="text" required></md-input-container><md-input-container flex><label>\n{{vm.getRegionLiteral(\'state\')}}</label> <input ng-model="vm.formWizard.main_branch.state" type="text" required>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="GLOBAL.POSTAL_CODE"></label> <input ng-model="vm.formWizard.main_branch.postcode" type="text" required>\n</md-input-container><md-input-container flex><label translate="GLOBAL.PHONE"></label> <input \nng-model="vm.formWizard.main_branch.phone" type="text"></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container flex><label translate="GLOBAL.EMAIL"></label> <input \nng-model="vm.formWizard.main_branch.email" type="text"></md-input-container><md-input-container flex>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container class="group-form" flex="100" \nflex-gt-xs="100"><div layout="row" layout-align="start center"><h1 translate="GLOBAL.BRANCH"></h1><md-button \nng-click="vm.openDialogForm(\'branch\')" class="ml-10 md-mini add-event-button md-fab md-warn"><md-icon \nmd-font-icon="icon-plus"></md-icon></md-button></div><div class="mail-list-pane s0" \nng-if="vm.formWizard.branch && vm.formWizard.branch.length > 0"><div class="items" ng-if="!branch.is_main" \nng-repeat="branch in vm.formWizard.branch"><div layout="row" layout-align="start center" flex="100" class="p-20"><div \nlayout="row" layout-align="start center" flex="90"><div class="avatar-wrapper"><md-icon md-font-icon="icon-city">\n</md-icon></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding" \nng-bind-html="branch.name"></strong><div class="field grey-600-fg ng-binding"><span ng-if="branch.city" \nng-bind-html="branch.city"></span> <span ng-if="branch.city && branch.state">, </span><span ng-if="branch.state" \nng-bind-html="branch.state"></span></div></div></div><div class="menu" flex="10" layout-align="center end" \nlayout="column"><md-menu class="float-right"><md-button class="md-icon-button" aria-label="More" \nng-click="vm.openMenu($mdMenu, $event)"><md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg">\n</md-icon></md-button><md-menu-content width="2"><md-menu-item><md-button translate="GLOBAL.EDIT" \nng-click="vm.editBranchDialog($event, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div></md-input-container></div>');
$templateCache.put('app/main/apps/stakeholders/views/read/form-tabs/step-company.html','<div layout="column" layout-gt-xs="row"><md-input-container flex><label translate="GLOBAL.SOCIAL_REASON"></label> \n<input type="text" ng-model="vm.formWizard.company.name" required></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container flex><label>{{vm.getRegionLiteral(\'tax_ic_number\')}}</label> <input type="text" \nng-model="vm.formWizard.company.tax_id_number"></md-input-container><md-input-container flex><label \ntranslate="GLOBAL.SECTOR"></label><md-select ng-model="vm.formWizard.company.sector_id"><md-option \nng-repeat="sector in vm.sectors track by $index" ng-value="sector.id">{{sector.name}}</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row"><md-input-container flex><label \ntranslate="GLOBAL.REGION"></label><md-select ng-model="vm.formWizard.company.region_id"><md-option \nng-repeat="region in vm.regions track by $index" ng-value="region.id">{{region.name}}</md-option></md-select>\n</md-input-container><md-input-container flex></md-input-container></div><div layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container><p class="mt-0 grey-400-fg" translate="GLOBAL.LOGOTYPE"></p><div \nclass="header simple relative" ng-if="image || imageUrl" layout="row" layout-align="space-between center"><md-menu>\n<button class="md-icon-button" aria-label="More"><div layout="column" layout-align="start center" \nng-click="$mdMenu.open($event)"><div class="media" flex layout="row" layout-align="center center"><img \nngf-thumbnail="!image.$error && image" class="image"> <img ng-if="!image && imageUrl" src="{{imageUrl}}" class="image">\n</div><md-button class="md-mini add-event-button no-sort md-fab md-warn block absolute-top-right" \naria-label="Add event"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button></div></button><md-menu-content\n width="3"><md-menu-item><md-button ng-click="vm.deleteLogotype()" aria-label="Toggle done" \ntranslate-attr-aria-label="GLOBAL.REMOVE"><md-icon md-font-icon="icon-close" class="s18"></md-icon><span \ntranslate="GLOBAL.REMOVE"></span></md-button></md-menu-item></md-menu-content></md-menu></div><div \nng-if="!image && !imageUrl" ng-click="vm.mediaDialogSingle($event, vm.formWizard.company.logotype)" class="relative">\n<img src="assets/images/logos/generic-logo.png" class="image"><md-button \nclass="md-mini add-event-button no-sort md-fab md-warn block absolute-top-right" aria-label="Add event" translate \ntranslate-attr-aria-label="CALENDAR.ADD_EVENT"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n</md-input-container></div>');
$templateCache.put('app/main/apps/stakeholders/views/read/form-tabs/step-options.html','<div class="options"><div layout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container \nfill-width flex><label translate="GLOBAL.DESCRIPTION"></label> <input type="text" \nng-model="vm.formWizard.company.description"></md-input-container><md-input-container fill-width flex><label \ntranslate="GLOBAL.COMPANY_TYPE"></label><md-select ng-model="vm.formWizard.company.extra_data.company_type"><md-option \nng-value="1">SA</md-option><md-option ng-value="2">SL</md-option><md-option ng-value="3">Cotizada</md-option><md-option\n ng-value="4">Fundaciones/asociaciones</md-option><md-option ng-value="5">Otras</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container\n fill-width flex><label translate="GLOBAL.EXECUTIVE_TYPE"></label><md-select \nng-model="vm.formWizard.company.extra_data.executives_type"><md-option ng-value="1">Accionista \xFAnico</md-option>\n<md-option ng-value="2">Varios accionistas</md-option><md-option ng-value="3">Consejo de administraci\xF3n</md-option>\n<md-option ng-value="4">Administrador \xFAnico</md-option><md-option ng-value="5">Otros</md-option></md-select>\n</md-input-container><md-input-container fill-width flex><label translate="GLOBAL.SOCIAL_CAPITAL"></label><md-select \nng-model="vm.formWizard.company.extra_data.capital"><md-option ng-value="1">Capital</md-option><md-option ng-value="2">\nAportaciones de socios</md-option><md-option ng-value="3">Aumentos de capital recientes</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container\n fill-width flex><label translate="GLOBAL.AMOUNT_CAPITAL"></label> <input type="number" type="text" \nng-model="vm.formWizard.company.extra_data.capital_amount"></md-input-container><md-input-container fill-width flex>\n<label translate="GLOBAL.BILLING_LAST_YEAR"></label> <input type="number" \nng-model="vm.formWizard.company.turnover_volume"></md-input-container></div><div layout="column" layout-gt-xs="row" \nflex layout-align="start center"><md-input-container fill-width flex><label>Cuentas anuales</label><md-select \nng-model="vm.formWizard.company.extra_data.annual_accounts"><md-option ng-value="1">Abreviadas</md-option><md-option \nng-value="2">Normales</md-option><md-option ng-value="3">Pymes</md-option><md-option ng-value="4">Mixtas</md-option>\n</md-select></md-input-container><md-input-container fill-width flex><label>Auditor\xEDas</label><md-select \nng-model="vm.formWizard.company.extra_data.audits"><md-option ng-value="1">Internas</md-option><md-option ng-value="2">\nExternas</md-option><md-option ng-value="3">No aplica</md-option></md-select></md-input-container></div><div \nlayout="column" layout-gt-xs="row" flex layout-align="start center"><md-input-container fill-width flex><label>\nCertificaciones ISO</label><md-select ng-model="vm.formWizard.company.extra_data.iso_certification"><md-option \nng-value="1">ISO 9001</md-option><md-option ng-value="2">ISO 14000</md-option><md-option ng-value="3">ISO 14001\n</md-option><md-option ng-value="4">ISO 19600</md-option><md-option ng-value="5">ISO 22000</md-option><md-option \nng-value="6">ISO 26000</md-option><md-option ng-value="7">ISO 27001</md-option><md-option ng-value="8">ISO 37001\n</md-option><md-option ng-value="9">OHSAS 18001</md-option></md-select></md-input-container><md-input-container \nfill-width flex><label>Convenio Colectivo Aplicable</label> <input type="text" \nng-model="vm.formWizard.company.extra_data.collective_agreement"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" flex layout-align="start center"><md-input-container fill-width flex><label>Seguros contratados\n</label> <input type="text" ng-model="vm.formWizard.company.extra_data.insurance"></md-input-container>\n<md-input-container fill-width flex><label translate="GLOBAL.CNAE"></label> <input type="text" \nng-model="vm.formWizard.company.extra_data.cnae"></md-input-container></div><div layout="column" layout-gt-xs="row" \nflex layout-align="start center"><md-input-container fill-width layout="row" layout-align="start center" flex><label \nclass="ph-15" fill-width translate="GLOBAL.FINANCING"></label><md-select flex \nng-init="!vm.formWizard.company.extra_data.financing ? vm.formWizard.company.extra_data.financing = [] : null;" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.financing"><md-option \nng-repeat="option in vm.financing_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container><md-input-container fill-width layout="row" layout-align="start center" flex><label class="ph-15" \nfill-width>Normativa Sectorial aplicable</label><md-select flex \nng-init="!vm.formWizard.company.extra_data.sector_regulations ? vm.formWizard.company.extra_data.sector_regulations = [] : null;" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.sector_regulations"><md-option \nng-repeat="option in vm.sector_regulations_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-align="start center"><md-input-container \nfill-width layout="row" layout-align="start center" flex><label class="ph-15" fill-width>Medidas implementadas</label>\n<md-select flex \nng-init="!vm.formWizard.company.extra_data.implemented_measures ? vm.formWizard.company.extra_data.implemented_measures = [] : null;" \nmultiple="{{false}}" ng-model="vm.formWizard.company.extra_data.implemented_measures"><md-option \nng-repeat="option in vm.implemented_measures_options" ng-value="option">{{option.name}}</md-option></md-select>\n</md-input-container></div><div class="separator-options" layout="row"><h2>Grupo de sociedades?</h2><md-input-container\n fill-width layout="row" layout-align="start center" flex class="mb-0"><md-checkbox \nng-checked="vm.formWizard.company.extra_data.belogns_to_holding" \nng-model="vm.formWizard.company.extra_data.belogns_to_holding"></md-checkbox></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-align="start center"></div><div \nng-if="vm.formWizard.company.extra_data.belogns_to_holding" layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container fill-width flex><label>Nombre corporaci\xF3n</label> <input type="text" \nng-model="vm.formWizard.company.extra_data.name_corporation"></md-input-container><md-input-container fill-width flex>\n<label>CIF corporaci\xF3n</label> <input type="text" ng-model="vm.formWizard.company.extra_data.cif_corporation">\n</md-input-container></div><div class="mv-25" ng-if="vm.formWizard.company.extra_data.belogns_to_holding" \nlayout="column" layout-gt-xs="row" layout-align="start center"><div fill-width><div ngf-drop ngf-select \nng-model="vm.files_belogns_to_holding" class="drop-box" layout="column" layout-gt-xs="row" \nngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="belogns_to_holding_isLoading"><div flex layout="column" layout-align="center center" layout-padding \nlayout-margin class="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30">\n</md-progress-circular></div></div></div><div layout="column" flex><div \nng-repeat="f in vm.formWizard.company.extra_data.belogns_to_holding_files track by $index" class="border-bottom" flex>\n<div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><div class="media photos" layout="row" layout-align="center center"><h2c-icon \nfile="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" alt=""></div><div class="info ml-15" flex \nlayout="column" layout-align="center center"><div class="name" layout="row" layout-align="center center"><span \nng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu class="float-right"><md-button \nclass="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.belogns_to_holding_files.splice($index, 1);"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></div></div></div><div class="separator-options" \nlayout="row"><h2>Responsabilidad social corporativa?</h2><md-input-container fill-width layout="row" \nlayout-align="start center" flex class="mb-0"><md-checkbox \nng-checked="vm.formWizard.company.extra_data.social_responsability" \nng-model="vm.formWizard.company.extra_data.social_responsability"></md-checkbox></md-input-container></div><div \nclass="mv-25" ng-if="vm.formWizard.company.extra_data.social_responsability" layout="column" layout-gt-xs="row" \nlayout-align="start center"><div fill-width><div ngf-drop ngf-select ng-model="vm.files_social_responsability" \nclass="drop-box" layout="column" layout-gt-xs="row" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" \nngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="social_responsability_isLoading"><div flex layout="column" layout-align="center center" layout-padding \nlayout-margin class="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30">\n</md-progress-circular></div></div></div><div layout="column" flex><div \nng-repeat="f in vm.formWizard.company.extra_data.social_responsability_files track by $index" class="border-bottom" \nflex><div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div class="size" layout="row" \nlayout-align="start left"><div class="media photos" layout="row" layout-align="center center"><h2c-icon \nfile="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" alt=""></div><div class="info ml-15" flex \nlayout="column" layout-align="center center"><div class="name" layout="row" layout-align="center center"><span \nng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu class="float-right"><md-button \nclass="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.social_responsability_files.splice($index, 1);"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></div></div></div><div class="separator-options" \nlayout="row"><h2>IVA</h2></div><div class="mv-25" layout="column"><div layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container fill-width flex><md-select \nng-model="vm.formWizard.company.extra_data.tax_options"><md-option ng-value="1">Presentaci\xF3n trimestral</md-option>\n<md-option ng-value="2">Presentaci\xF3n mensual</md-option></md-select></md-input-container><md-input-container \nfill-width flex></md-input-container></div><div layout="column" layout-gt-xs="row" layout-align="start center"><div \nfill-width><div ngf-drop ngf-select ng-model="vm.files_iva" class="drop-box" layout="column" layout-gt-xs="row" \nngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="iva_isLoading"><div flex layout="column" layout-align="center center" layout-padding layout-margin \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n</div></div><div layout="column" flex><div ng-repeat="f in vm.formWizard.company.extra_data.iva_files track by $index" \nclass="border-bottom" flex><div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size" layout="row" layout-align="start left"><div class="media photos" layout="row" \nlayout-align="center center"><h2c-icon file="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" \nalt=""></div><div class="info ml-15" flex layout="column" layout-align="center center"><div class="name" layout="row" \nlayout-align="center center"><span ng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.iva_files.splice($index, 1);"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div></div></div></div></div><div class="separator-options" layout="row"><h2>\nImpuesto de sociedades</h2></div><div class="mv-25" layout="column"><div layout="column" layout-gt-xs="row" \nlayout-align="start center"><md-input-container fill-width flex><md-datepicker \nng-model="vm.formWizard.company.extra_data.date_is" md-placeholder="Fecha"></md-datepicker></md-input-container>\n<md-input-contaimer class="md-block" flex><md-select ng-model="vm.formWizard.company.extra_data.currency_is" \nplaceholder="{{ \'GLOBAL.CURRENCY\' |\xA0translate}}"><md-option ng-repeat="currency in vm.currencies" \nng-value="currency.id">{{currency.symbol}}</md-option></md-select></md-input-contaimer><md-input-container fill-width \nflex><label translate="GLOBAL.AMOUNT_CAPITAL"></label> <input type="number" type="text" \nng-model="vm.formWizard.company.extra_data.amount_is"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-align="start center"><div fill-width><div ngf-drop ngf-select ng-model="vm.files_is" \nclass="drop-box" layout="column" layout-gt-xs="row" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" \nngf-allow-dir="true" \naccept="video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz" \nngf-pattern="\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz\'"><div \nlayout="column"><div flex><md-button class="send-button md-accent md-raised" aria-label="Select files" \ntranslate="GLOBAL.UPLOAD_DOCUMENTS"></md-button></div><div style="position: relative; height: 100px;" \nng-if="is_isLoading"><div flex layout="column" layout-align="center center" layout-padding layout-margin \nclass="loading-container"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>\n</div></div><div layout="column" flex><div ng-repeat="f in vm.formWizard.company.extra_data.is_files track by $index" \nclass="border-bottom" flex><div class="p-16" flex><div layout="row" layout-align="space-between center" flex><div \nclass="size" layout="row" layout-align="start left"><div class="media photos" layout="row" \nlayout-align="center center"><h2c-icon file="f.fileName"></h2c-icon><img ng-src="{{storagePrefix + f.fileName}}" \nalt=""></div><div class="info ml-15" flex layout="column" layout-align="center center"><div class="name" layout="row" \nlayout-align="center center"><span ng-if="f.originalFileName">{{f.originalFileName}}</span></div></div></div><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item><md-button translate="GLOBAL.REMOVE" \nng-click="vm.formWizard.company.extra_data.is_files.splice($index, 1);"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/stakeholders/views/read/form-tabs/step-people-global.html','<div layout="column" layout-gt-xs="row"><div class="mail-list-pane s0" flex="100"><div layout-gt-xs="row" \nlayout="column" class="mb-20"><div flex="20"><div layout="row" layout-align="start center" flex="100" \nclass="p-20 layout-align-start-center layout-row flex-100"><div layout="row" layout-align="start center" flex="100" \nclass="layout-align-start-center layout-row flex-100"><div class="avatar-wrapper"><md-icon md-font-icon="icon-city">\n</md-icon></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding" \nng-bind-html="vm.formWizard.main_branch.name"></strong><div class="field grey-600-fg ng-binding"><span \nng-if="vm.formWizard.main_branch.city" ng-bind-html="vm.formWizard.main_branch.city"></span> <span \nng-if="vm.formWizard.main_branch.city && vm.formWizard.main_branch.state">, </span><span \nng-if="vm.formWizard.main_branch.state" ng-bind-html="vm.formWizard.main_branch.state"></span></div></div></div></div>\n</div><div flex="80"><div layout="row" layout-align="start center"><div class="mail-list-pane s0" flex="100"><div \nclass="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="user.branch_id == vm.formWizard.main_branch.id"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId != user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong><div class="field grey-600-fg ng-binding"><span>\n{{vm.getDivisionName(user.division)[0].name}} | {{vm.getPositionName(user.position)[0].name}}</span></div></div></div>\n</div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu class="float-right">\n<md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" \nng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\', vm.formWizard.main_branch)"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div><div class="items"><div layout="row" \nlayout-align="start center" flex="100" class="pt-10 pb-10"><div class="info" flex layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><md-button \nng-click="vm.openDialogForm(\'personnel\', vm.formWizard.main_branch.id)" \nclass="md-mini add-event-button md-fab md-warn mh-0"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n</div></div></div></div></div></div></div></div></div><div layout-gt-xs="row" layout="column" class="mb-20" \nng-repeat="branch in vm.formWizard.branch" ng-if="branch.id != vm.formWizard.main_branch.id"><div flex="20"><div \nlayout="row" layout-align="start center" flex="100" class="p-20 layout-align-start-center layout-row flex-100"><div \nlayout="row" layout-align="start center" flex="100" class="layout-align-start-center layout-row flex-100"><div \nclass="avatar-wrapper"><md-icon md-font-icon="icon-city"></md-icon></div><div class="field mr-10 ml-10 flex" flex="">\n<strong class="grey-800-fg ng-binding" ng-bind-html="branch.name"></strong><div class="field grey-600-fg ng-binding">\n<span ng-if="branch.city" ng-bind-html="branch.city"></span> <span ng-if="branch.city && branch.state">, </span><span \nng-if="branch.state" ng-bind-html="branch.state"></span></div></div></div></div></div><div flex="80"><div layout="row" \nlayout-align="start center"><div class="mail-list-pane s0" flex="100"><div class="items" \nng-repeat="user in vm.formWizard.personnel track by $index" ng-if="user.branch_id == branch.id"><div layout="row" \nlayout-align="start center" flex="100" class="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" \nlayout="column"><div class="name" layout="row"><div layout="row" layout-align="start center" flex="100"><div \nclass="avatar-wrapper"><user-avatar ng-if="uploadingFotoUserId != user.id" user="user"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong><div class="field grey-600-fg ng-binding"><span>\n{{vm.getDivisionName(user.division)[0].name}} | {{vm.getPositionName(user.position)[0].name}}</span></div></div></div>\n</div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu class="float-right">\n<md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)"><md-icon \nmd-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content width="2">\n<md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\', branch)">\n<md-icon md-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div><div class="items"><div layout="row" \nlayout-align="start center" flex="100" class="pt-10 pb-10"><div class="info" flex layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><md-button \nng-click="vm.openDialogForm(\'personnel\', branch.id)" class="md-mini add-event-button md-fab md-warn mh-0"><md-icon \nmd-font-icon="icon-plus"></md-icon></md-button></div></div></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/apps/stakeholders/views/read/form-tabs/step-people.html','<div layout="column" layout-gt-xs="row"><div style="padding: 0px 15px;" flex layout="column"><h1>Direcci\xF3n</h1><div \nlayout="column" layout-gt-xs="row"><md-input-container class="group-form" flex="100" flex-gt-xs="100"><div \nlayout="row" layout-align="start center"><h2 translate="GLOBAL.LEGAL_MANAGER"></h2><md-button \nng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'managerLegal\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n<div class="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'managerLegal\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId !== user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container></div><div layout="column" \nlayout-gt-xs="row"><md-input-container class="group-form" flex="100" flex-gt-xs="100"><div layout="row" \nlayout-align="start center"><h2 translate="GLOBAL.ADMINISTRATOR"></h2><md-button \nng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'administrator\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button></div>\n<div class="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'administrator\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId !== user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container></div></div><div \nstyle="padding: 0px 15px;" flex layout="column"><h1>Compliance</h1><md-input-container class="group-form" flex="100" \nflex-gt-xs="100"><h2 translate="GLOBAL.COMPLIANCE_OFFICER" style="display: inline-block;"></h2><md-button \nng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'compliance_officer\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'compliance_officer\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId !== user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container><md-input-container \nclass="group-form" flex="100" flex-gt-xs="100"><h2 translate="GLOBAL.COLLABORATOR" style="display: inline-block;"></h2>\n<md-button ng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'collaborator\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'collaborator\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId != user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container><md-input-container \nclass="group-form" flex="100" flex-gt-xs="100"><h2 translate="GLOBAL.REPORT_COMMITTEE" style="display: inline-block;">\n</h2><md-button ng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'compliance_comite\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'compliance_comite\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId !== user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container><md-input-container \nclass="group-form" flex="100" flex-gt-xs="100"><h2 translate="GLOBAL.DELEGATE_DATA_PROTECCTION" \nstyle="display: inline-block;"></h2><md-button ng-click="vm.openDialogForm(\'personnel\',\'\',\'\',\'\',\'\',\'data_protection\')" \nclass="ml-10 md-mini add-event-button md-fab md-warn"><md-icon md-font-icon="icon-plus"></md-icon></md-button><div \nclass="mail-list-pane s0"><div class="items" ng-repeat="user in vm.formWizard.personnel track by $index" \nng-if="vm.isFromType(user,\'data_protection\')"><div layout="row" layout-align="start center" flex="100" \nclass="pt-10 pb-10"><div class="info" flex="90" layout-align="center start" layout="column"><div class="name" \nlayout="row"><div layout="row" layout-align="start center" flex="100"><div class="avatar-wrapper"><user-avatar \nng-if="uploadingFotoUserId != user.id" user="user" idx="$index"><md-progress-circular \nng-if="uploadingFotoUserId == user.id" class="md-accent" md-mode="indeterminate" md-diameter="64">\n</md-progress-circular></div><div class="field mr-10 ml-10 flex" flex=""><strong class="grey-800-fg ng-binding">\n{{user.first_name + \' \' + user.last_name + \' \'}} {{user[\'3rd_party_company_name\'] ? \'(\' + user[\'3rd_party_company_name\'] + \')\' : \'\' }}\n</strong></div></div></div></div><div class="menu" flex="10" layout-align="center end" layout="column"><md-menu \nclass="float-right"><md-button class="md-icon-button" aria-label="More" ng-click="vm.openMenu($mdMenu, $event)">\n<md-icon md-svg-icon="assets/angular-material-assets/img/icons/more_vert.svg"></md-icon></md-button><md-menu-content \nwidth="2"><md-menu-item ng-if="user.id"><md-button translate="GLOBAL.EDIT" \nng-click="vm.editUser(vm.formWizard.personnel, $index)"><md-icon md-font-icon="icon-delete" \nclass="md-default-theme md-font material-icons icon-delete"></md-icon></md-button></md-menu-item><md-menu-item>\n<md-button translate="GLOBAL.REMOVE" ng-click="vm.removeUser(vm.formWizard.personnel, $index, \'personnel\')"><md-icon \nmd-font-icon="icon-delete" class="md-default-theme md-font material-icons icon-delete"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></md-input-container></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.autocomplete/index.html','<div class="doc-content"><h1><code>material.components.autocomplete</code></h1></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.bottomSheet/index.html','<div class="doc-content"><h1><code>material.components.bottomSheet</code></h1><p>BottomSheet</p></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.button/index.html','<div class="doc-content"><h1><code>material.components.button</code></h1><p>Button</p></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.card/index.html','<div class="doc-content"><h1><code>material.components.card</code></h1><p>Card components.</p></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.checkbox/index.html','<div class="doc-content"><h1><code>material.components.checkbox</code></h1><p>Checkbox module!</p></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.content/index.html','<div class="doc-content"><h1><code>material.components.content</code></h1><p>Scrollable content</p></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.chips/index.html','<div class="doc-content"><h1><code>material.components.chips</code></h1></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.colors/index.html','<div class="doc-content"><h1><code>material.components.colors</code></h1><p>Define $mdColors service and a <code>\nmd-colors=&quot;&quot;</code> attribute directive</p></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.dialog/index.html','<div class="doc-content"><h1><code>material.components.dialog</code></h1></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.datepicker/index.html','<div class="doc-content"><h1><code>material.components.datepicker</code></h1><p>Datepicker</p></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.fabSpeedDial/index.html','<div class="doc-content"><h1><code>material.components.fabSpeedDial</code></h1></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.fabActions/index.html','<div class="doc-content"><h1><code>material.components.fabActions</code></h1></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.divider/index.html','<div class="doc-content"><h1><code>material.components.divider</code></h1><p>Divider module!</p></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.fabToolbar/index.html','<div class="doc-content"><h1><code>material.components.fabToolbar</code></h1></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.gridList/index.html','<div class="doc-content"><h1><code>material.components.gridList</code></h1></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.input/index.html','<div class="doc-content"><h1><code>material.components.input</code></h1></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.fabTrigger/index.html','<div class="doc-content"><h1><code>material.components.fabTrigger</code></h1></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.icon/index.html','<div class="doc-content"><h1><code>material.components.icon</code></h1><p>Icon</p></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.menu-bar/index.html','<div class="doc-content"><h1><code>material.components.menu-bar</code></h1></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.list/index.html','<div class="doc-content"><h1><code>material.components.list</code></h1><p>List module</p></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.menu/index.html','<div class="doc-content"><h1><code>material.components.menu</code></h1></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.navBar/index.html','<div class="doc-content"><h1><code>material.components.navBar</code></h1></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.panel/index.html','<div class="doc-content"><h1><code>material.components.panel</code></h1></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.progressCircular/index.html','<div class="doc-content"><h1><code>material.components.progressCircular</code></h1><p>Module for a circular progressbar\n</p></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.radioButton/index.html','<div class="doc-content"><h1><code>material.components.radioButton</code></h1><p>radioButton module!</p></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.progressLinear/index.html','<div class="doc-content"><h1><code>material.components.progressLinear</code></h1><p>Linear Progress module!</p></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.select/index.html','<div class="doc-content"><h1><code>material.components.select</code></h1></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.showHide/index.html','<div class="doc-content"><h1><code>material.components.showHide</code></h1></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.slider/index.html','<div class="doc-content"><h1><code>material.components.slider</code></h1></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.sidenav/index.html','<div class="doc-content"><h1><code>material.components.sidenav</code></h1><p>A Sidenav QP component.</p></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.sticky/index.html','<div class="doc-content"><h1><code>material.components.sticky</code></h1><p>Sticky effects for md</p></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.subheader/index.html','<div class="doc-content"><h1><code>material.components.subheader</code></h1><p>SubHeader module</p><p>\nSubheaders are special list tiles that delineate distinct sections of a list or grid list and are typically related to the current filtering or sorting criteria. Subheader tiles are either displayed inline with tiles or can be associated with content, for example, in an adjacent column.\n</p><p>\nUpon scrolling, subheaders remain pinned to the top of the screen and remain pinned until pushed on or off screen by the next subheader. @see \n<a href="https://www.google.com/design/spec/components/subheaders.html">Material Design Specifications</a></p>\n<blockquote><p>To improve the visual grouping of content, use the system color for your subheaders.</p></blockquote>\n</div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.switch/index.html','<div class="doc-content"><h1><code>material.components.switch</code></h1></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.tabs/index.html','<div class="doc-content"><h1><code>material.components.tabs</code></h1><p>Tabs, created with the <code>&lt;md-tabs&gt;\n</code> directive provide <em>tabbed</em>\n navigation with different styles. The Tabs component consists of clickable tabs that are aligned horizontally side-by-side.\n</p><p>Features include support for:</p><ul><li>static or dynamic tabs,</li><li>responsive designs,</li><li>\naccessibility support (ARIA),</li><li>tab pagination,</li><li>external or internal tab content,</li><li>\nfocus indicators and arrow-key navigations,</li><li>programmatic lookup and access to tab controllers, and</li><li>\ndynamic transitions through different tab contents.</li></ul></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.toast/index.html','<div class="doc-content"><h1><code>material.components.toast</code></h1><p>Toast</p></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.swipe/index.html','<div class="doc-content"><h1><code>material.components.swipe</code></h1><p>Swipe module!</p></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.toolbar/index.html','<div class="doc-content"><h1><code>material.components.toolbar</code></h1></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.whiteframe/index.html','<div class="doc-content"><h1><code>material.components.whiteframe</code></h1></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.virtualRepeat/index.html','<div class="doc-content"><h1><code>material.components.virtualRepeat</code></h1></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.tooltip/index.html','<div class="doc-content"><h1><code>material.components.tooltip</code></h1></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.core.componentRegistry/index.html','<div class="doc-content"><h1><code>material.core.componentRegistry</code></h1><p>\nA component instance registration service. Note: currently this as a private service in the SideNav component.</p>\n</div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.core.colorUtil/index.html','<div class="doc-content"><h1><code>material.core.colorUtil</code></h1><p>Color Util</p></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.core.ripple/index.html','<div class="doc-content"><h1><code>material.core.ripple</code></h1><p>Ripple</p></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.core.util/index.html','<div class="doc-content"><h1><code>material.core.util</code></h1><p>Util</p></div>');
$templateCache.put('app/main/apps/chat/sidenavs/left/views/chats/chats-view.html','<md-toolbar class="md-tall"><div class="md-toolbar-tools md-toolbar-tools-top"><div class="avatar-wrapper"><img \nng-click="vm.toggleLeftSidenavView(\'user\')" ng-src="{{vm.user.avatar}}" class="md-avatar avatar" \nalt="{{vm.user.name}}"><md-menu id="user-status-menu"><i ng-click="$mdMenu.open()" class="icon icon- s16 status" \nng-class="vm.user.status"></i><md-menu-content><md-menu-item><md-button ng-click="vm.setUserStatus(\'online\')"><div \nlayout="row" layout-align="start center"><i class="icon s16 status icon-checkbox-marked-circle mr-8 green-fg"></i> \n<span translate="CHAT.STATUS_ONLINE">Online</span></div></md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.setUserStatus(\'away\')"><div layout="row" layout-align="start center"><i \nclass="icon s16 status icon-clock mr-8 yellow-fg"></i> <span translate="CHAT.STATUS_AWAY">Away</span></div></md-button>\n</md-menu-item><md-menu-item><md-button ng-click="vm.setUserStatus(\'do-not-disturb\')"><div layout="row" \nlayout-align="start center"><i class="icon s16 status icon-minus-circle mr-8 red-fg"></i> <span \ntranslate="CHAT.STATUS_DO_NOT_DISTURB">Do not disturb</span></div></md-button></md-menu-item><md-menu-item><md-button \nng-click="vm.setUserStatus(\'offline\')"><div layout="row" layout-align="start center"><i \nclass="icon s16 status icon-checkbox-blank-circle-outline mr-8 green-fg"></i> <span translate="CHAT.STATUS_OFFLINE">\nOffline</span></div></md-button></md-menu-item></md-menu-content></md-menu></div><md-menu \nmd-position-mode="target-right target"><md-button class="md-icon-button" ng-click="$mdMenu.open()" aria-label="more">\n<md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content width="3"><md-menu-item><md-button \nng-click="vm.toggleLeftSidenavView(\'user\')" translate="CHAT.PROFILE">Profile</md-button></md-menu-item><md-menu-item>\n<md-button ng-click="" translate="CHAT.LOGOUT">Logout</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass="md-toolbar-tools md-toolbar-tools-bottom"><div class="search-wrapper md-whiteframe-1dp" layout="row" \nlayout-align="start center" flex><div class="search" flex layout="row" layout-align="start center"><md-icon \nmd-font-icon="icon-magnify" class="icon s18"></md-icon><input flex ng-model="vm.chatSearch" type="text" \nplaceholder="Search or start new chat" translate="" translate-attr-placeholder="CHAT.CHAT_SEARCH_PLACEHOLDER"></div>\n</div></div></md-toolbar><md-content flex ms-scroll><md-list class="chat-list"><div \nng-show="vm.chatSearch && filteredChat.length > 0" class="md-accent-fg subheader" \nng-style="{\'transform\':\'translate3d(0px, 0px, 0px)\', \'z-index\': filteredChat.length + filteredContact.length }" \ntranslate="CHAT.CHATS">CHATS</div><md-list-item class="contact md-3-line" \nng-style="{\'transform\': ( vm.chatSearch && filteredChat.length > 0 ) ?\'translate3d(0px, \'+($index + 1)* 100+\'%, 0px)\': \'translate3d(0px, \'+$index* 100+\'%, 0px)\', \'z-index\': filteredChat.length + filteredContact.length - $index}" \nng-repeat="contact in vm.contacts  | filter: { lastMessage:{}} | filter: {name: vm.chatSearch}  |  orderBy: \'lastMessage.time\' :true | filter:query as filteredChat" \nng-click="vm.getChat(contact.id)" ng-class="{\'unread\':contact.unread}"><div class="avatar-wrapper"><img \nng-src="{{contact.avatar}}" class="md-avatar avatar" alt="{{contact.name}}"> <i class="icon icon- s16 status" \nng-class="contact.status"></i></div><div class="md-list-item-text"><h3 class="name">{{contact.name}}</h3><p \nclass="last-message">{{contact.lastMessage.message}}</p></div><div layout="column" layout-align="center end"><div \nclass="last-message-time">{{contact.lastMessage.time | altDate}}</div><div ng-if="contact.unread" \nclass="md-accent-bg unread-message-count">{{contact.unread}}</div></div><md-divider></md-divider></md-list-item>\n</md-list><md-list class="contact-list"><div ng-show="vm.chatSearch && filteredContact.length > 0" \nclass="md-accent-fg subheader" \nng-style="{\'transform\': (filteredContact.length > 0 && filteredChat.length > 0 ) ? \'translate3d(0px, \'+(filteredChat.length +1) * 100+\'%, 0px)\':\'translate3d(0px, 0px, 0px)\', \'z-index\': filteredContact.length}" \ntranslate="CHAT.CONTACTS">CONTACTS</div><md-list-item class="contact md-3-line" ng-show="vm.chatSearch" \nng-style="{\'transform\': (filteredContact.length > 0 && filteredChat.length > 0 ) ?\'translate3d(0px, \'+(filteredChat.length + $index +2)* 100+\'%, 0px)\': \'translate3d(0px, \'+ ($index + 1)* 100+\'%, 0px)\', \'z-index\': filteredContact.length - $index}" \nng-repeat="contact in vm.contacts  | filter: { lastMessage:null} | filter: {name: vm.chatSearch} | orderBy: \'name\' :false | filter:query as filteredContact" \nng-click="vm.getChat(contact.id)"><div class="avatar-wrapper"><img ng-src="{{contact.avatar}}" \nclass="md-avatar avatar" alt="{{contact.name}}"> <i class="icon icon- s16 status" ng-class="contact.status"></i></div>\n<div class="md-list-item-text"><h3>{{contact.name}}</h3><p class="mood">{{contact.mood}}</p></div><md-divider>\n</md-divider></md-list-item></md-list><div ng-hide="(filteredChat.length + filteredContact.length) > 0" \nclass="no-results-message" translate="CHAT.NO_RESULTS">No results..</div></md-content><md-button \nclass="md-fab contacts-button" ng-click="vm.toggleLeftSidenavView(\'contacts\')" aria-label="contacts button"><md-icon \nmd-font-icon="icon-plus"></md-icon></md-button>');
$templateCache.put('app/main/apps/chat/sidenavs/left/views/contacts/contacts-view.html','<md-toolbar class="md-tall md-accent"><div class="md-toolbar-tools md-toolbar-tools-top"><md-button \nclass="md-icon-button" ng-click="vm.toggleLeftSidenavView(false)" aria-label="back button"><md-icon \nmd-font-icon="icon-arrow-left"></md-icon></md-button><h3><span translate="CHAT.CONTACTS">CONTACTS</span></h3></div><div\n class="md-toolbar-tools md-toolbar-tools-bottom"><div class="search-wrapper md-whiteframe-1dp" layout="row" \nlayout-align="start center" flex><div class="search" flex layout="row" layout-align="start center"><md-icon \nmd-font-icon="icon-magnify" class="icon s18"></md-icon><input flex ng-model="vm.contactSearch" type="text" \nplaceholder="Search contact" translate="" translate-attr-placeholder="CHAT.CONTACTS_SEARCH_PLACEHOLDER"></div></div>\n</div></md-toolbar><md-content flex ms-scroll><md-list class="contact-list"><md-list-item class="contact md-3-line" \nng-repeat="contact in vm.contacts  | filter: {name: vm.contactSearch} | orderBy: \'name\' :false | filter:query as filteredContact" \nng-style="{\'transform\': \'translate3d(0px, \'+$index * 100+\'%, 0px)\', \'z-index\': filteredContact.length - $index}" \nng-click="vm.getChat(contact.id)"><div class="fist-letter md-accent-fg" \nng-if="vm.contacts[$index].name.charAt(0) !== vm.contacts[$index-1].name.charAt(0)">{{contact.name.charAt(0)}}</div>\n<div class="avatar-wrapper"><img ng-src="{{contact.avatar}}" class="md-avatar avatar" alt="{{contact.name}}"> <i \nclass="icon icon- s16 status" ng-class="contact.status"></i></div><div class="md-list-item-text"><h3>{{contact.name}}\n</h3><p class="mood">{{contact.mood}}</p></div></md-list-item></md-list><div ng-if="filteredContact.length <= 0" \nclass="no-results-message" translate="CHAT.NO_RESULTS">No results..</div></md-content>');
$templateCache.put('app/main/apps/chat/sidenavs/left/views/user/user-view.html','<md-toolbar class="md-tall md-accent"><div class="md-toolbar-tools md-toolbar-tools-top"><md-button \nclass="md-icon-button" ng-click="vm.toggleLeftSidenavView(false)" aria-label="back"><md-icon \nmd-font-icon="icon-arrow-left"></md-icon></md-button></div><div class="md-toolbar-tools md-toolbar-tools-bottom" flex \nlayout="column" layout-align="center center"><div layout="column" layout-align="center center"><img \nng-src="{{vm.user.avatar}}" class="md-avatar avatar user-avatar huge" alt="{{vm.user.name}}"><div class="user-name">\n{{vm.user.name}}</div></div></div></md-toolbar><md-content flex ms-scroll ms-padding><md-card><md-card-title>Mood\n</md-card-title><md-card-content><span class="mood" editable-textarea="vm.user.mood" e-rows="7" e-cols="40">\n{{vm.user.mood || \'CHAT.ENTER_MOOD_MESSAGE\' | translate}}</span></md-card-content></md-card></md-content>');
$templateCache.put('app/main/apps/chat/sidenavs/right/views/contact/contact-view.html','<md-toolbar class="md-tall md-accent"><div class="md-toolbar-tools md-toolbar-tools-top"><div \ntranslate="CHAT.CONTACT_INFO">Contact Info</div><div flex></div><md-button class="md-icon-button" \nng-click="vm.toggleSidenav(\'right-sidenav\')" aria-label="back"><md-icon md-font-icon="icon-close"></md-icon>\n</md-button></div><div class="md-toolbar-tools md-toolbar-tools-bottom" flex layout="column" \nlayout-align="center center"><div layout="column" layout-align="center center"><img \nng-src="{{vm.contacts.getById(vm.chatContactId).avatar}}" class="md-avatar avatar contact-avatar huge" \nalt="{{vm.contacts.getById(vm.chatContactId).name}}"><div class="contact-name">\n{{vm.contacts.getById(vm.chatContactId).name}}</div></div></div></md-toolbar><md-content flex ms-scroll ms-padding>\n<md-card><md-card-title translate="CHAT.MOOD">Mood</md-card-title><md-card-content><span class="mood" \nng-if="vm.contacts.getById(vm.chatContactId).mood">{{vm.contacts.getById(vm.chatContactId).mood}}</span>\n</md-card-content></md-card></md-content>');
$templateCache.put('app/main/apps/clients-complaints/dialogs/media/views/templates/photo.html','<div class="ms-card-content-wrapper ng-scope"><div class="template-9"><div class="header p-16" layout="row" \nlayout-align="start center"><div ng-if="photo.avatar"><img class="avatar mr-16" ng-src="{{photo.avatar.src}}" \nalt="{{photo.avatar.alt}}"></div><div class="info"><div class="title">{{photo.title}}</div><div \nclass="subtitle secondary-text" ng-if="photo.subtitle">{{photo.subtitle}}</div></div></div><div \nclass="text ph-16 pb-16" ng-if="photo.text">{{photo.text}}</div><div class="media" flex><img \nng-src="{{photo.crop_status[0].urlformed}}" class="image"></div><div class="buttons m-8"><md-button \nclass="md-icon-button mr-16" aria-label="Favorite"><md-icon md-font-icon="icon-heart-outline" class="s24"></md-icon>\n</md-button><md-button class="md-icon-button" aria-label="Share"><md-icon md-font-icon="icon-share" class="s24">\n</md-icon></md-button><md-checkbox ng-checked="vm.alreadySelectedbyZone(vm.selectedImages, photo)" \nng-click="vm.toggleSelectedImages(photo, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, photo) ? \'Deselect\' : \'Select\'}}"></md-checkbox></div></div>\n</div>');
$templateCache.put('app/main/apps/clients-complaints/dialogs/media/views/templates/toolbar-search.html','<md-toolbar ng-if="vm.showSearchAndPaginator"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><div><md-button ng-click="vm.resetSearch()" aria-label="view type" \nclass="md-icon-button" translate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nid="ms-filters-cleaner" ng-if="vm.searchQuery == true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon>\n<md-tooltip><span>Reset search</span></md-tooltip></md-button></div><ms-search-bar-none flex \nclass="expanded ms-search-bar" debounce="300" model-search="vm.searchStringFilter" on-search="vm.searchMedia(query)" \nlayout="row" layout-align="start center"><div flex layout="row" layout-align="start center"><label \nfor="ms-search-bar-input"><md-icon id="ms-search-bar-expander" md-font-icon="icon-magnify" \nclass="md-icon-button md-button"><md-tooltip><span translate="TOOLBAR.SEARCH">Search</span></md-tooltip></md-icon>\n</label> <input id="ms-search-bar-input" type="text" ng-model="vm.modelSearch" placeholder="Search" md-autofocus \ntranslate translate-attr-placeholder="TOOLBAR.SEARCH" flex ng-enter="vm.pagination_search(vm.modelSearch)"><md-icon \nid="ms-search-bar-collapser" md-font-icon="icon-close-circle" class="icon s24"></md-icon><md-button hide show-gt-xs \nid="ms-search-bar-button" class="md-accent md-raised" ng-click="vm.pagination_search(vm.modelSearch)" \naria-label="description" md-no-ink="true" md-ripple-size="auto">Search</md-button><md-button hide show-xs \nid="ms-search-bar-button" class="md-accent md-raised md-icon-button" ng-click="vm.pagination_search(vm.modelSearch)" \nng-disabled="!vm.modelSearch" aria-label="description" md-no-ink="true" md-ripple-size="auto"><md-icon \nmd-font-icon="icon-chevron-right"></md-icon></md-button></div></ms-search-bar-none></div></md-toolbar>');
$templateCache.put('app/main/apps/clients/dialogs/media/views/templates/photo.html','<div class="ms-card-content-wrapper ng-scope"><div class="template-9"><div class="header p-16" layout="row" \nlayout-align="start center"><div ng-if="photo.avatar"><img class="avatar mr-16" ng-src="{{photo.avatar.src}}" \nalt="{{photo.avatar.alt}}"></div><div class="info"><div class="title">{{photo.title}}</div><div \nclass="subtitle secondary-text" ng-if="photo.subtitle">{{photo.subtitle}}</div></div></div><div \nclass="text ph-16 pb-16" ng-if="photo.text">{{photo.text}}</div><div class="media" flex><img \nng-src="{{photo.crop_status[0].urlformed}}" class="image"></div><div class="buttons m-8"><md-button \nclass="md-icon-button mr-16" aria-label="Favorite"><md-icon md-font-icon="icon-heart-outline" class="s24"></md-icon>\n</md-button><md-button class="md-icon-button" aria-label="Share"><md-icon md-font-icon="icon-share" class="s24">\n</md-icon></md-button><md-checkbox ng-checked="vm.alreadySelectedbyZone(vm.selectedImages, photo)" \nng-click="vm.toggleSelectedImages(photo, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, photo) ? \'Deselect\' : \'Select\'}}"></md-checkbox></div></div>\n</div>');
$templateCache.put('app/main/apps/clients/dialogs/media/views/templates/toolbar-search.html','<md-toolbar ng-if="vm.showSearchAndPaginator"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><div><md-button ng-click="vm.resetSearch()" aria-label="view type" \nclass="md-icon-button" translate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nid="ms-filters-cleaner" ng-if="vm.searchQuery == true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon>\n<md-tooltip><span>Reset search</span></md-tooltip></md-button></div><ms-search-bar-none flex \nclass="expanded ms-search-bar" debounce="300" model-search="vm.searchStringFilter" on-search="vm.searchMedia(query)" \nlayout="row" layout-align="start center"><div flex layout="row" layout-align="start center"><label \nfor="ms-search-bar-input"><md-icon id="ms-search-bar-expander" md-font-icon="icon-magnify" \nclass="md-icon-button md-button"><md-tooltip><span translate="TOOLBAR.SEARCH">Search</span></md-tooltip></md-icon>\n</label> <input id="ms-search-bar-input" type="text" ng-model="vm.modelSearch" placeholder="Search" md-autofocus \ntranslate translate-attr-placeholder="TOOLBAR.SEARCH" flex ng-enter="vm.pagination_search(vm.modelSearch)"><md-icon \nid="ms-search-bar-collapser" md-font-icon="icon-close-circle" class="icon s24"></md-icon><md-button hide show-gt-xs \nid="ms-search-bar-button" class="md-accent md-raised" ng-click="vm.pagination_search(vm.modelSearch)" \naria-label="description" md-no-ink="true" md-ripple-size="auto">Search</md-button><md-button hide show-xs \nid="ms-search-bar-button" class="md-accent md-raised md-icon-button" ng-click="vm.pagination_search(vm.modelSearch)" \nng-disabled="!vm.modelSearch" aria-label="description" md-no-ink="true" md-ripple-size="auto"><md-icon \nmd-font-icon="icon-chevron-right"></md-icon></md-button></div></ms-search-bar-none></div></md-toolbar>');
$templateCache.put('app/main/apps/proyects/dialogs/media/views/templates/photo.html','<div class="ms-card-content-wrapper ng-scope"><div class="template-9"><div class="header p-16" layout="row" \nlayout-align="start center"><div ng-if="photo.avatar"><img class="avatar mr-16" ng-src="{{photo.avatar.src}}" \nalt="{{photo.avatar.alt}}"></div><div class="info"><div class="title">{{photo.title}}</div><div \nclass="subtitle secondary-text" ng-if="photo.subtitle">{{photo.subtitle}}</div></div></div><div \nclass="text ph-16 pb-16" ng-if="photo.text">{{photo.text}}</div><div class="media" flex><img \nng-src="{{photo.crop_status[0].urlformed}}" class="image"></div><div class="buttons m-8"><md-button \nclass="md-icon-button mr-16" aria-label="Favorite"><md-icon md-font-icon="icon-heart-outline" class="s24"></md-icon>\n</md-button><md-button class="md-icon-button" aria-label="Share"><md-icon md-font-icon="icon-share" class="s24">\n</md-icon></md-button><md-checkbox ng-checked="vm.alreadySelectedbyZone(vm.selectedImages, photo)" \nng-click="vm.toggleSelectedImages(photo, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, photo) ? \'Deselect\' : \'Select\'}}"></md-checkbox></div></div>\n</div>');
$templateCache.put('app/main/apps/proyects/dialogs/media/views/templates/toolbar-search.html','<md-toolbar ng-if="vm.showSearchAndPaginator"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><div><md-button ng-click="vm.resetSearch()" aria-label="view type" \nclass="md-icon-button" translate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nid="ms-filters-cleaner" ng-if="vm.searchQuery == true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon>\n<md-tooltip><span>Reset search</span></md-tooltip></md-button></div><ms-search-bar-none flex \nclass="expanded ms-search-bar" debounce="300" model-search="vm.searchStringFilter" on-search="vm.searchMedia(query)" \nlayout="row" layout-align="start center"><div flex layout="row" layout-align="start center"><label \nfor="ms-search-bar-input"><md-icon id="ms-search-bar-expander" md-font-icon="icon-magnify" \nclass="md-icon-button md-button"><md-tooltip><span translate="TOOLBAR.SEARCH">Search</span></md-tooltip></md-icon>\n</label> <input id="ms-search-bar-input" type="text" ng-model="vm.modelSearch" placeholder="Search" md-autofocus \ntranslate translate-attr-placeholder="TOOLBAR.SEARCH" flex ng-enter="vm.pagination_search(vm.modelSearch)"><md-icon \nid="ms-search-bar-collapser" md-font-icon="icon-close-circle" class="icon s24"></md-icon><md-button hide show-gt-xs \nid="ms-search-bar-button" class="md-accent md-raised" ng-click="vm.pagination_search(vm.modelSearch)" \naria-label="description" md-no-ink="true" md-ripple-size="auto">Search</md-button><md-button hide show-xs \nid="ms-search-bar-button" class="md-accent md-raised md-icon-button" ng-click="vm.pagination_search(vm.modelSearch)" \nng-disabled="!vm.modelSearch" aria-label="description" md-no-ink="true" md-ripple-size="auto"><md-icon \nmd-font-icon="icon-chevron-right"></md-icon></md-button></div></ms-search-bar-none></div></md-toolbar>');
$templateCache.put('app/main/apps/items/dialogs/media/views/templates/photo.html','<div class="ms-card-content-wrapper ng-scope"><div class="template-9"><div class="header p-16" layout="row" \nlayout-align="start center"><div ng-if="photo.avatar"><img class="avatar mr-16" ng-src="{{photo.avatar.src}}" \nalt="{{photo.avatar.alt}}"></div><div class="info"><div class="title">{{photo.title}}</div><div \nclass="subtitle secondary-text" ng-if="photo.subtitle">{{photo.subtitle}}</div></div></div><div \nclass="text ph-16 pb-16" ng-if="photo.text">{{photo.text}}</div><div class="media" flex><img \nng-src="{{photo.crop_status[0].urlformed}}" class="image"></div><div class="buttons m-8"><md-button \nclass="md-icon-button mr-16" aria-label="Favorite"><md-icon md-font-icon="icon-heart-outline" class="s24"></md-icon>\n</md-button><md-button class="md-icon-button" aria-label="Share"><md-icon md-font-icon="icon-share" class="s24">\n</md-icon></md-button><md-checkbox ng-checked="vm.alreadySelectedbyZone(vm.selectedImages, photo)" \nng-click="vm.toggleSelectedImages(photo, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, photo) ? \'Deselect\' : \'Select\'}}"></md-checkbox></div></div>\n</div>');
$templateCache.put('app/main/apps/items/dialogs/media/views/templates/toolbar-search.html','<md-toolbar ng-if="vm.showSearchAndPaginator"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><div><md-button ng-click="vm.resetSearch()" aria-label="view type" \nclass="md-icon-button" translate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nid="ms-filters-cleaner" ng-if="vm.searchQuery == true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon>\n<md-tooltip><span>Reset search</span></md-tooltip></md-button></div><ms-search-bar-none flex \nclass="expanded ms-search-bar" debounce="300" model-search="vm.searchStringFilter" on-search="vm.searchMedia(query)" \nlayout="row" layout-align="start center"><div flex layout="row" layout-align="start center"><label \nfor="ms-search-bar-input"><md-icon id="ms-search-bar-expander" md-font-icon="icon-magnify" \nclass="md-icon-button md-button"><md-tooltip><span translate="TOOLBAR.SEARCH">Search</span></md-tooltip></md-icon>\n</label> <input id="ms-search-bar-input" type="text" ng-model="vm.modelSearch" placeholder="Search" md-autofocus \ntranslate translate-attr-placeholder="TOOLBAR.SEARCH" flex ng-enter="vm.pagination_search(vm.modelSearch)"><md-icon \nid="ms-search-bar-collapser" md-font-icon="icon-close-circle" class="icon s24"></md-icon><md-button hide show-gt-xs \nid="ms-search-bar-button" class="md-accent md-raised" ng-click="vm.pagination_search(vm.modelSearch)" \naria-label="description" md-no-ink="true" md-ripple-size="auto">Search</md-button><md-button hide show-xs \nid="ms-search-bar-button" class="md-accent md-raised md-icon-button" ng-click="vm.pagination_search(vm.modelSearch)" \nng-disabled="!vm.modelSearch" aria-label="description" md-no-ink="true" md-ripple-size="auto"><md-icon \nmd-font-icon="icon-chevron-right"></md-icon></md-button></div></ms-search-bar-none></div></md-toolbar>');
$templateCache.put('app/main/apps/questions/dialogs/media/views/templates/photo.html','<div class="ms-card-content-wrapper ng-scope"><div class="template-9"><div class="header p-16" layout="row" \nlayout-align="start center"><div ng-if="photo.avatar"><img class="avatar mr-16" ng-src="{{photo.avatar.src}}" \nalt="{{photo.avatar.alt}}"></div><div class="info"><div class="title">{{photo.title}}</div><div \nclass="subtitle secondary-text" ng-if="photo.subtitle">{{photo.subtitle}}</div></div></div><div \nclass="text ph-16 pb-16" ng-if="photo.text">{{photo.text}}</div><div class="media" flex><img \nng-src="{{photo.crop_status[0].urlformed}}" class="image"></div><div class="buttons m-8"><md-button \nclass="md-icon-button mr-16" aria-label="Favorite"><md-icon md-font-icon="icon-heart-outline" class="s24"></md-icon>\n</md-button><md-button class="md-icon-button" aria-label="Share"><md-icon md-font-icon="icon-share" class="s24">\n</md-icon></md-button><md-checkbox ng-checked="vm.alreadySelectedbyZone(vm.selectedImages, photo)" \nng-click="vm.toggleSelectedImages(photo, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, photo) ? \'Deselect\' : \'Select\'}}"></md-checkbox></div></div>\n</div>');
$templateCache.put('app/main/apps/questions/dialogs/media/views/templates/toolbar-search.html','<md-toolbar ng-if="vm.showSearchAndPaginator"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><div><md-button ng-click="vm.resetSearch()" aria-label="view type" \nclass="md-icon-button" translate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nid="ms-filters-cleaner" ng-if="vm.searchQuery == true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon>\n<md-tooltip><span>Reset search</span></md-tooltip></md-button></div><ms-search-bar-none flex \nclass="expanded ms-search-bar" debounce="300" model-search="vm.searchStringFilter" on-search="vm.searchMedia(query)" \nlayout="row" layout-align="start center"><div flex layout="row" layout-align="start center"><label \nfor="ms-search-bar-input"><md-icon id="ms-search-bar-expander" md-font-icon="icon-magnify" \nclass="md-icon-button md-button"><md-tooltip><span translate="TOOLBAR.SEARCH">Search</span></md-tooltip></md-icon>\n</label> <input id="ms-search-bar-input" type="text" ng-model="vm.modelSearch" placeholder="Search" md-autofocus \ntranslate translate-attr-placeholder="TOOLBAR.SEARCH" flex ng-enter="vm.pagination_search(vm.modelSearch)"><md-icon \nid="ms-search-bar-collapser" md-font-icon="icon-close-circle" class="icon s24"></md-icon><md-button hide show-gt-xs \nid="ms-search-bar-button" class="md-accent md-raised" ng-click="vm.pagination_search(vm.modelSearch)" \naria-label="description" md-no-ink="true" md-ripple-size="auto">Search</md-button><md-button hide show-xs \nid="ms-search-bar-button" class="md-accent md-raised md-icon-button" ng-click="vm.pagination_search(vm.modelSearch)" \nng-disabled="!vm.modelSearch" aria-label="description" md-no-ink="true" md-ripple-size="auto"><md-icon \nmd-font-icon="icon-chevron-right"></md-icon></md-button></div></ms-search-bar-none></div></md-toolbar>');
$templateCache.put('app/main/apps/riskconfig/dialogs/media/views/templates/photo.html','<div class="ms-card-content-wrapper ng-scope"><div class="template-9"><div class="header p-16" layout="row" \nlayout-align="start center"><div ng-if="photo.avatar"><img class="avatar mr-16" ng-src="{{photo.avatar.src}}" \nalt="{{photo.avatar.alt}}"></div><div class="info"><div class="title">{{photo.title}}</div><div \nclass="subtitle secondary-text" ng-if="photo.subtitle">{{photo.subtitle}}</div></div></div><div \nclass="text ph-16 pb-16" ng-if="photo.text">{{photo.text}}</div><div class="media" flex><img \nng-src="{{photo.crop_status[0].urlformed}}" class="image"></div><div class="buttons m-8"><md-button \nclass="md-icon-button mr-16" aria-label="Favorite"><md-icon md-font-icon="icon-heart-outline" class="s24"></md-icon>\n</md-button><md-button class="md-icon-button" aria-label="Share"><md-icon md-font-icon="icon-share" class="s24">\n</md-icon></md-button><md-checkbox ng-checked="vm.alreadySelectedbyZone(vm.selectedImages, photo)" \nng-click="vm.toggleSelectedImages(photo, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, photo) ? \'Deselect\' : \'Select\'}}"></md-checkbox></div></div>\n</div>');
$templateCache.put('app/main/apps/riskconfig/dialogs/media/views/templates/toolbar-search.html','<md-toolbar ng-if="vm.showSearchAndPaginator"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><div><md-button ng-click="vm.resetSearch()" aria-label="view type" \nclass="md-icon-button" translate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nid="ms-filters-cleaner" ng-if="vm.searchQuery == true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon>\n<md-tooltip><span>Reset search</span></md-tooltip></md-button></div><ms-search-bar-none flex \nclass="expanded ms-search-bar" debounce="300" model-search="vm.searchStringFilter" on-search="vm.searchMedia(query)" \nlayout="row" layout-align="start center"><div flex layout="row" layout-align="start center"><label \nfor="ms-search-bar-input"><md-icon id="ms-search-bar-expander" md-font-icon="icon-magnify" \nclass="md-icon-button md-button"><md-tooltip><span translate="TOOLBAR.SEARCH">Search</span></md-tooltip></md-icon>\n</label> <input id="ms-search-bar-input" type="text" ng-model="vm.modelSearch" placeholder="Search" md-autofocus \ntranslate translate-attr-placeholder="TOOLBAR.SEARCH" flex ng-enter="vm.pagination_search(vm.modelSearch)"><md-icon \nid="ms-search-bar-collapser" md-font-icon="icon-close-circle" class="icon s24"></md-icon><md-button hide show-gt-xs \nid="ms-search-bar-button" class="md-accent md-raised" ng-click="vm.pagination_search(vm.modelSearch)" \naria-label="description" md-no-ink="true" md-ripple-size="auto">Search</md-button><md-button hide show-xs \nid="ms-search-bar-button" class="md-accent md-raised md-icon-button" ng-click="vm.pagination_search(vm.modelSearch)" \nng-disabled="!vm.modelSearch" aria-label="description" md-no-ink="true" md-ripple-size="auto"><md-icon \nmd-font-icon="icon-chevron-right"></md-icon></md-button></div></ms-search-bar-none></div></md-toolbar>');
$templateCache.put('app/main/apps/stakeholders/dialogs/media/views/templates/photo.html','<div class="ms-card-content-wrapper ng-scope"><div class="template-9"><div class="header p-16" layout="row" \nlayout-align="start center"><div ng-if="photo.avatar"><img class="avatar mr-16" ng-src="{{photo.avatar.src}}" \nalt="{{photo.avatar.alt}}"></div><div class="info"><div class="title">{{photo.title}}</div><div \nclass="subtitle secondary-text" ng-if="photo.subtitle">{{photo.subtitle}}</div></div></div><div \nclass="text ph-16 pb-16" ng-if="photo.text">{{photo.text}}</div><div class="media" flex><img \nng-src="{{photo.crop_status[0].urlformed}}" class="image"></div><div class="buttons m-8"><md-button \nclass="md-icon-button mr-16" aria-label="Favorite"><md-icon md-font-icon="icon-heart-outline" class="s24"></md-icon>\n</md-button><md-button class="md-icon-button" aria-label="Share"><md-icon md-font-icon="icon-share" class="s24">\n</md-icon></md-button><md-checkbox ng-checked="vm.alreadySelectedbyZone(vm.selectedImages, photo)" \nng-click="vm.toggleSelectedImages(photo, $event)" \naria-label="{{vm.alreadySelectedbyZone(vm.selectedImages, photo) ? \'Deselect\' : \'Select\'}}"></md-checkbox></div></div>\n</div>');
$templateCache.put('app/main/apps/stakeholders/dialogs/media/views/templates/toolbar-search.html','<md-toolbar ng-if="vm.showSearchAndPaginator"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><div><md-button ng-click="vm.resetSearch()" aria-label="view type" \nclass="md-icon-button" translate="" translate-attr-aria-label="GLOBAL.FILTERS" class="md-icon-button" \nid="ms-filters-cleaner" ng-if="vm.searchQuery == true"><md-icon md-font-icon="icon-filter-remove-outline"></md-icon>\n<md-tooltip><span>Reset search</span></md-tooltip></md-button></div><ms-search-bar-none flex \nclass="expanded ms-search-bar" debounce="300" model-search="vm.searchStringFilter" on-search="vm.searchMedia(query)" \nlayout="row" layout-align="start center"><div flex layout="row" layout-align="start center"><label \nfor="ms-search-bar-input"><md-icon id="ms-search-bar-expander" md-font-icon="icon-magnify" \nclass="md-icon-button md-button"><md-tooltip><span translate="TOOLBAR.SEARCH">Search</span></md-tooltip></md-icon>\n</label> <input id="ms-search-bar-input" type="text" ng-model="vm.modelSearch" placeholder="Search" md-autofocus \ntranslate translate-attr-placeholder="TOOLBAR.SEARCH" flex ng-enter="vm.pagination_search(vm.modelSearch)"><md-icon \nid="ms-search-bar-collapser" md-font-icon="icon-close-circle" class="icon s24"></md-icon><md-button hide show-gt-xs \nid="ms-search-bar-button" class="md-accent md-raised" ng-click="vm.pagination_search(vm.modelSearch)" \naria-label="description" md-no-ink="true" md-ripple-size="auto">Search</md-button><md-button hide show-xs \nid="ms-search-bar-button" class="md-accent md-raised md-icon-button" ng-click="vm.pagination_search(vm.modelSearch)" \nng-disabled="!vm.modelSearch" aria-label="description" md-no-ink="true" md-ripple-size="auto"><md-icon \nmd-font-icon="icon-chevron-right"></md-icon></md-button></div></ms-search-bar-none></div></md-toolbar>');
$templateCache.put('app/main/apps/scrumboard/sidenavs/settings/menus/color/color-menu.html','<div class="header md-whiteframe-2dp"><md-list><md-list-item class="selected-color"><p class="title" flex>\nSelected Color:</p><div ng-if="!vm.board.settings.color" class="preview md-background-bg md-hue-1"></div><div \nng-if="vm.board.settings.color" class="preview" ng-class="\'md-\'+vm.board.settings.color+\'-bg\'">\n{{vm.board.settings.color}}</div><md-button class="md-icon-button" ng-click="vm.board.settings.color = \'\'" \naria-label="Default Color"><md-icon md-font-icon="icon-close-circle"></md-icon></md-button></md-list-item></md-list>\n</div><div flex class="content" ms-scroll ms-sidenav-helper><md-list><md-list-item class="color" \nng-repeat="(paletteName, palette) in vm.palettes" ng-click="vm.board.settings.color = paletteName" \nng-class="\'md-\'+paletteName+\'-bg\'" aria-label="color select"><p flex>{{paletteName}}</p><i class="icon-check s16" \nng-if="paletteName === vm.board.settings.color"></i></md-list-item></md-list></div>');
$templateCache.put('app/main/apps/scrumboard/sidenavs/settings/menus/labels/labels-menu.html','<md-list><md-subheader class="md-no-sticky">Add New Label</md-subheader><md-list-item class="label"><div layout="row" \nlayout-align="start center"><md-menu md-offset="0 52px"><md-button class="md-icon-button label-color-button" \nng-click="$mdMenu.open($event)" aria-label="label color"><md-icon md-font-icon="icon-label" \nng-class="vm.newLabelColor+\'-fg\'" class="label-icon"></md-icon></md-button><md-menu-content \nclass="labels-settings-menu-content" width="3"><div class="new-label-color-pick" layout="row" layout-wrap><label \nclass="color" ng-repeat="(palette, hues) in vm.palettes" \nng-style="{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}" layout="column" \nlayout-align="center center"><input class="ng-hide" type="radio" ng-model="vm.newLabelColor" ng-value="palette" \naria-label="{{palette}}" ng-click="$mdMenu.hide()"> <i class="icon-check s18" ng-if="label.color === palette"></i>\n</label></div></md-menu-content></md-menu><span editable-text="vm.newLabelName" e-form="newLabelForm" \nonaftersave="vm.addNewLabel()"></span><p flex class="title new-label-form-button" ng-click="newLabelForm.$show()" \nng-hide="newLabelForm.$visible">Enter New Label Name</p></div></md-list-item><md-divider></md-divider><md-list-item \nclass="label" ng-repeat="label in vm.board.labels"><div layout="row" layout-align="start center"><md-menu \nmd-offset="0 52px"><md-button class="md-icon-button label-color-button" ng-click="$mdMenu.open($event)" \naria-label="label color"><md-icon md-font-icon="icon-label" ng-class="label.color+\'-fg\'" class="label-icon"></md-icon>\n</md-button><md-menu-content class="labels-settings-menu-content" width="3"><div class="new-label-color-pick" \nlayout="row" layout-wrap><label class="color" ng-repeat="(palette, hues) in vm.palettes" \nng-style="{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}" layout="column" \nlayout-align="center center"><input class="ng-hide" type="radio" ng-model="label.color" ng-value="palette" \naria-label="{{palette}}" ng-click="$mdMenu.hide()"> <i class="icon-check s18" ng-if="label.color === palette"></i>\n</label></div></md-menu-content></md-menu><p flex class="title" editable-text="label.name">{{label.name}}</p><md-button\n ng-click="vm.removeLabel($event, label.id);" class="remove-button md-icon-button" aria-label="remove"><md-icon \nmd-font-icon="icon-delete"></md-icon></md-button></div></md-list-item></md-list>');
$templateCache.put('app/main/apps/scrumboard/sidenavs/settings/menus/members/members-menu.html','<md-list><md-subheader class="md-no-sticky">Add New Member</md-subheader><md-list-item class="add-new-member"><form \nng-submit="vm.newMember()" layout="row" layout-align="start center"><input flex placeholder="Type Member Name" \ntype="text" ng-model="vm.newMemberSearchInput"><md-button type="submit" class="md-accent md-raised" \naria-label="Add New Member">Add</md-button></form></md-list-item><md-divider></md-divider><md-list-item class="member" \nng-repeat="member in vm.board.members"><img alt="{{ member.name }}" ng-src="{{ member.avatar }}" class="md-avatar"><p \nclass="member-name">{{ member.name }}</p><md-button ng-click="vm.removeMember($event, member.id);" \nclass="remove-button md-icon-button" aria-label="remove"><md-icon md-font-icon="icon-delete"></md-icon></md-button>\n</md-list-item></md-list>');
$templateCache.put('app/main/apps/scrumboard/views/calendar/dialogs/event/event-dialog.html','<md-dialog class="event-calendar-dialog" aria-label="Event Dialog" ng-cloak><md-toolbar class="md-accent" \nng-class="\'md-\'+vm.board.settings.color+\'-bg\'"><div class="md-toolbar-tools"><h2 class="title">\n{{vm.dueDate | date:\'mediumDate\':\'UTC\'}}</h2><span flex></span><md-button class="md-icon-button" \nng-click="vm.closeDialog()" aria-label="close dialog"><md-icon md-font-icon="icon-close" aria-label="Close dialog">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-tabs md-dynamic-height><md-tab><md-tab-label>\n<span translate="SB.ADD_A_CARD">Add a card</span></md-tab-label><md-tab-body><div class="new-card" layout="column">\n<form name="newCardForm" novalidate><md-input-container class="new-card-name md-block" md-no-float><input name="name" \nng-model="vm.newCard.name" placeholder="Card name" required><div ng-messages="newCardForm.name.$error" role="alert">\n<div ng-message="required"><span translate="SB.ERRORS.TITLE_REQUIRED">Title field is required</span></div></div>\n</md-input-container><div class="lists"><p>Select a list:</p><md-radio-group ng-model="vm.newCard.listId" required>\n<md-radio-button ng-repeat="list in vm.board.lists" ng-value="list.id">{{list.name}}</md-radio-button></md-radio-group>\n</div><md-dialog-actions><md-button class="md-accent md-raised" ng-click="vm.addNewCard()" \nng-disabled="newCardForm.$invalid || newCardForm.$pristine">Add</md-button></md-dialog-actions></form></div>\n</md-tab-body></md-tab><md-tab><md-tab-label><span translate="SB.ASSIGN_THE_DATE_TO_CARDS">Assign the date to cards\n</span></md-tab-label><md-tab-body><div class="assign-due-date"><md-list class="cards"><md-content \nclass="cards-content" flex ms-scroll><md-list-item class="card" ng-repeat="card in vm.board.cards" \nng-click="vm.toggleInArray(card.id, vm.selectedCards)" aria-label="card"><p layout="column" layout-align="start start">\n<span class="card-name">{{card.name}}</span> <span ng-if="card.due" class="card-date">{{card.due | date}}</span></p>\n<md-checkbox ng-checked="vm.exists(card.id, vm.selectedCards)" ng-click="vm.toggleInArray(card.id, vm.selectedCards)" \nclass="md-secondary" aria-label="card"></md-checkbox></md-list-item></md-content></md-list><md-dialog-actions>\n<md-button ng-disabled="!vm.selectedCards[0]" ng-click="vm.assignDueDate()" class="md-accent md-raised">Assign\n</md-button></md-dialog-actions></div></md-tab-body></md-tab></md-tabs></md-dialog-content></md-dialog>');
$templateCache.put('app/main/apps/scrumboard/views/calendar/sidenavs/scheduled-tasks/scheduled-tasks-sidenav.html','<div class="md-title sidenav-title">Scheduled Cards</div><div class="cards"><div ng-if="vm.cards.length <= 0"><span \ntranslate="SB.NO_SCHEDULED_CARD">There is no scheduled card.</span></div><div class="card" layout="row" \nng-repeat="card in vm.cards"><md-button class="md-raised card-date" ng-click="vm.goToDate(card.start)"><div \nclass="day-in-week">{{card.due | date:\'EEEE\'}}</div><div class="day">{{card.due | date:\'d\' }}</div><div \nclass="month-year">{{card.due | date:\'MMM yyyy\'}}</div></md-button><div class="card-title" flex layout="column" \nlayout-align="center start" ng-click="vm.openCardDialog($event, card.idCard)"><span>{{card.title}}</span></div></div>\n</div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.backdrop/directive/mdBackdrop.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p><code>&lt;md-backdrop&gt;</code>\n is a backdrop element used by other components, such as dialog and bottom sheet. Apply class <code>opaque</code>\n to make the backdrop use the theme backdrop color.</p></div><div><section class="api-section"><h2 id="Usage">Usage\n</h2><ul><li>as element:<pre><code>&lt;md-backdrop&gt;&#13;&#10;...&#13;&#10;&lt;/md-backdrop&gt;&#13;</code></pre>\n</li></ul></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.autocomplete/directive/mdAutocomplete.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p><code>&lt;md-autocomplete&gt;</code>\n is a special input component with a drop-down of all possible matches to a custom query. This component allows you to provide real-time suggestions as the user types in the input area.\n</p><p>\nTo start, you will need to specify the required parameters and provide a template for your results. The content inside \n<code>md-autocomplete</code> will be treated as a template.</p><p>\nIn more complex cases, you may want to include other content such as a message to display when no matches were found. You can do this by wrapping your template in \n<code>md-item-template</code> and adding a tag for <code>md-not-found</code>. An example of this is shown below.</p><h3\n id="validation">Validation</h3><p>You can use <code>ng-messages</code>\n to include validation the same way that you would normally validate; however, if you want to replicate a standard input with a floating label, you will have to do the following:\n</p><ul><li>Make sure that your template is wrapped in <code>md-item-template</code></li><li>Add your <code>ng-messages\n</code> code inside of <code>md-autocomplete</code></li><li>Add your validation properties to <code>md-autocomplete\n</code> (ie. <code>required</code>)</li><li>Add a <code>name</code> to <code>md-autocomplete</code>\n (to be used on the generated <code>input</code>)</li></ul><p>There is an example below of how this should look.</p>\n</div><div><section class="api-section"><h2 id="Usage">Usage</h2><h3 id="basic-example">Basic Example</h3><hljs \nlang="html"><md-autocomplete md-selected-item="selectedItem" md-search-text="searchText" \nmd-items="item in getMatches(searchText)" md-item-text="item.display"><span md-highlight-text="searchText">\n{{item.display}}</span></md-autocomplete></hljs><h3 id="example-with-not-found-message">\nExample with &quot;not found&quot; message</h3><hljs lang="html"><md-autocomplete md-selected-item="selectedItem" \nmd-search-text="searchText" md-items="item in getMatches(searchText)" md-item-text="item.display"><md-item-template>\n<span md-highlight-text="searchText">{{item.display}}</span></md-item-template><md-not-found>No matches found.\n</md-not-found></md-autocomplete></hljs><p>In this example, our code utilizes <code>md-item-template</code> and <code>\nmd-not-found</code> to specify the different parts that make up our component.</p><h3 id="example-with-validation">\nExample with validation</h3><hljs lang="html"><form name="autocompleteForm"><md-autocomplete required \nmd-input-name="autocomplete" md-selected-item="selectedItem" md-search-text="searchText" \nmd-items="item in getMatches(searchText)" md-item-text="item.display"><md-item-template><span \nmd-highlight-text="searchText">{{item.display}}</span></md-item-template><div \nng-messages="autocompleteForm.autocomplete.$error"><div ng-message="required">This field is required</div></div>\n</md-autocomplete></form></hljs><p>In this example, our code utilizes <code>md-item-template</code> and <code>\nng-messages</code> to specify input validation for the field.</p></section><div class="api-param-section"><h2>\nAttributes</h2><div class="api-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;"><b>* md-items</b> \n<span hide show-sm><code class="api-type label type-hint type-hint-expression">expression</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-expression">expression</code></td><td \nclass="description"><p>An expression in the format of <code>item in items</code>\n to iterate over matches for your search.</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">\nmd-selected-item-change <span hide show-sm><code class="api-type label type-hint type-hint-expression">expression\n</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-expression">\nexpression</code></td><td class="description"><p>An expression to be run each time a new item is selected</p></td></tr>\n<tr class="api-params-item"><td style="white-space: nowrap;">md-search-text-change <span hide show-sm><code \nclass="api-type label type-hint type-hint-expression">expression</code></span></td><td style="white-space: nowrap;">\n<code class="api-type label type-hint type-hint-expression">expression</code></td><td class="description"><p>\nAn expression to be run each time the search text updates</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-search-text <span hide show-sm><code \nclass="api-type label type-hint type-hint-expression">expression</code></span></td><td style="white-space: nowrap;">\n<code class="api-type label type-hint type-hint-expression">expression</code></td><td class="description"><p>\nA model to bind the search query text to</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">\nmd-selected-item <span hide show-sm><code class="api-type label type-hint type-hint-object">object</code></span></td>\n<td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-object">object</code></td><td \nclass="description"><p>A model to bind the selected item to</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-item-text <span hide show-sm><code \nclass="api-type label type-hint type-hint-expression">expression</code></span></td><td style="white-space: nowrap;">\n<code class="api-type label type-hint type-hint-expression">expression</code></td><td class="description"><p>\nAn expression that will convert your object to a single string.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">placeholder <span hide show-sm><code class="api-type label type-hint type-hint-string">\nstring</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">\nstring</code></td><td class="description"><p>Placeholder text that will be forwarded to the input.</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">md-no-cache <span hide show-sm><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>\nDisables the internal caching that happens in autocomplete</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">ng-disabled <span hide show-sm><code class="api-type label type-hint type-hint-boolean">\nboolean</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-boolean">\nboolean</code></td><td class="description"><p>Determines whether or not to disable the input field</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">md-min-length <span hide show-sm><code \nclass="api-type label type-hint type-hint-number">number</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-number">number</code></td><td class="description"><p>\nSpecifies the minimum length of text before autocomplete will make suggestions</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">md-delay <span hide show-sm><code \nclass="api-type label type-hint type-hint-number">number</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-number">number</code></td><td class="description"><p>\nSpecifies the amount of time (in milliseconds) to wait before looking for results</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">md-autofocus <span hide show-sm><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>\nIf true, the autocomplete will be automatically focused when a <code>$mdDialog</code>, <code>$mdBottomsheet</code> or \n<code>$mdSidenav</code>, which contains the autocomplete, is opening.<br><br>\nAlso the autocomplete will immediately focus the input element.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-no-asterisk <span hide show-sm><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>\nWhen present, asterisk will not be appended to the floating label</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-autoselect <span hide show-sm><code class="api-type label type-hint type-hint-boolean">\nboolean</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-boolean">\nboolean</code></td><td class="description"><p>If true, the first item will be selected by default</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">md-menu-class <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nThis will be applied to the dropdown menu for styling</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-floating-label <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nThis will add a floating label to autocomplete and wrap it in <code>md-input-container</code></p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">md-input-name <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nThe name attribute given to the input element to be used with FormController</p></td></tr><tr class="api-params-item">\n<td style="white-space: nowrap;">md-select-on-focus <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nWhen present the inputs text will be automatically selected on focus.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-input-id <span hide show-sm><code class="api-type label type-hint type-hint-string">\nstring</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">\nstring</code></td><td class="description"><p>An ID to be added to the input element</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">md-input-minlength <span hide show-sm><code \nclass="api-type label type-hint type-hint-number">number</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-number">number</code></td><td class="description"><p>\nThe minimum length for the input&#39;s value for validation</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-input-maxlength <span hide show-sm><code \nclass="api-type label type-hint type-hint-number">number</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-number">number</code></td><td class="description"><p>\nThe maximum length for the input&#39;s value for validation</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-select-on-match <span hide show-sm><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>\nWhen set, autocomplete will automatically select exact the item if the search text is an exact match</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">md-match-case-insensitive <span hide show-sm><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>When set and using \n<code>md-select-on-match</code>, autocomplete will select on case-insensitive match</p></td></tr></tbody></table></div>\n</div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.autocomplete/directive/mdHighlightText.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>The <code>md-highlight-text</code>\n directive allows you to specify text that should be highlighted within an element. Highlighted text will be wrapped in \n<code>&lt;span class=&quot;highlight&quot;&gt;&lt;/span&gt;</code>\n which can be styled through CSS. Please note that child elements may not be used with this directive.</p></div><div>\n<section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="html"><input placeholder="Enter a search term..." \nng-model="searchTerm" type="text"><ul><li ng-repeat="result in results" md-highlight-text="searchTerm">{{result.text}}\n</li></ul></hljs></section><div class="api-param-section"><h2>Attributes</h2><div class="api-param-table"><table \nclass="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass="api-params-item"><td style="white-space: nowrap;"><b>* md-highlight-text</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nA model to be searched for</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">\nmd-highlight-flags <span hide show-sm><code class="api-type label type-hint type-hint-string">string</code></span></td>\n<td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">string</code></td><td \nclass="description"><p>A list of flags (loosely based on JavaScript RexExp flags).</p><h4 id="-supported-flags-">\n<strong>Supported flags</strong>:</h4><ul><li><code>g</code>: Find all matches within the provided text</li><li><code>i\n</code>: Ignore case when searching for matches</li><li><code>$</code>\n: Only match if the text ends with the search term</li><li><code>^</code>\n: Only match if the text begins with the search term</li></ul></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.bottomSheet/service/$mdBottomSheet.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p><code>$mdBottomSheet</code>\n opens a bottom sheet over the app and provides a simple promise API.</p><h2 id="restrictions">Restrictions</h2><ul>\n<li>The bottom sheet&#39;s template must have an outer <code>&lt;md-bottom-sheet&gt;</code> element.</li><li>Add the \n<code>md-grid</code> class to the bottom sheet for a grid layout.</li><li>Add the <code>md-list</code>\n class to the bottom sheet for a list layout.</li></ul></div><div><section class="api-section"><h2 id="Usage">Usage\n</h2><hljs lang="html"><div ng-controller="MyController"><md-button ng-click="openBottomSheet()">Open a Bottom Sheet!\n</md-button></div></hljs><hljs lang="js">\nvar app = angular.module(&#39;app&#39;, [&#39;ngMaterial&#39;]); app.controller(&#39;MyController&#39;, function($scope, $mdBottomSheet) { $scope.openBottomSheet = function() { $mdBottomSheet.show({ template: &#39;\n<md-bottom-sheet>Hello!</md-bottom-sheet>&#39; }); }; });</hljs></section><section class="api-section"><h2>Methods</h2>\n<br><ul class="methods"><li id="show"><h3 class="method-function-syntax"><code class="method-function-syntax">\n$mdBottomSheet.show(options);</code></h3><div class="service-desc"><p>Show a bottom sheet with the specified options.\n</p></div><div class="method-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;"><b>* options</b> <span\n hide show-sm><code class="api-type label type-hint type-hint-object">object</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-object">object</code></td><td \nclass="description"><p>An options object, with the following properties:</p><ul><li><code>templateUrl</code> - <code>\n{string=}</code>\n: The url of an html template file that will be used as the content of the bottom sheet. Restrictions: the template must have an outer \n<code>md-bottom-sheet</code> element.</li><li><code>template</code> - <code>{string=}</code>\n: Same as templateUrl, except this is an actual template string.</li><li><code>scope</code> - <code>{object=}</code>\n: the scope to link the template / controller to. If none is specified, it will create a new child scope. This scope will be destroyed when the bottom sheet is removed unless \n<code>preserveScope</code> is set to true.</li><li><code>preserveScope</code> - <code>{boolean=}</code>\n: whether to preserve the scope when the element is removed. Default is false</li><li><code>controller</code> - <code>\n{string=}</code>: The controller to associate with this bottom sheet.</li><li><code>locals</code> - <code>{string=}\n</code>\n: An object containing key/value pairs. The keys will be used as names of values to inject into the controller. For example, \n<code>locals: {three: 3}</code> would inject <code>three</code> into the controller with the value of 3.</li><li><code>\nclickOutsideToClose</code> - <code>{boolean=}</code>\n: Whether the user can click outside the bottom sheet to close it. Default true.</li><li><code>disableBackdrop</code>\n - <code>{boolean=}</code>: When set to true, the bottomsheet will not show a backdrop.</li><li><code>escapeToClose\n</code> - <code>{boolean=}</code>: Whether the user can press escape to close the bottom sheet. Default true.</li><li>\n<code>resolve</code> - <code>{object=}</code>\n: Similar to locals, except it takes promises as values and the bottom sheet will not open until the promises resolve.\n</li><li><code>controllerAs</code> - <code>{string=}</code>: An alias to assign the controller to on the scope.</li>\n<li><code>parent</code> - <code>{element=}</code>: The element to append the bottom sheet to. The <code>parent</code>\n may be a <code>function</code>, <code>string</code>, <code>object</code>\n, or null. Defaults to appending to the body of the root element (or the root element) of the application. e.g. angular.element(document.getElementById(&#39;content&#39;)) or &quot;#content&quot;\n</li><li><code>disableParentScroll</code> - <code>{boolean=}</code>\n: Whether to disable scrolling while the bottom sheet is open. Default true.</li></ul></td></tr></tbody></table><table \nclass="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass="api-type label type-hint type-hint-promise">promise</code></td><td class="description"><p>\nA promise that can be resolved with <code>$mdBottomSheet.hide()</code> or rejected with <code>$mdBottomSheet.cancel()\n</code>.</p></td></tr></tbody></table></div></li><li id="hide"><h3 class="method-function-syntax"><code \nclass="method-function-syntax">$mdBottomSheet.hide([response]);</code></h3><div class="service-desc"><p>\nHide the existing bottom sheet and resolve the promise returned from <code>$mdBottomSheet.show()</code>\n. This call will close the most recently opened/current bottomsheet (if any).</p></div><div class="method-param-table">\n<table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass="api-params-item"><td style="white-space: nowrap;">response <span hide show-sm><code \nclass="api-type label type-hint type-hint-object">*</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-object">*</code></td><td class="description"><p>\nAn argument for the resolved promise.</p></td></tr></tbody></table></div></li><li id="cancel"><h3 \nclass="method-function-syntax"><code class="method-function-syntax">$mdBottomSheet.cancel([response]);</code></h3><div \nclass="service-desc"><p>Hide the existing bottom sheet and reject the promise returned from <code>$mdBottomSheet.show()\n</code>.</p></div><div class="method-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type\n</th><th>Description</th></tr></thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;">response \n<span hide show-sm><code class="api-type label type-hint type-hint-object">*</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-object">*</code></td><td \nclass="description"><p>An argument for the rejected promise.</p></td></tr></tbody></table></div></li></ul></section>\n</div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.card/directive/mdCard.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>The <code>&lt;md-card&gt;</code> directive is a container element used within <code>\n&lt;md-content&gt;</code> containers.</p><p>\nAn image included as a direct descendant will fill the card&#39;s width, while the <code>&lt;md-card-content&gt;</code>\n container will wrap text content and provide padding. An <code>&lt;md-card-footer&gt;</code>\n element can be optionally included to put content flush against the bottom edge of the card.</p><p>\nAction buttons can be included in an <code>&lt;md-card-actions&gt;</code> element, similar to <code>\n&lt;md-dialog-actions&gt;</code>. You can then position buttons using layout attributes.</p><p>Card is built with:</p>\n<ul><li><code>&lt;md-card-header&gt;</code> - Header for the card, holds avatar, text and squared image<ul><li><code>\n&lt;md-card-avatar&gt;</code> - Card avatar<ul><li><code>md-user-avatar</code> - Class for user image</li><li><code>\n&lt;md-icon&gt;</code></li></ul></li><li><code>&lt;md-card-header-text&gt;</code>\n - Contains elements for the card description<ul><li><code>md-title</code> - Class for the card title</li><li><code>\nmd-subhead</code> - Class for the card sub header</li></ul></li></ul></li><li><code>&lt;img&gt;</code>\n - Image for the card</li><li><code>&lt;md-card-title&gt;</code> - Card content title<ul><li><code>\n&lt;md-card-title-text&gt;</code><ul><li><code>md-headline</code> - Class for the card content title</li><li><code>\nmd-subhead</code> - Class for the card content sub header</li></ul></li><li><code>&lt;md-card-title-media&gt;</code>\n - Squared image within the title<ul><li><code>md-media-sm</code> - Class for small image</li><li><code>md-media-md\n</code> - Class for medium image</li><li><code>md-media-lg</code> - Class for large image</li></ul></li></ul></li><li>\n<code>&lt;md-card-content&gt;</code> - Card content<ul><li><code>md-media-xl</code> - Class for extra large image</li>\n</ul></li><li><code>&lt;md-card-actions&gt;</code> - Card actions<ul><li><code>&lt;md-card-icon-actions&gt;</code>\n - Icon actions</li></ul></li></ul><p>\nCards have constant width and variable heights; where the maximum height is limited to what can fit within a single view on a platform, but it can temporarily expand as needed.\n</p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><h3 id="card-with-optional-footer">\nCard with optional footer</h3><hljs lang="html"><md-card><img src="card-image.png" class="md-card-image" \nalt="image caption"><md-card-content><h2>Card headline</h2><p>Card content</p></md-card-content><md-card-footer>\nCard footer</md-card-footer></md-card></hljs><h3 id="card-with-actions">Card with actions</h3><hljs lang="html">\n<md-card><img src="card-image.png" class="md-card-image" alt="image caption"><md-card-content><h2>Card headline</h2><p>\nCard content</p></md-card-content><md-card-actions layout="row" layout-align="end center"><md-button>Action 1\n</md-button><md-button>Action 2</md-button></md-card-actions></md-card></hljs><h3 \nid="card-with-header-image-title-actions-and-content">Card with header, image, title actions and content</h3><hljs \nlang="html"><md-card><md-card-header><md-card-avatar><img class="md-user-avatar" src="avatar.png"></md-card-avatar>\n<md-card-header-text><span class="md-title">Title</span> <span class="md-subhead">Sub header</span>\n</md-card-header-text></md-card-header><img ng-src="card-image.png" class="md-card-image" alt="image caption">\n<md-card-title><md-card-title-text><span class="md-headline">Card headline</span> <span class="md-subhead">\nCard subheader</span></md-card-title-text></md-card-title><md-card-actions layout="row" layout-align="start center">\n<md-button>Action 1</md-button><md-button>Action 2</md-button><md-card-icon-actions><md-button class="md-icon-button" \naria-label="icon"><md-icon md-svg-icon="icon"></md-icon></md-button></md-card-icon-actions></md-card-actions>\n<md-card-content><p>Card content</p></md-card-content></md-card></hljs></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.button/directive/mdButton.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p><code>&lt;md-button&gt;</code>\n is a button directive with optional ink ripples (default enabled).</p><p>If you supply a <code>href</code> or <code>\nng-href</code> attribute, it will become an <code>&lt;a&gt;</code> element. Otherwise, it will become a <code>\n&lt;button&gt;</code> element. As per the <a \nhref="http://www.google.com/design/spec/style/color.html#color-ui-color-application">Material Design specifications</a>\n the FAB button background is filled with the accent color [by default]. The primary color palette may be used with the \n<code>md-primary</code> class.</p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><p>Regular buttons:\n</p><hljs lang="html"><md-button>Flat Button</md-button><md-button href="http://google.com">Flat link</md-button>\n<md-button class="md-raised">Raised Button</md-button><md-button ng-disabled="true">Disabled Button</md-button>\n<md-button><md-icon md-svg-src="your/icon.svg"></md-icon>Register Now</md-button></hljs><p>FAB buttons:</p><hljs \nlang="html"><md-button class="md-fab" aria-label="FAB"><md-icon md-svg-src="your/icon.svg"></md-icon></md-button>\n<md-button class="md-fab md-mini" aria-label="Mini FAB"><md-icon md-svg-src="your/icon.svg"></md-icon></md-button>\n<md-button class="md-icon-button" aria-label="Custom Icon Button"><md-icon md-svg-icon="path/to/your.svg"></md-icon>\n</md-button></hljs></section><div class="api-param-section"><h2>Attributes</h2><div class="api-param-table"><table \nclass="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass="api-params-item"><td style="white-space: nowrap;">md-no-ink <span hide show-sm><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>\nIf present, disable ripple ink effects.</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">\nmd-no-focus-style <span hide show-sm><code class="api-type label type-hint type-hint-boolean">boolean</code></span>\n</td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-boolean">boolean</code></td><td \nclass="description"><p>If present, disable focus style on button</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">ng-disabled <span hide show-sm><code \nclass="api-type label type-hint type-hint-expression">expression</code></span></td><td style="white-space: nowrap;">\n<code class="api-type label type-hint type-hint-expression">expression</code></td><td class="description"><p>\nEn/Disable based on the expression</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">\nmd-ripple-size <span hide show-sm><code class="api-type label type-hint type-hint-string">string</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">string</code></td><td \nclass="description"><p>Overrides the default ripple size logic. Options: <code>full</code>, <code>partial</code>, \n<code>auto</code></p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">aria-label <span hide \nshow-sm><code class="api-type label type-hint type-hint-string">string</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">string</code></td><td \nclass="description"><p>\nAdds alternative text to button for accessibility, useful for icon buttons. If no default text is found, a warning will be logged.\n</p></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.content/directive/mdContent.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>The <code>&lt;md-content&gt;</code>\n directive is a container element useful for scrollable content. It achieves this by setting the CSS <code>overflow\n</code> property to <code>auto</code> so that content can properly scroll.</p><p>In general, <code>&lt;md-content&gt;\n</code>\n components are not designed to be nested inside one another. If possible, it is better to make them siblings. This often results in a better user experience as having nested scrollbars may confuse the user.\n</p><h2 id="troubleshooting">Troubleshooting</h2><p>In some cases, you may wish to apply the <code>md-no-momentum\n</code>\n class to ensure that Safari&#39;s momentum scrolling is disabled. Momentum scrolling can cause flickering issues while scrolling SVG icons and some other components.\n</p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><p>Add the <code>[layout-padding]</code>\n attribute to make the content padded.</p><hljs lang="html"><md-content layout-padding>\nLorem ipsum dolor sit amet, ne quod novum mei.</md-content></hljs></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.checkbox/directive/mdCheckbox.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>The checkbox directive is used like the normal <a \nhref="https://docs.angularjs.org/api/ng/input/input%5Bcheckbox%5D">angular checkbox</a>.</p><p>As per the <a \nhref="http://www.google.com/design/spec/style/color.html#color-ui-color-application">material design spec</a>\n the checkbox is in the accent color by default. The primary color palette may be used with the <code>md-primary</code>\n class.</p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="html"><md-checkbox \nng-model="isChecked" aria-label="Finished?">Finished ?</md-checkbox><md-checkbox md-no-ink ng-model="hasInk" \naria-label="No Ink Effects">No Ink Effects</md-checkbox><md-checkbox ng-disabled="true" ng-model="isDisabled" \naria-label="Disabled">Disabled</md-checkbox></hljs></section><div class="api-param-section"><h2>Attributes</h2><div \nclass="api-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;"><b>* ng-model</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nAssignable angular expression to data-bind to.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">name <span hide show-sm><code class="api-type label type-hint type-hint-string">string\n</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">string\n</code></td><td class="description"><p>Property name of the form under which the control is published.</p></td></tr><tr\n class="api-params-item"><td style="white-space: nowrap;">ng-true-value <span hide show-sm><code \nclass="api-type label type-hint type-hint-expression">expression</code></span></td><td style="white-space: nowrap;">\n<code class="api-type label type-hint type-hint-expression">expression</code></td><td class="description"><p>\nThe value to which the expression should be set when selected.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">ng-false-value <span hide show-sm><code \nclass="api-type label type-hint type-hint-expression">expression</code></span></td><td style="white-space: nowrap;">\n<code class="api-type label type-hint type-hint-expression">expression</code></td><td class="description"><p>\nThe value to which the expression should be set when not selected.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">ng-change <span hide show-sm><code class="api-type label type-hint type-hint-string">\nstring</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">\nstring</code></td><td class="description"><p>\nAngular expression to be executed when input changes due to user interaction with the input element.</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">md-no-ink <span hide show-sm><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>\nUse of attribute indicates use of ripple ink effects</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">aria-label <span hide show-sm><code class="api-type label type-hint type-hint-string">\nstring</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">\nstring</code></td><td class="description"><p>\nAdds label to checkbox for accessibility. Defaults to checkbox&#39;s text. If no default text is found, a warning will be logged.\n</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">md-indeterminate <span hide show-sm><code \nclass="api-type label type-hint type-hint-expression">expression</code></span></td><td style="white-space: nowrap;">\n<code class="api-type label type-hint type-hint-expression">expression</code></td><td class="description"><p>\nThis determines when the checkbox should be rendered as &#39;indeterminate&#39;. If a truthy expression or no value is passed in the checkbox renders in the md-indeterminate state. If falsy expression is passed in it just looks like a normal unchecked checkbox. The indeterminate, checked, and unchecked states are mutually exclusive. A box cannot be in any two states at the same time. When a checkbox is indeterminate that overrides any checked/unchecked rendering logic.\n</p></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.chips/directive/mdChip.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p><code>&lt;md-chip&gt;</code> is a component used within <code>&lt;md-chips&gt;\n</code> and is responsible for rendering individual chips.</p></div><div><section class="api-section"><h2 id="Usage">\nUsage</h2><hljs lang="html"><md-chip>{{$chip}}</md-chip></hljs></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.chips/directive/mdChipRemove.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p><code>&lt;md-chip-remove&gt;</code>\n Designates an element to be used as the delete button for a chip. This element is passed as a child of the <code>\nmd-chips</code> element.</p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="html">\n<md-chips><button md-chip-remove>DEL</button></md-chips></hljs></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.chips/directive/mdChips.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p><code>&lt;md-chips&gt;</code>\n is an input component for building lists of strings or objects. The list items are displayed as &#39;chips&#39;. This component can make use of an \n<code>&lt;input&gt;</code> element or an <code>&lt;md-autocomplete&gt;</code> element.</p><h3 id="custom-templates">\nCustom templates</h3><p>\nA custom template may be provided to render the content of each chip. This is achieved by specifying an <code>\n&lt;md-chip-template&gt;</code> element containing the custom content as a child of <code>&lt;md-chips&gt;</code>.</p>\n<p>Note: Any attributes on <code>&lt;md-chip-template&gt;</code>\n will be dropped as only the innerHTML is used for the chip template. The variables <code>$chip</code> and <code>$index\n</code> are available in the scope of <code>&lt;md-chip-template&gt;</code>\n, representing the chip object and its index in the list of chips, respectively. To override the chip delete control, include an element (ideally a button) with the attribute \n<code>md-chip-remove</code>\n. A click listener to remove the chip will be added automatically. The element is also placed as a sibling to the chip content (on which there are also click listeners) to avoid a nested ng-click situation.\n</p><p></p><h3>Pending Features</h3><p></p><ul style="padding-left:20px;"><ul>Style<li>\nColours for hover, press states (ripple?).</li></ul><ul>Validation<li>allow a validation callback</li><li>\nhilighting style for invalid chips</li></ul><ul>Item mutation<li>Support <code>&lt;md-chip-edit&gt;</code>\n template, show/hide the edit element on tap/click? double tap/double click?</li></ul><ul>\nTruncation and Disambiguation (?)<li>\nTruncate chip text where possible, but do not truncate entries such that two are indistinguishable.</li></ul><ul>\nDrag and Drop<li>Drag and drop chips between related <code>&lt;md-chips&gt;</code> elements.</li></ul></ul><p><span \nstyle="font-size:.8em;text-align:center">\nWarning: This component is a WORK IN PROGRESS. If you use it now, it will probably break on you in the future.</span>\n</p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="html"><md-chips ng-model="myItems" \nplaceholder="Add an item" readonly="isReadOnly"></md-chips></hljs><p></p><h3>Validation</h3>When using <a \nhref="https://docs.angularjs.org/api/ngMessages">ngMessages</a>, you can show errors based on our custom validators.<p>\n</p><hljs lang="html"><form name="userForm"><md-chips name="fruits" ng-model="myItems" placeholder="Add an item" \nmd-max-chips="5"></md-chips><div ng-messages="userForm.fruits.$error" ng-if="userForm.$dirty"><div \nng-message="md-max-chips">You reached the maximum amount of chips</div></div></form></hljs></section><div \nclass="api-param-section"><h2>Attributes</h2><div class="api-param-table"><table class="md-api-table"><thead><tr><th>\nParameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class="api-params-item"><td \nstyle="white-space: nowrap;"><b>* ng-model</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code><code class="api-type label type-hint type-hint-object">\nobject</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">\nstring</code><code class="api-type label type-hint type-hint-object">object</code></td><td class="description"><p>\nA model to bind the list of items to</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;"><b>\n* md-transform-chip</b> <span hide show-sm><code class="api-type label type-hint type-hint-expression">expression\n</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-expression">\nexpression</code></td><td class="description"><p>An expression of form <code>myFunction($chip)</code>\n that when called expects one of the following return values:</p><ul><li>an object representing the <code>$chip</code>\n input string</li><li><code>undefined</code> to simply add the <code>$chip</code> input string, or</li><li><code>null\n</code> to prevent the chip from being appended</li></ul></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;"><b>* md-require-match</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>\nIf true, and the chips template contains an autocomplete, only allow selection of pre-defined chips (i.e. you cannot add new ones).\n</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">placeholder <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nPlaceholder text that will be forwarded to the input.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">secondary-placeholder <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nPlaceholder text that will be forwarded to the input, displayed when there is at least one item in the list</p></td>\n</tr><tr class="api-params-item"><td style="white-space: nowrap;">readonly <span hide show-sm><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>\nDisables list manipulation (deleting or adding list items), hiding the input and delete buttons. If no <code>ng-model\n</code> is provided, the chips will automatically be marked as readonly.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-enable-chip-edit <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nSet this to &quot;true&quot; to enable editing of chip contents. The user can go into edit mode with pressing &quot;space&quot;, &quot;enter&quot;, or double clicking on the chip. Chip edit is only supported for chips with basic template.\n</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">md-max-chips <span hide show-sm><code \nclass="api-type label type-hint type-hint-number">number</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-number">number</code></td><td class="description"><p>\nThe maximum number of chips allowed to add through user input.<br><br>The validation property <code>md-max-chips</code>\n can be used when the max chips amount is reached.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-on-add <span hide show-sm><code class="api-type label type-hint type-hint-expression">\nexpression</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-expression">expression</code></td><td class="description"><p>\nAn expression which will be called when a chip has been added.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-on-remove <span hide show-sm><code \nclass="api-type label type-hint type-hint-expression">expression</code></span></td><td style="white-space: nowrap;">\n<code class="api-type label type-hint type-hint-expression">expression</code></td><td class="description"><p>\nAn expression which will be called when a chip has been removed.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-on-select <span hide show-sm><code \nclass="api-type label type-hint type-hint-expression">expression</code></span></td><td style="white-space: nowrap;">\n<code class="api-type label type-hint type-hint-expression">expression</code></td><td class="description"><p>\nAn expression which will be called when a chip is selected.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">delete-hint <span hide show-sm><code class="api-type label type-hint type-hint-string">\nstring</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">\nstring</code></td><td class="description"><p>\nA string read by screen readers instructing users that pressing the delete key will remove the chip.</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">delete-button-label <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nA label for the delete button. Also hidden and read by screen readers.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-separator-keys <span hide show-sm><code \nclass="api-type label type-hint type-hint-expression">expression</code></span></td><td style="white-space: nowrap;">\n<code class="api-type label type-hint type-hint-expression">expression</code></td><td class="description"><p>\nAn array of key codes used to separate chips.</p></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.chips/directive/mdContactChips.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p><code>&lt;md-contact-chips&gt;</code> is an input component based on <code>md-chips\n</code> and makes use of an <code>md-autocomplete</code>\n element. The component allows the caller to supply a query expression which returns a list of possible contacts. The user can select one of these and add it to the list of chips.\n</p><p>You may also use the <code>md-highlight-text</code>\n directive along with its parameters to control the appearance of the matched text inside of the contacts&#39; autocomplete popup.\n</p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="html"><md-contact-chips \nng-model="ctrl.contacts" md-contacts="ctrl.querySearch($query)" md-contact-name="name" md-contact-image="image" \nmd-contact-email="email" placeholder="To"></md-contact-chips></hljs></section><div class="api-param-section"><h2>\nAttributes</h2><div class="api-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;"><b>* ng-model</b> \n<span hide show-sm><code class="api-type label type-hint type-hint-string">string</code><code \nclass="api-type label type-hint type-hint-object">object</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code><code class="api-type label type-hint type-hint-object">\nobject</code></td><td class="description"><p>A model to bind the list of items to</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;"><b>* md-contacts</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-expression">expression</code></span></td><td style="white-space: nowrap;">\n<code class="api-type label type-hint type-hint-expression">expression</code></td><td class="description"><p>\nAn expression expected to return contacts matching the search test, <code>$query</code>\n. If this expression involves a promise, a loading bar is displayed while waiting for it to resolve.</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;"><b>* md-contact-name</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nThe field name of the contact object representing the contact&#39;s name.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;"><b>* md-contact-email</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nThe field name of the contact object representing the contact&#39;s email address.</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;"><b>* md-contact-image</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nThe field name of the contact object representing the contact&#39;s image.</p></td></tr><tr class="api-params-item"><td\n style="white-space: nowrap;">placeholder <span hide show-sm><code class="api-type label type-hint type-hint-string">\nstring</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">\nstring</code></td><td class="description"><p>Placeholder text that will be forwarded to the input.</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">secondary-placeholder <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nPlaceholder text that will be forwarded to the input, displayed when there is at least on item in the list</p></td>\n</tr><tr class="api-params-item"><td style="white-space: nowrap;">filter-selected <span hide show-sm><code \nclass="api-type label type-hint type-hint-expression">expression</code></span></td><td style="white-space: nowrap;">\n<code class="api-type label type-hint type-hint-expression">expression</code></td><td class="description"><p>\nWhether to filter selected contacts from the list of suggestions shown in the autocomplete. This attribute has been removed but may come back.\n</p></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.colors/directive/mdColors.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p><code>mdColors</code>\n directive will apply the theme-based color expression as RGBA CSS style values.</p><p>\nThe format will be similar to our color defining in the scss files:</p><h2 id="-theme-palette-hue-opacity-"><code>\n[?theme]-[palette]-[?hue]-[?opacity]</code></h2><ul><li>[theme] - default value is the default theme</li><li>\n[palette] - can be either palette name or primary/accent/warn/background</li><li>\n[hue] - default is 500 (hue-x can be used with primary/accent/warn/background)</li><li><p>[opacity] - default is 1</p>\n<blockquote><p><code>?</code> indicates optional parameter</p></blockquote></li></ul></div><div><section \nclass="api-section"><h2 id="Usage">Usage</h2><hljs lang="html"><div \nmd-colors="{background: \'myTheme-accent-900-0.43\'}"><div md-colors="{color: \'red-A100\', border-color: \'primary-600\'}">\n<span>Color demo</span></div></div></hljs><p><code>mdColors</code>\n directive will automatically watch for changes in the expression if it recognizes an interpolation expression or a function. For performance options, you can use \n<code>::</code> prefix to the <code>md-colors</code> expression to indicate a one-time data binding.</p><hljs \nlang="html"><md-card md-colors="::{background: \'{{theme}}-primary-700\'}"></md-card></hljs></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.colors/service/$mdColors.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>\nWith only defining themes, one couldn&#39;t get non ngMaterial elements colored with Material colors, <code>$mdColors\n</code>\n service is used by the md-color directive to convert the 1..n color expressions to RGBA values and will apply those values to element as CSS property values.\n</p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="js">\nangular.controller(&#39;myCtrl&#39;, function ($mdColors) { var color = $mdColors.getThemeColor(&#39;myTheme-red-200-0.5&#39;); ... });\n</hljs></section><section class="api-section"><h2>Methods</h2><br><ul class="methods"><li id="applyThemeColors"><h3 \nclass="method-function-syntax"><code class="method-function-syntax">\n$mdColors.applyThemeColors(element, colorExpression);</code></h3><div class="service-desc"><p>\nConvert the color expression into an object with scope-interpolated values Then calculate the rgba() values based on the theme color parts\n</p></div><div class="method-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;"><b>* element</b> <span\n hide show-sm><code class="api-type label type-hint type-hint-domelement">DOMElement</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-domelement">DOMElement</code></td><td \nclass="description"><p>the element to apply the styles on.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;"><b>* colorExpression</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-object">object</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-object">object</code></td><td class="description"><p>\njson object, keys are css properties and values are string of the wanted color, for example: <code>\n{color: &#39;red-A200-0.3&#39;}</code>.</p></td></tr></tbody></table></div></li><li id="getThemeColor"><h3 \nclass="method-function-syntax"><code class="method-function-syntax">$mdColors.getThemeColor(expression);</code></h3>\n<div class="service-desc"><p>Get parsed color from expression</p></div><div class="method-param-table"><table \nclass="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass="api-params-item"><td style="white-space: nowrap;"><b>* expression</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nstring of a color expression (for instance <code>&#39;red-700-0.8&#39;</code>)</p></td></tr></tbody></table><table \nclass="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\na css color expression (for instance <code>rgba(211, 47, 47, 0.8)</code>)</p></td></tr></tbody></table></div></li></ul>\n</section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.dialog/directive/mdDialog.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p><code>&lt;md-dialog&gt;</code>\n - The dialog&#39;s template must be inside this element.</p><p>Inside, use an <code>&lt;md-dialog-content&gt;</code>\n element for the dialog&#39;s content, and use an <code>&lt;md-dialog-actions&gt;</code>\n element for the dialog&#39;s actions.</p><h2 id="css">CSS</h2><ul><li><code>.md-dialog-content</code>\n - class that sets the padding on the content as the spec file</li></ul><h2 id="notes">Notes</h2><ul><li>\nIf you specify an <code>id</code> for the <code>&lt;md-dialog&gt;</code>, the <code>&lt;md-dialog-content&gt;</code>\n will have the same <code>id</code> prefixed with <code>dialogContent_</code>.</li></ul></div><div><section \nclass="api-section"><h2 id="Usage">Usage</h2><h3 id="dialog-template">Dialog template</h3><hljs lang="html"><md-dialog \naria-label="List dialog"><md-dialog-content><md-list><md-list-item ng-repeat="item in items"><p>Number {{item}}</p>\n</md-list-item></md-list></md-dialog-content><md-dialog-actions><md-button ng-click="closeDialog()" class="md-primary">\nClose Dialog</md-button></md-dialog-actions></md-dialog></hljs></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.dialog/service/$mdDialog.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p><code>$mdDialog</code>\n opens a dialog over the app to inform users about critical information or require them to make decisions. There are two approaches for setup: a simple promise API and regular object syntax.\n</p><h2 id="restrictions">Restrictions</h2><ul><li>The dialog is always given an isolate scope.</li><li>\nThe dialog&#39;s template must have an outer <code>&lt;md-dialog&gt;</code> element. Inside, use an <code>\n&lt;md-dialog-content&gt;</code> element for the dialog&#39;s content, and use an <code>&lt;md-dialog-actions&gt;\n</code> element for the dialog&#39;s actions.</li><li>\nDialogs must cover the entire application to keep interactions inside of them. Use the <code>parent</code>\n option to change where dialogs are appended.</li></ul><h2 id="sizing">Sizing</h2><ul><li>\nComplex dialogs can be sized with <code>flex=&quot;percentage&quot;</code>, i.e. <code>flex=&quot;66&quot;</code>.</li>\n<li>Default max-width is 80% of the <code>rootElement</code> or <code>parent</code>.</li></ul><h2 id="css">CSS</h2><ul>\n<li><code>.md-dialog-content</code> - class that sets the padding on the content as the spec file</li></ul></div><div>\n<section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="html"><div ng-app="demoApp" \nng-controller="EmployeeController"><div><md-button ng-click="showAlert()" class="md-raised md-warn">Employee Alert!\n</md-button></div><div><md-button ng-click="showDialog($event)" class="md-raised">Custom Dialog</md-button></div><div>\n<md-button ng-click="closeAlert()" ng-disabled="!hasAlert()" class="md-raised">Close Alert</md-button></div><div>\n<md-button ng-click="showGreeting($event)" class="md-raised md-primary">Greet Employee</md-button></div></div></hljs>\n<h3 id="javascript-object-syntax">JavaScript: object syntax</h3><hljs lang="js">\n(function(angular, undefined){ &quot;use strict&quot;; angular .module(&#39;demoApp&#39;, [&#39;ngMaterial&#39;]) .controller(&#39;AppCtrl&#39;, AppController); function AppController($scope, $mdDialog) { var alert; $scope.showAlert = showAlert; $scope.showDialog = showDialog; $scope.items = [1, 2, 3]; // Internal method function showAlert() { alert = $mdDialog.alert({ title: &#39;Attention&#39;, textContent: &#39;This is an example of how easy dialogs can be!&#39;, ok: &#39;Close&#39; }); $mdDialog .show( alert ) .finally(function() { alert = undefined; }); } function showDialog($event) { var parentEl = angular.element(document.body); $mdDialog.show({ parent: parentEl, targetEvent: $event, template: &#39;\n<md-dialog aria-label="List dialog">&#39; + &#39;<md-dialog-content>&#39;+ &#39;<md-list>&#39;+ &#39;<md-list-item \nng-repeat="item in items">&#39;+ &#39;<p>Number {{item}}</p>&#39; + &#39;&#39;+ &#39;</md-list-item></md-list>\n&#39;+ &#39;</md-dialog-content>&#39; + &#39;<md-dialog-actions>&#39; + &#39;<md-button ng-click="closeDialog()" \nclass="md-primary">&#39; + &#39; Close Dialog&#39; + &#39;</md-button>&#39; + &#39;</md-dialog-actions>&#39; + &#39;\n</md-dialog>\n&#39;, locals: { items: $scope.items }, controller: DialogController }); function DialogController($scope, $mdDialog, items) { $scope.items = items; $scope.closeDialog = function() { $mdDialog.hide(); } } } } })(angular);\n</hljs><h3 id="javascript-promise-api-syntax-custom-dialog-template">\nJavaScript: promise API syntax, custom dialog template</h3><hljs lang="js">\n(function(angular, undefined){ &quot;use strict&quot;; angular .module(&#39;demoApp&#39;, [&#39;ngMaterial&#39;]) .controller(&#39;EmployeeController&#39;, EmployeeEditor) .controller(&#39;GreetingController&#39;, GreetingController); // Fictitious Employee Editor to show how to use simple and complex dialogs. function EmployeeEditor($scope, $mdDialog) { var alert; $scope.showAlert = showAlert; $scope.closeAlert = closeAlert; $scope.showGreeting = showCustomGreeting; $scope.hasAlert = function() { return !!alert }; $scope.userName = $scope.userName || &#39;Bobby&#39;; // Dialog #1 - Show simple alert dialog and cache // reference to dialog instance function showAlert() { alert = $mdDialog.alert() .title(&#39;Attention, &#39; + $scope.userName) .textContent(&#39;This is an example of how easy dialogs can be!&#39;) .ok(&#39;Close&#39;); $mdDialog .show( alert ) .finally(function() { alert = undefined; }); } // Close the specified dialog instance and resolve with &#39;finished&#39; flag // Normally this is not needed, just use &#39;$mdDialog.hide()&#39; to close // the most recent dialog popup. function closeAlert() { $mdDialog.hide( alert, &quot;finished&quot; ); alert = undefined; } // Dialog #2 - Demonstrate more complex dialogs construction and popup. function showCustomGreeting($event) { $mdDialog.show({ targetEvent: $event, template: &#39;\n<md-dialog>&#39; + &#39;<md-dialog-content>Hello {{ employee }}!</md-dialog-content>&#39; + &#39;<md-dialog-actions>\n&#39; + &#39;<md-button ng-click="closeDialog()" class="md-primary">&#39; + &#39; Close Greeting&#39; + &#39;\n</md-button>&#39; + &#39;</md-dialog-actions>&#39; + &#39;</md-dialog>\n&#39;, controller: &#39;GreetingController&#39;, onComplete: afterShowAnimation, locals: { employee: $scope.userName } }); // When the &#39;enter&#39; animation finishes... function afterShowAnimation(scope, element, options) { // post-show code here: DOM element focus, etc. } } // Dialog #3 - Demonstrate use of ControllerAs and passing $scope to dialog // Here we used ng-controller=&quot;GreetingController as vm&quot; and // $scope.vm ===\n<controller instance>\nfunction showCustomGreeting() { $mdDialog.show({ clickOutsideToClose: true, scope: $scope, // use parent scope in template preserveScope: true, // do not forget this if use parent scope // Since GreetingController is instantiated with ControllerAs syntax // AND we are passing the parent &#39;$scope&#39; to the dialog, we MUST // use &#39;vm.\n<xxx>&#39; in the template markup template: &#39;<md-dialog>&#39; + &#39;<md-dialog-content>\n&#39; + &#39; Hi There {{vm.employee}}&#39; + &#39;</md-dialog-content>&#39; + &#39;</md-dialog>\n&#39;, controller: function DialogController($scope, $mdDialog) { $scope.closeDialog = function() { $mdDialog.hide(); } } }); } } // Greeting controller used with the more complex &#39;showCustomGreeting()&#39; custom dialog function GreetingController($scope, $mdDialog, employee) { // Assigned from construction \n<code>locals</code>\n options... $scope.employee = employee; $scope.closeDialog = function() { // Easily hides most recent dialog shown... // no specific instance reference is needed. $mdDialog.hide(); }; } })(angular);\n</xxx></controller></hljs></section><section class="api-section"><h2>Methods</h2><br><ul class="methods"><li \nid="alert"><h3 class="method-function-syntax"><code class="method-function-syntax">$mdDialog.alert();</code></h3><div \nclass="service-desc"><p>Builds a preconfigured dialog with the specified message.</p></div><div \nclass="method-param-table"><table class="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class="api-type label type-hint type-hint-obj">obj</code></td><td class="description"><p>an <code>\n$mdDialogPreset</code> with the chainable configuration methods:</p><ul><li>\n$mdDialogPreset#title(string) - Sets the alert title.</li><li>\n$mdDialogPreset#textContent(string) - Sets the alert message.</li><li>\n$mdDialogPreset#htmlContent(string) - Sets the alert message as HTML. Requires ngSanitize module to be loaded. HTML is not run through Angular&#39;s compiler.\n</li><li>$mdDialogPreset#ok(string) - Sets the alert &quot;Okay&quot; button text.</li><li>\n$mdDialogPreset#theme(string) - Sets the theme of the alert dialog.</li><li>\n$mdDialogPreset#targetEvent(DOMClickEvent=) - A click&#39;s event object. When passed in as an option, the location of the click will be used as the starting point for the opening animation of the the dialog.\n</li></ul></td></tr></tbody></table></div></li><li id="confirm"><h3 class="method-function-syntax"><code \nclass="method-function-syntax">$mdDialog.confirm();</code></h3><div class="service-desc"><p>\nBuilds a preconfigured dialog with the specified message. You can call show and the promise returned will be resolved only if the user clicks the confirm action on the dialog.\n</p></div><div class="method-param-table"><table class="md-api-table"><thead><tr><th>Returns</th><th>Description</th>\n</tr></thead><tbody><tr><td><code class="api-type label type-hint type-hint-obj">obj</code></td><td \nclass="description"><p>an <code>$mdDialogPreset</code> with the chainable configuration methods:</p><p>\nAdditionally, it supports the following methods:</p><ul><li>$mdDialogPreset#title(string) - Sets the confirm title.\n</li><li>$mdDialogPreset#textContent(string) - Sets the confirm message.</li><li>\n$mdDialogPreset#htmlContent(string) - Sets the confirm message as HTML. Requires ngSanitize module to be loaded. HTML is not run through Angular&#39;s compiler.\n</li><li>$mdDialogPreset#ok(string) - Sets the confirm &quot;Okay&quot; button text.</li><li>\n$mdDialogPreset#cancel(string) - Sets the confirm &quot;Cancel&quot; button text.</li><li>\n$mdDialogPreset#theme(string) - Sets the theme of the confirm dialog.</li><li>\n$mdDialogPreset#targetEvent(DOMClickEvent=) - A click&#39;s event object. When passed in as an option, the location of the click will be used as the starting point for the opening animation of the the dialog.\n</li></ul></td></tr></tbody></table></div></li><li id="prompt"><h3 class="method-function-syntax"><code \nclass="method-function-syntax">$mdDialog.prompt();</code></h3><div class="service-desc"><p>\nBuilds a preconfigured dialog with the specified message and input box. You can call show and the promise returned will be resolved only if the user clicks the prompt action on the dialog, passing the input value as the first argument.\n</p></div><div class="method-param-table"><table class="md-api-table"><thead><tr><th>Returns</th><th>Description</th>\n</tr></thead><tbody><tr><td><code class="api-type label type-hint type-hint-obj">obj</code></td><td \nclass="description"><p>an <code>$mdDialogPreset</code> with the chainable configuration methods:</p><p>\nAdditionally, it supports the following methods:</p><ul><li>$mdDialogPreset#title(string) - Sets the prompt title.</li>\n<li>$mdDialogPreset#textContent(string) - Sets the prompt message.</li><li>\n$mdDialogPreset#htmlContent(string) - Sets the prompt message as HTML. Requires ngSanitize module to be loaded. HTML is not run through Angular&#39;s compiler.\n</li><li>$mdDialogPreset#placeholder(string) - Sets the placeholder text for the input.</li><li>\n$mdDialogPreset#ok(string) - Sets the prompt &quot;Okay&quot; button text.</li><li>\n$mdDialogPreset#cancel(string) - Sets the prompt &quot;Cancel&quot; button text.</li><li>\n$mdDialogPreset#theme(string) - Sets the theme of the prompt dialog.</li><li>\n$mdDialogPreset#targetEvent(DOMClickEvent=) - A click&#39;s event object. When passed in as an option, the location of the click will be used as the starting point for the opening animation of the the dialog.\n</li></ul></td></tr></tbody></table></div></li><li id="show"><h3 class="method-function-syntax"><code \nclass="method-function-syntax">$mdDialog.show(optionsOrPreset);</code></h3><div class="service-desc"><p>\nShow a dialog with the specified options.</p></div><div class="method-param-table"><table class="md-api-table"><thead>\n<tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class="api-params-item"><td \nstyle="white-space: nowrap;"><b>* optionsOrPreset</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-object">object</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-object">object</code></td><td class="description"><p>Either provide an <code>\n$mdDialogPreset</code> returned from <code>alert()</code>, and <code>confirm()</code>\n, or an options object with the following properties:</p><ul><li><code>templateUrl</code> - <code>{string=}</code>\n: The url of a template that will be used as the content of the dialog.</li><li><code>template</code> - <code>{string=}\n</code>: HTML template to show in the dialog. This <strong>must</strong> be trusted HTML with respect to Angular&#39;s \n<a href="https://docs.angularjs.org/api/ng/service/$sce">$sce service</a>. This template should <strong>never</strong>\n be constructed with any kind of user input or user data.</li><li><code>autoWrap</code> - <code>{boolean=}</code>\n: Whether or not to automatically wrap the template with a <code>&lt;md-dialog&gt;</code>\n tag if one is not provided. Defaults to true. Can be disabled if you provide a custom dialog directive.</li><li><code>\ntargetEvent</code> - <code>{DOMClickEvent=}</code>\n: A click&#39;s event object. When passed in as an option, the location of the click will be used as the starting point for the opening animation of the the dialog.\n</li><li><code>openFrom</code> - <code>{string|Element|object}</code>\n: The query selector, DOM element or the Rect object that is used to determine the bounds (top, left, height, width) from which the Dialog will originate.\n</li><li><code>closeTo</code> - <code>{string|Element|object}</code>\n: The query selector, DOM element or the Rect object that is used to determine the bounds (top, left, height, width) to which the Dialog will target.\n</li><li><code>scope</code> - <code>{object=}</code>\n: the scope to link the template / controller to. If none is specified, it will create a new isolate scope. This scope will be destroyed when the dialog is removed unless \n<code>preserveScope</code> is set to true.</li><li><code>preserveScope</code> - <code>{boolean=}</code>\n: whether to preserve the scope when the element is removed. Default is false</li><li><code>disableParentScroll</code>\n - <code>{boolean=}</code>: Whether to disable scrolling while the dialog is open. Default true.</li><li><code>\nhasBackdrop</code> - <code>{boolean=}</code>\n: Whether there should be an opaque backdrop behind the dialog. Default true.</li><li><code>clickOutsideToClose</code>\n - <code>{boolean=}</code>: Whether the user can click outside the dialog to close it. Default false.</li><li><code>\nescapeToClose</code> - <code>{boolean=}</code>: Whether the user can press escape to close the dialog. Default true.\n</li><li><code>focusOnOpen</code> - <code>{boolean=}</code>\n: An option to override focus behavior on open. Only disable if focusing some other way, as focus management is required for dialogs to be accessible. Defaults to true.\n</li><li><code>controller</code> - <code>{function|string=}</code>\n: The controller to associate with the dialog. The controller will be injected with the local <code>$mdDialog</code>\n, which passes along a scope for the dialog.</li><li><code>locals</code> - <code>{object=}</code>\n: An object containing key/value pairs. The keys will be used as names of values to inject into the controller. For example, \n<code>locals: {three: 3}</code> would inject <code>three</code> into the controller, with the value 3. If <code>\nbindToController</code> is true, they will be copied to the controller instead.</li><li><code>bindToController</code>\n - <code>bool</code>: bind the locals to the controller, instead of passing them in.</li><li><code>resolve</code> - \n<code>{object=}</code>\n: Similar to locals, except it takes promises as values, and the dialog will not open until all of the promises resolve.\n</li><li><code>controllerAs</code> - <code>{string=}</code>: An alias to assign the controller to on the scope.</li>\n<li><code>parent</code> - <code>{element=}</code>\n: The element to append the dialog to. Defaults to appending to the root element of the application.</li><li><code>\nonShowing</code> `{function=} Callback function used to announce the show() action is starting.</li><li><code>\nonComplete</code> <code>{function=}</code>: Callback function used to announce when the show() action is finished.</li>\n<li><code>onRemoving</code> <code>{function=}</code>\n: Callback function used to announce the close/hide() action is starting. This allows developers to run custom animations in parallel the close animations.\n</li><li><code>fullscreen</code> <code>{boolean=}</code>: An option to apply <code>.md-dialog-fullscreen</code>\n class on open.</li></ul></td></tr></tbody></table><table class="md-api-table"><thead><tr><th>Returns</th><th>\nDescription</th></tr></thead><tbody><tr><td><code class="api-type label type-hint type-hint-promise">promise</code>\n</td><td class="description"><p>A promise that can be resolved with <code>$mdDialog.hide()</code> or rejected with \n<code>$mdDialog.cancel()</code>.</p></td></tr></tbody></table></div></li><li id="hide"><h3 \nclass="method-function-syntax"><code class="method-function-syntax">$mdDialog.hide([response]);</code></h3><div \nclass="service-desc"><p>Hide an existing dialog and resolve the promise returned from <code>$mdDialog.show()</code>.\n</p></div><div class="method-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;">response <span hide \nshow-sm><code class="api-type label type-hint type-hint-object">*</code></span></td><td style="white-space: nowrap;">\n<code class="api-type label type-hint type-hint-object">*</code></td><td class="description"><p>\nAn argument for the resolved promise.</p></td></tr></tbody></table><table class="md-api-table"><thead><tr><th>Returns\n</th><th>Description</th></tr></thead><tbody><tr><td><code class="api-type label type-hint type-hint-promise">promise\n</code></td><td class="description"><p>A promise that is resolved when the dialog has been closed.</p></td></tr>\n</tbody></table></div></li><li id="cancel"><h3 class="method-function-syntax"><code class="method-function-syntax">\n$mdDialog.cancel([response]);</code></h3><div class="service-desc"><p>\nHide an existing dialog and reject the promise returned from <code>$mdDialog.show()</code>.</p></div><div \nclass="method-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;">response <span hide show-sm><code \nclass="api-type label type-hint type-hint-object">*</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-object">*</code></td><td class="description"><p>\nAn argument for the rejected promise.</p></td></tr></tbody></table><table class="md-api-table"><thead><tr><th>Returns\n</th><th>Description</th></tr></thead><tbody><tr><td><code class="api-type label type-hint type-hint-promise">promise\n</code></td><td class="description"><p>A promise that is resolved when the dialog has been closed.</p></td></tr>\n</tbody></table></div></li></ul></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.datepicker/directive/mdDatepicker.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p><code>&lt;md-datepicker&gt;</code>\n is a component used to select a single date. For information on how to configure internationalization for the date picker, see \n<code>$mdDateLocaleProvider</code>.</p><p>This component supports <a \nhref="https://docs.angularjs.org/api/ngMessages/directive/ngMessages">ngMessages</a>. Supported attributes are:</p><ul>\n<li><code>required</code>: whether a required date is not set.</li><li><code>mindate</code>\n: whether the selected date is before the minimum allowed date.</li><li><code>maxdate</code>\n: whether the selected date is after the maximum allowed date.</li></ul></div><div><section class="api-section"><h2 \nid="Usage">Usage</h2><hljs lang="html"><md-datepicker ng-model="birthday"></md-datepicker></hljs></section><div \nclass="api-param-section"><h2>Attributes</h2><div class="api-param-table"><table class="md-api-table"><thead><tr><th>\nParameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class="api-params-item"><td \nstyle="white-space: nowrap;"><b>* ng-model</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-date">Date</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-date">Date</code></td><td class="description"><p>\nThe component&#39;s model. Expects a JavaScript Date object.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">ng-change <span hide show-sm><code class="api-type label type-hint type-hint-expression">\nexpression</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-expression">expression</code></td><td class="description"><p>\nExpression evaluated when the model value changes.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-min-date <span hide show-sm><code class="api-type label type-hint type-hint-date">Date\n</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-date">Date</code>\n</td><td class="description"><p>Expression representing a min date (inclusive).</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">md-max-date <span hide show-sm><code \nclass="api-type label type-hint type-hint-date">Date</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-date">Date</code></td><td class="description"><p>\nExpression representing a max date (inclusive).</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-date-filter <span hide show-sm><code \nclass="api-type label type-hint type-hint-function">function(Date): boolean</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-function">function(Date): boolean</code>\n</td><td class="description"><p>Function expecting a date and returning a boolean whether it can be selected or not.\n</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">md-placeholder <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">String</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">String</code></td><td class="description"><p>\nThe date input placeholder value.</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">\nng-disabled <span hide show-sm><code class="api-type label type-hint type-hint-boolean">boolean</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-boolean">boolean</code></td><td \nclass="description"><p>Whether the datepicker is disabled.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">ng-required <span hide show-sm><code class="api-type label type-hint type-hint-boolean">\nboolean</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-boolean">\nboolean</code></td><td class="description"><p>Whether a value is required for the datepicker.</p></td></tr></tbody>\n</table></div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.datepicker/service/$mdDateLocaleProvider.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>The <code>$mdDateLocaleProvider</code> is the provider that creates the <code>\n$mdDateLocale</code>\n service. This provider that allows the user to specify messages, formatters, and parsers for date internationalization. The \n<code>$mdDateLocale</code> service itself is consumed by Angular Material components that deal with dates.</p></div>\n<div><section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="js">\nmyAppModule.config(function($mdDateLocaleProvider) { // Example of a French localization. $mdDateLocaleProvider.months = [&#39;janvier&#39;, &#39;f\xE9vrier&#39;, &#39;mars&#39;, ...]; $mdDateLocaleProvider.shortMonths = [&#39;janv&#39;, &#39;f\xE9vr&#39;, &#39;mars&#39;, ...]; $mdDateLocaleProvider.days = [&#39;dimanche&#39;, &#39;lundi&#39;, &#39;mardi&#39;, ...]; $mdDateLocaleProvider.shortDays = [&#39;Di&#39;, &#39;Lu&#39;, &#39;Ma&#39;, ...]; // Can change week display to start on Monday. $mdDateLocaleProvider.firstDayOfWeek = 1; // Optional. $mdDateLocaleProvider.dates = [1, 2, 3, 4, 5, 6, ...]; // Example uses moment.js to parse and format dates. $mdDateLocaleProvider.parseDate = function(dateString) { var m = moment(dateString, &#39;L&#39;, true); return m.isValid() ? m.toDate() : new Date(NaN); }; $mdDateLocaleProvider.formatDate = function(date) { var m = moment(date); return m.isValid() ? m.format(&#39;L&#39;) : &#39;&#39;; }; $mdDateLocaleProvider.monthHeaderFormatter = function(date) { return myShortMonths[date.getMonth()] + &#39; &#39; + date.getFullYear(); }; // In addition to date display, date components also need localized messages // for aria-labels for screen-reader users. $mdDateLocaleProvider.weekNumberFormatter = function(weekNumber) { return &#39;Semaine &#39; + weekNumber; }; $mdDateLocaleProvider.msgCalendar = &#39;Calendrier&#39;; $mdDateLocaleProvider.msgOpenCalendar = &#39;Ouvrir le calendrier&#39;; });\n</hljs></section><section class="api-section"><h2>Properties</h2><div class="api-param-table"><table \nclass="md-api-table"><thead><tr><th>Property</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass="api-params-item"><td style="white-space: nowrap;">months <span hide show-sm><code \nclass="api-type label type-hint type-hint-array">Array.&lt;string&gt;</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-array">Array.&lt;string&gt;</code></td><td\n class="description"><p>Array of month names (in order).</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">shortMonths <span hide show-sm><code class="api-type label type-hint type-hint-array">\nArray.&lt;string&gt;</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-array">Array.&lt;string&gt;</code></td><td class="description"><p>\nArray of abbreviated month names.</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">days <span \nhide show-sm><code class="api-type label type-hint type-hint-array">Array.&lt;string&gt;</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-array">Array.&lt;string&gt;</code></td><td\n class="description"><p>Array of the days of the week (in order).</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">shortDays <span hide show-sm><code class="api-type label type-hint type-hint-array">\nArray.&lt;string&gt;</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-array">Array.&lt;string&gt;</code></td><td class="description"><p>\nArray of abbreviated dayes of the week.</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">\ndates <span hide show-sm><code class="api-type label type-hint type-hint-array">Array.&lt;string&gt;</code></span></td>\n<td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-array">Array.&lt;string&gt;</code>\n</td><td class="description"><p>\nArray of dates of the month. Only necessary for locales using a numeral system other than [1, 2, 3...].</p></td></tr>\n<tr class="api-params-item"><td style="white-space: nowrap;">firstDayOfWeek <span hide show-sm><code \nclass="api-type label type-hint type-hint-array">Array.&lt;string&gt;</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-array">Array.&lt;string&gt;</code></td><td\n class="description"><p>The first day of the week. Sunday = 0, Monday = 1, etc.</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">parseDate <span hide show-sm><code \nclass="api-type label type-hint type-hint-function">function(string): Date</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-function">function(string): Date</code>\n</td><td class="description"><p>Function to parse a date object from a string.</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">formatDate <span hide show-sm><code \nclass="api-type label type-hint type-hint-function">function(Date): string</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-function">function(Date): string</code>\n</td><td class="description"><p>Function to format a date object to a string.</p></td></tr><tr class="api-params-item">\n<td style="white-space: nowrap;">monthHeaderFormatter <span hide show-sm><code \nclass="api-type label type-hint type-hint-function">function(Date): string</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-function">function(Date): string</code>\n</td><td class="description"><p>Function that returns the label for a month given a date.</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">weekNumberFormatter <span hide show-sm><code \nclass="api-type label type-hint type-hint-function">function(number): string</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-function">function(number): string</code>\n</td><td class="description"><p>Function that returns a label for a week given the week number.</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">msgCalendar <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nTranslation of the label &quot;Calendar&quot; for the current locale.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">msgOpenCalendar <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nTranslation of the button label &quot;Open calendar&quot; for the current locale.</p></td></tr></tbody></table></div>\n</section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.fabSpeedDial/directive/mdFabSpeedDial.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>The <code>&lt;md-fab-speed-dial&gt;</code>\n directive is used to present a series of popup elements (usually <code>&lt;md-button&gt;</code>\ns) for quick access to common actions.</p><p>\nThere are currently two animations available by applying one of the following classes to the component:</p><ul><li>\n<code>md-fling</code>\n - The speed dial items appear from underneath the trigger and move into their appropriate positions.</li><li><code>\nmd-scale</code> - The speed dial items appear in their proper places by scaling from 0% to 100%.</li></ul><p>\nYou may also easily position the trigger by applying one one of the following classes to the <code>\n&lt;md-fab-speed-dial&gt;</code> element:</p><ul><li><code>md-fab-top-left</code></li><li><code>md-fab-top-right</code>\n</li><li><code>md-fab-bottom-left</code></li><li><code>md-fab-bottom-right</code></li></ul><p>These CSS classes use \n<code>position: absolute</code>, so you need to ensure that the container element also uses <code>position: absolute\n</code> or <code>position: relative</code> in order for them to work.</p><p>Additionally, you may use the standard \n<code>ng-mouseenter</code> and <code>ng-mouseleave</code>\n directives to open or close the speed dial. However, if you wish to allow users to hover over the empty space where the actions will appear, you must also add the \n<code>md-hover-full</code>\n class to the speed dial element. Without this, the hover effect will only occur on top of the trigger.</p><p>\nSee the demos for more information.</p><h2 id="troubleshooting">Troubleshooting</h2><p>\nIf your speed dial shows the closing animation upon launch, you may need to use <code>ng-cloak</code>\n on the parent container to ensure that it is only visible once ready. We have plans to remove this necessity in the future.\n</p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="html"><md-fab-speed-dial \nmd-direction="up" class="md-fling"><md-fab-trigger><md-button aria-label="Add..."><md-icon \nicon="/assets/angular-material-assets/img/icons/plus.svg"></md-icon></md-button></md-fab-trigger><md-fab-actions>\n<md-button aria-label="Add User"><md-icon icon="/assets/angular-material-assets/img/icons/user.svg"></md-icon>\n</md-button><md-button aria-label="Add Group"><md-icon icon="/assets/angular-material-assets/img/icons/group.svg">\n</md-icon></md-button></md-fab-actions></md-fab-speed-dial></hljs></section><div class="api-param-section"><h2>\nAttributes</h2><div class="api-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;"><b>* md-direction</b> \n<span hide show-sm><code class="api-type label type-hint type-hint-string">string</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">string</code></td><td \nclass="description"><p>From which direction you would like the speed dial to appear relative to the trigger element.\n</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">md-open <span hide show-sm><code \nclass="api-type label type-hint type-hint-expression">expression</code></span></td><td style="white-space: nowrap;">\n<code class="api-type label type-hint type-hint-expression">expression</code></td><td class="description"><p>\nProgrammatically control whether or not the speed-dial is visible.</p></td></tr></tbody></table></div></div></div>\n</div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.fabSpeedDial/directive/mdFabTrigger.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>The <code>&lt;md-fab-trigger&gt;</code> directive is used inside of a <code>\n&lt;md-fab-speed-dial&gt;</code> or <code>&lt;md-fab-toolbar&gt;</code>\n directive to mark an element (or elements) as the trigger and setup the proper event listeners.</p></div><div><section\n class="api-section"><h2 id="Usage">Usage</h2><p>See the <code>&lt;md-fab-speed-dial&gt;</code> or <code>\n&lt;md-fab-toolbar&gt;</code> directives for example usage.</p></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.divider/directive/mdDivider.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>\nDividers group and separate content within lists and page layouts using strong visual and spatial distinctions. This divider is a thin rule, lightweight enough to not distract the user from content.\n</p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="html"><md-divider></md-divider>\n<md-divider md-inset></md-divider></hljs></section><div class="api-param-section"><h2>Attributes</h2><div \nclass="api-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;">md-inset <span hide show-sm><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>\nAdd this attribute to activate the inset divider style.</p></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.fabActions/directive/mdFabActions.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>The <code>&lt;md-fab-actions&gt;</code> directive is used inside of a <code>\n&lt;md-fab-speed-dial&gt;</code> or <code>&lt;md-fab-toolbar&gt;</code>\n directive to mark an element (or elements) as the actions and setup the proper event listeners.</p></div><div><section\n class="api-section"><h2 id="Usage">Usage</h2><p>See the <code>&lt;md-fab-speed-dial&gt;</code> or <code>\n&lt;md-fab-toolbar&gt;</code> directives for example usage.</p></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.gridList/directive/mdGridList.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>\nGrid lists are an alternative to standard list views. Grid lists are distinct from grids used for layouts and other visual presentations.\n</p><p>\nA grid list is best suited to presenting a homogenous data type, typically images, and is optimized for visual comprehension and differentiating between like data types.\n</p><p>\nA grid list is a continuous element consisting of tessellated, regular subdivisions called cells that contain tiles (\n<code>md-grid-tile</code>).</p><p><img \nsrc="//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7OVlEaXZ5YmU1Xzg/components_grids_usage2.png" \nstyle="width: 300px; height: auto; margin-right: 16px;" alt="Concept of grid explained visually"> <img \nsrc="//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7VGhsOE5idWlJWXM/components_grids_usage3.png" \nstyle="width: 300px; height: auto;" alt="Grid concepts legend"></p><p>\nCells are arrayed vertically and horizontally within the grid.</p><p>\nTiles hold content and can span one or more cells vertically or horizontally.</p><h3 id="responsive-attributes">\nResponsive Attributes</h3><p>The <code>md-grid-list</code>\n directive supports &quot;responsive&quot; attributes, which allow different <code>md-cols</code>, <code>md-gutter\n</code> and <code>md-row-height</code> values depending on the currently matching media query.</p><p>\nIn order to set a responsive attribute, first define the fallback value with the standard attribute name, then add additional attributes with the following convention: \n<code>{base-attribute-name}-{media-query-name}=&quot;{value}&quot;</code> (ie. <code>md-cols-lg=&quot;8&quot;</code>)\n</p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><p>Basic:</p><hljs lang="html"><md-grid-list \nmd-cols="5" md-gutter="1em" md-row-height="4:3"><md-grid-tile></md-grid-tile></md-grid-list></hljs><p>\nFixed-height rows:</p><hljs lang="html"><md-grid-list md-cols="4" md-row-height="200px" ...><md-grid-tile>\n</md-grid-tile></md-grid-list></hljs><p>Fit rows:</p><hljs lang="html"><md-grid-list md-cols="4" md-row-height="fit" \nstyle="height: 400px;" ...><md-grid-tile></md-grid-tile></md-grid-list></hljs><p>Using responsive attributes:</p><hljs \nlang="html"><md-grid-list md-cols-sm="2" md-cols-md="4" md-cols-lg="8" md-cols-gt-lg="12" ...><md-grid-tile>\n</md-grid-tile></md-grid-list></hljs></section><div class="api-param-section"><h2>Attributes</h2><div \nclass="api-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;"><b>* md-cols</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-number">number</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-number">number</code></td><td class="description"><p>\nNumber of columns in the grid.</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;"><b>\n* md-row-height</b> <span hide show-sm><code class="api-type label type-hint type-hint-string">string</code></span>\n</td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">string</code></td><td \nclass="description"><p>One of</p><ul><li>CSS length - Fixed height rows (eg. <code>8px</code> or <code>1rem</code>)\n</li><li><code>{width}:{height}</code> - Ratio of width to height (eg. <code>md-row-height=&quot;16:9&quot;</code>)\n</li><li><code>&quot;fit&quot;</code>\n - Height will be determined by subdividing the available height by the number of rows</li></ul></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">md-gutter <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nThe amount of space between tiles in CSS units (default 1px)</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-on-layout <span hide show-sm><code \nclass="api-type label type-hint type-hint-expression">expression</code></span></td><td style="white-space: nowrap;">\n<code class="api-type label type-hint type-hint-expression">expression</code></td><td class="description"><p>\nExpression to evaluate after layout. Event object is available as <code>$event</code>\n, and contains performance information.</p></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.gridList/directive/mdGridTile.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>Tiles contain the content of an <code>md-grid-list</code>\n. They span one or more grid cells vertically or horizontally, and use <code>md-grid-tile-{footer,header}</code>\n to display secondary content.</p><h3 id="responsive-attributes">Responsive Attributes</h3><p>The <code>md-grid-tile\n</code> directive supports &quot;responsive&quot; attributes, which allow different <code>md-rowspan</code> and <code>\nmd-colspan</code> values depending on the currently matching media query.</p><p>\nIn order to set a responsive attribute, first define the fallback value with the standard attribute name, then add additional attributes with the following convention: \n<code>{base-attribute-name}-{media-query-name}=&quot;{value}&quot;</code> (ie. <code>md-colspan-sm=&quot;4&quot;</code>\n)</p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><p>With header:</p><hljs lang="html">\n<md-grid-tile><md-grid-tile-header><h3>This is a header</h3></md-grid-tile-header></md-grid-tile></hljs><p>With footer:\n</p><hljs lang="html"><md-grid-tile><md-grid-tile-footer><h3>This is a footer</h3></md-grid-tile-footer></md-grid-tile>\n</hljs><p>Spanning multiple rows/columns:</p><hljs lang="html"><md-grid-tile md-colspan="2" md-rowspan="3">\n</md-grid-tile></hljs><p>Responsive attributes:</p><hljs lang="html"><md-grid-tile md-colspan="1" md-colspan-sm="3" \nmd-colspan-md="5"></md-grid-tile></hljs></section><div class="api-param-section"><h2>Attributes</h2><div \nclass="api-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;">md-colspan <span hide show-sm><code \nclass="api-type label type-hint type-hint-number">number</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-number">number</code></td><td class="description"><p>\nThe number of columns to span (default 1). Cannot exceed the number of columns in the grid. Supports interpolation.</p>\n</td></tr><tr class="api-params-item"><td style="white-space: nowrap;">md-rowspan <span hide show-sm><code \nclass="api-type label type-hint type-hint-number">number</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-number">number</code></td><td class="description"><p>\nThe number of rows to span (default 1). Supports interpolation.</p></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.fabToolbar/directive/mdFabToolbar.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>The <code>&lt;md-fab-toolbar&gt;</code>\n directive is used present a toolbar of elements (usually <code>&lt;md-button&gt;</code>\ns) for quick access to common actions when a floating action button is activated (via click or keyboard navigation).\n</p><p>You may also easily position the trigger by applying one one of the following classes to the <code>\n&lt;md-fab-toolbar&gt;</code> element:</p><ul><li><code>md-fab-top-left</code></li><li><code>md-fab-top-right</code>\n</li><li><code>md-fab-bottom-left</code></li><li><code>md-fab-bottom-right</code></li></ul><p>These CSS classes use \n<code>position: absolute</code>, so you need to ensure that the container element also uses <code>position: absolute\n</code> or <code>position: relative</code> in order for them to work.</p></div><div><section class="api-section"><h2 \nid="Usage">Usage</h2><hljs lang="html"><md-fab-toolbar md-direction="left"><md-fab-trigger><md-button \naria-label="Add..."><md-icon icon="/assets/angular-material-assets/img/icons/plus.svg"></md-icon></md-button>\n</md-fab-trigger><md-toolbar><md-fab-actions><md-button aria-label="Add User"><md-icon \nicon="/assets/angular-material-assets/img/icons/user.svg"></md-icon></md-button><md-button aria-label="Add Group">\n<md-icon icon="/assets/angular-material-assets/img/icons/group.svg"></md-icon></md-button></md-fab-actions>\n</md-toolbar></md-fab-toolbar></hljs></section><div class="api-param-section"><h2>Attributes</h2><div \nclass="api-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;"><b>* md-direction</b> <span hide show-sm>\n<code class="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code\n class="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nFrom which direction you would like the toolbar items to appear relative to the trigger element. Supports <code>left\n</code> and <code>right</code> directions.</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">\nmd-open <span hide show-sm><code class="api-type label type-hint type-hint-expression">expression</code></span></td><td\n style="white-space: nowrap;"><code class="api-type label type-hint type-hint-expression">expression</code></td><td \nclass="description"><p>Programmatically control whether or not the toolbar is visible.</p></td></tr></tbody></table>\n</div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.input/directive/mdInput.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>You can use any <code>&lt;input&gt;</code> or <code>&lt;textarea&gt;</code>\n element as a child of an <code>&lt;md-input-container&gt;</code>\n. This allows you to build complex forms for data entry.</p></div><div><section class="api-section"><h2 id="Usage">\nUsage</h2><hljs lang="html"><md-input-container><label>Color</label> <input type="text" ng-model="color" required \nmd-maxlength="10"></md-input-container></hljs><h3>With Errors</h3><p><code>md-input-container</code>\n also supports errors using the standard <code>ng-messages</code>\n directives and animates the messages when they become visible using from the <code>ngEnter</code>/<code>ngLeave</code>\n events or the <code>ngShow</code>/<code>ngHide</code> events.</p><p>\nBy default, the messages will be hidden until the input is in an error state. This is based off of the <code>\nmd-is-error</code> expression of the <code>md-input-container</code>\n. This gives the user a chance to fill out the form before the errors become visible.</p><hljs lang="html"><form \nname="colorForm"><md-input-container><label>Favorite Color</label> <input name="favoriteColor" \nng-model="favoriteColor" required><div ng-messages="userForm.lastName.$error"><div ng-message="required">\nThis is required!</div></div></md-input-container></form></hljs><p>\nWe automatically disable this auto-hiding functionality if you provide any of the following visibility directives on the \n<code>ng-messages</code> container:</p><ul><li><code>ng-if</code></li><li><code>ng-show</code>/<code>ng-hide</code>\n</li><li><code>ng-switch-when</code>/<code>ng-switch-default</code></li></ul><p>\nYou can also disable this functionality manually by adding the <code>md-auto-hide=&quot;false&quot;</code>\n expression to the <code>ng-messages</code>\n container. This may be helpful if you always want to see the error messages or if you are building your own visibilty directive.\n</p><p><em><b>Note:</b> The <code>md-auto-hide</code>\n attribute is a static string that is only checked upon initialization of the <code>ng-messages</code>\n directive to see if it equals the string <code>false</code>.</em></p><hljs lang="html"><form name="userForm">\n<md-input-container><label>Last Name</label> <input name="lastName" ng-model="lastName" required md-maxlength="10" \nminlength="4"><div ng-messages="userForm.lastName.$error" ng-show="userForm.lastName.$dirty"><div \nng-message="required">This is required!</div><div ng-message="md-maxlength">That&#39;s too long!</div><div \nng-message="minlength">That&#39;s too short!</div></div></md-input-container><md-input-container><label>Biography\n</label> <textarea name="bio" ng-model="biography" required md-maxlength="150"></textarea><div \nng-messages="userForm.bio.$error" ng-show="userForm.bio.$dirty"><div ng-message="required">This is required!</div><div \nng-message="md-maxlength">That&#39;s too long!</div></div></md-input-container><md-input-container><input \naria-label="title" ng-model="title"></md-input-container><md-input-container><input placeholder="title" \nng-model="title"></md-input-container></form></hljs><h3>Notes</h3><ul><li>Requires <a \nhref="https://docs.angularjs.org/api/ngMessages">ngMessages</a>.</li><li>Behaves like the <a \nhref="https://docs.angularjs.org/api/ng/directive/input">AngularJS input directive</a>.</li></ul><p>The <code>md-input\n</code> and <code>md-input-container</code>\n directives use very specific positioning to achieve the error animation effects. Therefore, it is <em>not</em>\n advised to use the Layout system inside of the <code>&lt;md-input-container&gt;</code>\n tags. Instead, use relative or absolute positioning.</p></section><div class="api-param-section"><h2>Attributes</h2>\n<div class="api-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;">md-maxlength <span hide show-sm><code \nclass="api-type label type-hint type-hint-number">number</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-number">number</code></td><td class="description"><p>\nThe maximum number of characters allowed in this input. If this is specified, a character counter will be shown underneath the input.\n<br><br>The purpose of <strong><code>md-maxlength</code></strong>\n is exactly to show the max length counter text. If you don&#39;t want the counter text and only need &quot;plain&quot; validation, you can use the &quot;simple&quot; \n<code>ng-maxlength</code> or maxlength attributes.<br><br><strong>Note:</strong>\n Only valid for text/string inputs (not numeric).</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">aria-label <span hide show-sm><code class="api-type label type-hint type-hint-string">\nstring</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">\nstring</code></td><td class="description"><p>\nAria-label is required when no label is present. A warning message will be logged in the console if not present.</p>\n</td></tr><tr class="api-params-item"><td style="white-space: nowrap;">placeholder <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nAn alternative approach to using aria-label when the label is not PRESENT. The placeholder text is copied to the aria-label attribute.\n</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">md-no-autogrow <span hide show-sm><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>\nWhen present, textareas will not grow automatically.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-no-asterisk <span hide show-sm><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>\nWhen present, asterisk will not be appended to required inputs label</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-detect-hidden <span hide show-sm><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>\nWhen present, textareas will be sized properly when they are revealed after being hidden. This is off by default for performance reasons because it guarantees a reflow every digest cycle.\n</p></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.input/directive/mdInputContainer.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p><code>&lt;md-input-container&gt;</code>\n is the parent of any input or textarea element.</p><p>\nInput and textarea elements will not behave properly unless the md-input-container parent is provided.</p><p>A single \n<code>&lt;md-input-container&gt;</code> should contain only one <code>&lt;input&gt;</code>\n element, otherwise it will throw an error.</p><p><b>Exception:</b> Hidden inputs (<code>\n&lt;input type=&quot;hidden&quot; /&gt;</code>\n) are ignored and will not throw an error, so you may combine these with other inputs.</p></div><div><section \nclass="api-section"><h2 id="Usage">Usage</h2><hljs lang="html"><md-input-container><label>Username</label> <input \ntype="text" ng-model="user.name"></md-input-container><md-input-container><label>Description</label> <textarea \nng-model="user.description"></textarea></md-input-container></hljs><p></p><h3>When disabling floating labels</h3><p>\n</p><hljs lang="html"><md-input-container md-no-float><input type="text" placeholder="Non-Floating Label">\n</md-input-container></hljs></section><div class="api-param-section"><h2>Attributes</h2><div class="api-param-table">\n<table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass="api-params-item"><td style="white-space: nowrap;">md-is-error <span hide show-sm><code \nclass="api-type label type-hint type-hint-expression">expression</code></span></td><td style="white-space: nowrap;">\n<code class="api-type label type-hint type-hint-expression">expression</code></td><td class="description"><p>\nWhen the given expression evaluates to true, the input container will go into error state. Defaults to erroring if the input has been touched and is invalid.\n</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">md-no-float <span hide show-sm><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>When present, <code>\nplaceholder</code> attributes on the input will not be converted to floating labels.</p></td></tr></tbody></table>\n</div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.input/directive/mdSelectOnFocus.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>The <code>md-select-on-focus</code>\n directive allows you to automatically select the element&#39;s input text on focus.</p><p></p><h3>Notes</h3><p></p>\n<ul><li>The use of <code>md-select-on-focus</code> is restricted to <code>&lt;input&gt;</code> and <code>\n&lt;textarea&gt;</code> elements.</li></ul></div><div><section class="api-section"><h2 id="Usage">Usage</h2><p></p><h3>\nUsing with an Input</h3><p></p><hljs lang="html"><md-input-container><label>Auto Select</label> <input type="text" \nmd-select-on-focus></md-input-container></hljs><p></p><h3>Using with a Textarea</h3><p></p><hljs lang="html">\n<md-input-container><label>Auto Select</label> <textarea md-select-on-focus>This text will be selected on focus.\n</textarea></md-input-container></hljs></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.icon/directive/mdIcon.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>The <code>md-icon</code>\n directive makes it easier to use vector-based icons in your app (as opposed to raster-based icons types like PNG). The directive supports both icon fonts and SVG icons.\n</p><p>Icons should be consider view-only elements that should not be used directly as buttons; instead nest a <code>\n&lt;md-icon&gt;</code> inside a <code>md-button</code> to add hover and click features.</p><h3 id="icon-fonts">\nIcon fonts</h3><p>\nIcon fonts are a technique in which you use a font where the glyphs in the font are your icons instead of text. Benefits include a straightforward way to bundle everything into a single HTTP request, simple scaling, easy color changing, and more.\n</p><p><code>md-icon</code>\n lets you consume an icon font by letting you reference specific icons in that font by name rather than character code.\n</p><h3 id="svg">SVG</h3><p>For SVGs, the problem with using <code>&lt;img&gt;</code> or a CSS <code>background-image\n</code>\n is that you can&#39;t take advantage of some SVG features, such as styling specific parts of the icon with CSS or SVG animation.\n</p><p><code>md-icon</code> makes it easier to use SVG icons by <em>inlining</em> the SVG into an <code>&lt;svg&gt;\n</code>\n element in the document. The most straightforward way of referencing an SVG icon is via URL, just like a traditional \n<code>&lt;img&gt;</code>. <code>$mdIconProvider</code>, as a convenience, lets you <em>name</em>\n an icon so you can reference it by name instead of URL throughout your templates.</p><p>\nAdditionally, you may not want to make separate HTTP requests for every icon, so you can bundle your SVG icons together and pre-load them with $mdIconProvider as an icon set. An icon set can also be given a name, which acts as a namespace for individual icons, so you can reference them like \n<code>&quot;social:cake&quot;</code>.</p><p>\nWhen using SVGs, both external SVGs (via URLs) or sets of SVGs [from icon sets] can be easily loaded and used.When use font-icons, developers must following three (3) simple steps:\n</p><ol><li>Load the font library. e.g.<br><code>\n&lt;link href=&quot;https://fonts.googleapis.com/icon?family=Material+Icons&quot; rel=&quot;stylesheet&quot;&gt;</code>\n</li><li>Use either (a) font-icon class names or (b) font ligatures to render the font glyph by using its textual name\n</li><li>Use <code>&lt;md-icon md-font-icon=&quot;classname&quot; /&gt;</code> or<br>use <code>\n&lt;md-icon md-font-set=&quot;font library classname or alias&quot;&gt; textual_name &lt;/md-icon&gt;</code> or<br>use \n<code>\n&lt;md-icon md-font-set=&quot;font library classname or alias&quot;&gt; numerical_character_reference &lt;/md-icon&gt;\n</code></li></ol><p>Full details for these steps can be found:</p><ul><li><a \nhref="http://google.github.io/material-design-icons/">http://google.github.io/material-design-icons/</a></li><li><a \nhref="http://google.github.io/material-design-icons/#icon-font-for-the-web">\nhttp://google.github.io/material-design-icons/#icon-font-for-the-web</a></li></ul><p>The Material Design icon style \n<code>.material-icons</code> and the icon font references are published in Material Design Icons:</p><ul><li><a \nhref="http://www.google.com/design/icons/">http://www.google.com/design/icons/</a></li><li><a \nhref="https://www.google.com/design/icons/#ic_accessibility">https://www.google.com/design/icons/#ic_accessibility</a>\n</li></ul><p></p><h2 id="material_design_icons">Material Design Icons</h2>\nUsing the Material Design Icon-Selector, developers can easily and quickly search for a Material Design font-icon and determine its textual name and character reference code. Click on any icon to see the slide-up information panel with details regarding a SVG download or information on the font-icon usage.\n<p></p><p><a href="https://www.google.com/design/icons/#ic_accessibility" target="_blank" style="border-bottom:none;">\n<img src="https://cloud.githubusercontent.com/assets/210413/7902490/fe8dd14c-0780-11e5-98fb-c821cc6475e6.png" \naria-label="Material Design Icon-Selector" style="max-width:75%;padding-left:10%"></a></p><p><span \nclass="image_caption">Click on the image above to link to the <a \nhref="https://www.google.com/design/icons/#ic_accessibility" target="_blank">Material Design Icon-Selector</a>.</span>\n</p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><p>When using SVGs:</p><hljs lang="html"><md-icon \nmd-svg-icon="social:android" aria-label="android "></md-icon><md-icon md-svg-src="/android.svg" aria-label="android ">\n</md-icon><md-icon md-svg-src="{{ getAndroid() }}" aria-label="android "></md-icon></hljs><p>Use the <code>\n$mdIconProvider</code> to configure your application with svg iconsets.</p><hljs lang="js">\nangular.module(&#39;appSvgIconSets&#39;, [&#39;ngMaterial&#39;]) .controller(&#39;DemoCtrl&#39;, function($scope) {}) .config(function($mdIconProvider) { $mdIconProvider .iconSet(&#39;social&#39;, &#39;assets/angular-material-assets/img/icons/sets/social-icons.svg&#39;, 24) .defaultIconSet(&#39;assets/angular-material-assets/img/icons/sets/core-icons.svg&#39;, 24); });\n</hljs><p>When using Font Icons with classnames:</p><hljs lang="html"><md-icon md-font-icon="android" \naria-label="android"></md-icon><md-icon class="icon_home" aria-label="Home"></md-icon></hljs><p>\nWhen using Material Font Icons with ligatures:</p><hljs lang="html"><md-icon>face</md-icon><md-icon \nmd-font-set="material-icons">face</md-icon><md-icon>&#xE87C;</md-icon><md-icon class="material-icons md-light md-48">\nface</md-icon></hljs><p>When using other Font-Icon libraries:</p><hljs lang="js">\n// Specify a font-icon style alias angular.config(function($mdIconProvider) { $mdIconProvider.fontSet(&#39;md&#39;, &#39;material-icons&#39;); });\n</hljs><hljs lang="html"><md-icon md-font-set="md">favorite</md-icon></hljs></section><div class="api-param-section">\n<h2>Attributes</h2><div class="api-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th>\n<th>Description</th></tr></thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;"><b>* md-font-icon\n</b> <span hide show-sm><code class="api-type label type-hint type-hint-string">string</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">string</code></td><td \nclass="description"><p>\nString name of CSS icon associated with the font-face will be used to render the icon. Requires the fonts and the named CSS styles to be preloaded.\n</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;"><b>* md-font-set</b> <span hide show-sm>\n<code class="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code\n class="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nCSS style name associated with the font library; which will be assigned as the class for the font-icon ligature. This value may also be an alias that is used to lookup the classname; internally use \n<code>$mdIconProvider.fontSet(&lt;alias&gt;)</code> to determine the style name.</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;"><b>* md-svg-src</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nString URL (or expression) used to load, cache, and display an external SVG.</p></td></tr><tr class="api-params-item">\n<td style="white-space: nowrap;"><b>* md-svg-icon</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nmd-svg-icon String name used for lookup of the icon from the internal cache; interpolated strings or expressions may also be used. Specific set names can be used with the syntax \n<code>&lt;set name&gt;:&lt;icon name&gt;</code>.<br><br>\nTo use icon sets, developers are required to pre-register the sets using the <code>$mdIconProvider</code> service.</p>\n</td></tr><tr class="api-params-item"><td style="white-space: nowrap;">aria-label <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nLabels icon for accessibility. If an empty string is provided, icon will be hidden from accessibility layer with <code>\naria-hidden=&quot;true&quot;</code>\n. If there&#39;s no aria-label on the icon nor a label on the parent element, a warning will be logged to the console.\n</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">alt <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nLabels icon for accessibility. If an empty string is provided, icon will be hidden from accessibility layer with <code>\naria-hidden=&quot;true&quot;</code>\n. If there&#39;s no alt on the icon nor a label on the parent element, a warning will be logged to the console.</p>\n</td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.icon/service/$mdIcon.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>The <code>$mdIcon</code> service is a function used to lookup SVG icons.</p></div>\n<div><section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="js">\nfunction SomeDirective($mdIcon) { // See if the icon has already been loaded, if not // then lookup the icon from the registry cache, load and cache // it for future requests. // NOTE: ID queries require configuration with $mdIconProvider $mdIcon(&#39;android&#39;).then(function(iconEl) { element.append(iconEl); }); $mdIcon(&#39;work:chair&#39;).then(function(iconEl) { element.append(iconEl); }); // Load and cache the external SVG using a URL $mdIcon(&#39;assets/angular-material-assets/img/icons/android.svg&#39;).then(function(iconEl) { element.append(iconEl); }); };\n</hljs><p>NOTE: The <code>&lt;md-icon /&gt;</code> directive internally uses the <code>$mdIcon</code>\n service to query, loaded, and instantiate SVG DOM elements.</p></section><section class="api-section"><div \nclass="api-param-section"><h2>Arguments</h2><div class="api-param-table"><table class="md-api-table"><thead><tr><th>\nParameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class="api-params-item"><td \nstyle="white-space: nowrap;"><b>* id</b> <span hide show-sm><code class="api-type label type-hint type-hint-string">\nstring</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">\nstring</code></td><td class="description"><p>\nQuery value for a unique Id or URL. If the argument is a URL, then the service will retrieve the icon element from its internal cache or load the icon and cache it first. If the value is not a URL-type string, then an ID lookup is performed. The Id may be a unique icon ID or may include an iconSet ID prefix.\n</p><p>For the <strong>id</strong>\n query to work properly, this means that all id-to-URL mappings must have been previously configured using the <code>\n$mdIconProvider</code>.</p></td></tr></tbody></table></div></div><section class="api-section"></section><div \nclass="api-param-table"><table class="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody>\n<tr><td><code class="api-type label type-hint type-hint-angular">angular.$q.Promise</code></td><td class="description">\n<p>\nA promise that gets resolved to a clone of the initial SVG DOM element; which was created from the SVG markup in the SVG data file. If an error occurs (e.g. the icon cannot be found) the promise will get rejected.\n</p></td></tr></tbody></table></div></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.icon/service/$mdIconProvider.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p><code>$mdIconProvider</code>\n is used only to register icon IDs with URLs. These configuration features allow icons and icon sets to be pre-registered and associated with source URLs \n<strong>before</strong> the <code>&lt;md-icon /&gt;</code> directives are compiled.</p><p>\nIf using font-icons, the developer is responsible for loading the fonts.</p><p>\nIf using SVGs, loading of the actual svg files are deferred to on-demand requests and are loaded internally by the \n<code>$mdIcon</code> service using the <code>$templateRequest</code> service. When an SVG is requested by name/ID, the \n<code>$mdIcon</code>\n service searches its registry for the associated source URL; that URL is used to on-demand load and parse the SVG dynamically.\n</p><p><strong>Notice:</strong> Most font-icons libraries do not support ligatures (for example <code>fontawesome\n</code>).<br>In such cases you are not able to use the icon&#39;s ligature name - Like so:</p><hljs lang="html">\n<md-icon md-font-set="fa">fa-bell</md-icon></hljs><p>\nYou should instead use the given unicode, instead of the ligature name.</p><p></p><p ng-hide="true">\n##// Notice we can&#39;t use a hljs element here, because the characters will be escaped.</p><p></p><pre><code \nclass="lang-html">&lt;md-icon md-font-set=&quot;fa&quot;&gt;&amp;#xf0f3&lt;/md-icon&gt;\n</code></pre><p>\nAll unicode ligatures are prefixed with the <code>&amp;#x</code> string.</p></div><div><section class="api-section"><h2\n id="Usage">Usage</h2><hljs lang="js">\napp.config(function($mdIconProvider) { // Configure URLs for icons specified by [set:]id. $mdIconProvider .defaultFontSet( &#39;fa&#39; ) // This sets our default fontset className. .defaultIconSet(&#39;my/app/icons.svg&#39;) // Register a default set of SVG icons .iconSet(&#39;social&#39;, &#39;my/app/social.svg&#39;) // Register a named icon set of SVGs .icon(&#39;android&#39;, &#39;my/app/android.svg&#39;) // Register a specific icon (by name) .icon(&#39;work:chair&#39;, &#39;my/app/chair.svg&#39;); // Register icon in a specific set });\n</hljs><p>\nSVG icons and icon sets can be easily pre-loaded and cached using either (a) a build process or (b) a runtime <strong>\nstartup</strong> process (shown below):</p><hljs lang="js">\napp.config(function($mdIconProvider) { // Register a default set of SVG icon definitions $mdIconProvider.defaultIconSet(&#39;my/app/icons.svg&#39;) }) .run(function($templateRequest){ // Pre-fetch icons sources by URL and cache in the $templateCache... // subsequent $templateRequest calls will look there first. var urls = [ &#39;imy/app/icons.svg&#39;, &#39;assets/angular-material-assets/img/icons/android.svg&#39;]; angular.forEach(urls, function(url) { $templateRequest(url); }); });\n</hljs><p>NOTE: the loaded SVG data is subsequently cached internally for future requests.</p></section><section \nclass="api-section"><h2>Methods</h2><br><ul class="methods"><li id="icon"><h3 class="method-function-syntax"><code \nclass="method-function-syntax">$mdIconProvider.icon(id, url, [viewBoxSize]);</code></h3><div class="service-desc"><p>\nRegister a source URL for a specific icon name; the name may include optional &#39;icon set&#39; name prefix. These icons will later be retrieved from the cache using \n<code>$mdIcon( &lt;icon name&gt; )</code></p></div><div class="method-param-table"><table class="md-api-table"><thead>\n<tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class="api-params-item"><td \nstyle="white-space: nowrap;"><b>* id</b> <span hide show-sm><code class="api-type label type-hint type-hint-string">\nstring</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">\nstring</code></td><td class="description"><p>Icon name/id used to register the icon</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;"><b>* url</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nspecifies the external location for the data file. Used internally by <code>$templateRequest</code>\n to load the data or as part of the lookup in <code>$templateCache</code> if pre-loading was configured.</p></td></tr>\n<tr class="api-params-item"><td style="white-space: nowrap;">viewBoxSize <span hide show-sm><code \nclass="api-type label type-hint type-hint-number">number</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-number">number</code></td><td class="description"><p>\nSets the width and height the icon&#39;s viewBox. It is ignored for icons with an existing viewBox. Default size is 24.\n</p></td></tr></tbody></table><table class="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class="api-type label type-hint type-hint-obj">obj</code></td><td class="description"><p>an <code>\n$mdIconProvider</code> reference; used to support method call chains for the API</p></td></tr></tbody></table></div>\n</li><li id="iconSet"><h3 class="method-function-syntax"><code class="method-function-syntax">\n$mdIconProvider.iconSet(id, url, [viewBoxSize]);</code></h3><div class="service-desc"><p>\nRegister a source URL for a &#39;named&#39; set of icons; group of SVG definitions where each definition has an icon id. Individual icons can be subsequently retrieved from this cached set using \n<code>$mdIcon(&lt;icon set name&gt;:&lt;icon name&gt;)</code></p></div><div class="method-param-table"><table \nclass="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass="api-params-item"><td style="white-space: nowrap;"><b>* id</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nIcon name/id used to register the iconset</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;"><b>\n* url</b> <span hide show-sm><code class="api-type label type-hint type-hint-string">string</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">string</code></td><td \nclass="description"><p>specifies the external location for the data file. Used internally by <code>$templateRequest\n</code> to load the data or as part of the lookup in <code>$templateCache</code> if pre-loading was configured.</p>\n</td></tr><tr class="api-params-item"><td style="white-space: nowrap;">viewBoxSize <span hide show-sm><code \nclass="api-type label type-hint type-hint-number">number</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-number">number</code></td><td class="description"><p>\nSets the width and height of the viewBox of all icons in the set. It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size. Default value is 24.\n</p></td></tr></tbody></table><table class="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class="api-type label type-hint type-hint-obj">obj</code></td><td class="description"><p>an <code>\n$mdIconProvider</code> reference; used to support method call chains for the API</p></td></tr></tbody></table></div>\n</li><li id="defaultIconSet"><h3 class="method-function-syntax"><code class="method-function-syntax">\n$mdIconProvider.defaultIconSet(url, [viewBoxSize]);</code></h3><div class="service-desc"><p>\nRegister a source URL for the default &#39;named&#39; set of icons. Unless explicitly registered, subsequent lookups of icons will failover to search this &#39;default&#39; icon set. Icon can be retrieved from this cached, default set using \n<code>$mdIcon(&lt;name&gt;)</code></p></div><div class="method-param-table"><table class="md-api-table"><thead><tr><th>\nParameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class="api-params-item"><td \nstyle="white-space: nowrap;"><b>* url</b> <span hide show-sm><code class="api-type label type-hint type-hint-string">\nstring</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">\nstring</code></td><td class="description"><p>specifies the external location for the data file. Used internally by \n<code>$templateRequest</code> to load the data or as part of the lookup in <code>$templateCache</code>\n if pre-loading was configured.</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">viewBoxSize \n<span hide show-sm><code class="api-type label type-hint type-hint-number">number</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-number">number</code></td><td \nclass="description"><p>\nSets the width and height of the viewBox of all icons in the set. It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size. Default value is 24.\n</p></td></tr></tbody></table><table class="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class="api-type label type-hint type-hint-obj">obj</code></td><td class="description"><p>an <code>\n$mdIconProvider</code> reference; used to support method call chains for the API</p></td></tr></tbody></table></div>\n</li><li id="defaultFontSet"><h3 class="method-function-syntax"><code class="method-function-syntax">\n$mdIconProvider.defaultFontSet(name);</code></h3><div class="service-desc"><p>\nWhen using Font-Icons, Angular Material assumes the the Material Design icons will be used and automatically configures the default font-set == &#39;material-icons&#39;. Note that the font-set references the font-icon library class style that should be applied to the \n<code>&lt;md-icon&gt;</code>.</p><p>Configuring the default means that the attributes <code>\nmd-font-set=&quot;material-icons&quot;</code> or <code>class=&quot;material-icons&quot;</code>\n do not need to be explicitly declared on the <code>&lt;md-icon&gt;</code> markup. For example:</p><p><code>\n&lt;md-icon&gt; face &lt;/md-icon&gt;</code> will render as <code>\n&lt;span class=&quot;material-icons&quot;&gt; face &lt;/span&gt;</code>, and</p><p><code>\n&lt;md-icon md-font-set=&quot;fa&quot;&gt; face &lt;/md-icon&gt;</code> will render as <code>\n&lt;span class=&quot;fa&quot;&gt; face &lt;/span&gt;</code></p></div><div class="method-param-table"><table \nclass="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass="api-params-item"><td style="white-space: nowrap;"><b>* name</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nof the font-library style that should be applied to the md-icon DOM element</p></td></tr></tbody></table></div></li><li\n id="fontSet"><h3 class="method-function-syntax"><code class="method-function-syntax">\n$mdIconProvider.fontSet(alias, className);</code></h3><div class="service-desc"><p>When using a font set for <code>\n&lt;md-icon&gt;</code> you must specify the correct font classname in the <code>md-font-set</code>\n attribute. If the fonset className is really long, your markup may become cluttered... an easy solution is to define an \n<code>alias</code> for your fontset:</p></div><div class="method-param-table"><table class="md-api-table"><thead><tr>\n<th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class="api-params-item"><td \nstyle="white-space: nowrap;"><b>* alias</b> <span hide show-sm><code class="api-type label type-hint type-hint-string">\nstring</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">\nstring</code></td><td class="description"><p>of the specified fontset.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;"><b>* className</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>of the fontset.</p></td>\n</tr></tbody></table></div></li><li id="defaultViewBoxSize"><h3 class="method-function-syntax"><code \nclass="method-function-syntax">$mdIconProvider.defaultViewBoxSize([viewBoxSize]);</code></h3><div class="service-desc">\n<p>While <code>&lt;md-icon /&gt;</code>\n markup can also be style with sizing CSS, this method configures the default width <strong>and</strong>\n height used for all icons; unless overridden by specific CSS. The default sizing is (24px, 24px).</p></div><div \nclass="method-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;">viewBoxSize <span hide show-sm><code \nclass="api-type label type-hint type-hint-number">number</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-number">number</code></td><td class="description"><p>\nSets the width and height of the viewBox for an icon or an icon set. All icons in a set should be the same size. The default value is 24.\n</p></td></tr></tbody></table><table class="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class="api-type label type-hint type-hint-obj">obj</code></td><td class="description"><p>an <code>\n$mdIconProvider</code> reference; used to support method call chains for the API</p></td></tr></tbody></table></div>\n</li></ul></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.menu-bar/directive/mdMenuBar.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>\nMenu bars are containers that hold multiple menus. They change the behavior and appearence of the <code>md-menu</code>\n directive to behave similar to an operating system provided menu.</p></div><div><section class="api-section"><h2 \nid="Usage">Usage</h2><hljs lang="html"><md-menu-bar><md-menu><button ng-click="$mdMenu.open()">File</button>\n<md-menu-content><md-menu-item><md-button ng-click="ctrl.sampleAction(\'share\', $event)">Share...</md-button>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-menu-item><md-menu><md-button \nng-click="$mdMenu.open()">New</md-button><md-menu-content><md-menu-item><md-button \nng-click="ctrl.sampleAction(\'New Document\', $event)">Document</md-button></md-menu-item><md-menu-item><md-button \nng-click="ctrl.sampleAction(\'New Spreadsheet\', $event)">Spreadsheet</md-button></md-menu-item><md-menu-item><md-button \nng-click="ctrl.sampleAction(\'New Presentation\', $event)">Presentation</md-button></md-menu-item><md-menu-item>\n<md-button ng-click="ctrl.sampleAction(\'New Form\', $event)">Form</md-button></md-menu-item><md-menu-item><md-button \nng-click="ctrl.sampleAction(\'New Drawing\', $event)">Drawing</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item></md-menu-item></md-menu-content></md-menu></md-menu-bar></hljs><h2 id="menu-bar-controls">\nMenu Bar Controls</h2><p>You may place <code>md-menu-items</code>\n that function as controls within menu bars. There are two modes that are exposed via the <code>type</code>\n attribute of the <code>md-menu-item</code>. <code>type=&quot;checkbox&quot;</code>\n will function as a boolean control for the <code>ng-model</code> attribute of the <code>md-menu-item</code>. <code>\ntype=&quot;radio&quot;</code> will function like a radio button, setting the <code>ngModel</code> to the <code>string\n</code> value of the <code>value</code> attribute. If you need non-string values, you can use <code>ng-value</code>\n to provide an expression (this is similar to how angular&#39;s native <code>input[type=radio]</code> works.</p><hljs \nlang="html"><md-menu-bar><md-menu><button ng-click="$mdMenu.open()">Sample Menu</button><md-menu-content><md-menu-item \ntype="checkbox" ng-model="settings.allowChanges">Allow changes</md-menu-item><md-menu-divider></md-menu-divider>\n<md-menu-item type="radio" ng-model="settings.mode" ng-value="1">Mode 1</md-menu-item><md-menu-item type="radio" \nng-model="settings.mode" ng-value="1">Mode 2</md-menu-item><md-menu-item type="radio" ng-model="settings.mode" \nng-value="1">Mode 3</md-menu-item></md-menu-content></md-menu></md-menu-bar></hljs><h3 id="nesting-menus">Nesting Menus\n</h3><p>\nMenus may be nested within menu bars. This is commonly called cascading menus. To nest a menu place the nested menu inside the content of the \n<code>md-menu-item</code>.</p><hljs lang="html"><md-menu-item><md-menu><button ng-click="$mdMenu.open()">New\n<md-menu-content><md-menu-item><md-button ng-click="ctrl.sampleAction(\'New Document\', $event)">Document</md-button>\n</md-menu-item><md-menu-item><md-button ng-click="ctrl.sampleAction(\'New Spreadsheet\', $event)">Spreadsheet</md-button>\n</md-menu-item><md-menu-item><md-button ng-click="ctrl.sampleAction(\'New Presentation\', $event)">Presentation\n</md-button></md-menu-item><md-menu-item><md-button ng-click="ctrl.sampleAction(\'New Form\', $event)">Form</md-button>\n</md-menu-item><md-menu-item><md-button ng-click="ctrl.sampleAction(\'New Drawing\', $event)">Drawing</md-button>\n</md-menu-item></md-menu-content></button></md-menu></md-menu-item></hljs></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.list/directive/mdList.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>The <code>&lt;md-list&gt;</code> directive is a list container for 1..n <code>\n&lt;md-list-item&gt;</code> tags.</p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><hljs \nlang="html"><md-list><md-list-item class="md-2-line" ng-repeat="item in todos"><md-checkbox ng-model="item.done">\n</md-checkbox><div class="md-list-item-text"><h3>{{item.title}}</h3><p>{{item.description}}</p></div></md-list-item>\n</md-list></hljs></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.list/directive/mdListItem.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>The <code>&lt;md-list-item&gt;</code>\n directive is a container intended for row items in a <code>&lt;md-list&gt;</code> container. The <code>md-2-line\n</code> and <code>md-3-line</code> classes can be added to a <code>&lt;md-list-item&gt;</code>\n to increase the height with 22px and 40px respectively.</p><h2 id="css">CSS</h2><p><code>.md-avatar</code>\n - class for image avatars</p><p><code>.md-avatar-icon</code> - class for icon avatars</p><p><code>.md-offset</code>\n - on content without an avatar</p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="html">\n<md-list><md-list-item><img class="md-avatar" ng-src="path/to/img"> <span>Item content in list</span></md-list-item>\n<md-list-item><md-icon class="md-avatar-icon" md-svg-icon="communication:phone"></md-icon><span>Item content in list\n</span></md-list-item></md-list></hljs><p><em><strong>Note:</strong>\n We automatically apply special styling when the inner contents are wrapped inside of a <code>&lt;md-button&gt;</code>\n tag. This styling is automatically ignored for <code>class=&quot;md-secondary&quot;</code>\n buttons and you can include a class of <code>class=&quot;md-exclude&quot;</code>\n if you need to use a non-secondary button that is inside the list, but does not wrap the contents.</em></p></section>\n</div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.menu/directive/mdMenu.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>\nMenus are elements that open when clicked. They are useful for displaying additional options within the context of an action.\n</p><p>Every <code>md-menu</code>\n must specify exactly two child elements. The first element is what is left in the DOM and is used to open the menu. This element is called the trigger element. The trigger element&#39;s scope has access to \n<code>$mdMenu.open($event)</code>\n which it may call to open the menu. By passing $event as argument, the corresponding event is stopped from propagating up the DOM-tree.\n</p><p>The second element is the <code>md-menu-content</code>\n element which represents the contents of the menu when it is open. Typically this will contain <code>md-menu-item\n</code>s, but you can do custom content as well.</p><hljs lang="html"><md-menu><md-button \nng-click="$mdMenu.open($event)" class="md-icon-button" aria-label="Open sample menu"><md-icon md-svg-icon="call:phone">\n</md-icon></md-button><md-menu-content><md-menu-item><md-button ng-click="doSomething()">Do Something</md-button>\n</md-menu-item></md-menu-content></md-menu></hljs><h2 id="sizing-menus">Sizing Menus</h2><p>\nThe width of the menu when it is open may be specified by specifying a <code>width</code> attribute on the <code>\nmd-menu-content</code> element. See the <a href="http://www.google.com/design/spec/components/menus.html#menus-specs">\nMaterial Design Spec</a> for more information.</p><h2 id="aligning-menus">Aligning Menus</h2><p>\nWhen a menu opens, it is important that the content aligns with the trigger element. Failure to align menus can result in jarring experiences for users as content suddenly shifts. To help with this, \n<code>md-menu</code> provides serveral APIs to help with alignment.</p><h3 id="target-mode">Target Mode</h3><p>\nBy default, <code>md-menu</code> will attempt to align the <code>md-menu-content</code>\n by aligning designated child elements in both the trigger and the menu content.</p><p>\nTo specify the alignment element in the <code>trigger</code> you can use the <code>md-menu-origin</code>\n attribute on a child element. If no <code>md-menu-origin</code> is specified, the <code>md-menu</code>\n will be used as the origin element.</p><p>Similarly, the <code>md-menu-content</code> may specify a <code>\nmd-menu-align-target</code> for a <code>md-menu-item</code> to specify the node that it should try and align with.</p>\n<p>\nIn this example code, we specify an icon to be our origin element, and an icon in our menu content to be our alignment target. This ensures that both icons are aligned when the menu opens.\n</p><hljs lang="html"><md-menu><md-button ng-click="$mdMenu.open($event)" class="md-icon-button" \naria-label="Open some menu"><md-icon md-menu-origin md-svg-icon="call:phone"></md-icon></md-button><md-menu-content>\n<md-menu-item><md-button ng-click="doSomething()" aria-label="Do something"><md-icon md-menu-align-target \nmd-svg-icon="call:phone"></md-icon>Do Something</md-button></md-menu-item></md-menu-content></md-menu></hljs><p>\nSometimes we want to specify alignment on the right side of an element, for example if we have a menu on the right side a toolbar, we want to right align our menu content.\n</p><p>We can specify the origin by using the <code>md-position-mode</code> attribute on both the <code>x</code> and \n<code>y</code> axis. Right now only the <code>x-axis</code>\n has more than one option. You may specify the default mode of <code>target target</code> or <code>target-right target\n</code> to specify a right-oriented alignment target. See the position section of the demos for more examples.</p><h3 \nid="menu-offsets">Menu Offsets</h3><p>\nIt is sometimes unavoidable to need to have a deeper level of control for the positioning of a menu to ensure perfect alignment. \n<code>md-menu</code> provides the <code>md-offset</code>\n attribute to allow pixel level specificty of adjusting the exact positioning.</p><p>\nThis offset is provided in the format of <code>x y</code> or <code>n</code> where <code>n</code>\n will be used in both the <code>x</code> and <code>y</code> axis.</p><p>For example, to move a menu by <code>2px</code>\n from the top, we can use:</p><hljs lang="html"><md-menu md-offset="2 0"></md-menu></hljs><h3 id="preventing-close">\nPreventing close</h3><p>\nSometimes you would like to be able to click on a menu item without having the menu close. To do this, ngMaterial exposes the \n<code>md-prevent-menu-close</code>\n attribute which can be added to a button inside a menu to stop the menu from automatically closing. You can then close the menu programatically by injecting \n<code>$mdMenu</code> and calling <code>$mdMenu.hide()</code>.</p><hljs lang="html"><md-menu-item><md-button \nng-click="doSomething()" aria-label="Do something" md-prevent-menu-close="md-prevent-menu-close"><md-icon \nmd-menu-align-target md-svg-icon="call:phone"></md-icon>Do Something</md-button></md-menu-item></hljs></div><div>\n<section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="html"><md-menu><md-button \nng-click="$mdMenu.open($event)" class="md-icon-button"><md-icon md-svg-icon="call:phone"></md-icon></md-button>\n<md-menu-content><md-menu-item><md-button ng-click="doSomething()">Do Something</md-button></md-menu-item>\n</md-menu-content></md-menu></hljs></section><div class="api-param-section"><h2>Attributes</h2><div \nclass="api-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;"><b>* md-position-mode</b> <span hide \nshow-sm><code class="api-type label type-hint type-hint-string">string</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">string</code></td><td \nclass="description"><p>The position mode in the form of <code>x</code>, <code>y</code>. Default value is <code>target\n</code>,<code>target</code>. Right now the <code>x</code> axis also suppports <code>target-right</code>.</p></td></tr>\n<tr class="api-params-item"><td style="white-space: nowrap;"><b>* md-offset</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nAn offset to apply to the dropdown after positioning <code>x</code>, <code>y</code>. Default value is <code>0</code>,\n<code>0</code>.</p></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.navBar/directive/mdNavBar.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>The <code>&lt;md-nav-bar&gt;</code>\n directive renders a list of material tabs that can be used for top-level page navigation. Unlike <code>&lt;md-tabs&gt;\n</code>, it has no concept of a tab body and no bar pagination.</p><p>\nBecause it deals with page navigation, certain routing concepts are built-in. Route changes via via ng-href, ui-sref, or ng-click events are supported. Alternatively, the user could simply watch currentNavItem for changes.\n</p><p>Accessibility functionality is implemented as a site navigator with a listbox, according to <a \nhref="https://www.w3.org/TR/wai-aria-practices/#Site_Navigator_Tabbed_Style">\nhttps://www.w3.org/TR/wai-aria-practices/#Site_Navigator_Tabbed_Style</a></p></div><div><section class="api-section">\n<h2 id="Usage">Usage</h2><hljs lang="html"><md-nav-bar md-selected-nav-item="currentNavItem"><md-nav-item \nmd-nav-click="goto(\'page1\')" name="page1">Page One</md-nav-item><md-nav-item md-nav-sref="app.page2" name="page2">\nPage Two</md-nav-item><md-nav-item md-nav-href="#page3" name="page3">Page Three</md-nav-item></md-nav-bar></hljs><hljs \nlang="js">\n(function() { \u2018use strict\u2019; $rootScope.$on(&#39;$routeChangeSuccess&#39;, function(event, current) { $scope.currentLink = getCurrentLinkFromRoute(current); }); });\n</hljs></section><div class="api-param-section"><h2>Attributes</h2><div class="api-param-table"><table \nclass="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass="api-params-item"><td style="white-space: nowrap;">mdSelectedNavItem <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nThe name of the current tab; this must match the name attribute of <code>&lt;md-nav-item&gt;</code></p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">navBarAriaLabel <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nAn aria-label for the nav-bar</p></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.navBar/directive/mdNavItem.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p><code>&lt;md-nav-item&gt;</code> describes a page navigation link within the <code>\n&lt;md-nav-bar&gt;</code> component. It renders an md-button as the actual link.</p><p>\nExactly one of the mdNavClick, mdNavHref, mdNavSref attributes are required to be specified.</p></div><div><section \nclass="api-section"><h2 id="Usage">Usage</h2><p>See <code>&lt;md-nav-bar&gt;</code> for usage.</p></section><div \nclass="api-param-section"><h2>Attributes</h2><div class="api-param-table"><table class="md-api-table"><thead><tr><th>\nParameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class="api-params-item"><td \nstyle="white-space: nowrap;">mdNavClick <span hide show-sm><code class="api-type label type-hint type-hint-function">\nFunction=</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-function">\nFunction=</code></td><td class="description"><p>\nFunction which will be called when the link is clicked to change the page. Renders as an <code>ng-click</code>.</p>\n</td></tr><tr class="api-params-item"><td style="white-space: nowrap;">mdNavHref <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nurl to transition to when this link is clicked. Renders as an <code>ng-href</code>.</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">mdNavSref <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nUi-router state to transition to when this link is clicked. Renders as a <code>ui-sref</code>.</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">name <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nThe name of this link. Used by the nav bar to know which link is currently selected.</p></td></tr></tbody></table>\n</div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.panel/service/$mdPanel.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p><code>$mdPanel</code>\n is a robust, low-level service for creating floating panels on the screen. It can be used to implement tooltips, dialogs, pop-ups, etc.\n</p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="js">\n(function(angular, undefined) { \u2018use strict\u2019; angular .module(&#39;demoApp&#39;, [&#39;ngMaterial&#39;]) .controller(&#39;DemoDialogController&#39;, DialogController); var panelRef; function showPanel($event) { var panelPosition = $mdPanelPosition .absolute() .top(&#39;50%&#39;) .left(&#39;50%&#39;); var panelAnimation = $mdPanelAnimation .targetEvent($event) .defaultAnimation(&#39;md-panel-animate-fly&#39;) .closeTo(&#39;.show-button&#39;); var config = { attachTo: angular.element(document.body), controller: DialogController, controllerAs: &#39;ctrl&#39;, position: panelPosition, animation: panelAnimation, targetEvent: $event, template: &#39;dialog-template.html&#39;, clickOutsideToClose: true, escapeToClose: true, focusOnOpen: true } panelRef = $mdPanel.create(config); panelRef.open() .finally(function() { panelRef = undefined; }); } function DialogController(MdPanelRef, toppings) { var toppings; function closeDialog() { MdPanelRef.close(); } } })(angular);\n</hljs></section><section class="api-section"><h2>Methods</h2><br><ul class="methods"><li id="create"><h3 \nclass="method-function-syntax"><code class="method-function-syntax">$mdPanel.create([opt_config]);</code></h3><div \nclass="service-desc"><p>Creates a panel with the specified options.</p></div><div class="method-param-table"><table \nclass="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass="api-params-item"><td style="white-space: nowrap;">opt_config <span hide show-sm><code \nclass="api-type label type-hint type-hint-object">Object</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-object">Object</code></td><td class="description"><p>\nSpecific configuration object that may contain the following properties:</p><ul><li><code>template</code> - <code>\n{string=}</code>: HTML template to show in the dialog. This <strong>must</strong>\n be trusted HTML with respect to Angular\u2019s <a href="https://docs.angularjs.org/api/ng/service/$sce">$sce service</a>.\n</li><li><code>templateUrl</code> - <code>{string=}</code>: The URL that will be used as the content of the panel.</li>\n<li><code>controller</code> - <code>{(function|string)=}</code>\n: The controller to associate with the panel. The controller can inject a reference to the returned panelRef, which allows the panel to be closed, hidden, and shown. Any fields passed in through locals or resolve will be bound to the controller.\n</li><li><code>controllerAs</code> - <code>{string=}</code>: An alias to assign the controller to on the scope.</li>\n<li><code>bindToController</code> - <code>{boolean=}</code>\n: Binds locals to the controller instead of passing them in. Defaults to true, as this is a best practice.</li><li>\n<code>locals</code> - <code>{Object=}</code>\n: An object containing key/value pairs. The keys will be used as names of values to inject into the controller. For example, \n<code>locals: {three: 3}</code> would inject <code>three</code> into the controller, with the value 3.</li><li><code>\nresolve</code> - <code>{Object=}</code>\n: Similar to locals, except it takes promises as values. The panel will not open until all of the promises resolve.\n</li><li><code>attachTo</code> - <code>{(string|!angular.JQLite|!Element)=}</code>\n: The element to attach the panel to. Defaults to appending to the root element of the application.</li><li><code>\npanelClass</code> - <code>{string=}</code>\n: A css class to apply to the panel element. This class should define any borders, box-shadow, etc. for the panel.</li>\n<li><code>zIndex</code> - <code>{number=}</code>: The z-index to place the panel at. Defaults to 80.</li><li><code>\nposition</code> - <code>{MdPanelPosition=}</code>\n: An MdPanelPosition object that specifies the alignment of the panel. For more information, see <code>MdPanelPosition\n</code>.</li><li><code>clickOutsideToClose</code> - <code>{boolean=}</code>\n: Whether the user can click outside the panel to close it. Defaults to false.</li><li><code>escapeToClose</code> - \n<code>{boolean=}</code>: Whether the user can press escape to close the panel. Defaults to false.</li><li><code>\ntrapFocus</code> - <code>{boolean=}</code>: Whether focus should be trapped within the panel. If <code>trapFocus</code>\n is true, the user will not be able to interact with the rest of the page until the panel is dismissed. Defaults to false.\n</li><li><code>focusOnOpen</code> - <code>{boolean=}</code>\n: An option to override focus behavior on open. Only disable if focusing some other way, as focus management is required for panels to be accessible. Defaults to true.\n</li><li><code>fullscreen</code> - <code>{boolean=}</code>: Whether the panel should be full screen. Applies the class \n<code>._md-panel-fullscreen</code> to the panel on open. Defaults to false.</li><li><code>animation</code> - <code>\n{MdPanelAnimation=}</code>\n: An MdPanelAnimation object that specifies the animation of the panel. For more information, see <code>\nMdPanelAnimation</code>.</li><li><code>hasBackdrop</code> - <code>{boolean=}</code>\n: Whether there should be an opaque backdrop behind the panel. Defaults to false.</li><li><code>disableParentScroll\n</code> - <code>{boolean=}</code>: Whether the user can scroll the page behind the panel. Defaults to false.</li><li>\n<code>onDomAdded</code> - <code>{function=}</code>\n: Callback function used to announce when the panel is added to the DOM.</li><li><code>onOpenComplete</code> - <code>\n{function=}</code>: Callback function used to announce when the open() action is finished.</li><li><code>onRemoving\n</code> - <code>{function=}</code>: Callback function used to announce the close/hide() action is starting.</li><li>\n<code>onDomRemoved</code> - <code>{function=}</code>\n: Callback function used to announce when the panel is removed from the DOM.</li><li><code>origin</code> - <code>\n{(string|!angular.JQLite|!Element)=}</code>\n: The element to focus on when the panel closes. This is commonly the element which triggered the opening of the panel. If you do not use \n<code>origin</code>, you need to control the focus manually.</li></ul><p>\nTODO(ErinCoughlan): Add the following config options.</p><ul><li><code>groupName</code> - <code>{string=}</code>\n: Name of panel groups. This group name is used for configuring the number of open panels and identifying specific behaviors for groups. For instance, all tooltips will be identified using the same groupName.\n</li></ul></td></tr></tbody></table><table class="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr>\n</thead><tbody><tr><td><code class="api-type label type-hint type-hint-mdpanelref">MdPanelRef</code></td><td \nclass="description"><p>panelRef</p></td></tr></tbody></table></div></li><li id="open"><h3 \nclass="method-function-syntax"><code class="method-function-syntax">$mdPanel.open([opt_config]);</code></h3><div \nclass="service-desc"><p>\nCalls the create method above, then opens the panel. This is a shortcut for creating and then calling open manually. If custom methods need to be called when the panel is added to the DOM or opened, do not use this method. Instead create the panel, chain promises on the domAdded and openComplete methods, and call open from the returned panelRef.\n</p></div><div class="method-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;">opt_config <span hide \nshow-sm><code class="api-type label type-hint type-hint-object">Object</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-object">Object</code></td><td \nclass="description"><p>Specific configuration object that may contain the properties defined in <code>$mdPanel.create\n</code>.</p></td></tr></tbody></table><table class="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr>\n</thead><tbody><tr><td><code class="api-type label type-hint type-hint-angular">angular.$q.Promise&lt;MdPanelRef&gt;\n</code></td><td class="description"><p>panelRef A promise that resolves to an instance of the panel.</p></td></tr>\n</tbody></table></div></li><li id="setGroupMaxOpen"><h3 class="method-function-syntax"><code \nclass="method-function-syntax">$mdPanel.setGroupMaxOpen(groupName, maxOpen);</code></h3><div class="service-desc"><p>\nSets the maximum number of panels in a group that can be opened at a given time.</p></div><div \nclass="method-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;"><b>* groupName</b> <span hide show-sm>\n<code class="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code\n class="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nThe name of the group to configure.</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;"><b>\n* maxOpen</b> <span hide show-sm><code class="api-type label type-hint type-hint-number">number</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-number">number</code></td><td \nclass="description"><p>The max number of panels that can be opened.</p></td></tr></tbody></table></div></li><li \nid="newPanelPosition"><h3 class="method-function-syntax"><code class="method-function-syntax">\n$mdPanel.newPanelPosition();</code></h3><div class="service-desc"><p>\nReturns a new instance of the MdPanelPosition object. Use this to create the position config object.</p></div><div \nclass="method-param-table"><table class="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class="api-type label type-hint type-hint-mdpanelposition">MdPanelPosition</code></td><td \nclass="description"><p>panelPosition</p></td></tr></tbody></table></div></li><li id="newPanelAnimation"><h3 \nclass="method-function-syntax"><code class="method-function-syntax">$mdPanel.newPanelAnimation();</code></h3><div \nclass="service-desc"><p>\nReturns a new instance of the MdPanelAnimation object. Use this to create the animation config object.</p></div><div \nclass="method-param-table"><table class="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class="api-type label type-hint type-hint-mdpanelanimation">MdPanelAnimation</code></td><td \nclass="description"><p>panelAnimation</p></td></tr></tbody></table></div></li></ul></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.panel/type/MdPanelPosition.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>Object for configuring the position of the panel. Examples:</p><p>\nCentering the panel: <code>new MdPanelPosition().absolute().center();</code></p><p>\nOverlapping the panel with an element: <code>\nnew MdPanelPosition() .relativeTo(someElement) .addPanelPosition($mdPanel.xPosition.ALIGN_START, $mdPanel.yPosition.ALIGN_TOPS);\n</code></p><p>\nAligning the panel with the bottom of an element: `new MdPanelPosition() .relativeTo(someElement) .addPanelPosition($mdPanel.xPosition.CENTER, $mdPanel.yPosition.BELOW);\n</p></div><div><section class="api-section"><h2>Methods</h2><br><ul class="methods"><li id="absolute"><h3 \nclass="method-function-syntax"><code class="method-function-syntax">MdPanelPosition.absolute();</code></h3><div \nclass="service-desc"><p>\nPositions the panel absolutely relative to the parent element. If the parent is document.body, this is equivalent to positioning the panel absolutely within the viewport.\n</p></div><div class="method-param-table"><table class="md-api-table"><thead><tr><th>Returns</th><th>Description</th>\n</tr></thead><tbody><tr><td><code class="api-type label type-hint type-hint-mdpanelposition">MdPanelPosition</code>\n</td><td class="description"></td></tr></tbody></table></div></li><li id="relativeTo"><h3 \nclass="method-function-syntax"><code class="method-function-syntax">MdPanelPosition.relativeTo(element);</code></h3>\n<div class="service-desc"><p>Positions the panel relative to a specific element.</p></div><div \nclass="method-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;"><b>* element</b> <span hide show-sm>\n<code class="api-type label type-hint type-hint-string">string</code><code \nclass="api-type label type-hint type-hint-element">Element</code><code \nclass="api-type label type-hint type-hint-angular">angular.JQLite</code></span></td><td style="white-space: nowrap;">\n<code class="api-type label type-hint type-hint-string">string</code><code \nclass="api-type label type-hint type-hint-element">Element</code><code \nclass="api-type label type-hint type-hint-angular">angular.JQLite</code></td><td class="description"><p>\nQuery selector, DOM element, or angular element to position the panel with respect to.</p></td></tr></tbody></table>\n<table class="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass="api-type label type-hint type-hint-mdpanelposition">MdPanelPosition</code></td><td class="description"></td>\n</tr></tbody></table></div></li><li id="top"><h3 class="method-function-syntax"><code class="method-function-syntax">\nMdPanelPosition.top([opt_top]);</code></h3><div class="service-desc"><p>Sets the value of <code>top</code>\n for the panel. Clears any previously set vertical position.</p></div><div class="method-param-table"><table \nclass="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass="api-params-item"><td style="white-space: nowrap;">opt_top <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>Value of <code>top\n</code>. Defaults to &#39;0&#39;.</p></td></tr></tbody></table><table class="md-api-table"><thead><tr><th>Returns</th>\n<th>Description</th></tr></thead><tbody><tr><td><code class="api-type label type-hint type-hint-mdpanelposition">\nMdPanelPosition</code></td><td class="description"></td></tr></tbody></table></div></li><li id="bottom"><h3 \nclass="method-function-syntax"><code class="method-function-syntax">MdPanelPosition.bottom([opt_bottom]);</code></h3>\n<div class="service-desc"><p>Sets the value of <code>bottom</code>\n for the panel. Clears any previously set vertical position.</p></div><div class="method-param-table"><table \nclass="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass="api-params-item"><td style="white-space: nowrap;">opt_bottom <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>Value of <code>bottom\n</code>. Defaults to &#39;0&#39;.</p></td></tr></tbody></table><table class="md-api-table"><thead><tr><th>Returns</th>\n<th>Description</th></tr></thead><tbody><tr><td><code class="api-type label type-hint type-hint-mdpanelposition">\nMdPanelPosition</code></td><td class="description"></td></tr></tbody></table></div></li><li id="left"><h3 \nclass="method-function-syntax"><code class="method-function-syntax">MdPanelPosition.left([opt_left]);</code></h3><div \nclass="service-desc"><p>Sets the value of <code>left</code>\n for the panel. Clears any previously set horizontal position.</p></div><div class="method-param-table"><table \nclass="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass="api-params-item"><td style="white-space: nowrap;">opt_left <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>Value of <code>left\n</code>. Defaults to &#39;0&#39;.</p></td></tr></tbody></table><table class="md-api-table"><thead><tr><th>Returns</th>\n<th>Description</th></tr></thead><tbody><tr><td><code class="api-type label type-hint type-hint-mdpanelposition">\nMdPanelPosition</code></td><td class="description"></td></tr></tbody></table></div></li><li id="right"><h3 \nclass="method-function-syntax"><code class="method-function-syntax">MdPanelPosition.right([opt_right]);</code></h3><div\n class="service-desc"><p>Sets the value of <code>right</code>\n for the panel. Clears any previously set horizontal position.</p></div><div class="method-param-table"><table \nclass="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass="api-params-item"><td style="white-space: nowrap;">opt_right <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>Value of <code>right\n</code>. Defaults to &#39;0&#39;.</p></td></tr></tbody></table><table class="md-api-table"><thead><tr><th>Returns</th>\n<th>Description</th></tr></thead><tbody><tr><td><code class="api-type label type-hint type-hint-mdpanelposition">\nMdPanelPosition</code></td><td class="description"></td></tr></tbody></table></div></li><li id="centerHorizontally"><h3\n class="method-function-syntax"><code class="method-function-syntax">MdPanelPosition.centerHorizontally();</code></h3>\n<div class="service-desc"><p>\nCenters the panel horizontally in the viewport. Clears any previously set horizontal position.</p></div><div \nclass="method-param-table"><table class="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class="api-type label type-hint type-hint-mdpanelposition">MdPanelPosition</code></td><td \nclass="description"></td></tr></tbody></table></div></li><li id="centerVertically"><h3 class="method-function-syntax">\n<code class="method-function-syntax">MdPanelPosition.centerVertically();</code></h3><div class="service-desc"><p>\nCenters the panel vertically in the viewport. Clears any previously set vertical position.</p></div><div \nclass="method-param-table"><table class="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class="api-type label type-hint type-hint-mdpanelposition">MdPanelPosition</code></td><td \nclass="description"></td></tr></tbody></table></div></li><li id="center"><h3 class="method-function-syntax"><code \nclass="method-function-syntax">MdPanelPosition.center();</code></h3><div class="service-desc"><p>\nCenters the panel horizontally and vertically in the viewport. This is equivalent to calling both <code>\ncenterHorizontally</code> and <code>centerVertically</code>\n. Clears any previously set horizontal and vertical positions.</p></div><div class="method-param-table"><table \nclass="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass="api-type label type-hint type-hint-mdpanelposition">MdPanelPosition</code></td><td class="description"></td>\n</tr></tbody></table></div></li><li id="addPanelPosition"><h3 class="method-function-syntax"><code \nclass="method-function-syntax">MdPanelPosition.addPanelPosition(xPosition, yPosition);</code></h3><div \nclass="service-desc"><p>\nSets the x and y position for the panel relative to another element. Can be called multiple times to specify an ordered list of panel positions. The first position which allows the panel to be completely on-screen will be chosen; the last position will be chose whether it is on-screen or not.\n</p><p>xPosition must be one of the following values available on $mdPanel.xPosition:</p><p>\nCENTER | ALIGN_START | ALIGN_END | OFFSET_START | OFFSET_END</p><hr><ul><li>*</li><li>PANEL *</li><li>*</li></ul><hr>\n<p>A B C D E</p><p>\nA: OFFSET_START (for LTR displays) B: ALIGN_START (for LTR displays) C: CENTER D: ALIGN_END (for LTR displays) E: OFFSET_END (for LTR displays)\n</p><p>yPosition must be one of the following values available on $mdPanel.yPosition:</p><p>\nCENTER | ALIGN_TOPS | ALIGN_BOTTOMS | ABOVE | BELOW</p><p>F G <strong><strong><strong>*</strong></strong></strong></p>\n<pre><code>*           *\n</code></pre><p>H <em>PANEL</em></p><pre><code>*           *\n</code></pre><p>I <strong>\n<strong><strong>*</strong></strong></strong> J</p><p>F: BELOW G: ALIGN_TOPS H: CENTER I: ALIGN_BOTTOMS J: ABOVE</p>\n</div><div class="method-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;"><b>* xPosition</b> \n<span hide show-sm><code class="api-type label type-hint type-hint-string">string</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">string</code></td><td \nclass="description"></td></tr><tr class="api-params-item"><td style="white-space: nowrap;"><b>* yPosition</b> <span \nhide show-sm><code class="api-type label type-hint type-hint-string">string</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">string</code></td><td \nclass="description"></td></tr></tbody></table><table class="md-api-table"><thead><tr><th>Returns</th><th>Description\n</th></tr></thead><tbody><tr><td><code class="api-type label type-hint type-hint-mdpanelposition">MdPanelPosition\n</code></td><td class="description"></td></tr></tbody></table></div></li><li id="withOffsetX"><h3 \nclass="method-function-syntax"><code class="method-function-syntax">MdPanelPosition.withOffsetX(offsetX);</code></h3>\n<div class="service-desc"><p>Sets the value of the offset in the x-direction.</p></div><div class="method-param-table">\n<table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass="api-params-item"><td style="white-space: nowrap;"><b>* offsetX</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"></td></tr></tbody></table>\n<table class="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass="api-type label type-hint type-hint-mdpanelposition">MdPanelPosition</code></td><td class="description"></td>\n</tr></tbody></table></div></li><li id="withOffsetY"><h3 class="method-function-syntax"><code \nclass="method-function-syntax">MdPanelPosition.withOffsetY(offsetY);</code></h3><div class="service-desc"><p>\nSets the value of the offset in the y-direction.</p></div><div class="method-param-table"><table class="md-api-table">\n<thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class="api-params-item"><td \nstyle="white-space: nowrap;"><b>* offsetY</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"></td></tr></tbody></table>\n<table class="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass="api-type label type-hint type-hint-mdpanelposition">MdPanelPosition</code></td><td class="description"></td>\n</tr></tbody></table></div></li></ul></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.panel/type/MdPanelRef.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>\nA reference to a created panel. This reference contains a unique id for the panel, along with the following properties:\n</p><ul><li><code>id</code>\n - `{string}: The unique id for the panel. This id is used to track when a panel was interacted with.</li><li><code>\nconfig</code> - <code>{Object=}</code>: The entire config object that was used in create.</li><li><code>isAttached\n</code> - <code>{boolean}</code>\n: Whether the panel is attached to the DOM. Visibility to the user does not factor into isAttached.</li></ul></div>\n<div><section class="api-section"><h2>Methods</h2><br><ul class="methods"><li id="open"><h3 \nclass="method-function-syntax"><code class="method-function-syntax">MdPanelRef.open();</code></h3><div \nclass="service-desc"><p>Attaches and shows the panel.</p></div><div class="method-param-table"><table \nclass="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass="api-type label type-hint type-hint-angular">angular.$q.Promise</code></td><td class="description"><p>\nA promise that is resolved when the panel is opened.</p></td></tr></tbody></table></div></li><li id="close"><h3 \nclass="method-function-syntax"><code class="method-function-syntax">MdPanelRef.close();</code></h3><div \nclass="service-desc"><p>Hides and detaches the panel.</p></div><div class="method-param-table"><table \nclass="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass="api-type label type-hint type-hint-angular">angular.$q.Promise</code></td><td class="description"><p>\nA promise that is resolved when the panel is closed.</p></td></tr></tbody></table></div></li><li id="attach"><h3 \nclass="method-function-syntax"><code class="method-function-syntax">MdPanelRef.attach();</code></h3><div \nclass="service-desc"><p>Create the panel elements and attach them to the DOM. The panel will be hidden by default.</p>\n</div><div class="method-param-table"><table class="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr>\n</thead><tbody><tr><td><code class="api-type label type-hint type-hint-angular">angular.$q.Promise</code></td><td \nclass="description"><p>A promise that is resolved when the panel is attached.</p></td></tr></tbody></table></div></li>\n<li id="detach"><h3 class="method-function-syntax"><code class="method-function-syntax">MdPanelRef.detach();</code>\n</h3><div class="service-desc"><p>Removes the panel from the DOM. This will NOT hide the panel before removing it.</p>\n</div><div class="method-param-table"><table class="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr>\n</thead><tbody><tr><td><code class="api-type label type-hint type-hint-angular">angular.$q.Promise</code></td><td \nclass="description"><p>A promise that is resolved when the panel is detached.</p></td></tr></tbody></table></div></li>\n<li id="show"><h3 class="method-function-syntax"><code class="method-function-syntax">MdPanelRef.show();</code></h3>\n<div class="service-desc"><p>Shows the panel.</p></div><div class="method-param-table"><table class="md-api-table">\n<thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass="api-type label type-hint type-hint-angular">angular.$q.Promise</code></td><td class="description"><p>\nA promise that is resolved when the panel has shown and animations are completed.</p></td></tr></tbody></table></div>\n</li><li id="hide"><h3 class="method-function-syntax"><code class="method-function-syntax">MdPanelRef.hide();</code>\n</h3><div class="service-desc"><p>Hides the panel.</p></div><div class="method-param-table"><table \nclass="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass="api-type label type-hint type-hint-angular">angular.$q.Promise</code></td><td class="description"><p>\nA promise that is resolved when the panel has hidden and animations are completed.</p></td></tr></tbody></table></div>\n</li><li id="destroy"><h3 class="method-function-syntax"><code class="method-function-syntax">MdPanelRef.destroy();\n</code></h3><div class="service-desc"><p>Destroys the panel. The panel cannot be opened again after this is called.</p>\n</div><div class="method-param-table"></div></li><li id="addClass"><h3 class="method-function-syntax"><code \nclass="method-function-syntax">MdPanelRef.addClass(newClass);</code></h3><div class="service-desc"><p>\nAdds a class to the panel. DO NOT use this to hide/show the panel.</p></div><div class="method-param-table"><table \nclass="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass="api-params-item"><td style="white-space: nowrap;"><b>* newClass</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>Class to be added.</p>\n</td></tr></tbody></table></div></li><li id="removeClass"><h3 class="method-function-syntax"><code \nclass="method-function-syntax">MdPanelRef.removeClass(oldClass);</code></h3><div class="service-desc"><p>\nRemoves a class from the panel. DO NOT use this to hide/show the panel.</p></div><div class="method-param-table"><table\n class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass="api-params-item"><td style="white-space: nowrap;"><b>* oldClass</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>Class to be removed.</p>\n</td></tr></tbody></table></div></li><li id="toggleClass"><h3 class="method-function-syntax"><code \nclass="method-function-syntax">MdPanelRef.toggleClass(toggleClass);</code></h3><div class="service-desc"><p>\nToggles a class on the panel. DO NOT use this to hide/show the panel.</p></div><div class="method-param-table"><table \nclass="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass="api-params-item"><td style="white-space: nowrap;"><b>* toggleClass</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>Class to be toggled.</p>\n</td></tr></tbody></table></div></li><li id="focusOnOpen"><h3 class="method-function-syntax"><code \nclass="method-function-syntax">MdPanelRef.focusOnOpen();</code></h3><div class="service-desc"><p>\nFocuses the panel content if the focusOnOpen config value is true.</p></div><div class="method-param-table"></div></li>\n</ul></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.progressCircular/directive/mdProgressCircular.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>\nThe circular progress directive is used to make loading content in your app as delightful and painless as possible by minimizing the amount of visual change a user sees before they can view and interact with content.\n</p><p>\nFor operations where the percentage of the operation completed can be determined, use a determinate indicator. They give users a quick sense of how long an operation will take.\n</p><p>\nFor operations where the user is asked to wait a moment while something finishes up, and it\u2019s not necessary to expose what&#39;s happening behind the scenes and how long it will take, use an indeterminate indicator.\n</p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="html"><md-progress-circular \nmd-mode="determinate" value="..."></md-progress-circular><md-progress-circular md-mode="determinate" ng-value="...">\n</md-progress-circular><md-progress-circular md-mode="determinate" value="..." md-diameter="100">\n</md-progress-circular><md-progress-circular md-mode="indeterminate"></md-progress-circular></hljs></section><div \nclass="api-param-section"><h2>Attributes</h2><div class="api-param-table"><table class="md-api-table"><thead><tr><th>\nParameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class="api-params-item"><td \nstyle="white-space: nowrap;"><b>* md-mode</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nSelect from one of two modes: <strong>&#39;determinate&#39;</strong> and <strong>&#39;indeterminate&#39;</strong>.</p>\n<p>Note: if the <code>md-mode</code> value is set as undefined or specified as not 1 of the two (2) valid modes, then \n<strong>&#39;indeterminate&#39;</strong> will be auto-applied as the mode.</p><p>Note: if not configured, the <code>\nmd-mode=&quot;indeterminate&quot;</code> will be auto injected as an attribute. If <code>value=&quot;&quot;</code>\n is also specified, however, then <code>md-mode=&quot;determinate&quot;</code> would be auto-injected instead.</p></td>\n</tr><tr class="api-params-item"><td style="white-space: nowrap;">value <span hide show-sm><code \nclass="api-type label type-hint type-hint-number">number</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-number">number</code></td><td class="description"><p>\nIn determinate mode, this number represents the percentage of the circular progress. Default: 0</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">md-diameter <span hide show-sm><code \nclass="api-type label type-hint type-hint-number">number</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-number">number</code></td><td class="description"><p>\nThis specifies the diameter of the circular progress. The value should be a pixel-size value (eg &#39;100&#39;). If this attribute is not present then a default value of &#39;50px&#39; is assumed.\n</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">ng-disabled <span hide show-sm><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>\nDetermines whether to disable the progress element.</p></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.progressCircular/service/$mdProgressCircular.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>Allows the user to specify the default options for the <code>progressCircular</code>\n directive.</p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="js">\nmyAppModule.config(function($mdProgressCircularProvider) { // Example of changing the default progress options. $mdProgressCircularProvider.configure({ progressSize: 100, strokeWidth: 20, duration: 800 }); });\n</hljs></section><section class="api-section"><h2>Properties</h2><div class="api-param-table"><table \nclass="md-api-table"><thead><tr><th>Property</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass="api-params-item"><td style="white-space: nowrap;"><b>* progressSize</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-number">number</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-number">number</code></td><td class="description"><p>\nDiameter of the progress circle in pixels.</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">\n<b>* strokeWidth</b> <span hide show-sm><code class="api-type label type-hint type-hint-number">number</code></span>\n</td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-number">number</code></td><td \nclass="description"><p>Width of the circle&#39;s stroke as a percentage of the circle&#39;s size.</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;"><b>* duration</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-number">number</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-number">number</code></td><td class="description"><p>\nLength of the circle animation in milliseconds.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;"><b>* easeFn</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-function">function</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-function">function</code></td><td class="description"><p>\nDefault easing animation function.</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;"><b>\n* easingPresets</b> <span hide show-sm><code class="api-type label type-hint type-hint-object">object</code></span>\n</td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-object">object</code></td><td \nclass="description"><p>Collection of pre-defined easing functions.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;"><b>* durationIndeterminate</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-number">number</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-number">number</code></td><td class="description"><p>\nDuration of the indeterminate animation.</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;"><b>\n* startIndeterminate</b> <span hide show-sm><code class="api-type label type-hint type-hint-number">number</code>\n</span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-number">number</code></td>\n<td class="description"><p>Indeterminate animation start point.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;"><b>* endIndeterminate</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-number">number</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-number">number</code></td><td class="description"><p>\nIndeterminate animation end point.</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;"><b>\n* easeFnIndeterminate</b> <span hide show-sm><code class="api-type label type-hint type-hint-function">function</code>\n</span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-function">function</code>\n</td><td class="description"><p>Easing function to be used when animating between the indeterminate values.</p></td>\n</tr><tr class="api-params-item"><td style="white-space: nowrap;"><b>* configure</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-function">function(object): object</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-function">function(object): object</code>\n</td><td class="description"><p>Used to modify the default options.</p></td></tr></tbody></table></div></section></div>\n</div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.radioButton/directive/mdRadioButton.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>The <code>&lt;md-radio-button&gt;</code>\ndirective is the child directive required to be used within <code>&lt;md-radio-group&gt;</code> elements.</p><p>\nWhile similar to the <code>&lt;input type=&quot;radio&quot; ng-model=&quot;&quot; value=&quot;&quot;&gt;</code>\n directive, the <code>&lt;md-radio-button&gt;</code>\n directive provides ink effects, ARIA support, and supports use within named radio groups.</p></div><div><section \nclass="api-section"><h2 id="Usage">Usage</h2><hljs lang="html"><md-radio-button value="1" aria-label="Label 1">Label 1\n</md-radio-button><md-radio-button ng-model="color" ng-value="specialValue" aria-label="Green">Green</md-radio-button>\n</hljs></section><div class="api-param-section"><h2>Attributes</h2><div class="api-param-table"><table \nclass="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass="api-params-item"><td style="white-space: nowrap;"><b>* ngModel</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nAssignable angular expression to data-bind to.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;"><b>* ngValue</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nAngular expression which sets the value to which the expression should be set when selected.</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;"><b>* value</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nThe value to which the expression should be set when selected.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">ngChange <span hide show-sm><code class="api-type label type-hint type-hint-string">string\n</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">string\n</code></td><td class="description"><p>\nAngular expression to be executed when input changes due to user interaction with the input element.</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">name <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nProperty name of the form under which the control is published.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">aria-label <span hide show-sm><code class="api-type label type-hint type-hint-string">\nstring</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">\nstring</code></td><td class="description"><p>\nAdds label to radio button for accessibility. Defaults to radio button&#39;s text. If no text content is available, a warning will be logged.\n</p></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.radioButton/directive/mdRadioGroup.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>The <code>&lt;md-radio-group&gt;</code>\n directive identifies a grouping container for the 1..n grouped radio buttons; specified using nested <code>\n&lt;md-radio-button&gt;</code> tags.</p><p>As per the <a \nhref="http://www.google.com/design/spec/style/color.html#color-ui-color-application">material design spec</a>\n the radio button is in the accent color by default. The primary color palette may be used with the <code>md-primary\n</code> class.</p><p>Note: <code>&lt;md-radio-group&gt;</code> and <code>&lt;md-radio-button&gt;</code>\n handle tabindex differently than the native <code>&lt;input type=&#39;radio&#39;&gt;</code>\n controls. Whereas the native controls force the user to tab through all the radio buttons, <code>\n&lt;md-radio-group&gt;</code> is focusable, and by default the <code>&lt;md-radio-button&gt;</code>s are not.</p></div>\n<div><section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="html"><md-radio-group ng-model="selected">\n<md-radio-button ng-repeat="d in colorOptions" ng-value="d.value" aria-label="{{ d.label }}">{{ d.label }}\n</md-radio-button></md-radio-group></hljs></section><div class="api-param-section"><h2>Attributes</h2><div \nclass="api-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;"><b>* ng-model</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nAssignable angular expression to data-bind to.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-no-ink <span hide show-sm><code class="api-type label type-hint type-hint-boolean">\nboolean</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-boolean">\nboolean</code></td><td class="description"><p>Use of attribute indicates flag to disable ink ripple effects.</p></td>\n</tr></tbody></table></div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.progressLinear/directive/mdProgressLinear.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>\nThe linear progress directive is used to make loading content in your app as delightful and painless as possible by minimizing the amount of visual change a user sees before they can view and interact with content.\n</p><p>\nEach operation should only be represented by one activity indicator For example: one refresh operation should not display both a refresh bar and an activity circle.\n</p><p>\nFor operations where the percentage of the operation completed can be determined, use a determinate indicator. They give users a quick sense of how long an operation will take.\n</p><p>\nFor operations where the user is asked to wait a moment while something finishes up, and it\u2019s not necessary to expose what&#39;s happening behind the scenes and how long it will take, use an indeterminate indicator.\n</p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="html"><md-progress-linear \nmd-mode="determinate" value="..."></md-progress-linear><md-progress-linear md-mode="determinate" ng-value="...">\n</md-progress-linear><md-progress-linear md-mode="indeterminate"></md-progress-linear><md-progress-linear \nmd-mode="buffer" value="..." md-buffer-value="..."></md-progress-linear><md-progress-linear md-mode="query">\n</md-progress-linear></hljs></section><div class="api-param-section"><h2>Attributes</h2><div class="api-param-table">\n<table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass="api-params-item"><td style="white-space: nowrap;"><b>* md-mode</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nSelect from one of four modes: determinate, indeterminate, buffer or query.</p><p>Note: if the <code>md-mode</code>\n value is set as undefined or specified as 1 of the four (4) valid modes, then <code>indeterminate</code>\n will be auto-applied as the mode.</p><p>Note: if not configured, the <code>md-mode=&quot;indeterminate&quot;</code>\n will be auto injected as an attribute. If <code>value=&quot;&quot;</code> is also specified, however, then <code>\nmd-mode=&quot;determinate&quot;</code> would be auto-injected instead.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">value <span hide show-sm><code class="api-type label type-hint type-hint-number">number\n</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-number">number\n</code></td><td class="description"><p>\nIn determinate and buffer modes, this number represents the percentage of the primary progress bar. Default: 0</p></td>\n</tr><tr class="api-params-item"><td style="white-space: nowrap;">md-buffer-value <span hide show-sm><code \nclass="api-type label type-hint type-hint-number">number</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-number">number</code></td><td class="description"><p>\nIn the buffer mode, this number represents the percentage of the secondary progress bar. Default: 0</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">ng-disabled <span hide show-sm><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>\nDetermines whether to disable the progress element.</p></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.select/directive/mdSelect.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>Displays a select box, bound to an ng-model.</p></div><div><section \nclass="api-section"><h2 id="Usage">Usage</h2><p>With a placeholder (label and aria-label are added dynamically)</p>\n<hljs lang="html"><md-input-container><md-select ng-model="someModel" placeholder="Select a state"><md-option \nng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option></md-select></md-input-container></hljs><p>\nWith an explicit label</p><hljs lang="html"><md-input-container><label>State</label><md-select ng-model="someModel">\n<md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option></md-select></md-input-container>\n</hljs><p>With a select-header</p><p>\nWhen a developer needs to put more than just a text label in the md-select-menu, they should use the md-select-header. The user can put custom HTML inside of the header and style it to their liking. One common use case of this would be a sticky search bar.\n</p><p>When using the md-select-header the labels that would previously be added to the OptGroupDirective are ignored.\n</p><hljs lang="html"><md-input-container><md-select ng-model="someModel"><md-select-header><span>Neighborhoods -\n</span></md-select-header><md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option></md-select>\n</md-input-container></hljs><h2 id="selects-and-object-equality">Selects and object equality</h2><p>When using a <code>\nmd-select</code>\n to pick from a list of objects, it is important to realize how javascript handles equality. Consider the following example:\n</p><hljs lang="js">\nangular.controller(&#39;MyCtrl&#39;, function($scope) { $scope.users = [ { id: 1, name: &#39;Bob&#39; }, { id: 2, name: &#39;Alice&#39; }, { id: 3, name: &#39;Steve&#39; } ]; $scope.selectedUser = { id: 1, name: &#39;Bob&#39; }; });\n</hljs><hljs lang="html"><div ng-controller="MyCtrl"><md-select ng-model="selectedUser"><md-option ng-value="user" \nng-repeat="user in users">{{ user.name }}</md-option></md-select></div></hljs><p>\nAt first one might expect that the select should be populated with &quot;Bob&quot; as the selected user. However, this is not true. To determine whether something is selected, \n<code>ngModelController</code> is looking at whether <code>$scope.selectedUser == (any user in $scope.users);</code>;\n</p><p>Javascript&#39;s <code>==</code>\n operator does not check for deep equality (ie. that all properties on the object are the same), but instead whether the objects are \n<em>the same object in memory</em>\n. In this case, we have two instances of identical objects, but they exist in memory as unique entities. Because of this, the select will have no value populated for a selected user.\n</p><p>To get around this, <code>ngModelController</code> provides a <code>track by</code>\n option that allows us to specify a different expression which will be used for the equality operator. As such, we can update our \n<code>html</code> to make use of this by specifying the <code>\nng-model-options=&quot;{trackBy: &#39;$value.id&#39;}&quot;</code> on the <code>md-select</code>\n element. This converts our equality expression to be <code>\n$scope.selectedUser.id == (any id in $scope.users.map(function(u) { return u.id; }));</code>\n which results in Bob being selected as desired.</p><p>Working HTML:</p><hljs lang="html"><div ng-controller="MyCtrl">\n<md-select ng-model="selectedUser" ng-model-options="{trackBy: \'$value.id\'}"><md-option ng-value="user" \nng-repeat="user in users">{{ user.name }}</md-option></md-select></div></hljs></section><div class="api-param-section">\n<h2>Attributes</h2><div class="api-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th>\n<th>Description</th></tr></thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;"><b>* ng-model</b> \n<span hide show-sm><code class="api-type label type-hint type-hint-expression">expression</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-expression">expression</code></td><td \nclass="description"><p>The model!</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">multiple \n<span hide show-sm><code class="api-type label type-hint type-hint-boolean">boolean</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-boolean">boolean</code></td><td \nclass="description"><p>Whether it&#39;s multiple.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-on-close <span hide show-sm><code \nclass="api-type label type-hint type-hint-expression">expression</code></span></td><td style="white-space: nowrap;">\n<code class="api-type label type-hint type-hint-expression">expression</code></td><td class="description"><p>\nExpression to be evaluated when the select is closed.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-on-open <span hide show-sm><code class="api-type label type-hint type-hint-expression">\nexpression</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-expression">expression</code></td><td class="description"><p>\nExpression to be evaluated when opening the select. Will hide the select options and show a spinner until the evaluated promise resolves.\n</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">md-selected-text <span hide show-sm><code \nclass="api-type label type-hint type-hint-expression">expression</code></span></td><td style="white-space: nowrap;">\n<code class="api-type label type-hint type-hint-expression">expression</code></td><td class="description"><p>\nExpression to be evaluated that will return a string to be displayed as a placeholder in the select input box when it is closed.\n</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">placeholder <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>Placeholder hint text.\n</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">aria-label <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nOptional label for accessibility. Only necessary if no placeholder or explicit label is present.</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">md-container-class <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nClass list to get applied to the <code>._md-select-menu-container</code> element (for custom styling).</p></td></tr>\n</tbody></table></div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.slider/directive/mdSlider.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>The <code>&lt;md-slider&gt;</code>\n component allows the user to choose from a range of values.</p><p>As per the <a \nhref="http://www.google.com/design/spec/style/color.html#color-ui-color-application">material design spec</a>\n the slider is in the accent color by default. The primary color palette may be used with the <code>md-primary</code>\n class.</p><p>\nIt has two modes: &#39;normal&#39; mode, where the user slides between a wide range of values, and &#39;discrete&#39; mode, where the user slides between only a few select values.\n</p><p>To enable discrete mode, add the <code>md-discrete</code> attribute to a slider, and use the <code>step</code>\n attribute to change the distance between values the user is allowed to pick.</p></div><div><section \nclass="api-section"><h2 id="Usage">Usage</h2><p></p><h4>Normal Mode</h4><p></p><hljs lang="html"><md-slider \nng-model="myValue" min="5" max="500"></md-slider></hljs><h4>Discrete Mode</h4><hljs lang="html"><md-slider md-discrete \nng-model="myDiscreteValue" step="10" min="10" max="130"></md-slider></hljs></section><div class="api-param-section">\n<h2>Attributes</h2><div class="api-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th>\n<th>Description</th></tr></thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;">md-discrete <span \nhide show-sm><code class="api-type label type-hint type-hint-boolean">boolean</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-boolean">boolean</code></td><td \nclass="description"><p>Whether to enable discrete mode.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">step <span hide show-sm><code class="api-type label type-hint type-hint-number">number\n</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-number">number\n</code></td><td class="description"><p>The distance between values the user is allowed to pick. Default 1.</p></td>\n</tr><tr class="api-params-item"><td style="white-space: nowrap;">min <span hide show-sm><code \nclass="api-type label type-hint type-hint-number">number</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-number">number</code></td><td class="description"><p>\nThe minimum value the user is allowed to pick. Default 0.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">max <span hide show-sm><code class="api-type label type-hint type-hint-number">number\n</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-number">number\n</code></td><td class="description"><p>The maximum value the user is allowed to pick. Default 100.</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">round <span hide show-sm><code \nclass="api-type label type-hint type-hint-number">number</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-number">number</code></td><td class="description"><p>\nThe amount of numbers after the decimal point, maximum is 6 to prevent scientific notation. Default 3.</p></td></tr>\n</tbody></table></div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.slider/directive/mdSliderContainer.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>The <code>&lt;md-slider-container&gt;</code>\n contains slider with two other elements.</p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><p></p>\n<h4>Normal Mode</h4><p></p><hljs lang="html"></hljs></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.sidenav/directive/mdSidenav.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>A Sidenav component that can be opened and closed programatically.</p><p>\nBy default, upon opening it will slide out on top of the main content area.</p><p>\nFor keyboard and screen reader accessibility, focus is sent to the sidenav wrapper by default. It can be overridden with the \n<code>md-autofocus</code> directive on the child element you want focused.</p></div><div><section class="api-section">\n<h2 id="Usage">Usage</h2><hljs lang="html"><div layout="row" ng-controller="MyController"><md-sidenav \nmd-component-id="left" class="md-sidenav-left">Left Nav!</md-sidenav><md-content>Center Content<md-button \nng-click="openLeftMenu()">Open Left Menu</md-button></md-content><md-sidenav md-component-id="right" \nmd-is-locked-open="$mdMedia(\'min-width: 333px\')" class="md-sidenav-right"><form><md-input-container><label \nfor="testInput">Test input</label> <input id="testInput" type="text" ng-model="data" md-autofocus></md-input-container>\n</form></md-sidenav></div></hljs><hljs lang="js">\nvar app = angular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]); app.controller(&#39;MyController&#39;, function($scope, $mdSidenav) { $scope.openLeftMenu = function() { $mdSidenav(&#39;left&#39;).toggle(); }; });\n</hljs></section><div class="api-param-section"><h2>Attributes</h2><div class="api-param-table"><table \nclass="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass="api-params-item"><td style="white-space: nowrap;">md-is-open <span hide show-sm><code \nclass="api-type label type-hint type-hint-expression">expression</code></span></td><td style="white-space: nowrap;">\n<code class="api-type label type-hint type-hint-expression">expression</code></td><td class="description"><p>\nA model bound to whether the sidenav is opened.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-disable-backdrop <span hide show-sm><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>\nWhen present in the markup, the sidenav will not show a backdrop.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-component-id <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\ncomponentId to use with $mdSidenav service.</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">\nmd-is-locked-open <span hide show-sm><code class="api-type label type-hint type-hint-expression">expression</code>\n</span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-expression">expression\n</code></td><td class="description"><p>\nWhen this expression evaluates to true, the sidenav &#39;locks open&#39;: it falls into the content&#39;s flow instead of appearing over it. This overrides the \n<code>md-is-open</code> attribute.</p><p>\nThe $mdMedia() servic e is exposed to the is-locked-open attribute, which can be given a media query or one of the \n<code>sm</code>, <code>gt-sm</code>, <code>md</code>, <code>gt-md</code>, <code>lg</code> or <code>gt-lg</code>\n presets. Examples:</p><ul><li><code>&lt;md-sidenav md-is-locked-open=&quot;shouldLockOpen&quot;&gt;&lt;/md-sidenav&gt;\n</code></li><li><code>\n&lt;md-sidenav md-is-locked-open=&quot;$mdMedia(&#39;min-width: 1000px&#39;)&quot;&gt;&lt;/md-sidenav&gt;</code></li>\n<li><code>&lt;md-sidenav md-is-locked-open=&quot;$mdMedia(&#39;sm&#39;)&quot;&gt;&lt;/md-sidenav&gt;</code>\n (locks open on small screens)</li></ul></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.sidenav/directive/mdSidenavFocus.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p><code>mdSidenavFocus</code>\n provides a way to specify the focused element when a sidenav opens. This is completely optional, as the sidenav itself is focused by default.\n</p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="html"><md-sidenav><form>\n<md-input-container><label for="testInput">Label</label> <input id="testInput" type="text" md-sidenav-focus>\n</md-input-container></form></md-sidenav></hljs></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.sidenav/service/$mdSidenav.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p><code>$mdSidenav</code>\n makes it easy to interact with multiple sidenavs in an app. When looking up a sidenav instance, you can either look it up synchronously or wait for it to be initializied asynchronously. This is done by passing the second argument to \n<code>$mdSidenav</code>.</p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="js">\n// Async lookup for sidenav instance; will resolve when the instance is available $mdSidenav(componentId, true).then(function(instance) { $log.debug( componentId + &quot;is now ready&quot; ); }); // Sync lookup for sidenav instance; this will resolve immediately. $mdSidenav(componentId).then(function(instance) { $log.debug( componentId + &quot;is now ready&quot; ); }); // Async toggle the given sidenav; // when instance is known ready and lazy lookup is not needed. $mdSidenav(componentId) .toggle() .then(function(){ $log.debug(&#39;toggled&#39;); }); // Async open the given sidenav $mdSidenav(componentId) .open() .then(function(){ $log.debug(&#39;opened&#39;); }); // Async close the given sidenav $mdSidenav(componentId) .close() .then(function(){ $log.debug(&#39;closed&#39;); }); // Sync check to see if the specified sidenav is set to be open $mdSidenav(componentId).isOpen(); // Sync check to whether given sidenav is locked open // If this is true, the sidenav will be open regardless of close() $mdSidenav(componentId).isLockedOpen();\n</hljs></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.sticky/service/$mdSticky.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>The <code>$mdSticky</code>service provides a mixin to make elements sticky.</p><p>\nBy default the <code>$mdSticky</code> service compiles the cloned element, when not specified through the <code>\nelementClone</code> parameter, in the same scope as the actual element lives.</p><p></p><h3>Notes</h3>\nWhen using an element which is containing a compiled directive, which changed its DOM structure during compilation, you should compile the clone yourself using the plain template.\n<br><br>See the right usage below:<p></p><hljs lang="js">\nangular.module(&#39;myModule&#39;) .directive(&#39;stickySelect&#39;, function($mdSticky, $compile) { var SELECT_TEMPLATE = &#39;\n<md-select ng-model="selected">&#39; + &#39;<md-option>Option 1</md-option>&#39; + &#39;</md-select>\n&#39;; return { restrict: &#39;E&#39;, replace: true, template: SELECT_TEMPLATE, link: function(scope,element) { $mdSticky(scope, element, $compile(SELECT_TEMPLATE)(scope)); } }; });\n</hljs></div><div><section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="js">\nangular.module(&#39;myModule&#39;) .directive(&#39;stickyText&#39;, function($mdSticky, $compile) { return { restrict: &#39;E&#39;, template: &#39;\n<span>Sticky Text</span>&#39;, link: function(scope,element) { $mdSticky(scope, element); } }; });</hljs></section>\n<section class="api-section"><section class="api-section"></section><div class="api-param-table"><table \nclass="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td></td><td \nclass="description"><p>A <code>$mdSticky</code> function that takes three arguments:</p><ul><li><code>scope</code></li>\n<li><code>element</code>: The element that will be &#39;sticky&#39;</li><li><code>elementClone</code>\n: A clone of the element, that will be shown when the user starts scrolling past the original element. If not provided, it will use the result of \n<code>element.clone()</code> and compiles it in the given scope.</li></ul></td></tr></tbody></table></div></section>\n</div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.subheader/directive/mdSubheader.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>The <code>&lt;md-subheader&gt;</code>\n directive is a subheader for a section. By default it is sticky. You can make it not sticky by applying the <code>\nmd-no-sticky</code> class to the subheader.</p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><hljs \nlang="html"><md-subheader>Online Friends</md-subheader></hljs></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.toast/service/$mdToast.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p><code>$mdToast</code>\n is a service to build a toast notification on any position on the screen with an optional duration, and provides a simple promise API.\n</p><p>The toast will be always positioned at the <code>bottom</code>, when the screen size is between <code>600px\n</code> and <code>959px</code> (<code>sm</code> breakpoint)</p><h2 id="restrictions-on-custom-toasts">\nRestrictions on custom toasts</h2><ul><li>The toast&#39;s template must have an outer <code>&lt;md-toast&gt;</code>\n element.</li><li>For a toast action, use element with class <code>md-action</code>.</li><li>Add the class <code>\nmd-capsule</code> for curved corners.</li></ul><h2 id="parent-container-notes">Parent container notes</h2><p>\nThe toast is positioned using absolute positioning relative to it&#39;s first non-static parent container. Thus, if the requested parent container uses static positioning, we will temporarily set it&#39;s positioning to \n<code>relative</code> while the toast is visible and reset it when the toast is hidden.</p><p>\nBecause of this, it is usually best to ensure that the parent container has a fixed height and prevents scrolling by setting the \n<code>overflow: hidden;</code>\n style. Since the position is based off of the parent&#39;s height, the toast may be mispositioned if you allow the parent to scroll.\n</p><p>\nYou can, however, have a scrollable element inside of the container; just make sure the container itself does not scroll.\n</p><hljs lang="html"><div layout-fill id="toast-container"><md-content>I can have lots of content and scroll!\n</md-content></div></hljs></div><div><section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="html"><div \nng-controller="MyController"><md-button ng-click="openToast()">Open a Toast!</md-button></div></hljs><hljs lang="js">\nvar app = angular.module(&#39;app&#39;, [&#39;ngMaterial&#39;]); app.controller(&#39;MyController&#39;, function($scope, $mdToast) { $scope.openToast = function($event) { $mdToast.show($mdToast.simple().textContent(&#39;Hello!&#39;)); // Could also do $mdToast.showSimple(&#39;Hello&#39;); }; });\n</hljs></section><section class="api-section"><h2>Methods</h2><br><ul class="methods"><li id="showSimple"><h3 \nclass="method-function-syntax"><code class="method-function-syntax">$mdToast.showSimple(message);</code></h3><div \nclass="service-desc"><p>Convenience method which builds and shows a simple toast.</p></div><div \nclass="method-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;"><b>* message</b> <span hide show-sm>\n<code class="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code\n class="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nThe message to display inside the toast</p></td></tr></tbody></table><table class="md-api-table"><thead><tr><th>Returns\n</th><th>Description</th></tr></thead><tbody><tr><td><code class="api-type label type-hint type-hint-promise">promise\n</code></td><td class="description"><p>A promise that can be resolved with <code>$mdToast.hide()</code>\n or rejected with <code>$mdToast.cancel()</code>.</p></td></tr></tbody></table></div></li><li id="simple"><h3 \nclass="method-function-syntax"><code class="method-function-syntax">$mdToast.simple();</code></h3><div \nclass="service-desc"><p>Builds a preconfigured toast.</p></div><div class="method-param-table"><table \nclass="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass="api-type label type-hint type-hint-obj">obj</code></td><td class="description"><p>a <code>$mdToastPreset</code>\n with the following chainable configuration methods.</p><p><em><strong>Note:</strong>\n These configuration methods are provided in addition to the methods provided by the <code>build()</code> and <code>\nshow()</code> methods below.</em></p><table class="md-api-table methods"><thead><tr><th>Method</th><th>Description</th>\n</tr></thead><tbody><tr><td><code>.textContent(string)</code></td><td>Sets the toast content to the specified string\n</td></tr><tr><td><code>.action(string)</code></td><td>Adds an action button.<br>\nIf clicked, the promise (returned from <code>show()</code>) will resolve with the value <code>&#39;ok&#39;</code>\n; otherwise, it is resolved with <code>true</code> after a <code>hideDelay</code> timeout</td></tr><tr><td><code>\n.highlightAction(boolean)</code></td><td>Whether or not the action button will have an additional highlight class.<br>\nBy default the <code>accent</code> color will be applied to the action button.</td></tr><tr><td><code>\n.highlightClass(string)</code></td><td>If set, the given class will be applied to the highlighted action button.<br>\nThis allows you to specify the highlight color easily. Highlight classes are <code>md-primary</code>, <code>md-warn\n</code> and <code>md-accent</code></td></tr><tr><td><code>.capsule(boolean)</code></td><td>Whether or not to add the \n<code>md-capsule</code> class to the toast to provide rounded corners</td></tr><tr><td><code>.theme(string)</code></td>\n<td>Sets the theme on the toast to the requested theme. Default is <code>$mdThemingProvider</code>&#39;s default.</td>\n</tr></tbody></table></td></tr></tbody></table></div></li><li id="updateTextContent"><h3 \nclass="method-function-syntax"><code class="method-function-syntax">$mdToast.updateTextContent();</code></h3><div \nclass="service-desc"><p>Updates the content of an existing toast. Useful for updating things like counts, etc.</p>\n</div><div class="method-param-table"></div></li><li id="build"><h3 class="method-function-syntax"><code \nclass="method-function-syntax">$mdToast.build();</code></h3><div class="service-desc"><p>Creates a custom <code>\n$mdToastPreset</code> that you can configure.</p></div><div class="method-param-table"><table class="md-api-table">\n<thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass="api-type label type-hint type-hint-obj">obj</code></td><td class="description"><p>a <code>$mdToastPreset</code>\n with the chainable configuration methods for shows&#39; options (see below).</p></td></tr></tbody></table></div></li>\n<li id="show"><h3 class="method-function-syntax"><code class="method-function-syntax">$mdToast.show(optionsOrPreset);\n</code></h3><div class="service-desc"><p>Shows the toast.</p></div><div class="method-param-table"><table \nclass="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass="api-params-item"><td style="white-space: nowrap;"><b>* optionsOrPreset</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-object">object</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-object">object</code></td><td class="description"><p>Either provide an <code>\n$mdToastPreset</code> returned from <code>simple()</code> and <code>build()</code>\n, or an options object with the following properties:</p><ul><li><code>templateUrl</code> - <code>{string=}</code>\n: The url of an html template file that will be used as the content of the toast. Restrictions: the template must have an outer \n<code>md-toast</code> element.</li><li><code>template</code> - <code>{string=}</code>\n: Same as templateUrl, except this is an actual template string.</li><li><code>autoWrap</code> - <code>{boolean=}\n</code>: Whether or not to automatically wrap the template content with a <code>\n&lt;div class=&quot;md-toast-content&quot;&gt;</code>\n if one is not provided. Defaults to true. Can be disabled if you provide a custom toast directive.</li><li><code>scope\n</code> - <code>{object=}</code>\n: the scope to link the template / controller to. If none is specified, it will create a new child scope. This scope will be destroyed when the toast is removed unless \n<code>preserveScope</code> is set to true.</li><li><code>preserveScope</code> - <code>{boolean=}</code>\n: whether to preserve the scope when the element is removed. Default is false</li><li><code>hideDelay</code> - <code>\n{number=}</code>\n: How many milliseconds the toast should stay active before automatically closing. Set to 0 or false to have the toast stay open until closed manually. Default: 3000.\n</li><li><code>position</code> - <code>{string=}</code>\n: Where to place the toast. Available: any combination of &#39;bottom&#39;, &#39;left&#39;, &#39;top&#39;, &#39;right&#39;. Default: &#39;bottom left&#39;.\n</li><li><code>controller</code> - <code>{string=}</code>\n: The controller to associate with this toast. The controller will be injected the local <code>$mdToast.hide( )</code>\n, which is a function used to hide the toast.</li><li><code>locals</code> - <code>{string=}</code>\n: An object containing key/value pairs. The keys will be used as names of values to inject into the controller. For example, \n<code>locals: {three: 3}</code> would inject <code>three</code> into the controller with the value of 3.</li><li><code>\nbindToController</code> - <code>bool</code>: bind the locals to the controller, instead of passing them in.</li><li>\n<code>resolve</code> - <code>{object=}</code>\n: Similar to locals, except it takes promises as values and the toast will not open until the promises resolve.</li>\n<li><code>controllerAs</code> - <code>{string=}</code>: An alias to assign the controller to on the scope.</li><li>\n<code>parent</code> - <code>{element=}</code>\n: The element to append the toast to. Defaults to appending to the root element of the application.</li></ul></td></tr>\n</tbody></table><table class="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td>\n<code class="api-type label type-hint type-hint-promise">promise</code></td><td class="description"><p>\nA promise that can be resolved with <code>$mdToast.hide()</code> or rejected with <code>$mdToast.cancel()</code>. \n<code>$mdToast.hide()</code>\n will resolve either with a Boolean value == &#39;true&#39; or the value passed as an argument to <code>$mdToast.hide()\n</code>. And <code>$mdToast.cancel()</code> will resolve the promise with a Boolean value == &#39;false&#39;</p></td>\n</tr></tbody></table></div></li><li id="hide"><h3 class="method-function-syntax"><code class="method-function-syntax">\n$mdToast.hide([response]);</code></h3><div class="service-desc"><p>\nHide an existing toast and resolve the promise returned from <code>$mdToast.show()</code>.</p></div><div \nclass="method-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;">response <span hide show-sm><code \nclass="api-type label type-hint type-hint-object">*</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-object">*</code></td><td class="description"><p>\nAn argument for the resolved promise.</p></td></tr></tbody></table><table class="md-api-table"><thead><tr><th>Returns\n</th><th>Description</th></tr></thead><tbody><tr><td><code class="api-type label type-hint type-hint-promise">promise\n</code></td><td class="description"><p>\na promise that is called when the existing element is removed from the DOM. The promise is resolved with either a Boolean value == &#39;true&#39; or the value passed as the argument to \n<code>.hide()</code>.</p></td></tr></tbody></table></div></li><li id="cancel"><h3 class="method-function-syntax"><code \nclass="method-function-syntax">$mdToast.cancel([response]);</code></h3><div class="service-desc"><p><code>DEPRECATED\n</code>\n - The promise returned from opening a toast is used only to notify about the closing of the toast. As such, there isn&#39;t any reason to also allow that promise to be rejected, since it&#39;s not clear what the difference between resolve and reject would be.\n</p><p>Hide the existing toast and reject the promise returned from <code>$mdToast.show()</code>.</p></div><div \nclass="method-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;">response <span hide show-sm><code \nclass="api-type label type-hint type-hint-object">*</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-object">*</code></td><td class="description"><p>\nAn argument for the rejected promise.</p></td></tr></tbody></table><table class="md-api-table"><thead><tr><th>Returns\n</th><th>Description</th></tr></thead><tbody><tr><td><code class="api-type label type-hint type-hint-promise">promise\n</code></td><td class="description"><p>\na promise that is called when the existing element is removed from the DOM The promise is resolved with a Boolean value == &#39;false&#39;.\n</p></td></tr></tbody></table></div></li></ul></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.swipe/directive/mdSwipeDown.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>\nThe md-swipe-down directive allows you to specify custom behavior when an element is swiped down.</p></div><div>\n<section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="html"><div md-swipe-down="onSwipDown()">\nSwipe me down!</div></hljs></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.swipe/directive/mdSwipeLeft.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>\nThe md-swipe-left directive allows you to specify custom behavior when an element is swiped left.</p></div><div>\n<section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="html"><div md-swipe-left="onSwipeLeft()">\nSwipe me left!</div></hljs></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.swipe/directive/mdSwipeRight.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>\nThe md-swipe-right directive allows you to specify custom behavior when an element is swiped right.</p></div><div>\n<section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="html"><div md-swipe-right="onSwipeRight()">\nSwipe me right!</div></hljs></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.swipe/directive/mdSwipeUp.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>\nThe md-swipe-up directive allows you to specify custom behavior when an element is swiped up.</p></div><div><section \nclass="api-section"><h2 id="Usage">Usage</h2><hljs lang="html"><div md-swipe-up="onSwipeUp()">Swipe me up!</div></hljs>\n</section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.switch/directive/mdSwitch.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"></div><div><section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="html">\n<md-switch ng-model="isActive" aria-label="Finished?">Finished ?</md-switch><md-switch md-no-ink ng-model="hasInk" \naria-label="No Ink Effects">No Ink Effects</md-switch><md-switch ng-disabled="true" ng-model="isDisabled" \naria-label="Disabled">Disabled</md-switch></hljs></section><div class="api-param-section"><h2>Attributes</h2><div \nclass="api-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;"><b>* ng-model</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nAssignable angular expression to data-bind to.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">name <span hide show-sm><code class="api-type label type-hint type-hint-string">string\n</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">string\n</code></td><td class="description"><p>Property name of the form under which the control is published.</p></td></tr><tr\n class="api-params-item"><td style="white-space: nowrap;">ng-true-value <span hide show-sm><code \nclass="api-type label type-hint type-hint-expression">expression</code></span></td><td style="white-space: nowrap;">\n<code class="api-type label type-hint type-hint-expression">expression</code></td><td class="description"><p>\nThe value to which the expression should be set when selected.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">ng-false-value <span hide show-sm><code \nclass="api-type label type-hint type-hint-expression">expression</code></span></td><td style="white-space: nowrap;">\n<code class="api-type label type-hint type-hint-expression">expression</code></td><td class="description"><p>\nThe value to which the expression should be set when not selected.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">ng-change <span hide show-sm><code class="api-type label type-hint type-hint-string">\nstring</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">\nstring</code></td><td class="description"><p>\nAngular expression to be executed when input changes due to user interaction with the input element.</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">ng-disabled <span hide show-sm><code \nclass="api-type label type-hint type-hint-expression">expression</code></span></td><td style="white-space: nowrap;">\n<code class="api-type label type-hint type-hint-expression">expression</code></td><td class="description"><p>\nEn/Disable based on the expression.</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">\nmd-no-ink <span hide show-sm><code class="api-type label type-hint type-hint-boolean">boolean</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-boolean">boolean</code></td><td \nclass="description"><p>Use of attribute indicates use of ripple ink effects.</p></td></tr><tr class="api-params-item">\n<td style="white-space: nowrap;">aria-label <span hide show-sm><code class="api-type label type-hint type-hint-string">\nstring</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">\nstring</code></td><td class="description"><p>\nPublish the button label used by screen-readers for accessibility. Defaults to the switch&#39;s text.</p></td></tr>\n</tbody></table></div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.tabs/directive/mdTab.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>Use the <code>&lt;md-tab&gt;</code> a nested directive used within <code>\n&lt;md-tabs&gt;</code> to specify a tab with a <strong>label</strong> and optional <em>view content</em>.</p><p>If the \n<code>label</code> attribute is not specified, then an optional <code>&lt;md-tab-label&gt;</code>\n tag can be used to specify more complex tab header markup. If neither the <strong>label</strong> nor the <strong>\nmd-tab-label</strong> are specified, then the nested markup of the <code>&lt;md-tab&gt;</code>\n is used as the tab header markup.</p><p>Please note that if you use <code>&lt;md-tab-label&gt;</code>, your content \n<strong>MUST</strong> be wrapped in the <code>&lt;md-tab-body&gt;</code>\n tag. This is to define a clear separation between the tab content and the tab label.</p><p>\nThis container is used by the TabsController to show/hide the active tab&#39;s content view. This synchronization is automatically managed by the internal TabsController whenever the tab selection changes. Selection changes can be initiated via data binding changes, programmatic invocation, or user gestures.\n</p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="html"><md-tab label="" ng-disabled \nmd-on-select="" md-on-deselect=""><h3>My Tab content</h3></md-tab><md-tab><md-tab-label><h3>My Tab content</h3>\n</md-tab-label><md-tab-body><p>\nSed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.\n</p></md-tab-body></md-tab></hljs></section><div class="api-param-section"><h2>Attributes</h2><div \nclass="api-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;">label <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nOptional attribute to specify a simple string as the tab label</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">ng-disabled <span hide show-sm><code class="api-type label type-hint type-hint-boolean">\nboolean</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-boolean">\nboolean</code></td><td class="description"><p>If present and expression evaluates to truthy, disabled tab selection.\n</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">md-on-deselect <span hide show-sm><code \nclass="api-type label type-hint type-hint-expression">expression</code></span></td><td style="white-space: nowrap;">\n<code class="api-type label type-hint type-hint-expression">expression</code></td><td class="description"><p>\nExpression to be evaluated after the tab has been de-selected.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-on-select <span hide show-sm><code \nclass="api-type label type-hint type-hint-expression">expression</code></span></td><td style="white-space: nowrap;">\n<code class="api-type label type-hint type-hint-expression">expression</code></td><td class="description"><p>\nExpression to be evaluated after the tab has been selected.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-active <span hide show-sm><code class="api-type label type-hint type-hint-boolean">\nboolean</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-boolean">\nboolean</code></td><td class="description"><p>\nWhen true, sets the active tab. Note: There can only be one active tab at a time.</p></td></tr></tbody></table></div>\n</div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.tabs/directive/mdTabs.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>The <code>&lt;md-tabs&gt;</code> directive serves as the container for 1..n <code>\n&lt;md-tab&gt;</code> child directives to produces a Tabs components. In turn, the nested <code>&lt;md-tab&gt;</code>\n directive is used to specify a tab label for the <strong>header button</strong>\n and a [optional] tab view content that will be associated with each tab button.</p><p>\nBelow is the markup for its simplest usage:</p><hljs lang="html"><md-tabs><md-tab label="Tab #1"></md-tab><md-tab \nlabel="Tab #2"></md-tab><md-tab label="Tab #3"></md-tab></md-tabs></hljs><p>Tabs supports three (3) usage scenarios:\n</p><ol><li>Tabs (buttons only)</li><li>Tabs with internal view content</li><li>Tabs with external view content</li>\n</ol><p><strong>Tab-only</strong>\n support is useful when tab buttons are used for custom navigation regardless of any other components, content, or views. \n<strong>Tabs with internal views</strong>\n are the traditional usages where each tab has associated view content and the view switching is managed internally by the Tabs component. \n<strong>Tabs with external view content</strong>\n is often useful when content associated with each tab is independently managed and data-binding notifications announce tab selection changes.\n</p><p>Additional features also include:</p><ul><li>Content can include any markup.</li><li>\nIf a tab is disabled while active/selected, then the next tab will be auto-selected.</li></ul><h3 \nid="explanation-of-tab-stretching">Explanation of tab stretching</h3><p>\nInitially, tabs will have an inherent size. This size will either be defined by how much space is needed to accommodate their text or set by the user through CSS. Calculations will be based on this size.\n</p><p>\nOn mobile devices, tabs will be expanded to fill the available horizontal space. When this happens, all tabs will become the same size.\n</p><p>On desktops, by default, stretching will never occur.</p><p>This default behavior can be overridden through the \n<code>md-stretch-tabs</code> attribute. Here is a table showing when stretching will occur:</p><table><thead><tr><th>\n<code>md-stretch-tabs</code></th><th>mobile</th><th>desktop</th></tr></thead><tbody><tr><td><code>auto</code></td><td>\nstretched</td><td>---</td></tr><tr><td><code>always</code></td><td>stretched</td><td>stretched</td></tr><tr><td><code>\nnever</code></td><td>---</td><td>---</td></tr></tbody></table></div><div><section class="api-section"><h2 id="Usage">\nUsage</h2><hljs lang="html"><md-tabs md-selected="selectedIndex"><img \nng-src="assets/angular-material-assets/img/angular.png" class="centered"><md-tab \nng-repeat="tab in tabs | orderBy:predicate:reversed" md-on-select="onTabSelected(tab)" \nmd-on-deselect="announceDeselected(tab)" ng-disabled="tab.disabled"><md-tab-label>{{tab.title}} <img \nsrc="assets/angular-material-assets/img/removeTab.png" ng-click="removeTab(tab)" class="delete"></md-tab-label>\n<md-tab-body>{{tab.content}}</md-tab-body></md-tab></md-tabs></hljs></section><div class="api-param-section"><h2>\nAttributes</h2><div class="api-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;">md-selected <span \nhide show-sm><code class="api-type label type-hint type-hint-integer">integer</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-integer">integer</code></td><td \nclass="description"><p>Index of the active/selected tab</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-no-ink <span hide show-sm><code class="api-type label type-hint type-hint-boolean">\nboolean</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-boolean">\nboolean</code></td><td class="description"><p>If present, disables ink ripple effects.</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">md-no-ink-bar <span hide show-sm><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>\nIf present, disables the selection ink bar.</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">\nmd-align-tabs <span hide show-sm><code class="api-type label type-hint type-hint-string">string</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">string</code></td><td \nclass="description"><p>Attribute to indicate position of tab buttons: <code>bottom</code> or <code>top</code>\n; default is <code>top</code></p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">\nmd-stretch-tabs <span hide show-sm><code class="api-type label type-hint type-hint-string">string</code></span></td><td\n style="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">string</code></td><td \nclass="description"><p>Attribute to indicate whether or not to stretch tabs: <code>auto</code>, <code>always</code>\n, or <code>never</code>; default is <code>auto</code></p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-dynamic-height <span hide show-sm><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>\nWhen enabled, the tab wrapper will resize based on the contents of the selected tab</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">md-border-bottom <span hide show-sm><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>\nIf present, shows a solid <code>1px</code> border between the tabs and their content</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">md-center-tabs <span hide show-sm><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>\nWhen enabled, tabs will be centered provided there is no need for pagination</p></td></tr><tr class="api-params-item">\n<td style="white-space: nowrap;">md-no-pagination <span hide show-sm><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>\nWhen enabled, pagination will remain off</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">\nmd-swipe-content <span hide show-sm><code class="api-type label type-hint type-hint-boolean">boolean</code></span></td>\n<td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-boolean">boolean</code></td><td \nclass="description"><p>When enabled, swipe gestures will be enabled for the content area to jump between tabs</p></td>\n</tr><tr class="api-params-item"><td style="white-space: nowrap;">md-enable-disconnect <span hide show-sm><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>\nWhen enabled, scopes will be disconnected for tabs that are not being displayed. This provides a performance boost, but may also cause unexpected issues and is not recommended for most users.\n</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">md-autoselect <span hide show-sm><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>\nWhen present, any tabs added after the initial load will be automatically selected</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">md-no-select-click <span hide show-sm><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>\nWhen enabled, click events will not be fired when selecting tabs</p></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.toolbar/directive/mdToolbar.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p><code>md-toolbar</code> is used to place a toolbar in your app.</p><p>\nToolbars are usually used above a content area to display the title of the current page, and show relevant action buttons for that page.\n</p><p>You can change the height of the toolbar by adding either the <code>md-medium-tall</code> or <code>md-tall\n</code> class to the toolbar.</p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="html">\n<div layout="column" layout-fill><md-toolbar><div class="md-toolbar-tools"><span>My App&#39;s Title</span><span flex>\n</span><md-button>Right Bar Button</md-button></div></md-toolbar><md-content>Hello!</md-content></div></hljs></section>\n<div class="api-param-section"><h2>Attributes</h2><div class="api-param-table"><table class="md-api-table"><thead><tr>\n<th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-scroll-shrink <span hide show-sm><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>\nWhether the header should shrink away as the user scrolls down, and reveal itself as the user scrolls up.</p><p><em>\n<strong>Note (1):</strong> for scrollShrink to work, the toolbar must be a sibling of a <code>md-content</code>\n element, placed before it. See the scroll shrink demo.</em></p><p><em><strong>Note (2):</strong> The <code>\nmd-scroll-shrink</code> attribute is only parsed on component initialization, it does not watch for scope changes.</em>\n</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">md-shrink-speed-factor <span hide show-sm>\n<code class="api-type label type-hint type-hint-number">number</code></span></td><td style="white-space: nowrap;"><code\n class="api-type label type-hint type-hint-number">number</code></td><td class="description"><p>\nHow much to change the speed of the toolbar&#39;s shrinking by. For example, if 0.25 is given then the toolbar will shrink at one fourth the rate at which the user scrolls down. Default 0.5.\n</p></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.whiteframe/directive/mdWhiteframe.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>The md-whiteframe directive allows you to apply an elevation shadow to an element.\n</p><p>The attribute values needs to be a number between 1 and 24.</p><h3 id="notes">Notes</h3><ul><li>\nIf there is no value specified it defaults to 4dp.</li><li>If the value is not valid it defaults to 4dp.</li></ul>\n</div><div><section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="html"><div md-whiteframe="3"><span>\nElevation of 3dp</span></div></hljs></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.virtualRepeat/directive/mdVirtualRepeat.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p><code>md-virtual-repeat</code>\n specifies an element to repeat using virtual scrolling.</p><p>\nVirtual repeat is a limited substitute for ng-repeat that renders only enough dom nodes to fill the container and recycling them as the user scrolls. Arrays, but not objects are supported for iteration. Track by, as alias, and (key, value) syntax are not supported.\n</p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="html"><md-virtual-repeat-container>\n<div md-virtual-repeat="i in items">Hello {{i}}!</div></md-virtual-repeat-container><md-virtual-repeat-container \nmd-orient-horizontal><div md-virtual-repeat="i in items" md-item-size="20">Hello {{i}}!</div>\n</md-virtual-repeat-container></hljs></section><div class="api-param-section"><h2>Attributes</h2><div \nclass="api-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;">md-item-size <span hide show-sm><code \nclass="api-type label type-hint type-hint-number">number</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-number">number</code></td><td class="description"><p>\nThe height or width of the repeated elements (which must be identical for each element). Optional. Will attempt to read the size from the dom if missing, but still assumes that all repeated nodes have same height or width.\n</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">md-extra-name <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nEvaluates to an additional name to which the current iterated item can be assigned on the repeated scope (needed for use in \n<code>md-autocomplete</code>).</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">md-on-demand \n<span hide show-sm><code class="api-type label type-hint type-hint-boolean">boolean</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-boolean">boolean</code></td><td \nclass="description"><p>\nWhen present, treats the md-virtual-repeat argument as an object that can fetch rows rather than an array.</p><p>\n<strong>NOTE:</strong> This object must implement the following interface with two (2) methods:</p><ul><li><code>\ngetItemAtIndex: function(index) [object]</code>\n The item at that index or null if it is not yet loaded (it should start downloading the item in that case).</li><li>\n<code>getLength: function() [number]</code>\n The data length to which the repeater container should be sized. Ideally, when the count is known, this method should return it. Otherwise, return a higher number than the currently loaded items to produce an infinite-scroll behavior.\n</li></ul></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.virtualRepeat/directive/mdVirtualRepeatContainer.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p><code>md-virtual-repeat-container</code>\n provides the scroll container for md-virtual-repeat.</p><p>\nVirtual repeat is a limited substitute for ng-repeat that renders only enough dom nodes to fill the container and recycling them as the user scrolls.\n</p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="html"><md-virtual-repeat-container \nmd-top-index="topIndex"><div md-virtual-repeat="i in items" md-item-size="20">Hello {{i}}!</div>\n</md-virtual-repeat-container></hljs></section><div class="api-param-section"><h2>Attributes</h2><div \nclass="api-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;">md-top-index <span hide show-sm><code \nclass="api-type label type-hint type-hint-number">number</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-number">number</code></td><td class="description"><p>\nBinds the index of the item that is at the top of the scroll container to $scope. It can both read and set the scroll position.\n</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">md-orient-horizontal <span hide show-sm>\n<code class="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;">\n<code class="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>\nWhether the container should scroll horizontally (defaults to orientation and scrolling vertically).</p></td></tr><tr \nclass="api-params-item"><td style="white-space: nowrap;">md-auto-shrink <span hide show-sm><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>\nWhen present, the container will shrink to fit the number of items when that number is less than its original size.</p>\n</td></tr><tr class="api-params-item"><td style="white-space: nowrap;">md-auto-shrink-min <span hide show-sm><code \nclass="api-type label type-hint type-hint-number">number</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-number">number</code></td><td class="description"><p>\nMinimum number of items that md-auto-shrink will shrink to (default: 0).</p></td></tr></tbody></table></div></div>\n</div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.components.tooltip/directive/mdTooltip.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>\nTooltips are used to describe elements that are interactive and primarily graphical (not textual).</p><p>Place a <code>\n&lt;md-tooltip&gt;</code> as a child of the element it describes.</p><p>\nA tooltip will activate when the user focuses, hovers over, or touches the parent.</p></div><div><section \nclass="api-section"><h2 id="Usage">Usage</h2><hljs lang="html"><md-button class="md-fab md-accent" aria-label="Play">\n<md-tooltip>Play Music</md-tooltip><md-icon icon="assets/angular-material-assets/img/icons/ic_play_arrow_24px.svg">\n</md-icon></md-button></hljs></section><div class="api-param-section"><h2>Attributes</h2><div class="api-param-table">\n<table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass="api-params-item"><td style="white-space: nowrap;">md-visible <span hide show-sm><code \nclass="api-type label type-hint type-hint-expression">expression</code></span></td><td style="white-space: nowrap;">\n<code class="api-type label type-hint type-hint-expression">expression</code></td><td class="description"><p>\nBoolean bound to whether the tooltip is currently visible.</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">md-delay <span hide show-sm><code class="api-type label type-hint type-hint-number">number\n</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-number">number\n</code></td><td class="description"><p>\nHow many milliseconds to wait to show the tooltip after the user focuses, hovers, or touches the parent. Defaults to 0ms.\n</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">md-autohide <span hide show-sm><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>\nIf present or provided with a boolean value, the tooltip will hide on mouse leave, regardless of focus</p></td></tr><tr\n class="api-params-item"><td style="white-space: nowrap;">md-direction <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code></td><td class="description"><p>\nWhich direction would you like the tooltip to go? Supports left, right, top, and bottom. Defaults to bottom.</p></td>\n</tr></tbody></table></div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.core/service/$mdButtonInkRipple.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>\nProvides ripple effects for md-button. See $mdInkRipple service for all possible configuration options.</p></div><div>\n<section class="api-section"><div class="api-param-section"><h2>Arguments</h2><div class="api-param-table"><table \nclass="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass="api-params-item"><td style="white-space: nowrap;">scope <span hide show-sm><code \nclass="api-type label type-hint type-hint-object">object</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-object">object</code></td><td class="description"><p>\nScope within the current context</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">element \n<span hide show-sm><code class="api-type label type-hint type-hint-object">object</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-object">object</code></td><td \nclass="description"><p>The element the ripple effect should be applied to</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">options <span hide show-sm><code class="api-type label type-hint type-hint-object">object\n</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-object">object\n</code></td><td class="description"><p>(Optional) Configuration options to override the default ripple configuration\n</p></td></tr></tbody></table></div></div><section class="api-section"></section></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.core/service/$mdCheckboxInkRipple.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>\nProvides ripple effects for md-checkbox. See $mdInkRipple service for all possible configuration options.</p></div>\n<div><section class="api-section"><div class="api-param-section"><h2>Arguments</h2><div class="api-param-table"><table \nclass="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass="api-params-item"><td style="white-space: nowrap;">scope <span hide show-sm><code \nclass="api-type label type-hint type-hint-object">object</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-object">object</code></td><td class="description"><p>\nScope within the current context</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">element \n<span hide show-sm><code class="api-type label type-hint type-hint-object">object</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-object">object</code></td><td \nclass="description"><p>The element the ripple effect should be applied to</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">options <span hide show-sm><code class="api-type label type-hint type-hint-object">object\n</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-object">object\n</code></td><td class="description"><p>(Optional) Configuration options to override the defaultripple configuration</p>\n</td></tr></tbody></table></div></div><section class="api-section"></section></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.core/service/$mdListInkRipple.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>\nProvides ripple effects for md-list. See $mdInkRipple service for all possible configuration options.</p></div><div>\n<section class="api-section"><div class="api-param-section"><h2>Arguments</h2><div class="api-param-table"><table \nclass="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass="api-params-item"><td style="white-space: nowrap;">scope <span hide show-sm><code \nclass="api-type label type-hint type-hint-object">object</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-object">object</code></td><td class="description"><p>\nScope within the current context</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">element \n<span hide show-sm><code class="api-type label type-hint type-hint-object">object</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-object">object</code></td><td \nclass="description"><p>The element the ripple effect should be applied to</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">options <span hide show-sm><code class="api-type label type-hint type-hint-object">object\n</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-object">object\n</code></td><td class="description"><p>(Optional) Configuration options to override the defaultripple configuration</p>\n</td></tr></tbody></table></div></div><section class="api-section"></section></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.core/service/$mdMedia.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p><code>$mdMedia</code>\n is used to evaluate whether a given media query is true or false given the current device&#39;s screen / window size. The media query will be re-evaluated on resize, allowing you to register a watch.\n</p><p><code>$mdMedia</code> also has pre-programmed support for media queries that match the layout breakpoints:</p>\n<table class="md-api-table"><thead><tr><th>Breakpoint</th><th>mediaQuery</th></tr></thead><tbody><tr><td>xs</td><td>\n(max-width: 599px)</td></tr><tr><td>gt-xs</td><td>(min-width: 600px)</td></tr><tr><td>sm</td><td>\n(min-width: 600px) and (max-width: 959px)</td></tr><tr><td>gt-sm</td><td>(min-width: 960px)</td></tr><tr><td>md</td>\n<td>(min-width: 960px) and (max-width: 1279px)</td></tr><tr><td>gt-md</td><td>(min-width: 1280px)</td></tr><tr><td>lg\n</td><td>(min-width: 1280px) and (max-width: 1919px)</td></tr><tr><td>gt-lg</td><td>(min-width: 1920px)</td></tr><tr>\n<td>xl</td><td>(min-width: 1920px)</td></tr><tr><td>print</td><td>print</td></tr></tbody></table><p>\nSee Material Design&#39;s <a href="https://www.google.com/design/spec/layout/adaptive-ui.html">Layout - Adaptive UI</a>\n for more details.</p><p><a href="https://www.google.com/design/spec/layout/adaptive-ui.html"><img \nsrc="https://material-design.storage.googleapis.com/publish/material_v_4/material_ext_publish/0B8olV15J7abPSGFxemFiQVRtb1k/layout_adaptive_breakpoints_01.png" \nwidth="100%" height="100%"></a></p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="js">\napp.controller(&#39;MyController&#39;, function($mdMedia, $scope) { $scope.$watch(function() { return $mdMedia(&#39;lg&#39;); }, function(big) { $scope.bigScreen = big; }); $scope.screenIsSmall = $mdMedia(&#39;sm&#39;); $scope.customQuery = $mdMedia(&#39;(min-width: 1234px)&#39;); $scope.anotherCustom = $mdMedia(&#39;max-width: 300px&#39;); });\n</hljs></section><section class="api-section"><section class="api-section"></section><div class="api-param-table">\n<table class="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>\na boolean representing whether or not the given media query is true or false.</p></td></tr></tbody></table></div>\n</section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.core/service/$mdTabInkRipple.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>\nProvides ripple effects for md-tabs. See $mdInkRipple service for all possible configuration options.</p></div><div>\n<section class="api-section"><div class="api-param-section"><h2>Arguments</h2><div class="api-param-table"><table \nclass="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass="api-params-item"><td style="white-space: nowrap;">scope <span hide show-sm><code \nclass="api-type label type-hint type-hint-object">object</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-object">object</code></td><td class="description"><p>\nScope within the current context</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">element \n<span hide show-sm><code class="api-type label type-hint type-hint-object">object</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-object">object</code></td><td \nclass="description"><p>The element the ripple effect should be applied to</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">options <span hide show-sm><code class="api-type label type-hint type-hint-object">object\n</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-object">object\n</code></td><td class="description"><p>(Optional) Configuration options to override the defaultripple configuration</p>\n</td></tr></tbody></table></div></div><section class="api-section"></section></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.core.gestures/service/$mdGestureProvider.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>\nIn some scenarios on Mobile devices (without jQuery), the click events should NOT be hijacked. <code>$mdGestureProvider\n</code> is used to configure the Gesture module to ignore or skip click hijacking on mobile devices.</p><hljs \nlang="js">\napp.config(function($mdGestureProvider) { // For mobile devices without jQuery loaded, do not // intercept click events during the capture phase. $mdGestureProvider.skipClickHijack(); });\n</hljs></div><div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.core.theming/service/$mdThemingProvider.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>Provider to configure the <code>$mdTheming</code> service.</p></div><div><section \nclass="api-section"><h2>Methods</h2><br><ul class="methods"><li id="setNonce"><h3 class="method-function-syntax"><code \nclass="method-function-syntax">$mdThemingProvider.setNonce(nonceValue);</code></h3><div class="service-desc"></div><div\n class="method-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;"><b>* nonceValue</b> <span hide \nshow-sm><code class="api-type label type-hint type-hint-string">string</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">string</code></td><td \nclass="description"><p>\nThe nonce to be added as an attribute to the theme style tags. Setting a value allows the use CSP policy without using the unsafe-inline directive.\n</p></td></tr></tbody></table></div></li><li id="setDefaultTheme"><h3 class="method-function-syntax"><code \nclass="method-function-syntax">$mdThemingProvider.setDefaultTheme(themeName);</code></h3><div class="service-desc">\n</div><div class="method-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;"><b>* themeName</b> \n<span hide show-sm><code class="api-type label type-hint type-hint-string">string</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">string</code></td><td \nclass="description"><p>Default theme name to be applied to elements. Default value is <code>default</code>.</p></td>\n</tr></tbody></table></div></li><li id="alwaysWatchTheme"><h3 class="method-function-syntax"><code \nclass="method-function-syntax">$mdThemingProvider.alwaysWatchTheme(watch);</code></h3><div class="service-desc"></div>\n<div class="method-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description\n</th></tr></thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;"><b>* watch</b> <span hide \nshow-sm><code class="api-type label type-hint type-hint-boolean">boolean</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-boolean">boolean</code></td><td \nclass="description"><p>\nWhether or not to always watch themes for changes and re-apply classes when they change. Default is <code>false</code>\n. Enabling can reduce performance.</p></td></tr></tbody></table></div></li></ul></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.core.util/directive/mdAutofocus.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p><code>[md-autofocus]</code>\n provides an optional way to identify the focused element when a <code>$mdDialog</code>, <code>$mdBottomSheet</code>\n, or <code>$mdSidenav</code> opens or upon page load for input-like elements.</p><p>\nWhen one of these opens, it will find the first nested element with the <code>[md-autofocus]</code>\n attribute directive and optional expression. An expression may be specified as the directive value to enable conditional activation of the autofocus.\n</p></div><div><section class="api-section"><h2 id="Usage">Usage</h2><h3 id="dialog">Dialog</h3><hljs lang="html">\n<md-dialog><form><md-input-container><label for="testInput">Label</label> <input id="testInput" type="text" \nmd-autofocus></md-input-container></form></md-dialog></hljs><h3 id="bottomsheet">Bottomsheet</h3><hljs lang="html">\n<md-bottom-sheet class="md-list md-has-header"><md-subheader>Comment Actions</md-subheader><md-list><md-list-item \nng-repeat="item in items"><md-button md-autofocus="$index == 2"><md-icon md-svg-src="{{item.icon}}"></md-icon><span \nclass="md-inline-list-icon-label">{{ item.name }}</span></md-button></md-list-item></md-list></md-bottom-sheet></hljs>\n<h3 id="autocomplete">Autocomplete</h3><hljs lang="html"><md-autocomplete md-autofocus md-selected-item="selectedItem" \nmd-search-text="searchText" md-items="item in getMatches(searchText)" md-item-text="item.display"><span \nmd-highlight-text="searchText">{{item.display}}</span></md-autocomplete></hljs><h3 id="sidenav">Sidenav</h3><hljs \nlang="html"><div layout="row" ng-controller="MyController"><md-sidenav md-component-id="left" class="md-sidenav-left">\nLeft Nav!</md-sidenav><md-content>Center Content<md-button ng-click="openLeftMenu()">Open Left Menu</md-button>\n</md-content><md-sidenav md-component-id="right" md-is-locked-open="$mdMedia(\'min-width: 333px\')" \nclass="md-sidenav-right"><form><md-input-container><label for="testInput">Test input</label> <input id="testInput" \ntype="text" ng-model="data" md-autofocus></md-input-container></form></md-sidenav></div></hljs></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.core.ripple/directive/mdInkRipple.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>The <code>md-ink-ripple</code>\n directive allows you to specify the ripple color or id a ripple is allowed.</p></div><div><section \nclass="api-section"><h2 id="Usage">Usage</h2><h3 id="string-values">String values</h3><hljs lang="html"><any \nmd-ink-ripple="#FF0000">Ripples in red</any><any md-ink-ripple="false">Not rippling</any></hljs><h3 \nid="interpolated-values">Interpolated values</h3><hljs lang="html"><any md-ink-ripple="{{ randomColor() }}">\nRipples with the return value of &#39;randomColor&#39; function</any><any md-ink-ripple="{{ canRipple() }}">\nRipples if &#39;canRipple&#39; function return value is not &#39;false&#39; or &#39;0&#39;</any></hljs></section><div \nclass="api-param-section"><h2>Attributes</h2><div class="api-param-table"><table class="md-api-table"><thead><tr><th>\nParameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class="api-params-item"><td \nstyle="white-space: nowrap;"><b>* md-ink-ripple</b> <span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code><code \nclass="api-type label type-hint type-hint-boolean">boolean</code></td><td class="description"><p>A color string <code>\n#FF0000</code> or boolean (<code>false</code> or <code>0</code>) for preventing ripple</p></td></tr></tbody></table>\n</div></div></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/material.core.ripple/service/$mdInkRipple.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p><code>$mdInkRipple</code> is a service for adding ripples to any element</p></div>\n<div><section class="api-section"><h2 id="Usage">Usage</h2><hljs lang="js">\napp.factory(&#39;$myElementInkRipple&#39;, function($mdInkRipple) { return { attach: function (scope, element, options) { return $mdInkRipple.attach(scope, element, angular.extend({ center: false, dimBackground: true }, options)); } }; }); app.controller(&#39;myController&#39;, function ($scope, $element, $myElementInkRipple) { $scope.onClick = function (ev) { $myElementInkRipple.attach($scope, angular.element(ev.target), { center: true }); } });\n</hljs><h3 id="disabling-ripples-globally">Disabling ripples globally</h3><p>\nIf you want to disable ink ripples globally, for all components, you can call the <code>disableInkRipple</code>\n method in your app&#39;s config.</p><p><hljs lang="js">\napp.config(function ($mdInkRippleProvider) { $mdInkRippleProvider.disableInkRipple(); });</hljs></p></section><section \nclass="api-section"><h2>Methods</h2><br><ul class="methods"><li id="attach"><h3 class="method-function-syntax"><code \nclass="method-function-syntax">$mdInkRipple.attach([scope], [element], [options]);</code></h3><div \nclass="service-desc"><p>Attaching given scope, element and options to inkRipple controller</p></div><div \nclass="method-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;">scope <span hide show-sm><code \nclass="api-type label type-hint type-hint-object">object</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-object">object</code></td><td class="description"><p>\nScope within the current context</p></td></tr><tr class="api-params-item"><td style="white-space: nowrap;">element \n<span hide show-sm><code class="api-type label type-hint type-hint-object">object</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-object">object</code></td><td \nclass="description"><p>The element the ripple effect should be applied to</p></td></tr><tr class="api-params-item"><td \nstyle="white-space: nowrap;">options <span hide show-sm><code class="api-type label type-hint type-hint-object">object\n</code></span></td><td style="white-space: nowrap;"><code class="api-type label type-hint type-hint-object">object\n</code></td><td class="description"><p>(Optional) Configuration options to override the defaultRipple configuration</p>\n<ul><li><code>center</code> - Whether the ripple should start from the center of the container element</li><li><code>\ndimBackground</code> - Whether the background should be dimmed with the ripple color</li><li><code>colorElement</code>\n - The element the ripple should take its color from, defined by css property <code>color</code></li><li><code>\nfitRipple</code> - Whether the ripple should fill the element</li></ul></td></tr></tbody></table></div></li><li \nid="disableInkRipple"><h3 class="method-function-syntax"><code class="method-function-syntax">\n$mdInkRipple.disableInkRipple();</code></h3><div class="service-desc"><p>\nA config-time method that, when called, disables ripples globally.</p></div><div class="method-param-table"></div></li>\n</ul></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/src/object/MdPanelAnimation.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>\nAnimation configuration object. To use, create an MdPanelAnimation with the desired properties, then pass the object as part of $mdPanel creation.\n</p><p>Example:</p><p>\nvar panelAnimation = new MdPanelAnimation() .openFrom(myButtonEl) .closeTo(&#39;.my-button&#39;) .withAnimation($mdPanel.animation.SCALE);\n</p><p>$mdPanel.create({ animation: panelAnimation });</p></div><div><section class="api-section"><h2>Methods</h2><br>\n<ul class="methods"><li id="openFrom"><h3 class="method-function-syntax"><code class="method-function-syntax">\nMdPanelAnimation.openFrom();</code></h3><div class="service-desc"><p>Specifies where to start the open animation. \n<code>openFrom</code>\n accepts a click event object, query selector, DOM element, or a Rect object that is used to determine the bounds. When passed a click event, the location of the click will be used as the position to start the animation.\n</p></div><div class="method-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;"><b>* </b><span hide \nshow-sm><code class="api-type label type-hint type-hint-string">string</code><code \nclass="api-type label type-hint type-hint-element">Element</code><code \nclass="api-type label type-hint type-hint-event">Event</code><code class="api-type label type-hint type-hint-object">\n{top: number, left: number}</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-string">string</code><code \nclass="api-type label type-hint type-hint-element">Element</code><code \nclass="api-type label type-hint type-hint-event">Event</code><code class="api-type label type-hint type-hint-object">\n{top: number, left: number}</code></td><td class="description"></td></tr></tbody></table><table class="md-api-table">\n<thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass="api-type label type-hint type-hint-mdpanelanimation">MdPanelAnimation</code></td><td class="description"></td>\n</tr></tbody></table></div></li><li id="closeTo"><h3 class="method-function-syntax"><code \nclass="method-function-syntax">MdPanelAnimation.closeTo();</code></h3><div class="service-desc"><p>\nSpecifies where to animate the dialog close. <code>closeTo</code>\n accepts a query selector, DOM element, or a Rect object that is used to determine the bounds.</p></div><div \nclass="method-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;"><b>* </b><span hide show-sm><code \nclass="api-type label type-hint type-hint-string">string</code><code \nclass="api-type label type-hint type-hint-element">Element</code><code \nclass="api-type label type-hint type-hint-object">{top: number, left: number}</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">string</code><code \nclass="api-type label type-hint type-hint-element">Element</code><code \nclass="api-type label type-hint type-hint-object">{top: number, left: number}</code></td><td class="description"></td>\n</tr></tbody></table><table class="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody>\n<tr><td><code class="api-type label type-hint type-hint-mdpanelanimation">MdPanelAnimation</code></td><td \nclass="description"></td></tr></tbody></table></div></li><li id="withAnimation"><h3 class="method-function-syntax">\n<code class="method-function-syntax">MdPanelAnimation.withAnimation(cssClass);</code></h3><div class="service-desc"><p>\nSpecifies the animation class.</p><p>\nThere are several default animations that can be used: ($mdPanel.animation) SLIDE: The panel slides in and out from the specified elements. It will not fade in or out. SCALE: The panel scales in and out. Slide and fade are included in this animation. FADE: The panel fades in and out.\n</p><p>\nCustom classes will by default fade in and out unless &quot;transition: opacity 1ms&quot; is added to the to custom class.\n</p></div><div class="method-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;"><b>* cssClass</b> \n<span hide show-sm><code class="api-type label type-hint type-hint-string">string</code><code \nclass="api-type label type-hint type-hint-object">{open: string, close: string}</code></span></td><td \nstyle="white-space: nowrap;"><code class="api-type label type-hint type-hint-string">string</code><code \nclass="api-type label type-hint type-hint-object">{open: string, close: string}</code></td><td class="description">\n</td></tr></tbody></table><table class="md-api-table"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class="api-type label type-hint type-hint-mdpanelanimation">MdPanelAnimation</code></td><td \nclass="description"></td></tr></tbody></table></div></li></ul></section></div></div>');
$templateCache.put('app/main/components/material-docs/partials/api/src/service/$mdTheming.html','<div class="doc-content"><header class="api-profile-header"><h2 class="md-display-1">\n{{currentDoc.name}} API Documentation</h2></header><div layout="row" class="api-options-bar with-icon"></div><div \nclass="api-profile-description"><p>Service that makes an element apply theming related classes to itself.</p><pre><code\n class="lang-js">\napp.directive(&#39;myFancyDirective&#39;, function($mdTheming) {\n  return {\n    restrict: &#39;e&#39;,\n    link: function(scope, el, attrs) {\n      $mdTheming(el);\n    }\n  };\n});\n\n</code></pre></div><div><section class="api-section"><div class="api-param-section"><h2>Arguments</h2><div \nclass="api-param-table"><table class="md-api-table"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class="api-params-item"><td style="white-space: nowrap;">element <span hide show-sm><code \nclass="api-type label type-hint type-hint-el">el</code></span></td><td style="white-space: nowrap;"><code \nclass="api-type label type-hint type-hint-el">el</code></td><td class="description"><p>to apply theming to</p></td>\n</tr></tbody></table></div></div><section class="api-section"></section></section></div></div>');}]);